// @__NO_SIDE_EFFECTS__
function i1(i) {
  const e = /* @__PURE__ */ Object.create(null);
  for (const t of i.split(",")) e[t] = 1;
  return (t) => t in e;
}
const en = {}, jr = [], Qr = () => {
}, D3 = () => !1, Wf = (i) => i.charCodeAt(0) === 111 && i.charCodeAt(1) === 110 && // uppercase letter
(i.charCodeAt(2) > 122 || i.charCodeAt(2) < 97), qf = (i) => i.startsWith("onUpdate:"), gi = Object.assign, O3 = (i, e) => {
  const t = i.indexOf(e);
  t > -1 && i.splice(t, 1);
}, PP = Object.prototype.hasOwnProperty, jt = (i, e) => PP.call(i, e), mt = Array.isArray, jo = (i) => mu(i) === "[object Map]", Il = (i) => mu(i) === "[object Set]", Dx = (i) => mu(i) === "[object Date]", Ft = (i) => typeof i == "function", on = (i) => typeof i == "string", is = (i) => typeof i == "symbol", qt = (i) => i !== null && typeof i == "object", L3 = (i) => (qt(i) || Ft(i)) && Ft(i.then) && Ft(i.catch), B3 = Object.prototype.toString, mu = (i) => B3.call(i), EP = (i) => mu(i).slice(8, -1), F3 = (i) => mu(i) === "[object Object]", s1 = (i) => on(i) && i !== "NaN" && i[0] !== "-" && "" + parseInt(i, 10) === i, sc = /* @__PURE__ */ i1(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), Kf = (i) => {
  const e = /* @__PURE__ */ Object.create(null);
  return ((t) => e[t] || (e[t] = i(t)));
}, RP = /-\w/g, ri = Kf(
  (i) => i.replace(RP, (e) => e.slice(1).toUpperCase())
), zP = /\B([A-Z])/g, lr = Kf(
  (i) => i.replace(zP, "-$1").toLowerCase()
), Yf = Kf((i) => i.charAt(0).toUpperCase() + i.slice(1)), $m = Kf(
  (i) => i ? `on${Yf(i)}` : ""
), ys = (i, e) => !Object.is(i, e), pp = (i, ...e) => {
  for (let t = 0; t < i.length; t++)
    i[t](...e);
}, N3 = (i, e, t, n = !1) => {
  Object.defineProperty(i, e, {
    configurable: !0,
    enumerable: !1,
    writable: n,
    value: t
  });
}, o1 = (i) => {
  const e = parseFloat(i);
  return isNaN(e) ? i : e;
}, $P = (i) => {
  const e = on(i) ? Number(i) : NaN;
  return isNaN(e) ? i : e;
};
let Ox;
const Xf = () => Ox || (Ox = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : typeof global != "undefined" ? global : {});
function ce(i) {
  if (mt(i)) {
    const e = {};
    for (let t = 0; t < i.length; t++) {
      const n = i[t], s = on(n) ? BP(n) : ce(n);
      if (s)
        for (const o in s)
          e[o] = s[o];
    }
    return e;
  } else if (on(i) || qt(i))
    return i;
}
const DP = /;(?![^(]*\))/g, OP = /:([^]+)/, LP = /"(?:[^"\\]|\\[^])*"|'(?:[^'\\]|\\[^])*'|\\[^]|\/\*[^]*?\*\//g;
function BP(i) {
  const e = {};
  return i.replace(LP, (t) => t.startsWith("/*") ? "" : t).split(DP).forEach((t) => {
    if (t) {
      const n = t.split(OP);
      n.length > 1 && (e[n[0].trim()] = n[1].trim());
    }
  }), e;
}
function G(i) {
  let e = "";
  if (on(i))
    e = i;
  else if (mt(i))
    for (let t = 0; t < i.length; t++) {
      const n = G(i[t]);
      n && (e += n + " ");
    }
  else if (qt(i))
    for (const t in i)
      i[t] && (e += t + " ");
  return e.trim();
}
const FP = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", NP = /* @__PURE__ */ i1(FP);
function U3(i) {
  return !!i || i === "";
}
function UP(i, e, t) {
  if (i.length !== e.length) return !1;
  let n = !0;
  for (let s = 0; n && s < i.length; s++)
    n = Vl(i[s], e[s], t);
  return n;
}
function Lx(i, e, t) {
  if (i.size !== e.size) return !1;
  const n = Array.from(e), s = new Uint8Array(n.length);
  for (const o of i) {
    let r = -1;
    for (let a = 0; a < n.length; a++)
      if (!s[a] && Vl(o, n[a], t)) {
        r = a;
        break;
      }
    if (r < 0) return !1;
    s[r] = 1;
  }
  return !0;
}
function GP(i, e, t) {
  let n = jo(i), s = jo(e);
  if (n || s || (n = Il(i), s = Il(e), n || s))
    return n && s ? Lx(i, e, t) : !1;
  const o = Object.keys(i).length, r = Object.keys(e).length;
  if (o !== r)
    return !1;
  for (const a in i) {
    const l = i.hasOwnProperty(a), d = e.hasOwnProperty(a);
    if (l && !d || !l && d || !Vl(i[a], e[a], t))
      return !1;
  }
  return String(i) === String(e);
}
function Bx(i, e, t, n) {
  t || (t = [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map()]);
  const [s, o] = t;
  if (s.has(i) || o.has(e))
    return s.get(i) === e && o.get(e) === i;
  s.set(i, e), o.set(e, i);
  const r = n(i, e, t);
  return s.delete(i), o.delete(e), r;
}
function Vl(i, e, t) {
  if (i === e) return !0;
  let n = Dx(i), s = Dx(e);
  return n || s ? n && s ? i.getTime() === e.getTime() : !1 : (n = is(i), s = is(e), n || s ? i === e : (n = mt(i), s = mt(e), n || s ? n && s ? Bx(i, e, t, UP) : !1 : (n = qt(i), s = qt(e), n || s ? !n || !s ? !1 : Bx(i, e, t, GP) : String(i) === String(e))));
}
function G3(i, e) {
  return i.findIndex((t) => Vl(t, e));
}
const j3 = (i) => !!(i && i.__v_isRef === !0), E = (i) => on(i) ? i : i == null ? "" : mt(i) || qt(i) && (i.toString === B3 || !Ft(i.toString)) ? j3(i) ? E(i.value) : JSON.stringify(i, H3, 2) : String(i), H3 = (i, e) => j3(e) ? H3(i, e.value) : jo(e) ? {
  [`Map(${e.size})`]: [...e.entries()].reduce(
    (t, [n, s], o) => (t[Dm(n, o) + " =>"] = s, t),
    {}
  )
} : Il(e) ? {
  [`Set(${e.size})`]: [...e.values()].map((t) => Dm(t))
} : is(e) ? Dm(e) : qt(e) && !mt(e) && !F3(e) ? String(e) : e, Dm = (i, e = "") => {
  var t;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    is(i) ? `Symbol(${(t = i.description) != null ? t : e})` : i
  );
};
let Bn;
class V3 {
  // TODO isolatedDeclarations "__v_skip"
  constructor(e = !1) {
    this.detached = e, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this._warnOnRun = !0, this.__v_skip = !0, !e && Bn && (Bn.active ? (this.parent = Bn, this.index = (Bn.scopes || (Bn.scopes = [])).push(
      this
    ) - 1) : (this._active = !1, this._warnOnRun = !1));
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let e, t;
      if (this.scopes) {
        const n = this.scopes.slice();
        for (e = 0, t = n.length; e < t; e++)
          n[e].pause();
      }
      for (e = 0, t = this.effects.length; e < t; e++)
        this.effects[e].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let e, t;
      if (this.scopes) {
        const s = this.scopes.slice();
        for (e = 0, t = s.length; e < t; e++)
          s[e].resume();
      }
      const n = this.effects.slice();
      for (e = 0, t = n.length; e < t; e++)
        n[e].resume();
    }
  }
  run(e) {
    if (this._active) {
      const t = Bn;
      try {
        return Bn = this, e();
      } finally {
        Bn = t;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    ++this._on === 1 && (this.prevScope = Bn, Bn = this);
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    if (this._on > 0 && --this._on === 0) {
      if (Bn === this)
        Bn = this.prevScope;
      else {
        let e = Bn;
        for (; e; ) {
          if (e.prevScope === this) {
            e.prevScope = this.prevScope;
            break;
          }
          e = e.prevScope;
        }
      }
      this.prevScope = void 0;
    }
  }
  stop(e) {
    if (this._active) {
      this._active = !1;
      let t, n;
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].stop();
      for (this.effects.length = 0, t = 0, n = this.cleanups.length; t < n; t++)
        this.cleanups[t]();
      if (this.cleanups.length = 0, this.scopes) {
        const s = this.scopes.slice();
        for (t = 0, n = s.length; t < n; t++)
          s[t].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !e) {
        const s = this.parent.scopes.pop();
        s && s !== this && (this.parent.scopes[this.index] = s, s.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function r1(i) {
  return new V3(i);
}
function jP() {
  return Bn;
}
let Ht;
const Om = /* @__PURE__ */ new WeakSet();
class W3 {
  constructor(e) {
    this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, Bn && (Bn.active ? Bn.effects.push(this) : this.flags &= -2);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, Om.has(this) && (Om.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || K3(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, Fx(this), Y3(this);
    const e = Ht, t = Zi;
    Ht = this, Zi = !0;
    try {
      return this.fn();
    } finally {
      X3(this), Ht = e, Zi = t, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let e = this.deps; e; e = e.nextDep)
        d1(e);
      this.deps = this.depsTail = void 0, Fx(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? Om.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    sv(this) && this.run();
  }
  get dirty() {
    return sv(this);
  }
}
let q3 = 0, oc, rc;
function K3(i, e = !1) {
  if (i.flags |= 8, e) {
    i.next = rc, rc = i;
    return;
  }
  i.next = oc, oc = i;
}
function a1() {
  q3++;
}
function l1() {
  if (--q3 > 0)
    return;
  if (rc) {
    let e = rc;
    for (rc = void 0; e; ) {
      const t = e.next;
      e.next = void 0, e.flags &= -9, e = t;
    }
  }
  let i;
  for (; oc; ) {
    let e = oc;
    for (oc = void 0; e; ) {
      const t = e.next;
      if (e.next = void 0, e.flags &= -9, e.flags & 1)
        try {
          e.trigger();
        } catch (n) {
          i || (i = n);
        }
      e = t;
    }
  }
  if (i) throw i;
}
function Y3(i) {
  for (let e = i.deps; e; e = e.nextDep)
    e.version = -1, e.prevActiveLink = e.dep.activeLink, e.dep.activeLink = e;
}
function X3(i) {
  let e, t = i.depsTail, n = t;
  for (; n; ) {
    const s = n.prevDep;
    n.version === -1 ? (n === t && (t = s), d1(n), HP(n)) : e = n, n.dep.activeLink = n.prevActiveLink, n.prevActiveLink = void 0, n = s;
  }
  i.deps = e, i.depsTail = t;
}
function sv(i) {
  for (let e = i.deps; e; e = e.nextDep)
    if (e.dep.version !== e.version || e.dep.computed && (J3(e.dep.computed) || e.dep.version !== e.version))
      return !0;
  return !!i._dirty;
}
function J3(i) {
  if (i.flags & 4 && !(i.flags & 16) || (i.flags &= -17, i.globalVersion === Ac) || (i.globalVersion = Ac, !i.isSSR && i.flags & 128 && (!i.deps && !i._dirty || !sv(i))))
    return;
  i.flags |= 2;
  const e = i.dep, t = Ht, n = Zi;
  Ht = i, Zi = !0;
  try {
    Y3(i);
    const s = i.fn(i._value);
    (e.version === 0 || ys(s, i._value)) && (i.flags |= 128, i._value = s, e.version++);
  } catch (s) {
    throw e.version++, s;
  } finally {
    Ht = t, Zi = n, X3(i), i.flags &= -3;
  }
}
function d1(i, e = !1) {
  const { dep: t, prevSub: n, nextSub: s } = i;
  if (n && (n.nextSub = s, i.prevSub = void 0), s && (s.prevSub = n, i.nextSub = void 0), t.subs === i && (t.subs = n, !n && t.computed)) {
    t.computed.flags &= -5;
    for (let o = t.computed.deps; o; o = o.nextDep)
      d1(o, !0);
  }
  !e && !--t.sc && t.map && t.map.delete(t.key);
}
function HP(i) {
  const { prevDep: e, nextDep: t } = i;
  e && (e.nextDep = t, i.prevDep = void 0), t && (t.prevDep = e, i.nextDep = void 0);
}
let Zi = !0;
const Z3 = [];
function Jo() {
  Z3.push(Zi), Zi = !1;
}
function Zo() {
  const i = Z3.pop();
  Zi = i === void 0 ? !0 : i;
}
function Fx(i) {
  const { cleanup: e } = i;
  if (i.cleanup = void 0, e) {
    const t = Ht;
    Ht = void 0;
    try {
      e();
    } finally {
      Ht = t;
    }
  }
}
let Ac = 0, VP = class {
  constructor(e, t) {
    this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
};
class c1 {
  // TODO isolatedDeclarations "__v_skip"
  constructor(e) {
    this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0;
  }
  track(e) {
    if (!Ht || !Zi || Ht === this.computed)
      return;
    let t = this.activeLink;
    if (t === void 0 || t.sub !== Ht)
      t = this.activeLink = new VP(Ht, this), Ht.deps ? (t.prevDep = Ht.depsTail, Ht.depsTail.nextDep = t, Ht.depsTail = t) : Ht.deps = Ht.depsTail = t, Q3(t);
    else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
      const n = t.nextDep;
      n.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = n), t.prevDep = Ht.depsTail, t.nextDep = void 0, Ht.depsTail.nextDep = t, Ht.depsTail = t, Ht.deps === t && (Ht.deps = n);
    }
    return t;
  }
  trigger(e) {
    this.version++, Ac++, this.notify(e);
  }
  notify(e) {
    a1();
    try {
      for (let t = this.subs; t; t = t.prevSub)
        t.sub.notify() && t.sub.dep.notify();
    } finally {
      l1();
    }
  }
}
function Q3(i) {
  if (i.dep.sc++, i.sub.flags & 4) {
    const e = i.dep.computed;
    if (e && !i.dep.subs) {
      e.flags |= 20;
      for (let n = e.deps; n; n = n.nextDep)
        Q3(n);
    }
    const t = i.dep.subs;
    t !== i && (i.prevSub = t, t && (t.nextSub = i)), i.dep.subs = i;
  }
}
const ov = /* @__PURE__ */ new WeakMap(), ea = /* @__PURE__ */ Symbol(
  ""
), rv = /* @__PURE__ */ Symbol(
  ""
), Pc = /* @__PURE__ */ Symbol(
  ""
);
function Vn(i, e, t) {
  if (Zi && Ht) {
    let n = ov.get(i);
    n || ov.set(i, n = /* @__PURE__ */ new Map());
    let s = n.get(t);
    s || (n.set(t, s = new c1()), s.map = n, s.key = t), s.track();
  }
}
function Ws(i, e, t, n, s, o) {
  const r = ov.get(i);
  if (!r) {
    Ac++;
    return;
  }
  const a = (l) => {
    l && l.trigger();
  };
  if (a1(), e === "clear")
    r.forEach(a);
  else {
    const l = mt(i), d = l && s1(t);
    if (l && t === "length") {
      const c = Number(n);
      r.forEach((h, f) => {
        (f === "length" || f === Pc || !is(f) && f >= c) && a(h);
      });
    } else
      switch ((t !== void 0 || r.has(void 0)) && a(r.get(t)), d && a(r.get(Pc)), e) {
        case "add":
          l ? d && a(r.get("length")) : (a(r.get(ea)), jo(i) && a(r.get(rv)));
          break;
        case "delete":
          l || (a(r.get(ea)), jo(i) && a(r.get(rv)));
          break;
        case "set":
          jo(i) && a(r.get(ea));
          break;
      }
  }
  l1();
}
function wa(i) {
  const e = /* @__PURE__ */ Et(i);
  return e === i || (Vn(e, "iterate", Pc), /* @__PURE__ */ Li(i)) ? e : /* @__PURE__ */ _s(i) ? /* @__PURE__ */ Ho(i) ? e.map((t) => Qo(Fi(t))) : e.map(Qo) : e.map(Fi);
}
function Jf(i) {
  return Vn(i = /* @__PURE__ */ Et(i), "iterate", Pc), i;
}
function bs(i, e) {
  return /* @__PURE__ */ _s(i) ? Qo(/* @__PURE__ */ Ho(i) ? Fi(e) : e) : Fi(e);
}
const WP = {
  __proto__: null,
  [Symbol.iterator]() {
    return Lm(this, Symbol.iterator, (i) => bs(this, i));
  },
  concat(...i) {
    return wa(this).concat(
      ...i.map((e) => mt(e) ? wa(e) : e)
    );
  },
  entries() {
    return Lm(this, "entries", (i) => (i[1] = bs(this, i[1]), i));
  },
  every(i, e) {
    return As(this, "every", i, e, void 0, arguments);
  },
  filter(i, e) {
    return As(
      this,
      "filter",
      i,
      e,
      (t) => t.map((n) => bs(this, n)),
      arguments
    );
  },
  find(i, e) {
    return As(
      this,
      "find",
      i,
      e,
      (t) => bs(this, t),
      arguments
    );
  },
  findIndex(i, e) {
    return As(this, "findIndex", i, e, void 0, arguments);
  },
  findLast(i, e) {
    return As(
      this,
      "findLast",
      i,
      e,
      (t) => bs(this, t),
      arguments
    );
  },
  findLastIndex(i, e) {
    return As(this, "findLastIndex", i, e, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(i, e) {
    return As(this, "forEach", i, e, void 0, arguments);
  },
  includes(...i) {
    return Bm(this, "includes", i);
  },
  indexOf(...i) {
    return Bm(this, "indexOf", i);
  },
  join(i) {
    return wa(this).join(i);
  },
  // keys() iterator only reads `length`, no optimization required
  lastIndexOf(...i) {
    return Bm(this, "lastIndexOf", i);
  },
  map(i, e) {
    return As(this, "map", i, e, void 0, arguments);
  },
  pop() {
    return sd(this, "pop");
  },
  push(...i) {
    return sd(this, "push", i);
  },
  reduce(i, ...e) {
    return Nx(this, "reduce", i, e);
  },
  reduceRight(i, ...e) {
    return Nx(this, "reduceRight", i, e);
  },
  shift() {
    return sd(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(i, e) {
    return As(this, "some", i, e, void 0, arguments);
  },
  splice(...i) {
    return sd(this, "splice", i);
  },
  toReversed() {
    return wa(this).toReversed();
  },
  toSorted(i) {
    return wa(this).toSorted(i);
  },
  toSpliced(...i) {
    return wa(this).toSpliced(...i);
  },
  unshift(...i) {
    return sd(this, "unshift", i);
  },
  values() {
    return Lm(this, "values", (i) => bs(this, i));
  }
};
function Lm(i, e, t) {
  const n = Jf(i), s = n[e]();
  return n !== i && !/* @__PURE__ */ Li(i) && (s._next = s.next, s.next = () => {
    const o = s._next();
    return o.done || (o.value = t(o.value)), o;
  }), s;
}
const qP = Array.prototype;
function As(i, e, t, n, s, o) {
  const r = Jf(i), a = r !== i && !/* @__PURE__ */ Li(i), l = r[e];
  if (l !== qP[e]) {
    const h = l.apply(i, o);
    return a ? Fi(h) : h;
  }
  let d = t;
  r !== i && (a ? d = function(h, f) {
    return t.call(this, bs(i, h), f, i);
  } : t.length > 2 && (d = function(h, f) {
    return t.call(this, h, f, i);
  }));
  const c = l.call(r, d, n);
  return a && s ? s(c) : c;
}
function Nx(i, e, t, n) {
  const s = Jf(i), o = s !== i && !/* @__PURE__ */ Li(i);
  let r = t, a = !1;
  s !== i && (o ? (a = n.length === 0, r = function(d, c, h) {
    return a && (a = !1, d = bs(i, d)), t.call(this, d, bs(i, c), h, i);
  }) : t.length > 3 && (r = function(d, c, h) {
    return t.call(this, d, c, h, i);
  }));
  const l = s[e](r, ...n);
  return a ? bs(i, l) : l;
}
function Bm(i, e, t) {
  const n = /* @__PURE__ */ Et(i);
  Vn(n, "iterate", Pc);
  const s = n[e](...t);
  return (s === -1 || s === !1) && /* @__PURE__ */ p1(t[0]) ? (t[0] = /* @__PURE__ */ Et(t[0]), n[e](...t)) : s;
}
function sd(i, e, t = []) {
  Jo(), a1();
  const n = (/* @__PURE__ */ Et(i))[e].apply(i, t);
  return l1(), Zo(), n;
}
const KP = /* @__PURE__ */ i1("__proto__,__v_isRef,__isVue"), e5 = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((i) => i !== "arguments" && i !== "caller").map((i) => Symbol[i]).filter(is)
);
function YP(i) {
  is(i) || (i = String(i));
  const e = /* @__PURE__ */ Et(this);
  return Vn(e, "has", i), e.hasOwnProperty(i);
}
class t5 {
  constructor(e = !1, t = !1) {
    this._isReadonly = e, this._isShallow = t;
  }
  get(e, t, n) {
    if (t === "__v_skip") return e.__v_skip;
    const s = this._isReadonly, o = this._isShallow;
    if (t === "__v_isReactive")
      return !s;
    if (t === "__v_isReadonly")
      return s;
    if (t === "__v_isShallow")
      return o;
    if (t === "__v_raw")
      return n === (s ? o ? oE : o5 : o ? s5 : i5).get(e) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(e) === Object.getPrototypeOf(n) ? e : void 0;
    const r = mt(e);
    if (!s) {
      let l;
      if (r && (l = WP[t]))
        return l;
      if (t === "hasOwnProperty")
        return YP;
    }
    const a = Reflect.get(
      e,
      t,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      /* @__PURE__ */ ai(e) ? e : n
    );
    if ((is(t) ? e5.has(t) : KP(t)) || (s || Vn(e, "get", t), o))
      return a;
    if (/* @__PURE__ */ ai(a)) {
      const l = r && s1(t) ? a : a.value;
      return s && qt(l) ? /* @__PURE__ */ dv(l) : l;
    }
    return qt(a) ? s ? /* @__PURE__ */ dv(a) : /* @__PURE__ */ Xt(a) : a;
  }
}
class n5 extends t5 {
  constructor(e = !1) {
    super(!1, e);
  }
  set(e, t, n, s) {
    let o = e[t];
    const r = mt(e) && s1(t);
    if (!this._isShallow) {
      const d = /* @__PURE__ */ _s(o);
      if (!/* @__PURE__ */ Li(n) && !/* @__PURE__ */ _s(n) && (o = /* @__PURE__ */ Et(o), n = /* @__PURE__ */ Et(n)), !r && /* @__PURE__ */ ai(o) && !/* @__PURE__ */ ai(n))
        return d || (o.value = n), !0;
    }
    const a = r ? Number(t) < e.length : jt(e, t), l = Reflect.set(
      e,
      t,
      n,
      /* @__PURE__ */ ai(e) ? e : s
    );
    return e === /* @__PURE__ */ Et(s) && l && (a ? ys(n, o) && Ws(e, "set", t, n) : Ws(e, "add", t, n)), l;
  }
  deleteProperty(e, t) {
    const n = jt(e, t);
    e[t];
    const s = Reflect.deleteProperty(e, t);
    return s && n && Ws(e, "delete", t, void 0), s;
  }
  has(e, t) {
    const n = Reflect.has(e, t);
    return (!is(t) || !e5.has(t)) && Vn(e, "has", t), n;
  }
  ownKeys(e) {
    return Vn(
      e,
      "iterate",
      mt(e) ? "length" : ea
    ), Reflect.ownKeys(e);
  }
}
class XP extends t5 {
  constructor(e = !1) {
    super(!0, e);
  }
  set(e, t) {
    return !0;
  }
  deleteProperty(e, t) {
    return !0;
  }
}
const JP = /* @__PURE__ */ new n5(), ZP = /* @__PURE__ */ new XP(), QP = /* @__PURE__ */ new n5(!0);
const av = (i) => i, Au = (i) => Reflect.getPrototypeOf(i);
function eE(i, e, t) {
  return function(...n) {
    const s = this.__v_raw, o = /* @__PURE__ */ Et(s), r = jo(o), a = i === "entries" || i === Symbol.iterator && r, l = i === "keys" && r, d = s[i](...n), c = t ? av : e ? Qo : Fi;
    return !e && Vn(
      o,
      "iterate",
      l ? rv : ea
    ), gi(
      // inheriting all iterator properties
      Object.create(d),
      {
        // iterator protocol
        next() {
          const { value: h, done: f } = d.next();
          return f ? { value: h, done: f } : {
            value: a ? [c(h[0]), c(h[1])] : c(h),
            done: f
          };
        }
      }
    );
  };
}
function Pu(i) {
  return function(...e) {
    return i === "delete" ? !1 : i === "clear" ? void 0 : this;
  };
}
function tE(i, e) {
  const t = {
    get(s) {
      const o = this.__v_raw, r = /* @__PURE__ */ Et(o), a = /* @__PURE__ */ Et(s);
      i || (ys(s, a) && Vn(r, "get", s), Vn(r, "get", a));
      const { has: l } = Au(r), d = e ? av : i ? Qo : Fi;
      if (l.call(r, s))
        return d(o.get(s));
      if (l.call(r, a))
        return d(o.get(a));
      o !== r && o.get(s);
    },
    get size() {
      const s = this.__v_raw;
      return !i && Vn(/* @__PURE__ */ Et(s), "iterate", ea), s.size;
    },
    has(s) {
      const o = this.__v_raw, r = /* @__PURE__ */ Et(o), a = /* @__PURE__ */ Et(s);
      return i || (ys(s, a) && Vn(r, "has", s), Vn(r, "has", a)), s === a ? o.has(s) : o.has(s) || o.has(a);
    },
    forEach(s, o) {
      const r = this, a = r.__v_raw, l = /* @__PURE__ */ Et(a), d = e ? av : i ? Qo : Fi;
      return !i && Vn(l, "iterate", ea), a.forEach((c, h) => s.call(o, d(c), d(h), r));
    }
  };
  return gi(
    t,
    i ? {
      add: Pu("add"),
      set: Pu("set"),
      delete: Pu("delete"),
      clear: Pu("clear")
    } : {
      add(s) {
        const o = /* @__PURE__ */ Et(this), r = Au(o), a = /* @__PURE__ */ Et(s), l = !e && !/* @__PURE__ */ Li(s) && !/* @__PURE__ */ _s(s) ? a : s;
        return r.has.call(o, l) || ys(s, l) && r.has.call(o, s) || ys(a, l) && r.has.call(o, a) || (o.add(l), Ws(o, "add", l, l)), this;
      },
      set(s, o) {
        !e && !/* @__PURE__ */ Li(o) && !/* @__PURE__ */ _s(o) && (o = /* @__PURE__ */ Et(o));
        const r = /* @__PURE__ */ Et(this), { has: a, get: l } = Au(r);
        let d = a.call(r, s);
        d || (s = /* @__PURE__ */ Et(s), d = a.call(r, s));
        const c = l.call(r, s);
        return r.set(s, o), d ? ys(o, c) && Ws(r, "set", s, o) : Ws(r, "add", s, o), this;
      },
      delete(s) {
        const o = /* @__PURE__ */ Et(this), { has: r, get: a } = Au(o);
        let l = r.call(o, s);
        l || (s = /* @__PURE__ */ Et(s), l = r.call(o, s)), a && a.call(o, s);
        const d = o.delete(s);
        return l && Ws(o, "delete", s, void 0), d;
      },
      clear() {
        const s = /* @__PURE__ */ Et(this), o = s.size !== 0, r = s.clear();
        return o && Ws(
          s,
          "clear",
          void 0,
          void 0
        ), r;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((s) => {
    t[s] = eE(s, i, e);
  }), t;
}
function u1(i, e) {
  const t = tE(i, e);
  return (n, s, o) => s === "__v_isReactive" ? !i : s === "__v_isReadonly" ? i : s === "__v_raw" ? n : Reflect.get(
    jt(t, s) && s in n ? t : n,
    s,
    o
  );
}
const nE = {
  get: /* @__PURE__ */ u1(!1, !1)
}, iE = {
  get: /* @__PURE__ */ u1(!1, !0)
}, sE = {
  get: /* @__PURE__ */ u1(!0, !1)
};
const i5 = /* @__PURE__ */ new WeakMap(), s5 = /* @__PURE__ */ new WeakMap(), o5 = /* @__PURE__ */ new WeakMap(), oE = /* @__PURE__ */ new WeakMap();
function rE(i) {
  switch (i) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
// @__NO_SIDE_EFFECTS__
function Xt(i) {
  return /* @__PURE__ */ _s(i) ? i : h1(
    i,
    !1,
    JP,
    nE,
    i5
  );
}
// @__NO_SIDE_EFFECTS__
function lv(i) {
  return h1(
    i,
    !1,
    QP,
    iE,
    s5
  );
}
// @__NO_SIDE_EFFECTS__
function dv(i) {
  return h1(
    i,
    !0,
    ZP,
    sE,
    o5
  );
}
function h1(i, e, t, n, s) {
  if (!qt(i) || i.__v_raw && !(e && i.__v_isReactive) || i.__v_skip || !Object.isExtensible(i))
    return i;
  const o = s.get(i);
  if (o)
    return o;
  const r = rE(EP(i));
  if (r === 0)
    return i;
  const a = new Proxy(
    i,
    r === 2 ? n : t
  );
  return s.set(i, a), a;
}
// @__NO_SIDE_EFFECTS__
function Ho(i) {
  return /* @__PURE__ */ _s(i) ? /* @__PURE__ */ Ho(i.__v_raw) : !!(i && i.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function _s(i) {
  return !!(i && i.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function Li(i) {
  return !!(i && i.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function p1(i) {
  return i ? !!i.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function Et(i) {
  const e = i && i.__v_raw;
  return e ? /* @__PURE__ */ Et(e) : i;
}
function cv(i) {
  return !jt(i, "__v_skip") && Object.isExtensible(i) && N3(i, "__v_skip", !0), i;
}
const Fi = (i) => qt(i) ? /* @__PURE__ */ Xt(i) : i, Qo = (i) => qt(i) ? /* @__PURE__ */ dv(i) : i;
// @__NO_SIDE_EFFECTS__
function ai(i) {
  return i ? i.__v_isRef === !0 : !1;
}
// @__NO_SIDE_EFFECTS__
function K(i) {
  return r5(i, !1);
}
// @__NO_SIDE_EFFECTS__
function qe(i) {
  return r5(i, !0);
}
function r5(i, e) {
  return /* @__PURE__ */ ai(i) ? i : new aE(i, e);
}
class aE {
  constructor(e, t) {
    this.dep = new c1(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = t ? e : /* @__PURE__ */ Et(e), this._value = t ? e : Fi(e), this.__v_isShallow = t;
  }
  get value() {
    return this.dep.track(), this._value;
  }
  set value(e) {
    const t = this._rawValue, n = this.__v_isShallow || /* @__PURE__ */ Li(e) || /* @__PURE__ */ _s(e);
    e = n ? e : /* @__PURE__ */ Et(e), ys(e, t) && (this._rawValue = e, this._value = n ? e : Fi(e), this.dep.trigger());
  }
}
function xs(i) {
  i.dep && i.dep.trigger();
}
function m(i) {
  return /* @__PURE__ */ ai(i) ? i.value : i;
}
const lE = {
  get: (i, e, t) => e === "__v_raw" ? i : m(Reflect.get(i, e, t)),
  set: (i, e, t, n) => {
    const s = i[e];
    return /* @__PURE__ */ ai(s) && !/* @__PURE__ */ ai(t) ? (s.value = t, !0) : Reflect.set(i, e, t, n);
  }
};
function a5(i) {
  return /* @__PURE__ */ Ho(i) ? i : new Proxy(i, lE);
}
class dE {
  constructor(e, t, n) {
    this.fn = e, this.setter = t, this._value = void 0, this.dep = new c1(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = Ac - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !t, this.isSSR = n;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    Ht !== this)
      return K3(this, !0), !0;
  }
  get value() {
    const e = this.dep.track();
    return J3(this), e && (e.version = this.dep.version), this._value;
  }
  set value(e) {
    this.setter && this.setter(e);
  }
}
// @__NO_SIDE_EFFECTS__
function cE(i, e, t = !1) {
  let n, s;
  return Ft(i) ? n = i : (n = i.get, s = i.set), new dE(n, s, t);
}
const Eu = {}, Np = /* @__PURE__ */ new WeakMap();
let Cr;
function uE(i, e = !1, t = Cr) {
  if (t) {
    let n = Np.get(t);
    n || Np.set(t, n = []), n.push(i);
  }
}
function hE(i, e, t = en) {
  const { immediate: n, deep: s, once: o, scheduler: r, augmentJob: a, call: l } = t, d = (_) => s ? _ : /* @__PURE__ */ Li(_) || s === !1 || s === 0 ? qs(_, 1) : qs(_);
  let c, h, f, p, y = !1, v = !1;
  if (/* @__PURE__ */ ai(i) ? (h = () => i.value, y = /* @__PURE__ */ Li(i)) : /* @__PURE__ */ Ho(i) ? (h = () => d(i), y = !0) : mt(i) ? (v = !0, y = i.some((_) => /* @__PURE__ */ Ho(_) || /* @__PURE__ */ Li(_)), h = () => i.map((_) => {
    if (/* @__PURE__ */ ai(_))
      return _.value;
    if (/* @__PURE__ */ Ho(_))
      return d(_);
    if (Ft(_))
      return l ? l(_, 2) : _();
  })) : Ft(i) ? e ? h = l ? () => l(i, 2) : i : h = () => {
    if (f) {
      Jo();
      try {
        f();
      } finally {
        Zo();
      }
    }
    const _ = Cr;
    Cr = c;
    try {
      return l ? l(i, 3, [p]) : i(p);
    } finally {
      Cr = _;
    }
  } : h = Qr, e && s) {
    const _ = h, T = s === !0 ? 1 / 0 : s;
    h = () => qs(_(), T);
  }
  const x = jP(), w = () => {
    c.stop(), x && x.active && O3(x.effects, c);
  };
  if (o && e) {
    const _ = e;
    e = (...T) => {
      const k = _(...T);
      return w(), k;
    };
  }
  let S = v ? new Array(i.length).fill(Eu) : Eu;
  const M = (_) => {
    if (!(!(c.flags & 1) || !c.dirty && !_))
      if (e) {
        const T = c.run();
        if (_ || s || y || (v ? T.some((k, P) => ys(k, S[P])) : ys(T, S))) {
          f && f();
          const k = Cr;
          Cr = c;
          try {
            const P = [
              T,
              // pass undefined as the old value when it's changed for the first time
              S === Eu ? void 0 : v && S[0] === Eu ? [] : S,
              p
            ];
            S = T, l ? l(e, 3, P) : (
              // @ts-expect-error
              e(...P)
            );
          } finally {
            Cr = k;
          }
        }
      } else
        c.run();
  };
  return a && a(M), c = new W3(h), c.scheduler = r ? () => r(M, !1) : M, p = (_) => uE(_, !1, c), f = c.onStop = () => {
    const _ = Np.get(c);
    if (_) {
      if (l)
        l(_, 4);
      else
        for (const T of _) T();
      Np.delete(c);
    }
  }, e ? n ? M(!0) : S = c.run() : r ? r(M.bind(null, !0), !0) : c.run(), w.pause = c.pause.bind(c), w.resume = c.resume.bind(c), w.stop = w, w;
}
function qs(i, e = 1 / 0, t) {
  if (e <= 0 || !qt(i) || i.__v_skip || (t = t || /* @__PURE__ */ new Map(), (t.get(i) || 0) >= e))
    return i;
  if (t.set(i, e), e--, /* @__PURE__ */ ai(i))
    qs(i.value, e, t);
  else if (mt(i))
    for (let n = 0; n < i.length; n++)
      qs(i[n], e, t);
  else if (Il(i) || jo(i))
    i.forEach((n) => {
      qs(n, e, t);
    });
  else if (F3(i)) {
    for (const n in i)
      qs(i[n], e, t);
    for (const n of Object.getOwnPropertySymbols(i))
      Object.prototype.propertyIsEnumerable.call(i, n) && qs(i[n], e, t);
  }
  return i;
}
function gu(i, e, t, n) {
  try {
    return n ? i(...n) : i();
  } catch (s) {
    Zf(s, e, t);
  }
}
function ss(i, e, t, n) {
  if (Ft(i)) {
    const s = gu(i, e, t, n);
    return s && L3(s) && s.catch((o) => {
      Zf(o, e, t);
    }), s;
  }
  if (mt(i)) {
    const s = [];
    for (let o = 0; o < i.length; o++)
      s.push(ss(i[o], e, t, n));
    return s;
  }
}
function Zf(i, e, t, n = !0) {
  const s = e ? e.vnode : null, { errorHandler: o, throwUnhandledErrorInProduction: r } = e && e.appContext.config || en;
  if (e) {
    let a = e.parent;
    const l = e.proxy, d = `https://vuejs.org/error-reference/#runtime-${t}`;
    for (; a; ) {
      const c = a.ec;
      if (c) {
        for (let h = 0; h < c.length; h++)
          if (c[h](i, l, d) === !1)
            return;
      }
      a = a.parent;
    }
    if (o) {
      Jo(), gu(o, null, 10, [
        i,
        l,
        d
      ]), Zo();
      return;
    }
  }
  pE(i, t, s, n, r);
}
function pE(i, e, t, n = !0, s = !1) {
  if (s)
    throw i;
  console.error(i);
}
const ii = [];
let fs = -1;
const cl = [];
let Po = null, qa = 0;
const l5 = /* @__PURE__ */ Promise.resolve();
let Up = null;
function nt(i) {
  const e = Up || l5;
  return i ? e.then(this ? i.bind(this) : i) : e;
}
function fE(i) {
  let e = fs + 1, t = ii.length;
  for (; e < t; ) {
    const n = e + t >>> 1, s = ii[n], o = Ec(s);
    o < i || o === i && s.flags & 2 ? e = n + 1 : t = n;
  }
  return e;
}
function f1(i) {
  if (!(i.flags & 1)) {
    const e = Ec(i), t = ii[ii.length - 1];
    !t || // fast path when the job id is larger than the tail
    !(i.flags & 2) && e >= Ec(t) ? ii.push(i) : ii.splice(fE(e), 0, i), i.flags |= 1, d5();
  }
}
function d5() {
  Up || (Up = l5.then(u5));
}
function mE(i) {
  if (!mt(i))
    Po && i.id === -1 ? Po.splice(qa + 1, 0, i) : i.flags & 1 || (cl.push(i), i.flags |= 1);
  else
    for (let e = 0; e < i.length; e++)
      cl.push(i[e]);
  d5();
}
function Ux(i, e, t = fs + 1) {
  for (; t < ii.length; t++) {
    const n = ii[t];
    if (n && n.flags & 2) {
      if (i && n.id !== i.uid)
        continue;
      ii.splice(t, 1), t--, n.flags & 4 && (n.flags &= -2), n(), n.flags & 4 || (n.flags &= -2);
    }
  }
}
function c5(i) {
  if (cl.length) {
    const e = [...new Set(cl)].sort(
      (t, n) => Ec(t) - Ec(n)
    );
    if (cl.length = 0, Po) {
      for (let t = 0; t < e.length; t++)
        Po.push(e[t]);
      return;
    }
    for (Po = e, qa = 0; qa < Po.length; qa++) {
      const t = Po[qa];
      t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2;
    }
    Po = null, qa = 0;
  }
}
const Ec = (i) => i.id == null ? i.flags & 2 ? -1 : 1 / 0 : i.id;
function u5(i) {
  try {
    for (fs = 0; fs < ii.length; fs++) {
      const e = ii[fs];
      e && !(e.flags & 8) && (e.flags & 4 && (e.flags &= -2), gu(
        e,
        e.i,
        e.i ? 15 : 14
      ), e.flags & 4 || (e.flags &= -2));
    }
  } finally {
    for (; fs < ii.length; fs++) {
      const e = ii[fs];
      e && (e.flags &= -2);
    }
    fs = -1, ii.length = 0, c5(), Up = null, (ii.length || cl.length) && u5();
  }
}
let Un = null, h5 = null;
function Gp(i) {
  const e = Un;
  return Un = i, h5 = i && i.type.__scopeId || null, e;
}
function Xe(i, e = Un, t) {
  if (!e || i._n)
    return i;
  const n = (...s) => {
    n._d && Vp(-1);
    const o = Gp(e), r = Xs.length;
    let a;
    try {
      a = i(...s);
    } finally {
      for (let l = Xs.length; l > r; l--) k1();
      Gp(o), n._d && Vp(1);
    }
    return a;
  };
  return n._n = !0, n._c = !0, n._d = !0, n;
}
function kt(i, e) {
  if (Un === null)
    return i;
  const t = im(Un), n = i.dirs || (i.dirs = []);
  for (let s = 0; s < e.length; s++) {
    let [o, r, a, l = en] = e[s];
    o && (Ft(o) && (o = {
      mounted: o,
      updated: o
    }), o.deep && qs(r), n.push({
      dir: o,
      instance: t,
      value: r,
      oldValue: void 0,
      arg: a,
      modifiers: l
    }));
  }
  return i;
}
function pr(i, e, t, n) {
  const s = i.dirs, o = e && e.dirs;
  for (let r = 0; r < s.length; r++) {
    const a = s[r];
    o && (a.oldValue = o[r].value);
    let l = a.dir[n];
    l && (Jo(), ss(l, t, 8, [
      i.el,
      a,
      i,
      e
    ]), Zo());
  }
}
function p5(i, e) {
  if (pi) {
    let t = pi.provides;
    const n = pi.parent && pi.parent.provides;
    n === t && (t = pi.provides = Object.create(n)), t[i] = e;
  }
}
function Qf(i, e, t = !1) {
  const n = Wl();
  if (n || hl) {
    let s = hl ? hl._context.provides : n ? n.parent == null || n.ce ? n.vnode.appContext && n.vnode.appContext.provides : n.parent.provides : void 0;
    if (s && i in s)
      return s[i];
    if (arguments.length > 1)
      return t && Ft(e) ? e.call(n && n.proxy) : e;
  }
}
const gE = /* @__PURE__ */ Symbol.for("v-scx"), bE = () => Qf(gE);
function vE(i, e) {
  return f5(i, null, e);
}
function Ae(i, e, t) {
  return f5(i, e, t);
}
function f5(i, e, t = en) {
  const { immediate: n, deep: s, flush: o, once: r } = t, a = gi({}, t), l = e && n || !e && o !== "post";
  let d;
  if (Oc) {
    if (o === "sync") {
      const p = bE();
      d = p.__watcherHandles || (p.__watcherHandles = []);
    } else if (!l) {
      const p = () => {
      };
      return p.stop = Qr, p.resume = Qr, p.pause = Qr, p;
    }
  }
  const c = pi;
  a.call = (p, y, v) => ss(p, c, y, v);
  let h = !1;
  o === "post" ? a.scheduler = (p) => {
    ei(p, c && c.suspense);
  } : o !== "sync" && (h = !0, a.scheduler = (p, y) => {
    y ? p() : f1(p);
  }), a.augmentJob = (p) => {
    e && (p.flags |= 4), h && (p.flags |= 2, c && (p.id = c.uid, p.i = c));
  };
  const f = hE(i, e, a);
  return Oc && (d ? d.push(f) : l && f()), f;
}
const To = /* @__PURE__ */ new WeakMap(), m5 = /* @__PURE__ */ Symbol("_vte"), em = (i) => i.__isTeleport, Br = (i) => i && (i.disabled || i.disabled === ""), yE = (i) => i && (i.defer || i.defer === ""), Gx = (i) => typeof SVGElement != "undefined" && i instanceof SVGElement, jx = (i) => typeof MathMLElement == "function" && i instanceof MathMLElement, uv = (i, e) => {
  const t = i && i.to;
  return on(t) ? e ? e(t) : null : t;
}, xE = {
  name: "Teleport",
  __isTeleport: !0,
  process(i, e, t, n, s, o, r, a, l, d) {
    const {
      mc: c,
      pc: h,
      pbc: f,
      o: { insert: p, querySelector: y, createText: v, createComment: x, parentNode: w }
    } = d, S = Br(e.props);
    let { dynamicChildren: M } = e;
    const _ = (P, A, R) => {
      P.shapeFlag & 16 && c(
        P.children,
        A,
        R,
        s,
        o,
        r,
        a,
        l
      );
    }, T = (P = e) => {
      const A = Br(P.props), R = P.target = uv(P.props, y), D = hv(R, P, v, p);
      R && (r !== "svg" && Gx(R) ? r = "svg" : r !== "mathml" && jx(R) && (r = "mathml"), s && s.isCE && (s.ce._teleportTargets || (s.ce._teleportTargets = /* @__PURE__ */ new Set())).add(R), A || (_(P, R, D), Gd(P, !1)));
    }, k = (P) => {
      const A = () => {
        if (To.get(P) === A) {
          if (To.delete(P), Br(P.props)) {
            const R = w(P.el) || t;
            _(P, R, P.anchor), Gd(P, !0);
          }
          T(P);
        }
      };
      To.set(P, A), ei(A, o);
    };
    if (i == null) {
      const P = e.el = v(""), A = e.anchor = v("");
      if (p(P, t, n), p(A, t, n), yE(e.props) || o && o.pendingBranch) {
        k(e);
        return;
      }
      S && (_(e, t, A), Gd(e, !0)), T();
    } else {
      e.el = i.el;
      const P = e.anchor = i.anchor, A = To.get(i);
      if (A) {
        A.flags |= 8, To.delete(i), k(e);
        return;
      }
      e.targetStart = i.targetStart;
      const R = e.target = i.target, D = e.targetAnchor = i.targetAnchor, O = Br(i.props), F = O ? t : R, te = O ? P : D;
      if (r === "svg" || Gx(R) ? r = "svg" : (r === "mathml" || jx(R)) && (r = "mathml"), M ? (f(
        i.dynamicChildren,
        M,
        F,
        s,
        o,
        r,
        a
      ), w1(i, e, !0)) : l || h(
        i,
        e,
        F,
        te,
        s,
        o,
        r,
        a,
        !1
      ), S)
        O ? e.props && i.props && e.props.to !== i.props.to && (e.props.to = i.props.to) : Ru(
          e,
          t,
          P,
          d,
          1
        );
      else if ((e.props && e.props.to) !== (i.props && i.props.to)) {
        const ee = uv(e.props, y);
        ee && (e.target = ee, Ru(
          e,
          ee,
          null,
          d,
          0
        ));
      } else O && Ru(
        e,
        R,
        D,
        d,
        1
      );
      Gd(e, S);
    }
  },
  remove(i, e, t, { um: n, o: { remove: s } }, o) {
    const {
      shapeFlag: r,
      children: a,
      anchor: l,
      targetStart: d,
      targetAnchor: c,
      target: h,
      props: f
    } = i, p = Br(f), y = o || !p, v = To.get(i);
    if (v && (v.flags |= 8, To.delete(i)), h && (s(d), s(c)), o && s(l), !v && (p || h) && r & 16)
      for (let x = 0; x < a.length; x++) {
        const w = a[x];
        n(
          w,
          e,
          t,
          y,
          !!w.dynamicChildren
        );
      }
  },
  move: Ru,
  hydrate: wE
};
function Ru(i, e, t, { o: { insert: n }, m: s }, o = 2) {
  o === 0 && n(i.targetAnchor, e, t);
  const { el: r, anchor: a, shapeFlag: l, children: d, props: c } = i, h = o === 2;
  if (h && n(r, e, t), !To.has(i) && (!h || Br(c)) && l & 16)
    for (let f = 0; f < d.length; f++)
      s(
        d[f],
        e,
        t,
        2
      );
  h && n(a, e, t);
}
function wE(i, e, t, n, s, o, {
  o: { nextSibling: r, parentNode: a, querySelector: l, insert: d, createText: c }
}, h) {
  function f(x, w) {
    let S = w;
    for (; S; ) {
      if (S && S.nodeType === 8) {
        if (S.data === "teleport start anchor")
          e.targetStart = S;
        else if (S.data === "teleport anchor") {
          e.targetAnchor = S, x._lpa = e.targetAnchor && r(e.targetAnchor);
          break;
        }
      }
      S = r(S);
    }
  }
  function p(x, w) {
    w.anchor = h(
      r(x),
      w,
      a(x),
      t,
      n,
      s,
      o
    );
  }
  const y = e.target = uv(
    e.props,
    l
  ), v = Br(e.props);
  if (y) {
    const x = y._lpa || y.firstChild;
    e.shapeFlag & 16 && (v ? (p(i, e), f(y, x), e.targetAnchor || hv(
      y,
      e,
      c,
      d,
      // if target is the same as the main view, insert anchors before current node
      // to avoid hydrating mismatch
      a(i) === y ? i : null
    )) : (e.anchor = r(i), f(y, x), e.targetAnchor || hv(y, e, c, d), h(
      x && r(x),
      e,
      y,
      t,
      n,
      s,
      o
    ))), Gd(e, v);
  } else v && e.shapeFlag & 16 && (p(i, e), e.targetStart = i, e.targetAnchor = r(i));
  return e.anchor && r(e.anchor);
}
const m1 = xE;
function Gd(i, e) {
  const t = i.ctx;
  if (t && t.ut) {
    let n, s;
    for (e ? (n = i.el, s = i.anchor) : (n = i.targetStart, s = i.targetAnchor); n && n !== s; )
      n.nodeType === 1 && n.setAttribute("data-v-owner", t.uid), n = n.nextSibling;
    t.ut();
  }
}
function hv(i, e, t, n, s = null) {
  const o = e.targetStart = t(""), r = e.targetAnchor = t("");
  return o[m5] = r, i && (n(o, i, s), n(r, i, s)), r;
}
const $i = /* @__PURE__ */ Symbol("_leaveCb"), od = /* @__PURE__ */ Symbol("_enterCb");
function g5() {
  const i = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return ot(() => {
    i.isMounted = !0;
  }), We(() => {
    i.isUnmounting = !0;
  }), i;
}
const Pi = [Function, Array], b5 = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: Pi,
  onEnter: Pi,
  onAfterEnter: Pi,
  onEnterCancelled: Pi,
  // leave
  onBeforeLeave: Pi,
  onLeave: Pi,
  onAfterLeave: Pi,
  onLeaveCancelled: Pi,
  // appear
  onBeforeAppear: Pi,
  onAppear: Pi,
  onAfterAppear: Pi,
  onAppearCancelled: Pi
}, v5 = (i) => {
  const e = i.subTree;
  return e.component ? v5(e.component) : e;
}, kE = {
  name: "BaseTransition",
  props: b5,
  setup(i, { slots: e }) {
    const t = Wl(), n = g5();
    return () => {
      const s = e.default && g1(e.default(), !0), o = s && s.length ? y5(s) : (
        // Keep explicit default-slot conditionals on the same transition path
        // as regular v-if branches, which render a comment placeholder.
        t.subTree ? z() : void 0
      );
      if (!o)
        return;
      const r = /* @__PURE__ */ Et(i), { mode: a } = r;
      if (n.isLeaving)
        return Fm(o);
      const l = jp(o);
      if (!l)
        return Fm(o);
      let d = Rc(
        l,
        r,
        n,
        t,
        // #11061, ensure enterHooks is fresh after clone
        (h) => d = h
      );
      l.type !== qn && aa(l, d);
      let c = t.subTree && jp(t.subTree);
      if (c && c.type !== qn && !Fr(c, l) && v5(t).type !== qn) {
        let h = Rc(
          c,
          r,
          n,
          t
        );
        if (aa(c, h), a === "out-in" && l.type !== qn)
          return n.isLeaving = !0, h.afterLeave = () => {
            n.isLeaving = !1, t.job.flags & 8 || t.update(), delete h.afterLeave, c = void 0;
          }, Fm(o);
        a === "in-out" && l.type !== qn ? h.delayLeave = (f, p, y) => {
          const v = x5(
            n,
            c
          );
          v[String(c.key)] = c, f[$i] = () => {
            p(), f[$i] = void 0, delete d.delayedLeave, c = void 0;
          }, d.delayedLeave = () => {
            y(), delete d.delayedLeave, c = void 0;
          };
        } : c = void 0;
      } else c && (c = void 0);
      return o;
    };
  }
};
function y5(i) {
  let e = i[0];
  if (i.length > 1) {
    for (const t of i)
      if (t.type !== qn) {
        e = t;
        break;
      }
  }
  return e;
}
const _E = kE;
function x5(i, e) {
  const { leavingVNodes: t } = i;
  let n = t.get(e.type);
  return n || (n = /* @__PURE__ */ Object.create(null), t.set(e.type, n)), n;
}
function Rc(i, e, t, n, s) {
  const {
    appear: o,
    mode: r,
    persisted: a = !1,
    onBeforeEnter: l,
    onEnter: d,
    onAfterEnter: c,
    onEnterCancelled: h,
    onBeforeLeave: f,
    onLeave: p,
    onAfterLeave: y,
    onLeaveCancelled: v,
    onBeforeAppear: x,
    onAppear: w,
    onAfterAppear: S,
    onAppearCancelled: M
  } = e, _ = String(i.key), T = x5(t, i), k = (R, D) => {
    R && ss(
      R,
      n,
      9,
      D
    );
  }, P = (R, D) => {
    const O = D[1];
    k(R, D), mt(R) ? R.every((F) => F.length <= 1) && O() : R.length <= 1 && O();
  }, A = {
    mode: r,
    persisted: a,
    beforeEnter(R) {
      let D = l;
      if (!t.isMounted)
        if (o)
          D = x || l;
        else
          return;
      R[$i] && R[$i](
        !0
        /* cancelled */
      );
      const O = T[_];
      O && Fr(i, O) && O.el[$i] && O.el[$i](), k(D, [R]);
    },
    enter(R) {
      if (T[_] === i) return;
      let D = d, O = c, F = h;
      if (!t.isMounted)
        if (o)
          D = w || d, O = S || c, F = M || h;
        else
          return;
      let te = !1;
      R[od] = (me) => {
        te || (te = !0, me ? k(F, [R]) : k(O, [R]), A.delayedLeave && A.delayedLeave(), R[od] = void 0);
      };
      const ee = R[od].bind(null, !1);
      D ? P(D, [R, ee]) : ee();
    },
    leave(R, D) {
      const O = String(i.key);
      if (R[od] && R[od](
        !0
        /* cancelled */
      ), t.isUnmounting)
        return D();
      k(f, [R]);
      let F = !1;
      R[$i] = (ee) => {
        F || (F = !0, D(), ee ? k(v, [R]) : k(y, [R]), R[$i] = void 0, T[O] === i && delete T[O]);
      };
      const te = R[$i].bind(null, !1);
      T[O] = i, p ? P(p, [R, te]) : te();
    },
    clone(R) {
      const D = Rc(
        R,
        e,
        t,
        n,
        s
      );
      return s && s(D), D;
    }
  };
  return A;
}
function Fm(i) {
  if (b1(i))
    return i = er(i), i.children = null, i;
}
function jp(i) {
  if (!b1(i))
    return em(i.type) && i.children ? y5(i.children) : i;
  if (i.component)
    return i.component.subTree;
  const { shapeFlag: e, children: t } = i;
  if (t) {
    if (e & 16)
      return t[0];
    if (e & 32 && Ft(t.default))
      return t.default();
  }
}
function aa(i, e) {
  if (i.shapeFlag & 6 && i.component) {
    i.transition = e;
    const t = i.component.subTree;
    aa(
      em(t.type) && jp(t) || t,
      e
    );
  } else i.shapeFlag & 128 ? (i.ssContent.transition = e.clone(i.ssContent), i.ssFallback.transition = e.clone(i.ssFallback)) : i.transition = e;
}
function g1(i, e = !1, t) {
  let n = [], s = 0;
  for (let o = 0; o < i.length; o++) {
    let r = i[o];
    const a = t == null ? r.key : String(t) + String(r.key != null ? r.key : o);
    r.type === j ? (r.patchFlag & 128 && s++, n = n.concat(
      g1(r.children, e, a)
    )) : (e || r.type !== qn) && n.push(a != null ? er(r, { key: a }) : r);
  }
  if (s > 1)
    for (let o = 0; o < n.length; o++)
      n[o].patchFlag = -2;
  return n;
}
// @__NO_SIDE_EFFECTS__
function Pe(i, e) {
  return Ft(i) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    gi({ name: i.name }, e, { setup: i })
  ) : i;
}
function SE() {
  const i = Wl();
  return i ? (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++ : "";
}
function ME(i) {
  i.ids = [i.ids[0] + i.ids[2]++ + "-", 0, 0];
}
function Hx(i, e) {
  let t;
  return !!((t = Object.getOwnPropertyDescriptor(i, e)) && !t.configurable);
}
const Hp = /* @__PURE__ */ new WeakMap();
function ac(i, e, t, n, s = !1) {
  if (mt(i)) {
    i.forEach(
      (v, x) => ac(
        v,
        e && (mt(e) ? e[x] : e),
        t,
        n,
        s
      )
    );
    return;
  }
  if (ul(n) && !s) {
    n.shapeFlag & 512 && n.type.__asyncResolved && n.component.subTree.component && ac(i, e, t, n.component.subTree);
    return;
  }
  const o = n.shapeFlag & 4 ? im(n.component) : n.el, r = s ? null : o, { i: a, r: l } = i, d = e && e.r, c = a.refs === en ? a.refs = {} : a.refs, h = a.setupState, f = /* @__PURE__ */ Et(h), p = h === en ? D3 : (v) => Hx(c, v) ? !1 : jt(f, v), y = (v, x) => !(x && Hx(c, x));
  if (d != null && d !== l) {
    if (Vx(e), on(d))
      c[d] = null, p(d) && (h[d] = null);
    else if (/* @__PURE__ */ ai(d)) {
      const v = e;
      y(d, v.k) && (d.value = null), v.k && (c[v.k] = null);
    }
  }
  if (Ft(l))
    gu(l, a, 12, [r, c]);
  else {
    const v = on(l), x = /* @__PURE__ */ ai(l);
    if (v || x) {
      const w = () => {
        if (i.f) {
          const S = v ? p(l) ? h[l] : c[l] : y() || !i.k ? l.value : c[i.k];
          if (s)
            mt(S) && O3(S, o);
          else if (mt(S))
            S.includes(o) || S.push(o);
          else if (v)
            c[l] = [o], p(l) && (h[l] = c[l]);
          else {
            const M = [o];
            y(l, i.k) && (l.value = M), i.k && (c[i.k] = M);
          }
        } else v ? (c[l] = r, p(l) && (h[l] = r)) : x && (y(l, i.k) && (l.value = r), i.k && (c[i.k] = r));
      };
      if (r) {
        const S = () => {
          w(), Hp.delete(i);
        };
        S.id = -1, Hp.set(i, S), ei(S, t);
      } else
        Vx(i), w();
    }
  }
}
function Vx(i) {
  const e = Hp.get(i);
  e && (e.flags |= 8, Hp.delete(i));
}
Xf().requestIdleCallback;
Xf().cancelIdleCallback;
const ul = (i) => !!i.type.__asyncLoader, b1 = (i) => i.type.__isKeepAlive;
function TE(i, e, t = pi, n = !1) {
  if (t) {
    const s = t[i] || (t[i] = []), o = e.__weh || (e.__weh = (...r) => {
      Jo();
      const a = S1(t), l = ss(e, t, i, r);
      return a(), Zo(), l;
    });
    return n ? s.unshift(o) : s.push(o), o;
  }
}
const v1 = (i) => (e, t = pi) => {
  (!Oc || i === "sp") && TE(i, (...n) => e(...n), t);
}, ot = v1("m"), w5 = v1("u"), We = v1(
  "bum"
), CE = "components", k5 = /* @__PURE__ */ Symbol.for("v-ndc");
function la(i) {
  return on(i) ? IE(CE, i, !1) || i : i || k5;
}
function IE(i, e, t = !0, n = !1) {
  const s = Un || pi;
  if (s) {
    const o = s.type;
    {
      const a = a9(
        o,
        !1
      );
      if (a && (a === e || a === ri(e) || a === Yf(ri(e))))
        return o;
    }
    const r = (
      // local registration
      // check instance[type] first which is resolved for options API
      Wx(s[i] || o[i], e) || // global registration
      Wx(s.appContext[i], e)
    );
    return !r && n ? o : r;
  }
}
function Wx(i, e) {
  return i && (i[e] || i[ri(e)] || i[Yf(ri(e))]);
}
function be(i, e, t, n) {
  let s;
  const o = t, r = mt(i);
  if (r || on(i)) {
    const a = r && /* @__PURE__ */ Ho(i);
    let l = !1, d = !1;
    a && (l = !/* @__PURE__ */ Li(i), d = /* @__PURE__ */ _s(i), i = Jf(i)), s = new Array(i.length);
    for (let c = 0, h = i.length; c < h; c++)
      s[c] = e(
        l ? d ? Qo(Fi(i[c])) : Fi(i[c]) : i[c],
        c,
        void 0,
        o
      );
  } else if (typeof i == "number") {
    s = new Array(i);
    for (let a = 0; a < i; a++)
      s[a] = e(a + 1, a, void 0, o);
  } else if (qt(i))
    if (i[Symbol.iterator])
      s = Array.from(
        i,
        (a, l) => e(a, l, void 0, o)
      );
    else {
      const a = Object.keys(i);
      s = new Array(a.length);
      for (let l = 0, d = a.length; l < d; l++) {
        const c = a[l];
        s[l] = e(i[c], c, l, o);
      }
    }
  else
    s = [];
  return s;
}
function AE(i, e) {
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    if (mt(n))
      for (let s = 0; s < n.length; s++)
        i[n[s].name] = n[s].fn;
    else n && (i[n.name] = n.key ? (...s) => {
      const o = n.fn(...s);
      return o && (o.key = n.key), o;
    } : n.fn);
  }
  return i;
}
function Ss(i, e, t, n, s, o) {
  if (t == null && (t = {}), Un.ce || Un.parent && ul(Un.parent) && Un.parent.ce) {
    const d = t, c = Object.keys(d).length > 0;
    return e !== "default" && (d.name = e), g(), Ce(
      j,
      null,
      [C("slot", d, n)],
      c ? -2 : 64
    );
  }
  let r = i[e];
  r && r._c && (r._d = !1);
  const a = Xs.length;
  g();
  let l;
  try {
    const d = r && _5(r(t)), c = t.key || o || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    d && d.key;
    l = Ce(
      j,
      {
        key: (c && !is(c) ? c : `_${e}`) + // #7256 force differentiate fallback content from actual content
        (!d && n ? "_fb" : "")
      },
      d || (n ? n() : []),
      d && i._ === 1 ? 64 : -2
    );
  } catch (d) {
    for (let c = Xs.length; c > a; c--) k1();
    throw d;
  } finally {
    r && r._c && (r._d = !0);
  }
  return l.scopeId && (l.slotScopeIds = [l.scopeId + "-s"]), l;
}
function _5(i) {
  return i.some((e) => $c(e) ? !(e.type === qn || e.type === j && !_5(e.children)) : !0) ? i : null;
}
const pv = (i) => i ? F5(i) ? im(i) : pv(i.parent) : null, lc = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ gi(/* @__PURE__ */ Object.create(null), {
    $: (i) => i,
    $el: (i) => i.vnode.el,
    $data: (i) => i.data,
    $props: (i) => i.props,
    $attrs: (i) => i.attrs,
    $slots: (i) => i.slots,
    $refs: (i) => i.refs,
    $parent: (i) => pv(i.parent),
    $root: (i) => pv(i.root),
    $host: (i) => i.ce,
    $emit: (i) => i.emit,
    $options: (i) => i.type,
    $forceUpdate: (i) => i.f || (i.f = () => {
      f1(i.update);
    }),
    $nextTick: (i) => i.n || (i.n = nt.bind(i.proxy)),
    $watch: (i) => Qr
  })
), Nm = (i, e) => i !== en && !i.__isScriptSetup && jt(i, e), PE = {
  get({ _: i }, e) {
    if (e === "__v_skip")
      return !0;
    const { ctx: t, setupState: n, data: s, props: o, accessCache: r, type: a, appContext: l } = i;
    if (e[0] !== "$") {
      const f = r[e];
      if (f !== void 0)
        switch (f) {
          case 1:
            return n[e];
          case 2:
            return s[e];
          case 4:
            return t[e];
          case 3:
            return o[e];
        }
      else {
        if (Nm(n, e))
          return r[e] = 1, n[e];
        if (jt(o, e))
          return r[e] = 3, o[e];
        if (t !== en && jt(t, e))
          return r[e] = 4, t[e];
        r[e] = 0;
      }
    }
    const d = lc[e];
    let c, h;
    if (d)
      return e === "$attrs" && Vn(i.attrs, "get", ""), d(i);
    if (
      // css module (injected by vue-loader)
      (c = a.__cssModules) && (c = c[e])
    )
      return c;
    if (t !== en && jt(t, e))
      return r[e] = 4, t[e];
    if (
      // global properties
      h = l.config.globalProperties, jt(h, e)
    )
      return h[e];
  },
  set({ _: i }, e, t) {
    const { data: n, setupState: s, ctx: o } = i;
    return Nm(s, e) ? (s[e] = t, !0) : jt(i.props, e) || e[0] === "$" && e.slice(1) in i ? !1 : (o[e] = t, !0);
  },
  has({
    _: { data: i, setupState: e, accessCache: t, ctx: n, appContext: s, props: o, type: r }
  }, a) {
    let l;
    return !!(t[a] || Nm(e, a) || jt(o, a) || jt(n, a) || jt(lc, a) || jt(s.config.globalProperties, a) || (l = r.__cssModules) && l[a]);
  },
  defineProperty(i, e, t) {
    return t.get != null ? i._.accessCache[e] = 0 : jt(t, "value") && this.set(i, e, t.value, null), Reflect.defineProperty(i, e, t);
  }
};
function EE() {
  return RE().slots;
}
function RE(i) {
  const e = Wl();
  return e.setupContext || (e.setupContext = U5(e));
}
function S5() {
  return {
    app: null,
    config: {
      isNativeTag: D3,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let zE = 0;
function $E(i, e) {
  return function(n, s = null) {
    Ft(n) || (n = gi({}, n)), s != null && !qt(s) && (s = null);
    const o = S5(), r = /* @__PURE__ */ new WeakSet(), a = [];
    let l = !1;
    const d = o.app = {
      _uid: zE++,
      _component: n,
      _props: s,
      _container: null,
      _context: o,
      _instance: null,
      version: d9,
      get config() {
        return o.config;
      },
      set config(c) {
      },
      use(c, ...h) {
        return r.has(c) || (c && Ft(c.install) ? (r.add(c), c.install(d, ...h)) : Ft(c) && (r.add(c), c(d, ...h))), d;
      },
      mixin(c) {
        return d;
      },
      component(c, h) {
        return h ? (o.components[c] = h, d) : o.components[c];
      },
      directive(c, h) {
        return h ? (o.directives[c] = h, d) : o.directives[c];
      },
      mount(c, h, f) {
        if (!l) {
          const p = d._ceVNode || C(n, s);
          return p.appContext = o, f === !0 ? f = "svg" : f === !1 && (f = void 0), i(p, c, f), l = !0, d._container = c, c.__vue_app__ = d, im(p.component);
        }
      },
      onUnmount(c) {
        a.push(c);
      },
      unmount() {
        l && (ss(
          a,
          d._instance,
          16
        ), i(null, d._container), delete d._container.__vue_app__);
      },
      provide(c, h) {
        return o.provides[c] = h, d;
      },
      runWithContext(c) {
        const h = hl;
        hl = d;
        try {
          return c();
        } finally {
          hl = h;
        }
      }
    };
    return d;
  };
}
let hl = null;
const DE = (i, e) => e === "modelValue" || e === "model-value" ? i.modelModifiers : i[`${e}Modifiers`] || i[`${ri(e)}Modifiers`] || i[`${lr(e)}Modifiers`];
function OE(i, e, ...t) {
  if (i.isUnmounted) return;
  const n = i.vnode.props || en;
  let s = t;
  const o = e.startsWith("update:"), r = o && DE(n, e.slice(7));
  r && (r.trim && (s = t.map((c) => on(c) ? c.trim() : c)), r.number && (s = s.map(o1)));
  let a, l = n[a = $m(e)] || // also try camelCase event handler (#2249)
  n[a = $m(ri(e))];
  !l && o && (l = n[a = $m(lr(e))]), l && ss(
    l,
    i,
    6,
    s
  );
  const d = n[a + "Once"];
  if (d) {
    if (!i.emitted)
      i.emitted = {};
    else if (i.emitted[a])
      return;
    i.emitted[a] = !0, ss(
      d,
      i,
      6,
      s
    );
  }
}
function LE(i, e, t = !1) {
  const n = e.emitsCache, s = n.get(i);
  if (s !== void 0)
    return s;
  const o = i.emits;
  let r = {};
  return o ? (mt(o) ? o.forEach((a) => r[a] = null) : gi(r, o), qt(i) && n.set(i, r), r) : (qt(i) && n.set(i, null), null);
}
function tm(i, e) {
  return !i || !Wf(e) ? !1 : (e = e.slice(2), e = e === "Once" ? e : e.replace(/Once$/, ""), jt(i, e[0].toLowerCase() + e.slice(1)) || jt(i, lr(e)) || jt(i, e));
}
function qx(i) {
  const {
    type: e,
    vnode: t,
    proxy: n,
    withProxy: s,
    propsOptions: [o],
    slots: r,
    attrs: a,
    emit: l,
    render: d,
    renderCache: c,
    props: h,
    data: f,
    setupState: p,
    ctx: y,
    inheritAttrs: v
  } = i, x = Gp(i);
  let w, S;
  try {
    if (t.shapeFlag & 4) {
      const _ = s || n, T = _;
      w = vs(
        d.call(
          T,
          _,
          c,
          h,
          p,
          f,
          y
        )
      ), S = a;
    } else {
      const _ = e;
      w = vs(
        _.length > 1 ? _(
          h,
          { attrs: a, slots: r, emit: l }
        ) : _(
          h,
          null
        )
      ), S = e.props ? a : BE(a);
    }
  } catch (_) {
    Xs.length = 0, Zf(_, i, 1), w = C(qn);
  }
  let M = w;
  if (S && v !== !1) {
    const _ = Object.keys(S), { shapeFlag: T } = M;
    _.length && T & 7 && (o && _.some(qf) && (S = FE(
      S,
      o
    )), M = er(M, S, !1, !0));
  }
  if (t.dirs && (M = er(M, null, !1, !0), M.dirs = M.dirs ? M.dirs.concat(t.dirs) : t.dirs), t.transition) {
    const _ = em(M.type) && jp(M) || M;
    aa(_, t.transition);
  }
  return w = M, Gp(x), w;
}
const BE = (i) => {
  let e;
  for (const t in i)
    (t === "class" || t === "style" || Wf(t)) && ((e || (e = {}))[t] = i[t]);
  return e;
}, FE = (i, e) => {
  const t = {};
  for (const n in i)
    (!qf(n) || !(n.slice(9) in e)) && (t[n] = i[n]);
  return t;
};
function NE(i, e, t) {
  const { props: n, children: s, component: o } = i, { props: r, children: a, patchFlag: l } = e, d = o.emitsOptions;
  if (e.dirs || e.transition)
    return !0;
  if (t && l >= 0) {
    if (l & 1024)
      return !0;
    if (l & 16)
      return n ? Kx(n, r, d) : !!r;
    if (l & 8) {
      const c = e.dynamicProps;
      for (let h = 0; h < c.length; h++) {
        const f = c[h];
        if (M5(r, n, f) && !tm(d, f))
          return !0;
      }
    }
  } else
    return (s || a) && (!a || !a.$stable) ? !0 : n === r ? !1 : n ? r ? Kx(n, r, d) : !0 : !!r;
  return !1;
}
function Kx(i, e, t) {
  const n = Object.keys(e);
  if (n.length !== Object.keys(i).length)
    return !0;
  for (let s = 0; s < n.length; s++) {
    const o = n[s];
    if (M5(e, i, o) && !tm(t, o))
      return !0;
  }
  return !1;
}
function M5(i, e, t) {
  const n = i[t], s = e[t];
  return t === "style" && qt(n) && qt(s) ? !Vl(n, s) : n !== s;
}
function UE({ vnode: i, parent: e, suspense: t }, n) {
  for (; e; ) {
    const s = e.subTree;
    if (s.suspense && s.suspense.activeBranch === i && (s.suspense.vnode.el = s.el = n, i = s), s === i)
      (i = e.vnode).el = n, e = e.parent;
    else
      break;
  }
  t && t.activeBranch === i && (t.vnode.el = n);
}
const T5 = {}, C5 = () => Object.create(T5), I5 = (i) => Object.getPrototypeOf(i) === T5;
function GE(i, e, t, n = !1) {
  const s = {}, o = C5();
  i.propsDefaults = /* @__PURE__ */ Object.create(null), A5(i, e, s, o);
  for (const r in i.propsOptions[0])
    r in s || (s[r] = void 0);
  t ? i.props = n ? s : /* @__PURE__ */ lv(s) : i.type.props ? i.props = s : i.props = o, i.attrs = o;
}
function jE(i, e, t, n) {
  const {
    props: s,
    attrs: o,
    vnode: { patchFlag: r }
  } = i, a = /* @__PURE__ */ Et(s), [l] = i.propsOptions;
  let d = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (n || r > 0) && !(r & 16)
  ) {
    if (r & 8) {
      const c = i.vnode.dynamicProps;
      for (let h = 0; h < c.length; h++) {
        let f = c[h];
        if (tm(i.emitsOptions, f))
          continue;
        const p = e[f];
        if (l)
          if (jt(o, f))
            p !== o[f] && (o[f] = p, d = !0);
          else {
            const y = ri(f);
            s[y] = fv(
              l,
              a,
              y,
              p,
              i,
              !1
            );
          }
        else
          p !== o[f] && (o[f] = p, d = !0);
      }
    }
  } else {
    A5(i, e, s, o) && (d = !0);
    let c;
    for (const h in a)
      (!e || // for camelCase
      !jt(e, h) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((c = lr(h)) === h || !jt(e, c))) && (l ? t && // for camelCase
      (t[h] !== void 0 || // for kebab-case
      t[c] !== void 0) && (s[h] = fv(
        l,
        a,
        h,
        void 0,
        i,
        !0
      )) : delete s[h]);
    if (o !== a)
      for (const h in o)
        (!e || !jt(e, h)) && (delete o[h], d = !0);
  }
  d && Ws(i.attrs, "set", "");
}
function A5(i, e, t, n) {
  const [s, o] = i.propsOptions;
  let r = !1, a;
  if (e)
    for (let l in e) {
      if (sc(l))
        continue;
      const d = e[l];
      let c;
      s && jt(s, c = ri(l)) ? !o || !o.includes(c) ? t[c] = d : (a || (a = {}))[c] = d : tm(i.emitsOptions, l) || (!(l in n) || d !== n[l]) && (n[l] = d, r = !0);
    }
  if (o) {
    const l = /* @__PURE__ */ Et(t), d = a || en;
    for (let c = 0; c < o.length; c++) {
      const h = o[c];
      t[h] = fv(
        s,
        l,
        h,
        d[h],
        i,
        !jt(d, h)
      );
    }
  }
  return r;
}
function fv(i, e, t, n, s, o) {
  const r = i[t];
  if (r != null) {
    const a = jt(r, "default");
    if (a && n === void 0) {
      const l = r.default;
      if (r.type !== Function && !r.skipFactory && Ft(l)) {
        const { propsDefaults: d } = s;
        if (t in d)
          n = d[t];
        else {
          const c = S1(s);
          n = d[t] = l.call(
            null,
            e
          ), c();
        }
      } else
        n = l;
      s.ce && s.ce._setProp(t, n);
    }
    r[
      0
      /* shouldCast */
    ] && (o && !a ? n = !1 : r[
      1
      /* shouldCastTrue */
    ] && (n === "" || n === lr(t)) && (n = !0));
  }
  return n;
}
function HE(i, e, t = !1) {
  const n = e.propsCache, s = n.get(i);
  if (s)
    return s;
  const o = i.props, r = {}, a = [];
  if (!o)
    return qt(i) && n.set(i, jr), jr;
  if (mt(o))
    for (let d = 0; d < o.length; d++) {
      const c = ri(o[d]);
      Yx(c) && (r[c] = en);
    }
  else if (o)
    for (const d in o) {
      const c = ri(d);
      if (Yx(c)) {
        const h = o[d], f = r[c] = mt(h) || Ft(h) ? { type: h } : gi({}, h), p = f.type;
        let y = !1, v = !0;
        if (mt(p))
          for (let x = 0; x < p.length; ++x) {
            const w = p[x], S = Ft(w) && w.name;
            if (S === "Boolean") {
              y = !0;
              break;
            } else S === "String" && (v = !1);
          }
        else
          y = Ft(p) && p.name === "Boolean";
        f[
          0
          /* shouldCast */
        ] = y, f[
          1
          /* shouldCastTrue */
        ] = v, (y || jt(f, "default")) && a.push(c);
      }
    }
  const l = [r, a];
  return qt(i) && n.set(i, l), l;
}
function Yx(i) {
  return i[0] !== "$" && !sc(i);
}
const y1 = (i) => i === "_" || i === "_ctx" || i === "$stable", x1 = (i) => mt(i) ? i.map(vs) : [vs(i)], VE = (i, e, t) => {
  if (e._n)
    return e;
  const n = Xe((...s) => x1(e(...s)), t);
  return n._c = !1, n;
}, P5 = (i, e, t) => {
  const n = i._ctx;
  for (const s in i) {
    if (y1(s)) continue;
    const o = i[s];
    if (Ft(o))
      e[s] = VE(s, o, n);
    else if (o != null) {
      const r = x1(o);
      e[s] = () => r;
    }
  }
}, E5 = (i, e) => {
  const t = x1(e);
  i.slots.default = () => t;
}, R5 = (i, e, t) => {
  for (const n in e)
    (t || !y1(n)) && (i[n] = e[n]);
}, WE = (i, e, t) => {
  const n = i.slots = C5();
  if (i.vnode.shapeFlag & 32) {
    const s = e._;
    s ? (R5(n, e, t), t && N3(n, "_", s, !0)) : P5(e, n);
  } else e && E5(i, e);
}, qE = (i, e, t) => {
  const { vnode: n, slots: s } = i;
  let o = !0, r = en;
  if (n.shapeFlag & 32) {
    const a = e._;
    a ? t && a === 1 ? o = !1 : R5(s, e, t) : (o = !e.$stable, P5(e, s)), r = e;
  } else e && (E5(i, e), r = { default: 1 });
  if (o)
    for (const a in s)
      !y1(a) && r[a] == null && delete s[a];
}, ei = ZE;
function KE(i) {
  return YE(i);
}
function YE(i, e) {
  const t = Xf();
  t.__VUE__ = !0;
  const {
    insert: n,
    remove: s,
    patchProp: o,
    createElement: r,
    createText: a,
    createComment: l,
    setText: d,
    setElementText: c,
    parentNode: h,
    nextSibling: f,
    setScopeId: p = Qr,
    insertStaticContent: y
  } = i, v = (U, q, ie, de = null, pe = null, Te = null, Be = void 0, ge = null, ne = !!q.dynamicChildren) => {
    if (U === q)
      return;
    U && !Fr(U, q) && (de = he(U), Z(U, pe, Te, !0), U = null), q.patchFlag === -2 && (ne = !1, q.dynamicChildren = null), q.dynamicChildren && U && U.dynamicChildren && U.dynamicChildren.hasOnce && (q.dynamicChildren === jr && (q.dynamicChildren = []), q.dynamicChildren.hasOnce = !0);
    const { type: oe, ref: ye, shapeFlag: Oe } = q;
    switch (oe) {
      case nm:
        x(U, q, ie, de);
        break;
      case qn:
        w(U, q, ie, de);
        break;
      case fp:
        U == null && S(q, ie, de, Be);
        break;
      case j:
        F(
          U,
          q,
          ie,
          de,
          pe,
          Te,
          Be,
          ge,
          ne
        );
        break;
      default:
        Oe & 1 ? T(
          U,
          q,
          ie,
          de,
          pe,
          Te,
          Be,
          ge,
          ne
        ) : Oe & 6 ? te(
          U,
          q,
          ie,
          de,
          pe,
          Te,
          Be,
          ge,
          ne
        ) : (Oe & 64 || Oe & 128) && oe.process(
          U,
          q,
          ie,
          de,
          pe,
          Te,
          Be,
          ge,
          ne,
          Me
        );
    }
    ye != null && pe ? ac(ye, U && U.ref, Te, q || U, !q) : ye == null && U && U.ref != null && ac(U.ref, null, Te, U, !0);
  }, x = (U, q, ie, de) => {
    if (U == null)
      n(
        q.el = a(q.children),
        ie,
        de
      );
    else {
      const pe = q.el = U.el;
      q.children !== U.children && d(pe, q.children);
    }
  }, w = (U, q, ie, de) => {
    U == null ? n(
      q.el = l(q.children || ""),
      ie,
      de
    ) : q.el = U.el;
  }, S = (U, q, ie, de) => {
    [U.el, U.anchor] = y(
      U.children,
      q,
      ie,
      de,
      U.el,
      U.anchor
    );
  }, M = ({ el: U, anchor: q }, ie, de) => {
    let pe;
    for (; U && U !== q; )
      pe = f(U), n(U, ie, de), U = pe;
    n(q, ie, de);
  }, _ = ({ el: U, anchor: q }) => {
    let ie;
    for (; U && U !== q; )
      ie = f(U), s(U), U = ie;
    s(q);
  }, T = (U, q, ie, de, pe, Te, Be, ge, ne) => {
    if (q.type === "svg" ? Be = "svg" : q.type === "math" && (Be = "mathml"), U == null)
      k(
        q,
        ie,
        de,
        pe,
        Te,
        Be,
        ge,
        ne
      );
    else {
      const oe = U.el && U.el._isVueCE ? U.el : null;
      try {
        oe && oe._beginPatch(), R(
          U,
          q,
          pe,
          Te,
          Be,
          ge,
          ne
        );
      } finally {
        oe && oe._endPatch();
      }
    }
  }, k = (U, q, ie, de, pe, Te, Be, ge) => {
    let ne, oe;
    const { props: ye, shapeFlag: Oe, transition: Ve, dirs: Ue } = U;
    if (ne = U.el = r(
      U.type,
      Te,
      ye && ye.is,
      ye
    ), Oe & 8 ? c(ne, U.children) : Oe & 16 && A(
      U.children,
      ne,
      null,
      de,
      pe,
      Um(U, Te),
      Be,
      ge
    ), Ue && pr(U, null, de, "created"), P(ne, U, U.scopeId, Be, de), ye) {
      for (const Ye in ye)
        Ye !== "value" && !sc(Ye) && o(ne, Ye, null, ye[Ye], Te, de);
      "value" in ye && o(ne, "value", null, ye.value, Te), (oe = ye.onVnodeBeforeMount) && ds(oe, de, U);
    }
    Ue && pr(U, null, de, "beforeMount");
    const tt = XE(pe, Ve);
    tt && Ve.beforeEnter(ne), n(ne, q, ie), ((oe = ye && ye.onVnodeMounted) || tt || Ue) && ei(() => {
      oe && ds(oe, de, U), tt && Ve.enter(ne), Ue && pr(U, null, de, "mounted");
    }, pe);
  }, P = (U, q, ie, de, pe) => {
    if (ie && p(U, ie), de)
      for (let Te = 0; Te < de.length; Te++)
        p(U, de[Te]);
    if (pe) {
      let Te = pe.subTree;
      if (q === Te || D5(Te.type) && (Te.ssContent === q || Te.ssFallback === q)) {
        const Be = pe.vnode;
        P(
          U,
          Be,
          Be.scopeId,
          Be.slotScopeIds,
          pe.parent
        );
      }
    }
  }, A = (U, q, ie, de, pe, Te, Be, ge, ne = 0) => {
    for (let oe = ne; oe < U.length; oe++) {
      const ye = U[oe] = ge ? Gs(U[oe]) : vs(U[oe]);
      v(
        null,
        ye,
        q,
        ie,
        de,
        pe,
        Te,
        Be,
        ge
      );
    }
  }, R = (U, q, ie, de, pe, Te, Be) => {
    const ge = q.el = U.el;
    let { patchFlag: ne, dynamicChildren: oe, dirs: ye } = q;
    ne |= U.patchFlag & 16;
    const Oe = U.props || en, Ve = q.props || en;
    let Ue;
    if (ie && fr(ie, !1), (Ue = Ve.onVnodeBeforeUpdate) && ds(Ue, ie, q, U), ye && pr(q, U, ie, "beforeUpdate"), ie && fr(ie, !0), // #6385 the old vnode may be a user-wrapped non-isomorphic block
    // Force full diff when block metadata is unstable.
    oe && (!U.dynamicChildren || U.dynamicChildren.length !== oe.length) && (ne = 0, Be = !1, oe = null), (Oe.innerHTML && Ve.innerHTML == null || Oe.textContent && Ve.textContent == null) && c(ge, ""), oe ? D(
      U.dynamicChildren,
      oe,
      ge,
      ie,
      de,
      Um(q, pe),
      Te
    ) : Be || X(
      U,
      q,
      ge,
      null,
      ie,
      de,
      Um(q, pe),
      Te,
      !1
    ), ne > 0) {
      if (ne & 16)
        O(ge, Oe, Ve, ie, pe);
      else if (ne & 2 && Oe.class !== Ve.class && o(ge, "class", null, Ve.class, pe), ne & 4 && o(ge, "style", Oe.style, Ve.style, pe), ne & 8) {
        const tt = q.dynamicProps;
        for (let Ye = 0; Ye < tt.length; Ye++) {
          const at = tt[Ye], wt = Oe[at], $e = Ve[at];
          ($e !== wt || at === "value") && o(ge, at, wt, $e, pe, ie);
        }
      }
      ne & 1 && U.children !== q.children && c(ge, q.children);
    } else !Be && oe == null && O(ge, Oe, Ve, ie, pe);
    ((Ue = Ve.onVnodeUpdated) || ye) && ei(() => {
      Ue && ds(Ue, ie, q, U), ye && pr(q, U, ie, "updated");
    }, de);
  }, D = (U, q, ie, de, pe, Te, Be) => {
    for (let ge = 0; ge < q.length; ge++) {
      const ne = U[ge], oe = q[ge], ye = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        ne.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (ne.type === j || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Fr(ne, oe) || // - In the case of a component, it could contain anything.
        ne.shapeFlag & 198) ? h(ne.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          ie
        )
      );
      v(
        ne,
        oe,
        ye,
        null,
        de,
        pe,
        Te,
        Be,
        !0
      );
    }
  }, O = (U, q, ie, de, pe) => {
    if (q !== ie) {
      if (q !== en)
        for (const Te in q)
          !sc(Te) && !(Te in ie) && o(
            U,
            Te,
            q[Te],
            null,
            pe,
            de
          );
      for (const Te in ie) {
        if (sc(Te)) continue;
        const Be = ie[Te], ge = q[Te];
        Be !== ge && Te !== "value" && o(U, Te, ge, Be, pe, de);
      }
      "value" in ie && o(U, "value", q.value, ie.value, pe);
    }
  }, F = (U, q, ie, de, pe, Te, Be, ge, ne) => {
    const oe = q.el = U ? U.el : a(""), ye = q.anchor = U ? U.anchor : a("");
    let { patchFlag: Oe, dynamicChildren: Ve, slotScopeIds: Ue } = q;
    Ue && (ge = ge ? ge.concat(Ue) : Ue), U == null ? (n(oe, ie, de), n(ye, ie, de), A(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      q.children || [],
      ie,
      ye,
      pe,
      Te,
      Be,
      ge,
      ne
    )) : Oe > 0 && Oe & 64 && Ve && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    U.dynamicChildren && U.dynamicChildren.length === Ve.length ? (D(
      U.dynamicChildren,
      Ve,
      ie,
      pe,
      Te,
      Be,
      ge
    ), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (q.key != null || pe && q === pe.subTree) && w1(
      U,
      q,
      !0
      /* shallow */
    )) : X(
      U,
      q,
      ie,
      ye,
      pe,
      Te,
      Be,
      ge,
      ne
    );
  }, te = (U, q, ie, de, pe, Te, Be, ge, ne) => {
    q.slotScopeIds = ge, U == null ? q.shapeFlag & 512 ? pe.ctx.activate(
      q,
      ie,
      de,
      Be,
      ne
    ) : ee(
      q,
      ie,
      de,
      pe,
      Te,
      Be,
      ne
    ) : me(U, q, ne);
  }, ee = (U, q, ie, de, pe, Te, Be) => {
    const ge = U.component = i9(
      U,
      de,
      pe
    );
    if (b1(U) && (ge.ctx.renderer = Me), s9(ge, !1, Be), ge.asyncDep) {
      if (pe && pe.registerDep(ge, L, Be), !U.el) {
        const ne = ge.subTree = C(qn);
        w(null, ne, q, ie), U.placeholder = ne.el;
      }
    } else
      L(
        ge,
        U,
        q,
        ie,
        pe,
        Te,
        Be
      );
  }, me = (U, q, ie) => {
    const de = q.component = U.component;
    if (NE(U, q, ie))
      if (de.asyncDep && !de.asyncResolved) {
        q.el = U.el, N(de, q, ie);
        return;
      } else
        de.next = q, de.update();
    else
      q.el = U.el, de.vnode = q;
  }, L = (U, q, ie, de, pe, Te, Be) => {
    const ge = () => {
      if (U.isMounted) {
        let { next: Oe, bu: Ve, u: Ue, parent: tt, vnode: Ye } = U;
        {
          const W = z5(U);
          if (W) {
            Oe && (Oe.el = Ye.el, N(U, Oe, Be)), W.asyncDep.then(() => {
              ei(() => {
                U.isUnmounted || oe();
              }, pe);
            });
            return;
          }
        }
        let at = Oe, wt;
        fr(U, !1), Oe ? (Oe.el = Ye.el, N(U, Oe, Be)) : Oe = Ye, Ve && pp(Ve), (wt = Oe.props && Oe.props.onVnodeBeforeUpdate) && ds(wt, tt, Oe, Ye), fr(U, !0);
        const $e = qx(U), Fe = U.subTree;
        U.subTree = $e, v(
          Fe,
          $e,
          // parent may have changed if it's in a teleport
          h(Fe.el),
          // anchor may have changed if it's in a fragment
          he(Fe),
          U,
          pe,
          Te
        ), Oe.el = $e.el, at === null && UE(U, $e.el), Ue && ei(Ue, pe), (wt = Oe.props && Oe.props.onVnodeUpdated) && ei(
          () => ds(wt, tt, Oe, Ye),
          pe
        );
      } else {
        let Oe;
        const { el: Ve, props: Ue } = q, { bm: tt, m: Ye, parent: at, root: wt, type: $e } = U, Fe = ul(q);
        fr(U, !1), tt && pp(tt), !Fe && (Oe = Ue && Ue.onVnodeBeforeMount) && ds(Oe, at, q), fr(U, !0);
        {
          wt.ce && wt.ce._hasShadowRoot() && wt.ce._injectChildStyle(
            $e,
            U.parent ? U.parent.type : void 0
          );
          const W = U.subTree = qx(U);
          v(
            null,
            W,
            ie,
            de,
            U,
            pe,
            Te
          ), q.el = W.el;
        }
        if (Ye && ei(Ye, pe), !Fe && (Oe = Ue && Ue.onVnodeMounted)) {
          const W = q;
          ei(
            () => ds(Oe, at, W),
            pe
          );
        }
        (q.shapeFlag & 256 || at && ul(at.vnode) && at.vnode.shapeFlag & 256) && U.a && ei(U.a, pe), U.isMounted = !0, q = ie = de = null;
      }
    };
    U.scope.on();
    const ne = U.effect = new W3(ge);
    U.scope.off();
    const oe = U.update = ne.run.bind(ne), ye = U.job = ne.runIfDirty.bind(ne);
    ye.i = U, ye.id = U.uid, ne.scheduler = () => f1(ye), fr(U, !0), oe();
  }, N = (U, q, ie) => {
    q.component = U;
    const de = U.vnode.props;
    U.vnode = q, U.next = null, jE(U, q.props, de, ie), qE(U, q.children, ie), Jo(), Ux(U), Zo();
  }, X = (U, q, ie, de, pe, Te, Be, ge, ne = !1) => {
    const oe = U && U.children, ye = U ? U.shapeFlag : 0, Oe = q.children, { patchFlag: Ve, shapeFlag: Ue } = q;
    if (Ve > 0) {
      if (Ve & 128) {
        se(
          oe,
          Oe,
          ie,
          de,
          pe,
          Te,
          Be,
          ge,
          ne
        );
        return;
      } else if (Ve & 256) {
        B(
          oe,
          Oe,
          ie,
          de,
          pe,
          Te,
          Be,
          ge,
          ne
        );
        return;
      }
    }
    Ue & 8 ? (ye & 16 && le(oe, pe, Te), Oe !== oe && c(ie, Oe)) : ye & 16 ? Ue & 16 ? se(
      oe,
      Oe,
      ie,
      de,
      pe,
      Te,
      Be,
      ge,
      ne
    ) : le(oe, pe, Te, !0) : (ye & 8 && c(ie, ""), Ue & 16 && A(
      Oe,
      ie,
      de,
      pe,
      Te,
      Be,
      ge,
      ne
    ));
  }, B = (U, q, ie, de, pe, Te, Be, ge, ne) => {
    U = U || jr, q = q || jr;
    const oe = U.length, ye = q.length, Oe = Math.min(oe, ye);
    let Ve;
    for (Ve = 0; Ve < Oe; Ve++) {
      const Ue = q[Ve] = ne ? Gs(q[Ve]) : vs(q[Ve]);
      v(
        U[Ve],
        Ue,
        ie,
        null,
        pe,
        Te,
        Be,
        ge,
        ne
      );
    }
    oe > ye ? le(
      U,
      pe,
      Te,
      !0,
      !1,
      Oe
    ) : A(
      q,
      ie,
      de,
      pe,
      Te,
      Be,
      ge,
      ne,
      Oe
    );
  }, se = (U, q, ie, de, pe, Te, Be, ge, ne) => {
    let oe = 0;
    const ye = q.length;
    let Oe = U.length - 1, Ve = ye - 1;
    for (; oe <= Oe && oe <= Ve; ) {
      const Ue = U[oe], tt = q[oe] = ne ? Gs(q[oe]) : vs(q[oe]);
      if (Fr(Ue, tt))
        v(
          Ue,
          tt,
          ie,
          null,
          pe,
          Te,
          Be,
          ge,
          ne
        );
      else
        break;
      oe++;
    }
    for (; oe <= Oe && oe <= Ve; ) {
      const Ue = U[Oe], tt = q[Ve] = ne ? Gs(q[Ve]) : vs(q[Ve]);
      if (Fr(Ue, tt))
        v(
          Ue,
          tt,
          ie,
          null,
          pe,
          Te,
          Be,
          ge,
          ne
        );
      else
        break;
      Oe--, Ve--;
    }
    if (oe > Oe) {
      if (oe <= Ve) {
        const Ue = Ve + 1, tt = Ue < ye ? q[Ue].el : de;
        for (; oe <= Ve; )
          v(
            null,
            q[oe] = ne ? Gs(q[oe]) : vs(q[oe]),
            ie,
            tt,
            pe,
            Te,
            Be,
            ge,
            ne
          ), oe++;
      }
    } else if (oe > Ve)
      for (; oe <= Oe; )
        Z(U[oe], pe, Te, !0), oe++;
    else {
      const Ue = oe, tt = oe, Ye = /* @__PURE__ */ new Map();
      for (oe = tt; oe <= Ve; oe++) {
        const Le = q[oe] = ne ? Gs(q[oe]) : vs(q[oe]);
        Le.key != null && Ye.set(Le.key, oe);
      }
      let at, wt = 0;
      const $e = Ve - tt + 1;
      let Fe = !1, W = 0;
      const Q = new Array($e);
      for (oe = 0; oe < $e; oe++) Q[oe] = 0;
      for (oe = Ue; oe <= Oe; oe++) {
        const Le = U[oe];
        if (wt >= $e) {
          Z(Le, pe, Te, !0);
          continue;
        }
        let ve;
        if (Le.key != null)
          ve = Ye.get(Le.key);
        else
          for (at = tt; at <= Ve; at++)
            if (Q[at - tt] === 0 && Fr(Le, q[at])) {
              ve = at;
              break;
            }
        ve === void 0 ? Z(Le, pe, Te, !0) : (Q[ve - tt] = oe + 1, ve >= W ? W = ve : Fe = !0, v(
          Le,
          q[ve],
          ie,
          null,
          pe,
          Te,
          Be,
          ge,
          ne
        ), wt++);
      }
      const ae = Fe ? JE(Q) : jr;
      for (at = ae.length - 1, oe = $e - 1; oe >= 0; oe--) {
        const Le = tt + oe, ve = q[Le], ke = q[Le + 1], De = Le + 1 < ye ? (
          // #13559, #14173 fallback to el placeholder for unresolved async component
          ke.el || $5(ke)
        ) : de;
        Q[oe] === 0 ? v(
          null,
          ve,
          ie,
          De,
          pe,
          Te,
          Be,
          ge,
          ne
        ) : Fe && (at < 0 || oe !== ae[at] ? V(ve, ie, De, 2) : at--);
      }
    }
  }, V = (U, q, ie, de, pe = null) => {
    const { el: Te, type: Be, transition: ge, children: ne, shapeFlag: oe } = U;
    if (oe & 6) {
      V(U.component.subTree, q, ie, de);
      return;
    }
    if (oe & 128) {
      U.suspense.move(q, ie, de);
      return;
    }
    if (oe & 64) {
      Be.move(U, q, ie, Me);
      return;
    }
    if (Be === j) {
      n(Te, q, ie);
      for (let Oe = 0; Oe < ne.length; Oe++)
        V(ne[Oe], q, ie, de);
      n(U.anchor, q, ie);
      return;
    }
    if (Be === fp) {
      M(U, q, ie);
      return;
    }
    if (de !== 2 && oe & 1 && ge)
      if (de === 0)
        ge.persisted && !Te[$i] ? n(Te, q, ie) : (ge.beforeEnter(Te), n(Te, q, ie), ei(() => ge.enter(Te), pe));
      else {
        const { leave: Oe, delayLeave: Ve, afterLeave: Ue } = ge, tt = () => {
          U.ctx.isUnmounted ? s(Te) : n(Te, q, ie);
        }, Ye = () => {
          const at = Te._isLeaving || !!Te[$i];
          Te._isLeaving && Te[$i](
            !0
            /* cancelled */
          ), ge.persisted && !at ? tt() : Oe(Te, () => {
            tt(), Ue && Ue();
          });
        };
        Ve ? Ve(Te, tt, Ye) : Ye();
      }
    else
      n(Te, q, ie);
  }, Z = (U, q, ie, de = !1, pe = !1) => {
    const {
      type: Te,
      props: Be,
      ref: ge,
      children: ne,
      dynamicChildren: oe,
      shapeFlag: ye,
      patchFlag: Oe,
      dirs: Ve,
      cacheIndex: Ue,
      memo: tt
    } = U;
    if ((Oe === -2 || oe && oe.hasOnce) && (pe = !1), ge != null && (Jo(), ac(ge, null, ie, U, !0), Zo()), Ue != null && (!U.ctx || U.ctx === q) && (q.renderCache[Ue] = void 0), ye & 256) {
      q.ctx.deactivate(U);
      return;
    }
    const Ye = ye & 1 && Ve, at = !ul(U);
    let wt;
    if (at && (wt = Be && Be.onVnodeBeforeUnmount) && ds(wt, q, U), ye & 6)
      re(U.component, ie, de);
    else {
      if (ye & 128) {
        U.suspense.unmount(ie, de);
        return;
      }
      Ye && pr(U, null, q, "beforeUnmount"), ye & 64 ? U.type.remove(
        U,
        q,
        ie,
        Me,
        de
      ) : oe && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !oe.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (Te !== j || Oe > 0 && Oe & 64) ? le(
        oe,
        q,
        ie,
        !1,
        !0
      ) : (Te === j && Oe & 384 || !pe && ye & 16) && le(ne, q, ie), de && Y(U);
    }
    const $e = tt != null && Ue == null;
    (at && (wt = Be && Be.onVnodeUnmounted) || Ye || $e) && ei(() => {
      wt && ds(wt, q, U), Ye && pr(U, null, q, "unmounted"), $e && (U.el = null);
    }, ie);
  }, Y = (U) => {
    const { type: q, el: ie, anchor: de, transition: pe } = U;
    if (q === j) {
      H(ie, de);
      return;
    }
    if (q === fp) {
      _(U), pe && !pe.persisted && pe.afterLeave && pe.afterLeave();
      return;
    }
    const Te = () => {
      s(ie), pe && !pe.persisted && pe.afterLeave && pe.afterLeave();
    };
    if (U.shapeFlag & 1 && pe && !pe.persisted) {
      const { leave: Be, delayLeave: ge } = pe, ne = () => Be(ie, Te);
      ge ? ge(U.el, Te, ne) : ne();
    } else
      Te();
  }, H = (U, q) => {
    let ie;
    for (; U !== q; )
      ie = f(U), s(U), U = ie;
    s(q);
  }, re = (U, q, ie) => {
    const { bum: de, scope: pe, job: Te, subTree: Be, um: ge, m: ne, a: oe } = U;
    Xx(ne), Xx(oe), de && pp(de), pe.stop(), Te ? (Te.flags |= 8, Z(Be, U, q, ie)) : U.vnode.el && Be && (Be.transition = U.vnode.transition, Z(Be, U, q, ie)), ge && ei(ge, q), ei(() => {
      U.isUnmounted = !0;
    }, q);
  }, le = (U, q, ie, de = !1, pe = !1, Te = 0) => {
    for (let Be = Te; Be < U.length; Be++)
      Z(U[Be], q, ie, de, pe);
  }, he = (U) => {
    if (U.shapeFlag & 6)
      return he(U.component.subTree);
    if (U.shapeFlag & 128)
      return U.suspense.next();
    const q = f(U.anchor || U.el), ie = q && q[m5];
    return ie ? f(ie) : q;
  };
  let Re = !1;
  const Ne = (U, q, ie) => {
    let de;
    U == null ? q._vnode && (Z(q._vnode, null, null, !0), de = q._vnode.component) : v(
      q._vnode || null,
      U,
      q,
      null,
      null,
      null,
      ie
    ), q._vnode = U, Re || (Re = !0, Ux(de), c5(), Re = !1);
  }, Me = {
    p: v,
    um: Z,
    m: V,
    r: Y,
    mt: ee,
    mc: A,
    pc: X,
    pbc: D,
    n: he,
    o: i
  };
  return {
    render: Ne,
    hydrate: void 0,
    createApp: $E(Ne)
  };
}
function Um({ type: i, props: e }, t) {
  return t === "svg" && i === "foreignObject" || t === "mathml" && i === "annotation-xml" && e && e.encoding && e.encoding.includes("html") ? void 0 : t;
}
function fr({ effect: i, job: e }, t) {
  t ? (i.flags |= 32, e.flags |= 4) : (i.flags &= -33, e.flags &= -5);
}
function XE(i, e) {
  return (!i || i && !i.pendingBranch) && e && !e.persisted;
}
function w1(i, e, t = !1) {
  const n = i.children, s = e.children;
  if (mt(n) && mt(s))
    for (let o = 0; o < n.length; o++) {
      const r = n[o];
      let a = s[o];
      a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = s[o] = Gs(s[o]), a.el = r.el), !t && a.patchFlag !== -2 && w1(r, a)), a.type === nm && (a.patchFlag === -1 && (a = s[o] = Gs(a)), a.el = r.el), a.type === qn && !a.el && (a.el = r.el);
    }
}
function JE(i) {
  const e = i.slice(), t = [0];
  let n, s, o, r, a;
  const l = i.length;
  for (n = 0; n < l; n++) {
    const d = i[n];
    if (d !== 0) {
      if (s = t[t.length - 1], i[s] < d) {
        e[n] = s, t.push(n);
        continue;
      }
      for (o = 0, r = t.length - 1; o < r; )
        a = o + r >> 1, i[t[a]] < d ? o = a + 1 : r = a;
      d < i[t[o]] && (o > 0 && (e[n] = t[o - 1]), t[o] = n);
    }
  }
  for (o = t.length, r = t[o - 1]; o-- > 0; )
    t[o] = r, r = e[r];
  return t;
}
function z5(i) {
  const e = i.subTree.component;
  if (e)
    return e.asyncDep && !e.asyncResolved ? e : z5(e);
}
function Xx(i) {
  if (i)
    for (let e = 0; e < i.length; e++)
      i[e].flags |= 8;
}
function $5(i) {
  if (i.placeholder)
    return i.placeholder;
  const e = i.component;
  return e ? $5(e.subTree) : null;
}
const D5 = (i) => i.__isSuspense;
function ZE(i, e) {
  e && e.pendingBranch ? mt(i) ? e.effects.push(...i) : e.effects.push(i) : mE(i);
}
const j = /* @__PURE__ */ Symbol.for("v-fgt"), nm = /* @__PURE__ */ Symbol.for("v-txt"), qn = /* @__PURE__ */ Symbol.for("v-cmt"), fp = /* @__PURE__ */ Symbol.for("v-stc"), Xs = [];
let Ii = null;
function g(i = !1) {
  Xs.push(Ii = i ? null : []);
}
function k1() {
  Xs.pop(), Ii = Xs[Xs.length - 1] || null;
}
let zc = 1;
function Vp(i, e = !1) {
  zc += i, i < 0 && Ii && e && (Ii.hasOnce = !0);
}
function O5(i) {
  return i.dynamicChildren = zc > 0 ? Ii || jr : null, k1(), zc > 0 && Ii && Ii.push(i), i;
}
function b(i, e, t, n, s, o) {
  return O5(
    u(
      i,
      e,
      t,
      n,
      s,
      o,
      !0
    )
  );
}
function Ce(i, e, t, n, s) {
  return O5(
    C(
      i,
      e,
      t,
      n,
      s,
      !0
    )
  );
}
function $c(i) {
  return i ? i.__v_isVNode === !0 : !1;
}
function Fr(i, e) {
  return i.type === e.type && i.key === e.key;
}
const L5 = ({ key: i }) => i != null ? i : null, mp = ({
  ref: i,
  ref_key: e,
  ref_for: t
}) => (typeof i == "number" && (i = "" + i), i != null ? on(i) || /* @__PURE__ */ ai(i) || Ft(i) ? { i: Un, r: i, k: e, f: !!t } : i : null);
function u(i, e = null, t = null, n = 0, s = null, o = i === j ? 0 : 1, r = !1, a = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: i,
    props: e,
    key: e && L5(e),
    ref: e && mp(e),
    scopeId: h5,
    slotScopeIds: null,
    children: t,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: o,
    patchFlag: n,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: Un
  };
  return a ? (Wp(l, t), o & 128 && i.normalize(l)) : t && (l.shapeFlag |= on(t) ? 8 : 16), zc > 0 && // avoid a block node from tracking itself
  !r && // has current parent block
  Ii && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (l.patchFlag > 0 || o & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  l.patchFlag !== 32 && Ii.push(l), l;
}
const C = QE;
function QE(i, e = null, t = null, n = 0, s = null, o = !1) {
  if ((!i || i === k5) && (i = qn), $c(i)) {
    const a = er(
      i,
      e,
      !0
      /* mergeRef: true */
    );
    return t && Wp(a, t), zc > 0 && !o && Ii && (a.shapeFlag & 6 ? Ii[Ii.indexOf(i)] = a : Ii.push(a)), a.patchFlag = -2, a;
  }
  if (l9(i) && (i = i.__vccOpts), e) {
    e = e9(e);
    let { class: a, style: l } = e;
    a && !on(a) && (e.class = G(a)), qt(l) && (/* @__PURE__ */ p1(l) && !mt(l) && (l = gi({}, l)), e.style = ce(l));
  }
  const r = on(i) ? 1 : D5(i) ? 128 : em(i) ? 64 : qt(i) ? 4 : Ft(i) ? 2 : 0;
  return u(
    i,
    e,
    t,
    n,
    s,
    r,
    o,
    !0
  );
}
function e9(i) {
  return i ? /* @__PURE__ */ p1(i) || I5(i) ? gi({}, i) : i : null;
}
function er(i, e, t = !1, n = !1) {
  const { props: s, ref: o, patchFlag: r, children: a, transition: l } = i, d = e ? B5(s || {}, e) : s, c = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: i.type,
    props: d,
    key: d && L5(d),
    ref: e && e.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      t && o ? mt(o) ? o.concat(mp(e)) : [o, mp(e)] : mp(e)
    ) : o,
    scopeId: i.scopeId,
    slotScopeIds: i.slotScopeIds,
    children: a,
    target: i.target,
    targetStart: i.targetStart,
    targetAnchor: i.targetAnchor,
    staticCount: i.staticCount,
    shapeFlag: i.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: e && i.type !== j ? r === -1 ? 16 : r | 16 : r,
    dynamicProps: i.dynamicProps,
    dynamicChildren: i.dynamicChildren,
    appContext: i.appContext,
    dirs: i.dirs,
    transition: l,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: i.component,
    suspense: i.suspense,
    ssContent: i.ssContent && er(i.ssContent),
    ssFallback: i.ssFallback && er(i.ssFallback),
    placeholder: i.placeholder,
    el: i.el,
    anchor: i.anchor,
    ctx: i.ctx,
    ce: i.ce,
    cacheIndex: i.cacheIndex
  };
  return l && n && aa(
    c,
    l.clone(c)
  ), c;
}
function J(i = " ", e = 0) {
  return C(nm, null, i, e);
}
function _1(i, e) {
  const t = C(fp, null, i);
  return t.staticCount = e, t;
}
function z(i = "", e = !1) {
  return e ? (g(), Ce(qn, null, i)) : C(qn, null, i);
}
function vs(i) {
  return i == null || typeof i == "boolean" ? C(qn) : mt(i) ? C(
    j,
    null,
    // #3666, avoid reference pollution when reusing vnode
    i.slice()
  ) : $c(i) ? Gs(i) : C(nm, null, String(i));
}
function Gs(i) {
  return i.el === null && i.patchFlag !== -1 || i.memo ? i : er(i);
}
function Wp(i, e) {
  let t = 0;
  const { shapeFlag: n } = i;
  if (e == null)
    e = null;
  else if (mt(e))
    t = 16;
  else if (typeof e == "object")
    if (n & 65) {
      const s = e.default;
      s && (s._c && (s._d = !1), Wp(i, s()), s._c && (s._d = !0));
      return;
    } else {
      t = 32;
      const s = e._;
      !s && !I5(e) ? e._ctx = Un : s === 3 && Un && (Un.slots._ === 1 ? e._ = 1 : (e._ = 2, i.patchFlag |= 1024));
    }
  else if (Ft(e)) {
    if (n & 65) {
      Wp(i, { default: e });
      return;
    }
    e = { default: e, _ctx: Un }, t = 32;
  } else
    e = String(e), n & 64 ? (t = 16, e = [J(e)]) : t = 8;
  i.children = e, i.shapeFlag |= t;
}
function B5(...i) {
  const e = {};
  for (let t = 0; t < i.length; t++) {
    const n = i[t];
    for (const s in n)
      if (s === "class")
        e.class !== n.class && (e.class = G([e.class, n.class]));
      else if (s === "style")
        e.style = ce([e.style, n.style]);
      else if (Wf(s)) {
        const o = e[s], r = n[s];
        r && o !== r && !(mt(o) && o.includes(r)) ? e[s] = o ? [].concat(o, r) : r : r == null && o == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
        // the model listener.
        !qf(s) && (e[s] = r);
      } else s !== "" && (e[s] = n[s]);
  }
  return e;
}
function ds(i, e, t, n = null) {
  ss(i, e, 7, [
    t,
    n
  ]);
}
const t9 = S5();
let n9 = 0;
function i9(i, e, t) {
  const n = i.type, s = (e ? e.appContext : i.appContext) || t9, o = {
    uid: n9++,
    vnode: i,
    type: n,
    parent: e,
    appContext: s,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new V3(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: e ? e.provides : Object.create(s.provides),
    ids: e ? e.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: HE(n, s),
    emitsOptions: LE(n, s),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: en,
    // inheritAttrs
    inheritAttrs: n.inheritAttrs,
    // state
    ctx: en,
    data: en,
    props: en,
    attrs: en,
    slots: en,
    refs: en,
    setupState: en,
    setupContext: null,
    // suspense related
    suspense: t,
    suspenseId: t ? t.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return o.ctx = { _: o }, o.root = e ? e.root : o, o.emit = OE.bind(null, o), i.ce && i.ce(o), o;
}
let pi = null;
const Wl = () => pi || Un;
let qp, Dc;
{
  const i = Xf(), e = (t, n) => {
    let s;
    return (s = i[t]) || (s = i[t] = []), s.push(n), (o) => {
      s.length > 1 ? s.forEach((r) => r(o)) : s[0](o);
    };
  };
  qp = e(
    "__VUE_INSTANCE_SETTERS__",
    (t) => pi = t
  ), Dc = e(
    "__VUE_SSR_SETTERS__",
    (t) => Oc = t
  );
}
const S1 = (i) => {
  const e = pi;
  return qp(i), i.scope.on(), () => {
    i.scope.off(), qp(e);
  };
}, Jx = () => {
  pi && pi.scope.off(), qp(null);
};
function F5(i) {
  return i.vnode.shapeFlag & 4;
}
let Oc = !1;
function s9(i, e = !1, t = !1) {
  e && Dc(e);
  const { props: n, children: s } = i.vnode, o = F5(i);
  GE(i, n, o, e), WE(i, s, t || e);
  const r = o ? o9(i, e) : void 0;
  return e && Dc(!1), r;
}
function o9(i, e) {
  const t = i.type;
  i.accessCache = /* @__PURE__ */ Object.create(null), i.proxy = new Proxy(i.ctx, PE);
  const { setup: n } = t;
  if (n) {
    Jo();
    const s = i.setupContext = n.length > 1 ? U5(i) : null, o = S1(i), r = gu(
      n,
      i,
      0,
      [
        i.props,
        s
      ]
    ), a = L3(r);
    if (Zo(), o(), (a || i.sp) && !ul(i) && ME(i), a) {
      if (r.then(Jx, Jx), e)
        return r.then((l) => {
          Dc(!0);
          try {
            Zx(i, l, e);
          } finally {
            Dc(!1);
          }
        }).catch((l) => {
          Zf(l, i, 0);
        });
      i.asyncDep = r;
    } else
      Zx(i, r);
  } else
    N5(i);
}
function Zx(i, e, t) {
  Ft(e) ? i.type.__ssrInlineRender ? i.ssrRender = e : i.render = e : qt(e) && (i.setupState = a5(e)), N5(i);
}
function N5(i, e, t) {
  const n = i.type;
  i.render || (i.render = n.render || Qr);
}
const r9 = {
  get(i, e) {
    return Vn(i, "get", ""), i[e];
  }
};
function U5(i) {
  const e = (t) => {
    i.exposed = t || {};
  };
  return {
    attrs: new Proxy(i.attrs, r9),
    slots: i.slots,
    emit: i.emit,
    expose: e
  };
}
function im(i) {
  return i.exposed ? i.exposeProxy || (i.exposeProxy = new Proxy(a5(cv(i.exposed)), {
    get(e, t) {
      if (t in e)
        return e[t];
      if (t in lc)
        return lc[t](i);
    },
    has(e, t) {
      return t in e || t in lc;
    }
  })) : i.proxy;
}
function a9(i, e = !0) {
  return Ft(i) ? i.displayName || i.name : i.name || e && i.__name;
}
function l9(i) {
  return Ft(i) && "__vccOpts" in i;
}
const I = (i, e) => /* @__PURE__ */ cE(i, e, Oc);
function Al(i, e, t) {
  try {
    Vp(-1);
    const n = arguments.length;
    return n === 2 ? qt(e) && !mt(e) ? $c(e) ? C(i, null, [e]) : C(i, e) : C(i, null, e) : (n > 3 ? t = Array.prototype.slice.call(arguments, 2) : n === 3 && $c(t) && (t = [t]), C(i, e, t));
  } finally {
    Vp(1);
  }
}
const d9 = "3.5.43";
let mv;
const Qx = typeof window != "undefined" && window.trustedTypes;
if (Qx)
  try {
    mv = /* @__PURE__ */ Qx.createPolicy("vue", {
      createHTML: (i) => i
    });
  } catch {
  }
const G5 = mv ? (i) => mv.createHTML(i) : (i) => i, c9 = "http://www.w3.org/2000/svg", u9 = "http://www.w3.org/1998/Math/MathML", Ns = typeof document != "undefined" ? document : null, ew = Ns && /* @__PURE__ */ Ns.createElement("template"), h9 = {
  insert: (i, e, t) => {
    e.insertBefore(i, t || null);
  },
  remove: (i) => {
    const e = i.parentNode;
    e && e.removeChild(i);
  },
  createElement: (i, e, t, n) => {
    const s = e === "svg" ? Ns.createElementNS(c9, i) : e === "mathml" ? Ns.createElementNS(u9, i) : t ? Ns.createElement(i, { is: t }) : Ns.createElement(i);
    return i === "select" && n && n.multiple != null && s.setAttribute("multiple", n.multiple), s;
  },
  createText: (i) => Ns.createTextNode(i),
  createComment: (i) => Ns.createComment(i),
  setText: (i, e) => {
    i.nodeValue = e;
  },
  setElementText: (i, e) => {
    i.textContent = e;
  },
  parentNode: (i) => i.parentNode,
  nextSibling: (i) => i.nextSibling,
  querySelector: (i) => Ns.querySelector(i),
  setScopeId(i, e) {
    i.setAttribute(e, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(i, e, t, n, s, o) {
    const r = t ? t.previousSibling : e.lastChild;
    if (s && (s === o || s.nextSibling))
      for (; e.insertBefore(s.cloneNode(!0), t), !(s === o || !(s = s.nextSibling)); )
        ;
    else {
      ew.innerHTML = G5(
        n === "svg" ? `<svg>${i}</svg>` : n === "mathml" ? `<math>${i}</math>` : i
      );
      const a = ew.content;
      if (n === "svg" || n === "mathml") {
        const l = a.firstChild;
        for (; l.firstChild; )
          a.appendChild(l.firstChild);
        a.removeChild(l);
      }
      e.insertBefore(a, t);
    }
    return [
      // first
      r ? r.nextSibling : e.firstChild,
      // last
      t ? t.previousSibling : e.lastChild
    ];
  }
}, fo = "transition", rd = "animation", Pl = /* @__PURE__ */ Symbol("_vtc"), j5 = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, H5 = /* @__PURE__ */ gi(
  {},
  b5,
  j5
), p9 = (i) => (i.displayName = "Transition", i.props = H5, i), vt = /* @__PURE__ */ p9(
  (i, { slots: e }) => Al(_E, V5(i), e)
), mr = (i, e = []) => {
  mt(i) ? i.forEach((t) => t(...e)) : i && i(...e);
}, tw = (i) => i ? mt(i) ? i.some((e) => e.length > 1) : i.length > 1 : !1;
function V5(i) {
  const e = {};
  for (const F in i)
    F in j5 || (e[F] = i[F]);
  if (i.css === !1)
    return e;
  const {
    name: t = "v",
    type: n,
    duration: s,
    enterFromClass: o = `${t}-enter-from`,
    enterActiveClass: r = `${t}-enter-active`,
    enterToClass: a = `${t}-enter-to`,
    appearFromClass: l = o,
    appearActiveClass: d = r,
    appearToClass: c = a,
    leaveFromClass: h = `${t}-leave-from`,
    leaveActiveClass: f = `${t}-leave-active`,
    leaveToClass: p = `${t}-leave-to`
  } = i, y = f9(s), v = y && y[0], x = y && y[1], {
    onBeforeEnter: w,
    onEnter: S,
    onEnterCancelled: M,
    onLeave: _,
    onLeaveCancelled: T,
    onBeforeAppear: k = w,
    onAppear: P = S,
    onAppearCancelled: A = M
  } = e, R = (F, te, ee, me) => {
    F._enterCancelled = me, Co(F, te ? c : a), Co(F, te ? d : r), ee && ee();
  }, D = (F, te) => {
    F._isLeaving = !1, Co(F, h), Co(F, p), Co(F, f), te && te();
  }, O = (F) => (te, ee) => {
    const me = F ? P : S, L = () => R(te, F, ee);
    mr(me, [te, L]), nw(() => {
      Co(te, F ? l : o), cs(te, F ? c : a), tw(me) || iw(te, n, v, L);
    });
  };
  return gi(e, {
    onBeforeEnter(F) {
      mr(w, [F]), cs(F, o), cs(F, r);
    },
    onBeforeAppear(F) {
      mr(k, [F]), cs(F, l), cs(F, d);
    },
    onEnter: O(!1),
    onAppear: O(!0),
    onLeave(F, te) {
      F._isLeaving = !0;
      const ee = () => D(F, te);
      cs(F, h), F._enterCancelled ? (cs(F, f), gv(F)) : (gv(F), cs(F, f)), nw(() => {
        F._isLeaving && (Co(F, h), cs(F, p), tw(_) || iw(F, n, x, ee));
      }), mr(_, [F, ee]);
    },
    onEnterCancelled(F) {
      R(F, !1, void 0, !0), mr(M, [F]);
    },
    onAppearCancelled(F) {
      R(F, !0, void 0, !0), mr(A, [F]);
    },
    onLeaveCancelled(F) {
      D(F), mr(T, [F]);
    }
  });
}
function f9(i) {
  if (i == null)
    return null;
  if (qt(i))
    return [Gm(i.enter), Gm(i.leave)];
  {
    const e = Gm(i);
    return [e, e];
  }
}
function Gm(i) {
  return $P(i);
}
function cs(i, e) {
  e.split(/\s+/).forEach((t) => t && i.classList.add(t)), (i[Pl] || (i[Pl] = /* @__PURE__ */ new Set())).add(e);
}
function Co(i, e) {
  e.split(/\s+/).forEach((n) => n && i.classList.remove(n));
  const t = i[Pl];
  t && (t.delete(e), t.size || (i[Pl] = void 0));
}
function nw(i) {
  requestAnimationFrame(() => {
    requestAnimationFrame(i);
  });
}
let m9 = 0;
function iw(i, e, t, n) {
  const s = i._endId = ++m9, o = () => {
    s === i._endId && n();
  };
  if (t != null)
    return setTimeout(o, t);
  const { type: r, timeout: a, propCount: l } = W5(i, e);
  if (!r)
    return n();
  const d = r + "end";
  let c = 0;
  const h = () => {
    i.removeEventListener(d, f), o();
  }, f = (p) => {
    p.target === i && ++c >= l && h();
  };
  setTimeout(() => {
    c < l && h();
  }, a + 1), i.addEventListener(d, f);
}
function W5(i, e) {
  const t = window.getComputedStyle(i), n = (y) => (t[y] || "").split(", "), s = n(`${fo}Delay`), o = n(`${fo}Duration`), r = sw(s, o), a = n(`${rd}Delay`), l = n(`${rd}Duration`), d = sw(a, l);
  let c = null, h = 0, f = 0;
  e === fo ? r > 0 && (c = fo, h = r, f = o.length) : e === rd ? d > 0 && (c = rd, h = d, f = l.length) : (h = Math.max(r, d), c = h > 0 ? r > d ? fo : rd : null, f = c ? c === fo ? o.length : l.length : 0);
  const p = c === fo && /\b(?:transform|all)(?:,|$)/.test(
    n(`${fo}Property`).toString()
  );
  return {
    type: c,
    timeout: h,
    propCount: f,
    hasTransform: p
  };
}
function sw(i, e) {
  for (; i.length < e.length; )
    i = i.concat(i);
  return Math.max(...e.map((t, n) => ow(t) + ow(i[n])));
}
function ow(i) {
  return i === "auto" ? 0 : Number(i.slice(0, -1).replace(",", ".")) * 1e3;
}
function gv(i) {
  return (i ? i.ownerDocument : document).body.offsetHeight;
}
function g9(i, e, t) {
  const n = i[Pl];
  n && (e = (e ? [e, ...n] : [...n]).join(" ")), e == null ? i.removeAttribute("class") : t ? i.setAttribute("class", e) : i.className = e;
}
const Kp = /* @__PURE__ */ Symbol("_vod"), M1 = /* @__PURE__ */ Symbol("_vsh"), bv = {
  // used for prop mismatch check during hydration
  name: "show",
  beforeMount(i, { value: e }, { transition: t }) {
    i[Kp] = i.style.display === "none" ? "" : i.style.display, t && e ? t.beforeEnter(i) : ad(i, e);
  },
  mounted(i, { value: e }, { transition: t }) {
    t && e && t.enter(i);
  },
  updated(i, { value: e, oldValue: t }, { transition: n }) {
    !e != !t && (n ? e ? (n.beforeEnter(i), ad(i, !0), n.enter(i)) : n.leave(i, () => {
      ad(i, !1);
    }) : ad(i, e));
  },
  beforeUnmount(i, { value: e }) {
    ad(i, e);
  }
};
function ad(i, e) {
  i.style.display = e ? i[Kp] : "none", i[M1] = !e;
}
const b9 = /* @__PURE__ */ Symbol(""), v9 = /(?:^|;)\s*display\s*:/;
function y9(i, e, t) {
  const n = i.style, s = on(t);
  let o = !1;
  if (t && !s) {
    if (e)
      if (on(e))
        for (const r of e.split(";")) {
          const a = r.slice(0, r.indexOf(":")).trim();
          t[a] == null && jd(n, a, "");
        }
      else
        for (const r in e)
          t[r] == null && jd(n, r, "");
    for (const r in t) {
      r === "display" && (o = !0);
      const a = t[r];
      a != null ? w9(
        i,
        r,
        !on(e) && e ? e[r] : void 0,
        a
      ) || jd(n, r, a) : jd(n, r, "");
    }
  } else if (s) {
    if (e !== t) {
      const r = n[b9];
      r && (t += ";" + r), n.cssText = t, o = v9.test(t);
    }
  } else e && i.removeAttribute("style");
  Kp in i && (i[Kp] = o ? n.display : "", i[M1] && (n.display = "none"));
}
const zu = /\s*!important$/;
function jd(i, e, t) {
  if (mt(t))
    t.forEach((n) => jd(i, e, n));
  else if (t == null && (t = ""), e.startsWith("--"))
    zu.test(t) ? i.setProperty(e, t.replace(zu, ""), "important") : i.setProperty(e, t);
  else {
    const n = x9(i, e);
    zu.test(t) ? i.setProperty(
      lr(n),
      t.replace(zu, ""),
      "important"
    ) : i[n] = t;
  }
}
const rw = ["Webkit", "Moz", "ms"], jm = {};
function x9(i, e) {
  const t = jm[e];
  if (t)
    return t;
  let n = ri(e);
  if (n !== "filter" && n in i)
    return jm[e] = n;
  n = Yf(n);
  for (let s = 0; s < rw.length; s++) {
    const o = rw[s] + n;
    if (o in i)
      return jm[e] = o;
  }
  return e;
}
function w9(i, e, t, n) {
  return i.tagName === "TEXTAREA" && (e === "width" || e === "height") && on(n) && t === n;
}
const aw = "http://www.w3.org/1999/xlink";
function lw(i, e, t, n, s, o = NP(e)) {
  n && e.startsWith("xlink:") ? t == null ? i.removeAttributeNS(aw, e.slice(6, e.length)) : i.setAttributeNS(aw, e, t) : t == null || o && !U3(t) ? i.removeAttribute(e) : i.setAttribute(
    e,
    o ? "" : is(t) ? String(t) : t
  );
}
function dw(i, e, t, n, s) {
  if (e === "innerHTML" || e === "textContent") {
    t != null && (i[e] = e === "innerHTML" ? G5(t) : t);
    return;
  }
  const o = i.tagName;
  if (e === "value" && o !== "PROGRESS" && // custom elements may use _value internally
  !o.includes("-")) {
    const a = o === "OPTION" ? i.getAttribute("value") || "" : i.value, l = t == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      i.type === "checkbox" ? "on" : ""
    ) : String(t);
    (a !== l || !("_value" in i)) && (i.value = l), t == null && i.removeAttribute(e), i._value = t;
    return;
  }
  let r = !1;
  if (t === "" || t == null) {
    const a = typeof i[e];
    a === "boolean" ? t = U3(t) : t == null && a === "string" ? (t = "", r = !0) : a === "number" && (t = 0, r = !0);
  }
  try {
    i[e] = t;
  } catch {
  }
  r && i.removeAttribute(s || e);
}
function Nr(i, e, t, n) {
  i.addEventListener(e, t, n);
}
function k9(i, e, t, n) {
  i.removeEventListener(e, t, n);
}
const cw = /* @__PURE__ */ Symbol("_vei");
function _9(i, e, t, n, s = null) {
  const o = i[cw] || (i[cw] = {}), r = o[e];
  if (n && r)
    r.value = n;
  else {
    const [a, l] = T9(e);
    if (n) {
      const d = o[e] = A9(
        n,
        s
      );
      Nr(i, a, d, l);
    } else r && (k9(i, a, r, l), o[e] = void 0);
  }
}
const S9 = /(Once|Passive|Capture)$/, M9 = /^on:?(?:Once|Passive|Capture)$/;
function T9(i) {
  let e, t;
  for (; (t = i.match(S9)) && !M9.test(i); )
    e || (e = {}), i = i.slice(0, i.length - t[1].length), e[t[1].toLowerCase()] = !0;
  return [i[2] === ":" ? i.slice(3) : lr(i.slice(2)), e];
}
let Hm = 0;
const C9 = /* @__PURE__ */ Promise.resolve(), I9 = () => Hm || (C9.then(() => Hm = 0), Hm = Date.now());
function A9(i, e) {
  const t = (n) => {
    if (!n._vts)
      n._vts = Date.now();
    else if (n._vts <= t.attached)
      return;
    const s = t.value;
    if (mt(s)) {
      const o = n.stopImmediatePropagation;
      n.stopImmediatePropagation = () => {
        o.call(n), n._stopped = !0;
      };
      const r = s.slice(), a = [n];
      for (let l = 0; l < r.length && !n._stopped; l++) {
        const d = r[l];
        d && ss(
          d,
          e,
          5,
          a
        );
      }
    } else
      ss(
        s,
        e,
        5,
        [n]
      );
  };
  return t.value = i, t.attached = I9(), t;
}
const uw = (i) => i.charCodeAt(0) === 111 && i.charCodeAt(1) === 110 && // lowercase letter
i.charCodeAt(2) > 96 && i.charCodeAt(2) < 123, P9 = (i, e, t, n, s, o) => {
  const r = s === "svg";
  e === "class" ? g9(i, n, r) : e === "style" ? y9(i, t, n) : Wf(e) ? qf(e) || _9(i, e, t, n, o) : (e[0] === "." ? (e = e.slice(1), !0) : e[0] === "^" ? (e = e.slice(1), !1) : E9(i, e, n, r)) ? (dw(i, e, n), !i.tagName.includes("-") && (e === "value" || e === "checked" || e === "selected") && lw(i, e, n, r, o, e !== "value")) : /* #11081 force set props for possible async custom element */ i._isVueCE && // #12408 check if it's declared prop or it's async custom element
  (R9(i, e) || // @ts-expect-error _def is private
  i._def.__asyncLoader && (/[A-Z]/.test(e) || !on(n))) ? dw(i, ri(e), n, o, e) : (e === "true-value" ? i._trueValue = n : e === "false-value" && (i._falseValue = n), lw(i, e, n, r));
};
function E9(i, e, t, n) {
  if (n)
    return !!(e === "innerHTML" || e === "textContent" || e in i && uw(e) && Ft(t));
  if (e === "spellcheck" || e === "draggable" || e === "translate" || e === "autocorrect" || e === "sandbox" && i.tagName === "IFRAME" || e === "form" || e === "list" && i.tagName === "INPUT" || e === "type" && i.tagName === "TEXTAREA")
    return !1;
  if (e === "width" || e === "height") {
    const s = i.tagName;
    if (s === "IMG" || s === "VIDEO" || s === "CANVAS" || s === "SOURCE")
      return !1;
  }
  return uw(e) && on(t) ? !1 : e in i;
}
function R9(i, e) {
  const t = (
    // @ts-expect-error _def is private
    i._def.props
  );
  if (!t)
    return !1;
  const n = ri(e);
  return Array.isArray(t) ? t.some((s) => ri(s) === n) : Object.keys(t).some((s) => ri(s) === n);
}
const q5 = /* @__PURE__ */ new WeakMap(), K5 = /* @__PURE__ */ new WeakMap(), Yp = /* @__PURE__ */ Symbol("_moveCb"), hw = /* @__PURE__ */ Symbol("_enterCb"), z9 = (i) => (delete i.props.mode, i), $9 = /* @__PURE__ */ z9({
  name: "TransitionGroup",
  props: /* @__PURE__ */ gi({}, H5, {
    tag: String,
    moveClass: String
  }),
  setup(i, { slots: e }) {
    const t = Wl(), n = g5();
    let s, o;
    return w5(() => {
      if (!s.length)
        return;
      const r = i.moveClass || `${i.name || "v"}-move`;
      if (!B9(
        s[0].el,
        t.vnode.el,
        r
      )) {
        s = [];
        return;
      }
      s.forEach(D9), s.forEach(O9);
      const a = s.filter(L9);
      gv(t.vnode.el), a.forEach((l) => {
        const d = l.el, c = d.style;
        cs(d, r), c.transform = c.webkitTransform = c.transitionDuration = "";
        const h = d[Yp] = (f) => {
          f && f.target !== d || (!f || f.propertyName.endsWith("transform")) && (d.removeEventListener("transitionend", h), d[Yp] = null, Co(d, r));
        };
        d.addEventListener("transitionend", h);
      }), s = [];
    }), () => {
      const r = /* @__PURE__ */ Et(i), a = V5(r);
      let l = r.tag || j;
      if (s = [], o)
        for (let d = 0; d < o.length; d++) {
          const c = o[d];
          c.el && c.el instanceof Element && // Hidden v-show nodes have no previous layout box to animate from.
          !c.el[M1] && (s.push(c), aa(
            c,
            Rc(
              c,
              a,
              n,
              t
            )
          ), q5.set(c, Y5(c.el)));
        }
      o = e.default ? g1(e.default()) : [];
      for (let d = 0; d < o.length; d++) {
        const c = o[d];
        c.key != null && aa(
          c,
          Rc(c, a, n, t)
        );
      }
      return C(l, null, o);
    };
  }
}), Xp = $9;
function D9(i) {
  const e = i.el;
  e[Yp] && e[Yp](), e[hw] && e[hw]();
}
function O9(i) {
  K5.set(i, Y5(i.el));
}
function L9(i) {
  const e = q5.get(i), t = K5.get(i), n = e.left - t.left, s = e.top - t.top;
  if (n || s) {
    const o = i.el, r = o.style, a = o.getBoundingClientRect();
    let l = 1, d = 1;
    return o.offsetWidth && (l = a.width / o.offsetWidth), o.offsetHeight && (d = a.height / o.offsetHeight), (!Number.isFinite(l) || l === 0) && (l = 1), (!Number.isFinite(d) || d === 0) && (d = 1), Math.abs(l - 1) < 0.01 && (l = 1), Math.abs(d - 1) < 0.01 && (d = 1), r.transform = r.webkitTransform = `translate(${n / l}px,${s / d}px)`, r.transitionDuration = "0s", i;
  }
}
function Y5(i) {
  const e = i.getBoundingClientRect();
  return {
    left: e.left,
    top: e.top
  };
}
function B9(i, e, t) {
  const n = i.cloneNode(), s = i[Pl];
  s && s.forEach((a) => {
    a.split(/\s+/).forEach((l) => l && n.classList.remove(l));
  }), t.split(/\s+/).forEach((a) => a && n.classList.add(a)), n.style.display = "none";
  const o = e.nodeType === 1 ? e : e.parentNode;
  o.appendChild(n);
  const { hasTransform: r } = W5(n);
  return o.removeChild(n), r;
}
const Jp = (i) => {
  const e = i.props["onUpdate:modelValue"] || !1;
  return mt(e) ? (t) => pp(e, t) : e;
};
function F9(i) {
  i.target.composing = !0;
}
function pw(i) {
  const e = i.target;
  e.composing && (e.composing = !1, e.dispatchEvent(new Event("input")));
}
const Hr = /* @__PURE__ */ Symbol("_assign"), $u = /* @__PURE__ */ Symbol("_initialValue");
function Vm(i, e, t) {
  return e && (i = i.trim()), t && (i = o1(i)), i;
}
const Zt = {
  created(i, { modifiers: { lazy: e, trim: t, number: n } }, s) {
    i.parentNode && (i.type === "text" ? i[$u] = i.defaultValue.replace(/[\r\n]/g, "") : i.type === "textarea" && (i[$u] = i.defaultValue.replace(/\r\n?/g, `
`))), i[Hr] = Jp(s);
    const o = n || s.props && s.props.type === "number";
    Nr(i, e ? "change" : "input", (r) => {
      r.target.composing || i[Hr](Vm(i.value, t, o));
    }), (t || o) && Nr(i, "change", () => {
      i.value = Vm(i.value, t, o);
    }), e || (Nr(i, "compositionstart", F9), Nr(i, "compositionend", pw), Nr(i, "change", pw));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(i, { value: e, modifiers: { trim: t, number: n } }) {
    const s = e == null ? "" : e, o = i[$u];
    delete i[$u], o !== void 0 && (i.type === "text" || i.type === "textarea") && i.value !== o ? i[Hr](Vm(i.value, t, n)) : i.value = s;
  },
  beforeUpdate(i, { value: e, oldValue: t, modifiers: { lazy: n, trim: s, number: o } }, r) {
    if (i[Hr] = Jp(r), i.composing) return;
    const a = (o || i.type === "number") && !/^0\d/.test(i.value) ? o1(i.value) : i.value, l = e == null ? "" : e;
    if (a === l)
      return;
    const d = i.getRootNode();
    (d instanceof Document || d instanceof ShadowRoot) && d.activeElement === i && i.type !== "range" && (n && e === t || s && i.value.trim() === l) || (i.value = l);
  }
}, ol = {
  // #4096 array checkboxes need to be deep traversed
  deep: !0,
  created(i, e, t) {
    i[Hr] = Jp(t), Nr(i, "change", () => {
      const n = i._modelValue, s = N9(i), o = i.checked, r = i[Hr];
      if (mt(n)) {
        const a = G3(n, s), l = a !== -1;
        if (o && !l)
          r(n.concat(s));
        else if (!o && l) {
          const d = [...n];
          d.splice(a, 1), r(d);
        }
      } else if (Il(n)) {
        const a = new Set(n);
        o ? a.add(s) : a.delete(s), r(a);
      } else
        r(X5(i, o));
    });
  },
  // set initial checked on mount to wait for true-value/false-value
  mounted: fw,
  beforeUpdate(i, e, t) {
    i[Hr] = Jp(t), fw(i, e, t);
  }
};
function fw(i, { value: e, oldValue: t }, n) {
  i._modelValue = e;
  let s;
  if (mt(e))
    s = G3(e, n.props.value) > -1;
  else if (Il(e))
    s = e.has(n.props.value);
  else {
    if (e === t) return;
    s = Vl(e, X5(i, !0));
  }
  i.checked !== s && (i.checked = s);
}
function N9(i) {
  return "_value" in i ? i._value : i.value;
}
function X5(i, e) {
  const t = e ? "_trueValue" : "_falseValue";
  return t in i ? i[t] : e;
}
const U9 = ["ctrl", "shift", "alt", "meta"], G9 = {
  stop: (i) => i.stopPropagation(),
  prevent: (i) => i.preventDefault(),
  self: (i) => i.target !== i.currentTarget,
  ctrl: (i) => !i.ctrlKey,
  shift: (i) => !i.shiftKey,
  alt: (i) => !i.altKey,
  meta: (i) => !i.metaKey,
  left: (i) => "button" in i && i.button !== 0,
  middle: (i) => "button" in i && i.button !== 1,
  right: (i) => "button" in i && i.button !== 2,
  exact: (i, e) => U9.some((t) => i[`${t}Key`] && !e.includes(t))
}, Se = (i, e) => {
  if (!i) return i;
  const t = i._withMods || (i._withMods = {}), n = e.join(".");
  return t[n] || (t[n] = ((s, ...o) => {
    for (let r = 0; r < e.length; r++) {
      const a = G9[e[r]];
      if (a && a(s, e)) return;
    }
    return i(s, ...o);
  }));
}, j9 = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
}, tn = (i, e) => {
  const t = i._withKeys || (i._withKeys = {}), n = e.join(".");
  return t[n] || (t[n] = ((s) => {
    if (!("key" in s))
      return;
    const o = lr(s.key);
    if (e.some(
      (r) => r === o || j9[r] === o
    ))
      return i(s);
  }));
}, H9 = /* @__PURE__ */ gi({ patchProp: P9 }, h9);
let mw;
function V9() {
  return mw || (mw = KE(H9));
}
const J5 = ((...i) => {
  const e = V9().createApp(...i), { mount: t } = e;
  return e.mount = (n) => {
    const s = q9(n);
    if (!s) return;
    const o = e._component;
    !Ft(o) && !o.render && !o.template && (o.template = s.innerHTML), s.nodeType === 1 && (s.textContent = "");
    const r = t(s, !1, W9(s));
    return s instanceof Element && (s.removeAttribute("v-cloak"), s.setAttribute("data-v-app", "")), r;
  }, e;
});
function W9(i) {
  if (i instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && i instanceof MathMLElement)
    return "mathml";
}
function q9(i) {
  return on(i) ? document.querySelector(i) : i;
}
const gr = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const gw = (...i) => i.filter((e, t, n) => !!e && e.trim() !== "" && n.indexOf(e) === t).join(" ").trim();
function Wm(i) {
  return i != null;
}
function K9(i, e = {}) {
  var f, p, y, v, x, w, S, M, _, T, k, P, A, R, D;
  const t = (f = e.attributeNames) != null ? f : {}, n = (O) => {
    var F;
    return (F = t[O]) != null ? F : O;
  }, s = (y = (p = i.size) != null ? p : i.width) != null ? y : gr.width, o = (x = (v = i.size) != null ? v : i.height) != null ? x : gr.height, r = (S = (w = i.aliases) == null ? void 0 : w.filter((O) => typeof O == "string" && O.trim() !== "").map((O) => `lucide-${O}`)) != null ? S : [], a = [...i.name ? [`lucide-${i.name}`] : [], ...r], l = (_ = (M = e.className) == null ? void 0 : M.split(" ").filter(Boolean)) != null ? _ : [], d = e.includeDefaultClasses === !1 ? gw(...l) : gw("lucide", ...a, ...l), c = e.absoluteStrokeWidth ? Number((T = e.strokeWidth) != null ? T : gr["stroke-width"]) * Number((P = (k = i.size) != null ? k : i.width) != null ? P : gr.width) / Number((R = (A = e.size) != null ? A : e.width) != null ? R : gr.width) : (D = e.strokeWidth) != null ? D : gr["stroke-width"];
  return [
    "svg",
    {
      ...Object.entries(gr).reduce((O, [F, te]) => (O[n(F)] = te, O), {}),
      ..."color" in e && e.color && {
        [n("stroke")]: e.color
      },
      ..."size" in e && Wm(e.size) && {
        [n("width")]: e.size,
        [n("height")]: e.size
      },
      ..."width" in e && Wm(e.width) && {
        [n("width")]: e.width
      },
      ..."height" in e && Wm(e.height) && {
        [n("height")]: e.height
      },
      [n("stroke-width")]: c,
      ...d && {
        [n("class")]: d
      },
      [n("viewBox")]: `0 0 ${s} ${o}`,
      ...e.hasA11yProp === !1 ? {
        [n("aria-hidden")]: "true"
      } : {},
      ..."attributes" in e && e.attributes
    },
    i.node.map((O) => {
      const [F, te, ee] = O, me = e.nonScalingStroke ? { [n("vector-effect")]: "non-scaling-stroke", ...te } : te;
      return ee ? [F, me, ee] : [F, me];
    })
  ];
}
const Y9 = (i) => {
  for (const e in i)
    if (e.startsWith("aria-") || e === "role" || e === "title")
      return !0;
  return !1;
};
const Du = (i) => i === "";
const X9 = (i) => i == null ? void 0 : i.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const J9 = /* @__PURE__ */ Symbol("lucide-icons");
function Z9() {
  return Qf(J9, {});
}
const Q9 = ({
  name: i,
  iconNode: e,
  "icon-node": t,
  icon: n = {
    name: i && X9(i),
    node: ((x) => (x = e != null ? e : t) != null ? x : [])(),
    size: 24,
    aliases: []
  },
  absoluteStrokeWidth: s,
  "absolute-stroke-width": o,
  nonScalingStroke: r,
  "non-scaling-stroke": a,
  strokeWidth: l,
  "stroke-width": d,
  size: c,
  width: h = c,
  height: f = c,
  color: p,
  ...y
}, { slots: v }) => {
  var F, te, ee, me;
  const {
    size: w,
    color: S,
    strokeWidth: M = 2,
    absoluteStrokeWidth: _ = !1,
    nonScalingStroke: T = !1,
    class: k = ""
  } = Z9(), P = Du(s) || Du(o) || s === !0 || o === !0 || _ === !0, A = Du(r) || Du(a) || r === !0 || a === !0 || T === !0;
  delete y.class;
  const R = (F = v.default) == null ? void 0 : F.call(v), [, D, O = []] = K9(n, {
    color: p != null ? p : S,
    width: (te = h != null ? h : c) != null ? te : w,
    height: (ee = f != null ? f : c) != null ? ee : w,
    strokeWidth: (me = l != null ? l : d) != null ? me : M,
    absoluteStrokeWidth: P,
    nonScalingStroke: A,
    className: k,
    hasA11yProp: R != null && R.length > 0 || Y9(y),
    attributes: y
  });
  return Al("svg", D, [
    ...O.map(([L, N]) => Al(L, N)),
    ...R != null ? R : []
  ]);
};
function _e(i, e = []) {
  const t = typeof i == "string" ? {
    name: i,
    node: e
  } : i;
  return (n, { slots: s }) => Al(
    Q9,
    {
      ...n,
      icon: t
    },
    s.default ? { default: s.default } : void 0
  );
}
const eR = {
  name: "align-center-horizontal",
  size: 24,
  node: [
    ["path", { d: "M2 12h20", key: "9i4pu4" }],
    ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
    ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
    ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" }],
    ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }]
  ]
}, tR = _e(eR);
const nR = {
  name: "align-horizontal-distribute-center",
  size: 24,
  node: [
    ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
    ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
    ["path", { d: "M17 22v-5", key: "4b6g73" }],
    ["path", { d: "M17 7V2", key: "hnrr36" }],
    ["path", { d: "M7 22v-3", key: "1r4jpn" }],
    ["path", { d: "M7 5V2", key: "liy1u9" }]
  ]
}, iR = _e(nR);
const sR = {
  name: "align-start-horizontal",
  size: 24,
  node: [
    ["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" }],
    ["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" }],
    ["path", { d: "M22 2H2", key: "fhrpnj" }]
  ]
}, oR = _e(sR);
const rR = {
  name: "align-start-vertical",
  size: 24,
  node: [
    ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }],
    ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }],
    ["path", { d: "M2 2v20", key: "1ivd8o" }]
  ]
}, aR = _e(rR);
const lR = {
  name: "aperture",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m14.31 8 5.74 9.94", key: "1y6ab4" }],
    ["path", { d: "M9.69 8h11.48", key: "1wxppr" }],
    ["path", { d: "m7.38 12 5.74-9.94", key: "1grp0k" }],
    ["path", { d: "M9.69 16 3.95 6.06", key: "libnyf" }],
    ["path", { d: "M14.31 16H2.83", key: "x5fava" }],
    ["path", { d: "m16.62 12-5.74 9.94", key: "1vwawt" }]
  ]
}, dR = _e(lR);
const cR = {
  name: "arrow-down-to-line",
  size: 24,
  node: [
    ["path", { d: "M12 17V3", key: "1cwfxf" }],
    ["path", { d: "m6 11 6 6 6-6", key: "12ii2o" }],
    ["path", { d: "M19 21H5", key: "150jfl" }]
  ]
}, uR = _e(cR);
const hR = {
  name: "arrow-down",
  size: 24,
  node: [
    ["path", { d: "M12 5v14", key: "s699le" }],
    ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
  ]
}, pR = _e(hR);
const fR = {
  name: "arrow-left",
  size: 24,
  node: [
    ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
    ["path", { d: "M19 12H5", key: "x3x0zl" }]
  ]
}, mR = _e(fR);
const gR = {
  name: "arrow-right",
  size: 24,
  node: [
    ["path", { d: "M5 12h14", key: "1ays0h" }],
    ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
  ]
}, Z5 = _e(gR);
const bR = {
  name: "arrow-up-down",
  size: 24,
  node: [
    ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
    ["path", { d: "M17 20V4", key: "1ejh1v" }],
    ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
    ["path", { d: "M7 4v16", key: "1glfcx" }]
  ]
}, vR = _e(bR);
const yR = {
  name: "arrow-up-right",
  size: 24,
  node: [
    ["path", { d: "M7 7h10v10", key: "1tivn9" }],
    ["path", { d: "M7 17 17 7", key: "1vkiza" }]
  ]
}, Q5 = _e(yR);
const xR = {
  name: "arrow-up",
  size: 24,
  node: [
    ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
    ["path", { d: "M12 19V5", key: "x0mq9r" }]
  ]
}, e6 = _e(xR);
const wR = {
  name: "at-sign",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
    ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", key: "7n84p3" }]
  ]
}, kR = _e(wR);
const _R = {
  name: "bell-off",
  size: 24,
  node: [
    ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
    [
      "path",
      {
        d: "M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742",
        key: "178tsu"
      }
    ],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    ["path", { d: "M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05", key: "1hqiys" }]
  ]
}, SR = _e(_R);
const MR = {
  name: "bell",
  size: 24,
  node: [
    ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
    [
      "path",
      {
        d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
        key: "11g9vi"
      }
    ]
  ]
}, TR = _e(MR);
const CR = {
  name: "blend",
  size: 24,
  node: [
    ["circle", { cx: "15", cy: "9", r: "7", key: "1i12rt" }],
    ["circle", { cx: "9", cy: "15", r: "7", key: "19bs8k" }]
  ]
}, IR = _e(CR);
const AR = {
  name: "bookmark-plus",
  size: 24,
  node: [
    ["path", { d: "M12 7v6", key: "lw1j43" }],
    ["path", { d: "M15 10H9", key: "o6yqo3" }],
    [
      "path",
      {
        d: "M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z",
        key: "oz39mx"
      }
    ]
  ]
}, PR = _e(AR);
const ER = {
  name: "bookmark",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z",
        key: "oz39mx"
      }
    ]
  ]
}, RR = _e(ER);
const zR = {
  name: "box",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
        key: "hh9hay"
      }
    ],
    ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
    ["path", { d: "M12 22V12", key: "d0xqtd" }]
  ]
}, $R = _e(zR);
const DR = {
  name: "bring-to-front",
  size: 24,
  node: [
    ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "2", key: "yj20xf" }],
    ["path", { d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2", key: "1ltk23" }],
    ["path", { d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2", key: "1q24h9" }]
  ]
}, OR = _e(DR);
const LR = {
  name: "brush",
  size: 24,
  node: [
    ["path", { d: "m11 10 3 3", key: "fzmg1i" }],
    [
      "path",
      {
        d: "M6.5 21A3.5 3.5 0 1 0 3 17.5a2.62 2.62 0 0 1-.708 1.792A1 1 0 0 0 3 21z",
        key: "p4q2r7"
      }
    ],
    ["path", { d: "M9.969 17.031 21.378 5.624a1 1 0 0 0-3.002-3.002L6.967 14.031", key: "wy6l02" }]
  ]
}, BR = _e(LR);
const FR = {
  name: "bug",
  size: 24,
  node: [
    ["path", { d: "M12 20v-9", key: "1qisl0" }],
    ["path", { d: "M14 7a4 4 0 0 1 4 4v3a6 6 0 0 1-12 0v-3a4 4 0 0 1 4-4z", key: "uouzyp" }],
    ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
    ["path", { d: "M21 21a4 4 0 0 0-3.81-4", key: "1b0z45" }],
    ["path", { d: "M21 5a4 4 0 0 1-3.55 3.97", key: "5cxbf6" }],
    ["path", { d: "M22 13h-4", key: "1jl80f" }],
    ["path", { d: "M3 21a4 4 0 0 1 3.81-4", key: "1fjd4g" }],
    ["path", { d: "M3 5a4 4 0 0 0 3.55 3.97", key: "1d7oge" }],
    ["path", { d: "M6 13H2", key: "82j7cp" }],
    ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
    ["path", { d: "M9 7.13V6a3 3 0 1 1 6 0v1.13", key: "1vgav8" }]
  ]
}, NR = _e(FR);
const UR = {
  name: "building-complex",
  size: 24,
  node: [
    ["path", { d: "M10 12h4", key: "a56b0p" }],
    ["path", { d: "M10 8h4", key: "1sr2af" }],
    ["path", { d: "M14 21v-3a2 2 0 0 0-4 0v3", key: "1rgiei" }],
    [
      "path",
      {
        d: "M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2",
        key: "secmi2"
      }
    ],
    ["path", { d: "M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16", key: "16ra0t" }]
  ],
  aliases: ["building-2"]
}, GR = _e(UR);
const jR = {
  name: "camera",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
        key: "18u6gg"
      }
    ],
    ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
  ]
}, HR = _e(jR);
const VR = {
  name: "check-check",
  size: 24,
  node: [
    ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
    ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
  ]
}, WR = _e(VR);
const qR = {
  name: "check",
  size: 24,
  node: [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]
}, t6 = _e(qR);
const KR = {
  name: "chevron-down",
  size: 24,
  node: [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]]
}, n6 = _e(KR);
const YR = {
  name: "chevron-left",
  size: 24,
  node: [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]]
}, i6 = _e(YR);
const XR = {
  name: "chevron-right",
  size: 24,
  node: [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]]
}, s6 = _e(XR);
const JR = {
  name: "chevron-up",
  size: 24,
  node: [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]
}, ZR = _e(JR);
const QR = {
  name: "chevrons-down-up",
  size: 24,
  node: [
    ["path", { d: "m7 20 5-5 5 5", key: "13a0gw" }],
    ["path", { d: "m7 4 5 5 5-5", key: "1kwcof" }]
  ]
}, ez = _e(QR);
const tz = {
  name: "chevrons-up-down",
  size: 24,
  node: [
    ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
    ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
  ]
}, nz = _e(tz);
const iz = {
  name: "chevrons-up",
  size: 24,
  node: [
    ["path", { d: "m17 11-5-5-5 5", key: "e8nh98" }],
    ["path", { d: "m17 18-5-5-5 5", key: "2avn1x" }]
  ]
}, sz = _e(iz);
const oz = {
  name: "circle-alert",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
    ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
  ],
  aliases: ["alert-circle"]
}, vv = _e(oz);
const rz = {
  name: "circle-check",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m16 9-5.5 5.5L8 12", key: "xofnsj" }]
  ],
  aliases: ["check-circle-2"]
}, o6 = _e(rz);
const az = {
  name: "circle-minus",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }]
  ],
  aliases: ["minus-circle"]
}, lz = _e(az);
const dz = {
  name: "circle-play",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z",
        key: "kmsa83"
      }
    ],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
  ],
  aliases: ["play-circle"]
}, cz = _e(dz);
const uz = {
  name: "circle-question-mark",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
    ["path", { d: "M12 17h.01", key: "p32p05" }]
  ],
  aliases: ["help-circle", "circle-help"]
}, bw = _e(uz);
const hz = {
  name: "circle-stop",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1", key: "1ssd4o" }]
  ],
  aliases: ["stop-circle"]
}, pz = _e(hz);
const fz = {
  name: "circle",
  size: 24,
  node: [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]]
}, mz = _e(fz);
const gz = {
  name: "circle-x",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
    ["path", { d: "m9 9 6 6", key: "z0biqf" }]
  ],
  aliases: ["x-circle"]
}, r6 = _e(gz);
const bz = {
  name: "clapperboard",
  size: 24,
  node: [
    ["path", { d: "m12.296 3.464 3.02 3.956", key: "qash78" }],
    [
      "path",
      {
        d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3z",
        key: "1h7j8b"
      }
    ],
    ["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z", key: "4lm6w1" }],
    ["path", { d: "m6.18 5.276 3.1 3.899", key: "zjj9t3" }]
  ]
}, vz = _e(bz);
const yz = {
  name: "clipboard",
  size: 24,
  node: [
    ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
    [
      "path",
      {
        d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        key: "116196"
      }
    ]
  ]
}, xz = _e(yz);
const wz = {
  name: "clock",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }]
  ]
}, kz = _e(wz);
const _z = {
  name: "cloud-off",
  size: 24,
  node: [
    [
      "path",
      { d: "M10.94 5.274A7 7 0 0 1 15.71 10h1.79a4.5 4.5 0 0 1 4.222 6.057", key: "1uxyv8" }
    ],
    ["path", { d: "M18.796 18.81A4.5 4.5 0 0 1 17.5 19H9A7 7 0 0 1 5.79 5.78", key: "99tcn7" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }]
  ]
}, Sz = _e(_z);
const Mz = {
  name: "coffee",
  size: 24,
  node: [
    ["path", { d: "M10 2v2", key: "7u0qdc" }],
    ["path", { d: "M14 2v2", key: "6buw04" }],
    [
      "path",
      {
        d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
        key: "pwadti"
      }
    ],
    ["path", { d: "M6 2v2", key: "colzsn" }]
  ]
}, Tz = _e(Mz);
const Cz = {
  name: "columns-2",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M12 3v18", key: "108xh3" }]
  ],
  aliases: ["columns"]
}, Iz = _e(Cz);
const Az = {
  name: "columns-3",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }]
  ],
  aliases: ["panels-left-right"]
}, Pz = _e(Az);
const Ez = {
  name: "contrast",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 18a6 6 0 0 0 0-12v12z", key: "j4l70d" }]
  ]
}, Rz = _e(Ez);
const zz = {
  name: "copy",
  size: 24,
  node: [
    ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
    ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
  ]
}, a6 = _e(zz);
const $z = {
  name: "corner-down-left",
  size: 24,
  node: [
    ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }],
    ["path", { d: "m9 10-5 5 5 5", key: "1kshq7" }]
  ]
}, Dz = _e($z);
const Oz = {
  name: "corner-down-right",
  size: 24,
  node: [
    ["path", { d: "m15 10 5 5-5 5", key: "qqa56n" }],
    ["path", { d: "M4 4v7a4 4 0 0 0 4 4h12", key: "z08zvw" }]
  ]
}, Lz = _e(Oz);
const Bz = {
  name: "cpu",
  size: 24,
  node: [
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "M17 20v2", key: "1rnc9c" }],
    ["path", { d: "M17 2v2", key: "11trls" }],
    ["path", { d: "M2 12h2", key: "1t8f8n" }],
    ["path", { d: "M2 17h2", key: "7oei6x" }],
    ["path", { d: "M2 7h2", key: "asdhe0" }],
    ["path", { d: "M20 12h2", key: "1q8mjw" }],
    ["path", { d: "M20 17h2", key: "1fpfkl" }],
    ["path", { d: "M20 7h2", key: "1o8tra" }],
    ["path", { d: "M7 20v2", key: "4gnj0m" }],
    ["path", { d: "M7 2v2", key: "1i4yhu" }],
    ["rect", { x: "4", y: "4", width: "16", height: "16", rx: "2", key: "1vbyd7" }],
    ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "1", key: "z9xiuo" }]
  ]
}, Fz = _e(Bz);
const Nz = {
  name: "crop",
  size: 24,
  node: [
    ["path", { d: "M6 2v14a2 2 0 0 0 2 2h14", key: "ron5a4" }],
    ["path", { d: "M18 22V8a2 2 0 0 0-2-2H2", key: "7s9ehn" }]
  ]
}, Uz = _e(Nz);
const Gz = {
  name: "dice-5",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
    ["path", { d: "M16 8h.01", key: "cr5u4v" }],
    ["path", { d: "M8 8h.01", key: "1e4136" }],
    ["path", { d: "M8 16h.01", key: "18s6g9" }],
    ["path", { d: "M16 16h.01", key: "1f9h7w" }],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }]
  ]
}, jz = _e(Gz);
const Hz = {
  name: "download",
  size: 24,
  node: [
    ["path", { d: "M12 15V3", key: "m9g1x1" }],
    ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
    ["path", { d: "m7 10 5 5 5-5", key: "brsn70" }]
  ]
}, l6 = _e(Hz);
const Vz = {
  name: "droplet",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
        key: "c7niix"
      }
    ]
  ]
}, Wz = _e(Vz);
const qz = {
  name: "ellipsis-vertical",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
    ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
    ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
  ],
  aliases: ["more-vertical"]
}, Kz = _e(qz);
const Yz = {
  name: "ellipsis",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
    ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
    ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
  ],
  aliases: ["more-horizontal"]
}, d6 = _e(Yz);
const Xz = {
  name: "eraser",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M21 21H8a2 2 0 0 1-1.42-.587l-3.994-3.999a2 2 0 0 1 0-2.828l10-10a2 2 0 0 1 2.829 0l5.999 6a2 2 0 0 1 0 2.828L12.834 21",
        key: "g5wo59"
      }
    ],
    ["path", { d: "m5.082 11.09 8.828 8.828", key: "1wx5vj" }]
  ]
}, Jz = _e(Xz);
const Zz = {
  name: "expand",
  size: 24,
  node: [
    ["path", { d: "m15 15 6 6", key: "1s409w" }],
    ["path", { d: "m15 9 6-6", key: "ko1vev" }],
    ["path", { d: "M21 16v5h-5", key: "1ck2sf" }],
    ["path", { d: "M21 8V3h-5", key: "1qoq8a" }],
    ["path", { d: "M3 16v5h5", key: "1t08am" }],
    ["path", { d: "m3 21 6-6", key: "wwnumi" }],
    ["path", { d: "M3 8V3h5", key: "1ln10m" }],
    ["path", { d: "M9 9 3 3", key: "v551iv" }]
  ]
}, Qz = _e(Zz);
const e$ = {
  name: "external-link",
  size: 24,
  node: [
    ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
    ["path", { d: "M10 14 21 3", key: "gplh6r" }],
    ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
  ]
}, c6 = _e(e$);
const t$ = {
  name: "eye-off",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
        key: "ct8e1f"
      }
    ],
    ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
    [
      "path",
      {
        d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
        key: "13bj9a"
      }
    ],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }]
  ]
}, n$ = _e(t$);
const i$ = {
  name: "eye",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
        key: "1nclc0"
      }
    ],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
  ]
}, s$ = _e(i$);
const o$ = {
  name: "face-slightly-smiling-plus",
  size: 24,
  node: [
    ["path", { d: "M13.267 2.08a10 10 0 108.653 8.653", key: "1wbpyh" }],
    ["path", { d: "M15 10V9", key: "4dkmfx" }],
    ["path", { d: "M16 5h6", key: "1vod17" }],
    ["path", { d: "M16.472 15a6 6 0 01-8.943 0", key: "7qomzy" }],
    ["path", { d: "M19 2v6", key: "4bpg5p" }],
    ["path", { d: "M9 10V9", key: "1lazqi" }]
  ],
  aliases: ["smile-plus"]
}, r$ = _e(o$);
const a$ = {
  name: "face-slightly-smiling",
  size: 24,
  node: [
    ["path", { d: "M15 10V9", key: "4dkmfx" }],
    ["path", { d: "M16.472 15a6 6 0 01-8.943 0", key: "7qomzy" }],
    ["path", { d: "M9 10V9", key: "1lazqi" }],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
  ],
  aliases: ["smile"]
}, l$ = _e(a$);
const d$ = {
  name: "file-box",
  size: 24,
  node: [
    ["path", { d: "M14 2v5a1 1 0 001 1h5", key: "9v5fu7" }],
    [
      "path",
      {
        d: "M14.692 22H18a2 2 0 002-2V8a2.4 2.4 0 00-.706-1.706l-3.588-3.588A2.4 2.4 0 0014 2H6a2 2 0 00-2 2v3.804",
        key: "1ne0j7"
      }
    ],
    ["path", { d: "M2.264 13.752 7 16.5l4.737-2.748", key: "t73mg3" }],
    [
      "path",
      {
        d: "M2.995 13.014A2 2 0 002 14.744v3.516a2 2 0 00.996 1.73l3 1.74a2 2 0 002.008 0l3-1.74A2 2 0 0012 18.26v-3.517a2 2 0 00-.995-1.73l-3-1.742a2 2 0 00-1.892-.064z",
        key: "h4qck"
      }
    ],
    ["path", { d: "M7 16.5V22", key: "1i1gou" }]
  ]
}, c$ = _e(d$);
const u$ = {
  name: "film",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M7 3v18", key: "bbkbws" }],
    ["path", { d: "M3 7.5h4", key: "zfgn84" }],
    ["path", { d: "M3 12h18", key: "1i2n21" }],
    ["path", { d: "M3 16.5h4", key: "1230mu" }],
    ["path", { d: "M17 3v18", key: "in4fa5" }],
    ["path", { d: "M17 7.5h4", key: "myr1c1" }],
    ["path", { d: "M17 16.5h4", key: "go4c1d" }]
  ]
}, h$ = _e(u$);
const p$ = {
  name: "flag",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528",
        key: "1jaruq"
      }
    ]
  ]
}, f$ = _e(p$);
const m$ = {
  name: "focus",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
  ]
}, g$ = _e(m$);
const b$ = {
  name: "folder-open",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
        key: "usdka0"
      }
    ]
  ]
}, v$ = _e(b$);
const y$ = {
  name: "frame",
  size: 24,
  node: [
    ["line", { x1: "22", x2: "2", y1: "6", y2: "6", key: "15w7dq" }],
    ["line", { x1: "22", x2: "2", y1: "18", y2: "18", key: "1ip48p" }],
    ["line", { x1: "6", x2: "6", y1: "2", y2: "22", key: "a2lnyx" }],
    ["line", { x1: "18", x2: "18", y1: "2", y2: "22", key: "8vb6jd" }]
  ]
}, u6 = _e(y$);
const x$ = {
  name: "gauge",
  size: 24,
  node: [
    ["path", { d: "m12 14 4-4", key: "9kzdfg" }],
    ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0", key: "19p75a" }]
  ]
}, w$ = _e(x$);
const k$ = {
  name: "globe",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
    ["path", { d: "M2 12h20", key: "9i4pu4" }]
  ]
}, h6 = _e(k$);
const _$ = {
  name: "grid-3x3",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M3 9h18", key: "1pudct" }],
    ["path", { d: "M3 15h18", key: "5xshup" }],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }]
  ],
  aliases: ["grid", "grid-3-x-3"]
}, S$ = _e(_$);
const M$ = {
  name: "group",
  size: 24,
  node: [
    ["path", { d: "M3 7V5c0-1.1.9-2 2-2h2", key: "adw53z" }],
    ["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2", key: "an4l38" }],
    ["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2", key: "144t0e" }],
    ["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2", key: "rtnfgi" }],
    ["rect", { width: "7", height: "5", x: "7", y: "7", rx: "1", key: "1eyiv7" }],
    ["rect", { width: "7", height: "5", x: "10", y: "12", rx: "1", key: "1qlmkx" }]
  ]
}, T$ = _e(M$);
const C$ = {
  name: "hand",
  size: 24,
  node: [
    ["path", { d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1fvzgz" }],
    ["path", { d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "1kc0my" }],
    ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8", key: "10h0bg" }],
    [
      "path",
      {
        d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
        key: "1s1gnw"
      }
    ]
  ]
}, p6 = _e(C$);
const I$ = {
  name: "heart",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
        key: "mvr1a0"
      }
    ]
  ]
}, f6 = _e(I$);
const A$ = {
  name: "image-off",
  size: 24,
  node: [
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
    ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
    ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
    ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
    [
      "path",
      {
        d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
        key: "mmje98"
      }
    ],
    ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
  ]
}, P$ = _e(A$);
const E$ = {
  name: "image-plus",
  size: 24,
  node: [
    ["path", { d: "M16 5h6", key: "1vod17" }],
    ["path", { d: "M19 2v6", key: "4bpg5p" }],
    ["path", { d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5", key: "1ue2ih" }],
    ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }],
    ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
  ]
}, m6 = _e(E$);
const R$ = {
  name: "image",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
    ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
    ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
  ]
}, g6 = _e(R$);
const z$ = {
  name: "images",
  size: 24,
  node: [
    ["path", { d: "m22 11-1.296-1.296a2.4 2.4 0 0 0-3.408 0L11 16", key: "9kzy35" }],
    ["path", { d: "M4 8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2", key: "1t0f0t" }],
    ["circle", { cx: "13", cy: "7", r: "1", fill: "currentColor", key: "1obus6" }],
    ["rect", { x: "8", y: "2", width: "14", height: "14", rx: "2", key: "1gvhby" }]
  ]
}, $$ = _e(z$);
const D$ = {
  name: "inbox",
  size: 24,
  node: [
    ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
    [
      "path",
      {
        d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
        key: "oot6mr"
      }
    ]
  ]
}, O$ = _e(D$);
const L$ = {
  name: "info",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 16v-4", key: "1dtifu" }],
    ["path", { d: "M12 8h.01", key: "e9boi3" }]
  ]
}, B$ = _e(L$);
const F$ = {
  name: "keyboard",
  size: 24,
  node: [
    ["path", { d: "M10 8h.01", key: "1r9ogq" }],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }],
    ["path", { d: "M14 8h.01", key: "1primd" }],
    ["path", { d: "M16 12h.01", key: "1l6xoz" }],
    ["path", { d: "M18 8h.01", key: "emo2bl" }],
    ["path", { d: "M6 8h.01", key: "x9i8wu" }],
    ["path", { d: "M7 16h10", key: "wp8him" }],
    ["path", { d: "M8 12h.01", key: "czm47f" }],
    ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }]
  ]
}, N$ = _e(F$);
const U$ = {
  name: "lamp",
  size: 24,
  node: [
    ["path", { d: "M12 12v6", key: "3ahymv" }],
    [
      "path",
      {
        d: "M4.077 10.615A1 1 0 0 0 5 12h14a1 1 0 0 0 .923-1.385l-3.077-7.384A2 2 0 0 0 15 2H9a2 2 0 0 0-1.846 1.23Z",
        key: "1l7kg2"
      }
    ],
    [
      "path",
      { d: "M8 20a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1z", key: "1mmzpi" }
    ]
  ]
}, G$ = _e(U$);
const j$ = {
  name: "lasso-select",
  size: 24,
  node: [
    ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
    ["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91", key: "ybbtv3" }],
    [
      "path",
      {
        d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
        key: "gt5e1w"
      }
    ],
    ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }],
    [
      "path",
      {
        d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14z",
        key: "72q637"
      }
    ]
  ]
}, H$ = _e(j$);
const V$ = {
  name: "layers",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
        key: "zw3jo"
      }
    ],
    [
      "path",
      {
        d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
        key: "1wduqc"
      }
    ],
    [
      "path",
      {
        d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
        key: "kqbvx6"
      }
    ]
  ],
  aliases: ["layers-3"]
}, W$ = _e(V$);
const q$ = {
  name: "layout-dashboard",
  size: 24,
  node: [
    ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" }],
    ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" }],
    ["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" }],
    ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" }]
  ]
}, K$ = _e(q$);
const Y$ = {
  name: "layout-grid",
  size: 24,
  node: [
    ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
    ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
    ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
    ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
  ]
}, b6 = _e(Y$);
const X$ = {
  name: "layout-template",
  size: 24,
  node: [
    ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
    ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }],
    ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }]
  ]
}, v6 = _e(X$);
const J$ = {
  name: "leaf",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M11 20a10 10 0 0010-10 25.9 25.9 0 00-1.04-7.281 1 1 0 00-1.755-.325C15.833 5.5 13 5.5 9.8 6.1A7 7 0 0011 20",
        key: "1wjnjv"
      }
    ],
    ["path", { d: "M2 21a5 5 0 012.911-4.544C7.613 15.212 8.351 15.24 11 13", key: "c1ejpn" }]
  ]
}, Z$ = _e(J$);
const Q$ = {
  name: "library",
  size: 24,
  node: [
    ["path", { d: "m16 6 4 14", key: "ji33uf" }],
    ["path", { d: "M12 6v14", key: "1n7gus" }],
    ["path", { d: "M8 8v12", key: "1gg7y9" }],
    ["path", { d: "M4 4v16", key: "6qkkli" }]
  ]
}, e7 = _e(Q$);
const t7 = {
  name: "lightbulb",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
        key: "1gvzjb"
      }
    ],
    ["path", { d: "M9 18h6", key: "x1upvd" }],
    ["path", { d: "M10 22h4", key: "ceow96" }]
  ]
}, n7 = _e(t7);
const i7 = {
  name: "link",
  size: 24,
  node: [
    ["path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", key: "1cjeqo" }],
    ["path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71", key: "19qd67" }]
  ]
}, s7 = _e(i7);
const o7 = {
  name: "link-2",
  size: 24,
  node: [
    ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
    ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
    ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
  ]
}, r7 = _e(o7);
const a7 = {
  name: "loader-circle",
  size: 24,
  node: [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]],
  aliases: ["loader-2"]
}, y6 = _e(a7);
const l7 = {
  name: "locate-fixed",
  size: 24,
  node: [
    ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
    ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
    ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
    ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
    ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
  ]
}, d7 = _e(l7);
const c7 = {
  name: "lock-open",
  size: 24,
  node: [
    ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
    ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }]
  ],
  aliases: ["unlock"]
}, u7 = _e(c7);
const h7 = {
  name: "lock",
  size: 24,
  node: [
    ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
    ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
  ]
}, x6 = _e(h7);
const p7 = {
  name: "log-out",
  size: 24,
  node: [
    ["path", { d: "m16 17 5-5-5-5", key: "1bji2h" }],
    ["path", { d: "M21 12H9", key: "dn1m92" }],
    ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }]
  ]
}, f7 = _e(p7);
const m7 = {
  name: "map-pin",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
        key: "1r0f0z"
      }
    ],
    ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
  ]
}, g7 = _e(m7);
const b7 = {
  name: "map",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
        key: "169xi5"
      }
    ],
    ["path", { d: "M15 5.764v15", key: "1pn4in" }],
    ["path", { d: "M9 3.236v15", key: "1uimfh" }]
  ]
}, v7 = _e(b7);
const y7 = {
  name: "maximize-2",
  size: 24,
  node: [
    ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
    ["path", { d: "m21 3-7 7", key: "1l2asr" }],
    ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
    ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
  ]
}, w6 = _e(y7);
const x7 = {
  name: "message-circle-plus",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        key: "1sd12s"
      }
    ],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
    ["path", { d: "M12 8v8", key: "napkw2" }]
  ]
}, w7 = _e(x7);
const k7 = {
  name: "message-circle",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
        key: "1sd12s"
      }
    ]
  ]
}, _7 = _e(k7);
const S7 = {
  name: "message-square-dot",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M12.7 3H4a2 2 0 0 0-2 2v16.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H20a2 2 0 0 0 2-2v-4.7",
        key: "wjb7ig"
      }
    ],
    ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }]
  ]
}, M7 = _e(S7);
const T7 = {
  name: "message-square-plus",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        key: "18887p"
      }
    ],
    ["path", { d: "M12 8v6", key: "1ib9pf" }],
    ["path", { d: "M9 11h6", key: "1fldmi" }]
  ]
}, C7 = _e(T7);
const I7 = {
  name: "message-square-warning",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        key: "18887p"
      }
    ],
    ["path", { d: "M12 15h.01", key: "q59x07" }],
    ["path", { d: "M12 7v4", key: "xawao1" }]
  ]
}, A7 = _e(I7);
const P7 = {
  name: "message-square",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
        key: "18887p"
      }
    ]
  ]
}, E7 = _e(P7);
const R7 = {
  name: "messages-square",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M16 10a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 14.286V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z",
        key: "1n2ejm"
      }
    ],
    [
      "path",
      {
        d: "M20 9a2 2 0 0 1 2 2v10.286a.71.71 0 0 1-1.212.502l-2.202-2.202A2 2 0 0 0 17.172 19H10a2 2 0 0 1-2-2v-1",
        key: "1qfcsi"
      }
    ]
  ]
}, z7 = _e(R7);
const $7 = {
  name: "minimize-2",
  size: 24,
  node: [
    ["path", { d: "m14 10 7-7", key: "oa77jy" }],
    ["path", { d: "M20 10h-6V4", key: "mjg0md" }],
    ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
    ["path", { d: "M4 14h6v6", key: "rmj7iw" }]
  ]
}, D7 = _e($7);
const O7 = {
  name: "minus",
  size: 24,
  node: [["path", { d: "M5 12h14", key: "1ays0h" }]]
}, k6 = _e(O7);
const L7 = {
  name: "moon",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
        key: "kfwtm"
      }
    ]
  ]
}, B7 = _e(L7);
const F7 = {
  name: "mountain",
  size: 24,
  node: [["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }]]
}, N7 = _e(F7);
const U7 = {
  name: "mouse-pointer-2",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
        key: "edeuup"
      }
    ]
  ]
}, _6 = _e(U7);
const G7 = {
  name: "mouse-pointer-click",
  size: 24,
  node: [
    ["path", { d: "M14 4.1 12 6", key: "ita8i4" }],
    ["path", { d: "m5.1 8-2.9-.8", key: "1go3kf" }],
    ["path", { d: "m6 12-1.9 2", key: "mnht97" }],
    ["path", { d: "M7.2 2.2 8 5.1", key: "1cfko1" }],
    [
      "path",
      {
        d: "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z",
        key: "s0h3yz"
      }
    ]
  ]
}, j7 = _e(G7);
const H7 = {
  name: "move",
  size: 24,
  node: [
    ["path", { d: "M12 2v20", key: "t6zp3m" }],
    ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
    ["path", { d: "m19 9 3 3-3 3", key: "1mg7y2" }],
    ["path", { d: "M2 12h20", key: "9i4pu4" }],
    ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }],
    ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
  ]
}, V7 = _e(H7);
const W7 = {
  name: "orbit",
  size: 24,
  node: [
    ["path", { d: "M20.341 6.484A10 10 0 0 1 10.266 21.85", key: "1enhxb" }],
    ["path", { d: "M3.659 17.516A10 10 0 0 1 13.74 2.152", key: "1crzgf" }],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
    ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }]
  ]
}, q7 = _e(W7);
const K7 = {
  name: "paint-bucket",
  size: 24,
  node: [
    ["path", { d: "M11 7 6 2", key: "1jwth8" }],
    ["path", { d: "M18.992 12H2.041", key: "xw1gg" }],
    [
      "path",
      {
        d: "M21.145 18.38A3.34 3.34 0 0 1 20 16.5a3.3 3.3 0 0 1-1.145 1.88c-.575.46-.855 1.02-.855 1.595A2 2 0 0 0 20 22a2 2 0 0 0 2-2.025c0-.58-.285-1.13-.855-1.595",
        key: "1nkol4"
      }
    ],
    [
      "path",
      {
        d: "m8.5 4.5 2.148-2.148a1.205 1.205 0 0 1 1.704 0l7.296 7.296a1.205 1.205 0 0 1 0 1.704l-7.592 7.592a3.615 3.615 0 0 1-5.112 0l-3.888-3.888a3.615 3.615 0 0 1 0-5.112L5.67 7.33",
        key: "1nk1rd"
      }
    ]
  ]
}, Y7 = _e(K7);
const X7 = {
  name: "paintbrush",
  size: 24,
  node: [
    ["path", { d: "m14.622 17.897-10.68-2.913", key: "vj2p1u" }],
    [
      "path",
      {
        d: "M18.376 2.622a1 1 0 1 1 3.002 3.002L17.36 9.643a.5.5 0 0 0 0 .707l.944.944a2.41 2.41 0 0 1 0 3.408l-.944.944a.5.5 0 0 1-.707 0L8.354 7.348a.5.5 0 0 1 0-.707l.944-.944a2.41 2.41 0 0 1 3.408 0l.944.944a.5.5 0 0 0 .707 0z",
        key: "18tc5c"
      }
    ],
    [
      "path",
      {
        d: "M9 8c-1.804 2.71-3.97 3.46-6.583 3.948a.507.507 0 0 0-.302.819l7.32 8.883a1 1 0 0 0 1.185.204C12.735 20.405 16 16.792 16 15",
        key: "ytzfxy"
      }
    ]
  ]
}, J7 = _e(X7);
const Z7 = {
  name: "palette",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
        key: "e79jfc"
      }
    ],
    ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
    ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
    ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
    ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }]
  ]
}, Q7 = _e(Z7);
const eD = {
  name: "panel-left",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M9 3v18", key: "fh3hqa" }]
  ],
  aliases: ["sidebar"]
}, tD = _e(eD);
const nD = {
  name: "panel-right-close",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }],
    ["path", { d: "m8 9 3 3-3 3", key: "12hl5m" }]
  ]
}, iD = _e(nD);
const sD = {
  name: "panel-right-open",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }],
    ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }]
  ]
}, oD = _e(sD);
const rD = {
  name: "pause",
  size: 24,
  node: [
    ["rect", { x: "14", y: "3", width: "5", height: "18", rx: "1", key: "kaeet6" }],
    ["rect", { x: "5", y: "3", width: "5", height: "18", rx: "1", key: "1wsw3u" }]
  ]
}, aD = _e(rD);
const lD = {
  name: "pencil",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
        key: "1a8usu"
      }
    ],
    ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
  ]
}, S6 = _e(lD);
const dD = {
  name: "pin-off",
  size: 24,
  node: [
    ["path", { d: "M12 17v5", key: "bb1du9" }],
    ["path", { d: "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89", key: "znwnzq" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    [
      "path",
      {
        d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11",
        key: "c9qhm2"
      }
    ]
  ]
}, cD = _e(dD);
const uD = {
  name: "pin",
  size: 24,
  node: [
    ["path", { d: "M12 17v5", key: "bb1du9" }],
    [
      "path",
      {
        d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
        key: "1nkz8b"
      }
    ]
  ]
}, hD = _e(uD);
const pD = {
  name: "pipette",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12",
        key: "1y3wsu"
      }
    ],
    [
      "path",
      {
        d: "m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z",
        key: "110lr1"
      }
    ],
    ["path", { d: "m2 22 .414-.414", key: "jhxm08" }]
  ]
}, M6 = _e(pD);
const fD = {
  name: "plane",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
        key: "1v9wt8"
      }
    ]
  ]
}, mD = _e(fD);
const gD = {
  name: "play",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
        key: "10ikf1"
      }
    ]
  ]
}, T6 = _e(gD);
const bD = {
  name: "plus",
  size: 24,
  node: [
    ["path", { d: "M5 12h14", key: "1ays0h" }],
    ["path", { d: "M12 5v14", key: "s699le" }]
  ]
}, C6 = _e(bD);
const vD = {
  name: "proportions",
  size: 24,
  node: [
    ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
    ["path", { d: "M12 9v11", key: "1fnkrn" }],
    ["path", { d: "M2 9h13a2 2 0 0 1 2 2v9", key: "11z3ex" }]
  ]
}, yD = _e(vD);
const xD = {
  name: "rainbow",
  size: 24,
  node: [
    ["path", { d: "M22 17a10 10 0 0 0-20 0", key: "ozegv" }],
    ["path", { d: "M6 17a6 6 0 0 1 12 0", key: "5giftw" }],
    ["path", { d: "M10 17a2 2 0 0 1 4 0", key: "gnsikk" }]
  ]
}, wD = _e(xD);
const kD = {
  name: "rectangle-vertical",
  size: 24,
  node: [["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }]]
}, I6 = _e(kD);
const _D = {
  name: "rectangle-horizontal",
  size: 24,
  node: [["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]]
}, SD = _e(_D);
const MD = {
  name: "redo-2",
  size: 24,
  node: [
    ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
    ["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13", key: "6uklza" }]
  ]
}, TD = _e(MD);
const CD = {
  name: "refresh-cw",
  size: 24,
  node: [
    ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
    ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
    ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
    ["path", { d: "M8 16H3v5", key: "1cv678" }]
  ]
}, ID = _e(CD);
const AD = {
  name: "repeat",
  size: 24,
  node: [
    ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
    ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
    ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
    ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }]
  ]
}, PD = _e(AD);
const ED = {
  name: "replace",
  size: 24,
  node: [
    ["path", { d: "M14 4a1 1 0 0 1 1-1", key: "dhj8ez" }],
    ["path", { d: "M15 10a1 1 0 0 1-1-1", key: "1mnyi5" }],
    ["path", { d: "M21 4a1 1 0 0 0-1-1", key: "sfs9ap" }],
    ["path", { d: "M21 9a1 1 0 0 1-1 1", key: "mp6qeo" }],
    ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
    ["path", { d: "M6 10V5a2 2 0 0 1 2-2h2", key: "15xut4" }],
    ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1", key: "1bkyp8" }]
  ]
}, RD = _e(ED);
const zD = {
  name: "rotate-3d",
  size: 24,
  node: [
    ["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814", key: "16shm9" }],
    ["path", { d: "M16.47214 7.52786 A 5 10 0 1 0 13 21.79796", key: "1245p8" }],
    ["path", { d: "M21.79796 11 A 10 5 0 1 0 19 15.57071", key: "1i40ks" }]
  ],
  aliases: ["rotate-3-d"]
}, $D = _e(zD);
const DD = {
  name: "rotate-ccw-clock",
  size: 24,
  node: [
    ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
    ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
    ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
  ],
  aliases: ["history"]
}, OD = _e(DD);
const LD = {
  name: "rotate-ccw",
  size: 24,
  node: [
    ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
    ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
  ]
}, BD = _e(LD);
const FD = {
  name: "rotate-cw",
  size: 24,
  node: [
    ["path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8", key: "1p45f6" }],
    ["path", { d: "M21 3v5h-5", key: "1q7to0" }]
  ]
}, ND = _e(FD);
const UD = {
  name: "route",
  size: 24,
  node: [
    ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
    ["path", { d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15", key: "1d8sl" }],
    ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
  ]
}, GD = _e(UD);
const jD = {
  name: "rows-3",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "M21 9H3", key: "1338ky" }],
    ["path", { d: "M21 15H3", key: "9uk58r" }]
  ],
  aliases: ["panels-top-bottom"]
}, HD = _e(jD);
const VD = {
  name: "scan-face",
  size: 24,
  node: [
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
    ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
    ["path", { d: "M9 9h.01", key: "1q5me6" }],
    ["path", { d: "M15 9h.01", key: "x1ddxp" }]
  ]
}, WD = _e(VD);
const qD = {
  name: "scan",
  size: 24,
  node: [
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
  ]
}, KD = _e(qD);
const YD = {
  name: "search",
  size: 24,
  node: [
    ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
  ]
}, A6 = _e(YD);
const XD = {
  name: "send",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
        key: "1ffxy3"
      }
    ],
    ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
  ]
}, JD = _e(XD);
const ZD = {
  name: "send-to-back",
  size: 24,
  node: [
    ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
    ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }],
    ["path", { d: "M7 14v1a2 2 0 0 0 2 2h1", key: "pao6x6" }],
    ["path", { d: "M14 7h1a2 2 0 0 1 2 2v1", key: "19tdru" }]
  ]
}, QD = _e(ZD);
const eO = {
  name: "settings-2",
  size: 24,
  node: [
    ["path", { d: "M14 17H5", key: "gfn3mx" }],
    ["path", { d: "M19 7h-9", key: "6i9tg" }],
    ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
    ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }]
  ]
}, tO = _e(eO);
const nO = {
  name: "settings",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
        key: "1i5ecw"
      }
    ],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
  ]
}, P6 = _e(nO);
const iO = {
  name: "share-2",
  size: 24,
  node: [
    ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
    ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
    ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
    ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
    ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
  ]
}, sO = _e(iO);
const oO = {
  name: "shield-check",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        key: "oel41y"
      }
    ],
    ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
  ]
}, rO = _e(oO);
const aO = {
  name: "slash",
  size: 24,
  node: [["path", { d: "M22 2 2 22", key: "y4kqgn" }]]
}, lO = _e(aO);
const dO = {
  name: "sliders-horizontal",
  size: 24,
  node: [
    ["path", { d: "M10 5H3", key: "1qgfaw" }],
    ["path", { d: "M12 19H3", key: "yhmn1j" }],
    ["path", { d: "M14 3v4", key: "1sua03" }],
    ["path", { d: "M16 17v4", key: "1q0r14" }],
    ["path", { d: "M21 12h-9", key: "1o4lsq" }],
    ["path", { d: "M21 19h-5", key: "1rlt1p" }],
    ["path", { d: "M21 5h-7", key: "1oszz2" }],
    ["path", { d: "M8 10v4", key: "tgpxqk" }],
    ["path", { d: "M8 12H3", key: "a7s4jb" }]
  ]
}, E6 = _e(dO);
const cO = {
  name: "sofa",
  size: 24,
  node: [
    ["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3", key: "1dgpiv" }],
    [
      "path",
      {
        d: "M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
        key: "xacw8m"
      }
    ],
    ["path", { d: "M4 18v2", key: "jwo5n2" }],
    ["path", { d: "M20 18v2", key: "1ar1qi" }],
    ["path", { d: "M12 4v9", key: "oqhhn3" }]
  ]
}, uO = _e(cO);
const hO = {
  name: "sparkle",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
        key: "1s2grr"
      }
    ]
  ]
}, pO = _e(hO);
const fO = {
  name: "sparkles",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
        key: "1s2grr"
      }
    ],
    ["path", { d: "M20 2v4", key: "1rf3ol" }],
    ["path", { d: "M22 4h-4", key: "gwowj6" }],
    ["circle", { cx: "4", cy: "20", r: "2", key: "6kqj1y" }]
  ],
  aliases: ["stars"]
}, yv = _e(fO);
const mO = {
  name: "spotlight",
  size: 24,
  node: [
    ["path", { d: "M15.295 19.562 16 22", key: "31jsb7" }],
    ["path", { d: "m17 16 3.758 2.098", key: "121ar7" }],
    ["path", { d: "m19 12.5 3.026-.598", key: "19ukd3" }],
    [
      "path",
      {
        d: "M7.61 6.3a3 3 0 0 0-3.92 1.3l-1.38 2.79a3 3 0 0 0 1.3 3.91l6.89 3.597a1 1 0 0 0 1.342-.447l3.106-6.211a1 1 0 0 0-.447-1.341z",
        key: "lwb9l9"
      }
    ],
    ["path", { d: "M8 9V2", key: "1xa0v7" }]
  ]
}, gO = _e(mO);
const bO = {
  name: "square-check",
  size: 24,
  node: [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
    ["path", { d: "m16 9-5.5 5.5L8 12", key: "xofnsj" }]
  ],
  aliases: ["check-square-2"]
}, vO = _e(bO);
const yO = {
  name: "square-dashed",
  size: 24,
  node: [
    ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
    ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
    ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
    ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
    ["path", { d: "M9 3h1", key: "1yesri" }],
    ["path", { d: "M9 21h1", key: "15o7lz" }],
    ["path", { d: "M14 3h1", key: "1ec4yj" }],
    ["path", { d: "M14 21h1", key: "v9vybs" }],
    ["path", { d: "M3 9v1", key: "1r0deq" }],
    ["path", { d: "M21 9v1", key: "mxsmne" }],
    ["path", { d: "M3 14v1", key: "vnatye" }],
    ["path", { d: "M21 14v1", key: "169vum" }]
  ],
  aliases: ["box-select"]
}, xO = _e(yO);
const wO = {
  name: "square",
  size: 24,
  node: [["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]]
}, R6 = _e(wO);
const kO = {
  name: "sticky-note",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M21 9a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z",
        key: "1dfntj"
      }
    ],
    ["path", { d: "M15 3v5a1 1 0 0 0 1 1h5", key: "6s6qgf" }]
  ]
}, z6 = _e(kO);
const _O = {
  name: "sun",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
    ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
    ["path", { d: "M2 12h2", key: "1t8f8n" }],
    ["path", { d: "M20 12h2", key: "1q8mjw" }],
    ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
    ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
  ]
}, SO = _e(_O);
const MO = {
  name: "swatch-book",
  size: 24,
  node: [
    ["path", { d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z", key: "1ldrpk" }],
    ["path", { d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7", key: "11i5po" }],
    ["path", { d: "M 7 17h.01", key: "1euzgo" }],
    [
      "path",
      {
        d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8",
        key: "o2gii7"
      }
    ]
  ]
}, TO = _e(MO);
const CO = {
  name: "table-2",
  size: 24,
  node: [
    ["path", { d: "M3 9h18", key: "1pudct" }],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
  ]
}, IO = _e(CO);
const AO = {
  name: "thermometer",
  size: 24,
  node: [["path", { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "17jzev" }]]
}, PO = _e(AO);
const EO = {
  name: "trash",
  size: 24,
  node: [
    ["path", { d: "M10 11v6", key: "nco0om" }],
    ["path", { d: "M14 11v6", key: "outv1u" }],
    ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", key: "miytrc" }],
    ["path", { d: "M3 6h18", key: "d0wm0j" }],
    ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", key: "e791ji" }]
  ],
  aliases: ["trash-2"]
}, $6 = _e(EO);
const RO = {
  name: "trees",
  size: 24,
  node: [
    [
      "path",
      { d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z", key: "1l6gj6" }
    ],
    ["path", { d: "M7 16v6", key: "1a82de" }],
    ["path", { d: "M13 19v3", key: "13sx9i" }],
    [
      "path",
      {
        d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
        key: "1sj9kv"
      }
    ]
  ]
}, zO = _e(RO);
const $O = {
  name: "triangles-centerline-dashed-horizontal",
  size: 24,
  node: [
    ["path", { d: "M10 12H8", key: "s88cx1" }],
    ["path", { d: "M16 12h-2", key: "10asgb" }],
    ["path", { d: "M22 12h-2", key: "14jgyd" }],
    ["path", { d: "M4 12H2", key: "rhcxmi" }],
    [
      "path",
      {
        d: "M7.298 20.288A1 1 0 008 22h8a1 1 0 00.703-1.712l-3.991-3.99a1 1 0 00-1.424-.001z",
        key: "15ue1v"
      }
    ],
    [
      "path",
      {
        d: "M7.298 3.712A1 1 0 018 2h8a1 1 0 01.703 1.712l-3.991 3.99a1 1 0 01-1.424.001z",
        key: "lzh03e"
      }
    ]
  ],
  aliases: ["flip-horizontal-2"]
}, DO = _e($O);
const OO = {
  name: "triangles-centerline-dashed-vertical",
  size: 24,
  node: [
    ["path", { d: "M12 14v2", key: "8jcxud" }],
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "M12 8v2", key: "1woqiv" }],
    [
      "path",
      {
        d: "M20.288 16.703A1 1 0 0022 16V8a1 1 0 00-1.712-.703l-3.99 3.991a1 1 0 00-.001 1.424z",
        key: "1ewq2t"
      }
    ],
    [
      "path",
      {
        d: "M3.712 16.703A1 1 0 012 16V8a1 1 0 011.712-.703l3.99 3.991a1 1 0 01.001 1.424z",
        key: "1c1klx"
      }
    ]
  ],
  aliases: ["flip-vertical-2"]
}, LO = _e(OO);
const BO = {
  name: "trophy",
  size: 24,
  node: [
    ["path", { d: "M10 14.66V17a1 1 0 0 1-1 1 2 2 0 0 0-2 2v2", key: "pwuv1l" }],
    ["path", { d: "M14 14.66V17a1 1 0 0 0 1 1 2 2 0 0 1 2 2v2", key: "1y54w1" }],
    ["path", { d: "M17.916 10H19.5A2.5 2.5 0 0 0 22 7.5V5a1 1 0 0 0-1-1h-3", key: "e30mpu" }],
    ["path", { d: "M4 22h16", key: "57wxv0" }],
    ["path", { d: "M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z", key: "1mhfuq" }],
    ["path", { d: "M6.084 10H4.5A2.5 2.5 0 0 1 2 7.5V5a1 1 0 0 1 1-1h3", key: "i0yafy" }]
  ]
}, FO = _e(BO);
const NO = {
  name: "type",
  size: 24,
  node: [
    ["path", { d: "M12 4v16", key: "1654pz" }],
    ["path", { d: "M4 7V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2", key: "e0r10z" }],
    ["path", { d: "M9 20h6", key: "s66wpe" }]
  ]
}, UO = _e(NO);
const GO = {
  name: "undo-2",
  size: 24,
  node: [
    ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
    ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
  ]
}, jO = _e(GO);
const HO = {
  name: "upload",
  size: 24,
  node: [
    ["path", { d: "M12 3v12", key: "1x0j5s" }],
    ["path", { d: "m17 8-5-5-5 5", key: "7q97r8" }],
    ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }]
  ]
}, VO = _e(HO);
const WO = {
  name: "user-check",
  size: 24,
  node: [
    ["path", { d: "m16 11 2 2 4-4", key: "9rsbq5" }],
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }]
  ]
}, qO = _e(WO);
const KO = {
  name: "user-plus",
  size: 24,
  node: [
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
    ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
    ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
  ]
}, D6 = _e(KO);
const YO = {
  name: "user-round-cog",
  size: 24,
  node: [
    ["path", { d: "m14.305 19.53.923-.382", key: "3m78fa" }],
    ["path", { d: "m15.228 16.852-.923-.383", key: "npixar" }],
    ["path", { d: "m16.852 15.228-.383-.923", key: "5xggr7" }],
    ["path", { d: "m16.852 20.772-.383.924", key: "dpfhf9" }],
    ["path", { d: "m19.148 15.228.383-.923", key: "1reyyz" }],
    ["path", { d: "m19.53 21.696-.382-.924", key: "1goivc" }],
    ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
    ["path", { d: "m20.772 16.852.924-.383", key: "htqkph" }],
    ["path", { d: "m20.772 19.148.924.383", key: "9w9pjp" }],
    ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
    ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
  ],
  aliases: ["user-cog-2"]
}, XO = _e(YO);
const JO = {
  name: "user-round",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
    ["path", { d: "M20 21a8 8 0 0 0-16 0", key: "rfgkzh" }]
  ],
  aliases: ["user-2"]
}, ZO = _e(JO);
const QO = {
  name: "users",
  size: 24,
  node: [
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["path", { d: "M16 3.128a4 4 0 0 1 0 7.744", key: "16gr8j" }],
    ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }]
  ]
}, O6 = _e(QO);
const eL = {
  name: "video",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
        key: "ftymec"
      }
    ],
    ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
  ]
}, L6 = _e(eL);
const tL = {
  name: "wand-sparkles",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
        key: "ul74o6"
      }
    ],
    ["path", { d: "m14 7 3 3", key: "1r5n42" }],
    ["path", { d: "M5 6v4", key: "ilb8ba" }],
    ["path", { d: "M19 14v4", key: "blhpug" }],
    ["path", { d: "M10 2v2", key: "7u0qdc" }],
    ["path", { d: "M7 8H3", key: "zfb6yr" }],
    ["path", { d: "M21 16h-4", key: "1cnmox" }],
    ["path", { d: "M11 3H9", key: "1obp7u" }]
  ],
  aliases: ["wand-2"]
}, B6 = _e(tL);
const nL = {
  name: "x",
  size: 24,
  node: [
    ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
    ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
  ]
}, F6 = _e(nL);
const iL = {
  name: "zoom-in",
  size: 24,
  node: [
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
    ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
    ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
    ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
  ]
}, sL = _e(iL);
const oL = {
  name: "zoom-out",
  size: 24,
  node: [
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
    ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
    ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
  ]
}, rL = _e(oL), aL = [
  "M7.61988 8.70002C9.40944 8.70002 10.8599 7.97426 10.8599 7.08002C10.8599 6.18578 9.40944 5.46002 7.61988 5.46002C5.83032 5.46002 4.37988 6.18578 4.37988 7.08002C4.37988 7.97426 5.83032 8.70002 7.61988 8.70002Z",
  "M4.37988 7.08002V9.24002C4.37988 10.1343 5.83032 10.86 7.61988 10.86C9.40944 10.86 10.8599 10.1343 10.8599 9.24002V7.08002",
  "M4.37989 4.38001C6.16945 4.38001 7.61989 3.65425 7.61989 2.76001C7.61989 1.86577 6.16945 1.14001 4.37989 1.14001C2.59033 1.14001 1.13989 1.86577 1.13989 2.76001C1.13989 3.65425 2.59033 4.38001 4.37989 4.38001Z",
  "M1.13989 2.76001V8.16001C1.13989 8.63953 1.55677 9.07045 2.21989 9.36745",
  "M1.13989 5.46002C1.13989 5.93954 1.55677 6.37046 2.21989 6.66746"
], N6 = (i) => Al(
  "svg",
  { width: i.size || 16, height: i.size || 16, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
  aL.map((e) => Al("path", { d: e, stroke: "currentColor", "stroke-width": 1.2, "stroke-linecap": "round", "stroke-linejoin": "round" }))
);
N6.props = ["size"];
const $ = /* @__PURE__ */ Pe({
  __name: "Icon",
  props: {
    name: {},
    size: { default: 16 },
    stroke: { default: 2 },
    spin: { type: Boolean, default: !1 }
  },
  setup(i) {
    const e = {
      MousePointer2: _6,
      Hand: p6,
      Image: g6,
      StickyNote: z6,
      Frame: u6,
      ChevronDown: n6,
      ChevronUp: ZR,
      ChevronRight: s6,
      ChevronLeft: i6,
      X: F6,
      Square: R6,
      Circle: mz,
      Slash: lO,
      ArrowUpRight: Q5,
      ArrowRight: Z5,
      Check: t6,
      Search: A6,
      Plus: C6,
      Minus: k6,
      Scan: KD,
      Sun: SO,
      Moon: B7,
      Map: v7,
      PanelRightOpen: oD,
      PanelRightClose: iD,
      Trash2: $6,
      Play: T6,
      Heart: f6,
      Link2: r7,
      Info: B$,
      Wand2: B6,
      AlignStartVertical: aR,
      AlignCenterHorizontal: tR,
      AlignStartHorizontal: oR,
      AlignHorizontalDistributeCenter: iR,
      BringToFront: OR,
      SendToBack: QD,
      Settings: P6,
      Settings2: tO,
      ImagePlus: m6,
      Clock: kz,
      Loader2: y6,
      Type: UO,
      Images: $$,
      MessageSquare: E7,
      Clipboard: xz,
      Share2: sO,
      Download: l6,
      Maximize2: w6,
      ArrowDownToLine: uR,
      Repeat: PD,
      RotateCcw: BD,
      HelpCircle: bw,
      CircleHelp: bw,
      Video: L6,
      Box: $R,
      Layers: W$,
      Sparkles: yv,
      RectangleVertical: I6,
      RectangleHorizontal: SD,
      Building2: GR,
      Sofa: uO,
      Rows3: HD,
      LayoutGrid: b6,
      Copy: a6,
      Undo2: jO,
      Redo2: TD,
      Group: T$,
      AlertCircle: vv,
      CircleAlert: vv,
      Upload: VO,
      FolderOpen: v$,
      Ellipsis: d6,
      EllipsisVertical: Kz,
      Pencil: S6,
      ArrowLeft: mR,
      Gauge: w$,
      ImageOff: P$,
      Trees: zO,
      Eye: s$,
      Mountain: N7,
      Lightbulb: n7,
      Camera: HR,
      Palette: Q7,
      LocateFixed: d7,
      Clapperboard: vz,
      Keyboard: N$,
      EyeOff: n$,
      Users: O6,
      Lock: x6,
      Globe: h6,
      UserPlus: D6,
      ExternalLink: c6,
      Library: e7,
      LogOut: f7,
      // the Studios view
      Brush: BR,
      MapPin: g7,
      Eraser: Jz,
      BookmarkPlus: PR,
      CornerDownLeft: Dz,
      Rotate3d: $D,
      Cpu: Fz,
      SquareCheck: vO,
      Replace: RD,
      FileBox: c$,
      // the Library
      Grid3x3: S$,
      LayoutDashboard: K$,
      SlidersHorizontal: E6,
      Columns3: Pz,
      // the prompt library (its sidebar opens from PanelLeft when the panel is narrow)
      LayoutTemplate: v6,
      ChevronsUp: sz,
      CloudOff: Sz,
      Bookmark: RR,
      PanelLeft: tD,
      // pinned sessions
      Pin: hD,
      PinOff: cD,
      // the eyedropper
      Pipette: M6,
      // the board's history, on the side rail
      History: OD,
      // beta feedback
      MessageSquareWarning: A7,
      Bug: NR,
      Send: JD,
      // unlocking a frame
      LockOpen: u7,
      // the Edit side's tools (IL-073)
      Crop: Uz,
      Smile: l$,
      LassoSelect: H$,
      MousePointerClick: j7,
      Expand: Qz,
      FlipHorizontal2: DO,
      FlipVertical2: LO,
      RotateCw: ND,
      Contrast: Rz,
      Droplet: Wz,
      Paintbrush: J7,
      Aperture: dR,
      Film: h$,
      Blend: IR,
      SquareDashed: xO,
      Sparkle: pO,
      Move: V7,
      Thermometer: PO,
      Columns2: Iz,
      Spotlight: gO,
      Orbit: q7,
      ZoomIn: sL,
      ZoomOut: rL,
      Proportions: yD,
      ScanFace: WD,
      Dice5: jz,
      Lamp: G$,
      SwatchBook: TO,
      Rainbow: wD,
      PaintBucket: Y7,
      // comments (IL-092) and the emoji picker's categories
      SmilePlus: r$,
      AtSign: kR,
      Bell: TR,
      BellOff: SR,
      CircleCheck: o6,
      MessageCircle: _7,
      MessageCirclePlus: w7,
      MessagesSquare: z7,
      MessageSquareDot: M7,
      Leaf: Z$,
      Coffee: Tz,
      Plane: mD,
      Trophy: FO,
      Flag: f$,
      ArrowUp: e6,
      CheckCheck: WR,
      Inbox: O$,
      // chat sessions in frames (Smart Frames)
      MessageSquarePlus: C7,
      Route: GD,
      CornerDownRight: Lz,
      CircleX: r6,
      CircleStop: pz,
      Focus: g$,
      // RunDiffusion's own mark for token costs
      Tokens: N6,
      ChevronsDownUp: ez,
      ChevronsUpDown: nz
    }, t = i, n = I(() => e[t.name] || e.Sparkles);
    return (s, o) => (g(), b("span", {
      class: G(["licon", { "licon-spin": i.spin }]),
      "aria-hidden": "true"
    }, [
      (g(), Ce(la(n.value), {
        size: i.size,
        "stroke-width": i.stroke
      }, null, 8, ["size", "stroke-width"]))
    ], 2));
  }
}), U6 = /* @__PURE__ */ Symbol("board");
function lL(i) {
  p5(U6, i);
}
function Ze() {
  const i = Qf(U6);
  if (!i) throw new Error("useBoard() outside a board");
  return i;
}
function as(i) {
  const { board: e } = Ze(), t = I(() => {
    const n = i();
    e.rev(n).value;
    const s = e.store.get(n);
    return s ? { ...s } : null;
  });
  return We(() => {
    e.store.get(i()) || e.releaseRev(i());
  }), t;
}
const dL = { class: "cv-atmo" }, cL = /* @__PURE__ */ Pe({
  __name: "Atmosphere",
  setup(i) {
    const { board: e } = Ze(), t = /* @__PURE__ */ K(null);
    function n(o) {
      const r = t.value;
      if (!r) return;
      let l = 30 * (Number.isFinite(o.zoom) && o.zoom > 0 ? o.zoom : 1);
      for (let d = 0; d < 24 && l < 16; d++) l *= 2;
      for (let d = 0; d < 24 && l > 64; d++) l /= 2;
      r.style.backgroundSize = l + "px " + l + "px", r.style.backgroundPosition = o.x % l + "px " + (o.y + e.view.top) % l + "px";
    }
    let s = null;
    return ot(() => {
      s = e.onCameraFrame(n), n(e.cam.value);
    }), We(() => {
      s && s();
    }), (o, r) => (g(), b("div", dL, [
      r[0] || (r[0] = u("div", { class: "cv-atmo-glow" }, null, -1)),
      r[1] || (r[1] = u("div", { class: "cv-atmo-orb-a" }, null, -1)),
      r[2] || (r[2] = u("div", { class: "cv-atmo-orb-b" }, null, -1)),
      u("div", {
        ref_key: "grid",
        ref: t,
        class: "cv-grid"
      }, null, 512)
    ]));
  }
}), uL = ["title", "aria-expanded"], hL = {
  key: 0,
  class: "n"
}, pL = {
  key: 0,
  class: "cv-board-menu cv-links-menu",
  role: "dialog",
  "aria-label": "Linked boards",
  "data-testid": "linked-boards"
}, fL = { class: "cv-links-head" }, mL = {
  key: 0,
  class: "n"
}, gL = {
  key: 0,
  class: "cv-links-empty"
}, bL = { class: "ic" }, vL = { class: "tx" }, yL = ["title"], xL = { class: "s" }, wL = ["aria-label", "onClick"], kL = ["data-testid", "onClick"], _L = /* @__PURE__ */ Pe({
  __name: "LinkedBoards",
  setup(i) {
    const { board: e } = Ze(), t = /* @__PURE__ */ K(!1), n = /* @__PURE__ */ K(null), s = I(() => {
      e.docRev.value;
      const c = [], h = /* @__PURE__ */ new Set();
      for (const f of e.store.all()) {
        const p = f.type === "note" ? f.link : void 0;
        !p || h.has(p.boardId) || (h.add(p.boardId), c.push({ id: f.id, boardId: p.boardId, title: p.title, back: !!p.back, missing: e.missingBoards.value.has(p.boardId) }));
      }
      return c.sort((f, p) => f.title.localeCompare(p.title));
    });
    function o(c) {
      t.value = !1, e.openBoardLink(c);
    }
    function r(c) {
      t.value = !1;
      const h = e.store.get(c);
      h && (e.ui.selection = [c], e.jumpTo(h.x + h.w / 2, h.y + h.h / 2, Math.max(e.cam.value.zoom, 0.8)));
    }
    function a() {
      t.value = !1;
      const c = e.view;
      e.openBoardLinkMenu(c.left + c.w / 2 - 170, c.top + c.h / 2 - 160);
    }
    function l(c) {
      n.value && !n.value.contains(c.target) && (t.value = !1);
    }
    function d(c) {
      c.key === "Escape" && (c.stopPropagation(), t.value = !1);
    }
    return Ae(t, (c) => {
      c ? (window.addEventListener("pointerdown", l, !0), window.addEventListener("keydown", d, !0), e.refreshLinks()) : (window.removeEventListener("pointerdown", l, !0), window.removeEventListener("keydown", d, !0));
    }), We(() => {
      window.removeEventListener("pointerdown", l, !0), window.removeEventListener("keydown", d, !0);
    }), (c, h) => m(e).canLinkBoards ? (g(), b("div", {
      key: 0,
      ref_key: "wrap",
      ref: n,
      class: "cv-links-wrap"
    }, [
      u("button", {
        class: G(["cv-links-btn", { on: t.value, "has-links": s.value.length > 0 }]),
        title: s.value.length ? "Linked boards (" + s.value.length + ")" : "Linked boards",
        "aria-label": "Linked boards",
        "aria-haspopup": "dialog",
        "aria-expanded": t.value,
        "data-testid": "linked-boards-button",
        onClick: h[0] || (h[0] = (f) => t.value = !t.value)
      }, [
        C($, {
          name: "Link2",
          size: 14
        }),
        s.value.length ? (g(), b("span", hL, E(s.value.length), 1)) : z("", !0)
      ], 10, uL),
      t.value ? (g(), b("div", pL, [
        u("div", fL, [
          h[1] || (h[1] = J("Linked boards ", -1)),
          s.value.length ? (g(), b("span", mL, E(s.value.length), 1)) : z("", !0)
        ]),
        s.value.length ? z("", !0) : (g(), b("div", gL, "No linked boards yet. Link the boards a project spans, and go between them in a click.")),
        (g(!0), b(j, null, be(s.value, (f) => (g(), b("div", {
          key: f.boardId,
          class: G(["cv-links-row", { "is-missing": f.missing }])
        }, [
          u("span", bL, [
            C($, {
              name: "LayoutDashboard",
              size: 14
            })
          ]),
          u("span", vL, [
            u("span", {
              class: "t",
              title: f.title
            }, E(f.title), 9, yL),
            u("span", xL, E(f.missing ? "Not found, or you can't open it" : f.back ? "You came here from it" : "Linked from this board"), 1)
          ]),
          u("button", {
            class: "cv-topbar-btn",
            title: "Find its card on the board",
            "aria-label": "Find the card for " + f.title,
            "data-testid": "linked-boards-show",
            onClick: (p) => r(f.id)
          }, [
            C($, {
              name: "LocateFixed",
              size: 14
            })
          ], 8, wL),
          f.missing ? z("", !0) : (g(), b("button", {
            key: 0,
            class: "cv-links-open",
            "data-testid": "linked-boards-open-" + f.boardId,
            onClick: (p) => o(f.id)
          }, [
            h[2] || (h[2] = J("Open ", -1)),
            C($, {
              name: "ArrowUpRight",
              size: 12
            })
          ], 8, kL))
        ], 2))), 128)),
        u("button", {
          class: "cv-board-menu-item cv-links-add",
          "data-testid": "linked-boards-add",
          onClick: a
        }, [
          C($, {
            name: "Plus",
            size: 15
          }),
          h[3] || (h[3] = u("span", { class: "cv-board-menu-text" }, [
            u("span", { class: "cv-board-menu-title" }, "Link a board"),
            u("span", { class: "cv-board-menu-desc" }, "An existing board, or a new one; it links back here")
          ], -1))
        ])
      ])) : z("", !0)
    ], 512)) : z("", !0);
  }
}), T1 = !1;
function C1(i) {
  const e = Math.max(0, Math.floor(i / 1e3));
  return Math.floor(e / 60) + ":" + String(e % 60).padStart(2, "0");
}
function SL(i) {
  const e = Math.max(1, Math.round(i / 1e3));
  if (e < 60) return e + " s";
  const t = Math.floor(e / 60);
  return t < 60 ? t + " min" + (e % 60 ? " " + e % 60 + " s" : "") : Math.floor(t / 60) + " h" + (t % 60 ? " " + t % 60 + " min" : "");
}
const Ou = /* @__PURE__ */ qe(Date.now());
let vw = 0, yw = 0;
function dr() {
  return Wl() && (vw++ === 0 && (yw = window.setInterval(() => {
    Ou.value = Date.now();
  }, 1e3)), Ou.value = Date.now(), We(() => {
    --vw === 0 && clearInterval(yw);
  })), Ou;
}
function Jn(i, e = Date.now()) {
  const t = Math.max(0, Math.round((e - i) / 1e3));
  if (t < 45) return "just now";
  const n = Math.round(t / 60);
  if (n < 60) return n + "m ago";
  const s = Math.round(n / 60);
  if (s < 24) return s + "h ago";
  const o = Math.round(s / 24);
  return o < 7 ? o + "d ago" : new Date(i).toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
function I1(i) {
  const e = new Date(i), t = e.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  let n = e.getHours();
  const s = n >= 12 ? "pm" : "am";
  return n = n % 12 || 12, t + " @ " + n + ":" + String(e.getMinutes()).padStart(2, "0") + " " + s;
}
const G6 = 24 * 3600 * 1e3;
function Zp(i, e = Date.now()) {
  const t = new Date(i), n = t.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }).toLowerCase(), s = new Date(e);
  if (s.setHours(0, 0, 0, 0), i >= s.getTime()) return "today, " + n;
  if (i >= s.getTime() - G6) return "yesterday, " + n;
  const o = t.getFullYear() === s.getFullYear() ? { month: "short", day: "numeric" } : { month: "short", day: "numeric", year: "numeric" };
  return t.toLocaleDateString("en-US", o) + ", " + n;
}
function ML(i, e = Date.now()) {
  const t = Math.max(1, Math.ceil((i - e) / G6));
  return t === 1 ? "1 day" : t + " days";
}
function xv(i) {
  return String(i || "").split(/\s+/).filter(Boolean).map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
}
function ma(i) {
  const e = String(i || "").trim(), t = (e.includes("@") ? e.split("@")[0].replace(/[._+-]+/g, " ") : e).split(/\s+/).filter(Boolean);
  return t.length ? t.length === 1 ? t[0].slice(0, 2).toUpperCase() : (t[0][0] + t[t.length - 1][0]).toUpperCase() : "YOU";
}
const xw = [
  ["1:1", 1],
  ["4:3", 4 / 3],
  ["3:2", 1.5],
  ["16:9", 16 / 9],
  ["3:4", 0.75],
  ["2:3", 2 / 3],
  ["9:16", 9 / 16]
];
function TL(i, e) {
  const t = i / Math.max(1, e);
  let n = xw[0];
  for (const s of xw) Math.abs(s[1] - t) < Math.abs(n[1] - t) && (n = s);
  return n[0];
}
const ww = null, CL = "";
function IL(i, e) {
  return AL(e.type) ? EL(i, e) : e.type === "SINGLE_SELECT" ? zL(i, e) : e.type === "WIDTH_HEIGHT" ? $L(i, e) : { valid: !0 };
}
function AL(i) {
  return i === "SLIDER" || i === "UPSCALE_FACTOR_SLIDER" || i === "CFG" || i === "STEPS";
}
function PL(i) {
  if (typeof i == "number" && Number.isFinite(i)) return i;
  if (i && typeof i == "object" && "value" in i) {
    const e = i.value;
    if (typeof e == "number" && Number.isFinite(e)) return e;
  }
  return typeof i == "string" && !isNaN(Number(i)) ? Number(i) : null;
}
function EL(i, e) {
  const t = e.display || {}, n = PL(i);
  if (n === null)
    return { valid: !1, reason: "Invalid numeric value" };
  if (Array.isArray(t.options) && t.options.length > 0)
    return t.options.some(
      (c) => Number(c.value) === n || c.value === n
    ) ? { valid: !0 } : { valid: !1, reason: "Value is not one of the allowed options" };
  if (n < t.min)
    return { valid: !1, reason: `Value below minimum (${t.min})` };
  if (n > t.max)
    return { valid: !1, reason: `Value above maximum (${t.max})` };
  const s = typeof t.step == "number" ? t.step : 1, o = (n - t.min) / s, r = Math.round(o), a = t.min + r * s, l = s * 1e-4;
  return Math.abs(n - a) > l ? { valid: !1, reason: `Value doesn't align with step (${s})` } : { valid: !0 };
}
function RL(i) {
  return i ? i.text && Array.isArray(i.text.options) ? i.text.options : i.radio && Array.isArray(i.radio.options) ? i.radio.options : i.image && Array.isArray(i.image.options) ? i.image.options : [] : [];
}
function zL(i, e) {
  const t = RL(e.display);
  if (t.length === 0)
    return { valid: !1, reason: "No valid options available" };
  let n = i;
  return i && typeof i == "object" && "value" in i && (n = i.value), t.some((o) => o.value === n) ? { valid: !0 } : typeof n != "string" && typeof n != "number" ? { valid: !1, reason: "Invalid option format" } : t.some(
    (o) => (typeof o.value == "string" || typeof o.value == "number") && String(o.value) === String(n)
  ) ? { valid: !0 } : { valid: !1, reason: "Invalid option" };
}
function $L(i, e) {
  const t = e.display, n = t && t.select;
  if (!n) return { valid: !0 };
  const s = Array.isArray(n.options) ? n.options : [];
  if (s.length === 0)
    return { valid: !1, reason: "No valid resolution options available" };
  if (n.format === "wh") {
    if (i && typeof i == "object" && !Array.isArray(i) && typeof i.width == "number" && typeof i.height == "number") {
      const a = i.width, l = i.height;
      return s.some((c) => c.width === a && c.height === l) ? { valid: !0 } : { valid: !1, reason: "Invalid width/height combination" };
    }
    return { valid: !1, reason: "Invalid width/height format" };
  }
  let o = i;
  return i && typeof i == "object" && "value" in i && (o = i.value), typeof o != "string" && typeof o != "number" ? { valid: !1, reason: "Invalid resolution option format" } : s.some(
    (a) => a.value === o || String(a.value) === String(o)
  ) ? { valid: !0 } : { valid: !1, reason: "Invalid resolution option" };
}
function Js(i) {
  return i !== null && (typeof i == "object" || typeof i == "function");
}
function ln(i, e) {
  let t = i;
  for (const n of e.replace(/\[(\d+)\]/g, ".$1").split(".")) {
    if (t == null) return;
    t = t[n];
  }
  return t;
}
const Hd = (i, e) => i === !0 && !!e || Array.isArray(i) && i.some((t) => t === e), kw = {
  "720p": { width: 1280, height: 720 },
  "1080p": { width: 1920, height: 1080 },
  "1440p": { width: 2560, height: 1440 },
  "2160p": { width: 3840, height: 2160 },
  "4k": { width: 3840, height: 2160 }
};
function A1(i) {
  return Js(i) && "value" in i ? i.value : i;
}
function ka(i) {
  if (!Js(i)) return null;
  const e = i.width, t = i.height;
  return !e || !t ? null : { width: e, height: t };
}
function j6(i) {
  const e = A1(i);
  if (typeof e != "string" && typeof e != "number") return null;
  const t = String(e).trim().toLowerCase();
  return Object.prototype.hasOwnProperty.call(kw, t) ? kw[t] : null;
}
function ga(i) {
  if (!Js(i)) return null;
  const e = Js(i.image) ? i.image : {}, t = Js(i.video) ? i.video : {};
  return t.nodeRunResult ? ka(ln(t, "nodeRunResult.file")) : t.upload ? ka(t.upload) : e.nodeRunResult ? ka(ln(e, "nodeRunResult.file")) : i.nodeRunResult ? ka(ln(i, "nodeRunResult.file")) : e.upload ? ka(e.upload) : i.upload ? ka(i.upload) : null;
}
const H6 = (i, e) => i.width >= e.width || i.height >= e.height;
function DL(i, e) {
  let t = null, n = 1 / 0;
  for (const s of e) {
    const o = j6(s);
    if (!o || H6(i, o)) continue;
    const r = o.width * o.height;
    r >= n || (n = r, t = String(A1(s)));
  }
  return t;
}
function OL(i, e, t, n, s) {
  if (!i.width || !i.height) return null;
  const o = j6(e);
  if (!o || !H6(i, o)) return null;
  const r = n ? n + ": " : "";
  if (s) return r + s;
  const a = i.width + "x" + i.height, l = DL(i, t), d = l ? "Choose " + l + " or higher." : "No available option is larger than your " + a + " input.";
  return r + String(A1(e)) + " targets " + o.width + "x" + o.height + ", which is not larger than your " + a + " input. " + d;
}
function V6(i) {
  return i ? i.text && Array.isArray(i.text.options) ? i.text.options : i.radio && Array.isArray(i.radio.options) ? i.radio.options : i.image && Array.isArray(i.image.options) ? i.image.options : [] : [];
}
function bu(i, e) {
  const t = { allDisables: [], allShows: [], allRequires: [], triggeredDisables: [], triggeredShows: [], triggeredRequires: [] }, n = i.logic && i.logic.field || {};
  for (const s of Object.keys(n)) {
    const o = (e || {})[s] || null, { disable: r, show: a, autoSet: l, require: d, enforceTargetLargerThanInput: c } = n[s];
    if (r && t.allDisables.push(r), a && t.allShows.push(a), d && t.allRequires.push(d), r && Hd(r.onValue, o) && t.triggeredDisables.push(r), a && Hd(a.onValue, o) && t.triggeredShows.push(a), d && Hd(d.onValue, o) && t.triggeredRequires.push(d), c) {
      const y = ga(o);
      if (y) {
        const v = V6(i.display).map((w) => w ? w.value : void 0), x = OL(y, (e || {})[i.fieldDefUuid || ""], v, i.label, c.message);
        x && (t.targetLargerThanInputError = x);
      }
    }
    if (!l || l.onValue !== null && l.onValue !== void 0 && !Hd(l.onValue, o)) continue;
    t.autoSetAllowEdit = l.allowEdit || !1, t.autoSetVisible = l.visible || l.allowEdit || !1;
    const h = e[s];
    if (!h) continue;
    const f = l.dataFieldKey;
    let p = null;
    if (f ? (ln(h, "image.nodeRunResult") ? p = ln(h, "image.nodeRunResult.file." + f) : ln(h, "nodeRunResult") ? p = ln(h, "nodeRunResult.file." + f) : ln(h, "image.upload") ? p = ln(h, "image.upload." + f) : ln(h, "upload") && (p = ln(h, "upload." + f)), ln(h, "video.nodeRunResult") ? p = ln(h, "video.nodeRunResult.file." + f) : ln(h, "video.upload") && (p = ln(h, "video.upload." + f)), p == null && (p = ln(h, f))) : p = h, p != null)
      t.autoSetValue = l.setToValue !== void 0 ? l.setToValue : p;
    else {
      const y = ln(h, "image.nodeRunResult") || ln(h, "image.upload") || ln(h, "video.nodeRunResult") || ln(h, "video.upload") || ln(h, "upload") || ln(h, "nodeRunResult");
      f && y && (t.autoSetError = l.errorMessage || "Unable to extract " + f + " from input data");
    }
  }
  return t;
}
function P1(i, e, t = !1) {
  if (!i.logic) return !0;
  const n = bu(i, e), s = !n.allShows.length || n.triggeredShows.length > 0, o = s && n.triggeredDisables.length > 0;
  return !n.autoSetVisible && !n.autoSetAllowEdit && t ? !1 : s && !o;
}
function W6(i, e) {
  return i.required ? !0 : i.logic ? bu(i, e).triggeredRequires.length > 0 : !1;
}
function vu(i) {
  const e = [];
  for (const t of i || [])
    t && (t.__rgroup ? e.push(...vu(t.fields)) : t.__rfield && e.push(t));
  return e;
}
function E1(i, e, t = !1) {
  const n = [];
  for (const s of i || [])
    !s || !P1(s, e, t) || (s.__rgroup ? n.push(...E1(s.fields, e, t)) : s.__rfield && n.push(s));
  return n;
}
function q6(i, e) {
  const t = [];
  for (const n of i || [])
    !n || !n.__rgroup || !P1(n, e) || (n.required && !E1(n.fields, e).some((s) => {
      const o = e[s.fieldDefUuid || ""];
      return s.type === "PROMPT" ? (typeof o == "string" ? o : Js(o) && typeof o.value == "string" ? o.value : "").trim() !== "" : !!o;
    }) && t.push(n), t.push(...q6(n.fields, e)));
  return t;
}
function _w(i, e) {
  if (e === !0 && i) return !0;
  if (Array.isArray(e)) {
    if (e.includes(i)) return !0;
    if (Js(i))
      return e.some((t) => Js(t) && Object.keys(t).every((n) => i[n] === t[n]));
  }
  return !1;
}
function LL(i, e, t, n, s) {
  let o = i || 0;
  if (t && n)
    for (const r of t)
      for (const [a, l] of Object.entries(r.field)) {
        const d = n[a];
        if (s) {
          const p = vu(s).find((y) => y.fieldDefUuid === a);
          if (p && !P1(p, n)) continue;
        }
        let c = l.operand;
        if (l.operandIsFieldValue) {
          const p = Number(d);
          Number.isFinite(p) && (c = p);
        }
        let h = null;
        l.logicPerArrayItem && (Array.isArray(d) ? h = d : Js(d) && (Array.isArray(d.uploads) || Array.isArray(d.nodeRunResults)) && (h = [...d.uploads || [], ...d.nodeRunResults || []]));
        const f = h !== null ? h.filter((p) => _w(p, l.onValue)).length : _w(d, l.onValue) ? 1 : 0;
        for (let p = 0; p < f; p++)
          l.operator === "ADD" ? o += c : l.operator === "MULTIPLY" ? o *= c : l.operator === "SET" && (o = c);
      }
  return BL(o, e || 1);
}
function Sw(i) {
  const [e, t] = String(i).toLowerCase().split("e"), n = e[0] === "-", [s, o = ""] = (n ? e.slice(1) : e).split("."), r = BigInt(s + o);
  return { digits: n ? -r : r, scale: o.length - (t ? Number(t) : 0) };
}
function BL(i, e) {
  if (!Number.isFinite(i) || !Number.isFinite(e)) return Math.floor(i * e);
  const t = Sw(i), n = Sw(e), s = t.digits * n.digits, o = t.scale + n.scale, r = BigInt(10);
  if (o <= 0) return Number(s * r ** BigInt(-o));
  const a = r ** BigInt(o);
  let l = s / a;
  return s < BigInt(0) && l * a !== s && (l -= BigInt(1)), Number(l);
}
const R1 = "__boardUrls", K6 = 0.8;
function Qp(i) {
  return "strength:" + i;
}
function FL(i) {
  return i.raw && i.raw.display || {};
}
function NL(i) {
  const e = FL(i);
  return i.kind === "video" ? !!e.hasStrength : !!(e.hasStrength || e.hasInpainting);
}
function Y6(i) {
  return i.fields.filter((e) => e.placement === "reference");
}
function X6(i, e, t) {
  const n = t.inputs ? t.inputs[e.key] : void 0;
  if (e.kind === "images" && Array.isArray(n)) {
    const o = n.filter((r) => typeof r == "string" && !!r);
    if (o.length) return o;
  }
  const s = Y6(i)[0] === e ? t.ref : n;
  return typeof s == "string" && s ? s : null;
}
function Mw(i) {
  return { boardUrl: i };
}
function Eo(i, e, t = "run") {
  const n = {}, s = [], o = {}, r = e.assets || {}, a = t === "rules";
  for (const d of i.fields) {
    if (d.kind === "header") continue;
    if (d.placement === "reference") {
      const h = X6(i, d, e);
      if (!h || Array.isArray(h) && !h.length) continue;
      if (d.kind === "images") {
        const y = [].concat(h), v = [], x = [], w = [];
        for (const S of y) {
          const M = r[S];
          M ? "upload" in M ? v.push(M.upload) : x.push(M.nodeRunResult) : a ? v.push(Mw(S)) : w.push(S);
        }
        (v.length || x.length) && (n[d.key] = { uploads: v, nodeRunResults: x }), w.length && (s.push(...w), o[d.key] = w);
        continue;
      }
      const f = Array.isArray(h) ? h[0] : h, p = r[f] || (a ? Mw(f) : null);
      if (!p) {
        s.push(f), o[d.key] = f;
        continue;
      }
      if (NL(d)) {
        const y = e.inputs && e.inputs[Qp(d.key)], v = typeof y == "number" ? y : K6, x = e.masks && e.masks[d.key];
        n[d.key] = d.kind === "video" ? { video: p, strength: v } : { image: p, inpainting: x ? { mask: x } : null, strength: v };
      } else
        n[d.key] = p;
      continue;
    }
    const c = d.placement === "prompt" ? e.prompt : e.inputs && e.inputs[d.key] !== void 0 ? e.inputs[d.key] : d.defaultValue;
    c == null || c === "" || (n[d.key] = d.kind === "prompt" ? { value: c } : c);
  }
  const l = i.raw && i.raw.fields;
  if (l) {
    const d = new Set(i.fields.map((c) => c.key));
    for (const c of vu(l)) {
      const h = c.fieldDefUuid;
      !h || d.has(h) || h in n || c.defaultValue !== void 0 && c.defaultValue !== null && (n[h] = c.defaultValue);
    }
  }
  return t === "draft" && Object.keys(o).length && (n[R1] = o), { inputs: n, pending: s };
}
function UL(i) {
  return typeof i == "string" ? i : i && typeof i == "object" && "value" in i ? String(i.value || "") : "";
}
function wv(i) {
  if (!i || typeof i != "object") return null;
  const e = i;
  return e.upload && typeof e.upload == "object" ? { upload: e.upload } : e.nodeRunResult && typeof e.nodeRunResult == "object" ? { nodeRunResult: e.nodeRunResult } : e.image ? wv(e.image) : e.video ? wv(e.video) : null;
}
function dc(i, e, t) {
  const n = { prompt: "", ref: null, inputs: {}, assets: {} }, s = n.inputs, o = n.assets, r = e[R1] || {}, a = Y6(i), l = (d, c) => {
    const h = [].concat(c);
    h.length > 1 && (s[d.key] = h), a[0] === d ? n.ref = h[0] : h.length === 1 && (s[d.key] = h[0]);
  };
  for (const d of i.fields) {
    if (d.kind === "header") continue;
    const c = e[d.key];
    if (d.placement === "prompt") {
      n.prompt = UL(c);
      continue;
    }
    if (d.placement === "reference") {
      if (d.kind === "images") {
        const f = [], p = c || {};
        for (const v of p.uploads || []) {
          const x = { upload: v }, w = t(x);
          o[w] = x, f.push(w);
        }
        for (const v of p.nodeRunResults || []) {
          const x = { nodeRunResult: v }, w = t(x);
          o[w] = x, f.push(w);
        }
        const y = r[d.key];
        y && f.push(...[].concat(y)), f.length && l(d, f);
        continue;
      }
      const h = wv(c);
      if (h) {
        const f = t(h);
        o[f] = h, l(d, f);
        const p = c && typeof c == "object" ? c.strength : void 0;
        typeof p == "number" && (s[Qp(d.key)] = p);
      } else typeof r[d.key] == "string" && l(d, r[d.key]);
      continue;
    }
    c !== void 0 && (s[d.key] = c);
  }
  return n;
}
function GL(i, e) {
  const t = (n) => JSON.stringify({
    prompt: n && n.prompt || "",
    ref: n && n.ref || null,
    n: n && n.n || null,
    inputs: jL(n && n.inputs || {})
  });
  return t(i) === t(e);
}
function jL(i) {
  const e = {};
  for (const t of Object.keys(i).sort()) i[t] !== void 0 && i[t] !== null && i[t] !== "" && (e[t] = i[t]);
  return e;
}
const HL = { shown: !0, locked: !1, why: "", required: !1, problem: "" };
function Ka(i) {
  return /[.!?]$/.test(i) ? i : i + ".";
}
function Ur(i, e) {
  return i.fields.get(e) || HL;
}
function Ki(i) {
  return !!i && typeof i == "object";
}
function VL(i, e) {
  const t = i.display || {};
  if (i.type === "SINGLE_SELECT") {
    const n = V6(t).find((s) => !!s && s.value === e);
    return n ? n.value : void 0;
  }
  if (i.type === "WIDTH_HEIGHT" && t.select) {
    const n = t.select.options || [], s = typeof e == "string" ? n.find((o) => !!o && o.value === e) : Ki(e) && e.width && e.height ? n.find((o) => !!o && o.width === e.width && o.height === e.height) : void 0;
    return s ? t.select.format === "value" ? s.value : { width: s.width, height: s.height } : void 0;
  }
  if (i.type === "SLIDER") {
    const n = Number(e);
    if (!Number.isFinite(n)) return;
    const s = t.min == null ? 1 : t.min, o = t.max || 30, r = t.step || 1;
    return s + Math.round((Math.min(o, Math.max(s, n)) - s) / r) * r;
  }
  return e;
}
function kv(i, e, t) {
  const n = i.raw && i.raw.fields;
  if (!n) return { values: e, errors: [] };
  const s = vu(n).filter((a) => !!a.logic && !!a.fieldDefUuid);
  if (!s.length) return { values: e, errors: [] };
  let o = e;
  const r = [];
  for (let a = 0; a < 4; a++) {
    let l = !1;
    for (const d of s) {
      const c = d.fieldDefUuid, h = bu(d, o);
      if (h.autoSetError && !r.includes(h.autoSetError) && r.push(h.autoSetError), h.autoSetValue === null || h.autoSetValue === void 0 || h.autoSetAllowEdit && t && t.inputs && t.inputs[c] !== void 0) continue;
      const f = VL(d, h.autoSetValue);
      if (f === void 0) {
        const p = h.autoSetError || (d.label || "A setting") + " couldn't be set to match your other settings.";
        r.includes(p) || r.push(p);
        continue;
      }
      JSON.stringify(o[c]) !== JSON.stringify(f) && (o = { ...o, [c]: f }, l = !0);
    }
    if (!l) break;
  }
  return { values: o, errors: r };
}
const Tw = [
  ["3:1", 3],
  ["2.5:1", 2.5],
  ["21:9", 2.3],
  ["16:9", 1.8],
  ["3:2", 1.5],
  ["4:3", 1.33],
  ["5:4", 1.25],
  ["1:1", 1],
  ["3:4", 0.75],
  ["2:3", 0.67],
  ["9:16", 0.6],
  ["9:21", 0.4],
  ["1:3", 0.33]
];
function WL(i) {
  const e = ga(i);
  if (!e) return null;
  const t = Math.round(e.width / e.height * 10) / 10;
  let n = Tw[0];
  for (const s of Tw) Math.abs(s[1] - t) < Math.abs(n[1] - t) && (n = s);
  return n[0];
}
function qL(i, e, t, n) {
  const s = i.logic && i.logic.field || {}, o = e.triggeredDisables[0];
  if (!o) {
    let l = "";
    for (const d of Object.keys(s)) {
      const c = s[d].autoSet;
      c && (c.onValue === null || c.onValue === void 0 || Hd(c.onValue, t[d] || null)) && (l = n.get(d) || "");
    }
    return l ? "Set to match your " + l.toLowerCase() : "Set for you by your other settings";
  }
  const r = Object.keys(s).find((l) => s[l].disable === o) || "";
  if (i.type === "WIDTH_HEIGHT" && o.imageAspectRatioOverride && r) {
    const l = WL(t[r]);
    if (l) return "Aspect Ratio will match input image (" + l + ")";
  }
  if (o.message) return o.message;
  const a = n.get(r);
  return a ? "Turned off by your " + a.toLowerCase() : "Another setting turned this off";
}
function J6(i, e, t) {
  const { values: n, isAdmin: s, labels: o, out: r } = e;
  for (const a of i) {
    if (!a) continue;
    const l = a.logic ? bu(a, n) : null, d = a.logic && a.logic.field || {}, c = !!l && l.autoSetVisible === !1 && Object.keys(d).some((y) => !!d[y].autoSet), h = t.shown && (!l || !l.allShows.length || l.triggeredShows.length > 0) && (!a.adminOnly || s) && !c, f = h && !!l && (l.triggeredDisables.length > 0 || l.autoSetValue !== void 0 && !!l.autoSetVisible && !l.autoSetAllowEdit), p = {
      shown: h,
      locked: t.locked || f,
      why: f && l ? qL(a, l, n, o) : t.why
    };
    a.__rgroup ? J6(a.fields || [], e, p) : a.__rfield && a.fieldDefUuid && r.set(a.fieldDefUuid, {
      ...p,
      required: W6(a, n),
      problem: h && !p.locked && l && l.targetLargerThanInputError ? l.targetLargerThanInputError : ""
    });
  }
}
const KL = 2e3;
function Cw(i) {
  return Ki(i) ? Ki(i.nodeRunResult) && Ki(i.nodeRunResult.file) ? i.nodeRunResult.file : Ki(i.upload) ? i.upload : null : null;
}
function Iw(i, e, t) {
  if (!e || !e.width || !e.height) return "";
  const n = t || 3, s = e.width / e.height;
  return s > n ? i + " aspect ratio (" + s.toFixed(2) + ":1) is too wide. Maximum allowed is " + n + ":1" : s < 1 / n ? i + " aspect ratio (1:" + (1 / s).toFixed(2) + ") is too tall. Maximum allowed is 1:" + n : "";
}
function Aw(i, e, t) {
  return !e || !t ? "" : e.width !== void 0 && e.width < t ? i + " width (" + e.width + "px) is too small. Minimum required is " + t + "px" : e.height !== void 0 && e.height < t ? i + " height (" + e.height + "px) is too small. Minimum required is " + t + "px" : "";
}
function Pw(i) {
  return typeof i == "string" ? i : Ki(i) && typeof i.value == "string" ? i.value : "";
}
const YL = /* @__PURE__ */ new Set(["IMG", "IMGS", "VIDEO", "ASSET_3D"]);
function Z6(i, e, t) {
  if (t) return "Write a prompt first";
  if (i === "MODEL_SINGLE_SELECT") return "Choose a trained model first";
  const n = (e || "a setting").toLowerCase();
  return (i && YL.has(i) ? "Add " : "Set ") + n + " first";
}
function XL(i, e) {
  const t = [], n = e[i.fieldDefUuid || ""], s = i.display || {}, o = i.label || i.fieldDefUuid || "A field";
  if (W6(i, e) && (!n || i.type === "PROMPT" && !Pw(n).trim())) {
    const a = i.type === "PROMPT" || (i.type === "TEXT" || i.type === "TEXT_AREA") && s.primaryForm === "PROMPT";
    t.push(Z6(i.type, i.label, a));
  }
  if (i.type === "IMG") {
    const a = Cw(n), l = Iw("Image", a, s.maxAspectRatio);
    l && t.push(l);
    const d = Aw("Image", a, s.minDimension);
    d && t.push(d), s.hasInpainting && s.inpaintingRequired && !(Ki(n) && Ki(n.inpainting) && n.inpainting.mask) && t.push("Mask is required");
  }
  if (i.type === "IMGS" && s.maxImages && Ki(n) && (Array.isArray(n.uploads) ? n.uploads.length : 0) + (Array.isArray(n.nodeRunResults) ? n.nodeRunResults.length : 0) > s.maxImages && t.push("Maximum of " + s.maxImages + " images allowed"), i.type === "VIDEO") {
    const a = Cw(Ki(n) && n.video ? n.video : n), l = Iw("Video", a, s.maxAspectRatio);
    l && t.push(l);
    const d = Aw("Video", a, s.minDimension);
    d && t.push(d), a && a.width && s.maxWidth && a.width > s.maxWidth && t.push("Video width (" + a.width + "px) exceeds maximum allowed width of " + s.maxWidth + "px"), a && a.height && s.maxHeight && a.height > s.maxHeight && t.push("Video height (" + a.height + "px) exceeds maximum allowed height of " + s.maxHeight + "px"), a && a.duration && s.maxDuration && a.duration > s.maxDuration && t.push("Video duration (" + a.duration + "s) exceeds maximum allowed duration of " + s.maxDuration + "s");
  }
  if (i.type === "PROMPT") {
    const a = s.maxLength || KL;
    Pw(n).length > a && t.push("Maximum of " + a + " characters allowed");
  }
  if (i.type === "UPSCALE_FACTOR_SLIDER") {
    const a = typeof n == "number" ? n : Ki(n) && typeof n.value == "number" ? n.value : null, l = s.dataFieldDefUuid ? ga(e[s.dataFieldDefUuid]) : null;
    if (a !== null && l) {
      const d = Math.round(l.width * a), c = Math.round(l.height * a), h = s.maxWidth || 3840, f = s.maxHeight || 2160;
      d > h ? t.push("Final width (" + d + "px) exceeds maximum allowed width of " + h + "px") : c > f && t.push("Final height (" + c + "px) exceeds maximum allowed height of " + f + "px");
    }
  }
  if (i.type === "SINGLE_SELECT") {
    const a = bu(i, e).targetLargerThanInputError;
    a && t.push(a);
  }
  if ((i.type === "UPSCALE_FACTOR_SLIDER" || !!n && (i.type === "WIDTH_HEIGHT" || i.type === "SINGLE_SELECT" || i.type === "SLIDER" || i.type === "CFG" || i.type === "STEPS")) && i.type) {
    const a = IL(n, { type: i.type, display: i.display, label: i.label, fieldDefUuid: i.fieldDefUuid });
    a.valid || t.push((a.reason || "Invalid value") + " for " + o);
  }
  return t;
}
function Xi(i, e, t, n = !1) {
  const { values: s, errors: o } = kv(i, Eo(i, e, "rules").inputs, e), r = i.raw, a = r && r.fields, l = /* @__PURE__ */ new Map(), d = [];
  if (a) {
    const h = /* @__PURE__ */ new Map();
    for (const f of vu(a)) f.fieldDefUuid && f.label && h.set(f.fieldDefUuid, f.label);
    J6(a, { values: s, isAdmin: n, labels: h, out: l }, { shown: !0, locked: !1, why: "" });
    for (const f of E1(a, s)) d.push(...XL(f, s));
    for (const f of q6(a, s)) d.push("Select at least one: " + (f.label || "option"));
  } else
    for (const h of i.fields) {
      if (!h.required) continue;
      const f = h.placement === "prompt";
      (f ? !(e.prompt || "").trim() : !s[h.key]) && d.push(Z6(h.placement === "reference" ? "IMG" : void 0, h.label, f));
    }
  let c = null;
  return r && (!r.pricingType || r.pricingType === "COST") && r.costPerResult > 0 ? c = LL(r.costPerResult, t, r.costPerResultLogics, s, a) : !r && i.tokensPerResult != null && (c = Math.round(i.tokensPerResult * t * 100)), { fields: l, values: s, problems: d, price: c, autoErrors: o };
}
function yn(i) {
  if (i && typeof i == "object") {
    const e = i;
    return e.width != null && e.height != null ? e.width + "x" + e.height : JSON.stringify(i);
  }
  return String(i);
}
function Qi(i, e) {
  return yn(i) === yn(e);
}
function ef(i) {
  if (!i || typeof i != "object") return !1;
  const e = i;
  return e.width != null && e.height != null;
}
function cc(i, e) {
  const t = typeof e == "number" ? e : typeof e == "string" && e.trim() !== "" ? Number(e) : NaN;
  if (!Number.isFinite(t)) return null;
  const n = i.min == null ? 1 : i.min, s = i.max == null ? 30 : i.max, o = i.step && i.step > 0 ? i.step : 1;
  let r = n + Math.round((Math.min(s, Math.max(n, t)) - n) / o) * o;
  r > s + 1e-9 && (r -= o);
  const a = (String(o).split(".")[1] || "").length;
  return Number(r.toFixed(a));
}
function Lc(i, e) {
  if (i.placement === "prompt") return e.prompt != null ? e.prompt : i.defaultValue;
  const t = e.inputs ? e.inputs[i.key] : void 0;
  return t !== void 0 ? t : i.defaultValue;
}
function JL(i) {
  const e = i.value;
  if (e && typeof e == "object" && Number(e.width) > 0 && Number(e.height) > 0) return { width: Number(e.width), height: Number(e.height) };
  const t = /(\d+)\s*×\s*(\d+)/.exec(i.meta || "");
  return t ? { width: Number(t[1]), height: Number(t[2]) } : null;
}
function Q6(i, e, t, n = () => null) {
  const s = e.raw && e.raw.display || {}, o = s.dataFieldDefUuid || s.imageFieldDefUuid, r = o ? i.fields.find((v) => v.key === o && v.placement === "reference") : null;
  if (e.kind !== "size" || !e.options || !r) return null;
  const a = X6(i, r, t), l = Array.isArray(a) ? a[0] : a, d = l ? t.assets && ga(t.assets[l]) || n(l) : null;
  if (!d) return null;
  const c = d.width / d.height, h = e.options.flatMap((v) => {
    const x = JL(v);
    return x ? [{ o: v, gap: Math.abs(x.width / x.height - c), px: Math.abs(x.width - d.width) + Math.abs(x.height - d.height) }] : [];
  }), f = Math.min(...h.map((v) => v.gap));
  let p = null, y = 1 / 0;
  for (const v of h)
    Math.abs(v.gap - f) < 1e-4 && v.px < y && (p = v.o, y = v.px);
  return p;
}
function e8(i, e) {
  var t;
  if (!i) return "";
  let n = "";
  const s = i.fields.find((d) => d.kind === "size"), o = s ? e(s) : void 0;
  if (o && ef(o)) {
    const d = o;
    n = d.width + " × " + d.height;
  } else if (s && s.options) {
    const d = s.options.find((h) => Qi(h.value, o)), c = d && d.meta ? /(\d{3,5})\s*[x×]\s*(\d{3,5})/.exec(d.meta) : null;
    c && (n = c[1] + " × " + c[2]);
  }
  if (!n) {
    const d = i.fields.find((f) => /resolution/i.test(f.key + " " + f.label)), c = d ? /(\d{3,4})\s*p/i.exec(String(e(d) || "")) : null, h = o && typeof o != "object" ? /(\d+(?:\.\d+)?)\s*:\s*(\d+(?:\.\d+)?)/.exec(String(o)) : null;
    if (c && h) {
      const f = Number(c[1]), p = Number(h[1]) / Number(h[2]), y = p >= 1 ? Math.round(f * p / 16) * 16 : f, v = p >= 1 ? f : Math.round(f / p / 16) * 16;
      n = y + " × " + v;
    }
  }
  const r = i.fields.find((d) => d.kind !== "size" && /dur|length|seconds/i.test(d.key + " " + d.label)), a = r ? /(\d+(?:\.\d+)?)/.exec(String((t = e(r)) != null ? t : "")) : null, l = a ? Number(a[1]) + " s" : "";
  return !n && !l ? "" : "Comes out at about " + [n, l].filter(Boolean).join(", ");
}
function Zs(i) {
  return i.kind === "images" ? Math.max(1, i.maxImages || 4) : 1;
}
function El(i) {
  const e = i / 100;
  return e >= 100 ? String(Math.round(e)) : String(Math.round(e * 10) / 10);
}
function t8(i, e, t) {
  if (!i) return "";
  if (i.raw && t) {
    const n = Xi(i, t, e).price;
    if (n != null) return El(n);
  }
  return i.tokensPerResult != null ? String(Math.round(i.tokensPerResult * e * 100) / 100) : i.tokensLabel || "";
}
const ZL = { class: "cv-topbar-left" }, QL = ["value"], eB = { class: "cv-topbar-right" }, tB = ["title"], nB = ["title"], iB = {
  key: 0,
  class: "cv-feedback-dot",
  "data-testid": "feedback-draft-dot"
}, sB = { class: "cv-board-menu-wrap" }, oB = ["aria-expanded"], rB = {
  key: 0,
  class: "cv-topbar-dot",
  "data-testid": "board-menu-dot"
}, aB = {
  key: 0,
  class: "cv-board-menu",
  role: "menu",
  "data-testid": "board-menu"
}, lB = {
  key: 0,
  class: "cv-board-menu-count",
  "data-testid": "trash-count"
}, dB = /* @__PURE__ */ Pe({
  __name: "TopBar",
  props: {
    onHome: { type: Function },
    onIndex: { type: Function }
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = /* @__PURE__ */ K(!1), s = /* @__PURE__ */ K(null), o = I(() => {
      const S = t.balance.value;
      if (!S) return null;
      const M = S.tokens / 100, _ = Math.abs(M) >= 1e3 ? Math.floor(M).toLocaleString("en-US") : El(S.tokens);
      return t.teamName.value, { text: _, title: t.tokensTitle(), empty: S.tokens <= 0 };
    }), r = I(() => t.canGetTokens || !!t.meta.teamId && !t.canBuyTokens), a = I(() => t.trash.value.length);
    function l(S) {
      t.ui.boardMenu = !1, t.ui[S] = !0;
    }
    const d = t.feedback, c = I(() => !!d && d.state.mode === "closed" && d.hasDraft);
    function h(S) {
      t.ui.boardMenu = !1, d && d.start(S);
    }
    function f() {
      t.ui.boardMenu = !1, t.openTour();
    }
    function p() {
      t.ui.boardMenu = !1;
      const S = t.promptTool.value;
      t.promptLibrary.open(S ? S.id : null);
    }
    function y(S) {
      t.ui.boardMenu && !S.target.closest(".cv-board-menu-wrap") && (t.ui.boardMenu = !1);
    }
    ot(() => window.addEventListener("pointerdown", y, !0)), We(() => window.removeEventListener("pointerdown", y, !0));
    const v = I(() => {
      const S = t.saveState.value;
      return S === "saving" ? { cls: "is-saving", text: "Saving…" } : S === "error" ? { cls: "is-error", text: "Not saved: retrying" } : S === "offline" ? { cls: "is-error", text: "Offline: changes kept here" } : { cls: "", text: "Saved" };
    });
    function x() {
      n.value = !0, nt(() => {
        s.value && (s.value.focus({ preventScroll: !0 }), s.value.select());
      });
    }
    function w(S) {
      if (!n.value) return;
      const M = s.value ? s.value.value : "";
      n.value = !1, S && t.renameBoard(M);
    }
    return (S, M) => (g(), b("div", {
      class: "cv-topbar",
      onPointerdown: M[11] || (M[11] = Se(() => {
      }, ["stop"]))
    }, [
      u("div", ZL, [
        u("button", {
          class: "cv-mark",
          title: "RunDiffusion",
          "aria-label": "RunDiffusion",
          onClick: M[0] || (M[0] = (_) => e.onHome())
        }, [...M[12] || (M[12] = [
          u("svg", {
            viewBox: "1 33 239 173",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            u("path", {
              d: "M160.973 91.1044H105.586C103.271 91.1044 101.134 89.8671 99.9766 87.8597L74.5215 43.7307C72.0284 39.4055 75.1448 33.9999 80.1311 33.9999H135.518C137.833 33.9999 139.97 35.2372 141.128 37.2447L166.579 81.3772C169.072 85.7024 165.956 91.108 160.97 91.108L160.973 91.1044Z",
              fill: "#CC5FD1"
            }),
            u("path", {
              d: "M160.974 205.317H105.587C103.271 205.317 101.134 204.079 99.9769 202.072L74.5254 157.939C72.0323 153.614 75.1487 148.209 80.135 148.209H135.522C137.837 148.209 139.974 149.446 141.132 151.453L166.583 195.586C169.076 199.911 165.96 205.317 160.974 205.317Z",
              fill: "#B0B3F6"
            }),
            u("path", {
              d: "M150.485 148.213H205.872C208.187 148.213 210.324 146.975 211.481 144.968L236.933 100.835C239.426 96.5102 236.31 91.1046 231.323 91.1046H175.936C173.621 91.1046 171.484 92.3419 170.327 94.3494L144.875 138.482C142.382 142.807 145.498 148.213 150.485 148.213Z",
              fill: "#9A6ADF"
            }),
            u("path", {
              d: "M40.7394 200.572L67.1953 151.857C68.2994 149.821 68.2389 147.35 67.0279 145.371L40.4581 101.905C37.8545 97.6479 31.6216 97.8048 29.2389 102.194L2.78656 150.909C1.68245 152.945 1.74299 155.416 2.95395 157.395L29.5238 200.86C32.1274 205.118 38.3603 204.961 40.743 200.572H40.7394Z",
              fill: "#A691DF"
            })
          ], -1)
        ])]),
        u("button", {
          class: "cv-crumb",
          title: "All boards",
          onClick: M[1] || (M[1] = (_) => e.onIndex())
        }, "Boards"),
        M[13] || (M[13] = u("span", { class: "cv-crumb cv-crumb-sep" }, "/", -1)),
        n.value ? (g(), b("input", {
          key: 0,
          ref_key: "inputEl",
          ref: s,
          class: "cv-board-title-input",
          value: m(t).meta.title,
          spellcheck: "false",
          maxlength: "120",
          onKeydown: [
            M[2] || (M[2] = tn(Se((_) => w(!0), ["prevent"]), ["enter"])),
            M[3] || (M[3] = tn(Se((_) => w(!1), ["stop", "prevent"]), ["esc"]))
          ],
          onBlur: M[4] || (M[4] = (_) => w(!0))
        }, null, 40, QL)) : (g(), b("span", {
          key: 1,
          class: "cv-board-title",
          title: "Rename board",
          onClick: x
        }, E(m(t).meta.title), 1)),
        C(_L)
      ]),
      u("div", eB, [
        m(ww) ? (g(), Ce(la(m(ww)), {
          key: 0,
          board: m(t)
        }, null, 8, ["board"])) : z("", !0),
        o.value ? (g(), Ce(la(r.value ? "button" : "span"), {
          key: 1,
          class: G(["cv-tokens", { "is-empty": o.value.empty, "is-link": r.value }]),
          title: o.value.title,
          "data-testid": "token-balance",
          onClick: M[5] || (M[5] = (_) => m(t).getTokens())
        }, {
          default: Xe(() => [
            C($, {
              name: "Tokens",
              size: 13
            }),
            J(E(o.value.text), 1)
          ]),
          _: 1
        }, 8, ["class", "title"])) : z("", !0),
        u("span", {
          class: G(["cv-save-state", v.value.cls]),
          title: v.value.text
        }, [
          M[14] || (M[14] = u("span", { class: "dot" }, null, -1)),
          J(E(v.value.text), 1)
        ], 10, tB),
        m(d) ? (g(), b("button", {
          key: 2,
          class: "cv-feedback",
          title: c.value ? "Your report is waiting: open it to finish and send" : "Report a bug or share an idea (`)",
          "data-testid": "feedback-button",
          onClick: M[6] || (M[6] = (_) => h("button"))
        }, [
          C($, {
            name: "MessageSquareWarning",
            size: 13
          }),
          M[15] || (M[15] = J("Feedback ", -1)),
          c.value ? (g(), b("span", iB)) : z("", !0)
        ], 8, nB)) : z("", !0),
        u("div", sB, [
          u("button", {
            class: G(["cv-topbar-btn", { on: m(t).ui.boardMenu }]),
            title: "Board menu",
            "aria-label": "Board menu",
            "aria-haspopup": "menu",
            "aria-expanded": m(t).ui.boardMenu,
            "data-testid": "board-menu-button",
            onClick: M[7] || (M[7] = (_) => m(t).ui.boardMenu = !m(t).ui.boardMenu)
          }, [
            C($, {
              name: "EllipsisVertical",
              size: 16
            }),
            a.value && !m(t).ui.boardMenu ? (g(), b("span", rB)) : z("", !0)
          ], 10, oB),
          m(t).ui.boardMenu ? (g(), b("div", aB, [
            u("button", {
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "library-menu-item",
              onClick: p
            }, [
              C($, {
                name: "LayoutTemplate",
                size: 17
              }),
              M[16] || (M[16] = u("span", { class: "cv-board-menu-text" }, [
                u("span", { class: "cv-board-menu-title" }, "Prompt Library"),
                u("span", { class: "cv-board-menu-desc" }, "Browse Featured prompts and start a session from one")
              ], -1))
            ]),
            u("button", {
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "trash-button",
              onClick: M[8] || (M[8] = (_) => l("trashOpen"))
            }, [
              C($, {
                name: "Trash2",
                size: 17
              }),
              M[17] || (M[17] = u("span", { class: "cv-board-menu-text" }, [
                u("span", { class: "cv-board-menu-title" }, "Recently Deleted"),
                u("span", { class: "cv-board-menu-desc" }, "Recover what was deleted from this board, or delete it for good")
              ], -1)),
              a.value ? (g(), b("span", lB, E(a.value > 99 ? "99+" : a.value), 1)) : z("", !0)
            ]),
            u("button", {
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "shortcuts-button",
              onClick: M[9] || (M[9] = (_) => l("keysOpen"))
            }, [
              C($, {
                name: "Keyboard",
                size: 17
              }),
              M[18] || (M[18] = u("span", { class: "cv-board-menu-text" }, [
                u("span", { class: "cv-board-menu-title" }, "Keyboard Shortcuts"),
                u("span", { class: "cv-board-menu-desc" }, "Every key the board answers to")
              ], -1)),
              M[19] || (M[19] = u("kbd", { class: "cv-board-menu-kbd" }, "?", -1))
            ]),
            m(t).canOpenTour ? (g(), b("button", {
              key: 0,
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "tour-menu-item",
              onClick: f
            }, [
              C($, {
                name: "CircleHelp",
                size: 17
              }),
              M[20] || (M[20] = u("span", { class: "cv-board-menu-text" }, [
                u("span", { class: "cv-board-menu-title" }, "Take the Tour"),
                u("span", { class: "cv-board-menu-desc" }, "Three minutes on sessions, Tab, Studio view and Edit")
              ], -1))
            ])) : z("", !0),
            m(d) ? (g(), b("button", {
              key: 1,
              class: "cv-board-menu-item",
              role: "menuitem",
              "data-testid": "feedback-menu-item",
              onClick: M[10] || (M[10] = (_) => h("menu"))
            }, [
              C($, {
                name: "MessageSquareWarning",
                size: 17
              }),
              M[21] || (M[21] = u("span", { class: "cv-board-menu-text" }, [
                u("span", { class: "cv-board-menu-title" }, "Send Feedback"),
                u("span", { class: "cv-board-menu-desc" }, "Report a bug or share an idea, with a screenshot")
              ], -1)),
              M[22] || (M[22] = u("kbd", { class: "cv-board-menu-kbd" }, "`", -1))
            ])) : z("", !0)
          ])) : z("", !0)
        ])
      ])
    ], 32));
  }
});
function cB(i) {
  const e = [i.userAgentData && i.userAgentData.platform || "", i.platform || "", i.userAgent || ""].join(" ").toLowerCase();
  return /mac|iphone|ipad|ipod/.test(e) ? "mac" : /\bwin/.test(e) ? "windows" : /cros|chrome os|chromeos/.test(e) ? "chromeos" : /linux|x11|android/.test(e) ? "linux" : "other";
}
const ws = typeof navigator == "undefined" ? "other" : cB(navigator);
function kn(i, e = ws) {
  return e === "mac" ? i.metaKey : i.ctrlKey;
}
function uB(i, e = ws) {
  return e === "mac" ? i.ctrlKey : i.metaKey;
}
function sm(i = ws) {
  return i === "mac" ? { mod: "⌘", shift: "⇧", alt: "⌥", enter: "↵", del: "⌫", esc: "Esc" } : { mod: "Ctrl", shift: "Shift", alt: "Alt", enter: "Enter", del: "Del", esc: "Esc" };
}
function pn(i, e = ws) {
  const t = sm(e), s = (e === "mac" ? ["alt", "shift", "mod"] : ["mod", "alt", "shift"]).filter((r) => i.includes(r)).map((r) => t[r]), o = i.filter((r) => r !== "mod" && r !== "shift" && r !== "alt").map((r) => r === "enter" ? t.enter : r === "del" ? t.del : r === "esc" ? t.esc : r);
  return s.concat(o);
}
function En(i, e = ws) {
  return pn(i, e).join(e === "mac" ? "" : "+");
}
function z1(i = ws) {
  return i === "mac" ? ["shift", "mod", "Z"] : ["mod", "Y"];
}
const hB = ["aria-label", "aria-expanded"], pB = {
  class: "caret",
  "aria-hidden": "true"
}, fB = ["aria-checked", "data-testid", "onClick"], mB = { class: "tick" }, gB = { class: "lb" }, bB = { class: "k" }, vB = /* @__PURE__ */ Pe({
  __name: "ShapeTool",
  setup(i) {
    const { board: e } = Ze(), t = [
      { id: "rect", label: "Rectangle", icon: "Square", key: "M" },
      { id: "ellipse", label: "Ellipse", icon: "Circle", key: "L" },
      { id: "line", label: "Line", icon: "Slash", key: "\\" },
      { id: "arrow", label: "Arrow", icon: "ArrowUpRight", key: En(["shift", "\\"]) }
    ], n = I(() => t.find((o) => o.id === e.ui.shapeKind) || t[0]);
    function s() {
      e.ui.addMenu = !1, e.ui.shapeMenu = !e.ui.shapeMenu;
    }
    return (o, r) => (g(), b("div", {
      class: G(["v2-shapetool", { on: m(e).ui.shapeArmed, "is-open": m(e).ui.shapeMenu }])
    }, [
      u("button", {
        class: "face cv-tool",
        "aria-label": "Shapes: " + n.value.label,
        "aria-haspopup": "menu",
        "aria-expanded": m(e).ui.shapeMenu,
        "data-testid": "shape-tool",
        onClick: s
      }, [
        C($, {
          name: n.value.icon,
          size: 17
        }, null, 8, ["name"]),
        u("span", pB, [
          C($, {
            name: "ChevronUp",
            size: 9,
            stroke: 2.5
          })
        ]),
        r[1] || (r[1] = u("span", { class: "tip" }, "Shapes", -1))
      ], 8, hB),
      m(e).ui.shapeMenu ? (g(), b("div", {
        key: 0,
        class: "v2-shapemenu",
        role: "menu",
        "data-testid": "shape-menu",
        onPointerdown: r[0] || (r[0] = Se(() => {
        }, ["stop"]))
      }, [
        r[2] || (r[2] = u("div", { class: "hd" }, "Shapes", -1)),
        (g(), b(j, null, be(t, (a) => u("button", {
          key: a.id,
          class: G(["row", { on: a.id === m(e).ui.shapeKind }]),
          role: "menuitemradio",
          "aria-checked": m(e).ui.shapeArmed && a.id === m(e).ui.shapeKind,
          "data-testid": "shape-" + a.id,
          onClick: (l) => m(e).armShape(a.id)
        }, [
          u("span", mB, [
            a.id === m(e).ui.shapeKind ? (g(), Ce($, {
              key: 0,
              name: "Check",
              size: 13
            })) : z("", !0)
          ]),
          C($, {
            name: a.icon,
            size: 15
          }, null, 8, ["name"]),
          u("span", gB, E(a.label), 1),
          u("span", bB, E(a.key), 1)
        ], 10, fB)), 64))
      ], 32)) : z("", !0)
    ], 2));
  }
}), yB = { class: "cv-badge" }, xB = { class: "cv-badge is-lib" }, wB = /* @__PURE__ */ Pe({
  __name: "PlaceMenu",
  emits: ["computer"],
  setup(i, { emit: e }) {
    const t = e, { board: n } = Ze(), s = /* @__PURE__ */ K(null);
    function o() {
      n.ui.placeMenu = !1, t("computer");
    }
    function r() {
      n.openLibrary({ purpose: "place" });
    }
    function a(l) {
      const d = l.target;
      !s.value || !d || s.value.contains(d) || d.closest("[data-place-toggle]") || (n.ui.placeMenu = !1);
    }
    return ot(() => window.addEventListener("pointerdown", a, !0)), We(() => window.removeEventListener("pointerdown", a, !0)), (l, d) => (g(), b("div", {
      ref_key: "el",
      ref: s,
      class: "v2-placemenu",
      role: "menu",
      "aria-label": "Place images",
      "data-testid": "place-menu"
    }, [
      u("button", {
        class: "am-row",
        role: "menuitem",
        "data-testid": "place-computer",
        onClick: o
      }, [
        u("span", yB, [
          C($, {
            name: "Upload",
            size: 15
          })
        ]),
        d[0] || (d[0] = u("span", { class: "am-main" }, [
          u("span", { class: "am-name" }, "From your computer"),
          u("span", { class: "am-sub" }, "Or drop images anywhere on the board")
        ], -1))
      ]),
      u("button", {
        class: "am-row",
        role: "menuitem",
        "data-testid": "place-library",
        onClick: r
      }, [
        u("span", xB, [
          C($, {
            name: "Library",
            size: 15
          })
        ]),
        d[1] || (d[1] = u("span", { class: "am-main" }, [
          u("span", { class: "am-name" }, "From your Library"),
          u("span", { class: "am-sub" }, "Your generations, uploads and favorites")
        ], -1))
      ])
    ], 512));
  }
}), kB = ["aria-label", "data-testid"], _B = { class: "dp-card" }, SB = { class: "dp-media" }, MB = ["poster", "autoplay", "data-slide"], TB = ["src"], CB = ["src"], IB = ["src", "data-slide"], AB = { class: "dp-tag" }, PB = { class: "dp-body" }, EB = { class: "dp-foot" }, RB = {
  class: "dp-dots",
  role: "tablist",
  "aria-label": "Slides"
}, zB = ["aria-selected", "aria-label", "onClick"], $B = { class: "dp-cta" }, DB = 500, OB = 160, qm = 3400, Km = 8e3, n8 = /* @__PURE__ */ Pe({
  __name: "DemoPopout",
  props: {
    slides: {},
    media: {},
    tag: {},
    tagIcon: {},
    cta: {},
    placement: { default: "above" },
    disabled: { type: Boolean, default: !1 },
    testid: { default: "demo-popout" }
  },
  emits: ["open"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches, o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(0), a = /* @__PURE__ */ K(qm / 1e3), l = I(() => t.slides[r.value]);
    let d = 0, c = 0, h = 0;
    function f() {
      clearTimeout(c), !(o.value || t.disabled) && (clearTimeout(d), d = window.setTimeout(v, DB));
    }
    function p() {
      clearTimeout(d), clearTimeout(c), c = window.setTimeout(y, OB);
    }
    function y() {
      clearTimeout(d), clearTimeout(h), o.value = !1;
    }
    function v() {
      t.disabled || !t.slides.length || (w(), r.value = 0, o.value = !0, S());
    }
    let x = !1;
    function w() {
      if (!x) {
        x = !0;
        for (const P of t.slides) {
          const A = new Image();
          A.src = t.media + P.id + ".jpg";
        }
      }
    }
    function S() {
      if (clearTimeout(h), s) return;
      const P = l.value;
      a.value = (P.video ? Km : qm) / 1e3, h = window.setTimeout(_, P.video ? Km : qm);
    }
    function M(P) {
      r.value = (P + t.slides.length) % t.slides.length, S();
    }
    function _() {
      M(r.value + 1);
    }
    function T(P) {
      if (s) return;
      const A = P.target;
      Number.isFinite(A.duration) && A.duration > 0 && (a.value = Math.min(Km / 1e3, A.duration + 0.6), clearTimeout(h), h = window.setTimeout(_, a.value * 1e3));
    }
    function k() {
      y(), n("open");
    }
    return Ae(() => t.disabled, (P) => {
      P && y();
    }), We(() => {
      clearTimeout(d), clearTimeout(c), clearTimeout(h);
    }), (P, A) => (g(), b("span", {
      class: G(["dp-wrap", "is-" + i.placement]),
      onMouseenter: f,
      onMouseleave: p,
      onFocusin: f,
      onFocusout: p,
      onClick: y
    }, [
      Ss(P.$slots, "default", { open: o.value }),
      C(vt, { name: "dp-pop" }, {
        default: Xe(() => [
          o.value ? (g(), b("div", {
            key: 0,
            class: "dp-pop",
            role: "dialog",
            "aria-label": i.tag,
            "data-testid": i.testid,
            onClick: Se(k, ["stop"])
          }, [
            u("div", _B, [
              u("div", SB, [
                C(vt, { name: "dp-slide" }, {
                  default: Xe(() => [
                    l.value.video ? (g(), b("video", {
                      key: l.value.id,
                      poster: i.media + l.value.id + ".jpg",
                      autoplay: !m(s),
                      muted: "",
                      playsinline: "",
                      preload: "auto",
                      disablepictureinpicture: "",
                      "data-slide": l.value.id,
                      onLoadedmetadata: T
                    }, [
                      u("source", {
                        src: i.media + l.value.id + ".webm",
                        type: "video/webm"
                      }, null, 8, TB),
                      u("source", {
                        src: i.media + l.value.id + ".mp4",
                        type: "video/mp4"
                      }, null, 8, CB)
                    ], 40, MB)) : (g(), b("img", {
                      key: l.value.id,
                      src: i.media + l.value.id + ".jpg",
                      alt: "",
                      "data-slide": l.value.id,
                      draggable: "false"
                    }, null, 8, IB))
                  ]),
                  _: 1
                }),
                u("span", AB, [
                  C($, {
                    name: i.tagIcon,
                    size: 10
                  }, null, 8, ["name"]),
                  J(E(i.tag), 1)
                ])
              ]),
              u("div", PB, [
                C(vt, {
                  name: "dp-words",
                  mode: "out-in"
                }, {
                  default: Xe(() => [
                    (g(), b("div", {
                      key: l.value.id,
                      class: "dp-words"
                    }, [
                      u("b", null, E(l.value.title), 1),
                      u("span", null, E(l.value.text), 1)
                    ]))
                  ]),
                  _: 1
                }),
                u("div", EB, [
                  u("span", RB, [
                    (g(!0), b(j, null, be(i.slides, (R, D) => (g(), b("button", {
                      key: R.id,
                      role: "tab",
                      "aria-selected": D === r.value,
                      "aria-label": R.title,
                      class: G({ on: D === r.value }),
                      style: ce(D === r.value ? { "--d": a.value + "s" } : void 0),
                      onClick: Se((O) => M(D), ["stop"])
                    }, [
                      (g(), b("i", {
                        key: r.value + ":" + D
                      }))
                    ], 14, zB))), 128))
                  ]),
                  u("span", $B, [
                    J(E(i.cta), 1),
                    C($, {
                      name: "ChevronRight",
                      size: 12
                    })
                  ])
                ])
              ])
            ])
          ], 8, kB)) : z("", !0)
        ]),
        _: 1
      })
    ], 34));
  }
});
function tf(i) {
  if (!i.detail) return;
  const e = i.target instanceof Element ? i.target.closest("button") : null;
  e && e === document.activeElement && e.blur();
}
const i8 = "/img/board/prompt-library/", s8 = [
  { id: "start", video: !0, title: "Start from a prompt", text: "Open the prompt library from the toolbar, or from Start from a prompt when you add a session." },
  { id: "browse", video: !0, title: "Browse by picture", text: "Pick a kind and a category on the left, or search. Hover a tile to see the images it starts from." },
  { id: "use", video: !0, title: "Use it, or remix it", text: "Use prompt puts the words in your session. Remix sets up the whole example, images included." },
  { id: "session", video: !1, title: "On every session", text: "The same icon sits beside every session's prompt. A prompt picked there goes straight into it." },
  { id: "save", video: !0, title: "Save your own", text: "Keep the prompt behind a result you like, just for you or shared with the people you work with." },
  { id: "kinds", video: !1, title: "Generate or edit", text: "Image and Video each split in two: Generate starts from words, Edit from your own image." }
], o8 = "rd-board-prompt-library-seen";
function LB() {
  try {
    return window.localStorage.getItem(o8) === "1";
  } catch {
    return !1;
  }
}
const Bc = /* @__PURE__ */ K(typeof window != "undefined" && LB());
function BB() {
  if (!Bc.value) {
    Bc.value = !0;
    try {
      window.localStorage.setItem(o8, "1");
    } catch {
    }
  }
}
const FB = ["aria-expanded"], NB = {
  key: 0,
  class: "tip"
}, UB = ["aria-expanded"], GB = {
  key: 0,
  class: "lib-new",
  "aria-hidden": "true"
}, jB = ["aria-label", "onClick"], HB = { class: "tip" }, VB = { class: "key" }, WB = { class: "v2-placewrap" }, qB = ["aria-expanded"], KB = {
  key: 0,
  class: "tip"
}, YB = ["aria-pressed"], XB = /* @__PURE__ */ Pe({
  __name: "ToolRail",
  props: {
    away: { type: Boolean },
    onImage: { type: Function }
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = I(() => t.ui.library.open && !t.ui.library.sessionId);
    function s() {
      t.ui.addMenu = !1, t.ui.placeMenu = !1, t.promptLibrary.toggle(null);
    }
    const o = [
      { id: "select", icon: "MousePointer2", label: "Select", key: "V" },
      { id: "hand", icon: "Hand", label: "Pan", key: "H" }
    ];
    function r() {
      if (!t.hasLibrary) {
        e.onImage();
        return;
      }
      t.ui.addMenu = !1, t.ui.placeMenu = !t.ui.placeMenu;
    }
    return (a, l) => (g(), b("div", {
      class: G(["v2-railwrap", { "is-away": e.away }]),
      onPointerdown: l[6] || (l[6] = Se(() => {
      }, ["stop"]))
    }, [
      u("div", {
        class: "v2-rail",
        "data-testid": "tool-rail",
        onClick: l[5] || (l[5] = //@ts-ignore
        (...d) => m(tf) && m(tf)(...d))
      }, [
        u("button", {
          class: G(["cv-tool v2-add", { on: m(t).ui.addMenu }]),
          "aria-label": "Start a tool session",
          "aria-expanded": m(t).ui.addMenu,
          "data-testid": "all-tools",
          onClick: l[0] || (l[0] = (d) => m(t).addElement("tool"))
        }, [
          C($, {
            name: "Plus",
            size: 19,
            stroke: 2.4
          }),
          m(t).ui.addMenu ? z("", !0) : (g(), b("span", NB, "Start a tool session"))
        ], 10, FB),
        C(n8, {
          slides: m(s8),
          media: m(i8),
          tag: "Prompt library",
          "tag-icon": "LayoutTemplate",
          cta: "Open the prompt library",
          disabled: n.value,
          testid: "rail-prompts-demo",
          onOpen: s
        }, {
          default: Xe(() => [
            u("button", {
              class: G(["cv-tool v2-prompts", { on: n.value }]),
              "aria-label": "Start from a prompt",
              "aria-expanded": n.value,
              "data-testid": "rail-prompts",
              onClick: s
            }, [
              C($, {
                name: "LayoutTemplate",
                size: 15
              }),
              m(Bc) ? z("", !0) : (g(), b("span", GB))
            ], 10, UB)
          ]),
          _: 1
        }, 8, ["slides", "media", "disabled"]),
        l[11] || (l[11] = u("span", { class: "sep" }, null, -1)),
        (g(), b(j, null, be(o, (d) => u("button", {
          key: d.id,
          class: G(["cv-tool", { on: m(t).ui.mode === d.id && !m(t).ui.shapeArmed && !m(t).comments.ui.armed }]),
          "aria-label": d.label,
          onClick: (c) => m(t).setMode(d.id)
        }, [
          C($, {
            name: d.icon,
            size: 17
          }, null, 8, ["name"]),
          u("span", HB, [
            J(E(d.label), 1),
            u("span", VB, E(d.key), 1)
          ])
        ], 10, jB)), 64)),
        l[12] || (l[12] = u("span", { class: "sep" }, null, -1)),
        u("span", WB, [
          u("button", {
            class: G(["cv-tool", { on: m(t).ui.placeMenu }]),
            "aria-label": "Place image",
            "aria-expanded": m(t).hasLibrary ? m(t).ui.placeMenu : void 0,
            "data-place-toggle": "",
            "data-testid": "place-image",
            onClick: r
          }, [
            C($, {
              name: "Image",
              size: 17
            }),
            m(t).ui.placeMenu ? z("", !0) : (g(), b("span", KB, "Place image"))
          ], 10, qB),
          C(vt, { name: "v2-placemenu" }, {
            default: Xe(() => [
              m(t).ui.placeMenu ? (g(), Ce(wB, {
                key: 0,
                onComputer: l[1] || (l[1] = (d) => e.onImage())
              })) : z("", !0)
            ]),
            _: 1
          })
        ]),
        u("button", {
          class: "cv-tool",
          "aria-label": "Add note",
          onClick: l[2] || (l[2] = (d) => m(t).addElement("note"))
        }, [
          C($, {
            name: "StickyNote",
            size: 17
          }),
          l[7] || (l[7] = u("span", { class: "tip" }, [
            J("Add note"),
            u("span", { class: "key" }, "N")
          ], -1))
        ]),
        u("button", {
          class: "cv-tool",
          "aria-label": "Add frame",
          onClick: l[3] || (l[3] = (d) => m(t).addElement("frame"))
        }, [
          C($, {
            name: "Frame",
            size: 17
          }),
          l[8] || (l[8] = u("span", { class: "tip" }, [
            J("Add frame"),
            u("span", { class: "key" }, "F")
          ], -1))
        ]),
        C(vB),
        m(t).comments.enabled ? (g(), b(j, { key: 0 }, [
          l[10] || (l[10] = u("span", { class: "sep" }, null, -1)),
          u("button", {
            class: G(["cv-tool", { on: m(t).comments.ui.armed }]),
            "aria-label": "Comment",
            "aria-pressed": m(t).comments.ui.armed,
            "data-testid": "comment-tool",
            onClick: l[4] || (l[4] = (d) => m(t).comments.arm())
          }, [
            C($, {
              name: "MessageCirclePlus",
              size: 17
            }),
            l[9] || (l[9] = u("span", { class: "tip" }, [
              J("Comment"),
              u("span", { class: "key" }, "C")
            ], -1))
          ], 10, YB)
        ], 64)) : z("", !0)
      ])
    ], 34));
  }
});
function $1(i) {
  const e = /^(.*\/o\/)([^?#]+)(\?[^#]*)?$/.exec(i || "");
  if (!e) return null;
  let t;
  try {
    t = decodeURIComponent(e[2]);
  } catch {
    return null;
  }
  if (!/^(runnitResults|runnitUploads)\//.test(t) || t.includes("/thumbs/")) return null;
  const n = t.lastIndexOf("/"), s = t.slice(0, n) + "/thumbs/" + t.slice(n + 1).replace(/\.[^/.]+$/, "_512x512.webp");
  return e[1] + encodeURIComponent(s) + (e[3] || "");
}
const Ym = /* @__PURE__ */ Xt(/* @__PURE__ */ new Map()), Ew = /* @__PURE__ */ new Set();
function Bt(i) {
  const e = Ym.get(i);
  if (e) return e;
  const t = $1(i);
  if (!t) return i;
  if (!Ew.has(i) && typeof Image != "undefined") {
    Ew.add(i);
    const n = new Image();
    n.onload = () => Ym.set(i, t), n.onerror = () => Ym.set(i, i), n.src = t;
  }
  return t;
}
const om = [
  { id: "all", label: "All" },
  { id: "pinned", label: "Pinned" },
  { id: "image", label: "Image", match: /image/i },
  { id: "video", label: "Video", match: /video/i },
  { id: "threed", label: "3D", match: /3d/i },
  { id: "upscale", label: "Upscale", match: /upscale|enhance/i }
];
function r8(i, e, t, n) {
  const s = om.find((r) => r.id === e), o = t.trim().toLowerCase();
  return i.filter((r) => e === "pinned" && !n(r.id) || s && s.match && !s.match.test((r.kind || "") + " " + (r.name || "")) ? !1 : !o || ((r.kind || "") + " " + (r.name || "") + " " + (r.model || "")).toLowerCase().includes(o));
}
const JB = "start from a prompt prompts library featured saved my templates ideas";
function a8(i) {
  return i.trim().toLowerCase().split(/\s+/).filter(Boolean).every((e) => JB.includes(e));
}
function l8(i, e, t) {
  if (e === "pinned") return [];
  const n = om.find((o) => o.id === e), s = t.trim().toLowerCase();
  return i.filter((o) => n && n.match && !n.match.test(o.name) ? !1 : !s || (o.name + " " + o.desc + " " + o.models.map((r) => r.name).join(" ")).toLowerCase().includes(s));
}
function Bi(i) {
  return i.models.find((e) => e.id === i.defaultModelId) || i.models[0] || null;
}
function nf(i, e, t = [], n = []) {
  const s = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  for (const a of e)
    for (const l of a.models)
      s.set(l.id, l), o.has(l.name) || o.set(l.name, l);
  for (const a of t)
    s.has(a.id) || (s.set(a.id, a), o.has(a.name) || o.set(a.name, a));
  const r = [...s.values()].sort((a, l) => a.name.localeCompare(l.name, void 0, { numeric: !0, sensitivity: "base" }));
  return { source: i, kits: e, all: r, byId: s, byName: o, tools: n };
}
function pl(i) {
  return i === "imageEdit" ? "image" : i === "videoEdit" ? "video" : i || "";
}
function Fc(i, e, t) {
  const n = pl(e.id);
  let s = !1;
  for (const o of i.kits)
    if (o.models.some((r) => r.id === t.id)) {
      if (pl(o.id) === n) return !0;
      s = !0;
    }
  return !s && pl(t.kitId) === n;
}
function _v(i, e, t) {
  const n = t && i.kits.find((s) => s.id === t) || null;
  return n && Fc(i, n, e) ? n : i.kits.find((s) => s.models.some((o) => o.id === e.id)) || i.kits.find((s) => s.id === e.kitId) || i.kits.find((s) => pl(s.id) === pl(e.kitId)) || null;
}
const ZB = { class: "rs-empty-body" }, QB = { class: "rs-empty-kinds" }, eF = ["tabindex", "title", "data-testid", "onClick"], tF = ["tabindex"], nF = { class: "rs-head" }, iF = { class: "rs-count" }, sF = { class: "rs-tools" }, oF = { class: "v2-dock-search rs-search" }, rF = ["tabindex"], aF = { class: "v2-dock-filters rs-filters" }, lF = ["tabindex", "onClick"], dF = ["data-ref-session", "title", "onClick"], cF = {
  key: 1,
  class: "busy"
}, uF = { class: "k" }, hF = {
  key: 2,
  class: "pin"
}, pF = { class: "rs-meta" }, fF = { class: "rs-name" }, mF = { class: "rs-sub" }, gF = { class: "kind" }, bF = {
  key: 0,
  class: "rs-n"
}, vF = ["title", "aria-label", "aria-pressed", "tabindex", "data-testid", "onClick"], yF = {
  key: 0,
  class: "rs-none"
}, xF = {
  key: 0,
  class: "rs-more"
}, Rw = 4, Xm = 40, wF = /* @__PURE__ */ Pe({
  __name: "RecentSessions",
  setup(i) {
    const { board: e } = Ze(), t = /* @__PURE__ */ K(!1), n = /* @__PURE__ */ K(!1), s = /* @__PURE__ */ K(""), o = /* @__PURE__ */ K("all");
    let r = 0;
    const a = () => {
      clearTimeout(r), r = window.setTimeout(() => {
        t.value = !0;
      }, 90);
    }, l = () => {
      clearTimeout(r), !n.value && (r = window.setTimeout(() => {
        t.value = !1;
      }, 240));
    };
    We(() => clearTimeout(r));
    const d = I(() => (e.docRev.value, e.ui.recentIds.length, e.recentTools())), c = I(() => e.promptTool.value ? e.promptTool.value.id : null), h = I(() => t.value ? r8(d.value, o.value, s.value, (_) => e.isPinned(_)) : d.value), f = I(() => d.value.length - Rw), p = /* @__PURE__ */ K(Xm), y = I(() => t.value ? h.value.slice(0, p.value) : h.value.slice(0, Rw));
    Ae([s, o, t], () => {
      p.value = Xm;
    });
    function v(_) {
      const T = _.target;
      T.scrollTop + T.clientHeight > T.scrollHeight - 150 && p.value < h.value.length && (p.value += Xm);
    }
    function x(_) {
      _.stopPropagation(), _.key === "Escape" ? (s.value = "", _.target.blur(), t.value = !1) : _.key === "Enter" && h.value.length && e.openSession(h.value[0]);
    }
    function w() {
      e.openAddMenu(), t.value = !1;
    }
    const S = I(() => e.catalog.value.kits.filter((_) => !!Bi(_)));
    function M(_) {
      const T = e.catalog.value.kits.find((P) => P.id === _), k = T && Bi(T);
      !T || !k || (e.pickModel(T, k), t.value = !1);
    }
    return (_, T) => d.value.length ? (g(), b("div", {
      key: 1,
      class: G(["rs", { "is-open": t.value }]),
      "data-testid": "recent-sessions",
      onMouseenter: a,
      onMouseleave: l,
      onPointerdown: T[5] || (T[5] = Se(() => {
      }, ["stop"]))
    }, [
      u("div", nF, [
        T[10] || (T[10] = u("span", { class: "rs-eyebrow" }, "Tool sessions", -1)),
        u("span", iF, E(d.value.length), 1)
      ]),
      u("div", sF, [
        u("div", oF, [
          C($, {
            name: "Search",
            size: 13
          }),
          kt(u("input", {
            "onUpdate:modelValue": T[1] || (T[1] = (k) => s.value = k),
            type: "text",
            placeholder: "Search tool sessions",
            tabindex: t.value ? 0 : -1,
            onFocus: T[2] || (T[2] = (k) => n.value = !0),
            onBlur: T[3] || (T[3] = (k) => {
              n.value = !1, l();
            }),
            onKeydown: x
          }, null, 40, rF), [
            [Zt, s.value]
          ]),
          s.value ? (g(), b("button", {
            key: 0,
            class: "cv-iconbtn",
            style: { width: "22px", height: "22px" },
            onClick: T[4] || (T[4] = (k) => s.value = "")
          }, [
            C($, {
              name: "X",
              size: 11
            })
          ])) : z("", !0)
        ]),
        u("div", aF, [
          (g(!0), b(j, null, be(m(om), (k) => (g(), b("button", {
            key: k.id,
            class: G(["v2-fchip", { on: o.value === k.id }]),
            tabindex: t.value ? 0 : -1,
            onClick: (P) => o.value = k.id
          }, E(k.label), 11, lF))), 128))
        ])
      ]),
      u("div", {
        class: "rs-list",
        onScrollPassive: v
      }, [
        (g(!0), b(j, null, be(y.value, (k) => (g(), b("div", {
          key: k.id,
          class: G(["rs-item", { "is-pinned": m(e).isPinned(k.id) }])
        }, [
          u("button", {
            class: G(["rs-row", { on: k.id === c.value, "is-ref-target": m(e).ui.refSession === k.id }]),
            "data-ref-session": k.id,
            "data-ref-reveal": "",
            title: t.value ? void 0 : k.name,
            onClick: (P) => m(e).openSession(k)
          }, [
            u("span", {
              class: "rs-shot",
              style: ce(k.thumbs && k.thumbs.length ? { backgroundImage: 'url("' + m(Bt)(k.thumbs[0]) + '")' } : void 0)
            }, [
              !k.thumbs || !k.thumbs.length ? (g(), Ce($, {
                key: 0,
                name: k.icon,
                size: 15
              }, null, 8, ["name"])) : z("", !0),
              m(e).generating[k.id] ? (g(), b("span", cF)) : z("", !0),
              u("span", uF, [
                C($, {
                  name: k.icon,
                  size: 9
                }, null, 8, ["name"])
              ]),
              m(e).isPinned(k.id) ? (g(), b("span", hF, [
                C($, {
                  name: "Pin",
                  size: 8
                })
              ])) : z("", !0)
            ], 4),
            u("span", pF, [
              u("span", fF, E(k.name), 1),
              u("span", mF, [
                u("span", gF, E(k.kind), 1),
                k.model ? (g(), b(j, { key: 0 }, [
                  T[11] || (T[11] = u("span", { class: "sep" }, "·", -1)),
                  J(E(k.model), 1)
                ], 64)) : z("", !0)
              ])
            ]),
            k.count ? (g(), b("span", bF, E(k.count), 1)) : z("", !0)
          ], 10, dF),
          u("button", {
            class: G(["rs-pin", { on: m(e).isPinned(k.id) }]),
            title: m(e).isPinned(k.id) ? "Unpin" : "Pin to the top",
            "aria-label": (m(e).isPinned(k.id) ? "Unpin " : "Pin ") + k.name,
            "aria-pressed": m(e).isPinned(k.id),
            tabindex: t.value ? 0 : -1,
            "data-testid": "rs-pin-" + k.id,
            onClick: Se((P) => m(e).togglePinned(k.id), ["stop"])
          }, [
            C($, {
              name: "Pin",
              size: 12
            })
          ], 10, vF)
        ], 2))), 128)),
        t.value && !h.value.length ? (g(), b("div", yF, E(o.value === "pinned" && !s.value.trim() ? "Nothing pinned yet. Pin a session to keep it at the top." : "No tool sessions match"), 1)) : z("", !0)
      ], 32),
      !t.value && f.value > 0 ? (g(), b("span", xF, "+" + E(f.value), 1)) : z("", !0),
      T[12] || (T[12] = u("div", { class: "rs-pad" }, null, -1))
    ], 34)) : (g(), b("div", {
      key: 0,
      class: G(["rs rs-empty", { "is-open": t.value }]),
      "data-testid": "recent-sessions",
      onMouseenter: a,
      onMouseleave: l,
      onPointerdown: T[0] || (T[0] = Se(() => {
      }, ["stop"]))
    }, [
      T[8] || (T[8] = u("div", { class: "rs-head" }, [
        u("span", { class: "rs-eyebrow" }, "Tool sessions"),
        u("span", { class: "rs-count" }, "0")
      ], -1)),
      u("div", ZB, [
        u("button", {
          class: "rs-empty-slot",
          title: "Start a tool session",
          onClick: w
        }, [
          C($, {
            name: "Plus",
            size: 16
          })
        ]),
        T[6] || (T[6] = u("span", { class: "rs-empty-txt" }, [
          u("span", { class: "t" }, "No tool sessions yet"),
          u("span", { class: "s" }, "Each generator you add to the board keeps its prompts and results here.")
        ], -1))
      ]),
      u("div", QB, [
        (g(!0), b(j, null, be(S.value, (k) => (g(), b("button", {
          key: k.id,
          type: "button",
          class: "rs-empty-kind",
          tabindex: t.value ? 0 : -1,
          title: "New " + k.name + " session",
          "data-testid": "start-kind-" + k.id,
          onClick: (P) => M(k.id)
        }, [
          C($, {
            name: k.icon,
            size: 12
          }, null, 8, ["name"]),
          J(E(k.name), 1)
        ], 8, eF))), 128))
      ]),
      u("button", {
        class: "rs-empty-cta",
        tabindex: t.value ? 0 : -1,
        onClick: w
      }, [
        C($, {
          name: "Plus",
          size: 13
        }),
        T[7] || (T[7] = J(" Start a tool session", -1))
      ], 8, tF),
      T[9] || (T[9] = u("div", { class: "rs-pad" }, null, -1))
    ], 34));
  }
}), kF = { class: "am-view fwd" }, _F = { class: "am-searchrow" }, SF = { class: "am-search" }, MF = { class: "am-rows" }, TF = {
  key: 0,
  class: "am-eyebrow"
}, CF = ["data-testid", "onMouseenter", "onClick"], IF = { class: "cv-badge" }, AF = { class: "am-main" }, PF = { class: "am-name" }, EF = { class: "am-sub" }, RF = { class: "am-go" }, zF = { class: "cv-badge is-prompts" }, $F = { class: "am-go" }, DF = {
  key: 2,
  class: "am-none"
}, OF = /* @__PURE__ */ Pe({
  __name: "AddToolMenu",
  setup(i) {
    const { board: e } = Ze(), t = /* @__PURE__ */ K(""), n = /* @__PURE__ */ K(0), s = /* @__PURE__ */ K(null), o = I(() => l8(e.catalog.value.kits, "all", t.value)), r = I(() => a8(t.value)), a = I(() => o.value.length + (r.value ? 1 : 0));
    Ae(t, () => {
      n.value = 0;
    }), ot(() => {
      s.value && s.value.focus({ preventScroll: !0 });
    });
    function l(h) {
      if (h === o.value.length && r.value) {
        d();
        return;
      }
      const f = o.value[h];
      if (!f) return;
      const p = Bi(f);
      p && e.pickModel(f, p);
    }
    function d() {
      e.ui.addMenu = !1, e.promptLibrary.open(null);
    }
    function c(h) {
      h.key === "Escape" ? (h.stopPropagation(), t.value ? t.value = "" : e.ui.addMenu = !1) : h.key === "ArrowDown" ? (h.preventDefault(), n.value = Math.min(a.value - 1, n.value + 1)) : h.key === "ArrowUp" ? (h.preventDefault(), n.value = Math.max(0, n.value - 1)) : h.key === "Enter" && (h.preventDefault(), l(n.value));
    }
    return (h, f) => (g(), b("div", {
      class: "cv-addmenu at-rail",
      "data-testid": "add-menu",
      onPointerdown: f[4] || (f[4] = Se(() => {
      }, ["stop"]))
    }, [
      u("div", kF, [
        u("div", _F, [
          u("div", SF, [
            C($, {
              name: "Search",
              size: 13
            }),
            kt(u("input", {
              ref_key: "inputEl",
              ref: s,
              "onUpdate:modelValue": f[0] || (f[0] = (p) => t.value = p),
              type: "text",
              placeholder: "Search generators",
              onKeydown: c
            }, null, 544), [
              [Zt, t.value]
            ]),
            t.value ? (g(), b("button", {
              key: 0,
              class: "cv-iconbtn",
              style: { width: "22px", height: "22px" },
              title: "Clear",
              onClick: f[1] || (f[1] = (p) => t.value = "")
            }, [
              C($, {
                name: "X",
                size: 11
              })
            ])) : z("", !0)
          ]),
          u("button", {
            class: "am-close",
            title: "Close",
            onClick: f[2] || (f[2] = (p) => m(e).ui.addMenu = !1)
          }, [
            C($, {
              name: "X",
              size: 14
            })
          ])
        ]),
        u("div", MF, [
          o.value.length ? (g(), b("div", TF, "New tool session")) : z("", !0),
          (g(!0), b(j, null, be(o.value, (p, y) => (g(), b("button", {
            key: p.id,
            class: G(["am-row", { "is-active": n.value === y }]),
            "data-testid": "add-kit-" + p.id,
            onMouseenter: (v) => n.value = y,
            onClick: (v) => l(y)
          }, [
            u("span", IF, [
              C($, {
                name: p.icon,
                size: 15
              }, null, 8, ["name"])
            ]),
            u("span", AF, [
              u("div", PF, E(p.name), 1),
              u("div", EF, E(p.desc), 1)
            ]),
            u("span", RF, [
              C($, {
                name: "Plus",
                size: 13
              })
            ])
          ], 42, CF))), 128)),
          r.value ? (g(), b(j, { key: 1 }, [
            u("div", {
              class: G(["am-eyebrow", { "is-apart": o.value.length }])
            }, "Start from a prompt", 2),
            u("button", {
              class: G(["am-row", { "is-active": n.value === o.value.length }]),
              "data-testid": "add-menu-prompts",
              onMouseenter: f[3] || (f[3] = (p) => n.value = o.value.length),
              onClick: d
            }, [
              u("span", zF, [
                C($, {
                  name: "LayoutTemplate",
                  size: 15
                })
              ]),
              f[5] || (f[5] = u("span", { class: "am-main" }, [
                u("div", { class: "am-name" }, "Prompt library"),
                u("div", { class: "am-sub" }, "Featured prompts and your saved ones")
              ], -1)),
              u("span", $F, [
                C($, {
                  name: "ChevronRight",
                  size: 14
                })
              ])
            ], 34)
          ], 64)) : z("", !0),
          a.value ? z("", !0) : (g(), b("div", DF, "Nothing matches “" + E(t.value.trim()) + "”", 1))
        ])
      ])
    ], 32));
  }
}), _a = 2, Os = 10, Sv = 52;
function LF(i, e, t) {
  let n = i.x + _a, s = !1;
  n + e.w > t.w - Os && (i.x - _a - e.w >= Os ? (n = i.x - _a - e.w, s = !0) : n = Math.max(Os, t.w - Os - e.w));
  let o = i.y + _a, r = !1;
  return o + e.h > t.h - Os && (i.y - _a - e.h >= Sv + Os ? (o = i.y - _a - e.h, r = !0) : o = Math.max(Sv + Os, t.h - Os - e.h)), { left: n, top: o, up: r, leftward: s };
}
function BF(i, e) {
  return Math.max(160, Math.min(e, i - Sv - Os * 2));
}
function D1(i, e, t, n = {}) {
  const s = (o) => {
    const r = o.target;
    i.value && r && i.value.contains(r) || t();
  };
  ot(() => {
    const o = i.value;
    if (!o) return;
    const a = (o.offsetParent || document.body).getBoundingClientRect(), l = { w: a.width, h: a.height }, d = e();
    n.maxH && (o.style.maxHeight = BF(l.h, n.maxH) + "px");
    const c = LF({ x: d.x - a.left, y: d.y - a.top }, { w: o.offsetWidth, h: o.offsetHeight }, l);
    o.style.left = c.left + "px", o.style.top = c.top + "px", n.fixHeight && (o.style.height = o.offsetHeight + "px"), o.style.setProperty("--pm-origin", (c.up ? "bottom" : "top") + " " + (c.leftward ? "right" : "left")), window.addEventListener("pointerdown", s, !0), n.keepOnResize || window.addEventListener("resize", t);
  }), We(() => {
    window.removeEventListener("pointerdown", s, !0), window.removeEventListener("resize", t);
  });
}
function FF(i, e, t, n, s) {
  const o = t + n;
  if (!o || i < 0 || i >= o) return 0;
  const r = i < t, a = Math.floor((t - 1) / s) * s;
  return e === "ArrowRight" ? r ? Math.min(t - 1, i + 1) : i : e === "ArrowLeft" ? r ? Math.max(0, i - 1) : i : e === "ArrowDown" ? r ? i < a ? Math.min(t - 1, i + s) : n ? t : i : Math.min(o - 1, i + 1) : r ? i >= s ? i - s : i : i === t ? t ? a : i : i - 1;
}
const NF = {
  key: 0,
  class: "bd-pm-eyebrow"
}, UF = ["data-testid", "onClick"], GF = { class: "bd-pm-ic" }, jF = { class: "lbl" }, HF = {
  class: "bd-pm-add",
  "aria-hidden": "true"
}, VF = {
  key: 1,
  class: "bd-pm-sep",
  role: "separator"
}, WF = { class: "bd-pm-ic is-prompts" }, qF = ["data-testid", "onClick"], KF = { class: "bd-pm-ic is-plain" }, YF = { class: "lbl" }, XF = { key: 0 }, JF = /* @__PURE__ */ Pe({
  __name: "CanvasMenu",
  props: {
    menu: {},
    onImage: { type: Function }
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = /* @__PURE__ */ K(null), s = I(() => t.catalog.value.kits.filter((f) => Bi(f)).map((f) => ({
      id: "kit-" + f.id,
      icon: f.icon,
      label: f.name,
      run: () => {
        const p = Bi(f);
        p && t.pickModel(f, p, e.menu.at);
      }
    }))), o = {
      rect: { label: "Rectangle", icon: "Square", key: "M" },
      ellipse: { label: "Ellipse", icon: "Circle", key: "L" },
      line: { label: "Line", icon: "Slash", key: "\\" },
      arrow: { label: "Arrow", icon: "ArrowUpRight", key: "" }
    }, r = I(() => o[t.ui.shapeKind] || o.rect), a = I(() => {
      const f = e.menu.at, p = [
        { id: "note", icon: "StickyNote", label: "Sticky note", key: "N", plain: !0, run: () => t.addElement("note", f) },
        { id: "frame", icon: "Frame", label: "Frame", key: "F", plain: !0, run: () => t.addElement("frame", f) },
        { id: "shape", icon: r.value.icon, label: r.value.label, key: r.value.key, plain: !0, run: () => {
          l(), t.addShape(f);
        } }
      ];
      if (e.onImage) {
        const y = e.onImage;
        p.push({ id: "image", icon: "ImagePlus", label: "Image from computer", plain: !0, run: () => {
          l(), y(f);
        } });
      }
      return t.hasLibrary && p.push({ id: "library", icon: "Library", label: "Image from Library", plain: !0, run: () => {
        l(), t.openLibrary({ purpose: "place", at: f });
      } }), t.canLinkBoards && p.push({ id: "board-link", icon: "Link2", label: "Link to a board", plain: !0, run: () => t.openBoardLinkMenu(e.menu.x, e.menu.y) }), t.comments.enabled && p.push({ id: "comment", icon: "MessageCirclePlus", label: "Comment", key: "C", plain: !0, run: () => {
        l(), t.comments.startAt(f);
      } }), p;
    }), l = () => {
      t.ui.canvasMenu = null;
    };
    D1(n, () => e.menu, l);
    function d() {
      const f = e.menu.at;
      l(), t.promptLibrary.open(null, { at: f });
    }
    ot(() => {
      n.value && n.value.focus({ preventScroll: !0 });
    });
    function c() {
      return n.value ? Array.from(n.value.querySelectorAll(".bd-pm-row")) : [];
    }
    function h(f) {
      const p = f.key;
      if (p === "ArrowDown" || p === "ArrowUp" || p === "Home" || p === "End") {
        f.preventDefault(), f.stopPropagation();
        const y = c(), v = y.indexOf(document.activeElement), x = p === "Home" ? 0 : p === "End" ? y.length - 1 : v < 0 ? p === "ArrowDown" ? 0 : y.length - 1 : (v + (p === "ArrowDown" ? 1 : -1) + y.length) % y.length;
        y[x] && y[x].focus();
      } else if (p === "Escape")
        f.preventDefault(), f.stopPropagation(), l();
      else if (!f.metaKey && !f.ctrlKey && !f.altKey && /^[nfc]$/i.test(p)) {
        f.preventDefault(), f.stopPropagation();
        const y = a.value.find((v) => v.id === { n: "note", f: "frame", c: "comment" }[p.toLowerCase()]);
        y && y.run();
      } else p === "Tab" ? f.preventDefault() : p === "Enter" || p === " " ? f.stopPropagation() : p !== "Shift" && p !== "Meta" && p !== "Control" && p !== "Alt" && l();
    }
    return (f, p) => (g(), b("div", {
      ref_key: "el",
      ref: n,
      class: "bd-pointmenu bd-canvasmenu",
      role: "menu",
      "aria-label": "Add to the board here",
      tabindex: "-1",
      "data-testid": "canvas-menu",
      onKeydown: h,
      onPointerdown: p[3] || (p[3] = Se(() => {
      }, ["stop"])),
      onContextmenu: p[4] || (p[4] = Se(() => {
      }, ["prevent"]))
    }, [
      s.value.length ? (g(), b("div", NF, "New tool session")) : z("", !0),
      (g(!0), b(j, null, be(s.value, (y) => (g(), b("button", {
        key: y.id,
        class: "bd-pm-row",
        role: "menuitem",
        tabindex: "-1",
        "data-testid": "canvas-menu-" + y.id,
        onMouseenter: p[0] || (p[0] = (v) => v.currentTarget.focus({ preventScroll: !0 })),
        onClick: (v) => y.run()
      }, [
        u("span", GF, [
          C($, {
            name: y.icon,
            size: 13
          }, null, 8, ["name"])
        ]),
        u("span", jF, E(y.label), 1),
        u("span", HF, [
          C($, {
            name: "Plus",
            size: 12
          })
        ])
      ], 40, UF))), 128)),
      s.value.length ? (g(), b("div", VF)) : z("", !0),
      p[6] || (p[6] = u("div", { class: "bd-pm-eyebrow" }, "Start from a prompt", -1)),
      u("button", {
        class: "bd-pm-row",
        role: "menuitem",
        tabindex: "-1",
        "data-testid": "canvas-menu-prompts",
        onMouseenter: p[1] || (p[1] = (y) => y.currentTarget.focus({ preventScroll: !0 })),
        onClick: d
      }, [
        u("span", WF, [
          C($, {
            name: "LayoutTemplate",
            size: 13
          })
        ]),
        p[5] || (p[5] = u("span", { class: "lbl" }, "Prompt library", -1))
      ], 32),
      p[7] || (p[7] = u("div", {
        class: "bd-pm-sep",
        role: "separator"
      }, null, -1)),
      (g(!0), b(j, null, be(a.value, (y) => (g(), b("button", {
        key: y.id,
        class: "bd-pm-row",
        role: "menuitem",
        tabindex: "-1",
        "data-testid": "canvas-menu-" + y.id,
        onMouseenter: p[2] || (p[2] = (v) => v.currentTarget.focus({ preventScroll: !0 })),
        onClick: (v) => y.run()
      }, [
        u("span", KF, [
          C($, {
            name: y.icon,
            size: 13
          }, null, 8, ["name"])
        ]),
        u("span", YF, E(y.label), 1),
        y.key ? (g(), b("kbd", XF, E(y.key), 1)) : z("", !0)
      ], 40, qF))), 128))
    ], 544));
  }
}), ZF = { class: "am-searchrow sf-searchrow" }, QF = { class: "am-search" }, eN = { class: "v2-dock-filters sf-filters" }, tN = ["onClick"], nN = { class: "sf-kits" }, iN = ["data-i", "title", "aria-label", "data-testid", "onMousemove", "onClick"], sN = { class: "bd-pm-ic sf-kit-ic" }, oN = {
  class: "sf-add",
  "aria-hidden": "true"
}, rN = { class: "nm" }, aN = ["data-i"], lN = { class: "bd-pm-ic is-prompts" }, dN = { class: "sf-eyebrow" }, cN = { class: "n" }, uN = ["data-i", "data-testid", "onMousemove", "onClick"], hN = {
  key: 1,
  class: "busy"
}, pN = { class: "k" }, fN = { class: "sf-meta" }, mN = { class: "rs-name" }, gN = { class: "rs-sub" }, bN = { class: "kind" }, vN = {
  key: 0,
  class: "sf-n"
}, yN = ["title", "aria-label", "aria-pressed", "onClick"], xN = {
  key: 3,
  class: "sf-none"
}, wN = { class: "sf-foot" }, kN = { key: 0 }, _N = 3, Lu = 40, SN = /* @__PURE__ */ Pe({
  __name: "SessionFinder",
  props: {
    menu: {}
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = pn(["enter"])[0], a = /* @__PURE__ */ K(""), l = /* @__PURE__ */ K("all"), d = /* @__PURE__ */ K(0), c = I(() => l8(t.catalog.value.kits.filter((R) => Bi(R)), l.value, a.value)), h = I(() => (t.docRev.value, t.ui.recentIds.length, t.ui.pinnedIds.length, t.recentTools())), f = I(() => r8(h.value, l.value, a.value, (R) => t.isPinned(R))), p = /* @__PURE__ */ K(Lu), y = I(() => f.value.slice(0, p.value));
    function v(R) {
      const D = R.target;
      D.scrollTop + D.clientHeight > D.scrollHeight - 150 && p.value < f.value.length && (p.value += Lu);
    }
    Ae([a, l], () => {
      d.value = 0, p.value = Lu, s.value && (s.value.scrollTop = 0);
    });
    const x = I(() => ["all", "image", "video"].includes(l.value) && a8(a.value)), w = I(() => c.value.length + (x.value ? 1 : 0)), S = I(() => d.value < w.value), M = I(() => !w.value && !f.value.length), _ = () => {
      t.ui.finder = null;
    };
    D1(n, () => e.menu, _, { maxH: 500, fixHeight: !0, keepOnResize: !0 }), ot(() => {
      o.value && o.value.focus({ preventScroll: !0 });
    });
    function T() {
      const R = e.menu.at, D = l.value === "image" || l.value === "video" ? l.value : null;
      _(), t.promptLibrary.open(null, { at: R, kind: D });
    }
    function k(R) {
      const D = c.value.length;
      if (R < D) {
        const F = c.value[R], te = Bi(F);
        te && t.pickModel(F, te, e.menu.at);
        return;
      }
      if (R === D && x.value) {
        T();
        return;
      }
      const O = f.value[R - w.value];
      O && (_(), t.openSession(O));
    }
    async function P() {
      await nt();
      const R = s.value && s.value.querySelector('[data-i="' + d.value + '"]');
      R && R.scrollIntoView({ block: "nearest" });
    }
    function A(R) {
      R.stopPropagation();
      const D = R.key, O = w.value;
      if (D === "Escape")
        R.preventDefault(), a.value ? a.value = "" : _();
      else if (D === "ArrowDown" || D === "ArrowUp" || (D === "ArrowLeft" || D === "ArrowRight") && S.value && O > 0) {
        R.preventDefault();
        const F = FF(d.value, D, O, f.value.length, _N);
        F - O >= p.value && (p.value += Lu), d.value = F, P();
      } else D === "Enter" && (R.preventDefault(), k(d.value));
    }
    return (R, D) => (g(), b("div", {
      ref_key: "el",
      ref: n,
      class: "bd-pointmenu bd-finder",
      role: "dialog",
      "aria-label": "Find or start a tool session",
      "data-testid": "session-finder",
      onPointerdown: D[10] || (D[10] = Se(() => {
      }, ["stop"])),
      onContextmenu: D[11] || (D[11] = Se(() => {
      }, ["prevent"]))
    }, [
      u("div", ZF, [
        u("div", QF, [
          C($, {
            name: "Search",
            size: 13
          }),
          kt(u("input", {
            ref_key: "inputEl",
            ref: o,
            "onUpdate:modelValue": D[0] || (D[0] = (O) => a.value = O),
            type: "text",
            placeholder: "Search sessions and generators",
            "aria-label": "Search sessions and generators",
            "data-testid": "session-finder-search",
            onKeydown: A
          }, null, 544), [
            [Zt, a.value]
          ]),
          a.value ? (g(), b("button", {
            key: 0,
            class: "cv-iconbtn",
            style: { width: "22px", height: "22px" },
            title: "Clear",
            onMousedown: D[1] || (D[1] = Se(() => {
            }, ["prevent"])),
            onClick: D[2] || (D[2] = (O) => a.value = "")
          }, [
            C($, {
              name: "X",
              size: 11
            })
          ], 32)) : z("", !0)
        ]),
        u("button", {
          class: "am-close",
          title: "Close",
          onClick: _
        }, [
          C($, {
            name: "X",
            size: 14
          })
        ])
      ]),
      u("div", eN, [
        (g(!0), b(j, null, be(m(om), (O) => (g(), b("button", {
          key: O.id,
          class: G(["v2-fchip", { on: l.value === O.id }]),
          onMousedown: D[3] || (D[3] = Se(() => {
          }, ["prevent"])),
          onClick: (F) => l.value = O.id
        }, E(O.label), 43, tN))), 128))
      ]),
      u("div", {
        ref_key: "body",
        ref: s,
        class: "sf-body",
        onScrollPassive: v
      }, [
        c.value.length ? (g(), b(j, { key: 0 }, [
          D[12] || (D[12] = u("div", { class: "sf-eyebrow" }, "New tool session", -1)),
          u("div", nN, [
            (g(!0), b(j, null, be(c.value, (O, F) => (g(), b("button", {
              key: O.id,
              class: G(["sf-kit", { "is-active": d.value === F }]),
              "data-i": F,
              title: O.desc,
              "aria-label": "New " + O.name + " session",
              "data-testid": "finder-kit-" + O.id,
              onMousemove: (te) => d.value = F,
              onMousedown: D[4] || (D[4] = Se(() => {
              }, ["prevent"])),
              onClick: (te) => k(F)
            }, [
              u("span", sN, [
                C($, {
                  name: O.icon,
                  size: 13
                }, null, 8, ["name"]),
                u("span", oN, [
                  C($, {
                    name: "Plus",
                    size: 9
                  })
                ])
              ]),
              u("span", rN, E(O.name), 1)
            ], 42, iN))), 128))
          ])
        ], 64)) : z("", !0),
        x.value ? (g(), b(j, { key: 1 }, [
          D[15] || (D[15] = u("div", { class: "sf-eyebrow" }, "Start from a prompt", -1)),
          u("button", {
            class: G(["sf-prompts", { "is-active": d.value === c.value.length }]),
            "data-i": c.value.length,
            title: "Featured prompts and your saved ones",
            "data-testid": "finder-prompts",
            onMousemove: D[5] || (D[5] = (O) => d.value = c.value.length),
            onMousedown: D[6] || (D[6] = Se(() => {
            }, ["prevent"])),
            onClick: D[7] || (D[7] = (O) => k(c.value.length))
          }, [
            u("span", lN, [
              C($, {
                name: "LayoutTemplate",
                size: 13
              })
            ]),
            D[13] || (D[13] = u("span", { class: "nm" }, "Prompt library", -1)),
            D[14] || (D[14] = u("span", { class: "sub" }, "Featured prompts and your saved ones", -1))
          ], 42, aN)
        ], 64)) : z("", !0),
        f.value.length ? (g(), b(j, { key: 2 }, [
          u("div", dN, [
            D[16] || (D[16] = J("Tool sessions", -1)),
            u("span", cN, E(f.value.length), 1)
          ]),
          (g(!0), b(j, null, be(y.value, (O, F) => (g(), b("div", {
            key: O.id,
            class: G(["sf-item", { "is-active": d.value === w.value + F, "is-pinned": m(t).isPinned(O.id) }])
          }, [
            u("button", {
              class: "sf-row",
              "data-i": w.value + F,
              "data-testid": "finder-session-" + O.id,
              onMousemove: (te) => d.value = w.value + F,
              onMousedown: D[8] || (D[8] = Se(() => {
              }, ["prevent"])),
              onClick: (te) => k(w.value + F)
            }, [
              u("span", {
                class: "rs-shot",
                style: ce(O.thumbs && O.thumbs.length ? { backgroundImage: 'url("' + m(Bt)(O.thumbs[0]) + '")' } : void 0)
              }, [
                !O.thumbs || !O.thumbs.length ? (g(), Ce($, {
                  key: 0,
                  name: O.icon,
                  size: 15
                }, null, 8, ["name"])) : z("", !0),
                m(t).generating[O.id] ? (g(), b("span", hN)) : z("", !0),
                u("span", pN, [
                  C($, {
                    name: O.icon,
                    size: 9
                  }, null, 8, ["name"])
                ])
              ], 4),
              u("span", fN, [
                u("span", mN, E(O.name), 1),
                u("span", gN, [
                  u("span", bN, E(O.kind), 1),
                  O.model ? (g(), b(j, { key: 0 }, [
                    D[17] || (D[17] = u("span", { class: "sep" }, "·", -1)),
                    J(E(O.model), 1)
                  ], 64)) : z("", !0)
                ])
              ]),
              O.count ? (g(), b("span", vN, E(O.count), 1)) : z("", !0)
            ], 40, uN),
            u("button", {
              class: G(["sf-pin", { on: m(t).isPinned(O.id) }]),
              title: m(t).isPinned(O.id) ? "Unpin" : "Pin to the top",
              "aria-label": (m(t).isPinned(O.id) ? "Unpin " : "Pin ") + O.name,
              "aria-pressed": m(t).isPinned(O.id),
              tabindex: "-1",
              onMousedown: D[9] || (D[9] = Se(() => {
              }, ["prevent"])),
              onClick: Se((te) => m(t).togglePinned(O.id), ["stop"])
            }, [
              C($, {
                name: "Pin",
                size: 12
              })
            ], 42, yN)
          ], 2))), 128))
        ], 64)) : z("", !0),
        M.value ? (g(), b("div", xN, E(a.value.trim() ? "Nothing matches “" + a.value.trim() + "”" : l.value === "pinned" ? "Nothing pinned yet. Pin a session to keep it at the top." : "No tool sessions match"), 1)) : z("", !0)
      ], 544),
      u("div", wN, [
        D[18] || (D[18] = u("span", null, [
          u("kbd", null, "↑"),
          u("kbd", null, "↓"),
          J("Move")
        ], -1)),
        M.value ? z("", !0) : (g(), b("span", kN, [
          u("kbd", null, E(m(r)), 1),
          J(E(S.value ? "Start here" : "Open"), 1)
        ])),
        D[19] || (D[19] = u("span", null, [
          u("kbd", null, "Esc"),
          J("Close")
        ], -1))
      ])
    ], 544));
  }
}), MN = { class: "am-searchrow sf-searchrow" }, TN = { class: "am-search" }, CN = { class: "sf-eyebrow" }, IN = {
  key: 0,
  class: "n"
}, AN = {
  key: 0,
  class: "sf-none"
}, PN = {
  key: 1,
  class: "sf-none"
}, EN = ["data-i", "data-testid", "onMousemove", "onClick"], RN = { class: "bl-ic" }, zN = { class: "sf-meta" }, $N = { class: "rs-name" }, DN = { class: "rs-sub" }, ON = ["data-i"], LN = { class: "bl-ic" }, BN = { class: "sf-meta" }, FN = { class: "rs-name" }, NN = {
  key: 3,
  class: "sf-none"
}, UN = /* @__PURE__ */ Pe({
  __name: "BoardLinkMenu",
  props: {
    menu: {}
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(""), a = /* @__PURE__ */ K(0), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(!1), c = /* @__PURE__ */ K(!1), h = I(() => {
      t.docRev.value;
      const T = /* @__PURE__ */ new Set();
      for (const k of t.store.all()) k.type === "note" && k.link && T.add(k.link.boardId);
      return T;
    }), f = I(() => {
      const T = l.value || [], k = r.value.trim().toLowerCase();
      return k ? T.filter((P) => P.title.toLowerCase().includes(k)) : T;
    }), p = I(() => !!r.value.trim() && !f.value.some((T) => T.title.trim().toLowerCase() === r.value.trim().toLowerCase())), y = I(() => f.value.length + (p.value ? 1 : 0)), v = () => {
      t.ui.boardLinkMenu = null;
    };
    D1(n, () => e.menu, v, { maxH: 440, fixHeight: !0, keepOnResize: !0 }), ot(async () => {
      o.value && o.value.focus({ preventScroll: !0 });
      try {
        l.value = await t.linkableBoards();
      } catch (T) {
        console.error("[board] boards not listed", T), d.value = !0, l.value = [];
      }
    });
    let x = 0, w = 0;
    Ae(r, (T) => {
      a.value = 0, s.value && (s.value.scrollTop = 0), clearTimeout(x), x = window.setTimeout(async () => {
        const k = ++w;
        try {
          const P = await t.linkableBoards(T);
          k === w && (l.value = P);
        } catch (P) {
          console.error("[board] boards not searched", P);
        }
      }, 250);
    }), We(() => clearTimeout(x));
    async function S(T) {
      if (c.value) return;
      const k = f.value[T];
      if (k) {
        v(), t.addBoardLink({ id: k.id, title: k.title }, e.menu.at);
        return;
      }
      if (p.value && T === f.value.length) {
        c.value = !0;
        const P = e.menu.at, A = r.value.trim();
        v(), await t.addNewBoardLink(A, P);
      }
    }
    async function M() {
      await nt();
      const T = s.value && s.value.querySelector('[data-i="' + a.value + '"]');
      T && T.scrollIntoView({ block: "nearest" });
    }
    function _(T) {
      T.stopPropagation();
      const k = T.key;
      if (k === "Escape")
        T.preventDefault(), r.value ? r.value = "" : v();
      else if (k === "ArrowDown" || k === "ArrowUp") {
        if (T.preventDefault(), !y.value) return;
        a.value = (a.value + (k === "ArrowDown" ? 1 : -1) + y.value) % y.value, M();
      } else k === "Enter" && (T.preventDefault(), S(a.value));
    }
    return (T, k) => (g(), b("div", {
      ref_key: "el",
      ref: n,
      class: "bd-pointmenu bd-finder bd-linkmenu",
      role: "dialog",
      "aria-label": "Link to a board",
      "data-testid": "board-link-menu",
      onPointerdown: k[5] || (k[5] = Se(() => {
      }, ["stop"])),
      onContextmenu: k[6] || (k[6] = Se(() => {
      }, ["prevent"]))
    }, [
      u("div", MN, [
        u("div", TN, [
          C($, {
            name: "Search",
            size: 13
          }),
          kt(u("input", {
            ref_key: "inputEl",
            ref: o,
            "onUpdate:modelValue": k[0] || (k[0] = (P) => r.value = P),
            type: "text",
            placeholder: "Find a board, or name a new one",
            "aria-label": "Find a board, or name a new one",
            "data-testid": "board-link-search",
            onKeydown: _
          }, null, 544), [
            [Zt, r.value]
          ])
        ]),
        u("button", {
          class: "am-close",
          title: "Close",
          onClick: v
        }, [
          C($, {
            name: "X",
            size: 14
          })
        ])
      ]),
      u("div", {
        ref_key: "body",
        ref: s,
        class: "sf-body"
      }, [
        u("div", CN, [
          k[7] || (k[7] = J("Link to a board ", -1)),
          l.value ? (g(), b("span", IN, E(l.value.length), 1)) : z("", !0)
        ]),
        l.value ? d.value ? (g(), b("div", PN, "Your boards couldn't be listed. You can still name a new one.")) : z("", !0) : (g(), b("div", AN, "Finding your boards…")),
        (g(!0), b(j, null, be(f.value, (P, A) => (g(), b("div", {
          key: P.id,
          class: G(["sf-item", { "is-active": a.value === A }])
        }, [
          u("button", {
            class: "sf-row bl-row",
            "data-i": A,
            "data-testid": "board-link-pick-" + P.id,
            onMousemove: (R) => a.value = A,
            onMousedown: k[1] || (k[1] = Se(() => {
            }, ["prevent"])),
            onClick: (R) => S(A)
          }, [
            u("span", RN, [
              C($, {
                name: "LayoutDashboard",
                size: 14
              })
            ]),
            u("span", zN, [
              u("span", $N, E(P.title), 1),
              u("span", DN, E(h.value.has(P.id) ? "Linked here already" : P.at ? "Updated " + m(Jn)(P.at) : "Board"), 1)
            ])
          ], 40, EN)
        ], 2))), 128)),
        p.value ? (g(), b("div", {
          key: 2,
          class: G(["sf-item", { "is-active": a.value === f.value.length }])
        }, [
          u("button", {
            class: "sf-row bl-row is-new",
            "data-i": f.value.length,
            "data-testid": "board-link-new",
            onMousemove: k[2] || (k[2] = (P) => a.value = f.value.length),
            onMousedown: k[3] || (k[3] = Se(() => {
            }, ["prevent"])),
            onClick: k[4] || (k[4] = (P) => S(f.value.length))
          }, [
            u("span", LN, [
              C($, {
                name: "Plus",
                size: 14
              })
            ]),
            u("span", BN, [
              u("span", FN, "New board: " + E(r.value.trim()), 1),
              k[8] || (k[8] = u("span", { class: "rs-sub" }, "Made now, and linked here", -1))
            ])
          ], 40, ON)
        ], 2)) : z("", !0),
        l.value && !d.value && !f.value.length && !p.value ? (g(), b("div", NN, E(l.value.length ? "No board by that name." : "No other boards yet. Type a name to make one."), 1)) : z("", !0)
      ], 512),
      k[9] || (k[9] = u("div", { class: "sf-foot" }, [
        u("span", null, "Its card opens the board, which links back here")
      ], -1))
    ], 544));
  }
});
function Ro(i) {
  return !!i && i.type === "frame" && !!i.locked;
}
const GN = [
  { id: "amethyst", label: "Amethyst" },
  { id: "vista", label: "Vista" },
  { id: "sky", label: "Sky" },
  { id: "mint", label: "Mint" },
  { id: "amber", label: "Amber" },
  { id: "rose", label: "Rose" },
  { id: "glass", label: "Glass" }
], Bu = { w: 248, h: 124 }, Rt = { w: 252, h: 160 }, Nc = 64;
function He(i) {
  if (i.type === "tool") {
    const e = i.scale || 1;
    return { x: i.x, y: i.y, w: Math.round(Rt.w * e), h: Math.round((i.collapsed ? Nc : Rt.h) * e) };
  }
  return i.type === "chat" && i.collapsed ? { x: i.x, y: i.y, w: i.w, h: Nc } : { x: i.x, y: i.y, w: i.w, h: i.h };
}
function Ya(i, e) {
  return i.x < e.x + e.w && i.x + i.w > e.x && i.y < e.y + e.h && i.y + i.h > e.y;
}
function uc(i) {
  if (!i.length) return null;
  let e = 1 / 0, t = 1 / 0, n = -1 / 0, s = -1 / 0;
  for (const o of i)
    o.x < e && (e = o.x), o.y < t && (t = o.y), o.x + o.w > n && (n = o.x + o.w), o.y + o.h > s && (s = o.y + o.h);
  return { x: e, y: t, w: n - e, h: s - t };
}
const Mv = {
  frame: "frames",
  image: "content",
  shape: "annotations",
  note: "annotations",
  tool: "annotations",
  chat: "annotations",
  // never in the store (studio/records.ts); named so the table stays whole
  studio: "annotations"
}, Ri = { w: 252, h: 160 }, jN = 0.01, HN = 4;
function tr(i) {
  return Number.isFinite(i) ? Math.min(HN, Math.max(jN, i)) : 1;
}
function Tv(i, e, t) {
  return { x: (e - i.x) / i.zoom, y: (t - i.y) / i.zoom };
}
function Cv(i, e, t, n) {
  const s = tr(i.zoom * n), o = s / i.zoom;
  return { zoom: s, x: e - (e - i.x) * o, y: t - (t - i.y) * o };
}
function VN(i, e) {
  const t = tr(i * e), n = 5e-3;
  return i < 1 - n && t > 1 || i > 1 + n && t < 1 ? 1 : t;
}
function rm(i, e, t, n = 120, s = 1) {
  const o = Math.max(1, i.w), r = Math.max(1, i.h), a = tr(Math.min(s, (e - n * 2) / o, (t - n * 2) / r));
  return {
    zoom: a,
    x: (e - o * a) / 2 - i.x * a,
    y: (t - r * a) / 2 - i.y * a
  };
}
function rl(i, e, t, n, s) {
  const o = tr(t);
  return { zoom: o, x: n / 2 - i * o, y: s / 2 - e * o };
}
function fl(i, e, t, n = 0) {
  const s = n / i.zoom;
  return {
    x: -i.x / i.zoom - s,
    y: -i.y / i.zoom - s,
    w: e / i.zoom + s * 2,
    h: t / i.zoom + s * 2
  };
}
function Jm(i) {
  return WN(0.16, 1, 0.3, 1, i);
}
function WN(i, e, t, n, s) {
  let o = s;
  for (let r = 0; r < 6; r++) {
    const a = zw(i, t, o) - s, l = qN(i, t, o);
    if (Math.abs(a) < 1e-5 || Math.abs(l) < 1e-6) break;
    o -= a / l;
  }
  return o = Math.min(1, Math.max(0, o)), zw(e, n, o);
}
function zw(i, e, t) {
  return ((1 - 3 * e + 3 * i) * t + (3 * e - 6 * i)) * t * t + 3 * i * t;
}
function qN(i, e, t) {
  return 3 * (1 - 3 * e + 3 * i) * t * t + 2 * (3 * e - 6 * i) * t + 3 * i;
}
function KN(i, e, t, n, s) {
  const o = Tv(i, n / 2, s / 2), r = Tv(e, n / 2, s / 2), a = Math.exp(Math.log(i.zoom) + (Math.log(e.zoom) - Math.log(i.zoom)) * t), l = o.x + (r.x - o.x) * t, d = o.y + (r.y - o.y) * t;
  return { zoom: a, x: n / 2 - l * a, y: s / 2 - d * a };
}
const ld = 188, Fu = 124, $w = 28, YN = /* @__PURE__ */ Pe({
  __name: "Minimap",
  setup(i) {
    const { board: e } = Ze(), t = /* @__PURE__ */ K(null), n = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K(!1), o = /* @__PURE__ */ qe(null);
    let r = 0;
    function a() {
      !e.engine || e.view.w < 2 || e.view.h < 2 || (o.value = fl(e.cam.value, e.view.w, e.view.h, 0));
    }
    Ae(() => e.cam.value, () => {
      if (!o.value) {
        a();
        return;
      }
      clearTimeout(r), r = window.setTimeout(a, 240);
    }, { immediate: !0 });
    const l = I(() => {
      e.docRev.value;
      const S = e.store.bounds(), M = o.value;
      let _ = S || M || { x: 0, y: 0, w: 1200, h: 800 };
      if (S && M) {
        const O = Math.min(S.x, M.x), F = Math.min(S.y, M.y);
        _ = { x: O, y: F, w: Math.max(S.x + S.w, M.x + M.w) - O, h: Math.max(S.y + S.h, M.y + M.h) - F };
      }
      const T = Math.max(80, Math.max(_.w, _.h) * 0.06), k = _.x - T, P = _.y - T, A = _.w + T * 2, R = _.h + T * 2, D = Math.min(ld / A, Fu / R);
      return { bx: k, by: P, k: D, ox: (ld - A * D) / 2, oy: (Fu - R * D) / 2 };
    }), d = I(() => {
      const S = l.value, M = e.cam.value, _ = -M.x / M.zoom, T = -M.y / M.zoom;
      return {
        left: (_ - S.bx) * S.k + S.ox,
        top: (T - S.by) * S.k + S.oy,
        width: e.view.w / M.zoom * S.k,
        height: e.view.h / M.zoom * S.k
      };
    });
    let c = 0, h = 0;
    function f() {
      if (c) return;
      const S = Math.max(0, 90 - (performance.now() - h));
      c = window.setTimeout(() => {
        c = 0, h = performance.now(), p();
      }, S);
    }
    function p() {
      const S = t.value;
      if (!S) return;
      const M = Math.min(2, window.devicePixelRatio || 1);
      S.width !== ld * M && (S.width = ld * M, S.height = Fu * M);
      const _ = S.getContext("2d");
      if (!_) return;
      _.setTransform(M, 0, 0, M, 0, 0), _.clearRect(0, 0, ld, Fu);
      const T = l.value, k = e.ui.lightCanvas, P = [];
      for (const A of e.store.all()) {
        const R = He(A), D = (R.x - T.bx) * T.k + T.ox, O = (R.y - T.by) * T.k + T.oy, F = Math.max(2, R.w * T.k), te = Math.max(2, R.h * T.k), ee = A.type === "frame" ? 0 : A.type === "image" ? 1 : 2;
        P.push([ee, () => {
          A.type === "frame" ? (_.fillStyle = k ? "rgba(19,24,40,0.05)" : "rgba(255,255,255,0.08)", _.fillRect(D, O, F, te), _.strokeStyle = k ? "rgba(19,24,40,0.16)" : "rgba(255,255,255,0.14)", _.lineWidth = 1, _.strokeRect(D + 0.5, O + 0.5, F - 1, te - 1)) : A.type === "shape" ? (_.strokeStyle = A.stroke || (k ? "rgba(19,24,40,0.35)" : "rgba(255,255,255,0.3)"), _.lineWidth = 1, _.strokeRect(D + 0.5, O + 0.5, Math.max(1, F - 1), Math.max(1, te - 1))) : (_.fillStyle = A.type === "tool" ? "rgba(153,104,223,0.65)" : A.type === "chat" ? "rgba(194,164,236,0.8)" : A.type === "note" ? "rgba(163,167,245,0.55)" : k ? "rgba(19,24,40,0.28)" : "rgba(255,255,255,0.30)", _.fillRect(D, O, F, te));
        }]);
      }
      P.sort((A, R) => A[0] - R[0]);
      for (const A of P) A[1]();
    }
    Ae(() => e.docRev.value, f), Ae(() => e.ui.lightCanvas, f), Ae(l, f), ot(() => {
      a(), p();
    }), We(() => {
      clearTimeout(c), clearTimeout(r);
    });
    function y(S) {
      const M = n.value;
      if (!M) return;
      const _ = M.getBoundingClientRect(), T = l.value, k = (S.clientX - _.left - T.ox) / T.k + T.bx, P = (S.clientY - _.top - T.oy) / T.k + T.by, A = e.cam.value;
      e.setCamera({ zoom: A.zoom, x: e.view.w / 2 - k * A.zoom, y: e.view.h / 2 - P * A.zoom });
    }
    function v(S) {
      e.ui.miniGoing || (s.value = !0, S.currentTarget.setPointerCapture(S.pointerId), y(S));
    }
    function x() {
      const S = n.value, M = S && S.parentElement ? S.parentElement.querySelector(".cv-zoomhud") : null;
      if (!S || !M) {
        e.ui.miniOpen = !1;
        return;
      }
      const _ = S.getBoundingClientRect(), T = M.getBoundingClientRect(), k = T.right - 5 - $w / 2 - (_.left + _.width / 2), P = T.top + T.height / 2 - (_.top + _.height / 2);
      e.ui.miniGoing = !0, S.classList.add("is-going"), S.offsetWidth, S.style.transform = "translate(" + k + "px, " + P + "px) scale(" + ($w / _.width).toFixed(3) + ")", S.style.opacity = "0", S.style.borderRadius = "40px";
    }
    function w(S) {
      e.ui.miniGoing && S.propertyName === "transform" && (e.ui.miniOpen = !1, e.ui.miniGoing = !1);
    }
    return (S, M) => (g(), b("div", {
      ref_key: "self",
      ref: n,
      class: "cv-minimap",
      "data-testid": "minimap",
      onTransitionend: w,
      onPointerdown: Se(v, ["stop"]),
      onPointermove: M[1] || (M[1] = (_) => s.value && y(_)),
      onPointerup: M[2] || (M[2] = (_) => s.value = !1),
      onPointercancel: M[3] || (M[3] = (_) => s.value = !1)
    }, [
      u("canvas", {
        ref_key: "canvas",
        ref: t
      }, null, 512),
      u("button", {
        class: "mm-hide",
        title: "Hide minimap",
        onPointerdown: M[0] || (M[0] = Se(() => {
        }, ["stop"])),
        onClick: Se(x, ["stop"])
      }, [
        C($, {
          name: "Minus",
          size: 12
        })
      ], 32),
      u("span", {
        class: "mm-view",
        style: ce({ left: d.value.left + "px", top: d.value.top + "px", width: d.value.width + "px", height: d.value.height + "px" })
      }, null, 4)
    ], 544));
  }
}), XN = ["title", "aria-label"], JN = ["title", "aria-label", "aria-pressed"], ZN = ["disabled"], QN = /* @__PURE__ */ Pe({
  __name: "ZoomHud",
  setup(i) {
    const { board: e } = Ze(), t = I(() => Math.round(e.cam.value.zoom * 100) + "%");
    return (n, s) => (g(), b("div", {
      class: "cv-zoomhud",
      "data-testid": "zoom-hud",
      onPointerdown: s[7] || (s[7] = Se(() => {
      }, ["stop"])),
      onClick: s[8] || (s[8] = //@ts-ignore
      (...o) => m(tf) && m(tf)(...o))
    }, [
      u("button", {
        title: "Zoom out",
        "aria-label": "Zoom out",
        onClick: s[0] || (s[0] = (o) => m(e).zoomBy(1 / 1.25))
      }, [
        C($, {
          name: "Minus",
          size: 14
        })
      ]),
      u("button", {
        class: "pct",
        title: "Reset to 100%",
        "data-testid": "zoom-pct",
        onClick: s[1] || (s[1] = (o) => m(e).zoomTo(1))
      }, E(t.value), 1),
      u("button", {
        title: "Zoom in",
        "aria-label": "Zoom in",
        onClick: s[2] || (s[2] = (o) => m(e).zoomBy(1.25))
      }, [
        C($, {
          name: "Plus",
          size: 14
        })
      ]),
      u("button", {
        title: "Fit to content",
        "aria-label": "Fit to content",
        onClick: s[3] || (s[3] = (o) => m(e).fit())
      }, [
        C($, {
          name: "Scan",
          size: 14
        })
      ]),
      s[10] || (s[10] = u("span", { class: "sep" }, null, -1)),
      u("button", {
        title: m(e).ui.lightCanvas ? "Dark board" : "Light board",
        "aria-label": m(e).ui.lightCanvas ? "Dark board" : "Light board",
        "data-testid": "light-toggle",
        onClick: s[4] || (s[4] = (o) => m(e).ui.lightCanvas = !m(e).ui.lightCanvas)
      }, [
        C($, {
          name: m(e).ui.lightCanvas ? "Moon" : "Sun",
          size: 14
        }, null, 8, ["name"])
      ], 8, XN),
      u("button", {
        class: G(["grid-toggle", { "is-off": !m(e).ui.showGrid }]),
        title: m(e).ui.showGrid ? "Hide grid" : "Show grid",
        "aria-label": m(e).ui.showGrid ? "Hide grid" : "Show grid",
        "aria-pressed": m(e).ui.showGrid,
        "data-testid": "grid-toggle",
        onClick: s[5] || (s[5] = (o) => m(e).ui.showGrid = !m(e).ui.showGrid)
      }, [
        C($, {
          name: "Grid3x3",
          size: 14
        })
      ], 10, JN),
      !m(e).ui.miniOpen || m(e).ui.miniGoing ? (g(), b(j, { key: 0 }, [
        s[9] || (s[9] = u("span", { class: "sep" }, null, -1)),
        u("button", {
          class: G(["mm-slot", { "is-landing": m(e).ui.miniGoing }]),
          disabled: m(e).ui.miniGoing,
          title: "Show minimap",
          "aria-label": "Show minimap",
          onClick: s[6] || (s[6] = (o) => m(e).ui.miniOpen = !0)
        }, [
          C($, {
            name: "Map",
            size: 14
          })
        ], 10, ZN)
      ], 64)) : z("", !0)
    ], 32));
  }
}), io = { stroke: "#9968df", sw: 3 };
function am(i) {
  const e = Math.max(0, i.w), t = Math.max(0, i.h), n = i.sc || [0, 0];
  return { x1: n[0] * e, y1: n[1] * t, x2: (1 - n[0]) * e, y2: (1 - n[1]) * t };
}
function d8(i) {
  const { x1: e, y1: t, x2: n, y2: s } = am(i), o = i.sw == null ? io.sw : i.sw, r = Math.atan2(s - t, n - e), a = Math.max(11, o * 3.6), l = 0.44;
  return [
    [n - a * Math.cos(r - l), s - a * Math.sin(r - l)],
    [n, s],
    [n - a * Math.cos(r + l), s - a * Math.sin(r + l)]
  ];
}
function eU(i) {
  return /^#[0-9a-f]{6}$/i.test(i) ? parseInt(i.slice(1), 16) : /^#[0-9a-f]{3}$/i.test(i) ? parseInt(i.slice(1).split("").map((e) => e + e).join(""), 16) : 10053855;
}
function Dw(i, e) {
  const t = Math.max(0, e.w), n = Math.max(0, e.h), s = e.sw == null ? io.sw : e.sw, o = eU(e.stroke || io.stroke), r = { width: s, color: o, cap: "round", join: "round" };
  if (i.clear(), e.shape === "rect")
    i.roundRect(0, 0, t, n, Math.min(10, t / 8, n / 8)), i.stroke(r);
  else if (e.shape === "ellipse")
    i.ellipse(t / 2, n / 2, Math.max(0.01, t / 2), Math.max(0.01, n / 2)), i.stroke(r);
  else {
    const { x1: a, y1: l, x2: d, y2: c } = am(e);
    if (i.moveTo(a, l), i.lineTo(d, c), i.stroke(r), e.shape === "arrow") {
      const h = d8(e);
      i.moveTo(h[0][0], h[0][1]), i.lineTo(h[1][0], h[1][1]), i.lineTo(h[2][0], h[2][1]), i.stroke(r);
    }
  }
}
function Zm(i, e, t, n, s, o) {
  const r = s - t, a = o - n, l = r * r + a * a;
  let d = l ? ((i - t) * r + (e - n) * a) / l : 0;
  d = Math.max(0, Math.min(1, d));
  const c = t + d * r, h = n + d * a;
  return Math.hypot(i - c, e - h);
}
function tU(i, e, t, n) {
  const s = e - i.x, o = t - i.y, r = Math.max(0, i.w), a = Math.max(0, i.h);
  if (i.shape === "rect") {
    const f = s >= -n && o >= -n && s <= r + n && o <= a + n, p = s > n && o > n && s < r - n && o < a - n;
    return f && !p;
  }
  if (i.shape === "ellipse") {
    const f = Math.max(0.01, r / 2), p = Math.max(0.01, a / 2), y = s - f, v = o - p, x = y * y / (f * f) + v * v / (p * p) - 1, w = 2 * y / (f * f), S = 2 * v / (p * p), M = Math.hypot(w, S);
    return M ? Math.abs(x) / M <= n : Math.min(f, p) <= n;
  }
  const { x1: l, y1: d, x2: c, y2: h } = am(i);
  if (Zm(s, o, l, d, c, h) <= n) return !0;
  if (i.shape === "arrow") {
    const f = d8(i);
    if (Zm(s, o, f[0][0], f[0][1], f[1][0], f[1][1]) <= n || Zm(s, o, f[1][0], f[1][1], f[2][0], f[2][1]) <= n) return !0;
  }
  return !1;
}
const Xn = {
  /** a pin control, off */
  pin: "Pin for yourself (only you see your pins)",
  /** a pin control, on */
  unpin: "Unpin",
  /** the badge on a pinned picture */
  badge: "Pinned by you (only you see it)",
  /** the toast on your first pin, once */
  first: "Pinned for you. Only you see your pins: find them under Pinned in the board's history."
};
function lm(i) {
  return {
    url: i.url,
    w: i.w,
    h: i.h,
    label: i.label || i.prompt || "Result",
    asset: i.asset || null,
    resultId: i.id,
    sessionId: i.sessionId,
    video: !!i.video,
    videoSrc: i.videoSrc || null,
    dur: i.dur || null
  };
}
function c8(i, e) {
  if (e && e.url === i.src) return lm(e);
  const t = ga(i.asset);
  return {
    url: i.src,
    w: t ? t.width : i.w,
    h: t ? t.height : i.h,
    label: i.label || "Image",
    asset: i.asset || null,
    resultId: i.resultId || null,
    sessionId: i.sessionId || null,
    video: !!i.video,
    videoSrc: i.videoSrc || null,
    dur: i.dur || null
  };
}
function nU(i) {
  return {
    url: i.url,
    w: i.w || 4,
    h: i.h || 3,
    label: i.label || "Image",
    asset: i.asset || null,
    video: !!i.video,
    videoSrc: i.video && i.videoSrc || null
  };
}
const iU = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
function St() {
  const i = new Uint8Array(20);
  crypto.getRandomValues(i);
  let e = "";
  for (let t = 0; t < 20; t++) e += iU[i[t] % 62];
  return e;
}
var sU = Object.defineProperty, oU = (i, e, t) => e in i ? sU(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Nu = (i, e, t) => oU(i, typeof e != "symbol" ? e + "" : e, t);
function rU(i, e = 30) {
  const t = /^(\d+(?:\.\d+)?)\s*(s|m)$/.exec((i || "").trim());
  return t ? Math.round(Number(t[1]) * (t[2] === "m" ? 60 : 1)) : e;
}
function Rl(i) {
  return String(i || "").toLowerCase().replace(/[^a-z0-9.\s]+/g, " ").replace(/\s+/g, " ").trim();
}
function aU(i) {
  return i.fields.find((e) => e.placement === "reference" && (e.kind === "image" || e.kind === "images")) || null;
}
class u8 {
  constructor(e, t = !1) {
    Nu(this, "catalog", e), Nu(this, "isAdmin", t), Nu(this, "list", []), Nu(this, "byIdMap", /* @__PURE__ */ new Map());
    for (const n of e.kits)
      for (const s of n.models) {
        const o = this.byIdMap.get(s.id);
        if (o) {
          o.kits.push(n);
          continue;
        }
        const r = aU(s), a = {
          id: s.id,
          name: s.name,
          desc: s.desc,
          model: s,
          kits: [n],
          imageField: r,
          maxImages: r ? r.kind === "images" ? Math.max(1, r.maxImages || 4) : 1 : 0,
          needsImage: !!r && !!r.required,
          secs: rU(s.time)
        };
        this.byIdMap.set(s.id, a), this.list.push(a);
      }
  }
  entries() {
    return this.list;
  }
  get(e) {
    return this.byIdMap.get(e) || null;
  }
  /** It's on this board's tool list. */
  has(e) {
    return this.byIdMap.has(e);
  }
  /**
   * Tools whose names match what someone typed: every word they typed starts
   * a word of the name ("chatgpt image 2.5" finds both ChatGPT Image 2.5
   * tools, "flux 3" finds Flux 3 Image). Exact names first, then shorter ones.
   */
  search(e) {
    const t = Rl(e);
    if (!t) return [];
    const n = t.split(" "), s = [];
    for (const o of this.list) {
      const r = Rl(o.name);
      if (r === t) {
        s.push({ e: o, score: 0 });
        continue;
      }
      const a = r.split(" ");
      n.every((d) => a.some((c) => c.startsWith(d))) && s.push({ e: o, score: 1 + a.length - n.length });
    }
    return s.sort((o, r) => o.score - r.score || o.e.name.localeCompare(r.e.name)).map((o) => o.e);
  }
  /** The kit a job wants it in: an edit in Image Edit, a new picture in Image, else its first. */
  kitFor(e, t) {
    const n = t === "edit" ? ["imageEdit", "image"] : ["image", "imageEdit"];
    for (const s of n) {
      const o = e.kits.find((r) => r.id === s);
      if (o) return o;
    }
    return e.kits[0];
  }
  /** What `runs` runs of `n` results cost with this prompt state, in tokens (the price rules v1's Run button uses); null when it has none. */
  price(e, t, n, s = 1) {
    const o = Xi(e.model, t, n, this.isAdmin).price;
    return o == null ? null : o * s / 100;
  }
  /** Why a run of this prompt state couldn't go (a required field, a bad value); empty when it can. */
  problems(e, t, n) {
    return Xi(e.model, t, n, this.isAdmin).problems;
  }
  /** The results a run makes: n clamped to what the tool allows. */
  results(e, t) {
    const n = e.model.numResults;
    return Math.max(n.min, Math.min(n.max, Math.round(t) || n.def || 1));
  }
  /** A field by its label ("Quality"), any case. */
  field(e, t) {
    const n = t.trim().toLowerCase();
    return e.model.fields.find((s) => (s.label || "").trim().toLowerCase() === n) || null;
  }
  /** The size option nearest an image's shape, in the size tier the tool starts at. */
  sizeFor(e, t, n) {
    const s = e.model.fields.find((x) => x.kind === "size" && x.options && x.options.length);
    if (!s || !s.options || !t || !n) return null;
    const o = (x) => {
      const w = x;
      return w && w.width && w.height ? w.width * w.height : 0;
    }, r = (x) => {
      const w = x;
      return w && w.width && w.height ? w.width / w.height : 1;
    }, a = s.defaultValue != null ? s.defaultValue : s.options[0].value, l = s.options.find((x) => yn(x.value) === yn(a)), d = l ? (/^(\d+(?:\.\d+)?K)\b/i.exec(l.label) || [])[1] : void 0, c = o(a), h = d ? s.options.filter((x) => x.label.toUpperCase().startsWith(d.toUpperCase() + " ")) : [], f = s.options.filter((x) => c && Math.abs(o(x.value) - c) / c < 0.34), p = h.length ? h : f.length ? f : s.options, y = Math.log(t / n);
    let v = p[0];
    for (const x of p) Math.abs(Math.log(r(x.value)) - y) < Math.abs(Math.log(r(v.value)) - y) && (v = x);
    return { field: s, value: v.value, label: v.label };
  }
  /** An option of a select field by its value or its label, any case; null when it has no such option. */
  option(e, t) {
    const n = e.options || [], s = yn(t).toLowerCase(), o = n.find((r) => yn(r.value).toLowerCase() === s || r.label.toLowerCase() === s);
    return o ? { value: o.value, label: o.label } : null;
  }
}
function Uu(i) {
  return {
    get: (e) => i.store.get(e),
    childrenOf: (e) => i.childrenOf(e),
    framesIn: (e) => i.store.query(He(e)).filter((t) => {
      if (t.type !== "frame" || t.id === e.id) return !1;
      const n = t.x + t.w / 2, s = t.y + t.h / 2;
      return n > e.x && n < e.x + e.w && s > e.y && s < e.y + e.h;
    }),
    promptOf: (e) => i.promptOf(e),
    result: (e) => i.results.get(e),
    modelOf: (e) => i.modelFor(e).model,
    generating: (e) => !!i.generating[e]
  };
}
function lU(i) {
  const e = (t) => {
    const n = i.ui.selection.slice(), s = t();
    return i.ui.selection = n.filter((o) => !!i.store.get(o)), s;
  };
  return {
    element: (t) => i.store.get(t),
    contents: (t) => i.childrenOf(t).map((n) => i.store.get(n)).filter(Boolean).map((n) => He(n)),
    modelOf: (t, n) => {
      const s = i.catalog.value, o = s.kits.find((a) => a.id === t && a.models.some((l) => l.id === n)) || s.kits.find((a) => a.models.some((l) => l.id === n)), r = o ? o.models.find((a) => a.id === n) : null;
      return o && r ? { kit: o, model: r } : null;
    },
    imageFields: (t) => {
      const n = i.store.get(t);
      if (!n || n.type !== "tool") return [];
      const { model: s } = i.modelFor(n);
      return s ? s.fields.filter((o) => o.placement === "reference" && (o.kind === "image" || o.kind === "images")) : [];
    },
    assetOf: (t, n) => {
      const s = i.store.get(t);
      return s && s.type === "image" && s.asset || i.assetFor(n);
    },
    promptOf: (t) => i.promptOf(t),
    // a second "Night versions" in the frame is "Night versions 2", as the board names a copy
    addSession: (t, n, s, o) => i.addSession(t, n, i.uniqueSessionName(s), o, { quiet: !0 }),
    move: (t, n, s) => i.patch(t, { x: n, y: s }, "Move"),
    resizeFrame: (t, n) => i.patch(t, { x: n.x, y: n.y, w: n.w, h: n.h }, "Resize frame"),
    setPrompt: (t, n) => i.setPrompt(t, n),
    setRefInput: (t, n, s, o) => i.setRefInput(t, n, s, o),
    generate: (t) => i.generate(t),
    submitting: (t) => i.submitting(t),
    generating: (t) => !!i.generating[t],
    error: (t) => {
      const n = i.store.get(t);
      return n && n.type === "tool" && n.error || null;
    },
    results: (t) => i.results.list(t),
    place: (t, n) => e(() => i.placeImages([{
      url: t.url,
      w: n.w,
      h: n.h,
      x: n.x,
      y: n.y,
      label: t.label || "result",
      resultId: t.id,
      sessionId: t.sessionId,
      video: t.video,
      dur: t.dur,
      videoSrc: t.videoSrc,
      previewSrc: t.previewSrc,
      asset: t.asset,
      download: t.download,
      kind: t.kind
    }], { x: n.x + n.w / 2, y: n.y + n.h / 2 })[0] || null),
    wait: (t) => new Promise((n) => window.setTimeout(n, t))
  };
}
function dd(i) {
  const e = i.slice().sort((n, s) => n.y - s.y || n.x - s.x), t = [];
  for (; e.length; ) {
    const n = e[0], s = n.y + n.h / 2, o = e.filter((r) => r.y <= s && r.y + r.h >= s).sort((r, a) => r.x - a.x);
    for (const r of o) e.splice(e.indexOf(r), 1);
    t.push(...o);
  }
  return t;
}
function dU(i) {
  return !!i && i.fields.some((e) => e.placement === "reference" && (e.kind === "image" || e.kind === "images"));
}
const Qm = (i) => ({ x: i.x + i.w / 2, y: i.y + i.h / 2 }), eg = (i, e, t = 0) => i.x > e.x - t && i.x < e.x + e.w + t && i.y > e.y - t && i.y < e.y + e.h + t, mo = (i) => i.w * i.h, cU = 4, uU = 32, hU = /* @__PURE__ */ new Set(["select", "size", "boolean", "slider", "text", "seed"]);
function O1(i, e) {
  const t = i.replace(/\s+/g, " ").trim();
  return t.length > e ? t.slice(0, e - 1) + "…" : t;
}
function pU(i, e) {
  if (e == null || e === "") return null;
  if (i.options && i.options.length) {
    const t = i.options.find((n) => yn(n.value) === yn(e));
    return t ? t.label : null;
  }
  return i.kind === "boolean" ? e ? "on" : "off" : typeof e == "number" ? String(e) : typeof e == "string" ? O1(e, 80) : null;
}
function fU(i, e) {
  if (!i) return [];
  const t = [], n = e.inputs || {};
  for (const s of i.fields) {
    const o = Object.prototype.hasOwnProperty.call(n, s.key) ? n[s.key] : void 0;
    if (s.kind === "negPrompt") {
      typeof o == "string" && o.trim() && t.push({ label: s.label || "Negative prompt", value: O1(o, 200) });
      continue;
    }
    if (!hU.has(s.kind) || s.placement === "reference" || s.placement === "prompt") continue;
    const r = o !== void 0 && yn(o) !== yn(s.defaultValue);
    if (s.placement !== "chip" && !r) continue;
    const a = pU(s, o !== void 0 ? o : s.defaultValue);
    a != null && t.push({ label: s.label, value: a });
  }
  return t;
}
function mU(i, e) {
  const t = [];
  e.ref && t.push(e.ref);
  for (const n of i && i.fields || []) {
    if (n.placement !== "reference" || n.kind !== "image" && n.kind !== "images") continue;
    const s = e.inputs ? e.inputs[n.key] : void 0;
    if (typeof s == "string" && s) t.push(s);
    else if (Array.isArray(s))
      for (const o of s) typeof o == "string" && o && t.push(o);
  }
  return Array.from(new Set(t));
}
function gU(i, e) {
  const t = e.w / 2, n = e.h / 2;
  if (t <= 0 || n <= 0) return !1;
  const s = (i.x - (e.x + t)) / t, o = (i.y - (e.y + n)) / n;
  return s * s + o * o <= 1;
}
function Gu(i, e, t) {
  const n = [], s = [], o = [], r = [], a = [];
  let l = 0;
  for (const k of i.childrenOf(e)) {
    if (k === t) continue;
    const P = i.get(k);
    P && (P.type === "image" ? n.push(P) : P.type === "tool" ? s.push(P) : P.type === "note" && !P.link ? o.push(P) : P.type === "shape" ? r.push(P) : P.type === "chat" ? a.push(P.name || "Chat") : l++);
  }
  const d = He(e), c = i.framesIn(e).filter((k) => k.id !== e.id && mo(He(k)) < mo(d)).sort((k, P) => mo(He(k)) - mo(He(P))), h = dd(c.map((k) => ({ ...He(k), g: k }))).map(({ g: k }) => ({ id: k.id, title: (k.title || "").trim() || "Untitled frame", members: [] })), f = (k) => {
    const P = Qm(k), A = c.find((R) => eg(P, He(R)));
    return A && h.find((R) => R.id === A.id) || null;
  }, p = (k, P) => {
    const A = f(P);
    if (A)
      return A.members.push(k), A.title;
  }, y = /* @__PURE__ */ new Map();
  for (const k of n) {
    y.set(k.src, k.id);
    for (const P of Object.values(k.tiers || {})) y.has(P) || y.set(P, k.id);
  }
  const v = dd(n).map((k) => {
    const P = k.resultId ? i.result(k.resultId) : void 0, A = !P && k.sessionId ? i.get(k.sessionId) : void 0, R = { id: k.id, url: k.src, w: k.w, h: k.h, hasAsset: !!k.asset };
    k.label && k.label !== "placed_image" && (R.label = k.label), k.video ? R.video = !0 : (k.kind === "3d" || k.kind === "layers") && (R.kind = k.kind), k.fav && (R.fav = !0), k.sessionId && (R.sessionId = k.sessionId), P ? (P.prompt && (R.prompt = P.prompt), P.model && (R.model = P.model), P.modelId && (R.modelId = P.modelId)) : A && A.type === "tool" && (R.model = A.model);
    const D = p(k.id, He(k));
    return D && (R.group = D), R;
  }), x = dd(s.map((k) => ({ ...k, ...He(k) }))).map((k) => {
    const P = i.modelOf(k), A = i.promptOf(k.id), R = [];
    let D = 0;
    for (const te of mU(P, A)) {
      const ee = y.get(te);
      ee ? R.push(ee) : D++;
    }
    const O = {
      id: k.id,
      name: k.name,
      kind: k.kind,
      kitId: k.kitId,
      model: P && P.name || k.model,
      nodeDefId: P && P.id || k.nodeDefId,
      prompt: (A.prompt || "").trim(),
      n: A.n || (P ? P.numResults.def : 1) || 1,
      results: k.count || 0,
      takesImages: dU(P),
      generating: i.generating(k.id),
      settings: fU(P, A),
      inputs: R,
      otherInputs: D,
      thumbs: (k.thumbs || []).filter(Boolean).slice(0, cU)
    };
    k.error && (O.error = O1(String(k.error), 200));
    const F = p(k.id, He(k));
    return F && (O.group = F), O;
  }), w = dd(o).filter((k) => !!(k.text || "").trim()).map((k) => {
    const P = { id: k.id, text: (k.text || "").trim() };
    k.author && (P.author = k.author), k.tint && k.tint !== "glass" && (P.tint = k.tint);
    const A = p(k.id, He(k));
    return A && (P.group = A), P;
  }), S = [
    ...n.map((k) => ({ id: k.id, rect: He(k) })),
    ...s.map((k) => ({ id: k.id, rect: He(k) })),
    ...o.filter((k) => !!(k.text || "").trim()).map((k) => ({ id: k.id, rect: He(k) })),
    ...c.map((k) => ({ id: k.id, rect: He(k) }))
  ], M = (k) => {
    let P = null;
    for (const A of S)
      eg(k, A.rect, uU) && (!P || mo(A.rect) < mo(P.rect)) && (P = A);
    return P ? P.id : null;
  }, _ = [], T = [];
  for (const k of dd(r)) {
    if (k.shape === "line" || k.shape === "arrow") {
      const R = am(k), D = M({ x: k.x + R.x1, y: k.y + R.y1 }), O = M({ x: k.x + R.x2, y: k.y + R.y2 });
      !D && !O ? l++ : _.push({ id: k.id, kind: k.shape, from: D, to: O });
      continue;
    }
    const P = He(k), A = S.filter((R) => mo(R.rect) < mo(P) && (k.shape === "ellipse" ? gU(Qm(R.rect), P) : eg(Qm(R.rect), P))).map((R) => R.id);
    A.length ? T.push({ id: k.id, kind: k.shape === "ellipse" ? "ellipse" : "rect", around: A }) : l++;
  }
  return {
    frameId: e.id,
    title: e.title || "Untitled frame",
    rect: d,
    images: v,
    sessions: x,
    notes: w,
    groups: h,
    links: _,
    marks: T,
    chats: a,
    ignored: l
  };
}
function tg(i, e, t = e + "s") {
  return i + " " + (i === 1 ? e : t);
}
function h8(i) {
  return i.images.length + i.sessions.length + i.notes.length;
}
function p8(i) {
  const e = [];
  return i.images.length && e.push(tg(i.images.length, "image")), i.sessions.length && e.push(tg(i.sessions.length, "session")), i.notes.length && e.push(tg(i.notes.length, "note")), e.length ? e.join(", ") : "Empty";
}
function bU(i) {
  return i ? i.images.length ? "Ask about " + (i.images.length === 1 ? "this image" : "these " + i.images.length + " images") + "…" : i.sessions.length ? "Ask about " + (i.sessions.length === 1 ? "this session" : "these " + i.sessions.length + " sessions") + "…" : "What should we build here?" : "Move this chat into a frame to give it something to work with";
}
function vU(i, e) {
  const t = He(e), n = t.x + t.w / 2, s = t.y + t.h / 2;
  let o = null;
  for (const r of i)
    n > r.x && n < r.x + r.w && s > r.y && s < r.y + r.h && (!o || r.w * r.h < o.w * o.h || r.w * r.h === o.w * o.h && r.z > o.z) && (o = r);
  return o;
}
const yU = "draft", xU = "Draft guidance: placeholder recommendations that RunDiffusion will tune", it = {
  flare: { id: "50XKlkMz7r9kmipyspRQ", name: "ChatGPT Image 2.5 Flare" },
  sunburst: { id: "s9ShIto8LPgdOSImFC39", name: "ChatGPT Image 2.5 Sunburst" },
  nb2: { id: "6BJyvazKHGTilS1yWk76", name: "Nano Banana 2" },
  nbPro: { id: "eILT27MJkTwxnVSPQP2x", name: "Nano Banana Pro" },
  nb2Lite: { id: "VpkLvmqERLkoU2vBNTJ7" },
  nb1: { id: "umNAyCPJkWXmSrTUevOM" },
  flux3: { id: "JcDKjRIyFolGJVEOIgya", name: "Flux 3 Image" },
  flux2Max: { id: "vMzpgBA14pAFuBgU8yby", name: "Flux 2 Max" },
  kontextPro: { id: "bKkjGeP6wjLsl1314ybn", name: "Flux Kontext Pro" },
  seedream5: { id: "B9nbLi2HgM7XHeaBoOJD", name: "Seedream V5 Pro" },
  seedream45: { id: "sI3TYrxuB8l4st8KXHSH" },
  rdPhoto: { id: "4Qsc76pSm5HKYRMnClef", name: "RunDiffusion Photo FLUX" },
  zTurbo: { id: "cnedcdG4HabkoZGBu1Fs", name: "Z Image Turbo" },
  juggLightning: { id: "2t5JQGvAIiSr669KYnVq", name: "Juggernaut Lightning Flux" },
  klein4b: { id: "UNuq3Ia9Wlos2DWSFrlv", name: "Flux 2 Klein 4B" },
  ideoEdit: { id: "uW9DvVweUX4OoA3n8Brt" },
  ideoReframe: { id: "F4QfdOqv9ehwMR4Z0qNW" },
  layers: { id: "px6klFXH0N11egFiDoVB", name: "Image-to-Layers" },
  wanPro: { id: "seBwSSKFPpNZMYycG7i5" }
}, wU = {
  status: yU,
  jobs: {
    compare: {
      id: "compare",
      label: "Comparing one prompt across tools",
      intro: "For a fair comparison, use strong all-rounders that take a prompt on its own and finish in about the same time.",
      suggest: 3,
      picks: [
        { ...it.flare, why: "follows long, detailed prompts closely and lights scenes naturally" },
        { ...it.nb2, why: "photoreal materials and geometry, a strong all-rounder for architecture" },
        { ...it.flux3, why: "crisp detail up to 4K, and the cleanest text of the group" },
        { ...it.seedream5, why: "cinematic light and colour, up to six results a run" },
        { ...it.nbPro, why: "the highest fidelity here, slower and the most expensive" },
        { ...it.flux2Max, why: "sharp, high-resolution renders with tight prompt control" }
      ]
    },
    photoreal: {
      id: "photoreal",
      label: "Photoreal renders",
      intro: "For photoreal architecture and interiors:",
      picks: [
        { ...it.nbPro, why: "the most convincing materials and light, for finals" },
        { ...it.nb2, why: "nearly as real for half the price, and quick to iterate" },
        { ...it.rdPhoto, why: "RunDiffusion's own photographic model, for natural daylight" },
        { ...it.seedream5, why: "cinematic mood and colour grading" }
      ]
    },
    text: {
      id: "text",
      label: "Text and signage",
      intro: "For legible words in the picture (signage, posters, labels):",
      picks: [
        { ...it.flux3, why: "the most reliable lettering here, up to 4K" },
        { ...it.sunburst, why: "precise layout and tight revisions, with transparent backgrounds" },
        { ...it.nbPro, why: "good short signage inside a photoreal scene" }
      ]
    },
    edit: {
      id: "edit",
      label: "Editing images you have",
      intro: "For changing an image while keeping the building and camera:",
      picks: [
        { ...it.flare, why: "relights and restyles naturally while holding the layout" },
        { ...it.nb2, why: "keeps geometry and materials steady through big changes" },
        { ...it.kontextPro, why: "fast, faithful single-image edits" },
        { ...it.seedream5, why: "mood and colour changes with up to ten reference images" }
      ]
    },
    drafts: {
      id: "drafts",
      label: "Fast, cheap drafts",
      intro: "For quick drafts while you find the idea:",
      picks: [
        { ...it.zTurbo, why: "about five seconds and 12 tokens a picture" },
        { ...it.juggLightning, why: "about 3 tokens a picture, good for volume" },
        { ...it.klein4b, why: "cheap, and it takes reference images" }
      ]
    },
    design: {
      id: "design",
      label: "Design and vector-style graphics",
      intro: "For logos, icons and flat graphics (no true vector tool is on this board yet):",
      picks: [
        { ...it.sunburst, why: "transparent backgrounds and tight control of layout" },
        { ...it.flux3, why: "clean type and graphic layouts" },
        { ...it.layers, why: "splits a finished design into editable layers (it needs the image)" }
      ]
    }
  },
  families: [
    {
      name: "ChatGPT Image 2.5",
      match: /\b(chat\s*gpt|gpt)[\s-]*image(?:[\s-]*2\.5)?\b|\bchatgpt\b/i,
      members: [it.flare.id, it.sunburst.id],
      pick: {
        edit: { id: it.flare.id, why: "it relights scenes naturally and keeps the layout, which suits a time-of-day change" },
        text: { id: it.sunburst.id, why: "it has tighter revision control and the most detail, which lettering needs" },
        design: { id: it.sunburst.id, why: "it has tighter revision control and supports transparent backgrounds" },
        default: { id: it.flare.id, why: "it's the faster of the two and the better all-rounder" }
      }
    },
    {
      name: "Nano Banana",
      match: /\bnano[\s-]*banana\b/i,
      members: [it.nb2.id, it.nbPro.id, it.nb1.id, it.nb2Lite.id],
      pick: {
        photoreal: { id: it.nbPro.id, why: "it's the highest-fidelity Nano Banana" },
        default: { id: it.nb2.id, why: "it's the best balance of quality and price of the Nano Banana tools" }
      }
    },
    {
      name: "Flux 3",
      match: /\bflux[\s-]*3\b/i,
      members: [it.flux3.id],
      pick: { default: { id: it.flux3.id, why: "it's the Flux 3 tool on this board" } }
    },
    {
      name: "Seedream",
      match: /\bseedream\b/i,
      members: [it.seedream5.id, it.seedream45.id],
      pick: { default: { id: it.seedream5.id, why: "it's the newest Seedream and takes reference images" } }
    },
    {
      name: "Flux Kontext",
      match: /\b(flux[\s-]*)?kontext\b/i,
      members: [it.kontextPro.id],
      pick: { default: { id: it.kontextPro.id, why: "Pro is the balanced Kontext" } }
    },
    {
      name: "Wan",
      match: /\bwan(?:[\s-]*2\.7)?\b/i,
      members: [it.wanPro.id],
      pick: { default: { id: it.wanPro.id, why: "Pro is the sharper Wan image tool" } }
    },
    {
      name: "Ideogram",
      match: /\bideogram\b/i,
      members: [it.ideoEdit.id, it.ideoReframe.id],
      pick: {
        edit: { id: it.ideoEdit.id, why: "it edits an image (with a mask), and it's the Ideogram that does" }
      },
      note: "Ideogram v4, the Ideogram that makes a picture from a prompt alone, isn't on this board's tool list. The Ideogram tools here (v3 Edit and V3 Reframe) need an image to start from."
    }
  ],
  tools: [
    {
      ids: [it.flare.id, it.sunburst.id],
      name: "ChatGPT Image 2.5",
      tips: [
        'Say what changes first, then what must stay: "same building, same camera angle, same materials".',
        "Name the light: the time of day, where it comes from and its colour.",
        "Quality sets the price: Medium for drafts, High for finals, Extra High only for print.",
        "Pick the size that matches your source image's shape, so nothing gets cropped."
      ],
      settings: [{ field: "Quality", value: "high", say: "High quality" }],
      sizeFromInput: !0,
      tuned: "{prompt}. Natural, physically accurate light and a precise, well-balanced composition."
    },
    {
      ids: [it.nb2.id, it.nbPro.id, it.nb1.id, it.nb2Lite.id],
      name: "Nano Banana",
      tips: [
        "Write plain, complete sentences: it follows them closely.",
        "Name materials and finishes (board-formed concrete, oiled oak, bronze mullions).",
        "For an edit, attach the image and describe only what should change."
      ],
      tuned: "A photograph of {prompt}. Real materials and finishes, accurate geometry, natural light."
    },
    {
      ids: [it.flux3.id],
      name: "Flux 3 Image",
      tips: [
        "Put exact words in double quotes and name the type style.",
        "Choose the size first: it sets the price.",
        'Concrete nouns beat adjectives: "cedar slats" says more than "warm and natural".'
      ],
      tuned: "{prompt}, highly detailed, sharp focus, professional architectural photography"
    },
    {
      ids: [it.seedream5.id, it.seedream45.id],
      name: "Seedream",
      tips: [
        "Describe mood and light like a cinematographer: golden hour, low sun, long shadows.",
        "Reference images steer style and palette: add one or two."
      ],
      tuned: "{prompt}, cinematic lighting, rich colour, atmospheric depth"
    },
    {
      ids: [it.ideoEdit.id, it.ideoReframe.id],
      name: "Ideogram",
      tips: [
        "Put the exact sign text in double quotes, and keep it short: one to four words read best.",
        "Name the lettering: bold geometric sans serif, brushed steel channel letters, hand-painted serif.",
        "Say where the sign is and how it's lit: on the canopy fascia, backlit, facing the street.",
        "Ask for clean, legible typography, and leave other words out of the prompt so they don't end up on the sign.",
        "Choose a Design or Typography style when the tool offers one."
      ]
    },
    {
      ids: [it.kontextPro.id],
      name: "Flux Kontext Pro",
      tips: [
        'Describe the change as an instruction: "make it night", "replace the cladding with zinc".',
        "One change per run edits most faithfully."
      ]
    }
  ],
  edits: [
    { match: /night|nighttime|night-time|evening|after dark/i, name: "Night versions", change: "a nighttime scene", light: "Deep blue night sky, warm light glowing from the interior windows, soft uplighting on the facade, realistic reflections and gentle street lighting." },
    { match: /dusk|twilight|blue hour/i, name: "Dusk versions", change: "dusk", light: "Blue-hour sky fading to warm orange at the horizon, interior lights coming on, soft even light on the facade." },
    { match: /sunset|golden hour/i, name: "Golden hour versions", change: "golden hour", light: "Low warm sun, long soft shadows, glowing highlights on the facade, a clear gradient sky." },
    { match: /\bfog|\bmist/i, name: "Fog versions", change: "a foggy morning", light: "Dense soft fog fading the background, muted colours, diffuse light." },
    { match: /dawn|sunrise|morning/i, name: "Morning versions", change: "early morning", light: "Cool soft dawn light, a pale sky with warm first light on the upper floors, light mist at street level." },
    { match: /snow|winter/i, name: "Winter versions", change: "a snowy winter scene", light: "Fresh snow on the ground and ledges, overcast soft light, cool tones with warm windows." },
    { match: /\brain|\bwet\b|storm/i, name: "Rainy day versions", change: "a rainy day", light: "Wet reflective pavement, overcast sky, soft diffuse light, rain streaks in the air." },
    { match: /autumn|\bfall\b/i, name: "Autumn versions", change: "autumn", light: "Trees in full autumn colour, low warm sun, fallen leaves on the ground." }
  ]
};
function dm(i, e) {
  return i.tools.find((t) => t.ids.includes(e)) || null;
}
function f8(i, e, t) {
  const n = dm(i, e), s = t.trim().replace(/[.\s]+$/, "");
  return n && n.tuned ? n.tuned.replace("{prompt}", s) : s;
}
function m8(i, e, t, n, s) {
  const o = { prompt: e, n: t, inputs: { ...n } }, r = i.imageField;
  if (r && s.length) {
    const a = i.model.fields.find((l) => l.placement === "reference") === r;
    s.length > 1 && r.kind === "images" ? o.inputs[r.key] = s.slice() : a ? o.ref = s[0] : o.inputs[r.key] = s[0];
  }
  return o;
}
function kU(i, e, t, n) {
  const s = {}, o = [];
  for (const [r, a] of Object.entries(t.settings || {})) {
    if (r.toLowerCase() === "size") {
      if (a !== "match" || !n) continue;
      const d = i.sizeFor(e, n.w, n.h);
      if (!d) continue;
      s[d.field.key] = d.value, o.push(d.label.replace(/\s*-\s*\d+x\d+$/, ""));
      continue;
    }
    const l = i.field(e, r);
    if (!l) return e.name + " has no " + r + " setting.";
    if (l.options && l.options.length) {
      const d = i.option(l, a);
      if (!d) return r + " can't be " + String(a) + " in " + e.name + ".";
      s[l.key] = d.value, o.push(d.label + " " + r.toLowerCase());
    } else
      s[l.key] = a, o.push(r + " " + String(a));
  }
  return { inputs: s, said: o };
}
function _U(i) {
  let e = 0;
  for (const t of i) e = Math.max(e, t.secs + 4 * Math.max(0, t.runs - 1));
  return Math.round(e);
}
function Iv(i, e, t) {
  if (!i.sessions.length) return { ok: !1, error: "The plan has nothing to run." };
  const n = new Map(e.images.map((a) => [a.id, a])), s = [], o = [];
  let r = 0;
  for (const a of i.sessions) {
    const l = t.get(a.modelId);
    if (!l) return { ok: !1, error: "That tool isn't on this board's tool list, so the plan can't use it." };
    let d;
    if (a.toolId) {
      const w = e.sessions.find((S) => S.id === a.toolId);
      if (!w) return { ok: !1, error: "A session the plan uses is no longer in this frame." };
      d = w.kitId;
    } else
      d = t.kitFor(l, a.job || "generate").id;
    const c = (a.runs && a.runs.length ? a.runs : [{ imageIds: [] }]).map((w) => {
      const S = [];
      for (const M of w.imageIds || []) {
        const _ = n.get(M);
        _ && S.push(_);
      }
      return S;
    });
    if (c.some((w, S) => w.length !== (a.runs && a.runs[S] && a.runs[S].imageIds || []).length))
      return { ok: !1, error: "An image the plan uses is no longer in this frame." };
    const h = c.some((w) => w.length);
    if (h && !l.imageField) return { ok: !1, error: l.name + " can't take an image as input." };
    if (c.some((w) => w.length > l.maxImages)) return { ok: !1, error: l.name + " takes up to " + l.maxImages + (l.maxImages === 1 ? " image" : " images") + " a run." };
    if (!h && l.needsImage) return { ok: !1, error: l.name + " needs an image to start from." };
    const f = t.results(l, a.n || 1), p = c.find((w) => w.length) ? c.find((w) => w.length)[0] : null, y = kU(t, l, a, p);
    if (typeof y == "string") return { ok: !1, error: y };
    let v = 0, x = !0;
    for (const w of c) {
      const S = m8(l, a.prompt, f, y.inputs, w.map((T) => T.url)), M = t.problems(l, S, f);
      if (M.length) return { ok: !1, error: M[0] };
      const _ = t.price(l, S, f);
      _ == null ? x = !1 : v += _;
    }
    if (!x) return { ok: !1, error: l.name + " has no price the board can show, so the plan can't include it." };
    v = Math.round(v * 10) / 10, r += v, o.push({ secs: l.secs, runs: c.length }), s.push({
      key: "s" + (s.length + 1),
      ...a.toolId ? { toolId: a.toolId } : {},
      name: a.name,
      kitId: d,
      modelId: l.id,
      model: l.name,
      prompt: a.prompt,
      n: f,
      runs: c.map((w) => w.length ? { images: w.map((S) => ({ id: S.id, url: S.url })) } : {}),
      ...Object.keys(y.inputs).length ? { inputs: y.inputs } : {},
      ...y.said.length ? { settings: y.said.join(" · ") } : {},
      tokens: v,
      ...a.why ? { why: a.why } : {}
    });
  }
  return {
    ok: !0,
    plan: {
      id: St(),
      title: i.title,
      ...i.summary ? { summary: i.summary } : {},
      status: "proposed",
      tokens: Math.round(r * 10) / 10,
      secs: _U(o),
      sessions: s,
      ...i.place ? { place: !0 } : {}
    }
  };
}
function SU(i) {
  let e = 0, t = 0, n = 0;
  for (const s of i.sessions)
    e += s.runs.length, t += s.runs.length * s.n, s.toolId || n++;
  return { runs: e, results: t, sessions: i.sessions.length, added: n };
}
function hc(i) {
  return (i >= 100 ? Math.round(i) : Math.round(i * 10) / 10).toLocaleString("en-US");
}
function g8(i) {
  return hc(i) + (i === 1 ? " token" : " tokens");
}
function Ow(i) {
  return i < 90 ? Math.max(1, Math.round(i)) + "s" : Math.round(i / 60) + " min";
}
var MU = Object.defineProperty, TU = (i, e, t) => e in i ? MU(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, ng = (i, e, t) => TU(i, typeof e != "symbol" ? e + "" : e, t);
const b8 = "/__smart-frames", v8 = { url: b8 }, CU = { "Content-Type": "application/json", "X-Smart-Frames": "1" }, ig = 16, IU = 384, AU = 1, PU = 4, y8 = (i) => i.url === b8, sg = (i) => y8(i) ? "The assistant runs in the web app's dev server, which didn't answer here." : "The chat couldn't be reached. Try again in a little while.";
async function x8(i, e, t, n) {
  const s = { ...CU };
  if (i.token) {
    const r = await i.token();
    r && (s.Authorization = "Bearer " + r);
  }
  const o = i.url + e + (i.teamId ? "?team=" + encodeURIComponent(i.teamId) : "");
  return n(o, { ...t, headers: s });
}
async function EU(i = v8, e = fetch) {
  try {
    const t = await x8(i, "/status", {}, e);
    let n = null;
    try {
      n = await t.json();
    } catch {
      n = null;
    }
    if (!t.ok || !n) return { ready: !1, reason: n && n.reason || sg(i) };
    const s = Array.isArray(n.models) ? n.models.filter((o) => o && o.id && o.label) : [];
    return n.ready && s.length ? { ready: !0, models: s } : { ready: !1, reason: n.reason || sg(i) };
  } catch {
    return { ready: !1, reason: sg(i) };
  }
}
function og(i, e, t, n = []) {
  return i.price(e, m8(e, "x", 1, t, n), 1);
}
const Lw = /* @__PURE__ */ new WeakMap();
function RU(i, e) {
  let t = Lw.get(i.catalog);
  t || (t = /* @__PURE__ */ new Map(), Lw.set(i.catalog, t));
  const n = t.get(e.id);
  if (n) return n;
  const s = [], o = og(i, e, {});
  if (o != null) {
    for (const r of e.model.fields) {
      if (r.kind !== "select" && r.kind !== "size" || !r.options || r.options.length < 2 || r.options.length > 10) continue;
      const a = r.options.map((l) => ({ label: l.label, p: og(i, e, { [r.key]: l.value }) }));
      a.some((l) => l.p == null) || a.every((l) => l.p === a[0].p) || s.push(r.label + ": " + a.map((l) => l.label + " " + Math.round(l.p * 10) / 10).join(", ") + " tokens a result");
    }
    if (e.imageField) {
      const r = og(i, e, {}, ["https://board.invalid/a.png"]);
      r != null && r !== o && s.push("each input image adds " + Math.round((r - o) * 10) / 10 + " tokens a result");
    }
  }
  return t.set(e.id, s), s;
}
function zU(i) {
  const e = [];
  for (const t of i.entries()) {
    const n = i.price(t, { prompt: "x", n: 1 }, 1), s = t.model.fields.find((r) => r.placement === "reference" && r.kind === "video"), o = RU(i, t);
    e.push({
      id: t.id,
      name: t.name,
      ...t.desc ? { desc: t.desc.slice(0, 240) } : {},
      kits: t.kits.map((r) => r.id),
      ...t.model.kitTags && t.model.kitTags.length ? { tags: t.model.kitTags.slice(0, 6) } : {},
      ...t.model.labels && t.model.labels.length ? { labels: t.model.labels.map((r) => r.label).slice(0, 6) } : {},
      images: t.imageField ? t.needsImage ? "required" : "optional" : "none",
      maxImages: t.maxImages,
      ...s ? { video: s.required ? "required" : "optional" } : {},
      maxResults: t.model.numResults.max,
      perResult: n == null ? null : Math.round(n * 10) / 10,
      priceVaries: o.length > 0,
      ...o.length ? { priceNotes: o } : {},
      secs: t.secs,
      settings: t.model.fields.filter((r) => (r.kind === "select" || r.kind === "size") && r.options && r.options.length).map((r) => {
        const a = r.options.find((l) => yn(l.value) === yn(r.defaultValue));
        return {
          label: r.label,
          kind: r.kind,
          options: r.options.map((l) => l.label),
          values: r.options.map((l) => yn(l.value)),
          ...a ? { default: a.label } : {}
        };
      })
    });
  }
  return { kits: i.catalog.kits.map((t) => ({ id: t.id, name: t.name, ...t.desc ? { desc: t.desc } : {} })), tools: e };
}
function $U(i) {
  return {
    status: i.status,
    jobs: i.jobs,
    families: i.families.map((e) => ({ ...e, match: e.match.source })),
    tools: i.tools,
    edits: i.edits.map((e) => ({ ...e, match: e.match.source }))
  };
}
function w8(i) {
  return {
    title: i.title,
    status: i.status,
    ...i.results != null ? { results: i.results } : {},
    ...i.error ? { error: i.error } : {},
    sessions: i.sessions.map((e) => ({
      name: e.name,
      model: e.model,
      modelId: e.modelId,
      ...e.toolId || e.addedId ? { toolId: e.toolId || e.addedId } : {},
      prompt: e.prompt,
      runs: e.runs.length,
      n: e.n,
      images: e.runs.reduce((t, n) => t + (n.images ? n.images.length : 0), 0)
    }))
  };
}
function DU(i) {
  return i.map((e) => ({
    role: e.role,
    author: e.role === "agent" ? "Assistant" : e.author,
    text: e.text || "",
    ...e.plan ? { plan: w8(e.plan) } : {},
    ...e.picks && e.picks.length ? { picks: e.picks.map((t) => t.name) } : {},
    ...e.ideas && e.ideas.length ? { ideas: e.ideas.map((t) => t.title) } : {}
  }));
}
const Sa = /* @__PURE__ */ new Map();
function Bw(i) {
  return new Promise((e) => {
    if (typeof Image == "undefined" || typeof document == "undefined") {
      e(null);
      return;
    }
    const t = new Image();
    t.crossOrigin = "anonymous", t.decoding = "async";
    const n = window.setTimeout(() => e(null), 8e3);
    t.onload = () => {
      window.clearTimeout(n);
      try {
        const s = t.naturalWidth, o = t.naturalHeight;
        if (!s || !o) return e(null);
        const r = Math.min(1, IU / Math.max(s, o)), a = document.createElement("canvas");
        a.width = Math.max(1, Math.round(s * r)), a.height = Math.max(1, Math.round(o * r));
        const l = a.getContext("2d");
        if (!l) return e(null);
        l.drawImage(t, 0, 0, a.width, a.height), e({ data: a.toDataURL("image/jpeg", 0.85), w: s, h: o });
      } catch {
        e(null);
      }
    }, t.onerror = () => {
      window.clearTimeout(n), e(null);
    }, t.src = i;
  });
}
function OU(i) {
  const e = Sa.get(i);
  if (e) return e;
  const t = $1(i), n = (t ? Bw(t) : Promise.resolve(null)).then((s) => s || Bw(i)).then((s) => (s || Sa.delete(i), s));
  return Sa.set(i, n), Sa.size > 96 && Sa.delete(Sa.keys().next().value), n;
}
async function LU(i) {
  try {
    const e = await crypto.subtle.digest("SHA-256", new TextEncoder().encode("smart-frames:" + i));
    return Array.from(new Uint8Array(e)).slice(0, 16).map((t) => t.toString(16).padStart(2, "0")).join("");
  } catch {
    return;
  }
}
function BU(i, e = /* @__PURE__ */ new Set()) {
  const t = i.sessions.map((a) => Math.min(a.thumbs.length, a.id && e.has(a.id) ? PU : AU)), n = t.reduce((a, l) => a + l, 0), s = Math.min(i.images.length, n ? ig - Math.min(n, 4) : ig);
  let o = ig - s;
  const r = t.map((a) => {
    const l = Math.max(0, Math.min(a, o));
    return o -= l, l;
  });
  return { images: s, sessions: r };
}
async function FU(i, e, t = OU) {
  const n = i.context, s = new Set(i.input.kind === "plan-ended" ? i.input.plan.sessions.map((l) => l.toolId || l.addedId || "").filter(Boolean) : []), o = BU(n, s), r = await Promise.all(n.images.map((l, d) => d < o.images ? t(l.url) : Promise.resolve(null))), a = await Promise.all(n.sessions.map((l, d) => Promise.all(l.thumbs.slice(0, o.sessions[d]).map((c) => t(c)))));
  return {
    v: 2,
    model: e.model,
    ...e.boardId ? { board: { id: e.boardId } } : {},
    ...i.chatId ? { chat: { id: i.chatId } } : {},
    ...e.user ? { user: e.user } : {},
    input: i.input.kind === "message" ? { kind: "message", text: i.input.text, author: i.input.author } : { kind: "plan-ended", plan: w8(i.input.plan) },
    frame: {
      title: n.title,
      images: n.images.map((l, d) => {
        const c = $1(l.url), h = r[d];
        return {
          id: l.id,
          url: l.url,
          w: l.w,
          h: l.h,
          ...c ? { thumb: c } : {},
          ...h ? { thumbData: h.data, px: { w: h.w, h: h.h } } : {},
          ...l.label ? { label: l.label } : {},
          ...l.prompt ? { prompt: l.prompt } : {},
          ...l.model ? { model: l.model } : {},
          ...l.sessionId ? { session: l.sessionId } : {},
          ...l.video ? { video: !0 } : {},
          ...l.kind ? { kind: l.kind } : {},
          ...l.fav ? { fav: !0 } : {},
          ...l.group ? { group: l.group } : {}
        };
      }),
      sessions: n.sessions.map((l, d) => ({
        id: l.id,
        name: l.name,
        kit: l.kind,
        kitId: l.kitId,
        model: l.model,
        ...l.nodeDefId ? { modelId: l.nodeDefId } : {},
        prompt: l.prompt,
        n: l.n,
        results: l.results,
        takesImages: l.takesImages,
        generating: l.generating,
        settings: l.settings,
        inputs: l.inputs,
        otherInputs: l.otherInputs,
        ...l.error ? { error: l.error } : {},
        ...l.group ? { group: l.group } : {},
        ...o.sessions[d] ? {
          latest: l.thumbs.slice(0, o.sessions[d]).map((c, h) => {
            const f = a[d][h];
            return { url: c, ...f ? { thumbData: f.data } : {} };
          })
        } : {}
      })),
      notes: n.notes.map((l) => ({ id: l.id, text: l.text, ...l.author ? { author: l.author } : {}, ...l.tint ? { tint: l.tint } : {}, ...l.group ? { group: l.group } : {} })),
      groups: n.groups,
      links: n.links.map((l) => ({ kind: l.kind, from: l.from, to: l.to })),
      marks: n.marks.map((l) => ({ kind: l.kind, around: l.around })),
      chats: n.chats,
      ignored: n.ignored
    },
    history: DU(i.history),
    ...i.dropped ? { dropped: i.dropped } : {},
    catalog: zU(i.catalog),
    guidance: $U(i.guidance)
  };
}
async function* NU(i, e) {
  const t = i.getReader(), n = new TextDecoder();
  let s = "";
  try {
    for (; !(e && e.aborted); ) {
      const { done: o, value: r } = await t.read();
      s += n.decode(r || new Uint8Array(), { stream: !o });
      const a = s.split(/\r?\n\r?\n/);
      s = o ? "" : a.pop() || "";
      for (const l of a) {
        const d = l.split(/\r?\n/).filter((c) => c.startsWith("data:")).map((c) => c.slice(5).trimStart()).join(`
`);
        if (d)
          try {
            yield JSON.parse(d);
          } catch {
          }
      }
      if (o) break;
    }
  } finally {
    e && e.aborted ? t.cancel().catch(() => {
    }) : t.releaseLock();
  }
}
class UU {
  constructor(e) {
    ng(this, "opts", e), ng(this, "id"), ng(this, "label"), this.id = "model:" + e.model.id, this.label = e.model.label;
  }
  async *turn(e, t) {
    const n = this.opts.fetchImpl || fetch, s = this.opts.endpoint || v8;
    yield { type: "status", text: e.context.images.length && e.input.kind === "message" ? "Looking at the frame…" : "Thinking…" };
    let o;
    try {
      const a = await FU(e, { model: this.opts.model.id, boardId: this.opts.boardId, user: this.opts.uid ? await LU(this.opts.uid) : void 0 }, this.opts.draw);
      if (t.aborted) return;
      o = await x8(s, "/turn", { method: "POST", body: JSON.stringify(a), signal: t }, n);
    } catch {
      if (t.aborted) return;
      yield { type: "text", delta: y8(s) ? "The assistant couldn't be reached. Is the dev server still running?" : "The chat couldn't be reached. Check your connection and try again." };
      return;
    }
    if (!o.ok || !o.body) {
      let a = "";
      try {
        a = (await o.json()).error || "";
      } catch {
        a = "";
      }
      yield { type: "text", delta: a || "The assistant couldn't answer (HTTP " + o.status + ")." };
      return;
    }
    let r = !1;
    for await (const a of NU(o.body, t))
      if (a.type === "status") yield a;
      else if (a.type === "text")
        r = !0, yield a;
      else if (a.type === "plan") yield { type: "plan", plan: a.plan };
      else if (a.type === "picks" || a.type === "ideas" || a.type === "chips") yield a;
      else if (a.type === "error")
        yield { type: "text", delta: (r ? `

` : "") + a.message }, r = !0;
      else if (a.type === "done") {
        a.usage && (yield { type: "usage", usage: a.usage });
        return;
      }
  }
}
const In = 40, cm = 24, k8 = 56;
function GU(i, e) {
  return { x: i.x - e, y: i.y - e, w: i.w + e * 2, h: i.h + e * 2 };
}
function Av(i, e, t, n, s = cm, o = 16) {
  const r = i.x + In, a = i.y + In;
  for (let l = a; l + n <= i.y + i.h - In; l += o)
    for (let d = r; d + t <= i.x + i.w - In; d += o) {
      const c = GU({ x: d, y: l, w: t, h: n }, s - 1);
      if (!e.some((h) => Ya(c, h))) return { x: d, y: l };
    }
  return null;
}
function Pv(i, e, t = cm) {
  const n = uc(e);
  return { x: i.x + In, y: n ? Math.max(i.y + In, n.y + n.h + t) : i.y + In };
}
function jU(i, e, t, n, s, o = k8) {
  if (t <= 0) return [];
  const r = t * n + (t - 1) * o, l = Av(i, e, r, s, o) || Pv(i, e, o), d = [];
  for (let c = 0; c < t; c++) d.push({ x: l.x + c * (n + o), y: l.y, w: n, h: s });
  return d;
}
function Ev(i, e) {
  let t = i.x + i.w, n = i.y + i.h;
  for (const s of e)
    t = Math.max(t, s.x + s.w + In), n = Math.max(n, s.y + s.h + In);
  return t === i.x + i.w && n === i.y + i.h ? null : { x: i.x, y: i.y, w: Math.round(t - i.x), h: Math.round(n - i.y) };
}
function HU(i, e, t, n, s = cm) {
  let o = i.y + i.h;
  for (const r of e)
    r.x < i.x + i.w && r.x + r.w > i.x && r.y >= i.y && r.y + r.h > o && (o = r.y + r.h);
  return { x: i.x, y: o + s, w: t, h: n };
}
function VU(i, e, t, n = 400) {
  if (!e || !t) return { w: i, h: Math.round(i * 0.75) };
  const s = Math.round(i * t / e);
  return s <= n ? { w: i, h: s } : { w: Math.round(n * e / t), h: n };
}
var WU = Object.defineProperty, qU = (i, e, t) => e in i ? WU(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, di = (i, e, t) => qU(i, typeof e != "symbol" ? e + "" : e, t);
const KU = Rt.w;
function br(i) {
  return "“" + i + "”";
}
function ju(i, e, t = e + "s") {
  return i + " " + (i === 1 ? e : t);
}
class YU {
  constructor(e, t, n, s = () => {
  }, o = {}) {
    di(this, "cmd", e), di(this, "plan", t), di(this, "frameId", n), di(this, "onUpdate", s), di(this, "cancelled", !1), di(this, "steps", []), di(this, "added", {}), di(this, "results", 0), di(this, "pollMs"), di(this, "timeoutMs"), di(this, "sendTimeoutMs"), di(this, "columns", []), di(this, "rowY", null), di(this, "nextY", /* @__PURE__ */ new Map()), this.pollMs = o.pollMs || 400, this.timeoutMs = o.timeoutMs || 600 * 1e3, this.sendTimeoutMs = o.sendTimeoutMs || 120 * 1e3;
  }
  /** Stop before the next step. Runs already sent finish anyway (they're paid for). */
  cancel() {
    this.cancelled = !0;
  }
  step(e) {
    return this.steps.find((t) => t.id === e);
  }
  set(e, t) {
    Object.assign(this.step(e), t), this.emit();
  }
  emit() {
    this.onUpdate({ steps: this.steps.map((e) => ({ ...e })), added: { ...this.added }, results: this.results });
  }
  outcome(e, t) {
    return { status: e, steps: this.steps.map((n) => ({ ...n })), added: { ...this.added }, results: this.results, ...t ? { error: t } : {} };
  }
  fail(e, t) {
    return this.set(e, { status: "failed", detail: t }), this.outcome("failed", t);
  }
  stopIfCancelled(e) {
    return this.cancelled ? (this.set(e, { status: "failed", detail: "Stopped before this step" }), this.outcome("cancelled", "Stopped")) : null;
  }
  frame() {
    const e = this.cmd.element(this.frameId);
    return e && e.type === "frame" ? e : null;
  }
  /** Grow the frame to hold these rects, when it doesn't. */
  fit(e) {
    const t = this.frame();
    if (!t) return;
    const n = Ev(He(t), e);
    n && this.cmd.resizeFrame(t.id, n);
  }
  toolOf(e) {
    const t = e.toolId || this.added[e.key], n = t ? this.cmd.element(t) : void 0;
    return n && n.type === "tool" ? t : null;
  }
  async until(e, t) {
    const n = Math.max(1, Math.ceil(t / this.pollMs));
    for (let s = 0; s < n; s++) {
      if (e()) return !0;
      await this.cmd.wait(this.pollMs);
    }
    return e();
  }
  async run() {
    const e = this.plan, t = e.sessions, n = t.filter((_) => !_.toolId), s = t.reduce((_, T) => _ + T.runs.length, 0), o = t.reduce((_, T) => _ + T.runs.reduce((k, P) => k + (P.images ? P.images.length : 0), 0), 0), r = t.some((_) => _.inputs && Object.keys(_.inputs).length);
    for (const _ of n) this.steps.push({ id: "add:" + _.key, text: "Add " + br(_.name) + " to the frame", status: "pending" });
    if (this.steps.push({ id: "prompt", text: t.length > 1 ? "Set the prompt in " + t.length + " sessions" : "Set the prompt" + (r ? " and recommended settings" : ""), status: "pending" }), o && this.steps.push({ id: "attach", text: "Attach " + ju(o, "image") + (o === s ? ", one per run" : ""), status: "pending" }), this.steps.push({ id: "run", text: s === 1 ? "Run it" : "Run " + s + " times", status: "pending" }), e.place && this.steps.push({ id: "place", text: "Set the results out under their sessions", status: "pending" }), this.emit(), !this.frame()) return this.fail(this.steps[0].id, "The frame is gone, so there's nowhere to put the work.");
    if (n.length) {
      const _ = this.frame(), T = jU(He(_), this.cmd.contents(_), n.length, Rt.w, Rt.h, k8);
      this.fit(T);
      for (let k = 0; k < n.length; k++) {
        const P = n[k], A = "add:" + P.key, R = this.stopIfCancelled(A);
        if (R) return R;
        this.set(A, { status: "running" });
        const D = this.cmd.modelOf(P.kitId, P.modelId);
        if (!D) return this.fail(A, P.model + " isn't on this board's tool list any more.");
        const O = T[k], F = this.cmd.addSession(D.kit, D.model, P.name, { x: O.x + O.w / 2, y: O.y + O.h / 2 });
        (F.x !== O.x || F.y !== O.y) && this.cmd.move(F.id, O.x, O.y), this.added[P.key] = F.id, this.set(A, { status: "done", text: "Added " + br(F.name || P.name) + " to the frame" });
      }
    }
    {
      const _ = this.stopIfCancelled("prompt");
      if (_) return _;
      this.set("prompt", { status: "running" });
      for (const T of t) {
        const k = this.toolOf(T);
        if (!k) return this.fail("prompt", br(T.name) + " is no longer on the board.");
        const P = this.cmd.promptOf(k);
        this.cmd.setPrompt(k, { prompt: T.prompt, n: T.n, inputs: { ...P.inputs || {}, ...T.inputs || {} } });
      }
      this.set("prompt", { status: "done", text: t.length > 1 ? "Set the prompt in " + t.length + " sessions" : "Set the prompt" + (r ? " and recommended settings" : "") });
    }
    const a = /* @__PURE__ */ new Map();
    for (const _ of t) {
      const T = this.toolOf(_);
      a.set(T, new Set(this.cmd.results(T).map((k) => k.id)));
    }
    let l = 0, d = 0;
    const c = /* @__PURE__ */ new Set();
    this.set("run", { status: "running", text: "Running 0 of " + s });
    for (const _ of t) {
      const T = this.toolOf(_);
      if (!T) return this.fail("run", br(_.name) + " is no longer on the board.");
      for (const k of _.runs) {
        const P = this.stopIfCancelled("run");
        if (P) return P;
        if (!await this.until(() => !this.cmd.submitting(T), this.sendTimeoutMs)) return this.fail("run", "The last run in " + br(_.name) + " is still being sent.");
        const R = this.cmd.error(T);
        if (c.has(T) && R) return this.fail("run", R);
        if (k.images && k.images.length) {
          const O = this.cmd.imageFields(T)[0];
          if (!O) return this.fail("attach", _.model + " takes no images.");
          d === 0 && this.set("attach", { status: "running" }), this.cmd.setRefInput(T, O.key, null);
          for (const F of k.images) {
            if (!this.cmd.setRefInput(T, O.key, F.url, this.cmd.assetOf(F.id, F.url))) return this.fail("attach", "An image couldn't be attached to " + br(_.name) + ".");
            d++;
          }
          this.set("attach", d >= o ? { status: "done", text: "Attached " + ju(o, "image") + (o === s ? ", one per run" : "") } : { text: "Attaching " + d + " of " + o });
        }
        const D = this.cmd.generate(T);
        if (D) return this.fail("run", D);
        c.add(T), l++, this.set("run", { text: "Running " + l + " of " + s });
      }
    }
    const h = t.reduce((_, T) => _ + T.runs.length * T.n, 0);
    this.columns = t.map((_) => this.toolOf(_)).filter((_) => !!_);
    const f = /* @__PURE__ */ new Set(), p = (_) => this.cmd.results(_).filter((T) => T.status === "done" && !!T.url && !a.get(_).has(T.id)), y = () => {
      let _ = 0;
      for (const T of t) _ += p(this.toolOf(T) || "").length;
      return _;
    }, v = () => {
      let _ = !1;
      for (const k of t) {
        const P = this.toolOf(k);
        if (P) {
          if (this.cmd.submitting(P) || this.cmd.generating(P)) {
            _ = !0;
            continue;
          }
          e.place && this.placeFor(P, p(P), f);
        }
      }
      const T = y();
      return T !== this.results && (this.results = T, this.emit()), !_;
    }, x = await this.until(v, this.timeoutMs), w = t.map((_) => this.toolOf(_)).filter((_) => !!_).map((_) => this.cmd.error(_)).filter((_) => !!_);
    if (!x)
      return this.fail("run", "Still running after " + Math.round(this.timeoutMs / 6e4) + " minutes. The results will land in their sessions when they finish.");
    if (w.length && this.results < h)
      return this.fail("run", w[0]);
    const S = t.length === 1 ? this.cmd.element(this.toolOf(t[0]) || "") : void 0, M = S && S.type === "tool" ? S.name : t[0].name;
    return this.set("run", { status: "done", text: ju(this.results, "result") + " landed" + (t.length === 1 ? " in " + br(M) : "") }), e.place && this.set("place", { status: f.size ? "done" : "failed", text: f.size ? "Set " + ju(f.size, "result") + " out under " + (t.length === 1 ? "the session" : "their sessions") : "Set the results out under their sessions", ...f.size ? {} : { detail: "No results to place" } }), this.outcome("done");
  }
  /**
   * Where this plan's results start: one row, under whatever is already in
   * every one of its sessions' columns, so a comparison reads as a grid (a
   * row per prompt, a column per tool). Worked out when the first result is
   * ready, so a run started before anything else was placed starts higher.
   */
  firstRow() {
    if (this.rowY != null) return this.rowY;
    const e = this.frame(), t = e ? this.cmd.contents(e) : [];
    let n = -1 / 0;
    for (const s of this.columns) {
      const o = this.cmd.element(s);
      o && (n = Math.max(n, HU(He(o), t, 0, 0).y));
    }
    return this.rowY = Number.isFinite(n) ? n : 0, this.rowY;
  }
  /** A session's new results onto the board, in its column from the plan's row down, the frame growing to hold them. */
  placeFor(e, t, n) {
    const s = this.frame(), o = this.cmd.element(e);
    if (!s || !o) return;
    const r = He(o), a = t.filter((l) => !n.has(l.id)).sort((l, d) => l.createdAt - d.createdAt);
    if (a.length) {
      this.step("place").status === "pending" && this.set("place", { status: "running" });
      for (const l of a) {
        const d = VU(Math.min(KU, r.w), l.w, l.h), c = this.nextY.has(e) ? this.nextY.get(e) : this.firstRow(), h = { x: r.x, y: c, w: d.w, h: d.h };
        this.fit([h]), this.cmd.place(l, h) && (n.add(l.id), this.nextY.set(e, c + d.h + cm));
      }
    }
  }
}
function _8(i) {
  for (let e = i.length - 1; e >= 0; e--) {
    const t = i[e];
    if (t.role === "agent") return t.memo || null;
  }
  return null;
}
var XU = Object.defineProperty, JU = (i, e, t) => e in i ? XU(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Hu = (i, e, t) => JU(i, typeof e != "symbol" ? e + "" : e, t);
const um = [
  "A glass pavilion in a pine forest at dawn",
  "A timber library on a lake at dusk",
  "A rooftop garden café in the rain"
], S8 = /* @__PURE__ */ new Set(["image", "imageEdit"]), ZU = { one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10, twelve: 12 };
function Do(i) {
  const e = /\b(\d{1,2}|one|two|three|four|five|six|seven|eight|nine|ten|twelve)\b/i.exec(i);
  if (!e) return null;
  const t = /\d/.test(e[1]) ? Number(e[1]) : ZU[e[1].toLowerCase()];
  return Number.isFinite(t) && t > 0 ? t : null;
}
function es(i, e, t = e + "s") {
  return i + " " + (i === 1 ? e : t);
}
function da(i) {
  return i && i.charAt(0).toUpperCase() + i.slice(1);
}
function nr(i) {
  return i.length <= 1 ? i.join("") : i.slice(0, -1).join(", ") + " and " + i[i.length - 1];
}
function Kn(i) {
  return "**" + i + "**";
}
function ml(i) {
  return i.trim().replace(/^(now\s+)?(try|run|do|prompt|another( one)?|next)\s*[:,-]\s*/i, "").replace(/^["“'‘]+|["”'’]+$/g, "").trim();
}
function ql(i, e, t) {
  const n = " " + Rl(i) + " ", s = [], o = [], r = (l, d) => !o.some(([c, h]) => l < h && d > c), a = e.entries().filter((l) => l.kits.some((d) => S8.has(d.id))).map((l) => ({ e: l, n: Rl(l.name) })).filter((l) => l.n.length >= 4).sort((l, d) => d.n.length - l.n.length);
  for (const { e: l, n: d } of a) {
    const c = n.indexOf(" " + d + " ");
    c < 0 || !r(c, c + d.length + 2) || (o.push([c, c + d.length + 2]), s.push({ at: c, entry: l }));
  }
  for (const l of t.families) {
    const d = new RegExp(l.match.source, "gi");
    let c;
    for (; c = d.exec(n); )
      if (r(c.index, c.index + c[0].length)) {
        o.push([c.index, c.index + c[0].length]), s.push({ at: c.index, family: l });
        break;
      }
  }
  return s.sort((l, d) => l.at - d.at);
}
function hm(i, e, t) {
  if (i.entry) return { entry: i.entry, others: [] };
  const n = i.family, s = n.members.map((r) => t.get(r)).filter((r) => !!r), o = n.pick[e] || n.pick.default;
  return o && t.has(o.id) ? { entry: t.get(o.id), why: o.why, family: n, others: s.filter((r) => r.id !== o.id) } : { entry: null, family: n, others: s, note: n.note };
}
function ts(i, e, t) {
  return t.jobs[i].picks.filter((n) => e.has(n.id)).map((n) => ({ entry: e.get(n.id), why: n.why }));
}
function QU(i, e) {
  const t = i.price(e, { prompt: "x", n: 1 }, 1);
  return t == null ? "" : "about " + g8(t) + " a picture";
}
function gp(i) {
  return /\b(sign|signage|text|lettering|typograph|poster|logo type|wordmark|label)/i.test(i) ? "text" : /\b(logo|icon|vector|flat|graphic|illustration|design)/i.test(i) ? "design" : /\b(draft|quick|fast|cheap|rough|sketch)/i.test(i) ? "drafts" : /\b(edit|change|relight|restyle|retouch)/i.test(i) ? "edit" : /\b(compar|side by side|shoot-?out)/i.test(i) ? "compare" : "photoreal";
}
function M8(i) {
  return i.notes.map((e) => e.text.replace(/^\s*(client|note|brief|nb|todo)\s*:\s*/i, "").replace(/\s+/g, " ").trim()).filter(Boolean);
}
function T8(i) {
  const e = i.trim();
  return e ? da(e) + (/[.!?]$/.test(e) ? "" : ".") : "";
}
function Vo(i) {
  const e = [];
  return i.images.length && e.push({ label: "Make these night scenes", send: "Change " + (i.images.length === 1 ? "this image" : "all " + i.images.length + " of these images") + " to a nighttime scene with ChatGPT Image 2.5. Use recommended settings." }), i.sessions.length && e.push({ label: "Run a new prompt here", send: "Now try: " + um[0].toLowerCase() }), e.push({ label: "Compare 3 image tools", send: "Get me the best image tools to compare a single prompt across 3 different image tools. Which are the best?" }), e.push({ label: "Prompting tips", send: "How should I prompt Ideogram for signage text?" }), {
    text: `I can't do that one in this prototype. Here's what I can do with this frame:
- change the images in it with a tool you name
- recommend tools and set up a side-by-side comparison
- run a new prompt through the sessions in it
- make new pictures from a prompt
- give prompting tips for a tool

Every plan shows its token cost, and nothing runs until you press Run plan.`,
    chips: e
  };
}
function eG(i) {
  const e = p8(i), t = e === "Empty" ? "which is empty so far" : "which holds " + e, n = i.images.length ? [{ label: "Make these night scenes", send: "Change " + (i.images.length === 1 ? "this image" : "all " + i.images.length + " of these images") + " to a nighttime scene with ChatGPT Image 2.5. Use recommended settings." }, { label: "What's in this frame?" }] : [{ label: "Compare 3 image tools", send: "Get me the best image tools to compare a single prompt across 3 different image tools. Which are the best?" }, { label: "Make 4 concept images", send: "Make 4 concept images of a timber pavilion on a lake at dusk" }];
  return n.push({ label: "Which tools are best for photoreal?" }), {
    text: "Hi! I work on what's in “" + i.title + "”, " + t + ". I set up tool sessions here and run them for you, always with a priced plan you approve first. What should we do?",
    chips: n
  };
}
function tG(i) {
  const e = ["Here's what's in “" + i.title + "”:"];
  i.images.forEach((t, n) => {
    const s = t.model ? t.prompt ? ": made with " + t.model + " from “" + Qs(t.prompt, 90) + "”" : ": made with " + t.model : ": an image I have no record of";
    e.push(n + 1 + ". Image " + (n + 1) + s);
  });
  for (const t of i.sessions) e.push("- Session " + Kn(t.name) + " (" + t.model + ")" + (t.prompt ? ", prompt “" + Qs(t.prompt, 70) + "”" : "") + ", " + es(t.results, "result"));
  for (const t of i.notes) e.push("- Note: “" + Qs(t.text, 100) + "” (I treat notes as standing instructions)");
  return e.length === 1 && e.push("Nothing yet. Add images, sessions or notes to the frame and I'll read them."), i.ignored && e.push(`
I leave out ` + es(i.ignored, "shape or nested frame", "shapes and nested frames") + "."), { text: e.join(`
`) };
}
function Qs(i, e) {
  const t = i.replace(/\s+/g, " ").trim();
  return t.length > e ? t.slice(0, e - 1).trimEnd() + "…" : t;
}
function Fw(i) {
  return /\b(change|turn|make|convert|edit|transform|restyle|relight|redo|update|switch)\b/i.test(i) && /\b(these|this|them|those|all|every|each|the)\b(\s+\w+){0,3}\s*\b(images?|pictures?|renders?|photos?|shots?|views?|ones)\b|\b(them|these|all of (them|these)|each of (them|these))\b/i.test(i);
}
function nG(i) {
  const e = /\b(?:to|into|as)\s+(.+?)(?:\s+\b(?:with|using|in|via|on)\b\s+.*|[.!?\n]|$)/i.exec(i);
  return e ? e[1].trim().replace(/^(an?|the)\s+/i, (t) => t.toLowerCase()) : "";
}
function iG(i, e, t) {
  const n = i.edits.findIndex((a) => a.match.test(e)), s = n >= 0 ? i.edits[n] : null, r = [
    "Turn this image into " + (s ? s.change : e || "the change described") + ".",
    "Keep the same building, camera angle, framing and materials."
  ];
  s && r.push(s.light);
  for (const a of t) r.push(T8(a));
  return r.push("Photorealistic architectural photograph."), { prompt: r.join(" "), name: s ? s.name : da(Qs(e || "Edited", 24)) + (s ? "" : " versions"), recipe: n };
}
function pc(i) {
  return Math.max(1, i.model.numResults.max);
}
function bp(i, e, t, n, s) {
  const o = Math.min(s.n, pc(n)), r = M8(e), { prompt: a, name: l, recipe: d } = iG(i, s.change, r), c = dm(i, n.id), h = {};
  for (const p of c && c.settings || []) h[p.field] = p.value;
  s.quality && (h.Quality = s.quality), c && c.sizeFromInput && (h.size = "match");
  const f = {
    name: l,
    modelId: n.id,
    job: "edit",
    prompt: a,
    n: o,
    runs: t.map((p) => ({ imageIds: [p.id] })),
    settings: h,
    ...s.why ? { why: s.why } : {}
  };
  return {
    plan: {
      title: l,
      summary: "One session, one run per image, each with that image as its input" + (o > 1 ? ", " + o + " results a run" : "") + ".",
      sessions: [f]
    },
    recipe: d,
    name: l
  };
}
function sG(i, e, t) {
  const { context: n, catalog: s, guidance: o } = i;
  if (!n.images.length)
    return {
      text: "There are no images in “" + n.title + "” to change. Drag some into the frame, or ask me to make new ones.",
      chips: [{ label: "Make 4 concept images", send: "Make 4 concept images of a timber pavilion on a lake at dusk" }]
    };
  const r = Do(e.replace(/\b2\.5\b/g, "")), l = (r && r < n.images.length && /\b(first|these|the)\b/i.test(e) ? n.images.slice(0, r) : n.images).filter((F) => !F.video);
  if (!l.length) return { text: "Those are videos, and this prototype only edits still images." };
  const d = /(\d+|two|three|four)\s+(versions?|results?|options?|variations?)\s+(each|per image|of each)/i.exec(e), c = d && Do(d[1]) || 1, h = nG(e) || t && t.change || "", f = ql(e, s, o), p = [];
  let y = null, v = "";
  if (f.length) {
    const F = hm(f[0], "edit", s);
    if (F.entry && F.entry.imageField)
      y = F.entry, F.family && F.others.length ? (v = F.why || "", p.push(F.family.name + " comes in " + so(F.others.length + 1) + " versions here, " + nr([F.entry, ...F.others].map((te) => te.name.replace(F.family.name, "").trim() || te.name)) + ". I picked " + Kn(F.entry.name) + ": " + v + ".")) : p.push("I'll use " + Kn(F.entry.name) + ".");
    else {
      const te = F.entry ? F.entry.name : F.family ? F.family.name : "That tool", ee = ts("edit", s, o)[0];
      if (!ee) return Vo(n);
      y = ee.entry, v = ee.why, p.push((F.note || te + " can't take an image as input, so it can't change these.") + " " + Kn(y.name) + " can: " + ee.why + ". I've used it instead.");
    }
  } else {
    const F = ts("edit", s, o)[0];
    if (!F) return Vo(n);
    y = F.entry, v = F.why, p.push("I'll use " + Kn(y.name) + ", RunDiffusion's pick for edits: it " + F.why + ".");
  }
  const x = bp(o, n, l, y, { change: h, n: c, quality: void 0, why: v }), w = Iv(x.plan, n, s);
  let S = x.plan;
  if (!w.ok) {
    const F = ts("edit", s, o).find((te) => te.entry.id !== y.id && Iv(bp(o, n, l, te.entry, { change: h, n: c }).plan, n, s).ok);
    if (!F) return { text: y.name + " can't run this: " + w.error + " I couldn't find another tool here that can." };
    p.length = 0, p.push(y.name + " can't run this as asked (" + w.error.replace(/\.$/, "") + "). " + Kn(F.entry.name) + " can: it " + F.why + ". I've used it instead."), y = F.entry, S = bp(o, n, l, y, { change: h, n: c }).plan;
  }
  const M = l.length, _ = M === 1 ? "I'll edit this image with the change you asked for." : "I'll edit each image on its own so the " + so(M) + " stay comparable: one session, one run per image, each with that image as its input.", T = M8(n);
  T.length && p.push("I kept " + (T.length === 1 ? "your note" : "your notes") + " in the prompt: " + T.map((F) => "“" + Qs(F, 80).replace(/[.!]+$/, "") + "”").join(", ") + ".");
  const k = dm(o, y.id), P = (k && k.settings ? k.settings.map((F) => F.say) : []).concat(k && k.sizeFromInput ? ["sized to match your images"] : []);
  P.length && p.push((/recommended/i.test(e) ? "Recommended settings, as you asked: " : "Recommended settings: ") + nr(P) + ".");
  const A = [], R = o.families.find((F) => F.members.includes(y.id) && F.members.length > 1) || null, D = R ? R.members.map((F) => s.get(F)).find((F) => F && F.id !== y.id && !!F.imageField) : null;
  R && D && A.push({ label: "Use " + (D.name.replace(R.name, "").trim() || D.name) + " instead", send: "Use " + D.name + " instead" });
  const O = S.sessions[0] ? S.sessions[0].n : 1;
  return O === 1 && pc(y) > 1 && A.push({ label: "2 versions per image", send: "Make 2 versions per image" }), s.field(y, "Quality") && A.push({ label: "Medium quality, cheaper", send: "Use medium quality" }), {
    status: "Reading the frame…",
    text: [_, ...p].join(`

`),
    plan: S,
    chips: A,
    memo: { flow: "edit", step: "proposed", modelId: y.id, imageIds: l.map((F) => F.id), change: h, n: O, quality: t ? t.quality : void 0 }
  };
}
function oG(i, e, t) {
  const { context: n, catalog: s, guidance: o } = i;
  let r = t.modelId ? s.get(t.modelId) : null;
  if (!r) return null;
  const a = [];
  let l = t.n || 1, d = t.quality;
  const c = ql(e, s, o);
  let h = !1;
  if (/\b(instead|switch|swap|use)\b/i.test(e) && c.length) {
    const x = hm(c[0], "edit", s);
    if (x.entry && x.entry.imageField && x.entry.id !== r.id)
      r = x.entry, a.push("Switched to " + Kn(r.name) + "."), h = !0;
    else if (x.entry && !x.entry.imageField)
      return { text: x.entry.name + " can't take an image as input, so I've kept " + r.name + "." };
  }
  const f = /(\d+|two|three|four)\s+(versions?|results?|options?|variations?)/i.exec(e);
  if (f) {
    const x = Math.max(1, Math.min(4, Do(f[1]) || 1));
    l = Math.min(x, pc(r)), a.push(l < x ? r.name + " makes " + es(pc(r), "result") + " a run, so it stays at " + es(l, "result") + " per image." : es(l, "result") + " per image."), h = !0;
  }
  const p = /\b(low|medium|high|extra high|xhigh|max)\b\s*quality|\bquality\s*(low|medium|high|max)\b|\bcheaper\b/i.exec(e);
  if (p && s.field(r, "Quality")) {
    const x = (p[1] || p[2] || "medium").toLowerCase().replace("extra high", "xhigh");
    d = p[0].toLowerCase().includes("cheaper") && !p[1] && !p[2] ? "medium" : x, a.push(da(d === "xhigh" ? "extra high" : d) + " quality."), h = !0;
  }
  if (!h) return null;
  const y = (t.imageIds || []).map((x) => n.images.find((w) => w.id === x)).filter((x) => !!x);
  if (!y.length) return null;
  const v = bp(o, n, y, r, { change: t.change || "", n: l, quality: d });
  return {
    text: "Here's the plan again with that change. " + a.join(" "),
    plan: v.plan,
    chips: v.plan.sessions[0].n === 1 && pc(r) > 1 ? [{ label: "2 versions per image", send: "Make 2 versions per image" }] : [],
    memo: { ...t, modelId: r.id, n: v.plan.sessions[0].n, quality: d }
  };
}
function rG(i) {
  return /\bcompar(e|ing|ison)\b|\bside[- ]by[- ]side\b|\bshoot-?out\b|\bhead[- ]to[- ]head\b|\bacross\s+(\d+|two|three|four)\s+(different\s+)?(image\s+)?(tools|models)\b/i.test(i);
}
function Nw(i, e) {
  const { catalog: t, guidance: n } = i, s = n.jobs.compare, o = ts("compare", t, n);
  if (o.length < 2) return { text: "There aren't enough image tools on this board's tool list to compare." };
  const r = Math.min(o.length, Do(e) && Do(e) >= 2 && Do(e) <= 5 ? Do(e) : s.suggest || 3), a = [s.intro + " From RunDiffusion's guidance:", ""];
  return o.forEach((l, d) => {
    const c = QU(t, l.entry);
    a.push(d + 1 + ". " + Kn(l.entry.name) + ": " + l.why + (c ? ". " + da(c) + "." : "."));
  }), a.push("", "My " + so(r) + ": " + nr(o.slice(0, r).map((l) => l.entry.name)) + ", a good spread of strengths at a fair price. Pick yours below, or name them."), {
    status: "Checking the tool list…",
    text: a.join(`
`),
    chips: [{ label: "Use your top " + r, send: "Use your top " + r }].concat(o.map((l) => ({ label: l.entry.name, send: l.entry.name }))),
    memo: { flow: "rig", step: "pick", picks: [], n: r }
  };
}
function Vd(i) {
  return /\b(tuned?|tuning|per[- ]tool|optimi[sz]ed?|each its own|adapt)/i.test(i) ? "tuned" : /\b(exact|same|identical|fair|verbatim|as[- ]is|one prompt)\b/i.test(i) ? "exact" : null;
}
function Wd(i) {
  const e = i.indexOf(":");
  return e >= 0 ? ml(i.slice(e + 1)) : "";
}
function vp(i) {
  const e = i.trim();
  return e.length < 8 || /\?$/.test(e) || /^(yes|yeah|yep|no|nope|ok|okay|sure|thanks|thank you|cool|great|nice|done|that'?s it)\b/i.test(e) ? !1 : /\b(a|an|the)\b/i.test(e) || e.split(/\s+/).length >= 4;
}
function Uw(i, e, t) {
  const { catalog: n, guidance: s } = i, o = t.n || s.jobs.compare.suggest || 3;
  let r = (t.picks || []).filter((l) => n.has(l));
  const a = [];
  if (t.step === "pick") {
    if (/\b(top|your|recommended|suggested|default)\b.*\b(\d|three|two|four|picks?|ones)\b|\byour picks\b|\bgo with yours\b|\bsounds good\b/i.test(e))
      r = ts("compare", n, s).slice(0, o).map((c) => c.entry.id);
    else {
      const c = ql(e, n, s);
      if (!c.length && !/\b(that'?s it|just these|done|only these)\b/i.test(e)) return null;
      const h = c.map((p) => hm(p, "compare", n)), f = new Set(h.filter((p) => p.entry && !p.entry.needsImage).map((p) => p.entry.id));
      for (const p of h) {
        if (p.entry && !p.entry.needsImage) {
          r.includes(p.entry.id) || r.push(p.entry.id), p.family && p.others.length && p.why && a.push("For " + p.family.name + " I took " + Kn(p.entry.name) + ": " + p.why + ".");
          continue;
        }
        const y = ts("compare", n, s).find((w) => !r.includes(w.entry.id) && !f.has(w.entry.id)), v = p.entry ? p.entry.name : p.family ? p.family.name : "That tool", x = p.note || v + " needs an image to start from, so it can't run a prompt on its own.";
        y ? (r.push(y.entry.id), f.add(y.entry.id), a.push(x + " I've put " + Kn(y.entry.name) + " in its place: " + y.why + ".")) : a.push(x);
      }
      if (r.length < 2 || r.length < o && !/\b(that'?s it|just these|done|only these)\b/i.test(e)) {
        const p = ts("compare", n, s).filter((v) => !r.includes(v.entry.id)), y = r.map((v) => n.get(v).name);
        return {
          text: [a.join(" "), (y.length ? nr(y) + ", noted. " : "") + (o - r.length === 1 ? "One more: pick it below, or name it." : o - r.length + " more: pick them below, or name them.") + (r.length >= 2 ? " Or say “that's it” to compare just these." : "")].filter(Boolean).join(`

`),
          chips: p.map((v) => ({ label: v.entry.name, send: v.entry.name })),
          memo: { ...t, picks: r }
        };
      }
    }
    const l = Vd(e), d = Wd(e);
    return Vu(i, { ...t, picks: r, mode: l || void 0, prompt: d || void 0 }, a);
  }
  if (t.step === "mode") {
    const l = Vd(e), d = Wd(e) || (!l && vp(e) ? ml(e) : "");
    if (!l && !d) return null;
    const c = !l && d ? ["I'll keep the exact same prompt for all of them, the fairest test. Say “tuned” to word it for each tool instead."] : [];
    return Vu(i, { ...t, mode: l || "exact", prompt: d || t.prompt }, c);
  }
  if (t.step === "prompt") {
    const l = Vd(e), d = /:/.test(e) ? Wd(e) : ml(e);
    return !vp(d) && !(d && d.split(/\s+/).length >= 2) ? null : Vu(i, { ...t, mode: l || t.mode, prompt: d }, []);
  }
  if (t.step === "proposed") {
    const l = Vd(e), d = /:/.test(e) ? Wd(e) : vp(e) && !l ? ml(e) : "";
    return !l && !d ? null : Vu(i, { ...t, mode: l || t.mode, prompt: d || t.prompt }, ["Here's the rig again with that change."]);
  }
  return null;
}
function Vu(i, e, t) {
  const { catalog: n, guidance: s } = i, o = (e.picks || []).map((d) => n.get(d)).filter((d) => !!d), r = nr(o.map((d) => Kn(d.name)));
  if (!e.mode)
    return {
      text: [t.join(" "), r + " it is. Should " + (o.length === 2 ? "both" : "all " + so(o.length)) + " get the exact same prompt, which is the fairest test, or should I tune the wording for each tool, closer to how each is best used? Then tell me the prompt."].filter(Boolean).join(`

`),
      chips: [{ label: "Exact prompt" }, { label: "Tuned per tool" }],
      memo: { ...e, flow: "rig", step: "mode" }
    };
  if (!e.prompt)
    return {
      text: [t.join(" "), (e.mode === "exact" ? "Exact prompt it is: every tool gets the same words." : "Tuned it is: I'll word the prompt for each tool, from RunDiffusion's prompt tips.") + " What's the prompt?"].filter(Boolean).join(`

`),
      chips: um.map((d) => ({ label: d })),
      memo: { ...e, flow: "rig", step: "prompt" }
    };
  const a = e.prompt, l = o.map((d) => ({
    name: d.name,
    modelId: d.id,
    job: "generate",
    prompt: e.mode === "tuned" ? f8(s, d.id, a) : a,
    n: 1,
    why: (s.jobs.compare.picks.find((c) => c.id === d.id) || { why: "" }).why
  }));
  return {
    status: "Laying out the rig…",
    text: [
      t.join(" "),
      "Here's the rig: " + so(o.length) + " sessions side by side in this frame, " + (e.mode === "tuned" ? "each with the prompt worded for its tool" : "the same prompt in each") + ", one picture apiece. Results land under their tools, so you can compare them right here.",
      e.mode === "tuned" ? "Each session's wording is on the plan; open any session to change it." : ""
    ].filter(Boolean).join(`

`),
    plan: {
      title: "Compare " + o.length + " tools",
      summary: o.length + " sessions side by side under one prompt: “" + Qs(a, 80) + "”.",
      place: !0,
      sessions: l
    },
    memo: { ...e, flow: "rig", step: "proposed" }
  };
}
function aG(i, e) {
  return /^\s*(now\s+)?(try|run|do)\s*[:,-]/i.test(i) || /^\s*now try\b/i.test(i) || /^\s*(another( one)?|next( prompt)?)\s*:/i.test(i) || /\brun\b.*\b(across|through|in)\b.*\b(all|each|every|these|the)\b.*\b(sessions?|tools?)\b/i.test(i) ? !0 : !!e && e.step === "ready" && vp(i) && !/\b(how|what|which|why)\b/i.test(i);
}
function lG(i, e, t) {
  const { context: n, catalog: s, guidance: o } = i, r = /:/.test(e) ? Wd(e) : ml(e.replace(/\brun\b.*\b(across|through)\b.*?\b(sessions?|tools?)\b[:,]?/i, ""));
  if (!r) return { text: "What's the prompt? Write it after “Now try:” and I'll run it through every session here." };
  const a = [], l = [];
  for (const f of n.sessions) {
    const p = f.nodeDefId ? s.get(f.nodeDefId) : null;
    !p || p.needsImage || !S8.has(f.kitId) ? l.push(f.name) : a.push(f);
  }
  if (!a.length)
    return { text: "None of the sessions here can run a prompt on its own" + (l.length ? " (" + nr(l) + " need an image to start from)" : "") + ". Want me to set up a comparison instead?", chips: [{ label: "Compare 3 image tools", send: "Get me the best image tools to compare a single prompt across 3 different image tools. Which are the best?" }] };
  const d = Vd(e) || t && t.mode || "exact", c = a.map((f) => ({
    toolId: f.id,
    name: f.name,
    modelId: f.nodeDefId,
    prompt: d === "tuned" ? f8(o, f.nodeDefId, r) : r,
    n: 1
  })), h = a.length === 1 ? "the session" : a.length === 2 ? "both sessions" : "all " + so(a.length) + " sessions";
  return {
    status: "Reading the frame…",
    text: [
      "I'll run it through " + h + " in this frame, " + (d === "tuned" ? "with the wording tuned for each tool" : "the exact same prompt in each") + (t && t.mode ? ", as before" : "") + ". The results land in a new row under each tool.",
      l.length ? "I've left out " + nr(l) + ": " + (l.length === 1 ? "it needs" : "they need") + " an image to start from." : "",
      !t || !t.mode ? "Say “tuned” to word it for each tool instead." : ""
    ].filter(Boolean).join(`

`),
    plan: {
      title: "New prompt across " + es(a.length, "session"),
      summary: "“" + Qs(r, 90) + "”, through " + h + " here.",
      place: !0,
      sessions: c
    },
    memo: { flow: "reuse", step: "proposed", mode: d, prompt: r }
  };
}
function dG(i) {
  return /\?\s*$/.test(i) || /^(how|what|which|why|when|should|can|could|is|are|do|does|any)\b/i.test(i.trim()) || /\b(tips?|advice|best way)\b/i.test(i);
}
function cG(i, e) {
  const { catalog: t, guidance: n } = i, s = ql(e, t, n), o = gp(e);
  if (/\bprompt|tips?|advice|best way|write\b/i.test(e) && s.length) {
    const r = s[0], a = r.entry ? r.entry.id : r.family ? r.family.members[0] : "", l = a ? dm(n, a) : null, d = r.entry ? r.entry.name : r.family ? r.family.name : "";
    if (l) {
      const c = [(l.tips.length > 3 ? da(so(l.tips.length)) + " things" : "A few things") + " that help " + d + (o === "text" ? " with signage and lettering" : "") + ":"];
      for (const p of l.tips) c.push("- " + p);
      const h = r.family && r.family.note, f = ts(o, t, n)[0];
      return h && c.push("", "On this board: " + h + (f && o !== "edit" ? " For a new picture with " + (o === "text" ? "signage" : "this kind of work") + ", " + Kn(f.entry.name) + " is the strongest here: " + f.why + "." : "")), { status: "Looking it up…", text: c.join(`
`), chips: o === "text" ? [{ label: "Which tools are best for text?" }] : [] };
    }
  }
  if (/\b(best|which|recommend|good)\b/i.test(e)) {
    const r = n.jobs[o], a = ts(o, t, n);
    if (a.length) {
      const l = [r.intro];
      for (const d of a) l.push("- " + Kn(d.entry.name) + ": " + d.why + ".");
      return {
        status: "Checking the tool list…",
        text: l.join(`
`),
        chips: [{ label: "Compare the top 3", send: "Compare " + nr(a.slice(0, 3).map((d) => d.entry.name)) + " side by side" }]
      };
    }
  }
  return Vo(i.context);
}
function so(i) {
  return ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten"][i] || String(i);
}
function uG(i) {
  return /\b(make|create|generate|render|draw|design|imagine|give me|show me|produce)\b/i.test(i);
}
function hG(i, e) {
  const { catalog: t, guidance: n } = i, s = ql(e, t, n), o = gp(e) === "edit" || gp(e) === "compare" ? "photoreal" : gp(e);
  let r = null, a = "";
  const l = [];
  if (s.length) {
    const y = hm(s[0], o, t);
    if (y.entry && !y.entry.needsImage)
      r = y.entry, a = y.why || "", y.family && y.others.length && a && l.push("For " + y.family.name + " I took " + Kn(r.name) + ": " + a + ".");
    else {
      const v = ts(o, t, n)[0];
      if (!v) return Vo(i.context);
      l.push((y.note || (y.entry ? y.entry.name : "That tool") + " needs an image to start from.") + " I've used " + Kn(v.entry.name) + " instead: " + v.why + "."), r = v.entry;
    }
  } else {
    const y = ts(o, t, n)[0];
    if (!y) return Vo(i.context);
    r = y.entry, a = y.why, l.push("I'll use " + Kn(r.name) + ", RunDiffusion's pick for " + n.jobs[o].label.toLowerCase() + ": " + a + ".");
  }
  const d = ml(e.replace(/^\s*(please\s+)?(can you\s+)?(make|create|generate|render|draw|design|imagine|give me|show me|produce)\s+(me\s+)?/i, "").replace(/^(\d+|one|two|three|four|five|six|seven|eight|nine|ten|twelve|a|an|some)\s+/i, "").replace(/^((concept|new|quick|fresh)\s+)*(images?|pictures?|renders?|options?|versions?|concepts?|variations?|shots?)\s+(of\s+)?/i, "").replace(/\s+(with|using|in)\s+[^,]*?(nano banana|chatgpt|flux|seedream|ideogram|gpt)[^,.]*$/i, ""));
  if (!d || d.split(/\s+/).length < 2)
    return { text: "What should the pictures show? Describe the subject and I'll plan it.", chips: um.map((y) => ({ label: y, send: "Make 4 images of " + y.charAt(0).toLowerCase() + y.slice(1) })) };
  const c = Math.max(1, Math.min(12, Do(e.replace(/\b\d\.\d\b/g, "")) || 1)), h = t.results(r, c), f = Math.ceil(c / h), p = T8(d).replace(/\.$/, "") + ". " + (o === "photoreal" ? "Photorealistic architectural photograph, natural light." : "");
  return {
    status: "Reading the frame…",
    text: [
      "I'll add a session to this frame and make " + es(c, "picture") + (f > 1 ? " in " + f + " runs of " + h : "") + ". They'll land under the session.",
      ...l
    ].join(`

`),
    plan: {
      title: da(Qs(d, 32)),
      summary: "One new session, " + es(c, "picture") + ".",
      place: !0,
      sessions: [{ name: da(Qs(d.split(/[,.]/)[0], 28)), modelId: r.id, job: "generate", prompt: p.trim(), n: h, runs: Array.from({ length: f }, () => ({ imageIds: [] })), ...a ? { why: a } : {} }]
    },
    memo: { flow: "make", step: "proposed" }
  };
}
function pG(i, e) {
  const t = _8(i.history) || {}, n = e.results || 0;
  if (e.status === "cancelled") return null;
  if (e.status === "failed" || e.status === "stopped")
    return {
      text: "The plan stopped" + (e.error ? ": " + e.error.replace(/\.$/, "") : "") + "." + (n ? " " + es(n, "result") + " made it before it did." : " Nothing was charged for the steps that didn't run."),
      chips: [{ label: "What's in this frame?" }],
      memo: t
    };
  const s = e.sessions.some((r) => r.runs.some((a) => a.images && a.images.length));
  if (!s && (e.sessions.length > 1 || e.sessions.every((r) => !!r.toolId))) {
    const r = e.sessions.length, a = e.sessions.map((d) => Rl(d.prompt)), l = um.filter((d) => !a.some((c) => c.includes(Rl(d))));
    return {
      text: (r === 2 ? "Both are" : r === 1 ? "It's" : "All " + so(r) + " are") + " in, side by side under " + (r === 1 ? "the session" : "their tools") + ". Want to run another prompt across " + (r === 2 ? "both" : r === 1 ? "it" : "all " + so(r)) + "? Just type it, like “Now try: " + l[0].toLowerCase() + "”.",
      chips: l.slice(0, 2).map((d) => ({ label: "Now try: " + d.toLowerCase() })),
      memo: { flow: "rig", step: "ready", mode: t.mode || "exact" }
    };
  }
  if (s) {
    const r = e.sessions[0];
    return {
      text: "Done: " + es(n, "result") + " in “" + (r ? r.name : e.title) + "”. Click a thumbnail on the session to see one full size, or drag it onto the board.",
      chips: [{ label: "Make them dusk instead", send: "Change all of these images to dusk" }, { label: "What's in this frame?" }],
      memo: { flow: "edit", step: "ready" }
    };
  }
  return {
    text: "Done: " + es(n, "result") + " in the frame.",
    chips: [{ label: "What's in this frame?" }],
    memo: t
  };
}
function fG(i) {
  if (i.input.kind === "plan-ended") return pG(i, i.input.plan);
  const e = i.input.text.trim(), t = i.context, n = _8(i.history);
  if (!e) return Vo(t);
  if (/^(hi|hello|hey|hiya|yo|good (morning|afternoon|evening))\b[\s!.,]*$/i.test(e)) return eG(t);
  const s = /\bhow (should|do|can) i\b|\btips?\b|\badvice\b/i.test(e);
  if (n && n.flow === "rig" && (n.step === "pick" || n.step === "mode" || n.step === "prompt" || n.step === "proposed") && !s && !Fw(e)) {
    const o = Uw(i, e, n);
    if (o) return o;
  }
  if (n && n.flow === "edit" && n.step === "proposed" && !s) {
    const o = oG(i, e, n);
    if (o) return o;
  }
  if (/\bwhat('?s| is| are)?\s+(in|on)\s+(this|the)\s+frame\b|\bwhat do you see\b|\bdescribe (these|this|the)\b|\bwhat are these\b/i.test(e)) return tG(t);
  if (Fw(e) && !s) return sG(i, e, null);
  if (rG(e) && !s) {
    const o = ql(e, i.catalog, i.guidance);
    return o.length >= 2 && Uw(i, e, { flow: "rig", step: "pick", picks: [], n: o.length }) || Nw(i, e);
  }
  if (t.sessions.length && aG(e, n)) return lG(i, e, n);
  if (dG(e)) return cG(i, e);
  if (/\b(video|animate|animation|upscale|3d|mesh)\b/i.test(e)) {
    const o = Vo(t);
    return { ...o, text: "Video, upscale and 3D tools aren't part of this prototype's plans. " + o.text.replace("I can't do that one in this prototype. ", "") };
  }
  return uG(e) ? hG(i, e) : Vo(t);
}
const mG = (i) => new Promise((e) => window.setTimeout(e, i));
function C8(i) {
  const e = [], t = i.split(/(\s+)/);
  let n = "", s = 0;
  for (const o of t)
    n += o, /\S/.test(o) && s++, (s >= 2 || o.includes(`
`)) && (e.push(n), n = "", s = 0);
  return n && e.push(n), e;
}
class gG {
  constructor(e = {}) {
    Hu(this, "id", "simulated"), Hu(this, "label", "Simulated assistant"), Hu(this, "sleep"), Hu(this, "pace"), this.sleep = e.sleep || mG, this.pace = e.pace == null ? 1 : e.pace;
  }
  wait(e) {
    return this.pace > 0 ? this.sleep(e * this.pace) : Promise.resolve();
  }
  async *turn(e, t) {
    const n = fG(e);
    if (n) {
      yield { type: "status", text: n.status || "Thinking…" }, await this.wait(500 + Math.min(700, n.text.length * 1.5));
      for (const s of C8(n.text)) {
        if (t.aborted) return;
        yield { type: "text", delta: s }, await this.wait(16 + Math.random() * 22);
      }
      if (!t.aborted) {
        if (n.plan) {
          if (yield { type: "status", text: "Pricing the plan…" }, await this.wait(420), t.aborted) return;
          yield { type: "plan", plan: n.plan };
        }
        n.chips && n.chips.length && (yield { type: "chips", chips: n.chips }), n.memo && (yield { type: "memo", memo: n.memo });
      }
    }
  }
}
var bG = Object.defineProperty, vG = (i, e, t) => e in i ? bG(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Wu = (i, e, t) => vG(i, typeof e != "symbol" ? e + "" : e, t);
const I8 = 1, yG = 400, xG = 300 * 1024, Rv = 90, L1 = Rv * 24 * 3600 * 1e3, A8 = ["deletedAt", "hardDeleteAt", "deletedBy", "deletedByEmail", "shelvedAt"];
function Uc(i) {
  if (i === null || typeof i != "object") return JSON.stringify(i === void 0 ? null : i);
  if (Array.isArray(i)) return "[" + i.map(Uc).join(",") + "]";
  const e = i;
  return "{" + Object.keys(e).filter((n) => e[n] !== void 0).sort().map((n) => JSON.stringify(n) + ":" + Uc(e[n])).join(",") + "}";
}
function sf(i) {
  if (Array.isArray(i)) return i.map((e) => sf(e));
  if (i && typeof i == "object" && Object.getPrototypeOf(i) === Object.prototype) {
    const e = {};
    for (const [t, n] of Object.entries(i))
      n !== void 0 && (e[t] = sf(n));
    return e;
  }
  return i;
}
function zl(i) {
  return Uc(i).length;
}
function yp(i, e, t, n = {}) {
  const s = sf({ ...i, createdBy: i.createdBy || e, updatedBy: e, updatedAt: t, ...n });
  for (const o of A8) s[o] == null && delete s[o];
  return s;
}
function P8(i, e) {
  const t = { ...e };
  for (const n of A8) delete t[n];
  return { ...t, id: i };
}
function wG(i, e, t) {
  return { deletedAt: t, hardDeleteAt: t + L1, deletedBy: i, deletedByEmail: e || null, updatedBy: i, updatedAt: t };
}
function rg(i) {
  return !i || i.deletedAt ? "deleted" : i.shelvedAt ? "shelved" : "live";
}
function fc(i) {
  return !!(i && i.deletedAt);
}
function B1(i) {
  return !i || !i.deletedAt ? null : typeof i.hardDeleteAt == "number" ? i.hardDeleteAt : i.deletedAt + L1;
}
function E8(i) {
  let e = null;
  for (const t of Object.values(i)) {
    const n = B1(t);
    n != null && (e == null || n < e) && (e = n);
  }
  return e;
}
function kG(i, e, t) {
  let n = null;
  for (const [s, o] of e) {
    if (fc(s) || !fc(o)) continue;
    const r = B1(o);
    r != null && (n == null || r < n) && (n = r);
  }
  return n != null ? i != null && i < n ? i : n : i != null ? null : E8(t);
}
function _G(i, e, t) {
  const n = B1(e);
  return !e || n == null || n <= t ? null : {
    el: P8(i, e),
    deletedAt: e.deletedAt,
    hardDeleteAt: n,
    deletedBy: e.deletedBy || void 0,
    deletedByEmail: e.deletedByEmail || void 0
  };
}
class R8 {
  constructor(e = yG, t = xG) {
    Wu(this, "maxElements", e), Wu(this, "maxBytes", t), Wu(this, "home", /* @__PURE__ */ new Map()), Wu(this, "use", /* @__PURE__ */ new Map());
  }
  /** What a bucket holds now, from its document (a load, or anyone's write). */
  setBucket(e, t) {
    let n = 0, s = 0;
    for (const [o, r] of Object.entries(t))
      r && (s++, n += zl(r), this.home.has(o) || this.home.set(o, e));
    this.use.set(e, { count: s, bytes: n });
  }
  bucketOf(e) {
    return this.home.get(e);
  }
  buckets() {
    return Array.from(this.use.keys());
  }
  usage(e) {
    return this.use.get(e);
  }
  /** A home for a new element; `newBucketId` names a bucket when none has room. */
  place(e, t, n) {
    const s = this.home.get(e);
    if (s) return s;
    let o = null, r = -1;
    for (const [d, c] of this.use)
      c.count + 1 > this.maxElements || c.bytes + t > this.maxBytes || c.count > r && (o = d, r = c.count);
    const a = o || n(), l = this.use.get(a) || { count: 0, bytes: 0 };
    return this.use.set(a, { count: l.count + 1, bytes: l.bytes + t }), this.home.set(e, a), a;
  }
  /** An element's size changed (a long note, more thumbnails). */
  grow(e, t) {
    const n = this.home.get(e), s = n ? this.use.get(n) : void 0;
    s && (s.bytes = Math.max(0, s.bytes + t));
  }
}
function Gw(i, e, t, n = /* @__PURE__ */ new Set()) {
  const s = { upserted: [], removed: [], trash: !1 }, o = /* @__PURE__ */ new Set();
  for (const [r, a] of Object.entries(t)) {
    if (!a || (o.add(r), e.add(r), n.has(r))) continue;
    const l = i.get(r);
    if (l && Uc(l) === Uc(a)) continue;
    i.set(r, a), (fc(l) || fc(a)) && (s.trash = !0);
    const d = rg(l);
    rg(a) === "live" ? s.upserted.push(P8(r, a)) : d === "live" && s.removed.push(r);
  }
  for (const r of Array.from(e)) {
    if (o.has(r) || n.has(r)) continue;
    e.delete(r);
    const a = i.get(r);
    i.delete(r), fc(a) && (s.trash = !0), rg(a) === "live" && s.removed.push(r);
  }
  return s;
}
function qu(i, e) {
  if (!i) return e;
  if (e.kind === "patch") {
    if (i.kind === "put") {
      const t = { ...i.data };
      for (const [n, s] of Object.entries(e.fields))
        s === void 0 ? delete t[n] : t[n] = s;
      return { kind: "put", data: t };
    }
    return i.kind === "patch" ? { kind: "patch", fields: { ...i.fields, ...e.fields } } : i;
  }
  return e;
}
function ag(i, e) {
  if (e.kind === "put") return e.data;
  if (e.kind === "delete" || !i) return;
  const t = { ...i };
  for (const [n, s] of Object.entries(e.fields))
    s === void 0 ? delete t[n] : t[n] = s;
  return t;
}
const SG = 40 * 1024, zv = 2e3;
function MG(i, e = 0) {
  let t = i.slice(-60), n = e + (i.length - t.length), s = zl(t);
  for (; t.length > 1 && s > SG; )
    s -= zl(t[0]) + 1, t = t.slice(1), n++;
  return { messages: t, dropped: n };
}
function TG(i) {
  const e = String(i || "").replace(/\r\n/g, `
`).trim();
  return e.length > zv ? e.slice(0, zv - 1).trimEnd() + "…" : e;
}
function cd(i, e) {
  const t = i.messages || [];
  for (let n = t.length - 1; n >= 0; n--) {
    const s = t[n].plan;
    if (s && s.id === e) return { index: n, message: t[n], plan: s };
  }
  return null;
}
function Ku(i, e, t) {
  return i.map((n) => n.plan && n.plan.id === e ? { ...n, plan: { ...n.plan, ...t } } : n);
}
function CG(i) {
  return i.map((e) => e.plan && e.plan.status === "proposed" ? { ...e, plan: { ...e.plan, status: "cancelled", error: "Replaced by a newer plan" } } : e);
}
function IG(i) {
  const e = i.messages || [];
  for (let t = e.length - 1; t >= 0; t--) {
    const n = e[t], s = (n.text || "").replace(/\*\*/g, "").replace(/\s+/g, " ").trim();
    if (s) return { who: n.role === "agent" ? "Assistant" : n.author || "Someone", text: s };
    if (n.plan) return { who: "Assistant", text: "Plan: " + n.plan.title };
  }
  return null;
}
function AG(i) {
  const e = i.messages || [];
  for (let t = e.length - 1; t >= 0; t--) if (e[t].plan) return e[t].plan;
  return null;
}
function z8(i) {
  return (i.messages ? i.messages.length : 0) + (i.dropped || 0);
}
function $8(i) {
  return String(i || "").replace(/^([ \t]*)—[ \t]*/gm, "$1- ").replace(/[ \t]*—[ \t]*/g, ", ").replace(/,([ \t]*,)+/g, ",").replace(/\bcoming soon\b/gi, (e) => e[0] === "C" ? "In development" : "in development");
}
function PG(i, e) {
  const t = i ? { usd: i.usd, credits: i.credits, turns: i.turns, byModel: { ...i.byModel } } : { usd: 0, credits: 0, turns: 0, byModel: {} };
  t.usd += e.usd || 0, t.credits += e.credits || 0, t.turns += 1;
  const n = t.byModel[e.model] || { usd: 0, turns: 0 };
  return t.byModel[e.model] = { usd: n.usd + (e.usd || 0), turns: n.turns + 1 }, t;
}
function lg(i) {
  return i === 0 ? "$0" : "$" + (i < 0.1 ? i.toFixed(4) : i.toFixed(2));
}
var EG = Object.defineProperty, RG = (i, e, t) => e in i ? EG(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, vn = (i, e, t) => RG(i, typeof e != "symbol" ? e + "" : e, t);
const zG = 464, Ci = "simulated", $v = "unavailable";
class jw {
  constructor(e) {
    vn(this, "reason", e), vn(this, "id", $v), vn(this, "label", "Unavailable");
  }
  // eslint-disable-next-line require-yield
  async *turn() {
    yield { type: "text", delta: this.reason };
  }
}
const Hw = (i) => "rd-smart-frames-model:" + i;
class $G {
  constructor(e, t) {
    vn(this, "board", e), vn(this, "live", /* @__PURE__ */ Xt({})), vn(this, "brain", /* @__PURE__ */ qe(Ci)), vn(this, "agentStatus", /* @__PURE__ */ qe(null)), vn(this, "canSimulate"), vn(this, "showCosts"), vn(this, "endpoint"), vn(this, "asksAgent"), vn(this, "agentReady", null), vn(this, "usage", /* @__PURE__ */ Xt({})), vn(this, "driver"), vn(this, "simulated"), vn(this, "running", /* @__PURE__ */ new Map()), vn(this, "aborts", /* @__PURE__ */ new Map()), vn(this, "scope", r1(!0)), vn(this, "disposed", !1), vn(this, "open"), this.simulated = t || new gG(), this.canSimulate = !!t || T1, this.showCosts = !!e.user.isAdmin, this.endpoint = t ? null : e.agent ? { url: e.agent.url, token: e.agent.token, teamId: e.user.teamId || null } : null, this.asksAgent = !!this.endpoint, this.driver = this.canSimulate ? this.simulated : new jw("The chat isn't available here."), this.brain.value = this.canSimulate ? Ci : $v, this.endpoint && (this.agentReady = this.refreshAgent().catch(() => {
    })), this.open = this.scope.run(() => I(() => {
      const n = e.ui.chatOpen;
      if (!n) return null;
      e.rev(n).value;
      const s = e.store.get(n);
      return s && s.type === "chat" ? { ...s } : null;
    })), this.scope.run(() => {
      Ae(() => e.docRev.value, () => {
        const n = e.ui.chatOpen;
        n && !e.store.get(n) && (e.ui.chatOpen = null);
      }), Ae(() => e.ui.chatOpen, (n, s) => {
        n && (e.ui.boardHistory && (e.ui.boardHistory = !1), e.comments.ui.panelOpen && (e.comments.ui.panelOpen = !1), n !== s && this.onOpen(n));
      }), Ae(() => e.ui.boardHistory || e.comments.ui.panelOpen, (n) => {
        n && e.ui.chatOpen && (e.ui.chatOpen = null);
      }), Ae(() => e.ui.selection.slice(), (n) => {
        if (n.length !== 1 || e.ui.marquee) return;
        const s = e.store.get(n[0]);
        s && s.type === "chat" && e.ui.chatOpen !== s.id && (e.ui.chatOpen = s.id);
      }), Ae(() => e.loaded.value, (n) => {
        n && this.recover();
      }, { immediate: !0 });
    }), e.shiftPick = (n) => {
      const s = e.ui.chatOpen ? this.chat(e.ui.chatOpen) : null;
      return !s || this.frameOf(s) ? !1 : (this.togglePick(s.id, n), !0);
    };
  }
  setDriver(e) {
    this.driver = e;
  }
  get driverLabel() {
    return this.answerer().label;
  }
  /** A tour drives this board (src/onboarding): its scripted brain answers, and there's no model to pick. */
  get guided() {
    return !!(this.board.tour && this.board.tour.chat);
  }
  /** Who answers the next turn: the tour's brain while one drives the board, else this person's pick. */
  answerer() {
    const e = this.board.tour;
    return e && e.chat || this.driver;
  }
  /** Ask the agent again, and answer with this person's model (the default one, unless they picked another or the simulated brain). */
  async refreshAgent() {
    if (!this.endpoint) return;
    const e = await EU(this.endpoint);
    if (this.disposed) return;
    this.agentStatus.value = e;
    let t = null;
    try {
      t = window.localStorage.getItem(Hw(this.board.user.uid));
    } catch {
      t = null;
    }
    const n = e.ready && e.models || [];
    this.useBrain(t === Ci && this.canSimulate || !n.length ? Ci : (n.find((s) => s.id === t) || n[0]).id);
  }
  /** The models the agent offers (none until it's asked, or without a key). */
  get models() {
    const e = this.agentStatus.value;
    return e && e.ready && e.models || [];
  }
  useBrain(e) {
    const t = this.models.find((n) => n.id === e);
    if (t)
      this.driver = new UU({ model: t, boardId: this.board.meta.id, uid: this.board.user.uid, endpoint: this.endpoint || void 0 }), this.brain.value = t.id;
    else if (this.canSimulate)
      this.driver = this.simulated, this.brain.value = Ci;
    else {
      const n = this.agentStatus.value;
      this.driver = new jw(n && n.reason || "The chat isn't available right now. Try again in a little while."), this.brain.value = $v;
    }
  }
  /** This person's pick of brain (SIMULATED or a model's id), kept in this browser. */
  setBrain(e) {
    if (!(e === Ci && !this.canSimulate)) {
      try {
        window.localStorage.setItem(Hw(this.board.user.uid), e);
      } catch {
      }
      this.useBrain(e);
    }
  }
  // ------------------------------------------------------------ reading
  chat(e) {
    const t = this.board.store.get(e);
    return t && t.type === "chat" ? t : null;
  }
  /** The frame a chat's card sits in: its context. */
  frameOf(e) {
    const t = He(e), n = this.board.store.query(t).filter((s) => s.type === "frame");
    return vU(n, e);
  }
  /** What the chat sees now. Reactive: it follows the board, its results and its prompts. */
  contextOf(e) {
    this.board.docRev.value, this.board.results.rev.value, this.board.promptRev.value;
    const t = this.frameOf(e);
    return t ? Gu(Uu(this.board), t, e.id) : this.pickedContext(e);
  }
  // ------------------------------------------------------------ outside a frame (A3, Decision 5)
  /** What was picked for a chat outside a frame, still on the board: pictures, sessions and notes. */
  picksOf(e) {
    const t = [];
    for (const n of e.contextIds || []) {
      const s = this.board.store.get(n);
      s && (s.type === "image" || s.type === "tool" || s.type === "note") && t.push(s);
    }
    return t;
  }
  /** Its picks read as a frame's contents would be: a frame round them that isn't on the board. */
  pickedContext(e) {
    const t = this.picksOf(e);
    if (!t.length) return null;
    const n = uc(t.map((a) => He(a))), s = { id: "picks:" + e.id, type: "frame", title: "Picked from the board", x: n.x - In, y: n.y - In, w: n.w + In * 2, h: n.h + In * 2, z: 0 }, o = Uu(this.board), r = t.map((a) => a.id);
    return Gu({ ...o, childrenOf: (a) => a.id === s.id ? r : o.childrenOf(a), framesIn: (a) => a.id === s.id ? [] : o.framesIn(a) }, s, e.id);
  }
  /** In or out of a chat's picks (Shift-click on the board, or a chip's ×). Not an undo step: a conversation's context. */
  togglePick(e, t) {
    const n = this.chat(e), s = this.board.store.get(t);
    if (!n || !s) return;
    const o = n.contextIds || [], r = !o.includes(t), a = r ? o.concat([t]) : o.filter((l) => l !== t);
    this.board.store.update(e, { contextIds: a.length ? a : void 0 }, { history: !1 }), r && s.type === "image" && s.resultId && !this.board.results.get(s.resultId) && this.board.loadRecord(s.resultId).catch(() => {
    }), this.board.toast(r ? "Added to " + n.name + "'s context" : "Taken out of " + n.name + "'s context");
  }
  /**
   * A plan from a chat outside a frame runs in one (Decision 5): a frame is
   * made round the chat and its picks first, named for the chat, and the
   * picks are the frame's now. One Undo step; null when there's nothing picked.
   */
  frameForPicks(e) {
    const t = this.picksOf(e);
    if (!t.length) return null;
    const n = this.board, s = uc([He(e), ...t.map((r) => He(r))]), o = { id: St(), type: "frame", title: e.name, x: Math.round(s.x - In), y: Math.round(s.y - In - 24), w: Math.round(s.w + In * 2), h: Math.round(s.h + In * 2 + 24), z: 0, createdBy: n.user.uid };
    return o.z = n.store.nextZ(o, !0), n.store.batch("Frame the chat's work", () => {
      n.store.add([o]), n.store.update(e.id, { contextIds: void 0 });
    }), n.toast("Put " + e.name + " and its pictures in a frame, where its plan runs"), o;
  }
  /** The chats in a frame, in reading order. */
  chatsIn(e) {
    return this.board.childrenOf(e).map((t) => this.board.store.get(t)).filter((t) => !!t && t.type === "chat");
  }
  /** Every chat on the board, the most recently active first. */
  allChats() {
    this.board.docRev.value;
    const e = [];
    for (const n of this.board.store.all()) n.type === "chat" && e.push(n);
    const t = (n) => (n.messages && n.messages.length ? n.messages[n.messages.length - 1].at : 0) || n.updatedAt || 0;
    return e.sort((n, s) => t(s) - t(n));
  }
  busy(e) {
    return !!this.live[e];
  }
  /** A plan this page is running. */
  isRunningHere(e) {
    return this.running.has(e);
  }
  // ------------------------------------------------------------ chats in frames
  /** "Chat 1", "Chat 2"… per frame. */
  nextName(e) {
    let t = 0;
    for (const n of this.chatsIn(e)) {
      const s = /^Chat (\d+)$/.exec(n.name || "");
      s && (t = Math.max(t, Number(s[1])));
    }
    return "Chat " + (t + 1);
  }
  /** A new chat card in the frame's first clear spot (the frame grows when it has none), selected and open. */
  createChat(e) {
    const t = this.board, n = t.store.get(e);
    if (!n || n.type !== "frame") return null;
    const s = n, o = t.childrenOf(s).map((c) => t.store.get(c)).filter(Boolean).map((c) => He(c)), r = He(s), a = Av(r, o, Ri.w, Ri.h) || Pv(r, o), l = {
      id: St(),
      type: "chat",
      x: a.x,
      y: a.y,
      w: Ri.w,
      h: Ri.h,
      z: 0,
      name: this.nextName(s),
      messages: [],
      createdBy: t.user.uid
    };
    l.z = t.store.nextZ(l);
    const d = Ev(r, [He(l)]);
    return t.store.batch("Add chat", () => {
      d && t.store.update(s.id, { w: d.w, h: d.h }), t.store.add([l]);
    }), t.ui.selection = [l.id], t.ui.chatOpen = l.id, l;
  }
  /**
   * A chat about pictures picked on the board, outside any frame (A3: Nathan,
   * start from the pictures you have): beside them, with them as its context.
   */
  createChatFor(e) {
    const t = this.board, n = e.map((l) => t.store.get(l)).filter((l) => !!l && l.type === "image");
    if (!n.length) return null;
    const s = uc(n.map((l) => He(l))), o = t.freeSpot(Ri.w, Ri.h, { x: s.x + s.w + 48 + Ri.w / 2, y: s.y + Ri.h / 2 }, [], { outsideFrames: !0 }), r = this.allChats().length + 1, a = {
      id: St(),
      type: "chat",
      x: o.x,
      y: o.y,
      w: Ri.w,
      h: Ri.h,
      z: 0,
      name: "Chat " + r,
      messages: [],
      createdBy: t.user.uid,
      contextIds: n.map((l) => l.id)
    };
    a.z = t.store.nextZ(a), t.store.add([a]), t.ui.selection = [a.id], t.ui.chatOpen = a.id;
    for (const l of n) {
      const d = l.resultId;
      d && !t.results.get(d) && t.loadRecord(d).catch(() => {
      });
    }
    return a;
  }
  /** The selected pictures into a frameless chat's context, all at once (those not in it already). */
  addPicks(e, t) {
    const n = this.chat(e);
    if (!n || this.frameOf(n)) return 0;
    const s = new Set(n.contextIds || []), o = t.filter((r) => {
      var a;
      return !s.has(r) && ((a = this.board.store.get(r)) == null ? void 0 : a.type) === "image";
    });
    return o.length ? (this.board.store.update(e, { contextIds: (n.contextIds || []).concat(o) }, { history: !1 }), o.length) : 0;
  }
  close() {
    this.board.ui.chatOpen = null;
  }
  /**
   * A recommended tool, tried: a new session with it in the chat's frame (in
   * its first clear spot, the frame growing when it has none), selected so
   * its prompt opens. Nothing runs: the person writes the prompt.
   */
  addTool(e, t) {
    const n = this.board, s = this.chat(e), o = s ? this.frameOf(s) : null, r = this.catalogView(), a = r.get(t);
    if (!o || !a) return null;
    const l = r.kitFor(a, "generate"), d = He(o), c = n.childrenOf(o).map((p) => n.store.get(p)).filter(Boolean).map((p) => He(p)), h = Av(d, c, Rt.w, Rt.h) || Pv(d, c);
    let f = null;
    return n.store.batch("Add session", () => {
      f = n.addSession(l, a.model, n.uniqueSessionName(a.name), { x: h.x + Rt.w / 2, y: h.y + Rt.h / 2 }, { quiet: !0 }), n.store.update(f.id, { x: h.x, y: h.y });
      const p = Ev(d, [{ x: h.x, y: h.y, w: Rt.w, h: Rt.h }]);
      p && n.store.update(o.id, { x: p.x, y: p.y, w: p.w, h: p.h });
    }), f && (n.ui.selection = [f.id]), f;
  }
  /** Opening a chat: its frame comes into view beside the panel, and its images' records are read for the context. */
  onOpen(e) {
    const t = this.chat(e);
    if (!t) return;
    const n = this.frameOf(t);
    if (!n) {
      for (const s of this.picksOf(t)) {
        const o = s.type === "image" ? s.resultId : void 0;
        o && !this.board.results.get(o) && this.board.loadRecord(o).catch(() => {
        });
      }
      return;
    }
    this.showFrame(n, !1);
    for (const s of this.board.childrenOf(n)) {
      const o = this.board.store.get(s);
      o && o.type === "image" && o.resultId && !this.board.results.get(o.resultId) && this.board.loadRecord(o.resultId).catch(() => {
      });
    }
  }
  /** Where the board can be seen beside the chat panel, in the stage's pixels. */
  freeArea() {
    const e = this.board.view;
    return { x: 76, y: 16, w: Math.max(240, e.w - 76 - zG), h: Math.max(200, e.h - 16 - 110) };
  }
  /** Bring a frame into view beside the panel; `always`, even when it's already in view. */
  showFrame(e, t) {
    const n = this.board.engine;
    if (!n) return;
    const s = He(e), o = this.board.cam.value, r = this.freeArea(), a = s.x * o.zoom + o.x, l = s.y * o.zoom + o.y;
    if (a >= r.x && l >= r.y + 24 && a + s.w * o.zoom <= r.x + r.w && l + s.h * o.zoom <= r.y + r.h && s.w * o.zoom > r.w * 0.3 && !t) return;
    const c = rm(s, r.w, r.h, 48, 1);
    n.animateCamera({ zoom: tr(c.zoom), x: c.x + r.x, y: c.y + r.y + 12 }, 460);
  }
  // ------------------------------------------------------------ the transcript
  /** Change a chat's transcript (capped), outside the undo history: a conversation isn't undone. `also` patches the chat with it (its spend). */
  write(e, t, n = {}) {
    const s = this.chat(e);
    if (!s) return;
    const o = MG(t((s.messages || []).slice()), s.dropped || 0);
    this.board.store.update(e, { ...n, messages: o.messages, dropped: o.dropped || void 0 }, { history: !1 });
  }
  catalogView() {
    return new u8(this.board.catalog.value, !!this.board.user.isAdmin);
  }
  /** A person's message, and the agent's answer to it. */
  async send(e, t) {
    const n = TG(t), s = this.chat(e);
    if (!n || !s || this.busy(e)) return;
    const o = this.frameOf(s), r = o ? Gu(Uu(this.board), o, s.id) : this.pickedContext(s);
    if (!r) {
      this.board.toast("Shift-click pictures on the board to give this chat something to work with, or move it into a frame.");
      return;
    }
    const a = (s.messages || []).slice(), l = this.board.user;
    this.write(e, (d) => d.concat({
      id: St(),
      role: "user",
      author: l.name || l.initials || "You",
      authorId: l.uid,
      at: Date.now(),
      text: n,
      context: p8(r)
    })), await this.answer(e, { kind: "message", text: n, author: l.name || "You" }, a, r);
  }
  /** Ask the agent for its next message, stream it, and put it in the transcript. */
  async answer(e, t, n, s) {
    const o = this.catalogView(), r = { status: "Thinking…", text: "", plan: null, chips: [], picks: [], ideas: [] };
    this.live[e] = r;
    const a = new AbortController();
    this.aborts.set(e, a);
    let l, d, c = "";
    try {
      if (this.agentReady && !this.guided && await this.agentReady, this.disposed || a.signal.aborted) return;
      const v = this.chat(e), x = { input: t, context: s, history: n, dropped: v && v.dropped || 0, chatId: e, catalog: o, guidance: wU };
      for await (const w of this.answerer().turn(x, a.signal)) {
        if (this.disposed || a.signal.aborted) return;
        const S = this.live[e];
        if (!S) return;
        if (w.type === "status") S.status = w.text;
        else if (w.type === "text")
          S.status = null, S.text += w.delta;
        else if (w.type === "plan") {
          const M = Iv(w.plan, s, o);
          M.ok ? S.plan = M.plan : S.text += (S.text ? `

` : "") + "I couldn't put that plan together: " + M.error, S.status = null;
        } else if (w.type === "chips") S.chips = w.chips;
        else if (w.type === "picks")
          S.picks = w.picks.filter((M) => o.has(M.modelId)), S.status = null;
        else if (w.type === "ideas")
          S.ideas = w.ideas.map((M) => M.modelId && !o.has(M.modelId) ? { title: M.title, pitch: M.pitch } : M), S.status = null;
        else if (w.type === "usage") {
          this.usage[e] = w.usage;
          const M = w.usage;
          d = { model: M.model, usd: M.usd, credits: M.credits, input: M.input, cached: M.cached, output: M.output, ms: M.ms };
        } else w.type === "memo" && (l = w.memo);
      }
    } catch (v) {
      console.error("[board] the chat's answer failed", v), c = "Something went wrong while I was answering. Please try again.";
    } finally {
      this.aborts.delete(e);
    }
    const h = this.live[e];
    if (delete this.live[e], this.disposed || !h || !this.chat(e)) return;
    const f = $8(h.text.trim() || c).trim();
    if (!f && !h.plan && !h.picks.length && !h.ideas.length) return;
    const p = { id: St(), role: "agent", author: "Assistant", at: Date.now(), text: f };
    h.plan && (p.plan = h.plan), h.picks.length && (p.picks = h.picks), h.ideas.length && (p.ideas = h.ideas), h.chips.length && (p.chips = h.chips), l && (p.memo = l), d && (p.usage = d);
    const y = this.chat(e);
    this.write(e, (v) => (h.plan ? CG(v) : v).concat(p), d && y ? { spend: PG(y.spend, d) } : {});
  }
  /** Stop an answer on its way (the chat closed, the card was deleted). */
  stopAnswer(e) {
    const t = this.aborts.get(e);
    t && t.abort(), delete this.live[e];
  }
  // ------------------------------------------------------------ plans
  /** Run a proposed plan: one click, the board's own commands, progress in the transcript as it goes. */
  async runPlan(e, t) {
    const n = this.chat(e), s = n ? cd(n, t) : null;
    if (!n || !s || s.plan.status !== "proposed") return;
    const o = this.frameOf(n) || this.frameForPicks(n);
    if (!o) {
      this.board.toast("Move this chat back into a frame to run its plan.");
      return;
    }
    const r = this.board.user;
    this.write(e, (v) => Ku(v, t, { status: "running", ranBy: r.name || r.initials || "You", ranById: r.uid, ranAt: Date.now(), steps: [] }));
    const a = cd(this.chat(e), t).plan, l = new YU(lU(this.board), a, o.id, (v) => this.onProgress(e, t, o.id, v));
    this.running.set(t, { chatId: e, runner: l });
    let d;
    try {
      d = await l.run();
    } catch (v) {
      console.error("[board] the plan failed", v), d = { status: "failed", steps: [], added: {}, results: 0, error: "Something went wrong while it ran." };
    } finally {
      this.running.delete(t);
    }
    if (this.disposed || !this.chat(e)) return;
    const c = d.status === "cancelled" ? "cancelled" : d.status;
    this.write(e, (v) => Ku(v, t, {
      status: c,
      endedAt: Date.now(),
      results: d.results,
      ...d.steps.length ? { steps: d.steps } : {},
      ...d.error ? { error: d.error } : {},
      sessions: a.sessions.map((x) => this.withAdded(x, d.added[x.key]))
    }));
    const h = this.board.store.get(o.id);
    h && h.type === "frame" && this.showFrame(h, !1);
    const f = this.chat(e), p = f ? cd(f, t) : null, y = f ? this.frameOf(f) : null;
    f && p && y && c !== "cancelled" && await this.answer(e, { kind: "plan-ended", plan: p.plan }, (f.messages || []).slice(), Gu(Uu(this.board), y, f.id));
  }
  onProgress(e, t, n, s) {
    if (this.disposed) return;
    const o = this.chat(e), r = o ? cd(o, t) : null;
    if (!r) return;
    this.write(e, (l) => Ku(l, t, {
      steps: s.steps,
      results: s.results,
      sessions: r.plan.sessions.map((d) => this.withAdded(d, s.added[d.key]))
    }));
    const a = this.board.store.get(n);
    a && a.type === "frame" && this.board.ui.chatOpen === e && this.showFrame(a, !1);
  }
  /** A plan's session with the one it added, under the name the board gave it ("Night versions 2"). */
  withAdded(e, t) {
    if (!t) return e;
    const n = this.board.store.get(t);
    return { ...e, addedId: t, ...n && n.type === "tool" ? { name: n.name } : {} };
  }
  /** Cancel a plan not yet run; stop one running here before its next step. */
  cancelPlan(e, t) {
    const n = this.chat(e), s = n ? cd(n, t) : null;
    if (!s) return;
    if (s.plan.status === "proposed") {
      this.write(e, (r) => Ku(r, t, { status: "cancelled", endedAt: Date.now() }));
      return;
    }
    const o = this.running.get(t);
    o && o.runner.cancel();
  }
  /**
   * Plans this person started that were running when their page closed: a
   * runner lives in the page that started it, so they're stopped where they
   * were (what ran stays on the board).
   */
  recover() {
    const e = this.board.user.uid;
    for (const t of this.board.store.all()) {
      if (t.type !== "chat") continue;
      const n = t, s = (n.messages || []).filter((o) => o.plan && o.plan.status === "running" && o.plan.ranById === e && !this.running.has(o.plan.id));
      s.length && this.write(n.id, (o) => o.map((r) => s.some((a) => a.id === r.id) && r.plan ? { ...r, plan: { ...r.plan, status: "stopped", error: "The page running it closed before it finished", endedAt: Date.now() } } : r));
    }
  }
  dispose() {
    this.board.shiftPick && (this.board.shiftPick = null), this.disposed = !0;
    for (const e of this.running.values()) e.runner.cancel();
    this.running.clear();
    for (const e of this.aborts.values()) e.abort();
    this.aborts.clear(), this.scope.stop();
  }
}
const of = /* @__PURE__ */ new WeakMap();
function os(i) {
  let e = of.get(i);
  return e || (e = new $G(i), of.set(i, e)), e;
}
function DG(i) {
  const e = of.get(i);
  e && e.dispose(), of.delete(i);
}
const OG = ["aria-pressed"], LG = { class: "tip" }, BG = ["title"], FG = ["aria-label", "aria-pressed", "data-testid", "onClick"], NG = { class: "tip" }, UG = { class: "tip" }, GG = { style: { opacity: ".5", "margin-left": "6px" } }, jG = { class: "tip" }, HG = { class: "tip" }, VG = { style: { opacity: ".5", "margin-left": "6px" } }, WG = ["aria-disabled"], qG = { class: "tip" }, KG = {
  key: 0,
  class: "why"
}, YG = ["aria-disabled"], XG = { class: "tip" }, JG = {
  key: 0,
  class: "why"
}, ZG = ["aria-expanded"], QG = {
  key: 0,
  class: "tip"
}, ej = {
  key: 0,
  class: "bd-pm-sep",
  role: "separator"
}, tj = ["disabled", "data-testid", "onClick"], nj = { class: "bd-pm-ic is-plain is-bare" }, ij = { class: "lbl" }, sj = { key: 0 }, oj = /* @__PURE__ */ Pe({
  __name: "ContextToolbar",
  setup(i) {
    const { board: e } = Ze(), t = /* @__PURE__ */ K(null), n = /* @__PURE__ */ K(160), s = I(() => e.selectedEls.value), o = I(() => s.value.length > 1), r = I(() => s.value.filter((Me) => Me.type === "tool" || Me.type === "chat")), a = I(() => r.value.length > 0 && r.value.every((Me) => !!Me.collapsed)), l = I(() => s.value.length === 1 ? s.value[0] : null), d = I(() => !!l.value && l.value.type === "image"), c = I(() => !!l.value && l.value.type === "shape"), h = I(() => !!l.value && l.value.type === "frame");
    function f() {
      l.value && os(e).createChat(l.value.id);
    }
    const p = I(() => s.value.length > 0 && s.value.every((Me) => Me.type === "image" && !e.ownerFrame(Me)));
    function y() {
      os(e).createChatFor(s.value.map((Me) => Me.id));
    }
    const v = I(() => s.value.some((Me) => Me.type === "note")), x = I(() => {
      const Me = new Set(s.value.filter((ue) => ue.type === "note").map((ue) => ue.tint || "glass"));
      return Me.size === 1 ? Array.from(Me)[0] : null;
    }), w = I(() => {
      e.docRev.value;
      const Me = s.value.map((ue) => ue.id);
      return { forward: e.orderBlock(Me, "forward"), back: e.orderBlock(Me, "back") };
    }), S = I(() => s.value.length > 0 && !(s.value.length === 1 && s.value[0].type === "frame")), M = I(() => s.value.length === 1 && Ro(s.value[0])), _ = I(() => s.value.filter((Me) => Me.type === "frame")), T = I(() => _.value.length > 0 && _.value.every((Me) => Me.locked)), k = En(["mod", "shift", "L"]), P = I(() => c.value ? l.value.stroke || io.stroke : ""), A = I(() => s.value.length > 0 && !e.ui.marquee && !e.ui.dragging && !e.ui.studio), R = I(() => !!e.ui.editingNote);
    function D(Me) {
      R.value && Me.preventDefault();
    }
    const O = I(() => d.value && !l.value.video), F = I(() => d.value && e.isPinnedImage(l.value.src));
    function te() {
      const Me = l.value;
      e.togglePinImage(c8(Me, Me.resultId && e.results.get(Me.resultId) || null));
    }
    const ee = I(() => {
      if (!d.value || !e.promptLibrary.canSave) return !1;
      const Me = l.value.resultId;
      if (!Me) return !1;
      const ue = e.results.get(Me);
      return !ue || !!ue.prompt && ue.status === "done";
    }), me = I(() => {
      e.docRev.value;
      const Me = e.cam.value;
      let ue = 1 / 0, U = 1 / 0, q = -1 / 0, ie = -1 / 0;
      for (const de of s.value) {
        const pe = He(de);
        ue = Math.min(ue, pe.x), U = Math.min(U, pe.y), q = Math.max(q, pe.x + pe.w), ie = Math.max(ie, pe.y + pe.h);
      }
      return {
        cx: (ue + q) / 2 * Me.zoom + Me.x + e.view.left,
        top: U * Me.zoom + Me.y + e.view.top,
        bottom: ie * Me.zoom + Me.y + e.view.top
      };
    }), L = I(() => {
      const Me = n.value, ue = Math.min(Math.max(8, me.value.cx - Me / 2), window.innerWidth - Me - 8), U = me.value.top - 50, q = U < 62 ? Math.min(window.innerHeight - 60, me.value.bottom + 12) : U;
      return { left: ue, top: q };
    });
    Ae(() => [A.value, s.value.length, d.value, c.value, h.value, v.value, o.value, M.value, ee.value], () => {
      nt(() => {
        t.value && (n.value = t.value.offsetWidth);
      });
    }, { immediate: !0 });
    function N() {
      const Me = s.value[0];
      Me && (e.ui.selection = [], e.comments.draftOn(Me));
    }
    function X(Me) {
      e.ctxAction(Me);
    }
    const B = /* @__PURE__ */ K(null), se = I(() => A.value && e.ui.ctxMenu), V = /* @__PURE__ */ K({ w: 220, h: 0, barH: 42 }), Z = I(() => {
      const Me = [
        { id: "copy", icon: "Clipboard", label: "Copy", keys: En(["mod", "C"]) },
        { id: "duplicate", icon: "Copy", label: "Duplicate", keys: En(["mod", "D"]) }
      ];
      return l.value && l.value.type === "frame" && Me.push({ id: "rename", icon: "Pencil", label: "Rename" }), _.value.length && Me.push({ id: "lock", icon: T.value ? "LockOpen" : "Lock", label: T.value ? "Unlock" : "Lock", keys: k, sepBefore: !0 }), Me.push({ id: "delete", icon: "Trash2", label: "Delete", keys: En(["del"]), off: s.value.every((ue) => e.isHeld(ue)), danger: !0, sepBefore: !0 }), Me;
    }), Y = I(() => {
      const Me = V.value, ue = Math.min(Math.max(8, L.value.left + n.value - Me.w), window.innerWidth - Me.w - 8), U = L.value.top + Me.barH + 6, q = U + Me.h > window.innerHeight - 8 && L.value.top - 6 - Me.h >= 8;
      return { left: ue, top: q ? L.value.top - 6 - Me.h : U, up: q };
    });
    function H() {
      e.ui.ctxMenu = !1;
    }
    function re() {
      e.ui.ctxMenu = !e.ui.ctxMenu;
    }
    function le(Me) {
      const ue = Me.target;
      ue && (B.value && B.value.contains(ue) || t.value && t.value.contains(ue)) || H();
    }
    Ae(se, (Me) => {
      if (!Me) {
        window.removeEventListener("pointerdown", le, !0);
        return;
      }
      window.addEventListener("pointerdown", le, !0), nt(() => {
        const ue = B.value;
        ue && (V.value = { w: ue.offsetWidth, h: ue.offsetHeight, barH: t.value ? t.value.offsetHeight : 42 }, ue.focus({ preventScroll: !0 }));
      });
    }), Ae(() => e.ui.selection, H), Ae(A, (Me) => {
      Me || H();
    }), We(() => {
      window.removeEventListener("pointerdown", le, !0), H();
    });
    function he(Me) {
      Me.off || (H(), X(Me.id));
    }
    function Re() {
      return B.value ? Array.from(B.value.querySelectorAll(".bd-pm-row:not(:disabled)")) : [];
    }
    function Ne(Me) {
      const ue = Me.key;
      if (ue === "ArrowDown" || ue === "ArrowUp" || ue === "Home" || ue === "End") {
        Me.preventDefault(), Me.stopPropagation();
        const U = Re(), q = U.indexOf(document.activeElement), ie = ue === "Home" ? 0 : ue === "End" ? U.length - 1 : q < 0 ? ue === "ArrowDown" ? 0 : U.length - 1 : (q + (ue === "ArrowDown" ? 1 : -1) + U.length) % U.length;
        U[ie] && U[ie].focus();
      } else ue === "Escape" ? (Me.preventDefault(), Me.stopPropagation(), H()) : ue === "Tab" ? Me.preventDefault() : (ue === "Enter" || ue === " ") && Me.stopPropagation();
    }
    return (Me, ue) => (g(), b(j, null, [
      A.value ? (g(), b("div", {
        ref_key: "bar",
        ref: t,
        key: s.value.length + (d.value ? "i" : "") + (c.value ? "s" : "") + (h.value ? "f" : "") + (o.value ? "m" : "") + (M.value ? "l" : ""),
        class: "cv-ctxbar",
        "data-testid": "context-toolbar",
        style: ce({ left: L.value.left + "px", top: L.value.top + "px" }),
        onPointerdown: Se(D, ["stop"])
      }, [
        d.value ? (g(), b(j, { key: 0 }, [
          O.value ? (g(), b("button", {
            key: 0,
            class: "cv-ctx-info",
            title: "Edit in Studio view, in its session",
            "data-testid": "ctx-edit",
            onClick: ue[0] || (ue[0] = (U) => X("edit"))
          }, [
            C($, {
              name: "Wand2",
              size: 13
            }),
            ue[20] || (ue[20] = J(" Edit", -1))
          ])) : z("", !0),
          u("button", {
            class: "cv-ctx-info",
            title: "Its details, large",
            "data-testid": "ctx-details",
            onClick: ue[1] || (ue[1] = (U) => X("info"))
          }, [
            C($, {
              name: "Info",
              size: 13
            }),
            ue[21] || (ue[21] = J(" Details", -1))
          ]),
          u("button", {
            title: "Download",
            onClick: ue[2] || (ue[2] = (U) => X("download"))
          }, [
            C($, {
              name: "Download",
              size: 14
            }),
            ue[22] || (ue[22] = u("span", { class: "tip" }, "Download", -1))
          ]),
          u("button", {
            title: "Use as reference",
            onClick: ue[3] || (ue[3] = (U) => X("reference"))
          }, [
            C($, {
              name: "ImagePlus",
              size: 14
            }),
            ue[23] || (ue[23] = u("span", { class: "tip" }, "Use as reference", -1))
          ]),
          u("button", {
            class: G(["is-pin", { on: F.value }]),
            "aria-pressed": F.value,
            "data-testid": "ctx-pin",
            onClick: te
          }, [
            C($, {
              name: "Pin",
              size: 14
            }),
            u("span", LG, E(F.value ? m(Xn).unpin : m(Xn).pin), 1)
          ], 10, OG),
          ee.value ? (g(), b("button", {
            key: 1,
            title: "Save to the prompt library",
            "data-testid": "ctx-save-prompt",
            onClick: ue[4] || (ue[4] = (U) => X("save-prompt"))
          }, [
            C($, {
              name: "Bookmark",
              size: 14
            }),
            ue[24] || (ue[24] = u("span", { class: "tip" }, "Save to the prompt library", -1))
          ])) : z("", !0),
          ue[25] || (ue[25] = u("span", { class: "sep" }, null, -1))
        ], 64)) : z("", !0),
        h.value ? (g(), b(j, { key: 1 }, [
          u("button", {
            class: "cv-ctx-info is-chat",
            title: "Start a chat about everything in this frame",
            "data-testid": "ctx-chat",
            onClick: f
          }, [
            C($, {
              name: "MessageSquarePlus",
              size: 13
            }),
            ue[26] || (ue[26] = J(" Chat", -1))
          ]),
          ue[27] || (ue[27] = u("span", { class: "sep" }, null, -1))
        ], 64)) : p.value ? (g(), b(j, { key: 2 }, [
          u("button", {
            class: "cv-ctx-info is-chat",
            title: s.value.length === 1 ? "Start a chat about this picture" : "Start a chat about these " + s.value.length + " pictures",
            "data-testid": "ctx-chat-pics",
            onClick: y
          }, [
            C($, {
              name: "MessageSquarePlus",
              size: 13
            }),
            ue[28] || (ue[28] = J(" Chat", -1))
          ], 8, BG),
          ue[29] || (ue[29] = u("span", { class: "sep" }, null, -1))
        ], 64)) : z("", !0),
        c.value ? (g(), b(j, { key: 3 }, [
          u("button", {
            class: "cv-ctx-edit",
            title: "Stroke colour and width",
            onClick: ue[5] || (ue[5] = (U) => X("style"))
          }, [
            u("span", {
              class: "swatch",
              style: ce({ background: P.value })
            }, null, 4),
            ue[30] || (ue[30] = J(" Stroke ", -1))
          ]),
          ue[31] || (ue[31] = u("span", { class: "sep" }, null, -1))
        ], 64)) : z("", !0),
        o.value ? (g(), b(j, { key: 4 }, [
          u("button", {
            onClick: ue[6] || (ue[6] = (U) => X("align-left"))
          }, [
            C($, {
              name: "AlignStartVertical",
              size: 14
            }),
            ue[32] || (ue[32] = u("span", { class: "tip" }, "Align left", -1))
          ]),
          u("button", {
            onClick: ue[7] || (ue[7] = (U) => X("align-center"))
          }, [
            C($, {
              name: "AlignCenterHorizontal",
              size: 14
            }),
            ue[33] || (ue[33] = u("span", { class: "tip" }, "Align centres", -1))
          ]),
          u("button", {
            onClick: ue[8] || (ue[8] = (U) => X("align-top"))
          }, [
            C($, {
              name: "AlignStartHorizontal",
              size: 14
            }),
            ue[34] || (ue[34] = u("span", { class: "tip" }, "Align top", -1))
          ]),
          u("button", {
            onClick: ue[9] || (ue[9] = (U) => X("distribute-h"))
          }, [
            C($, {
              name: "AlignHorizontalDistributeCenter",
              size: 14
            }),
            ue[35] || (ue[35] = u("span", { class: "tip" }, "Distribute horizontally", -1))
          ]),
          ue[36] || (ue[36] = u("span", { class: "sep" }, null, -1))
        ], 64)) : z("", !0),
        v.value ? (g(), b(j, { key: 5 }, [
          (g(!0), b(j, null, be(m(GN), (U) => (g(), b("button", {
            key: U.id,
            class: G(["is-swatch", { on: x.value === U.id }]),
            "aria-label": U.label,
            "aria-pressed": x.value === U.id,
            "data-testid": "note-tint-" + U.id,
            onClick: (q) => X("tint-" + U.id)
          }, [
            u("span", {
              class: G(["swatch", "tint-" + U.id])
            }, null, 2),
            u("span", NG, E(U.label), 1)
          ], 10, FG))), 128)),
          ue[37] || (ue[37] = u("span", { class: "sep" }, null, -1))
        ], 64)) : z("", !0),
        M.value ? (g(), b("button", {
          key: 6,
          class: "cv-ctx-info is-locked",
          "aria-label": "Unlock frame",
          "data-testid": "ctx-unlock",
          onClick: ue[10] || (ue[10] = (U) => X("lock"))
        }, [
          C($, {
            name: "Lock",
            size: 13
          }),
          ue[39] || (ue[39] = J(" Locked", -1)),
          u("span", UG, [
            ue[38] || (ue[38] = J("Unlock", -1)),
            u("span", GG, E(m(k)), 1)
          ])
        ])) : (g(), b(j, { key: 7 }, [
          S.value ? (g(), b("button", {
            key: 0,
            onClick: ue[11] || (ue[11] = (U) => X("frame"))
          }, [
            C($, {
              name: "Frame",
              size: 14
            }),
            ue[40] || (ue[40] = u("span", { class: "tip" }, "Group into frame", -1))
          ])) : z("", !0),
          r.value.length ? (g(), b("button", {
            key: 1,
            "data-testid": "ctx-fold",
            onClick: ue[12] || (ue[12] = (U) => m(e).toggleCollapsed(r.value.map((q) => q.id)))
          }, [
            C($, {
              name: a.value ? "ChevronsUpDown" : "ChevronsDownUp",
              size: 14
            }, null, 8, ["name"]),
            u("span", jG, E(a.value ? "Expand" : "Collapse to the title"), 1)
          ])) : z("", !0),
          u("button", {
            onClick: ue[13] || (ue[13] = (U) => X("duplicate"))
          }, [
            C($, {
              name: "Copy",
              size: 14
            }),
            u("span", HG, [
              ue[41] || (ue[41] = J("Duplicate", -1)),
              u("span", VG, E(m(En)(["mod", "D"])), 1)
            ])
          ]),
          u("button", {
            class: G({ "is-rest": !!w.value.forward }),
            "aria-disabled": !!w.value.forward,
            "data-testid": "ctx-forward",
            onClick: ue[14] || (ue[14] = (U) => !w.value.forward && X("forward"))
          }, [
            C($, {
              name: "BringToFront",
              size: 14
            }),
            u("span", qG, [
              ue[42] || (ue[42] = J("Bring forward", -1)),
              w.value.forward ? (g(), b("span", KG, E(w.value.forward), 1)) : z("", !0)
            ])
          ], 10, WG),
          u("button", {
            class: G({ "is-rest": !!w.value.back }),
            "aria-disabled": !!w.value.back,
            "data-testid": "ctx-back",
            onClick: ue[15] || (ue[15] = (U) => !w.value.back && X("back"))
          }, [
            C($, {
              name: "SendToBack",
              size: 14
            }),
            u("span", XG, [
              ue[43] || (ue[43] = J("Send back", -1)),
              w.value.back ? (g(), b("span", JG, E(w.value.back), 1)) : z("", !0)
            ])
          ], 10, YG),
          ue[45] || (ue[45] = u("span", { class: "sep" }, null, -1)),
          u("button", {
            class: "danger",
            "data-testid": "ctx-delete",
            onClick: ue[16] || (ue[16] = (U) => X("delete"))
          }, [
            C($, {
              name: "Trash2",
              size: 14
            }),
            ue[44] || (ue[44] = u("span", { class: "tip" }, "Delete", -1))
          ])
        ], 64)),
        !o.value && m(e).comments.enabled ? (g(), b("button", {
          key: 8,
          "data-testid": "ctx-comment",
          onClick: N
        }, [
          C($, {
            name: "MessageCirclePlus",
            size: 14
          }),
          ue[46] || (ue[46] = u("span", { class: "tip" }, [
            J("Comment"),
            u("span", { style: { opacity: ".5", "margin-left": "6px" } }, "C")
          ], -1))
        ])) : z("", !0),
        u("button", {
          class: G(["is-more", { on: se.value }]),
          "aria-label": "More",
          "aria-haspopup": "menu",
          "aria-expanded": se.value,
          "data-testid": "ctx-more",
          onClick: re
        }, [
          C($, {
            name: "EllipsisVertical",
            size: 14
          }),
          se.value ? z("", !0) : (g(), b("span", QG, "More"))
        ], 10, ZG)
      ], 36)) : z("", !0),
      se.value ? (g(), b("div", {
        key: 1,
        ref_key: "menu",
        ref: B,
        class: "bd-pointmenu bd-ctxmenu",
        role: "menu",
        "aria-label": "More",
        tabindex: "-1",
        "data-testid": "ctx-menu",
        style: ce({ left: Y.value.left + "px", top: Y.value.top + "px", "--pm-origin": (Y.value.up ? "bottom" : "top") + " right" }),
        onKeydown: Ne,
        onPointerdown: ue[18] || (ue[18] = Se(() => {
        }, ["stop"])),
        onContextmenu: ue[19] || (ue[19] = Se(() => {
        }, ["prevent"]))
      }, [
        (g(!0), b(j, null, be(Z.value, (U) => (g(), b(j, {
          key: U.id
        }, [
          U.sepBefore ? (g(), b("div", ej)) : z("", !0),
          u("button", {
            class: G(["bd-pm-row", { "is-danger": U.danger }]),
            role: "menuitem",
            tabindex: "-1",
            disabled: U.off,
            "data-testid": "ctx-menu-" + U.id,
            onMouseenter: ue[17] || (ue[17] = (q) => q.currentTarget.focus({ preventScroll: !0 })),
            onClick: (q) => he(U)
          }, [
            u("span", nj, [
              C($, {
                name: U.icon,
                size: 14
              }, null, 8, ["name"])
            ]),
            u("span", ij, E(U.label), 1),
            U.keys ? (g(), b("kbd", sj, E(U.keys), 1)) : z("", !0)
          ], 42, tj)
        ], 64))), 128))
      ], 36)) : z("", !0)
    ], 64));
  }
});
var rj = Object.defineProperty, aj = (i, e, t) => e in i ? rj(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, dg = (i, e, t) => aj(i, typeof e != "symbol" ? e + "" : e, t);
const lj = 0.5;
function dj(i) {
  return i.type === "tool" || i.type === "chat";
}
function cj(i, e) {
  const t = Math.min(i.x + i.w, e.x + e.w) - Math.max(i.x, e.x), n = Math.min(i.y + i.h, e.y + e.h) - Math.max(i.y, e.y);
  return t <= 0 || n <= 0 ? 0 : t * n / Math.max(1, Math.min(i.w * i.h, e.w * e.h));
}
function uj(i) {
  const e = i.filter(dj), t = e.map((a, l) => l), n = (a) => {
    for (; t[a] !== a; ) a = t[a] = t[t[a]];
    return a;
  }, s = e.map(He);
  for (let a = 0; a < e.length; a++)
    for (let l = a + 1; l < e.length; l++)
      cj(s[a], s[l]) >= lj && (t[n(a)] = n(l));
  const o = /* @__PURE__ */ new Map();
  e.forEach((a, l) => {
    const d = n(l), c = o.get(d);
    c ? c.push(a) : o.set(d, [a]);
  });
  const r = /* @__PURE__ */ new Map();
  for (const a of o.values())
    a.length < 2 || (a.sort((l, d) => d.z - l.z), r.set(a[0].id, a.map((l) => l.id)));
  return r;
}
const hj = 450;
class pj {
  constructor(e) {
    dg(this, "board", e), dg(this, "s", /* @__PURE__ */ Xt({ top: null, ids: [] })), dg(this, "timer", 0);
  }
  /** Fan this stack out (a hover on its badge), or keep it open. */
  open(e, t) {
    clearTimeout(this.timer), this.s.top = e, this.s.ids = t.slice();
  }
  /** The pointer is on the fan or the badge: it stays. */
  keep() {
    clearTimeout(this.timer);
  }
  /** The pointer left: fold after a moment, unless it comes back. */
  leave() {
    clearTimeout(this.timer), this.timer = window.setTimeout(() => this.close(), hj);
  }
  close() {
    clearTimeout(this.timer), this.s.top = null, this.s.ids = [];
  }
  /** A card in the fan picked: it comes to the top of the stack, selected. */
  pick(e) {
    this.close(), this.board.bringToTop(e);
  }
}
const Vw = /* @__PURE__ */ new WeakMap();
function D8(i) {
  let e = Vw.get(i);
  return e || (e = new pj(i), Vw.set(i, e)), e;
}
const fj = ["title", "data-testid", "onClick"], mj = { class: "txt" }, gj = {
  key: 0,
  class: "on-top"
}, bj = 168, vj = 10, yj = /* @__PURE__ */ Pe({
  __name: "StackFan",
  setup(i) {
    const { board: e } = Ze(), t = D8(e), n = I(() => (e.docRev.value, t.s.ids.map((r) => e.store.get(r)).filter((r) => !!r && (r.type === "tool" || r.type === "chat")).map((r) => {
      const a = r.type === "tool" ? r : null;
      return {
        id: r.id,
        name: r.name || (a ? a.kind : "Chat"),
        icon: a ? a.icon || "Image" : "MessagesSquare",
        sub: a ? a.kind + (a.model ? " · " + a.model : "") : "Chat",
        thumb: a && a.thumbs && a.thumbs.length ? Bt(a.thumbs[0]) : ""
      };
    }))), s = I(() => {
      e.docRev.value;
      const r = t.s.top ? e.store.get(t.s.top) : null;
      if (!r || n.value.length < 2) return null;
      const a = e.cam.value, l = He(r), d = (l.x + l.w / 2) * a.zoom + a.x + e.view.left, c = l.y * a.zoom + a.y + e.view.top, h = (l.y + l.h) * a.zoom + a.y + e.view.top, f = n.value.length, p = f * bj + (f - 1) * vj, y = Math.min(Math.max(8, d - p / 2), window.innerWidth - p - 8), v = c - 164 < 62;
      return { left: y, top: v ? h + 22 : c - 150, width: p, below: v, origin: d - y + "px " + (v ? "0" : "100%") };
    });
    function o(r) {
      const a = n.value.length, l = a > 1 ? (r - (a - 1) / 2) / ((a - 1) / 2) : 0;
      return "rotate(" + (l * 4).toFixed(2) + "deg) translateY(" + (Math.abs(l) * 8).toFixed(1) + "px)";
    }
    return (r, a) => (g(), Ce(vt, { name: "cv-fan" }, {
      default: Xe(() => [
        s.value ? (g(), b("div", {
          key: 0,
          class: G(["cv-fan", { "is-below": s.value.below }]),
          style: ce({ left: s.value.left + "px", top: s.value.top + "px", width: s.value.width + "px", transformOrigin: s.value.origin }),
          role: "menu",
          "aria-label": "The cards in this stack",
          "data-testid": "stack-fan",
          onPointerdown: a[0] || (a[0] = Se(() => {
          }, ["stop"])),
          onMouseenter: a[1] || (a[1] = (l) => m(t).keep()),
          onMouseleave: a[2] || (a[2] = (l) => m(t).leave())
        }, [
          (g(!0), b(j, null, be(n.value, (l, d) => (g(), b("button", {
            key: l.id,
            type: "button",
            role: "menuitem",
            class: G(["cv-fan-card", { "is-top": d === 0 }]),
            style: ce({ "--tilt": o(d), "--i": d }),
            title: d === 0 ? l.name + " (on top)" : "Bring " + l.name + " to the top",
            "data-testid": "stack-fan-" + l.id,
            onClick: (c) => m(t).pick(l.id)
          }, [
            u("span", {
              class: "pic",
              style: ce(l.thumb ? { backgroundImage: 'url("' + l.thumb + '")' } : void 0)
            }, [
              l.thumb ? z("", !0) : (g(), Ce($, {
                key: 0,
                name: l.icon,
                size: 18
              }, null, 8, ["name"]))
            ], 4),
            u("span", mj, [
              u("b", null, E(l.name), 1),
              u("small", null, [
                C($, {
                  name: l.icon,
                  size: 10
                }, null, 8, ["name"]),
                J(E(l.sub), 1)
              ])
            ]),
            d === 0 ? (g(), b("span", gj, "On top")) : z("", !0)
          ], 14, fj))), 128))
        ], 38)) : z("", !0)
      ]),
      _: 1
    }));
  }
}), xj = { class: "hd" }, wj = { class: "sw-grid" }, kj = ["title", "onClick"], _j = { class: "wrow" }, Sj = ["value"], Mj = { class: "num" }, Tj = { class: "stp" }, Cj = { class: "prev" }, Ij = {
  width: "100%",
  height: "26",
  viewBox: "0 0 250 26",
  fill: "none",
  preserveAspectRatio: "none"
}, Aj = ["stroke", "stroke-width"], cg = 306, Ww = 168, qw = 62, Pj = /* @__PURE__ */ Pe({
  __name: "ShapeStyleBar",
  setup(i) {
    const e = ["#9968df", "#a3a7f5", "#c750ce", "#37d399", "#ffb347", "#ff5c7a", "#ffffff", "#8b93ad", "#0b0d14"], { board: t } = Ze(), n = I(() => {
      t.docRev.value;
      const l = t.ui.selection.length === 1 ? t.store.get(t.ui.selection[0]) : null;
      return l && l.type === "shape" ? { ...l } : null;
    }), s = I(() => n.value && n.value.sw != null ? n.value.sw : io.sw), o = I(() => n.value && n.value.stroke || io.stroke), r = I(() => {
      const l = n.value;
      if (!l) return { left: 0, top: 0 };
      const d = t.cam.value, c = He(l), h = (c.x + c.w / 2) * d.zoom + d.x + t.view.left, f = c.y * d.zoom + d.y + t.view.top, p = f + c.h * d.zoom, y = f - 50;
      let v;
      return y >= qw ? v = y - Ww - 8 >= qw ? y - Ww - 8 : p + 12 : v = p + 12 + 46, {
        left: Math.min(Math.max(8, h - cg / 2), window.innerWidth - cg - 8),
        top: v
      };
    });
    function a(l) {
      n.value && t.patchShape(n.value.id, { sw: Math.max(1, Math.min(32, Math.round(l))) });
    }
    return (l, d) => n.value && m(t).ui.styleOpen && !m(t).ui.dragging ? (g(), b("div", {
      key: 0,
      class: "v2-stylebar",
      "data-testid": "stroke-popover",
      style: ce({ left: r.value.left + "px", top: r.value.top + "px", width: cg + "px" }),
      onPointerdown: d[4] || (d[4] = Se(() => {
      }, ["stop"]))
    }, [
      u("div", xj, [
        d[5] || (d[5] = u("span", null, "Stroke", -1)),
        u("button", {
          class: "x",
          "aria-label": "Close",
          onClick: d[0] || (d[0] = (c) => m(t).ui.styleOpen = !1)
        }, [
          C($, {
            name: "X",
            size: 12
          })
        ])
      ]),
      u("div", wj, [
        (g(), b(j, null, be(e, (c) => u("button", {
          key: c,
          class: G(["sw", { on: c === o.value }]),
          title: c,
          onClick: (h) => m(t).patchShape(n.value.id, { stroke: c })
        }, [
          u("span", {
            style: ce({ background: c })
          }, null, 4)
        ], 10, kj)), 64))
      ]),
      u("div", _j, [
        d[6] || (d[6] = u("span", { class: "lb" }, "Width", -1)),
        u("input", {
          type: "range",
          min: "1",
          max: "32",
          step: "1",
          value: s.value,
          onInput: d[1] || (d[1] = (c) => a(+c.target.value))
        }, null, 40, Sj),
        u("div", Mj, [
          u("span", null, E(s.value), 1),
          u("div", Tj, [
            u("button", {
              "aria-label": "Thicker",
              onClick: d[2] || (d[2] = (c) => a(s.value + 1))
            }, [
              C($, {
                name: "ChevronUp",
                size: 10
              })
            ]),
            u("button", {
              "aria-label": "Thinner",
              onClick: d[3] || (d[3] = (c) => a(s.value - 1))
            }, [
              C($, {
                name: "ChevronDown",
                size: 10
              })
            ])
          ])
        ])
      ]),
      u("div", Cj, [
        (g(), b("svg", Ij, [
          u("path", {
            d: "M6 13 H244",
            stroke: o.value,
            "stroke-width": s.value,
            "stroke-linecap": "round"
          }, null, 8, Aj)
        ]))
      ])
    ], 36)) : z("", !0);
  }
}), Ej = /* @__PURE__ */ new Set(["fbx"]);
function Rj(i) {
  const e = /\.([a-z0-9]+)$/i.exec(i || ""), t = e ? e[1].toLowerCase() : "";
  return Ej.has(t) ? t : null;
}
const Vt = 768, O8 = [
  "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
  "m3.3 7 8.7 5 8.7-5",
  "M12 22V12"
], rf = 'Inter, system-ui, -apple-system, "Segoe UI", sans-serif', L8 = "#1d1730", B8 = "#0b0d15", F8 = "#b79cf0", N8 = "#ece8f6", U8 = "#8f8aa6", Dv = /* @__PURE__ */ new Map();
function G8(i) {
  return ["3D model, ." + i, "No preview: download to open it"];
}
function zj(i) {
  const [e, t] = G8(i), n = 8, s = (Vt - 24 * n) / 2, o = `<svg xmlns="http://www.w3.org/2000/svg" width="${Vt}" height="${Vt}" viewBox="0 0 ${Vt} ${Vt}"><defs><radialGradient id="g" cx="50%" cy="40%" r="70%"><stop offset="0" stop-color="${L8}"/><stop offset="1" stop-color="${B8}"/></radialGradient></defs><rect width="${Vt}" height="${Vt}" fill="url(#g)"/><g transform="translate(${s} ${s - 70}) scale(${n})" fill="none" stroke="${F8}" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">${O8.map((r) => `<path d="${r}"/>`).join("")}</g><text x="${Vt / 2}" y="${Vt / 2 + 150}" text-anchor="middle" font-family='${rf}' font-size="66" font-weight="600" fill="${N8}">${e}</text><text x="${Vt / 2}" y="${Vt / 2 + 214}" text-anchor="middle" font-family='${rf}' font-size="38" fill="${U8}">${t}</text></svg>`;
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(o);
}
function $j(i) {
  if (typeof document == "undefined" || typeof Path2D == "undefined") return null;
  const e = document.createElement("canvas");
  e.width = Vt, e.height = Vt;
  const t = e.getContext("2d");
  if (!t) return null;
  const n = t.createRadialGradient(Vt / 2, Vt * 0.4, 0, Vt / 2, Vt * 0.4, Vt * 0.7);
  n.addColorStop(0, L8), n.addColorStop(1, B8), t.fillStyle = n, t.fillRect(0, 0, Vt, Vt);
  const s = 8, o = (Vt - 24 * s) / 2;
  t.save(), t.translate(o, o - 70), t.scale(s, s), t.strokeStyle = F8, t.lineWidth = 1.4, t.lineCap = "round", t.lineJoin = "round";
  for (const l of O8) t.stroke(new Path2D(l));
  t.restore();
  const [r, a] = G8(i);
  t.textAlign = "center", t.fillStyle = N8, t.font = "600 66px " + rf, t.fillText(r, Vt / 2, Vt / 2 + 150), t.fillStyle = U8, t.font = "38px " + rf, t.fillText(a, Vt / 2, Vt / 2 + 214);
  try {
    return e.toDataURL("image/png");
  } catch {
    return null;
  }
}
function Dj(i, e = "") {
  let t = Dv.get(i);
  return t || (t = $j(i) || zj(i), Dv.set(i, t)), e ? t + "#" + encodeURIComponent(e) : t;
}
function af(i) {
  if (!i) return !1;
  const e = i.split("#")[0];
  for (const t of Dv.values()) if (t === e) return !0;
  return !1;
}
const Kw = Vt, Oj = { class: "v2-hist-head" }, Lj = { class: "n" }, Bj = { class: "t" }, Fj = {
  key: 0,
  class: "v2-hist-empty"
}, Nj = ["data-testid", "onMouseenter"], Uj = ["title", "onPointerdown"], Gj = {
  key: 1,
  class: "v2-hist-withheld"
}, jj = {
  key: 0,
  class: "v2-hist-time"
}, Hj = {
  key: 1,
  class: "v2-hist-vid"
}, Vj = {
  key: 2,
  class: "v2-hist-fav"
}, Wj = ["title"], qj = {
  key: 1,
  class: "v2-hist-more"
}, Kj = ["src"], Yj = { class: "cap" }, Xj = { class: "n" }, Jj = {
  key: 0,
  class: "m"
}, Zj = { class: "v2-hist-acts" }, Qj = ["aria-pressed"], eH = { class: "tip" }, Yw = 300, Yu = 8, tH = /* @__PURE__ */ Pe({
  __name: "ToolHistory",
  props: {
    tool: {}
  },
  setup(i) {
    const e = i, { board: t, input: n } = Ze(), s = dr(), o = /* @__PURE__ */ K(!1);
    async function r() {
      if (!(o.value || t.historyDone(e.tool.id))) {
        o.value = !0;
        try {
          await t.loadHistory(e.tool.id);
        } finally {
          o.value = !1;
        }
      }
    }
    Ae(() => e.tool.id, () => {
      r();
    }, { immediate: !0 });
    function a(L) {
      const N = L.target;
      c.value = N.scrollTop, P(), N.scrollHeight - N.scrollTop - N.clientHeight < 400 && r();
    }
    const l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(null), c = /* @__PURE__ */ K(0), h = /* @__PURE__ */ K(600), f = /* @__PURE__ */ K(274), p = /* @__PURE__ */ K(null);
    let y = 0;
    const v = I(() => (t.results.rev.value, t.results.list(e.tool.id))), x = I(() => new Set(v.value.slice(0, t.ui.newThumbs[e.tool.id] || 0).map((L) => L.id))), w = I(() => {
      const L = (f.value - Yu) / 2;
      return { w: L, h: Math.round(L * 3 / 4) };
    }), S = I(() => Math.ceil(v.value.length / 2) * (w.value.h + Yu)), M = I(() => {
      const L = w.value.h + Yu, N = Math.max(0, Math.floor(c.value / L) - 2), X = Math.ceil((c.value + h.value) / L) + 2, B = [];
      for (let se = N; se <= X; se++)
        for (let V = 0; V < 2; V++) {
          const Z = se * 2 + V, Y = v.value[Z];
          Y && B.push({ it: Y, i: Z, x: V * (w.value.w + Yu), y: se * L });
        }
      return B;
    });
    let _ = null;
    ot(() => {
      d.value && (_ = new ResizeObserver(() => {
        d.value && (h.value = d.value.clientHeight, f.value = d.value.clientWidth - 2);
      }), _.observe(d.value));
    }), We(() => {
      _ && _.disconnect(), clearTimeout(y);
    });
    const T = () => clearTimeout(y), k = () => {
      clearTimeout(y), y = window.setTimeout(() => {
        p.value = null;
      }, 180);
    }, P = () => {
      clearTimeout(y), p.value = null;
    };
    function A(L, N) {
      if (T(), L.status !== "done") return;
      const X = l.value;
      if (!X) return;
      const B = N.currentTarget.getBoundingClientRect(), se = X.getBoundingClientRect(), V = Math.round(Yw * ((L.h || 3) / (L.w || 4))), Z = Math.min(Math.max(8 - se.top, B.top - se.top + B.height / 2 - V / 2), window.innerHeight - 8 - V - se.top);
      p.value = { id: L.id, it: L, top: Z, h: V };
    }
    function R(L) {
      if (L.status !== "done") return;
      const N = t.placedFor(L.id);
      t.ui.infoSession = e.tool.id, t.ui.infoAt = N ? N.id : "result:" + L.id;
    }
    function D(L, N) {
      if (P(), L.status !== "done") return;
      if (t.ui.eyedropper) {
        N.preventDefault(), t.eyedrop(L.url, L.asset || null, !!L.video);
        return;
      }
      const X = Math.min(360, Math.max(200, L.w || 300)), B = Math.round(X * (L.h || 3) / (L.w || 4));
      n.dragResultOut({ url: L.url, w: X, h: B, result: L, sessionId: e.tool.id }, N, {
        keepSelection: e.tool.id,
        onClick: () => R(L)
      });
    }
    function O(L) {
      P();
      const N = t.placedFor(L.id);
      N && (t.ui.selection = [N.id], t.jumpTo(N.x + N.w / 2, N.y + N.h / 2, Math.max(t.cam.value.zoom, 0.6)));
    }
    function F(L) {
      P(), t.placeResult(L);
    }
    function te(L) {
      t.setPrompt(e.tool.id, { prompt: L.prompt || "" }), t.toast("Prompt loaded into " + e.tool.name);
    }
    function ee(L) {
      t.addReference(e.tool.id, L.url, L.asset || null);
    }
    function me(L) {
      R(L), t.ui.infoSave = !0;
    }
    return (L, N) => (g(), b("div", {
      ref_key: "panel",
      ref: l,
      class: "v2-hist",
      "data-testid": "results-gallery",
      onPointerdown: N[11] || (N[11] = Se(() => {
      }, ["stop"])),
      onWheel: N[12] || (N[12] = Se(() => {
      }, ["stop"])),
      onMouseleave: k
    }, [
      u("div", Oj, [
        u("span", Lj, E(v.value.length), 1),
        u("span", Bj, E(i.tool.name), 1),
        u("button", {
          class: "v2-hist-close",
          title: "Hide the gallery",
          onClick: N[0] || (N[0] = (X) => m(t).ui.histOpen = !1)
        }, [
          C($, {
            name: "PanelRightClose",
            size: 13
          })
        ])
      ]),
      N[22] || (N[22] = u("div", { class: "v2-hist-hint" }, "Click for the full record · drag onto the board", -1)),
      u("div", {
        ref_key: "grid",
        ref: d,
        class: "v2-hist-grid",
        onScroll: a
      }, [
        !v.value.length && !o.value ? (g(), b("div", Fj, "Results from this session will collect here. Write a prompt and Run.")) : z("", !0),
        u("div", {
          style: ce({ height: S.value + "px", position: "relative" })
        }, [
          (g(!0), b(j, null, be(M.value, (X) => (g(), b("div", {
            key: X.it.id,
            class: G(["v2-hist-item", {
              "is-on": p.value && p.value.id === X.it.id,
              "is-new": x.value.has(X.it.id),
              "is-pending": X.it.status === "pending",
              "is-failed": X.it.status === "failed",
              "is-withheld": X.it.status === "moderated"
            }]),
            style: ce({ left: X.x + "px", top: X.y + "px", width: w.value.w + "px", height: w.value.h + "px" }),
            "data-testid": "gallery-item-" + X.it.status,
            onMouseenter: (B) => A(X.it, B)
          }, [
            u("button", {
              class: "shot",
              title: X.it.status === "moderated" ? "Withheld by the safety check" : X.it.label,
              onPointerdown: (B) => D(X.it, B)
            }, [
              u("span", {
                class: "art",
                style: ce(X.it.url && X.it.status === "done" ? { backgroundImage: 'url("' + m(Bt)(X.it.url) + '")' } : void 0)
              }, [
                X.it.status === "failed" ? (g(), Ce($, {
                  key: 0,
                  name: "AlertCircle",
                  size: 16
                })) : X.it.status === "moderated" ? (g(), b("span", Gj, [
                  C($, {
                    name: "EyeOff",
                    size: 14
                  }),
                  N[13] || (N[13] = J("Withheld", -1))
                ])) : z("", !0)
              ], 4),
              X.it.status === "pending" && X.it.startedAt ? (g(), b("span", jj, E(m(C1)(m(s) - X.it.startedAt)), 1)) : z("", !0),
              X.it.video && X.it.status === "done" ? (g(), b("span", Hj, [
                C($, {
                  name: "Play",
                  size: 8
                }),
                J(" " + E(X.it.dur || "0:05"), 1)
              ])) : z("", !0),
              m(t).isFav(X.it) ? (g(), b("span", Vj, [
                C($, {
                  name: "Heart",
                  size: 8
                })
              ])) : z("", !0),
              X.it.status === "done" && m(t).isPinnedImage(X.it.url) ? (g(), b("span", {
                key: 3,
                class: "v2-hist-pin",
                title: m(Xn).badge
              }, [
                C($, {
                  name: "Pin",
                  size: 9
                })
              ], 8, Wj)) : z("", !0)
            ], 40, Uj)
          ], 46, Nj))), 128))
        ], 4),
        o.value ? (g(), b("div", qj, [...N[14] || (N[14] = [
          u("span", { class: "bd-spinner is-sm" }, null, -1)
        ])])) : z("", !0)
      ], 544),
      p.value ? (g(), b("div", {
        key: 0,
        class: "v2-hist-pop",
        style: ce({ top: p.value.top + "px", width: Yw + "px", height: p.value.h + "px" }),
        onMouseenter: T,
        onMouseleave: k
      }, [
        u("button", {
          class: "art",
          title: "Open the full record",
          style: ce({ backgroundImage: 'url("' + p.value.it.url + '")' }),
          onClick: N[2] || (N[2] = (X) => R(p.value.it))
        }, [
          p.value.it.video && p.value.it.videoSrc ? (g(), b("video", {
            key: p.value.it.videoSrc,
            class: "art-vid",
            src: p.value.it.videoSrc,
            "data-testid": "gallery-video",
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            preload: "auto",
            disablepictureinpicture: "",
            onPlaying: N[1] || (N[1] = (X) => X.target.classList.add("is-shown"))
          }, null, 40, Kj)) : z("", !0)
        ], 4),
        u("span", Yj, [
          u("span", Xj, E(p.value.it.label || p.value.it.prompt), 1),
          p.value.it.video ? (g(), b("span", Jj, [
            C($, {
              name: "Play",
              size: 10
            }),
            J(" " + E(p.value.it.dur || "0:05"), 1)
          ])) : z("", !0)
        ]),
        u("span", Zj, [
          u("button", {
            class: G(["find is-pin", { on: m(t).isPinnedImage(p.value.it.url) }]),
            "aria-pressed": m(t).isPinnedImage(p.value.it.url),
            "data-testid": "gallery-pin",
            onClick: N[3] || (N[3] = Se((X) => m(t).togglePinImage(m(lm)(p.value.it)), ["stop"]))
          }, [
            C($, {
              name: "Pin",
              size: 13
            }),
            u("span", eH, E(m(t).isPinnedImage(p.value.it.url) ? m(Xn).unpin : m(Xn).pin), 1)
          ], 10, Qj),
          m(af)(p.value.it.url) ? z("", !0) : (g(), b("button", {
            key: 0,
            class: "find",
            "data-testid": "gallery-use-ref",
            onClick: N[4] || (N[4] = Se((X) => ee(p.value.it), ["stop"]))
          }, [
            C($, {
              name: "ImagePlus",
              size: 13
            }),
            N[15] || (N[15] = u("span", { class: "tip" }, "Use as reference", -1))
          ])),
          u("button", {
            class: "find",
            "data-testid": "gallery-use-prompt",
            onClick: N[5] || (N[5] = Se((X) => te(p.value.it), ["stop"]))
          }, [
            C($, {
              name: "Type",
              size: 13
            }),
            N[16] || (N[16] = u("span", { class: "tip" }, "Use the prompt", -1))
          ]),
          m(t).placedFor(p.value.it.id) ? (g(), b("button", {
            key: 1,
            class: "find",
            "data-testid": "gallery-find",
            onClick: N[6] || (N[6] = Se((X) => O(p.value.it), ["stop"]))
          }, [
            C($, {
              name: "LocateFixed",
              size: 13
            }),
            N[17] || (N[17] = u("span", { class: "tip" }, "Find it on the board", -1))
          ])) : p.value.it.status === "done" ? (g(), b("button", {
            key: 2,
            class: "find",
            "data-testid": "gallery-place",
            onClick: N[7] || (N[7] = Se((X) => F(p.value.it), ["stop"]))
          }, [
            C($, {
              name: "ArrowDownToLine",
              size: 13
            }),
            N[18] || (N[18] = u("span", { class: "tip" }, "Place on the board", -1))
          ])) : z("", !0),
          p.value.it.status === "done" ? (g(), b("button", {
            key: 3,
            class: "find",
            "data-testid": "gallery-details",
            onClick: N[8] || (N[8] = Se((X) => R(p.value.it), ["stop"]))
          }, [
            C($, {
              name: "Info",
              size: 13
            }),
            N[19] || (N[19] = u("span", { class: "tip" }, "Details", -1))
          ])) : z("", !0),
          m(t).promptLibrary.canSave && p.value.it.prompt ? (g(), b("button", {
            key: 4,
            class: "find",
            "data-testid": "gallery-save-prompt",
            onClick: N[9] || (N[9] = Se((X) => me(p.value.it), ["stop"]))
          }, [
            C($, {
              name: "Bookmark",
              size: 13
            }),
            N[20] || (N[20] = u("span", { class: "tip" }, "Save to the prompt library", -1))
          ])) : z("", !0),
          p.value.it.kind === "3d" && p.value.it.download ? (g(), b("button", {
            key: 5,
            class: "find",
            "data-testid": "gallery-download",
            onClick: N[10] || (N[10] = Se((X) => m(t).downloadResult(p.value.it), ["stop"]))
          }, [
            C($, {
              name: "Download",
              size: 13
            }),
            N[21] || (N[21] = u("span", { class: "tip" }, "Download the 3D model", -1))
          ])) : z("", !0)
        ])
      ], 36)) : z("", !0)
    ], 544));
  }
});
var nH = Object.defineProperty, iH = (i, e, t) => e in i ? nH(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, go = (i, e, t) => iH(i, typeof e != "symbol" ? e + "" : e, t);
const Gr = 1, mc = 5, Ov = 2;
function F1(i) {
  if (i.allSessions()) return "All sessions";
  const e = i.pickedSessions();
  if (e.length > 1) return e.length + " sessions";
  const t = i.historySessions.value.find((n) => n.id === e[0]);
  return t ? t.name : "All sessions";
}
const j8 = (i) => "rd-board-studio-history:" + i;
function H8(i) {
  try {
    const e = Number(JSON.parse(localStorage.getItem(j8(i)) || "{}").columns);
    return e >= Gr && e <= mc ? Math.round(e) : Ov;
  } catch {
    return Ov;
  }
}
function V8(i, e) {
  try {
    localStorage.setItem(j8(i), JSON.stringify({ columns: e }));
  } catch {
  }
}
function W8(i) {
  const e = Math.round(i);
  return Number.isFinite(e) ? Math.max(Gr, Math.min(mc, e)) : Ov;
}
function Xw(i) {
  return i.doneAt || i.createdAt;
}
function sH(i) {
  return i.status !== "moderated" && !(i.status === "done" && !i.url);
}
class oH {
  constructor(e) {
    go(this, "board", e), go(this, "s"), go(this, "boardItems"), go(this, "historySessions"), go(this, "shown"), go(this, "unread"), go(this, "seenAt"), go(this, "scope", r1(!0)), this.s = /* @__PURE__ */ Xt({ sessions: [], columns: H8(e.user.uid), pinned: !1 }), this.seenAt = /* @__PURE__ */ K(e.historySeenAt != null ? e.historySeenAt : Date.now());
    const t = this.scope.run(() => {
      const n = I(() => {
        e.docRev.value;
        const l = [];
        for (const d of e.store.all()) d.type === "tool" && l.push(d.id);
        return l.join(" ");
      }), s = I(() => {
        e.results.rev.value;
        const l = [];
        for (const d of n.value ? n.value.split(" ") : [])
          for (const c of e.results.list(d)) sH(c) && l.push(c);
        return l.sort((d, c) => c.createdAt - d.createdAt);
      }), o = I(() => {
        const l = /* @__PURE__ */ new Map();
        for (const d of s.value) l.set(d.sessionId, (l.get(d.sessionId) || 0) + 1);
        return e.recentTools().filter((d) => l.has(d.id) || e.isPinned(d.id)).map((d) => ({ id: d.id, name: d.name, icon: d.icon || "Image", count: l.get(d.id) || 0, here: !1, pinned: e.isPinned(d.id) }));
      }), r = I(() => {
        const l = this.pickedSessions();
        return l.length ? s.value.filter((d) => l.includes(d.sessionId)) : s.value;
      }), a = I(() => {
        const l = this.seenAt.value;
        let d = 0;
        for (const c of s.value) c.status === "done" && Xw(c) > l && d++;
        return d;
      });
      return Ae([() => e.ui.boardHistory, s], ([l]) => {
        l && this.markSeen();
      }, { immediate: !0 }), { boardItems: s, historySessions: o, shown: r, unread: a };
    });
    this.boardItems = t.boardItems, this.historySessions = t.historySessions, this.shown = t.shown, this.unread = t.unread;
  }
  /** Everything in history seen: the newest finish, or now, whichever is later. */
  markSeen() {
    let e = Math.max(this.seenAt.value, Date.now());
    for (const t of this.boardItems.value) t.status === "done" && (e = Math.max(e, Xw(t)));
    this.seenAt.value = e, this.board.markHistorySeen(e);
  }
  pickedSessions() {
    const e = this.historySessions.value;
    return this.s.sessions.filter((t) => e.some((n) => n.id === t));
  }
  allSessions() {
    const e = this.pickedSessions();
    return !e.length || e.length === this.historySessions.value.length;
  }
  toggleSession(e) {
    const t = this.pickedSessions();
    this.s.sessions = t.includes(e) ? t.filter((n) => n !== e) : [...t, e];
  }
  onlySession(e) {
    this.s.sessions = e ? [e] : [];
  }
  /** History's columns, remembered for the next visit and the next board (the Studios view's too). */
  setColumns(e) {
    const t = W8(e);
    t !== this.s.columns && (this.s.columns = t, V8(this.board.user.uid, t));
  }
  /** The session a result came from, while it's on the board. */
  sessionOf(e) {
    const t = this.board.store.get(e.sessionId);
    return t && t.type === "tool" ? t : null;
  }
  dispose() {
    this.scope.stop();
  }
}
const Jw = /* @__PURE__ */ new WeakMap();
function q8(i) {
  let e = Jw.get(i);
  return e || (e = new oH(i), Jw.set(i, e)), e;
}
const rH = ["aria-pressed"], aH = {
  key: 0,
  class: "badge is-unread",
  "data-testid": "comments-badge"
}, lH = {
  key: 1,
  class: "cm-rail-dot",
  "data-testid": "comments-elsewhere-dot"
}, dH = { class: "tip" }, cH = ["aria-pressed"], uH = {
  key: 0,
  class: "badge is-unread",
  "data-testid": "board-history-badge"
}, hH = { class: "tip" }, pH = ["aria-pressed"], fH = {
  key: 0,
  class: "badge"
}, mH = { class: "tip" }, gH = /* @__PURE__ */ Pe({
  __name: "SideRail",
  setup(i) {
    const { board: e } = Ze(), t = q8(e), n = I(() => t.unread.value), s = e.comments, o = I(() => s.unreadCount.value), r = I(() => s.elsewhereUnread.value);
    function a() {
      s.ui.panelOpen = !s.ui.panelOpen;
    }
    const l = os(e), d = I(() => l.allChats());
    function c() {
      if (e.ui.chatOpen) {
        e.ui.chatOpen = null;
        return;
      }
      const h = d.value[0];
      h && (e.ui.selection = [h.id], e.ui.chatOpen = h.id);
    }
    return (h, f) => (g(), b("nav", {
      class: "bd-siderail",
      "aria-label": "Board panels",
      "data-testid": "side-rail",
      onPointerdown: f[1] || (f[1] = Se(() => {
      }, ["stop"]))
    }, [
      m(s).enabled ? (g(), b("button", {
        key: 0,
        class: G(["bd-siderail-btn", { on: m(s).ui.panelOpen }]),
        "aria-pressed": m(s).ui.panelOpen,
        "aria-label": "Comments",
        "data-testid": "comments-toggle",
        onClick: a
      }, [
        C($, {
          name: "MessageCircle",
          size: 16
        }),
        o.value ? (g(), b("span", aH, E(o.value > 99 ? "99+" : o.value), 1)) : r.value ? (g(), b("span", lH)) : z("", !0),
        u("span", dH, "Comments" + E(o.value ? ": " + o.value + " unread" : r.value ? ": news on other boards" : ""), 1)
      ], 10, rH)) : z("", !0),
      u("button", {
        class: G(["bd-siderail-btn", { on: m(e).ui.boardHistory }]),
        "aria-pressed": m(e).ui.boardHistory,
        "aria-label": "Board history",
        "data-testid": "board-history-toggle",
        onClick: f[0] || (f[0] = (p) => m(e).ui.boardHistory = !m(e).ui.boardHistory)
      }, [
        C($, {
          name: "History",
          size: 16
        }),
        n.value ? (g(), b("span", uH, E(n.value > 99 ? "99+" : n.value), 1)) : z("", !0),
        u("span", hH, "Board history" + E(n.value ? ": " + n.value + " new" : ""), 1)
      ], 10, cH),
      d.value.length ? (g(), b("button", {
        key: 1,
        class: G(["bd-siderail-btn", { on: !!m(e).ui.chatOpen }]),
        "aria-pressed": !!m(e).ui.chatOpen,
        "aria-label": "Chats",
        "data-testid": "chat-toggle",
        onClick: c
      }, [
        C($, {
          name: "MessagesSquare",
          size: 16
        }),
        d.value.length > 1 ? (g(), b("span", fH, E(d.value.length), 1)) : z("", !0),
        u("span", mH, E(d.value.length === 1 ? d.value[0].name : "Chats: the latest opens"), 1)
      ], 10, pH)) : z("", !0)
    ], 32));
  }
}), bH = { "data-testid": "elapsed" }, N1 = /* @__PURE__ */ Pe({
  __name: "Elapsed",
  props: {
    since: {}
  },
  setup(i) {
    const e = i, t = dr(), n = I(() => C1(t.value - e.since));
    return (s, o) => (g(), b("span", bH, E(n.value), 1));
  }
}), vH = ["title"], yH = { class: "sv-hist-cols-track" }, xH = ["min", "max", "value", "aria-valuetext", "data-testid"], K8 = /* @__PURE__ */ Pe({
  __name: "HistoryColumns",
  props: {
    columns: {},
    testid: {}
  },
  emits: ["set"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = Array.from({ length: mc - Gr + 1 }, (a, l) => Gr + l), o = (a) => (a - Gr) / (mc - Gr), r = I(() => t.columns + (t.columns === 1 ? " column" : " columns"));
    return (a, l) => (g(), b("div", {
      class: "sv-hist-cols",
      title: r.value
    }, [
      C($, {
        name: "Square",
        size: 11
      }),
      u("span", yH, [
        l[1] || (l[1] = u("span", { class: "rail" }, null, -1)),
        u("span", {
          class: "fill",
          style: ce({ width: "calc((100% - 12px) * " + o(i.columns) + ")" })
        }, null, 4),
        (g(!0), b(j, null, be(m(s), (d) => (g(), b("i", {
          key: d,
          class: G({ on: d <= i.columns }),
          style: ce({ left: "calc(6px + (100% - 12px) * " + o(d) + ")" })
        }, null, 6))), 128)),
        u("input", {
          type: "range",
          min: m(Gr),
          max: m(mc),
          step: "1",
          value: i.columns,
          "aria-label": "Columns",
          "aria-valuetext": r.value,
          "data-testid": i.testid,
          onInput: l[0] || (l[0] = (d) => n("set", +d.target.value))
        }, null, 40, xH)
      ]),
      C($, {
        name: "Grid3x3",
        size: 11
      })
    ], 8, vH));
  }
}), wH = { class: "sv-hist-filterrow" }, kH = ["aria-expanded", "disabled", "title", "data-testid"], _H = { class: "lb" }, SH = ["data-testid"], MH = {
  key: 0,
  class: "sv-hist-filter-pop",
  role: "menu",
  "aria-label": "Sessions in history"
}, TH = { class: "sv-hist-search" }, CH = ["data-testid", "onKeydown"], IH = ["aria-checked", "data-testid"], AH = { class: "ck" }, PH = { class: "ct" }, EH = ["aria-checked", "title", "data-testid"], RH = { class: "ck" }, zH = { class: "tx" }, $H = { class: "ct" }, DH = { class: "sv-hist-opts" }, OH = ["data-testid"], LH = ["aria-checked", "data-testid", "onClick"], BH = { class: "ck" }, FH = { class: "ic" }, NH = { class: "tx" }, UH = { key: 0 }, GH = { class: "ct" }, jH = { class: "sv-hist-opt-acts" }, HH = ["title", "aria-label", "data-testid", "onClick"], VH = ["title", "data-testid", "onClick"], WH = ["aria-checked", "title", "aria-label", "data-testid", "onClick"], qH = {
  key: 0,
  class: "sv-hist-opt-none"
}, KH = {
  key: 1,
  class: "sv-hist-opt-none"
}, YH = ["data-testid"], XH = ["aria-pressed", "title", "data-testid"], JH = ["data-testid"], Y8 = /* @__PURE__ */ Pe({
  __name: "HistorySessions",
  props: {
    filter: {},
    tid: {},
    pinned: { type: Boolean },
    pinCount: {},
    current: {},
    goTo: { type: Function }
  },
  emits: ["pinned"],
  setup(i, { emit: e }) {
    const t = i, n = e, { board: s } = Ze(), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(null), a = I(() => t.filter.historySessions.value), l = I(() => t.filter.pickedSessions()), d = I(() => t.filter.allSessions()), c = I(() => F1(t.filter)), h = I(() => a.value.find((T) => T.here) || (t.current ? a.value.find((T) => T.id === t.current) : null) || null), f = I(() => !!h.value && l.value.length === 1 && l.value[0] === h.value.id);
    function p(T) {
      o.value = !1, t.goTo && t.goTo(T);
    }
    const y = /* @__PURE__ */ K(""), v = /* @__PURE__ */ K(null), x = I(() => {
      const T = y.value.trim().toLowerCase(), k = a.value.filter((A) => !T || A.name.toLowerCase().includes(T)), P = k.filter((A) => !A.here && A.pinned);
      return [
        { id: "here", label: "", rows: k.filter((A) => A.here) },
        { id: "pinned", label: P.length ? "Pinned" : "", rows: P },
        { id: "rest", label: P.length ? "Sessions" : "", rows: k.filter((A) => !A.here && !A.pinned) }
      ].map((A) => ({ ...A, label: A.rows.length ? A.label : "" }));
    });
    function w() {
      const T = x.value.flatMap((k) => k.rows)[0];
      T && t.filter.toggleSession(T.id);
    }
    function S() {
      y.value = "", v.value && v.value.focus();
    }
    function M(T) {
      r.value && !r.value.contains(T.target) && (o.value = !1);
    }
    Ae(o, async (T) => {
      T ? window.addEventListener("pointerdown", M, !0) : window.removeEventListener("pointerdown", M, !0), y.value = "", T && (await nt(), v.value && v.value.focus());
    }), We(() => window.removeEventListener("pointerdown", M, !0));
    function _(T) {
      T.key === "Escape" && o.value && (T.preventDefault(), T.stopPropagation(), o.value = !1);
    }
    return (T, k) => (g(), b("div", wH, [
      u("div", {
        ref_key: "menuEl",
        ref: r,
        class: G(["sv-hist-filter", { "is-resting": i.pinned }]),
        onKeydown: _
      }, [
        u("button", {
          class: G(["sv-hist-filter-btn", { on: o.value, "is-narrowed": !d.value && !i.pinned }]),
          "aria-expanded": o.value,
          "aria-haspopup": "menu",
          disabled: i.pinned,
          title: i.pinned ? "Showing your pinned images, which only you see: turn Pinned off to pick sessions" : void 0,
          "data-testid": i.tid + "-sessions",
          onClick: k[0] || (k[0] = (P) => o.value = !o.value)
        }, [
          C($, {
            name: i.pinned ? "Pin" : "Layers",
            size: 13
          }, null, 8, ["name"]),
          u("span", _H, E(i.pinned ? "Your pinned images" : c.value), 1),
          i.pinned ? (g(), b("span", {
            key: 0,
            class: "sv-hist-private",
            "data-testid": i.tid + "-pinned-private"
          }, [
            C($, {
              name: "Lock",
              size: 10
            }),
            k[5] || (k[5] = J("Only you", -1))
          ], 8, SH)) : (g(), Ce($, {
            key: 1,
            name: "ChevronDown",
            size: 12,
            class: "chev"
          }))
        ], 10, kH),
        o.value ? (g(), b("div", MH, [
          u("div", TH, [
            C($, {
              name: "Search",
              size: 13
            }),
            kt(u("input", {
              ref_key: "searchEl",
              ref: v,
              "onUpdate:modelValue": k[1] || (k[1] = (P) => y.value = P),
              type: "text",
              placeholder: "Search sessions",
              "aria-label": "Search sessions",
              "data-testid": i.tid + "-sessions-search",
              onKeydown: tn(Se(w, ["prevent"]), ["enter"])
            }, null, 40, CH), [
              [Zt, y.value]
            ]),
            y.value ? (g(), b("button", {
              key: 0,
              class: "x",
              "aria-label": "Clear the search",
              onClick: S
            }, [
              C($, {
                name: "X",
                size: 11
              })
            ])) : z("", !0)
          ]),
          u("button", {
            role: "menuitemcheckbox",
            "aria-checked": d.value,
            class: G(["sv-hist-opt is-all", { on: d.value }]),
            "data-testid": i.tid + "-sessions-all",
            onClick: k[2] || (k[2] = (P) => i.filter.onlySession(null))
          }, [
            u("span", AH, [
              d.value ? (g(), Ce($, {
                key: 0,
                name: "Check",
                size: 11
              })) : z("", !0)
            ]),
            k[6] || (k[6] = u("span", { class: "tx" }, [
              u("b", null, "All sessions"),
              u("small", null, "Everything made on this board")
            ], -1)),
            u("span", PH, E(i.filter.boardItems.value.length), 1)
          ], 10, IH),
          h.value ? (g(), b("button", {
            key: 0,
            role: "menuitemcheckbox",
            "aria-checked": f.value,
            class: G(["sv-hist-opt is-all is-current", { on: f.value }]),
            title: "Only what " + h.value.name + " made",
            "data-testid": i.tid + "-sessions-current",
            onClick: k[3] || (k[3] = (P) => i.filter.onlySession(h.value.id))
          }, [
            u("span", RH, [
              f.value ? (g(), Ce($, {
                key: 0,
                name: "Check",
                size: 11
              })) : z("", !0)
            ]),
            u("span", zH, [
              k[7] || (k[7] = u("b", null, "Current session", -1)),
              u("small", null, E(h.value.name), 1)
            ]),
            u("span", $H, E(h.value.count), 1)
          ], 10, EH)) : z("", !0),
          k[8] || (k[8] = u("div", {
            class: "sv-hist-opt-sep",
            role: "separator"
          }, null, -1)),
          u("div", DH, [
            (g(!0), b(j, null, be(x.value, (P) => (g(), b(j, {
              key: P.id
            }, [
              P.label ? (g(), b("div", {
                key: 0,
                class: "sv-hist-opt-label",
                "data-testid": i.tid + "-sessions-" + P.id
              }, E(P.label), 9, OH)) : z("", !0),
              (g(!0), b(j, null, be(P.rows, (A) => (g(), b("div", {
                key: A.id,
                class: G(["sv-hist-opt-line", { "is-pinned": A.pinned }])
              }, [
                u("button", {
                  role: "menuitemcheckbox",
                  "aria-checked": l.value.includes(A.id),
                  class: G(["sv-hist-opt", { on: l.value.includes(A.id) }]),
                  "data-testid": i.tid + "-session-" + A.id,
                  onClick: (R) => i.filter.toggleSession(A.id)
                }, [
                  u("span", BH, [
                    l.value.includes(A.id) ? (g(), Ce($, {
                      key: 0,
                      name: "Check",
                      size: 11
                    })) : z("", !0)
                  ]),
                  u("span", FH, [
                    C($, {
                      name: A.icon,
                      size: 12
                    }, null, 8, ["name"])
                  ]),
                  u("span", NH, [
                    u("b", null, E(A.name), 1),
                    A.here ? (g(), b("small", UH, "This session")) : z("", !0)
                  ]),
                  u("span", GH, E(A.count), 1)
                ], 10, LH),
                u("span", jH, [
                  p ? (g(), b("button", {
                    key: 0,
                    role: "menuitem",
                    class: "sv-hist-pin is-go",
                    title: "Go to " + A.name + " on the board",
                    "aria-label": "Go to " + A.name + " on the board",
                    "data-testid": i.tid + "-session-go-" + A.id,
                    onClick: (R) => p(A.id)
                  }, [
                    C($, {
                      name: "LocateFixed",
                      size: 12
                    })
                  ], 8, HH)) : z("", !0),
                  u("button", {
                    role: "menuitem",
                    class: "sv-hist-only",
                    title: "Show only " + A.name,
                    "data-testid": i.tid + "-session-only-" + A.id,
                    onClick: (R) => i.filter.onlySession(A.id)
                  }, "Only", 8, VH),
                  u("button", {
                    role: "menuitemcheckbox",
                    "aria-checked": A.pinned,
                    class: G(["sv-hist-pin", { on: A.pinned }]),
                    title: A.pinned ? "Unpin" : "Pin to the top",
                    "aria-label": (A.pinned ? "Unpin " : "Pin ") + A.name,
                    "data-testid": i.tid + "-session-pin-" + A.id,
                    onClick: (R) => m(s).togglePinned(A.id)
                  }, [
                    C($, {
                      name: "Pin",
                      size: 12
                    })
                  ], 10, WH)
                ])
              ], 2))), 128))
            ], 64))), 128)),
            y.value && !x.value.some((P) => P.rows.length) ? (g(), b("div", qH, "No sessions match")) : z("", !0),
            !y.value && !a.value.length ? (g(), b("div", KH, "No sessions have made anything yet")) : z("", !0)
          ]),
          u("p", {
            class: "sv-hist-opt-note",
            "data-testid": i.tid + "-sessions-note"
          }, "Each session is a tool on the board, named after its first prompt until you rename it on its card.", 8, YH)
        ])) : z("", !0)
      ], 34),
      u("button", {
        class: G(["sv-hist-pinned", { on: i.pinned }]),
        "aria-pressed": i.pinned,
        title: i.pinned ? "Back to everything" : "Your pinned images (only you see them)",
        "data-testid": i.tid + "-pinned",
        onClick: k[4] || (k[4] = (P) => {
          o.value = !1, n("pinned", !i.pinned);
        })
      }, [
        C($, {
          name: "Pin",
          size: 13
        }),
        i.pinCount ? (g(), b("span", {
          key: 0,
          class: "ct",
          "data-testid": i.tid + "-pinned-count"
        }, E(i.pinCount), 9, JH)) : z("", !0)
      ], 10, XH)
    ]));
  }
}), ZH = ["data-testid"], QH = {
  class: "pe-art",
  "aria-hidden": "true"
}, eV = { class: "pe-pin" }, tV = { class: "pe-private" }, nV = {
  key: 0,
  class: "pe-body"
}, iV = { class: "pe-hint" }, sV = { class: "pe-key" }, U1 = /* @__PURE__ */ Pe({
  __name: "PinnedEmpty",
  props: {
    compact: { type: Boolean, default: !1 },
    kind: { default: "image" }
  },
  setup(i) {
    const e = i, t = I(() => e.kind === "video" ? "videos" : "images");
    return (n, s) => (g(), b("div", {
      class: G(["pe", { "is-compact": i.compact }]),
      "data-testid": i.compact ? "ref-pinned-empty" : "pinned-empty"
    }, [
      u("div", QH, [
        s[0] || (s[0] = _1('<span class="pe-glow"></span><span class="pe-card c1"><i class="sun"></i><i class="hill"></i></span><span class="pe-card c3"><i class="sun"></i><i class="hill"></i></span><span class="pe-card c2"><i class="sun"></i><i class="hill"></i><i class="hill b"></i></span><span class="pe-ring"></span>', 5)),
        u("span", eV, [
          C($, {
            name: "Pin",
            size: 12
          })
        ])
      ]),
      u("span", tV, [
        C($, {
          name: "Lock",
          size: 10
        }),
        s[1] || (s[1] = J("Only you see your pins", -1))
      ]),
      s[5] || (s[5] = u("b", { class: "pe-title" }, "Pin your go-to references", -1)),
      i.compact ? (g(), b("p", nV, "Pin the " + E(t.value) + " you reach for as references and they wait here, one click away.", 1)) : (g(), b(j, { key: 1 }, [
        s[2] || (s[2] = u("p", { class: "pe-body" }, "Keep the images you reach for again and again one click away: a mood shot, a material, the site photo you're matching. Use them as references in any prompt on this board.", -1)),
        s[3] || (s[3] = u("p", { class: "pe-note" }, "They're personal: everyone on this board has their own. And unlike favorites, which gather in your Library from every board, pins stay with this board.", -1))
      ], 64)),
      u("span", iV, [
        s[4] || (s[4] = J("Look for ", -1)),
        u("span", sV, [
          C($, {
            name: "Pin",
            size: 11
          })
        ]),
        J(" on any " + E(i.kind), 1)
      ])
    ], 10, ZH));
  }
}), oV = { class: "sv-hist-head" }, rV = { class: "t" }, aV = {
  class: "n",
  "data-testid": "board-history-count"
}, lV = ["title", "data-testid", "data-result", "data-url", "onMouseenter", "onPointerdown"], dV = { class: "frame" }, cV = {
  key: 0,
  class: "sv-art"
}, uV = ["src"], hV = {
  key: 1,
  class: "sv-cell-fail"
}, pV = {
  key: 0,
  class: "bd-boardhist-vid"
}, fV = ["title"], mV = { class: "sv-cell-cap" }, gV = {
  key: 1,
  class: "sv-hist-empty"
}, bV = {
  key: 2,
  class: "sv-hist-empty"
}, vV = ["title"], yV = { class: "sv-art" }, xV = ["src"], wV = ["src"], kV = { class: "cap" }, _V = { class: "n" }, SV = { class: "m" }, MV = { class: "sv-hist-acts" }, TV = ["aria-pressed"], CV = { class: "tip" }, IV = { class: "tip" }, ug = 60, AV = 300, PV = 380, EV = 52, RV = /* @__PURE__ */ Pe({
  __name: "BoardHistory",
  setup(i) {
    const { board: e, input: t } = Ze(), n = q8(e), s = n.s, o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null);
    function a(H) {
      return {
        id: H.id,
        url: H.url,
        w: H.w || 4,
        h: H.h || 3,
        status: H.status === "moderated" ? "failed" : H.status,
        label: H.label || H.prompt || "Result",
        createdAt: H.createdAt,
        video: !!H.video,
        videoSrc: H.videoSrc || null,
        dur: H.dur || null,
        sessionId: H.sessionId,
        result: H,
        asset: H.asset || null
      };
    }
    function l(H) {
      const re = H.resultId && e.results.get(H.resultId) || null;
      return {
        id: "pin:" + H.id,
        url: H.url,
        w: H.pw,
        h: H.ph,
        status: "done",
        label: H.label,
        createdAt: H.createdAt,
        video: !!H.video,
        videoSrc: H.videoSrc || null,
        dur: H.dur || null,
        sessionId: H.fromSession || (re ? re.sessionId : null),
        result: re,
        asset: H.asset || null
      };
    }
    const d = I(() => s.pinned ? (e.results.rev.value, e.pinnedImages.value.map(l)) : n.shown.value.map(a)), c = I(() => n.allSessions()), h = I(() => F1(n)), f = I(() => (c.value ? n.historySessions.value.length : n.pickedSessions().length) > 1), p = I(() => {
      e.docRev.value;
      const H = /* @__PURE__ */ new Map(), re = /* @__PURE__ */ new Map();
      for (const le of e.store.all()) {
        if (le.type !== "image") continue;
        const he = le;
        he.resultId && !H.has(he.resultId) && H.set(he.resultId, he), re.has(he.src) || re.set(he.src, he);
      }
      return { byResult: H, byUrl: re };
    });
    function y(H) {
      return H.result && p.value.byResult.get(H.result.id) || p.value.byUrl.get(H.url) || null;
    }
    function v(H) {
      const re = H.sessionId ? e.store.get(H.sessionId) : null;
      return re && re.type === "tool" ? re : null;
    }
    const x = /* @__PURE__ */ K(ug), w = I(() => d.value.slice(0, x.value)), S = /* @__PURE__ */ K(!1);
    async function M() {
      if (!(s.pinned || S.value || e.boardHistoryDone())) {
        S.value = !0;
        try {
          await e.loadBoardHistory();
        } finally {
          S.value = !1;
        }
      }
    }
    Ae(() => n.pickedSessions().join(" ") + (s.pinned ? " pinned" : ""), () => {
      x.value = ug, D(), r.value && (r.value.scrollTop = 0);
    });
    function _(H) {
      D();
      const re = H.target;
      re.scrollHeight - re.scrollTop - re.clientHeight > 400 || (x.value < d.value.length ? x.value += ug : M());
    }
    ot(() => {
      M();
    });
    function T(H) {
      if (H.status === "pending") return "Making…";
      if (H.status === "failed") return "Failed";
      if (s.pinned || f.value) {
        const re = v(H);
        if (re) return re.name;
        if (s.pinned) return H.label;
      }
      return Jn(H.createdAt);
    }
    const k = /* @__PURE__ */ K(null);
    let P = 0;
    const A = () => clearTimeout(P), R = () => {
      clearTimeout(P), P = window.setTimeout(() => {
        k.value = null;
      }, 180);
    }, D = () => {
      clearTimeout(P), k.value = null;
    };
    We(() => clearTimeout(P));
    function O(H, re) {
      if (A(), H.status !== "done" || !o.value) {
        k.value = null;
        return;
      }
      const le = re.currentTarget.getBoundingClientRect(), he = o.value.getBoundingClientRect(), Re = Math.min(AV / H.w, PV / H.h), Ne = Math.round(H.w * Re), Me = Math.round(H.h * Re), ue = Math.min(Math.max(EV + 8 - he.top, le.top - he.top + le.height / 2 - Me / 2), window.innerHeight - 8 - Me - he.top);
      k.value = { c: H, top: ue, w: Ne, h: Me };
    }
    function F(H) {
      return H.status === "done" && (!!H.result || !!y(H));
    }
    function te(H) {
      if (!F(H)) return;
      const re = y(H);
      e.ui.infoSession = H.result ? H.result.sessionId : null, e.ui.infoAt = re ? re.id : "result:" + H.result.id;
    }
    function ee(H, re) {
      if (D(), H.status !== "done") return;
      if (e.ui.eyedropper) {
        re.preventDefault(), e.eyedrop(H.url, H.asset, H.video);
        return;
      }
      const le = Math.min(360, Math.max(200, H.w || 300)), he = Math.round(le * H.h / H.w);
      t.dragResultOut({ url: H.url, w: le, h: he, result: H.result, label: H.label, sessionId: H.sessionId || void 0 }, re, { onClick: () => te(H) });
    }
    function me(H) {
      H(), D();
    }
    function L(H) {
      return H.result ? lm(H.result) : { url: H.url, w: H.w, h: H.h, label: H.label, asset: H.asset, sessionId: H.sessionId, video: H.video, videoSrc: H.videoSrc, dur: H.dur };
    }
    function N(H) {
      const re = y(H);
      re && (e.ui.selection = [re.id], e.jumpTo(re.x + re.w / 2, re.y + re.h / 2, Math.max(e.cam.value.zoom, 0.6)));
    }
    const X = I(() => e.promptTool.value);
    function B(H) {
      const re = X.value;
      re && e.addReference(re.id, H.url, H.asset) && e.toast("Added to " + re.name + " as a reference");
    }
    function se(H) {
      H.result && H.result.url === H.url ? e.placeResult(H.result) : e.placeImages([{ url: H.url, w: Math.min(360, H.w), h: Math.round(Math.min(360, H.w) * H.h / H.w), label: H.label, asset: H.asset || void 0, video: H.video || void 0, videoSrc: H.videoSrc || void 0, dur: H.dur || void 0 }]);
    }
    function V(H) {
      const re = v(H);
      return (re ? re.name + " · " : "") + Jn(H.createdAt);
    }
    function Z(H) {
      s.pinned = H;
    }
    function Y(H) {
      const re = e.store.get(H);
      re && re.type === "tool" && e.openSession(re);
    }
    return (H, re) => (g(), b("aside", {
      ref_key: "panel",
      ref: o,
      class: G(["sv-hist bd-boardhist", ["cols-" + m(s).columns, { "is-pinned-view": m(s).pinned }]]),
      "aria-label": "Board history",
      "data-testid": "board-history",
      onPointerdown: re[12] || (re[12] = Se(() => {
      }, ["stop"])),
      onWheel: re[13] || (re[13] = Se(() => {
      }, ["stop"])),
      onMouseleave: R
    }, [
      u("div", oV, [
        u("span", rV, E(m(s).pinned ? "Pinned" : "History"), 1),
        u("span", aV, E(d.value.length), 1),
        re[14] || (re[14] = u("span", { class: "sv-grow" }, null, -1)),
        m(e).hasLibrary ? (g(), b("button", {
          key: 0,
          class: "sv-hist-lib",
          title: "Place pictures from your Library",
          "data-testid": "board-history-library",
          onClick: re[0] || (re[0] = (le) => m(e).openLibrary())
        }, [
          C($, {
            name: "Library",
            size: 14
          })
        ])) : z("", !0),
        C(K8, {
          columns: m(s).columns,
          testid: "board-history-cols",
          onSet: re[1] || (re[1] = (le) => m(n).setColumns(le))
        }, null, 8, ["columns"]),
        u("button", {
          class: "bd-boardhist-close",
          title: "Close (Esc)",
          "aria-label": "Close the board history",
          "data-testid": "board-history-close",
          onClick: re[2] || (re[2] = (le) => m(e).ui.boardHistory = !1)
        }, [
          C($, {
            name: "X",
            size: 14
          })
        ])
      ]),
      C(Y8, {
        filter: m(n),
        tid: "board-history",
        pinned: m(s).pinned,
        "pin-count": m(e).pinnedImages.value.length,
        current: m(e).promptTool.value ? m(e).promptTool.value.id : null,
        "go-to": Y,
        onPinned: Z
      }, null, 8, ["filter", "pinned", "pin-count", "current"]),
      u("div", {
        ref_key: "grid",
        ref: r,
        class: "sv-hist-grid",
        style: ce({ "--cols": m(s).columns }),
        onScroll: _
      }, [
        (g(!0), b(j, null, be(w.value, (le) => (g(), b("div", {
          key: le.id,
          class: G(["sv-cell", {
            "is-pending": le.status === "pending",
            "is-failed": le.status === "failed",
            "is-new": Date.now() - le.createdAt < 4e3,
            "is-on": k.value && k.value.c.id === le.id
          }]),
          title: le.status === "done" ? void 0 : T(le),
          "data-testid": (m(s).pinned ? "board-history-pinned-" : "board-history-item-") + le.status,
          "data-result": le.result ? le.result.id : void 0,
          "data-url": le.url,
          onMouseenter: (he) => O(le, he),
          onMouseleave: R,
          onPointerdown: (he) => ee(le, he)
        }, [
          u("span", dV, [
            le.status === "done" ? (g(), b("span", cV, [
              u("img", {
                src: m(Bt)(le.url),
                alt: "",
                draggable: "false",
                loading: "lazy"
              }, null, 8, uV)
            ])) : le.status === "failed" ? (g(), b("span", hV, [
              C($, {
                name: "AlertCircle",
                size: 16
              })
            ])) : le.status === "pending" ? (g(), Ce(N1, {
              key: 2,
              class: "sv-cell-time",
              since: le.result && le.result.startedAt || le.createdAt
            }, null, 8, ["since"])) : z("", !0)
          ]),
          le.video && le.status === "done" ? (g(), b("span", pV, [
            C($, {
              name: "Play",
              size: 8
            }),
            J(E(le.dur || "0:05"), 1)
          ])) : z("", !0),
          !m(s).pinned && le.status === "done" && m(e).isPinnedImage(le.url) ? (g(), b("span", {
            key: 1,
            class: "sv-cell-pin",
            title: m(Xn).badge
          }, [
            C($, {
              name: "Pin",
              size: 10
            })
          ], 8, fV)) : z("", !0),
          u("span", mV, E(T(le)), 1)
        ], 42, lV))), 128)),
        m(s).pinned && !d.value.length ? (g(), Ce(U1, { key: 0 })) : !d.value.length && !S.value ? (g(), b("div", gV, E(c.value ? "What the board's sessions make collects here, newest first." : "Nothing from " + h.value + " yet."), 1)) : z("", !0),
        S.value && !m(s).pinned ? (g(), b("div", bV, [...re[15] || (re[15] = [
          u("span", { class: "bd-spinner is-sm" }, null, -1)
        ])])) : z("", !0)
      ], 36),
      k.value ? (g(), b("div", {
        key: 0,
        class: "sv-hist-pop",
        style: ce({ top: k.value.top + "px", width: k.value.w + "px", height: k.value.h + "px" }),
        "data-testid": "board-history-preview",
        onMouseenter: A,
        onMouseleave: R
      }, [
        u("button", {
          class: "art",
          title: F(k.value.c) ? "Open the full record" : k.value.c.label,
          onClick: re[3] || (re[3] = (le) => me(() => te(k.value.c)))
        }, [
          u("span", yV, [
            u("img", {
              src: k.value.c.url,
              alt: "",
              draggable: "false"
            }, null, 8, xV)
          ]),
          k.value.c.video && k.value.c.videoSrc ? (g(), b("video", {
            key: k.value.c.videoSrc,
            class: "bd-boardhist-play",
            src: k.value.c.videoSrc,
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            preload: "auto",
            disablepictureinpicture: ""
          }, null, 8, wV)) : z("", !0)
        ], 8, vV),
        u("span", kV, [
          u("span", _V, E(k.value.c.label), 1),
          u("span", SV, E(V(k.value.c)), 1)
        ]),
        u("span", MV, [
          u("button", {
            class: G(["is-pin", { on: m(e).isPinnedImage(k.value.c.url) }]),
            "aria-pressed": m(e).isPinnedImage(k.value.c.url),
            "data-testid": "board-history-pin",
            onClick: re[4] || (re[4] = Se((le) => m(e).togglePinImage(L(k.value.c)), ["stop"]))
          }, [
            C($, {
              name: "Pin",
              size: 13
            }),
            u("span", CV, E(m(e).isPinnedImage(k.value.c.url) ? m(Xn).unpin : m(Xn).pin), 1)
          ], 10, TV),
          X.value && !k.value.c.video && !m(af)(k.value.c.url) ? (g(), b("button", {
            key: 0,
            "data-testid": "board-history-use-ref",
            onClick: re[5] || (re[5] = Se((le) => me(() => B(k.value.c)), ["stop"]))
          }, [
            C($, {
              name: "ImagePlus",
              size: 13
            }),
            u("span", IV, "Use as reference in " + E(X.value.name), 1)
          ])) : z("", !0),
          y(k.value.c) ? (g(), b("button", {
            key: 1,
            "data-testid": "board-history-find",
            onClick: re[6] || (re[6] = Se((le) => me(() => N(k.value.c)), ["stop"]))
          }, [
            C($, {
              name: "LocateFixed",
              size: 13
            }),
            re[16] || (re[16] = u("span", { class: "tip" }, "Find it on the board", -1))
          ])) : (g(), b("button", {
            key: 2,
            "data-testid": "board-history-place",
            onClick: re[7] || (re[7] = Se((le) => me(() => se(k.value.c)), ["stop"]))
          }, [
            C($, {
              name: "ArrowDownToLine",
              size: 13
            }),
            re[17] || (re[17] = u("span", { class: "tip" }, "Place on the board", -1))
          ])),
          F(k.value.c) ? (g(), b("button", {
            key: 3,
            "data-testid": "board-history-details",
            onClick: re[8] || (re[8] = Se((le) => me(() => te(k.value.c)), ["stop"]))
          }, [
            C($, {
              name: "Info",
              size: 13
            }),
            re[18] || (re[18] = u("span", { class: "tip" }, "Details", -1))
          ])) : z("", !0),
          v(k.value.c) ? (g(), b("button", {
            key: 4,
            "data-testid": "board-history-session",
            onClick: re[9] || (re[9] = Se((le) => me(() => m(e).openSession(v(k.value.c))), ["stop"]))
          }, [
            C($, {
              name: "LayoutGrid",
              size: 13
            }),
            re[19] || (re[19] = u("span", { class: "tip" }, "Open its session", -1))
          ])) : z("", !0),
          k.value.c.result && !k.value.c.video && !m(af)(k.value.c.url) ? (g(), b("button", {
            key: 5,
            "data-testid": "board-history-edit",
            onClick: re[10] || (re[10] = Se((le) => me(() => m(e).openStudio({ resultId: k.value.c.result.id })), ["stop"]))
          }, [
            C($, {
              name: "Wand2",
              size: 13
            }),
            re[20] || (re[20] = u("span", { class: "tip" }, "Edit in Studio view", -1))
          ])) : z("", !0),
          k.value.c.result && k.value.c.result.kind === "3d" && k.value.c.result.download ? (g(), b("button", {
            key: 6,
            "data-testid": "board-history-download",
            onClick: re[11] || (re[11] = Se((le) => me(() => m(e).downloadResult(k.value.c.result)), ["stop"]))
          }, [
            C($, {
              name: "Download",
              size: 13
            }),
            re[21] || (re[21] = u("span", { class: "tip" }, "Download the 3D model", -1))
          ])) : z("", !0)
        ])
      ], 36)) : z("", !0)
    ], 34));
  }
});
function gn(i) {
  if (i == null) return;
  if (typeof i == "number") return i;
  if (i instanceof Date) return i.getTime();
  const e = i;
  if (typeof e.toMillis == "function") return e.toMillis();
}
function Wo(i) {
  return i && typeof i == "object" && "code" in i && typeof i.code == "string" ? i.code : "";
}
function Lt(i) {
  return typeof i == "string" ? i : "";
}
function ta(i) {
  return i && typeof i == "object" && !Array.isArray(i) ? i : null;
}
function zV(i) {
  const e = ta(i);
  return !e || !Lt(e.url) ? null : { label: Lt(e.label), role: Lt(e.role), title: Lt(e.title) || void 0, kind: e.kind === "markup" ? "markup" : "reference", url: Lt(e.url) };
}
function $V(i) {
  const e = ta(i), t = e && ta(e.tool), n = e && ta(e.output);
  if (!e || !t || !n || !Lt(e.id) || !Lt(e.name) || !Lt(e.prompt) || !Lt(n.url)) return null;
  const s = {
    id: Lt(e.id),
    name: Lt(e.name),
    category: Lt(e.category),
    description: Lt(e.description),
    prompt: Lt(e.prompt),
    mode: Lt(e.mode),
    tags: Array.isArray(e.tags) ? e.tags.filter((o) => typeof o == "string") : [],
    kind: e.kind === "video" ? "video" : "image",
    tool: { nodeDefId: Lt(t.nodeDefId), name: Lt(t.name) },
    output: { url: Lt(n.url), w: Number(n.w) || 0, h: Number(n.h) || 0, video: Lt(n.video) || void 0 },
    inputs: Array.isArray(e.inputs) ? e.inputs.map(zV).filter((o) => !!o) : []
  };
  return Lt(e.line) && (s.line = Lt(e.line)), s;
}
function DV(i) {
  const e = ta(i);
  if (!e || !Array.isArray(e.prompts)) return null;
  const t = e.prompts.map($V).filter((s) => !!s), n = Array.isArray(e.categories) ? e.categories.map((s) => ta(s)).filter((s) => !!s && !!Lt(s.label)).map((s) => ({ id: Lt(s.id) || Lt(s.label), label: Lt(s.label), description: Lt(s.description) })) : [];
  return { id: Lt(e.id), name: Lt(e.name), source: Lt(e.source) || void 0, categories: n, prompts: t };
}
function G1(i) {
  return (i || "").toLowerCase().split(/\s+/).filter(Boolean);
}
function X8(i, e, t) {
  let n = 0;
  const s = i.name.toLowerCase(), o = [i.category, i.tool.name, i.tags.join(" ")].join(" ").toLowerCase(), r = i.description.toLowerCase(), a = i.prompt.toLowerCase();
  for (const l of e) {
    const d = s.includes(l) ? 8 : o.includes(l) ? 4 : r.includes(l) ? 2 : a.includes(l) ? 1 : 0;
    if (!d) return null;
    n += d;
  }
  return t && i.kind === t ? n + 100 : n;
}
function OV(i, e = {}) {
  const t = G1(e.query), n = [];
  return i.forEach((s, o) => {
    if (e.category && s.category !== e.category || e.only && s.kind !== e.only || e.action && ca(s) !== e.action) return;
    const r = X8(s, t, e.kind);
    r !== null && n.push({ p: s, score: r, at: o });
  }), n.sort((s, o) => o.score - s.score || s.at - o.at).map((s) => s.p);
}
function ca(i) {
  return i.inputs.length ? "edit" : "generate";
}
const LV = ["image", "video"], BV = ["generate", "edit"];
function Zw(i) {
  const e = /* @__PURE__ */ new Map();
  for (const t of i) {
    const n = { kind: t.kind, action: ca(t), label: t.category || "" }, s = n.kind + "|" + n.action + "|" + n.label, o = e.get(s);
    o ? o.count++ : e.set(s, { ...n, count: 1 });
  }
  return Array.from(e.values()).sort((t, n) => n.count - t.count || t.label.localeCompare(n.label));
}
function Xu(i, e = [], t) {
  const n = (o) => {
    const r = e.indexOf(o);
    return r < 0 ? e.length : r;
  }, s = LV.map((o) => {
    const r = BV.map((a) => {
      const l = i.filter((h) => h.kind === o && h.action === a && h.count > 0), d = l.reduce((h, f) => h + f.count, 0), c = l.filter((h) => !!h.label).sort((h, f) => n(h.label) - n(f.label) || f.count - h.count || h.label.localeCompare(f.label)).map((h) => ({ label: h.label, count: h.count }));
      return { action: a, count: t ? t[o][a] : d, categories: c };
    });
    return { kind: o, count: r.reduce((a, l) => a + l.count, 0), actions: r };
  });
  return { total: s.reduce((o, r) => o + r.count, 0), kinds: s };
}
function FV(i) {
  return i ? i.charAt(0).toUpperCase() + i.slice(1) : "";
}
function Xa(i, e) {
  return i.byId.get(e.nodeDefId) || i.source === "demo" && i.byName.get(e.name) || null;
}
function Qw(i, e, t) {
  return _v(i, e, t);
}
function Ja(i) {
  return i === "image" || i === "imageEdit" ? "image" : i === "video" || i === "videoEdit" ? "video" : null;
}
function ek(i) {
  return /^(Image|Video|3D|Upscale|Image Edit|Video Edit) Tool \d+$/.test(i || "");
}
const NV = /^\s*(\d+(?:\.\d+)?)\s*[:x×]\s*(\d+(?:\.\d+)?)\s*$/;
function J8(i) {
  const e = ta(i.value);
  if (e && Number(e.width) > 0 && Number(e.height) > 0) return Number(e.width) / Number(e.height);
  for (const t of [typeof i.value == "string" ? i.value : "", i.meta || "", i.label]) {
    const n = NV.exec(t);
    if (n && Number(n[2]) > 0) return Number(n[1]) / Number(n[2]);
  }
  return null;
}
function UV(i) {
  return i.fields.find((e) => e.placement === "chip" && !!e.options && (e.kind === "size" || e.kind === "select" && /aspect|ratio|size/i.test(e.label) && e.options.filter((t) => J8(t) != null).length >= 2)) || null;
}
function GV(i, e, t) {
  if (!e || !t || !i.options) return;
  const n = e / t;
  let s = null;
  for (const o of i.options) {
    const r = J8(o);
    if (r == null) continue;
    const a = Math.abs(Math.log(r / n));
    (!s || a < s.d) && (s = { v: o.value, d: a });
  }
  return s && s.d < Math.log(1.12) ? s.v : void 0;
}
function jV(i, e) {
  const t = i.fields.filter((l) => l.placement === "reference"), n = e.inputs.map((l) => l.url), s = {}, o = { prompt: e.prompt, ref: null, inputs: s, n: 1 };
  let r = 0;
  for (const l of t) {
    if (r >= n.length) break;
    if (l.kind !== "image" && l.kind !== "images") continue;
    const d = l.kind === "images" ? n.slice(r, r + Math.max(1, l.maxImages || n.length)) : [n[r]];
    r += d.length, l === t[0] && (o.ref = d[0]), d.length > 1 ? s[l.key] = d : l !== t[0] && (s[l.key] = d[0]);
  }
  const a = UV(i);
  if (a) {
    const l = GV(a, e.output.w, e.output.h);
    l !== void 0 && (s[a.key] = l);
  }
  return { up: o, dropped: n.length - r };
}
function HV(i, e, t) {
  return e ? i.filter((n) => !!n.line && n.kind === e && (t || !n.inputs.length)).map((n) => ({ id: n.id, text: n.line })) : [];
}
function VV(i, e) {
  if (!e) return 0;
  let t = 0;
  for (let n = 0; n < i.length; n++) t = t * 31 + i.charCodeAt(n) >>> 0;
  return t % e;
}
const Kt = (i) => typeof i == "string" ? i : "", Ma = (i) => i && typeof i == "object" && !Array.isArray(i) ? i : null;
function WV(i, e) {
  const t = Ma(e), n = t && Ma(t.tool);
  if (!t || !n || t.deletedAt || !Kt(t.authorId) || !Kt(t.prompt)) return null;
  const s = Ma(t.output) || {}, o = Array.isArray(t.inputs) ? t.inputs.map(Ma).filter((a) => !!a && !!Kt(a.url)).map((a) => ({ label: Kt(a.label), role: Kt(a.role), title: Kt(a.title) || void 0, kind: a.kind === "markup" ? "markup" : "reference", url: Kt(a.url) })) : [], r = Ma(t.run);
  return {
    id: i,
    name: Kt(t.name) || "Untitled prompt",
    category: Kt(t.category),
    description: Kt(t.description),
    prompt: Kt(t.prompt),
    mode: Kt(t.mode) || yu(o.length),
    tags: Array.isArray(t.tags) ? t.tags.filter((a) => typeof a == "string") : [],
    kind: t.kind === "video" ? "video" : "image",
    tool: { nodeDefId: Kt(n.nodeDefId), name: Kt(n.name) },
    output: { url: Kt(s.url), w: Number(s.w) || 0, h: Number(s.h) || 0, thumb: Kt(s.thumb) || void 0, video: Kt(s.video) || void 0 },
    inputs: o,
    authorId: Kt(t.authorId),
    authorName: Kt(t.authorName),
    boardId: Kt(t.boardId) || null,
    teamId: Kt(t.teamId) || null,
    companyId: Kt(t.companyId) || null,
    values: Ma(t.values),
    run: r && Kt(r.runId) ? { runId: Kt(r.runId), uuid: Kt(r.uuid) } : null,
    createdAt: gn(t.createdAt) || 0,
    updatedAt: gn(t.updatedAt) || gn(t.createdAt) || 0
  };
}
function lf(i, e) {
  const t = [];
  return i.boardId && i.boardId === e && t.push("board"), i.teamId && t.push("team"), i.companyId && t.push("company"), t.length || i.boardId ? t : ["me"];
}
function Z8(i, e) {
  return !!i.boardId && i.boardId !== e;
}
function yu(i) {
  return i === 0 ? "text only" : i === 1 ? "one image" : "multiple images";
}
const qV = 2e4;
function KV(i) {
  const e = i ? i.fields.find((n) => n.kind === "prompt") : void 0, t = e && e.raw && e.raw.display ? e.raw.display.maxLength : void 0;
  return Math.min(typeof t == "number" && t > 0 ? t : 2e3, qV);
}
function tk(i, e) {
  if (e && !/^(Image|Video|3D|Upscale|Image Edit|Video Edit) Tool \d+$/.test(e)) return e;
  const t = String(i || "").replace(/([.!?])\s+/g, `$1
`).split(/\n+/).map((o) => o.trim()).filter(Boolean);
  let s = (t.find((o) => !/^create one finished architectural/i.test(o) && !/^image \d+ is /i.test(o)) || t[0] || "").replace(/[.!?]+$/, "").split(/[,;:]/)[0].trim();
  return s.length > 42 && (s = s.slice(0, 42).replace(/\s\S*$/, "")), s ? s.charAt(0).toUpperCase() + s.slice(1) : "Untitled prompt";
}
function Q8(i, e, t, n) {
  const s = [];
  if (i && e) {
    const o = dc(i, e, n);
    i.fields.filter((a) => a.placement === "reference").forEach((a, l) => {
      const d = o.inputs ? o.inputs[a.key] : void 0, c = Array.isArray(d) ? d.filter((f) => typeof f == "string") : [], h = l === 0 ? o.ref : typeof d == "string" ? d : null;
      for (const f of c.length ? c : h ? [h] : []) s.push({ url: f, role: a.label });
    });
  }
  if (!s.length) for (const o of t) s.push({ url: o, role: "Input image" });
  return s.map((o, r) => ({ label: "Image " + (r + 1), role: o.role, kind: "reference", url: o.url }));
}
function YV(i, e) {
  if (!e) return null;
  const t = { ...e };
  if (delete t[R1], i)
    for (const n of i.fields) n.placement === "reference" && delete t[n.key];
  return t;
}
function XV(i, e, t) {
  const n = i.inputs ? JSON.parse(JSON.stringify(i.inputs)) : null, s = Q8(e, n, i.refs || [], t);
  return {
    name: "",
    category: "",
    description: "",
    prompt: i.prompt || "",
    mode: yu(s.length),
    tags: [],
    kind: i.video ? "video" : "image",
    tool: { nodeDefId: i.modelId || (e ? e.id : ""), name: e && e.name || i.model || "" },
    output: { url: i.url, w: i.w || 0, h: i.h || 0, thumb: i.thumb, video: i.videoSrc },
    inputs: s,
    boardId: null,
    teamId: null,
    companyId: null,
    values: n,
    run: i.runId && i.uuid ? { runId: i.runId, uuid: i.uuid } : null
  };
}
function nk(i, e, t, n) {
  const s = new Set(e.filter((a) => a.authorId === t && a.id !== n).map((a) => a.name.trim().toLowerCase())), o = i.trim();
  if (!s.has(o.toLowerCase())) return o;
  let r = 2;
  for (; s.has((o + " " + r).toLowerCase()); ) r++;
  return o + " " + r;
}
function ik(i, e, t, n, s) {
  const o = t.trim();
  return i.find((r) => r.authorId === e && r.id !== s && r.tool.nodeDefId === n && r.prompt.trim() === o) || null;
}
function JV(i) {
  const e = /* @__PURE__ */ new Map();
  for (const t of i) t.category && e.set(t.category, (e.get(t.category) || 0) + 1);
  return Array.from(e.entries()).sort((t, n) => n[1] - t[1] || t[0].localeCompare(n[0])).map(([t]) => t);
}
const j1 = 200, eS = 12, ZV = 100;
function QV(i) {
  return G1(i.slice(0, j1)).slice(0, eS);
}
function eW(i) {
  const e = Array.from(new Set(G1(i))).sort((s, o) => o.length - s.length), t = [];
  let n = 0;
  for (const s of e) {
    if (t.length === eS) break;
    const o = (t.length ? 1 : 0) + s.length;
    n + o > j1 || (t.push(s), n += o);
  }
  return t.join(" ");
}
function tW(i, e) {
  return e.levels.length && !lf(i, e.boardId).some((t) => e.levels.includes(t)) || e.onlyKind && i.kind !== e.onlyKind || e.onlyAction && ca(i) !== e.onlyAction || e.category && i.category !== e.category || e.mine && i.authorId !== e.uid || e.toolId && i.tool.nodeDefId !== e.toolId ? !1 : X8(i, QV(e.query)) !== null;
}
function nW(i) {
  return Array.from(i.entries()).filter(([, e]) => e > 0).sort((e, t) => t[1] - e[1] || e[0].localeCompare(t[0])).slice(0, ZV).map(([e, t]) => ({ label: e, count: t }));
}
function iW(i, e, t) {
  const n = { kind: e.kind, action: ca(e), label: e.category || "" }, s = i.findIndex((r) => r.kind === n.kind && r.action === n.action && r.label === n.label), o = i.slice();
  return s < 0 ? t > 0 && o.push({ ...n, count: t }) : o[s] = { ...o[s], count: Math.max(0, o[s].count + t) }, o.filter((r) => r.count > 0).sort((r, a) => a.count - r.count || r.label.localeCompare(a.label));
}
function hg(i, e, t, n) {
  if (!i) return i;
  const s = { ...i.levels }, o = i.kinds ? { ...i.kinds } : void 0, r = i.actions ? { image: { ...i.actions.image }, video: { ...i.actions.video } } : void 0;
  let a = i.groups;
  const l = new Map(i.categories.map((h) => [h.label, h.count]));
  let d = i.total;
  const c = (h, f) => {
    d = Math.max(0, d + f);
    for (const p of lf(h, n)) s[p] = Math.max(0, s[p] + f);
    o && (o[h.kind] = Math.max(0, o[h.kind] + f)), r && (r[h.kind][ca(h)] = Math.max(0, r[h.kind][ca(h)] + f)), a && (a = iW(a, h, f)), h.category && l.set(h.category, Math.max(0, (l.get(h.category) || 0) + f));
  };
  return e && c(e, -1), t && c(t, 1), { total: d, levels: s, ...o ? { kinds: o } : {}, ...r ? { actions: r } : {}, categories: nW(l), ...a ? { groups: a } : {} };
}
function tS(i) {
  const e = /* @__PURE__ */ K(!1), t = () => {
    const s = i.value;
    e.value = !!s && s.scrollHeight - s.scrollTop - s.clientHeight > 4;
  }, n = typeof ResizeObserver != "undefined" ? new ResizeObserver(t) : null;
  return Ae(i, (s, o) => {
    n && o && n.unobserve(o), n && s && n.observe(s), t();
  }, { flush: "post" }), w5(t), We(() => {
    n && n.disconnect();
  }), { more: e, measure: t };
}
const sW = { class: "ps-head" }, oW = { class: "ps-mark" }, rW = { class: "ps-title" }, aW = { class: "ps-field" }, lW = { class: "ps-field" }, dW = {
  class: "ps-audience",
  "data-testid": "save-audience"
}, cW = { class: "ps-levels" }, uW = ["aria-checked"], hW = { class: "ps-level-text" }, pW = ["aria-checked", "disabled"], fW = { class: "ps-level-text" }, mW = ["aria-checked", "disabled"], gW = { class: "ps-level-text" }, bW = { class: "ps-field" }, vW = { class: "ps-cats" }, yW = ["onClick"], xW = { class: "ps-field" }, wW = { class: "ps-field" }, kW = { class: "pl-pills" }, _W = { class: "pl-pill" }, SW = { class: "pl-pill is-quiet" }, MW = {
  key: 0,
  class: "ps-check",
  "data-testid": "save-inputs"
}, TW = { class: "ps-thumbs" }, CW = {
  key: 0,
  class: "ps-dup",
  "data-testid": "save-duplicate"
}, IW = ["disabled"], AW = { class: "ps-foot" }, PW = ["disabled"], nS = /* @__PURE__ */ Pe({
  __name: "SavePromptSheet",
  props: {
    draft: {},
    editingId: {}
  },
  emits: ["done", "cancel"],
  setup(i, { emit: e }) {
    const t = i, n = e, { board: s } = Ze(), o = s.promptLibrary, r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), { more: l, measure: d } = tS(a), c = /* @__PURE__ */ K(t.draft.name), h = /* @__PURE__ */ K(!1), f = /* @__PURE__ */ K(t.draft.category), p = /* @__PURE__ */ K(""), y = /* @__PURE__ */ K(t.draft.prompt), v = /* @__PURE__ */ K(!0), x = { levels: o.levelsFor(t.draft), boardId: t.draft.boardId, teamId: t.draft.teamId, companyId: t.draft.companyId }, w = /* @__PURE__ */ Xt({ ...x.levels }), S = I(() => !w.board && Z8(t.draft, s.meta.id)), M = /* @__PURE__ */ K(!1), _ = I(() => o.team.value), T = I(() => o.company()), k = I(() => o.managesTeam() || !!t.editingId && x.levels.team), P = I(() => o.managesCompany() || !!t.editingId && x.levels.company), A = I(() => w.team && k.value), R = I(() => w.company && P.value), D = I(() => s.labels.team), O = I(() => s.meta.title || "this board"), F = I(() => !!s.meta.teamId), te = I(() => {
      o.myPrompts.counts.value, o.mine.value;
      const de = o.mineCategories();
      return t.draft.category && !de.includes(t.draft.category) ? [t.draft.category].concat(de) : de;
    }), ee = I(() => p.value.trim() || f.value), me = I(() => s.catalog.value.byId.get(t.draft.tool.nodeDefId) || null), L = I(() => KV(me.value)), N = I(() => y.value.length > L.value), X = I(() => !!c.value.trim() && !!y.value.trim() && !N.value && !M.value), B = I(() => _.value && _.value.name ? "Everyone in " + _.value.name : "Everyone in your " + D.value), se = I(() => "Only people who manage " + (_.value && _.value.name ? _.value.name + "'s" : "your " + D.value + "'s") + " prompts can share here"), V = I(() => T.value && T.value.name ? "Everyone at " + T.value.name : "Everyone in your company"), Z = I(() => "Only people who manage " + (T.value && T.value.name ? T.value.name + "'s" : "your company's") + " prompts can share here"), Y = I(() => S.value ? "On another board now: turn this on to move it here" : F.value ? "Everyone who can open this board" : "Only you can open this board"), H = I(() => {
      const de = w.board ? O.value : S.value ? "the board it's filed on" : "";
      return R.value && T.value ? V.value + (de ? ", and kept with " + de : "") : A.value && _.value ? B.value + (de ? ", and kept with " + de : "") : w.board ? F.value ? "Everyone who can open " + O.value : "Kept with " + O.value + ", which only you can open" : S.value ? "Everyone who can open the board it's filed on" : "Only you, on every board";
    }), re = /* @__PURE__ */ K(null);
    let le = 0, he = null;
    function Re() {
      const de = ++le;
      o.duplicateFor(y.value, t.draft.tool.nodeDefId, t.editingId).then((pe) => {
        de === le && (re.value = pe);
      }).catch(() => {
        de === le && (re.value = null);
      });
    }
    Ae(y, () => {
      he && clearTimeout(he), he = setTimeout(Re, 300);
    });
    function Ne() {
      const de = v.value ? t.draft.inputs : [], pe = v.value ? t.draft.values : YV(me.value, t.draft.values);
      return o.withLevels({
        ...t.draft,
        name: c.value.trim(),
        category: ee.value,
        prompt: y.value,
        inputs: de,
        mode: yu(de.length),
        values: pe
      }, { board: w.board, team: A.value, company: R.value }, x);
    }
    async function Me() {
      if (!X.value) return;
      M.value = !0;
      const de = await o.save(Ne(), t.editingId);
      M.value = !1, de && n("done", de);
    }
    async function ue() {
      const de = re.value;
      if (!de || M.value) return;
      M.value = !0;
      const pe = await o.save({ ...Ne(), name: de.name, category: de.category, boardId: de.boardId, teamId: de.teamId, companyId: de.companyId }, de.id);
      M.value = !1, pe && n("done", pe);
    }
    function U(de) {
      de.stopPropagation(), de.key === "Escape" ? (de.preventDefault(), n("cancel")) : de.key === "Enter" && kn(de) && (de.preventDefault(), Me());
    }
    function q() {
      if (t.editingId) return;
      const de = c.value;
      o.freshNameFor(de).then((pe) => {
        h.value || M.value || c.value !== de || pe === de || (c.value = pe, nt(() => {
          r.value && document.activeElement === r.value && r.value.select();
        }));
      }).catch(() => {
      });
    }
    function ie(de) {
      f.value = f.value === de && !p.value ? "" : de, p.value = "";
    }
    return We(() => {
      he && clearTimeout(he), le++;
    }), ot(() => {
      o.startMine(), q(), Re(), nt(() => {
        const de = r.value;
        de && (de.focus({ preventScroll: !0 }), de.select());
      });
    }), (de, pe) => (g(), b("form", {
      class: "ps",
      "data-testid": "save-prompt",
      onSubmit: Se(Me, ["prevent"]),
      onKeydown: U,
      onPointerdown: pe[10] || (pe[10] = Se(() => {
      }, ["stop"]))
    }, [
      u("header", sW, [
        u("span", oW, [
          C($, {
            name: "Bookmark",
            size: 15
          })
        ]),
        u("span", rW, [
          u("b", null, E(i.editingId ? "Edit prompt" : "Save to the prompt library"), 1),
          u("em", null, E(i.editingId ? "Changes reach everyone it's shared with." : "Keep it for any board, or share it."), 1)
        ])
      ]),
      u("div", {
        ref_key: "bodyEl",
        ref: a,
        class: G(["ps-body", { "is-more": m(l) }]),
        onScrollPassive: pe[8] || (pe[8] = //@ts-ignore
        (...Te) => m(d) && m(d)(...Te))
      }, [
        u("label", aW, [
          pe[11] || (pe[11] = u("span", { class: "pl-label" }, "Name", -1)),
          kt(u("input", {
            ref_key: "nameEl",
            ref: r,
            "onUpdate:modelValue": pe[0] || (pe[0] = (Te) => c.value = Te),
            class: "ps-input",
            maxlength: "80",
            placeholder: "Name this prompt",
            "data-testid": "save-name",
            onInput: pe[1] || (pe[1] = (Te) => h.value = !0)
          }, null, 544), [
            [Zt, c.value]
          ])
        ]),
        u("div", lW, [
          pe[17] || (pe[17] = u("span", { class: "pl-label" }, "Who can use it", -1)),
          u("p", dW, [
            C($, {
              name: w.board || A.value || R.value || S.value ? "Users" : "Lock",
              size: 12
            }, null, 8, ["name"]),
            J(E(H.value), 1)
          ]),
          u("div", cW, [
            u("button", {
              type: "button",
              class: G(["ps-level", { on: w.board }]),
              role: "switch",
              "aria-checked": w.board,
              "data-testid": "level-board",
              onClick: pe[2] || (pe[2] = (Te) => w.board = !w.board)
            }, [
              C($, {
                name: "LayoutGrid",
                size: 14
              }),
              u("span", hW, [
                pe[12] || (pe[12] = u("b", null, "This board", -1)),
                u("em", null, E(Y.value), 1)
              ]),
              pe[13] || (pe[13] = u("span", { class: "ps-switch" }, null, -1))
            ], 10, uW),
            _.value ? (g(), b("button", {
              key: 0,
              type: "button",
              class: G(["ps-level", { on: A.value, "is-off": !k.value }]),
              role: "switch",
              "aria-checked": A.value,
              disabled: !k.value,
              "data-testid": "level-team",
              onClick: pe[3] || (pe[3] = (Te) => w.team = !w.team)
            }, [
              C($, {
                name: "Users",
                size: 14
              }),
              u("span", fW, [
                u("b", null, E(m(xv)(D.value)), 1),
                u("em", null, E(k.value ? B.value : se.value), 1)
              ]),
              pe[14] || (pe[14] = u("span", { class: "ps-switch" }, null, -1))
            ], 10, pW)) : z("", !0),
            T.value ? (g(), b("button", {
              key: 1,
              type: "button",
              class: G(["ps-level", { on: R.value, "is-off": !P.value }]),
              role: "switch",
              "aria-checked": R.value,
              disabled: !P.value,
              "data-testid": "level-company",
              onClick: pe[4] || (pe[4] = (Te) => w.company = !w.company)
            }, [
              C($, {
                name: "Building2",
                size: 14
              }),
              u("span", gW, [
                pe[15] || (pe[15] = u("b", null, "Company", -1)),
                u("em", null, E(P.value ? V.value : Z.value), 1)
              ]),
              pe[16] || (pe[16] = u("span", { class: "ps-switch" }, null, -1))
            ], 10, mW)) : z("", !0)
          ])
        ]),
        u("div", bW, [
          pe[18] || (pe[18] = u("span", { class: "pl-label" }, "Category", -1)),
          u("div", vW, [
            (g(!0), b(j, null, be(te.value, (Te) => (g(), b("button", {
              key: Te,
              type: "button",
              class: G(["pl-chip", { on: !p.value.trim() && f.value === Te }]),
              onClick: (Be) => ie(Te)
            }, E(Te), 11, yW))), 128)),
            kt(u("input", {
              "onUpdate:modelValue": pe[5] || (pe[5] = (Te) => p.value = Te),
              class: "ps-input is-chip",
              maxlength: "40",
              placeholder: "New category",
              "data-testid": "save-new-category"
            }, null, 512), [
              [Zt, p.value]
            ])
          ])
        ]),
        u("label", xW, [
          pe[19] || (pe[19] = u("span", { class: "pl-label" }, "Prompt", -1)),
          kt(u("textarea", {
            "onUpdate:modelValue": pe[6] || (pe[6] = (Te) => y.value = Te),
            class: "ps-input ps-text",
            rows: "5",
            "data-testid": "save-prompt-text"
          }, null, 512), [
            [Zt, y.value]
          ]),
          u("span", {
            class: G(["ps-hint", { "is-bad": N.value }])
          }, E(N.value ? y.value.length.toLocaleString() + " characters: " + (i.draft.tool.name || "its tool") + " takes up to " + L.value.toLocaleString() + "." : "Edit it to take out anything only this project needs."), 3)
        ]),
        u("div", wW, [
          pe[21] || (pe[21] = u("span", { class: "pl-label" }, "Comes with", -1)),
          u("div", kW, [
            u("span", _W, [
              C($, {
                name: "Sparkles",
                size: 12
              }),
              J(E(i.draft.tool.name || "Its tool"), 1)
            ]),
            u("span", SW, [
              C($, {
                name: "Settings2",
                size: 12
              }),
              pe[20] || (pe[20] = J("Its settings", -1))
            ])
          ]),
          i.draft.inputs.length ? (g(), b("label", MW, [
            kt(u("input", {
              "onUpdate:modelValue": pe[7] || (pe[7] = (Te) => v.value = Te),
              type: "checkbox"
            }, null, 512), [
              [ol, v.value]
            ]),
            u("span", null, "Its " + E(i.draft.inputs.length === 1 ? "input image" : i.draft.inputs.length + " input images"), 1),
            u("span", TW, [
              (g(!0), b(j, null, be(i.draft.inputs.slice(0, 5), (Te, Be) => (g(), b("span", {
                key: Be,
                style: ce({ backgroundImage: 'url("' + m(Bt)(Te.url) + '")' })
              }, null, 4))), 128))
            ])
          ])) : z("", !0)
        ]),
        re.value ? (g(), b("p", CW, [
          C($, {
            name: "Info",
            size: 12
          }),
          u("span", null, "You saved this prompt before as “" + E(re.value.name) + "”.", 1),
          u("button", {
            type: "button",
            class: "ps-link",
            disabled: M.value,
            onClick: ue
          }, "Update that one instead", 8, IW)
        ])) : z("", !0)
      ], 34),
      u("footer", AW, [
        u("button", {
          type: "submit",
          class: "pl-cta",
          disabled: !X.value,
          "data-testid": "save-submit"
        }, E(M.value ? "Saving…" : i.editingId ? "Save changes" : "Save prompt"), 9, PW),
        u("button", {
          type: "button",
          class: "pl-btn is-glass is-lg",
          "data-testid": "save-cancel",
          onClick: pe[9] || (pe[9] = (Te) => n("cancel"))
        }, "Cancel")
      ])
    ], 32));
  }
}), EW = "Bonneville Tower", RW = { team: [{ initials: "KB", name: "Kira Bennett" }, { initials: "JR", name: "Jonah Reyes" }, { initials: "MT", name: "Mei Tanaka" }] }, zW = /* @__PURE__ */ JSON.parse('[{"id":"f1","type":"frame","x":200,"y":200,"w":1400,"h":548,"title":"Site photos","z":0},{"id":"f2","type":"frame","x":1720,"y":200,"w":1400,"h":626,"title":"Massing sketches","z":1},{"id":"f3","type":"frame","x":3240,"y":200,"w":1400,"h":389,"title":"Site plans & analysis","z":2},{"id":"f4","type":"frame","x":4760,"y":200,"w":1400,"h":575,"title":"White card models","z":3},{"id":"f5","type":"frame","x":200,"y":858,"w":1400,"h":573,"title":"Direction renders","z":4},{"id":"f6","type":"frame","x":1720,"y":936,"w":1400,"h":997,"title":"Bench Gardens","z":5},{"id":"f7","type":"frame","x":3240,"y":699,"w":1400,"h":575,"title":"Hero options","z":6},{"id":"f8","type":"frame","x":4760,"y":885,"w":1400,"h":1473,"title":"Facade iterations","z":7},{"id":"f9","type":"frame","x":200,"y":1541,"w":1400,"h":1075,"title":"Material studies","z":8},{"id":"f10","type":"frame","x":1720,"y":2043,"w":1400,"h":650,"title":"Lobby","z":9},{"id":"f11","type":"frame","x":3240,"y":1384,"w":1400,"h":532,"title":"Sky lounge","z":10},{"id":"f12","type":"frame","x":4760,"y":2468,"w":1400,"h":1022,"title":"Camera set","z":11},{"id":"f13","type":"frame","x":200,"y":2726,"w":1400,"h":600,"title":"Corner residence","z":12},{"id":"f14","type":"frame","x":1720,"y":2803,"w":1400,"h":1473,"title":"Seasons & light","z":13},{"id":"f15","type":"frame","x":3240,"y":2026,"w":1400,"h":530,"title":"Masterplan views","z":14},{"id":"f16","type":"frame","x":4760,"y":3600,"w":1400,"h":1473,"title":"Motion","z":15},{"id":"f17","type":"frame","x":200,"y":3436,"w":1400,"h":575,"title":"Print upscales","z":16},{"id":"b1","type":"tool","x":244,"y":296,"name":"Site photos","kind":"Image","model":"Nano Banana 2","icon":"Map","count":3,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s01-existing-site-aerial-f3aa4c-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s02-existing-depot-street-7c94e0-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s03-existing-buried-creek-channel-160598-800w.webp"],"z":17},{"id":"n11","type":"note","x":244,"y":492,"w":184,"h":184,"tint":"amethyst","text":"Site walk done. The buried creek is the opportunity.","author":"KB","z":18},{"id":"x1","type":"image","x":540,"y":296,"w":316,"h":176,"label":"existing_site_aerial","tid":"s01","z":19,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s01-existing-site-aerial-f3aa4c-800w.webp","pw":800,"ph":447},{"id":"x2","type":"image","x":882,"y":304,"w":316,"h":176,"label":"existing_depot_street","tid":"s02","z":20,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s02-existing-depot-street-7c94e0-800w.webp","pw":800,"ph":447},{"id":"x3","type":"image","x":1224,"y":292,"w":316,"h":176,"label":"existing_buried_creek_ch","tid":"s03","z":21,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s03-existing-buried-creek-channel-160598-800w.webp","pw":800,"ph":447},{"id":"b2","type":"tool","x":1764,"y":296,"name":"Massing sketches","kind":"Image","model":"Nano Banana 2","icon":"Building2","count":3,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e02-option-b-sketch-canyon-374663-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e03-option-c-sketch-salt-11df63-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e01-option-a-sketch-shoreline-c101a0-800w.webp"],"z":22},{"id":"x4","type":"image","x":2060,"y":296,"w":316,"h":423,"label":"option_b_sketch_canyon","tid":"e02","z":23,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e02-option-b-sketch-canyon-374663-800w.webp","pw":800,"ph":1071},{"id":"x5","type":"image","x":2402,"y":304,"w":316,"h":421,"label":"option_c_sketch_salt","tid":"e03","z":24,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e03-option-c-sketch-salt-11df63-800w.webp","pw":800,"ph":1067},{"id":"x6","type":"image","x":2744,"y":292,"w":316,"h":474,"label":"option_a_sketch_shorelin","tid":"e01","z":25,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e01-option-a-sketch-shoreline-c101a0-800w.webp","pw":800,"ph":1200},{"id":"b3","type":"tool","x":3284,"y":296,"name":"Site plans","kind":"Image","model":"ChatGPT Image 2","icon":"Map","count":2,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s04-existing-site-plan-ee31f8-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s05-concept-drivers-board-25e1a7-800w.webp"],"z":26},{"id":"x7","type":"image","x":3580,"y":296,"w":316,"h":237,"label":"existing_site_plan","tid":"s04","z":27,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s04-existing-site-plan-ee31f8-800w.webp","pw":800,"ph":600},{"id":"x8","type":"image","x":3922,"y":304,"w":316,"h":178,"label":"concept_drivers_board","tid":"s05","z":28,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s05-concept-drivers-board-25e1a7-800w.webp","pw":800,"ph":450},{"id":"b4","type":"tool","x":4804,"y":296,"name":"White card","kind":"Image","model":"Seedream 5 Lite","icon":"Building2","count":2,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e04-white-card-options-a-b-c-1713cd-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e05-option-a-white-card-model-c61989-800w.webp"],"z":29},{"id":"n41","type":"note","x":4804,"y":492,"w":184,"h":184,"tint":"amethyst","text":"Client leaning A. The shorelines story lands.","author":"JR","z":30},{"id":"x9","type":"image","x":5100,"y":296,"w":316,"h":178,"label":"white_card_options_a_b_c","tid":"e04","z":31,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e04-white-card-options-a-b-c-1713cd-800w.webp","pw":800,"ph":450},{"id":"x10","type":"image","x":5442,"y":304,"w":316,"h":423,"label":"option_a_white_card_mode","tid":"e05","z":32,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e05-option-a-white-card-model-c61989-800w.webp","pw":800,"ph":1071},{"id":"b5","type":"tool","x":244,"y":954,"name":"Direction renders","kind":"Image","model":"ChatGPT Image 2","icon":"Building2","count":3,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e06-option-b-render-parked-80d4c0-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e07-option-c-render-parked-e0c191-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e08-option-a-watercolor-db5917-800w.webp"],"z":33},{"id":"x11","type":"image","x":540,"y":954,"w":316,"h":421,"label":"option_b_render_parked","tid":"e06","z":34,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e06-option-b-render-parked-80d4c0-800w.webp","pw":800,"ph":1067},{"id":"x12","type":"image","x":882,"y":962,"w":316,"h":421,"label":"option_c_render_parked","tid":"e07","z":35,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e07-option-c-render-parked-e0c191-800w.webp","pw":800,"ph":1067},{"id":"x13","type":"image","x":1224,"y":950,"w":316,"h":421,"label":"option_a_watercolor","tid":"e08","z":36,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e08-option-a-watercolor-db5917-800w.webp","pw":800,"ph":1067},{"id":"b6","type":"tool","x":1764,"y":1032,"name":"Bench Gardens","kind":"Image","model":"Nano Banana 2","icon":"Trees","count":12,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l01-rendered-landscape-masterplan-0b3979-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l02-watercolor-masterplan-6b0e55-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l09-greener-depot-street-a56204-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l03-creek-walk-engine-export-d0559e-800w.webp"],"z":37},{"id":"x14","type":"image","x":2060,"y":1032,"w":316,"h":237,"label":"rendered_landscape_maste","tid":"l01","z":38,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l01-rendered-landscape-masterplan-0b3979-800w.webp","pw":800,"ph":600},{"id":"x15","type":"image","x":2402,"y":1040,"w":316,"h":237,"label":"watercolor_masterplan","tid":"l02","z":39,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l02-watercolor-masterplan-6b0e55-800w.webp","pw":800,"ph":600},{"id":"x16","type":"image","x":2744,"y":1028,"w":316,"h":176,"label":"greener_depot_street","tid":"l09","z":40,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l09-greener-depot-street-a56204-800w.webp","pw":800,"ph":447},{"id":"x17","type":"image","x":2060,"y":1295,"w":316,"h":178,"label":"creek_walk_engine_export","tid":"l03","z":41,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l03-creek-walk-engine-export-d0559e-800w.webp","pw":800,"ph":450},{"id":"x18","type":"image","x":2402,"y":1303,"w":316,"h":176,"label":"creek_walk_marketing_her","tid":"l04","fav":true,"z":42,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l04-creek-walk-marketing-hero-92d17d-800w.webp","pw":800,"ph":447},{"id":"x19","type":"image","x":2744,"y":1291,"w":316,"h":176,"label":"swap_trees_to_gambel_oak","tid":"l05","z":43,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l05-swap-trees-to-gambel-oak-2f2873-800w.webp","pw":800,"ph":447},{"id":"x20","type":"image","x":2060,"y":1499,"w":316,"h":176,"label":"markup_benches_and_overl","tid":"l06","z":44,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l06-markup-benches-and-overlook-11b969-800w.webp","pw":800,"ph":447},{"id":"x21","type":"image","x":2402,"y":1507,"w":316,"h":176,"label":"benches_and_overlook_add","tid":"l07","z":45,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l07-benches-and-overlook-added-ca8f6c-800w.webp","pw":800,"ph":447},{"id":"x22","type":"image","x":2744,"y":1495,"w":316,"h":176,"label":"level_24_terrace_empty","tid":"l10","z":46,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l10-level-24-terrace-empty-788189-800w.webp","pw":800,"ph":447},{"id":"x23","type":"image","x":2060,"y":1701,"w":316,"h":176,"label":"terrace_built_in_seating","tid":"l11","z":47,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l11-terrace-built-in-seating-56f47f-800w.webp","pw":800,"ph":447},{"id":"x24","type":"image","x":2402,"y":1709,"w":316,"h":176,"label":"taller_planters_trailing","tid":"l12","z":48,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l12-taller-planters-trailing-plants-0310f9-800w.webp","pw":800,"ph":447},{"id":"x25","type":"image","x":2744,"y":1697,"w":316,"h":176,"label":"daytime_gardens_with_peo","tid":"l08","fav":true,"z":49,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l08-daytime-gardens-with-people-8fb7f2-800w.webp","pw":800,"ph":447},{"id":"b7","type":"tool","x":3284,"y":795,"name":"Hero options","kind":"Image","model":"Nano Banana Pro","icon":"Building2","count":2,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e09-hero-v1-model-to-photo-0725c1-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e21-hero-as-fine-pen-colour-sketch-92581b-800w.webp"],"z":50},{"id":"n71","type":"note","x":3284,"y":991,"w":184,"h":184,"tint":"amethyst","text":"Client review Thursday. Pick two for the cover spread.","author":"JR","z":51},{"id":"x26","type":"image","x":3580,"y":795,"w":316,"h":423,"label":"hero_v1_model_to_photo","tid":"e09","fav":true,"z":52,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e09-hero-v1-model-to-photo-0725c1-800w.webp","pw":800,"ph":1071},{"id":"x27","type":"image","x":3922,"y":803,"w":316,"h":423,"label":"hero_as_fine_pen_colour_","tid":"e21","z":53,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e21-hero-as-fine-pen-colour-sketch-92581b-800w.webp","pw":800,"ph":1071},{"id":"b8","type":"tool","x":4804,"y":981,"name":"Facade iterations","kind":"Image","model":"Nano Banana 2","icon":"Building2","count":7,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e10-hero-v2-open-crown-4a3b4d-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e11-markup-terraces-8b641f-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e12-hero-v3-deeper-terraces-1c4ede-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e13-markup-crown-louvres-c1ed86-800w.webp"],"z":54},{"id":"n81","type":"note","x":4804,"y":1177,"w":184,"h":184,"tint":"vista","text":"Crown feels heavy. Open it up.","author":"JR","z":55},{"id":"n82","type":"note","x":4804,"y":1377,"w":184,"h":184,"tint":"glass","text":"Plum crown? Fun, but reads Vegas. Staying sandstone.","author":"MT","z":56},{"id":"x28","type":"image","x":5100,"y":981,"w":316,"h":423,"label":"hero_v2_open_crown","tid":"e10","z":57,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e10-hero-v2-open-crown-4a3b4d-800w.webp","pw":800,"ph":1071},{"id":"x29","type":"image","x":5442,"y":989,"w":316,"h":423,"label":"markup_terraces","tid":"e11","z":58,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e11-markup-terraces-8b641f-800w.webp","pw":800,"ph":1071},{"id":"x30","type":"image","x":5784,"y":977,"w":316,"h":423,"label":"hero_v3_deeper_terraces","tid":"e12","z":59,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e12-hero-v3-deeper-terraces-1c4ede-800w.webp","pw":800,"ph":1071},{"id":"x31","type":"image","x":5100,"y":1430,"w":316,"h":423,"label":"markup_crown_louvres","tid":"e13","z":60,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e13-markup-crown-louvres-c1ed86-800w.webp","pw":800,"ph":1071},{"id":"x32","type":"image","x":5442,"y":1438,"w":316,"h":423,"label":"option_plum_crown_reject","tid":"e14","z":61,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e14-option-plum-crown-rejected-0a7466-800w.webp","pw":800,"ph":1071},{"id":"x33","type":"image","x":5784,"y":1426,"w":316,"h":423,"label":"hero_v4_brick_podium","tid":"e15","fav":true,"z":62,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp","pw":800,"ph":1071},{"id":"x34","type":"image","x":5100,"y":1879,"w":316,"h":423,"label":"option_east_face_balconi","tid":"e23","z":63,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e23-option-east-face-balconies-21b33e-800w.webp","pw":800,"ph":1071},{"id":"b9","type":"tool","x":244,"y":1637,"name":"Material studies","kind":"Image","model":"Nano Banana 2","icon":"Layers","count":8,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m01-material-sample-flat-lay-2f160f-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m05-lobby-floor-red-rock-terrazzo-5379b6-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m06-match-paving-to-the-benches-f8aac0-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m02-louvre-option-oxide-red-3b9834-800w.webp"],"z":64},{"id":"n91","type":"note","x":244,"y":1833,"w":184,"h":184,"tint":"glass","text":"Try oxide red on the west face?","author":"MT","z":65},{"id":"x35","type":"image","x":540,"y":1637,"w":316,"h":237,"label":"material_sample_flat_lay","tid":"m01","z":66,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m01-material-sample-flat-lay-2f160f-800w.webp","pw":800,"ph":600},{"id":"x36","type":"image","x":882,"y":1645,"w":316,"h":236,"label":"lobby_floor_red_rock_ter","tid":"m05","z":67,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m05-lobby-floor-red-rock-terrazzo-5379b6-800w.webp","pw":800,"ph":597},{"id":"x37","type":"image","x":1224,"y":1633,"w":316,"h":176,"label":"match_paving_to_the_benc","tid":"m06","z":68,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m06-match-paving-to-the-benches-f8aac0-800w.webp","pw":800,"ph":447},{"id":"x38","type":"image","x":540,"y":1900,"w":316,"h":423,"label":"louvre_option_oxide_red","tid":"m02","z":69,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m02-louvre-option-oxide-red-3b9834-800w.webp","pw":800,"ph":1071},{"id":"x39","type":"image","x":882,"y":1908,"w":316,"h":423,"label":"louvre_option_pale_limes","tid":"m03","z":70,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m03-louvre-option-pale-limestone-b2566c-800w.webp","pw":800,"ph":1071},{"id":"x40","type":"image","x":1224,"y":1896,"w":316,"h":176,"label":"local_sandstone_podium_a","tid":"m04","z":71,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m04-local-sandstone-podium-and-walls-34452a-800w.webp","pw":800,"ph":447},{"id":"x41","type":"image","x":540,"y":2349,"w":316,"h":211,"label":"residence_palette_from_r","tid":"m07","z":72,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m07-residence-palette-from-reference-371621-800w.webp","pw":800,"ph":534},{"id":"x42","type":"image","x":882,"y":2357,"w":316,"h":211,"label":"island_countertop_and_re","tid":"m08","z":73,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m08-island-countertop-and-render-polish-c79356-800w.webp","pw":800,"ph":534},{"id":"b10","type":"tool","x":1764,"y":2139,"name":"Lobby","kind":"Image","model":"Nano Banana 2","icon":"Sofa","count":6,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i01-lobby-white-model-d9fd93-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i02-lobby-v1-geometry-materials-ef49f9-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i03-lobby-v2-artwork-sconces-7284ac-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i04-markup-longer-desk-260c81-800w.webp"],"z":74},{"id":"n101","type":"note","x":1764,"y":2335,"w":184,"h":184,"tint":"amethyst","text":"Desk needs to be twice as long. Marked it up.","author":"KB","z":75},{"id":"x43","type":"image","x":2060,"y":2139,"w":316,"h":178,"label":"lobby_white_model","tid":"i01","z":76,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i01-lobby-white-model-d9fd93-800w.webp","pw":800,"ph":450},{"id":"x44","type":"image","x":2402,"y":2147,"w":316,"h":236,"label":"lobby_v1_geometry_materi","tid":"i02","z":77,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i02-lobby-v1-geometry-materials-ef49f9-800w.webp","pw":800,"ph":597},{"id":"x45","type":"image","x":2744,"y":2135,"w":316,"h":236,"label":"lobby_v2_artwork_sconces","tid":"i03","z":78,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i03-lobby-v2-artwork-sconces-7284ac-800w.webp","pw":800,"ph":597},{"id":"x46","type":"image","x":2060,"y":2401,"w":316,"h":236,"label":"markup_longer_desk","tid":"i04","z":79,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i04-markup-longer-desk-260c81-800w.webp","pw":800,"ph":597},{"id":"x47","type":"image","x":2402,"y":2409,"w":316,"h":236,"label":"lobby_v3_stone_desk_plac","tid":"i05","z":80,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i05-lobby-v3-stone-desk-placed-c250ca-800w.webp","pw":800,"ph":597},{"id":"x48","type":"image","x":2744,"y":2397,"w":316,"h":236,"label":"lobby_v4_competition_bri","tid":"i06","fav":true,"z":81,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i06-lobby-v4-competition-brightening-34918a-800w.webp","pw":800,"ph":597},{"id":"b11","type":"tool","x":3284,"y":1480,"name":"Sky lounge","kind":"Image","model":"Nano Banana 2","icon":"Sofa","count":5,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i07-sky-lounge-engine-export-f60a11-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i08-sky-lounge-engine-to-photo-a7f5c1-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i09-sky-lounge-staged-from-reference-8b3de4-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i10-sky-lounge-borrow-evening-light-667177-800w.webp"],"z":82},{"id":"x49","type":"image","x":3580,"y":1480,"w":316,"h":178,"label":"sky_lounge_engine_export","tid":"i07","z":83,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i07-sky-lounge-engine-export-f60a11-800w.webp","pw":800,"ph":450},{"id":"x50","type":"image","x":3922,"y":1488,"w":316,"h":178,"label":"sky_lounge_engine_to_pho","tid":"i08","z":84,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i08-sky-lounge-engine-to-photo-a7f5c1-800w.webp","pw":800,"ph":450},{"id":"x51","type":"image","x":4264,"y":1476,"w":316,"h":176,"label":"sky_lounge_staged_from_r","tid":"i09","z":85,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i09-sky-lounge-staged-from-reference-8b3de4-800w.webp","pw":800,"ph":447},{"id":"x52","type":"image","x":3580,"y":1684,"w":316,"h":176,"label":"sky_lounge_borrow_evenin","tid":"i10","z":86,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i10-sky-lounge-borrow-evening-light-667177-800w.webp","pw":800,"ph":447},{"id":"x53","type":"image","x":3922,"y":1692,"w":316,"h":176,"label":"sky_lounge_evening_gathe","tid":"i11","fav":true,"z":87,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i11-sky-lounge-evening-gathering-b786e8-800w.webp","pw":800,"ph":447},{"id":"b12","type":"tool","x":4804,"y":2564,"name":"Camera set","kind":"Image","model":"Nano Banana 2","icon":"Building2","count":5,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e16-raise-camera-reveal-the-gardens-4fe978-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e17-top-down-drone-over-the-crown-87d397-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e18-terrace-edge-detail-with-bokeh-d096d7-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e19-cutaway-axonometric-22df20-800w.webp"],"z":88},{"id":"x54","type":"image","x":5100,"y":2564,"w":316,"h":176,"label":"raise_camera_reveal_the_","tid":"e16","z":89,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e16-raise-camera-reveal-the-gardens-4fe978-800w.webp","pw":800,"ph":447},{"id":"x55","type":"image","x":5442,"y":2572,"w":316,"h":316,"label":"top_down_drone_over_the_","tid":"e17","z":90,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e17-top-down-drone-over-the-crown-87d397-800w.webp","pw":800,"ph":800},{"id":"x56","type":"image","x":5784,"y":2560,"w":316,"h":423,"label":"terrace_edge_detail_with","tid":"e18","z":91,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e18-terrace-edge-detail-with-bokeh-d096d7-800w.webp","pw":800,"ph":1071},{"id":"x57","type":"image","x":5100,"y":3013,"w":316,"h":421,"label":"cutaway_axonometric","tid":"e19","z":92,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e19-cutaway-axonometric-22df20-800w.webp","pw":800,"ph":1067},{"id":"x58","type":"image","x":5442,"y":3021,"w":316,"h":176,"label":"lunchtime_people_in_the_","tid":"e20","z":93,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e20-lunchtime-people-in-the-gardens-280901-800w.webp","pw":800,"ph":447},{"id":"b13","type":"tool","x":244,"y":2822,"name":"Corner residence","kind":"Image","model":"Nano Banana 2","icon":"Sofa","count":4,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i12-corner-residence-sketch-400d0d-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i13-residence-sketch-to-render-7d94bc-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i14-residence-curated-styling-f59e05-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i15-residence-winter-view-2b49f6-800w.webp"],"z":94},{"id":"x59","type":"image","x":540,"y":2822,"w":316,"h":211,"label":"corner_residence_sketch","tid":"i12","z":95,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i12-corner-residence-sketch-400d0d-800w.webp","pw":800,"ph":533},{"id":"x60","type":"image","x":882,"y":2830,"w":316,"h":211,"label":"residence_sketch_to_rend","tid":"i13","z":96,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i13-residence-sketch-to-render-7d94bc-800w.webp","pw":800,"ph":534},{"id":"x61","type":"image","x":1224,"y":2818,"w":316,"h":211,"label":"residence_curated_stylin","tid":"i14","z":97,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i14-residence-curated-styling-f59e05-800w.webp","pw":800,"ph":534},{"id":"x62","type":"image","x":540,"y":3059,"w":316,"h":211,"label":"residence_winter_view","tid":"i15","z":98,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i15-residence-winter-view-2b49f6-800w.webp","pw":800,"ph":534},{"id":"b14","type":"tool","x":1764,"y":2899,"name":"Seasons & light","kind":"Image","model":"Nano Banana 2","icon":"Sun","count":8,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t02-summer-monsoon-afternoon-8923fc-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t07-alpenglow-dusk-1d0baa-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t01-spring-noon-3be8a4-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t03-autumn-golden-hour-3768d6-800w.webp"],"z":99},{"id":"n141","type":"note","x":1764,"y":3095,"w":184,"h":184,"tint":"vista","text":"Winter set is for the ski-season brochure.","author":"MT","z":100},{"id":"x63","type":"image","x":2060,"y":2899,"w":316,"h":423,"label":"summer_monsoon_afternoon","tid":"t02","z":101,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t02-summer-monsoon-afternoon-8923fc-800w.webp","pw":800,"ph":1071},{"id":"x64","type":"image","x":2402,"y":2907,"w":316,"h":423,"label":"alpenglow_dusk","tid":"t07","fav":true,"z":102,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t07-alpenglow-dusk-1d0baa-800w.webp","pw":800,"ph":1071},{"id":"x65","type":"image","x":2744,"y":2895,"w":316,"h":423,"label":"spring_noon","tid":"t01","z":103,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t01-spring-noon-3be8a4-800w.webp","pw":800,"ph":1071},{"id":"x66","type":"image","x":2060,"y":3348,"w":316,"h":423,"label":"autumn_golden_hour","tid":"t03","z":104,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t03-autumn-golden-hour-3768d6-800w.webp","pw":800,"ph":1071},{"id":"x67","type":"image","x":2402,"y":3356,"w":316,"h":423,"label":"winter_inversion_haze","tid":"t05","z":105,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t05-winter-inversion-haze-c734b0-800w.webp","pw":800,"ph":1071},{"id":"x68","type":"image","x":2744,"y":3344,"w":316,"h":423,"label":"winter_blue_hour","tid":"t04","fav":true,"z":106,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t04-winter-blue-hour-50f063-800w.webp","pw":800,"ph":1071},{"id":"x69","type":"image","x":2060,"y":3797,"w":316,"h":423,"label":"night_facade_lighting","tid":"t06","z":107,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t06-night-facade-lighting-69ccb0-800w.webp","pw":800,"ph":1071},{"id":"x70","type":"image","x":2402,"y":3805,"w":316,"h":423,"label":"soft_glow_behind_glazing","tid":"t08","z":108,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t08-soft-glow-behind-glazing-6fc036-800w.webp","pw":800,"ph":1071},{"id":"b15","type":"tool","x":3284,"y":2122,"name":"Masterplan views","kind":"Image","model":"Nano Banana Pro","icon":"Map","count":4,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s06-masterplan-aerial-55b63e-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s09-masterplan-twilight-glow-1694c9-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s07-markup-eye-level-camera-spot-e6cfa2-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s08-eye-level-view-from-site-markup-96d820-800w.webp"],"z":109},{"id":"x71","type":"image","x":3580,"y":2122,"w":316,"h":176,"label":"masterplan_aerial","tid":"s06","fav":true,"z":110,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s06-masterplan-aerial-55b63e-800w.webp","pw":800,"ph":447},{"id":"x72","type":"image","x":3922,"y":2130,"w":316,"h":176,"label":"masterplan_twilight_glow","tid":"s09","z":111,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s09-masterplan-twilight-glow-1694c9-800w.webp","pw":800,"ph":447},{"id":"x73","type":"image","x":4264,"y":2118,"w":316,"h":176,"label":"markup_eye_level_camera_","tid":"s07","z":112,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s07-markup-eye-level-camera-spot-e6cfa2-800w.webp","pw":800,"ph":447},{"id":"x74","type":"image","x":3580,"y":2324,"w":316,"h":176,"label":"eye_level_view_from_site","tid":"s08","z":113,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s08-eye-level-view-from-site-markup-96d820-800w.webp","pw":800,"ph":447},{"id":"b16","type":"tool","x":4804,"y":3696,"name":"Motion","kind":"Video","model":"Kling 2.6 Pro","icon":"Video","count":8,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v01-white-card-model-orbit-b46495aa-poster-400w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v07-creek-walk-evening-stroll-0f8f5947-poster-400w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v05-detail-to-tower-pull-out-reveal-024b9c3f-poster-400w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v02-hero-dolly-in-88196408-poster-400w.webp"],"z":114},{"id":"x75","type":"image","x":5100,"y":3696,"w":316,"h":423,"label":"white_card_model_orbit","tid":"v01","video":true,"dur":"0:05","kind":"video","z":115,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v01-white-card-model-orbit-b46495aa-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v01-white-card-model-orbit-b46495aa-optimized.mp4"},{"id":"x76","type":"image","x":5442,"y":3704,"w":316,"h":178,"label":"creek_walk_evening_strol","tid":"v07","video":true,"dur":"0:10","kind":"video","z":116,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v07-creek-walk-evening-stroll-0f8f5947-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v07-creek-walk-evening-stroll-0f8f5947-optimized.mp4"},{"id":"x77","type":"image","x":5784,"y":3692,"w":316,"h":423,"label":"detail_to_tower_pull_out","tid":"v05","video":true,"dur":"0:05","kind":"video","z":117,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v05-detail-to-tower-pull-out-reveal-024b9c3f-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v05-detail-to-tower-pull-out-reveal-024b9c3f-optimized.mp4"},{"id":"x78","type":"image","x":5100,"y":4145,"w":316,"h":423,"label":"hero_dolly_in","tid":"v02","video":true,"dur":"0:05","kind":"video","z":118,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v02-hero-dolly-in-88196408-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v02-hero-dolly-in-88196408-optimized.mp4"},{"id":"x79","type":"image","x":5442,"y":4153,"w":316,"h":178,"label":"sky_lounge_sunset_time_l","tid":"v06","video":true,"dur":"0:08","kind":"video","z":119,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v06-sky-lounge-sunset-time-lapse-a0a91aee-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v06-sky-lounge-sunset-time-lapse-a0a91aee-optimized.mp4"},{"id":"x80","type":"image","x":5784,"y":4141,"w":316,"h":177,"label":"bring_the_gardens_to_lif","tid":"v04","video":true,"dur":"0:05","kind":"video","z":120,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v04-bring-the-gardens-to-life-1cb39008-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v04-bring-the-gardens-to-life-1cb39008-optimized.mp4"},{"id":"x81","type":"image","x":5100,"y":4594,"w":316,"h":178,"label":"aerial_day_to_night_time","tid":"v03","video":true,"dur":"0:08","kind":"video","z":121,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v03-aerial-day-to-night-time-lapse-744df3b5-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v03-aerial-day-to-night-time-lapse-744df3b5-optimized.mp4"},{"id":"x82","type":"image","x":5442,"y":4602,"w":316,"h":423,"label":"white_card_to_photo_tran","tid":"v08","video":true,"dur":"0:05","kind":"video","z":122,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v08-white-card-to-photo-transition-ad34593f-poster-800w.webp","videoSrc":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v08-white-card-to-photo-transition-ad34593f-optimized.mp4"},{"id":"b17","type":"tool","x":244,"y":3532,"name":"Print upscales","kind":"Image","model":"Nano Banana Pro","icon":"Building2","count":1,"thumbs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e22-hero-final-editorial-upgrade-dc0390-800w.webp"],"z":123},{"id":"x83","type":"image","x":540,"y":3532,"w":316,"h":423,"label":"hero_final_editorial_upg","tid":"e22","fav":true,"z":124,"src":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e22-hero-final-editorial-upgrade-dc0390-800w.webp","pw":800,"ph":1071},{"id":"lg1","type":"note","x":204,"y":-132,"w":184,"h":184,"tint":"amethyst","text":"1 - CANVAS\\n\\n- Tools\\n- Generations\\n- Organization","author":"You","z":125},{"id":"lga1","type":"shape","shape":"arrow","x":425,"y":-41,"w":38,"h":0,"sc":[0,0],"stroke":"#ffffff","sw":7,"z":126},{"id":"lg2","type":"note","x":499,"y":-132,"w":184,"h":184,"tint":"vista","text":"2 - PROMPT LIBRARY","author":"You","z":127},{"id":"lga2","type":"shape","shape":"arrow","x":717,"y":-41,"w":36,"h":0,"sc":[0,0],"stroke":"#ffffff","sw":7,"z":128},{"id":"lg3","type":"note","x":796,"y":-131,"w":184,"h":212,"tint":"glass","text":"3 - INTEGRATIONS\\n\\n- Revit\\n- Photoshop\\n- Rhino\\n- Sketchup\\n- Miro","author":"You","z":129},{"id":"lga3","type":"shape","shape":"arrow","x":1022,"y":-40,"w":33,"h":0,"sc":[0,0],"stroke":"#ffffff","sw":7,"z":130},{"id":"lg4","type":"note","x":1101,"y":-131,"w":184,"h":212,"tint":"amethyst","text":"4 - CHAT\\n\\n- Tutorials/Questions\\n- Prompts\\n- Generations\\n- Workflows","author":"You","z":131}]'), $W = /* @__PURE__ */ JSON.parse(`[{"id":"bm1","name":"Existing site aerial","model":"Nano Banana Pro","prompt":"Create a realistic oblique aerial drone photograph of Depot Yards, a 4-acre former rail yard block at the west edge of downtown Salt Lake City, Utah, with a restored red-brick freight depot, rusted rail spurs and a buried creek channel crossing the block diagonally, looking east. The block is empty: gravel lots, rail spurs, the restored brick depot with a gabled roof in the lower left, and a dry, overgrown creek channel cutting diagonally across it. Surround it with low brick warehouses, a light rail line along the north edge and mid-rise downtown buildings beyond, with the snow-capped Wasatch Range rising to the east behind. Use a clear spring morning with long soft shadows and crisp, dry high-desert light under a deep blue sky. Retain the utilitarian character of a real site photograph, with no diagram overlays, labels or proposed buildings.","author":"KB","at":"2026-09-01","board":"Site photos","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s01-existing-site-aerial-f3aa4c-800w.webp","inputs":[]},{"id":"bm2","name":"Existing site plan","model":"ChatGPT Image 2","prompt":"Create a clean top-down architectural site plan drawing of Depot Yards, a 4-acre former rail yard block at the west edge of downtown Salt Lake City, Utah, with a restored red-brick freight depot, rusted rail spurs and a buried creek channel crossing the block diagonally as it exists today. Show the city block outline and surrounding streets, the brick depot footprint in the lower left, rail spurs, the buried creek alignment as a dashed line crossing the block diagonally, the light rail line along the top edge and adjacent warehouse footprints. Use thin black linework on white, light grey hatching for existing buildings, a north arrow, a scale bar and small neat labels: 'DEPOT YARDS', 'FREIGHT DEPOT', 'CREEK (CULVERTED)', 'LIGHT RAIL', '400 WEST'. No colour, no rendering and no proposed buildings.","author":"MT","at":"2026-09-02","board":"Site plans & analysis","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s04-existing-site-plan-ee31f8-800w.webp","inputs":[]},{"id":"bm3","name":"Masterplan aerial","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the existing Depot Yards site aerial and is the primary scene to edit. Image 2 is the Bench Gardens landscape masterplan, supplied only for the specific reference role described below. Image 3 is the Bonneville Tower design render, supplied only for the specific reference role described below.\\n\\nRender the proposed project into the aerial in Image 1. Use Image 2 for the site layout: the daylighted creek, curved limestone terraces, cottonwood grove, water-mirror plaza, depot plaza and paths. Use Image 3 for the tower's design, placing it in the northeast corner of the block with its four planted setbacks, terracotta bands, open crown and brick podium. Keep the surrounding city, the brick depot, the light rail line, the mountains, the camera and the morning light unchanged. Make the new landscape and tower read as built and mature, at correct scale.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"KB","at":"2026-09-12","board":"Masterplan views","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s06-masterplan-aerial-55b63e-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s01-existing-site-aerial-f3aa4c-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l02-watercolor-masterplan-6b0e55-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm4","name":"Eye-level view from site markup","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the annotated masterplan aerial with a camera position and view arrow and is the primary scene to edit. Image 2 is the Bonneville Tower design render, supplied only for the specific reference role described below.\\n\\nFollow and remove the annotations marked on the image; create an eye-level view at the red dot looking along the arrow toward the tower. Show the daylighted creek and curved limestone terraces in the foreground, the cottonwood grove and the tower from Image 2 rising behind, with the snow-capped Wasatch Range rising to the east beyond. This is a reimagining of the site as built. Photo reference: documentary-style architectural photography in late-afternoon spring light.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-13","board":"Masterplan views","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s08-eye-level-view-from-site-markup-96d820-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s07-markup-eye-level-camera-spot-e6cfa2-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm5","name":"Option B sketch: Canyon","model":"Nano Banana 2","prompt":"Create an architectural concept marker sketch on white trace paper of a 52-storey skyscraper split top to bottom by a narrow slot-canyon void, its two halves clad in curved vertical fins. Render it in warm red-rock and ochre marker tones with black fineliner linework. Use a street-level perspective with loose people silhouettes at the base and a mountain range hinted behind in grey marker. A designer's quick ideation sketch with energetic line weight and white paper showing through.","author":"MT","at":"2026-09-02","board":"Massing sketches","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e02-option-b-sketch-canyon-374663-800w.webp","inputs":[]},{"id":"bm6","name":"White card options A / B / C","model":"Seedream 5 Lite","prompt":"Create a photograph of an architecture studio's white card massing models on a large worktable: three alternative skyscraper options side by side on one shared site base, each about 60 cm tall and built from white foam board and basswood. Option A is a slender tower tapering through four stepped setbacks with horizontal banding. Option B is a tower split top to bottom by a narrow vertical slot with vertical fin ribs. Option C is a faceted crystalline tower with folded facets and a sharp crown. The site base shows a city block with a diagonal creek channel cut into it, small white context buildings and one tiny brick-red depot building. Small folded paper tags in front read 'A', 'B' and 'C'. Soft overhead studio daylight, shallow depth of field, with a cutting mat and rolls of trace paper at the edge of the frame.","author":"JR","at":"2026-09-03","board":"White card models","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e04-white-card-options-a-b-c-1713cd-800w.webp","inputs":[]},{"id":"bm7","name":"Hero v1: model to photo","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the white card model of Bonneville Tower and is the primary scene to edit. Image 2 is the existing Depot Yards street photograph, supplied only for the specific reference role described below.\\n\\nRender Image 1 as the completed Bonneville Tower in Salt Lake City. Use Image 2 only for site context, photographic atmosphere and material realism, not its building geometry. Preserve the model's silhouette, four stepped setbacks and undulating horizontal bands. Clad the bands in warm sandstone-coloured terracotta louvres alternating with low-iron glass, with bronze soffits and native trees and grasses on every setback terrace. Show the tower rising beyond the restored brick depot, with a light rail line and a few pedestrians in the foreground and the snow-capped Wasatch Range rising to the east behind. Late-afternoon spring light, crisp, dry high-desert light under a deep blue sky. Keep the camera level with corrected verticals, a restrained 24 mm architectural lens character and deep focus.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-05","board":"Hero options","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e09-hero-v1-model-to-photo-0725c1-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e05-option-a-white-card-model-c61989-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-s02-existing-depot-street-7c94e0-800w.webp"]},{"id":"bm8","name":"Hero v4: brick podium","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the Bonneville Tower render with deepened terraces and is the primary scene to edit. Image 2 is the tight brick facade rhythm reference, supplied only for the specific reference role described below.\\n\\nApply the tight vertical pier rhythm from Image 2 only to the five-storey podium at the base of the tower in Image 1: close-spaced warm brick piers with deep-set glazing that relate the podium to the neighbouring brick freight depot. Keep the tower above the podium, its setbacks, crown, terracotta bands, street, light and camera unchanged. Use Image 2 only for facade rhythm and brick character, not its building form. Keep the full tower in frame from the street to the top of the open crown, with the same portrait composition as Image 1.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-09","board":"Facade iterations","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e12-hero-v3-deeper-terraces-1c4ede-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r117-tight-facade-rhythm-reference-a4ddff-800w.webp"]},{"id":"bm9","name":"Hero final: editorial upgrade","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit. Image 2 is the residential tower comparison photograph, supplied only for the specific reference role described below.\\n\\nUpgrade Image 1 to an editorial architectural photograph, using Image 2 only as a realism reference. Preserve the tower design, setback terraces, crown, podium rhythm, street context and camera. Use warm late-afternoon sunlight, soft shadows, a subtle deep-blue sky gradient and the snow-capped Wasatch Range crisp behind. Refine glass reflections, terracotta material response and planting with balanced colour and controlled contrast. Keep the building crisp, without exaggerated sharpening or artificial saturation.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-13","board":"Print upscales","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e22-hero-final-editorial-upgrade-dc0390-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r143-residential-tower-comparison-reference-620572-800w.webp"]},{"id":"bm10","name":"Terrace edge detail with bokeh","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit.\\n\\nCreate a close-up detail photograph of one setback terrace edge: warm sandstone terracotta louvres, a bronze soffit, a low-iron glass guardrail and native grasses spilling over the planter lip, with the upper tower bands blurred into soft bokeh behind. Keep the materials, colours and afternoon light consistent with Image 1. Shallow depth of field with an 85 mm lens character.\\n\\nResolve the requested composition into one coherent image with appropriate scale, clear spatial relationships and consistent light. Include no unrelated annotations, labels or extra panels unless the brief explicitly calls for them.","author":"KB","at":"2026-09-10","board":"Camera set","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e18-terrace-edge-detail-with-bokeh-d096d7-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm11","name":"Watercolor masterplan","model":"ChatGPT Image 2","prompt":"Create one finished architectural image. Image 1 is the rendered landscape masterplan and is the primary scene to edit.\\n\\nMake this plan a clean architectural watercolor sketch: loose ink linework, soft transparent washes for the planting and water, white paper left for the paths, and the existing labels kept neat and legible.\\n\\nResolve the requested composition into one coherent image with appropriate scale, clear spatial relationships and consistent light. Include no unrelated annotations, labels or extra panels unless the brief explicitly calls for them.","author":"MT","at":"2026-09-05","board":"Bench Gardens","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l02-watercolor-masterplan-6b0e55-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l01-rendered-landscape-masterplan-0b3979-800w.webp"]},{"id":"bm12","name":"Creek walk marketing hero","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the Bench Gardens creek walk engine render and is the primary scene to edit. Image 2 is the Bonneville Tower design render, supplied only for the specific reference role described below.\\n\\nStrengthen this engine render into a marketing hero image: photorealistic limestone, clear rippling creek water, lush native grasses, sagebrush and flowering purple penstemon, mature cottonwoods, and natural people walking and sitting on the benches. Replace the placeholder striped tower at the right edge of the frame with the tower from Image 2 (its brick podium, warm terracotta bands and planted setback terraces) at the same position and scale, using Image 2 only for the tower's design. Late-afternoon spring light, crisp, dry high-desert light under a deep blue sky, with the snow-capped Wasatch Range rising to the east glimpsed beyond. Top-tier architectural visualization quality with verticals corrected.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-09","board":"Bench Gardens","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l04-creek-walk-marketing-hero-92d17d-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l03-creek-walk-engine-export-d0559e-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm13","name":"Daytime gardens with people","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the Bench Gardens creek walk render and is the primary scene to edit. Image 2 is the pavilion terrace people and placement reference, supplied only for the specific reference role described below.\\n\\nRender Image 1 in bright daytime and add people inspired by the placement and activity in Image 2: small groups sitting on the new benches, a couple leaning on the boardwalk rail and people strolling the path, all at correct scale. Use Image 2 only for people and placement. Keep the architecture, landscape, boardwalk and camera unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-12","board":"Bench Gardens","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l08-daytime-gardens-with-people-8fb7f2-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l07-benches-and-overlook-added-ca8f6c-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r123-pavilion-terrace-people-reference-crop-a239be-800w.webp"]},{"id":"bm14","name":"Louvre option: pale limestone","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the terrace-edge louvre detail photograph and is the primary scene to edit. Image 2 is the material sample board, supplied only for the specific reference role described below.\\n\\nReplace only the sandstone terracotta louvre finish in Image 1 with the pale limestone glazed terracotta sample from Image 2. Follow every louvre edge and profile with consistent glaze and realistic joints, and preserve the louvre geometry exactly. Keep the bronze soffit, glass guardrail, planting, bokeh background, camera and lighting unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-11","board":"Material studies","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m03-louvre-option-pale-limestone-b2566c-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e18-terrace-edge-detail-with-bokeh-d096d7-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m01-material-sample-flat-lay-2f160f-800w.webp"]},{"id":"bm15","name":"Residence palette from reference","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the corner residence living room render and is the primary scene to edit. Image 2 is the amber and rose lounge atmosphere reference, supplied only for the specific reference role described below.\\n\\nTransfer the warm amber-and-rose material palette and moody lighting of Image 2 onto the residence in Image 1: warm walnut millwork, rust and rose upholstery, bronze accents and soft amber lamp light. Use Image 2 only for palette and lighting, not its layout. Keep the room geometry, windows, mountain view, furniture layout and camera unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"KB","at":"2026-09-12","board":"Material studies","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m07-residence-palette-from-reference-371621-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i13-residence-sketch-to-render-7d94bc-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r044-amber-and-rose-lounge-atmosphere-396273-800w.webp"]},{"id":"bm16","name":"Lobby v1: geometry + materials","model":"Nano Banana Pro","prompt":"Create one finished architectural image. Image 1 is the white clay model of the lobby geometry and is the primary scene to edit. Image 2 is the material sample board, supplied only for the specific reference role described below.\\n\\nRender Image 1 as a finished photorealistic lobby while keeping its geometry, openings and camera exactly. Use Image 2 only for materials: the rammed-earth sample for the long curved feature wall, with horizontal strata like ancient shorelines; warm sandstone terracotta for the fin walls; red-rock terrazzo for the floor; walnut for the reception desk; and bronze trim. Warm afternoon light through the window wall onto the garden, with a few natural people.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"KB","at":"2026-09-09","board":"Lobby","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i02-lobby-v1-geometry-materials-ef49f9-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i01-lobby-white-model-d9fd93-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-m01-material-sample-flat-lay-2f160f-800w.webp"]},{"id":"bm17","name":"Lobby v4: competition brightening","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the lobby photograph and is the primary scene to edit.\\n\\nBrighten this lobby for a competition board: lift the interior exposure, add soft daylight bouncing off the floor, keep the sconces and artwork warm, and make the colours clean and inviting without losing material detail. Keep everything else unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"KB","at":"2026-09-11","board":"Lobby","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i06-lobby-v4-competition-brightening-34918a-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i05-lobby-v3-stone-desk-placed-c250ca-800w.webp"]},{"id":"bm18","name":"Sky lounge: evening gathering","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the evening sky lounge photograph and is the primary scene to edit. Image 2 is the casual evening gathering people reference, supplied only for the specific reference role described below.\\n\\nStage a lively evening gathering in Image 1, with people inspired by the mix, clothing and activity in Image 2: small groups talking with drinks, people seated in the lounge chairs and someone photographing the view. Use Image 2 only for people. Keep the architecture, furniture, lighting and camera unchanged.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"JR","at":"2026-09-12","board":"Sky lounge","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i11-sky-lounge-evening-gathering-b786e8-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i10-sky-lounge-borrow-evening-light-667177-800w.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-ref-r095-casual-workplace-evening-gathering-0bce32-800w.webp"]},{"id":"bm19","name":"Residence: sketch to render","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the fine-pen corner residence sketch and is the primary scene to edit.\\n\\nPlease transform this sketch into a hyper realistic render. Recognize the different textures from the sketch and translate them into warm walnut, pale limestone floors, linen upholstery and bronze fixtures. Maintain the point of view. Show the snow-capped Wasatch Range through the corner windows in afternoon light.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-11","board":"Corner residence","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i13-residence-sketch-to-render-7d94bc-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-i12-corner-residence-sketch-400d0d-800w.webp"]},{"id":"bm20","name":"Winter blue hour","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit.\\n\\nKeep image exactly how it is. Only change the season and time to a deep winter blue hour: fresh snow on the terraces, street and depot roof, light snow falling, the mountains fully white and warm glowing windows.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-12","board":"Seasons & light","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t04-winter-blue-hour-50f063-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm21","name":"Alpenglow dusk","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit.\\n\\nReveal the full horizon behind the tower: show the whole Wasatch Range glowing pink and orange with alpenglow just after sunset, under a clear peach-to-deep-blue sky. Keep the tower, street context and camera exactly the same.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-11","board":"Seasons & light","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t07-alpenglow-dusk-1d0baa-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm22","name":"Autumn golden hour","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the final Bonneville Tower render and is the primary scene to edit.\\n\\nSet the scene at golden hour in early October, with the building's interior lights glowing warmly and spilling outward into the fading light. The foothills behind are red and orange with autumn scrub oak, and the terrace trees have turned gold. You can't see the sun.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","author":"MT","at":"2026-09-12","board":"Seasons & light","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-t03-autumn-golden-hour-3768d6-800w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e15-hero-v4-brick-podium-11449d-800w.webp"]},{"id":"bm23","name":"Hero dolly-in","model":"Kling 2.6 Pro","prompt":"Do a gentle, smooth cinematic dolly forward toward the tower, as if the viewer is slowly walking up the street. Keep the architecture perfectly stable and verticals straight, with subtle natural motion in the trees and a few pedestrians.","author":"KB","at":"2026-09-14","board":"Motion","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v02-hero-dolly-in-88196408-poster-400w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-e22-hero-final-editorial-upgrade-dc0390-800w.webp"]},{"id":"bm24","name":"Creek walk evening stroll","model":"LTX 2.3","prompt":"People stroll along the creek path and sit on the benches as the evening light warms. Slight, slow camera push in. The water ripples and the grasses sway. The architecture and landscape remain stable.","author":"MT","at":"2026-09-14","board":"Motion","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-v07-creek-walk-evening-stroll-0f8f5947-poster-400w.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-l07-benches-and-overlook-added-ca8f6c-800w.webp"]},{"id":"sm1","name":"Ink + wet watercolour board","model":"Seedream 5 Lite","prompt":"Create one finished architectural image. Image 1 is the timber riverside pavilion at sunset and is the primary scene to edit. Image 2 is the watercolor stepped public courtyard, supplied only for the specific reference role described below. Image 3 is the watercolor stone and glass entrance, supplied only for the specific reference role described below. Image 4 is the forest cabin pencil and wash study, supplied only for the specific reference role described below. Image 5 is the watercolor glass pavilion and pool, supplied only for the specific reference role described below. Image 6 is the sepia civic pavilion beside water, supplied only for the specific reference role described below. Image 7 is the glass pavilion landscape watercolor, supplied only for the specific reference role described below. Image 8 is the raw timber building concept sketch, supplied only for the specific reference role described below. Image 9 is the red urban building watercolor, supplied only for the specific reference role described below. Image 10 is the orange modular building sketch, supplied only for the specific reference role described below. Image 11 is the slender red tower concept sketch, supplied only for the specific reference role described below. Image 12 is the three sculptural facade studies, supplied only for the specific reference role described below. Image 13 is the three colorful massing studies, supplied only for the specific reference role described below.\\n\\nRestyle Image 1 as a single architectural illustration. Use Images 2 through 13 solely as references for ink and watercolor technique; do not combine their buildings or make a collage. Draw structural edges in medium black ink with loose wet-in-wet washes, soft bleeds, pigment blooms and light paper grain. Use transparent blues, warm ochres and greens, darker pooled shadows and untouched white highlights. Simplify the existing people into loose silhouettes while preserving the pavilion, river landscape and composition from Image 1.\\n\\nPreserve the source design and spatial relationships except for the requested transformation. Keep linework, color and surface treatment consistent with the specified illustration style. Include no unrelated labels or graphic marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f015-ink-and-wet-watercolor-8fee6e-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r016-timber-riverside-pavilion-at-sunset-fa0780-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r017-watercolor-stepped-public-courtyard-7fc530-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r018-watercolor-stone-and-glass-entrance-09e1b4-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r019-forest-cabin-pencil-and-wash-study-aee0f0-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r020-watercolor-glass-pavilion-and-pool-9ae5e5-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r021-sepia-civic-pavilion-beside-water-118403-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r022-glass-pavilion-landscape-watercolor-ec8063-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r023-raw-timber-building-concept-sketch-863af3-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r024-red-urban-building-watercolor-225c95-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r025-orange-modular-building-sketch-88edb7-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r026-slender-red-tower-concept-sketch-4ccc34-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r027-three-sculptural-facade-studies-e88423-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r028-three-colorful-massing-studies-f239ea-original.webp"]},{"id":"sm2","name":"White model → render","model":"GPT Image 1.5","prompt":"Create one finished architectural image. Image 1 is the white office model interior and is the primary scene to edit. Image 2 is the warm workplace interior mood board, supplied only for the specific reference role described below. Image 3 is the office materials and furniture board, supplied only for the specific reference role described below. Image 4 is the sunlit industrial office lounge, supplied only for the specific reference role described below.\\n\\nRender the white office model in Image 1 with the warm workplace palette and furnishings suggested by Images 2 and 3. Use Image 4 for the rhythm of the exposed ceiling structure, translated into smooth warm concrete as the specified finish. Preserve the office layout, workstation positions, window arrangement and camera. Produce a coherent photorealistic workplace with credible material scale, daylight and contact shadows.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f009-white-model-look-transfer-820fb4-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r005-white-office-model-interior-ace253-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r006-warm-workplace-interior-mood-board-1dc35d-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r007-office-materials-and-furniture-board-95471b-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r008-sunlit-industrial-office-lounge-59d45b-original.webp"]},{"id":"sm3","name":"Magazine-grade upgrade","model":"ChatGPT Image 2","prompt":"Create one finished architectural image. Image 1 is the residential tower street render and is the primary scene to edit. Image 2 is the residential tower comparison reference, supplied only for the specific reference role described below.\\n\\nUpgrade Image 1 to an editorial architectural photograph, using Image 2 only as a realism reference. Preserve the tower design, facade proportions, balcony rhythm, street context and camera. Use warm natural sunlight, soft shadows, a subtle sky gradient and mild atmospheric depth. Refine glass reflections, material response and planting with balanced color and controlled contrast. Keep the building crisp without exaggerated sharpening or artificial saturation.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f093-magazine-grade-photoreal-upgrade-bd0a54-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r142-residential-tower-street-render-359681-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r143-residential-tower-comparison-reference-29add0-original.webp"]},{"id":"sm4","name":"Colour-coded markup edits","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the new annotated color-coded multi-markup edits and is the primary scene to edit.\\n\\nReplace the surface within the red outline with a perforated metal panel system fitted to the existing stair-tower facade. Turn the ground-level bay within the white outline into a vehicle exit with a proportionate exit barrier arm. Preserve the garage structure, other openings, street, people, trees and camera. Remove the red and white annotations from the completed scene.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f087-color-coded-multi-markup-edits-76f768-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/a087-color-coded-multi-markup-edits-annotation-4043aa-original.webp","https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r131-urban-parking-garage-street-approach-fabe37-original.webp"]},{"id":"sm5","name":"Remove the CGI look","model":"GPT Image 1.5","prompt":"Create one finished architectural image. Image 1 is the neutral stone elevator lobby render and is the primary scene to edit.\\n\\nRefine the lighting in the render view - True-to-life color grading, architectural digest style. No cgi look, no over-sharpening, no artificial symmetry perfection. 4000k lighting. Keep everything else the same.\\n\\nLimit changes to the specified edit. Preserve the remaining architecture, openings, proportions, objects and camera composition. Integrate altered surfaces or additions with correct scale, perspective, contact shadows and reflections. Deliver one clean finished image with no editing marks.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f094-remove-the-cgi-look-532569-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r144-neutral-stone-elevator-lobby-render-a2ae6f-original.webp"]},{"id":"sm6","name":"Raise camera, reveal plaza","model":"Nano Banana 2","prompt":"Create one finished architectural image. Image 1 is the residential courtyard street elevation and is the primary scene to edit.\\n\\nRaise the camera upward and look slightly down so more of the central plaza and foreground public space become visible.\\n\\nResolve the requested composition into one coherent image with appropriate scale, clear spatial relationships and consistent light. Include no unrelated annotations, labels or extra panels unless the brief explicitly calls for them.","img":"https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/f072-raise-camera-reveal-the-plaza-7d8009-original.webp","inputs":["https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/prompt-template-library/r102-residential-courtyard-street-elevation-fe3a75-original.webp"]}]`), DW = [{ id: "image", name: "Image", icon: "Image", desc: "Create images with AI-powered models", models: [{ name: "Nano Banana Pro", desc: "Best-in-class prompt adherence and editing", time: "50s", tokens: "240", g: 4 }, { name: "Nano Banana 2", desc: "Improved text, realism, and editing (Gemini 3.1)", time: "45s", tokens: "173", g: 8 }, { name: "ChatGPT Image 2", desc: "Prompt-perfect generation and surgical editing", time: "24s", tokens: "22–484", g: 10 }, { name: "GPT Image 1.5", desc: "Fast, faithful edits with strong text", time: "20s", tokens: "120", g: 1 }, { name: "Seedream 5 Lite", desc: "Bytedance’s fast, low-cost image model", time: "8s", tokens: "40", g: 2 }, { name: "Flux 2 Pro", desc: "FLUX 2 by Black Forest Labs", time: "15s", tokens: "70–700", g: 15 }] }, { id: "video", name: "Video", icon: "Video", desc: "Generate dynamic videos and animations", models: [{ name: "Kling 2.6 Pro", desc: "Expressive motion with strong camera control", time: "2m", tokens: "210", g: 6 }, { name: "LTX 2.3", desc: "Fast open video generation", time: "70s", tokens: "90", g: 12 }, { name: "Veo 3 Fast", desc: "Cinematic motion, quick turnaround", time: "90s", tokens: "260", g: 0 }, { name: "Hailuo 02", desc: "Strong physics and camera control", time: "2m", tokens: "210", g: 14 }] }, { id: "threed", name: "3D", icon: "Box", desc: "Generate 3D models from images or prompts", models: [{ name: "Hunyuan3D 2.1", desc: "Textured meshes from a single image", time: "2m", tokens: "240", g: 5 }, { name: "Trellis", desc: "Detailed geometry for hard-surface objects", time: "90s", tokens: "150", g: 9 }, { name: "Rodin Gen-2", desc: "Production-ready meshes with clean topology", time: "4m", tokens: "360", g: 3 }] }, { id: "upscale", name: "Upscale", icon: "Maximize2", desc: "Upscale your images and videos", models: [{ name: "Clarity Upscale", desc: "Crisp detail for print and large format", time: "30s", tokens: "40", g: 17 }, { name: "SUPIR", desc: "Restoration-grade photo upscaling", time: "50s", tokens: "55", g: 2 }, { name: "Topaz Video AI", desc: "Footage upscaling to 4k", time: "6m", tokens: "310", g: 10 }] }], na = {
  title: EW,
  project: RW,
  elements: zW,
  templates: $W,
  kits: DW
}, OW = { image: "image", video: "video", "3d": "threed", upscale: "upscale" };
function LW(i) {
  return OW[String(i || "").toLowerCase()] || "image";
}
function sk(i, e) {
  return i.x >= e.x && i.y >= e.y && i.x < e.x + e.w && i.y < e.y + e.h;
}
function Kl() {
  const i = na.elements, e = i.map((d) => {
    const c = { id: d.id, x: d.x, y: d.y, z: d.z };
    switch (d.type) {
      case "frame":
        return { ...c, type: "frame", w: d.w, h: d.h, title: d.title };
      case "note":
        return { ...c, type: "note", w: d.w, h: d.h, text: d.text, tint: d.tint || "glass", author: d.author };
      case "shape":
        return { ...c, type: "shape", w: d.w, h: d.h, shape: d.shape, stroke: d.stroke, sw: d.sw, sc: d.sc || [0, 0] };
      case "tool":
        return {
          ...c,
          type: "tool",
          w: 252,
          h: 160,
          name: d.name,
          kind: d.kind,
          kitId: LW(d.kind),
          model: d.model,
          icon: d.icon || "Image",
          count: d.count || 0,
          thumbs: d.thumbs || [],
          up: {},
          lastRunAt: Date.UTC(2026, 8, 1 + d.z % 14, 15, d.z * 7 % 60)
        };
      default:
        return {
          ...c,
          type: "image",
          w: d.w,
          h: d.h,
          src: d.src,
          label: d.label,
          fav: !!d.fav || void 0,
          video: !!d.video || void 0,
          dur: d.dur,
          videoSrc: d.videoSrc
        };
    }
  }), t = e.filter((d) => d.type === "frame"), n = e.filter((d) => d.type === "tool"), s = na.templates, o = /* @__PURE__ */ new Map();
  for (const d of i) d.type === "image" && d.pw && d.ph && o.set(d.id, { pw: d.pw, ph: d.ph });
  const r = [], a = Date.UTC(2026, 8, 1, 14, 0);
  let l = 0;
  for (const d of e) {
    if (d.type !== "image") continue;
    const c = d, h = t.find((x) => sk(He(c), He(x))), f = h ? n.find((x) => sk(He(x), He(h))) : void 0;
    if (!f) continue;
    const p = s.find((x) => x.img === c.src) || s.find((x) => x.board === f.name), y = "r-" + c.id, v = o.get(c.id);
    c.resultId = y, c.sessionId = f.id, r.push({
      id: y,
      sessionId: f.id,
      status: "done",
      url: c.src,
      w: v ? v.pw : c.w,
      h: v ? v.ph : c.h,
      video: c.video,
      dur: c.dur,
      videoSrc: c.videoSrc,
      prompt: p ? p.prompt : "",
      model: p && p.model || f.model,
      author: p ? p.author : "KB",
      createdAt: a + l++ * 3.7 * 3600 * 1e3,
      label: c.label,
      fav: c.fav,
      refs: p ? p.inputs : [],
      parents: p ? p.inputs : []
    });
  }
  return { title: na.title, elements: e, results: r };
}
function BW(i) {
  const e = /* @__PURE__ */ new Set();
  for (const t of i) {
    const n = t.type === "image" ? t.resultId : void 0;
    n && n.startsWith("r-") && !n.includes(":") && e.add(n);
  }
  return e.size ? Kl().results.filter((t) => e.has(t.id)) : [];
}
function iS() {
  const i = /* @__PURE__ */ new Set();
  for (const e of na.elements) e.type === "image" && e.src && !e.video && i.add(e.src);
  return Array.from(i);
}
function FW() {
  return na.elements.filter((i) => i.type === "image" && i.video && i.videoSrc).map((i) => ({ poster: i.src, src: i.videoSrc }));
}
function NW() {
  return na.project.team || [];
}
const ok = 600;
function sS(i, e) {
  const t = i.elements.filter((p) => p.type === "image").length, n = Math.max(1, Math.ceil(Math.max(1, e) / Math.max(1, t)));
  let s = 1 / 0, o = 1 / 0, r = -1 / 0, a = -1 / 0;
  for (const p of i.elements) {
    const y = He(p);
    s = Math.min(s, y.x), o = Math.min(o, y.y), r = Math.max(r, y.x + y.w), a = Math.max(a, y.y + y.h);
  }
  const l = r - s, d = a - o, c = Math.max(1, Math.min(n, Math.round(Math.sqrt(n * 1.6 * d / l)))), h = Math.ceil(n / c), f = [];
  for (let p = 0; p < n; p++)
    f.push({ x: s + p % c * (l + ok), y: o + Math.floor(p / c) * (d + ok), w: l, h: d });
  return { perCopy: t, copies: n, cols: c, rows: h, tiles: f };
}
function rk(i) {
  return sS(Kl(), i);
}
function UW(i) {
  const e = Kl(), t = sS(e, i), { copies: n, tiles: s } = t;
  let o = 0;
  for (const d of e.elements) o = Math.max(o, d.z + 1);
  const r = [], a = [];
  for (let d = 0; d < n; d++) {
    const c = d === 0 ? "" : "~" + d, h = s[d].x - s[0].x, f = s[d].y - s[0].y;
    for (const p of e.elements) {
      const y = JSON.parse(JSON.stringify(p));
      y.id = p.id + c, y.x = p.x + h, y.y = p.y + f, y.z = p.z + d * o, y.resultId && (y.resultId += c), y.sessionId && (y.sessionId += c), y.type === "frame" && n > 1 && (y.title = y.title + " · " + (d + 1)), r.push(y);
    }
    for (const p of e.results) {
      const y = JSON.parse(JSON.stringify(p));
      y.id = p.id + c, y.sessionId = p.sessionId + c, a.push(y);
    }
  }
  return { title: "Stress test: " + (t.perCopy * n).toLocaleString("en-US") + " images", elements: r, results: a, layout: t };
}
function GW(i, e) {
  const t = [], n = [], s = iS(), o = 24, r = 6, a = 316, l = 26, d = Math.ceil(i / o), c = Math.max(1, Math.round(Math.sqrt(d * 0.7))), h = 300 + r * (a + l) + 60, f = Math.ceil(o / r);
  let p = 0, y = 0;
  for (let v = 0; v < d; v++) {
    const x = v % c * (h + 140), w = Math.floor(v / c) * (f * 300 + 260), S = f * 300 + 100;
    t.push({ id: "sf" + v, type: "frame", x, y: w, w: h, h: S, z: p++, title: "Study " + (v + 1) });
    const M = "st" + v, _ = [];
    for (let T = 0; T < o && y < i; T++, y++) {
      const k = T % r, P = Math.floor(T / r), A = [176, 211, 316, 236][(v + T) % 4], R = e ? "synthetic://" + (y + 1) + "/800x" + Math.round(800 * A / a) : s[y % s.length], D = "si" + y;
      t.push({
        id: D,
        type: "image",
        x: x + 300 + k * (a + l),
        y: w + 50 + P * 300,
        w: a,
        h: A,
        z: p++,
        src: R,
        label: "study_" + (v + 1) + "_v" + String(T + 1).padStart(2, "0"),
        resultId: "r-" + D,
        sessionId: M
      }), _.length < 4 && _.push(R), n.push({
        id: "r-" + D,
        sessionId: M,
        status: "done",
        url: R,
        w: a,
        h: A,
        prompt: "Study " + (v + 1) + ", variation " + (T + 1),
        model: "Nano Banana 2",
        createdAt: Date.now() - y * 6e4,
        label: "study_" + (v + 1) + "_v" + String(T + 1).padStart(2, "0")
      });
    }
    t.push({
      id: M,
      type: "tool",
      x: x + 30,
      y: w + 50,
      w: 252,
      h: 160,
      z: p++,
      name: "Study " + (v + 1),
      kind: "Image",
      kitId: "image",
      model: "Nano Banana 2",
      icon: "Image",
      count: o,
      thumbs: _,
      up: {}
    }), v % 3 === 0 && t.push({
      id: "sn" + v,
      type: "note",
      x: x + 30,
      y: w + 260,
      w: 184,
      h: 184,
      z: p++,
      tint: ["amethyst", "vista", "glass"][v % 3],
      text: "Review notes for study " + (v + 1) + ".",
      author: "KB"
    }), v % 4 === 1 && t.push({
      id: "ss" + v,
      type: "shape",
      shape: "arrow",
      x: x + 120,
      y: w + 470,
      w: 160,
      h: 0,
      z: p++,
      stroke: "#a3a7f5",
      sw: 4,
      sc: [0, 0]
    });
  }
  return { title: i + " image benchmark", elements: t, results: n };
}
function oS(i) {
  return i === "INIT" || i === "QUEUED";
}
function jW(i) {
  return i === "DONE" || i === "ERROR" || i === "NSFW";
}
const ak = 512;
function lk(i, e) {
  return "thumbs/" + i.replace(/\.[^/.]+$/, `_${ak}x${ak}.${e}`);
}
function H1(i) {
  const e = i.templateOriginalData || null, t = e && e.nodeRunId || i.nodeRunId || "", n = e && e.teamId || i.teamId || null, s = e && e.userId || i.userId || "", o = n ? `runnitResults/teams/${n}/runs/${t}/` : `runnitResults/users/${s}/runs/${t}/`, r = i.type === "LAYERS" && i.displayFile ? i.displayFile : i.file, a = r && r.name || "", l = i.downloadFile && i.downloadFile.name ? o + i.downloadFile.name : null;
  return { file: o + a, thumb: o + lk(a, "webp"), mp4: o + lk(a, "mp4"), download: l };
}
function V1(i) {
  return (i.teamId ? `runnitUploads/teams/${i.teamId}/uploads/` : `runnitUploads/users/${i.userId || ""}/uploads/`) + (i.name || "");
}
function rS(i) {
  const e = i.teamId ? `avatars/teams/${i.teamId}/uploads/` : `avatars/users/${i.userId || ""}/uploads/`, t = i.name || "avatar";
  return { file: e + t, thumb: e + "thumbs/" + t.replace(/\.[^/.]+$/, "_256x256.webp") };
}
function HW(i) {
  return "nodeRunResult" in i ? H1(i.nodeRunResult).file : "upload" in i ? V1(i.upload) : null;
}
function* aS(i) {
  for (const e of i || []) {
    const t = e;
    t && (t.__rgroup ? yield* aS(t.fields) : t.__rfield && (yield t));
  }
}
function VW(i) {
  return typeof i == "string" ? i : i && typeof i == "object" && "value" in i ? String(i.value || "") : "";
}
function WW(i) {
  let e = "", t = null;
  const n = i.inputs || {};
  for (const s of aS(i.fields)) {
    const o = String(s.fieldDefUuid || s.uuid || "");
    !e && s.type === "PROMPT" && (e = VW(n[o])), t == null && s.type === "SEED" && Number.isFinite(Number(n[o])) && (t = Number(n[o]));
  }
  return { prompt: e, seed: t };
}
function qW(i) {
  const e = [], t = (n) => {
    if (!n || typeof n != "object") return;
    const s = n;
    s.nodeRunResult && typeof s.nodeRunResult == "object" ? e.push(H1(s.nodeRunResult).file) : s.upload && typeof s.upload == "object" && e.push(V1(s.upload));
    for (const o of ["image", "video"]) s[o] && t(s[o]);
    for (const o of ["uploads", "nodeRunResults"]) {
      const r = s[o];
      if (Array.isArray(r)) for (const a of r) t(o === "uploads" ? { upload: a } : { nodeRunResult: a });
    }
  };
  for (const n of Object.values(i.inputs || {})) t(n);
  return e;
}
function df(i, e, t) {
  const n = t.split("?")[0], s = n.lastIndexOf("."), o = s > n.lastIndexOf("/") && s > n.lastIndexOf("%2F") ? n.slice(s) : "", r = String(i || "").replace(/@{MODEL-(\S{12,36})}/g, "MODEL").slice(0, 100).replace(/[^a-zA-Z0-9_-]+/g, "_").replace(/^_+|_+$/g, "");
  return (r ? r + "-" + e : e) + o;
}
function KW(i) {
  if (!i || !Number.isFinite(i)) return;
  const e = Math.round(i);
  return Math.floor(e / 60) + ":" + String(e % 60).padStart(2, "0");
}
function YW(i, e) {
  return (String(i || "result").toLowerCase().replace(/[^a-z0-9 ]+/g, " ").trim().split(/\s+/).slice(0, 4).join("_") || "result").slice(0, 24) + "_v" + String(e + 1).padStart(2, "0");
}
function XW(i) {
  return i.initAt && i.doneAt && i.doneAt >= i.initAt ? i.doneAt - i.initAt : void 0;
}
function lS(i, e) {
  if (i.deletedAt) return [];
  const { prompt: t, seed: n } = WW(i), s = i.initAt || Date.now(), o = {
    sessionId: i.nodeId,
    prompt: t,
    model: e.modelName(i.nodeDefId),
    modelId: i.nodeDefId,
    inputs: i.inputs,
    refs: qW(i).map((a) => e.storageUrl(a)),
    seed: n,
    author: e.authorName(i.userId, i.email),
    userId: i.userId,
    authorEmail: i.email,
    runId: i.id
  };
  if (oS(i.state)) {
    const a = Math.max(1, Number(i.staticInputs && i.staticInputs.numResults) || 1), l = [];
    for (let d = 0; d < a; d++)
      l.push({ ...o, id: `${i.id}:p${d}`, status: "pending", url: "", w: 0, h: 0, createdAt: s + d, startedAt: s });
    return l;
  }
  if (i.state !== "DONE" && i.state !== "NSFW") return [];
  const r = [];
  return (i.results || []).forEach((a, l) => {
    if (!a || a.deletedAt) return;
    const d = H1({ ...a, nodeRunId: a.nodeRunId || i.id, userId: a.userId || i.userId, teamId: a.teamId !== void 0 ? a.teamId : i.teamId }), c = a.type === "LAYERS" && a.displayFile || a.file || {}, h = a.type === "VID", f = a.type === "ASSET_3D" || a.type === "MODEL", p = f ? Rj(c.name) : null, y = p ? Kw : c.width || 1024, v = p ? Kw : c.height || (c.aspectRatio ? Math.round(y / c.aspectRatio) : y);
    r.push({
      ...o,
      id: `${i.id}:${a.uuid}`,
      uuid: a.uuid,
      status: a.isNsfw ? "moderated" : "done",
      kind: h ? "video" : f ? "3d" : a.type === "LAYERS" ? "layers" : "image",
      // a video shows its first frame and a 3D model its preview until opened
      url: p ? Dj(p, `${i.id}:${a.uuid}`) : e.storageUrl(h || f ? d.thumb : d.file),
      thumb: h || f ? void 0 : e.storageUrl(d.thumb),
      video: h || void 0,
      videoSrc: h ? e.storageUrl(d.file) : void 0,
      previewSrc: h ? e.storageUrl(d.mp4) : void 0,
      dur: h ? KW(c.duration) : void 0,
      download: f ? e.storageUrl(d.file) : d.download ? e.storageUrl(d.download) : void 0,
      w: y,
      h: v,
      createdAt: (i.initAt || i.doneAt || 0) + l,
      took: XW(i),
      doneAt: i.doneAt,
      label: YW(t, l),
      asset: { nodeRunResult: { ...a, nodeRunId: a.nodeRunId || i.id } }
    });
  }), r;
}
const JW = ["disabled"], ZW = ["disabled"], QW = ["src", "poster", "aria-label"], eq = ["src"], tq = ["src", "alt"], nq = { class: "knob" }, iq = { class: "tag at-left" }, sq = {
  key: 2,
  class: "v2-info-pair-view",
  "data-testid": "info-compare"
}, oq = { class: "pic" }, rq = ["src"], aq = { class: "pic" }, lq = ["src", "alt"], dq = ["src", "alt"], cq = {
  key: 4,
  class: "v2-info-play",
  "aria-hidden": "true"
}, uq = { class: "v2-info-zoom" }, hq = ["aria-expanded"], pq = {
  key: 5,
  class: "v2-info-cmp-menu",
  role: "menu",
  "data-testid": "info-compare-menu"
}, fq = ["data-testid", "onClick"], mq = { class: "v2-info-side" }, gq = { class: "v2-info-top" }, bq = ["title"], vq = ["title"], yq = ["title"], xq = {
  key: 0,
  class: "v2-info-confirm"
}, wq = {
  key: 0,
  class: "v2-info-card is-form"
}, kq = {
  key: 1,
  class: "v2-info-card is-record"
}, _q = { class: "v2-info-strip" }, Sq = { class: "n" }, Mq = { class: "when" }, Tq = ["title", "aria-pressed"], Cq = ["title", "aria-pressed"], Iq = { class: "v2-info-block" }, Aq = { class: "v2-info-block-head" }, Pq = {
  key: 0,
  class: "v2-info-prompt is-reading",
  "data-testid": "info-reading"
}, Eq = {
  key: 0,
  class: "v2-info-specs",
  "data-testid": "info-settings"
}, Rq = ["title", "onClick", "onKeydown"], zq = ["title"], $q = {
  key: 1,
  class: "v2-info-specs"
}, Dq = {
  key: 1,
  class: "none"
}, Oq = {
  key: 1,
  class: "none"
}, Lq = ["title"], Bq = { class: "body" }, Fq = { class: "v2-info-acts" }, Nq = { class: "v2-info-pair" }, Uq = /* @__PURE__ */ Pe({
  __name: "ImageInfoModal",
  setup(i) {
    const { board: e } = Ze(), t = /* @__PURE__ */ K(1), n = /* @__PURE__ */ K(!1), s = /* @__PURE__ */ K(""), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(1.3), a = I(() => {
      e.docRev.value, e.results.rev.value;
      const W = e.ui.infoAt;
      if (!W) return null;
      if (W.startsWith("result:")) {
        const Le = e.results.get(W.slice(7)) || null;
        return Le ? { el: null, result: Le } : null;
      }
      const Q = e.store.get(W);
      if (!Q || Q.type !== "image") return null;
      const ae = Q;
      return { el: { ...ae }, result: ae.resultId && e.results.get(ae.resultId) || null };
    }), l = I(() => !!e.ui.infoSession), d = I(() => {
      e.docRev.value, e.results.rev.value;
      const W = e.ui.infoSession;
      if (W) {
        const Q = /* @__PURE__ */ new Map();
        for (const ae of e.store.all()) {
          const Le = ae.type === "image" ? ae.resultId : void 0;
          Le && !Q.has(Le) && Q.set(Le, ae.id);
        }
        return e.results.list(W).filter((ae) => ae.status === "done").map((ae) => ({ key: Q.get(ae.id) || "result:" + ae.id }));
      }
      return e.imagesInOrder().map((Q) => ({ key: Q.id }));
    }), c = I(() => {
      const W = e.ui.infoAt, Q = d.value.findIndex((Le) => Le.key === W);
      if (Q >= 0 || !W || !W.startsWith("result:")) return Q;
      const ae = e.placedFor(W.slice(7));
      return ae ? d.value.findIndex((Le) => Le.key === ae.id) : -1;
    }), h = I(() => a.value ? a.value.el ? a.value.el.src : a.value.result.url : ""), f = I(() => a.value && (a.value.el ? a.value.el.w : a.value.result.w) || 4), p = I(() => a.value && (a.value.el ? a.value.el.h : a.value.result.h) || 3), y = I(() => !!(a.value && (a.value.el && a.value.el.video || a.value.result && a.value.result.video))), v = I(() => {
      const W = a.value;
      return !W || !y.value ? "" : W.el && W.el.videoSrc || W.result && W.result.videoSrc || "";
    }), x = I(() => a.value ? a.value.el && a.value.el.label || a.value.result && a.value.result.label || "image" : ""), w = I(() => !!a.value && e.isFav(a.value.result, a.value.el)), S = I(() => !!a.value && e.canFav(a.value.result, a.value.el)), M = I(() => {
      const W = a.value;
      if (!W) return null;
      if (W.el) return e.toolFor(W.el);
      const Q = e.store.get(W.result.sessionId);
      return Q && Q.type === "tool" ? Q : null;
    }), _ = I(() => a.value ? a.value.result : null), T = I(() => {
      const W = a.value;
      return W && W.el && W.el.resultId && !W.result ? W.el.resultId : null;
    });
    Ae(T, (W) => {
      W && e.loadRecord(W);
    }, { immediate: !0 });
    const k = I(() => !!T.value && e.readingRecord(T.value)), P = NW(), A = I(() => {
      const W = _.value;
      if (W && W.userId) {
        const ve = W.userId === e.user.uid, ke = (ve ? e.user.email : W.authorEmail) || W.author || "Someone else", De = ve && e.user.name || ke;
        return { initials: ve && e.user.initials || ma(De), name: De, mail: ke };
      }
      const Q = W && W.author || e.user.initials || "YOU", ae = P.find((ve) => ve.initials === Q), Le = ae ? ae.name : W && W.author && W.author !== e.user.initials ? W.author : e.user.name || "You";
      return { initials: Q, name: Le, mail: ae ? ae.name.split(" ")[0].toLowerCase() + "@rundiffusion.com" : e.user.email || Le };
    }), R = I(() => _.value ? I1(_.value.createdAt) : k.value ? "" : "Not recorded"), D = I(() => {
      const W = _.value, Q = W && W.modelId ? e.toolModel(W.modelId) : null;
      return Q && Q.name || (W && W.model !== "Tool" ? W.model : "") || M.value && M.value.model || (k.value ? "" : "Not recorded");
    }), O = I(() => _.value ? "No prompt: this run didn't use one." : T.value ? "Its run's record couldn't be read." : "No prompt recorded: this image was placed on the board rather than generated here."), F = I(() => TL(f.value, p.value)), te = I(() => /upgrade|upscal|editorial|print/i.test(x.value) ? "4K" : y.value ? "1080p" : "1K"), ee = I(() => _.value && _.value.refs || []), me = I(() => {
      const W = _.value;
      if (!W || !W.inputs || !W.modelId) return null;
      const Q = e.catalog.value.byId.get(W.modelId), ae = [];
      if (W.w && W.h && W.status === "done" && ae.push({ label: "Size", value: W.w + " × " + W.h + (W.dur ? " · " + W.dur : "") }), W.took && ae.push({ label: "Generation time", value: SL(W.took) }), Q)
        for (const Le of Q.fields) {
          if (Le.placement === "prompt" || Le.placement === "reference" || Le.kind === "header") continue;
          const ve = W.inputs[Le.key];
          ve == null || ve === "" || ae.push({ label: Le.label || "Setting", value: L(Le, ve) });
        }
      return ae;
    });
    function L(W, Q) {
      if (typeof Q == "boolean") return Q ? "On" : "Off";
      const ae = (W.options || []).find((Le) => Qi(Le.value, Q));
      if (ae) return ae.label;
      if (Q && typeof Q == "object") {
        const Le = Q;
        return Le.width && Le.height ? Le.width + " × " + Le.height : Le.value !== void 0 ? String(Le.value) : Le.model && Le.model.name ? Le.model.name : "";
      }
      return String(Q);
    }
    const N = I(() => {
      const W = _.value, Q = ee.value;
      if (!W || !W.modelId || !Q.length) return [];
      const ae = e.catalog.value.byId.get(W.modelId), Le = ae ? ae.fields.filter((ve) => ve.placement === "reference").map((ve) => ve.label) : [];
      return Q.slice(0, 4).map((ve, ke) => ({ label: Le[ke] || "Input " + (ke + 1), url: ve }));
    }), X = I(() => {
      if (y.value) return [];
      const W = [], Q = (Qe) => {
        Qe.url && Qe.url !== h.value && !W.some((ft) => ft.url === Qe.url) && W.push(Qe);
      }, ae = N.value;
      ee.value.forEach((Qe, ft) => Q({ key: "in:" + ft, label: ae[ft] && ae[ft].label || "Image " + (ft + 1), url: Qe }));
      const Le = _.value;
      for (const Qe of Le && Le.parents || []) {
        const ft = e.results.get(Qe);
        ft && ft.url && !ft.video && Q({ key: "from:" + Qe, label: "What it was made from", url: ft.url });
      }
      const ve = d.value, ke = c.value, De = ke >= 0 && ke + 1 < ve.length ? ve[ke + 1].key : null;
      if (De) {
        const Qe = De.startsWith("result:") ? e.results.get(De.slice(7)) : null, ft = Qe ? null : e.store.get(De), Dn = Qe ? Qe.video ? "" : Qe.url : ft && ft.type === "image" && !ft.video ? ft.src : "";
        Dn && Q({ key: "prev", label: "The one before", url: Dn });
      }
      return W;
    }), B = /* @__PURE__ */ K(null), se = /* @__PURE__ */ K("split"), V = /* @__PURE__ */ K(0.5), Z = /* @__PURE__ */ K(!1), Y = /* @__PURE__ */ K(null);
    function H(W) {
      B.value = W, Z.value = !1, V.value = 0.5, t.value = 1;
    }
    function re() {
      B.value = null, Z.value = !1;
    }
    function le(W) {
      const Q = Y.value;
      if (!Q || se.value !== "split") return;
      W.preventDefault(), Q.setPointerCapture(W.pointerId);
      const ae = (ke) => {
        const De = Q.getBoundingClientRect();
        V.value = Math.min(0.98, Math.max(0.02, (ke.clientX - De.left) / Math.max(1, De.width)));
      };
      ae(W);
      const Le = (ke) => ae(ke), ve = () => {
        Q.removeEventListener("pointermove", Le), Q.removeEventListener("pointerup", ve), Q.removeEventListener("pointercancel", ve);
      };
      Q.addEventListener("pointermove", Le), Q.addEventListener("pointerup", ve), Q.addEventListener("pointercancel", ve);
    }
    const he = I(() => e.canDelete(_.value)), Re = /* @__PURE__ */ K(!1);
    async function Ne() {
      const W = _.value;
      if (!W) return;
      if (!Re.value) {
        Re.value = !0;
        return;
      }
      Re.value = !1;
      const Q = e.ui.infoAt, ae = e.ui.infoSession;
      if (l.value) {
        const ve = d.value, ke = c.value;
        e.ui.infoAt = ve.length > 1 && ke >= 0 ? ve[ke + 1 < ve.length ? ke + 1 : ke - 1].key : null;
      }
      const Le = e.ui.infoAt;
      !await e.deleteResult(W) && e.ui.infoAt === Le && (e.ui.infoSession = ae, e.ui.infoAt = Q);
    }
    const Me = /* @__PURE__ */ K(null), { more: ue, measure: U } = tS(Me);
    Ae(() => e.ui.infoAt, (W, Q) => {
      t.value = 1, re(), n.value = !1, Re.value = !1, Me.value && (Me.value.scrollTop = 0), Q && W !== Q && (e.ui.infoSave = !1);
    });
    const q = I(() => e.promptLibrary.canSave && !!_.value && !!_.value.prompt && _.value.status === "done"), ie = /* @__PURE__ */ qe(null);
    Ae(() => [e.ui.infoSave, _.value ? _.value.id : null], ([W]) => {
      const Q = _.value;
      ie.value = W && Q && q.value ? e.promptLibrary.draftForResult(Q) : null;
    }, { immediate: !0 });
    function de() {
      e.ui.infoSave = !0;
    }
    function pe() {
      e.ui.infoSave = !1;
    }
    function Te(W) {
      const Q = d.value;
      if (!Q.length) return;
      const ae = c.value < 0 ? 0 : (c.value + W + Q.length) % Q.length;
      e.ui.infoAt = Q[ae].key, l.value || (e.ui.selection = [Q[ae].key]);
    }
    function Be(W) {
      if (!(W.target.tagName === "INPUT" || W.target.tagName === "TEXTAREA")) {
        if (W.key === "Escape" && (B.value || Z.value)) {
          W.stopPropagation(), re();
          return;
        }
        W.key === "ArrowRight" ? Te(1) : W.key === "ArrowLeft" ? Te(-1) : W.key === "+" || W.key === "=" ? t.value = Math.min(2, +(t.value + 0.2).toFixed(2)) : W.key === "-" && (t.value = Math.max(0.6, +(t.value - 0.2).toFixed(2)));
      }
    }
    let ge = null;
    ot(() => {
      window.addEventListener("keydown", Be, !0), o.value && (ge = new ResizeObserver(() => {
        if (!o.value) return;
        const W = o.value.getBoundingClientRect();
        W.height && (r.value = W.width / W.height);
      }), ge.observe(o.value));
    }), We(() => {
      window.removeEventListener("keydown", Be, !0), ge && ge.disconnect(), e.ui.infoSession = null;
    });
    function ne() {
      const W = _.value ? _.value.prompt : "";
      try {
        navigator.clipboard.writeText(W).catch(() => {
        });
      } catch {
      }
      n.value = !0, setTimeout(() => {
        n.value = !1;
      }, 1400);
    }
    function oe() {
      e.ui.infoAt = null;
    }
    function ye() {
      const W = a.value;
      W && (W.el ? e.toggleFav(W.el.id) : W.result && e.toggleResultFav(W.result));
    }
    const Oe = I(() => !!h.value && e.isPinnedImage(h.value));
    function Ve() {
      const W = a.value;
      W && e.togglePinImage(W.el ? c8(W.el, W.result) : lm(W.result));
    }
    const Ue = I(() => {
      e.docRev.value;
      const W = a.value;
      return W ? W.el ? W.el : W.result ? e.placedFor(W.result.id) : null : null;
    });
    function tt() {
      const W = a.value;
      if (!W) return;
      const Q = Ue.value;
      if (Q) {
        e.ui.infoAt = null, e.ui.selection = [Q.id], e.jumpTo(Q.x + Q.w / 2, Q.y + Q.h / 2, Math.max(e.cam.value.zoom, 0.6));
        return;
      }
      W.result && (e.ui.infoAt = null, e.placeResult(W.result));
    }
    function Ye() {
      const W = a.value;
      if (!W) return;
      const Q = W.el || { id: "", type: "image", x: 0, y: 0, w: f.value, h: p.value, z: 0, src: h.value, video: y.value };
      e.remixFrom(Q, _.value);
    }
    function at() {
      const W = a.value;
      if (!W) return;
      const Q = _.value, ae = Q && Q.download || W.el && W.el.download || v.value || h.value, Le = Q && Q.uuid ? df(Q.prompt, Q.uuid, ae) : x.value;
      e.saveFile(ae, Le), Q && Q.runId && e.trackDownload(Q);
    }
    function wt() {
      const W = M.value;
      !W || !e.store.get(W.id) || (e.ui.infoAt = null, e.openSession(W));
    }
    const $e = I(() => !y.value && !!a.value);
    function Fe() {
      const W = a.value;
      W && (W.result ? e.openStudio({ resultId: W.result.id }) : W.el && e.openStudio({ elementId: W.el.id }));
    }
    return (W, Q) => a.value ? (g(), b("div", {
      key: 0,
      class: "v2-info",
      "data-testid": "info-modal",
      onPointerdown: Se(oe, ["self"])
    }, [
      u("button", {
        class: "v2-info-nav at-left",
        title: "Previous",
        disabled: d.value.length < 2,
        onClick: Q[0] || (Q[0] = (ae) => Te(-1))
      }, [
        C($, {
          name: "ChevronLeft",
          size: 22
        })
      ], 8, JW),
      u("button", {
        class: "v2-info-nav at-right",
        title: "Next",
        disabled: d.value.length < 2,
        onClick: Q[1] || (Q[1] = (ae) => Te(1))
      }, [
        C($, {
          name: "ChevronRight",
          size: 22
        })
      ], 8, ZW),
      u("div", {
        class: "v2-info-shell",
        onPointerdown: Q[11] || (Q[11] = Se(() => {
        }, ["stop"]))
      }, [
        u("div", {
          ref_key: "stage",
          ref: o,
          class: "v2-info-stage"
        }, [
          v.value ? (g(), b("video", {
            key: v.value,
            class: G(["v2-info-art is-video", { "is-loading": s.value !== h.value }]),
            src: v.value,
            poster: h.value,
            "aria-label": x.value,
            style: ce({
              width: f.value / p.value > r.value ? "calc(100% - 36px)" : "auto",
              height: f.value / p.value > r.value ? "auto" : "calc(100% - 36px)",
              aspectRatio: f.value + " / " + p.value,
              transform: "scale(" + t.value + ")"
            }),
            "data-testid": "info-video",
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            controls: "",
            controlslist: "nodownload noplaybackrate",
            disablepictureinpicture: "",
            onLoadeddata: Q[2] || (Q[2] = (ae) => s.value = h.value)
          }, null, 46, QW)) : B.value && se.value === "split" ? (g(), b("div", {
            key: 1,
            ref_key: "cmpBox",
            ref: Y,
            class: "v2-info-cmp",
            style: ce({
              width: f.value / p.value > r.value ? "calc(100% - 36px)" : "auto",
              height: f.value / p.value > r.value ? "auto" : "calc(100% - 36px)",
              aspectRatio: f.value + " / " + p.value
            }),
            "data-testid": "info-compare",
            onPointerdown: le
          }, [
            u("img", {
              class: "under",
              src: B.value.url,
              alt: "",
              draggable: "false"
            }, null, 8, eq),
            u("img", {
              class: "over",
              src: h.value,
              alt: x.value,
              draggable: "false",
              style: ce({ clipPath: "inset(0 0 0 " + (V.value * 100).toFixed(2) + "%)" })
            }, null, 12, tq),
            u("span", {
              class: "line",
              style: ce({ left: (V.value * 100).toFixed(2) + "%" })
            }, [
              u("span", nq, [
                C($, {
                  name: "ChevronLeft",
                  size: 12
                }),
                C($, {
                  name: "ChevronRight",
                  size: 12
                })
              ])
            ], 4),
            u("span", iq, E(B.value.label), 1),
            Q[12] || (Q[12] = u("span", { class: "tag at-right" }, "This one", -1))
          ], 36)) : B.value ? (g(), b("div", sq, [
            u("figure", null, [
              u("span", oq, [
                u("img", {
                  src: B.value.url,
                  alt: "",
                  draggable: "false"
                }, null, 8, rq),
                u("figcaption", null, E(B.value.label), 1)
              ])
            ]),
            u("figure", null, [
              u("span", aq, [
                u("img", {
                  src: h.value,
                  alt: x.value,
                  draggable: "false"
                }, null, 8, lq),
                Q[13] || (Q[13] = u("figcaption", null, "This one", -1))
              ])
            ])
          ])) : (g(), b("img", {
            key: h.value,
            class: G(["v2-info-art", { "is-loading": s.value !== h.value }]),
            src: h.value,
            alt: x.value,
            style: ce({
              width: f.value / p.value > r.value ? "calc(100% - 36px)" : "auto",
              height: f.value / p.value > r.value ? "auto" : "calc(100% - 36px)",
              aspectRatio: f.value + " / " + p.value,
              transform: "scale(" + t.value + ")"
            }),
            draggable: "false",
            onLoad: Q[3] || (Q[3] = (ae) => s.value = h.value)
          }, null, 46, dq)),
          y.value && !v.value ? (g(), b("span", cq, [
            C($, {
              name: "Play",
              size: 24
            })
          ])) : z("", !0),
          u("div", uq, [
            B.value ? (g(), b(j, { key: 0 }, [
              u("button", {
                class: G(["is-word", { on: se.value === "split" }]),
                "data-testid": "info-compare-split",
                onClick: Q[4] || (Q[4] = (ae) => se.value = "split")
              }, "Split", 2),
              u("button", {
                class: G(["is-word", { on: se.value === "side" }]),
                "data-testid": "info-compare-side",
                onClick: Q[5] || (Q[5] = (ae) => se.value = "side")
              }, "Side by side", 2),
              Q[14] || (Q[14] = u("i", { class: "sep" }, null, -1)),
              u("button", {
                class: "is-word",
                title: "Stop comparing (Esc)",
                "data-testid": "info-compare-done",
                onClick: re
              }, "Done")
            ], 64)) : (g(), b(j, { key: 1 }, [
              u("button", {
                title: "Zoom out",
                onClick: Q[6] || (Q[6] = (ae) => t.value = Math.max(0.6, +(t.value - 0.2).toFixed(2)))
              }, [
                C($, {
                  name: "Minus",
                  size: 13
                })
              ]),
              u("span", null, E(Math.round(t.value * 100)) + "%", 1),
              u("button", {
                title: "Zoom in",
                onClick: Q[7] || (Q[7] = (ae) => t.value = Math.min(2, +(t.value + 0.2).toFixed(2)))
              }, [
                C($, {
                  name: "Plus",
                  size: 13
                })
              ]),
              X.value.length ? (g(), b(j, { key: 0 }, [
                Q[16] || (Q[16] = u("i", { class: "sep" }, null, -1)),
                u("button", {
                  class: G(["is-word", { on: Z.value }]),
                  "aria-expanded": Z.value,
                  title: "Compare it with what it was made from",
                  "data-testid": "info-compare-open",
                  onClick: Q[8] || (Q[8] = (ae) => Z.value = !Z.value)
                }, [
                  C($, {
                    name: "Columns2",
                    size: 13
                  }),
                  Q[15] || (Q[15] = J(" Compare ", -1))
                ], 10, hq)
              ], 64)) : z("", !0)
            ], 64))
          ]),
          Z.value && !B.value ? (g(), b("div", pq, [
            Q[17] || (Q[17] = u("div", { class: "hd" }, "Compare with", -1)),
            (g(!0), b(j, null, be(X.value, (ae) => (g(), b("button", {
              key: ae.key,
              role: "menuitem",
              class: "row",
              "data-testid": "info-compare-" + ae.key,
              onClick: (Le) => H(ae)
            }, [
              u("span", {
                class: "pic",
                style: ce({ backgroundImage: 'url("' + m(Bt)(ae.url) + '"), url("' + ae.url + '")' })
              }, null, 4),
              u("span", null, E(ae.label), 1)
            ], 8, fq))), 128))
          ])) : z("", !0)
        ], 512),
        u("div", mq, [
          u("div", gq, [
            u("span", {
              class: "v2-info-avatar",
              title: A.value.name
            }, E(A.value.initials), 9, bq),
            u("span", {
              class: "v2-info-mail",
              title: A.value.name
            }, E(A.value.mail), 9, vq),
            u("button", {
              class: "v2-info-act",
              title: "Download",
              "data-testid": "info-download",
              onClick: at
            }, [
              C($, {
                name: "Download",
                size: 14
              })
            ]),
            he.value ? (g(), b("button", {
              key: 0,
              class: G(["v2-info-act is-danger", { "is-confirming": Re.value }]),
              title: Re.value ? "Click again to delete it from this session's history" + (Ue.value ? " (its card stays on the board)" : "") : "Delete from history",
              "data-testid": "info-delete",
              onClick: Ne,
              onBlur: Q[9] || (Q[9] = (ae) => Re.value = !1)
            }, [
              C($, {
                name: Re.value ? "Check" : "Trash2",
                size: 14
              }, null, 8, ["name"]),
              Re.value ? (g(), b("span", xq, "Delete?")) : z("", !0)
            ], 42, yq)) : z("", !0),
            u("button", {
              class: "v2-info-act",
              title: "Close",
              "data-testid": "info-close",
              onClick: oe
            }, [
              C($, {
                name: "X",
                size: 14
              })
            ])
          ]),
          m(e).ui.infoSave && ie.value ? (g(), b("div", wq, [
            (g(), Ce(nS, {
              key: ie.value.output.url,
              draft: ie.value,
              "editing-id": null,
              onDone: pe,
              onCancel: pe
            }, null, 8, ["draft"]))
          ])) : (g(), b("div", kq, [
            u("div", {
              ref_key: "detailsEl",
              ref: Me,
              class: G(["v2-info-scroll", { "is-more": m(ue) }]),
              onScrollPassive: Q[10] || (Q[10] = //@ts-ignore
              (...ae) => m(U) && m(U)(...ae))
            }, [
              u("div", _q, [
                u("span", Sq, [
                  C($, {
                    name: "Images",
                    size: 13
                  }),
                  J(" " + E(c.value >= 0 ? c.value + 1 : "–") + " of " + E(d.value.length), 1)
                ]),
                u("span", Mq, E(R.value), 1),
                u("button", {
                  class: G(["v2-info-star is-pin", { on: Oe.value }]),
                  title: Oe.value ? m(Xn).unpin : "Pin for yourself: one click away under Pinned, and only you see your pins",
                  "aria-pressed": Oe.value,
                  "data-testid": "info-pin",
                  onClick: Ve
                }, [
                  C($, {
                    name: "Pin",
                    size: 15
                  })
                ], 10, Tq),
                S.value ? (g(), b("button", {
                  key: 0,
                  class: G(["v2-info-star", { on: w.value }]),
                  title: w.value ? "Remove from your favorites" : "Add to your favorites",
                  "aria-pressed": w.value,
                  "data-testid": "info-fav",
                  onClick: ye
                }, [
                  C($, {
                    name: "Heart",
                    size: 15
                  })
                ], 10, Cq)) : z("", !0)
              ]),
              u("div", Iq, [
                u("div", Aq, [
                  u("span", null, [
                    C($, {
                      name: "MessageSquare",
                      size: 13
                    }),
                    Q[18] || (Q[18] = J(" Prompt", -1))
                  ]),
                  _.value && _.value.prompt ? (g(), b("button", {
                    key: 0,
                    title: "Copy prompt",
                    onClick: ne
                  }, [
                    C($, {
                      name: n.value ? "Check" : "Clipboard",
                      size: 13
                    }, null, 8, ["name"])
                  ])) : z("", !0)
                ]),
                k.value && !_.value ? (g(), b("p", Pq, "Loading its record…")) : (g(), b("p", {
                  key: 1,
                  class: G(["v2-info-prompt", { "is-none": !(_.value && _.value.prompt) }]),
                  "data-testid": "info-prompt"
                }, E(_.value && _.value.prompt ? _.value.prompt : O.value), 3))
              ]),
              me.value ? (g(), b("div", Eq, [
                (g(!0), b(j, null, be(N.value, (ae, Le) => (g(), b("div", {
                  key: ae.label + ae.url
                }, [
                  u("span", null, E(ae.label), 1),
                  u("em", {
                    class: "is-compare",
                    role: "button",
                    tabindex: "0",
                    title: "Compare with " + ae.label,
                    style: ce({ backgroundImage: 'url("' + m(Bt)(ae.url) + '")' }),
                    onClick: (ve) => H({ key: "in:" + Le, label: ae.label, url: ae.url }),
                    onKeydown: tn((ve) => H({ key: "in:" + Le, label: ae.label, url: ae.url }), ["enter"])
                  }, null, 44, Rq)
                ]))), 128)),
                (g(!0), b(j, null, be(me.value, (ae) => (g(), b("div", {
                  key: ae.label
                }, [
                  u("span", null, E(ae.label), 1),
                  u("b", {
                    title: ae.value
                  }, E(ae.value), 9, zq)
                ]))), 128)),
                u("div", null, [
                  Q[19] || (Q[19] = u("span", null, "Session", -1)),
                  u("b", null, E(M.value ? M.value.name : "Removed"), 1)
                ])
              ])) : (g(), b("div", $q, [
                u("div", null, [
                  Q[20] || (Q[20] = u("span", null, "Image to edit", -1)),
                  ee.value[0] ? (g(), b("em", {
                    key: 0,
                    style: ce({ backgroundImage: 'url("' + m(Bt)(ee.value[0]) + '")' })
                  }, null, 4)) : (g(), b("b", Dq, "none"))
                ]),
                u("div", null, [
                  Q[21] || (Q[21] = u("span", null, "Second image", -1)),
                  ee.value[1] ? (g(), b("em", {
                    key: 0,
                    style: ce({ backgroundImage: 'url("' + m(Bt)(ee.value[1]) + '")' })
                  }, null, 4)) : (g(), b("b", Oq, "none"))
                ]),
                u("div", null, [
                  Q[22] || (Q[22] = u("span", null, "Aspect ratio", -1)),
                  u("b", null, E(F.value), 1)
                ]),
                u("div", null, [
                  Q[23] || (Q[23] = u("span", null, "Resolution", -1)),
                  u("b", null, E(te.value), 1)
                ]),
                u("div", null, [
                  Q[24] || (Q[24] = u("span", null, "File", -1)),
                  u("b", { title: x.value }, E(x.value), 9, Lq)
                ]),
                u("div", null, [
                  Q[25] || (Q[25] = u("span", null, "Session", -1)),
                  u("b", null, E(M.value ? M.value.name : "None"), 1)
                ])
              ])),
              (g(), Ce(la(M.value && m(e).store.get(M.value.id) ? "button" : "div"), {
                class: "v2-info-tool",
                title: M.value && m(e).store.get(M.value.id) ? "Open this session" : void 0,
                onClick: wt
              }, {
                default: Xe(() => [
                  u("span", {
                    class: "thumb",
                    style: ce({ backgroundImage: 'url("' + m(Bt)(M.value && M.value.thumbs && M.value.thumbs[0] || h.value) + '")' })
                  }, null, 4),
                  u("span", Bq, [
                    Q[26] || (Q[26] = u("em", null, "Tool", -1)),
                    u("b", null, E(D.value), 1)
                  ]),
                  M.value && m(e).store.get(M.value.id) ? (g(), Ce($, {
                    key: 0,
                    class: "go",
                    name: "ChevronRight",
                    size: 15
                  })) : z("", !0)
                ]),
                _: 1
              }, 8, ["title"]))
            ], 34),
            u("div", Fq, [
              u("button", {
                class: "v2-info-place",
                "data-testid": "info-place",
                onClick: tt
              }, [
                Ue.value ? (g(), b(j, { key: 0 }, [
                  C($, {
                    name: "LocateFixed",
                    size: 15
                  }),
                  Q[27] || (Q[27] = J(" Find it on the board", -1))
                ], 64)) : (g(), b(j, { key: 1 }, [
                  C($, {
                    name: "ArrowDownToLine",
                    size: 15
                  }),
                  Q[28] || (Q[28] = J(" Place on the board", -1))
                ], 64))
              ]),
              u("div", Nq, [
                u("button", {
                  class: "v2-info-remix",
                  onClick: Ye
                }, [
                  C($, {
                    name: "Repeat",
                    size: 14
                  }),
                  J(" Remix this " + E(y.value ? "video" : "image"), 1)
                ]),
                q.value ? (g(), b("button", {
                  key: 0,
                  class: "v2-info-remix",
                  title: "Save its prompt, tool, settings and images to the prompt library",
                  "data-testid": "info-save-prompt",
                  onClick: de
                }, [
                  C($, {
                    name: "Bookmark",
                    size: 14
                  }),
                  Q[29] || (Q[29] = J(" Save prompt ", -1))
                ])) : z("", !0),
                $e.value ? (g(), b("button", {
                  key: 1,
                  class: "v2-info-remix",
                  "data-testid": "info-edit",
                  onClick: Fe
                }, [
                  C($, {
                    name: "Wand2",
                    size: 14
                  }),
                  Q[30] || (Q[30] = J(" Edit in Studio view", -1))
                ])) : z("", !0)
              ])
            ])
          ]))
        ])
      ], 32)
    ], 32)) : z("", !0);
  }
}), Gq = { class: "ks-head" }, jq = { class: "ks-mark" }, Hq = { class: "ks-titles" }, Vq = { id: "ks-title" }, Wq = {
  key: 0,
  class: "ks-os",
  "data-testid": "shortcuts-os"
}, qq = { class: "ks-grid" }, Kq = { class: "ks-label" }, Yq = { key: 0 }, Xq = { class: "ks-keys" }, Jq = /* @__PURE__ */ Pe({
  __name: "ShortcutsPanel",
  setup(i) {
    const { board: e } = Ze(), t = /* @__PURE__ */ K(null), n = sm().shift, s = ws === "mac" ? "Mac" : ws === "windows" ? "Windows" : ws === "chromeos" ? "ChromeOS" : ws === "linux" ? "Linux" : "", o = [
      {
        title: "Tools",
        area: "tools",
        rows: [
          { label: "Select", keys: ["V"] },
          { label: "Hand", keys: ["H"] },
          { label: "Pan while held", keys: ["Space"] },
          { label: "Note", keys: ["N"] },
          { label: "Frame", keys: ["F"] },
          { label: "Rectangle", keys: ["M"] },
          { label: "Ellipse", keys: ["L"] },
          { label: "Line", keys: ["\\"] },
          { label: "Arrow", keys: pn(["shift", "\\"]) },
          { label: "Pick from the board", keys: ["I"], hint: "Into the open prompt's images" },
          { label: "Comment", keys: ["C"], hint: "Then click anything on the board" },
          { label: "Show or hide comments", keys: pn(["shift", "C"]) }
        ]
      },
      {
        title: "View",
        area: "view",
        rows: [
          { label: "Pan", keys: ["Scroll"], hint: "Or drag with two fingers" },
          { label: "Pan sideways", keys: pn(["shift", "Scroll"]) },
          { label: "Zoom", keys: pn(["mod", "Scroll"]), hint: "Or pinch" },
          { label: "Zoom in", keys: ["+"] },
          { label: "Zoom out", keys: ["−"] },
          { label: "Zoom to 100%", keys: ["0"] },
          { label: "Fit the board", keys: ["1"] }
        ]
      },
      {
        title: "Board",
        area: "board",
        rows: [
          { label: "Find or start a session", keys: ["Double-click"], hint: "On the empty board; it starts one there" },
          { label: "Add a session, note or frame there", keys: ["Right-click"] },
          { label: "Use an image as a reference", keys: pn(["shift", "Drag"]), hint: "Onto a session, or the open prompt" },
          { label: "Run the prompt", keys: pn(["mod", "enter"]) },
          { label: "Edit a note, open an image", keys: pn(["enter"]) },
          { label: "Close, then deselect", keys: pn(["esc"]) },
          { label: "These shortcuts", keys: ["?"] },
          { label: "Send feedback", keys: ["`"], hint: "With a screenshot of what's open" }
        ]
      },
      {
        title: "Edit",
        area: "edit",
        rows: [
          { label: "Undo", keys: pn(["mod", "Z"]) },
          { label: "Redo", keys: pn(z1()) },
          { label: "Copy", keys: pn(["mod", "C"]) },
          { label: "Cut", keys: pn(["mod", "X"]) },
          { label: "Paste", keys: pn(["mod", "V"]) },
          { label: "Duplicate", keys: pn(["mod", "D"]) },
          { label: "Select all", keys: pn(["mod", "A"]) },
          { label: "Delete", keys: pn(["del"]) },
          { label: "Lock or unlock a frame", keys: pn(["mod", "shift", "L"]) },
          { label: "Nudge", keys: ["←", "↑", "↓", "→"], hint: `Hold ${n} for 10 px` },
          { label: "Drag without snapping", keys: pn(["mod", "Drag"]) }
        ]
      }
    ];
    function r() {
      e.ui.keysOpen = !1;
    }
    let a = null;
    return ot(() => {
      a = document.activeElement, t.value && t.value.focus({ preventScroll: !0 });
    }), We(() => {
      a && document.contains(a) && a.focus({ preventScroll: !0 });
    }), (l, d) => (g(), b("div", {
      class: "ks",
      "data-testid": "shortcuts",
      onPointerdown: Se(r, ["self"]),
      onWheel: d[1] || (d[1] = Se(() => {
      }, ["stop"]))
    }, [
      u("div", {
        ref_key: "card",
        ref: t,
        class: "ks-card",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "ks-title",
        tabindex: "-1",
        onPointerdown: d[0] || (d[0] = Se(() => {
        }, ["stop"]))
      }, [
        u("header", Gq, [
          u("span", jq, [
            C($, {
              name: "Keyboard",
              size: 17
            })
          ]),
          u("div", Hq, [
            u("h2", Vq, [
              d[2] || (d[2] = J("Keyboard shortcuts", -1)),
              m(s) ? (g(), b("span", Wq, E(m(s)), 1)) : z("", !0)
            ]),
            d[3] || (d[3] = u("p", null, [
              J("Press "),
              u("kbd", { class: "ks-key is-inline" }, "?"),
              J(" on the board to bring these up any time.")
            ], -1))
          ]),
          u("button", {
            class: "ks-close",
            title: "Close",
            "aria-label": "Close",
            "data-testid": "shortcuts-close",
            onClick: r
          }, [
            C($, {
              name: "X",
              size: 15
            })
          ])
        ]),
        u("div", qq, [
          (g(), b(j, null, be(o, (c) => u("section", {
            key: c.title,
            class: "ks-group",
            style: ce({ gridArea: c.area })
          }, [
            u("h3", null, E(c.title), 1),
            u("ul", null, [
              (g(!0), b(j, null, be(c.rows, (h) => (g(), b("li", {
                key: h.label
              }, [
                u("span", Kq, [
                  J(E(h.label) + " ", 1),
                  h.hint ? (g(), b("small", Yq, E(h.hint), 1)) : z("", !0)
                ]),
                u("span", Xq, [
                  (g(!0), b(j, null, be(h.keys, (f, p) => (g(), b("kbd", {
                    key: p,
                    class: G(["ks-key", { "is-word": f.length > 1 }])
                  }, E(f), 3))), 128))
                ])
              ]))), 128))
            ])
          ], 4)), 64))
        ])
      ], 544)
    ], 32));
  }
});
var Zq = Object.defineProperty, Qq = (i, e, t) => e in i ? Zq(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Ju = (i, e, t) => Qq(i, typeof e != "symbol" ? e + "" : e, t);
const Zu = 32768;
class eK {
  constructor(e = 512) {
    Ju(this, "cell"), Ju(this, "cells", /* @__PURE__ */ new Map()), Ju(this, "items", /* @__PURE__ */ new Map()), Ju(this, "mark", 0), this.cell = e;
  }
  get size() {
    return this.items.size;
  }
  has(e) {
    return this.items.has(e);
  }
  rectOf(e) {
    const t = this.items.get(e);
    return t ? t.r : void 0;
  }
  keysFor(e) {
    const t = this.cell, n = Math.floor(e.x / t), s = Math.floor(e.y / t), o = Math.floor((e.x + Math.max(0, e.w)) / t), r = Math.floor((e.y + Math.max(0, e.h)) / t), a = [];
    for (let l = n; l <= o; l++)
      for (let d = s; d <= r; d++) a.push((l + Zu) * 65536 + (d + Zu));
    return a;
  }
  insert(e, t) {
    if (this.items.has(e)) {
      this.update(e, t);
      return;
    }
    const n = this.keysFor(t);
    this.items.set(e, { r: { x: t.x, y: t.y, w: t.w, h: t.h }, keys: n, mark: 0 });
    for (const s of n) {
      let o = this.cells.get(s);
      o || (o = /* @__PURE__ */ new Set(), this.cells.set(s, o)), o.add(e);
    }
  }
  update(e, t) {
    const n = this.items.get(e);
    if (!n) {
      this.insert(e, t);
      return;
    }
    const s = this.keysFor(t);
    if (n.r.x = t.x, n.r.y = t.y, n.r.w = t.w, n.r.h = t.h, !(s.length === n.keys.length && s.every((o, r) => o === n.keys[r]))) {
      for (const o of n.keys) {
        const r = this.cells.get(o);
        r && (r.delete(e), r.size || this.cells.delete(o));
      }
      n.keys = s;
      for (const o of s) {
        let r = this.cells.get(o);
        r || (r = /* @__PURE__ */ new Set(), this.cells.set(o, r)), r.add(e);
      }
    }
  }
  remove(e) {
    const t = this.items.get(e);
    if (t) {
      for (const n of t.keys) {
        const s = this.cells.get(n);
        s && (s.delete(e), s.size || this.cells.delete(n));
      }
      this.items.delete(e);
    }
  }
  clear() {
    this.cells.clear(), this.items.clear();
  }
  /** Ids whose rects intersect r (touching edges count). Unordered. */
  query(e, t = []) {
    const n = ++this.mark, s = this.cell, o = Math.floor(e.x / s), r = Math.floor(e.y / s), a = Math.floor((e.x + e.w) / s), l = Math.floor((e.y + e.h) / s), d = e.x + e.w, c = e.y + e.h;
    if ((a - o + 1) * (l - r + 1) > this.cells.size) {
      for (const [h, f] of this.items) {
        const p = f.r;
        p.x <= d && p.x + p.w >= e.x && p.y <= c && p.y + p.h >= e.y && t.push(h);
      }
      return t;
    }
    for (let h = o; h <= a; h++)
      for (let f = r; f <= l; f++) {
        const p = this.cells.get((h + Zu) * 65536 + (f + Zu));
        if (p)
          for (const y of p) {
            const v = this.items.get(y);
            if (v.mark === n) continue;
            v.mark = n;
            const x = v.r;
            x.x <= d && x.x + x.w >= e.x && x.y <= c && x.y + x.h >= e.y && t.push(y);
          }
      }
    return t;
  }
  queryPoint(e, t, n = 0, s = []) {
    return this.query({ x: e - n, y: t - n, w: n * 2, h: n * 2 }, s);
  }
}
var tK = Object.defineProperty, nK = (i, e, t) => e in i ? tK(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, ci = (i, e, t) => nK(i, typeof e != "symbol" ? e + "" : e, t);
const iK = 100;
function us(i) {
  return i == null || typeof i != "object" ? i : JSON.parse(JSON.stringify(i));
}
function pg(i) {
  const e = {};
  for (const t of Object.keys(i)) e[t] = us(i[t]);
  return e;
}
function fg(i, e) {
  return i === e ? !0 : i && e && typeof i == "object" && typeof e == "object" ? JSON.stringify(i) === JSON.stringify(e) : !1;
}
class sK {
  constructor() {
    ci(this, "elements", /* @__PURE__ */ new Map()), ci(this, "index", new eK(512)), ci(this, "listeners", /* @__PURE__ */ new Set()), ci(this, "undoStack", []), ci(this, "redoStack", []), ci(this, "depth", 0), ci(this, "batchLabel", ""), ci(this, "batchPatches", []), ci(this, "batchSet", null), ci(this, "batchHistory", !0), ci(this, "gesture", null), ci(this, "maxZ", { frames: 0, content: 0, annotations: 0 }), ci(this, "minZ", { frames: 0, content: 0, annotations: 0 }), ci(this, "version", 0);
  }
  // ---------------------------------------------------------------- reads
  get(e) {
    return this.elements.get(e);
  }
  all() {
    return this.elements.values();
  }
  get size() {
    return this.elements.size;
  }
  /** Elements intersecting a world rect, unordered. */
  query(e) {
    const t = this.index.query(e), n = [];
    for (const s of t) {
      const o = this.elements.get(s);
      o && n.push(o);
    }
    return n;
  }
  bounds(e) {
    let t = 1 / 0, n = 1 / 0, s = -1 / 0, o = -1 / 0;
    const r = (a) => {
      const l = He(a);
      l.x < t && (t = l.x), l.y < n && (n = l.y), l.x + l.w > s && (s = l.x + l.w), l.y + l.h > o && (o = l.y + l.h);
    };
    if (e)
      for (const a of e) {
        const l = this.elements.get(a);
        l && r(l);
      }
    else
      for (const a of this.elements.values()) r(a);
    return t === 1 / 0 ? null : { x: t, y: n, w: s - t, h: o - n };
  }
  nextZ(e, t = !1) {
    const n = Mv[e.type];
    return t ? this.minZ[n] - 1 : this.maxZ[n] + 1;
  }
  get canUndo() {
    return this.undoStack.length > 0;
  }
  get canRedo() {
    return this.redoStack.length > 0;
  }
  get inGesture() {
    return !!this.gesture;
  }
  // -------------------------------------------------------------- events
  subscribe(e) {
    return this.listeners.add(e), () => this.listeners.delete(e);
  }
  emit(e) {
    if (!(!e.added.length && !e.updated.length && !e.removed.length)) {
      this.version++;
      for (const t of this.listeners)
        try {
          t(e);
        } catch (n) {
          console.error("[board] change listener failed", n);
        }
    }
  }
  // ------------------------------------------------------------ batching
  /** Run fn as one undo step and one change set. Nestable. */
  batch(e, t, n = {}) {
    this.open(e, n);
    try {
      return t();
    } finally {
      this.close();
    }
  }
  open(e, t) {
    this.depth++ === 0 && (this.batchLabel = e, this.batchPatches = [], this.batchHistory = t.history !== !1 && (t.origin || "local") === "local", this.batchSet = {
      origin: t.origin || "local",
      ephemeral: !!this.gesture && (t.origin || "local") === "local",
      label: e,
      added: [],
      updated: [],
      removed: []
    });
  }
  close() {
    if (--this.depth > 0) return;
    const e = this.batchSet, t = this.batchPatches;
    this.batchSet = null, this.batchPatches = [], this.batchHistory && t.length && !this.gesture && this.pushHistory({ label: this.batchLabel, patches: t }), this.emit(e);
  }
  pushHistory(e) {
    this.undoStack.push(e), this.undoStack.length > iK && this.undoStack.shift(), this.redoStack = [];
  }
  // ----------------------------------------------------------- mutations
  add(e, t = {}) {
    this.batch("Add", () => {
      for (const n of e) {
        if (this.elements.has(n.id)) continue;
        const s = n;
        this.elements.set(s.id, s), this.index.insert(s.id, He(s)), this.trackZ(s), this.batchSet.added.push(s), this.batchPatches.push({ op: "add", el: us(s) }), this.gesture && this.batchSet.origin === "local" && this.gesture.added.add(s.id);
      }
    }, t);
  }
  update(e, t, n = {}) {
    this.updateMany([[e, t]], n);
  }
  updateMany(e, t = {}) {
    this.batch("Edit", () => {
      for (const [n, s] of e) {
        const o = this.elements.get(n);
        if (!o) continue;
        const r = {}, a = {};
        let l = !1;
        for (const c of Object.keys(s)) {
          if (c === "id" || c === "type") continue;
          const h = s[c];
          fg(o[c], h) || (r[c] = us(o[c]), a[c] = us(h), o[c] = h === void 0 ? void 0 : us(h), h === void 0 && delete o[c], l = !0);
        }
        if (!l) continue;
        if (("x" in a || "y" in a || "w" in a || "h" in a || "scale" in a) && this.index.update(n, He(o)), "z" in a && this.trackZ(o), this.gesture && this.batchSet.origin === "local" && !this.gesture.added.has(n)) {
          const c = this.gesture.before.get(n) || {};
          for (const h of Object.keys(r)) h in c || (c[h] = r[h]);
          this.gesture.before.set(n, c);
        }
        const d = this.batchSet.updated.find((c) => c.id === n);
        if (d)
          for (const c of Object.keys(a))
            c in d.before || (d.before[c] = r[c]), d.after[c] = a[c];
        else
          this.batchSet.updated.push({ id: n, el: o, before: r, after: a });
        this.batchPatches.push({ op: "update", id: n, before: r, after: a });
      }
    }, t);
  }
  remove(e, t = {}) {
    this.batch("Delete", () => {
      for (const n of e) {
        const s = this.elements.get(n);
        s && (this.elements.delete(n), this.index.remove(n), this.batchSet.removed.push(s), this.batchPatches.push({ op: "remove", el: us(s) }));
      }
    }, t);
  }
  /** Replace everything (initial load). No history. */
  load(e) {
    const t = Array.from(this.elements.values());
    this.elements.clear(), this.index.clear(), this.maxZ = { frames: 0, content: 0, annotations: 0 }, this.minZ = { frames: 0, content: 0, annotations: 0 }, this.undoStack = [], this.redoStack = [];
    for (const n of e)
      this.elements.set(n.id, n), this.index.insert(n.id, He(n)), this.trackZ(n);
    this.emit({ origin: "load", ephemeral: !1, label: "Load", added: e, updated: [], removed: t });
  }
  trackZ(e) {
    const t = Mv[e.type];
    e.z > this.maxZ[t] && (this.maxZ[t] = e.z), e.z < this.minZ[t] && (this.minZ[t] = e.z);
  }
  // ------------------------------------------------------------ gestures
  beginGesture(e) {
    this.gesture && this.endGesture(), this.gesture = { label: e, before: /* @__PURE__ */ new Map(), added: /* @__PURE__ */ new Set() };
  }
  /** Commit the gesture: one persisted change set, one undo step. */
  endGesture() {
    const e = this.gesture;
    if (!e) return;
    this.gesture = null;
    const t = { origin: "local", ephemeral: !1, label: e.label, added: [], updated: [], removed: [] }, n = [];
    for (const s of e.added) {
      const o = this.elements.get(s);
      o && (t.added.push(o), n.push({ op: "add", el: us(o) }));
    }
    for (const [s, o] of e.before) {
      const r = this.elements.get(s);
      if (!r) continue;
      const a = {}, l = {};
      for (const d of Object.keys(o))
        fg(o[d], r[d]) || (l[d] = o[d], a[d] = us(r[d]));
      Object.keys(a).length && (t.updated.push({ id: s, el: r, before: l, after: a }), n.push({ op: "update", id: s, before: l, after: a }));
    }
    n.length && this.pushHistory({ label: e.label, patches: n }), this.emit(t);
  }
  /** Abandon the gesture and put everything back. */
  cancelGesture() {
    const e = this.gesture;
    e && (this.gesture = null, this.batch("Cancel", () => {
      this.remove(e.added, { history: !1 });
      const t = [];
      for (const [n, s] of e.before) t.push([n, s]);
      this.updateMany(t, { history: !1 });
    }, { history: !1 }));
  }
  // ------------------------------------------------------------- history
  /**
   * Record an undo step for an edit already applied without history (text
   * typed into a note, saved as you type): one step for the whole edit.
   */
  recordEdit(e, t, n, s) {
    !Object.keys(s).some((r) => !fg(n[r], s[r])) || !this.elements.has(t) || this.pushHistory({ label: e, patches: [{ op: "update", id: t, before: pg(n), after: pg(s) }] });
  }
  undo() {
    this.gesture && this.endGesture();
    const e = this.undoStack.pop();
    return e ? (this.applyPatches(e.patches, !0, "Undo " + e.label), this.redoStack.push(e), !0) : !1;
  }
  redo() {
    this.gesture && this.endGesture();
    const e = this.redoStack.pop();
    return e ? (this.applyPatches(e.patches, !1, "Redo " + e.label), this.undoStack.push(e), !0) : !1;
  }
  /**
   * Elements gone for good (deleted from Recently Deleted): no undo or redo
   * step brings them back or changes them. Their part of each step goes, and
   * a step left with nothing goes too; the rest of a step stays, so Undo
   * still takes back whatever else it did.
   */
  forget(e) {
    if (!e.length) return;
    const t = new Set(e), n = (s) => s.map((o) => ({ ...o, patches: o.patches.filter((r) => !t.has(r.op === "update" ? r.id : r.el.id)) })).filter((o) => o.patches.length > 0);
    this.undoStack = n(this.undoStack), this.redoStack = n(this.redoStack);
  }
  /** The elements an Undo (or a Redo) would put back on the board: what an undoable step removed, or Undo took away. */
  restorableIds() {
    const e = /* @__PURE__ */ new Set();
    for (const t of this.undoStack) for (const n of t.patches) n.op === "remove" && e.add(n.el.id);
    for (const t of this.redoStack) for (const n of t.patches) n.op === "add" && e.add(n.el.id);
    return Array.from(e);
  }
  /** The labels on the undo stack, oldest first: what Undo would take back, in turn from the end. */
  undoLabels() {
    return this.undoStack.map((e) => e.label);
  }
  applyPatches(e, t, n) {
    const s = t ? e.slice().reverse() : e;
    this.batch(n, () => {
      for (const o of s)
        o.op === "add" ? t ? this.remove([o.el.id], { history: !1, origin: "local" }) : this.add([us(o.el)], { history: !1, origin: "local" }) : o.op === "remove" ? t ? this.add([us(o.el)], { history: !1, origin: "local" }) : this.remove([o.el.id], { history: !1, origin: "local" }) : this.update(o.id, pg(t ? o.before : o.after), { history: !1, origin: "local" });
    }, { history: !1, origin: "local" });
  }
}
var Ie = /* @__PURE__ */ ((i) => (i.Application = "application", i.WebGLPipes = "webgl-pipes", i.WebGLPipesAdaptor = "webgl-pipes-adaptor", i.WebGLSystem = "webgl-system", i.WebGLLoader = "webgl-loader", i.WebGPUPipes = "webgpu-pipes", i.WebGPUPipesAdaptor = "webgpu-pipes-adaptor", i.WebGPUSystem = "webgpu-system", i.WebGPULoader = "webgpu-loader", i.CanvasSystem = "canvas-system", i.CanvasPipesAdaptor = "canvas-pipes-adaptor", i.CanvasPipes = "canvas-pipes", i.CanvasLoader = "canvas-loader", i.Asset = "asset", i.LoadParser = "load-parser", i.ResolveParser = "resolve-parser", i.CacheParser = "cache-parser", i.DetectionParser = "detection-parser", i.MaskEffect = "mask-effect", i.BlendMode = "blend-mode", i.TextureSource = "texture-source", i.TextureUploaderWebGL = "texture-uploader-webgl", i.TextureUploaderWebGPU = "texture-uploader-webgpu", i.Environment = "environment", i.ShapeBuilder = "shape-builder", i.Batcher = "batcher", i))(Ie || {});
const Lv = (i) => {
  if (typeof i == "function" || typeof i == "object" && i.extension) {
    if (!i.extension)
      throw new Error("Extension class must have an extension object");
    i = { ...typeof i.extension != "object" ? { type: i.extension } : i.extension, ref: i };
  }
  if (typeof i == "object")
    i = { ...i };
  else
    throw new Error("Invalid extension type");
  return typeof i.type == "string" && (i.type = [i.type]), i;
}, Qu = (i, e) => {
  var t;
  return (t = Lv(i).priority) != null ? t : e;
}, ht = {
  /** @ignore */
  _addHandlers: {},
  /** @ignore */
  _removeHandlers: {},
  /** @ignore */
  _queue: {},
  /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed. Can be:
   * - Extension class with static `extension` property
   * - Extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns {extensions} this for chaining
   * @example
   * ```ts
   * // Remove a single extension
   * extensions.remove(MyRendererPlugin);
   *
   * // Remove multiple extensions
   * extensions.remove(
   *     MyRendererPlugin,
   *     MySystemPlugin
   * );
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   */
  remove(...i) {
    return i.map(Lv).forEach((e) => {
      e.type.forEach((t) => {
        var n, s;
        return (s = (n = this._removeHandlers)[t]) == null ? void 0 : s.call(n, e);
      });
    }), this;
  },
  /**
   * Register new extensions with PixiJS. Extensions can be registered in multiple formats:
   * - As a class with a static `extension` property
   * - As an extension format object
   * - As multiple extensions passed as separate arguments
   * @param extensions - Extensions to add to PixiJS. Each can be:
   * - A class with static `extension` property
   * - An extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns This extensions instance for chaining
   * @example
   * ```ts
   * // Register a simple extension
   * extensions.add(MyRendererPlugin);
   *
   * // Register multiple extensions
   * extensions.add(
   *     MyRendererPlugin,
   *     MySystemPlugin,
   * });
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   * @see {@link extensions.remove} For removing registered extensions
   */
  add(...i) {
    return i.map(Lv).forEach((e) => {
      e.type.forEach((t) => {
        var o, r;
        const n = this._addHandlers, s = this._queue;
        n[t] ? (r = n[t]) == null || r.call(n, e) : (s[t] = s[t] || [], (o = s[t]) == null || o.push(e));
      });
    }), this;
  },
  /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function handler when extensions are added/registered {@link StrictExtensionFormat}.
   * @param onRemove  - Function handler when extensions are removed/unregistered {@link StrictExtensionFormat}.
   * @returns this for chaining.
   * @internal
   * @ignore
   */
  handle(i, e, t) {
    var r;
    const n = this._addHandlers, s = this._removeHandlers;
    if (n[i] || s[i])
      throw new Error(`Extension type ${i} already has a handler`);
    n[i] = e, s[i] = t;
    const o = this._queue;
    return o[i] && ((r = o[i]) == null || r.forEach((a) => e(a)), delete o[i]), this;
  },
  /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns this for chaining.
   * @ignore
   */
  handleByMap(i, e) {
    return this.handle(
      i,
      (t) => {
        t.name && (e[t.name] = t.ref);
      },
      (t) => {
        t.name && delete e[t.name];
      }
    );
  },
  /**
   * Handle a type, but using a list of extensions with a `name` property.
   * @param type - Type of extension to handle.
   * @param map - The array of named extensions.
   * @param defaultPriority - Fallback priority if none is defined.
   * @returns this for chaining.
   * @ignore
   */
  handleByNamedList(i, e, t = -1) {
    return this.handle(
      i,
      (n) => {
        e.findIndex((o) => o.name === n.name) >= 0 || (e.push({ name: n.name, value: n.ref }), e.sort((o, r) => Qu(r.value, t) - Qu(o.value, t)));
      },
      (n) => {
        const s = e.findIndex((o) => o.name === n.name);
        s !== -1 && e.splice(s, 1);
      }
    );
  },
  /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns this for chaining.
   * @ignore
   */
  handleByList(i, e, t = -1) {
    return this.handle(
      i,
      (n) => {
        e.includes(n.ref) || (e.push(n.ref), e.sort((s, o) => Qu(o, t) - Qu(s, t)));
      },
      (n) => {
        const s = e.indexOf(n.ref);
        s !== -1 && e.splice(s, 1);
      }
    );
  },
  /**
   * Mixin the source object(s) properties into the target class's prototype.
   * Copies all property descriptors from source objects to the target's prototype.
   * @param Target - The target class to mix properties into
   * @param sources - One or more source objects containing properties to mix in
   * @example
   * ```ts
   * // Create a mixin with shared properties
   * const moveable = {
   *     x: 0,
   *     y: 0,
   *     move(x: number, y: number) {
   *         this.x += x;
   *         this.y += y;
   *     }
   * };
   *
   * // Create a mixin with computed properties
   * const scalable = {
   *     scale: 1,
   *     get scaled() {
   *         return this.scale > 1;
   *     }
   * };
   *
   * // Apply mixins to a class
   * extensions.mixin(Sprite, moveable, scalable);
   *
   * // Use mixed-in properties
   * const sprite = new Sprite();
   * sprite.move(10, 20);
   * console.log(sprite.x, sprite.y); // 10, 20
   * ```
   * @remarks
   * - Copies all properties including getters/setters
   * - Does not modify source objects
   * - Preserves property descriptors
   * @see {@link Object.defineProperties} For details on property descriptors
   * @see {@link Object.getOwnPropertyDescriptors} For details on property copying
   */
  mixin(i, ...e) {
    for (const t of e)
      Object.defineProperties(i.prototype, Object.getOwnPropertyDescriptors(t));
  }
}, oK = {
  extension: {
    type: Ie.Environment,
    name: "browser",
    priority: -1
  },
  test: () => !0,
  load: async () => {
    await Promise.resolve().then(() => zRe);
  }
}, rK = {
  extension: {
    type: Ie.Environment,
    name: "webworker",
    priority: 0
  },
  test: () => typeof self != "undefined" && self.WorkerGlobalScope !== void 0,
  load: async () => {
    await Promise.resolve().then(() => $Re);
  }
};
class Fn {
  /**
   * Creates a new `ObservablePoint`
   * @param observer - Observer to pass to listen for change events.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(e, t, n) {
    this._x = t || 0, this._y = n || 0, this._observer = e;
  }
  /**
   * Creates a clone of this point.
   * @example
   * ```ts
   * // Basic cloning
   * const point = new ObservablePoint(observer, 100, 200);
   * const copy = point.clone();
   *
   * // Clone with new observer
   * const newObserver = {
   *     _onUpdate: (p) => console.log(`Clone updated: (${p.x}, ${p.y})`)
   * };
   * const watched = point.clone(newObserver);
   *
   * // Verify independence
   * watched.set(300, 400); // Only triggers new observer
   * ```
   * @param observer - Optional observer to pass to the new observable point
   * @returns A copy of this observable point
   * @see {@link ObservablePoint.copyFrom} For copying into existing point
   * @see {@link Observer} For observer interface details
   */
  clone(e) {
    return new Fn(e != null ? e : this._observer, this._x, this._y);
  }
  /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new ObservablePoint(observer);
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.equals} For comparing positions
   */
  set(e = 0, t = e) {
    return (this._x !== e || this._y !== t) && (this._x = e, this._y = t, this._observer._onUpdate(this)), this;
  }
  /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(observer, 100, 200);
   * const target = new ObservablePoint();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new ObservablePoint()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyTo} For copying to another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */
  copyFrom(e) {
    return (this._x !== e.x || this._y !== e.y) && (this._x = e.x, this._y = e.y, this._observer._onUpdate(this)), this;
  }
  /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(100, 200);
   * const target = new ObservablePoint();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */
  copyTo(e) {
    return e.set(this._x, this._y), e;
  }
  /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new ObservablePoint(100, 200);
   * const p2 = new ObservablePoint(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new ObservablePoint(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link ObservablePoint.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */
  equals(e) {
    return e.x === this._x && e.y === this._y;
  }
  toString() {
    return `[pixi.js/math:ObservablePoint x=${this._x} y=${this._y} scope=${this._observer}]`;
  }
  /**
   * Position of the observable point on the x axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic x position
   * const point = new ObservablePoint(observer);
   * point.x = 100; // Triggers observer
   *
   * // Use in calculations
   * const width = rightPoint.x - leftPoint.x;
   * ```
   * @default 0
   */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x !== e && (this._x = e, this._observer._onUpdate(this));
  }
  /**
   * Position of the observable point on the y axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic y position
   * const point = new ObservablePoint(observer);
   * point.y = 200; // Triggers observer
   *
   * // Use in calculations
   * const height = bottomPoint.y - topPoint.y;
   * ```
   * @default 0
   */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y !== e && (this._y = e, this._observer._onUpdate(this));
  }
}
function aK(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
var mg = { exports: {} }, dk;
function lK() {
  return dk || (dk = 1, (function(i) {
    var e = Object.prototype.hasOwnProperty, t = "~";
    function n() {
    }
    Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (t = !1));
    function s(l, d, c) {
      this.fn = l, this.context = d, this.once = c || !1;
    }
    function o(l, d, c, h, f) {
      if (typeof c != "function")
        throw new TypeError("The listener must be a function");
      var p = new s(c, h || l, f), y = t ? t + d : d;
      return l._events[y] ? l._events[y].fn ? l._events[y] = [l._events[y], p] : l._events[y].push(p) : (l._events[y] = p, l._eventsCount++), l;
    }
    function r(l, d) {
      --l._eventsCount === 0 ? l._events = new n() : delete l._events[d];
    }
    function a() {
      this._events = new n(), this._eventsCount = 0;
    }
    a.prototype.eventNames = function() {
      var d = [], c, h;
      if (this._eventsCount === 0) return d;
      for (h in c = this._events)
        e.call(c, h) && d.push(t ? h.slice(1) : h);
      return Object.getOwnPropertySymbols ? d.concat(Object.getOwnPropertySymbols(c)) : d;
    }, a.prototype.listeners = function(d) {
      var c = t ? t + d : d, h = this._events[c];
      if (!h) return [];
      if (h.fn) return [h.fn];
      for (var f = 0, p = h.length, y = new Array(p); f < p; f++)
        y[f] = h[f].fn;
      return y;
    }, a.prototype.listenerCount = function(d) {
      var c = t ? t + d : d, h = this._events[c];
      return h ? h.fn ? 1 : h.length : 0;
    }, a.prototype.emit = function(d, c, h, f, p, y) {
      var v = t ? t + d : d;
      if (!this._events[v]) return !1;
      var x = this._events[v], w = arguments.length, S, M;
      if (x.fn) {
        switch (x.once && this.removeListener(d, x.fn, void 0, !0), w) {
          case 1:
            return x.fn.call(x.context), !0;
          case 2:
            return x.fn.call(x.context, c), !0;
          case 3:
            return x.fn.call(x.context, c, h), !0;
          case 4:
            return x.fn.call(x.context, c, h, f), !0;
          case 5:
            return x.fn.call(x.context, c, h, f, p), !0;
          case 6:
            return x.fn.call(x.context, c, h, f, p, y), !0;
        }
        for (M = 1, S = new Array(w - 1); M < w; M++)
          S[M - 1] = arguments[M];
        x.fn.apply(x.context, S);
      } else {
        var _ = x.length, T;
        for (M = 0; M < _; M++)
          switch (x[M].once && this.removeListener(d, x[M].fn, void 0, !0), w) {
            case 1:
              x[M].fn.call(x[M].context);
              break;
            case 2:
              x[M].fn.call(x[M].context, c);
              break;
            case 3:
              x[M].fn.call(x[M].context, c, h);
              break;
            case 4:
              x[M].fn.call(x[M].context, c, h, f);
              break;
            default:
              if (!S) for (T = 1, S = new Array(w - 1); T < w; T++)
                S[T - 1] = arguments[T];
              x[M].fn.apply(x[M].context, S);
          }
      }
      return !0;
    }, a.prototype.on = function(d, c, h) {
      return o(this, d, c, h, !1);
    }, a.prototype.once = function(d, c, h) {
      return o(this, d, c, h, !0);
    }, a.prototype.removeListener = function(d, c, h, f) {
      var p = t ? t + d : d;
      if (!this._events[p]) return this;
      if (!c)
        return r(this, p), this;
      var y = this._events[p];
      if (y.fn)
        y.fn === c && (!f || y.once) && (!h || y.context === h) && r(this, p);
      else {
        for (var v = 0, x = [], w = y.length; v < w; v++)
          (y[v].fn !== c || f && !y[v].once || h && y[v].context !== h) && x.push(y[v]);
        x.length ? this._events[p] = x.length === 1 ? x[0] : x : r(this, p);
      }
      return this;
    }, a.prototype.removeAllListeners = function(d) {
      var c;
      return d ? (c = t ? t + d : d, this._events[c] && r(this, c)) : (this._events = new n(), this._eventsCount = 0), this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = t, a.EventEmitter = a, i.exports = a;
  })(mg)), mg.exports;
}
var dK = lK();
const bi = /* @__PURE__ */ aK(dK), cK = Math.PI * 2, uK = 180 / Math.PI, hK = Math.PI / 180;
class Wt {
  /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(e = 0, t = 0) {
    this.x = 0, this.y = 0, this.x = e, this.y = t;
  }
  /**
   * Creates a clone of this point, which is a new instance with the same `x` and `y` values.
   * @example
   * ```ts
   * // Basic point cloning
   * const original = new Point(100, 200);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.set(300, 400);
   *
   * // Verify independence
   * console.log(original); // Point(100, 200)
   * console.log(modified); // Point(300, 400)
   * ```
   * @remarks
   * - Creates new Point instance
   * - Deep copies x and y values
   * - Independent from original
   * - Useful for preserving values
   * @returns A clone of this point
   * @see {@link Point.copyFrom} For copying into existing point
   * @see {@link Point.copyTo} For copying to existing point
   */
  clone() {
    return new Wt(this.x, this.y);
  }
  /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new Point()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link Point.copyTo} For copying to another point
   * @see {@link Point.clone} For creating new point copy
   */
  copyFrom(e) {
    return this.set(e.x, e.y), this;
  }
  /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.clone} For creating new point copy
   */
  copyTo(e) {
    return e.set(this.x, this.y), e;
  }
  /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new Point(100, 200);
   * const p2 = new Point(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new Point(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link Point.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new Point();
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   *
   * // Chain with other operations
   * point
   *     .set(10, 20)
   *     .copyTo(otherPoint);
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.equals} For comparing positions
   */
  set(e = 0, t = e) {
    return this.x = e, this.y = t, this;
  }
  toString() {
    return `[pixi.js/math:Point x=${this.x} y=${this.y}]`;
  }
  /**
   * A static Point object with `x` and `y` values of `0`.
   *
   * This shared instance is reset to zero values when accessed.
   *
   * > [!IMPORTANT] This point is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempPoint = Point.shared;
   * tempPoint.set(100, 200);
   * matrix.apply(tempPoint);
   *
   * // Will be reset to (0,0) on next access
   * const fresh = Point.shared; // x=0, y=0
   * ```
   * @readonly
   * @returns A fresh zeroed point for temporary use
   * @see {@link Point.constructor} For creating new points
   * @see {@link PointData} For basic point interface
   */
  static get shared() {
    return gg.x = 0, gg.y = 0, gg;
  }
}
const gg = new Wt();
class st {
  /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */
  constructor(e = 1, t = 0, n = 0, s = 1, o = 0, r = 0) {
    this.array = null, this.a = e, this.b = t, this.c = n, this.d = s, this.tx = o, this.ty = r;
  }
  /**
   * Creates a Matrix object based on the given array.
   * Populates matrix components from a flat array in column-major order.
   *
   * > [!NOTE] Array mapping order:
   * > ```
   * > array[0] = a  (x scale)
   * > array[1] = b  (y skew)
   * > array[2] = tx (x translation)
   * > array[3] = c  (x skew)
   * > array[4] = d  (y scale)
   * > array[5] = ty (y translation)
   * > ```
   * @example
   * ```ts
   * // Create matrix from array
   * const matrix = new Matrix();
   * matrix.fromArray([
   *     2, 0,  100,  // a, b, tx
   *     0, 2,  100   // c, d, ty
   * ]);
   *
   * // Create matrix from typed array
   * const float32Array = new Float32Array([
   *     1, 0, 0,     // Scale x1, no skew
   *     0, 1, 0      // No skew, scale x1
   * ]);
   * matrix.fromArray(float32Array);
   * ```
   * @param array - The array to populate the matrix from
   * @see {@link Matrix.toArray} For converting matrix to array
   * @see {@link Matrix.set} For setting values directly
   */
  fromArray(e) {
    this.a = e[0], this.b = e[1], this.c = e[3], this.d = e[4], this.tx = e[2], this.ty = e[5];
  }
  /**
   * Sets the matrix properties directly.
   * All matrix components can be set in one call.
   * @example
   * ```ts
   * // Set to identity matrix
   * matrix.set(1, 0, 0, 1, 0, 0);
   *
   * // Set to scale matrix
   * matrix.set(2, 0, 0, 2, 0, 0); // Scale 2x
   *
   * // Set to translation matrix
   * matrix.set(1, 0, 0, 1, 100, 50); // Move 100,50
   * ```
   * @param a - Scale on x axis
   * @param b - Shear on y axis
   * @param c - Shear on x axis
   * @param d - Scale on y axis
   * @param tx - Translation on x axis
   * @param ty - Translation on y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.fromArray} For setting from array
   */
  set(e, t, n, s, o, r) {
    return this.a = e, this.b = t, this.c = n, this.d = s, this.tx = o, this.ty = r, this;
  }
  /**
   * Creates an array from the current Matrix object.
   *
   * > [!NOTE] The array format is:
   * > ```
   * > Non-transposed:
   * > [a, c, tx,
   * > b, d, ty,
   * > 0, 0, 1]
   * >
   * > Transposed:
   * > [a, b, 0,
   * > c, d, 0,
   * > tx,ty,1]
   * > ```
   * @example
   * ```ts
   * // Basic array conversion
   * const matrix = new Matrix(2, 0, 0, 2, 100, 100);
   * const array = matrix.toArray();
   *
   * // Using existing array
   * const float32Array = new Float32Array(9);
   * matrix.toArray(false, float32Array);
   *
   * // Get transposed array
   * const transposed = matrix.toArray(true);
   * ```
   * @param transpose - Whether to transpose the matrix
   * @param out - Optional Float32Array to store the result
   * @returns The array containing the matrix values
   * @see {@link Matrix.fromArray} For creating matrix from array
   * @see {@link Matrix.array} For cached array storage
   */
  toArray(e, t) {
    this.array || (this.array = new Float32Array(9));
    const n = t || this.array;
    return e ? (n[0] = this.a, n[1] = this.b, n[2] = 0, n[3] = this.c, n[4] = this.d, n[5] = 0, n[6] = this.tx, n[7] = this.ty, n[8] = 1) : (n[0] = this.a, n[1] = this.c, n[2] = this.tx, n[3] = this.b, n[4] = this.d, n[5] = this.ty, n[6] = 0, n[7] = 0, n[8] = 1), n;
  }
  /**
   * Get a new position with the current transformation applied.
   *
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @example
   * ```ts
   * // Basic point transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const point = new Point(10, 20);
   * const transformed = matrix.apply(point);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.apply(point, output);
   * ```
   * @param pos - The origin point to transform
   * @param newPos - Optional point to store the result
   * @returns The transformed point
   * @see {@link Matrix.applyInverse} For inverse transformation
   * @see {@link Point} For point operations
   */
  apply(e, t) {
    t = t || new Wt();
    const n = e.x, s = e.y;
    return t.x = this.a * n + this.c * s + this.tx, t.y = this.b * n + this.d * s + this.ty, t;
  }
  /**
   * Get a new position with the inverse of the current transformation applied.
   *
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @example
   * ```ts
   * // Basic inverse transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const worldPoint = new Point(150, 100);
   * const localPoint = matrix.applyInverse(worldPoint);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.applyInverse(worldPoint, output);
   *
   * // Convert mouse position to local space
   * const mousePoint = new Point(mouseX, mouseY);
   * const localMouse = matrix.applyInverse(mousePoint);
   * ```
   * @param pos - The origin point to inverse-transform
   * @param newPos - Optional point to store the result
   * @returns The inverse-transformed point
   * @see {@link Matrix.apply} For forward transformation
   * @see {@link Matrix.invert} For getting inverse matrix
   */
  applyInverse(e, t) {
    t = t || new Wt();
    const n = this.a, s = this.b, o = this.c, r = this.d, a = this.tx, l = this.ty, d = 1 / (n * r + o * -s), c = e.x, h = e.y;
    return t.x = r * d * c + -o * d * h + (l * o - a * r) * d, t.y = n * d * h + -s * d * c + (-l * n + a * s) * d, t;
  }
  /**
   * Translates the matrix on the x and y axes.
   * Adds to the position values while preserving scale, rotation and skew.
   * @example
   * ```ts
   * // Basic translation
   * const matrix = new Matrix();
   * matrix.translate(100, 50); // Move right 100, down 50
   *
   * // Chain with other transformations
   * matrix
   *     .scale(2, 2)
   *     .translate(100, 0)
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - How much to translate on the x axis
   * @param y - How much to translate on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.set} For setting position directly
   * @see {@link Matrix.setTransform} For complete transform setup
   */
  translate(e, t) {
    return this.tx += e, this.ty += t, this;
  }
  /**
   * Applies a scale transformation to the matrix.
   * Multiplies the scale values with existing matrix components.
   * @example
   * ```ts
   * // Basic scaling
   * const matrix = new Matrix();
   * matrix.scale(2, 3); // Scale 2x horizontally, 3x vertically
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100)
   *     .scale(2, 2)     // Scales after translation
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting scale directly
   * @see {@link Matrix.append} For combining transformations
   */
  scale(e, t) {
    return this.a *= e, this.d *= t, this.c *= e, this.b *= t, this.tx *= e, this.ty *= t, this;
  }
  /**
   * Applies a rotation transformation to the matrix.
   *
   * Rotates around the origin (0,0) by the given angle in radians.
   * @example
   * ```ts
   * // Basic rotation
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // Rotate 45 degrees
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100) // Move to rotation center
   *     .rotate(Math.PI)     // Rotate 180 degrees
   *     .scale(2, 2);        // Scale after rotation
   *
   * // Common angles
   * matrix.rotate(Math.PI / 2);  // 90 degrees
   * matrix.rotate(Math.PI);      // 180 degrees
   * matrix.rotate(Math.PI * 2);  // 360 degrees
   * ```
   * @remarks
   * - Rotates around origin point (0,0)
   * - Affects position if translation was set
   * - Uses counter-clockwise rotation
   * - Order of operations matters when chaining
   * @param angle - The angle in radians
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting rotation directly
   * @see {@link Matrix.append} For combining transformations
   */
  rotate(e) {
    const t = Math.cos(e), n = Math.sin(e), s = this.a, o = this.c, r = this.tx;
    return this.a = s * t - this.b * n, this.b = s * n + this.b * t, this.c = o * t - this.d * n, this.d = o * n + this.d * t, this.tx = r * t - this.ty * n, this.ty = r * n + this.ty * t, this;
  }
  /**
   * Appends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = this * matrix
   * @example
   * ```ts
   * // Basic matrix combination
   * const matrix = new Matrix();
   * const other = new Matrix().translate(100, 0).rotate(Math.PI / 4);
   * matrix.append(other);
   * ```
   * @remarks
   * - Order matters: A.append(B) !== B.append(A)
   * - Modifies current matrix
   * - Preserves transformation order
   * - Commonly used for combining transforms
   * @param matrix - The matrix to append
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.prepend} For prepending transformations
   * @see {@link Matrix.appendFrom} For appending two external matrices
   */
  append(e) {
    const t = this.a, n = this.b, s = this.c, o = this.d;
    return this.a = e.a * t + e.b * s, this.b = e.a * n + e.b * o, this.c = e.c * t + e.d * s, this.d = e.c * n + e.d * o, this.tx = e.tx * t + e.ty * s + this.tx, this.ty = e.tx * n + e.ty * o + this.ty, this;
  }
  /**
   * Appends two matrices and sets the result to this matrix.
   * Performs matrix multiplication: this = A * B
   * @example
   * ```ts
   * // Basic matrix multiplication
   * const result = new Matrix();
   * const matrixA = new Matrix().scale(2, 2);
   * const matrixB = new Matrix().rotate(Math.PI / 4);
   * result.appendFrom(matrixA, matrixB);
   * ```
   * @remarks
   * - Order matters: A * B !== B * A
   * - Creates a new transformation from two others
   * - More efficient than append() for multiple operations
   * - Does not modify input matrices
   * @param a - The first matrix to multiply
   * @param b - The second matrix to multiply
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For single matrix combination
   * @see {@link Matrix.prepend} For reverse order multiplication
   */
  appendFrom(e, t) {
    const n = e.a, s = e.b, o = e.c, r = e.d, a = e.tx, l = e.ty, d = t.a, c = t.b, h = t.c, f = t.d;
    return this.a = n * d + s * h, this.b = n * c + s * f, this.c = o * d + r * h, this.d = o * c + r * f, this.tx = a * d + l * h + t.tx, this.ty = a * c + l * f + t.ty, this;
  }
  /**
   * Sets the matrix based on all the available properties.
   * Combines position, scale, rotation, skew and pivot in a single operation.
   * @example
   * ```ts
   * // Basic transform setup
   * const matrix = new Matrix();
   * matrix.setTransform(
   *     100, 100,    // position
   *     0, 0,        // pivot
   *     2, 2,        // scale
   *     Math.PI / 4, // rotation (45 degrees)
   *     0, 0         // skew
   * );
   * ```
   * @remarks
   * - Updates all matrix components at once
   * - More efficient than separate transform calls
   * - Uses radians for rotation and skew
   * - Pivot affects rotation center
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.decompose} For extracting transform properties
   * @see {@link TransformableObject} For transform data structure
   */
  setTransform(e, t, n, s, o, r, a, l, d) {
    return this.a = Math.cos(a + d) * o, this.b = Math.sin(a + d) * o, this.c = -Math.sin(a - l) * r, this.d = Math.cos(a - l) * r, this.tx = e - (n * this.a + s * this.c), this.ty = t - (n * this.b + s * this.d), this;
  }
  /**
   * Prepends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = matrix * this
   * @example
   * ```ts
   * // Basic matrix prepend
   * const matrix = new Matrix().scale(2, 2);
   * const other = new Matrix().translate(100, 0);
   * matrix.prepend(other); // Translation happens before scaling
   * ```
   * @remarks
   * - Order matters: A.prepend(B) !== B.prepend(A)
   * - Modifies current matrix
   * - Reverses transformation order compared to append()
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For appending transformations
   * @see {@link Matrix.appendFrom} For combining external matrices
   */
  prepend(e) {
    const t = this.tx;
    if (e.a !== 1 || e.b !== 0 || e.c !== 0 || e.d !== 1) {
      const n = this.a, s = this.c;
      this.a = n * e.a + this.b * e.c, this.b = n * e.b + this.b * e.d, this.c = s * e.a + this.d * e.c, this.d = s * e.b + this.d * e.d;
    }
    return this.tx = t * e.a + this.ty * e.c + e.tx, this.ty = t * e.b + this.ty * e.d + e.ty, this;
  }
  /**
   * Decomposes the matrix into its individual transform components.
   * Extracts position, scale, rotation and skew values from the matrix.
   * @example
   * ```ts
   * // Basic decomposition
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * const transform = {
   *     position: new Point(),
   *     scale: new Point(),
   *     pivot: new Point(),
   *     skew: new Point(),
   *     rotation: 0
   * };
   *
   * matrix.decompose(transform);
   * console.log(transform.position); // Point(100, 100)
   * console.log(transform.rotation); // ~0.785 (PI/4)
   * console.log(transform.scale); // Point(2, 2)
   * ```
   * @remarks
   * - Handles combined transformations
   * - Accounts for pivot points
   * - Chooses between rotation/skew based on transform type
   * - Uses radians for rotation and skew
   * @param transform - The transform object to store the decomposed values
   * @returns The transform with the newly applied properties
   * @see {@link Matrix.setTransform} For composing from components
   * @see {@link TransformableObject} For transform structure
   */
  decompose(e) {
    const t = this.a, n = this.b, s = this.c, o = this.d, r = e.pivot, a = -Math.atan2(-s, o), l = Math.atan2(n, t), d = Math.abs(a + l);
    let c = Math.sqrt(t * t + n * n);
    return d < 1e-5 || Math.abs(cK - d) < 1e-5 ? (e.rotation = l, e.skew.x = e.skew.y = 0) : Math.abs(Math.PI - d) < 1e-5 ? (e.rotation = l - Math.PI, e.skew.x = e.skew.y = 0, c = -c) : (e.rotation = 0, e.skew.x = a, e.skew.y = l), e.scale.x = c, e.scale.y = Math.sqrt(s * s + o * o), e.position.x = this.tx + (r.x * t + r.y * s), e.position.y = this.ty + (r.x * n + r.y * o), e;
  }
  /**
   * Inverts this matrix.
   * Creates the matrix that when multiplied with this matrix results in an identity matrix.
   * @example
   * ```ts
   * // Basic matrix inversion
   * const matrix = new Matrix()
   *     .translate(100, 50)
   *     .scale(2, 2);
   *
   * matrix.invert(); // Now transforms in opposite direction
   *
   * // Verify inversion
   * const point = new Point(50, 50);
   * const transformed = matrix.apply(point);
   * const original = matrix.invert().apply(transformed);
   * // original ≈ point
   * ```
   * @remarks
   * - Modifies the current matrix
   * - Useful for reversing transformations
   * - Cannot invert matrices with zero determinant
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.applyInverse} For inverse transformations
   */
  invert() {
    const e = this.a, t = this.b, n = this.c, s = this.d, o = this.tx, r = e * s - t * n;
    return this.a = s / r, this.b = -t / r, this.c = -n / r, this.d = e / r, this.tx = (n * this.ty - s * o) / r, this.ty = -(e * this.ty - t * o) / r, this;
  }
  /**
   * Checks if this matrix is an identity matrix.
   *
   * An identity matrix has no transformations applied (default state).
   * @example
   * ```ts
   * // Check if matrix is identity
   * const matrix = new Matrix();
   * console.log(matrix.isIdentity()); // true
   *
   * // Check after transformations
   * matrix.translate(100, 0);
   * console.log(matrix.isIdentity()); // false
   *
   * // Reset and verify
   * matrix.identity();
   * console.log(matrix.isIdentity()); // true
   * ```
   * @remarks
   * - Verifies a = 1, d = 1 (no scale)
   * - Verifies b = 0, c = 0 (no skew)
   * - Verifies tx = 0, ty = 0 (no translation)
   * @returns True if matrix has no transformations
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   */
  isIdentity() {
    return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.tx === 0 && this.ty === 0;
  }
  /**
   * Resets this Matrix to an identity (default) matrix.
   * Sets all components to their default values: scale=1, no skew, no translation.
   * @example
   * ```ts
   * // Reset transformed matrix
   * const matrix = new Matrix()
   *     .scale(2, 2)
   *     .rotate(Math.PI / 4);
   * matrix.identity(); // Back to default state
   *
   * // Chain after reset
   * matrix
   *     .identity()
   *     .translate(100, 100)
   *     .scale(2, 2);
   *
   * // Compare with identity constant
   * const isDefault = matrix.equals(Matrix.IDENTITY);
   * ```
   * @remarks
   * - Sets a=1, d=1 (default scale)
   * - Sets b=0, c=0 (no skew)
   * - Sets tx=0, ty=0 (no translation)
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   * @see {@link Matrix.isIdentity} For checking identity state
   */
  identity() {
    return this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.tx = 0, this.ty = 0, this;
  }
  /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */
  clone() {
    const e = new st();
    return e.a = this.a, e.b = this.b, e.c = this.c, e.d = this.d, e.tx = this.tx, e.ty = this.ty, e;
  }
  /**
   * Creates a new Matrix object with the same values as this one.
   * @param matrix
   * @example
   * ```ts
   * // Basic matrix cloning
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const copy = matrix.clone();
   *
   * // Clone and modify
   * const modified = matrix.clone()
   *     .scale(2, 2);
   *
   * // Compare matrices
   * console.log(matrix.equals(copy));     // true
   * console.log(matrix.equals(modified)); // false
   * ```
   * @returns A copy of this matrix. Good for chaining method calls.
   * @see {@link Matrix.copyTo} For copying to existing matrix
   * @see {@link Matrix.copyFrom} For copying from another matrix
   */
  copyTo(e) {
    return e.a = this.a, e.b = this.b, e.c = this.c, e.d = this.d, e.tx = this.tx, e.ty = this.ty, e;
  }
  /**
   * Changes the values of the matrix to be the same as the ones in given matrix.
   * @example
   * ```ts
   * // Basic matrix copying
   * const source = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const target = new Matrix();
   * target.copyFrom(source);
   * ```
   * @param matrix - The matrix to copy from
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.clone} For creating new matrix copy
   * @see {@link Matrix.copyTo} For copying to another matrix
   */
  copyFrom(e) {
    return this.a = e.a, this.b = e.b, this.c = e.c, this.d = e.d, this.tx = e.tx, this.ty = e.ty, this;
  }
  /**
   * Checks if this matrix equals another matrix.
   * Compares all components for exact equality.
   * @example
   * ```ts
   * // Basic equality check
   * const m1 = new Matrix();
   * const m2 = new Matrix();
   * console.log(m1.equals(m2)); // true
   *
   * // Compare transformed matrices
   * const transform = new Matrix()
   *     .translate(100, 100)
   * const clone = new Matrix()
   *     .scale(2, 2);
   * console.log(transform.equals(clone)); // false
   * ```
   * @param matrix - The matrix to compare to
   * @returns True if matrices are identical
   * @see {@link Matrix.copyFrom} For copying matrix values
   * @see {@link Matrix.isIdentity} For identity comparison
   */
  equals(e) {
    return e.a === this.a && e.b === this.b && e.c === this.c && e.d === this.d && e.tx === this.tx && e.ty === this.ty;
  }
  toString() {
    return `[pixi.js:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
  }
  /**
   * A default (identity) matrix with no transformations applied.
   *
   * > [!IMPORTANT] This is a shared read-only object. Create a new Matrix if you need to modify it.
   * @example
   * ```ts
   * // Get identity matrix reference
   * const identity = Matrix.IDENTITY;
   * console.log(identity.isIdentity()); // true
   *
   * // Compare with identity
   * const matrix = new Matrix();
   * console.log(matrix.equals(Matrix.IDENTITY)); // true
   *
   * // Create new matrix instead of modifying IDENTITY
   * const transform = new Matrix()
   *     .copyFrom(Matrix.IDENTITY)
   *     .translate(100, 100);
   * ```
   * @readonly
   * @returns A read-only identity matrix
   * @see {@link Matrix.shared} For temporary calculations
   * @see {@link Matrix.identity} For resetting matrices
   */
  static get IDENTITY() {
    return fK.identity();
  }
  /**
   * A static Matrix that can be used to avoid creating new objects.
   * Will always ensure the matrix is reset to identity when requested.
   *
   * > [!IMPORTANT] This matrix is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempMatrix = Matrix.shared;
   * tempMatrix.translate(100, 100).rotate(Math.PI / 4);
   * const point = tempMatrix.apply({ x: 10, y: 20 });
   *
   * // Will be reset to identity on next access
   * const fresh = Matrix.shared; // Back to identity
   * ```
   * @remarks
   * - Always returns identity matrix
   * - Safe to modify temporarily
   * - Not safe to store references
   * - Useful for one-off calculations
   * @readonly
   * @returns A fresh identity matrix for temporary use
   * @see {@link Matrix.IDENTITY} For immutable identity matrix
   * @see {@link Matrix.identity} For resetting matrices
   */
  static get shared() {
    return pK.identity();
  }
}
const pK = new st(), fK = new st(), Ir = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1], Ar = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1], Pr = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1], Er = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1], Bv = [], dS = [], eh = Math.sign;
function mK() {
  for (let i = 0; i < 16; i++) {
    const e = [];
    Bv.push(e);
    for (let t = 0; t < 16; t++) {
      const n = eh(Ir[i] * Ir[t] + Pr[i] * Ar[t]), s = eh(Ar[i] * Ir[t] + Er[i] * Ar[t]), o = eh(Ir[i] * Pr[t] + Pr[i] * Er[t]), r = eh(Ar[i] * Pr[t] + Er[i] * Er[t]);
      for (let a = 0; a < 16; a++)
        if (Ir[a] === n && Ar[a] === s && Pr[a] === o && Er[a] === r) {
          e.push(a);
          break;
        }
    }
  }
  for (let i = 0; i < 16; i++) {
    const e = new st();
    e.set(Ir[i], Ar[i], Pr[i], Er[i], 0, 0), dS.push(e);
  }
}
mK();
const Mt = {
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  E: 0,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  SE: 1,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  S: 2,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  SW: 3,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  W: 4,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  NW: 5,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  N: 6,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @group groupD8
   * @type {GD8Symmetry}
   */
  NE: 7,
  /**
   * Reflection about Y-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  MIRROR_VERTICAL: 8,
  /**
   * Reflection about the main diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  MAIN_DIAGONAL: 10,
  /**
   * Reflection about X-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  MIRROR_HORIZONTAL: 12,
  /**
   * Reflection about reverse diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */
  REVERSE_DIAGONAL: 14,
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */
  uX: (i) => Ir[i],
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */
  uY: (i) => Ar[i],
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */
  vX: (i) => Pr[i],
  /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */
  vY: (i) => Er[i],
  /**
   * @group groupD8
   * @param {GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {GD8Symmetry} The opposite symmetry of `rotation`
   */
  inv: (i) => i & 8 ? i & 15 : -i & 7,
  /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {GD8Symmetry} Composed operation
   */
  add: (i, e) => Bv[i][e],
  /**
   * Reverse of `add`.
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation
   * @param {GD8Symmetry} rotationFirst - First operation
   * @returns {GD8Symmetry} Result
   */
  sub: (i, e) => Bv[i][Mt.inv(e)],
  /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @group groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */
  rotate180: (i) => i ^ 4,
  /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @group groupD8
   * @param {GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */
  isVertical: (i) => (i & 3) === 2,
  // rotation % 4 === 2
  /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @group groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */
  byDirection: (i, e) => Math.abs(i) * 2 <= Math.abs(e) ? e >= 0 ? Mt.S : Mt.N : Math.abs(e) * 2 <= Math.abs(i) ? i > 0 ? Mt.E : Mt.W : e > 0 ? i > 0 ? Mt.SE : Mt.SW : i > 0 ? Mt.NE : Mt.NW,
  /**
   * Helps sprite to compensate texture packer rotation.
   * @group groupD8
   * @param {Matrix} matrix - sprite world matrix
   * @param {GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   * @param {number} dw - sprite width
   * @param {number} dh - sprite height
   */
  matrixAppendRotationInv: (i, e, t = 0, n = 0, s = 0, o = 0) => {
    const r = dS[Mt.inv(e)], a = r.a, l = r.b, d = r.c, c = r.d, h = t - Math.min(0, a * s, d * o, a * s + d * o), f = n - Math.min(0, l * s, c * o, l * s + c * o), p = i.a, y = i.b, v = i.c, x = i.d;
    i.a = a * p + l * v, i.b = a * y + l * x, i.c = d * p + c * v, i.d = d * y + c * x, i.tx = h * p + f * v + i.tx, i.ty = h * y + f * x + i.ty;
  },
  /**
   * Transforms rectangle coordinates based on texture packer rotation.
   * Used when texture atlas pages are rotated and coordinates need to be adjusted.
   * @group groupD8
   * @param {RectangleLike} rect - Rectangle with original coordinates to transform
   * @param {RectangleLike} sourceFrame - Source texture frame (includes offset and dimensions)
   * @param {GD8Symmetry} rotation - The groupD8 rotation value
   * @param {Rectangle} out - Rectangle to store the result
   * @returns {Rectangle} Transformed coordinates (includes source frame offset)
   */
  transformRectCoords: (i, e, t, n) => {
    const { x: s, y: o, width: r, height: a } = i, { x: l, y: d, width: c, height: h } = e;
    return t === Mt.E ? (n.set(s + l, o + d, r, a), n) : t === Mt.S ? n.set(
      c - o - a + l,
      s + d,
      a,
      r
    ) : t === Mt.W ? n.set(
      c - s - r + l,
      h - o - a + d,
      r,
      a
    ) : t === Mt.N ? n.set(
      o + l,
      h - s - r + d,
      a,
      r
    ) : n.set(s + l, o + d, r, a);
  }
}, th = [new Wt(), new Wt(), new Wt(), new Wt()];
class Tt {
  /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */
  constructor(e = 0, t = 0, n = 0, s = 0) {
    this.type = "rectangle", this.x = Number(e), this.y = Number(t), this.width = Number(n), this.height = Number(s);
  }
  /**
   * Returns the left edge (x-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get left edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.left); // 100
   *
   * // Use in alignment calculations
   * sprite.x = rect.left + padding;
   *
   * // Compare positions
   * if (point.x > rect.left) {
   *     console.log('Point is right of rectangle');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the left edge
   * @see {@link Rectangle.right} For right edge position
   * @see {@link Rectangle.x} For direct x-coordinate access
   */
  get left() {
    return this.x;
  }
  /**
   * Returns the right edge (x + width) of the rectangle.
   * @example
   * ```ts
   * // Get right edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.right); // 300
   *
   * // Align to right edge
   * sprite.x = rect.right - sprite.width;
   *
   * // Check boundaries
   * if (point.x < rect.right) {
   *     console.log('Point is inside right bound');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the right edge
   * @see {@link Rectangle.left} For left edge position
   * @see {@link Rectangle.width} For width value
   */
  get right() {
    return this.x + this.width;
  }
  /**
   * Returns the top edge (y-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get top edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.top); // 100
   *
   * // Position above rectangle
   * sprite.y = rect.top - sprite.height;
   *
   * // Check vertical position
   * if (point.y > rect.top) {
   *     console.log('Point is below top edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the top edge
   * @see {@link Rectangle.bottom} For bottom edge position
   * @see {@link Rectangle.y} For direct y-coordinate access
   */
  get top() {
    return this.y;
  }
  /**
   * Returns the bottom edge (y + height) of the rectangle.
   * @example
   * ```ts
   * // Get bottom edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.bottom); // 250
   *
   * // Stack below rectangle
   * sprite.y = rect.bottom + margin;
   *
   * // Check vertical bounds
   * if (point.y < rect.bottom) {
   *     console.log('Point is above bottom edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the bottom edge
   * @see {@link Rectangle.top} For top edge position
   * @see {@link Rectangle.height} For height value
   */
  get bottom() {
    return this.y + this.height;
  }
  /**
   * Determines whether the Rectangle is empty (has no area).
   * @example
   * ```ts
   * // Check zero dimensions
   * const rect = new Rectangle(100, 100, 0, 50);
   * console.log(rect.isEmpty()); // true
   * ```
   * @returns True if the rectangle has no area
   * @see {@link Rectangle.width} For width value
   * @see {@link Rectangle.height} For height value
   */
  isEmpty() {
    return this.left === this.right || this.top === this.bottom;
  }
  /**
   * A constant empty rectangle. This is a new object every time the property is accessed.
   * @example
   * ```ts
   * // Get fresh empty rectangle
   * const empty = Rectangle.EMPTY;
   * console.log(empty.isEmpty()); // true
   * ```
   * @returns A new empty rectangle instance
   * @see {@link Rectangle.isEmpty} For empty state testing
   */
  static get EMPTY() {
    return new Tt(0, 0, 0, 0);
  }
  /**
   * Creates a clone of this Rectangle
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Rectangle(100, 100, 200, 150);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.width *= 2;
   * modified.height += 50;
   *
   * // Verify independence
   * console.log(original.width);  // 200
   * console.log(modified.width);  // 400
   * ```
   * @returns A copy of the rectangle
   * @see {@link Rectangle.copyFrom} For copying into existing rectangle
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   */
  clone() {
    return new Tt(this.x, this.y, this.width, this.height);
  }
  /**
   * Converts a Bounds object to a Rectangle object.
   * @example
   * ```ts
   * // Convert bounds to rectangle
   * const bounds = container.getBounds();
   * const rect = new Rectangle().copyFromBounds(bounds);
   * ```
   * @param bounds - The bounds to copy and convert to a rectangle
   * @returns Returns itself
   * @see {@link Bounds} For bounds object structure
   * @see {@link Rectangle.getBounds} For getting rectangle bounds
   */
  copyFromBounds(e) {
    return this.x = e.minX, this.y = e.minY, this.width = e.maxX - e.minX, this.height = e.maxY - e.minY, this;
  }
  /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new Rectangle()
   *     .copyFrom(source)
   *     .pad(10);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.width = e.width, this.height = e.height, this;
  }
  /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new Rectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isInside = rect.contains(150, 125); // true
   * // Check edge cases
   * console.log(rect.contains(100, 100)); // true (on edge)
   * console.log(rect.contains(300, 250)); // false (outside)
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   * @see {@link Rectangle.containsRect} For rectangle containment
   * @see {@link Rectangle.strokeContains} For checking stroke intersection
   */
  contains(e, t) {
    return this.width <= 0 || this.height <= 0 ? !1 : e >= this.x && e < this.x + this.width && t >= this.y && t < this.y + this.height;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link Rectangle.contains} For checking fill containment
   * @see {@link Rectangle.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, n, s = 0.5) {
    const { width: o, height: r } = this;
    if (o <= 0 || r <= 0) return !1;
    const a = this.x, l = this.y, d = n * (1 - s), c = n - d, h = a - d, f = a + o + d, p = l - d, y = l + r + d, v = a + c, x = a + o - c, w = l + c, S = l + r - c;
    return e >= h && e <= f && t >= p && t <= y && !(e > v && e < x && t > w && t < S);
  }
  /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */
  /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   *
   * Returns true only if the area of the intersection is greater than 0.
   * This means that rectangles sharing only a side are not considered intersecting.
   * @example
   * ```ts
   * // Basic intersection check
   * const rect1 = new Rectangle(0, 0, 100, 100);
   * const rect2 = new Rectangle(50, 50, 100, 100);
   * console.log(rect1.intersects(rect2)); // true
   *
   * // With transformation matrix
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // 45 degrees
   * console.log(rect1.intersects(rect2, matrix)); // Checks with rotation
   *
   * // Edge cases
   * const zeroWidth = new Rectangle(0, 0, 0, 100);
   * console.log(rect1.intersects(zeroWidth)); // false (no area)
   * ```
   * @remarks
   * - Returns true only if intersection area is > 0
   * - Rectangles sharing only a side are not intersecting
   * - Zero-area rectangles cannot intersect anything
   * - Supports optional transformation matrix
   * @param other - The Rectangle to intersect with `this`
   * @param transform - Optional transformation matrix of `other`
   * @returns True if the transformed `other` Rectangle intersects with `this`
   * @see {@link Rectangle.containsRect} For containment testing
   * @see {@link Rectangle.contains} For point testing
   */
  intersects(e, t) {
    if (!t) {
      const A = this.x < e.x ? e.x : this.x;
      if ((this.right > e.right ? e.right : this.right) <= A)
        return !1;
      const D = this.y < e.y ? e.y : this.y;
      return (this.bottom > e.bottom ? e.bottom : this.bottom) > D;
    }
    const n = this.left, s = this.right, o = this.top, r = this.bottom;
    if (s <= n || r <= o)
      return !1;
    const a = th[0].set(e.left, e.top), l = th[1].set(e.left, e.bottom), d = th[2].set(e.right, e.top), c = th[3].set(e.right, e.bottom);
    if (d.x <= a.x || l.y <= a.y)
      return !1;
    const h = Math.sign(t.a * t.d - t.b * t.c);
    if (h === 0 || (t.apply(a, a), t.apply(l, l), t.apply(d, d), t.apply(c, c), Math.max(a.x, l.x, d.x, c.x) <= n || Math.min(a.x, l.x, d.x, c.x) >= s || Math.max(a.y, l.y, d.y, c.y) <= o || Math.min(a.y, l.y, d.y, c.y) >= r))
      return !1;
    const f = h * (l.y - a.y), p = h * (a.x - l.x), y = f * n + p * o, v = f * s + p * o, x = f * n + p * r, w = f * s + p * r;
    if (Math.max(y, v, x, w) <= f * a.x + p * a.y || Math.min(y, v, x, w) >= f * c.x + p * c.y)
      return !1;
    const S = h * (a.y - d.y), M = h * (d.x - a.x), _ = S * n + M * o, T = S * s + M * o, k = S * n + M * r, P = S * s + M * r;
    return !(Math.max(_, T, k, P) <= S * a.x + M * a.y || Math.min(_, T, k, P) >= S * c.x + M * c.y);
  }
  /**
   * Pads the rectangle making it grow in all directions.
   *
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * // Basic padding
   * const rect = new Rectangle(100, 100, 200, 150);
   * rect.pad(10); // Adds 10px padding on all sides
   *
   * // Different horizontal and vertical padding
   * const uiRect = new Rectangle(0, 0, 100, 50);
   * uiRect.pad(20, 10); // 20px horizontal, 10px vertical
   * ```
   * @remarks
   * - Adjusts x/y by subtracting padding
   * - Increases width/height by padding * 2
   * - Common in UI layout calculations
   * - Chainable with other methods
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   */
  pad(e = 0, t = e) {
    return this.x -= e, this.y -= t, this.width += e * 2, this.height += t * 2, this;
  }
  /**
   * Fits this rectangle around the passed one.
   * @example
   * ```ts
   * // Basic fitting
   * const container = new Rectangle(0, 0, 100, 100);
   * const content = new Rectangle(25, 25, 200, 200);
   * content.fit(container); // Clips to container bounds
   * ```
   * @param rectangle - The rectangle to fit around
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */
  fit(e) {
    const t = Math.max(this.x, e.x), n = Math.min(this.x + this.width, e.x + e.width), s = Math.max(this.y, e.y), o = Math.min(this.y + this.height, e.y + e.height);
    return this.x = t, this.width = Math.max(n - t, 0), this.y = s, this.height = Math.max(o - s, 0), this;
  }
  /**
   * Enlarges rectangle so that its corners lie on a grid defined by resolution.
   * @example
   * ```ts
   * // Basic grid alignment
   * const rect = new Rectangle(10.2, 10.6, 100.8, 100.4);
   * rect.ceil(); // Aligns to whole pixels
   *
   * // Custom resolution grid
   * const uiRect = new Rectangle(5.3, 5.7, 50.2, 50.8);
   * uiRect.ceil(0.5); // Aligns to half pixels
   *
   * // Use with precision value
   * const preciseRect = new Rectangle(20.001, 20.999, 100.001, 100.999);
   * preciseRect.ceil(1, 0.01); // Handles small decimal variations
   * ```
   * @param resolution - The grid size to align to (1 = whole pixels)
   * @param eps - Small number to prevent floating point errors
   * @returns Returns itself
   * @see {@link Rectangle.fit} For constraining to bounds
   * @see {@link Rectangle.enlarge} For growing dimensions
   */
  ceil(e = 1, t = 1e-3) {
    const n = Math.ceil((this.x + this.width - t) * e) / e, s = Math.ceil((this.y + this.height - t) * e) / e;
    return this.x = Math.floor((this.x + t) * e) / e, this.y = Math.floor((this.y + t) * e) / e, this.width = n - this.x, this.height = s - this.y, this;
  }
  /**
   * Scales the rectangle's dimensions and position by the specified factors.
   * @example
   * ```ts
   * const rect = new Rectangle(50, 50, 100, 100);
   *
   * // Scale uniformly
   * rect.scale(0.5, 0.5);
   * // rect is now: x=25, y=25, width=50, height=50
   *
   * // non-uniformly
   * rect.scale(0.5, 1);
   * // rect is now: x=25, y=50, width=50, height=100
   * ```
   * @param x - The factor by which to scale the horizontal properties (x, width).
   * @param y - The factor by which to scale the vertical properties (y, height).
   * @returns Returns itself
   */
  scale(e, t = e) {
    return this.x *= e, this.y *= t, this.width *= e, this.height *= t, this;
  }
  /**
   * Enlarges this rectangle to include the passed rectangle.
   * @example
   * ```ts
   * // Basic enlargement
   * const rect = new Rectangle(50, 50, 100, 100);
   * const other = new Rectangle(0, 0, 200, 75);
   * rect.enlarge(other);
   * // rect is now: x=0, y=0, width=200, height=150
   *
   * // Use for bounding box calculation
   * const bounds = new Rectangle();
   * objects.forEach((obj) => {
   *     bounds.enlarge(obj.getBounds());
   * });
   * ```
   * @param rectangle - The rectangle to include
   * @returns Returns itself
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */
  enlarge(e) {
    const t = Math.min(this.x, e.x), n = Math.max(this.x + this.width, e.x + e.width), s = Math.min(this.y, e.y), o = Math.max(this.y + this.height, e.y + e.height);
    return this.x = t, this.width = n - t, this.y = s, this.height = o - s, this;
  }
  /**
   * Returns the framing rectangle of the rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds retrieval
   * const rect = new Rectangle(100, 100, 200, 150);
   * const bounds = rect.getBounds();
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle.copyFrom} For direct copying
   * @see {@link Rectangle.clone} For creating new copy
   */
  getBounds(e) {
    return e || (e = new Tt()), e.copyFrom(this), e;
  }
  /**
   * Determines whether another Rectangle is fully contained within this Rectangle.
   *
   * Rectangles that occupy the same space are considered to be containing each other.
   *
   * Rectangles without area (width or height equal to zero) can't contain anything,
   * not even other arealess rectangles.
   * @example
   * ```ts
   * // Check if one rectangle contains another
   * const container = new Rectangle(0, 0, 100, 100);
   * const inner = new Rectangle(25, 25, 50, 50);
   *
   * console.log(container.containsRect(inner)); // true
   *
   * // Check overlapping rectangles
   * const partial = new Rectangle(75, 75, 50, 50);
   * console.log(container.containsRect(partial)); // false
   *
   * // Zero-area rectangles can't contain anything
   * const empty = new Rectangle(0, 0, 0, 100);
   * console.log(empty.containsRect(inner)); // false
   * ```
   * @param other - The Rectangle to check for containment
   * @returns True if other is fully contained within this Rectangle
   * @see {@link Rectangle.contains} For point containment
   * @see {@link Rectangle.intersects} For overlap testing
   */
  containsRect(e) {
    if (this.width <= 0 || this.height <= 0) return !1;
    const t = e.x, n = e.y, s = e.x + e.width, o = e.y + e.height;
    return t >= this.x && t < this.x + this.width && n >= this.y && n < this.y + this.height && s >= this.x && s <= this.x + this.width && o >= this.y && o <= this.y + this.height;
  }
  /**
   * Sets the position and dimensions of the rectangle.
   * @example
   * ```ts
   * // Basic usage
   * const rect = new Rectangle();
   * rect.set(100, 100, 200, 150);
   *
   * // Chain with other operations
   * const bounds = new Rectangle()
   *     .set(0, 0, 100, 100)
   *     .pad(10);
   * ```
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   * @returns Returns itself for method chaining
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating a new copy
   */
  set(e, t, n, s) {
    return this.x = e, this.y = t, this.width = n, this.height = s, this;
  }
  toString() {
    return `[pixi.js/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
  }
}
const bg = {
  default: -1
};
function Nt(i = "default") {
  return bg[i] === void 0 && (bg[i] = -1), ++bg[i];
}
const ck = /* @__PURE__ */ new Set(), dn = "8.0.0", gK = "8.3.4", js = "8.21.0", bK = "8.22.0", al = {
  quiet: !1,
  noColor: !1
}, rt = ((i, e, t = 3) => {
  if (al.quiet || ck.has(e)) return;
  let n = new Error().stack;
  const s = `${e}
Deprecated since v${i}`, o = typeof console.groupCollapsed == "function" && !al.noColor;
  typeof n == "undefined" ? console.warn("PixiJS Deprecation Warning: ", s) : (n = n.split(`
`).splice(t).join(`
`), o ? (console.groupCollapsed(
    "%cPixiJS Deprecation Warning: %c%s",
    "color:#614108;background:#fffbe6",
    "font-weight:normal;color:#614108;background:#fffbe6",
    s
  ), console.warn(n), console.groupEnd()) : (console.warn("PixiJS Deprecation Warning: ", s), console.warn(n))), ck.add(e);
});
Object.defineProperties(rt, {
  quiet: {
    get: () => al.quiet,
    set: (i) => {
      al.quiet = i;
    },
    enumerable: !0,
    configurable: !1
  },
  noColor: {
    get: () => al.noColor,
    set: (i) => {
      al.noColor = i;
    },
    enumerable: !0,
    configurable: !1
  }
});
const cS = () => {
};
function Fv(i) {
  return i.endsWith("int");
}
function cf(i) {
  return i += i === 0 ? 1 : 0, --i, i |= i >>> 1, i |= i >>> 2, i |= i >>> 4, i |= i >>> 8, i |= i >>> 16, i + 1;
}
function $l(i) {
  return !(i & i - 1) && !!i;
}
function uS(i) {
  const e = {};
  for (const t in i)
    i[t] !== void 0 && (e[t] = i[t]);
  return e;
}
const uk = /* @__PURE__ */ Object.create(null);
function vK(i) {
  const e = uk[i];
  return e === void 0 && (uk[i] = Nt("resource")), e;
}
const hS = class pS extends bi {
  /**
   * @param options - options for the style
   */
  constructor(e = {}) {
    var t, n, s, o, r, a, l;
    super(), this._resourceType = "textureSampler", this._maxAnisotropy = 1, this.destroyed = !1, e = { ...pS.defaultOptions, ...e }, this.addressMode = e.addressMode, this.addressModeU = (t = e.addressModeU) != null ? t : this.addressModeU, this.addressModeV = (n = e.addressModeV) != null ? n : this.addressModeV, this.addressModeW = (s = e.addressModeW) != null ? s : this.addressModeW, this.scaleMode = e.scaleMode, this.magFilter = (o = e.magFilter) != null ? o : this.magFilter, this.minFilter = (r = e.minFilter) != null ? r : this.minFilter, this.mipmapFilter = (a = e.mipmapFilter) != null ? a : this.mipmapFilter, this.lodMinClamp = e.lodMinClamp, this.lodMaxClamp = e.lodMaxClamp, this.compare = e.compare, this.maxAnisotropy = (l = e.maxAnisotropy) != null ? l : 1;
  }
  set addressMode(e) {
    this.addressModeU = e, this.addressModeV = e, this.addressModeW = e;
  }
  /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */
  get addressMode() {
    return this.addressModeU;
  }
  set wrapMode(e) {
    rt(dn, "TextureStyle.wrapMode is now TextureStyle.addressMode"), this.addressMode = e;
  }
  get wrapMode() {
    return this.addressMode;
  }
  set scaleMode(e) {
    this.magFilter = e, this.minFilter = e, this.mipmapFilter = e;
  }
  /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */
  get scaleMode() {
    return this.magFilter;
  }
  /** Specifies the maximum anisotropy value clamp used by the sampler. */
  set maxAnisotropy(e) {
    this._maxAnisotropy = Math.min(e, 16), this._maxAnisotropy > 1 && (this.scaleMode = "linear");
  }
  get maxAnisotropy() {
    return this._maxAnisotropy;
  }
  // TODO - move this to WebGL?
  get _resourceId() {
    return this._sharedResourceId || this._generateResourceId();
  }
  update() {
    this._sharedResourceId = null, this.emit("change", this);
  }
  _generateResourceId() {
    const e = `${this.addressModeU}-${this.addressModeV}-${this.addressModeW}-${this.magFilter}-${this.minFilter}-${this.mipmapFilter}-${this.lodMinClamp}-${this.lodMaxClamp}-${this.compare}-${this._maxAnisotropy}`;
    return this._sharedResourceId = vK(e), this._resourceId;
  }
  /** Destroys the style */
  destroy() {
    this.destroyed = !0, this.emit("destroy", this), this.emit("change", this), this.removeAllListeners();
  }
};
hS.defaultOptions = {
  addressMode: "clamp-to-edge",
  scaleMode: "linear"
};
let xp = hS;
const fS = class mS extends bi {
  /**
   * @param options - options for creating a new TextureSource
   */
  constructor(e = {}) {
    var o, r, a, l, d, c;
    super(), this.options = e, this._gpuData = /* @__PURE__ */ Object.create(null), this._gcLastUsed = -1, this.uid = Nt("textureSource"), this._resourceType = "textureSource", this._resourceId = Nt("resource"), this.uploadMethodId = "unknown", this._resolution = 1, this.pixelWidth = 1, this.pixelHeight = 1, this.width = 1, this.height = 1, this.sampleCount = 1, this.mipLevelCount = 1, this.autoGenerateMipmaps = !1, this.format = "rgba8unorm", this.dimension = "2d", this.viewDimension = "2d", this.arrayLayerCount = 1, this.depth = 1, this._ownsStyle = !1, this.antialias = !1, this.transient = !1, this.storage = !1, this._batchTick = -1, this._textureBindLocation = -1;
    const t = e;
    e = { ...mS.defaultOptions, ...e };
    const n = yK(e), s = n === "3d" || n === "1d" ? n : "2d";
    xK(t, n, s), this.label = (o = e.label) != null ? o : "", this.resource = e.resource, this.autoGarbageCollect = e.autoGarbageCollect, this._resolution = e.resolution, e.width ? this.pixelWidth = e.width * this._resolution : this.pixelWidth = this.resource && (r = this.resourceWidth) != null ? r : 1, e.height ? this.pixelHeight = e.height * this._resolution : this.pixelHeight = this.resource && (a = this.resourceHeight) != null ? a : 1, this.width = this.pixelWidth / this._resolution, this.height = this.pixelHeight / this._resolution, this.format = e.format, this.dimension = s, this.viewDimension = n, this.arrayLayerCount = e.arrayLayerCount, this.depth = s === "3d" && (l = e.depth) != null ? l : 1, this.mipLevelCount = e.mipLevelCount, this.autoGenerateMipmaps = e.autoGenerateMipmaps, this.sampleCount = e.sampleCount, this.antialias = s === "3d" ? !1 : e.antialias, this.transient = (d = e.transient) != null ? d : !1, this.storage = (c = e.storage) != null ? c : !1, this.alphaMode = e.alphaMode, this.style = new xp(uS(e)), this._ownsStyle = !0, this.destroyed = !1, this._refreshPOT();
  }
  /**
   * The size along z that the GPU allocates: {@link TextureSource#depth} for a 3D texture,
   * {@link TextureSource#arrayLayerCount} otherwise. WebGPU's `depthOrArrayLayers`.
   */
  get depthOrArrayLayers() {
    return this.dimension === "3d" ? this.depth : this.arrayLayerCount || 1;
  }
  /** returns itself */
  get source() {
    return this;
  }
  /** the style of the texture */
  get style() {
    return this._style;
  }
  set style(e) {
    var t, n;
    this.style !== e && (this._ownsStyle = !1, (t = this._style) == null || t.off("change", this._onStyleChange, this), this._style = e, (n = this._style) == null || n.on("change", this._onStyleChange, this), this._onStyleChange());
  }
  /** Specifies the maximum anisotropy value clamp used by the sampler. */
  set maxAnisotropy(e) {
    this._style.maxAnisotropy = e;
  }
  get maxAnisotropy() {
    return this._style.maxAnisotropy;
  }
  /** setting this will set wrapModeU, wrapModeV and wrapModeW all at once! */
  get addressMode() {
    return this._style.addressMode;
  }
  set addressMode(e) {
    this._style.addressMode = e;
  }
  /** setting this will set wrapModeU, wrapModeV and wrapModeW all at once! */
  get repeatMode() {
    return this._style.addressMode;
  }
  set repeatMode(e) {
    this._style.addressMode = e;
  }
  /** Specifies the sampling behavior when the sample footprint is smaller than or equal to one texel. */
  get magFilter() {
    return this._style.magFilter;
  }
  set magFilter(e) {
    this._style.magFilter = e;
  }
  /** Specifies the sampling behavior when the sample footprint is larger than one texel. */
  get minFilter() {
    return this._style.minFilter;
  }
  set minFilter(e) {
    this._style.minFilter = e;
  }
  /** Specifies behavior for sampling between mipmap levels. */
  get mipmapFilter() {
    return this._style.mipmapFilter;
  }
  set mipmapFilter(e) {
    this._style.mipmapFilter = e;
  }
  /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */
  get lodMinClamp() {
    return this._style.lodMinClamp;
  }
  set lodMinClamp(e) {
    this._style.lodMinClamp = e;
  }
  /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */
  get lodMaxClamp() {
    return this._style.lodMaxClamp;
  }
  set lodMaxClamp(e) {
    this._style.lodMaxClamp = e;
  }
  _onStyleChange() {
    this.emit("styleChange", this);
  }
  /** call this if you have modified the texture outside of the constructor */
  update() {
    if (this.resource) {
      const e = this._resolution;
      if (this.resize(this.resourceWidth / e, this.resourceHeight / e)) return;
    }
    this.emit("update", this);
  }
  /** Destroys this texture source */
  destroy() {
    this.destroyed = !0, this.unload(), this.emit("destroy", this), this._style && (this._ownsStyle && this._style.destroy(), this._style = null), this.uploadMethodId = null, this.resource = null, this.removeAllListeners();
  }
  /**
   * This will unload the Texture source from the GPU. This will free up the GPU memory
   * As soon as it is required fore rendering, it will be re-uploaded.
   */
  unload() {
    var e, t;
    this._resourceId = Nt("resource"), this.emit("change", this), this.emit("unload", this);
    for (const n in this._gpuData)
      (t = (e = this._gpuData[n]) == null ? void 0 : e.destroy) == null || t.call(e);
    this._gpuData = /* @__PURE__ */ Object.create(null);
  }
  /** the width of the resource. This is the REAL pure number, not accounting resolution   */
  get resourceWidth() {
    const { resource: e } = this;
    return e.naturalWidth || e.videoWidth || e.displayWidth || e.width;
  }
  /** the height of the resource. This is the REAL pure number, not accounting resolution */
  get resourceHeight() {
    const { resource: e } = this;
    return e.naturalHeight || e.videoHeight || e.displayHeight || e.height;
  }
  /**
   * the resolution of the texture. Changing this number, will not change the number of pixels in the actual texture
   * but will the size of the texture when rendered.
   *
   * changing the resolution of this texture to 2 for example will make it appear twice as small when rendered (as pixel
   * density will have increased)
   */
  get resolution() {
    return this._resolution;
  }
  set resolution(e) {
    this._resolution !== e && (this._resolution = e, this.width = this.pixelWidth / e, this.height = this.pixelHeight / e);
  }
  /**
   * Resize the texture, this is handy if you want to use the texture as a render texture
   * @param width - the new width of the texture
   * @param height - the new height of the texture
   * @param resolution - the new resolution of the texture
   * @returns - if the texture was resized
   */
  resize(e, t, n) {
    n || (n = this._resolution), e || (e = this.width), t || (t = this.height);
    const s = Math.round(e * n), o = Math.round(t * n);
    return this.width = s / n, this.height = o / n, this._resolution = n, this.pixelWidth === s && this.pixelHeight === o ? !1 : (this._refreshPOT(), this.pixelWidth = s, this.pixelHeight = o, this.emit("resize", this), this._resourceId = Nt("resource"), this.emit("change", this), !0);
  }
  /**
   * Lets the renderer know that this texture has been updated and its mipmaps should be re-generated.
   * This is only important for RenderTexture instances, as standard Texture instances will have their
   * mipmaps generated on upload. You should call this method after you make any change to the texture
   *
   * The reason for this is is can be quite expensive to update mipmaps for a texture. So by default,
   * We want you, the developer to specify when this action should happen.
   *
   * Generally you don't want to have mipmaps generated on Render targets that are changed every frame,
   */
  updateMipmaps() {
    this.autoGenerateMipmaps && this.mipLevelCount > 1 && this.emit("updateMipmaps", this);
  }
  set wrapMode(e) {
    this._style.wrapMode = e;
  }
  get wrapMode() {
    return this._style.wrapMode;
  }
  set scaleMode(e) {
    this._style.scaleMode = e;
  }
  /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */
  get scaleMode() {
    return this._style.scaleMode;
  }
  /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */
  _refreshPOT() {
    this.isPowerOfTwo = $l(this.pixelWidth) && $l(this.pixelHeight);
  }
  static test(e) {
    throw new Error("Unimplemented");
  }
};
fS.defaultOptions = {
  resolution: 1,
  format: "bgra8unorm",
  alphaMode: "premultiply-alpha-on-upload",
  arrayLayerCount: 1,
  mipLevelCount: 1,
  autoGenerateMipmaps: !1,
  sampleCount: 1,
  antialias: !1,
  autoGarbageCollect: !1
};
let un = fS;
function yK(i) {
  return i.viewDimension ? i.viewDimension : i.depth ? "3d" : i.arrayLayerCount > 1 ? "2d-array" : "2d";
}
function xK(i, e, t) {
  if (i.depth !== void 0 && typeof i.depth != "number")
    throw new Error(`[TextureSource] depth is a 3D texture's depth in texels, but got ${i.depth}. For a depth buffer, use the depth option of a RenderTarget or the renderer.`);
  if (i.depth && i.arrayLayerCount > 1)
    throw new Error("[TextureSource] depth and arrayLayerCount can't be combined: use depth for a 3D texture or arrayLayerCount for a 2D array.");
  if (i.depth && e !== "3d")
    throw new Error(`[TextureSource] depth makes a 3D texture, but viewDimension is '${e}'. Use arrayLayerCount for layered textures.`);
  if (e === "3d" && i.arrayLayerCount > 1)
    throw new Error("[TextureSource] a 3D texture takes depth, not arrayLayerCount.");
  if (i.dimensions && i.dimensions !== t)
    throw new Error(`[TextureSource] dimensions '${i.dimensions}' doesn't match viewDimension '${e}'. Leave dimensions out; it is derived from the view.`);
  if (i.dimensions && rt(bK, "TextureSource dimensions is derived from viewDimension and depth; leave it out."), t === "3d" && i.antialias)
    throw new Error("[TextureSource] a 3D texture can't be antialiased: WebGPU has no multisampled 3D textures.");
}
class W1 extends un {
  constructor(e) {
    var r, a;
    const t = (a = (r = e.depth) != null ? r : e.arrayLayerCount) != null ? a : 1, n = e.resource || new Float32Array(e.width * e.height * t * 4);
    let s = e.format;
    s || (n instanceof Float32Array ? s = "rgba32float" : n instanceof Int32Array || n instanceof Uint32Array ? s = "rgba32uint" : n instanceof Int16Array || n instanceof Uint16Array ? s = "rgba16uint" : (n instanceof Int8Array, s = "bgra8unorm"));
    const o = Fv(s) || t > 1;
    super({
      ...o && { alphaMode: "no-premultiply-alpha" },
      ...e,
      resource: n,
      format: s
    }), this.uploadMethodId = "buffer", this._updateStart = 0, this._updateEnd = 1 / 0;
  }
  /**
   * Uploads the buffer to the GPU. Call this after changing the data in {@link TextureSource#resource}.
   *
   * The buffer is a flat list of texels in row-major order, so texel `i` sits at
   * `x = i % width`, `y = floor(i / width)`. Pass a texel range to upload only that part of
   * the texture; leave it out to upload everything.
   *
   * The upload happens immediately for every renderer that already holds the texture, and the
   * range applies to this call only. If you change several parts of the buffer, track the dirty
   * span yourself and call `update` once with the combined range. Each call has a fixed cost on
   * top of the bytes it moves, which reaches tens of microseconds on some mobile GPUs. One span
   * usually beats many small calls.
   *
   * Partial uploads assume the buffer holds exactly `width * height` texels. A 3D texture or 2D array
   * always uploads whole, so it takes no range.
   * @example
   * ```ts
   * const data = new Float32Array(4096 * 64 * 4);
   * const source = new BufferImageSource({ resource: data, width: 4096, height: 64 });
   *
   * // change texels 100 to 115 (4 floats per rgba32float texel)
   * data.fill(1, 100 * 4, 116 * 4);
   *
   * // upload only those 16 texels
   * source.update(100, 116);
   * ```
   * @param start - index of the first texel to upload
   * @param end - index one past the last texel to upload (exclusive, like `TypedArray.subarray`)
   */
  update(e = 0, t = 1 / 0) {
    if ((e > 0 || t < 1 / 0) && this.depthOrArrayLayers > 1)
      throw new Error("[BufferImageSource] a 3D texture or 2D array uploads whole: call update() with no range.");
    this._updateStart = e, this._updateEnd = t, super.update(), this._updateStart = 0, this._updateEnd = 1 / 0;
  }
  static test(e) {
    return e instanceof Int8Array || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int16Array || e instanceof Uint16Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Float32Array;
  }
}
W1.extension = Ie.TextureSource;
const hk = new st();
class gS {
  /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */
  constructor(e, t) {
    this.mapCoord = new st(), this.uClampFrame = new Float32Array(4), this.uClampOffset = new Float32Array(2), this._updateID = 0, this.clampOffset = 0, typeof t == "undefined" ? this.clampMargin = e.width < 10 ? 0 : 0.5 : this.clampMargin = t, this.isSimple = !1, this.texture = e;
  }
  /** Texture property. */
  get texture() {
    return this._texture;
  }
  set texture(e) {
    var t;
    this._texture !== e && ((t = this._texture) == null || t.removeListener("update", this.update, this), this._texture = e, this._texture.addListener("update", this.update, this)), this.update();
  }
  /** Releases the observed texture, removing the `update` listener from it. */
  destroy() {
    var e;
    (e = this._texture) == null || e.removeListener("update", this.update, this), this._texture = null;
  }
  /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */
  multiplyUvs(e, t) {
    t === void 0 && (t = e);
    const n = this.mapCoord;
    for (let s = 0; s < e.length; s += 2) {
      const o = e[s], r = e[s + 1];
      t[s] = o * n.a + r * n.c + n.tx, t[s + 1] = o * n.b + r * n.d + n.ty;
    }
    return t;
  }
  /**
   * Updates matrices if texture was changed
   * @returns - whether or not it was updated
   */
  update() {
    const e = this._texture;
    this._updateID++;
    const t = e.uvs;
    this.mapCoord.set(t.x1 - t.x0, t.y1 - t.y0, t.x3 - t.x0, t.y3 - t.y0, t.x0, t.y0);
    const n = e.orig, s = e.trim;
    s && (hk.set(
      n.width / s.width,
      0,
      0,
      n.height / s.height,
      -s.x / s.width,
      -s.y / s.height
    ), this.mapCoord.append(hk));
    const o = e.source, r = this.uClampFrame, a = this.clampMargin / o._resolution, l = this.clampOffset / o._resolution;
    return r[0] = (e.frame.x + a + l) / o.width, r[1] = (e.frame.y + a + l) / o.height, r[2] = (e.frame.x + e.frame.width - a + l) / o.width, r[3] = (e.frame.y + e.frame.height - a + l) / o.height, this.uClampOffset[0] = this.clampOffset / o.pixelWidth, this.uClampOffset[1] = this.clampOffset / o.pixelHeight, this.isSimple = e.frame.width === o.width && e.frame.height === o.height && e.rotate === 0, !0;
  }
}
class et extends bi {
  /**
   * @param {TextureOptions} options - Options for the texture
   */
  constructor({
    source: e,
    label: t,
    frame: n,
    orig: s,
    trim: o,
    defaultAnchor: r,
    defaultBorders: a,
    rotate: l,
    dynamic: d
  } = {}) {
    var c;
    if (super(), this.uid = Nt("texture"), this.uvs = { x0: 0, y0: 0, x1: 0, y1: 0, x2: 0, y2: 0, x3: 0, y3: 0 }, this.frame = new Tt(), this.noFrame = !1, this.dynamic = !1, this.isTexture = !0, this.label = t, this.source = (c = e == null ? void 0 : e.source) != null ? c : new un(), this.noFrame = !n, n)
      this.frame.copyFrom(n);
    else {
      const { width: h, height: f } = this._source;
      this.frame.width = h, this.frame.height = f;
    }
    this.orig = s || this.frame, this.trim = o, this.rotate = l != null ? l : 0, this.defaultAnchor = r, this.defaultBorders = a, this.destroyed = !1, this.dynamic = d || !1, this.updateUvs();
  }
  set source(e) {
    this._source && this._source.off("resize", this.update, this), this._source = e, e.on("resize", this.update, this), this.emit("update", this);
  }
  /** the underlying source of the texture (equivalent of baseTexture in v7) */
  get source() {
    return this._source;
  }
  /** returns a TextureMatrix instance for this texture. By default, that object is not created because its heavy. */
  get textureMatrix() {
    return this._textureMatrix || (this._textureMatrix = new gS(this)), this._textureMatrix;
  }
  /** The width of the Texture in pixels. */
  get width() {
    return this.orig.width;
  }
  /** The height of the Texture in pixels. */
  get height() {
    return this.orig.height;
  }
  /** Call this function when you have modified the frame of this texture. */
  updateUvs() {
    const { uvs: e, frame: t } = this, { width: n, height: s } = this._source, o = t.x / n, r = t.y / s, a = t.width / n, l = t.height / s;
    let d = this.rotate;
    if (d) {
      const c = a / 2, h = l / 2, f = o + c, p = r + h;
      d = Mt.add(d, Mt.NW), e.x0 = f + c * Mt.uX(d), e.y0 = p + h * Mt.uY(d), d = Mt.add(d, 2), e.x1 = f + c * Mt.uX(d), e.y1 = p + h * Mt.uY(d), d = Mt.add(d, 2), e.x2 = f + c * Mt.uX(d), e.y2 = p + h * Mt.uY(d), d = Mt.add(d, 2), e.x3 = f + c * Mt.uX(d), e.y3 = p + h * Mt.uY(d);
    } else
      e.x0 = o, e.y0 = r, e.x1 = o + a, e.y1 = r, e.x2 = o + a, e.y2 = r + l, e.x3 = o, e.y3 = r + l;
  }
  /**
   * Destroys this texture
   * @param destroySource - Destroy the source when the texture is destroyed.
   */
  destroy(e = !1) {
    this._source && (this._source.off("resize", this.update, this), e && (this._source.destroy(), this._source = null)), this._textureMatrix = null, this.destroyed = !0, this.emit("destroy", this), this.removeAllListeners();
  }
  /**
   * Call this if you have modified the `texture outside` of the constructor.
   *
   * If you have modified this texture's source, you must separately call `texture.source.update()` to see those changes.
   */
  update() {
    this.noFrame && (this.frame.width = this._source.width, this.frame.height = this._source.height), this.updateUvs(), this.emit("update", this);
  }
  /** @deprecated since 8.0.0 */
  get baseTexture() {
    return rt(dn, "Texture.baseTexture is now Texture.source"), this._source;
  }
}
et.EMPTY = new et({
  label: "EMPTY",
  source: new un({
    label: "EMPTY"
  })
});
et.EMPTY.destroy = cS;
et.WHITE = new et({
  source: new W1({
    resource: new Uint8Array([255, 255, 255, 255]),
    width: 1,
    height: 1,
    alphaMode: "premultiply-alpha-on-upload",
    label: "WHITE"
  }),
  label: "WHITE"
});
et.WHITE.destroy = cS;
function wK(i, e, t) {
  const { width: n, height: s } = t.orig, o = t.trim;
  if (o) {
    const r = o.width, a = o.height;
    i.minX = o.x - e._x * n, i.maxX = i.minX + r, i.minY = o.y - e._y * s, i.maxY = i.minY + a;
  } else
    i.minX = -e._x * n, i.maxX = i.minX + n, i.minY = -e._y * s, i.maxY = i.minY + s;
}
const pk = new st();
class Gn {
  /**
   * Creates a new Bounds object.
   * @param minX - The minimum X coordinate of the bounds.
   * @param minY - The minimum Y coordinate of the bounds.
   * @param maxX - The maximum X coordinate of the bounds.
   * @param maxY - The maximum Y coordinate of the bounds.
   */
  constructor(e = 1 / 0, t = 1 / 0, n = -1 / 0, s = -1 / 0) {
    this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.matrix = pk, this.minX = e, this.minY = t, this.maxX = n, this.maxY = s;
  }
  /**
   * Checks if bounds are empty, meaning either width or height is zero or negative.
   * Empty bounds occur when min values exceed max values on either axis.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Check if newly created bounds are empty
   * console.log(bounds.isEmpty()); // true, default bounds are empty
   *
   * // Add frame and check again
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false, bounds now have area
   *
   * // Clear bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true, bounds are empty again
   * ```
   * @returns True if bounds are empty (have no area)
   * @see {@link Bounds#clear} For resetting bounds
   * @see {@link Bounds#isValid} For checking validity
   */
  isEmpty() {
    return this.minX > this.maxX || this.minY > this.maxY;
  }
  /**
   * The bounding rectangle representation of these bounds.
   * Lazily creates and updates a Rectangle instance based on the current bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Get rectangle representation
   * const rect = bounds.rectangle;
   * console.log(rect.x, rect.y, rect.width, rect.height);
   *
   * // Use for hit testing
   * if (bounds.rectangle.contains(mouseX, mouseY)) {
   *     console.log('Mouse is inside bounds!');
   * }
   * ```
   * @see {@link Rectangle} For rectangle methods
   * @see {@link Bounds.isEmpty} For bounds validation
   */
  get rectangle() {
    this._rectangle || (this._rectangle = new Tt());
    const e = this._rectangle;
    return this.minX > this.maxX || this.minY > this.maxY ? (e.x = 0, e.y = 0, e.width = 0, e.height = 0) : e.copyFromBounds(this), e;
  }
  /**
   * Clears the bounds and resets all coordinates to their default values.
   * Resets the transformation matrix back to identity.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false
   * // Clear the bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true
   * ```
   * @returns This bounds object for chaining
   */
  clear() {
    return this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.matrix = pk, this;
  }
  /**
   * Sets the bounds directly using coordinate values.
   * Provides a way to set all bounds values at once.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(0, 0, 100, 100);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @see {@link Bounds#addFrame} For matrix-aware bounds setting
   * @see {@link Bounds#clear} For resetting bounds
   */
  set(e, t, n, s) {
    this.minX = e, this.minY = t, this.maxX = n, this.maxY = s;
  }
  /**
   * Adds a rectangular frame to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the new frame coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.addFrame(0, 0, 100, 100);
   *
   * // Add transformed frame
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addFrame(0, 0, 100, 100, matrix);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addRect} For adding Rectangle objects
   * @see {@link Bounds#addBounds} For adding other Bounds
   */
  addFrame(e, t, n, s, o) {
    o || (o = this.matrix);
    const r = o.a, a = o.b, l = o.c, d = o.d, c = o.tx, h = o.ty;
    let f = this.minX, p = this.minY, y = this.maxX, v = this.maxY, x = r * e + l * t + c, w = a * e + d * t + h;
    x < f && (f = x), w < p && (p = w), x > y && (y = x), w > v && (v = w), x = r * n + l * t + c, w = a * n + d * t + h, x < f && (f = x), w < p && (p = w), x > y && (y = x), w > v && (v = w), x = r * e + l * s + c, w = a * e + d * s + h, x < f && (f = x), w < p && (p = w), x > y && (y = x), w > v && (v = w), x = r * n + l * s + c, w = a * n + d * s + h, x < f && (f = x), w < p && (p = w), x > y && (y = x), w > v && (v = w), this.minX = f, this.minY = p, this.maxX = y, this.maxY = v;
  }
  /**
   * Adds a rectangle to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the given rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * // Add simple rectangle
   * const rect = new Rectangle(0, 0, 100, 100);
   * bounds.addRect(rect);
   *
   * // Add transformed rectangle
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addRect(rect, matrix);
   * ```
   * @param rect - The rectangle to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addBounds} For adding other bounds
   */
  addRect(e, t) {
    this.addFrame(e.x, e.y, e.x + e.width, e.y + e.height, t);
  }
  /**
   * Adds another bounds object to this one, optionally transformed by a matrix.
   * Expands the bounds to include the given bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add child bounds
   * const childBounds = sprite.getBounds();
   * bounds.addBounds(childBounds);
   *
   * // Add transformed bounds
   * const matrix = new Matrix()
   *     .scale(2, 2);
   * bounds.addBounds(childBounds, matrix);
   * ```
   * @param bounds - The bounds to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addRect} For adding rectangles
   */
  addBounds(e, t) {
    this.addFrame(e.minX, e.minY, e.maxX, e.maxY, t);
  }
  /**
   * Adds other Bounds as a mask, creating an intersection of the two bounds.
   * Only keeps the overlapping region between current bounds and mask bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Create mask bounds
   * const mask = new Bounds();
   * mask.addFrame(50, 50, 150, 150);
   * // Apply mask - results in bounds of (50,50,100,100)
   * bounds.addBoundsMask(mask);
   * ```
   * @param mask - The Bounds to use as a mask
   * @see {@link Bounds#addBounds} For union operation
   * @see {@link Bounds#fit} For fitting to rectangle
   */
  addBoundsMask(e) {
    this.minX = this.minX > e.minX ? this.minX : e.minX, this.minY = this.minY > e.minY ? this.minY : e.minY, this.maxX = this.maxX < e.maxX ? this.maxX : e.maxX, this.maxY = this.maxY < e.maxY ? this.maxY : e.maxY;
  }
  /**
   * Applies a transformation matrix to the bounds, updating its coordinates.
   * Transforms all corners of the bounds using the given matrix.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Apply translation
   * const translateMatrix = new Matrix()
   *     .translate(50, 50);
   * bounds.applyMatrix(translateMatrix);
   * ```
   * @param matrix - The matrix to apply to the bounds
   * @see {@link Matrix} For matrix operations
   * @see {@link Bounds#addFrame} For adding transformed frames
   */
  applyMatrix(e) {
    const t = this.minX, n = this.minY, s = this.maxX, o = this.maxY, { a: r, b: a, c: l, d, tx: c, ty: h } = e;
    let f = r * t + l * n + c, p = a * t + d * n + h;
    this.minX = f, this.minY = p, this.maxX = f, this.maxY = p, f = r * s + l * n + c, p = a * s + d * n + h, this.minX = f < this.minX ? f : this.minX, this.minY = p < this.minY ? p : this.minY, this.maxX = f > this.maxX ? f : this.maxX, this.maxY = p > this.maxY ? p : this.maxY, f = r * t + l * o + c, p = a * t + d * o + h, this.minX = f < this.minX ? f : this.minX, this.minY = p < this.minY ? p : this.minY, this.maxX = f > this.maxX ? f : this.maxX, this.maxY = p > this.maxY ? p : this.maxY, f = r * s + l * o + c, p = a * s + d * o + h, this.minX = f < this.minX ? f : this.minX, this.minY = p < this.minY ? p : this.minY, this.maxX = f > this.maxX ? f : this.maxX, this.maxY = p > this.maxY ? p : this.maxY;
  }
  /**
   * Resizes the bounds object to fit within the given rectangle.
   * Clips the bounds if they extend beyond the rectangle's edges.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit within viewport
   * const viewport = new Rectangle(50, 50, 100, 100);
   * bounds.fit(viewport);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param rect - The rectangle to fit within
   * @returns This bounds object for chaining
   * @see {@link Bounds#addBoundsMask} For intersection
   * @see {@link Bounds#pad} For expanding bounds
   */
  fit(e) {
    return this.minX < e.left && (this.minX = e.left), this.maxX > e.right && (this.maxX = e.right), this.minY < e.top && (this.minY = e.top), this.maxY > e.bottom && (this.maxY = e.bottom), this;
  }
  /**
   * Resizes the bounds object to include the given bounds.
   * Similar to fit() but works with raw coordinate values instead of a Rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit to specific coordinates
   * bounds.fitBounds(50, 150, 50, 150);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param left - The left value of the bounds
   * @param right - The right value of the bounds
   * @param top - The top value of the bounds
   * @param bottom - The bottom value of the bounds
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For fitting to Rectangle
   * @see {@link Bounds#addBoundsMask} For intersection
   */
  fitBounds(e, t, n, s) {
    return this.minX < e && (this.minX = e), this.maxX > t && (this.maxX = t), this.minY < n && (this.minY = n), this.maxY > s && (this.maxY = s), this;
  }
  /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Add equal padding
   * bounds.pad(10);
   * // bounds are now (-10, -10, 110, 110)
   *
   * // Add different padding for x and y
   * bounds.pad(20, 10);
   * // bounds are now (-30, -20, 130, 120)
   * ```
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For constraining bounds
   * @see {@link Bounds#scale} For uniform scaling
   */
  pad(e, t = e) {
    return this.minX -= e, this.maxX += e, this.minY -= t, this.maxY += t, this;
  }
  /**
   * Ceils the bounds by rounding up max values and rounding down min values.
   * Useful for pixel-perfect calculations and avoiding fractional pixels.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(10.2, 10.9, 50.1, 50.8);
   *
   * // Round to whole pixels
   * bounds.ceil();
   * // bounds are now (10, 10, 51, 51)
   * ```
   * @returns This bounds object for chaining
   * @see {@link Bounds#scale} For size adjustments
   * @see {@link Bounds#fit} For constraining bounds
   */
  ceil() {
    return this.minX = Math.floor(this.minX), this.minY = Math.floor(this.minY), this.maxX = Math.ceil(this.maxX), this.maxY = Math.ceil(this.maxY), this;
  }
  /**
   * Creates a new Bounds instance with the same values.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Create a copy
   * const copy = bounds.clone();
   *
   * // Original and copy are independent
   * bounds.pad(10);
   * console.log(copy.width === bounds.width); // false
   * ```
   * @returns A new Bounds instance with the same values
   * @see {@link Bounds#copyFrom} For reusing existing bounds
   */
  clone() {
    return new Gn(this.minX, this.minY, this.maxX, this.maxY);
  }
  /**
   * Scales the bounds by the given values, adjusting all edges proportionally.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Scale uniformly
   * bounds.scale(2);
   * // bounds are now (0, 0, 200, 200)
   *
   * // Scale non-uniformly
   * bounds.scale(0.5, 2);
   * // bounds are now (0, 0, 100, 400)
   * ```
   * @param x - The X value to scale by
   * @param y - The Y value to scale by (defaults to x)
   * @returns This bounds object for chaining
   * @see {@link Bounds#pad} For adding padding
   * @see {@link Bounds#fit} For constraining size
   */
  scale(e, t = e) {
    return this.minX *= e, this.minY *= t, this.maxX *= e, this.maxY *= t, this;
  }
  /**
   * The x position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its width.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get x position
   * console.log(bounds.x); // 0
   *
   * // Move bounds horizontally
   * bounds.x = 50;
   * console.log(bounds.minX, bounds.maxX); // 50, 150
   *
   * // Width stays the same
   * console.log(bounds.width); // Still 100
   * ```
   */
  get x() {
    return this.minX;
  }
  set x(e) {
    const t = this.maxX - this.minX;
    this.minX = e, this.maxX = e + t;
  }
  /**
   * The y position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its height.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get y position
   * console.log(bounds.y); // 0
   *
   * // Move bounds vertically
   * bounds.y = 50;
   * console.log(bounds.minY, bounds.maxY); // 50, 150
   *
   * // Height stays the same
   * console.log(bounds.height); // Still 100
   * ```
   */
  get y() {
    return this.minY;
  }
  set y(e) {
    const t = this.maxY - this.minY;
    this.minY = e, this.maxY = e + t;
  }
  /**
   * The width value of the bounds.
   * Represents the distance between minX and maxX coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get width
   * console.log(bounds.width); // 100
   * // Resize width
   * bounds.width = 200;
   * console.log(bounds.maxX - bounds.minX); // 200
   * ```
   */
  get width() {
    return this.maxX - this.minX;
  }
  set width(e) {
    this.maxX = this.minX + e;
  }
  /**
   * The height value of the bounds.
   * Represents the distance between minY and maxY coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get height
   * console.log(bounds.height); // 100
   * // Resize height
   * bounds.height = 150;
   * console.log(bounds.maxY - bounds.minY); // 150
   * ```
   */
  get height() {
    return this.maxY - this.minY;
  }
  set height(e) {
    this.maxY = this.minY + e;
  }
  /**
   * The left edge coordinate of the bounds.
   * Alias for minX.
   * @example
   * ```ts
   * const bounds = new Bounds(50, 0, 150, 100);
   * console.log(bounds.left); // 50
   * console.log(bounds.left === bounds.minX); // true
   * ```
   * @readonly
   */
  get left() {
    return this.minX;
  }
  /**
   * The right edge coordinate of the bounds.
   * Alias for maxX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.right); // 100
   * console.log(bounds.right === bounds.maxX); // true
   * ```
   * @readonly
   */
  get right() {
    return this.maxX;
  }
  /**
   * The top edge coordinate of the bounds.
   * Alias for minY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 25, 100, 125);
   * console.log(bounds.top); // 25
   * console.log(bounds.top === bounds.minY); // true
   * ```
   * @readonly
   */
  get top() {
    return this.minY;
  }
  /**
   * The bottom edge coordinate of the bounds.
   * Alias for maxY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 200);
   * console.log(bounds.bottom); // 200
   * console.log(bounds.bottom === bounds.maxY); // true
   * ```
   * @readonly
   */
  get bottom() {
    return this.maxY;
  }
  /**
   * Whether the bounds has positive width and height.
   * Checks if both dimensions are greater than zero.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Check if bounds are positive
   * console.log(bounds.isPositive); // true
   *
   * // Negative bounds
   * bounds.maxX = bounds.minX;
   * console.log(bounds.isPositive); // false, width is 0
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isValid} For checking validity
   */
  get isPositive() {
    return this.maxX - this.minX > 0 && this.maxY - this.minY > 0;
  }
  /**
   * Whether the bounds has valid coordinates.
   * Checks if the bounds has been initialized with real values.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * console.log(bounds.isValid); // false, default state
   *
   * // Set valid bounds
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isValid); // true
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isPositive} For checking dimensions
   */
  get isValid() {
    return this.minX + this.minY !== 1 / 0;
  }
  /**
   * Adds vertices from a Float32Array to the bounds, optionally transformed by a matrix.
   * Used for efficiently updating bounds from raw vertex data.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add vertices from geometry
   * const vertices = new Float32Array([
   *     0, 0,    // Vertex 1
   *     100, 0,  // Vertex 2
   *     100, 100 // Vertex 3
   * ]);
   * bounds.addVertexData(vertices, 0, 6);
   *
   * // Add transformed vertices
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addVertexData(vertices, 0, 6, matrix);
   *
   * // Add subset of vertices
   * bounds.addVertexData(vertices, 2, 4); // Only second vertex
   * ```
   * @param vertexData - The array of vertices to add
   * @param beginOffset - Starting index in the vertex array
   * @param endOffset - Ending index in the vertex array (excluded)
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding rectangular frames
   * @see {@link Matrix} For transformation details
   */
  addVertexData(e, t, n, s) {
    let o = this.minX, r = this.minY, a = this.maxX, l = this.maxY;
    s || (s = this.matrix);
    const d = s.a, c = s.b, h = s.c, f = s.d, p = s.tx, y = s.ty;
    for (let v = t; v < n; v += 2) {
      const x = e[v], w = e[v + 1], S = d * x + h * w + p, M = c * x + f * w + y;
      o = S < o ? S : o, r = M < r ? M : r, a = S > a ? S : a, l = M > l ? M : l;
    }
    this.minX = o, this.minY = r, this.maxX = a, this.maxY = l;
  }
  /**
   * Checks if a point is contained within the bounds.
   * Returns true if the point's coordinates fall within the bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Basic point check
   * console.log(bounds.containsPoint(50, 50)); // true
   * console.log(bounds.containsPoint(150, 150)); // false
   *
   * // Check edges
   * console.log(bounds.containsPoint(0, 0));   // true, includes edges
   * console.log(bounds.containsPoint(100, 100)); // true, includes edges
   * ```
   * @param x - x coordinate to check
   * @param y - y coordinate to check
   * @returns True if the point is inside the bounds
   * @see {@link Bounds#isPositive} For valid bounds check
   * @see {@link Bounds#rectangle} For Rectangle representation
   */
  containsPoint(e, t) {
    return this.minX <= e && this.minY <= t && this.maxX >= e && this.maxY >= t;
  }
  /**
   * Returns a string representation of the bounds.
   * Useful for debugging and logging bounds information.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.toString()); // "[pixi.js:Bounds minX=0 minY=0 maxX=100 maxY=100 width=100 height=100]"
   * ```
   * @returns A string describing the bounds
   * @see {@link Bounds#copyFrom} For copying bounds
   * @see {@link Bounds#clone} For creating a new instance
   */
  toString() {
    return `[pixi.js:Bounds minX=${this.minX} minY=${this.minY} maxX=${this.maxX} maxY=${this.maxY} width=${this.width} height=${this.height}]`;
  }
  /**
   * Copies the bounds from another bounds object.
   * Useful for reusing bounds objects and avoiding allocations.
   * @example
   * ```ts
   * const sourceBounds = new Bounds(0, 0, 100, 100);
   * // Copy bounds
   * const targetBounds = new Bounds();
   * targetBounds.copyFrom(sourceBounds);
   * ```
   * @param bounds - The bounds to copy from
   * @returns This bounds object for chaining
   * @see {@link Bounds#clone} For creating new instances
   */
  copyFrom(e) {
    return this.minX = e.minX, this.minY = e.minY, this.maxX = e.maxX, this.maxY = e.maxY, this;
  }
}
var kK = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, Ps = function(i) {
  return typeof i == "string" ? i.length > 0 : typeof i == "number";
}, An = function(i, e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = Math.pow(10, e)), Math.round(t * i) / t + 0;
}, Di = function(i, e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = 1), i > t ? t : i > e ? i : e;
}, bS = function(i) {
  return (i = isFinite(i) ? i % 360 : 0) > 0 ? i : i + 360;
}, fk = function(i) {
  return { r: Di(i.r, 0, 255), g: Di(i.g, 0, 255), b: Di(i.b, 0, 255), a: Di(i.a) };
}, vg = function(i) {
  return { r: An(i.r), g: An(i.g), b: An(i.b), a: An(i.a, 3) };
}, _K = /^#([0-9a-f]{3,8})$/i, nh = function(i) {
  var e = i.toString(16);
  return e.length < 2 ? "0" + e : e;
}, vS = function(i) {
  var e = i.r, t = i.g, n = i.b, s = i.a, o = Math.max(e, t, n), r = o - Math.min(e, t, n), a = r ? o === e ? (t - n) / r : o === t ? 2 + (n - e) / r : 4 + (e - t) / r : 0;
  return { h: 60 * (a < 0 ? a + 6 : a), s: o ? r / o * 100 : 0, v: o / 255 * 100, a: s };
}, yS = function(i) {
  var e = i.h, t = i.s, n = i.v, s = i.a;
  e = e / 360 * 6, t /= 100, n /= 100;
  var o = Math.floor(e), r = n * (1 - t), a = n * (1 - (e - o) * t), l = n * (1 - (1 - e + o) * t), d = o % 6;
  return { r: 255 * [n, a, r, r, l, n][d], g: 255 * [l, n, n, a, r, r][d], b: 255 * [r, r, l, n, n, a][d], a: s };
}, mk = function(i) {
  return { h: bS(i.h), s: Di(i.s, 0, 100), l: Di(i.l, 0, 100), a: Di(i.a) };
}, gk = function(i) {
  return { h: An(i.h), s: An(i.s), l: An(i.l), a: An(i.a, 3) };
}, bk = function(i) {
  return yS((t = (e = i).s, { h: e.h, s: (t *= ((n = e.l) < 50 ? n : 100 - n) / 100) > 0 ? 2 * t / (n + t) * 100 : 0, v: n + t, a: e.a }));
  var e, t, n;
}, gc = function(i) {
  return { h: (e = vS(i)).h, s: (s = (200 - (t = e.s)) * (n = e.v) / 100) > 0 && s < 200 ? t * n / 100 / (s <= 100 ? s : 200 - s) * 100 : 0, l: s / 2, a: e.a };
  var e, t, n, s;
}, SK = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, MK = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, TK = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, CK = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Nv = { string: [[function(i) {
  var e = _K.exec(i);
  return e ? (i = e[1]).length <= 4 ? { r: parseInt(i[0] + i[0], 16), g: parseInt(i[1] + i[1], 16), b: parseInt(i[2] + i[2], 16), a: i.length === 4 ? An(parseInt(i[3] + i[3], 16) / 255, 2) : 1 } : i.length === 6 || i.length === 8 ? { r: parseInt(i.substr(0, 2), 16), g: parseInt(i.substr(2, 2), 16), b: parseInt(i.substr(4, 2), 16), a: i.length === 8 ? An(parseInt(i.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(i) {
  var e = TK.exec(i) || CK.exec(i);
  return e ? e[2] !== e[4] || e[4] !== e[6] ? null : fk({ r: Number(e[1]) / (e[2] ? 100 / 255 : 1), g: Number(e[3]) / (e[4] ? 100 / 255 : 1), b: Number(e[5]) / (e[6] ? 100 / 255 : 1), a: e[7] === void 0 ? 1 : Number(e[7]) / (e[8] ? 100 : 1) }) : null;
}, "rgb"], [function(i) {
  var e = SK.exec(i) || MK.exec(i);
  if (!e) return null;
  var t, n, s = mk({ h: (t = e[1], n = e[2], n === void 0 && (n = "deg"), Number(t) * (kK[n] || 1)), s: Number(e[3]), l: Number(e[4]), a: e[5] === void 0 ? 1 : Number(e[5]) / (e[6] ? 100 : 1) });
  return bk(s);
}, "hsl"]], object: [[function(i) {
  var e = i.r, t = i.g, n = i.b, s = i.a, o = s === void 0 ? 1 : s;
  return Ps(e) && Ps(t) && Ps(n) ? fk({ r: Number(e), g: Number(t), b: Number(n), a: Number(o) }) : null;
}, "rgb"], [function(i) {
  var e = i.h, t = i.s, n = i.l, s = i.a, o = s === void 0 ? 1 : s;
  if (!Ps(e) || !Ps(t) || !Ps(n)) return null;
  var r = mk({ h: Number(e), s: Number(t), l: Number(n), a: Number(o) });
  return bk(r);
}, "hsl"], [function(i) {
  var e = i.h, t = i.s, n = i.v, s = i.a, o = s === void 0 ? 1 : s;
  if (!Ps(e) || !Ps(t) || !Ps(n)) return null;
  var r = (function(a) {
    return { h: bS(a.h), s: Di(a.s, 0, 100), v: Di(a.v, 0, 100), a: Di(a.a) };
  })({ h: Number(e), s: Number(t), v: Number(n), a: Number(o) });
  return yS(r);
}, "hsv"]] }, vk = function(i, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t][0](i);
    if (n) return [n, e[t][1]];
  }
  return [null, void 0];
}, IK = function(i) {
  return typeof i == "string" ? vk(i.trim(), Nv.string) : typeof i == "object" && i !== null ? vk(i, Nv.object) : [null, void 0];
}, yg = function(i, e) {
  var t = gc(i);
  return { h: t.h, s: Di(t.s + 100 * e, 0, 100), l: t.l, a: t.a };
}, xg = function(i) {
  return (299 * i.r + 587 * i.g + 114 * i.b) / 1e3 / 255;
}, yk = function(i, e) {
  var t = gc(i);
  return { h: t.h, s: t.s, l: Di(t.l + 100 * e, 0, 100), a: t.a };
}, Uv = (function() {
  function i(e) {
    this.parsed = IK(e)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return i.prototype.isValid = function() {
    return this.parsed !== null;
  }, i.prototype.brightness = function() {
    return An(xg(this.rgba), 2);
  }, i.prototype.isDark = function() {
    return xg(this.rgba) < 0.5;
  }, i.prototype.isLight = function() {
    return xg(this.rgba) >= 0.5;
  }, i.prototype.toHex = function() {
    return e = vg(this.rgba), t = e.r, n = e.g, s = e.b, r = (o = e.a) < 1 ? nh(An(255 * o)) : "", "#" + nh(t) + nh(n) + nh(s) + r;
    var e, t, n, s, o, r;
  }, i.prototype.toRgb = function() {
    return vg(this.rgba);
  }, i.prototype.toRgbString = function() {
    return e = vg(this.rgba), t = e.r, n = e.g, s = e.b, (o = e.a) < 1 ? "rgba(" + t + ", " + n + ", " + s + ", " + o + ")" : "rgb(" + t + ", " + n + ", " + s + ")";
    var e, t, n, s, o;
  }, i.prototype.toHsl = function() {
    return gk(gc(this.rgba));
  }, i.prototype.toHslString = function() {
    return e = gk(gc(this.rgba)), t = e.h, n = e.s, s = e.l, (o = e.a) < 1 ? "hsla(" + t + ", " + n + "%, " + s + "%, " + o + ")" : "hsl(" + t + ", " + n + "%, " + s + "%)";
    var e, t, n, s, o;
  }, i.prototype.toHsv = function() {
    return e = vS(this.rgba), { h: An(e.h), s: An(e.s), v: An(e.v), a: An(e.a, 3) };
    var e;
  }, i.prototype.invert = function() {
    return hs({ r: 255 - (e = this.rgba).r, g: 255 - e.g, b: 255 - e.b, a: e.a });
    var e;
  }, i.prototype.saturate = function(e) {
    return e === void 0 && (e = 0.1), hs(yg(this.rgba, e));
  }, i.prototype.desaturate = function(e) {
    return e === void 0 && (e = 0.1), hs(yg(this.rgba, -e));
  }, i.prototype.grayscale = function() {
    return hs(yg(this.rgba, -1));
  }, i.prototype.lighten = function(e) {
    return e === void 0 && (e = 0.1), hs(yk(this.rgba, e));
  }, i.prototype.darken = function(e) {
    return e === void 0 && (e = 0.1), hs(yk(this.rgba, -e));
  }, i.prototype.rotate = function(e) {
    return e === void 0 && (e = 15), this.hue(this.hue() + e);
  }, i.prototype.alpha = function(e) {
    return typeof e == "number" ? hs({ r: (t = this.rgba).r, g: t.g, b: t.b, a: e }) : An(this.rgba.a, 3);
    var t;
  }, i.prototype.hue = function(e) {
    var t = gc(this.rgba);
    return typeof e == "number" ? hs({ h: e, s: t.s, l: t.l, a: t.a }) : An(t.h);
  }, i.prototype.isEqual = function(e) {
    return this.toHex() === hs(e).toHex();
  }, i;
})(), hs = function(i) {
  return i instanceof Uv ? i : new Uv(i);
}, xk = [], AK = function(i) {
  i.forEach(function(e) {
    xk.indexOf(e) < 0 && (e(Uv, Nv), xk.push(e));
  });
};
function PK(i, e) {
  var t = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, n = {};
  for (var s in t) n[t[s]] = s;
  var o = {};
  i.prototype.toName = function(r) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
    var a, l, d = n[this.toHex()];
    if (d) return d;
    if (r != null && r.closest) {
      var c = this.toRgb(), h = 1 / 0, f = "black";
      if (!o.length) for (var p in t) o[p] = new i(t[p]).toRgb();
      for (var y in t) {
        var v = (a = c, l = o[y], Math.pow(a.r - l.r, 2) + Math.pow(a.g - l.g, 2) + Math.pow(a.b - l.b, 2));
        v < h && (h = v, f = y);
      }
      return f;
    }
  }, e.string.push([function(r) {
    var a = r.toLowerCase(), l = a === "transparent" ? "#0000" : t[a];
    return l ? new i(l).toRgb() : null;
  }, "name"]);
}
AK([PK]);
const Dl = class qd {
  /**
   * @param {ColorSource} value - Optional value to use, if not provided, white is used.
   */
  constructor(e = 16777215) {
    this._value = null, this._components = new Float32Array(4), this._components.fill(1), this._int = 16777215, this.value = e;
  }
  /**
   * Get the red component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.red); // 1
   *
   * const green = new Color('#00ff00');
   * console.log(green.red); // 0
   * ```
   */
  get red() {
    return this._components[0];
  }
  /**
   * Get the green component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('lime');
   * console.log(color.green); // 1
   *
   * const red = new Color('#ff0000');
   * console.log(red.green); // 0
   * ```
   */
  get green() {
    return this._components[1];
  }
  /**
   * Get the blue component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('blue');
   * console.log(color.blue); // 1
   *
   * const yellow = new Color('#ffff00');
   * console.log(yellow.blue); // 0
   * ```
   */
  get blue() {
    return this._components[2];
  }
  /**
   * Get the alpha component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.alpha); // 1 (fully opaque)
   *
   * const transparent = new Color('rgba(255, 0, 0, 0.5)');
   * console.log(transparent.alpha); // 0.5 (semi-transparent)
   * ```
   */
  get alpha() {
    return this._components[3];
  }
  /**
   * Sets the color value and returns the instance for chaining.
   *
   * This is a chainable version of setting the `value` property.
   * @param value - The color to set. Accepts various formats:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA values (arrays, objects)
   * - CSS color names
   * - HSL/HSLA values
   * - HSV/HSVA values
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic usage
   * const color = new Color();
   * color.setValue('#ff0000')
   *     .setAlpha(0.5)
   *     .premultiply(0.8);
   *
   * // Different formats
   * color.setValue(0xff0000);          // Hex number
   * color.setValue('#ff0000');         // Hex string
   * color.setValue([1, 0, 0]);         // RGB array
   * color.setValue([1, 0, 0, 0.5]);    // RGBA array
   * color.setValue({ r: 1, g: 0, b: 0 }); // RGB object
   *
   * // Copy from another color
   * const red = new Color('red');
   * color.setValue(red);
   * ```
   * @throws {Error} If the color value is invalid or null
   * @see {@link Color.value} For the underlying value property
   */
  setValue(e) {
    return this.value = e, this;
  }
  /**
   * The current color source. This property allows getting and setting the color value
   * while preserving the original format where possible.
   * @remarks
   * When setting:
   * - Setting to a `Color` instance copies its source and components
   * - Setting to other valid sources normalizes and stores the value
   * - Setting to `null` throws an Error
   * - The color remains unchanged if normalization fails
   *
   * When getting:
   * - Returns `null` if color was modified by {@link Color.multiply} or {@link Color.premultiply}
   * - Otherwise returns the original color source
   * @example
   * ```ts
   * // Setting different color formats
   * const color = new Color();
   *
   * color.value = 0xff0000;         // Hex number
   * color.value = '#ff0000';        // Hex string
   * color.value = [1, 0, 0];        // RGB array
   * color.value = [1, 0, 0, 0.5];   // RGBA array
   * color.value = { r: 1, g: 0, b: 0 }; // RGB object
   *
   * // Copying from another color
   * const red = new Color('red');
   * color.value = red;  // Copies red's components
   *
   * // Getting the value
   * console.log(color.value);  // Returns original format
   *
   * // After modifications
   * color.multiply([0.5, 0.5, 0.5]);
   * console.log(color.value);  // Returns null
   * ```
   * @throws {Error} When attempting to set `null`
   */
  set value(e) {
    if (e instanceof qd)
      this._value = this._cloneSource(e._value), this._int = e._int, this._components.set(e._components);
    else {
      if (e === null)
        throw new Error("Cannot set Color#value to null");
      (this._value === null || !this._isSourceEqual(this._value, e)) && (this._value = this._cloneSource(e), this._normalize(this._value));
    }
  }
  get value() {
    return this._value;
  }
  /**
   * Copy a color source internally.
   * @param value - Color source
   */
  _cloneSource(e) {
    return typeof e == "string" || typeof e == "number" || e instanceof Number || e === null ? e : Array.isArray(e) || ArrayBuffer.isView(e) ? e.slice(0) : typeof e == "object" && e !== null ? { ...e } : e;
  }
  /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */
  _isSourceEqual(e, t) {
    const n = typeof e;
    if (n !== typeof t)
      return !1;
    if (n === "number" || n === "string" || e instanceof Number)
      return e === t;
    if (Array.isArray(e) && Array.isArray(t) || ArrayBuffer.isView(e) && ArrayBuffer.isView(t))
      return e.length !== t.length ? !1 : e.every((o, r) => o === t[r]);
    if (e !== null && t !== null) {
      const o = Object.keys(e), r = Object.keys(t);
      return o.length !== r.length ? !1 : o.every((a) => e[a] === t[a]);
    }
    return e === t;
  }
  /**
   * Convert to a RGBA color object with normalized components (0-1).
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA objects
   * new Color('white').toRgba();     // returns { r: 1, g: 1, b: 1, a: 1 }
   * new Color('#ff0000').toRgba();   // returns { r: 1, g: 0, b: 0, a: 1 }
   *
   * // With transparency
   * new Color('rgba(255,0,0,0.5)').toRgba(); // returns { r: 1, g: 0, b: 0, a: 0.5 }
   * ```
   * @returns An RGBA object with normalized components
   */
  toRgba() {
    const [e, t, n, s] = this._components;
    return { r: e, g: t, b: n, a: s };
  }
  /**
   * Convert to a RGB color object with normalized components (0-1).
   *
   * Alpha component is omitted in the output.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGB objects
   * new Color('white').toRgb();     // returns { r: 1, g: 1, b: 1 }
   * new Color('#ff0000').toRgb();   // returns { r: 1, g: 0, b: 0 }
   *
   * // Alpha is ignored
   * new Color('rgba(255,0,0,0.5)').toRgb(); // returns { r: 1, g: 0, b: 0 }
   * ```
   * @returns An RGB object with normalized components
   */
  toRgb() {
    const [e, t, n] = this._components;
    return { r: e, g: t, b: n };
  }
  /**
   * Convert to a CSS-style rgba string representation.
   *
   * RGB components are scaled to 0-255 range, alpha remains 0-1.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA strings
   * new Color('white').toRgbaString();     // returns "rgba(255,255,255,1)"
   * new Color('#ff0000').toRgbaString();   // returns "rgba(255,0,0,1)"
   *
   * // With transparency
   * new Color([1, 0, 0, 0.5]).toRgbaString(); // returns "rgba(255,0,0,0.5)"
   * ```
   * @returns A CSS-compatible rgba string
   */
  toRgbaString() {
    const [e, t, n] = this.toUint8RgbArray();
    return `rgba(${e},${t},${n},${this.alpha})`;
  }
  /**
   * Convert to an [R, G, B] array of clamped uint8 values (0 to 255).
   * @param {number[]|Uint8Array|Uint8ClampedArray} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as integers between 0-255
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toUint8RgbArray(); // returns [255, 255, 255]
   * new Color('#ff0000').toUint8RgbArray(); // returns [255, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Uint8Array(3);
   * new Color('blue').toUint8RgbArray(rgb); // rgb is now [0, 0, 255]
   *
   * // Using different array types
   * new Color('red').toUint8RgbArray(new Uint8ClampedArray(3)); // [255, 0, 0]
   * new Color('red').toUint8RgbArray([]); // [255, 0, 0]
   * ```
   * @remarks
   * - Output values are always clamped between 0-255
   * - Alpha component is not included in output
   * - Reuses internal cache array if no output array provided
   */
  toUint8RgbArray(e) {
    const [t, n, s] = this._components;
    return this._arrayRgb || (this._arrayRgb = []), e || (e = this._arrayRgb), e[0] = Math.round(t * 255), e[1] = Math.round(n * 255), e[2] = Math.round(s * 255), e;
  }
  /**
   * Convert to an [R, G, B, A] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGBA components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toArray();  // returns [1, 1, 1, 1]
   * new Color('red').toArray();    // returns [1, 0, 0, 1]
   *
   * // With alpha
   * new Color('rgba(255,0,0,0.5)').toArray(); // returns [1, 0, 0, 0.5]
   *
   * // Using custom output array
   * const rgba = new Float32Array(4);
   * new Color('blue').toArray(rgba); // rgba is now [0, 0, 1, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Includes alpha component as the fourth value
   * - Reuses internal cache array if no output array provided
   */
  toArray(e) {
    this._arrayRgba || (this._arrayRgba = []), e || (e = this._arrayRgba);
    const [t, n, s, o] = this._components;
    return e[0] = t, e[1] = n, e[2] = s, e[3] = o, e;
  }
  /**
   * Convert to an [R, G, B] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toRgbArray(); // returns [1, 1, 1]
   * new Color('red').toRgbArray();   // returns [1, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Float32Array(3);
   * new Color('blue').toRgbArray(rgb); // rgb is now [0, 0, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Alpha component is omitted from output
   * - Reuses internal cache array if no output array provided
   */
  toRgbArray(e) {
    this._arrayRgb || (this._arrayRgb = []), e || (e = this._arrayRgb);
    const [t, n, s] = this._components;
    return e[0] = t, e[1] = n, e[2] = s, e;
  }
  /**
   * Convert to a hexadecimal number.
   * @returns The color as a 24-bit RGB integer
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toNumber(); // returns 0xffffff
   * new Color('red').toNumber();   // returns 0xff0000
   *
   * // Store as hex
   * const color = new Color('blue');
   * const hex = color.toNumber(); // 0x0000ff
   * ```
   */
  toNumber() {
    return this._int;
  }
  /**
   * Convert to a BGR number.
   *
   * Useful for platforms that expect colors in BGR format.
   * @returns The color as a 24-bit BGR integer
   * @example
   * ```ts
   * // Convert RGB to BGR
   * new Color(0xffcc99).toBgrNumber(); // returns 0x99ccff
   *
   * // Common use case: platform-specific color format
   * const color = new Color('orange');
   * const bgrColor = color.toBgrNumber(); // Color with swapped R/B channels
   * ```
   * @remarks
   * This swaps the red and blue channels compared to the normal RGB format:
   * - RGB 0xRRGGBB becomes BGR 0xBBGGRR
   */
  toBgrNumber() {
    const [e, t, n] = this.toUint8RgbArray();
    return (n << 16) + (t << 8) + e;
  }
  /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   *
   * Useful for platforms that expect colors in little endian byte order.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert RGB color to little endian format
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   *
   * // Common use cases:
   * const color = new Color('orange');
   * const leColor = color.toLittleEndianNumber(); // Swaps byte order for LE systems
   *
   * // Multiple conversions
   * const colors = {
   *     normal: 0xffcc99,
   *     littleEndian: new Color(0xffcc99).toLittleEndianNumber(), // 0x99ccff
   *     backToNormal: new Color(0x99ccff).toLittleEndianNumber()  // 0xffcc99
   * };
   * ```
   * @remarks
   * - Swaps R and B channels in the color value
   * - RGB 0xRRGGBB becomes 0xBBGGRR
   * - Useful for systems that use little endian byte order
   * - Can be used to convert back and forth between formats
   * @returns The color as a number in little endian format (BBGGRR)
   * @see {@link Color.toBgrNumber} For BGR format without byte swapping
   */
  toLittleEndianNumber() {
    const e = this._int;
    return (e >> 16) + (e & 65280) + ((e & 255) << 16);
  }
  /**
   * Multiply with another color.
   *
   * This action is destructive and modifies the original color.
   * @param {ColorSource} value - The color to multiply by. Accepts any valid color format:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA arrays ([1, 0, 0], [1, 0, 0, 1])
   * - Color objects ({ r: 1, g: 0, b: 0 })
   * - CSS color names ('red', 'blue')
   * @returns this - The Color instance for chaining
   * @example
   * ```ts
   * // Basic multiplication
   * const color = new Color('#ff0000');
   * color.multiply(0x808080); // 50% darker red
   *
   * // With transparency
   * color.multiply([1, 1, 1, 0.5]); // 50% transparent
   *
   * // Chain operations
   * color
   *     .multiply('#808080')
   *     .multiply({ r: 1, g: 1, b: 1, a: 0.5 });
   * ```
   * @remarks
   * - Multiplies each RGB component and alpha separately
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */
  multiply(e) {
    const [t, n, s, o] = qd._temp.setValue(e)._components;
    return this._components[0] *= t, this._components[1] *= n, this._components[2] *= s, this._components[3] *= o, this._refreshInt(), this._value = null, this;
  }
  /**
   * Converts color to a premultiplied alpha format.
   *
   * This action is destructive and modifies the original color.
   * @param alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {Color} The Color instance for chaining
   * @example
   * ```ts
   * // Basic premultiplication
   * const color = new Color('red');
   * color.premultiply(0.5); // 50% transparent red with premultiplied RGB
   *
   * // Alpha only (RGB unchanged)
   * color.premultiply(0.5, false); // 50% transparent, original RGB
   *
   * // Chain with other operations
   * color
   *     .multiply(0x808080)
   *     .premultiply(0.5)
   *     .toNumber();
   * ```
   * @remarks
   * - RGB channels are multiplied by alpha when applyToRGB is true
   * - Alpha is always set to the provided value
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */
  premultiply(e, t = !0) {
    return t && (this._components[0] *= e, this._components[1] *= e, this._components[2] *= e), this._components[3] = e, this._refreshInt(), this._value = null, this;
  }
  /**
   * Returns the color as a 32-bit premultiplied alpha integer.
   *
   * Format: 0xAARRGGBB
   * @param {number} alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {number} The premultiplied color as a 32-bit integer
   * @example
   * ```ts
   * // Convert to premultiplied format
   * const color = new Color('red');
   *
   * // Full opacity (0xFFRRGGBB)
   * color.toPremultiplied(1.0); // 0xFFFF0000
   *
   * // 50% transparency with premultiplied RGB
   * color.toPremultiplied(0.5); // 0x7F7F0000
   *
   * // 50% transparency without RGB premultiplication
   * color.toPremultiplied(0.5, false); // 0x7FFF0000
   * ```
   * @remarks
   * - Returns full opacity (0xFF000000) when alpha is 1.0
   * - Returns 0 when alpha is 0.0 and applyToRGB is true
   * - RGB values are rounded during premultiplication
   */
  toPremultiplied(e, t = !0) {
    if (e === 1)
      return (255 << 24) + this._int;
    if (e === 0)
      return t ? 0 : this._int;
    let n = this._int >> 16 & 255, s = this._int >> 8 & 255, o = this._int & 255;
    return t && (n = n * e + 0.5 | 0, s = s * e + 0.5 | 0, o = o * e + 0.5 | 0), (e * 255 << 24) + (n << 16) + (s << 8) + o;
  }
  /**
   * Convert to a hexadecimal string (6 characters).
   * @returns A CSS-compatible hex color string (e.g., "#ff0000")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Basic colors
   * new Color('red').toHex();    // returns "#ff0000"
   * new Color('white').toHex();  // returns "#ffffff"
   * new Color('black').toHex();  // returns "#000000"
   *
   * // From different formats
   * new Color(0xff0000).toHex(); // returns "#ff0000"
   * new Color([1, 0, 0]).toHex(); // returns "#ff0000"
   * new Color({ r: 1, g: 0, b: 0 }).toHex(); // returns "#ff0000"
   * ```
   * @remarks
   * - Always returns a 6-character hex string
   * - Includes leading "#" character
   * - Alpha channel is ignored
   * - Values are rounded to nearest hex value
   */
  toHex() {
    const e = this._int.toString(16);
    return `#${"000000".substring(0, 6 - e.length) + e}`;
  }
  /**
   * Convert to a hexadecimal string with alpha (8 characters).
   * @returns A CSS-compatible hex color string with alpha (e.g., "#ff0000ff")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Fully opaque colors
   * new Color('red').toHexa();   // returns "#ff0000ff"
   * new Color('white').toHexa(); // returns "#ffffffff"
   *
   * // With transparency
   * new Color('rgba(255, 0, 0, 0.5)').toHexa(); // returns "#ff00007f"
   * new Color([1, 0, 0, 0]).toHexa(); // returns "#ff000000"
   * ```
   * @remarks
   * - Returns an 8-character hex string
   * - Includes leading "#" character
   * - Alpha is encoded in last two characters
   * - Values are rounded to nearest hex value
   */
  toHexa() {
    const t = Math.round(this._components[3] * 255).toString(16);
    return this.toHex() + "00".substring(0, 2 - t.length) + t;
  }
  /**
   * Set alpha (transparency) value while preserving color components.
   *
   * Provides a chainable interface for setting alpha.
   * @param alpha - Alpha value between 0 (fully transparent) and 1 (fully opaque)
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic alpha setting
   * const color = new Color('red');
   * color.setAlpha(0.5);  // 50% transparent red
   *
   * // Chain with other operations
   * color
   *     .setValue('#ff0000')
   *     .setAlpha(0.8)    // 80% opaque
   *     .premultiply(0.5); // Further modify alpha
   *
   * // Reset to fully opaque
   * color.setAlpha(1);
   * ```
   * @remarks
   * - Alpha value is clamped between 0-1
   * - Can be chained with other color operations
   */
  setAlpha(e) {
    return this._components[3] = this._clamp(e), this._value = null, this;
  }
  /**
   * Normalize the input value into rgba
   * @param value - Input value
   */
  _normalize(e) {
    let t, n, s, o;
    if ((typeof e == "number" || e instanceof Number) && e >= 0 && e <= 16777215) {
      const r = e;
      t = (r >> 16 & 255) / 255, n = (r >> 8 & 255) / 255, s = (r & 255) / 255, o = 1;
    } else if ((Array.isArray(e) || e instanceof Float32Array) && e.length >= 3 && e.length <= 4)
      e = this._clamp(e), [t, n, s, o = 1] = e;
    else if ((e instanceof Uint8Array || e instanceof Uint8ClampedArray) && e.length >= 3 && e.length <= 4)
      e = this._clamp(e, 0, 255), [t, n, s, o = 255] = e, t /= 255, n /= 255, s /= 255, o /= 255;
    else if (typeof e == "string" || typeof e == "object") {
      if (typeof e == "string") {
        const a = qd.HEX_PATTERN.exec(e);
        a && (e = `#${a[2]}`);
      }
      const r = hs(e);
      r.isValid() && ({ r: t, g: n, b: s, a: o } = r.rgba, t /= 255, n /= 255, s /= 255);
    }
    if (t !== void 0)
      this._components[0] = t, this._components[1] = n, this._components[2] = s, this._components[3] = o, this._refreshInt();
    else
      throw new Error(`Unable to convert color ${e}`);
  }
  /** Refresh the internal color rgb number */
  _refreshInt() {
    this._clamp(this._components);
    const [e, t, n] = this._components;
    this._int = (e * 255 << 16) + (t * 255 << 8) + (n * 255 | 0);
  }
  /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */
  _clamp(e, t = 0, n = 1) {
    return typeof e == "number" ? Math.min(Math.max(e, t), n) : (e.forEach((s, o) => {
      e[o] = Math.min(Math.max(s, t), n);
    }), e);
  }
  /**
   * Check if a value can be interpreted as a valid color format.
   * Supports all color formats that can be used with the Color class.
   * @param value - Value to check
   * @returns True if the value can be used as a color
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // CSS colors and hex values
   * Color.isColorLike('red');          // true
   * Color.isColorLike('#ff0000');      // true
   * Color.isColorLike(0xff0000);       // true
   *
   * // Arrays (RGB/RGBA)
   * Color.isColorLike([1, 0, 0]);      // true
   * Color.isColorLike([1, 0, 0, 0.5]); // true
   *
   * // TypedArrays
   * Color.isColorLike(new Float32Array([1, 0, 0]));          // true
   * Color.isColorLike(new Uint8Array([255, 0, 0]));          // true
   * Color.isColorLike(new Uint8ClampedArray([255, 0, 0]));   // true
   *
   * // Object formats
   * Color.isColorLike({ r: 1, g: 0, b: 0 });            // true (RGB)
   * Color.isColorLike({ r: 1, g: 0, b: 0, a: 0.5 });    // true (RGBA)
   * Color.isColorLike({ h: 0, s: 100, l: 50 });         // true (HSL)
   * Color.isColorLike({ h: 0, s: 100, l: 50, a: 0.5 }); // true (HSLA)
   * Color.isColorLike({ h: 0, s: 100, v: 100 });        // true (HSV)
   * Color.isColorLike({ h: 0, s: 100, v: 100, a: 0.5 });// true (HSVA)
   *
   * // Color instances
   * Color.isColorLike(new Color('red')); // true
   *
   * // Invalid values
   * Color.isColorLike(null);           // false
   * Color.isColorLike(undefined);      // false
   * Color.isColorLike({});             // false
   * Color.isColorLike([]);             // false
   * Color.isColorLike('not-a-color');  // false
   * ```
   * @remarks
   * Checks for the following formats:
   * - Numbers (0x000000 to 0xffffff)
   * - CSS color strings
   * - RGB/RGBA arrays and objects
   * - HSL/HSLA objects
   * - HSV/HSVA objects
   * - TypedArrays (Float32Array, Uint8Array, Uint8ClampedArray)
   * - Color instances
   * @see {@link ColorSource} For supported color format types
   * @see {@link Color.setValue} For setting color values
   * @category utility
   */
  static isColorLike(e) {
    return typeof e == "number" || typeof e == "string" || e instanceof Number || e instanceof qd || Array.isArray(e) || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Float32Array || e.r !== void 0 && e.g !== void 0 && e.b !== void 0 || e.r !== void 0 && e.g !== void 0 && e.b !== void 0 && e.a !== void 0 || e.h !== void 0 && e.s !== void 0 && e.l !== void 0 || e.h !== void 0 && e.s !== void 0 && e.l !== void 0 && e.a !== void 0 || e.h !== void 0 && e.s !== void 0 && e.v !== void 0 || e.h !== void 0 && e.s !== void 0 && e.v !== void 0 && e.a !== void 0;
  }
};
Dl.shared = new Dl();
Dl._temp = new Dl();
Dl.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let bn = Dl;
const EK = {
  cullArea: null,
  cullable: !1,
  cullableChildren: !0
};
let wg = 0;
const wk = 500;
function dt(...i) {
  wg !== wk && (wg++, wg === wk ? console.warn("PixiJS Warning: too many warnings, no more warnings will be reported to the console by PixiJS.") : console.warn("PixiJS Warning: ", ...i));
}
const Yl = {
  /**
   * Set of registered pools and cleanable objects.
   * @private
   */
  _registeredResources: /* @__PURE__ */ new Set(),
  /**
   * Registers a pool or cleanable object for cleanup.
   * @param {Cleanable} pool - The pool or object to register.
   */
  register(i) {
    this._registeredResources.add(i);
  },
  /**
   * Unregisters a pool or cleanable object from cleanup.
   * @param {Cleanable} pool - The pool or object to unregister.
   */
  unregister(i) {
    this._registeredResources.delete(i);
  },
  /** Clears all registered pools and cleanable objects. This will call clear() on each registered item. */
  release() {
    this._registeredResources.forEach((i) => i.clear());
  },
  /**
   * Gets the number of registered pools and cleanable objects.
   * @returns {number} The count of registered items.
   */
  get registeredCount() {
    return this._registeredResources.size;
  },
  /**
   * Checks if a specific pool or cleanable object is registered.
   * @param {Cleanable} pool - The pool or object to check.
   * @returns {boolean} True if the item is registered, false otherwise.
   */
  isRegistered(i) {
    return this._registeredResources.has(i);
  },
  /**
   * Removes all registrations without clearing the pools.
   * Useful if you want to reset the collector without affecting the pools.
   */
  reset() {
    this._registeredResources.clear();
  }
};
class RK {
  /**
   * Constructs a new Pool.
   * @param ClassType - The constructor of the items in the pool.
   * @param {number} [initialSize] - The initial size of the pool.
   */
  constructor(e, t) {
    this._pool = [], this._count = 0, this._index = 0, this._classType = e, t && this.prepopulate(t);
  }
  /**
   * Prepopulates the pool with a given number of items.
   * @param total - The number of items to add to the pool.
   */
  prepopulate(e) {
    for (let t = 0; t < e; t++)
      this._pool[this._index++] = new this._classType();
    this._count += e;
  }
  /**
   * Gets an item from the pool. Calls the item's `init` method if it exists.
   * If there are no items left in the pool, a new one will be created.
   * @param {I} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */
  get(e) {
    var n;
    let t;
    return this._index > 0 ? t = this._pool[--this._index] : (t = new this._classType(), this._count++), (n = t.init) == null || n.call(t, e), t;
  }
  /**
   * Returns an item to the pool. Calls the item's `reset` method if it exists.
   * @param {T} item - The item to return to the pool.
   */
  return(e) {
    var t;
    (t = e.reset) == null || t.call(e), this._pool[this._index++] = e;
  }
  /**
   * Gets the number of items in the pool.
   * @readonly
   */
  get totalSize() {
    return this._count;
  }
  /**
   * Gets the number of items in the pool that are free to use without needing to create more.
   * @readonly
   */
  get totalFree() {
    return this._index;
  }
  /**
   * Gets the number of items in the pool that are currently in use.
   * @readonly
   */
  get totalUsed() {
    return this._count - this._index;
  }
  /** clears the pool */
  clear() {
    if (this._pool.length > 0 && this._pool[0].destroy)
      for (let e = 0; e < this._index; e++)
        this._pool[e].destroy();
    this._pool.length = 0, this._count = 0, this._index = 0;
  }
}
class zK {
  constructor() {
    this._poolsByClass = /* @__PURE__ */ new Map();
  }
  /**
   * Prepopulates a specific pool with a given number of items.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {number} total - The number of items to add to the pool.
   */
  prepopulate(e, t) {
    this.getPool(e).prepopulate(t);
  }
  /**
   * Gets an item from a specific pool.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */
  get(e, t) {
    return this.getPool(e).get(t);
  }
  /**
   * Returns an item to its respective pool.
   * @param {PoolItem} item - The item to return to the pool.
   */
  return(e) {
    this.getPool(e.constructor).return(e);
  }
  /**
   * Gets a specific pool based on the class type.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} ClassType - The constructor of the items in the pool.
   * @returns {Pool<T>} The pool of the given class type.
   */
  getPool(e) {
    return this._poolsByClass.has(e) || this._poolsByClass.set(e, new RK(e)), this._poolsByClass.get(e);
  }
  /** gets the usage stats of each pool in the system */
  stats() {
    const e = {};
    return this._poolsByClass.forEach((t) => {
      const n = e[t._classType.name] ? t._classType.name + t._classType.ID : t._classType.name;
      e[n] = {
        free: t.totalFree,
        used: t.totalUsed,
        size: t.totalSize
      };
    }), e;
  }
  /** Clears all pools in the group. This will reset all pools and free their resources. */
  clear() {
    this._poolsByClass.forEach((e) => e.clear()), this._poolsByClass.clear();
  }
}
const $n = new zK();
Yl.register($n);
const $K = {
  get isCachedAsTexture() {
    var i;
    return !!((i = this.renderGroup) != null && i.isCachedAsTexture);
  },
  cacheAsTexture(i) {
    typeof i == "boolean" && i === !1 ? this.disableRenderGroup() : (this.enableRenderGroup(), this.renderGroup.enableCacheAsTexture(i === !0 ? {} : i));
  },
  updateCacheTexture() {
    var i;
    (i = this.renderGroup) == null || i.updateCacheTexture();
  },
  get cacheAsBitmap() {
    return this.isCachedAsTexture;
  },
  set cacheAsBitmap(i) {
    rt("v8.6.0", "cacheAsBitmap is deprecated, use cacheAsTexture instead."), this.cacheAsTexture(i);
  }
};
function xS(i, e, t) {
  const n = i.length;
  let s;
  if (e >= n || t === 0)
    return;
  t = e + t > n ? n - e : t;
  const o = n - t;
  for (s = e; s < o; ++s)
    i[s] = i[s + t];
  i.length = o;
}
const DK = {
  allowChildren: !0,
  removeChildren(i = 0, e) {
    var o;
    const t = e != null ? e : this.children.length, n = t - i, s = [];
    if (n > 0 && n <= t) {
      for (let a = t - 1; a >= i; a--) {
        const l = this.children[a];
        l && (s.push(l), l.parent = null);
      }
      xS(this.children, i, t);
      const r = this.renderGroup || this.parentRenderGroup;
      r && r.removeChildren(s);
      for (let a = 0; a < s.length; ++a) {
        const l = s[a];
        (o = l.parentRenderLayer) == null || o.detach(l), this.emit("childRemoved", l, this, a), s[a].emit("removed", this);
      }
      return s.length > 0 && this._didViewChangeTick++, s;
    } else if (n === 0 && this.children.length === 0)
      return s;
    throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
  },
  removeChildAt(i) {
    const e = this.getChildAt(i);
    return this.removeChild(e);
  },
  getChildAt(i) {
    if (i < 0 || i >= this.children.length)
      throw new Error(`getChildAt: Index (${i}) does not exist.`);
    return this.children[i];
  },
  setChildIndex(i, e) {
    if (e < 0 || e >= this.children.length)
      throw new Error(`The index ${e} supplied is out of bounds ${this.children.length}`);
    this.getChildIndex(i), this.addChildAt(i, e);
  },
  getChildIndex(i) {
    const e = this.children.indexOf(i);
    if (e === -1)
      throw new Error("The supplied Container must be a child of the caller");
    return e;
  },
  addChildAt(i, e) {
    this.allowChildren || rt(dn, "addChildAt: Only Containers will be allowed to add children in v8.0.0");
    const { children: t } = this;
    if (e < 0 || e > t.length)
      throw new Error(`${i}addChildAt: The index ${e} supplied is out of bounds ${t.length}`);
    const n = i.parent === this;
    if (i.parent) {
      const o = i.parent.children.indexOf(i);
      if (n) {
        if (o === e)
          return i;
        i.parent.children.splice(o, 1);
      } else
        i.removeFromParent();
    }
    e === t.length ? t.push(i) : t.splice(e, 0, i);
    const s = this.renderGroup || this.parentRenderGroup;
    return this.sortableChildren && (this.sortDirty = !0), n ? (s && (s.structureDidChange = !0), i) : (i.parent = this, i.didChange = !0, i._updateFlags = 15, s && s.addChild(i), this.emit("childAdded", i, this, e), i.emit("added", this), i);
  },
  swapChildren(i, e) {
    if (i === e)
      return;
    const t = this.getChildIndex(i), n = this.getChildIndex(e);
    this.children[t] = e, this.children[n] = i;
    const s = this.renderGroup || this.parentRenderGroup;
    s && (s.structureDidChange = !0), this._didContainerChangeTick++;
  },
  removeFromParent() {
    var i;
    (i = this.parent) == null || i.removeChild(this);
  },
  reparentChild(...i) {
    return i.length === 1 ? this.reparentChildAt(i[0], this.children.length) : (i.forEach((e) => this.reparentChildAt(e, this.children.length)), i[0]);
  },
  reparentChildAt(i, e) {
    if (i.parent === this)
      return this.setChildIndex(i, e), i;
    const t = i.worldTransform.clone();
    i.removeFromParent(), this.addChildAt(i, e);
    const n = this.worldTransform.clone();
    return n.invert(), t.prepend(n), i.setFromMatrix(t), i;
  },
  replaceChild(i, e) {
    i.updateLocalTransform(), this.addChildAt(e, this.getChildIndex(i)), e.setFromMatrix(i.localTransform), e.updateLocalTransform(), this.removeChild(i);
  }
}, OK = {
  collectRenderables(i, e, t) {
    this.parentRenderLayer && this.parentRenderLayer !== t || this.globalDisplayStatus < 7 || !this.includeInBuild || (this.sortableChildren && this.sortChildren(), this.isSimple ? this.collectRenderablesSimple(i, e, t) : this.renderGroup ? e.renderPipes.renderGroup.addRenderGroup(this.renderGroup, i) : this.collectRenderablesWithEffects(i, e, t));
  },
  collectRenderablesSimple(i, e, t) {
    const n = this.children, s = n.length;
    for (let o = 0; o < s; o++)
      n[o].collectRenderables(i, e, t);
  },
  collectRenderablesWithEffects(i, e, t) {
    const { renderPipes: n } = e;
    for (let s = 0; s < this.effects.length; s++) {
      const o = this.effects[s];
      n[o.pipe].push(o, this, i);
    }
    this.collectRenderablesSimple(i, e, t);
    for (let s = this.effects.length - 1; s >= 0; s--) {
      const o = this.effects[s];
      n[o.pipe].pop(o, this, i);
    }
  }
};
class uf {
  constructor() {
    this.pipe = "filter", this.priority = 1;
  }
  destroy() {
    for (let e = 0; e < this.filters.length; e++)
      this.filters[e].destroy();
    this.filters = null, this.filterArea = null;
  }
}
class LK {
  constructor() {
    this._effectClasses = [], this._tests = [], this._initialized = !1;
  }
  init() {
    this._initialized || (this._initialized = !0, this._effectClasses.forEach((e) => {
      this.add({
        test: e.test,
        maskClass: e
      });
    }));
  }
  add(e) {
    this._tests.push(e);
  }
  getMaskEffect(e) {
    this._initialized || this.init();
    for (let t = 0; t < this._tests.length; t++) {
      const n = this._tests[t];
      if (n.test(e))
        return $n.get(n.maskClass, e);
    }
    return e;
  }
  returnMaskEffect(e) {
    $n.return(e);
  }
}
const Gv = new LK();
ht.handleByList(Ie.MaskEffect, Gv._effectClasses);
const BK = {
  _maskEffect: null,
  _maskOptions: {
    inverse: !1,
    channel: "red"
  },
  _filterEffect: null,
  effects: [],
  _markStructureAsChanged() {
    const i = this.renderGroup || this.parentRenderGroup;
    i && (i.structureDidChange = !0);
  },
  addEffect(i) {
    this.effects.indexOf(i) === -1 && (this.effects.push(i), this.effects.sort((t, n) => t.priority - n.priority), this._markStructureAsChanged(), this._updateIsSimple());
  },
  removeEffect(i) {
    const e = this.effects.indexOf(i);
    e !== -1 && (this.effects.splice(e, 1), this._markStructureAsChanged(), this._updateIsSimple());
  },
  set mask(i) {
    const e = this._maskEffect;
    (e == null ? void 0 : e.mask) !== i && (e && (this.removeEffect(e), Gv.returnMaskEffect(e), this._maskEffect = null), i != null && (this._maskEffect = Gv.getMaskEffect(i), this.addEffect(this._maskEffect)));
  },
  get mask() {
    var i;
    return (i = this._maskEffect) == null ? void 0 : i.mask;
  },
  setMask(i) {
    this._maskOptions = {
      ...this._maskOptions,
      ...i
    }, i.mask && (this.mask = i.mask), this._markStructureAsChanged();
  },
  set filters(i) {
    var o;
    !Array.isArray(i) && i && (i = [i]);
    const e = this._filterEffect || (this._filterEffect = new uf());
    i = i;
    const t = (i == null ? void 0 : i.length) > 0, n = ((o = e.filters) == null ? void 0 : o.length) > 0, s = t !== n;
    i = Array.isArray(i) ? i.slice(0) : i, e.filters = Object.freeze(i), s && (t ? this.addEffect(e) : (this.removeEffect(e), e.filters = i != null ? i : null));
  },
  get filters() {
    var i;
    return (i = this._filterEffect) == null ? void 0 : i.filters;
  },
  set filterArea(i) {
    this._filterEffect || (this._filterEffect = new uf()), this._filterEffect.filterArea = i;
  },
  get filterArea() {
    var i;
    return (i = this._filterEffect) == null ? void 0 : i.filterArea;
  }
}, FK = {
  label: null,
  get name() {
    return rt(dn, "Container.name property has been removed, use Container.label instead"), this.label;
  },
  set name(i) {
    rt(dn, "Container.name property has been removed, use Container.label instead"), this.label = i;
  },
  getChildByName(i, e = !1) {
    return this.getChildByLabel(i, e);
  },
  getChildByLabel(i, e = !1) {
    const t = this.children;
    for (let n = 0; n < t.length; n++) {
      const s = t[n];
      if (s.label === i || i instanceof RegExp && i.test(s.label)) return s;
    }
    if (e)
      for (let n = 0; n < t.length; n++) {
        const o = t[n].getChildByLabel(i, !0);
        if (o)
          return o;
      }
    return null;
  },
  getChildrenByLabel(i, e = !1, t = []) {
    const n = this.children;
    for (let s = 0; s < n.length; s++) {
      const o = n[s];
      (o.label === i || i instanceof RegExp && i.test(o.label)) && t.push(o);
    }
    if (e)
      for (let s = 0; s < n.length; s++)
        n[s].getChildrenByLabel(i, !0, t);
    return t;
  }
}, oi = $n.getPool(st), eo = $n.getPool(Gn), NK = new st(), UK = {
  getFastGlobalBounds(i, e) {
    e || (e = new Gn()), e.clear(), this._getGlobalBoundsRecursive(!!i, e, this.parentRenderLayer), e.isValid || e.set(0, 0, 0, 0);
    const t = this.renderGroup || this.parentRenderGroup;
    return e.applyMatrix(t.worldTransform), e;
  },
  _getGlobalBoundsRecursive(i, e, t) {
    let n = e;
    if (i && this.parentRenderLayer && this.parentRenderLayer !== t || this.localDisplayStatus !== 7 || !this.measurable)
      return;
    const s = !!this.effects.length;
    if ((this.renderGroup || s) && (n = eo.get().clear()), this.boundsArea)
      e.addRect(this.boundsArea, this.worldTransform);
    else {
      if (this.renderPipeId) {
        const r = this.bounds;
        n.addFrame(
          r.minX,
          r.minY,
          r.maxX,
          r.maxY,
          this.groupTransform
        );
      }
      const o = this.children;
      for (let r = 0; r < o.length; r++)
        o[r]._getGlobalBoundsRecursive(i, n, t);
    }
    if (s) {
      let o = !1;
      const r = this.renderGroup || this.parentRenderGroup;
      for (let a = 0; a < this.effects.length; a++)
        this.effects[a].addBounds && (o || (o = !0, n.applyMatrix(r.worldTransform)), this.effects[a].addBounds(n, !0));
      o && n.applyMatrix(r.worldTransform.copyTo(NK).invert()), e.addBounds(n), eo.return(n);
    } else this.renderGroup && (e.addBounds(n, this.relativeGroupTransform), eo.return(n));
  }
};
function q1(i, e, t) {
  t.clear();
  let n, s;
  return i.parent ? e ? n = i.parent.worldTransform : (s = oi.get().identity(), n = K1(i, s)) : n = st.IDENTITY, wS(i, t, n, e), s && oi.return(s), t.isValid || t.set(0, 0, 0, 0), t;
}
function wS(i, e, t, n) {
  var a, l;
  if (!i.visible || !i.measurable) return;
  let s;
  n ? s = i.worldTransform : (i.updateLocalTransform(), s = oi.get(), s.appendFrom(i.localTransform, t));
  const o = e, r = !!i.effects.length;
  if (r && (e = eo.get().clear()), i.boundsArea)
    e.addRect(i.boundsArea, s);
  else {
    const d = i.bounds;
    d && !d.isEmpty() && (e.matrix = s, e.addBounds(d));
    for (let c = 0; c < i.children.length; c++)
      wS(i.children[c], e, s, n);
  }
  if (r) {
    for (let d = 0; d < i.effects.length; d++)
      (l = (a = i.effects[d]).addBounds) == null || l.call(a, e);
    o.addBounds(e, st.IDENTITY), eo.return(e);
  }
  n || oi.return(s);
}
function K1(i, e) {
  const t = i.parent;
  return t && (K1(t, e), t.updateLocalTransform(), e.append(t.localTransform)), e;
}
function ia(i, e) {
  if (i === 16777215 || !e) return e;
  if (e === 16777215 || !i) return i;
  const t = i >> 16 & 255, n = i >> 8 & 255, s = i & 255, o = e >> 16 & 255, r = e >> 8 & 255, a = e & 255, l = t * o / 255 | 0, d = n * r / 255 | 0, c = s * a / 255 | 0;
  return (l << 16) + (d << 8) + c;
}
const kk = 16777215;
function hf(i, e) {
  return i === kk ? e : e === kk ? i : ia(i, e);
}
function sa(i) {
  return ((i & 255) << 16) + (i & 65280) + (i >> 16 & 255);
}
const GK = {
  getGlobalAlpha(i) {
    if (i)
      return this.renderGroup ? this.renderGroup.worldAlpha : this.parentRenderGroup ? this.parentRenderGroup.worldAlpha * this.alpha : this.alpha;
    let e = this.alpha, t = this.parent;
    for (; t; )
      e *= t.alpha, t = t.parent;
    return e;
  },
  getGlobalTransform(i = new st(), e) {
    if (e)
      return i.copyFrom(this.worldTransform);
    this.updateLocalTransform();
    const t = K1(this, oi.get().identity());
    return i.appendFrom(this.localTransform, t), oi.return(t), i;
  },
  getGlobalTint(i) {
    if (i)
      return this.renderGroup ? sa(this.renderGroup.worldColor) : this.parentRenderGroup ? sa(
        hf(this.localColor, this.parentRenderGroup.worldColor)
      ) : this.tint;
    let e = this.localColor, t = this.parent;
    for (; t; )
      e = hf(e, t.localColor), t = t.parent;
    return sa(e);
  }
};
function Y1(i, e, t) {
  return e.clear(), t || (t = st.IDENTITY), kS(i, e, t, i, !0), e.isValid || e.set(0, 0, 0, 0), e;
}
function kS(i, e, t, n, s) {
  var l, d;
  let o;
  if (s)
    o = oi.get(), o = t.copyTo(o);
  else {
    if (!i.visible || !i.measurable) return;
    i.updateLocalTransform();
    const c = i.localTransform;
    o = oi.get(), o.appendFrom(c, t);
  }
  const r = e, a = !!i.effects.length;
  if (a && (e = eo.get().clear()), i.boundsArea)
    e.addRect(i.boundsArea, o);
  else {
    i.renderPipeId && (e.matrix = o, e.addBounds(i.bounds));
    const c = i.children;
    for (let h = 0; h < c.length; h++)
      kS(c[h], e, o, n, !1);
  }
  if (a) {
    for (let c = 0; c < i.effects.length; c++)
      (d = (l = i.effects[c]).addLocalBounds) == null || d.call(l, e, n);
    r.addBounds(e, st.IDENTITY), eo.return(e);
  }
  oi.return(o);
}
function _S(i, e) {
  const t = i.children;
  for (let n = 0; n < t.length; n++) {
    const s = t[n], o = s.uid, r = (s._didViewChangeTick & 65535) << 16 | s._didContainerChangeTick & 65535, a = e.index;
    (e.data[a] !== o || e.data[a + 1] !== r) && (e.data[e.index] = o, e.data[e.index + 1] = r, e.didChange = !0), e.index = a + 2, s.children.length && _S(s, e);
  }
  return e.didChange;
}
const jK = new st(), HK = {
  _localBoundsCacheId: -1,
  _localBoundsCacheData: null,
  _setWidth(i, e) {
    const t = Math.sign(this.scale.x) || 1;
    e !== 0 ? this.scale.x = i / e * t : this.scale.x = t;
  },
  _setHeight(i, e) {
    const t = Math.sign(this.scale.y) || 1;
    e !== 0 ? this.scale.y = i / e * t : this.scale.y = t;
  },
  getLocalBounds() {
    this._localBoundsCacheData || (this._localBoundsCacheData = {
      data: [],
      index: 1,
      didChange: !1,
      localBounds: new Gn()
    });
    const i = this._localBoundsCacheData;
    return i.index = 1, i.didChange = !1, i.data[0] !== this._didViewChangeTick && (i.didChange = !0, i.data[0] = this._didViewChangeTick), _S(this, i), i.didChange && Y1(this, i.localBounds, jK), i.localBounds;
  },
  getBounds(i, e) {
    return q1(this, i, e || new Gn());
  }
}, VK = {
  _onRender: null,
  set onRender(i) {
    const e = this.renderGroup || this.parentRenderGroup;
    if (!i) {
      this._onRender && (e == null || e.removeOnRender(this)), this._onRender = null;
      return;
    }
    this._onRender || e == null || e.addOnRender(this), this._onRender = i;
  },
  get onRender() {
    return this._onRender;
  }
}, WK = {
  _zIndex: 0,
  sortDirty: !1,
  sortableChildren: !1,
  get zIndex() {
    return this._zIndex;
  },
  set zIndex(i) {
    this._zIndex !== i && (this._zIndex = i, this.depthOfChildModified());
  },
  depthOfChildModified() {
    this.parent && (this.parent.sortableChildren = !0, this.parent.sortDirty = !0), this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0);
  },
  sortChildren() {
    this.sortDirty && (this.sortDirty = !1, this.children.sort(qK));
  }
};
function qK(i, e) {
  return i._zIndex - e._zIndex;
}
const KK = {
  getGlobalPosition(i = new Wt(), e = !1) {
    return this.parent ? this.parent.toGlobal(this._position, i, e) : (i.x = this._position.x, i.y = this._position.y), i;
  },
  toGlobal(i, e, t = !1) {
    const n = this.getGlobalTransform(oi.get(), t);
    return e = n.apply(i, e), oi.return(n), e;
  },
  toLocal(i, e, t, n) {
    e && (i = e.toGlobal(i, t, n));
    const s = this.getGlobalTransform(oi.get(), n);
    return t = s.applyInverse(i, t), oi.return(s), t;
  }
};
class X1 {
  constructor() {
    this.uid = Nt("instructionSet"), this.instructions = [], this.instructionSize = 0, this.renderables = [], this.gcTick = 0;
  }
  /** reset the instruction set so it can be reused set size back to 0 */
  reset() {
    this.instructionSize = 0;
  }
  /**
   * Destroy the instruction set, clearing the instructions and renderables and notifying
   * each render pipe so it can release any per-InstructionSet cached resources.
   * @internal
   */
  destroy() {
    var e, t;
    if (this.renderPipes)
      for (const n in this.renderPipes)
        (t = (e = this.renderPipes[n]).destroyInstructionSet) == null || t.call(e, this);
    this.instructions.length = 0, this.renderables.length = 0, this.renderPipes = null, this.gcTick = 0;
  }
  /**
   * Add an instruction to the set
   * @param instruction - add an instruction to the set
   */
  add(e) {
    this.instructions[this.instructionSize++] = e;
  }
  /**
   * Log the instructions to the console (for debugging)
   * @internal
   */
  log() {
    this.instructions.length = this.instructionSize, console.table(this.instructions, ["type", "action"]);
  }
}
class SS {
  constructor() {
    this._screenSizes = /* @__PURE__ */ new Map(), this._widths = [], this._heights = [];
  }
  /** The number of renderers with a registered screen. */
  get size() {
    return this._screenSizes.size;
  }
  /**
   * Registers, or updates, the screen size of a renderer.
   * @param rendererUid - The uid of the renderer, used to update or remove this screen later.
   * @param pixelWidth - The width of the screen in physical pixels.
   * @param pixelHeight - The height of the screen in physical pixels.
   * @returns `true` if this changed the registered screens, `false` if the size was already registered.
   */
  set(e, t, n) {
    const s = this._screenSizes.get(e);
    return s && s.pixelWidth === t && s.pixelHeight === n ? !1 : (this._screenSizes.set(e, { pixelWidth: t, pixelHeight: n }), this._update(), !0);
  }
  /**
   * Removes the screen of a renderer.
   * @param rendererUid - The uid the screen was registered with.
   * @returns `true` if a screen was removed, `false` if the renderer had none registered.
   */
  remove(e) {
    return this._screenSizes.delete(e) ? (this._update(), !0) : !1;
  }
  /**
   * The smallest registered screen width the request fits in.
   * @param pixelWidth - The requested width in physical pixels.
   * @returns The smallest live screen width that is at least `pixelWidth`, or `undefined` if none.
   */
  getFittingWidth(e) {
    return this._getFittingAxis(e, this._widths);
  }
  /**
   * The smallest registered screen height the request fits in.
   * @param pixelHeight - The requested height in physical pixels.
   * @returns The smallest live screen height that is at least `pixelHeight`, or `undefined` if none.
   */
  getFittingHeight(e) {
    return this._getFittingAxis(e, this._heights);
  }
  /**
   * Whether a live screen uses this width.
   * @param width - The width in physical pixels.
   */
  hasWidth(e) {
    return this._widths.includes(e);
  }
  /**
   * Whether a live screen uses this height.
   * @param height - The height in physical pixels.
   */
  hasHeight(e) {
    return this._heights.includes(e);
  }
  /**
   * The smallest registered screen on this axis that the request still fits in.
   * @param pixelSize - The requested size on this axis in physical pixels.
   * @param screenSizes - The live screen sizes on this axis, sorted ascending.
   * @returns The smallest screen size that is at least `pixelSize`, or `undefined` if none.
   */
  _getFittingAxis(e, t) {
    for (let n = 0; n < t.length; n++) {
      const s = t[n];
      if (s >= e) return s;
    }
  }
  /** Rebuilds the sorted unique sizes for each axis. */
  _update() {
    this._widths = [...this._screenSizes.values()].map((e) => e.pixelWidth).filter((e, t, n) => n.indexOf(e) === t).sort((e, t) => e - t), this._heights = [...this._screenSizes.values()].map((e) => e.pixelHeight).filter((e, t, n) => n.indexOf(e) === t).sort((e, t) => e - t);
  }
}
let YK = 0;
const kg = 32767, XK = 4294967296, JK = 8589934592, _k = /* @__PURE__ */ Object.create(null);
let ZK = 0;
function QK(i) {
  const e = _k[i];
  return e !== void 0 ? e : _k[i] = ZK++;
}
function eY(i, e, t, n, s, o) {
  return (i << 17) + (e << 2) + ((n ? 1 : 0) << 1) + (t ? 1 : 0) + (o === "nearest" ? 1 : 0) * XK + QK(s) * JK;
}
class tY {
  /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {SCALE_MODE} [textureOptions.scaleMode] - See {@link SCALE_MODE} for possible values.
   */
  constructor(e) {
    this._buckets = /* @__PURE__ */ new Map(), this._poolKey = /* @__PURE__ */ Object.create(null), this._poolStyle = /* @__PURE__ */ Object.create(null), this._screens = new SS(), this._enableFullScreen = !1, this.textureOptions = e || {};
  }
  /**
   * A style built from the pool options. The pool no longer applies it to anything.
   * @deprecated since 8.21.0, pooled textures carry their own style; pass `scaleMode` in the request instead.
   */
  get textureStyle() {
    return rt(js, "TexturePool.textureStyle is no longer used, pooled textures carry their own style. Pass scaleMode in the request instead."), this._textureStyle || (this._textureStyle = new xp(this.textureOptions)), this._textureStyle;
  }
  set textureStyle(e) {
    rt(js, "TexturePool.textureStyle is no longer used, pooled textures carry their own style. Pass scaleMode in the request instead."), this._textureStyle = e;
  }
  /**
   * Has no effect. The pool sizes textures to the screens registered with
   * {@link TexturePoolClass#setScreenSize|setScreenSize}.
   * @deprecated since 8.21.0
   */
  get enableFullScreen() {
    return rt(js, "TexturePool.enableFullScreen is no longer used, the pool sizes textures to the screens registered with setScreenSize."), this._enableFullScreen;
  }
  set enableFullScreen(e) {
    rt(js, "TexturePool.enableFullScreen is no longer used, the pool sizes textures to the screens registered with setScreenSize."), this._enableFullScreen = e;
  }
  createTexture(...e) {
    var r, a, l, d, c, h, f, p;
    let t = e[0];
    typeof t == "number" && (rt(js, "TexturePool.createTexture params are now an options object. See params: { width, height, antialias, autoGenerateMipmaps }"), t = {
      width: t,
      height: e[1],
      antialias: (r = e[2]) != null ? r : !1,
      autoGenerateMipmaps: (a = e[3]) != null ? a : !1
    });
    const n = (d = (l = t.format) != null ? l : this.textureOptions.format) != null ? d : un.defaultOptions.format, s = (h = (c = t.scaleMode) != null ? c : this.textureOptions.scaleMode) != null ? h : xp.defaultOptions.scaleMode, o = new un({
      ...this.textureOptions,
      width: t.width,
      height: t.height,
      resolution: 1,
      antialias: (f = t.antialias) != null ? f : !1,
      autoGarbageCollect: !1,
      autoGenerateMipmaps: (p = t.autoGenerateMipmaps) != null ? p : !1,
      format: n,
      scaleMode: s
    });
    return new et({
      source: o,
      label: `texturePool_${YK++}`
    });
  }
  getOptimalTexture(...e) {
    var v, x, w, S, M, _, T, k, P, A;
    let t = e[0];
    typeof t == "number" && (rt(js, "TexturePool.getOptimalTexture params are now an options object. See params: { width, height, resolution, antialias, autoGenerateMipmaps }"), t = {
      width: t,
      height: e[1],
      resolution: (v = e[2]) != null ? v : 1,
      antialias: (x = e[3]) != null ? x : !1,
      autoGenerateMipmaps: (w = e[4]) != null ? w : !1
    });
    const n = t.width, s = t.height, o = (S = t.resolution) != null ? S : 1, r = (M = t.antialias) != null ? M : !1, a = (_ = t.autoGenerateMipmaps) != null ? _ : !1, l = (k = (T = t.format) != null ? T : this.textureOptions.format) != null ? k : un.defaultOptions.format, d = (A = (P = t.scaleMode) != null ? P : this.textureOptions.scaleMode) != null ? A : xp.defaultOptions.scaleMode, { width: c, height: h } = this.getOptimalSize(
      n,
      s,
      o
    );
    (c > kg || h > kg) && dt(`TexturePool: ${c}x${h} is larger than the ${kg}px pool key limit, textures of this size may be pooled together`);
    const f = eY(c, h, r, a, l, d);
    let p = this._buckets.get(f);
    p || (p = [], this._buckets.set(f, p));
    let y = p.pop();
    return y || (y = this.createTexture({
      width: c,
      height: h,
      antialias: r,
      autoGenerateMipmaps: a,
      format: l,
      scaleMode: d
    }), this._poolStyle[y.uid] = y.source.style), y.source._resolution = o, y.source.width = c / o, y.source.height = h / o, y.source.pixelWidth = c, y.source.pixelHeight = h, y.frame.x = 0, y.frame.y = 0, y.frame.width = n, y.frame.height = s, y.updateUvs(), this._poolKey[y.uid] = f, y;
  }
  /**
   * The backing size, in physical pixels, that {@link TexturePoolClass#getOptimalTexture|getOptimalTexture}
   * would allocate for a request, without taking a texture from the pool.
   *
   * Each axis is the next power of two, or the smallest registered screen the request fits inside
   * (see {@link TexturePoolClass#setScreenSize|setScreenSize}). Use it when a consumer needs to know
   * where a request's content will sit inside its pooled texture before it has one, such as a uniform
   * that maps content space onto texture space.
   * @param frameWidth - The minimum width of the texture.
   * @param frameHeight - The minimum height of the texture.
   * @param resolution - The resolution of the texture.
   * @returns The width and height the pooled texture would have, in physical pixels.
   */
  getOptimalSize(e, t, n = 1) {
    const s = Math.ceil(e * n - 1e-6), o = Math.ceil(t * n - 1e-6), r = cf(s), a = this._screens.getFittingWidth(s), l = cf(o), d = this._screens.getFittingHeight(o);
    return {
      width: a !== void 0 ? Math.min(a, r) : r,
      height: d !== void 0 ? Math.min(d, l) : l
    };
  }
  /**
   * Gets a pooled texture matching the dimensions and resolution of the given texture.
   *
   * This is a convenience wrapper around {@link TexturePoolClass#getOptimalTexture|getOptimalTexture}
   * that copies width, height, and resolution from an existing texture. Useful when a filter needs
   * a temporary texture the same size as its input (e.g., for multi-pass blur).
   * @param texture - The texture whose dimensions to match.
   * @param antialias - Whether to use antialias on the pooled texture. Defaults to `false`.
   * @returns A pooled texture with power-of-two or screen sized backing dimensions at the source resolution.
   */
  getSameSizeTexture(e, t = !1) {
    const n = e.source;
    return this.getOptimalTexture({
      width: e.width,
      height: e.height,
      resolution: n._resolution,
      antialias: t
    });
  }
  /**
   * Returns a texture to the pool so it can be reused by future
   * {@link TexturePoolClass#getOptimalTexture|getOptimalTexture}
   * or {@link TexturePoolClass#getSameSizeTexture|getSameSizeTexture} calls.
   *
   * If you gave the texture a style of your own after obtaining it (a different address mode, anisotropy
   * or similar), pass `resetStyle = true` so the pool puts its own style back. Otherwise your style stays
   * on the texture and the next consumer inherits it.
   * @param renderTexture - The texture to return to the pool.
   * @param resetStyle - When `true`, restores the style the pool created for this texture. Defaults to `false`.
   */
  returnTexture(e, t = !1) {
    const n = e.uid, s = this._poolKey[n];
    if (s === void 0) {
      dt("TexturePool: returnTexture was passed a texture that did not come from this pool, ignoring it");
      return;
    }
    const o = this._poolStyle[n];
    t && e.source.style !== o && (e.source.style = o);
    const r = this._buckets.get(s);
    if (!r) {
      delete this._poolKey[n], delete this._poolStyle[n], e.destroy(!0);
      return;
    }
    r.push(e);
  }
  /**
   * Registers the screen size of a renderer with the pool, in physical pixels.
   *
   * While a screen is registered, a request that fits inside it on an axis is given that screen's size on
   * that axis instead of the next power of two, which stops a full screen filter from allocating a texture
   * far larger than the screen. Requests larger than every registered screen on an axis keep the power of
   * two size - the pool never rounds a request up to a screen it does not fit in.
   * @param rendererUid - The uid of the renderer, used to update or remove this screen later.
   * @param pixelWidth - The width of the screen in physical pixels.
   * @param pixelHeight - The height of the screen in physical pixels.
   */
  setScreenSize(e, t, n) {
    this._screens.set(e, t, n) && this._pruneScreenTextures();
  }
  /**
   * Removes a screen previously registered with
   * {@link TexturePoolClass#setScreenSize|setScreenSize}, destroying any idle textures that were
   * only being kept for it.
   * @param rendererUid - The uid the screen was registered with.
   */
  removeScreen(e) {
    this._screens.remove(e) && this._pruneScreenTextures();
  }
  /**
   * Destroys the idle textures in every bucket that has a non power of two dimension matching no live
   * screen. Power of two buckets are always kept, as any request can fall back to them.
   */
  _pruneScreenTextures() {
    for (const [e, t] of this._buckets) {
      const n = e >>> 0, s = n >>> 17, o = n >>> 2 & 32767;
      ($l(s) || this._screens.hasWidth(s)) && ($l(o) || this._screens.hasHeight(o)) || (this._dropTextures(t, !0), this._buckets.delete(e));
    }
  }
  /**
   * Forgets idle textures were ever handed out, so a later return is ignored, and optionally destroys them.
   * @param textures - The textures of one bucket.
   * @param destroy - Whether to destroy the textures as well.
   */
  _dropTextures(e, t) {
    for (let n = 0; n < e.length; n++) {
      const s = e[n];
      delete this._poolKey[s.uid], delete this._poolStyle[s.uid], t && s.destroy(!0);
    }
  }
  /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */
  clear(e) {
    for (const t of this._buckets.values())
      this._dropTextures(t, e !== !1);
    this._buckets.clear();
  }
}
const Nn = new tY();
Yl.register(Nn);
class jv {
  constructor() {
    this.renderPipeId = "renderGroup", this.root = null, this.canBundle = !1, this.renderGroupParent = null, this.renderGroupChildren = [], this.worldTransform = new st(), this.worldColorAlpha = 4294967295, this.worldColor = 16777215, this.worldAlpha = 1, this.childrenToUpdate = /* @__PURE__ */ Object.create(null), this.updateTick = 0, this.gcTick = 0, this.childrenRenderablesToUpdate = { list: [], index: 0 }, this.structureDidChange = !0, this.instructionSet = new X1(), this._onRenderContainers = [], this.textureNeedsUpdate = !0, this.isCachedAsTexture = !1, this._matrixDirty = 7;
  }
  init(e) {
    this.root = e, e._onRender && this.addOnRender(e), e.didChange = !0;
    const t = e.children;
    for (let n = 0; n < t.length; n++) {
      const s = t[n];
      s._updateFlags = 15, this.addChild(s);
    }
  }
  enableCacheAsTexture(e = {}) {
    this.textureOptions = e, this.isCachedAsTexture = !0, this.textureNeedsUpdate = !0;
  }
  disableCacheAsTexture() {
    this.isCachedAsTexture = !1, this.texture && (Nn.returnTexture(this.texture), this.texture = null);
  }
  updateCacheTexture() {
    this.textureNeedsUpdate = !0;
    const e = this._parentCacheAsTextureRenderGroup;
    e && !e.textureNeedsUpdate && e.updateCacheTexture();
  }
  reset() {
    this.renderGroupChildren.length = 0;
    for (const e in this.childrenToUpdate) {
      const t = this.childrenToUpdate[e];
      t.list.fill(null), t.index = 0;
    }
    this.childrenRenderablesToUpdate.index = 0, this.childrenRenderablesToUpdate.list.fill(null), this.root = null, this.updateTick = 0, this.structureDidChange = !0, this._onRenderContainers.length = 0, this.renderGroupParent = null, this.disableCacheAsTexture();
  }
  get localTransform() {
    return this.root.localTransform;
  }
  addRenderGroupChild(e) {
    e.renderGroupParent && e.renderGroupParent._removeRenderGroupChild(e), e.renderGroupParent = this, this.renderGroupChildren.push(e);
  }
  _removeRenderGroupChild(e) {
    const t = this.renderGroupChildren.indexOf(e);
    t > -1 && this.renderGroupChildren.splice(t, 1), e.renderGroupParent = null;
  }
  addChild(e) {
    if (this.structureDidChange = !0, e.parentRenderGroup = this, e.updateTick = -1, e.parent === this.root ? e.relativeRenderGroupDepth = 1 : e.relativeRenderGroupDepth = e.parent.relativeRenderGroupDepth + 1, e.didChange = !0, this.onChildUpdate(e), e.renderGroup) {
      this.addRenderGroupChild(e.renderGroup);
      return;
    }
    e._onRender && this.addOnRender(e);
    const t = e.children;
    for (let n = 0; n < t.length; n++)
      this.addChild(t[n]);
  }
  removeChild(e) {
    if (this.structureDidChange = !0, e._onRender && (e.renderGroup || this.removeOnRender(e)), e.parentRenderGroup = null, e.renderGroup) {
      this._removeRenderGroupChild(e.renderGroup);
      return;
    }
    const t = e.children;
    for (let n = 0; n < t.length; n++)
      this.removeChild(t[n]);
  }
  removeChildren(e) {
    for (let t = 0; t < e.length; t++)
      this.removeChild(e[t]);
  }
  onChildUpdate(e) {
    let t = this.childrenToUpdate[e.relativeRenderGroupDepth];
    t || (t = this.childrenToUpdate[e.relativeRenderGroupDepth] = {
      index: 0,
      list: []
    }), t.list[t.index++] = e;
  }
  updateRenderable(e) {
    e.globalDisplayStatus < 7 || (this.instructionSet.renderPipes[e.renderPipeId].updateRenderable(e), e.didViewUpdate = !1);
  }
  onChildViewUpdate(e) {
    this.childrenRenderablesToUpdate.list[this.childrenRenderablesToUpdate.index++] = e;
  }
  get isRenderable() {
    return this.root.localDisplayStatus === 7 && this.worldAlpha > 0;
  }
  /**
   * adding a container to the onRender list will make sure the user function
   * passed in to the user defined 'onRender` callBack
   * @param container - the container to add to the onRender list
   */
  addOnRender(e) {
    this._onRenderContainers.indexOf(e) === -1 && this._onRenderContainers.push(e);
  }
  removeOnRender(e) {
    const t = this._onRenderContainers.indexOf(e);
    t !== -1 && this._onRenderContainers.splice(t, 1);
  }
  runOnRender(e) {
    for (let t = 0; t < this._onRenderContainers.length; t++)
      this._onRenderContainers[t]._onRender(e);
  }
  destroy() {
    var e;
    this.disableCacheAsTexture(), this.renderGroupParent = null, this.root = null, this.childrenRenderablesToUpdate = null, this.childrenToUpdate = null, this.renderGroupChildren = null, this._onRenderContainers = null, (e = this.instructionSet) == null || e.destroy(), this.instructionSet = null;
  }
  getChildren(e = []) {
    const t = this.root.children;
    for (let n = 0; n < t.length; n++)
      this._getChildren(t[n], e);
    return e;
  }
  _getChildren(e, t = []) {
    if (t.push(e), e.renderGroup) return t;
    const n = e.children;
    for (let s = 0; s < n.length; s++)
      this._getChildren(n[s], t);
    return t;
  }
  invalidateMatrices() {
    this._matrixDirty = 7;
  }
  /**
   * Returns the inverse of the world transform matrix.
   * @returns {Matrix} The inverse of the world transform matrix.
   */
  get inverseWorldTransform() {
    return (this._matrixDirty & 1) === 0 ? this._inverseWorldTransform : (this._matrixDirty &= -2, this._inverseWorldTransform || (this._inverseWorldTransform = new st()), this._inverseWorldTransform.copyFrom(this.worldTransform).invert());
  }
  /**
   * Returns the inverse of the texture offset transform matrix.
   * @returns {Matrix} The inverse of the texture offset transform matrix.
   */
  get textureOffsetInverseTransform() {
    return (this._matrixDirty & 2) === 0 ? this._textureOffsetInverseTransform : (this._matrixDirty &= -3, this._textureOffsetInverseTransform || (this._textureOffsetInverseTransform = new st()), this._textureOffsetInverseTransform.copyFrom(this.inverseWorldTransform).translate(
      -this._textureBounds.x,
      -this._textureBounds.y
    ));
  }
  /**
   * Returns the inverse of the parent texture transform matrix.
   * This is used to properly transform coordinates when rendering into cached textures.
   * @returns {Matrix} The inverse of the parent texture transform matrix.
   */
  get inverseParentTextureTransform() {
    if ((this._matrixDirty & 4) === 0) return this._inverseParentTextureTransform;
    this._matrixDirty &= -5;
    const e = this._parentCacheAsTextureRenderGroup;
    return e ? (this._inverseParentTextureTransform || (this._inverseParentTextureTransform = new st()), this._inverseParentTextureTransform.copyFrom(this.worldTransform).prepend(e.inverseWorldTransform).translate(
      -e._textureBounds.x,
      -e._textureBounds.y
    )) : this.worldTransform;
  }
  /**
   * Returns a matrix that transforms coordinates to the correct coordinate space of the texture being rendered to.
   * This is the texture offset inverse transform of the closest parent RenderGroup that is cached as a texture.
   * @returns {Matrix | null} The transform matrix for the cached texture coordinate space,
   * or null if no parent is cached as texture.
   */
  get cacheToLocalTransform() {
    return this.isCachedAsTexture ? this.textureOffsetInverseTransform : this._parentCacheAsTextureRenderGroup ? this._parentCacheAsTextureRenderGroup.textureOffsetInverseTransform : null;
  }
}
function nY(i, e, t = {}) {
  for (const n in e)
    !t[n] && e[n] !== void 0 && (i[n] = e[n]);
}
const _g = new Fn(null), ih = new Fn(null), Sg = new Fn(null, 1, 1), sh = new Fn(null), pf = 1, J1 = 2, bc = 4;
class mn extends bi {
  constructor(e = {}) {
    var t, n;
    super(), this.uid = Nt("renderable"), this._updateFlags = 15, this.renderGroup = null, this.parentRenderGroup = null, this.parentRenderGroupIndex = 0, this.didChange = !1, this.didViewUpdate = !1, this.relativeRenderGroupDepth = 0, this.children = [], this.parent = null, this.includeInBuild = !0, this.measurable = !0, this.isSimple = !0, this.parentRenderLayer = null, this.updateTick = -1, this.localTransform = new st(), this.relativeGroupTransform = new st(), this.groupTransform = this.relativeGroupTransform, this.destroyed = !1, this._position = new Fn(this, 0, 0), this._scale = Sg, this._pivot = ih, this._origin = sh, this._skew = _g, this._cx = 1, this._sx = 0, this._cy = 0, this._sy = 1, this._rotation = 0, this.localColor = 16777215, this.localAlpha = 1, this.groupAlpha = 1, this.groupColor = 16777215, this.groupColorAlpha = 4294967295, this.localBlendMode = "inherit", this.groupBlendMode = "normal", this.localDisplayStatus = 7, this.globalDisplayStatus = 7, this._didContainerChangeTick = 0, this._didViewChangeTick = 0, this._didLocalTransformChangeId = -1, this.effects = [], nY(this, e, {
      children: !0,
      parent: !0,
      effects: !0
    }), (t = e.children) == null || t.forEach((s) => this.addChild(s)), (n = e.parent) == null || n.addChild(this);
  }
  /**
   * Mixes all enumerable properties and methods from a source object to Container.
   * @param source - The source of properties and methods to mix in.
   * @deprecated since 8.8.0
   */
  static mixin(e) {
    rt("8.8.0", "Container.mixin is deprecated, please use extensions.mixin instead."), ht.mixin(mn, e);
  }
  // = 'default';
  /**
   * We now use the _didContainerChangeTick and _didViewChangeTick to track changes
   * @deprecated since 8.2.6
   * @ignore
   */
  set _didChangeId(e) {
    this._didViewChangeTick = e >> 12 & 4095, this._didContainerChangeTick = e & 4095;
  }
  /** @ignore */
  get _didChangeId() {
    return this._didContainerChangeTick & 4095 | (this._didViewChangeTick & 4095) << 12;
  }
  /**
   * Adds one or more children to the container.
   * The children will be rendered as part of this container's display list.
   * @example
   * ```ts
   * // Add a single child
   * container.addChild(sprite);
   *
   * // Add multiple children
   * container.addChild(background, player, foreground);
   *
   * // Add with type checking
   * const sprite = container.addChild<Sprite>(new Sprite(texture));
   * sprite.tint = 'red';
   * ```
   * @param children - The Container(s) to add to the container
   * @returns The first child that was added
   * @see {@link Container#removeChild} For removing children
   * @see {@link Container#addChildAt} For adding at specific index
   */
  addChild(...e) {
    if (this.allowChildren || rt(dn, "addChild: Only Containers will be allowed to add children in v8.0.0"), e.length > 1) {
      for (let s = 0; s < e.length; s++)
        this.addChild(e[s]);
      return e[0];
    }
    const t = e[0], n = this.renderGroup || this.parentRenderGroup;
    return t.parent === this ? (this.children.splice(this.children.indexOf(t), 1), this.children.push(t), n && (n.structureDidChange = !0), t) : (t.parent && t.parent.removeChild(t), this.children.push(t), this.sortableChildren && (this.sortDirty = !0), t.parent = this, t.didChange = !0, t._updateFlags = 15, n && n.addChild(t), this.emit("childAdded", t, this, this.children.length - 1), t.emit("added", this), this._didViewChangeTick++, t._zIndex !== 0 && t.depthOfChildModified(), t);
  }
  /**
   * Removes one or more children from the container.
   * When removing multiple children, events will be triggered for each child in sequence.
   * @example
   * ```ts
   * // Remove a single child
   * const removed = container.removeChild(sprite);
   *
   * // Remove multiple children
   * const bg = container.removeChild(background, player, userInterface);
   *
   * // Remove with type checking
   * const sprite = container.removeChild<Sprite>(childSprite);
   * sprite.texture = newTexture;
   * ```
   * @param children - The Container(s) to remove
   * @returns The first child that was removed
   * @see {@link Container#addChild} For adding children
   * @see {@link Container#removeChildren} For removing multiple children
   */
  removeChild(...e) {
    if (e.length > 1) {
      for (let s = 0; s < e.length; s++)
        this.removeChild(e[s]);
      return e[0];
    }
    const t = e[0], n = this.children.indexOf(t);
    return n > -1 && (this._didViewChangeTick++, this.children.splice(n, 1), this.renderGroup ? this.renderGroup.removeChild(t) : this.parentRenderGroup && this.parentRenderGroup.removeChild(t), t.parentRenderLayer && t.parentRenderLayer.detach(t), t.parent = null, this.emit("childRemoved", t, this, n), t.emit("removed", this)), t;
  }
  /** @ignore */
  _onUpdate(e) {
    e && e === this._skew && this._updateSkew(), this._didContainerChangeTick++, !this.didChange && (this.didChange = !0, this.parentRenderGroup && this.parentRenderGroup.onChildUpdate(this));
  }
  set isRenderGroup(e) {
    !!this.renderGroup !== e && (e ? this.enableRenderGroup() : this.disableRenderGroup());
  }
  /**
   * Returns true if this container is a render group.
   * This means that it will be rendered as a separate pass, with its own set of instructions
   * @advanced
   */
  get isRenderGroup() {
    return !!this.renderGroup;
  }
  /**
   * Calling this enables a render group for this container.
   * This means it will be rendered as a separate set of instructions.
   * The transform of the container will also be handled on the GPU rather than the CPU.
   * @advanced
   */
  enableRenderGroup() {
    if (this.renderGroup) return;
    const e = this.parentRenderGroup;
    e == null || e.removeChild(this), this.renderGroup = $n.get(jv, this), this.groupTransform = st.IDENTITY, e == null || e.addChild(this), this._updateIsSimple();
  }
  /**
   * This will disable the render group for this container.
   * @advanced
   */
  disableRenderGroup() {
    if (!this.renderGroup) return;
    const e = this.parentRenderGroup;
    e == null || e.removeChild(this), $n.return(this.renderGroup), this.renderGroup = null, this.groupTransform = this.relativeGroupTransform, e == null || e.addChild(this), this._updateIsSimple();
  }
  /** @ignore */
  _updateIsSimple() {
    this.isSimple = !this.renderGroup && this.effects.length === 0;
  }
  /**
   * Current transform of the object based on world (parent) factors.
   *
   * This matrix represents the absolute transformation in the scene graph.
   * @example
   * ```ts
   * // Get world position
   * const worldPos = container.worldTransform;
   * console.log(`World position: (${worldPos.tx}, ${worldPos.ty})`);
   * ```
   * @readonly
   * @see {@link Container#localTransform} For local space transform
   */
  get worldTransform() {
    return this._worldTransform || (this._worldTransform = new st()), this.renderGroup ? this._worldTransform.copyFrom(this.renderGroup.worldTransform) : this.parentRenderGroup && this._worldTransform.appendFrom(this.relativeGroupTransform, this.parentRenderGroup.worldTransform), this._worldTransform;
  }
  /**
   * The position of the container on the x axis relative to the local coordinates of the parent.
   *
   * An alias to position.x
   * @example
   * ```ts
   * // Basic position
   * container.x = 100;
   * ```
   */
  get x() {
    return this._position.x;
  }
  set x(e) {
    this._position.x = e;
  }
  /**
   * The position of the container on the y axis relative to the local coordinates of the parent.
   *
   * An alias to position.y
   * @example
   * ```ts
   * // Basic position
   * container.y = 200;
   * ```
   */
  get y() {
    return this._position.y;
  }
  set y(e) {
    this._position.y = e;
  }
  /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @example
   * ```ts
   * // Basic position setting
   * container.position.set(100, 200);
   * container.position.set(100); // Sets both x and y to 100
   * // Using point data
   * container.position = { x: 50, y: 75 };
   * ```
   * @since 4.0.0
   */
  get position() {
    return this._position;
  }
  set position(e) {
    this._position.copyFrom(e);
  }
  /**
   * The rotation of the object in radians.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   *
   * // Convert from degrees
   * const degrees = 45;
   * container.rotation = degrees * Math.PI / 180;
   *
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   *
   * // Rotate around center with origin
   * container.origin.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   * ```
   */
  get rotation() {
    return this._rotation;
  }
  set rotation(e) {
    this._rotation !== e && (this._rotation = e, this._onUpdate(this._skew));
  }
  /**
   * The angle of the object in degrees.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic angle rotation
   * sprite.angle = 45; // 45 degrees
   *
   * // Rotate around center
   * sprite.pivot.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Rotate around center with origin
   * sprite.origin.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Reset rotation
   * sprite.angle = 0;
   * ```
   */
  get angle() {
    return this.rotation * uK;
  }
  set angle(e) {
    this.rotation = e * hK;
  }
  /**
   * The center of rotation, scaling, and skewing for this display object in its local space.
   * The `position` is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @example
   * ```ts
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   * ```
   * @since 4.0.0
   */
  get pivot() {
    return this._pivot === ih && (this._pivot = new Fn(this, 0, 0)), this._pivot;
  }
  set pivot(e) {
    this._pivot === ih && (this._pivot = new Fn(this, 0, 0), this._origin !== sh && dt("Setting both a pivot and origin on a Container is not recommended. This can lead to unexpected behavior if not handled carefully.")), typeof e == "number" ? this._pivot.set(e) : this._pivot.copyFrom(e);
  }
  /**
   * The skew factor for the object in radians. Skewing is a transformation that distorts
   * the object by rotating it differently at each point, creating a non-uniform shape.
   * @example
   * ```ts
   * // Basic skewing
   * container.skew.set(0.5, 0); // Skew horizontally
   * container.skew.set(0, 0.5); // Skew vertically
   *
   * // Skew with point data
   * container.skew = { x: 0.3, y: 0.3 }; // Diagonal skew
   *
   * // Reset skew
   * container.skew.set(0, 0);
   *
   * // Animate skew
   * app.ticker.add(() => {
   *     // Create wave effect
   *     container.skew.x = Math.sin(Date.now() / 1000) * 0.3;
   * });
   *
   * // Combine with rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   * container.skew.set(0.2, 0.2); // Skew the rotated object
   * ```
   * @since 4.0.0
   * @type {ObservablePoint} Point-like object with x/y properties in radians
   * @default {x: 0, y: 0}
   */
  get skew() {
    return this._skew === _g && (this._skew = new Fn(this, 0, 0)), this._skew;
  }
  set skew(e) {
    this._skew === _g && (this._skew = new Fn(this, 0, 0)), this._skew.copyFrom(e);
  }
  /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @example
   * ```ts
   * // Basic scaling
   * container.scale.set(2, 2); // Scales to double size
   * container.scale.set(2); // Scales uniformly to double size
   * container.scale = 2; // Scales uniformly to double size
   * // Scale to a specific width and height
   * container.setSize(200, 100); // Sets width to 200 and height to 100
   * ```
   * @since 4.0.0
   */
  get scale() {
    return this._scale === Sg && (this._scale = new Fn(this, 1, 1)), this._scale;
  }
  set scale(e) {
    this._scale === Sg && (this._scale = new Fn(this, 0, 0)), typeof e == "string" && (e = parseFloat(e)), typeof e == "number" ? this._scale.set(e) : this._scale.copyFrom(e);
  }
  /**
   * @experimental
   * The origin point around which the container rotates and scales without affecting its position.
   * Unlike pivot, changing the origin will not move the container's position.
   * @example
   * ```ts
   * // Rotate around center point
   * container.origin.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   *
   * // Reset origin
   * container.origin.set(0, 0);
   * ```
   */
  get origin() {
    return this._origin === sh && (this._origin = new Fn(this, 0, 0)), this._origin;
  }
  set origin(e) {
    this._origin === sh && (this._origin = new Fn(this, 0, 0), this._pivot !== ih && dt("Setting both a pivot and origin on a Container is not recommended. This can lead to unexpected behavior if not handled carefully.")), typeof e == "number" ? this._origin.set(e) : this._origin.copyFrom(e);
  }
  /**
   * The width of the Container, setting this will actually modify the scale to achieve the value set.
   * > [!NOTE] Changing the width will adjust the scale.x property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic width setting
   * container.width = 100;
   * // Optimized width setting
   * container.setSize(100, 100);
   * ```
   */
  get width() {
    return Math.abs(this.scale.x * this.getLocalBounds().width);
  }
  set width(e) {
    const t = this.getLocalBounds().width;
    this._setWidth(e, t);
  }
  /**
   * The height of the Container,
   * > [!NOTE] Changing the height will adjust the scale.y property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic height setting
   * container.height = 200;
   * // Optimized height setting
   * container.setSize(100, 200);
   * ```
   */
  get height() {
    return Math.abs(this.scale.y * this.getLocalBounds().height);
  }
  set height(e) {
    const t = this.getLocalBounds().height;
    this._setHeight(e, t);
  }
  /**
   * Retrieves the size of the container as a [Size]{@link Size} object.
   *
   * This is faster than get the width and height separately.
   * @example
   * ```ts
   * // Basic size retrieval
   * const size = container.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * container.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in.
   * @returns The size of the container.
   */
  getSize(e) {
    e || (e = {});
    const t = this.getLocalBounds();
    return e.width = Math.abs(this.scale.x * t.width), e.height = Math.abs(this.scale.y * t.height), e;
  }
  /**
   * Sets the size of the container to the specified width and height.
   * This is more efficient than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * container.setSize(100, 200);
   *
   * // Set uniform size
   * container.setSize(100); // Sets both width and height to 100
   * ```
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */
  setSize(e, t) {
    var s;
    const n = this.getLocalBounds();
    typeof e == "object" ? (t = (s = e.height) != null ? s : e.width, e = e.width) : t != null || (t = e), e !== void 0 && this._setWidth(e, n.width), t !== void 0 && this._setHeight(t, n.height);
  }
  /** Called when the skew or the rotation changes. */
  _updateSkew() {
    const e = this._rotation, t = this._skew;
    this._cx = Math.cos(e + t._y), this._sx = Math.sin(e + t._y), this._cy = -Math.sin(e - t._x), this._sy = Math.cos(e - t._x);
  }
  /**
   * Updates the transform properties of the container.
   * Allows partial updates of transform properties for optimized manipulation.
   * @example
   * ```ts
   * // Basic transform update
   * container.updateTransform({
   *     x: 100,
   *     y: 200,
   *     rotation: Math.PI / 4
   * });
   *
   * // Scale and rotate around center
   * sprite.updateTransform({
   *     pivotX: sprite.width / 2,
   *     pivotY: sprite.height / 2,
   *     scaleX: 2,
   *     scaleY: 2,
   *     rotation: Math.PI
   * });
   *
   * // Update position only
   * button.updateTransform({
   *     x: button.x + 10, // Move right
   *     y: button.y      // Keep same y
   * });
   * ```
   * @param opts - Transform options to update
   * @param opts.x - The x position
   * @param opts.y - The y position
   * @param opts.scaleX - The x-axis scale factor
   * @param opts.scaleY - The y-axis scale factor
   * @param opts.rotation - The rotation in radians
   * @param opts.skewX - The x-axis skew factor
   * @param opts.skewY - The y-axis skew factor
   * @param opts.pivotX - The x-axis pivot point
   * @param opts.pivotY - The y-axis pivot point
   * @returns This container, for chaining
   * @see {@link Container#setFromMatrix} For matrix-based transforms
   * @see {@link Container#position} For direct position access
   */
  updateTransform(e) {
    return this.position.set(
      typeof e.x == "number" ? e.x : this.position.x,
      typeof e.y == "number" ? e.y : this.position.y
    ), this.scale.set(
      typeof e.scaleX == "number" ? e.scaleX : this.scale.x,
      typeof e.scaleY == "number" ? e.scaleY : this.scale.y
    ), this.rotation = typeof e.rotation == "number" ? e.rotation : this.rotation, this.skew.set(
      typeof e.skewX == "number" ? e.skewX : this.skew.x,
      typeof e.skewY == "number" ? e.skewY : this.skew.y
    ), this.pivot.set(
      typeof e.pivotX == "number" ? e.pivotX : this.pivot.x,
      typeof e.pivotY == "number" ? e.pivotY : this.pivot.y
    ), this.origin.set(
      typeof e.originX == "number" ? e.originX : this.origin.x,
      typeof e.originY == "number" ? e.originY : this.origin.y
    ), this;
  }
  /**
   * Updates the local transform properties by decomposing the given matrix.
   * Extracts position, scale, rotation, and skew from a transformation matrix.
   * @example
   * ```ts
   * // Basic matrix transform
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * container.setFromMatrix(matrix);
   *
   * // Copy transform from another container
   * const source = new Container();
   * source.position.set(100, 100);
   * source.rotation = Math.PI / 2;
   *
   * target.setFromMatrix(source.localTransform);
   *
   * // Reset transform
   * container.setFromMatrix(Matrix.IDENTITY);
   * ```
   * @param matrix - The matrix to use for updating the transform
   * @see {@link Container#updateTransform} For property-based updates
   * @see {@link Matrix#decompose} For matrix decomposition details
   */
  setFromMatrix(e) {
    e.decompose(this);
  }
  /** Updates the local transform. */
  updateLocalTransform() {
    const e = this._didContainerChangeTick;
    if (this._didLocalTransformChangeId === e) return;
    this._didLocalTransformChangeId = e;
    const t = this.localTransform, n = this._scale, s = this._pivot, o = this._origin, r = this._position, a = n._x, l = n._y, d = s._x, c = s._y, h = -o._x, f = -o._y;
    t.a = this._cx * a, t.b = this._sx * a, t.c = this._cy * l, t.d = this._sy * l, t.tx = r._x - (d * t.a + c * t.c) + (h * t.a + f * t.c) - h, t.ty = r._y - (d * t.b + c * t.d) + (h * t.b + f * t.d) - f;
  }
  // / ///// color related stuff
  set alpha(e) {
    e !== this.localAlpha && (this.localAlpha = e, this._updateFlags |= pf, this._onUpdate());
  }
  /**
   * The opacity of the object relative to its parent's opacity.
   * Value ranges from 0 (fully transparent) to 1 (fully opaque).
   * @example
   * ```ts
   * // Basic transparency
   * sprite.alpha = 0.5; // 50% opacity
   *
   * // Inherited opacity
   * container.alpha = 0.5;
   * const child = new Sprite(texture);
   * child.alpha = 0.5;
   * container.addChild(child);
   * // child's effective opacity is 0.25 (0.5 * 0.5)
   * ```
   * @default 1
   * @see {@link Container#visible} For toggling visibility
   * @see {@link Container#renderable} For render control
   */
  get alpha() {
    return this.localAlpha;
  }
  set tint(e) {
    const n = bn.shared.setValue(e != null ? e : 16777215).toBgrNumber();
    n !== this.localColor && (this.localColor = n, this._updateFlags |= pf, this._onUpdate());
  }
  /**
   * The tint applied to the sprite.
   *
   * This can be any valid {@link ColorSource}.
   * @example
   * ```ts
   * // Basic color tinting
   * container.tint = 0xff0000; // Red tint
   * container.tint = 'red';    // Same as above
   * container.tint = '#00ff00'; // Green
   * container.tint = 'rgb(0,0,255)'; // Blue
   *
   * // Remove tint
   * container.tint = 0xffffff; // White = no tint
   * container.tint = null;     // Also removes tint
   * ```
   * @default 0xFFFFFF
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#visible} For visibility control
   */
  get tint() {
    return sa(this.localColor);
  }
  // / //////////////// blend related stuff
  set blendMode(e) {
    this.localBlendMode !== e && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= J1, this.localBlendMode = e, this._onUpdate());
  }
  /**
   * The blend mode to be applied to the sprite. Controls how pixels are blended when rendering.
   *
   * Setting to 'normal' will reset to default blending.
   * > [!NOTE] More blend modes are available after importing the `pixi.js/advanced-blend-modes` sub-export.
   * @example
   * ```ts
   * // Basic blend modes
   * sprite.blendMode = 'add';        // Additive blending
   * sprite.blendMode = 'multiply';   // Multiply colors
   * sprite.blendMode = 'screen';     // Screen blend
   *
   * // Reset blend mode
   * sprite.blendMode = 'normal';     // Normal blending
   * ```
   * @default 'normal'
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#tint} For color adjustments
   */
  get blendMode() {
    return this.localBlendMode;
  }
  // / ///////// VISIBILITY / RENDERABLE /////////////////
  /**
   * The visibility of the object. If false the object will not be drawn,
   * and the transform will not be updated.
   * @example
   * ```ts
   * // Basic visibility toggle
   * sprite.visible = false; // Hide sprite
   * sprite.visible = true;  // Show sprite
   * ```
   * @default true
   * @see {@link Container#renderable} For render-only control
   * @see {@link Container#alpha} For transparency
   */
  get visible() {
    return !!(this.localDisplayStatus & 2);
  }
  set visible(e) {
    const t = e ? 2 : 0;
    (this.localDisplayStatus & 2) !== t && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= bc, this.localDisplayStatus ^= 2, this._onUpdate(), this.emit("visibleChanged", e));
  }
  /** @ignore */
  get culled() {
    return !(this.localDisplayStatus & 4);
  }
  /** @ignore */
  set culled(e) {
    const t = e ? 0 : 4;
    (this.localDisplayStatus & 4) !== t && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= bc, this.localDisplayStatus ^= 4, this._onUpdate());
  }
  /**
   * Controls whether this object can be rendered. If false the object will not be drawn,
   * but the transform will still be updated. This is different from visible, which skips
   * transform updates.
   * @example
   * ```ts
   * // Basic render control
   * sprite.renderable = false; // Skip rendering
   * sprite.renderable = true;  // Enable rendering
   * ```
   * @default true
   * @see {@link Container#visible} For skipping transform updates
   * @see {@link Container#alpha} For transparency
   */
  get renderable() {
    return !!(this.localDisplayStatus & 1);
  }
  set renderable(e) {
    const t = e ? 1 : 0;
    (this.localDisplayStatus & 1) !== t && (this._updateFlags |= bc, this.localDisplayStatus ^= 1, this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._onUpdate());
  }
  /**
   * Whether or not the object should be rendered.
   * @advanced
   */
  get isRenderable() {
    return this.localDisplayStatus === 7 && this.groupAlpha > 0;
  }
  /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * ```ts
   * container.destroy();
   * container.destroy(true);
   * container.destroy({ children: true });
   * container.destroy({ children: true, texture: true, textureSource: true });
   * ```
   */
  destroy(e = !1) {
    var s;
    if (this.destroyed) return;
    this.destroyed = !0;
    let t;
    if (this.children.length && (t = this.removeChildren(0, this.children.length)), this.removeFromParent(), this.parent = null, this._maskEffect = null, this._filterEffect = null, this.effects = null, this._position = null, this._scale = null, this._pivot = null, this._origin = null, this._skew = null, this.emit("destroyed", this), this.removeAllListeners(), (typeof e == "boolean" ? e : e == null ? void 0 : e.children) && t)
      for (let o = 0; o < t.length; ++o)
        t[o].destroy(e);
    (s = this.renderGroup) == null || s.destroy(), this.renderGroup = null;
  }
}
ht.mixin(
  mn,
  DK,
  UK,
  KK,
  VK,
  HK,
  BK,
  FK,
  WK,
  EK,
  $K,
  GK,
  OK
);
class Z1 extends mn {
  constructor(e) {
    var t;
    super(e), this.canBundle = !0, this.allowChildren = !1, this._roundPixels = 0, this._lastUsed = -1, this._gpuData = /* @__PURE__ */ Object.create(null), this.autoGarbageCollect = !0, this._gcLastUsed = -1, this._bounds = new Gn(0, 1, 0, 0), this._boundsDirty = !0, this.autoGarbageCollect = (t = e.autoGarbageCollect) != null ? t : !0;
  }
  /**
   * The local bounds of the view in its own coordinate space.
   * Bounds are automatically updated when the view's content changes.
   * @example
   * ```ts
   * // Get bounds dimensions
   * const bounds = view.bounds;
   * console.log(`Width: ${bounds.maxX - bounds.minX}`);
   * console.log(`Height: ${bounds.maxY - bounds.minY}`);
   * ```
   * @returns The rectangular bounds of the view
   * @see {@link Bounds} For bounds operations
   */
  get bounds() {
    return this._boundsDirty ? (this.updateBounds(), this._boundsDirty = !1, this._bounds) : this._bounds;
  }
  /**
   * Whether or not to round the x/y position of the sprite.
   * @example
   * ```ts
   * // Enable pixel rounding for crisp rendering
   * view.roundPixels = true;
   * ```
   * @default false
   */
  get roundPixels() {
    return !!this._roundPixels;
  }
  set roundPixels(e) {
    this._roundPixels = e ? 1 : 0;
  }
  /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the view's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = view.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the view's bounds
   * @see {@link ViewContainer#bounds} For the bounds used in hit testing
   * @see {@link Container#toLocal} For converting global coordinates to local
   */
  containsPoint(e) {
    const t = this.bounds, { x: n, y: s } = e;
    return n >= t.minX && n <= t.maxX && s >= t.minY && s <= t.maxY;
  }
  /** @private */
  onViewUpdate() {
    if (this._didViewChangeTick++, this._boundsDirty = !0, this.didViewUpdate) return;
    this.didViewUpdate = !0;
    const e = this.renderGroup || this.parentRenderGroup;
    e && e.onChildViewUpdate(this);
  }
  /** Unloads the GPU data from the view. */
  unload() {
    var e;
    this.emit("unload", this);
    for (const t in this._gpuData)
      (e = this._gpuData[t]) == null || e.destroy();
    this._gpuData = /* @__PURE__ */ Object.create(null), this.onViewUpdate();
  }
  destroy(e) {
    this.unload(), super.destroy(e), this._bounds = null;
  }
  /**
   * Collects renderables for the view container.
   * @param instructionSet - The instruction set to collect renderables for.
   * @param renderer - The renderer to collect renderables for.
   * @param currentLayer - The current render layer.
   * @internal
   */
  collectRenderablesSimple(e, t, n) {
    const { renderPipes: s } = t;
    s.blendMode.pushBlendMode(this, this.groupBlendMode, e);
    const r = s[this.renderPipeId];
    r != null && r.addRenderable && r.addRenderable(this, e), this.didViewUpdate = !1;
    const a = this.children, l = a.length;
    for (let d = 0; d < l; d++)
      a[d].collectRenderables(e, t, n);
    s.blendMode.popBlendMode(e);
  }
}
class ks extends Z1 {
  /**
   * @param options - The options for creating the sprite.
   */
  constructor(e = et.EMPTY) {
    e instanceof et && (e = { texture: e });
    const { texture: t = et.EMPTY, anchor: n, roundPixels: s, width: o, height: r, ...a } = e;
    super({
      label: "Sprite",
      ...a
    }), this.renderPipeId = "sprite", this.batched = !0, this._visualBounds = { minX: 0, maxX: 1, minY: 0, maxY: 0 }, this._anchor = new Fn(
      {
        _onUpdate: () => {
          this.onViewUpdate();
        }
      }
    ), n ? this.anchor = n : t.defaultAnchor && (this.anchor = t.defaultAnchor), this.texture = t, this.allowChildren = !1, this.roundPixels = s != null ? s : !1, o !== void 0 && (this.width = o), r !== void 0 && (this.height = r);
  }
  /**
   * Creates a new sprite based on a source texture, image, video, or canvas element.
   * This is a convenience method that automatically creates and manages textures.
   * @example
   * ```ts
   * // Create from path or URL
   * const sprite = Sprite.from('assets/image.png');
   *
   * // Create from existing texture
   * const sprite = Sprite.from(texture);
   *
   * // Create from canvas
   * const canvas = document.createElement('canvas');
   * const sprite = Sprite.from(canvas, true); // Skip caching new texture
   * ```
   * @param source - The source to create the sprite from. Can be a path to an image, a texture,
   * or any valid texture source (canvas, video, etc.)
   * @param skipCache - Whether to skip adding to the texture cache when creating a new texture
   * @returns A new sprite based on the source
   * @see {@link Texture.from} For texture creation details
   * @see {@link Assets} For asset loading and management
   */
  static from(e, t = !1) {
    return e instanceof et ? new ks(e) : new ks(et.from(e, t));
  }
  set texture(e) {
    e || (e = et.EMPTY);
    const t = this._texture;
    t !== e && (t && t.dynamic && t.off("update", this.onViewUpdate, this), e.dynamic && e.on("update", this.onViewUpdate, this), this._texture = e, this._width && this._setWidth(this._width, this._texture.orig.width), this._height && this._setHeight(this._height, this._texture.orig.height), this.onViewUpdate());
  }
  /**
   * The texture that is displayed by the sprite. When changed, automatically updates
   * the sprite dimensions and manages texture event listeners.
   * @example
   * ```ts
   * // Create sprite with texture
   * const sprite = new Sprite({
   *     texture: Texture.from('sprite.png')
   * });
   *
   * // Update texture
   * sprite.texture = Texture.from('newSprite.png');
   *
   * // Use texture from spritesheet
   * const sheet = await Assets.load('spritesheet.json');
   * sprite.texture = sheet.textures['frame1.png'];
   *
   * // Reset to empty texture
   * sprite.texture = Texture.EMPTY;
   * ```
   * @see {@link Texture} For texture creation and management
   * @see {@link Assets} For asset loading
   */
  get texture() {
    return this._texture;
  }
  /**
   * The bounds of the sprite, taking into account the texture's trim area.
   * @example
   * ```ts
   * const texture = new Texture({
   *     source: new TextureSource({ width: 300, height: 300 }),
   *     frame: new Rectangle(196, 66, 58, 56),
   *     trim: new Rectangle(4, 4, 58, 56),
   *     orig: new Rectangle(0, 0, 64, 64),
   *     rotate: 2,
   * });
   * const sprite = new Sprite(texture);
   * const visualBounds = sprite.visualBounds;
   * // console.log(visualBounds); // { minX: -4, maxX: 62, minY: -4, maxY: 60 }
   */
  get visualBounds() {
    return wK(this._visualBounds, this._anchor, this._texture), this._visualBounds;
  }
  /**
   * @deprecated
   * @ignore
   */
  get sourceBounds() {
    return rt("8.6.1", "Sprite.sourceBounds is deprecated, use visualBounds instead."), this.visualBounds;
  }
  /** @private */
  updateBounds() {
    const e = this._anchor, t = this._texture, n = this._bounds, { width: s, height: o } = t.orig;
    n.minX = -e._x * s, n.maxX = n.minX + s, n.minY = -e._y * o, n.maxY = n.minY + o;
  }
  /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * sprite.destroy();
   * sprite.destroy(true);
   * sprite.destroy({ texture: true, textureSource: true });
   */
  destroy(e = !1) {
    if (super.destroy(e), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const n = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      this._texture.destroy(n);
    }
    this._texture = null, this._visualBounds = null, this._bounds = null, this._anchor = null;
  }
  /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    typeof e == "number" ? this._anchor.set(e) : this._anchor.copyFrom(e);
  }
  /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * sprite.width = 200;
   * console.log(sprite.scale.x); // Scale adjusted to match width
   *
   * // Set width while preserving aspect ratio
   * const ratio = sprite.height / sprite.width;
   * sprite.width = 300;
   * sprite.height = 300 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.width = sprite.texture.orig.width;
   * ```
   */
  get width() {
    return Math.abs(this.scale.x) * this._texture.orig.width;
  }
  set width(e) {
    this._setWidth(e, this._texture.orig.width), this._width = e;
  }
  /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * sprite.height = 150;
   * console.log(sprite.scale.y); // Scale adjusted to match height
   *
   * // Set height while preserving aspect ratio
   * const ratio = sprite.width / sprite.height;
   * sprite.height = 200;
   * sprite.width = 200 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.height = sprite.texture.orig.height;
   * ```
   */
  get height() {
    return Math.abs(this.scale.y) * this._texture.orig.height;
  }
  set height(e) {
    this._setHeight(e, this._texture.orig.height), this._height = e;
  }
  /**
   * Retrieves the size of the Sprite as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * const size = sprite.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * sprite.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Sprite#width} For getting just the width
   * @see {@link Sprite#height} For getting just the height
   * @see {@link Sprite#setSize} For setting both width and height
   */
  getSize(e) {
    return e || (e = {}), e.width = Math.abs(this.scale.x) * this._texture.orig.width, e.height = Math.abs(this.scale.y) * this._texture.orig.height, e;
  }
  /**
   * Sets the size of the Sprite to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * sprite.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * sprite.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * sprite.setSize({
   *     width: 200,
   *     height: 300
   * });
   *
   * // Reset to texture size
   * sprite.setSize(
   *     sprite.texture.orig.width,
   *     sprite.texture.orig.height
   * );
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Sprite#width} For setting width only
   * @see {@link Sprite#height} For setting height only
   * @see {@link Sprite#texture} For the source dimensions
   */
  setSize(e, t) {
    var n;
    typeof e == "object" ? (t = (n = e.height) != null ? n : e.width, e = e.width) : t != null || (t = e), e !== void 0 && this._setWidth(e, this._texture.orig.width), t !== void 0 && this._setHeight(t, this._texture.orig.height);
  }
}
const iY = new Gn();
function MS(i, e, t) {
  const n = iY;
  i.measurable = !0, q1(i, t, n), e.addBoundsMask(n), i.measurable = !1;
}
function TS(i, e, t) {
  const n = eo.get();
  i.measurable = !0;
  const s = oi.get().identity(), o = CS(i, t, s);
  Y1(i, n, o), i.measurable = !1, e.addBoundsMask(n), oi.return(s), eo.return(n);
}
function CS(i, e, t) {
  return i ? (i !== e && (CS(i.parent, e, t), i.updateLocalTransform(), t.append(i.localTransform)), t) : (dt("Mask bounds, renderable is not inside the root container"), t);
}
class IS {
  constructor(e) {
    this.priority = 0, this.inverse = !1, this.channel = "red", this.pipe = "alphaMask", e != null && e.mask && this.init(e.mask);
  }
  init(e) {
    this.mask = e, this.renderMaskToTexture = !(e instanceof ks), this.mask.renderable = this.renderMaskToTexture, this.mask.includeInBuild = !this.renderMaskToTexture, this.mask.measurable = !1;
  }
  reset() {
    this.mask !== null && (this.mask.measurable = !0, this.mask = null);
  }
  addBounds(e, t) {
    this.inverse || MS(this.mask, e, t);
  }
  addLocalBounds(e, t) {
    TS(this.mask, e, t);
  }
  containsPoint(e, t) {
    const n = this.mask;
    return t(n, e);
  }
  destroy() {
    this.reset();
  }
  static test(e) {
    return e instanceof ks;
  }
}
IS.extension = Ie.MaskEffect;
class AS {
  constructor(e) {
    this.priority = 0, this.pipe = "colorMask", e != null && e.mask && this.init(e.mask);
  }
  init(e) {
    this.mask = e;
  }
  destroy() {
  }
  static test(e) {
    return typeof e == "number";
  }
}
AS.extension = Ie.MaskEffect;
class PS {
  constructor(e) {
    this.priority = 0, this.pipe = "stencilMask", e != null && e.mask && this.init(e.mask);
  }
  init(e) {
    this.mask = e, this.mask.includeInBuild = !1, this.mask.measurable = !1;
  }
  reset() {
    this.mask !== null && (this.mask.measurable = !0, this.mask.includeInBuild = !0, this.mask = null);
  }
  addBounds(e, t) {
    MS(this.mask, e, t);
  }
  addLocalBounds(e, t) {
    TS(this.mask, e, t);
  }
  containsPoint(e, t) {
    const n = this.mask;
    return t(n, e);
  }
  destroy() {
    this.reset();
  }
  static test(e) {
    return e instanceof mn;
  }
}
PS.extension = Ie.MaskEffect;
const sY = {
  createCanvas: (i, e) => {
    const t = document.createElement("canvas");
    return t.width = i, t.height = e, t;
  },
  createImage: () => new Image(),
  getCanvasRenderingContext2D: () => CanvasRenderingContext2D,
  getWebGLRenderingContext: () => WebGLRenderingContext,
  getNavigator: () => navigator,
  getBaseUrl: () => {
    var i;
    return (i = document.baseURI) != null ? i : window.location.href;
  },
  getFontFaceSet: () => document.fonts,
  fetch: (i, e) => fetch(i, e),
  parseXML: (i) => new DOMParser().parseFromString(i, "text/xml")
};
let Sk = sY;
const zt = {
  /**
   * Returns the current adapter.
   * @returns {environment.Adapter} The current adapter.
   */
  get() {
    return Sk;
  },
  /**
   * Sets the current adapter.
   * @param adapter - The new adapter.
   */
  set(i) {
    Sk = i;
  }
};
class Ai extends un {
  constructor(e) {
    e.resource || (e.resource = zt.get().createCanvas()), e.width || (e.width = e.resource.width, e.autoDensity || (e.width /= e.resolution)), e.height || (e.height = e.resource.height, e.autoDensity || (e.height /= e.resolution)), super(e), this.uploadMethodId = "image", this.autoDensity = e.autoDensity, this.resizeCanvas(), this.transparent = !!e.transparent;
  }
  resizeCanvas() {
    this.autoDensity && "style" in this.resource && (this.resource.style.width = `${this.width}px`, this.resource.style.height = `${this.height}px`), (this.resource.width !== this.pixelWidth || this.resource.height !== this.pixelHeight) && (this.resource.width = this.pixelWidth, this.resource.height = this.pixelHeight);
  }
  resize(e = this.width, t = this.height, n = this._resolution) {
    const s = super.resize(e, t, n);
    return s && this.resizeCanvas(), s;
  }
  static test(e) {
    return globalThis.HTMLCanvasElement && e instanceof HTMLCanvasElement || globalThis.OffscreenCanvas && e instanceof OffscreenCanvas;
  }
  /**
   * Returns the 2D rendering context for the canvas.
   * Caches the context after creating it.
   * @returns The 2D rendering context of the canvas.
   */
  get context2D() {
    return this._context2D || (this._context2D = this.resource.getContext("2d"));
  }
}
Ai.extension = Ie.TextureSource;
class Gc extends un {
  constructor(e) {
    super(e), this.uploadMethodId = "image", this.autoGarbageCollect = !0;
  }
  static test(e) {
    return globalThis.HTMLImageElement && e instanceof HTMLImageElement || typeof ImageBitmap != "undefined" && e instanceof ImageBitmap || globalThis.VideoFrame && e instanceof VideoFrame;
  }
}
Gc.extension = Ie.TextureSource;
var Ol = /* @__PURE__ */ ((i) => (i[i.INTERACTION = 50] = "INTERACTION", i[i.HIGH = 25] = "HIGH", i[i.NORMAL = 0] = "NORMAL", i[i.LOW = -25] = "LOW", i[i.UTILITY = -50] = "UTILITY", i))(Ol || {});
class Mg {
  /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */
  constructor(e, t = null, n = 0, s = !1) {
    this.next = null, this.previous = null, this._destroyed = !1, this._fn = e, this._context = t, this.priority = n, this._once = s;
  }
  /**
   * Simple compare function to figure out if a function and context match.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */
  match(e, t = null) {
    return this._fn === e && this._context === t;
  }
  /**
   * Emit by calling the current function.
   * @param ticker - The ticker emitting.
   * @returns Next ticker
   */
  emit(e) {
    this._fn && (this._context ? this._fn.call(this._context, e) : this._fn(e));
    const t = this.next;
    return this._once && this.destroy(!0), this._destroyed && (this.next = null), t;
  }
  /**
   * Connect to the list.
   * @param previous - Input node, previous listener
   */
  connect(e) {
    this.previous = e, e.next && (e.next.previous = this), this.next = e.next, e.next = this;
  }
  /**
   * Destroy and don't use after this.
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */
  destroy(e = !1) {
    this._destroyed = !0, this._fn = null, this._context = null, this.previous && (this.previous.next = this.next), this.next && (this.next.previous = this.previous);
    const t = this.next;
    return this.next = e ? null : t, this.previous = null, t;
  }
}
const ES = class xi {
  constructor() {
    this.autoStart = !1, this.deltaTime = 1, this.lastTime = -1, this.speed = 1, this.started = !1, this._requestId = null, this._maxElapsedMS = 100, this._minElapsedMS = 0, this._protected = !1, this._lastFrame = -1, this._head = new Mg(null, null, 1 / 0), this.deltaMS = 1 / xi.targetFPMS, this.elapsedMS = 1 / xi.targetFPMS, this._tick = (e) => {
      this._requestId = null, this.started && (this.update(e), this.started && this._requestId === null && this._head.next && (this._requestId = requestAnimationFrame(this._tick)));
    };
  }
  /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   */
  _requestIfNeeded() {
    this._requestId === null && this._head.next && (this.lastTime = performance.now(), this._lastFrame = this.lastTime, this._requestId = requestAnimationFrame(this._tick));
  }
  /** Conditionally cancels a pending animation frame. */
  _cancelIfNeeded() {
    this._requestId !== null && (cancelAnimationFrame(this._requestId), this._requestId = null);
  }
  /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   */
  _startIfPossible() {
    this.started ? this._requestIfNeeded() : this.autoStart && this.start();
  }
  /**
   * Register a handler for tick events.
   * @param fn - The listener function to add. Receives the Ticker instance as parameter
   * @param context - The context for the listener
   * @param priority - The priority of the listener
   * @example
   * ```ts
   * // Access time properties through the ticker parameter
   * ticker.add((ticker) => {
   *     // Use deltaTime (dimensionless scalar) for frame-independent animations
   *     sprite.rotation += 0.1 * ticker.deltaTime;
   *
   *     // Use deltaMS (milliseconds) for time-based calculations
   *     const progress = ticker.deltaMS / animationDuration;
   *
   *     // Use elapsedMS for raw timing measurements
   *     console.log(`Raw frame time: ${ticker.elapsedMS}ms`);
   * });
   * ```
   */
  add(e, t, n = Ol.NORMAL) {
    return this._addListener(new Mg(e, t, n));
  }
  /**
   * Add a handler for the tick event which is only executed once on the next frame.
   * @example
   * ```ts
   * // Basic one-time update
   * ticker.addOnce(() => {
   *     console.log('Runs next frame only');
   * });
   *
   * // With specific context
   * const game = {
   *     init(ticker) {
   *         this.loadResources();
   *         console.log('Game initialized');
   *     }
   * };
   * ticker.addOnce(game.init, game);
   *
   * // With priority
   * ticker.addOnce(
   *     () => {
   *         // High priority one-time setup
   *         physics.init();
   *     },
   *     undefined,
   *     UPDATE_PRIORITY.HIGH
   * );
   * ```
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting (default: UPDATE_PRIORITY.NORMAL)
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For continuous updates
   * @see {@link Ticker#remove} For removing handlers
   */
  addOnce(e, t, n = Ol.NORMAL) {
    return this._addListener(new Mg(e, t, n, !0));
  }
  /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */
  _addListener(e) {
    let t = this._head.next, n = this._head;
    if (!t)
      e.connect(n);
    else {
      for (; t; ) {
        if (e.priority > t.priority) {
          e.connect(n);
          break;
        }
        n = t, t = t.next;
      }
      e.previous || e.connect(n);
    }
    return this._startIfPossible(), this;
  }
  /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @example
   * ```ts
   * // Basic removal
   * const onTick = () => {
   *     sprite.rotation += 0.1;
   * };
   * ticker.add(onTick);
   * ticker.remove(onTick);
   *
   * // Remove with context
   * const game = {
   *     update(ticker) {
   *         this.physics.update(ticker.deltaTime);
   *     }
   * };
   * ticker.add(game.update, game);
   * ticker.remove(game.update, game);
   *
   * // Remove all matching handlers
   * // (if same function was added multiple times)
   * ticker.add(onTick);
   * ticker.add(onTick);
   * ticker.remove(onTick); // Removes all instances
   * ```
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For adding handlers
   * @see {@link Ticker#addOnce} For one-time handlers
   */
  remove(e, t) {
    let n = this._head.next;
    for (; n; )
      n.match(e, t) ? n = n.destroy() : n = n.next;
    return this._head.next || this._cancelIfNeeded(), this;
  }
  /**
   * The number of listeners on this ticker, calculated by walking through linked list.
   * @example
   * ```ts
   * // Check number of active listeners
   * const ticker = new Ticker();
   * console.log(ticker.count); // 0
   *
   * // Add some listeners
   * ticker.add(() => {});
   * ticker.add(() => {});
   * console.log(ticker.count); // 2
   *
   * // Check after cleanup
   * ticker.destroy();
   * console.log(ticker.count); // 0
   * ```
   * @readonly
   * @see {@link Ticker#add} For adding listeners
   * @see {@link Ticker#remove} For removing listeners
   */
  get count() {
    if (!this._head)
      return 0;
    let e = 0, t = this._head;
    for (; t = t.next; )
      e++;
    return e;
  }
  /**
   * Starts the ticker. If the ticker has listeners a new animation frame is requested at this point.
   * @example
   * ```ts
   * // Basic manual start
   * const ticker = new Ticker();
   * ticker.add(() => {
   *     // Animation code here
   * });
   * ticker.start();
   * ```
   * @see {@link Ticker#stop} For stopping the ticker
   * @see {@link Ticker#autoStart} For automatic starting
   * @see {@link Ticker#started} For checking ticker state
   */
  start() {
    this.started || (this.started = !0, this._requestIfNeeded());
  }
  /**
   * Stops the ticker. If the ticker has requested an animation frame it is canceled at this point.
   * @example
   * ```ts
   * // Basic stop
   * const ticker = new Ticker();
   * ticker.stop();
   * ```
   * @see {@link Ticker#start} For starting the ticker
   * @see {@link Ticker#started} For checking ticker state
   * @see {@link Ticker#destroy} For cleaning up the ticker
   */
  stop() {
    this.started && (this.started = !1, this._cancelIfNeeded());
  }
  /**
   * Destroy the ticker and don't use after this. Calling this method removes all references to internal events.
   * @example
   * ```ts
   * // Clean up with active listeners
   * const ticker = new Ticker();
   * ticker.add(() => {});
   * ticker.destroy(); // Removes all listeners
   * ```
   * @see {@link Ticker#stop} For stopping without destroying
   * @see {@link Ticker#remove} For removing specific listeners
   */
  destroy() {
    if (!this._protected) {
      this.stop();
      let e = this._head.next;
      for (; e; )
        e = e.destroy(!0);
      this._head.destroy(), this._head = null;
    }
  }
  /**
   * Triggers an update.
   *
   * An update entails setting the
   * current {@link Ticker#elapsedMS|elapsedMS},
   * the current {@link Ticker#deltaTime|deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link Ticker#lastTime|lastTime}
   * with the value of currentTime that was provided.
   *
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @example
   * ```ts
   * // Basic manual update
   * const ticker = new Ticker();
   * ticker.update(performance.now());
   * ```
   * @param currentTime - The current time of execution (defaults to performance.now())
   * @see {@link Ticker#deltaTime} For frame delta value
   * @see {@link Ticker#elapsedMS} For raw elapsed time
   */
  update(e = performance.now()) {
    let t;
    if (e > this.lastTime) {
      if (t = this.elapsedMS = e - this.lastTime, t > this._maxElapsedMS && (t = this._maxElapsedMS), t *= this.speed, this._minElapsedMS) {
        const o = e - this._lastFrame | 0;
        if (o < this._minElapsedMS)
          return;
        this._lastFrame = e - o % this._minElapsedMS;
      }
      this.deltaMS = t, this.deltaTime = this.deltaMS * xi.targetFPMS;
      const n = this._head;
      let s = n.next;
      for (; s; )
        s = s.emit(this);
      n.next || this._cancelIfNeeded();
    } else
      this.deltaTime = this.deltaMS = this.elapsedMS = 0;
    this.lastTime = e;
  }
  /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * > [!NOTE] This does not factor in the value of
   * > {@link Ticker#speed|speed}, which is specific
   * > to scaling {@link Ticker#deltaTime|deltaTime}.
   * @example
   * ```ts
   * // Basic FPS monitoring
   * ticker.add(() => {
   *     console.log(`Current FPS: ${Math.round(ticker.FPS)}`);
   * });
   * ```
   * @readonly
   */
  get FPS() {
    return 1e3 / this.elapsedMS;
  }
  /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This value is used to cap {@link Ticker#deltaTime|deltaTime},
   * but does not effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000` (typically 60).
   *
   * If `maxFPS` is currently set (non-zero) and `minFPS` is set above it,
   * `maxFPS` is automatically raised to match. This keeps the two limits consistent.
   * @example
   * ```ts
   * // Set minimum acceptable frame rate
   * const ticker = new Ticker();
   * ticker.minFPS = 30; // Never go below 30 FPS
   *
   * // Use with maxFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // minFPS above maxFPS pushes maxFPS up
   * ticker.minFPS = 50; // maxFPS is raised to 50
   * ```
   * @default 10
   */
  get minFPS() {
    return 1e3 / this._maxElapsedMS;
  }
  set minFPS(e) {
    const t = Math.min(Math.max(0, e) / 1e3, xi.targetFPMS);
    this._maxElapsedMS = 1 / t, this._minElapsedMS && e > this.maxFPS && (this.maxFPS = e);
  }
  /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This will effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`.
   *
   * If `maxFPS` is set below the current `minFPS`, `minFPS` is automatically lowered to match.
   * This keeps the two limits consistent.
   * @example
   * ```ts
   * // Cap the frame rate
   * const ticker = new Ticker();
   * ticker.maxFPS = 60; // Never go above 60 FPS
   *
   * // Use with minFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // maxFPS below minFPS pushes minFPS down
   * ticker.maxFPS = 20; // minFPS is now also 20
   * ```
   * @default 0
   */
  get maxFPS() {
    return this._minElapsedMS ? Math.round(1e3 / this._minElapsedMS) : 0;
  }
  set maxFPS(e) {
    e === 0 ? this._minElapsedMS = 0 : (e < this.minFPS && (this.minFPS = e), this._minElapsedMS = 1 / (e / 1e3));
  }
  /**
   * The shared ticker instance used by {@link AnimatedSprite} and by
   * {@link VideoSource} to update animation frames / video textures.
   *
   * It may also be used by {@link Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @type {Ticker}
   * @readonly
   */
  static get shared() {
    if (!xi._shared) {
      const e = xi._shared = new xi();
      e.autoStart = !0, e._protected = !0;
    }
    return xi._shared;
  }
  /**
   * The system ticker instance used by {@link PrepareBase} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * @type {Ticker}
   * @readonly
   * @advanced
   */
  static get system() {
    if (!xi._system) {
      const e = xi._system = new xi();
      e.autoStart = !0, e._protected = !0;
    }
    return xi._system;
  }
};
ES.targetFPMS = 0.06;
let Oi = ES, ud;
async function oY() {
  return ud != null || (ud = (async () => {
    var r;
    const e = zt.get().createCanvas(1, 1).getContext("webgl");
    if (!e)
      return "premultiply-alpha-on-upload";
    const t = await new Promise((a) => {
      const l = document.createElement("video");
      l.onloadeddata = () => a(l), l.onerror = () => a(null), l.autoplay = !1, l.crossOrigin = "anonymous", l.preload = "auto", l.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=", l.load();
    });
    if (!t)
      return "premultiply-alpha-on-upload";
    const n = e.createTexture();
    e.bindTexture(e.TEXTURE_2D, n);
    const s = e.createFramebuffer();
    e.bindFramebuffer(e.FRAMEBUFFER, s), e.framebufferTexture2D(
      e.FRAMEBUFFER,
      e.COLOR_ATTACHMENT0,
      e.TEXTURE_2D,
      n,
      0
    ), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, e.NONE), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, t);
    const o = new Uint8Array(4);
    return e.readPixels(0, 0, 1, 1, e.RGBA, e.UNSIGNED_BYTE, o), e.deleteFramebuffer(s), e.deleteTexture(n), (r = e.getExtension("WEBGL_lose_context")) == null || r.loseContext(), o[0] <= o[3] ? "premultiplied-alpha" : "premultiply-alpha-on-upload";
  })()), ud;
}
const pm = class RS extends un {
  constructor(e) {
    var t;
    super(e), this.isReady = !1, this.uploadMethodId = "video", e = {
      ...RS.defaultOptions,
      ...e
    }, this._autoUpdate = !0, this._isConnectedToTicker = !1, this._updateFPS = e.updateFPS || 0, this._msToNextUpdate = 0, this.autoPlay = e.autoPlay !== !1, this.alphaMode = (t = e.alphaMode) != null ? t : "premultiply-alpha-on-upload", this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this), this._videoFrameRequestCallbackHandle = null, this._load = null, this._resolve = null, this._reject = null, this._onCanPlay = this._onCanPlay.bind(this), this._onCanPlayThrough = this._onCanPlayThrough.bind(this), this._onError = this._onError.bind(this), this._onPlayStart = this._onPlayStart.bind(this), this._onPlayStop = this._onPlayStop.bind(this), this._onSeeked = this._onSeeked.bind(this), this._onLoadedMetadata = this._onLoadedMetadata.bind(this), e.autoLoad !== !1 && this.load();
  }
  /** Update the video frame if the source is not destroyed and meets certain conditions. */
  updateFrame() {
    if (!this.destroyed) {
      if (this._updateFPS) {
        const e = Oi.shared.elapsedMS * this.resource.playbackRate;
        this._msToNextUpdate = Math.floor(this._msToNextUpdate - e);
      }
      (!this._updateFPS || this._msToNextUpdate <= 0) && (this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0), this.isValid && this.update();
    }
  }
  /** Callback to update the video frame and potentially request the next frame update. */
  _videoFrameRequestCallback() {
    this.updateFrame(), this.destroyed ? this._videoFrameRequestCallbackHandle = null : this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(
      this._videoFrameRequestCallback
    );
  }
  /**
   * Checks if the resource has valid dimensions.
   * @returns {boolean} True if width and height are set, otherwise false.
   */
  get isValid() {
    return !!this.resource.videoWidth && !!this.resource.videoHeight;
  }
  /**
   * Start preloading the video resource.
   * @returns {Promise<this>} Handle the validate event
   */
  async load() {
    if (this._load)
      return this._load;
    const e = this.resource, t = this.options;
    return (e.readyState === e.HAVE_ENOUGH_DATA || e.readyState === e.HAVE_FUTURE_DATA) && e.width && e.height && (e.complete = !0), e.addEventListener("play", this._onPlayStart), e.addEventListener("pause", this._onPlayStop), e.addEventListener("seeked", this._onSeeked), this._isSourceReady() ? this._mediaReady() : (t.preload || e.addEventListener("canplay", this._onCanPlay), e.addEventListener("canplaythrough", this._onCanPlayThrough), e.addEventListener("error", this._onError, !0)), this.isValid || e.addEventListener("loadedmetadata", this._onLoadedMetadata), this.alphaMode = await oY(), this._load = new Promise((n, s) => {
      this.isValid ? n(this) : (this._resolve = n, this._reject = s, t.preloadTimeoutMs !== void 0 && (this._preloadTimeout = setTimeout(() => {
        this._onError(new ErrorEvent(`Preload exceeded timeout of ${t.preloadTimeoutMs}ms`));
      })), e.load());
    }), this._load;
  }
  /**
   * Handle video error events.
   * @param event - The error event
   */
  _onError(e) {
    this.resource.removeEventListener("error", this._onError, !0), this.emit("error", e), this._reject && (this._reject(e), this._reject = null, this._resolve = null);
  }
  /**
   * Checks if the underlying source is playing.
   * @returns True if playing.
   */
  _isSourcePlaying() {
    const e = this.resource;
    return !e.paused && !e.ended;
  }
  /**
   * Checks if the underlying source is ready for playing.
   * @returns True if ready.
   */
  _isSourceReady() {
    return this.resource.readyState > 2;
  }
  /** Runs the update loop when the video is ready to play. */
  _onPlayStart() {
    this._configureAutoUpdate();
  }
  /** Stops the update loop when a pause event is triggered. */
  _onPlayStop() {
    this._configureAutoUpdate();
  }
  /** Handles behavior when the video completes seeking to the current playback position. */
  _onSeeked() {
    this._autoUpdate && !this._isSourcePlaying() && (this._msToNextUpdate = 0, this.updateFrame(), this._msToNextUpdate = 0);
  }
  /** When intrinsic size becomes known after play / canplay (common with MediaStream). */
  _onLoadedMetadata() {
    this.isValid && this._mediaReady();
  }
  _onCanPlay() {
    this.resource.removeEventListener("canplay", this._onCanPlay), this._mediaReady();
  }
  _onCanPlayThrough() {
    this.resource.removeEventListener("canplaythrough", this._onCanPlayThrough), this._preloadTimeout && (clearTimeout(this._preloadTimeout), this._preloadTimeout = void 0), this._mediaReady();
  }
  /** Fired when the video is loaded and ready to play. */
  _mediaReady() {
    const e = this.resource;
    this.isValid && (this.isReady = !0, this.resize(e.videoWidth, e.videoHeight)), this._msToNextUpdate = 0, this.updateFrame(), this._msToNextUpdate = 0, this._resolve && this.isValid && (this._resolve(this), this._resolve = null, this._reject = null), this._isSourcePlaying() ? this._onPlayStart() : this.autoPlay && this.resource.play();
  }
  /** Cleans up resources and event listeners associated with this texture. */
  destroy() {
    this._configureAutoUpdate();
    const e = this.resource;
    e && (e.removeEventListener("play", this._onPlayStart), e.removeEventListener("pause", this._onPlayStop), e.removeEventListener("seeked", this._onSeeked), e.removeEventListener("canplay", this._onCanPlay), e.removeEventListener("canplaythrough", this._onCanPlayThrough), e.removeEventListener("loadedmetadata", this._onLoadedMetadata), e.removeEventListener("error", this._onError, !0), e.pause(), e.src = "", e.load()), super.destroy();
  }
  /** Should the base texture automatically update itself, set to true by default. */
  get autoUpdate() {
    return this._autoUpdate;
  }
  set autoUpdate(e) {
    e !== this._autoUpdate && (this._autoUpdate = e, this._configureAutoUpdate());
  }
  /**
   * How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */
  get updateFPS() {
    return this._updateFPS;
  }
  set updateFPS(e) {
    e !== this._updateFPS && (this._updateFPS = e, this._configureAutoUpdate());
  }
  /**
   * Configures the updating mechanism based on the current state and settings.
   *
   * This method decides between using the browser's native video frame callback or a custom ticker
   * for updating the video frame. It ensures optimal performance and responsiveness
   * based on the video's state, playback status, and the desired frames-per-second setting.
   *
   * - If `_autoUpdate` is enabled and the video source is playing:
   *   - It will prefer the native video frame callback if available and no specific FPS is set.
   *   - Otherwise, it will use a custom ticker for manual updates.
   * - If `_autoUpdate` is disabled or the video isn't playing, any active update mechanisms are halted.
   */
  _configureAutoUpdate() {
    this._autoUpdate && this._isSourcePlaying() ? !this._updateFPS && this.resource.requestVideoFrameCallback ? (this._isConnectedToTicker && (Oi.shared.remove(this.updateFrame, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0), this._videoFrameRequestCallbackHandle === null && (this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(
      this._videoFrameRequestCallback
    ))) : (this._videoFrameRequestCallbackHandle !== null && (this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker || (Oi.shared.add(this.updateFrame, this), this._isConnectedToTicker = !0, this._msToNextUpdate = 0)) : (this._videoFrameRequestCallbackHandle !== null && (this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker && (Oi.shared.remove(this.updateFrame, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0));
  }
  static test(e) {
    return globalThis.HTMLVideoElement && e instanceof HTMLVideoElement;
  }
};
pm.extension = Ie.TextureSource;
pm.defaultOptions = {
  ...un.defaultOptions,
  /** If true, the video will start loading immediately. */
  autoLoad: !0,
  /** If true, the video will start playing as soon as it is loaded. */
  autoPlay: !0,
  /** The number of times a second to update the texture from the video. Leave at 0 to update at every render. */
  updateFPS: 0,
  /** If true, the video will be loaded with the `crossorigin` attribute. */
  crossorigin: !0,
  /** If true, the video will loop when it ends. */
  loop: !1,
  /** If true, the video will be muted. */
  muted: !0,
  /** If true, the video will play inline. */
  playsinline: !0,
  /** If true, the video will be preloaded. */
  preload: !1
};
pm.MIME_TYPES = {
  ogv: "video/ogg",
  mov: "video/quicktime",
  m4v: "video/mp4"
};
let rY = pm;
const Za = (i, e, t = !1) => (Array.isArray(i) || (i = [i]), e ? i.map((n) => typeof n == "string" || t ? e(n) : n) : i);
class aY {
  constructor() {
    this._parsers = [], this._cache = /* @__PURE__ */ new Map(), this._cacheMap = /* @__PURE__ */ new Map();
  }
  /** Clear all entries. */
  reset() {
    this._cacheMap.clear(), this._cache.clear();
  }
  /**
   * Check if the key exists
   * @param key - The key to check
   */
  has(e) {
    return this._cache.has(e);
  }
  /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */
  get(e) {
    const t = this._cache.get(e);
    return t || dt(`[Assets] Asset id ${e} was not found in the Cache`), t;
  }
  /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */
  set(e, t) {
    const n = Za(e);
    let s;
    for (let l = 0; l < this.parsers.length; l++) {
      const d = this.parsers[l];
      if (d.test(t)) {
        s = d.getCacheableAssets(n, t);
        break;
      }
    }
    const o = new Map(Object.entries(s || {}));
    s || n.forEach((l) => {
      o.set(l, t);
    });
    const r = [...o.keys()], a = {
      cacheKeys: r,
      keys: n
    };
    n.forEach((l) => {
      this._cacheMap.set(l, a);
    }), r.forEach((l) => {
      const d = s ? s[l] : t;
      this._cache.has(l) && this._cache.get(l) !== d && dt("[Cache] already has key:", l), this._cache.set(l, o.get(l));
    });
  }
  /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */
  remove(e) {
    if (!this._cacheMap.has(e)) {
      dt(`[Assets] Asset id ${e} was not found in the Cache`);
      return;
    }
    const t = this._cacheMap.get(e);
    t.cacheKeys.forEach((s) => {
      this._cache.delete(s);
    }), t.keys.forEach((s) => {
      this._cacheMap.delete(s);
    });
  }
  /**
   * All loader parsers registered
   * @advanced
   */
  get parsers() {
    return this._parsers;
  }
}
const Qa = new aY(), Hv = [];
ht.handleByList(Ie.TextureSource, Hv);
function zS(i = {}) {
  const e = i && i.resource, t = e ? i.resource : i, n = e ? i : { resource: i };
  for (let s = 0; s < Hv.length; s++) {
    const o = Hv[s];
    if (o.test(t))
      return new o(n);
  }
  throw new Error(`Could not find a source type for resource: ${n.resource}`);
}
function lY(i = {}, e = !1) {
  const t = i && i.resource, n = t ? i.resource : i, s = t ? i : { resource: i };
  if (!e && Qa.has(n))
    return Qa.get(n);
  const o = new et({ source: zS(s) });
  return o.on("destroy", () => {
    Qa.has(n) && Qa.remove(n);
  }), e || Qa.set(n, o), o;
}
function dY(i, e = !1) {
  return typeof i == "string" ? Qa.get(i) : i instanceof un ? new et({ source: i }) : lY(i, e);
}
et.from = dY;
un.from = zS;
ht.add(
  IS,
  AS,
  PS,
  rY,
  Gc,
  Ai,
  W1
);
var $S = /* @__PURE__ */ ((i) => (i[i.Low = 0] = "Low", i[i.Normal = 1] = "Normal", i[i.High = 2] = "High", i))($S || {});
function Gi(i) {
  if (typeof i != "string")
    throw new TypeError(`Path must be a string. Received ${JSON.stringify(i)}`);
}
function hd(i) {
  return i.split("?")[0].split("#")[0];
}
function cY(i) {
  return i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function uY(i, e, t) {
  return i.replace(new RegExp(cY(e), "g"), t);
}
function hY(i, e) {
  let t = "", n = 0, s = -1, o = 0, r = -1;
  for (let a = 0; a <= i.length; ++a) {
    if (a < i.length)
      r = i.charCodeAt(a);
    else {
      if (r === 47)
        break;
      r = 47;
    }
    if (r === 47) {
      if (!(s === a - 1 || o === 1)) if (s !== a - 1 && o === 2) {
        if (t.length < 2 || n !== 2 || t.charCodeAt(t.length - 1) !== 46 || t.charCodeAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            const l = t.lastIndexOf("/");
            if (l !== t.length - 1) {
              l === -1 ? (t = "", n = 0) : (t = t.slice(0, l), n = t.length - 1 - t.lastIndexOf("/")), s = a, o = 0;
              continue;
            }
          } else if (t.length === 2 || t.length === 1) {
            t = "", n = 0, s = a, o = 0;
            continue;
          }
        }
      } else
        t.length > 0 ? t += `/${i.slice(s + 1, a)}` : t = i.slice(s + 1, a), n = a - s - 1;
      s = a, o = 0;
    } else r === 46 && o !== -1 ? ++o : o = -1;
  }
  return t;
}
const jc = {
  /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   * @example
   * ```ts
   * // Convert a Windows path to POSIX format
   * path.toPosix('C:\\Users\\User\\Documents\\file.txt');
   * // -> 'C:/Users/User/Documents/file.txt'
   * ```
   */
  toPosix(i) {
    return uY(i, "\\", "/");
  },
  /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a URL
   * path.isUrl('http://www.example.com');
   * // -> true
   * path.isUrl('C:/Users/User/Documents/file.txt');
   * // -> false
   * ```
   */
  isUrl(i) {
    return /^https?:/.test(this.toPosix(i));
  },
  /**
   * Checks if the path is a data URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a data URL
   * path.isDataUrl('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA...');
   * // -> true
   * ```
   */
  isDataUrl(i) {
    return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(i);
  },
  /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a blob URL
   * path.isBlobUrl('blob:http://www.example.com/12345678-1234-1234-1234-123456789012');
   * // -> true
   * ```
   */
  isBlobUrl(i) {
    return i.startsWith("blob:");
  },
  /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path has a protocol
   * path.hasProtocol('http://www.example.com');
   * // -> true
   * path.hasProtocol('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */
  hasProtocol(i) {
    return /^[^/:]+:/.test(this.toPosix(i));
  },
  /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   * @example
   * ```ts
   * // Get the protocol from a URL
   * path.getProtocol('http://www.example.com/path/to/resource');
   * // -> 'http://'
   * // Get the protocol from a file path
   * path.getProtocol('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */
  getProtocol(i) {
    Gi(i), i = this.toPosix(i);
    const e = /^file:\/\/\//.exec(i);
    if (e)
      return e[0];
    const t = /^[^/:]+:\/{0,2}/.exec(i);
    return t ? t[0] : "";
  },
  /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   * @example
   * ```ts
   * // Convert a relative URL to an absolute path
   * path.toAbsolute('images/texture.png', 'http://example.com/assets/');
   * // -> 'http://example.com/assets/images/texture.png'
   * ```
   */
  toAbsolute(i, e, t) {
    if (Gi(i), this.isDataUrl(i) || this.isBlobUrl(i)) return i;
    const n = hd(this.toPosix(e != null ? e : zt.get().getBaseUrl())), s = hd(this.toPosix(t != null ? t : this.rootname(n)));
    return i = this.toPosix(i), i.startsWith("/") ? jc.join(s, i.slice(1)) : this.isAbsolute(i) ? i : this.join(n, i);
  },
  /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   * @example
   * ```ts
   * // Normalize a path with relative segments
   * path.normalize('http://www.example.com/foo/bar/../baz');
   * // -> 'http://www.example.com/foo/baz'
   * // Normalize a file path with relative segments
   * path.normalize('C:\\Users\\User\\Documents\\..\\file.txt');
   * // -> 'C:/Users/User/file.txt'
   * ```
   */
  normalize(i) {
    if (Gi(i), i.length === 0) return ".";
    if (this.isDataUrl(i) || this.isBlobUrl(i)) return i;
    i = this.toPosix(i);
    let e = "";
    const t = i.startsWith("/");
    this.hasProtocol(i) && (e = this.rootname(i), i = i.slice(e.length));
    const n = i.endsWith("/");
    return i = hY(i), i.length > 0 && n && (i += "/"), t ? `/${i}` : e + i;
  },
  /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   * @example
   * ```ts
   * // Check if a path is absolute
   * path.isAbsolute('http://www.example.com/foo/bar');
   * // -> true
   * path.isAbsolute('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */
  isAbsolute(i) {
    return Gi(i), i = this.toPosix(i), this.hasProtocol(i) ? !0 : i.startsWith("/");
  },
  /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   * @example
   * ```ts
   * // Join multiple path segments
   * path.join('assets', 'images', 'sprite.png');
   * // -> 'assets/images/sprite.png'
   * // Join with relative segments
   * path.join('assets', 'images', '../textures', 'sprite.png');
   * // -> 'assets/textures/sprite.png'
   * ```
   */
  join(...i) {
    var t;
    if (i.length === 0)
      return ".";
    let e;
    for (let n = 0; n < i.length; ++n) {
      const s = i[n];
      if (Gi(s), s.length > 0)
        if (e === void 0) e = s;
        else {
          const o = (t = i[n - 1]) != null ? t : "";
          this.joinExtensions.includes(this.extname(o).toLowerCase()) ? e += `/../${s}` : e += `/${s}`;
        }
    }
    return e === void 0 ? "." : this.normalize(e);
  },
  /**
   * Returns the directory name of a path
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the directory name of a path
   * path.dirname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/foo/bar'
   * // Get the directory name of a file path
   * path.dirname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/Users/User/Documents'
   * ```
   */
  dirname(i) {
    if (Gi(i), i.length === 0) return ".";
    i = this.toPosix(i);
    let e = i.charCodeAt(0);
    const t = e === 47;
    let n = -1, s = !0;
    const o = this.getProtocol(i), r = i;
    i = i.slice(o.length);
    for (let a = i.length - 1; a >= 1; --a)
      if (e = i.charCodeAt(a), e === 47) {
        if (!s) {
          n = a;
          break;
        }
      } else
        s = !1;
    return n === -1 ? t ? "/" : this.isUrl(r) ? o + i : o : t && n === 1 ? "//" : o + i.slice(0, n);
  },
  /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the root of a URL
   * path.rootname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/'
   * // Get the root of a file path
   * path.rootname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */
  rootname(i) {
    Gi(i), i = this.toPosix(i);
    let e = "";
    if (i.startsWith("/") ? e = "/" : e = this.getProtocol(i), this.isUrl(i)) {
      const t = i.indexOf("/", e.length);
      t !== -1 ? e = i.slice(0, t) : e = i, e.endsWith("/") || (e += "/");
    }
    return e;
  },
  /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   * @example
   * ```ts
   * // Get the basename of a URL
   * path.basename('http://www.example.com/foo/bar/baz.png');
   * // -> 'baz.png'
   * // Get the basename of a file path
   * path.basename('C:/Users/User/Documents/file.txt');
   * // -> 'file.txt'
   * ```
   */
  basename(i, e) {
    Gi(i), e && Gi(e), i = hd(this.toPosix(i));
    let t = 0, n = -1, s = !0, o;
    if (e !== void 0 && e.length > 0 && e.length <= i.length) {
      if (e.length === i.length && e === i) return "";
      let r = e.length - 1, a = -1;
      for (o = i.length - 1; o >= 0; --o) {
        const l = i.charCodeAt(o);
        if (l === 47) {
          if (!s) {
            t = o + 1;
            break;
          }
        } else
          a === -1 && (s = !1, a = o + 1), r >= 0 && (l === e.charCodeAt(r) ? --r === -1 && (n = o) : (r = -1, n = a));
      }
      return t === n ? n = a : n === -1 && (n = i.length), i.slice(t, n);
    }
    for (o = i.length - 1; o >= 0; --o)
      if (i.charCodeAt(o) === 47) {
        if (!s) {
          t = o + 1;
          break;
        }
      } else n === -1 && (s = !1, n = o + 1);
    return n === -1 ? "" : i.slice(t, n);
  },
  /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the extension of a URL
   * path.extname('http://www.example.com/foo/bar/baz.png');
   * // -> '.png'
   * // Get the extension of a file path
   * path.extname('C:/Users/User/Documents/file.txt');
   * // -> '.txt'
   * ```
   */
  extname(i) {
    Gi(i), i = hd(this.toPosix(i));
    let e = -1, t = 0, n = -1, s = !0, o = 0;
    for (let r = i.length - 1; r >= 0; --r) {
      const a = i.charCodeAt(r);
      if (a === 47) {
        if (!s) {
          t = r + 1;
          break;
        }
        continue;
      }
      n === -1 && (s = !1, n = r + 1), a === 46 ? e === -1 ? e = r : o !== 1 && (o = 1) : e !== -1 && (o = -1);
    }
    return e === -1 || n === -1 || o === 0 || o === 1 && e === n - 1 && e === t + 1 ? "" : i.slice(e, n);
  },
  /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Parse a URL
   * const parsed = path.parse('http://www.example.com/foo/bar/baz.png');
   * // -> {
   * //   root: 'http://www.example.com/',
   * //   dir: 'http://www.example.com/foo/bar',
   * //   base: 'baz.png',
   * //   ext: '.png',
   * //   name: 'baz'
   * // }
   * // Parse a file path
   * const parsedFile = path.parse('C:/Users/User/Documents/file.txt');
   * // -> {
   * //   root: 'C:/',
   * //   dir: 'C:/Users/User/Documents',
   * //   base: 'file.txt',
   * //   ext: '.txt',
   * //   name: 'file'
   * // }
   * ```
   */
  parse(i) {
    Gi(i);
    const e = { root: "", dir: "", base: "", ext: "", name: "" };
    if (i.length === 0) return e;
    i = hd(this.toPosix(i));
    let t = i.charCodeAt(0);
    const n = this.isAbsolute(i);
    let s;
    e.root = this.rootname(i), n || this.hasProtocol(i) ? s = 1 : s = 0;
    let o = -1, r = 0, a = -1, l = !0, d = i.length - 1, c = 0;
    for (; d >= s; --d) {
      if (t = i.charCodeAt(d), t === 47) {
        if (!l) {
          r = d + 1;
          break;
        }
        continue;
      }
      a === -1 && (l = !1, a = d + 1), t === 46 ? o === -1 ? o = d : c !== 1 && (c = 1) : o !== -1 && (c = -1);
    }
    return o === -1 || a === -1 || c === 0 || c === 1 && o === a - 1 && o === r + 1 ? a !== -1 && (r === 0 && n ? e.base = e.name = i.slice(1, a) : e.base = e.name = i.slice(r, a)) : (r === 0 && n ? (e.name = i.slice(1, o), e.base = i.slice(1, a)) : (e.name = i.slice(r, o), e.base = i.slice(r, a)), e.ext = i.slice(o, a)), e.dir = this.dirname(i), e;
  },
  sep: "/",
  delimiter: ":",
  joinExtensions: [".html"]
};
function DS(i, e, t, n, s) {
  const o = e[t];
  for (let r = 0; r < o.length; r++) {
    const a = o[r];
    t < e.length - 1 ? DS(i.replace(n[t], a), e, t + 1, n, s) : s.push(i.replace(n[t], a));
  }
}
function pY(i) {
  const e = /\{(.*?)\}/g, t = i.match(e), n = [];
  if (t) {
    const s = [];
    t.forEach((o) => {
      const r = o.substring(1, o.length - 1).split(",");
      s.push(r);
    }), DS(i, s, 0, t, n);
  } else
    n.push(i);
  return n;
}
const Mk = (i) => !Array.isArray(i);
class OS {
  constructor() {
    this._defaultBundleIdentifierOptions = {
      connector: "-",
      createBundleAssetId: (e, t) => `${e}${this._bundleIdConnector}${t}`,
      extractAssetIdFromBundle: (e, t) => t.replace(`${e}${this._bundleIdConnector}`, "")
    }, this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector, this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId, this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle, this._assetMap = {}, this._preferredOrder = [], this._parsers = [], this._resolverHash = {}, this._bundles = {};
  }
  /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */
  setBundleIdentifier(e) {
    var t, n, s;
    if (this._bundleIdConnector = (t = e.connector) != null ? t : this._bundleIdConnector, this._createBundleAssetId = (n = e.createBundleAssetId) != null ? n : this._createBundleAssetId, this._extractAssetIdFromBundle = (s = e.extractAssetIdFromBundle) != null ? s : this._extractAssetIdFromBundle, this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar")
      throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
  }
  /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */
  prefer(...e) {
    e.forEach((t) => {
      this._preferredOrder.push(t), t.priority || (t.priority = Object.keys(t.params));
    }), this._resolverHash = {};
  }
  /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */
  set basePath(e) {
    this._basePath = e;
  }
  get basePath() {
    return this._basePath;
  }
  /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */
  set rootPath(e) {
    this._rootPath = e;
  }
  get rootPath() {
    return this._rootPath;
  }
  /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */
  get parsers() {
    return this._parsers;
  }
  /** Used for testing, this resets the resolver to its initial state */
  reset() {
    this.setBundleIdentifier(this._defaultBundleIdentifierOptions), this._assetMap = {}, this._preferredOrder = [], this._resolverHash = {}, this._rootPath = null, this._basePath = null, this._manifest = null, this._bundles = {}, this._defaultSearchParams = null;
  }
  /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */
  setDefaultSearchParams(e) {
    if (typeof e == "string")
      this._defaultSearchParams = e;
    else {
      const t = e;
      this._defaultSearchParams = Object.keys(t).map((n) => `${encodeURIComponent(n)}=${encodeURIComponent(t[n])}`).join("&");
    }
  }
  /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */
  getAlias(e) {
    const { alias: t, src: n } = e;
    return Za(
      t || n,
      (o) => typeof o == "string" ? o : Array.isArray(o) ? o.map((r) => {
        var a;
        return (a = r == null ? void 0 : r.src) != null ? a : r;
      }) : o != null && o.src ? o.src : o,
      !0
    );
  }
  /**
   * Removes the specified alias for an asset.
   *
   * This only removes the alias mapping. It does **not** remove, unload, or destroy the
   * underlying asset. If the asset is already cached, it stays in memory until you call
   * `Assets.unload`.
   *
   * If `asset` is provided, the alias is only removed when the resolver's current mapping for
   * that alias matches the given `ResolvedAsset`. This lets you avoid accidentally removing an
   * alias that has been reassigned.
   *
   * Silently returns if the alias does not exist or the asset does not match.
   * @param alias - the alias to remove
   * @param asset - only remove the alias if it is currently assigned to this asset
   * @example
   * ```ts
   * resolver.add({ alias: 'hero', src: 'hero.png' });
   *
   * // Simple removal
   * resolver.removeAlias('hero');
   *
   * // Conditional removal — only if alias currently maps to a specific asset
   * const resolved = resolver.resolve('hero');
   * resolver.removeAlias('hero', resolved);
   * ```
   */
  removeAlias(e, t) {
    this._assetMap[e] && (t && t !== this._resolverHash[e] || (delete this._resolverHash[e], delete this._assetMap[e]));
  }
  /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */
  addManifest(e) {
    this._manifest && dt("[Resolver] Manifest already exists, this will be overwritten"), this._manifest = e, e.bundles.forEach((t) => {
      this.addBundle(t.name, t.assets);
    });
  }
  /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */
  addBundle(e, t) {
    const n = [];
    let s = t;
    Array.isArray(t) || (s = Object.entries(t).map(([o, r]) => typeof r == "string" || Array.isArray(r) ? { alias: o, src: r } : { alias: o, ...r })), s.forEach((o) => {
      const r = o.src, a = o.alias;
      let l;
      if (typeof a == "string") {
        const d = this._createBundleAssetId(e, a);
        n.push(d), l = [a, d];
      } else {
        const d = a.map((c) => this._createBundleAssetId(e, c));
        n.push(...d), l = [...a, ...d];
      }
      this.add({
        ...o,
        alias: l,
        src: r
      });
    }), this._bundles[e] = n;
  }
  /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the UnresolvedAsset or array of UnresolvedAssets to add to the resolver
   */
  add(e) {
    const t = [];
    Array.isArray(e) ? t.push(...e) : t.push(e);
    let n;
    n = (o) => {
      this.hasKey(o) && dt(`[Resolver] already has key: ${o} overwriting`);
    }, Za(t).forEach((o) => {
      const { src: r } = o;
      let {
        data: a,
        format: l,
        loadParser: d,
        parser: c
      } = o;
      const h = Za(r).map((v) => typeof v == "string" ? pY(v) : Array.isArray(v) ? v : [v]), f = this.getAlias(o);
      Array.isArray(f) ? f.forEach(n) : n(f);
      const p = [], y = (v) => {
        const x = this._parsers.find((w) => w.test(v));
        return {
          src: v,
          ...x == null ? void 0 : x.parse(v)
        };
      };
      h.forEach((v) => {
        v.forEach((x) => {
          var S, M, _, T;
          let w = {};
          if (typeof x != "object" ? w = y(x) : (a = (S = x.data) != null ? S : a, l = (M = x.format) != null ? M : l, (x.loadParser || x.parser) && (d = (_ = x.loadParser) != null ? _ : d, c = (T = x.parser) != null ? T : c), w = {
            ...y(x.src),
            ...x
          }), !f)
            throw new Error(`[Resolver] alias is undefined for this asset: ${w.src}`);
          w = this._buildResolvedAsset(w, {
            aliases: f,
            data: a,
            format: l,
            loadParser: d,
            parser: c,
            progressSize: o.progressSize
          }), p.push(w);
        });
      }), f.forEach((v) => {
        this._assetMap[v] = p;
      });
    });
  }
  // TODO: this needs an overload like load did in Assets
  /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */
  resolveBundle(e) {
    const t = Mk(e);
    e = Za(e);
    const n = {};
    return e.forEach((s) => {
      const o = this._bundles[s];
      if (o) {
        const r = this.resolve(o), a = {};
        for (const l in r) {
          const d = r[l];
          a[this._extractAssetIdFromBundle(s, l)] = d;
        }
        n[s] = a;
      }
    }), t ? n[e[0]] : n;
  }
  /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */
  resolveUrl(e) {
    const t = this.resolve(e);
    if (typeof e != "string") {
      const n = {};
      for (const s in t)
        n[s] = t[s].src;
      return n;
    }
    return t.src;
  }
  resolve(e) {
    const t = Mk(e);
    e = Za(e);
    const n = {};
    return e.forEach((s) => {
      if (!this._resolverHash[s])
        if (this._assetMap[s]) {
          let o = this._assetMap[s];
          const r = this._getPreferredOrder(o);
          r == null || r.priority.forEach((a) => {
            r.params[a].forEach((l) => {
              const d = o.filter((c) => c[a] ? c[a] === l : !1);
              d.length && (o = d);
            });
          }), this._resolverHash[s] = o[0];
        } else
          this._resolverHash[s] = this._buildResolvedAsset({
            alias: [s],
            src: s
          }, {});
      n[s] = this._resolverHash[s];
    }), t ? n[e[0]] : n;
  }
  /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */
  hasKey(e) {
    return !!this._assetMap[e];
  }
  /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */
  hasBundle(e) {
    return !!this._bundles[e];
  }
  /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */
  _getPreferredOrder(e) {
    for (let t = 0; t < e.length; t++) {
      const n = e[t], s = this._preferredOrder.find((o) => o.params.format.includes(n.format));
      if (s)
        return s;
    }
    return this._preferredOrder[0];
  }
  /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */
  _appendDefaultSearchParams(e) {
    if (!this._defaultSearchParams) return e;
    const t = /\?/.test(e) ? "&" : "?";
    return `${e}${t}${this._defaultSearchParams}`;
  }
  _buildResolvedAsset(e, t) {
    var d, c;
    const { aliases: n, data: s, loadParser: o, parser: r, format: a, progressSize: l } = t;
    return (this._basePath || this._rootPath) && (e.src = jc.toAbsolute(e.src, this._basePath, this._rootPath)), e.alias = (d = n != null ? n : e.alias) != null ? d : [e.src], e.src = this._appendDefaultSearchParams(e.src), e.data = { ...s || {}, ...e.data }, e.loadParser = o != null ? o : e.loadParser, e.parser = r != null ? r : e.parser, e.format = (c = a != null ? a : e.format) != null ? c : fY(e.src), l !== void 0 && (e.progressSize = l), e;
  }
}
OS.RETINA_PREFIX = /@([0-9\.]+)x/;
function fY(i) {
  return i.split(".").pop().split("?").shift().split("#").shift();
}
const Tk = (i, e) => {
  const t = e.split("?")[1];
  return t && (i += `?${t}`), i;
}, LS = class Kd {
  constructor(e, t) {
    this.linkedSheets = [];
    let n = e;
    (e == null ? void 0 : e.source) instanceof un && (n = {
      texture: e,
      data: t
    });
    const { texture: s, data: o, cachePrefix: r = "" } = n;
    this.cachePrefix = r, this._texture = s instanceof et ? s : null, this.textureSource = s.source, this.textures = {}, this.animations = {}, this.data = o;
    const a = parseFloat(o.meta.scale);
    a ? (this.resolution = a, s.source.resolution = this.resolution) : this.resolution = s.source._resolution, this._frames = this.data.frames, this._frameKeys = Object.keys(this._frames), this._batchIndex = 0, this._callback = null;
  }
  /**
   * Parse spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   */
  parse() {
    return new Promise((e) => {
      this._callback = e, this._batchIndex = 0, this._frameKeys.length <= Kd.BATCH_SIZE ? (this._processFrames(0), this._processAnimations(), this._parseComplete()) : this._nextBatch();
    });
  }
  /**
   * Parse spritesheet from loaded data. This is done synchronously
   * and is only suitable for smaller spritesheets (less than ~1000 frames)
   * or may cause too many Texture within a single process. However, synchronous parsing may be
   * more convenient since the called does not need to be asynchronous and is safe for
   * small-to-medium sized spritesheets.
   *
   * Other than being synchronous, `parseSync` is otherwise identical to `.parse()`.
   */
  parseSync() {
    return this._processFrames(0, !0), this._processAnimations(), this.textures;
  }
  /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   * @param processAll - if true will process all frames in a single batch, ignoring BATCH_SIZE - this
   * is used for synchronous parsing.
   */
  _processFrames(e, t = !1) {
    let n = e;
    const s = t ? 1 / 0 : Kd.BATCH_SIZE;
    for (; n - e < s && n < this._frameKeys.length; ) {
      const o = this._frameKeys[n], r = this._frames[o], a = r.frame;
      if (a) {
        let l = null, d = null;
        const c = r.trimmed !== !1 && r.sourceSize ? r.sourceSize : r.frame, h = new Tt(
          0,
          0,
          Math.floor(c.w) / this.resolution,
          Math.floor(c.h) / this.resolution
        );
        r.rotated ? l = new Tt(
          Math.floor(a.x) / this.resolution,
          Math.floor(a.y) / this.resolution,
          Math.floor(a.h) / this.resolution,
          Math.floor(a.w) / this.resolution
        ) : l = new Tt(
          Math.floor(a.x) / this.resolution,
          Math.floor(a.y) / this.resolution,
          Math.floor(a.w) / this.resolution,
          Math.floor(a.h) / this.resolution
        ), r.trimmed !== !1 && r.spriteSourceSize && (d = new Tt(
          Math.floor(r.spriteSourceSize.x) / this.resolution,
          Math.floor(r.spriteSourceSize.y) / this.resolution,
          Math.floor(a.w) / this.resolution,
          Math.floor(a.h) / this.resolution
        )), this.textures[o] = new et({
          source: this.textureSource,
          frame: l,
          orig: h,
          trim: d,
          rotate: r.rotated ? 2 : 0,
          defaultAnchor: r.anchor,
          defaultBorders: r.borders,
          label: o.toString()
        });
      }
      n++;
    }
  }
  /** Parse animations config. */
  _processAnimations() {
    const e = this.data.animations || {};
    for (const t in e) {
      this.animations[t] = [];
      for (let n = 0; n < e[t].length; n++) {
        const s = e[t][n];
        this.animations[t].push(this.textures[s]);
      }
    }
  }
  /** The parse has completed. */
  _parseComplete() {
    const e = this._callback;
    this._callback = null, this._batchIndex = 0, e.call(this, this.textures);
  }
  /** Begin the next batch of textures. */
  _nextBatch() {
    this._processFrames(this._batchIndex * Kd.BATCH_SIZE), this._batchIndex++, setTimeout(() => {
      this._batchIndex * Kd.BATCH_SIZE < this._frameKeys.length ? this._nextBatch() : (this._processAnimations(), this._parseComplete());
    }, 0);
  }
  /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */
  destroy(e = !1) {
    var t;
    for (const n in this.textures)
      this.textures[n].destroy();
    this._frames = null, this._frameKeys = null, this.data = null, this.textures = null, e && ((t = this._texture) == null || t.destroy(), this.textureSource.destroy()), this._texture = null, this.textureSource = null, this.linkedSheets = [];
  }
};
LS.BATCH_SIZE = 1e3;
let Ck = LS;
const mY = [
  "jpg",
  "png",
  "jpeg",
  "avif",
  "webp",
  "basis",
  "etc2",
  "bc7",
  "bc6h",
  "bc5",
  "bc4",
  "bc3",
  "bc2",
  "bc1",
  "eac",
  "astc"
];
function BS(i, e, t) {
  const n = {};
  if (i.forEach((s) => {
    n[s] = e;
  }), Object.keys(e.textures).forEach((s) => {
    n[`${e.cachePrefix}${s}`] = e.textures[s];
  }), !t) {
    const s = jc.dirname(i[0]);
    e.linkedSheets.forEach((o, r) => {
      const a = BS([`${s}/${e.data.meta.related_multi_packs[r]}`], o, !0);
      Object.assign(n, a);
    });
  }
  return n;
}
const gY = {
  extension: Ie.Asset,
  /** Handle the caching of the related Spritesheet Textures */
  cache: {
    test: (i) => i instanceof Ck,
    getCacheableAssets: (i, e) => BS(i, e, !1)
  },
  /** Resolve the resolution of the asset. */
  resolver: {
    extension: {
      type: Ie.ResolveParser,
      name: "resolveSpritesheet"
    },
    test: (i) => {
      const t = i.split("?")[0].split("."), n = t.pop(), s = t.pop();
      return n === "json" && mY.includes(s);
    },
    parse: (i) => {
      var t, n;
      const e = i.split(".");
      return {
        resolution: parseFloat((n = (t = OS.RETINA_PREFIX.exec(i)) == null ? void 0 : t[1]) != null ? n : "1"),
        format: e[e.length - 2],
        src: i
      };
    }
  },
  /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into Spritesheet
   * All textures in the sprite sheet are then added to the cache
   */
  loader: {
    /** used for deprecation purposes */
    name: "spritesheetLoader",
    id: "spritesheet",
    extension: {
      type: Ie.LoadParser,
      priority: $S.Normal,
      name: "spritesheetLoader"
    },
    async testParse(i, e) {
      return jc.extname(e.src).toLowerCase() === ".json" && !!i.frames;
    },
    async parse(i, e, t) {
      var h, f, p;
      const {
        texture: n,
        // if user need to use preloaded texture
        imageFilename: s,
        // if user need to use custom filename (not from jsonFile.meta.image)
        textureOptions: o,
        // if user need to set texture options on texture
        cachePrefix: r
        // if user need to use custom cache prefix
      } = (h = e == null ? void 0 : e.data) != null ? h : {};
      let a = jc.dirname(e.src);
      a && a.lastIndexOf("/") !== a.length - 1 && (a += "/");
      let l;
      if (n instanceof et)
        l = n;
      else {
        const y = Tk(a + (s != null ? s : i.meta.image), e.src);
        l = (await t.load([{ src: y, data: o }]))[y];
      }
      const d = new Ck({
        texture: l.source,
        data: i,
        cachePrefix: r
      });
      await d.parse();
      const c = (f = i == null ? void 0 : i.meta) == null ? void 0 : f.related_multi_packs;
      if (Array.isArray(c)) {
        const y = [];
        for (const x of c) {
          if (typeof x != "string")
            continue;
          let w = a + x;
          (p = e.data) != null && p.ignoreMultiPack || (w = Tk(w, e.src), y.push(t.load({
            src: w,
            data: {
              textureOptions: o,
              ignoreMultiPack: !0
            }
          })));
        }
        const v = await Promise.all(y);
        d.linkedSheets = v, v.forEach((x) => {
          x.linkedSheets = [d].concat(d.linkedSheets.filter((w) => w !== x));
        });
      }
      return d;
    },
    async unload(i, e, t) {
      await t.unload(i.textureSource._sourceOrigin), i.destroy(!1);
    }
  }
};
ht.add(gY);
class FS {
  constructor(e) {
    this._lastTransform = "", this._observer = null, this._tickerAttached = !1, this.updateTranslation = () => {
      if (!this._canvas) return;
      const t = this._canvas.getBoundingClientRect(), n = this._canvas.width, s = this._canvas.height, o = t.width / n * this._renderer.resolution, r = t.height / s * this._renderer.resolution, a = t.left, l = t.top, d = `translate(${a}px, ${l}px) scale(${o}, ${r})`;
      d !== this._lastTransform && (this._domElement.style.transform = d, this._lastTransform = d);
    }, this._domElement = e.domElement, this._renderer = e.renderer, !(globalThis.OffscreenCanvas && this._renderer.canvas instanceof OffscreenCanvas) && (this._canvas = this._renderer.canvas, this._attachObserver());
  }
  /** The canvas element that this CanvasObserver is associated with. */
  get canvas() {
    return this._canvas;
  }
  /** Attaches the DOM element to the canvas parent if it is not already attached. */
  ensureAttached() {
    !this._domElement.parentNode && this._canvas.parentNode && (this._canvas.parentNode.appendChild(this._domElement), this.updateTranslation());
  }
  /** Sets up a ResizeObserver if available. This ensures that the DOM element is kept in sync with the canvas size . */
  _attachObserver() {
    "ResizeObserver" in globalThis ? (this._observer && (this._observer.disconnect(), this._observer = null), this._observer = new ResizeObserver((e) => {
      for (const t of e) {
        if (t.target !== this._canvas)
          continue;
        const n = this.canvas.width, s = this.canvas.height, o = t.contentRect.width / n * this._renderer.resolution, r = t.contentRect.height / s * this._renderer.resolution;
        (this._lastScaleX !== o || this._lastScaleY !== r) && (this.updateTranslation(), this._lastScaleX = o, this._lastScaleY = r);
      }
    }), this._observer.observe(this._canvas)) : this._tickerAttached || Oi.shared.add(this.updateTranslation, this, Ol.HIGH);
  }
  /** Destroys the CanvasObserver instance, cleaning up observers and Ticker. */
  destroy() {
    this._observer ? (this._observer.disconnect(), this._observer = null) : this._tickerAttached && Oi.shared.remove(this.updateTranslation), this._domElement = null, this._renderer = null, this._canvas = null, this._tickerAttached = !1, this._lastTransform = "", this._lastScaleX = null, this._lastScaleY = null;
  }
}
class xu {
  /**
   * @param manager - The event boundary which manages this event. Propagation can only occur
   *  within the boundary's jurisdiction.
   */
  constructor(e) {
    this.bubbles = !0, this.cancelBubble = !0, this.cancelable = !1, this.composed = !1, this.defaultPrevented = !1, this.eventPhase = xu.prototype.NONE, this.propagationStopped = !1, this.propagationImmediatelyStopped = !1, this.layer = new Wt(), this.page = new Wt(), this.NONE = 0, this.CAPTURING_PHASE = 1, this.AT_TARGET = 2, this.BUBBLING_PHASE = 3, this.manager = e;
  }
  /** @readonly */
  get layerX() {
    return this.layer.x;
  }
  /** @readonly */
  get layerY() {
    return this.layer.y;
  }
  /** @readonly */
  get pageX() {
    return this.page.x;
  }
  /** @readonly */
  get pageY() {
    return this.page.y;
  }
  /**
   * Fallback for the deprecated `InteractionEvent.data`.
   * @deprecated since 7.0.0
   */
  get data() {
    return this;
  }
  /**
   * The propagation path for this event. Alias for {@link EventBoundary.propagationPath}.
   * @advanced
   */
  composedPath() {
    return this.manager && (!this.path || this.path[this.path.length - 1] !== this.target) && (this.path = this.target ? this.manager.propagationPath(this.target) : []), this.path;
  }
  /**
   * Unimplemented method included for implementing the DOM interface `Event`. It will throw an `Error`.
   * @deprecated
   * @ignore
   * @param _type
   * @param _bubbles
   * @param _cancelable
   */
  initEvent(e, t, n) {
    throw new Error("initEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
  }
  /**
   * Unimplemented method included for implementing the DOM interface `UIEvent`. It will throw an `Error`.
   * @ignore
   * @deprecated
   * @param _typeArg
   * @param _bubblesArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   */
  initUIEvent(e, t, n, s, o) {
    throw new Error("initUIEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
  }
  /**
   * Prevent default behavior of both PixiJS and the user agent.
   * @example
   * ```ts
   * sprite.on('click', (event) => {
   *     // Prevent both browser's default click behavior
   *     // and PixiJS's default handling
   *     event.preventDefault();
   *
   *     // Custom handling
   *     customClickHandler();
   * });
   * ```
   * @remarks
   * - Only works if the native event is cancelable
   * - Does not stop event propagation
   */
  preventDefault() {
    this.nativeEvent instanceof Event && this.nativeEvent.cancelable && this.nativeEvent.preventDefault(), this.defaultPrevented = !0;
  }
  /**
   * Stop this event from propagating to any additional listeners, including those
   * on the current target and any following targets in the propagation path.
   * @example
   * ```ts
   * container.on('pointerdown', (event) => {
   *     // Stop all further event handling
   *     event.stopImmediatePropagation();
   *
   *     // These handlers won't be called:
   *     // - Other pointerdown listeners on this container
   *     // - Any pointerdown listeners on parent containers
   * });
   * ```
   * @remarks
   * - Immediately stops all event propagation
   * - Prevents other listeners on same target from being called
   * - More aggressive than stopPropagation()
   */
  stopImmediatePropagation() {
    this.propagationImmediatelyStopped = !0;
  }
  /**
   * Stop this event from propagating to the next target in the propagation path.
   * The rest of the listeners on the current target will still be notified.
   * @example
   * ```ts
   * child.on('pointermove', (event) => {
   *     // Handle event on child
   *     updateChild();
   *
   *     // Prevent parent handlers from being called
   *     event.stopPropagation();
   * });
   *
   * // This won't be called if child handles the event
   * parent.on('pointermove', (event) => {
   *     updateParent();
   * });
   * ```
   * @remarks
   * - Stops event bubbling to parent containers
   * - Does not prevent other listeners on same target
   * - Less aggressive than stopImmediatePropagation()
   */
  stopPropagation() {
    this.propagationStopped = !0;
  }
}
var Tg = /iPhone/i, Ik = /iPod/i, Ak = /iPad/i, Pk = /\biOS-universal(?:.+)Mac\b/i, Cg = /\bAndroid(?:.+)Mobile\b/i, Ek = /Android/i, Ta = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i, oh = /Silk/i, Es = /Windows Phone/i, Rk = /\bWindows(?:.+)ARM\b/i, zk = /BlackBerry/i, $k = /BB10/i, Dk = /Opera Mini/i, Ok = /\b(CriOS|Chrome)(?:.+)Mobile/i, Lk = /Mobile(?:.+)Firefox\b/i, Bk = function(i) {
  return typeof i != "undefined" && i.platform === "MacIntel" && typeof i.maxTouchPoints == "number" && i.maxTouchPoints > 1 && typeof MSStream == "undefined";
};
function bY(i) {
  return function(e) {
    return e.test(i);
  };
}
function Fk(i) {
  var e = {
    userAgent: "",
    platform: "",
    maxTouchPoints: 0
  };
  !i && typeof navigator != "undefined" ? e = {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    maxTouchPoints: navigator.maxTouchPoints || 0
  } : typeof i == "string" ? e.userAgent = i : i && i.userAgent && (e = {
    userAgent: i.userAgent,
    platform: i.platform,
    maxTouchPoints: i.maxTouchPoints || 0
  });
  var t = e.userAgent, n = t.split("[FBAN");
  typeof n[1] != "undefined" && (t = n[0]), n = t.split("Twitter"), typeof n[1] != "undefined" && (t = n[0]);
  var s = bY(t), o = {
    apple: {
      phone: s(Tg) && !s(Es),
      ipod: s(Ik),
      tablet: !s(Tg) && (s(Ak) || Bk(e)) && !s(Es),
      universal: s(Pk),
      device: (s(Tg) || s(Ik) || s(Ak) || s(Pk) || Bk(e)) && !s(Es)
    },
    amazon: {
      phone: s(Ta),
      tablet: !s(Ta) && s(oh),
      device: s(Ta) || s(oh)
    },
    android: {
      phone: !s(Es) && s(Ta) || !s(Es) && s(Cg),
      tablet: !s(Es) && !s(Ta) && !s(Cg) && (s(oh) || s(Ek)),
      device: !s(Es) && (s(Ta) || s(oh) || s(Cg) || s(Ek)) || s(/\bokhttp\b/i)
    },
    windows: {
      phone: s(Es),
      tablet: s(Rk),
      device: s(Es) || s(Rk)
    },
    other: {
      blackberry: s(zk),
      blackberry10: s($k),
      opera: s(Dk),
      firefox: s(Lk),
      chrome: s(Ok),
      device: s(zk) || s($k) || s(Dk) || s(Lk) || s(Ok)
    },
    any: !1,
    phone: !1,
    tablet: !1
  };
  return o.any = o.apple.device || o.android.device || o.windows.device || o.other.device, o.phone = o.apple.phone || o.android.phone || o.windows.phone, o.tablet = o.apple.tablet || o.android.tablet || o.windows.tablet, o;
}
var z3;
const vY = (z3 = Fk.default) != null ? z3 : Fk, yY = vY(globalThis.navigator), xY = 9, Nk = 100, wY = 0, kY = 0, Uk = 2, Gk = 1, _Y = -1e3, SY = -1e3, MY = 2, Q1 = class NS {
  // eslint-disable-next-line jsdoc/require-param
  /**
   * @param {WebGLRenderer|WebGPURenderer} renderer - A reference to the current renderer
   */
  constructor(e, t = yY) {
    this._mobileInfo = t, this.debug = !1, this._activateOnTab = !0, this._deactivateOnMouseMove = !0, this._isActive = !1, this._isMobileAccessibility = !1, this._div = null, this._pools = {}, this._renderId = 0, this._children = [], this._androidUpdateCount = 0, this._androidUpdateFrequency = 500, this._isRunningTests = !1, this._boundOnKeyDown = this._onKeyDown.bind(this), this._boundOnMouseMove = this._onMouseMove.bind(this), this._hookDiv = null, (t.tablet || t.phone) && this._createTouchHook(), this._renderer = e;
  }
  /**
   * Value of `true` if accessibility is currently active and accessibility layers are showing.
   * @type {boolean}
   * @readonly
   */
  get isActive() {
    return this._isActive;
  }
  /**
   * Value of `true` if accessibility is enabled for touch devices.
   * @type {boolean}
   * @readonly
   */
  get isMobileAccessibility() {
    return this._isMobileAccessibility;
  }
  /**
   * Button element for handling touch hooks.
   * @readonly
   */
  get hookDiv() {
    return this._hookDiv;
  }
  /**
   * The DOM element that will sit over the PixiJS element. This is where the div overlays will go.
   * @readonly
   */
  get div() {
    return this._div;
  }
  /**
   * Creates the touch hooks.
   * @private
   */
  _createTouchHook() {
    const e = document.createElement("button");
    e.style.width = `${Gk}px`, e.style.height = `${Gk}px`, e.style.position = "absolute", e.style.top = `${_Y}px`, e.style.left = `${SY}px`, e.style.zIndex = MY.toString(), e.style.backgroundColor = "#FF0000", e.title = "select to enable accessibility for this content", e.addEventListener("focus", () => {
      this._isMobileAccessibility = !0, this._activate(), this._destroyTouchHook();
    }), document.body.appendChild(e), this._hookDiv = e;
  }
  /**
   * Destroys the touch hooks.
   * @private
   */
  _destroyTouchHook() {
    this._hookDiv && (document.body.removeChild(this._hookDiv), this._hookDiv = null);
  }
  /**
   * Activating will cause the Accessibility layer to be shown.
   * This is called when a user presses the tab key.
   * @private
   */
  _activate() {
    if (this._isActive)
      return;
    this._isActive = !0, this._div || (this._div = document.createElement("div"), this._div.style.position = "absolute", this._div.style.top = `${wY}px`, this._div.style.left = `${kY}px`, this._div.style.pointerEvents = "none", this._div.style.zIndex = Uk.toString(), this._canvasObserver = new FS({
      domElement: this._div,
      renderer: this._renderer
    })), this._deactivateOnMouseMove && globalThis.document.addEventListener("mousemove", this._boundOnMouseMove, !0);
    const e = this._renderer.view.canvas;
    if (e.parentNode)
      this._canvasObserver.ensureAttached(), this._initAccessibilitySetup();
    else {
      const t = new MutationObserver(() => {
        e.parentNode && (t.disconnect(), this._canvasObserver.ensureAttached(), this._initAccessibilitySetup());
      });
      t.observe(document.body, { childList: !0, subtree: !0 });
    }
  }
  // New method to handle initialization after div is ready
  _initAccessibilitySetup() {
    this._renderer.runners.postrender.add(this), this._renderer.lastObjectRendered && this._updateAccessibleObjects(this._renderer.lastObjectRendered);
  }
  /**
   * Deactivates the accessibility system. Removes listeners and accessibility elements.
   * @private
   */
  _deactivate() {
    var e, t;
    if (!(!this._isActive || this._isMobileAccessibility)) {
      this._isActive = !1, globalThis.document.removeEventListener("mousemove", this._boundOnMouseMove, !0), this._renderer.runners.postrender.remove(this);
      for (const n of this._children)
        (e = n._accessibleDiv) != null && e.parentNode && (n._accessibleDiv.parentNode.removeChild(n._accessibleDiv), n._accessibleDiv = null), n._accessibleActive = !1;
      for (const n in this._pools)
        this._pools[n].forEach((o) => {
          o.parentNode && o.parentNode.removeChild(o);
        }), delete this._pools[n];
      (t = this._div) != null && t.parentNode && this._div.parentNode.removeChild(this._div), this._pools = {}, this._children = [];
    }
  }
  /**
   * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
   * @private
   * @param {Container} container - The Container to check.
   */
  _updateAccessibleObjects(e) {
    if (!e.visible || !e.accessibleChildren)
      return;
    e.accessible && (e._accessibleActive || this._addChild(e), e._renderId = this._renderId);
    const t = e.children;
    if (t)
      for (let n = 0; n < t.length; n++)
        this._updateAccessibleObjects(t[n]);
  }
  /**
   * Runner init called, view is available at this point.
   * @ignore
   */
  init(e) {
    const n = {
      accessibilityOptions: {
        ...NS.defaultOptions,
        ...(e == null ? void 0 : e.accessibilityOptions) || {}
      }
    };
    this.debug = n.accessibilityOptions.debug, this._activateOnTab = n.accessibilityOptions.activateOnTab, this._deactivateOnMouseMove = n.accessibilityOptions.deactivateOnMouseMove, this._activateOnTab && globalThis.addEventListener("keydown", this._boundOnKeyDown, !1), n.accessibilityOptions.enabledByDefault && this._activate(), this._renderer.runners.postrender.remove(this);
  }
  /**
   * Updates the accessibility layer during rendering.
   * - Removes divs for containers no longer in the scene
   * - Updates the position and dimensions of the root div
   * - Updates positions of active accessibility divs
   * Only fires while the accessibility system is active.
   * @ignore
   */
  postrender() {
    const e = performance.now();
    if (this._mobileInfo.android.device && e < this._androidUpdateCount || (this._androidUpdateCount = e + this._androidUpdateFrequency, (!this._renderer.renderingToScreen || !this._renderer.view.canvas) && !this._isRunningTests))
      return;
    const t = /* @__PURE__ */ new Set();
    if (this._renderer.lastObjectRendered) {
      this._updateAccessibleObjects(this._renderer.lastObjectRendered);
      for (const n of this._children)
        n._renderId === this._renderId && t.add(this._children.indexOf(n));
    }
    for (let n = this._children.length - 1; n >= 0; n--) {
      const s = this._children[n];
      t.has(n) || (s._accessibleDiv && s._accessibleDiv.parentNode && (s._accessibleDiv.parentNode.removeChild(s._accessibleDiv), this._getPool(s.accessibleType).push(s._accessibleDiv), s._accessibleDiv = null), s._accessibleActive = !1, xS(this._children, n, 1));
    }
    this._renderer.renderingToScreen && this._canvasObserver.ensureAttached();
    for (let n = 0; n < this._children.length; n++) {
      const s = this._children[n];
      if (!s._accessibleActive || !s._accessibleDiv)
        continue;
      const o = s._accessibleDiv, r = s.hitArea || s.getBounds().rectangle;
      if (s.hitArea) {
        const a = s.worldTransform;
        o.style.left = `${a.tx + r.x * a.a}px`, o.style.top = `${a.ty + r.y * a.d}px`, o.style.width = `${r.width * a.a}px`, o.style.height = `${r.height * a.d}px`;
      } else
        this._capHitArea(r), o.style.left = `${r.x}px`, o.style.top = `${r.y}px`, o.style.width = `${r.width}px`, o.style.height = `${r.height}px`;
    }
    this._renderId++;
  }
  /**
   * private function that will visually add the information to the
   * accessibility div
   * @param {HTMLElement} div -
   */
  _updateDebugHTML(e) {
    e.innerHTML = `type: ${e.type}</br> title : ${e.title}</br> tabIndex: ${e.tabIndex}`;
  }
  /**
   * Adjust the hit area based on the bounds of a display object
   * @param {Rectangle} hitArea - Bounds of the child
   */
  _capHitArea(e) {
    e.x < 0 && (e.width += e.x, e.x = 0), e.y < 0 && (e.height += e.y, e.y = 0);
    const { width: t, height: n } = this._renderer;
    e.x + e.width > t && (e.width = t - e.x), e.y + e.height > n && (e.height = n - e.y);
  }
  /**
   * Creates or reuses a div element for a Container and adds it to the accessibility layer.
   * Sets up ARIA attributes, event listeners, and positioning based on the container's properties.
   * @private
   * @param {Container} container - The child to make accessible.
   */
  _addChild(e) {
    let n = this._getPool(e.accessibleType).pop();
    n ? (n.innerHTML = "", n.removeAttribute("title"), n.removeAttribute("aria-label"), n.tabIndex = 0) : (e.accessibleType === "button" ? (n = document.createElement("button"), this.debug || (n.style.color = "transparent")) : (n = document.createElement(e.accessibleType), n.style.cssText = `
                        color: transparent;
                        pointer-events: none;
                        padding: 0;
                        margin: 0;
                        border: 0;
                        outline: 0;
                        background: transparent;
                        box-sizing: border-box;
                        user-select: none;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                    `), n.style.width = `${Nk}px`, n.style.height = `${Nk}px`, n.style.backgroundColor = this.debug ? "rgba(255,255,255,0.5)" : "transparent", n.style.position = "absolute", n.style.zIndex = Uk.toString(), n.style.borderStyle = "none", navigator.userAgent.toLowerCase().includes("chrome") ? n.setAttribute("aria-live", "off") : n.setAttribute("aria-live", "polite"), navigator.userAgent.match(/rv:.*Gecko\//) ? n.setAttribute("aria-relevant", "additions") : n.setAttribute("aria-relevant", "text"), n.addEventListener("click", this._onClick.bind(this)), n.addEventListener("focus", this._onFocus.bind(this)), n.addEventListener("focusout", this._onFocusOut.bind(this))), n.style.pointerEvents = e.accessiblePointerEvents, n.type = e.accessibleType, e.accessibleText && (n.innerText = e.accessibleText), e.accessibleTitle && e.accessibleTitle !== null ? n.title = e.accessibleTitle : (!e.accessibleHint || e.accessibleHint === null) && (n.title = `container ${e.tabIndex}`), e.accessibleHint && e.accessibleHint !== null && n.setAttribute("aria-label", e.accessibleHint), e.interactive ? n.tabIndex = e.tabIndex : n.tabIndex = 0, this.debug && this._updateDebugHTML(n), e._accessibleActive = !0, e._accessibleDiv = n, n.container = e, this._children.push(e), this._div.appendChild(e._accessibleDiv);
  }
  /**
   * Dispatch events with the EventSystem.
   * @param e
   * @param type
   * @private
   */
  _dispatchEvent(e, t) {
    const { container: n } = e.target, s = this._renderer.events.rootBoundary, o = Object.assign(new xu(s), { target: n });
    s.rootTarget = this._renderer.lastObjectRendered, t.forEach((r) => s.dispatchEvent(o, r));
  }
  /**
   * Maps the div button press to pixi's EventSystem (click)
   * @private
   * @param {MouseEvent} e - The click event.
   */
  _onClick(e) {
    this._dispatchEvent(e, ["click", "pointertap", "tap"]);
  }
  /**
   * Maps the div focus events to pixi's EventSystem (mouseover)
   * @private
   * @param {FocusEvent} e - The focus event.
   */
  _onFocus(e) {
    e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "assertive"), this._dispatchEvent(e, ["mouseover"]);
  }
  /**
   * Maps the div focus events to pixi's EventSystem (mouseout)
   * @private
   * @param {FocusEvent} e - The focusout event.
   */
  _onFocusOut(e) {
    e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "polite"), this._dispatchEvent(e, ["mouseout"]);
  }
  /**
   * Is called when a key is pressed
   * @private
   * @param {KeyboardEvent} e - The keydown event.
   */
  _onKeyDown(e) {
    e.keyCode !== xY || !this._activateOnTab || this._activate();
  }
  /**
   * Is called when the mouse moves across the renderer element
   * @private
   * @param {MouseEvent} e - The mouse event.
   */
  _onMouseMove(e) {
    e.movementX === 0 && e.movementY === 0 || this._deactivate();
  }
  /**
   * Destroys the accessibility system. Removes all elements and listeners.
   * > [!IMPORTANT] This is typically called automatically when the {@link Application} is destroyed.
   * > A typically user should not need to call this method directly.
   */
  destroy() {
    var e;
    this._deactivate(), this._destroyTouchHook(), (e = this._canvasObserver) == null || e.destroy(), this._canvasObserver = null, this._div = null, this._pools = null, this._children = null, this._renderer = null, this._hookDiv = null, globalThis.removeEventListener("keydown", this._boundOnKeyDown), this._boundOnKeyDown = null, globalThis.document.removeEventListener("mousemove", this._boundOnMouseMove, !0), this._boundOnMouseMove = null;
  }
  /**
   * Enables or disables the accessibility system.
   * @param enabled - Whether to enable or disable accessibility.
   * @example
   * ```js
   * app.renderer.accessibility.setAccessibilityEnabled(true); // Enable accessibility
   * app.renderer.accessibility.setAccessibilityEnabled(false); // Disable accessibility
   * ```
   */
  setAccessibilityEnabled(e) {
    e ? this._activate() : this._deactivate();
  }
  _getPool(e) {
    return this._pools[e] || (this._pools[e] = []), this._pools[e];
  }
};
Q1.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem
  ],
  name: "accessibility"
};
Q1.defaultOptions = {
  /**
   * Whether to enable accessibility features on initialization
   * @default false
   */
  enabledByDefault: !1,
  /**
   * Whether to visually show the accessibility divs for debugging
   * @default false
   */
  debug: !1,
  /**
   * Whether to activate accessibility when tab key is pressed
   * @default true
   */
  activateOnTab: !0,
  /**
   * Whether to deactivate accessibility when mouse moves
   * @default true
   */
  deactivateOnMouseMove: !0
};
let TY = Q1;
const CY = {
  accessible: !1,
  accessibleTitle: null,
  accessibleHint: null,
  tabIndex: 0,
  accessibleType: "button",
  accessibleText: null,
  accessiblePointerEvents: "auto",
  accessibleChildren: !0,
  _accessibleActive: !1,
  _accessibleDiv: null,
  _renderId: -1
}, Ig = /* @__PURE__ */ Object.create(null), jk = /* @__PURE__ */ Object.create(null);
function Ll(i, e) {
  let t = jk[i];
  return t === void 0 && (Ig[e] === void 0 && (Ig[e] = 1), jk[i] = t = Ig[e]++), t;
}
let Ca;
function US() {
  return (!Ca || Ca != null && Ca.isContextLost()) && (Ca = zt.get().createCanvas().getContext("webgl", {})), Ca;
}
let rh;
function IY() {
  if (!rh) {
    rh = "mediump";
    const i = US();
    i && i.getShaderPrecisionFormat && (rh = i.getShaderPrecisionFormat(i.FRAGMENT_SHADER, i.HIGH_FLOAT).precision ? "highp" : "mediump");
  }
  return rh;
}
function AY(i, e, t) {
  return e ? i : t ? (i = i.replace("out vec4 finalColor;", ""), `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in varying
        #define finalColor gl_FragColor
        #define texture texture2D
        #endif
        ${i}
        `) : `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in attribute
        #define out varying
        #endif
        ${i}
        `;
}
const PY = /\buniform\s+([iu]?sampler\w+)/g, EY = /\bprecision\s+\w+\s+([iu]?sampler\w+)\s*;/g, RY = {
  sampler2D: "lowp",
  samplerCube: "lowp"
};
function zY(i, e, t) {
  const n = t ? e.maxSupportedFragmentPrecision : e.maxSupportedVertexPrecision;
  if (i.substring(0, 9) !== "precision") {
    let o = t ? e.requestedFragmentPrecision : e.requestedVertexPrecision;
    o === "highp" && n !== "highp" && (o = "mediump"), i = `precision ${o} float;
${i}`;
  } else n !== "highp" && i.substring(0, 15) === "precision highp" && (i = i.replace("precision highp", "precision mediump"));
  const s = e.maxSupportedFragmentPrecision === "highp" ? "highp" : "mediump";
  return $Y(i, s);
}
function $Y(i, e) {
  var s;
  const t = /* @__PURE__ */ new Set();
  let n = "";
  for (const [, o] of i.matchAll(EY)) t.add(o);
  for (const [, o] of i.matchAll(PY))
    t.has(o) || (t.add(o), n += `precision ${(s = RY[o]) != null ? s : e} ${o};
`);
  return n + i;
}
function DY(i, e) {
  return e ? `#version 300 es
${i}` : i;
}
const OY = {}, LY = {};
function BY(i, { name: e = "pixi-program" }, t = !0) {
  e = e.replace(/\s+/g, "-"), e += t ? "-fragment" : "-vertex";
  const n = t ? OY : LY;
  return n[e] ? (n[e]++, e += `-${n[e]}`) : n[e] = 1, i.indexOf("#define SHADER_NAME") !== -1 ? i : `${`#define SHADER_NAME ${e}`}
${i}`;
}
function FY(i, e) {
  return e ? i.replace("#version 300 es", "") : i;
}
const Ag = {
  // strips any version headers..
  stripVersion: FY,
  // adds precision string if not already present
  ensurePrecision: zY,
  // add some defines if WebGL1 to make it more compatible with WebGL2 shaders
  addProgramDefines: AY,
  // add the program name to the shader
  setProgramName: BY,
  // add the version string to the shader header
  insertVersion: DY
}, pd = /* @__PURE__ */ Object.create(null), GS = class Vv {
  /**
   * Creates a shiny new GlProgram. Used by WebGL renderer.
   * @param options - The options for the program.
   */
  constructor(e) {
    e = { ...Vv.defaultOptions, ...e };
    const t = e.fragment.indexOf("#version 300 es") !== -1, n = {
      stripVersion: t,
      ensurePrecision: {
        requestedFragmentPrecision: e.preferredFragmentPrecision,
        requestedVertexPrecision: e.preferredVertexPrecision,
        maxSupportedVertexPrecision: "highp",
        maxSupportedFragmentPrecision: IY()
      },
      setProgramName: {
        name: e.name
      },
      addProgramDefines: t,
      insertVersion: t
    };
    let s = e.fragment, o = e.vertex;
    Object.keys(Ag).forEach((r) => {
      const a = n[r];
      s = Ag[r](s, a, !0), o = Ag[r](o, a, !1);
    }), this.fragment = s, this.vertex = o, this.transformFeedbackVaryings = e.transformFeedbackVaryings, this._key = Ll(`${this.vertex}:${this.fragment}`, "gl-program");
  }
  /** destroys the program */
  destroy() {
    this.fragment = null, this.vertex = null, this._attributeData = null, this._uniformData = null, this._uniformBlockData = null, this.transformFeedbackVaryings = null, pd[this._cacheKey] = null;
  }
  /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */
  static from(e) {
    const t = `${e.vertex}:${e.fragment}`;
    return pd[t] || (pd[t] = new Vv(e), pd[t]._cacheKey = t), pd[t];
  }
};
GS.defaultOptions = {
  preferredVertexPrecision: "highp",
  preferredFragmentPrecision: "mediump"
};
let Xl = GS;
const Hk = {
  uint8x2: { size: 2, stride: 2, normalised: !1 },
  uint8x4: { size: 4, stride: 4, normalised: !1 },
  sint8x2: { size: 2, stride: 2, normalised: !1 },
  sint8x4: { size: 4, stride: 4, normalised: !1 },
  unorm8x2: { size: 2, stride: 2, normalised: !0 },
  unorm8x4: { size: 4, stride: 4, normalised: !0 },
  snorm8x2: { size: 2, stride: 2, normalised: !0 },
  snorm8x4: { size: 4, stride: 4, normalised: !0 },
  uint16x2: { size: 2, stride: 4, normalised: !1 },
  uint16x4: { size: 4, stride: 8, normalised: !1 },
  sint16x2: { size: 2, stride: 4, normalised: !1 },
  sint16x4: { size: 4, stride: 8, normalised: !1 },
  unorm16x2: { size: 2, stride: 4, normalised: !0 },
  unorm16x4: { size: 4, stride: 8, normalised: !0 },
  snorm16x2: { size: 2, stride: 4, normalised: !0 },
  snorm16x4: { size: 4, stride: 8, normalised: !0 },
  float16x2: { size: 2, stride: 4, normalised: !1 },
  float16x4: { size: 4, stride: 8, normalised: !1 },
  float32: { size: 1, stride: 4, normalised: !1 },
  float32x2: { size: 2, stride: 8, normalised: !1 },
  float32x3: { size: 3, stride: 12, normalised: !1 },
  float32x4: { size: 4, stride: 16, normalised: !1 },
  uint32: { size: 1, stride: 4, normalised: !1 },
  uint32x2: { size: 2, stride: 8, normalised: !1 },
  uint32x3: { size: 3, stride: 12, normalised: !1 },
  uint32x4: { size: 4, stride: 16, normalised: !1 },
  sint32: { size: 1, stride: 4, normalised: !1 },
  sint32x2: { size: 2, stride: 8, normalised: !1 },
  sint32x3: { size: 3, stride: 12, normalised: !1 },
  sint32x4: { size: 4, stride: 16, normalised: !1 }
};
function Hc(i) {
  var e;
  return (e = Hk[i]) != null ? e : Hk.float32;
}
const NY = {
  f32: "float32",
  "vec2<f32>": "float32x2",
  "vec3<f32>": "float32x3",
  "vec4<f32>": "float32x4",
  vec2f: "float32x2",
  vec3f: "float32x3",
  vec4f: "float32x4",
  i32: "sint32",
  "vec2<i32>": "sint32x2",
  "vec3<i32>": "sint32x3",
  "vec4<i32>": "sint32x4",
  vec2i: "sint32x2",
  vec3i: "sint32x3",
  vec4i: "sint32x4",
  u32: "uint32",
  "vec2<u32>": "uint32x2",
  "vec3<u32>": "uint32x3",
  "vec4<u32>": "uint32x4",
  vec2u: "uint32x2",
  vec3u: "uint32x3",
  vec4u: "uint32x4",
  bool: "uint32",
  "vec2<bool>": "uint32x2",
  "vec3<bool>": "uint32x3",
  "vec4<bool>": "uint32x4"
}, Vk = /@location\((\d+)\)\s+([a-zA-Z0-9_]+)\s*:\s*([a-zA-Z0-9_<>]+)(?:,|\s|\)|$)/g;
function Wk(i, e) {
  var n;
  let t;
  for (; (t = Vk.exec(i)) !== null; ) {
    const s = (n = NY[t[3]]) != null ? n : "float32";
    e[t[2]] = {
      location: parseInt(t[1], 10),
      format: s,
      stride: Hc(s).stride,
      offset: 0,
      instance: !1,
      start: 0
    };
  }
  Vk.lastIndex = 0;
}
function UY(i) {
  return i.replace(/\/\/.*$/gm, "").replace(/\/\*[\s\S]*?\*\//g, "");
}
function GY({ source: i, entryPoint: e }) {
  const t = {}, n = UY(i), s = n.indexOf(`fn ${e}(`);
  if (s === -1)
    return t;
  const o = n.indexOf("->", s);
  if (o === -1)
    return t;
  const r = n.substring(s, o);
  if (Wk(r, t), Object.keys(t).length === 0) {
    const a = r.match(/\(\s*\w+\s*:\s*(\w+)/);
    if (a) {
      const l = a[1], d = new RegExp(`struct\\s+${l}\\s*\\{([^}]+)\\}`, "s"), c = n.match(d);
      c && Wk(c[1], t);
    }
  }
  return t;
}
function Pg(i) {
  var h, f, p;
  const e = /(^|[^/])@(group|binding)\(\d+\)[^;]+;/g, t = /@group\((\d+)\)/, n = /@binding\((\d+)\)/, s = /var(<[^>]+>)? (\w+)/, o = /:\s*([\w<>]+)/, r = /struct\s+(\w+)\s*{([^}]+)}/g, a = /(\w+)\s*:\s*([\w\<\>]+)/g, l = /struct\s+(\w+)/, d = (h = i.match(e)) == null ? void 0 : h.map((y) => {
    var S;
    const v = y.match(s), x = (S = v == null ? void 0 : v[1]) != null ? S : "";
    let w;
    return x === "<uniform>" ? w = "uniform" : x.startsWith("<storage") && (w = "storage"), {
      group: parseInt(y.match(t)[1], 10),
      binding: parseInt(y.match(n)[1], 10),
      name: v[2],
      accessMode: w,
      type: y.match(o)[1]
    };
  });
  if (!d)
    return {
      groups: [],
      structs: []
    };
  const c = (p = (f = i.match(r)) == null ? void 0 : f.map((y) => {
    const v = y.match(l)[1], x = y.match(a).reduce((w, S) => {
      const [M, _] = S.split(":");
      return w[M.trim()] = _.trim(), w;
    }, {});
    return x ? { name: v, members: x } : null;
  }).filter(({ name: y }) => d.some(
    (v) => (
      // Handle both direct type matches and generic types like array<StructName>
      v.type === y || v.type.includes(`<${y}>`)
    )
  ))) != null ? p : [];
  return {
    groups: d,
    structs: c
  };
}
var hn = /* @__PURE__ */ ((i) => (i[i.VERTEX = 1] = "VERTEX", i[i.FRAGMENT = 2] = "FRAGMENT", i[i.COMPUTE = 4] = "COMPUTE", i))(hn || {});
function ah(i) {
  return i.endsWith("<u32>") ? "uint" : i.endsWith("<i32>") ? "sint" : "float";
}
function jY({ groups: i }) {
  const e = [];
  for (let t = 0; t < i.length; t++) {
    const n = i[t];
    e[n.group] || (e[n.group] = []), n.accessMode === "uniform" ? e[n.group].push({
      binding: n.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      buffer: {
        type: "uniform"
      }
    }) : n.accessMode === "storage" ? e[n.group].push({
      binding: n.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      buffer: {
        type: "read-only-storage"
      }
    }) : n.type === "sampler" ? e[n.group].push({
      binding: n.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      sampler: {
        type: "filtering"
      }
    }) : n.type === "sampler_comparison" ? e[n.group].push({
      binding: n.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      sampler: {
        type: "comparison"
      }
    }) : n.type === "texture_2d" || n.type.startsWith("texture_2d<") ? e[n.group].push({
      binding: n.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      texture: {
        sampleType: ah(n.type),
        viewDimension: "2d",
        multisampled: !1
      }
    }) : n.type === "texture_depth_2d" ? e[n.group].push({
      binding: n.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      texture: {
        sampleType: "depth",
        viewDimension: "2d",
        multisampled: !1
      }
    }) : n.type === "texture_depth_2d_array" ? e[n.group].push({
      binding: n.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      texture: {
        sampleType: "depth",
        viewDimension: "2d-array",
        multisampled: !1
      }
    }) : n.type === "texture_2d_array" || n.type.startsWith("texture_2d_array<") ? e[n.group].push({
      binding: n.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      texture: {
        sampleType: ah(n.type),
        viewDimension: "2d-array",
        multisampled: !1
      }
    }) : n.type === "texture_3d" || n.type.startsWith("texture_3d<") ? e[n.group].push({
      binding: n.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      texture: {
        sampleType: ah(n.type),
        viewDimension: "3d",
        multisampled: !1
      }
    }) : (n.type === "texture_cube" || n.type.startsWith("texture_cube<")) && e[n.group].push({
      binding: n.binding,
      visibility: hn.VERTEX | hn.FRAGMENT,
      texture: {
        sampleType: ah(n.type),
        viewDimension: "cube",
        multisampled: !1
      }
    });
  }
  for (let t = 0; t < e.length; t++)
    e[t] || (e[t] = []);
  return e;
}
function HY({ groups: i }) {
  const e = [];
  for (let t = 0; t < i.length; t++) {
    const n = i[t];
    e[n.group] || (e[n.group] = {}), e[n.group][n.name] = n.binding;
  }
  return e;
}
function VY(i, e) {
  const t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), s = [...i.structs, ...e.structs].filter((r) => t.has(r.name) ? !1 : (t.add(r.name), !0)), o = [...i.groups, ...e.groups].filter((r) => {
    const a = `${r.name}-${r.binding}`;
    return n.has(a) ? !1 : (n.add(a), !0);
  });
  return { structs: s, groups: o };
}
const fd = /* @__PURE__ */ Object.create(null);
class ba {
  /**
   * Create a new GpuProgram
   * @param options - The options for the gpu program
   */
  constructor(e) {
    var a, l;
    this._layoutKey = 0, this._attributeLocationsKey = 0;
    const { fragment: t, vertex: n, layout: s, gpuLayout: o, name: r } = e;
    if (this.name = r, this.fragment = t, this.vertex = n, t.source === n.source) {
      const d = Pg(t.source);
      this.structsAndGroups = d;
    } else {
      const d = Pg(n.source), c = Pg(t.source);
      this.structsAndGroups = VY(d, c);
    }
    this.layout = s != null ? s : HY(this.structsAndGroups), this.gpuLayout = o != null ? o : jY(this.structsAndGroups), this.autoAssignGlobalUniforms = ((a = this.layout[0]) == null ? void 0 : a.globalUniforms) !== void 0, this.autoAssignLocalUniforms = ((l = this.layout[1]) == null ? void 0 : l.localUniforms) !== void 0, this._generateProgramKey();
  }
  // TODO maker this pure
  _generateProgramKey() {
    const { vertex: e, fragment: t } = this, n = e.source + t.source + e.entryPoint + t.entryPoint;
    this._layoutKey = Ll(n, "program");
  }
  get attributeData() {
    var e;
    return (e = this._attributeData) != null || (this._attributeData = GY(this.vertex)), this._attributeData;
  }
  /** destroys the program */
  destroy() {
    this.gpuLayout = null, this.layout = null, this.structsAndGroups = null, this.fragment = null, this.vertex = null, fd[this._cacheKey] = null;
  }
  /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */
  static from(e) {
    const t = `${e.vertex.source}:${e.fragment.source}:${e.fragment.entryPoint}:${e.vertex.entryPoint}`;
    return fd[t] || (fd[t] = new ba(e), fd[t]._cacheKey = t), fd[t];
  }
}
const jS = [
  "f32",
  "i32",
  "u32",
  "vec2<f32>",
  "vec3<f32>",
  "vec4<f32>",
  "mat2x2<f32>",
  "mat3x3<f32>",
  "mat4x4<f32>",
  "mat3x2<f32>",
  "mat4x2<f32>",
  "mat2x3<f32>",
  "mat4x3<f32>",
  "mat2x4<f32>",
  "mat3x4<f32>",
  "vec2<i32>",
  "vec3<i32>",
  "vec4<i32>",
  "vec2<u32>",
  "vec3<u32>",
  "vec4<u32>"
], WY = jS.reduce((i, e) => (i[e] = !0, i), {});
function qY(i, e) {
  switch (i) {
    case "f32":
      return 0;
    case "vec2<f32>":
      return new Float32Array(2 * e);
    case "vec3<f32>":
      return new Float32Array(3 * e);
    case "vec4<f32>":
      return new Float32Array(4 * e);
    case "mat2x2<f32>":
      return new Float32Array([
        1,
        0,
        0,
        1
      ]);
    case "mat3x3<f32>":
      return new Float32Array([
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ]);
    case "mat4x4<f32>":
      return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]);
  }
  return null;
}
const HS = class VS extends bi {
  /**
   * Create a new Uniform group
   * @param uniformStructures - The structures of the uniform group
   * @param options - The optional parameters of this uniform group
   */
  constructor(e, t) {
    var s, o;
    super(), this.uid = Nt("uniform"), this._resourceType = "uniformGroup", this._resourceId = Nt("resource"), this.isUniformGroup = !0, this._dirtyId = 0, this.destroyed = !1, t = { ...VS.defaultOptions, ...t }, this.uniformStructures = e;
    const n = {};
    for (const r in e) {
      const a = e[r];
      if (a.name = r, a.size = (s = a.size) != null ? s : 1, !WY[a.type]) {
        const l = a.type.match(/^array<(\w+(?:<\w+>)?),\s*(\d+)>$/);
        if (l) {
          const [, d, c] = l;
          throw new Error(
            `Uniform type ${a.type} is not supported. Use type: '${d}', size: ${c} instead.`
          );
        }
        throw new Error(`Uniform type ${a.type} is not supported. Supported uniform types are: ${jS.join(", ")}`);
      }
      (o = a.value) != null || (a.value = qY(a.type, a.size)), n[r] = a.value;
    }
    this.uniforms = n, this._dirtyId = 1, this.ubo = t.ubo, this.isStatic = t.isStatic, this._signature = Ll(Object.keys(n).map(
      (r) => `${r}-${e[r].type}`
    ).join("-"), "uniform-group");
  }
  /**
   * an underlying buffer that will be uploaded to the GPU when using this UniformGroup.
   * It is created lazily by the renderer's ubo system on first use.
   */
  get buffer() {
    return this._buffer;
  }
  set buffer(e) {
    var t;
    this._buffer !== e && ((t = this._buffer) == null || t.off("change", this.onBufferChange, this), this._buffer = e, e == null || e.on("change", this.onBufferChange, this));
  }
  /**
   * The GC tracks this group's underlying buffer, not the group itself — a GC stamp on the
   * group (see BindGroup._touch) must land on the buffer, or the GC collects it while
   * cached bind groups still reference it.
   * @internal
   */
  get _gcLastUsed() {
    var e, t;
    return (t = (e = this._buffer) == null ? void 0 : e._gcLastUsed) != null ? t : -1;
  }
  set _gcLastUsed(e) {
    this._buffer && (this._buffer._gcLastUsed = e);
  }
  /**
   * Bind group keys are built from this group's _resourceId, not the buffer's — so when the
   * buffer re-keys (it resized, or the GC unloaded its GPU copy), this group must re-key too,
   * or cached GPUBindGroups keep referencing the destroyed GPU buffer.
   */
  onBufferChange() {
    this._resourceId = Nt("resource"), this.emit("change", this);
  }
  /** Call this if you want the uniform groups data to be uploaded to the GPU only useful if `isStatic` is true. */
  update() {
    this._dirtyId++;
  }
};
HS.defaultOptions = {
  /** if true the UniformGroup is handled as an Uniform buffer object. */
  ubo: !1,
  /** if true, then you are responsible for when the data is uploaded to the GPU by calling `update()` */
  isStatic: !1
};
let Ts = HS;
class qo {
  /**
   * Create a new instance of the Bind Group.
   * @param resources - The resources that are bound together for use by a shader.
   */
  constructor(e) {
    this.resources = /* @__PURE__ */ Object.create(null), this._resourceKeysValue = null, this._dirty = !0;
    let t = 0;
    for (const n in e) {
      const s = e[n];
      this.setResource(s, t++);
    }
  }
  /**
   * The binding numbers in use in {@link BindGroup#resources}, ascending. Binding numbers can
   * have gaps, so per-draw loops index this list instead of running `for...in` over
   * `resources`, which builds a fresh key list on every call for integer keys.
   * @internal
   */
  get _resourceKeys() {
    var e;
    return (e = this._resourceKeysValue) != null || (this._resourceKeysValue = Object.keys(this.resources).map(Number)), this._resourceKeysValue;
  }
  /**
   * A key used internally to match it up to a WebGPU BindGroup.
   * Lazily rebuilt from resource IDs when dirty.
   * @internal
   */
  get _key() {
    if (this._dirty) {
      this._dirty = !1;
      const e = [];
      let t = 0;
      for (const n in this.resources)
        e[t++] = this.resources[n] ? this.resources[n]._resourceId : -1;
      this._keyValue = e.join("|");
    }
    return this._keyValue;
  }
  /**
   * Set a resource at a given index. This function will
   * ensure that listeners will be removed from the current resource
   * and added to the new resource.
   * @param resource - The resource to set.
   * @param index - The index to set the resource at.
   */
  setResource(e, t) {
    var s, o;
    const n = this.resources[t];
    e !== n && (n && ((s = n.off) == null || s.call(n, "change", this.onResourceChange, this)), (o = e.on) == null || o.call(e, "change", this.onResourceChange, this), n === void 0 && (this._resourceKeysValue = null), this.resources[t] = e, this._dirty = !0);
  }
  /**
   * Returns the resource at the current specified index.
   * @param index - The index of the resource to get.
   * @returns - The resource at the specified index.
   */
  getResource(e) {
    return this.resources[e];
  }
  /**
   * Used internally to 'touch' each resource, to ensure that the GC
   * knows that all resources in this bind group are still being used.
   * @param now - The current time in milliseconds.
   * @internal
   */
  _touch(e) {
    const t = this.resources, n = this._resourceKeys;
    for (let s = 0; s < n.length; s++) {
      const o = t[n[s]];
      o && (o._gcLastUsed = e);
    }
  }
  /** Destroys this bind group and removes all listeners. */
  destroy() {
    var t;
    const e = this.resources;
    for (const n in e) {
      const s = e[n];
      (t = s == null ? void 0 : s.off) == null || t.call(s, "change", this.onResourceChange, this);
    }
    this.resources = null, this._resourceKeysValue = null;
  }
  onResourceChange(e) {
    if (this._dirty = !0, e.destroyed) {
      const t = this.resources;
      for (const n in t)
        t[n] === e && (t[n] = null);
      dt(`[BindGroup] a '${e._resourceType}' was destroyed while still bound to a shader. Remove it from the shader before destroying it.`);
    }
  }
}
var rs = /* @__PURE__ */ ((i) => (i[i.WEBGL = 1] = "WEBGL", i[i.WEBGPU = 2] = "WEBGPU", i[i.CANVAS = 4] = "CANVAS", i[i.BOTH = 3] = "BOTH", i))(rs || {});
class Vc {
  /**
   * @param data - A dictionary of constants to set on the shader.
   * Keys should match the constant names in the WGSL shader.
   */
  constructor(e) {
    this.data = { ...e };
    const t = Object.keys(e).sort().map((n) => `${n}:${e[n]}`).join("|");
    this.id = Ll(t, "shader-overrides");
  }
  /**
   * Creates a ShaderOverrides instance from a plain object or existing instance.
   * @param overrides - The overrides to convert.
   * @returns A ShaderOverrides instance.
   */
  static from(e) {
    return e instanceof Vc ? e : new Vc(e);
  }
}
class lo extends bi {
  constructor(e) {
    super(), this.uid = Nt("shader"), this._uniformBindMap = /* @__PURE__ */ Object.create(null), this._ownedBindGroups = [], this._destroyed = !1;
    let {
      gpuProgram: t,
      glProgram: n,
      groups: s,
      resources: o,
      compatibleRenderers: r,
      groupMap: a,
      overrides: l
    } = e;
    this._overrides = l ? Vc.from(l) : null, this.gpuProgram = t, this.glProgram = n, r === void 0 && (r = 0, t && (r |= rs.WEBGPU), n && (r |= rs.WEBGL)), this.compatibleRenderers = r;
    const d = {};
    if (a)
      for (const c in a)
        for (const h in a[c]) {
          const f = a[c][h];
          d[f] = {
            group: c,
            binding: h,
            name: f
          };
        }
    if (!o && !s && (o = {}), o && s)
      throw new Error("[Shader] Cannot have both resources and groups");
    if (!t && s && !a)
      throw new Error("[Shader] No group map or WebGPU shader provided - consider using resources instead.");
    if (t && s && !a) {
      const c = t.structsAndGroups.groups;
      a = {}, c.forEach((h) => {
        a[h.group] = a[h.group] || {}, a[h.group][h.binding] = h.name, d[h.name] = h;
      });
    } else if (o) {
      s = {}, a || (a = {}), t && t.structsAndGroups.groups.forEach((f) => {
        a[f.group] = a[f.group] || {}, a[f.group][f.binding] = f.name, d[f.name] = f;
      });
      let c = 0;
      for (const h in o)
        d[h] || (t && !n && dt(`[Shader] the resource '${h}' matches no binding in the WGSL source — is the name correct?`), s[99] || (s[99] = new qo(), this._ownedBindGroups.push(s[99])), d[h] = { group: 99, binding: c, name: h }, a[99] = a[99] || {}, a[99][c] = h, c++);
      for (const h in o) {
        const f = h;
        let p = o[h];
        !p.source && !p._resourceType && (p = new Ts(p));
        const y = d[f];
        y && (s[y.group] || (s[y.group] = new qo(), this._ownedBindGroups.push(s[y.group])), s[y.group].setResource(p, y.binding));
      }
    }
    this.groups = s, this._uniformBindMap = a, this.resources = this._buildResourceAccessor(s, d);
  }
  /**
   * Sometimes a resource group will be provided later (for example global uniforms)
   * In such cases, this method can be used to let the shader know about the group.
   * @param name - the name of the resource group
   * @param groupIndex - the index of the group (should match the webGPU shader group location)
   * @param bindIndex - the index of the bind point (should match the webGPU shader bind point)
   */
  addResource(e, t, n) {
    var s, o;
    (s = this._uniformBindMap)[t] || (s[t] = {}), (o = this._uniformBindMap[t])[n] || (o[n] = e), this.groups[t] || (this.groups[t] = new qo(), this._ownedBindGroups.push(this.groups[t]));
  }
  _buildResourceAccessor(e, t) {
    const n = {};
    for (const s in t) {
      const o = t[s];
      Object.defineProperty(n, o.name, {
        get() {
          return e[o.group].getResource(o.binding);
        },
        set(r) {
          e[o.group].setResource(r, o.binding);
        }
      });
    }
    return n;
  }
  /**
   * Use to destroy the shader when its not longer needed.
   * It will destroy the resources and remove listeners.
   * @param destroyPrograms - if the programs should be destroyed as well.
   * Make sure its not being used by other shaders!
   */
  destroy(e = !1) {
    var t, n;
    this._destroyed || (this._destroyed = !0, this.emit("destroy", this), e && ((t = this.gpuProgram) == null || t.destroy(), (n = this.glProgram) == null || n.destroy()), this.gpuProgram = null, this.glProgram = null, this.removeAllListeners(), this._uniformBindMap = null, this._ownedBindGroups.forEach((s) => {
      s.destroy();
    }), this._ownedBindGroups = null, this.resources = null, this.groups = null, this._overrides = null);
  }
  static from(e) {
    const { gpu: t, gl: n, ...s } = e;
    let o, r;
    return t && (o = ba.from(t)), n && (r = Xl.from(n)), new lo({
      gpuProgram: o,
      glProgram: r,
      ...s
    });
  }
}
const KY = {
  normal: 0,
  add: 1,
  multiply: 2,
  screen: 3,
  overlay: 4,
  erase: 5,
  "normal-npm": 6,
  "add-npm": 7,
  "screen-npm": 8,
  min: 9,
  max: 10
}, WS = {
  BLEND: 0,
  OFFSET: 1,
  CULLING: 2,
  DEPTH_TEST: 3,
  WINDING: 4,
  DEPTH_MASK: 5
}, { BLEND: Eg, OFFSET: Rg, CULLING: zg, DEPTH_TEST: $g, WINDING: Dg, DEPTH_MASK: Og } = WS, Wv = class qS {
  constructor() {
    this.data = 0, this.blendMode = "normal", this.polygonOffset = 0, this.blend = !0, this.depthMask = !0;
  }
  /**
   * Activates blending of the computed fragment color values.
   * @default true
   */
  get blend() {
    return !!(this.data & 1 << Eg);
  }
  set blend(e) {
    !!(this.data & 1 << Eg) !== e && (this.data ^= 1 << Eg);
  }
  /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */
  get offsets() {
    return !!(this.data & 1 << Rg);
  }
  set offsets(e) {
    !!(this.data & 1 << Rg) !== e && (this.data ^= 1 << Rg);
  }
  /** The culling settings for this state none - No culling back - Back face culling front - Front face culling */
  set cullMode(e) {
    if (e === "none") {
      this.culling = !1;
      return;
    }
    this.culling = !0, this.clockwiseFrontFace = e === "front";
  }
  get cullMode() {
    return this.culling ? this.clockwiseFrontFace ? "front" : "back" : "none";
  }
  /**
   * Activates culling of polygons.
   * @default false
   */
  get culling() {
    return !!(this.data & 1 << zg);
  }
  set culling(e) {
    !!(this.data & 1 << zg) !== e && (this.data ^= 1 << zg);
  }
  /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */
  get depthTest() {
    return !!(this.data & 1 << $g);
  }
  set depthTest(e) {
    !!(this.data & 1 << $g) !== e && (this.data ^= 1 << $g);
  }
  /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */
  get depthMask() {
    return !!(this.data & 1 << Og);
  }
  set depthMask(e) {
    !!(this.data & 1 << Og) !== e && (this.data ^= 1 << Og);
  }
  /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */
  get clockwiseFrontFace() {
    return !!(this.data & 1 << Dg);
  }
  set clockwiseFrontFace(e) {
    !!(this.data & 1 << Dg) !== e && (this.data ^= 1 << Dg);
  }
  /**
   * The blend mode to be applied when this state is set. Apply a value of `normal` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default 'normal'
   */
  get blendMode() {
    return this._blendMode;
  }
  set blendMode(e) {
    this.blend = e !== "none", this._blendMode = e, this._blendModeId = KY[e] || 0;
  }
  /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */
  get polygonOffset() {
    return this._polygonOffset;
  }
  set polygonOffset(e) {
    this.offsets = !!e, this._polygonOffset = e;
  }
  toString() {
    return `[pixi.js/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
  }
  /**
   * A quickly getting an instance of a State that is configured for 2d rendering.
   * @returns a new State with values set for 2d rendering
   */
  static for2d() {
    const e = new qS();
    return e.depthTest = !1, e.depthMask = !1, e.blend = !0, e;
  }
};
Wv.default2d = Wv.for2d();
let co = Wv;
const KS = class qv extends lo {
  /**
   * @param options - The optional parameters of this filter.
   */
  constructor(e) {
    e = { ...qv.defaultOptions, ...e }, super(e), this.enabled = !0, this._state = co.for2d(), this.blendMode = e.blendMode, this.padding = e.padding, typeof e.antialias == "boolean" ? this.antialias = e.antialias ? "on" : "off" : this.antialias = e.antialias, this.resolution = e.resolution, this.blendRequired = e.blendRequired, this.clipToViewport = e.clipToViewport, this.addResource("uTexture", 0, 1), e.blendRequired && this.addResource("uBackTexture", 0, 3);
  }
  /**
   * Applies the filter
   * @param filterManager - The renderer to retrieve the filter from
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it
   */
  apply(e, t, n, s) {
    e.applyFilter(this, t, n, s);
  }
  /**
   * Get the blend mode of the filter.
   * @default "normal"
   */
  get blendMode() {
    return this._state.blendMode;
  }
  /** Sets the blend mode of the filter. */
  set blendMode(e) {
    this._state.blendMode = e;
  }
  /**
   * A short hand function to create a filter based of a vertex and fragment shader src.
   * @param options
   * @returns A shiny new PixiJS filter!
   */
  static from(e) {
    const { gpu: t, gl: n, ...s } = e;
    let o, r;
    return t && (o = ba.from(t)), n && (r = Xl.from(n)), new qv({
      gpuProgram: o,
      glProgram: r,
      ...s
    });
  }
};
KS.defaultOptions = {
  blendMode: "normal",
  resolution: 1,
  padding: 0,
  antialias: "off",
  blendRequired: !1,
  clipToViewport: !0
};
let YS = KS;
const Kv = [];
ht.handleByNamedList(Ie.Environment, Kv);
async function YY(i) {
  if (!i)
    for (let e = 0; e < Kv.length; e++) {
      const t = Kv[e];
      if (t.value.test()) {
        await t.value.load();
        return;
      }
    }
}
let md;
function XS() {
  if (typeof md == "boolean")
    return md;
  try {
    md = new Function("param1", "param2", "param3", "return param1[param2] === param3;")({ a: "b" }, "a", "b") === !0;
  } catch {
    md = !1;
  }
  return md;
}
const Wc = /* @__PURE__ */ new Set();
let Yv = !1;
function qk(i, e, t = 2) {
  const n = e && e.length, s = n ? e[0] * t : i.length;
  Wc.size && Wc.clear();
  let o = JS(i, 0, s, t, !0);
  const r = [];
  if (!o || o.next === o.prev) return r;
  let a = 0, l = 0, d = 0;
  if (n && (o = eX(i, e, o, t)), i.length > 80 * t) {
    a = i[0], l = i[1];
    let c = a, h = l;
    for (let f = t; f < s; f += t) {
      const p = i[f], y = i[f + 1];
      p < a && (a = p), y < l && (l = y), p > c && (c = p), y > h && (h = y);
    }
    d = Math.max(c - a, h - l), d = d !== 0 ? 32767 / d : 0;
  }
  return Xv(o, r, a, l, d), r;
}
function JS(i, e, t, n, s) {
  let o = null;
  if (s === pX(i, e, t, n) > 0)
    for (let r = e; r < t; r += n) o = Xk(r / n | 0, i[r], i[r + 1], o);
  else
    for (let r = t - n; r >= e; r -= n) o = Xk(r / n | 0, i[r], i[r + 1], o);
  return o && qc(o, o.next) && (Yc(o), o = o.next), o;
}
function ua(i, e = i) {
  const t = e === i;
  let n = i, s;
  do
    s = !1, n !== n.next && (Wc.size === 0 || !Wc.has(n)) && (qc(n, n.next) || xn(n.prev, n, n.next) === 0) ? ((t || n === e) && (e = n.prev), Yv = !0, Yc(n), n = n.prev, s = !0) : (t || n !== e) && (n = n.next, s = !t);
  while (s || n !== e);
  return e;
}
function Xv(i, e, t, n, s) {
  s && aX(i, t, n, s);
  let o = i, r = !1;
  for (; i.prev !== i.next; ) {
    const a = i.prev, l = i.next;
    if (xn(a, i, l) < 0 && (s ? JY(i, t, n, s) : XY(i))) {
      e.push(a.i, i.i, l.i), Yc(i), i = l, o = l;
      continue;
    }
    if (i = l, i === o) {
      if (Yv = !1, i = ua(i), Yv) {
        o = i;
        continue;
      }
      if (!r) {
        i = ZY(i, e), o = i, r = !0;
        continue;
      }
      QY(i, e, t, n, s);
      break;
    }
  }
}
function XY(i) {
  const e = i.prev, t = i, n = i.next, s = e.x, o = t.x, r = n.x, a = e.y, l = t.y, d = n.y, c = Math.min(s, o, r), h = Math.min(a, l, d), f = Math.max(s, o, r), p = Math.max(a, l, d);
  let y = n.next;
  for (; y !== e; ) {
    if (y.x >= c && y.x <= f && y.y >= h && y.y <= p && !(s === y.x && a === y.y) && mf(s, a, o, l, r, d, y.x, y.y) && xn(y.prev, y, y.next) >= 0) return !1;
    y = y.next;
  }
  return !0;
}
function JY(i, e, t, n) {
  const s = i.prev, o = i, r = i.next, a = s.x, l = o.x, d = r.x, c = s.y, h = o.y, f = r.y, p = Math.min(a, l, d), y = Math.min(c, h, f), v = Math.max(a, l, d), x = Math.max(c, h, f), w = e0(p, y, e, t, n), S = e0(v, x, e, t, n);
  let M = i.prevZ;
  for (; M && M.z >= w; ) {
    if (M.x >= p && M.x <= v && M.y >= y && M.y <= x && M !== r && !(a === M.x && c === M.y) && mf(a, c, l, h, d, f, M.x, M.y) && xn(M.prev, M, M.next) >= 0) return !1;
    M = M.prevZ;
  }
  let _ = i.nextZ;
  for (; _ && _.z <= S; ) {
    if (_.x >= p && _.x <= v && _.y >= y && _.y <= x && _ !== r && !(a === _.x && c === _.y) && mf(a, c, l, h, d, f, _.x, _.y) && xn(_.prev, _, _.next) >= 0) return !1;
    _ = _.nextZ;
  }
  return !0;
}
function ZY(i, e) {
  let t = i, n = !1;
  do {
    const s = t.prev, o = t.next.next;
    eM(s, t, t.next, o, !1) && Kc(s, o) && Kc(o, s) && (e.push(s.i, t.i, o.i), Yc(t), Yc(t.next), t = i = o, n = !0), t = t.next;
  } while (t !== i);
  return n ? ua(t) : t;
}
function QY(i, e, t, n, s) {
  let o = i;
  do {
    let r = o.next.next;
    for (; r !== o.prev; ) {
      if (o.i !== r.i && cX(o, r)) {
        let a = tM(o, r);
        o = ua(o, o.next), a = ua(a, a.next), Xv(o, e, t, n, s), Xv(a, e, t, n, s);
        return;
      }
      r = r.next;
    }
    o = o.next;
  } while (o !== i);
}
let Jv = !1;
function eX(i, e, t, n) {
  const s = [];
  for (let o = 0, r = e.length; o < r; o++) {
    const a = e[o] * n, l = o < r - 1 ? e[o + 1] * n : i.length, d = (
      /** @type {Node} */
      JS(i, a, l, n, !1)
    );
    d === d.next && Wc.add(d), s.push(dX(d));
  }
  s.sort(tX), iX(i.length / n, e.length), QS(t, t), Jv = !0;
  for (let o = 0; o < s.length; o++)
    t = nX(s[o], t);
  return Jv = !1, ua(t);
}
function tX(i, e) {
  return i.x - e.x || i.y - e.y || (i.next.y - i.y) / (i.next.x - i.x) - (e.next.y - e.y) / (e.next.x - e.x);
}
function nX(i, e) {
  const t = oX(i, e);
  if (!t)
    return e;
  const n = tM(t, i), s = n.next;
  return QS(t, s.next), ua(n, n.next), ua(t, t.next);
}
const ZS = 16;
let cn = new Float64Array(0), ff = 0;
const Zv = [], Qv = [];
function iX(i, e) {
  const t = Math.ceil((i + 2 * e) / ZS) + e + 2;
  cn.length < t * 4 && (cn = new Float64Array(t * 4)), ff = 0;
}
function QS(i, e) {
  let t = i;
  do {
    const n = ff++;
    Zv[n] = t;
    let s = t.x, o = t.y, r = t.x, a = t.y, l = 0;
    do {
      const c = t.next;
      t.z = n, c.x < s && (s = c.x), c.x > r && (r = c.x), c.y < o && (o = c.y), c.y > a && (a = c.y), t = c;
    } while (++l < ZS && t !== e);
    Qv[n] = t;
    const d = n * 4;
    cn[d] = s, cn[d + 1] = o, cn[d + 2] = r, cn[d + 3] = a;
  } while (t !== e);
}
function sX(i, e) {
  const t = i.z * 4;
  e.x < cn[t] && (cn[t] = e.x), e.y < cn[t + 1] && (cn[t + 1] = e.y), e.x > cn[t + 2] && (cn[t + 2] = e.x), e.y > cn[t + 3] && (cn[t + 3] = e.y);
}
function Kk(i) {
  let e = Qv[i];
  for (; e.prev.next !== e; ) e = e.next;
  return Qv[i] = e, e;
}
function Yk(i) {
  let e = Zv[i];
  for (; e.prev.next !== e; ) e = e.next;
  return Zv[i] = e, e;
}
function oX(i, e) {
  let t = e;
  const n = i.x, s = i.y;
  let o = -1 / 0, r;
  if (qc(i, t)) return t;
  for (let f = 0, p = 0; f < ff; f++, p += 4) {
    if (s < cn[p + 1] || s > cn[p + 3] || cn[p] > n || cn[p + 2] <= o) continue;
    const y = Kk(f);
    t = Yk(f);
    do {
      if (t.prev.next === t) {
        if (qc(i, t.next)) return t.next;
        if (s <= t.y && s >= t.next.y && t.next.y !== t.y) {
          const v = t.x + (s - t.y) * (t.next.x - t.x) / (t.next.y - t.y);
          if (v <= n && v > o && (o = v, r = t.x < t.next.x ? t : t.next, v === n))
            return r;
        }
      }
      t = t.next;
    } while (t !== y);
  }
  if (!r) return null;
  const a = r.x, l = r.y, d = Math.min(s, l), c = Math.max(s, l);
  let h = 1 / 0;
  for (let f = 0, p = 0; f < ff; f++, p += 4) {
    if (cn[p + 2] < a || cn[p] > n || cn[p + 3] < d || cn[p + 1] > c) continue;
    const y = Kk(f);
    t = Yk(f);
    do {
      if (t.prev.next === t && n >= t.x && t.x >= a && n !== t.x && // skip dead nodes
      mf(s < l ? n : o, s, a, l, s < l ? o : n, s, t.x, t.y)) {
        const v = Math.abs(s - t.y) / (n - t.x);
        (Kc(t, i) || t.y === s && t.next.y === s && t.next.x > n) && (v < h || v === h && (t.x > r.x || t.x === r.x && rX(r, t))) && (r = t, h = v);
      }
      t = t.next;
    } while (t !== y);
  }
  return r;
}
function rX(i, e) {
  return xn(i.prev, i, e.prev) < 0 && xn(e.next, i, i.next) < 0;
}
const Mi = [];
let el = [], vr = new Uint32Array(0), gd = new Uint32Array(0);
const bd = new Uint32Array(256);
function aX(i, e, t, n) {
  let s = i, o = 0;
  do
    s.z = e0(s.x, s.y, e, t, n), Mi[o++] = s, s = s.next;
  while (s !== i);
  lX(o);
  let r = null;
  for (let a = 0; a < o; a++) {
    const l = Mi[a];
    l.prevZ = r, r && (r.nextZ = l), r = l;
  }
  r.nextZ = null, Mi.fill(
    /** @type {Node} */
    /** @type {unknown} */
    null,
    0,
    o
  ), el.fill(
    /** @type {Node} */
    /** @type {unknown} */
    null,
    0,
    o
  );
}
function lX(i) {
  if (i <= 32) {
    for (let e = 1; e < i; e++) {
      const t = Mi[e], n = t.z;
      let s = e - 1;
      for (; s >= 0 && Mi[s].z > n; )
        Mi[s + 1] = Mi[s], s--;
      Mi[s + 1] = t;
    }
    return;
  }
  vr.length < i && (vr = new Uint32Array(i), gd = new Uint32Array(i), el = new Array(i));
  for (let e = 0; e < i; e++) vr[e] = Mi[e].z;
  lh(i, Mi, vr, el, gd, 0), lh(i, el, gd, Mi, vr, 8), lh(i, Mi, vr, el, gd, 16), lh(i, el, gd, Mi, vr, 24);
}
function lh(i, e, t, n, s, o) {
  bd.fill(0);
  for (let a = 0; a < i; a++) bd[t[a] >>> o & 255]++;
  let r = 0;
  for (let a = 0; a < 256; a++) {
    const l = bd[a];
    bd[a] = r, r += l;
  }
  for (let a = 0; a < i; a++) {
    const l = t[a], d = bd[l >>> o & 255]++;
    n[d] = e[a], s[d] = l;
  }
}
function e0(i, e, t, n, s) {
  return i = (i - t) * s | 0, e = (e - n) * s | 0, i = (i | i << 8) & 16711935, i = (i | i << 4) & 252645135, i = (i | i << 2) & 858993459, i = (i | i << 1) & 1431655765, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, i | e << 1;
}
function dX(i) {
  let e = i, t = i;
  do
    (e.x < t.x || e.x === t.x && e.y < t.y) && (t = e), e = e.next;
  while (e !== i);
  return t;
}
function mf(i, e, t, n, s, o, r, a) {
  return (s - r) * (e - a) >= (i - r) * (o - a) && (i - r) * (n - a) >= (t - r) * (e - a) && (t - r) * (o - a) >= (s - r) * (n - a);
}
function cX(i, e) {
  const t = qc(i, e) && xn(i.prev, i, i.next) > 0 && xn(e.prev, e, e.next) > 0;
  return i.next.i !== e.i && (t || Kc(i, e) && Kc(e, i) && // // locally visible
  (xn(i.prev, i, e.prev) !== 0 || xn(i, e.prev, e) !== 0)) && // no opposite-facing sectors
  !uX(i, e) && (t || hX(i, e));
}
function xn(i, e, t) {
  return (e.y - i.y) * (t.x - e.x) - (e.x - i.x) * (t.y - e.y);
}
function qc(i, e) {
  return i.x === e.x && i.y === e.y;
}
function eM(i, e, t, n, s = !0) {
  const o = xn(i, e, t), r = xn(i, e, n), a = xn(t, n, i), l = xn(t, n, e);
  return (o > 0 && r < 0 || o < 0 && r > 0) && (a > 0 && l < 0 || a < 0 && l > 0) ? !0 : s ? !!(o === 0 && dh(i, t, e) || r === 0 && dh(i, n, e) || a === 0 && dh(t, i, n) || l === 0 && dh(t, e, n)) : !1;
}
function dh(i, e, t) {
  return e.x <= Math.max(i.x, t.x) && e.x >= Math.min(i.x, t.x) && e.y <= Math.max(i.y, t.y) && e.y >= Math.min(i.y, t.y);
}
function uX(i, e) {
  const t = Math.min(i.x, e.x), n = Math.max(i.x, e.x), s = Math.min(i.y, e.y), o = Math.max(i.y, e.y);
  let r = i;
  do {
    const a = r.next;
    if (r.x > n && a.x > n || r.x < t && a.x < t || r.y > o && a.y > o || r.y < s && a.y < s) {
      r = a;
      continue;
    }
    if (r.i !== i.i && a.i !== i.i && r.i !== e.i && a.i !== e.i && eM(r, a, i, e)) return !0;
    r = a;
  } while (r !== i);
  return !1;
}
function Kc(i, e) {
  return xn(i.prev, i, i.next) < 0 ? xn(i, e, i.next) >= 0 && xn(i, i.prev, e) >= 0 : xn(i, e, i.prev) < 0 || xn(i, i.next, e) < 0;
}
function hX(i, e) {
  let t = i, n = !1;
  const s = (i.x + e.x) / 2, o = (i.y + e.y) / 2;
  do {
    const r = t.next;
    t.y > o != r.y > o && s < (r.x - t.x) * (o - t.y) / (r.y - t.y) + t.x && (n = !n), t = r;
  } while (t !== i);
  return n;
}
function tM(i, e) {
  const t = t0(i.i, i.x, i.y), n = t0(e.i, e.x, e.y), s = i.next, o = e.prev;
  return i.next = e, e.prev = i, t.next = s, s.prev = t, n.next = t, t.prev = n, o.next = n, n.prev = o, n;
}
function Xk(i, e, t, n) {
  const s = t0(i, e, t);
  return n ? (s.next = n.next, s.prev = n, n.next.prev = s, n.next = s) : (s.prev = s, s.next = s), s;
}
function Yc(i) {
  i.next.prev = i.prev, i.prev.next = i.next, i.prevZ && (i.prevZ.nextZ = i.nextZ), i.nextZ && (i.nextZ.prevZ = i.prevZ), Jv && sX(i.prev, i.next);
}
function t0(i, e, t) {
  return (
    /** @type {Node} */
    /** @type {unknown} */
    {
      i,
      // vertex index in coordinates array
      x: e,
      y: t,
      // vertex coordinates
      prev: null,
      // previous and next vertex nodes in a polygon ring
      next: null,
      z: 0,
      // z-order curve value; doubles as owning block in the hole-bridge index during eliminateHoles
      prevZ: null,
      // previous and next nodes in z-order
      nextZ: null
    }
  );
}
function pX(i, e, t, n) {
  let s = 0;
  for (let o = e, r = t - n; o < t; o += n)
    s += (i[r] - i[o]) * (i[o + 1] + i[r + 1]), r = o;
  return s;
}
const fX = qk.default || qk;
var Mn = /* @__PURE__ */ ((i) => (i[i.NONE = 0] = "NONE", i[i.COLOR = 16384] = "COLOR", i[i.STENCIL = 1024] = "STENCIL", i[i.DEPTH = 256] = "DEPTH", i[i.COLOR_DEPTH = 16640] = "COLOR_DEPTH", i[i.COLOR_STENCIL = 17408] = "COLOR_STENCIL", i[i.DEPTH_STENCIL = 1280] = "DEPTH_STENCIL", i[i.ALL = 17664] = "ALL", i))(Mn || {});
class nM {
  /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */
  constructor(e) {
    this.items = [], this._name = e;
  }
  /* jsdoc/check-param-names */
  /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */
  /* jsdoc/check-param-names */
  emit(e, t, n, s, o, r, a, l) {
    const { name: d, items: c } = this;
    for (let h = 0, f = c.length; h < f; h++)
      c[h][d](e, t, n, s, o, r, a, l);
    return this;
  }
  /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```ts
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */
  add(e) {
    return e[this._name] && (this.remove(e), this.items.push(e)), this;
  }
  /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */
  remove(e) {
    const t = this.items.indexOf(e);
    return t !== -1 && this.items.splice(t, 1), this;
  }
  /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */
  contains(e) {
    return this.items.indexOf(e) !== -1;
  }
  /** Remove all listeners from the Runner */
  removeAll() {
    return this.items.length = 0, this;
  }
  /** Remove all references, don't use after this. */
  destroy() {
    this.removeAll(), this.items = null, this._name = null;
  }
  /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */
  get empty() {
    return this.items.length === 0;
  }
  /**
   * The name of the runner.
   * @readonly
   */
  get name() {
    return this._name;
  }
}
const mX = [
  "init",
  "destroy",
  "contextChange",
  "resolutionChange",
  "resetState",
  "renderEnd",
  "renderStart",
  "render",
  "update",
  "postrender",
  "prerender"
], iM = class sM extends bi {
  /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */
  constructor(e) {
    var n;
    super(), this.tick = 0, this.uid = Nt("renderer"), this.runners = /* @__PURE__ */ Object.create(null), this.renderPipes = /* @__PURE__ */ Object.create(null), this._initOptions = {}, this._systemsHash = /* @__PURE__ */ Object.create(null), this.type = e.type, this.name = e.name, this.config = e;
    const t = [...mX, ...(n = this.config.runners) != null ? n : []];
    this._addRunners(...t), this._unsafeEvalCheck();
  }
  /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */
  async init(e = {}) {
    const t = e.skipExtensionImports === !0 ? !0 : e.manageImports === !1;
    await YY(t), !t && this.config.loaders && await Promise.all(this.config.loaders.map((n) => n.value.load())), this._addSystems(this.config.systems), this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
    for (const n in this._systemsHash)
      e = { ...this._systemsHash[n].constructor.defaultOptions, ...e };
    e = { ...sM.defaultOptions, ...e }, this._roundPixels = e.roundPixels ? 1 : 0;
    for (let n = 0; n < this.runners.init.items.length; n++)
      await this.runners.init.items[n].init(e);
    this._initOptions = e;
  }
  render(e, t) {
    var s, o;
    this.tick++;
    let n = e;
    if (n instanceof mn && (n = { container: n }, t && (rt(dn, "passing a second argument is deprecated, please use render options instead"), n.target = t.renderTexture)), n.target || (n.target = this.view.renderTarget), n.target === this.view.renderTarget && (this._lastObjectRendered = n.container, (s = n.clearColor) != null || (n.clearColor = this.background.colorRgba), (o = n.clear) != null || (n.clear = this.background.clearBeforeRender)), n.clearColor) {
      const r = Array.isArray(n.clearColor) && n.clearColor.length === 4;
      n.clearColor = r ? n.clearColor : bn.shared.setValue(n.clearColor).toArray();
    }
    n.transform || (n.container.updateLocalTransform(), n.transform = n.container.localTransform), n.container.visible && (n.container.enableRenderGroup(), this.runners.prerender.emit(n), this.runners.renderStart.emit(n), this.runners.render.emit(n), this.runners.renderEnd.emit(n), this.runners.postrender.emit(n));
  }
  /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */
  resize(e, t, n) {
    const s = this.view.resolution;
    this.view.resize(e, t, n), this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution), n !== void 0 && n !== s && this.runners.resolutionChange.emit(n);
  }
  /**
   * Clears the render target.
   * @param options - The options to use when clearing the render target.
   * @param options.target - The render target to clear.
   * @param options.clearColor - The color to clear with.
   * @param options.clear - The clear mode to use.
   * @advanced
   */
  clear(e = {}) {
    var l;
    const t = this;
    e.target || (e.target = t.renderTarget.renderTarget), e.clearColor || (e.clearColor = this.background.colorRgba), (l = e.clear) != null || (e.clear = Mn.ALL);
    const { clear: n, clearColor: s, target: o, mipLevel: r, layer: a } = e;
    bn.shared.setValue(s != null ? s : this.background.colorRgba), t.renderTarget.clear(o, n, bn.shared.toArray(), r != null ? r : 0, a != null ? a : 0);
  }
  /** The resolution / device pixel ratio of the renderer. */
  get resolution() {
    return this.view.resolution;
  }
  set resolution(e) {
    this.view.resolution = e, this.runners.resolutionChange.emit(e);
  }
  /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @type {number}
   * @readonly
   * @default 800
   */
  get width() {
    return this.view.texture.frame.width;
  }
  /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */
  get height() {
    return this.view.texture.frame.height;
  }
  // NOTE: this was `view` in v7
  /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */
  get canvas() {
    return this.view.canvas;
  }
  /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */
  get lastObjectRendered() {
    return this._lastObjectRendered;
  }
  /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */
  get renderingToScreen() {
    return this.renderTarget.renderingToScreen;
  }
  /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */
  get screen() {
    return this.view.screen;
  }
  /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */
  _addRunners(...e) {
    e.forEach((t) => {
      this.runners[t] = new nM(t);
    });
  }
  _addSystems(e) {
    let t;
    for (t in e) {
      const n = e[t];
      this._addSystem(n.value, n.name);
    }
  }
  /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */
  _addSystem(e, t) {
    const n = new e(this);
    if (this[t])
      throw new Error(`Whoops! The name "${t}" is already in use`);
    this[t] = n, this._systemsHash[t] = n;
    for (const s in this.runners)
      this.runners[s].add(n);
    return this;
  }
  _addPipes(e, t) {
    const n = t.reduce((s, o) => (s[o.name] = o.value, s), {});
    e.forEach((s) => {
      const o = s.value, r = s.name, a = n[r];
      this.renderPipes[r] = new o(
        this,
        a ? new a() : null
      ), this.runners.destroy.add(this.renderPipes[r]);
    });
  }
  destroy(e = !1) {
    this.runners.destroy.items.reverse(), this.runners.destroy.emit(e), (e === !0 || typeof e == "object" && e.releaseGlobalResources) && Yl.release(), Object.values(this.runners).forEach((t) => {
      t.destroy();
    }), this._systemsHash = null, this.renderPipes = null, this.removeAllListeners();
  }
  /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */
  generateTexture(e) {
    return this.textureGenerator.generateTexture(e);
  }
  /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */
  get roundPixels() {
    return !!this._roundPixels;
  }
  /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */
  _unsafeEvalCheck() {
    if (!XS())
      throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
  }
  /**
   * Resets the rendering state of the renderer.
   * This is useful when you want to use the WebGL context directly and need to ensure PixiJS's internal state
   * stays synchronized. When modifying the WebGL context state externally, calling this method before the next Pixi
   * render will reset all internal caches and ensure it executes correctly.
   *
   * This is particularly useful when combining PixiJS with other rendering engines like Three.js:
   * ```js
   * // Reset Three.js state
   * threeRenderer.resetState();
   *
   * // Render a Three.js scene
   * threeRenderer.render(threeScene, threeCamera);
   *
   * // Reset PixiJS state since Three.js modified the WebGL context
   * pixiRenderer.resetState();
   *
   * // Now render Pixi content
   * pixiRenderer.render(pixiScene);
   * ```
   * @advanced
   */
  resetState() {
    this.runners.resetState.emit();
  }
};
iM.defaultOptions = {
  /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */
  resolution: 1,
  /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */
  failIfMajorPerformanceCaveat: !1,
  /**
   * Should round pixels be forced when rendering?
   * @default false
   */
  roundPixels: !1
};
let wu = iM, ch;
function gX(i) {
  return ch !== void 0 || (ch = (() => {
    var t;
    const e = {
      stencil: !0,
      failIfMajorPerformanceCaveat: i != null ? i : wu.defaultOptions.failIfMajorPerformanceCaveat
    };
    try {
      if (!zt.get().getWebGLRenderingContext())
        return !1;
      let s = zt.get().createCanvas().getContext("webgl", e);
      const o = !!((t = s == null ? void 0 : s.getContextAttributes()) != null && t.stencil);
      if (s) {
        const r = s.getExtension("WEBGL_lose_context");
        r && r.loseContext();
      }
      return s = null, o;
    } catch {
      return !1;
    }
  })()), ch;
}
let uh;
async function bX(i = {}) {
  return uh !== void 0 || (uh = await (async () => {
    const e = zt.get().getNavigator().gpu;
    if (!e)
      return !1;
    try {
      return await (await e.requestAdapter(i)).requestDevice(), !0;
    } catch {
      return !1;
    }
  })()), uh;
}
const Jk = ["webgl", "webgpu", "canvas"];
async function vX(i) {
  var o;
  let e = [];
  i.preference ? Array.isArray(i.preference) ? e = i.preference.slice() : (e.push(i.preference), Jk.forEach((r) => {
    r !== i.preference && e.push(r);
  })) : e = Jk.slice();
  let t, n = {};
  for (let r = 0; r < e.length; r++) {
    const a = e[r];
    if (a === "webgpu" && await bX()) {
      const { WebGPURenderer: l } = await Promise.resolve().then(() => Jee);
      t = l, n = { ...i, ...i.webgpu };
      break;
    } else if (a === "webgl" && gX(
      (o = i.failIfMajorPerformanceCaveat) != null ? o : wu.defaultOptions.failIfMajorPerformanceCaveat
    )) {
      const { WebGLRenderer: l } = await Promise.resolve().then(() => vee);
      t = l, n = { ...i, ...i.webgl };
      break;
    } else if (a === "canvas") {
      const { CanvasRenderer: l } = await Promise.resolve().then(() => bQ);
      t = l, n = { ...i, ...i.canvasOptions };
      break;
    }
  }
  if (delete n.webgpu, delete n.webgl, delete n.canvasOptions, !t)
    throw new Error("No available renderer for the current environment");
  const s = new t();
  return await s.init(n), s;
}
const gf = "8.22.0";
class oM {
  static init() {
    var e;
    (e = globalThis.__PIXI_APP_INIT__) == null || e.call(globalThis, this, gf);
  }
  static destroy() {
  }
}
oM.extension = Ie.Application;
class rM {
  constructor(e) {
    this._renderer = e;
  }
  init() {
    var e;
    (e = globalThis.__PIXI_RENDERER_INIT__) == null || e.call(globalThis, this._renderer, gf);
  }
  destroy() {
    this._renderer = null;
  }
}
rM.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem
  ],
  name: "initHook",
  priority: -10
};
class aM {
  /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */
  static init(e) {
    Object.defineProperty(
      this,
      "resizeTo",
      {
        configurable: !0,
        set(t) {
          globalThis.removeEventListener("resize", this.queueResize), this._resizeTo = t, t && (globalThis.addEventListener("resize", this.queueResize), this.resize());
        },
        get() {
          return this._resizeTo;
        }
      }
    ), this.queueResize = () => {
      this._resizeTo && (this._cancelResize(), this._resizeId = requestAnimationFrame(() => this.resize()));
    }, this._cancelResize = () => {
      this._resizeId && (cancelAnimationFrame(this._resizeId), this._resizeId = null);
    }, this.resize = () => {
      if (!this._resizeTo)
        return;
      this._cancelResize();
      let t, n;
      if (this._resizeTo === globalThis.window)
        t = globalThis.innerWidth, n = globalThis.innerHeight;
      else {
        const { clientWidth: s, clientHeight: o } = this._resizeTo;
        t = s, n = o;
      }
      this.renderer.resize(t, n), this.render();
    }, this._resizeId = null, this._resizeTo = null, this.resizeTo = e.resizeTo || null;
  }
  /**
   * Clean up the ticker, scoped to application
   * @private
   */
  static destroy() {
    globalThis.removeEventListener("resize", this.queueResize), this._cancelResize(), this._cancelResize = null, this.queueResize = null, this.resizeTo = null, this.resize = null;
  }
}
aM.extension = Ie.Application;
class lM {
  /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */
  static init(e) {
    e = Object.assign({
      autoStart: !0,
      sharedTicker: !1
    }, e), Object.defineProperty(
      this,
      "ticker",
      {
        configurable: !0,
        set(t) {
          this._ticker && this._ticker.remove(this.render, this), this._ticker = t, t && t.add(this.render, this, Ol.LOW);
        },
        get() {
          return this._ticker;
        }
      }
    ), this.stop = () => {
      this._ticker.stop();
    }, this.start = () => {
      this._ticker.start();
    }, this._ticker = null, this.ticker = e.sharedTicker ? Oi.shared : new Oi(), e.autoStart && this.start();
  }
  /**
   * Clean up the ticker, scoped to application.
   * @private
   */
  static destroy() {
    if (this._ticker) {
      const e = this._ticker;
      this.ticker = null, e.destroy();
    }
  }
}
lM.extension = Ie.Application;
ht.add(aM);
ht.add(lM);
const dM = class n0 {
  constructor(...e) {
    this.stage = new mn(), e[0] !== void 0 && rt(dn, "Application constructor options are deprecated, please use Application.init() instead.");
  }
  /**
   * Initializes the PixiJS application with the specified options.
   *
   * This method must be called after creating a new Application instance.
   * @param options - Configuration options for the application and renderer
   * @returns A promise that resolves when initialization is complete
   * @example
   * ```js
   * const app = new Application();
   *
   * // Initialize with custom options
   * await app.init({
   *     width: 800,
   *     height: 600,
   *     backgroundColor: 0x1099bb,
   *     preference: 'webgl', // or 'webgpu'
   * });
   * ```
   */
  async init(e) {
    e = { ...e }, this.stage || (this.stage = new mn()), this.renderer = await vX(e), n0._plugins.forEach((t) => {
      t.init.call(this, e);
    });
  }
  /**
   * Renders the current stage to the screen.
   *
   * When using the default setup with {@link TickerPlugin} (enabled by default), you typically don't need to call
   * this method directly as rendering is handled automatically.
   *
   * Only use this method if you've disabled the {@link TickerPlugin} or need custom
   * render timing control.
   * @example
   * ```js
   * // Example 1: Default setup (TickerPlugin handles rendering)
   * const app = new Application();
   * await app.init();
   * // No need to call render() - TickerPlugin handles it
   *
   * // Example 2: Custom rendering loop (if TickerPlugin is disabled)
   * const app = new Application();
   * await app.init({ autoStart: false }); // Disable automatic rendering
   *
   * function animate() {
   *     app.render();
   *     requestAnimationFrame(animate);
   * }
   * animate();
   * ```
   */
  render() {
    this.renderer.render({ container: this.stage });
  }
  /**
   * Reference to the renderer's canvas element. This is the HTML element
   * that displays your application's graphics.
   * @readonly
   * @type {HTMLCanvasElement}
   * @example
   * ```js
   * // Create a new application
   * const app = new Application();
   * // Initialize the application
   * await app.init({...});
   * // Add canvas to the page
   * document.body.appendChild(app.canvas);
   *
   * // Access the canvas directly
   * console.log(app.canvas); // HTMLCanvasElement
   * ```
   */
  get canvas() {
    return this.renderer.canvas;
  }
  /**
   * Reference to the renderer's canvas element.
   * @type {HTMLCanvasElement}
   * @deprecated since 8.0.0
   * @see {@link Application#canvas}
   */
  get view() {
    return rt(dn, "Application.view is deprecated, please use Application.canvas instead."), this.renderer.canvas;
  }
  /**
   * Reference to the renderer's screen rectangle. This represents the visible area of your application.
   *
   * It's commonly used for:
   * - Setting filter areas for full-screen effects
   * - Defining hit areas for screen-wide interaction
   * - Determining the visible bounds of your application
   * @readonly
   * @example
   * ```js
   * // Use as filter area for a full-screen effect
   * const blurFilter = new BlurFilter();
   * sprite.filterArea = app.screen;
   *
   * // Use as hit area for screen-wide interaction
   * const screenSprite = new Sprite();
   * screenSprite.hitArea = app.screen;
   *
   * // Get screen dimensions
   * console.log(app.screen.width, app.screen.height);
   * ```
   * @see {@link Rectangle} For all available properties and methods
   */
  get screen() {
    return this.renderer.screen;
  }
  /**
   * Get the html div element that holds all DOM Container elements.
   * @readonly
   * @type {HTMLDivElement}
   */
  get domContainerRoot() {
    var e;
    return (e = this.renderer.renderPipes.dom) == null ? void 0 : e._domElement;
  }
  /**
   * Destroys the application and all of its resources.
   *
   * This method should be called when you want to completely
   * clean up the application and free all associated memory.
   * @param rendererDestroyOptions - Options for destroying the renderer:
   *  - `false` or `undefined`: Preserves the canvas element (default)
   *  - `true`: Removes the canvas element
   *  - `{ removeView: boolean }`: Object with removeView property to control canvas removal
   * @param options - Options for destroying the application:
   *  - `false` or `undefined`: Basic cleanup (default)
   *  - `true`: Complete cleanup including children
   *  - Detailed options object:
   *    - `children`: Remove children
   *    - `texture`: Destroy textures
   *    - `textureSource`: Destroy texture sources
   *    - `context`: Destroy WebGL context
   * @example
   * ```js
   * // Basic cleanup
   * app.destroy();
   *
   * // Remove canvas and do complete cleanup
   * app.destroy(true, true);
   *
   * // Remove canvas with explicit options
   * app.destroy({ removeView: true }, true);
   *
   * // Detailed cleanup with specific options
   * app.destroy(
   *     { removeView: true },
   *     {
   *         children: true,
   *         texture: true,
   *         textureSource: true,
   *         context: true
   *     }
   * );
   * ```
   * > [!WARNING] After calling destroy, the application instance should no longer be used.
   * > All properties will be null and further operations will throw errors.
   */
  destroy(e = !1, t = !1) {
    const n = n0._plugins.slice(0);
    n.reverse(), n.forEach((s) => {
      s.destroy.call(this);
    }), this.stage.destroy(t), this.stage = null, this.renderer.destroy(e), this.renderer = null;
  }
};
dM._plugins = [];
let cM = dM;
ht.handleByList(Ie.Application, cM._plugins);
ht.add(oM);
const Lg = {
  a: 7,
  c: 6,
  h: 1,
  l: 2,
  m: 2,
  q: 4,
  s: 4,
  t: 2,
  v: 1,
  z: 0
}, yX = /([astvzqmhlc])([^astvzqmhlc]*)/gi, xX = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
function wX(i) {
  const e = [];
  return i.replace(yX, (t, n, s) => {
    let o = n.toLowerCase(), r = n;
    const a = kX(s);
    for (o === "m" && a.length > 2 && (e.push([r, ...a.splice(0, 2)]), o = "l", r = r === "m" ? "l" : "L"); ; ) {
      if (a.length === Lg[o])
        return e.push([r, ...a]), "";
      if (a.length < Lg[o]) throw new Error("malformed path data");
      e.push([r, ...a.splice(0, Lg[o])]);
    }
  }), e;
}
function kX(i) {
  const e = i.match(xX);
  return e ? e.map(Number) : [];
}
function _X(i, e) {
  const t = wX(i), n = [];
  let s = null, o = 0, r = 0;
  for (let a = 0; a < t.length; a++) {
    const l = t[a], d = l[0], c = l;
    switch (d) {
      case "M":
        o = c[1], r = c[2], e.moveTo(o, r);
        break;
      case "m":
        o += c[1], r += c[2], e.moveTo(o, r);
        break;
      case "H":
        o = c[1], e.lineTo(o, r);
        break;
      case "h":
        o += c[1], e.lineTo(o, r);
        break;
      case "V":
        r = c[1], e.lineTo(o, r);
        break;
      case "v":
        r += c[1], e.lineTo(o, r);
        break;
      case "L":
        o = c[1], r = c[2], e.lineTo(o, r);
        break;
      case "l":
        o += c[1], r += c[2], e.lineTo(o, r);
        break;
      case "C":
        o = c[5], r = c[6], e.bezierCurveTo(
          c[1],
          c[2],
          // First control point
          c[3],
          c[4],
          // Second control point
          o,
          r
          // End point
        );
        break;
      case "c":
        e.bezierCurveTo(
          o + c[1],
          r + c[2],
          // First control point
          o + c[3],
          r + c[4],
          // Second control point
          o + c[5],
          r + c[6]
          // End point
        ), o += c[5], r += c[6];
        break;
      case "S":
        o = c[3], r = c[4], e.bezierCurveToShort(
          c[1],
          c[2],
          // Control point
          o,
          r
          // End point
        );
        break;
      case "s":
        e.bezierCurveToShort(
          o + c[1],
          r + c[2],
          // Control point
          o + c[3],
          r + c[4]
          // End point
        ), o += c[3], r += c[4];
        break;
      case "Q":
        o = c[3], r = c[4], e.quadraticCurveTo(
          c[1],
          c[2],
          // Control point
          o,
          r
          // End point
        );
        break;
      case "q":
        e.quadraticCurveTo(
          o + c[1],
          r + c[2],
          // Control point
          o + c[3],
          r + c[4]
          // End point
        ), o += c[3], r += c[4];
        break;
      case "T":
        o = c[1], r = c[2], e.quadraticCurveToShort(
          o,
          r
          // End point
        );
        break;
      case "t":
        o += c[1], r += c[2], e.quadraticCurveToShort(
          o,
          r
          // End point
        );
        break;
      case "A":
        o = c[6], r = c[7], e.arcToSvg(
          c[1],
          // rx
          c[2],
          // ry
          c[3],
          // x-axis-rotation
          c[4],
          // large-arc-flag
          c[5],
          // sweep-flag
          o,
          r
          // End point
        );
        break;
      case "a":
        o += c[6], r += c[7], e.arcToSvg(
          c[1],
          // rx
          c[2],
          // ry
          c[3],
          // x-axis-rotation
          c[4],
          // large-arc-flag
          c[5],
          // sweep-flag
          o,
          r
          // End point
        );
        break;
      case "Z":
      // Close Path
      case "z":
        e.closePath(), n.length > 0 && (s = n.pop(), s ? (o = s.startX, r = s.startY) : (o = 0, r = 0)), s = null;
        break;
      default:
        dt(`Unknown SVG path command: ${d}`);
    }
    d !== "Z" && d !== "z" && s === null && (s = { startX: o, startY: r }, n.push(s));
  }
  return e;
}
class ey {
  /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */
  constructor(e = 0, t = 0, n = 0) {
    this.type = "circle", this.x = e, this.y = t, this.radius = n;
  }
  /**
   * Creates a clone of this Circle instance.
   * @example
   * ```ts
   * // Basic circle cloning
   * const original = new Circle(100, 100, 50);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 75;
   *
   * // Verify independence
   * console.log(original.radius); // 50
   * console.log(modified.radius); // 75
   * ```
   * @returns A copy of the Circle
   * @see {@link Circle.copyFrom} For copying into existing circle
   * @see {@link Circle.copyTo} For copying to another circle
   */
  clone() {
    return new ey(this.x, this.y, this.radius);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this circle.
   *
   * Uses the distance formula to determine if a point is inside the circle's radius.
   *
   * Commonly used for hit testing in PixiJS events and graphics.
   * @example
   * ```ts
   * // Basic containment check
   * const circle = new Circle(100, 100, 50);
   * const isInside = circle.contains(120, 120);
   *
   * // Check mouse position
   * const circle = new Circle(0, 0, 100);
   * container.hitArea = circle;
   * container.on('pointermove', (e) => {
   *     // only called if pointer is within circle
   * });
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   * @see {@link Circle.strokeContains} For checking stroke intersection
   * @see {@link Circle.getBounds} For getting bounding box
   */
  contains(e, t) {
    if (this.radius <= 0) return !1;
    const n = this.radius * this.radius;
    let s = this.x - e, o = this.y - t;
    return s *= s, o *= o, s + o <= n;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this circle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const circle = new Circle(100, 100, 50);
   * const isOnStroke = circle.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = circle.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = circle.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = circle.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this Circle's stroke
   * @see {@link Circle.contains} For checking fill containment
   * @see {@link Circle.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, n, s = 0.5) {
    if (this.radius === 0) return !1;
    const o = this.x - e, r = this.y - t, a = this.radius, l = (1 - s) * n, d = Math.sqrt(o * o + r * r);
    return d <= a + l && d > a - (n - l);
  }
  /**
   * Returns the framing rectangle of the circle as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const circle = new Circle(100, 100, 50);
   * const bounds = circle.getBounds();
   * // bounds: x=50, y=50, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * circle.getBounds(rect);
   * ```
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Circle.contains} For point containment
   */
  getBounds(e) {
    return e || (e = new Tt()), e.x = this.x - this.radius, e.y = this.y - this.radius, e.width = this.radius * 2, e.height = this.radius * 2, e;
  }
  /**
   * Copies another circle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * target.copyFrom(source);
   * ```
   * @param circle - The circle to copy from
   * @returns Returns itself
   * @see {@link Circle.copyTo} For copying to another circle
   * @see {@link Circle.clone} For creating new circle copy
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.radius = e.radius, this;
  }
  /**
   * Copies this circle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * source.copyTo(target);
   * ```
   * @param circle - The circle to copy to
   * @returns Returns given parameter
   * @see {@link Circle.copyFrom} For copying from another circle
   * @see {@link Circle.clone} For creating new circle copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  toString() {
    return `[pixi.js/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
  }
}
class ty {
  /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */
  constructor(e = 0, t = 0, n = 0, s = 0) {
    this.type = "ellipse", this.x = e, this.y = t, this.halfWidth = n, this.halfHeight = s;
  }
  /**
   * Creates a clone of this Ellipse instance.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Ellipse(100, 100, 50, 25);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.halfWidth *= 2;
   * modified.halfHeight *= 2;
   *
   * // Verify independence
   * console.log(original.halfWidth);  // 50
   * console.log(modified.halfWidth);  // 100
   * ```
   * @returns A copy of the ellipse
   * @see {@link Ellipse.copyFrom} For copying into existing ellipse
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   */
  clone() {
    return new ty(this.x, this.y, this.halfWidth, this.halfHeight);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this ellipse.
   * Uses normalized coordinates and the ellipse equation to determine containment.
   * @example
   * ```ts
   * // Basic containment check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isInside = ellipse.contains(120, 110);
   * ```
   * @remarks
   * - Uses ellipse equation (x²/a² + y²/b² ≤ 1)
   * - Returns false if dimensions are 0 or negative
   * - Normalized to center (0,0) for calculation
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   * @see {@link Ellipse.strokeContains} For checking stroke intersection
   * @see {@link Ellipse.getBounds} For getting containing rectangle
   */
  contains(e, t) {
    if (this.halfWidth <= 0 || this.halfHeight <= 0)
      return !1;
    let n = (e - this.x) / this.halfWidth, s = (t - this.y) / this.halfHeight;
    return n *= n, s *= s, n + s <= 1;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this ellipse including stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isOnStroke = ellipse.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = ellipse.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = ellipse.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = ellipse.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @remarks
   * - Uses normalized ellipse equations
   * - Considers stroke alignment
   * - Returns false if dimensions are 0
   * - A stroke wider than the shape covers it entirely, leaving no unstroked interior
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coords are within this ellipse's stroke
   * @see {@link Ellipse.contains} For checking fill containment
   * @see {@link Ellipse.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, n, s = 0.5) {
    const { halfWidth: o, halfHeight: r } = this;
    if (o <= 0 || r <= 0)
      return !1;
    const a = n * (1 - s), l = n - a, d = o - l, c = r - l, h = o + a, f = r + a, p = e - this.x, y = t - this.y;
    return p * p / (h * h) + y * y / (f * f) > 1 ? !1 : d <= 0 || c <= 0 ? !0 : p * p / (d * d) + y * y / (c * c) > 1;
  }
  /**
   * Returns the framing rectangle of the ellipse as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const bounds = ellipse.getBounds();
   * // bounds: x=50, y=75, width=100, height=50
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * ellipse.getBounds(rect);
   * ```
   * @remarks
   * - Creates Rectangle if none provided
   * - Top-left is (x-halfWidth, y-halfHeight)
   * - Width is halfWidth * 2
   * - Height is halfHeight * 2
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Ellipse.contains} For checking if a point is inside
   */
  getBounds(e) {
    return e || (e = new Tt()), e.x = this.x - this.halfWidth, e.y = this.y - this.halfHeight, e.width = this.halfWidth * 2, e.height = this.halfHeight * 2, e;
  }
  /**
   * Copies another ellipse to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * target.copyFrom(source);
   * ```
   * @param ellipse - The ellipse to copy from
   * @returns Returns itself
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.halfWidth = e.halfWidth, this.halfHeight = e.halfHeight, this;
  }
  /**
   * Copies this ellipse to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * source.copyTo(target);
   * ```
   * @param ellipse - The ellipse to copy to
   * @returns Returns given parameter
   * @see {@link Ellipse.copyFrom} For copying from another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  toString() {
    return `[pixi.js/math:Ellipse x=${this.x} y=${this.y} halfWidth=${this.halfWidth} halfHeight=${this.halfHeight}]`;
  }
}
function uM(i) {
  const e = i.length;
  if (e < 6)
    return 1;
  let t = 0;
  for (let n = 0, s = i[e - 2], o = i[e - 1]; n < e; n += 2) {
    const r = i[n], a = i[n + 1];
    t += (r - s) * (a + o), s = r, o = a;
  }
  return t < 0 ? -1 : 1;
}
function SX(i, e, t, n, s, o) {
  const r = i - t, a = e - n, l = s - t, d = o - n, c = r * l + a * d, h = l * l + d * d;
  let f = -1;
  h !== 0 && (f = c / h);
  let p, y;
  f < 0 ? (p = t, y = n) : f > 1 ? (p = s, y = o) : (p = t + f * l, y = n + f * d);
  const v = i - p, x = e - y;
  return v * v + x * x;
}
let MX, TX;
class vc {
  /**
   * @param points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */
  constructor(...e) {
    this.type = "polygon";
    let t = Array.isArray(e[0]) ? e[0] : e;
    if (typeof t[0] != "number") {
      const n = [];
      for (let s = 0, o = t.length; s < o; s++)
        n.push(t[s].x, t[s].y);
      t = n;
    }
    this.points = t, this.closePath = !0;
  }
  /**
   * Determines whether the polygon's points are arranged in a clockwise direction.
   * Uses the shoelace formula (surveyor's formula) to calculate the signed area.
   *
   * A positive area indicates clockwise winding, while negative indicates counter-clockwise.
   *
   * The formula sums up the cross products of adjacent vertices:
   * For each pair of adjacent points (x1,y1) and (x2,y2), we calculate (x1*y2 - x2*y1)
   * The final sum divided by 2 gives the signed area - positive for clockwise.
   * @example
   * ```ts
   * // Check polygon winding
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * console.log(polygon.isClockwise()); // Check direction
   *
   * // Use in path construction
   * const hole = new Polygon([25, 25, 75, 25, 75, 75, 25, 75]);
   * if (hole.isClockwise() === shape.isClockwise()) {
   *     hole.points.reverse(); // Reverse for proper hole winding
   * }
   * ```
   * @returns `true` if the polygon's points are arranged clockwise, `false` if counter-clockwise
   */
  isClockwise() {
    let e = 0;
    const t = this.points, n = t.length;
    for (let s = 0; s < n; s += 2) {
      const o = t[s], r = t[s + 1], a = t[(s + 2) % n], l = t[(s + 3) % n];
      e += (a - o) * (l + r);
    }
    return e < 0;
  }
  /**
   * Checks if this polygon completely contains another polygon.
   * Used for detecting holes in shapes, like when parsing SVG paths.
   * @example
   * ```ts
   * // Basic containment check
   * const outerSquare = new Polygon([0,0, 100,0, 100,100, 0,100]); // A square
   * const innerSquare = new Polygon([25,25, 75,25, 75,75, 25,75]); // A smaller square inside
   *
   * outerSquare.containsPolygon(innerSquare); // Returns true
   * innerSquare.containsPolygon(outerSquare); // Returns false
   * ```
   * @remarks
   * - Uses bounds check for quick rejection
   * - Tests all points for containment
   * @param polygon - The polygon to test for containment
   * @returns True if this polygon completely contains the other polygon
   * @see {@link Polygon.contains} For single point testing
   * @see {@link Polygon.getBounds} For bounds calculation
   */
  containsPolygon(e) {
    const t = this.getBounds(MX), n = e.getBounds(TX);
    if (!t.containsRect(n))
      return !1;
    const s = e.points;
    for (let o = 0; o < s.length; o += 2) {
      const r = s[o], a = s[o + 1];
      if (!this.contains(r, a))
        return !1;
    }
    return !0;
  }
  /**
   * Creates a clone of this polygon.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Polygon([0, 0, 100, 0, 50, 100]);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.points[0] = 10; // Modify first x coordinate
   * ```
   * @returns A copy of the polygon
   * @see {@link Polygon.copyFrom} For copying into existing polygon
   * @see {@link Polygon.copyTo} For copying to another polygon
   */
  clone() {
    const e = this.points.slice(), t = new vc(e);
    return t.closePath = this.closePath, t;
  }
  /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * Uses raycasting algorithm for point-in-polygon testing.
   * @example
   * ```ts
   * // Basic containment check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isInside = polygon.contains(25, 25); // true
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this polygon
   * @see {@link Polygon.strokeContains} For checking stroke intersection
   * @see {@link Polygon.containsPolygon} For polygon-in-polygon testing
   */
  contains(e, t) {
    let n = !1;
    const s = this.points.length / 2;
    for (let o = 0, r = s - 1; o < s; r = o++) {
      const a = this.points[o * 2], l = this.points[o * 2 + 1], d = this.points[r * 2], c = this.points[r * 2 + 1];
      l > t != c > t && e < (d - a) * ((t - l) / (c - l)) + a && (n = !n);
    }
    return n;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this polygon including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isOnStroke = polygon.strokeContains(25, 25, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = polygon.strokeContains(25, 25, 4, 1);   // Inside
   * const centerStroke = polygon.strokeContains(25, 25, 4, 0.5); // Centered
   * const outerStroke = polygon.strokeContains(25, 25, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this polygon's stroke
   * @see {@link Polygon.contains} For checking fill containment
   * @see {@link Polygon.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, n, s = 0.5) {
    const { points: o } = this, r = s === 0.5 ? s : (s - 0.5) * uM(o) + 0.5, a = n * r, l = n - a, d = a * a, c = l * l, h = o.length - (this.closePath ? 0 : 2);
    for (let f = 0; f < h; f += 2) {
      const p = o[f], y = o[f + 1], v = o[(f + 2) % o.length], x = o[(f + 3) % o.length], w = SX(e, t, p, y, v, x), S = Math.sign((v - p) * (t - y) - (x - y) * (e - p));
      if (w <= (S < 0 ? d : c))
        return !0;
    }
    return !1;
  }
  /**
   * Returns the framing rectangle of the polygon as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const bounds = polygon.getBounds();
   * // bounds: x=0, y=0, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * polygon.getBounds(rect);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Polygon.contains} For checking if a point is inside
   */
  getBounds(e) {
    e || (e = new Tt());
    const t = this.points;
    let n = 1 / 0, s = -1 / 0, o = 1 / 0, r = -1 / 0;
    for (let a = 0, l = t.length; a < l; a += 2) {
      const d = t[a], c = t[a + 1];
      n = d < n ? d : n, s = d > s ? d : s, o = c < o ? c : o, r = c > r ? c : r;
    }
    return e.x = n, e.width = s - n, e.y = o, e.height = r - o, e;
  }
  /**
   * Copies another polygon to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * target.copyFrom(source);
   * ```
   * @param polygon - The polygon to copy from
   * @returns Returns itself
   * @see {@link Polygon.copyTo} For copying to another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */
  copyFrom(e) {
    return this.points = e.points.slice(), this.closePath = e.closePath, this;
  }
  /**
   * Copies this polygon to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * source.copyTo(target);
   * ```
   * @param polygon - The polygon to copy to
   * @returns Returns given parameter
   * @see {@link Polygon.copyFrom} For copying from another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  toString() {
    return `[pixi.js/math:PolygoncloseStroke=${this.closePath}points=${this.points.reduce((e, t) => `${e}, ${t}`, "")}]`;
  }
  /**
   * Get the last X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastX); // 300
   * ```
   * @readonly
   * @returns The x-coordinate of the last vertex
   * @see {@link Polygon.lastY} For last Y coordinate
   * @see {@link Polygon.points} For raw points array
   */
  get lastX() {
    return this.points[this.points.length - 2];
  }
  /**
   * Get the last Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastY); // 400
   * ```
   * @readonly
   * @returns The y-coordinate of the last vertex
   * @see {@link Polygon.lastX} For last X coordinate
   * @see {@link Polygon.points} For raw points array
   */
  get lastY() {
    return this.points[this.points.length - 1];
  }
  /**
   * Get the last X coordinate of the polygon.
   * @readonly
   * @deprecated since 8.11.0, use {@link Polygon.lastX} instead.
   */
  get x() {
    return rt("8.11.0", "Polygon.lastX is deprecated, please use Polygon.lastX instead."), this.points[this.points.length - 2];
  }
  /**
   * Get the last Y coordinate of the polygon.
   * @readonly
   * @deprecated since 8.11.0, use {@link Polygon.lastY} instead.
   */
  get y() {
    return rt("8.11.0", "Polygon.y is deprecated, please use Polygon.lastY instead."), this.points[this.points.length - 1];
  }
  /**
   * Get the first X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.x); // 0
   * ```
   * @readonly
   * @returns The x-coordinate of the first vertex
   * @see {@link Polygon.startY} For first Y coordinate
   * @see {@link Polygon.points} For raw points array
   */
  get startX() {
    return this.points[0];
  }
  /**
   * Get the first Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.y); // 0
   * ```
   * @readonly
   * @returns The y-coordinate of the first vertex
   * @see {@link Polygon.startX} For first X coordinate
   * @see {@link Polygon.points} For raw points array
   */
  get startY() {
    return this.points[1];
  }
}
const hh = (i, e, t, n, s, o, r) => {
  const a = i - t, l = e - n, d = Math.sqrt(a * a + l * l);
  return d >= s - o && d <= s + r;
};
class ny {
  /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */
  constructor(e = 0, t = 0, n = 0, s = 0, o = 20) {
    this.type = "roundedRectangle", this.x = e, this.y = t, this.width = n, this.height = s, this.radius = o;
  }
  /**
   * Returns the framing rectangle of the rounded rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds calculation
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const bounds = rect.getBounds();
   * // bounds: x=100, y=100, width=200, height=150
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @remarks
   * - Rectangle matches outer dimensions
   * - Ignores corner radius
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link RoundedRectangle.contains} For checking if a point is inside
   */
  getBounds(e) {
    return e || (e = new Tt()), e.x = this.x, e.y = this.y, e.width = this.width, e.height = this.height, e;
  }
  /**
   * Creates a clone of this Rounded Rectangle.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new RoundedRectangle(100, 100, 200, 150, 20);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 30;
   * modified.width *= 2;
   *
   * // Verify independence
   * console.log(original.radius);  // 20
   * console.log(modified.radius);  // 30
   * ```
   * @returns A copy of the rounded rectangle
   * @see {@link RoundedRectangle.copyFrom} For copying into existing rectangle
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   */
  clone() {
    return new ny(this.x, this.y, this.width, this.height, this.radius);
  }
  /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new RoundedRectangle()
   *     .copyFrom(source)
   *     .getBounds(rect);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.width = e.width, this.height = e.height, this.radius = e.radius, this;
  }
  /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new RoundedRectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link RoundedRectangle.copyFrom} For copying from another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isInside = rect.contains(150, 125); // true
   * // Check corner radius
   * const corner = rect.contains(100, 100); // false if within corner curve
   * ```
   * @remarks
   * - Returns false if width/height is 0 or negative
   * - Handles rounded corners with radius check
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rounded Rectangle
   * @see {@link RoundedRectangle.strokeContains} For checking stroke intersection
   * @see {@link RoundedRectangle.getBounds} For getting containing rectangle
   */
  contains(e, t) {
    if (this.width <= 0 || this.height <= 0)
      return !1;
    if (e >= this.x && e <= this.x + this.width && t >= this.y && t <= this.y + this.height) {
      const n = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
      if (t >= this.y + n && t <= this.y + this.height - n || e >= this.x + n && e <= this.x + this.width - n)
        return !0;
      let s = e - (this.x + n), o = t - (this.y + n);
      const r = n * n;
      if (s * s + o * o <= r || (s = e - (this.x + this.width - n), s * s + o * o <= r) || (o = t - (this.y + this.height - n), s * s + o * o <= r) || (s = e - (this.x + n), s * s + o * o <= r))
        return !0;
    }
    return !1;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param pX - The X coordinate of the point to test
   * @param pY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link RoundedRectangle.contains} For checking fill containment
   * @see {@link RoundedRectangle.getBounds} For getting stroke bounds
   */
  strokeContains(e, t, n, s = 0.5) {
    const { x: o, y: r, width: a, height: l, radius: d } = this, c = n * (1 - s), h = n - c, f = o + d, p = r + d, y = a - d * 2, v = l - d * 2, x = o + a, w = r + l;
    return (e >= o - c && e <= o + h || e >= x - h && e <= x + c) && t >= p && t <= p + v || (t >= r - c && t <= r + h || t >= w - h && t <= w + c) && e >= f && e <= f + y ? !0 : (
      // Top-left
      e < f && t < p && hh(
        e,
        t,
        f,
        p,
        d,
        h,
        c
      ) || e > x - d && t < p && hh(
        e,
        t,
        x - d,
        p,
        d,
        h,
        c
      ) || e > x - d && t > w - d && hh(
        e,
        t,
        x - d,
        w - d,
        d,
        h,
        c
      ) || e < f && t > w - d && hh(
        e,
        t,
        f,
        w - d,
        d,
        h,
        c
      )
    );
  }
  toString() {
    return `[pixi.js/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
  }
}
const hM = {};
function iy(i, e, t) {
  let n = 2166136261;
  for (let s = 0; s < e; s++)
    n ^= i[s].uid, n = Math.imul(n, 16777619), n >>>= 0;
  return hM[n] || CX(i, e, n, t);
}
function CX(i, e, t, n) {
  const s = {};
  let o = 0;
  for (let a = 0; a < n; a++) {
    const l = a < e ? i[a] : et.EMPTY.source;
    s[o++] = l.source, s[o++] = l.style;
  }
  const r = new qo(s);
  return hM[t] = r, r;
}
class Zk {
  constructor(e) {
    typeof e == "number" ? this.rawBinaryData = new ArrayBuffer(e) : e instanceof Uint8Array ? this.rawBinaryData = e.buffer : this.rawBinaryData = e, this.uint32View = new Uint32Array(this.rawBinaryData), this.float32View = new Float32Array(this.rawBinaryData), this.size = this.rawBinaryData.byteLength;
  }
  /** View on the raw binary data as a `Int8Array`. */
  get int8View() {
    return this._int8View || (this._int8View = new Int8Array(this.rawBinaryData)), this._int8View;
  }
  /** View on the raw binary data as a `Uint8Array`. */
  get uint8View() {
    return this._uint8View || (this._uint8View = new Uint8Array(this.rawBinaryData)), this._uint8View;
  }
  /**  View on the raw binary data as a `Int16Array`. */
  get int16View() {
    return this._int16View || (this._int16View = new Int16Array(this.rawBinaryData)), this._int16View;
  }
  /** View on the raw binary data as a `Int32Array`. */
  get int32View() {
    return this._int32View || (this._int32View = new Int32Array(this.rawBinaryData)), this._int32View;
  }
  /** View on the raw binary data as a `Float64Array`. */
  get float64View() {
    return this._float64Array || (this._float64Array = new Float64Array(this.rawBinaryData)), this._float64Array;
  }
  /** View on the raw binary data as a `BigUint64Array`. */
  get bigUint64View() {
    return this._bigUint64Array || (this._bigUint64Array = new BigUint64Array(this.rawBinaryData)), this._bigUint64Array;
  }
  /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */
  view(e) {
    return this[`${e}View`];
  }
  /** Destroys all buffer references. Do not use after calling this. */
  destroy() {
    this.rawBinaryData = null, this.uint32View = null, this.float32View = null, this.uint16View = null, this._int8View = null, this._uint8View = null, this._int16View = null, this._int32View = null, this._float64Array = null, this._bigUint64Array = null;
  }
  /**
   * Returns the size of the given type in bytes.
   * @param type - One of `int8`, `uint8`, `int16`,
   *   `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - size of the type in bytes
   */
  static sizeOf(e) {
    switch (e) {
      case "int8":
      case "uint8":
        return 1;
      case "int16":
      case "uint16":
        return 2;
      case "int32":
      case "uint32":
      case "float32":
        return 4;
      default:
        throw new Error(`${e} isn't a valid view type`);
    }
  }
}
function i0(i, e, t, n) {
  if (t != null || (t = 0), n != null || (n = Math.min(i.byteLength - t, e.byteLength)), !(t & 7) && !(n & 7)) {
    const s = n / 8;
    new Float64Array(e, 0, s).set(new Float64Array(i, t, s));
  } else if (!(t & 3) && !(n & 3)) {
    const s = n / 4;
    new Float32Array(e, 0, s).set(new Float32Array(i, t, s));
  } else
    new Uint8Array(e).set(new Uint8Array(i, t, n));
}
const IX = {
  normal: "normal-npm",
  add: "add-npm",
  screen: "screen-npm"
};
var fn = /* @__PURE__ */ ((i) => (i[i.DISABLED = 0] = "DISABLED", i[i.RENDERING_MASK_ADD = 1] = "RENDERING_MASK_ADD", i[i.MASK_ACTIVE = 2] = "MASK_ACTIVE", i[i.INVERSE_MASK_ACTIVE = 3] = "INVERSE_MASK_ACTIVE", i[i.RENDERING_MASK_REMOVE = 4] = "RENDERING_MASK_REMOVE", i[i.NONE = 5] = "NONE", i))(fn || {});
function Qk(i, e) {
  return e.alphaMode === "no-premultiply-alpha" && IX[i] || i;
}
const AX = [
  "precision mediump float;",
  "void main(void){",
  "float test = 0.1;",
  "%forloop%",
  "gl_FragColor = vec4(0.0);",
  "}"
].join(`
`);
function PX(i) {
  let e = "";
  for (let t = 0; t < i; ++t)
    t > 0 && (e += `
else `), t < i - 1 && (e += `if(test == ${t}.0){}`);
  return e;
}
function pM(i, e) {
  if (i === 0)
    throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
  const t = e.createShader(e.FRAGMENT_SHADER);
  try {
    for (; ; ) {
      const n = AX.replace(/%forloop%/gi, PX(i));
      if (e.shaderSource(t, n), e.compileShader(t), !e.getShaderParameter(t, e.COMPILE_STATUS))
        i = i / 2 | 0;
      else
        break;
    }
  } finally {
    e.deleteShader(t);
  }
  return i;
}
let Ia = null;
function EX() {
  var e;
  if (Ia) return Ia;
  const i = US();
  return Ia = i.getParameter(i.MAX_TEXTURE_IMAGE_UNITS), Ia = pM(
    Ia,
    i
  ), (e = i.getExtension("WEBGL_lose_context")) == null || e.loseContext(), Ia;
}
class RX {
  constructor() {
    this.ids = /* @__PURE__ */ Object.create(null), this.textures = [], this.count = 0;
  }
  /** Clear the textures and their locations. */
  clear() {
    for (let e = 0; e < this.count; e++) {
      const t = this.textures[e];
      this.textures[e] = null, this.ids[t.uid] = null;
    }
    this.count = 0;
  }
}
class zX {
  constructor() {
    this.renderPipeId = "batch", this.action = "startBatch", this.start = 0, this.size = 0, this.textures = new RX(), this.blendMode = "normal", this.topology = "triangle-strip", this.canBundle = !0;
  }
  destroy() {
    this.textures = null, this.gpuBindGroup = null, this.bindGroup = null, this.batcher = null, this.elements = null;
  }
}
const yc = [];
let bf = 0;
Yl.register({
  clear: () => {
    if (yc.length > 0)
      for (const i of yc)
        i && i.destroy();
    yc.length = 0, bf = 0;
  }
});
function e2() {
  return bf > 0 ? yc[--bf] : new zX();
}
function t2(i) {
  i.elements = null, yc[bf++] = i;
}
let vd = 0;
const fM = class mM {
  constructor(e) {
    this.uid = Nt("batcher"), this.dirty = !0, this.batchIndex = 0, this.batches = [], this._elements = [], e = { ...mM.defaultOptions, ...e }, e.maxTextures || (rt("v8.8.0", "maxTextures is a required option for Batcher now, please pass it in the options"), e.maxTextures = EX());
    const { maxTextures: t, attributesInitialSize: n, indicesInitialSize: s } = e;
    this.attributeBuffer = new Zk(n * 4), this.indexBuffer = new Uint16Array(s), this.maxTextures = t;
  }
  begin() {
    this.elementSize = 0, this.elementStart = 0, this.indexSize = 0, this.attributeSize = 0;
    for (let e = 0; e < this.batchIndex; e++)
      t2(this.batches[e]);
    this.batchIndex = 0, this._batchIndexStart = 0, this._batchIndexSize = 0, this.dirty = !0;
  }
  add(e) {
    this._elements[this.elementSize++] = e, e._indexStart = this.indexSize, e._attributeStart = this.attributeSize, e._batcher = this, this.indexSize += e.indexSize, this.attributeSize += e.attributeSize * this.vertexSize;
  }
  checkAndUpdateTexture(e, t) {
    const n = e._batch.textures.ids[t._source.uid];
    return !n && n !== 0 ? !1 : (e._textureId = n, e.texture = t, !0);
  }
  updateElement(e) {
    this.dirty = !0;
    const t = this.attributeBuffer;
    e.packAsQuad ? this.packQuadAttributes(
      e,
      t.float32View,
      t.uint32View,
      e._attributeStart,
      e._textureId
    ) : this.packAttributes(
      e,
      t.float32View,
      t.uint32View,
      e._attributeStart,
      e._textureId
    );
  }
  /**
   * breaks the batcher. This happens when a batch gets too big,
   * or we need to switch to a different type of rendering (a filter for example)
   * @param instructionSet
   */
  break(e) {
    const t = this._elements;
    if (!t[this.elementStart]) return;
    let n = e2(), s = n.textures;
    s.clear();
    const o = t[this.elementStart];
    let r = Qk(o.blendMode, o.texture._source), a = o.topology;
    this.attributeSize * 4 > this.attributeBuffer.size && this._resizeAttributeBuffer(this.attributeSize * 4), this.indexSize > this.indexBuffer.length && this._resizeIndexBuffer(this.indexSize);
    const l = this.attributeBuffer.float32View, d = this.attributeBuffer.uint32View, c = this.indexBuffer;
    let h = this._batchIndexSize, f = this._batchIndexStart, p = "startBatch", y = [];
    const v = this.maxTextures;
    for (let x = this.elementStart; x < this.elementSize; ++x) {
      const w = t[x];
      t[x] = null;
      const M = w.texture._source, _ = Qk(w.blendMode, M), T = r !== _ || a !== w.topology;
      if (M._batchTick === vd && !T) {
        w._textureId = M._textureBindLocation, h += w.indexSize, w.packAsQuad ? (this.packQuadAttributes(
          w,
          l,
          d,
          w._attributeStart,
          w._textureId
        ), this.packQuadIndex(
          c,
          w._indexStart,
          w._attributeStart / this.vertexSize
        )) : (this.packAttributes(
          w,
          l,
          d,
          w._attributeStart,
          w._textureId
        ), this.packIndex(
          w,
          c,
          w._indexStart,
          w._attributeStart / this.vertexSize
        )), w._batch = n, y.push(w);
        continue;
      }
      M._batchTick = vd, (s.count >= v || T) && (this._finishBatch(
        n,
        f,
        h - f,
        s,
        r,
        a,
        e,
        p,
        y
      ), p = "renderBatch", f = h, r = _, a = w.topology, n = e2(), s = n.textures, s.clear(), y = [], ++vd), w._textureId = M._textureBindLocation = s.count, s.ids[M.uid] = s.count, s.textures[s.count++] = M, w._batch = n, y.push(w), h += w.indexSize, w.packAsQuad ? (this.packQuadAttributes(
        w,
        l,
        d,
        w._attributeStart,
        w._textureId
      ), this.packQuadIndex(
        c,
        w._indexStart,
        w._attributeStart / this.vertexSize
      )) : (this.packAttributes(
        w,
        l,
        d,
        w._attributeStart,
        w._textureId
      ), this.packIndex(
        w,
        c,
        w._indexStart,
        w._attributeStart / this.vertexSize
      ));
    }
    s.count > 0 && (this._finishBatch(
      n,
      f,
      h - f,
      s,
      r,
      a,
      e,
      p,
      y
    ), f = h, ++vd), this.elementStart = this.elementSize, this._batchIndexStart = f, this._batchIndexSize = h;
  }
  _finishBatch(e, t, n, s, o, r, a, l, d) {
    e.gpuBindGroup = null, e.bindGroup = null, e.action = l, e.batcher = this, e.textures = s, e.blendMode = o, e.topology = r, e.start = t, e.size = n, e.elements = d, ++vd, this.batches[this.batchIndex++] = e, a.add(e);
  }
  finish(e) {
    this.break(e);
  }
  /**
   * Resizes the attribute buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */
  ensureAttributeBuffer(e) {
    e * 4 <= this.attributeBuffer.size || this._resizeAttributeBuffer(e * 4);
  }
  /**
   * Resizes the index buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */
  ensureIndexBuffer(e) {
    e <= this.indexBuffer.length || this._resizeIndexBuffer(e);
  }
  _resizeAttributeBuffer(e) {
    const t = Math.max(e, this.attributeBuffer.size * 2), n = new Zk(t);
    i0(this.attributeBuffer.rawBinaryData, n.rawBinaryData), this.attributeBuffer = n;
  }
  _resizeIndexBuffer(e) {
    const t = this.indexBuffer;
    let n = Math.max(e, t.length * 1.5);
    n += n % 2;
    const s = n > 65535 ? new Uint32Array(n) : new Uint16Array(n);
    if (s.BYTES_PER_ELEMENT !== t.BYTES_PER_ELEMENT)
      for (let o = 0; o < t.length; o++)
        s[o] = t[o];
    else
      i0(t.buffer, s.buffer);
    this.indexBuffer = s;
  }
  packQuadIndex(e, t, n) {
    e[t] = n + 0, e[t + 1] = n + 1, e[t + 2] = n + 2, e[t + 3] = n + 0, e[t + 4] = n + 2, e[t + 5] = n + 3;
  }
  packIndex(e, t, n, s) {
    const o = e.indices, r = e.indexSize, a = e.indexOffset, l = e.attributeOffset;
    for (let d = 0; d < r; d++)
      t[n++] = s + o[d + a] - l;
  }
  /**
   * Destroys the batch and its resources.
   * @param options - destruction options
   * @param options.shader - whether to destroy the associated shader
   */
  destroy(e = {}) {
    var t;
    if (this.batches !== null) {
      for (let n = 0; n < this.batchIndex; n++)
        t2(this.batches[n]);
      this.batches = null, this.geometry.destroy(!0), this.geometry = null, e.shader && ((t = this.shader) == null || t.destroy(), this.shader = null);
      for (let n = 0; n < this._elements.length; n++)
        this._elements[n] && (this._elements[n]._batch = null);
      this._elements = null, this.indexBuffer = null, this.attributeBuffer.destroy(), this.attributeBuffer = null;
    }
  }
};
fM.defaultOptions = {
  maxTextures: null,
  attributesInitialSize: 4,
  indicesInitialSize: 6
};
let $X = fM;
var $t = /* @__PURE__ */ ((i) => (i[i.MAP_READ = 1] = "MAP_READ", i[i.MAP_WRITE = 2] = "MAP_WRITE", i[i.COPY_SRC = 4] = "COPY_SRC", i[i.COPY_DST = 8] = "COPY_DST", i[i.INDEX = 16] = "INDEX", i[i.VERTEX = 32] = "VERTEX", i[i.UNIFORM = 64] = "UNIFORM", i[i.STORAGE = 128] = "STORAGE", i[i.INDIRECT = 256] = "INDIRECT", i[i.QUERY_RESOLVE = 512] = "QUERY_RESOLVE", i[i.STATIC = 1024] = "STATIC", i))($t || {});
class ns extends bi {
  /**
   * Creates a new Buffer with the given options
   * @param options - the options for the buffer
   */
  constructor(e) {
    let { data: t, size: n } = e;
    const { usage: s, label: o, shrinkToFit: r } = e;
    super(), this._gpuData = /* @__PURE__ */ Object.create(null), this._gcLastUsed = -1, this.autoGarbageCollect = !0, this.uid = Nt("buffer"), this._resourceType = "buffer", this._resourceId = Nt("resource"), this._updateID = 1, this._updateOffset = 0, this._dataInt32 = null, this.shrinkToFit = !0, this.destroyed = !1, t instanceof Array && (t = new Float32Array(t)), this._data = t, n != null || (n = t == null ? void 0 : t.byteLength);
    const a = !!t;
    this.descriptor = {
      size: n,
      usage: s,
      mappedAtCreation: a,
      label: o
    }, this.shrinkToFit = r != null ? r : !0;
  }
  /** the data in the buffer */
  get data() {
    return this._data;
  }
  set data(e) {
    this.setDataWithSize(e, e.length, !0);
  }
  get dataInt32() {
    return this._dataInt32 || (this._dataInt32 = new Int32Array(this.data.buffer)), this._dataInt32;
  }
  /** whether the buffer is static or not */
  get static() {
    return !!(this.descriptor.usage & $t.STATIC);
  }
  set static(e) {
    e ? this.descriptor.usage |= $t.STATIC : this.descriptor.usage &= ~$t.STATIC;
  }
  /**
   * Sets the data in the buffer to the given value. This will immediately update the buffer on the GPU.
   * If you only want to update a subset of the buffer, you can pass in the size of the data.
   * @param value - the data to set
   * @param size - the size of the data in bytes
   * @param syncGPU - should the buffer be updated on the GPU immediately?
   */
  setDataWithSize(e, t, n) {
    if (this._updateID++, this._updateSize = t * e.BYTES_PER_ELEMENT, this._updateOffset = 0, this._data === e) {
      n && this.emit("update", this);
      return;
    }
    const s = this._data;
    if (this._data = e, this._dataInt32 = null, !s || s.length !== e.length) {
      !this.shrinkToFit && s && e.byteLength < s.byteLength ? n && this.emit("update", this) : (this.descriptor.size = e.byteLength, this._resourceId = Nt("resource"), this.emit("change", this));
      return;
    }
    n && this.emit("update", this);
  }
  /**
   * updates the buffer on the GPU to reflect the data in the buffer.
   * By default it will update the entire buffer. If you only want to update a subset of the buffer,
   * you can pass in the size of the buffer to update.
   * @param sizeInBytes - the new size of the buffer in bytes
   * @param offsetInBytes - the offset to start updating from
   */
  update(e, t) {
    this._updateSize = e != null ? e : this._updateSize, this._updateOffset = t || 0, this._updateID++, this.emit("update", this);
  }
  /** Unloads the buffer from the GPU */
  unload() {
    var e;
    this.emit("unload", this);
    for (const t in this._gpuData)
      (e = this._gpuData[t]) == null || e.destroy();
    this._gpuData = /* @__PURE__ */ Object.create(null), this.destroyed || (this._resourceId = Nt("resource"), this.emit("change", this));
  }
  /** Destroys the buffer */
  destroy() {
    this.destroyed = !0, this.unload(), this.emit("destroy", this), this.emit("change", this), this._data = null, this.descriptor = null, this.removeAllListeners();
  }
}
function gM(i, e) {
  if (!(i instanceof ns)) {
    let t = e ? $t.INDEX : $t.VERTEX;
    i instanceof Array && (e ? (i = new Uint32Array(i), t = $t.INDEX | $t.COPY_DST) : (i = new Float32Array(i), t = $t.VERTEX | $t.COPY_DST)), i = new ns({
      data: i,
      label: e ? "index-mesh-buffer" : "vertex-mesh-buffer",
      usage: t
    });
  }
  return i;
}
function DX(i, e, t) {
  const n = i.getAttribute(e);
  if (!n)
    return t.minX = 0, t.minY = 0, t.maxX = 0, t.maxY = 0, t;
  const s = n.buffer.data;
  let o = 1 / 0, r = 1 / 0, a = -1 / 0, l = -1 / 0;
  const d = s.BYTES_PER_ELEMENT, c = (n.offset || 0) / d, h = (n.stride || 8) / d;
  for (let f = c; f < s.length; f += h) {
    const p = s[f], y = s[f + 1];
    p > a && (a = p), y > l && (l = y), p < o && (o = p), y < r && (r = y);
  }
  return t.minX = o, t.minY = r, t.maxX = a, t.maxY = l, t;
}
function OX(i) {
  return (i instanceof ns || Array.isArray(i) || i.BYTES_PER_ELEMENT) && (i = {
    buffer: i
  }), i.buffer = gM(i.buffer, !1), i;
}
class fm extends bi {
  /**
   * Create a new instance of a geometry
   * @param options - The options for the geometry.
   */
  constructor(e = {}) {
    var o, r;
    super(), this._gpuData = /* @__PURE__ */ Object.create(null), this.autoGarbageCollect = !0, this._gcLastUsed = -1, this.uid = Nt("geometry"), this._layoutKey = 0, this.instanceCount = 1, this.indexCount = 0, this._bounds = new Gn(), this._boundsDirty = !0, this._vertexCount = 0, this._vertexCountDirty = !0;
    const { attributes: t, indexBuffer: n, topology: s } = e;
    if (this.buffers = [], this.attributes = {}, t)
      for (const a in t)
        this.addAttribute(a, t[a]);
    this.instanceCount = (o = e.instanceCount) != null ? o : 1, this.indexCount = (r = e.indexCount) != null ? r : 0, n && this.addIndex(n), this.topology = s || "triangle-list";
  }
  onBufferUpdate() {
    this._boundsDirty = !0, this._vertexCountDirty = !0, this.emit("update", this);
  }
  /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */
  getAttribute(e) {
    return this.attributes[e];
  }
  /**
   * Returns the index buffer
   * @returns - The index buffer.
   */
  getIndex() {
    return this.indexBuffer;
  }
  /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */
  getBuffer(e) {
    return this.getAttribute(e).buffer;
  }
  /**
   * The number of vertices in this geometry, derived from the first non-instanced attribute.
   * The value is cached and only recalculated when the geometry's buffers or attributes change.
   */
  get vertexCount() {
    if (!this._vertexCountDirty) return this._vertexCount;
    this._vertexCountDirty = !1;
    const e = this.attributes;
    for (const t in e) {
      const n = e[t];
      if (n.instance) continue;
      const s = n.buffer;
      return this._vertexCount = s.data.length / (n.stride / 4 || n.size), this._vertexCount;
    }
    return this._vertexCount = 0, 0;
  }
  /**
   * Used to figure out how many vertices there are in this geometry
   * @returns the number of vertices in the geometry
   * @deprecated since 8.20.0, use {@link Geometry.vertexCount} instead
   */
  getSize() {
    return rt("8.20.0", "Geometry.getSize is deprecated, please use Geometry.vertexCount instead."), this.vertexCount;
  }
  /**
   * Adds an attribute to the geometry.
   * @param name - The name of the attribute to add.
   * @param attributeOption - The attribute option to add.
   */
  addAttribute(e, t) {
    const n = OX(t);
    this.buffers.indexOf(n.buffer) === -1 && (this.buffers.push(n.buffer), n.buffer.on("update", this.onBufferUpdate, this), n.buffer.on("change", this.onBufferUpdate, this)), this.attributes[e] = n, this._vertexCountDirty = !0;
  }
  /**
   * Adds an index buffer to the geometry.
   * @param indexBuffer - The index buffer to add. Can be a Buffer, TypedArray, or an array of numbers.
   */
  addIndex(e) {
    this.indexBuffer = gM(e, !0), this.buffers.push(this.indexBuffer);
  }
  /** Returns the bounds of the geometry. */
  get bounds() {
    return this._boundsDirty ? (this._boundsDirty = !1, DX(this, "aPosition", this._bounds)) : this._bounds;
  }
  /** Unloads the geometry from the GPU. */
  unload() {
    var e;
    this.emit("unload", this);
    for (const t in this._gpuData)
      (e = this._gpuData[t]) == null || e.destroy();
    this._gpuData = /* @__PURE__ */ Object.create(null);
  }
  /**
   * destroys the geometry.
   * @param destroyBuffers - destroy the buffers associated with this geometry
   */
  destroy(e = !1) {
    this.emit("destroy", this);
    for (const t of this.buffers)
      t.off("update", this.onBufferUpdate, this), t.off("change", this.onBufferUpdate, this), e && t.destroy();
    this.unload(), this.removeAllListeners(), this.attributes = null, this.buffers = null, this.indexBuffer = null, this._bounds = null;
  }
}
const LX = new Float32Array(1), BX = new Uint32Array(1);
class FX extends fm {
  constructor() {
    const t = new ns({
      data: LX,
      label: "attribute-batch-buffer",
      usage: $t.VERTEX | $t.COPY_DST,
      shrinkToFit: !1
    }), n = new ns({
      data: BX,
      label: "index-batch-buffer",
      usage: $t.INDEX | $t.COPY_DST,
      // | BufferUsage.STATIC,
      shrinkToFit: !1
    }), s = 24;
    super({
      attributes: {
        aPosition: {
          buffer: t,
          format: "float32x2",
          stride: s,
          offset: 0
        },
        aUV: {
          buffer: t,
          format: "float32x2",
          stride: s,
          offset: 8
        },
        aColor: {
          buffer: t,
          format: "unorm8x4",
          stride: s,
          offset: 16
        },
        aTextureIdAndRound: {
          buffer: t,
          format: "uint16x2",
          stride: s,
          offset: 20
        }
      },
      indexBuffer: n
    });
  }
}
function n2(i, e, t) {
  if (i)
    for (const n in i) {
      const s = n.toLocaleLowerCase(), o = e[s];
      if (o) {
        let r = i[n];
        n === "header" && (r = r.replace(/@in\s+[^;]+;\s*/g, "").replace(/@out\s+[^;]+;\s*/g, "")), t && o.push(`//----${t}----//`), o.push(r);
      } else
        dt(`${n} placement hook does not exist in shader`);
    }
}
const NX = /\{\{(.*?)\}\}/g;
function i2(i) {
  var n, s;
  const e = {};
  return ((s = (n = i.match(NX)) == null ? void 0 : n.map((o) => o.replace(/[{()}]/g, ""))) != null ? s : []).forEach((o) => {
    e[o] = [];
  }), e;
}
function s2(i, e) {
  let t;
  const n = /@in\s+([^;]+);/g;
  for (; (t = n.exec(i)) !== null; )
    e.push(t[1]);
}
function o2(i, e, t = !1) {
  const n = [];
  s2(e, n), i.forEach((a) => {
    a.header && s2(a.header, n);
  });
  const s = n;
  t && s.sort();
  const o = s.map((a, l) => `       @location(${l}) ${a},`).join(`
`);
  let r = e.replace(/@in\s+[^;]+;\s*/g, "");
  return r = r.replace("{{in}}", `
${o}
`), r;
}
function r2(i, e) {
  let t;
  const n = /@out\s+([^;]+);/g;
  for (; (t = n.exec(i)) !== null; )
    e.push(t[1]);
}
function UX(i) {
  const t = /\b(\w+)\s*:/g.exec(i);
  return t ? t[1] : "";
}
function GX(i) {
  const e = /@.*?\s+/g;
  return i.replace(e, "");
}
function jX(i, e) {
  const t = [];
  r2(e, t), i.forEach((l) => {
    l.header && r2(l.header, t);
  });
  let n = 0;
  const s = t.sort().map((l) => l.indexOf("builtin") > -1 ? l : `@location(${n++}) ${l}`).join(`,
`), o = t.sort().map((l) => `       var ${GX(l)};`).join(`
`), r = `return VSOutput(
            ${t.sort().map((l) => ` ${UX(l)}`).join(`,
`)});`;
  let a = e.replace(/@out\s+[^;]+;\s*/g, "");
  return a = a.replace("{{struct}}", `
${s}
`), a = a.replace("{{start}}", `
${o}
`), a = a.replace("{{return}}", `
${r}
`), a;
}
function a2(i, e) {
  let t = i;
  for (const n in e) {
    const s = e[n];
    s.join(`
`).length ? t = t.replace(`{{${n}}}`, `//-----${n} START-----//
${s.join(`
`)}
//----${n} FINISH----//`) : t = t.replace(`{{${n}}}`, "");
  }
  return t;
}
const Oo = /* @__PURE__ */ Object.create(null), Bg = /* @__PURE__ */ new Map();
let HX = 0;
function VX({
  template: i,
  bits: e
}) {
  const t = bM(i, e);
  if (Oo[t]) return Oo[t];
  const { vertex: n, fragment: s } = qX(i, e);
  return Oo[t] = vM(n, s, e), Oo[t];
}
function WX({
  template: i,
  bits: e
}) {
  const t = bM(i, e);
  return Oo[t] || (Oo[t] = vM(i.vertex, i.fragment, e)), Oo[t];
}
function qX(i, e) {
  const t = e.map((r) => r.vertex).filter((r) => !!r), n = e.map((r) => r.fragment).filter((r) => !!r);
  let s = o2(t, i.vertex, !0);
  s = jX(t, s);
  const o = o2(n, i.fragment, !0);
  return {
    vertex: s,
    fragment: o
  };
}
function bM(i, e) {
  return e.map((t) => (Bg.has(t) || Bg.set(t, HX++), Bg.get(t))).sort((t, n) => t - n).join("-") + i.vertex + i.fragment;
}
function vM(i, e, t) {
  const n = i2(i), s = i2(e);
  return t.forEach((o) => {
    n2(o.vertex, n, o.name), n2(o.fragment, s, o.name);
  }), {
    vertex: a2(i, n),
    fragment: a2(e, s)
  };
}
const KX = (
  /* wgsl */
  `
    @in aPosition: vec2<f32>;
    @in aUV: vec2<f32>;

    @out @builtin(position) vPosition: vec4<f32>;
    @out vUV : vec2<f32>;
    @out vColor : vec4<f32>;

    {{header}}

    struct VSOutput {
        {{struct}}
    };

    @vertex
    fn main( {{in}} ) -> VSOutput {

        var worldTransformMatrix = globalUniforms.uWorldTransformMatrix;
        var modelMatrix = mat3x3<f32>(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        var position = aPosition;
        var uv = aUV;

        {{start}}

        vColor = vec4<f32>(1., 1., 1., 1.);

        {{main}}

        vUV = uv;

        var modelViewProjectionMatrix = globalUniforms.uProjectionMatrix * worldTransformMatrix * modelMatrix;

        vPosition =  vec4<f32>((modelViewProjectionMatrix *  vec3<f32>(position, 1.0)).xy, 0.0, 1.0);

        vColor *= globalUniforms.uWorldColorAlpha;

        {{end}}

        {{return}}
    };
`
), YX = (
  /* wgsl */
  `
    @in vUV : vec2<f32>;
    @in vColor : vec4<f32>;

    {{header}}

    @fragment
    fn main(
        {{in}}
      ) -> @location(0) vec4<f32> {

        {{start}}

        var outColor:vec4<f32>;

        {{main}}

        var finalColor:vec4<f32> = outColor * vColor;

        {{end}}

        return finalColor;
      };
`
), XX = (
  /* glsl */
  `
    in vec2 aPosition;
    in vec2 aUV;

    out vec4 vColor;
    out vec2 vUV;

    {{header}}

    void main(void){

        mat3 worldTransformMatrix = uWorldTransformMatrix;
        mat3 modelMatrix = mat3(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        vec2 position = aPosition;
        vec2 uv = aUV;

        {{start}}

        vColor = vec4(1.);

        {{main}}

        vUV = uv;

        mat3 modelViewProjectionMatrix = uProjectionMatrix * worldTransformMatrix * modelMatrix;

        gl_Position = vec4((modelViewProjectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);

        vColor *= uWorldColorAlpha;

        {{end}}
    }
`
), JX = (
  /* glsl */
  `

    in vec4 vColor;
    in vec2 vUV;

    out vec4 finalColor;

    {{header}}

    void main(void) {

        {{start}}

        vec4 outColor;

        {{main}}

        finalColor = outColor * vColor;

        {{end}}
    }
`
), ZX = {
  name: "global-uniforms-bit",
  vertex: {
    header: (
      /* wgsl */
      `
        struct GlobalUniforms {
            uProjectionMatrix:mat3x3<f32>,
            uWorldTransformMatrix:mat3x3<f32>,
            uWorldColorAlpha: vec4<f32>,
            uResolution: vec2<f32>,
        }

        @group(0) @binding(0) var<uniform> globalUniforms : GlobalUniforms;
        `
    )
  }
}, QX = {
  name: "global-uniforms-bit",
  vertex: {
    header: (
      /* glsl */
      `
          uniform mat3 uProjectionMatrix;
          uniform mat3 uWorldTransformMatrix;
          uniform vec4 uWorldColorAlpha;
          uniform vec2 uResolution;
        `
    )
  }
};
function sy({ bits: i, name: e }) {
  const t = VX({
    template: {
      fragment: YX,
      vertex: KX
    },
    bits: [
      ZX,
      ...i
    ]
  });
  return ba.from({
    name: e,
    vertex: {
      source: t.vertex,
      entryPoint: "main"
    },
    fragment: {
      source: t.fragment,
      entryPoint: "main"
    }
  });
}
function oy({ bits: i, name: e }) {
  return new Xl({
    name: e,
    ...WX({
      template: {
        vertex: XX,
        fragment: JX
      },
      bits: [
        QX,
        ...i
      ]
    })
  });
}
const yM = {
  name: "color-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            @in aColor: vec4<f32>;
        `
    ),
    main: (
      /* wgsl */
      `
            vColor *= vec4<f32>(aColor.rgb * aColor.a, aColor.a);
        `
    )
  }
}, xM = {
  name: "color-bit",
  vertex: {
    header: (
      /* glsl */
      `
            in vec4 aColor;
        `
    ),
    main: (
      /* glsl */
      `
            vColor *= vec4(aColor.rgb * aColor.a, aColor.a);
        `
    )
  }
}, Fg = {};
function eJ(i) {
  const e = [];
  if (i === 1)
    e.push("@group(1) @binding(0) var textureSource1: texture_2d<f32>;"), e.push("@group(1) @binding(1) var textureSampler1: sampler;");
  else {
    let t = 0;
    for (let n = 0; n < i; n++)
      e.push(`@group(1) @binding(${t++}) var textureSource${n + 1}: texture_2d<f32>;`), e.push(`@group(1) @binding(${t++}) var textureSampler${n + 1}: sampler;`);
  }
  return e.join(`
`);
}
function tJ(i) {
  const e = [];
  if (i === 1)
    e.push("outColor = textureSampleGrad(textureSource1, textureSampler1, vUV, uvDx, uvDy);");
  else {
    e.push("switch vTextureId {");
    for (let t = 0; t < i; t++)
      t === i - 1 ? e.push("  default:{") : e.push(`  case ${t}:{`), e.push(`      outColor = textureSampleGrad(textureSource${t + 1}, textureSampler${t + 1}, vUV, uvDx, uvDy);`), e.push("      break;}");
    e.push("}");
  }
  return e.join(`
`);
}
function wM(i) {
  return Fg[i] || (Fg[i] = {
    name: "texture-batch-bit",
    vertex: {
      header: `
                @in aTextureIdAndRound: vec2<u32>;
                @out @interpolate(flat) vTextureId : u32;
            `,
      main: `
                vTextureId = aTextureIdAndRound.y;
            `,
      end: `
                if(aTextureIdAndRound.x == 1)
                {
                    vPosition = vec4<f32>(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
                }
            `
    },
    fragment: {
      header: `
                @in @interpolate(flat) vTextureId: u32;

                ${eJ(i)}
            `,
      main: `
                var uvDx = dpdx(vUV);
                var uvDy = dpdy(vUV);

                ${tJ(i)}
            `
    }
  }), Fg[i];
}
const Ng = {};
function nJ(i) {
  const e = [];
  for (let t = 0; t < i; t++)
    t > 0 && e.push("else"), t < i - 1 && e.push(`if(vTextureId < ${t}.5)`), e.push("{"), e.push(`	outColor = texture(uTextures[${t}], vUV);`), e.push("}");
  return e.join(`
`);
}
function kM(i) {
  return Ng[i] || (Ng[i] = {
    name: "texture-batch-bit",
    vertex: {
      header: `
                in vec2 aTextureIdAndRound;
                out float vTextureId;

            `,
      main: `
                vTextureId = aTextureIdAndRound.y;
            `,
      end: `
                if(aTextureIdAndRound.x == 1.)
                {
                    gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
                }
            `
    },
    fragment: {
      header: `
                in float vTextureId;

                uniform sampler2D uTextures[${i}];

            `,
      main: `

                ${nJ(i)}
            `
    }
  }), Ng[i];
}
const ry = {
  name: "round-pixels-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            fn roundPixels(position: vec2<f32>, targetSize: vec2<f32>) -> vec2<f32>
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    )
  }
}, ay = {
  name: "round-pixels-bit",
  vertex: {
    header: (
      /* glsl */
      `
            vec2 roundPixels(vec2 position, vec2 targetSize)
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    )
  }
}, l2 = {};
function _M(i) {
  let e = l2[i];
  if (e) return e;
  const t = new Int32Array(i);
  for (let n = 0; n < i; n++)
    t[n] = n;
  return e = l2[i] = new Ts({
    uTextures: { value: t, type: "i32", size: i }
  }, { isStatic: !0 }), e;
}
class d2 extends lo {
  constructor(e) {
    const t = oy({
      name: "batch",
      bits: [
        xM,
        kM(e),
        ay
      ]
    }), n = sy({
      name: "batch",
      bits: [
        yM,
        wM(e),
        ry
      ]
    });
    super({
      glProgram: t,
      gpuProgram: n,
      resources: {
        batchSamplers: _M(e)
      }
    }), this.maxTextures = e;
  }
}
let yr = null;
const SM = class MM extends $X {
  constructor(e) {
    super(e), this.geometry = new FX(), this.name = MM.extension.name, this.vertexSize = 6, yr != null || (yr = new d2(e.maxTextures)), this.shader = yr;
  }
  /**
   * Packs the attributes of a DefaultBatchableMeshElement into the provided views.
   * @param element - The DefaultBatchableMeshElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */
  packAttributes(e, t, n, s, o) {
    const r = o << 16 | e.roundPixels & 65535, a = e.transform, l = a.a, d = a.b, c = a.c, h = a.d, f = a.tx, p = a.ty, { positions: y, uvs: v } = e, x = e.color, w = e.attributeOffset, S = w + e.attributeSize;
    for (let M = w; M < S; M++) {
      const _ = M * 2, T = y[_], k = y[_ + 1];
      t[s++] = l * T + c * k + f, t[s++] = h * k + d * T + p, t[s++] = v[_], t[s++] = v[_ + 1], n[s++] = x, n[s++] = r;
    }
  }
  /**
   * Packs the attributes of a DefaultBatchableQuadElement into the provided views.
   * @param element - The DefaultBatchableQuadElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */
  packQuadAttributes(e, t, n, s, o) {
    const r = e.texture, a = e.transform, l = a.a, d = a.b, c = a.c, h = a.d, f = a.tx, p = a.ty, y = e.bounds, v = y.maxX, x = y.minX, w = y.maxY, S = y.minY, M = r.uvs, _ = e.color, T = o << 16 | e.roundPixels & 65535;
    t[s + 0] = l * x + c * S + f, t[s + 1] = h * S + d * x + p, t[s + 2] = M.x0, t[s + 3] = M.y0, n[s + 4] = _, n[s + 5] = T, t[s + 6] = l * v + c * S + f, t[s + 7] = h * S + d * v + p, t[s + 8] = M.x1, t[s + 9] = M.y1, n[s + 10] = _, n[s + 11] = T, t[s + 12] = l * v + c * w + f, t[s + 13] = h * w + d * v + p, t[s + 14] = M.x2, t[s + 15] = M.y2, n[s + 16] = _, n[s + 17] = T, t[s + 18] = l * x + c * w + f, t[s + 19] = h * w + d * x + p, t[s + 20] = M.x3, t[s + 21] = M.y3, n[s + 22] = _, n[s + 23] = T;
  }
  /**
   * Updates the maximum number of textures that can be used in the shader.
   * @param maxTextures - The maximum number of textures that can be used in the shader.
   * @internal
   */
  _updateMaxTextures(e) {
    this.shader.maxTextures !== e && (yr = new d2(e), this.shader = yr);
  }
  destroy() {
    this.shader = null, super.destroy();
  }
};
SM.extension = {
  type: [
    Ie.Batcher
  ],
  name: "default"
};
let ly = SM;
class Cs {
  constructor(e) {
    this.items = /* @__PURE__ */ Object.create(null);
    const { renderer: t, type: n, onUnload: s, priority: o, name: r } = e;
    this._renderer = t, t.gc.addResourceHash(this, "items", n, o != null ? o : 0), this._onUnload = s, this.name = r;
  }
  /**
   * Add an item to the hash. No-op if already added.
   * @param item
   * @returns true if the item was added, false if it was already in the hash
   */
  add(e) {
    return this.items[e.uid] ? !1 : (this.items[e.uid] = e, e.once("unload", this.remove, this), e._gcLastUsed = this._renderer.gc.now, !0);
  }
  remove(e, ...t) {
    var s;
    if (!this.items[e.uid]) return;
    const n = e._gpuData[this._renderer.uid];
    n && ((s = this._onUnload) == null || s.call(this, e, ...t), e.off("unload", this.remove, this), n.destroy(), e._gpuData[this._renderer.uid] = null, this.items[e.uid] = null);
  }
  removeAll(...e) {
    Object.values(this.items).forEach((t) => t && this.remove(t, ...e));
  }
  destroy(...e) {
    this.removeAll(...e), this.items = /* @__PURE__ */ Object.create(null), this._renderer = null, this._onUnload = null;
  }
}
function iJ(i, e, t, n, s, o, r, a = null) {
  let l = 0;
  t *= e, s *= o;
  const d = a.a, c = a.b, h = a.c, f = a.d, p = a.tx, y = a.ty;
  for (; l < r; ) {
    const v = i[t], x = i[t + 1];
    n[s] = d * v + h * x + p, n[s + 1] = c * v + f * x + y, s += o, t += e, l++;
  }
}
function sJ(i, e, t, n) {
  let s = 0;
  for (e *= t; s < n; )
    i[e] = 0, i[e + 1] = 0, e += t, s++;
}
function TM(i, e, t, n, s) {
  const o = e.a, r = e.b, a = e.c, l = e.d, d = e.tx, c = e.ty;
  t || (t = 0), n || (n = 2), s || (s = i.length / n - t);
  let h = t * n;
  for (let f = 0; f < s; f++) {
    const p = i[h], y = i[h + 1];
    i[h] = o * p + a * y + d, i[h + 1] = r * p + l * y + c, h += n;
  }
}
const oJ = new st();
class dy {
  constructor() {
    this.packAsQuad = !1, this.batcherName = "default", this.topology = "triangle-list", this.applyTransform = !0, this.roundPixels = 0, this._batcher = null, this._batch = null;
  }
  get uvs() {
    return this.geometryData.uvs;
  }
  get positions() {
    return this.geometryData.vertices;
  }
  get indices() {
    return this.geometryData.indices;
  }
  get blendMode() {
    return this.renderable && this.applyTransform ? this.renderable.groupBlendMode : "normal";
  }
  get color() {
    const e = this.baseColor, t = e >> 16 | e & 65280 | (e & 255) << 16, n = this.renderable;
    return n ? ia(t, n.groupColor) + (this.alpha * n.groupAlpha * 255 << 24) : t + (this.alpha * 255 << 24);
  }
  get transform() {
    var e;
    return ((e = this.renderable) == null ? void 0 : e.groupTransform) || oJ;
  }
  copyTo(e) {
    e.indexOffset = this.indexOffset, e.indexSize = this.indexSize, e.attributeOffset = this.attributeOffset, e.attributeSize = this.attributeSize, e.baseColor = this.baseColor, e.alpha = this.alpha, e.texture = this.texture, e.geometryData = this.geometryData, e.topology = this.topology;
  }
  reset() {
    this.applyTransform = !0, this.renderable = null, this.topology = "triangle-list";
  }
  destroy() {
    this.renderable = null, this.texture = null, this.geometryData = null, this._batcher = null, this._batch = null;
  }
}
const Xc = {
  extension: {
    type: Ie.ShapeBuilder,
    name: "circle"
  },
  build(i, e) {
    let t, n, s, o, r, a;
    if (i.type === "circle") {
      const _ = i;
      if (r = a = _.radius, r <= 0)
        return !1;
      t = _.x, n = _.y, s = o = 0;
    } else if (i.type === "ellipse") {
      const _ = i;
      if (r = _.halfWidth, a = _.halfHeight, r <= 0 || a <= 0)
        return !1;
      t = _.x, n = _.y, s = o = 0;
    } else {
      const _ = i, T = _.width / 2, k = _.height / 2;
      t = _.x + T, n = _.y + k, r = a = Math.max(0, Math.min(_.radius, Math.min(T, k))), s = T - r, o = k - a;
    }
    if (s < 0 || o < 0)
      return !1;
    const l = Math.ceil(2.3 * Math.sqrt(r + a)), d = l * 8 + (s ? 4 : 0) + (o ? 4 : 0);
    if (d === 0)
      return !1;
    if (l === 0)
      return e[0] = e[6] = t + s, e[1] = e[3] = n + o, e[2] = e[4] = t - s, e[5] = e[7] = n - o, !0;
    let c = 0, h = l * 4 + (s ? 2 : 0) + 2, f = h, p = d, y = s + r, v = o, x = t + y, w = t - y, S = n + v;
    if (e[c++] = x, e[c++] = S, e[--h] = S, e[--h] = w, o) {
      const _ = n - v;
      e[f++] = w, e[f++] = _, e[--p] = _, e[--p] = x;
    }
    for (let _ = 1; _ < l; _++) {
      const T = Math.PI / 2 * (_ / l), k = s + Math.cos(T) * r, P = o + Math.sin(T) * a, A = t + k, R = t - k, D = n + P, O = n - P;
      e[c++] = A, e[c++] = D, e[--h] = D, e[--h] = R, e[f++] = R, e[f++] = O, e[--p] = O, e[--p] = A;
    }
    y = s, v = o + a, x = t + y, w = t - y, S = n + v;
    const M = n - v;
    return e[c++] = x, e[c++] = S, e[--p] = M, e[--p] = x, s && (e[c++] = w, e[c++] = S, e[--p] = M, e[--p] = w), !0;
  },
  triangulate(i, e, t, n, s, o) {
    if (i.length === 0)
      return;
    let r = 0, a = 0;
    for (let c = 0; c < i.length; c += 2)
      r += i[c], a += i[c + 1];
    r /= i.length / 2, a /= i.length / 2;
    let l = n;
    e[l * t] = r, e[l * t + 1] = a;
    const d = l++;
    for (let c = 0; c < i.length; c += 2)
      e[l * t] = i[c], e[l * t + 1] = i[c + 1], c > 0 && (s[o++] = l, s[o++] = d, s[o++] = l - 1), l++;
    s[o++] = d + 1, s[o++] = d, s[o++] = l - 1;
  }
}, rJ = { ...Xc, extension: { ...Xc.extension, name: "ellipse" } }, aJ = { ...Xc, extension: { ...Xc.extension, name: "roundedRectangle" } }, CM = 1e-4, c2 = 1e-4;
function u2(i, e, t, n, s, o, r, a) {
  const l = i - t * s, d = e - n * s, c = i + t * o, h = e + n * o;
  let f, p;
  r ? (f = n, p = -t) : (f = -n, p = t);
  const y = l + f, v = d + p, x = c + f, w = h + p;
  return a.push(y, v), a.push(x, w), 2;
}
function xr(i, e, t, n, s, o, r, a) {
  const l = t - i, d = n - e;
  let c = Math.atan2(l, d), h = Math.atan2(s - i, o - e);
  a && c < h ? c += Math.PI * 2 : !a && c > h && (h += Math.PI * 2);
  let f = c;
  const p = h - c, y = Math.abs(p), v = Math.sqrt(l * l + d * d), x = (15 * y * Math.sqrt(v) / Math.PI >> 0) + 1, w = p / x;
  if (f += w, a) {
    r.push(i, e), r.push(t, n);
    for (let S = 1, M = f; S < x; S++, M += w)
      r.push(i, e), r.push(
        i + Math.sin(M) * v,
        e + Math.cos(M) * v
      );
    r.push(i, e), r.push(s, o);
  } else {
    r.push(t, n), r.push(i, e);
    for (let S = 1, M = f; S < x; S++, M += w)
      r.push(
        i + Math.sin(M) * v,
        e + Math.cos(M) * v
      ), r.push(i, e);
    r.push(s, o), r.push(i, e);
  }
  return x * 2;
}
function cy(i, e, t, n, s, o) {
  const r = CM;
  if (i.length === 0)
    return;
  const a = e;
  let l = a.alignment;
  if (e.alignment !== 0.5) {
    let B = uM(i);
    l = (l - 0.5) * B + 0.5;
  }
  const d = new Wt(i[0], i[1]), c = new Wt(i[i.length - 2], i[i.length - 1]), h = n, f = Math.abs(d.x - c.x) < r && Math.abs(d.y - c.y) < r;
  if (h) {
    i = i.slice(), f && (i.pop(), i.pop(), c.set(i[i.length - 2], i[i.length - 1]));
    const B = (d.x + c.x) * 0.5, se = (c.y + d.y) * 0.5;
    i.unshift(B, se), i.push(B, se);
  }
  const p = s, y = i.length / 2;
  let v = i.length;
  const x = p.length / 2, w = a.width / 2, S = w * w, M = a.miterLimit * a.miterLimit;
  let _ = i[0], T = i[1], k = i[2], P = i[3], A = 0, R = 0, D = -(T - P), O = _ - k, F = 0, te = 0, ee = Math.sqrt(D * D + O * O);
  D /= ee, O /= ee, D *= w, O *= w;
  const me = l, L = (1 - me) * 2, N = me * 2;
  h || (a.cap === "round" ? v += xr(
    _ - D * (L - N) * 0.5,
    T - O * (L - N) * 0.5,
    _ - D * L,
    T - O * L,
    _ + D * N,
    T + O * N,
    p,
    !0
  ) + 2 : a.cap === "square" && (v += u2(_, T, D, O, L, N, !0, p))), p.push(
    _ - D * L,
    T - O * L
  ), p.push(
    _ + D * N,
    T + O * N
  );
  for (let B = 1; B < y - 1; ++B) {
    _ = i[(B - 1) * 2], T = i[(B - 1) * 2 + 1], k = i[B * 2], P = i[B * 2 + 1], A = i[(B + 1) * 2], R = i[(B + 1) * 2 + 1], D = -(T - P), O = _ - k, ee = Math.sqrt(D * D + O * O), D /= ee, O /= ee, D *= w, O *= w, F = -(P - R), te = k - A, ee = Math.sqrt(F * F + te * te), F /= ee, te /= ee, F *= w, te *= w;
    const se = k - _, V = T - P, Z = k - A, Y = R - P, H = se * Z + V * Y, re = V * Z - Y * se, le = re < 0;
    if (Math.abs(re) < 1e-3 * Math.abs(H)) {
      p.push(
        k - D * L,
        P - O * L
      ), p.push(
        k + D * N,
        P + O * N
      ), H >= 0 && (a.join === "round" ? v += xr(
        k,
        P,
        k - D * L,
        P - O * L,
        k - F * L,
        P - te * L,
        p,
        !1
      ) + 4 : v += 2, p.push(
        k - F * N,
        P - te * N
      ), p.push(
        k + F * L,
        P + te * L
      ));
      continue;
    }
    const he = (-D + _) * (-O + P) - (-D + k) * (-O + T), Re = (-F + A) * (-te + P) - (-F + k) * (-te + R), Ne = (se * Re - Z * he) / re, Me = (Y * he - V * Re) / re, ue = (Ne - k) * (Ne - k) + (Me - P) * (Me - P), U = k + (Ne - k) * L, q = P + (Me - P) * L, ie = k - (Ne - k) * N, de = P - (Me - P) * N, pe = Math.min(se * se + V * V, Z * Z + Y * Y), Te = le ? L : N, Be = pe + Te * Te * S;
    ue <= Be ? a.join === "bevel" || ue / S > M ? (le ? (p.push(U, q), p.push(k + D * N, P + O * N), p.push(U, q), p.push(k + F * N, P + te * N)) : (p.push(k - D * L, P - O * L), p.push(ie, de), p.push(k - F * L, P - te * L), p.push(ie, de)), v += 2) : a.join === "round" ? le ? (p.push(U, q), p.push(k + D * N, P + O * N), v += xr(
      k,
      P,
      k + D * N,
      P + O * N,
      k + F * N,
      P + te * N,
      p,
      !0
    ) + 4, p.push(U, q), p.push(k + F * N, P + te * N)) : (p.push(k - D * L, P - O * L), p.push(ie, de), v += xr(
      k,
      P,
      k - D * L,
      P - O * L,
      k - F * L,
      P - te * L,
      p,
      !1
    ) + 4, p.push(k - F * L, P - te * L), p.push(ie, de)) : (p.push(U, q), p.push(ie, de)) : (p.push(k - D * L, P - O * L), p.push(k + D * N, P + O * N), a.join === "round" ? le ? v += xr(
      k,
      P,
      k + D * N,
      P + O * N,
      k + F * N,
      P + te * N,
      p,
      !0
    ) + 2 : v += xr(
      k,
      P,
      k - D * L,
      P - O * L,
      k - F * L,
      P - te * L,
      p,
      !1
    ) + 2 : a.join === "miter" && ue / S <= M && (le ? (p.push(ie, de), p.push(ie, de)) : (p.push(U, q), p.push(U, q)), v += 2), p.push(k - F * L, P - te * L), p.push(k + F * N, P + te * N), v += 2);
  }
  _ = i[(y - 2) * 2], T = i[(y - 2) * 2 + 1], k = i[(y - 1) * 2], P = i[(y - 1) * 2 + 1], D = -(T - P), O = _ - k, ee = Math.sqrt(D * D + O * O), D /= ee, O /= ee, D *= w, O *= w, p.push(k - D * L, P - O * L), p.push(k + D * N, P + O * N), h || (a.cap === "round" ? v += xr(
    k - D * (L - N) * 0.5,
    P - O * (L - N) * 0.5,
    k - D * L,
    P - O * L,
    k + D * N,
    P + O * N,
    p,
    !1
  ) + 2 : a.cap === "square" && (v += u2(k, P, D, O, L, N, !1, p)));
  const X = c2 * c2;
  for (let B = x; B < v + x - 2; ++B)
    _ = p[B * 2], T = p[B * 2 + 1], k = p[(B + 1) * 2], P = p[(B + 1) * 2 + 1], A = p[(B + 2) * 2], R = p[(B + 2) * 2 + 1], !(Math.abs(_ * (P - R) + k * (R - T) + A * (T - P)) < X) && o.push(B, B + 1, B + 2);
}
function lJ(i, e, t, n) {
  const s = CM;
  if (i.length === 0)
    return;
  const o = i[0], r = i[1], a = i[i.length - 2], l = i[i.length - 1], d = e || Math.abs(o - a) < s && Math.abs(r - l) < s, c = t, h = i.length / 2, f = c.length / 2;
  for (let p = 0; p < h; p++)
    c.push(i[p * 2]), c.push(i[p * 2 + 1]);
  for (let p = 0; p < h - 1; p++)
    n.push(f + p, f + p + 1);
  d && n.push(f + h - 1, f);
}
function IM(i, e, t, n, s, o, r) {
  const a = fX(i, e, 2);
  if (!a)
    return;
  for (let d = 0; d < a.length; d += 3)
    o[r++] = a[d] + s, o[r++] = a[d + 1] + s, o[r++] = a[d + 2] + s;
  let l = s * n;
  for (let d = 0; d < i.length; d += 2)
    t[l] = i[d], t[l + 1] = i[d + 1], l += n;
}
const dJ = [], cJ = {
  extension: {
    type: Ie.ShapeBuilder,
    name: "polygon"
  },
  build(i, e) {
    for (let t = 0; t < i.points.length; t++)
      e[t] = i.points[t];
    return !0;
  },
  triangulate(i, e, t, n, s, o) {
    IM(i, dJ, e, t, n, s, o);
  }
}, uJ = {
  extension: {
    type: Ie.ShapeBuilder,
    name: "rectangle"
  },
  build(i, e) {
    const t = i, n = t.x, s = t.y, o = t.width, r = t.height;
    return o > 0 && r > 0 ? (e[0] = n, e[1] = s, e[2] = n + o, e[3] = s, e[4] = n + o, e[5] = s + r, e[6] = n, e[7] = s + r, !0) : !1;
  },
  triangulate(i, e, t, n, s, o) {
    let r = 0;
    n *= t, e[n + r] = i[0], e[n + r + 1] = i[1], r += t, e[n + r] = i[2], e[n + r + 1] = i[3], r += t, e[n + r] = i[6], e[n + r + 1] = i[7], r += t, e[n + r] = i[4], e[n + r + 1] = i[5], r += t;
    const a = n / t;
    s[o++] = a, s[o++] = a + 1, s[o++] = a + 2, s[o++] = a + 1, s[o++] = a + 3, s[o++] = a + 2;
  }
}, hJ = {
  extension: {
    type: Ie.ShapeBuilder,
    name: "triangle"
  },
  build(i, e) {
    return e[0] = i.x, e[1] = i.y, e[2] = i.x2, e[3] = i.y2, e[4] = i.x3, e[5] = i.y3, !0;
  },
  triangulate(i, e, t, n, s, o) {
    let r = 0;
    n *= t, e[n + r] = i[0], e[n + r + 1] = i[1], r += t, e[n + r] = i[2], e[n + r + 1] = i[3], r += t, e[n + r] = i[4], e[n + r + 1] = i[5];
    const a = n / t;
    s[o++] = a, s[o++] = a + 1, s[o++] = a + 2;
  }
}, h2 = [{ offset: 0, color: "white" }, { offset: 1, color: "black" }], uy = class s0 {
  constructor(...e) {
    var s;
    this.uid = Nt("fillGradient"), this._tick = 0, this.type = "linear", this.colorStops = [];
    let t = pJ(e);
    t = { ...t.type === "radial" ? s0.defaultRadialOptions : s0.defaultLinearOptions, ...uS(t) }, this._textureSize = t.textureSize, this._wrapMode = t.wrapMode, t.type === "radial" ? (this.center = t.center, this.outerCenter = (s = t.outerCenter) != null ? s : this.center, this.innerRadius = t.innerRadius, this.outerRadius = t.outerRadius, this.scale = t.scale, this.rotation = t.rotation) : (this.start = t.start, this.end = t.end), this.textureSpace = t.textureSpace, this.type = t.type, t.colorStops.forEach((o) => {
      this.addColorStop(o.offset, o.color);
    });
  }
  /**
   * Adds a color stop to the gradient
   * @param offset - Position of the stop (0-1)
   * @param color - Color of the stop
   * @returns This gradient instance for chaining
   */
  addColorStop(e, t) {
    return this.colorStops.push({ offset: e, color: bn.shared.setValue(t).toHexa() }), this;
  }
  /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */
  buildLinearGradient() {
    if (this.texture) return;
    let { x: e, y: t } = this.start, { x: n, y: s } = this.end, o = n - e, r = s - t;
    const a = o < 0 || r < 0;
    if (this._wrapMode === "clamp-to-edge") {
      if (o < 0) {
        const x = e;
        e = n, n = x, o *= -1;
      }
      if (r < 0) {
        const x = t;
        t = s, s = x, r *= -1;
      }
    }
    const l = this.colorStops.length ? this.colorStops : h2, d = this._textureSize, { canvas: c, context: h } = f2(d, 1), f = a ? h.createLinearGradient(this._textureSize, 0, 0, 0) : h.createLinearGradient(0, 0, this._textureSize, 0);
    p2(f, l), h.fillStyle = f, h.fillRect(0, 0, d, 1), this.texture = new et({
      source: new Gc({
        resource: c,
        addressMode: this._wrapMode
      })
    });
    const p = Math.sqrt(o * o + r * r), y = Math.atan2(r, o), v = new st();
    v.scale(p / d, 1), v.rotate(y), v.translate(e, t), this.textureSpace === "local" && v.scale(d, d), this.transform = v;
  }
  /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */
  buildGradient() {
    this.texture || this._tick++, this.type === "linear" ? this.buildLinearGradient() : this.buildRadialGradient();
  }
  /**
   * Builds the internal texture and transform for the radial gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */
  buildRadialGradient() {
    if (this.texture) return;
    const e = this.colorStops.length ? this.colorStops : h2, t = this._textureSize, { canvas: n, context: s } = f2(t, t), { x: o, y: r } = this.center, { x: a, y: l } = this.outerCenter, d = this.innerRadius, c = this.outerRadius, h = a - c, f = l - c, p = t / (c * 2), y = (o - h) * p, v = (r - f) * p, x = s.createRadialGradient(
      y,
      v,
      d * p,
      (a - h) * p,
      (l - f) * p,
      c * p
    );
    p2(x, e), s.fillStyle = e[e.length - 1].color, s.fillRect(0, 0, t, t), s.fillStyle = x, s.translate(y, v), s.rotate(this.rotation), s.scale(1, this.scale), s.translate(-y, -v), s.fillRect(0, 0, t, t), this.texture = new et({
      source: new Gc({
        resource: n,
        addressMode: this._wrapMode
      })
    });
    const w = new st();
    this.textureSpace === "local" ? w.scale(2 * c, 2 * c) : w.scale(1 / p, 1 / p), w.translate(h, f), this.transform = w;
  }
  /** Destroys the gradient, releasing resources. This will also destroy the internal texture. */
  destroy() {
    var e;
    (e = this.texture) == null || e.destroy(!0), this.texture = null, this.transform = null, this.colorStops = [], this.start = null, this.end = null, this.center = null, this.outerCenter = null;
  }
  /**
   * Returns a unique key for this gradient instance.
   * This key is used for caching and texture management.
   * @returns {string} Unique key for the gradient
   */
  get styleKey() {
    return `fill-gradient-${this.uid}-${this._tick}`;
  }
};
uy.defaultLinearOptions = {
  start: { x: 0, y: 0 },
  end: { x: 0, y: 1 },
  colorStops: [],
  textureSpace: "local",
  type: "linear",
  textureSize: 256,
  wrapMode: "clamp-to-edge"
};
uy.defaultRadialOptions = {
  center: { x: 0.5, y: 0.5 },
  innerRadius: 0,
  outerRadius: 0.5,
  colorStops: [],
  scale: 1,
  rotation: 0,
  textureSpace: "local",
  type: "radial",
  textureSize: 256,
  wrapMode: "clamp-to-edge"
};
let Jl = uy;
function p2(i, e) {
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    i.addColorStop(n.offset, n.color);
  }
}
function f2(i, e) {
  const t = zt.get().createCanvas(i, e), n = t.getContext("2d");
  return { canvas: t, context: n };
}
function pJ(i) {
  var t, n;
  let e = (t = i[0]) != null ? t : {};
  return (typeof e == "number" || i[1]) && (rt("8.5.2", "use options object instead"), e = {
    type: "linear",
    start: { x: i[0], y: i[1] },
    end: { x: i[2], y: i[3] },
    textureSpace: i[4],
    textureSize: (n = i[5]) != null ? n : Jl.defaultLinearOptions.textureSize
  }), e;
}
const fJ = new st(), mJ = new Tt(), gJ = new st();
function AM(i, e, t, n) {
  const s = e.matrix ? i.copyFrom(e.matrix).invert() : i.identity();
  if (e.textureSpace === "local") {
    const r = t.getBounds(mJ);
    e.width && r.pad(e.width);
    const { x: a, y: l } = r, d = 1 / r.width, c = 1 / r.height, h = -a * d, f = -l * c, p = s.a, y = s.b, v = s.c, x = s.d;
    s.a *= d, s.b *= d, s.c *= c, s.d *= c, s.tx = h * p + f * v + s.tx, s.ty = h * y + f * x + s.ty;
  } else if (e.texture.rotate) {
    const { uvs: r, orig: a } = e.texture;
    s.scale(1 / a.width, 1 / a.height), s.prepend(gJ.set(
      r.x1 - r.x0,
      r.y1 - r.y0,
      r.x3 - r.x0,
      r.y3 - r.y0,
      r.x0,
      r.y0
    ));
  } else
    s.translate(e.texture.frame.x, e.texture.frame.y), s.scale(1 / e.texture.source.width, 1 / e.texture.source.height);
  const o = e.texture.source.style;
  return !(e.fill instanceof Jl) && o.addressMode === "clamp-to-edge" && (o.addressMode = "repeat", o.update()), n && s.append(fJ.copyFrom(n).invert()), s;
}
const Zl = {};
ht.handleByMap(Ie.ShapeBuilder, Zl);
ht.add(uJ, cJ, hJ, Xc, rJ, aJ);
const bJ = new Tt(), vJ = new st();
function yJ(i, e) {
  const { geometryData: t, batches: n } = e;
  n.length = 0, t.indices.length = 0, t.vertices.length = 0, t.uvs.length = 0;
  for (let s = 0; s < i.instructions.length; s++) {
    const o = i.instructions[s];
    if (o.action === "texture")
      xJ(o.data, n, t);
    else if (o.action === "fill" || o.action === "stroke") {
      const r = o.action === "stroke", a = o.data.path.shapePath, l = o.data.style, d = o.data.hole;
      r && d && m2(d.shapePath, l, !0, n, t), d && (a.shapePrimitives[a.shapePrimitives.length - 1].holes = d.shapePath.shapePrimitives), m2(a, l, r, n, t);
    }
  }
}
function xJ(i, e, t) {
  const n = [], s = Zl.rectangle, o = bJ;
  o.x = i.dx, o.y = i.dy, o.width = i.dw, o.height = i.dh;
  const r = i.transform;
  if (!s.build(o, n))
    return;
  const { vertices: a, uvs: l, indices: d } = t, c = d.length, h = a.length / 2;
  r && TM(n, r), s.triangulate(n, a, 2, h, d, c);
  const f = i.image, p = f.uvs;
  l.push(
    p.x0,
    p.y0,
    p.x1,
    p.y1,
    p.x3,
    p.y3,
    p.x2,
    p.y2
  );
  const y = $n.get(dy);
  y.indexOffset = c, y.indexSize = d.length - c, y.attributeOffset = h, y.attributeSize = a.length / 2 - h, y.baseColor = i.style, y.alpha = i.alpha, y.texture = f, y.geometryData = t, e.push(y);
}
function m2(i, e, t, n, s) {
  const { vertices: o, uvs: r, indices: a } = s;
  i.shapePrimitives.forEach(({ shape: l, transform: d, holes: c }) => {
    var M;
    const h = [], f = Zl[l.type];
    if (!f.build(l, h))
      return;
    const p = a.length, y = o.length / 2;
    let v = "triangle-list";
    if (d && TM(h, d), t) {
      const _ = (M = l.closePath) != null ? M : !0, T = e;
      T.pixelLine ? (lJ(h, _, o, a), v = "line-list") : cy(h, T, !1, _, o, a);
    } else if (c) {
      const _ = [], T = h.slice();
      wJ(c).forEach((P) => {
        _.push(T.length / 2), T.push(...P);
      }), IM(T, _, o, 2, y, a, p);
    } else
      f.triangulate(h, o, 2, y, a, p);
    const x = r.length / 2, w = e.texture;
    if (w !== et.WHITE) {
      const _ = AM(vJ, e, l, d);
      iJ(o, 2, y, r, x, 2, o.length / 2 - y, _);
    } else
      sJ(r, x, 2, o.length / 2 - y);
    const S = $n.get(dy);
    S.indexOffset = p, S.indexSize = a.length - p, S.attributeOffset = y, S.attributeSize = o.length / 2 - y, S.baseColor = e.color, S.alpha = e.alpha, S.texture = w, S.geometryData = s, S.topology = v, n.push(S);
  });
}
function wJ(i) {
  const e = [];
  for (let t = 0; t < i.length; t++) {
    const n = i[t].shape, s = [];
    Zl[n.type].build(n, s) && e.push(s);
  }
  return e;
}
class kJ {
  constructor() {
    this.batches = [], this.geometryData = {
      vertices: [],
      uvs: [],
      indices: []
    };
  }
  reset() {
    this.batches && this.batches.forEach((e) => {
      $n.return(e);
    }), this.graphicsData && $n.return(this.graphicsData), this.isBatchable = !1, this.context = null, this.batches.length = 0, this.geometryData.indices.length = 0, this.geometryData.vertices.length = 0, this.geometryData.uvs.length = 0, this.graphicsData = null;
  }
  destroy() {
    this.reset(), this.batches = null, this.geometryData = null;
  }
}
class _J {
  constructor() {
    this.instructions = new X1();
  }
  init(e) {
    const t = e.maxTextures;
    this.batcher ? this.batcher._updateMaxTextures(t) : this.batcher = new ly({ maxTextures: t }), this.instructions.reset();
  }
  /**
   * @deprecated since version 8.0.0
   * Use `batcher.geometry` instead.
   * @see {Batcher#geometry}
   */
  get geometry() {
    return rt(gK, "GraphicsContextRenderData#geometry is deprecated, please use batcher.geometry instead."), this.batcher.geometry;
  }
  destroy() {
    this.batcher.destroy(), this.instructions.destroy(), this.batcher = null, this.instructions = null;
  }
}
const hy = class o0 {
  constructor(e) {
    this._renderer = e, this._managedContexts = new Cs({ renderer: e, type: "resource", name: "graphicsContext" });
  }
  /**
   * Runner init called, update the default options
   * @ignore
   */
  init(e) {
    var t;
    o0.defaultOptions.bezierSmoothness = (t = e == null ? void 0 : e.bezierSmoothness) != null ? t : o0.defaultOptions.bezierSmoothness;
  }
  /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */
  getContextRenderData(e) {
    return e._gpuData[this._renderer.uid].graphicsData || this._initContextRenderData(e);
  }
  /**
   * Updates the GPU context for a given GraphicsContext.
   * If the context is dirty, it will rebuild the batches and geometry data.
   * @param context - The GraphicsContext to update.
   * @returns The updated GpuGraphicsContext.
   * @internal
   */
  updateGpuContext(e) {
    const t = !!e._gpuData[this._renderer.uid], n = e._gpuData[this._renderer.uid] || this._initContext(e);
    if (e.dirty || !t) {
      t && n.reset(), yJ(e, n);
      const s = e.batchMode;
      e.customShader || s === "no-batch" ? n.isBatchable = !1 : s === "auto" ? n.isBatchable = n.geometryData.vertices.length < 400 : n.isBatchable = !0, e.dirty = !1;
    }
    return n;
  }
  /**
   * Returns the GpuGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the GpuGraphicsContext for.
   * @returns The GpuGraphicsContext for the given GraphicsContext.
   * @internal
   */
  getGpuContext(e) {
    return e._gpuData[this._renderer.uid] || this._initContext(e);
  }
  _initContextRenderData(e) {
    const t = $n.get(_J, {
      maxTextures: this._renderer.limits.maxBatchableTextures
    }), n = e._gpuData[this._renderer.uid], { batches: s, geometryData: o } = n;
    n.graphicsData = t;
    const r = o.vertices.length, a = o.indices.length;
    for (let h = 0; h < s.length; h++)
      s[h].applyTransform = !1;
    const l = t.batcher;
    l.ensureAttributeBuffer(r), l.ensureIndexBuffer(a), l.begin();
    for (let h = 0; h < s.length; h++) {
      const f = s[h];
      l.add(f);
    }
    l.finish(t.instructions);
    const d = l.geometry;
    d.indexBuffer.setDataWithSize(l.indexBuffer, l.indexSize, !0), d.buffers[0].setDataWithSize(l.attributeBuffer.float32View, l.attributeSize, !0);
    const c = l.batches;
    for (let h = 0; h < l.batchIndex; h++) {
      const f = c[h];
      f.bindGroup = iy(
        f.textures.textures,
        f.textures.count,
        this._renderer.limits.maxBatchableTextures
      );
    }
    return t;
  }
  _initContext(e) {
    const t = new kJ();
    return t.context = e, e._gpuData[this._renderer.uid] = t, this._managedContexts.add(e), t;
  }
  destroy() {
    this._managedContexts.destroy(), this._renderer = null;
  }
};
hy.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem
  ],
  name: "graphicsContext"
};
hy.defaultOptions = {
  /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */
  bezierSmoothness: 0.5
};
let py = hy;
const SJ = 8, ph = 11920929e-14, MJ = 1;
function PM(i, e, t, n, s, o, r, a, l, d) {
  const h = Math.min(
    0.99,
    // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, d != null ? d : py.defaultOptions.bezierSmoothness)
  );
  let f = (MJ - h) / 1;
  return f *= f, TJ(e, t, n, s, o, r, a, l, i, f), i;
}
function TJ(i, e, t, n, s, o, r, a, l, d) {
  r0(i, e, t, n, s, o, r, a, l, d, 0), l.push(r, a);
}
function r0(i, e, t, n, s, o, r, a, l, d, c) {
  if (c > SJ)
    return;
  const h = (i + t) / 2, f = (e + n) / 2, p = (t + s) / 2, y = (n + o) / 2, v = (s + r) / 2, x = (o + a) / 2, w = (h + p) / 2, S = (f + y) / 2, M = (p + v) / 2, _ = (y + x) / 2, T = (w + M) / 2, k = (S + _) / 2;
  if (c > 0) {
    let P = r - i, A = a - e;
    const R = Math.abs((t - r) * A - (n - a) * P), D = Math.abs((s - r) * A - (o - a) * P);
    if (R > ph && D > ph) {
      if ((R + D) * (R + D) <= d * (P * P + A * A)) {
        l.push(T, k);
        return;
      }
    } else if (R > ph) {
      if (R * R <= d * (P * P + A * A)) {
        l.push(T, k);
        return;
      }
    } else if (D > ph) {
      if (D * D <= d * (P * P + A * A)) {
        l.push(T, k);
        return;
      }
    } else if (P = T - (i + r) / 2, A = k - (e + a) / 2, P * P + A * A <= d) {
      l.push(T, k);
      return;
    }
  }
  r0(i, e, h, f, w, S, T, k, l, d, c + 1), r0(T, k, M, _, v, x, r, a, l, d, c + 1);
}
const CJ = 8, IJ = 11920929e-14, AJ = 1;
function PJ(i, e, t, n, s, o, r, a) {
  const d = Math.min(
    0.99,
    // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, a != null ? a : py.defaultOptions.bezierSmoothness)
  );
  let c = (AJ - d) / 1;
  return c *= c, EJ(e, t, n, s, o, r, i, c), i;
}
function EJ(i, e, t, n, s, o, r, a) {
  a0(r, i, e, t, n, s, o, a, 0), r.push(s, o);
}
function a0(i, e, t, n, s, o, r, a, l) {
  if (l > CJ)
    return;
  const d = (e + n) / 2, c = (t + s) / 2, h = (n + o) / 2, f = (s + r) / 2, p = (d + h) / 2, y = (c + f) / 2;
  let v = o - e, x = r - t;
  const w = Math.abs((n - o) * x - (s - r) * v);
  if (w > IJ) {
    if (w * w <= a * (v * v + x * x)) {
      i.push(p, y);
      return;
    }
  } else if (v = p - (e + o) / 2, x = y - (t + r) / 2, v * v + x * x <= a) {
    i.push(p, y);
    return;
  }
  a0(i, e, t, d, c, p, y, a, l + 1), a0(i, p, y, h, f, o, r, a, l + 1);
}
function EM(i, e, t, n, s, o, r, a) {
  let l = Math.abs(s - o);
  (!r && s > o || r && o > s) && (l = 2 * Math.PI - l), a || (a = Math.max(6, Math.floor(6 * Math.pow(n, 1 / 3) * (l / Math.PI)))), a = Math.max(a, 3);
  let d = l / a, c = s;
  d *= r ? -1 : 1;
  for (let h = 0; h < a + 1; h++) {
    const f = Math.cos(c), p = Math.sin(c), y = e + f * n, v = t + p * n;
    i.push(y, v), c += d;
  }
}
function RJ(i, e, t, n, s, o) {
  const r = i[i.length - 2], l = i[i.length - 1] - t, d = r - e, c = s - t, h = n - e, f = Math.abs(l * h - d * c);
  if (f < 1e-8 || o === 0) {
    (i[i.length - 2] !== e || i[i.length - 1] !== t) && i.push(e, t);
    return;
  }
  const p = l * l + d * d, y = c * c + h * h, v = l * c + d * h, x = o * Math.sqrt(p) / f, w = o * Math.sqrt(y) / f, S = x * v / p, M = w * v / y, _ = x * h + w * d, T = x * c + w * l, k = d * (w + S), P = l * (w + S), A = h * (x + M), R = c * (x + M), D = Math.atan2(P - T, k - _), O = Math.atan2(R - T, A - _);
  EM(
    i,
    _ + e,
    T + t,
    o,
    D,
    O,
    d * c > h * l
  );
}
const xc = Math.PI * 2, Ug = {
  centerX: 0,
  centerY: 0,
  ang1: 0,
  ang2: 0
}, Gg = ({ x: i, y: e }, t, n, s, o, r, a, l) => {
  i *= t, e *= n;
  const d = s * i - o * e, c = o * i + s * e;
  return l.x = d + r, l.y = c + a, l;
};
function zJ(i, e) {
  const t = e === -1.5707963267948966 ? -0.551915024494 : 1.3333333333333333 * Math.tan(e / 4), n = e === 1.5707963267948966 ? 0.551915024494 : t, s = Math.cos(i), o = Math.sin(i), r = Math.cos(i + e), a = Math.sin(i + e);
  return [
    {
      x: s - o * n,
      y: o + s * n
    },
    {
      x: r + a * n,
      y: a - r * n
    },
    {
      x: r,
      y: a
    }
  ];
}
const g2 = (i, e, t, n) => {
  const s = i * n - e * t < 0 ? -1 : 1;
  let o = i * t + e * n;
  return o > 1 && (o = 1), o < -1 && (o = -1), s * Math.acos(o);
}, $J = (i, e, t, n, s, o, r, a, l, d, c, h, f) => {
  const p = Math.pow(s, 2), y = Math.pow(o, 2), v = Math.pow(c, 2), x = Math.pow(h, 2);
  let w = p * y - p * x - y * v;
  w < 0 && (w = 0), w /= p * x + y * v, w = Math.sqrt(w) * (r === a ? -1 : 1);
  const S = w * s / o * h, M = w * -o / s * c, _ = d * S - l * M + (i + t) / 2, T = l * S + d * M + (e + n) / 2, k = (c - S) / s, P = (h - M) / o, A = (-c - S) / s, R = (-h - M) / o, D = g2(1, 0, k, P);
  let O = g2(k, P, A, R);
  a === 0 && O > 0 && (O -= xc), a === 1 && O < 0 && (O += xc), f.centerX = _, f.centerY = T, f.ang1 = D, f.ang2 = O;
};
function DJ(i, e, t, n, s, o, r, a = 0, l = 0, d = 0) {
  if (o === 0 || r === 0)
    return;
  const c = Math.sin(a * xc / 360), h = Math.cos(a * xc / 360), f = h * (e - n) / 2 + c * (t - s) / 2, p = -c * (e - n) / 2 + h * (t - s) / 2;
  if (f === 0 && p === 0)
    return;
  o = Math.abs(o), r = Math.abs(r);
  const y = Math.pow(f, 2) / Math.pow(o, 2) + Math.pow(p, 2) / Math.pow(r, 2);
  y > 1 && (o *= Math.sqrt(y), r *= Math.sqrt(y)), $J(
    e,
    t,
    n,
    s,
    o,
    r,
    l,
    d,
    c,
    h,
    f,
    p,
    Ug
  );
  let { ang1: v, ang2: x } = Ug;
  const { centerX: w, centerY: S } = Ug;
  let M = Math.abs(x) / (xc / 4);
  Math.abs(1 - M) < 1e-7 && (M = 1);
  const _ = Math.max(Math.ceil(M), 1);
  x /= _;
  let T = i[i.length - 2], k = i[i.length - 1];
  const P = { x: 0, y: 0 };
  for (let A = 0; A < _; A++) {
    const R = zJ(v, x), { x: D, y: O } = Gg(R[0], o, r, h, c, w, S, P), { x: F, y: te } = Gg(R[1], o, r, h, c, w, S, P), { x: ee, y: me } = Gg(R[2], o, r, h, c, w, S, P);
    PM(
      i,
      T,
      k,
      D,
      O,
      F,
      te,
      ee,
      me
    ), T = ee, k = me, v += x;
  }
}
function OJ(i, e, t) {
  var r;
  const n = (a, l) => {
    const d = l.x - a.x, c = l.y - a.y, h = Math.sqrt(d * d + c * c), f = d / h, p = c / h;
    return { len: h, nx: f, ny: p };
  }, s = (a, l) => {
    a === 0 ? i.moveTo(l.x, l.y) : i.lineTo(l.x, l.y);
  };
  let o = e[e.length - 1];
  for (let a = 0; a < e.length; a++) {
    const l = e[a % e.length], d = (r = l.radius) != null ? r : t;
    if (d <= 0) {
      s(a, l), o = l;
      continue;
    }
    const c = e[(a + 1) % e.length], h = n(l, o), f = n(l, c);
    if (h.len < 1e-4 || f.len < 1e-4) {
      s(a, l), o = l;
      continue;
    }
    let p = Math.asin(h.nx * f.ny - h.ny * f.nx), y = 1, v = !1;
    h.nx * f.nx - h.ny * -f.ny < 0 ? p < 0 ? p = Math.PI + p : (p = Math.PI - p, y = -1, v = !0) : p > 0 && (y = -1, v = !0);
    const x = p / 2;
    let w, S = Math.abs(
      Math.cos(x) * d / Math.sin(x)
    );
    S > Math.min(h.len / 2, f.len / 2) ? (S = Math.min(h.len / 2, f.len / 2), w = Math.abs(S * Math.sin(x) / Math.cos(x))) : w = d;
    const M = l.x + f.nx * S + -f.ny * w * y, _ = l.y + f.ny * S + f.nx * w * y, T = Math.atan2(h.ny, h.nx) + Math.PI / 2 * y, k = Math.atan2(f.ny, f.nx) - Math.PI / 2 * y;
    a === 0 && i.moveTo(
      M + Math.cos(T) * w,
      _ + Math.sin(T) * w
    ), i.arc(M, _, w, T, k, v), o = l;
  }
}
function LJ(i, e, t, n) {
  var a;
  const s = (l, d) => Math.sqrt((l.x - d.x) ** 2 + (l.y - d.y) ** 2), o = (l, d, c) => ({
    x: l.x + (d.x - l.x) * c,
    y: l.y + (d.y - l.y) * c
  }), r = e.length;
  for (let l = 0; l < r; l++) {
    const d = e[(l + 1) % r], c = (a = d.radius) != null ? a : t;
    if (c <= 0) {
      l === 0 ? i.moveTo(d.x, d.y) : i.lineTo(d.x, d.y);
      continue;
    }
    const h = e[l], f = e[(l + 2) % r], p = s(h, d);
    let y;
    if (p < 1e-4)
      y = d;
    else {
      const w = Math.min(p / 2, c);
      y = o(
        d,
        h,
        w / p
      );
    }
    const v = s(f, d);
    let x;
    if (v < 1e-4)
      x = d;
    else {
      const w = Math.min(v / 2, c);
      x = o(
        d,
        f,
        w / v
      );
    }
    l === 0 ? i.moveTo(y.x, y.y) : i.lineTo(y.x, y.y), i.quadraticCurveTo(d.x, d.y, x.x, x.y, n);
  }
}
const BJ = new Tt();
class FJ {
  constructor(e) {
    this.shapePrimitives = [], this._currentPoly = null, this._bounds = new Gn(), this._graphicsPath2D = e, this.signed = e.checkForHoles;
  }
  /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */
  moveTo(e, t) {
    return this.startPoly(e, t), this;
  }
  /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */
  lineTo(e, t) {
    this._ensurePoly();
    const n = this._currentPoly.points, s = n[n.length - 2], o = n[n.length - 1];
    return (s !== e || o !== t) && n.push(e, t), this;
  }
  /**
   * Adds an arc to the path. The arc is centered at (x, y)
   *  position with radius `radius` starting at `startAngle` and ending at `endAngle`.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The radius of the arc.
   * @param startAngle - The starting angle of the arc, in radians.
   * @param endAngle - The ending angle of the arc, in radians.
   * @param counterclockwise - Specifies whether the arc should be drawn in the anticlockwise direction. False by default.
   * @returns The instance of the current object for chaining.
   */
  arc(e, t, n, s, o, r) {
    this._ensurePoly(!1);
    const a = this._currentPoly.points;
    return EM(a, e, t, n, s, o, r), this;
  }
  /**
   * Adds an arc to the path with the arc tangent to the line joining two specified points.
   * The arc radius is specified by `radius`.
   * @param x1 - The x-coordinate of the first point.
   * @param y1 - The y-coordinate of the first point.
   * @param x2 - The x-coordinate of the second point.
   * @param y2 - The y-coordinate of the second point.
   * @param radius - The radius of the arc.
   * @returns The instance of the current object for chaining.
   */
  arcTo(e, t, n, s, o) {
    this._ensurePoly();
    const r = this._currentPoly.points;
    return RJ(r, e, t, n, s, o), this;
  }
  /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */
  arcToSvg(e, t, n, s, o, r, a) {
    const l = this._currentPoly.points;
    return DJ(
      l,
      this._currentPoly.lastX,
      this._currentPoly.lastY,
      r,
      a,
      e,
      t,
      n,
      s,
      o
    ), this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveTo(e, t, n, s, o, r, a) {
    this._ensurePoly();
    const l = this._currentPoly;
    return PM(
      this._currentPoly.points,
      l.lastX,
      l.lastY,
      e,
      t,
      n,
      s,
      o,
      r,
      a
    ), this;
  }
  /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the control point.
   * @param cp1y - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothing - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveTo(e, t, n, s, o) {
    this._ensurePoly();
    const r = this._currentPoly;
    return PJ(
      this._currentPoly.points,
      r.lastX,
      r.lastY,
      e,
      t,
      n,
      s,
      o
    ), this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    return this.endPoly(!0), this;
  }
  /**
   * Adds another path to the current path. This method allows for the combination of multiple paths into one.
   * @param path - The `GraphicsPath` object representing the path to add.
   * @param transform - An optional `Matrix` object to apply a transformation to the path before adding it.
   * @returns The instance of the current object for chaining.
   */
  addPath(e, t) {
    this.endPoly(), t && !t.isIdentity() && (e = e.clone(!0), e.transform(t));
    const n = this.shapePrimitives, s = n.length;
    for (let o = 0; o < e.instructions.length; o++) {
      const r = e.instructions[o];
      this[r.action](...r.data);
    }
    if (e.checkForHoles && n.length - s > 1) {
      let o = null;
      for (let r = s; r < n.length; r++) {
        const a = n[r];
        if (a.shape.type === "polygon") {
          const l = a.shape, d = o == null ? void 0 : o.shape;
          d && d.containsPolygon(l) ? (o.holes || (o.holes = []), o.holes.push(a), n.copyWithin(r, r + 1), n.length--, r--) : o = a;
        }
      }
    }
    return this;
  }
  /**
   * Finalizes the drawing of the current path. Optionally, it can close the path.
   * @param closePath - A boolean indicating whether to close the path after finishing. False by default.
   */
  finish(e = !1) {
    this.endPoly(e);
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(e, t, n, s, o) {
    return this.drawShape(new Tt(e, t, n, s), o), this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(e, t, n, s) {
    return this.drawShape(new ey(e, t, n), s), this;
  }
  /**
   * Draws a polygon shape. This method allows for the creation of complex polygons by specifying a sequence of points.
   * @param points - An array of numbers, or or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  poly(e, t, n) {
    const s = new vc(e);
    return s.closePath = t, this.drawShape(s, n), this;
  }
  /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  regularPoly(e, t, n, s, o = 0, r) {
    s = Math.max(s | 0, 3);
    const a = -1 * Math.PI / 2 + o, l = Math.PI * 2 / s, d = [];
    for (let c = 0; c < s; c++) {
      const h = a - c * l;
      d.push(
        e + n * Math.cos(h),
        t + n * Math.sin(h)
      );
    }
    return this.poly(d, !0, r), this;
  }
  /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param smoothness - Optional parameter to adjust the smoothness of the rounding.
   * @returns The instance of the current object for chaining.
   */
  roundPoly(e, t, n, s, o, r = 0, a) {
    if (s = Math.max(s | 0, 3), o <= 0)
      return this.regularPoly(e, t, n, s, r);
    const l = n * Math.sin(Math.PI / s) - 1e-3;
    o = Math.min(o, l);
    const d = -1 * Math.PI / 2 + r, c = Math.PI * 2 / s, h = (s - 2) * Math.PI / s / 2;
    for (let f = 0; f < s; f++) {
      const p = f * c + d, y = e + n * Math.cos(p), v = t + n * Math.sin(p), x = p + Math.PI + h, w = p - Math.PI - h, S = y + o * Math.cos(x), M = v + o * Math.sin(x), _ = y + o * Math.cos(w), T = v + o * Math.sin(w);
      f === 0 ? this.moveTo(S, M) : this.lineTo(S, M), this.quadraticCurveTo(y, v, _, T, a);
    }
    return this.closePath();
  }
  /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */
  roundShape(e, t, n = !1, s) {
    return e.length < 3 ? this : (n ? LJ(this, e, t, s) : OJ(this, e, t), this.closePath());
  }
  /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */
  filletRect(e, t, n, s, o) {
    if (o === 0)
      return this.rect(e, t, n, s);
    const r = Math.min(n, s) / 2, a = Math.min(r, Math.max(-r, o)), l = e + n, d = t + s, c = a < 0 ? -a : 0, h = Math.abs(a);
    return this.moveTo(e, t + h).arcTo(e + c, t + c, e + h, t, h).lineTo(l - h, t).arcTo(l - c, t + c, l, t + h, h).lineTo(l, d - h).arcTo(l - c, d - c, e + n - h, d, h).lineTo(e + h, d).arcTo(e + c, d - c, e, d - h, h).closePath();
  }
  /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */
  chamferRect(e, t, n, s, o, r) {
    if (o <= 0)
      return this.rect(e, t, n, s);
    const a = Math.min(o, Math.min(n, s) / 2), l = e + n, d = t + s, c = [
      e + a,
      t,
      l - a,
      t,
      l,
      t + a,
      l,
      d - a,
      l - a,
      d,
      e + a,
      d,
      e,
      d - a,
      e,
      t + a
    ];
    for (let h = c.length - 1; h >= 2; h -= 2)
      c[h] === c[h - 2] && c[h - 1] === c[h - 3] && c.splice(h - 1, 2);
    return this.poly(c, !0, r);
  }
  /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @param transform - An optional `Matrix` object to apply a transformation to the ellipse. This can include rotations.
   * @returns The instance of the current object for chaining.
   */
  ellipse(e, t, n, s, o) {
    return this.drawShape(new ty(e, t, n, s), o), this;
  }
  /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  roundRect(e, t, n, s, o, r) {
    return this.drawShape(new ny(e, t, n, s, o), r), this;
  }
  /**
   * Draws a given shape on the canvas.
   * This is a generic method that can draw any type of shape specified by the `ShapePrimitive` parameter.
   * An optional transformation matrix can be applied to the shape, allowing for complex transformations.
   * @param shape - The shape to draw, defined as a `ShapePrimitive` object.
   * @param matrix - An optional `Matrix` for transforming the shape. This can include rotations,
   * scaling, and translations.
   * @returns The instance of the current object for chaining.
   */
  drawShape(e, t) {
    return this.endPoly(), this.shapePrimitives.push({ shape: e, transform: t }), this;
  }
  /**
   * Starts a new polygon path from the specified starting point.
   * This method initializes a new polygon or ends the current one if it exists.
   * @param x - The x-coordinate of the starting point of the new polygon.
   * @param y - The y-coordinate of the starting point of the new polygon.
   * @returns The instance of the current object for chaining.
   */
  startPoly(e, t) {
    let n = this._currentPoly;
    return n && this.endPoly(), n = new vc(), n.points.push(e, t), this._currentPoly = n, this;
  }
  /**
   * Ends the current polygon path. If `closePath` is set to true,
   * the path is closed by connecting the last point to the first one.
   * This method finalizes the current polygon and prepares it for drawing or adding to the shape primitives.
   * @param closePath - A boolean indicating whether to close the polygon by connecting the last point
   *  back to the starting point. False by default.
   * @returns The instance of the current object for chaining.
   */
  endPoly(e = !1) {
    const t = this._currentPoly;
    return t && t.points.length > 2 && (t.closePath = e, this.shapePrimitives.push({ shape: t })), this._currentPoly = null, this;
  }
  _ensurePoly(e = !0) {
    if (!this._currentPoly && (this._currentPoly = new vc(), e)) {
      const t = this.shapePrimitives[this.shapePrimitives.length - 1];
      if (t) {
        let n = t.shape.x, s = t.shape.y;
        if (t.transform && !t.transform.isIdentity()) {
          const o = t.transform, r = n;
          n = o.a * n + o.c * s + o.tx, s = o.b * r + o.d * s + o.ty;
        }
        this._currentPoly.points.push(n, s);
      } else
        this._currentPoly.points.push(0, 0);
    }
  }
  /** Builds the path. */
  buildPath() {
    const e = this._graphicsPath2D;
    this.shapePrimitives.length = 0, this._currentPoly = null;
    for (let t = 0; t < e.instructions.length; t++) {
      const n = e.instructions[t];
      this[n.action](...n.data);
    }
    this.finish();
  }
  /** Gets the bounds of the path. */
  get bounds() {
    const e = this._bounds;
    e.clear();
    const t = this.shapePrimitives;
    for (let n = 0; n < t.length; n++) {
      const s = t[n], o = s.shape.getBounds(BJ);
      s.transform ? e.addRect(o, s.transform) : e.addRect(o);
    }
    return e;
  }
}
class to {
  /**
   * Creates a `GraphicsPath` instance optionally from an SVG path string or an array of `PathInstruction`.
   * @param instructions - An SVG path string or an array of `PathInstruction` objects.
   * @param signed
   */
  constructor(e, t = !1) {
    var n;
    this.instructions = [], this.uid = Nt("graphicsPath"), this._dirty = !0, this.checkForHoles = t, typeof e == "string" ? _X(e, this) : this.instructions = (n = e == null ? void 0 : e.slice()) != null ? n : [];
  }
  /**
   * Provides access to the internal shape path, ensuring it is up-to-date with the current instructions.
   * @returns The `ShapePath` instance associated with this `GraphicsPath`.
   */
  get shapePath() {
    return this._shapePath || (this._shapePath = new FJ(this)), this._dirty && (this._dirty = !1, this._shapePath.buildPath()), this._shapePath;
  }
  /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @param transform - An optional transformation to apply to the added path.
   * @returns The instance of the current object for chaining.
   */
  addPath(e, t) {
    return e = e.clone(), this.instructions.push({ action: "addPath", data: [e, t] }), this._dirty = !0, this;
  }
  arc(...e) {
    return this.instructions.push({ action: "arc", data: e }), this._dirty = !0, this;
  }
  arcTo(...e) {
    return this.instructions.push({ action: "arcTo", data: e }), this._dirty = !0, this;
  }
  arcToSvg(...e) {
    return this.instructions.push({ action: "arcToSvg", data: e }), this._dirty = !0, this;
  }
  bezierCurveTo(...e) {
    return this.instructions.push({ action: "bezierCurveTo", data: e }), this._dirty = !0, this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires two points: the second control point and the end point. The first control point is assumed to be
   * The starting point is the last point in the current path.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveToShort(e, t, n, s, o) {
    const r = this.instructions[this.instructions.length - 1], a = this.getLastPoint(Wt.shared);
    let l = 0, d = 0;
    if (!r || r.action !== "bezierCurveTo")
      l = a.x, d = a.y;
    else {
      l = r.data[2], d = r.data[3];
      const c = a.x, h = a.y;
      l = c + (c - l), d = h + (h - d);
    }
    return this.instructions.push({ action: "bezierCurveTo", data: [l, d, e, t, n, s, o] }), this._dirty = !0, this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    return this.instructions.push({ action: "closePath", data: [] }), this._dirty = !0, this;
  }
  ellipse(...e) {
    return this.instructions.push({ action: "ellipse", data: e }), this._dirty = !0, this;
  }
  lineTo(...e) {
    return this.instructions.push({ action: "lineTo", data: e }), this._dirty = !0, this;
  }
  moveTo(...e) {
    return this.instructions.push({ action: "moveTo", data: e }), this;
  }
  quadraticCurveTo(...e) {
    return this.instructions.push({ action: "quadraticCurveTo", data: e }), this._dirty = !0, this;
  }
  /**
   * Adds a quadratic curve to the path. It uses the previous point as the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveToShort(e, t, n) {
    const s = this.instructions[this.instructions.length - 1], o = this.getLastPoint(Wt.shared);
    let r = 0, a = 0;
    if (!s || s.action !== "quadraticCurveTo")
      r = o.x, a = o.y;
    else {
      r = s.data[0], a = s.data[1];
      const l = o.x, d = o.y;
      r = l + (l - r), a = d + (d - a);
    }
    return this.instructions.push({ action: "quadraticCurveTo", data: [r, a, e, t, n] }), this._dirty = !0, this;
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(e, t, n, s, o) {
    return this.instructions.push({ action: "rect", data: [e, t, n, s, o] }), this._dirty = !0, this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(e, t, n, s) {
    return this.instructions.push({ action: "circle", data: [e, t, n, s] }), this._dirty = !0, this;
  }
  roundRect(...e) {
    return this.instructions.push({ action: "roundRect", data: e }), this._dirty = !0, this;
  }
  poly(...e) {
    return this.instructions.push({ action: "poly", data: e }), this._dirty = !0, this;
  }
  regularPoly(...e) {
    return this.instructions.push({ action: "regularPoly", data: e }), this._dirty = !0, this;
  }
  roundPoly(...e) {
    return this.instructions.push({ action: "roundPoly", data: e }), this._dirty = !0, this;
  }
  roundShape(...e) {
    return this.instructions.push({ action: "roundShape", data: e }), this._dirty = !0, this;
  }
  filletRect(...e) {
    return this.instructions.push({ action: "filletRect", data: e }), this._dirty = !0, this;
  }
  chamferRect(...e) {
    return this.instructions.push({ action: "chamferRect", data: e }), this._dirty = !0, this;
  }
  /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @param transform - An optional `Matrix` object to apply a transformation to the star.
   * This can include rotations, scaling, and translations.
   * @returns The instance of the current object for chaining further drawing commands.
   */
  // eslint-disable-next-line max-len
  star(e, t, n, s, o, r, a) {
    o || (o = s / 2);
    const l = -1 * Math.PI / 2 + r, d = n * 2, c = Math.PI * 2 / d, h = [];
    for (let f = 0; f < d; f++) {
      const p = f % 2 ? o : s, y = f * c + l;
      h.push(
        e + p * Math.cos(y),
        t + p * Math.sin(y)
      );
    }
    return this.poly(h, !0, a), this;
  }
  /**
   * Creates a copy of the current `GraphicsPath` instance. This method supports both shallow and deep cloning.
   * A shallow clone copies the reference of the instructions array, while a deep clone creates a new array and
   * copies each instruction individually, ensuring that modifications to the instructions of the cloned `GraphicsPath`
   * do not affect the original `GraphicsPath` and vice versa.
   * @param deep - A boolean flag indicating whether the clone should be deep.
   * @returns A new `GraphicsPath` instance that is a clone of the current instance.
   */
  clone(e = !1) {
    const t = new to();
    if (t.checkForHoles = this.checkForHoles, !e)
      t.instructions = this.instructions.slice();
    else
      for (let n = 0; n < this.instructions.length; n++) {
        const s = this.instructions[n];
        t.instructions.push({ action: s.action, data: s.data.slice() });
      }
    return t;
  }
  clear() {
    return this.instructions.length = 0, this._dirty = !0, this;
  }
  /**
   * Applies a transformation matrix to all drawing instructions within the `GraphicsPath`.
   * This method enables the modification of the path's geometry according to the provided
   * transformation matrix, which can include translations, rotations, scaling, and skewing.
   *
   * Each drawing instruction in the path is updated to reflect the transformation,
   * ensuring the visual representation of the path is consistent with the applied matrix.
   *
   * Note: The transformation is applied directly to the coordinates and control points of the drawing instructions,
   * not to the path as a whole. This means the transformation's effects are baked into the individual instructions,
   * allowing for fine-grained control over the path's appearance.
   * @param matrix - A `Matrix` object representing the transformation to apply.
   * @returns The instance of the current object for chaining further operations.
   */
  transform(e) {
    if (e.isIdentity()) return this;
    const t = e.a, n = e.b, s = e.c, o = e.d, r = e.tx, a = e.ty;
    let l = 0, d = 0, c = 0, h = 0, f = 0, p = 0, y = 0, v = 0;
    for (let x = 0; x < this.instructions.length; x++) {
      const w = this.instructions[x], S = w.data;
      switch (w.action) {
        case "moveTo":
        case "lineTo":
          l = S[0], d = S[1], S[0] = t * l + s * d + r, S[1] = n * l + o * d + a;
          break;
        case "bezierCurveTo":
          c = S[0], h = S[1], f = S[2], p = S[3], l = S[4], d = S[5], S[0] = t * c + s * h + r, S[1] = n * c + o * h + a, S[2] = t * f + s * p + r, S[3] = n * f + o * p + a, S[4] = t * l + s * d + r, S[5] = n * l + o * d + a;
          break;
        case "quadraticCurveTo":
          c = S[0], h = S[1], l = S[2], d = S[3], S[0] = t * c + s * h + r, S[1] = n * c + o * h + a, S[2] = t * l + s * d + r, S[3] = n * l + o * d + a;
          break;
        case "arcToSvg":
          l = S[5], d = S[6], y = S[0], v = S[1], S[0] = t * y + s * v, S[1] = n * y + o * v, S[5] = t * l + s * d + r, S[6] = n * l + o * d + a;
          break;
        case "circle":
          S[4] = Aa(S[3], e);
          break;
        case "rect":
          S[4] = Aa(S[4], e);
          break;
        case "ellipse":
          S[8] = Aa(S[8], e);
          break;
        case "roundRect":
          S[5] = Aa(S[5], e);
          break;
        case "addPath":
          S[0].transform(e);
          break;
        case "poly":
          S[2] = Aa(S[2], e);
          break;
        case "regularPoly":
        case "chamferRect":
          S[5] = Aa(S[5], e);
          break;
        case "closePath":
          break;
        default:
          dt("unknown transform action", w.action);
          break;
      }
    }
    return this._dirty = !0, this;
  }
  get bounds() {
    return this.shapePath.bounds;
  }
  /**
   * Retrieves the last point from the current drawing instructions in the `GraphicsPath`.
   * This method is useful for operations that depend on the path's current endpoint,
   * such as connecting subsequent shapes or paths. It supports various drawing instructions,
   * ensuring the last point's position is accurately determined regardless of the path's complexity.
   *
   * If the last instruction is a `closePath`, the method iterates backward through the instructions
   *  until it finds an actionable instruction that defines a point (e.g., `moveTo`, `lineTo`,
   * `quadraticCurveTo`, etc.). For compound paths added via `addPath`, it recursively retrieves
   * the last point from the nested path.
   * @param out - A `Point` object where the last point's coordinates will be stored.
   * This object is modified directly to contain the result.
   * @returns The `Point` object containing the last point's coordinates.
   */
  getLastPoint(e) {
    let t = this.instructions.length - 1, n = this.instructions[t];
    if (!n)
      return e.x = 0, e.y = 0, e;
    for (; n.action === "closePath"; ) {
      if (t--, t < 0)
        return e.x = 0, e.y = 0, e;
      n = this.instructions[t];
    }
    switch (n.action) {
      case "moveTo":
      case "lineTo":
        e.x = n.data[0], e.y = n.data[1];
        break;
      case "quadraticCurveTo":
        e.x = n.data[2], e.y = n.data[3];
        break;
      case "bezierCurveTo":
        e.x = n.data[4], e.y = n.data[5];
        break;
      case "arc":
      case "arcToSvg":
        e.x = n.data[5], e.y = n.data[6];
        break;
      case "addPath":
        n.data[0].getLastPoint(e);
        break;
    }
    return e;
  }
}
function Aa(i, e) {
  return i ? i.prepend(e) : e.clone();
}
function Cn(i, e, t) {
  const n = i.getAttribute(e);
  return n ? Number(n) : t;
}
function NJ(i, e) {
  const t = i.querySelectorAll("defs");
  for (let n = 0; n < t.length; n++) {
    const s = t[n];
    for (let o = 0; o < s.children.length; o++) {
      const r = s.children[o];
      switch (r.nodeName.toLowerCase()) {
        case "lineargradient":
          e.defs[r.id] = UJ(r);
          break;
        case "radialgradient":
          e.defs[r.id] = GJ(r);
          break;
      }
    }
  }
}
function qi(i, e, t) {
  const n = i.getAttribute(e);
  if (n != null && n.trim().endsWith("%")) {
    const s = Number(n.trim().slice(0, -1));
    return Number.isNaN(s) ? t : s / 100;
  }
  return Cn(i, e, t);
}
function RM(i) {
  return (i.getAttribute("gradientUnits") || "objectBoundingBox") === "objectBoundingBox" ? "local" : "global";
}
function zM(i) {
  const e = [];
  for (let t = 0; t < i.children.length; t++) {
    const n = i.children[t], s = qi(n, "offset", 0), o = bn.shared.setValue(n.getAttribute("stop-color")).toNumber();
    e.push({ offset: s, color: o });
  }
  return e;
}
function UJ(i) {
  const e = qi(i, "x1", 0), t = qi(i, "y1", 0), n = qi(i, "x2", 1), s = qi(i, "y2", 0);
  return new Jl({
    type: "linear",
    start: { x: e, y: t },
    end: { x: n, y: s },
    textureSpace: RM(i),
    colorStops: zM(i)
  });
}
function GJ(i) {
  const e = qi(i, "cx", 0.5), t = qi(i, "cy", 0.5), n = qi(i, "r", 0.5), s = qi(i, "fx", e), o = qi(i, "fy", t), r = qi(i, "fr", 0);
  return new Jl({
    type: "radial",
    center: { x: s, y: o },
    innerRadius: r,
    outerCenter: { x: e, y: t },
    outerRadius: n,
    textureSpace: RM(i),
    colorStops: zM(i)
  });
}
function b2(i) {
  const e = i.match(/url\s*\(\s*['"]?\s*#([^'"\s)]+)\s*['"]?\s*\)/i);
  return e ? e[1] : "";
}
const v2 = {
  // Fill properties
  fill: { type: "paint", default: 0 },
  // Fill color/gradient
  "fill-opacity": { type: "number", default: 1 },
  // Fill transparency
  // Stroke properties
  stroke: { type: "paint", default: 0 },
  // Stroke color/gradient
  "stroke-width": { type: "number", default: 1 },
  // Width of stroke
  "stroke-opacity": { type: "number", default: 1 },
  // Stroke transparency
  "stroke-linecap": { type: "string", default: "butt" },
  // End cap style: butt, round, square
  "stroke-linejoin": { type: "string", default: "miter" },
  // Join style: miter, round, bevel
  "stroke-miterlimit": { type: "number", default: 10 },
  // Limit on miter join sharpness
  "stroke-dasharray": { type: "string", default: "none" },
  // Dash pattern
  "stroke-dashoffset": { type: "number", default: 0 },
  // Offset for dash pattern
  // Global properties
  opacity: { type: "number", default: 1 }
  // Overall opacity
};
function $M(i, e) {
  const t = i.getAttribute("style"), n = {}, s = {}, o = {
    strokeStyle: n,
    fillStyle: s,
    useFill: !1,
    useStroke: !1
  };
  for (const r in v2) {
    const a = i.getAttribute(r);
    a && y2(e, o, r, a.trim());
  }
  if (t) {
    const r = t.split(";");
    for (let a = 0; a < r.length; a++) {
      const l = r[a].trim(), [d, c] = l.split(":");
      v2[d] && y2(e, o, d, c.trim());
    }
  }
  return {
    strokeStyle: o.useStroke ? n : null,
    fillStyle: o.useFill ? s : null,
    useFill: o.useFill,
    useStroke: o.useStroke
  };
}
function y2(i, e, t, n) {
  switch (t) {
    case "stroke":
      if (n !== "none") {
        if (n.startsWith("url(")) {
          const s = b2(n);
          e.strokeStyle.fill = i.defs[s];
        } else
          e.strokeStyle.color = bn.shared.setValue(n).toNumber();
        e.useStroke = !0;
      }
      break;
    case "stroke-width":
      e.strokeStyle.width = Number(n);
      break;
    case "fill":
      if (n !== "none") {
        if (n.startsWith("url(")) {
          const s = b2(n);
          e.fillStyle.fill = i.defs[s];
        } else
          e.fillStyle.color = bn.shared.setValue(n).toNumber();
        e.useFill = !0;
      }
      break;
    case "fill-opacity":
      e.fillStyle.alpha = Number(n);
      break;
    case "stroke-opacity":
      e.strokeStyle.alpha = Number(n);
      break;
    case "opacity":
      e.fillStyle.alpha = Number(n), e.strokeStyle.alpha = Number(n);
      break;
  }
}
function jJ(i) {
  if (i.length <= 2)
    return !0;
  const e = i.map((a) => a.area).sort((a, l) => l - a), [t, n] = e, s = e[e.length - 1], o = t / n, r = n / s;
  return !(o > 3 && r < 2);
}
function HJ(i) {
  return i.split(/(?=[Mm])/).filter((n) => n.trim().length > 0);
}
function VJ(i) {
  const e = i.match(/[-+]?[0-9]*\.?[0-9]+/g);
  if (!e || e.length < 4) return 0;
  const t = e.map(Number), n = [], s = [];
  for (let c = 0; c < t.length; c += 2)
    c + 1 < t.length && (n.push(t[c]), s.push(t[c + 1]));
  if (n.length === 0 || s.length === 0) return 0;
  const o = Math.min(...n), r = Math.max(...n), a = Math.min(...s), l = Math.max(...s);
  return (r - o) * (l - a);
}
function x2(i, e) {
  const t = new to(i, !1);
  for (const n of t.instructions)
    e.instructions.push(n);
}
function WJ(i, e) {
  if (typeof i == "string") {
    const r = document.createElement("div");
    r.innerHTML = i.trim(), i = r.querySelector("svg");
  }
  const t = {
    context: e,
    defs: {},
    path: new to()
  };
  NJ(i, t);
  const n = i.children, { fillStyle: s, strokeStyle: o } = $M(i, t);
  for (let r = 0; r < n.length; r++) {
    const a = n[r];
    a.nodeName.toLowerCase() !== "defs" && DM(a, t, s, o);
  }
  return e;
}
function DM(i, e, t, n) {
  const s = i.children, { fillStyle: o, strokeStyle: r } = $M(i, e);
  o && t ? t = { ...t, ...o } : o && (t = o), r && n ? n = { ...n, ...r } : r && (n = r);
  const a = !t && !n;
  a && (t = { color: 0 });
  let l, d, c, h, f, p, y, v, x, w, S, M, _, T, k, P, A;
  switch (i.nodeName.toLowerCase()) {
    case "path": {
      T = i.getAttribute("d");
      const R = i.getAttribute("fill-rule"), D = HJ(T), O = R === "evenodd", F = D.length > 1;
      if (O && F) {
        const ee = D.map((L) => ({
          path: L,
          area: VJ(L)
        }));
        if (ee.sort((L, N) => N.area - L.area), D.length > 3 || !jJ(ee))
          for (let L = 0; L < ee.length; L++) {
            const N = ee[L], X = L === 0;
            e.context.beginPath();
            const B = new to(void 0, !0);
            x2(N.path, B), e.context.path(B), X ? (t && e.context.fill(t), n && e.context.stroke(n)) : e.context.cut();
          }
        else
          for (let L = 0; L < ee.length; L++) {
            const N = ee[L], X = L % 2 === 1;
            e.context.beginPath();
            const B = new to(void 0, !0);
            x2(N.path, B), e.context.path(B), X ? e.context.cut() : (t && e.context.fill(t), n && e.context.stroke(n));
          }
      } else {
        const ee = R ? R === "evenodd" : !0;
        k = new to(T, ee), e.context.path(k), t && e.context.fill(t), n && e.context.stroke(n);
      }
      break;
    }
    case "circle":
      y = Cn(i, "cx", 0), v = Cn(i, "cy", 0), x = Cn(i, "r", 0), e.context.ellipse(y, v, x, x), t && e.context.fill(t), n && e.context.stroke(n);
      break;
    case "rect":
      l = Cn(i, "x", 0), d = Cn(i, "y", 0), P = Cn(i, "width", 0), A = Cn(i, "height", 0), w = Cn(i, "rx", 0), S = Cn(i, "ry", 0), w || S ? e.context.roundRect(l, d, P, A, w || S) : e.context.rect(l, d, P, A), t && e.context.fill(t), n && e.context.stroke(n);
      break;
    case "ellipse":
      y = Cn(i, "cx", 0), v = Cn(i, "cy", 0), w = Cn(i, "rx", 0), S = Cn(i, "ry", 0), e.context.beginPath(), e.context.ellipse(y, v, w, S), t && e.context.fill(t), n && e.context.stroke(n);
      break;
    case "line":
      c = Cn(i, "x1", 0), h = Cn(i, "y1", 0), f = Cn(i, "x2", 0), p = Cn(i, "y2", 0), e.context.beginPath(), e.context.moveTo(c, h), e.context.lineTo(f, p), n && e.context.stroke(n);
      break;
    case "polygon":
      _ = i.getAttribute("points"), M = _.match(/-?\d+/g).map((R) => parseInt(R, 10)), e.context.poly(M, !0), t && e.context.fill(t), n && e.context.stroke(n);
      break;
    case "polyline":
      _ = i.getAttribute("points"), M = _.match(/-?\d+/g).map((R) => parseInt(R, 10)), e.context.poly(M, !1), n && e.context.stroke(n);
      break;
    // Group elements - just process children
    case "g":
    case "svg":
      break;
    default: {
      dt(`[SVG parser] <${i.nodeName}> elements unsupported`);
      break;
    }
  }
  a && (t = null);
  for (let R = 0; R < s.length; R++)
    DM(s[R], e, t, n);
}
function qJ(i) {
  return i.texture !== void 0;
}
const w2 = {
  repeat: {
    addressModeU: "repeat",
    addressModeV: "repeat"
  },
  "repeat-x": {
    addressModeU: "repeat",
    addressModeV: "clamp-to-edge"
  },
  "repeat-y": {
    addressModeU: "clamp-to-edge",
    addressModeV: "repeat"
  },
  "no-repeat": {
    addressModeU: "clamp-to-edge",
    addressModeV: "clamp-to-edge"
  }
};
class OM {
  constructor(e, t) {
    var o;
    this.uid = Nt("fillPattern"), this._tick = 0, this.transform = new st();
    const n = qJ(e) ? e : { texture: e, repetition: t };
    this.texture = n.texture, this.textureSpace = (o = n.textureSpace) != null ? o : "global";
    const s = n.repetition;
    s && (this.texture.source.style.addressModeU = w2[s].addressModeU, this.texture.source.style.addressModeV = w2[s].addressModeV);
  }
  /**
   * Sets the transform for the pattern
   * @param transform - The transform matrix to apply to the pattern.
   * If not provided, the pattern will use the default transform.
   */
  setTransform(e) {
    if (e) {
      if (this.transform.equals(e)) return;
      this.transform.copyFrom(e);
    } else {
      if (this.transform.isIdentity()) return;
      this.transform.identity();
    }
    this._tick++;
  }
  /** Internal texture used to render the gradient */
  get texture() {
    return this._texture;
  }
  set texture(e) {
    this._texture !== e && (this._texture = e, this._tick++);
  }
  /**
   * Returns a unique key for this instance.
   * This key is used for caching.
   * @returns {string} Unique key for the instance
   */
  get styleKey() {
    return `fill-pattern-${this.uid}-${this._tick}`;
  }
  /** Destroys the fill pattern, releasing resources. This will also destroy the internal texture. */
  destroy() {
    this.texture.destroy(!0), this.texture = null;
  }
}
function KJ(i) {
  return bn.isColorLike(i);
}
function k2(i) {
  return i instanceof OM;
}
function _2(i) {
  return i instanceof Jl;
}
function YJ(i) {
  return i instanceof et;
}
function XJ(i, e, t) {
  const n = bn.shared.setValue(e != null ? e : 0);
  return i.color = n.toNumber(), i.alpha = n.alpha === 1 ? t.alpha : n.alpha, i.texture = et.WHITE, { ...t, ...i };
}
function JJ(i, e, t) {
  return i.texture = e, { ...t, ...i };
}
function S2(i, e, t) {
  return i.fill = e, i.color = 16777215, i.texture = e.texture, i.matrix = e.transform, i.textureSpace = e.textureSpace, { ...t, ...i };
}
function M2(i, e, t) {
  return e.buildGradient(), i.fill = e, i.color = 16777215, i.texture = e.texture, i.matrix = e.transform, i.textureSpace = e.textureSpace, { ...t, ...i };
}
function ZJ(i, e) {
  const t = { ...e, ...i }, n = bn.shared.setValue(t.color);
  return t.alpha *= n.alpha, t.color = n.toNumber(), t;
}
function Yd(i, e) {
  if (i == null)
    return null;
  const t = {}, n = i;
  return KJ(i) ? XJ(t, i, e) : YJ(i) ? JJ(t, i, e) : k2(i) ? S2(t, i, e) : _2(i) ? M2(t, i, e) : n.fill && k2(n.fill) ? S2(n, n.fill, e) : n.fill && _2(n.fill) ? M2(n, n.fill, e) : ZJ(n, e);
}
function T2(i, e) {
  const { width: t, alignment: n, miterLimit: s, cap: o, join: r, pixelLine: a, ...l } = e, d = Yd(i, l);
  return d ? {
    width: t,
    alignment: n,
    miterLimit: s,
    cap: o,
    join: r,
    pixelLine: a,
    ...d
  } : null;
}
function QJ(i, e) {
  let t = 1;
  const n = i.shapePath.shapePrimitives;
  for (let s = 0; s < n.length; s++) {
    const o = n[s].shape;
    if (o.type !== "polygon") continue;
    const r = o.points, a = r.length;
    if (a < 6) continue;
    const l = o.closePath;
    for (let d = 0; d < a; d += 2) {
      if (!l && (d === 0 || d === a - 2)) continue;
      const c = (d - 2 + a) % a, h = (d + 2) % a, f = r[c], p = r[c + 1], y = r[d], v = r[d + 1], x = r[h], w = r[h + 1], S = f - y, M = p - v, _ = x - y, T = w - v, k = S * S + M * M, P = _ * _ + T * T;
      if (k < 1e-12 || P < 1e-12) continue;
      let D = (S * _ + M * T) / Math.sqrt(k * P);
      D < -1 ? D = -1 : D > 1 && (D = 1);
      const O = Math.sqrt((1 - D) * 0.5);
      if (O < 1e-6) continue;
      const F = Math.min(1 / O, e);
      F > t && (t = F);
    }
  }
  return t;
}
const eZ = new Wt(), C2 = new st(), fy = class ps extends bi {
  constructor() {
    super(...arguments), this._gpuData = /* @__PURE__ */ Object.create(null), this.autoGarbageCollect = !0, this._gcLastUsed = -1, this.uid = Nt("graphicsContext"), this.dirty = !0, this.batchMode = "auto", this.instructions = [], this.destroyed = !1, this._activePath = new to(), this._transform = new st(), this._fillStyle = { ...ps.defaultFillStyle }, this._strokeStyle = { ...ps.defaultStrokeStyle }, this._stateStack = [], this._tick = 0, this._bounds = new Gn(), this._boundsDirty = !0;
  }
  /**
   * Creates a new GraphicsContext object that is a clone of this instance, copying all properties,
   * including the current drawing state, transformations, styles, and instructions.
   * @returns A new GraphicsContext instance with the same properties and state as this one.
   */
  clone() {
    const e = new ps();
    return e.batchMode = this.batchMode, e.instructions = this.instructions.slice(), e._activePath = this._activePath.clone(), e._transform = this._transform.clone(), e._fillStyle = { ...this._fillStyle }, e._strokeStyle = { ...this._strokeStyle }, e._stateStack = this._stateStack.slice(), e._bounds = this._bounds.clone(), e._boundsDirty = !0, e;
  }
  /**
   * The current fill style of the graphics context. This can be a color, gradient, pattern, or a more complex style defined by a FillStyle object.
   */
  get fillStyle() {
    return this._fillStyle;
  }
  set fillStyle(e) {
    this._fillStyle = Yd(e, ps.defaultFillStyle);
  }
  /**
   * The current stroke style of the graphics context. Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   */
  get strokeStyle() {
    return this._strokeStyle;
  }
  set strokeStyle(e) {
    this._strokeStyle = T2(e, ps.defaultStrokeStyle);
  }
  /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param style - The fill style to apply. This can be a simple color, a gradient or pattern object,
   *                or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setFillStyle(e) {
    return this._fillStyle = Yd(e, ps.defaultFillStyle), this;
  }
  /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param style - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   *                or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setStrokeStyle(e) {
    return this._strokeStyle = Yd(e, ps.defaultStrokeStyle), this;
  }
  texture(e, t, n, s, o, r) {
    return this.instructions.push({
      action: "texture",
      data: {
        image: e,
        dx: n || 0,
        dy: s || 0,
        dw: o || e.frame.width,
        dh: r || e.frame.height,
        transform: this._transform.clone(),
        alpha: this._fillStyle.alpha,
        style: t || t === 0 ? bn.shared.setValue(t).toNumber() : 16777215
      }
    }), this.onUpdate(), this;
  }
  /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  beginPath() {
    return this._activePath = new to(), this;
  }
  fill(e, t) {
    let n;
    const s = this.instructions[this.instructions.length - 1];
    return this._tick === 0 && (s == null ? void 0 : s.action) === "stroke" ? n = s.data.path : n = this._activePath.clone(), n ? (e != null && (t !== void 0 && typeof e == "number" && (rt(dn, "GraphicsContext.fill(color, alpha) is deprecated, use GraphicsContext.fill({ color, alpha }) instead"), e = { color: e, alpha: t }), this._fillStyle = Yd(e, ps.defaultFillStyle)), this.instructions.push({
      action: "fill",
      // TODO copy fill style!
      data: { style: this.fillStyle, path: n }
    }), this.onUpdate(), this._initNextPathLocation(), this._tick = 0, this) : this;
  }
  _initNextPathLocation() {
    const { x: e, y: t } = this._activePath.getLastPoint(Wt.shared);
    this._activePath.clear(), this._activePath.moveTo(e, t);
  }
  /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillInput parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param style - (Optional) The stroke style to apply. Can be defined as a simple color or a more complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  stroke(e) {
    let t;
    const n = this.instructions[this.instructions.length - 1];
    return this._tick === 0 && (n == null ? void 0 : n.action) === "fill" ? t = n.data.path : t = this._activePath.clone(), t ? (e != null && (this._strokeStyle = T2(e, ps.defaultStrokeStyle)), this.instructions.push({
      action: "stroke",
      // TODO copy fill style!
      data: { style: this.strokeStyle, path: t }
    }), this.onUpdate(), this._initNextPathLocation(), this._tick = 0, this) : this;
  }
  /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  cut() {
    for (let e = 0; e < 2; e++) {
      const t = this.instructions[this.instructions.length - 1 - e], n = this._activePath.clone();
      if (t && (t.action === "stroke" || t.action === "fill"))
        if (t.data.hole)
          t.data.hole.addPath(n);
        else {
          t.data.hole = n;
          break;
        }
    }
    return this._initNextPathLocation(), this;
  }
  /**
   * Adds an arc to the current path, which is centered at (x, y) with the specified radius,
   * starting and ending angles, and direction.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The arc's radius.
   * @param startAngle - The starting angle, in radians.
   * @param endAngle - The ending angle, in radians.
   * @param counterclockwise - (Optional) Specifies whether the arc is drawn counterclockwise (true) or clockwise (false). Defaults to false.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  arc(e, t, n, s, o, r) {
    this._tick++;
    const a = this._transform;
    return this._activePath.arc(
      a.a * e + a.c * t + a.tx,
      a.b * e + a.d * t + a.ty,
      n,
      s,
      o,
      r
    ), this;
  }
  /**
   * Adds an arc to the current path with the given control points and radius, connected to the previous point
   * by a straight line if necessary.
   * @param x1 - The x-coordinate of the first control point.
   * @param y1 - The y-coordinate of the first control point.
   * @param x2 - The x-coordinate of the second control point.
   * @param y2 - The y-coordinate of the second control point.
   * @param radius - The arc's radius.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  arcTo(e, t, n, s, o) {
    this._tick++;
    const r = this._transform;
    return this._activePath.arcTo(
      r.a * e + r.c * t + r.tx,
      r.b * e + r.d * t + r.ty,
      r.a * n + r.c * s + r.tx,
      r.b * n + r.d * s + r.ty,
      o
    ), this;
  }
  /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */
  arcToSvg(e, t, n, s, o, r, a) {
    this._tick++;
    const l = this._transform;
    return this._activePath.arcToSvg(
      e,
      t,
      n,
      // should we rotate this with transform??
      s,
      o,
      l.a * r + l.c * a + l.tx,
      l.b * r + l.d * a + l.ty
    ), this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveTo(e, t, n, s, o, r, a) {
    this._tick++;
    const l = this._transform;
    return this._activePath.bezierCurveTo(
      l.a * e + l.c * t + l.tx,
      l.b * e + l.d * t + l.ty,
      l.a * n + l.c * s + l.tx,
      l.b * n + l.d * s + l.ty,
      l.a * o + l.c * r + l.tx,
      l.b * o + l.d * r + l.ty,
      a
    ), this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    var e;
    return this._tick++, (e = this._activePath) == null || e.closePath(), this;
  }
  /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @returns The instance of the current object for chaining.
   */
  ellipse(e, t, n, s) {
    return this._tick++, this._activePath.ellipse(e, t, n, s, this._transform.clone()), this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(e, t, n) {
    return this._tick++, this._activePath.circle(e, t, n, this._transform.clone()), this;
  }
  /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @returns The instance of the current object for chaining.
   */
  path(e) {
    return this._tick++, this._activePath.addPath(e, this._transform.clone()), this;
  }
  /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */
  lineTo(e, t) {
    this._tick++;
    const n = this._transform;
    return this._activePath.lineTo(
      n.a * e + n.c * t + n.tx,
      n.b * e + n.d * t + n.ty
    ), this;
  }
  /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */
  moveTo(e, t) {
    this._tick++;
    const n = this._transform, s = this._activePath.instructions, o = n.a * e + n.c * t + n.tx, r = n.b * e + n.d * t + n.ty;
    return s.length === 1 && s[0].action === "moveTo" ? (s[0].data[0] = o, s[0].data[1] = r, this) : (this._activePath.moveTo(
      o,
      r
    ), this);
  }
  /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cpx - The x-coordinate of the control point.
   * @param cpy - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveTo(e, t, n, s, o) {
    this._tick++;
    const r = this._transform;
    return this._activePath.quadraticCurveTo(
      r.a * e + r.c * t + r.tx,
      r.b * e + r.d * t + r.ty,
      r.a * n + r.c * s + r.tx,
      r.b * n + r.d * s + r.ty,
      o
    ), this;
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(e, t, n, s) {
    return this._tick++, this._activePath.rect(e, t, n, s, this._transform.clone()), this;
  }
  /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @returns The instance of the current object for chaining.
   */
  roundRect(e, t, n, s, o) {
    return this._tick++, this._activePath.roundRect(e, t, n, s, o, this._transform.clone()), this;
  }
  /**
   * Draws a polygon shape by specifying a sequence of points. This method allows for the creation of complex polygons,
   * which can be both open and closed. An optional transformation can be applied, enabling the polygon to be scaled,
   * rotated, or translated as needed.
   * @param points - An array of numbers, or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates, of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   */
  poly(e, t) {
    return this._tick++, this._activePath.poly(e, t, this._transform.clone()), this;
  }
  /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  regularPoly(e, t, n, s, o = 0, r) {
    return this._tick++, this._activePath.regularPoly(e, t, n, s, o, r), this;
  }
  /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @returns The instance of the current object for chaining.
   */
  roundPoly(e, t, n, s, o, r) {
    return this._tick++, this._activePath.roundPoly(e, t, n, s, o, r), this;
  }
  /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */
  roundShape(e, t, n, s) {
    return this._tick++, this._activePath.roundShape(e, t, n, s), this;
  }
  /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */
  filletRect(e, t, n, s, o) {
    return this._tick++, this._activePath.filletRect(e, t, n, s, o), this;
  }
  /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */
  chamferRect(e, t, n, s, o, r) {
    return this._tick++, this._activePath.chamferRect(e, t, n, s, o, r), this;
  }
  /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @returns The instance of the current object for chaining further drawing commands.
   */
  star(e, t, n, s, o = 0, r = 0) {
    return this._tick++, this._activePath.star(e, t, n, s, o, r, this._transform.clone()), this;
  }
  /**
   * Parses and renders an SVG string into the graphics context. This allows for complex shapes and paths
   * defined in SVG format to be drawn within the graphics context.
   * @param svg - The SVG string to be parsed and rendered.
   */
  svg(e) {
    return this._tick++, WJ(e, this), this;
  }
  /**
   * Restores the most recently saved graphics state by popping the top of the graphics state stack.
   * This includes transformations, fill styles, and stroke styles.
   */
  restore() {
    const e = this._stateStack.pop();
    return e && (this._transform = e.transform, this._fillStyle = e.fillStyle, this._strokeStyle = e.strokeStyle), this;
  }
  /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */
  save() {
    return this._stateStack.push({
      transform: this._transform.clone(),
      fillStyle: { ...this._fillStyle },
      strokeStyle: { ...this._strokeStyle }
    }), this;
  }
  /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */
  getTransform() {
    return this._transform;
  }
  /**
   * Resets the current transformation matrix to the identity matrix, effectively removing any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  resetTransform() {
    return this._transform.identity(), this;
  }
  /**
   * Applies a rotation transformation to the graphics context around the current origin.
   * @param angle - The angle of rotation in radians.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  rotate(e) {
    return this._transform.rotate(e), this;
  }
  /**
   * Applies a scaling transformation to the graphics context, scaling drawings by x horizontally and by y vertically.
   * @param x - The scale factor in the horizontal direction.
   * @param y - (Optional) The scale factor in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  scale(e, t = e) {
    return this._transform.scale(e, t), this;
  }
  setTransform(e, t, n, s, o, r) {
    return e instanceof st ? (this._transform.set(e.a, e.b, e.c, e.d, e.tx, e.ty), this) : (this._transform.set(e, t, n, s, o, r), this);
  }
  transform(e, t, n, s, o, r) {
    return e instanceof st ? (this._transform.append(e), this) : (C2.set(e, t, n, s, o, r), this._transform.append(C2), this);
  }
  /**
   * Applies a translation transformation to the graphics context, moving the origin by the specified amounts.
   * @param x - The amount to translate in the horizontal direction.
   * @param y - (Optional) The amount to translate in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  translate(e, t = e) {
    return this._transform.translate(e, t), this;
  }
  /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  clear() {
    return this._activePath.clear(), this.instructions.length = 0, this.resetTransform(), this.onUpdate(), this;
  }
  onUpdate() {
    this._boundsDirty = !0, this.dirty = !0, this.emit("update", this, 16);
  }
  /** The bounds of the graphic shape. */
  get bounds() {
    if (!this._boundsDirty) return this._bounds;
    this._boundsDirty = !1;
    const e = this._bounds;
    e.clear();
    for (let t = 0; t < this.instructions.length; t++) {
      const n = this.instructions[t], s = n.action;
      if (s === "fill") {
        const o = n.data;
        e.addBounds(o.path.bounds);
      } else if (s === "texture") {
        const o = n.data;
        e.addFrame(o.dx, o.dy, o.dx + o.dw, o.dy + o.dh, o.transform);
      }
      if (s === "stroke") {
        const o = n.data, r = o.style.alignment;
        let a = o.style.width * (1 - r);
        o.style.join === "miter" && (a *= QJ(o.path, o.style.miterLimit));
        const l = o.path.bounds;
        e.addFrame(
          l.minX - a,
          l.minY - a,
          l.maxX + a,
          l.maxY + a
        );
      }
    }
    return e.isValid || e.set(0, 0, 0, 0), e;
  }
  /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */
  containsPoint(e) {
    var s;
    if (!this.bounds.containsPoint(e.x, e.y)) return !1;
    const t = this.instructions;
    let n = !1;
    for (let o = 0; o < t.length; o++) {
      const r = t[o], a = r.data, l = a.path;
      if (!r.action || !l) continue;
      const d = a.style, c = l.shapePath.shapePrimitives;
      for (let h = 0; h < c.length; h++) {
        const f = c[h].shape;
        if (!d || !f) continue;
        const p = c[h].transform, y = p ? p.applyInverse(e, eZ) : e;
        if (r.action === "fill")
          n = f.contains(y.x, y.y);
        else {
          const x = d;
          n = f.strokeContains(y.x, y.y, x.width, x.alignment);
        }
        const v = a.hole;
        if (v) {
          const x = (s = v.shapePath) == null ? void 0 : s.shapePrimitives;
          if (x)
            for (let w = 0; w < x.length; w++)
              x[w].shape.contains(y.x, y.y) && (n = !1);
        }
        if (n)
          return !0;
      }
    }
    return n;
  }
  /** Unloads the GPU data from the graphics context. */
  unload() {
    var e;
    this.emit("unload", this);
    for (const t in this._gpuData)
      (e = this._gpuData[t]) == null || e.destroy();
    this._gpuData = /* @__PURE__ */ Object.create(null);
  }
  /**
   * Destroys the GraphicsData object.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * context.destroy();
   * context.destroy(true);
   * context.destroy({ texture: true, textureSource: true });
   */
  destroy(e = !1) {
    if (this.destroyed) return;
    if (this.destroyed = !0, this._stateStack.length = 0, this._transform = null, this.unload(), this.emit("destroy", this), this.removeAllListeners(), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const n = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      this._fillStyle.texture && (this._fillStyle.fill && "uid" in this._fillStyle.fill ? this._fillStyle.fill.destroy() : this._fillStyle.texture.destroy(n)), this._strokeStyle.texture && (this._strokeStyle.fill && "uid" in this._strokeStyle.fill ? this._strokeStyle.fill.destroy() : this._strokeStyle.texture.destroy(n));
    }
    this._fillStyle = null, this._strokeStyle = null, this.instructions = null, this._activePath = null, this._bounds = null, this._stateStack = null, this.customShader = null, this._transform = null;
  }
};
fy.defaultFillStyle = {
  /** The color to use for the fill. */
  color: 16777215,
  /** The alpha value to use for the fill. */
  alpha: 1,
  /** The texture to use for the fill. */
  texture: et.WHITE,
  /** The matrix to apply. */
  matrix: null,
  /** The fill pattern to use. */
  fill: null,
  /** Whether coordinates are 'global' or 'local' */
  textureSpace: "local"
};
fy.defaultStrokeStyle = {
  /** The width of the stroke. */
  width: 1,
  /** The color to use for the stroke. */
  color: 16777215,
  /** The alpha value to use for the stroke. */
  alpha: 1,
  /** The alignment of the stroke. */
  alignment: 0.5,
  /** The miter limit to use. */
  miterLimit: 10,
  /** The line cap style to use. */
  cap: "butt",
  /** The line join style to use. */
  join: "miter",
  /** The texture to use for the fill. */
  texture: et.WHITE,
  /** The matrix to apply. */
  matrix: null,
  /** The fill pattern to use. */
  fill: null,
  /** Whether coordinates are 'global' or 'local' */
  textureSpace: "local",
  /** If the stroke is a pixel line. */
  pixelLine: !1
};
let yd = fy;
class LM {
  /**
   * Constructor for the DOMPipe class.
   * @param renderer - The renderer instance that this DOMPipe will be associated with.
   */
  constructor(e) {
    this._attachedDomElements = [], this._renderer = e, this._renderer.runners.postrender.add(this), this._renderer.runners.init.add(this), this._domElement = document.createElement("div"), this._domElement.style.position = "absolute", this._domElement.style.top = "0", this._domElement.style.left = "0", this._domElement.style.pointerEvents = "none", this._domElement.style.zIndex = "1000";
  }
  /** Initializes the DOMPipe, setting up the main DOM element and adding it to the document body. */
  init() {
    this._canvasObserver = new FS({
      domElement: this._domElement,
      renderer: this._renderer
    });
  }
  /**
   * Adds a renderable DOM container to the list of attached elements.
   * @param domContainer - The DOM container to be added.
   * @param _instructionSet - The instruction set (unused).
   */
  addRenderable(e, t) {
    this._attachedDomElements.includes(e) || this._attachedDomElements.push(e);
  }
  /**
   * Updates a renderable DOM container.
   * @param _domContainer - The DOM container to be updated (unused).
   */
  updateRenderable(e) {
  }
  /**
   * Validates a renderable DOM container.
   * @param _domContainer - The DOM container to be validated (unused).
   * @returns Always returns true as validation is not required.
   */
  validateRenderable(e) {
    return !0;
  }
  /** Handles the post-rendering process, ensuring DOM elements are correctly positioned and visible. */
  postrender() {
    const e = this._attachedDomElements;
    if (e.length === 0) {
      this._domElement.remove();
      return;
    }
    this._canvasObserver.ensureAttached();
    for (let t = 0; t < e.length; t++) {
      const n = e[t], s = n.element;
      if (!n.parent || n.globalDisplayStatus < 7)
        s == null || s.remove(), e.splice(t, 1), t--;
      else {
        this._domElement.contains(s) || (s.style.position = "absolute", s.style.pointerEvents = "auto", this._domElement.appendChild(s));
        const o = n.worldTransform, r = n._anchor, a = n.width * r.x, l = n.height * r.y;
        s.style.transformOrigin = `${a}px ${l}px`, s.style.transform = `matrix(${o.a}, ${o.b}, ${o.c}, ${o.d}, ${o.tx - a}, ${o.ty - l})`, s.style.opacity = n.groupAlpha.toString();
      }
    }
  }
  /** Destroys the DOMPipe, removing all attached DOM elements and cleaning up resources. */
  destroy() {
    var e;
    this._renderer.runners.postrender.remove(this);
    for (let t = 0; t < this._attachedDomElements.length; t++)
      (e = this._attachedDomElements[t].element) == null || e.remove();
    this._attachedDomElements.length = 0, this._domElement.remove(), this._canvasObserver.destroy(), this._renderer = null;
  }
}
LM.extension = {
  type: [
    Ie.WebGLPipes,
    Ie.WebGPUPipes,
    Ie.CanvasPipes
  ],
  name: "dom"
};
class tZ {
  constructor() {
    this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this._tickerAdded = !1, this._pauseUpdate = !0;
  }
  /**
   * Initializes the event ticker.
   * @param events - The event system.
   */
  init(e) {
    this.removeTickerListener(), this.events = e, this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this._tickerAdded = !1, this._pauseUpdate = !0;
  }
  /** Whether to pause the update checks or not. */
  get pauseUpdate() {
    return this._pauseUpdate;
  }
  set pauseUpdate(e) {
    this._pauseUpdate = e;
  }
  /** Adds the ticker listener. */
  addTickerListener() {
    this._tickerAdded || !this.domElement || (Oi.system.add(this._tickerUpdate, this, Ol.INTERACTION), this._tickerAdded = !0);
  }
  /** Removes the ticker listener. */
  removeTickerListener() {
    this._tickerAdded && (Oi.system.remove(this._tickerUpdate, this), this._tickerAdded = !1);
  }
  /** Sets flag to not fire extra events when the user has already moved there mouse */
  pointerMoved() {
    this._didMove = !0;
  }
  /** Updates the state of interactive objects. */
  _update() {
    if (!this.domElement || this._pauseUpdate)
      return;
    if (this._didMove) {
      this._didMove = !1;
      return;
    }
    const e = this.events._rootPointerEvent;
    this.events.supportsTouchEvents && e.pointerType === "touch" || globalThis.document.dispatchEvent(this.events.supportsPointerEvents ? new PointerEvent("pointermove", {
      clientX: e.clientX,
      clientY: e.clientY,
      pointerType: e.pointerType,
      pointerId: e.pointerId
    }) : new MouseEvent("mousemove", {
      clientX: e.clientX,
      clientY: e.clientY
    }));
  }
  /**
   * Updates the state of interactive objects if at least {@link interactionFrequency}
   * milliseconds have passed since the last invocation.
   *
   * Invoked by a throttled ticker update from {@link Ticker.system}.
   * @param ticker - The throttled ticker.
   */
  _tickerUpdate(e) {
    this._deltaTime += e.deltaTime, !(this._deltaTime < this.interactionFrequency) && (this._deltaTime = 0, this._update());
  }
  /** Destroys the event ticker. */
  destroy() {
    this.removeTickerListener(), this.events = null, this.domElement = null, this._deltaTime = 0, this._didMove = !1, this._tickerAdded = !1, this._pauseUpdate = !0;
  }
}
const Hs = new tZ();
class vf extends xu {
  constructor() {
    super(...arguments), this.client = new Wt(), this.movement = new Wt(), this.offset = new Wt(), this.global = new Wt(), this.screen = new Wt();
  }
  /** @readonly */
  get clientX() {
    return this.client.x;
  }
  /** @readonly */
  get clientY() {
    return this.client.y;
  }
  /**
   * Alias for {@link FederatedMouseEvent.clientX this.clientX}.
   * @readonly
   */
  get x() {
    return this.clientX;
  }
  /**
   * Alias for {@link FederatedMouseEvent.clientY this.clientY}.
   * @readonly
   */
  get y() {
    return this.clientY;
  }
  /** @readonly */
  get movementX() {
    return this.movement.x;
  }
  /** @readonly */
  get movementY() {
    return this.movement.y;
  }
  /** @readonly */
  get offsetX() {
    return this.offset.x;
  }
  /** @readonly */
  get offsetY() {
    return this.offset.y;
  }
  /** @readonly */
  get globalX() {
    return this.global.x;
  }
  /** @readonly */
  get globalY() {
    return this.global.y;
  }
  /**
   * The pointer coordinates in the renderer's screen. Alias for `screen.x`.
   * @readonly
   */
  get screenX() {
    return this.screen.x;
  }
  /**
   * The pointer coordinates in the renderer's screen. Alias for `screen.y`.
   * @readonly
   */
  get screenY() {
    return this.screen.y;
  }
  /**
   * Converts global coordinates into container-local coordinates.
   *
   * This method transforms coordinates from world space to a container's local space,
   * useful for precise positioning and hit testing.
   * @param container - The Container to get local coordinates for
   * @param point - Optional Point object to store the result. If not provided, a new Point will be created
   * @param globalPos - Optional custom global coordinates. If not provided, the event's global position is used
   * @returns The local coordinates as a Point object
   * @example
   * ```ts
   * // Basic usage - get local coordinates relative to a container
   * sprite.on('pointermove', (event: FederatedMouseEvent) => {
   *     // Get position relative to the sprite
   *     const localPos = event.getLocalPosition(sprite);
   *     console.log('Local position:', localPos.x, localPos.y);
   * });
   * // Using custom global coordinates
   * const customGlobal = new Point(100, 100);
   * sprite.on('pointermove', (event: FederatedMouseEvent) => {
   *     // Transform custom coordinates
   *     const localPos = event.getLocalPosition(sprite, undefined, customGlobal);
   *     console.log('Custom local position:', localPos.x, localPos.y);
   * });
   * ```
   * @see {@link Container.worldTransform} For the transformation matrix
   * @see {@link Point} For the point class used to store coordinates
   */
  getLocalPosition(e, t, n) {
    return e.worldTransform.applyInverse(n || this.global, t);
  }
  /**
   * Whether the modifier key was pressed when this event natively occurred.
   * @param key - The modifier key.
   */
  getModifierState(e) {
    return "getModifierState" in this.nativeEvent && this.nativeEvent.getModifierState(e);
  }
  /**
   * Not supported.
   * @param _typeArg
   * @param _canBubbleArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   * @param _screenXArg
   * @param _screenYArg
   * @param _clientXArg
   * @param _clientYArg
   * @param _ctrlKeyArg
   * @param _altKeyArg
   * @param _shiftKeyArg
   * @param _metaKeyArg
   * @param _buttonArg
   * @param _relatedTargetArg
   * @deprecated since 7.0.0
   * @ignore
   */
  // eslint-disable-next-line max-params
  initMouseEvent(e, t, n, s, o, r, a, l, d, c, h, f, p, y, v) {
    throw new Error("Method not implemented.");
  }
}
class _i extends vf {
  constructor() {
    super(...arguments), this.width = 0, this.height = 0, this.isPrimary = !1, this.persistentDeviceId = 0;
  }
  /**
   * Only included for completeness for now
   * @ignore
   */
  getCoalescedEvents() {
    return this.type === "pointermove" || this.type === "mousemove" || this.type === "touchmove" ? [this] : [];
  }
  /**
   * Only included for completeness for now
   * @ignore
   */
  getPredictedEvents() {
    throw new Error("getPredictedEvents is not supported!");
  }
}
class Bl extends vf {
  constructor() {
    super(...arguments), this.DOM_DELTA_PIXEL = 0, this.DOM_DELTA_LINE = 1, this.DOM_DELTA_PAGE = 2;
  }
}
Bl.DOM_DELTA_PIXEL = 0;
Bl.DOM_DELTA_LINE = 1;
Bl.DOM_DELTA_PAGE = 2;
const nZ = 2048, iZ = new Wt(), xd = new Wt();
class sZ {
  /**
   * @param rootTarget - The holder of the event boundary.
   */
  constructor(e) {
    this.dispatch = new bi(), this.moveOnAll = !1, this.enableGlobalMoveEvents = !0, this.mappingState = {
      trackingData: {}
    }, this.eventPool = /* @__PURE__ */ new Map(), this._allInteractiveElements = [], this._hitElements = [], this._isPointerMoveEvent = !1, this.rootTarget = e, this.hitPruneFn = this.hitPruneFn.bind(this), this.hitTestFn = this.hitTestFn.bind(this), this.mapPointerDown = this.mapPointerDown.bind(this), this.mapPointerMove = this.mapPointerMove.bind(this), this.mapPointerOut = this.mapPointerOut.bind(this), this.mapPointerOver = this.mapPointerOver.bind(this), this.mapPointerUp = this.mapPointerUp.bind(this), this.mapPointerUpOutside = this.mapPointerUpOutside.bind(this), this.mapWheel = this.mapWheel.bind(this), this.mapContextMenu = this.mapContextMenu.bind(this), this.mappingTable = {}, this.addEventMapping("pointerdown", this.mapPointerDown), this.addEventMapping("pointermove", this.mapPointerMove), this.addEventMapping("pointerout", this.mapPointerOut), this.addEventMapping("pointerleave", this.mapPointerOut), this.addEventMapping("pointerover", this.mapPointerOver), this.addEventMapping("pointerup", this.mapPointerUp), this.addEventMapping("pointerupoutside", this.mapPointerUpOutside), this.addEventMapping("wheel", this.mapWheel), this.addEventMapping("contextmenu", this.mapContextMenu);
  }
  /**
   * Adds an event mapping for the event `type` handled by `fn`.
   *
   * Event mappings can be used to implement additional or custom events. They take an event
   * coming from the upstream scene (or directly from the {@link EventSystem}) and dispatch new downstream events
   * generally trickling down and bubbling up to {@link EventBoundary.rootTarget this.rootTarget}.
   *
   * To modify the semantics of existing events, the built-in mapping methods of EventBoundary should be overridden
   * instead.
   * @param type - The type of upstream event to map.
   * @param fn - The mapping method. The context of this function must be bound manually, if desired.
   */
  addEventMapping(e, t) {
    this.mappingTable[e] || (this.mappingTable[e] = []), this.mappingTable[e].push({
      fn: t,
      priority: 0
    }), this.mappingTable[e].sort((n, s) => n.priority - s.priority);
  }
  /**
   * Dispatches the given event
   * @param e - The event to dispatch.
   * @param type - The type of event to dispatch. Defaults to `e.type`.
   */
  dispatchEvent(e, t) {
    e.propagationStopped = !1, e.propagationImmediatelyStopped = !1, this.propagate(e, t), this.dispatch.emit(t || e.type, e);
  }
  /**
   * Maps the given upstream event through the event boundary and propagates it downstream.
   * @param e - The event to map.
   */
  mapEvent(e) {
    if (!this.rootTarget)
      return;
    const t = this.mappingTable[e.type];
    if (t)
      for (let n = 0, s = t.length; n < s; n++)
        t[n].fn(e);
    else
      dt(`[EventBoundary]: Event mapping not defined for ${e.type}`);
  }
  /**
   * Finds the Container that is the target of a event at the given coordinates.
   *
   * The passed (x,y) coordinates are in the world space above this event boundary.
   * @param x - The x coordinate of the event.
   * @param y - The y coordinate of the event.
   */
  hitTest(e, t) {
    Hs.pauseUpdate = !0;
    const s = this._isPointerMoveEvent && this.enableGlobalMoveEvents ? "hitTestMoveRecursive" : "hitTestRecursive", o = this[s](
      this.rootTarget,
      this.rootTarget.eventMode,
      iZ.set(e, t),
      this.hitTestFn,
      this.hitPruneFn
    );
    return o && o[0];
  }
  /**
   * Propagate the passed event from from {@link EventBoundary.rootTarget this.rootTarget} to its
   * target `e.target`.
   * @param e - The event to propagate.
   * @param type - The type of event to propagate. Defaults to `e.type`.
   */
  propagate(e, t) {
    if (!e.target)
      return;
    const n = e.composedPath();
    e.eventPhase = e.CAPTURING_PHASE;
    for (let s = 0, o = n.length - 1; s < o; s++)
      if (e.currentTarget = n[s], this.notifyTarget(e, t), e.propagationStopped || e.propagationImmediatelyStopped) return;
    if (e.eventPhase = e.AT_TARGET, e.currentTarget = e.target, this.notifyTarget(e, t), !(e.propagationStopped || e.propagationImmediatelyStopped)) {
      e.eventPhase = e.BUBBLING_PHASE;
      for (let s = n.length - 2; s >= 0; s--)
        if (e.currentTarget = n[s], this.notifyTarget(e, t), e.propagationStopped || e.propagationImmediatelyStopped) return;
    }
  }
  /**
   * Emits the event `e` to all interactive containers. The event is propagated in the bubbling phase always.
   *
   * This is used in the `globalpointermove` event.
   * @param e - The emitted event.
   * @param type - The listeners to notify.
   * @param targets - The targets to notify.
   */
  all(e, t, n = this._allInteractiveElements) {
    if (n.length === 0) return;
    e.eventPhase = e.BUBBLING_PHASE;
    const s = Array.isArray(t) ? t : [t];
    for (let o = n.length - 1; o >= 0; o--)
      s.forEach((r) => {
        e.currentTarget = n[o], this.notifyTarget(e, r);
      });
  }
  /**
   * Finds the propagation path from {@link EventBoundary.rootTarget rootTarget} to the passed
   * `target`. The last element in the path is `target`.
   * @param target - The target to find the propagation path to.
   */
  propagationPath(e) {
    const t = [e];
    for (let n = 0; n < nZ && e !== this.rootTarget && e.parent; n++) {
      if (!e.parent)
        throw new Error("Cannot find propagation path to disconnected target");
      t.push(e.parent), e = e.parent;
    }
    return t.reverse(), t;
  }
  hitTestMoveRecursive(e, t, n, s, o, r = !1) {
    let a = !1;
    if (this._interactivePrune(e)) return null;
    if ((e.eventMode === "dynamic" || t === "dynamic") && (Hs.pauseUpdate = !1), e.interactiveChildren && e.children) {
      const c = e.children;
      for (let h = c.length - 1; h >= 0; h--) {
        const f = c[h], p = this.hitTestMoveRecursive(
          f,
          this._isInteractive(t) ? t : f.eventMode,
          n,
          s,
          o,
          r || o(e, n)
        );
        if (p) {
          if (p.length > 0 && !p[p.length - 1].parent)
            continue;
          const y = e.isInteractive();
          (p.length > 0 || y) && (y && this._allInteractiveElements.push(e), p.push(e)), this._hitElements.length === 0 && (this._hitElements = p), a = !0;
        }
      }
    }
    const l = this._isInteractive(t), d = e.isInteractive();
    return d && d && this._allInteractiveElements.push(e), r || this._hitElements.length > 0 ? null : a ? this._hitElements : l && !o(e, n) && s(e, n) ? d ? [e] : [] : null;
  }
  /**
   * Recursive implementation for {@link EventBoundary.hitTest hitTest}.
   * @param currentTarget - The Container that is to be hit tested.
   * @param eventMode - The event mode for the `currentTarget` or one of its parents.
   * @param location - The location that is being tested for overlap.
   * @param testFn - Callback that determines whether the target passes hit testing. This callback
   *  can assume that `pruneFn` failed to prune the container.
   * @param pruneFn - Callback that determiness whether the target and all of its children
   *  cannot pass the hit test. It is used as a preliminary optimization to prune entire subtrees
   *  of the scene graph.
   * @returns An array holding the hit testing target and all its ancestors in order. The first element
   *  is the target itself and the last is {@link EventBoundary.rootTarget rootTarget}. This is the opposite
   *  order w.r.t. the propagation path. If no hit testing target is found, null is returned.
   */
  hitTestRecursive(e, t, n, s, o) {
    if (this._interactivePrune(e) || o(e, n))
      return null;
    if ((e.eventMode === "dynamic" || t === "dynamic") && (Hs.pauseUpdate = !1), e.interactiveChildren && e.children) {
      const l = e.children, d = n;
      for (let c = l.length - 1; c >= 0; c--) {
        const h = l[c], f = this.hitTestRecursive(
          h,
          this._isInteractive(t) ? t : h.eventMode,
          d,
          s,
          o
        );
        if (f) {
          if (f.length > 0 && !f[f.length - 1].parent)
            continue;
          const p = e.isInteractive();
          return (f.length > 0 || p) && f.push(e), f;
        }
      }
    }
    const r = this._isInteractive(t), a = e.isInteractive();
    return r && s(e, n) ? a ? [e] : [] : null;
  }
  _isInteractive(e) {
    return e === "static" || e === "dynamic";
  }
  _interactivePrune(e) {
    return !e || !e.visible || !e.renderable || !e.measurable || e.eventMode === "none" || e.eventMode === "passive" && !e.interactiveChildren;
  }
  /**
   * Checks whether the container or any of its children cannot pass the hit test at all.
   *
   * {@link EventBoundary}'s implementation uses the {@link Container.hitArea hitArea}
   * and {@link Container._maskEffect} for pruning.
   * @param container - The container to prune.
   * @param location - The location to test for overlap.
   */
  hitPruneFn(e, t) {
    if (e.hitArea && (e.worldTransform.applyInverse(t, xd), !e.hitArea.contains(xd.x, xd.y)))
      return !0;
    if (e.effects && e.effects.length)
      for (let n = 0; n < e.effects.length; n++) {
        const s = e.effects[n];
        if (s.containsPoint && !s.containsPoint(t, this.hitTestFn))
          return !0;
      }
    return !1;
  }
  /**
   * Checks whether the container passes hit testing for the given location.
   * @param container - The container to test.
   * @param location - The location to test for overlap.
   * @returns - Whether `container` passes hit testing for `location`.
   */
  hitTestFn(e, t) {
    return e.hitArea ? !0 : e != null && e.containsPoint ? (e.worldTransform.applyInverse(t, xd), e.containsPoint(xd)) : !1;
  }
  /**
   * Notify all the listeners to the event's `currentTarget`.
   *
   * If the `currentTarget` contains the property `on<type>`, then it is called here,
   * simulating the behavior from version 6.x and prior.
   * @param e - The event passed to the target.
   * @param type - The type of event to notify. Defaults to `e.type`.
   */
  notifyTarget(e, t) {
    var o, r;
    if (!e.currentTarget.isInteractive())
      return;
    t != null || (t = e.type);
    const n = `on${t}`;
    (r = (o = e.currentTarget)[n]) == null || r.call(o, e);
    const s = e.eventPhase === e.CAPTURING_PHASE || e.eventPhase === e.AT_TARGET ? `${t}capture` : t;
    this._notifyListeners(e, s), e.eventPhase === e.AT_TARGET && this._notifyListeners(e, t);
  }
  /**
   * Maps the upstream `pointerdown` events to a downstream `pointerdown` event.
   *
   * `touchstart`, `rightdown`, `mousedown` events are also dispatched for specific pointer types.
   * @param from - The upstream `pointerdown` event.
   */
  mapPointerDown(e) {
    if (!(e instanceof _i)) {
      dt("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.createPointerEvent(e);
    if (this.dispatchEvent(t, "pointerdown"), t.pointerType === "touch")
      this.dispatchEvent(t, "touchstart");
    else if (t.pointerType === "mouse" || t.pointerType === "pen") {
      const s = t.button === 2;
      this.dispatchEvent(t, s ? "rightdown" : "mousedown");
    }
    const n = this.trackingData(e.pointerId);
    n.pressTargetsByButton[e.button] = t.composedPath(), this.freeEvent(t);
  }
  /**
   * Maps the upstream `pointermove` to downstream `pointerout`, `pointerover`, and `pointermove` events, in that order.
   *
   * The tracking data for the specific pointer has an updated `overTarget`. `mouseout`, `mouseover`,
   * `mousemove`, and `touchmove` events are fired as well for specific pointer types.
   * @param from - The upstream `pointermove` event.
   */
  mapPointerMove(e) {
    var l, d, c;
    if (!(e instanceof _i)) {
      dt("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    this._allInteractiveElements.length = 0, this._hitElements.length = 0, this._isPointerMoveEvent = !0;
    const t = this.createPointerEvent(e);
    this._isPointerMoveEvent = !1;
    const n = t.pointerType === "mouse" || t.pointerType === "pen", s = this.trackingData(e.pointerId), o = this.findMountedTarget(s.overTargets);
    if (((l = s.overTargets) == null ? void 0 : l.length) > 0 && o !== t.target) {
      const h = e.type === "mousemove" ? "mouseout" : "pointerout", f = this.createPointerEvent(e, h, o);
      if (this.dispatchEvent(f, "pointerout"), n && this.dispatchEvent(f, "mouseout"), !t.composedPath().includes(o)) {
        const p = this.createPointerEvent(e, "pointerleave", o);
        for (p.eventPhase = p.AT_TARGET; p.target && !t.composedPath().includes(p.target); )
          p.currentTarget = p.target, this.notifyTarget(p), n && this.notifyTarget(p, "mouseleave"), p.target = p.target.parent;
        this.freeEvent(p);
      }
      this.freeEvent(f);
    }
    if (o !== t.target) {
      const h = e.type === "mousemove" ? "mouseover" : "pointerover", f = this.clonePointerEvent(t, h);
      this.dispatchEvent(f, "pointerover"), n && this.dispatchEvent(f, "mouseover");
      let p = o == null ? void 0 : o.parent;
      for (; p && p !== this.rootTarget.parent && p !== t.target; )
        p = p.parent;
      if (!p || p === this.rootTarget.parent) {
        const v = this.clonePointerEvent(t, "pointerenter");
        for (v.eventPhase = v.AT_TARGET; v.target && v.target !== o && v.target !== this.rootTarget.parent; )
          v.currentTarget = v.target, this.notifyTarget(v), n && this.notifyTarget(v, "mouseenter"), v.target = v.target.parent;
        this.freeEvent(v);
      }
      this.freeEvent(f);
    }
    const r = [], a = (d = this.enableGlobalMoveEvents) != null ? d : !0;
    this.moveOnAll ? r.push("pointermove") : this.dispatchEvent(t, "pointermove"), a && r.push("globalpointermove"), t.pointerType === "touch" && (this.moveOnAll ? r.splice(1, 0, "touchmove") : this.dispatchEvent(t, "touchmove"), a && r.push("globaltouchmove")), n && (this.moveOnAll ? r.splice(1, 0, "mousemove") : this.dispatchEvent(t, "mousemove"), a && r.push("globalmousemove"), this.cursor = (c = t.target) == null ? void 0 : c.cursor), r.length > 0 && this.all(t, r), this._allInteractiveElements.length = 0, this._hitElements.length = 0, s.overTargets = t.composedPath(), this.freeEvent(t);
  }
  /**
   * Maps the upstream `pointerover` to downstream `pointerover` and `pointerenter` events, in that order.
   *
   * The tracking data for the specific pointer gets a new `overTarget`.
   * @param from - The upstream `pointerover` event.
   */
  mapPointerOver(e) {
    var r;
    if (!(e instanceof _i)) {
      dt("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.trackingData(e.pointerId), n = this.createPointerEvent(e), s = n.pointerType === "mouse" || n.pointerType === "pen";
    this.dispatchEvent(n, "pointerover"), s && this.dispatchEvent(n, "mouseover"), n.pointerType === "mouse" && (this.cursor = (r = n.target) == null ? void 0 : r.cursor);
    const o = this.clonePointerEvent(n, "pointerenter");
    for (o.eventPhase = o.AT_TARGET; o.target && o.target !== this.rootTarget.parent; )
      o.currentTarget = o.target, this.notifyTarget(o), s && this.notifyTarget(o, "mouseenter"), o.target = o.target.parent;
    t.overTargets = n.composedPath(), this.freeEvent(n), this.freeEvent(o);
  }
  /**
   * Maps the upstream `pointerout` to downstream `pointerout`, `pointerleave` events, in that order.
   *
   * The tracking data for the specific pointer is cleared of a `overTarget`.
   * @param from - The upstream `pointerout` event.
   */
  mapPointerOut(e) {
    if (!(e instanceof _i)) {
      dt("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.trackingData(e.pointerId);
    if (t.overTargets) {
      const n = e.pointerType === "mouse" || e.pointerType === "pen", s = this.findMountedTarget(t.overTargets), o = this.createPointerEvent(e, "pointerout", s);
      this.dispatchEvent(o), n && this.dispatchEvent(o, "mouseout");
      const r = this.createPointerEvent(e, "pointerleave", s);
      for (r.eventPhase = r.AT_TARGET; r.target && r.target !== this.rootTarget.parent; )
        r.currentTarget = r.target, this.notifyTarget(r), n && this.notifyTarget(r, "mouseleave"), r.target = r.target.parent;
      t.overTargets = null, this.freeEvent(o), this.freeEvent(r);
    }
    this.cursor = null;
  }
  /**
   * Maps the upstream `pointerup` event to downstream `pointerup`, `pointerupoutside`,
   * and `click`/`rightclick`/`pointertap` events, in that order.
   *
   * The `pointerupoutside` event bubbles from the original `pointerdown` target to the most specific
   * ancestor of the `pointerdown` and `pointerup` targets, which is also the `click` event's target. `touchend`,
   * `rightup`, `mouseup`, `touchendoutside`, `rightupoutside`, `mouseupoutside`, and `tap` are fired as well for
   * specific pointer types.
   * @param from - The upstream `pointerup` event.
   */
  mapPointerUp(e) {
    if (!(e instanceof _i)) {
      dt("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = performance.now(), n = this.createPointerEvent(e);
    if (this.dispatchEvent(n, "pointerup"), n.pointerType === "touch")
      this.dispatchEvent(n, "touchend");
    else if (n.pointerType === "mouse" || n.pointerType === "pen") {
      const a = n.button === 2;
      this.dispatchEvent(n, a ? "rightup" : "mouseup");
    }
    const s = this.trackingData(e.pointerId), o = this.findMountedTarget(s.pressTargetsByButton[e.button]);
    let r = o;
    if (o && !n.composedPath().includes(o)) {
      let a = o;
      for (; a && !n.composedPath().includes(a); ) {
        if (n.currentTarget = a, this.notifyTarget(n, "pointerupoutside"), n.pointerType === "touch")
          this.notifyTarget(n, "touchendoutside");
        else if (n.pointerType === "mouse" || n.pointerType === "pen") {
          const l = n.button === 2;
          this.notifyTarget(n, l ? "rightupoutside" : "mouseupoutside");
        }
        a = a.parent;
      }
      delete s.pressTargetsByButton[e.button], r = a;
    }
    if (r) {
      const a = this.clonePointerEvent(n, "click");
      a.target = r, a.path = null, s.clicksByButton[e.button] || (s.clicksByButton[e.button] = {
        clickCount: 0,
        target: a.target,
        timeStamp: t
      });
      const l = s.clicksByButton[e.button];
      if (l.target === a.target && t - l.timeStamp < 200 ? ++l.clickCount : l.clickCount = 1, l.target = a.target, l.timeStamp = t, a.detail = l.clickCount, a.pointerType === "mouse") {
        const d = a.button === 2;
        this.dispatchEvent(a, d ? "rightclick" : "click");
      } else a.pointerType === "touch" && this.dispatchEvent(a, "tap");
      this.dispatchEvent(a, "pointertap"), this.freeEvent(a);
    }
    this.freeEvent(n);
  }
  /**
   * Maps the upstream `pointerupoutside` event to a downstream `pointerupoutside` event, bubbling from the original
   * `pointerdown` target to `rootTarget`.
   *
   * (The most specific ancestor of the `pointerdown` event and the `pointerup` event must the
   * `{@link EventBoundary}'s root because the `pointerup` event occurred outside of the boundary.)
   *
   * `touchendoutside`, `mouseupoutside`, and `rightupoutside` events are fired as well for specific pointer
   * types. The tracking data for the specific pointer is cleared of a `pressTarget`.
   * @param from - The upstream `pointerupoutside` event.
   */
  mapPointerUpOutside(e) {
    if (!(e instanceof _i)) {
      dt("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.trackingData(e.pointerId), n = this.findMountedTarget(t.pressTargetsByButton[e.button]), s = this.createPointerEvent(e);
    if (n) {
      let o = n;
      for (; o; )
        s.currentTarget = o, this.notifyTarget(s, "pointerupoutside"), s.pointerType === "touch" ? this.notifyTarget(s, "touchendoutside") : (s.pointerType === "mouse" || s.pointerType === "pen") && this.notifyTarget(s, s.button === 2 ? "rightupoutside" : "mouseupoutside"), o = o.parent;
      delete t.pressTargetsByButton[e.button];
    }
    this.freeEvent(s);
  }
  /**
   * Maps the upstream `wheel` event to a downstream `wheel` event.
   * @param from - The upstream `wheel` event.
   */
  mapWheel(e) {
    if (!(e instanceof Bl)) {
      dt("EventBoundary cannot map a non-wheel event as a wheel event");
      return;
    }
    const t = this.createWheelEvent(e);
    this.dispatchEvent(t), this.freeEvent(t);
  }
  /**
   * Maps the upstream `contextmenu` event to a downstream `contextmenu` event.
   * @param from - The upstream `contextmenu` event.
   */
  mapContextMenu(e) {
    if (!(e instanceof _i)) {
      dt("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.createPointerEvent(e);
    this.dispatchEvent(t, "contextmenu"), this.freeEvent(t);
  }
  /**
   * Finds the most specific event-target in the given propagation path that is still mounted in the scene graph.
   *
   * This is used to find the correct `pointerup` and `pointerout` target in the case that the original `pointerdown`
   * or `pointerover` target was unmounted from the scene graph.
   * @param propagationPath - The propagation path was valid in the past.
   * @returns - The most specific event-target still mounted at the same location in the scene graph.
   */
  findMountedTarget(e) {
    if (!e)
      return null;
    let t = e[0];
    for (let n = 1; n < e.length && e[n].parent === t; n++)
      t = e[n];
    return t;
  }
  /**
   * Creates an event whose `originalEvent` is `from`, with an optional `type` and `target` override.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The `originalEvent` for the returned event.
   * @param [type=from.type] - The type of the returned event.
   * @param target - The target of the returned event.
   */
  createPointerEvent(e, t, n) {
    var o;
    const s = this.allocateEvent(_i);
    return this.copyPointerData(e, s), this.copyMouseData(e, s), this.copyData(e, s), s.nativeEvent = e.nativeEvent, s.originalEvent = e, s.target = (o = n != null ? n : this.hitTest(s.global.x, s.global.y)) != null ? o : this._hitElements[0], typeof t == "string" && (s.type = t), s;
  }
  /**
   * Creates a wheel event whose `originalEvent` is `from`.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The upstream wheel event.
   */
  createWheelEvent(e) {
    const t = this.allocateEvent(Bl);
    return this.copyWheelData(e, t), this.copyMouseData(e, t), this.copyData(e, t), t.nativeEvent = e.nativeEvent, t.originalEvent = e, t.target = this.hitTest(t.global.x, t.global.y), t;
  }
  /**
   * Clones the event `from`, with an optional `type` override.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The event to clone.
   * @param [type=from.type] - The type of the returned event.
   */
  clonePointerEvent(e, t) {
    const n = this.allocateEvent(_i);
    return n.nativeEvent = e.nativeEvent, n.originalEvent = e.originalEvent, this.copyPointerData(e, n), this.copyMouseData(e, n), this.copyData(e, n), n.target = e.target, n.path = e.composedPath().slice(), n.type = t != null ? t : n.type, n;
  }
  /**
   * Copies wheel {@link FederatedWheelEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + deltaMode
   * + deltaX
   * + deltaY
   * + deltaZ
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyWheelData(e, t) {
    t.deltaMode = e.deltaMode, t.deltaX = e.deltaX, t.deltaY = e.deltaY, t.deltaZ = e.deltaZ;
  }
  /**
   * Copies pointer {@link FederatedPointerEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + pointerId
   * + width
   * + height
   * + isPrimary
   * + pointerType
   * + pressure
   * + tangentialPressure
   * + tiltX
   * + tiltY
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyPointerData(e, t) {
    e instanceof _i && t instanceof _i && (t.pointerId = e.pointerId, t.width = e.width, t.height = e.height, t.isPrimary = e.isPrimary, t.pointerType = e.pointerType, t.pressure = e.pressure, t.tangentialPressure = e.tangentialPressure, t.tiltX = e.tiltX, t.tiltY = e.tiltY, t.twist = e.twist, t.persistentDeviceId = e.persistentDeviceId);
  }
  /**
   * Copies mouse {@link FederatedMouseEvent} data from `from` to `to`.
   *
   * The following properties are copied:
   * + altKey
   * + button
   * + buttons
   * + clientX
   * + clientY
   * + metaKey
   * + movementX
   * + movementY
   * + pageX
   * + pageY
   * + x
   * + y
   * + screen
   * + shiftKey
   * + global
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyMouseData(e, t) {
    e instanceof vf && t instanceof vf && (t.altKey = e.altKey, t.button = e.button, t.buttons = e.buttons, t.client.copyFrom(e.client), t.ctrlKey = e.ctrlKey, t.metaKey = e.metaKey, t.movement.copyFrom(e.movement), t.screen.copyFrom(e.screen), t.shiftKey = e.shiftKey, t.global.copyFrom(e.global));
  }
  /**
   * Copies base {@link FederatedEvent} data from `from` into `to`.
   *
   * The following properties are copied:
   * + isTrusted
   * + srcElement
   * + timeStamp
   * + type
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyData(e, t) {
    t.isTrusted = e.isTrusted, t.srcElement = e.srcElement, t.timeStamp = performance.now(), t.type = e.type, t.detail = e.detail, t.view = e.view, t.which = e.which, t.layer.copyFrom(e.layer), t.page.copyFrom(e.page);
  }
  /**
   * @param id - The pointer ID.
   * @returns The tracking data stored for the given pointer. If no data exists, a blank
   *  state will be created.
   */
  trackingData(e) {
    return this.mappingState.trackingData[e] || (this.mappingState.trackingData[e] = {
      pressTargetsByButton: {},
      clicksByButton: {},
      overTarget: null
    }), this.mappingState.trackingData[e];
  }
  /**
   * Allocate a specific type of event from {@link EventBoundary#eventPool this.eventPool}.
   *
   * This allocation is constructor-agnostic, as long as it only takes one argument - this event
   * boundary.
   * @param constructor - The event's constructor.
   * @returns An event of the given type.
   */
  allocateEvent(e) {
    this.eventPool.has(e) || this.eventPool.set(e, []);
    const t = this.eventPool.get(e).pop() || new e(this);
    return t.eventPhase = t.NONE, t.currentTarget = null, t.defaultPrevented = !1, t.path = null, t.target = null, t;
  }
  /**
   * Frees the event and puts it back into the event pool.
   *
   * It is illegal to reuse the event until it is allocated again, using `this.allocateEvent`.
   *
   * It is also advised that events not allocated from {@link EventBoundary#allocateEvent this.allocateEvent}
   * not be freed. This is because of the possibility that the same event is freed twice, which can cause
   * it to be allocated twice & result in overwriting.
   * @param event - The event to be freed.
   * @throws Error if the event is managed by another event boundary.
   */
  freeEvent(e) {
    if (e.manager !== this) throw new Error("It is illegal to free an event not managed by this EventBoundary!");
    const t = e.constructor;
    this.eventPool.has(t) || this.eventPool.set(t, []), this.eventPool.get(t).push(e);
  }
  /**
   * Similar to {@link EventEmitter.emit}, except it stops if the `propagationImmediatelyStopped` flag
   * is set on the event.
   * @param e - The event to call each listener with.
   * @param type - The event key.
   */
  _notifyListeners(e, t) {
    const n = e.currentTarget._events[t];
    if (n)
      if ("fn" in n)
        n.once && e.currentTarget.removeListener(t, n.fn, void 0, !0), n.fn.call(n.context, e);
      else
        for (let s = 0, o = n.length; s < o && !e.propagationImmediatelyStopped; s++)
          n[s].once && e.currentTarget.removeListener(t, n[s].fn, void 0, !0), n[s].fn.call(n[s].context, e);
  }
}
const oZ = 1, rZ = {
  touchstart: "pointerdown",
  touchend: "pointerup",
  touchendoutside: "pointerupoutside",
  touchmove: "pointermove",
  touchcancel: "pointercancel"
}, my = class l0 {
  /**
   * @param {Renderer} renderer
   */
  constructor(e) {
    this.supportsTouchEvents = "ontouchstart" in globalThis, this.supportsPointerEvents = !!globalThis.PointerEvent, this.domElement = null, this.resolution = 1, this.renderer = e, this.rootBoundary = new sZ(null), Hs.init(this), this.autoPreventDefault = !0, this._eventsAdded = !1, this._rootPointerEvent = new _i(null), this._rootWheelEvent = new Bl(null), this._rootContextMenuEvent = new _i(null), this.cursorStyles = {
      default: "inherit",
      pointer: "pointer"
    }, this.features = new Proxy({ ...l0.defaultEventFeatures }, {
      set: (t, n, s) => (n === "globalMove" && (this.rootBoundary.enableGlobalMoveEvents = s), t[n] = s, !0)
    }), this._onPointerDown = this._onPointerDown.bind(this), this._onPointerMove = this._onPointerMove.bind(this), this._onPointerUp = this._onPointerUp.bind(this), this._onPointerOverOut = this._onPointerOverOut.bind(this), this._onContextMenu = this._onContextMenu.bind(this), this.onWheel = this.onWheel.bind(this);
  }
  /**
   * The default interaction mode for all display objects.
   * @see Container.eventMode
   * @type {EventMode}
   * @readonly
   * @since 7.2.0
   */
  static get defaultEventMode() {
    return this._defaultEventMode;
  }
  /**
   * Runner init called, view is available at this point.
   * @ignore
   */
  init(e) {
    var s, o;
    const { canvas: t, resolution: n } = this.renderer;
    this.setTargetElement(t), this.resolution = n, l0._defaultEventMode = (s = e.eventMode) != null ? s : "passive", Object.assign(this.features, (o = e.eventFeatures) != null ? o : {}), this.rootBoundary.enableGlobalMoveEvents = this.features.globalMove;
  }
  /**
   * Handle changing resolution.
   * @ignore
   */
  resolutionChange(e) {
    this.resolution = e;
  }
  /** Destroys all event listeners and detaches the renderer. */
  destroy() {
    Hs.destroy(), this.setTargetElement(null), this.renderer = null, this._currentCursor = null;
  }
  /**
   * Sets the current cursor mode, handling any callbacks or CSS style changes.
   * The cursor can be a CSS cursor string, a custom callback function, or a key from the cursorStyles dictionary.
   * @param mode - Cursor mode to set. Can be:
   * - A CSS cursor string (e.g., 'pointer', 'grab')
   * - A key from the cursorStyles dictionary
   * - null/undefined to reset to default
   * @example
   * ```ts
   * // Using predefined cursor styles
   * app.renderer.events.setCursor('pointer');    // Set standard pointer cursor
   * app.renderer.events.setCursor('grab');       // Set grab cursor
   * app.renderer.events.setCursor(null);         // Reset to default
   *
   * // Using custom cursor styles
   * app.renderer.events.cursorStyles.custom = 'url("cursor.png"), auto';
   * app.renderer.events.setCursor('custom');     // Apply custom cursor
   *
   * // Using callback-based cursor
   * app.renderer.events.cursorStyles.dynamic = (mode) => {
   *     document.body.style.cursor = mode === 'hover' ? 'pointer' : 'default';
   * };
   * app.renderer.events.setCursor('dynamic');    // Trigger cursor callback
   * ```
   * @remarks
   * - Has no effect on OffscreenCanvas except for callback-based cursors
   * - Caches current cursor to avoid unnecessary DOM updates
   * - Supports CSS cursor values, style objects, and callback functions
   * @see {@link EventSystem.cursorStyles} For defining custom cursor styles
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/cursor} MDN Cursor Reference
   */
  setCursor(e) {
    e || (e = "default");
    let t = !0;
    if (globalThis.OffscreenCanvas && this.domElement instanceof OffscreenCanvas && (t = !1), this._currentCursor === e)
      return;
    this._currentCursor = e;
    const n = this.cursorStyles[e];
    if (n)
      switch (typeof n) {
        case "string":
          t && (this.domElement.style.cursor = n);
          break;
        case "function":
          n(e);
          break;
        case "object":
          t && Object.assign(this.domElement.style, n);
          break;
      }
    else t && typeof e == "string" && !Object.prototype.hasOwnProperty.call(this.cursorStyles, e) && (this.domElement.style.cursor = e);
  }
  /**
   * The global pointer event instance containing the most recent pointer state.
   * This is useful for accessing pointer information without listening to events.
   * @example
   * ```ts
   * // Access current pointer position at any time
   * const eventSystem = app.renderer.events;
   * const pointer = eventSystem.pointer;
   *
   * // Get global coordinates
   * console.log('Position:', pointer.global.x, pointer.global.y);
   *
   * // Check button state
   * console.log('Buttons pressed:', pointer.buttons);
   *
   * // Get pointer type and pressure
   * console.log('Type:', pointer.pointerType);
   * console.log('Pressure:', pointer.pressure);
   * ```
   * @readonly
   * @since 7.2.0
   * @see {@link FederatedPointerEvent} For all available pointer properties
   */
  get pointer() {
    return this._rootPointerEvent;
  }
  /**
   * Event handler for pointer down events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerDown(e) {
    if (!this.features.click) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const t = this._normalizeToPointerData(e);
    this.autoPreventDefault && t[0].isNormalized && (e.cancelable || !("cancelable" in e)) && e.preventDefault();
    for (let n = 0, s = t.length; n < s; n++) {
      const o = t[n], r = this._bootstrapEvent(this._rootPointerEvent, o);
      this.rootBoundary.mapEvent(r);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer move events on on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch events.
   */
  _onPointerMove(e) {
    if (!this.features.move) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, Hs.pointerMoved();
    const t = this._normalizeToPointerData(e);
    for (let n = 0, s = t.length; n < s; n++) {
      const o = this._bootstrapEvent(this._rootPointerEvent, t[n]);
      this.rootBoundary.mapEvent(o);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer up events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerUp(e) {
    if (!this.features.click) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    let t = e.target;
    e.composedPath && e.composedPath().length > 0 && (t = e.composedPath()[0]);
    const n = t !== this.domElement ? "outside" : "", s = this._normalizeToPointerData(e);
    for (let o = 0, r = s.length; o < r; o++) {
      const a = this._bootstrapEvent(this._rootPointerEvent, s[o]);
      a.type += n, this.rootBoundary.mapEvent(a);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer over & out events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerOverOut(e) {
    if (!this.features.click) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const t = this._normalizeToPointerData(e);
    for (let n = 0, s = t.length; n < s; n++) {
      const o = this._bootstrapEvent(this._rootPointerEvent, t[n]);
      this.rootBoundary.mapEvent(o);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for `contextmenu` events on {@link EventSystem#domElement this.domElement}.
   *
   * {@link EventSystem#autoPreventDefault autoPreventDefault} does not apply, so the browser menu
   * opens unless a listener calls `preventDefault()`.
   * @param nativeEvent - The native mouse/pointer event.
   */
  _onContextMenu(e) {
    if (!this.features.click) return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const t = this._normalizeToPointerData(e);
    for (let n = 0, s = t.length; n < s; n++) {
      const o = this._bootstrapEvent(this._rootContextMenuEvent, t[n]);
      this.rootBoundary.mapEvent(o);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Passive handler for `wheel` events on {@link EventSystem.domElement this.domElement}.
   * @param nativeEvent - The native wheel event.
   */
  onWheel(e) {
    if (!this.features.wheel) return;
    const t = this.normalizeWheelEvent(e);
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, this.rootBoundary.mapEvent(t);
  }
  /**
   * Sets the {@link EventSystem#domElement domElement} and binds event listeners.
   * This method manages the DOM event bindings for the event system, allowing you to
   * change or remove the target element that receives input events.
   * > [!IMPORTANT] This will default to the canvas element of the renderer, so you
   * > should not need to call this unless you are using a custom element.
   * @param element - The new DOM element to bind events to, or null to remove all event bindings
   * @example
   * ```ts
   * // Set a new canvas element as the target
   * const canvas = document.createElement('canvas');
   * app.renderer.events.setTargetElement(canvas);
   *
   * // Remove all event bindings
   * app.renderer.events.setTargetElement(null);
   *
   * // Switch to a different canvas
   * const newCanvas = document.querySelector('#game-canvas');
   * app.renderer.events.setTargetElement(newCanvas);
   * ```
   * @remarks
   * - Automatically removes event listeners from previous element
   * - Required for the event system to function
   * - Safe to call multiple times
   * @see {@link EventSystem#domElement} The current DOM element
   * @see {@link EventsTicker} For the ticker system that tracks pointer movement
   */
  setTargetElement(e) {
    this._removeEvents(), this.domElement = e, Hs.domElement = e, this._addEvents();
  }
  /** Register event listeners on {@link Renderer#domElement this.domElement}. */
  _addEvents() {
    if (this._eventsAdded || !this.domElement)
      return;
    Hs.addTickerListener();
    const e = this.domElement.style;
    e && (globalThis.navigator.msPointerEnabled ? (e.msContentZooming = "none", e.msTouchAction = "none") : this.supportsPointerEvents && (e.touchAction = "none")), this.supportsPointerEvents ? (globalThis.document.addEventListener("pointermove", this._onPointerMove, !0), this.domElement.addEventListener("pointerdown", this._onPointerDown, !0), this.domElement.addEventListener("pointerleave", this._onPointerOverOut, !0), this.domElement.addEventListener("pointerover", this._onPointerOverOut, !0), globalThis.addEventListener("pointerup", this._onPointerUp, !0)) : (globalThis.document.addEventListener("mousemove", this._onPointerMove, !0), this.domElement.addEventListener("mousedown", this._onPointerDown, !0), this.domElement.addEventListener("mouseout", this._onPointerOverOut, !0), this.domElement.addEventListener("mouseover", this._onPointerOverOut, !0), globalThis.addEventListener("mouseup", this._onPointerUp, !0), this.supportsTouchEvents && (this.domElement.addEventListener("touchstart", this._onPointerDown, !0), this.domElement.addEventListener("touchend", this._onPointerUp, !0), this.domElement.addEventListener("touchmove", this._onPointerMove, !0))), this.domElement.addEventListener("wheel", this.onWheel, {
      passive: !0,
      capture: !0
    }), this.domElement.addEventListener("contextmenu", this._onContextMenu, !0), this._eventsAdded = !0;
  }
  /** Unregister event listeners on {@link EventSystem#domElement this.domElement}. */
  _removeEvents() {
    if (!this._eventsAdded || !this.domElement)
      return;
    Hs.removeTickerListener();
    const e = this.domElement.style;
    e && (globalThis.navigator.msPointerEnabled ? (e.msContentZooming = "", e.msTouchAction = "") : this.supportsPointerEvents && (e.touchAction = "")), this.supportsPointerEvents ? (globalThis.document.removeEventListener("pointermove", this._onPointerMove, !0), this.domElement.removeEventListener("pointerdown", this._onPointerDown, !0), this.domElement.removeEventListener("pointerleave", this._onPointerOverOut, !0), this.domElement.removeEventListener("pointerover", this._onPointerOverOut, !0), globalThis.removeEventListener("pointerup", this._onPointerUp, !0)) : (globalThis.document.removeEventListener("mousemove", this._onPointerMove, !0), this.domElement.removeEventListener("mousedown", this._onPointerDown, !0), this.domElement.removeEventListener("mouseout", this._onPointerOverOut, !0), this.domElement.removeEventListener("mouseover", this._onPointerOverOut, !0), globalThis.removeEventListener("mouseup", this._onPointerUp, !0), this.supportsTouchEvents && (this.domElement.removeEventListener("touchstart", this._onPointerDown, !0), this.domElement.removeEventListener("touchend", this._onPointerUp, !0), this.domElement.removeEventListener("touchmove", this._onPointerMove, !0))), this.domElement.removeEventListener("wheel", this.onWheel, !0), this.domElement.removeEventListener("contextmenu", this._onContextMenu, !0), this.domElement = null, this._eventsAdded = !1;
  }
  /**
   * Maps coordinates from DOM/screen space into PixiJS normalized coordinates.
   * This takes into account the current scale, position, and resolution of the DOM element.
   * @param point - The point to store the mapped coordinates in
   * @param x - The x coordinate in DOM/client space
   * @param y - The y coordinate in DOM/client space
   * @example
   * ```ts
   * // Map mouse coordinates to PixiJS space
   * const point = new Point();
   * app.renderer.events.mapPositionToPoint(
   *     point,
   *     event.clientX,
   *     event.clientY
   * );
   * console.log('Mapped position:', point.x, point.y);
   *
   * // Using with pointer events
   * sprite.on('pointermove', (event) => {
   *     // event.global already contains mapped coordinates
   *     console.log('Global:', event.global.x, event.global.y);
   *
   *     // Map to local coordinates
   *     const local = event.getLocalPosition(sprite);
   *     console.log('Local:', local.x, local.y);
   * });
   * ```
   * @remarks
   * - Accounts for element scaling and positioning
   * - Adjusts for device pixel ratio/resolution
   */
  mapPositionToPoint(e, t, n) {
    const s = this.domElement.isConnected ? this.domElement.getBoundingClientRect() : {
      width: this.domElement.width,
      height: this.domElement.height,
      left: 0,
      top: 0
    }, o = 1 / this.resolution;
    e.x = (t - s.left) * (this.domElement.width / s.width) * o, e.y = (n - s.top) * (this.domElement.height / s.height) * o;
  }
  /**
   * Ensures that the original event object contains all data that a regular pointer event would have
   * @param event - The original event data from a touch or mouse event
   * @returns An array containing a single normalized pointer event, in the case of a pointer
   *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
   */
  _normalizeToPointerData(e) {
    var n, s, o, r;
    const t = [];
    if (this.supportsTouchEvents && e instanceof TouchEvent)
      for (let a = 0, l = e.changedTouches.length; a < l; a++) {
        const d = e.changedTouches[a];
        typeof d.button == "undefined" && (d.button = 0), typeof d.buttons == "undefined" && (d.buttons = 1), typeof d.isPrimary == "undefined" && (d.isPrimary = e.touches.length === 1 && e.type === "touchstart"), typeof d.width == "undefined" && (d.width = d.radiusX || 1), typeof d.height == "undefined" && (d.height = d.radiusY || 1), typeof d.tiltX == "undefined" && (d.tiltX = 0), typeof d.tiltY == "undefined" && (d.tiltY = 0), typeof d.pointerType == "undefined" && (d.pointerType = "touch"), typeof d.pointerId == "undefined" && (d.pointerId = d.identifier || 0), typeof d.pressure == "undefined" && (d.pressure = d.force || 0.5), typeof d.twist == "undefined" && (d.twist = 0), typeof d.tangentialPressure == "undefined" && (d.tangentialPressure = 0), typeof d.layerX == "undefined" && (d.layerX = d.offsetX = d.clientX), typeof d.layerY == "undefined" && (d.layerY = d.offsetY = d.clientY), d.isNormalized = !0, d.type = e.type, (n = d.altKey) != null || (d.altKey = e.altKey), (s = d.ctrlKey) != null || (d.ctrlKey = e.ctrlKey), (o = d.metaKey) != null || (d.metaKey = e.metaKey), (r = d.shiftKey) != null || (d.shiftKey = e.shiftKey), t.push(d);
      }
    else if (!globalThis.MouseEvent || e instanceof MouseEvent && (!this.supportsPointerEvents || !(e instanceof globalThis.PointerEvent))) {
      const a = e;
      typeof a.isPrimary == "undefined" && (a.isPrimary = !0), typeof a.width == "undefined" && (a.width = 1), typeof a.height == "undefined" && (a.height = 1), typeof a.tiltX == "undefined" && (a.tiltX = 0), typeof a.tiltY == "undefined" && (a.tiltY = 0), typeof a.pointerType == "undefined" && (a.pointerType = "mouse"), typeof a.pointerId == "undefined" && (a.pointerId = oZ), typeof a.pressure == "undefined" && (a.pressure = 0.5), typeof a.twist == "undefined" && (a.twist = 0), typeof a.tangentialPressure == "undefined" && (a.tangentialPressure = 0), a.isNormalized = !0, t.push(a);
    } else
      t.push(e);
    return t;
  }
  /**
   * Normalizes the native {@link https://w3c.github.io/uievents/#interface-wheelevent WheelEvent}.
   *
   * The returned {@link FederatedWheelEvent} is a shared instance. It will not persist across
   * multiple native wheel events.
   * @param nativeEvent - The native wheel event that occurred on the canvas.
   * @returns A federated wheel event.
   */
  normalizeWheelEvent(e) {
    const t = this._rootWheelEvent;
    return this._transferMouseData(t, e), t.deltaX = e.deltaX, t.deltaY = e.deltaY, t.deltaZ = e.deltaZ, t.deltaMode = e.deltaMode, this.mapPositionToPoint(t.screen, e.clientX, e.clientY), t.global.copyFrom(t.screen), t.offset.copyFrom(t.screen), t.nativeEvent = e, t.type = e.type, t;
  }
  /**
   * Normalizes the `nativeEvent` into a federateed {@link FederatedPointerEvent}.
   * @param event
   * @param nativeEvent
   */
  _bootstrapEvent(e, t) {
    return e.originalEvent = null, e.nativeEvent = t, e.pointerId = t.pointerId, e.width = t.width, e.height = t.height, e.isPrimary = t.isPrimary, e.pointerType = t.pointerType, e.pressure = t.pressure, e.tangentialPressure = t.tangentialPressure, e.tiltX = t.tiltX, e.tiltY = t.tiltY, e.twist = t.twist, this._transferMouseData(e, t), this.mapPositionToPoint(e.screen, t.clientX, t.clientY), e.global.copyFrom(e.screen), e.offset.copyFrom(e.screen), e.isTrusted = t.isTrusted, e.type === "pointerleave" && (e.type = "pointerout"), e.type.startsWith("mouse") && (e.type = e.type.replace("mouse", "pointer")), e.type.startsWith("touch") && (e.type = rZ[e.type] || e.type), e;
  }
  /**
   * Transfers base & mouse event data from the `nativeEvent` to the federated event.
   * @param event
   * @param nativeEvent
   */
  _transferMouseData(e, t) {
    e.isTrusted = t.isTrusted, e.srcElement = t.srcElement, e.timeStamp = performance.now(), e.type = t.type, e.altKey = t.altKey, e.button = t.button, e.buttons = t.buttons, e.client.x = t.clientX, e.client.y = t.clientY, e.ctrlKey = t.ctrlKey, e.metaKey = t.metaKey, e.movement.x = t.movementX, e.movement.y = t.movementY, e.page.x = t.pageX, e.page.y = t.pageY, e.relatedTarget = null, e.shiftKey = t.shiftKey;
  }
};
my.extension = {
  name: "events",
  type: [
    Ie.WebGLSystem,
    Ie.CanvasSystem,
    Ie.WebGPUSystem
  ],
  priority: -1
};
my.defaultEventFeatures = {
  /** Enables pointer events associated with pointer movement. */
  move: !0,
  /** Enables global pointer move events. */
  globalMove: !0,
  /** Enables pointer events associated with clicking. */
  click: !0,
  /** Enables wheel events. */
  wheel: !0
};
let BM = my;
const aZ = {
  onclick: null,
  oncontextmenu: null,
  onmousedown: null,
  onmouseenter: null,
  onmouseleave: null,
  onmousemove: null,
  onglobalmousemove: null,
  onmouseout: null,
  onmouseover: null,
  onmouseup: null,
  onmouseupoutside: null,
  onpointercancel: null,
  onpointerdown: null,
  onpointerenter: null,
  onpointerleave: null,
  onpointermove: null,
  onglobalpointermove: null,
  onpointerout: null,
  onpointerover: null,
  onpointertap: null,
  onpointerup: null,
  onpointerupoutside: null,
  onrightclick: null,
  onrightdown: null,
  onrightup: null,
  onrightupoutside: null,
  ontap: null,
  ontouchcancel: null,
  ontouchend: null,
  ontouchendoutside: null,
  ontouchmove: null,
  onglobaltouchmove: null,
  ontouchstart: null,
  onwheel: null,
  get interactive() {
    return this.eventMode === "dynamic" || this.eventMode === "static";
  },
  set interactive(i) {
    this.eventMode = i ? "static" : "passive";
  },
  _internalEventMode: void 0,
  get eventMode() {
    var i;
    return (i = this._internalEventMode) != null ? i : BM.defaultEventMode;
  },
  set eventMode(i) {
    this._internalEventMode = i;
  },
  isInteractive() {
    return this.eventMode === "static" || this.eventMode === "dynamic";
  },
  interactiveChildren: !0,
  hitArea: null,
  addEventListener(i, e, t) {
    const n = typeof t == "boolean" && t || typeof t == "object" && t.capture, s = typeof t == "object" ? t.signal : void 0, o = typeof t == "object" ? t.once === !0 : !1, r = typeof e == "function" ? void 0 : e;
    i = n ? `${i}capture` : i;
    const a = typeof e == "function" ? e : e.handleEvent, l = this;
    s && s.addEventListener("abort", () => {
      l.off(i, a, r);
    }), o ? l.once(i, a, r) : l.on(i, a, r);
  },
  removeEventListener(i, e, t) {
    const n = typeof t == "boolean" && t || typeof t == "object" && t.capture, s = typeof e == "function" ? void 0 : e;
    i = n ? `${i}capture` : i, e = typeof e == "function" ? e : e.handleEvent, this.off(i, e, s);
  },
  dispatchEvent(i) {
    if (!(i instanceof xu))
      throw new Error("Container cannot propagate events outside of the Federated Events API");
    return i.defaultPrevented = !1, i.path = null, i.target = this, i.manager.dispatchEvent(i), !i.defaultPrevented;
  }
};
let Pa;
function I2(i) {
  const e = zt.get().createCanvas(6, 1), t = e.getContext("2d");
  return t.fillStyle = i, t.fillRect(0, 0, 6, 1), e;
}
function FM() {
  if (Pa !== void 0)
    return Pa;
  try {
    const i = I2("#ff00ff"), e = I2("#ffff00"), n = zt.get().createCanvas(6, 1).getContext("2d");
    n.globalCompositeOperation = "multiply", n.drawImage(i, 0, 0), n.drawImage(e, 2, 0);
    const s = n.getImageData(2, 0, 1, 1);
    if (!s)
      Pa = !1;
    else {
      const o = s.data;
      Pa = o[0] === 255 && o[1] === 0 && o[2] === 0;
    }
  } catch {
    Pa = !1;
  }
  return Pa;
}
const _t = {
  canvas: null,
  convertTintToImage: !1,
  cacheStepsPerColorChannel: 8,
  canUseMultiply: FM(),
  tintMethod: null,
  _canvasSourceCache: /* @__PURE__ */ new WeakMap(),
  _unpremultipliedCache: /* @__PURE__ */ new WeakMap(),
  getCanvasSource: (i) => {
    var a, l;
    const e = i.source, t = e == null ? void 0 : e.resource;
    if (!t)
      return null;
    const n = e.alphaMode === "premultiplied-alpha", s = (a = e.resourceWidth) != null ? a : e.pixelWidth, o = (l = e.resourceHeight) != null ? l : e.pixelHeight, r = s !== e.pixelWidth || o !== e.pixelHeight;
    if (n) {
      if ((t instanceof HTMLCanvasElement || typeof OffscreenCanvas != "undefined" && t instanceof OffscreenCanvas) && !r)
        return t;
      const d = _t._unpremultipliedCache.get(e);
      if ((d == null ? void 0 : d.resourceId) === e._resourceId)
        return d.canvas;
    }
    if (t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Int8Array || t instanceof Uint16Array || t instanceof Int16Array || t instanceof Uint32Array || t instanceof Int32Array || t instanceof Float32Array || t instanceof ArrayBuffer) {
      const d = _t._canvasSourceCache.get(e);
      if ((d == null ? void 0 : d.resourceId) === e._resourceId)
        return d.canvas;
      const c = zt.get().createCanvas(e.pixelWidth, e.pixelHeight), h = c.getContext("2d"), f = h.createImageData(e.pixelWidth, e.pixelHeight), p = f.data, y = t instanceof ArrayBuffer ? new Uint8Array(t) : new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
      if (e.format === "bgra8unorm")
        for (let v = 0; v < p.length && v + 3 < y.length; v += 4)
          p[v] = y[v + 2], p[v + 1] = y[v + 1], p[v + 2] = y[v], p[v + 3] = y[v + 3];
      else
        p.set(y.subarray(0, p.length));
      return h.putImageData(f, 0, 0), _t._canvasSourceCache.set(e, { canvas: c, resourceId: e._resourceId }), c;
    }
    if (n) {
      const d = zt.get().createCanvas(e.pixelWidth, e.pixelHeight), c = d.getContext("2d", { willReadFrequently: !0 });
      d.width = e.pixelWidth, d.height = e.pixelHeight, c.drawImage(t, 0, 0);
      const h = c.getImageData(0, 0, d.width, d.height), f = h.data;
      for (let p = 0; p < f.length; p += 4) {
        const y = f[p + 3];
        if (y > 0) {
          const v = 255 / y;
          f[p] = Math.min(255, f[p] * v + 0.5), f[p + 1] = Math.min(255, f[p + 1] * v + 0.5), f[p + 2] = Math.min(255, f[p + 2] * v + 0.5);
        }
      }
      return c.putImageData(h, 0, 0), _t._unpremultipliedCache.set(e, { canvas: d, resourceId: e._resourceId }), d;
    }
    if (r) {
      const d = _t._canvasSourceCache.get(e);
      if ((d == null ? void 0 : d.resourceId) === e._resourceId)
        return d.canvas;
      const c = zt.get().createCanvas(e.pixelWidth, e.pixelHeight), h = c.getContext("2d");
      return c.width = e.pixelWidth, c.height = e.pixelHeight, h.drawImage(t, 0, 0), _t._canvasSourceCache.set(e, { canvas: c, resourceId: e._resourceId }), c;
    }
    return t;
  },
  getTintedCanvas: (i, e) => {
    const t = i.texture, n = bn.shared.setValue(e).toHex(), s = t.tintCache || (t.tintCache = {}), o = s[n], r = t.source._resourceId;
    if ((o == null ? void 0 : o.tintId) === r)
      return o;
    const a = o && "getContext" in o ? o : zt.get().createCanvas();
    return _t.tintMethod(t, e, a), a.tintId = r, s[n] = a, s[n];
  },
  getTintedPattern: (i, e) => {
    const t = bn.shared.setValue(e).toHex(), n = i.patternCache || (i.patternCache = {}), s = i.source._resourceId;
    let o = n[t];
    return (o == null ? void 0 : o.tintId) === s || (_t.canvas || (_t.canvas = zt.get().createCanvas()), _t.tintMethod(i, e, _t.canvas), o = _t.canvas.getContext("2d").createPattern(_t.canvas, "repeat"), o.tintId = s, n[t] = o), o;
  },
  /**
   * Applies a transform to a CanvasPattern.
   * @param pattern - The pattern to apply the transform to.
   * @param matrix - The matrix to apply.
   * @param matrix.a
   * @param matrix.b
   * @param matrix.c
   * @param matrix.d
   * @param matrix.tx
   * @param matrix.ty
   * @param invert
   */
  applyPatternTransform: (i, e, t = !0) => {
    if (!e) return;
    const n = i;
    if (!n.setTransform) return;
    const s = globalThis.DOMMatrix;
    if (!s) return;
    const o = new s([e.a, e.b, e.c, e.d, e.tx, e.ty]);
    n.setTransform(t ? o.inverse() : o);
  },
  tintWithMultiply: (i, e, t) => {
    var h, f;
    const n = t.getContext("2d"), s = i.frame.clone(), o = (f = (h = i.source._resolution) != null ? h : i.source.resolution) != null ? f : 1, r = i.rotate;
    s.x *= o, s.y *= o, s.width *= o, s.height *= o;
    const a = Mt.isVertical(r), l = a ? s.height : s.width, d = a ? s.width : s.height;
    t.width = Math.ceil(l), t.height = Math.ceil(d), n.save(), e !== 16777215 && (n.fillStyle = bn.shared.setValue(e).toHex(), n.fillRect(0, 0, l, d), n.globalCompositeOperation = "multiply");
    const c = _t.getCanvasSource(i);
    if (!c) {
      n.restore();
      return;
    }
    r && _t._applyInverseRotation(n, r, s.width, s.height), n.drawImage(
      c,
      s.x,
      s.y,
      s.width,
      s.height,
      0,
      0,
      s.width,
      s.height
    ), e !== 16777215 && (n.globalCompositeOperation = "destination-atop", n.drawImage(
      c,
      s.x,
      s.y,
      s.width,
      s.height,
      0,
      0,
      s.width,
      s.height
    )), n.restore();
  },
  tintWithOverlay: (i, e, t) => {
    var h, f;
    const n = t.getContext("2d"), s = i.frame.clone(), o = (f = (h = i.source._resolution) != null ? h : i.source.resolution) != null ? f : 1, r = i.rotate;
    s.x *= o, s.y *= o, s.width *= o, s.height *= o;
    const a = Mt.isVertical(r), l = a ? s.height : s.width, d = a ? s.width : s.height;
    t.width = Math.ceil(l), t.height = Math.ceil(d), n.save(), n.globalCompositeOperation = "copy", n.fillStyle = bn.shared.setValue(e).toHex(), n.fillRect(0, 0, l, d), n.globalCompositeOperation = "destination-atop";
    const c = _t.getCanvasSource(i);
    if (!c) {
      n.restore();
      return;
    }
    r && _t._applyInverseRotation(n, r, s.width, s.height), n.drawImage(
      c,
      s.x,
      s.y,
      s.width,
      s.height,
      0,
      0,
      s.width,
      s.height
    ), n.restore();
  },
  tintWithPerPixel: (i, e, t) => {
    var x, w;
    const n = t.getContext("2d"), s = i.frame.clone(), o = (w = (x = i.source._resolution) != null ? x : i.source.resolution) != null ? w : 1, r = i.rotate;
    s.x *= o, s.y *= o, s.width *= o, s.height *= o;
    const a = Mt.isVertical(r), l = a ? s.height : s.width, d = a ? s.width : s.height;
    t.width = Math.ceil(l), t.height = Math.ceil(d), n.save(), n.globalCompositeOperation = "copy";
    const c = _t.getCanvasSource(i);
    if (!c) {
      n.restore();
      return;
    }
    r && _t._applyInverseRotation(n, r, s.width, s.height), n.drawImage(
      c,
      s.x,
      s.y,
      s.width,
      s.height,
      0,
      0,
      s.width,
      s.height
    ), n.restore();
    const h = e >> 16 & 255, f = e >> 8 & 255, p = e & 255, y = n.getImageData(0, 0, l, d), v = y.data;
    for (let S = 0; S < v.length; S += 4)
      v[S] = v[S] * h / 255, v[S + 1] = v[S + 1] * f / 255, v[S + 2] = v[S + 2] * p / 255;
    n.putImageData(y, 0, 0);
  },
  /**
   * Applies inverse rotation transform to context for texture packer rotation compensation.
   * Supports all 16 groupD8 symmetries (rotations and reflections).
   * @param context - Canvas 2D context
   * @param rotate - The groupD8 rotation value
   * @param srcWidth - Source crop width (before rotation)
   * @param srcHeight - Source crop height (before rotation)
   */
  _applyInverseRotation: (i, e, t, n) => {
    const s = Mt.inv(e), o = Mt.uX(s), r = Mt.uY(s), a = Mt.vX(s), l = Mt.vY(s), d = -Math.min(0, o * t, a * n, o * t + a * n), c = -Math.min(0, r * t, l * n, r * t + l * n);
    i.transform(o, r, a, l, d, c);
  }
};
_t.tintMethod = _t.canUseMultiply ? _t.tintWithMultiply : _t.tintWithPerPixel;
const jg = 32767;
function A2(i, e) {
  return (i << 17) + (e << 2);
}
class lZ {
  constructor(e) {
    this._buckets = /* @__PURE__ */ new Map(), this._screens = new SS(), this._enableFullScreen = !1, this.canvasOptions = e || {};
  }
  /**
   * Has no effect. The pool sizes canvases to the screens registered with
   * {@link CanvasPoolClass#setScreenSize|setScreenSize}.
   * @deprecated since 8.21.0
   */
  get enableFullScreen() {
    return rt(js, "CanvasPool.enableFullScreen is no longer used, the pool sizes canvases to the screens registered with setScreenSize."), this._enableFullScreen;
  }
  set enableFullScreen(e) {
    rt(js, "CanvasPool.enableFullScreen is no longer used, the pool sizes canvases to the screens registered with setScreenSize."), this._enableFullScreen = e;
  }
  /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */
  _createCanvasAndContext(e, t) {
    const n = zt.get().createCanvas();
    n.width = e, n.height = t;
    const s = n.getContext("2d");
    return { canvas: n, context: s };
  }
  /**
   * Gets a Power-of-Two canvas or screen sized canvas
   * @param minWidth - The minimum width of the canvas.
   * @param minHeight - The minimum height of the canvas.
   * @param resolution - The resolution of the canvas.
   * @returns The new canvas and its context.
   */
  getOptimalCanvasAndContext(e, t, n = 1) {
    const { width: s, height: o } = this.getOptimalSize(e, t, n);
    (s > jg || o > jg) && dt(`CanvasPool: ${s}x${o} is larger than the ${jg}px pool key limit, canvases of this size may be pooled together`);
    const r = A2(s, o);
    let a = this._buckets.get(r);
    a || (a = [], this._buckets.set(r, a));
    let l = a.pop();
    return l || (l = this._createCanvasAndContext(s, o)), l;
  }
  /**
   * The backing size, in physical pixels, that
   * {@link CanvasPoolClass#getOptimalCanvasAndContext|getOptimalCanvasAndContext} would allocate for a request,
   * without taking a canvas from the pool.
   *
   * Each axis is the next power of two, or the smallest registered screen the request fits inside
   * (see {@link CanvasPoolClass#setScreenSize|setScreenSize}).
   * @param minWidth - The minimum width of the canvas.
   * @param minHeight - The minimum height of the canvas.
   * @param resolution - The resolution of the canvas.
   * @returns The width and height the pooled canvas would have, in physical pixels.
   */
  getOptimalSize(e, t, n = 1) {
    const s = Math.ceil(e * n - 1e-6), o = Math.ceil(t * n - 1e-6), r = cf(s), a = this._screens.getFittingWidth(s), l = cf(o), d = this._screens.getFittingHeight(o);
    return {
      width: a !== void 0 ? Math.min(a, r) : r,
      height: d !== void 0 ? Math.min(d, l) : l
    };
  }
  /**
   * Place a canvas back into the pool.
   * @param canvasAndContext
   */
  returnCanvasAndContext(e) {
    const t = e.canvas, { width: n, height: s } = t, o = this._buckets.get(A2(n, s));
    o && (e.context.resetTransform(), e.context.clearRect(0, 0, n, s), o.push(e));
  }
  /**
   * Registers the screen size of a renderer with the pool, in physical pixels.
   *
   * While a screen is registered, a request that fits inside it on an axis is given that screen's size on
   * that axis instead of the next power of two, which stops a full screen canvas from being allocated far
   * larger than the screen. Requests larger than every registered screen on an axis keep the power of two
   * size - the pool never rounds a request up to a screen it does not fit in.
   * @param rendererUid - The uid of the renderer, used to update or remove this screen later.
   * @param pixelWidth - The width of the screen in physical pixels.
   * @param pixelHeight - The height of the screen in physical pixels.
   */
  setScreenSize(e, t, n) {
    this._screens.set(e, t, n) && this._pruneScreenCanvases();
  }
  /**
   * Removes a screen previously registered with
   * {@link CanvasPoolClass#setScreenSize|setScreenSize}, dropping any idle canvases that were
   * only being kept for it.
   * @param rendererUid - The uid the screen was registered with.
   */
  removeScreen(e) {
    this._screens.remove(e) && this._pruneScreenCanvases();
  }
  /** Clears the pool. */
  clear() {
    this._buckets.clear();
  }
  /**
   * Drops the idle canvases in every bucket that has a non power of two dimension matching no live
   * screen. Power of two buckets are always kept, as any request can fall back to them.
   */
  _pruneScreenCanvases() {
    for (const [e] of this._buckets) {
      const t = e >>> 17, n = e >>> 2 & 32767;
      ($l(t) || this._screens.hasWidth(t)) && ($l(n) || this._screens.hasHeight(n)) || this._buckets.delete(e);
    }
  }
}
const Fl = new lZ();
Yl.register(Fl);
const P2 = new st();
function NM(i, e) {
  var n;
  e.clear();
  const t = e.matrix;
  for (let s = 0; s < i.length; s++) {
    const o = i[s];
    if (o.globalDisplayStatus < 7)
      continue;
    const r = (n = o.renderGroup) != null ? n : o.parentRenderGroup;
    r != null && r.isCachedAsTexture ? e.matrix = P2.copyFrom(r.textureOffsetInverseTransform).append(o.worldTransform) : r != null && r._parentCacheAsTextureRenderGroup ? e.matrix = P2.copyFrom(r._parentCacheAsTextureRenderGroup.inverseWorldTransform).append(o.groupTransform) : e.matrix = o.worldTransform, e.addBounds(o.bounds);
  }
  return e.matrix = t, e;
}
const dZ = new Gn();
function cZ(i, e, t, n, s = !1, o) {
  const r = dZ;
  r.minX = 0, r.minY = 0, r.maxX = i.width / n | 0, r.maxY = i.height / n | 0;
  const a = Nn.getOptimalTexture({
    width: r.width,
    height: r.height,
    resolution: n,
    autoGenerateMipmaps: s,
    scaleMode: o
  });
  return a.source.uploadMethodId = "image", a.source.resource = i, a.source.alphaMode = "premultiply-alpha-on-upload", a.frame.width = e / n, a.frame.height = t / n, a.source.emit("update", a.source), a.updateUvs(), a;
}
function E2(i) {
  return typeof i.getCanvasFilterString == "function";
}
class uZ {
  constructor() {
    this.skip = !1, this.useClip = !1, this.filters = null, this.container = null, this.bounds = new Gn(), this.cssFilterString = "";
  }
}
class UM {
  /**
   * @param renderer - The Canvas renderer
   * @param renderer.canvasContext
   * @param renderer.canvasContext.activeContext
   * @param renderer.canvasContext.activeResolution
   */
  constructor(e) {
    this._filterStack = [], this._filterStackIndex = 0, this._savedStates = [], this._alphaMultiplier = 1, this._warnedFilterTypes = /* @__PURE__ */ new Set(), this.renderer = e;
  }
  /**
   * Push a filter instruction onto the stack.
   * Called when entering a filtered container.
   * @param instruction - The filter instruction from FilterPipe
   */
  push(e) {
    const t = this._pushFilterFrame(), n = e.filterEffect.filters;
    if (t.skip = !1, t.useClip = !1, t.filters = n, t.container = e.container, t.cssFilterString = "", n.every((l) => !l.enabled)) {
      t.skip = !0;
      return;
    }
    const s = [], o = 1;
    for (const l of n) {
      if (!l.enabled) continue;
      if (!E2(l)) {
        this._warnUnsupportedFilter(l);
        continue;
      }
      const d = l.getCanvasFilterString();
      if (d === null) {
        this._warnUnsupportedFilter(l);
        continue;
      }
      d && s.push(d);
    }
    if (s.length === 0 && o === 1) {
      t.skip = !0;
      return;
    }
    t.cssFilterString = s.join(" "), this._calculateFilterArea(e, t.bounds), t.useClip = !!e.filterEffect.filterArea;
    const r = this.renderer.canvasContext.activeContext, a = r.filter || "none";
    if (this._savedStates.push({ filter: a, alphaMultiplier: this._alphaMultiplier }), t.useClip && Number.isFinite(t.bounds.width) && Number.isFinite(t.bounds.height) && t.bounds.width > 0 && t.bounds.height > 0) {
      const l = this.renderer.canvasContext.activeResolution || 1;
      r.save(), r.setTransform(1, 0, 0, 1, 0, 0), r.beginPath(), r.rect(
        t.bounds.x * l,
        t.bounds.y * l,
        t.bounds.width * l,
        t.bounds.height * l
      ), r.clip();
    } else
      t.useClip = !1;
    t.cssFilterString && (r.filter = a !== "none" ? `${a} ${t.cssFilterString}` : t.cssFilterString);
  }
  /** Pop a filter from the stack. Called when exiting a filtered container. */
  pop() {
    const e = this._popFilterFrame();
    if (e.skip)
      return;
    const t = this._savedStates.pop();
    if (!t)
      return;
    const n = this.renderer.canvasContext.activeContext;
    e.useClip ? n.restore() : n.filter = t.filter, this._alphaMultiplier = t.alphaMultiplier;
  }
  /**
   * Applies supported filters to a texture and returns a new texture.
   * Unsupported filters are skipped with a warn-once message.
   * @param params - The parameters for applying filters.
   * @param params.texture
   * @param params.filters
   * @returns The resulting texture after filters are applied.
   */
  generateFilteredTexture({ texture: e, filters: t }) {
    var w, S;
    if (!(t != null && t.length) || t.every((M) => !M.enabled))
      return e;
    const n = [], s = 1;
    for (const M of t) {
      if (!M.enabled) continue;
      if (!E2(M)) {
        this._warnUnsupportedFilter(M);
        continue;
      }
      const _ = M.getCanvasFilterString();
      if (_ === null) {
        this._warnUnsupportedFilter(M);
        continue;
      }
      _ && n.push(_);
    }
    if (n.length === 0 && s === 1)
      return e;
    const o = _t.getCanvasSource(e);
    if (!o)
      return e;
    const r = e.frame, a = (S = (w = e.source._resolution) != null ? w : e.source.resolution) != null ? S : 1, l = r.width, d = r.height, c = Fl.getOptimalCanvasAndContext(l, d, a), { canvas: h, context: f } = c;
    f.setTransform(1, 0, 0, 1, 0, 0), f.clearRect(0, 0, h.width, h.height), n.length && (f.filter = n.join(" "));
    const p = r.x * a, y = r.y * a, v = l * a, x = d * a;
    return f.drawImage(
      o,
      p,
      y,
      v,
      x,
      0,
      0,
      v,
      x
    ), f.filter = "none", f.globalAlpha = 1, cZ(h, l, d, a);
  }
  /**
   * Calculate the filter area bounds.
   * @param instruction - Filter instruction
   * @param bounds - Bounds object to populate
   */
  _calculateFilterArea(e, t) {
    if (e.renderables ? NM(e.renderables, t) : e.filterEffect.filterArea ? (t.clear(), t.addRect(e.filterEffect.filterArea), t.applyMatrix(e.container.worldTransform)) : e.container.getFastGlobalBounds(!0, t), e.container) {
      const n = e.container.renderGroup || e.container.parentRenderGroup, s = n == null ? void 0 : n.cacheToLocalTransform;
      s && t.applyMatrix(s);
    }
  }
  _warnUnsupportedFilter(e) {
    var n;
    const t = ((n = e == null ? void 0 : e.constructor) == null ? void 0 : n.name) || "Filter";
    this._warnedFilterTypes.has(t) || (this._warnedFilterTypes.add(t), console.warn(
      `CanvasRenderer: filter "${t}" is not supported in Canvas2D and will be skipped.`
    ));
  }
  get alphaMultiplier() {
    return this._alphaMultiplier;
  }
  _pushFilterFrame() {
    let e = this._filterStack[this._filterStackIndex];
    return e || (e = this._filterStack[this._filterStackIndex] = new uZ()), this._filterStackIndex++, e;
  }
  _popFilterFrame() {
    return this._filterStackIndex <= 0 ? this._filterStack[0] : (this._filterStackIndex--, this._filterStack[this._filterStackIndex]);
  }
  /** Destroys the system */
  destroy() {
    this._filterStack = null, this._savedStates = null, this._warnedFilterTypes = null, this._alphaMultiplier = 1;
  }
}
UM.extension = {
  type: [Ie.CanvasSystem],
  name: "filter"
};
var hZ = `in vec2 aPosition;
out vec2 vTextureCoord;

uniform vec4 uInputSize;
uniform vec4 uOutputFrame;
uniform vec4 uOutputTexture;

vec4 filterVertexPosition( void )
{
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
    
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aPosition * (uOutputFrame.zw * uInputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`, pZ = `in vec2 vTextureCoord;
out vec4 finalColor;
uniform sampler2D uTexture;
void main() {
    finalColor = texture(uTexture, vTextureCoord);
}
`, R2 = `struct GlobalFilterUniforms {
  uInputSize: vec4<f32>,
  uInputPixel: vec4<f32>,
  uInputClamp: vec4<f32>,
  uOutputFrame: vec4<f32>,
  uGlobalFrame: vec4<f32>,
  uOutputTexture: vec4<f32>,
};

@group(0) @binding(0) var <uniform> gfu: GlobalFilterUniforms;
@group(0) @binding(1) var uTexture: texture_2d<f32>;
@group(0) @binding(2) var uSampler: sampler;

struct VSOutput {
  @builtin(position) position: vec4<f32>,
  @location(0) uv: vec2<f32>
};

fn filterVertexPosition(aPosition: vec2<f32>) -> vec4<f32>
{
    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;

    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0 * gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

fn filterTextureCoord(aPosition: vec2<f32>) -> vec2<f32>
{
    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);
}

@vertex
fn mainVertex(
  @location(0) aPosition: vec2<f32>,
) -> VSOutput {
  return VSOutput(
   filterVertexPosition(aPosition),
   filterTextureCoord(aPosition)
  );
}

@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>,
) -> @location(0) vec4<f32> {
    return textureSample(uTexture, uSampler, uv);
}
`;
class fZ extends YS {
  constructor() {
    const e = ba.from({
      vertex: { source: R2, entryPoint: "mainVertex" },
      fragment: { source: R2, entryPoint: "mainFragment" },
      name: "passthrough-filter"
    }), t = Xl.from({
      vertex: hZ,
      fragment: pZ,
      name: "passthrough-filter"
    });
    super({
      gpuProgram: e,
      glProgram: t
    });
  }
}
class GM {
  constructor(e) {
    this._renderer = e;
  }
  push(e, t, n) {
    this._renderer.renderPipes.batch.break(n), n.add({
      renderPipeId: "filter",
      canBundle: !1,
      action: "pushFilter",
      container: t,
      filterEffect: e
    });
  }
  pop(e, t, n) {
    this._renderer.renderPipes.batch.break(n), n.add({
      renderPipeId: "filter",
      action: "popFilter",
      canBundle: !1
    });
  }
  execute(e) {
    e.action === "pushFilter" ? this._renderer.filter.push(e) : e.action === "popFilter" && this._renderer.filter.pop();
  }
  destroy() {
    this._renderer = null;
  }
}
GM.extension = {
  type: [
    Ie.WebGLPipes,
    Ie.WebGPUPipes,
    Ie.CanvasPipes
  ],
  name: "filter"
};
const mZ = new fm({
  attributes: {
    aPosition: {
      buffer: new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]),
      format: "float32x2",
      stride: 8,
      offset: 0
    }
  },
  indexBuffer: new Uint32Array([0, 1, 2, 0, 2, 3])
});
class gZ {
  constructor() {
    this.skip = !1, this.inputTexture = null, this.backTexture = null, this.filters = null, this.bounds = new Gn(), this.container = null, this.blendRequired = !1, this.outputRenderSurface = null, this.firstEnabledIndex = -1, this.lastEnabledIndex = -1;
  }
}
class jM {
  constructor(e) {
    this._filterStackIndex = 0, this._filterStack = [], this._filterGlobalUniforms = new Ts({
      uInputSize: { value: new Float32Array(4), type: "vec4<f32>" },
      uInputPixel: { value: new Float32Array(4), type: "vec4<f32>" },
      uInputClamp: { value: new Float32Array(4), type: "vec4<f32>" },
      uOutputFrame: { value: new Float32Array(4), type: "vec4<f32>" },
      uGlobalFrame: { value: new Float32Array(4), type: "vec4<f32>" },
      uOutputTexture: { value: new Float32Array(4), type: "vec4<f32>" }
    }), this._globalFilterBindGroup = new qo({}), this.renderer = e;
  }
  /**
   * The back texture of the currently active filter. Requires the filter to have `blendRequired` set to true.
   * @readonly
   */
  get activeBackTexture() {
    var e;
    return (e = this._activeFilterData) == null ? void 0 : e.backTexture;
  }
  /**
   * Pushes a filter instruction onto the filter stack.
   * @param instruction - The instruction containing the filter effect and container.
   * @internal
   */
  push(e) {
    const t = this.renderer, n = e.filterEffect.filters, s = this._pushFilterData();
    s.skip = !1, s.filters = n, s.container = e.container, s.outputRenderSurface = t.renderTarget.renderSurface;
    const o = t.renderTarget.renderTarget.colorTexture.source, r = o.resolution, a = o.antialias;
    if (n.every((c) => !c.enabled)) {
      s.skip = !0;
      return;
    }
    const l = s.bounds;
    if (this._calculateFilterArea(e, l), this._calculateFilterBounds(s, t.renderTarget.rootViewPort, a, r, 1), s.skip)
      return;
    const d = this._getPreviousFilterData();
    this._setupFilterTextures(s, l, t, d);
  }
  /**
   * Applies filters to a texture.
   *
   * This method takes a texture and a list of filters, applies the filters to the texture,
   * and returns the resulting texture.
   * @param {object} params - The parameters for applying filters.
   * @param {Texture} params.texture - The texture to apply filters to.
   * @param {Filter[]} params.filters - The filters to apply.
   * @returns {Texture} The resulting texture after all filters have been applied.
   * @example
   *
   * ```ts
   * // Create a texture and a list of filters
   * const texture = new Texture(...);
   * const filters = [new BlurFilter(), new ColorMatrixFilter()];
   *
   * // Apply the filters to the texture
   * const resultTexture = renderer.filter.generateFilteredTexture({ texture, filters });
   *
   * // Use the resulting texture
   * sprite.texture = resultTexture;
   * ```
   *
   * Key Points:
   * 1. padding is not currently supported here - so clipping may occur with filters that use padding.
   * 2. If all filters are disabled or skipped, the original texture is returned.
   */
  generateFilteredTexture({ texture: e, filters: t }) {
    if (t.every((c) => !c.enabled))
      return e;
    const n = this._pushFilterData();
    this._activeFilterData = n, n.skip = !1, n.filters = t;
    const s = e.source, o = s.resolution, r = s.antialias, a = n.bounds;
    if (a.clear(), a.addRect(e.frame), this._calculateFilterBounds(n, a.rectangle, r, o, 0), n.skip)
      return this._popFilterData(), e;
    n.outputRenderSurface = Nn.getOptimalTexture({
      width: a.width,
      height: a.height,
      resolution: n.resolution,
      antialias: n.antialias
    }), n.backTexture = et.EMPTY, n.inputTexture = e, this.renderer.renderTarget.finishRenderPass(), this._applyFiltersToTexture(n, !0);
    const d = n.outputRenderSurface;
    return d.source.alphaMode = "premultiplied-alpha", this._popFilterData(), d;
  }
  /** @internal */
  pop() {
    const e = this.renderer, t = this._popFilterData();
    t.skip || (e.globalUniforms.pop(), e.renderTarget.finishRenderPass(), this._activeFilterData = t, this._applyFiltersToTexture(t, !1), t.blendRequired && Nn.returnTexture(t.backTexture), Nn.returnTexture(t.inputTexture));
  }
  /**
   * Copies the last render surface to a texture.
   * @param lastRenderSurface - The last render surface to copy from.
   * @param bounds - The bounds of the area to copy.
   * @param previousBounds - The previous bounds to use for offsetting the copy.
   */
  getBackTexture(e, t, n) {
    const s = e.colorTexture.source._resolution, o = Nn.getOptimalTexture({
      width: t.width,
      height: t.height,
      resolution: s
    });
    let r = t.minX, a = t.minY;
    n && (r -= n.minX, a -= n.minY), r = Math.floor(r * s), a = Math.floor(a * s);
    const l = Math.ceil(t.width * s), d = Math.ceil(t.height * s);
    return this.renderer.renderTarget.copyToTexture(
      e,
      o,
      { x: r, y: a },
      { width: l, height: d },
      { x: 0, y: 0 }
    ), o;
  }
  /**
   * Applies a filter to a texture.
   * @param filter - The filter to apply.
   * @param input - The input texture.
   * @param output - The output render surface.
   * @param clear - Whether to clear the output surface before applying the filter.
   */
  applyFilter(e, t, n, s) {
    const o = this.renderer, r = this._activeFilterData, l = r.outputRenderSurface === n, d = this._findClosestFilterData(), c = d ? d.inputTexture.source._resolution : o.renderTarget.rootRenderTarget.colorTexture.source._resolution;
    let h = 0, f = 0;
    l && d && (h = d.bounds.minX, f = d.bounds.minY), this._updateFilterUniforms(t, n, r, h, f, c, l, s);
    const p = e.enabled ? e : this._getPassthroughFilter();
    this._setupBindGroupsAndRender(p, t, o);
  }
  /**
   * Multiply _input normalized coordinates_ to this matrix to get _sprite texture normalized coordinates_.
   *
   * Use `outputMatrix * vTextureCoord` in the shader.
   * @param outputMatrix - The matrix to output to.
   * @param {Sprite} sprite - The sprite to map to.
   * @returns The mapped matrix.
   */
  calculateSpriteMatrix(e, t) {
    const n = this._activeFilterData, s = e.set(
      n.inputTexture._source.width,
      0,
      0,
      n.inputTexture._source.height,
      n.bounds.minX,
      n.bounds.minY
    ), o = t.worldTransform.copyTo(st.shared), r = t.renderGroup || t.parentRenderGroup;
    return r && r.cacheToLocalTransform && o.prepend(r.cacheToLocalTransform), o.invert(), s.prepend(o), s.scale(
      1 / t.texture.orig.width,
      1 / t.texture.orig.height
    ), s.translate(t.anchor.x, t.anchor.y), s;
  }
  destroy() {
    var e;
    (e = this._passthroughFilter) == null || e.destroy(!0), this._passthroughFilter = null;
  }
  _getPassthroughFilter() {
    var e;
    return (e = this._passthroughFilter) != null || (this._passthroughFilter = new fZ()), this._passthroughFilter;
  }
  /**
   * Sets up the bind groups and renders the filter.
   * @param filter - The filter to apply
   * @param input - The input texture
   * @param renderer - The renderer instance
   */
  _setupBindGroupsAndRender(e, t, n) {
    if (n.renderPipes.uniformBatch) {
      const s = n.renderPipes.uniformBatch.getUboResource(this._filterGlobalUniforms);
      this._globalFilterBindGroup.setResource(s, 0);
    } else
      this._globalFilterBindGroup.setResource(this._filterGlobalUniforms, 0);
    this._globalFilterBindGroup.setResource(t.source, 1), this._globalFilterBindGroup.setResource(t.source.style, 2), e.groups[0] = this._globalFilterBindGroup, n.encoder.draw({
      geometry: mZ,
      shader: e,
      state: e._state,
      topology: "triangle-list"
    }), n.type === rs.WEBGL && n.renderTarget.finishRenderPass();
  }
  /**
   * Sets up the filter textures including input texture and back texture if needed.
   * @param filterData - The filter data to update
   * @param bounds - The bounds for the texture
   * @param renderer - The renderer instance
   * @param previousFilterData - The previous filter data for back texture calculation
   */
  _setupFilterTextures(e, t, n, s) {
    if (e.backTexture = et.EMPTY, e.inputTexture = Nn.getOptimalTexture({
      width: t.width,
      height: t.height,
      resolution: e.resolution,
      antialias: e.antialias
    }), e.blendRequired) {
      n.renderTarget.finishRenderPass();
      const o = n.renderTarget.getRenderTarget(e.outputRenderSurface);
      e.backTexture = this.getBackTexture(o, t, s == null ? void 0 : s.bounds);
    }
    n.renderTarget.bind({ target: e.inputTexture, clear: !0 }), n.globalUniforms.push({
      offset: t
    });
  }
  /**
   * Updates the filter uniforms with the current filter state.
   * @param input - The input texture
   * @param output - The output render surface
   * @param filterData - The current filter data
   * @param offsetX - The X offset for positioning
   * @param offsetY - The Y offset for positioning
   * @param resolution - The current resolution
   * @param isFinalTarget - Whether this is the final render target
   * @param clear - Whether to clear the output surface
   */
  _updateFilterUniforms(e, t, n, s, o, r, a, l) {
    const d = this._filterGlobalUniforms.uniforms, c = d.uOutputFrame, h = d.uInputSize, f = d.uInputPixel, p = d.uInputClamp, y = d.uGlobalFrame, v = d.uOutputTexture;
    a ? (c[0] = n.bounds.minX - s, c[1] = n.bounds.minY - o) : (c[0] = 0, c[1] = 0), c[2] = e.frame.width, c[3] = e.frame.height, h[0] = e.source.width, h[1] = e.source.height, h[2] = 1 / h[0], h[3] = 1 / h[1], f[0] = e.source.pixelWidth, f[1] = e.source.pixelHeight, f[2] = 1 / f[0], f[3] = 1 / f[1], p[0] = 0.5 * f[2], p[1] = 0.5 * f[3], p[2] = e.frame.width * h[2] - 0.5 * f[2], p[3] = e.frame.height * h[3] - 0.5 * f[3];
    const x = this.renderer.renderTarget.rootRenderTarget.colorTexture;
    y[0] = s * r, y[1] = o * r, y[2] = x.source.width * r, y[3] = x.source.height * r, t instanceof et && (t.source.resource = null);
    const w = this.renderer.renderTarget.getRenderTarget(t);
    this.renderer.renderTarget.bind({ target: t, clear: !!l }), t instanceof et ? (v[0] = t.frame.width, v[1] = t.frame.height) : (v[0] = w.width, v[1] = w.height), v[2] = w.isRoot ? -1 : 1, this._filterGlobalUniforms.update();
  }
  /**
   * Finds the non-skipped entry closest to the top of the filter stack.
   *
   * `pop()` removes its entry before it applies the filters, so the result is the enclosing filter's entry.
   * `generateFilteredTexture()` applies the filters while its entry is still on the stack, so the result is that entry.
   * @returns The entry, or null if there is none
   */
  _findClosestFilterData() {
    for (let e = this._filterStackIndex - 1; e >= 0; e--) {
      const t = this._filterStack[e];
      if (!t.skip) return t;
    }
    return null;
  }
  /**
   * Calculates the filter area bounds based on the instruction type.
   * @param instruction - The filter instruction
   * @param bounds - The bounds object to populate
   */
  _calculateFilterArea(e, t) {
    if (e.renderables ? NM(e.renderables, t) : e.filterEffect.filterArea ? (t.clear(), t.addRect(e.filterEffect.filterArea), t.applyMatrix(e.container.worldTransform)) : e.container.getFastGlobalBounds(!0, t), e.container) {
      const s = (e.container.renderGroup || e.container.parentRenderGroup).cacheToLocalTransform;
      s && t.applyMatrix(s);
    }
  }
  _applyFiltersToTexture(e, t) {
    const n = e.inputTexture, s = e.bounds, o = e.filters, r = e.firstEnabledIndex, a = e.lastEnabledIndex;
    if (this._globalFilterBindGroup.setResource(n.source.style, 2), this._globalFilterBindGroup.setResource(e.backTexture.source, 3), r === a)
      o[r].apply(this, n, e.outputRenderSurface, t);
    else {
      let l = e.inputTexture;
      const d = Nn.getOptimalTexture({
        width: s.width,
        height: s.height,
        resolution: l.source._resolution
      });
      let c = d;
      for (let h = r; h < a; h++) {
        const f = o[h];
        if (!f.enabled) continue;
        f.apply(this, l, c, !0);
        const p = l;
        l = c, c = p;
      }
      o[a].apply(this, l, e.outputRenderSurface, t), Nn.returnTexture(d);
    }
  }
  _calculateFilterBounds(e, t, n, s, o) {
    var w, S;
    const r = this.renderer, a = e.bounds, l = e.filters;
    let d = 1 / 0, c = 0, h = !0, f = !1, p = !1, y = !0, v = -1, x = -1;
    for (let M = 0; M < l.length; M++) {
      const _ = l[M];
      if (!_.enabled) continue;
      if (v === -1 && (v = M), x = M, d = Math.min(d, _.resolution === "inherit" ? s : _.resolution), c += _.padding, _.antialias === "off" ? h = !1 : _.antialias === "inherit" && h && (h = n), _.clipToViewport || (y = !1), !!!(_.compatibleRenderers & r.type)) {
        p = !1;
        break;
      }
      if (_.blendRequired && !((S = (w = r.backBuffer) == null ? void 0 : w.useBackBuffer) == null || S)) {
        dt("Blend filter requires backBuffer on WebGL renderer to be enabled. Set `useBackBuffer: true` in the renderer options."), p = !1;
        break;
      }
      p = !0, f || (f = _.blendRequired);
    }
    if (!p) {
      e.skip = !0;
      return;
    }
    if (y && a.fitBounds(0, t.width / s, 0, t.height / s), a.scale(d).ceil().scale(1 / d).pad((c | 0) * o), !a.isPositive) {
      e.skip = !0;
      return;
    }
    e.antialias = h, e.resolution = d, e.blendRequired = f, e.firstEnabledIndex = v, e.lastEnabledIndex = x;
  }
  _popFilterData() {
    return this._filterStackIndex--, this._filterStack[this._filterStackIndex];
  }
  /**
   * Finds the closest non-skipped entry that encloses the filter being pushed.
   *
   * `push()` has already added that filter's own entry, so the search starts one entry below it.
   * @returns The entry, or null if there is none
   */
  _getPreviousFilterData() {
    for (let e = this._filterStackIndex - 2; e >= 0; e--) {
      const t = this._filterStack[e];
      if (!t.skip) return t;
    }
    return null;
  }
  _pushFilterData() {
    let e = this._filterStack[this._filterStackIndex];
    return e || (e = this._filterStack[this._filterStackIndex] = new gZ()), this._filterStackIndex++, e;
  }
}
jM.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem
  ],
  name: "filter"
};
var bZ = `in vec2 vMaskCoord;
in vec2 vTextureCoord;

uniform sampler2D uTexture;
uniform sampler2D uMaskTexture;

uniform float uAlpha;
uniform vec4 uMaskClamp;
uniform float uInverse;
uniform float uChannel;

out vec4 finalColor;

void main(void)
{
    float clip = step(3.5,
        step(uMaskClamp.x, vMaskCoord.x) +
        step(uMaskClamp.y, vMaskCoord.y) +
        step(vMaskCoord.x, uMaskClamp.z) +
        step(vMaskCoord.y, uMaskClamp.w));

    // TODO look into why this is needed
    float npmAlpha = uAlpha;
    vec4 original = texture(uTexture, vTextureCoord);
    vec4 masky = texture(uMaskTexture, vMaskCoord);

    float a;
    if (uChannel == 1.0) {
        a = masky.a * npmAlpha * clip;
    } else {
        float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);
        a = alphaMul * masky.r * npmAlpha * clip;
    }

    if (uInverse == 1.0) {
        a = 1.0 - a;
    }

    finalColor = original * a;
}
`, vZ = `in vec2 aPosition;

out vec2 vTextureCoord;
out vec2 vMaskCoord;


uniform vec4 uInputSize;
uniform vec4 uOutputFrame;
uniform vec4 uOutputTexture;
uniform mat3 uFilterMatrix;

vec4 filterVertexPosition(  vec2 aPosition )
{
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
       
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

vec2 filterTextureCoord(  vec2 aPosition )
{
    return aPosition * (uOutputFrame.zw * uInputSize.zw);
}

vec2 getFilterCoord( vec2 aPosition )
{
    return  ( uFilterMatrix * vec3( filterTextureCoord(aPosition), 1.0)  ).xy;
}   

void main(void)
{
    gl_Position = filterVertexPosition(aPosition);
    vTextureCoord = filterTextureCoord(aPosition);
    vMaskCoord = getFilterCoord(aPosition);
}
`, z2 = `struct GlobalFilterUniforms {
  uInputSize:vec4<f32>,
  uInputPixel:vec4<f32>,
  uInputClamp:vec4<f32>,
  uOutputFrame:vec4<f32>,
  uGlobalFrame:vec4<f32>,
  uOutputTexture:vec4<f32>,
};

struct MaskUniforms {
  uFilterMatrix:mat3x3<f32>,
  uMaskClamp:vec4<f32>,
  uAlpha:f32,
  uInverse:f32,
  uChannel:f32,
};

@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;
@group(0) @binding(1) var uTexture: texture_2d<f32>;
@group(0) @binding(2) var uSampler : sampler;

@group(1) @binding(0) var<uniform> filterUniforms : MaskUniforms;
@group(1) @binding(1) var uMaskTexture: texture_2d<f32>;

struct VSOutput {
    @builtin(position) position: vec4<f32>,
    @location(0) uv : vec2<f32>,
    @location(1) filterUv : vec2<f32>,
};

fn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>
{
    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;

    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

fn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);
}

fn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);
}

fn getFilterCoord(aPosition:vec2<f32> ) -> vec2<f32>
{
  return ( filterUniforms.uFilterMatrix * vec3( filterTextureCoord(aPosition), 1.0)  ).xy;
}

fn getSize() -> vec2<f32>
{
  return gfu.uGlobalFrame.zw;
}

@vertex
fn mainVertex(
  @location(0) aPosition : vec2<f32>,
) -> VSOutput {
  return VSOutput(
   filterVertexPosition(aPosition),
   filterTextureCoord(aPosition),
   getFilterCoord(aPosition)
  );
}

@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>,
  @location(1) filterUv: vec2<f32>,
  @builtin(position) position: vec4<f32>
) -> @location(0) vec4<f32> {

    var maskClamp = filterUniforms.uMaskClamp;
    var uAlpha = filterUniforms.uAlpha;

    var clip = step(3.5,
      step(maskClamp.x, filterUv.x) +
      step(maskClamp.y, filterUv.y) +
      step(filterUv.x, maskClamp.z) +
      step(filterUv.y, maskClamp.w));

    var mask = textureSample(uMaskTexture, uSampler, filterUv);
    var source = textureSample(uTexture, uSampler, uv);

    var a: f32;
    if (filterUniforms.uChannel == 1.0) {
        a = mask.a * uAlpha * clip;
    } else {
        var alphaMul = 1.0 - uAlpha * (1.0 - mask.a);
        a = alphaMul * mask.r * uAlpha * clip;
    }

    if (filterUniforms.uInverse == 1.0) {
        a = 1.0 - a;
    }

    return source * a;
}
`;
class yZ extends YS {
  constructor(e) {
    const { sprite: t, ...n } = e, s = new gS(t.texture), o = new Ts({
      uFilterMatrix: { value: new st(), type: "mat3x3<f32>" },
      uMaskClamp: { value: s.uClampFrame, type: "vec4<f32>" },
      uAlpha: { value: 1, type: "f32" },
      uInverse: { value: e.inverse ? 1 : 0, type: "f32" },
      uChannel: { value: e.channel === "alpha" ? 1 : 0, type: "f32" }
    }), r = ba.from({
      vertex: {
        source: z2,
        entryPoint: "mainVertex"
      },
      fragment: {
        source: z2,
        entryPoint: "mainFragment"
      }
    }), a = Xl.from({
      vertex: vZ,
      fragment: bZ,
      name: "mask-filter"
    });
    super({
      ...n,
      gpuProgram: r,
      glProgram: a,
      clipToViewport: !1,
      resources: {
        filterUniforms: o,
        uMaskTexture: t.texture.source
      }
    }), this.sprite = t, this._textureMatrix = s;
  }
  /**
   * Rebinds the filter to a new mask sprite, moving the texture-matrix `update`
   * listener and the bind group's `change` subscription over to the new sprite's
   * texture. `apply` refreshes the same bindings on every use — this method exists
   * to release the previous sprite's texture immediately, without waiting for
   * (or requiring) another `apply`.
   * @param sprite - the sprite to mask with from now on.
   */
  setSprite(e) {
    this.sprite = e;
    const t = this._getSafeTexture();
    this._textureMatrix.texture = t, this.resources.uMaskTexture = t.source;
  }
  set inverse(e) {
    this.resources.filterUniforms.uniforms.uInverse = e ? 1 : 0;
  }
  get inverse() {
    return this.resources.filterUniforms.uniforms.uInverse === 1;
  }
  set channel(e) {
    this.resources.filterUniforms.uniforms.uChannel = e === "alpha" ? 1 : 0;
  }
  get channel() {
    return this.resources.filterUniforms.uniforms.uChannel === 1 ? "alpha" : "red";
  }
  apply(e, t, n, s) {
    const o = this._getSafeTexture();
    this._textureMatrix.texture = o, e.calculateSpriteMatrix(
      this.resources.filterUniforms.uniforms.uFilterMatrix,
      this.sprite
    ).prepend(this._textureMatrix.mapCoord), this.resources.uMaskTexture = o.source, e.applyFilter(this, t, n, s);
  }
  /**
   * The sprite's texture, or `Texture.EMPTY` when that texture has been destroyed —
   * a destroyed texture has no source left to sample, so the mask degrades to empty
   * rather than crashing the render.
   */
  _getSafeTexture() {
    const e = this.sprite.texture;
    return e.destroyed || !e.source || e.source.destroyed ? (dt("[MaskFilter] The mask texture was destroyed while the mask is still in use. Remove the mask before destroying its texture."), et.EMPTY) : e;
  }
  destroy(e = !1) {
    this._textureMatrix.destroy(), super.destroy(e);
  }
}
class xZ {
  constructor() {
    this.isBatchable = !1;
  }
  /**
   * Reset cached canvas data.
   * @advanced
   */
  reset() {
    this.isBatchable = !1, this.context = null, this.graphicsData && (this.graphicsData.destroy(), this.graphicsData = null);
  }
  /**
   * Destroy the cached data.
   * @advanced
   */
  destroy() {
    this.reset();
  }
}
class wZ {
  constructor() {
    this.instructions = new X1();
  }
  /**
   * Initialize render data.
   * @advanced
   */
  init() {
    this.instructions.reset();
  }
  /**
   * Destroy render data.
   * @advanced
   */
  destroy() {
    this.instructions.destroy(), this.instructions = null;
  }
}
const gy = class d0 {
  constructor(e) {
    this._renderer = e, this._managedContexts = new Cs({ renderer: e, type: "resource", name: "graphicsContext" });
  }
  /**
   * Runner init called, update the default options
   * @ignore
   */
  init(e) {
    var t;
    d0.defaultOptions.bezierSmoothness = (t = e == null ? void 0 : e.bezierSmoothness) != null ? t : d0.defaultOptions.bezierSmoothness;
  }
  /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */
  getContextRenderData(e) {
    return this.getGpuContext(e).graphicsData || this._initContextRenderData(e);
  }
  /**
   * Updates the GPU context for a given GraphicsContext.
   * @param context - The GraphicsContext to update.
   * @returns The updated CanvasGraphicsContext.
   * @internal
   */
  updateGpuContext(e) {
    const t = e._gpuData, n = !!t[this._renderer.uid], s = t[this._renderer.uid] || this._initContext(e);
    return (e.dirty || !n) && (n && s.reset(), s.isBatchable = !1, e.dirty = !1), s;
  }
  /**
   * Returns the CanvasGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the CanvasGraphicsContext for.
   * @returns The CanvasGraphicsContext for the given GraphicsContext.
   * @internal
   */
  getGpuContext(e) {
    return e._gpuData[this._renderer.uid] || this._initContext(e);
  }
  _initContextRenderData(e) {
    const t = new wZ(), n = this.getGpuContext(e);
    return n.graphicsData = t, t.init(), t;
  }
  _initContext(e) {
    const t = new xZ();
    return t.context = e, e._gpuData[this._renderer.uid] = t, this._managedContexts.add(e), t;
  }
  destroy() {
    this._managedContexts.destroy(), this._renderer = null;
  }
};
gy.extension = {
  type: [
    Ie.CanvasSystem
  ],
  name: "graphicsContext"
};
gy.defaultOptions = {
  /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */
  bezierSmoothness: 0.5
};
let kZ = gy;
class HM {
  constructor(e, t) {
    this.state = co.for2d(), this.renderer = e, this._adaptor = t, this.renderer.runners.contextChange.add(this), this._managedGraphics = new Cs({ renderer: e, type: "renderable", priority: -1, name: "graphics" });
  }
  contextChange() {
    this._adaptor.contextChange(this.renderer);
  }
  validateRenderable(e) {
    return !1;
  }
  addRenderable(e, t) {
    this._managedGraphics.add(e), this.renderer.renderPipes.batch.break(t), t.add(e);
  }
  updateRenderable(e) {
  }
  execute(e) {
    e.isRenderable && this._adaptor.execute(this, e);
  }
  destroy() {
    this._managedGraphics.destroy(), this.renderer = null, this._adaptor.destroy(), this._adaptor = null;
  }
}
HM.extension = {
  type: [
    Ie.CanvasPipes
  ],
  name: "graphics"
};
function VM(i, e, t) {
  const n = (i >> 24 & 255) / 255;
  e[t++] = (i & 255) / 255 * n, e[t++] = (i >> 8 & 255) / 255 * n, e[t++] = (i >> 16 & 255) / 255 * n, e[t++] = n;
}
class _Z {
  constructor() {
    this.batches = [], this.batched = !1;
  }
  destroy() {
    this.batches.forEach((e) => {
      $n.return(e);
    }), this.batches.length = 0;
  }
}
class WM {
  constructor(e, t) {
    this.state = co.for2d(), this.renderer = e, this._adaptor = t, this.renderer.runners.contextChange.add(this), this._managedGraphics = new Cs({ renderer: e, type: "renderable", priority: -1, name: "graphics" });
  }
  contextChange() {
    this._adaptor.contextChange(this.renderer);
  }
  validateRenderable(e) {
    const t = e.context, n = !!e._gpuData, o = this.renderer.graphicsContext.updateGpuContext(t);
    return !!(o.isBatchable || n !== o.isBatchable);
  }
  addRenderable(e, t) {
    const s = this.renderer.graphicsContext.updateGpuContext(e.context);
    (e.didViewUpdate || !e._gpuData[this.renderer.uid]) && this._rebuild(e), s.isBatchable ? this._addToBatcher(e, t) : (this.renderer.renderPipes.batch.break(t), t.add(e));
  }
  updateRenderable(e) {
    const n = this._getGpuDataForRenderable(e).batches;
    for (let s = 0; s < n.length; s++) {
      const o = n[s];
      o._batcher.updateElement(o);
    }
  }
  execute(e) {
    if (!e.isRenderable) return;
    const t = this.renderer, n = e.context;
    if (!t.graphicsContext.getGpuContext(n).batches.length)
      return;
    const o = n.customShader || this._adaptor.shader;
    this.state.blendMode = e.groupBlendMode;
    const r = o.resources.localUniforms.uniforms;
    r.uTransformMatrix = e.groupTransform, r.uRound = t._roundPixels | e._roundPixels, VM(
      e.groupColorAlpha,
      r.uColor,
      0
    ), this._adaptor.execute(this, e);
  }
  _rebuild(e) {
    const t = this._getGpuDataForRenderable(e), s = this.renderer.graphicsContext.updateGpuContext(e.context);
    t.destroy(), s.isBatchable && this._updateBatchesForRenderable(e, t);
  }
  _addToBatcher(e, t) {
    const n = this.renderer.renderPipes.batch, s = this._getGpuDataForRenderable(e).batches;
    for (let o = 0; o < s.length; o++) {
      const r = s[o];
      n.addToBatch(r, t);
    }
  }
  _getGpuDataForRenderable(e) {
    return e._gpuData[this.renderer.uid] || this._initGpuDataForRenderable(e);
  }
  _initGpuDataForRenderable(e) {
    const t = new _Z();
    return e._gpuData[this.renderer.uid] = t, this._managedGraphics.add(e), t;
  }
  _updateBatchesForRenderable(e, t) {
    const n = e.context, o = this.renderer.graphicsContext.getGpuContext(n), r = this.renderer._roundPixels | e._roundPixels;
    t.batches = o.batches.map((a) => {
      const l = $n.get(dy);
      return a.copyTo(l), l.renderable = e, l.roundPixels = r, l;
    });
  }
  destroy() {
    this._managedGraphics.destroy(), this.renderer = null, this._adaptor.destroy(), this._adaptor = null, this.state = null;
  }
}
WM.extension = {
  type: [
    Ie.WebGLPipes,
    Ie.WebGPUPipes
  ],
  name: "graphics"
};
ht.add(HM);
ht.add(WM);
ht.add(kZ);
ht.add(py);
class Ko extends Z1 {
  /**
   * Creates a new Graphics object.
   * @param options - Options for the Graphics.
   */
  constructor(e) {
    e instanceof yd && (e = { context: e });
    const { context: t, roundPixels: n, ...s } = e || {};
    super({
      label: "Graphics",
      ...s
    }), this.renderPipeId = "graphics", t ? this.context = t : (this.context = this._ownedContext = new yd(), this.context.autoGarbageCollect = this.autoGarbageCollect), this.didViewUpdate = !0, this.allowChildren = !1, this.roundPixels = n != null ? n : !1;
  }
  set context(e) {
    e !== this._context && (this._context && (this._context.off("update", this.onViewUpdate, this), this._context.off("unload", this.unload, this)), this._context = e, this._context.on("update", this.onViewUpdate, this), this._context.on("unload", this.unload, this), this.onViewUpdate());
  }
  /**
   * The underlying graphics context used for drawing operations.
   * Controls how shapes and paths are rendered.
   * @example
   * ```ts
   * // Create a shared context
   * const sharedContext = new GraphicsContext();
   *
   * // Create graphics objects sharing the same context
   * const graphics1 = new Graphics();
   * const graphics2 = new Graphics();
   *
   * // Assign shared context
   * graphics1.context = sharedContext;
   * graphics2.context = sharedContext;
   *
   * // Both graphics will show the same shapes
   * sharedContext
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   * ```
   * @see {@link GraphicsContext} For drawing operations
   * @see {@link GraphicsOptions} For context configuration
   */
  get context() {
    return this._context;
  }
  /**
   * The local bounds of the graphics object.
   * Returns the boundaries after all graphical operations but before any transforms.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Get bounds information
   * const bounds = graphics.bounds;
   * console.log(bounds.width);  // 100
   * console.log(bounds.height); // 100
   * ```
   * @readonly
   * @see {@link Bounds} For bounds operations
   * @see {@link Container#getBounds} For transformed bounds
   */
  get bounds() {
    return this._context.bounds;
  }
  /**
   * Graphics objects do not need to update their bounds as the context handles this.
   * @private
   */
  updateBounds() {
  }
  /**
   * Checks if the object contains the given point.
   * Returns true if the point lies within the Graphics object's rendered area.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Check point intersection
   * if (graphics.containsPoint({ x: 50, y: 50 })) {
   *     console.log('Point is inside rectangle!');
   * }
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is inside the Graphics object
   * @see {@link Graphics#bounds} For bounding box checks
   * @see {@link PointData} For point data structure
   */
  containsPoint(e) {
    return this._context.containsPoint(e);
  }
  /**
   * Destroys this graphics renderable and optionally its context.
   * @param options - Options parameter. A boolean will act as if all options
   *
   * If the context was created by this graphics and `destroy(false)` or `destroy()` is called
   * then the context will still be destroyed.
   *
   * If you want to explicitly not destroy this context that this graphics created,
   * then you should pass destroy({ context: false })
   *
   * If the context was passed in as an argument to the constructor then it will not be destroyed
   * @example
   * ```ts
   * // Destroy the graphics and its context
   * graphics.destroy();
   * graphics.destroy(true);
   * graphics.destroy({ context: true, texture: true, textureSource: true });
   * ```
   */
  destroy(e) {
    var t, n;
    this._ownedContext && !e ? this._ownedContext.destroy(e) : (e === !0 || (e == null ? void 0 : e.context) === !0) && this._context.destroy(e), (t = this._context) == null || t.off("update", this.onViewUpdate, this), (n = this._context) == null || n.off("unload", this.unload, this), this._ownedContext = null, this._context = null, super.destroy(e);
  }
  /**
   * @param now - The current time in milliseconds.
   * @internal
   */
  _onTouch(e) {
    this._gcLastUsed = e, this._context._gcLastUsed = e;
  }
  _callContextMethod(e, t) {
    return this.context[e](...t), this;
  }
  // --------------------------------------- GraphicsContext methods ---------------------------------------
  /**
   * Sets the current fill style of the graphics context.
   * The fill style can be a color, gradient, pattern, or a complex style object.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics
   *     .setFillStyle({ color: 0xff0000 }) // Red fill
   *     .rect(0, 0, 100, 100)
   *     .fill();
   *
   * // Gradient fill
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setFillStyle(gradient)
   *     .circle(100, 100, 50)
   *     .fill();
   *
   * // Pattern fill
   * const pattern = new FillPattern(texture);
   * graphics
   *     .setFillStyle({
   *         fill: pattern,
   *         alpha: 0.5
   *     })
   *     .rect(0, 0, 200, 200)
   *     .fill();
   * ```
   * @param {FillInput} args - The fill style to apply
   * @returns The Graphics instance for chaining
   * @see {@link FillStyle} For fill style options
   * @see {@link FillGradient} For gradient fills
   * @see {@link FillPattern} For pattern fills
   */
  setFillStyle(...e) {
    return this._callContextMethod("setFillStyle", e);
  }
  /**
   * Sets the current stroke style of the graphics context.
   * Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color stroke
   * graphics
   *     .setStrokeStyle({
   *         width: 2,
   *         color: 0x000000
   *     })
   *     .rect(0, 0, 100, 100)
   *     .stroke();
   *
   * // Complex stroke style
   * graphics
   *     .setStrokeStyle({
   *         width: 4,
   *         color: 0xff0000,
   *         alpha: 0.5,
   *         join: 'round',
   *         cap: 'round',
   *         alignment: 0.5
   *     })
   *     .circle(100, 100, 50)
   *     .stroke();
   *
   * // Gradient stroke
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setStrokeStyle({
   *         width: 10,
   *         fill: gradient
   *     })
   *     .poly([0,0, 100,50, 0,100])
   *     .stroke();
   * ```
   * @param {StrokeInput} args - The stroke style to apply
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link FillPattern} For pattern strokes
   */
  setStrokeStyle(...e) {
    return this._callContextMethod("setStrokeStyle", e);
  }
  fill(...e) {
    return this._callContextMethod("fill", e);
  }
  /**
   * Strokes the current path with the current stroke style or specified style.
   * Outlines the shape using the stroke settings.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Stroke with direct color
   * graphics
   *     .circle(50, 50, 25)
   *     .stroke({
   *         width: 2,
   *         color: 0xff0000
   *     }); // 2px red stroke
   *
   * // Fill with texture
   * graphics
   *    .rect(0, 0, 100, 100)
   *    .stroke(myTexture); // Fill with texture
   *
   * // Stroke with gradient
   * const gradient = new FillGradient({
   *     end: { x: 1, y: 0 },
   *     colorStops: [
   *         { offset: 0, color: 0xff0000 },
   *         { offset: 0.5, color: 0x00ff00 },
   *         { offset: 1, color: 0x0000ff },
   *     ],
   * });
   *
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .stroke({
   *         width: 4,
   *         fill: gradient,
   *         alignment: 0.5,
   *         join: 'round'
   *     });
   * ```
   * @param {StrokeStyle} args - Optional stroke style to apply. Can be:
   * - A stroke style object with width, color, etc.
   * - A gradient
   * - A pattern
   * If omitted, uses current stroke style.
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link setStrokeStyle} For setting default stroke style
   */
  stroke(...e) {
    return this._callContextMethod("stroke", e);
  }
  texture(...e) {
    return this._callContextMethod("texture", e);
  }
  /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @example
   * ```ts
   * const graphics = new Graphics();
   * graphics
   *     .circle(150, 150, 50)
   *     .fill({ color: 0x00ff00 })
   *     .beginPath() // Starts a new path
   *     .circle(250, 150, 50)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for chaining
   * @see {@link Graphics#moveTo} For starting a new subpath
   * @see {@link Graphics#closePath} For closing the current path
   */
  beginPath() {
    return this._callContextMethod("beginPath", []);
  }
  /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path.
   *
   * If a hole is not completely in a shape, it will fail to cut correctly.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw outer circle
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *     .circle(100, 100, 25) // Inner circle
   *     .cut() // Cuts out the inner circle from the outer circle
   * ```
   */
  cut() {
    return this._callContextMethod("cut", []);
  }
  arc(...e) {
    return this._callContextMethod("arc", e);
  }
  arcTo(...e) {
    return this._callContextMethod("arcTo", e);
  }
  arcToSvg(...e) {
    return this._callContextMethod("arcToSvg", e);
  }
  bezierCurveTo(...e) {
    return this._callContextMethod("bezierCurveTo", e);
  }
  /**
   * Closes the current path by drawing a straight line back to the start point.
   *
   * This is useful for completing shapes and ensuring they are properly closed for fills.
   * @example
   * ```ts
   * // Create a triangle with closed path
   * const graphics = new Graphics();
   * graphics
   *     .moveTo(50, 50)
   *     .lineTo(100, 100)
   *     .lineTo(0, 100)
   *     .closePath()
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path
   * @see {@link Graphics#fill} For filling closed paths
   * @see {@link Graphics#stroke} For stroking paths
   */
  closePath() {
    return this._callContextMethod("closePath", []);
  }
  ellipse(...e) {
    return this._callContextMethod("ellipse", e);
  }
  circle(...e) {
    return this._callContextMethod("circle", e);
  }
  path(...e) {
    return this._callContextMethod("path", e);
  }
  lineTo(...e) {
    return this._callContextMethod("lineTo", e);
  }
  moveTo(...e) {
    return this._callContextMethod("moveTo", e);
  }
  quadraticCurveTo(...e) {
    return this._callContextMethod("quadraticCurveTo", e);
  }
  rect(...e) {
    return this._callContextMethod("rect", e);
  }
  roundRect(...e) {
    return this._callContextMethod("roundRect", e);
  }
  poly(...e) {
    return this._callContextMethod("poly", e);
  }
  regularPoly(...e) {
    return this._callContextMethod("regularPoly", e);
  }
  roundPoly(...e) {
    return this._callContextMethod("roundPoly", e);
  }
  roundShape(...e) {
    return this._callContextMethod("roundShape", e);
  }
  filletRect(...e) {
    return this._callContextMethod("filletRect", e);
  }
  chamferRect(...e) {
    return this._callContextMethod("chamferRect", e);
  }
  star(...e) {
    return this._callContextMethod("star", e);
  }
  svg(...e) {
    return this._callContextMethod("svg", e);
  }
  restore(...e) {
    return this._callContextMethod("restore", e);
  }
  /**
   * Saves the current graphics state onto a stack. The state includes:
   * - Current transformation matrix
   * - Current fill style
   * - Current stroke style
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Save state before complex operations
   * graphics.save();
   *
   * // Create transformed and styled shape
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4)
   *     .setFillStyle({
   *         color: 0xff0000,
   *         alpha: 0.5
   *     })
   *     .rect(-25, -25, 50, 50)
   *     .fill();
   *
   * // Restore to original state
   * graphics.restore();
   *
   * // Continue drawing with previous state
   * graphics
   *     .circle(50, 50, 25)
   *     .fill();
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#restore} For restoring the saved state
   * @see {@link Graphics#setTransform} For setting transformations
   */
  save() {
    return this._callContextMethod("save", []);
  }
  /**
   * Returns the current transformation matrix of the graphics context.
   * This matrix represents all accumulated transformations including translate, scale, and rotate.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply some transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4);
   *
   * // Get the current transform matrix
   * const matrix = graphics.getTransform();
   * console.log(matrix.tx, matrix.ty); // 100, 100
   *
   * // Use the matrix for other operations
   * graphics
   *     .setTransform(matrix)
   *     .circle(0, 0, 50)
   *     .fill({ color: 0xff0000 });
   * ```
   * @returns The current transformation matrix.
   * @see {@link Graphics#setTransform} For setting the transform matrix
   * @see {@link Matrix} For matrix operations
   */
  getTransform() {
    return this.context.getTransform();
  }
  /**
   * Resets the current transformation matrix to the identity matrix, effectively removing
   * any transformations (rotation, scaling, translation) previously applied.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .scaleTransform(2, 2)
   *     .circle(0, 0, 25)
   *     .fill({ color: 0xff0000 });
   * // Reset transform to default state
   * graphics
   *     .resetTransform()
   *     .circle(50, 50, 25) // Will draw at actual coordinates
   *     .fill({ color: 0x00ff00 });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#getTransform} For getting the current transform
   * @see {@link Graphics#setTransform} For setting a specific transform
   * @see {@link Graphics#save} For saving the current transform state
   * @see {@link Graphics#restore} For restoring a previous transform state
   */
  resetTransform() {
    return this._callContextMethod("resetTransform", []);
  }
  rotateTransform(...e) {
    return this._callContextMethod("rotate", e);
  }
  scaleTransform(...e) {
    return this._callContextMethod("scale", e);
  }
  setTransform(...e) {
    return this._callContextMethod("setTransform", e);
  }
  transform(...e) {
    return this._callContextMethod("transform", e);
  }
  translateTransform(...e) {
    return this._callContextMethod("translate", e);
  }
  /**
   * Clears all drawing commands from the graphics context, effectively resetting it.
   * This includes clearing the current path, fill style, stroke style, and transformations.
   *
   * > [!NOTE] Graphics objects are not designed to be continuously cleared and redrawn.
   * > Instead, they are intended to be used for static or semi-static graphics that
   * > can be redrawn as needed. Frequent clearing and redrawing may lead to performance issues.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw some shapes
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 })
   *     .rect(200, 100, 100, 50)
   *     .fill({ color: 0x00ff00 });
   *
   * // Clear all graphics
   * graphics.clear();
   *
   * // Start fresh with new shapes
   * graphics
   *     .circle(150, 150, 30)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path without clearing styles
   * @see {@link Graphics#save} For saving the current state
   * @see {@link Graphics#restore} For restoring a previous state
   */
  clear() {
    return this._callContextMethod("clear", []);
  }
  /**
   * Gets or sets the current fill style for the graphics context. The fill style determines
   * how shapes are filled when using the fill() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics.fillStyle = {
   *     color: 0xff0000,  // Red
   *     alpha: 1
   * };
   *
   * // Using gradients
   * const gradient = new FillGradient({
   *     end: { x: 0, y: 1 }, // Vertical gradient
   *     stops: [
   *         { offset: 0, color: 0xff0000, alpha: 1 }, // Start color
   *         { offset: 1, color: 0x0000ff, alpha: 1 }  // End color
   *     ]
   * });
   *
   * graphics.fillStyle = {
   *     fill: gradient,
   *     alpha: 0.8
   * };
   *
   * // Using patterns
   * graphics.fillStyle = {
   *     texture: myTexture,
   *     alpha: 1,
   *     matrix: new Matrix()
   *         .scale(0.5, 0.5)
   *         .rotate(Math.PI / 4)
   * };
   * ```
   * @type {ConvertedFillStyle}
   * @see {@link FillStyle} For all available fill style options
   * @see {@link FillGradient} For creating gradient fills
   * @see {@link Graphics#fill} For applying the fill to paths
   */
  get fillStyle() {
    return this._context.fillStyle;
  }
  set fillStyle(e) {
    this._context.fillStyle = e;
  }
  /**
   * Gets or sets the current stroke style for the graphics context. The stroke style determines
   * how paths are outlined when using the stroke() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic stroke style
   * graphics.strokeStyle = {
   *     width: 2,
   *     color: 0xff0000,
   *     alpha: 1
   * };
   *
   * // Using with gradients
   * const gradient = new FillGradient({
   *   end: { x: 0, y: 1 },
   *   stops: [
   *       { offset: 0, color: 0xff0000, alpha: 1 },
   *       { offset: 1, color: 0x0000ff, alpha: 1 }
   *   ]
   * });
   *
   * graphics.strokeStyle = {
   *     width: 4,
   *     fill: gradient,
   *     alignment: 0.5,
   *     join: 'round',
   *     cap: 'round'
   * };
   *
   * // Complex stroke settings
   * graphics.strokeStyle = {
   *     width: 6,
   *     color: 0x00ff00,
   *     alpha: 0.5,
   *     join: 'miter',
   *     miterLimit: 10,
   * };
   * ```
   * @see {@link StrokeStyle} For all available stroke style options
   * @see {@link Graphics#stroke} For applying the stroke to paths
   */
  get strokeStyle() {
    return this._context.strokeStyle;
  }
  set strokeStyle(e) {
    this._context.strokeStyle = e;
  }
  /**
   * Creates a new Graphics object that copies the current graphics content.
   * The clone can either share the same context (shallow clone) or have its own independent
   * context (deep clone).
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Create original graphics content
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *
   * // Create a shallow clone (shared context)
   * const shallowClone = graphics.clone();
   *
   * // Changes to original affect the clone
   * graphics
   *     .circle(200, 100, 30)
   *     .fill({ color: 0x00ff00 });
   *
   * // Create a deep clone (independent context)
   * const deepClone = graphics.clone(true);
   *
   * // Modify deep clone independently
   * deepClone
   *     .translateTransform(100, 100)
   *     .circle(0, 0, 40)
   *     .fill({ color: 0x0000ff });
   * ```
   * @param deep - Whether to create a deep clone of the graphics object.
   *              If false (default), the context will be shared between objects.
   *              If true, creates an independent copy of the context.
   * @returns A new Graphics instance with either shared or copied context
   * @see {@link Graphics#context} For accessing the underlying graphics context
   * @see {@link GraphicsContext} For understanding the shared context behavior
   */
  clone(e = !1) {
    return e ? new Ko(this._context.clone()) : (this._ownedContext = null, new Ko(this._context));
  }
  // -------- v7 deprecations ---------
  /**
   * @param width
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#setStrokeStyle} instead
   */
  lineStyle(e, t, n) {
    rt(dn, "Graphics#lineStyle is no longer needed. Use Graphics#setStrokeStyle to set the stroke style.");
    const s = {};
    return e && (s.width = e), t && (s.color = t), n && (s.alpha = n), this.context.strokeStyle = s, this;
  }
  /**
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */
  beginFill(e, t) {
    rt(dn, "Graphics#beginFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
    const n = {};
    return e !== void 0 && (n.color = e), t !== void 0 && (n.alpha = t), this.context.fillStyle = n, this;
  }
  /**
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */
  endFill() {
    rt(dn, "Graphics#endFill is no longer needed. Use Graphics#fill to fill the shape with the desired style."), this.context.fill();
    const e = this.context.strokeStyle;
    return (e.width !== yd.defaultStrokeStyle.width || e.color !== yd.defaultStrokeStyle.color || e.alpha !== yd.defaultStrokeStyle.alpha) && this.context.stroke(), this;
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#circle} instead
   */
  drawCircle(...e) {
    return rt(dn, "Graphics#drawCircle has been renamed to Graphics#circle"), this._callContextMethod("circle", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#ellipse} instead
   */
  drawEllipse(...e) {
    return rt(dn, "Graphics#drawEllipse has been renamed to Graphics#ellipse"), this._callContextMethod("ellipse", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#poly} instead
   */
  drawPolygon(...e) {
    return rt(dn, "Graphics#drawPolygon has been renamed to Graphics#poly"), this._callContextMethod("poly", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#rect} instead
   */
  drawRect(...e) {
    return rt(dn, "Graphics#drawRect has been renamed to Graphics#rect"), this._callContextMethod("rect", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#roundRect} instead
   */
  drawRoundedRect(...e) {
    return rt(dn, "Graphics#drawRoundedRect has been renamed to Graphics#roundRect"), this._callContextMethod("roundRect", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#star} instead
   */
  drawStar(...e) {
    return rt(dn, "Graphics#drawStar has been renamed to Graphics#star"), this._callContextMethod("star", e);
  }
}
const qM = class KM extends fm {
  constructor(...e) {
    var c;
    let t = (c = e[0]) != null ? c : {};
    t instanceof Float32Array && (rt(dn, "use new MeshGeometry({ positions, uvs, indices }) instead"), t = {
      positions: t,
      uvs: e[1],
      indices: e[2]
    }), t = { ...KM.defaultOptions, ...t };
    const n = t.positions || new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);
    let s = t.uvs;
    s || (t.positions ? s = new Float32Array(n.length) : s = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]));
    const o = t.indices || new Uint32Array([0, 1, 2, 0, 2, 3]), r = t.shrinkBuffersToFit, a = new ns({
      data: n,
      label: "attribute-mesh-positions",
      shrinkToFit: r,
      usage: $t.VERTEX | $t.COPY_DST
    }), l = new ns({
      data: s,
      label: "attribute-mesh-uvs",
      shrinkToFit: r,
      usage: $t.VERTEX | $t.COPY_DST
    }), d = new ns({
      data: o,
      label: "index-mesh-buffer",
      shrinkToFit: r,
      usage: $t.INDEX | $t.COPY_DST
    });
    super({
      attributes: {
        aPosition: {
          buffer: a,
          format: "float32x2",
          stride: 8,
          offset: 0
        },
        aUV: {
          buffer: l,
          format: "float32x2",
          stride: 8,
          offset: 0
        }
      },
      indexBuffer: d,
      topology: t.topology
    }), this.batchMode = "auto";
  }
  /** The positions of the mesh. */
  get positions() {
    return this.attributes.aPosition.buffer.data;
  }
  /**
   * Set the positions of the mesh.
   * When setting the positions, its important that the uvs array is at least as long as the positions array.
   * otherwise the geometry will not be valid.
   * @param {Float32Array} value - The positions of the mesh.
   */
  set positions(e) {
    this.attributes.aPosition.buffer.data = e;
  }
  /** The UVs of the mesh. */
  get uvs() {
    return this.attributes.aUV.buffer.data;
  }
  /**
   * Set the UVs of the mesh.
   * Its important that the uvs array you set is at least as long as the positions array.
   * otherwise the geometry will not be valid.
   * @param {Float32Array} value - The UVs of the mesh.
   */
  set uvs(e) {
    this.attributes.aUV.buffer.data = e;
  }
  /** The indices of the mesh. */
  get indices() {
    return this.indexBuffer.data;
  }
  set indices(e) {
    this.indexBuffer.data = e;
  }
};
qM.defaultOptions = {
  topology: "triangle-list",
  shrinkBuffersToFit: !1
};
let SZ = qM;
class MZ {
  constructor() {
    this.batcherName = "default", this.packAsQuad = !1, this.indexOffset = 0, this.attributeOffset = 0, this.roundPixels = 0, this._batcher = null, this._batch = null, this._textureMatrixUpdateId = -1, this._uvUpdateId = -1;
  }
  get blendMode() {
    return this.renderable.groupBlendMode;
  }
  get topology() {
    return this._topology || this.geometry.topology;
  }
  set topology(e) {
    this._topology = e;
  }
  reset() {
    this.renderable = null, this.texture = null, this._batcher = null, this._batch = null, this.geometry = null, this._uvUpdateId = -1, this._textureMatrixUpdateId = -1;
  }
  /**
   * Sets the texture for the batchable mesh.
   * As it does so, it resets the texture matrix update ID.
   * this is to ensure that the texture matrix is recalculated when the uvs are referenced
   * @param value - The texture to set.
   */
  setTexture(e) {
    this.texture !== e && (this.texture = e, this._textureMatrixUpdateId = -1);
  }
  get uvs() {
    const t = this.geometry.getBuffer("aUV"), n = t.data;
    let s = n;
    const o = this.texture.textureMatrix;
    return o.isSimple || (s = this._transformedUvs, (this._textureMatrixUpdateId !== o._updateID || this._uvUpdateId !== t._updateID) && ((!s || s.length < n.length) && (s = this._transformedUvs = new Float32Array(n.length)), this._textureMatrixUpdateId = o._updateID, this._uvUpdateId = t._updateID, o.multiplyUvs(n, s))), s;
  }
  get positions() {
    return this.geometry.positions;
  }
  get indices() {
    return this.geometry.indices;
  }
  get color() {
    return this.renderable.groupColorAlpha;
  }
  get groupTransform() {
    return this.renderable.groupTransform;
  }
  get attributeSize() {
    return this.geometry.positions.length / 2;
  }
  get indexSize() {
    return this.geometry.indices.length;
  }
}
const wp = {
  name: "local-uniform-bit",
  vertex: {
    header: (
      /* wgsl */
      `

            struct LocalUniforms {
                uTransformMatrix:mat3x3<f32>,
                uColor:vec4<f32>,
                uRound:f32,
            }

            @group(1) @binding(0) var<uniform> localUniforms : LocalUniforms;
        `
    ),
    main: (
      /* wgsl */
      `
            vColor *= localUniforms.uColor;
            modelMatrix *= localUniforms.uTransformMatrix;
        `
    ),
    end: (
      /* wgsl */
      `
            if(localUniforms.uRound == 1)
            {
                vPosition = vec4(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
            }
        `
    )
  }
}, TZ = {
  ...wp,
  vertex: {
    ...wp.vertex,
    // replace the group!
    header: wp.vertex.header.replace("group(1)", "group(2)")
  }
}, YM = {
  name: "local-uniform-bit",
  vertex: {
    header: (
      /* glsl */
      `

            uniform mat3 uTransformMatrix;
            uniform vec4 uColor;
            uniform float uRound;
        `
    ),
    main: (
      /* glsl */
      `
            vColor *= uColor;
            modelMatrix = uTransformMatrix;
        `
    ),
    end: (
      /* glsl */
      `
            if(uRound == 1.)
            {
                gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
            }
        `
    )
  }
};
class XM {
  constructor() {
    this.batcherName = "default", this.topology = "triangle-list", this.attributeSize = 4, this.indexSize = 6, this.packAsQuad = !0, this.roundPixels = 0, this._attributeStart = 0, this._batcher = null, this._batch = null;
  }
  get blendMode() {
    return this.renderable.groupBlendMode;
  }
  get color() {
    return this.renderable.groupColorAlpha;
  }
  reset() {
    this.renderable = null, this.texture = null, this._batcher = null, this._batch = null, this.bounds = null;
  }
  destroy() {
    this.reset();
  }
}
function CZ() {
  const { userAgent: i } = zt.get().getNavigator();
  return /^((?!chrome|android).)*safari/i.test(i);
}
const by = class Rr {
  static _getPatternRepeat(e, t) {
    const n = e && e !== "clamp-to-edge", s = t && t !== "clamp-to-edge";
    return n && s ? "repeat" : n ? "repeat-x" : s ? "repeat-y" : "no-repeat";
  }
  start(e, t, n) {
  }
  execute(e, t) {
    var a, l, d, c, h, f, p, y, v, x;
    const n = t.elements;
    if (!n || !n.length) return;
    const s = e.renderer, o = s.canvasContext, r = o.activeContext;
    for (let w = 0; w < n.length; w++) {
      const S = n[w];
      if (!S.packAsQuad) continue;
      const M = S, _ = M.texture, T = _ ? _t.getCanvasSource(_) : null;
      if (!T) continue;
      const k = _.source.style, P = o.smoothProperty, A = k.scaleMode !== "nearest";
      r[P] !== A && (r[P] = A), o.setBlendMode(t.blendMode);
      const R = (l = (a = s.globalUniforms.globalUniformData) == null ? void 0 : a.worldColor) != null ? l : 4294967295, D = M.color, O = (R >>> 24 & 255) / 255, F = (D >>> 24 & 255) / 255, te = (c = (d = s.filter) == null ? void 0 : d.alphaMultiplier) != null ? c : 1, ee = O * F * te;
      if (ee <= 0) continue;
      r.globalAlpha = ee;
      const me = R & 16777215, L = D & 16777215, N = sa(ia(L, me)), X = _.frame, B = (h = k.addressModeU) != null ? h : k.addressMode, se = (f = k.addressModeV) != null ? f : k.addressMode, V = Rr._getPatternRepeat(B, se), Z = (y = (p = _.source._resolution) != null ? p : _.source.resolution) != null ? y : 1, Y = (x = (v = M.renderable) == null ? void 0 : v.renderGroup) == null ? void 0 : x.isCachedAsTexture, H = X.x * Z, re = X.y * Z, le = X.width * Z, he = X.height * Z, Re = M.bounds, Ne = s.renderTarget.renderTarget.isRoot, Me = Re.minX, ue = Re.minY, U = Re.maxX - Re.minX, q = Re.maxY - Re.minY, ie = _.rotate, de = _.uvs, pe = Math.min(de.x0, de.x1, de.x2, de.x3, de.y0, de.y1, de.y2, de.y3), Te = Math.max(de.x0, de.x1, de.x2, de.x3, de.y0, de.y1, de.y2, de.y3), Be = V !== "no-repeat" && (pe < 0 || Te > 1), ne = ie && !(!Be && (N !== 16777215 || ie));
      ne ? (Rr._tempPatternMatrix.copyFrom(M.transform), Mt.matrixAppendRotationInv(
        Rr._tempPatternMatrix,
        ie,
        Me,
        ue,
        U,
        q
      ), o.setContextTransform(
        Rr._tempPatternMatrix,
        M.roundPixels === 1,
        void 0,
        Y && Ne
      )) : o.setContextTransform(
        M.transform,
        M.roundPixels === 1,
        void 0,
        Y && Ne
      );
      const oe = U, ye = q;
      let Oe = ne ? 0 : Me, Ve = ne ? 0 : ue;
      if (!ne && M.roundPixels === 1 && (Oe |= 0, Ve |= 0), Be) {
        let Ue = T;
        const tt = N !== 16777215 && !ie, Ye = X.width <= _.source.width && X.height <= _.source.height;
        tt && Ye && (Ue = _t.getTintedCanvas({ texture: _ }, N));
        const at = r.createPattern(Ue, V);
        if (!at) continue;
        const wt = oe, $e = ye;
        if (wt === 0 || $e === 0) continue;
        const Fe = 1 / wt, W = 1 / $e, Q = (de.x1 - de.x0) * Fe, ae = (de.y1 - de.y0) * Fe, Le = (de.x3 - de.x0) * W, ve = (de.y3 - de.y0) * W, ke = de.x0 - Q * Oe - Le * Ve, De = de.y0 - ae * Oe - ve * Ve, Qe = _.source.pixelWidth, ft = _.source.pixelHeight;
        Rr._tempPatternMatrix.set(
          Q * Qe,
          ae * ft,
          Le * Qe,
          ve * ft,
          ke * Qe,
          De * ft
        ), _t.applyPatternTransform(at, Rr._tempPatternMatrix), r.fillStyle = at, r.fillRect(Oe, Ve, oe, ye);
      } else {
        const tt = N !== 16777215 || ie ? _t.getTintedCanvas({ texture: _ }, N) : T, Ye = tt !== T;
        r.drawImage(
          tt,
          Ye ? 0 : H,
          Ye ? 0 : re,
          Ye ? tt.width : le,
          Ye ? tt.height : he,
          Oe,
          Ve,
          oe,
          ye
        );
      }
    }
  }
};
by._tempPatternMatrix = new st();
by.extension = {
  type: [
    Ie.CanvasPipesAdaptor
  ],
  name: "batch"
};
let IZ = by;
class JM {
  constructor() {
    this._tempState = co.for2d(), this._didUploadHash = {};
  }
  init(e) {
    e.renderer.runners.contextChange.add(this);
  }
  contextChange() {
    this._didUploadHash = {};
  }
  start(e, t, n) {
    const s = e.renderer, o = this._didUploadHash[n.uid];
    s.shader.bind(n, o), o || (this._didUploadHash[n.uid] = !0), s.shader.updateUniformGroup(s.globalUniforms.uniformGroup), s.geometry.bind(t, n.glProgram);
  }
  execute(e, t) {
    const n = e.renderer;
    this._tempState.blendMode = t.blendMode, n.state.set(this._tempState);
    const s = t.textures.textures;
    for (let o = 0; o < t.textures.count; o++)
      n.texture.bind(s[o], o);
    n.texture.unbindIntegerTextures(t.textures.count), n.geometry.draw(t.topology, t.size, t.start);
  }
}
JM.extension = {
  type: [
    Ie.WebGLPipesAdaptor
  ],
  name: "batch"
};
const fh = co.for2d();
class ZM {
  start(e, t, n) {
    const s = e.renderer, o = s.encoder, r = n.gpuProgram;
    this._shader = n, this._geometry = t, o.setGeometry(t, r), fh.blendMode = "normal", s.pipeline.getPipeline(
      t,
      r,
      fh,
      void 0,
      n._overrides
    );
    const a = s.globalUniforms.bindGroup;
    o.resetBindGroup(1), o.setBindGroup(0, a, r);
  }
  execute(e, t) {
    const n = this._shader.gpuProgram, s = e.renderer, o = s.encoder;
    if (!t.bindGroup) {
      const l = t.textures;
      t.bindGroup = iy(
        l.textures,
        l.count,
        s.limits.maxBatchableTextures
      );
    }
    fh.blendMode = t.blendMode;
    const r = s.bindGroup.getBindGroup(
      t.bindGroup,
      n,
      1
    ), a = s.pipeline.getPipeline(
      this._geometry,
      n,
      fh,
      t.topology,
      this._shader._overrides
    );
    t.bindGroup._touch(s.gc.now), o.setPipeline(a), o.renderPassEncoder.setBindGroup(1, r), o.renderPassEncoder.drawIndexed(t.size, 1, t.start);
  }
}
ZM.extension = {
  type: [
    Ie.WebGPUPipesAdaptor
  ],
  name: "batch"
};
const vy = class QM {
  constructor(e, t) {
    var n, s;
    this.state = co.for2d(), this._batchersByInstructionSet = /* @__PURE__ */ Object.create(null), this._activeBatches = /* @__PURE__ */ Object.create(null), this.renderer = e, this._adaptor = t, (s = (n = this._adaptor).init) == null || s.call(n, this);
  }
  static getBatcher(e, t) {
    return new this._availableBatchers[e]({ maxTextures: t });
  }
  buildStart(e) {
    let t = this._batchersByInstructionSet[e.uid];
    t || (t = this._batchersByInstructionSet[e.uid] = /* @__PURE__ */ Object.create(null), t.default || (t.default = new ly({
      maxTextures: this.renderer.limits.maxBatchableTextures
    }))), this._activeBatches = t, this._activeBatch = this._activeBatches.default;
    for (const n in this._activeBatches)
      this._activeBatches[n].begin();
  }
  addToBatch(e, t) {
    if (this._activeBatch.name !== e.batcherName) {
      this._activeBatch.break(t);
      let n = this._activeBatches[e.batcherName];
      n || (n = this._activeBatches[e.batcherName] = QM.getBatcher(e.batcherName, this.renderer.limits.maxBatchableTextures), n.begin()), this._activeBatch = n;
    }
    this._activeBatch.add(e);
  }
  break(e) {
    this._activeBatch.break(e);
  }
  buildEnd(e) {
    this._activeBatch.break(e);
    const t = this._activeBatches;
    for (const n in t) {
      const s = t[n], o = s.geometry;
      o.indexBuffer.setDataWithSize(s.indexBuffer, s.indexSize, !0), o.buffers[0].setDataWithSize(s.attributeBuffer.float32View, s.attributeSize, !1);
    }
  }
  upload(e) {
    const t = this._batchersByInstructionSet[e.uid];
    for (const n in t) {
      const s = t[n], o = s.geometry;
      s.dirty && (s.dirty = !1, o.buffers[0].update(s.attributeSize * 4));
    }
  }
  execute(e) {
    if (e.action === "startBatch") {
      const t = e.batcher, n = t.geometry, s = t.shader;
      this._adaptor.start(this, n, s);
    }
    this._adaptor.execute(this, e);
  }
  /**
   * Releases all batchers cached for the given InstructionSet. Called from
   * `InstructionSet.destroy()` so that batchers (and their GPU geometry / attribute
   * buffers / referenced textures) do not leak when the owning RenderGroup is destroyed.
   * @param instructionSet - the instruction set being destroyed
   */
  destroyInstructionSet(e) {
    const t = this._batchersByInstructionSet[e.uid];
    if (t) {
      for (const n in t)
        t[n].destroy();
      delete this._batchersByInstructionSet[e.uid], this._activeBatches === t && (this._activeBatches = /* @__PURE__ */ Object.create(null), this._activeBatch = null);
    }
  }
  destroy() {
    this.state = null, this.renderer = null, this._adaptor = null;
    for (const e in this._activeBatches)
      this._activeBatches[e].destroy();
    this._activeBatches = null;
  }
};
vy.extension = {
  type: [
    Ie.WebGLPipes,
    Ie.WebGPUPipes,
    Ie.CanvasPipes
  ],
  name: "batch"
};
vy._availableBatchers = /* @__PURE__ */ Object.create(null);
let yy = vy;
ht.handleByMap(Ie.Batcher, yy._availableBatchers);
ht.add(ly);
const AZ = {
  name: "texture-bit",
  vertex: {
    header: (
      /* wgsl */
      `

        struct TextureUniforms {
            uTextureMatrix:mat3x3<f32>,
        }

        @group(2) @binding(2) var<uniform> textureUniforms : TextureUniforms;
        `
    ),
    main: (
      /* wgsl */
      `
            uv = (textureUniforms.uTextureMatrix * vec3(uv, 1.0)).xy;
        `
    )
  },
  fragment: {
    header: (
      /* wgsl */
      `
            @group(2) @binding(0) var uTexture: texture_2d<f32>;
            @group(2) @binding(1) var uSampler: sampler;


        `
    ),
    main: (
      /* wgsl */
      `
            outColor = textureSample(uTexture, uSampler, vUV);
        `
    )
  }
}, PZ = {
  name: "texture-bit",
  vertex: {
    header: (
      /* glsl */
      `
            uniform mat3 uTextureMatrix;
        `
    ),
    main: (
      /* glsl */
      `
            uv = (uTextureMatrix * vec3(uv, 1.0)).xy;
        `
    )
  },
  fragment: {
    header: (
      /* glsl */
      `
        uniform sampler2D uTexture;


        `
    ),
    main: (
      /* glsl */
      `
            outColor = texture(uTexture, vUV);
        `
    )
  }
}, EZ = new Gn();
class RZ extends uf {
  constructor() {
    super(), this._placeholderSprite = new ks(et.EMPTY), this.filters = [new yZ({
      sprite: this._placeholderSprite,
      inverse: !1,
      resolution: "inherit",
      antialias: "inherit"
    })];
  }
  get sprite() {
    return this.filters[0].sprite;
  }
  set sprite(e) {
    this.filters[0].setSprite(e);
  }
  get inverse() {
    return this.filters[0].inverse;
  }
  set inverse(e) {
    this.filters[0].inverse = e;
  }
  get channel() {
    return this.filters[0].channel;
  }
  set channel(e) {
    this.filters[0].channel = e;
  }
  /**
   * Called by {@link BigPool} when the pipe returns the effect: parks the filter
   * on the empty placeholder so a pooled effect keeps no bindings to the last
   * mask it applied. Without this, the pooled filter pins the mask sprite and
   * its texture for as long as the effect sits in the pool, and destroying that
   * texture's source hits a bind group subscription the user cannot release.
   */
  reset() {
    this._placeholderSprite.texture = et.EMPTY, this.sprite = this._placeholderSprite;
  }
}
class xy {
  constructor(e) {
    this._activeMaskStage = [], this._usedEffects = [], this._renderer = e, e.runners.postrender.add(this);
  }
  push(e, t, n) {
    var o;
    const s = this._renderer;
    if (s.renderPipes.batch.break(n), n.add({
      renderPipeId: "alphaMask",
      action: "pushMaskBegin",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1,
      maskedContainer: t
    }), e.inverse = t._maskOptions.inverse, e.channel = (o = t._maskOptions.channel) != null ? o : "red", e.renderMaskToTexture) {
      const r = e.mask;
      r.includeInBuild = !0, r.collectRenderables(
        n,
        s,
        null
      ), r.includeInBuild = !1;
    }
    s.renderPipes.batch.break(n), n.add({
      renderPipeId: "alphaMask",
      action: "pushMaskEnd",
      mask: e,
      maskedContainer: t,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
  }
  pop(e, t, n) {
    this._renderer.renderPipes.batch.break(n), n.add({
      renderPipeId: "alphaMask",
      action: "popMaskEnd",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
  }
  execute(e) {
    const t = this._renderer, n = e.mask.renderMaskToTexture;
    if (e.action === "pushMaskBegin") {
      const s = $n.get(RZ);
      if (s.inverse = e.inverse, s.channel = e.mask.channel, n) {
        e.mask.mask.measurable = !0;
        const o = q1(e.mask.mask, !0, EZ);
        e.mask.mask.measurable = !1, o.ceil();
        const r = t.renderTarget.renderTarget.colorTexture.source, a = Nn.getOptimalTexture({
          width: o.width,
          height: o.height,
          resolution: r._resolution,
          antialias: r.antialias
        });
        t.renderTarget.push({ target: a, clear: !0 }), t.globalUniforms.push({
          offset: o,
          worldColor: 4294967295
        });
        const l = s.sprite;
        l.texture = a, l.worldTransform.tx = o.minX, l.worldTransform.ty = o.minY, this._activeMaskStage.push({
          filterEffect: s,
          maskedContainer: e.maskedContainer,
          filterTexture: a
        });
      } else
        s.sprite = e.mask.mask, this._activeMaskStage.push({
          filterEffect: s,
          maskedContainer: e.maskedContainer
        });
    } else if (e.action === "pushMaskEnd") {
      const s = this._activeMaskStage[this._activeMaskStage.length - 1];
      n && (t.type === rs.WEBGL && t.renderTarget.finishRenderPass(), t.renderTarget.pop(), t.globalUniforms.pop()), t.filter.push({
        renderPipeId: "filter",
        action: "pushFilter",
        container: s.maskedContainer,
        filterEffect: s.filterEffect,
        canBundle: !1
      });
    } else if (e.action === "popMaskEnd") {
      t.filter.pop();
      const s = this._activeMaskStage.pop();
      n && Nn.returnTexture(s.filterTexture), this._usedEffects.push(s.filterEffect);
    }
  }
  postrender() {
    const e = this._usedEffects;
    for (let t = 0; t < e.length; t++)
      $n.return(e[t]);
    e.length = 0;
  }
  destroy() {
    this.postrender(), this._renderer.runners.postrender.remove(this), this._renderer = null, this._activeMaskStage = null, this._usedEffects = null;
  }
}
xy.extension = {
  type: [
    Ie.WebGLPipes,
    Ie.WebGPUPipes,
    Ie.CanvasPipes
  ],
  name: "alphaMask"
};
class eT {
  constructor(e) {
    this._colorStack = [], this._colorStackIndex = 0, this._currentColor = 0, this._renderer = e;
  }
  buildStart() {
    this._colorStack[0] = 15, this._colorStackIndex = 1, this._currentColor = 15;
  }
  push(e, t, n) {
    this._renderer.renderPipes.batch.break(n);
    const s = this._colorStack;
    s[this._colorStackIndex] = s[this._colorStackIndex - 1] & e.mask;
    const o = this._colorStack[this._colorStackIndex];
    o !== this._currentColor && (this._currentColor = o, n.add({
      renderPipeId: "colorMask",
      colorMask: o,
      canBundle: !1
    })), this._colorStackIndex++;
  }
  pop(e, t, n) {
    this._renderer.renderPipes.batch.break(n);
    const s = this._colorStack;
    this._colorStackIndex--;
    const o = s[this._colorStackIndex - 1];
    o !== this._currentColor && (this._currentColor = o, n.add({
      renderPipeId: "colorMask",
      colorMask: o,
      canBundle: !1
    }));
  }
  execute(e) {
  }
  destroy() {
    this._renderer = null, this._colorStack = null;
  }
}
eT.extension = {
  type: [
    Ie.CanvasPipes
  ],
  name: "colorMask"
};
class tT {
  constructor(e) {
    this._colorStack = [], this._colorStackIndex = 0, this._currentColor = 0, this._renderer = e;
  }
  buildStart() {
    this._colorStack[0] = 15, this._colorStackIndex = 1, this._currentColor = 15;
  }
  push(e, t, n) {
    this._renderer.renderPipes.batch.break(n);
    const o = this._colorStack;
    o[this._colorStackIndex] = o[this._colorStackIndex - 1] & e.mask;
    const r = this._colorStack[this._colorStackIndex];
    r !== this._currentColor && (this._currentColor = r, n.add({
      renderPipeId: "colorMask",
      colorMask: r,
      canBundle: !1
    })), this._colorStackIndex++;
  }
  pop(e, t, n) {
    this._renderer.renderPipes.batch.break(n);
    const o = this._colorStack;
    this._colorStackIndex--;
    const r = o[this._colorStackIndex - 1];
    r !== this._currentColor && (this._currentColor = r, n.add({
      renderPipeId: "colorMask",
      colorMask: r,
      canBundle: !1
    }));
  }
  execute(e) {
    this._renderer.colorMask.setMask(e.colorMask);
  }
  destroy() {
    this._renderer = null, this._colorStack = null;
  }
}
tT.extension = {
  type: [
    Ie.WebGLPipes,
    Ie.WebGPUPipes
  ],
  name: "colorMask"
};
function zZ(i, e, t, n, s, o) {
  o = Math.max(0, Math.min(o, Math.min(n, s) / 2)), i.moveTo(e + o, t), i.lineTo(e + n - o, t), i.quadraticCurveTo(e + n, t, e + n, t + o), i.lineTo(e + n, t + s - o), i.quadraticCurveTo(e + n, t + s, e + n - o, t + s), i.lineTo(e + o, t + s), i.quadraticCurveTo(e, t + s, e, t + s - o), i.lineTo(e, t + o), i.quadraticCurveTo(e, t, e + o, t);
}
function nT(i, e) {
  switch (e.type) {
    case "rectangle": {
      const t = e;
      i.rect(t.x, t.y, t.width, t.height);
      break;
    }
    case "roundedRectangle": {
      const t = e;
      zZ(i, t.x, t.y, t.width, t.height, t.radius);
      break;
    }
    case "circle": {
      const t = e;
      i.moveTo(t.x + t.radius, t.y), i.arc(t.x, t.y, t.radius, 0, Math.PI * 2);
      break;
    }
    case "ellipse": {
      const t = e;
      i.ellipse ? (i.moveTo(t.x + t.halfWidth, t.y), i.ellipse(t.x, t.y, t.halfWidth, t.halfHeight, 0, 0, Math.PI * 2)) : (i.save(), i.translate(t.x, t.y), i.scale(t.halfWidth, t.halfHeight), i.moveTo(1, 0), i.arc(0, 0, 1, 0, Math.PI * 2), i.restore());
      break;
    }
    case "triangle": {
      const t = e;
      i.moveTo(t.x, t.y), i.lineTo(t.x2, t.y2), i.lineTo(t.x3, t.y3), i.closePath();
      break;
    }
    default: {
      const t = e, n = t.points;
      if (!(n != null && n.length)) break;
      i.moveTo(n[0], n[1]);
      for (let s = 2; s < n.length; s += 2)
        i.lineTo(n[s], n[s + 1]);
      t.closePath && i.closePath();
      break;
    }
  }
}
function $Z(i, e, t) {
  var l;
  const n = [], s = [], o = [], r = Zl[e.type];
  if (!(r != null && r.build(e, n))) return !1;
  const a = (l = e.closePath) != null ? l : !0;
  cy(n, t, !1, a, s, o);
  for (let d = 0; d < o.length; d += 3) {
    const c = o[d] * 2, h = o[d + 1] * 2, f = o[d + 2] * 2;
    i.moveTo(s[c], s[c + 1]), i.lineTo(s[h], s[h + 1]), i.lineTo(s[f], s[f + 1]), i.closePath();
  }
  return !0;
}
function DZ(i, e) {
  if (!(e != null && e.length)) return !1;
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    if (!(n != null && n.shape)) continue;
    const s = n.transform, o = s && !s.isIdentity();
    o && (i.save(), i.transform(s.a, s.b, s.c, s.d, s.tx, s.ty)), nT(i, n.shape), o && i.restore();
  }
  return !0;
}
class iT {
  constructor(e) {
    this._warnedMaskTypes = /* @__PURE__ */ new Set(), this._canvasMaskStack = [], this._renderer = e;
  }
  push(e, t, n) {
    this._renderer.renderPipes.batch.break(n), n.add({
      renderPipeId: "stencilMask",
      action: "pushMaskBegin",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
  }
  pop(e, t, n) {
    this._renderer.renderPipes.batch.break(n), n.add({
      renderPipeId: "stencilMask",
      action: "popMaskEnd",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
  }
  execute(e) {
    var c, h, f;
    if (e.action !== "pushMaskBegin" && e.action !== "popMaskEnd")
      return;
    const t = this._renderer, n = t.canvasContext, s = n == null ? void 0 : n.activeContext;
    if (!s) return;
    if (e.action === "popMaskEnd") {
      this._canvasMaskStack.pop() && s.restore();
      return;
    }
    e.inverse && this._warnOnce(
      "inverse",
      "CanvasRenderer: inverse masks are not supported on Canvas2D; ignoring inverse flag."
    );
    const o = e.mask.mask;
    if (!(o instanceof Ko)) {
      this._warnOnce(
        "nonGraphics",
        "CanvasRenderer: only Graphics masks are supported in Canvas2D; skipping mask."
      ), this._canvasMaskStack.push(!1);
      return;
    }
    const r = o, a = (c = r.context) == null ? void 0 : c.instructions;
    if (!(a != null && a.length)) {
      this._canvasMaskStack.push(!1);
      return;
    }
    s.save(), n.setContextTransform(
      r.groupTransform,
      (t._roundPixels | r._roundPixels) === 1
    ), s.beginPath();
    let l = !1, d = !1;
    for (let p = 0; p < a.length; p++) {
      const y = a[p], v = y.action;
      if (v !== "fill" && v !== "stroke") continue;
      const x = y.data, w = (h = x == null ? void 0 : x.path) == null ? void 0 : h.shapePath;
      if (!((f = w == null ? void 0 : w.shapePrimitives) != null && f.length)) continue;
      const S = v === "stroke", M = w.shapePrimitives;
      for (let _ = 0; _ < M.length; _++) {
        const T = M[_];
        if (!(T != null && T.shape)) continue;
        const k = T.transform, P = k && !k.isIdentity();
        P && (s.save(), s.transform(k.a, k.b, k.c, k.d, k.tx, k.ty)), S && x.style ? l = $Z(
          s,
          T.shape,
          x.style
        ) || l : (nT(s, T.shape), d = DZ(s, T.holes) || d, l = !0), P && s.restore();
      }
    }
    if (!l) {
      s.restore(), this._canvasMaskStack.push(!1);
      return;
    }
    d ? s.clip("evenodd") : s.clip(), this._canvasMaskStack.push(!0);
  }
  destroy() {
    this._renderer = null, this._warnedMaskTypes = null, this._canvasMaskStack = null;
  }
  _warnOnce(e, t) {
    this._warnedMaskTypes.has(e) || (this._warnedMaskTypes.add(e), dt(t));
  }
}
iT.extension = {
  type: [
    Ie.CanvasPipes
  ],
  name: "stencilMask"
};
class sT {
  constructor(e) {
    this._maskHash = /* @__PURE__ */ new WeakMap(), this._renderer = e;
  }
  push(e, t, n) {
    const s = e, o = this._renderer;
    o.renderPipes.batch.break(n), o.renderPipes.blendMode.setBlendMode(s.mask, "none", n), n.add({
      renderPipeId: "stencilMask",
      action: "pushMaskBegin",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
    const r = s.mask;
    r.includeInBuild = !0, this._maskHash.has(s) || this._maskHash.set(s, {
      instructionsStart: 0,
      instructionsLength: 0
    });
    const a = this._maskHash.get(s);
    a.instructionsStart = n.instructionSize, r.collectRenderables(
      n,
      o,
      null
    ), r.includeInBuild = !1, o.renderPipes.batch.break(n), n.add({
      renderPipeId: "stencilMask",
      action: "pushMaskEnd",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
    const l = n.instructionSize - a.instructionsStart - 1;
    a.instructionsLength = l;
  }
  pop(e, t, n) {
    const s = e, o = this._renderer;
    o.renderPipes.batch.break(n), o.renderPipes.blendMode.setBlendMode(s.mask, "none", n), n.add({
      renderPipeId: "stencilMask",
      action: "popMaskBegin",
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
    const r = this._maskHash.get(e);
    for (let a = 0; a < r.instructionsLength; a++)
      n.instructions[n.instructionSize++] = n.instructions[r.instructionsStart++];
    n.add({
      renderPipeId: "stencilMask",
      action: "popMaskEnd",
      canBundle: !1
    });
  }
  execute(e) {
    const n = this._renderer, s = n.renderTarget.getGpuRenderTarget(n.renderTarget.renderTarget);
    let o = s.maskStackIndex;
    e.action === "pushMaskBegin" ? (n.renderTarget.ensureDepthStencil(), n.stencil.setStencilMode(fn.RENDERING_MASK_ADD, o), o++, n.colorMask.setMask(0)) : e.action === "pushMaskEnd" ? (e.inverse ? n.stencil.setStencilMode(fn.INVERSE_MASK_ACTIVE, o) : n.stencil.setStencilMode(fn.MASK_ACTIVE, o), n.colorMask.setMask(15)) : e.action === "popMaskBegin" ? (n.colorMask.setMask(0), o !== 0 ? n.stencil.setStencilMode(fn.RENDERING_MASK_REMOVE, o) : (n.renderTarget.clear(null, Mn.STENCIL), n.stencil.setStencilMode(fn.DISABLED, o)), o--) : e.action === "popMaskEnd" && (e.inverse ? n.stencil.setStencilMode(fn.INVERSE_MASK_ACTIVE, o) : n.stencil.setStencilMode(fn.MASK_ACTIVE, o), n.colorMask.setMask(15)), s.maskStackIndex = o;
  }
  destroy() {
    this._renderer = null, this._maskHash = null;
  }
}
sT.extension = {
  type: [
    Ie.WebGLPipes,
    Ie.WebGPUPipes
  ],
  name: "stencilMask"
};
const Gt = "source-over";
function OZ() {
  const i = FM(), e = /* @__PURE__ */ Object.create(null);
  return e.inherit = Gt, e.none = Gt, e.normal = "source-over", e.add = "lighter", e.multiply = i ? "multiply" : Gt, e.screen = i ? "screen" : Gt, e.overlay = i ? "overlay" : Gt, e.darken = i ? "darken" : Gt, e.lighten = i ? "lighten" : Gt, e["color-dodge"] = i ? "color-dodge" : Gt, e["color-burn"] = i ? "color-burn" : Gt, e["hard-light"] = i ? "hard-light" : Gt, e["soft-light"] = i ? "soft-light" : Gt, e.difference = i ? "difference" : Gt, e.exclusion = i ? "exclusion" : Gt, e.saturation = i ? "saturation" : Gt, e.color = i ? "color" : Gt, e.luminosity = i ? "luminosity" : Gt, e["linear-burn"] = i ? "color-burn" : Gt, e["linear-dodge"] = i ? "color-dodge" : Gt, e["linear-light"] = i ? "hard-light" : Gt, e["pin-light"] = i ? "hard-light" : Gt, e["vivid-light"] = i ? "hard-light" : Gt, e["hard-mix"] = Gt, e.negation = i ? "difference" : Gt, e["normal-npm"] = e.normal, e["add-npm"] = e.add, e["screen-npm"] = e.screen, e.erase = "destination-out", e.subtract = Gt, e.divide = Gt, e.min = Gt, e.max = Gt, e;
}
const LZ = new st();
class oT {
  /**
   * @param renderer - The owning CanvasRenderer.
   */
  constructor(e) {
    this.activeResolution = 1, this.smoothProperty = "imageSmoothingEnabled", this.blendModes = OZ(), this._activeBlendMode = "normal", this._projTransform = null, this._outerBlend = !1, this._warnedBlendModes = /* @__PURE__ */ new Set(), this._renderer = e;
  }
  resolutionChange(e) {
    this.activeResolution = e;
  }
  /** Initializes the root context and smoothing flag selection. */
  init() {
    const e = this._renderer.background.alpha < 1;
    if (this.rootContext = this._renderer.canvas.getContext(
      "2d",
      { alpha: e }
    ), this.activeContext = this.rootContext, this.activeResolution = this._renderer.resolution, !this.rootContext.imageSmoothingEnabled) {
      const t = this.rootContext;
      t.webkitImageSmoothingEnabled ? this.smoothProperty = "webkitImageSmoothingEnabled" : t.mozImageSmoothingEnabled ? this.smoothProperty = "mozImageSmoothingEnabled" : t.oImageSmoothingEnabled ? this.smoothProperty = "oImageSmoothingEnabled" : t.msImageSmoothingEnabled && (this.smoothProperty = "msImageSmoothingEnabled");
    }
  }
  /**
   * Sets the current transform on the active context.
   * @param transform - Transform to apply.
   * @param roundPixels - Whether to round translation to integers.
   * @param localResolution - Optional local resolution multiplier.
   * @param skipGlobalTransform - If true, skip applying the global world transform matrix.
   */
  setContextTransform(e, t, n, s) {
    var d;
    const o = s ? st.IDENTITY : ((d = this._renderer.globalUniforms.globalUniformData) == null ? void 0 : d.worldTransformMatrix) || st.IDENTITY;
    let r = LZ;
    r.copyFrom(o), r.append(e);
    const a = this._projTransform, l = this.activeResolution;
    if (n = n || l, a) {
      const c = st.shared;
      c.copyFrom(r), c.prepend(a), r = c;
    }
    t ? this.activeContext.setTransform(
      r.a * n,
      r.b * n,
      r.c * n,
      r.d * n,
      r.tx * l | 0,
      r.ty * l | 0
    ) : this.activeContext.setTransform(
      r.a * n,
      r.b * n,
      r.c * n,
      r.d * n,
      r.tx * l,
      r.ty * l
    );
  }
  /**
   * Clears the current render target, optionally filling with a color.
   * @param clearColor - Color to fill after clearing.
   * @param alpha - Alpha override for the clear color.
   */
  clear(e, t) {
    const n = this.activeContext, s = this._renderer;
    if (n.clearRect(0, 0, s.width, s.height), e) {
      const o = bn.shared.setValue(e);
      n.globalAlpha = t != null ? t : o.alpha, n.fillStyle = o.toHex(), n.fillRect(0, 0, s.width, s.height), n.globalAlpha = 1;
    }
  }
  /**
   * Sets the active blend mode.
   * @param blendMode - Pixi blend mode.
   */
  setBlendMode(e) {
    if (this._activeBlendMode === e) return;
    this._activeBlendMode = e, this._outerBlend = !1;
    const t = this.blendModes[e];
    if (!t) {
      this._warnedBlendModes.has(e) || (console.warn(
        `CanvasRenderer: blend mode "${e}" is not supported in Canvas2D; falling back to "source-over".`
      ), this._warnedBlendModes.add(e)), this.activeContext.globalCompositeOperation = "source-over";
      return;
    }
    this.activeContext.globalCompositeOperation = t;
  }
  /** Releases context references. */
  destroy() {
    this.rootContext = null, this.activeContext = null, this._warnedBlendModes.clear();
  }
}
oT.extension = {
  type: [
    Ie.CanvasSystem
  ],
  name: "canvasContext"
};
class rT {
  constructor() {
    this.maxTextures = 16, this.maxBatchableTextures = 16, this.maxUniformBindings = 0;
  }
  init() {
  }
}
rT.extension = {
  type: [
    Ie.CanvasSystem
  ],
  name: "limits"
};
class wy {
  constructor(e) {
    this._renderer = e;
  }
  updateRenderable() {
  }
  destroyRenderable() {
  }
  validateRenderable() {
    return !1;
  }
  addRenderable(e, t) {
    this._renderer.renderPipes.batch.break(t), t.add(e);
  }
  execute(e) {
    e.isRenderable && e.render(this._renderer);
  }
  destroy() {
    this._renderer = null;
  }
}
wy.extension = {
  type: [
    Ie.WebGLPipes,
    Ie.WebGPUPipes,
    Ie.CanvasPipes
  ],
  name: "customRender"
};
function c0(i, e) {
  const t = i.instructionSet, n = t.instructions;
  for (let s = 0; s < t.instructionSize; s++) {
    const o = n[s];
    e[o.renderPipeId].execute(o);
  }
}
class ky {
  constructor(e) {
    this._renderer = e;
  }
  addRenderGroup(e, t) {
    e.isCachedAsTexture ? this._addRenderableCacheAsTexture(e, t) : this._addRenderableDirect(e, t);
  }
  execute(e) {
    e.isRenderable && (e.isCachedAsTexture ? this._executeCacheAsTexture(e) : this._executeDirect(e));
  }
  destroy() {
    this._renderer = null;
  }
  _addRenderableDirect(e, t) {
    this._renderer.renderPipes.batch.break(t), e._batchableRenderGroup && ($n.return(e._batchableRenderGroup), e._batchableRenderGroup = null), t.add(e);
  }
  _addRenderableCacheAsTexture(e, t) {
    var s;
    const n = (s = e._batchableRenderGroup) != null ? s : e._batchableRenderGroup = $n.get(XM);
    n.renderable = e.root, n.transform = e.root.relativeGroupTransform, n.texture = e.texture, n.bounds = e._textureBounds, t.add(e), this._renderer.renderPipes.blendMode.pushBlendMode(e, e.root.groupBlendMode, t), this._renderer.renderPipes.batch.addToBatch(n, t), this._renderer.renderPipes.blendMode.popBlendMode(t);
  }
  _executeCacheAsTexture(e) {
    if (e.textureNeedsUpdate) {
      e.textureNeedsUpdate = !1;
      const t = new st().translate(
        -e._textureBounds.x,
        -e._textureBounds.y
      );
      this._renderer.renderTarget.push({
        target: e.texture,
        clear: !0,
        frame: e.texture.frame
      }), this._renderer.globalUniforms.push({
        worldTransformMatrix: t,
        worldColor: 4294967295,
        offset: { x: 0, y: 0 }
      }), c0(e, this._renderer.renderPipes), this._renderer.renderTarget.finishRenderPass(), this._renderer.renderTarget.pop(), this._renderer.globalUniforms.pop();
    }
    e._batchableRenderGroup._batcher.updateElement(e._batchableRenderGroup), e._batchableRenderGroup._batcher.geometry.buffers[0].update();
  }
  _executeDirect(e) {
    this._renderer.globalUniforms.push({
      worldTransformMatrix: e.inverseParentTextureTransform,
      worldColor: e.worldColorAlpha
    }), c0(e, this._renderer.renderPipes), this._renderer.globalUniforms.pop();
  }
}
ky.extension = {
  type: [
    Ie.WebGLPipes,
    Ie.WebGPUPipes,
    Ie.CanvasPipes
  ],
  name: "renderGroup"
};
const BZ = "#808080", mh = new st(), FZ = new st(), NZ = new st(), Hg = new st(), UZ = new st();
function GZ(i, e, t) {
  i.beginPath();
  for (let n = 0; n < t.length; n += 3) {
    const s = t[n] * 2, o = t[n + 1] * 2, r = t[n + 2] * 2;
    i.moveTo(e[s], e[s + 1]), i.lineTo(e[o], e[o + 1]), i.lineTo(e[r], e[r + 1]), i.closePath();
  }
  i.fill();
}
function jZ(i) {
  return `#${(i & 16777215).toString(16).padStart(6, "0")}`;
}
function HZ(i, e, t, n, s, o) {
  o = Math.max(0, Math.min(o, Math.min(n, s) / 2)), i.moveTo(e + o, t), i.lineTo(e + n - o, t), i.quadraticCurveTo(e + n, t, e + n, t + o), i.lineTo(e + n, t + s - o), i.quadraticCurveTo(e + n, t + s, e + n - o, t + s), i.lineTo(e + o, t + s), i.quadraticCurveTo(e, t + s, e, t + s - o), i.lineTo(e, t + o), i.quadraticCurveTo(e, t, e + o, t);
}
function kp(i, e) {
  switch (e.type) {
    case "rectangle": {
      const t = e;
      i.rect(t.x, t.y, t.width, t.height);
      break;
    }
    case "roundedRectangle": {
      const t = e;
      HZ(i, t.x, t.y, t.width, t.height, t.radius);
      break;
    }
    case "circle": {
      const t = e;
      i.arc(t.x, t.y, t.radius, 0, Math.PI * 2);
      break;
    }
    case "ellipse": {
      const t = e;
      i.ellipse ? i.ellipse(t.x, t.y, t.halfWidth, t.halfHeight, 0, 0, Math.PI * 2) : (i.save(), i.translate(t.x, t.y), i.scale(t.halfWidth, t.halfHeight), i.arc(0, 0, 1, 0, Math.PI * 2), i.restore());
      break;
    }
    case "triangle": {
      const t = e;
      i.moveTo(t.x, t.y), i.lineTo(t.x2, t.y2), i.lineTo(t.x3, t.y3), i.closePath();
      break;
    }
    default: {
      const t = e, n = t.points;
      if (!(n != null && n.length)) break;
      i.moveTo(n[0], n[1]);
      for (let s = 2; s < n.length; s += 2)
        i.lineTo(n[s], n[s + 1]);
      t.closePath && i.closePath();
      break;
    }
  }
}
function VZ(i, e) {
  if (!(e != null && e.length)) return !1;
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    if (!(n != null && n.shape)) continue;
    const s = n.transform, o = s && !s.isIdentity();
    o && (i.save(), i.transform(s.a, s.b, s.c, s.d, s.tx, s.ty)), kp(i, n.shape), o && i.restore();
  }
  return !0;
}
function WZ(i, e, t, n) {
  const s = i.fill;
  if (s instanceof Jl) {
    s.buildGradient();
    const r = s.texture;
    if (r) {
      const a = _t.getTintedPattern(r, e), l = t ? Hg.copyFrom(t).scale(r.source.pixelWidth, r.source.pixelHeight) : Hg.copyFrom(s.transform);
      return n && !i.textureSpace && l.append(n), _t.applyPatternTransform(a, l), a;
    }
  }
  if (s instanceof OM) {
    const r = _t.getTintedPattern(s.texture, e);
    return _t.applyPatternTransform(r, s.transform, !1), r;
  }
  const o = i.texture;
  if (o && o !== et.WHITE) {
    if (!o.source.resource)
      return BZ;
    const r = _t.getTintedPattern(o, e);
    let a = i.matrix;
    if (t) {
      const { resolution: l } = o.source;
      if (a = Hg.copyFrom(t), o.rotate) {
        const { uvs: d, orig: c } = o;
        a.prepend(UZ.set(
          d.x1 - d.x0,
          d.y1 - d.y0,
          d.x3 - d.x0,
          d.y3 - d.y0,
          d.x0,
          d.y0
        ).invert()).scale(c.width * l, c.height * l);
      } else
        a.scale(o.source.pixelWidth, o.source.pixelHeight).translate(-o.frame.x * l, -o.frame.y * l);
    }
    return _t.applyPatternTransform(r, a), r;
  }
  return jZ(e);
}
class aT {
  constructor() {
    this.shader = null;
  }
  contextChange(e) {
  }
  execute(e, t) {
    var S, M, _, T, k, P, A, R, D, O, F, te;
    const n = e.renderer, s = n.canvasContext, o = s.activeContext, r = t.groupTransform, a = (M = (S = n.globalUniforms.globalUniformData) == null ? void 0 : S.worldColor) != null ? M : 4294967295, l = t.groupColorAlpha, d = (a >>> 24 & 255) / 255, c = (l >>> 24 & 255) / 255, h = (T = (_ = n.filter) == null ? void 0 : _.alphaMultiplier) != null ? T : 1, f = d * c * h;
    if (f <= 0) return;
    const p = a & 16777215, y = l & 16777215, v = sa(ia(y, p)), x = n._roundPixels | t._roundPixels;
    o.save(), s.setContextTransform(r, x === 1), s.setBlendMode(t.groupBlendMode);
    const w = t.context.instructions;
    for (let ee = 0; ee < w.length; ee++) {
      const me = w[ee];
      if (me.action === "texture") {
        const Y = me.data, H = Y.image, re = H ? _t.getCanvasSource(H) : null;
        if (!re) continue;
        const le = Y.alpha * f;
        if (le <= 0) continue;
        const he = ia(Y.style, v);
        o.globalAlpha = le;
        let Re = re;
        he !== 16777215 && (Re = _t.getTintedCanvas({ texture: H }, he));
        const Ne = H.frame, Me = (P = (k = H.source._resolution) != null ? k : H.source.resolution) != null ? P : 1;
        let ue = Ne.x * Me, U = Ne.y * Me;
        const q = Ne.width * Me, ie = Ne.height * Me;
        Re !== re && (ue = 0, U = 0);
        const de = Y.transform, pe = de && !de.isIdentity(), Te = H.rotate;
        pe || Te ? (mh.copyFrom(r), pe && mh.append(de), Te && Mt.matrixAppendRotationInv(mh, Te, Y.dx, Y.dy, Y.dw, Y.dh), s.setContextTransform(mh, x === 1)) : s.setContextTransform(r, x === 1), o.drawImage(
          Re,
          ue,
          U,
          Re === re ? q : Re.width,
          Re === re ? ie : Re.height,
          Te ? 0 : Y.dx,
          Te ? 0 : Y.dy,
          Y.dw,
          Y.dh
        ), (pe || Te) && s.setContextTransform(r, x === 1);
        continue;
      }
      const L = me.data, N = (A = L == null ? void 0 : L.path) == null ? void 0 : A.shapePath;
      if (!((R = N == null ? void 0 : N.shapePrimitives) != null && R.length)) continue;
      const X = L.style, B = ia(X.color, v), se = X.alpha * f;
      if (se <= 0) continue;
      const V = me.action === "stroke";
      if (o.globalAlpha = se, V) {
        const Y = X;
        o.lineWidth = Y.width, o.lineCap = Y.cap, o.lineJoin = Y.join, o.miterLimit = Y.miterLimit;
      }
      const Z = N.shapePrimitives;
      if (!V && ((F = (O = (D = L.hole) == null ? void 0 : D.shapePath) == null ? void 0 : O.shapePrimitives) != null && F.length)) {
        const Y = Z[Z.length - 1];
        Y.holes = L.hole.shapePath.shapePrimitives;
      }
      for (let Y = 0; Y < Z.length; Y++) {
        const H = Z[Y];
        if (!(H != null && H.shape)) continue;
        const re = H.transform, le = re && !re.isIdentity(), he = X.texture && X.texture !== et.WHITE, Re = X.textureSpace === "global" ? re : null, Ne = he ? AM(FZ, X, H.shape, Re) : null, Me = le ? NZ.copyFrom(r).append(re) : r, ue = WZ(
          X,
          B,
          Ne,
          Me
        );
        if (le && (o.save(), o.transform(re.a, re.b, re.c, re.d, re.tx, re.ty)), V) {
          const U = X;
          if (U.alignment !== 0.5 && !U.pixelLine) {
            const ie = [], de = [], pe = [], Te = Zl[H.shape.type];
            if (Te != null && Te.build(H.shape, ie)) {
              const Be = (te = H.shape.closePath) != null ? te : !0;
              cy(ie, U, !1, Be, de, pe), o.fillStyle = ue, GZ(o, de, pe);
            } else
              o.strokeStyle = ue, o.beginPath(), kp(o, H.shape), o.stroke();
          } else
            o.strokeStyle = ue, o.beginPath(), kp(o, H.shape), o.stroke();
        } else
          o.fillStyle = ue, o.beginPath(), kp(o, H.shape), VZ(o, H.holes) ? o.fill("evenodd") : o.fill();
        le && o.restore();
      }
    }
    o.restore();
  }
  destroy() {
    this.shader = null;
  }
}
aT.extension = {
  type: [
    Ie.CanvasPipesAdaptor
  ],
  name: "graphics"
};
class _y {
  constructor(e) {
    this._renderer = e;
  }
  addRenderable(e, t) {
    const n = this._getGpuSprite(e);
    e.didViewUpdate && this._updateBatchableSprite(e, n), this._renderer.renderPipes.batch.addToBatch(n, t);
  }
  updateRenderable(e) {
    const t = this._getGpuSprite(e);
    e.didViewUpdate && this._updateBatchableSprite(e, t), t._batcher.updateElement(t);
  }
  validateRenderable(e) {
    const t = this._getGpuSprite(e);
    return !t._batcher.checkAndUpdateTexture(
      t,
      e._texture
    );
  }
  _updateBatchableSprite(e, t) {
    t.bounds = e.visualBounds, t.texture = e._texture;
  }
  _getGpuSprite(e) {
    return e._gpuData[this._renderer.uid] || this._initGPUSprite(e);
  }
  _initGPUSprite(e) {
    const t = new XM();
    return t.renderable = e, t.transform = e.groupTransform, t.texture = e._texture, t.bounds = e.visualBounds, t.roundPixels = this._renderer._roundPixels | e._roundPixels, e._gpuData[this._renderer.uid] = t, t;
  }
  destroy() {
    this._renderer = null;
  }
}
_y.extension = {
  type: [
    Ie.WebGLPipes,
    Ie.WebGPUPipes,
    Ie.CanvasPipes
  ],
  name: "sprite"
};
const wc = {};
ht.handle(Ie.BlendMode, (i) => {
  if (!i.name)
    throw new Error("BlendMode extension must have a name property");
  wc[i.name] = i.ref;
}, (i) => {
  delete wc[i.name];
});
class Sy {
  constructor(e) {
    this._blendModeStack = [], this._isAdvanced = !1, this._filterHash = /* @__PURE__ */ Object.create(null), this._renderer = e, this._renderer.runners.prerender.add(this);
  }
  prerender() {
    this._activeBlendMode = "normal", this._isAdvanced = !1;
  }
  /**
   * Push a blend mode onto the internal stack and apply it to the instruction set if needed.
   * @param renderable - The renderable or {@link RenderGroup} associated with the change.
   * @param blendMode - The blend mode to activate.
   * @param instructionSet - The instruction set being built.
   */
  pushBlendMode(e, t, n) {
    this._blendModeStack.push(t), this.setBlendMode(e, t, n);
  }
  /**
   * Pop the last blend mode from the stack and apply the new top-of-stack mode.
   * @param instructionSet - The instruction set being built.
   */
  popBlendMode(e) {
    var n;
    this._blendModeStack.pop();
    const t = (n = this._blendModeStack[this._activeBlendMode.length - 1]) != null ? n : "normal";
    this.setBlendMode(null, t, e);
  }
  /**
   * Ensure a blend mode switch is added to the instruction set when the mode changes.
   * If an advanced blend mode is active, subsequent renderables will be collected so they can be
   * rendered within a single filter pass.
   * @param renderable - The renderable or {@link RenderGroup} to associate with the change, or null when unwinding.
   * @param blendMode - The target blend mode.
   * @param instructionSet - The instruction set being built.
   */
  setBlendMode(e, t, n) {
    var o;
    const s = e instanceof jv;
    if (this._activeBlendMode === t) {
      this._isAdvanced && e && !s && ((o = this._renderableList) == null || o.push(e));
      return;
    }
    this._isAdvanced && this._endAdvancedBlendMode(n), this._activeBlendMode = t, e && (this._isAdvanced = !!wc[t], this._isAdvanced && this._beginAdvancedBlendMode(e, n));
  }
  _beginAdvancedBlendMode(e, t) {
    this._renderer.renderPipes.batch.break(t);
    const n = this._activeBlendMode;
    if (!wc[n]) {
      dt(`Unable to assign BlendMode: '${n}'. You may want to include: import 'pixi.js/advanced-blend-modes'`);
      return;
    }
    const s = this._ensureFilterEffect(n), o = e instanceof jv, r = {
      renderPipeId: "filter",
      action: "pushFilter",
      filterEffect: s,
      renderables: o ? null : [e],
      container: o ? e.root : null,
      canBundle: !1
    };
    this._renderableList = r.renderables, t.add(r);
  }
  _ensureFilterEffect(e) {
    let t = this._filterHash[e];
    return t || (t = this._filterHash[e] = new uf(), t.filters = [new wc[e]()]), t;
  }
  _endAdvancedBlendMode(e) {
    this._isAdvanced = !1, this._renderableList = null, this._renderer.renderPipes.batch.break(e), e.add({
      renderPipeId: "filter",
      action: "popFilter",
      canBundle: !1
    });
  }
  /**
   * called when the instruction build process is starting this will reset internally to the default blend mode
   * @internal
   */
  buildStart() {
    this._isAdvanced = !1;
  }
  /**
   * called when the instruction build process is finished, ensuring that if there is an advanced blend mode
   * active, we add the final render instructions added to the instruction set
   * @param instructionSet - The instruction set we are adding to
   * @internal
   */
  buildEnd(e) {
    this._isAdvanced && this._endAdvancedBlendMode(e);
  }
  /** @internal */
  destroy() {
    this._renderer = null, this._renderableList = null;
    for (const e in this._filterHash)
      this._filterHash[e].destroy();
    this._filterHash = null;
  }
}
Sy.extension = {
  type: [
    Ie.WebGLPipes,
    Ie.WebGPUPipes,
    Ie.CanvasPipes
  ],
  name: "blendMode"
};
function u0(i, e) {
  e || (e = 0);
  for (let t = e; t < i.length && i[t]; t++)
    i[t] = null;
}
const qZ = new mn(), $2 = bc | pf | J1;
function lT(i, e = !1) {
  KZ(i);
  const t = i.childrenToUpdate, n = i.updateTick++;
  for (const s in t) {
    const o = Number(s), r = t[s], a = r.list, l = r.index;
    for (let d = 0; d < l; d++) {
      const c = a[d];
      c.parentRenderGroup === i && c.relativeRenderGroupDepth === o && dT(c, n, 0);
    }
    u0(a, l), r.index = 0;
  }
  if (e)
    for (let s = 0; s < i.renderGroupChildren.length; s++)
      lT(i.renderGroupChildren[s], e);
}
function KZ(i) {
  const e = i.root;
  let t;
  if (i.renderGroupParent) {
    const n = i.renderGroupParent;
    i.worldTransform.appendFrom(
      e.relativeGroupTransform,
      n.worldTransform
    ), i.worldColor = hf(
      e.groupColor,
      n.worldColor
    ), t = e.groupAlpha * n.worldAlpha;
  } else
    i.worldTransform.copyFrom(e.localTransform), i.worldColor = e.localColor, t = e.localAlpha;
  t = t < 0 ? 0 : t > 1 ? 1 : t, i.worldAlpha = t, i.worldColorAlpha = i.worldColor + ((t * 255 | 0) << 24);
}
function dT(i, e, t) {
  if (e === i.updateTick) return;
  i.updateTick = e, i.didChange = !1;
  const n = i.localTransform;
  i.updateLocalTransform();
  const s = i.parent;
  if (s && !s.renderGroup ? (t |= i._updateFlags, i.relativeGroupTransform.appendFrom(
    n,
    s.relativeGroupTransform
  ), t & $2 && D2(i, s, t)) : (t = i._updateFlags, i.relativeGroupTransform.copyFrom(n), t & $2 && D2(i, qZ, t)), !i.renderGroup) {
    const o = i.children, r = o.length;
    for (let d = 0; d < r; d++)
      dT(o[d], e, t);
    const a = i.parentRenderGroup, l = i;
    l.renderPipeId && !a.structureDidChange && a.updateRenderable(l);
  }
}
function D2(i, e, t) {
  if (t & pf) {
    i.groupColor = hf(
      i.localColor,
      e.groupColor
    );
    let n = i.localAlpha * e.groupAlpha;
    n = n < 0 ? 0 : n > 1 ? 1 : n, i.groupAlpha = n, i.groupColorAlpha = i.groupColor + ((n * 255 | 0) << 24);
  }
  t & J1 && (i.groupBlendMode = i.localBlendMode === "inherit" ? e.groupBlendMode : i.localBlendMode), t & bc && (i.globalDisplayStatus = i.localDisplayStatus & e.globalDisplayStatus), i._updateFlags = 0;
}
function YZ(i, e) {
  const { list: t } = i.childrenRenderablesToUpdate;
  let n = !1;
  for (let s = 0; s < i.childrenRenderablesToUpdate.index; s++) {
    const o = t[s];
    if (n = e[o.renderPipeId].validateRenderable(o), n)
      break;
  }
  return i.structureDidChange = n, n;
}
const XZ = new st();
class cT {
  constructor(e) {
    this._renderer = e;
  }
  render({ container: e, transform: t }) {
    const n = e.parent, s = e.renderGroup.renderGroupParent;
    e.parent = null, e.renderGroup.renderGroupParent = null;
    const o = this._renderer, r = XZ;
    t && (r.copyFrom(e.renderGroup.localTransform), e.renderGroup.localTransform.copyFrom(t));
    const a = o.renderPipes;
    this._updateCachedRenderGroups(e.renderGroup, null), this._updateRenderGroups(e.renderGroup), o.globalUniforms.start({
      worldTransformMatrix: t ? e.renderGroup.localTransform : e.renderGroup.worldTransform,
      worldColor: e.renderGroup.worldColorAlpha
    }), c0(e.renderGroup, a), a.uniformBatch && a.uniformBatch.renderEnd(), t && e.renderGroup.localTransform.copyFrom(r), e.parent = n, e.renderGroup.renderGroupParent = s;
  }
  destroy() {
    this._renderer = null;
  }
  _updateCachedRenderGroups(e, t) {
    var n, s;
    if (e._parentCacheAsTextureRenderGroup = t, e.isCachedAsTexture) {
      if (!e.textureNeedsUpdate) return;
      t = e;
    }
    for (let o = e.renderGroupChildren.length - 1; o >= 0; o--)
      this._updateCachedRenderGroups(e.renderGroupChildren[o], t);
    if (e.invalidateMatrices(), e.isCachedAsTexture) {
      if (e.textureNeedsUpdate) {
        const o = e.root.getLocalBounds(), r = this._renderer, a = e.textureOptions.resolution || r.view.resolution, l = (n = e.textureOptions.antialias) != null ? n : r.view.antialias, d = (s = e.textureOptions.scaleMode) != null ? s : "linear", c = e.texture;
        o.ceil(), e.texture && Nn.returnTexture(e.texture);
        const h = Nn.getOptimalTexture({
          width: o.width,
          height: o.height,
          resolution: a,
          antialias: l,
          scaleMode: d
        });
        e.texture = h, e._textureBounds || (e._textureBounds = new Gn()), e._textureBounds.copyFrom(o), c !== e.texture && e.renderGroupParent && (e.renderGroupParent.structureDidChange = !0);
      }
    } else e.texture && (Nn.returnTexture(e.texture), e.texture = null);
  }
  _updateRenderGroups(e) {
    const t = this._renderer, n = t.renderPipes;
    if (e.runOnRender(t), e.instructionSet.renderPipes = n, e.structureDidChange ? u0(e.childrenRenderablesToUpdate.list, 0) : YZ(e, n), lT(e), e.structureDidChange ? (e.structureDidChange = !1, this._buildInstructions(e, t)) : this._updateRenderables(e), e.childrenRenderablesToUpdate.index = 0, t.renderPipes.batch.upload(e.instructionSet), !(e.isCachedAsTexture && !e.textureNeedsUpdate))
      for (let s = 0; s < e.renderGroupChildren.length; s++)
        this._updateRenderGroups(e.renderGroupChildren[s]);
  }
  _updateRenderables(e) {
    const { list: t, index: n } = e.childrenRenderablesToUpdate;
    for (let s = 0; s < n; s++) {
      const o = t[s];
      o.didViewUpdate && e.updateRenderable(o);
    }
    u0(t, n);
  }
  _buildInstructions(e, t) {
    const n = e.root, s = e.instructionSet;
    s.reset();
    const o = t.renderPipes ? t : t.batch.renderer, r = o.renderPipes;
    r.batch.buildStart(s), r.blendMode.buildStart(), r.colorMask.buildStart(), n.sortableChildren && n.sortChildren(), n.collectRenderablesWithEffects(s, o, null), r.batch.buildEnd(s), r.blendMode.buildEnd(s);
  }
}
cT.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem,
    Ie.CanvasSystem
  ],
  name: "renderGroup"
};
const My = class uT {
  constructor() {
    this.clearBeforeRender = !0, this._backgroundColor = new bn(0), this.color = this._backgroundColor, this.alpha = 1;
  }
  /**
   * initiates the background system
   * @param options - the options for the background colors
   */
  init(e) {
    e = { ...uT.defaultOptions, ...e }, this.clearBeforeRender = e.clearBeforeRender, this.color = e.background || e.backgroundColor || this._backgroundColor, this.alpha = e.backgroundAlpha, this._backgroundColor.setAlpha(e.backgroundAlpha);
  }
  /** The background color to fill if not transparent */
  get color() {
    return this._backgroundColor;
  }
  set color(e) {
    bn.shared.setValue(e).alpha < 1 && this._backgroundColor.alpha === 1 && dt(
      "Cannot set a transparent background on an opaque canvas. To enable transparency, set backgroundAlpha < 1 when initializing your Application."
    ), this._backgroundColor.setValue(e);
  }
  /** The background color alpha. Setting this to 0 will make the canvas transparent. */
  get alpha() {
    return this._backgroundColor.alpha;
  }
  set alpha(e) {
    this._backgroundColor.setAlpha(e);
  }
  /** The background color as an [R, G, B, A] array. */
  get colorRgba() {
    return this._backgroundColor.toArray();
  }
  /**
   * destroys the background system
   * @internal
   */
  destroy() {
  }
};
My.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem,
    Ie.CanvasSystem
  ],
  name: "background",
  priority: 0
};
My.defaultOptions = {
  /**
   * {@link WebGLOptions.backgroundAlpha}
   * @default 1
   */
  backgroundAlpha: 1,
  /**
   * {@link WebGLOptions.backgroundColor}
   * @default 0x000000
   */
  backgroundColor: 0,
  /**
   * {@link WebGLOptions.clearBeforeRender}
   * @default true
   */
  clearBeforeRender: !0
};
let JZ = My;
const Vg = {
  png: "image/png",
  jpg: "image/jpeg",
  webp: "image/webp"
}, Ty = class hT {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._renderer = e;
  }
  _normalizeOptions(e, t = {}) {
    return e instanceof mn || e instanceof et ? {
      target: e,
      ...t
    } : {
      ...t,
      ...e
    };
  }
  /**
   * Creates an IImage from a display object or texture.
   * @param options - Options for creating the image, or the target to extract
   * @returns Promise that resolves with the generated IImage
   * @example
   * ```ts
   * // Basic usage with a sprite
   * const sprite = new Sprite(texture);
   * const image = await renderer.extract.image(sprite);
   * document.body.appendChild(image);
   *
   * // Advanced usage with options
   * const image = await renderer.extract.image({
   *     target: container,
   *     format: 'webp',
   *     quality: 0.8,
   *     frame: new Rectangle(0, 0, 100, 100),
   *     resolution: 2,
   *     clearColor: '#ff0000',
   *     antialias: true
   * });
   *
   * // Extract directly from a texture
   * const texture = Texture.from('myTexture.png');
   * const image = await renderer.extract.image(texture);
   * ```
   * @see {@link ExtractImageOptions} For detailed options
   * @see {@link ExtractSystem.base64} For base64 string output
   * @see {@link ExtractSystem.canvas} For canvas output
   * @see {@link ImageLike} For the image interface
   * @category rendering
   */
  async image(e) {
    const t = zt.get().createImage();
    return t.src = await this.base64(e), t;
  }
  /**
   * Converts the target into a base64 encoded string.
   *
   * This method works by first creating
   * a canvas using `Extract.canvas` and then converting it to a base64 string.
   * @param options - The options for creating the base64 string, or the target to extract
   * @returns Promise that resolves with the base64 encoded string
   * @example
   * ```ts
   * // Basic usage with a sprite
   * const sprite = new Sprite(texture);
   * const base64 = await renderer.extract.base64(sprite);
   * console.log(base64); // data:image/png;base64,...
   *
   * // Advanced usage with options
   * const base64 = await renderer.extract.base64({
   *     target: container,
   *     format: 'webp',
   *     quality: 0.8,
   *     frame: new Rectangle(0, 0, 100, 100),
   *     resolution: 2
   * });
   * ```
   * @throws Will throw an error if the platform doesn't support any of:
   * - ICanvas.toDataURL
   * - ICanvas.toBlob
   * - ICanvas.convertToBlob
   * @see {@link ExtractImageOptions} For detailed options
   * @see {@link ExtractSystem.canvas} For canvas output
   * @see {@link ExtractSystem.image} For HTMLImage output
   * @category rendering
   */
  async base64(e) {
    e = this._normalizeOptions(
      e,
      hT.defaultImageOptions
    );
    const { format: t, quality: n } = e, s = this.canvas(e);
    if (s.toBlob !== void 0)
      return new Promise((o, r) => {
        s.toBlob((a) => {
          if (!a) {
            r(new Error("ICanvas.toBlob failed!"));
            return;
          }
          const l = new FileReader();
          l.onload = () => o(l.result), l.onerror = r, l.readAsDataURL(a);
        }, Vg[t], n);
      });
    if (s.toDataURL !== void 0)
      return s.toDataURL(Vg[t], n);
    if (s.convertToBlob !== void 0) {
      const o = await s.convertToBlob({ type: Vg[t], quality: n });
      return new Promise((r, a) => {
        const l = new FileReader();
        l.onload = () => r(l.result), l.onerror = a, l.readAsDataURL(o);
      });
    }
    throw new Error("Extract.base64() requires ICanvas.toDataURL, ICanvas.toBlob, or ICanvas.convertToBlob to be implemented");
  }
  /**
   * Creates a Canvas element, renders the target to it and returns it.
   * This method is useful for creating static images or when you need direct canvas access.
   * @param options - The options for creating the canvas, or the target to extract
   * @returns A Canvas element with the texture rendered on
   * @example
   * ```ts
   * // Basic canvas extraction from a sprite
   * const sprite = new Sprite(texture);
   * const canvas = renderer.extract.canvas(sprite);
   * document.body.appendChild(canvas);
   *
   * // Extract with custom region
   * const canvas = renderer.extract.canvas({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const canvas = renderer.extract.canvas({
   *     target: sprite,
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Extract directly from a texture
   * const texture = Texture.from('myTexture.png');
   * const canvas = renderer.extract.canvas(texture);
   *
   * // Extract with anti-aliasing
   * const canvas = renderer.extract.canvas({
   *     target: graphics,
   *     antialias: true
   * });
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link ExtractSystem.image} For HTMLImage output
   * @see {@link ExtractSystem.pixels} For raw pixel data
   * @category rendering
   */
  canvas(e) {
    e = this._normalizeOptions(e);
    const t = e.target, n = this._renderer;
    if (t instanceof et)
      return n.texture.generateCanvas(t);
    const s = n.textureGenerator.generateTexture(e), o = n.texture.generateCanvas(s);
    return s.destroy(!0), o;
  }
  /**
   * Returns a one-dimensional array containing the pixel data of the entire texture in RGBA order,
   * with integer values between 0 and 255 (inclusive).
   * > [!NOE] The returned array is a flat Uint8Array where every 4 values represent RGBA
   * @param options - The options for extracting the image, or the target to extract
   * @returns One-dimensional Uint8Array containing the pixel data in RGBA format
   * @example
   * ```ts
   * // Basic pixel extraction
   * const sprite = new Sprite(texture);
   * const pixels = renderer.extract.pixels(sprite);
   * console.log(pixels[0], pixels[1], pixels[2], pixels[3]); // R,G,B,A values
   *
   * // Extract with custom region
   * const pixels = renderer.extract.pixels({
   *     target: sprite,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const pixels = renderer.extract.pixels({
   *     target: sprite,
   *     resolution: 2
   * });
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link ExtractSystem.canvas} For canvas output
   * @see {@link ExtractSystem.image} For image output
   * @category rendering
   */
  pixels(e) {
    e = this._normalizeOptions(e);
    const t = e.target, n = this._renderer, s = t instanceof et ? t : n.textureGenerator.generateTexture(e), o = n.texture.getPixels(s);
    return t instanceof mn && s.destroy(!0), o;
  }
  /**
   * Creates a texture from a display object or existing texture.
   *
   * This is useful for creating
   * reusable textures from rendered content or making copies of existing textures.
   * > [!NOTE] The returned texture should be destroyed when no longer needed
   * @param options - The options for creating the texture, or the target to extract
   * @returns A new texture containing the extracted content
   * @example
   * ```ts
   * // Basic texture extraction from a sprite
   * const sprite = new Sprite(texture);
   * const extractedTexture = renderer.extract.texture(sprite);
   *
   * // Extract with custom region
   * const regionTexture = renderer.extract.texture({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Extract with high resolution
   * const hiResTexture = renderer.extract.texture({
   *     target: sprite,
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Create a new sprite from extracted texture
   * const newSprite = new Sprite(
   *     renderer.extract.texture({
   *         target: graphics,
   *         antialias: true
   *     })
   * );
   *
   * // Clean up when done
   * extractedTexture.destroy(true);
   * ```
   * @see {@link ExtractOptions} For detailed options
   * @see {@link Texture} For texture management
   * @see {@link GenerateTextureSystem} For texture generation
   * @category rendering
   */
  texture(e) {
    return e = this._normalizeOptions(e), e.target instanceof et ? e.target : this._renderer.textureGenerator.generateTexture(e);
  }
  /**
   * Extracts and downloads content from the renderer as an image file.
   * This is a convenient way to save screenshots or export rendered content.
   * > [!NOTE] The download will use PNG format regardless of the filename extension
   * @param options - The options for downloading and extracting the image, or the target to extract
   * @example
   * ```ts
   * // Basic download with default filename
   * const sprite = new Sprite(texture);
   * renderer.extract.download(sprite); // Downloads as 'image.png'
   *
   * // Download with custom filename
   * renderer.extract.download({
   *     target: sprite,
   *     filename: 'screenshot.png'
   * });
   *
   * // Download with custom region
   * renderer.extract.download({
   *     target: container,
   *     filename: 'region.png',
   *     frame: new Rectangle(0, 0, 100, 100)
   * });
   *
   * // Download with high resolution and background
   * renderer.extract.download({
   *     target: stage,
   *     filename: 'hd-screenshot.png',
   *     resolution: 2,
   *     clearColor: '#ff0000'
   * });
   *
   * // Download with anti-aliasing
   * renderer.extract.download({
   *     target: graphics,
   *     filename: 'smooth.png',
   *     antialias: true
   * });
   * ```
   * @see {@link ExtractDownloadOptions} For detailed options
   * @see {@link ExtractSystem.image} For creating images without download
   * @see {@link ExtractSystem.canvas} For canvas output
   * @category rendering
   */
  download(e) {
    var s;
    e = this._normalizeOptions(e);
    const t = this.canvas(e), n = document.createElement("a");
    n.download = (s = e.filename) != null ? s : "image.png", n.href = t.toDataURL("image/png"), document.body.appendChild(n), n.click(), document.body.removeChild(n);
  }
  /**
   * Logs the target to the console as an image. This is a useful way to debug what's happening in the renderer.
   * The image will be displayed in the browser's console using CSS background images.
   * @param options - The options for logging the image, or the target to log
   * @param options.width - The width of the logged image preview in the console (in pixels)
   * @example
   * ```ts
   * // Basic usage
   * const sprite = new Sprite(texture);
   * renderer.extract.log(sprite);
   * ```
   * @see {@link ExtractSystem.canvas} For getting raw canvas output
   * @see {@link ExtractSystem.pixels} For raw pixel data
   * @category rendering
   * @advanced
   */
  log(e) {
    var r;
    const t = (r = e.width) != null ? r : 200;
    e = this._normalizeOptions(e);
    const n = this.canvas(e), s = n.toDataURL();
    console.log(`[Pixi Texture] ${n.width}px ${n.height}px`);
    const o = [
      "font-size: 1px;",
      `padding: ${t}px 300px;`,
      `background: url(${s}) no-repeat;`,
      "background-size: contain;"
    ].join(" ");
    console.log("%c ", o);
  }
  destroy() {
    this._renderer = null;
  }
};
Ty.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem,
    Ie.CanvasSystem
  ],
  name: "extract"
};
Ty.defaultImageOptions = {
  format: "png",
  quality: 1
};
let ZZ = Ty;
class Cy extends et {
  /**
   * Creates a RenderTexture. Pass `dynamic: true` in options to allow resizing after creation.
   * @param options - Options for the RenderTexture, including width, height, textureOptions, and dynamic.
   * @returns A new RenderTexture instance.
   * @example
   * const textureOptions = { defaultAnchor: { x: 0.5, y: 0.5 } };
   * const rt = RenderTexture.create({ width: 100, height: 100, dynamic: true, textureOptions });
   * rt.resize(500, 500);
   */
  static create(e) {
    const { dynamic: t, textureOptions: n, ...s } = e;
    return new Cy({
      ...n,
      source: new un(s),
      dynamic: t != null ? t : !1
    });
  }
  /**
   * Resizes the render texture.
   * @param width - The new width of the render texture.
   * @param height - The new height of the render texture.
   * @param resolution - The new resolution of the render texture.
   * @returns This texture.
   */
  resize(e, t, n) {
    return this.source.resize(e, t, n), this;
  }
}
const QZ = new Tt(), eQ = new Gn(), tQ = [0, 0, 0, 0];
class pT {
  constructor(e) {
    this._renderer = e;
  }
  /**
   * Creates a texture from a display object that can be used for creating sprites and other textures.
   * This is particularly useful for optimizing performance when a complex container needs to be reused.
   * @param options - Generate texture options or a container to convert to texture
   * @returns A new RenderTexture containing the rendered display object
   * @example
   * ```ts
   * // Basic usage with a container
   * const container = new Container();
   * container.addChild(
   *     new Graphics()
   *         .circle(0, 0, 50)
   *         .fill('red')
   * );
   *
   * const texture = renderer.textureGenerator.generateTexture(container);
   *
   * // Advanced usage with options
   * const texture = renderer.textureGenerator.generateTexture({
   *     target: container,
   *     frame: new Rectangle(0, 0, 100, 100), // Specific region
   *     resolution: 2,                        // High DPI
   *     clearColor: '#ff0000',               // Red background
   *     antialias: true                      // Smooth edges
   * });
   *
   * // Create a sprite from the generated texture
   * const sprite = new Sprite(texture);
   *
   * // Clean up when done
   * texture.destroy(true);
   * ```
   * @see {@link GenerateTextureOptions} For detailed texture generation options
   * @see {@link RenderTexture} For the type of texture created
   * @category rendering
   */
  generateTexture(e) {
    var c;
    e instanceof mn && (e = {
      target: e,
      frame: void 0,
      textureSourceOptions: {},
      resolution: void 0
    });
    const t = e.resolution || this._renderer.resolution, n = e.antialias || this._renderer.view.antialias, s = e.target;
    let o = e.clearColor;
    o ? o = Array.isArray(o) && o.length === 4 ? o : bn.shared.setValue(o).toArray() : o = tQ;
    const r = ((c = e.frame) == null ? void 0 : c.copyTo(QZ)) || Y1(s, eQ).rectangle, a = e.defaultAnchor && {
      defaultAnchor: e.defaultAnchor
    };
    r.width = Math.max(r.width, 1 / t) | 0, r.height = Math.max(r.height, 1 / t) | 0;
    const l = Cy.create({
      ...e.textureSourceOptions,
      width: r.width,
      height: r.height,
      resolution: t,
      antialias: n,
      textureOptions: a
    }), d = st.shared.translate(-r.x, -r.y);
    return this._renderer.render({
      container: s,
      transform: d,
      target: l,
      clearColor: o
    }), l.source.updateMipmaps(), l;
  }
  destroy() {
    this._renderer = null;
  }
}
pT.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem,
    Ie.CanvasSystem
  ],
  name: "textureGenerator"
};
function nQ(i) {
  let e = !1;
  for (const n in i)
    if (i[n] == null) {
      e = !0;
      break;
    }
  if (!e) return i;
  const t = /* @__PURE__ */ Object.create(null);
  for (const n in i) {
    const s = i[n];
    s && (t[n] = s);
  }
  return t;
}
function iQ(i) {
  let e = 0;
  for (let t = 0; t < i.length; t++)
    i[t] == null ? e++ : i[t - e] = i[t];
  return i.length -= e, i;
}
const Iy = class fT {
  /**
   * Creates a new GCSystem instance.
   * @param renderer - The renderer this garbage collection system works for
   */
  constructor(e) {
    this._managedResources = [], this._managedResourceHashes = [], this._managedCollections = [], this._ready = !1, this._running = !1, this._renderer = e;
  }
  /**
   * Initializes the garbage collection system with the provided options.
   * @param options - Configuration options
   */
  init(e) {
    e = { ...fT.defaultOptions, ...e }, this.maxUnusedTime = e.gcMaxUnusedTime, this._frequency = e.gcFrequency, this.enabled = e.gcActive, this.now = performance.now();
  }
  /**
   * Gets whether the garbage collection system is currently enabled.
   * @returns True if GC is enabled, false otherwise
   */
  get enabled() {
    return !!this._handler;
  }
  /**
   * Enables or disables the garbage collection system.
   * When enabled, schedules periodic cleanup of resources.
   * When disabled, cancels all scheduled cleanups.
   */
  set enabled(e) {
    this.enabled !== e && (e ? (this._handler = this._renderer.scheduler.repeat(
      () => {
        this._ready = !0;
      },
      this._frequency,
      !1
    ), this._collectionsHandler = this._renderer.scheduler.repeat(
      () => {
        for (const t of this._managedCollections) {
          const { context: n, collection: s, type: o } = t;
          o === "hash" ? n[s] = nQ(n[s]) : n[s] = iQ(n[s]);
        }
      },
      this._frequency
    )) : (this._renderer.scheduler.cancel(this._handler), this._renderer.scheduler.cancel(this._collectionsHandler), this._handler = 0, this._collectionsHandler = 0));
  }
  /**
   * Called before rendering. Updates the current timestamp.
   * @param options - The render options
   * @param options.container - The container to render
   */
  prerender({ container: e }) {
    this.now = performance.now(), e.renderGroup.gcTick = this._renderer.tick++, this._updateInstructionGCTick(e.renderGroup, e.renderGroup.gcTick);
  }
  /** Performs garbage collection after rendering. */
  postrender() {
    !this._ready || !this.enabled || (this.run(), this._ready = !1);
  }
  /**
   * Updates the GC tick counter for a render group and its children.
   * @param renderGroup - The render group to update
   * @param gcTick - The new tick value
   */
  _updateInstructionGCTick(e, t) {
    e.instructionSet.gcTick = t, e.gcTick = t;
    for (const n of e.renderGroupChildren)
      this._updateInstructionGCTick(n, t);
  }
  /**
   * Registers a collection for garbage collection tracking.
   * @param context - The object containing the collection
   * @param collection - The property name on context that holds the collection
   * @param type - The type of collection to track ('hash' or 'array')
   */
  addCollection(e, t, n) {
    this._managedCollections.push({
      context: e,
      collection: t,
      type: n
    });
  }
  /**
   * Registers a resource for garbage collection tracking.
   * @param resource - The resource to track
   * @param type - The type of resource to track
   */
  addResource(e, t) {
    var s, o;
    if (e._gcLastUsed !== -1) {
      e._gcLastUsed = this.now, (s = e._onTouch) == null || s.call(e, this.now);
      return;
    }
    const n = this._managedResources.length;
    e._gcData = {
      index: n,
      type: t
    }, e._gcLastUsed = this.now, (o = e._onTouch) == null || o.call(e, this.now), e.once("unload", this.removeResource, this), this._managedResources.push(e);
  }
  /**
   * Removes a resource from garbage collection tracking.
   * Call this when manually destroying a resource.
   * @param resource - The resource to stop tracking
   */
  removeResource(e) {
    const t = e._gcData;
    if (!t) return;
    const n = t.index, s = this._managedResources.length - 1;
    if (this._running)
      this._managedResources[n] = null;
    else {
      if (n !== s) {
        const o = this._managedResources[s];
        this._managedResources[n] = o, o._gcData.index = n;
      }
      this._managedResources.length--;
    }
    e._gcData = null, e._gcLastUsed = -1;
  }
  /**
   * Registers a hash-based resource collection for garbage collection tracking.
   * Resources in the hash will be automatically tracked and cleaned up when unused.
   * @param context - The object containing the hash property
   * @param hash - The property name on context that holds the resource hash
   * @param type - The type of resources in the hash ('resource' or 'renderable')
   * @param priority - Processing priority (lower values are processed first)
   */
  addResourceHash(e, t, n, s = 0) {
    this._managedResourceHashes.push({
      context: e,
      hash: t,
      type: n,
      priority: s
    }), this._managedResourceHashes.sort((o, r) => o.priority - r.priority);
  }
  /**
   * Performs garbage collection by cleaning up unused resources.
   * Removes resources that haven't been used for longer than maxUnusedTime.
   */
  run() {
    if (this._running) return;
    const e = performance.now(), t = this._managedResourceHashes, n = this._managedResources;
    this._running = !0;
    try {
      for (const o of t)
        this.runOnHash(o, e);
      const s = n.length;
      for (let o = 0; o < s; o++) {
        const r = n[o];
        r && this.runOnResource(r, e);
      }
    } finally {
      let s = 0;
      for (let o = 0; o < n.length; o++) {
        const r = n[o];
        r && (s !== o && (n[s] = r, r._gcData.index = s), s++);
      }
      n.length = s, this._running = !1;
    }
  }
  updateRenderableGCTick(e, t) {
    var o, r, a, l, d;
    const n = (o = e.renderGroup) != null ? o : e.parentRenderGroup, s = (a = (r = n == null ? void 0 : n.instructionSet) == null ? void 0 : r.gcTick) != null ? a : -1;
    ((l = n == null ? void 0 : n.gcTick) != null ? l : 0) === s && (e._gcLastUsed = t, (d = e._onTouch) == null || d.call(e, t));
  }
  runOnResource(e, t) {
    e._gcData.type === "renderable" && this.updateRenderableGCTick(e, t), !(t - e._gcLastUsed < this.maxUnusedTime || !e.autoGarbageCollect) && (e.off("unload", this.removeResource, this), e.unload(), this.removeResource(e));
  }
  /**
   * Creates a clone of the hash, copying all non-null entries up to (but not including) the stop key.
   * @param hashValue - The original hash to clone from
   * @param stopKey - The key to stop at (exclusive)
   * @returns A new hash object with copied entries
   */
  _createHashClone(e, t) {
    const n = /* @__PURE__ */ Object.create(null);
    for (const s in e) {
      if (s === t) break;
      e[s] !== null && (n[s] = e[s]);
    }
    return n;
  }
  runOnHash(e, t) {
    var d, c;
    const { context: n, hash: s, type: o } = e, r = n[s];
    let a = null, l = 0;
    for (const h in r) {
      const f = r[h];
      if (f === null) {
        l++, l === 1e4 && !a && (a = this._createHashClone(r, h));
        continue;
      }
      if (f._gcLastUsed === -1) {
        f._gcLastUsed = t, (d = f._onTouch) == null || d.call(f, t), a && (a[h] = f);
        continue;
      }
      if (o === "renderable" && this.updateRenderableGCTick(f, t), !(t - f._gcLastUsed < this.maxUnusedTime) && f.autoGarbageCollect) {
        if (o === "renderable") {
          const y = f, v = (c = y.renderGroup) != null ? c : y.parentRenderGroup;
          v && (v.structureDidChange = !0);
        }
        f.unload(), f._gcData = null, f._gcLastUsed = -1, a || (l + 1 !== 1e4 ? (r[h] = null, l++) : a = this._createHashClone(r, h));
      } else a && (a[h] = f);
    }
    a && (n[s] = a);
  }
  /** Cleans up the garbage collection system. Disables GC and removes all tracked resources. */
  destroy() {
    this.enabled = !1, this._managedResources.forEach((e) => {
      e == null || e.off("unload", this.removeResource, this);
    }), this._managedResources.length = 0, this._managedResourceHashes.length = 0, this._managedCollections.length = 0, this._renderer = null;
  }
};
Iy.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem,
    Ie.CanvasSystem
  ],
  name: "gc",
  priority: 0
};
Iy.defaultOptions = {
  /** Enable/disable the garbage collector */
  gcActive: !0,
  /** Time in ms before an unused resource is collected (default 1 minute) */
  gcMaxUnusedTime: 6e4,
  /** How often to run garbage collection in ms (default 30 seconds) */
  gcFrequency: 3e4
};
let sQ = Iy;
class mT {
  constructor(e) {
    this._stackIndex = 0, this._globalUniformDataStack = [], this._uniformsPool = [], this._activeUniforms = [], this._bindGroupPool = [], this._activeBindGroups = [], this._renderer = e;
  }
  reset() {
    this._stackIndex = 0;
    for (let e = 0; e < this._activeUniforms.length; e++)
      this._uniformsPool.push(this._activeUniforms[e]);
    for (let e = 0; e < this._activeBindGroups.length; e++)
      this._bindGroupPool.push(this._activeBindGroups[e]);
    this._activeUniforms.length = 0, this._activeBindGroups.length = 0;
  }
  start(e) {
    this.reset(), this.push(e);
  }
  bind({
    size: e,
    projectionMatrix: t,
    worldTransformMatrix: n,
    worldColor: s,
    offset: o
  }) {
    const r = this._renderer.renderTarget.renderTarget, a = this._stackIndex ? this._globalUniformDataStack[this._stackIndex - 1] : {
      worldTransformMatrix: new st(),
      worldColor: 4294967295,
      offset: new Wt()
    }, l = {
      projectionMatrix: t || this._renderer.renderTarget.projectionMatrix,
      resolution: e || r.size,
      worldTransformMatrix: n || a.worldTransformMatrix,
      worldColor: s || a.worldColor,
      offset: o || a.offset,
      bindGroup: null
    }, d = this._uniformsPool.pop() || this._createUniforms();
    this._activeUniforms.push(d);
    const c = d.uniforms;
    c.uProjectionMatrix = l.projectionMatrix, c.uResolution = l.resolution, c.uWorldTransformMatrix.copyFrom(l.worldTransformMatrix), c.uWorldTransformMatrix.tx -= l.offset.x, c.uWorldTransformMatrix.ty -= l.offset.y, VM(
      l.worldColor,
      c.uWorldColorAlpha,
      0
    ), d.update();
    let h;
    this._renderer.renderPipes.uniformBatch ? h = this._renderer.renderPipes.uniformBatch.getUniformBindGroup(d, !1) : (h = this._bindGroupPool.pop() || new qo(), this._activeBindGroups.push(h), h.setResource(d, 0)), l.bindGroup = h, this._currentGlobalUniformData = l;
  }
  push(e) {
    this.bind(e), this._globalUniformDataStack[this._stackIndex++] = this._currentGlobalUniformData;
  }
  pop() {
    this._currentGlobalUniformData = this._globalUniformDataStack[--this._stackIndex - 1], this._renderer.type === rs.WEBGL && this._currentGlobalUniformData.bindGroup.resources[0].update();
  }
  get bindGroup() {
    return this._currentGlobalUniformData.bindGroup;
  }
  get globalUniformData() {
    return this._currentGlobalUniformData;
  }
  get uniformGroup() {
    return this._currentGlobalUniformData.bindGroup.resources[0];
  }
  _createUniforms() {
    return new Ts({
      uProjectionMatrix: { value: new st(), type: "mat3x3<f32>" },
      uWorldTransformMatrix: { value: new st(), type: "mat3x3<f32>" },
      // TODO - someone smart - set this to be a unorm8x4 rather than a vec4<f32>
      uWorldColorAlpha: { value: new Float32Array(4), type: "vec4<f32>" },
      uResolution: { value: [0, 0], type: "vec2<f32>" }
    }, {
      isStatic: !0
    });
  }
  destroy() {
    this._renderer = null, this._globalUniformDataStack.length = 0, this._uniformsPool.length = 0, this._activeUniforms.length = 0, this._bindGroupPool.length = 0, this._activeBindGroups.length = 0, this._currentGlobalUniformData = null;
  }
}
mT.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem,
    Ie.CanvasSystem
  ],
  name: "globalUniforms"
};
let oQ = 1;
class gT {
  constructor() {
    this._tasks = [], this._offset = 0;
  }
  /** Initializes the scheduler system and starts the ticker. */
  init() {
    Oi.system.add(this._update, this);
  }
  /**
   * Schedules a repeating task.
   * @param func - The function to execute.
   * @param duration - The interval duration in milliseconds.
   * @param useOffset - this will spread out tasks so that they do not all run at the same time
   * @returns The unique identifier for the scheduled task.
   */
  repeat(e, t, n = !0) {
    const s = oQ++;
    let o = 0;
    return n && (this._offset += 1e3, o = this._offset), this._tasks.push({
      func: e,
      duration: t,
      start: performance.now(),
      offset: o,
      last: performance.now(),
      repeat: !0,
      id: s
    }), s;
  }
  /**
   * Cancels a scheduled task.
   * @param id - The unique identifier of the task to cancel.
   */
  cancel(e) {
    for (let t = 0; t < this._tasks.length; t++)
      if (this._tasks[t].id === e) {
        this._tasks.splice(t, 1);
        return;
      }
  }
  /**
   * Updates and executes the scheduled tasks.
   * @private
   */
  _update() {
    const e = performance.now();
    for (let t = 0; t < this._tasks.length; t++) {
      const n = this._tasks[t];
      if (e - n.offset - n.last >= n.duration) {
        const s = e - n.start;
        n.func(s), n.last = e;
      }
    }
  }
  /**
   * Destroys the scheduler system and removes all tasks.
   * @internal
   */
  destroy() {
    Oi.system.remove(this._update, this), this._tasks.length = 0;
  }
}
gT.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem,
    Ie.CanvasSystem
  ],
  name: "scheduler",
  priority: 0
};
let O2 = !1;
function rQ(i) {
  if (!O2) {
    if (zt.get().getNavigator().userAgent.toLowerCase().indexOf("chrome") > -1) {
      const e = [
        `%c  %c  %c  %c  %c PixiJS %c v${gf} (${i}) http://www.pixijs.com/

`,
        "background: #E72264; padding:5px 0;",
        "background: #6CA2EA; padding:5px 0;",
        "background: #B5D33D; padding:5px 0;",
        "background: #FED23F; padding:5px 0;",
        "color: #FFFFFF; background: #E72264; padding:5px 0;",
        "color: #E72264; background: #FFFFFF; padding:5px 0;"
      ];
      globalThis.console.log(...e);
    } else globalThis.console && globalThis.console.log(`PixiJS ${gf} - ${i} - http://www.pixijs.com/`);
    O2 = !0;
  }
}
class Ay {
  constructor(e) {
    this._renderer = e;
  }
  /**
   * It all starts here! This initiates every system, passing in the options for any system by name.
   * @param options - the config for the renderer and all its systems
   */
  init(e) {
    if (e.hello) {
      let t = this._renderer.name;
      this._renderer.type === rs.WEBGL && (t += ` ${this._renderer.context.webGLVersion}`), rQ(t);
    }
  }
}
Ay.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem,
    Ie.CanvasSystem
  ],
  name: "hello",
  priority: -2
};
Ay.defaultOptions = {
  /** {@link WebGLOptions.hello} */
  hello: !1
};
const Py = class bT {
  /**
   * Creates a new RenderableGCSystem instance.
   * @param renderer - The renderer this garbage collection system works for
   */
  constructor(e) {
    this._renderer = e;
  }
  /**
   * Initializes the garbage collection system with the provided options.
   * @param options - Configuration options for the renderer
   */
  init(e) {
    e = { ...bT.defaultOptions, ...e }, this.maxUnusedTime = e.renderableGCMaxUnusedTime;
  }
  /**
   * Gets whether the garbage collection system is currently enabled.
   * @returns True if GC is enabled, false otherwise
   */
  get enabled() {
    return rt("8.15.0", "RenderableGCSystem.enabled is deprecated, please use the GCSystem.enabled instead."), this._renderer.gc.enabled;
  }
  /**
   * Enables or disables the garbage collection system.
   * When enabled, schedules periodic cleanup of resources.
   * When disabled, cancels all scheduled cleanups.
   */
  set enabled(e) {
    rt("8.15.0", "RenderableGCSystem.enabled is deprecated, please use the GCSystem.enabled instead."), this._renderer.gc.enabled = e;
  }
  /**
   * Adds a hash table to be managed by the garbage collector.
   * @param context - The object containing the hash table
   * @param hash - The property name of the hash table
   */
  addManagedHash(e, t) {
    rt("8.15.0", "RenderableGCSystem.addManagedHash is deprecated, please use the GCSystem.addCollection instead."), this._renderer.gc.addCollection(e, t, "hash");
  }
  /**
   * Adds an array to be managed by the garbage collector.
   * @param context - The object containing the array
   * @param hash - The property name of the array
   */
  addManagedArray(e, t) {
    rt("8.15.0", "RenderableGCSystem.addManagedArray is deprecated, please use the GCSystem.addCollection instead."), this._renderer.gc.addCollection(e, t, "array");
  }
  /**
   * Starts tracking a renderable for garbage collection.
   * @param _renderable - The renderable to track
   * @deprecated since 8.15.0
   */
  addRenderable(e) {
    rt("8.15.0", "RenderableGCSystem.addRenderable is deprecated, please use the GCSystem instead."), this._renderer.gc.addResource(e, "renderable");
  }
  /**
   * Performs garbage collection by cleaning up unused renderables.
   * Removes renderables that haven't been used for longer than maxUnusedTime.
   */
  run() {
    rt("8.15.0", "RenderableGCSystem.run is deprecated, please use the GCSystem instead."), this._renderer.gc.run();
  }
  /** Cleans up the garbage collection system. Disables GC and removes all tracked resources. */
  destroy() {
    this._renderer = null;
  }
};
Py.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem,
    Ie.CanvasSystem
  ],
  name: "renderableGC",
  priority: 0
};
Py.defaultOptions = {
  /** Enable/disable the garbage collector */
  renderableGCActive: !0,
  /** Time in ms before an unused resource is collected (default 1 minute) */
  renderableGCMaxUnusedTime: 6e4,
  /** How often to run garbage collection in ms (default 30 seconds) */
  renderableGCFrequency: 3e4
};
let aQ = Py;
const Ey = class _p {
  /**
   * Frame count since started.
   * @readonly
   * @deprecated since 8.15.0
   */
  get count() {
    return this._renderer.tick;
  }
  /**
   * Frame count since last garbage collection.
   * @readonly
   * @deprecated since 8.15.0
   */
  get checkCount() {
    return this._checkCount;
  }
  set checkCount(e) {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead."), this._checkCount = e;
  }
  /**
   * Maximum idle frames before a texture is destroyed by garbage collection.
   * @see TextureGCSystem.defaultMaxIdle
   * @deprecated since 8.15.0
   */
  get maxIdle() {
    return this._renderer.gc.maxUnusedTime / 1e3 * 60;
  }
  set maxIdle(e) {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead."), this._renderer.gc.maxUnusedTime = e / 60 * 1e3;
  }
  /**
   * Frames between two garbage collections.
   * @see TextureGCSystem.defaultCheckCountMax
   * @deprecated since 8.15.0
   */
  // eslint-disable-next-line dot-notation
  get checkCountMax() {
    return Math.floor(this._renderer.gc._frequency / 1e3);
  }
  set checkCountMax(e) {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead.");
  }
  /**
   * Current garbage collection mode.
   * @see TextureGCSystem.defaultMode
   * @deprecated since 8.15.0
   */
  get active() {
    return this._renderer.gc.enabled;
  }
  set active(e) {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead."), this._renderer.gc.enabled = e;
  }
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._renderer = e, this._checkCount = 0;
  }
  init(e) {
    e.textureGCActive !== _p.defaultOptions.textureGCActive && (this.active = e.textureGCActive), e.textureGCMaxIdle !== _p.defaultOptions.textureGCMaxIdle && (this.maxIdle = e.textureGCMaxIdle), e.textureGCCheckCountMax !== _p.defaultOptions.textureGCCheckCountMax && (this.checkCountMax = e.textureGCCheckCountMax);
  }
  /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   * @deprecated since 8.15.0
   */
  run() {
    rt("8.15.0", "TextureGCSystem.run is deprecated, please use the GCSystem instead."), this._renderer.gc.run();
  }
  destroy() {
    this._renderer = null;
  }
};
Ey.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem
  ],
  name: "textureGC"
};
Ey.defaultOptions = {
  /**
   * If set to true, this will enable the garbage collector on the GPU.
   * @default true
   */
  textureGCActive: !0,
  /**
   * @deprecated since 8.3.0
   * @see {@link TextureGCSystemOptions.textureGCMaxIdle}
   */
  textureGCAMaxIdle: null,
  /**
   * The maximum idle frames before a texture is destroyed by garbage collection.
   * @default 60 * 60
   */
  textureGCMaxIdle: 3600,
  /**
   * Frames between two garbage collections.
   * @default 600
   */
  textureGCCheckCountMax: 600
};
let lQ = Ey;
const vT = class yT extends bi {
  /**
   * @param options - Options for creating a render target, or a WebGPU-flavored descriptor.
   */
  constructor(e = {}) {
    var n;
    super(), this.uid = Nt("renderTarget"), this.colorAttachments = [], this.dirtyId = 0, this.isRoot = !1, this._size = new Float32Array(2), this._managedColorTextures = !1, this._depth = !1, this._stencil = !1, this._colorTextures = null;
    const t = "colorAttachments" in e ? e : this._normalizeOptions(e);
    if (this.isRoot = (n = t.isRoot) != null ? n : !1, this.label = t.label, this.colorAttachments = t.colorAttachments, this.depthStencilAttachment = t.depthStencilAttachment, this.depthStencilAttachment) {
      const s = this.depthStencilAttachment.texture.format;
      this._depth || (this._depth = s.includes("depth")), this._stencil || (this._stencil = s.includes("stencil"));
    }
    if (this.colorAttachments.length === 0 && !this.depthStencilAttachment)
      throw new Error("[RenderTarget] no color textures or depth textures were provided. Provide a depthStencilTexture or set depth/stencil to true when using colorTextures: 0.");
    if (this.colorAttachments.length > 0) {
      const s = this.colorTexture;
      this.resize(s.width, s.height, s._resolution);
    }
    this.sizeSource && this.sizeSource.on("resize", this.onSourceResize, this);
  }
  _normalizeOptions(e) {
    const t = { ...yT.defaultOptions, ...e }, n = [];
    let s;
    if (typeof t.colorTextures == "number") {
      if (t.colorTextures > 0) {
        this._managedColorTextures = !0;
        for (let r = 0; r < t.colorTextures; r++)
          n.push({
            texture: new un({
              width: t.width,
              height: t.height,
              resolution: t.resolution,
              antialias: t.antialias
            }),
            loadOp: "clear",
            storeOp: "store"
          });
      }
    } else
      t.colorTextures.forEach((r) => {
        n.push({
          texture: r.source,
          loadOp: "clear",
          storeOp: "store"
        });
      });
    const o = t.depthStencilTexture === !0;
    if (this._depth = !!(t.depth || o), this._stencil = !!(t.stencil || o), t.depthStencilTexture instanceof et || t.depthStencilTexture instanceof un) {
      if (t.isRoot)
        throw new Error("[RenderTarget] cannot attach a depth-stencil texture to the screen — the canvas owns its own depth/stencil buffers. Render to a texture target instead.");
      s = {
        texture: t.depthStencilTexture.source
      };
    } else (o && !t.isRoot || (t.stencil || t.depth) && n.length === 0) && (s = this._createDepthStencilTexture(t.width, t.height, t.resolution));
    return {
      colorAttachments: n,
      depthStencilAttachment: s,
      isRoot: t.isRoot,
      label: t.label
    };
  }
  get size() {
    const e = this._size;
    return e[0] = this.pixelWidth, e[1] = this.pixelHeight, e;
  }
  get width() {
    return this.sizeSource.width;
  }
  get height() {
    return this.sizeSource.height;
  }
  get pixelWidth() {
    return this.sizeSource.pixelWidth;
  }
  get pixelHeight() {
    return this.sizeSource.pixelHeight;
  }
  get resolution() {
    return this.sizeSource._resolution;
  }
  /**
   * An array of textures that can be written to by the GPU - mostly this has one texture in Pixi, but you could
   * write to multiple if required! (eg deferred lighting).
   * This is a backwards-compatible getter that extracts the textures from `colorAttachments`.
   */
  get colorTextures() {
    return this._colorTextures || (this._colorTextures = this.colorAttachments.map((e) => e.texture)), this._colorTextures;
  }
  /** The stencil and depth buffer will write to this texture in WebGPU. */
  get depthStencilTexture() {
    var e, t;
    return (t = (e = this.depthStencilAttachment) == null ? void 0 : e.texture) != null ? t : null;
  }
  /** Whether this target provides a depth buffer — requested via options or implied by its attachment's format. */
  get depth() {
    return this._depth;
  }
  /** Whether this target provides a stencil buffer — requested via options or implied by its attachment's format. */
  get stencil() {
    return this._stencil;
  }
  get colorTexture() {
    var e;
    return (e = this.colorAttachments[0]) == null ? void 0 : e.texture;
  }
  /**
   * The texture that drives size, resolution, and resize events.
   * For standard targets this is `colorAttachments[0].texture`;
   * for depth-only targets it is `depthStencilAttachment.texture`.
   */
  get sizeSource() {
    var e, t, n;
    return (n = (e = this.colorAttachments[0]) == null ? void 0 : e.texture) != null ? n : (t = this.depthStencilAttachment) == null ? void 0 : t.texture;
  }
  onSourceResize(e) {
    this.resize(e.width, e.height, e._resolution, !0);
  }
  /**
   * This will ensure a depthStencil texture is created for this render target.
   * Most likely called by the mask system to make sure we have stencil buffer added.
   * @internal
   */
  ensureDepthStencilTexture() {
    this._createDepthStencilTexture(this.sizeSource.width, this.sizeSource.height, this.sizeSource._resolution), this._depth = !0, this._stencil = !0;
  }
  resize(e, t, n = this.resolution, s = !1) {
    if (this.dirtyId++, this.colorAttachments.forEach((o, r) => {
      s && r === 0 || o.texture.resize(e, t, n);
    }), this.depthStencilAttachment) {
      if (s && this.colorAttachments.length === 0) return;
      this.depthStencilAttachment.texture.resize(e, t, n);
    }
  }
  destroy() {
    !this.colorAttachments && !this.depthStencilAttachment || (this.emit("destroy", this), this.sizeSource.off("resize", this.onSourceResize, this), this._managedColorTextures && this.colorAttachments.forEach((e) => {
      e.texture.destroy();
    }), this.depthStencilAttachment && (this.depthStencilAttachment.texture.destroy(), delete this.depthStencilAttachment), this.colorAttachments = null, this._colorTextures = null, this.removeAllListeners());
  }
  /**
   * The single recipe for internally-created depth-stencil textures.
   * @param width
   * @param height
   * @param resolution
   */
  _createDepthStencilTexture(e, t, n) {
    var s;
    return (s = this.depthStencilAttachment) != null || (this.depthStencilAttachment = {
      texture: new un({
        width: e,
        height: t,
        resolution: n,
        format: "depth24plus-stencil8",
        autoGenerateMipmaps: !1,
        antialias: !1,
        mipLevelCount: 1
        // sampleCount: handled by the render target system..
      })
    }), this.depthStencilAttachment;
  }
};
vT.defaultOptions = {
  /** the width of the RenderTarget */
  width: 0,
  /** the height of the RenderTarget */
  height: 0,
  /** the resolution of the RenderTarget */
  resolution: 1,
  /** an array of textures, or a number indicating how many color textures there should be */
  colorTextures: 1,
  /** should this render target have a stencil buffer? */
  stencil: !1,
  /** should this render target have a depth buffer? */
  depth: !1,
  /** should this render target be antialiased? */
  antialias: !1,
  // save on perf by default!
  /** is this a root element, true if this is gl context owners render target */
  isRoot: !1
};
let Sp = vT;
const tl = /* @__PURE__ */ new Map();
Yl.register(tl);
function xT(i, e) {
  if (!tl.has(i)) {
    const t = new et({
      source: new Ai({
        resource: i,
        ...e
      })
    }), n = () => {
      tl.get(i) === t && tl.delete(i);
    };
    t.once("destroy", n), t.source.once("destroy", n), tl.set(i, t);
  }
  return tl.get(i);
}
const Ry = class wT {
  /**
   * Whether CSS dimensions of canvas view should be resized to screen dimensions automatically.
   * This is only supported for HTMLCanvasElement and will be ignored if the canvas is an OffscreenCanvas.
   * @type {boolean}
   */
  get autoDensity() {
    return this.texture.source.autoDensity;
  }
  set autoDensity(e) {
    this.texture.source.autoDensity = e;
  }
  /** The resolution / device pixel ratio of the renderer. */
  get resolution() {
    return this.texture.source._resolution;
  }
  set resolution(e) {
    this.texture.source.resize(
      this.texture.source.width,
      this.texture.source.height,
      e
    );
  }
  constructor(e) {
    this._renderer = e;
  }
  /**
   * initiates the view system
   * @param options - the options for the view
   */
  init(e) {
    e = {
      ...wT.defaultOptions,
      ...e
    }, e.view && (rt(dn, "ViewSystem.view has been renamed to ViewSystem.canvas"), e.canvas = e.view), this.screen = new Tt(0, 0, e.width, e.height), this.canvas = e.canvas || zt.get().createCanvas(), this.antialias = !!e.antialias;
    const { depth: t, ...n } = e;
    this.texture = xT(this.canvas, n), this.renderTarget = new Sp({
      colorTextures: [this.texture],
      depth: !!t,
      isRoot: !0
    }), this.texture.source.transparent = e.backgroundAlpha < 1, this.texture.source.on("resize", this._updateScreenSize, this), this.resolution = e.resolution, this._updateScreenSize();
  }
  /**
   * Resizes the screen and canvas to the specified dimensions.
   * @param desiredScreenWidth - The new width of the screen.
   * @param desiredScreenHeight - The new height of the screen.
   * @param resolution
   */
  resize(e, t, n) {
    this.texture.source.resize(e, t, n), this.screen.width = this.texture.frame.width, this.screen.height = this.texture.frame.height;
  }
  /**
   * Destroys this System and optionally removes the canvas from the dom.
   * @param {options | false} options - The options for destroying the view, or "false".
   * @example
   * viewSystem.destroy();
   * viewSystem.destroy(true);
   * viewSystem.destroy({ removeView: true });
   */
  destroy(e = !1) {
    (typeof e == "boolean" ? e : e != null && e.removeView) && this.canvas.parentNode && this.canvas.parentNode.removeChild(this.canvas), this.texture.source.off("resize", this._updateScreenSize, this), Nn.removeScreen(this._renderer.uid), Fl.removeScreen(this._renderer.uid), this.texture.destroy();
  }
  /**
   * Tells the texture and canvas pools how big this renderer's screen is, in physical pixels, so they
   * can hand out screen sized resources instead of rounding every request up to a power of two.
   */
  _updateScreenSize() {
    const { pixelWidth: e, pixelHeight: t } = this.texture.source, n = this._renderer.uid;
    Nn.setScreenSize(n, e, t), Fl.setScreenSize(n, e, t);
  }
};
Ry.extension = {
  type: [
    Ie.WebGLSystem,
    Ie.WebGPUSystem,
    Ie.CanvasSystem
  ],
  name: "view",
  priority: 0
};
Ry.defaultOptions = {
  /**
   * {@link WebGLOptions.width}
   * @default 800
   */
  width: 800,
  /**
   * {@link WebGLOptions.height}
   * @default 600
   */
  height: 600,
  /**
   * {@link WebGLOptions.autoDensity}
   * @default false
   */
  autoDensity: !1,
  /**
   * {@link WebGLOptions.antialias}
   * @default false
   */
  antialias: !1
};
let dQ = Ry;
const zy = [
  JZ,
  mT,
  Ay,
  dQ,
  cT,
  sQ,
  lQ,
  pT,
  ZZ,
  rM,
  aQ,
  gT
], kT = [
  Sy,
  yy,
  _y,
  ky,
  xy,
  sT,
  tT,
  wy
];
function cQ(i, e, t, n, s, o) {
  const r = o ? 1 : -1;
  return i.identity(), i.a = 1 / n * 2, i.d = r * (1 / s * 2), i.tx = -1 - e * i.a, i.ty = -r - t * i.d, i;
}
function uQ(i) {
  if (i.colorAttachments.length === 0) return !1;
  const e = i.colorTexture.resource;
  return globalThis.HTMLCanvasElement && e instanceof HTMLCanvasElement && document.body.contains(e);
}
class $y {
  constructor(e) {
    this.rootViewPort = new Tt(), this.viewport = new Tt(), this.onRenderTargetChange = new nM("onRenderTargetChange"), this.projectionMatrix = new st(), this.defaultClearColor = [0, 0, 0, 0], this._renderSurfaceToRenderTargetHash = /* @__PURE__ */ new Map(), this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null), this._renderTargetStack = [], this._bindState = {
      target: null,
      frame: void 0,
      mipLevel: 0,
      layer: 0,
      flipY: !1
    }, this._bindFrame = new Tt(), this._renderer = e, e.gc.addCollection(this, "_gpuRenderTargetHash", "hash");
  }
  /** the current active render surface that the render target is created from */
  get renderSurface() {
    return this._bindState.target;
  }
  /** the current mip level being rendered to (for texture subresources) */
  get mipLevel() {
    return this._bindState.mipLevel;
  }
  /** the current array layer being rendered to (for array-backed targets) */
  get layer() {
    return this._bindState.layer;
  }
  /** called when dev wants to finish a render pass */
  finishRenderPass() {
    this.adaptor.finishRenderPass(this.renderTarget);
  }
  /**
   * called when the renderer starts to render a scene: resets the bind stack and binds the
   * root render surface
   * @param options - the {@link BindOptions} for the root binding
   */
  renderStart(e) {
    var t, n;
    this._renderTargetStack.length = 0, this.push(e), this.rootViewPort.copyFrom(this.viewport), this.rootRenderTarget = this.renderTarget, this.renderingToScreen = uQ(this.rootRenderTarget), (n = (t = this.adaptor).prerender) == null || n.call(t, this.rootRenderTarget);
  }
  postrender() {
    var e, t;
    (t = (e = this.adaptor).postrender) == null || t.call(e, this.rootRenderTarget);
  }
  bind(e, t = !0, n, s, o = 0, r = 0, a) {
    var M, _, T, k, P;
    let l;
    "target" in e ? l = e : (rt("8.20.0", "RenderTargetSystem.bind: positional arguments are deprecated, please use an options object instead: bind({ target, clear, clearColor, frame, mipLevel, layer, flipY })"), l = { target: e, clear: t, clearColor: n, frame: s, mipLevel: o, layer: r, flipY: a });
    const d = l.target;
    t = (M = l.clear) != null ? M : !0, n = l.clearColor, o = ((_ = l.mipLevel) != null ? _ : 0) | 0, r = ((T = l.layer) != null ? T : 0) | 0, a = l.flipY, s = l.frame;
    const c = this.getRenderTarget(d), h = this.renderTarget !== c || !!c.flipY != !!a;
    this.renderTarget = c;
    const f = this.getGpuRenderTarget(c);
    (c.pixelWidth !== f.width || c.pixelHeight !== f.height) && (this.adaptor.resizeGpuRenderTarget(c), f.width = c.pixelWidth, f.height = c.pixelHeight);
    const p = ((k = c.colorAttachments[0]) == null ? void 0 : k.texture) || ((P = c.depthStencilAttachment) == null ? void 0 : P.texture), y = this.viewport, v = p.dimension === "3d" ? Math.max(p.depth >> o, 1) : p.depthOrArrayLayers;
    if (r < 0 || r >= v)
      throw new Error(`[RenderTargetSystem] layer ${r} is out of bounds (layer count=${v}).`);
    const x = this._bindState;
    x.target = d, x.frame = s ? this._bindFrame.copyFrom(s) : void 0, x.mipLevel = o, x.layer = r, x.flipY = a;
    const w = Math.max(p.pixelWidth >> o, 1), S = Math.max(p.pixelHeight >> o, 1);
    if (!s && d instanceof et && (s = d.frame), s) {
      const A = p._resolution, R = 1 << Math.max(o, 0), D = s.x * A + 0.5 | 0, O = s.y * A + 0.5 | 0, F = s.width * A + 0.5 | 0, te = s.height * A + 0.5 | 0;
      let ee = Math.floor(D / R), me = Math.floor(O / R), L = Math.ceil(F / R), N = Math.ceil(te / R);
      ee < 0 && (L += ee, ee = 0), me < 0 && (N += me, me = 0), ee = Math.min(ee, w - 1), me = Math.min(me, S - 1), L = Math.min(L, w - ee), N = Math.min(N, S - me), L = Math.max(L, 1), N = Math.max(N, 1), y.x = ee, y.y = me, y.width = L, y.height = N;
    } else
      y.x = 0, y.y = 0, y.width = w, y.height = S;
    return c.flipY = a, cQ(
      this.projectionMatrix,
      0,
      0,
      y.width / p.resolution,
      y.height / p.resolution,
      !c.isRoot != !!c.flipY
    ), this.adaptor.startRenderPass(c, t, n, y, o, r), h && this.onRenderTargetChange.emit(c), c;
  }
  /**
   * Captures the current binding as a {@link BindOptions} that can be passed back to
   * {@link RenderTargetSystem.bind} to restore it. The capture replays non-destructively:
   * its `clear` is `CLEAR.NONE`, so restoring never wipes the target.
   *
   * ```js
   * const saved = renderer.renderTarget.getBindState();
   *
   * renderer.renderTarget.bind({ target: scratchTexture, clear: true });
   * // ... draw ...
   * renderer.renderTarget.bind(saved);
   *
   * // or compose: the saved binding, but into mip 1
   * renderer.renderTarget.bind({ ...saved, mipLevel: 1 });
   * ```
   *
   * The capture is a snapshot owned by the caller — later binds cannot change it — and holds
   * `target` and `frame` as they were passed, so a Texture bound without an explicit frame
   * replays through its frame fallback. It stays valid for as long as its target does.
   * Pass `out` to reuse one object across captures; every field of it is overwritten.
   * @param out - an optional object to write the bind state into; allocated when omitted
   * @returns the captured bind state (`out` when provided)
   */
  getBindState(e) {
    if (!this.renderTarget)
      throw new Error("[RenderTargetSystem] getBindState is only valid while a render surface is bound");
    const t = this._bindState;
    return e != null || (e = {}), e.target = t.target, e.clear = Mn.NONE, e.clearColor = void 0, t.frame ? e.frame ? e.frame.copyFrom(t.frame) : e.frame = t.frame.clone() : e.frame = void 0, e.mipLevel = t.mipLevel, e.layer = t.layer, e.flipY = !!t.flipY, e;
  }
  /**
   * Whether pixi inverts the front face for a bind — `true` when a front-facing triangle ends up
   * wound the opposite way on the surface, so the winding/cull has been inverted to compensate.
   *
   * With no arguments, answers for the current bind. With a target, answers for that target as if
   * it were bound with the given `flipY` (defaulting to `false`, exactly as {@link bind} would), so
   * a consumer can choose a projection or a `flipY` before binding.
   *
   * This is the requested `flipY` combined with the backend's inherent orientation, not the raw request:
   *
   * ```text
   * inverted = flipY XOR (isWebGL && !isRoot)
   * ```
   *
   * WebGL's non-root FBOs carry an inherent Y-flip vs the root (the classic render-texture flip), so the
   * same requested `flipY` lands with the opposite winding depending on `isRoot`. WebGPU has no such
   * inherent flip, so there it is simply `flipY`. This is the one spelling of the rule: the winding each
   * backend bakes at bind ({@link GlStateSystem} / {@link PipelineSystem}) comes from here too, so
   * consumers (e.g. 3D pipelines) read the resolved orientation instead of re-deriving it.
   * @param renderTarget - the target to ask about; omit for the current bind
   * @param flipY - the `flipY` the target would be bound with; ignored when `renderTarget` is omitted
   * @returns whether the front face is inverted
   */
  isFrontFaceInverted(e, t) {
    if (!e) {
      if (e = this.renderTarget, !e) return !1;
      t = e.flipY;
    }
    return !!t != (this._renderer.type === rs.WEBGL && !e.isRoot);
  }
  /**
   * The effective front-face orientation of the current bind.
   * @deprecated since 8.21.0, use {@link isFrontFaceInverted} instead
   * @returns whether the current bind's front face is inverted
   */
  get frontFaceInverted() {
    return rt(js, "RenderTargetSystem.frontFaceInverted is deprecated, use isFrontFaceInverted() instead"), this.isFrontFaceInverted();
  }
  clear(e, t = Mn.ALL, n, s = this.mipLevel, o = this.layer) {
    t && (e && (e = this.getRenderTarget(e)), this.adaptor.clear(
      e || this.renderTarget,
      t,
      n,
      this.viewport,
      s,
      o
    ));
  }
  contextChange() {
    this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null);
  }
  push(e, t = Mn.ALL, n, s, o = 0, r = 0, a) {
    let l;
    "target" in e ? l = e : (rt("8.20.0", "RenderTargetSystem.push: positional arguments are deprecated, please use an options object instead: push({ target, clear, clearColor, frame, mipLevel, layer, flipY })"), l = { target: e, clear: t, clearColor: n, frame: s, mipLevel: o, layer: r, flipY: a });
    const d = this.bind(l);
    return this._renderTargetStack.push({
      target: l.target,
      clear: !1,
      clearColor: void 0,
      frame: l.frame ? l.frame.clone() : void 0,
      mipLevel: l.mipLevel,
      layer: l.layer,
      flipY: l.flipY
    }), d;
  }
  /**
   * Pops the current render target and restores the previous binding.
   * @returns the render target that was restored
   */
  pop() {
    this._renderTargetStack.pop();
    const e = this._renderTargetStack[this._renderTargetStack.length - 1];
    if (!e)
      throw new Error("[RenderTargetSystem] pop: no previous binding to restore (unbalanced pop)");
    return this.bind(e);
  }
  /**
   * Gets the render target from the provide render surface. Eg if its a texture,
   * it will return the render target for the texture.
   * If its a render target, it will return the same render target.
   * @param renderSurface - the render surface to get the render target for
   * @returns the render target for the render surface
   */
  getRenderTarget(e) {
    var t;
    return e.isTexture && (e = e.source), (t = this._renderSurfaceToRenderTargetHash.get(e)) != null ? t : this._initRenderTarget(e);
  }
  /**
   * Copies a render surface to another texture.
   *
   * NOTE:
   * for sourceRenderSurfaceTexture, The render target must be something that is written too by the renderer
   *
   * The following is not valid:
   * @example
   * const canvas = document.createElement('canvas')
   * canvas.width = 200;
   * canvas.height = 200;
   *
   * const ctx = canvas2.getContext('2d')!
   * ctx.fillStyle = 'red'
   * ctx.fillRect(0, 0, 200, 200);
   *
   * const texture = RenderTexture.create({
   *   width: 200,
   *   height: 200,
   * })
   * const renderTarget = renderer.renderTarget.getRenderTarget(canvas2);
   *
   * renderer.renderTarget.copyToTexture(renderTarget,texture, {x:0,y:0},{width:200,height:200},{x:0,y:0});
   *
   * The best way to copy a canvas is to create a texture from it. Then render with that.
   *
   * Parsing in a RenderTarget canvas context (with a 2d context)
   * @param sourceRenderSurface - the render surface (render target, texture, or canvas) to copy from
   * @param {Texture} destinationTexture - the texture to copy to
   * @param {object} originSrc - the origin of the copy
   * @param {number} originSrc.x - the x origin of the copy
   * @param {number} originSrc.y - the y origin of the copy
   * @param {object} size - the size of the copy
   * @param {number} size.width - the width of the copy
   * @param {number} size.height - the height of the copy
   * @param {object} originDest - the destination origin (top left to paste from!)
   * @param {number} originDest.x - the x origin of the paste
   * @param {number} originDest.y - the y origin of the paste
   */
  copyToTexture(e, t, n, s, o) {
    const r = this.getRenderTarget(e);
    n.x < 0 && (s.width += n.x, o.x -= n.x, n.x = 0), n.y < 0 && (s.height += n.y, o.y -= n.y, n.y = 0);
    const { pixelWidth: a, pixelHeight: l } = r;
    return s.width = Math.min(s.width, a - n.x), s.height = Math.min(s.height, l - n.y), this.adaptor.copyToTexture(
      r,
      t,
      n,
      s,
      o
    );
  }
  /**
   * Copies the depth attachment from one render target to another.
   * Both source and destination must have a depthStencilAttachment.
   *
   * **Important Note:** When using the copied depth buffer in a subsequent render pass,
   * you must ensure you do not clear the depth buffer again. If you need to clear the color
   * buffer of the destination render target, use `clear: CLEAR.COLOR` to preserve the copied depth data.
   * @example
   * ```js
   * renderer.renderTarget.copyDepthTexture(
   *   sourceRT, destRT, { x: 0, y: 0 }, { width: 200, height: 200 }, { x: 0, y: 0 }
   * );
   *
   * // In the subsequent render pass, clear ONLY the color buffer!
   * renderer.render({
   *   target: destRT,
   *   container: myMesh,
   *   clear: CLEAR.COLOR, // Preserves the copied depth
   *   clearColor: [0, 0, 0, 1]
   * });
   * ```
   * @param source - the render surface (render target, depth texture, or canvas) to copy depth from
   * @param destination - the depth/stencil texture to copy depth to
   * @param {object} originSrc - the origin of the copy
   * @param {number} originSrc.x - the x origin of the copy
   * @param {number} originSrc.y - the y origin of the copy
   * @param {object} size - the size of the copy
   * @param {number} size.width - the width of the copy
   * @param {number} size.height - the height of the copy
   * @param {object} originDest - the destination origin (top left to paste from!)
   * @param {number} originDest.x - the x origin of the paste
   * @param {number} originDest.y - the y origin of the paste
   */
  copyDepthTexture(e, t, n, s, o = { x: 0, y: 0 }) {
    const r = this.getRenderTarget(e);
    if (!r.depthStencilAttachment) {
      dt("[RenderTargetSystem] copyDepthTexture: the source render target has no depth attachment to copy from");
      return;
    }
    const a = t.source;
    if (!a.format.includes("depth") && !a.format.includes("stencil")) {
      dt(`[RenderTargetSystem] copyDepthTexture: the destination texture must have a depth/stencil format (got '${a.format}')`);
      return;
    }
    let l = n.x, d = n.y, c = o.x, h = o.y, f = s.width, p = s.height;
    l < 0 && (f += l, c -= l, l = 0), d < 0 && (p += d, h -= d, d = 0), f = Math.min(f, r.pixelWidth - l), p = Math.min(p, r.pixelHeight - d), f = Math.min(f, a.pixelWidth - c), p = Math.min(p, a.pixelHeight - h), !(f <= 0 || p <= 0) && this.adaptor.copyDepthTexture(
      r,
      t,
      { x: l, y: d },
      { width: f, height: p },
      { x: c, y: h }
    );
  }
  /**
   * ensures that we have a depth stencil buffer available to render to
   * This is used by the mask system to make sure we have a stencil buffer.
   */
  ensureDepthStencil() {
    if (!this.renderTarget.stencil) {
      if (this.renderTarget.depthStencilTexture) {
        dt(`[RenderTargetSystem] a stencil mask is being used, but the render target's depthStencilTexture format '${this.renderTarget.depthStencilTexture.format}' has no stencil aspect, so masking cannot work here. Use a 'depth24plus-stencil8' texture instead.`);
        return;
      }
      this.renderTarget._depth = !0, this.renderTarget._stencil = !0, this.adaptor.startRenderPass(this.renderTarget, !1, null, this.viewport, 0, this.layer);
    }
  }
  /** nukes the render target system */
  destroy() {
    this._renderer = null, this._renderSurfaceToRenderTargetHash.forEach((e, t) => {
      e !== t ? this._releaseRenderTarget(t, e) : e.off("destroy", this._onRenderTargetDestroy, this);
    }), this._renderSurfaceToRenderTargetHash.clear();
    for (const e of Object.values(this._gpuRenderTargetHash))
      e && this.adaptor.destroyGpuRenderTarget(e);
    this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null);
  }
  _initRenderTarget(e) {
    let t = null;
    if (Ai.test(e) && (e = xT(e).source), e instanceof Sp)
      t = e, e.once("destroy", this._onRenderTargetDestroy, this);
    else if (e instanceof un) {
      const n = e.format;
      t = n.includes("depth") || n.includes("stencil") ? new Sp({ colorTextures: 0, depthStencilTexture: e }) : new Sp({ colorTextures: [e] }), e.source instanceof Ai && (t.isRoot = !0), e.once("destroy", this._onRenderSurfaceDestroy, this);
    }
    return this._renderSurfaceToRenderTargetHash.set(e, t), t;
  }
  _onRenderSurfaceDestroy(e) {
    const t = this._renderSurfaceToRenderTargetHash.get(e);
    t && this._releaseRenderTarget(e, t);
  }
  /**
   * A caller-owned render target is tearing itself down. It releases its own attachments,
   * so only the system's references to it and the backend objects built for it go here.
   * @param renderTarget - the render target being destroyed
   */
  _onRenderTargetDestroy(e) {
    this._renderSurfaceToRenderTargetHash.delete(e), this._releaseGpuRenderTarget(e);
  }
  /**
   * Tears down a render target that wraps a texture source, removing every reference the
   * system holds to it so neither the system's own teardown nor the source's `destroy`
   * event can destroy it a second time.
   * @param renderSurface - the texture source the render target wraps
   * @param renderTarget - the render target to release
   */
  _releaseRenderTarget(e, t) {
    t.destroy(), this._renderSurfaceToRenderTargetHash.delete(e), e.off("destroy", this._onRenderSurfaceDestroy, this), this._releaseGpuRenderTarget(t);
  }
  /**
   * Frees the backend objects (framebuffers, renderbuffers, MSAA textures) cached for a render target.
   * @param renderTarget - the render target whose backend counterpart is no longer needed
   */
  _releaseGpuRenderTarget(e) {
    const t = this._gpuRenderTargetHash[e.uid];
    t && (this._gpuRenderTargetHash[e.uid] = null, this.adaptor.destroyGpuRenderTarget(t));
  }
  getGpuRenderTarget(e) {
    return this._gpuRenderTargetHash[e.uid] || (this._gpuRenderTargetHash[e.uid] = this.adaptor.initGpuRenderTarget(e));
  }
  resetState() {
    this.renderTarget = null, this._bindState.target = null;
  }
}
class hQ {
  /**
   * Initializes the adaptor.
   * @param renderer - Canvas renderer instance.
   * @param renderTargetSystem - The render target system.
   * @advanced
   */
  init(e, t) {
    this._renderer = e, this._renderTargetSystem = t;
  }
  /**
   * Creates a GPU render target for canvas.
   * @param renderTarget - Render target to initialize.
   * @advanced
   */
  initGpuRenderTarget(e) {
    const t = e.colorTexture, { canvas: n, context: s } = this._ensureCanvas(t);
    return {
      canvas: n,
      context: s,
      width: n.width,
      height: n.height
    };
  }
  /**
   * Resizes the backing canvas for a render target.
   * @param renderTarget - Render target to resize.
   * @advanced
   */
  resizeGpuRenderTarget(e) {
    const t = e.colorTexture, { canvas: n } = this._ensureCanvas(t);
    n.width = e.pixelWidth, n.height = e.pixelHeight;
  }
  /**
   * Starts a render pass on the canvas target.
   * @param renderTarget - Target to render to.
   * @param clear - Clear mode.
   * @param clearColor - Optional clear color.
   * @param viewport - Optional viewport.
   * @advanced
   */
  startRenderPass(e, t, n, s) {
    const o = this._renderTargetSystem.getGpuRenderTarget(e);
    this._renderer.canvasContext.activeContext = o.context, this._renderer.canvasContext.activeResolution = e.resolution, t && this.clear(e, t, n, s);
  }
  /**
   * Clears the render target.
   * @param renderTarget - Target to clear.
   * @param _clear - Clear mode (unused).
   * @param clearColor - Optional clear color.
   * @param viewport - Optional viewport rectangle.
   * @advanced
   */
  clear(e, t, n, s) {
    const r = this._renderTargetSystem.getGpuRenderTarget(e).context, a = s || { x: 0, y: 0, width: e.pixelWidth, height: e.pixelHeight };
    if (r.setTransform(1, 0, 0, 1, 0, 0), r.clearRect(a.x, a.y, a.width, a.height), n) {
      const l = bn.shared.setValue(n);
      l.alpha > 0 && (r.globalAlpha = l.alpha, r.fillStyle = l.toHex(), r.fillRect(a.x, a.y, a.width, a.height), r.globalAlpha = 1);
    }
  }
  /**
   * Finishes the render pass (no-op for canvas).
   * @advanced
   */
  finishRenderPass() {
  }
  /**
   * Copies a render target into a texture source.
   * @param {RenderTarget} sourceRenderSurfaceTexture - Source render target.
   * @param {Texture} destinationTexture - Destination texture.
   * @param {object} originSrc - Source origin.
   * @param {number} originSrc.x - Source x origin.
   * @param {number} originSrc.y - Source y origin.
   * @param {object} size - Copy size.
   * @param {number} size.width - Copy width.
   * @param {number} size.height - Copy height.
   * @param {object} [originDest] - Destination origin.
   * @param {number} originDest.x - Destination x origin.
   * @param {number} originDest.y - Destination y origin.
   * @advanced
   */
  copyToTexture(e, t, n, s, o) {
    var f, p;
    const a = this._renderTargetSystem.getGpuRenderTarget(e).canvas, l = t.source, { context: d } = this._ensureCanvas(l), c = (f = o == null ? void 0 : o.x) != null ? f : 0, h = (p = o == null ? void 0 : o.y) != null ? p : 0;
    return d.drawImage(
      a,
      n.x,
      n.y,
      s.width,
      s.height,
      c,
      h,
      s.width,
      s.height
    ), l.update(), t;
  }
  /**
   * Copies the depth attachment of a render target into a texture (not supported in canvas).
   * @param _source - Source render target.
   * @param _destination - Destination depth/stencil texture.
   * @param _originSrc - Source origin of the copy.
   * @param _originSrc.x
   * @param _originSrc.y
   * @param _size - Size of the copy.
   * @param _size.width
   * @param _size.height
   * @param _originDest - Destination origin of the copy.
   * @param _originDest.x
   * @param _originDest.y
   * @advanced
   */
  copyDepthTexture(e, t, n, s, o) {
    dt("[CanvasRenderTargetAdaptor] copyDepthTexture is not supported in the canvas renderer");
  }
  /**
   * Destroys a GPU render target (no-op for canvas).
   * @param _gpuRenderTarget - Target to destroy.
   * @advanced
   */
  destroyGpuRenderTarget(e) {
  }
  _ensureCanvas(e) {
    let t = e.resource;
    (!t || !Ai.test(t)) && (t = zt.get().createCanvas(e.pixelWidth, e.pixelHeight), e.resource = t), (t.width !== e.pixelWidth || t.height !== e.pixelHeight) && (t.width = e.pixelWidth, t.height = e.pixelHeight);
    const n = t.getContext("2d");
    return { canvas: t, context: n };
  }
}
class _T extends $y {
  constructor(e) {
    super(e), this.adaptor = new hQ(), this.adaptor.init(e, this);
  }
}
_T.extension = {
  type: [Ie.CanvasSystem],
  name: "renderTarget"
};
class ST {
  /**
   * @param renderer - The owning CanvasRenderer.
   */
  constructor(e) {
  }
  /** Initializes the system (no-op for canvas). */
  init() {
  }
  /**
   * Initializes a texture source (no-op for canvas).
   * @param _source - Texture source.
   */
  initSource(e) {
  }
  /**
   * Creates a canvas containing the texture's frame.
   * @param texture - Texture to render.
   */
  generateCanvas(e) {
    var h, f;
    const t = zt.get().createCanvas(), n = t.getContext("2d"), s = _t.getCanvasSource(e);
    if (!s)
      return t;
    const o = e.frame, r = (f = (h = e.source._resolution) != null ? h : e.source.resolution) != null ? f : 1, a = o.x * r, l = o.y * r, d = o.width * r, c = o.height * r;
    return t.width = Math.ceil(d), t.height = Math.ceil(c), n.drawImage(
      s,
      a,
      l,
      d,
      c,
      0,
      0,
      d,
      c
    ), t;
  }
  /**
   * Reads pixel data from a texture.
   * @param texture - Texture to read.
   */
  getPixels(e) {
    const t = this.generateCanvas(e);
    return {
      pixels: t.getContext("2d", { willReadFrequently: !0 }).getImageData(0, 0, t.width, t.height).data,
      width: t.width,
      height: t.height
    };
  }
  /** Destroys the system (no-op for canvas). */
  destroy() {
  }
}
ST.extension = {
  type: [
    Ie.CanvasSystem
  ],
  name: "texture"
};
const pQ = [
  ...zy,
  oT,
  rT,
  ST,
  _T
], fQ = [
  Sy,
  yy,
  _y,
  ky,
  xy,
  iT,
  eT,
  wy
], mQ = [
  IZ,
  aT
], MT = [], TT = [], CT = [], IT = [];
ht.handleByNamedList(Ie.CanvasSystem, MT);
ht.handleByNamedList(Ie.CanvasPipes, TT);
ht.handleByNamedList(Ie.CanvasPipesAdaptor, CT);
ht.handleByNamedList(Ie.CanvasLoader, IT);
ht.add(...pQ, ...fQ, ...mQ);
class gQ extends wu {
  constructor() {
    const e = {
      name: "canvas",
      type: rs.CANVAS,
      systems: MT,
      renderPipes: TT,
      renderPipeAdaptors: CT,
      loaders: IT
    };
    super(e);
  }
}
const bQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CanvasRenderer: gQ
}, Symbol.toStringTag, { value: "Module" }));
var Mp = /* @__PURE__ */ ((i) => (i[i.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER", i[i.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", i[i.UNIFORM_BUFFER = 35345] = "UNIFORM_BUFFER", i))(Mp || {});
class vQ {
  constructor(e, t) {
    this._lastBindBaseLocation = -1, this._lastBindCallId = -1, this.buffer = e || null, this.updateID = -1, this.byteLength = -1, this.type = t;
  }
  destroy() {
    this.buffer = null, this.updateID = -1, this.byteLength = -1, this.type = -1, this._lastBindBaseLocation = -1, this._lastBindCallId = -1;
  }
}
class AT {
  /**
   * @param {Renderer} renderer - The renderer this System works for.
   */
  constructor(e) {
    this._boundBufferBases = /* @__PURE__ */ Object.create(null), this._minBaseLocation = 0, this._nextBindBaseIndex = this._minBaseLocation, this._bindCallId = 0, this._renderer = e, this._managedBuffers = new Cs({
      renderer: e,
      type: "resource",
      onUnload: this.onBufferUnload.bind(this),
      name: "glBuffer"
    });
  }
  /** @ignore */
  destroy() {
    this._managedBuffers.destroy(), this._renderer = null, this._gl = null, this._boundBufferBases = {};
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    this._gl = this._renderer.gl, this.destroyAll(!0), this._maxBindings = this._renderer.limits.maxUniformBindings;
  }
  getGlBuffer(e) {
    return e._gcLastUsed = this._renderer.gc.now, e._gpuData[this._renderer.uid] || this.createGLBuffer(e);
  }
  /**
   * This binds specified buffer. On first run, it will create the webGL buffers for the context too
   * @param buffer - the buffer to bind to the renderer
   */
  bind(e) {
    const { _gl: t } = this, n = this.getGlBuffer(e);
    t.bindBuffer(n.type, n.buffer);
  }
  /**
   * Binds an uniform buffer to at the given index.
   *
   * A cache is used so a buffer will not be bound again if already bound.
   * @param glBuffer - the buffer to bind
   * @param index - the base index to bind it to.
   */
  bindBufferBase(e, t) {
    const { _gl: n } = this;
    this._boundBufferBases[t] !== e && (this._boundBufferBases[t] = e, e._lastBindBaseLocation = t, n.bindBufferBase(n.UNIFORM_BUFFER, t, e.buffer));
  }
  nextBindBase(e) {
    this._bindCallId++, this._minBaseLocation = 0, e && (this._boundBufferBases[0] = null, this._minBaseLocation = 1, this._nextBindBaseIndex < 1 && (this._nextBindBaseIndex = 1));
  }
  freeLocationForBufferBase(e) {
    let t = this.getLastBindBaseLocation(e);
    if (t >= this._minBaseLocation)
      return e._lastBindCallId = this._bindCallId, t;
    let n = 0, s = this._nextBindBaseIndex;
    for (; n < 2; ) {
      s >= this._maxBindings && (s = this._minBaseLocation, n++);
      const o = this._boundBufferBases[s];
      if (o && o._lastBindCallId === this._bindCallId) {
        s++;
        continue;
      }
      break;
    }
    return t = s, this._nextBindBaseIndex = s + 1, n >= 2 ? -1 : (e._lastBindCallId = this._bindCallId, this._boundBufferBases[t] = null, t);
  }
  getLastBindBaseLocation(e) {
    const t = e._lastBindBaseLocation;
    return this._boundBufferBases[t] === e ? t : -1;
  }
  /**
   * Binds a buffer whilst also binding its range.
   * This will make the buffer start from the offset supplied rather than 0 when it is read.
   * @param glBuffer - the buffer to bind
   * @param index - the base index to bind at, defaults to 0
   * @param offset - the offset to bind at (this is blocks of 256). 0 = 0, 1 = 256, 2 = 512 etc
   * @param size - the size to bind at (this is blocks of 256).
   */
  bindBufferRange(e, t, n, s) {
    const { _gl: o } = this;
    n || (n = 0), t || (t = 0), this._boundBufferBases[t] = null, o.bindBufferRange(o.UNIFORM_BUFFER, t || 0, e.buffer, n * 256, s || 256);
  }
  /**
   * Will ensure the data in the buffer is uploaded to the GPU.
   * @param {Buffer} buffer - the buffer to update
   */
  updateBuffer(e) {
    const { _gl: t } = this, n = this.getGlBuffer(e);
    if (e._updateID === n.updateID)
      return n;
    n.updateID = e._updateID, t.bindBuffer(n.type, n.buffer);
    const s = e.data, o = e.descriptor.usage & $t.STATIC ? t.STATIC_DRAW : t.DYNAMIC_DRAW;
    return s ? n.byteLength >= s.byteLength ? t.bufferSubData(
      n.type,
      e._updateOffset,
      s,
      e._updateOffset / s.BYTES_PER_ELEMENT,
      (e._updateSize || s.byteLength) / s.BYTES_PER_ELEMENT
    ) : (n.byteLength = s.byteLength, t.bufferData(n.type, s, o)) : (n.byteLength = e.descriptor.size, t.bufferData(n.type, n.byteLength, o)), n;
  }
  /**
   * dispose all WebGL resources of all managed buffers
   * @param contextLost
   */
  destroyAll(e = !1) {
    this._managedBuffers.removeAll(e);
  }
  onBufferUnload(e, t = !1) {
    const n = e._gpuData[this._renderer.uid];
    n && (t || this._gl.deleteBuffer(n.buffer));
  }
  /**
   * creates and attaches a GLBuffer object tied to the current context.
   * @param buffer
   * @protected
   */
  createGLBuffer(e) {
    const { _gl: t } = this;
    let n = Mp.ARRAY_BUFFER;
    e.descriptor.usage & $t.INDEX ? n = Mp.ELEMENT_ARRAY_BUFFER : e.descriptor.usage & $t.UNIFORM && (n = Mp.UNIFORM_BUFFER);
    const s = new vQ(t.createBuffer(), n);
    return e._gpuData[this._renderer.uid] = s, this._managedBuffers.add(e), s;
  }
  resetState() {
    this._boundBufferBases = /* @__PURE__ */ Object.create(null);
  }
}
AT.extension = {
  type: [
    Ie.WebGLSystem
  ],
  name: "buffer"
};
const Dy = class PT {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this.supports = {
      /** Support for 32-bit indices buffer. */
      uint32Indices: !0,
      /** Support for UniformBufferObjects */
      uniformBufferObject: !0,
      /** Support for VertexArrayObjects */
      vertexArrayObject: !0,
      /** Support for SRGB texture format */
      srgbTextures: !0,
      /** Support for wrapping modes if a texture is non-power of two */
      nonPowOf2wrapping: !0,
      /** Support for MSAA (antialiasing of dynamic textures) */
      msaa: !0,
      /** Support for mipmaps if a texture is non-power of two */
      nonPowOf2mipmaps: !0
    }, this._renderer = e, this.extensions = /* @__PURE__ */ Object.create(null), this.handleContextLost = this.handleContextLost.bind(this), this.handleContextRestored = this.handleContextRestored.bind(this);
  }
  /**
   * `true` if the context is lost
   * @readonly
   */
  get isLost() {
    return !this.gl || this.gl.isContextLost();
  }
  /**
   * Handles the context change event.
   * @param {WebGLRenderingContext} gl - New WebGL context.
   */
  contextChange(e) {
    this.gl = e, this._renderer.gl = e;
  }
  init(e) {
    var n, s;
    e = { ...PT.defaultOptions, ...e };
    let t = this.multiView = e.multiView;
    if (e.context && t && (dt("Renderer created with both a context and multiview enabled. Disabling multiView as both cannot work together."), t = !1), t ? this.canvas = zt.get().createCanvas(this._renderer.canvas.width, this._renderer.canvas.height) : this.canvas = this._renderer.view.canvas, e.context)
      this.initFromContext(e.context);
    else {
      const o = this._renderer.background.alpha < 1, r = (n = e.premultipliedAlpha) != null ? n : !0, a = e.antialias && !this._renderer.backBuffer.useBackBuffer;
      this.createContext(e.preferWebGLVersion, {
        alpha: o,
        premultipliedAlpha: r,
        antialias: a,
        stencil: !0,
        preserveDrawingBuffer: e.preserveDrawingBuffer,
        powerPreference: (s = e.powerPreference) != null ? s : "default"
      });
    }
  }
  ensureCanvasSize(e) {
    if (!this.multiView) {
      e !== this.canvas && dt("multiView is disabled, but targetCanvas is not the main canvas");
      return;
    }
    const { canvas: t } = this;
    (t.width < e.width || t.height < e.height) && (t.width = Math.max(e.width, e.width), t.height = Math.max(e.height, e.height));
  }
  /**
   * Initializes the context.
   * @protected
   * @param {WebGLRenderingContext} gl - WebGL context
   */
  initFromContext(e) {
    this.gl = e, this.webGLVersion = e instanceof zt.get().getWebGLRenderingContext() ? 1 : 2, this.getExtensions(), this.validateContext(e), this._renderer.runners.contextChange.emit(e);
    const t = this._renderer.view.canvas;
    t.addEventListener("webglcontextlost", this.handleContextLost, !1), t.addEventListener("webglcontextrestored", this.handleContextRestored, !1);
  }
  /**
   * Initialize from context options
   * @protected
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
   * @param preferWebGLVersion
   * @param {object} options - context attributes
   */
  createContext(e, t) {
    let n;
    const s = this.canvas;
    if (e === 2 && (n = s.getContext("webgl2", t)), !n && (n = s.getContext("webgl", t), !n))
      throw new Error("This browser does not support WebGL. Try using the canvas renderer");
    this.gl = n, this.initFromContext(this.gl);
  }
  /** Auto-populate the {@link GlContextSystem.extensions extensions}. */
  getExtensions() {
    const { gl: e } = this, t = {
      anisotropicFiltering: e.getExtension("EXT_texture_filter_anisotropic"),
      floatTextureLinear: e.getExtension("OES_texture_float_linear"),
      s3tc: e.getExtension("WEBGL_compressed_texture_s3tc"),
      s3tc_sRGB: e.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
      // eslint-disable-line camelcase
      etc: e.getExtension("WEBGL_compressed_texture_etc"),
      etc1: e.getExtension("WEBGL_compressed_texture_etc1"),
      pvrtc: e.getExtension("WEBGL_compressed_texture_pvrtc") || e.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
      atc: e.getExtension("WEBGL_compressed_texture_atc"),
      astc: e.getExtension("WEBGL_compressed_texture_astc"),
      bptc: e.getExtension("EXT_texture_compression_bptc"),
      rgtc: e.getExtension("EXT_texture_compression_rgtc"),
      loseContext: e.getExtension("WEBGL_lose_context")
    };
    if (this.webGLVersion === 1)
      this.extensions = {
        ...t,
        drawBuffers: e.getExtension("WEBGL_draw_buffers"),
        depthTexture: e.getExtension("WEBGL_depth_texture"),
        vertexArrayObject: e.getExtension("OES_vertex_array_object") || e.getExtension("MOZ_OES_vertex_array_object") || e.getExtension("WEBKIT_OES_vertex_array_object"),
        uint32ElementIndex: e.getExtension("OES_element_index_uint"),
        // Floats and half-floats
        floatTexture: e.getExtension("OES_texture_float"),
        floatTextureLinear: e.getExtension("OES_texture_float_linear"),
        textureHalfFloat: e.getExtension("OES_texture_half_float"),
        textureHalfFloatLinear: e.getExtension("OES_texture_half_float_linear"),
        vertexAttribDivisorANGLE: e.getExtension("ANGLE_instanced_arrays"),
        srgb: e.getExtension("EXT_sRGB")
      };
    else {
      this.extensions = {
        ...t,
        colorBufferFloat: e.getExtension("EXT_color_buffer_float")
      };
      const n = e.getExtension("WEBGL_provoking_vertex");
      n && n.provokingVertexWEBGL(n.FIRST_VERTEX_CONVENTION_WEBGL);
    }
  }
  /**
   * Handles a lost webgl context
   * @param {WebGLContextEvent} event - The context lost event.
   */
  handleContextLost(e) {
    e.preventDefault(), this._contextLossForced && (this._contextLossForced = !1, setTimeout(() => {
      var t;
      this.gl.isContextLost() && ((t = this.extensions.loseContext) == null || t.restoreContext());
    }, 0));
  }
  /** Handles a restored webgl context. */
  handleContextRestored() {
    this.getExtensions(), this._renderer.runners.contextChange.emit(this.gl);
  }
  destroy() {
    var t;
    const e = this._renderer.view.canvas;
    this._renderer = null, e.removeEventListener("webglcontextlost", this.handleContextLost), e.removeEventListener("webglcontextrestored", this.handleContextRestored), this.gl.useProgram(null), (t = this.extensions.loseContext) == null || t.loseContext();
  }
  /**
   * this function can be called to force a webGL context loss
   * this will release all resources on the GPU.
   * Useful if you need to put Pixi to sleep, and save some GPU memory
   *
   * As soon as render is called - all resources will be created again.
   */
  forceContextLoss() {
    var e;
    (e = this.extensions.loseContext) == null || e.loseContext(), this._contextLossForced = !0;
  }
  /**
   * Validate context.
   * @param {WebGLRenderingContext} gl - Render context.
   */
  validateContext(e) {
    const t = e.getContextAttributes();
    t && !t.stencil && dt("Provided WebGL context does not have a stencil buffer, masks may not render correctly");
    const n = this.supports, s = this.webGLVersion === 2, o = this.extensions;
    n.uint32Indices = s || !!o.uint32ElementIndex, n.uniformBufferObject = s, n.vertexArrayObject = s || !!o.vertexArrayObject, n.srgbTextures = s || !!o.srgb, n.nonPowOf2wrapping = s, n.nonPowOf2mipmaps = s, n.msaa = s, n.uint32Indices || dt("Provided WebGL context does not support 32 index buffer, large scenes may not render correctly");
  }
};
Dy.extension = {
  type: [
    Ie.WebGLSystem
  ],
  name: "context"
};
Dy.defaultOptions = {
  /**
   * {@link WebGLOptions.context}
   * @default null
   */
  context: null,
  /**
   * {@link WebGLOptions.premultipliedAlpha}
   * @default true
   */
  premultipliedAlpha: !0,
  /**
   * {@link WebGLOptions.preserveDrawingBuffer}
   * @default false
   */
  preserveDrawingBuffer: !1,
  /**
   * {@link WebGLOptions.powerPreference}
   * @default default
   */
  powerPreference: void 0,
  /**
   * {@link WebGLOptions.webGLVersion}
   * @default 2
   */
  preferWebGLVersion: 2,
  /**
   * {@link WebGLOptions.multiView}
   * @default false
   */
  multiView: !1
};
let yQ = Dy;
function h0(i, e) {
  var t, n, s;
  for (const o in i.attributes) {
    const r = i.attributes[o], a = e[o];
    a ? ((t = r.format) != null || (r.format = a.format), (n = r.offset) != null || (r.offset = a.offset), (s = r.instance) != null || (r.instance = a.instance)) : r.format || dt(`Attribute ${o} is not present in the shader, but is present in the geometry. Unable to infer attribute details.`);
  }
  xQ(i);
}
function xQ(i) {
  var o, r;
  const { buffers: e, attributes: t } = i, n = {}, s = {};
  for (const a in e) {
    const l = e[a];
    n[l.uid] = 0, s[l.uid] = 0;
  }
  for (const a in t) {
    const l = t[a];
    n[l.buffer.uid] += Hc(l.format).stride;
  }
  for (const a in t) {
    const l = t[a];
    (o = l.stride) != null || (l.stride = n[l.buffer.uid]), (r = l.start) != null || (l.start = s[l.buffer.uid]), s[l.buffer.uid] += Hc(l.format).stride;
  }
}
var p0 = /* @__PURE__ */ ((i) => (i[i.RGBA = 6408] = "RGBA", i[i.RGB = 6407] = "RGB", i[i.RG = 33319] = "RG", i[i.RED = 6403] = "RED", i[i.RGBA_INTEGER = 36249] = "RGBA_INTEGER", i[i.RGB_INTEGER = 36248] = "RGB_INTEGER", i[i.RG_INTEGER = 33320] = "RG_INTEGER", i[i.RED_INTEGER = 36244] = "RED_INTEGER", i[i.ALPHA = 6406] = "ALPHA", i[i.LUMINANCE = 6409] = "LUMINANCE", i[i.LUMINANCE_ALPHA = 6410] = "LUMINANCE_ALPHA", i[i.DEPTH_COMPONENT = 6402] = "DEPTH_COMPONENT", i[i.DEPTH_STENCIL = 34041] = "DEPTH_STENCIL", i))(p0 || {}), Jc = /* @__PURE__ */ ((i) => (i[i.TEXTURE_2D = 3553] = "TEXTURE_2D", i[i.TEXTURE_CUBE_MAP = 34067] = "TEXTURE_CUBE_MAP", i[i.TEXTURE_2D_ARRAY = 35866] = "TEXTURE_2D_ARRAY", i[i.TEXTURE_3D = 32879] = "TEXTURE_3D", i[i.TEXTURE_CUBE_MAP_POSITIVE_X = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X", i[i.TEXTURE_CUBE_MAP_NEGATIVE_X = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X", i[i.TEXTURE_CUBE_MAP_POSITIVE_Y = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y", i[i.TEXTURE_CUBE_MAP_NEGATIVE_Y = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y", i[i.TEXTURE_CUBE_MAP_POSITIVE_Z = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z", i[i.TEXTURE_CUBE_MAP_NEGATIVE_Z = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z", i))(Jc || {}), At = /* @__PURE__ */ ((i) => (i[i.UNSIGNED_BYTE = 5121] = "UNSIGNED_BYTE", i[i.UNSIGNED_SHORT = 5123] = "UNSIGNED_SHORT", i[i.UNSIGNED_SHORT_5_6_5 = 33635] = "UNSIGNED_SHORT_5_6_5", i[i.UNSIGNED_SHORT_4_4_4_4 = 32819] = "UNSIGNED_SHORT_4_4_4_4", i[i.UNSIGNED_SHORT_5_5_5_1 = 32820] = "UNSIGNED_SHORT_5_5_5_1", i[i.UNSIGNED_INT = 5125] = "UNSIGNED_INT", i[i.UNSIGNED_INT_10F_11F_11F_REV = 35899] = "UNSIGNED_INT_10F_11F_11F_REV", i[i.UNSIGNED_INT_2_10_10_10_REV = 33640] = "UNSIGNED_INT_2_10_10_10_REV", i[i.UNSIGNED_INT_24_8 = 34042] = "UNSIGNED_INT_24_8", i[i.UNSIGNED_INT_5_9_9_9_REV = 35902] = "UNSIGNED_INT_5_9_9_9_REV", i[i.BYTE = 5120] = "BYTE", i[i.SHORT = 5122] = "SHORT", i[i.INT = 5124] = "INT", i[i.FLOAT = 5126] = "FLOAT", i[i.FLOAT_32_UNSIGNED_INT_24_8_REV = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV", i[i.HALF_FLOAT = 36193] = "HALF_FLOAT", i))(At || {});
const L2 = {
  uint8x2: At.UNSIGNED_BYTE,
  uint8x4: At.UNSIGNED_BYTE,
  sint8x2: At.BYTE,
  sint8x4: At.BYTE,
  unorm8x2: At.UNSIGNED_BYTE,
  unorm8x4: At.UNSIGNED_BYTE,
  snorm8x2: At.BYTE,
  snorm8x4: At.BYTE,
  uint16x2: At.UNSIGNED_SHORT,
  uint16x4: At.UNSIGNED_SHORT,
  sint16x2: At.SHORT,
  sint16x4: At.SHORT,
  unorm16x2: At.UNSIGNED_SHORT,
  unorm16x4: At.UNSIGNED_SHORT,
  snorm16x2: At.SHORT,
  snorm16x4: At.SHORT,
  float16x2: At.HALF_FLOAT,
  float16x4: At.HALF_FLOAT,
  float32: At.FLOAT,
  float32x2: At.FLOAT,
  float32x3: At.FLOAT,
  float32x4: At.FLOAT,
  uint32: At.UNSIGNED_INT,
  uint32x2: At.UNSIGNED_INT,
  uint32x3: At.UNSIGNED_INT,
  uint32x4: At.UNSIGNED_INT,
  sint32: At.INT,
  sint32x2: At.INT,
  sint32x3: At.INT,
  sint32x4: At.INT
};
function wQ(i) {
  var e;
  return (e = L2[i]) != null ? e : L2.float32;
}
const kQ = {
  "point-list": 0,
  "line-list": 1,
  "line-strip": 3,
  "triangle-list": 4,
  "triangle-strip": 5
};
class _Q {
  constructor() {
    this.vaoCache = /* @__PURE__ */ Object.create(null);
  }
  destroy() {
    this.vaoCache = /* @__PURE__ */ Object.create(null);
  }
}
class ET {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._renderer = e, this._activeGeometry = null, this._activeVao = null, this.hasVao = !0, this.hasInstance = !0, this._managedGeometries = new Cs({
      renderer: e,
      type: "resource",
      onUnload: this.onGeometryUnload.bind(this),
      name: "glGeometry"
    });
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    const e = this.gl = this._renderer.gl;
    if (!this._renderer.context.supports.vertexArrayObject)
      throw new Error("[PixiJS] Vertex Array Objects are not supported on this device");
    this.destroyAll(!0);
    const t = this._renderer.context.extensions.vertexArrayObject;
    t && (e.createVertexArray = () => t.createVertexArrayOES(), e.bindVertexArray = (s) => t.bindVertexArrayOES(s), e.deleteVertexArray = (s) => t.deleteVertexArrayOES(s));
    const n = this._renderer.context.extensions.vertexAttribDivisorANGLE;
    n && (e.drawArraysInstanced = (s, o, r, a) => {
      n.drawArraysInstancedANGLE(s, o, r, a);
    }, e.drawElementsInstanced = (s, o, r, a, l) => {
      n.drawElementsInstancedANGLE(s, o, r, a, l);
    }, e.vertexAttribDivisor = (s, o) => n.vertexAttribDivisorANGLE(s, o)), this._activeGeometry = null, this._activeVao = null;
  }
  /**
   * Binds geometry so that is can be drawn. Creating a Vao if required
   * @param geometry - Instance of geometry to bind.
   * @param program - Instance of program to use vao for.
   */
  bind(e, t) {
    const n = this.gl;
    this._activeGeometry = e;
    const s = this.getVao(e, t);
    this._activeVao !== s && (this._activeVao = s, n.bindVertexArray(s)), this.updateBuffers();
  }
  /** Reset and unbind any active VAO and geometry. */
  resetState() {
    this.unbind();
  }
  /** Update buffers of the currently bound geometry. */
  updateBuffers() {
    const e = this._activeGeometry, t = this._renderer.buffer;
    for (let n = 0; n < e.buffers.length; n++) {
      const s = e.buffers[n];
      t.updateBuffer(s);
    }
    e._gcLastUsed = this._renderer.gc.now;
  }
  /**
   * Check compatibility between a geometry and a program
   * @param geometry - Geometry instance.
   * @param program - Program instance.
   */
  checkCompatibility(e, t) {
    const n = e.attributes, s = t._attributeData;
    for (const o in s)
      if (!n[o])
        throw new Error(`shader and geometry incompatible, geometry missing the "${o}" attribute`);
  }
  /**
   * Takes a geometry and program and generates a unique signature for them.
   * @param geometry - To get signature from.
   * @param program - To test geometry against.
   * @returns - Unique signature of the geometry and program
   */
  getSignature(e, t) {
    const n = e.attributes, s = t._attributeData, o = ["g", e.uid];
    for (const r in n)
      s[r] && o.push(r, s[r].location);
    return o.join("-");
  }
  getVao(e, t) {
    var n;
    return ((n = e._gpuData[this._renderer.uid]) == null ? void 0 : n.vaoCache[t._key]) || this.initGeometryVao(e, t);
  }
  /**
   * Creates or gets Vao with the same structure as the geometry and stores it on the geometry.
   * If vao is created, it is bound automatically. We use a shader to infer what and how to set up the
   * attribute locations.
   * @param geometry - Instance of geometry to to generate Vao for.
   * @param program
   * @param _incRefCount - Increment refCount of all geometry buffers.
   */
  initGeometryVao(e, t, n = !0) {
    const s = this._renderer.gl, o = this._renderer.buffer;
    this._renderer.shader._getProgramData(t), this.checkCompatibility(e, t);
    const r = this.getSignature(e, t);
    let a = e._gpuData[this._renderer.uid];
    a || (a = new _Q(), e._gpuData[this._renderer.uid] = a, this._managedGeometries.add(e));
    const l = a.vaoCache;
    let d = l[r];
    if (d)
      return l[t._key] = d, d;
    h0(e, t._attributeData);
    const c = e.buffers;
    d = s.createVertexArray(), s.bindVertexArray(d);
    for (let h = 0; h < c.length; h++) {
      const f = c[h];
      o.bind(f);
    }
    return this.activateVao(e, t), l[t._key] = d, l[r] = d, s.bindVertexArray(null), d;
  }
  onGeometryUnload(e, t = !1) {
    const n = e._gpuData[this._renderer.uid];
    if (!n) return;
    const s = n.vaoCache;
    if (!t)
      for (const o in s)
        this._activeVao === s[o] && this.resetState(), this.gl.deleteVertexArray(s[o]);
  }
  /**
   * Dispose all WebGL resources of all managed geometries.
   * @param [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */
  destroyAll(e = !1) {
    this._managedGeometries.removeAll(e);
  }
  /**
   * Activate vertex array object.
   * @param geometry - Geometry instance.
   * @param program - Shader program instance.
   */
  activateVao(e, t) {
    var a, l;
    const n = this._renderer.gl, s = this._renderer.buffer, o = e.attributes;
    e.indexBuffer && s.bind(e.indexBuffer);
    let r = null;
    for (const d in o) {
      const c = o[d], h = c.buffer, f = s.getGlBuffer(h), p = t._attributeData[d];
      if (p) {
        r !== f && (s.bind(h), r = f);
        const y = p.location;
        n.enableVertexAttribArray(y);
        const v = Hc(c.format), x = wQ(c.format);
        if (((a = p.format) == null ? void 0 : a.substring(1, 4)) === "int" ? n.vertexAttribIPointer(
          y,
          v.size,
          x,
          c.stride,
          c.offset
        ) : n.vertexAttribPointer(
          y,
          v.size,
          x,
          v.normalised,
          c.stride,
          c.offset
        ), c.instance)
          if (this.hasInstance) {
            const w = (l = c.divisor) != null ? l : 1;
            n.vertexAttribDivisor(y, w);
          } else
            throw new Error("geometry error, GPU Instancing is not supported on this device");
      }
    }
  }
  /**
   * Draws the currently bound geometry.
   * @param topology - The type primitive to render.
   * @param size - The number of elements to be rendered. If not specified, an indexed geometry
   *  falls back to {@link Geometry.indexCount} and then to its whole index buffer, and a
   *  non-indexed one to {@link Geometry.vertexCount}.
   * @param start - The starting vertex in the geometry to start drawing from. If not specified,
   *  drawing will start from the first vertex.
   * @param instanceCount - The number of instances of the set of elements to execute. If not specified,
   *  all instances will be drawn.
   * @returns This instance of the geometry system.
   */
  draw(e, t, n, s) {
    const { gl: o } = this._renderer, r = this._activeGeometry, a = kQ[e || r.topology];
    if (s != null || (s = r.instanceCount), r.indexBuffer) {
      const l = r.indexBuffer.data.BYTES_PER_ELEMENT, d = l === 2 ? o.UNSIGNED_SHORT : o.UNSIGNED_INT, c = t || r.indexCount || r.indexBuffer.data.length, h = (n || 0) * l;
      s !== 1 ? o.drawElementsInstanced(a, c, d, h, s) : o.drawElements(a, c, d, h);
    } else s !== 1 ? o.drawArraysInstanced(a, n || 0, t || r.vertexCount, s) : o.drawArrays(a, n || 0, t || r.vertexCount);
    return this;
  }
  /** Unbind/reset everything. */
  unbind() {
    this.gl.bindVertexArray(null), this._activeVao = null, this._activeGeometry = null;
  }
  destroy() {
    this._managedGeometries.destroy(), this._renderer = null, this.gl = null, this._activeVao = null, this._activeGeometry = null;
  }
}
ET.extension = {
  type: [
    Ie.WebGLSystem
  ],
  name: "geometry"
};
const SQ = new fm({
  attributes: {
    aPosition: [
      -1,
      -1,
      // Bottom left corner
      3,
      -1,
      // Bottom right corner, extending beyond right edge
      -1,
      3
      // Top left corner, extending beyond top edge
    ]
  }
}), Oy = class RT {
  constructor(e) {
    this.useBackBuffer = !1, this._useBackBufferThisRender = !1, this._renderer = e;
  }
  init(e = {}) {
    const { useBackBuffer: t, antialias: n } = { ...RT.defaultOptions, ...e };
    this.useBackBuffer = t, this._antialias = n, this._renderer.context.supports.msaa || (dt("antialiasing, is not supported on when using the back buffer"), this._antialias = !1), this._state = co.for2d();
    const s = new Xl({
      vertex: `
                attribute vec2 aPosition;
                out vec2 vUv;

                void main() {
                    gl_Position = vec4(aPosition, 0.0, 1.0);

                    vUv = (aPosition + 1.0) / 2.0;

                    // flip dem UVs
                    vUv.y = 1.0 - vUv.y;
                }`,
      fragment: `
                in vec2 vUv;
                out vec4 finalColor;

                uniform sampler2D uTexture;

                void main() {
                    finalColor = texture(uTexture, vUv);
                }`,
      name: "big-triangle"
    });
    this._bigTriangleShader = new lo({
      glProgram: s,
      resources: {
        uTexture: et.WHITE.source
      }
    });
  }
  /**
   * This is called before the RenderTargetSystem is started. This is where
   * we replace the target with the back buffer if required.
   * @param options - The options for this render.
   */
  renderStart(e) {
    const t = this._renderer.renderTarget.getRenderTarget(e.target);
    if (this._useBackBufferThisRender = this.useBackBuffer && !!t.isRoot, this._useBackBufferThisRender) {
      const n = this._renderer.renderTarget.getRenderTarget(e.target);
      this._targetTexture = n.colorTexture, e.target = this._getBackBufferTexture(n.colorTexture);
    }
  }
  renderEnd() {
    this._presentBackBuffer();
  }
  _presentBackBuffer() {
    const e = this._renderer;
    e.renderTarget.finishRenderPass(), this._useBackBufferThisRender && (e.renderTarget.bind({ target: this._targetTexture, clear: !1 }), this._bigTriangleShader.resources.uTexture = this._backBufferTexture.source, e.encoder.draw({
      geometry: SQ,
      shader: this._bigTriangleShader,
      state: this._state
    }));
  }
  _getBackBufferTexture(e) {
    return this._backBufferTexture = this._backBufferTexture || new et({
      source: new un({
        width: e.width,
        height: e.height,
        resolution: e._resolution,
        antialias: this._antialias
      })
    }), this._backBufferTexture.source.resize(
      e.width,
      e.height,
      e._resolution
    ), this._backBufferTexture;
  }
  /** destroys the back buffer */
  destroy() {
    this._backBufferTexture && (this._backBufferTexture.destroy(), this._backBufferTexture = null);
  }
};
Oy.extension = {
  type: [
    Ie.WebGLSystem
  ],
  name: "backBuffer",
  priority: 1
};
Oy.defaultOptions = {
  /** if true will use the back buffer where required */
  useBackBuffer: !1
};
let MQ = Oy;
class zT {
  constructor(e) {
    this._colorMaskCache = 15, this._renderer = e;
  }
  setMask(e) {
    this._colorMaskCache !== e && (this._colorMaskCache = e, this._renderer.gl.colorMask(
      !!(e & 8),
      !!(e & 4),
      !!(e & 2),
      !!(e & 1)
    ));
  }
}
zT.extension = {
  type: [
    Ie.WebGLSystem
  ],
  name: "colorMask"
};
class $T {
  constructor(e) {
    this.commandFinished = Promise.resolve(), this._renderer = e;
  }
  setGeometry(e, t) {
    this._renderer.geometry.bind(e, t.glProgram);
  }
  finishRenderPass() {
  }
  draw(e) {
    const t = this._renderer, { geometry: n, shader: s, state: o, skipSync: r, topology: a, size: l, start: d, instanceCount: c } = e;
    t.shader.bind(s, r), t.geometry.bind(n, t.shader._activeProgram), o && t.state.set(o), t.geometry.draw(a, l, d, c != null ? c : n.instanceCount);
  }
  destroy() {
    this._renderer = null;
  }
}
$T.extension = {
  type: [
    Ie.WebGLSystem
  ],
  name: "encoder"
};
class DT {
  constructor(e) {
    this._renderer = e;
  }
  contextChange() {
    const e = this._renderer.gl;
    this.maxTextures = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS), this.maxBatchableTextures = pM(this.maxTextures, e);
    const t = this._renderer.context.webGLVersion === 2;
    this.maxUniformBindings = t ? e.getParameter(e.MAX_UNIFORM_BUFFER_BINDINGS) : 0;
  }
  destroy() {
  }
}
DT.extension = {
  type: [
    Ie.WebGLSystem
  ],
  name: "limits"
};
class TQ {
  constructor() {
    this.width = -1, this.height = -1, this.msaa = !1, this._attachedMipLevel = 0, this._attachedLayer = 0, this.msaaRenderBuffer = [], this.stencilMode = fn.DISABLED, this.stencilReference = 0, this.maskStackIndex = 0;
  }
}
const cr = [];
cr[fn.NONE] = void 0;
cr[fn.DISABLED] = {
  stencilWriteMask: 0,
  stencilReadMask: 0
};
cr[fn.RENDERING_MASK_ADD] = {
  stencilFront: {
    compare: "equal",
    passOp: "increment-clamp"
  },
  stencilBack: {
    compare: "equal",
    passOp: "increment-clamp"
  }
};
cr[fn.RENDERING_MASK_REMOVE] = {
  stencilFront: {
    compare: "equal",
    passOp: "decrement-clamp"
  },
  stencilBack: {
    compare: "equal",
    passOp: "decrement-clamp"
  }
};
cr[fn.MASK_ACTIVE] = {
  stencilWriteMask: 0,
  stencilFront: {
    compare: "equal",
    passOp: "keep"
  },
  stencilBack: {
    compare: "equal",
    passOp: "keep"
  }
};
cr[fn.INVERSE_MASK_ACTIVE] = {
  stencilWriteMask: 0,
  stencilFront: {
    compare: "not-equal",
    passOp: "keep"
  },
  stencilBack: {
    compare: "not-equal",
    passOp: "keep"
  }
};
class OT {
  constructor(e) {
    this._stencilCache = {
      enabled: !1,
      stencilReference: 0,
      stencilMode: fn.NONE
    }, this._renderer = e, e.renderTarget.onRenderTargetChange.add(this);
  }
  contextChange(e) {
    this._gl = e, this._comparisonFuncMapping = {
      always: e.ALWAYS,
      never: e.NEVER,
      equal: e.EQUAL,
      "not-equal": e.NOTEQUAL,
      less: e.LESS,
      "less-equal": e.LEQUAL,
      greater: e.GREATER,
      "greater-equal": e.GEQUAL
    }, this._stencilOpsMapping = {
      keep: e.KEEP,
      zero: e.ZERO,
      replace: e.REPLACE,
      invert: e.INVERT,
      "increment-clamp": e.INCR,
      "decrement-clamp": e.DECR,
      "increment-wrap": e.INCR_WRAP,
      "decrement-wrap": e.DECR_WRAP
    }, this._activeGpuRenderTarget = null, this.resetState();
  }
  onRenderTargetChange(e) {
    if (this._activeRenderTarget === e) return;
    this._activeRenderTarget = e;
    const t = this._renderer.renderTarget.getGpuRenderTarget(e);
    this._activeGpuRenderTarget = t, this.setStencilMode(t.stencilMode, t.stencilReference);
  }
  resetState() {
    this._stencilCache.enabled = !1, this._stencilCache.stencilMode = fn.NONE, this._stencilCache.stencilReference = 0;
  }
  setStencilMode(e, t) {
    var a;
    const n = (a = this._activeGpuRenderTarget) != null ? a : this._activeGpuRenderTarget = this._renderer.renderTarget.getGpuRenderTarget(this._activeRenderTarget), s = this._gl, o = cr[e], r = this._stencilCache;
    if (n.stencilMode = e, n.stencilReference = t, e === fn.DISABLED) {
      this._stencilCache.enabled && (this._stencilCache.enabled = !1, s.disable(s.STENCIL_TEST));
      return;
    }
    this._stencilCache.enabled || (this._stencilCache.enabled = !0, s.enable(s.STENCIL_TEST)), (e !== r.stencilMode || r.stencilReference !== t) && (r.stencilMode = e, r.stencilReference = t, s.stencilFunc(this._comparisonFuncMapping[o.stencilBack.compare], t, 255), s.stencilOp(s.KEEP, s.KEEP, this._stencilOpsMapping[o.stencilBack.passOp]));
  }
  destroy() {
    this._renderer.renderTarget.onRenderTargetChange.remove(this), this._renderer = null, this._gl = null, this._activeRenderTarget = null, this._activeGpuRenderTarget = null;
  }
}
OT.extension = {
  type: [
    Ie.WebGLSystem
  ],
  name: "stencil"
};
class LT {
  constructor(e) {
    this._syncFunctionHash = /* @__PURE__ */ Object.create(null), this._adaptor = e, this._systemCheck();
  }
  /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   */
  _systemCheck() {
    if (!XS())
      throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
  }
  ensureUniformGroup(e) {
    const t = this.getUniformGroupData(e);
    e.buffer || (e.buffer = new ns({
      data: new Float32Array(t.layout.size / 4),
      usage: $t.UNIFORM | $t.COPY_DST
    }));
  }
  getUniformGroupData(e) {
    return this._syncFunctionHash[e._signature] || this._initUniformGroup(e);
  }
  _initUniformGroup(e) {
    const t = e._signature;
    let n = this._syncFunctionHash[t];
    if (!n) {
      const s = Object.keys(e.uniformStructures).map((a) => e.uniformStructures[a]), o = this._adaptor.createUboElements(s), r = this._generateUboSync(o.uboElements);
      n = this._syncFunctionHash[t] = {
        layout: o,
        syncFunction: r
      };
    }
    return this._syncFunctionHash[t];
  }
  _generateUboSync(e) {
    return this._adaptor.generateUboSync(e);
  }
  syncUniformGroup(e, t, n) {
    const s = this.getUniformGroupData(e);
    e.buffer || (e.buffer = new ns({
      data: new Float32Array(s.layout.size / 4),
      usage: $t.UNIFORM | $t.COPY_DST
    }));
    let o = null;
    return t || (t = e.buffer.data, o = e.buffer.dataInt32), n || (n = 0), s.syncFunction(e.uniforms, t, o, n), !0;
  }
  updateUniformGroup(e) {
    if (e.isStatic && !e._dirtyId) return !1;
    e._dirtyId = 0;
    const t = this.syncUniformGroup(e);
    return e.buffer.update(), t;
  }
  destroy() {
    this._syncFunctionHash = null;
  }
}
const BT = {
  f32: 4,
  i32: 4,
  "vec2<f32>": 8,
  "vec3<f32>": 12,
  "vec4<f32>": 16,
  "vec2<i32>": 8,
  "vec3<i32>": 12,
  "vec4<i32>": 16,
  u32: 4,
  "vec2<u32>": 8,
  "vec3<u32>": 12,
  "vec4<u32>": 16,
  "mat2x2<f32>": 32,
  "mat3x3<f32>": 48,
  "mat4x4<f32>": 64
  // TODO - not essential for now but support these in the future
  // int:      4,
  // ivec2:    8,
  // ivec3:    12,
  // ivec4:    16,
  // uint:     4,
  // uvec2:    8,
  // uvec3:    12,
  // uvec4:    16,
  // bool:     4,
  // bvec2:    8,
  // bvec3:    12,
  // bvec4:    16,
  // mat2:     16 * 2,
  // mat3:     16 * 3,
  // mat4:     16 * 4,
};
function CQ(i) {
  const e = i.map((o) => ({
    data: o,
    offset: 0,
    size: 0
  })), t = 16;
  let n = 0, s = 0;
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    if (n = BT[r.data.type], !n)
      throw new Error(`Unknown type ${r.data.type}`);
    r.data.size > 1 && (n = Math.max(n, t) * r.data.size);
    const a = n === 12 ? 16 : n;
    r.size = n;
    const l = s % t;
    l > 0 && t - l < a ? s += (t - l) % 16 : s += (n - l % n) % n, r.offset = s, s += n;
  }
  return s = Math.ceil(s / 16) * 16, { uboElements: e, size: s };
}
const gl = [
  // uploading pixi matrix object to mat3
  {
    type: "mat3x3<f32>",
    test: (i) => i.value.a !== void 0,
    ubo: `
            var matrix = uv[name].toArray(true);
            data[offset] = matrix[0];
            data[offset + 1] = matrix[1];
            data[offset + 2] = matrix[2];
            data[offset + 4] = matrix[3];
            data[offset + 5] = matrix[4];
            data[offset + 6] = matrix[5];
            data[offset + 8] = matrix[6];
            data[offset + 9] = matrix[7];
            data[offset + 10] = matrix[8];
        `,
    uniform: `
            gl.uniformMatrix3fv(ud[name].location, false, uv[name].toArray(true));
        `
  },
  // uploading a pixi rectangle as a vec4
  {
    type: "vec4<f32>",
    test: (i) => i.type === "vec4<f32>" && i.size === 1 && i.value.width !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.x;
            data[offset + 1] = v.y;
            data[offset + 2] = v.width;
            data[offset + 3] = v.height;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height) {
                cv[0] = v.x;
                cv[1] = v.y;
                cv[2] = v.width;
                cv[3] = v.height;
                gl.uniform4f(ud[name].location, v.x, v.y, v.width, v.height);
            }
        `
  },
  // uploading a pixi point as a vec2
  {
    type: "vec2<f32>",
    test: (i) => i.type === "vec2<f32>" && i.size === 1 && i.value.x !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.x;
            data[offset + 1] = v.y;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.x || cv[1] !== v.y) {
                cv[0] = v.x;
                cv[1] = v.y;
                gl.uniform2f(ud[name].location, v.x, v.y);
            }
        `
  },
  // uploading a pixi color as a vec4
  {
    type: "vec4<f32>",
    test: (i) => i.type === "vec4<f32>" && i.size === 1 && i.value.red !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.red;
            data[offset + 1] = v.green;
            data[offset + 2] = v.blue;
            data[offset + 3] = v.alpha;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.alpha) {
                cv[0] = v.red;
                cv[1] = v.green;
                cv[2] = v.blue;
                cv[3] = v.alpha;
                gl.uniform4f(ud[name].location, v.red, v.green, v.blue, v.alpha);
            }
        `
  },
  // uploading a pixi color as a vec3
  {
    type: "vec3<f32>",
    test: (i) => i.type === "vec3<f32>" && i.size === 1 && i.value.red !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.red;
            data[offset + 1] = v.green;
            data[offset + 2] = v.blue;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue) {
                cv[0] = v.red;
                cv[1] = v.green;
                cv[2] = v.blue;
                gl.uniform3f(ud[name].location, v.red, v.green, v.blue);
            }
        `
  }
];
function FT(i, e, t) {
  const n = [`
        var v = null;
        var v2 = null;
        var t = 0;
        var index = 0;
        var name = null;
        var arrayOffset = null;
    `];
  let s = 0;
  for (let r = 0; r < i.length; r++) {
    const a = i[r], l = a.data.name;
    let d = !1, c = 0;
    for (let h = 0; h < gl.length; h++)
      if (gl[h].test(a.data)) {
        c = a.offset / 4, n.push(
          `name = "${l}";`,
          `offset += ${c - s};`,
          gl[h].ubo
        ), d = !0;
        break;
      }
    if (!d)
      if (a.data.size > 1)
        c = a.offset / 4, n.push(t(a, c - s));
      else {
        const h = e[a.data.type];
        c = a.offset / 4, n.push(
          /* wgsl */
          `
                    v = uv.${l};
                    offset += ${c - s};
                    ${h};
                `
        );
      }
    s = c;
  }
  const o = n.join(`
`);
  return new Function(
    "uv",
    "data",
    "dataInt32",
    "offset",
    o
  );
}
function Ea(i, e) {
  return `
        for (let i = 0; i < ${i * e}; i++) {
            data[offset + (((i / ${i})|0) * 4) + (i % ${i})] = v[i];
        }
    `;
}
const NT = {
  f32: `
        data[offset] = v;`,
  i32: `
        dataInt32[offset] = v;`,
  u32: `
        dataInt32[offset] = v;`,
  "vec2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];`,
  "vec3<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];`,
  "vec4<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 3] = v[3];`,
  "vec2<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];`,
  "vec3<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];`,
  "vec4<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];
        dataInt32[offset + 3] = v[3];`,
  "vec2<u32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];`,
  "vec3<u32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];`,
  "vec4<u32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];
        dataInt32[offset + 3] = v[3];`,
  "mat2x2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 4] = v[2];
        data[offset + 5] = v[3];`,
  "mat3x3<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 4] = v[3];
        data[offset + 5] = v[4];
        data[offset + 6] = v[5];
        data[offset + 8] = v[6];
        data[offset + 9] = v[7];
        data[offset + 10] = v[8];`,
  "mat4x4<f32>": `
        for (let i = 0; i < 16; i++) {
            data[offset + i] = v[i];
        }`,
  "mat3x2<f32>": Ea(3, 2),
  "mat4x2<f32>": Ea(4, 2),
  "mat2x3<f32>": Ea(2, 3),
  "mat4x3<f32>": Ea(4, 3),
  "mat2x4<f32>": Ea(2, 4),
  "mat3x4<f32>": Ea(3, 4)
}, IQ = {
  ...NT,
  "mat2x2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 3] = v[3];
    `
};
function AQ(i, e) {
  const t = Math.max(BT[i.data.type] / 16, 1), n = i.data.value.length / i.data.size, s = (4 - n % 4) % 4, o = i.data.type.indexOf("i32") >= 0 ? "dataInt32" : "data";
  return `
        v = uv.${i.data.name};
        offset += ${e};

        arrayOffset = offset;

        t = 0;

        for(var i=0; i < ${i.data.size * t}; i++)
        {
            for(var j = 0; j < ${n}; j++)
            {
                ${o}[arrayOffset++] = v[t++];
            }
            ${s !== 0 ? `arrayOffset += ${s};` : ""}
        }
    `;
}
function PQ(i) {
  return FT(
    i,
    NT,
    AQ
  );
}
class UT extends LT {
  constructor() {
    super({
      createUboElements: CQ,
      generateUboSync: PQ
    });
  }
}
UT.extension = {
  type: [Ie.WebGLSystem],
  name: "ubo"
};
class EQ {
  constructor() {
    this._clearColorCache = [0, 0, 0, 0], this._viewPortCache = new Tt(), this._boundFramebuffer = void 0;
  }
  init(e, t) {
    this._renderer = e, this._renderTargetSystem = t, e.runners.contextChange.add(this);
  }
  contextChange() {
    this._clearColorCache = [0, 0, 0, 0], this._viewPortCache = new Tt(), this._boundFramebuffer = void 0;
    const e = this._renderer.gl;
    this._drawBuffersCache = [];
    for (let t = 1; t <= 16; t++)
      this._drawBuffersCache[t] = Array.from({ length: t }, (n, s) => e.COLOR_ATTACHMENT0 + s);
  }
  copyToTexture(e, t, n, s, o) {
    const r = this._renderTargetSystem, a = this._renderer, l = r.getGpuRenderTarget(e), d = a.gl;
    return this.finishRenderPass(e), d.bindFramebuffer(d.FRAMEBUFFER, l.resolveTargetFramebuffer), this._boundFramebuffer = l.resolveTargetFramebuffer, a.texture.bind(t, 0), d.copyTexSubImage2D(
      d.TEXTURE_2D,
      0,
      o.x,
      o.y,
      n.x,
      n.y,
      s.width,
      s.height
    ), t;
  }
  copyDepthTexture(e, t, n, s, o) {
    const r = this._renderTargetSystem, a = this._renderer.gl;
    this.finishRenderPass(e);
    const l = r.getRenderTarget(t), d = r.getGpuRenderTarget(e), c = r.getGpuRenderTarget(l);
    a.bindFramebuffer(a.READ_FRAMEBUFFER, d.framebuffer), a.bindFramebuffer(a.DRAW_FRAMEBUFFER, c.framebuffer), this._boundFramebuffer = void 0, a.blitFramebuffer(
      n.x,
      n.y,
      n.x + s.width,
      n.y + s.height,
      o.x,
      o.y,
      o.x + s.width,
      o.y + s.height,
      a.DEPTH_BUFFER_BIT,
      a.NEAREST
    );
  }
  startRenderPass(e, t = !0, n, s, o = 0, r = 0) {
    const l = this._renderTargetSystem.getGpuRenderTarget(e);
    if (r !== 0 && this._renderer.context.webGLVersion < 2)
      throw new Error("[RenderTargetSystem] Rendering to array layers requires WebGL2.");
    if (o > 0) {
      if (l.msaa)
        throw new Error("[RenderTargetSystem] Rendering to mip levels is not supported with MSAA render targets.");
      if (this._renderer.context.webGLVersion < 2)
        throw new Error("[RenderTargetSystem] Rendering to mip levels requires WebGL2.");
    }
    e.colorAttachments.forEach((f) => {
      this._renderer.texture.unbind(f.texture);
    });
    const d = this._renderer.gl;
    this.bindFramebuffer(l.framebuffer), !e.isRoot && e.colorAttachments.length > 0 && (l._attachedMipLevel !== o || l._attachedLayer !== r) && (e.colorAttachments.forEach((f, p) => {
      const y = f.texture, v = this._renderer.texture.getGlSource(y);
      if (v.target === d.TEXTURE_2D) {
        if (r !== 0)
          throw new Error("[RenderTargetSystem] layer must be 0 when rendering to 2D textures in WebGL.");
        d.framebufferTexture2D(
          d.FRAMEBUFFER,
          d.COLOR_ATTACHMENT0 + p,
          d.TEXTURE_2D,
          v.texture,
          o
        );
      } else if (v.target === d.TEXTURE_2D_ARRAY || v.target === d.TEXTURE_3D)
        d.framebufferTextureLayer(
          d.FRAMEBUFFER,
          d.COLOR_ATTACHMENT0 + p,
          v.texture,
          o,
          r
        );
      else if (v.target === d.TEXTURE_CUBE_MAP) {
        if (r < 0 || r > 5)
          throw new Error("[RenderTargetSystem] Cube map layer must be between 0 and 5.");
        d.framebufferTexture2D(
          d.FRAMEBUFFER,
          d.COLOR_ATTACHMENT0 + p,
          d.TEXTURE_CUBE_MAP_POSITIVE_X + r,
          v.texture,
          o
        );
      } else
        throw new Error("[RenderTargetSystem] Unsupported texture target for render-to-layer in WebGL.");
    }), l._attachedMipLevel = o, l._attachedLayer = r), l.framebuffer && (e.depthStencilAttachment ? this._attachDepthStencilTexture(e, o, r) : !l.depthStencilRenderBuffer && (e.stencil || e.depth) && this._initStencil(l)), e.colorAttachments.length > 1 && this._setDrawBuffers(e, d);
    let c = s.y;
    e.isRoot && (c = e.pixelHeight - s.height - s.y);
    const h = this._viewPortCache;
    (h.x !== s.x || h.y !== c || h.width !== s.width || h.height !== s.height) && (h.x = s.x, h.y = c, h.width = s.width, h.height = s.height, d.viewport(
      s.x,
      c,
      s.width,
      s.height
    )), this.clear(e, t, n);
  }
  finishRenderPass(e) {
    const n = this._renderTargetSystem.getGpuRenderTarget(e);
    if (!n.msaa || e.colorAttachments.length === 0) return;
    const s = this._renderer.gl;
    s.bindFramebuffer(s.FRAMEBUFFER, n.resolveTargetFramebuffer), s.bindFramebuffer(s.READ_FRAMEBUFFER, n.framebuffer), s.blitFramebuffer(
      0,
      0,
      n.width,
      n.height,
      0,
      0,
      n.width,
      n.height,
      s.COLOR_BUFFER_BIT,
      s.NEAREST
    ), s.bindFramebuffer(s.FRAMEBUFFER, n.framebuffer), this._boundFramebuffer = n.framebuffer;
  }
  initGpuRenderTarget(e) {
    const n = this._renderer.gl, s = new TQ();
    s._attachedMipLevel = 0, s._attachedLayer = 0;
    const o = e.colorTexture;
    return o instanceof Ai ? (this._renderer.context.ensureCanvasSize(o.resource), s.framebuffer = null, s) : (s.width = e.pixelWidth, s.height = e.pixelHeight, e.colorAttachments.length === 0 ? this._initDepth(e, s) : this._initColor(e, s), e.depthStencilAttachment && this._attachDepthStencilTexture(e, 0, 0), n.bindFramebuffer(n.FRAMEBUFFER, null), this._boundFramebuffer = null, s);
  }
  destroyGpuRenderTarget(e) {
    const t = this._renderer.gl;
    e.framebuffer && (t.deleteFramebuffer(e.framebuffer), e.framebuffer = null), e.resolveTargetFramebuffer && (t.deleteFramebuffer(e.resolveTargetFramebuffer), e.resolveTargetFramebuffer = null), e.depthStencilRenderBuffer && (t.deleteRenderbuffer(e.depthStencilRenderBuffer), e.depthStencilRenderBuffer = null), e.msaaRenderBuffer.forEach((n) => {
      t.deleteRenderbuffer(n);
    }), e.msaaRenderBuffer.length = 0;
  }
  clear(e, t, n, s, o = 0, r = 0) {
    if (!t) return;
    if (r !== 0)
      throw new Error("[RenderTargetSystem] Clearing array layers is not supported in WebGL renderer.");
    const a = this._renderTargetSystem;
    if (typeof t == "boolean" && (t = t ? Mn.ALL : Mn.NONE), e.colorAttachments.length === 0 && (t &= ~Mn.COLOR, !t))
      return;
    const l = this._renderer.gl, d = !!(t & Mn.DEPTH) && !this._renderer.state.depthMaskEnabled;
    if (t & Mn.COLOR) {
      n != null || (n = a.defaultClearColor);
      const c = this._clearColorCache, h = n;
      (c[0] !== h[0] || c[1] !== h[1] || c[2] !== h[2] || c[3] !== h[3]) && (c[0] = h[0], c[1] = h[1], c[2] = h[2], c[3] = h[3], l.clearColor(h[0], h[1], h[2], h[3]));
    }
    d && l.depthMask(!0), l.clear(t), d && l.depthMask(!1);
  }
  resizeGpuRenderTarget(e) {
    if (e.isRoot) return;
    const t = this._renderTargetSystem.getGpuRenderTarget(e);
    t.width = e.pixelWidth, t.height = e.pixelHeight, e.colorAttachments.length > 0 && this._resizeColor(e, t), t.depthStencilRenderBuffer && this._resizeStencil(t), this._boundFramebuffer = void 0;
  }
  _initColor(e, t) {
    const n = this._renderer, s = n.gl, o = s.createFramebuffer();
    if (t.resolveTargetFramebuffer = o, s.bindFramebuffer(s.FRAMEBUFFER, o), e.colorAttachments.forEach((a, l) => {
      const d = a.texture;
      d.antialias && (n.context.supports.msaa ? t.msaa = !0 : dt("[RenderTexture] Antialiasing on textures is not supported in WebGL1")), n.texture.bindSource(d, 0);
      const c = n.texture.getGlSource(d), h = c.texture;
      if (c.target === s.TEXTURE_2D)
        s.framebufferTexture2D(
          s.FRAMEBUFFER,
          s.COLOR_ATTACHMENT0 + l,
          s.TEXTURE_2D,
          h,
          0
        );
      else if (c.target === s.TEXTURE_2D_ARRAY || c.target === s.TEXTURE_3D)
        s.framebufferTextureLayer(
          s.FRAMEBUFFER,
          s.COLOR_ATTACHMENT0 + l,
          h,
          0,
          0
        );
      else if (c.target === s.TEXTURE_CUBE_MAP)
        s.framebufferTexture2D(
          s.FRAMEBUFFER,
          s.COLOR_ATTACHMENT0 + l,
          s.TEXTURE_CUBE_MAP_POSITIVE_X,
          h,
          0
        );
      else
        throw new Error("[RenderTargetSystem] Unsupported texture target for framebuffer attachment.");
    }), t.msaa) {
      const a = s.createFramebuffer();
      t.framebuffer = a, s.bindFramebuffer(s.FRAMEBUFFER, a), e.colorAttachments.forEach((l, d) => {
        const c = s.createRenderbuffer();
        t.msaaRenderBuffer[d] = c;
      });
    } else
      t.framebuffer = o;
    this._resizeColor(e, t);
  }
  _initDepth(e, t) {
    const n = this._renderer;
    if (n.context.webGLVersion < 2)
      throw new Error("[RenderTargetSystem] Depth-only render targets require WebGL2.");
    const s = n.gl, o = s.createFramebuffer();
    t.resolveTargetFramebuffer = o, t.framebuffer = o, s.bindFramebuffer(s.FRAMEBUFFER, o), s.drawBuffers([s.NONE]), s.readBuffer(s.NONE);
  }
  _resizeColor(e, t) {
    const n = e.colorAttachments[0].texture;
    if (t._attachedMipLevel = 0, t._attachedLayer = 0, e.colorAttachments.forEach((s, o) => {
      o !== 0 && s.texture.resize(n.width, n.height, n._resolution);
    }), t.msaa) {
      const s = this._renderer, o = s.gl, r = t.framebuffer;
      o.bindFramebuffer(o.FRAMEBUFFER, r), e.colorAttachments.forEach((a, l) => {
        const d = a.texture;
        s.texture.bindSource(d, 0);
        const h = s.texture.getGlSource(d).internalFormat, f = t.msaaRenderBuffer[l];
        o.bindRenderbuffer(
          o.RENDERBUFFER,
          f
        ), o.renderbufferStorageMultisample(
          o.RENDERBUFFER,
          4,
          h,
          d.pixelWidth,
          d.pixelHeight
        ), o.framebufferRenderbuffer(
          o.FRAMEBUFFER,
          o.COLOR_ATTACHMENT0 + l,
          o.RENDERBUFFER,
          f
        );
      });
    }
  }
  _attachDepthStencilTexture(e, t, n) {
    const s = this._renderer, o = s.gl, r = e.depthStencilAttachment.texture, a = s.texture.getGlSource(r), l = a.texture, d = r.format;
    let c;
    d === "depth24plus-stencil8" || d === "depth32float-stencil8" ? c = o.DEPTH_STENCIL_ATTACHMENT : d === "stencil8" ? c = o.STENCIL_ATTACHMENT : c = o.DEPTH_ATTACHMENT, a.target === o.TEXTURE_2D ? o.framebufferTexture2D(
      o.FRAMEBUFFER,
      c,
      o.TEXTURE_2D,
      l,
      t
    ) : a.target === o.TEXTURE_2D_ARRAY || a.target === o.TEXTURE_3D ? o.framebufferTextureLayer(
      o.FRAMEBUFFER,
      c,
      l,
      t,
      n
    ) : a.target === o.TEXTURE_CUBE_MAP && o.framebufferTexture2D(
      o.FRAMEBUFFER,
      c,
      o.TEXTURE_CUBE_MAP_POSITIVE_X + n,
      l,
      t
    );
  }
  _initStencil(e) {
    if (e.framebuffer === null) return;
    const t = this._renderer.gl, n = t.createRenderbuffer();
    e.depthStencilRenderBuffer = n, t.bindRenderbuffer(
      t.RENDERBUFFER,
      n
    ), t.framebufferRenderbuffer(
      t.FRAMEBUFFER,
      t.DEPTH_STENCIL_ATTACHMENT,
      t.RENDERBUFFER,
      n
    ), this._resizeStencil(e);
  }
  _resizeStencil(e) {
    const t = this._renderer.gl;
    t.bindRenderbuffer(
      t.RENDERBUFFER,
      e.depthStencilRenderBuffer
    ), e.msaa ? t.renderbufferStorageMultisample(
      t.RENDERBUFFER,
      4,
      t.DEPTH24_STENCIL8,
      e.width,
      e.height
    ) : t.renderbufferStorage(
      t.RENDERBUFFER,
      this._renderer.context.webGLVersion === 2 ? t.DEPTH24_STENCIL8 : t.DEPTH_STENCIL,
      e.width,
      e.height
    );
  }
  prerender(e) {
    if (e.colorAttachments.length === 0) return;
    const t = e.colorAttachments[0].texture.resource;
    this._renderer.context.multiView && Ai.test(t) && this._renderer.context.ensureCanvasSize(t);
  }
  postrender(e) {
    if (!this._renderer.context.multiView || e.colorAttachments.length === 0) return;
    const t = e.colorAttachments[0].texture;
    if (Ai.test(t.resource)) {
      const n = this._renderer.context.canvas, s = t;
      s.context2D.drawImage(
        n,
        0,
        s.pixelHeight - n.height
      );
    }
  }
  _setDrawBuffers(e, t) {
    const n = e.colorAttachments.length, s = this._drawBuffersCache[n];
    if (this._renderer.context.webGLVersion === 1) {
      const o = this._renderer.context.extensions.drawBuffers;
      o ? o.drawBuffersWEBGL(s) : dt("[RenderTexture] This WebGL1 context does not support rendering to multiple targets");
    } else
      t.drawBuffers(s);
  }
  /**
   * Forget the GL-call caches (framebuffer binding, viewport, clear color) so the next pass
   * re-applies them. Called via the renderer's `resetState` runner when external GL code may
   * have changed state behind our back.
   */
  resetState() {
    this._boundFramebuffer = void 0, this._viewPortCache = new Tt(), this._clearColorCache = [0, 0, 0, 0];
  }
  /**
   * Binds a framebuffer to `gl.FRAMEBUFFER`, skipping the call when it is already bound.
   * The single blessed way to bind a framebuffer — keeps {@link _boundFramebuffer} coherent.
   * @param framebuffer - the framebuffer to bind
   * @internal
   */
  bindFramebuffer(e) {
    this._boundFramebuffer !== e && (this._boundFramebuffer = e, this._renderer.gl.bindFramebuffer(this._renderer.gl.FRAMEBUFFER, e));
  }
}
class GT extends $y {
  constructor(e) {
    super(e), this.adaptor = new EQ(), this.adaptor.init(e, this);
  }
  /** Called via the renderer's `resetState` runner when mixing Pixi with external GL code. */
  resetState() {
    this.adaptor.resetState();
  }
}
GT.extension = {
  type: [Ie.WebGLSystem],
  name: "renderTarget"
};
class Ly extends bi {
  /**
   * Create a new Buffer Resource.
   * @param options - The options for the buffer resource
   * @param options.buffer - The underlying buffer that this resource is using
   * @param options.offset - The offset of the buffer this resource is using.
   * If not provided, then it will use the offset of the buffer.
   * @param options.size - The size of the buffer this resource is using.
   * If not provided, then it will use the size of the buffer.
   */
  constructor({ buffer: e, offset: t, size: n }) {
    super(), this.uid = Nt("buffer"), this._resourceType = "bufferResource", this._resourceId = Nt("resource"), this._bufferResource = !0, this.destroyed = !1, this.buffer = e, this.offset = t | 0, this.size = n, this.buffer.on("change", this.onBufferChange, this);
  }
  /**
   * The GC tracks the underlying buffer, not this resource — a GC stamp here (see
   * BindGroup._touch) must land on the buffer, or the GC collects it while cached
   * bind groups still reference it.
   * @internal
   */
  get _gcLastUsed() {
    var e, t;
    return (t = (e = this.buffer) == null ? void 0 : e._gcLastUsed) != null ? t : -1;
  }
  set _gcLastUsed(e) {
    this.buffer && (this.buffer._gcLastUsed = e);
  }
  onBufferChange() {
    this._resourceId = Nt("resource"), this.emit("change", this);
  }
  /**
   * Destroys this resource. Make sure the underlying buffer is not used anywhere else
   * if you want to destroy it as well, or code will explode
   * @param destroyBuffer - Should the underlying buffer be destroyed as well?
   */
  destroy(e = !1) {
    this.destroyed = !0, e && this.buffer.destroy(), this.emit("change", this), this.buffer = null, this.removeAllListeners();
  }
}
class RQ extends bi {
  /**
   * @param source - The texture source to view.
   * @param viewDescriptor - The WebGPU texture view descriptor.
   */
  constructor(e, t) {
    super(), this._resourceType = "textureView", this._resourceId = Nt("resource"), this.source = e, this.viewDescriptor = t, this._onChange = this._onChange.bind(this), this._onDestroy = this._onDestroy.bind(this), this.source.on("change", this._onChange), this.source.on("destroy", this._onDestroy);
  }
  _onChange() {
    this.emit("change", this);
  }
  _onDestroy() {
    this.destroy();
  }
  /** Returns whether the underlying source is destroyed. */
  get destroyed() {
    return this.source.destroyed;
  }
  /** Destroys the view and cleans up event listeners. */
  destroy() {
    this.source && (this.source.off("change", this._onChange), this.source.off("destroy", this._onDestroy)), this.emit("destroy", this), this.removeAllListeners();
  }
}
function zQ(i, e) {
  const t = [], n = [`
        var g = s.groups;
        var sS = r.shader;
        var p = s.glProgram;
        var ugS = r.uniformGroup;
        var resources;
    `];
  let s = !1, o = 0;
  const r = e._getProgramData(i.glProgram);
  for (const l in i.groups) {
    const d = i.groups[l];
    t.push(`
            resources = g[${l}].resources;
        `);
    for (const c in d.resources) {
      const h = d.resources[c];
      if (h instanceof Ts)
        if (h.ubo) {
          const f = i._uniformBindMap[l][Number(c)];
          t.push(`
                        sS.bindUniformBlock(
                            resources[${c}],
                            '${f}',
                            ${i.glProgram._uniformBlockData[f].index}
                        );
                    `);
        } else
          t.push(`
                        ugS.updateUniformGroup(resources[${c}], p, sD);
                    `);
      else if (h instanceof Ly) {
        const f = i._uniformBindMap[l][Number(c)];
        t.push(`
                    sS.bindUniformBlock(
                        resources[${c}],
                        '${f}',
                        ${i.glProgram._uniformBlockData[f].index}
                    );
                `);
      } else if (h instanceof un || h instanceof RQ) {
        const f = i._uniformBindMap[l][c], p = r.uniformData[f];
        p && (s || (s = !0, n.push(`
                        var tS = r.texture;
                        `)), e._gl.uniform1i(p.location, o), t.push(`
                        tS.bind(resources[${c}], ${o});
                    `), o++);
      }
    }
  }
  const a = [...n, ...t].join(`
`);
  return new Function("r", "s", "sD", a);
}
class $Q {
  /**
   * Makes a new Pixi program.
   * @param program - webgl program
   * @param uniformData - uniforms
   */
  constructor(e, t) {
    this.program = e, this.uniformData = t, this.uniformGroups = {}, this.uniformDirtyGroups = {}, this.uniformBlockBindings = {};
  }
  /** Destroys this program. */
  destroy() {
    this.uniformData = null, this.uniformGroups = null, this.uniformDirtyGroups = null, this.uniformBlockBindings = null, this.program = null;
  }
}
function B2(i, e, t) {
  const n = i.createShader(e);
  return i.shaderSource(n, t), i.compileShader(n), n;
}
function Wg(i) {
  const e = new Array(i);
  for (let t = 0; t < e.length; t++)
    e[t] = !1;
  return e;
}
function jT(i, e) {
  switch (i) {
    case "float":
      return 0;
    case "vec2":
      return new Float32Array(2 * e);
    case "vec3":
      return new Float32Array(3 * e);
    case "vec4":
      return new Float32Array(4 * e);
    case "int":
    case "uint":
    case "sampler2D":
    case "sampler2DArray":
    case "sampler3D":
      return 0;
    case "ivec2":
      return new Int32Array(2 * e);
    case "ivec3":
      return new Int32Array(3 * e);
    case "ivec4":
      return new Int32Array(4 * e);
    case "uvec2":
      return new Uint32Array(2 * e);
    case "uvec3":
      return new Uint32Array(3 * e);
    case "uvec4":
      return new Uint32Array(4 * e);
    case "bool":
      return !1;
    case "bvec2":
      return Wg(2 * e);
    case "bvec3":
      return Wg(3 * e);
    case "bvec4":
      return Wg(4 * e);
    case "mat2":
      return new Float32Array([
        1,
        0,
        0,
        1
      ]);
    case "mat3":
      return new Float32Array([
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ]);
    case "mat4":
      return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]);
  }
  return null;
}
let gh = null;
const F2 = {
  FLOAT: "float",
  FLOAT_VEC2: "vec2",
  FLOAT_VEC3: "vec3",
  FLOAT_VEC4: "vec4",
  INT: "int",
  INT_VEC2: "ivec2",
  INT_VEC3: "ivec3",
  INT_VEC4: "ivec4",
  UNSIGNED_INT: "uint",
  UNSIGNED_INT_VEC2: "uvec2",
  UNSIGNED_INT_VEC3: "uvec3",
  UNSIGNED_INT_VEC4: "uvec4",
  BOOL: "bool",
  BOOL_VEC2: "bvec2",
  BOOL_VEC3: "bvec3",
  BOOL_VEC4: "bvec4",
  FLOAT_MAT2: "mat2",
  FLOAT_MAT3: "mat3",
  FLOAT_MAT4: "mat4",
  SAMPLER_2D: "sampler2D",
  INT_SAMPLER_2D: "sampler2D",
  UNSIGNED_INT_SAMPLER_2D: "sampler2D",
  SAMPLER_2D_SHADOW: "sampler2DShadow",
  SAMPLER_CUBE: "samplerCube",
  INT_SAMPLER_CUBE: "samplerCube",
  UNSIGNED_INT_SAMPLER_CUBE: "samplerCube",
  SAMPLER_CUBE_SHADOW: "samplerCubeShadow",
  SAMPLER_2D_ARRAY: "sampler2DArray",
  INT_SAMPLER_2D_ARRAY: "sampler2DArray",
  UNSIGNED_INT_SAMPLER_2D_ARRAY: "sampler2DArray",
  SAMPLER_2D_ARRAY_SHADOW: "sampler2DArrayShadow",
  SAMPLER_3D: "sampler3D",
  INT_SAMPLER_3D: "sampler3D",
  UNSIGNED_INT_SAMPLER_3D: "sampler3D"
}, DQ = {
  float: "float32",
  vec2: "float32x2",
  vec3: "float32x3",
  vec4: "float32x4",
  int: "sint32",
  ivec2: "sint32x2",
  ivec3: "sint32x3",
  ivec4: "sint32x4",
  uint: "uint32",
  uvec2: "uint32x2",
  uvec3: "uint32x3",
  uvec4: "uint32x4",
  bool: "uint32",
  bvec2: "uint32x2",
  bvec3: "uint32x3",
  bvec4: "uint32x4"
};
function HT(i, e) {
  if (!gh) {
    const t = Object.keys(F2);
    gh = {};
    for (let n = 0; n < t.length; ++n) {
      const s = t[n];
      gh[i[s]] = F2[s];
    }
  }
  return gh[e];
}
function OQ(i, e) {
  const t = HT(i, e);
  return DQ[t] || "float32";
}
function LQ(i, e, t = !1) {
  const n = {}, s = e.getProgramParameter(i, e.ACTIVE_ATTRIBUTES);
  for (let r = 0; r < s; r++) {
    const a = e.getActiveAttrib(i, r);
    if (a.name.startsWith("gl_"))
      continue;
    const l = OQ(e, a.type);
    n[a.name] = {
      location: 0,
      // set further down..
      format: l,
      stride: Hc(l).stride,
      offset: 0,
      instance: !1,
      start: 0
    };
  }
  const o = Object.keys(n);
  if (t) {
    o.sort((r, a) => r > a ? 1 : -1);
    for (let r = 0; r < o.length; r++)
      n[o[r]].location = r, e.bindAttribLocation(i, r, o[r]);
    e.linkProgram(i);
  } else
    for (let r = 0; r < o.length; r++)
      n[o[r]].location = e.getAttribLocation(i, o[r]);
  return n;
}
function BQ(i, e) {
  if (!e.ACTIVE_UNIFORM_BLOCKS) return {};
  const t = {}, n = e.getProgramParameter(i, e.ACTIVE_UNIFORM_BLOCKS);
  for (let s = 0; s < n; s++) {
    const o = e.getActiveUniformBlockName(i, s), r = e.getUniformBlockIndex(i, o), a = e.getActiveUniformBlockParameter(i, s, e.UNIFORM_BLOCK_DATA_SIZE);
    t[o] = {
      name: o,
      index: r,
      size: a
    };
  }
  return t;
}
function FQ(i, e) {
  const t = {}, n = e.getProgramParameter(i, e.ACTIVE_UNIFORMS);
  for (let s = 0; s < n; s++) {
    const o = e.getActiveUniform(i, s), r = o.name.replace(/\[.*?\]$/, ""), a = !!o.name.match(/\[.*?\]$/), l = HT(e, o.type);
    t[r] = {
      name: r,
      index: s,
      type: l,
      size: o.size,
      isArray: a,
      value: jT(l, o.size)
    };
  }
  return t;
}
function N2(i, e) {
  var c;
  const t = i.getShaderSource(e);
  if (t === null) {
    console.error("PixiJS Error: Could not retrieve shader source (WebGL context may be lost).");
    return;
  }
  const n = t.split(`
`).map((h, f) => `${f}: ${h}`), s = (c = i.getShaderInfoLog(e)) != null ? c : "", o = s.split(`
`), r = {}, a = o.map((h) => parseFloat(h.replace(/^ERROR\: 0\:([\d]+)\:.*$/, "$1"))).filter((h) => h && !r[h] ? (r[h] = !0, !0) : !1), l = [""];
  a.forEach((h) => {
    n[h - 1] = `%c${n[h - 1]}%c`, l.push("background: #FF0000; color:#FFFFFF; font-size: 10px", "font-size: 10px");
  });
  const d = n.join(`
`);
  l[0] = d, console.error(s), console.groupCollapsed("click to view full shader code"), console.warn(...l), console.groupEnd();
}
function NQ(i, e, t, n) {
  i.getProgramParameter(e, i.LINK_STATUS) || (i.getShaderParameter(t, i.COMPILE_STATUS) || N2(i, t), i.getShaderParameter(n, i.COMPILE_STATUS) || N2(i, n), console.error("PixiJS Error: Could not initialize shader."), i.getProgramInfoLog(e) !== "" && console.warn("PixiJS Warning: gl.getProgramInfoLog()", i.getProgramInfoLog(e)));
}
function UQ(i, e) {
  const t = B2(i, i.VERTEX_SHADER, e.vertex), n = B2(i, i.FRAGMENT_SHADER, e.fragment), s = i.createProgram();
  i.attachShader(s, t), i.attachShader(s, n);
  const o = e.transformFeedbackVaryings;
  o && (typeof i.transformFeedbackVaryings != "function" ? dt("TransformFeedback is not supported but TransformFeedbackVaryings are given.") : i.transformFeedbackVaryings(
    s,
    o.names,
    o.bufferMode === "separate" ? i.SEPARATE_ATTRIBS : i.INTERLEAVED_ATTRIBS
  )), i.linkProgram(s), i.getProgramParameter(s, i.LINK_STATUS) || NQ(i, s, t, n), e._attributeData = LQ(
    s,
    i,
    !/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(e.vertex)
  ), e._uniformData = FQ(s, i), e._uniformBlockData = BQ(s, i), i.deleteShader(t), i.deleteShader(n);
  const r = {};
  for (const l in e._uniformData) {
    const d = e._uniformData[l];
    r[l] = {
      location: i.getUniformLocation(s, l),
      value: jT(d.type, d.size)
    };
  }
  return new $Q(s, r);
}
const bh = {
  textureCount: 0,
  blockIndex: 0
};
class VT {
  constructor(e) {
    this._activeProgram = null, this._programDataHash = /* @__PURE__ */ Object.create(null), this._shaderSyncFunctions = /* @__PURE__ */ Object.create(null), this._renderer = e;
  }
  contextChange(e) {
    this._gl = e, this._programDataHash = /* @__PURE__ */ Object.create(null), this._shaderSyncFunctions = /* @__PURE__ */ Object.create(null), this._activeProgram = null;
  }
  /**
   * Changes the current shader to the one given in parameter.
   * @param shader - the new shader
   * @param skipSync - false if the shader should automatically sync its uniforms.
   * @returns the glProgram that belongs to the shader.
   */
  bind(e, t) {
    if (this._setProgram(e.glProgram), t) return;
    bh.textureCount = 0, bh.blockIndex = 0;
    let n = this._shaderSyncFunctions[e.glProgram._key];
    n || (n = this._shaderSyncFunctions[e.glProgram._key] = this._generateShaderSync(e, this)), this._renderer.buffer.nextBindBase(!!e.glProgram.transformFeedbackVaryings), n(this._renderer, e, bh);
  }
  /**
   * Updates the uniform group.
   * @param uniformGroup - the uniform group to update
   */
  updateUniformGroup(e) {
    this._renderer.uniformGroup.updateUniformGroup(e, this._activeProgram, bh);
  }
  /**
   * Binds a uniform block to the shader.
   * @param uniformGroup - the uniform group to bind
   * @param name - the name of the uniform block
   * @param index - the index of the uniform block
   */
  bindUniformBlock(e, t, n = 0) {
    const s = this._renderer.buffer, o = this._getProgramData(this._activeProgram), r = e._bufferResource;
    r || this._renderer.ubo.updateUniformGroup(e);
    const a = e.buffer, l = s.updateBuffer(a), d = s.freeLocationForBufferBase(l);
    if (r) {
      const { offset: h, size: f } = e;
      h === 0 && f === a.data.byteLength ? s.bindBufferBase(l, d) : s.bindBufferRange(l, d, h);
    } else s.getLastBindBaseLocation(l) !== d && s.bindBufferBase(l, d);
    const c = this._activeProgram._uniformBlockData[t].index;
    o.uniformBlockBindings[n] !== d && (o.uniformBlockBindings[n] = d, this._renderer.gl.uniformBlockBinding(o.program, c, d));
  }
  _setProgram(e) {
    if (this._activeProgram === e) return;
    this._activeProgram = e;
    const t = this._getProgramData(e);
    this._gl.useProgram(t.program);
  }
  /**
   * @param program - the program to get the data for
   * @internal
   */
  _getProgramData(e) {
    return this._programDataHash[e._key] || this._createProgramData(e);
  }
  _createProgramData(e) {
    const t = e._key;
    return this._programDataHash[t] = UQ(this._gl, e), this._programDataHash[t];
  }
  destroy() {
    for (const e of Object.keys(this._programDataHash))
      this._programDataHash[e].destroy();
    this._programDataHash = null, this._shaderSyncFunctions = null, this._activeProgram = null, this._renderer = null, this._gl = null;
  }
  /**
   * Creates a function that can be executed that will sync the shader as efficiently as possible.
   * Overridden by the unsafe eval package if you don't want eval used in your project.
   * @param shader - the shader to generate the sync function for
   * @param shaderSystem - the shader system to use
   * @returns - the generated sync function
   * @ignore
   */
  _generateShaderSync(e, t) {
    return zQ(e, t);
  }
  resetState() {
    this._activeProgram = null;
  }
}
VT.extension = {
  type: [
    Ie.WebGLSystem
  ],
  name: "shader"
};
const GQ = {
  f32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1f(location, v);
        }`,
  "vec2<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2f(location, v[0], v[1]);
        }`,
  "vec3<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3f(location, v[0], v[1], v[2]);
        }`,
  "vec4<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4f(location, v[0], v[1], v[2], v[3]);
        }`,
  i32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1i(location, v);
        }`,
  "vec2<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2i(location, v[0], v[1]);
        }`,
  "vec3<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3i(location, v[0], v[1], v[2]);
        }`,
  "vec4<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4i(location, v[0], v[1], v[2], v[3]);
        }`,
  u32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1ui(location, v);
        }`,
  "vec2<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2ui(location, v[0], v[1]);
        }`,
  "vec3<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3ui(location, v[0], v[1], v[2]);
        }`,
  "vec4<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4ui(location, v[0], v[1], v[2], v[3]);
        }`,
  bool: `if (cv !== v) {
            cu.value = v;
            gl.uniform1i(location, v);
        }`,
  "vec2<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2i(location, v[0], v[1]);
        }`,
  "vec3<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3i(location, v[0], v[1], v[2]);
        }`,
  "vec4<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4i(location, v[0], v[1], v[2], v[3]);
        }`,
  "mat2x2<f32>": "gl.uniformMatrix2fv(location, false, v);",
  "mat3x3<f32>": "gl.uniformMatrix3fv(location, false, v);",
  "mat4x4<f32>": "gl.uniformMatrix4fv(location, false, v);"
}, jQ = {
  f32: "gl.uniform1fv(location, v);",
  "vec2<f32>": "gl.uniform2fv(location, v);",
  "vec3<f32>": "gl.uniform3fv(location, v);",
  "vec4<f32>": "gl.uniform4fv(location, v);",
  "mat2x2<f32>": "gl.uniformMatrix2fv(location, false, v);",
  "mat3x3<f32>": "gl.uniformMatrix3fv(location, false, v);",
  "mat4x4<f32>": "gl.uniformMatrix4fv(location, false, v);",
  i32: "gl.uniform1iv(location, v);",
  "vec2<i32>": "gl.uniform2iv(location, v);",
  "vec3<i32>": "gl.uniform3iv(location, v);",
  "vec4<i32>": "gl.uniform4iv(location, v);",
  u32: "gl.uniform1iv(location, v);",
  "vec2<u32>": "gl.uniform2iv(location, v);",
  "vec3<u32>": "gl.uniform3iv(location, v);",
  "vec4<u32>": "gl.uniform4iv(location, v);",
  bool: "gl.uniform1iv(location, v);",
  "vec2<bool>": "gl.uniform2iv(location, v);",
  "vec3<bool>": "gl.uniform3iv(location, v);",
  "vec4<bool>": "gl.uniform4iv(location, v);"
};
function HQ(i, e) {
  const t = [`
        var v = null;
        var cv = null;
        var cu = null;
        var t = 0;
        var gl = renderer.gl;
        var name = null;
    `];
  for (const n in i.uniforms) {
    if (!e[n]) {
      i.uniforms[n] instanceof Ts ? i.uniforms[n].ubo ? t.push(`
                        renderer.shader.bindUniformBlock(uv.${n}, "${n}");
                    `) : t.push(`
                        renderer.shader.updateUniformGroup(uv.${n});
                    `) : i.uniforms[n] instanceof Ly && t.push(`
                        renderer.shader.bindBufferResource(uv.${n}, "${n}");
                    `);
      continue;
    }
    const s = i.uniformStructures[n];
    let o = !1;
    for (let r = 0; r < gl.length; r++) {
      const a = gl[r];
      if (s.type === a.type && a.test(s)) {
        t.push(`name = "${n}";`, gl[r].uniform), o = !0;
        break;
      }
    }
    if (!o) {
      const a = (s.size === 1 ? GQ : jQ)[s.type].replace("location", `ud["${n}"].location`);
      t.push(`
            cu = ud["${n}"];
            cv = cu.value;
            v = uv["${n}"];
            ${a};`);
    }
  }
  return new Function("ud", "uv", "renderer", "syncData", t.join(`
`));
}
class WT {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._cache = {}, this._uniformGroupSyncHash = {}, this._renderer = e, this.gl = null, this._cache = {};
  }
  contextChange(e) {
    this.gl = e;
  }
  /**
   * Uploads the uniforms values to the currently bound shader.
   * @param group - the uniforms values that be applied to the current shader
   * @param program
   * @param syncData
   * @param syncData.textureCount
   */
  updateUniformGroup(e, t, n) {
    const s = this._renderer.shader._getProgramData(t);
    (!e.isStatic || e._dirtyId !== s.uniformDirtyGroups[e.uid]) && (s.uniformDirtyGroups[e.uid] = e._dirtyId, this._getUniformSyncFunction(e, t)(s.uniformData, e.uniforms, this._renderer, n));
  }
  /**
   * Overridable by the pixi.js/unsafe-eval package to use static syncUniforms instead.
   * @param group
   * @param program
   */
  _getUniformSyncFunction(e, t) {
    var n;
    return ((n = this._uniformGroupSyncHash[e._signature]) == null ? void 0 : n[t._key]) || this._createUniformSyncFunction(e, t);
  }
  _createUniformSyncFunction(e, t) {
    const n = this._uniformGroupSyncHash[e._signature] || (this._uniformGroupSyncHash[e._signature] = {}), s = this._getSignature(e, t._uniformData, "u");
    return this._cache[s] || (this._cache[s] = this._generateUniformsSync(e, t._uniformData)), n[t._key] = this._cache[s], n[t._key];
  }
  _generateUniformsSync(e, t) {
    return HQ(e, t);
  }
  /**
   * Takes a uniform group and data and generates a unique signature for them.
   * @param group - The uniform group to get signature of
   * @param group.uniforms
   * @param uniformData - Uniform information generated by the shader
   * @param preFix
   * @returns Unique signature of the uniform group
   */
  _getSignature(e, t, n) {
    const s = e.uniforms, o = [`${n}-`];
    for (const r in s)
      o.push(r), t[r] && o.push(t[r].type);
    return o.join("-");
  }
  /** Destroys this System and removes all its textures. */
  destroy() {
    this._renderer = null, this._cache = null;
  }
}
WT.extension = {
  type: [
    Ie.WebGLSystem
  ],
  name: "uniformGroup"
};
function VQ(i) {
  const e = {};
  if (e.normal = [i.ONE, i.ONE_MINUS_SRC_ALPHA], e.add = [i.ONE, i.ONE], e.multiply = [i.DST_COLOR, i.ONE_MINUS_SRC_ALPHA, i.ONE, i.ONE_MINUS_SRC_ALPHA], e.screen = [i.ONE, i.ONE_MINUS_SRC_COLOR, i.ONE, i.ONE_MINUS_SRC_ALPHA], e.none = [0, 0], e["normal-npm"] = [i.SRC_ALPHA, i.ONE_MINUS_SRC_ALPHA, i.ONE, i.ONE_MINUS_SRC_ALPHA], e["add-npm"] = [i.SRC_ALPHA, i.ONE, i.ONE, i.ONE], e["screen-npm"] = [i.SRC_ALPHA, i.ONE_MINUS_SRC_COLOR, i.ONE, i.ONE_MINUS_SRC_ALPHA], e.erase = [i.ZERO, i.ONE_MINUS_SRC_ALPHA], !(i instanceof zt.get().getWebGLRenderingContext()))
    e.min = [i.ONE, i.ONE, i.ONE, i.ONE, i.MIN, i.MIN], e.max = [i.ONE, i.ONE, i.ONE, i.ONE, i.MAX, i.MAX];
  else {
    const n = i.getExtension("EXT_blend_minmax");
    n && (e.min = [i.ONE, i.ONE, i.ONE, i.ONE, n.MIN_EXT, n.MIN_EXT], e.max = [i.ONE, i.ONE, i.ONE, i.ONE, n.MAX_EXT, n.MAX_EXT]);
  }
  return e;
}
const { BLEND: WQ, OFFSET: qQ, CULLING: KQ, DEPTH_TEST: YQ, WINDING: XQ, DEPTH_MASK: U2 } = WS, qT = class f0 {
  constructor(e) {
    this._invertFrontFace = !1, this._renderer = e, this.gl = null, this.stateId = 0, this.polygonOffset = 0, this.blendMode = "none", this._blendEq = !1, this.map = [], this.map[WQ] = this.setBlend, this.map[qQ] = this.setOffset, this.map[KQ] = this.setCullFace, this.map[YQ] = this.setDepthTest, this.map[XQ] = this.setFrontFace, this.map[U2] = this.setDepthMask, this.checks = [], this.defaultState = co.for2d(), e.renderTarget.onRenderTargetChange.add(this);
  }
  onRenderTargetChange(e) {
    this._invertFrontFace = this._renderer.renderTarget.isFrontFaceInverted(e, e.flipY), this._cullFace ? this.setFrontFace(this._frontFace) : this._frontFaceDirty = !0;
  }
  contextChange(e) {
    this.gl = e, this.blendModesMap = VQ(e), this.resetState();
  }
  /**
   * Sets the current state
   * @param {*} state - The state to set.
   */
  set(e) {
    if (e || (e = this.defaultState), this.stateId !== e.data) {
      let t = this.stateId ^ e.data, n = 0;
      for (; t; )
        t & 1 && this.map[n].call(this, !!(e.data & 1 << n)), t >>= 1, n++;
      this.stateId = e.data;
    }
    for (let t = 0; t < this.checks.length; t++)
      this.checks[t](this, e);
  }
  /**
   * Sets the state, when previous state is unknown.
   * @param {*} state - The state to set
   */
  forceState(e) {
    e || (e = this.defaultState);
    for (let t = 0; t < this.map.length; t++)
      this.map[t].call(this, !!(e.data & 1 << t));
    for (let t = 0; t < this.checks.length; t++)
      this.checks[t](this, e);
    this.stateId = e.data;
  }
  /**
   * Sets whether to enable or disable blending.
   * @param value - Turn on or off WebGl blending.
   */
  setBlend(e) {
    this._updateCheck(f0._checkBlendMode, e), this.gl[e ? "enable" : "disable"](this.gl.BLEND);
  }
  /**
   * Sets whether to enable or disable polygon offset fill.
   * @param value - Turn on or off webgl polygon offset testing.
   */
  setOffset(e) {
    this._updateCheck(f0._checkPolygonOffset, e), this.gl[e ? "enable" : "disable"](this.gl.POLYGON_OFFSET_FILL);
  }
  /**
   * Sets whether to enable or disable depth test.
   * @param value - Turn on or off webgl depth testing.
   */
  setDepthTest(e) {
    this.gl[e ? "enable" : "disable"](this.gl.DEPTH_TEST);
  }
  /**
   * Sets whether to enable or disable depth mask.
   * @param value - Turn on or off webgl depth mask.
   */
  setDepthMask(e) {
    this.gl.depthMask(e);
  }
  /**
   * Whether depth writes are currently enabled on the GL context, as last applied by this
   * system. `gl.clear` is masked by this state, so depth clears must consult it.
   * @internal
   */
  get depthMaskEnabled() {
    return !!(this.stateId & 1 << U2);
  }
  /**
   * Sets whether to enable or disable cull face.
   * @param {boolean} value - Turn on or off webgl cull face.
   */
  setCullFace(e) {
    this._cullFace = e, this.gl[e ? "enable" : "disable"](this.gl.CULL_FACE), this._cullFace && this._frontFaceDirty && this.setFrontFace(this._frontFace);
  }
  /**
   * Sets the gl front face.
   * @param {boolean} value - true is clockwise and false is counter-clockwise
   */
  setFrontFace(e) {
    this._frontFace = e, this._frontFaceDirty = !1;
    const t = this._invertFrontFace ? !e : e;
    this._glFrontFace !== t && (this._glFrontFace = t, this.gl.frontFace(this.gl[t ? "CW" : "CCW"]));
  }
  /**
   * Sets the blend mode.
   * @param {number} value - The blend mode to set to.
   */
  setBlendMode(e) {
    if (this.blendModesMap[e] || (e = "normal"), e === this.blendMode)
      return;
    this.blendMode = e;
    const t = this.blendModesMap[e], n = this.gl;
    t.length === 2 ? n.blendFunc(t[0], t[1]) : n.blendFuncSeparate(t[0], t[1], t[2], t[3]), t.length === 6 ? (this._blendEq = !0, n.blendEquationSeparate(t[4], t[5])) : this._blendEq && (this._blendEq = !1, n.blendEquationSeparate(n.FUNC_ADD, n.FUNC_ADD));
  }
  /**
   * Sets the polygon offset.
   * @param {number} value - the polygon offset
   * @param {number} scale - the polygon offset scale
   */
  setPolygonOffset(e, t) {
    this.gl.polygonOffset(e, t);
  }
  /** Resets all the logic and disables the VAOs. */
  resetState() {
    this._glFrontFace = !1, this._frontFace = !1, this._cullFace = !1, this._frontFaceDirty = !1, this._invertFrontFace = !1, this.gl.frontFace(this.gl.CCW), this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, !1), this.forceState(this.defaultState), this._blendEq = !0, this.blendMode = "", this.setBlendMode("normal");
  }
  /**
   * Checks to see which updates should be checked based on which settings have been activated.
   *
   * For example, if blend is enabled then we should check the blend modes each time the state is changed
   * or if polygon fill is activated then we need to check if the polygon offset changes.
   * The idea is that we only check what we have too.
   * @param func - the checking function to add or remove
   * @param value - should the check function be added or removed.
   */
  _updateCheck(e, t) {
    const n = this.checks.indexOf(e);
    t && n === -1 ? this.checks.push(e) : !t && n !== -1 && this.checks.splice(n, 1);
  }
  /**
   * A private little wrapper function that we call to check the blend mode.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */
  static _checkBlendMode(e, t) {
    e.setBlendMode(t.blendMode);
  }
  /**
   * A private little wrapper function that we call to check the polygon offset.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */
  static _checkPolygonOffset(e, t) {
    e.setPolygonOffset(1, t.polygonOffset);
  }
  /** @ignore */
  destroy() {
    this.gl = null, this.checks.length = 0, this._renderer = null;
  }
};
qT.extension = {
  type: [
    Ie.WebGLSystem
  ],
  name: "state"
};
let JQ = qT;
class ZQ {
  constructor(e) {
    this.target = Jc.TEXTURE_2D, this._layerInitMask = 0, this.texture = e, this.width = -1, this.height = -1, this.type = At.UNSIGNED_BYTE, this.internalFormat = p0.RGBA, this.format = p0.RGBA, this.samplerType = 0;
  }
  destroy() {
  }
}
function KT(i, e, t, n, s) {
  if (i = Math.max(0, i), e = Math.min(e, t * n), i >= e) return 0;
  const o = Math.floor(i / t), r = i - o * t, a = Math.floor(e / t), l = e - a * t;
  if (o === a)
    return s[0].set(r, o, l - r, 1), 1;
  let d = 0, c = o;
  return r > 0 && (s[d++].set(r, o, t - r, 1), c++), a > c && s[d++].set(0, c, t, a - c), l > 0 && s[d++].set(0, a, l, 1), d;
}
const G2 = [new Tt(), new Tt(), new Tt()], QQ = {
  id: "buffer",
  upload(i, e, t, n, s, o = !1) {
    const r = s || e.target, a = i.resource;
    if (r === Jc.TEXTURE_3D || r === Jc.TEXTURE_2D_ARRAY) {
      o || e.width !== i.width || e.height !== i.height ? t.texImage3D(
        r,
        0,
        e.internalFormat,
        i.width,
        i.height,
        i.depthOrArrayLayers,
        0,
        e.format,
        e.type,
        a
      ) : t.texSubImage3D(
        r,
        0,
        0,
        0,
        0,
        i.width,
        i.height,
        i.depthOrArrayLayers,
        e.format,
        e.type,
        a
      ), e.width = i.width, e.height = i.height;
      return;
    }
    const l = i.width * i.height, d = o || e.width !== i.width || e.height !== i.height, c = i._updateStart > 0 || i._updateEnd < l;
    if (d)
      t.texImage2D(
        r,
        0,
        e.internalFormat,
        i.width,
        i.height,
        0,
        e.format,
        e.type,
        a
      );
    else if (c) {
      const h = a.length / l, f = KT(
        i._updateStart,
        i._updateEnd,
        i.width,
        i.height,
        G2
      );
      for (let p = 0; p < f; p++) {
        const y = G2[p], v = (y.y * i.width + y.x) * h;
        t.texSubImage2D(
          r,
          0,
          y.x,
          y.y,
          y.width,
          y.height,
          e.format,
          e.type,
          a.subarray(v, v + y.width * y.height * h)
        );
      }
    } else
      t.texSubImage2D(
        r,
        0,
        0,
        0,
        i.width,
        i.height,
        e.format,
        e.type,
        a
      );
    e.width = i.width, e.height = i.height;
  }
}, eee = {
  "bc1-rgba-unorm": !0,
  "bc1-rgba-unorm-srgb": !0,
  "bc2-rgba-unorm": !0,
  "bc2-rgba-unorm-srgb": !0,
  "bc3-rgba-unorm": !0,
  "bc3-rgba-unorm-srgb": !0,
  "bc4-r-unorm": !0,
  "bc4-r-snorm": !0,
  "bc5-rg-unorm": !0,
  "bc5-rg-snorm": !0,
  "bc6h-rgb-ufloat": !0,
  "bc6h-rgb-float": !0,
  "bc7-rgba-unorm": !0,
  "bc7-rgba-unorm-srgb": !0,
  // ETC2 compressed formats usable if "texture-compression-etc2" is both
  // supported by the device/user agent and enabled in requestDevice.
  "etc2-rgb8unorm": !0,
  "etc2-rgb8unorm-srgb": !0,
  "etc2-rgb8a1unorm": !0,
  "etc2-rgb8a1unorm-srgb": !0,
  "etc2-rgba8unorm": !0,
  "etc2-rgba8unorm-srgb": !0,
  "eac-r11unorm": !0,
  "eac-r11snorm": !0,
  "eac-rg11unorm": !0,
  "eac-rg11snorm": !0,
  // ASTC compressed formats usable if "texture-compression-astc" is both
  // supported by the device/user agent and enabled in requestDevice.
  "astc-4x4-unorm": !0,
  "astc-4x4-unorm-srgb": !0,
  "astc-5x4-unorm": !0,
  "astc-5x4-unorm-srgb": !0,
  "astc-5x5-unorm": !0,
  "astc-5x5-unorm-srgb": !0,
  "astc-6x5-unorm": !0,
  "astc-6x5-unorm-srgb": !0,
  "astc-6x6-unorm": !0,
  "astc-6x6-unorm-srgb": !0,
  "astc-8x5-unorm": !0,
  "astc-8x5-unorm-srgb": !0,
  "astc-8x6-unorm": !0,
  "astc-8x6-unorm-srgb": !0,
  "astc-8x8-unorm": !0,
  "astc-8x8-unorm-srgb": !0,
  "astc-10x5-unorm": !0,
  "astc-10x5-unorm-srgb": !0,
  "astc-10x6-unorm": !0,
  "astc-10x6-unorm-srgb": !0,
  "astc-10x8-unorm": !0,
  "astc-10x8-unorm-srgb": !0,
  "astc-10x10-unorm": !0,
  "astc-10x10-unorm-srgb": !0,
  "astc-12x10-unorm": !0,
  "astc-12x10-unorm-srgb": !0,
  "astc-12x12-unorm": !0,
  "astc-12x12-unorm-srgb": !0
}, tee = {
  id: "compressed",
  upload(i, e, t, n, s, o) {
    const r = s != null ? s : e.target;
    t.pixelStorei(t.UNPACK_ALIGNMENT, 4);
    let a = i.pixelWidth, l = i.pixelHeight;
    const d = !!eee[i.format];
    for (let c = 0; c < i.resource.length; c++) {
      const h = i.resource[c];
      d ? t.compressedTexImage2D(
        r,
        c,
        e.internalFormat,
        a,
        l,
        0,
        h
      ) : t.texImage2D(
        r,
        c,
        e.internalFormat,
        a,
        l,
        0,
        e.format,
        e.type,
        h
      ), a = Math.max(a >> 1, 1), l = Math.max(l >> 1, 1);
    }
  }
}, j2 = ["right", "left", "top", "bottom", "front", "back"];
function nee(i) {
  return {
    id: "cube",
    upload(e, t, n, s) {
      const o = e.faces;
      for (let r = 0; r < j2.length; r++) {
        const a = j2[r], l = o[a];
        if (!l.resource) continue;
        (i[l.uploadMethodId] || i.image).upload(
          l,
          t,
          n,
          s,
          // Use the face target for the current face. cube faces ids go up 1 so
          // GL_TARGETS.TEXTURE_CUBE_MAP_POSITIVE_X + i addresses the i'th face target.
          Jc.TEXTURE_CUBE_MAP_POSITIVE_X + r,
          // Force allocation for the first upload of each face.
          (t._layerInitMask & 1 << r) === 0
        ), t._layerInitMask |= 1 << r;
      }
      t.width = e.pixelWidth, t.height = e.pixelHeight;
    }
  };
}
const YT = {
  id: "image",
  upload(i, e, t, n, s, o = !1) {
    const r = s || e.target, a = i.pixelWidth, l = i.pixelHeight, d = i.resourceWidth, c = i.resourceHeight, h = n === 2, f = o || e.width !== a || e.height !== l, p = d >= a && c >= l, y = i.resource;
    (h ? iee : see)(
      t,
      r,
      e,
      a,
      l,
      d,
      c,
      y,
      f,
      p
    ), e.width = a, e.height = l;
  }
};
function iee(i, e, t, n, s, o, r, a, l, d) {
  if (!d) {
    l && i.texImage2D(
      e,
      0,
      t.internalFormat,
      n,
      s,
      0,
      t.format,
      t.type,
      null
    ), i.texSubImage2D(
      e,
      0,
      0,
      0,
      o,
      r,
      t.format,
      t.type,
      a
    );
    return;
  }
  if (!l) {
    i.texSubImage2D(
      e,
      0,
      0,
      0,
      t.format,
      t.type,
      a
    );
    return;
  }
  i.texImage2D(
    e,
    0,
    t.internalFormat,
    n,
    s,
    0,
    t.format,
    t.type,
    a
  );
}
function see(i, e, t, n, s, o, r, a, l, d) {
  if (!d) {
    l && i.texImage2D(
      e,
      0,
      t.internalFormat,
      n,
      s,
      0,
      t.format,
      t.type,
      null
    ), i.texSubImage2D(
      e,
      0,
      0,
      0,
      t.format,
      t.type,
      a
    );
    return;
  }
  if (!l) {
    i.texSubImage2D(
      e,
      0,
      0,
      0,
      t.format,
      t.type,
      a
    );
    return;
  }
  i.texImage2D(
    e,
    0,
    t.internalFormat,
    t.format,
    t.type,
    a
  );
}
const oee = CZ(), ree = {
  id: "video",
  upload(i, e, t, n, s, o = oee) {
    if (!i.isValid) {
      const r = s != null ? s : e.target;
      t.texImage2D(
        r,
        0,
        e.internalFormat,
        1,
        1,
        0,
        e.format,
        e.type,
        null
      );
      return;
    }
    YT.upload(i, e, t, n, s, o);
  }
}, H2 = {
  linear: 9729,
  nearest: 9728
}, aee = {
  linear: {
    linear: 9987,
    nearest: 9985
  },
  nearest: {
    linear: 9986,
    nearest: 9984
  }
}, qg = {
  "clamp-to-edge": 33071,
  repeat: 10497,
  "mirror-repeat": 33648
}, lee = {
  never: 512,
  less: 513,
  equal: 514,
  "less-equal": 515,
  greater: 516,
  "not-equal": 517,
  "greater-equal": 518,
  always: 519
};
function V2(i, e, t, n, s, o, r, a) {
  const l = o;
  if (!a || i.addressModeU !== "repeat" || i.addressModeV !== "repeat" || i.addressModeW !== "repeat") {
    const d = qg[r ? "clamp-to-edge" : i.addressModeU], c = qg[r ? "clamp-to-edge" : i.addressModeV], h = qg[r ? "clamp-to-edge" : i.addressModeW];
    e[s](l, e.TEXTURE_WRAP_S, d), e[s](l, e.TEXTURE_WRAP_T, c), e.TEXTURE_WRAP_R && e[s](l, e.TEXTURE_WRAP_R, h);
  }
  if ((!a || i.magFilter !== "linear") && e[s](l, e.TEXTURE_MAG_FILTER, H2[i.magFilter]), t) {
    if (!a || i.mipmapFilter !== "linear") {
      const d = aee[i.minFilter][i.mipmapFilter];
      e[s](l, e.TEXTURE_MIN_FILTER, d);
    }
  } else
    e[s](l, e.TEXTURE_MIN_FILTER, H2[i.minFilter]);
  if (n && i.maxAnisotropy > 1) {
    const d = Math.min(i.maxAnisotropy, e.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
    e[s](l, n.TEXTURE_MAX_ANISOTROPY_EXT, d);
  }
  i.compare ? (e[s](l, e.TEXTURE_COMPARE_FUNC, lee[i.compare]), e[s](l, e.TEXTURE_COMPARE_MODE, e.COMPARE_REF_TO_TEXTURE)) : a || e[s](l, e.TEXTURE_COMPARE_MODE, e.NONE);
}
function dee(i) {
  return {
    // 8-bit formats
    r8unorm: i.RED,
    r8snorm: i.RED,
    r8uint: i.RED_INTEGER,
    r8sint: i.RED_INTEGER,
    // 16-bit formats
    r16uint: i.RED_INTEGER,
    r16sint: i.RED_INTEGER,
    r16float: i.RED,
    rg8unorm: i.RG,
    rg8snorm: i.RG,
    rg8uint: i.RG_INTEGER,
    rg8sint: i.RG_INTEGER,
    // 32-bit formats
    r32uint: i.RED_INTEGER,
    r32sint: i.RED_INTEGER,
    r32float: i.RED,
    rg16uint: i.RG_INTEGER,
    rg16sint: i.RG_INTEGER,
    rg16float: i.RG,
    rgba8unorm: i.RGBA,
    "rgba8unorm-srgb": i.RGBA,
    // Packed 32-bit formats
    rgba8snorm: i.RGBA,
    rgba8uint: i.RGBA_INTEGER,
    rgba8sint: i.RGBA_INTEGER,
    bgra8unorm: i.RGBA,
    "bgra8unorm-srgb": i.RGBA,
    rgb9e5ufloat: i.RGB,
    rgb10a2unorm: i.RGBA,
    rg11b10ufloat: i.RGB,
    // 64-bit formats
    rg32uint: i.RG_INTEGER,
    rg32sint: i.RG_INTEGER,
    rg32float: i.RG,
    rgba16uint: i.RGBA_INTEGER,
    rgba16sint: i.RGBA_INTEGER,
    rgba16float: i.RGBA,
    // 128-bit formats
    rgba32uint: i.RGBA_INTEGER,
    rgba32sint: i.RGBA_INTEGER,
    rgba32float: i.RGBA,
    // Depth/stencil formats
    stencil8: i.STENCIL_INDEX8,
    depth16unorm: i.DEPTH_COMPONENT,
    depth24plus: i.DEPTH_COMPONENT,
    "depth24plus-stencil8": i.DEPTH_STENCIL,
    depth32float: i.DEPTH_COMPONENT,
    "depth32float-stencil8": i.DEPTH_STENCIL
  };
}
function cee(i, e) {
  let t = {}, n = i.RGBA;
  return i instanceof zt.get().getWebGLRenderingContext() ? e.srgb && (t = {
    "rgba8unorm-srgb": e.srgb.SRGB8_ALPHA8_EXT,
    "bgra8unorm-srgb": e.srgb.SRGB8_ALPHA8_EXT
  }) : (t = {
    "rgba8unorm-srgb": i.SRGB8_ALPHA8,
    "bgra8unorm-srgb": i.SRGB8_ALPHA8
  }, n = i.RGBA8), {
    // 8-bit formats
    r8unorm: i.R8,
    r8snorm: i.R8_SNORM,
    r8uint: i.R8UI,
    r8sint: i.R8I,
    // 16-bit formats
    r16uint: i.R16UI,
    r16sint: i.R16I,
    r16float: i.R16F,
    rg8unorm: i.RG8,
    rg8snorm: i.RG8_SNORM,
    rg8uint: i.RG8UI,
    rg8sint: i.RG8I,
    // 32-bit formats
    r32uint: i.R32UI,
    r32sint: i.R32I,
    r32float: i.R32F,
    rg16uint: i.RG16UI,
    rg16sint: i.RG16I,
    rg16float: i.RG16F,
    rgba8unorm: i.RGBA,
    ...t,
    // Packed 32-bit formats
    rgba8snorm: i.RGBA8_SNORM,
    rgba8uint: i.RGBA8UI,
    rgba8sint: i.RGBA8I,
    bgra8unorm: n,
    rgb9e5ufloat: i.RGB9_E5,
    rgb10a2unorm: i.RGB10_A2,
    rg11b10ufloat: i.R11F_G11F_B10F,
    // 64-bit formats
    rg32uint: i.RG32UI,
    rg32sint: i.RG32I,
    rg32float: i.RG32F,
    rgba16uint: i.RGBA16UI,
    rgba16sint: i.RGBA16I,
    rgba16float: i.RGBA16F,
    // 128-bit formats
    rgba32uint: i.RGBA32UI,
    rgba32sint: i.RGBA32I,
    rgba32float: i.RGBA32F,
    // Depth/stencil formats
    stencil8: i.STENCIL_INDEX8,
    depth16unorm: i.DEPTH_COMPONENT16,
    depth24plus: i.DEPTH_COMPONENT24,
    "depth24plus-stencil8": i.DEPTH24_STENCIL8,
    depth32float: i.DEPTH_COMPONENT32F,
    "depth32float-stencil8": i.DEPTH32F_STENCIL8,
    // Compressed formats
    ...e.s3tc ? {
      "bc1-rgba-unorm": e.s3tc.COMPRESSED_RGBA_S3TC_DXT1_EXT,
      "bc2-rgba-unorm": e.s3tc.COMPRESSED_RGBA_S3TC_DXT3_EXT,
      "bc3-rgba-unorm": e.s3tc.COMPRESSED_RGBA_S3TC_DXT5_EXT
    } : {},
    ...e.s3tc_sRGB ? {
      "bc1-rgba-unorm-srgb": e.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT,
      "bc2-rgba-unorm-srgb": e.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT,
      "bc3-rgba-unorm-srgb": e.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
    } : {},
    ...e.rgtc ? {
      "bc4-r-unorm": e.rgtc.COMPRESSED_RED_RGTC1_EXT,
      "bc4-r-snorm": e.rgtc.COMPRESSED_SIGNED_RED_RGTC1_EXT,
      "bc5-rg-unorm": e.rgtc.COMPRESSED_RED_GREEN_RGTC2_EXT,
      "bc5-rg-snorm": e.rgtc.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT
    } : {},
    ...e.bptc ? {
      "bc6h-rgb-float": e.bptc.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT,
      "bc6h-rgb-ufloat": e.bptc.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT,
      "bc7-rgba-unorm": e.bptc.COMPRESSED_RGBA_BPTC_UNORM_EXT,
      "bc7-rgba-unorm-srgb": e.bptc.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT
    } : {},
    ...e.etc ? {
      "etc2-rgb8unorm": e.etc.COMPRESSED_RGB8_ETC2,
      "etc2-rgb8unorm-srgb": e.etc.COMPRESSED_SRGB8_ETC2,
      "etc2-rgb8a1unorm": e.etc.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2,
      "etc2-rgb8a1unorm-srgb": e.etc.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2,
      "etc2-rgba8unorm": e.etc.COMPRESSED_RGBA8_ETC2_EAC,
      "etc2-rgba8unorm-srgb": e.etc.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC,
      "eac-r11unorm": e.etc.COMPRESSED_R11_EAC,
      // 'eac-r11snorm'
      "eac-rg11unorm": e.etc.COMPRESSED_SIGNED_RG11_EAC
      // 'eac-rg11snorm'
    } : {},
    ...e.astc ? {
      "astc-4x4-unorm": e.astc.COMPRESSED_RGBA_ASTC_4x4_KHR,
      "astc-4x4-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR,
      "astc-5x4-unorm": e.astc.COMPRESSED_RGBA_ASTC_5x4_KHR,
      "astc-5x4-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR,
      "astc-5x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_5x5_KHR,
      "astc-5x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR,
      "astc-6x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_6x5_KHR,
      "astc-6x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR,
      "astc-6x6-unorm": e.astc.COMPRESSED_RGBA_ASTC_6x6_KHR,
      "astc-6x6-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR,
      "astc-8x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_8x5_KHR,
      "astc-8x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR,
      "astc-8x6-unorm": e.astc.COMPRESSED_RGBA_ASTC_8x6_KHR,
      "astc-8x6-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR,
      "astc-8x8-unorm": e.astc.COMPRESSED_RGBA_ASTC_8x8_KHR,
      "astc-8x8-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR,
      "astc-10x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x5_KHR,
      "astc-10x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR,
      "astc-10x6-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x6_KHR,
      "astc-10x6-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR,
      "astc-10x8-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x8_KHR,
      "astc-10x8-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR,
      "astc-10x10-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x10_KHR,
      "astc-10x10-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR,
      "astc-12x10-unorm": e.astc.COMPRESSED_RGBA_ASTC_12x10_KHR,
      "astc-12x10-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR,
      "astc-12x12-unorm": e.astc.COMPRESSED_RGBA_ASTC_12x12_KHR,
      "astc-12x12-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR
    } : {}
  };
}
function uee(i) {
  return {
    // 8-bit formats
    r8unorm: i.UNSIGNED_BYTE,
    r8snorm: i.BYTE,
    r8uint: i.UNSIGNED_BYTE,
    r8sint: i.BYTE,
    // 16-bit formats
    r16uint: i.UNSIGNED_SHORT,
    r16sint: i.SHORT,
    r16float: i.HALF_FLOAT,
    rg8unorm: i.UNSIGNED_BYTE,
    rg8snorm: i.BYTE,
    rg8uint: i.UNSIGNED_BYTE,
    rg8sint: i.BYTE,
    // 32-bit formats
    r32uint: i.UNSIGNED_INT,
    r32sint: i.INT,
    r32float: i.FLOAT,
    rg16uint: i.UNSIGNED_SHORT,
    rg16sint: i.SHORT,
    rg16float: i.HALF_FLOAT,
    rgba8unorm: i.UNSIGNED_BYTE,
    "rgba8unorm-srgb": i.UNSIGNED_BYTE,
    // Packed 32-bit formats
    rgba8snorm: i.BYTE,
    rgba8uint: i.UNSIGNED_BYTE,
    rgba8sint: i.BYTE,
    bgra8unorm: i.UNSIGNED_BYTE,
    "bgra8unorm-srgb": i.UNSIGNED_BYTE,
    rgb9e5ufloat: i.UNSIGNED_INT_5_9_9_9_REV,
    rgb10a2unorm: i.UNSIGNED_INT_2_10_10_10_REV,
    rg11b10ufloat: i.UNSIGNED_INT_10F_11F_11F_REV,
    // 64-bit formats
    rg32uint: i.UNSIGNED_INT,
    rg32sint: i.INT,
    rg32float: i.FLOAT,
    rgba16uint: i.UNSIGNED_SHORT,
    rgba16sint: i.SHORT,
    rgba16float: i.HALF_FLOAT,
    // 128-bit formats
    rgba32uint: i.UNSIGNED_INT,
    rgba32sint: i.INT,
    rgba32float: i.FLOAT,
    // Depth/stencil formats
    stencil8: i.UNSIGNED_BYTE,
    depth16unorm: i.UNSIGNED_SHORT,
    depth24plus: i.UNSIGNED_INT,
    "depth24plus-stencil8": i.UNSIGNED_INT_24_8,
    depth32float: i.FLOAT,
    "depth32float-stencil8": i.FLOAT_32_UNSIGNED_INT_24_8_REV
  };
}
function hee(i) {
  return {
    "2d": i.TEXTURE_2D,
    cube: i.TEXTURE_CUBE_MAP,
    "1d": null,
    // WebGL2 only
    "3d": (i == null ? void 0 : i.TEXTURE_3D) || null,
    "2d-array": (i == null ? void 0 : i.TEXTURE_2D_ARRAY) || null,
    "cube-array": (i == null ? void 0 : i.TEXTURE_CUBE_MAP_ARRAY) || null
  };
}
const pee = 4, By = class XT {
  constructor(e) {
    this._glSamplers = /* @__PURE__ */ Object.create(null), this._boundTextures = [], this._integerUnits = 0, this._activeTextureLocation = -1, this._boundSamplers = /* @__PURE__ */ Object.create(null), this._premultiplyAlpha = !1, this._useSeparateSamplers = !1, this._renderer = e, this._managedTextures = new Cs({
      renderer: e,
      type: "resource",
      onUnload: this.onSourceUnload.bind(this),
      name: "glTexture"
    });
    const t = {
      image: YT,
      buffer: QQ,
      video: ree,
      compressed: tee,
      ...XT.uploadExtensions
    };
    this._uploads = {
      ...t,
      cube: nee(t)
    };
  }
  /**
   * @deprecated since 8.15.0
   */
  get managedTextures() {
    return Object.values(this._managedTextures.items);
  }
  contextChange(e) {
    this._gl = e, this._mapFormatToInternalFormat || (this._mapFormatToInternalFormat = cee(e, this._renderer.context.extensions), this._mapFormatToType = uee(e), this._mapFormatToFormat = dee(e), this._mapViewDimensionToGlTarget = hee(e)), this._managedTextures.removeAll(!0), this._glSamplers = /* @__PURE__ */ Object.create(null), this._boundSamplers = /* @__PURE__ */ Object.create(null), this._premultiplyAlpha = !1;
    for (let t = 0; t < 16; t++)
      this.bind(et.EMPTY, t);
  }
  /**
   * Initializes a texture source, if it has already been initialized nothing will happen.
   * @param source - The texture source to initialize.
   * @returns The initialized texture source.
   */
  initSource(e) {
    this.bind(e);
  }
  bind(e, t = 0) {
    const n = e.source;
    e ? (this.bindSource(n, t), this._useSeparateSamplers && this._bindSampler(n.style, t)) : (this.bindSource(null, t), this._useSeparateSamplers && this._bindSampler(null, t));
  }
  bindSource(e, t = 0) {
    const n = this._gl;
    if (e._gcLastUsed = this._renderer.gc.now, this._boundTextures[t] !== e) {
      this._setBoundTexture(t, e), this._activateLocation(t), e || (e = et.EMPTY.source);
      const s = this.getGlSource(e);
      n.bindTexture(s.target, s.texture);
    }
  }
  /**
   * Binds the empty texture over every integer texture on unit `location` and above
   *
   * WebGL fails a draw when a float sampler's unit holds an integer texture, even if the shader
   * never samples it. Call this after binding a batch's textures when the shader declares more
   * samplers than the batch binds.
   * @param location - The first texture unit to check.
   */
  unbindIntegerTextures(e) {
    if (e >= 32) return;
    let t = this._integerUnits >>> e << e;
    for (; t; ) {
      const n = 31 - Math.clz32(t);
      t &= ~(1 << n), this.bind(et.EMPTY, n);
    }
  }
  /**
   * Records the source bound to a unit, keeping `_integerUnits` in step. Every per-unit write to
   * `_boundTextures` goes through here so the two can't drift apart.
   *
   * A unit has a separate binding per target (2D, 2D array, cube), and the batch shaders sample
   * the 2D target, so only a 2D source changes the unit's bit. Anything else, including null,
   * leaves it as it was: a bit left set after the integer texture is gone only costs one extra
   * `bind(Texture.EMPTY)` in `unbindIntegerTextures`, while a cleared bit over an integer texture
   * fails the next batch.
   * @param location - The texture unit.
   * @param source - The source now bound there, or null.
   */
  _setBoundTexture(e, t) {
    this._boundTextures[e] = t, !(e < 0 || e > 31) && (!t || t.viewDimension !== "2d" || (Fv(t.format) ? this._integerUnits |= 1 << e : this._integerUnits &= ~(1 << e)));
  }
  _bindSampler(e, t = 0) {
    const n = this._gl;
    if (!e) {
      this._boundSamplers[t] = null, n.bindSampler(t, null);
      return;
    }
    const s = this._getGlSampler(e);
    this._boundSamplers[t] !== s && (this._boundSamplers[t] = s, n.bindSampler(t, s));
  }
  unbind(e) {
    const t = e.source, n = this._boundTextures, s = this._gl;
    for (let o = 0; o < n.length; o++)
      if (n[o] === t) {
        this._activateLocation(o);
        const r = this.getGlSource(t);
        s.bindTexture(r.target, null), this._setBoundTexture(o, null);
      }
  }
  _activateLocation(e) {
    this._activeTextureLocation !== e && (this._activeTextureLocation = e, this._gl.activeTexture(this._gl.TEXTURE0 + e));
  }
  _initSource(e) {
    const t = this._gl, n = new ZQ(t.createTexture());
    if (n.type = this._mapFormatToType[e.format], n.internalFormat = this._mapFormatToInternalFormat[e.format], n.format = this._mapFormatToFormat[e.format], n.target = this._mapViewDimensionToGlTarget[e.viewDimension], n.target === null)
      throw new Error(`Unsupported view dimension: ${e.viewDimension} with this webgl version: ${this._renderer.context.webGLVersion}`);
    if (e.autoGenerateMipmaps && (this._renderer.context.supports.nonPowOf2mipmaps || e.isPowerOfTwo)) {
      const o = Math.max(e.width, e.height, e.depth);
      e.mipLevelCount = Math.floor(Math.log2(o)) + 1;
    }
    return e._gpuData[this._renderer.uid] = n, this._managedTextures.add(e) && (e.on("update", this.onSourceUpdate, this), e.on("resize", this.onSourceUpdate, this), e.on("styleChange", this.onStyleChange, this), e.on("updateMipmaps", this.onUpdateMipmaps, this)), this.onSourceUpdate(e), this.updateStyle(e, !1), n;
  }
  onStyleChange(e) {
    this.updateStyle(e, !1);
  }
  updateStyle(e, t) {
    const n = this._gl, s = this.getGlSource(e);
    n.bindTexture(s.target, s.texture), this._setBoundTexture(this._activeTextureLocation, e), V2(
      e.style,
      n,
      e.mipLevelCount > 1,
      this._renderer.context.extensions.anisotropicFiltering,
      "texParameteri",
      s.target,
      // will force a clamp to edge if the texture is not a power of two
      !this._renderer.context.supports.nonPowOf2wrapping && !e.isPowerOfTwo,
      t
    );
  }
  onSourceUnload(e, t = !1) {
    const n = e._gpuData[this._renderer.uid];
    n && (t || (this.unbind(e), this._gl.deleteTexture(n.texture)), e.off("update", this.onSourceUpdate, this), e.off("resize", this.onSourceUpdate, this), e.off("styleChange", this.onStyleChange, this), e.off("updateMipmaps", this.onUpdateMipmaps, this));
  }
  onSourceUpdate(e) {
    const t = this._gl, n = this.getGlSource(e);
    t.bindTexture(n.target, n.texture), this._setBoundTexture(this._activeTextureLocation, e);
    const s = e.alphaMode === "premultiply-alpha-on-upload" && !Fv(e.format) && n.target !== t.TEXTURE_3D && n.target !== t.TEXTURE_2D_ARRAY;
    if (this._premultiplyAlpha !== s && (this._premultiplyAlpha = s, t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, s)), this._uploads[e.uploadMethodId])
      this._uploads[e.uploadMethodId].upload(e, n, t, this._renderer.context.webGLVersion);
    else if (n.target === t.TEXTURE_2D)
      this._initEmptyTexture2D(n, e);
    else if (n.target === t.TEXTURE_2D_ARRAY || n.target === t.TEXTURE_3D)
      this._initEmptyTexture3D(n, e);
    else if (n.target === t.TEXTURE_CUBE_MAP)
      this._initEmptyTextureCube(n, e);
    else
      throw new Error("[GlTextureSystem] Unsupported texture target for empty allocation.");
    this._applyMipRange(n, e), e.autoGenerateMipmaps && e.mipLevelCount > 1 && this.onUpdateMipmaps(e, !1);
  }
  onUpdateMipmaps(e, t = !0) {
    t && this.bindSource(e, 0);
    const n = this.getGlSource(e);
    this._gl.generateMipmap(n.target);
  }
  _initEmptyTexture2D(e, t) {
    const n = this._gl;
    n.texImage2D(
      n.TEXTURE_2D,
      0,
      e.internalFormat,
      t.pixelWidth,
      t.pixelHeight,
      0,
      e.format,
      e.type,
      null
    );
    let s = Math.max(t.pixelWidth >> 1, 1), o = Math.max(t.pixelHeight >> 1, 1);
    for (let r = 1; r < t.mipLevelCount; r++)
      n.texImage2D(
        n.TEXTURE_2D,
        r,
        e.internalFormat,
        s,
        o,
        0,
        e.format,
        e.type,
        null
      ), s = Math.max(s >> 1, 1), o = Math.max(o >> 1, 1);
  }
  /**
   * Allocates a texture with a depth: the layers of a 2D array or the slices of a 3D texture.
   * Layer counts stay the same at every mip level; 3D depth halves like width and height.
   * @param glTexture - The GL texture wrapper.
   * @param source - The texture source describing the size.
   */
  _initEmptyTexture3D(e, t) {
    const n = this._gl, s = e.target === n.TEXTURE_3D;
    let o = t.pixelWidth, r = t.pixelHeight, a = t.depthOrArrayLayers;
    for (let l = 0; l < t.mipLevelCount; l++)
      n.texImage3D(
        e.target,
        l,
        e.internalFormat,
        o,
        r,
        a,
        0,
        e.format,
        e.type,
        null
      ), o = Math.max(o >> 1, 1), r = Math.max(r >> 1, 1), s && (a = Math.max(a >> 1, 1));
  }
  _initEmptyTextureCube(e, t) {
    const n = this._gl, s = 6;
    for (let a = 0; a < s; a++)
      n.texImage2D(
        n.TEXTURE_CUBE_MAP_POSITIVE_X + a,
        0,
        e.internalFormat,
        t.pixelWidth,
        t.pixelHeight,
        0,
        e.format,
        e.type,
        null
      );
    let o = Math.max(t.pixelWidth >> 1, 1), r = Math.max(t.pixelHeight >> 1, 1);
    for (let a = 1; a < t.mipLevelCount; a++) {
      for (let l = 0; l < s; l++)
        n.texImage2D(
          n.TEXTURE_CUBE_MAP_POSITIVE_X + l,
          a,
          e.internalFormat,
          o,
          r,
          0,
          e.format,
          e.type,
          null
        );
      o = Math.max(o >> 1, 1), r = Math.max(r >> 1, 1);
    }
  }
  /**
   * Applies a mip range to the currently-bound texture so WebGL2 considers the texture "mipmap complete"
   * for the declared `mipLevelCount` (especially important for partial mip chains rendered via FBO).
   * @param glTexture - The GL texture wrapper.
   * @param source - The texture source describing mipLevelCount.
   */
  _applyMipRange(e, t) {
    if (this._renderer.context.webGLVersion !== 2 || t.mipLevelCount <= 1) return;
    const n = this._gl, s = Math.max((t.mipLevelCount | 0) - 1, 0);
    n.texParameteri(e.target, n.TEXTURE_BASE_LEVEL, 0), n.texParameteri(e.target, n.TEXTURE_MAX_LEVEL, s);
  }
  _initSampler(e) {
    const t = this._gl, n = this._gl.createSampler();
    return this._glSamplers[e._resourceId] = n, V2(
      e,
      t,
      this._boundTextures[this._activeTextureLocation].mipLevelCount > 1,
      this._renderer.context.extensions.anisotropicFiltering,
      "samplerParameteri",
      n,
      !1,
      !0
    ), this._glSamplers[e._resourceId];
  }
  _getGlSampler(e) {
    return this._glSamplers[e._resourceId] || this._initSampler(e);
  }
  getGlSource(e) {
    return e._gcLastUsed = this._renderer.gc.now, e._gpuData[this._renderer.uid] || this._initSource(e);
  }
  generateCanvas(e) {
    const { pixels: t, width: n, height: s } = this.getPixels(e), o = zt.get().createCanvas();
    o.width = n, o.height = s;
    const r = o.getContext("2d");
    if (r) {
      const a = r.createImageData(n, s);
      a.data.set(t), r.putImageData(a, 0, 0);
    }
    return o;
  }
  getPixels(e) {
    const t = e.source.resolution, n = e.frame, s = Math.max(Math.round(n.width * t), 1), o = Math.max(Math.round(n.height * t), 1), r = new Uint8Array(pee * s * o), a = this._renderer, l = a.renderTarget.getRenderTarget(e), d = a.renderTarget.getGpuRenderTarget(l), c = a.gl;
    return a.renderTarget.adaptor.bindFramebuffer(d.resolveTargetFramebuffer), c.readPixels(
      Math.round(n.x * t),
      Math.round(n.y * t),
      s,
      o,
      c.RGBA,
      c.UNSIGNED_BYTE,
      r
    ), { pixels: new Uint8ClampedArray(r.buffer), width: s, height: o };
  }
  destroy() {
    this._managedTextures.destroy(), this._glSamplers = null, this._boundTextures = null, this._boundSamplers = null, this._mapFormatToInternalFormat = null, this._mapFormatToType = null, this._mapFormatToFormat = null, this._uploads = null, this._renderer = null;
  }
  resetState() {
    const e = this._renderer.limits.maxTextures;
    this._activeTextureLocation = -1, this._boundTextures.fill(null), this._integerUnits = e >= 32 ? -1 : (1 << e) - 1, this._boundSamplers = /* @__PURE__ */ Object.create(null);
    const t = this._gl;
    this._premultiplyAlpha = !1, t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this._premultiplyAlpha);
  }
};
By.extension = {
  type: [
    Ie.WebGLSystem
  ],
  name: "texture"
};
By.uploadExtensions = /* @__PURE__ */ Object.create(null);
let JT = By;
ht.handleByMap(Ie.TextureUploaderWebGL, JT.uploadExtensions);
class ZT {
  contextChange(e) {
    const t = new Ts({
      uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
      uTransformMatrix: { value: new st(), type: "mat3x3<f32>" },
      uRound: { value: 0, type: "f32" }
    }), n = e.limits.maxBatchableTextures, s = oy({
      name: "graphics",
      bits: [
        xM,
        kM(n),
        YM,
        ay
      ]
    });
    this.shader = new lo({
      glProgram: s,
      resources: {
        localUniforms: t,
        batchSamplers: _M(n)
      }
    });
  }
  execute(e, t) {
    const n = t.context, s = n.customShader || this.shader, o = e.renderer, r = o.graphicsContext, {
      batcher: a,
      instructions: l
    } = r.getContextRenderData(n);
    s.groups[0] = o.globalUniforms.bindGroup, o.state.set(e.state), o.shader.bind(s), o.geometry.bind(a.geometry, s.glProgram);
    const d = l.instructions;
    for (let c = 0; c < l.instructionSize; c++) {
      const h = d[c];
      if (h.size) {
        for (let f = 0; f < h.textures.count; f++)
          o.texture.bind(h.textures.textures[f], f);
        o.texture.unbindIntegerTextures(h.textures.count), o.geometry.draw(h.topology, h.size, h.start);
      }
    }
  }
  destroy() {
    this.shader.destroy(!0), this.shader = null;
  }
}
ZT.extension = {
  type: [
    Ie.WebGLPipesAdaptor
  ],
  name: "graphics"
};
class QT {
  init() {
    const e = oy({
      name: "mesh",
      bits: [
        YM,
        PZ,
        ay
      ]
    });
    this._shader = new lo({
      glProgram: e,
      resources: {
        uTexture: et.EMPTY.source,
        textureUniforms: {
          uTextureMatrix: { type: "mat3x3<f32>", value: new st() }
        }
      }
    });
  }
  execute(e, t) {
    const n = e.renderer;
    let s = t._shader;
    if (s) {
      if (!s.glProgram) {
        dt("Mesh shader has no glProgram", t.shader);
        return;
      }
    } else {
      s = this._shader;
      const o = t.texture, r = o.source;
      s.resources.uTexture = r, s.resources.uSampler = r.style, s.resources.textureUniforms.uniforms.uTextureMatrix = o.textureMatrix.mapCoord;
    }
    s.groups[100] = n.globalUniforms.bindGroup, s.groups[101] = e.localUniformsBindGroup, n.encoder.draw({
      geometry: t._geometry,
      shader: s,
      state: t.state
    });
  }
  destroy() {
    this._shader.destroy(!0), this._shader = null;
  }
}
QT.extension = {
  type: [
    Ie.WebGLPipesAdaptor
  ],
  name: "mesh"
};
const fee = [
  ...zy,
  UT,
  MQ,
  yQ,
  DT,
  AT,
  JT,
  GT,
  ET,
  WT,
  VT,
  $T,
  JQ,
  OT,
  zT
], mee = [...kT], gee = [JM, QT, ZT], eC = [], tC = [], nC = [], iC = [];
ht.handleByNamedList(Ie.WebGLSystem, eC);
ht.handleByNamedList(Ie.WebGLPipes, tC);
ht.handleByNamedList(Ie.WebGLPipesAdaptor, nC);
ht.handleByNamedList(Ie.WebGLLoader, iC);
ht.add(...fee, ...mee, ...gee);
class bee extends wu {
  constructor() {
    const e = {
      name: "webgl",
      type: rs.WEBGL,
      systems: eC,
      renderPipes: tC,
      renderPipeAdaptors: nC,
      loaders: iC
    };
    super(e);
  }
}
const vee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WebGLRenderer: bee
}, Symbol.toStringTag, { value: "Module" }));
class yee {
  constructor(e, t) {
    this.autoGarbageCollect = !0, this._gpuData = null, this.gpuBindGroup = e, this._gcLastUsed = t;
  }
  /**
   * Native bind groups have no destroy; dropping the reference is the whole release. Anything
   * still holding the group (a recorded render bundle, a graphics batch) keeps it alive, and the
   * next immediate-mode bind simply recreates the cache entry.
   */
  unload() {
    this.gpuBindGroup = null;
  }
}
class sC {
  constructor(e) {
    this._hash = /* @__PURE__ */ Object.create(null), this._renderer = e, e.gc.addResourceHash(this, "_hash", "resource"), e.gc.addCollection(this, "_hash", "hash");
  }
  contextChange(e) {
    this._gpu = e, this._hash = /* @__PURE__ */ Object.create(null);
  }
  getBindGroup(e, t, n) {
    const s = `${e._key}:${t._layoutKey << 4 | n}`, o = this._hash[s];
    return o ? (o._gcLastUsed = this._renderer.gc.now, o.gpuBindGroup) : this._createBindGroup(s, e, t, n);
  }
  _createBindGroup(e, t, n, s) {
    var h, f;
    const o = this._gpu.device, r = n.layout[s], a = [], l = this._renderer;
    for (const p in r) {
      const y = (h = t.resources[p]) != null ? h : t.resources[r[p]];
      if (!y || y.destroyed)
        throw new Error(`[BindGroup] the resource bound as '${p}' was destroyed while a shader still uses it. Remove it from the shader before destroying it.`);
      let v;
      if (y._resourceType === "uniformGroup") {
        const x = y;
        l.ubo.updateUniformGroup(x);
        const w = x.buffer;
        v = {
          buffer: l.buffer.getGPUBuffer(w),
          offset: 0,
          size: w.descriptor.size
        };
      } else if (y._resourceType === "buffer") {
        const x = y;
        v = {
          buffer: l.buffer.getGPUBuffer(x),
          offset: 0,
          size: x.descriptor.size
        };
      } else if (y._resourceType === "bufferResource") {
        const x = y;
        v = {
          buffer: l.buffer.getGPUBuffer(x.buffer),
          offset: x.offset,
          size: (f = x.size) != null ? f : x.buffer.descriptor.size
        };
      } else if (y._resourceType === "textureSampler") {
        const x = y;
        v = l.texture.getGpuSampler(x);
      } else if (y._resourceType === "textureSource") {
        const x = y;
        v = l.texture.getTextureView(x);
      } else if (y._resourceType === "textureView") {
        const x = y;
        v = l.texture.getTextureView(x.source, x.viewDescriptor);
      }
      a.push({
        binding: r[p],
        resource: v
      });
    }
    const d = l.shader.getProgramData(n).bindGroups[s], c = o.createBindGroup({
      layout: d,
      entries: a
    });
    return this._hash[e] = new yee(c, l.gc.now), c;
  }
  destroy() {
    this._hash = null, this._renderer = null;
  }
}
sC.extension = {
  type: [
    Ie.WebGPUSystem
  ],
  name: "bindGroup"
};
class xee {
  constructor(e) {
    this.gpuBuffer = e;
  }
  destroy() {
    this.gpuBuffer.destroy(), this.gpuBuffer = null;
  }
}
class oC {
  constructor(e) {
    this._renderer = e, this._managedBuffers = new Cs({
      renderer: e,
      type: "resource",
      onUnload: this.onBufferUnload.bind(this),
      name: "gpuBuffer"
    });
  }
  contextChange(e) {
    this._gpu = e, this.destroyAll();
  }
  getGPUBuffer(e) {
    var t;
    return e._gcLastUsed = this._renderer.gc.now, ((t = e._gpuData[this._renderer.uid]) == null ? void 0 : t.gpuBuffer) || this.createGPUBuffer(e);
  }
  updateBuffer(e) {
    const t = this.getGPUBuffer(e), n = e.data;
    return e._updateID && n && (e._updateID = 0, this._gpu.device.queue.writeBuffer(
      t,
      e._updateOffset,
      n.buffer,
      n.byteOffset + e._updateOffset,
      // round to the nearest 4 bytes
      (e._updateSize || n.byteLength) + 3 & -4
    )), t;
  }
  /** dispose all WebGL resources of all managed buffers */
  destroyAll() {
    this._managedBuffers.removeAll();
  }
  onBufferUnload(e) {
    e.off("update", this.updateBuffer, this), e.off("change", this.onBufferChange, this);
  }
  createGPUBuffer(e) {
    const t = this._gpu.device.createBuffer(e.descriptor);
    return e._updateID = 0, e.data && (i0(
      e.data.buffer,
      t.getMappedRange(),
      e.data.byteOffset,
      e.data.byteLength
    ), t.unmap()), e._gpuData[this._renderer.uid] = new xee(t), this._managedBuffers.add(e) && (e.on("update", this.updateBuffer, this), e.on("change", this.onBufferChange, this)), t;
  }
  onBufferChange(e) {
    this._managedBuffers.remove(e), e._updateID = 0, this.createGPUBuffer(e);
  }
  destroy() {
    this._managedBuffers.destroy(), this._renderer = null, this._gpu = null;
  }
}
oC.extension = {
  type: [
    Ie.WebGPUSystem
  ],
  name: "buffer"
};
class wee {
  constructor({ minUniformOffsetAlignment: e }) {
    this._minUniformOffsetAlignment = 256, this.byteIndex = 0, this._minUniformOffsetAlignment = e, this.data = new Float32Array(65535);
  }
  clear() {
    this.byteIndex = 0;
  }
  addEmptyGroup(e) {
    if (e > this._minUniformOffsetAlignment / 4)
      throw new Error(`UniformBufferBatch: array is too large: ${e * 4}`);
    const t = this.byteIndex;
    let n = t + e * 4;
    if (n = Math.ceil(n / this._minUniformOffsetAlignment) * this._minUniformOffsetAlignment, n > this.data.length * 4)
      throw new Error("UniformBufferBatch: ubo batch got too big");
    return this.byteIndex = n, t;
  }
  addGroup(e) {
    const t = this.addEmptyGroup(e.length);
    for (let n = 0; n < e.length; n++)
      this.data[t / 4 + n] = e[n];
    return t;
  }
  destroy() {
    this.data = null;
  }
}
class rC {
  constructor(e) {
    this._colorMaskCache = 15, this._renderer = e;
  }
  setMask(e) {
    this._colorMaskCache !== e && (this._colorMaskCache = e, this._renderer.pipeline.setColorMask(e));
  }
  destroy() {
    this._renderer = null, this._colorMaskCache = null;
  }
}
rC.extension = {
  type: [
    Ie.WebGPUSystem
  ],
  name: "colorMask"
};
const kee = /* @__PURE__ */ new Set(["apple", "arm", "qualcomm", "img-tec"]);
class Fy {
  /**
   * @param {WebGPURenderer} renderer - The renderer this System works for.
   */
  constructor(e) {
    this._renderer = e;
  }
  async init(e) {
    return this._initPromise ? this._initPromise : (this._options = e, this._initPromise = (e.gpu ? Promise.resolve(e.gpu) : this._createDeviceAndAdaptor(e)).then((t) => this._setGpu(t)), this._initPromise);
  }
  _setGpu(e) {
    var t, n;
    this.gpu = e, this.extensions = {
      transientAttachment: typeof GPUTextureUsage.TRANSIENT_ATTACHMENT == "number",
      tileBased: kee.has((n = (t = e.adapter) == null ? void 0 : t.info) == null ? void 0 : n.vendor)
    }, this._options.gpu || e.device.lost.then(() => this._restoreDevice()).catch((s) => dt("WebGPU device was lost and could not be restored", s)), this._renderer.runners.contextChange.emit(this.gpu);
  }
  async _restoreDevice() {
    if (!this._renderer) return;
    const e = await this._createDeviceAndAdaptor(this._options);
    if (!this._renderer) {
      e.device.destroy();
      return;
    }
    this._setGpu(e);
  }
  /**
   * Handle the context change event
   * @param gpu
   */
  contextChange(e) {
    this._renderer.gpu = e;
  }
  /**
   * Helper class to create a WebGL Context
   * @param {object} options - An options object that gets passed in to the canvas element containing the
   *    context attributes
   * @see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext
   * @returns {WebGLRenderingContext} the WebGL context
   */
  async _createDeviceAndAdaptor(e) {
    const t = await zt.get().getNavigator().gpu.requestAdapter({
      powerPreference: e.powerPreference,
      forceFallbackAdapter: e.forceFallbackAdapter
    });
    if (!t)
      throw new Error("WebGPU not supported. No GPU adapter was returned by navigator.gpu.requestAdapter().");
    const n = [
      "texture-compression-bc",
      "texture-compression-astc",
      "texture-compression-etc2",
      "indirect-first-instance",
      // more formats for TextureSource `storage`
      "bgra8unorm-storage",
      "texture-formats-tier1"
    ].filter((o) => t.features.has(o)), s = await t.requestDevice({
      requiredFeatures: n,
      requiredLimits: {
        maxSampledTexturesPerShaderStage: t.limits.maxSampledTexturesPerShaderStage,
        maxSamplersPerShaderStage: t.limits.maxSamplersPerShaderStage
      }
    });
    return { adapter: t, device: s };
  }
  destroy() {
    var e, t;
    (e = this._options) != null && e.gpu || (t = this.gpu) == null || t.device.destroy(), this.gpu = null, this.extensions = null, this._renderer = null;
  }
}
Fy.extension = {
  type: [
    Ie.WebGPUSystem
  ],
  name: "device"
};
Fy.defaultOptions = {
  /**
   * {@link WebGPUOptions.powerPreference}
   * @default default
   */
  powerPreference: void 0,
  /**
   * Force the use of the fallback adapter
   * @default false
   */
  forceFallbackAdapter: !1
};
class _ee {
  /**
   * @param gpuBundle - The recorded native render bundle.
   * @param stateKey - The pipeline state key captured when recording began.
   * @param device - The device the bundle was recorded on.
   * @param label - Optional debug label for the bundle.
   */
  constructor(e, t, n, s) {
    this.gpuBundle = e, this.stateKey = t, this.device = n, this.label = s;
  }
}
class aC {
  constructor(e) {
    this._boundBindGroup = /* @__PURE__ */ Object.create(null), this._boundVertexBuffer = /* @__PURE__ */ Object.create(null), this._renderer = e;
    for (let t = 0; t < 16; t++)
      this._boundBindGroup[t] = { bindGroup: null, program: null, key: null };
  }
  renderStart() {
    this.commandFinished = new Promise((e) => {
      this._resolveCommandFinished = e;
    }), this.commandEncoder = this._renderer.gpu.device.createCommandEncoder();
  }
  /**
   * Ends any open pass and begins one on the target's descriptor.
   * @param gpuRenderTarget - the target to render to
   * @returns the begun pass
   */
  beginRenderPass(e) {
    return this.endRenderPass(), this._clearCache(), this._passEncoder = this.commandEncoder.beginRenderPass(e.descriptor), this.renderPassEncoder = this._passEncoder, this._passEncoder;
  }
  endRenderPass() {
    this._passEncoder && this._passEncoder.end(), this.renderPassEncoder = null, this._passEncoder = null;
  }
  /**
   * Begins recording a render bundle. While recording, all draw commands are captured into a
   * {@link GPURenderBundleEncoder} instead of the active render pass. The current render pass
   * encoder is saved and restored when {@link endBundle} is called.
   *
   * Render bundles allow pre-recording of draw commands that can be replayed multiple times
   * via {@link executeBundle}, reducing CPU overhead for repeated draw sequences.
   * @param label - Optional debug label. Names the bundle in GPU captures and in the WebGPU
   * validation errors it can raise when replayed, instead of `(unlabeled)`.
   * @throws If a render bundle is already being recorded.
   */
  beginBundle(e) {
    if (this._passEncoder !== this.renderPassEncoder)
      throw new Error("Cannot begin a new render bundle while one is already being recorded.");
    this._clearCache();
    const t = this._renderer.pipeline, n = t.getBundleDescriptor();
    n.label = e, this._bundleStateKey = t.bundleStateKey, this._bundleLabel = e, this.renderPassEncoder = this._gpu.device.createRenderBundleEncoder(n);
  }
  /**
   * Finishes recording the current render bundle and restores the previous render pass encoder.
   * @returns The recorded {@link RenderBundle}, ready to be executed via {@link executeBundle} and
   * stamped with the pipeline state it baked so {@link isBundleValid} can vet it on later frames.
   */
  endBundle() {
    const e = this.renderPassEncoder;
    if (!e || !("finish" in e))
      throw new Error("endBundle called without an active render bundle.");
    const t = e.finish({ label: this._bundleLabel });
    return this.renderPassEncoder = this._passEncoder, this._clearCache(), new _ee(t, this._bundleStateKey, this._gpu.device, this._bundleLabel);
  }
  /**
   * Checks whether a recorded bundle can still be replayed against the render target that is
   * bound now.
   *
   * A bundle permanently bakes the attachment state it was recorded with — color format(s),
   * color target count, depth/stencil format, sample count — and WebGPU rejects the entire
   * command buffer if any of it differs at execute time. It also bakes the front-face winding of
   * its pipelines, which WebGPU does *not* validate: once the target's {@link RenderTarget.flipY}
   * parity changes, replaying silently renders geometry inside out.
   *
   * Ask before replaying rather than after: only the caller owns the draw commands, so only the
   * caller can re-record. A missing bundle reports `false`, so `!isBundleValid(bundles[i])` reads
   * correctly on the first frame, before anything has been recorded.
   * @param bundle - The bundle to check, as returned by {@link endBundle}.
   * @returns `true` if the bundle is safe to execute right now, `false` if it must be re-recorded.
   */
  isBundleValid(e) {
    return (e == null ? void 0 : e.stateKey) === this._renderer.pipeline.bundleStateKey && e.device === this._gpu.device;
  }
  /**
   * Replays previously recorded render bundles on the current render pass.
   * The bound state cache is cleared since a bundle may set its own pipeline, bind groups, and buffers.
   *
   * Pass a whole run of bundles rather than calling this once per bundle: WebGPU resets the pass
   * state after every call, so N calls cost N cache clears and N trips through the binding layer
   * for exactly the same result.
   *
   * Every bundle must have been recorded against a matching render target — check with
   * {@link isBundleValid} first and re-record if it says no, as Pixi cannot rebuild your draw
   * commands for you.
   * @param bundle - The render bundle to execute, or a run of them to execute in one call.
   */
  executeBundle(e) {
    const t = [];
    if (Array.isArray(e))
      for (let n = 0; n < e.length; n++)
        t[n] = this._getGpuBundle(e[n]);
    else
      t[0] = this._getGpuBundle(e);
    this._clearCache(), this._passEncoder.executeBundles(t);
  }
  /**
   * Unwraps a bundle for {@link executeBundle}, complaining first if it no longer matches the
   * bound render target — the winding half of that mismatch is invisible otherwise, since WebGPU
   * validates attachments but not front-face order.
   * @param bundle - The bundle being executed.
   * @returns The native bundle to hand to `executeBundles`.
   */
  _getGpuBundle(e) {
    var t;
    return this.isBundleValid(e) || dt(`Render bundle ${(t = e == null ? void 0 : e.label) != null ? t : "(unlabeled)"} was recorded against a different render target state or on a lost device. Re-record it — replaying it will either be rejected by WebGPU or draw with the wrong winding. Check encoder.isBundleValid(bundle) before executing.`), e.gpuBundle;
  }
  setViewport(e) {
    this._passEncoder.setViewport(e.x, e.y, e.width, e.height, 0, 1);
  }
  /**
   * Sets the stencil reference value for subsequent draws. This is a pass-level command, so it
   * always targets the real render pass — not a bundle encoder, which cannot set stencil state.
   * @param stencilReference - The stencil reference value to use.
   */
  setStencilReference(e) {
    this._passEncoder.setStencilReference(e);
  }
  setPipelineFromGeometryProgramAndState(e, t, n, s, o) {
    const r = this._renderer.pipeline.getPipeline(
      e,
      t,
      n,
      s,
      o
    );
    this.setPipeline(r);
  }
  setPipeline(e) {
    this._boundPipeline !== e && (this._boundPipeline = e, this.renderPassEncoder.setPipeline(e));
  }
  _setVertexBuffer(e, t) {
    this._boundVertexBuffer[e] !== t && (this._boundVertexBuffer[e] = t, this.renderPassEncoder.setVertexBuffer(e, this._renderer.buffer.updateBuffer(t)));
  }
  _setIndexBuffer(e) {
    if (this._boundIndexBuffer === e) return;
    this._boundIndexBuffer = e;
    const t = e.data.BYTES_PER_ELEMENT === 2 ? "uint16" : "uint32";
    this.renderPassEncoder.setIndexBuffer(this._renderer.buffer.updateBuffer(e), t);
  }
  resetBindGroup(e) {
    const t = this._boundBindGroup[e];
    t.bindGroup = null, t.program = null, t.key = null;
  }
  setBindGroup(e, t, n) {
    const s = this._boundBindGroup[e];
    if (s.bindGroup === t && s.program === n && s.key === t._key) return;
    s.bindGroup = t, s.program = n, s.key = t._key, t._touch(this._renderer.gc.now);
    const o = this._renderer.bindGroup.getBindGroup(t, n, e);
    this.renderPassEncoder.setBindGroup(e, o);
  }
  setGeometry(e, t) {
    const n = this._renderer.pipeline.getBufferNamesToBind(e, t);
    for (let s = 0; s < n.length; s++)
      this._setVertexBuffer(s, e.attributes[n[s]].buffer);
    e.indexBuffer && this._setIndexBuffer(e.indexBuffer);
  }
  _setShaderBindGroups(e, t) {
    const n = e.gpuProgram, s = n.layout;
    for (let o = 0; o < s.length; o++) {
      const r = e.groups[o];
      !s[o] || !r || (t || this._syncBindGroup(r), this.setBindGroup(o, r, n));
    }
  }
  _syncBindGroup(e) {
    const t = e.resources, n = e._resourceKeys;
    for (let s = 0; s < n.length; s++) {
      const o = t[n[s]];
      o && o.isUniformGroup && this._renderer.ubo.updateUniformGroup(o);
    }
  }
  draw(e) {
    const { geometry: t, shader: n, state: s, topology: o, size: r, start: a, baseVertex: l, instanceCount: d, skipSync: c, firstInstance: h } = e;
    this.setPipelineFromGeometryProgramAndState(t, n.gpuProgram, s, o, n._overrides), this.setGeometry(t, n.gpuProgram), this._setShaderBindGroups(n, c), t.indexBuffer ? this.renderPassEncoder.drawIndexed(
      r || t.indexCount || t.indexBuffer.data.length,
      d != null ? d : t.instanceCount,
      a || 0,
      l || 0,
      h || 0
    ) : this.renderPassEncoder.draw(
      r || t.vertexCount,
      d != null ? d : t.instanceCount,
      a || 0,
      h || 0
    );
  }
  /**
   * Sets up the pipeline, geometry, and bind groups then issues an indirect draw call.
   * Uses `drawIndexedIndirect` when the geometry has an index buffer, otherwise `drawIndirect`.
   * Draw parameters (vertex count, instance count, etc.) are read from the indirect buffer on the GPU.
   * @param options - The draw options.
   * @param options.geometry - The geometry to draw.
   * @param options.shader - The shader to use.
   * @param options.state - Optional render state (blending, depth, etc.).
   * @param options.topology - Optional primitive topology override.
   * @param options.skipSync - If true, skips syncing uniform groups to their GPU buffers.
   * @param options.indirectBuffer - The GPU buffer containing the indirect draw parameters.
   * @param options.indirectOffset - Byte offset into the indirect buffer.
   */
  drawIndirect(e) {
    const { geometry: t, shader: n, state: s, topology: o, skipSync: r, indirectBuffer: a, indirectOffset: l } = e;
    this.setPipelineFromGeometryProgramAndState(t, n.gpuProgram, s, o, n._overrides), this.setGeometry(t, n.gpuProgram), this._setShaderBindGroups(n, r), t.indexBuffer ? this.renderPassEncoder.drawIndexedIndirect(a, l) : this.renderPassEncoder.drawIndirect(a, l);
  }
  finishRenderPass() {
    this._passEncoder && (this._passEncoder.end(), this.renderPassEncoder = null, this._passEncoder = null);
  }
  postrender() {
    this.finishRenderPass(), this._gpu.device.queue.submit([this.commandEncoder.finish()]), this._resolveCommandFinished(), this.commandEncoder = null;
  }
  _clearCache() {
    for (let e = 0; e < 16; e++) {
      const t = this._boundBindGroup[e];
      t.bindGroup = null, t.program = null, t.key = null, this._boundVertexBuffer[e] = null;
    }
    this._boundIndexBuffer = null, this._boundPipeline = null;
  }
  destroy() {
    this._renderer = null, this._gpu = null, this._boundBindGroup = null, this._boundVertexBuffer = null, this._boundIndexBuffer = null, this._boundPipeline = null, this.renderPassEncoder = null, this._passEncoder = null;
  }
  contextChange(e) {
    this._gpu = e;
  }
}
aC.extension = {
  type: [Ie.WebGPUSystem],
  name: "encoder",
  priority: 1
};
class lC {
  constructor(e) {
    this.supportsOverrideConstants = !1, this._renderer = e;
  }
  contextChange() {
    const e = this._renderer.device.gpu.device;
    this.maxTextures = Math.min(
      e.limits.maxSampledTexturesPerShaderStage,
      e.limits.maxSamplersPerShaderStage
    ), this.maxBatchableTextures = this.maxTextures, this._detectOverrideConstantsSupport(e);
  }
  _detectOverrideConstantsSupport(e) {
    e.pushErrorScope("validation");
    const t = e.createShaderModule({
      code: `override TEST_VALUE: f32 = 0.0;
@compute @workgroup_size(1) fn main() {}`
    });
    e.createComputePipeline({
      layout: "auto",
      compute: {
        module: t,
        entryPoint: "main",
        constants: { TEST_VALUE: 1 }
      }
    }), e.popErrorScope().then((n) => {
      this.supportsOverrideConstants = !n;
    });
  }
  destroy() {
  }
}
lC.extension = {
  type: [
    Ie.WebGPUSystem
  ],
  name: "limits"
};
class dC {
  constructor(e) {
    this._renderer = e, e.renderTarget.onRenderTargetChange.add(this);
  }
  contextChange() {
    this._activeGpuRenderTarget = null;
  }
  onRenderTargetChange(e) {
    const t = this._renderer.renderTarget.getGpuRenderTarget(e);
    this._activeRenderTarget = e, this._activeGpuRenderTarget = t, this.setStencilMode(t.stencilMode, t.stencilReference);
  }
  setStencilMode(e, t) {
    var o;
    const n = (o = this._activeGpuRenderTarget) != null ? o : this._activeGpuRenderTarget = this._renderer.renderTarget.getGpuRenderTarget(this._activeRenderTarget);
    n.stencilMode = e, n.stencilReference = t;
    const s = this._renderer;
    s.pipeline.setStencilMode(e), s.encoder.setStencilReference(t);
  }
  destroy() {
    this._renderer.renderTarget.onRenderTargetChange.remove(this), this._renderer = null, this._activeRenderTarget = null, this._activeGpuRenderTarget = null;
  }
}
dC.extension = {
  type: [
    Ie.WebGPUSystem
  ],
  name: "stencil"
};
const Tp = {
  i32: { align: 4, size: 4 },
  u32: { align: 4, size: 4 },
  f32: { align: 4, size: 4 },
  f16: { align: 2, size: 2 },
  "vec2<i32>": { align: 8, size: 8 },
  "vec2<u32>": { align: 8, size: 8 },
  "vec2<f32>": { align: 8, size: 8 },
  "vec2<f16>": { align: 4, size: 4 },
  "vec3<i32>": { align: 16, size: 12 },
  "vec3<u32>": { align: 16, size: 12 },
  "vec3<f32>": { align: 16, size: 12 },
  "vec3<f16>": { align: 8, size: 6 },
  "vec4<i32>": { align: 16, size: 16 },
  "vec4<u32>": { align: 16, size: 16 },
  "vec4<f32>": { align: 16, size: 16 },
  "vec4<f16>": { align: 8, size: 8 },
  "mat2x2<f32>": { align: 8, size: 16 },
  "mat2x2<f16>": { align: 4, size: 8 },
  "mat3x2<f32>": { align: 8, size: 24 },
  "mat3x2<f16>": { align: 4, size: 12 },
  "mat4x2<f32>": { align: 8, size: 32 },
  "mat4x2<f16>": { align: 4, size: 16 },
  "mat2x3<f32>": { align: 16, size: 32 },
  "mat2x3<f16>": { align: 8, size: 16 },
  "mat3x3<f32>": { align: 16, size: 48 },
  "mat3x3<f16>": { align: 8, size: 24 },
  "mat4x3<f32>": { align: 16, size: 64 },
  "mat4x3<f16>": { align: 8, size: 32 },
  "mat2x4<f32>": { align: 16, size: 32 },
  "mat2x4<f16>": { align: 8, size: 16 },
  "mat3x4<f32>": { align: 16, size: 48 },
  "mat3x4<f16>": { align: 8, size: 24 },
  "mat4x4<f32>": { align: 16, size: 64 },
  "mat4x4<f16>": { align: 8, size: 32 }
};
function See(i) {
  const e = i.map((n) => ({
    data: n,
    offset: 0,
    size: 0
  }));
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    let o = Tp[s.data.type].size;
    const r = Tp[s.data.type].align;
    if (!Tp[s.data.type])
      throw new Error(`[Pixi.js] WebGPU UniformBuffer: Unknown type ${s.data.type}`);
    s.data.size > 1 && (o = Math.max(o, r) * s.data.size), t = Math.ceil(t / r) * r, s.size = o, s.offset = t, t += o;
  }
  return t = Math.ceil(t / 16) * 16, { uboElements: e, size: t };
}
function Mee(i, e) {
  const { size: t, align: n } = Tp[i.data.type], s = (Math.max(t, n) - t) / 4, o = i.data.type.indexOf("i32") >= 0 ? "dataInt32" : "data";
  return `
         v = uv.${i.data.name};
         ${e !== 0 ? `offset += ${e};` : ""}

         arrayOffset = offset;

         t = 0;

         for(var i=0; i < ${i.data.size}; i++)
         {
             for(var j = 0; j < ${t / 4}; j++)
             {
                 ${o}[arrayOffset++] = v[t++];
             }
             ${s !== 0 ? `arrayOffset += ${s};` : ""}
         }
     `;
}
function Tee(i) {
  return FT(
    i,
    IQ,
    Mee
  );
}
class cC extends LT {
  constructor() {
    super({
      createUboElements: See,
      generateUboSync: Tee
    });
  }
}
cC.extension = {
  type: [Ie.WebGPUSystem],
  name: "ubo"
};
const bo = 128;
class uC {
  constructor(e) {
    this._bindGroupHash = /* @__PURE__ */ Object.create(null), this._buffers = [], this._bindGroups = [], this._bufferResources = [], this._renderer = e, this._batchBuffer = new wee({ minUniformOffsetAlignment: bo });
    const t = 256 / bo;
    for (let n = 0; n < t; n++) {
      let s = $t.UNIFORM | $t.COPY_DST;
      n === 0 && (s |= $t.COPY_SRC), this._buffers.push(new ns({
        data: this._batchBuffer.data,
        usage: s
      }));
    }
  }
  renderEnd() {
    this._uploadBindGroups(), this._resetBindGroups();
  }
  _resetBindGroups() {
    this._bindGroupHash = /* @__PURE__ */ Object.create(null), this._batchBuffer.clear();
  }
  // just works for single bind groups for now
  getUniformBindGroup(e, t) {
    if (!t && this._bindGroupHash[e.uid])
      return this._bindGroupHash[e.uid];
    this._renderer.ubo.ensureUniformGroup(e);
    const n = e.buffer.data, s = this._batchBuffer.addEmptyGroup(n.length);
    return this._renderer.ubo.syncUniformGroup(e, this._batchBuffer.data, s / 4), this._bindGroupHash[e.uid] = this._getBindGroup(s / bo), this._bindGroupHash[e.uid];
  }
  getUboResource(e) {
    this._renderer.ubo.updateUniformGroup(e);
    const t = e.buffer.data, n = this._batchBuffer.addGroup(t);
    return this._getBufferResource(n / bo);
  }
  getArrayBindGroup(e) {
    const t = this._batchBuffer.addGroup(e);
    return this._getBindGroup(t / bo);
  }
  getArrayBufferResource(e) {
    const n = this._batchBuffer.addGroup(e) / bo;
    return this._getBufferResource(n);
  }
  _getBufferResource(e) {
    if (!this._bufferResources[e]) {
      const t = this._buffers[e % 2];
      this._bufferResources[e] = new Ly({
        buffer: t,
        offset: (e / 2 | 0) * 256,
        size: bo
      });
    }
    return this._bufferResources[e];
  }
  _getBindGroup(e) {
    if (!this._bindGroups[e]) {
      const t = new qo({
        0: this._getBufferResource(e)
      });
      this._bindGroups[e] = t;
    }
    return this._bindGroups[e];
  }
  _uploadBindGroups() {
    const e = this._renderer.buffer, t = this._buffers[0];
    t.update(this._batchBuffer.byteIndex), e.updateBuffer(t);
    const n = this._renderer.gpu.device.createCommandEncoder();
    for (let s = 1; s < this._buffers.length; s++) {
      const o = this._buffers[s];
      n.copyBufferToBuffer(
        e.getGPUBuffer(t),
        bo,
        e.getGPUBuffer(o),
        0,
        this._batchBuffer.byteIndex
      );
    }
    this._renderer.gpu.device.queue.submit([n.finish()]);
  }
  destroy() {
    var e;
    for (let t = 0; t < this._bindGroups.length; t++)
      (e = this._bindGroups[t]) == null || e.destroy();
    this._bindGroups = null, this._bindGroupHash = null;
    for (let t = 0; t < this._buffers.length; t++)
      this._buffers[t].destroy();
    this._buffers = null;
    for (let t = 0; t < this._bufferResources.length; t++)
      this._bufferResources[t].destroy();
    this._bufferResources = null, this._batchBuffer.destroy(), this._renderer = null;
  }
}
uC.extension = {
  type: [
    Ie.WebGPUPipes
  ],
  name: "uniformBatch"
};
const W2 = {
  "point-list": 0,
  "line-list": 1,
  "line-strip": 2,
  "triangle-list": 3,
  "triangle-strip": 4
}, Cee = new Vc({}), Iee = {
  "depth24plus-stencil8": { depth: !0, stencil: !0, index: 1 },
  depth24plus: { depth: !0, stencil: !1, index: 2 },
  depth32float: { depth: !0, stencil: !1, index: 3 },
  "depth32float-stencil8": { depth: !0, stencil: !0, index: 4 },
  depth16unorm: { depth: !0, stencil: !1, index: 5 },
  stencil8: { depth: !1, stencil: !0, index: 6 }
}, q2 = { depth: !1, stencil: !1, index: 0 };
function K2(i, e) {
  for (const [t, n] of Object.entries(e)) {
    const s = new RegExp(
      `override\\s+${t}\\s*:\\s*(\\w+)\\s*(?:=[^;]*)?;`
    );
    i = i.replace(s, (o, r) => {
      let a;
      return r === "u32" ? a = `${Math.trunc(n)}u` : r === "i32" ? a = `${Math.trunc(n)}` : a = Number.isInteger(n) ? `${n}.0` : `${n}`, `const ${t}: ${r} = ${a};`;
    });
  }
  return i;
}
function Y2(i, e, t, n, s, o) {
  return i * 35184372088832 + e * 536870912 + o * 16384 + (t << 8) + (n << 3) + s;
}
const X2 = /* @__PURE__ */ Object.create(null);
let Aee = 0;
function J2(i) {
  let e = X2[i];
  return e === void 0 && (e = X2[i] = Aee++), e;
}
function Pee(i, e, t, n, s, o, r, a) {
  return a << 20 | o << 16 | s << 13 | t << 9 | i << 6 | r << 5 | n << 1 | e;
}
function Eee(i, e, t, n, s, o, r) {
  return r << 11 | o << 10 | s << 9 | n << 8 | t << 5 | e << 1 | i;
}
class hC {
  constructor(e) {
    this._moduleCache = /* @__PURE__ */ Object.create(null), this._bufferLayoutsCache = /* @__PURE__ */ Object.create(null), this._bindingNamesCache = /* @__PURE__ */ Object.create(null), this._pipeCache = /* @__PURE__ */ new Map(), this._pipeStateCaches = /* @__PURE__ */ Object.create(null), this._colorMask = 15, this._multisampleCount = 1, this._colorTargetCount = 1, this._colorFormat = "bgra8unorm", this._colorFormatId = J2("bgra8unorm"), this._depthStencilFormat = "depth24plus-stencil8", this._depthStencilFormatData = q2, this._depthReadOnly = !1, this._stencilReadOnly = !1, this._invertFrontFace = !1, this._renderer = e;
  }
  contextChange(e) {
    this._gpu = e, this._moduleCache = /* @__PURE__ */ Object.create(null), this._pipeStateCaches = /* @__PURE__ */ Object.create(null), this.setStencilMode(fn.DISABLED), this._updatePipeHash();
  }
  setMultisampleCount(e) {
    this._multisampleCount !== e && (this._multisampleCount = e, this._updatePipeHash());
  }
  setRenderTarget(e) {
    var n, s, o, r, a, l, d;
    const t = (n = e.colorAttachments[0]) == null ? void 0 : n.texture;
    this._multisampleCount = t != null && t.source.antialias ? 4 : 1, this._colorTargetCount = e.colorAttachments.length, this._colorFormat = (s = t == null ? void 0 : t.format) != null ? s : "bgra8unorm", this._colorFormatId = J2(this._colorFormat), this._depthStencilFormat = (o = e.depthStencilAttachment) == null ? void 0 : o.texture.format, this._depthStencilFormatData = Iee[this._depthStencilFormat] || q2, this._depthReadOnly = (a = (r = e.depthStencilAttachment) == null ? void 0 : r.depthReadOnly) != null ? a : !1, this._stencilReadOnly = (d = (l = e.depthStencilAttachment) == null ? void 0 : l.stencilReadOnly) != null ? d : this._depthReadOnly, this._invertFrontFace = this._renderer.renderTarget.isFrontFaceInverted(e, e.flipY), this._updatePipeHash();
  }
  setColorMask(e) {
    this._colorMask !== e && (this._colorMask = e, this._updatePipeHash());
  }
  setStencilMode(e) {
    this._stencilMode !== e && (this._stencilMode = e, this._stencilState = cr[e], this._updatePipeHash());
  }
  /**
   * A packed key for everything a render bundle recorded right now would bake into itself: the
   * attachment state WebGPU validates when the bundle is executed (color format(s), color target
   * count, depth/stencil format, sample count, read-only aspects), plus the front-face winding
   * its pipelines capture — which WebGPU does *not* validate.
   *
   * Equal keys mean a bundle recorded then is compatible with, and correct for, the pass now;
   * different keys mean it has to be re-recorded before it is replayed. Comparing the two is
   * what {@link GpuEncoderSystem.isBundleValid} does.
   *
   * `colorMask` and `stencilMode` are deliberately left out, unlike the pipeline cache key: they
   * are ambient draw state a bundle bakes per-pipeline as it records, so their value at execute
   * time says nothing about whether the bundle is still good.
   */
  get bundleStateKey() {
    const e = this._depthStencilFormatData;
    return Eee(
      // normalize the raw sample count (1 or 4 — WebGPU's only renderable counts) to a
      // true single bit, so it cannot spill into the colorTargetCount field above it
      this._multisampleCount === 1 ? 0 : 1,
      this._colorTargetCount,
      e.index,
      // the same two flags getBundleDescriptor sets — keep them in step
      e.depth && this._depthReadOnly ? 1 : 0,
      e.stencil && this._stencilReadOnly ? 1 : 0,
      this._invertFrontFace ? 1 : 0,
      this._colorFormatId
    );
  }
  /**
   * Builds a `GPURenderBundleEncoderDescriptor` that matches the current render target
   * configuration (color formats, sample count, depth/stencil format, and which of its aspects
   * are read-only).
   * Used by {@link GpuEncoderSystem.beginBundle} to create a compatible render bundle encoder.
   * @returns A descriptor for creating a GPURenderBundleEncoder.
   */
  getBundleDescriptor() {
    const e = [];
    for (let s = 0; s < this._colorTargetCount; s++)
      e.push(this._colorFormat);
    const t = {
      colorFormats: e,
      sampleCount: this._multisampleCount
    }, n = this._depthStencilFormatData;
    return (n.depth || n.stencil) && (t.depthStencilFormat = this._depthStencilFormat, n.depth && this._depthReadOnly && (t.depthReadOnly = !0), n.stencil && this._stencilReadOnly && (t.stencilReadOnly = !0)), t;
  }
  setPipeline(e, t, n, s) {
    const o = this.getPipeline(e, t, n);
    s.setPipeline(o);
  }
  /**
   * Generates a key for the pipeline.advanced usage only.
   * @param geometry - The geometry to get the key for
   * @param program - The program to get the key for
   * @param state - The state to get the key for
   * @param topology - The topology to get the key for
   * @param overrides - The overrides to get the key for
   * @returns The key for the pipeline
   */
  getPipelineKey(e, t, n, s, o) {
    return e._layoutKey || (h0(e, t.attributeData), this._generateBufferKey(e)), Y2(
      e._layoutKey,
      t._layoutKey,
      n.data,
      n._blendModeId,
      W2[s],
      o.id
    );
  }
  getPipeline(e, t, n, s, o) {
    e._layoutKey || (h0(e, t.attributeData), this._generateBufferKey(e)), s || (s = e.topology), o || (o = Cee);
    const r = Y2(
      e._layoutKey,
      t._layoutKey,
      n.data,
      n._blendModeId,
      W2[s],
      o.id
    );
    let a = this._pipeCache.get(r);
    return a || (a = this._createPipeline(e, t, n, s, o), this._pipeCache.set(r, a)), a;
  }
  _createPipeline(e, t, n, s, o) {
    const r = this._gpu.device, a = this._createVertexBufferLayouts(e, t), l = this._renderer.state.getColorTargets(n, this._colorTargetCount, this._colorFormat), d = this._stencilMode === fn.RENDERING_MASK_ADD ? 0 : this._colorMask;
    for (let w = 0; w < l.length; w++)
      l[w].writeMask = d;
    const c = this._renderer.shader.getProgramData(t).pipeline, h = Object.keys(o.data).length > 0;
    let f = t.vertex.source, p = t.fragment.source, y;
    h && (this._renderer.limits.supportsOverrideConstants ? y = o.data : (f = K2(f, o.data), p = K2(p, o.data)));
    const v = {
      // TODO later check if its helpful to create..
      // layout,
      vertex: {
        module: this._getModule(f),
        entryPoint: t.vertex.entryPoint,
        constants: y,
        buffers: a
      },
      fragment: {
        module: this._getModule(p),
        entryPoint: t.fragment.entryPoint,
        targets: l,
        constants: y
      },
      primitive: {
        topology: s,
        // Mirror WebGL's split: `gl.cullFace` is left at its `BACK` default, so the back is always
        // the culled side. Taking this from `state.cullMode` instead folds the winding into *which
        // side* is culled — the same triangles survive, but `@builtin(front_facing)` then reports
        // the opposite of `gl_FrontFacing` for clockwise-wound geometry.
        cullMode: n.culling ? "back" : "none",
        // The winding is stated once, here, exactly as `gl.frontFace` does it. `flipY` inverts the
        // projection (see setRenderTarget), so inverting the winding alongside it makes the two
        // cancel and a front face stays a front face. Both flags are part of the pipeline cache key.
        frontFace: n.clockwiseFrontFace !== this._invertFrontFace ? "cw" : "ccw"
      },
      layout: c,
      multisample: {
        count: this._multisampleCount
      },
      // depthStencil,
      label: t.name ? `PIXI Pipeline (${t.name})` : "PIXI Pipeline"
    };
    if (this._depthStencilFormatData.depth || this._depthStencilFormatData.stencil) {
      const w = this._depthStencilFormatData;
      v.depthStencil = {
        ...this._stencilState,
        format: this._depthStencilFormat,
        depthWriteEnabled: w.depth ? n.depthMask && !this._depthReadOnly : !1,
        depthCompare: w.depth && n.depthTest ? "less" : "always"
      };
    }
    return r.createRenderPipeline(v);
  }
  _getModule(e) {
    return this._moduleCache[e] || this._createModule(e);
  }
  _createModule(e) {
    const t = this._gpu.device;
    return this._moduleCache[e] = t.createShaderModule({
      code: e
    }), this._moduleCache[e];
  }
  /**
   * Generates and caches a numeric layout key on the geometry based on its sorted attribute
   * descriptors (offset, format, stride, instancing). Geometries with identical attribute
   * layouts share the same key, enabling pipeline reuse.
   * @param geometry - The geometry to generate a layout key for.
   */
  _generateBufferKey(e) {
    const t = [];
    let n = 0;
    const s = Object.keys(e.attributes).sort();
    for (let r = 0; r < s.length; r++) {
      const a = e.attributes[s[r]];
      t[n++] = a.offset, t[n++] = a.format, t[n++] = a.stride, t[n++] = a.instance;
    }
    const o = t.join("|");
    return e._layoutKey = Ll(o, "geometry"), e._layoutKey;
  }
  _generateAttributeLocationsKey(e) {
    const t = [];
    let n = 0;
    const s = Object.keys(e.attributeData).sort();
    for (let r = 0; r < s.length; r++) {
      const a = e.attributeData[s[r]];
      t[n++] = a.location;
    }
    const o = t.join("|");
    return e._attributeLocationsKey = Ll(o, "programAttributes"), e._attributeLocationsKey;
  }
  /**
   * Returns the buffer names to bind, one per vertex buffer slot.
   * This is used to bind the correct buffer to the correct location in the shader.
   * @param geometry - The geometry where to get the buffer names
   * @param program - The program where to get the buffer names
   * @returns The buffer names, indexed by vertex buffer slot.
   */
  getBufferNamesToBind(e, t) {
    const n = e._layoutKey << 16 | t._attributeLocationsKey;
    if (this._bindingNamesCache[n]) return this._bindingNamesCache[n];
    const s = this._createVertexBufferLayouts(e, t), o = [], r = t.attributeData;
    for (let a = 0; a < s.length; a++) {
      const d = Object.values(s[a].attributes)[0].shaderLocation;
      for (const c in r)
        if (r[c].location === d) {
          o[a] = c;
          break;
        }
    }
    return this._bindingNamesCache[n] = o, o;
  }
  _createVertexBufferLayouts(e, t) {
    t._attributeLocationsKey || this._generateAttributeLocationsKey(t);
    const n = e._layoutKey << 16 | t._attributeLocationsKey;
    if (this._bufferLayoutsCache[n])
      return this._bufferLayoutsCache[n];
    const s = [];
    return e.buffers.forEach((o) => {
      var l;
      const r = {
        arrayStride: 0,
        stepMode: "vertex",
        attributes: []
      }, a = r.attributes;
      for (const d in t.attributeData) {
        const c = e.attributes[d];
        ((l = c.divisor) != null ? l : 1) !== 1 && dt(`Attribute ${d} has an invalid divisor value of '${c.divisor}'. WebGPU only supports a divisor value of 1`), c.buffer === o && (r.arrayStride = c.stride, r.stepMode = c.instance ? "instance" : "vertex", a.push({
          shaderLocation: t.attributeData[d].location,
          offset: c.offset,
          format: c.format
        }));
      }
      a.length && s.push(r);
    }), this._bufferLayoutsCache[n] = s, s;
  }
  _updatePipeHash() {
    var n;
    var e;
    const t = Pee(
      this._stencilMode,
      // normalize the raw sample count (1 or 4 — WebGPU's only renderable counts) to a
      // true single bit, so it cannot spill into the colorTargetCount field above it
      this._multisampleCount === 1 ? 0 : 1,
      this._colorMask,
      this._colorTargetCount,
      this._depthStencilFormatData.index,
      this._colorFormatId,
      this._depthReadOnly ? 1 : 0,
      this._invertFrontFace ? 1 : 0
    );
    this._pipeCache = (n = (e = this._pipeStateCaches)[t]) != null ? n : e[t] = /* @__PURE__ */ new Map();
  }
  destroy() {
    this._bufferLayoutsCache = null, this._pipeCache = null, this._gpu = null, this._renderer = null, this._bindingNamesCache = null, this._pipeStateCaches = null, this._moduleCache = null;
  }
}
hC.extension = {
  type: [Ie.WebGPUSystem],
  name: "pipeline"
};
class Ree {
  constructor(e) {
    this._pipelines = /* @__PURE__ */ Object.create(null), this._modules = /* @__PURE__ */ Object.create(null), this._bindGroups = /* @__PURE__ */ new WeakMap(), this._renderer = e, this._device = e.gpu.device, this._layout = this._device.createBindGroupLayout({
      entries: [{
        binding: 0,
        visibility: GPUShaderStage.FRAGMENT,
        texture: { sampleType: "unfilterable-float" }
      }]
    }), this._pipelineLayout = this._device.createPipelineLayout({ bindGroupLayouts: [this._layout] });
  }
  /**
   * Copies one colour attachment's resolved image into the target's back texture, creating it on first use
   * at the attachment's size and format. Must be recorded outside a render pass.
   * @param commandEncoder - the encoder to record the copy on
   * @param renderTarget - the target being reopened
   * @param index - the colour attachment to copy
   * @param resolved - the attachment's resolved texture
   */
  copy(e, t, n, s) {
    var d;
    var o;
    const r = this._renderer.renderTarget.getGpuRenderTarget(t), a = t.colorAttachments[n].texture;
    (d = (o = r.msaaBackTextures)[n]) != null || (o[n] = new un({
      label: "msaa-back-texture",
      width: a.width,
      height: a.height,
      resolution: a._resolution,
      format: r.msaaTextures[n].format,
      autoGenerateMipmaps: !1,
      // every restore copies into it afresh, so an idle one can be freed and re-created on the next restore
      autoGarbageCollect: !0
    }));
    const l = this._renderer.texture.getGpuSource(r.msaaBackTextures[n]);
    e.copyTextureToTexture(
      { texture: s },
      { texture: l },
      { width: Math.min(s.width, l.width), height: Math.min(s.height, l.height) }
    );
  }
  /**
   * Draws one colour attachment's back texture into the multisampled buffer. Must be the first draw of the
   * pass, before any viewport or scissor is set.
   * @param pass - the pass that was just begun
   * @param renderTarget - the target the pass renders to
   * @param index - the colour attachment to restore, copied by {@link GpuMsaaRestore.copy}
   */
  draw(e, t, n) {
    var c, h, f, p;
    var s;
    const o = this._renderer.renderTarget.getGpuRenderTarget(t), r = this._renderer.texture.getGpuSource(o.msaaBackTextures[n]);
    let a = (h = (c = t.depthStencilAttachment) == null ? void 0 : c.texture.format) != null ? h : "";
    for (const y of t.colorAttachments)
      a += `|${y.texture.format}`;
    const l = (f = (s = this._pipelines)[a]) != null ? f : s[a] = [];
    let d = this._bindGroups.get(r);
    d || (d = this._device.createBindGroup({
      layout: this._layout,
      entries: [{ binding: 0, resource: r.createView() }]
    }), this._bindGroups.set(r, d)), e.setPipeline((p = l[n]) != null ? p : l[n] = this._createPipeline(t, n)), e.setBindGroup(0, d), e.draw(3);
  }
  _getModule(e) {
    var n;
    var t;
    return (n = (t = this._modules)[e]) != null || (t[e] = this._device.createShaderModule({
      label: "msaa-restore",
      code: (
        /* wgsl */
        `
                @group(0) @binding(0) var resolved: texture_2d<f32>;

                @vertex
                fn vertexMain(@builtin(vertex_index) i: u32) -> @builtin(position) vec4<f32> {
                    let pos = array<vec2<f32>, 3>(vec2<f32>(-1.0, -1.0), vec2<f32>(3.0, -1.0), vec2<f32>(-1.0, 3.0));

                    return vec4<f32>(pos[i], 0.0, 1.0);
                }

                @fragment
                fn fragmentMain(@builtin(position) position: vec4<f32>) -> @location(${e}) vec4<f32> {
                    return textureLoad(resolved, vec2<i32>(position.xy), 0);
                }
            `
      )
    })), this._modules[e];
  }
  _createPipeline(e, t) {
    var r;
    const n = (r = e.depthStencilAttachment) == null ? void 0 : r.texture.format;
    let s;
    n && (s = { format: n }, n.includes("depth") && (s.depthWriteEnabled = !1, s.depthCompare = "always"));
    const o = this._getModule(t);
    return this._device.createRenderPipeline({
      label: "msaa-restore",
      layout: this._pipelineLayout,
      vertex: { module: o, entryPoint: "vertexMain" },
      fragment: {
        module: o,
        entryPoint: "fragmentMain",
        // every attachment must be declared to match the pass; only the restored one is written
        targets: e.colorAttachments.map((a, l) => ({
          format: a.texture.format,
          writeMask: l === t ? GPUColorWrite.ALL : 0
        }))
      },
      depthStencil: s,
      multisample: { count: 4 }
    });
  }
}
class zee {
  constructor() {
    this.contexts = [], this.canvasTextures = [], this.msaaTextures = [], this.transient = !1, this.msaaSamples = 1, this.msaaBackTextures = [], this.stencilMode = fn.DISABLED, this.stencilReference = 0, this.maskStackIndex = 0;
  }
}
const $ee = {
  bgra8unorm: !0,
  rgba8unorm: !0,
  rgba16float: !0
};
function Dee(i) {
  if ($ee[i]) return i;
  const e = navigator.gpu.getPreferredCanvasFormat();
  return dt(`[WebGPU] CanvasSource format '${i}' is not a valid GPUCanvasContext format. Falling back to '${e}'. Allowed formats are: bgra8unorm, rgba8unorm, rgba16float.`), e;
}
class Oee {
  constructor() {
    this._activePass = null;
  }
  init(e, t) {
    this._renderer = e, this._renderTargetSystem = t, e.runners.contextChange.add(this), e.runners.destroy.add(this);
  }
  /** Drops the restore helper, whose pipelines belong to the old device. The next restore makes a new one. */
  contextChange() {
    this._msaaRestore = null;
  }
  destroy() {
    this._msaaRestore = null;
  }
  copyToTexture(e, t, n, s, o) {
    const r = this._renderer;
    this.finishRenderPass();
    const a = this._getGpuColorTexture(
      e
    ), l = r.texture.getGpuSource(
      t.source
    );
    return r.encoder.commandEncoder.copyTextureToTexture(
      {
        texture: a,
        origin: n
      },
      {
        texture: l,
        origin: o
      },
      s
    ), t;
  }
  copyDepthTexture(e, t, n, s, o) {
    const r = this._renderer;
    this.finishRenderPass();
    const a = e.depthStencilAttachment.texture, l = r.texture.getGpuSource(a), d = r.texture.getGpuSource(t.source), c = r.encoder.commandEncoder === null, h = c ? r.gpu.device.createCommandEncoder() : r.encoder.commandEncoder;
    h.copyTextureToTexture(
      { texture: l, origin: n },
      { texture: d, origin: o },
      { width: s.width, height: s.height }
    ), c && r.gpu.device.queue.submit([h.finish()]);
  }
  startRenderPass(e, t = !0, n, s, o = 0, r = 0) {
    var x, w;
    const l = this._renderTargetSystem.getGpuRenderTarget(e);
    if (r !== 0 && ((x = l.msaaTextures) != null && x.length))
      throw new Error("[RenderTargetSystem] Rendering to array layers is not supported with MSAA render targets.");
    if (o > 0 && ((w = l.msaaTextures) != null && w.length))
      throw new Error("[RenderTargetSystem] Rendering to mip levels is not supported with MSAA render targets.");
    let d = t;
    typeof d == "boolean" && (d = d ? Mn.ALL : Mn.NONE), (e.stencil || e.depth) && !e.depthStencilAttachment && e.ensureDepthStencilTexture();
    const c = !!e.depthStencilAttachment, h = this._activePass, f = h !== null && h.renderTarget === e && h.mipLevel === o && h.layer === r && h.depthStencil === c && this._renderer.encoder.renderPassEncoder !== null && d === Mn.NONE;
    if (this._renderer.pipeline.setRenderTarget(e), f) {
      this._renderer.encoder.setViewport(s);
      return;
    }
    const { descriptor: p, restore: y } = this._buildDescriptor(e, t, n, o, r);
    l.descriptor = p;
    const v = this._renderer.encoder;
    y ? (v.endRenderPass(), this._beginRestoredPass(
      e,
      y,
      v.commandEncoder,
      () => v.beginRenderPass(l)
    )) : v.beginRenderPass(l), v.setViewport(s), this._activePass = { renderTarget: e, mipLevel: o, layer: r, depthStencil: c };
  }
  finishRenderPass() {
    this._renderer.encoder.endRenderPass(), this._activePass = null;
  }
  /**
   * Begins a pass whose MSAA colour must be restored: copies each resolved texture in `restore` into the
   * target's back textures, begins the pass, and draws them back in before anything else (see GpuMsaaRestore).
   * @param renderTarget - the target being reopened
   * @param restore - the colour attachments to restore
   * @param commandEncoder - the encoder to record the copies on, with no pass open
   * @param beginPass - begins the pass on the same encoder
   * @returns the begun pass
   */
  _beginRestoredPass(e, t, n, s) {
    var a;
    const o = (a = this._msaaRestore) != null ? a : this._msaaRestore = new Ree(this._renderer);
    for (const l of t)
      o.copy(n, e, l, this._getGpuColorTexture(e, l));
    const r = s();
    for (const l of t)
      o.draw(r, e, l);
    return r;
  }
  /**
   * returns the gpu texture for a color texture in the render target, the first by default
   * mainly used by the filter manager to copy the texture for blending
   * @param renderTarget
   * @param index - the color attachment to get
   * @returns a gpu texture
   */
  _getGpuColorTexture(e, t = 0) {
    if (e.colorAttachments.length === 0)
      throw new Error("[GpuRenderTargetAdaptor] cannot get gpu color texture from a depth-only render target");
    const n = e.colorAttachments[t].texture;
    return n instanceof Ai && n._gpuContext ? n._gpuContext.getCurrentTexture() : this._renderer.texture.getGpuSource(n);
  }
  getDescriptor(e, t, n, s = 0, o = 0) {
    return this._buildDescriptor(e, t, n, s, o).descriptor;
  }
  /**
   * Builds the pass descriptor, along with the MSAA colour attachments it opens with `clear` in place of
   * `load`. Those buffers were discarded, so the pass must restore them before drawing.
   * @param renderTarget - the target to render to
   * @param clear - what to clear
   * @param clearValue - the colour to clear to
   * @param mipLevel - the mip level to render to
   * @param layer - the array layer to render to
   */
  _buildDescriptor(e, t, n, s = 0, o = 0) {
    var f, p, y, v, x, w, S, M;
    let r = null;
    typeof t == "boolean" && (t = t ? Mn.ALL : Mn.NONE);
    const a = this._renderTargetSystem, l = a.getGpuRenderTarget(e), d = e.colorAttachments.map(
      (_, T) => {
        var N, X;
        const k = _.texture, P = k instanceof Ai ? k._gpuContext : null;
        let A, R, D = !1;
        if (P) {
          if (o !== 0)
            throw new Error("[RenderTargetSystem] Rendering to array layers is not supported for canvas targets.");
          const B = P.getCurrentTexture();
          D = l.canvasTextures[T] !== B, l.canvasTextures[T] = B, A = B.createView(_.viewDescriptor);
        } else
          A = this._renderer.texture.getTextureRenderTargetView(
            _.texture,
            s,
            o,
            _.viewDescriptor
          );
        const O = l.msaaTextures[T];
        O && (R = A, A = this._renderer.texture.getTextureView(O));
        let F = _.loadOp;
        t !== void 0 && (F = t & Mn.COLOR ? "clear" : "load"), n != null || (n = a.defaultClearColor);
        const te = !!(O != null && O.transient), ee = te && F !== "clear", me = ee && !D;
        ee && (F = "clear", me && (r != null ? r : r = []).push(T));
        const L = {
          view: A,
          resolveTarget: R,
          storeOp: te ? "discard" : (N = _.storeOp) != null ? N : "store",
          loadOp: F
        };
        k.dimension === "3d" && (L.depthSlice = o), ee ? L.clearValue = [0, 0, 0, 0] : F === "clear" && (n != null || (n = (X = _.clearValue) != null ? X : a.defaultClearColor), L.clearValue = n);
        for (const B in _)
          B !== "texture" && B !== "viewDescriptor" && B !== "clearValue" && B !== "loadOp" && B !== "storeOp" && (L[B] = _[B]);
        return L;
      }
    );
    let c;
    if (e.depthStencilAttachment) {
      this._prepareDepthStencil(e, l);
      const _ = e.depthStencilAttachment, T = _.texture.format.includes("stencil"), k = _.texture.format.includes("depth"), P = l.transient ? "discard" : "store", A = l.transient ? "clear" : "load";
      c = {
        view: this._renderer.texture.getTextureRenderTargetView(
          _.texture,
          s,
          o,
          _.viewDescriptor
        )
      };
      const R = (f = _.depthReadOnly) != null ? f : !1, D = (p = _.stencilReadOnly) != null ? p : R;
      T && !D ? (c.stencilLoadOp = t & Mn.STENCIL ? "clear" : (y = _.stencilLoadOp) != null ? y : A, c.stencilStoreOp = (v = _.stencilStoreOp) != null ? v : P, c.stencilLoadOp === "clear" && (c.stencilClearValue = (x = _.stencilClearValue) != null ? x : 0)) : T && D && (c.stencilReadOnly = !0), k && !R ? (c.depthLoadOp = t & Mn.DEPTH ? "clear" : (w = _.depthLoadOp) != null ? w : A, c.depthStoreOp = (S = _.depthStoreOp) != null ? S : P, c.depthLoadOp === "clear" && (c.depthClearValue = (M = _.depthClearValue) != null ? M : 1)) : k && R && (c.depthReadOnly = !0);
      for (const O in _)
        O !== "texture" && O !== "viewDescriptor" && O !== "stencilLoadOp" && O !== "stencilStoreOp" && O !== "stencilClearValue" && O !== "stencilReadOnly" && O !== "depthLoadOp" && O !== "depthStoreOp" && O !== "depthClearValue" && O !== "depthReadOnly" && (c[O] = _[O]);
    }
    return { descriptor: {
      colorAttachments: d,
      depthStencilAttachment: c,
      label: e.label
    }, restore: r };
  }
  clear(e, t = !0, n, s, o = 0, r = 0) {
    if (!t) return;
    const { gpu: a, encoder: l } = this._renderer, d = a.device;
    if (l.commandEncoder === null) {
      const h = d.createCommandEncoder(), { descriptor: f, restore: p } = this._buildDescriptor(e, t, n, o, r), y = () => h.beginRenderPass(f), v = p ? this._beginRestoredPass(e, p, h, y) : y();
      v.setViewport(s.x, s.y, s.width, s.height, 0, 1), v.end();
      const x = h.finish();
      d.queue.submit([x]);
    } else
      this.startRenderPass(e, t, n, s, o, r);
  }
  initGpuRenderTarget(e) {
    var n;
    e.isRoot = !0;
    const t = new zee();
    return t.transient = !!((n = e.colorTexture) != null && n.antialias) && !!e.colorTexture.transient, e.colorAttachments.forEach((s, o) => {
      var a;
      const r = s.texture;
      if (r instanceof Ai) {
        const l = (a = r._gpuContext) != null ? a : r._gpuContext = r.resource.getContext(
          "webgpu"
        ), d = r.transparent ? "premultiplied" : "opaque", c = Dee(r.format);
        try {
          l.configure({
            device: this._renderer.gpu.device,
            usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC,
            format: c,
            alphaMode: d,
            ...c === "rgba16float" ? { toneMapping: { mode: "extended" } } : {}
          });
        } catch (h) {
          console.error(h);
        }
        t.contexts[o] = l;
      }
      if (t.msaa = r.source.antialias, r.antialias) {
        const l = new un({
          width: 0,
          height: 0,
          sampleCount: 4,
          // WebGPU requires multisampled textures to have exactly 1 mip level, so this must never
          // inherit TextureSource.defaultOptions.autoGenerateMipmaps
          autoGenerateMipmaps: !1,
          transient: this._renderer.device.extensions.tileBased || t.transient,
          arrayLayerCount: r.arrayLayerCount,
          format: r.format
        });
        t.msaaTextures[o] = l;
      }
    }), t.msaa && (t.msaaSamples = 4), t;
  }
  /**
   * Sets up a depth/stencil texture for an MSAA target before its GPU texture is created: 4 samples, and
   * the transient usage bit when the user marked the target single-pass. Both are fixed at creation, so this
   * runs when a pass descriptor is built, just before the depth/stencil view is first made.
   * @param renderTarget - the target whose depth/stencil texture to set up
   * @param gpuRenderTarget - its backend target
   */
  _prepareDepthStencil(e, t) {
    var s;
    const n = (s = e.depthStencilAttachment) == null ? void 0 : s.texture;
    !n || !t.msaa || (n.sampleCount = 4, n.transient = t.transient);
  }
  destroyGpuRenderTarget(e) {
    e.contexts.forEach((t) => {
      t.unconfigure();
    }), e.msaaTextures.forEach((t) => {
      t.destroy();
    }), e.msaaBackTextures.forEach((t) => {
      t == null || t.destroy();
    }), e.msaaTextures.length = 0, e.msaaBackTextures.length = 0, e.contexts.length = 0;
  }
  ensureDepthStencilTexture(e) {
    this._prepareDepthStencil(e, this._renderTargetSystem.getGpuRenderTarget(e));
  }
  resizeGpuRenderTarget(e) {
    const t = this._renderTargetSystem.getGpuRenderTarget(e);
    t.width = e.width, t.height = e.height, t.msaa && e.colorAttachments.forEach((n, s) => {
      var r, a;
      const o = n.texture;
      (r = t.msaaTextures[s]) == null || r.resize(o.width, o.height, o._resolution), (a = t.msaaBackTextures[s]) == null || a.resize(
        o.width,
        o.height,
        o._resolution
      );
    });
  }
}
class pC extends $y {
  constructor(e) {
    super(e), this.adaptor = new Oee(), this.adaptor.init(e, this);
  }
}
pC.extension = {
  type: [Ie.WebGPUSystem],
  name: "renderTarget"
};
class fC {
  constructor() {
    this._gpuProgramData = /* @__PURE__ */ Object.create(null);
  }
  contextChange(e) {
    this._gpu = e, this._gpuProgramData = /* @__PURE__ */ Object.create(null);
  }
  getProgramData(e) {
    return this._gpuProgramData[e._layoutKey] || this._createGPUProgramData(e);
  }
  _createGPUProgramData(e) {
    const t = this._gpu.device, n = e.gpuLayout.map((o) => t.createBindGroupLayout({ entries: o })), s = { bindGroupLayouts: n };
    return this._gpuProgramData[e._layoutKey] = {
      bindGroups: n,
      pipeline: t.createPipelineLayout(s)
    }, this._gpuProgramData[e._layoutKey];
  }
  destroy() {
    this._gpu = null, this._gpuProgramData = null;
  }
}
fC.extension = {
  type: [
    Ie.WebGPUSystem
  ],
  name: "shader"
};
const mi = {};
mi.normal = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
mi.add = {
  alpha: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "add"
  }
};
mi.multiply = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "dst",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
mi.screen = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
mi.overlay = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
mi.none = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "zero",
    dstFactor: "zero",
    operation: "add"
  }
};
mi["normal-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
mi["add-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one",
    operation: "add"
  }
};
mi["screen-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
mi.erase = {
  alpha: {
    srcFactor: "zero",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "zero",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
mi.min = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "min"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "min"
  }
};
mi.max = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "max"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "max"
  }
};
class mC {
  constructor() {
    this.defaultState = new co(), this.defaultState.blend = !0;
  }
  contextChange(e) {
    this.gpu = e;
  }
  /**
   * Gets the blend mode data for the current state
   * @param state - The state to get the blend mode from
   * @param count - The number of color targets to create
   * @param format - The texture format of the color attachments (assumed uniform across attachments)
   */
  getColorTargets(e, t, n) {
    const s = e.blend ? mi[e.blendMode] || mi.normal : void 0, o = [];
    for (let r = 0; r < t; r++)
      o[r] = {
        format: n,
        writeMask: 0,
        blend: s
      };
    return o;
  }
  destroy() {
    this.gpu = null;
  }
}
mC.extension = {
  type: [
    Ie.WebGPUSystem
  ],
  name: "state"
};
const Z2 = [new Tt(), new Tt(), new Tt()], Lee = {
  type: "image",
  upload(i, e, t, n = 0) {
    const s = i.resource, o = i.pixelWidth | 0, r = i.pixelHeight | 0, a = i.depthOrArrayLayers, l = s.byteLength / (o * r * a);
    if (a > 1) {
      t.device.queue.writeTexture(
        { texture: e, origin: { x: 0, y: 0, z: n } },
        s,
        { offset: 0, rowsPerImage: r, bytesPerRow: o * l },
        { width: o, height: r, depthOrArrayLayers: a }
      );
      return;
    }
    const d = KT(i._updateStart, i._updateEnd, o, r, Z2);
    for (let c = 0; c < d; c++) {
      const h = Z2[c];
      t.device.queue.writeTexture(
        { texture: e, origin: { x: h.x, y: h.y, z: n } },
        s,
        {
          offset: (h.y * o + h.x) * l,
          rowsPerImage: h.height,
          bytesPerRow: o * l
        },
        {
          width: h.width,
          height: h.height,
          depthOrArrayLayers: 1
        }
      );
    }
  }
}, gC = {
  "bc1-rgba-unorm": { blockBytes: 8, blockWidth: 4, blockHeight: 4 },
  "bc2-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "bc3-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "bc7-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "etc1-rgb-unorm": { blockBytes: 8, blockWidth: 4, blockHeight: 4 },
  "etc2-rgba8unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "astc-4x4-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 }
}, Bee = { blockBytes: 4, blockWidth: 1, blockHeight: 1 }, Fee = {
  type: "compressed",
  upload(i, e, t, n = 0) {
    let s = i.pixelWidth, o = i.pixelHeight;
    const r = gC[i.format] || Bee;
    for (let a = 0; a < i.resource.length; a++) {
      const l = i.resource[a], d = Math.ceil(s / r.blockWidth) * r.blockBytes;
      t.device.queue.writeTexture(
        {
          texture: e,
          mipLevel: a,
          origin: { x: 0, y: 0, z: n }
        },
        l,
        {
          offset: 0,
          bytesPerRow: d
        },
        {
          width: Math.ceil(s / r.blockWidth) * r.blockWidth,
          height: Math.ceil(o / r.blockHeight) * r.blockHeight,
          depthOrArrayLayers: 1
        }
      ), s = Math.max(s >> 1, 1), o = Math.max(o >> 1, 1);
    }
  }
}, Q2 = ["right", "left", "top", "bottom", "front", "back"];
function Nee(i) {
  return {
    type: "cube",
    upload(e, t, n) {
      const s = e.faces;
      for (let o = 0; o < Q2.length; o++) {
        const r = Q2[o], a = s[r];
        (i[a.uploadMethodId] || i.image).upload(a, t, n, o);
      }
    }
  };
}
const bC = {
  type: "image",
  upload(i, e, t, n = 0) {
    const s = i.resource;
    if (!s) return;
    if (globalThis.HTMLImageElement && s instanceof HTMLImageElement) {
      const l = zt.get().createCanvas(s.width, s.height);
      l.getContext("2d").drawImage(s, 0, 0, s.width, s.height), i.resource = l, dt("ImageSource: Image element passed, converting to canvas and replacing resource.");
    }
    const o = Math.min(e.width, i.resourceWidth || i.pixelWidth), r = Math.min(e.height, i.resourceHeight || i.pixelHeight), a = i.alphaMode === "premultiply-alpha-on-upload";
    t.device.queue.copyExternalImageToTexture(
      { source: s },
      { texture: e, origin: { x: 0, y: 0, z: n }, premultipliedAlpha: a },
      {
        width: o,
        height: r
      }
    );
  }
}, Uee = {
  type: "video",
  upload(i, e, t, n) {
    bC.upload(i, e, t, n);
  }
}, e_ = ["rgba8unorm", "rgba16float"], Ra = 4;
function vC(i, e) {
  if (!e)
    throw new Error("[Gpu3dMipmapGenerator] generating mipmaps for a 3D texture needs storage: true.");
  if (!e_.includes(i))
    throw new Error(`[Gpu3dMipmapGenerator] format '${i}' can't be downsampled. Use ${e_.join(", ")}.`);
}
class Gee {
  constructor(e) {
    this._pipelines = {}, this._device = e, this._sampler = e.createSampler({
      magFilter: "linear",
      minFilter: "linear"
    });
  }
  _getMipmapPipeline(e) {
    var n;
    var t;
    return (n = (t = this._pipelines)[e]) != null || (t[e] = this._device.createComputePipeline({
      layout: "auto",
      compute: {
        module: this._device.createShaderModule({
          code: (
            /* wgsl */
            `
                        @group(0) @binding(0) var srcSampler : sampler;
                        @group(0) @binding(1) var src : texture_3d<f32>;
                        @group(0) @binding(2) var dst : texture_storage_3d<${e}, write>;

                        @compute @workgroup_size(${Ra}, ${Ra}, ${Ra})
                        fn main(@builtin(global_invocation_id) gid : vec3<u32>) {
                            let dstSize = textureDimensions(dst);

                            if (gid.x >= dstSize.x || gid.y >= dstSize.y || gid.z >= dstSize.z) {
                                return;
                            }

                            // centre of the 2x2x2 footprint in the previous mip. When a dimension is
                            // odd its last texel, row or slice is never sampled, as in the 2D generator
                            let uv = (vec3<f32>(gid) * 2.0 + 1.0) / vec3<f32>(textureDimensions(src));

                            textureStore(dst, gid, textureSampleLevel(src, srcSampler, uv, 0.0));
                        }
                    `
          )
        }),
        entryPoint: "main"
      }
    })), this._pipelines[e];
  }
  /**
   * Fills mip levels 1..n of a 3D texture from level 0.
   * @param texture - a 3D texture with `STORAGE_BINDING` and more than one mip level
   */
  generateMipmap(e) {
    if (e.dimension !== "3d")
      throw new Error("[Gpu3dMipmapGenerator] generateMipmap expects a 3D texture.");
    if (e.mipLevelCount < 2) return;
    vC(e.format, (e.usage & GPUTextureUsage.STORAGE_BINDING) !== 0);
    const t = this._getMipmapPipeline(e.format), n = t.getBindGroupLayout(0), s = this._device.createCommandEncoder({ label: "Gpu3dMipmapGenerator" }), o = s.beginComputePass();
    o.setPipeline(t);
    let r = e.width, a = e.height, l = e.depthOrArrayLayers, d = e.createView({ dimension: "3d", baseMipLevel: 0, mipLevelCount: 1 });
    for (let c = 1; c < e.mipLevelCount; c++) {
      r = Math.max(1, r >> 1), a = Math.max(1, a >> 1), l = Math.max(1, l >> 1);
      const h = e.createView({ dimension: "3d", baseMipLevel: c, mipLevelCount: 1 });
      o.setBindGroup(0, this._device.createBindGroup({
        layout: n,
        entries: [
          { binding: 0, resource: this._sampler },
          { binding: 1, resource: d },
          { binding: 2, resource: h }
        ]
      })), o.dispatchWorkgroups(
        Math.ceil(r / Ra),
        Math.ceil(a / Ra),
        Math.ceil(l / Ra)
      ), d = h;
    }
    o.end(), this._device.queue.submit([s.finish()]);
  }
}
class jee {
  constructor(e) {
    this._pipelines = {}, this._device = e, this._sampler = e.createSampler({ minFilter: "linear" });
  }
  _getMipmapPipeline(e) {
    let t = this._pipelines[e];
    return t || (this._mipmapShaderModule || (this._mipmapShaderModule = this._device.createShaderModule({
      code: (
        /* wgsl */
        `
                        var<private> pos : array<vec2<f32>, 3> = array<vec2<f32>, 3>(
                        vec2<f32>(-1.0, -1.0), vec2<f32>(-1.0, 3.0), vec2<f32>(3.0, -1.0));

                        struct VertexOutput {
                        @builtin(position) position : vec4<f32>,
                        @location(0) texCoord : vec2<f32>,
                        };

                        @vertex
                        fn vertexMain(@builtin(vertex_index) vertexIndex : u32) -> VertexOutput {
                        var output : VertexOutput;
                        output.texCoord = pos[vertexIndex] * vec2<f32>(0.5, -0.5) + vec2<f32>(0.5);
                        output.position = vec4<f32>(pos[vertexIndex], 0.0, 1.0);
                        return output;
                        }

                        @group(0) @binding(0) var imgSampler : sampler;
                        @group(0) @binding(1) var img : texture_2d<f32>;

                        @fragment
                        fn fragmentMain(@location(0) texCoord : vec2<f32>) -> @location(0) vec4<f32> {
                        return textureSample(img, imgSampler, texCoord);
                        }
                    `
      )
    })), t = this._device.createRenderPipeline({
      layout: "auto",
      vertex: {
        module: this._mipmapShaderModule,
        entryPoint: "vertexMain"
      },
      fragment: {
        module: this._mipmapShaderModule,
        entryPoint: "fragmentMain",
        targets: [{ format: e }]
      }
    }), this._pipelines[e] = t), t;
  }
  /**
   * Generates mipmaps for the given GPUTexture from the data in level 0.
   * @param {module:External.GPUTexture} texture - Texture to generate mipmaps for.
   * @returns {module:External.GPUTexture} - The originally passed texture
   */
  generateMipmap(e) {
    if (e.dimension === "3d")
      throw new Error("[GpuMipmapGenerator] a 3D texture uses Gpu3dMipmapGenerator.");
    if (e.dimension === "1d")
      throw new Error("Generating mipmaps for 1d textures is currently unsupported!");
    const t = this._getMipmapPipeline(e.format);
    let n = e;
    const s = e.depthOrArrayLayers || 1, o = e.usage & GPUTextureUsage.RENDER_ATTACHMENT;
    if (!o) {
      const l = {
        size: {
          width: Math.ceil(e.width / 2),
          height: Math.ceil(e.height / 2),
          depthOrArrayLayers: s
        },
        format: e.format,
        usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.RENDER_ATTACHMENT,
        mipLevelCount: e.mipLevelCount - 1
      };
      n = this._device.createTexture(l);
    }
    const r = this._device.createCommandEncoder({}), a = t.getBindGroupLayout(0);
    for (let l = 0; l < s; ++l) {
      let d = e.createView({
        baseMipLevel: 0,
        mipLevelCount: 1,
        dimension: "2d",
        baseArrayLayer: l,
        arrayLayerCount: 1
      }), c = o ? 1 : 0;
      for (let h = 1; h < e.mipLevelCount; ++h) {
        const f = n.createView({
          baseMipLevel: c++,
          mipLevelCount: 1,
          dimension: "2d",
          baseArrayLayer: l,
          arrayLayerCount: 1
        }), p = r.beginRenderPass({
          colorAttachments: [{
            view: f,
            storeOp: "store",
            loadOp: "clear",
            clearValue: { r: 0, g: 0, b: 0, a: 0 }
          }]
        }), y = this._device.createBindGroup({
          layout: a,
          entries: [{
            binding: 0,
            resource: this._sampler
          }, {
            binding: 1,
            resource: d
          }]
        });
        p.setPipeline(t), p.setBindGroup(0, y), p.draw(3, 1, 0, 0), p.end(), d = f;
      }
    }
    if (!o) {
      const l = {
        width: Math.ceil(e.width / 2),
        height: Math.ceil(e.height / 2),
        depthOrArrayLayers: s
      };
      for (let d = 1; d < e.mipLevelCount; ++d)
        r.copyTextureToTexture({
          texture: n,
          mipLevel: d - 1
        }, {
          texture: e,
          mipLevel: d
        }, l), l.width = Math.ceil(l.width / 2), l.height = Math.ceil(l.height / 2);
    }
    return this._device.queue.submit([r.finish()]), o || n.destroy(), e;
  }
}
class Hee {
  constructor(e) {
    this.textureView = null, this.textureViews = /* @__PURE__ */ Object.create(null), this.gpuTexture = e;
  }
  /** Destroys this GPU data instance. */
  destroy() {
    this.gpuTexture.destroy(), this.textureView = null, this.textureViews = null, this.gpuTexture = null;
  }
}
const Vee = /^(rgba8|bgra8|bc[1237]-rgba-|etc2-rgb8|etc2-rgb8a1|etc2-rgba8|astc-\d+x\d+-)unorm$/;
function Wee(i) {
  return Vee.test(i) ? [`${i}-srgb`] : void 0;
}
function t_(i) {
  return `${i.format || ""}.${i.dimension || ""}.${i.aspect || ""}.${i.baseMipLevel || 0}.${i.mipLevelCount || ""}.${i.baseArrayLayer || 0}.${i.arrayLayerCount || ""}`;
}
const Ny = class yC {
  constructor(e) {
    this._gpuSamplers = /* @__PURE__ */ Object.create(null), this._bindGroupHash = /* @__PURE__ */ Object.create(null), this._renderer = e, e.gc.addCollection(this, "_bindGroupHash", "hash"), this._managedTextures = new Cs({
      renderer: e,
      type: "resource",
      onUnload: this.onSourceUnload.bind(this),
      name: "gpuTextureSource"
    });
    const t = {
      image: bC,
      buffer: Lee,
      video: Uee,
      compressed: Fee,
      ...yC.uploadExtensions
    };
    this._uploads = {
      ...t,
      cube: Nee(t)
    };
  }
  /**
   * @deprecated since 8.15.0
   */
  get managedTextures() {
    return Object.values(this._managedTextures.items);
  }
  contextChange(e) {
    this._gpu = e, this._managedTextures.removeAll(), this._gpuSamplers = /* @__PURE__ */ Object.create(null), this._mipmapGenerator = null, this._mipmap3dGenerator = null;
  }
  /**
   * Initializes a texture source, if it has already been initialized nothing will happen.
   * @param source - The texture source to initialize.
   * @returns The initialized texture source.
   */
  initSource(e) {
    var t;
    return ((t = e._gpuData[this._renderer.uid]) == null ? void 0 : t.gpuTexture) || this._initSource(e);
  }
  _initSource(e) {
    if (e.autoGenerateMipmaps) {
      e.dimension === "3d" && vC(e.format, e.storage);
      const c = Math.max(e.pixelWidth, e.pixelHeight, e.depth);
      e.mipLevelCount = Math.floor(Math.log2(c)) + 1;
    }
    let t, n;
    e.sampleCount > 1 ? (t = GPUTextureUsage.RENDER_ATTACHMENT, e.transient && this._renderer.device.extensions.transientAttachment && (t |= GPUTextureUsage.TRANSIENT_ATTACHMENT)) : (t = GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST, e.uploadMethodId !== "compressed" && (t |= GPUTextureUsage.RENDER_ATTACHMENT, t |= GPUTextureUsage.COPY_SRC), e.storage && (t |= GPUTextureUsage.STORAGE_BINDING), n = Wee(e.format));
    const s = gC[e.format] || { blockWidth: 1, blockHeight: 1 }, o = Math.ceil(e.pixelWidth / s.blockWidth) * s.blockWidth, r = Math.ceil(e.pixelHeight / s.blockHeight) * s.blockHeight, a = {
      label: e.label,
      // WebGPU cube textures are 2D textures with 6 array layers and a cube view.
      size: { width: o, height: r, depthOrArrayLayers: e.depthOrArrayLayers },
      format: e.format,
      viewFormats: n,
      sampleCount: e.sampleCount,
      mipLevelCount: e.mipLevelCount,
      dimension: e.dimension,
      usage: t
    }, l = this._gpu.device.createTexture(a);
    return e._gpuData[this._renderer.uid] = new Hee(l), this._managedTextures.add(e) && (e.on("update", this.onSourceUpdate, this), e.on("resize", this.onSourceResize, this), e.on("updateMipmaps", this.onUpdateMipmaps, this)), this.onSourceUpdate(e), l;
  }
  onSourceUpdate(e) {
    const t = this.getGpuSource(e);
    t && (this._uploads[e.uploadMethodId] && this._uploads[e.uploadMethodId].upload(e, t, this._gpu), e.autoGenerateMipmaps && e.mipLevelCount > 1 && this.onUpdateMipmaps(e));
  }
  onUpdateMipmaps(e) {
    var n, s;
    const t = this.getGpuSource(e);
    if (e.dimension === "3d") {
      (n = this._mipmap3dGenerator) != null || (this._mipmap3dGenerator = new Gee(this._gpu.device)), this._mipmap3dGenerator.generateMipmap(t);
      return;
    }
    (s = this._mipmapGenerator) != null || (this._mipmapGenerator = new jee(this._gpu.device)), this._mipmapGenerator.generateMipmap(t);
  }
  onSourceUnload(e) {
    e.off("update", this.onSourceUpdate, this), e.off("resize", this.onSourceResize, this), e.off("updateMipmaps", this.onUpdateMipmaps, this);
  }
  onSourceResize(e) {
    e._gcLastUsed = this._renderer.gc.now;
    const t = e._gpuData[this._renderer.uid], n = t == null ? void 0 : t.gpuTexture;
    n ? (n.width !== e.pixelWidth || n.height !== e.pixelHeight) && (t.destroy(), this._bindGroupHash[e.uid] = null, e._gpuData[this._renderer.uid] = null, this.initSource(e)) : this.initSource(e);
  }
  _initSampler(e) {
    return this._gpuSamplers[e._resourceId] = this._gpu.device.createSampler(e), this._gpuSamplers[e._resourceId];
  }
  getGpuSampler(e) {
    return this._gpuSamplers[e._resourceId] || this._initSampler(e);
  }
  getGpuSource(e) {
    var t;
    return e._gcLastUsed = this._renderer.gc.now, ((t = e._gpuData[this._renderer.uid]) == null ? void 0 : t.gpuTexture) || this.initSource(e);
  }
  /**
   * this returns s bind group for a specific texture, the bind group contains
   * - the texture source
   * - the texture style
   * - the texture matrix
   * This is cached so the bind group should only be created once per texture
   * @param texture - the texture you want the bindgroup for
   * @returns the bind group for the texture
   */
  getTextureBindGroup(e) {
    return this._bindGroupHash[e.uid] || this._createTextureBindGroup(e);
  }
  _createTextureBindGroup(e) {
    const t = e.source;
    return this._bindGroupHash[e.uid] = new qo({
      0: t,
      1: t.style,
      2: new Ts({
        uTextureMatrix: { type: "mat3x3<f32>", value: e.textureMatrix.mapCoord }
      })
    }), this._bindGroupHash[e.uid];
  }
  getTextureView(e, t) {
    var n;
    const s = e.source;
    s._gcLastUsed = this._renderer.gc.now;
    let o = s._gpuData[this._renderer.uid];
    o || (this.initSource(s), o = s._gpuData[this._renderer.uid]);
    const r = t ? t_(t) : 0;
    return (n = o.textureViews)[r] || (n[r] = o.gpuTexture.createView({
      dimension: s.viewDimension,
      ...t
    })), o.textureViews[r];
  }
  getTextureRenderTargetView(e, t = 0, n = 0, s) {
    var o;
    const r = e.source;
    r._gcLastUsed = this._renderer.gc.now;
    let a = r._gpuData[this._renderer.uid];
    a || (this.initSource(r), a = r._gpuData[this._renderer.uid]);
    const l = r.dimension === "3d";
    l && (n = 0);
    let d = n * (r.mipLevelCount || 1) + t + 1;
    return s && (d = `${d}.${t_(s)}`), (o = a.textureViews)[d] || (o[d] = a.gpuTexture.createView({
      dimension: l ? "3d" : "2d",
      baseMipLevel: t,
      mipLevelCount: 1,
      baseArrayLayer: n,
      arrayLayerCount: 1,
      ...s
    })), a.textureViews[d];
  }
  generateCanvas(e) {
    const t = this._renderer, n = t.gpu.device.createCommandEncoder(), s = zt.get().createCanvas();
    s.width = e.source.pixelWidth, s.height = e.source.pixelHeight;
    const o = s.getContext("webgpu");
    return o.configure({
      device: t.gpu.device,
      usage: GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC,
      format: zt.get().getNavigator().gpu.getPreferredCanvasFormat(),
      alphaMode: "premultiplied"
    }), n.copyTextureToTexture({
      texture: t.texture.getGpuSource(e.source),
      origin: {
        x: 0,
        y: 0
      }
    }, {
      texture: o.getCurrentTexture()
    }, {
      width: s.width,
      height: s.height
    }), t.gpu.device.queue.submit([n.finish()]), s;
  }
  getPixels(e) {
    const t = this.generateCanvas(e), n = Fl.getOptimalCanvasAndContext(t.width, t.height), s = n.context;
    s.drawImage(t, 0, 0);
    const { width: o, height: r } = t, a = s.getImageData(0, 0, o, r), l = new Uint8ClampedArray(a.data.buffer);
    return Fl.returnCanvasAndContext(n), { pixels: l, width: o, height: r };
  }
  destroy() {
    this._managedTextures.destroy();
    for (const e of Object.keys(this._bindGroupHash)) {
      const t = Number(e), n = this._bindGroupHash[t];
      n == null || n.destroy();
    }
    this._renderer = null, this._gpu = null, this._mipmapGenerator = null, this._mipmap3dGenerator = null, this._gpuSamplers = null, this._bindGroupHash = null;
  }
};
Ny.extension = {
  type: [
    Ie.WebGPUSystem
  ],
  name: "texture"
};
Ny.uploadExtensions = /* @__PURE__ */ Object.create(null);
let xC = Ny;
ht.handleByMap(Ie.TextureUploaderWebGPU, xC.uploadExtensions);
class wC {
  constructor() {
    this._maxTextures = 0;
  }
  contextChange(e) {
    const t = new Ts({
      uTransformMatrix: { value: new st(), type: "mat3x3<f32>" },
      uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
      uRound: { value: 0, type: "f32" }
    });
    this._maxTextures = e.limits.maxBatchableTextures;
    const n = sy({
      name: "graphics",
      bits: [
        yM,
        wM(this._maxTextures),
        TZ,
        ry
      ]
    });
    this.shader = new lo({
      gpuProgram: n,
      resources: {
        // added on the fly!
        localUniforms: t
      }
    });
  }
  execute(e, t) {
    const n = t.context, s = n.customShader || this.shader, o = e.renderer, r = o.graphicsContext, {
      batcher: a,
      instructions: l
    } = r.getContextRenderData(n), d = o.encoder;
    d.setGeometry(a.geometry, s.gpuProgram);
    const c = o.globalUniforms.bindGroup;
    d.setBindGroup(0, c, s.gpuProgram);
    const h = o.renderPipes.uniformBatch.getUniformBindGroup(s.resources.localUniforms, !0);
    d.setBindGroup(2, h, s.gpuProgram);
    const f = l.instructions;
    let p = null;
    for (let y = 0; y < l.instructionSize; y++) {
      const v = f[y];
      if (v.topology !== p && (p = v.topology, d.setPipelineFromGeometryProgramAndState(
        a.geometry,
        s.gpuProgram,
        e.state,
        v.topology,
        s._overrides
      )), s.groups[1] = v.bindGroup, !v.gpuBindGroup) {
        const x = v.textures;
        v.bindGroup = iy(
          x.textures,
          x.count,
          this._maxTextures
        ), v.gpuBindGroup = o.bindGroup.getBindGroup(
          v.bindGroup,
          s.gpuProgram,
          1
        );
      }
      d.setBindGroup(1, v.bindGroup, s.gpuProgram), d.renderPassEncoder.drawIndexed(v.size, 1, v.start);
    }
  }
  destroy() {
    this.shader.destroy(), this.shader = null;
  }
}
wC.extension = {
  type: [
    Ie.WebGPUPipesAdaptor
  ],
  name: "graphics"
};
class kC {
  init() {
    const e = sy({
      name: "mesh",
      bits: [
        wp,
        AZ,
        ry
      ]
    });
    this._shader = new lo({
      gpuProgram: e,
      resources: {
        uTexture: et.EMPTY._source,
        uSampler: et.EMPTY._source.style,
        textureUniforms: {
          uTextureMatrix: { type: "mat3x3<f32>", value: new st() }
        }
      }
    });
  }
  execute(e, t) {
    const n = e.renderer;
    let s = t._shader;
    if (!s)
      s = this._shader, s.groups[2] = n.texture.getTextureBindGroup(t.texture);
    else if (!s.gpuProgram) {
      dt("Mesh shader has no gpuProgram", t.shader);
      return;
    }
    const o = s.gpuProgram;
    if (o.autoAssignGlobalUniforms && (s.groups[0] = n.globalUniforms.bindGroup), o.autoAssignLocalUniforms) {
      const r = e.localUniforms;
      s.groups[1] = n.renderPipes.uniformBatch.getUniformBindGroup(r, !0);
    }
    n.encoder.draw({
      geometry: t._geometry,
      shader: s,
      state: t.state
    });
  }
  destroy() {
    this._shader.destroy(), this._shader = null;
  }
}
kC.extension = {
  type: [
    Ie.WebGPUPipesAdaptor
  ],
  name: "mesh"
};
const qee = [
  ...zy,
  cC,
  aC,
  Fy,
  lC,
  oC,
  xC,
  pC,
  fC,
  mC,
  hC,
  rC,
  dC,
  sC
], Kee = [...kT, uC], Yee = [ZM, kC, wC], _C = [], SC = [], MC = [], TC = [];
ht.handleByNamedList(Ie.WebGPUSystem, _C);
ht.handleByNamedList(Ie.WebGPUPipes, SC);
ht.handleByNamedList(Ie.WebGPUPipesAdaptor, MC);
ht.handleByNamedList(Ie.WebGPULoader, TC);
ht.add(...qee, ...Kee, ...Yee);
class Xee extends wu {
  constructor() {
    const e = {
      name: "webgpu",
      type: rs.WEBGPU,
      systems: _C,
      renderPipes: SC,
      renderPipeAdaptors: MC,
      loaders: TC
    };
    super(e);
  }
}
const Jee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WebGPURenderer: Xee
}, Symbol.toStringTag, { value: "Module" })), CC = class IC extends SZ {
  constructor(...e) {
    var n;
    super({});
    let t = (n = e[0]) != null ? n : {};
    typeof t == "number" && (rt(dn, "PlaneGeometry constructor changed please use { width, height, verticesX, verticesY } instead"), t = {
      width: t,
      height: e[1],
      verticesX: e[2],
      verticesY: e[3]
    }), this.build(t);
  }
  /**
   * Refreshes plane coordinates
   * @param options - Options to be applied to plane geometry
   */
  build(e) {
    var h, f, p, y;
    e = { ...IC.defaultOptions, ...e }, this.verticesX = (h = this.verticesX) != null ? h : e.verticesX, this.verticesY = (f = this.verticesY) != null ? f : e.verticesY, this.width = (p = this.width) != null ? p : e.width, this.height = (y = this.height) != null ? y : e.height;
    const t = this.verticesX * this.verticesY, n = [], s = [], o = [], r = this.verticesX - 1, a = this.verticesY - 1, l = this.width / r, d = this.height / a;
    for (let v = 0; v < t; v++) {
      const x = v % this.verticesX, w = v / this.verticesX | 0;
      n.push(x * l, w * d), s.push(x / r, w / a);
    }
    const c = r * a;
    for (let v = 0; v < c; v++) {
      const x = v % r, w = v / r | 0, S = w * this.verticesX + x, M = w * this.verticesX + x + 1, _ = (w + 1) * this.verticesX + x, T = (w + 1) * this.verticesX + x + 1;
      o.push(
        S,
        M,
        _,
        M,
        T,
        _
      );
    }
    this.buffers[0].data = new Float32Array(n), this.buffers[1].data = new Float32Array(s), this.indexBuffer.data = new Uint32Array(o), this.buffers[0].update(), this.buffers[1].update(), this.indexBuffer.update();
  }
};
CC.defaultOptions = {
  width: 100,
  height: 100,
  verticesX: 10,
  verticesY: 10
};
let Zee = CC;
const Kg = [[0, 0], [0, 0], [0, 0]], Yg = [[0, 0], [0, 0], [0, 0]], Xg = [[0, 0], [0, 0], [0, 0]], Jg = [[0, 0], [0, 0], [0, 0]];
function vh(i, e, t, n, s, o, r) {
  i[0][0] = e, i[0][1] = t, i[1][0] = n, i[1][1] = s, i[2][0] = o, i[2][1] = r;
}
class AC {
  constructor(e) {
    this._renderer = e;
  }
  validateRenderable(e) {
    return !1;
  }
  addRenderable(e, t) {
    this._renderer.renderPipes.batch.break(t), t.add(e);
  }
  updateRenderable(e) {
  }
  execute(e) {
    var ge, ne, oe, ye, Oe, Ve;
    const t = this._renderer, n = t.canvasContext, s = n.activeContext;
    s.save();
    const o = e.groupTransform, r = t._roundPixels | e._roundPixels;
    n.setContextTransform(o, r === 1), n.setBlendMode(e.groupBlendMode);
    const a = (ne = (ge = t.globalUniforms.globalUniformData) == null ? void 0 : ge.worldColor) != null ? ne : 4294967295, l = e.groupColorAlpha, d = (a >>> 24 & 255) / 255, c = (l >>> 24 & 255) / 255, h = (ye = (oe = t.filter) == null ? void 0 : oe.alphaMultiplier) != null ? ye : 1, f = d * c * h;
    if (f <= 0) {
      s.restore();
      return;
    }
    s.globalAlpha = f;
    const p = a & 16777215, y = l & 16777215, v = sa(ia(y, p)), x = e.texture, w = _t.getCanvasSource(x);
    if (!w) {
      s.restore();
      return;
    }
    const S = n.smoothProperty, M = x.source.style.scaleMode !== "nearest";
    s[S] !== M && (s[S] = M);
    const _ = v !== 16777215 || x.rotate !== 0, T = _ ? _t.getTintedCanvas({ texture: x }, v) : w, {
      leftWidth: k,
      topHeight: P,
      rightWidth: A,
      bottomHeight: R,
      width: D,
      height: O
    } = e, F = k + A, te = P + R, ee = Math.min(
      F > D ? D / F : 1,
      te > O ? O / te : 1,
      1
    ), me = k * ee, L = A * ee, N = P * ee, X = R * ee, B = Math.max(0, D - me - L), se = Math.max(0, O - N - X), V = e.anchor, Z = (Ve = (Oe = x.source._resolution) != null ? Oe : x.source.resolution) != null ? Ve : 1;
    let Y = x.frame.x * Z, H = x.frame.y * Z;
    const re = -V.x * D, le = -V.y * O, he = k * Z, Re = P * Z, Ne = A * Z, Me = R * Z;
    let ue = x.frame.width * Z, U = x.frame.height * Z;
    _ && (Y = 0, H = 0, ue = T.width, U = T.height);
    const q = ue - he - Ne, ie = U - Re - Me, de = q > 0 ? Y + he : Math.max(Y, Math.min(Y + he, Y + ue - 1)), pe = q > 0 ? q : 1, Te = ie > 0 ? H + Re : Math.max(H, Math.min(H + Re, H + U - 1)), Be = ie > 0 ? ie : 1;
    vh(Kg, Y, he, de, pe, Y + ue - Ne, Ne), vh(Yg, H, Re, Te, Be, H + U - Me, Me), vh(
      Xg,
      re,
      me,
      re + me,
      B,
      re + D - L,
      L
    ), vh(
      Jg,
      le,
      N,
      le + N,
      se,
      le + O - X,
      X
    );
    for (let Ue = 0; Ue < 3; Ue++) {
      const tt = Xg[Ue][1];
      if (tt <= 0) continue;
      const Ye = Kg[Ue][0], at = Kg[Ue][1], wt = Xg[Ue][0];
      for (let $e = 0; $e < 3; $e++) {
        const Fe = Jg[$e][1];
        Fe <= 0 || s.drawImage(
          T,
          Ye,
          Yg[$e][0],
          at,
          Yg[$e][1],
          wt,
          Jg[$e][0],
          tt,
          Fe
        );
      }
    }
    s.restore();
  }
  destroy() {
    this._renderer = null;
  }
}
AC.extension = {
  type: [
    Ie.CanvasPipes
  ],
  name: "nineSliceSprite"
};
const PC = class Cp extends Zee {
  constructor(e = {}) {
    var t, n;
    e = { ...Cp.defaultOptions, ...e }, super({
      width: e.width,
      height: e.height,
      verticesX: 4,
      verticesY: 4
    }), this._trimX = 0, this._trimY = 0, this._trimWidth = (t = e.originalWidth) != null ? t : Cp.defaultOptions.originalWidth, this._trimHeight = (n = e.originalHeight) != null ? n : Cp.defaultOptions.originalHeight, this.update(e);
  }
  /**
   * Updates the NineSliceGeometry with the options.
   * @param options - The options of the NineSliceGeometry.
   */
  update(e) {
    var t, n, s, o, r, a, l, d, c, h, f, p, y, v, x, w, S, M;
    this.width = (t = e.width) != null ? t : this.width, this.height = (n = e.height) != null ? n : this.height, this._originalWidth = (s = e.originalWidth) != null ? s : this._originalWidth, this._originalHeight = (o = e.originalHeight) != null ? o : this._originalHeight, this._leftWidth = (r = e.leftWidth) != null ? r : this._leftWidth, this._rightWidth = (a = e.rightWidth) != null ? a : this._rightWidth, this._topHeight = (l = e.topHeight) != null ? l : this._topHeight, this._bottomHeight = (d = e.bottomHeight) != null ? d : this._bottomHeight, this._anchorX = (c = e.anchor) == null ? void 0 : c.x, this._anchorY = (h = e.anchor) == null ? void 0 : h.y, e.trim !== void 0 ? (this._trimX = (p = (f = e.trim) == null ? void 0 : f.x) != null ? p : 0, this._trimY = (v = (y = e.trim) == null ? void 0 : y.y) != null ? v : 0, this._trimWidth = (w = (x = e.trim) == null ? void 0 : x.width) != null ? w : this._originalWidth, this._trimHeight = (M = (S = e.trim) == null ? void 0 : S.height) != null ? M : this._originalHeight) : (this._trimWidth = this._originalWidth, this._trimHeight = this._originalHeight), this.updateUvs(), this.updatePositions();
  }
  /** Updates the positions of the vertices. */
  updatePositions() {
    const e = this.positions, {
      width: t,
      height: n,
      _leftWidth: s,
      _rightWidth: o,
      _topHeight: r,
      _bottomHeight: a,
      _anchorX: l,
      _anchorY: d
    } = this, c = s + o, h = t > c ? 1 : t / c, f = r + a, p = n > f ? 1 : n / f, y = Math.min(h, p), v = l * t, x = d * n;
    e[0] = e[8] = e[16] = e[24] = -v, e[2] = e[10] = e[18] = e[26] = s * y - v, e[4] = e[12] = e[20] = e[28] = t - o * y - v, e[6] = e[14] = e[22] = e[30] = t - v, e[1] = e[3] = e[5] = e[7] = -x, e[9] = e[11] = e[13] = e[15] = r * y - x, e[17] = e[19] = e[21] = e[23] = n - a * y - x, e[25] = e[27] = e[29] = e[31] = n - x, this.getBuffer("aPosition").update();
  }
  /** Updates the UVs of the vertices. */
  updateUvs() {
    const e = this.uvs, t = this._originalWidth, n = this._originalHeight, s = this._trimX / t, o = this._trimY / n, r = (this._trimX + this._trimWidth) / t, a = (this._trimY + this._trimHeight) / n;
    e[0] = e[8] = e[16] = e[24] = s, e[1] = e[3] = e[5] = e[7] = o, e[6] = e[14] = e[22] = e[30] = r, e[25] = e[27] = e[29] = e[31] = a;
    const l = 1 / t, d = 1 / n;
    e[2] = e[10] = e[18] = e[26] = s + l * this._leftWidth, e[9] = e[11] = e[13] = e[15] = o + d * this._topHeight, e[4] = e[12] = e[20] = e[28] = r - l * this._rightWidth, e[17] = e[19] = e[21] = e[23] = a - d * this._bottomHeight, this.getBuffer("aUV").update();
  }
};
PC.defaultOptions = {
  /** The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */
  width: 100,
  /** The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */
  height: 100,
  /** The width of the left column. */
  leftWidth: 10,
  /** The height of the top row. */
  topHeight: 10,
  /** The width of the right column. */
  rightWidth: 10,
  /** The height of the bottom row. */
  bottomHeight: 10,
  /** The original width of the texture */
  originalWidth: 100,
  /** The original height of the texture */
  originalHeight: 100
};
let zr = PC;
class Qee extends MZ {
  constructor() {
    super(), this.geometry = new zr();
  }
  destroy() {
    this.geometry.destroy();
  }
}
class EC {
  constructor(e) {
    this._renderer = e, this._managedSprites = new Cs({ renderer: e, type: "renderable", name: "nineSliceSprite" });
  }
  addRenderable(e, t) {
    const n = this._getGpuSprite(e);
    e.didViewUpdate && this._updateBatchableSprite(e, n), this._renderer.renderPipes.batch.addToBatch(n, t);
  }
  updateRenderable(e) {
    const t = this._getGpuSprite(e);
    e.didViewUpdate && this._updateBatchableSprite(e, t), t._batcher.updateElement(t);
  }
  validateRenderable(e) {
    const t = this._getGpuSprite(e);
    return !t._batcher.checkAndUpdateTexture(
      t,
      e._texture
    );
  }
  _updateBatchableSprite(e, t) {
    t.geometry.update(e), t.setTexture(e._texture);
  }
  _getGpuSprite(e) {
    return e._gpuData[this._renderer.uid] || this._initGPUSprite(e);
  }
  _initGPUSprite(e) {
    const t = e._gpuData[this._renderer.uid] = new Qee(), n = t;
    return n.renderable = e, n.transform = e.groupTransform, n.texture = e._texture, n.roundPixels = this._renderer._roundPixels | e._roundPixels, this._managedSprites.add(e), e.didViewUpdate || this._updateBatchableSprite(e, n), t;
  }
  destroy() {
    this._managedSprites.destroy(), this._renderer = null;
  }
}
EC.extension = {
  type: [
    Ie.WebGLPipes,
    Ie.WebGPUPipes
  ],
  name: "nineSliceSprite"
};
ht.add(AC);
ht.add(EC);
const RC = class zC extends Z1 {
  constructor(e) {
    var f, p, y, v, x, w, S, M, _, T;
    e instanceof et && (e = { texture: e });
    const {
      width: t,
      height: n,
      anchor: s,
      leftWidth: o,
      rightWidth: r,
      topHeight: a,
      bottomHeight: l,
      texture: d,
      roundPixels: c,
      ...h
    } = e;
    super({
      label: "NineSliceSprite",
      ...h
    }), this.renderPipeId = "nineSliceSprite", this.batched = !0, this._leftWidth = (p = o != null ? o : (f = d == null ? void 0 : d.defaultBorders) == null ? void 0 : f.left) != null ? p : zr.defaultOptions.leftWidth, this._topHeight = (v = a != null ? a : (y = d == null ? void 0 : d.defaultBorders) == null ? void 0 : y.top) != null ? v : zr.defaultOptions.topHeight, this._rightWidth = (w = r != null ? r : (x = d == null ? void 0 : d.defaultBorders) == null ? void 0 : x.right) != null ? w : zr.defaultOptions.rightWidth, this._bottomHeight = (M = l != null ? l : (S = d == null ? void 0 : d.defaultBorders) == null ? void 0 : S.bottom) != null ? M : zr.defaultOptions.bottomHeight, this._width = (_ = t != null ? t : d.width) != null ? _ : zr.defaultOptions.width, this._height = (T = n != null ? n : d.height) != null ? T : zr.defaultOptions.height, this.allowChildren = !1, this.texture = d != null ? d : zC.defaultOptions.texture, this.roundPixels = c != null ? c : !1, this._anchor = new Fn(
      {
        _onUpdate: () => {
          this.onViewUpdate();
        }
      }
    ), s ? this.anchor = s : this.texture.defaultAnchor && (this.anchor = this.texture.defaultAnchor);
  }
  /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    typeof e == "number" ? this._anchor.set(e) : this._anchor.copyFrom(e);
  }
  /**
   * The width of the NineSliceSprite, setting this will actually modify the vertices and UV's of this plane.
   * The width affects how the middle sections are scaled.
   * @example
   * ```ts
   * // Create a nine-slice sprite with fixed width
   * const panel = new NineSliceSprite({
   *     texture: Texture.from('panel.png'),
   *     width: 200  // Sets initial width
   * });
   *
   * // Adjust width dynamically
   * panel.width = 300;  // Stretches middle sections
   * ```
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   * @see {@link NineSliceSprite#height} For setting height
   */
  get width() {
    return this._width;
  }
  set width(e) {
    this._width = e, this.onViewUpdate();
  }
  /**
   * The height of the NineSliceSprite, setting this will actually modify the vertices and UV's of this plane.
   * The height affects how the middle sections are scaled.
   * @example
   * ```ts
   * // Create a nine-slice sprite with fixed height
   * const panel = new NineSliceSprite({
   *     texture: Texture.from('panel.png'),
   *     height: 150  // Sets initial height
   * });
   *
   * // Adjust height dynamically
   * panel.height = 200;  // Stretches middle sections
   *
   * // Create responsive UI element
   * const dialog = new NineSliceSprite({
   *     texture: Texture.from('dialog.png'),
   *     topHeight: 30,
   *     bottomHeight: 30,
   *     height: parent.height * 0.5  // 50% of parent height
   * });
   * ```
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   * @see {@link NineSliceSprite#width} For setting width
   */
  get height() {
    return this._height;
  }
  set height(e) {
    this._height = e, this.onViewUpdate();
  }
  /**
   * Sets the size of the NineSliceSprite to the specified width and height.
   * This method directly modifies the vertices and UV coordinates of the sprite.
   *
   * Using this is more efficient than setting width and height separately as it only triggers one update.
   * @example
   * ```ts
   * // Set to specific dimensions
   * panel.setSize(300, 200); // Width: 300, Height: 200
   *
   * // Set uniform size
   * panel.setSize(200); // Makes a square 200x200
   *
   * // Set size using object
   * panel.setSize({
   *     width: 400,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number or a Size object with width/height properties
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link NineSliceSprite#width} For setting width only
   * @see {@link NineSliceSprite#height} For setting height only
   */
  setSize(e, t) {
    var n;
    typeof e == "object" && (t = (n = e.height) != null ? n : e.width, e = e.width), this._width = e, this._height = t != null ? t : e, this.onViewUpdate();
  }
  /**
   * Retrieves the size of the NineSliceSprite as a [Size]{@link Size} object.
   * This method is more efficient than getting width and height separately.
   * @example
   * ```ts
   * // Get basic size
   * const size = panel.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * panel.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the NineSliceSprite
   * @see {@link NineSliceSprite#width} For getting just the width
   * @see {@link NineSliceSprite#height} For getting just the height
   * @see {@link NineSliceSprite#setSize} For setting both width and height efficiently
   */
  getSize(e) {
    return e || (e = {}), e.width = this._width, e.height = this._height, e;
  }
  /**
   * Width of the left vertical bar (A).
   * Controls the size of the left edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., leftWidth: 20 });
   * sprite.leftWidth = 20; // Set left border width
   * ```
   * @default 10
   */
  get leftWidth() {
    return this._leftWidth;
  }
  set leftWidth(e) {
    this._leftWidth = e, this.onViewUpdate();
  }
  /**
   * Height of the top horizontal bar (C).
   * Controls the size of the top edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., topHeight: 20 });
   * sprite.topHeight = 20; // Set top border height
   * ```
   * @default 10
   */
  get topHeight() {
    return this._topHeight;
  }
  set topHeight(e) {
    this._topHeight = e, this.onViewUpdate();
  }
  /**
   * Width of the right vertical bar (B).
   * Controls the size of the right edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., rightWidth: 20 });
   * sprite.rightWidth = 20; // Set right border width
   * ```
   * @default 10
   */
  get rightWidth() {
    return this._rightWidth;
  }
  set rightWidth(e) {
    this._rightWidth = e, this.onViewUpdate();
  }
  /**
   * Height of the bottom horizontal bar (D).
   * Controls the size of the bottom edge that remains unscaled
   * @example
   * ```ts
   * const sprite = new NineSliceSprite({ ..., bottomHeight: 20 });
   * sprite.bottomHeight = 20; // Set bottom border height
   * ```
   * @default 10
   */
  get bottomHeight() {
    return this._bottomHeight;
  }
  set bottomHeight(e) {
    this._bottomHeight = e, this.onViewUpdate();
  }
  /**
   * The texture to use on the NineSliceSprite.
   * ```ts
   * // Create a sprite with a texture
   * const sprite = new NineSliceSprite({
   *     texture: Texture.from('path/to/image.png')
   * });
   * // Update the texture later
   * sprite.texture = Texture.from('path/to/another-image.png');
   * ```
   * @default Texture.EMPTY
   */
  get texture() {
    return this._texture;
  }
  set texture(e) {
    e || (e = et.EMPTY);
    const t = this._texture;
    t !== e && (t && t.dynamic && t.off("update", this.onViewUpdate, this), e.dynamic && e.on("update", this.onViewUpdate, this), this._texture = e, this.onViewUpdate());
  }
  /**
   * The original width of the texture before any nine-slice scaling.
   * This is the width of the source texture used to create the nine-slice sprite.
   * @example
   * ```ts
   * // Get original dimensions
   * console.log(`Original size: ${sprite.originalWidth}x${sprite.originalHeight}`);
   *
   * // Use for relative scaling
   * sprite.width = sprite.originalWidth * 2; // Double the original width
   *
   * // Reset to original size
   * sprite.setSize(sprite.originalWidth, sprite.originalHeight);
   * ```
   * @readonly
   * @see {@link NineSliceSprite#width} For the current displayed width
   * @see {@link Texture#width} For direct texture width access
   * @returns The original width of the texture
   */
  get originalWidth() {
    return this._texture.width;
  }
  /**
   * The original height of the texture before any nine-slice scaling.
   * This is the height of the source texture used to create the nine-slice sprite.
   * @example
   * ```ts
   * // Get original dimensions
   * console.log(`Original size: ${sprite.originalWidth}x${sprite.originalHeight}`);
   *
   * // Use for relative scaling
   * sprite.height = sprite.originalHeight * 2; // Double the original height
   *
   * // Reset to original size
   * sprite.setSize(sprite.originalWidth, sprite.originalHeight);
   * ```
   * @readonly
   * @see {@link NineSliceSprite#height} For the current displayed height
   * @see {@link Texture#height} For direct texture height access
   * @returns The original height of the texture
   */
  get originalHeight() {
    return this._texture.height;
  }
  /**
   * The trim rectangle of the underlying texture, or `null` if the texture is not trimmed.
   * This is forwarded to the {@link NineSliceGeometry} so that UV coordinates are clamped
   * to the visible pixel region, preventing transparent atlas padding from bleeding into
   * the rendered sprite corners.
   * @readonly
   * @internal
   */
  get trim() {
    var e;
    return (e = this._texture.trim) != null ? e : null;
  }
  /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * nineSliceSprite.destroy();
   * nineSliceSprite.destroy(true);
   * nineSliceSprite.destroy({ texture: true, textureSource: true });
   */
  destroy(e) {
    if (super.destroy(e), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const n = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      this._texture.destroy(n);
    }
    this._texture = null;
  }
  /** @private */
  updateBounds() {
    const e = this._bounds, t = this._anchor, n = this._width, s = this._height;
    e.minX = -t._x * n, e.maxX = e.minX + n, e.minY = -t._y * s, e.maxY = e.minY + s;
  }
};
RC.defaultOptions = {
  /** @default Texture.EMPTY */
  texture: et.EMPTY
};
let ete = RC;
ht.add(oK, rK);
function tte() {
  const i = self;
  function e(s) {
    const o = /^synthetic:\/\/(\d+)\/(\d+)x(\d+)/.exec(s), r = o ? Number(o[1]) : 1, a = o ? Number(o[2]) : 640, l = o ? Number(o[3]) : 480, d = new OffscreenCanvas(a, l), c = d.getContext("2d");
    let h = r * 9301 + 49297;
    const f = () => (h = (h * 9301 + 49297) % 233280, h / 233280), p = Math.floor(f() * 360), y = c.createLinearGradient(0, 0, a, l);
    y.addColorStop(0, "hsl(" + p + ",45%," + (18 + f() * 20) + "%)"), y.addColorStop(1, "hsl(" + (p + 40 + f() * 80) % 360 + ",55%," + (35 + f() * 25) + "%)"), c.fillStyle = y, c.fillRect(0, 0, a, l);
    for (let v = 0; v < 7; v++) {
      c.fillStyle = "hsla(" + (p + f() * 120) % 360 + ",60%," + (40 + f() * 40) + "%," + (0.25 + f() * 0.4) + ")";
      const x = a * (0.1 + f() * 0.4), w = l * (0.1 + f() * 0.6);
      c.fillRect(f() * (a - x), l - w - f() * l * 0.3, x, w);
    }
    return c.fillStyle = "rgba(255,255,255,0.85)", c.font = "600 " + Math.round(l * 0.09) + "px sans-serif", c.fillText("#" + r, a * 0.06, l * 0.9), { canvas: d, w: a, h: l };
  }
  async function t(s) {
    if (s.startsWith("synthetic://")) {
      const d = e(s);
      return { src: d.canvas, sw: d.w, sh: d.h };
    }
    const o = s.startsWith("blob:") || s.startsWith("data:") ? s : s + (s.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1", r = await fetch(o, { mode: "cors", credentials: "omit" });
    if (!r.ok) throw new Error("HTTP " + r.status);
    const a = await r.blob(), l = await createImageBitmap(a);
    return { src: l, sw: l.width, sh: l.height, close: () => l.close() };
  }
  function n(s, o, r) {
    const l = new OffscreenCanvas(1, 1).getContext("2d", { willReadFrequently: !0 });
    l.drawImage(s, 0, 0, o, r, 0, 0, 1, 1);
    const d = l.getImageData(0, 0, 1, 1).data, c = (h) => h.toString(16).padStart(2, "0");
    return "#" + c(d[0]) + c(d[1]) + c(d[2]);
  }
  i.onmessage = async (s) => {
    const o = s.data;
    let r = null;
    try {
      r = await t(o.url);
      const { src: a, sw: l, sh: d } = r, c = Math.max(1, Math.round(o.tw)), h = Math.max(1, Math.round(o.th)), f = c / h, p = l / d;
      let y = 0, v = 0, x = l, w = d;
      p > f ? (x = d * f, y = (l - x) / 2) : (w = l / f, v = (d - w) / 2);
      const S = new OffscreenCanvas(c, h), M = S.getContext("2d");
      M.imageSmoothingEnabled = !0, M.imageSmoothingQuality = "high";
      const _ = Math.min(o.radius, c / 2, h / 2);
      M.save(), M.beginPath(), M.roundRect(0, 0, c, h, _), M.clip();
      let T = a, k = x, P = w, A = y, R = v;
      for (; k > c * 2.5 && P > h * 2.5; ) {
        const F = Math.max(c, Math.round(k / 2)), te = Math.max(h, Math.round(P / 2)), ee = new OffscreenCanvas(F, te), me = ee.getContext("2d");
        me.imageSmoothingEnabled = !0, me.imageSmoothingQuality = "high", me.drawImage(T, A, R, k, P, 0, 0, F, te), T = ee, A = 0, R = 0, k = F, P = te;
      }
      if (M.drawImage(T, A, R, k, P, 0, 0, c, h), M.restore(), o.border > 0) {
        const F = o.border;
        M.lineWidth = F, M.strokeStyle = "rgba(255,255,255,0.09)", M.beginPath(), M.roundRect(F / 2, F / 2, c - F, h - F, Math.max(0, _ - F / 2)), M.stroke(), M.save(), M.beginPath(), M.roundRect(0, 0, c, h, _), M.clip(), M.fillStyle = "rgba(255,255,255,0.07)", M.fillRect(0, F, c, F), M.restore();
      }
      const D = n(a, l, d), O = S.transferToImageBitmap();
      r.close && r.close(), i.postMessage({ id: o.id, bitmap: O, color: D, sw: l, sh: d }, [O]);
    } catch (a) {
      r && r.close && r.close(), i.postMessage({ id: o.id, error: String(a && a.message || a) });
    }
  };
}
let Zg = null;
function nte() {
  return typeof Worker != "undefined" && typeof OffscreenCanvas != "undefined" && typeof createImageBitmap != "undefined";
}
function ite() {
  if (!Zg) {
    const i = "(" + tte.toString() + ")();";
    Zg = URL.createObjectURL(new Blob([i], { type: "text/javascript" }));
  }
  return new Worker(Zg);
}
var ste = Object.defineProperty, ote = (i, e, t) => e in i ? ste(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, yi = (i, e, t) => ote(i, typeof e != "symbol" ? e + "" : e, t);
const Ip = [64, 128, 256, 512, 1024, 2048], yh = 64;
function rte(i) {
  for (const e of Ip) if (e >= i / 1.15) return e;
  return Ip[Ip.length - 1];
}
class ate {
  constructor(e) {
    if (yi(this, "opts", e), yi(this, "entries", /* @__PURE__ */ new Map()), yi(this, "queue", []), yi(this, "queueDirty", !1), yi(this, "workers", []), yi(this, "idle", []), yi(this, "jobs", /* @__PURE__ */ new Map()), yi(this, "jobSeq", 0), yi(this, "frame", 0), yi(this, "bytes", 0), yi(this, "ready", []), yi(this, "destroyed", !1), yi(this, "evicted", []), nte()) {
      const t = Math.max(2, Math.min(4, Math.floor((navigator.hardwareConcurrency || 4) / 2)));
      for (let n = 0; n < t; n++) {
        const s = ite();
        s.onmessage = (o) => this.onResult(s, o.data), this.workers.push(s), this.idle.push(s);
      }
    }
  }
  get totalBytes() {
    return this.bytes;
  }
  get textureCount() {
    let e = 0;
    for (const t of this.entries.values()) e += t.tiers.size;
    return e;
  }
  get pending() {
    return this.jobs.size + this.queue.length;
  }
  /** Register or refresh a card's source. Size changes keep loaded tiers. */
  track(e, t, n, s) {
    const o = this.entries.get(e);
    if (!o) {
      this.entries.set(e, {
        id: e,
        url: t,
        w: n,
        h: s,
        tiers: /* @__PURE__ */ new Map(),
        sw: 0,
        sh: 0,
        want: 0,
        priority: 0,
        inflight: 0,
        failed: 0,
        lastSeen: 0
      });
      return;
    }
    o.url !== t && (this.dropAll(o), o.url = t, o.sw = 0, o.sh = 0, o.failed = 0), o.w = n, o.h = s;
  }
  untrack(e) {
    const t = this.entries.get(e);
    if (!t) return;
    this.dropAll(t), this.entries.delete(e);
    const n = this.queue.indexOf(t);
    n >= 0 && this.queue.splice(n, 1);
  }
  /** Called once per rendered frame. */
  tick() {
    this.frame++;
  }
  /**
   * A card is on screen at `screenPx` device pixels on its long edge. Returns
   * the best rendition already loaded (exact tier, else the nearest), and
   * queues the wanted tier. `settled` false = only fill gaps, don't refine.
   */
  request(e, t, n, s) {
    const o = this.entries.get(e);
    if (!o) return null;
    o.lastSeen = this.frame;
    let r = rte(t);
    const a = Math.max(o.sw, o.sh);
    if (a) {
      let c = yh;
      for (const h of Ip) h <= a * 1.1 && (c = h);
      r = Math.min(r, Math.max(c, yh));
    }
    const l = this.best(o, r);
    l && (l.lastUsed = this.frame);
    const d = !l || l.tier * 2 < r;
    if (o.failed < 3 && !o.tiers.has(r) && (s || d)) {
      const c = !l && !s ? Math.min(r, 128) : r;
      o.tiers.has(c) || (o.want = c, o.priority = n, !o.inflight && this.queue.indexOf(o) < 0 && this.queue.push(o), this.queueDirty = !0);
    }
    return l;
  }
  best(e, t) {
    const n = e.tiers.get(t);
    if (n) return n;
    let s = null, o = null;
    for (const r of e.tiers.values())
      r.tier < t && (!s || r.tier > s.tier) && (s = r), r.tier > t && (!o || r.tier < o.tier) && (o = r);
    return o || s;
  }
  /** Start queued loads; call each frame after the visible pass. */
  pump() {
    if (!this.destroyed)
      for (this.queueDirty && (this.queue.sort((e, t) => e.priority - t.priority), this.queueDirty = !1); this.jobs.size < this.opts.maxInFlight && this.queue.length; ) {
        const e = this.queue.shift();
        this.frame - e.lastSeen > 120 || e.tiers.has(e.want) || this.start(e, e.want);
      }
  }
  /**
   * Bitmaps finished since last frame, at most `max` (the upload budget).
   * Ids `cheap` says yes to (no texture upload) have their own budget,
   * `maxCheap`; the rest wait their turn in order.
   */
  drainReady(e, t, n, s = 0) {
    if (!this.ready.length) return [];
    const o = [], r = [];
    let a = 0, l = 0, d = 0;
    for (const c of this.ready)
      n && d < s && n(c.id) ? (d++, o.push(c)) : l < e && (a < t || !l) ? (l++, a += c.tex.bytes, o.push(c)) : r.push(c);
    return this.ready = r, o;
  }
  start(e, t) {
    const n = Math.max(e.w, e.h), s = t / n, o = Math.max(1, Math.round(e.w * s)), r = Math.max(1, Math.round(e.h * s)), a = this.opts.radius * s, l = s >= 0.5 ? Math.max(1, s) : 0, d = ++this.jobSeq;
    e.inflight++, this.jobs.set(d, { entry: e, tier: t, jobId: d });
    const c = { id: d, url: e.url, tw: o, th: r, radius: a, border: l }, h = this.idle.pop();
    h ? h.postMessage(c) : this.workers.length ? this.workers[d % this.workers.length].postMessage(c) : lte(c).then((f) => this.onResult(null, f));
  }
  onResult(e, t) {
    e && this.idle.indexOf(e) < 0 && this.idle.push(e);
    const n = this.jobs.get(t.id);
    if (this.jobs.delete(t.id), !n || this.destroyed) {
      t.bitmap && t.bitmap.close();
      return;
    }
    const s = n.entry;
    if (s.inflight = Math.max(0, s.inflight - 1), t.error || !t.bitmap) {
      s.failed++, s.failed >= 3 && this.opts.onError ? this.opts.onError(s.id, t.error || "unknown") : s.failed < 3 && setTimeout(() => {
        !this.destroyed && this.entries.get(s.id) === s && !s.tiers.has(n.tier) && (s.want = n.tier, this.queue.indexOf(s) < 0 && this.queue.push(s), this.queueDirty = !0);
      }, 800 * s.failed);
      return;
    }
    if (this.entries.get(s.id) !== s) {
      t.bitmap.close();
      return;
    }
    t.sw && t.sh && (s.sw = t.sw, s.sh = t.sh);
    const o = t.bitmap, r = new Gc({
      resource: o,
      alphaMode: "premultiplied-alpha",
      autoGenerateMipmaps: n.tier >= 256,
      scaleMode: "linear"
    }), a = new et({ source: r }), l = o.width * o.height * 4 * (n.tier >= 256 ? 1.34 : 1), d = s.tiers.get(n.tier);
    d && this.free(d);
    const c = { tier: n.tier, texture: a, bytes: l, lastUsed: this.frame };
    s.tiers.set(n.tier, c), this.bytes += l, this.ready.push({ id: s.id, tex: c, color: t.color }), s.want !== n.tier && !s.tiers.has(s.want) && this.queue.indexOf(s) < 0 && (this.queue.push(s), this.queueDirty = !0), this.evict();
  }
  /** Free renditions until under budget; returns ids whose shown tier went. */
  evict() {
    if (this.bytes <= this.opts.budgetBytes) return;
    const e = [];
    for (const t of this.entries.values())
      for (const n of t.tiers.values())
        this.frame - n.lastUsed < 2 || e.push({ e: t, t: n });
    e.sort((t, n) => t.t.lastUsed - n.t.lastUsed || (t.t.tier === yh ? 1 : 0) - (n.t.tier === yh ? 1 : 0) || n.t.bytes - t.t.bytes);
    for (const t of e) {
      if (this.bytes <= this.opts.budgetBytes * 0.9) break;
      t.e.tiers.delete(t.t.tier), this.evicted.push({ id: t.e.id, tier: t.t.tier, texture: t.t.texture, bytes: t.t.bytes }), this.bytes -= t.t.bytes;
    }
  }
  /** Renditions evicted since the last call. The caller swaps any sprite
   *  still pointing at one, then calls release(). */
  takeEvicted() {
    const e = this.evicted;
    return this.evicted = [], e;
  }
  release(e) {
    e.destroy(!0);
  }
  /** Best loaded rendition for an id, regardless of want. */
  anyFor(e) {
    const t = this.entries.get(e);
    if (!t) return null;
    let n = null;
    for (const s of t.tiers.values()) (!n || s.tier > n.tier) && (n = s);
    return n;
  }
  free(e) {
    this.bytes -= e.bytes, e.texture.destroy(!0);
  }
  dropAll(e) {
    for (const t of e.tiers.values()) this.free(t);
    e.tiers.clear();
  }
  destroy() {
    this.destroyed = !0;
    for (const e of this.workers) e.terminate();
    this.workers.length = 0, this.idle.length = 0;
    for (const e of this.entries.values()) this.dropAll(e);
    this.entries.clear();
    for (const e of this.ready) e.tex.texture.destroy(!0);
    this.ready.length = 0;
    for (const e of this.evicted) e.texture.destroy(!0);
    this.evicted = [];
  }
}
async function lte(i) {
  try {
    const e = i.url.startsWith("blob:") || i.url.startsWith("data:") ? i.url : i.url + (i.url.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1", t = await fetch(e, { mode: "cors", credentials: "omit" });
    if (!t.ok) throw new Error("HTTP " + t.status);
    const n = await createImageBitmap(await t.blob()), s = document.createElement("canvas");
    s.width = Math.max(1, Math.round(i.tw)), s.height = Math.max(1, Math.round(i.th));
    const o = s.getContext("2d"), r = s.width / s.height;
    let a = n.width, l = n.height, d = 0, c = 0;
    n.width / n.height > r ? (a = n.height * r, d = (n.width - a) / 2) : (l = n.width / r, c = (n.height - l) / 2), o.beginPath(), o.roundRect(0, 0, s.width, s.height, i.radius), o.clip(), o.imageSmoothingQuality = "high", o.drawImage(n, d, c, a, l, 0, 0, s.width, s.height);
    const h = await createImageBitmap(s), f = n.width, p = n.height;
    return n.close(), { id: i.id, bitmap: h, sw: f, sh: p };
  } catch (e) {
    return { id: i.id, error: String(e && e.message || e) };
  }
}
var dte = Object.defineProperty, cte = (i, e, t) => e in i ? dte(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, wd = (i, e, t) => cte(i, typeof e != "symbol" ? e + "" : e, t);
const ha = 32, Ls = 1, Vr = ha + Ls * 2, Xd = 1024, yf = Math.floor(Xd / Vr), n_ = yf * yf;
function Qg(i) {
  return { x: i % yf * Vr, y: Math.floor(i / yf) * Vr };
}
function ute(i, e) {
  const t = Math.max(1, i, e);
  return { w: Math.max(1, Math.round(ha * i / t)), h: Math.max(1, Math.round(ha * e / t)) };
}
class hte {
  constructor() {
    wd(this, "pages", []), wd(this, "cells", /* @__PURE__ */ new Map()), wd(this, "free", []), wd(this, "next", 0), wd(this, "blank", null);
  }
  get size() {
    return this.cells.size;
  }
  get pageCount() {
    return this.pages.length;
  }
  /** GPU bytes held (each page also keeps its canvas). */
  get bytes() {
    return this.pages.length * Xd * Xd * 4 * 1.34;
  }
  has(e) {
    return this.cells.has(e);
  }
  get(e) {
    const t = this.cells.get(e);
    return t ? t.texture : null;
  }
  /** A white cell on the first page: tinted, it is a tiny image's placeholder. */
  get placeholder() {
    if (!this.blank) {
      const e = this.take(), t = this.pages[e.page], n = Qg(e.slot);
      t.ctx.fillStyle = "#fff", t.ctx.fillRect(n.x, n.y, Vr, Vr), t.dirty = !0, this.blank = new et({ source: t.source, frame: new Tt(n.x + Ls, n.y + Ls, ha, ha) });
    }
    return this.blank;
  }
  /** Draw `image` (any rendition of the picture) into the id's cell; returns its texture. */
  put(e, t, n, s) {
    let o = this.cells.get(e);
    const r = ute(n, s);
    if (o)
      (o.texture.frame.width !== r.w || o.texture.frame.height !== r.h) && (o.texture.frame.width = r.w, o.texture.frame.height = r.h, o.texture.update());
    else {
      const c = this.take(), h = Qg(c.slot), f = this.pages[c.page];
      o = {
        page: c.page,
        slot: c.slot,
        texture: new et({ source: f.source, frame: new Tt(h.x + Ls, h.y + Ls, r.w, r.h) })
      }, this.cells.set(e, o);
    }
    const a = this.pages[o.page], l = Qg(o.slot), d = a.ctx;
    return d.clearRect(l.x, l.y, Vr, Vr), d.drawImage(t, l.x, l.y, r.w + Ls * 2, r.h + Ls * 2), d.drawImage(t, l.x + Ls, l.y + Ls, r.w, r.h), a.dirty = !0, o.texture;
  }
  remove(e) {
    const t = this.cells.get(e);
    t && (this.cells.delete(e), t.texture.destroy(!1), this.free.push({ page: t.page, slot: t.slot }));
  }
  /** Upload the pages drawn into since the last call; once per frame, before rendering. */
  flush() {
    for (const e of this.pages)
      e.dirty && (e.dirty = !1, e.source.update());
  }
  destroy() {
    for (const e of this.cells.values()) e.texture.destroy(!1);
    this.cells.clear(), this.blank && this.blank.destroy(!1), this.blank = null;
    for (const e of this.pages) e.source.destroy();
    this.pages.length = 0, this.free.length = 0, this.next = 0;
  }
  take() {
    const e = this.free.pop();
    if (e) return e;
    const t = Math.floor(this.next / n_), n = this.next % n_;
    return this.next++, t === this.pages.length && this.pages.push(this.newPage()), { page: t, slot: n };
  }
  newPage() {
    const e = document.createElement("canvas");
    e.width = Xd, e.height = Xd;
    const t = e.getContext("2d");
    t.imageSmoothingEnabled = !0, t.imageSmoothingQuality = "high";
    const n = new Ai({
      resource: e,
      scaleMode: "linear",
      // mipmaps keep a 3 px thumbnail from shimmering as the board pans
      autoGenerateMipmaps: !0,
      // a page's pixels live only in this atlas: never let the GPU copy idle out
      autoGarbageCollect: !1
    });
    return { canvas: e, ctx: t, source: n, dirty: !1 };
  }
}
const i_ = /* @__PURE__ */ new Map();
function za(i, e) {
  const t = Math.round(i / Math.max(1, e) * 20) / 20, n = String(t);
  let s = i_.get(n);
  if (s) return s;
  const o = 128, r = t >= 1 ? o : Math.max(8, Math.round(o * t)), a = t >= 1 ? Math.max(8, Math.round(o / t)) : o, l = document.createElement("canvas");
  l.width = r, l.height = a;
  const d = l.getContext("2d");
  return d.fillStyle = "#fff", d.beginPath(), d.roundRect(0, 0, r, a, Math.max(2, o * 0.038)), d.fill(), s = et.from(l), i_.set(n, s), s;
}
let xh = null;
function pte() {
  if (xh) return xh;
  const i = 60, e = i * 2, t = 64, n = t + e * 2, s = document.createElement("canvas");
  s.width = n, s.height = n;
  const o = s.getContext("2d");
  return o.shadowColor = "rgba(5,8,20,1)", o.shadowBlur = i, o.shadowOffsetX = n * 2, o.fillStyle = "#000", o.beginPath(), o.roundRect(e - n * 2, e, t, t, 12), o.fill(), xh = et.from(s), xh;
}
const fte = 120, $C = "rd-board-colors", mte = 6e3;
let kd = null, s_ = 0;
function DC() {
  if (kd) return kd;
  kd = /* @__PURE__ */ new Map();
  try {
    const i = localStorage.getItem($C);
    if (i) for (const [e, t] of JSON.parse(i)) kd.set(e, t);
  } catch {
  }
  return kd;
}
function gte(i) {
  return DC().get(i);
}
function bte(i, e) {
  const t = DC();
  if (t.get(i) !== e) {
    for (t.delete(i), t.set(i, e); t.size > mte; ) t.delete(t.keys().next().value);
    clearTimeout(s_), s_ = window.setTimeout(() => {
      try {
        localStorage.setItem($C, JSON.stringify(Array.from(t.entries())));
      } catch {
      }
    }, 2e3);
  }
}
const xf = {
  amethyst: { fill: 10053855, fillA: 0.13, line: 12756204, lineA: 0.22 },
  vista: { fill: 5923309, fillA: 0.13, line: 10725365, lineA: 0.22 },
  sky: { fill: 4044006, fillA: 0.13, line: 10082803, lineA: 0.22 },
  mint: { fill: 3458970, fillA: 0.13, line: 9430473, lineA: 0.22 },
  amber: { fill: 15774794, fillA: 0.13, line: 16241807, lineA: 0.22 },
  rose: { fill: 15489946, fillA: 0.13, line: 16098247, lineA: 0.22 },
  glass: { fill: 16777215, fillA: 0.06, line: 16777215, lineA: 0.1 }
};
function vte() {
  const i = new mn(), e = new Ko();
  return i.addChild(e), { root: i, g: e, thumbs: [] };
}
function wf() {
  const t = (Rt.w - 28 - 2 - 18) / 4;
  return [0, 1, 2, 3].map((n) => ({ x: 15 + n * (t + 6), y: 63, s: t }));
}
function OC(i, e, t, n, s) {
  const o = Nc, r = i.g, a = n ? 1251368 : 16777215;
  r.clear(), r.roundRect(0, 0, e, o, 16), r.fill(n ? { color: 16777215, alpha: 1 } : s ? { color: 10053855, alpha: 0.1 } : { color: 16777215, alpha: 0.062 }), r.roundRect(0.5, 0.5, e - 1, o - 1, 15.5), r.stroke({ width: 1, color: n ? s ? 7680723 : 1251368 : s ? 12756204 : 16777215, alpha: n ? s ? 0.3 : 0.14 : s ? 0.24 : 0.1 }), r.roundRect(14, 14, 36, 36, 12).fill({ color: a, alpha: n ? 0.05 : 0.06 }), r.roundRect(24, 24, 16, 16, 4).fill({ color: n ? 7680723 : 12756204, alpha: 0.55 }), r.roundRect(60, 20, 46, 5, 2.5).fill({ color: a, alpha: n ? 0.3 : 0.22 }), r.roundRect(60, 31, Math.min(e - 120, 30 + t.length * 6.4), 9, 4.5).fill({ color: a, alpha: n ? 0.75 : 0.78 }), r.roundRect(e - 14 - 30, 23, 30, 18, 9).fill({ color: a, alpha: n ? 0.06 : 0.05 });
}
function yte(i, e, t) {
  const n = e.scale || 1, s = Rt.w, o = Rt.h, r = i.g;
  if (e.collapsed) {
    OC(i, s, e.name || "", t, !1), i.root.position.set(e.x, e.y), i.root.scale.set(n), i.root.zIndex = e.z;
    return;
  }
  r.clear(), r.roundRect(0, 0, s, o, 16), r.fill(t ? { color: 16777215, alpha: 1 } : { color: 16777215, alpha: 0.062 }), r.roundRect(0.5, 0.5, s - 1, o - 1, 15.5), r.stroke({ width: 1, color: t ? 1251368 : 16777215, alpha: t ? 0.14 : 0.1 });
  const a = t ? 1251368 : 16777215;
  r.roundRect(15, 15, 36, 36, 12).fill({ color: a, alpha: t ? 0.05 : 0.06 }), r.roundRect(25, 25, 16, 16, 4).fill({ color: t ? 7680723 : 12756204, alpha: 0.55 }), r.roundRect(61, 21, 46, 5, 2.5).fill({ color: a, alpha: t ? 0.3 : 0.22 }), r.roundRect(61, 32, Math.min(130, 30 + (e.name || "").length * 6.4), 9, 4.5).fill({ color: a, alpha: t ? 0.75 : 0.78 }), r.roundRect(s - 15 - 30, 24, 30, 18, 9).fill({ color: a, alpha: t ? 0.06 : 0.05 }), r.roundRect(15, o - 15 - 6, 70, 5, 2.5).fill({ color: a, alpha: t ? 0.25 : 0.2 });
  const l = wf(), d = (e.thumbs || []).slice(0, 4);
  for (let c = d.length; c < 4; c++) {
    const h = l[c];
    r.roundRect(h.x, h.y, h.s, h.s, 8).stroke({ width: 1, color: a, alpha: 0.1 });
  }
  i.root.position.set(e.x, e.y), i.root.scale.set(n), i.root.zIndex = e.z;
}
function xte(i, e, t) {
  const n = wf();
  for (; i.thumbs.length > e; ) i.thumbs.pop().destroy();
  for (; i.thumbs.length < e; ) {
    const s = new ks(et.WHITE);
    i.root.addChild(s), i.thumbs.push(s);
  }
  i.thumbs.forEach((s, o) => {
    const r = n[o], a = t(o);
    (s.texture === et.WHITE || !s.texture) && (s.texture = a.texture, s.tint = a.tint), s.position.set(r.x, r.y), s.setSize(r.s, r.s);
  });
}
function wte(i, e, t) {
  const n = e.w || Ri.w, s = e.h || Ri.h, o = i.g;
  if (e.collapsed) {
    OC(i, n, e.name || "", t, !0), i.root.position.set(e.x, e.y), i.root.scale.set(1), i.root.zIndex = e.z;
    return;
  }
  o.clear(), o.roundRect(0, 0, n, s, 16), o.fill(t ? { color: 16777215, alpha: 1 } : { color: 10053855, alpha: 0.1 }), o.roundRect(0.5, 0.5, n - 1, s - 1, 15.5), o.stroke({ width: 1, color: t ? 7680723 : 12756204, alpha: t ? 0.3 : 0.24 });
  const r = t ? 1251368 : 16777215;
  o.roundRect(15, 15, 36, 36, 12).fill({ color: r, alpha: t ? 0.05 : 0.06 }), o.roundRect(24, 26, 18, 13, 4).fill({ color: t ? 7680723 : 12756204, alpha: 0.6 }), o.roundRect(61, 21, 40, 5, 2.5).fill({ color: r, alpha: t ? 0.3 : 0.22 }), o.roundRect(61, 32, Math.min(130, 30 + (e.name || "").length * 6.4), 9, 4.5).fill({ color: r, alpha: t ? 0.75 : 0.78 }), o.roundRect(n - 15 - 30, 24, 30, 18, 9).fill({ color: r, alpha: t ? 0.06 : 0.05 }), o.roundRect(15, 68, n - 30, 7, 3.5).fill({ color: r, alpha: t ? 0.4 : 0.32 }), o.roundRect(15, 84, (n - 30) * 0.66, 7, 3.5).fill({ color: r, alpha: t ? 0.4 : 0.32 }), o.roundRect(15, s - 15 - 6, 70, 5, 2.5).fill({ color: r, alpha: t ? 0.25 : 0.2 }), i.root.position.set(e.x, e.y), i.root.scale.set(1), i.root.zIndex = e.z;
}
function kte(i, e) {
  const t = { color: 15132910, alpha: 1 };
  if (i.type === "tool") return e ? t : { color: 16777215, alpha: 0.09 };
  if (i.type === "chat") return e ? t : { color: 10053855, alpha: 0.16 };
  const n = xf[i.tint] || xf.glass;
  return e && i.tint === "glass" ? t : { color: n.fill, alpha: (e ? n.fillA * 1.4 : n.fillA) + 0.05 };
}
function _te(i, e, t) {
  const n = i.g, s = xf[e.tint] || xf.glass;
  n.clear(), n.roundRect(0, 0, e.w, e.h, 16), t && e.tint === "glass" ? n.fill({ color: 16777215, alpha: 1 }) : n.fill({ color: s.fill, alpha: t ? s.fillA * 1.4 : s.fillA }), n.roundRect(0.5, 0.5, e.w - 1, e.h - 1, 15.5), n.stroke({ width: 1, color: t && e.tint === "glass" ? 1251368 : s.line, alpha: t ? 0.3 : s.lineA });
  const o = t ? 1251368 : 16777215, r = e.w - 32, a = Math.max(4, Math.floor(r / 7.1)), l = Math.max(0, Math.floor((e.h - 32 - 20) / 19.6));
  let d = 0;
  for (const c of String((e.link ? e.link.title : e.text) || "").split(`
`)) {
    const h = c.trim().length;
    if (!h) {
      d++;
      continue;
    }
    const f = Math.ceil(h / a);
    for (let p = 0; p < f && d < l; p++, d++) {
      const y = p === f - 1 ? h - a * p : a;
      n.roundRect(16, 16 + d * 19.6 + 6, Math.max(10, y / a * r), 7, 3.5).fill({ color: o, alpha: t ? 0.55 : 0.5 });
    }
    if (d >= l) break;
  }
  n.roundRect(16, e.h - 16 - 7, 16, 6, 3).fill({ color: o, alpha: 0.22 }), i.root.position.set(e.x, e.y), i.root.scale.set(1), i.root.zIndex = e.z;
}
var Ste = Object.defineProperty, Mte = (i, e, t) => e in i ? Ste(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, gt = (i, e, t) => Mte(i, typeof e != "symbol" ? e + "" : e, t);
const o_ = 10053855, Tte = 12, r_ = 650, Cte = 0.05, Ite = 0.06;
class Ate {
  constructor(e) {
    gt(this, "app"), gt(this, "camera", { x: 0, y: 0, zoom: 1 }), gt(this, "viewW", 1), gt(this, "viewH", 1), gt(this, "dpr", 1), gt(this, "theme"), gt(this, "opts"), gt(this, "store"), gt(this, "world"), gt(this, "frameLayer"), gt(this, "imageLayer"), gt(this, "shapeLayer"), gt(this, "cardLayer"), gt(this, "screenLayer"), gt(this, "far", !1), gt(this, "simple", !1), gt(this, "rings"), gt(this, "textures"), gt(this, "micro", new hte()), gt(this, "nodes", /* @__PURE__ */ new Map()), gt(this, "unsub", null), gt(this, "resizeObs", null), gt(this, "raf", 0), gt(this, "paused", !1), gt(this, "ringsDirty", !0), gt(this, "cameraChanged", !0), gt(this, "lastCameraMove", 0), gt(this, "settledPass", !1), gt(this, "tween", null), gt(this, "visibleIds", /* @__PURE__ */ new Set()), gt(this, "lastCull", null), gt(this, "selection", /* @__PURE__ */ new Set()), gt(this, "dragging", !1), gt(this, "hoverId", null), gt(this, "hidden", /* @__PURE__ */ new Set()), gt(this, "enteringUntil", 0), gt(this, "destroyed", !1), gt(this, "frameTimes", []), gt(this, "lastFrameAt", 0), gt(this, "lastRenderMs", 0), gt(this, "statsAt", 0), gt(this, "ready"), this.opts = e, this.store = e.store, this.theme = e.theme || "dark", this.ready = this.init();
  }
  // ------------------------------------------------------------- setup
  async init() {
    const e = this.opts.host;
    this.dpr = Math.min(2, window.devicePixelRatio || 1);
    const t = e.getBoundingClientRect();
    this.viewW = Math.max(1, t.width), this.viewH = Math.max(1, t.height);
    const n = new cM();
    if (await n.init({
      width: this.viewW,
      height: this.viewH,
      resolution: this.dpr,
      autoDensity: !0,
      antialias: !0,
      backgroundAlpha: 0,
      autoStart: !1,
      sharedTicker: !1,
      preference: "webgl",
      powerPreference: "high-performance",
      eventMode: "none"
    }), this.destroyed) {
      n.destroy(!0);
      return;
    }
    this.app = n, n.ticker.stop();
    const s = n.canvas;
    s.className = "bd-canvas", e.appendChild(s), n.stage.eventMode = "none", this.world = new mn({ isRenderGroup: !0 }), this.frameLayer = new mn(), this.imageLayer = new mn(), this.imageLayer.sortableChildren = !0, this.shapeLayer = new mn(), this.shapeLayer.sortableChildren = !0, this.frameLayer.sortableChildren = !0, this.cardLayer = new mn(), this.cardLayer.sortableChildren = !0, this.cardLayer.visible = this.far, this.world.addChild(this.frameLayer, this.imageLayer, this.shapeLayer, this.cardLayer), this.screenLayer = new mn(), this.rings = new Ko(), this.screenLayer.addChild(this.rings), n.stage.addChild(this.world, this.screenLayer);
    const o = (navigator.deviceMemory || 8) <= 4;
    this.textures = new ate({
      budgetBytes: (o ? 160 : 420) * 1024 * 1024,
      maxInFlight: 10,
      radius: Tte,
      onReady: () => this.requestRender(),
      onError: (r, a) => console.warn("[board] image failed to load", r, a)
    }), this.resizeObs = new ResizeObserver(() => this.resize()), this.resizeObs.observe(e);
    for (const r of this.store.all()) this.addNode(r, !1);
    this.unsub = this.store.subscribe((r) => this.onChange(r)), this.requestRender();
  }
  resize() {
    if (!this.app) return;
    const e = this.opts.host.getBoundingClientRect(), t = Math.max(1, e.width), n = Math.max(1, e.height);
    t === this.viewW && n === this.viewH || (this.viewW = t, this.viewH = n, this.app.renderer.resize(t, n), this.cameraChanged = !0, this.requestRender());
  }
  destroy() {
    this.destroyed = !0, cancelAnimationFrame(this.raf), this.unsub && this.unsub(), this.resizeObs && this.resizeObs.disconnect(), this.textures && this.textures.destroy(), this.micro.destroy(), this.app && this.app.destroy(!0, { children: !0 }), this.nodes.clear();
  }
  // ------------------------------------------------------------ camera
  setCamera(e) {
    this.tween = null, this.applyCamera(e);
  }
  applyCamera(e) {
    const t = tr(e.zoom);
    !Number.isFinite(e.x) || !Number.isFinite(e.y) || t === this.camera.zoom && e.x === this.camera.x && e.y === this.camera.y || (this.camera = { x: e.x, y: e.y, zoom: t }, this.cameraChanged = !0, this.ringsDirty = !0, this.lastCameraMove = performance.now(), this.settledPass = !1, this.requestRender());
  }
  /** Glide to a camera with the design's ease-out curve. */
  animateCamera(e, t = 420) {
    const n = { ...e, zoom: tr(e.zoom) };
    return t <= 0 || matchMedia("(prefers-reduced-motion: reduce)").matches ? (this.setCamera(n), Promise.resolve()) : (this.tween && this.tween.resolve(), new Promise((s) => {
      this.tween = { from: { ...this.camera }, to: n, start: performance.now(), ms: t, resolve: s }, this.requestRender();
    }));
  }
  get isAnimatingCamera() {
    return !!this.tween;
  }
  /** Where the camera is headed: a glide's end while one is under way, else where it is. */
  get cameraGoal() {
    return this.tween ? this.tween.to : this.camera;
  }
  zoomAt(e, t, n) {
    this.setCamera(Cv(this.tween ? this.tween.to : this.camera, e, t, n));
  }
  panBy(e, t) {
    const n = this.camera;
    this.setCamera({ zoom: n.zoom, x: n.x + e, y: n.y + t });
  }
  fitTo(e, t = {}) {
    if (!e) return Promise.resolve();
    const n = rm(e, this.viewW, this.viewH, t.pad == null ? 120 : t.pad, t.maxZoom == null ? 1 : t.maxZoom);
    return this.animateCamera(n, t.animate == null ? 420 : t.animate);
  }
  screenToWorld(e, t) {
    return Tv(this.camera, e, t);
  }
  get moving() {
    return !!this.tween || performance.now() - this.lastCameraMove < 160;
  }
  // ------------------------------------------------------------- state
  setTheme(e) {
    if (this.theme !== e) {
      this.theme = e;
      for (const t of this.nodes.values())
        t.kind === "frame" && this.drawFrame(t), t.kind === "image" && !t.loaded && (t.sprite.tint = this.placeholderTint(t.el)), t.kind === "card" && this.drawCard(t);
      this.ringsDirty = !0, this.requestRender();
    }
  }
  setSelection(e) {
    this.selection = new Set(e), this.ringsDirty = !0, this.requestRender();
  }
  /** A drag is moving the selection: a shape's square box steps aside while it moves (IL-100). */
  setDragging(e) {
    e !== this.dragging && (this.dragging = e, this.ringsDirty = !0, this.requestRender());
  }
  /** The hovered image lifts 4px and casts a deeper shadow. */
  setHover(e) {
    if (e === this.hoverId) return;
    const t = this.hoverId ? this.nodes.get(this.hoverId) : null;
    t && t.kind === "image" && (t.liftTarget = 0), this.hoverId = e;
    const n = e ? this.nodes.get(e) : null;
    n && n.kind === "image" && !this.selection.has(e) && (n.liftTarget = 1), this.requestRender();
  }
  /** Hide elements another layer is drawing (e.g. while dragged as DOM). */
  setHidden(e) {
    this.hidden = new Set(e);
    for (const t of this.nodes.values()) this.applyVisibility(t);
    this.requestRender();
  }
  /**
   * Far zoom: the engine draws tool sessions and notes itself (cheap
   * stand-ins) and the DOM layer stands down; near, the reverse.
   */
  setFar(e) {
    this.far !== e && (this.far = e, this.cardLayer.visible = e, this.ringsDirty = !0, this.requestRender());
  }
  get isFar() {
    return this.far;
  }
  /** Play the board's entrance: elements rise in with a short stagger. */
  playEntrance() {
    const e = performance.now(), n = Array.from(this.nodes.values()).sort((o, r) => o.el.y - r.el.y || o.el.x - r.el.x).filter((o) => this.isInView(o.el)), s = Math.min(45, 900 / Math.max(1, n.length));
    n.forEach((o, r) => {
      o.enter = e + r * s;
    }), this.enteringUntil = e + n.length * s + r_, this.requestRender();
  }
  // ------------------------------------------------------------ queries
  /** Topmost GPU-drawn element under a screen point (images, shapes, frames). */
  hitTest(e, t) {
    const n = this.screenToWorld(e, t), s = 10 / this.camera.zoom, o = this.store.index.queryPoint(n.x, n.y, s);
    let r = null, a = -1 / 0;
    for (const l of o) {
      const d = this.store.get(l);
      if (!d || this.hidden.has(l)) continue;
      let c;
      if (d.type === "shape") {
        if (!tU(d, n.x, n.y, Math.max(d.sw / 2 + 2 / this.camera.zoom, 7 / this.camera.zoom))) continue;
        c = 3e9 + d.z;
      } else if (d.type === "image") {
        const h = He(d);
        if (n.x < h.x || n.y < h.y || n.x > h.x + h.w || n.y > h.y + h.h) continue;
        c = 2e9 + d.z;
      } else if (d.type === "frame") {
        const h = He(d);
        if (n.x < h.x || n.y < h.y || n.x > h.x + h.w || n.y > h.y + h.h) continue;
        c = 1e9 + d.z;
      } else if (this.far && (d.type === "tool" || d.type === "note" || d.type === "chat")) {
        const h = He(d);
        if (n.x < h.x || n.y < h.y || n.x > h.x + h.w || n.y > h.y + h.h) continue;
        c = 4e9 + d.z;
      } else
        continue;
      c > a && (a = c, r = d);
    }
    return r;
  }
  isInView(e, t = 0) {
    const n = fl(this.camera, this.viewW, this.viewH, t), s = He(e);
    return s.x < n.x + n.w && s.x + s.w > n.x && s.y < n.y + n.h && s.y + s.h > n.y;
  }
  textureStats() {
    return {
      textures: (this.textures ? this.textures.textureCount : 0) + this.micro.pageCount,
      mb: Math.round(((this.textures ? this.textures.totalBytes : 0) + this.micro.bytes) / 1048576),
      pending: this.textures ? this.textures.pending : 0
    };
  }
  // ---------------------------------------------------------- document
  onChange(e) {
    for (const t of e.removed) this.removeNode(t.id);
    for (const t of e.added) this.addNode(t, e.origin !== "load");
    for (const t of e.updated) this.updateNode(t.el, t.after);
    this.ringsDirty = !0, this.lastCull = null, this.requestRender();
  }
  addNode(e, t) {
    if (this.nodes.has(e.id)) return;
    const n = t ? performance.now() : 0;
    if (e.type === "image") {
      const s = new ks(za(e.w, e.h));
      s.tint = this.placeholderTint(e);
      const o = {
        kind: "image",
        el: e,
        sprite: s,
        shown: null,
        loaded: !1,
        lift: 0,
        liftTarget: 0,
        fade: 1,
        under: null,
        shadow: null,
        visible: !1,
        enter: n,
        tiny: !1
      };
      this.layoutImage(o), this.imageLayer.addChild(s), this.textures.track(e.id, e.src, e.w, e.h), this.nodes.set(e.id, o), this.applyVisibility(o);
    } else if (e.type === "frame") {
      const s = new Ko(), o = { kind: "frame", el: e, g: s, rect: null, visible: !1, enter: n };
      this.drawFrame(o), this.frameLayer.addChild(s), this.nodes.set(e.id, o), this.applyVisibility(o);
    } else if (e.type === "tool" || e.type === "note" || e.type === "chat") {
      const s = vte(), o = { kind: "card", el: e, proxy: s, thumbShown: [], rect: null, visible: !1, enter: n };
      this.drawCard(o), this.cardLayer.addChild(s.root), this.nodes.set(e.id, o), this.applyVisibility(o);
    } else if (e.type === "shape") {
      const s = new Ko(), o = { kind: "shape", el: e, g: s, visible: !1, enter: n };
      Dw(s, e), s.position.set(e.x, e.y), s.zIndex = e.z, this.shapeLayer.addChild(s), this.nodes.set(e.id, o), this.applyVisibility(o);
    }
  }
  updateNode(e, t) {
    const n = this.nodes.get(e.id);
    if (n) {
      if (n.kind === "image") {
        const s = e;
        ("src" in t || "w" in t || "h" in t) && (this.textures.track(s.id, s.src, s.w, s.h), this.micro.remove(s.id), n.tiny && this.enterTiny(n)), ("w" in t || "h" in t) && !n.loaded && !n.tiny && (n.sprite.texture = za(s.w, s.h)), "color" in t && !n.loaded && (n.sprite.tint = this.placeholderTint(s)), this.layoutImage(n);
      } else if (n.kind === "frame")
        this.drawFrame(n);
      else if (n.kind === "card") {
        if ("thumbs" in t) {
          for (let s = 0; s < 4; s++) this.textures.untrack(this.thumbKey(n.el.id, s));
          n.thumbShown = [];
          for (const s of n.proxy.thumbs) s.texture = et.WHITE;
        }
        this.drawCard(n);
      } else
        Dw(n.g, n.el), n.g.position.set(n.el.x, n.el.y), n.g.zIndex = n.el.z;
      this.applyVisibility(n);
    }
  }
  removeNode(e) {
    const t = this.nodes.get(e);
    if (t)
      if (this.nodes.delete(e), this.visibleIds.delete(e), t.kind === "image")
        t.sprite.destroy(), t.under && t.under.destroy(), t.shadow && t.shadow.destroy(), this.textures.untrack(e), this.micro.remove(e);
      else if (t.kind === "card") {
        for (let n = 0; n < 4; n++) this.textures.untrack(this.thumbKey(e, n));
        t.proxy.root.destroy({ children: !0 }), t.rect && t.rect.destroy();
      } else
        t.kind === "frame" && t.rect && t.rect.destroy(), t.g.destroy();
  }
  placeholderTint(e) {
    const t = e.color || gte(e.src);
    if (t && /^#[0-9a-f]{6}$/i.test(t)) {
      const n = parseInt(t.slice(1), 16), s = this.theme === "light" ? 0.92 : 0.82;
      return Math.round((n >> 16 & 255) * s) << 16 | Math.round((n >> 8 & 255) * s) << 8 | Math.round((n & 255) * s);
    }
    return this.theme === "light" ? 14672618 : 1777456;
  }
  layoutImage(e) {
    const t = e.el, n = e.sprite;
    n.position.set(t.x, t.y - 4 * e.lift), n.setSize(t.w, t.h), n.zIndex = t.z, e.under && (e.under.position.copyFrom(n.position), e.under.setSize(t.w, t.h), e.under.zIndex = t.z - 1e-4), e.shadow && this.layoutShadow(e);
  }
  layoutShadow(e) {
    const t = e.shadow, n = e.el, s = 1 + 0.18 * e.lift, o = fte * s * 0.5;
    t.position.set(n.x - o, n.y - o + 18 + 6 * e.lift - 4 * e.lift), t.setSize(n.w + o * 2, n.h + o * 2), t.alpha = (this.theme === "light" ? 0.22 : 0.3) + 0.14 * e.lift, t.zIndex = n.z - 2e-4;
  }
  thumbKey(e, t) {
    return e + "#t" + t;
  }
  drawCard(e) {
    const t = this.theme === "light";
    if (e.el.type === "tool") {
      const n = e.el;
      yte(e.proxy, n, t);
      const s = n.collapsed ? [] : (n.thumbs || []).slice(0, 4), o = wf()[0].s;
      s.forEach((r, a) => this.textures.track(this.thumbKey(n.id, a), r, o, o)), xte(e.proxy, s.length, (r) => ({
        texture: za(1, 1),
        tint: this.placeholderTint({ src: s[r] })
      }));
    } else e.el.type === "chat" ? wte(e.proxy, e.el, t) : _te(e.proxy, e.el, t);
    (e.rect || this.simple) && this.layoutRect(e);
  }
  /** A frame's or card's plain-rectangle stand-in (see SIMPLE_IN), made on first use. */
  layoutRect(e) {
    e.rect || (e.rect = new ks(et.WHITE), e.rect.visible = !1, (e.kind === "frame" ? this.frameLayer : this.cardLayer).addChild(e.rect));
    const t = this.theme === "light", n = He(e.el), s = e.kind === "frame" ? { color: 16777215, alpha: t ? 0.62 : 0.03 } : kte(e.el, t);
    e.rect.position.set(n.x, n.y), e.rect.setSize(n.w, n.h), e.rect.tint = s.color, e.rect.alpha = s.alpha, e.rect.zIndex = e.el.z;
  }
  setSimple(e) {
    this.simple = e;
    for (const t of this.nodes.values())
      t.kind !== "frame" && t.kind !== "card" || (e && this.layoutRect(t), this.applyVisibility(t));
  }
  drawFrame(e) {
    const t = e.el, n = e.g, s = this.theme === "light";
    n.clear(), n.roundRect(0, 0, t.w, t.h, 24), n.fill({ color: 16777215, alpha: s ? 0.62 : 0.022 }), n.roundRect(0.5, 0.5, t.w - 1, t.h - 1, 23.5), n.stroke({ width: 1, color: s ? 1251368 : 16777215, alpha: s ? 0.14 : 0.06 }), n.position.set(t.x, t.y), n.zIndex = t.z, (e.rect || this.simple) && this.layoutRect(e);
  }
  applyVisibility(e) {
    const t = e.visible && !this.hidden.has(e.el.id);
    e.kind === "image" ? (e.sprite.visible = t, e.under && (e.under.visible = t), e.shadow && (e.shadow.visible = t)) : e.kind === "card" ? (e.proxy.root.visible = t && !this.simple, e.rect && (e.rect.visible = t && this.simple)) : e.kind === "frame" ? (e.g.visible = t && !this.simple, e.rect && (e.rect.visible = t && this.simple)) : e.g.visible = t;
  }
  // --------------------------------------------------------- screenshots
  /**
   * The board as it is on screen now, read back from the GPU into a 2D canvas
   * (a feedback report's screenshot). The WebGL canvas is made without
   * preserveDrawingBuffer, which would cost every frame, so a copy of it taken
   * after the browser presents is blank: this renders the stage itself, in
   * this task. Null before the engine is ready or once it's gone.
   */
  snapshot() {
    if (!this.app || this.destroyed) return null;
    this.cameraChanged && (this.world.position.set(this.camera.x, this.camera.y), this.world.scale.set(this.camera.zoom));
    const e = this.app.renderer.extract.canvas({
      target: this.app.stage,
      frame: new Tt(0, 0, this.viewW, this.viewH),
      resolution: this.dpr,
      antialias: !0
    });
    return e instanceof HTMLCanvasElement ? e : null;
  }
  /** The last 90 frame intervals (ms), oldest first: a feedback report's frame-time history. */
  frameIntervals() {
    return this.frameTimes.slice();
  }
  /** The GPU as this board's WebGL context names it, for a feedback report; null where the browser won't say. */
  gpu() {
    if (!this.app || this.destroyed || !("gl" in this.app.renderer)) return null;
    const e = this.app.renderer.gl, t = e.getExtension("WEBGL_debug_renderer_info"), n = t ? e.getParameter(t.UNMASKED_RENDERER_WEBGL) : e.getParameter(e.RENDERER);
    return typeof n == "string" ? n : null;
  }
  // ------------------------------------------------------------- frame
  requestRender() {
    !this.raf && !this.destroyed && !this.paused && (this.raf = requestAnimationFrame((e) => this.frame(e)));
  }
  /**
   * Covered (the Studios view is open over the board): draw nothing, not
   * even textures still arriving, until it's uncovered; then carry on.
   */
  setPaused(e) {
    this.paused !== e && (this.paused = e, e ? (this.raf && cancelAnimationFrame(this.raf), this.raf = 0) : this.requestRender());
  }
  frame(e) {
    if (this.raf = 0, this.destroyed || !this.app) return;
    const t = performance.now();
    let n = !1;
    if (this.tween) {
      const r = this.tween, a = Math.min(1, (e - r.start) / r.ms);
      this.applyCamera(KN(r.from, r.to, Jm(a), this.viewW, this.viewH)), a >= 1 ? (this.tween = null, this.applyCamera(r.to), r.resolve()) : n = !0;
    }
    const s = this.moving;
    if (this.cameraChanged) {
      this.world.position.set(this.camera.x, this.camera.y), this.world.scale.set(this.camera.zoom), this.opts.onCamera && this.opts.onCamera(this.camera, s), this.cameraChanged = !1;
      const r = this.camera.zoom < (this.simple ? Ite : Cte);
      r !== this.simple && this.setSimple(r);
    }
    this.cull();
    const o = !s;
    this.updateTextures(o && !this.settledPass), o && (this.settledPass = !0), this.textures.pending && (n = !0), this.animate(e) && (n = !0), this.ringsDirty && this.drawRings(), this.textures.tick(), this.micro.flush(), this.app.render(), s && (n = !0), n && this.requestRender(), this.recordStats(e, performance.now() - t);
  }
  cull() {
    const e = fl(this.camera, this.viewW, this.viewH, 0), t = this.lastCull;
    if (t && e.x >= t.x && e.y >= t.y && e.x + e.w <= t.x + t.w && e.y + e.h <= t.y + t.h && t.w < e.w * 2.2)
      return;
    const n = e.w * 0.35, s = e.h * 0.35, o = { x: e.x - n, y: e.y - s, w: e.w + n * 2, h: e.h + s * 2 };
    this.lastCull = o;
    const r = this.store.index.query(o), a = /* @__PURE__ */ new Set();
    for (const l of r) this.nodes.has(l) && a.add(l);
    for (const l of this.visibleIds)
      if (!a.has(l)) {
        const d = this.nodes.get(l);
        d && (d.visible = !1, this.applyVisibility(d));
      }
    for (const l of a)
      if (!this.visibleIds.has(l)) {
        const d = this.nodes.get(l);
        d.visible = !0, this.applyVisibility(d);
      }
    this.visibleIds = a;
  }
  updateTextures(e) {
    const t = this.camera.zoom, n = this.dpr, s = (this.viewW / 2 - this.camera.x) / t, o = (this.viewH / 2 - this.camera.y) / t, r = fl(this.camera, this.viewW, this.viewH, 0), a = !this.moving, l = (d) => {
      const c = this.nodes.get(d);
      return !!c && c.kind === "image" && c.tiny;
    };
    for (const d of this.textures.drainReady(a ? 10 : 5, a ? 12 * 1048576 : 5 * 1048576, l, 64)) {
      const c = d.id.indexOf("#t");
      if (c > 0) {
        const f = this.nodes.get(d.id.slice(0, c)), p = Number(d.id.slice(c + 2));
        f && f.kind === "card" && f.proxy.thumbs[p] && (f.proxy.thumbs[p].texture = d.tex.texture, f.proxy.thumbs[p].tint = 16777215, f.thumbShown[p] = d.tex);
        continue;
      }
      const h = this.nodes.get(d.id);
      h && h.kind === "image" && (d.color && bte(h.el.src, d.color), h.tiny ? this.fillCell(h, d.tex) : this.consider(h, d.tex));
    }
    for (const d of this.textures.takeEvicted()) {
      const c = d.id.indexOf("#t");
      if (c > 0) {
        const f = this.nodes.get(d.id.slice(0, c)), p = Number(d.id.slice(c + 2));
        f && f.kind === "card" && f.proxy.thumbs[p] && f.proxy.thumbs[p].texture === d.texture && (f.proxy.thumbs[p].texture = za(1, 1), f.thumbShown[p] = null), this.textures.release(d.texture);
        continue;
      }
      const h = this.nodes.get(d.id);
      if (h && h.kind === "image" && h.shown && h.shown.texture === d.texture) {
        const f = this.textures.anyFor(d.id);
        f ? this.show(h, f, !1) : this.showPlaceholder(h);
      }
      this.textures.release(d.texture);
    }
    if (this.visibleIds.size) {
      for (const d of this.visibleIds) {
        const c = this.nodes.get(d);
        if (c && c.kind === "card" && this.far && c.el.type === "tool" && t >= 0.08) {
          const S = c.el, M = wf()[0].s * (S.scale || 1), _ = Math.min(4, (S.thumbs || []).length);
          for (let T = 0; T < _; T++) {
            const k = this.textures.request(this.thumbKey(S.id, T), M * t * n, 1e12, a || e);
            k && k !== c.thumbShown[T] && c.proxy.thumbs[T] && (c.proxy.thumbs[T].texture = k.texture, c.proxy.thumbs[T].tint = 16777215, c.thumbShown[T] = k);
          }
          continue;
        }
        if (!c || c.kind !== "image") continue;
        const h = c.el;
        if (!(h.x < r.x + r.w && h.x + h.w > r.x && h.y < r.y + r.h && h.y + h.h > r.y)) continue;
        const p = Math.max(h.w, h.h) * t * n, y = h.x + h.w / 2 - s, v = h.y + h.h / 2 - o, x = (y * y + v * v) * t * t - p * p * 0.25;
        if (p <= ha || c.tiny && p <= ha * 1.25) {
          if (c.tiny || this.enterTiny(c), !this.micro.has(d)) {
            const S = this.textures.anyFor(d);
            S ? this.fillCell(c, S) : this.textures.request(d, p, x, a || e);
          }
          continue;
        }
        c.tiny && this.leaveTiny(c);
        const w = this.textures.request(d, p, x, a || e);
        w && w !== c.shown && this.consider(c, w);
      }
      this.textures.pump();
    }
  }
  /** Tiny on screen: draw from the shared atlas, its cell or (until that fills) the tinted blank. */
  enterTiny(e) {
    e.under && (e.under.destroy(), e.under = null), e.fade = 1, e.sprite.alpha = 1, e.tiny = !0, e.shown = null;
    const t = this.micro.get(e.el.id);
    e.sprite.texture = t || this.micro.placeholder, e.sprite.tint = t ? 16777215 : this.placeholderTint(e.el), e.loaded = !!t, this.layoutImage(e);
  }
  /** Big enough for its own texture again: the best rendition loaded, else the thumbnail stretched. */
  leaveTiny(e) {
    e.tiny = !1;
    const t = this.textures.anyFor(e.el.id), n = this.micro.get(e.el.id);
    t ? (e.sprite.texture = t.texture, e.shown = t) : n ? e.sprite.texture = n : e.sprite.texture = za(e.el.w, e.el.h), e.loaded = !!(t || n), e.sprite.tint = e.loaded ? 16777215 : this.placeholderTint(e.el), this.layoutImage(e);
  }
  fillCell(e, t) {
    const n = t.texture.source.resource;
    n && (e.sprite.texture = this.micro.put(e.el.id, n, e.el.w, e.el.h), e.sprite.tint = 16777215, e.loaded = !0, this.layoutImage(e), this.requestRender());
  }
  consider(e, t) {
    if (e.shown !== t) {
      if (e.shown && e.shown.tier > t.tier) {
        const n = Math.max(e.el.w, e.el.h) * this.camera.zoom * this.dpr;
        if (e.shown.tier < n * 4) return;
      }
      this.show(e, t, !e.loaded);
    }
  }
  show(e, t, n) {
    n && !matchMedia("(prefers-reduced-motion: reduce)").matches && (e.under || (e.under = new ks(e.sprite.texture), e.under.tint = e.sprite.tint, this.imageLayer.addChild(e.under)), e.fade = 0, e.sprite.alpha = 0), e.sprite.texture = t.texture, e.sprite.tint = 16777215, e.shown = t, e.loaded = !0, this.layoutImage(e), this.applyVisibility(e), this.requestRender();
  }
  showPlaceholder(e) {
    e.sprite.texture = za(e.el.w, e.el.h), e.sprite.tint = this.placeholderTint(e.el), e.shown = null, e.loaded = !1, this.layoutImage(e);
  }
  /** Advance per-node animations; true while any is still running. */
  animate(e) {
    let t = !1;
    const n = e < this.enteringUntil;
    for (const s of this.visibleIds) {
      const o = this.nodes.get(s);
      if (o) {
        if (o.kind === "image") {
          let r = !1;
          if (o.lift !== o.liftTarget) {
            const a = o.liftTarget - o.lift;
            o.lift = Math.abs(a) < 0.02 ? o.liftTarget : o.lift + a * 0.28, r = !0, t = !0, o.liftTarget > 0 && !o.shadow && (o.shadow = new ete({
              texture: pte(),
              leftWidth: 124,
              rightWidth: 124,
              topHeight: 124,
              bottomHeight: 124
            }), this.imageLayer.addChild(o.shadow)), o.lift === 0 && o.liftTarget === 0 && o.shadow && (o.shadow.destroy(), o.shadow = null);
          }
          o.fade < 1 && (o.fade = Math.min(1, o.fade + 0.09), o.sprite.alpha = Jm(o.fade), o.fade >= 1 && o.under && (o.under.destroy(), o.under = null), t = !0), r && this.layoutImage(o);
        }
        if (n || o.enter) {
          const r = o.enter ? Math.min(1, Math.max(0, (e - o.enter) / r_)) : 1, a = Jm(r), l = o.kind === "image" ? o.sprite : o.kind === "card" ? o.proxy.root : o.g, d = o.kind === "image" ? o.el.y - 4 * o.lift : o.el.y;
          l.y = d + 34 * (1 - a), o.kind === "image" ? o.fade >= 1 && (l.alpha = a) : l.alpha = a, r < 1 ? t = !0 : o.enter = 0;
        }
      }
    }
    return t;
  }
  drawRings() {
    this.ringsDirty = !1;
    const e = this.rings;
    if (e.clear(), !this.selection.size) return;
    const t = this.camera.zoom, n = this.theme === "light";
    for (const s of this.selection) {
      const o = this.nodes.get(s);
      if (!o || o.kind === "card" && !this.far) continue;
      const r = o.el;
      if (this.dragging && r.type === "shape") continue;
      let a = 3, l = 12 * t + 3;
      r.type === "frame" && (l = 24 * t + 3), (r.type === "tool" || r.type === "note" || r.type === "chat") && (l = 16 * t * (r.scale || 1) + 3), r.type === "shape" && (a = r.shape === "line" || r.shape === "arrow" ? 12 : 9, l = 10);
      const d = He(r), c = d.x * t + this.camera.x - a, h = (d.y - (o.kind === "image" ? 4 * o.lift : 0)) * t + this.camera.y - a, f = d.w * t + a * 2, p = d.h * t + a * 2;
      e.roundRect(c - 2.75, h - 2.75, f + 5.5, p + 5.5, l + 2.75), e.stroke({ width: 4, color: o_, alpha: n ? 0.2 : 0.16 }), e.roundRect(c, h, f, p, l), e.stroke({ width: 1.5, color: o_, alpha: 1 });
    }
  }
  recordStats(e, t) {
    if (this.lastFrameAt) {
      const n = e - this.lastFrameAt;
      n < 250 && this.frameTimes.push(n), this.frameTimes.length > 90 && this.frameTimes.shift();
    }
    this.lastFrameAt = e, this.lastRenderMs = t, !(!this.opts.onStats || e - this.statsAt < 250) && (this.statsAt = e, this.opts.onStats(this.currentStats()));
  }
  /** What the stats readout shows, as of the last frame: a feedback report carries it too. */
  currentStats() {
    const e = this.frameTimes.length ? this.frameTimes.reduce((s, o) => s + o, 0) / this.frameTimes.length : 16.7;
    let t = 0;
    for (const s of this.nodes.values()) s.kind === "image" && t++;
    const n = this.textureStats();
    return {
      fps: Math.round(1e3 / e),
      frameMs: Math.round(this.lastRenderMs * 10) / 10,
      visible: this.visibleIds.size,
      images: t,
      textures: n.textures,
      textureMB: n.mb,
      pending: n.pending
    };
  }
}
function Pte() {
  return /* @__PURE__ */ Xt({
    mode: "select",
    selection: [],
    editingNote: null,
    editingTitle: null,
    marquee: null,
    panning: !1,
    dragging: !1,
    addMenu: !1,
    placeMenu: !1,
    canvasMenu: null,
    finder: null,
    boardLinkMenu: null,
    libraryOpen: null,
    shapeKind: "rect",
    shapeArmed: !1,
    shapeMenu: !1,
    shapeStyle: { ...io },
    styleOpen: !1,
    infoAt: null,
    infoSave: !1,
    infoSession: null,
    histOpen: !0,
    miniOpen: !0,
    miniGoing: !1,
    lightCanvas: !1,
    showGrid: !0,
    advOpen: !1,
    ghost: null,
    hoverId: null,
    newThumbs: {},
    recentIds: [],
    pinnedIds: [],
    pinnedModelIds: [],
    cameraViews: [],
    noteTint: "amethyst",
    promptH: null,
    boardMenu: !1,
    ctxMenu: !1,
    keysOpen: !1,
    trashOpen: !1,
    boardHistory: !1,
    chatOpen: null,
    toast: null,
    showStats: !1,
    refTarget: !1,
    eyedropper: null,
    refPulse: null,
    refSession: null,
    refGlow: null,
    studio: null,
    library: { open: !1, sessionId: null, tab: "featured", category: null, query: "", detail: null, levels: [], kind: null, action: null, at: null, editing: null, saveLevels: { board: !0, team: !1 } },
    promptLanded: null,
    promptCardH: 0
  });
}
const Ete = {
  lightCanvas: !1,
  showGrid: !0,
  shapeStyle: { ...io },
  shapeKind: "rect",
  histOpen: !0,
  miniOpen: !0,
  recentIds: [],
  pinnedIds: [],
  pinnedModelIds: [],
  noteTint: "amethyst",
  camera: null,
  promptH: null,
  library: { tab: "featured", category: null },
  pinHintSeen: !1,
  cameraViews: [],
  histSeenAt: null
}, LC = ["recentIds", "pinnedIds", "camera", "histSeenAt"], BC = ["lightCanvas", "showGrid", "shapeStyle", "shapeKind", "histOpen", "miniOpen", "noteTint", "promptH", "library", "pinHintSeen", "pinnedModelIds", "cameraViews"], FC = (i, e) => "rd-board-prefs:" + i + ":" + e, NC = (i) => "rd-board-prefs:" + i;
function Rte(i, e) {
  let t = JSON.parse(JSON.stringify(Ete));
  try {
    const n = JSON.parse(localStorage.getItem(NC(i)) || "{}"), s = JSON.parse(localStorage.getItem(FC(i, e)) || "{}");
    t = { ...t, ...kf(n, BC), ...kf(s, LC) };
  } catch {
  }
  return t;
}
function zte(i, e, t) {
  try {
    localStorage.setItem(NC(i), JSON.stringify(kf(t, BC))), localStorage.setItem(FC(i, e), JSON.stringify(kf(t, LC)));
  } catch {
  }
}
function kf(i, e) {
  const t = {};
  if (!i || typeof i != "object") return t;
  for (const n of e) i[n] !== void 0 && (t[n] = i[n]);
  return t;
}
var $te = Object.defineProperty, Dte = (i, e, t) => e in i ? $te(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, wh = (i, e, t) => Dte(i, typeof e != "symbol" ? e + "" : e, t);
class Ote {
  constructor() {
    wh(this, "bySession", /* @__PURE__ */ new Map()), wh(this, "byId", /* @__PURE__ */ new Map()), wh(this, "rev", /* @__PURE__ */ qe(0)), wh(this, "listeners", /* @__PURE__ */ new Set());
  }
  list(e) {
    return this.bySession.get(e) || [];
  }
  get(e) {
    return this.byId.get(e);
  }
  /** Every result, any session (the tour's Back puts a board back as a step found it). */
  all() {
    return Array.from(this.byId.values());
  }
  get size() {
    return this.byId.size;
  }
  /**
   * Insert or replace, keeping each list newest first. Lists are
   * copy-on-write: a changed session gets a new array, so anything that
   * derives from list() sees the change.
   */
  upsert(e, t = !0) {
    if (!e.length) return;
    const n = /* @__PURE__ */ new Map();
    for (const s of e) {
      const o = this.byId.get(s.id);
      this.byId.set(s.id, s);
      let r = n.get(s.sessionId);
      r || (r = (this.bySession.get(s.sessionId) || []).slice(), n.set(s.sessionId, r));
      const a = o ? r.indexOf(o) : -1;
      a >= 0 ? r[a] = s : r.push(s);
    }
    for (const [s, o] of n)
      o.sort((r, a) => a.createdAt - r.createdAt), this.bySession.set(s, o);
    if (this.rev.value++, xs(this.rev), t) for (const s of this.listeners) s(e);
  }
  /**
   * A run's results as they now are: its placeholders give way to its
   * results, or to nothing if it failed. One change for the lot.
   */
  replaceRun(e, t) {
    const n = [];
    for (const s of this.byId.values()) s.runId === e && !t.some((o) => o.id === s.id) && n.push(s.id);
    n.length && this.drop(n), t.length ? this.upsert(t, !1) : n.length && this.bump();
  }
  /** Every result of a run, in its order. */
  ofRun(e) {
    const t = [];
    for (const n of this.byId.values()) n.runId === e && t.push(n);
    return t.sort((n, s) => n.createdAt - s.createdAt);
  }
  drop(e) {
    const t = /* @__PURE__ */ new Set();
    for (const n of e) {
      const s = this.byId.get(n);
      s && (this.byId.delete(n), t.add(s.sessionId));
    }
    for (const n of t) this.bySession.set(n, (this.bySession.get(n) || []).filter((s) => this.byId.has(s.id)));
  }
  bump() {
    this.rev.value++, xs(this.rev);
  }
  remove(e) {
    const t = /* @__PURE__ */ new Set();
    for (const n of e) {
      const s = this.byId.get(n);
      s && (this.byId.delete(n), t.add(s.sessionId));
    }
    for (const n of t) this.bySession.set(n, (this.bySession.get(n) || []).filter((s) => this.byId.has(s.id)));
    this.rev.value++, xs(this.rev);
  }
  clear() {
    this.bySession.clear(), this.byId.clear(), this.rev.value++, xs(this.rev);
  }
  /** Local changes, for the sync adapter to persist. */
  onLocalChange(e) {
    return this.listeners.add(e), () => this.listeners.delete(e);
  }
}
const UC = 768;
function ir(i) {
  return new Promise((e, t) => {
    const n = new Image(), s = i.startsWith("data:") || i.startsWith("blob:");
    s || (n.crossOrigin = "anonymous"), n.onload = () => e(n), n.onerror = () => t(new Error("stand-in: picture not read")), n.src = s ? i : i + (i.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1";
  });
}
function sr(i, e) {
  if (typeof document == "undefined") return null;
  const t = document.createElement("canvas");
  t.width = Math.max(1, Math.round(i)), t.height = Math.max(1, Math.round(e));
  const n = t.getContext("2d");
  return n ? { c: t, x: n } : null;
}
function mm(i, e = UC) {
  const t = Math.min(1, e / Math.max(i.naturalWidth, i.naturalHeight));
  return { w: Math.round(i.naturalWidth * t), h: Math.round(i.naturalHeight * t) };
}
function Vs(i, e) {
  const t = i[e];
  return typeof t == "number" && Number.isFinite(t) ? t : null;
}
async function Lte(i) {
  const e = await ir(i), t = mm(e), n = sr(t.w, t.h);
  if (!n) return null;
  n.x.drawImage(e, 0, 0, t.w, t.h);
  const s = sr(t.w, t.h), o = s.x.createRadialGradient(t.w / 2, t.h * 0.55, Math.min(t.w, t.h) * 0.22, t.w / 2, t.h * 0.55, Math.min(t.w, t.h) * 0.46);
  return o.addColorStop(0, "rgba(0,0,0,1)"), o.addColorStop(0.85, "rgba(0,0,0,1)"), o.addColorStop(1, "rgba(0,0,0,0)"), s.x.fillStyle = o, s.x.fillRect(0, 0, t.w, t.h), n.x.globalCompositeOperation = "destination-in", n.x.drawImage(s.c, 0, 0), { url: n.c.toDataURL("image/png"), ...t };
}
async function Bte(i) {
  const e = await ir(i), t = 160, n = Math.max(1, Math.round(t * e.naturalHeight / e.naturalWidth)), s = sr(t, n);
  if (!s) return null;
  s.x.drawImage(e, 0, 0, t, n);
  const o = s.x.getImageData(0, 0, t, n).data, r = 7, a = [];
  for (let x = 0; x < r; x++) {
    const w = Math.floor((x + 0.5) / r * t * n) * 4;
    a.push([o[w], o[w + 1], o[w + 2]]);
  }
  const l = new Uint8Array(t * n);
  for (let x = 0; x < 8; x++) {
    const w = a.map(() => [0, 0, 0, 0]);
    for (let S = 0; S < t * n; S++) {
      const M = o[S * 4], _ = o[S * 4 + 1], T = o[S * 4 + 2];
      let k = 0, P = 1 / 0;
      for (let R = 0; R < r; R++) {
        const D = (M - a[R][0]) ** 2 + (_ - a[R][1]) ** 2 + (T - a[R][2]) ** 2;
        D < P && (P = D, k = R);
      }
      l[S] = k;
      const A = w[k];
      A[0] += M, A[1] += _, A[2] += T, A[3]++;
    }
    w.forEach((S, M) => {
      S[3] && (a[M] = [S[0] / S[3], S[1] / S[3], S[2] / S[3]]);
    });
  }
  const d = new Int32Array(t * n).fill(-1), c = [];
  let h = 0;
  const f = [];
  for (let x = 0; x < t * n; x++) {
    if (d[x] >= 0) continue;
    d[x] = h, f.push(x);
    let w = 0;
    for (; f.length; ) {
      const S = f.pop();
      w++;
      const M = S % t, _ = (S - M) / t, T = [M > 0 ? S - 1 : -1, M < t - 1 ? S + 1 : -1, _ > 0 ? S - t : -1, _ < n - 1 ? S + t : -1];
      for (const k of T)
        k < 0 || d[k] >= 0 || l[k] !== l[S] || (d[k] = h, f.push(k));
    }
    c.push(w), h++;
  }
  const p = t * n * 4e-3;
  for (let x = 0; x < 2; x++)
    for (let w = 0; w < t * n; w++) {
      if (c[d[w]] >= p) continue;
      const M = w % t > 0 ? w - 1 : w + 1 < t * n ? w + 1 : w;
      c[d[M]] >= p && (d[w] = d[M]);
    }
  const y = /* @__PURE__ */ new Map(), v = s.x.createImageData(t, n);
  for (let x = 0; x < t * n; x++) {
    let w = y.get(d[x]);
    w === void 0 && (w = y.size + 1, y.set(d[x], w)), v.data[x * 4] = w & 255, v.data[x * 4 + 1] = w >> 8 & 255, v.data[x * 4 + 2] = 0, v.data[x * 4 + 3] = 255;
  }
  return s.x.putImageData(v, 0, 0), { url: s.c.toDataURL("image/png"), w: t, h: n };
}
async function Fte(i, e) {
  const t = await ir(i), n = mm(t), s = sr(n.w, n.h);
  if (!s) return null;
  if (s.x.drawImage(t, 0, 0, n.w, n.h), !e) return { url: s.c.toDataURL("image/jpeg", 0.88), ...n };
  const o = await ir(e), r = sr(n.w, n.h);
  return r.x.filter = "blur(" + Math.round(Math.max(n.w, n.h) / 22) + "px)", r.x.drawImage(t, -n.w * 0.06, -n.h * 0.06, n.w * 1.12, n.h * 1.12), r.x.filter = "none", r.x.globalCompositeOperation = "destination-in", r.x.filter = "blur(3px)", r.x.drawImage(o, 0, 0, n.w, n.h), s.x.drawImage(r.c, 0, 0), { url: s.c.toDataURL("image/jpeg", 0.88), ...n };
}
async function Nte(i, e) {
  const t = await ir(i), n = Vs(e, "canvasWidth"), s = Vs(e, "canvasHeight");
  if (!n || !s) return null;
  const o = Math.min(1, UC / Math.max(n, s)), r = Math.round(n * o), a = Math.round(s * o), l = sr(r, a);
  if (!l) return null;
  const d = (Vs(e, "imageWidth") || t.naturalWidth) * o, c = (Vs(e, "imageHeight") || t.naturalHeight) * o, h = (Vs(e, "imageX") || 0) * o, f = (Vs(e, "imageY") || 0) * o;
  return l.x.filter = "blur(" + Math.round(Math.max(r, a) / 18) + "px) saturate(1.05)", l.x.drawImage(t, -r * 0.05, -a * 0.05, r * 1.1, a * 1.1), l.x.filter = "none", l.x.drawImage(t, h, f, d, c), { url: l.c.toDataURL("image/jpeg", 0.88), w: r, h: a };
}
async function Ute(i, e) {
  var t, n, s;
  const o = await ir(i), r = mm(o), a = sr(r.w, r.h);
  if (!a) return null;
  const l = (t = Vs(e, "rotate")) != null ? t : 45, d = (n = Vs(e, "vertical")) != null ? n : 0, c = (s = Vs(e, "zoom")) != null ? s : 5, h = (l % 360 + 360) % 360, f = h > 180 ? h - 360 : h, p = Math.abs(f) > 120, y = 1 + (c - 5) * 0.06;
  return a.x.fillStyle = "#20222b", a.x.fillRect(0, 0, r.w, r.h), a.x.save(), a.x.translate(r.w / 2, r.h / 2), a.x.transform(1 - Math.abs(Math.sin(f * Math.PI / 180)) * 0.18, Math.sin(f * Math.PI / 180) * 0.12, 0, 1 - d / 90 * 0.12, 0, 0), a.x.scale(p ? -y : y, y), a.x.drawImage(o, -r.w / 2, -r.h / 2, r.w, r.h), a.x.restore(), { url: a.c.toDataURL("image/jpeg", 0.88), ...r };
}
async function Gte(i, e) {
  const t = await ir(i), n = mm(t), s = sr(n.w, n.h);
  if (!s) return null;
  s.x.drawImage(t, 0, 0, n.w, n.h);
  const o = /golden|warm|tungsten|candle|dusk|night/i.test(e), r = /from the (front )?left/i.test(e), a = s.x.createLinearGradient(r ? 0 : n.w, 0, r ? n.w : 0, n.h * 0.4);
  return a.addColorStop(0, o ? "rgba(255,170,80,0.55)" : "rgba(170,200,255,0.5)"), a.addColorStop(1, "rgba(10,8,30,0.55)"), s.x.globalCompositeOperation = "soft-light", s.x.fillStyle = a, s.x.fillRect(0, 0, n.w, n.h), /night|dusk|dark/i.test(e) && (s.x.globalCompositeOperation = "multiply", s.x.fillStyle = "rgba(40,50,110,0.5)", s.x.fillRect(0, 0, n.w, n.h)), { url: s.c.toDataURL("image/jpeg", 0.88), ...n };
}
let kh = null;
function jte() {
  if (kh === null)
    try {
      kh = typeof document != "undefined" && !!document.createElement("canvas").getContext("2d");
    } catch {
      kh = !1;
    }
  return kh;
}
function Hte(i, e, t) {
  return jte() ? i === "removebg" || i === "select" || i === "erase" || i === "expand" || i === "camera" || e === "upscale" || /^Relighting only|^Relight image 1/.test(t) : !1;
}
async function Vte(i, e, t, n, s) {
  const o = t[0];
  if (!o || typeof document == "undefined") return null;
  try {
    if (i === "removebg") return await Lte(o);
    if (i === "select") return await Bte(o);
    if (i === "erase") return await Fte(o, typeof n.__mask == "string" ? n.__mask : null);
    if (i === "expand") return await Nte(o, n);
    if (i === "camera") return await Ute(o, n);
    if (e === "upscale") {
      const r = await ir(o);
      return { url: o, w: r.naturalWidth * 2, h: r.naturalHeight * 2 };
    }
    return /^Relighting only|^Relight image 1/.test(s) ? await Gte(o, s) : null;
  } catch (r) {
    return console.warn("[harness] no stand-in for this tool", r), null;
  }
}
var Wte = Object.defineProperty, qte = (i, e, t) => e in i ? Wte(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, eb = (i, e, t) => qte(i, typeof e != "symbol" ? e + "" : e, t);
const Kte = {
  "1:1": [1, 1],
  "3:4": [3, 4],
  "4:3": [4, 3],
  "16:9": [16, 9],
  "9:16": [9, 16],
  "2:3": [2, 3],
  "3:2": [3, 2]
};
function Uy(i, e = 316) {
  const t = i && Kte[i] || [4, 3];
  return t[0] >= t[1] ? { w: e, h: Math.round(e * t[1] / t[0]) } : { w: Math.round(e * t[0] / t[1]), h: e };
}
class Yte {
  /** `pool`: still images; `videoPool`: videos, each a poster and its playable file */
  constructor(e, t = []) {
    eb(this, "pool", e), eb(this, "videoPool", t), eb(this, "cursor", 0);
  }
  run(e, t) {
    const n = St(), s = e.model.kitId === "video", o = Uy(e.aspect || (s ? "16:9" : "3:4")), r = Math.max(1, Math.round(parseFloat(String(e.inputs.length || "5s")) || 5)), a = s ? Math.floor(r / 60) + ":" + String(r % 60).padStart(2, "0") : void 0, l = Date.now(), d = [];
    for (let v = 0; v < e.count; v++)
      d.push({
        id: St(),
        sessionId: e.sessionId,
        status: "pending",
        url: "",
        w: o.w,
        h: o.h,
        prompt: e.prompt,
        model: e.model.name,
        modelId: e.model.id,
        inputs: e.inputs,
        refs: e.refs,
        seed: Math.floor(Math.random() * 1e9),
        author: e.author,
        createdAt: l + v,
        runId: n,
        parents: e.refs.slice(),
        video: s || void 0,
        dur: a
      });
    const c = [];
    let h = !1;
    const f = /\bfail\b/i.test(e.prompt), p = 1300 + Math.random() * 600, y = [];
    if (f)
      c.push(window.setTimeout(() => {
        h || t.onError("The provider rejected this prompt. No tokens were charged.", d);
      }, p));
    else {
      const v = Hte(e.model.boardTool, e.model.kitId, e.prompt);
      d.forEach((x, w) => {
        c.push(window.setTimeout(async () => {
          if (h) return;
          const S = v ? await Vte(e.model.boardTool, e.model.kitId, e.refs, e.inputs, e.prompt) : null;
          if (h) return;
          const M = !S && s && this.videoPool.length ? this.videoPool[this.cursor++ % this.videoPool.length] : null, _ = S ? S.url : M ? M.poster : this.pool[this.cursor++ % this.pool.length], T = {
            ...x,
            status: "done",
            url: _,
            w: S ? S.w : x.w,
            h: S ? S.h : x.h,
            videoSrc: M ? M.src : void 0,
            dur: a,
            took: Date.now() - l,
            label: Xte(e.prompt, w)
          };
          y.push(T), t.onResult(T), y.length === d.length && t.onDone(y);
        }, p + w * (260 + Math.random() * 220)));
      });
    }
    return {
      runId: n,
      pending: d,
      cancel: () => {
        h = !0;
        for (const v of c) clearTimeout(v);
      }
    };
  }
}
function Xte(i, e) {
  return (String(i || "result").toLowerCase().replace(/[^a-z0-9 ]+/g, " ").trim().split(/\s+/).slice(0, 4).join("_") || "result").slice(0, 24) + "_v" + String(e + 1).padStart(2, "0");
}
const $r = {
  image: "image",
  video: "video",
  imageEdit: "imageEdit",
  videoEdit: "videoEdit",
  upscale: "upscale",
  // Quoted key: an identifier cannot start with a digit, so this kit is
  // always reached as KIT_TYPE['3d'], unlike its dot-accessed siblings.
  "3d": "3d"
}, m0 = [
  $r.image,
  $r.video,
  $r.imageEdit,
  $r.videoEdit,
  $r.upscale,
  $r["3d"]
], a_ = (i) => typeof i == "string" && Object.prototype.hasOwnProperty.call($r, i), Jte = "mdi-shape-outline", tb = "Featured", nb = "Other", GC = (i) => {
  const e = {};
  if (!i || typeof i != "object") return e;
  for (const t of Object.keys(i))
    i[t] && (e[t] = !0);
  return e;
}, Zte = (i, e, t) => {
  if (!i || typeof i != "object") return null;
  const n = i, s = typeof n.label == "string" ? n.label : "", o = typeof n.icon == "string" ? n.icon : "";
  return !s && !o ? null : {
    // Heal a label authored without an id rather than dropping it. The id
    // is an opaque UI key, so a positional fallback is safe and stable
    // for a given stored array.
    id: typeof n.id == "string" && n.id ? n.id : `${t}:${e}`,
    icon: o,
    label: s,
    value: typeof n.value == "number" ? n.value : null,
    type: typeof n.type == "string" ? n.type : void 0,
    tooltip: typeof n.tooltip == "string" ? n.tooltip : void 0
  };
}, Qte = (i) => {
  if (!i || typeof i != "object") return null;
  const e = i, t = typeof e.nodeDefId == "string" ? e.nodeDefId.trim() : "";
  if (!t) return null;
  const n = Array.isArray(e.labels) ? e.labels.map((s, o) => Zte(s, o, t)).filter((s) => s !== null) : [];
  return { nodeDefId: t, tags: GC(e.tags), labels: n };
}, ene = (i, e) => {
  if (!i || typeof i != "object") return null;
  const t = i, n = a_(t.id) ? t.id : a_(e) ? e : null;
  if (!n) return null;
  const s = Array.isArray(t.tools) ? t.tools.map(Qte).filter((o) => o !== null) : [];
  return {
    id: n,
    label: typeof t.label == "string" && t.label ? t.label : n,
    icon: typeof t.icon == "string" && t.icon ? t.icon : Jte,
    description: typeof t.description == "string" ? t.description : "",
    sortOrder: typeof t.sortOrder == "number" ? t.sortOrder : m0.indexOf(n),
    // STRICT. Anything other than an explicit `true` is a draft, matching
    // the Firestore rule and the non-admin query in web
    // (`where('isPublished', '==', true)`), which cannot match a document
    // where the field is missing or null. Read loosely, a half-authored Kit
    // would read as live here while being unreadable to the very users it
    // claims to be published for.
    isPublished: t.isPublished === !0,
    // `=== undefined` rather than `??`: web's webpack-4 parser lints the
    // symlinked shared dist and cannot parse nullish-coalescing.
    publishedAt: t.publishedAt === void 0 ? null : t.publishedAt,
    // Faithful (`=== true`) rather than strict-inverse, deliberately: a Kit
    // whose `isDeleted` is missing is INVISIBLE to users (see
    // `isKitReadableByUsers`) but must still appear in Manage Kits, because
    // an admin is the only one who can repair it. Reading a missing field
    // as deleted here would hide the broken Kit from the person fixing it.
    isDeleted: t.isDeleted === !0,
    deletedAt: t.deletedAt === void 0 ? null : t.deletedAt,
    defaultNodeDefId: typeof t.defaultNodeDefId == "string" && t.defaultNodeDefId ? t.defaultNodeDefId : null,
    surfaces: t.surfaces && typeof t.surfaces == "object" ? GC(t.surfaces) : null,
    tools: s
  };
}, tne = (i) => {
  if (!i || typeof i != "object") return !1;
  const e = i;
  return e.isPublished === !0 && e.isDeleted === !1;
}, nne = (i, e) => {
  if (!e) return !0;
  const t = i.surfaces;
  return !t || !Object.keys(t).length ? !0 : !!t[e];
}, ine = (i) => {
  const e = [];
  for (const s of i)
    for (const o of Object.keys(s.tags))
      e.includes(o) || e.push(o);
  const t = e.filter((s) => s !== tb && s !== nb).sort((s, o) => s.localeCompare(o));
  return [
    ...e.includes(tb) ? [tb] : [],
    ...t,
    ...e.includes(nb) ? [nb] : []
  ].map((s) => ({ key: s, label: s }));
}, sne = (i) => {
  const { nodeDefs: e, isBlocked: t, surface: n, includeUnpublished: s } = i, o = ene(i.kit);
  if (!o || !s && !tne(i.kit) || !nne(o, n)) return null;
  const r = {};
  for (const c of e || [])
    c && typeof c.id == "string" && (r[c.id] = c);
  const a = [], l = {};
  for (const c of o.tools) {
    if (l[c.nodeDefId]) continue;
    const h = r[c.nodeDefId];
    h && (!s && (h.isPublished === !1 || h.isDeleted === !0) || t && t(h) || (l[c.nodeDefId] = !0, a.push({
      value: h.id,
      nodeDefId: h.id,
      text: typeof h.title == "string" ? h.title : "",
      description: typeof h.description == "string" ? h.description : "",
      imageUrl: h.imageUrl || null,
      avatar: h.avatar || null,
      newUntil: h.newUntil === void 0 ? null : h.newUntil,
      sortOrder: typeof h.sortOrder == "number" ? h.sortOrder : 0,
      tags: c.tags,
      labels: c.labels,
      nodeDef: h
    })));
  }
  const d = a.some((c) => c.nodeDefId === o.defaultNodeDefId) ? o.defaultNodeDefId : a.length ? a[0].nodeDefId : null;
  return {
    id: o.id,
    label: o.label,
    icon: o.icon,
    description: o.description,
    sortOrder: o.sortOrder,
    tools: a,
    tags: ine(a),
    defaultNodeDefId: d
  };
}, one = (i) => {
  const e = [];
  for (const t of i.kits || []) {
    const n = sne({ ...i, kit: t });
    n && e.push(n);
  }
  return e.sort((t, n) => t.sortOrder - n.sortOrder || m0.indexOf(t.id) - m0.indexOf(n.id));
}, Ti = {
  image: "YrM1HzvaCa9i1Y62U05t",
  video: "yAF6gcg8KczjQx4XVBgr",
  threed: "tfGE9ARninUX4Ledph0j",
  upscaling: "ZV5i4keWclGqG7zfUMPw",
  app: "bt7aOyhEugBXpHu80JsX",
  pluginEdit: "TN70c8DUV6X82hM8xM9W",
  pluginLayers: "b1fdfcfIpojbCLpks6JI"
}, jC = [
  { id: "image", name: "Image", icon: "Image", desc: "Create images with AI-powered models", prefer: ["Nano Banana Pro", "Nano Banana 2", "ChatGPT Image 2.0", "ChatGPT Image 1.5", "Seedream V5 Lite", "Flux 2 Pro", "Seedream V5 Pro"] },
  { id: "video", name: "Video", icon: "Video", desc: "Generate dynamic videos and animations", prefer: ["Kling 3.0 Pro", "Veo 3.1 Fast", "Kling 2.6 Pro", "LTX 2.3", "Seedance 2.0", "Hailuo 2"] },
  { id: "threed", name: "3D", icon: "Box", desc: "Generate 3D models from images or prompts", prefer: ["Hunyuan3D 3", "Trellis 2", "Rodin Gen-2", "Meshy v7", "Tripo"] },
  { id: "upscale", name: "Upscale", icon: "Maximize2", desc: "Upscale your images and videos", prefer: ["Topaz Generative Upscale", "SeedVR Upscale", "Magnific Upscale", "AuraSR - True Upscaler", "Topaz Video Upscale"] }
];
function HC(i) {
  const e = i.tags || {};
  return (e[Ti.app] || e[Ti.pluginEdit] || e[Ti.pluginLayers]) && !e[Ti.image] && !e[Ti.video] ? null : e[Ti.upscaling] ? "upscale" : e[Ti.threed] ? "threed" : e[Ti.video] ? "video" : e[Ti.image] ? "image" : null;
}
function rne(i) {
  const e = i.tags || {};
  return e[Ti.app] ? null : e[Ti.upscaling] ? "upscale" : e[Ti.threed] ? "threed" : e[Ti.video] ? "video" : "image";
}
function* VC(i) {
  for (const e of i || [])
    e && (e.__rgroup ? yield* VC(e.fields) : e.__rfield && (yield e));
}
function l_(i, e) {
  return Math.abs(i - e) / Math.max(i, e) < 0.04 ? "Square" : i > e ? "RectangleHorizontal" : "RectangleVertical";
}
function ane(i) {
  return (i && (i.text && i.text.options || i.radio && i.radio.options || i.image && i.image.options) || []).map((t) => ({ value: t.value, label: String(t.text != null ? t.text : t.value), image: t.imageUrl }));
}
const lne = [["1:1", 1, 1], ["4:3", 4, 3], ["3:4", 3, 4], ["16:9", 16, 9], ["9:16", 9, 16]];
function dne(i, e) {
  if (i.adminOnly && !e.isAdmin) return null;
  const t = i.display || {}, n = t.primaryForm, s = {
    key: String(i.fieldDefUuid || i.uuid),
    label: i.label || "",
    required: !!i.required,
    defaultValue: i.defaultValue,
    tooltip: i.tooltip,
    placeholder: i.placeholder,
    raw: i
  }, o = (r) => n === "CHIP" ? "chip" : n === "MAIN_ACTION" ? "reference" : n === "PROMPT" ? "prompt" : r;
  switch (i.type) {
    case "PROMPT":
      return e.firstPrompt ? { ...s, kind: "prompt", placement: "prompt", defaultValue: i.defaultValue && typeof i.defaultValue == "object" ? i.defaultValue.value || "" : i.defaultValue || "" } : { ...s, kind: "text", placement: "advanced" };
    case "NEG_PROMPT":
      return { ...s, kind: "negPrompt", placement: "advanced" };
    case "TEXT":
    case "TEXT_AREA":
      return { ...s, kind: "text", placement: n === "PROMPT" && e.firstPrompt ? "prompt" : "advanced" };
    case "BOOLEAN":
      return n === "CHIP" ? { ...s, kind: "select", placement: "chip", icon: "Settings2", options: [{ value: !0, label: "On" }, { value: !1, label: "Off" }], defaultValue: !!i.defaultValue } : { ...s, kind: "boolean", placement: "advanced", defaultValue: !!i.defaultValue };
    case "SINGLE_SELECT": {
      const r = ane(t);
      return r.length ? { ...s, kind: "select", placement: o("advanced"), options: r, defaultValue: i.defaultValue != null ? i.defaultValue : r[0].value } : null;
    }
    case "WIDTH_HEIGHT": {
      if (t.select && Array.isArray(t.select.options) && t.select.options.length) {
        const r = t.select.options.map((a) => ({
          value: t.select.format === "wh" ? { width: a.width, height: a.height } : a.value,
          label: a.text || a.value,
          meta: a.width && a.height ? a.width + "×" + a.height : void 0,
          icon: l_(a.width || 1, a.height || 1)
        }));
        return { ...s, kind: "size", placement: n ? o("chip") : "chip", options: r, defaultValue: i.defaultValue != null ? i.defaultValue : r[0].value };
      }
      if (t.sliders) {
        const [r, a] = t.sliders.max || [1024, 1024], [l, d] = t.sliders.min || [256, 256], c = lne.map(([h, f, p]) => {
          const y = Math.min(r / f, a / p), v = Math.max(l, Math.round(f * y / 64) * 64), x = Math.max(d, Math.round(p * y / 64) * 64);
          return { value: { width: v, height: x }, label: h, meta: v + "×" + x, icon: l_(v, x) };
        });
        return { ...s, kind: "size", placement: "chip", options: c, defaultValue: i.defaultValue || c[0].value };
      }
      return null;
    }
    case "IMG":
      return { ...s, kind: "image", placement: n === "CHIP" || n === "MAIN_ACTION" || e.imageIndex < 3 ? "reference" : "advanced" };
    case "IMGS":
      return { ...s, kind: "images", placement: "reference", maxImages: t.maxImages || 4 };
    case "VIDEO":
    case "ASSET_3D":
      return { ...s, kind: "video", placement: "reference" };
    case "SLIDER":
    case "UPSCALE_FACTOR_SLIDER": {
      if (Array.isArray(t.options) && t.options.length) {
        const r = t.options.map((a) => ({ value: a.value, label: String(a.label) }));
        return { ...s, kind: "select", placement: o("advanced"), icon: "Maximize2", options: r, defaultValue: i.defaultValue != null ? i.defaultValue : r[0].value };
      }
      return { ...s, kind: "slider", placement: o("advanced"), min: t.min, max: t.max, step: t.step || 1 };
    }
    case "CFG":
      return { ...s, kind: "slider", placement: "advanced", min: t.min != null ? t.min : 1, max: t.max != null ? t.max : 20, step: 0.5 };
    case "STEPS":
      return { ...s, kind: "slider", placement: "advanced", min: t.min != null ? t.min : 1, max: t.max != null ? t.max : 50, step: 1 };
    case "SEED":
      return { ...s, kind: "seed", placement: "advanced", defaultValue: i.defaultValue != null ? i.defaultValue : null };
    case "NUM":
      return { ...s, kind: "text", placement: "advanced" };
    case "MODEL_SINGLE_SELECT":
      return { ...s, kind: "model", placement: "chip", icon: "Sparkles", architecture: t.architecture || void 0 };
    default:
      return null;
  }
}
function ku(i, e, t, n = HC(e)) {
  if (!n) return null;
  const s = [];
  let o = !0, r = 0;
  for (const c of VC(e.fields)) {
    const h = dne(c, { isAdmin: t, firstPrompt: o, imageIndex: r });
    h && (h.placement === "prompt" && (o = !1), (h.kind === "image" || h.kind === "images") && r++, s.push(h));
  }
  s.sort((c, h) => d_(c) - d_(h));
  const a = e.staticFields && e.staticFields.numResults || { min: 1, max: 1, defaultValue: 1 }, l = Number(e.costPerResult) || 0, d = Array.isArray(e.costPerResultLogics) && e.costPerResultLogics.length > 0;
  return {
    id: i,
    name: e.title || "Tool",
    desc: e.description,
    kitId: n,
    tokensLabel: une(l) + (d ? "+" : ""),
    tokensPerResult: d ? void 0 : l / 100,
    time: e.averageGenInSeconds ? hne(e.averageGenInSeconds) : void 0,
    fields: s,
    numResults: { min: a.min || 1, max: a.max || 1, def: a.defaultValue || 1 },
    raw: { id: i, costPerResult: l, costPerResultLogics: e.costPerResultLogics || [], sortOrder: e.sortOrder || 0, pricingType: e.pricingType, fields: e.fields || [] },
    boardTool: typeof e.boardTool == "string" && e.boardTool ? e.boardTool : void 0
  };
}
function cne(i, e) {
  const t = [];
  for (const n of i) {
    const s = ku(n.id, n.data, e, HC(n.data) || "tools");
    s && t.push(s);
  }
  return t;
}
function d_(i) {
  return i.placement === "prompt" ? 0 : i.placement === "reference" ? 1 : i.placement === "chip" ? 2 : 3;
}
function une(i) {
  const e = Math.floor(i) / 100;
  return e >= 100 ? String(Math.round(e)) : String(Math.round(e * 10) / 10);
}
function hne(i) {
  return i < 90 ? Math.round(i) + "s" : Math.round(i / 60) + "m";
}
const pne = { "3d": "threed" }, fne = {
  image: "Image",
  video: "Video",
  imageEdit: "Wand2",
  videoEdit: "Clapperboard",
  upscale: "Maximize2",
  "3d": "Box"
};
function mne(i, e, t) {
  const n = e.map((o) => ({ ...o.data, id: o.id })), s = [];
  for (const o of one({ kits: i, nodeDefs: n, surface: "web" })) {
    const r = pne[o.id] || o.id, a = [];
    for (const c of o.tools) {
      const h = ku(c.nodeDefId, c.nodeDef, t, r);
      h && (h.kitTags = Object.keys(c.tags), h.labels = c.labels.map((f) => ({ label: f.label, tooltip: f.tooltip, type: f.type })), a.push(h));
    }
    if (!a.length) continue;
    const l = o.tags.map((c) => c.key).filter((c) => a.some((h) => h.kitTags && h.kitTags.includes(c))), d = a.some((c) => c.id === o.defaultNodeDefId) ? o.defaultNodeDefId : a[0].id;
    s.push({ id: r, name: o.label, icon: fne[o.id] || "Sparkles", desc: o.description, models: a, tags: l, defaultModelId: d });
  }
  return s;
}
const g0 = "Company";
async function WC(i, e, t, n = {}) {
  const s = await i.db.doc("teams/" + e).get(), o = s.exists ? (s.data() || {}).companyId : null;
  if (!o) return [];
  let r = i.db.collection("runnitNodeDefs").where("appType", "==", "RUNNIT").where("type", "==", "COMPANY").where("isDeleted", "==", !1).where("companyIds." + o, "==", !0);
  t.isAdmin || (r = r.where("isPublished", "==", !0));
  const a = await r.get(), l = [];
  for (const d of a.docs) {
    const c = { ...d.data(), id: d.id };
    if (n.isBlocked && n.isBlocked(c)) continue;
    const h = ku(d.id, c, !!t.isAdmin);
    h && (h.kitTags = [g0], l.push(h));
  }
  return l;
}
function gne(i, e) {
  if (!e.length) return i;
  const t = i.kits.map((n) => ({ ...n, models: n.models.slice(), tags: n.tags ? n.tags.slice() : void 0 }));
  for (const n of e) {
    let s = t.find((o) => o.id === n.kitId);
    if (!s) {
      const o = jC.find((r) => r.id === n.kitId);
      if (!o) continue;
      s = { id: o.id, name: o.name, icon: o.icon, desc: o.desc, models: [] }, t.push(s);
    }
    s.models.some((o) => o.id === n.id) || (s.models.push(n), s.tags && !s.tags.includes(g0) && s.tags.unshift(g0));
  }
  return nf(i.source, t, i.all, i.tools || []);
}
function bne(i, e, t) {
  const n = /* @__PURE__ */ new Set();
  for (const o of i) for (const r of o.models) n.add(r.id);
  const s = [];
  for (const o of e) {
    if (n.has(o.id) || !o.data || o.data.isPublished !== !0) continue;
    const r = ku(o.id, o.data, t, rne(o.data));
    r && !r.boardTool && s.push(r);
  }
  return s;
}
async function vne(i, e, t = {}) {
  let n = i.db.collection("runnitNodeDefs").where("appType", "==", "RUNNIT").where("type", "==", "CORE").where("isDeleted", "==", !1);
  e.isAdmin || (n = n.where("isPublished", "==", !0));
  const s = i.db.collection("runnitKits").where("isPublished", "==", !0).where("isDeleted", "==", !1), [o, r] = await Promise.all([
    n.get(),
    s.get().catch((p) => (console.warn("[board] v1 kits unavailable, grouping tools by tag", p), { docs: [] }))
  ]), a = t.isBlocked, l = o.docs.map((p) => ({ id: p.id, data: p.data() })).filter((p) => !a || !a({ ...p.data, id: p.id })), d = mne(r.docs.map((p) => ({ ...p.data(), id: p.id })), l, !!e.isAdmin), c = cne(l, !!e.isAdmin);
  if (d.length) return nf("firestore", d, bne(d, l, !!e.isAdmin), c);
  const h = /* @__PURE__ */ new Map();
  l.forEach((p) => {
    const y = ku(p.id, p.data, !!e.isAdmin);
    y && (h.has(y.kitId) || h.set(y.kitId, []), h.get(y.kitId).push(y));
  });
  const f = jC.map((p) => {
    const y = (h.get(p.id) || []).slice().sort((v, x) => {
      const w = p.prefer.indexOf(v.name), S = p.prefer.indexOf(x.name);
      if (w >= 0 || S >= 0) return (w < 0 ? 999 : w) - (S < 0 ? 999 : S);
      const M = v.raw && v.raw.sortOrder || 0, _ = x.raw && x.raw.sortOrder || 0;
      return M - _ || v.name.localeCompare(x.name);
    });
    return { id: p.id, name: p.name, icon: p.icon, desc: p.desc, models: y };
  }).filter((p) => p.models.length);
  return nf("firestore", f, [], c);
}
var yne = Object.defineProperty, xne = (i, e, t) => e in i ? yne(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, _h = (i, e, t) => xne(i, typeof e != "symbol" ? e + "" : e, t);
function wne(i) {
  return "deleted:" + i;
}
function Ap(i) {
  return "edit:" + i;
}
function c_(i) {
  return "marks:" + i;
}
const bl = { x: 0, y: 0, w: 0, h: 0, z: 0 };
function Bs(i) {
  return i.type === "studio";
}
function kne(i, e) {
  return i === e ? !0 : i && e && typeof i == "object" && typeof e == "object" ? JSON.stringify(i) === JSON.stringify(e) : !1;
}
class _ne {
  constructor(e, t) {
    _h(this, "save", e), _h(this, "who", t), _h(this, "byId", /* @__PURE__ */ new Map()), _h(this, "rev", /* @__PURE__ */ qe(0));
  }
  bump() {
    this.rev.value++, xs(this.rev);
  }
  /** What the board loaded with. */
  load(e) {
    for (const t of e) this.byId.set(t.id, t);
    this.bump();
  }
  /** Someone else changed some (another tab, a teammate). */
  applyRemote(e, t) {
    if (!(!e.length && !t.length)) {
      for (const n of e) this.byId.set(n.id, n);
      for (const n of t) this.byId.delete(n);
      this.bump();
    }
  }
  has(e) {
    return this.byId.has(e);
  }
  get(e) {
    return this.byId.get(e);
  }
  all() {
    return this.rev.value, Array.from(this.byId.values());
  }
  /** A session's records. */
  forSession(e) {
    return this.all().filter((t) => t.sessionId === e);
  }
  /** Add a record, or replace one whole. Unchanged, it writes nothing. */
  put(e) {
    const t = this.byId.get(e.id), n = { updatedAt: Date.now(), updatedBy: this.who() };
    if (!t) {
      const c = { ...e, ...n };
      this.byId.set(e.id, c), this.bump(), this.save({ origin: "local", ephemeral: !1, label: "Studio record", added: [c], updated: [], removed: [] });
      return;
    }
    const s = {}, o = {}, r = t, a = e;
    for (const c of /* @__PURE__ */ new Set([...Object.keys(r), ...Object.keys(a)]))
      c === "updatedAt" || c === "updatedBy" || kne(r[c], a[c]) || (s[c] = r[c], o[c] = a[c]);
    if (!Object.keys(o).length) return;
    const l = { ...e, ...n };
    this.byId.set(e.id, l), this.bump(), Object.assign(o, n);
    const d = { id: e.id, el: l, before: s, after: o };
    this.save({ origin: "local", ephemeral: !1, label: "Studio record", added: [], updated: [d], removed: [] });
  }
  /** Change some of a record's fields. */
  patch(e, t) {
    const n = this.byId.get(e);
    n && this.put({ ...n, ...t });
  }
  /** Into Recently Deleted. */
  remove(e) {
    const t = [];
    for (const n of e) {
      const s = this.byId.get(n);
      s && (this.byId.delete(n), t.push(s));
    }
    t.length && (this.bump(), this.save({ origin: "local", ephemeral: !1, label: "Studio record", added: [], updated: [], removed: t }));
  }
  /** Back from Recently Deleted, as they were. */
  restore(e) {
    const t = e.filter((n) => !this.byId.has(n.id));
    if (t.length) {
      for (const n of t) this.byId.set(n.id, n);
      this.bump(), this.save({ origin: "local", ephemeral: !1, label: "Studio record", added: t, updated: [], removed: [] });
    }
  }
}
function Sne(i) {
  if ("nodeRunResult" in i) {
    const t = i.nodeRunResult, n = typeof t.nodeRunId == "string" ? t.nodeRunId : "", s = typeof t.uuid == "string" ? t.uuid : "";
    return n && s ? { kind: "result", nodeRunId: n, resultUuid: s, variant: "file" } : null;
  }
  const e = typeof i.upload.id == "string" ? i.upload.id : "";
  return e ? { kind: "upload", uploadId: e } : null;
}
function oo(i) {
  return i ? i.fields.filter((e) => e.placement === "reference" && (e.kind === "image" || e.kind === "images")) : [];
}
function zo(i) {
  return oo(i).reduce((e, t) => e + Zs(t), 0);
}
function Mne(i) {
  const e = oo(i);
  if (e.length < 2) return [];
  const t = [];
  for (const n of e) for (let s = 0; s < Zs(n); s++) t.push(n.label);
  return t;
}
function _f(i) {
  return zo(i) > 0;
}
function qC(i, e, t) {
  if (e === "prompt") {
    const o = i.kits.find((r) => r.id === t) || i.kits.find((r) => r.id === "image") || i.kits[0];
    return o ? o.models : [];
  }
  const n = /* @__PURE__ */ new Set(), s = [];
  for (const o of i.kits)
    if (o.id === "image")
      for (const r of o.models)
        n.has(r.id) || !_f(r) || (n.add(r.id), s.push(r));
  return s;
}
function Gy(i) {
  return i.fields.find((e) => e.placement === "reference") || null;
}
function Sf(i, e) {
  if (!i) return [];
  const t = Gy(i), n = [];
  for (const s of oo(i)) {
    const o = e.inputs ? e.inputs[s.key] : void 0;
    if (s.kind === "images" && Array.isArray(o)) {
      for (const a of o) typeof a == "string" && a && n.push(a);
      continue;
    }
    const r = s === t ? e.ref : o;
    typeof r == "string" && r && n.push(r);
  }
  return n;
}
function _d(i, e, t) {
  const n = Gy(i), s = { ...e.inputs || {} }, o = { ...e.assets || {} };
  let r = n && oo(i).includes(n) ? null : e.ref || null, a = 0;
  for (const l of oo(i)) {
    delete s[l.key];
    const d = t.slice(a, a + Zs(l));
    if (a += d.length, !d.length) continue;
    for (const h of d) h.asset && (o[h.url] = h.asset);
    const c = d.map((h) => h.url);
    l === n ? (r = c[0], c.length > 1 && (s[l.key] = c)) : s[l.key] = l.kind === "images" ? c : c[0];
  }
  return { ...e, ref: r, inputs: s, assets: o };
}
function Tne(i, e) {
  const t = e.assets || {}, n = [], s = Gy(i);
  for (const o of oo(i)) {
    if (o.kind !== "images") continue;
    const r = e.inputs ? e.inputs[o.key] : void 0, a = Array.isArray(r) ? r : o === s && e.ref ? [e.ref] : [];
    let l = -1;
    a.forEach((d, c) => {
      const h = t[d];
      (!h || "upload" in h) && (l = c);
    }), a.forEach((d, c) => {
      const h = t[d];
      c < l && h && "nodeRunResult" in h && !n.includes(d) && n.push(d);
    });
  }
  return n;
}
const Cne = /(?:^|\s)(\d+(?:\.\d+)?)\s*[:x×]\s*(\d+(?:\.\d+)?)$/;
function Mf(i) {
  if (i.value && typeof i.value == "object") {
    const e = i.value, t = Number(e.width), n = Number(e.height);
    if (t > 0 && n > 0) return t / n;
  }
  for (const e of [typeof i.value == "string" ? i.value : "", i.label, i.meta || ""]) {
    const t = Cne.exec(String(e).trim());
    if (t && Number(t[2]) > 0) return Number(t[1]) / Number(t[2]);
  }
  return null;
}
const Ine = /match|auto|input|original/i;
function jy(i) {
  return Ine.test(String(i.label) + " " + String(typeof i.value == "string" ? i.value : ""));
}
function Hy(i) {
  for (const e of i.fields) {
    if (e.kind === "size") return e;
    if (e.kind !== "select" || !e.options) continue;
    const t = e.options.filter((n) => Mf(n) != null).length;
    if (t >= 2 || t >= 1 && e.options.some(jy)) return e;
  }
  return null;
}
function Ane(i) {
  if (i.value && typeof i.value == "object") {
    const t = i.value, n = Number(t.width) * Number(t.height);
    if (n > 0) return n;
  }
  const e = /(\d+)\s*[×x]\s*(\d+)/.exec(i.meta || "");
  return e ? Number(e[1]) * Number(e[2]) : null;
}
function Pne(i) {
  const e = /^(\d+(?:\.\d+)?K)\b/i.exec(String(i.label).trim());
  return e ? e[1].toUpperCase() : i.meta || String(i.label);
}
function KC(i, e, t) {
  const n = Hy(i);
  if (!n || !n.options || !e || !t || n.options.some(jy)) return [];
  const s = Math.log(e / t);
  let o = null;
  for (const l of n.options) {
    const d = Mf(l);
    d != null && (o == null || Math.abs(Math.log(d) - s) < Math.abs(Math.log(o) - s)) && (o = d);
  }
  if (o == null) return [];
  const r = o, a = n.options.filter((l) => {
    const d = Mf(l);
    return d != null && Math.abs(Math.log(d) - Math.log(r)) < 1e-6;
  }).map((l) => ({ o: l, px: Ane(l) }));
  return a.length < 2 || a.some((l) => l.px == null) ? [] : (a.sort((l, d) => l.px - d.px), a.map(({ o: l, px: d }) => ({ label: Pne(l), value: l.value, meta: l.meta, px: d })));
}
function Ene(i, e, t, n = 0) {
  const s = Hy(i);
  if (!s || !s.options || !s.options.length || !e || !t) return null;
  const o = s.options.find(jy);
  if (o) return { key: s.key, value: o.value };
  const r = KC(i, e, t);
  if (r.length) return { key: s.key, value: r[Math.max(0, Math.min(n, r.length - 1))].value };
  const a = Math.log(e / t);
  let l = s.options[0], d = 1 / 0;
  for (const c of s.options) {
    const h = Mf(c);
    if (h == null) continue;
    const f = Math.abs(Math.log(h) - a);
    f < d && (d = f, l = c);
  }
  return { key: s.key, value: l.value };
}
const Pp = { rotate: 45, vertical: 0, zoom: 5 }, Tf = 50, Vy = 60;
function Rne(i, e) {
  const t = ro(i), n = ro(e);
  return t.rotate === n.rotate && t.vertical === n.vertical && t.zoom === n.zoom;
}
function zne(i) {
  if (!i || typeof i != "object") return null;
  const e = i;
  if (typeof e.id != "string" || !e.id || typeof e.name != "string") return null;
  const t = ro({ rotate: Number(e.rotate), vertical: Number(e.vertical), zoom: Number(e.zoom) });
  return { id: e.id, name: e.name.slice(0, Vy), ...t, createdAt: Number(e.createdAt) || 0 };
}
const $ne = -30, Dne = 90, One = 0, Lne = 10, b0 = [0, 45, 90, 135, 180, 225, 270, 315], Bne = ["Front", "Front right", "Right side", "Back right", "Back", "Back left", "Left side", "Front left"], Cf = [
  { at: -30, name: "Low, looking up" },
  { at: 0, name: "Eye level" },
  { at: 30, name: "Slightly above" },
  { at: 60, name: "High above" },
  { at: 90, name: "Overhead" }
], YC = [
  { at: 0, name: "Wide" },
  { at: 5, name: "Medium" },
  { at: 10, name: "Close-up" }
], Fne = 0.9, Nne = "same scene and subject, same materials, colours and lighting", Une = "different person, changed clothing, distorted face, extra limbs, warped architecture";
function _u(i) {
  const e = (i % 360 + 360) % 360;
  return Math.round(e * 1e3) / 1e3;
}
function Wy(i) {
  const e = _u(i);
  return e > 180 ? e - 360 : e;
}
function u_(i, e, t) {
  return Math.min(t, Math.max(e, i));
}
function ro(i) {
  const e = Number.isFinite(i.rotate) ? i.rotate : Pp.rotate, t = Number.isFinite(i.vertical) ? i.vertical : Pp.vertical, n = Number.isFinite(i.zoom) ? i.zoom : Pp.zoom, s = _u(e);
  return { rotate: s === 360 ? 0 : s, vertical: u_(t, $ne, Dne), zoom: u_(n, One, Lne) };
}
function Gne(i) {
  return Math.round(_u(i) / 45) % 8;
}
function qy(i, e, t) {
  let n = i, s = t;
  for (const o of e) {
    const r = Math.abs(o - i);
    r <= s && (s = r, n = o);
  }
  return n;
}
function h_(i, e = 7) {
  const t = qy(_u(i), [...b0, 360], e);
  return t === 360 ? 0 : t;
}
function p_(i, e = 6) {
  return qy(i, Cf.map((t) => t.at), e);
}
function jne(i, e = 0.6) {
  return qy(i, YC.map((t) => t.at), e);
}
function Hne(i, e) {
  return e.reduce((t, n) => Math.abs(n.at - i) < Math.abs(t.at - i) ? n : t);
}
function v0(i) {
  return Bne[Gne(i)];
}
function y0(i) {
  return Hne(i, Cf).name;
}
function XC(i) {
  return i <= 3 ? "Wide" : i >= 7 ? "Close-up" : "Medium";
}
function kc(i) {
  const e = ro(i);
  return v0(e.rotate) + ", " + y0(e.vertical).toLowerCase() + ", " + XC(e.zoom).toLowerCase();
}
function JC(i) {
  return Math.abs(Wy(i.rotate)) > 90;
}
function Vne(i, e) {
  const t = ro(i), n = {
    rotate: t.rotate,
    vertical: t.vertical,
    zoom: t.zoom,
    keep: Nne,
    avoid: Une,
    loraScale: Fne
  };
  return e != null && (n.seed = e), n;
}
const Wne = "/internal/library-prompts", qne = 40, ZC = 100, Kne = 80, Yne = ["me", "board", "team", "company"];
function $a(i) {
  return i && i.trim() ? i.trim() : null;
}
function Xne(i) {
  const e = new URLSearchParams(), t = $a(i.teamId);
  t && e.set("team_id", t);
  const n = $a(i.boardId);
  n && e.set("board_id", n);
  const s = Yne.filter((d) => i.levels.includes(d));
  s.length && e.set("level", s.join(","));
  const o = $a(i.category);
  o && e.set("category", o.slice(0, Kne));
  const r = $a(i.query);
  r && e.set("q", r.slice(0, j1)), i.kind && e.set("kind", i.kind), i.onlyKind && e.set("only_kind", i.onlyKind), i.onlyAction && e.set("only_action", i.onlyAction), i.mine && e.set("author", "me");
  const a = $a(i.toolId);
  a && e.set("tool_id", a);
  const l = $a(i.cursor);
  return l && e.set("cursor", l), e.set("limit", String(Math.min(ZC, Math.max(1, Math.floor(i.limit) || 1)))), e;
}
function Pn(i) {
  return i !== null && typeof i == "object" && !Array.isArray(i) ? i : null;
}
const Pt = (i) => typeof i == "string" ? i : "", Si = (i) => typeof i == "number" && Number.isFinite(i) ? i : 0, f_ = (i) => {
  const e = typeof i == "string" ? Date.parse(i) : NaN;
  return Number.isFinite(e) ? e : 0;
};
function Jne(i) {
  const e = Pn(i), t = e ? Pt(e.id) : "";
  if (!e || !t || !Pt(e.author_id) || !Pt(e.prompt)) return null;
  const n = Pn(e.tool) || {}, s = Pn(e.output) || {}, o = Array.isArray(e.inputs) ? e.inputs.map(Pn).filter((a) => !!a && !!Pt(a.url)).map((a) => ({ label: Pt(a.label), role: Pt(a.role), title: Pt(a.title) || void 0, kind: a.kind === "markup" ? "markup" : "reference", url: Pt(a.url) })) : [], r = f_(e.created);
  return {
    id: t,
    name: Pt(e.name) || "Untitled prompt",
    category: Pt(e.category),
    description: Pt(e.description),
    prompt: Pt(e.prompt),
    mode: Pt(e.mode) || yu(o.length),
    tags: Array.isArray(e.tags) ? e.tags.filter((a) => typeof a == "string") : [],
    kind: e.kind === "video" ? "video" : "image",
    tool: { nodeDefId: Pt(n.node_def_id), name: Pt(n.name) },
    output: { url: Pt(s.url), w: Si(s.w), h: Si(s.h), thumb: Pt(s.thumb) || void 0, video: Pt(s.video) || void 0 },
    inputs: o,
    authorId: Pt(e.author_id),
    authorName: Pt(e.author_name),
    boardId: Pt(e.board_id) || null,
    teamId: Pt(e.team_id) || null,
    companyId: Pt(e.company_id) || null,
    values: Pn(e.values),
    // not mirrored: the document has it, and an edit reads the document
    run: null,
    createdAt: r,
    updatedAt: f_(e.updated) || r
  };
}
function Zne(i) {
  const e = Pn(i);
  if (!e) return null;
  const t = Pn(e.levels) || {}, n = Pn(e.kinds), s = Array.isArray(e.categories) ? e.categories.map(Pn).filter((l) => !!l && !!Pt(l.label)).map((l) => ({ label: Pt(l.label), count: Si(l.count) })) : [], o = Pn(e.actions), r = (l) => {
    const d = Pn(l) || {};
    return { generate: Si(d.generate), edit: Si(d.edit) };
  }, a = Array.isArray(e.groups) ? e.groups.map(Pn).filter((l) => !!l && (l.kind === "image" || l.kind === "video") && (l.action === "generate" || l.action === "edit")).map((l) => ({ kind: l.kind, action: l.action, label: Pt(l.label), count: Si(l.count) })) : null;
  return {
    total: Si(e.total),
    levels: { me: Si(t.me), board: Si(t.board), team: Si(t.team), company: Si(t.company) },
    // an API from before the Image and Video filter doesn't count them
    ...n ? { kinds: { image: Si(n.image), video: Si(n.video) } } : {},
    // nor one from before Generate and Edit (IL-103)
    ...o ? { actions: { image: r(o.image), video: r(o.video) } } : {},
    categories: s,
    ...a ? { groups: a } : {}
  };
}
function Qne(i) {
  const e = Pn(i);
  if (!e) return null;
  const t = Pn(e.team), n = Pn(e.company);
  return {
    team: t && Pt(t.id) ? { id: Pt(t.id), manage: t.manage === !0 } : null,
    company: n && Pt(n.id) ? { id: Pt(n.id), name: Pt(n.name) || null, manage: n.manage === !0 } : null
  };
}
function eie(i) {
  const e = Pn(i) || {};
  return {
    prompts: Array.isArray(e.data) ? e.data.map(Jne).filter((t) => t !== null) : [],
    nextCursor: Pt(e.next_cursor) || null,
    hasMore: !!e.has_more,
    counts: Zne(e.counts),
    access: Qne(e.access)
  };
}
async function tie(i) {
  var e;
  try {
    const t = Pn((e = Pn(await i.json())) == null ? void 0 : e.error) || {};
    return {
      code: typeof t.code == "string" ? t.code : void 0,
      message: typeof t.message == "string" ? t.message : void 0
    };
  } catch {
    return {};
  }
}
async function nie(i, e, t, n = window.fetch.bind(window)) {
  const s = i.replace(/\/$/, "") + Wne + "?" + Xne(t).toString();
  let o;
  try {
    o = await n(s, { method: "GET", headers: { Authorization: "Bearer " + e.idToken, "X-Device-Id": e.deviceId } });
  } catch {
    return { ok: !1, reason: "network" };
  }
  if (!o.ok) {
    const { code: r, message: a } = await tie(o);
    return { ok: !1, reason: r === "INVALID_CURSOR" ? "stale-cursor" : o.status === 401 ? "unauthorized" : o.status === 403 ? "forbidden" : "failed", ...r ? { code: r } : {}, message: a || "HTTP " + o.status };
  }
  try {
    return { ok: !0, page: eie(await o.json()) };
  } catch {
    return { ok: !1, reason: "failed", message: "Invalid JSON" };
  }
}
var iie = Object.defineProperty, sie = (i, e, t) => e in i ? iie(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, _n = (i, e, t) => sie(i, typeof e != "symbol" ? e + "" : e, t);
const oie = 2e4;
function rie(i, e) {
  return JSON.stringify(i) === JSON.stringify(e);
}
class aie {
  constructor(e, t = {}) {
    _n(this, "shelf", e), _n(this, "opts", t), _n(this, "rows", /* @__PURE__ */ qe([])), _n(this, "state", /* @__PURE__ */ qe("idle")), _n(this, "counts", /* @__PURE__ */ qe(null)), _n(this, "access", /* @__PURE__ */ qe(null)), _n(this, "hasMore", /* @__PURE__ */ qe(!1)), _n(this, "loadingMore", /* @__PURE__ */ qe(!1)), _n(this, "ask", null), _n(this, "fetched", []), _n(this, "cursor", null), _n(this, "version", 0), _n(this, "stale", !1), _n(this, "shown", !1), _n(this, "followed", /* @__PURE__ */ new Map()), _n(this, "pinned", /* @__PURE__ */ new Map()), _n(this, "hidden", /* @__PURE__ */ new Map()), _n(this, "lastWrite", 0), _n(this, "lagTimer", null);
  }
  get pageSize() {
    return this.opts.pageSize || qne;
  }
  /**
   * Ask for the first page, with these filters. The same ask again is
   * answered by what's here, unless it failed, it was refreshed, or a write
   * since needs the mirror's word.
   */
  query(e) {
    return this.ask && rie(this.ask, e) && !this.stale && (this.state.value === "ready" || this.state.value === "loading") ? Promise.resolve() : (this.ask = e, this.firstPage());
  }
  /** The next ask goes to the API even if it's the same: the panel opened again, and others may have saved since. */
  refresh() {
    this.stale = !0;
  }
  /** The next page, when there is one. */
  async loadMore() {
    const e = this.ask;
    if (!e || !this.cursor || this.loadingMore.value || this.state.value !== "ready") return;
    const t = this.version;
    this.loadingMore.value = !0;
    const n = await this.shelf.list({ ...e, cursor: this.cursor, limit: this.pageSize });
    if (t !== this.version) return;
    if (this.loadingMore.value = !1, !n.ok) {
      if (n.reason === "stale-cursor") return this.firstPage();
      console.warn("[board] more of my prompts unavailable", n);
      return;
    }
    const s = new Set(this.fetched.map((o) => o.id));
    this.fetched = this.fetched.concat(n.page.prompts.filter((o) => !s.has(o.id))), this.cursor = n.page.nextCursor, this.hasMore.value = n.page.hasMore, this.recompute();
  }
  /** While the panel shows the list, each prompt it holds follows its document. */
  setShown(e) {
    this.shown !== e && (this.shown = e, e ? this.follow() : this.unfollowAll());
  }
  /** A prompt saved (no `before`) or edited here: shown at once, first when it fits the filters. */
  pin(e, t) {
    this.pinned.set(e.id, e), this.hidden.delete(e.id), this.counts.value = hg(this.counts.value, t, e, this.boardId()), this.wrote();
  }
  /** A prompt deleted here: gone at once. */
  drop(e) {
    this.hidden.has(e.id) || (this.counts.value = hg(this.counts.value, e, null, this.boardId())), this.hidden.set(e.id, Date.now()), this.pinned.delete(e.id), this.wrote();
  }
  /** A delete undone (or refused): back at once. */
  undrop(e) {
    this.hidden.delete(e.id) && (this.findHeld(e.id) || this.pinned.set(e.id, e), this.counts.value = hg(this.counts.value, null, e, this.boardId()), this.wrote());
  }
  /**
   * A prompt the list holds, as it is now; null when it doesn't, or it's gone.
   * Read through the rows, so a view that shows one (the detail) changes with it.
   */
  get(e) {
    const t = this.rows.value.find((n) => n.id === e);
    return t || (!e || this.hidden.has(e) ? null : this.findHeld(e));
  }
  /** Whether this prompt is as its document says (followed), rather than as the API listed it. */
  isLive(e) {
    const t = this.followed.get(e);
    return !!t && !!t.prompt;
  }
  /** Every prompt the list knows of: for spotting a name or a prompt you have, before the API answers. */
  known() {
    const e = /* @__PURE__ */ new Map();
    for (const t of this.fetched) e.set(t.id, t);
    for (const t of this.pinned.values()) e.set(t.id, t);
    for (const [t, n] of this.followed) n.prompt && e.set(t, n.prompt);
    for (const t of this.hidden.keys()) e.delete(t);
    return Array.from(e.values());
  }
  dispose() {
    this.version++, this.unfollowAll(), this.lagTimer && clearTimeout(this.lagTimer), this.lagTimer = null;
  }
  // ------------------------------------------------------------- inside
  async firstPage() {
    const e = this.ask;
    if (!e) return;
    const t = ++this.version, n = Date.now();
    this.stale = !1, this.loadingMore.value = !1, this.state.value !== "ready" && (this.state.value = "loading");
    const s = await this.shelf.list({ ...e, cursor: null, limit: this.pageSize });
    if (t !== this.version) return;
    if (!s.ok) {
      console.warn("[board] my prompts unavailable", s), this.state.value = "failed";
      return;
    }
    const o = s.page;
    this.fetched = o.prompts, this.cursor = o.nextCursor, this.hasMore.value = o.hasMore, o.counts && (!this.counts.value || n - this.lastWrite >= this.lagMs) && (this.counts.value = o.counts), o.access !== void 0 && (this.access.value = o.access);
    for (const r of o.prompts) this.pinned.delete(r.id);
    for (const [r, a] of this.hidden) n - a >= this.lagMs && this.hidden.delete(r);
    this.state.value = "ready", this.recompute();
  }
  /** The board the list is asked for, whose prompts are "This board"'s. */
  boardId() {
    return this.ask ? this.ask.boardId : null;
  }
  findHeld(e) {
    const t = this.followed.get(e);
    return t && t.prompt ? t.prompt : t && t.prompt === null ? null : this.pinned.get(e) || this.fetched.find((n) => n.id === e) || null;
  }
  recompute() {
    const e = this.ask, t = [], n = /* @__PURE__ */ new Set(), s = (o) => {
      if (n.has(o.id) || this.hidden.has(o.id)) return;
      n.add(o.id);
      const r = this.followed.get(o.id);
      t.push(r && r.prompt ? r.prompt : o);
    };
    if (e) {
      const o = Array.from(this.pinned.values()).sort((r, a) => a.updatedAt - r.updatedAt);
      for (const r of o) {
        const a = this.findHeld(r.id) || r;
        tW(a, { ...e, limit: this.pageSize }) && s(a);
      }
    }
    for (const o of this.fetched) s(o);
    this.rows.value = t, this.shown && this.follow();
  }
  /** Follow exactly what's shown: start the new ones, stop the ones that went. */
  follow() {
    const e = new Set(this.rows.value.map((t) => t.id));
    for (const [t, n] of this.followed)
      e.has(t) || (n.stop(), this.followed.delete(t));
    for (const t of e) {
      if (this.followed.has(t)) continue;
      const n = { prompt: void 0, failed: !1, stop: () => {
      } };
      this.followed.set(t, n);
      try {
        n.stop = this.shelf.follow(t, (s) => this.heard(t, n, s), (s) => {
          s.code !== "permission-denied" && console.warn("[board] could not follow a saved prompt", t, s), n.failed = !0;
        });
      } catch (s) {
        console.warn("[board] could not follow a saved prompt", t, s), n.failed = !0;
      }
    }
  }
  heard(e, t, n) {
    this.followed.get(e) === t && (t.prompt = n, n || (this.hidden.set(e, Date.now()), this.pinned.delete(e)), this.recompute());
  }
  unfollowAll() {
    for (const e of this.followed.values()) e.stop();
    this.followed.clear();
  }
  /** A write of yours: what's shown changes now, and the list asks again once the mirror has it. */
  wrote() {
    this.lastWrite = Date.now(), this.recompute(), this.lagTimer && clearTimeout(this.lagTimer), this.lagTimer = setTimeout(() => {
      this.lagTimer = null, this.shown ? this.firstPage() : this.stale = !0;
    }, this.lagMs);
  }
  get lagMs() {
    return this.opts.lagMs !== void 0 ? this.opts.lagMs : oie;
  }
}
var lie = Object.defineProperty, die = (i, e, t) => e in i ? lie(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, ji = (i, e, t) => die(i, typeof e != "symbol" ? e + "" : e, t);
function Dr(i) {
  return "authorId" in i;
}
const Sh = () => Promise.reject(new Error("Saving prompts isn't available here")), cie = {
  list: () => Promise.resolve({ ok: !0, page: { prompts: [], nextCursor: null, hasMore: !1, counts: { total: 0, levels: { me: 0, board: 0, team: 0, company: 0 }, categories: [] }, access: null } }),
  follow: () => () => {
  },
  save: Sh,
  update: Sh,
  remove: Sh,
  restore: Sh,
  teamName: () => Promise.resolve(null)
};
class uie {
  constructor(e, t, n = null) {
    ji(this, "b", e), ji(this, "source", t), ji(this, "shelf", n), ji(this, "featured", /* @__PURE__ */ qe(null)), ji(this, "state", /* @__PURE__ */ qe("idle")), ji(this, "scroll", {}), ji(this, "loading", null), ji(this, "myPrompts"), ji(this, "mine"), ji(this, "mineState"), ji(this, "team", /* @__PURE__ */ qe(null)), this.myPrompts = new aie(n || cie), this.mine = this.myPrompts.rows, this.mineState = this.myPrompts.state;
  }
  /** Saving is offered where prompts can be kept. */
  get canSave() {
    return !!this.shelf;
  }
  dispose() {
    this.myPrompts.dispose();
  }
  /** Read the Featured set, once (again after a failure). */
  load() {
    if (this.loading) return this.loading;
    if (this.state.value === "ready") return Promise.resolve();
    if (!this.source)
      return this.state.value = "ready", Promise.resolve();
    this.state.value = "loading";
    const e = this.source.load().then((t) => {
      this.featured.value = t, this.state.value = "ready";
    }).catch((t) => {
      console.warn("[board] featured prompts unavailable", t), this.state.value = "failed";
    }).then(() => {
      this.loading = null;
    });
    return this.loading = e, e;
  }
  prompt(e) {
    const t = this.featured.value;
    return e && t && t.prompts.find((n) => n.id === e) || null;
  }
  /** A saved prompt My prompts holds, as it is now. */
  myPrompt(e) {
    return this.myPrompts.get(e);
  }
  // -------------------------------------------------------------- my prompts
  /** The team a prompt can be shared with on this board. */
  teamId() {
    return this.b.meta.teamId || this.b.user.teamId || null;
  }
  /** What My prompts asks for: what's yours or shared here, through the panel's filters. */
  mineAsk() {
    const e = this.b.ui.library, t = this.session(e.sessionId);
    return {
      uid: this.b.user.uid,
      boardId: this.b.meta.id,
      teamId: this.teamId(),
      levels: e.levels.slice(),
      category: e.category,
      query: e.query.trim(),
      kind: t ? Ja(t.kitId) : null,
      onlyKind: e.kind,
      onlyAction: e.kind ? e.action : null,
      mine: !1,
      toolId: null
    };
  }
  /** Ask for My prompts as the panel's filters stand (the same ask again is answered by what's here). */
  startMine() {
    this.myPrompts.query(this.mineAsk());
    const e = this.teamId();
    !this.shelf || !e || this.team.value && this.team.value.id === e || (this.team.value = { id: e, name: null }, this.shelf.teamName(e).then((t) => {
      this.team.value && this.team.value.id === e && (this.team.value = { id: e, name: t });
    }));
  }
  /** The categories My prompts uses, most used first: everything you can read here, not just what's loaded. */
  mineCategories() {
    const e = this.myPrompts.counts.value;
    return e ? e.categories.map((t) => t.label) : JV(this.myPrompts.known());
  }
  /** Your own prompts that hold every word of a search (the API's answer; none when it can't be asked). */
  async yours(e, t = null) {
    if (!this.shelf || !e) return [];
    const n = { ...this.mineAsk(), levels: [], category: null, query: e, kind: null, onlyKind: null, onlyAction: null, mine: !0, toolId: t, cursor: null, limit: ZC }, s = await this.shelf.list(n);
    return s.ok ? s.page.prompts : [];
  }
  // ---------------------------------------------------- who manages what (IL-101)
  /** Who manages the shared levels here, as the API said for this board's team; null until it has. */
  access() {
    const e = this.myPrompts.access.value;
    return e && e.team && e.team.id === this.teamId() ? e : null;
  }
  /** You may share with this board's team, and edit or remove what's shared with it: its library is yours to manage, or the company's is. */
  managesTeam() {
    const e = this.access();
    return !!e && !!e.team && (e.team.manage || !!e.company && e.company.manage);
  }
  /** The company prompts can be shared with here: this board's team's. */
  company() {
    const e = this.access();
    return e && e.company ? { id: e.company.id, name: e.company.name } : null;
  }
  /** You may share with the whole company, and edit or remove what's shared in it. */
  managesCompany() {
    const e = this.access();
    return !!e && !!e.company && e.company.manage;
  }
  /** Who may edit or delete a saved prompt here: whoever saved it, and whoever manages a library it's shared with. */
  canEdit(e) {
    if (e.authorId === this.b.user.uid) return !0;
    const t = this.access();
    return t ? e.teamId && t.team && e.teamId === t.team.id && this.managesTeam() ? !0 : !!e.companyId && !!t.company && e.companyId === t.company.id && t.company.manage : !1;
  }
  /**
   * A draft's levels from the save form's toggles (none: Only me). A toggle
   * the form left as it found it (`was`) keeps that level as it was, so
   * editing a prompt filed on another board, or shared with another team or
   * company, doesn't move it here.
   */
  withLevels(e, t, n) {
    const s = this.teamId(), o = this.company(), r = n && t.board === n.levels.board ? n.boardId : t.board ? this.b.meta.id : null, a = n && t.team === n.levels.team ? n.teamId : t.team && s ? s : null, l = n && !!t.company === n.levels.company ? n.companyId : t.company && o ? o.id : null;
    return { ...e, boardId: r, teamId: a, companyId: l };
  }
  /** The save form's toggles for a draft: This board when it's filed on this board, the team or company when it's shared with one. */
  levelsFor(e) {
    return { board: !!e.boardId && e.boardId === this.b.meta.id, team: !!e.teamId, company: !!e.companyId };
  }
  /** What saving a finished result keeps: its prompt, tool, input images, settings and picture. */
  draftForResult(e) {
    const t = e.modelId && this.b.catalog.value.byId.get(e.modelId) || null, n = XV(e, t, (o) => this.b.assetUrl(o)), s = this.session(e.sessionId);
    return n.name = this.freshName(tk(n.prompt, s ? s.name : null)), this.withLevels(n, this.b.ui.library.saveLevels);
  }
  /** A name none of your saved prompts that My prompts knows of has yet (freshNameFor asks about the rest). */
  freshName(e) {
    return nk(e, this.myPrompts.known(), this.b.user.uid);
  }
  /** A name none of your saved prompts has: the API names yours that share its words. */
  async freshNameFor(e, t = null) {
    const n = await this.yours(e.trim());
    return nk(e, n.concat(this.myPrompts.known()), this.b.user.uid, t);
  }
  /** A prompt you saved before with this text and tool: the API names yours that hold its words. */
  async duplicateFor(e, t, n) {
    const s = this.b.user.uid, o = ik(this.myPrompts.known(), s, e, t, n);
    return o || !e.trim() ? o : ik(await this.yours(eW(e), t), s, e, t, n);
  }
  /** What saving a session's current prompt keeps; its latest result from that prompt is the picture. Null with no prompt. */
  draftForSession(e) {
    const t = this.session(e);
    if (!t) return null;
    const n = this.b.promptOf(t.id), s = (n.prompt || "").trim();
    if (!s) return null;
    const { model: o } = this.b.modelFor(t), r = o ? Eo(o, n, "draft").inputs : null, a = Q8(o, r, n.ref ? [n.ref] : [], (d) => this.b.assetUrl(d)), l = this.b.results.list(t.id).find((d) => d.status === "done" && !!d.url && (d.prompt || "").trim() === s) || null;
    return this.withLevels({
      name: this.freshName(tk(s, t.name)),
      category: "",
      description: "",
      prompt: n.prompt || "",
      mode: yu(a.length),
      tags: [],
      kind: Ja(t.kitId) === "video" ? "video" : "image",
      tool: { nodeDefId: o ? o.id : t.nodeDefId || "", name: o ? o.name : t.model },
      output: l ? { url: l.url, w: l.w, h: l.h, thumb: l.thumb, video: l.videoSrc } : { url: "", w: 0, h: 0 },
      inputs: a,
      boardId: null,
      teamId: null,
      companyId: null,
      values: r,
      run: l && l.runId && l.uuid ? { runId: l.runId, uuid: l.uuid } : null
    }, this.b.ui.library.saveLevels);
  }
  /**
   * A saved prompt as the save form edits it. Until its document has been
   * read, the prompt is as the API listed it, which doesn't carry the run it
   * was saved from: the draft leaves the run out, so saving keeps it.
   */
  draftFor(e) {
    const t = { ...e };
    return delete t.id, delete t.authorId, delete t.authorName, delete t.createdAt, delete t.updatedAt, this.myPrompts.isLive(e.id) || delete t.run, t;
  }
  /**
   * Save (or, with `editingId`, update) a prompt. The levels it went to are
   * where the next save starts. A new one's toast opens it. My prompts shows
   * it at once, as saved.
   */
  async save(e, t) {
    const n = this.b, s = this.shelf;
    if (!s)
      return n.toast("Saving prompts isn't available here.", "error"), null;
    const o = this.levelsFor(e);
    n.ui.library.saveLevels = { board: o.board, team: o.team };
    try {
      if (t) {
        const d = this.myPrompt(t);
        return await s.update(t, e), d && this.myPrompts.pin({ ...d, ...e, updatedAt: Date.now() }, d), n.toast("Saved your changes to " + e.name), t;
      }
      const r = { uid: n.user.uid, name: n.user.name || n.user.email || "You" }, a = await s.save(e, r), l = Date.now();
      return this.myPrompts.pin({ ...e, id: a, authorId: r.uid, authorName: r.name, createdAt: l, updatedAt: l }, null), n.toast("Saved to My prompts: " + e.name, "info", { label: "Open", run: () => this.openMine(a) }), a;
    } catch (r) {
      return console.warn("[board] saving a prompt failed", r), n.toast("The prompt couldn't be saved. Try again.", "error"), null;
    }
  }
  /** Open My prompts (at one of them). */
  openMine(e) {
    const t = this.b;
    t.dismissToast(), t.ui.infoAt = null, t.ui.infoSave = !1;
    const n = t.promptTool.value;
    this.open(n ? n.id : null), t.ui.library.tab = "mine", t.ui.library.detail = e, this.startMine();
  }
  /** Delete a saved prompt (a soft delete): gone at once, and the toast's Undo brings it back. */
  async remove(e) {
    const t = this.b, n = this.shelf;
    if (!(!n || !this.canEdit(e))) {
      t.ui.library.detail === e.id && (t.ui.library.detail = null), this.myPrompts.drop(e);
      try {
        await n.remove(e.id), t.toast("Deleted " + e.name, "info", {
          label: "Undo",
          run: () => {
            t.dismissToast(), this.myPrompts.undrop(e), n.restore(e.id).catch(() => {
              this.myPrompts.drop(e), t.toast("It couldn't be brought back.", "error");
            });
          }
        });
      } catch (s) {
        console.warn("[board] deleting a prompt failed", s), this.myPrompts.undrop(e), t.toast("The prompt couldn't be deleted. Try again.", "error");
      }
    }
  }
  // --------------------------------------------------------------- the panel
  /**
   * Open it over a session's prompt, or over the canvas: from the board menu,
   * the rail, or Start from a prompt in a menu that starts sessions. It opens
   * on All prompts (or the kind `kind` asks for), so a branch left from one
   * session never hides another's prompts. Over the canvas, `at` is where a
   * session it starts goes (a right-click's point).
   */
  open(e, t = {}) {
    const n = this.b.ui;
    n.advOpen = !1, n.boardMenu = !1, n.library.sessionId = e, n.library.inStudio = !1, n.library.at = e ? null : t.at || null, n.library.kind = t.kind || null, n.library.action = null, n.library.category = null, n.library.detail = null, n.library.editing = null, n.library.query = "", n.library.open = !0, this.load(), this.myPrompts.refresh(), this.startMine();
  }
  /** Open it over the Studios view, for the session open there (B25: Studio's Generate side offers everything the card does). */
  openInStudio(e) {
    this.open(e), this.b.ui.library.inStudio = !0;
  }
  toggle(e) {
    const t = this.b.ui.library;
    t.open && t.sessionId === e ? this.close() : this.open(e);
  }
  close() {
    this.b.ui.library.open = !1, this.b.ui.library.detail = null, this.b.ui.library.editing = null;
  }
  /** Esc: the detail steps back to the grid, then the panel closes. */
  back() {
    const e = this.b.ui.library;
    e.editing ? e.editing = null : e.detail ? e.detail = null : this.close();
  }
  setTab(e) {
    const t = this.b.ui.library;
    t.tab = e, t.detail = null, t.editing = null, e === "mine" && this.startMine();
  }
  setCategory(e) {
    this.b.ui.library.category = e, this.b.ui.library.detail = null;
  }
  /** Both tabs narrowed to prompts for image sessions or for video ones; null for both. */
  setKind(e) {
    this.setBranch(e, null, null);
  }
  /**
   * The sidebar's branch (IL-103): a kind, what its prompts do (Generate or
   * Edit) and a category under that; each narrower one needs the one before.
   */
  setBranch(e, t = null, n = null) {
    const s = this.b.ui.library;
    s.kind = e, s.action = e ? t : null, s.category = e && t ? n : null, s.detail = null;
  }
  /** Where a tab's grid scroll is kept: it comes back only to the branch it was left in. */
  scrollKey() {
    const e = this.b.ui.library;
    return [e.tab, e.kind || "", e.action || "", e.category || ""].join("|");
  }
  // ------------------------------------------------------- what it will do
  /** The session the panel applies to, if it's still there. */
  session(e) {
    const t = e ? this.b.store.get(e) : null;
    return t && t.type === "tool" ? t : null;
  }
  /**
   * What Use prompt and Remix will do with this prompt here, said before the
   * click: the tool isn't on this board, or isn't in this session's kit.
   */
  toolNote(e, t) {
    const n = this.b.catalog.value, s = Xa(n, e.tool);
    if (!s) {
      const r = this.kitForKind(n, e.kind, this.session(t)), a = r ? Bi(r) : null;
      return e.tool.name + " isn't available here. Use prompt keeps your tool" + (a ? "; Remix uses " + a.name + "." : ".");
    }
    const o = this.session(t);
    if (o) {
      const { kit: r } = this.b.modelFor(o);
      if (r && !Fc(n, r, s)) return "This session can't run " + s.name + ". Use prompt keeps its tool; Remix starts a new " + (Qw(n, s) || { name: "" }).name.toLowerCase() + " session.";
    }
    return "";
  }
  /**
   * Where Remix will put the example: the session it was opened for, when
   * that session's kit runs it (B25: Nathan, a remix belongs with the
   * session's work, not in a new session), else a new one beside it.
   */
  remixFills(e, t) {
    const n = this.session(t);
    if (!n || this.b.isHeld(n)) return !1;
    const s = this.remixKit(e, n);
    return !!s && s.id === n.kitId;
  }
  // ---------------------------------------------------------- use prompt
  /**
   * Put the prompt's text in the session, switching it to the prompt's tool
   * when its kit has it. Its images and settings stay; one Undo puts it all
   * back. With no session (opened from the board menu), a new one starts.
   */
  async use(e, t) {
    const n = this.b, s = this.session(t);
    if (this.close(), !s) {
      this.startSession(e);
      return;
    }
    await n.draftReady(s.id);
    const o = this.session(s.id);
    if (!o) return;
    const r = { prompt: n.promptOf(o.id).prompt || "", model: o.model, nodeDefId: o.nodeDefId, name: o.name, fresh: n.freshTools.has(o.id) }, a = Xa(n.catalog.value, e.tool), { kit: l, model: d } = n.modelFor(o), c = a && l && (!d || d.id !== a.id) && Fc(n.catalog.value, l, a) ? a : null, h = ek(o.name) ? n.uniqueSessionName(e.name, o.id) : null;
    (c || h) && n.patchTool(o.id, { ...c ? { model: c.name, nodeDefId: c.id } : {}, ...h ? { name: h } : {} }), n.setPrompt(o.id, { prompt: e.prompt }), n.landPrompt(o.id);
    const f = h || o.name;
    n.toast(c ? "Prompt added to " + f + ", on " + c.name : "Prompt added to " + f, "info", {
      label: "Undo",
      run: () => this.undoUse(o.id, r)
    });
  }
  undoUse(e, t) {
    const n = this.b, s = this.session(e);
    if (!s) return;
    const o = {};
    s.nodeDefId !== t.nodeDefId && (o.model = t.model, o.nodeDefId = t.nodeDefId), s.name !== t.name && (o.name = t.name), Object.keys(o).length && n.patchTool(e, o), n.setPrompt(e, { prompt: t.prompt }), t.fresh && n.freshTools.add(e), n.landPrompt(e), n.dismissToast();
  }
  // --------------------------------------------------------------- remix
  /** The kit Remix runs the prompt in: its tool's, the session's own first. */
  remixKit(e, t) {
    const n = this.b.catalog.value, s = Xa(n, e.tool);
    return s ? Qw(n, s, t ? t.kitId : null) : this.kitForKind(n, e.kind, t);
  }
  /** Without the prompt's tool: the session's kit when it takes this kind of prompt, else the first that does. */
  kitForKind(e, t, n) {
    if (n && Ja(n.kitId) === t) {
      const s = e.kits.find((o) => o.id === n.kitId);
      if (s) return s;
    }
    return e.kits.find((s) => Ja(s.id) === t) || null;
  }
  /**
   * Recreate the example: the tool, the prompt, its input images in order and
   * the output's shape, so Run makes it again. A new, empty session takes it;
   * otherwise a new session starts beside it (a session is one line of work,
   * so one with results is never overwritten).
   */
  async remix(e, t) {
    const n = this.b, s = this.session(t);
    s && this.remixFills(e, s.id) && await n.draftReady(s.id);
    const o = this.session(t), r = n.catalog.value, a = Xa(r, e.tool), l = this.remixKit(e, o), d = a || (l ? Bi(l) : null);
    if (this.close(), !l || !d) {
      n.toast("No tool on this board can run this prompt.", "error");
      return;
    }
    let c, h = 0;
    if (Dr(e) && e.values && a && a.id === e.tool.nodeDefId) {
      const w = dc(a, e.values, (S) => n.assetUrl(S));
      if (w.inputs)
        for (const S of a.fields) S.kind === "seed" && delete w.inputs[S.key];
      c = { ...w, prompt: e.prompt, n: 1 };
    } else
      ({ up: c, dropped: h } = jV(d, e));
    let f, p, y = null;
    o && this.remixFills(e, o.id) ? (y = { up: JSON.parse(JSON.stringify(n.promptOf(o.id))), model: o.model, nodeDefId: o.nodeDefId, name: o.name }, p = ek(o.name) ? n.uniqueSessionName(e.name, o.id) : o.name, n.patchTool(o.id, { model: d.name, nodeDefId: d.id, ...p !== o.name ? { name: p } : {} }), f = o.id, n.ui.selection = [f]) : (p = n.uniqueSessionName(e.name), f = n.addSession(l, d, p, o ? void 0 : n.ui.library.at || void 0).id), n.setPrompt(f, { prompt: c.prompt, ref: c.ref || null, inputs: c.inputs || {}, assets: c.assets, n: 1 }), n.landPrompt(f), n.track("remix_initiated", { node_def_id: d.id, source: "prompt_library", prompt_id: e.id });
    let v = "";
    a ? h && (v = " " + (h === 1 ? "One of its images doesn't" : h + " of its images don't") + " fit " + d.name + ", so " + (h === 1 ? "it was" : "they were") + " left out.") : v = " " + e.tool.name + " isn't available here, so it uses " + d.name + ".";
    const x = y;
    n.toast("Remix ready in " + p + ". Run makes it again." + v, "info", x ? {
      label: "Undo",
      run: () => {
        const w = this.session(f);
        w && (n.patchTool(f, { model: x.model, nodeDefId: x.nodeDefId, ...w.name !== x.name ? { name: x.name } : {} }), n.replacePrompt(f, x.up), n.landPrompt(f), n.dismissToast());
      }
    } : void 0);
  }
  /** Use prompt with no session: a new one, with the prompt's text, where the panel was opened for (a right-click's point). */
  startSession(e) {
    const t = this.b, n = t.catalog.value, s = Xa(n, e.tool), o = this.remixKit(e, null), r = s || (o ? Bi(o) : null);
    if (!o || !r) {
      t.toast("No tool on this board can run this prompt.", "error");
      return;
    }
    const a = t.uniqueSessionName(e.name), l = t.addSession(o, r, a, t.ui.library.at || void 0).id;
    t.setPrompt(l, { prompt: e.prompt, n: 1 }), t.landPrompt(l), t.toast("New session ready: " + a);
  }
  // ----------------------------------------------------------- ghost text
  /**
   * The one-liners a new session's empty prompt cycles: its kind's, the edits
   * only once it has an image. Each session starts on its own line.
   */
  ghostLines(e) {
    const t = this.featured.value;
    if (!t) return [];
    const n = this.b.promptOf(e.id), s = (l) => typeof l == "string" && /^(https?:|blob:|data:)/.test(l), o = !!n.ref || Object.values(n.inputs || {}).some((l) => s(l) || Array.isArray(l) && l.some(s)), r = HV(t.prompts, Ja(e.kitId), o), a = VV(e.id, r.length);
    return r.slice(a).concat(r.slice(0, a));
  }
}
const hie = [{ key: "smileys", label: "Smileys" }, { key: "people", label: "People" }, { key: "nature", label: "Animals & nature" }, { key: "food", label: "Food & drink" }, { key: "travel", label: "Travel & places" }, { key: "activities", label: "Activities" }, { key: "objects", label: "Objects" }, { key: "symbols", label: "Symbols" }, { key: "flags", label: "Flags" }], pie = `#smileys
😀|grinning face|cheerful cheery grin happy laugh nice|grinning|1|
😃|grinning face with big eyes|awesome grin happy mouth open smile|smiley|0.6|
😄|grinning face with smiling eyes|eye grin happy laugh lol mouth|smile|0.6|
😁|beaming face with smiling eyes|eye grin grinning happy nice smile|grin|0.6|
😆|grinning squinting face|closed eyes haha hahaha happy laugh|laughing satisfied|0.6|
😅|grinning face with sweat|cold dejected excited mouth nervous open|sweat_smile|0.6|
🤣|rolling on the floor laughing|crying face funny haha happy hehe|rofl|3|
😂|face with tears of joy|crying feels funny haha happy hehe|joy|0.6|
🙂|slightly smiling face|happy smile|slightly_smiling_face|1|
🙃|upside-down face|hehe smile upside-down|upside_down_face|1|
🫠|melting face|disappear dissolve embarrassed haha heat hot|melting_face|14|
🫫|cracking face|breaking crumbling masking resilience reveal tension||18|
😉|winking face|flirt heartbreaker sexy slide tease wink|wink|0.6|
😊|smiling face with smiling eyes|blush eye glad satisfied smile|blush|0.6|
😇|smiling face with halo|angel angelic angels blessed fairy fairytale|innocent|1|
🥰|smiling face with hearts|3 adore crush heart ily love|smiling_face_with_three_hearts|11|
😍|smiling face with heart-eyes|143 bae eye feels heart-eyes hearts|heart_eyes|0.6|
🤩|star-struck|excited eyes face grinning smile starry-eyed|star_struck|5|
😘|face blowing a kiss|adorbs bae flirt heart ily love|kissing_heart|0.6|
😗|kissing face|143 date dating flirt ily kiss|kissing|1|
☺️|smiling face|happy outlined relaxed smile|relaxed|0.6|
😚|kissing face with closed eyes|143 bae blush date dating eye|kissing_closed_eyes|0.6|
😙|kissing face with smiling eyes|143 closed date dating eye flirt|kissing_smiling_eyes|1|
🥲|smiling face with tear|glad grateful happy joy pain proud|smiling_face_with_tear|13|
😋|face savoring food|delicious eat full hungry savor smile|yum|0.6|
😛|face with tongue|awesome cool nice party stuck-out sweet|stuck_out_tongue|1|
😜|winking face with tongue|crazy epic eye funny joke loopy|stuck_out_tongue_winking_eye|0.6|
🤪|zany face|crazy eye eyes goofy large small|zany_face|5|
😝|squinting face with tongue|closed eye eyes gross horrible omg|stuck_out_tongue_closed_eyes|0.6|
🤑|money-mouth face|money-mouth paid|money_mouth_face|1|
🤗|smiling face with open hands|hug hugging|hugs|1|
🤭|face with hand over mouth|giggle giggling oops realization secret shock|hand_over_mouth|5|
🫢|face with open eyes and hand over mouth|amazement awe disbelief embarrass gasp omg|face_with_open_eyes_and_hand_over_mouth|14|
🫣|face with peeking eye|captivated embarrass hide hiding peek peep|face_with_peeking_eye|14|
🤫|shushing face|quiet shh shush|shushing_face|5|
🤔|thinking face|chin consider hmm ponder pondering wondering|thinking|1|
🫡|saluting face|ok good luck ma’am respect salute|saluting_face|14|
🤐|zipper-mouth face|keep quiet secret shut zip zipper-mouth|zipper_mouth_face|1|
🤨|face with raised eyebrow|disapproval disbelief distrust emoji hmm mild|raised_eyebrow|5|
😐|neutral face|awkward blank deadpan expressionless fine jealous|neutral_face|0.7|
😑|expressionless face|awkward dead fine inexpressive jealous meh|expressionless|1|
😶|face without mouth|awkward blank expressionless mouthless mute quiet|no_mouth|1|
🫥|dotted line face|depressed disappear hidden hide introvert invisible|dotted_line_face|14|
😶‍🌫️|face in clouds|absentminded fog head|face_in_clouds|13.1|
😏|smirking face|boss dapper flirt homie kidding leer|smirk|0.6|
😒|unamused face|... bored fine jealous jel jelly|unamused|0.6|
🙄|face with rolling eyes|eyeroll shade ugh whatever|roll_eyes|1|
😬|grimacing face|awk awkward dentist grimace grinning smile|grimacing|1|
😮‍💨|face exhaling|blow blowing exhale exhausted gasp groan|face_exhaling|13.1|
🤥|lying face|liar lie pinocchio|lying_face|3|
🫨|shaking face|crazy daze earthquake omg panic shock|shaking_face|15|
🙂‍↔️|head shaking horizontally|no shake||15.1|
🙂‍↕️|head shaking vertically|nod yes||15.1|
😌|relieved face|calm peace relief zen|relieved|0.6|
😔|pensive face|awful bored dejected died disappointed losing|pensive|0.6|
😪|sleepy face|crying good night sad sleep sleeping|sleepy|0.6|
🤤|drooling face||drooling_face|3|
😴|sleeping face|bed bedtime good goodnight nap night|sleeping|1|
🫩|face with bags under eyes|bored exhausted fatigued late sleepy tired||16|
😷|face with medical mask|cold dentist dermatologist doctor dr germs|mask|0.6|
🤒|face with thermometer|ill sick|face_with_thermometer|1|
🤕|face with head-bandage|head-bandage hurt injury ouch|face_with_head_bandage|1|
🤢|nauseated face|gross nasty sick vomit|nauseated_face|3|
🤮|face vomiting|barf ew gross puke sick spew|vomiting_face|5|
🤧|sneezing face|fever flu gesundheit sick sneeze|sneezing_face|3|
🥵|hot face|dying feverish heat panting red-faced stroke|hot_face|11|
🥶|cold face|blue blue-faced freezing frostbite icicles subzero|cold_face|11|
🥴|woozy face|dizzy drunk eyes intoxicated mouth tipsy|woozy_face|11|
😵|face with crossed-out eyes|crossed-out dead dizzy feels knocked sick|dizzy_face|0.6|
😵‍💫|face with spiral eyes|confused dizzy hypnotized omg smiley trouble|face_with_spiral_eyes|13.1|
🤯|exploding head|blown explode mind mindblown no shocked|exploding_head|5|
🤠|cowboy hat face|cowgirl|cowboy_hat_face|3|
🥳|partying face|bday birthday celebrate celebration excited happy|partying_face|11|
🥸|disguised face|disguise eyebrow glasses incognito moustache mustache|disguised_face|13|
😎|smiling face with sunglasses|awesome beach bright bro chilling cool|sunglasses|1|
🤓|nerd face|brainy clever expert geek gifted glasses|nerd_face|1|
🧐|face with monocle|classy fancy rich stuffy wealthy|monocle_face|5|
😕|confused face|befuddled confusing dunno frown hm meh|confused|1|
🫤|face with diagonal mouth|confused confusion disappointed doubt doubtful frustrated|face_with_diagonal_mouth|14|
😟|worried face|anxious butterflies nerves nervous sad stress|worried|1|
🙁|slightly frowning face|frown sad|slightly_frowning_face|1|
☹️|frowning face|frown sad|frowning_face|0.7|
😮|face with open mouth|believe forgot omg shocked surprised sympathy|open_mouth|1|
😯|hushed face|epic omg stunned surprised whoa woah|hushed|1|
😲|astonished face|cost no omg shocked totally way|astonished|0.6|
😳|flushed face|amazed awkward crazy dazed dead disbelief|flushed|0.6|
🫪|distorted face|anxiety bloated panic shocked surprised vulnerable||17|
🥺|pleading face|begging big eyes mercy not please|pleading_face|11|
🥹|face holding back tears|admiration aww cry embarrassed feelings grateful|face_holding_back_tears|14|
😦|frowning face with open mouth|caught frown guard scared scary surprise|frowning|1|
😧|anguished face|forgot scared scary stressed surprise unhappy|anguished|1|
😨|fearful face|afraid anxious blame fear scared worried|fearful|0.6|
😰|anxious face with sweat|blue cold eek mouth nervous open|cold_sweat|0.6|
😥|sad but relieved face|anxious call close complicated disappointed not|disappointed_relieved|0.6|
😢|crying face|awful cry feels miss sad tear|cry|0.6|
😭|loudly crying face|bawling cry sad sob tear tears|sob|0.6|
😱|face screaming in fear|epic fearful munch scared scream screamer|scream|0.6|
😖|confounded face|annoyed confused cringe distraught feels frustrated|confounded|0.6|
😣|persevering face|concentrate concentration focus headache persevere|persevere|0.6|
😞|disappointed face|awful blame dejected fail losing sad|disappointed|0.6|
😓|downcast face with sweat|close cold feels headache nervous sad|sweat|0.6|
😩|weary face|crying fail feels hungry mad nooo|weary|0.6|
😫|tired face|cost feels nap sad sneeze|tired_face|0.6|
🥱|yawning face|bedtime bored goodnight nap night sleep|yawning_face|12|
😤|face with steam from nose|anger angry feels fume fuming furious|triumph|0.6|
😡|enraged face|anger angry feels mad maddening pouting|pout rage|0.6|
😠|angry face|anger blame feels frustrated mad maddening|angry|0.6|
🤬|face with symbols on mouth|censor cursing cussing mad pissed swearing|cursing_face|5|
😈|smiling face with horns|demon devil evil fairy fairytale fantasy|smiling_imp|1|
👿|angry face with horns|demon devil evil fairy fairytale fantasy|imp|0.6|
💀|skull|body dead death face fairy fairytale|skull|0.6|
☠️|skull and crossbones|bone dead death face monster|skull_and_crossbones|1|
💩|pile of poo|bs comic doo dung face fml|hankey poop|0.6|
🤡|clown face||clown_face|3|
👹|ogre|creature devil face fairy fairytale fantasy|japanese_ogre|0.6|
👺|goblin|angry creature face fairy fairytale fantasy|japanese_goblin|0.6|
👻|ghost|boo creature excited face fairy fairytale|ghost|0.6|
👽|alien|creature extraterrestrial face fairy fairytale fantasy|alien|0.6|
👾|alien monster|creature extraterrestrial face fairy fairytale fantasy|space_invader|0.6|
🤖|robot|face monster|robot|1|
😺|grinning cat|animal face mouth open smile smiling|smiley_cat|0.6|
😸|grinning cat with smiling eyes|animal eye face grin smile|smile_cat|0.6|
😹|cat with tears of joy|animal face laugh laughing lol tear|joy_cat|0.6|
😻|smiling cat with heart-eyes|animal eye face heart-eyes love smile|heart_eyes_cat|0.6|
😼|cat with wry smile|animal face ironic|smirk_cat|0.6|
😽|kissing cat|animal closed eye eyes face kiss|kissing_cat|0.6|
🙀|weary cat|animal face oh surprised|scream_cat|0.6|
😿|crying cat|animal cry face sad tear|crying_cat_face|0.6|
😾|pouting cat|animal face|pouting_cat|0.6|
🙈|see-no-evil monkey|embarrassed face forbidden forgot gesture hide|see_no_evil|0.6|
🙉|hear-no-evil monkey|animal ears face forbidden gesture listen|hear_no_evil|0.6|
🙊|speak-no-evil monkey|animal face forbidden gesture not oops|speak_no_evil|0.6|
💌|love letter|heart mail romance valentine|love_letter|0.6|
💘|heart with arrow|143 adorbs cupid date emotion ily|cupid|0.6|
💝|heart with ribbon|143 anniversary emotion ily kisses valentine|gift_heart|0.6|
💖|sparkling heart|143 emotion excited good ily kisses|sparkling_heart|0.6|
💗|growing heart|143 emotion excited heartpulse ily kisses|heartpulse|0.6|
💓|beating heart|143 cardio emotion heartbeat ily love|heartbeat|0.6|
💞|revolving hearts|143 adorbs anniversary emotion heart|revolving_hearts|0.6|
💕|two hearts|143 anniversary date dating emotion heart|two_hearts|0.6|
💟|heart decoration|143 emotion hearth purple white|heart_decoration|0.6|
❣️|heart exclamation|bang heavy mark punctuation|heavy_heart_exclamation|1|
💔|broken heart|break crushed emotion heartbroken lonely sad|broken_heart|0.6|
❤️‍🔥|heart on fire|burn love lust sacred|heart_on_fire|13.1|
❤️‍🩹|mending heart|healthier improving recovering recuperating well|mending_heart|13.1|
❤️|red heart|emotion love|heart|0.6|
🩷|pink heart|143 adorable cute emotion ily like|pink_heart|15|
🧡|orange heart|143|orange_heart|5|
💛|yellow heart|143 cardiac emotion ily love|yellow_heart|0.6|
💚|green heart|143 emotion ily love romantic|green_heart|0.6|
💙|blue heart|143 emotion ily love romance|blue_heart|0.6|
🩵|light blue heart|143 cute cyan emotion ily like|light_blue_heart|15|
💜|purple heart|143 bestest emotion ily love|purple_heart|0.6|
🤎|brown heart|143|brown_heart|12|
🖤|black heart|evil wicked|black_heart|3|
🩶|grey heart|143 emotion gray ily love silver|grey_heart|15|
🤍|white heart|143|white_heart|12|
💋|kiss mark|dating emotion heart kissing lips romance|kiss|0.6|
💯|hundred points|100 true a+ agree clearly definitely|100|0.6|
💢|anger symbol|angry comic mad upset|anger|0.6|
🫯|fight cloud|argument brawl debate disagreement ruckus wrestle||17|
💥|collision|bomb boom collide comic explode|boom collision|0.6|
💫|dizzy|comic shining shooting star stars|dizzy|0.6|
💦|sweat droplets|comic drip droplet drops splashing squirt|sweat_drops|0.6|
💨|dashing away|cloud comic dash fart fast go|dash|0.6|
🕳️|hole||hole|0.7|
💬|speech balloon|bubble comic dialog message sms talk|speech_balloon|0.6|
👁️‍🗨️|eye in speech bubble|balloon witness|eye_speech_bubble|2|
🗨️|left speech bubble|balloon dialog|left_speech_bubble|2|
🗯️|right anger bubble|angry balloon mad|right_anger_bubble|0.7|
💭|thought balloon|bubble cartoon cloud comic daydream decisions|thought_balloon|1|
💤|ZZZ|comic good goodnight night sleep sleeping|zzz|0.6|
#people
👋|waving hand|bye cya g2g greetings gtg hello|wave|0.6|👋🏻 👋🏼 👋🏽 👋🏾 👋🏿
🤚|raised back of hand|backhand|raised_back_of_hand|3|🤚🏻 🤚🏼 🤚🏽 🤚🏾 🤚🏿
🖐️|hand with fingers splayed|finger raised stop|raised_hand_with_fingers_splayed|0.7|🖐🏻 🖐🏼 🖐🏽 🖐🏾 🖐🏿
✋|raised hand|5 five high stop|hand raised_hand|0.6|✋🏻 ✋🏼 ✋🏽 ✋🏾 ✋🏿
🖖|vulcan salute|finger hand hands|vulcan_salute|1|🖖🏻 🖖🏼 🖖🏽 🖖🏾 🖖🏿
🫱|rightwards hand|handshake hold reach right rightward shake|rightwards_hand|14|🫱🏻 🫱🏼 🫱🏽 🫱🏾 🫱🏿
🫲|leftwards hand|handshake hold left leftward reach shake|leftwards_hand|14|🫲🏻 🫲🏼 🫲🏽 🫲🏾 🫲🏿
🫳|palm down hand|dismiss drop dropped pick shoo up|palm_down_hand|14|🫳🏻 🫳🏼 🫳🏽 🫳🏾 🫳🏿
🫴|palm up hand|beckon catch come hold know lift|palm_up_hand|14|🫴🏻 🫴🏼 🫴🏽 🫴🏾 🫴🏿
🫷|leftwards pushing hand|block five halt high hold leftward|leftwards_pushing_hand|15|🫷🏻 🫷🏼 🫷🏽 🫷🏾 🫷🏿
🫸|rightwards pushing hand|block five halt high hold pause|rightwards_pushing_hand|15|🫸🏻 🫸🏼 🫸🏽 🫸🏾 🫸🏿
👌|OK hand|awesome bet dope fleek fosho got|ok_hand|0.6|👌🏻 👌🏼 👌🏽 👌🏾 👌🏿
🤌|pinched fingers|gesture hand hold huh interrogation patience|pinched_fingers|13|🤌🏻 🤌🏼 🤌🏽 🤌🏾 🤌🏿
🤏|pinching hand|amount bit fingers little small sort|pinching_hand|12|🤏🏻 🤏🏼 🤏🏽 🤏🏾 🤏🏿
✌️|victory hand|peace v|v|0.6|✌🏻 ✌🏼 ✌🏽 ✌🏾 ✌🏿
🤞|crossed fingers|cross finger hand luck|crossed_fingers|3|🤞🏻 🤞🏼 🤞🏽 🤞🏾 🤞🏿
🫰|hand with index finger and thumb crossed|<3 expensive heart love money snap|hand_with_index_finger_and_thumb_crossed|14|🫰🏻 🫰🏼 🫰🏽 🫰🏾 🫰🏿
🤟|love-you gesture|ily fingers hand love-you three|love_you_gesture|5|🤟🏻 🤟🏼 🤟🏽 🤟🏾 🤟🏿
🤘|sign of the horns|finger hand rock-on|metal|1|🤘🏻 🤘🏼 🤘🏽 🤘🏾 🤘🏿
🤙|call me hand|shaka hang loose|call_me_hand|3|🤙🏻 🤙🏼 🤙🏽 🤙🏾 🤙🏿
👈|backhand index pointing left|finger hand point|point_left|0.6|👈🏻 👈🏼 👈🏽 👈🏾 👈🏿
👉|backhand index pointing right|finger hand point|point_right|0.6|👉🏻 👉🏼 👉🏽 👉🏾 👉🏿
👆|backhand index pointing up|finger hand point|point_up_2|0.6|👆🏻 👆🏼 👆🏽 👆🏾 👆🏿
🖕|middle finger|hand|fu middle_finger|1|🖕🏻 🖕🏼 🖕🏽 🖕🏾 🖕🏿
👇|backhand index pointing down|finger hand point|point_down|0.6|👇🏻 👇🏼 👇🏽 👇🏾 👇🏿
☝️|index pointing up|finger hand point this|point_up|0.6|☝🏻 ☝🏼 ☝🏽 ☝🏾 ☝🏿
🫵|index pointing at the viewer|finger hand poke you|index_pointing_at_the_viewer|14|🫵🏻 🫵🏼 🫵🏽 🫵🏾 🫵🏿
👍|thumbs up|+1 good hand like thumb yes|+1 thumbsup|0.6|👍🏻 👍🏼 👍🏽 👍🏾 👍🏿
👎|thumbs down|-1 bad dislike good hand no|-1 thumbsdown|0.6|👎🏻 👎🏼 👎🏽 👎🏾 👎🏿
🫹|leftwards thumb sign|grip left neutral point that this||18|🫹🏻 🫹🏼 🫹🏽 🫹🏾 🫹🏿
🫺|rightwards thumb sign|grip neutral point right that this||18|🫺🏻 🫺🏼 🫺🏽 🫺🏾 🫺🏿
✊|raised fist|clenched hand punch solidarity|fist fist_raised|0.6|✊🏻 ✊🏼 ✊🏽 ✊🏾 ✊🏿
👊|oncoming fist|absolutely agree boom bro bruh bump|facepunch fist_oncoming|0.6|👊🏻 👊🏼 👊🏽 👊🏾 👊🏿
🤛|left-facing fist|left-facing leftwards|fist_left|3|🤛🏻 🤛🏼 🤛🏽 🤛🏾 🤛🏿
🤜|right-facing fist|right-facing rightwards|fist_right|3|🤜🏻 🤜🏼 🤜🏽 🤜🏾 🤜🏿
👏|clapping hands|applause approval awesome clap congrats congratulations|clap|0.6|👏🏻 👏🏼 👏🏽 👏🏾 👏🏿
🙌|raising hands|celebration gesture hand hooray praise raised|raised_hands|0.6|🙌🏻 🙌🏼 🙌🏽 🙌🏾 🙌🏿
🫶|heart hands|<3 love you|heart_hands|14|🫶🏻 🫶🏼 🫶🏽 🫶🏾 🫶🏿
👐|open hands|hand hug jazz swerve|open_hands|0.6|👐🏻 👐🏼 👐🏽 👐🏾 👐🏿
🤲|palms up together|cupped dua hands pray prayer wish|palms_up_together|5|🤲🏻 🤲🏼 🤲🏽 🤲🏾 🤲🏿
🤝|handshake|agreement deal hand meeting shake|handshake|3|🤝🏻 🤝🏼 🤝🏽 🤝🏾 🤝🏿
🙏|folded hands|appreciate ask beg blessed bow cmon|pray|0.6|🙏🏻 🙏🏼 🙏🏽 🙏🏾 🙏🏿
✍️|writing hand|write|writing_hand|0.7|✍🏻 ✍🏼 ✍🏽 ✍🏾 ✍🏿
💅|nail polish|bored care cosmetics done makeup manicure|nail_care|0.6|💅🏻 💅🏼 💅🏽 💅🏾 💅🏿
🤳|selfie|camera phone|selfie|3|🤳🏻 🤳🏼 🤳🏽 🤳🏾 🤳🏿
💪|flexed biceps|arm beast bench bodybuilder bro curls|muscle|0.6|💪🏻 💪🏼 💪🏽 💪🏾 💪🏿
🦾|mechanical arm|accessibility prosthetic|mechanical_arm|12|
🦿|mechanical leg|accessibility prosthetic|mechanical_leg|12|
🦵|leg|bent foot kick knee limb|leg|11|🦵🏻 🦵🏼 🦵🏽 🦵🏾 🦵🏿
🦶|foot|ankle feet kick stomp|foot|11|🦶🏻 🦶🏼 🦶🏽 🦶🏾 🦶🏿
👂|ear|body ears hear hearing listen listening|ear|0.6|👂🏻 👂🏼 👂🏽 👂🏾 👂🏿
🦻|ear with hearing aid|accessibility hard|ear_with_hearing_aid|12|🦻🏻 🦻🏼 🦻🏽 🦻🏾 🦻🏿
👃|nose|body noses nosey odor smell smells|nose|0.6|👃🏻 👃🏼 👃🏽 👃🏾 👃🏿
🧠|brain|intelligent smart|brain|5|
🫀|anatomical heart|beat cardiology heartbeat organ pulse real|anatomical_heart|13|
🫁|lungs|breath breathe exhalation inhalation lung organ|lungs|13|
🦷|tooth|dentist pearly teeth white|tooth|11|
🦴|bone|bones dog skeleton wishbone|bone|11|
👀|eyes|body eye face googly look looking|eyes|0.6|
👁️|eye|1 body one|eye|0.7|
👅|tongue|body lick slurp|tongue|0.6|
👄|mouth|beauty body kiss kissing lips lipstick|lips|0.6|
🫦|biting lip|anxious bite fear flirt flirting kiss|biting_lip|14|
👶|baby|babies children goo infant newborn pregnant|baby|0.6|👶🏻 👶🏼 👶🏽 👶🏾 👶🏿
🧒|child|bright-eyed grandchild kid young younger|child|5|🧒🏻 🧒🏼 🧒🏽 🧒🏾 🧒🏿
👦|boy|bright-eyed child grandson kid son young|boy|0.6|👦🏻 👦🏼 👦🏽 👦🏾 👦🏿
👧|girl|virgo bright-eyed child daughter granddaughter kid|girl|0.6|👧🏻 👧🏼 👧🏽 👧🏾 👧🏿
🧑|person|adult|adult|5|🧑🏻 🧑🏼 🧑🏽 🧑🏾 🧑🏿
👱|person: blond hair|blond-haired human|blond_haired_person|0.6|👱🏻 👱🏼 👱🏽 👱🏾 👱🏿
👨|man|adult bro|man|0.6|👨🏻 👨🏼 👨🏽 👨🏾 👨🏿
🧔|person: beard|bearded whiskers|bearded_person|5|🧔🏻 🧔🏼 🧔🏽 🧔🏾 🧔🏿
🧔‍♂️|man: beard|bearded whiskers|man_beard|13.1|🧔🏻‍♂️ 🧔🏼‍♂️ 🧔🏽‍♂️ 🧔🏾‍♂️ 🧔🏿‍♂️
🧔‍♀️|woman: beard|bearded whiskers|woman_beard|13.1|🧔🏻‍♀️ 🧔🏼‍♀️ 🧔🏽‍♀️ 🧔🏾‍♀️ 🧔🏿‍♀️
👨‍🦰|man: red hair|adult bro red hair|red_haired_man|11|👨🏻‍🦰 👨🏼‍🦰 👨🏽‍🦰 👨🏾‍🦰 👨🏿‍🦰
👨‍🦱|man: curly hair|adult bro curly hair|curly_haired_man|11|👨🏻‍🦱 👨🏼‍🦱 👨🏽‍🦱 👨🏾‍🦱 👨🏿‍🦱
👨‍🦳|man: white hair|adult bro white hair|white_haired_man|11|👨🏻‍🦳 👨🏼‍🦳 👨🏽‍🦳 👨🏾‍🦳 👨🏿‍🦳
👨‍🦲|man: bald|adult bro|bald_man|11|👨🏻‍🦲 👨🏼‍🦲 👨🏽‍🦲 👨🏾‍🦲 👨🏿‍🦲
👩|woman|adult lady|woman|0.6|👩🏻 👩🏼 👩🏽 👩🏾 👩🏿
👩‍🦰|woman: red hair|adult lady red hair|red_haired_woman|11|👩🏻‍🦰 👩🏼‍🦰 👩🏽‍🦰 👩🏾‍🦰 👩🏿‍🦰
🧑‍🦰|person: red hair|adult red hair|person_red_hair|12.1|🧑🏻‍🦰 🧑🏼‍🦰 🧑🏽‍🦰 🧑🏾‍🦰 🧑🏿‍🦰
👩‍🦱|woman: curly hair|adult curly hair lady|curly_haired_woman|11|👩🏻‍🦱 👩🏼‍🦱 👩🏽‍🦱 👩🏾‍🦱 👩🏿‍🦱
🧑‍🦱|person: curly hair|adult curly hair|person_curly_hair|12.1|🧑🏻‍🦱 🧑🏼‍🦱 🧑🏽‍🦱 🧑🏾‍🦱 🧑🏿‍🦱
👩‍🦳|woman: white hair|adult lady white hair|white_haired_woman|11|👩🏻‍🦳 👩🏼‍🦳 👩🏽‍🦳 👩🏾‍🦳 👩🏿‍🦳
🧑‍🦳|person: white hair|adult white hair|person_white_hair|12.1|🧑🏻‍🦳 🧑🏼‍🦳 🧑🏽‍🦳 🧑🏾‍🦳 🧑🏿‍🦳
👩‍🦲|woman: bald|adult lady|bald_woman|11|👩🏻‍🦲 👩🏼‍🦲 👩🏽‍🦲 👩🏾‍🦲 👩🏿‍🦲
🧑‍🦲|person: bald|adult|person_bald|12.1|🧑🏻‍🦲 🧑🏼‍🦲 🧑🏽‍🦲 🧑🏾‍🦲 🧑🏿‍🦲
👱‍♀️|woman: blond hair|blond-haired blonde|blond_haired_woman blonde_woman|4|👱🏻‍♀️ 👱🏼‍♀️ 👱🏽‍♀️ 👱🏾‍♀️ 👱🏿‍♀️
👱‍♂️|man: blond hair|blond-haired|blond_haired_man|4|👱🏻‍♂️ 👱🏼‍♂️ 👱🏽‍♂️ 👱🏾‍♂️ 👱🏿‍♂️
🧓|older person|adult elderly grandparent old wise|older_adult|5|🧓🏻 🧓🏼 🧓🏽 🧓🏾 🧓🏿
👴|old man|adult bald elderly gramps grandfather grandpa|older_man|0.6|👴🏻 👴🏼 👴🏽 👴🏾 👴🏿
👵|old woman|adult elderly grandma grandmother granny lady|older_woman|0.6|👵🏻 👵🏼 👵🏽 👵🏾 👵🏿
🙍|person frowning|annoyed disappointed disgruntled disturbed frown frustrated|frowning_person|0.6|🙍🏻 🙍🏼 🙍🏽 🙍🏾 🙍🏿
🙍‍♂️|man frowning|annoyed disappointed disgruntled disturbed frown frustrated|frowning_man|4|🙍🏻‍♂️ 🙍🏼‍♂️ 🙍🏽‍♂️ 🙍🏾‍♂️ 🙍🏿‍♂️
🙍‍♀️|woman frowning|annoyed disappointed disgruntled disturbed frown frustrated|frowning_woman|4|🙍🏻‍♀️ 🙍🏼‍♀️ 🙍🏽‍♀️ 🙍🏾‍♀️ 🙍🏿‍♀️
🙎|person pouting|disappointed downtrodden frown grimace scowl sulk|pouting_face|0.6|🙎🏻 🙎🏼 🙎🏽 🙎🏾 🙎🏿
🙎‍♂️|man pouting|disappointed downtrodden frown grimace scowl sulk|pouting_man|4|🙎🏻‍♂️ 🙎🏼‍♂️ 🙎🏽‍♂️ 🙎🏾‍♂️ 🙎🏿‍♂️
🙎‍♀️|woman pouting|disappointed downtrodden frown grimace scowl sulk|pouting_woman|4|🙎🏻‍♀️ 🙎🏼‍♀️ 🙎🏽‍♀️ 🙎🏾‍♀️ 🙎🏿‍♀️
🙅|person gesturing NO|forbidden gesture hand not prohibit|no_good|0.6|🙅🏻 🙅🏼 🙅🏽 🙅🏾 🙅🏿
🙅‍♂️|man gesturing NO|forbidden gesture hand not prohibit|ng_man no_good_man|4|🙅🏻‍♂️ 🙅🏼‍♂️ 🙅🏽‍♂️ 🙅🏾‍♂️ 🙅🏿‍♂️
🙅‍♀️|woman gesturing NO|forbidden gesture hand not prohibit|ng_woman no_good_woman|4|🙅🏻‍♀️ 🙅🏼‍♀️ 🙅🏽‍♀️ 🙅🏾‍♀️ 🙅🏿‍♀️
🙆|person gesturing OK|exercise gesture hand omg|ok_person|0.6|🙆🏻 🙆🏼 🙆🏽 🙆🏾 🙆🏿
🙆‍♂️|man gesturing OK|exercise gesture hand omg|ok_man|4|🙆🏻‍♂️ 🙆🏼‍♂️ 🙆🏽‍♂️ 🙆🏾‍♂️ 🙆🏿‍♂️
🙆‍♀️|woman gesturing OK|exercise gesture hand omg|ok_woman|4|🙆🏻‍♀️ 🙆🏼‍♀️ 🙆🏽‍♀️ 🙆🏾‍♀️ 🙆🏿‍♀️
💁|person tipping hand|fetch flick flip gossip sarcasm sarcastic|information_desk_person tipping_hand_person|0.6|💁🏻 💁🏼 💁🏽 💁🏾 💁🏿
💁‍♂️|man tipping hand|fetch flick flip gossip sarcasm sarcastic|sassy_man tipping_hand_man|4|💁🏻‍♂️ 💁🏼‍♂️ 💁🏽‍♂️ 💁🏾‍♂️ 💁🏿‍♂️
💁‍♀️|woman tipping hand|fetch flick flip gossip sarcasm sarcastic|sassy_woman tipping_hand_woman|4|💁🏻‍♀️ 💁🏼‍♀️ 💁🏽‍♀️ 💁🏾‍♀️ 💁🏿‍♀️
🙋|person raising hand|gesture here know me pick question|raising_hand|0.6|🙋🏻 🙋🏼 🙋🏽 🙋🏾 🙋🏿
🙋‍♂️|man raising hand|gesture here know me pick question|raising_hand_man|4|🙋🏻‍♂️ 🙋🏼‍♂️ 🙋🏽‍♂️ 🙋🏾‍♂️ 🙋🏿‍♂️
🙋‍♀️|woman raising hand|gesture here know me pick question|raising_hand_woman|4|🙋🏻‍♀️ 🙋🏼‍♀️ 🙋🏽‍♀️ 🙋🏾‍♀️ 🙋🏿‍♀️
🧏|deaf person|accessibility ear gesture hear|deaf_person|12|🧏🏻 🧏🏼 🧏🏽 🧏🏾 🧏🏿
🧏‍♂️|deaf man|accessibility ear gesture hear|deaf_man|12|🧏🏻‍♂️ 🧏🏼‍♂️ 🧏🏽‍♂️ 🧏🏾‍♂️ 🧏🏿‍♂️
🧏‍♀️|deaf woman|accessibility ear gesture hear|deaf_woman|12|🧏🏻‍♀️ 🧏🏼‍♀️ 🧏🏽‍♀️ 🧏🏾‍♀️ 🧏🏿‍♀️
🙇|person bowing|apology ask beg bow favor forgive|bow|0.6|🙇🏻 🙇🏼 🙇🏽 🙇🏾 🙇🏿
🙇‍♂️|man bowing|apology ask beg bow favor forgive|bowing_man|4|🙇🏻‍♂️ 🙇🏼‍♂️ 🙇🏽‍♂️ 🙇🏾‍♂️ 🙇🏿‍♂️
🙇‍♀️|woman bowing|apology ask beg bow favor forgive|bowing_woman|4|🙇🏻‍♀️ 🙇🏼‍♀️ 🙇🏽‍♀️ 🙇🏾‍♀️ 🙇🏿‍♀️
🤦|person facepalming|again bewilder disbelief exasperation facepalm no|facepalm|3|🤦🏻 🤦🏼 🤦🏽 🤦🏾 🤦🏿
🤦‍♂️|man facepalming|again bewilder disbelief exasperation facepalm no|man_facepalming|4|🤦🏻‍♂️ 🤦🏼‍♂️ 🤦🏽‍♂️ 🤦🏾‍♂️ 🤦🏿‍♂️
🤦‍♀️|woman facepalming|again bewilder disbelief exasperation facepalm no|woman_facepalming|4|🤦🏻‍♀️ 🤦🏼‍♀️ 🤦🏽‍♀️ 🤦🏾‍♀️ 🤦🏿‍♀️
🤷|person shrugging|doubt dunno guess idk ignorance indifference|shrug|3|🤷🏻 🤷🏼 🤷🏽 🤷🏾 🤷🏿
🤷‍♂️|man shrugging|doubt dunno guess idk ignorance indifference|man_shrugging|4|🤷🏻‍♂️ 🤷🏼‍♂️ 🤷🏽‍♂️ 🤷🏾‍♂️ 🤷🏿‍♂️
🤷‍♀️|woman shrugging|doubt dunno guess idk ignorance indifference|woman_shrugging|4|🤷🏻‍♀️ 🤷🏼‍♀️ 🤷🏽‍♀️ 🤷🏾‍♀️ 🤷🏿‍♀️
🧑‍⚕️|health worker|doctor healthcare nurse therapist|health_worker|12.1|🧑🏻‍⚕️ 🧑🏼‍⚕️ 🧑🏽‍⚕️ 🧑🏾‍⚕️ 🧑🏿‍⚕️
👨‍⚕️|man health worker|doctor healthcare nurse therapist|man_health_worker|4|👨🏻‍⚕️ 👨🏼‍⚕️ 👨🏽‍⚕️ 👨🏾‍⚕️ 👨🏿‍⚕️
👩‍⚕️|woman health worker|doctor healthcare nurse therapist|woman_health_worker|4|👩🏻‍⚕️ 👩🏼‍⚕️ 👩🏽‍⚕️ 👩🏾‍⚕️ 👩🏿‍⚕️
🧑‍🎓|student|graduate|student|12.1|🧑🏻‍🎓 🧑🏼‍🎓 🧑🏽‍🎓 🧑🏾‍🎓 🧑🏿‍🎓
👨‍🎓|man student|graduate|man_student|4|👨🏻‍🎓 👨🏼‍🎓 👨🏽‍🎓 👨🏾‍🎓 👨🏿‍🎓
👩‍🎓|woman student|graduate|woman_student|4|👩🏻‍🎓 👩🏼‍🎓 👩🏽‍🎓 👩🏾‍🎓 👩🏿‍🎓
🧑‍🏫|teacher|instructor lecturer professor|teacher|12.1|🧑🏻‍🏫 🧑🏼‍🏫 🧑🏽‍🏫 🧑🏾‍🏫 🧑🏿‍🏫
👨‍🏫|man teacher|instructor lecturer professor|man_teacher|4|👨🏻‍🏫 👨🏼‍🏫 👨🏽‍🏫 👨🏾‍🏫 👨🏿‍🏫
👩‍🏫|woman teacher|instructor lecturer professor|woman_teacher|4|👩🏻‍🏫 👩🏼‍🏫 👩🏽‍🏫 👩🏾‍🏫 👩🏿‍🏫
🧑‍⚖️|judge|justice law scales|judge|12.1|🧑🏻‍⚖️ 🧑🏼‍⚖️ 🧑🏽‍⚖️ 🧑🏾‍⚖️ 🧑🏿‍⚖️
👨‍⚖️|man judge|justice law scales|man_judge|4|👨🏻‍⚖️ 👨🏼‍⚖️ 👨🏽‍⚖️ 👨🏾‍⚖️ 👨🏿‍⚖️
👩‍⚖️|woman judge|justice law scales|woman_judge|4|👩🏻‍⚖️ 👩🏼‍⚖️ 👩🏽‍⚖️ 👩🏾‍⚖️ 👩🏿‍⚖️
🧑‍🌾|farmer|gardener rancher|farmer|12.1|🧑🏻‍🌾 🧑🏼‍🌾 🧑🏽‍🌾 🧑🏾‍🌾 🧑🏿‍🌾
👨‍🌾|man farmer|gardener rancher|man_farmer|4|👨🏻‍🌾 👨🏼‍🌾 👨🏽‍🌾 👨🏾‍🌾 👨🏿‍🌾
👩‍🌾|woman farmer|gardener rancher|woman_farmer|4|👩🏻‍🌾 👩🏼‍🌾 👩🏽‍🌾 👩🏾‍🌾 👩🏿‍🌾
🧑‍🍳|cook|chef|cook|12.1|🧑🏻‍🍳 🧑🏼‍🍳 🧑🏽‍🍳 🧑🏾‍🍳 🧑🏿‍🍳
👨‍🍳|man cook|chef|man_cook|4|👨🏻‍🍳 👨🏼‍🍳 👨🏽‍🍳 👨🏾‍🍳 👨🏿‍🍳
👩‍🍳|woman cook|chef|woman_cook|4|👩🏻‍🍳 👩🏼‍🍳 👩🏽‍🍳 👩🏾‍🍳 👩🏿‍🍳
🧑‍🔧|mechanic|electrician plumber tradesperson|mechanic|12.1|🧑🏻‍🔧 🧑🏼‍🔧 🧑🏽‍🔧 🧑🏾‍🔧 🧑🏿‍🔧
👨‍🔧|man mechanic|electrician plumber tradesperson|man_mechanic|4|👨🏻‍🔧 👨🏼‍🔧 👨🏽‍🔧 👨🏾‍🔧 👨🏿‍🔧
👩‍🔧|woman mechanic|electrician plumber tradesperson|woman_mechanic|4|👩🏻‍🔧 👩🏼‍🔧 👩🏽‍🔧 👩🏾‍🔧 👩🏿‍🔧
🧑‍🏭|factory worker|assembly industrial|factory_worker|12.1|🧑🏻‍🏭 🧑🏼‍🏭 🧑🏽‍🏭 🧑🏾‍🏭 🧑🏿‍🏭
👨‍🏭|man factory worker|assembly industrial|man_factory_worker|4|👨🏻‍🏭 👨🏼‍🏭 👨🏽‍🏭 👨🏾‍🏭 👨🏿‍🏭
👩‍🏭|woman factory worker|assembly industrial|woman_factory_worker|4|👩🏻‍🏭 👩🏼‍🏭 👩🏽‍🏭 👩🏾‍🏭 👩🏿‍🏭
🧑‍💼|office worker|architect business manager white-collar|office_worker|12.1|🧑🏻‍💼 🧑🏼‍💼 🧑🏽‍💼 🧑🏾‍💼 🧑🏿‍💼
👨‍💼|man office worker|architect business manager white-collar|man_office_worker|4|👨🏻‍💼 👨🏼‍💼 👨🏽‍💼 👨🏾‍💼 👨🏿‍💼
👩‍💼|woman office worker|architect business manager white-collar|woman_office_worker|4|👩🏻‍💼 👩🏼‍💼 👩🏽‍💼 👩🏾‍💼 👩🏿‍💼
🧑‍🔬|scientist|biologist chemist engineer mathematician physicist|scientist|12.1|🧑🏻‍🔬 🧑🏼‍🔬 🧑🏽‍🔬 🧑🏾‍🔬 🧑🏿‍🔬
👨‍🔬|man scientist|biologist chemist engineer mathematician physicist|man_scientist|4|👨🏻‍🔬 👨🏼‍🔬 👨🏽‍🔬 👨🏾‍🔬 👨🏿‍🔬
👩‍🔬|woman scientist|biologist chemist engineer mathematician physicist|woman_scientist|4|👩🏻‍🔬 👩🏼‍🔬 👩🏽‍🔬 👩🏾‍🔬 👩🏿‍🔬
🧑‍💻|technologist|coder computer developer inventor software|technologist|12.1|🧑🏻‍💻 🧑🏼‍💻 🧑🏽‍💻 🧑🏾‍💻 🧑🏿‍💻
👨‍💻|man technologist|coder computer developer inventor software|man_technologist|4|👨🏻‍💻 👨🏼‍💻 👨🏽‍💻 👨🏾‍💻 👨🏿‍💻
👩‍💻|woman technologist|coder computer developer inventor software|woman_technologist|4|👩🏻‍💻 👩🏼‍💻 👩🏽‍💻 👩🏾‍💻 👩🏿‍💻
🧑‍🎤|singer|actor entertainer rock rockstar star|singer|12.1|🧑🏻‍🎤 🧑🏼‍🎤 🧑🏽‍🎤 🧑🏾‍🎤 🧑🏿‍🎤
👨‍🎤|man singer|actor entertainer rock rockstar star|man_singer|4|👨🏻‍🎤 👨🏼‍🎤 👨🏽‍🎤 👨🏾‍🎤 👨🏿‍🎤
👩‍🎤|woman singer|actor entertainer rock rockstar star|woman_singer|4|👩🏻‍🎤 👩🏼‍🎤 👩🏽‍🎤 👩🏾‍🎤 👩🏿‍🎤
🧑‍🎨|artist|palette|artist|12.1|🧑🏻‍🎨 🧑🏼‍🎨 🧑🏽‍🎨 🧑🏾‍🎨 🧑🏿‍🎨
👨‍🎨|man artist|palette|man_artist|4|👨🏻‍🎨 👨🏼‍🎨 👨🏽‍🎨 👨🏾‍🎨 👨🏿‍🎨
👩‍🎨|woman artist|palette|woman_artist|4|👩🏻‍🎨 👩🏼‍🎨 👩🏽‍🎨 👩🏾‍🎨 👩🏿‍🎨
🧑‍✈️|pilot|plane|pilot|12.1|🧑🏻‍✈️ 🧑🏼‍✈️ 🧑🏽‍✈️ 🧑🏾‍✈️ 🧑🏿‍✈️
👨‍✈️|man pilot|plane|man_pilot|4|👨🏻‍✈️ 👨🏼‍✈️ 👨🏽‍✈️ 👨🏾‍✈️ 👨🏿‍✈️
👩‍✈️|woman pilot|plane|woman_pilot|4|👩🏻‍✈️ 👩🏼‍✈️ 👩🏽‍✈️ 👩🏾‍✈️ 👩🏿‍✈️
🧑‍🚀|astronaut|rocket space|astronaut|12.1|🧑🏻‍🚀 🧑🏼‍🚀 🧑🏽‍🚀 🧑🏾‍🚀 🧑🏿‍🚀
👨‍🚀|man astronaut|rocket space|man_astronaut|4|👨🏻‍🚀 👨🏼‍🚀 👨🏽‍🚀 👨🏾‍🚀 👨🏿‍🚀
👩‍🚀|woman astronaut|rocket space|woman_astronaut|4|👩🏻‍🚀 👩🏼‍🚀 👩🏽‍🚀 👩🏾‍🚀 👩🏿‍🚀
🧑‍🚒|firefighter|fire firetruck|firefighter|12.1|🧑🏻‍🚒 🧑🏼‍🚒 🧑🏽‍🚒 🧑🏾‍🚒 🧑🏿‍🚒
👨‍🚒|man firefighter|fire firetruck|man_firefighter|4|👨🏻‍🚒 👨🏼‍🚒 👨🏽‍🚒 👨🏾‍🚒 👨🏿‍🚒
👩‍🚒|woman firefighter|fire firetruck|woman_firefighter|4|👩🏻‍🚒 👩🏼‍🚒 👩🏽‍🚒 👩🏾‍🚒 👩🏿‍🚒
👮|police officer|apprehend arrest citation cop law over|cop police_officer|0.6|👮🏻 👮🏼 👮🏽 👮🏾 👮🏿
👮‍♂️|man police officer|apprehend arrest citation cop law over|policeman|4|👮🏻‍♂️ 👮🏼‍♂️ 👮🏽‍♂️ 👮🏾‍♂️ 👮🏿‍♂️
👮‍♀️|woman police officer|apprehend arrest citation cop law over|policewoman|4|👮🏻‍♀️ 👮🏼‍♀️ 👮🏽‍♀️ 👮🏾‍♀️ 👮🏿‍♀️
🕵️|detective|sleuth spy|detective|0.7|🕵🏻 🕵🏼 🕵🏽 🕵🏾 🕵🏿
🕵️‍♂️|man detective|sleuth spy|male_detective|4|🕵🏻‍♂️ 🕵🏼‍♂️ 🕵🏽‍♂️ 🕵🏾‍♂️ 🕵🏿‍♂️
🕵️‍♀️|woman detective|sleuth spy|female_detective|4|🕵🏻‍♀️ 🕵🏼‍♀️ 🕵🏽‍♀️ 🕵🏾‍♀️ 🕵🏿‍♀️
💂|guard|buckingham helmet london palace|guard|0.6|💂🏻 💂🏼 💂🏽 💂🏾 💂🏿
💂‍♂️|man guard|buckingham helmet london palace|guardsman|4|💂🏻‍♂️ 💂🏼‍♂️ 💂🏽‍♂️ 💂🏾‍♂️ 💂🏿‍♂️
💂‍♀️|woman guard|buckingham helmet london palace|guardswoman|4|💂🏻‍♀️ 💂🏼‍♀️ 💂🏽‍♀️ 💂🏾‍♀️ 💂🏿‍♀️
🥷|ninja|assassin fight fighter hidden person secret|ninja|13|🥷🏻 🥷🏼 🥷🏽 🥷🏾 🥷🏿
👷|construction worker|build fix hardhat hat man person|construction_worker|0.6|👷🏻 👷🏼 👷🏽 👷🏾 👷🏿
👷‍♂️|man construction worker|build fix hardhat hat rebuild remodel|construction_worker_man|4|👷🏻‍♂️ 👷🏼‍♂️ 👷🏽‍♂️ 👷🏾‍♂️ 👷🏿‍♂️
👷‍♀️|woman construction worker|build fix hardhat hat man rebuild|construction_worker_woman|4|👷🏻‍♀️ 👷🏼‍♀️ 👷🏽‍♀️ 👷🏾‍♀️ 👷🏿‍♀️
🫅|person with crown|monarch noble regal royal royalty|person_with_crown|14|🫅🏻 🫅🏼 🫅🏽 🫅🏾 🫅🏿
🤴|prince|crown fairy fairytale fantasy king royal|prince|3|🤴🏻 🤴🏼 🤴🏽 🤴🏾 🤴🏿
👸|princess|crown fairy fairytale fantasy queen royal|princess|0.6|👸🏻 👸🏼 👸🏽 👸🏾 👸🏿
👳|person wearing turban||person_with_turban|0.6|👳🏻 👳🏼 👳🏽 👳🏾 👳🏿
👳‍♂️|man wearing turban||man_with_turban|4|👳🏻‍♂️ 👳🏼‍♂️ 👳🏽‍♂️ 👳🏾‍♂️ 👳🏿‍♂️
👳‍♀️|woman wearing turban||woman_with_turban|4|👳🏻‍♀️ 👳🏼‍♀️ 👳🏽‍♀️ 👳🏾‍♀️ 👳🏿‍♀️
👲|person with skullcap|chinese cap gua guapi hat mao|man_with_gua_pi_mao|0.6|👲🏻 👲🏼 👲🏽 👲🏾 👲🏿
🧕|woman with headscarf|bandana head hijab kerchief mantilla tichel|woman_with_headscarf|5|🧕🏻 🧕🏼 🧕🏽 🧕🏾 🧕🏿
🤵|person in tuxedo|formal wedding|person_in_tuxedo|3|🤵🏻 🤵🏼 🤵🏽 🤵🏾 🤵🏿
🤵‍♂️|man in tuxedo|formal groom wedding|man_in_tuxedo|13|🤵🏻‍♂️ 🤵🏼‍♂️ 🤵🏽‍♂️ 🤵🏾‍♂️ 🤵🏿‍♂️
🤵‍♀️|woman in tuxedo|formal wedding|woman_in_tuxedo|13|🤵🏻‍♀️ 🤵🏼‍♀️ 🤵🏽‍♀️ 🤵🏾‍♀️ 🤵🏿‍♀️
👰|person with veil|wedding|person_with_veil|0.6|👰🏻 👰🏼 👰🏽 👰🏾 👰🏿
👰‍♂️|man with veil|wedding|man_with_veil|13|👰🏻‍♂️ 👰🏼‍♂️ 👰🏽‍♂️ 👰🏾‍♂️ 👰🏿‍♂️
👰‍♀️|woman with veil|bride wedding|bride_with_veil woman_with_veil|13|👰🏻‍♀️ 👰🏼‍♀️ 👰🏽‍♀️ 👰🏾‍♀️ 👰🏿‍♀️
🤰|pregnant woman||pregnant_woman|3|🤰🏻 🤰🏼 🤰🏽 🤰🏾 🤰🏿
🫃|pregnant man|belly bloated full overeat|pregnant_man|14|🫃🏻 🫃🏼 🫃🏽 🫃🏾 🫃🏿
🫄|pregnant person|belly bloated full overeat stuffed|pregnant_person|14|🫄🏻 🫄🏼 🫄🏽 🫄🏾 🫄🏿
🤱|breast-feeding|baby mom mother nursing woman|breast_feeding|5|🤱🏻 🤱🏼 🤱🏽 🤱🏾 🤱🏿
👩‍🍼|woman feeding baby|feed mom mother nanny newborn nursing|woman_feeding_baby|13|👩🏻‍🍼 👩🏼‍🍼 👩🏽‍🍼 👩🏾‍🍼 👩🏿‍🍼
👨‍🍼|man feeding baby|dad father feed nanny newborn nursing|man_feeding_baby|13|👨🏻‍🍼 👨🏼‍🍼 👨🏽‍🍼 👨🏾‍🍼 👨🏿‍🍼
🧑‍🍼|person feeding baby|feed nanny newborn nursing parent|person_feeding_baby|13|🧑🏻‍🍼 🧑🏼‍🍼 🧑🏽‍🍼 🧑🏾‍🍼 🧑🏿‍🍼
👼|baby angel|church face fairy fairytale fantasy tale|angel|0.6|👼🏻 👼🏼 👼🏽 👼🏾 👼🏿
🎅|Santa Claus|christmas celebration fairy fantasy father holiday|santa|0.6|🎅🏻 🎅🏼 🎅🏽 🎅🏾 🎅🏿
🤶|Mrs. Claus|christmas mrs celebration fairy fantasy holiday|mrs_claus|3|🤶🏻 🤶🏼 🤶🏽 🤶🏾 🤶🏿
🧑‍🎄|Mx Claus|christmas celebration fairy fantasy holiday merry|mx_claus|13|🧑🏻‍🎄 🧑🏼‍🎄 🧑🏽‍🎄 🧑🏾‍🎄 🧑🏿‍🎄
🦸|superhero|good hero superpower|superhero|11|🦸🏻 🦸🏼 🦸🏽 🦸🏾 🦸🏿
🦸‍♂️|man superhero|good hero superpower|superhero_man|11|🦸🏻‍♂️ 🦸🏼‍♂️ 🦸🏽‍♂️ 🦸🏾‍♂️ 🦸🏿‍♂️
🦸‍♀️|woman superhero|good hero heroine superpower|superhero_woman|11|🦸🏻‍♀️ 🦸🏼‍♀️ 🦸🏽‍♀️ 🦸🏾‍♀️ 🦸🏿‍♀️
🦹|supervillain|bad criminal evil superpower villain|supervillain|11|🦹🏻 🦹🏼 🦹🏽 🦹🏾 🦹🏿
🦹‍♂️|man supervillain|bad criminal evil superpower villain|supervillain_man|11|🦹🏻‍♂️ 🦹🏼‍♂️ 🦹🏽‍♂️ 🦹🏾‍♂️ 🦹🏿‍♂️
🦹‍♀️|woman supervillain|bad criminal evil superpower villain|supervillain_woman|11|🦹🏻‍♀️ 🦹🏼‍♀️ 🦹🏽‍♀️ 🦹🏾‍♀️ 🦹🏿‍♀️
🧙|mage|fantasy magic play sorcerer sorceress sorcery|mage|5|🧙🏻 🧙🏼 🧙🏽 🧙🏾 🧙🏿
🧙‍♂️|man mage|fantasy magic play sorcerer sorceress sorcery|mage_man|5|🧙🏻‍♂️ 🧙🏼‍♂️ 🧙🏽‍♂️ 🧙🏾‍♂️ 🧙🏿‍♂️
🧙‍♀️|woman mage|fantasy magic play sorcerer sorceress sorcery|mage_woman|5|🧙🏻‍♀️ 🧙🏼‍♀️ 🧙🏽‍♀️ 🧙🏾‍♀️ 🧙🏿‍♀️
🧚|fairy|fairytale fantasy myth person pixie tale|fairy|5|🧚🏻 🧚🏼 🧚🏽 🧚🏾 🧚🏿
🧚‍♂️|man fairy|oberon puck fairytale fantasy myth person|fairy_man|5|🧚🏻‍♂️ 🧚🏼‍♂️ 🧚🏽‍♂️ 🧚🏾‍♂️ 🧚🏿‍♂️
🧚‍♀️|woman fairy|titania fairytale fantasy myth person pixie|fairy_woman|5|🧚🏻‍♀️ 🧚🏼‍♀️ 🧚🏽‍♀️ 🧚🏾‍♀️ 🧚🏿‍♀️
🧛|vampire|dracula blood fangs halloween scary supernatural|vampire|5|🧛🏻 🧛🏼 🧛🏽 🧛🏾 🧛🏿
🧛‍♂️|man vampire|blood fangs halloween scary supernatural teeth|vampire_man|5|🧛🏻‍♂️ 🧛🏼‍♂️ 🧛🏽‍♂️ 🧛🏾‍♂️ 🧛🏿‍♂️
🧛‍♀️|woman vampire|blood fangs halloween scary supernatural teeth|vampire_woman|5|🧛🏻‍♀️ 🧛🏼‍♀️ 🧛🏽‍♀️ 🧛🏾‍♀️ 🧛🏿‍♀️
🧜|merperson|creature fairytale folklore ocean sea siren|merperson|5|🧜🏻 🧜🏼 🧜🏽 🧜🏾 🧜🏿
🧜‍♂️|merman|neptune poseidon triton creature fairytale folklore|merman|5|🧜🏻‍♂️ 🧜🏼‍♂️ 🧜🏽‍♂️ 🧜🏾‍♂️ 🧜🏿‍♂️
🧜‍♀️|mermaid|creature fairytale folklore merwoman ocean sea|mermaid|5|🧜🏻‍♀️ 🧜🏼‍♀️ 🧜🏽‍♀️ 🧜🏾‍♀️ 🧜🏿‍♀️
🧝|elf|elves enchantment fantasy folklore magic magical|elf|5|🧝🏻 🧝🏼 🧝🏽 🧝🏾 🧝🏿
🧝‍♂️|man elf|elves enchantment fantasy folklore magic magical|elf_man|5|🧝🏻‍♂️ 🧝🏼‍♂️ 🧝🏽‍♂️ 🧝🏾‍♂️ 🧝🏿‍♂️
🧝‍♀️|woman elf|elves enchantment fantasy folklore magic magical|elf_woman|5|🧝🏻‍♀️ 🧝🏼‍♀️ 🧝🏽‍♀️ 🧝🏾‍♀️ 🧝🏿‍♀️
🧞|genie|djinn fantasy jinn lamp myth rub|genie|5|
🧞‍♂️|man genie|djinn fantasy jinn lamp myth rub|genie_man|5|
🧞‍♀️|woman genie|djinn fantasy jinn lamp myth rub|genie_woman|5|
🧟|zombie|apocalypse dead halloween horror scary undead|zombie|5|
🧟‍♂️|man zombie|apocalypse dead halloween horror scary undead|zombie_man|5|
🧟‍♀️|woman zombie|apocalypse dead halloween horror scary undead|zombie_woman|5|
🧌|troll|fairy fantasy monster tale trolling|troll|14|
🫈|hairy creature|bigfoot cryptid forest giant sasquatch woodwose||17|
💆|person getting massage|face headache relax relaxing salon soothe|massage|0.6|💆🏻 💆🏼 💆🏽 💆🏾 💆🏿
💆‍♂️|man getting massage|face headache relax relaxing salon soothe|massage_man|4|💆🏻‍♂️ 💆🏼‍♂️ 💆🏽‍♂️ 💆🏾‍♂️ 💆🏿‍♂️
💆‍♀️|woman getting massage|face headache relax relaxing salon soothe|massage_woman|4|💆🏻‍♀️ 💆🏼‍♀️ 💆🏽‍♀️ 💆🏾‍♀️ 💆🏿‍♀️
💇|person getting haircut|barber beauty chop cosmetology cut groom|haircut|0.6|💇🏻 💇🏼 💇🏽 💇🏾 💇🏿
💇‍♂️|man getting haircut|barber beauty chop cosmetology cut groom|haircut_man|4|💇🏻‍♂️ 💇🏼‍♂️ 💇🏽‍♂️ 💇🏾‍♂️ 💇🏿‍♂️
💇‍♀️|woman getting haircut|barber beauty chop cosmetology cut groom|haircut_woman|4|💇🏻‍♀️ 💇🏼‍♀️ 💇🏽‍♀️ 💇🏾‍♀️ 💇🏿‍♀️
🚶|person walking|amble gait hike man pace pedestrian|walking|0.6|🚶🏻 🚶🏼 🚶🏽 🚶🏾 🚶🏿
🚶‍♂️|man walking|amble gait hike pace pedestrian stride|walking_man|4|🚶🏻‍♂️ 🚶🏼‍♂️ 🚶🏽‍♂️ 🚶🏾‍♂️ 🚶🏿‍♂️
🚶‍♀️|woman walking|amble gait hike man pace pedestrian|walking_woman|4|🚶🏻‍♀️ 🚶🏼‍♀️ 🚶🏽‍♀️ 🚶🏾‍♀️ 🚶🏿‍♀️
🚶‍➡️|person walking: facing right|amble gait hike man pace pedestrian||15.1|🚶🏻‍➡️ 🚶🏼‍➡️ 🚶🏽‍➡️ 🚶🏾‍➡️ 🚶🏿‍➡️
🚶‍♀️‍➡️|woman walking: facing right|amble gait hike man pace pedestrian||15.1|🚶🏻‍♀️‍➡️ 🚶🏼‍♀️‍➡️ 🚶🏽‍♀️‍➡️ 🚶🏾‍♀️‍➡️ 🚶🏿‍♀️‍➡️
🚶‍♂️‍➡️|man walking: facing right|amble gait hike pace pedestrian stride||15.1|🚶🏻‍♂️‍➡️ 🚶🏼‍♂️‍➡️ 🚶🏽‍♂️‍➡️ 🚶🏾‍♂️‍➡️ 🚶🏿‍♂️‍➡️
🧍|person standing|stand|standing_person|12|🧍🏻 🧍🏼 🧍🏽 🧍🏾 🧍🏿
🧍‍♂️|man standing|stand|standing_man|12|🧍🏻‍♂️ 🧍🏼‍♂️ 🧍🏽‍♂️ 🧍🏾‍♂️ 🧍🏿‍♂️
🧍‍♀️|woman standing|stand|standing_woman|12|🧍🏻‍♀️ 🧍🏼‍♀️ 🧍🏽‍♀️ 🧍🏾‍♀️ 🧍🏿‍♀️
🧎|person kneeling|kneel knees|kneeling_person|12|🧎🏻 🧎🏼 🧎🏽 🧎🏾 🧎🏿
🧎‍♂️|man kneeling|kneel knees|kneeling_man|12|🧎🏻‍♂️ 🧎🏼‍♂️ 🧎🏽‍♂️ 🧎🏾‍♂️ 🧎🏿‍♂️
🧎‍♀️|woman kneeling|kneel knees|kneeling_woman|12|🧎🏻‍♀️ 🧎🏼‍♀️ 🧎🏽‍♀️ 🧎🏾‍♀️ 🧎🏿‍♀️
🧎‍➡️|person kneeling: facing right|kneel knees||15.1|🧎🏻‍➡️ 🧎🏼‍➡️ 🧎🏽‍➡️ 🧎🏾‍➡️ 🧎🏿‍➡️
🧎‍♀️‍➡️|woman kneeling: facing right|kneel knees||15.1|🧎🏻‍♀️‍➡️ 🧎🏼‍♀️‍➡️ 🧎🏽‍♀️‍➡️ 🧎🏾‍♀️‍➡️ 🧎🏿‍♀️‍➡️
🧎‍♂️‍➡️|man kneeling: facing right|kneel knees||15.1|🧎🏻‍♂️‍➡️ 🧎🏼‍♂️‍➡️ 🧎🏽‍♂️‍➡️ 🧎🏾‍♂️‍➡️ 🧎🏿‍♂️‍➡️
🧑‍🦯|person with white cane|accessibility blind probing|person_with_probing_cane|12.1|🧑🏻‍🦯 🧑🏼‍🦯 🧑🏽‍🦯 🧑🏾‍🦯 🧑🏿‍🦯
🧑‍🦯‍➡️|person with white cane: facing right|accessibility blind probing||15.1|🧑🏻‍🦯‍➡️ 🧑🏼‍🦯‍➡️ 🧑🏽‍🦯‍➡️ 🧑🏾‍🦯‍➡️ 🧑🏿‍🦯‍➡️
👨‍🦯|man with white cane|accessibility blind probing|man_with_probing_cane|12|👨🏻‍🦯 👨🏼‍🦯 👨🏽‍🦯 👨🏾‍🦯 👨🏿‍🦯
👨‍🦯‍➡️|man with white cane: facing right|accessibility blind probing||15.1|👨🏻‍🦯‍➡️ 👨🏼‍🦯‍➡️ 👨🏽‍🦯‍➡️ 👨🏾‍🦯‍➡️ 👨🏿‍🦯‍➡️
👩‍🦯|woman with white cane|accessibility blind probing|woman_with_probing_cane|12|👩🏻‍🦯 👩🏼‍🦯 👩🏽‍🦯 👩🏾‍🦯 👩🏿‍🦯
👩‍🦯‍➡️|woman with white cane: facing right|accessibility blind probing||15.1|👩🏻‍🦯‍➡️ 👩🏼‍🦯‍➡️ 👩🏽‍🦯‍➡️ 👩🏾‍🦯‍➡️ 👩🏿‍🦯‍➡️
🧑‍🦼|person in motorized wheelchair|accessibility|person_in_motorized_wheelchair|12.1|🧑🏻‍🦼 🧑🏼‍🦼 🧑🏽‍🦼 🧑🏾‍🦼 🧑🏿‍🦼
🧑‍🦼‍➡️|person in motorized wheelchair: facing right|accessibility||15.1|🧑🏻‍🦼‍➡️ 🧑🏼‍🦼‍➡️ 🧑🏽‍🦼‍➡️ 🧑🏾‍🦼‍➡️ 🧑🏿‍🦼‍➡️
👨‍🦼|man in motorized wheelchair|accessibility|man_in_motorized_wheelchair|12|👨🏻‍🦼 👨🏼‍🦼 👨🏽‍🦼 👨🏾‍🦼 👨🏿‍🦼
👨‍🦼‍➡️|man in motorized wheelchair: facing right|accessibility||15.1|👨🏻‍🦼‍➡️ 👨🏼‍🦼‍➡️ 👨🏽‍🦼‍➡️ 👨🏾‍🦼‍➡️ 👨🏿‍🦼‍➡️
👩‍🦼|woman in motorized wheelchair|accessibility|woman_in_motorized_wheelchair|12|👩🏻‍🦼 👩🏼‍🦼 👩🏽‍🦼 👩🏾‍🦼 👩🏿‍🦼
👩‍🦼‍➡️|woman in motorized wheelchair: facing right|accessibility||15.1|👩🏻‍🦼‍➡️ 👩🏼‍🦼‍➡️ 👩🏽‍🦼‍➡️ 👩🏾‍🦼‍➡️ 👩🏿‍🦼‍➡️
🧑‍🦽|person in manual wheelchair|accessibility|person_in_manual_wheelchair|12.1|🧑🏻‍🦽 🧑🏼‍🦽 🧑🏽‍🦽 🧑🏾‍🦽 🧑🏿‍🦽
🧑‍🦽‍➡️|person in manual wheelchair: facing right|accessibility||15.1|🧑🏻‍🦽‍➡️ 🧑🏼‍🦽‍➡️ 🧑🏽‍🦽‍➡️ 🧑🏾‍🦽‍➡️ 🧑🏿‍🦽‍➡️
👨‍🦽|man in manual wheelchair|accessibility|man_in_manual_wheelchair|12|👨🏻‍🦽 👨🏼‍🦽 👨🏽‍🦽 👨🏾‍🦽 👨🏿‍🦽
👨‍🦽‍➡️|man in manual wheelchair: facing right|accessibility||15.1|👨🏻‍🦽‍➡️ 👨🏼‍🦽‍➡️ 👨🏽‍🦽‍➡️ 👨🏾‍🦽‍➡️ 👨🏿‍🦽‍➡️
👩‍🦽|woman in manual wheelchair|accessibility|woman_in_manual_wheelchair|12|👩🏻‍🦽 👩🏼‍🦽 👩🏽‍🦽 👩🏾‍🦽 👩🏿‍🦽
👩‍🦽‍➡️|woman in manual wheelchair: facing right|accessibility||15.1|👩🏻‍🦽‍➡️ 👩🏼‍🦽‍➡️ 👩🏽‍🦽‍➡️ 👩🏾‍🦽‍➡️ 👩🏿‍🦽‍➡️
🏃|person running|fast hurry marathon move quick race|runner running|0.6|🏃🏻 🏃🏼 🏃🏽 🏃🏾 🏃🏿
🏃‍♂️|man running|fast hurry marathon move quick race|running_man|4|🏃🏻‍♂️ 🏃🏼‍♂️ 🏃🏽‍♂️ 🏃🏾‍♂️ 🏃🏿‍♂️
🏃‍♀️|woman running|fast hurry marathon move quick race|running_woman|4|🏃🏻‍♀️ 🏃🏼‍♀️ 🏃🏽‍♀️ 🏃🏾‍♀️ 🏃🏿‍♀️
🏃‍➡️|person running: facing right|fast hurry marathon move quick race||15.1|🏃🏻‍➡️ 🏃🏼‍➡️ 🏃🏽‍➡️ 🏃🏾‍➡️ 🏃🏿‍➡️
🏃‍♀️‍➡️|woman running: facing right|fast hurry marathon move quick race||15.1|🏃🏻‍♀️‍➡️ 🏃🏼‍♀️‍➡️ 🏃🏽‍♀️‍➡️ 🏃🏾‍♀️‍➡️ 🏃🏿‍♀️‍➡️
🏃‍♂️‍➡️|man running: facing right|fast hurry marathon move quick race||15.1|🏃🏻‍♂️‍➡️ 🏃🏼‍♂️‍➡️ 🏃🏽‍♂️‍➡️ 🏃🏾‍♂️‍➡️ 🏃🏿‍♂️‍➡️
🧑‍🩰|ballet dancer|||17|🧑🏻‍🩰 🧑🏼‍🩰 🧑🏽‍🩰 🧑🏾‍🩰 🧑🏿‍🩰
💃|woman dancing|dance dancer elegant festive flair flamenco|dancer woman_dancing|0.6|💃🏻 💃🏼 💃🏽 💃🏾 💃🏿
🕺|man dancing|dance dancer elegant festive flair flamenco|man_dancing|3|🕺🏻 🕺🏼 🕺🏽 🕺🏾 🕺🏿
🕴️|person in suit levitating|business|business_suit_levitating|0.7|🕴🏻 🕴🏼 🕴🏽 🕴🏾 🕴🏿
👯|people with bunny ears|bestie bff counterpart dancer double ear|dancers|0.6|👯🏻 👯🏼 👯🏽 👯🏾 👯🏿
👯‍♂️|men with bunny ears|bestie bff counterpart dancer double ear|dancing_men|4|👯🏻‍♂️ 👯🏼‍♂️ 👯🏽‍♂️ 👯🏾‍♂️ 👯🏿‍♂️
👯‍♀️|women with bunny ears|bestie bff counterpart dancer double ear|dancing_women|4|👯🏻‍♀️ 👯🏼‍♀️ 👯🏽‍♀️ 👯🏾‍♀️ 👯🏿‍♀️
🧖|person in steamy room|day luxurious pamper relax sauna spa|sauna_person|5|🧖🏻 🧖🏼 🧖🏽 🧖🏾 🧖🏿
🧖‍♂️|man in steamy room|day luxurious pamper relax sauna spa|sauna_man|5|🧖🏻‍♂️ 🧖🏼‍♂️ 🧖🏽‍♂️ 🧖🏾‍♂️ 🧖🏿‍♂️
🧖‍♀️|woman in steamy room|day luxurious pamper relax sauna spa|sauna_woman|5|🧖🏻‍♀️ 🧖🏼‍♀️ 🧖🏽‍♀️ 🧖🏾‍♀️ 🧖🏿‍♀️
🧗|person climbing|climb climber mountain rock scale up|climbing|5|🧗🏻 🧗🏼 🧗🏽 🧗🏾 🧗🏿
🧗‍♂️|man climbing|climb climber mountain rock scale up|climbing_man|5|🧗🏻‍♂️ 🧗🏼‍♂️ 🧗🏽‍♂️ 🧗🏾‍♂️ 🧗🏿‍♂️
🧗‍♀️|woman climbing|climb climber mountain rock scale up|climbing_woman|5|🧗🏻‍♀️ 🧗🏼‍♀️ 🧗🏽‍♀️ 🧗🏾‍♀️ 🧗🏿‍♀️
🤺|person fencing|fencer sword|person_fencing|3|
🏇|horse racing|jockey racehorse riding sport|horse_racing|1|🏇🏻 🏇🏼 🏇🏽 🏇🏾 🏇🏿
⛷️|skier|ski snow|skier|0.7|
🏂|snowboarder|ski snow snowboard sport|snowboarder|0.6|🏂🏻 🏂🏼 🏂🏽 🏂🏾 🏂🏿
🏌️|person golfing|ball birdie caddy driving golf green|golfing|0.7|🏌🏻 🏌🏼 🏌🏽 🏌🏾 🏌🏿
🏌️‍♂️|man golfing|ball birdie caddy driving golf green|golfing_man|4|🏌🏻‍♂️ 🏌🏼‍♂️ 🏌🏽‍♂️ 🏌🏾‍♂️ 🏌🏿‍♂️
🏌️‍♀️|woman golfing|ball birdie caddy driving golf green|golfing_woman|4|🏌🏻‍♀️ 🏌🏼‍♀️ 🏌🏽‍♀️ 🏌🏾‍♀️ 🏌🏿‍♀️
🏄|person surfing|beach ocean sport surf surfer swell|surfer|0.6|🏄🏻 🏄🏼 🏄🏽 🏄🏾 🏄🏿
🏄‍♂️|man surfing|beach ocean sport surf surfer swell|surfing_man|4|🏄🏻‍♂️ 🏄🏼‍♂️ 🏄🏽‍♂️ 🏄🏾‍♂️ 🏄🏿‍♂️
🏄‍♀️|woman surfing|beach ocean person sport surf surfer|surfing_woman|4|🏄🏻‍♀️ 🏄🏼‍♀️ 🏄🏽‍♀️ 🏄🏾‍♀️ 🏄🏿‍♀️
🚣|person rowing boat|canoe cruise fishing lake oar paddle|rowboat|1|🚣🏻 🚣🏼 🚣🏽 🚣🏾 🚣🏿
🚣‍♂️|man rowing boat|canoe cruise fishing lake oar paddle|rowing_man|4|🚣🏻‍♂️ 🚣🏼‍♂️ 🚣🏽‍♂️ 🚣🏾‍♂️ 🚣🏿‍♂️
🚣‍♀️|woman rowing boat|canoe cruise fishing lake oar paddle|rowing_woman|4|🚣🏻‍♀️ 🚣🏼‍♀️ 🚣🏽‍♀️ 🚣🏾‍♀️ 🚣🏿‍♀️
🏊|person swimming|freestyle sport swim swimmer triathlon|swimmer|0.6|🏊🏻 🏊🏼 🏊🏽 🏊🏾 🏊🏿
🏊‍♂️|man swimming|freestyle sport swim swimmer triathlon|swimming_man|4|🏊🏻‍♂️ 🏊🏼‍♂️ 🏊🏽‍♂️ 🏊🏾‍♂️ 🏊🏿‍♂️
🏊‍♀️|woman swimming|freestyle man sport swim swimmer triathlon|swimming_woman|4|🏊🏻‍♀️ 🏊🏼‍♀️ 🏊🏽‍♀️ 🏊🏾‍♀️ 🏊🏿‍♀️
⛹️|person bouncing ball|athletic basketball championship dribble net player|bouncing_ball_person|0.7|⛹🏻 ⛹🏼 ⛹🏽 ⛹🏾 ⛹🏿
⛹️‍♂️|man bouncing ball|athletic basketball championship dribble net player|basketball_man bouncing_ball_man|4|⛹🏻‍♂️ ⛹🏼‍♂️ ⛹🏽‍♂️ ⛹🏾‍♂️ ⛹🏿‍♂️
⛹️‍♀️|woman bouncing ball|athletic basketball championship dribble net player|basketball_woman bouncing_ball_woman|4|⛹🏻‍♀️ ⛹🏼‍♀️ ⛹🏽‍♀️ ⛹🏾‍♀️ ⛹🏿‍♀️
🏋️|person lifting weights|barbell bodybuilder deadlift lifter powerlifting weight|weight_lifting|0.7|🏋🏻 🏋🏼 🏋🏽 🏋🏾 🏋🏿
🏋️‍♂️|man lifting weights|barbell bodybuilder deadlift lifter powerlifting weight|weight_lifting_man|4|🏋🏻‍♂️ 🏋🏼‍♂️ 🏋🏽‍♂️ 🏋🏾‍♂️ 🏋🏿‍♂️
🏋️‍♀️|woman lifting weights|barbell bodybuilder deadlift lifter powerlifting weight|weight_lifting_woman|4|🏋🏻‍♀️ 🏋🏼‍♀️ 🏋🏽‍♀️ 🏋🏾‍♀️ 🏋🏿‍♀️
🚴|person biking|bicycle bicyclist bike cycle cyclist riding|bicyclist|1|🚴🏻 🚴🏼 🚴🏽 🚴🏾 🚴🏿
🚴‍♂️|man biking|bicycle bicyclist bike cycle cyclist riding|biking_man|4|🚴🏻‍♂️ 🚴🏼‍♂️ 🚴🏽‍♂️ 🚴🏾‍♂️ 🚴🏿‍♂️
🚴‍♀️|woman biking|bicycle bicyclist bike cycle cyclist riding|biking_woman|4|🚴🏻‍♀️ 🚴🏼‍♀️ 🚴🏽‍♀️ 🚴🏾‍♀️ 🚴🏿‍♀️
🚵|person mountain biking|bicycle bicyclist bike cycle cyclist riding|mountain_bicyclist|1|🚵🏻 🚵🏼 🚵🏽 🚵🏾 🚵🏿
🚵‍♂️|man mountain biking|bicycle bicyclist bike cycle cyclist riding|mountain_biking_man|4|🚵🏻‍♂️ 🚵🏼‍♂️ 🚵🏽‍♂️ 🚵🏾‍♂️ 🚵🏿‍♂️
🚵‍♀️|woman mountain biking|bicycle bicyclist bike cycle cyclist riding|mountain_biking_woman|4|🚵🏻‍♀️ 🚵🏼‍♀️ 🚵🏽‍♀️ 🚵🏾‍♀️ 🚵🏿‍♀️
🤸|person cartwheeling|active cartwheel excited flip gymnastics happy|cartwheeling|3|🤸🏻 🤸🏼 🤸🏽 🤸🏾 🤸🏿
🤸‍♂️|man cartwheeling|active cartwheel excited flip gymnastics happy|man_cartwheeling|4|🤸🏻‍♂️ 🤸🏼‍♂️ 🤸🏽‍♂️ 🤸🏾‍♂️ 🤸🏿‍♂️
🤸‍♀️|woman cartwheeling|active cartwheel excited flip gymnastics happy|woman_cartwheeling|4|🤸🏻‍♀️ 🤸🏼‍♀️ 🤸🏽‍♀️ 🤸🏾‍♀️ 🤸🏿‍♀️
🤼|people wrestling|combat duel grapple ring tournament wrestle|wrestling|3|🤼🏻 🤼🏼 🤼🏽 🤼🏾 🤼🏿
🤼‍♂️|men wrestling|combat duel grapple ring tournament wrestle|men_wrestling|4|🤼🏻‍♂️ 🤼🏼‍♂️ 🤼🏽‍♂️ 🤼🏾‍♂️ 🤼🏿‍♂️
🤼‍♀️|women wrestling|combat duel grapple ring tournament wrestle|women_wrestling|4|🤼🏻‍♀️ 🤼🏼‍♀️ 🤼🏽‍♀️ 🤼🏾‍♀️ 🤼🏿‍♀️
🤽|person playing water polo|sport swimming waterpolo|water_polo|3|🤽🏻 🤽🏼 🤽🏽 🤽🏾 🤽🏿
🤽‍♂️|man playing water polo|sport swimming waterpolo|man_playing_water_polo|4|🤽🏻‍♂️ 🤽🏼‍♂️ 🤽🏽‍♂️ 🤽🏾‍♂️ 🤽🏿‍♂️
🤽‍♀️|woman playing water polo|sport swimming waterpolo|woman_playing_water_polo|4|🤽🏻‍♀️ 🤽🏼‍♀️ 🤽🏽‍♀️ 🤽🏾‍♀️ 🤽🏿‍♀️
🤾|person playing handball|athletics ball catch chuck hurl lob|handball_person|3|🤾🏻 🤾🏼 🤾🏽 🤾🏾 🤾🏿
🤾‍♂️|man playing handball|athletics ball catch chuck hurl lob|man_playing_handball|4|🤾🏻‍♂️ 🤾🏼‍♂️ 🤾🏽‍♂️ 🤾🏾‍♂️ 🤾🏿‍♂️
🤾‍♀️|woman playing handball|athletics ball catch chuck hurl lob|woman_playing_handball|4|🤾🏻‍♀️ 🤾🏼‍♀️ 🤾🏽‍♀️ 🤾🏾‍♀️ 🤾🏿‍♀️
🤹|person juggling|act balance balancing handle juggle manage|juggling_person|3|🤹🏻 🤹🏼 🤹🏽 🤹🏾 🤹🏿
🤹‍♂️|man juggling|act balance balancing handle juggle manage|man_juggling|4|🤹🏻‍♂️ 🤹🏼‍♂️ 🤹🏽‍♂️ 🤹🏾‍♂️ 🤹🏿‍♂️
🤹‍♀️|woman juggling|act balance balancing handle juggle manage|woman_juggling|4|🤹🏻‍♀️ 🤹🏼‍♀️ 🤹🏽‍♀️ 🤹🏾‍♀️ 🤹🏿‍♀️
🧘|person in lotus position|cross legged legs meditation peace relax|lotus_position|5|🧘🏻 🧘🏼 🧘🏽 🧘🏾 🧘🏿
🧘‍♂️|man in lotus position|cross legged legs meditation peace relax|lotus_position_man|5|🧘🏻‍♂️ 🧘🏼‍♂️ 🧘🏽‍♂️ 🧘🏾‍♂️ 🧘🏿‍♂️
🧘‍♀️|woman in lotus position|cross legged legs meditation peace relax|lotus_position_woman|5|🧘🏻‍♀️ 🧘🏼‍♀️ 🧘🏽‍♀️ 🧘🏾‍♀️ 🧘🏿‍♀️
🛀|person taking bath|bathtub tub|bath|0.6|🛀🏻 🛀🏼 🛀🏽 🛀🏾 🛀🏿
🛌|person in bed|bedtime good goodnight hotel nap night|sleeping_bed|1|🛌🏻 🛌🏼 🛌🏽 🛌🏾 🛌🏿
🧑‍🤝‍🧑|people holding hands|bae bestie bff couple dating flirt|people_holding_hands|12|🧑🏻‍🤝‍🧑🏻 🧑🏼‍🤝‍🧑🏼 🧑🏽‍🤝‍🧑🏽 🧑🏾‍🤝‍🧑🏾 🧑🏿‍🤝‍🧑🏿
👭|women holding hands|bae bestie bff couple dating flirt|two_women_holding_hands|1|👭🏻 👭🏼 👭🏽 👭🏾 👭🏿
👫|woman and man holding hands|bae bestie bff couple dating flirt|couple|0.6|👫🏻 👫🏼 👫🏽 👫🏾 👫🏿
👬|men holding hands|bae bestie bff boys brothers couple|two_men_holding_hands|1|👬🏻 👬🏼 👬🏽 👬🏾 👬🏿
💏|kiss|anniversary babe bae couple date dating|couplekiss|0.6|💏🏻 💏🏼 💏🏽 💏🏾 💏🏿
👩‍❤️‍💋‍👨|kiss: woman, man|anniversary babe bae couple date dating|couplekiss_man_woman|2|👩🏻‍❤️‍💋‍👨🏻 👩🏼‍❤️‍💋‍👨🏼 👩🏽‍❤️‍💋‍👨🏽 👩🏾‍❤️‍💋‍👨🏾 👩🏿‍❤️‍💋‍👨🏿
👨‍❤️‍💋‍👨|kiss: man, man|anniversary babe bae couple date dating|couplekiss_man_man|2|👨🏻‍❤️‍💋‍👨🏻 👨🏼‍❤️‍💋‍👨🏼 👨🏽‍❤️‍💋‍👨🏽 👨🏾‍❤️‍💋‍👨🏾 👨🏿‍❤️‍💋‍👨🏿
👩‍❤️‍💋‍👩|kiss: woman, woman|anniversary babe bae couple date dating|couplekiss_woman_woman|2|👩🏻‍❤️‍💋‍👩🏻 👩🏼‍❤️‍💋‍👩🏼 👩🏽‍❤️‍💋‍👩🏽 👩🏾‍❤️‍💋‍👩🏾 👩🏿‍❤️‍💋‍👩🏿
💑|couple with heart|anniversary babe bae dating kiss love|couple_with_heart|0.6|💑🏻 💑🏼 💑🏽 💑🏾 💑🏿
👩‍❤️‍👨|couple with heart: woman, man|anniversary babe bae dating kiss love|couple_with_heart_woman_man|2|👩🏻‍❤️‍👨🏻 👩🏼‍❤️‍👨🏼 👩🏽‍❤️‍👨🏽 👩🏾‍❤️‍👨🏾 👩🏿‍❤️‍👨🏿
👨‍❤️‍👨|couple with heart: man, man|anniversary babe bae dating kiss love|couple_with_heart_man_man|2|👨🏻‍❤️‍👨🏻 👨🏼‍❤️‍👨🏼 👨🏽‍❤️‍👨🏽 👨🏾‍❤️‍👨🏾 👨🏿‍❤️‍👨🏿
👩‍❤️‍👩|couple with heart: woman, woman|anniversary babe bae dating kiss love|couple_with_heart_woman_woman|2|👩🏻‍❤️‍👩🏻 👩🏼‍❤️‍👩🏼 👩🏽‍❤️‍👩🏽 👩🏾‍❤️‍👩🏾 👩🏿‍❤️‍👩🏿
👨‍👩‍👦|family: man, woman, boy|child|family_man_woman_boy|2|
👨‍👩‍👧|family: man, woman, girl|child|family_man_woman_girl|2|
👨‍👩‍👧‍👦|family: man, woman, girl, boy|child|family_man_woman_girl_boy|2|
👨‍👩‍👦‍👦|family: man, woman, boy, boy|child|family_man_woman_boy_boy|2|
👨‍👩‍👧‍👧|family: man, woman, girl, girl|child|family_man_woman_girl_girl|2|
👨‍👨‍👦|family: man, man, boy|child|family_man_man_boy|2|
👨‍👨‍👧|family: man, man, girl|child|family_man_man_girl|2|
👨‍👨‍👧‍👦|family: man, man, girl, boy|child|family_man_man_girl_boy|2|
👨‍👨‍👦‍👦|family: man, man, boy, boy|child|family_man_man_boy_boy|2|
👨‍👨‍👧‍👧|family: man, man, girl, girl|child|family_man_man_girl_girl|2|
👩‍👩‍👦|family: woman, woman, boy|child|family_woman_woman_boy|2|
👩‍👩‍👧|family: woman, woman, girl|child|family_woman_woman_girl|2|
👩‍👩‍👧‍👦|family: woman, woman, girl, boy|child|family_woman_woman_girl_boy|2|
👩‍👩‍👦‍👦|family: woman, woman, boy, boy|child|family_woman_woman_boy_boy|2|
👩‍👩‍👧‍👧|family: woman, woman, girl, girl|child|family_woman_woman_girl_girl|2|
👨‍👦|family: man, boy|child|family_man_boy|4|
👨‍👦‍👦|family: man, boy, boy|child|family_man_boy_boy|4|
👨‍👧|family: man, girl|child|family_man_girl|4|
👨‍👧‍👦|family: man, girl, boy|child|family_man_girl_boy|4|
👨‍👧‍👧|family: man, girl, girl|child|family_man_girl_girl|4|
👩‍👦|family: woman, boy|child|family_woman_boy|4|
👩‍👦‍👦|family: woman, boy, boy|child|family_woman_boy_boy|4|
👩‍👧|family: woman, girl|child|family_woman_girl|4|
👩‍👧‍👦|family: woman, girl, boy|child|family_woman_girl_boy|4|
👩‍👧‍👧|family: woman, girl, girl|child|family_woman_girl_girl|4|
🗣️|speaking head|face silhouette speak|speaking_head|0.7|
👤|bust in silhouette|mysterious shadow|bust_in_silhouette|0.6|
👥|busts in silhouette|bff bust everyone friend friends people|busts_in_silhouette|1|
🫂|people hugging|comfort embrace farewell friendship goodbye hello|people_hugging|13|
👪|family|child|family|0.6|
🧑‍🧑‍🧒|family: adult, adult, child|||15.1|
🧑‍🧑‍🧒‍🧒|family: adult, adult, child, child|||15.1|
🧑‍🧒|family: adult, child|||15.1|
🧑‍🧒‍🧒|family: adult, child, child|||15.1|
👣|footprints|barefoot clothing footprint omw print walk|footprints|0.6|
🫆|fingerprint|clue crime detective forensics identity mystery||16|
#nature
🐵|monkey face|animal banana|monkey_face|0.6|
🐒|monkey|animal banana|monkey|0.6|
🦍|gorilla|animal|gorilla|3|
🦧|orangutan|animal ape monkey|orangutan|12|
🐶|dog face|adorbs animal pet puppies puppy|dog|0.6|
🐕|dog|animal animals dogs pet|dog2|0.7|
🦮|guide dog|accessibility animal blind|guide_dog|12|
🐕‍🦺|service dog|accessibility animal assistance|service_dog|12|
🐩|poodle|animal dog fluffy|poodle|0.6|
🐺|wolf|animal face|wolf|0.6|
🦊|fox|animal face|fox_face|3|
🦝|raccoon|animal curious sly|raccoon|11|
🐱|cat face|animal kitten kitty pet|cat|0.6|
🐈|cat|animal animals cats kitten pet|cat2|0.7|
🐈‍⬛|black cat|animal feline halloween meow unlucky|black_cat|13|
🦁|lion|leo alpha animal face mane order|lion|1|
🐯|tiger face|animal big cat predator|tiger|0.6|
🐅|tiger|animal big cat predator zoo|tiger2|1|
🐆|leopard|animal big cat predator zoo|leopard|1|
🐴|horse face|animal dressage equine farm horses|horse|0.6|
🫎|moose|alces animal antlers elk mammal|moose|15|
🫏|donkey|animal ass burro hinny mammal mule|donkey|15|
🐎|horse|animal equestrian farm racehorse racing|racehorse|0.6|
🦄|unicorn|face|unicorn|1|
🦓|zebra|animal stripe|zebra|5|
🦌|deer|animal|deer|3|
🦬|bison|animal buffalo herd wisent|bison|13|
🐮|cow face|animal farm milk moo|cow|0.6|
🐂|ox|taurus animal animals bull farm zodiac|ox|1|
🐃|water buffalo|animal zoo|water_buffalo|1|
🐄|cow|animal animals farm milk moo|cow2|1|
🐷|pig face|animal bacon farm pork|pig|0.6|
🐖|pig|animal bacon farm pork sow|pig2|1|
🐗|boar|animal pig|boar|0.6|
🐽|pig nose|animal face farm smell snout|pig_nose|0.6|
🐏|ram|aries animal horns male sheep zodiac|ram|1|
🐑|ewe|animal baa farm female fluffy lamb|sheep|0.6|
🐐|goat|capricorn animal farm milk zodiac|goat|1|
🐪|camel|animal desert dromedary hump one|dromedary_camel|1|
🐫|two-hump camel|animal bactrian desert two-hump|camel|0.6|
🦙|llama|alpaca animal guanaco vicuña wool|llama|11|
🦒|giraffe|animal spots|giraffe|5|
🐘|elephant|animal|elephant|0.6|
🦣|mammoth|animal extinction large tusk wooly|mammoth|13|
🦏|rhinoceros|animal|rhinoceros|3|
🦛|hippopotamus|animal hippo|hippopotamus|11|
🐭|mouse face|animal|mouse|0.6|
🐁|mouse|animal animals|mouse2|1|
🐀|rat|animal|rat|1|
🐹|hamster|animal face pet|hamster|0.6|
🐰|rabbit face|animal bunny pet|rabbit|0.6|
🐇|rabbit|animal bunny pet|rabbit2|1|
🐿️|chipmunk|animal squirrel|chipmunk|0.7|
🦫|beaver|animal dam teeth|beaver|13|
🦔|hedgehog|animal spiny|hedgehog|5|
🦇|bat|animal vampire|bat|3|
🐻|bear|animal face grizzly growl honey|bear|0.6|
🐻‍❄️|polar bear|animal arctic white|polar_bear|13|
🐨|koala|animal australia bear down face marsupial|koala|0.6|
🐼|panda|animal bamboo face|panda_face|0.6|
🦥|sloth|lazy slow|sloth|12|
🦦|otter|animal fishing playful|otter|12|
🦨|skunk|animal stink|skunk|12|
🦘|kangaroo|animal joey jump marsupial|kangaroo|11|
🦡|badger|animal honey pester|badger|11|
🐾|paw prints|feet paws print|feet paw_prints|0.6|
🦃|turkey|bird gobble thanksgiving|turkey|1|
🐔|chicken|animal bird ornithology|chicken|0.6|
🐓|rooster|animal bird ornithology|rooster|1|
🐣|hatching chick|animal baby bird egg|hatching_chick|0.6|
🐤|baby chick|animal bird ornithology|baby_chick|0.6|
🐥|front-facing baby chick|animal bird front-facing newborn ornithology|hatched_chick|0.6|
🐦|bird|animal ornithology|bird|0.6|
🐧|penguin|animal antarctica bird ornithology|penguin|0.6|
🕊️|dove|bird fly ornithology peace|dove|0.7|
🦅|eagle|animal bird ornithology|eagle|3|
🦆|duck|animal bird ornithology|duck|3|
🦢|swan|animal bird cygnet duckling ornithology ugly|swan|11|
🦉|owl|animal bird ornithology wise|owl|3|
🦤|dodo|animal bird extinction large ornithology|dodo|13|
🪶|feather|bird flight light plumage|feather|13|
🦩|flamingo|animal bird flamboyant ornithology tropical|flamingo|12|
🦚|peacock|animal bird colorful ornithology ostentatious peahen|peacock|11|
🦜|parrot|animal bird ornithology pirate talk|parrot|11|
🪽|wing|angelic ascend aviation bird fly flying|wing|15|
🐦‍⬛|black bird|animal beak caw corvid crow ornithology|black_bird|15|
🪿|goose|animal bird duck flock fowl gaggle|goose|15|
🐦‍🔥|phoenix|ascend ascension emerge fantasy firebird glory||15.1|
🐸|frog|animal face|frog|0.6|
🐊|crocodile|animal zoo|crocodile|1|
🐢|turtle|animal terrapin tortoise|turtle|0.6|
🦎|lizard|animal reptile|lizard|3|
🐍|snake|ophiuchus animal bearer serpent zodiac|snake|0.6|
🐲|dragon face|animal fairy fairytale tale|dragon_face|0.6|
🐉|dragon|animal fairy fairytale knights tale|dragon|1|
🦕|sauropod|brachiosaurus brontosaurus dinosaur diplodocus|sauropod|5|
🦖|T-Rex|tyrannosaurus dinosaur|t-rex|5|
🐳|spouting whale|animal beach face ocean|whale|0.6|
🐋|whale|animal beach ocean|whale2|1|
🐬|dolphin|animal beach flipper ocean|dolphin flipper|0.6|
🫍|orca|marine ocean whale||17|
🦭|seal|animal lion ocean sea|seal|13|
🐟|fish|pisces animal dinner fishes fishing zodiac|fish|0.6|
🐠|tropical fish|animal fishes|tropical_fish|0.6|
🐡|blowfish|animal fish|blowfish|0.6|
🦈|shark|animal fish|shark|3|
🐙|octopus|animal creature ocean|octopus|0.6|
🐚|spiral shell|animal beach conch sea|shell|0.6|
🪸|coral|change climate ocean reef sea|coral|14|
🪼|jellyfish|animal aquarium burn invertebrate jelly life|jellyfish|15|
🦀|crab|cancer zodiac|crab|1|
🦞|lobster|animal bisque claws seafood|lobster|11|
🦐|shrimp|food shellfish small|shrimp|3|
🦑|squid|animal food mollusk|squid|3|
🦪|oyster|diving pearl|oyster|12|
🐌|snail|animal escargot garden nature slug|snail|0.6|
🦋|butterfly|insect pretty|butterfly|3|
🫌|monarch butterfly|caterpillar change fragile hope insect metamorphosis||18|
🐛|bug|animal garden insect|bug|0.6|
🐜|ant|animal garden insect|ant|0.6|
🐝|honeybee|animal bee bumblebee honey insect nature|bee honeybee|0.6|
🪲|beetle|animal bug insect|beetle|13|
🐞|lady beetle|animal garden insect ladybird ladybug nature|lady_beetle|0.6|
🦗|cricket|orthoptera animal bug grasshopper insect|cricket|5|
🪳|cockroach|animal insect pest roach|cockroach|13|
🕷️|spider|animal insect|spider|0.7|
🕸️|spider web||spider_web|0.7|
🦂|scorpion|scorpio scorpius zodiac|scorpion|1|
🦟|mosquito|bite disease fever insect malaria pest|mosquito|11|
🪰|fly|animal disease insect maggot pest rotting|fly|13|
🪱|worm|animal annelid earthworm parasite|worm|13|
🦠|microbe|amoeba bacteria science virus|microbe|11|
💐|bouquet|anniversary birthday date flower love plant|bouquet|0.6|
🌸|cherry blossom|flower plant spring springtime|cherry_blossom|0.6|
💮|white flower||white_flower|0.6|
🪷|lotus|buddhism hinduism beauty calm flower peace|lotus|14|
🏵️|rosette|plant|rosette|0.7|
🌹|rose|beauty elegant flower love plant red|rose|0.6|
🥀|wilted flower|dying|wilted_flower|3|
🌺|hibiscus|flower plant|hibiscus|0.6|
🌻|sunflower|flower outdoors plant sun|sunflower|0.6|
🌼|blossom|buttercup dandelion flower plant|blossom|0.6|
🌷|tulip|blossom flower growth plant|tulip|0.6|
🪻|hyacinth|bloom bluebonnet flower indigo lavender lilac|hyacinth|15|
🌱|seedling|plant sapling sprout young|seedling|0.6|
🪴|potted plant|decor grow house nurturing pot|potted_plant|13|
🌲|evergreen tree|christmas forest pine|evergreen_tree|1|
🌳|deciduous tree|forest green habitat shedding|deciduous_tree|1|
🌴|palm tree|beach plant tropical|palm_tree|0.6|
🌵|cactus|desert drought nature plant|cactus|0.6|
🌾|sheaf of rice|ear grain grains plant|ear_of_rice|0.6|
🌿|herb|leaf plant|herb|0.6|
☘️|shamrock|irish plant|shamrock|1|
🍀|four leaf clover|4 four-leaf irish lucky plant|four_leaf_clover|0.6|
🍁|maple leaf|falling|maple_leaf|0.6|
🍂|fallen leaf|autumn fall falling|fallen_leaf|0.6|
🍃|leaf fluttering in wind|blow flutter|leaves|0.6|
🪹|empty nest|branch home nesting|empty_nest|14|
🪺|nest with eggs|bird branch egg nesting|nest_with_eggs|14|
🍄|mushroom|fungus toadstool|mushroom|0.6|
🪾|leafless tree|bare barren branches dead drought trunk||16|
#food
🍇|grapes|dionysus fruit grape|grapes|0.6|
🍈|melon|cantaloupe fruit|melon|0.6|
🍉|watermelon|fruit|watermelon|0.6|
🍊|tangerine|c citrus fruit nectarine orange vitamin|mandarin orange|0.6|
🍋|lemon|citrus fruit sour|lemon|1|
🍋‍🟩|lime|acidity citrus cocktail fruit garnish key||15.1|
🍌|banana|fruit potassium|banana|0.6|
🍍|pineapple|colada fruit pina tropical|pineapple|0.6|
🥭|mango|food fruit tropical|mango|11|
🍎|red apple|diet food fruit health ripe|apple|0.6|
🍏|green apple|fruit|green_apple|0.6|
🍐|pear|fruit|pear|1|
🍑|peach|fruit|peach|0.6|
🍒|cherries|berries cherry fruit red|cherries|0.6|
🍓|strawberry|berry fruit|strawberry|0.6|
🫐|blueberries|berries berry bilberry blue blueberry food|blueberries|13|
🥝|kiwi fruit|food|kiwi_fruit|3|
🍅|tomato|food fruit vegetable|tomato|0.6|
🫒|olive|food|olive|13|
🥥|coconut|colada palm piña|coconut|5|
🥑|avocado|food fruit|avocado|3|
🍆|eggplant|aubergine vegetable|eggplant|0.6|
🥔|potato|food vegetable|potato|3|
🥕|carrot|food vegetable|carrot|3|
🌽|ear of corn|crops farm maize maze|corn|0.6|
🌶️|hot pepper||hot_pepper|0.7|
🫑|bell pepper|capsicum food vegetable|bell_pepper|13|
🥒|cucumber|food pickle vegetable|cucumber|3|
🫝|pickle|brine condiment cucumber ferment gherkin relish||18|
🥬|leafy green|bok burgers cabbage choy kale lettuce|leafy_green|11|
🥦|broccoli|cabbage wild|broccoli|5|
🧄|garlic|flavoring|garlic|12|
🧅|onion|flavoring|onion|12|
🥜|peanuts|food nut peanut vegetable|peanuts|3|
🫘|beans|food kidney legume small|beans|14|
🌰|chestnut|almond plant|chestnut|0.6|
🫚|ginger root|beer health herb natural spice|ginger_root|15|
🫛|pea pod|beans beanstalk edamame legume soybean vegetable|pea_pod|15|
🍄‍🟫|brown mushroom|food fungi fungus nature pizza portobello||15.1|
🫜|root vegetable|beet food garden radish salad turnip||16|
🍞|bread|carbs food grain loaf restaurant toast|bread|0.6|
🥐|croissant|bread breakfast crescent food french roll|croissant|3|
🥖|baguette bread|food french|baguette_bread|3|
🫓|flatbread|arepa bread food gordita lavash naan|flatbread|13|
🥨|pretzel|convoluted twisted|pretzel|5|
🥯|bagel|bakery bread breakfast schmear|bagel|11|
🥞|pancakes|breakfast crêpe food hotcake pancake|pancakes|3|
🧇|waffle|breakfast indecisive iron|waffle|12|
🧀|cheese wedge||cheese|1|
🍖|meat on bone||meat_on_bone|0.6|
🍗|poultry leg|bone chicken drumstick hungry turkey|poultry_leg|0.6|
🥩|cut of meat|chop lambchop porkchop red steak|cut_of_meat|5|
🥓|bacon|breakfast food meat|bacon|3|
🍔|hamburger|burger eat fast food hungry|hamburger|0.6|
🍟|french fries|fast food|fries|0.6|
🍕|pizza|cheese food hungry pepperoni slice|pizza|0.6|
🌭|hot dog|frankfurter hotdog sausage|hotdog|1|
🥪|sandwich|bread|sandwich|5|
🌮|taco|mexican|taco|1|
🌯|burrito|mexican wrap|burrito|1|
🫔|tamale|food mexican pamonha wrapped|tamale|13|
🥙|stuffed flatbread|falafel food gyro kebab|stuffed_flatbread|3|
🧆|falafel|chickpea meatball|falafel|12|
🥚|egg|breakfast food|egg|3|
🍳|cooking|breakfast easy egg fry frying over|fried_egg|0.6|
🥘|shallow pan of food|casserole paella|shallow_pan_of_food|3|
🍲|pot of food|soup stew|stew|0.6|
🫕|fondue|cheese chocolate food melted pot ski|fondue|13|
🥣|bowl with spoon|breakfast cereal congee oatmeal porridge|bowl_with_spoon|5|
🥗|green salad|food|green_salad|3|
🍿|popcorn|corn movie pop|popcorn|1|
🧈|butter|dairy|butter|12|
🧂|salt|condiment flavor mad salty shaker taste|salt|11|
🥫|canned food|can|canned_food|5|
🍱|bento box|food|bento|0.6|
🍘|rice cracker|food|rice_cracker|0.6|
🍙|rice ball|japanese food|rice_ball|0.6|
🍚|cooked rice|food|rice|0.6|
🍛|curry rice|food|curry|0.6|
🍜|steaming bowl|chopsticks food noodle pho ramen soup|ramen|0.6|
🍝|spaghetti|food meatballs pasta restaurant|spaghetti|0.6|
🍠|roasted sweet potato|food|sweet_potato|0.6|
🍢|oden|food kebab restaurant seafood skewer stick|oden|0.6|
🍣|sushi|food|sushi|0.6|
🍤|fried shrimp|prawn tempura|fried_shrimp|0.6|
🍥|fish cake with swirl|food pastry restaurant|fish_cake|0.6|
🥮|moon cake|autumn festival yuèbǐng|moon_cake|11|
🍡|dango|japanese dessert skewer stick sweet|dango|0.6|
🥟|dumpling|empanada gyōza jiaozi pierogi potsticker|dumpling|5|
🥠|fortune cookie|prophecy|fortune_cookie|5|
🥡|takeout box|chopsticks delivery food oyster pail|takeout_box|5|
🍦|soft ice cream|dessert food icecream restaurant serve sweet|icecream|0.6|
🍧|shaved ice|dessert restaurant sweet|shaved_ice|0.6|
🍨|ice cream|dessert food restaurant sweet|ice_cream|0.6|
🍩|doughnut|breakfast dessert donut food sweet|doughnut|0.6|
🍪|cookie|chip chocolate dessert sweet|cookie|0.6|
🎂|birthday cake|bday celebration dessert happy pastry sweet|birthday|0.6|
🍰|shortcake|cake dessert pastry slice sweet|cake|0.6|
🧁|cupcake|bakery dessert sprinkles sugar sweet treat|cupcake|11|
🥧|pie|apple filling fruit meat pastry pumpkin|pie|5|
🍫|chocolate bar|candy dessert halloween sweet tooth|chocolate_bar|0.6|
🍬|candy|cavities dessert halloween restaurant sweet tooth|candy|0.6|
🍭|lollipop|candy dessert food restaurant sweet|lollipop|0.6|
🍮|custard|dessert pudding sweet|custard|0.6|
🍯|honey pot|barrel bear food honeypot jar sweet|honey_pot|0.6|
🍼|baby bottle|babies birth born drink infant milk|baby_bottle|1|
🥛|glass of milk|drink|milk_glass|3|
☕|hot beverage|cafe caffeine chai coffee drink morning|coffee|0.6|
🫖|teapot|brew drink food pot tea|teapot|13|
🍵|teacup without handle|beverage cup drink oolong tea|tea|0.6|
🍶|sake|bar beverage bottle cup drink restaurant|sake|0.6|
🍾|bottle with popping cork|bar drink|champagne|1|
🍷|wine glass|alcohol bar beverage booze club drink|wine_glass|0.6|
🍸|cocktail glass|alcohol bar booze club drink drinking|cocktail|0.6|
🍹|tropical drink|alcohol bar booze club cocktail drinking|tropical_drink|0.6|
🍺|beer mug|alcohol ale bar booze drink drinking|beer|0.6|
🍻|clinking beer mugs|alcohol bar booze bottoms cheers clink|beers|0.6|
🥂|clinking glasses|celebrate clink drink glass|clinking_glasses|3|
🥃|tumbler glass|liquor scotch shot whiskey whisky|tumbler_glass|3|
🫗|pouring liquid|accident drink empty glass oops pour|pouring_liquid|14|
🥤|cup with straw|drink juice malt soda soft water|cup_with_straw|5|
🧋|bubble tea|boba food milk pearl|bubble_tea|13|
🧃|beverage box|juice straw sweet|beverage_box|12|
🧉|mate|drink|mate|12|
🧊|ice|cold cube iceberg|ice_cube|12|
🥢|chopsticks|hashi jeotgarak kuaizi|chopsticks|5|
🍽️|fork and knife with plate|cooking dinner eat|plate_with_cutlery|0.7|
🍴|fork and knife|breakfast breaky cooking cutlery delicious dinner|fork_and_knife|0.6|
🥄|spoon|eat tableware|spoon|3|
🔪|kitchen knife|chef cooking hocho tool weapon|hocho knife|0.6|
🫙|jar|condiment container empty nothing sauce store|jar|14|
🏺|amphora|aquarius cooking drink jug tool weapon|amphora|1|
#travel
🌍|globe showing Europe-Africa|europe-africa earth world|earth_africa|0.7|
🌎|globe showing Americas|earth world|earth_americas|0.7|
🌏|globe showing Asia-Australia|asia-australia earth world|earth_asia|0.6|
🌐|globe with meridians|earth internet web world worldwide|globe_with_meridians|1|
🗺️|world map||world_map|0.7|
🗾|map of Japan||japan|0.6|
🧭|compass|direction magnetic navigation orienteering|compass|11|
🏔️|snow-capped mountain|cold snow-capped|mountain_snow|0.7|
⛰️|mountain||mountain|0.7|
🛘|landslide|avalanche danger disaster earthquake mountain mudslide||17|
🌋|volcano|eruption mountain nature|volcano|0.6|
🗻|mount fuji|mountain nature|mount_fuji|0.6|
🏕️|camping||camping|0.7|
🏖️|beach with umbrella||beach_umbrella|0.7|
🏜️|desert||desert|0.7|
🏝️|desert island||desert_island|0.7|
🏞️|national park||national_park|0.7|
🏟️|stadium||stadium|0.7|
🏛️|classical building||classical_building|0.7|
🏗️|building construction|crane|building_construction|0.7|
🧱|brick|bricks clay mortar wall|bricks|11|
🪨|rock|boulder heavy solid stone tough|rock|13|
🪵|wood|log lumber timber|wood|13|
🛖|hut|home house roundhouse shelter yurt|hut|13|
🏘️|houses|house|houses|0.7|
🏚️|derelict house|home|derelict_house|0.7|
🏠|house|building country heart home ranch settle|house|0.6|
🏡|house with garden|building country heart home ranch settle|house_with_garden|0.6|
🏢|office building|city cubical job|office|0.6|
🏣|Japanese post office|building|post_office|0.6|
🏤|post office|european building|european_post_office|1|
🏥|hospital|building doctor medicine|hospital|0.6|
🏦|bank|building|bank|0.6|
🏨|hotel|building|hotel|0.6|
🏩|love hotel|building|love_hotel|0.6|
🏪|convenience store|24 building hours|convenience_store|0.6|
🏫|school|building|school|0.6|
🏬|department store|building|department_store|0.6|
🏭|factory|building|factory|0.6|
🏯|Japanese castle|building|japanese_castle|0.6|
🏰|castle|european building|european_castle|0.6|
💒|wedding|chapel hitched nuptials romance|wedding|0.6|
🗼|Tokyo tower||tokyo_tower|0.6|
🗽|Statue of Liberty|new ny nyc york|statue_of_liberty|0.6|
⛪|church|christian bless chapel cross religion|church|0.6|
🕌|mosque|muslim islam masjid religion|mosque|1|
🛕|hindu temple||hindu_temple|12|
🕍|synagogue|jew jewish judaism religion temple|synagogue|1|
⛩️|shinto shrine|religion|shinto_shrine|0.7|
🕋|kaaba|muslim hajj islam religion umrah|kaaba|1|
⛲|fountain||fountain|0.6|
⛺|tent|camping|tent|0.6|
🌁|foggy|fog|foggy|0.6|
🌃|night with stars|star|night_with_stars|0.6|
🏙️|cityscape|city|cityscape|0.7|
🌄|sunrise over mountains|morning sun|sunrise_over_mountains|0.6|
🌅|sunrise|morning nature sun|sunrise|0.6|
🌆|cityscape at dusk|building city evening landscape sun sunset|city_sunset|0.6|
🌇|sunset|building dusk sun|city_sunrise|0.6|
🌉|bridge at night||bridge_at_night|0.6|
♨️|hot springs|hotsprings steaming|hotsprings|0.6|
🎠|carousel horse|entertainment|carousel_horse|0.6|
🛝|playground slide|amusement park play playing sliding theme|playground_slide|14|
🎡|ferris wheel|amusement park theme|ferris_wheel|0.6|
🎢|roller coaster|amusement park theme|roller_coaster|0.6|
💈|barber pole|cut fresh haircut shave|barber|0.6|
🎪|circus tent||circus_tent|0.6|
🚂|locomotive|caboose engine railway steam train trains|steam_locomotive|1|
🚃|railway car|electric train tram travel trolleybus|railway_car|0.6|
🚄|high-speed train|high-speed railway shinkansen|bullettrain_side|0.6|
🚅|bullet train|high-speed nose railway shinkansen speed travel|bullettrain_front|0.6|
🚆|train|arrived choo railway|train2|1|
🚇|metro|subway travel|metro|0.6|
🚈|light rail|arrived monorail railway|light_rail|1|
🚉|station|railway train|station|0.6|
🚊|tram|trolleybus|tram|1|
🚝|monorail|vehicle|monorail|1|
🚞|mountain railway|car trip|mountain_railway|1|
🚋|tram car|bus trolley trolleybus|train|1|
🚌|bus|school vehicle|bus|0.6|
🚍|oncoming bus|cars|oncoming_bus|0.7|
🚎|trolleybus|bus tram trolley|trolleybus|1|
🚐|minibus|bus drive van vehicle|minibus|1|
🚑|ambulance|emergency vehicle|ambulance|0.6|
🚒|fire engine|truck|fire_engine|0.6|
🚓|police car|5–0 cops patrol|police_car|0.6|
🚔|oncoming police car||oncoming_police_car|0.7|
🚕|taxi|cab cabbie car drive vehicle yellow|taxi|0.6|
🚖|oncoming taxi|cab cabbie cars drove hail yellow|oncoming_taxi|1|
🚗|automobile|car driving vehicle|car red_car|0.6|
🚘|oncoming automobile|car cars drove vehicle|oncoming_automobile|0.7|
🚙|sport utility vehicle|car drive recreational sportutility|blue_car|0.6|
🛻|pickup truck|automobile car flatbed pick-up transportation|pickup_truck|13|
🚚|delivery truck|car drive vehicle|truck|0.6|
🚛|articulated lorry|car drive move semi truck vehicle|articulated_lorry|1|
🚜|tractor|vehicle|tractor|1|
🏎️|racing car|zoom|racing_car|0.7|
🏍️|motorcycle|racing|motorcycle|0.7|
🛵|motor scooter||motor_scooter|3|
🦽|manual wheelchair|accessibility|manual_wheelchair|12|
🦼|motorized wheelchair|accessibility|motorized_wheelchair|12|
🛺|auto rickshaw|tuk|auto_rickshaw|12|
🚲|bicycle|bike class cycle cycling cyclist gang|bike|0.6|
🛴|kick scooter||kick_scooter|3|
🛹|skateboard|board skate skater wheels|skateboard|11|
🛼|roller skate|blades skates sport|roller_skate|13|
🚏|bus stop|busstop|busstop|0.6|
🛣️|motorway|highway road|motorway|0.7|
🛤️|railway track|train|railway_track|0.7|
🛢️|oil drum||oil_drum|0.7|
⛽|fuel pump|diesel fuelpump gas gasoline station|fuelpump|0.6|
🛞|wheel|car circle tire turn vehicle|wheel|14|
🚨|police car light|alarm alert beacon emergency revolving siren|rotating_light|0.6|
🚥|horizontal traffic light|intersection signal stop stoplight|traffic_light|0.6|
🚦|vertical traffic light|drove intersection signal stop stoplight|vertical_traffic_light|1|
🛑|stop sign|octagonal|stop_sign|3|
🚧|construction|barrier|construction|0.6|
🛙|lighthouse|beacon enlightenment guidance hope light maritime||18|
⚓|anchor|ship tool|anchor|0.6|
🛟|ring buoy|float life lifesaver preserver rescue safety|ring_buoy|14|
⛵|sailboat|boat resort sailing sea yacht|boat sailboat|0.6|
🛶|canoe|boat|canoe|3|
🚤|speedboat|billionaire boat lake luxury millionaire summer|speedboat|0.6|
🛳️|passenger ship||passenger_ship|0.7|
⛴️|ferry|boat passenger|ferry|0.7|
🛥️|motor boat|motorboat|motor_boat|0.7|
🚢|ship|boat passenger travel|ship|0.6|
✈️|airplane|aeroplane fly flying jet plane travel|airplane|0.6|
🛩️|small airplane|aeroplane plane|small_airplane|0.7|
🛫|airplane departure|aeroplane check-in departures plane|flight_departure|1|
🛬|airplane arrival|aeroplane arrivals arriving landing plane|flight_arrival|1|
🪂|parachute|hang-glide parasail skydive|parachute|12|
💺|seat|chair|seat|0.6|
🚁|helicopter|copter roflcopter travel vehicle|helicopter|1|
🚟|suspension railway||suspension_railway|1|
🚠|mountain cableway|cable gondola lift ski|mountain_cableway|1|
🚡|aerial tramway|cable car gondola ropeway|aerial_tramway|1|
🛰️|satellite|space|artificial_satellite|0.7|
🚀|rocket|launch rockets space travel|rocket|0.6|
🛸|flying saucer|ufo aliens extra terrestrial|flying_saucer|5|
🛎️|bellhop bell|hotel|bellhop_bell|0.7|
🧳|luggage|bag packing roller suitcase travel|luggage|11|
⌛|hourglass done|sand time timer|hourglass|0.6|
⏳|hourglass not done|flowing hours sand timer waiting yolo|hourglass_flowing_sand|0.6|
⌚|watch|clock time|watch|0.6|
⏰|alarm clock|hours hrs late time waiting|alarm_clock|0.6|
⏱️|stopwatch|clock time|stopwatch|1|
⏲️|timer clock||timer_clock|1|
🕰️|mantelpiece clock|time|mantelpiece_clock|0.7|
🕛|twelve o’clock|12 12:00 clock time|clock12|0.6|
🕧|twelve-thirty|12 12:30 30 clock time|clock1230|0.7|
🕐|one o’clock|1 1:00 clock time|clock1|0.6|
🕜|one-thirty|1 1:30 30 clock time|clock130|0.7|
🕑|two o’clock|2 2:00 clock time|clock2|0.6|
🕝|two-thirty|2 2:30 30 clock time|clock230|0.7|
🕒|three o’clock|3 3:00 clock time|clock3|0.6|
🕞|three-thirty|3 30 3:30 clock time|clock330|0.7|
🕓|four o’clock|4 4:00 clock time|clock4|0.6|
🕟|four-thirty|30 4 4:30 clock time|clock430|0.7|
🕔|five o’clock|5 5:00 clock time|clock5|0.6|
🕠|five-thirty|30 5 5:30 clock time|clock530|0.7|
🕕|six o’clock|6 6:00 clock time|clock6|0.6|
🕡|six-thirty|30 6 6:30 clock|clock630|0.7|
🕖|seven o’clock|0 7 7:00 clock|clock7|0.6|
🕢|seven-thirty|30 7 7:30 clock|clock730|0.7|
🕗|eight o’clock|8 8:00 clock time|clock8|0.6|
🕣|eight-thirty|30 8 8:30 clock time|clock830|0.7|
🕘|nine o’clock|9 9:00 clock time|clock9|0.6|
🕤|nine-thirty|30 9 9:30 clock time|clock930|0.7|
🕙|ten o’clock|0 10 10:00 clock|clock10|0.6|
🕥|ten-thirty|10 10:30 30 clock time|clock1030|0.7|
🕚|eleven o’clock|11 11:00 clock time|clock11|0.6|
🕦|eleven-thirty|11 11:30 30 clock time|clock1130|0.7|
🌑|new moon|dark space|new_moon|0.6|
🌒|waxing crescent moon|dreams space|waxing_crescent_moon|1|
🌓|first quarter moon|space|first_quarter_moon|0.6|
🌔|waxing gibbous moon|space|moon waxing_gibbous_moon|0.6|
🌕|full moon|space|full_moon|0.6|
🌖|waning gibbous moon|space|waning_gibbous_moon|1|
🌗|last quarter moon|space|last_quarter_moon|1|
🌘|waning crescent moon|space|waning_crescent_moon|1|
🌙|crescent moon|ramadan space|crescent_moon|0.6|
🌚|new moon face|space|new_moon_with_face|1|
🌛|first quarter moon face|space|first_quarter_moon_with_face|0.6|
🌜|last quarter moon face|dreams|last_quarter_moon_with_face|0.7|
🌡️|thermometer|weather|thermometer|0.7|
☀️|sun|bright rays space sunny weather|sunny|0.6|
🌝|full moon face|bright|full_moon_with_face|1|
🌞|sun with face|beach bright day heat shine sunny|sun_with_face|1|
🪐|ringed planet|saturn saturnine|ringed_planet|12|
⭐|star|astronomy medium stars white|star|0.6|
🌟|glowing star|glittery glow night shining sparkle win|star2|0.6|
🌠|shooting star|falling night space|stars|0.6|
🌌|milky way|space|milky_way|0.6|
☁️|cloud|weather|cloud|0.6|
⛅|sun behind cloud|cloudy weather|partly_sunny|0.6|
⛈️|cloud with lightning and rain|thunder thunderstorm|cloud_with_lightning_and_rain|0.7|
🌤️|sun behind small cloud|weather|sun_behind_small_cloud|0.7|
🌥️|sun behind large cloud|weather|sun_behind_large_cloud|0.7|
🌦️|sun behind rain cloud|weather|sun_behind_rain_cloud|0.7|
🌧️|cloud with rain|weather|cloud_with_rain|0.7|
🌨️|cloud with snow|cold weather|cloud_with_snow|0.7|
🌩️|cloud with lightning|weather|cloud_with_lightning|0.7|
🌪️|tornado|cloud weather whirlwind|tornado|0.7|
🌫️|fog|cloud weather|fog|0.7|
🌬️|wind face|blow cloud|wind_face|0.7|
🌀|cyclone|dizzy hurricane twister typhoon weather|cyclone|0.6|
🌈|rainbow|gay genderqueer glbt glbtq lesbian lgbt|rainbow|0.6|
🌂|closed umbrella|clothing rain|closed_umbrella|0.6|
☂️|umbrella|clothing rain|open_umbrella|0.7|
☔|umbrella with rain drops|clothing drop weather|umbrella|0.6|
⛱️|umbrella on ground|rain sun|parasol_on_ground|0.7|
⚡|high voltage|danger electric electricity lightning nature thunder|zap|0.6|
❄️|snowflake|cold snow weather|snowflake|0.6|
☃️|snowman|cold man snow|snowman_with_snow|0.7|
⛄|snowman without snow|cold man|snowman|0.6|
☄️|comet|space|comet|1|
🪋|meteor|apocalypse falling fireball gravity rock space||18|
🔥|fire|af burn flame hot lit litaf|fire|0.6|
💧|droplet|cold comic drop nature sad sweat|droplet|0.6|
🌊|water wave|nature ocean surf surfer surfing|ocean|0.6|
#activities
🎃|jack-o-lantern|celebration halloween pumpkin|jack_o_lantern|0.6|
🎄|Christmas tree|celebration|christmas_tree|0.6|
🎆|fireworks|boom celebration entertainment yolo|fireworks|0.6|
🎇|sparkler|boom celebration fireworks sparkle|sparkler|0.6|
🧨|firecracker|dynamite explosive fire fireworks light pop|firecracker|11|
✨|sparkles|* magic sparkle star|sparkles|0.6|
🎈|balloon|birthday celebrate celebration|balloon|0.6|
🎉|party popper|awesome birthday celebrate celebration excited hooray|tada|0.6|
🎊|confetti ball|celebrate celebration party woohoo|confetti_ball|0.6|
🎋|tanabata tree|japanese banner celebration|tanabata_tree|0.6|
🎍|pine decoration|japanese bamboo celebration plant|bamboo|0.6|
🎎|Japanese dolls|celebration doll festival|dolls|0.6|
🎏|carp streamer|celebration|flags|0.6|
🎐|wind chime|bell celebration|wind_chime|0.6|
🎑|moon viewing ceremony|celebration|rice_scene|0.6|
🧧|red envelope|gift good hóngbāo lai luck money|red_envelope|11|
🎀|ribbon|celebration|ribbon|0.6|
🎁|wrapped gift|birthday bow box celebration christmas present|gift|0.6|
🎗️|reminder ribbon|celebration|reminder_ribbon|0.7|
🎟️|admission tickets|ticket|tickets|0.7|
🎫|ticket|admission stub|ticket|0.6|
🎖️|military medal|award celebration|medal_military|0.7|
🏆|trophy|champion champs prize slay sport victory|trophy|0.6|
🏅|sports medal|award gold winner|medal_sports|1|
🥇|1st place medal|first gold|1st_place_medal|3|
🥈|2nd place medal|second silver|2nd_place_medal|3|
🥉|3rd place medal|bronze third|3rd_place_medal|3|
⚽|soccer ball|football futbol sport|soccer|0.6|
⚾|baseball|ball sport|baseball|0.6|
🥎|softball|ball glove sports underarm|softball|11|
🏀|basketball|ball hoop sport|basketball|0.6|
🏐|volleyball|ball game|volleyball|1|
🏈|american football|ball bowl sport super|football|0.6|
🏉|rugby football|ball sport|rugby_football|1|
🎾|tennis|ball racquet sport|tennis|0.6|
🥏|flying disc|ultimate|flying_disc|11|
🎳|bowling|ball game sport strike|bowling|0.6|
🏏|cricket game|ball bat|cricket_game|1|
🏑|field hockey|ball game stick|field_hockey|1|
🏒|ice hockey|game puck stick|ice_hockey|1|
🥍|lacrosse|ball goal sports stick|lacrosse|11|
🏓|ping pong|ball bat game paddle pingpong table|ping_pong|1|
🏸|badminton|birdie game racquet shuttlecock|badminton|1|
🥊|boxing glove||boxing_glove|3|
🥋|martial arts uniform|judo karate taekwondo|martial_arts_uniform|3|
🥅|goal net||goal_net|3|
⛳|flag in hole|golf sport|golf|0.6|
⛸️|ice skate|skating|ice_skate|0.7|
🎣|fishing pole|entertainment fish sport|fishing_pole_and_fish|0.6|
🤿|diving mask|scuba snorkeling|diving_mask|12|
🎽|running shirt|athletics sash|running_shirt_with_sash|0.6|
🎿|skis|ski snow sport|ski|0.6|
🛷|sled|luge sledge sleigh snow toboggan|sled|5|
🥌|curling stone|game rock|curling_stone|5|
🎯|bullseye|bull dart direct entertainment game hit|dart|0.6|
🪀|yo-yo|fluctuate toy|yo_yo|12|
🪁|kite|fly soar|kite|12|
🔫|water pistol|gun handgun revolver tool weapon|gun|0.6|
🎱|pool 8 ball|8ball billiard eight game|8ball|0.6|
🔮|crystal ball|fairy fairytale fantasy fortune future magic|crystal_ball|0.6|
🪄|magic wand|magician witch wizard|magic_wand|13|
🎮|video game|controller entertainment|video_game|0.6|
🕹️|joystick|game video videogame|joystick|0.7|
🎰|slot machine|casino gamble gambling game slots|slot_machine|0.6|
🎲|game die|dice entertainment|game_die|0.6|
🧩|puzzle piece|clue interlocking jigsaw|jigsaw|11|
🧸|teddy bear|plaything plush stuffed toy|teddy_bear|11|
🪅|piñata|candy celebrate celebration cinco de festive|pinata|13|
🪩|mirror ball|dance disco glitter party|mirror_ball|14|
🪆|nesting dolls|babooshka baboushka babushka doll matryoshka russia|nesting_dolls|13|
♠️|spade suit|card game|spades|0.6|
♥️|heart suit|card emotion game hearts|hearts|0.6|
♦️|diamond suit|card game|diamonds|0.6|
♣️|club suit|card clubs game|clubs|0.6|
♟️|chess pawn|dupe expendable|chess_pawn|11|
🃏|joker|card game wildcard|black_joker|0.6|
🀄|mahjong red dragon|game|mahjong|0.6|
🎴|flower playing cards|japanese card game|flower_playing_cards|0.6|
🎭|performing arts|actor actress art entertainment mask theater|performing_arts|0.6|
🖼️|framed picture|art frame museum painting|framed_picture|0.7|
🎨|artist palette|art artsy arty colorful creative entertainment|art|0.6|
🧵|thread|needle sewing spool string|thread|11|
🪡|sewing needle|embroidery sew stitches sutures tailoring thread|sewing_needle|13|
🧶|yarn|ball crochet knit|yarn|11|
🪢|knot|cord rope tangled tie twine twist|knot|13|
#objects
👓|glasses|clothing eye eyeglasses eyewear|eyeglasses|0.6|
🕶️|sunglasses|dark eye eyewear glasses|dark_sunglasses|0.7|
🥽|goggles|dive eye protection scuba swimming welding|goggles|11|
🥼|lab coat|clothes doctor dr experiment jacket scientist|lab_coat|11|
🦺|safety vest|emergency|safety_vest|12|
👔|necktie|clothing employed serious shirt tie|necktie|0.6|
👕|t-shirt|blue casual clothes clothing collar dressed|shirt tshirt|0.6|
👖|jeans|blue casual clothes clothing denim dressed|jeans|0.6|
🧣|scarf|bundle cold neck up|scarf|5|
🧤|gloves|hand|gloves|5|
🧥|coat|brr bundle cold jacket up|coat|5|
🧦|socks|stocking|socks|5|
👗|dress|clothes clothing dressed fancy shopping|dress|0.6|
👘|kimono|clothing comfortable|kimono|0.6|
🥻|sari|clothing dress|sari|12|
🩱|one-piece swimsuit|bathing one-piece suit|one_piece_swimsuit|12|
🩲|briefs|bathing one-piece suit swimsuit underwear|swim_brief|12|
🩳|shorts|bathing pants suit swimsuit underwear|shorts|12|
👙|bikini|bathing beach clothing pool suit swim|bikini|0.6|
👚|woman’s clothes|blouse clothing collar dress dressed lady|womans_clothes|0.6|
🪭|folding hand fan|clack clap cool cooling dance flirt|folding_hand_fan|15|
👛|purse|clothes clothing coin dress fancy handbag|purse|0.6|
👜|handbag|bag clothes clothing dress lady purse|handbag|0.6|
👝|clutch bag|clothes clothing dress handbag pouch purse|pouch|0.6|
🛍️|shopping bags|bag hotel|shopping|0.7|
🎒|backpack|backpacking bag bookbag education rucksack satchel|school_satchel|0.6|
🩴|thong sandal|beach flip flop sandals shoe thongs|thong_sandal|13|
👞|man’s shoe|brown clothes clothing feet foot kick|mans_shoe shoe|0.6|
👟|running shoe|athletic clothes clothing fast kick shoes|athletic_shoe|0.6|
🥾|hiking boot|backpacking brown camping outdoors shoe|hiking_boot|11|
🥿|flat shoe|ballet comfy flats slip-on slipper|flat_shoe|11|
👠|high-heeled shoe|clothes clothing dress fashion heel heels|high_heel|0.6|
👡|woman’s sandal|clothing shoe woman|sandal|0.6|
🩰|ballet shoes|dance|ballet_shoes|12|
👢|woman’s boot|clothes clothing dress shoe shoes shopping|boot|0.6|
🪮|hair pick|afro comb groom|hair_pick|15|
👑|crown|clothing family king medieval queen royal|crown|0.6|
👒|woman’s hat|clothes clothing garden hats party woman|womans_hat|0.6|
🎩|top hat|clothes clothing fancy formal magic tophat|tophat|0.6|
🎓|graduation cap|celebration clothing education hat scholar|mortar_board|0.6|
🧢|billed cap|baseball bent dad hat|billed_cap|5|
🪖|military helmet|army soldier war warrior|military_helmet|13|
⛑️|rescue worker’s helmet|aid cross face hat|rescue_worker_helmet|0.7|
📿|prayer beads|clothing necklace religion|prayer_beads|1|
💄|lipstick|cosmetics date makeup|lipstick|0.6|
💍|ring|diamond engaged engagement married romance shiny|ring|0.6|
💎|gem stone|diamond engagement jewel money romance wedding|gem|0.6|
🔇|muted speaker|mute quiet silent sound|mute|1|
🔈|speaker low volume|soft sound|speaker|0.7|
🔉|speaker medium volume|sound|sound|1|
🔊|speaker high volume|loud music sound|loud_sound|0.6|
📢|loudspeaker|address communication loud public sound|loudspeaker|0.6|
📣|megaphone|cheering sound|mega|0.6|
📯|postal horn|post|postal_horn|1|
🔔|bell|break church sound|bell|0.6|
🔕|bell with slash|forbidden mute no not prohibited quiet|no_bell|1|
🎼|musical score|music note|musical_score|0.6|
🎵|musical note|music sound|musical_note|0.6|
🎶|musical notes|music note sound|notes|0.6|
🎙️|studio microphone|mic music|studio_microphone|0.7|
🎚️|level slider|music|level_slider|0.7|
🎛️|control knobs|music|control_knobs|0.7|
🎤|microphone|karaoke mic music sing sound|microphone|0.6|
🎧|headphone|earbud sound|headphones|0.6|
📻|radio|entertainment tbt video|radio|0.6|
🎷|saxophone|instrument music sax|saxophone|0.6|
🎺|trumpet|instrument music|trumpet|0.6|
🪊|trombone|brass instrument jazz music sad slide||17|
🪗|accordion|box concertina instrument music squeeze squeezebox|accordion|13|
🎸|guitar|instrument music strat|guitar|0.6|
🎹|musical keyboard|instrument music piano|musical_keyboard|0.6|
🎻|violin|instrument music|violin|0.6|
🪕|banjo|music stringed|banjo|12|
🥁|drum|drumsticks music|drum|3|
🪘|long drum|beat conga instrument rhythm|long_drum|13|
🪇|maracas|cha dance instrument music party percussion|maracas|15|
🪈|flute|band fife flautist instrument marching music|flute|15|
🪉|harp|cupid instrument love music orchestra||16|
📱|mobile phone|cell communication telephone|iphone|0.6|
📲|mobile phone with arrow|build call cell communication receive telephone|calling|0.6|
☎️|telephone|phone|phone telephone|0.6|
📞|telephone receiver|communication phone voip|telephone_receiver|0.6|
📟|pager|communication|pager|0.6|
📠|fax machine|communication|fax|0.6|
🔋|battery||battery|0.6|
🪫|low battery|drained electronic energy power|low_battery|14|
🔌|electric plug|electricity|electric_plug|0.6|
💻|laptop|computer office pc personal|computer|0.6|
🖥️|desktop computer|monitor|desktop_computer|0.7|
🖨️|printer|computer|printer|0.7|
⌨️|keyboard|computer|keyboard|1|
🖱️|computer mouse||computer_mouse|0.7|
🖲️|trackball|computer|trackball|0.7|
💽|computer disk|minidisk optical|minidisc|0.6|
💾|floppy disk|computer|floppy_disk|0.6|
💿|optical disk|cd blu-ray computer dvd|cd|0.6|
📀|dvd|blu-ray cd computer disk optical|dvd|0.6|
🧮|abacus|calculation calculator|abacus|11|
🎥|movie camera|bollywood cinema film hollywood record|movie_camera|0.6|
🎞️|film frames|cinema movie|film_strip|0.7|
📽️|film projector|cinema movie video|film_projector|0.7|
🎬|clapper board|action movie|clapper|0.6|
📺|television|tv video|tv|0.6|
📷|camera|photo selfie snap tbt trip video|camera|0.6|
📸|camera with flash|video|camera_flash|1|
📹|video camera|camcorder tbt|video_camera|0.6|
📼|videocassette|old school tape vcr vhs video|vhs|0.6|
🔍|magnifying glass tilted left|lab left-pointing science search tool|mag|0.6|
🔎|magnifying glass tilted right|contact lab right-pointing science search tool|mag_right|0.6|
🕯️|candle|light|candle|0.7|
💡|light bulb|comic electric idea|bulb|0.6|
🔦|flashlight|electric light tool torch|flashlight|0.6|
🏮|red paper lantern|bar light restaurant|izakaya_lantern lantern|0.6|
🪔|diya lamp|light oil|diya_lamp|12|
📔|notebook with decorative cover|book decorated education school writing|notebook_with_decorative_cover|0.6|
📕|closed book|education|closed_book|0.6|
📖|open book|education fantasy knowledge library novels reading|book open_book|0.6|
📗|green book|education fantasy library reading|green_book|0.6|
📘|blue book|education fantasy library reading|blue_book|0.6|
📙|orange book|education fantasy library reading|orange_book|0.6|
📚|books|book education fantasy knowledge library novels|books|0.6|
📓|notebook||notebook|0.6|
📒|ledger|notebook|ledger|0.6|
📃|page with curl|document paper|page_with_curl|0.6|
📜|scroll|paper|scroll|0.6|
📄|page facing up|document paper|page_facing_up|0.6|
📰|newspaper|communication news paper|newspaper|0.6|
🗞️|rolled-up newspaper|news paper rolled-up|newspaper_roll|0.7|
📑|bookmark tabs|mark marker|bookmark_tabs|0.6|
🔖|bookmark|mark|bookmark|0.6|
🏷️|label|tag|label|0.7|
🪙|coin|dollar euro gold metal money rich|coin|13|
💰|money bag|bank bet billion cash cost dollar|moneybag|0.6|
🪎|treasure chest|gem gold jewels loot money prize||17|
💴|yen banknote|bank bill currency money note|yen|0.6|
💵|dollar banknote|bank bill currency money note|dollar|0.6|
💶|euro banknote|100 bank bill currency money note|euro|1|
💷|pound banknote|bank bill billion cash currency money|pound|1|
💸|money with wings|bank banknote bill billion cash dollar|money_with_wings|0.6|
💳|credit card|bank cash charge money pay|credit_card|0.6|
🧾|receipt|accounting bookkeeping evidence invoice proof|receipt|11|
💹|chart increasing with yen|bank currency graph growth market money|chart|0.6|
✉️|envelope|e-mail email letter|envelope|0.6|
📧|e-mail|email letter|e-mail email|0.6|
📨|incoming envelope|delivering e-mail email letter mail receive|incoming_envelope|0.6|
📩|envelope with arrow|communication down e-mail email letter mail|envelope_with_arrow|0.6|
📤|outbox tray|box email letter mail sent|outbox_tray|0.6|
📥|inbox tray|box email letter mail receive zero|inbox_tray|0.6|
📦|package|box communication delivery parcel shipping|package|0.6|
📫|closed mailbox with raised flag|communication mail postbox|mailbox|0.6|
📪|closed mailbox with lowered flag|mail postbox|mailbox_closed|0.6|
📬|open mailbox with raised flag|mail postbox|mailbox_with_mail|0.7|
📭|open mailbox with lowered flag|mail postbox|mailbox_with_no_mail|0.7|
📮|postbox|mail mailbox|postbox|0.6|
🗳️|ballot box with ballot||ballot_box|0.7|
✏️|pencil||pencil2|0.6|
✒️|black nib|pen|black_nib|0.6|
🖋️|fountain pen||fountain_pen|0.7|
🖊️|pen|ballpoint|pen|0.7|
🖌️|paintbrush|painting|paintbrush|0.7|
🖍️|crayon||crayon|0.7|
📝|memo|communication media notes pencil|memo pencil|0.6|
🪌|eraser|correction delete drawing erase error mistake||18|
💼|briefcase|office|briefcase|0.6|
📁|file folder||file_folder|0.6|
📂|open file folder||open_file_folder|0.6|
🗂️|card index dividers||card_index_dividers|0.7|
📅|calendar|date|date|0.6|
📆|tear-off calendar|tear-off|calendar|0.6|
🗒️|spiral notepad|note pad|spiral_notepad|0.7|
🗓️|spiral calendar|pad|spiral_calendar|0.7|
📇|card index|old rolodex school|card_index|0.6|
📈|chart increasing|data graph growth right trend up|chart_with_upwards_trend|0.6|
📉|chart decreasing|data down downward graph negative trend|chart_with_downwards_trend|0.6|
📊|bar chart|data graph|bar_chart|0.6|
📋|clipboard|do list notes|clipboard|0.6|
📌|pushpin|collage pin|pushpin|0.6|
📍|round pushpin|location map pin|round_pushpin|0.6|
📎|paperclip||paperclip|0.6|
🖇️|linked paperclips|link paperclip|paperclips|0.7|
📏|straight ruler|angle edge math straightedge|straight_ruler|0.6|
📐|triangular ruler|angle math rule set slide triangle|triangular_ruler|0.6|
✂️|scissors|cut cutting paper tool|scissors|0.6|
🗃️|card file box||card_file_box|0.7|
🗄️|file cabinet|filing paper|file_cabinet|0.7|
🗑️|wastebasket|can garbage trash waste|wastebasket|0.7|
🔒|locked|closed lock private|lock|0.6|
🔓|unlocked|cracked lock open unlock|unlock|0.6|
🔏|locked with pen|ink lock nib privacy|lock_with_ink_pen|0.6|
🔐|locked with key|bike closed lock secure|closed_lock_with_key|0.6|
🔑|key|keys lock major password unlock|key|0.6|
🗝️|old key|clue lock|old_key|0.7|
🪍|net with handle|catch collect mesh trap||18|
🔨|hammer|home improvement repairs tool|hammer|0.6|
🪓|axe|ax chop hatchet split wood|axe|12|
⛏️|pick|hammer mining tool|pick|0.7|
⚒️|hammer and pick|tool|hammer_and_pick|1|
🛠️|hammer and wrench|spanner tool|hammer_and_wrench|0.7|
🗡️|dagger|knife weapon|dagger|0.7|
⚔️|crossed swords|weapon|crossed_swords|1|
💣|bomb|boom comic dangerous explosion hot|bomb|0.6|
🪃|boomerang|rebound repercussion weapon|boomerang|13|
🏹|bow and arrow|sagittarius archer archery tool weapon zodiac|bow_and_arrow|1|
🛡️|shield|weapon|shield|0.7|
🪚|carpentry saw|carpenter cut lumber tool trim|carpentry_saw|13|
🔧|wrench|home improvement spanner tool|wrench|0.6|
🪛|screwdriver|flathead handy screw tool|screwdriver|13|
🔩|nut and bolt|home improvement tool|nut_and_bolt|0.6|
⚙️|gear|cog cogwheel tool|gear|1|
🗜️|clamp|compress tool vice|clamp|0.7|
⚖️|balance scale|libra justice scales tool weight zodiac|balance_scale|1|
🦯|white cane|accessibility blind probing|probing_cane|12|
🔗|link|links|link|0.6|
⛓️‍💥|broken chain|break breaking cuffs freedom||15.1|
⛓️|chains|chain|chains|0.7|
🪝|hook|catch crook curve ensnare point selling|hook|13|
🧰|toolbox|box chest mechanic red tool|toolbox|11|
🧲|magnet|attraction horseshoe magnetic negative positive shape|magnet|11|
🪜|ladder|climb rung step|ladder|13|
🪏|shovel|bury dig garden hole plant scoop||16|
⚗️|alembic|chemistry tool|alembic|1|
🧪|test tube|chemist chemistry experiment lab science|test_tube|11|
🧫|petri dish|bacteria biologist biology culture lab|petri_dish|11|
🧬|dna|biologist evolution gene genetics life|dna|11|
🔬|microscope|experiment lab science tool|microscope|1|
🔭|telescope|contact extraterrestrial science tool|telescope|1|
📡|satellite antenna|aliens contact dish science|satellite|0.6|
💉|syringe|doctor flu medicine needle shot sick|syringe|0.6|
🩸|drop of blood|bleed donation injury medicine menstruation|drop_of_blood|12|
💊|pill|doctor drugs medicated medicine pills sick|pill|0.6|
🩹|adhesive bandage||adhesive_bandage|12|
🩼|crutch|aid cane disability help hurt injured|crutch|14|
🩺|stethoscope|doctor heart medicine|stethoscope|12|
🩻|x-ray|bones doctor medical skeleton skull xray|x_ray|14|
🚪|door|back closet front|door|0.6|
🛗|elevator|accessibility hoist lift|elevator|13|
🪞|mirror|makeup reflection reflector speculum|mirror|13|
🪟|window|air frame fresh opening transparent view|window|13|
🛏️|bed|hotel sleep|bed|0.7|
🛋️|couch and lamp|hotel|couch_and_lamp|0.7|
🪑|chair|seat sit|chair|12|
🚽|toilet|bathroom|toilet|0.6|
🪠|plunger|cup force plumber poop suction toilet|plunger|13|
🚿|shower|water|shower|1|
🛁|bathtub|bath|bathtub|1|
🪤|mouse trap|bait cheese lure mousetrap snare|mouse_trap|13|
🪒|razor|sharp shave|razor|12|
🧴|lotion bottle|moisturizer shampoo sunscreen|lotion_bottle|11|
🧷|safety pin|diaper punk rock|safety_pin|11|
🧹|broom|cleaning sweeping witch|broom|11|
🧺|basket|farming laundry picnic|basket|11|
🧻|roll of paper|toilet towels|roll_of_paper|11|
🪣|bucket|cask pail vat|bucket|13|
🧼|soap|bar bathing clean cleaning lather soapdish|soap|11|
🫧|bubbles|bubble burp clean floating pearl soap|bubbles|14|
🪥|toothbrush|bathroom brush clean dental hygiene teeth|toothbrush|13|
🧽|sponge|absorbing cleaning porous soak|sponge|11|
🧯|fire extinguisher|extinguish quench|fire_extinguisher|11|
🛒|shopping cart|trolley|shopping_cart|3|
🚬|cigarette|smoking|smoking|0.6|
⚰️|coffin|dead death vampire|coffin|1|
🪦|headstone|cemetery dead grave graveyard memorial rip|headstone|13|
⚱️|funeral urn|ashes death|funeral_urn|1|
🧿|nazar amulet|bead blue charm evil-eye talisman|nazar_amulet|11|
🪬|hamsa|fatima mary miriam amulet fortune guide|hamsa|14|
🗿|moai|face moyai statue stoneface travel|moyai|0.6|
🪧|placard|card demonstration notice picket plaque protest|placard|13|
🪪|identification card|id credentials document license security|identification_card|14|
#symbols
🏧|ATM sign|automated bank cash money teller|atm|0.6|
🚮|litter in bin sign|litterbin|put_litter_in_its_place|1|
🚰|potable water|drinking|potable_water|1|
♿|wheelchair symbol|access handicap|wheelchair|0.6|
🚹|men’s room|wc bathroom lavatory man restroom toilet|mens|0.6|
🚺|women’s room|wc bathroom lavatory restroom toilet woman|womens|0.6|
🚻|restroom|wc bathroom lavatory toilet|restroom|0.6|
🚼|baby symbol|changing|baby_symbol|0.6|
🚾|water closet|wc bathroom lavatory restroom toilet|wc|0.6|
🛂|passport control||passport_control|1|
🛃|customs|packing|customs|1|
🛄|baggage claim|arrived bags case checked journey packing|baggage_claim|1|
🛅|left luggage|baggage case locker|left_luggage|1|
⚠️|warning|caution|warning|0.6|
🚸|children crossing|child pedestrian traffic|children_crossing|1|
⛔|no entry|do fail forbidden not pass prohibited|no_entry|0.6|
🚫|prohibited|entry forbidden no not smoke|no_entry_sign|0.6|
🚳|no bicycles|bicycle bike forbidden not prohibited|no_bicycles|1|
🚭|no smoking|forbidden not prohibited smoke|no_smoking|0.6|
🚯|no littering|forbidden litter not prohibited|do_not_litter|1|
🚱|non-potable water|dry non-drinking non-potable prohibited|non-potable_water|1|
🚷|no pedestrians|forbidden not pedestrian prohibited|no_pedestrians|1|
📵|no mobile phones|cell forbidden not phone prohibited telephone|no_mobile_phones|1|
🔞|no one under eighteen|18 age forbidden not prohibited restriction|underage|0.6|
☢️|radioactive|sign|radioactive|1|
☣️|biohazard|sign|biohazard|1|
⬆️|up arrow|cardinal direction north|arrow_up|0.6|
↗️|up-right arrow|direction intercardinal northeast up-right|arrow_upper_right|0.6|
➡️|right arrow|cardinal direction east|arrow_right|0.6|
↘️|down-right arrow|direction down-right intercardinal southeast|arrow_lower_right|0.6|
⬇️|down arrow|cardinal direction south|arrow_down|0.6|
↙️|down-left arrow|direction down-left intercardinal southwest|arrow_lower_left|0.6|
⬅️|left arrow|cardinal direction west|arrow_left|0.6|
↖️|up-left arrow|direction intercardinal northwest up-left|arrow_upper_left|0.6|
↕️|up-down arrow|up-down|arrow_up_down|0.6|
↔️|left-right arrow|left-right|left_right_arrow|0.6|
↩️|right arrow curving left||leftwards_arrow_with_hook|0.6|
↪️|left arrow curving right||arrow_right_hook|0.6|
⤴️|right arrow curving up||arrow_heading_up|0.6|
⤵️|right arrow curving down||arrow_heading_down|0.6|
🔃|clockwise vertical arrows|arrow refresh reload|arrows_clockwise|0.6|
🔄|counterclockwise arrows button|again anticlockwise arrow deja refresh rewindershins|arrows_counterclockwise|1|
🔙|BACK arrow||back|0.6|
🔚|END arrow||end|0.6|
🔛|ON! arrow|mark|on|0.6|
🔜|SOON arrow|brb omw|soon|0.6|
🔝|TOP arrow|homie up|top|0.6|
🛐|place of worship|pray religion|place_of_worship|1|
⚛️|atom symbol|atheist|atom_symbol|1|
🕉️|om|hindu religion|om|0.7|
✡️|star of David|jew jewish judaism religion|star_of_david|0.7|
☸️|wheel of dharma|buddhist religion|wheel_of_dharma|0.7|
☯️|yin yang|difficult lives religion tao taoist total|yin_yang|0.7|
✝️|latin cross|christian christ religion|latin_cross|0.7|
☦️|orthodox cross|christian religion|orthodox_cross|1|
☪️|star and crescent|muslim islam ramadan religion|star_and_crescent|0.7|
☮️|peace symbol|healing peaceful|peace_symbol|1|
🕎|menorah|candelabrum candlestick hanukkah jewish judaism religion|menorah|1|
🔯|dotted six-pointed star|fortune jewish judaism six-pointed|six_pointed_star|0.6|
🪯|khanda|deg fateh khalsa sikh sikhism tegh|khanda|15|
♈|Aries|horoscope ram zodiac|aries|0.6|
♉|Taurus|bull horoscope ox zodiac|taurus|0.6|
♊|Gemini|horoscope twins zodiac|gemini|0.6|
♋|Cancer|crab horoscope zodiac|cancer|0.6|
♌|Leo|horoscope lion zodiac|leo|0.6|
♍|Virgo|horoscope zodiac|virgo|0.6|
♎|Libra|balance horoscope justice scales zodiac|libra|0.6|
♏|Scorpio|scorpius horoscope scorpion zodiac|scorpius|0.6|
♐|Sagittarius|archer horoscope zodiac|sagittarius|0.6|
♑|Capricorn|goat horoscope zodiac|capricorn|0.6|
♒|Aquarius|bearer horoscope water zodiac|aquarius|0.6|
♓|Pisces|fish horoscope zodiac|pisces|0.6|
⛎|Ophiuchus|bearer serpent snake zodiac|ophiuchus|0.6|
🔀|shuffle tracks button|arrow crossed|twisted_rightwards_arrows|1|
🔁|repeat button|arrow clockwise|repeat|1|
🔂|repeat single button|arrow clockwise once|repeat_one|1|
▶️|play button|arrow right triangle|arrow_forward|0.6|
⏩|fast-forward button|arrow double fast-forward|fast_forward|0.6|
⏭️|next track button|arrow scene triangle|next_track_button|0.7|
⏯️|play or pause button|arrow right triangle|play_or_pause_button|1|
◀️|reverse button|arrow left triangle|arrow_backward|0.6|
⏪|fast reverse button|arrow double rewind|rewind|0.6|
⏮️|last track button|arrow previous scene triangle|previous_track_button|0.7|
🔼|upwards button|arrow red up|arrow_up_small|0.6|
⏫|fast up button|arrow double|arrow_double_up|0.6|
🔽|downwards button|arrow down red|arrow_down_small|0.6|
⏬|fast down button|arrow double|arrow_double_down|0.6|
⏸️|pause button|bar double vertical|pause_button|0.7|
⏹️|stop button|square|stop_button|0.7|
⏺️|record button|circle|record_button|0.7|
⏏️|eject button||eject_button|1|
🎦|cinema|camera film movie|cinema|0.6|
🔅|dim button|brightness low|low_brightness|1|
🔆|bright button|brightness light|high_brightness|1|
📶|antenna bars|bar cell communication mobile phone signal|signal_strength|0.6|
🛜|wireless|broadband computer connectivity hotspot internet network|wireless|15|
📳|vibration mode|cell communication mobile phone telephone|vibration_mode|0.6|
📴|mobile phone off|cell telephone|mobile_phone_off|0.6|
♀️|female sign|woman|female_sign|4|
♂️|male sign|man|male_sign|4|
⚧️|transgender symbol||transgender_symbol|13|
✖️|multiply|cancel multiplication sign x ×|heavy_multiplication_x|0.6|
➕|plus|+|heavy_plus_sign|0.6|
➖|minus|- heavy math sign −|heavy_minus_sign|0.6|
➗|divide|division heavy math sign ÷|heavy_division_sign|0.6|
🟰|heavy equals sign|answer equal equality math|heavy_equals_sign|14|
♾️|infinity|forever unbounded universal|infinity|11|
‼️|double exclamation mark|! !! bangbang punctuation|bangbang|0.6|
⁉️|exclamation question mark|! !? ? interrobang punctuation|interrobang|0.6|
❓|red question mark|? punctuation|question|0.6|
❔|white question mark|? outlined punctuation|grey_question|0.6|
❕|white exclamation mark|! bang outlined punctuation|grey_exclamation|0.6|
❗|red exclamation mark|! bang punctuation|exclamation heavy_exclamation_mark|0.6|
〰️|wavy dash|punctuation|wavy_dash|0.6|
💱|currency exchange|bank money|currency_exchange|0.6|
💲|heavy dollar sign|billion cash charge currency million money|heavy_dollar_sign|0.6|
⚕️|medical symbol|aesculapius medicine staff|medical_symbol|4|
♻️|recycling symbol|recycle|recycle|0.6|
⚜️|fleur-de-lis|knights|fleur_de_lis|1|
🔱|trident emblem|anchor poseidon ship tool|trident|0.6|
📛|name badge||name_badge|0.6|
🔰|Japanese symbol for beginner|chevron green leaf tool yellow|beginner|0.6|
⭕|hollow red circle|heavy large o|o|0.6|
✅|check mark button|checked checkmark complete completed done fixed|white_check_mark|0.6|
☑️|check box with check|ballot checked done off tick ✓|ballot_box_with_check|0.6|
✔️|check mark|checked checkmark done heavy tick ✓|heavy_check_mark|0.6|
❌|cross mark|cancel multiplication multiply x ×|x|0.6|
❎|cross mark button|multiplication multiply square x ×|negative_squared_cross_mark|0.6|
➰|curly loop|curl|curly_loop|0.6|
➿|double curly loop|curl|loop|1|
〽️|part alternation mark||part_alternation_mark|0.6|
✳️|eight-spoked asterisk|* eight-spoked|eight_spoked_asterisk|0.6|
✴️|eight-pointed star|* eight-pointed|eight_pointed_black_star|0.6|
❇️|sparkle|*|sparkle|0.6|
©️|copyright|c|copyright|0.6|
®️|registered|r|registered|0.6|
™️|trade mark|tm trademark|tm|0.6|
🫟|splatter|drip holi ink liquid mess paint||16|
#️⃣|keycap: #||hash|0.6|
*️⃣|keycap: *||asterisk|2|
0️⃣|keycap: 0|zero|zero|0.6|
1️⃣|keycap: 1|one|one|0.6|
2️⃣|keycap: 2|two|two|0.6|
3️⃣|keycap: 3|three|three|0.6|
4️⃣|keycap: 4|four|four|0.6|
5️⃣|keycap: 5|five|five|0.6|
6️⃣|keycap: 6|six|six|0.6|
7️⃣|keycap: 7|seven|seven|0.6|
8️⃣|keycap: 8|eight|eight|0.6|
9️⃣|keycap: 9|nine|nine|0.6|
🔟|keycap: 10||keycap_ten|0.6|
🔠|input latin uppercase|abcd letters|capital_abcd|0.6|
🔡|input latin lowercase|abcd letters|abcd|0.6|
🔢|input numbers|1234|1234|0.6|
🔣|input symbols|% & ♪ 〒|symbols|0.6|
🔤|input latin letters|abc alphabet|abc|0.6|
🅰️|A button (blood type)|blood type|a|0.6|
🆎|AB button (blood type)|blood type|ab|0.6|
🅱️|B button (blood type)|blood type|b|0.6|
🆑|CL button||cl|0.6|
🆒|COOL button||cool|0.6|
🆓|FREE button||free|0.6|
ℹ️|information|i|information_source|0.6|
🆔|ID button|identity|id|0.6|
Ⓜ️|circled M|circle|m|0.6|
🆕|NEW button||new|0.6|
🆖|NG button||ng|0.6|
🅾️|O button (blood type)|blood type|o2|0.6|
🆗|OK button|okay|ok|0.6|
🅿️|P button|parking|parking|0.6|
🆘|SOS button|help|sos|0.6|
🆙|UP! button|up mark|up|0.6|
🆚|VS button|versus|vs|0.6|
🈁|Japanese “here” button|here katakana|koko|0.6|
🈂️|Japanese “service charge” button|charge katakana service|sa|0.6|
🈷️|Japanese “monthly amount” button|amount ideograph monthly|u6708|0.6|
🈶|Japanese “not free of charge” button|charge ideograph not|u6709|0.6|
🈯|Japanese “reserved” button|ideograph reserved|u6307|0.6|
🉐|Japanese “bargain” button|bargain ideograph|ideograph_advantage|0.6|
🈹|Japanese “discount” button|discount ideograph|u5272|0.6|
🈚|Japanese “free of charge” button|charge free ideograph|u7121|0.6|
🈲|Japanese “prohibited” button|ideograph prohibited|u7981|0.6|
🉑|Japanese “acceptable” button|acceptable ideograph|accept|0.6|
🈸|Japanese “application” button|application ideograph|u7533|0.6|
🈴|Japanese “passing grade” button|grade ideograph passing|u5408|0.6|
🈳|Japanese “vacancy” button|ideograph vacancy|u7a7a|0.6|
㊗️|Japanese “congratulations” button|congratulations ideograph|congratulations|0.6|
㊙️|Japanese “secret” button|ideograph secret|secret|0.6|
🈺|Japanese “open for business” button|business ideograph open|u55b6|0.6|
🈵|Japanese “no vacancy” button|ideograph no vacancy|u6e80|0.6|
🔴|red circle|geometric|red_circle|0.6|
🟠|orange circle||orange_circle|12|
🟡|yellow circle||yellow_circle|12|
🟢|green circle||green_circle|12|
🔵|blue circle|geometric|large_blue_circle|0.6|
🟣|purple circle||purple_circle|12|
🟤|brown circle||brown_circle|12|
⚫|black circle|geometric|black_circle|0.6|
⚪|white circle|geometric|white_circle|0.6|
🟥|red square|card penalty|red_square|12|
🟧|orange square||orange_square|12|
🟨|yellow square|card penalty|yellow_square|12|
🟩|green square||green_square|12|
🟦|blue square||blue_square|12|
🟪|purple square||purple_square|12|
🟫|brown square||brown_square|12|
⬛|black large square|geometric|black_large_square|0.6|
⬜|white large square|geometric|white_large_square|0.6|
◼️|black medium square|geometric|black_medium_square|0.6|
◻️|white medium square|geometric|white_medium_square|0.6|
◾|black medium-small square|geometric medium-small|black_medium_small_square|0.6|
◽|white medium-small square|geometric medium-small|white_medium_small_square|0.6|
▪️|black small square|geometric|black_small_square|0.6|
▫️|white small square|geometric|white_small_square|0.6|
🔶|large orange diamond|geometric|large_orange_diamond|0.6|
🔷|large blue diamond|geometric|large_blue_diamond|0.6|
🔸|small orange diamond|geometric|small_orange_diamond|0.6|
🔹|small blue diamond|geometric|small_blue_diamond|0.6|
🔺|red triangle pointed up|geometric|small_red_triangle|0.6|
🔻|red triangle pointed down|geometric|small_red_triangle_down|0.6|
💠|diamond with a dot|comic geometric|diamond_shape_with_a_dot_inside|0.6|
🔘|radio button|geometric|radio_button|0.6|
🔳|white square button|geometric outlined|white_square_button|0.6|
🔲|black square button|geometric|black_square_button|0.6|
#flags
🏁|chequered flag|checkered finish flags game race racing|checkered_flag|0.6|
🚩|triangular flag|construction golf post|triangular_flag_on_post|0.6|
🎌|crossed flags|japanese celebration cross|crossed_flags|0.6|
🏴|black flag|waving|black_flag|1|
🏳️|white flag|waving|white_flag|0.7|
🏳️‍🌈|rainbow flag|bisexual gay genderqueer glbt glbtq lesbian|rainbow_flag|4|
🏳️‍⚧️|transgender flag|blue light pink white|transgender_flag|13|
🏴‍☠️|pirate flag|jolly roger plunder treasure|pirate_flag|11|
🇦🇨|flag: Ascension Island|ac|ascension_island|2|
🇦🇩|flag: Andorra|ad|andorra|2|
🇦🇪|flag: United Arab Emirates|ae|united_arab_emirates|2|
🇦🇫|flag: Afghanistan|af|afghanistan|2|
🇦🇬|flag: Antigua & Barbuda|ag|antigua_barbuda|2|
🇦🇮|flag: Anguilla|ai|anguilla|2|
🇦🇱|flag: Albania|al|albania|2|
🇦🇲|flag: Armenia|am|armenia|2|
🇦🇴|flag: Angola|ao|angola|2|
🇦🇶|flag: Antarctica|aq|antarctica|2|
🇦🇷|flag: Argentina|ar|argentina|2|
🇦🇸|flag: American Samoa|as|american_samoa|2|
🇦🇹|flag: Austria|at|austria|2|
🇦🇺|flag: Australia|au|australia|2|
🇦🇼|flag: Aruba|aw|aruba|2|
🇦🇽|flag: Åland Islands|ax|aland_islands|2|
🇦🇿|flag: Azerbaijan|az|azerbaijan|2|
🇧🇦|flag: Bosnia & Herzegovina|ba|bosnia_herzegovina|2|
🇧🇧|flag: Barbados|bb|barbados|2|
🇧🇩|flag: Bangladesh|bd|bangladesh|2|
🇧🇪|flag: Belgium|be|belgium|2|
🇧🇫|flag: Burkina Faso|bf|burkina_faso|2|
🇧🇬|flag: Bulgaria|bg|bulgaria|2|
🇧🇭|flag: Bahrain|bh|bahrain|2|
🇧🇮|flag: Burundi|bi|burundi|2|
🇧🇯|flag: Benin|bj|benin|2|
🇧🇱|flag: St. Barthélemy|bl|st_barthelemy|2|
🇧🇲|flag: Bermuda|bm|bermuda|2|
🇧🇳|flag: Brunei|bn|brunei|2|
🇧🇴|flag: Bolivia|bo|bolivia|2|
🇧🇶|flag: Caribbean Netherlands|bq|caribbean_netherlands|2|
🇧🇷|flag: Brazil|br|brazil|2|
🇧🇸|flag: Bahamas|bs|bahamas|2|
🇧🇹|flag: Bhutan|bt|bhutan|2|
🇧🇻|flag: Bouvet Island|bv|bouvet_island|2|
🇧🇼|flag: Botswana|bw|botswana|2|
🇧🇾|flag: Belarus|by|belarus|2|
🇧🇿|flag: Belize|bz|belize|2|
🇨🇦|flag: Canada|ca|canada|2|
🇨🇨|flag: Cocos (Keeling) Islands|cc|cocos_islands|2|
🇨🇩|flag: Congo - Kinshasa|cd|congo_kinshasa|2|
🇨🇫|flag: Central African Republic|cf|central_african_republic|2|
🇨🇬|flag: Congo - Brazzaville|cg|congo_brazzaville|2|
🇨🇭|flag: Switzerland|ch|switzerland|2|
🇨🇮|flag: Côte d’Ivoire|ci|cote_divoire|2|
🇨🇰|flag: Cook Islands|ck|cook_islands|2|
🇨🇱|flag: Chile|cl|chile|2|
🇨🇲|flag: Cameroon|cm|cameroon|2|
🇨🇳|flag: China|cn|cn|0.6|
🇨🇴|flag: Colombia|co|colombia|2|
🇨🇵|flag: Clipperton Island|cp|clipperton_island|2|
🇨🇶|flag: Sark|cq||16|
🇨🇷|flag: Costa Rica|cr|costa_rica|2|
🇨🇺|flag: Cuba|cu|cuba|2|
🇨🇻|flag: Cape Verde|cv|cape_verde|2|
🇨🇼|flag: Curaçao|cw|curacao|2|
🇨🇽|flag: Christmas Island|cx|christmas_island|2|
🇨🇾|flag: Cyprus|cy|cyprus|2|
🇨🇿|flag: Czechia|cz|czech_republic|2|
🇩🇪|flag: Germany|de|de|0.6|
🇩🇬|flag: Diego Garcia|dg|diego_garcia|2|
🇩🇯|flag: Djibouti|dj|djibouti|2|
🇩🇰|flag: Denmark|dk|denmark|2|
🇩🇲|flag: Dominica|dm|dominica|2|
🇩🇴|flag: Dominican Republic|do|dominican_republic|2|
🇩🇿|flag: Algeria|dz|algeria|2|
🇪🇦|flag: Ceuta & Melilla|ea|ceuta_melilla|2|
🇪🇨|flag: Ecuador|ec|ecuador|2|
🇪🇪|flag: Estonia|ee|estonia|2|
🇪🇬|flag: Egypt|eg|egypt|2|
🇪🇭|flag: Western Sahara|eh|western_sahara|2|
🇪🇷|flag: Eritrea|er|eritrea|2|
🇪🇸|flag: Spain|es|es|0.6|
🇪🇹|flag: Ethiopia|et|ethiopia|2|
🇪🇺|flag: European Union|eu|eu european_union|2|
🇫🇮|flag: Finland|fi|finland|2|
🇫🇯|flag: Fiji|fj|fiji|2|
🇫🇰|flag: Falkland Islands|fk|falkland_islands|2|
🇫🇲|flag: Micronesia|fm|micronesia|2|
🇫🇴|flag: Faroe Islands|fo|faroe_islands|2|
🇫🇷|flag: France|fr|fr|0.6|
🇬🇦|flag: Gabon|ga|gabon|2|
🇬🇧|flag: United Kingdom|gb|gb uk|0.6|
🇬🇩|flag: Grenada|gd|grenada|2|
🇬🇪|flag: Georgia|ge|georgia|2|
🇬🇫|flag: French Guiana|gf|french_guiana|2|
🇬🇬|flag: Guernsey|gg|guernsey|2|
🇬🇭|flag: Ghana|gh|ghana|2|
🇬🇮|flag: Gibraltar|gi|gibraltar|2|
🇬🇱|flag: Greenland|gl|greenland|2|
🇬🇲|flag: Gambia|gm|gambia|2|
🇬🇳|flag: Guinea|gn|guinea|2|
🇬🇵|flag: Guadeloupe|gp|guadeloupe|2|
🇬🇶|flag: Equatorial Guinea|gq|equatorial_guinea|2|
🇬🇷|flag: Greece|gr|greece|2|
🇬🇸|flag: South Georgia & South Sandwich Islands|gs|south_georgia_south_sandwich_islands|2|
🇬🇹|flag: Guatemala|gt|guatemala|2|
🇬🇺|flag: Guam|gu|guam|2|
🇬🇼|flag: Guinea-Bissau|gw|guinea_bissau|2|
🇬🇾|flag: Guyana|gy|guyana|2|
🇭🇰|flag: Hong Kong SAR China|hk|hong_kong|2|
🇭🇲|flag: Heard Island & McDonald Islands|hm|heard_mcdonald_islands|2|
🇭🇳|flag: Honduras|hn|honduras|2|
🇭🇷|flag: Croatia|hr|croatia|2|
🇭🇹|flag: Haiti|ht|haiti|2|
🇭🇺|flag: Hungary|hu|hungary|2|
🇮🇨|flag: Canary Islands|ic|canary_islands|2|
🇮🇩|flag: Indonesia|id|indonesia|2|
🇮🇪|flag: Ireland|ie|ireland|2|
🇮🇱|flag: Israel|il|israel|2|
🇮🇲|flag: Isle of Man|im|isle_of_man|2|
🇮🇳|flag: India|in|india|2|
🇮🇴|flag: British Indian Ocean Territory|io|british_indian_ocean_territory|2|
🇮🇶|flag: Iraq|iq|iraq|2|
🇮🇷|flag: Iran|ir|iran|2|
🇮🇸|flag: Iceland|is|iceland|2|
🇮🇹|flag: Italy|it|it|0.6|
🇯🇪|flag: Jersey|je|jersey|2|
🇯🇲|flag: Jamaica|jm|jamaica|2|
🇯🇴|flag: Jordan|jo|jordan|2|
🇯🇵|flag: Japan|jp|jp|0.6|
🇰🇪|flag: Kenya|ke|kenya|2|
🇰🇬|flag: Kyrgyzstan|kg|kyrgyzstan|2|
🇰🇭|flag: Cambodia|kh|cambodia|2|
🇰🇮|flag: Kiribati|ki|kiribati|2|
🇰🇲|flag: Comoros|km|comoros|2|
🇰🇳|flag: St. Kitts & Nevis|kn|st_kitts_nevis|2|
🇰🇵|flag: North Korea|kp|north_korea|2|
🇰🇷|flag: South Korea|kr|kr|0.6|
🇰🇼|flag: Kuwait|kw|kuwait|2|
🇰🇾|flag: Cayman Islands|ky|cayman_islands|2|
🇰🇿|flag: Kazakhstan|kz|kazakhstan|2|
🇱🇦|flag: Laos|la|laos|2|
🇱🇧|flag: Lebanon|lb|lebanon|2|
🇱🇨|flag: St. Lucia|lc|st_lucia|2|
🇱🇮|flag: Liechtenstein|li|liechtenstein|2|
🇱🇰|flag: Sri Lanka|lk|sri_lanka|2|
🇱🇷|flag: Liberia|lr|liberia|2|
🇱🇸|flag: Lesotho|ls|lesotho|2|
🇱🇹|flag: Lithuania|lt|lithuania|2|
🇱🇺|flag: Luxembourg|lu|luxembourg|2|
🇱🇻|flag: Latvia|lv|latvia|2|
🇱🇾|flag: Libya|ly|libya|2|
🇲🇦|flag: Morocco|ma|morocco|2|
🇲🇨|flag: Monaco|mc|monaco|2|
🇲🇩|flag: Moldova|md|moldova|2|
🇲🇪|flag: Montenegro|me|montenegro|2|
🇲🇫|flag: St. Martin|mf|st_martin|2|
🇲🇬|flag: Madagascar|mg|madagascar|2|
🇲🇭|flag: Marshall Islands|mh|marshall_islands|2|
🇲🇰|flag: North Macedonia|mk|macedonia|2|
🇲🇱|flag: Mali|ml|mali|2|
🇲🇲|flag: Myanmar (Burma)|mm|myanmar|2|
🇲🇳|flag: Mongolia|mn|mongolia|2|
🇲🇴|flag: Macao SAR China|mo|macau|2|
🇲🇵|flag: Northern Mariana Islands|mp|northern_mariana_islands|2|
🇲🇶|flag: Martinique|mq|martinique|2|
🇲🇷|flag: Mauritania|mr|mauritania|2|
🇲🇸|flag: Montserrat|ms|montserrat|2|
🇲🇹|flag: Malta|mt|malta|2|
🇲🇺|flag: Mauritius|mu|mauritius|2|
🇲🇻|flag: Maldives|mv|maldives|2|
🇲🇼|flag: Malawi|mw|malawi|2|
🇲🇽|flag: Mexico|mx|mexico|2|
🇲🇾|flag: Malaysia|my|malaysia|2|
🇲🇿|flag: Mozambique|mz|mozambique|2|
🇳🇦|flag: Namibia|na|namibia|2|
🇳🇨|flag: New Caledonia|nc|new_caledonia|2|
🇳🇪|flag: Niger|ne|niger|2|
🇳🇫|flag: Norfolk Island|nf|norfolk_island|2|
🇳🇬|flag: Nigeria|ng|nigeria|2|
🇳🇮|flag: Nicaragua|ni|nicaragua|2|
🇳🇱|flag: Netherlands|nl|netherlands|2|
🇳🇴|flag: Norway|no|norway|2|
🇳🇵|flag: Nepal|np|nepal|2|
🇳🇷|flag: Nauru|nr|nauru|2|
🇳🇺|flag: Niue|nu|niue|2|
🇳🇿|flag: New Zealand|nz|new_zealand|2|
🇴🇲|flag: Oman|om|oman|2|
🇵🇦|flag: Panama|pa|panama|2|
🇵🇪|flag: Peru|pe|peru|2|
🇵🇫|flag: French Polynesia|pf|french_polynesia|2|
🇵🇬|flag: Papua New Guinea|pg|papua_new_guinea|2|
🇵🇭|flag: Philippines|ph|philippines|2|
🇵🇰|flag: Pakistan|pk|pakistan|2|
🇵🇱|flag: Poland|pl|poland|2|
🇵🇲|flag: St. Pierre & Miquelon|pm|st_pierre_miquelon|2|
🇵🇳|flag: Pitcairn Islands|pn|pitcairn_islands|2|
🇵🇷|flag: Puerto Rico|pr|puerto_rico|2|
🇵🇸|flag: Palestinian Territories|ps|palestinian_territories|2|
🇵🇹|flag: Portugal|pt|portugal|2|
🇵🇼|flag: Palau|pw|palau|2|
🇵🇾|flag: Paraguay|py|paraguay|2|
🇶🇦|flag: Qatar|qa|qatar|2|
🇷🇪|flag: Réunion|re|reunion|2|
🇷🇴|flag: Romania|ro|romania|2|
🇷🇸|flag: Serbia|rs|serbia|2|
🇷🇺|flag: Russia|ru|ru|0.6|
🇷🇼|flag: Rwanda|rw|rwanda|2|
🇸🇦|flag: Saudi Arabia|sa|saudi_arabia|2|
🇸🇧|flag: Solomon Islands|sb|solomon_islands|2|
🇸🇨|flag: Seychelles|sc|seychelles|2|
🇸🇩|flag: Sudan|sd|sudan|2|
🇸🇪|flag: Sweden|se|sweden|2|
🇸🇬|flag: Singapore|sg|singapore|2|
🇸🇭|flag: St. Helena, Ascension & Tristan da Cunha|sh|st_helena|2|
🇸🇮|flag: Slovenia|si|slovenia|2|
🇸🇯|flag: Svalbard & Jan Mayen|sj|svalbard_jan_mayen|2|
🇸🇰|flag: Slovakia|sk|slovakia|2|
🇸🇱|flag: Sierra Leone|sl|sierra_leone|2|
🇸🇲|flag: San Marino|sm|san_marino|2|
🇸🇳|flag: Senegal|sn|senegal|2|
🇸🇴|flag: Somalia|so|somalia|2|
🇸🇷|flag: Suriname|sr|suriname|2|
🇸🇸|flag: South Sudan|ss|south_sudan|2|
🇸🇹|flag: São Tomé & Príncipe|st|sao_tome_principe|2|
🇸🇻|flag: El Salvador|sv|el_salvador|2|
🇸🇽|flag: Sint Maarten|sx|sint_maarten|2|
🇸🇾|flag: Syria|sy|syria|2|
🇸🇿|flag: Eswatini|sz|swaziland|2|
🇹🇦|flag: Tristan da Cunha|ta|tristan_da_cunha|2|
🇹🇨|flag: Turks & Caicos Islands|tc|turks_caicos_islands|2|
🇹🇩|flag: Chad|td|chad|2|
🇹🇫|flag: French Southern and Antarctic Lands|tf|french_southern_territories|2|
🇹🇬|flag: Togo|tg|togo|2|
🇹🇭|flag: Thailand|th|thailand|2|
🇹🇯|flag: Tajikistan|tj|tajikistan|2|
🇹🇰|flag: Tokelau|tk|tokelau|2|
🇹🇱|flag: Timor-Leste|tl|timor_leste|2|
🇹🇲|flag: Turkmenistan|tm|turkmenistan|2|
🇹🇳|flag: Tunisia|tn|tunisia|2|
🇹🇴|flag: Tonga|to|tonga|2|
🇹🇷|flag: Türkiye|tr|tr|2|
🇹🇹|flag: Trinidad & Tobago|tt|trinidad_tobago|2|
🇹🇻|flag: Tuvalu|tv|tuvalu|2|
🇹🇼|flag: Taiwan|tw|taiwan|2|
🇹🇿|flag: Tanzania|tz|tanzania|2|
🇺🇦|flag: Ukraine|ua|ukraine|2|
🇺🇬|flag: Uganda|ug|uganda|2|
🇺🇲|flag: U.S. Outlying Islands|um|us_outlying_islands|2|
🇺🇳|flag: United Nations|un|united_nations|4|
🇺🇸|flag: United States|us|us|0.6|
🇺🇾|flag: Uruguay|uy|uruguay|2|
🇺🇿|flag: Uzbekistan|uz|uzbekistan|2|
🇻🇦|flag: Vatican City|va|vatican_city|2|
🇻🇨|flag: St. Vincent & Grenadines|vc|st_vincent_grenadines|2|
🇻🇪|flag: Venezuela|ve|venezuela|2|
🇻🇬|flag: British Virgin Islands|vg|british_virgin_islands|2|
🇻🇮|flag: U.S. Virgin Islands|vi|us_virgin_islands|2|
🇻🇳|flag: Vietnam|vn|vietnam|2|
🇻🇺|flag: Vanuatu|vu|vanuatu|2|
🇼🇫|flag: Wallis & Futuna|wf|wallis_futuna|2|
🇼🇸|flag: Samoa|ws|samoa|2|
🇽🇰|flag: Kosovo|xk|kosovo|2|
🇾🇪|flag: Yemen|ye|yemen|2|
🇾🇹|flag: Mayotte|yt|mayotte|2|
🇿🇦|flag: South Africa|za|south_africa|2|
🇿🇲|flag: Zambia|zm|zambia|2|
🇿🇼|flag: Zimbabwe|zw|zimbabwe|2|
🏴󠁧󠁢󠁥󠁮󠁧󠁿|flag: England|gbeng|england|5|
🏴󠁧󠁢󠁳󠁣󠁴󠁿|flag: Scotland|gbsct|scotland|5|
🏴󠁧󠁢󠁷󠁬󠁳󠁿|flag: Wales|gbwls|wales|5|`, fie = ["👍", "❤️", "😂", "🎉", "🔥", "👀", "✅", "🙏"], m_ = ["✋", "✋🏻", "✋🏼", "✋🏽", "✋🏾", "✋🏿"];
let Mh = null;
function or(i) {
  return i.replace(/️/g, "");
}
function gm() {
  if (Mh) return Mh;
  const i = [], e = [], t = /* @__PURE__ */ new Map(), n = new Map(hie.map((o) => [o.key, o.label]));
  let s = null;
  for (const o of pie.split(`
`)) {
    if (o.charAt(0) === "#" && o.indexOf("|") < 0) {
      const p = o.slice(1);
      s = { key: p, label: n.get(p) || p, emoji: [] }, i.push(s);
      continue;
    }
    if (!s) continue;
    const [r, a, l, d, c, h] = o.split("|"), f = { c: r, n: a, k: (a + " " + l).toLowerCase(), s: d ? d.split(" ") : [], v: Number(c) || 0, skins: h ? h.split(" ") : null, g: s.key };
    if (s.emoji.push(f), e.push(f), t.set(or(r), f), f.skins) for (const p of f.skins) t.set(or(p), f);
  }
  return Mh = { groups: i, all: e, byBase: t }, Mh;
}
const g_ = "rd-board-emoji-version";
let Th = null;
function QC() {
  if (Th != null) return Th;
  if (typeof document == "undefined" || /jsdom/i.test(navigator.userAgent)) return 1 / 0;
  try {
    const e = JSON.parse(localStorage.getItem(g_) || "null");
    if (e && e.ua === navigator.userAgent && typeof e.v == "number") return Th = e.v;
  } catch {
  }
  const i = Th = mie();
  try {
    localStorage.setItem(g_, JSON.stringify({ ua: navigator.userAgent, v: i }));
  } catch {
  }
  return i;
}
function mie() {
  const i = document.createElement("canvas");
  i.width = i.height = 32;
  const e = i.getContext("2d", { willReadFrequently: !0 });
  if (!e) return 1 / 0;
  e.font = '24px "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif', e.textBaseline = "top";
  const t = e.measureText("😀").width;
  if (!t) return 1 / 0;
  const n = /* @__PURE__ */ new Map();
  for (const o of gm().all) o.v > 12 && !n.has(o.v) && n.set(o.v, o.c);
  let s = 12;
  for (const o of Array.from(n.keys()).sort((r, a) => r - a)) {
    if (!gie(e, n.get(o), t)) break;
    s = o;
  }
  return s;
}
function gie(i, e, t) {
  if (i.measureText(e).width > t * 1.5) return !1;
  i.clearRect(0, 0, 32, 32), i.fillText(e, 0, 0);
  const n = i.getImageData(0, 0, 32, 32).data;
  for (let s = 0; s < n.length; s += 4) {
    if (n[s + 3] < 128) continue;
    const o = n[s], r = n[s + 1], a = n[s + 2];
    if (Math.max(o, r, a) - Math.min(o, r, a) > 40) return !0;
  }
  return !1;
}
function bie() {
  const i = QC();
  return gm().groups.map((e) => ({ ...e, emoji: e.emoji.filter((t) => t.v <= i) }));
}
function Ky(i) {
  return gm().byBase.get(or(i)) || null;
}
function ll(i, e) {
  return e && i.skins ? i.skins[e - 1] : i.c;
}
function eI(i, e = 120) {
  const t = i.toLowerCase().replace(/^:+|:+$/g, "").trim();
  if (!t) return [];
  const n = t.split(/\s+/), s = QC(), o = [];
  for (const r of gm().all) {
    if (r.v > s) continue;
    let a = 0, l = !0;
    for (const d of n) {
      const c = vie(r, d);
      if (!c) {
        l = !1;
        break;
      }
      a += c;
    }
    l && o.push({ e: r, score: a });
  }
  return o.sort((r, a) => a.score - r.score), o.slice(0, e).map((r) => r.e);
}
function vie(i, e) {
  if (i.s.some((a) => a === e)) return 100;
  const t = i.n.toLowerCase();
  if (t === e) return 90;
  const n = (a) => e.length / Math.max(e.length, a.length), s = i.s.find((a) => a.startsWith(e));
  if (s) return 60 + 20 * n(s);
  if (t.startsWith(e)) return 50 + 20 * n(t);
  const o = t.split(/[\s:,-]+/).find((a) => a.startsWith(e));
  if (o) return 40 + 10 * n(o);
  const r = i.k.split(" ").find((a) => a.startsWith(e));
  return r ? 25 + 10 * n(r) : i.k.includes(e) ? 8 : 0;
}
const Yy = "rd-board-emoji-recent", tI = "rd-board-emoji-tone", nI = 24;
function x0() {
  try {
    const i = JSON.parse(localStorage.getItem(Yy) || "[]");
    return Array.isArray(i) ? i.filter((e) => typeof e == "string").slice(0, nI) : [];
  } catch {
    return [];
  }
}
function If(i) {
  const e = [i, ...x0().filter((t) => or(t) !== or(i))].slice(0, nI);
  try {
    localStorage.setItem(Yy, JSON.stringify(e));
  } catch {
  }
}
function yie() {
  try {
    localStorage.removeItem(Yy);
  } catch {
  }
}
function w0() {
  try {
    const i = Number(localStorage.getItem(tI));
    return i >= 0 && i <= 5 ? i : 0;
  } catch {
    return 0;
  }
}
function xie(i) {
  try {
    localStorage.setItem(tI, String(i));
  } catch {
  }
}
function wie(i) {
  return Array.from(or(i)).map((e) => e.codePointAt(0).toString(16)).join("-");
}
function kie(i) {
  const e = i.split("-").map((n) => String.fromCodePoint(parseInt(n, 16) || 63)).join(""), t = Ky(e);
  return t ? or(t.c) === e ? t.c : (t.skins || []).find((n) => or(n) === e) || e : e;
}
function _ie(i) {
  const e = i.trim();
  if (!e || e.length > 40) return !1;
  const n = (typeof Intl != "undefined" && "Segmenter" in Intl ? Array.from(new Intl.Segmenter(void 0, { granularity: "grapheme" }).segment(e)).map((s) => s.segment) : Array.from(e)).filter((s) => s.trim());
  return n.length > 0 && n.length <= 3 && n.every((s) => !!Ky(s) || /[\u{1F000}-\u{1FAFF}]/u.test(s));
}
const Sie = 280, ib = 5e3;
function Ch(i, e, t, n = 0) {
  return i.markedUnread.includes(t) ? !0 : k0(i, e, t, n) > 0;
}
function k0(i, e, t, n = 0) {
  const s = Math.max(i.readBy[t] || 0, n);
  let o = 0;
  for (const r of e) r.authorId !== t && r.createdAt > s && o++;
  return o;
}
function gs(i, e) {
  return i.markedUnread.includes(e) ? !0 : i.lastBy !== e && i.lastAt > (i.readBy[e] || 0);
}
function Mie(i, e) {
  return i.some((t) => t.mentions.some((n) => n.uid === e));
}
function b_(i, e, t) {
  return i.createdBy === t || e.some((n) => n.authorId === t);
}
function v_(i, e) {
  if (e && i.elementId && e.id === i.elementId) {
    const t = He(e);
    return { x: t.x + Af(i.ex) * t.w, y: t.y + Af(i.ey) * t.h };
  }
  return { x: i.x, y: i.y };
}
function Af(i) {
  return Number.isFinite(i) ? Math.min(1, Math.max(0, i)) : 0;
}
function sb(i, e, t) {
  if (!t || t.type === "studio") return { x: i, y: e, elementId: null, ex: 0, ey: 0, label: "", thumb: null };
  const n = He(t);
  return {
    x: i,
    y: e,
    elementId: t.id,
    ex: n.w ? Af((i - n.x) / n.w) : 0,
    ey: n.h ? Af((e - n.y) / n.h) : 0,
    label: Tie(t),
    thumb: t.type === "image" ? t.src || null : t.type === "tool" && (t.thumbs || [])[0] || null
  };
}
function Tie(i) {
  switch (i.type) {
    case "image": {
      const e = i;
      return nl(e.label || (e.video ? "Video" : "Image"), 80);
    }
    case "note":
      return nl(i.text.replace(/\s+/g, " ").trim() || "Note", 80);
    case "tool":
      return nl(i.name || "Session", 80);
    case "frame":
      return nl(i.title || "Frame", 80);
    case "shape":
      return "Shape";
    case "chat":
      return nl(i.name || "Chat", 80);
    default:
      return "";
  }
}
function Cie(i) {
  return i ? i.type === "image" ? i.video ? "video" : "image" : i.type === "studio" ? "canvas" : i.type : "canvas";
}
const y_ = /\b(?:https?:\/\/|www\.)[^\s<>"']+[^\s<>"'.,;:!?)\]}]/gi;
function Iie(i, e, t) {
  const n = [], s = (d, c) => n.some((h) => d < h.end && c > h.start), o = e.slice().sort((d, c) => c.name.length - d.name.length);
  for (const d of o) {
    if (!d.name) continue;
    const c = "@" + d.name;
    let h = i.indexOf(c);
    for (; h !== -1; ) {
      const f = h + c.length;
      s(h, f) || n.push({ start: h, end: f, part: { kind: "mention", text: c, uid: d.uid, me: d.uid === t } }), h = i.indexOf(c, f);
    }
  }
  y_.lastIndex = 0;
  let r;
  for (; r = y_.exec(i); ) {
    const d = r.index, c = d + r[0].length;
    if (s(d, c)) continue;
    const h = /^https?:/i.test(r[0]) ? r[0] : "https://" + r[0];
    n.push({ start: d, end: c, part: { kind: "link", text: r[0], href: h } });
  }
  n.sort((d, c) => d.start - c.start);
  const a = [];
  let l = 0;
  for (const d of n)
    d.start > l && a.push({ kind: "text", text: i.slice(l, d.start) }), a.push(d.part), l = d.end;
  return l < i.length && a.push({ kind: "text", text: i.slice(l) }), a;
}
const iI = 50;
function ob(i, e) {
  const t = /* @__PURE__ */ new Set(), n = [];
  for (const s of e) {
    if (n.length >= iI) break;
    t.has(s.uid) || !s.name || !i.includes("@" + s.name) || (t.add(s.uid), n.push({ uid: s.uid, name: s.name }));
  }
  return n;
}
function Aie(i, e) {
  const t = i.slice(0, e), n = t.lastIndexOf("@");
  if (n === -1 || n > 0 && /[\w.]/.test(t.charAt(n - 1))) return null;
  const s = t.slice(n + 1);
  return s.length > 30 || /[\n@]/.test(s) || /\s{2}/.test(s) ? null : { start: n, query: s };
}
function Pie(i, e) {
  const t = /(^|[\s(])(:[a-z0-9_+-]{2,30})$/i.exec(i.slice(0, e));
  return t ? { start: e - t[2].length, query: t[2].slice(1) } : null;
}
function nl(i, e) {
  const t = String(i || "");
  return t.length > e ? t.slice(0, e - 1).trimEnd() + "…" : t;
}
function Ep(i) {
  return { by: i.authorId, byName: i.authorName, text: nl(i.text.replace(/\s+/g, " ").trim(), Sie) };
}
function Eie(i, e) {
  const t = /* @__PURE__ */ new Map();
  let n = 0;
  const s = /* @__PURE__ */ new Map();
  for (const [o, r] of Object.entries(i.reactions || {}))
    if (Array.isArray(r))
      for (const a of r) {
        let l = t.get(a);
        l || (l = { key: a, emoji: kie(a), count: 0, mine: !1, who: [] }, t.set(a, l), s.set(a, n++)), !l.who.includes(o) && (l.who.push(o), l.count++, o === e && (l.mine = !0));
      }
  return Array.from(t.values()).sort((o, r) => r.count - o.count || s.get(o.key) - s.get(r.key));
}
function _c(i) {
  const t = String(i || "").split("@")[0].split("+")[0].split(/[._-]+/).filter(Boolean);
  return t.length ? t.map((n) => n.charAt(0).toUpperCase() + n.slice(1)).join(" ") : i || "Someone";
}
function Rie(i, e, t) {
  const n = e.trim().toLowerCase(), s = i.map((o, r) => {
    const a = o.name.toLowerCase(), l = o.email.toLowerCase();
    let d = 0;
    return n ? a.startsWith(n) ? d = 4 : a.split(/\s+/).some((c) => c.startsWith(n)) ? d = 3 : l.startsWith(n) ? d = 2 : (a.includes(n) || l.includes(n)) && (d = 1) : d = 1, { p: o, i: r, score: d && (o.uid === t ? d - 0.5 : d) };
  }).filter((o) => o.score > 0);
  return s.sort((o, r) => r.score - o.score || o.i - r.i), s.map((o) => o.p);
}
const x_ = [
  ["#9968df", "#5a61ed"],
  ["#c750ce", "#9968df"],
  ["#3db4e6", "#5a61ed"],
  ["#34c79a", "#2a8fd6"],
  ["#f2a93b", "#ef5f7a"],
  ["#ef5f7a", "#c750ce"],
  ["#7a86ff", "#3db4e6"],
  ["#5fd0b5", "#9968df"]
];
function zie(i) {
  let e = 0;
  for (let t = 0; t < i.length; t++) e = e * 31 + i.charCodeAt(t) | 0;
  return x_[Math.abs(e) % x_.length];
}
function $ie(i, e, t) {
  const n = t.toLowerCase().split(/\s+/).filter(Boolean);
  if (!n.length) return !0;
  const s = [i.anchorLabel, i.createdByName, ...e.map((o) => o.authorName + " " + o.text)].join(" ").toLowerCase();
  return n.every((o) => s.includes(o));
}
var Die = Object.defineProperty, Oie = (i, e, t) => e in i ? Die(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Ot = (i, e, t) => Oie(i, typeof e != "symbol" ? e + "" : e, t);
const sI = "rd-board-comments", Lie = 6500;
function Bie() {
  try {
    const i = JSON.parse(localStorage.getItem(sI) || "{}");
    return { showPins: i.showPins !== !1, showResolved: i.showResolved === !0, elsewhereUnread: i.elsewhereUnread !== !1 };
  } catch {
    return { showPins: !0, showResolved: !1, elsewhereUnread: !0 };
  }
}
class Fie {
  constructor(e, t) {
    Ot(this, "board", e), Ot(this, "opts", t), Ot(this, "ui"), Ot(this, "rev", /* @__PURE__ */ qe(0)), Ot(this, "loaded", /* @__PURE__ */ qe(!1)), Ot(this, "failed", /* @__PURE__ */ qe(!1)), Ot(this, "people", /* @__PURE__ */ qe({ people: [], scope: "personal" })), Ot(this, "followed", /* @__PURE__ */ qe([])), Ot(this, "titles", /* @__PURE__ */ qe({})), Ot(this, "enabled"), Ot(this, "pins"), Ot(this, "feed"), Ot(this, "unreadCount"), Ot(this, "elsewhere"), Ot(this, "elsewhereUnread"), Ot(this, "openCards"), Ot(this, "threads", /* @__PURE__ */ new Map()), Ot(this, "comments", /* @__PURE__ */ new Map()), Ot(this, "byThread", /* @__PURE__ */ new Map()), Ot(this, "hidden", /* @__PURE__ */ qe(/* @__PURE__ */ new Set())), Ot(this, "pending", /* @__PURE__ */ new Map()), Ot(this, "since", 0), Ot(this, "initial"), Ot(this, "unsubs", []), Ot(this, "readTimer", 0), Ot(this, "goneFor", /* @__PURE__ */ new Set()), Ot(this, "marked", /* @__PURE__ */ new Set()), Ot(this, "disposed", !1), Ot(this, "store"), this.store = t.store, this.enabled = !!t.store, this.initial = t.initial || null;
    const n = Bie();
    this.ui = /* @__PURE__ */ Xt({
      armed: !1,
      draft: null,
      openId: null,
      panelOpen: !1,
      tab: "board",
      filter: "all",
      query: "",
      showPins: n.showPins,
      showResolved: n.showResolved,
      elsewhereUnread: n.elsewhereUnread,
      flash: null,
      editingId: null,
      dragging: null,
      confirmDelete: null
    }), Ae(() => [this.ui.showPins, this.ui.showResolved, this.ui.elsewhereUnread], () => {
      try {
        localStorage.setItem(sI, JSON.stringify({ showPins: this.ui.showPins, showResolved: this.ui.showResolved, elsewhereUnread: this.ui.elsewhereUnread }));
      } catch {
      }
    }), Ae(() => this.ui.armed, (s) => {
      s && (e.ui.shapeArmed = !1, e.ui.eyedropper = null, e.ui.mode = "select");
    }), Ae(() => e.ui.shapeArmed || e.ui.mode === "hand" || !!e.ui.eyedropper, (s) => {
      s && (this.ui.armed = !1);
    }), Ae(() => [this.ui.openId, this.rev.value], () => this.readOpenSoon()), Ae(() => this.ui.panelOpen, (s) => {
      s && (e.ui.boardHistory = !1);
    }), Ae(() => e.ui.boardHistory, (s) => {
      s && (this.ui.panelOpen = !1);
    }), this.pins = I(() => {
      this.rev.value, e.docRev.value;
      const s = this.hidden.value, o = e.user.uid, r = [];
      for (const a of this.threads.values()) {
        if (s.has(a.id) || this.gone(a)) continue;
        const l = this.ui.openId === a.id;
        if (a.resolvedAt && !this.ui.showResolved && !l) continue;
        const c = (this.ui.dragging && this.ui.dragging.id === a.id ? this.ui.dragging : null) || v_(a, a.elementId ? e.store.get(a.elementId) : null), h = this.commentsOf(a.id);
        r.push({ t: a, x: c.x, y: c.y, unread: !a.resolvedAt && Ch(a, h, o, this.since), count: h.length });
      }
      return r.sort((a, l) => a.t.lastAt - l.t.lastAt), r;
    }), this.feed = I(() => {
      this.rev.value, e.docRev.value;
      const s = this.hidden.value, o = e.user.uid, r = [];
      for (const a of this.threads.values()) {
        if (s.has(a.id) || this.gone(a)) continue;
        const l = this.commentsOf(a.id), d = Ch(a, l, o, this.since), c = {
          t: a,
          first: l[0] || null,
          last: l[l.length - 1] || null,
          replies: Math.max(0, l.length - 1),
          fresh: k0(a, l, o, this.since),
          unread: d,
          pinned: a.pinnedBy.includes(o),
          mentionsMe: Mie(l, o)
        };
        a.resolvedAt && !this.ui.showResolved || this.ui.filter === "unread" && !d || this.ui.filter === "mentions" && !c.mentionsMe && !(b_(a, l, o) && c.fresh) || this.ui.filter === "mine" && !b_(a, l, o) || this.ui.query && !$ie(a, l, this.ui.query) || r.push(c);
      }
      return r.sort((a, l) => Number(l.pinned) - Number(a.pinned) || l.t.lastAt - a.t.lastAt), r;
    }), this.unreadCount = I(() => {
      this.rev.value, e.docRev.value;
      const s = this.hidden.value, o = e.user.uid;
      let r = 0;
      for (const a of this.threads.values())
        s.has(a.id) || a.resolvedAt || this.gone(a) || Ch(a, this.commentsOf(a.id), o, this.since) && r++;
      return r;
    }), this.elsewhere = I(() => {
      const s = e.user.uid, o = this.titles.value, r = /* @__PURE__ */ new Map();
      for (const a of this.followed.value) {
        if (a.boardId === e.meta.id || o[a.boardId] === null || a.deletedAt || this.ui.elsewhereUnread && !gs(a, s)) continue;
        let l = r.get(a.boardId);
        l || (l = { boardId: a.boardId, title: o[a.boardId] || a.boardTitle || "Untitled board", items: [] }, r.set(a.boardId, l)), l.items.push(a);
      }
      return Array.from(r.values());
    }), this.elsewhereUnread = I(() => {
      const s = e.user.uid, o = this.titles.value;
      return this.followed.value.filter((r) => r.boardId !== e.meta.id && o[r.boardId] !== null && !r.deletedAt && gs(r, s)).length;
    }), this.openCards = I(() => {
      this.rev.value, e.docRev.value;
      const s = this.hidden.value, o = e.user.uid, r = [];
      for (const a of this.threads.values()) {
        if (s.has(a.id) || this.gone(a)) continue;
        const l = this.ui.openId === a.id;
        !l && (!this.ui.showPins || a.resolvedAt && !this.ui.showResolved) || (l || a.pinnedBy.includes(o)) && r.push(a);
      }
      return r;
    });
  }
  // ---------------------------------------------------------------- loading
  /** Start listening, once the board has loaded (its title and team are known). */
  start() {
    const e = this.store;
    !e || this.disposed || (this.unsubs.push(e.watchBoard({
      threads: (t, n) => {
        for (const s of t) this.threads.set(s.id, s);
        this.markGone(t);
        for (const s of n)
          this.threads.delete(s), this.ui.openId === s && (this.ui.openId = null);
        this.bump(), this.loaded.value || (this.loaded.value = !0, this.openInitial());
      },
      comments: (t, n) => {
        const s = /* @__PURE__ */ new Set();
        for (const o of t) {
          const r = this.comments.get(o.id);
          r && r.threadId !== o.threadId && s.add(r.threadId), this.comments.set(o.id, o), s.add(o.threadId);
        }
        for (const o of n) {
          const r = this.comments.get(o);
          r && s.add(r.threadId), this.comments.delete(o), this.ui.editingId === o && (this.ui.editingId = null);
        }
        for (const o of s) this.reindex(o);
        this.bump();
      },
      error: (t) => {
        console.warn("[board] comments are unavailable", t), this.failed.value = !0, this.loaded.value = !0;
      }
    })), this.unsubs.push(e.watchFollowed((t) => {
      this.followed.value = t, this.fetchTitles(t);
    }, (t) => console.warn("[board] comments on other boards are unavailable", t))), e.checkIn().then((t) => {
      t && !this.disposed && (this.since = t, this.bump());
    }).catch((t) => console.warn("[board] comments: could not check in", t)), this.refreshPeople(), window.setTimeout(() => {
      !this.loaded.value && !this.disposed && (this.loaded.value = !0, this.openInitial());
    }, 4e3));
  }
  refreshPeople() {
    this.store && this.store.people().then((e) => {
      if (this.disposed) return;
      const t = /* @__PURE__ */ new Map();
      for (const s of this.comments.values()) t.set(s.authorId, s.authorName);
      const n = e.people.map((s) => ({ ...s, name: t.get(s.uid) || s.name || _c(s.email) }));
      this.people.value = { ...e, people: n };
    }).catch((e) => console.warn("[board] comments: who can be mentioned is unknown", e));
  }
  fetchTitles(e) {
    if (!this.store) return;
    const t = this.titles.value, n = Array.from(new Set(e.map((s) => s.boardId))).filter((s) => s !== this.board.meta.id && !(s in t));
    n.length && this.store.boardTitles(n).then((s) => {
      this.disposed || (this.titles.value = { ...this.titles.value, ...s });
    }).catch(() => {
    });
  }
  openInitial() {
    const e = this.initial;
    e && (this.initial = null, window.setTimeout(() => {
      this.disposed || (this.threads.has(e) ? this.focus(e) : this.board.toast("That comment was deleted, or it's on a board you can't open.", "error"), this.opts.onShown && this.opts.onShown());
    }, 350));
  }
  reindex(e) {
    const t = [];
    for (const n of this.comments.values()) n.threadId === e && t.push(n);
    t.sort((n, s) => n.createdAt - s.createdAt || (n.id < s.id ? -1 : 1)), t.length ? this.byThread.set(e, t) : this.byThread.delete(e);
  }
  bump() {
    this.rev.value++;
  }
  // ---------------------------------------------------------------- reading
  /** Your name as your comments carry it (an account without one goes by its email's). */
  get myName() {
    const e = this.board.user;
    return e.name || _c(e.email);
  }
  thread(e) {
    return this.rev.value, e && !this.hidden.value.has(e) && this.threads.get(e) || null;
  }
  /** A thread's comments, oldest first, less any deleted here and waiting out their Undo. */
  commentsOf(e) {
    this.rev.value;
    const t = this.byThread.get(e) || [], n = this.hidden.value;
    return n.size ? t.filter((s) => !n.has(s.id)) : t;
  }
  allThreads() {
    this.rev.value;
    const e = this.hidden.value;
    return Array.from(this.threads.values()).filter((t) => !e.has(t.id) && !t.deletedAt);
  }
  isUnread(e) {
    return Ch(e, this.commentsOf(e.id), this.board.user.uid, this.since);
  }
  /** A comment that's news to you: someone else's, since you last read its thread (and since you first opened the board). */
  isFresh(e, t) {
    const n = this.board.user.uid;
    return t.authorId !== n && t.createdAt > Math.max(e.readBy[n] || 0, e.boardId === this.board.meta.id ? this.since : 0);
  }
  /** A thread on another board, read whole (Everywhere else's expanded card). */
  commentsElsewhere(e) {
    return this.store ? this.store.threadComments(e.boardId, e.id) : Promise.resolve([]);
  }
  freshIn(e) {
    return k0(e, this.commentsOf(e.id), this.board.user.uid, this.since);
  }
  following(e) {
    return e.followers.includes(this.board.user.uid);
  }
  pinned(e) {
    return e.pinnedBy.includes(this.board.user.uid);
  }
  /** You may delete it: you started it, or it's your board. */
  canDelete(e) {
    const t = this.board.user.uid;
    return e.createdBy === t || this.board.meta.ownerId === t;
  }
  /** You may delete this comment: it's yours, or the thread or the board is. */
  canDeleteComment(e) {
    const t = this.board.user.uid, n = this.threads.get(e.threadId);
    return e.authorId === t || !!n && n.createdBy === t || this.board.meta.ownerId === t;
  }
  /** Where a thread's pin is now (world). */
  pointOf(e) {
    this.board.docRev.value;
    const t = this.ui.dragging;
    return t && t.id === e.id ? { x: t.x, y: t.y } : v_(e, e.elementId ? this.board.store.get(e.elementId) : null);
  }
  /** The element a thread is on, while it's on the board. */
  elementOf(e) {
    return this.board.docRev.value, e.elementId && this.board.store.get(e.elementId) || null;
  }
  /** People who can be mentioned, with anyone who has commented here. */
  mentionable() {
    this.rev.value;
    const e = this.people.value.people.slice(), t = new Set(e.map((n) => n.uid));
    for (const n of this.comments.values())
      t.has(n.authorId) || (t.add(n.authorId), e.push({ uid: n.authorId, name: n.authorName, email: n.authorEmail }));
    return e;
  }
  // ---------------------------------------------------------------- the tool
  arm(e = !this.ui.armed) {
    this.ui.armed = e, e && (this.board.ui.selection = [], this.ui.showPins || (this.ui.showPins = !0));
  }
  /** The topmost element at a world point, notes and sessions first (they sit over the canvas). */
  elementAt(e, t) {
    const n = 2 / Math.max(0.01, this.board.cam.value.zoom);
    let s = null, o = -1 / 0;
    const r = { frames: 1, content: 2, annotations: 3 };
    for (const a of this.board.store.index.queryPoint(e, t, n)) {
      const l = this.board.store.get(a);
      if (!l || l.type === "studio") continue;
      const d = He(l);
      if (e < d.x - n || t < d.y - n || e > d.x + d.w + n || t > d.y + d.h + n) continue;
      const c = (l.type === "note" || l.type === "tool" ? 4 : r[Mv[l.type]]) * 1e9 + l.z;
      c > o && (o = c, s = l);
    }
    return s;
  }
  /** The Comment tool's click: a draft thread there (a draft with words in it stays, and nods). */
  placeAt(e, t) {
    this.startAt(this.board.screenToWorld(e, t));
  }
  /** A draft at a point on the board (the canvas menu's Comment, CHAT-01): on what's under it, if anything. */
  startAt(e) {
    const t = this.ui.draft;
    if (t && t.text.trim()) {
      t.n++;
      return;
    }
    this.ui.openId = null, this.ui.draft = { anchor: sb(e.x, e.y, this.elementAt(e.x, e.y)), text: "", mentions: [], n: 0 };
  }
  /** A draft on an element, from its toolbar: at its top right corner. */
  draftOn(e) {
    const t = He(e);
    this.ui.armed = !1, this.ui.openId = null, this.ui.draft = { anchor: sb(t.x + t.w, t.y, e), text: "", mentions: [], n: 0 };
    const n = this.board.cam.value.zoom, s = this.board.view, o = this.board.worldToClient(t.x + t.w, t.y);
    (o.x < s.left + 40 || o.y < s.top + 30 || o.x > s.left + s.w - 380 || o.y > s.top + s.h - 220) && this.board.jumpTo(t.x + t.w + 170 / n, t.y + 90 / n);
  }
  cancelDraft() {
    this.ui.draft = null;
  }
  /** Post the draft as a new thread. */
  async post(e, t) {
    const n = this.ui.draft, s = this.store, o = e.trim().slice(0, ib);
    if (!n || !s || !o) return !1;
    const r = this.board, a = r.user, l = ob(o, t), d = St(), c = Date.now(), h = {
      id: St(),
      threadId: d,
      boardId: r.meta.id,
      authorId: a.uid,
      authorName: this.myName,
      authorEmail: a.email,
      text: o,
      mentions: l,
      createdAt: c,
      editedAt: null,
      reactions: {}
    }, f = n.anchor, p = {
      id: d,
      boardId: r.meta.id,
      teamId: r.meta.teamId || null,
      createdBy: a.uid,
      createdByName: h.authorName,
      createdByEmail: a.email,
      createdAt: c,
      x: f.x,
      y: f.y,
      elementId: f.elementId,
      ex: f.ex,
      ey: f.ey,
      anchorLabel: f.label,
      anchorThumb: f.thumb,
      color: "amethyst",
      resolvedAt: null,
      resolvedBy: null,
      followers: [a.uid, ...l.map((y) => y.uid).filter((y) => y !== a.uid)].slice(0, 300),
      readBy: { [a.uid]: c },
      markedUnread: [],
      pinnedBy: [],
      lastAt: c,
      lastBy: a.uid,
      count: 1,
      preview: Ep(h),
      boardTitle: r.meta.title
    };
    this.ui.draft = null, this.ui.openId = d;
    try {
      return await s.createThread(p, h), !0;
    } catch (y) {
      return this.fail("Your comment couldn't be posted", y), this.ui.openId = null, this.ui.draft = { anchor: f, text: o, mentions: l, n: 0 }, !1;
    }
  }
  // ---------------------------------------------------------------- threads
  /** Open a thread's card. */
  open(e) {
    this.ui.draft = null, this.ui.editingId = null, this.ui.openId = e;
  }
  close() {
    this.ui.openId = null, this.ui.editingId = null;
  }
  /** Fly to a thread, open it, and draw the eye to its pin. */
  focus(e) {
    const t = this.threads.get(e);
    if (!t) return;
    const n = this.board;
    if (t.deletedAt) {
      n.toast("This comment was deleted along with the item it was on.");
      return;
    }
    if (this.gone(t)) {
      n.toast("The item this comment is on was deleted. Recover it from Recently Deleted to see the comment.");
      return;
    }
    this.ui.draft = null, this.ui.openId = e, this.ui.showPins || (this.ui.showPins = !0);
    const s = this.pointOf(t), o = this.elementOf(t), r = n.cam.value;
    let a = Math.min(1.2, Math.max(r.zoom, 0.7));
    if (o) {
      const h = He(o), f = Math.min((n.view.w - this.rightInset() - 460) / h.w, (n.view.h - 220) / h.h);
      f > 0 && (a = Math.min(a, Math.max(0.35, f)));
    }
    const l = n.view.w - this.rightInset(), d = Math.max(140, l / 2 - 150), c = n.view.h / 2 - 40;
    n.engine && n.engine.animateCamera({ zoom: a, x: d - s.x * a, y: c - s.y * a }, 460), this.ui.flash = { id: e, n: (this.ui.flash ? this.ui.flash.n : 0) + 1 };
  }
  /** The width the Updates panel (or the history beside the rail) covers on the right. */
  rightInset() {
    return this.ui.panelOpen || this.board.ui.boardHistory ? 412 : 72;
  }
  /** The thread before or after the open one, in the panel's order (or the board's newest first). */
  step(e) {
    const t = this.order();
    if (!t.length) return;
    const n = this.ui.openId ? t.indexOf(this.ui.openId) : -1, s = t[(n + e + t.length) % t.length];
    s && this.focus(s);
  }
  /** Where the open thread is among those you can step through: "2 of 7". */
  position() {
    const e = this.order(), t = this.ui.openId ? e.indexOf(this.ui.openId) : -1;
    return t === -1 ? null : { at: t + 1, of: e.length };
  }
  order() {
    return this.ui.panelOpen && this.ui.tab === "board" ? this.feed.value.map((e) => e.t.id) : this.allThreads().filter((e) => !e.resolvedAt || this.ui.showResolved || e.id === this.ui.openId).sort((e, t) => t.lastAt - e.lastAt).map((e) => e.id);
  }
  async reply(e, t, n) {
    const s = this.threads.get(e), o = this.store, r = t.trim().slice(0, ib);
    if (!s || !o || !r) return !1;
    const a = this.board.user, l = ob(r, n), d = {
      id: St(),
      threadId: e,
      boardId: s.boardId,
      authorId: a.uid,
      authorName: this.myName,
      authorEmail: a.email,
      text: r,
      mentions: l,
      createdAt: Date.now(),
      editedAt: null,
      reactions: {}
    };
    try {
      return await o.reply(s, d, l.map((c) => c.uid).filter((c) => c !== a.uid)), s.resolvedAt && this.board.toast("Reopened with your reply"), !0;
    } catch (c) {
      return this.fail("Your reply couldn't be posted", c), !1;
    }
  }
  async edit(e, t, n) {
    const s = this.comments.get(e), o = this.store, r = t.trim().slice(0, ib);
    if (!s || !o || !r) return !1;
    if (r === s.text)
      return this.ui.editingId = null, !0;
    const a = ob(r, n), l = new Set(s.mentions.map((p) => p.uid)), d = a.map((p) => p.uid).filter((p) => !l.has(p) && p !== this.board.user.uid), c = this.commentsOf(s.threadId), h = c[c.length - 1], f = { ...s, text: r, mentions: a };
    this.ui.editingId = null;
    try {
      return await o.editComment(f, h && h.id === s.id ? Ep(f) : null, d), !0;
    } catch (p) {
      return this.fail("Your edit couldn't be saved", p), !1;
    }
  }
  /** Delete one comment; the first one takes its thread with it. Undo for a few seconds. */
  deleteComment(e) {
    const t = this.comments.get(e);
    if (!t) return;
    const n = this.commentsOf(t.threadId);
    if (n[0] && n[0].id === t.id) {
      this.askDeleteThread(t.threadId);
      return;
    }
    const s = n.filter((r) => r.id !== t.id), o = s[s.length - 1];
    this.ui.editingId = null, this.later(t.id, "Comment deleted", () => {
      this.store && this.store.deleteComment(t, s.length, o ? Ep(o) : null).catch((r) => this.fail("The comment couldn't be deleted", r));
    });
  }
  /**
   * On something no longer on the board: deleted with it (ADMIN-001), so
   * hidden while it waits in Recently Deleted. Undo or Recover puts the
   * element back, and the thread with it; deleting it for good marks the
   * thread deleted (deleteWith), which hides it everywhere.
   */
  gone(e) {
    return !!e.deletedAt || !!e.elementId && !this.board.store.get(e.elementId);
  }
  /**
   * Elements deleted for good: their threads are marked deleted with them,
   * whoever started them (a soft delete: each stays, with its comments,
   * hidden on this board and in everyone's Everywhere else).
   */
  deleteWith(e) {
    if (!(!this.store || !e.length)) {
      for (const t of e) this.goneFor.add(t);
      this.markGone(Array.from(this.threads.values()));
    }
  }
  /** Mark deleted the threads among these on an item deleted for good this visit, each once. */
  markGone(e) {
    const t = this.store;
    if (!(!t || !this.goneFor.size))
      for (const n of e)
        !n.elementId || !this.goneFor.has(n.elementId) || n.deletedAt || this.marked.has(n.id) || (this.marked.add(n.id), t.markDeleted(n.id).catch((s) => this.fail("The thread couldn't be deleted", s)));
  }
  /** The replies in a thread from anyone but you, and who wrote them. */
  othersReplies(e) {
    const t = this.board.user.uid, n = this.commentsOf(e).slice(1).filter((s) => s.authorId !== t);
    return { replies: n.length, names: Array.from(new Set(n.map((s) => s.authorName || "Someone"))) };
  }
  /**
   * Delete thread, from any of its buttons: when others have replied it asks
   * first, since their replies go too (CHAT-28); otherwise it goes now. Either
   * way Undo stays for a few seconds.
   */
  askDeleteThread(e) {
    const t = this.othersReplies(e);
    t.replies ? this.ui.confirmDelete = { threadId: e, ...t } : this.deleteThread(e);
  }
  /** The question's answer: delete it, or keep it. */
  answerDelete(e) {
    const t = this.ui.confirmDelete;
    this.ui.confirmDelete = null, e && t && this.deleteThread(t.threadId);
  }
  /** Delete a thread and everything in it. Undo for a few seconds. */
  deleteThread(e) {
    if (!this.threads.get(e)) return;
    this.ui.openId === e && (this.ui.openId = null);
    const n = (this.byThread.get(e) || []).map((s) => s.id);
    this.later(e, "Thread deleted", () => {
      this.store && this.store.deleteThread(e, n).catch((s) => this.fail("The thread couldn't be deleted", s));
    });
  }
  /** Hide something now and send its delete once its Undo has passed (or the page is leaving). */
  later(e, t, n) {
    const s = new Set(this.hidden.value);
    s.add(e), this.hidden.value = s;
    const o = window.setTimeout(() => this.commit(e), Lie);
    this.pending.set(e, { timer: o, send: n }), this.board.toast(t, "info", {
      label: "Undo",
      run: () => {
        const r = this.pending.get(e);
        if (!r) return;
        clearTimeout(r.timer), this.pending.delete(e);
        const a = new Set(this.hidden.value);
        a.delete(e), this.hidden.value = a, this.board.dismissToast();
      }
    });
  }
  commit(e) {
    const t = this.pending.get(e);
    t && (clearTimeout(t.timer), this.pending.delete(e), t.send());
  }
  /** Send every delete still waiting (the board is closing). */
  flush() {
    for (const e of Array.from(this.pending.keys())) this.commit(e);
  }
  async react(e, t) {
    const n = this.comments.get(e);
    if (!n || !this.store) return;
    const s = wie(t), o = !(n.reactions[this.board.user.uid] || []).includes(s);
    o && If(t);
    try {
      await this.store.react(n, s, o);
    } catch (r) {
      this.fail("Your reaction couldn't be saved", r);
    }
  }
  async resolve(e, t) {
    if (!(!this.threads.get(e) || !this.store)) {
      try {
        await this.store.resolve(e, t);
      } catch (s) {
        this.fail(t ? "The thread couldn't be resolved" : "The thread couldn't be reopened", s);
        return;
      }
      t && (this.ui.openId === e && !this.ui.showResolved && (this.ui.openId = null), this.board.toast("Resolved", "info", { label: "Undo", run: () => {
        this.resolve(e, !1), this.board.dismissToast();
      } }));
    }
  }
  setColor(e, t) {
    this.store && this.store.setColor(e, t).catch((n) => this.fail("The colour couldn't be saved", n));
  }
  /** A pin dropped at a world point: on the element there, if any. */
  moveTo(e, t, n) {
    this.store && this.store.move(e, sb(t, n, this.elementAt(t, n))).catch((s) => this.fail("The comment couldn't be moved", s));
  }
  follow(e, t) {
    this.store && (this.store.follow(e.id, t, e.boardId).catch((n) => this.fail("Couldn't change following", n)), this.board.toast(t ? "Following: replies show in your Updates" : "Unfollowed: you'll hear of it only if you're mentioned"));
  }
  pin(e, t) {
    this.store && (this.store.pin(e, t).catch((n) => this.fail("Couldn't change your pin", n)), t && this.board.toast("Pinned for you: it stays open on the board and first in Updates. Only you see your pins."));
  }
  markRead(e) {
    !this.store || !e.length || this.store.markRead(e.map((t) => ({ id: t.id, boardId: t.boardId }))).catch((t) => this.fail("Couldn't mark it read", t));
  }
  markUnread(e) {
    this.store && (this.ui.openId === e.id && (this.ui.openId = null), this.store.markUnread(e.id, e.boardId).catch((t) => this.fail("Couldn't mark it unread", t)));
  }
  /** Every unread thread on this board, read. */
  markAllRead() {
    this.markRead(this.allThreads().filter((e) => this.isUnread(e)));
  }
  markAllReadElsewhere(e) {
    const t = this.board.user.uid;
    this.markRead(this.followed.value.filter((n) => n.boardId !== this.board.meta.id && (!e || n.boardId === e) && gs(n, t)));
  }
  /** The open thread, read once it's been open a moment. */
  readOpenSoon() {
    clearTimeout(this.readTimer);
    const e = this.ui.openId;
    e && (this.readTimer = window.setTimeout(() => {
      const t = this.thread(e);
      t && this.ui.openId === e && this.isUnread(t) && this.markRead([t]);
    }, 600));
  }
  async copyLink(e) {
    const t = this.opts.linkFor ? this.opts.linkFor(e.boardId, e.id) : location.origin + "/board/" + e.boardId + "?comment=" + e.id;
    try {
      await navigator.clipboard.writeText(t), this.board.toast("Link copied: it opens this board at this thread");
    } catch {
      this.board.toast("Couldn't copy the link", "error");
    }
  }
  /** A thread on another board (Everywhere else): open that board there. */
  openElsewhere(e) {
    if (e.boardId === this.board.meta.id) {
      this.focus(e.id);
      return;
    }
    this.opts.openAt && this.opts.openAt(e.boardId, e.id);
  }
  /** A comment's reactions with one emoji tried: the picker remembers it. */
  pick(e) {
    If(e);
  }
  fail(e, t) {
    console.error("[board] " + e, t), this.board.toast(e + ". Please try again.", "error");
  }
  dispose() {
    this.disposed = !0, this.flush(), clearTimeout(this.readTimer);
    for (const e of this.unsubs) e();
    this.unsubs = [], this.store && this.store.dispose();
  }
}
var Nie = Object.defineProperty, Uie = (i, e, t) => e in i ? Nie(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Ke = (i, e, t) => Uie(i, typeof e != "symbol" ? e + "" : e, t);
const w_ = 4e3;
function Gie(i) {
  return "linkback-" + i;
}
const jie = 12e4, Hie = 25e3, Vie = 120 * 1e3, Wie = 5e3, Nl = { image: "Image", video: "Video", imageEdit: "Wand2", videoEdit: "Clapperboard", threed: "Box", upscale: "Maximize2" }, Ih = { w: 184, h: 184 }, qie = 0.32, Kie = 0.36, Yie = 120, Ah = { w: 720, h: 480 }, k_ = { w: 300, h: 200 };
let wr = null;
class Pf {
  constructor(e) {
    Ke(this, "store", new sK()), Ke(this, "results", new Ote()), Ke(this, "ui", Pte()), Ke(this, "cam", /* @__PURE__ */ qe({ x: 0, y: 0, zoom: 1 })), Ke(this, "view", /* @__PURE__ */ Xt({ w: 1, h: 1, left: 0, top: 52 })), Ke(this, "docRev", /* @__PURE__ */ qe(0)), Ke(this, "meta", /* @__PURE__ */ Xt({
      id: "",
      title: "",
      /** who made the board: only they can rename it */
      ownerId: "",
      /** the team that owns it (and pays for its runs); null on a personal board */
      teamId: null,
      description: "",
      accessLevel: null
    })), Ke(this, "overlayIds", /* @__PURE__ */ qe([])), Ke(this, "moving", /* @__PURE__ */ qe(!1)), Ke(this, "far", /* @__PURE__ */ qe(!1)), Ke(this, "guides", /* @__PURE__ */ qe(null)), Ke(this, "stats", /* @__PURE__ */ qe(null)), Ke(this, "loaded", /* @__PURE__ */ qe(!1)), Ke(this, "loadError", /* @__PURE__ */ qe(null)), Ke(this, "generating", /* @__PURE__ */ Xt({})), Ke(this, "runningSince", /* @__PURE__ */ Xt({})), Ke(this, "saveState"), Ke(this, "promptRev", /* @__PURE__ */ qe(0)), Ke(this, "loadErrorKind", /* @__PURE__ */ qe(null)), Ke(this, "trashRev", /* @__PURE__ */ qe(0)), Ke(this, "recovering", /* @__PURE__ */ new Set()), Ke(this, "trash"), Ke(this, "user"), Ke(this, "catalog"), Ke(this, "companyModels", /* @__PURE__ */ qe([])), Ke(this, "engine", null), Ke(this, "worldEl", null), Ke(this, "uploader", null), Ke(this, "onStep", null), Ke(this, "feedback", null), Ke(this, "cameraHooks", /* @__PURE__ */ new Set()), Ke(this, "styledZoom", 0), Ke(this, "opts"), Ke(this, "sync"), Ke(this, "gen"), Ke(this, "elRevs", /* @__PURE__ */ new Map()), Ke(this, "runs", /* @__PURE__ */ lv(/* @__PURE__ */ new Map())), Ke(this, "overlayArea", null), Ke(this, "unsubs", []), Ke(this, "pinsKept", { models: "unknown", sessions: "unknown" }), Ke(this, "viewsKept", "unknown"), Ke(this, "prefs"), Ke(this, "settleTimer", 0), Ke(this, "pasteCount", 0), Ke(this, "disposed", !1), Ke(this, "toastSeq", 0), Ke(this, "toastTimer", 0), Ke(this, "newThumbTimers", /* @__PURE__ */ new Map()), Ke(this, "prompts", /* @__PURE__ */ new Map()), Ke(this, "undecoded", /* @__PURE__ */ new Map()), Ke(this, "forgottenLibrary", []), Ke(this, "inflight", /* @__PURE__ */ new Map()), Ke(this, "started", /* @__PURE__ */ new Map()), Ke(this, "historyCursor", /* @__PURE__ */ new Map()), Ke(this, "boardCursor", null), Ke(this, "knownAssets", /* @__PURE__ */ new Map()), Ke(this, "measured", /* @__PURE__ */ lv(/* @__PURE__ */ new Map())), Ke(this, "recordReads", /* @__PURE__ */ new Map()), Ke(this, "readingRecords", /* @__PURE__ */ Xt({})), Ke(this, "studioRecords"), Ke(this, "pinnedImages"), Ke(this, "pinnedUrls"), Ke(this, "studioRuns", /* @__PURE__ */ new Map()), Ke(this, "studioFails", /* @__PURE__ */ new Map()), Ke(this, "promptTool"), Ke(this, "selectedEls"), Ke(this, "promptLibrary"), Ke(this, "comments"), Ke(this, "labels"), Ke(this, "tour", null), Ke(this, "agent"), Ke(this, "freshTools", /* @__PURE__ */ Xt(/* @__PURE__ */ new Set())), Ke(this, "shiftPick", null), Ke(this, "missingBoards", /* @__PURE__ */ qe(/* @__PURE__ */ new Set())), Ke(this, "balance", /* @__PURE__ */ qe(null)), Ke(this, "teamActive", /* @__PURE__ */ qe(null)), Ke(this, "teamName", /* @__PURE__ */ qe(null)), Ke(this, "tokenAccessRev", /* @__PURE__ */ qe(0)), Ke(this, "trainedModelsSeen", /* @__PURE__ */ qe(null)), this.opts = e, this.sync = e.sync, this.gen = e.gen, this.user = e.user, this.catalog = I(() => gne(e.catalog.value, this.companyModels.value)), this.saveState = /* @__PURE__ */ qe("saved"), this.meta.id = e.boardId, this.prefs = Rte(e.user.uid, e.boardId), this.ui.lightCanvas = this.prefs.lightCanvas, this.ui.showGrid = this.prefs.showGrid !== !1, this.ui.shapeStyle = { ...io, ...this.prefs.shapeStyle }, this.ui.shapeKind = this.prefs.shapeKind, this.ui.histOpen = this.prefs.histOpen, this.ui.miniOpen = this.prefs.miniOpen, this.ui.recentIds = this.prefs.recentIds.slice(), this.ui.pinnedIds = Array.isArray(this.prefs.pinnedIds) ? this.prefs.pinnedIds.filter((n) => typeof n == "string") : [], this.ui.pinnedModelIds = Array.isArray(this.prefs.pinnedModelIds) ? this.prefs.pinnedModelIds.filter((n) => typeof n == "string") : [], this.ui.cameraViews = M_(this.prefs.cameraViews), this.ui.noteTint = this.prefs.noteTint, this.ui.promptH = typeof this.prefs.promptH == "number" ? this.prefs.promptH : null, this.prefs.library && (this.ui.library.tab = this.prefs.library.tab === "mine" ? "mine" : "featured", this.ui.library.category = typeof this.prefs.library.category == "string" ? this.prefs.library.category : null, typeof this.prefs.library.saveBoard == "boolean" && (this.ui.library.saveLevels = { board: this.prefs.library.saveBoard, team: !!this.prefs.library.saveTeam })), this.labels = { team: e.labels && e.labels.team || "Team" }, this.agent = e.agent || null, this.promptLibrary = new uie(this, e.featured || null, e.myPrompts || null), this.comments = new Fie(this, e.comments || { store: null }), this.promptTool = I(() => {
      if (this.docRev.value, this.ui.selection.length !== 1 || this.ui.marquee) return null;
      const n = this.store.get(this.ui.selection[0]);
      return n && n.type === "tool" ? { ...n } : null;
    }), this.selectedEls = I(() => (this.docRev.value, this.ui.selection.map((n) => this.store.get(n)).filter(Boolean))), this.studioRecords = new _ne((n) => this.sync.commit(n), () => this.user.uid), this.pinnedImages = I(() => {
      this.studioRecords.rev.value;
      const n = /* @__PURE__ */ new Set();
      return this.studioRecords.all().filter((s) => s.role === "pin" && s.createdBy === this.user.uid).reverse().sort((s, o) => o.createdAt - s.createdAt).filter((s) => !n.has(s.url) && !!n.add(s.url));
    }), this.pinnedUrls = I(() => new Set(this.pinnedImages.value.map((n) => n.url))), Ae(this.pinnedUrls, () => {
      this.overlayArea = null, this.updateOverlay();
    }), this.trash = I(() => (this.trashRev.value, this.docRev.value, this.loaded.value ? this.sync.trash().filter((n) => !Bs(n.el) || this.recoverableRecord(n.el)) : [])), this.unsubs.push(this.store.subscribe((n) => this.onDocChange(n)));
    const t = () => {
      const n = document.activeElement;
      n && n.blur && n.closest && n.closest(".bd-root") && n.blur(), this.comments.flush(), this.sync.flush().catch(() => {
      });
    };
    window.addEventListener("pagehide", t), this.unsubs.push(() => window.removeEventListener("pagehide", t)), Ae(() => this.sync.status.value, (n) => {
      this.saveState.value = n;
    }), Ae(() => this.promptTool.value ? this.promptTool.value.id : null, (n) => {
      this.ui.eyedropper && this.ui.eyedropper.sessionId !== n && (this.ui.eyedropper = null);
      const s = this.ui.library;
      s.open && n && s.sessionId !== n ? s.sessionId = n : s.open && !n && s.sessionId && this.promptLibrary.close(), n && (this.ui.recentIds = [n].concat(this.ui.recentIds.filter((o) => o !== n)).slice(0, 200), this.persistPrefs());
    }), Ae(() => this.ui.selection.slice(), (n) => {
      this.engine && this.engine.setSelection(n);
    }), Ae(() => this.ui.dragging, (n) => {
      this.engine && this.engine.setDragging(n);
    }), Ae(() => !!(this.ui.studio || this.ui.infoAt || this.ui.libraryOpen || this.ui.trashOpen), (n) => {
      n && (this.ui.eyedropper = null);
    }), Ae(() => this.ui.studio ? this.ui.studio.sessionId : null, (n) => {
      this.opts.onStudio && this.opts.onStudio(n);
    }, { flush: "sync" }), Ae(() => (this.docRev.value, !!this.ui.eyedropper && !this.eyedropperField), (n) => {
      n && (this.ui.eyedropper = null);
    }), Ae(() => this.ui.lightCanvas, (n) => {
      this.engine && this.engine.setTheme(n ? "light" : "dark"), this.persistPrefs();
    }), Ae(() => [this.ui.showGrid, this.ui.histOpen, this.ui.miniOpen, this.ui.shapeKind, this.ui.noteTint, this.ui.shapeStyle.stroke, this.ui.shapeStyle.sw, this.ui.promptH, this.ui.library.tab, this.ui.library.category, this.ui.library.saveLevels.board, this.ui.library.saveLevels.team], () => this.persistPrefs());
  }
  // ----------------------------------------------------------- lifecycle
  async load() {
    var e;
    try {
      const t = await this.sync.load();
      if (this.disposed) return;
      this.meta.title = t.meta.title || "Untitled board", this.meta.ownerId = t.meta.ownerId || "", this.meta.teamId = t.meta.teamId || null, this.meta.description = t.meta.description || "", this.meta.accessLevel = t.meta.accessLevel || null, this.opts.onTitle && this.opts.onTitle(this.meta.title), this.results.upsert(t.results, !1);
      const n = [], s = [];
      for (const r of t.elements)
        Bs(r) ? n.push(r) : s.push(r);
      this.studioRecords.load(n), this.store.load(s), this.sweepStudioRecords(), this.sync.watch((r) => this.onRemote(r)), this.unsubs.push(this.results.onLocalChange((r) => this.sync.commitResults(r.filter((a) => a.status !== "pending")))), this.loaded.value = !0, this.startRealtime(), this.comments.start();
      const o = this.opts.initialStudio;
      o && ((e = this.store.get(o)) == null ? void 0 : e.type) === "tool" && this.restoreStudio(o), this.opts.linkedFrom && this.linkBack(this.opts.linkedFrom), this.refreshLinks();
    } catch (t) {
      if (this.disposed) return;
      console.error("[board] load failed", t), this.loadError.value = t instanceof Error && t.message || "This board could not be loaded.";
      const n = t && typeof t == "object" && "kind" in t ? String(t.kind) : null;
      this.loadErrorKind.value = n;
    }
  }
  /** Real boards: the board's runs, and your prompts, as they change. */
  startRealtime() {
    const e = this.opts.runs;
    e && e.watchRecent((a, l) => {
      for (const d of a) this.onRun(d);
      for (const d of l) this.onRunGone(d);
    }), this.opts.favorites && this.opts.favorites.start();
    const t = this.opts.pins;
    if (t) {
      for (const a of ["models", "sessions"])
        this.unsubs.push(t.watch(a, (l) => this.pinsFromAccount(a, l), () => {
          this.pinsKept[a] = "off";
        }));
      t.watchViews && this.unsubs.push(t.watchViews((a) => this.viewsFromAccount(a), () => {
        this.viewsKept = "off";
      }));
    }
    const n = this.opts.balance;
    n && this.unsubs.push(n.watch(this.meta.teamId || this.user.uid, (a) => {
      this.balance.value = a;
    }));
    const s = this.opts.teamStatus;
    s && this.meta.teamId && this.unsubs.push(s.watch(this.meta.teamId, (a, l) => {
      this.teamActive.value = a, l !== void 0 && (this.teamName.value = l);
    }));
    const o = this.opts.companyTools;
    o && this.meta.teamId && o(this.meta.teamId).then((a) => {
      this.disposed || (this.companyModels.value = a);
    }).catch((a) => console.warn("[board] company tools unavailable", a));
    const r = this.opts.prompts;
    r && (r.start((a, l) => this.onSavedPrompt(a, l)).catch(() => {
    }), this.unsubs.push(Ae(this.catalog, () => {
      for (const [a, l] of Array.from(this.undecoded)) this.onSavedPrompt(a, l);
    })));
  }
  /** Called by BoardView once the stage is in the DOM. */
  async attach(e, t) {
    this.worldEl = t;
    const n = e.getBoundingClientRect();
    this.view.w = n.width, this.view.h = n.height, this.view.left = n.left, this.view.top = n.top;
    const s = new Ate({
      host: e,
      store: this.store,
      theme: this.ui.lightCanvas ? "light" : "dark",
      onCamera: (a, l) => this.onCamera(a, l),
      onStats: (a) => {
        this.ui.showStats && (this.stats.value = a);
      }
    });
    if (this.engine = s, await s.ready, this.disposed) return;
    s.setSelection(this.ui.selection), s.setPaused(!!this.ui.studio);
    const o = new ResizeObserver(() => {
      const a = e.getBoundingClientRect();
      this.view.w = a.width, this.view.h = a.height, this.view.left = a.left, this.view.top = a.top, this.overlayArea = null, this.updateOverlay();
    });
    o.observe(e), this.unsubs.push(() => o.disconnect());
    const r = this.opts.initialCamera || this.prefs.camera;
    r && Number.isFinite(r.zoom) ? s.setCamera(r) : this.fit(0), s.playEntrance(), this.updateOverlay();
  }
  dispose() {
    this.disposed = !0;
    for (const e of this.unsubs) e();
    this.unsubs = [];
    for (const e of this.runs.values()) e.cancel();
    this.runs.clear();
    for (const e of this.started.values())
      e.unwatch(), clearTimeout(e.timer);
    this.started.clear(), this.opts.runs && this.opts.runs.dispose(), this.opts.prompts && this.opts.prompts.dispose(), this.opts.favorites && this.opts.favorites.dispose(), this.promptLibrary.dispose(), this.comments.dispose(), clearTimeout(this.settleTimer), clearTimeout(this.toastTimer);
    for (const e of this.newThumbTimers.values()) clearTimeout(e);
    this.persistPrefs(), this.sync.dispose(), this.engine && this.engine.destroy(), this.engine = null;
  }
  // ------------------------------------------------------------ reactivity
  /** A per-element revision ref, for DOM-layer components. */
  rev(e) {
    let t = this.elRevs.get(e);
    return t || (t = /* @__PURE__ */ qe(0), this.elRevs.set(e, t)), t;
  }
  releaseRev(e) {
    this.elRevs.delete(e);
  }
  bump(e) {
    const t = this.elRevs.get(e);
    t && (t.value++, xs(t));
  }
  onDocChange(e) {
    for (const t of e.added) this.bump(t.id);
    for (const t of e.updated) this.bump(t.id);
    for (const t of e.removed) this.bump(t.id);
    for (const t of e.updated) {
      const n = t.el;
      if (n.type !== "image" || !n.resultId || !("fav" in t.after)) continue;
      const s = this.results.get(n.resultId);
      s && !!s.fav != !!n.fav && this.results.upsert([{ ...s, fav: n.fav || void 0 }], e.origin === "local");
    }
    if (e.removed.length) {
      const t = new Set(e.removed.map((n) => n.id));
      this.ui.selection.some((n) => t.has(n)) && (this.ui.selection = this.ui.selection.filter((n) => !t.has(n))), this.ui.infoAt && t.has(this.ui.infoAt) && (this.ui.infoAt = null), this.ui.editingNote && t.has(this.ui.editingNote) && (this.ui.editingNote = null);
    }
    this.docRev.value++, xs(this.docRev), (e.added.length || e.removed.length) && (this.overlayArea = null), this.updateOverlay(), !e.ephemeral && e.origin !== "remote" && e.origin !== "load" && (this.sync.commit(e), (e.added.length || e.removed.length) && this.trashRev.value++);
  }
  onRemote(e) {
    if (e.meta) {
      const r = e.meta;
      if (r.deleted) {
        this.loadError.value = "This board was deleted.", this.loadErrorKind.value = "deleted";
        return;
      }
      r.refused && this.toast(r.refused === "owner" ? "Only the board's owner can change its name and description." : "The board's details couldn't be saved.", "error"), r.title && r.title !== this.meta.title && (this.meta.title = r.title, this.opts.onTitle && this.opts.onTitle(r.title)), r.description !== void 0 && (this.meta.description = r.description || ""), r.accessLevel !== void 0 && (this.meta.accessLevel = r.accessLevel || null);
    }
    e.results && e.results.length && this.results.upsert(e.results, !1), e.trash && (this.trashRev.value++, this.forgetPurged());
    const t = e.upserted.filter(Bs), n = e.removed.filter((r) => this.studioRecords.has(r));
    this.studioRecords.applyRemote(t, n);
    const s = t.length ? e.upserted.filter((r) => !Bs(r)) : e.upserted, o = n.length ? e.removed.filter((r) => !n.includes(r)) : e.removed;
    !s.length && !o.length || this.store.batch("Remote", () => {
      const r = [];
      for (const a of s)
        if (this.store.get(a.id)) {
          if (this.store.inGesture && this.ui.selection.includes(a.id)) continue;
          this.store.update(a.id, a, { origin: "remote", history: !1 });
        } else
          r.push(a);
      r.length && this.store.add(r, { origin: "remote", history: !1 }), o.length && this.store.remove(o, { origin: "remote", history: !1 });
    }, { origin: "remote", history: !1 });
  }
  /**
   * The Studios view's records of a session deleted for good (Recently
   * Deleted's 90 days passed, or by hand elsewhere) go too: nothing can show
   * them again. Only old ones, so a session still arriving from another tab
   * keeps its records.
   */
  sweepStudioRecords() {
    const e = /* @__PURE__ */ new Set();
    for (const s of this.store.all()) s.type === "tool" && e.add(s.id);
    for (const s of this.sync.trash()) s.el.type === "tool" && e.add(s.el.id);
    const t = Date.now(), n = this.studioRecords.all().filter((s) => s.role !== "pin" && !e.has(s.sessionId) && t - (s.updatedAt || s.createdAt || 0) > 600 * 1e3).map((s) => s.id);
    n.length && (this.studioRecords.remove(n), this.sync.purge(n));
  }
  // ---------------------------------------------------------------- camera
  /** Run fn on every camera frame (DOM writes that must not wait for Vue). */
  onCameraFrame(e) {
    return this.cameraHooks.add(e), () => this.cameraHooks.delete(e);
  }
  onCamera(e, t) {
    this.cam.value = e;
    for (const s of this.cameraHooks) s(e);
    this.worldEl && (this.worldEl.style.transform = "translate3d(" + e.x + "px," + e.y + "px,0) scale(" + e.zoom + ")", e.zoom !== this.styledZoom && (this.styledZoom = e.zoom, this.worldEl.style.setProperty("--cv-zoom", String(e.zoom)), this.worldEl.style.setProperty("--cv-inv-zoom", String(1 / e.zoom)))), t !== this.moving.value && (this.moving.value = t);
    const n = this.far.value ? e.zoom < Kie : e.zoom < qie;
    n !== this.far.value && (this.far.value = n, this.engine && this.engine.setFar(n), this.overlayArea = null), this.updateOverlay(), clearTimeout(this.settleTimer), this.settleTimer = window.setTimeout(() => {
      this.moving.value = !1, this.prefs.camera = { ...this.cam.value }, this.persistPrefs(), this.opts.onCameraSettled && this.opts.onCameraSettled(this.cam.value);
    }, 220);
  }
  /** Recompute which DOM-layer elements should exist, with a margin. */
  updateOverlay() {
    if (!this.engine) return;
    const e = this.cam.value, t = fl(e, this.view.w, this.view.h, 0), n = this.overlayArea;
    if (n && t.x >= n.x && t.y >= n.y && t.x + t.w <= n.x + n.w && t.y + t.h <= n.y + n.h && n.w < t.w * 2.6) return;
    const s = t.w * 0.5, o = t.h * 0.5, r = { x: t.x - s, y: t.y - o, w: t.w + s * 2, h: t.h + o * 2 };
    this.overlayArea = r;
    const a = [];
    if (this.far.value) {
      const d = Yie / e.zoom;
      for (const c of this.store.index.query(r)) {
        const h = this.store.get(c);
        h && h.type === "frame" && h.w >= d && a.push(c);
      }
      for (const c of [this.ui.editingNote, this.ui.editingTitle]) c && !a.includes(c) && this.store.get(c) && a.push(c);
    } else {
      for (const d of this.store.index.query(r)) {
        const c = this.store.get(d);
        c && (c.type === "note" || c.type === "tool" || c.type === "chat" || c.type === "frame" || c.type === "image" && (c.fav || c.video || this.isPinnedImage(c.src))) && a.push(d);
      }
      for (const d of this.ui.selection) if (!a.includes(d)) {
        const c = this.store.get(d);
        c && (c.type === "note" || c.type === "tool" || c.type === "chat") && a.push(d);
      }
    }
    const l = this.overlayIds.value;
    if (l.length === a.length) {
      const d = new Set(l);
      if (a.every((c) => d.has(c))) return;
    }
    this.overlayIds.value = a;
  }
  screenToWorld(e, t) {
    const n = this.cam.value;
    return { x: (e - this.view.left - n.x) / n.zoom, y: (t - this.view.top - n.y) / n.zoom };
  }
  worldToClient(e, t) {
    const n = this.cam.value;
    return { x: e * n.zoom + n.x + this.view.left, y: t * n.zoom + n.y + this.view.top };
  }
  viewportCentre() {
    const e = this.cam.value;
    return { x: (this.view.w / 2 - e.x) / e.zoom, y: (this.view.h / 2 - e.y) / e.zoom };
  }
  fit(e = 420) {
    if (!this.engine) return;
    const t = this.store.bounds();
    if (!t) {
      this.engine.animateCamera({ zoom: 1, x: this.view.w / 2, y: this.view.h / 2 }, e);
      return;
    }
    this.engine.fitTo(t, { pad: 120, maxZoom: 1, animate: e });
  }
  /** One press of zoom in or out: from where a glide under way is headed, so quick presses step evenly, and stopping at 100% on the way past (CHAT-29). */
  zoomBy(e) {
    if (!this.engine) return;
    const t = this.engine.cameraGoal;
    this.engine.animateCamera(Cv(t, this.view.w / 2, this.view.h / 2, VN(t.zoom, e) / t.zoom), 220);
  }
  zoomTo(e) {
    this.engine && this.engine.animateCamera(Cv(this.cam.value, this.view.w / 2, this.view.h / 2, e / this.cam.value.zoom), 260);
  }
  jumpTo(e, t, n) {
    this.engine && this.engine.animateCamera(rl(e, t, n || this.cam.value.zoom, this.view.w, this.view.h), 420);
  }
  /** Open a session from anywhere: centre it, close enough to read (≥ 50%). */
  openSession(e) {
    const t = He(e);
    this.ui.infoAt = null, this.ui.selection = [e.id], this.jumpTo(t.x + t.w / 2, t.y + t.h / 2, Math.max(this.cam.value.zoom, 0.5));
  }
  /** A tool by its id: in a kit, or one of the tools no kit lists (the Edit side's, IL-073). */
  toolModel(e) {
    const t = this.catalog.value;
    return t.byId.get(e) || (t.tools || []).find((n) => n.id === e) || null;
  }
  /**
   * A session card's Open, its empty slots, or a double-click on it (IL-100;
   * Adam: Open did nothing, and the empty slots should open the tool): the
   * session open and in view, with its results beside it. The board's
   * history, the comments and a chat open in the gallery's place, so they
   * step aside for it.
   */
  showSession(e) {
    this.openSession(e), this.ui.histOpen = !0, this.ui.boardHistory = !1, this.ui.chatOpen = null, this.comments.ui.panelOpen = !1;
  }
  /**
   * A new element lands where you look, at a readable zoom (≥ 100%). One put
   * where you pointed (a right-click, a double-click) stays where it is if it
   * can be read there (≥ 50%) and the chrome doesn't cover it.
   */
  revealNew(e, t = !1) {
    const n = He(e);
    t && this.inClearView(n, e.type === "tool") || this.jumpTo(n.x + n.w / 2, n.y + n.h / 2, Math.max(this.cam.value.zoom, 1));
  }
  /** All on screen at a readable zoom, clear of the top bar, the session list and the bottom bar (or, for a session, its prompt). */
  inClearView(e, t) {
    const n = this.cam.value;
    if (n.zoom < 0.5) return !1;
    const s = e.x * n.zoom + n.x, o = e.y * n.zoom + n.y;
    return s >= 84 && o >= 64 && s + e.w * n.zoom <= this.view.w - 24 && o + e.h * n.zoom <= this.view.h - (t ? 280 : 96);
  }
  /**
   * Where something placed without a point goes: beside the selection (its
   * right, top-aligned), where there is one (IL-100; Nathan: "if you have a
   * selection and place an image it should place next to that instead of
   * the center of the screen"), else the middle of the view.
   */
  placeNear(e, t) {
    const n = this.ui.selection.filter((o) => !!this.store.get(o)), s = n.length ? this.store.bounds(n) : null;
    return s ? { x: s.x + s.w + 48 + e / 2, y: s.y + t / 2 } : void 0;
  }
  /** The canvas menu's Shape (IL-100): the dock's shape, as a click with it drops one, centred where you pointed. */
  addShape(e) {
    const t = this.ui.shapeKind, n = t === "line" || t === "arrow", s = {
      id: St(),
      type: "shape",
      shape: t,
      z: 0,
      sc: [0, 0],
      x: Math.round(e.x - 130),
      y: Math.round(n ? e.y : e.y - 85),
      w: 260,
      h: n ? 0 : 170,
      stroke: this.ui.shapeStyle.stroke,
      sw: this.ui.shapeStyle.sw,
      createdBy: this.user.uid
    };
    return s.z = this.store.nextZ(s), this.closeAddMenus(), this.store.add([s]), this.ui.selection = [s.id], this.ui.styleOpen = !0, this.revealNew(s, !0), s.id;
  }
  /**
   * Clear space near the viewport centre (or `near`, a world point): rings
   * 160px apart, a 48px margin around everything already there. Frames
   * don't count — things go in them. `taken`: places already given out that the
   * board doesn't hold yet (several pictures placed at once).
   */
  freeSpot(e, t, n, s = [], o = {}) {
    const r = n || this.viewportCentre(), a = 48, l = (h, f) => {
      const p = { x: h - a, y: f - a, w: e + a * 2, h: t + a * 2 };
      for (const y of s) if (Ya({ x: h, y: f, w: e, h: t }, { x: y.x - 24, y: y.y - 24, w: y.w + 48, h: y.h + 48 })) return !1;
      for (const y of this.store.index.query(p)) {
        const v = this.store.get(y);
        if (!v) continue;
        const x = He(v);
        if (v.type === "frame") {
          if (o.outsideFrames) {
            if (Ya(p, x)) return !1;
            continue;
          }
          const w = 16;
          if (!(h >= x.x + w && f >= x.y + w && h + e <= x.x + x.w - w && f + t <= x.y + x.h - w) && Ya(p, x)) return !1;
          continue;
        }
        if (Ya(p, x)) return !1;
      }
      return !0;
    }, d = Math.round(r.x - e / 2), c = Math.round(r.y - t / 2);
    if (l(d, c)) return { x: d, y: c };
    for (let h = 1; h <= 14; h++) {
      const f = h * 160, p = 8 * h;
      let y = null;
      for (let v = 0; v < p; v++) {
        const x = v / p * Math.PI * 2, w = Math.round(d + Math.cos(x) * f), S = Math.round(c + Math.sin(x) * f * 0.75);
        if (l(w, S)) {
          y = { x: w, y: S };
          break;
        }
      }
      if (y) return y;
    }
    return { x: d, y: c };
  }
  /** Typing needs a readable zoom: bring a far element close first. */
  editNote(e) {
    const t = this.store.get(e);
    if (t) {
      if (t.type === "note" && t.link) {
        this.openBoardLink(e);
        return;
      }
      if (this.ui.selection = [e], this.far.value) {
        const n = He(t);
        this.jumpTo(n.x + n.w / 2, n.y + n.h / 2, 0.8);
      }
      this.ui.editingNote = e, this.overlayArea = null, this.updateOverlay();
    }
  }
  // ------------------------------------------------------------ selection
  select(e) {
    this.ui.selection = e, this.ui.styleOpen = !1;
  }
  /** Everything on the board, frames too: a move takes each frame with what it holds (CHAT-26). */
  selectAll() {
    this.ui.selection = Array.from(this.store.all()).map((e) => e.id);
  }
  clearSelection() {
    this.ui.selection = [], this.ui.styleOpen = !1;
  }
  // -------------------------------------------------------------- creation
  author() {
    return this.user.initials || "You";
  }
  // ------------------------------------------------------- menus at a point
  /** Right-click on the canvas: its menu, at the pointer, adds things there. */
  openCanvasMenu(e, t) {
    this.closeMenus(), this.ui.canvasMenu = this.pointMenu(e, t);
  }
  /** Link to a board (B33), at a point: the canvas menu's row hands over to it. */
  openBoardLinkMenu(e, t) {
    this.closeMenus(), this.ui.boardLinkMenu = this.pointMenu(e, t);
  }
  /** Double-click on the canvas: the session finder, at the pointer; a session started from it goes there. */
  openFinder(e, t) {
    this.closeMenus(), this.ui.finder = this.pointMenu(e, t);
  }
  pointMenu(e, t) {
    return { x: e, y: t, at: this.screenToWorld(e, t) };
  }
  /** The menus over the board (the add menu, the place menu, the shape menu, the board menu, the menus at a point); not its dialogs. */
  closeMenus() {
    this.ui.placeMenu = !1, this.ui.shapeMenu = !1, this.ui.boardMenu = !1, this.closeAddMenus();
  }
  /** The menus that add to the board: something added closes them. */
  closeAddMenus() {
    this.ui.addMenu = !1, this.ui.canvasMenu = null, this.ui.finder = null, this.ui.boardLinkMenu = null;
  }
  /**
   * The add menu opens where the tool rail is, and an open session's prompt
   * takes the rail's place: picking "new session" leaves the current one.
   */
  openAddMenu() {
    this.promptTool.value && (this.ui.selection = []), this.ui.addMenu = !0;
  }
  /**
   * `at`: a world point (a right-click's) the new element is centred on, or
   * as near it as there's room; without one, clear space where you look.
   */
  addElement(e, t) {
    if (e === "tool") {
      this.ui.addMenu ? this.ui.addMenu = !1 : this.openAddMenu();
      return;
    }
    if (this.closeAddMenus(), e === "image-gen") {
      this.newImageSession(t);
      return;
    }
    let n = null;
    if (e !== "image") {
      if (e === "note") {
        const s = this.freeSpot(Ih.w, Ih.h, t);
        n = { id: St(), type: "note", x: s.x, y: s.y, w: Ih.w, h: Ih.h, z: 0, tint: this.ui.noteTint, text: "", author: this.author(), grow: !0 };
      } else if (e === "frame") {
        const s = this.freeSpot(Ah.w, Ah.h, t);
        n = { id: St(), type: "frame", x: s.x, y: s.y, w: Ah.w, h: Ah.h, z: 0, title: "New frame" };
      }
      n && (n.z = this.store.nextZ(n, n.type === "frame"), n.createdBy = this.user.uid, this.store.add([n]), this.ui.selection = [n.id], this.revealNew(n, !!t), n.type === "note" && (this.ui.editingNote = n.id), n.type === "frame" && (this.ui.editingTitle = n.id));
    }
  }
  /** Place images (urls) at the viewport centre or a world point. */
  placeImages(e, t) {
    const n = [], s = [];
    let o = 0;
    const r = [];
    for (const a of e) {
      const l = a.w || k_.w, d = a.h || k_.h, c = r[r.length - 1], h = c ? { x: c.x + c.w + 24 + l / 2, y: c.y + d / 2 } : this.placeNear(l, d), f = a.x !== void 0 && a.y !== void 0 ? { x: a.x, y: a.y } : t ? { x: Math.round(t.x - l / 2 + o), y: Math.round(t.y - d / 2 + o) } : this.freeSpot(l, d, h, r);
      r.push({ x: f.x, y: f.y, w: l, h: d });
      const p = {
        id: St(),
        type: "image",
        x: f.x,
        y: f.y,
        w: l,
        h: d,
        z: 0,
        src: a.url,
        label: a.label || "placed_image",
        resultId: a.resultId,
        sessionId: a.sessionId,
        video: a.video,
        dur: a.dur,
        videoSrc: a.videoSrc,
        previewSrc: a.previewSrc,
        asset: a.asset,
        download: a.download,
        kind: a.kind,
        createdBy: this.user.uid
      };
      p.z = this.store.nextZ(p) + s.length, s.push(p), n.push(p.id), o += 28;
    }
    return s.length && (this.store.batch("Place", () => {
      this.store.add(s), this.growFramesFor(n);
    }), this.ui.selection = n, t || this.revealNew(s[0])), n;
  }
  // ------------------------------------------------------------ your Library
  /** Open your Library over the board: to place pictures on it (the default), or to pick some for something. */
  openLibrary(e = {}) {
    this.ui.placeMenu = !1, this.ui.addMenu = !1, this.ui.libraryOpen = {
      purpose: e.purpose || "place",
      max: e.max || Xie,
      kinds: e.kinds,
      confirmLabel: e.confirmLabel,
      onPick: e.onPick,
      at: e.at,
      n: (this.ui.libraryOpen ? this.ui.libraryOpen.n : 0) + 1
    };
  }
  closeLibrary() {
    this.ui.libraryOpen = null;
  }
  /**
   * Pictures picked in your Library go on the board at a card's size, in the
   * order picked, each with its record (so a run can send it as is).
   */
  placeFromLibrary(e, t) {
    const n = [];
    for (const y of e) {
      this.rememberAsset(y.url, y.asset);
      const v = __(y.w || 0, y.h || 0);
      n.push({
        url: y.url,
        w: v.w,
        h: v.h,
        label: y.label.slice(0, 60),
        asset: y.asset,
        video: y.video && y.videoSrc ? !0 : void 0,
        videoSrc: y.video ? y.videoSrc : void 0,
        // a 3D model's preview, which keeps its model to download (IL-100)
        kind: y.model3d ? "3d" : void 0,
        download: y.model3d ? y.model3d.url : void 0
      });
    }
    const s = 24, o = Math.max(1, Math.ceil(Math.sqrt(n.length * 1.6))), r = [];
    for (let y = 0; y < n.length; y += o) r.push(n.slice(y, y + o));
    const a = r.map((y) => y.reduce((v, x) => v + (x.w || 0), 0) + s * (y.length - 1)), l = r.map((y) => Math.max(...y.map((v) => v.h || 0))), d = Math.max(0, ...a), c = l.reduce((y, v) => y + v, 0) + s * (r.length - 1), h = this.freeSpot(d, c, t || this.placeNear(d, c));
    let f = h.y;
    r.forEach((y, v) => {
      let x = h.x;
      for (const w of y)
        w.x = x, w.y = f + Math.round((l[v] - (w.h || 0)) / 2), x += (w.w || 0) + s;
      f += l[v] + s;
    });
    const p = this.placeImages(n);
    return p.length && this.toast(p.length === 1 ? "Placed 1 image from your Library" : "Placed " + p.length + " images from your Library"), p;
  }
  /** Tools are concepts, not models: "Image Tool 3" until its first run. */
  nextToolName(e) {
    const t = new RegExp("^" + e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + " Tool (\\d+)$");
    let n = 0;
    const s = (o) => {
      const r = t.exec(o || "");
      r && (n = Math.max(n, Number(r[1])));
    };
    for (const o of this.store.all()) o.type === "tool" && s(o.name);
    for (const o of this.trash.value) o.el.type === "tool" && s(o.el.name);
    return e + " Tool " + (n + 1);
  }
  /** A new session on this kit and model; `at` as addElement has it, or where a tour (IL-095) says it lands. */
  pickModel(e, t, n) {
    const s = n || this.tour && this.tour.landing && this.tour.landing() || void 0, o = this.addSession(e, t, void 0, s);
    return this.prompts.set(o.id, { prompt: "", n: t.numResults.def || 1 }), this.bumpPrompt(), this.freshTools.add(o.id), o;
  }
  /** Image Gen: a session on the image kit's default model, or none while there's no catalog. */
  newImageSession(e) {
    const t = this.catalog.value.kits.find((s) => s.id === "image") || this.catalog.value.kits[0], n = t ? Bi(t) : null;
    return t && n ? this.pickModel(t, n, e) : null;
  }
  /**
   * A new session in clear space where you're looking (or near `at`), selected
   * and in view. `quiet`: the selection and the view stay as they are (a chat's
   * plan adds sessions to a frame you're already looking at).
   */
  addSession(e, t, n, s, o = {}) {
    const r = Rt, a = this.freeSpot(r.w, r.h, s), l = {
      id: St(),
      type: "tool",
      x: a.x,
      y: a.y,
      w: r.w,
      h: r.h,
      z: 0,
      name: n || this.nextToolName(e.name),
      kind: e.name,
      kitId: e.id,
      model: t.name,
      nodeDefId: t.id,
      icon: Nl[e.id] || e.icon || "Image",
      count: 0,
      thumbs: [],
      createdBy: this.user.uid
    };
    return l.z = this.store.nextZ(l), this.store.add([l]), o.quiet || (this.closeAddMenus(), this.ui.selection = [l.id], this.revealNew(l, !!s)), l;
  }
  /** `name`, or "name 2", "name 3"… when another session has it. */
  uniqueSessionName(e, t) {
    const n = /* @__PURE__ */ new Set();
    for (const o of this.store.all()) o.type === "tool" && o.id !== t && n.add(o.name);
    if (!n.has(e)) return e;
    let s = 2;
    for (; n.has(e + " " + s); ) s++;
    return e + " " + s;
  }
  /** A session that has made nothing yet, and isn't making anything. */
  isUnused(e) {
    return this.results.rev.value, !e.count && !(e.thumbs && e.thumbs.length) && !this.results.list(e.id).length && !this.generating[e.id];
  }
  /** A prompt just landed in this session's card: it glows once. */
  landPrompt(e) {
    this.ui.promptLanded = { id: e, seq: (this.ui.promptLanded ? this.ui.promptLanded.seq : 0) + 1 };
  }
  // ------------------------------------------------------------ mutations
  patch(e, t, n = "Edit") {
    this.store.batch(n, () => this.store.update(e, t));
  }
  patchTool(e, t) {
    this.store.batch("Edit session", () => this.store.update(e, t)), t.nodeDefId !== void 0 && this.persistPrompt(e);
  }
  // ------------------------------------------------------------- prompts
  /**
   * Your prompt in a session. On a real board it's your run draft, so it's
   * yours alone; until you change it, a demo session offers its own.
   */
  promptOf(e) {
    this.promptRev.value;
    const t = this.store.get(e);
    t && t.type === "tool" && this.opts.prompts && this.opts.prompts.follow(e).catch(() => {
    });
    const n = this.prompts.get(e);
    return n || t && t.type === "tool" && t.up || {};
  }
  setPrompt(e, t) {
    const n = { ...this.promptOf(e), ...t };
    t.assets && (n.assets = { ...this.promptOf(e).assets || {}, ...t.assets }), this.prompts.set(e, n), this.bumpPrompt(), t.prompt && this.freshTools.delete(e), this.persistPrompt(e);
  }
  /** Put a session's prompt back whole, as it was (an Undo's): what setPrompt merges, replaced. */
  replacePrompt(e, t) {
    this.prompts.set(e, t), this.bumpPrompt(), this.persistPrompt(e);
  }
  bumpPrompt() {
    this.promptRev.value++, xs(this.promptRev);
  }
  /** Save a session's prompt (your run draft), for its current model. */
  persistPrompt(e) {
    const t = this.opts.prompts;
    if (!t) return;
    const n = this.store.get(e);
    if (!n || n.type !== "tool") return;
    const { model: s } = this.modelFor(n);
    if (!s) return;
    const o = this.promptOf(e);
    t.save(e, s.id, Eo(s, o, "draft").inputs, this.countFor(s, o));
  }
  countFor(e, t) {
    return Math.max(e.numResults.min, Math.min(e.numResults.max, t.n || e.numResults.def || 1));
  }
  /** Your saved prompt for a session arrived (the load, or another tab of yours). */
  onSavedPrompt(e, t) {
    if (!t) return;
    const n = this.catalog.value, s = this.store.get(e), r = n.byId.get(t.nodeDefId) || null || (n.source === "firestore" && s ? this.modelFor(s).model : null);
    if (!r) {
      this.undecoded.set(e, t);
      return;
    }
    this.undecoded.delete(e);
    const a = dc(r, t.inputs, (l) => this.assetUrl(l));
    t.numResults && (a.n = t.numResults), !GL(this.prompts.get(e), a) && (this.prompts.set(e, a), this.dropForgotten(e), this.bumpPrompt());
  }
  /** Where the board shows a result's or an upload's file. */
  assetUrl(e) {
    const t = HW(e) || "";
    return this.opts.storageUrl ? this.opts.storageUrl(t) : t;
  }
  /** A session's image inputs, in the model's order. */
  refFieldsOf(e) {
    const { model: t } = this.modelFor(e);
    return t ? t.fields.filter((n) => n.placement === "reference") : [];
  }
  /**
   * The pictures in one of a session's image inputs. The first input is the
   * session's own reference (`ref`), the rest live under `inputs` by field
   * key; one that takes several keeps a list there once it holds more than one.
   */
  refImages(e, t) {
    const n = this.store.get(e);
    if (!n || n.type !== "tool") return [];
    const s = this.refFieldsOf(n), o = this.promptOf(e), r = o.inputs ? o.inputs[t] : void 0;
    if (Array.isArray(r)) {
      const l = r.filter((d) => typeof d == "string" && !!d);
      if (l.length) return l;
    }
    const a = !s.length || s[0].key === t ? o.ref : r;
    return typeof a == "string" && a ? [a] : [];
  }
  putRefImages(e, t, n, s) {
    const o = this.store.get(e);
    if (!o || o.type !== "tool") return;
    const r = this.refFieldsOf(o), a = !r.length || r[0].key === t, l = this.promptOf(e), d = n.length > 1 ? n : a ? void 0 : n[0] || null, c = {};
    s && (c.assets = s), a && (c.ref = n[0] || null), (!a || d !== void 0 || l.inputs && l.inputs[t] !== void 0) && (c.inputs = { ...l.inputs || {}, [t]: d }), this.setPrompt(e, c);
  }
  /**
   * Fill one of a session's image inputs, or clear it (null). One that takes
   * several adds the picture to those it holds, up to the model's limit; any
   * other holds just this one. `asset` is the result or upload behind the
   * picture, which a run sends. False when it didn't take (the input is full).
   */
  setRefInput(e, t, n, s) {
    const o = this.store.get(e);
    if (!o || o.type !== "tool") return !1;
    if (!n)
      return this.putRefImages(e, t, []), !0;
    const r = s ? { [n]: s } : void 0, a = this.refFieldsOf(o).find((l) => l.key === t);
    if (a && a.kind === "images") {
      const l = this.refImages(e, t);
      if (l.includes(n)) return !0;
      const d = Zs(a);
      return l.length >= d ? (this.toast("This model takes up to " + d + " images. Remove one to add another."), !1) : (this.putRefImages(e, t, l.concat(n), r), !0);
    }
    return this.putRefImages(e, t, [n], r), !0;
  }
  /** Take one picture out of an image input (the rest stay, in order). */
  removeRefImage(e, t, n) {
    this.putRefImages(e, t, this.refImages(e, t).filter((s) => s !== n));
  }
  /** A picture for a session's reference: its first image input. */
  addReference(e, t, n) {
    const s = this.store.get(e);
    if (!s || s.type !== "tool") return !1;
    const o = this.refFieldsOf(s)[0];
    return this.setRefInput(e, o ? o.key : "", t, n);
  }
  // ---------------------------------------------------------------- the eyedropper
  /**
   * The eyedropper: armed for one of a session's image inputs, a click on an
   * image on the board (or a session card's thumbnail, or a gallery result)
   * puts it there instead of selecting it. Without a key it arms the first
   * input with room for another picture, else the first.
   */
  armEyedropper(e, t) {
    const n = this.store.get(e);
    if (!n || n.type !== "tool") return;
    const s = this.refFieldsOf(n), o = t ? s.find((r) => r.key === t) : s.find((r) => this.refImages(e, r.key).length < Zs(r)) || s[0];
    if (!o) {
      this.toast("This model takes no images.");
      return;
    }
    this.ui.shapeArmed = !1, this.ui.mode = "select", this.ui.addMenu = !1, this.ui.eyedropper = { sessionId: e, key: o.key };
  }
  /** The prompt's eyedropper button (and I): on, or off again. */
  toggleEyedropper(e) {
    this.ui.eyedropper && this.ui.eyedropper.sessionId === e ? this.ui.eyedropper = null : this.armEyedropper(e);
  }
  /** The input the eyedropper fills, while the session still has it. */
  get eyedropperField() {
    const e = this.ui.eyedropper, t = e ? this.store.get(e.sessionId) : void 0;
    return !e || !t || t.type !== "tool" ? null : this.refFieldsOf(t).find((n) => n.key === e.key) || null;
  }
  /** Whether the eyedropper's input takes this picture (a video input takes videos, the rest stills). */
  eyedropperTakes(e) {
    const t = this.eyedropperField;
    return !!t && t.kind === "video" === e;
  }
  /**
   * Put a picture from the board in the eyedropper's input, and put the
   * eyedropper away: one pick per press. A picture of the wrong kind (a video
   * for an image input) is turned away and the eyedropper stays on.
   */
  eyedrop(e, t, n) {
    const s = this.ui.eyedropper, o = this.eyedropperField;
    if (!s || !o) {
      this.ui.eyedropper = null;
      return;
    }
    if (o.kind === "video" !== n) {
      this.toast(o.kind === "video" ? "This input takes a video. Pick a video on the board." : "This input takes images, not videos.");
      return;
    }
    this.ui.eyedropper = null;
    const r = t && "nodeRunResult" in t ? t.nodeRunResult : null;
    if (r && r.type === "ASSET_3D" && r.nodeRunId && r.uuid) {
      this.openStudio({ sessionId: s.sessionId, resultId: r.nodeRunId + ":" + r.uuid });
      return;
    }
    if (!this.refImages(s.sessionId, s.key).includes(e) && !this.setRefInput(s.sessionId, s.key, e, t)) return;
    const a = (this.ui.refPulse ? this.ui.refPulse.n : 0) + 1;
    this.ui.refPulse = { url: e, n: a }, window.setTimeout(() => {
      this.ui.refPulse && this.ui.refPulse.n === a && (this.ui.refPulse = null);
    }, 900);
  }
  /** An image on the board, through the eyedropper: its record goes with it, for the run. */
  eyedropImage(e) {
    const t = this.ui.eyedropper;
    if (t && e.kind === "3d" && !e.resultId) {
      this.ui.eyedropper = null, this.openStudio({ sessionId: t.sessionId, elementId: e.id });
      return;
    }
    this.eyedrop(e.src, e.asset || this.assetFor(e.src), !!e.video);
  }
  // ---------------------------------------------------------------- Shift-drag to a session
  /**
   * An image on the board, Shift-dragged onto a session (IL-071): its card,
   * its row in the sessions rail, or its open prompt. It goes into the input
   * it was dropped on, else the session's first input that takes it (with
   * room, if one has), with its record for the run. The session opens, and
   * the picture glows softly in its prompt for a few seconds. One already
   * there isn't added twice; it glows again. `reveal` brings a session from
   * elsewhere on the board into view.
   */
  referenceImage(e, t, n = {}) {
    const s = this.store.get(e), o = this.store.get(t);
    if (!s || s.type !== "image" || !o || o.type !== "tool") return !1;
    const r = s.resultId ? this.results.get(s.resultId) : void 0;
    if (s.kind === "3d" || r && r.kind === "3d")
      return this.openStudio({ sessionId: t, elementId: e }), !1;
    const a = !!s.video, l = this.refFieldsOf(o), d = (p) => p.kind === "video" === a, c = n.key ? l.find((p) => p.key === n.key) : l.find((p) => d(p) && this.refImages(t, p.key).length < Zs(p)) || l.find(d);
    if (!c)
      return this.toast(l.length ? a ? o.name + " takes images, not videos." : o.name + " takes a video, not images." : o.name + " takes no images."), !1;
    if (!d(c))
      return this.toast(c.kind === "video" ? "This input takes a video, not images." : "This input takes images, not videos."), !1;
    const h = s.src;
    if (!this.refImages(t, c.key).includes(h) && !this.setRefInput(t, c.key, h, s.asset || this.assetFor(h))) return !1;
    n.reveal ? this.openSession(o) : this.ui.selection = [t];
    const f = (this.ui.refGlow ? this.ui.refGlow.n : 0) + 1;
    return this.ui.refGlow = { sessionId: t, url: h, n: f }, window.setTimeout(() => {
      this.ui.refGlow && this.ui.refGlow.n === f && (this.ui.refGlow = null);
    }, Wie), !0;
  }
  /**
   * Upload a file (a drop, a paste, the picker's Upload): to your uploads
   * where the host offers its pipeline, keeping the upload's record so a run
   * can send the picture without uploading it again.
   */
  async uploadFile(e) {
    const t = this.uploader;
    if (!t) throw new Error("Uploads aren't available here.");
    if (t.uploadRecord) {
      const n = await t.uploadRecord(e), s = n.upload ? { upload: n.upload } : null;
      return s && this.knownAssets.set(n.url, s), { url: n.url, asset: s };
    }
    return { url: await t.upload(e), asset: null };
  }
  /** Whether a video can be brought in from your computer (the host keeps it in your uploads). */
  get canUploadVideo() {
    return !!(this.uploader && this.uploader.uploadVideo);
  }
  /** A video into your uploads, as a run's video input takes it (TD-13). */
  async uploadVideoFile(e) {
    const t = this.uploader;
    if (!t || !t.uploadVideo) throw new Error("Videos can't be uploaded here.");
    const n = await t.uploadVideo(e), s = n.upload ? { upload: n.upload } : null;
    return s && this.knownAssets.set(n.url, s), { url: n.url, asset: s };
  }
  get hasLibrary() {
    return !!this.opts.library;
  }
  /** Your Library, where the host gives the board one (the harness has a demo one). */
  get libraryShelf() {
    return this.opts.library || null;
  }
  /** A page of your Library: your generations, uploads or favorites, from `q.cursor`, filtered and searched as `q` says. */
  libraryPage(e, t = {}) {
    const n = this.opts.library;
    return n ? e === "generations" ? n.generations(t) : e === "uploads" ? n.uploads(t) : n.favorites(t) : Promise.resolve({ items: [], next: null });
  }
  /**
   * Something deleted from your Library (CHAT-13): the pictures the Studios
   * view brought in from it go too, for good (what they pointed at is
   * deleted, so there's nothing to recover), with their marks; and the
   * sessions' prompts let go of it, or opening a Studios view would bring it
   * back from its queue. Matched by its upload, its result, or its file. The
   * prompts are those of the sessions it was brought into and those already
   * read; reading every session's saved prompt for it would read the board's.
   */
  forgetLibraryItem(e) {
    const t = e.run ? e.run.uuid : null, n = (d, c) => d === e.url ? !0 : c ? e.uploadId && "upload" in c && c.upload.id === e.uploadId ? !0 : !!t && "nodeRunResult" in c && c.nodeRunResult.uuid === t : !1;
    e.run && this.forgetDeletedResult(e.run.id, e.run.uuid, e.run.nodeId, e.url), this.forgottenLibrary.push(n);
    const s = this.studioRecords.all().filter((d) => d.role === "ref" && n(d.url, d.asset)), o = /* @__PURE__ */ new Set([...s.map((d) => d.sessionId), ...this.prompts.keys()]);
    for (const d of o) {
      if (!this.store.get(d)) continue;
      const h = this.promptOf(d).assets || {};
      this.dropPictures(d, (f) => n(f, h[f] || this.knownAssets.get(f)));
    }
    if (!s.length) return;
    const r = s.map((d) => d.id), a = this.studioRecords.all().filter((d) => d.role === "marks" && r.includes(d.target)).map((d) => d.id), l = [...r, ...a];
    this.studioRecords.remove(l), this.sync.purge(l), this.trashRev.value++;
  }
  /**
   * A result deleted somewhere else this visit (the Library: CHAT-52, Adam
   * deleted a picture there and its session still said 12): off the session's
   * history and card. Its session's history needn't be read for the card to
   * come right: one off its count, and its picture off the thumbnails.
   */
  forgetDeletedResult(e, t, n, s) {
    const o = this.results.ofRun(e).find((r) => r.uuid === t);
    o && (this.ui.infoAt === "result:" + o.id && (this.ui.infoAt = null), this.results.remove([o.id])), o && this.historyCursor.get(o.sessionId) === "end" ? this.recount(o.sessionId) : this.uncount(o || { id: e + ":" + t, sessionId: n, status: "done", url: s, w: 0, h: 0, prompt: "", model: "", createdAt: 0 });
  }
  /** A session's prompt without the Library items deleted this visit (forgetLibraryItem), once its saved draft is read. */
  dropForgotten(e) {
    if (!this.forgottenLibrary.length || !this.store.get(e)) return;
    const t = this.promptOf(e).assets || {};
    this.dropPictures(e, (n) => this.forgottenLibrary.some((s) => s(n, t[n] || this.knownAssets.get(n))));
  }
  /** A session's prompt without the pictures `gone` names, in its reference and its picture inputs. */
  dropPictures(e, t) {
    const n = this.promptOf(e), s = (l) => typeof l == "string" && t(l);
    let o = !1;
    const r = n.ref && s(n.ref) ? null : n.ref;
    r !== n.ref && (o = !0);
    const a = {};
    for (const [l, d] of Object.entries(n.inputs || {})) {
      if (s(d)) {
        o = !0;
        continue;
      }
      if (Array.isArray(d) && d.some(s)) {
        o = !0;
        const c = d.filter((h) => !s(h));
        c.length && (a[l] = c);
        continue;
      }
      a[l] = d;
    }
    o && this.setPrompt(e, { ref: r, inputs: a });
  }
  /** Keep a picture's record (a Library pick), so a run sends it without uploading it again. */
  rememberAsset(e, t) {
    this.knownAssets.set(e, t);
  }
  /** The record behind a picture on the board or in a gallery, if it has one. */
  assetFor(e) {
    const t = this.knownAssets.get(e);
    if (t) return t;
    for (const s of this.store.all())
      if (s.type === "image" && s.src === e && s.asset) return s.asset;
    const n = this.resultByUrl(e);
    return n && n.asset || null;
  }
  /**
   * A picture's or video's own pixels, for one with no record to say them (a
   * board picture that isn't a result or an upload, B26): read from the file
   * once it loads. Null until then, or if it can't be read.
   */
  measuredSize(e) {
    const t = this.measured.get(e);
    if (t !== void 0) return t;
    this.measured.set(e, null);
    const n = (o, r) => {
      o && r && this.measured.set(e, { width: o, height: r });
    }, s = new Image();
    return s.onload = () => n(s.naturalWidth, s.naturalHeight), s.onerror = () => {
      const o = document.createElement("video");
      o.preload = "metadata", o.onloadedmetadata = () => n(o.videoWidth, o.videoHeight), o.src = e;
    }, s.src = e, null;
  }
  resultByUrl(e) {
    this.results.rev.value;
    for (const t of this.allResults()) if (t.url === e || t.thumb === e) return t;
    return null;
  }
  allResults() {
    const e = [];
    for (const t of this.store.all()) t.type === "tool" && e.push(...this.results.list(t.id));
    return e;
  }
  /**
   * Into Recently Deleted, sessions too (with their history); a session's run
   * in flight stops. A locked frame and what it holds stay, and say why.
   */
  deleteIds(e) {
    const t = e.filter((r) => !this.isHeld(this.store.get(r))), n = e.filter((r) => Ro(this.store.get(r))).length, s = e.length - t.length - n;
    if (n && s ? this.toast("Locked frames and what they hold stay. Unlock the frames to delete them.") : n ? this.toast(n === 1 ? "The locked frame stays. Unlock it to delete it." : "Locked frames stay. Unlock them to delete them.") : s && this.toast(s === 1 ? "It's in a locked frame. Unlock the frame to delete it." : "These are in a locked frame. Unlock the frame to delete them."), !t.length) return;
    const o = t.filter((r) => {
      var a;
      return ((a = this.store.get(r)) == null ? void 0 : a.type) === "tool";
    });
    this.store.batch("Delete", () => this.store.remove(t));
    for (const r of o) {
      const a = this.runs.get(r);
      a && (a.cancel(), this.runs.delete(r), delete this.generating[r]);
    }
    this.ui.selection = this.ui.selection.filter((r) => !t.includes(r));
  }
  duplicateIds(e, t = 28) {
    const n = [], s = /* @__PURE__ */ new Map();
    for (const o of e) {
      const r = this.store.get(o);
      if (!r) continue;
      const a = JSON.parse(JSON.stringify(r));
      if (a.id = St(), a.x += t, a.y += t, a.type === "frame" && delete a.locked, a.z = this.store.nextZ(a, a.type === "frame") + n.length, a.type === "tool")
        a.name = a.name + " copy", a.count = 0, a.thumbs = [];
      else if (a.type === "chat") {
        const l = a;
        l.name = l.name + " copy", l.messages = (l.messages || []).map((d) => d.plan && d.plan.status === "running" ? { ...d, plan: { ...d.plan, status: "stopped" } } : d);
      }
      s.set(o, a.id), n.push(a);
    }
    return n.length ? (this.store.batch("Duplicate", () => this.store.add(n)), this.ui.selection = n.map((o) => o.id), this.ui.selection) : [];
  }
  /**
   * Why Bring forward or Send back can't move any of `ids`, or null when it
   * can (B16: Blake found the commands dead on a shape over a picture). Order
   * only works inside a layer (frames, then pictures, then shapes, then notes,
   * sessions and chats), so a shape sent back stays over a picture: the
   * toolbar rests the button and says why, rather than doing nothing.
   */
  orderBlock(e, t) {
    const n = (a) => a === "frame" ? 0 : a === "image" ? 1 : a === "shape" ? 2 : 3, s = ["Frames stay under what they hold", "Pictures stay under shapes and notes", "Shapes stay under notes and sessions"], o = ["", "Pictures stay above frames", "Shapes stay above pictures", "Notes and sessions stay above pictures and shapes"];
    let r = null;
    for (const a of e) {
      const l = this.store.get(a);
      if (!l || Ro(l)) continue;
      const d = this.store.query(He(l)).filter((y) => y.id !== a);
      if (d.filter((y) => S_(y, l)).some((y) => t === "forward" ? y.z > l.z : y.z < l.z)) return null;
      const h = n(l.type), f = d.some((y) => t === "forward" ? n(y.type) > h : n(y.type) < h), p = f ? t === "forward" ? s[h] : o[h] : t === "forward" ? "Already at the front" : "Already at the back";
      (!r || f) && (r = p || r);
    }
    return r;
  }
  /** A card to the top of its layer, selected: a stack's fan picks one this way (CHAT-23). One undo step. */
  bringToTop(e) {
    const t = this.store.get(e);
    t && (Ro(t) || this.store.batch("Bring to top", () => this.store.update(e, { z: this.store.nextZ(t) })), this.select([e]));
  }
  /** Swap with the neighbour above / below, within the element's layer. A locked frame keeps its place. */
  reorder(e, t) {
    this.store.batch(t === "forward" ? "Bring forward" : "Send back", () => {
      for (const n of e) {
        const s = this.store.get(n);
        if (!s || Ro(s)) continue;
        const o = He(s), r = this.store.query(o).filter((a) => a.id !== n && S_(a, s));
        if (t === "forward") {
          const a = r.filter((d) => d.z > s.z).sort((d, c) => d.z - c.z)[0], l = a ? a.z + 0.5 : this.store.nextZ(s);
          this.store.update(n, { z: l });
        } else {
          const a = r.filter((d) => d.z < s.z).sort((d, c) => c.z - d.z)[0], l = a ? a.z - 0.5 : this.store.nextZ(s, !0);
          this.store.update(n, { z: l });
        }
      }
    });
  }
  /**
   * Lines up the selection; a locked frame and what it holds neither move nor count. A
   * frame lines up with what it holds, which goes with it rather than
   * lining up on its own (a selection can hold both since CHAT-26).
   */
  align(e) {
    var t, n;
    const s = this.ui.selection.map((c) => this.store.get(c)).filter((c) => c && !this.isHeld(c)), o = /* @__PURE__ */ new Map();
    for (const c of s) c.type === "frame" && o.set(c.id, this.carriedBy(c));
    const r = new Set(Array.from(o.values()).flat()), a = s.filter((c) => !r.has(c.id));
    if (a.length < 2) return;
    const l = a.map((c) => ({ id: c.id, ...He(c) })), d = [];
    if (e === "align-left") {
      const c = Math.min(...l.map((h) => h.x));
      l.forEach((h) => d.push([h.id, { x: c }]));
    } else if (e === "align-top") {
      const c = Math.min(...l.map((h) => h.y));
      l.forEach((h) => d.push([h.id, { y: c }]));
    } else if (e === "align-center") {
      const c = l.reduce((h, f) => h + f.y + f.h / 2, 0) / l.length;
      l.forEach((h) => d.push([h.id, { y: Math.round(c - h.h / 2) }]));
    } else {
      const c = l.slice().sort((x, w) => x.x - w.x), h = c[0].x, f = Math.max(...c.map((x) => x.x + x.w)), p = c.reduce((x, w) => x + w.w, 0), y = (f - h - p) / Math.max(1, c.length - 1);
      let v = h;
      c.forEach((x) => {
        d.push([x.id, { x: Math.round(v) }]), v += x.w + y;
      });
    }
    for (const [c, h] of d.slice()) {
      const f = o.get(c), p = this.store.get(c);
      if (!f || !p) continue;
      const y = ((t = h.x) != null ? t : p.x) - p.x, v = ((n = h.y) != null ? n : p.y) - p.y;
      for (const x of f) {
        const w = this.store.get(x);
        w && !this.isHeld(w) && d.push([x, { x: w.x + y, y: w.y + v }]);
      }
    }
    this.store.batch("Align", () => this.store.updateMany(d));
  }
  tint(e) {
    const t = [];
    for (const n of this.ui.selection) {
      const s = this.store.get(n);
      s && s.type === "note" && t.push([n, { tint: e }]);
    }
    t.length && this.store.batch("Tint", () => this.store.updateMany(t)), this.ui.noteTint = e;
  }
  /** Wrap the selection in a frame that hugs it. */
  groupIntoFrame() {
    const e = this.ui.selection.map((o) => this.store.get(o)).filter((o) => o && o.type !== "frame"), t = this.store.bounds(e.map((o) => o.id));
    if (!t) return;
    const n = 48, s = {
      id: St(),
      type: "frame",
      x: Math.round(t.x - n),
      y: Math.round(t.y - n - 12),
      w: Math.round(t.w + n * 2),
      h: Math.round(t.h + n * 2 + 12),
      z: 0,
      title: "New frame"
    };
    s.z = this.store.nextZ(s, !0), this.store.batch("Group into frame", () => this.store.add([s])), this.ui.selection = [s.id], this.ui.editingTitle = s.id;
  }
  /**
   * Lock the selected frames (IL-070), or unlock them when every one is
   * locked already: one undo step. Only frames lock; with none selected it
   * does nothing.
   */
  toggleLock(e = this.ui.selection) {
    const t = e.map((r) => this.store.get(r)).filter((r) => r && r.type === "frame");
    if (!t.length) return;
    const n = t.some((r) => !r.locked), s = t.length === 1 ? " frame" : " " + t.length + " frames", o = t.map((r) => [r.id, { locked: n ? !0 : void 0 }]);
    this.store.batch((n ? "Lock" : "Unlock") + s, () => this.store.updateMany(o));
  }
  ctxAction(e) {
    const t = this.ui.selection.slice();
    e === "delete" ? this.deleteIds(t) : e === "duplicate" ? this.duplicateIds(t) : e === "copy" ? this.copy(!1) : e === "lock" ? this.toggleLock(t) : e === "rename" ? this.ui.editingTitle = t[0] : e === "style" ? this.ui.styleOpen = !this.ui.styleOpen : e === "info" ? this.ui.infoAt = t[0] : e === "save-prompt" ? (this.ui.infoAt = t[0], this.ui.infoSave = !0) : e === "frame" ? this.groupIntoFrame() : e === "download" ? this.download(t[0]) : e === "reference" ? this.useAsReference(t[0]) : e === "edit" ? this.openStudio({ elementId: t[0] }) : e === "forward" || e === "back" ? this.reorder(t, e) : e.startsWith("tint-") ? this.tint(e.slice(5)) : (e.startsWith("align-") || e === "distribute-h") && this.align(e);
  }
  /** Download a card's file: a video's own file, a 3D model's, named as v1 names results. */
  download(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "image") return;
    const n = t, s = n.download || n.videoSrc || n.src, o = n.resultId ? this.results.get(n.resultId) : void 0, r = (/(\.\w{3,4})(\?|$)/.exec(s.replace(/%2F/gi, "/")) || ["", ".webp"])[1];
    this.saveFile(s, o && o.uuid ? df(o.prompt, o.uuid, s) : (n.label || "image") + r);
  }
  // ------------------------------------------------------------ board links (B33)
  /** The tour's practice board as it is now, to come back to (TD-03). */
  tourSnapshot() {
    const e = (t) => JSON.parse(JSON.stringify(t));
    return {
      elements: e(Array.from(this.store.all())),
      results: e(this.results.all()),
      prompts: e(Array.from(this.prompts.entries())),
      fresh: Array.from(this.freshTools),
      selection: this.ui.selection.slice(),
      studio: this.ui.studio ? { ...this.ui.studio } : null,
      chatOpen: this.ui.chatOpen,
      histOpen: this.ui.histOpen
    };
  }
  /** Put the practice board back as a snapshot found it: what the steps since added, ran or opened goes. */
  tourRestore(e) {
    const t = (s) => JSON.parse(JSON.stringify(s));
    this.ui.selection = [], this.store.load(t(e.elements)), this.results.clear(), this.results.upsert(t(e.results), !1), this.prompts.clear();
    for (const [s, o] of t(e.prompts)) this.prompts.set(s, o);
    this.bumpPrompt(), this.freshTools.clear();
    for (const s of e.fresh) this.freshTools.add(s);
    this.ui.chatOpen = e.chatOpen, this.ui.histOpen = e.histOpen;
    const n = this.ui.studio;
    e.studio ? (!n || n.sessionId !== e.studio.sessionId) && (this.ui.studio = { ...e.studio }) : n && this.closeStudio(), this.ui.selection = e.selection.filter((s) => !!this.store.get(s));
  }
  get canLinkBoards() {
    return !!this.opts.boardLinks;
  }
  /** The boards you can link to, from this board's own account, newest first, this one left out. */
  async linkableBoards(e = "") {
    const t = this.opts.boardLinks;
    return t ? (await t.list(this.meta.teamId || null, e.trim())).filter((s) => s.id !== this.meta.id).sort((s, o) => (o.at || 0) - (s.at || 0)) : [];
  }
  /** A card linking to a board, at a point (or near the view's middle), selected. One Undo step. */
  addBoardLink(e, t, n = {}) {
    const s = this.freeSpot(Bu.w, Bu.h, t), o = {
      id: n.id || St(),
      type: "note",
      x: s.x,
      y: s.y,
      w: Bu.w,
      h: Bu.h,
      z: 0,
      tint: "vista",
      text: "",
      author: this.author(),
      createdBy: this.user.uid,
      link: { boardId: e.id, title: e.title, ...n.back ? { back: !0 } : {} }
    };
    return o.z = this.store.nextZ(o), this.store.add([o], n.quiet ? { history: !1 } : {}), n.quiet || (this.ui.selection = [o.id], this.revealNew(o, !!t)), o.id;
  }
  /** Make a board from a link's name, and link to it. */
  async addNewBoardLink(e, t) {
    const n = this.opts.boardLinks, s = e.trim() || "Untitled board";
    if (!n) return null;
    try {
      const o = await n.create(s), r = this.addBoardLink({ id: o.id, title: o.title || s }, t);
      return this.toast("Made " + (o.title || s) + " and linked it here"), r;
    } catch (o) {
      return console.error("[board] linked board not made", o), this.toast("The board couldn't be made. Try again.", "error"), null;
    }
  }
  /** Go to a link card's board; it links back to this one when you land. */
  openBoardLink(e) {
    const t = this.store.get(e), n = this.opts.boardLinks;
    if (!(!t || t.type !== "note" || !t.link || !n)) {
      if (this.missingBoards.value.has(t.link.boardId)) {
        this.toast(t.link.title + " isn't there any more, or you can't open it.", "error");
        return;
      }
      n.open(t.link.boardId, { id: this.meta.id, title: this.meta.title, teamId: this.meta.teamId || null, accessLevel: this.meta.accessLevel || null, ownerId: this.meta.ownerId || "" });
    }
  }
  /**
   * Whether this board may link back to the one you came from (R2): only
   * where everyone who can see this board could see that one's name anyway.
   * A board shared with the whole team links back from another of the
   * team's boards; a personal board links back from another of your own
   * personal boards. A private or restricted board, or one in another
   * account, gets no card here: its name isn't this board's people's to see.
   */
  mayLinkBack(e) {
    const t = this.meta;
    return e.teamId ? e.teamId === (t.teamId || null) && e.accessLevel === "SHARED" : !t.teamId && !!t.ownerId && t.ownerId === e.ownerId && e.ownerId === this.user.uid;
  }
  /**
   * Arrived by a link: this board links back to where you came from, unless
   * it already does, or that board's name isn't for this board's people
   * (R2). Its id is the source board's (R14), so two people landing at once
   * write one card, not two.
   */
  linkBack(e) {
    if (e.id !== this.meta.id) {
      for (const t of this.store.all())
        if (t.type === "note" && t.link && t.link.boardId === e.id) return;
      if (!this.mayLinkBack(e)) {
        this.toast("No link back to " + e.title + " here: it isn't shared with everyone who sees this board");
        return;
      }
      this.addBoardLink({ id: e.id, title: e.title }, void 0, { back: !0, quiet: !0, id: Gie(e.id) }), this.toast("Linked back to " + e.title + ", so you can return to it");
    }
  }
  /**
   * Link cards keep their boards' titles, and say when one has gone or isn't
   * yours to open. Each linked board is looked up on its own (R11: a listing
   * capped at its first page, or kept to one account, took the rest for
   * gone); one that can't be read just now is left as it was.
   */
  async refreshLinks() {
    const e = this.opts.boardLinks, t = Array.from(this.store.all()).filter((a) => a.type === "note" && !!a.link);
    if (!e || !t.length) return;
    const n = Array.from(new Set(t.map((a) => a.link.boardId))), s = /* @__PURE__ */ new Map();
    if (await Promise.all(n.map(async (a) => {
      try {
        s.set(a, await e.get(a));
      } catch {
      }
    })), this.disposed) return;
    const o = /* @__PURE__ */ new Set(), r = [];
    for (const a of t) {
      const l = a.link.boardId;
      if (!s.has(l)) continue;
      const d = s.get(l);
      d ? d.title && d.title !== a.link.title && r.push([a.id, { link: { ...a.link, title: d.title } }]) : o.add(l);
    }
    this.missingBoards.value = o, r.length && this.store.updateMany(r, { history: !1 });
  }
  /**
   * Fold session and chat cards to their title bars, or open them again
   * (ADMIN-002: Blake, to move them out of the way in a busy frame): all of
   * them fold unless every one already is. One Undo step.
   */
  toggleCollapsed(e) {
    const t = e.map((s) => this.store.get(s)).filter((s) => !!s && (s.type === "tool" || s.type === "chat") && !this.isHeld(s));
    if (!t.length) return;
    const n = t.some((s) => !s.collapsed);
    this.store.batch(n ? "Collapse" : "Expand", () => this.store.updateMany(t.map((s) => [s.id, { collapsed: n }])));
  }
  /** Download a result from a gallery's hover: a 3D model's own file (P3-11), else the picture, named as v1 names results. */
  downloadResult(e) {
    const t = e.download || e.videoSrc || e.url;
    this.saveFile(t, e.uuid ? df(e.prompt, e.uuid, t) : e.label || "result"), e.runId && this.trackDownload(e);
  }
  /**
   * An image goes back to the session that made it (its `sessionId`), as that
   * session's reference, and the session opens. An image no session on the
   * board made (an upload, a drop, one whose session was deleted) goes to the
   * session used last.
   */
  useAsReference(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "image") return;
    const n = t;
    let s = this.toolFor(n);
    if (!s) {
      const r = this.ui.recentIds.find((a) => {
        var l;
        return ((l = this.store.get(a)) == null ? void 0 : l.type) === "tool";
      });
      s = r ? this.store.get(r) : null;
    }
    if (!s) {
      this.toast("Add a tool session first, then use this image as its reference.");
      return;
    }
    const o = this.addReference(s.id, n.src, n.asset || null);
    this.openSession(s), o && this.toast("Added as the reference for " + s.name);
  }
  // ---------------------------------------------------------------- the Studios view
  /**
   * Open the Studios view (plans/board-canvas/studios-view.md) on an image,
   * in its own session as Use as reference finds it (an image no session
   * made goes to the session used last); on a session's result; or on a
   * session alone.
   */
  openStudio(e) {
    let t = e.sessionId || null;
    if (e.resultId && !t) {
      const s = this.results.get(e.resultId);
      s && (t = s.sessionId);
    }
    const n = e.elementId ? this.store.get(e.elementId) : void 0;
    if (!(e.elementId && (!n || n.type !== "image"))) {
      if (n && !t) {
        let s = this.toolFor(n);
        if (!s) {
          const o = this.ui.recentIds.find((r) => {
            var a;
            return ((a = this.store.get(r)) == null ? void 0 : a.type) === "tool";
          });
          s = o ? this.store.get(o) : null;
        }
        if (!s) {
          for (const o of this.store.all())
            if (o.type === "tool") {
              s = o;
              break;
            }
        }
        s || (s = this.newImageSession({ x: n.x + n.w + Rt.w / 2 + 48, y: n.y + Math.min(n.h, Rt.h) / 2 })), t = s ? s.id : null;
      }
      if (!t || !this.store.get(t)) {
        this.toast("Add an image session first, then open it in Studio view.");
        return;
      }
      this.ui.infoAt = null, this.ui.addMenu = !1, this.ui.studio = {
        sessionId: t,
        elementId: e.elementId,
        resultId: e.resultId,
        n: (this.ui.studio ? this.ui.studio.n : 0) + 1
      };
    }
  }
  /**
   * Back in the Studios view a refresh left (CHAT-07), once its session's
   * saved draft is in: the view reads the draft's words and pictures as it
   * opens. Opened before, its queue went without the draft's pictures, and
   * the next picture queued saved over them. A draft still waiting for the
   * catalog to read it holds the view up a few seconds at most.
   */
  restoreStudio(e) {
    const t = () => {
      var s;
      this.disposed || this.ui.studio || ((s = this.store.get(e)) == null ? void 0 : s.type) !== "tool" || this.openStudio({ sessionId: e });
    }, n = this.opts.prompts;
    if (!n) {
      t();
      return;
    }
    n.follow(e).catch(() => {
    }).then(() => this.whenDecoded(e, w_)).then(t);
  }
  /** Once a session's saved draft has been read against the catalog (it waits there for its tool's definition), or `ms` at most. */
  whenDecoded(e, t) {
    return this.undecoded.has(e) ? new Promise((n) => {
      let s = !1;
      const o = () => {
        s || (s = !0, r(), clearTimeout(a), n());
      }, r = Ae(() => (this.promptRev.value, this.undecoded.has(e)), (l) => {
        l || o();
      }), a = window.setTimeout(o, t);
    }) : Promise.resolve();
  }
  closeStudio() {
    this.ui.studio = null, this.ui.infoAt = null;
  }
  // ---------------------------------------------------------------- notes
  setNoteText(e, t) {
    const n = this.store.get(e);
    !n || n.text === t || this.patch(e, { text: t }, "Edit note");
  }
  renameFrame(e, t) {
    const n = t.trim() || "Untitled frame";
    this.patch(e, { title: n }, "Rename frame");
  }
  renameTool(e, t) {
    const n = t.trim();
    n && this.patch(e, { name: n }, "Rename session");
  }
  renameBoard(e) {
    const t = e.trim() || "Untitled board";
    t !== this.meta.title && (this.meta.title = t, this.sync.saveMeta({ title: t }), this.opts.onTitle && this.opts.onTitle(t));
  }
  // --------------------------------------------------------------- shapes
  armShape(e) {
    this.ui.eyedropper = null, this.ui.shapeKind = e, this.ui.shapeArmed = !0, this.ui.shapeMenu = !1, this.ui.mode = "select", this.ui.selection = [], this.ui.styleOpen = !1;
  }
  /** Select or Pan (the rail's buttons, V and H): either puts down the shape tool, the eyedropper and the Comment tool (TD-05). */
  setMode(e) {
    this.ui.mode = e, this.ui.shapeArmed = !1, this.ui.eyedropper = null, this.comments.arm(!1);
  }
  /** The last style used becomes the default for the next shape. */
  patchShape(e, t) {
    this.patch(e, t, "Restyle shape"), this.ui.shapeStyle = { ...this.ui.shapeStyle, ...t.stroke ? { stroke: t.stroke } : {}, ...t.sw ? { sw: t.sw } : {} };
  }
  // ----------------------------------------------------------- generation
  modelFor(e) {
    const t = this.catalog.value, n = t.kits.find((a) => a.id === e.kitId) || null, s = n && (n.models.find((a) => !!e.nodeDefId && a.id === e.nodeDefId) || n.models.find((a) => a.name === e.model)) || null;
    if (n && s) return { kit: n, model: s };
    const o = e.nodeDefId && t.byId.get(e.nodeDefId) || t.byName.get(e.model) || null, r = o && _v(t, o, e.kitId) || n || t.kits.find((a) => a.name === e.kind) || t.kits[0] || null;
    return { kit: r, model: o || (r ? Bi(r) : null) };
  }
  /** The first run names the tool after the prompt's opening clause. */
  static conceptName(e) {
    const t = String(e || "").split(/[,.;\n]/)[0].trim().replace(/\s+/g, " ");
    if (!t) return null;
    let n = t.split(" ").slice(0, 4).join(" ");
    return n.length > 30 && (n = n.slice(0, 30).replace(/\s\S*$/, "")), n ? n.charAt(0).toUpperCase() + n.slice(1) : null;
  }
  /** Your run in this session is being sent (a moment; then it's in flight like anyone's). */
  submitting(e) {
    return this.promptRev.value, !!this.generating[e] && this.runs.has(e);
  }
  /**
   * Run a session's tool with your prompt. Answers null when the run went,
   * else why it didn't (also told in a toast): a chat's plan reports it.
   */
  generate(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "tool") return "This session is no longer on the board.";
    if (this.runs.has(e)) return "This session is still sending its last run.";
    const { model: n } = this.modelFor(t);
    if (!n)
      return this.toast("No model is available for this session.", "error"), "No model is available for this session.";
    const s = this.promptOf(e), o = Xi(n, s, this.countFor(n, s), !!this.user.isAdmin), r = this.accountProblem() || o.problems[0] || this.tokensProblem(o.price);
    if (r)
      return this.toast(Ka(r), "error"), Ka(r);
    if (this.opts.runs)
      return this.generateReal(t, n, s), null;
    const a = { ...s.inputs || {} }, l = this.countFor(n, s), d = s.ref ? [s.ref] : [];
    this.generating[e] = !0, this.freshTools.delete(e), t.error && this.store.update(e, { error: null }, { history: !1 });
    const c = this.gen.run({
      sessionId: e,
      model: n,
      prompt: s.prompt || "",
      inputs: a,
      refs: d,
      count: l,
      aspect: a.aspect || void 0,
      author: this.author()
    }, {
      onResult: (h) => {
        this.results.upsert([h]), this.countStubResult(e, h, s.prompt || "");
      },
      onDone: () => {
        this.runs.delete(e), delete this.generating[e];
      },
      onError: (h, f) => {
        this.runs.delete(e), delete this.generating[e], this.results.remove(f.map((p) => p.id)), this.tellRunError(e, h);
      }
    });
    return this.runs.set(e, c), this.results.upsert(c.pending, !1), null;
  }
  /**
   * A real run: images without a record (a picture on the board that isn't a
   * result or an upload) go to your uploads first, then your prompt is saved
   * as your run draft and runRunnitNode runs it. The run, and its results,
   * arrive with the board's runs.
   */
  async generateReal(e, t, n) {
    const s = e.id, o = this.countFor(t, n), r = { runId: "", pending: [], cancel: () => {
    } };
    this.runs.set(s, r), this.generating[s] = !0, this.freshTools.delete(s), e.error && this.store.update(s, { error: null }, { history: !1 });
    const a = (h) => {
      this.disposed || (this.runs.delete(s), this.settleGenerating(s), this.tellRunError(s, h));
    };
    let l = n, d = Eo(t, l);
    if (d.pending.length) {
      let h;
      try {
        h = await this.uploadPending(s, d.pending);
      } catch (p) {
        a(p instanceof Error && p.message || "An image couldn't be uploaded, so the run didn't start.");
        return;
      }
      if (this.disposed) return;
      if (l = { ...n, assets: { ...n.assets || {}, ...h } }, d = Eo(t, l), d.pending.length) {
        a("An image couldn't be uploaded, so the run didn't start.");
        return;
      }
      const f = Xi(t, l, o, !!this.user.isAdmin).problems[0];
      if (f) {
        a(Ka(f));
        return;
      }
    }
    if (this.disposed) return;
    const c = this.gen.run({
      sessionId: s,
      model: t,
      prompt: l.prompt || "",
      inputs: { ...l.inputs || {} },
      refs: l.ref ? [l.ref] : [],
      count: o,
      author: this.author(),
      // with the values the tool sets for itself (a video's length, a forced model)
      v1Inputs: kv(t, d.inputs, l).values
    }, {
      onStarted: (h) => {
        if (this.disposed) return;
        this.runs.delete(s), this.followRun(h, s, o, l.prompt || "");
        const f = t.raw;
        this.track("generation_run", {
          node_def_id: t.id,
          tool_title: t.name,
          app_type: "RUNNIT",
          cost_per_result: f ? f.costPerResult : null,
          runnit_id: this.meta.id,
          is_team_run: !!this.meta.teamId,
          is_first_run: this.firstRunEver()
        });
      },
      onResult: () => {
      },
      onDone: () => {
      },
      onError: (h) => a(h)
    });
    r.cancel = () => c.cancel();
  }
  /**
   * Pictures without a record go to your uploads (as a drop would), so a run
   * can send them. Their records also go into the session's prompt, so the
   * next run doesn't upload them again.
   */
  async uploadPending(e, t) {
    const n = await this.uploadPictures(t);
    return this.disposed || this.setPrompt(e, { assets: n }), n;
  }
  /** Pictures (by URL) into your uploads, for a run to send: each one's record. */
  async uploadPictures(e) {
    if (!this.uploader || !this.uploader.uploadRecord)
      throw new Error("That image can't be sent to a tool from here. Upload it, or use one of your results.");
    const t = {};
    for (const n of e) {
      const s = await fetch(Jie(n), { mode: "cors" }).catch(() => null);
      if (!s || !s.ok) throw new Error("An image couldn't be read, so the run didn't start.");
      const o = await s.blob(), r = (o.type.split("/")[1] || "png").replace("jpeg", "jpg"), a = new File([o], "board-reference." + r, { type: o.type || "image/png" }), l = await this.uploader.uploadRecord(a);
      if (!l.upload) throw new Error("An image couldn't be uploaded, so the run didn't start.");
      t[n] = { upload: l.upload };
    }
    return t;
  }
  /** A stub run's result landed: count it on its session card, as countRun counts a real one. */
  countStubResult(e, t, n) {
    const s = this.store.get(e);
    if (!s) return;
    const o = [t.url].concat(s.thumbs || []).slice(0, 6), r = /^(Image|Video|3D|Upscale) Tool \d+$/.test(s.name || "") && Pf.conceptName(n);
    this.store.update(e, {
      thumbs: o,
      count: (s.count || 0) + 1,
      lastRunAt: Date.now(),
      ...r ? { name: r } : {}
    }, { history: !1 }), this.ui.newThumbs = { ...this.ui.newThumbs, [e]: Math.min(4, (this.ui.newThumbs[e] || 0) + 1) }, clearTimeout(this.newThumbTimers.get(e)), this.newThumbTimers.set(e, window.setTimeout(() => {
      const a = { ...this.ui.newThumbs };
      delete a[e], this.ui.newThumbs = a;
    }, 1400));
  }
  // ---------------------------------------------------------------- the Studios view's runs
  /**
   * A run from the Studios view (IL-045). Its model may not be the session's
   * and its prompt isn't your session prompt, which stays as it was (on a
   * real board, it goes back into your run draft once the run has taken
   * it). Checked as v1's Run button checks a run. An Edit run records the
   * picture it changed, so its results are that picture's next versions.
   * Answers once the run is on its way, with its id, or with why it isn't.
   */
  async runStudio(e) {
    const t = this.store.get(e.sessionId);
    if (!t || t.type !== "tool") return { error: "This session is no longer on the board." };
    const n = Xi(e.model, e.up, e.count, !!this.user.isAdmin), s = this.accountProblem() || n.problems[0] || this.tokensProblem(n.price);
    return s ? { error: Ka(s) } : (this.freshTools.delete(t.id), t.error && this.store.update(t.id, { error: null }, { history: !1 }), this.opts.runs ? this.runStudioReal(t, e) : this.runStudioStub(t, e));
  }
  /** The harness's run: the stub's results, landing on the session card as a real run's do. */
  runStudioStub(e, t) {
    const { model: n, up: s, count: o } = t, r = { ...s.inputs || {} }, a = s.masks ? Object.values(s.masks)[0] : null;
    a && typeof a.boardMask == "string" && (r.__mask = a.boardMask);
    let l = "";
    const d = this.gen.run({
      sessionId: e.id,
      model: n,
      prompt: s.prompt || "",
      inputs: r,
      refs: Sf(n, s),
      count: o,
      aspect: typeof r.aspect == "string" ? r.aspect : void 0,
      author: this.author()
    }, {
      onResult: (c) => {
        this.results.upsert([c]), this.countStubResult(e.id, c, t.words);
      },
      onDone: () => this.markDone(e.id, l),
      onError: (c, h) => {
        this.markDone(e.id, l), this.results.remove(h.map((f) => f.id)), t.onFail && t.onFail(c);
      }
    });
    return l = d.runId, this.results.upsert(d.pending, !1), this.markRunning(e.id, l, Date.now()), this.studioRuns.set(l, t.words), t.edit && this.recordEdit(e.id, l, t.edit), { runId: l };
  }
  /**
   * A real run: pictures without a record go to your uploads first, and so
   * does a generation queued ahead of an upload (an input that takes several
   * sends its uploads first, so the model would get them out of order).
   */
  async runStudioReal(e, t) {
    const { model: n, count: s } = t;
    let o = t.up, r = Eo(n, o);
    const a = Tne(n, o).filter((h) => !r.pending.includes(h)), l = r.pending.concat(a);
    if (l.length) {
      let h;
      try {
        h = await this.uploadPictures(l);
      } catch (p) {
        return { error: p instanceof Error && p.message || "An image couldn't be uploaded, so the run didn't start." };
      }
      if (this.disposed) return { error: "The board was closed, so the run didn't start." };
      if (o = { ...o, assets: { ...o.assets || {}, ...h } }, r = Eo(n, o), r.pending.length) return { error: "An image couldn't be uploaded, so the run didn't start." };
      const f = Xi(n, o, s, !!this.user.isAdmin).problems[0];
      if (f) return { error: Ka(f) };
    }
    const d = this.draftOf(e), c = o.prompt || "";
    return new Promise((h) => {
      let f = !1;
      const p = (v) => {
        f || (f = !0, h(v));
      }, y = window.setTimeout(() => p({ error: "The run is taking a while to start. If it went, its results will appear here." }), jie);
      this.gen.run({
        sessionId: e.id,
        model: n,
        prompt: c,
        inputs: { ...o.inputs || {} },
        refs: Sf(n, o),
        count: s,
        author: this.author(),
        // with the values the tool sets for itself (a video's length, a forced model)
        v1Inputs: kv(n, r.inputs, o).values,
        restore: d
      }, {
        onStarted: (v) => {
          if (clearTimeout(y), this.disposed) return;
          this.studioRuns.set(v, t.words), t.onFail && this.studioFails.set(v, t.onFail), t.edit && this.recordEdit(e.id, v, t.edit), this.followRun(v, e.id, s, c);
          const x = n.raw;
          this.track("generation_run", {
            node_def_id: n.id,
            tool_title: n.name,
            app_type: "RUNNIT",
            cost_per_result: x ? x.costPerResult : null,
            runnit_id: this.meta.id,
            is_team_run: !!this.meta.teamId,
            is_first_run: this.firstRunEver()
          }), p({ runId: v });
        },
        onResult: () => {
        },
        onDone: () => {
        },
        onError: (v) => {
          clearTimeout(y), p({ error: v });
        }
      });
    });
  }
  /** Your session prompt as its run draft keeps it: what a Studios view run puts back. */
  draftOf(e) {
    const { model: t } = this.modelFor(e);
    if (!t) return null;
    const n = this.promptOf(e.id);
    return { nodeDefId: t.id, inputs: Eo(t, n, "draft").inputs, numResults: this.countFor(t, n) };
  }
  /** An Edit run's record: the picture it changed, so its results are that picture's next versions, and what the tool set. */
  recordEdit(e, t, n) {
    this.studioRecords.put({
      ...bl,
      id: Ap(t),
      type: "studio",
      role: "edit",
      sessionId: e,
      runId: t,
      base: n.base,
      studio: n.studio,
      createdAt: Date.now(),
      ...n.settings ? { settings: n.settings } : {},
      ...n.helper ? { helper: !0 } : {},
      ...n.precision ? { precision: n.precision } : {}
    });
  }
  /**
   * An area's mask, as v1's inpainting masks are kept (a runnitMasks record,
   * which a run's picture input carries as its mask): through the host's
   * pipeline, where it has one.
   */
  async uploadMask(e) {
    const t = this.opts.studio && this.opts.studio.uploadMask;
    if (!t) throw new Error("Masks can't be kept from here, so this edit can't run.");
    return t(e);
  }
  /** A real board's runs (runRunnitNode), rather than the harness's stub. */
  get realRuns() {
    return !!this.opts.runs;
  }
  /** Whether marked pictures are flattened by v1's annotation service (real boards), rather than here. */
  get canAnnotate() {
    return !!(this.opts.studio && this.opts.studio.annotate);
  }
  /**
   * A marked picture made one, to send in its place: by v1's annotation
   * service, which scales the overlay to the picture's full size, flattens
   * them and keeps the result in your uploads. A picture without a record
   * goes to your uploads first.
   */
  async flattenPicture(e, t) {
    const n = this.opts.studio && this.opts.studio.annotate;
    if (!n) throw new Error("Annotated pictures can't be sent from here.");
    let s = e.asset;
    const o = !!s && "upload" in s && typeof s.upload.userId == "string" && s.upload.userId !== this.user.uid;
    (!s || o) && (s = (await this.uploadPictures([e.url]))[e.url] || null);
    const r = s ? Sne(s) : null;
    if (!r) throw new Error("This picture can't be annotated for a run. Try one of your results or uploads.");
    const l = { upload: await n(r, t) };
    return { url: this.assetUrl(l), asset: l };
  }
  /** The Studios view's 3D: the host's Babylon, when it lends one. */
  get babylon() {
    return this.opts.studio && this.opts.studio.babylon || null;
  }
  /** A 3D model into your Library, where the host can keep one; null where it can't (the harness). */
  upload3d(e) {
    const t = this.opts.studio && this.opts.studio.upload3d;
    return t ? t(e) : null;
  }
  /**
   * Show another picture in a card's place on the canvas (the Studios view's
   * Promote, IL-045): another version of the same image. The card keeps its
   * place and width; its height follows the new picture's shape. One undo step.
   */
  showOnCard(e, t) {
    const n = this.store.get(e);
    if (!n || n.type !== "image" || !t.w || !t.h) return !1;
    const s = Math.max(1, Math.round(n.w * (t.h / t.w))), o = {
      src: t.url,
      h: s,
      tiers: void 0,
      color: void 0,
      label: t.label || n.label,
      resultId: t.resultId || void 0,
      sessionId: t.sessionId || n.sessionId,
      asset: t.asset || void 0,
      fav: t.fav || void 0,
      video: void 0,
      videoSrc: void 0,
      previewSrc: void 0,
      dur: void 0,
      download: void 0,
      kind: void 0
    };
    return this.patch(e, o, "Show another version"), !0;
  }
  /** Follow a run you started until it's over, and tell you how it went. */
  followRun(e, t, n, s) {
    if (this.onStep) {
      const h = this.store.get(t);
      this.onStep("run", "Ran " + (h && h.type === "tool" ? h.model : "a session") + " for " + n + (n === 1 ? " result" : " results"), "run " + e + ", session " + t);
    }
    const o = this.opts.runs;
    if (!o) return;
    const r = Date.now(), a = [];
    for (let h = 0; h < n; h++)
      a.push({
        id: `${e}:p${h}`,
        sessionId: t,
        runId: e,
        status: "pending",
        url: "",
        w: 0,
        h: 0,
        prompt: s,
        model: "",
        createdAt: r + h,
        startedAt: r,
        userId: this.user.uid
      });
    this.results.replaceRun(e, a), this.markRunning(t, e, r);
    const l = window.setTimeout(() => {
      this.settleStart(e, t).catch(() => {
      });
    }, Hie);
    this.started.set(e, { sessionId: t, unwatch: () => {
    }, timer: l, seen: !1 });
    const d = o.watchRun(e, (h) => {
      h && this.onRun(h);
    }), c = this.started.get(e);
    c ? c.unwatch = d : d();
  }
  /**
   * A run answered success but hasn't shown up. runRunnitNode answers success
   * for a few failures it swallows, and a listener can also miss a run that
   * went (a dropped connection), so the server has the last word: a run's
   * charge is written with its document. There, it's followed as usual; not
   * there, it never started and cost nothing. When the server can't be
   * asked, nobody can say yet, and the board's runs bring it if it went.
   */
  async settleStart(e, t) {
    const n = this.opts.runs, s = this.started.get(e);
    if (!n || !s || s.seen) return;
    let o;
    try {
      o = await n.getRun(e, !0);
    } catch {
      o = void 0;
    }
    const r = this.started.get(e);
    if (this.disposed || !r || r.seen) return;
    if (o) {
      this.onRun(o);
      return;
    }
    this.endFollow(e), this.results.replaceRun(e, []), this.markDone(t, e);
    const a = o === null ? "The run didn't start, so nothing was charged. Please try again." : "We couldn't confirm the run started. If it did, its results will appear here, so wait a moment before running it again.";
    this.tellRunError(t, a);
    const l = this.studioFails.get(e);
    l && (this.studioFails.delete(e), l(a));
  }
  endFollow(e) {
    const t = this.started.get(e);
    t && (t.unwatch(), clearTimeout(t.timer), this.started.delete(e));
  }
  /** A run on this board changed: yours, or anyone's on the team. */
  onRun(e) {
    if (this.disposed) return;
    const t = this.started.get(e.id);
    t && !t.seen && (t.seen = !0, clearTimeout(t.timer));
    const n = lS(e, {
      storageUrl: (s) => this.opts.storageUrl ? this.opts.storageUrl(s) : s,
      modelName: (s) => {
        const o = this.toolModel(s);
        return o ? o.name : "Tool";
      },
      authorName: (s, o) => s === this.user.uid ? this.author() : o ? o.split("@")[0] : "Someone else"
    });
    if (this.results.replaceRun(e.id, n), oS(e.state)) {
      this.markRunning(e.nodeId, e.id, e.initAt || Date.now());
      return;
    }
    this.markDone(e.nodeId, e.id), jW(e.state) && this.finishRun(e, n);
  }
  onRunGone(e) {
    if (!this.started.has(e))
      for (const [t, n] of this.inflight) n.has(e) && this.markDone(t, e);
  }
  markRunning(e, t, n) {
    let s = this.inflight.get(e);
    s || (s = /* @__PURE__ */ new Map(), this.inflight.set(e, s)), s.set(t, n), this.generating[e] = !0, this.runningSince[e] = Math.min(...Array.from(s.values()));
  }
  markDone(e, t) {
    const n = this.inflight.get(e);
    n && (n.delete(t), n.size || this.inflight.delete(e)), this.settleGenerating(e);
  }
  settleGenerating(e) {
    const t = this.inflight.get(e);
    t && t.size ? (this.generating[e] = !0, this.runningSince[e] = Math.min(...Array.from(t.values()))) : this.runs.has(e) || (delete this.generating[e], delete this.runningSince[e]);
  }
  /** A run finished: count it on its session card (once), and tell whoever started it how it went. */
  finishRun(e, t) {
    const n = this.started.has(e.id);
    n && this.endFollow(e.id);
    const s = t.filter((a) => a.status === "done"), o = t.filter((a) => a.status === "moderated").length;
    if (n && this.onStep) {
      const a = e.state === "ERROR" ? "A run failed" : "A run finished with " + s.length + (s.length === 1 ? " result" : " results") + (o ? ", " + o + " withheld" : "");
      this.onStep(e.state === "ERROR" ? "error" : "run", a, "run " + e.id + ", state " + e.state + ", model " + e.nodeDefId);
    }
    const r = this.studioFails.get(e.id);
    r && this.studioFails.delete(e.id), n && (e.state === "ERROR" ? (this.tellRunError(e.nodeId, "The run failed, so its tokens are being refunded. Try again, or try another model."), r && r("The run failed, so its tokens are being refunded. Try again, or try another model.")) : o && this.toast((o === 1 ? "A result was" : o + " results were") + " withheld by the safety check.", "error")), s.length && this.countRun(e, s, n);
  }
  /**
   * A run of yours failed: the card says so (the message in its tooltip),
   * and the session's prompt says why. A toast only when that prompt isn't
   * open, so the same news isn't told twice.
   */
  tellRunError(e, t) {
    this.store.update(e, { error: t }, { history: !1 });
    const n = this.promptTool.value;
    (!n || n.id !== e) && this.toast(t, "error");
  }
  /**
   * Fold a finished run into its session card: the newest thumbnails, the
   * count, when it last ran. Whoever ran it does this; anyone does, for a run
   * left uncounted (its runner closed the board before it finished). `ran`
   * keeps one run from being counted twice.
   */
  countRun(e, t, n) {
    const s = this.store.get(e.nodeId) || null;
    if (!s || s.type !== "tool") return;
    const o = s.ran || [];
    if (o.includes(e.id)) return;
    const r = e.doneAt || e.initAt || Date.now(), a = e.userId === this.user.uid;
    if (s.lastRunAt && r < s.lastRunAt - 1e3 && !n || !a && Date.now() - r < Vie) return;
    const l = t.map((h) => h.url).concat(s.thumbs || []).filter((h, f, p) => !!h && p.indexOf(h) === f).slice(0, 6), d = this.studioRuns.has(e.id) ? this.studioRuns.get(e.id) || "" : t[0].prompt || "", c = n && /^(Image|Video|3D|Upscale|Image Edit|Video Edit) Tool \d+$/.test(s.name || "") && Pf.conceptName(d);
    this.store.update(e.nodeId, {
      thumbs: l,
      count: (s.count || 0) + t.length,
      lastRunAt: Math.max(s.lastRunAt || 0, r),
      ran: [e.id].concat(o).slice(0, 12),
      error: null,
      ...c ? { name: c } : {}
    }, { history: !1 }), n && (this.ui.newThumbs = { ...this.ui.newThumbs, [e.nodeId]: Math.min(4, t.length) }, clearTimeout(this.newThumbTimers.get(e.nodeId)), this.newThumbTimers.set(e.nodeId, window.setTimeout(() => {
      const h = { ...this.ui.newThumbs };
      delete h[e.nodeId], this.ui.newThumbs = h;
    }, 1400)));
  }
  /**
   * A result deleted from its session's history comes off the session's card:
   * one fewer, and its thumbnail gone, the next newest the board holds taking
   * its place. Only a finished result was ever counted (finishRun).
   */
  uncount(e) {
    const t = this.store.get(e.sessionId) || null;
    if (!t || t.type !== "tool" || e.status !== "done") return;
    const n = (t.thumbs || []).filter((o) => o !== e.url), s = this.results.list(e.sessionId).filter((o) => o.status === "done").map((o) => o.url);
    this.store.update(t.id, {
      count: Math.max(0, (t.count || 0) - 1),
      thumbs: n.concat(s).filter((o, r, a) => !!o && a.indexOf(o) === r).slice(0, 6)
    }, { history: !1 });
  }
  /**
   * A session's whole history is in: its card says what that history holds.
   * The count is a tally kept as runs finish (countRun), so a result deleted
   * somewhere else (the Library, v1, another person) or two runs counted at
   * once leaves it off, and this is where it comes right. Only a complete
   * history can say (a long one pages in as its gallery scrolls), and only for
   * a card that has counted real runs: the demo board's seeded cards keep what
   * they were made with.
   */
  recount(e) {
    const t = this.store.get(e) || null;
    if (!t || t.type !== "tool" || !(t.ran && t.ran.length)) return;
    const n = this.results.list(e).filter((a) => a.status === "done"), s = n.map((a) => a.url).filter((a, l, d) => !!a && d.indexOf(a) === l).slice(0, 6), o = t.thumbs || [];
    if ((t.count || 0) === n.length && o.length === s.length && o.every((a, l) => a === s[l])) return;
    const r = n.map((a) => a.runId).filter((a, l, d) => !!a && d.indexOf(a) === l).slice(0, 12);
    this.store.update(e, { count: n.length, thumbs: s, ran: r }, { history: !1 });
  }
  /** A session's past runs, a page at a time (its gallery asks as it scrolls). */
  async loadHistory(e) {
    const t = this.opts.runs;
    if (!t) return;
    const n = this.historyCursor.get(e);
    if (n === "end") return;
    const s = await t.sessionPage(e, n == null ? null : n).catch((r) => (console.warn("[board] session history unavailable", r), null));
    if (!s || this.disposed) return;
    for (const r of s) this.onRun(r);
    const o = s.length ? s[s.length - 1].initAt : null;
    this.historyCursor.set(e, s.length < 24 || o == null ? "end" : o), this.historyCursor.get(e) === "end" && this.recount(e);
  }
  historyDone(e) {
    return this.historyCursor.get(e) === "end" || !this.opts.runs;
  }
  /**
   * The board's history, a page further back: every session's runs, older
   * than the newest the board follows (watchRecent) and what's been paged.
   */
  async loadBoardHistory() {
    const e = this.opts.runs;
    if (!e || this.boardCursor === "end") return;
    const t = 40, n = await e.boardPage(this.boardCursor, t).catch((o) => (console.warn("[board] the board's history unavailable", o), null));
    if (!n || this.disposed) return;
    for (const o of n) this.onRun(o);
    const s = n.length ? n[n.length - 1].initAt : null;
    this.boardCursor = n.length < t || s == null ? "end" : s;
  }
  boardHistoryDone() {
    return this.boardCursor === "end" || !this.opts.runs;
  }
  /** Remix: a fresh session preloaded with the image's prompt and model. */
  remixFrom(e, t) {
    this.ui.infoAt = null;
    const n = this.catalog.value, s = this.remixHome(e, t);
    if (s) return this.remixInSession(s.tool, s.model, e, t);
    const o = t && t.modelId && n.byId.get(t.modelId) || null, r = o && _v(n, o) || n.kits.find((p) => p.id === (e.video ? "video" : "image")) || n.kits[0];
    if (!r) return;
    const a = o || t && r.models.find((p) => p.name === t.model) || r.models[0], l = this.freeSpot(Rt.w, Rt.h), d = {
      id: St(),
      type: "tool",
      x: l.x,
      y: l.y,
      w: Rt.w,
      h: Rt.h,
      z: 0,
      name: this.nextToolName(r.name),
      kind: r.name,
      kitId: r.id,
      model: a.name,
      nodeDefId: a.id,
      icon: Nl[r.id] || "Image",
      count: 0,
      thumbs: [],
      createdBy: this.user.uid
    };
    d.z = this.store.nextZ(d), this.store.add([d]), t && t.runId && this.track("remix_initiated", { node_def_id: t.modelId || null, node_run_id: t.runId, source: "canvas_remix" });
    const c = e.asset || t && t.asset || null, h = t && t.inputs && t.modelId === a.id ? a : null, f = h ? dc(h, t.inputs, (p) => this.assetUrl(p)) : {};
    if (f.inputs)
      for (const p of a.fields) p.kind === "seed" && delete f.inputs[p.key];
    this.setPrompt(d.id, {
      ...f,
      prompt: t ? t.prompt : "",
      ref: e.src,
      n: 1,
      assets: { ...f.assets || {}, ...c ? { [e.src]: c } : {} }
    }), this.ui.selection = [d.id], this.revealNew(d);
  }
  /**
   * The session a picture remixes in (B25): the one on the board that made
   * it, when its kit has the run's model (R6: an Edit tool's upscale, made in
   * an Image session, isn't that session's to run again; it gets a session of
   * its own as before). A picture with no run's model takes its session's.
   */
  remixHome(e, t) {
    const n = t && t.sessionId || e.sessionId || null, s = n ? this.store.get(n) : void 0;
    if (!s || s.type !== "tool" || this.isHeld(s)) return null;
    const o = this.catalog.value.kits.find((a) => a.id === s.kitId);
    if (!o) return null;
    const r = t && t.modelId ? o.models.find((a) => a.id === t.modelId) || null : this.modelFor(s).model;
    return r ? { tool: s, model: r } : null;
  }
  /**
   * A session's saved draft, read (R4): on a real board a session's prompt
   * arrives after the board, so what's changed in it first waits for it,
   * or Undo's copy is the empty default and the change saves over the draft.
   */
  draftReady(e) {
    const t = this.opts.prompts;
    return t ? t.follow(e).catch(() => {
    }).then(() => this.whenDecoded(e, w_)) : Promise.resolve();
  }
  /**
   * Remix a session's own picture in that session: its model and settings
   * back as the run had them (a fresh seed), the picture as the reference,
   * the session opened, once its saved draft is in. Undo puts its prompt and
   * model back.
   */
  async remixInSession(e, t, n, s) {
    await this.draftReady(e.id);
    const o = this.store.get(e.id);
    if (this.disposed || !o || o.type !== "tool") return;
    const r = { up: JSON.parse(JSON.stringify(this.promptOf(o.id))), model: o.model, nodeDefId: o.nodeDefId };
    o.nodeDefId !== t.id && this.patchTool(o.id, { model: t.name, nodeDefId: t.id }), s && s.runId && this.track("remix_initiated", { node_def_id: s.modelId || null, node_run_id: s.runId, source: "canvas_remix" });
    const a = n.asset || s && s.asset || null, l = s && s.inputs && s.modelId === t.id ? t : null, d = l ? dc(l, s.inputs, (c) => this.assetUrl(c)) : {};
    if (d.inputs)
      for (const c of t.fields) c.kind === "seed" && delete d.inputs[c.key];
    this.setPrompt(o.id, {
      ...d,
      prompt: s ? s.prompt : this.promptOf(o.id).prompt || "",
      ref: n.src,
      n: 1,
      assets: { ...d.assets || {}, ...a ? { [n.src]: a } : {} }
    }), this.openSession(this.store.get(o.id)), this.toast("Remix ready in " + o.name + ". Run makes it again.", "info", {
      label: "Undo",
      run: () => {
        const c = this.store.get(o.id);
        c && (c.nodeDefId !== r.nodeDefId && this.patchTool(o.id, { model: r.model, nodeDefId: r.nodeDefId }), this.replacePrompt(o.id, r.up), this.dismissToast());
      }
    });
  }
  /** Placing from the record drops a copy where you are looking. */
  placeCopy(e) {
    this.ui.infoAt = null;
    const t = this.freeSpot(e.w, e.h), n = { ...JSON.parse(JSON.stringify(e)), id: St(), x: t.x, y: t.y };
    n.z = this.store.nextZ(n), this.store.add([n]), this.ui.selection = [n.id], this.revealNew(n);
  }
  placeResult(e, t) {
    if (e.status !== "done" || !e.url) return null;
    const n = __(e.w, e.h);
    return this.placeImages([{
      url: e.url,
      w: n.w,
      h: n.h,
      label: e.label || "result",
      resultId: e.id,
      sessionId: e.sessionId,
      video: e.video,
      dur: e.dur,
      videoSrc: e.videoSrc,
      previewSrc: e.previewSrc,
      asset: e.asset,
      download: e.download,
      kind: e.kind
    }], t)[0] || null;
  }
  /**
   * The record behind a result placed on the board: the board follows only
   * its newest runs (and the galleries' pages), so an older card's run is
   * read when its record is wanted. Null when there's none: deleted from its
   * session's history, or another board's (a pasted card).
   */
  loadRecord(e) {
    const t = this.results.get(e);
    if (t) return Promise.resolve(t);
    const n = this.opts.runs, s = e.split(":")[0];
    if (!n || !s) return Promise.resolve(null);
    let o = this.recordReads.get(s);
    return o || (this.readingRecords[s] = !0, o = n.getRun(s).then((r) => {
      r && r.runnitId === this.meta.id && !r.deletedAt && !this.disposed && this.onRun(r);
    }, (r) => {
      this.recordReads.delete(s), console.warn("[board] a result's record is unavailable", r);
    }).then(() => {
      delete this.readingRecords[s];
    }), this.recordReads.set(s, o)), o.then(() => this.results.get(e) || null);
  }
  /** Whether a result's record is being read (loadRecord). */
  readingRecord(e) {
    return !!this.readingRecords[e.split(":")[0]];
  }
  // ------------------------------------------------------------ recently deleted
  /**
   * Bring elements back from Recently Deleted, where they were (one undo
   * step), unless something has taken their place since: then they go
   * together to the nearest clear spot (CHAT-22). They come back selected.
   */
  recoverDeleted(e) {
    const t = new Map(this.trash.value.map((r) => [r.el.id, r])), n = [], s = [];
    for (const r of e) {
      const a = t.get(r);
      a && (Bs(a.el) ? this.recovering.has(r) || s.push(JSON.parse(JSON.stringify(a.el))) : this.store.get(r) || n.push(JSON.parse(JSON.stringify(a.el))));
    }
    if (!n.length && !s.length) return;
    if (n.length) {
      const r = this.recoverShift(n);
      if (r) for (const a of n)
        a.x += r.x, a.y += r.y;
      this.store.batch("Recover", () => this.store.add(n)), this.ui.selection = n.map((a) => a.id);
    }
    s.length && this.recoverRecords(s);
    const o = n.length + s.length;
    this.toast(o === 1 ? "Recovered 1 item." : "Recovered " + o + " items.");
  }
  /**
   * The Studios view's records Recently Deleted shows (CHAT-14): a deleted
   * result, and a picture brought into a session that's still on the board
   * (deleted with its session, it comes back with it).
   */
  recoverableRecord(e) {
    return e.role === "deleted" ? !0 : e.role === "ref" && !!this.store.get(e.sessionId);
  }
  /**
   * Recovered records: a picture brought in comes back with its marks; a
   * deleted result comes back to its run, and then its marks with it.
   */
  recoverRecords(e) {
    const t = e.filter((n) => n.role === "ref");
    t.length && this.studioRecords.restore([...t, ...this.trashedMarks(t.map((n) => n.id))]);
    for (const n of e) n.role === "deleted" && this.restoreResult(n);
    this.trashRev.value++;
  }
  /** The marks in Recently Deleted drawn on these pictures (StudioItem ids: a reference's, a result's). */
  trashedMarks(e) {
    const t = new Set(e);
    return this.sync.trash().map((n) => n.el).filter((n) => Bs(n) && n.role === "marks" && t.has(n.target));
  }
  /**
   * How far recovered elements move: nowhere while their place is clear,
   * else to freeSpot's nearest clear place for the group's box. Only what
   * sits on the board counts, not frames (things go in them), and a
   * neighbour that merely sits close doesn't move them.
   */
  recoverShift(e) {
    if (!e.filter((r) => r.type !== "frame").map(He).some((r) => this.store.index.query(r).some((a) => {
      const l = this.store.get(a);
      return !!l && l.type !== "frame" && Ya(r, He(l));
    }))) return null;
    const s = uc(e.map(He)), o = this.freeSpot(s.w, s.h, { x: s.x + s.w / 2, y: s.y + s.h / 2 });
    return { x: o.x - s.x, y: o.y - s.y };
  }
  /**
   * What was deleted for good elsewhere (another tab's Delete for good, or its
   * 90 days) leaves this tab's Undo too: put back, it would return without the
   * comment threads deleted with it. What Undo would bring back that's neither
   * on the board nor in Recently Deleted any more is gone for good.
   */
  forgetPurged() {
    const e = new Set(this.sync.trash().map((n) => n.el.id)), t = this.store.restorableIds().filter((n) => !e.has(n) && !this.store.get(n));
    t.length && this.store.forget(t);
  }
  /** Delete elements in Recently Deleted for good: they can't be recovered after this. */
  purgeDeleted(e) {
    const t = new Set(this.trash.value.map((l) => l.el.id)), n = e.filter((l) => this.recovering.has(l));
    n.length && this.toast(n.length === 1 ? "That picture is still being recovered." : "Those pictures are still being recovered.");
    const s = e.filter((l) => t.has(l) && !this.recovering.has(l));
    if (!s.length) return;
    const o = s.length, r = new Set(this.trash.value.filter((l) => s.includes(l.el.id) && l.el.type === "tool").map((l) => l.el.id));
    if (r.size) {
      const l = this.studioRecords.all().filter((c) => r.has(c.sessionId)).map((c) => c.id), d = this.sync.trash().filter((c) => Bs(c.el) && r.has(c.el.sessionId)).map((c) => c.el.id);
      this.studioRecords.remove(l), s.push(...l, ...d);
    }
    const a = [];
    for (const l of this.trash.value)
      !s.includes(l.el.id) || !Bs(l.el) || (l.el.role === "ref" ? a.push(l.el.id) : l.el.role === "deleted" && a.push(l.el.result.id));
    a.length && s.push(...this.trashedMarks(a).map((l) => l.id)), this.sync.purge(s), this.store.forget(s), this.comments.deleteWith(s), this.trashRev.value++, this.toast(o === 1 ? "Deleted 1 item for good." : "Deleted " + o + " items for good.");
  }
  // ---------------------------------------------------------------- pinned pictures
  /** Whether you've pinned this picture to the board. */
  isPinnedImage(e) {
    return !!e && this.pinnedUrls.value.has(e);
  }
  /**
   * Pin a picture to the board, or unpin it. Pins are yours, on this board,
   * kept with the board so they follow you to any device. An unpinned one is
   * gone at once (its records wait where deleted records do, never shown).
   */
  togglePinImage(e) {
    if (!e.url) return !1;
    if (this.isPinnedImage(e.url)) {
      const n = this.studioRecords.all().filter((s) => s.role === "pin" && s.createdBy === this.user.uid && s.url === e.url).map((s) => s.id);
      return this.studioRecords.remove(n), !1;
    }
    e.asset && this.rememberAsset(e.url, e.asset);
    const t = {
      ...bl,
      id: St(),
      type: "studio",
      role: "pin",
      sessionId: "",
      createdAt: Date.now(),
      createdBy: this.user.uid,
      url: e.url,
      pw: e.w || 4,
      ph: e.h || 3,
      label: (e.label || "Image").slice(0, 80),
      asset: e.asset || null,
      resultId: e.resultId || null,
      fromSession: e.sessionId || null,
      video: !!e.video,
      videoSrc: e.videoSrc || null,
      dur: e.dur || null
    };
    return this.studioRecords.put(t), this.prefs.pinHintSeen || (this.prefs.pinHintSeen = !0, this.persistPrefs(), this.toast(Xn.first)), !0;
  }
  /** The placed card for a result, if any. */
  placedFor(e) {
    for (const t of this.store.all()) if (t.type === "image" && t.resultId === e) return t;
    return null;
  }
  /**
   * A star. On a real board it's yours, v1's favorite (the Library lists
   * it), and only your own finished results take one; in the harness it's
   * the card's. The image's result follows along in onDocChange there (so
   * undo and redo do too).
   */
  toggleFav(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "image") return;
    if (this.opts.favorites) {
      const s = t.resultId && this.results.get(t.resultId) || null;
      s ? this.toggleResultFav(s) : t.resultId && this.opts.runs ? this.loadRecord(t.resultId).then((o) => {
        o ? this.toggleResultFav(o) : this.toast("Only generated results can be favorited.");
      }) : this.toast("Only generated results can be favorited.");
      return;
    }
    const n = !t.fav;
    this.patch(e, { fav: n || void 0 }, n ? "Favourite" : "Unfavourite");
  }
  isFav(e, t) {
    const n = this.opts.favorites;
    return n ? (n.uuids.value, !!(e && n.has(e.uuid))) : !!(t && t.fav || e && e.fav);
  }
  /** Whether the star is yours to set: on a real board, your own finished results only (v1's rule). */
  canFav(e, t) {
    const n = this.opts.favorites;
    return n ? !!e && n.canStar(e) : !!(t || e);
  }
  async toggleResultFav(e) {
    const t = this.opts.favorites;
    if (!t) {
      this.results.upsert([{ ...e, fav: !e.fav || void 0 }]);
      return;
    }
    if (!t.canStar(e)) {
      this.toast("Only the person who ran it can favorite a result.");
      return;
    }
    try {
      const n = !t.has(e.uuid);
      await t.set(e, n), n && this.track("result_favorited", this.resultEvent(e));
    } catch (n) {
      console.error("[board] favorite not saved", n), this.toast("The favorite couldn't be saved.", "error");
    }
  }
  /**
   * Why no run can go on this board, whatever its form and price: its team
   * is deactivated. The board and its results stay; new runs don't. Empty
   * when runs can go, and while the team's state is unknown (the server
   * decides then, and says so when it refuses).
   */
  accountProblem() {
    return !this.meta.teamId || this.teamActive.value !== !1 ? "" : "This " + this.labels.team + " is deactivated, so it can't run new generations.";
  }
  /** the board menu offers Take the tour (IL-095) where the host has it */
  get canOpenTour() {
    return !!this.opts.onOpenTour;
  }
  openTour() {
    this.opts.onOpenTour && this.opts.onOpenTour();
  }
  /**
   * Whether you may get more tokens for the account that pays for this board
   * (N5, Decision 3): on a personal board, yours, always; on a team board,
   * only with the host's say (MANAGE_COMPANY). Everyone else is pointed at an admin.
   */
  get canBuyTokens() {
    return this.tokenAccessRev.value, !this.meta.teamId || !this.opts.canBuyTokens ? !0 : this.opts.canBuyTokens(this.meta.teamId);
  }
  /** The host's say on who may buy tokens changed (its role loaded, or you switched team). */
  refreshTokenAccess() {
    this.tokenAccessRev.value++;
  }
  get canGetTokens() {
    return !!this.opts.onGetTokens && this.canBuyTokens;
  }
  /** Where someone who can't buy tokens for this board's {Team} gets more. */
  tokensAsk() {
    const e = this.labels.team;
    return "Ask " + (/^[aeiou]/i.test(e) ? "an " : "a ") + e + " admin for more tokens";
  }
  /**
   * The token chip's tooltip: whose tokens pay (the board's owner: its
   * {Team}, or you), and how to get more (N5).
   */
  tokensTitle() {
    if (!this.meta.teamId) return "Your tokens pay for runs on this board." + (this.opts.onGetTokens ? " Click to get more" : "");
    const e = this.labels.team.toLowerCase(), t = this.teamName.value, n = t ? t + "’s tokens (the " + e + " that owns this board)" : "the tokens of the " + e + " that owns this board", s = this.canGetTokens ? " Click to get more" : this.opts.onGetTokens ? " " + this.tokensAsk() : "";
    return "Runs on this board are paid from " + n + "." + s;
  }
  /** Open the plan of the account that pays for this board, to get more tokens; or say who can. */
  getTokens() {
    if (this.opts.onGetTokens) {
      if (!this.canBuyTokens) {
        this.toast(this.tokensAsk() + ".");
        return;
      }
      this.opts.onGetTokens(this.meta.teamId || null);
    }
  }
  /** Tell the host's analytics (v1's events and property names), marked as a canvas board's. */
  track(e, t) {
    if (this.opts.track)
      try {
        this.opts.track(e, { ...t, board_type: "CANVAS" });
      } catch (n) {
        console.warn("[board] analytics", n);
      }
  }
  /** A result's identity for analytics, as v1 names it. */
  resultEvent(e) {
    return { result_type: e.kind === "video" ? "VID" : e.kind === "3d" ? "ASSET_3D" : "IMG", node_run_id: e.runId || null, node_def_id: e.modelId || null, runnit_id: this.meta.id };
  }
  /** v1's "first run ever" for analytics: once per person, in this browser. */
  firstRunEver() {
    const e = "rd_has_generated_" + this.user.uid;
    try {
      return window.localStorage.getItem(e) ? !1 : (window.localStorage.setItem(e, "1"), !0);
    } catch {
      return !1;
    }
  }
  /** A result was downloaded (the info view's Download). */
  trackDownload(e) {
    const t = this.resultEvent(e);
    this.track("image_downloaded", { result_type: t.result_type, node_run_id: t.node_run_id, node_def_id: t.node_def_id, bulk: !1 });
  }
  /**
   * Why a run of this price (hundredths) can't go for want of tokens, as
   * v1's Run button says it; empty when it can. Only a personal account is
   * held to its balance here: some teams may run below zero, which only the
   * server knows, and it says so when it refuses.
   */
  tokensProblem(e) {
    const t = this.balance.value;
    return !t || t.team || e == null || e <= t.tokens ? "" : "Not enough tokens: this run costs " + El(e) + " and you have " + El(Math.max(0, t.tokens));
  }
  /**
   * Your trained models a model field can use on this board: on a team
   * board yours in the team and its shared ones, else your own. Empty in the
   * harness, which has none.
   */
  async trainedModels() {
    const e = this.opts.models;
    if (!e) return [];
    const t = await e.list(this.meta.teamId || null);
    return this.trainedModelsSeen.value = t, t;
  }
  /** The picture of a model chosen for a field (it carries its avatar, as v1 keeps it): small, and full. */
  modelPicture(e) {
    const t = this.opts.storageUrl, n = e && typeof e == "object" ? e.avatar : null;
    if (!t || !n || typeof n != "object") return null;
    const s = rS(n);
    return { thumb: t(s.thumb), image: t(s.file) };
  }
  /** Whether you can delete a result from its session's history: your own, as v1 allows. */
  canDelete(e) {
    return !!(this.opts.runs && e && e.runId && e.uuid && e.userId === this.user.uid && e.status !== "pending");
  }
  /**
   * Delete a result from its session's history (v1 marks it deleted in its
   * run), and take it off its session's card.
   */
  async deleteResult(e) {
    const t = this.opts.runs;
    if (!t || !e.runId || !e.uuid) return !1;
    try {
      await t.deleteResult(e.runId, e.uuid, this.user.uid);
    } catch (n) {
      return console.error("[board] result not deleted", n), this.toast("That result couldn't be deleted.", "error"), !1;
    }
    return this.ui.infoAt === "result:" + e.id && (this.ui.infoAt = null), this.results.remove([e.id]), this.historyCursor.get(e.sessionId) === "end" ? this.recount(e.sessionId) : this.uncount(e), this.binResult(e), !0;
  }
  /**
   * A deleted result waits in Recently Deleted (CHAT-14): its record is
   * written straight there, with the result as it was, so Recover can take
   * the delete back.
   */
  binResult(e) {
    const t = {
      ...bl,
      id: wne(e.id),
      type: "studio",
      role: "deleted",
      sessionId: e.sessionId,
      createdAt: Date.now(),
      createdBy: this.user.uid,
      result: JSON.parse(JSON.stringify(e))
    };
    this.studioRecords.put(t), this.studioRecords.remove([t.id]), this.trashRev.value++, this.toast(e.video ? "Video deleted. It waits in Recently Deleted." : "Picture deleted. It waits in Recently Deleted.");
  }
  /** A recovered result: back on its run, in its session's history, and counted. */
  async restoreResult(e) {
    const t = e.result, n = this.opts.runs;
    if (n && this.realRuns && t.runId && t.uuid) {
      this.recovering.add(e.id);
      try {
        await n.restoreResult(t.runId, t.uuid);
      } catch (o) {
        return console.error("[board] result not recovered", o), this.toast("That picture couldn't be recovered.", "error"), !1;
      } finally {
        this.recovering.delete(e.id);
      }
    }
    const s = this.trashedMarks([t.id]);
    return s.length && this.studioRecords.restore(s), this.results.upsert([t]), this.historyCursor.get(t.sessionId) === "end" ? this.recount(t.sessionId) : this.countBack(t), this.sync.purge([e.id]), this.trashRev.value++, !0;
  }
  /** uncount's other way: one more on the session's card, its picture among the thumbnails. */
  countBack(e) {
    const t = this.store.get(e.sessionId) || null;
    if (!t || t.type !== "tool" || e.status !== "done") return;
    const n = (t.thumbs || []).concat(e.url).filter((s, o, r) => !!s && r.indexOf(s) === o).slice(0, 6);
    this.store.update(t.id, { count: (t.count || 0) + 1, thumbs: n }, { history: !1 });
  }
  /**
   * Save a file under a name. The file is fetched first: a download link to
   * another origin (Storage, the CDN) ignores the name it's given.
   */
  async saveFile(e, t) {
    try {
      const n = await fetch(e, { mode: "cors" });
      if (!n.ok) throw new Error("HTTP " + n.status);
      const s = URL.createObjectURL(await n.blob()), o = document.createElement("a");
      o.href = s, o.download = t, document.body.appendChild(o), o.click(), o.remove(), window.setTimeout(() => URL.revokeObjectURL(s), 1e4);
    } catch (n) {
      console.warn("[board] download fell back to opening the file", n), window.open(e, "_blank", "noopener");
    }
  }
  // ------------------------------------------------------------ clipboard
  copy(e = !1) {
    const t = this.ui.selection.map((o) => this.store.get(o)).filter(Boolean);
    if (!t.length) return;
    const n = new Set(t.map((o) => o.id));
    for (const o of t) if (o.type === "frame") for (const r of this.carriedBy(o)) n.add(r);
    const s = Array.from(n).map((o) => this.store.get(o)).filter(Boolean);
    wr = { els: JSON.parse(JSON.stringify(s)), board: this.meta.id }, this.pasteCount = 0;
    try {
      navigator.clipboard.writeText(JSON.stringify({ rdBoard: 1, board: wr.board, els: wr.els })).catch(() => {
      });
    } catch {
    }
    e && this.deleteIds(this.ui.selection.slice());
  }
  /**
   * `fromBoard`: the board the system clipboard's copy came from, where it
   * says. Copied on this board with the originals in view, each paste steps
   * down and right; anything else (another board's, or this board's from out
   * of view) lands in the middle of the view (IL-100: on another board, an
   * empty one above all, it landed where it had been, often out of sight).
   */
  paste(e, t) {
    const n = e || (wr ? wr.els : null);
    if (!n || !n.length) return;
    const s = e ? t : wr ? wr.board : null, o = s == null || s === this.meta.id;
    this.pasteCount++;
    let r = 1 / 0, a = 1 / 0, l = -1 / 0, d = -1 / 0;
    for (const w of n) {
      const S = He(w);
      r = Math.min(r, S.x), a = Math.min(a, S.y), l = Math.max(l, S.x + S.w), d = Math.max(d, S.y + S.h);
    }
    const c = { x: r, y: a, w: l - r, h: d - a }, h = this.viewportCentre(), f = Math.round(h.x - (c.x + c.w / 2)), p = Math.round(h.y - (c.y + c.h / 2)), y = o && this.engine ? this.engine.isInView({ ...n[0] }) : !1, v = y ? 28 * this.pasteCount : 0, x = n.map((w, S) => {
      const M = JSON.parse(JSON.stringify(w));
      return M.id = St(), M.x = y ? w.x + v : w.x + f, M.y = y ? w.y + v : w.y + p, M.type === "frame" && delete M.locked, M.z = this.store.nextZ(M, M.type === "frame") + S, M;
    });
    this.store.batch("Paste", () => this.store.add(x)), this.ui.selection = x.filter((w) => w.type !== "frame" || x.length === 1).map((w) => w.id);
  }
  childrenOf(e) {
    const t = [];
    for (const n of this.store.query(He(e))) {
      if (n.id === e.id || n.type === "frame") continue;
      const s = He(n), o = s.x + s.w / 2, r = s.y + s.h / 2;
      o > e.x && o < e.x + e.w && r > e.y && r < e.y + e.h && t.push(n.id);
    }
    return t;
  }
  /**
   * The frame that holds something (CHAT-54): of the frames round its centre,
   * the innermost (the smallest; the higher one on a tie), as a chat picks its
   * frame. One frame each, so two overlapping frames never both carry a card
   * (Adam: "both of these frames control this 3D image"). A frame is held by a
   * bigger one round its centre: nested frames ride with their parent.
   */
  ownerFrame(e) {
    const t = He(e), n = t.x + t.w / 2, s = t.y + t.h / 2, o = e.type === "frame" ? t.w * t.h : 0;
    let r = null;
    for (const a of this.store.query({ x: n - 1, y: s - 1, w: 2, h: 2 })) {
      if (a.type !== "frame" || a.id === e.id || !(n > a.x && n < a.x + a.w && s > a.y && s < a.y + a.h)) continue;
      const l = a.w * a.h;
      l <= o || (!r || l < r.w * r.h || l === r.w * r.h && a.z > r.z) && (r = a);
    }
    return r;
  }
  /**
   * Frames grow to fit the pictures dropped into them (B4: Blake's smart,
   * responsive frames): a picture whose frame (ownerFrame) doesn't hold all of
   * it, with its padding, widens or lengthens that frame on whichever side it
   * hangs over, and a frame it pushes past its own parent grows that one too.
   * Never smaller, and never a locked frame. In the caller's undo step.
   */
  growFramesFor(e, t) {
    const n = In, s = /* @__PURE__ */ new Map(), o = (r, a) => {
      if (Ro(r)) return;
      const l = s.get(r.id) || He(r), d = Math.min(l.x, a.x - n), c = Math.min(l.y, a.y - n), h = Math.max(l.x + l.w, a.x + a.w + n), f = Math.max(l.y + l.h, a.y + a.h + n);
      if (d === l.x && c === l.y && h === l.x + l.w && f === l.y + l.h) return;
      const p = { x: Math.round(d), y: Math.round(c), w: Math.round(h - d), h: Math.round(f - c) };
      s.set(r.id, p);
      const y = this.ownerFrame(r);
      y && o(y, p);
    };
    for (const r of e) {
      const a = this.store.get(r);
      if (!a || a.type !== "image") continue;
      const l = t && t.get(r) ? this.store.get(t.get(r)) : void 0, d = l && l.type === "frame" ? l : this.ownerFrame(a);
      d && o(d, He(a));
    }
    s.size && this.store.updateMany(Array.from(s, ([r, a]) => [r, { x: a.x, y: a.y, w: a.w, h: a.h }]));
  }
  /**
   * What goes with a frame when it moves, is copied or lines up: what it holds
   * itself (ownerFrame), and the frames nested in it with what they hold.
   */
  carriedBy(e) {
    const t = [], n = /* @__PURE__ */ new Set([e.id]), s = (o) => {
      for (const r of this.store.query(He(o))) {
        if (n.has(r.id)) continue;
        const a = this.ownerFrame(r);
        !a || a.id !== o.id || (n.add(r.id), t.push(r.id), r.type === "frame" && s(r));
      }
    };
    return s(e), t;
  }
  /** The locked frame something sits in: its own frame, or one that frame sits in, if any is locked. */
  lockedFrameOf(e) {
    let t = this.ownerFrame(e);
    for (let n = 0; t && n < 32; n++) {
      if (t.locked) return t;
      t = this.ownerFrame(t);
    }
    return null;
  }
  /**
   * Stays where it is: a locked frame (IL-070), or what one holds (B31).
   * Held things can still be selected, opened, restacked and commented on;
   * they can't be moved, resized or deleted until the frame is unlocked.
   */
  isHeld(e) {
    return !!e && (Ro(e) || !!this.lockedFrameOf(e));
  }
  frameFor(e) {
    const t = He(e);
    let n = null;
    for (const s of this.store.query(t))
      s.type === "frame" && t.x >= s.x && t.y >= s.y && t.x < s.x + s.w && t.y < s.y + s.h && (!n || s.z > n.z) && (n = s);
    return n;
  }
  /** The session that made an image: its record, else the tool in its frame. */
  toolFor(e) {
    if (e.sessionId) {
      const n = this.store.get(e.sessionId);
      if (n && n.type === "tool") return n;
    }
    const t = this.frameFor(e);
    if (!t) return null;
    for (const n of this.store.query(He(t)))
      if (n.type === "tool" && n.x >= t.x && n.y >= t.y && n.x < t.x + t.w && n.y < t.y + t.h) return n;
    return null;
  }
  // --------------------------------------------------------------- history
  undo() {
    this.store.undo();
  }
  redo() {
    this.store.redo();
  }
  /** The arrow keys: the selection, a frame with what it holds; a locked frame and what it holds stay. */
  nudge(e, t) {
    const n = this.ui.selection.filter((r) => !this.isHeld(this.store.get(r)));
    if (!n.length) return;
    const s = new Set(n);
    for (const r of n) {
      const a = this.store.get(r);
      if (a && a.type === "frame")
        for (const l of this.carriedBy(a)) this.isHeld(this.store.get(l)) || s.add(l);
    }
    const o = [];
    for (const r of s) {
      const a = this.store.get(r);
      a && o.push([r, { x: a.x + e, y: a.y + t }]);
    }
    this.store.batch("Nudge", () => this.store.updateMany(o));
  }
  // ----------------------------------------------------------------- misc
  toast(e, t = "info", n) {
    const s = ++this.toastSeq;
    this.ui.toast = { id: s, text: e, tone: t, action: n }, clearTimeout(this.toastTimer);
    const o = t === "error" || e.length > 70 ? Math.max(5200, Math.min(1e4, 1800 + e.length * 45)) : n ? 6e3 : 3200;
    this.toastTimer = window.setTimeout(() => {
      this.ui.toast && this.ui.toast.id === s && (this.ui.toast = null);
    }, o);
  }
  dismissToast() {
    clearTimeout(this.toastTimer), this.ui.toast = null;
  }
  /** When you last looked at Board history here, or null before you ever have on this board (CHAT-46). */
  get historySeenAt() {
    return typeof this.prefs.histSeenAt == "number" ? this.prefs.histSeenAt : null;
  }
  /** Board history seen up to `at`: kept for the next visit. */
  markHistorySeen(e) {
    this.prefs.histSeenAt != null && e <= this.prefs.histSeenAt || (this.prefs.histSeenAt = e, this.persistPrefs());
  }
  persistPrefs() {
    this.prefs.lightCanvas = this.ui.lightCanvas, this.prefs.showGrid = this.ui.showGrid, this.prefs.shapeStyle = { ...this.ui.shapeStyle }, this.prefs.shapeKind = this.ui.shapeKind, this.prefs.histOpen = this.ui.histOpen, this.prefs.miniOpen = this.ui.miniOpen, this.prefs.recentIds = this.ui.recentIds.slice(0, 200), this.prefs.pinnedIds = this.ui.pinnedIds.slice(), this.prefs.pinnedModelIds = this.ui.pinnedModelIds.slice(), this.prefs.cameraViews = this.ui.cameraViews.map((e) => ({ ...e })), this.prefs.noteTint = this.ui.noteTint, this.prefs.promptH = this.ui.promptH, this.prefs.library = { tab: this.ui.library.tab, category: this.ui.library.category, saveBoard: this.ui.library.saveLevels.board, saveTeam: this.ui.library.saveLevels.team }, zte(this.user.uid, this.meta.id, this.prefs);
  }
  /**
   * The board's sessions as the session lists show them: pinned ones first,
   * in the order pinned (Tyler, 2026-10-14: pinned sessions "stay at the
   * top"), then the most recently touched, then the rest by newest placement.
   */
  recentTools() {
    this.docRev.value;
    const e = [];
    for (const r of this.store.all()) r.type === "tool" && e.push(r);
    const t = new Map(e.map((r) => [r.id, r])), n = this.ui.pinnedIds.filter((r) => t.has(r)).map((r) => t.get(r)), s = this.ui.recentIds.filter((r) => t.has(r) && !this.ui.pinnedIds.includes(r)).map((r) => t.get(r)), o = e.filter((r) => !this.ui.recentIds.includes(r.id) && !this.ui.pinnedIds.includes(r.id)).sort((r, a) => (a.lastRunAt || a.z) - (r.lastRunAt || r.z));
    return n.concat(s, o);
  }
  /** A session pinned to the top of the session lists (yours, on this board). */
  isPinned(e) {
    return this.ui.pinnedIds.includes(e);
  }
  /** Pin a session to the top of the session lists, after those pinned before it; or unpin it. */
  togglePinned(e) {
    const t = this.store.get(e);
    if (!t || t.type !== "tool") return;
    const n = !this.isPinned(e);
    this.ui.pinnedIds = n ? [...this.ui.pinnedIds, e] : this.ui.pinnedIds.filter((s) => s !== e), this.persistPrefs(), this.savePin("sessions", e, n);
  }
  /** A model pinned to the top of the model menus (yours, on every board). */
  isModelPinned(e) {
    return this.ui.pinnedModelIds.includes(e);
  }
  /**
   * Pin a model to the top of the model menus, after those pinned before it;
   * or unpin it. Only a model in the catalog can be pinned; one that has left
   * it can still be unpinned.
   */
  toggleModelPinned(e) {
    const t = !this.isModelPinned(e);
    t && !this.catalog.value.byId.has(e) || (this.ui.pinnedModelIds = t ? [...this.ui.pinnedModelIds, e] : this.ui.pinnedModelIds.filter((n) => n !== e), this.persistPrefs(), this.savePin("models", e, t));
  }
  /**
   * A pin list as your account has it (IL-068), from any device: it replaces
   * this browser's, which keeps a copy for the next open. An account with
   * none saved yet takes this browser's, on its first answer only: later, no
   * list means no pins (a refused first pin comes back that way).
   */
  pinsFromAccount(e, t) {
    const n = this.pinsKept[e] === "unknown";
    this.pinsKept[e] = "yes";
    const s = e === "models" ? this.ui.pinnedModelIds : this.ui.pinnedIds;
    if (t === null && n) {
      s.length && this.opts.pins && this.opts.pins.seed(e, s.slice()).catch((o) => console.warn("[board] your pins could not be saved to your account", o));
      return;
    }
    t === null && (t = []), !(t.length === s.length && t.every((o, r) => o === s[r])) && (e === "models" ? this.ui.pinnedModelIds = t.slice() : this.ui.pinnedIds = t.slice(), this.persistPrefs());
  }
  /** A pin or unpin, sent to your account where it keeps them; a refusal comes back as its pins, undoing this one. */
  savePin(e, t, n) {
    const s = this.opts.pins;
    !s || this.pinsKept[e] === "off" || s.pin(e, t, n).catch((o) => {
      console.warn("[board] pin not saved to your account", o), this.toast(n ? "Your pin couldn't be saved. Please try again." : "Your pin couldn't be removed. Please try again.", "error");
    });
  }
  // ---------------------------------------------------------------- your camera views (IL-077)
  /**
   * Save a camera view from Change camera, by name: yours alone, on every
   * board. The newest goes last. Null when you already keep the most.
   */
  saveCameraView(e, t) {
    if (this.ui.cameraViews.length >= Tf)
      return this.toast("You can keep up to " + Tf + " camera views. Remove one first."), null;
    const n = { id: St(), name: T_(t) || "Camera view", ...ro(e), createdAt: Date.now() };
    return this.ui.cameraViews = [...this.ui.cameraViews, n], this.keepViews(), n;
  }
  renameCameraView(e, t) {
    const n = T_(t), s = this.ui.cameraViews.find((o) => o.id === e);
    !s || !n || n === s.name || (this.ui.cameraViews = this.ui.cameraViews.map((o) => o.id === e ? { ...o, name: n } : o), this.keepViews());
  }
  removeCameraView(e) {
    this.ui.cameraViews.some((t) => t.id === e) && (this.ui.cameraViews = this.ui.cameraViews.filter((t) => t.id !== e), this.keepViews());
  }
  /**
   * Your views as your account has them, from any device: they replace this
   * browser's. An account with none yet takes this browser's, on its first
   * answer only, as your pins do.
   */
  viewsFromAccount(e) {
    if (this.viewsKept === "off") return;
    const t = this.viewsKept === "unknown";
    if (this.viewsKept = "yes", e === null && t) {
      this.ui.cameraViews.length && this.opts.pins && this.opts.pins.saveViews && this.opts.pins.saveViews(this.ui.cameraViews.map((s) => ({ ...s }))).catch((s) => {
        console.warn("[board] your camera views could not be saved to your account", s), this.viewsKept = "off";
      });
      return;
    }
    const n = M_(e || []);
    JSON.stringify(n) !== JSON.stringify(this.ui.cameraViews) && (this.ui.cameraViews = n, this.persistPrefs());
  }
  /** Your views, kept here and sent to your account where it keeps them. */
  keepViews() {
    this.persistPrefs();
    const e = this.opts.pins;
    !e || !e.saveViews || this.viewsKept === "off" || e.saveViews(this.ui.cameraViews.map((t) => ({ ...t }))).catch((t) => {
      console.warn("[board] camera views not saved to your account", t), this.toast("Your camera views are kept in this browser only for now.", "error"), this.viewsKept = "off";
    });
  }
  /** A model list as the model menus show it: your pinned models first, in the order pinned, then the rest in their own order. */
  pinnedModelsFirst(e) {
    const t = this.ui.pinnedModelIds;
    if (!t.length) return e;
    const n = e.filter((s) => t.includes(s.id)).sort((s, o) => t.indexOf(s.id) - t.indexOf(o.id));
    return n.length ? n.concat(e.filter((s) => !t.includes(s.id))) : e;
  }
  /** Images in board order, for the info modal's previous / next. */
  imagesInOrder() {
    const e = [];
    for (const t of this.store.all()) t.type === "image" && e.push(t);
    return e.sort((t, n) => t.z - n.z);
  }
  /** World rect of the selection, or null. */
  selectionRect() {
    return this.store.bounds(this.ui.selection);
  }
  zoomAroundPoint(e, t, n) {
    this.engine && this.engine.zoomAt(e - this.view.left, t - this.view.top, n);
  }
  setCamera(e) {
    this.engine && this.engine.setCamera({ ...e, zoom: tr(e.zoom) });
  }
}
const Xie = 24;
function __(i, e, t = 360) {
  return !i || !e ? Uy("4:3") : i >= e ? { w: t, h: Math.round(t * e / i) } : { w: Math.round(t * i / e), h: t };
}
function S_(i, e) {
  const t = (n) => n === "note" || n === "tool" || n === "chat" ? "dom" : n;
  return t(i.type) === t(e.type);
}
function Jie(i) {
  return /^(blob|data):/.test(i) ? i : i + (i.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1";
}
function M_(i) {
  return Array.isArray(i) ? i.map(zne).filter((e) => !!e).slice(0, Tf) : [];
}
function T_(i) {
  return i.replace(/\s+/g, " ").trim().slice(0, Vy);
}
const Zie = { class: "rd-head" }, Qie = { class: "rd-mark" }, ese = { class: "rd-titles" }, tse = {
  key: 0,
  class: "rd-head-acts"
}, nse = {
  key: 0,
  class: "rd-empty",
  "data-testid": "trash-empty"
}, ise = { class: "rd-empty-mark" }, sse = { class: "rd-group-head" }, ose = {
  class: "rd-avatar",
  "aria-hidden": "true"
}, rse = { class: "rd-who" }, ase = ["title"], lse = { key: 0 }, dse = { class: "rd-when" }, cse = ["title"], use = { class: "rd-group-acts" }, hse = ["onClick"], pse = ["onClick", "onBlur"], fse = ["data-id"], mse = ["src"], gse = {
  key: 0,
  class: "rd-play",
  "aria-hidden": "true"
}, bse = ["src"], vse = {
  key: 0,
  class: "rd-play",
  "aria-hidden": "true"
}, yse = {
  key: 3,
  class: "rd-frame"
}, xse = {
  key: 4,
  class: "rd-shape",
  viewBox: "0 0 100 100",
  "aria-hidden": "true"
}, wse = ["stroke"], kse = ["stroke"], _se = ["stroke"], Sse = {
  key: 0,
  d: "M58 24 H78 V44"
}, Mse = {
  key: 5,
  class: "rd-tool"
}, Tse = { class: "rd-item-acts" }, Cse = ["onClick"], Ise = ["title", "aria-label", "onClick", "onBlur"], Ase = { class: "rd-item-name" }, Pse = ["title"], Ese = ["onClick"], Rse = 24, zse = /* @__PURE__ */ Pe({
  __name: "RecentlyDeleted",
  setup(i) {
    const { board: e } = Ze(), t = /* @__PURE__ */ K(null), n = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K([]), o = I(() => {
      const M = [], _ = /* @__PURE__ */ new Map();
      for (const T of e.trash.value) {
        const k = T.deletedAt + ":" + (T.deletedBy || "");
        let P = _.get(k);
        P || (P = { key: k, at: T.deletedAt, email: T.deletedByEmail || "", mine: !!T.deletedBy && T.deletedBy === e.user.uid, items: [], due: T.hardDeleteAt }, _.set(k, P), M.push(P)), P.items.push(T), T.hardDeleteAt < P.due && (P.due = T.hardDeleteAt);
      }
      return M;
    }), r = I(() => e.trash.value.length), a = I(() => e.trash.value.map((M) => M.el.id)), l = {
      rect: { label: "Rectangle", icon: "Square" },
      ellipse: { label: "Ellipse", icon: "Circle" },
      line: { label: "Line", icon: "Slash" },
      arrow: { label: "Arrow", icon: "ArrowUpRight" }
    };
    function d(M) {
      const _ = M.el;
      if (!Bs(_)) return null;
      if (_.role === "deleted") {
        const T = _.result;
        return { url: T.thumb || T.url, video: !!T.video, label: T.label || (T.video ? "Video" : "Image") };
      }
      return _.role === "ref" ? { url: _.url, video: !1, label: _.label || "Image" } : null;
    }
    function c(M) {
      const _ = M.el, T = d(M);
      return T ? T.video ? { one: "video", many: "videos", icon: "Video" } : { one: "image", many: "images", icon: "Image" } : _.type === "image" ? _.video ? { one: "video", many: "videos", icon: "Video" } : { one: "image", many: "images", icon: "Image" } : _.type === "note" ? { one: "note", many: "notes", icon: "StickyNote" } : _.type === "chat" ? { one: "chat", many: "chats", icon: "MessagesSquare" } : _.type === "frame" ? { one: "frame", many: "frames", icon: "Frame" } : _.type === "shape" ? { one: "shape", many: "shapes", icon: (l[_.shape] || l.rect).icon } : { one: "tool session", many: "tool sessions", icon: Nl[_.kitId] || "Image" };
    }
    function h(M) {
      const _ = M.el, T = d(M);
      if (T) return T.label;
      if (_.type === "image") return _.label || (_.video ? "Video" : "Image");
      if (_.type === "note") {
        const k = (_.text || "").replace(/\s+/g, " ").trim();
        return k ? k.length > 60 ? k.slice(0, 60) + "…" : k : "Empty note";
      }
      return _.type === "frame" ? _.title || "Frame" : _.type === "chat" ? _.name || "Chat" : _.type === "shape" ? (l[_.shape] || l.rect).label : _.name || "Tool session";
    }
    function f(M) {
      const _ = /* @__PURE__ */ new Map();
      for (const T of M.items) {
        const k = c(T), P = _.get(k.one) || { n: 0, one: k.one, many: k.many };
        P.n++, _.set(k.one, P);
      }
      return Array.from(_.values()).map((T) => T.n + " " + (T.n === 1 ? T.one : T.many)).join(", ");
    }
    function p(M) {
      return s.value.includes(M.key) ? M.items : M.items.slice(0, Rse);
    }
    function y(M) {
      return new Date(M).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    }
    function v(M) {
      n.value = null, e.recoverDeleted(M);
    }
    function x(M, _) {
      if (n.value !== M) {
        n.value = M;
        return;
      }
      n.value = null, e.purgeDeleted(_);
    }
    function w() {
      e.ui.trashOpen = !1;
    }
    let S = null;
    return ot(() => {
      S = document.activeElement, t.value && t.value.focus({ preventScroll: !0 });
    }), We(() => {
      S && document.contains(S) && S.focus({ preventScroll: !0 });
    }), (M, _) => (g(), b("div", {
      class: "rd",
      "data-testid": "trash",
      onPointerdown: Se(w, ["self"]),
      onWheel: _[4] || (_[4] = Se(() => {
      }, ["stop"]))
    }, [
      u("div", {
        ref_key: "card",
        ref: t,
        class: "rd-card",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "rd-title",
        tabindex: "-1",
        onPointerdown: _[3] || (_[3] = Se(() => {
        }, ["stop"]))
      }, [
        u("header", Zie, [
          u("span", Qie, [
            C($, {
              name: "Trash2",
              size: 17
            })
          ]),
          u("div", ese, [
            _[5] || (_[5] = u("h2", { id: "rd-title" }, "Recently Deleted", -1)),
            u("p", null, "Deleted items stay here for " + E(m(Rv)) + " days, then they're deleted for good.", 1)
          ]),
          r.value ? (g(), b("div", tse, [
            u("button", {
              class: "rd-btn",
              "data-testid": "trash-recover-all",
              onClick: _[0] || (_[0] = (T) => v(a.value))
            }, [
              C($, {
                name: "RotateCcw",
                size: 13
              }),
              _[6] || (_[6] = J("Recover all ", -1))
            ]),
            u("button", {
              class: G(["rd-btn is-danger", { "is-confirming": n.value === "all" }]),
              "data-testid": "trash-delete-all",
              onClick: _[1] || (_[1] = (T) => x("all", a.value)),
              onBlur: _[2] || (_[2] = (T) => n.value === "all" && (n.value = null))
            }, [
              C($, {
                name: n.value === "all" ? "Check" : "Trash2",
                size: 13
              }, null, 8, ["name"]),
              J(E(n.value === "all" ? "Delete all for good?" : "Delete all"), 1)
            ], 34)
          ])) : z("", !0),
          u("button", {
            class: "rd-close",
            title: "Close",
            "aria-label": "Close",
            "data-testid": "trash-close",
            onClick: w
          }, [
            C($, {
              name: "X",
              size: 15
            })
          ])
        ]),
        r.value ? (g(), Ce(Xp, {
          key: 1,
          tag: "div",
          name: "rd-pop",
          class: "rd-groups"
        }, {
          default: Xe(() => [
            (g(!0), b(j, null, be(o.value, (T) => (g(), b("section", {
              key: T.key,
              class: "rd-group",
              "data-testid": "trash-group"
            }, [
              u("header", sse, [
                u("span", ose, E(T.mine && m(e).user.initials ? m(e).user.initials : m(ma)(T.email || "Someone")), 1),
                u("div", rse, [
                  u("span", {
                    class: "rd-email",
                    title: T.email,
                    "data-testid": "trash-deleted-by"
                  }, [
                    J(E(T.email || "Someone"), 1),
                    T.mine ? (g(), b("em", lse, "you")) : z("", !0)
                  ], 8, ase),
                  u("span", dse, "Deleted " + E(m(Zp)(T.at)) + " · " + E(f(T)), 1)
                ]),
                u("span", {
                  class: "rd-left",
                  title: "Deleted for good on " + y(T.due)
                }, [
                  C($, {
                    name: "Clock",
                    size: 12
                  }),
                  J(E(m(ML)(T.due)), 1)
                ], 8, cse),
                u("div", use, [
                  u("button", {
                    class: "rd-btn",
                    "data-testid": "trash-group-recover",
                    onClick: (k) => v(T.items.map((P) => P.el.id))
                  }, [
                    C($, {
                      name: "RotateCcw",
                      size: 13
                    }),
                    _[8] || (_[8] = J("Recover ", -1))
                  ], 8, hse),
                  u("button", {
                    class: G(["rd-btn is-danger", { "is-confirming": n.value === T.key }]),
                    "data-testid": "trash-group-delete",
                    onClick: (k) => x(T.key, T.items.map((P) => P.el.id)),
                    onBlur: (k) => n.value === T.key && (n.value = null)
                  }, [
                    C($, {
                      name: n.value === T.key ? "Check" : "Trash2",
                      size: 13
                    }, null, 8, ["name"]),
                    J(E(n.value === T.key ? "Delete for good?" : "Delete"), 1)
                  ], 42, pse)
                ])
              ]),
              C(Xp, {
                tag: "div",
                name: "rd-pop",
                class: "rd-grid"
              }, {
                default: Xe(() => [
                  (g(!0), b(j, null, be(p(T), (k) => (g(), b("div", {
                    key: k.el.id,
                    class: "rd-item",
                    "data-id": k.el.id,
                    "data-testid": "trash-item"
                  }, [
                    u("div", {
                      class: G(["rd-thumb", "is-" + k.el.type])
                    }, [
                      k.el.type === "image" ? (g(), b(j, { key: 0 }, [
                        u("img", {
                          src: m(Bt)(k.el.src),
                          alt: "",
                          loading: "lazy",
                          draggable: "false"
                        }, null, 8, mse),
                        k.el.video ? (g(), b("span", gse, [
                          C($, {
                            name: "Play",
                            size: 14
                          })
                        ])) : z("", !0)
                      ], 64)) : d(k) ? (g(), b(j, { key: 1 }, [
                        u("img", {
                          src: m(Bt)(d(k).url),
                          alt: "",
                          loading: "lazy",
                          draggable: "false"
                        }, null, 8, bse),
                        d(k).video ? (g(), b("span", vse, [
                          C($, {
                            name: "Play",
                            size: 14
                          })
                        ])) : z("", !0)
                      ], 64)) : k.el.type === "note" ? (g(), b("div", {
                        key: 2,
                        class: G(["rd-note", "tint-" + k.el.tint])
                      }, [
                        u("span", null, E(k.el.text || ""), 1)
                      ], 2)) : k.el.type === "frame" ? (g(), b("div", yse, [
                        u("span", null, E(k.el.title || "Frame"), 1)
                      ])) : k.el.type === "shape" ? (g(), b("svg", xse, [
                        k.el.shape === "rect" ? (g(), b("rect", {
                          key: 0,
                          x: "18",
                          y: "28",
                          width: "64",
                          height: "44",
                          rx: "5",
                          stroke: k.el.stroke
                        }, null, 8, wse)) : k.el.shape === "ellipse" ? (g(), b("ellipse", {
                          key: 1,
                          cx: "50",
                          cy: "50",
                          rx: "33",
                          ry: "23",
                          stroke: k.el.stroke
                        }, null, 8, kse)) : (g(), b("g", {
                          key: 2,
                          stroke: k.el.stroke
                        }, [
                          _[9] || (_[9] = u("line", {
                            x1: "22",
                            y1: "76",
                            x2: "78",
                            y2: "24"
                          }, null, -1)),
                          k.el.shape === "arrow" ? (g(), b("path", Sse)) : z("", !0)
                        ], 8, _se))
                      ])) : (g(), b("span", Mse, [
                        C($, {
                          name: c(k).icon,
                          size: 22
                        }, null, 8, ["name"])
                      ])),
                      u("div", Tse, [
                        u("button", {
                          title: "Recover",
                          "aria-label": "Recover",
                          "data-testid": "trash-item-recover",
                          onClick: (P) => v([k.el.id])
                        }, [
                          C($, {
                            name: "RotateCcw",
                            size: 14
                          })
                        ], 8, Cse),
                        u("button", {
                          class: G(["is-danger", { "is-confirming": n.value === k.el.id }]),
                          title: n.value === k.el.id ? "Click again to delete it for good" : "Delete for good",
                          "aria-label": n.value === k.el.id ? "Click again to delete it for good" : "Delete for good",
                          "data-testid": "trash-item-delete",
                          onClick: (P) => x(k.el.id, [k.el.id]),
                          onBlur: (P) => n.value === k.el.id && (n.value = null)
                        }, [
                          C($, {
                            name: n.value === k.el.id ? "Check" : "Trash2",
                            size: 14
                          }, null, 8, ["name"])
                        ], 42, Ise)
                      ])
                    ], 2),
                    u("div", Ase, [
                      C($, {
                        name: c(k).icon,
                        size: 12
                      }, null, 8, ["name"]),
                      u("span", {
                        title: h(k)
                      }, E(h(k)), 9, Pse)
                    ])
                  ], 8, fse))), 128)),
                  T.items.length > p(T).length ? (g(), b("button", {
                    key: "more",
                    class: "rd-more",
                    "data-testid": "trash-more",
                    onClick: (k) => s.value = s.value.concat(T.key)
                  }, " +" + E(T.items.length - p(T).length) + " more ", 9, Ese)) : z("", !0)
                ]),
                _: 2
              }, 1024)
            ]))), 128))
          ]),
          _: 1
        })) : (g(), b("div", nse, [
          u("span", ise, [
            C($, {
              name: "Trash2",
              size: 22
            })
          ]),
          _[7] || (_[7] = u("h3", null, "Nothing deleted lately", -1)),
          u("p", null, "Images, notes, frames and shapes deleted from this board wait here for " + E(m(Rv)) + " days, so they can be recovered.", 1)
        ]))
      ], 544)
    ], 32));
  }
}), $se = {
  class: "bd-stats",
  "data-testid": "stats"
}, Dse = { key: 1 }, Ose = /* @__PURE__ */ Pe({
  __name: "StatsOverlay",
  setup(i) {
    const { board: e } = Ze(), t = I(() => e.stats.value), n = I(() => e.overlayIds.value.length);
    return (s, o) => (g(), b("div", $se, [
      t.value ? (g(), b(j, { key: 0 }, [
        u("b", {
          class: G({ warn: t.value.fps < 55, bad: t.value.fps < 40 })
        }, E(t.value.fps) + " fps", 3),
        u("span", null, E(t.value.frameMs) + " ms/frame", 1),
        u("span", null, E(m(e).store.size) + " elements · " + E(t.value.images) + " images", 1),
        u("span", null, E(t.value.visible) + " culled-in · " + E(n.value) + " DOM", 1),
        u("span", null, E(t.value.textures) + " textures · " + E(t.value.textureMB) + " MB", 1),
        u("span", null, E(t.value.pending) + " loading", 1)
      ], 64)) : (g(), b("span", Dse, "measuring…"))
    ]));
  }
}), Lse = ["aria-label"], oI = /* @__PURE__ */ Pe({
  __name: "StackBadge",
  props: {
    top: {},
    ids: {}
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = D8(t);
    return (s, o) => (g(), b("button", {
      type: "button",
      class: G(["cv-stack-badge", { "is-open": m(n).s.top === e.top }]),
      "aria-label": e.ids.length + " cards stacked here: show them",
      "data-testid": "stack-badge",
      onPointerdown: o[0] || (o[0] = Se(() => {
      }, ["stop"])),
      onMouseenter: o[1] || (o[1] = (r) => m(n).open(e.top, e.ids)),
      onMouseleave: o[2] || (o[2] = (r) => m(n).leave()),
      onClick: o[3] || (o[3] = Se((r) => m(n).open(e.top, e.ids), ["stop"]))
    }, [
      C($, {
        name: "Layers",
        size: 11,
        stroke: 2.2
      }),
      J(E(e.ids.length), 1)
    ], 42, Lse));
  }
}), Bse = ["data-el", "data-ref-session"], Fse = { class: "cv-bucket-head" }, Nse = { class: "cv-badge" }, Use = { class: "cv-bucket-titles" }, Gse = { class: "cv-bucket-kind" }, jse = ["title"], Hse = ["value"], Vse = ["title"], Wse = ["title", "aria-label", "aria-expanded", "disabled"], qse = ["title"], Kse = ["title"], Yse = {
  key: 2,
  class: "cv-count"
}, Xse = {
  key: 0,
  class: "cv-bucket-thumbs"
}, Jse = ["data-testid", "onPointerdown"], Zse = {
  key: 1,
  class: "cv-bucket-foot"
}, Qse = ["title"], eoe = { key: 1 }, toe = /* @__PURE__ */ Pe({
  __name: "ToolCard",
  props: {
    id: {},
    enter: { type: Boolean },
    delay: {},
    stack: {}
  },
  setup(i) {
    const e = i, { board: t, input: n } = Ze(), s = as(() => e.id), o = I(() => t.ui.selection.includes(e.id)), r = I(() => o.value && t.ui.selection.length === 1), a = I(() => (t.docRev.value, t.isHeld(s.value))), l = I(() => !!t.generating[e.id]), d = I(() => t.ui.newThumbs[e.id] || 0), c = I(() => s.value && s.value.scale || 1), h = I(() => !!(s.value && s.value.collapsed)), f = I(() => h.value ? Nc : Rt.h), p = I(() => s.value ? (s.value.thumbs || []).slice(0, 4) : []), y = I(() => Math.max(0, 4 - p.value.length)), v = dr(), x = I(() => {
      const te = s.value;
      if (!te) return "";
      if (l.value) {
        const ee = t.runningSince[e.id];
        return ee ? "Generating… " + C1(v.value - ee) : "Generating…";
      }
      return te.lastRunAt ? "Updated " + Jn(te.lastRunAt) : te.count ? "Ready" : "No runs yet";
    }), w = /* @__PURE__ */ K(!1), S = /* @__PURE__ */ K(null);
    function M() {
      w.value = !0, nt(() => {
        S.value && (S.value.focus({ preventScroll: !0 }), S.value.select());
      });
    }
    function _(te) {
      if (!w.value) return;
      const ee = S.value ? S.value.value : "";
      w.value = !1, te && s.value && t.renameTool(e.id, ee);
    }
    function T(te) {
      !s.value || w.value || n.elementDown(t.store.get(e.id), te);
    }
    function k(te) {
      const ee = t.store.get(e.id);
      !ee || w.value || n.elementDown(ee, te, { onClick: () => P() });
    }
    function P() {
      const te = t.store.get(e.id);
      te && te.type === "tool" && t.showSession(te);
    }
    function A(te) {
      te.detail === 0 && P();
    }
    function R(te) {
      const ee = te.target;
      w.value || ee && ee.closest(".cv-thumb, input, textarea") || P();
    }
    function D(te, ee) {
      const me = s.value;
      if (!me || ee.button === 2) return;
      ee.stopPropagation();
      const L = t.results.list(e.id).find((B) => B.url === te) || null;
      if (t.ui.eyedropper) {
        ee.preventDefault(), t.eyedrop(te, L && L.asset || t.assetFor(te), !!(L && L.video));
        return;
      }
      const N = L && L.w ? Math.max(200, Math.min(360, L.w)) : 300, X = L && L.w ? Math.round(N * L.h / L.w) : 200;
      n.dragResultOut({ url: te, w: N, h: X, result: L, sessionId: me.id, label: L ? L.label : void 0 }, ee, {
        slop: 5,
        onClick: () => O(te, L)
      });
    }
    function O(te, ee) {
      const me = ee ? t.placedFor(ee.id) : null;
      if (ee && me) {
        t.ui.infoSession = ee.sessionId, t.ui.infoAt = me.id;
        return;
      }
      if (ee && ee.status === "done") {
        t.ui.infoSession = ee.sessionId, t.ui.infoAt = "result:" + ee.id;
        return;
      }
      const L = t.imagesInOrder().find((N) => N.src === te);
      L && (t.ui.infoAt = L.id);
    }
    function F(te) {
      const ee = t.store.get(e.id);
      ee && n.resizeDown(ee, te);
    }
    return (te, ee) => m(s) ? (g(), b("div", {
      key: 0,
      class: G(["cv-el is-tool", { "is-selected": o.value, "is-open": r.value, "cv-enter": i.enter, "is-ref-target": m(t).ui.refSession === i.id, "is-stack-top": !!i.stack, "is-stack-deep": !!i.stack && i.stack.length > 2, "is-folded": h.value }]),
      style: ce({
        left: m(s).x + "px",
        top: m(s).y + "px",
        width: m(Rt).w * c.value + "px",
        height: f.value * c.value + "px",
        zIndex: Math.round(m(s).z) + 10,
        "--d": (i.delay || 0) + "s"
      }),
      "data-el": i.id,
      "data-ref-session": i.id,
      onPointerdown: T,
      onDblclick: Se(R, ["stop"])
    }, [
      u("div", {
        class: "cv-el-body",
        style: ce(c.value !== 1 ? { transform: "scale(" + c.value + ")", transformOrigin: "0 0", width: m(Rt).w + "px", height: f.value + "px" } : void 0)
      }, [
        u("div", {
          class: G(["cv-bucket style-strip", { "is-busy": l.value }])
        }, [
          u("div", Fse, [
            u("span", Nse, [
              C($, {
                name: m(s).icon,
                size: 17
              }, null, 8, ["name"])
            ]),
            u("span", Use, [
              u("span", Gse, [
                J(E(m(s).kind) + " ", 1),
                m(s).model ? (g(), b(j, { key: 0 }, [
                  ee[7] || (ee[7] = u("span", { class: "cv-bucket-sep" }, "·", -1)),
                  u("span", {
                    class: "cv-bucket-model",
                    title: "Model: " + m(s).model
                  }, E(m(s).model), 9, jse)
                ], 64)) : z("", !0)
              ]),
              w.value ? (g(), b("input", {
                key: 0,
                ref_key: "nameInput",
                ref: S,
                class: "cv-bucket-name-input",
                value: m(s).name,
                spellcheck: "false",
                onPointerdown: ee[0] || (ee[0] = Se(() => {
                }, ["stop"])),
                onKeydown: [
                  ee[1] || (ee[1] = tn(Se((me) => _(!0), ["prevent"]), ["enter"])),
                  ee[2] || (ee[2] = tn(Se((me) => _(!1), ["stop", "prevent"]), ["esc"]))
                ],
                onBlur: ee[3] || (ee[3] = (me) => _(!0))
              }, null, 40, Hse)) : (g(), b("div", {
                key: 1,
                class: "cv-bucket-name",
                title: m(s).name,
                onDblclick: Se(M, ["stop"])
              }, E(m(s).name), 41, Vse))
            ]),
            u("button", {
              type: "button",
              class: "cv-fold",
              title: h.value ? "Expand" : "Collapse to its title",
              "aria-label": h.value ? "Expand" : "Collapse to its title",
              "aria-expanded": !h.value,
              disabled: a.value,
              "data-testid": "card-fold",
              onPointerdown: ee[4] || (ee[4] = Se(() => {
              }, ["stop"])),
              onDblclick: ee[5] || (ee[5] = Se(() => {
              }, ["stop"])),
              onClick: ee[6] || (ee[6] = Se((me) => m(t).toggleCollapsed([i.id]), ["stop"]))
            }, [
              C($, {
                name: h.value ? "ChevronDown" : "ChevronUp",
                size: 14
              }, null, 8, ["name"])
            ], 40, Wse),
            h.value && l.value ? (g(), b("span", {
              key: 0,
              class: "cv-count is-state",
              title: x.value
            }, [
              C($, {
                name: "Loader2",
                size: 11,
                spin: ""
              })
            ], 8, qse)) : h.value && m(s).error ? (g(), b("span", {
              key: 1,
              class: "cv-count is-state is-error",
              title: m(s).error
            }, [
              C($, {
                name: "AlertCircle",
                size: 11
              })
            ], 8, Kse)) : (g(), b("span", Yse, E(m(s).count), 1))
          ]),
          h.value ? z("", !0) : (g(), b("div", Xse, [
            l.value ? (g(), b(j, { key: 0 }, [
              (g(!0), b(j, null, be(p.value, (me, L) => (g(), b("div", {
                key: "s" + L,
                class: "cv-thumb thumb-shimmer",
                style: ce({ backgroundImage: 'url("' + m(Bt)(me) + '")' })
              }, null, 4))), 128)),
              (g(!0), b(j, null, be(y.value, (me) => (g(), b("div", {
                key: "se" + me,
                class: "cv-thumb-empty thumb-shimmer"
              }))), 128))
            ], 64)) : (g(), b(j, { key: 1 }, [
              (g(!0), b(j, null, be(p.value, (me, L) => (g(), b("div", {
                key: m(s).id + "-" + me + "-" + L,
                class: G(["cv-thumb cv-thumb-pull", { "thumb-new": L < d.value }]),
                style: ce({ backgroundImage: 'url("' + m(Bt)(me) + '")', "--d": L < d.value ? L * 0.07 + "s" : void 0 }),
                title: "Click to view. Drag onto the board to place it.",
                "data-testid": "session-thumb-" + L,
                onPointerdown: (N) => D(me, N)
              }, null, 46, Jse))), 128)),
              (g(!0), b(j, null, be(y.value, (me) => (g(), b("div", {
                key: "e" + me,
                class: "cv-thumb-empty is-open",
                title: "Open this session",
                "data-testid": "session-slot",
                onPointerdown: k
              }, null, 32))), 128))
            ], 64))
          ])),
          h.value ? z("", !0) : (g(), b("div", Zse, [
            m(s).error && !l.value ? (g(), b("span", {
              key: 0,
              class: "is-error",
              title: m(s).error
            }, [
              C($, {
                name: "AlertCircle",
                size: 11
              }),
              ee[8] || (ee[8] = J(" Run failed", -1))
            ], 8, Qse)) : (g(), b("span", eoe, E(x.value), 1)),
            r.value ? z("", !0) : (g(), b("button", {
              key: 2,
              type: "button",
              class: "cv-bucket-open-hint",
              "data-testid": "session-open",
              onPointerdown: k,
              onClick: Se(A, ["stop"])
            }, [
              ee[9] || (ee[9] = J("Open ", -1)),
              C($, {
                name: "ChevronRight",
                size: 11
              })
            ], 32))
          ])),
          ee[10] || (ee[10] = u("span", { class: "cv-ring" }, null, -1))
        ], 2)
      ], 4),
      r.value && !a.value && !h.value ? (g(), b("span", {
        key: 0,
        class: "cv-resize",
        title: "Resize",
        onPointerdown: F
      }, null, 32)) : z("", !0),
      i.stack ? (g(), Ce(oI, {
        key: 1,
        top: i.id,
        ids: i.stack
      }, null, 8, ["top", "ids"])) : z("", !0)
    ], 46, Bse)) : z("", !0);
  }
}), noe = ["data-el"], ioe = {
  key: 0,
  class: "cv-el-body"
}, soe = { class: "cv-link-head" }, ooe = { class: "ic" }, roe = { class: "kind" }, aoe = ["title"], loe = { class: "cv-link-foot" }, doe = {
  key: 0,
  class: "miss"
}, coe = {
  key: 1,
  class: "cv-el-body"
}, uoe = { class: "cv-note-meta" }, hoe = /* @__PURE__ */ Pe({
  __name: "NoteCard",
  props: {
    id: {},
    enter: { type: Boolean },
    delay: {}
  },
  setup(i) {
    const e = i, { board: t, input: n } = Ze(), s = as(() => e.id), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ Xt({ above: !1, below: !1 });
    function l() {
      const D = f.value ? o.value : r.value;
      a.above = !!D && D.scrollTop > 0, a.below = !!D && D.scrollTop + D.clientHeight < D.scrollHeight - 1;
    }
    const d = I(() => t.ui.selection.includes(e.id)), c = I(() => d.value && t.ui.selection.length === 1), h = I(() => (t.docRev.value, t.isHeld(s.value))), f = I(() => t.ui.editingNote === e.id), p = I(() => s.value && s.value.link || null), y = I(() => !!p.value && t.missingBoards.value.has(p.value.boardId));
    let v = "", x = 0, w = 0;
    function S() {
      if (clearTimeout(w), !o.value) return;
      const D = o.value.innerText.replace(/\n$/, ""), O = t.store.get(e.id);
      O && O.text !== D && t.store.update(e.id, { text: D }, { history: !1 });
    }
    function M() {
      clearTimeout(w), w = window.setTimeout(S, 350), _(), l();
    }
    function _() {
      const D = o.value, O = s.value;
      if (!D || !O || !O.grow || h.value) return;
      const F = D.scrollHeight - D.clientHeight;
      F > 0 && t.store.update(e.id, { h: O.h + F }, { history: !1 });
    }
    Ae(f, (D) => {
      if (!D) {
        nt(l);
        return;
      }
      v = s.value && s.value.text || "", x = s.value && s.value.h || 0, nt(() => {
        const O = o.value;
        if (!O) return;
        O.innerText = s.value && s.value.text || "", O.focus({ preventScroll: !0 });
        const F = document.createRange();
        F.selectNodeContents(O), F.collapse(!1);
        const te = window.getSelection();
        te && (te.removeAllRanges(), te.addRange(F)), l();
      });
    }, { immediate: !0 }), Ae(() => s.value && [s.value.text, s.value.w, s.value.h], () => nt(l)), ot(l);
    function T(D) {
      if (f.value) {
        D.stopPropagation();
        return;
      }
      const O = t.store.get(e.id);
      O && n.elementDown(O, D);
    }
    function k() {
      t.editNote(e.id);
    }
    function P() {
      if (!f.value || !o.value) return;
      S();
      const D = o.value.innerText.replace(/\n$/, "");
      n.commitNote(e.id, D);
      const O = s.value && s.value.h || x, F = O !== x ? { h: x } : {};
      t.store.recordEdit("Edit note", e.id, { text: v, ...F }, { text: D, ...O !== x ? { h: O } : {} });
    }
    We(() => {
      f.value && S(), clearTimeout(w);
    });
    function A(D) {
      D.key === "Escape" && (D.preventDefault(), D.stopPropagation(), D.target.blur());
    }
    function R(D) {
      const O = t.store.get(e.id);
      O && n.resizeDown(O, D);
    }
    return (D, O) => m(s) ? (g(), b("div", {
      key: 0,
      class: G(["cv-el is-note", { "is-selected": d.value, "cv-enter": i.enter }]),
      style: ce({ left: m(s).x + "px", top: m(s).y + "px", width: m(s).w + "px", height: m(s).h + "px", zIndex: Math.round(m(s).z) + 10, "--d": (i.delay || 0) + "s" }),
      "data-el": i.id,
      onPointerdown: T
    }, [
      p.value ? (g(), b("div", ioe, [
        u("div", {
          class: G(["cv-note cv-link", ["tint-" + (m(s).tint || "vista"), { "is-missing": y.value }]]),
          "data-testid": "board-link",
          onDblclick: O[2] || (O[2] = Se((F) => m(t).openBoardLink(i.id), ["stop"]))
        }, [
          u("div", soe, [
            u("span", ooe, [
              C($, {
                name: "Link2",
                size: 13
              })
            ]),
            u("span", roe, E(p.value.back ? "Back to" : "Linked board"), 1)
          ]),
          u("div", {
            class: "cv-link-title",
            title: p.value.title
          }, E(p.value.title), 9, aoe),
          u("div", loe, [
            y.value ? (g(), b("span", doe, "Not found, or you can't open it")) : (g(), b("button", {
              key: 1,
              type: "button",
              class: "cv-link-open",
              "data-testid": "board-link-open",
              onPointerdown: O[0] || (O[0] = Se(() => {
              }, ["stop"])),
              onClick: O[1] || (O[1] = Se((F) => m(t).openBoardLink(i.id), ["stop"]))
            }, [
              O[4] || (O[4] = J(" Open board ", -1)),
              C($, {
                name: "ArrowUpRight",
                size: 12
              })
            ], 32))
          ]),
          O[5] || (O[5] = u("span", { class: "cv-ring" }, null, -1))
        ], 34)
      ])) : (g(), b("div", coe, [
        u("div", {
          class: G(["cv-note", ["tint-" + (m(s).tint || "glass"), { "is-editing": f.value, "more-above": a.above, "more-below": a.below }]]),
          onDblclick: Se(k, ["stop"])
        }, [
          f.value ? (g(), b("div", {
            key: 1,
            ref_key: "textEl",
            ref: o,
            class: "cv-note-text",
            contenteditable: "plaintext-only",
            spellcheck: "false",
            "data-placeholder": "Type a note…",
            onBlur: P,
            onInput: M,
            onKeydown: A,
            onScroll: l,
            onPointerdown: O[3] || (O[3] = Se(() => {
            }, ["stop"]))
          }, null, 544)) : (g(), b("div", {
            key: 0,
            ref_key: "viewEl",
            ref: r,
            class: "cv-note-text",
            "data-placeholder": "Double-click to write",
            onScroll: l
          }, E(m(s).text), 545)),
          u("div", uoe, E(m(s).author || "You"), 1),
          O[6] || (O[6] = u("span", { class: "cv-ring" }, null, -1))
        ], 34)
      ])),
      c.value && !f.value && !h.value && !p.value ? (g(), b("span", {
        key: 2,
        class: "cv-resize",
        title: "Resize",
        onPointerdown: R
      }, null, 32)) : z("", !0)
    ], 46, noe)) : z("", !0);
  }
}), poe = ["data-el"], foe = { class: "cv-el-body" }, moe = { class: "cv-bucket-head" }, goe = { class: "cv-badge ch-badge" }, boe = { class: "cv-bucket-titles" }, voe = { class: "cv-bucket-kind" }, yoe = { class: "cv-bucket-model" }, xoe = ["value"], woe = ["title"], koe = ["title", "aria-label", "aria-expanded", "disabled"], _oe = ["title"], Soe = ["title"], Moe = {
  key: 1,
  class: "cv-bucket-foot"
}, Toe = {
  key: 0,
  class: "ch-pulse"
}, Coe = {
  key: 0,
  class: "cv-bucket-open-hint"
}, Ioe = /* @__PURE__ */ Pe({
  __name: "ChatCard",
  props: {
    id: {},
    enter: { type: Boolean },
    delay: {},
    stack: {}
  },
  setup(i) {
    const e = i, { board: t, input: n } = Ze(), s = os(t), o = as(() => e.id), r = I(() => t.ui.selection.includes(e.id)), a = I(() => t.ui.chatOpen === e.id), l = I(() => o.value ? s.contextOf(o.value) : null), d = I(() => l.value ? h8(l.value) : 0), c = I(() => o.value ? z8(o.value) : 0), h = I(() => o.value ? IG(o.value) : null), f = I(() => s.live[e.id] || null), p = I(() => o.value ? AG(o.value) : null), y = dr(), v = I(() => !!(o.value && o.value.collapsed)), x = I(() => (t.docRev.value, t.isHeld(o.value))), w = I(() => {
      if (f.value) return { text: f.value.status || "Writing…", busy: !0 };
      const A = p.value;
      if (A && A.status === "running") {
        const O = (A.steps || []).find((F) => F.id === "run" && F.status === "running");
        return { text: O ? O.text : "Running the plan…", busy: !0 };
      }
      if (A && A.status === "proposed") return { text: "Plan ready · " + g8(A.tokens), busy: !1 };
      const R = o.value ? o.value.messages || [] : [], D = R.length ? R[R.length - 1].at : 0;
      return y.value, { text: D ? "Updated " + Jn(D) : l.value ? "No messages yet" : "Not in a frame", busy: !1 };
    }), S = /* @__PURE__ */ K(!1), M = /* @__PURE__ */ K(null);
    function _() {
      S.value = !0, nt(() => {
        M.value && (M.value.focus({ preventScroll: !0 }), M.value.select());
      });
    }
    function T(A) {
      if (!S.value) return;
      const R = M.value ? M.value.value.trim() : "";
      S.value = !1, A && R && o.value && R !== o.value.name && t.patch(e.id, { name: R }, "Rename chat");
    }
    function k(A) {
      !o.value || S.value || n.elementDown(t.store.get(e.id), A);
    }
    function P() {
      t.ui.selection = [e.id], t.ui.chatOpen = e.id;
    }
    return (A, R) => m(o) ? (g(), b("div", {
      key: 0,
      class: G(["cv-el is-chat", { "is-selected": r.value, "is-open": a.value, "cv-enter": i.enter, "is-stack-top": !!i.stack, "is-stack-deep": !!i.stack && i.stack.length > 2, "is-folded": v.value }]),
      style: ce({ left: m(o).x + "px", top: m(o).y + "px", width: m(o).w + "px", height: (v.value ? m(Nc) : m(o).h) + "px", zIndex: Math.round(m(o).z) + 10, "--d": (i.delay || 0) + "s" }),
      "data-el": i.id,
      "data-testid": "chat-card",
      onPointerdown: k,
      onDblclick: Se(P, ["stop"])
    }, [
      u("div", foe, [
        u("div", {
          class: G(["cv-bucket ch-card", { "is-busy": w.value.busy, "is-live": a.value }])
        }, [
          u("div", moe, [
            u("span", goe, [
              C($, {
                name: "MessagesSquare",
                size: 17
              })
            ]),
            u("span", boe, [
              u("span", voe, [
                R[8] || (R[8] = J(" Chat ", -1)),
                l.value ? (g(), b(j, { key: 0 }, [
                  R[7] || (R[7] = u("span", { class: "cv-bucket-sep" }, "·", -1)),
                  u("span", yoe, E(d.value) + " in context", 1)
                ], 64)) : z("", !0)
              ]),
              S.value ? (g(), b("input", {
                key: 0,
                ref_key: "nameInput",
                ref: M,
                class: "cv-bucket-name-input",
                value: m(o).name,
                spellcheck: "false",
                onPointerdown: R[0] || (R[0] = Se(() => {
                }, ["stop"])),
                onKeydown: [
                  R[1] || (R[1] = tn(Se((D) => T(!0), ["prevent"]), ["enter"])),
                  R[2] || (R[2] = tn(Se((D) => T(!1), ["stop", "prevent"]), ["esc"]))
                ],
                onBlur: R[3] || (R[3] = (D) => T(!0))
              }, null, 40, xoe)) : (g(), b("div", {
                key: 1,
                class: "cv-bucket-name",
                title: m(o).name,
                onDblclick: Se(_, ["stop"])
              }, E(m(o).name), 41, woe))
            ]),
            u("button", {
              type: "button",
              class: "cv-fold",
              title: v.value ? "Expand" : "Collapse to its title",
              "aria-label": v.value ? "Expand" : "Collapse to its title",
              "aria-expanded": !v.value,
              disabled: x.value,
              "data-testid": "card-fold",
              onPointerdown: R[4] || (R[4] = Se(() => {
              }, ["stop"])),
              onDblclick: R[5] || (R[5] = Se(() => {
              }, ["stop"])),
              onClick: R[6] || (R[6] = Se((D) => m(t).toggleCollapsed([i.id]), ["stop"]))
            }, [
              C($, {
                name: v.value ? "ChevronDown" : "ChevronUp",
                size: 14
              }, null, 8, ["name"])
            ], 40, koe),
            v.value && w.value.busy ? (g(), b("span", {
              key: 0,
              class: "cv-count is-state",
              title: w.value.text
            }, [...R[9] || (R[9] = [
              u("span", { class: "ch-pulse" }, null, -1)
            ])], 8, _oe)) : (g(), b("span", {
              key: 1,
              class: "cv-count",
              title: c.value === 1 ? "1 message" : c.value + " messages"
            }, E(c.value), 9, Soe))
          ]),
          v.value ? z("", !0) : (g(), b("div", {
            key: 0,
            class: G(["ch-card-last", { "is-empty": !h.value }])
          }, [
            h.value ? (g(), b(j, { key: 0 }, [
              u("b", null, E(h.value.who) + ":", 1),
              J(" " + E(h.value.text), 1)
            ], 64)) : (g(), b(j, { key: 1 }, [
              J(E(m(s).frameOf(m(o)) ? "Ask about this frame, or have it set up tools here." : "Ask about the pictures it picked, or have it set up tools for them."), 1)
            ], 64))
          ], 2)),
          v.value ? z("", !0) : (g(), b("div", Moe, [
            u("span", {
              class: G(["ch-card-state", { "is-busy": w.value.busy }])
            }, [
              w.value.busy ? (g(), b("span", Toe)) : z("", !0),
              J(E(w.value.text), 1)
            ], 2),
            a.value ? z("", !0) : (g(), b("span", Coe, [
              R[10] || (R[10] = J("Open ", -1)),
              C($, {
                name: "ChevronRight",
                size: 11
              })
            ]))
          ])),
          R[11] || (R[11] = u("span", { class: "cv-ring" }, null, -1))
        ], 2)
      ]),
      i.stack ? (g(), Ce(oI, {
        key: 0,
        top: i.id,
        ids: i.stack
      }, null, 8, ["top", "ids"])) : z("", !0)
    ], 46, poe)) : z("", !0);
  }
}), Aoe = /* @__PURE__ */ Pe({
  __name: "FrameGlow",
  props: {
    frameId: {},
    chatId: {}
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = os(t), s = as(() => e.frameId), o = I(() => {
      if (n.live[e.chatId]) return !0;
      const r = n.open.value;
      return !!r && (r.messages || []).some((a) => a.plan && a.plan.status === "running");
    });
    return (r, a) => m(s) ? (g(), b("div", {
      key: 0,
      class: G(["cv-frame-glow", { "is-working": o.value }]),
      style: ce({ left: m(s).x + "px", top: m(s).y + "px", width: m(s).w + "px", height: m(s).h + "px" }),
      "data-testid": "frame-glow",
      "aria-hidden": "true"
    }, null, 6)) : z("", !0);
  }
}), Poe = /* @__PURE__ */ Pe({
  __name: "PickGlow",
  props: {
    id: {}
  },
  setup(i) {
    const e = i, t = as(() => e.id);
    return (n, s) => m(t) ? (g(), b("div", {
      key: 0,
      class: "cv-frame-glow cv-pick-glow",
      style: ce({ left: m(t).x + "px", top: m(t).y + "px", width: m(t).w + "px", height: m(t).h + "px" }),
      "data-testid": "pick-glow",
      "aria-hidden": "true"
    }, null, 4)) : z("", !0);
  }
}), Eoe = ["value"], Roe = {
  key: 2,
  class: "cv-frame-name"
}, zoe = { class: "cv-frame-count" }, $oe = /* @__PURE__ */ Pe({
  __name: "FrameTitle",
  props: {
    id: {},
    enter: { type: Boolean },
    delay: {}
  },
  setup(i) {
    const e = i, { board: t, input: n } = Ze(), s = as(() => e.id), o = /* @__PURE__ */ K(null), r = I(() => t.ui.selection.includes(e.id)), a = I(() => t.ui.editingTitle === e.id), l = I(() => {
      t.docRev.value;
      const h = t.store.get(e.id);
      return h ? t.carriedBy(h).filter((f) => {
        const p = t.store.get(f);
        return !!p && p.type !== "frame";
      }).length : 0;
    });
    Ae(a, (h) => {
      h && nt(() => {
        o.value && (o.value.focus({ preventScroll: !0 }), o.value.select());
      });
    }, { immediate: !0 });
    function d(h) {
      if (a.value) return;
      const f = t.store.get(e.id);
      f && n.elementDown(f, h);
    }
    function c(h) {
      if (!a.value) return;
      const f = o.value ? o.value.value : "";
      t.ui.editingTitle = null, h && t.renameFrame(e.id, f);
    }
    return (h, f) => m(s) ? (g(), b("div", {
      key: 0,
      class: G(["cv-el is-frame-title", { "cv-enter": i.enter }]),
      style: ce({ left: m(s).x + "px", top: m(s).y + "px", width: m(s).w + "px", height: "0px", zIndex: 5, "--d": (i.delay || 0) + "s" })
    }, [
      u("div", {
        class: G(["cv-frame-title", { "is-selected": r.value, "is-locked": m(s).locked }]),
        onPointerdown: d,
        onDblclick: f[4] || (f[4] = Se((p) => m(t).ui.editingTitle = i.id, ["stop"]))
      }, [
        m(s).locked ? (g(), Ce($, {
          key: 0,
          class: "cv-frame-lock",
          name: "Lock",
          size: 11,
          stroke: 2.25,
          "data-testid": "frame-locked"
        })) : z("", !0),
        a.value ? (g(), b("input", {
          key: 1,
          ref_key: "inputEl",
          ref: o,
          class: "cv-frame-title-input",
          value: m(s).title,
          spellcheck: "false",
          onPointerdown: f[0] || (f[0] = Se(() => {
          }, ["stop"])),
          onKeydown: [
            f[1] || (f[1] = tn(Se((p) => c(!0), ["prevent"]), ["enter"])),
            f[2] || (f[2] = tn(Se((p) => c(!1), ["stop", "prevent"]), ["esc"]))
          ],
          onBlur: f[3] || (f[3] = (p) => c(!0))
        }, null, 40, Eoe)) : (g(), b("span", Roe, E(m(s).title), 1)),
        u("span", zoe, E(l.value) + " " + E(l.value === 1 ? "item" : "items"), 1)
      ], 34)
    ], 6)) : z("", !0);
  }
}), Doe = {
  key: 0,
  class: "cv-img-vid"
}, Ooe = {
  key: 1,
  class: "cv-img-fav"
}, Loe = ["title"], Boe = /* @__PURE__ */ Pe({
  __name: "ImageBadges",
  props: {
    id: {}
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = as(() => e.id), s = I(() => {
      const r = n.value;
      return r ? (t.results.rev.value, t.isFav(r.resultId && t.results.get(r.resultId) || null, r)) : !1;
    }), o = I(() => !!n.value && t.isPinnedImage(n.value.src));
    return (r, a) => m(n) && (m(n).video || s.value || o.value) ? (g(), b("div", {
      key: 0,
      class: "cv-img-badges",
      style: ce({
        left: m(n).x + "px",
        top: m(n).y - (m(t).ui.hoverId === i.id ? 4 : 0) + "px",
        width: m(n).w + "px",
        height: m(n).h + "px",
        transition: "top 200ms cubic-bezier(0.16,1,0.3,1)"
      })
    }, [
      m(n).video ? (g(), b("span", Doe, [
        C($, {
          name: "Play",
          size: 9
        }),
        J(" " + E(m(n).dur || "0:05"), 1)
      ])) : z("", !0),
      s.value ? (g(), b("span", Ooe, [
        C($, {
          name: "Heart",
          size: 9
        })
      ])) : z("", !0),
      o.value ? (g(), b("span", {
        key: 2,
        class: "cv-img-pin",
        title: m(Xn).badge,
        "data-testid": "card-pinned"
      }, [
        C($, {
          name: "Pin",
          size: 10
        })
      ], 8, Loe)) : z("", !0)
    ], 4)) : z("", !0);
  }
}), Foe = { class: "cv-img-foot" }, Noe = {
  key: 0,
  class: "cv-img-model",
  "data-testid": "image-model"
}, Uoe = { class: "cv-img-label" }, Goe = {
  key: 1,
  class: "cv-img-hint",
  "data-testid": "image-ref-hint"
}, joe = { class: "cv-img-actions" }, Hoe = 280, Voe = /* @__PURE__ */ Pe({
  __name: "ImageHover",
  props: {
    id: {}
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = as(() => e.id), s = sm().shift, o = I(() => !!n.value && !!t.promptTool.value && n.value.w * t.cam.value.zoom >= Hoe), r = I(() => {
      const l = n.value;
      if (!l || !l.resultId) return "";
      t.results.rev.value;
      const d = t.results.get(l.resultId);
      return d && d.model || "";
    });
    function a(l) {
      l.stopPropagation(), t.deleteIds([e.id]);
    }
    return (l, d) => m(n) ? (g(), b("div", {
      key: 0,
      class: "cv-img-hover",
      style: ce({ left: m(n).x + "px", top: m(n).y - 4 + "px", width: m(n).w + "px", height: m(n).h + "px" })
    }, [
      d[2] || (d[2] = u("div", { class: "cv-img-shade" }, null, -1)),
      u("div", Foe, [
        r.value ? (g(), b("span", Noe, E(r.value), 1)) : z("", !0),
        u("span", Uoe, E(m(n).label), 1),
        o.value ? (g(), b("span", Goe, [
          u("kbd", null, E(m(s)), 1),
          d[1] || (d[1] = J("Drag to use as a reference", -1))
        ])) : z("", !0)
      ]),
      u("div", joe, [
        u("button", {
          title: "Remove",
          onPointerdown: d[0] || (d[0] = Se(() => {
          }, ["stop"])),
          onClick: a
        }, [
          C($, {
            name: "Trash2",
            size: 13
          })
        ], 32)
      ])
    ], 4)) : z("", !0);
  }
}), Woe = { class: "cv-dropper-chip" }, qoe = /* @__PURE__ */ Pe({
  __name: "DropperRing",
  props: {
    id: {}
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = as(() => e.id), s = I(() => {
      const r = t.ui.eyedropper;
      return !!r && !!n.value && t.refImages(r.sessionId, r.key).includes(n.value.src);
    }), o = I(() => {
      if (s.value) return "In the prompt";
      const r = t.eyedropperField;
      return r && r.kind === "images" ? "Add to the prompt" : "Use in the prompt";
    });
    return (r, a) => m(n) ? (g(), b("div", {
      key: 0,
      class: G(["cv-dropper-ring", { "is-in": s.value }]),
      style: ce({ left: m(n).x + "px", top: m(n).y - 4 + "px", width: m(n).w + "px", height: m(n).h + "px" }),
      "data-testid": "eyedropper-ring"
    }, [
      u("span", Woe, [
        C($, {
          name: s.value ? "Check" : "Pipette",
          size: 11
        }, null, 8, ["name"]),
        J(E(o.value), 1)
      ])
    ], 6)) : z("", !0);
  }
}), Koe = ["data-id"], Yoe = ["src"], Xoe = { class: "cv-vid-bar" }, Joe = /* @__PURE__ */ Pe({
  __name: "VideoHover",
  props: {
    id: {},
    active: { type: Boolean },
    light: { type: Boolean }
  },
  setup(i) {
    const e = i, t = as(() => e.id), n = I(() => {
      const c = t.value;
      return c && (e.light && c.previewSrc || c.videoSrc) || "";
    }), s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(!1);
    let a = 0;
    function l() {
      const c = s.value;
      c && o.value && c.duration > 0 && (o.value.style.transform = "scaleX(" + Math.min(1, c.currentTime / c.duration) + ")"), a = requestAnimationFrame(l);
    }
    function d() {
      const c = s.value;
      if (!c) return;
      c.muted = !0;
      const h = c.play();
      h && h.catch(() => {
      });
    }
    return Ae(() => e.active, (c) => {
      c && d();
    }), ot(() => {
      const c = s.value;
      c && (typeof c.requestVideoFrameCallback == "function" ? c.requestVideoFrameCallback(() => {
        r.value = !0;
      }) : c.addEventListener("playing", () => {
        r.value = !0;
      }, { once: !0 }), d(), a = requestAnimationFrame(l));
    }), We(() => {
      cancelAnimationFrame(a);
      const c = s.value;
      c && (c.pause(), c.removeAttribute("src"), c.load());
    }), (c, h) => m(t) && m(t).videoSrc ? (g(), b("div", {
      key: 0,
      class: G(["cv-vid", { "is-shown": r.value && i.active }]),
      style: ce({ left: m(t).x + "px", top: m(t).y - (i.active ? 4 : 0) + "px", width: m(t).w + "px", height: m(t).h + "px" }),
      "data-testid": "hover-video",
      "data-id": i.id
    }, [
      u("video", {
        ref_key: "video",
        ref: s,
        src: n.value,
        muted: "",
        loop: "",
        playsinline: "",
        preload: "auto",
        disablepictureinpicture: ""
      }, null, 8, Yoe),
      u("div", Xoe, [
        u("i", {
          ref_key: "bar",
          ref: o
        }, null, 512)
      ])
    ], 14, Koe)) : z("", !0);
  }
}), Zoe = /* @__PURE__ */ Pe({
  __name: "GpuHandle",
  props: {
    id: {}
  },
  setup(i) {
    const e = i, { board: t, input: n } = Ze(), s = as(() => e.id);
    function o(r) {
      const a = t.store.get(e.id);
      a && n.resizeDown(a, r);
    }
    return (r, a) => m(s) ? (g(), b("div", {
      key: 0,
      class: "cv-el is-handle",
      style: ce({ left: m(s).x + "px", top: m(s).y + "px", width: Math.max(0, m(s).w) + "px", height: Math.max(0, m(s).h) + "px", pointerEvents: "none", zIndex: 9999 })
    }, [
      u("span", {
        class: "cv-resize",
        title: "Resize",
        onPointerdown: o
      }, null, 32)
    ], 4)) : z("", !0);
  }
}), Qoe = 64, ere = 512, tre = /* @__PURE__ */ Pe({
  __name: "WorldLayer",
  setup(i) {
    const { board: e } = Ze(), t = os(e), n = /* @__PURE__ */ K(!0), s = /* @__PURE__ */ new Map();
    {
      const x = e.overlayIds.value.map((S) => e.store.get(S)).filter(Boolean);
      x.sort((S, M) => S.y - M.y || S.x - M.x);
      const w = Math.min(0.045, 0.9 / Math.max(1, x.length));
      x.forEach((S, M) => s.set(S.id, M * w));
    }
    const o = window.setTimeout(() => {
      n.value = !1;
    }, 1700);
    We(() => clearTimeout(o));
    const r = I(() => {
      e.docRev.value;
      const x = [], w = [], S = [];
      for (const M of e.overlayIds.value) {
        const _ = e.store.get(M);
        _ && (_.type === "frame" ? x.push(M) : _.type === "tool" || _.type === "note" || _.type === "chat" ? w.push({ id: M, type: _.type, z: _.z }) : _.type === "image" && S.push(M));
      }
      return w.sort((M, _) => M.z - _.z), { frames: x, cards: w, badges: S };
    }), a = I(() => {
      e.docRev.value;
      const x = [];
      for (const w of r.value.cards) {
        const S = w.type === "note" ? null : e.store.get(w.id);
        S && x.push(S);
      }
      return uj(x);
    }), l = I(() => {
      const x = e.ui.hoverId;
      if (!x || e.ui.dragging || e.ui.eyedropper) return null;
      const w = e.store.get(x);
      return w && w.type === "image" && !e.ui.selection.includes(x) ? x : null;
    }), d = I(() => {
      const x = e.ui.hoverId;
      if (!x || e.ui.dragging || !e.ui.eyedropper) return null;
      const w = e.store.get(x);
      return w && w.type === "image" && e.eyedropperTakes(!!w.video) ? x : null;
    }), c = I(() => {
      e.docRev.value;
      const x = e.ui.hoverId;
      if (!x || e.ui.dragging) return null;
      const w = e.store.get(x);
      if (!w || w.type !== "image") return null;
      const S = w;
      return !S.video || !S.videoSrc ? null : S.w * e.cam.value.zoom >= Qoe ? x : null;
    }), h = /* @__PURE__ */ qe(null);
    let f = 0;
    Ae(c, (x) => {
      if (clearTimeout(f), x) {
        const S = h.value;
        if (S && S.id === x) {
          h.value = { ...S, active: !0 };
          return;
        }
        const M = e.store.get(x), _ = !!M && Math.max(M.w, M.h) * e.cam.value.zoom <= ere;
        h.value = { id: x, active: !0, light: _ };
        return;
      }
      const w = h.value;
      w && (h.value = { ...w, active: !1 }, f = window.setTimeout(() => {
        h.value && !h.value.active && (h.value = null);
      }, 260));
    }, { immediate: !0 }), We(() => clearTimeout(f));
    const p = I(() => {
      const x = t.open.value, w = x ? t.frameOf(x) : null;
      return x && w ? { frameId: w.id, chatId: x.id } : null;
    }), y = I(() => {
      const x = t.open.value;
      return !x || p.value ? [] : t.picksOf(x).map((w) => w.id);
    }), v = I(() => {
      if (e.docRev.value, e.ui.selection.length !== 1 || e.ui.dragging) return null;
      const x = e.store.get(e.ui.selection[0]);
      return x && (x.type === "image" || x.type === "frame" || x.type === "shape") && !e.isHeld(x) ? x.id : null;
    });
    return (x, w) => (g(), b(j, null, [
      (g(!0), b(j, null, be(r.value.frames, (S) => (g(), Ce($oe, {
        key: "ft-" + S,
        id: S,
        enter: n.value && m(s).has(S),
        delay: m(s).get(S)
      }, null, 8, ["id", "enter", "delay"]))), 128)),
      p.value ? (g(), Ce(Aoe, {
        key: "fg-" + p.value.frameId,
        "frame-id": p.value.frameId,
        "chat-id": p.value.chatId
      }, null, 8, ["frame-id", "chat-id"])) : z("", !0),
      (g(!0), b(j, null, be(y.value, (S) => (g(), Ce(Poe, {
        key: "pg-" + S,
        id: S
      }, null, 8, ["id"]))), 128)),
      h.value ? (g(), Ce(Joe, {
        key: "vh-" + h.value.id,
        id: h.value.id,
        active: h.value.active,
        light: h.value.light
      }, null, 8, ["id", "active", "light"])) : z("", !0),
      (g(!0), b(j, null, be(r.value.badges, (S) => (g(), Ce(Boe, {
        key: "ib-" + S,
        id: S
      }, null, 8, ["id"]))), 128)),
      (g(!0), b(j, null, be(r.value.cards, (S) => (g(), b(j, {
        key: S.id
      }, [
        S.type === "tool" ? (g(), Ce(toe, {
          key: 0,
          id: S.id,
          enter: n.value && m(s).has(S.id),
          delay: m(s).get(S.id),
          stack: a.value.get(S.id) || null
        }, null, 8, ["id", "enter", "delay", "stack"])) : S.type === "chat" ? (g(), Ce(Ioe, {
          key: 1,
          id: S.id,
          enter: n.value && m(s).has(S.id),
          delay: m(s).get(S.id),
          stack: a.value.get(S.id) || null
        }, null, 8, ["id", "enter", "delay", "stack"])) : (g(), Ce(hoe, {
          key: 2,
          id: S.id,
          enter: n.value && m(s).has(S.id),
          delay: m(s).get(S.id)
        }, null, 8, ["id", "enter", "delay"]))
      ], 64))), 128)),
      l.value ? (g(), Ce(Voe, {
        key: "hv-" + l.value,
        id: l.value
      }, null, 8, ["id"])) : z("", !0),
      d.value ? (g(), Ce(qoe, {
        key: "dr-" + d.value,
        id: d.value
      }, null, 8, ["id"])) : z("", !0),
      v.value ? (g(), Ce(Zoe, {
        key: 4,
        id: v.value
      }, null, 8, ["id"])) : z("", !0)
    ], 64));
  }
}), nre = {
  key: 0,
  class: "cv-guides",
  "aria-hidden": "true",
  "data-testid": "snap-guides"
}, ire = ["d"], sre = ["d"], ore = ["d"], rre = ["d"], Ph = 16, C_ = 4, I_ = 4, vo = 4, are = /* @__PURE__ */ Pe({
  __name: "SnapGuides",
  setup(i) {
    const { board: e } = Ze(), t = I(() => {
      const n = e.guides.value;
      if (!n) return null;
      const s = e.cam.value, o = window.devicePixelRatio || 1, r = (f) => Math.round((f - 0.5) * o) / o + 0.5, a = (f) => f * s.zoom + s.x, l = (f) => f * s.zoom + s.y, d = (f) => Math.floor(f / (C_ * 2)) * C_ * 2;
      let c = "";
      for (const f of n.lines)
        if (f.axis === "x") {
          const p = r(a(f.at));
          c += "M" + p + " " + d(l(f.from) - Ph) + "V" + (l(f.to) + Ph);
        } else {
          const p = r(l(f.at));
          c += "M" + d(a(f.from) - Ph) + " " + p + "H" + (a(f.to) + Ph);
        }
      let h = "";
      for (const f of n.gaps) {
        const p = (f.axis === "x" ? a(f.from) : l(f.from)) + I_, y = (f.axis === "x" ? a(f.to) : l(f.to)) - I_;
        if (y - p < 4) continue;
        const v = r(p), x = r(y), w = r(f.axis === "x" ? l(f.at) : a(f.at));
        h += f.axis === "x" ? "M" + v + " " + w + "H" + x + "M" + v + " " + (w - vo) + "V" + (w + vo) + "M" + x + " " + (w - vo) + "V" + (w + vo) : "M" + w + " " + v + "V" + x + "M" + (w - vo) + " " + v + "H" + (w + vo) + "M" + (w - vo) + " " + x + "H" + (w + vo);
      }
      return c || h ? { lines: c, gaps: h } : null;
    });
    return (n, s) => t.value ? (g(), b("svg", nre, [
      t.value.lines ? (g(), b("path", {
        key: 0,
        class: "cv-guide-halo is-dashed",
        d: t.value.lines
      }, null, 8, ire)) : z("", !0),
      t.value.gaps ? (g(), b("path", {
        key: 1,
        class: "cv-guide-halo",
        d: t.value.gaps
      }, null, 8, sre)) : z("", !0),
      t.value.lines ? (g(), b("path", {
        key: 2,
        class: "cv-guide-line",
        d: t.value.lines,
        "data-testid": "snap-lines"
      }, null, 8, ore)) : z("", !0),
      t.value.gaps ? (g(), b("path", {
        key: 3,
        class: "cv-guide-gap",
        d: t.value.gaps,
        "data-testid": "snap-gaps"
      }, null, 8, rre)) : z("", !0)
    ])) : z("", !0);
  }
}), lre = { class: "bd-dropper-mark" }, dre = { class: "bd-dropper-text" }, cre = {
  key: 0,
  class: "bd-dropper-count",
  "data-testid": "eyedropper-count"
}, ure = /* @__PURE__ */ Pe({
  __name: "EyedropperBanner",
  setup(i) {
    const { board: e } = Ze(), t = I(() => {
      e.docRev.value;
      const n = e.ui.eyedropper, s = e.eyedropperField, o = e.promptTool.value;
      if (!n || !s || !o) return null;
      if (s.kind === "images")
        return { text: "Click an image on the board to add it to the prompt", count: e.refImages(n.sessionId, n.key).length + " of " + Zs(s) };
      const r = e.modelFor(o).model, a = !!r && r.fields.filter((d) => d.placement === "reference").length > 1;
      return { text: (s.kind === "video" ? "Click a video on the board to use it" : "Click an image on the board to use it") + (a ? " for the " + s.label.toLowerCase() : ""), count: "" };
    });
    return (n, s) => (g(), Ce(vt, { name: "bd-dropper" }, {
      default: Xe(() => [
        t.value ? (g(), b("div", {
          key: 0,
          class: "bd-dropper",
          role: "status",
          "data-testid": "eyedropper-banner",
          onPointerdown: s[1] || (s[1] = Se(() => {
          }, ["stop"]))
        }, [
          u("span", lre, [
            C($, {
              name: "Pipette",
              size: 13
            })
          ]),
          u("span", dre, E(t.value.text), 1),
          t.value.count ? (g(), b("span", cre, E(t.value.count), 1)) : z("", !0),
          u("button", {
            class: "bd-dropper-done",
            title: "Done (Esc)",
            "data-testid": "eyedropper-done",
            onClick: s[0] || (s[0] = (o) => m(e).ui.eyedropper = null)
          }, "Done")
        ], 32)) : z("", !0)
      ]),
      _: 1
    }));
  }
}), hre = { class: "up-adv-head" }, pre = ["disabled", "data-testid"], fre = { class: "up-adv-label" }, mre = {
  key: 0,
  class: "req"
}, gre = ["title"], bre = {
  key: 0,
  class: "up-adv-why"
}, vre = {
  key: 1,
  class: "up-adv-row"
}, yre = ["min", "max", "step", "value", "onInput"], xre = ["min", "max", "step", "value", "onChange"], wre = { class: "up-seg" }, kre = ["onClick"], _re = ["onClick"], Sre = ["value", "onChange"], Mre = ["aria-pressed", "onClick"], Tre = {
  key: 4,
  class: "up-seg"
}, Cre = ["onClick"], Ire = ["value", "onChange"], Are = ["value"], Pre = ["value", "placeholder", "onChange"], Ere = ["value", "placeholder", "onChange"], Rre = /* @__PURE__ */ Pe({
  __name: "AdvancedPanel",
  props: {
    tool: {},
    model: {},
    form: {}
  },
  emits: ["close"],
  setup(i, { emit: e }) {
    const t = i, n = e, { board: s } = Ze(), o = I(() => t.model.fields.filter((v) => v.placement === "advanced" && v.kind !== "header" && Ur(t.form, v.key).shown)), r = I(() => s.promptOf(t.tool.id));
    function a(v) {
      return Ur(t.form, v.key);
    }
    function l(v) {
      return v.key in t.form.values ? t.form.values[v.key] : Lc(v, r.value);
    }
    function d(v) {
      const x = l(v);
      return x == null ? "" : String(x);
    }
    function c(v, x) {
      s.setPrompt(t.tool.id, { inputs: { ...r.value.inputs || {}, [v]: x } });
    }
    function h() {
      const v = { ...r.value.inputs || {} };
      for (const x of o.value) delete v[x.key];
      s.setPrompt(t.tool.id, { inputs: v });
    }
    function f(v) {
      const x = Number(l(v));
      return Number.isFinite(x) ? x : v.min || 0;
    }
    function p(v, x) {
      const w = cc(v, x);
      w != null && c(v.key, w);
    }
    function y(v) {
      const x = l(v);
      return x == null || x === "" || x === -1 ? "random" : "custom";
    }
    return (v, x) => (g(), b("aside", {
      class: "up-adv",
      "data-testid": "advanced-panel",
      onPointerdown: x[5] || (x[5] = Se(() => {
      }, ["stop"]))
    }, [
      u("div", hre, [
        x[6] || (x[6] = u("span", { class: "up-adv-title" }, "Advanced", -1)),
        u("button", {
          class: "cv-iconbtn",
          title: "Reset to model defaults",
          onClick: h
        }, [
          C($, {
            name: "RotateCcw",
            size: 14
          })
        ]),
        u("button", {
          class: "cv-iconbtn",
          title: "Close",
          onClick: x[0] || (x[0] = (w) => n("close"))
        }, [
          C($, {
            name: "X",
            size: 14
          })
        ])
      ]),
      (g(!0), b(j, null, be(o.value, (w) => (g(), b("fieldset", {
        key: w.key,
        class: G(["up-adv-field", { "is-locked": a(w).locked }]),
        disabled: a(w).locked,
        "data-testid": "adv-" + w.key
      }, [
        u("div", fre, [
          J(E(w.label), 1),
          a(w).required ? (g(), b("span", mre, "*")) : z("", !0),
          w.tooltip ? (g(), b("span", {
            key: 1,
            title: w.tooltip
          }, [
            C($, {
              name: "HelpCircle",
              size: 12
            })
          ], 8, gre)) : z("", !0)
        ]),
        a(w).locked ? (g(), b("div", bre, [
          C($, {
            name: "Lock",
            size: 11
          }),
          J(E(a(w).why), 1)
        ])) : z("", !0),
        w.kind === "slider" ? (g(), b("div", vre, [
          u("input", {
            class: "up-range",
            type: "range",
            min: w.min,
            max: w.max,
            step: w.step || 1,
            value: f(w),
            onInput: (S) => p(w, S.target.value)
          }, null, 40, yre),
          u("input", {
            class: "up-adv-num",
            type: "number",
            min: w.min,
            max: w.max,
            step: w.step || 1,
            value: f(w),
            onChange: (S) => p(w, S.target.value),
            onKeydown: x[1] || (x[1] = Se(() => {
            }, ["stop"]))
          }, null, 40, xre)
        ])) : w.kind === "seed" ? (g(), b(j, { key: 2 }, [
          u("div", wre, [
            u("button", {
              class: G({ on: y(w) === "random" }),
              onClick: (S) => c(w.key, null)
            }, "Random", 10, kre),
            u("button", {
              class: G({ on: y(w) === "custom" }),
              onClick: (S) => y(w) === "random" && c(w.key, Math.floor(Math.random() * 1e9))
            }, "Custom", 10, _re)
          ]),
          y(w) === "custom" ? (g(), b("input", {
            key: 0,
            class: "up-adv-num is-full",
            value: d(w),
            placeholder: "e.g. 284917",
            inputmode: "numeric",
            onChange: (S) => c(w.key, S.target.value === "" ? null : Number(S.target.value)),
            onKeydown: x[2] || (x[2] = Se(() => {
            }, ["stop"]))
          }, null, 40, Sre)) : z("", !0)
        ], 64)) : w.kind === "boolean" ? (g(), b("button", {
          key: 3,
          class: G(["up-toggle", { on: !!l(w) }]),
          "aria-pressed": !!l(w),
          onClick: (S) => c(w.key, !l(w))
        }, null, 10, Mre)) : (w.kind === "select" || w.kind === "size") && (w.options || []).length <= 6 ? (g(), b("div", Tre, [
          (g(!0), b(j, null, be(w.options || [], (S) => (g(), b("button", {
            key: m(yn)(S.value),
            class: G({ on: m(Qi)(S.value, l(w)) }),
            onClick: (M) => c(w.key, S.value)
          }, E(S.label), 11, Cre))), 128))
        ])) : w.kind === "select" || w.kind === "size" ? (g(), b("select", {
          key: 5,
          class: "up-adv-num is-full",
          value: m(yn)(l(w)),
          onChange: (S) => {
            var M;
            return c(w.key, (M = (w.options || []).find((_) => m(yn)(_.value) === S.target.value)) == null ? void 0 : M.value);
          }
        }, [
          (g(!0), b(j, null, be(w.options || [], (S) => (g(), b("option", {
            key: m(yn)(S.value),
            value: m(yn)(S.value)
          }, E(S.label), 9, Are))), 128))
        ], 40, Ire)) : w.kind === "negPrompt" ? (g(), b("textarea", {
          key: 6,
          class: "up-adv-num is-full",
          value: d(w),
          placeholder: w.placeholder || "What to keep out of the image",
          onChange: (S) => c(w.key, S.target.value),
          onKeydown: x[3] || (x[3] = Se(() => {
          }, ["stop"]))
        }, null, 40, Pre)) : (g(), b("input", {
          key: 7,
          class: "up-adv-num is-full",
          value: d(w),
          placeholder: w.placeholder,
          onChange: (S) => c(w.key, S.target.value),
          onKeydown: x[4] || (x[4] = Se(() => {
          }, ["stop"]))
        }, null, 40, Ere))
      ], 10, pre))), 128))
    ], 32));
  }
}), zre = ["aria-label", "onMouseenter"], $re = ["title", "aria-label"], Dre = { class: "n" }, Ore = { class: "ic" }, rb = 3, Lre = /* @__PURE__ */ Pe({
  __name: "InputStack",
  props: {
    inputs: {}
  },
  emits: ["peek"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = /* @__PURE__ */ K(0), o = /* @__PURE__ */ K(-1), r = I(() => Math.max(0, t.inputs.length - rb)), a = I(() => r.value - s.value);
    function l(c) {
      o.value = c, n("peek", c >= 0 ? t.inputs[c] : null);
    }
    function d() {
      s.value = s.value >= r.value ? 0 : s.value + 1;
    }
    return (c, h) => (g(), b("div", {
      class: "pl-stack",
      onMouseleave: h[1] || (h[1] = (f) => l(-1)),
      onClick: h[2] || (h[2] = Se(() => {
      }, ["stop"]))
    }, [
      u("div", {
        class: "pl-stack-win",
        style: ce({ "--rows": Math.min(rb, i.inputs.length) })
      }, [
        u("div", {
          class: "pl-stack-reel",
          style: ce({ "--off": s.value })
        }, [
          (g(!0), b(j, null, be(i.inputs, (f, p) => (g(), b("span", {
            key: p,
            class: G(["pl-stack-th", { on: o.value === p, "is-markup": f.kind === "markup" }]),
            style: ce({ backgroundImage: 'url("' + f.url + '")' }),
            "aria-label": f.label + ": " + f.role,
            "data-testid": "input-thumb",
            onMouseenter: (y) => l(p)
          }, null, 46, zre))), 128))
        ], 4)
      ], 4),
      r.value ? (g(), b("button", {
        key: 0,
        class: G(["pl-stack-more", { "is-end": a.value <= 0 }]),
        title: a.value > 0 ? "Next image" : "Back to the first image",
        "aria-label": a.value > 0 ? "Next image" : "Back to the first image",
        "data-testid": "input-more",
        onClick: Se(d, ["stop"]),
        onKeydown: h[0] || (h[0] = Se(() => {
        }, ["stop"]))
      }, [
        u("span", Dre, E(a.value > 0 ? "+" + a.value : s.value + rb + "/" + i.inputs.length), 1),
        u("span", Ore, [
          C($, {
            name: a.value > 0 ? "ChevronDown" : "ChevronsUp",
            size: 13
          }, null, 8, ["name"])
        ])
      ], 42, $re)) : z("", !0)
    ], 32));
  }
}), Bre = ["data-prompt-id"], Fre = ["src"], Nre = ["src"], Ure = {
  key: 2,
  class: "pl-tile-words"
}, Gre = ["src"], jre = ["title"], Hre = ["aria-label"], Vre = {
  key: 0,
  class: "pl-tile-cap",
  "data-testid": "tile-caption"
}, Wre = { class: "pl-tile-meta" }, qre = { class: "pl-tile-name" }, Kre = { class: "pl-tile-tool" }, Yre = { class: "pl-tile-acts" }, Xre = ["title"], Jre = /* @__PURE__ */ Pe({
  __name: "PromptTile",
  props: {
    prompt: {},
    toolName: {},
    remixHint: {},
    levels: {}
  },
  emits: ["open", "use", "remix"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(!1), a = /* @__PURE__ */ K(null), l = I(() => t.prompt.output.thumb || (t.prompt.output.url ? Bt(t.prompt.output.url) : ""));
    function d() {
      s.value && n("open", s.value.getBoundingClientRect());
    }
    return (c, h) => (g(), b("article", {
      class: G(["pl-tile", { "is-in": o.value || !l.value, "is-peeking": !!a.value, "is-text": !l.value }]),
      "data-prompt-id": i.prompt.id,
      "data-testid": "prompt-tile",
      onMouseenter: h[5] || (h[5] = (f) => r.value = !0),
      onMouseleave: h[6] || (h[6] = (f) => r.value = !1)
    }, [
      u("span", {
        ref_key: "art",
        ref: s,
        class: "pl-tile-art"
      }, [
        l.value ? (g(), b("img", {
          key: 0,
          class: "pl-tile-img",
          src: l.value,
          alt: "",
          loading: "lazy",
          decoding: "async",
          draggable: "false",
          onLoad: h[0] || (h[0] = (f) => o.value = !0),
          onError: h[1] || (h[1] = (f) => o.value = !0)
        }, null, 40, Fre)) : z("", !0),
        i.prompt.output.video && r.value ? (g(), b("video", {
          key: 1,
          class: "pl-tile-img is-video",
          src: i.prompt.output.video,
          muted: "",
          loop: "",
          autoplay: "",
          playsinline: ""
        }, null, 8, Nre)) : z("", !0),
        l.value ? z("", !0) : (g(), b("span", Ure, E(i.prompt.prompt), 1)),
        C(vt, { name: "pl-peek" }, {
          default: Xe(() => [
            a.value ? (g(), b("img", {
              key: a.value.url,
              class: "pl-tile-img is-peek",
              src: m(Bt)(a.value.url),
              alt: "",
              draggable: "false"
            }, null, 8, Gre)) : z("", !0)
          ]),
          _: 1
        })
      ], 512),
      i.levels && i.levels.length ? (g(), b("span", {
        key: 0,
        class: "pl-tile-levels",
        title: i.levels.map((f) => f.label).join(" · "),
        "data-testid": "tile-levels"
      }, [
        (g(!0), b(j, null, be(i.levels, (f) => (g(), Ce($, {
          key: f.label,
          name: f.icon,
          size: 11
        }, null, 8, ["name"]))), 128))
      ], 8, jre)) : z("", !0),
      h[8] || (h[8] = u("span", { class: "pl-tile-shade" }, null, -1)),
      u("button", {
        class: "pl-tile-hit",
        "aria-label": "Open " + i.prompt.name,
        "data-testid": "tile-open",
        onClick: d
      }, null, 8, Hre),
      C(vt, { name: "pl-peek" }, {
        default: Xe(() => [
          a.value ? (g(), b("span", Vre, E(a.value.label) + " · " + E(a.value.role), 1)) : z("", !0)
        ]),
        _: 1
      }),
      i.prompt.inputs.length ? (g(), Ce(Lre, {
        key: 1,
        inputs: i.prompt.inputs,
        onPeek: h[2] || (h[2] = (f) => a.value = f)
      }, null, 8, ["inputs"])) : z("", !0),
      u("span", Wre, [
        u("span", qre, E(i.prompt.name), 1),
        u("span", Kre, E(i.toolName), 1),
        u("span", Yre, [
          u("button", {
            class: "pl-btn is-light",
            "data-testid": "tile-use",
            onClick: h[3] || (h[3] = (f) => n("use"))
          }, "Use prompt"),
          u("button", {
            class: "pl-btn is-glass",
            title: i.remixHint,
            "data-testid": "tile-remix",
            onClick: h[4] || (h[4] = (f) => n("remix"))
          }, [
            C($, {
              name: "Repeat",
              size: 12
            }),
            h[7] || (h[7] = J("Remix ", -1))
          ], 8, Xre)
        ])
      ])
    ], 42, Bre));
  }
}), Zre = ["data-prompt-id"], Qre = {
  class: "pl-detail-art",
  "data-testid": "detail-art"
}, eae = {
  key: 0,
  class: "pl-cover-text"
}, tae = ["src", "alt"], nae = {
  class: "pl-detail-cap",
  "data-testid": "detail-caption"
}, iae = {
  key: 2,
  class: "pl-detail-strip"
}, sae = ["onMouseenter"], oae = ["aria-label", "onFocus"], rae = {
  key: 0,
  class: "pl-detail-more"
}, aae = { class: "pl-detail-info" }, lae = { class: "pl-detail-scroll" }, dae = { class: "pl-detail-top" }, cae = { class: "pl-crumb" }, uae = { class: "pl-detail-nav" }, hae = ["disabled"], pae = { class: "pl-detail-count" }, fae = ["disabled"], mae = { class: "pl-detail-name" }, gae = {
  key: 0,
  class: "pl-detail-by",
  "data-testid": "detail-byline"
}, bae = {
  key: 1,
  class: "pl-detail-desc"
}, vae = { class: "pl-block" }, yae = { class: "pl-label-row" }, xae = ["title", "aria-label"], wae = {
  class: "pl-prompt",
  "data-testid": "detail-prompt"
}, kae = { class: "pl-block" }, _ae = { class: "pl-pills" }, Sae = { class: "pl-pill" }, Mae = {
  key: 0,
  class: "pl-pill is-quiet"
}, Tae = {
  key: 0,
  class: "pl-note",
  "data-testid": "detail-note"
}, Cae = {
  key: 2,
  class: "pl-block"
}, Iae = { class: "pl-pills" }, Aae = {
  key: 3,
  class: "pl-block"
}, Pae = { class: "pl-inputs" }, Eae = ["onMouseenter"], Rae = ["title", "aria-label", "onFocus"], zae = { class: "pl-input-n" }, $ae = {
  key: 0,
  class: "pl-input-tag"
}, Dae = { class: "pl-detail-foot" }, Oae = { class: "pl-detail-acts" }, Lae = ["title"], Bae = {
  key: 0,
  class: "pl-acts-own"
}, Fae = ["title", "aria-label"], Nae = { key: 0 }, Uae = { class: "pl-acts-hint" }, Gae = 5, jae = /* @__PURE__ */ Pe({
  __name: "PromptDetail",
  props: {
    prompt: {},
    index: {},
    total: {},
    more: { type: Boolean },
    toolName: {},
    note: {},
    remixHint: {},
    from: {},
    crumb: {},
    byline: {},
    levels: {},
    canEdit: { type: Boolean }
  },
  emits: ["back", "step", "use", "remix", "edit", "delete"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(!!t.from);
    let l = 0;
    const d = I(() => s.value ? s.value.url : t.prompt.output.url), c = /* @__PURE__ */ K(!1);
    function h() {
      if (!c.value) {
        c.value = !0;
        return;
      }
      c.value = !1, n("delete");
    }
    const f = I(() => s.value ? s.value.label + " · " + s.value.role : "Output"), p = I(() => t.prompt.inputs.slice(0, Gae)), y = I(() => t.prompt.inputs.length - p.value.length);
    Ae(() => t.prompt.id, () => {
      s.value = null, o.value = !1, c.value = !1;
    });
    function v() {
      try {
        navigator.clipboard.writeText(t.prompt.prompt).catch(() => {
        });
      } catch {
      }
      o.value = !0, clearTimeout(l), l = window.setTimeout(() => {
        o.value = !1;
      }, 1400);
    }
    async function x() {
      const w = t.from, S = typeof window.matchMedia == "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (!w || S) {
        a.value = !1;
        return;
      }
      await nt();
      const M = r.value;
      if (!M) {
        a.value = !1;
        return;
      }
      M.complete || await new Promise((A) => {
        M.addEventListener("load", () => A(), { once: !0 }), M.addEventListener("error", () => A(), { once: !0 });
      });
      const _ = M.getBoundingClientRect();
      if (!_.width || !_.height || typeof document.body.animate != "function") {
        a.value = !1;
        return;
      }
      const T = document.createElement("img");
      T.src = M.currentSrc || M.src, T.alt = "", Object.assign(T.style, {
        position: "fixed",
        left: w.left + "px",
        top: w.top + "px",
        width: w.width + "px",
        height: w.height + "px",
        objectFit: "cover",
        borderRadius: "14px",
        zIndex: "2147483000",
        pointerEvents: "none",
        margin: "0",
        boxShadow: "0 30px 80px rgba(2, 4, 12, 0.55)"
      }), document.body.appendChild(T);
      const k = T.animate([
        { left: w.left + "px", top: w.top + "px", width: w.width + "px", height: w.height + "px", borderRadius: "14px" },
        { left: _.left + "px", top: _.top + "px", width: _.width + "px", height: _.height + "px", borderRadius: "12px" }
      ], { duration: 460, easing: "cubic-bezier(0.16, 1, 0.3, 1)", fill: "forwards" }), P = () => {
        a.value = !1, requestAnimationFrame(() => T.remove());
      };
      k.onfinish = P, k.oncancel = P;
    }
    return ot(x), We(() => clearTimeout(l)), (w, S) => (g(), b("div", {
      class: "pl-detail",
      "data-testid": "prompt-detail",
      "data-prompt-id": i.prompt.id
    }, [
      u("div", Qre, [
        d.value ? (g(), Ce(vt, {
          key: 1,
          name: "pl-peek",
          mode: "out-in"
        }, {
          default: Xe(() => [
            (g(), b("img", {
              key: d.value,
              ref_key: "artImg",
              ref: r,
              class: G(["pl-detail-img", { "is-landing": a.value }]),
              src: d.value,
              alt: s.value ? s.value.title || s.value.role : i.prompt.name,
              draggable: "false"
            }, null, 10, tae))
          ]),
          _: 1
        })) : (g(), b("span", eae, E(i.prompt.prompt), 1)),
        u("button", {
          class: "pl-back",
          title: "Back to the prompts",
          "aria-label": "Back to the prompts",
          "data-testid": "detail-back",
          onClick: S[0] || (S[0] = (M) => n("back"))
        }, [
          C($, {
            name: "ArrowLeft",
            size: 15
          })
        ]),
        u("span", nae, E(f.value), 1),
        i.prompt.inputs.length ? (g(), b("div", iae, [
          (g(!0), b(j, null, be(p.value, (M, _) => (g(), b("span", {
            key: _,
            class: "pl-th-slot",
            onMouseenter: (T) => s.value = M,
            onMouseleave: S[2] || (S[2] = (T) => s.value = null)
          }, [
            u("button", {
              class: G(["pl-detail-th", { on: s.value === M, "is-markup": M.kind === "markup" }]),
              style: ce({ backgroundImage: 'url("' + M.url + '")' }),
              "aria-label": "Show " + M.label + ": " + M.role,
              "data-testid": "detail-thumb",
              onFocus: (T) => s.value = M,
              onBlur: S[1] || (S[1] = (T) => s.value = null)
            }, null, 46, oae)
          ], 40, sae))), 128)),
          y.value > 0 ? (g(), b("span", rae, "+" + E(y.value), 1)) : z("", !0)
        ])) : z("", !0)
      ]),
      u("div", aae, [
        u("div", lae, [
          u("div", dae, [
            u("span", cae, E(i.crumb), 1),
            u("span", uae, [
              u("button", {
                title: "Previous prompt",
                "aria-label": "Previous prompt",
                disabled: i.total < 2 && !i.more,
                onClick: S[3] || (S[3] = (M) => n("step", -1))
              }, [
                C($, {
                  name: "ChevronLeft",
                  size: 14
                })
              ], 8, hae),
              u("span", pae, E(i.index + 1) + " of " + E(i.total) + E(i.more ? "+" : ""), 1),
              u("button", {
                title: "Next prompt",
                "aria-label": "Next prompt",
                disabled: i.total < 2 && !i.more,
                onClick: S[4] || (S[4] = (M) => n("step", 1))
              }, [
                C($, {
                  name: "ChevronRight",
                  size: 14
                })
              ], 8, fae)
            ])
          ]),
          u("h3", mae, E(i.prompt.name), 1),
          i.byline ? (g(), b("p", gae, E(i.byline), 1)) : z("", !0),
          i.prompt.description ? (g(), b("p", bae, E(i.prompt.description), 1)) : z("", !0),
          u("section", vae, [
            u("div", yae, [
              S[11] || (S[11] = u("span", { class: "pl-label" }, "Prompt", -1)),
              u("button", {
                class: "pl-icon-btn",
                title: o.value ? "Copied" : "Copy the prompt",
                "aria-label": o.value ? "Copied" : "Copy the prompt",
                onClick: v
              }, [
                C($, {
                  name: o.value ? "Check" : "Copy",
                  size: 13
                }, null, 8, ["name"])
              ], 8, xae)
            ]),
            u("p", wae, E(i.prompt.prompt), 1)
          ]),
          u("section", kae, [
            S[12] || (S[12] = u("span", { class: "pl-label" }, "Tool", -1)),
            u("div", _ae, [
              u("span", Sae, [
                C($, {
                  name: "Sparkles",
                  size: 12
                }),
                J(E(i.toolName), 1)
              ]),
              i.prompt.mode ? (g(), b("span", Mae, [
                C($, {
                  name: i.prompt.inputs.length ? "Images" : "Type",
                  size: 12
                }, null, 8, ["name"]),
                J(E(m(FV)(i.prompt.mode)), 1)
              ])) : z("", !0)
            ]),
            i.note ? (g(), b("p", Tae, [
              C($, {
                name: "Info",
                size: 12
              }),
              J(E(i.note), 1)
            ])) : z("", !0)
          ]),
          i.levels && i.levels.length ? (g(), b("section", Cae, [
            S[13] || (S[13] = u("span", { class: "pl-label" }, "Who can use it", -1)),
            u("div", Iae, [
              (g(!0), b(j, null, be(i.levels, (M) => (g(), b("span", {
                key: M.label,
                class: "pl-pill is-quiet",
                "data-testid": "detail-level"
              }, [
                C($, {
                  name: M.icon,
                  size: 12
                }, null, 8, ["name"]),
                J(E(M.label), 1)
              ]))), 128))
            ])
          ])) : z("", !0),
          i.prompt.inputs.length ? (g(), b("section", Aae, [
            S[14] || (S[14] = u("span", { class: "pl-label" }, "Input images · hover to preview", -1)),
            u("div", Pae, [
              (g(!0), b(j, null, be(i.prompt.inputs, (M, _) => (g(), b("span", {
                key: _,
                class: "pl-th-slot",
                onMouseenter: (T) => s.value = M,
                onMouseleave: S[6] || (S[6] = (T) => s.value = null)
              }, [
                u("button", {
                  class: G(["pl-input", { on: s.value === M, "is-markup": M.kind === "markup" }]),
                  style: ce({ backgroundImage: 'url("' + M.url + '")' }),
                  title: [M.label, M.role, M.title].filter(Boolean).join(" · "),
                  "aria-label": "Show " + M.label + ": " + M.role,
                  "data-testid": "detail-input",
                  onFocus: (T) => s.value = M,
                  onBlur: S[5] || (S[5] = (T) => s.value = null)
                }, [
                  u("span", zae, E(_ + 1), 1),
                  M.kind === "markup" ? (g(), b("span", $ae, "Markup")) : z("", !0)
                ], 46, Rae)
              ], 40, Eae))), 128))
            ])
          ])) : z("", !0)
        ]),
        u("div", Dae, [
          u("div", Oae, [
            u("button", {
              class: "pl-cta",
              "data-testid": "detail-use",
              onClick: S[7] || (S[7] = (M) => n("use"))
            }, "Use prompt"),
            u("button", {
              class: "pl-btn is-glass is-lg",
              title: i.remixHint,
              "data-testid": "detail-remix",
              onClick: S[8] || (S[8] = (M) => n("remix"))
            }, [
              C($, {
                name: "Repeat",
                size: 13
              }),
              S[15] || (S[15] = J("Remix ", -1))
            ], 8, Lae),
            i.canEdit ? (g(), b("span", Bae, [
              u("button", {
                class: "pl-icon-btn is-lg",
                title: "Edit",
                "aria-label": "Edit",
                "data-testid": "detail-edit",
                onClick: S[9] || (S[9] = (M) => n("edit"))
              }, [
                C($, {
                  name: "Pencil",
                  size: 14
                })
              ]),
              u("button", {
                class: G(["pl-icon-btn is-lg is-danger", { "is-confirming": c.value }]),
                title: c.value ? "Click again to delete it for everyone it is shared with" : "Delete",
                "aria-label": c.value ? "Confirm delete" : "Delete",
                "data-testid": "detail-delete",
                onClick: h,
                onBlur: S[10] || (S[10] = (M) => c.value = !1)
              }, [
                C($, {
                  name: c.value ? "Check" : "Trash2",
                  size: 14
                }, null, 8, ["name"]),
                c.value ? (g(), b("span", Nae, "Delete?")) : z("", !0)
              ], 42, Fae)
            ])) : z("", !0)
          ]),
          u("p", Uae, E(i.remixHint), 1)
        ])
      ])
    ], 8, Zre));
  }
}), Hae = {
  class: "pl-tabs pl-side-tabs",
  role: "tablist",
  "aria-label": "Prompts"
}, Vae = ["aria-selected"], Wae = {
  key: 0,
  class: "n"
}, qae = ["aria-selected"], Kae = {
  key: 0,
  class: "n"
}, Yae = { class: "pl-side-scroll" }, Xae = {
  class: "pl-tree",
  "aria-label": "Kinds and categories",
  "data-testid": "library-tree"
}, Jae = ["aria-current"], Zae = { class: "n" }, Qae = ["aria-current", "aria-label", "data-testid", "onClick"], ele = { class: "lbl" }, tle = { class: "n" }, nle = ["aria-current", "aria-label", "title", "data-testid", "onClick"], ile = { class: "lbl" }, sle = { class: "n" }, ole = {
  key: 0,
  class: "pl-leaves",
  "data-testid": "library-categories"
}, rle = ["aria-current", "title", "data-testid", "onClick"], ale = { class: "lbl" }, lle = { class: "n" }, dle = {
  key: 0,
  class: "pl-side-sec",
  "aria-label": "Shared with"
}, cle = ["aria-pressed", "data-testid", "onClick"], ule = { class: "pl-tick" }, hle = { class: "lbl" }, ple = { class: "n" }, fle = { class: "pl-content" }, mle = { class: "pl-head" }, gle = ["aria-expanded"], ble = { class: "pl-search" }, vle = ["placeholder"], yle = {
  key: 1,
  class: "pl-kbd"
}, xle = {
  key: 0,
  class: "pl-scope",
  "data-testid": "library-scope"
}, wle = {
  key: 0,
  class: "pl-scope-crumb"
}, kle = { class: "pl-scope-title" }, _le = ["title"], Sle = {
  key: 1,
  class: "pl-scope-n"
}, Mle = { class: "pl-main" }, Tle = {
  key: 0,
  class: "pl-grid",
  "aria-busy": "true"
}, Cle = {
  key: 1,
  class: "pl-empty",
  "data-testid": "library-failed"
}, Ile = {
  key: 2,
  class: "pl-empty",
  "data-testid": "library-unpublished"
}, Ale = { key: 0 }, Ple = {
  key: 3,
  class: "pl-empty is-roomy",
  "data-testid": "library-mine-off"
}, Ele = { class: "pl-empty-mark" }, Rle = {
  key: 4,
  class: "pl-empty is-roomy",
  "data-testid": "library-mine-empty"
}, zle = { class: "pl-empty-mark" }, $le = {
  key: 5,
  class: "pl-empty is-roomy",
  "data-testid": "library-video-none"
}, Dle = { class: "pl-empty-mark" }, Ole = { class: "pl-empty-acts" }, Lle = {
  key: 6,
  class: "pl-empty",
  "data-testid": "library-no-match"
}, Ble = { class: "pl-empty-acts" }, Fle = {
  key: 0,
  class: "pl-edit",
  "data-testid": "library-edit"
}, Nle = { class: "pl-detail-art" }, Ule = ["src"], Gle = {
  key: 1,
  class: "pl-cover-text"
}, jle = { class: "pl-edit-form" }, Hle = 250, Vle = 600, Xy = /* @__PURE__ */ Pe({
  __name: "PromptLibrary",
  props: {
    floating: { type: Boolean }
  },
  setup(i) {
    const { board: e } = Ze(), t = e.promptLibrary, n = e.ui.library, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(!1), c = I(() => (e.docRev.value, t.session(n.sessionId))), h = I(() => c.value ? Ja(c.value.kitId) : null), f = I(() => n.tab === "featured"), p = I(() => t.featured.value), y = I(() => f.value ? t.state.value : t.mineState.value), v = I(() => t.mine.value), x = I(() => t.myPrompts.counts.value), w = I(() => x.value ? x.value.total : v.value.length), S = I(() => e.labels.team), M = I(() => [
      { id: "me", icon: "Lock", label: "Only me" },
      { id: "board", icon: "LayoutGrid", label: "This board" },
      ...t.team.value ? [{ id: "team", icon: "Users", label: xv(S.value) }] : [],
      // the company's, where the board's team has one (IL-101)
      ...t.company() || _("company") ? [{ id: "company", icon: "Building2", label: "Company" }] : []
    ]);
    function _(ve) {
      return x.value ? x.value.levels[ve] : v.value.filter((ke) => lf(ke, e.meta.id).includes(ve)).length;
    }
    function T(ve) {
      n.levels = n.levels.includes(ve) ? n.levels.filter((ke) => ke !== ve) : n.levels.concat([ve]), n.detail = null;
    }
    const k = I(() => f.value ? p.value ? OV(p.value.prompts, { category: n.category, query: n.query, kind: h.value, only: n.kind, action: n.action }) : [] : v.value), P = { image: "Image", video: "Video" }, A = { image: "Image", video: "Video" }, R = { generate: "Generate", edit: "Edit" }, D = { generate: "Sparkles", edit: "Wand2" }, O = {
      image: { generate: "From words alone", edit: "From your image" },
      video: { generate: "From words alone", edit: "From your image or clip" }
    }, F = {
      image: "Generate an image from words, or edit one of yours",
      video: "Generate a clip from words, or bring your image to life",
      "image-generate": "Start from words: a new concept, no image needed",
      "image-edit": "Start from your own image: change it, restyle it or add to it",
      "video-generate": "Start from words: a new clip, no image needed",
      "video-edit": "Start from your image or clip: move the camera, add life or transform it"
    }, te = I(() => {
      if (f.value) {
        const ke = p.value;
        return ke ? Xu(Zw(ke.prompts), ke.categories.map((De) => De.label)) : Xu([]);
      }
      const ve = x.value;
      return ve && ve.groups && ve.actions ? Xu(ve.groups, [], ve.actions) : Xu(Zw(v.value));
    }), ee = I(() => {
      const ve = /* @__PURE__ */ new Map();
      if (f.value && p.value) for (const ke of p.value.categories) ve.set(ke.label, { id: ke.id, description: ke.description });
      return ve;
    });
    function me(ve) {
      const ke = ee.value.get(ve);
      return ke ? ke.id : ve;
    }
    const L = I(() => {
      const ve = te.value.kinds.find((De) => De.kind === n.kind), ke = ve && ve.actions.find((De) => De.action === n.action);
      return ke ? ke.categories : [];
    }), N = I(() => {
      if (!n.kind)
        return { crumb: "", title: "All prompts", hint: f.value ? "Curated by RunDiffusion: each with its tool and the images it was given" : "Prompts you saved, and prompts shared with you here" };
      const ve = P[n.kind];
      if (!n.action) return { crumb: "", title: ve + " prompts", hint: F[n.kind] };
      const ke = F[n.kind + "-" + n.action];
      if (!n.category) return { crumb: ve, title: R[n.action], hint: ke };
      const De = ee.value.get(n.category);
      return { crumb: ve + " · " + R[n.action], title: n.category, hint: De && De.description ? De.description : ke };
    }), X = I(() => {
      if (!n.query.trim() || y.value !== "ready") return "";
      const ve = k.value.length, ke = !f.value && t.myPrompts.hasMore.value;
      return ve + (ke ? "+" : "") + (ve === 1 && !ke ? " match" : " matches");
    }), B = I(() => ({ image: te.value.kinds[0].count, video: te.value.kinds[1].count })), se = I(() => {
      const ve = n.category || (n.kind ? P[n.kind] + (n.action ? " · " + R[n.action] : "") : ""), ke = n.query.trim();
      return ke ? "Nothing " + (ve ? "in " + ve + " " : "") + "matches “" + ke + "”" : ve ? "No prompts in " + ve : "No prompts here";
    }), V = I(() => f.value ? t.prompt(n.detail) : t.myPrompt(n.detail)), Z = I(() => V.value ? k.value.findIndex((ve) => ve.id === V.value.id) : -1), Y = I(() => p.value ? p.value.prompts.length : 0), H = I(() => {
      const ve = k.value.length;
      if (f.value) return { n: ve, more: !1 };
      const ke = x.value;
      return ke && !n.query.trim() && !n.category && !n.levels.length && !n.kind ? { n: Math.max(ke.total, ve), more: !1 } : { n: ve, more: t.myPrompts.hasMore.value };
    });
    Ae(f, (ve) => t.myPrompts.setShown(!ve), { immediate: !0 });
    let re = null;
    Ae(() => [n.tab, n.levels.join(","), n.category, n.kind, n.action, h.value], () => {
      f.value || t.startMine();
    }), Ae(() => n.query, () => {
      re && clearTimeout(re), re = setTimeout(() => {
        re = null, f.value || t.startMine();
      }, Hle);
    });
    function le() {
      const ve = s.value;
      f.value || !ve || !t.myPrompts.hasMore.value || ve.scrollTop + ve.clientHeight >= ve.scrollHeight - Vle && t.myPrompts.loadMore();
    }
    function he() {
      Q(), le();
    }
    Ae(() => v.value.length, () => nt(le)), Ae(L, (ve) => {
      (f.value ? !p.value : !x.value) || n.category && !ve.some((ke) => ke.label === n.category) && t.setCategory(null);
    });
    function Re(ve) {
      const ke = Xa(e.catalog.value, ve.tool);
      return ke ? ke.name : ve.tool.name;
    }
    function Ne(ve) {
      if (ve === "company") return { icon: "Building2", label: "Company" };
      if (ve === "team") return { icon: "Users", label: xv(S.value) };
      const ke = M.value.find((De) => De.id === ve);
      return { icon: ke.icon, label: ke.label };
    }
    function Me(ve) {
      if (!Dr(ve)) return;
      const ke = lf(ve, e.meta.id).map(Ne);
      return Z8(ve, e.meta.id) ? [{ icon: "LayoutGrid", label: "Another board" }].concat(ke) : ke;
    }
    function ue(ve) {
      return c.value ? t.remixFills(ve, n.sessionId) ? "Remix sets this session up with the prompt, its tool and its images." : "Remix starts a new session beside this one, with the prompt, its tool and its images." : "Remix starts a new session with this prompt, its tool and its images.";
    }
    function U(ve) {
      const ke = P[ve.kind] + " " + R[ca(ve)].toLowerCase();
      return (Dr(ve) ? "My prompts" : "Featured") + " · " + ke + (ve.category ? " · " + ve.category : "");
    }
    function q(ve) {
      return Dr(ve) ? "Saved by " + (ve.authorId === e.user.uid ? "you" : ve.authorName || "someone") + (ve.updatedAt ? " · " + I1(ve.updatedAt) : "") : "";
    }
    const ie = I(() => (e.promptRev.value, e.results.rev.value, t.canSave ? t.draftForSession(n.sessionId) : null)), de = I(() => {
      if (!n.editing) return null;
      if (n.editing === "new") return ie.value;
      const ve = t.myPrompt(n.editing);
      return ve ? t.draftFor(ve) : null;
    }), pe = I(() => de.value ? de.value.output.thumb || de.value.output.url : "");
    function Te() {
      n.detail = null, n.editing = "new";
    }
    function Be(ve) {
      n.editing = null, n.detail = ve;
    }
    function ge(ve) {
      Q(), t.setTab(ve), nt(ae);
    }
    function ne(ve, ke = null, De = null) {
      Q(), t.setBranch(ve, ke, De), d.value = !1, nt(ae);
    }
    function oe(ve, ke) {
      l.value = ke, n.detail = ve.id;
    }
    function ye(ve) {
      const ke = k.value;
      if (!ke.length) return;
      if (!f.value && ve > 0 && Z.value === ke.length - 1 && t.myPrompts.hasMore.value) {
        const Qe = ke.length;
        t.myPrompts.loadMore().then(() => {
          const ft = k.value[Qe];
          ft && n.detail === ke[Qe - 1].id && (l.value = null, n.detail = ft.id);
        });
        return;
      }
      const De = Z.value < 0 ? 0 : (Z.value + ve + ke.length) % ke.length;
      l.value = null, n.detail = ke[De].id;
    }
    function Oe() {
      const ve = n.detail;
      n.detail = null, nt(() => {
        const ke = o.value && ve ? o.value.querySelector('[data-prompt-id="' + ve + '"] .pl-tile-hit') : null;
        ke && ke.focus({ preventScroll: !0 });
      });
    }
    function Ve() {
      n.query = "", r.value && r.value.focus();
    }
    function Ue(ve) {
      Dr(ve) && t.remove(ve);
    }
    function tt(ve) {
      Dr(ve) && (n.editing = ve.id);
    }
    Ae(() => n.query, () => {
      n.detail = null, s.value && (s.value.scrollTop = 0);
    });
    function Ye(ve) {
      ve.key === "Escape" ? (ve.preventDefault(), ve.stopPropagation(), n.query ? n.query = "" : r.value && r.value.blur()) : ve.key === "ArrowDown" && (ve.preventDefault(), wt(0));
    }
    function at() {
      return o.value ? Array.from(o.value.querySelectorAll(".pl-tile-hit")) : [];
    }
    function wt(ve) {
      const ke = at();
      if (!ke.length) return;
      const De = ke[Math.max(0, Math.min(ke.length - 1, ve))];
      De.focus(), De.scrollIntoView({ block: "nearest" });
    }
    function $e() {
      const ve = o.value;
      return ve ? Math.max(1, getComputedStyle(ve).gridTemplateColumns.split(" ").filter(Boolean).length) : 1;
    }
    function Fe(ve) {
      if (ve.key !== "ArrowDown" && ve.key !== "ArrowUp") return;
      const ke = a.value ? Array.from(a.value.querySelectorAll(".pl-node")) : [], De = ke.indexOf(document.activeElement);
      De < 0 || (ve.preventDefault(), ve.stopPropagation(), ke[Math.max(0, Math.min(ke.length - 1, De + (ve.key === "ArrowDown" ? 1 : -1)))].focus());
    }
    function W(ve) {
      if (!n.open || n.editing || ve.metaKey || ve.ctrlKey || ve.altKey) return;
      const ke = ve.target;
      if (ke && (ke.tagName === "INPUT" || ke.tagName === "TEXTAREA" || ke.isContentEditable) || ke && ke.closest && ke.closest(".pl-side") && ve.key !== "/") return;
      if (ve.key === "/") {
        ve.preventDefault(), r.value && r.value.focus();
        return;
      }
      if (V.value) {
        (ve.key === "ArrowRight" || ve.key === "ArrowLeft") && (ve.preventDefault(), ye(ve.key === "ArrowRight" ? 1 : -1));
        return;
      }
      const De = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: $e(), ArrowUp: -$e() };
      if (!(ve.key in De)) return;
      ve.preventDefault();
      const ft = at().indexOf(document.activeElement);
      wt(ft < 0 ? 0 : ft + De[ve.key]);
    }
    function Q() {
      s.value && (t.scroll[t.scrollKey()] = s.value.scrollTop);
    }
    function ae() {
      s.value && (s.value.scrollTop = t.scroll[t.scrollKey()] || 0);
    }
    Ae(y, (ve) => {
      ve === "ready" && nt(ae);
    }), ot(() => {
      window.addEventListener("keydown", W), nt(ae), BB();
    }), We(() => {
      window.removeEventListener("keydown", W), Q(), re && clearTimeout(re), t.myPrompts.setShown(!1);
    });
    function Le(ve) {
      return Dr(ve) && t.canEdit(ve);
    }
    return (ve, ke) => (g(), b("div", {
      class: G(["pl-wrap", { "is-floating": i.floating }]),
      "data-testid": "prompt-library",
      onPointerdown: ke[20] || (ke[20] = Se(() => {
      }, ["stop"]))
    }, [
      u("button", {
        class: "pl-close",
        title: "Close",
        "aria-label": "Close the prompt library",
        "data-testid": "library-close",
        onClick: ke[0] || (ke[0] = (De) => m(t).close())
      }, [
        C($, {
          name: "X",
          size: 15
        })
      ]),
      u("section", {
        class: G(["pl-panel", { "is-side-open": d.value }]),
        role: "dialog",
        "aria-label": "Prompt library"
      }, [
        u("aside", {
          ref_key: "sideEl",
          ref: a,
          class: "pl-side",
          "aria-label": "Browse prompts",
          "data-testid": "library-side",
          onKeydown: Fe
        }, [
          u("div", Hae, [
            u("button", {
              role: "tab",
              "aria-selected": m(n).tab === "featured",
              class: G({ on: m(n).tab === "featured" }),
              "data-testid": "tab-featured",
              onClick: ke[1] || (ke[1] = (De) => ge("featured"))
            }, [
              ke[21] || (ke[21] = J(" Featured", -1)),
              Y.value ? (g(), b("span", Wae, E(Y.value), 1)) : z("", !0)
            ], 10, Vae),
            u("button", {
              role: "tab",
              "aria-selected": m(n).tab === "mine",
              class: G({ on: m(n).tab === "mine" }),
              "data-testid": "tab-mine",
              onClick: ke[2] || (ke[2] = (De) => ge("mine"))
            }, [
              ke[22] || (ke[22] = J(" My prompts", -1)),
              w.value ? (g(), b("span", Kae, E(w.value), 1)) : z("", !0)
            ], 10, qae)
          ]),
          u("div", Yae, [
            u("nav", Xae, [
              u("button", {
                class: G(["pl-node is-root", { on: !m(n).kind }]),
                "aria-current": m(n).kind ? void 0 : "true",
                "data-testid": "kind-all",
                onClick: ke[3] || (ke[3] = (De) => ne(null))
              }, [
                C($, {
                  name: "LayoutGrid",
                  size: 14
                }),
                ke[23] || (ke[23] = u("span", { class: "lbl" }, "All prompts", -1)),
                u("span", Zae, E(te.value.total), 1)
              ], 10, Jae),
              (g(!0), b(j, null, be(te.value.kinds, (De) => (g(), b("div", {
                key: De.kind,
                class: G(["pl-branch", { "is-in": m(n).kind === De.kind }])
              }, [
                u("button", {
                  class: G(["pl-node is-kind", { on: m(n).kind === De.kind && !m(n).action, "is-empty": !De.count }]),
                  "aria-current": m(n).kind === De.kind && !m(n).action ? "true" : void 0,
                  "aria-label": P[De.kind] + " prompts, " + De.count,
                  "data-testid": "kind-" + De.kind,
                  onClick: (Qe) => ne(De.kind)
                }, [
                  C($, {
                    name: A[De.kind],
                    size: 14
                  }, null, 8, ["name"]),
                  u("span", ele, E(P[De.kind]), 1),
                  u("span", tle, E(De.count), 1)
                ], 10, Qae),
                (g(!0), b(j, null, be(De.actions, (Qe) => (g(), b(j, {
                  key: Qe.action
                }, [
                  u("button", {
                    class: G(["pl-node is-action", { on: m(n).kind === De.kind && m(n).action === Qe.action && !m(n).category, "is-in": m(n).kind === De.kind && m(n).action === Qe.action, "is-empty": !Qe.count }]),
                    "aria-current": m(n).kind === De.kind && m(n).action === Qe.action && !m(n).category ? "true" : void 0,
                    "aria-label": R[Qe.action] + " " + (De.kind === "image" ? "images" : "videos") + ", " + O[De.kind][Qe.action].toLowerCase() + ", " + Qe.count,
                    title: F[De.kind + "-" + Qe.action],
                    "data-testid": "action-" + De.kind + "-" + Qe.action,
                    onClick: (ft) => ne(De.kind, Qe.action)
                  }, [
                    C($, {
                      name: D[Qe.action],
                      size: 13
                    }, null, 8, ["name"]),
                    u("span", ile, [
                      J(E(R[Qe.action]), 1),
                      u("em", null, E(O[De.kind][Qe.action]), 1)
                    ]),
                    u("span", sle, E(Qe.count), 1)
                  ], 10, nle),
                  m(n).kind === De.kind && m(n).action === Qe.action && Qe.categories.length ? (g(), b("div", ole, [
                    (g(!0), b(j, null, be(Qe.categories, (ft) => {
                      var Dn;
                      return g(), b("button", {
                        key: ft.label,
                        class: G(["pl-node is-cat", { on: m(n).category === ft.label }]),
                        "aria-current": m(n).category === ft.label ? "true" : void 0,
                        title: ((Dn = ee.value.get(ft.label)) == null ? void 0 : Dn.description) || void 0,
                        "data-testid": "category-" + me(ft.label),
                        onClick: (Zn) => ne(De.kind, Qe.action, ft.label)
                      }, [
                        u("span", ale, E(ft.label), 1),
                        u("span", lle, E(ft.count), 1)
                      ], 10, rle);
                    }), 128))
                  ])) : z("", !0)
                ], 64))), 128))
              ], 2))), 128))
            ]),
            f.value ? z("", !0) : (g(), b("section", dle, [
              ke[24] || (ke[24] = u("span", { class: "pl-side-label" }, "Shared with", -1)),
              (g(!0), b(j, null, be(M.value, (De) => (g(), b("button", {
                key: De.id,
                class: G(["pl-node is-level", { on: m(n).levels.includes(De.id) }]),
                "aria-pressed": m(n).levels.includes(De.id),
                "data-testid": "level-filter-" + De.id,
                onClick: (Qe) => T(De.id)
              }, [
                u("span", ule, [
                  C($, {
                    name: "Check",
                    size: 10,
                    stroke: 3
                  })
                ]),
                C($, {
                  name: De.icon,
                  size: 13
                }, null, 8, ["name"]),
                u("span", hle, E(De.label), 1),
                u("span", ple, E(_(De.id)), 1)
              ], 10, cle))), 128))
            ]))
          ])
        ], 544),
        d.value ? (g(), b("div", {
          key: 0,
          class: "pl-side-scrim",
          onClick: ke[4] || (ke[4] = (De) => d.value = !1)
        })) : z("", !0),
        u("div", fle, [
          u("header", mle, [
            u("button", {
              class: "pl-icon-btn pl-side-toggle",
              "aria-expanded": d.value,
              title: "Browse by kind and category",
              "aria-label": "Browse by kind and category",
              "data-testid": "library-side-toggle",
              onClick: ke[5] || (ke[5] = (De) => d.value = !d.value)
            }, [
              C($, {
                name: "PanelLeft",
                size: 16
              })
            ], 8, gle),
            u("label", ble, [
              C($, {
                name: "Search",
                size: 14
              }),
              kt(u("input", {
                ref_key: "searchEl",
                ref: r,
                "onUpdate:modelValue": ke[6] || (ke[6] = (De) => m(n).query = De),
                placeholder: f.value ? "Search featured prompts" : "Search your prompts",
                spellcheck: "false",
                "data-testid": "library-search",
                onKeydown: Ye
              }, null, 40, vle), [
                [Zt, m(n).query]
              ]),
              m(n).query ? (g(), b("button", {
                key: 0,
                class: "pl-clear",
                title: "Clear the search",
                "aria-label": "Clear the search",
                onClick: Ve
              }, [
                C($, {
                  name: "X",
                  size: 12
                })
              ])) : (g(), b("kbd", yle, "/"))
            ]),
            !f.value && ie.value && !m(n).editing ? (g(), b("button", {
              key: 0,
              class: "pl-btn is-glass is-lg pl-head-act",
              title: "Save this session's prompt, tool and settings",
              "data-testid": "save-current",
              onClick: Te
            }, [
              C($, {
                name: "Plus",
                size: 13
              }),
              ke[25] || (ke[25] = J("Save current prompt ", -1))
            ])) : z("", !0)
          ]),
          !V.value && !m(n).editing ? (g(), b("div", xle, [
            N.value.crumb ? (g(), b("span", wle, [
              J(E(N.value.crumb), 1),
              C($, {
                name: "ChevronRight",
                size: 12
              })
            ])) : z("", !0),
            u("b", kle, E(N.value.title), 1),
            u("span", {
              class: "pl-scope-hint",
              title: N.value.hint
            }, E(N.value.hint), 9, _le),
            X.value ? (g(), b("span", Sle, E(X.value), 1)) : z("", !0)
          ])) : z("", !0),
          u("div", Mle, [
            u("div", {
              ref_key: "bodyEl",
              ref: s,
              class: G(["pl-body", { "is-covered": !!V.value || !!m(n).editing }]),
              onScrollPassive: he
            }, [
              y.value === "idle" || y.value === "loading" ? (g(), b("div", Tle, [
                (g(), b(j, null, be(6, (De) => u("span", {
                  key: De,
                  class: "pl-tile is-skeleton"
                })), 64))
              ])) : y.value === "failed" ? (g(), b("div", Cle, [
                C($, {
                  name: "CloudOff",
                  size: 22
                }),
                u("b", null, E(f.value ? "The Featured prompts couldn't be loaded" : "Your prompts couldn't be loaded"), 1),
                ke[26] || (ke[26] = u("span", null, "Check your connection, then try again.", -1)),
                f.value ? (g(), b("button", {
                  key: 0,
                  class: "pl-btn is-glass is-lg",
                  onClick: ke[7] || (ke[7] = (De) => m(t).load())
                }, "Try again")) : (g(), b("button", {
                  key: 1,
                  class: "pl-btn is-glass is-lg",
                  "data-testid": "library-mine-retry",
                  onClick: ke[8] || (ke[8] = (De) => m(t).startMine())
                }, "Try again"))
              ])) : f.value && !Y.value ? (g(), b("div", Ile, [
                C($, {
                  name: "LayoutTemplate",
                  size: 22
                }),
                ke[27] || (ke[27] = u("b", null, "Featured prompts are in development", -1)),
                m(e).user.isAdmin ? (g(), b("span", Ale, "No Featured set is published here yet.")) : z("", !0)
              ])) : !f.value && !m(t).canSave ? (g(), b("div", Ple, [
                u("span", Ele, [
                  C($, {
                    name: "Bookmark",
                    size: 20
                  })
                ]),
                ke[28] || (ke[28] = u("b", null, "Your own prompts", -1)),
                ke[29] || (ke[29] = u("span", null, "Saving prompts isn't available here.", -1))
              ])) : !f.value && !w.value && !v.value.length ? (g(), b("div", Rle, [
                u("span", zle, [
                  C($, {
                    name: "Bookmark",
                    size: 20
                  })
                ]),
                ke[31] || (ke[31] = u("b", null, "Nothing saved yet", -1)),
                u("span", null, "Save the prompt behind a result you like: select it on the canvas, open its record or hover it in a session's gallery, and choose Save prompt. Keep it for yourself, or share it with this board or your " + E(S.value) + ".", 1),
                ie.value ? (g(), b("button", {
                  key: 0,
                  class: "pl-btn is-glass is-lg",
                  onClick: Te
                }, [
                  C($, {
                    name: "Plus",
                    size: 13
                  }),
                  ke[30] || (ke[30] = J("Save current prompt", -1))
                ])) : z("", !0)
              ])) : f.value && m(n).kind === "video" && B.value && !B.value.video ? (g(), b("div", $le, [
                u("span", Dle, [
                  C($, {
                    name: "Video",
                    size: 20
                  })
                ]),
                ke[32] || (ke[32] = u("b", null, "Featured video prompts are in development", -1)),
                ke[33] || (ke[33] = u("span", null, "Prompts you save from a video session are under My prompts.", -1)),
                u("span", Ole, [
                  u("button", {
                    class: "pl-btn is-glass",
                    onClick: ke[9] || (ke[9] = (De) => ge("mine"))
                  }, "My prompts"),
                  u("button", {
                    class: "pl-btn is-glass",
                    onClick: ke[10] || (ke[10] = (De) => ne(null))
                  }, "All prompts")
                ])
              ])) : k.value.length ? (g(), b("div", {
                key: 7,
                ref_key: "gridEl",
                ref: o,
                class: "pl-grid",
                "data-testid": "library-grid"
              }, [
                (g(!0), b(j, null, be(k.value, (De) => (g(), Ce(Jre, {
                  key: De.id,
                  prompt: De,
                  "tool-name": Re(De),
                  "remix-hint": ue(De),
                  levels: Me(De),
                  onOpen: (Qe) => oe(De, Qe),
                  onUse: (Qe) => m(t).use(De, m(n).sessionId),
                  onRemix: (Qe) => m(t).remix(De, m(n).sessionId)
                }, null, 8, ["prompt", "tool-name", "remix-hint", "levels", "onOpen", "onUse", "onRemix"]))), 128))
              ], 512)) : (g(), b("div", Lle, [
                C($, {
                  name: "Search",
                  size: 22
                }),
                u("b", null, E(se.value), 1),
                u("span", Ble, [
                  m(n).category ? (g(), b("button", {
                    key: 0,
                    class: "pl-btn is-glass",
                    onClick: ke[11] || (ke[11] = (De) => ne(m(n).kind, m(n).action))
                  }, "Every category")) : z("", !0),
                  m(n).kind ? (g(), b("button", {
                    key: 1,
                    class: "pl-btn is-glass",
                    onClick: ke[12] || (ke[12] = (De) => ne(null))
                  }, "All prompts")) : z("", !0),
                  m(n).levels.length ? (g(), b("button", {
                    key: 2,
                    class: "pl-btn is-glass",
                    onClick: ke[13] || (ke[13] = (De) => m(n).levels = [])
                  }, "Every level")) : z("", !0),
                  m(n).query ? (g(), b("button", {
                    key: 3,
                    class: "pl-btn is-glass",
                    onClick: Ve
                  }, "Clear the search")) : z("", !0)
                ])
              ]))
            ], 34),
            C(vt, { name: "pl-detail" }, {
              default: Xe(() => [
                V.value && !m(n).editing ? (g(), Ce(jae, {
                  key: 0,
                  prompt: V.value,
                  index: Z.value < 0 ? 0 : Z.value,
                  total: H.value.n,
                  more: H.value.more,
                  "tool-name": Re(V.value),
                  note: m(t).toolNote(V.value, m(n).sessionId),
                  "remix-hint": ue(V.value),
                  from: l.value,
                  crumb: U(V.value),
                  byline: q(V.value),
                  levels: Me(V.value),
                  "can-edit": Le(V.value),
                  onBack: Oe,
                  onStep: ye,
                  onUse: ke[14] || (ke[14] = (De) => m(t).use(V.value, m(n).sessionId)),
                  onRemix: ke[15] || (ke[15] = (De) => m(t).remix(V.value, m(n).sessionId)),
                  onEdit: ke[16] || (ke[16] = (De) => tt(V.value)),
                  onDelete: ke[17] || (ke[17] = (De) => Ue(V.value))
                }, null, 8, ["prompt", "index", "total", "more", "tool-name", "note", "remix-hint", "from", "crumb", "byline", "levels", "can-edit"])) : z("", !0)
              ]),
              _: 1
            }),
            C(vt, { name: "pl-detail" }, {
              default: Xe(() => [
                m(n).editing && de.value ? (g(), b("div", Fle, [
                  u("div", Nle, [
                    pe.value ? (g(), b("img", {
                      key: 0,
                      class: "pl-detail-img",
                      src: pe.value,
                      alt: "",
                      draggable: "false"
                    }, null, 8, Ule)) : (g(), b("span", Gle, E(de.value.prompt), 1)),
                    u("button", {
                      class: "pl-back",
                      title: "Back",
                      "aria-label": "Back",
                      onClick: ke[18] || (ke[18] = (De) => m(n).editing = null)
                    }, [
                      C($, {
                        name: "ArrowLeft",
                        size: 15
                      })
                    ])
                  ]),
                  u("div", jle, [
                    (g(), Ce(nS, {
                      key: m(n).editing,
                      draft: de.value,
                      "editing-id": m(n).editing === "new" ? null : m(n).editing,
                      onDone: Be,
                      onCancel: ke[19] || (ke[19] = (De) => m(n).editing = null)
                    }, null, 8, ["draft", "editing-id"]))
                  ])
                ])) : z("", !0)
              ]),
              _: 1
            })
          ])
        ])
      ], 2)
    ], 34));
  }
}), Wle = { class: "up-pop-label" }, qle = ["aria-label"], Kle = ["aria-selected", "data-testid", "onClick"], Yle = {
  key: 0,
  class: "up-refgrid",
  "data-testid": "ref-pinned"
}, Xle = ["title", "onClick"], Jle = {
  key: 0,
  class: "up-refgrid"
}, Zle = ["title", "onClick"], Qle = {
  key: 1,
  class: "up-adv-hint up-refpick-note"
}, ede = {
  key: 0,
  class: "up-refgrid",
  "data-testid": "ref-library"
}, tde = ["title", "onClick"], nde = {
  key: 1,
  class: "up-adv-hint up-refpick-note"
}, ide = {
  key: 2,
  class: "up-adv-hint up-refpick-note"
}, sde = {
  key: 3,
  class: "up-adv-hint up-refpick-note"
}, ode = { class: "up-pop-main" }, rde = ["disabled"], ade = { class: "up-pop-main" }, lde = ["accept"], dde = {
  key: 6,
  class: "up-refpick-tip",
  "data-testid": "ref-tip"
}, cde = {
  key: 7,
  class: "up-refpick-tip",
  "data-testid": "ref-shift-tip"
}, Zc = /* @__PURE__ */ Pe({
  __name: "RefPicker",
  props: {
    sessionId: {},
    label: {},
    kind: { default: "image" },
    dropperLabel: { default: "Pick from the board" },
    tip: { default: "" },
    dropper: { type: Boolean, default: !0 }
  },
  emits: ["pick", "dropper", "close"],
  setup(i, { emit: e }) {
    const t = i, n = e, { board: s } = Ze(), o = /* @__PURE__ */ K(null), r = sm().shift, a = /* @__PURE__ */ K(!1), l = I(() => t.kind === "video"), d = [
      { id: "pinned", label: "Pinned" },
      { id: "board", label: "This board" },
      ...s.hasLibrary ? [
        { id: "generations", label: "Generations" },
        { id: "uploads", label: "Uploads" },
        { id: "favorites", label: "Favorites" }
      ] : []
    ], c = I(() => s.pinnedImages.value.filter((R) => !!R.video === l.value)), h = /* @__PURE__ */ K(c.value.length ? "pinned" : "board");
    function f(R) {
      R.asset && s.rememberAsset(R.url, R.asset), n("pick", R.url);
    }
    const p = I(() => {
      s.docRev.value, s.results.rev.value;
      const R = /* @__PURE__ */ new Set(), D = [];
      for (const F of s.results.list(t.sessionId))
        F.status !== "done" || !F.url || !!F.video !== l.value || R.has(F.url) || (R.add(F.url), D.push({ url: F.url, label: F.label || "result" }));
      const O = s.imagesInOrder().slice().reverse();
      for (const F of O)
        if (!(!!F.video !== l.value || R.has(F.src)) && (R.add(F.src), D.push({ url: F.src, label: F.label || "image" }), D.length >= 60))
          break;
      return D;
    }), y = /* @__PURE__ */ Xt({
      generations: { items: [], next: null, loading: !1, loaded: !1, failed: !1 },
      uploads: { items: [], next: null, loading: !1, loaded: !1, failed: !1 },
      favorites: { items: [], next: null, loading: !1, loaded: !1, failed: !1 }
    });
    async function v(R, D = !1) {
      const O = y[R];
      if (!O.loading) {
        O.loading = !0, O.failed = !1;
        try {
          const F = await s.libraryPage(R, { cursor: D ? O.next : null });
          O.items = D ? O.items.concat(F.items) : F.items, O.next = F.next, O.loaded = !0;
        } catch (F) {
          console.warn("[board] library unavailable", F), O.failed = !0;
        } finally {
          O.loading = !1;
        }
      }
    }
    const x = (R) => R !== "board" && R !== "pinned";
    Ae(h, (R) => {
      x(R) && !y[R].loaded && v(R);
    });
    function w() {
      const R = h.value;
      x(R) && v(R, !0);
    }
    const S = I(() => {
      const R = h.value;
      return x(R) ? y[R] : null;
    }), M = I(() => S.value ? S.value.items.filter((R) => R.video === l.value && !R.moderated) : []), _ = I(() => {
      const R = l.value ? "videos" : "images";
      return h.value === "generations" ? "No generated " + R + " yet." : h.value === "uploads" ? "No uploaded " + R + " yet." : "Star a result to keep it here.";
    });
    function T(R) {
      s.rememberAsset(R.url, R.asset), n("pick", R.url);
    }
    function k() {
      s.openLibrary({
        purpose: "pick",
        max: 1,
        kinds: [t.kind],
        onPick: (R) => {
          R[0] && T(R[0]);
        }
      });
    }
    const P = I(() => !!s.uploader && (!l.value || s.canUploadVideo));
    async function A(R) {
      const D = R.target.files;
      if (!(!D || !D.length || !s.uploader)) {
        a.value = !0;
        try {
          const { url: O } = l.value ? await s.uploadVideoFile(D[0]) : await s.uploadFile(D[0]);
          n("pick", O);
        } catch (O) {
          const F = O ? O.userMessage : void 0;
          s.toast(F || (l.value ? "That video could not be uploaded." : "That image could not be uploaded."), "error");
        } finally {
          a.value = !1;
        }
      }
    }
    return (R, D) => (g(), b("div", {
      class: "up-pop up-refpick has-tabs",
      "data-testid": "ref-picker",
      onPointerdown: D[2] || (D[2] = Se(() => {
      }, ["stop"]))
    }, [
      u("div", Wle, E(i.label), 1),
      u("div", {
        class: "up-pop-tabs",
        role: "tablist",
        "aria-label": i.label + " sources"
      }, [
        (g(), b(j, null, be(d, (O) => u("button", {
          key: O.id,
          role: "tab",
          "aria-selected": h.value === O.id,
          class: G({ on: h.value === O.id }),
          "data-testid": "ref-tab-" + O.id,
          onClick: (F) => h.value = O.id
        }, E(O.label), 11, Kle)), 64))
      ], 8, qle),
      h.value === "pinned" ? (g(), b(j, { key: 0 }, [
        c.value.length ? (g(), b("div", Yle, [
          (g(!0), b(j, null, be(c.value, (O) => (g(), b("button", {
            key: O.id,
            class: G(["up-refcell", { "is-video": O.video }]),
            title: O.label,
            style: ce({ backgroundImage: 'url("' + m(Bt)(O.url) + '")' }),
            onClick: (F) => f(O)
          }, null, 14, Xle))), 128))
        ])) : (g(), Ce(U1, {
          key: 1,
          compact: "",
          kind: i.kind
        }, null, 8, ["kind"]))
      ], 64)) : h.value === "board" ? (g(), b(j, { key: 1 }, [
        p.value.length ? (g(), b("div", Jle, [
          (g(!0), b(j, null, be(p.value, (O) => (g(), b("button", {
            key: O.url,
            class: "up-refcell",
            title: O.label,
            style: ce({ backgroundImage: 'url("' + m(Bt)(O.url) + '")' }),
            onClick: (F) => n("pick", O.url)
          }, null, 12, Zle))), 128))
        ])) : (g(), b("div", Qle, E(i.kind === "video" ? "No videos on this board yet." : "No images on this board yet."), 1))
      ], 64)) : S.value ? (g(), b(j, { key: 2 }, [
        M.value.length ? (g(), b("div", ede, [
          (g(!0), b(j, null, be(M.value, (O) => (g(), b("button", {
            key: O.id,
            class: G(["up-refcell", { "is-video": O.video }]),
            title: O.label,
            style: ce({ backgroundImage: 'url("' + m(Bt)(O.url) + '")' }),
            onClick: (F) => T(O)
          }, null, 14, tde))), 128))
        ])) : z("", !0),
        S.value.loading ? (g(), b("div", nde, [...D[3] || (D[3] = [
          u("span", { class: "bd-spinner is-sm" }, null, -1),
          J("Loading", -1)
        ])])) : S.value.failed ? (g(), b("div", ide, "This couldn't be loaded.")) : M.value.length ? z("", !0) : (g(), b("div", sde, E(_.value), 1)),
        S.value.next && !S.value.loading ? (g(), b("button", {
          key: 4,
          class: "up-pop-row up-refpick-more",
          onClick: w
        }, [
          C($, {
            name: "ChevronDown",
            size: 13
          }),
          D[4] || (D[4] = u("span", { class: "up-pop-main" }, "Load more", -1))
        ])) : z("", !0)
      ], 64)) : z("", !0),
      i.dropper ? (g(), b("button", {
        key: 3,
        class: "up-pop-row",
        "data-testid": "ref-pick-from-board",
        onClick: D[0] || (D[0] = (O) => n("dropper"))
      }, [
        C($, {
          name: "Pipette",
          size: 13
        }),
        u("span", ode, E(i.dropperLabel), 1)
      ])) : z("", !0),
      m(s).hasLibrary ? (g(), b("button", {
        key: 4,
        class: "up-pop-row",
        "data-testid": "ref-open-library",
        onClick: k
      }, [
        C($, {
          name: "Library",
          size: 13
        }),
        D[5] || (D[5] = u("span", { class: "up-pop-main" }, "Open your Library", -1))
      ])) : z("", !0),
      P.value ? (g(), b("button", {
        key: 5,
        class: "up-pop-row",
        disabled: a.value,
        "data-testid": "ref-upload",
        onClick: D[1] || (D[1] = (O) => o.value && o.value.click())
      }, [
        C($, {
          name: a.value ? "Loader2" : "Upload",
          size: 13,
          spin: a.value
        }, null, 8, ["name", "spin"]),
        u("span", ade, E(a.value ? "Uploading…" : l.value ? "Upload a video" : "Upload an image"), 1)
      ], 8, rde)) : z("", !0),
      u("input", {
        ref_key: "fileEl",
        ref: o,
        type: "file",
        accept: l.value ? "video/*" : "image/*",
        style: { display: "none" },
        onChange: A
      }, null, 40, lde),
      i.tip ? (g(), b("div", dde, [
        C($, {
          name: "Hand",
          size: 13
        }),
        u("span", null, E(i.tip), 1)
      ])) : (g(), b("div", cde, [
        u("kbd", null, E(m(r)), 1),
        u("span", null, "Or hold Shift and drag " + E(i.kind === "video" ? "a video" : "an image") + " from the board here, or onto any session.", 1)
      ]))
    ], 32));
  }
}), ude = { class: "up-pop-label" }, hde = {
  key: 0,
  class: "up-pop-search"
}, pde = { class: "up-modelpick-av is-none" }, fde = {
  key: 0,
  class: "up-modelpick-group"
}, mde = ["title", "onClick"], gde = ["src", "onError"], bde = {
  key: 1,
  class: "up-modelpick-av"
}, vde = { class: "up-pop-main" }, yde = {
  key: 0,
  class: "up-modelpick-desc"
}, xde = {
  key: 2,
  class: "up-modelpick-note"
}, wde = {
  key: 3,
  class: "up-modelpick-note"
}, kde = {
  key: 4,
  class: "up-modelpick-note"
}, _de = {
  key: 5,
  class: "up-modelpick-note"
}, Sde = /* @__PURE__ */ Pe({
  __name: "ModelFieldPop",
  props: {
    field: {},
    selectedId: {},
    required: { type: Boolean }
  },
  emits: ["pick"],
  setup(i, { emit: e }) {
    const t = i, n = e, { board: s } = Ze(), o = /* @__PURE__ */ K(!0), r = /* @__PURE__ */ K(!1), a = /* @__PURE__ */ K(""), l = /* @__PURE__ */ K(s.trainedModelsSeen.value || []);
    ot(async () => {
      try {
        l.value = await s.trainedModels();
      } catch (x) {
        console.warn("[board] trained models unavailable", x), r.value = !0;
      } finally {
        o.value = !1;
      }
    });
    const d = I(() => l.value.filter((x) => !t.field.architecture || x.architecture === t.field.architecture)), c = I(() => {
      const x = a.value.trim().toLowerCase();
      return x ? d.value.filter((w) => w.name.toLowerCase().includes(x) || (w.description || "").toLowerCase().includes(x)) : d.value;
    }), h = I(() => c.value.filter((x) => !x.shared)), f = I(() => c.value.filter((x) => x.shared)), p = I(() => [
      { key: "yours", label: f.value.length ? "Yours" : "", list: h.value },
      { key: "shared", label: "Shared", list: f.value }
    ].filter((x) => x.list.length)), y = I(() => t.field.architecture ? t.field.architecture + " " : "");
    function v(x, w) {
      const S = x.target;
      w.image && S.src !== w.image && (S.src = w.image);
    }
    return (x, w) => (g(), b("div", {
      class: "up-pop is-wide up-modelpick",
      "data-testid": "model-field-pop",
      onPointerdown: w[3] || (w[3] = Se(() => {
      }, ["stop"]))
    }, [
      u("div", ude, E(i.field.label || "Trained model"), 1),
      d.value.length > 6 ? (g(), b("div", hde, [
        C($, {
          name: "Search",
          size: 12
        }),
        kt(u("input", {
          "onUpdate:modelValue": w[0] || (w[0] = (S) => a.value = S),
          placeholder: "Search your models",
          onKeydown: w[1] || (w[1] = Se(() => {
          }, ["stop"]))
        }, null, 544), [
          [Zt, a.value]
        ])
      ])) : z("", !0),
      !i.required && i.selectedId ? (g(), b("button", {
        key: 1,
        class: "up-pop-row",
        "data-testid": "model-field-none",
        onClick: w[2] || (w[2] = (S) => n("pick", null))
      }, [
        u("span", pde, [
          C($, {
            name: "X",
            size: 13
          })
        ]),
        w[4] || (w[4] = u("span", { class: "up-pop-main" }, "Don't use a trained model", -1))
      ])) : z("", !0),
      (g(!0), b(j, null, be(p.value, (S) => (g(), b(j, {
        key: S.key
      }, [
        S.label ? (g(), b("div", fde, E(S.label), 1)) : z("", !0),
        (g(!0), b(j, null, be(S.list, (M) => (g(), b("button", {
          key: M.id,
          class: G(["up-pop-row up-modelpick-row", { on: M.id === i.selectedId }]),
          title: M.description || M.name,
          onClick: (_) => n("pick", M.record)
        }, [
          M.thumb ? (g(), b("img", {
            key: 0,
            class: "up-modelpick-av",
            src: M.thumb,
            alt: "",
            draggable: "false",
            onError: (_) => v(_, M)
          }, null, 40, gde)) : (g(), b("span", bde, [
            C($, {
              name: "Sparkles",
              size: 13
            })
          ])),
          u("span", vde, [
            J(E(M.name) + " ", 1),
            M.description ? (g(), b("span", yde, E(M.description), 1)) : z("", !0)
          ]),
          M.id === i.selectedId ? (g(), Ce($, {
            key: 2,
            name: "Check",
            size: 13
          })) : z("", !0)
        ], 10, mde))), 128))
      ], 64))), 128)),
      o.value && !l.value.length ? (g(), b("div", xde, [...w[5] || (w[5] = [
        u("span", { class: "bd-spinner is-sm" }, null, -1),
        J("Loading your models", -1)
      ])])) : r.value && !l.value.length ? (g(), b("div", wde, "Your models couldn't be loaded.")) : !o.value && !d.value.length ? (g(), b("div", kde, " No " + E(y.value) + "models yet. Models you train show up here. ", 1)) : a.value && !c.value.length ? (g(), b("div", _de, "No models match “" + E(a.value) + "”.", 1)) : z("", !0)
    ], 32));
  }
}), Mde = { class: "media" }, Tde = ["poster", "autoplay", "data-slide"], Cde = ["src"], Ide = ["src", "data-slide"], Ade = { class: "tag" }, Pde = { class: "body" }, Ede = { class: "foot" }, Rde = {
  class: "dots",
  role: "tablist",
  "aria-label": "Slides"
}, zde = ["aria-selected", "aria-label", "onClick"], $de = { class: "cta" }, Eh = "/img/board/studio-view/", Dde = 500, ab = 3400, lb = 7e3, Ode = /* @__PURE__ */ Pe({
  __name: "StudioViewButton",
  emits: ["open"],
  setup(i, { emit: e }) {
    const t = e, { board: n } = Ze(), s = [
      { id: "overview", video: !1, title: "Your session, full screen", text: "The picture large, its versions above it, the board's history beside it." },
      { id: "area", video: !0, title: "Change just one area", text: "Paint over it and say what changes. Precision keeps every other pixel." },
      { id: "refs", video: !0, title: "References from history", text: "Pick pictures from history to guide the edit, or drag them in." },
      { id: "camera", video: !0, title: "Move the camera", text: "See the same scene from another angle." },
      { id: "relight", video: !0, title: "Relight it", text: "Golden hour, dusk or night: new light on the same scene." },
      { id: "compare", video: !0, title: "Compare versions", text: "Every result is a version. Split two to see what changed." }
    ], o = typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches, r = /* @__PURE__ */ K(!1), a = /* @__PURE__ */ K(0), l = /* @__PURE__ */ K(ab / 1e3), d = I(() => s[a.value]);
    let c = 0, h = 0, f = 0;
    function p() {
      clearTimeout(h), !(r.value || n.tour) && (clearTimeout(c), c = window.setTimeout(v, Dde));
    }
    function y() {
      clearTimeout(c), clearTimeout(h), h = window.setTimeout(() => {
        r.value = !1, clearTimeout(f);
      }, 160);
    }
    function v() {
      w(), a.value = 0, r.value = !0, S();
    }
    let x = !1;
    function w() {
      if (!x) {
        x = !0;
        for (const P of s) {
          const A = new Image();
          A.src = Eh + P.id + ".jpg";
        }
      }
    }
    function S() {
      if (clearTimeout(f), o) return;
      const P = d.value;
      l.value = (P.video ? lb : ab) / 1e3, f = window.setTimeout(_, P.video ? lb : ab);
    }
    function M(P) {
      a.value = (P + s.length) % s.length, S();
    }
    function _() {
      M(a.value + 1);
    }
    function T(P) {
      const A = P.target;
      Number.isFinite(A.duration) && A.duration > 0 && (l.value = A.duration, clearTimeout(f), f = window.setTimeout(_, Math.min(lb, A.duration * 1e3 + 600)));
    }
    function k() {
      clearTimeout(c), clearTimeout(f), r.value = !1, t("open");
    }
    return We(() => {
      clearTimeout(c), clearTimeout(h), clearTimeout(f);
    }), (P, A) => (g(), b("span", {
      class: "up-studio-wrap",
      onMouseenter: p,
      onMouseleave: y
    }, [
      u("button", {
        class: G(["up-studio", { on: r.value }]),
        "aria-label": "Studio view: open this session full screen",
        "data-testid": "prompt-studio",
        onClick: k,
        onFocus: p,
        onBlur: y
      }, [
        C($, {
          name: "Expand",
          size: 13
        }),
        A[0] || (A[0] = u("span", null, "Studio", -1))
      ], 34),
      C(vt, { name: "up-studio-pop" }, {
        default: Xe(() => [
          r.value ? (g(), b("div", {
            key: 0,
            class: "up-studio-pop",
            role: "dialog",
            "aria-label": "Studio view",
            "data-testid": "studio-view-preview",
            onClick: k
          }, [
            u("div", Mde, [
              C(vt, { name: "up-studio-slide" }, {
                default: Xe(() => [
                  d.value.video ? (g(), b("video", {
                    key: d.value.id,
                    poster: Eh + d.value.id + (m(o) ? "-end" : "") + ".jpg",
                    autoplay: !m(o),
                    muted: "",
                    playsinline: "",
                    preload: "auto",
                    disablepictureinpicture: "",
                    "data-slide": d.value.id,
                    onLoadedmetadata: T
                  }, [
                    u("source", {
                      src: Eh + d.value.id + ".webm",
                      type: "video/webm"
                    }, null, 8, Cde)
                  ], 40, Tde)) : (g(), b("img", {
                    key: d.value.id,
                    src: Eh + d.value.id + ".jpg",
                    alt: "",
                    "data-slide": d.value.id,
                    draggable: "false"
                  }, null, 8, Ide))
                ]),
                _: 1
              }),
              u("span", Ade, [
                C($, {
                  name: "Expand",
                  size: 10
                }),
                A[1] || (A[1] = J(" Studio view", -1))
              ])
            ]),
            u("div", Pde, [
              C(vt, {
                name: "up-studio-words",
                mode: "out-in"
              }, {
                default: Xe(() => [
                  (g(), b("div", {
                    key: d.value.id,
                    class: "words"
                  }, [
                    u("b", null, E(d.value.title), 1),
                    u("span", null, E(d.value.text), 1)
                  ]))
                ]),
                _: 1
              }),
              u("div", Ede, [
                u("span", Rde, [
                  (g(), b(j, null, be(s, (R, D) => u("button", {
                    key: R.id,
                    role: "tab",
                    "aria-selected": D === a.value,
                    "aria-label": R.title,
                    class: G({ on: D === a.value }),
                    style: ce(D === a.value ? { "--d": l.value + "s" } : void 0),
                    onClick: Se((O) => M(D), ["stop"])
                  }, [
                    (g(), b("i", {
                      key: a.value + ":" + D
                    }))
                  ], 14, zde)), 64))
                ]),
                u("span", $de, [
                  A[2] || (A[2] = J("Open Studio ", -1)),
                  C($, {
                    name: "ArrowRight",
                    size: 11
                  })
                ])
              ])
            ])
          ])) : z("", !0)
        ]),
        _: 1
      })
    ], 32));
  }
}), Lde = ["aria-expanded", "aria-label", "title", "disabled"], Bde = ["data-testid"], Fde = { class: "sv-pop-rows" }, Nde = ["aria-selected", "data-testid", "onClick"], Ude = { class: "nm" }, Jy = /* @__PURE__ */ Pe({
  __name: "CountPick",
  props: {
    value: {},
    min: { default: 1 },
    max: {},
    testid: { default: void 0 },
    tall: { type: Boolean, default: !1 }
  },
  emits: ["update"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = /* @__PURE__ */ K(!1), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = I(() => {
      const x = [];
      for (let w = Math.max(1, t.min); w <= Math.max(t.min, t.max); w++) x.push(w);
      return x;
    }), d = I(() => l.value.length < 2);
    function c(x) {
      s.value = !1, x && nt(() => {
        var w;
        return (w = r.value) == null ? void 0 : w.focus({ preventScroll: !0 });
      });
    }
    function h(x) {
      c(!0), x !== t.value && n("update", x);
    }
    function f() {
      return a.value ? [...a.value.querySelectorAll('[role="option"]')] : [];
    }
    function p(x) {
      const w = f(), S = w.indexOf(document.activeElement);
      let M = -1;
      x.key === "ArrowDown" ? M = Math.min(w.length - 1, S + 1) : x.key === "ArrowUp" ? M = Math.max(0, S < 0 ? w.length - 1 : S - 1) : x.key === "Home" ? M = 0 : x.key === "End" && (M = w.length - 1), !(M < 0) && (x.preventDefault(), w[M].focus());
    }
    function y(x) {
      o.value && !o.value.contains(x.target) && c(!1);
    }
    function v(x) {
      x.key === "Escape" && (x.stopPropagation(), x.preventDefault(), c(!0));
    }
    return Ae(s, (x) => {
      x ? (window.addEventListener("pointerdown", y, !0), window.addEventListener("keydown", v, !0), nt(() => {
        const w = f().find((S) => S.getAttribute("aria-selected") === "true");
        w && w.focus({ preventScroll: !0 });
      })) : (window.removeEventListener("pointerdown", y, !0), window.removeEventListener("keydown", v, !0));
    }), We(() => {
      window.removeEventListener("pointerdown", y, !0), window.removeEventListener("keydown", v, !0);
    }), (x, w) => (g(), b("span", {
      ref_key: "wrap",
      ref: o,
      class: "up-count-wrap"
    }, [
      u("button", {
        ref_key: "btn",
        ref: r,
        class: G(["up-count", { on: s.value, "is-tall": i.tall }]),
        "aria-expanded": s.value,
        "aria-haspopup": "listbox",
        "aria-label": "How many to make: " + i.value,
        title: d.value ? "This model makes " + i.value + " a run" : "How many to make",
        disabled: d.value,
        "data-testid": "count-pick",
        onClick: w[0] || (w[0] = (S) => s.value = !s.value)
      }, [
        u("span", {
          class: "n",
          "data-testid": i.testid
        }, E(i.value), 9, Bde),
        d.value ? z("", !0) : (g(), Ce($, {
          key: 0,
          name: "ChevronDown",
          size: 12,
          class: "chev"
        }))
      ], 10, Lde),
      s.value ? (g(), b("div", {
        key: 0,
        ref_key: "list",
        ref: a,
        class: "sv-pop is-narrow up-count-pop",
        role: "listbox",
        "aria-label": "How many to make",
        "data-testid": "count-menu",
        onKeydown: p
      }, [
        w[1] || (w[1] = u("div", { class: "sv-pop-title" }, "How many", -1)),
        u("div", Fde, [
          (g(!0), b(j, null, be(l.value, (S) => (g(), b("button", {
            key: S,
            class: G(["sv-pop-row", { on: S === i.value }]),
            role: "option",
            "aria-selected": S === i.value,
            "data-testid": "count-" + S,
            onClick: (M) => h(S)
          }, [
            u("span", Ude, E(S), 1),
            S === i.value ? (g(), Ce($, {
              key: 0,
              name: "Check",
              size: 12,
              class: "ck"
            })) : z("", !0)
          ], 10, Nde))), 128))
        ])
      ], 544)) : z("", !0)
    ], 512));
  }
}), Wr = ":pinned", vl = ":all", Su = ":kit";
function _0(i) {
  return i.tags && i.tags.length >= 2 ? i.tags : [Su];
}
function rI(i, e) {
  return (e ? [Wr] : []).concat([vl], i);
}
function aI(i, e = "Models") {
  return i === Wr ? "Pinned" : i === vl ? "All" : i === Su ? e : i;
}
function lI(i, e, t, n, s) {
  const o = n.trim().toLowerCase();
  return o ? e.filter((r) => r.name.toLowerCase().includes(o)) : t === Wr ? e.filter((r) => s(r.id)) : t === vl ? e.slice().sort((r, a) => r.name.localeCompare(a.name, void 0, { sensitivity: "base", numeric: !0 })) : t && t !== Su ? i.filter((r) => !!r.kitTags && r.kitTags.includes(t)) : i.slice();
}
function Gde(i) {
  return i.scrollWidth > i.clientWidth + 1;
}
function A_(i, e) {
  e && Gde(i) ? i.setAttribute("title", e) : i.removeAttribute("title");
}
const dl = {
  mounted(i, e) {
    A_(i, e.value);
  },
  updated(i, e) {
    e.value !== e.oldValue && A_(i, e.value);
  }
}, jde = 42, Hde = 3200;
function dI(i, e = jde, t = Hde) {
  const n = Array.from(i);
  if (!n.length) return [];
  const s = n.map((l, d) => {
    const c = n[d - 1], h = (Math.sin((d + 1) * 12.9898) * 43758.5453 % 1 + 1) % 1;
    return (c === "," || c === "." || c === ":" ? 3.4 : c === " " ? 1.45 : 1) * (0.78 + 0.44 * h);
  }), o = s.reduce((l, d) => l + d, 0), r = Math.min(t, n.length / e * 1e3);
  let a = 0;
  return s.map((l) => (a += l, Math.round(a / o * r)));
}
function Vde(i, e, t = dI(i)) {
  const n = Array.from(i);
  let s = 0;
  for (; s < t.length && t[s] <= e; ) s++;
  return n.slice(0, s).join("");
}
function Zy(i) {
  const e = i.board.tour, t = I(() => {
    const l = i.sessionId();
    return e && l ? e.lineFor(i.field, l) : null;
  }), n = I(() => {
    const l = i.sessionId();
    return !!(e && l && e.holds(i.field, l));
  }), s = /* @__PURE__ */ K(!1), o = I(() => t.value && !s.value && !i.value() ? t.value : null);
  let r = 0;
  function a() {
    const l = t.value;
    if (!l || s.value || !e) return;
    s.value = !0, e.typing(i.field, !0);
    const d = dI(l), c = performance.now(), h = () => {
      const f = Vde(l, performance.now() - c, d);
      if (f !== i.value() && i.write(f), f.length < Array.from(l).length) {
        r = requestAnimationFrame(h);
        return;
      }
      r = 0, s.value = !1, i.done && i.done(), e.typing(i.field, !1);
    };
    r = requestAnimationFrame(h);
  }
  return e && Ae(() => e.tabbed(i.field), (l, d) => {
    l > (d || 0) && o.value && a();
  }), We(() => {
    r && cancelAnimationFrame(r), s.value && t.value && e && (i.write(t.value), i.done && i.done(), s.value = !1, e.typing(i.field, !1));
  }), { line: t, ghost: o, held: n, typing: s, typeIn: a };
}
const Wde = {
  key: 0,
  class: "up-error",
  role: "alert",
  "data-testid": "prompt-error"
}, qde = ["aria-valuenow"], Kde = { class: "up-side" }, Yde = ["aria-expanded"], Xde = {
  key: 0,
  class: "lib-new",
  "aria-hidden": "true"
}, Jde = ["aria-pressed"], Zde = {
  key: 1,
  class: "up-refs",
  "data-testid": "prompt-refs"
}, Qde = ["title", "data-ref-key", "onMouseenter"], ece = ["aria-label", "onClick"], tce = {
  key: 0,
  class: "lbl"
}, nce = {
  key: 0,
  class: "up-drop-wrap"
}, ice = ["title", "aria-label", "data-ref-key", "onClick"], sce = {
  key: 0,
  class: "up-drop-wrap"
}, oce = ["title", "aria-label", "aria-expanded"], rce = { class: "n" }, ace = { class: "s" }, lce = { class: "up-moregrid" }, dce = ["title", "data-ref-key"], cce = ["onClick"], uce = ["title", "aria-label", "data-ref-key", "onClick"], hce = ["title"], pce = ["value", "placeholder", "readonly"], fce = ["data-ref-key"], mce = {
  key: 5,
  class: "up-cue",
  "data-testid": "ghost-cue"
}, gce = ["src"], bce = { class: "n" }, vce = { class: "up-foot" }, yce = { class: "up-chips" }, xce = { class: "up-chip-wrap up-model-wrap" }, wce = { class: "nm" }, kce = { class: "up-pop-label" }, _ce = { class: "up-pop-search" }, Sce = ["placeholder", "aria-label"], Mce = ["aria-label"], Tce = ["aria-selected", "data-testid", "onClick"], Cce = ["onClick"], Ice = { class: "up-pop-main" }, Ace = ["title"], Pce = { class: "up-pop-meta" }, Ece = ["title", "aria-label", "aria-pressed", "data-testid", "onClick"], Rce = {
  key: 1,
  class: "up-pop-empty"
}, zce = {
  key: 2,
  class: "up-pop-empty",
  "data-testid": "model-search-empty"
}, $ce = {
  key: 1,
  class: "up-cost",
  title: "Token cost for this run",
  "data-testid": "run-cost"
}, Dce = {
  key: 0,
  class: "up-foot-sep"
}, Oce = ["title", "aria-disabled", "data-testid", "onClick"], Lce = ["src", "onError"], Bce = { class: "t" }, Fce = { class: "up-pop-label" }, Nce = {
  key: 0,
  class: "up-pop-slider",
  "data-testid": "chip-slider"
}, Uce = ["min", "max", "step", "value", "aria-label", "onInput"], Gce = ["min", "max", "step", "value", "aria-label", "onChange"], jce = ["onClick"], Hce = ["onClick"], Vce = { class: "up-pop-main" }, Wce = {
  key: 1,
  class: "up-pop-meta"
}, qce = ["title", "onClick"], Kce = { class: "t" }, Yce = { class: "up-pop-label" }, Xce = { class: "up-influence-ends" }, Jce = ["value", "onInput"], Zce = { class: "up-adv-hint" }, Qce = ["aria-expanded"], eue = ["title"], tue = { class: "up-run-wrap" }, nue = ["disabled", "title"], iue = {
  key: 2,
  class: "tip"
}, Rh = 3, sue = 70, oue = 48, P_ = 200, E_ = 44, rue = 12, aue = 84, lue = 3400, due = 320, cue = /* @__PURE__ */ Pe({
  __name: "UnifiedPrompt",
  props: {
    tool: {}
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(""), a = I(() => t.modelFor(e.tool)), l = I(() => a.value.model), d = I(() => a.value.kit), c = I(() => l.value ? l.value.fields : []), h = I(() => c.value.find((fe) => fe.placement === "prompt" && (fe.kind === "prompt" || fe.kind === "text")) || null), f = I(() => c.value.filter((fe) => fe.placement === "reference")), p = I(() => f.value.filter(wt)), y = I(() => p.value.length > Rh ? p.value.slice(0, Rh - 1) : p.value), v = I(() => p.value.length > Rh ? p.value.slice(Rh - 1) : []), x = I(() => v.value.filter((fe) => !!Q(fe)).length), w = /* @__PURE__ */ K(!1), S = I(() => v.value.find((fe) => fe.key === s.value) || null), M = I(() => {
      const fe = p.value[0];
      return fe ? "No prompt needed. Drop " + (fe.kind === "video" ? "a video" : "an image") + " here, or pick one from the board." : "No prompt needed for this tool.";
    }), _ = I(() => c.value.filter((fe) => fe.placement === "chip" && wt(fe))), T = I(() => t.promptOf(e.tool.id)), k = I(() => {
      const fe = l.value;
      return !fe || !(e.tool.kitId === "video" || e.tool.kitId === "videoEdit" || fe.fields.some((we) => we.kind === "video")) ? "" : e8(fe, (we) => Lc(we, T.value));
    }), P = /* @__PURE__ */ K(T.value.prompt || "");
    let A = 0;
    Ae(() => e.tool.id, (fe) => {
      P.value = t.promptOf(fe).prompt || "";
    }), Ae(() => T.value.prompt, (fe) => {
      document.activeElement !== o.value && (P.value = fe || "");
    });
    function R(fe) {
      P.value = fe.target.value, clearTimeout(A), A = window.setTimeout(O, 450);
    }
    function D(fe) {
      kn(fe) && (fe.preventDefault(), Tx());
    }
    function O() {
      clearTimeout(A), (T.value.prompt || "") !== P.value && t.setPrompt(e.tool.id, { prompt: P.value });
    }
    const F = Zy({
      board: t,
      field: "session",
      sessionId: () => e.tool.id,
      value: () => P.value,
      write: (fe) => {
        P.value = fe;
      },
      done: () => {
        O(), nt(() => {
          const fe = o.value;
          fe && fe.setSelectionRange(fe.value.length, fe.value.length);
        });
      }
    }), te = I(() => F.ghost.value ? aue : p.value.length ? oue : sue), ee = /* @__PURE__ */ K(0), me = /* @__PURE__ */ K(0), L = I(() => Math.max(te.value, Math.min(P_, ee.value - me.value))), N = I(() => t.ui.promptH != null ? t.ui.promptH : L.value), X = /* @__PURE__ */ K(!1), B = () => Math.max(P_, Math.round(window.innerHeight * 0.5) - 60), se = (fe) => Math.round(Math.max(E_, Math.min(B(), fe)));
    function V() {
      const fe = o.value;
      if (!fe) return;
      const we = fe.style.height;
      fe.style.height = "0px", ee.value = fe.scrollHeight, fe.style.height = we;
    }
    Ae(P, () => nt(V)), Ae(ee, () => {
      me.value = Math.min(me.value, Math.max(0, ee.value - te.value));
    });
    let Z = 0;
    const Y = new ResizeObserver((fe) => {
      const we = Math.round(fe[0].contentRect.width);
      if (we !== Z) {
        Z = we;
        const xe = ee.value;
        V(), me.value && (me.value = Math.max(0, me.value + ee.value - xe));
      }
    });
    Ae(o, (fe, we) => {
      we && Y.unobserve(we), fe && (Y.observe(fe), V());
    }), We(() => Y.disconnect());
    function H(fe) {
      if (fe.button !== 0) return;
      fe.preventDefault();
      const we = fe.currentTarget;
      we.setPointerCapture(fe.pointerId);
      const xe = fe.clientY, ct = N.value;
      X.value = !0;
      const vi = (hr) => {
        le(ct + (xe - hr.clientY));
      }, li = () => {
        X.value = !1, we.removeEventListener("pointermove", vi), we.removeEventListener("pointerup", li), we.removeEventListener("pointercancel", li), he();
      };
      we.addEventListener("pointermove", vi), we.addEventListener("pointerup", li), we.addEventListener("pointercancel", li);
    }
    const re = (fe) => Math.abs(fe - te.value) <= rue;
    function le(fe) {
      const we = se(fe);
      t.ui.promptH = re(we) ? te.value : we;
    }
    function he() {
      t.ui.promptH == null || !re(t.ui.promptH) || (t.ui.promptH = null, me.value = Math.max(0, ee.value - te.value));
    }
    function Re() {
      t.ui.promptH = null, me.value = 0, nt(V);
    }
    function Ne(fe) {
      fe.key === "ArrowUp" || fe.key === "ArrowDown" ? (fe.preventDefault(), fe.stopPropagation(), le(N.value + (fe.key === "ArrowUp" ? 20 : -20)), he()) : fe.key === "Enter" && (fe.preventDefault(), fe.stopPropagation(), Re());
    }
    We(O);
    const Me = I(() => t.freshTools.has(e.tool.id) && !P.value);
    ot(() => {
      Me.value && nt(() => o.value && o.value.focus({ preventScroll: !0 })), Me.value && t.promptLibrary.load();
    });
    const ue = I(() => t.ui.library.open && t.ui.library.sessionId === e.tool.id && !t.ui.library.inStudio);
    function U() {
      O(), n.value = null, t.promptLibrary.toggle(e.tool.id);
    }
    function q() {
      ue.value && t.promptLibrary.close(), t.ui.advOpen = !t.ui.advOpen;
    }
    const ie = I(() => Me.value && !!h.value && !n.value && !ue.value && !t.ui.advOpen), de = I(() => ie.value && !t.tour ? t.promptLibrary.ghostLines(e.tool) : []), pe = /* @__PURE__ */ K(0), Te = I(() => F.ghost.value && h.value ? { id: "tour", text: F.ghost.value, tour: !0 } : de.value.length ? { ...de.value[pe.value % de.value.length], tour: !1 } : null);
    vE((fe) => {
      if (de.value.length < 2) return;
      const we = window.setInterval(() => {
        pe.value = (pe.value + 1) % de.value.length;
      }, lue);
      fe(() => clearInterval(we));
    });
    function Be(fe) {
      !Te.value || fe.shiftKey || Te.value.tour || (fe.preventDefault(), P.value = Te.value.text, O(), nt(() => {
        const we = o.value;
        we && we.setSelectionRange(we.value.length, we.value.length);
      }));
    }
    const ge = /* @__PURE__ */ K(!1);
    let ne = 0;
    Ae(() => t.ui.promptLanded && t.ui.promptLanded.id === e.tool.id ? t.ui.promptLanded.seq : 0, (fe) => {
      fe && (ge.value = !1, clearTimeout(ne), requestAnimationFrame(() => {
        ge.value = !0, ne = window.setTimeout(() => {
          ge.value = !1, t.ui.promptLanded && t.ui.promptLanded.id === e.tool.id && (t.ui.promptLanded = null);
        }, 1300);
      }));
    }, { immediate: !0 }), We(() => clearTimeout(ne));
    const oe = /* @__PURE__ */ K(null), ye = /* @__PURE__ */ K(0), Oe = new ResizeObserver((fe) => {
      ye.value = Math.round(fe[0].contentRect.height), t.ui.promptCardH = ye.value;
    });
    Ae(oe, (fe, we) => {
      we && Oe.unobserve(we), fe && Oe.observe(fe);
    }), We(() => {
      Oe.disconnect(), t.ui.promptCardH = 0;
    });
    function Ve(fe) {
      t.setPrompt(e.tool.id, { prompt: P.value, ...fe });
    }
    function Ue(fe, we) {
      Ve({ inputs: { ...T.value.inputs || {}, [fe]: we } });
    }
    const tt = I(() => {
      const fe = l.value, we = T.value.n || (fe ? fe.numResults.def : 1) || 1;
      return fe ? Math.max(fe.numResults.min, Math.min(fe.numResults.max, we)) : we;
    }), Ye = I(() => l.value ? Xi(l.value, { ...T.value, prompt: P.value }, tt.value, !!t.user.isAdmin) : null), at = I(() => {
      const fe = l.value, we = Ye.value;
      return !!fe && !!we && fe.fields.some((xe) => xe.placement === "advanced" && xe.kind !== "header" && Ur(we, xe.key).shown);
    });
    Ae(at, (fe) => {
      !fe && t.ui.advOpen && (t.ui.advOpen = !1);
    });
    function wt(fe) {
      return !Ye.value || Ur(Ye.value, fe.key).shown;
    }
    function $e(fe) {
      return !!Ye.value && Ur(Ye.value, fe.key).locked;
    }
    function Fe(fe) {
      return Ye.value ? Ur(Ye.value, fe.key).why : "";
    }
    function W(fe) {
      const we = Ye.value;
      return we && fe.key in we.values ? we.values[fe.key] : Lc(fe, T.value);
    }
    Ae(() => Ye.value ? Ye.value.autoErrors.join(`
`) : "", (fe, we) => {
      if (!fe) return;
      const xe = new Set((we || "").split(`
`));
      for (const ct of fe.split(`
`)) xe.has(ct) || t.toast(ct, "error");
    });
    function Q(fe) {
      if (fe === f.value[0]) return T.value.ref || null;
      const we = T.value.inputs ? T.value.inputs[fe.key] : null;
      return typeof we == "string" ? we : null;
    }
    function ae(fe, we) {
      O(), t.setRefInput(e.tool.id, fe.key, we, we ? t.assetFor(we) : null);
    }
    function Le(fe) {
      const we = T.value.inputs ? T.value.inputs[fe.key] : null;
      return Array.isArray(we) ? we.filter((xe) => typeof xe == "string" && !!xe) : [];
    }
    function ve(fe) {
      const we = Le(fe);
      if (we.length) return we;
      const xe = Q(fe);
      return xe ? [xe] : [];
    }
    function ke(fe, we) {
      return fe.kind === "images" ? "Image " + (we + 1) : fe.label;
    }
    const De = I(() => !!t.ui.eyedropper && t.ui.eyedropper.sessionId === e.tool.id);
    function Qe(fe) {
      return De.value && !!t.ui.eyedropper && t.ui.eyedropper.key === fe.key;
    }
    function ft(fe) {
      s.value = null, w.value = !1, t.armEyedropper(e.tool.id, fe.key);
    }
    function Dn(fe) {
      s.value = s.value === fe ? null : fe, s.value && (t.ui.eyedropper = null);
    }
    function Zn(fe) {
      const we = t.ui.refPulse;
      return we && we.url === fe ? we.n : 0;
    }
    function ya(fe) {
      const we = t.ui.refGlow;
      return we && we.sessionId === e.tool.id && we.url === fe ? we.n : 0;
    }
    function xa(fe, we) {
      O(), ze.value = null, t.removeRefImage(e.tool.id, fe.key, we);
    }
    const ze = /* @__PURE__ */ K(null);
    function Ee(fe, we, xe) {
      const ct = oe.value;
      if (!ct) return;
      const vi = xe.currentTarget.getBoundingClientRect(), li = ct.getBoundingClientRect(), hr = due / 2;
      ze.value = { url: fe, label: we, left: Math.max(hr, Math.min(li.width - hr, vi.left - li.left + vi.width / 2)) };
    }
    const lt = I(() => {
      const fe = ze.value;
      return !fe || t.ui.dragging || s.value || w.value ? null : p.value.some((we) => ve(we).includes(fe.url)) ? fe : null;
    }), nn = I(() => t.accountProblem()), Ui = I(() => t.labels.team + " deactivated"), ho = I(() => !nn.value && Ye.value && !Ye.value.problems.length ? t.tokensProblem(Ye.value.price) : ""), po = I(() => nn.value || Ye.value && Ye.value.problems[0] || ho.value || null), mP = I(() => !!ho.value && t.canGetTokens), Is = I(() => t.submitting(e.tool.id)), Mx = I(() => {
      const fe = l.value;
      return fe ? fe.raw && Ye.value && Ye.value.price != null ? El(Ye.value.price) : t8(fe, tt.value) : "";
    }), nd = /* @__PURE__ */ K(!1);
    let Im = 0;
    function gP() {
      nd.value = !1, clearTimeout(Im), requestAnimationFrame(() => {
        nd.value = !0, Im = window.setTimeout(() => nd.value = !1, 1800);
      });
    }
    We(() => clearTimeout(Im));
    function Tx() {
      if (O(), !Is.value) {
        if (po.value) {
          gP();
          return;
        }
        t.generate(e.tool.id);
      }
    }
    function Am(fe) {
      n.value = n.value === fe ? null : fe, r.value = "", n.value === "model" && (ls.value = bP());
    }
    const ls = /* @__PURE__ */ K(null);
    function bP() {
      const fe = d.value, we = l.value;
      if (we && t.isModelPinned(we.id)) return Wr;
      if (!fe || we && !fe.models.some((xe) => xe.id === we.id)) return vl;
      if (!fe.tags || fe.tags.length < 2) return Su;
      if (we && we.kitTags) {
        if (we.kitTags.includes("Featured") && fe.tags.includes("Featured")) return "Featured";
        const xe = we.kitTags.find((ct) => fe.tags.includes(ct));
        if (xe) return xe;
      }
      return fe.tags.includes("Featured") ? "Featured" : fe.tags[0];
    }
    function Pm(fe) {
      const we = W(fe), xe = we && typeof we == "object" ? we.model : null;
      return xe && typeof xe == "object" ? xe : null;
    }
    function Em(fe) {
      const we = fe.kind === "model" ? Pm(fe) : null;
      return we ? t.modelPicture(we) : null;
    }
    function vP(fe, we) {
      const xe = Em(we), ct = fe.target;
      xe && ct.src !== xe.image && (ct.src = xe.image);
    }
    function yP(fe, we) {
      Ue(fe.key, we ? { model: we } : null), n.value = null;
    }
    function xP(fe) {
      return !!Ye.value && Ur(Ye.value, fe.key).required;
    }
    function wP(fe) {
      if (fe.kind === "model") {
        const ct = Pm(fe);
        return ct && ct.name || "Trained model";
      }
      const we = W(fe), xe = (fe.options || []).find((ct) => Qi(ct.value, we));
      return fe.kind === "size" && xe ? ef(xe.value) && xe.meta || xe.label : fe.kind === "size" && we && typeof we == "object" ? yn(we).replace("x", "×") : xe ? xe.label : String(we == null ? fe.label : we);
    }
    function kP(fe) {
      if (fe.icon) return fe.icon;
      if (fe.kind === "size") {
        const we = W(fe), xe = (fe.options || []).find((ct) => Qi(ct.value, we));
        return xe && xe.icon || "RectangleHorizontal";
      }
      return "Settings2";
    }
    const Rm = I(() => p.value.filter((fe) => !!(fe.raw && fe.raw.display && fe.raw.display.hasStrength) && !!Q(fe)));
    function Cx(fe) {
      const we = T.value.inputs ? T.value.inputs[Qp(fe.key)] : void 0;
      return typeof we == "number" ? we : K6;
    }
    function id(fe) {
      return 100 - Math.round(Cx(fe) * 100);
    }
    function _P(fe, we) {
      const xe = Math.min(0.95, Math.max(0.05, Number(we)));
      Number.isFinite(xe) && Ue(Qp(fe.key), Math.round(xe * 100) / 100);
    }
    function SP(fe) {
      if ($e(fe)) {
        t.toast(Ka(Fe(fe)));
        return;
      }
      Am(fe.key);
    }
    function Ix(fe, we) {
      Ue(fe.key, we.value), n.value = null;
    }
    function Ax(fe) {
      return l.value ? Q6(l.value, fe, T.value, (we) => t.measuredSize(we)) : null;
    }
    function Px(fe, we) {
      return we.meta && (fe.kind !== "size" || ef(we.value)) ? we.meta : "";
    }
    function Ex(fe) {
      const we = cc(fe, W(fe));
      return we == null ? cc(fe, fe.min == null ? 1 : fe.min) || 0 : we;
    }
    function Rx(fe, we) {
      const xe = cc(fe, we);
      xe != null && Ue(fe.key, xe);
    }
    const MP = I(() => zx.value.filter((fe) => t.isModelPinned(fe.id))), TP = I(() => {
      const fe = d.value;
      if (!fe || !ls.value) return [];
      const we = ls.value === Wr || MP.value.length > 0;
      return rI(_0(fe), we);
    }), CP = I(() => !!r.value.trim() || ls.value === vl), IP = { image: "image", video: "video", threed: "3D", upscale: "upscale" }, Iu = I(() => d.value ? IP[pl(d.value.id)] || d.value.name.toLowerCase() : ""), zx = I(() => {
      const fe = d.value, we = t.catalog.value;
      return fe ? we.all.filter((xe) => Fc(we, fe, xe)) : [];
    }), zm = I(() => {
      const fe = d.value;
      return fe ? t.pinnedModelsFirst(lI(fe.models, zx.value, ls.value, r.value, (we) => t.isModelPinned(we))) : [];
    });
    function AP(fe) {
      t.patchTool(e.tool.id, { model: fe.name, nodeDefId: fe.id }), n.value = null;
    }
    function $x(fe) {
      const we = fe.target;
      !we.closest(".v2-uprompt") && !we.closest(".lb-backdrop") && (n.value = null, s.value = null, w.value = !1);
    }
    return ot(() => window.addEventListener("pointerdown", $x, !0)), We(() => window.removeEventListener("pointerdown", $x, !0)), (fe, we) => (g(), b("div", {
      class: "v2-uprompt",
      style: ce({ "--up-card-h": (ye.value || 150) + "px" }),
      "data-testid": "unified-prompt",
      onPointerdown: we[21] || (we[21] = Se(() => {
      }, ["stop"]))
    }, [
      i.tool.error && !Is.value ? (g(), b("div", Wde, [
        C($, {
          name: "AlertCircle",
          size: 14
        }),
        u("span", null, E(i.tool.error), 1),
        u("button", {
          "aria-label": "Dismiss",
          onClick: we[0] || (we[0] = (xe) => m(t).patchTool(i.tool.id, { error: null }))
        }, [
          C($, {
            name: "X",
            size: 12
          })
        ])
      ])) : z("", !0),
      ue.value ? (g(), Ce(Xy, { key: 1 })) : z("", !0),
      m(t).ui.advOpen && !ue.value && l.value && Ye.value && at.value ? (g(), Ce(Rre, {
        key: 2,
        tool: i.tool,
        model: l.value,
        form: Ye.value,
        onClose: we[1] || (we[1] = (xe) => m(t).ui.advOpen = !1)
      }, null, 8, ["tool", "model", "form"])) : z("", !0),
      u("div", {
        ref_key: "cardEl",
        ref: oe,
        class: G(["up-card", { "has-refs": p.value.length > 0, "is-fresh": Me.value && !nd.value, "is-nudge": nd.value, "is-resizing": X.value, "is-landed": ge.value }])
      }, [
        h.value ? (g(), b("div", {
          key: 0,
          class: G(["up-grip", { "is-on": X.value, "is-hand": m(t).ui.promptH != null }]),
          role: "separator",
          "aria-orientation": "horizontal",
          "aria-label": "Prompt height",
          "aria-valuenow": Math.round(N.value),
          "aria-valuemin": E_,
          tabindex: "0",
          title: "Drag to resize. Double-click to fit the text.",
          "data-testid": "prompt-grip",
          onPointerdown: H,
          onDblclick: Re,
          onKeydown: Ne
        }, [...we[22] || (we[22] = [
          u("i", null, null, -1)
        ])], 42, qde)) : z("", !0),
        u("div", Kde, [
          h.value ? (g(), Ce(n8, {
            key: 0,
            slides: m(s8),
            media: m(i8),
            tag: "Prompt library",
            "tag-icon": "LayoutTemplate",
            cta: "Open the prompt library",
            placement: "above-start",
            disabled: ue.value || m(t).ui.advOpen,
            testid: "library-demo",
            onOpen: U
          }, {
            default: Xe(() => [
              u("button", {
                class: G(["up-side-btn", { on: ue.value, "has-new": !m(Bc) }]),
                "aria-label": "Prompt library",
                "aria-expanded": ue.value,
                "data-testid": "library-button",
                onClick: U
              }, [
                C($, {
                  name: "LayoutTemplate",
                  size: 15
                }),
                m(Bc) ? z("", !0) : (g(), b("span", Xde))
              ], 10, Yde)
            ]),
            _: 1
          }, 8, ["slides", "media", "disabled"])) : z("", !0),
          p.value.length ? (g(), b("button", {
            key: 1,
            class: G(["up-side-btn", { on: De.value }]),
            title: "Pick from the board (I)",
            "aria-label": "Pick from the board",
            "aria-pressed": De.value,
            "data-testid": "eyedropper-button",
            onClick: we[2] || (we[2] = (xe) => m(t).toggleEyedropper(i.tool.id))
          }, [
            C($, {
              name: "Pipette",
              size: 15
            })
          ], 10, Jde)) : z("", !0)
        ]),
        C(Ode, {
          onOpen: we[3] || (we[3] = (xe) => m(t).openStudio({ sessionId: i.tool.id }))
        }),
        p.value.length ? (g(), b("div", Zde, [
          (g(!0), b(j, null, be(y.value, (xe) => (g(), b(j, {
            key: xe.key
          }, [
            (g(!0), b(j, null, be(ve(xe), (ct, vi) => (g(), b("div", {
              key: xe.key + ":" + ct,
              class: G(["up-ref", { "is-target": m(t).ui.refTarget === xe.key, "is-dropper": Qe(xe) && ve(xe).length >= m(Zs)(xe) }]),
              style: ce({ backgroundImage: 'url("' + m(Bt)(ct) + '")' }),
              title: ke(xe, vi),
              "data-ref-key": xe.key,
              "data-testid": "prompt-ref",
              onMouseenter: (li) => Ee(ct, ke(xe, vi), li),
              onMouseleave: we[4] || (we[4] = (li) => ze.value = null)
            }, [
              u("button", {
                title: "Remove",
                "aria-label": "Remove " + ke(xe, vi).toLowerCase(),
                onClick: (li) => xa(xe, ct)
              }, [
                C($, {
                  name: "X",
                  size: 11
                })
              ], 8, ece),
              p.value.length > 1 && vi === 0 ? (g(), b("span", tce, E(xe.label), 1)) : z("", !0),
              Zn(ct) ? (g(), b("span", {
                key: "pulse" + Zn(ct),
                class: "up-ref-pulse",
                "aria-hidden": "true"
              })) : z("", !0),
              ya(ct) ? (g(), b("span", {
                key: "glow" + ya(ct),
                class: "up-ref-glow",
                "aria-hidden": "true",
                "data-testid": "prompt-ref-glow"
              })) : z("", !0)
            ], 46, Qde))), 128)),
            ve(xe).length < m(Zs)(xe) ? (g(), b("div", nce, [
              u("button", {
                class: G(["up-drop", { "is-target": m(t).ui.refTarget === xe.key, "is-dropper": Qe(xe) }]),
                title: (ve(xe).length ? "Add another image" : "Add " + xe.label.toLowerCase()) + ". Or Shift-drag one here from the board.",
                "aria-label": ve(xe).length ? "Add another image" : "Add " + xe.label.toLowerCase(),
                "data-ref-key": xe.key,
                onClick: (ct) => Dn(xe.key)
              }, [
                C($, {
                  name: xe.kind === "video" ? "Video" : "ImagePlus",
                  size: 18
                }, null, 8, ["name"])
              ], 10, ice),
              s.value === xe.key ? (g(), Ce(Zc, {
                key: 0,
                "session-id": i.tool.id,
                label: xe.label,
                kind: xe.kind === "video" ? "video" : "image",
                onPick: (ct) => {
                  ae(xe, ct), s.value = null;
                },
                onDropper: (ct) => ft(xe),
                onClose: we[5] || (we[5] = (ct) => s.value = null)
              }, null, 8, ["session-id", "label", "kind", "onPick", "onDropper"])) : z("", !0)
            ])) : z("", !0)
          ], 64))), 128)),
          v.value.length ? (g(), b("div", sce, [
            u("button", {
              class: G(["up-drop up-more", { on: w.value, "has-some": x.value > 0 }]),
              title: v.value.length + " more image inputs",
              "aria-label": v.value.length + " more image inputs",
              "aria-expanded": w.value,
              "data-testid": "more-refs",
              onClick: we[6] || (we[6] = (xe) => {
                w.value = !w.value, s.value = null;
              })
            }, [
              u("span", rce, "+" + E(v.value.length), 1),
              u("span", ace, E(x.value ? x.value + " set" : "inputs"), 1)
            ], 10, oce),
            w.value ? (g(), b("div", {
              key: 0,
              class: "up-pop up-refmore",
              onPointerdown: we[7] || (we[7] = Se(() => {
              }, ["stop"]))
            }, [
              we[23] || (we[23] = u("div", { class: "up-pop-label" }, "More inputs", -1)),
              u("div", lce, [
                (g(!0), b(j, null, be(v.value, (xe) => (g(), b("div", {
                  key: xe.key,
                  class: "up-morecell"
                }, [
                  Q(xe) ? (g(), b("div", {
                    key: 0,
                    class: G(["up-ref is-sm", { "is-target": m(t).ui.refTarget === xe.key }]),
                    style: ce({ backgroundImage: 'url("' + m(Bt)(Q(xe) || "") + '")' }),
                    title: xe.label,
                    "data-ref-key": xe.key
                  }, [
                    u("button", {
                      title: "Remove",
                      onClick: (ct) => ae(xe, null)
                    }, [
                      C($, {
                        name: "X",
                        size: 10
                      })
                    ], 8, cce),
                    ya(Q(xe) || "") ? (g(), b("span", {
                      key: "glow" + ya(Q(xe) || ""),
                      class: "up-ref-glow",
                      "aria-hidden": "true"
                    })) : z("", !0)
                  ], 14, dce)) : (g(), b("button", {
                    key: 1,
                    class: G(["up-drop is-sm", { "is-target": m(t).ui.refTarget === xe.key }]),
                    title: "Add " + xe.label.toLowerCase(),
                    "aria-label": "Add " + xe.label.toLowerCase(),
                    "data-ref-key": xe.key,
                    onClick: (ct) => {
                      w.value = !1, Dn(xe.key);
                    }
                  }, [
                    C($, {
                      name: xe.kind === "video" ? "Video" : "ImagePlus",
                      size: 15
                    }, null, 8, ["name"])
                  ], 10, uce)),
                  u("span", {
                    class: "lbl",
                    title: xe.label
                  }, E(xe.label), 9, hce)
                ]))), 128))
              ])
            ], 32)) : z("", !0),
            S.value ? (g(), Ce(Zc, {
              key: 1,
              "session-id": i.tool.id,
              label: S.value.label,
              kind: S.value.kind === "video" ? "video" : "image",
              onPick: we[8] || (we[8] = (xe) => {
                ae(S.value, xe), s.value = null, w.value = !0;
              }),
              onDropper: we[9] || (we[9] = (xe) => ft(S.value)),
              onClose: we[10] || (we[10] = (xe) => s.value = null)
            }, null, 8, ["session-id", "label", "kind"])) : z("", !0)
          ])) : z("", !0)
        ])) : z("", !0),
        h.value ? (g(), b("textarea", {
          key: 2,
          ref_key: "textEl",
          ref: o,
          class: G(["up-text", { "is-typing": m(F).typing.value }]),
          style: ce({ height: N.value + "px" }),
          value: P.value,
          spellcheck: "false",
          placeholder: Te.value ? "" : h.value.placeholder || "Describe what " + i.tool.name + " should make",
          readonly: m(F).held.value || m(F).typing.value,
          "data-testid": "prompt-text",
          onInput: R,
          onBlur: O,
          onKeydown: [
            tn(D, ["enter"]),
            tn(Be, ["tab"])
          ]
        }, null, 46, pce)) : (g(), b("div", {
          key: 3,
          class: G(["up-text up-text-static", { "is-target": !!p.value.length && m(t).ui.refTarget === p.value[0].key }]),
          "data-ref-key": p.value.length ? p.value[0].key : void 0
        }, E(M.value), 11, fce)),
        C(vt, {
          name: "up-ghost",
          mode: "out-in"
        }, {
          default: Xe(() => [
            Te.value ? (g(), b("span", {
              key: Te.value.id,
              class: G(["up-ghost", { "is-tour": Te.value.tour }]),
              "aria-hidden": "true",
              "data-testid": "ghost-line"
            }, E(Te.value.text), 3)) : z("", !0)
          ]),
          _: 1
        }),
        Te.value && Te.value.tour ? (g(), b("button", {
          key: 4,
          type: "button",
          tabindex: "-1",
          class: "up-cue is-tour",
          "data-testid": "ghost-cue",
          onClick: we[11] || (we[11] = (xe) => m(t).tour && m(t).tour.press && m(t).tour.press("session"))
        }, [...we[24] || (we[24] = [
          u("kbd", null, "Tab", -1),
          J(" to write it in", -1)
        ])])) : Te.value ? (g(), b("span", mce, [...we[25] || (we[25] = [
          u("kbd", null, "Tab", -1),
          J(" to use this prompt", -1),
          u("span", { class: "src" }, "Featured", -1)
        ])])) : z("", !0),
        lt.value ? (g(), b("div", {
          key: 6,
          class: "up-ref-peek",
          style: ce({ left: lt.value.left + "px" }),
          "aria-hidden": "true",
          "data-testid": "prompt-ref-peek"
        }, [
          u("img", {
            src: m(Bt)(lt.value.url),
            alt: "",
            draggable: "false"
          }, null, 8, gce),
          u("span", bce, E(lt.value.label), 1)
        ], 4)) : z("", !0),
        u("div", vce, [
          u("div", yce, [
            u("span", xce, [
              u("button", {
                class: G(["up-model", { on: n.value === "model" }]),
                "data-testid": "model-picker",
                onClick: we[12] || (we[12] = (xe) => Am("model"))
              }, [
                we[26] || (we[26] = u("span", { class: "lb" }, "Model", -1)),
                kt((g(), b("span", wce, [
                  J(E(l.value ? l.value.name : i.tool.model), 1)
                ])), [
                  [m(dl), l.value ? l.value.name : i.tool.model]
                ]),
                C($, {
                  name: "ChevronDown",
                  size: 12
                })
              ], 2),
              n.value === "model" && d.value ? (g(), b("div", {
                key: 0,
                class: "up-pop is-wide",
                onPointerdown: we[15] || (we[15] = Se(() => {
                }, ["stop"]))
              }, [
                u("div", kce, E(CP.value ? "All " + Iu.value + " models" : d.value.name + " models"), 1),
                u("div", _ce, [
                  C($, {
                    name: "Search",
                    size: 12
                  }),
                  kt(u("input", {
                    "onUpdate:modelValue": we[13] || (we[13] = (xe) => r.value = xe),
                    placeholder: "Search all " + Iu.value + " models",
                    "aria-label": "Search all " + Iu.value + " models",
                    "data-testid": "model-search",
                    onKeydown: we[14] || (we[14] = Se(() => {
                    }, ["stop"]))
                  }, null, 40, Sce), [
                    [Zt, r.value]
                  ])
                ]),
                ls.value && !r.value.trim() ? (g(), b("div", {
                  key: 0,
                  class: "up-pop-tabs",
                  role: "tablist",
                  "aria-label": d.value.name + " model groups"
                }, [
                  (g(!0), b(j, null, be(TP.value, (xe) => (g(), b("button", {
                    key: xe,
                    role: "tab",
                    "aria-selected": ls.value === xe,
                    class: G({ on: ls.value === xe }),
                    "data-testid": xe === m(Wr) ? "model-tab-pinned" : xe === m(vl) ? "model-tab-all" : void 0,
                    onClick: (ct) => ls.value = xe
                  }, E(m(aI)(xe, d.value.name)), 11, Tce))), 128))
                ], 8, Mce)) : z("", !0),
                (g(!0), b(j, null, be(zm.value, (xe) => (g(), b("div", {
                  key: xe.id,
                  class: G(["up-pop-item", { "is-pinned": m(t).isModelPinned(xe.id) }])
                }, [
                  u("button", {
                    class: G(["up-pop-row", { on: l.value && xe.id === l.value.id }]),
                    onClick: (ct) => AP(xe)
                  }, [
                    xe.avatar ? (g(), b("span", {
                      key: 0,
                      class: "up-pop-avatar",
                      style: ce({ backgroundImage: 'url("' + xe.avatar + '")' })
                    }, null, 4)) : z("", !0),
                    kt((g(), b("span", Ice, [
                      J(E(xe.name) + " ", 1),
                      (g(!0), b(j, null, be(xe.labels || [], (ct) => (g(), b("span", {
                        key: ct.label,
                        class: G(["up-pop-badge", { "is-popular": ct.type === "POPULAR" }]),
                        title: ct.tooltip
                      }, E(ct.label), 11, Ace))), 128))
                    ])), [
                      [m(dl), xe.name]
                    ]),
                    u("span", Pce, [
                      J(E(xe.tokensLabel) + " tk", 1),
                      xe.time ? (g(), b(j, { key: 0 }, [
                        J(" · " + E(xe.time), 1)
                      ], 64)) : z("", !0)
                    ])
                  ], 10, Cce),
                  u("button", {
                    class: G(["up-pop-pin", { on: m(t).isModelPinned(xe.id) }]),
                    title: m(t).isModelPinned(xe.id) ? "Unpin" : "Pin to the top",
                    "aria-label": (m(t).isModelPinned(xe.id) ? "Unpin " : "Pin ") + xe.name,
                    "aria-pressed": m(t).isModelPinned(xe.id),
                    "data-testid": "model-pin-" + xe.id,
                    onClick: Se((ct) => m(t).toggleModelPinned(xe.id), ["stop"])
                  }, [
                    C($, {
                      name: "Pin",
                      size: 12
                    })
                  ], 10, Ece)
                ], 2))), 128)),
                ls.value === m(Wr) && !r.value.trim() && !zm.value.length ? (g(), b("div", Rce, "Nothing pinned yet. Pin a model to keep it at the top.")) : z("", !0),
                r.value.trim() && !zm.value.length ? (g(), b("div", zce, "No " + E(Iu.value) + " model matches “" + E(r.value.trim()) + "”. Try a different search.", 1)) : z("", !0)
              ], 32)) : z("", !0),
              Mx.value ? (g(), b("span", $ce, [
                C($, {
                  name: "Tokens",
                  size: 12
                }),
                J(E(Mx.value), 1)
              ])) : z("", !0)
            ]),
            _.value.length || Rm.value.length || at.value ? (g(), b("span", Dce)) : z("", !0),
            (g(!0), b(j, null, be(_.value, (xe) => {
              var ct, vi, li, hr;
              return g(), b("span", {
                key: xe.key,
                class: "up-chip-wrap"
              }, [
                u("button", {
                  class: G(["up-chip", { on: n.value === xe.key, "is-locked": $e(xe) }]),
                  title: $e(xe) ? xe.label + ": " + Fe(xe) : xe.label,
                  "aria-disabled": $e(xe) || void 0,
                  "data-testid": "chip-" + xe.key,
                  onClick: (Tn) => SP(xe)
                }, [
                  Em(xe) ? (g(), b("img", {
                    key: 0,
                    class: "av",
                    src: Em(xe).thumb,
                    alt: "",
                    draggable: "false",
                    onError: (Tn) => vP(Tn, xe)
                  }, null, 40, Lce)) : (g(), Ce($, {
                    key: 1,
                    name: kP(xe),
                    size: 13
                  }, null, 8, ["name"])),
                  u("span", Bce, E(wP(xe)), 1),
                  $e(xe) ? (g(), Ce($, {
                    key: 2,
                    class: "lk",
                    name: "Lock",
                    size: 10
                  })) : z("", !0)
                ], 10, Oce),
                n.value === xe.key && xe.kind === "model" ? (g(), Ce(Sde, {
                  key: 0,
                  field: xe,
                  "selected-id": (Pm(xe) || {}).id || null,
                  required: xP(xe),
                  onPick: (Tn) => yP(xe, Tn)
                }, null, 8, ["field", "selected-id", "required", "onPick"])) : n.value === xe.key ? (g(), b("div", {
                  key: 1,
                  class: "up-pop",
                  onPointerdown: we[17] || (we[17] = Se(() => {
                  }, ["stop"]))
                }, [
                  u("div", Fce, E(xe.label), 1),
                  xe.kind === "slider" ? (g(), b("div", Nce, [
                    u("input", {
                      class: "up-range",
                      type: "range",
                      min: (ct = xe.min) != null ? ct : 1,
                      max: (vi = xe.max) != null ? vi : 30,
                      step: xe.step || 1,
                      value: Ex(xe),
                      "aria-label": xe.label,
                      onInput: (Tn) => Rx(xe, Tn.target.value)
                    }, null, 40, Uce),
                    u("input", {
                      class: "up-adv-num",
                      type: "number",
                      min: (li = xe.min) != null ? li : 1,
                      max: (hr = xe.max) != null ? hr : 30,
                      step: xe.step || 1,
                      value: Ex(xe),
                      "aria-label": xe.label,
                      "data-testid": "chip-slider-num",
                      onChange: (Tn) => Rx(xe, Tn.target.value),
                      onKeydown: we[16] || (we[16] = Se(() => {
                      }, ["stop"]))
                    }, null, 40, Gce)
                  ])) : (g(), b(j, { key: 1 }, [
                    Ax(xe) ? (g(), b(j, { key: 0 }, [
                      u("button", {
                        class: "up-pop-row",
                        "data-testid": "chip-match",
                        onClick: (Tn) => Ix(xe, Ax(xe))
                      }, [
                        C($, {
                          name: "Proportions",
                          size: 13
                        }),
                        we[27] || (we[27] = u("span", { class: "up-pop-main" }, "Match media input", -1))
                      ], 8, jce),
                      we[28] || (we[28] = u("div", { class: "up-pop-sep" }, null, -1))
                    ], 64)) : z("", !0),
                    (g(!0), b(j, null, be(xe.options || [], (Tn) => (g(), b("button", {
                      key: m(yn)(Tn.value),
                      class: G(["up-pop-row", { on: m(Qi)(Tn.value, W(xe)) }]),
                      onClick: (Gze) => Ix(xe, Tn)
                    }, [
                      Tn.icon ? (g(), Ce($, {
                        key: 0,
                        name: Tn.icon,
                        size: 13
                      }, null, 8, ["name"])) : z("", !0),
                      u("span", Vce, E(Tn.label), 1),
                      Px(xe, Tn) ? (g(), b("span", Wce, E(Px(xe, Tn)), 1)) : z("", !0)
                    ], 10, Hce))), 128))
                  ], 64))
                ], 32)) : z("", !0)
              ]);
            }), 128)),
            (g(!0), b(j, null, be(Rm.value, (xe) => (g(), b("span", {
              key: "influence:" + xe.key,
              class: "up-chip-wrap"
            }, [
              u("button", {
                class: G(["up-chip", { on: n.value === "influence:" + xe.key }]),
                title: "Influence of " + xe.label.toLowerCase() + " against the prompt",
                "data-testid": "influence-chip",
                onClick: (ct) => Am("influence:" + xe.key)
              }, [
                C($, {
                  name: xe.kind === "video" ? "Video" : "Image",
                  size: 13
                }, null, 8, ["name"]),
                u("span", Kce, E(xe.kind === "video" ? "Video" : "Image") + " " + E(id(xe)) + "%", 1)
              ], 10, qce),
              n.value === "influence:" + xe.key ? (g(), b("div", {
                key: 0,
                class: "up-pop up-influence",
                "data-testid": "influence-pop",
                onPointerdown: we[18] || (we[18] = Se(() => {
                }, ["stop"]))
              }, [
                u("div", Yce, "Influence" + E(Rm.value.length > 1 ? ": " + xe.label : ""), 1),
                u("div", Xce, [
                  u("span", {
                    style: ce({ fontSize: 11 + id(xe) / 25 + "px" })
                  }, [
                    C($, {
                      name: xe.kind === "video" ? "Video" : "Image",
                      size: 12
                    }, null, 8, ["name"]),
                    J(E(id(xe)) + "%", 1)
                  ], 4),
                  u("span", {
                    style: ce({ fontSize: 11 + (100 - id(xe)) / 25 + "px" })
                  }, [
                    J(E(100 - id(xe)) + "%", 1),
                    C($, {
                      name: "Type",
                      size: 12
                    })
                  ], 4)
                ]),
                u("input", {
                  class: "up-range",
                  type: "range",
                  min: "0.05",
                  max: "0.95",
                  step: "0.01",
                  value: Cx(xe),
                  "aria-label": "Influence",
                  "data-testid": "influence-range",
                  onInput: (ct) => _P(xe, ct.target.value)
                }, null, 40, Jce),
                u("div", Zce, "How much your " + E(xe.kind === "video" ? "video" : "image") + " shapes the result, against your prompt.", 1)
              ], 32)) : z("", !0)
            ]))), 128)),
            at.value ? (g(), b("button", {
              key: 1,
              class: G(["up-cog", { on: m(t).ui.advOpen && !ue.value }]),
              title: "Advanced settings",
              "aria-label": "Advanced settings",
              "aria-expanded": m(t).ui.advOpen && !ue.value,
              "data-testid": "advanced-button",
              onClick: q
            }, [
              C($, {
                name: "Settings",
                size: 15
              })
            ], 10, Qce)) : z("", !0)
          ]),
          k.value ? (g(), b("span", {
            key: 0,
            class: "up-out-line",
            "data-testid": "prompt-output-line",
            title: k.value + ": from this tool's settings"
          }, E(k.value), 9, eue)) : z("", !0),
          l.value && l.value.numResults.max > 1 ? (g(), Ce(Jy, {
            key: 1,
            value: tt.value,
            min: l.value.numResults.min,
            max: l.value.numResults.max,
            testid: "run-count",
            onUpdate: we[19] || (we[19] = (xe) => Ve({ n: xe }))
          }, null, 8, ["value", "min", "max"])) : z("", !0),
          u("span", tue, [
            mP.value && !Is.value ? (g(), b("button", {
              key: 0,
              class: "up-run is-get",
              "data-testid": "get-tokens",
              onClick: we[20] || (we[20] = (xe) => m(t).getTokens())
            }, [
              C($, {
                name: "Tokens",
                size: 13
              }),
              we[29] || (we[29] = J("Get tokens ", -1))
            ])) : (g(), b("button", {
              key: 1,
              class: G(["up-run", { "is-busy": Is.value }]),
              disabled: Is.value || !!po.value,
              title: po.value || Is.value ? void 0 : "Run (" + m(En)(["mod", "enter"]) + ")",
              "data-testid": "run",
              onClick: Tx
            }, [
              Is.value ? (g(), Ce($, {
                key: 0,
                name: "Loader2",
                size: 14,
                spin: ""
              })) : nn.value ? (g(), Ce($, {
                key: 1,
                name: "Lock",
                size: 13
              })) : z("", !0),
              J(" " + E(Is.value ? "Running" : nn.value ? Ui.value : "Run"), 1)
            ], 10, nue)),
            po.value && !Is.value ? (g(), b("span", iue, E(po.value), 1)) : z("", !0)
          ])
        ])
      ], 2)
    ], 36));
  }
}), Qc = "Arial, Helvetica, sans-serif", eu = 1.22, uue = 20;
let zh;
function hue() {
  if (zh === void 0) {
    const i = typeof navigator != "undefined" && /jsdom/i.test(navigator.userAgent);
    try {
      zh = typeof document != "undefined" && !i ? document.createElement("canvas").getContext("2d") : null;
    } catch {
      zh = null;
    }
  }
  return zh;
}
function Rp(i, e) {
  const t = hue();
  return t ? (t.font = "100px " + Qc, t.measureText(i).width * e / 100) : i.length * e * 0.55;
}
function pue(i, e, t) {
  const n = [];
  for (const s of (i || "").split(`
`)) {
    const o = s.split(/(\s+)/);
    let r = "";
    for (const a of o) {
      if (!a) continue;
      const l = r + a;
      for (Rp(l.replace(/\s+$/, ""), e) <= t || !r.trim() ? r = l : (n.push(r.replace(/\s+$/, "")), r = /^\s+$/.test(a) ? "" : a); Rp(r, e) > t && r.length > 1; ) {
        let d = r.length - 1;
        for (; d > 1 && Rp(r.slice(0, d), e) > t; ) d--;
        n.push(r.slice(0, d)), r = r.slice(d);
      }
    }
    n.push(r.replace(/\s+$/, ""));
  }
  return n.length ? n : [""];
}
function fue(i, e, t) {
  const n = pue(i, e, t), s = Math.max(e * 0.6, ...n.map((o) => Rp(o, e)));
  return { lines: n, width: Math.min(s, t), height: n.length * e * eu };
}
function qr(i) {
  return Math.max(i.w, i.h);
}
function tu(i, e) {
  return { x: i.x * e.w, y: i.y * e.h };
}
function $o(i, e) {
  return { x: i.x / e.w, y: i.y / e.h };
}
function Mu(i, e) {
  const t = i.size * qr(e), n = tu(i.pts[0], e), s = fue(i.text || "", t, Math.max(t, e.w - n.x));
  return { lines: s.lines, font: t, box: { x: n.x, y: n.y, w: s.width, h: s.height } };
}
function Sc(i, e) {
  if (i.kind === "text") return Mu(i, e).box;
  let t = 1 / 0, n = 1 / 0, s = -1 / 0, o = -1 / 0;
  for (const r of i.pts) {
    const a = tu(r, e);
    t = Math.min(t, a.x), n = Math.min(n, a.y), s = Math.max(s, a.x), o = Math.max(o, a.y);
  }
  return { x: t, y: n, w: s - t, h: o - n };
}
function Kr(i, e) {
  const t = Sc(i, e);
  return { x: t.x + t.w / 2, y: t.y + t.h / 2 };
}
function Lo(i, e, t) {
  const n = Math.cos(t), s = Math.sin(t), o = i.x - e.x, r = i.y - e.y;
  return { x: e.x + o * n - r * s, y: e.y + o * s + r * n };
}
function yl(i, e, t) {
  return e.rot ? Lo(i, Kr(e, t), -e.rot) : i;
}
function Sd(i, e, t) {
  const n = t.x - e.x, s = t.y - e.y, o = n * n + s * s || 1, r = Math.max(0, Math.min(1, ((i.x - e.x) * n + (i.y - e.y) * s) / o));
  return Math.hypot(i.x - (e.x + r * n), i.y - (e.y + r * s));
}
function S0(i, e, t) {
  if (i.kind === "text") {
    const l = Mu(i, t).box, d = Math.max(l.x - e.x, 0, e.x - (l.x + l.w)), c = Math.max(l.y - e.y, 0, e.y - (l.y + l.h));
    return Math.hypot(d, c);
  }
  const n = i.pts.map((l) => tu(l, t));
  if (i.kind === "brush" || i.kind === "arrow") {
    if (n.length === 1) return Math.hypot(e.x - n[0].x, e.y - n[0].y);
    let l = 1 / 0;
    for (let d = 1; d < n.length; d++) l = Math.min(l, Sd(e, n[d - 1], n[d]));
    return l;
  }
  const s = Sc(i, t);
  if (i.kind === "box") {
    const l = [{ x: s.x, y: s.y }, { x: s.x + s.w, y: s.y }, { x: s.x + s.w, y: s.y + s.h }, { x: s.x, y: s.y + s.h }];
    return Math.min(Sd(e, l[0], l[1]), Sd(e, l[1], l[2]), Sd(e, l[2], l[3]), Sd(e, l[3], l[0]));
  }
  const o = s.x + s.w / 2, r = s.y + s.h / 2;
  let a = 1 / 0;
  for (let l = 0; l < 64; l++) {
    const d = l / 64 * Math.PI * 2;
    a = Math.min(a, Math.hypot(e.x - (o + s.w / 2 * Math.cos(d)), e.y - (r + s.h / 2 * Math.sin(d))));
  }
  return a;
}
function mue(i, e, t, n = 6) {
  const s = yl(e, i, t);
  return i.kind === "text" ? S0(i, s, t) <= n : S0(i, s, t) <= Math.max(n, i.size * qr(t) / 2 + 4);
}
function cI(i, e, t) {
  const n = (s) => ({ x: s.x + e, y: s.y + t });
  return { ...i, pts: i.pts.map(n), erase: i.erase ? i.erase.map((s) => ({ ...s, pts: s.pts.map(n) })) : void 0 };
}
function gue(i, e, t, n, s) {
  const o = Kr(i, s), r = i.rot ? Lo(e, o, -i.rot) : e, a = (f) => {
    const p = tu(f, s);
    return $o({ x: r.x + (p.x - r.x) * t, y: r.y + (p.y - r.y) * n }, s);
  };
  let l;
  if (i.kind === "text") {
    const f = Math.max(0.05, n), p = tu(i.pts[0], s);
    l = { ...i, size: i.size * f, pts: [$o({ x: r.x + (p.x - r.x) * f, y: r.y + (p.y - r.y) * f }, s)] };
  } else
    l = { ...i, pts: i.pts.map(a), erase: i.erase ? i.erase.map((f) => ({ ...f, pts: f.pts.map(a) })) : void 0 };
  if (!i.rot) return l;
  const d = Kr(l, s), c = Lo(r, o, i.rot), h = Lo(r, d, i.rot);
  return cI(l, (c.x - h.x) / s.w, (c.y - h.y) / s.h);
}
function bue(i, e, t, n, s) {
  if (i.kind === "text") return !1;
  const o = yl(e, i, s), r = yl(t, i, s), a = n / 2 + i.size * qr(s) / 2 + 1, l = Math.max(1, Math.ceil(Math.hypot(r.x - o.x, r.y - o.y) / 3));
  for (let d = 0; d <= l; d++) {
    const c = d / l;
    if (S0(i, { x: o.x + (r.x - o.x) * c, y: o.y + (r.y - o.y) * c }, s) <= a) return !0;
  }
  return !1;
}
function vue(i, e) {
  return i.x < e.x + e.w && i.x + i.w > e.x && i.y < e.y + e.h && i.y + i.h > e.y;
}
const db = 1e3, uI = 0.1;
function M0(i) {
  return i.kind === "text" || i.opacity == null ? 1 : Math.max(uI, Math.min(1, i.opacity));
}
function hI(i, e) {
  const t = Math.round(db * (e || 3) / (i || 4));
  return { w: db, h: t, long: Math.max(db, t) };
}
function ui(i, e) {
  return i * e.w;
}
function hi(i, e) {
  return i * e.h;
}
function Ef(i, e) {
  if (!i.length) return "";
  if (i.length < 3) return "M" + ui(i[0].x, e) + " " + hi(i[0].y, e) + i.slice(1).map((s) => " L" + ui(s.x, e) + " " + hi(s.y, e)).join("") + (i.length === 1 ? " l0.1 0" : "");
  let t = "M" + ui(i[0].x, e) + " " + hi(i[0].y, e);
  for (let s = 1; s < i.length - 1; s++) {
    const o = (ui(i[s].x, e) + ui(i[s + 1].x, e)) / 2, r = (hi(i[s].y, e) + hi(i[s + 1].y, e)) / 2;
    t += " Q" + ui(i[s].x, e) + " " + hi(i[s].y, e) + " " + o + " " + r;
  }
  const n = i[i.length - 1];
  return t + " L" + ui(n.x, e) + " " + hi(n.y, e);
}
function Qy(i, e) {
  return Math.max(1.5, i.size * e.long);
}
function pI(i, e) {
  return Math.max(1.5, i * e.long);
}
function T0(i, e) {
  const t = i.pts[0], n = i.pts[i.pts.length - 1], s = ui(t.x, e), o = hi(t.y, e), r = ui(n.x, e), a = hi(n.y, e), l = Math.atan2(a - o, r - s), d = Math.max(0.012 * e.long, Qy(i, e) * 3.5), c = r - Math.cos(l) * d, h = a - Math.sin(l) * d, f = -Math.sin(l) * (d / 2), p = Math.cos(l) * (d / 2), y = r - Math.cos(l) * (d / 2), v = a - Math.sin(l) * (d / 2);
  return { line: "M" + s + " " + o + " L" + y + " " + v, head: r + "," + a + " " + (c + f) + "," + (h + p) + " " + (c - f) + "," + (h - p) };
}
function Us(i, e) {
  const t = i.pts[0], n = i.pts[i.pts.length - 1];
  return { x: ui(Math.min(t.x, n.x), e), y: hi(Math.min(t.y, n.y), e), width: Math.abs(ui(n.x, e) - ui(t.x, e)), height: Math.abs(hi(n.y, e) - hi(t.y, e)) };
}
function fI(i, e) {
  if (!i.rot) return;
  const t = i.kind === "text" ? Mu(i, e).box : null;
  let n, s;
  if (t)
    n = t.x + t.w / 2, s = t.y + t.h / 2;
  else {
    const o = i.pts.map((a) => ui(a.x, e)), r = i.pts.map((a) => hi(a.y, e));
    n = (Math.min(...o) + Math.max(...o)) / 2, s = (Math.min(...r) + Math.max(...r)) / 2;
  }
  return "rotate(" + i.rot * 180 / Math.PI + " " + n + " " + s + ")";
}
function Or(i, e) {
  const t = Mu(i, e);
  return { x: t.box.x, y: t.box.y, font: t.font, lines: t.lines };
}
function mI(i, e) {
  return i ? e * eu : e * (eu - 1) / 2;
}
function gI(i, e = !1) {
  return (e ? 0.022 : 0.026) * i.long;
}
function Jd(i, e) {
  return { cx: ui(i.x, e), cy: hi(i.y, e) };
}
const yue = "#7c4dff", xue = "#ffffff";
function Da(i) {
  return i.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function rn(i) {
  return String(Math.round(i * 100) / 100);
}
function wue(i, e, t, n, s) {
  const o = hI(e, t), r = [], a = [];
  i.strokes.forEach((d, c) => {
    const h = "e" + c, f = !!(d.erase && d.erase.length);
    if (f) {
      const S = d.erase.map((M) => '<path d="' + Ef(M.pts, o) + '" fill="none" stroke="#000" stroke-width="' + rn(pI(M.size, o)) + '" stroke-linecap="round" stroke-linejoin="round"/>').join("");
      a.push('<mask id="' + h + '" maskUnits="userSpaceOnUse" x="' + -o.w + '" y="' + -o.h + '" width="' + o.w * 3 + '" height="' + o.h * 3 + '"><rect x="' + -o.w + '" y="' + -o.h + '" width="' + o.w * 3 + '" height="' + o.h * 3 + '" fill="#fff"/>' + S + "</mask>");
    }
    const p = fI(d, o);
    let y = "";
    if (d.kind === "text") {
      const S = Or(d, o), M = S.lines.map((_, T) => '<tspan x="' + rn(S.x) + '" dy="' + rn(mI(T, S.font)) + '">' + Da(_ || " ") + "</tspan>").join("");
      y = '<text x="' + rn(S.x) + '" y="' + rn(S.y) + '" font-size="' + rn(S.font) + '" fill="' + Da(d.color) + '" font-family="' + Da(Qc) + '" dominant-baseline="text-before-edge">' + M + "</text>";
    } else {
      const S = 'fill="none" stroke="' + Da(d.color) + '" stroke-width="' + rn(Qy(d, o)) + '" stroke-linecap="round" stroke-linejoin="round"';
      if (d.kind === "brush") y = '<path d="' + Ef(d.pts, o) + '" ' + S + "/>";
      else if (d.kind === "arrow") {
        const M = T0(d, o);
        y = '<path d="' + M.line + '" ' + S + '/><polygon points="' + M.head + '" fill="' + Da(d.color) + '"/>';
      } else if (d.kind === "box") {
        const M = Us(d, o);
        y = '<rect x="' + rn(M.x) + '" y="' + rn(M.y) + '" width="' + rn(M.width) + '" height="' + rn(M.height) + '" ' + S + "/>";
      } else if (d.kind === "ellipse") {
        const M = Us(d, o);
        y = '<ellipse cx="' + rn(M.x + M.width / 2) + '" cy="' + rn(M.y + M.height / 2) + '" rx="' + rn(M.width / 2) + '" ry="' + rn(M.height / 2) + '" ' + S + "/>";
      }
    }
    const v = f ? '<g mask="url(#' + h + ')">' + y + "</g>" : y, x = M0(d), w = x < 1 ? '<g opacity="' + rn(x) + '">' + v + "</g>" : v;
    r.push(p ? '<g transform="' + p + '">' + w + "</g>" : w);
  });
  const l = gI(o);
  return i.pins.forEach((d, c) => {
    const h = Jd(d, o);
    r.push('<circle cx="' + rn(h.cx) + '" cy="' + rn(h.cy) + '" r="' + rn(l) + '" fill="' + yue + '" stroke="#fff" stroke-width="2.5"/><text x="' + rn(h.cx) + '" y="' + rn(h.cy) + '" font-size="' + rn(l * 1.05) + '" fill="' + xue + '" font-family="' + Da(Qc) + '" font-weight="700" text-anchor="middle" dominant-baseline="central">' + (c + 1) + "</text>");
  }), '<svg xmlns="http://www.w3.org/2000/svg" width="' + n + '" height="' + s + '" viewBox="0 0 ' + o.w + " " + o.h + '" preserveAspectRatio="none">' + (a.length ? "<defs>" + a.join("") + "</defs>" : "") + r.join("") + "</svg>";
}
const kue = ["viewBox", "preserveAspectRatio"], _ue = ["id", "x", "y", "width", "height"], Sue = ["x", "y", "width", "height"], Mue = ["d", "stroke-width"], Tue = ["data-stroke", "transform", "opacity"], Cue = ["mask"], Iue = ["x", "y", "font-size", "fill", "font-family"], Aue = ["x", "dy"], Pue = ["stroke", "stroke-width"], Eue = ["d"], Rue = ["d"], zue = ["points", "fill"], $ue = ["cx", "cy", "rx", "ry"], Due = ["cx", "cy", "r"], Oue = ["x", "y", "font-size"], bI = /* @__PURE__ */ Pe({
  __name: "MarksSvg",
  props: {
    marks: {},
    w: {},
    h: {},
    live: { default: null },
    small: { type: Boolean, default: !1 },
    hide: { default: () => [] },
    fit: { default: "slice" }
  },
  setup(i) {
    const e = i, t = SE(), n = I(() => hI(e.w, e.h)), s = I(() => {
      const r = e.live ? [...e.marks.strokes, e.live] : e.marks.strokes;
      return e.hide.length ? r.filter((a) => !e.hide.includes(a.id)) : r;
    }), o = I(() => gI(n.value, e.small));
    return (r, a) => (g(), b("svg", {
      class: "sv-marks",
      viewBox: "0 0 " + n.value.w + " " + n.value.h,
      preserveAspectRatio: i.fit === "slice" ? "xMidYMid slice" : "none",
      "aria-hidden": "true"
    }, [
      u("defs", null, [
        (g(!0), b(j, null, be(s.value.filter((l) => l.erase && l.erase.length), (l) => (g(), b("mask", {
          id: m(t) + "-" + l.id,
          key: l.id,
          maskUnits: "userSpaceOnUse",
          x: -n.value.w,
          y: -n.value.h,
          width: n.value.w * 3,
          height: n.value.h * 3
        }, [
          u("rect", {
            x: -n.value.w,
            y: -n.value.h,
            width: n.value.w * 3,
            height: n.value.h * 3,
            fill: "#fff"
          }, null, 8, Sue),
          (g(!0), b(j, null, be(l.erase, (d, c) => (g(), b("path", {
            key: c,
            d: m(Ef)(d.pts, n.value),
            fill: "none",
            stroke: "#000",
            "stroke-width": m(pI)(d.size, n.value),
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Mue))), 128))
        ], 8, _ue))), 128))
      ]),
      (g(!0), b(j, null, be(s.value, (l) => (g(), b("g", {
        key: l.id,
        "data-stroke": l.id,
        class: "sv-stroke",
        transform: m(fI)(l, n.value),
        opacity: m(M0)(l) < 1 ? m(M0)(l) : void 0
      }, [
        u("g", {
          mask: l.erase && l.erase.length ? "url(#" + m(t) + "-" + l.id + ")" : void 0
        }, [
          l.kind === "text" ? (g(), b("text", {
            key: 0,
            x: m(Or)(l, n.value).x,
            y: m(Or)(l, n.value).y,
            "font-size": m(Or)(l, n.value).font,
            fill: l.color,
            "font-family": m(Qc),
            "dominant-baseline": "text-before-edge"
          }, [
            (g(!0), b(j, null, be(m(Or)(l, n.value).lines, (d, c) => (g(), b("tspan", {
              key: c,
              x: m(Or)(l, n.value).x,
              dy: m(mI)(c, m(Or)(l, n.value).font)
            }, E(d || " "), 9, Aue))), 128))
          ], 8, Iue)) : (g(), b("g", {
            key: 1,
            fill: "none",
            stroke: l.color,
            "stroke-width": m(Qy)(l, n.value),
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            l.kind === "brush" ? (g(), b("path", {
              key: 0,
              d: m(Ef)(l.pts, n.value)
            }, null, 8, Eue)) : l.kind === "arrow" ? (g(), b(j, { key: 1 }, [
              u("path", {
                d: m(T0)(l, n.value).line
              }, null, 8, Rue),
              u("polygon", {
                points: m(T0)(l, n.value).head,
                fill: l.color,
                stroke: "none"
              }, null, 8, zue)
            ], 64)) : l.kind === "box" ? (g(), b("rect", B5({
              key: 2,
              ref_for: !0
            }, m(Us)(l, n.value)), null, 16)) : l.kind === "ellipse" ? (g(), b("ellipse", {
              key: 3,
              cx: m(Us)(l, n.value).x + m(Us)(l, n.value).width / 2,
              cy: m(Us)(l, n.value).y + m(Us)(l, n.value).height / 2,
              rx: m(Us)(l, n.value).width / 2,
              ry: m(Us)(l, n.value).height / 2
            }, null, 8, $ue)) : z("", !0)
          ], 8, Pue))
        ], 8, Cue)
      ], 8, Tue))), 128)),
      (g(!0), b(j, null, be(i.marks.pins, (l, d) => (g(), b("g", {
        key: l.id,
        class: "sv-pin-mark"
      }, [
        u("circle", {
          cx: m(Jd)(l, n.value).cx,
          cy: m(Jd)(l, n.value).cy,
          r: o.value
        }, null, 8, Due),
        i.small ? z("", !0) : (g(), b("text", {
          key: 0,
          x: m(Jd)(l, n.value).cx,
          y: m(Jd)(l, n.value).cy,
          "font-size": o.value * 1.05,
          "text-anchor": "middle",
          "dominant-baseline": "central"
        }, E(d + 1), 9, Oue))
      ]))), 128))
    ], 8, kue));
  }
});
function vI(i, e) {
  const t = /* @__PURE__ */ new Set([e]);
  let n = e;
  for (; ; ) {
    const s = i(n);
    if (!s || t.has(s)) return n;
    t.add(s), n = s;
  }
}
function Lue(i, e, t) {
  if (!t) return [];
  const n = /* @__PURE__ */ new Map(), s = (r) => {
    let a = n.get(r);
    return a === void 0 && (a = vI(e, r), n.set(r, a)), a;
  }, o = s(t);
  return i.filter((r) => s(r.id) === o).sort((r, a) => a.createdAt - r.createdAt);
}
function Bue(i, e) {
  const t = /* @__PURE__ */ new Map(), n = i.filter((s) => s.id !== e).sort((s, o) => s.createdAt - o.createdAt);
  return e && i.some((s) => s.id === e) && t.set(e, "Original"), n.forEach((s, o) => t.set(s.id, "v" + (o + 1))), t;
}
function $h(i, e, t) {
  return i.includes(e) ? { queue: i, full: !1 } : i.length >= t ? { queue: i, full: !0 } : { queue: [...i, e], full: !1 };
}
function R_(i, e) {
  return i.filter((t) => t !== e);
}
function Dh(i, e, t) {
  const n = i.filter((s) => s !== e);
  return n.length ? { queue: [e, ...n.slice(1)].slice(0, Math.max(1, t)), full: !1 } : { queue: [e], full: !1 };
}
function Fue(i, e) {
  return Math.min(i.length, Math.max(0, e));
}
function Nue() {
  const i = [];
  i.push({ x: 0, z: 0, y: 0, w: 64, d: 44, h: 9, rot: 0 }), i.push({ x: 0, z: 0, y: 9, w: 58, d: 38, h: 3, rot: 0 });
  for (let e = 0; e < 15; e++) i.push({ x: -13, z: -2, y: 12 + e * 5.2, w: 17, d: 17, h: 5.2, rot: e * 0.045 });
  for (let e = 0; e < 12; e++) i.push({ x: 14, z: 5, y: 12 + e * 5.2, w: 15, d: 15, h: 5.2, rot: -e * 0.06 });
  return i.push({ x: 0.5, z: 1.5, y: 58, w: 12, d: 5, h: 3.6, rot: 0.12 }), i.push({ x: -52, z: -40, y: 0, w: 26, d: 22, h: 16, rot: 0 }), i.push({ x: 50, z: -38, y: 0, w: 24, d: 26, h: 22, rot: 0 }), i.push({ x: -50, z: 42, y: 0, w: 22, d: 18, h: 11, rot: 0 }), i.push({ x: 54, z: 40, y: 0, w: 20, d: 20, h: 28, rot: 0 }), i.push({ x: 0, z: 0, y: -0.4, w: 180, d: 150, h: 0.4, rot: 0 }), i;
}
function Oa(i) {
  return String(Math.round(i * 1e3) / 1e3);
}
function yI() {
  const i = ["# Bonneville Tower massing (sample)", "o massing"];
  let e = 1, t = 1;
  for (const n of Nue()) {
    const s = Math.cos(n.rot), o = Math.sin(n.rot), r = (c, h, f) => {
      const p = c * n.w / 2, y = f * n.d / 2;
      return [n.x + p * s - y * o, h, n.z + p * o + y * s];
    }, a = n.y, l = n.y + n.h, d = [
      { pts: [r(-1, l, -1), r(-1, l, 1), r(1, l, 1), r(1, l, -1)], nrm: [0, 1, 0] },
      { pts: [r(-1, a, -1), r(1, a, -1), r(1, a, 1), r(-1, a, 1)], nrm: [0, -1, 0] },
      { pts: [r(-1, a, -1), r(-1, l, -1), r(1, l, -1), r(1, a, -1)], nrm: [o, 0, -s] },
      { pts: [r(1, a, -1), r(1, l, -1), r(1, l, 1), r(1, a, 1)], nrm: [s, 0, o] },
      { pts: [r(1, a, 1), r(1, l, 1), r(-1, l, 1), r(-1, a, 1)], nrm: [-o, 0, s] },
      { pts: [r(-1, a, 1), r(-1, l, 1), r(-1, l, -1), r(-1, a, -1)], nrm: [-s, 0, -o] }
    ];
    for (const c of d) {
      for (const h of c.pts) i.push("v " + Oa(h[0]) + " " + Oa(h[1]) + " " + Oa(h[2]));
      i.push("vn " + Oa(c.nrm[0]) + " " + Oa(c.nrm[1]) + " " + Oa(c.nrm[2])), i.push("f " + [0, 1, 2, 3].map((h) => e + h + "//" + t).join(" ")), e += 4, t += 1;
    }
  }
  return i.join(`
`) + `
`;
}
const Uue = 800;
function xI(i, e, t = Uue) {
  const n = Math.min(1, t / Math.max(i || 1, e || 1));
  return { w: Math.max(1, Math.round((i || 1) * n)), h: Math.max(1, Math.round((e || 1) * n)) };
}
function wI(i, e) {
  return new Promise((t, n) => {
    const s = new Image();
    e && (s.crossOrigin = "anonymous"), s.onload = () => t(s), s.onerror = () => n(new Error("The picture couldn't be read.")), s.src = i;
  });
}
function Gue(i) {
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(i);
}
async function kI(i, e, t, n, s, o) {
  const r = await wI(Gue(wue(e, t, n, s, o)), !1);
  i.drawImage(r, 0, 0, s, o);
}
async function jue(i, e, t) {
  const n = xI(e, t), s = document.createElement("canvas");
  s.width = n.w, s.height = n.h;
  const o = s.getContext("2d");
  if (!o) throw new Error("The annotations couldn't be drawn.");
  return await kI(o, i, e, t, n.w, n.h), s.toDataURL("image/png").split(",")[1] || "";
}
async function Hue(i, e, t, n, s = 640) {
  const o = xI(t, n, s), r = document.createElement("canvas");
  r.width = o.w, r.height = o.h;
  const a = r.getContext("2d");
  if (!a) throw new Error("The annotations couldn't be drawn.");
  try {
    const l = await wI(i, !i.startsWith("data:") && !i.startsWith("blob:"));
    a.drawImage(l, 0, 0, o.w, o.h);
  } catch {
    a.fillStyle = "#808080", a.fillRect(0, 0, o.w, o.h);
  }
  return await kI(a, e, t, n, o.w, o.h), r.toDataURL("image/jpeg", 0.85);
}
const z_ = { prompt: "generate", threed: "generate", edit: "edit" };
function cb(i) {
  return i !== "prompt" && i !== "threed";
}
const xl = {
  threed: { text: "3D view", icon: "Box" },
  upload: { text: "Brought in", icon: "Upload" },
  board: { text: "From the board", icon: "LayoutGrid" },
  library: { text: "From your Library", icon: "Library" },
  tool: { text: "Made here", icon: "Wand2" }
};
function Md() {
  return { strokes: [], pins: [] };
}
function Zd(i) {
  return !!i && (i.strokes.length > 0 || i.pins.length > 0);
}
function _I(i) {
  return !!i && !!i.area && i.area.some((e) => !e.cut);
}
function ub(i) {
  return Zd(i) || _I(i);
}
function Vue(i) {
  return i.kind === "object" ? { ...i } : { ...i, pts: i.pts.slice() };
}
function Td(i) {
  const e = {
    strokes: i.strokes.map((t) => ({ ...t, pts: t.pts.slice(), erase: t.erase ? t.erase.map((n) => ({ ...n, pts: n.pts.slice() })) : void 0 })),
    pins: i.pins.map((t) => ({ ...t }))
  };
  return i.area && i.area.length && (e.area = i.area.map(Vue)), e;
}
function Wue(i, e) {
  return JSON.stringify(i) === JSON.stringify(e);
}
const SI = [
  { id: "upscale", label: "Upscale", icon: "Maximize2", hint: "More pixels and detail, for print and large screens" },
  { id: "resize", label: "Resize", icon: "Crop", hint: "Crop to a shape, or expand past the edges" },
  { id: "background", label: "Background", icon: "Layers", hint: "Remove it, replace it, or adjust it apart from the subject" },
  { id: "adjust", label: "Adjust", icon: "SlidersHorizontal", hint: "Light, colour, grading, grain and rotation, live" },
  { id: "skin", label: "Improve people", icon: "Smile", hint: "Natural skin, light and detail on the people" },
  { id: "camera", label: "Change camera", icon: "Rotate3d", hint: "See the scene from another angle" },
  { id: "relight", label: "Relight", icon: "Lightbulb", hint: "New light: direction, colour and mood" }
];
function ex(i) {
  return i && SI.find((e) => e.id === i) || null;
}
const hb = {
  edit: "Edit",
  erase: "Erase",
  upscale: "Upscale",
  removebg: "Remove background",
  replacebg: "Replace background",
  expand: "Expand",
  skin: "Improve people",
  camera: "Change camera",
  relight: "Relight",
  select: "Find objects",
  draw: "Draw edit",
  comment: "Annotate edit",
  threed: "3D edit"
}, $_ = {
  removebg: ["w4WjiaPJ8YlnXqalLseS"],
  erase: ["n830hmDOmMafIztf5qZs"],
  upscale: ["n5NO4aX5MGjmfEVg0KdE", "ykyBMjS0ISJeWy9jOqhm", "QCpMJ7Dw9Wa1956Sh6Hw", "QejUMwHU49HRMWwpqhkD", "n4H8sQlLxTc1aeYJxdiv"]
}, que = {
  removebg: /^remove background$/i,
  erase: /person and object remover|eraser|^erase$/i,
  expand: /^expand$/i,
  camera: /^change camera|multiple angles/i,
  select: /^find objects|select objects/i
}, MI = /^nano banana pro\b/i, Kue = [
  "4CJEOIwhf2WhGq2K0eHl",
  // Nano Banana 2.1
  "6BJyvazKHGTilS1yWk76",
  // Nano Banana 2
  "VpkLvmqERLkoU2vBNTJ7",
  // Nano Banana 2 Lite
  "eILT27MJkTwxnVSPQP2x",
  // Nano Banana Pro
  "s9ShIto8LPgdOSImFC39",
  // ChatGPT Image 2.5 Sunburst
  "50XKlkMz7r9kmipyspRQ",
  // ChatGPT Image 2.5 Flare
  "YuklxMGHwrC50w7yjLBm",
  // ChatGPT Image 2.0 (Krea's ChatGPT 2)
  "B9nbLi2HgM7XHeaBoOJD",
  // Seedream V5 Pro
  "zzhnCi7Bow9ekkRXy5pP",
  // Luma UNI-1
  "gYjYjnyvD6hFxcdl1mul",
  // Luma UNI-1 Max
  "UNuq3Ia9Wlos2DWSFrlv",
  // Flux 2 Klein 4B
  "9rnhLVpVce28QPnjYiQ3",
  // ChatGPT Image Edit 1.5 (Krea's ChatGPT 1.5)
  "JcDKjRIyFolGJVEOIgya",
  // Flux 3 Image
  "7XrsYAALFZVLveefN5DL",
  // Flux 2 Pro
  "BfRqukmRHNORna2upyyt",
  // Flux 2 Flex
  "vMzpgBA14pAFuBgU8yby",
  // Flux 2 Max
  "2oYW3kqy1XetTh4PURbF",
  // Qwen Edit 2511 (Krea's Qwen Image Plus)
  "2aIZvnBeZYdY4ldYEdGO",
  // Nano Banana Edit (Krea's Nano Banana)
  "CzrPq1r9zRrEb8hsES2e",
  // Qwen Image Edit
  "bKkjGeP6wjLsl1314ybn",
  // Flux Kontext Pro
  "Wee8kviizptLQp8DkEKn"
  // Flux Kontext Max
];
function Ul(i) {
  return !!TI(i);
}
function TI(i) {
  return oo(i).find((e) => !!(e.raw && e.raw.display && e.raw.display.hasInpainting)) || null;
}
function Yue(i) {
  const e = /* @__PURE__ */ new Set(), t = [];
  for (const n of [...i.tools || [], ...i.kits.flatMap((s) => s.models)])
    e.has(n.id) || (e.add(n.id), t.push(n));
  return t;
}
function D_(i) {
  return oo(i).length > 0 && !i.fields.some((e) => e.kind === "video" && e.placement === "reference");
}
function Xue(i, e, t) {
  const n = Kue.map((s) => e.find((o) => o.id === s)).filter((s) => !!s && _f(s) && !Ul(s));
  return n.length ? n : qC(i, "edit", t).filter((s) => !Ul(s));
}
function Jue(i, e, t) {
  if (e === "prompt" || e === "threed") return qC(i, e, t);
  const n = Yue(i), s = n.filter((d) => d.boardTool === e);
  if (e === "edit" || e === "replacebg" || e === "skin" || e === "relight") {
    const d = Xue(i, n, t), c = d.find((f) => MI.test(f.name)), h = c ? [c, ...d.filter((f) => f !== c)] : d;
    return e === "relight" ? h.slice(0, 1) : h;
  }
  if (e === "upscale") {
    const d = i.kits.find((p) => p.id === "upscale"), c = (d ? d.models : []).filter((p) => D_(p) && _f(p)), h = ($_.upscale || []).map((p) => n.find((y) => y.id === p)).filter((p) => !!p && D_(p)), f = [];
    for (const p of [...s, ...h, ...c]) f.some((y) => y.id === p.id) || f.push(p);
    return f;
  }
  const o = $_[e] || [], r = que[e], a = [], l = [...s, ...o.map((d) => n.find((c) => c.id === d)).filter((d) => !!d), ...r ? n.filter((d) => r.test(d.name)) : []];
  for (const d of l)
    !a.some((c) => c.id === d.id) && _f(d) && a.push(d);
  return e === "erase" ? a.filter(Ul).concat(a.filter((d) => !Ul(d))) : a;
}
function Zue(i, e, t) {
  return i.fields.find((n) => n.raw && n.raw.boardKey === e) || i.fields.find((n) => n.key === e) || t && i.fields.find((n) => t.test(n.label)) || null;
}
function O_(i, e, t = {}) {
  const n = {};
  for (const [s, o] of Object.entries(e)) {
    if (o === void 0) continue;
    const r = Zue(i, s, t[s]);
    r && (n[r.key] = o);
  }
  return n;
}
function Que(i, e) {
  const t = [], n = i.trim();
  return e.erase ? t.push(n ? "Remove what is marked in magenta from image 1, and put this in its place, matching the surroundings: " + n : "Remove what is marked in magenta from image 1, and fill the space with what would naturally be behind it, matching the surroundings.") : n && t.push(n), e.guide ? t.push(e.erase ? "Image 2 is image 1 with the area to remove marked in magenta; it is a guide only." : "Image 1 is the image to edit. Image 2 is the same image with the area to change marked in magenta: make the change only inside that area of image 1, and keep the rest of image 1 as it is. Image 2 is a guide only: the result is image 1, with no magenta marking.") : t.push("The area to change is marked in magenta (a tinted wash with an outline): make the change only there, keep the rest of the image as it is, and remove the magenta marking from the result."), t.join(`
`);
}
function ehe(i, e) {
  return e <= 1 ? "Image " + i + " is a reference." : "Images " + i + (e === 2 ? " and " : " to ") + (i + e - 1) + " are references.";
}
function the(i, e) {
  const t = i.trim().replace(/\.$/, "");
  return "Replace the background of image 1 with " + (e ? "the background in image 2" + (t ? " (" + t + ")" : "") : t || "a clean, natural background that suits the subject") + ". Keep the subject exactly as it is: its shape, edges, colours and the light on it, and its place and size in the frame. Match the new background's perspective and horizon to the camera, and its light to the light on the subject, with natural contact shadows.";
}
const pb = [
  { id: "faithful", label: "Faithful", hint: "Keeps every feature; refines only the skin" },
  { id: "flexible", label: "Flexible", hint: "A balance of fidelity and polish" },
  { id: "creative", label: "Creative", hint: "Polishes freely; people stay recognisable" }
], nhe = [
  { id: "skin", label: "Natural skin" },
  { id: "everything", label: "Skin, eyes, hair and clothes" },
  { id: "light", label: "Better light on faces" },
  { id: "real", label: "Make them look real" },
  { id: "nomakeup", label: "No makeup" }
];
function ihe() {
  return { version: "faithful", focus: "skin", sharpen: 30, grain: 0 };
}
function she(i) {
  const e = ["Retouch the people in image 1 as a high-end photo retoucher would."];
  e.push(i.version === "faithful" ? "Keep each person's identity, features and expression exactly as they are, and change nothing about them except what follows." : i.version === "creative" ? "Improve them freely, as a beauty retoucher would, while keeping each person recognisable." : "Keep each person's identity and expression, and polish the skin and details with a light hand.");
  const t = {
    skin: "Give the skin natural texture and pores, even out blotches and blemishes, and remove any plastic, airbrushed look.",
    everything: "Give the skin natural texture and pores, and refine the eyes, hair, teeth and the detail in clothing.",
    light: "Improve the light on the faces: soft, flattering and natural, with gentle shadows.",
    real: "Make the people look like a real photograph of real people: real skin texture, natural imperfections and realistic hair, nothing rendered or doll-like.",
    nomakeup: "Remove all makeup, leaving natural bare skin."
  };
  return e.push(t[i.focus]), i.sharpen >= 60 ? e.push("Render fine detail crisply.") : i.sharpen >= 25 && e.push("Keep detail sharp."), i.grain >= 50 ? e.push("Add visible fine film grain.") : i.grain >= 15 && e.push("Add a subtle, natural photographic grain."), e.push("Keep everything else in the picture as it is: the background, the composition, the colours and the camera angle."), e.join(" ");
}
const ohe = 8192, La = /* @__PURE__ */ new Map();
function rhe(i) {
  return i.startsWith("blob:") || i.startsWith("data:") ? i : i + (i.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1";
}
function si(i) {
  let e = La.get(i);
  if (!e && (e = (async () => {
    const t = await fetch(rhe(i), { mode: "cors", credentials: "omit" });
    if (!t.ok) throw new Error("The picture couldn't be read (" + t.status + ").");
    return createImageBitmap(await t.blob());
  })(), La.set(i, e), e.catch(() => La.delete(i)), La.size > 12)) {
    const t = La.keys().next().value;
    t !== void 0 && t !== i && La.delete(t);
  }
  return e;
}
function Rn(i, e) {
  const t = document.createElement("canvas");
  return t.width = Math.max(1, Math.round(i)), t.height = Math.max(1, Math.round(e)), t;
}
function zn(i) {
  const e = i.getContext("2d", { willReadFrequently: !1 });
  if (!e) throw new Error("The browser couldn't draw the picture.");
  return e;
}
function fb(i, e = !1) {
  return new Promise((t, n) => {
    i.toBlob((s) => s ? t(s) : n(new Error("The picture couldn't be saved.")), e ? "image/png" : "image/jpeg", 0.94);
  });
}
function mb(i, e) {
  const t = i.type === "image/png" ? "png" : "jpg";
  return new File([i], e.replace(/[^a-z0-9-]+/gi, "-").toLowerCase() + "." + t, { type: i.type });
}
function wl(i, e, t = ohe) {
  const n = Math.min(1, t / Math.max(i, e));
  return { w: Math.max(1, Math.round(i * n)), h: Math.max(1, Math.round(e * n)) };
}
function ahe(i, e, t) {
  const n = e.x * i.width, s = e.y * i.height, o = e.w * i.width, r = e.h * i.height, a = wl(o, r), l = Rn(a.w, a.h), d = zn(l);
  return d.imageSmoothingQuality = "high", d.drawImage(i, n, s, o, r, 0, 0, a.w, a.h), l;
}
function CI(i) {
  const e = Math.min(1, 256 / Math.max(i.width, i.height)), t = Rn(i.width * e, i.height * e), n = zn(t);
  n.drawImage(i, 0, 0, t.width, t.height);
  const s = n.getImageData(0, 0, t.width, t.height).data;
  for (let o = 3; o < s.length; o += 4) if (s[o] < 250) return !0;
  return !1;
}
function lhe(i, e = 256) {
  const t = Math.min(1, e / Math.max(i.width, i.height)), n = Rn(i.width * t, i.height * t), s = zn(n);
  return s.drawImage(i, 0, 0, n.width, n.height), s.getImageData(0, 0, n.width, n.height).data;
}
function II(i, e) {
  const t = Rn(i.width, i.height), n = zn(t);
  return e && (n.fillStyle = e, n.fillRect(0, 0, t.width, t.height)), n.drawImage(i, 0, 0), t;
}
function Oh() {
  return { target: "background", blur: 0, grayscale: 0, sepia: 0, brightness: 100, contrast: 100, saturation: 100 };
}
function nu(i) {
  return i.blur > 0 || i.grayscale > 0 || i.sepia > 0 || i.brightness !== 100 || i.contrast !== 100 || i.saturation !== 100;
}
function L_(i, e = 1) {
  const t = [];
  return i.blur > 0 && t.push("blur(" + (i.blur * e).toFixed(2) + "px)"), i.grayscale > 0 && t.push("grayscale(" + i.grayscale + "%)"), i.sepia > 0 && t.push("sepia(" + i.sepia + "%)"), i.brightness !== 100 && t.push("brightness(" + i.brightness + "%)"), i.contrast !== 100 && t.push("contrast(" + i.contrast + "%)"), i.saturation !== 100 && t.push("saturate(" + i.saturation + "%)"), t.join(" ") || "none";
}
function AI(i, e, t, n = i.width, s = i.height) {
  const o = n / i.width, r = Rn(n, s), a = zn(r), l = Rn(n, s), d = zn(l);
  return d.drawImage(i, 0, 0, n, s), d.globalCompositeOperation = "destination-in", d.drawImage(e, 0, 0, n, s), t.target === "background" ? (a.filter = L_(t, o), a.drawImage(i, 0, 0, n, s), a.filter = "none", a.drawImage(l, 0, 0)) : (a.drawImage(i, 0, 0, n, s), a.filter = L_(t, o), a.drawImage(l, 0, 0), a.filter = "none"), r;
}
function dhe(i, e, t, n) {
  const s = i.width, o = i.height, r = Rn(s, o), a = zn(r);
  a.drawImage(i, 0, 0);
  const l = Rn(s, o), d = zn(l);
  return d.imageSmoothingQuality = "high", d.drawImage(e, 0, 0, s, o), d.globalCompositeOperation = "destination-in", d.filter = n > 0 ? "blur(" + n.toFixed(1) + "px)" : "none", d.drawImage(t, 0, 0, s, o), d.filter = "none", a.drawImage(l, 0, 0), r;
}
function gb(i, e, t) {
  const n = Math.min(1, e / Math.max(i.width, i.height));
  if (n >= 1) return i.toDataURL(t ? "image/png" : "image/jpeg", 0.9);
  const s = Rn(i.width * n, i.height * n), o = zn(s);
  return o.imageSmoothingQuality = "high", o.drawImage(i, 0, 0, s.width, s.height), s.toDataURL(t ? "image/png" : "image/jpeg", 0.9);
}
const bb = /* @__PURE__ */ new Map();
function che(i, e, t, n = "") {
  const s = new Uint16Array(e * t), o = /* @__PURE__ */ new Map();
  let r = 0;
  for (let a = 0, l = 0; a < s.length; a++, l += 4) {
    const d = i[l + 3] >= 128;
    d && i[l + 2] > 0 && r++;
    const c = !d || i[l + 2] > 0 ? 0 : i[l] + i[l + 1] * 256;
    s[a] = c, c && o.set(c, (o.get(c) || 0) + 1);
  }
  return { url: n, w: e, h: t, ids: s, count: o.size, sizes: o, stray: r, masks: /* @__PURE__ */ new Map() };
}
const uhe = 2048;
function hhe(i) {
  return i.count > 0 && i.count <= uhe && i.stray <= i.w * i.h * 0.01;
}
function Rf(i) {
  let e = bb.get(i);
  return e || (e = si(i).then((t) => {
    const n = Rn(t.width, t.height), s = n.getContext("2d", { willReadFrequently: !0 });
    s.imageSmoothingEnabled = !1, s.drawImage(t, 0, 0);
    const o = che(s.getImageData(0, 0, n.width, n.height).data, n.width, n.height, i);
    if (!hhe(o)) throw new Error(`not a map of objects (${o.count} objects, ${o.stray} stray pixels)`);
    return o;
  }), bb.set(i, e), e.catch(() => bb.delete(i))), e;
}
function B_(i, e, t) {
  const n = Math.min(i.w - 1, Math.max(0, Math.floor(e * i.w))), s = Math.min(i.h - 1, Math.max(0, Math.floor(t * i.h)));
  return i.ids[s * i.w + n] || 0;
}
function PI(i, e) {
  const t = i.masks.get(e);
  if (t) return t;
  const n = Rn(i.w, i.h), s = zn(n), o = s.createImageData(i.w, i.h), r = o.data;
  for (let a = 0, l = 0; a < i.ids.length; a++, l += 4)
    i.ids[a] === e && (r[l] = 255, r[l + 1] = 255, r[l + 2] = 255, r[l + 3] = 255);
  return s.putImageData(o, 0, 0), i.masks.set(e, n), n;
}
function F_(i) {
  return !!i && i.some((e) => !e.cut);
}
function EI(i) {
  return Array.from(new Set(i.filter((e) => e.kind === "object").map((e) => e.map)));
}
function N_(i, e, t, n) {
  i.beginPath(), e.forEach((s, o) => o ? i.lineTo(s.x * t, s.y * n) : i.moveTo(s.x * t, s.y * n));
}
function phe(i, e, t, n, s) {
  const o = Math.max(t, n);
  i.save(), i.lineCap = "round", i.lineJoin = "round";
  for (const r of e)
    if (i.globalCompositeOperation = r.cut ? "destination-out" : "source-over", i.fillStyle = "#fff", i.strokeStyle = "#fff", r.kind === "brush") {
      const a = Math.max(1, r.size * o);
      if (r.pts.length === 1) {
        i.beginPath(), i.arc(r.pts[0].x * t, r.pts[0].y * n, a / 2, 0, Math.PI * 2), i.fill();
        continue;
      }
      i.lineWidth = a, N_(i, r.pts, t, n), i.stroke();
    } else if (r.kind === "lasso") {
      if (r.pts.length < 3) continue;
      N_(i, r.pts, t, n), i.closePath(), i.fill();
    } else {
      const a = s.get(r.map);
      if (!a) continue;
      i.imageSmoothingEnabled = !0, i.drawImage(PI(a, r.segment), 0, 0, t, n);
    }
  i.restore();
}
function zp(i, e, t, n) {
  const s = Rn(e, t);
  return phe(zn(s), i, e, t, n), s;
}
const U_ = "#ff2bd6";
function fhe(i, e) {
  const t = i.width, n = i.height, s = Rn(t, n), o = zn(s);
  o.drawImage(i, 0, 0, t, n);
  const r = Rn(t, n), a = zn(r);
  a.drawImage(e, 0, 0, t, n), a.globalCompositeOperation = "source-in", a.fillStyle = U_, a.fillRect(0, 0, t, n), o.globalAlpha = 0.38, o.drawImage(r, 0, 0), o.globalAlpha = 1;
  const l = Rn(t, n), d = zn(l), c = Math.max(2, Math.round(Math.max(t, n) / 300));
  return d.filter = "blur(" + c + "px)", d.drawImage(e, 0, 0, t, n), d.filter = "none", d.globalCompositeOperation = "destination-out", d.drawImage(e, 0, 0, t, n), d.globalCompositeOperation = "source-in", d.fillStyle = U_, d.fillRect(0, 0, t, n), o.drawImage(l, 0, 0), s;
}
const C0 = [
  { id: "free", label: "Free", r: null },
  { id: "original", label: "Original", r: NaN },
  { id: "1:1", label: "1:1", r: 1 },
  { id: "4:5", label: "4:5", r: 4 / 5 },
  { id: "3:4", label: "3:4", r: 3 / 4 },
  { id: "2:3", label: "2:3", r: 2 / 3 },
  { id: "9:16", label: "9:16", r: 9 / 16 },
  { id: "16:9", label: "16:9", r: 16 / 9 },
  { id: "3:2", label: "3:2", r: 3 / 2 },
  { id: "4:3", label: "4:3", r: 4 / 3 },
  { id: "21:9", label: "21:9", r: 21 / 9 },
  { id: "5:4", label: "5:4", r: 5 / 4, more: !0 },
  { id: "2:1", label: "2:1", r: 2, more: !0 },
  { id: "3:1", label: "3:1", r: 3, more: !0 },
  { id: "1:2", label: "1:2", r: 1 / 2, more: !0 },
  { id: "1:3", label: "1:3", r: 1 / 3, more: !0 }
];
function Mc(i, e, t) {
  const n = C0.find((s) => s.id === i);
  return !n || n.r === null ? null : Number.isNaN(n.r) ? e / t : n.r;
}
const Lh = { x: 0, y: 0, w: 1, h: 1 };
function fi(i, e, t) {
  return Math.min(t, Math.max(e, i));
}
function mhe(i, e, t, n = { x: 0.5, y: 0.5 }) {
  const s = e / t, o = i >= s ? 1 : i / s, r = i >= s ? s / i : 1;
  return { x: fi(n.x - o / 2, 0, 1 - o), y: fi(n.y - r / 2, 0, 1 - r), w: o, h: r };
}
function I0(i, e, t) {
  return { w: Math.max(1, Math.round(i.w * e)), h: Math.max(1, Math.round(i.h * t)) };
}
function RI(i, e = 0.02) {
  const t = fi(i.w, e, 1), n = fi(i.h, e, 1);
  return { x: fi(i.x, 0, 1 - t), y: fi(i.y, 0, 1 - n), w: t, h: n };
}
function ghe(i, e, t) {
  return { ...i, x: fi(i.x + e, 0, 1 - i.w), y: fi(i.y + t, 0, 1 - i.h) };
}
function bhe(i, e, t, n, s, o, r, a = 24) {
  const l = a / s, d = a / o;
  let c = i.x, h = i.y, f = i.x + i.w, p = i.y + i.h;
  if (e.includes("w") && (c = fi(c + t, 0, f - l)), e.includes("e") && (f = fi(f + t, c + l, 1)), e.includes("n") && (h = fi(h + n, 0, p - d)), e.includes("s") && (p = fi(p + n, h + d, 1)), r == null) return { x: c, y: h, w: f - c, h: p - h };
  const y = s / (r * o), v = e.length === 2;
  let x = f - c, w = p - h;
  v ? Math.abs(t) * s >= Math.abs(n) * o ? w = x * y : x = w / y : e === "e" || e === "w" ? w = x * y : x = w / y;
  const S = e.includes("w") ? i.x + i.w : e.includes("e") ? 1 - i.x : Math.min(i.x + i.w / 2, 1 - i.x - i.w / 2) * 2, M = e.includes("n") ? i.y + i.h : e.includes("s") ? 1 - i.y : Math.min(i.y + i.h / 2, 1 - i.y - i.h / 2) * 2;
  x > S && (x = S, w = x * y), w > M && (w = M, x = w / y), x = Math.max(x, l), w = Math.max(w, d);
  const _ = i.x + i.w / 2, T = i.y + i.h / 2, k = e.includes("w") ? i.x + i.w - x : e.includes("e") ? i.x : _ - x / 2, P = e.includes("n") ? i.y + i.h - w : e.includes("s") ? i.y : T - w / 2;
  return RI({ x: k, y: P, w: x, h: w }, 0);
}
function G_(i, e, t, n, s) {
  const o = fi(e / n, 5e-3, 1), r = fi(t / s, 5e-3, 1), a = i.x + i.w / 2, l = i.y + i.h / 2;
  return RI({ x: a - o / 2, y: l - r / 2, w: o, h: r }, 0);
}
function j_(i) {
  return i.x <= 5e-4 && i.y <= 5e-4 && i.w >= 0.999 && i.h >= 0.999;
}
function vhe(i, e) {
  return i !== "free" && i !== "original" ? "Crop " + i : "Crop " + e.w + " × " + e.h;
}
const yhe = 5e3 * 5e3, xhe = 0.15;
function zI(i, e) {
  return { cw: i, ch: e, ix: 0, iy: 0, iw: i, ih: e };
}
function vb(i, e, t, n = 1) {
  let s = e * n, o = t * n;
  return s / o < i ? s = o * i : o = s / i, s = Math.round(s), o = Math.round(o), { cw: s, ch: o, ix: Math.round((s - e) / 2), iy: Math.round((o - t) / 2), iw: e, ih: t };
}
function whe(i) {
  return i.iw * i.ih / Math.max(1, i.cw * i.ch);
}
function A0(i) {
  return i.ix > 0.5 || i.iy > 0.5 || i.ix + i.iw < i.cw - 0.5 || i.iy + i.ih < i.ch - 0.5;
}
function khe(i) {
  const e = Math.min(1, Math.sqrt(yhe / Math.max(1, i.cw * i.ch)) * 0.999);
  return {
    canvas_size: [Math.round(i.cw * e), Math.round(i.ch * e)],
    original_image_size: [Math.max(1, Math.round(i.iw * e)), Math.max(1, Math.round(i.ih * e))],
    original_image_location: [Math.round(i.ix * e), Math.round(i.iy * e)]
  };
}
function _he(i, e, t, n = 64) {
  const s = { ...i };
  if (e === "e" && (s.cw = Math.max(n, i.cw + t)), e === "s" && (s.ch = Math.max(n, i.ch + t)), e === "w") {
    const o = Math.max(n, i.cw + t);
    s.ix = i.ix + (o - i.cw), s.cw = o;
  }
  if (e === "n") {
    const o = Math.max(n, i.ch + t);
    s.iy = i.iy + (o - i.ch), s.ch = o;
  }
  return s;
}
function She(i, e, t) {
  const n = Math.min(i.cw - i.iw * 0.25, Math.max(-i.iw * 0.75, i.ix + e)), s = Math.min(i.ch - i.ih * 0.25, Math.max(-i.ih * 0.75, i.iy + t));
  return { ...i, ix: Math.round(n), iy: Math.round(s) };
}
function Mhe(i, e, t, n) {
  const s = Math.max(16, Math.round(e * n)), o = Math.max(16, Math.round(t * n)), r = i.ix + i.iw / 2, a = i.iy + i.ih / 2;
  return { ...i, iw: s, ih: o, ix: Math.round(r - s / 2), iy: Math.round(a - o / 2) };
}
function The(i) {
  return { ...i, ix: Math.round((i.cw - i.iw) / 2), iy: Math.round((i.ch - i.ih) / 2) };
}
function Che(i, e) {
  return i && i !== "free" ? i : Math.round(e.cw) + " × " + Math.round(e.ch);
}
const Yi = [
  { id: "red", label: "Red", hue: 0, color: "#ff4d4d" },
  { id: "orange", label: "Orange", hue: 30, color: "#ff9a3d" },
  { id: "yellow", label: "Yellow", hue: 60, color: "#ffe14d" },
  { id: "green", label: "Green", hue: 120, color: "#4dd26b" },
  { id: "aqua", label: "Aqua", hue: 180, color: "#3dd9d9" },
  { id: "blue", label: "Blue", hue: 225, color: "#4d7bff" },
  { id: "purple", label: "Purple", hue: 275, color: "#a35cff" },
  { id: "magenta", label: "Magenta", hue: 315, color: "#ff4dcf" }
], Ihe = [
  { id: "normal", label: "Normal" },
  { id: "multiply", label: "Multiply" },
  { id: "screen", label: "Screen" },
  { id: "overlay", label: "Overlay" },
  { id: "soft-light", label: "Soft light" },
  { id: "color", label: "Colour" }
], yb = () => ({ hue: 0, amount: 0, lum: 0 });
function zf() {
  const i = {};
  for (const e of Yi) i[e.id] = { hue: 0, sat: 0, lum: 0 };
  return {
    exposure: 0,
    contrast: 0,
    brightness: 0,
    highlights: 0,
    shadows: 0,
    saturation: 0,
    hue: 0,
    temperature: 0,
    tint: 0,
    grade: { shadows: yb(), midtones: yb(), highlights: yb() },
    mixer: i,
    overlay: { color: "#ff8a3d", blend: "soft-light", opacity: 0 },
    grain: { amount: 0, size: 35 },
    straighten: 0,
    quarter: 0,
    flipH: !1,
    flipV: !1,
    match: { to: null, amount: 0, stats: null },
    look: null
  };
}
function Ahe(i, e) {
  const t = zf(), n = iu(i);
  return e === "light" && Object.assign(n, { exposure: 0, contrast: 0, brightness: 0, highlights: 0, shadows: 0 }), e === "colour" && Object.assign(n, { saturation: 0, hue: 0, temperature: 0, tint: 0 }), e === "grading" && (n.grade = t.grade), e === "mixer" && (n.mixer = t.mixer), e === "overlay" && (n.overlay = { ...n.overlay, opacity: 0 }), e === "grain" && (n.grain = t.grain), e === "rotate" && Object.assign(n, { straighten: 0, quarter: 0, flipH: !1, flipV: !1 }), e === "match" && (n.match = t.match), n.look = null, n;
}
function iu(i) {
  return JSON.parse(JSON.stringify(i));
}
function kl(i, e) {
  return e === "light" ? !!(i.exposure || i.contrast || i.brightness || i.highlights || i.shadows) : e === "colour" ? !!(i.saturation || i.hue || i.temperature || i.tint) : e === "grading" ? ["shadows", "midtones", "highlights"].some((t) => i.grade[t].amount > 0 || i.grade[t].lum !== 0) : e === "mixer" ? Yi.some((t) => i.mixer[t.id].hue || i.mixer[t.id].sat || i.mixer[t.id].lum) : e === "overlay" ? i.overlay.opacity > 0 : e === "grain" ? i.grain.amount > 0 : e === "rotate" ? !!(i.straighten || i.quarter || i.flipH || i.flipV) : !!i.match.to && i.match.amount > 0 && !!i.match.stats;
}
const P0 = ["light", "colour", "grading", "mixer", "overlay", "grain", "rotate", "match"];
function E0(i) {
  return P0.some((e) => kl(i, e));
}
function Phe(i) {
  return kl(i, "rotate");
}
function su(i, e, t) {
  return i.quarter % 2 ? { w: t, h: e } : { w: e, h: t };
}
function Ehe(i, e, t) {
  const n = Math.abs(i * Math.PI / 180);
  if (n < 1e-6) return 1;
  const s = Math.cos(n), o = Math.sin(n);
  return Math.max((e * s + t * o) / e, (e * o + t * s) / t);
}
const tx = [
  { id: "vintage", label: "Vintage", set: (i) => {
    Object.assign(i, { saturation: -28, contrast: -12, temperature: 18, shadows: 18 }), i.grade.shadows = { hue: 190, amount: 22, lum: 8 }, i.grade.highlights = { hue: 42, amount: 26, lum: 0 }, i.grain = { amount: 22, size: 40 };
  } },
  { id: "retro-film", label: "Retro film", set: (i) => {
    Object.assign(i, { contrast: 16, saturation: -10, highlights: -14 }), i.grade.shadows = { hue: 215, amount: 30, lum: 0 }, i.grade.highlights = { hue: 35, amount: 24, lum: 0 }, i.grain = { amount: 34, size: 45 };
  } },
  { id: "duotone", label: "Duotone", set: (i) => {
    Object.assign(i, { saturation: -100, contrast: 12 }), i.grade.shadows = { hue: 255, amount: 70, lum: -6 }, i.grade.highlights = { hue: 38, amount: 62, lum: 4 };
  } },
  { id: "vibrant", label: "Vibrant", set: (i) => Object.assign(i, { saturation: 34, contrast: 12, shadows: 8 }) },
  { id: "warm", label: "Warm tone", set: (i) => Object.assign(i, { temperature: 32, tint: 4, saturation: 6 }) },
  { id: "cool-breeze", label: "Cool breeze", set: (i) => Object.assign(i, { temperature: -28, tint: -4, highlights: 10, saturation: -6 }) },
  { id: "red-tint", label: "Red tint", set: (i) => {
    i.overlay = { color: "#ff3b30", blend: "soft-light", opacity: 30 };
  } },
  { id: "cold", label: "Cold tone", set: (i) => Object.assign(i, { temperature: -44, saturation: -18, contrast: 6 }) },
  { id: "mono", label: "Black and white", set: (i) => Object.assign(i, { saturation: -100, contrast: 16 }) },
  { id: "matte", label: "Matte", set: (i) => {
    Object.assign(i, { contrast: -22, shadows: 26, saturation: -12 }), i.grade.shadows = { hue: 220, amount: 10, lum: 10 };
  } }
];
function H_(i, e) {
  const t = tx.find((s) => s.id === e), n = zf();
  return Object.assign(n, { straighten: i.straighten, quarter: i.quarter, flipH: i.flipH, flipV: i.flipV, match: i.match }), t && t.set(n), n.look = t ? t.id : null, n;
}
function Rhe(i) {
  const e = tx.find((t) => t.id === i.look);
  return e ? "Adjust · " + e.label : kl(i, "match") && P0.filter((t) => kl(i, t)).length === 1 ? "Match colours" : Phe(i) && P0.filter((t) => kl(i, t)).length === 1 ? i.straighten ? "Straighten" : "Rotate" : "Adjust";
}
function xb(i) {
  return i <= 0.04045 ? i / 12.92 : Math.pow((i + 0.055) / 1.055, 2.4);
}
function zhe(i, e, t) {
  const n = xb(i), s = xb(e), o = xb(t);
  let r = (n * 0.4124 + s * 0.3576 + o * 0.1805) / 0.95047, a = n * 0.2126 + s * 0.7152 + o * 0.0722, l = (n * 0.0193 + s * 0.1192 + o * 0.9505) / 1.08883;
  const d = (c) => c > 8856e-6 ? Math.cbrt(c) : 7.787 * c + 16 / 116;
  return r = d(r), a = d(a), l = d(l), [116 * a - 16, 500 * (r - a), 200 * (a - l)];
}
function $he(i) {
  let e = 0;
  const t = [0, 0, 0], n = [0, 0, 0];
  for (let r = 0; r < i.length; r += 4) {
    if (i[r + 3] < 128) continue;
    const a = i[r] / 255, l = i[r + 1] / 255, d = i[r + 2] / 255, c = Math.max(a, l, d), h = Math.min(a, l, d);
    if (c < 0.02 || h > 0.985) continue;
    const f = zhe(a, l, d);
    for (let p = 0; p < 3; p++)
      t[p] += f[p], n[p] += f[p] * f[p];
    e++;
  }
  if (!e) return { mean: [50, 0, 0], std: [1, 1, 1] };
  const s = t.map((r) => r / e), o = n.map((r, a) => Math.sqrt(Math.max(1e-6, r / e - s[a] * s[a])));
  return { mean: s, std: o };
}
function Dhe(i, e) {
  const t = [0, 1, 2].map((s) => Math.max(0.5, Math.min(2, e.std[s] / Math.max(1e-3, i.std[s])))), n = [0, 1, 2].map((s) => e.mean[s] - i.mean[s] * t[s]);
  return { scale: t, shift: n };
}
function nx([i, e, t]) {
  const n = Math.max(i, e, t), s = Math.min(i, e, t), o = (n + s) / 2;
  if (n === s) return [0, 0, o];
  const r = n - s, a = o > 0.5 ? r / (2 - n - s) : r / (n + s);
  let l = n === i ? (e - t) / r + (e < t ? 6 : 0) : n === e ? (t - i) / r + 2 : (i - e) / r + 4;
  return l /= 6, [l, a, o];
}
function Ohe([i, e, t]) {
  if (e === 0) return [t, t, t];
  const n = t < 0.5 ? t * (1 + e) : t + e - t * e, s = 2 * t - n, o = (r) => {
    let a = r;
    return a < 0 && (a += 1), a > 1 && (a -= 1), a < 1 / 6 ? s + (n - s) * 6 * a : a < 1 / 2 ? n : a < 2 / 3 ? s + (n - s) * (2 / 3 - a) * 6 : s;
  };
  return [o(i + 1 / 3), o(i), o(i - 1 / 3)];
}
const $I = (i, e, t) => {
  const n = Math.min(1, Math.max(0, (t - i) / (e - i)));
  return n * n * (3 - 2 * n);
};
function Lhe(i, e) {
  const [t, n, s] = nx(i), o = t * 360;
  let r = [0, 0, 0], a = 0;
  for (const p of Yi) {
    const y = Math.abs(((o - p.hue + 180) % 360 + 360) % 360 - 180);
    let v = Math.max(0, 1 - y / 45);
    v = v * v * (3 - 2 * v);
    const x = e[p.id];
    r = [r[0] + x.hue / 100 * v, r[1] + x.sat / 100 * v, r[2] + x.lum / 100 * v], a += v;
  }
  const l = Math.max(1, a);
  r = [r[0] / l, r[1] / l, r[2] / l];
  const d = $I(0.02, 0.25, n), c = ((t + r[0] * d / 12 + 1) % 1 + 1) % 1, h = Math.min(1, Math.max(0, n * (1 + r[1] * d))), f = Math.min(1, Math.max(0, s + r[2] * 0.22 * d * n));
  return Ohe([c, h, f]);
}
function Bhe(i) {
  const e = nx(i)[0] * 360;
  let t = Yi[0], n = 999;
  for (const s of Yi) {
    const o = Math.abs(((e - s.hue + 180) % 360 + 360) % 360 - 180);
    o < n && (n = o, t = s);
  }
  return t.id;
}
function Fhe(i) {
  return $I(0.02, 0.25, nx(i)[1]);
}
function V_([i, e, t]) {
  return "rgb(" + Math.round(i * 255) + ", " + Math.round(e * 255) + ", " + Math.round(t * 255) + ")";
}
function Nhe(i) {
  const e = i.replace("#", ""), t = parseInt(e.length === 3 ? e.split("").map((n) => n + n).join("") : e, 16);
  return [(t >> 16 & 255) / 255, (t >> 8 & 255) / 255, (t & 255) / 255];
}
var Uhe = Object.defineProperty, Ghe = (i, e, t) => e in i ? Uhe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, kr = (i, e, t) => Ghe(i, typeof e != "symbol" ? e + "" : e, t);
const jhe = `#version 300 es
in vec2 aPos;
out vec2 vUv;
void main() {
	vUv = aPos * 0.5 + 0.5;
	gl_Position = vec4(aPos, 0.0, 1.0);
}`, Hhe = `#version 300 es
precision highp float;
in vec2 vUv;
out vec4 outColor;
uniform sampler2D uImg;
uniform vec2 uSrc;
uniform vec2 uOut;
uniform float uQuarter;
uniform vec2 uFlip;
uniform float uTurn;
uniform float uTurnScale;
uniform float uExposure;
uniform float uContrast;
uniform float uBrightness;
uniform float uHighlights;
uniform float uShadows;
uniform float uSaturation;
uniform float uHue;
uniform float uTemperature;
uniform float uTint;
uniform vec3 uGradeS;
uniform vec3 uGradeM;
uniform vec3 uGradeH;
uniform vec3 uGradeLum;
uniform vec3 uMixer[8];
uniform float uMixerHue[8];
uniform float uMixerOn;
uniform vec3 uOverlay;
uniform float uOverlayOpacity;
uniform int uBlend;
uniform float uGrain;
uniform float uGrainSize;
uniform float uSeed;
uniform vec3 uMatchScale;
uniform vec3 uMatchShift;
uniform float uMatch;
uniform float uShowOriginal;

float luma(vec3 c) { return dot(c, vec3(0.2126, 0.7152, 0.0722)); }

vec3 toLinear(vec3 c) {
	return mix(c / 12.92, pow((c + 0.055) / 1.055, vec3(2.4)), step(0.04045, c));
}
vec3 toSrgb(vec3 c) {
	c = max(c, 0.0);
	return mix(c * 12.92, 1.055 * pow(c, vec3(1.0 / 2.4)) - 0.055, step(0.0031308, c));
}

vec3 rgb2hsl(vec3 c) {
	float mx = max(c.r, max(c.g, c.b));
	float mn = min(c.r, min(c.g, c.b));
	float l = (mx + mn) * 0.5;
	float d = mx - mn;
	if (d < 1e-5) return vec3(0.0, 0.0, l);
	float s = d / (1.0 - abs(2.0 * l - 1.0) + 1e-5);
	float h;
	if (mx == c.r) h = mod((c.g - c.b) / d, 6.0);
	else if (mx == c.g) h = (c.b - c.r) / d + 2.0;
	else h = (c.r - c.g) / d + 4.0;
	return vec3(h / 6.0, clamp(s, 0.0, 1.0), l);
}
vec3 hsl2rgb(vec3 hsl) {
	vec3 rgb = clamp(abs(mod(hsl.x * 6.0 + vec3(0.0, 4.0, 2.0), 6.0) - 3.0) - 1.0, 0.0, 1.0);
	float C = (1.0 - abs(2.0 * hsl.z - 1.0)) * hsl.y;
	return (rgb - 0.5) * C + hsl.z;
}

vec3 rgb2lab(vec3 c) {
	vec3 l = toLinear(c);
	vec3 xyz = vec3(
		dot(l, vec3(0.4124, 0.3576, 0.1805)) / 0.95047,
		dot(l, vec3(0.2126, 0.7152, 0.0722)),
		dot(l, vec3(0.0193, 0.1192, 0.9505)) / 1.08883);
	vec3 f = mix(7.787 * xyz + 16.0 / 116.0, pow(xyz, vec3(1.0 / 3.0)), step(0.008856, xyz));
	return vec3(116.0 * f.y - 16.0, 500.0 * (f.x - f.y), 200.0 * (f.y - f.z));
}
vec3 lab2rgb(vec3 lab) {
	float fy = (lab.x + 16.0) / 116.0;
	float fx = fy + lab.y / 500.0;
	float fz = fy - lab.z / 200.0;
	vec3 f = vec3(fx, fy, fz);
	vec3 f3 = f * f * f;
	vec3 xyz = mix((f - 16.0 / 116.0) / 7.787, f3, step(0.008856, f3));
	xyz *= vec3(0.95047, 1.0, 1.08883);
	vec3 l = vec3(
		dot(xyz, vec3(3.2406, -1.5372, -0.4986)),
		dot(xyz, vec3(-0.9689, 1.8758, 0.0415)),
		dot(xyz, vec3(0.0557, -0.2040, 1.0570)));
	return toSrgb(l);
}

float hash(vec2 p) {
	p = fract(p * vec2(123.34, 456.21) + uSeed);
	p += dot(p, p + 45.32);
	return fract(p.x * p.y);
}

vec3 blend(vec3 base, vec3 top, int mode) {
	if (mode == 1) return base * top;
	if (mode == 2) return 1.0 - (1.0 - base) * (1.0 - top);
	if (mode == 3) return mix(2.0 * base * top, 1.0 - 2.0 * (1.0 - base) * (1.0 - top), step(0.5, base));
	if (mode == 4) return (1.0 - 2.0 * top) * base * base + 2.0 * top * base;
	if (mode == 5) {
		vec3 h = rgb2hsl(top);
		return hsl2rgb(vec3(h.x, h.y, rgb2hsl(base).z));
	}
	return top;
}

void main() {
	// where this output pixel comes from, in the source's pixels with y down as on screen:
	// undo the flip, the quarter turns (clockwise), then the straighten (clockwise)
	vec2 p = (vUv - 0.5) * uOut;
	p.y = -p.y;
	if (uFlip.x > 0.5) p.x = -p.x;
	if (uFlip.y > 0.5) p.y = -p.y;
	for (int i = 0; i < 3; i++) {
		if (float(i) < uQuarter) p = vec2(p.y, -p.x);
	}
	float cs = cos(uTurn);
	float sn = sin(uTurn);
	p = vec2(p.x * cs + p.y * sn, -p.x * sn + p.y * cs) / uTurnScale;
	vec2 uv = p / uSrc + 0.5;
	// the texture's first row is the picture's top (uploads aren't flipped: an ImageBitmap ignores the flag)
	vec4 src = texture(uImg, uv);
	vec3 c = src.rgb;
	if (uShowOriginal > 0.5) {
		outColor = vec4(c, src.a);
		return;
	}

	// exposure and white balance, in linear light
	vec3 lin = toLinear(c) * exp2(uExposure * 2.0);
	vec3 wb = vec3(1.0 + uTemperature * 0.22, 1.0 - uTint * 0.14, 1.0 - uTemperature * 0.22);
	wb /= max(1e-3, dot(wb, vec3(0.2126, 0.7152, 0.0722)));
	lin *= wb;
	c = toSrgb(lin);

	// highlights and shadows: lift or hold each end of the tones, keeping the colour
	float L = luma(c);
	float ws = pow(1.0 - smoothstep(0.0, 0.62, L), 2.0);
	float wh = pow(smoothstep(0.38, 1.0, L), 2.0);
	float L2 = L;
	L2 += uShadows * ws * 0.5 * (uShadows > 0.0 ? (1.0 - L) : L);
	L2 += uHighlights * wh * 0.5 * (uHighlights > 0.0 ? (1.0 - L) : L);
	c *= L2 / max(L, 1e-4);

	// brightness (the midtones), then contrast about the middle grey
	c = pow(max(c, 0.0), vec3(exp2(-uBrightness * 0.75)));
	float k = uContrast >= 0.0 ? 1.0 + uContrast * 1.1 : 1.0 + uContrast * 0.75;
	c = (c - 0.5) * k + 0.5;

	// colour grading: a tint and a brightness for the shadows, midtones and highlights
	L = clamp(luma(c), 0.0, 1.0);
	float gs = pow(1.0 - L, 2.0);
	float gh = L * L;
	float gm = max(0.0, 1.0 - gs - gh);
	c += uGradeS * gs + uGradeM * gm + uGradeH * gh;
	c += uGradeLum.x * gs + uGradeLum.y * gm + uGradeLum.z * gh;

	// the colour mixer: each hue band's own hue, saturation and luminance
	if (uMixerOn > 0.5) {
		vec3 hsl = rgb2hsl(clamp(c, 0.0, 1.0));
		float hue = hsl.x * 360.0;
		vec3 acc = vec3(0.0);
		float wsum = 0.0;
		for (int i = 0; i < 8; i++) {
			float d = abs(mod(hue - uMixerHue[i] + 180.0, 360.0) - 180.0);
			float w = max(0.0, 1.0 - d / 45.0);
			w = w * w * (3.0 - 2.0 * w);
			acc += uMixer[i] * w;
			wsum += w;
		}
		acc /= max(1.0, wsum);
		float chroma = smoothstep(0.02, 0.25, hsl.y);
		hsl.x = fract(hsl.x + acc.x * chroma / 12.0 + 1.0);
		hsl.y = clamp(hsl.y * (1.0 + acc.y * chroma), 0.0, 1.0);
		hsl.z = clamp(hsl.z + acc.z * 0.22 * chroma * hsl.y, 0.0, 1.0);
		c = hsl2rgb(hsl);
	}

	// hue, then saturation
	if (abs(uHue) > 1e-4) {
		vec3 hsl = rgb2hsl(clamp(c, 0.0, 1.0));
		hsl.x = fract(hsl.x + uHue / 360.0 + 1.0);
		c = hsl2rgb(hsl);
	}
	L = luma(c);
	c = mix(vec3(L), c, 1.0 + uSaturation);

	// match colours: another version's colour, carried over in Lab
	if (uMatch > 0.0) {
		vec3 lab = rgb2lab(clamp(c, 0.0, 1.0));
		vec3 moved = lab * uMatchScale + uMatchShift;
		c = mix(c, lab2rgb(moved), uMatch);
	}

	c = clamp(c, 0.0, 1.0);
	if (uOverlayOpacity > 0.0) c = mix(c, clamp(blend(c, uOverlay, uBlend), 0.0, 1.0), uOverlayOpacity);
	if (uGrain > 0.0) {
		vec2 cell = floor(gl_FragCoord.xy / max(1.0, uGrainSize));
		float n = hash(cell) - 0.5;
		float midtones = 1.0 - pow(abs(luma(c) - 0.5) * 2.0, 2.0);
		c += n * uGrain * (0.35 + 0.65 * midtones);
	}
	outColor = vec4(clamp(c, 0.0, 1.0), src.a);
}`, Vhe = { normal: 0, multiply: 1, screen: 2, overlay: 3, "soft-light": 4, color: 5 };
function Whe(i) {
  const e = /^#?([0-9a-f]{6})$/i.exec(i.trim()), t = e ? parseInt(e[1], 16) : 0;
  return [(t >> 16 & 255) / 255, (t >> 8 & 255) / 255, (t & 255) / 255];
}
function wb(i, e) {
  const t = (i % 360 + 360) % 360 / 60, n = 1 - Math.abs(t % 2 - 1), [s, o, r] = t < 1 ? [1, n, 0] : t < 2 ? [n, 1, 0] : t < 3 ? [0, 1, n] : t < 4 ? [0, n, 1] : t < 5 ? [n, 0, 1] : [1, 0, n], a = 0.2126 * s + 0.7152 * o + 0.0722 * r, l = e / 100 * 0.32;
  return [(s - a) * l, (o - a) * l, (r - a) * l];
}
class DI {
  constructor(e) {
    kr(this, "canvas", e), kr(this, "gl"), kr(this, "prog"), kr(this, "tex"), kr(this, "loc", /* @__PURE__ */ new Map()), kr(this, "src", { w: 1, h: 1 }), kr(this, "seed", Math.random());
    const t = e.getContext("webgl2", { premultipliedAlpha: !1, preserveDrawingBuffer: !0, antialias: !1 });
    if (!t) throw new Error("This browser can't adjust pictures (it has no WebGL 2).");
    this.gl = t;
    const n = this.shader(t.VERTEX_SHADER, jhe), s = this.shader(t.FRAGMENT_SHADER, Hhe), o = t.createProgram();
    if (t.attachShader(o, n), t.attachShader(o, s), t.linkProgram(o), !t.getProgramParameter(o, t.LINK_STATUS)) throw new Error("Adjust's shader didn't link: " + t.getProgramInfoLog(o));
    this.prog = o, t.useProgram(o);
    const r = t.createBuffer();
    t.bindBuffer(t.ARRAY_BUFFER, r), t.bufferData(t.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), t.STATIC_DRAW);
    const a = t.getAttribLocation(o, "aPos");
    t.enableVertexAttribArray(a), t.vertexAttribPointer(a, 2, t.FLOAT, !1, 0, 0), this.tex = t.createTexture(), t.bindTexture(t.TEXTURE_2D, this.tex), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE);
  }
  shader(e, t) {
    const n = this.gl, s = n.createShader(e);
    if (n.shaderSource(s, t), n.compileShader(s), !n.getShaderParameter(s, n.COMPILE_STATUS)) throw new Error("Adjust's shader didn't compile: " + n.getShaderInfoLog(s));
    return s;
  }
  u(e) {
    return this.loc.has(e) || this.loc.set(e, this.gl.getUniformLocation(this.prog, e)), this.loc.get(e) || null;
  }
  /** The picture to adjust. */
  setImage(e, t, n) {
    const s = this.gl;
    s.bindTexture(s.TEXTURE_2D, this.tex), s.pixelStorei(s.UNPACK_FLIP_Y_WEBGL, !1), s.texImage2D(s.TEXTURE_2D, 0, s.RGBA, s.RGBA, s.UNSIGNED_BYTE, e), this.src = { w: t, h: n };
  }
  /** The biggest picture this browser's graphics take. */
  maxSize() {
    return this.gl.getParameter(this.gl.MAX_TEXTURE_SIZE);
  }
  /**
   * Draw the picture adjusted, `w` by `h` (the output's shape: a quarter turn
   * swaps them). `grainScale` keeps grain the same size on the picture
   * whatever size it's drawn at (the preview is smaller than the bake).
   */
  render(e, t, n, s = {}) {
    const o = this.gl;
    this.canvas.width !== t && (this.canvas.width = t), this.canvas.height !== n && (this.canvas.height = n), o.viewport(0, 0, t, n), o.useProgram(this.prog);
    const r = (p, y) => o.uniform1f(this.u(p), y);
    o.uniform1i(this.u("uImg"), 0), o.uniform2f(this.u("uSrc"), this.src.w, this.src.h);
    const a = e.quarter % 2 ? [this.src.h, this.src.w] : [this.src.w, this.src.h];
    o.uniform2f(this.u("uOut"), a[0], a[1]), r("uQuarter", e.quarter), o.uniform2f(this.u("uFlip"), e.flipH ? 1 : 0, e.flipV ? 1 : 0), r("uTurn", e.straighten * Math.PI / 180), r("uTurnScale", Ehe(e.straighten, this.src.w, this.src.h)), r("uExposure", e.exposure / 100), r("uContrast", e.contrast / 100), r("uBrightness", e.brightness / 100), r("uHighlights", e.highlights / 100), r("uShadows", e.shadows / 100), r("uSaturation", e.saturation / 100), r("uHue", e.hue), r("uTemperature", e.temperature / 100), r("uTint", e.tint / 100), o.uniform3fv(this.u("uGradeS"), wb(e.grade.shadows.hue, e.grade.shadows.amount)), o.uniform3fv(this.u("uGradeM"), wb(e.grade.midtones.hue, e.grade.midtones.amount)), o.uniform3fv(this.u("uGradeH"), wb(e.grade.highlights.hue, e.grade.highlights.amount)), o.uniform3f(this.u("uGradeLum"), e.grade.shadows.lum / 100 * 0.22, e.grade.midtones.lum / 100 * 0.22, e.grade.highlights.lum / 100 * 0.22);
    const l = [], d = [];
    let c = 0;
    for (const p of Yi) {
      const y = e.mixer[p.id];
      l.push(y.hue / 100, y.sat / 100, y.lum / 100), d.push(p.hue), (y.hue || y.sat || y.lum) && (c = 1);
    }
    o.uniform3fv(this.u("uMixer"), new Float32Array(l)), o.uniform1fv(this.u("uMixerHue"), new Float32Array(d)), r("uMixerOn", c), o.uniform3fv(this.u("uOverlay"), Whe(e.overlay.color)), r("uOverlayOpacity", e.overlay.opacity / 100), o.uniform1i(this.u("uBlend"), Vhe[e.overlay.blend] || 0), r("uGrain", e.grain.amount / 100 * 0.22), r("uGrainSize", (1 + e.grain.size / 100 * 3) * (s.grainScale || 1)), r("uSeed", this.seed);
    const h = s.transfer, f = e.match;
    r("uMatch", h && f.to && f.stats ? f.amount / 100 : 0), o.uniform3fv(this.u("uMatchScale"), h ? h.scale : [1, 1, 1]), o.uniform3fv(this.u("uMatchShift"), h ? h.shift : [0, 0, 0]), r("uShowOriginal", s.original ? 1 : 0), o.activeTexture(o.TEXTURE0), o.bindTexture(o.TEXTURE_2D, this.tex), o.drawArrays(o.TRIANGLE_STRIP, 0, 4);
  }
  dispose() {
    const e = this.gl.getExtension("WEBGL_lose_context");
    e && e.loseContext();
  }
}
const W_ = 3, OI = [
  { kelvin: 1900, name: "Candlelight", color: "#ff9329" },
  { kelvin: 2800, name: "Golden", color: "#ffad5e" },
  { kelvin: 3200, name: "Tungsten", color: "#ffb46b" },
  { kelvin: 4300, name: "Warm white", color: "#ffd4a6" },
  { kelvin: 5600, name: "Daylight", color: "#fff4e5" },
  { kelvin: 6500, name: "Overcast", color: "#f2f5ff" },
  { kelvin: 8e3, name: "Blue hour", color: "#c9d9ff" }
], qhe = ["#ff2bd6", "#2be4ff", "#ff3d3d", "#ff8a3d", "#ffd23d", "#3dff8a", "#3d7bff", "#9b5cff"], Khe = [
  { id: "top", label: "Top", rotate: 0, elevation: 90 },
  { id: "front", label: "Front", rotate: 0, elevation: 0 },
  { id: "right", label: "Right", rotate: 90, elevation: 0 },
  { id: "left", label: "Left", rotate: -90, elevation: 0 },
  { id: "back", label: "Back", rotate: 180, elevation: 0 },
  { id: "bottom", label: "Bottom", rotate: 0, elevation: -90 }
];
let q_ = 0;
function Yhe() {
  return q_++, "l" + Date.now().toString(36) + q_;
}
function ix(i) {
  var e, t, n;
  return {
    id: i.id || Yhe(),
    rotate: (e = i.rotate) != null ? e : -45,
    elevation: (t = i.elevation) != null ? t : 45,
    intensity: (n = i.intensity) != null ? n : 7,
    color: i.color || "#fff4e5",
    kelvin: i.kelvin === void 0 ? i.color ? null : 5600 : i.kelvin
  };
}
const R0 = [
  {
    id: "golden-hour",
    label: "Golden hour",
    swatch: ["#ffad5e", "#3b2a4a"],
    softness: "soft",
    lights: [{ rotate: -45, elevation: 0, intensity: 7, color: "#ffad5e", kelvin: 2800 }],
    words: "Golden hour: a low warm sun casting long soft shadows, with a warm glow in the air."
  },
  {
    id: "dusk-interiors",
    label: "Dusk, interiors lit",
    swatch: ["#ffcf8a", "#24345e"],
    softness: "soft",
    arch: !0,
    lights: [{ rotate: 0, elevation: 45, intensity: 3, color: "#c9d9ff", kelvin: 8e3 }],
    words: "Dusk at blue hour: a deep blue sky with a last warm glow at the horizon; every interior is lit with warm light that glows through the windows; exterior surfaces are lit softly by the sky."
  },
  {
    id: "night-facade",
    label: "Night, facade lit",
    swatch: ["#ffd9a0", "#0d1226"],
    softness: "hard",
    arch: !0,
    lights: [{ rotate: 0, elevation: -45, intensity: 6, color: "#ffd4a6", kelvin: 4300 }],
    words: "Night: a dark sky; the facade is washed by warm architectural uplights from the ground, with soft pools of light and deep shadows above them; windows glow faintly."
  },
  {
    id: "overcast",
    label: "Overcast",
    swatch: ["#f2f5ff", "#6b7280"],
    softness: "soft",
    arch: !0,
    lights: [{ rotate: 0, elevation: 45, intensity: 5, color: "#f2f5ff", kelvin: 6500 }],
    words: "Overcast sky: diffuse light from above with no hard shadows and soft, low contrast."
  },
  {
    id: "midday-sun",
    label: "Midday sun",
    swatch: ["#fff4e5", "#38506b"],
    softness: "hard",
    arch: !0,
    lights: [{ rotate: 45, elevation: 90, intensity: 9, color: "#fff4e5", kelvin: 5600 }],
    words: "Midday sun: bright, high sunlight with short, crisp shadows and a clear blue sky."
  },
  {
    id: "softbox",
    label: "Studio softbox",
    swatch: ["#ffffff", "#4b5563"],
    softness: "soft",
    lights: [
      { rotate: -45, elevation: 45, intensity: 7, color: "#fff4e5", kelvin: 5600 },
      { rotate: 90, elevation: 0, intensity: 3, color: "#fff4e5", kelvin: 5600 }
    ],
    words: "A large studio softbox as the key light with a gentle fill: clean, even, flattering light with soft shadow edges."
  },
  {
    id: "rim",
    label: "Rim light",
    swatch: ["#eef3ff", "#111827"],
    softness: "hard",
    lights: [{ rotate: 135, elevation: 0, intensity: 8, color: "#f2f5ff", kelvin: 6500 }],
    words: "The front of the subject stays dim, lit only by faint ambient light."
  },
  {
    id: "neon",
    label: "Neon",
    swatch: ["#ff2bd6", "#2be4ff"],
    softness: "soft",
    lights: [
      { rotate: -90, elevation: 0, intensity: 7, color: "#ff2bd6", kelvin: null },
      { rotate: 90, elevation: 0, intensity: 7, color: "#2be4ff", kelvin: null }
    ],
    words: "The rest of the scene is dark."
  },
  {
    id: "three-point",
    label: "Key, fill and rim",
    swatch: ["#ffb46b", "#5fd8ff"],
    softness: "hard",
    lights: [
      { rotate: 45, elevation: 45, intensity: 8, color: "#ffb46b", kelvin: 3200 },
      { rotate: -90, elevation: 0, intensity: 3, color: "#5fd8ff", kelvin: null },
      { rotate: 135, elevation: 0, intensity: 6, color: "#ff8a3d", kelvin: null }
    ],
    words: ""
  }
];
function sx(i) {
  return i && R0.find((e) => e.id === i) || null;
}
function Xhe(i, e = "relight") {
  return { mode: e, softness: i.softness, look: i.id, lights: i.lights.map((t) => ix({ ...t })) };
}
function Tc() {
  return { mode: "relight", softness: "soft", look: null, lights: [ix({ rotate: -45, elevation: 45, intensity: 7, color: "#ffb46b", kelvin: 3200 })] };
}
function LI(i) {
  const e = sx(i.look);
  return !e || e.lights.length !== i.lights.length || e.softness !== i.softness ? !1 : e.lights.every((t, n) => {
    const s = i.lights[n];
    return s.rotate === t.rotate && s.elevation === t.elevation && s.intensity === t.intensity && s.color.toLowerCase() === t.color.toLowerCase();
  });
}
function Gl(i) {
  const e = (i % 360 + 360) % 360;
  return e > 180 ? e - 360 : e;
}
function Cc(i) {
  const e = Gl(Math.round(Gl(i) / 45) * 45);
  return e === -180 ? 180 : e;
}
function K_(i) {
  return Math.max(-90, Math.min(90, Math.round(i / 45) * 45));
}
const BI = {
  0: "from the front (the camera's side)",
  45: "from the front right of the frame",
  90: "from the right side of the frame",
  135: "from behind on the right",
  180: "from directly behind",
  "-45": "from the front left of the frame",
  "-90": "from the left side of the frame",
  "-135": "from behind on the left"
}, Y_ = [[-90, "from below"], [-45, "low, from below the subject"], [0, "at subject height"], [45, "high, about 45° above"], [90, "from directly overhead"]];
function X_(i, e) {
  return e.reduce((t, n) => Math.abs(n[0] - i) < Math.abs(t[0] - i) ? n : t)[1];
}
const ox = (i) => Math.abs(Gl(i.rotate)) >= 135, bm = (i) => i.elevation >= 75, vm = (i) => i.elevation <= -75, Jhe = (i) => i <= 2 ? "faint" : i <= 4 ? "soft" : i <= 6 ? "moderate" : i <= 8 ? "strong" : "very strong";
function FI(i) {
  const e = /^#?([0-9a-f]{6})$/i.exec(i.trim()), t = e ? parseInt(e[1], 16) : 16777215;
  return [t >> 16 & 255, t >> 8 & 255, t & 255];
}
function Zhe(i) {
  const [e, t, n] = FI(i).map((c) => c / 255), s = Math.max(e, t, n), o = Math.min(e, t, n), r = (s + o) / 2, a = s - o;
  if (a < 1e-6) return { h: 0, s: 0, l: r };
  const l = a / (1 - Math.abs(2 * r - 1));
  let d = s === e ? (t - n) / a % 6 : s === t ? (n - e) / a + 2 : (e - t) / a + 4;
  return d = (d * 60 + 360) % 360, { h: d, s: l, l: r };
}
const J_ = [
  [0, "red"],
  [14, "red-orange"],
  [30, "orange"],
  [45, "amber"],
  [56, "yellow"],
  [80, "lime green"],
  [120, "green"],
  [160, "teal"],
  [185, "cyan"],
  [205, "sky blue"],
  [225, "blue"],
  [250, "indigo"],
  [272, "violet"],
  [290, "purple"],
  [312, "magenta"],
  [335, "pink"],
  [360, "red"]
];
function NI(i) {
  if (i.kelvin) {
    const s = OI.find((a) => a.kelvin === i.kelvin), o = s ? s.name.toLowerCase() : "white";
    return (o === "daylight" ? "daylight" : o === "tungsten" ? "warm tungsten" : o === "overcast" ? "cool overcast" : o === "blue hour" ? "cool blue-hour" : o) + " (about " + i.kelvin + " K)";
  }
  const e = Zhe(i.color);
  if (e.s < 0.18) return e.l > 0.5 ? "white" : "grey";
  let t = J_[0][1], n = 999;
  for (const [s, o] of J_) {
    const r = Math.abs(s - e.h);
    r < n && (n = r, t = o);
  }
  return (e.s < 0.45 ? "soft " : "") + t;
}
function Qhe(i, e) {
  const t = i.intensity / e.intensity;
  return t <= 0.45 ? "about a third as bright" : t <= 0.75 ? "about two thirds as bright" : t < 0.95 ? "a little dimmer" : t > 1.3 ? "brighter" : "as bright";
}
function $f(i) {
  const e = Gl(i.rotate) * Math.PI / 180, t = i.elevation * Math.PI / 180;
  return { x: Math.sin(e) * Math.cos(t), y: -Math.sin(t) };
}
function epe(i) {
  if (bm(i)) return "Tops of surfaces are lit; the sides fall into shade.";
  if (vm(i)) return "Undersides are lit from below; upper surfaces fall into shadow.";
  if (ox(i)) return "The side facing the camera falls into shadow.";
  const e = $f(i);
  return e.x > 0.3 ? "Surfaces facing the right of the frame are lit; surfaces facing the left of the frame fall into shadow." : e.x < -0.3 ? "Surfaces facing the left of the frame are lit; surfaces facing the right of the frame fall into shadow." : "The side facing the camera is lit evenly.";
}
function tpe(i) {
  if (bm(i)) return "Shadows fall straight down.";
  if (vm(i)) return "Shadows are cast upward.";
  if (ox(i)) return "Shadows fall toward the camera.";
  const e = $f(i);
  if (Math.hypot(e.x, e.y) < 0.3) return "Shadows fall behind the subject, mostly out of view.";
  const t = [];
  return e.x > 0.3 && t.push("toward the left of the frame"), e.x < -0.3 && t.push("toward the right of the frame"), e.y < -0.3 && t.push("down"), e.y > 0.3 && t.push("upward"), t.length || t.push(Math.abs(e.x) >= Math.abs(e.y) ? e.x > 0 ? "toward the left of the frame" : "toward the right of the frame" : e.y < 0 ? "down" : "upward"), "Shadows fall " + t.join(" and ") + ".";
}
function UI(i, e) {
  const t = i[e];
  return e === 0 || !t ? "Key" : ox(t) ? "Rim" : t.intensity < i[0].intensity ? "Fill" : "Second";
}
function npe(i) {
  const e = /* @__PURE__ */ new Map();
  return i.map((t, n) => {
    const s = UI(i, n), o = (e.get(s) || 0) + 1;
    return e.set(s, o), o > 1 ? s + " " + o : s;
  });
}
const ipe = "Relighting only: keep the people, pose, expression, composition, camera angle, materials and object colours; change only the light, shadows, highlights and colour cast.";
function spe(i) {
  if (i.mode === "transfer") return ope();
  const e = i.lights.length ? i.lights : Tc().lights, t = e[0], n = i.softness === "hard" ? "hard, with crisp shadow edges" : "soft and diffused", s = [ipe];
  e.forEach((r, a) => {
    const l = UI(e, a) + " light", d = a === 0 ? Jhe(r.intensity) + ", " + n : Qhe(r, t), c = bm(r) || vm(r) ? X_(r.elevation, Y_) : BI[String(Cc(r.rotate))] + ", " + X_(r.elevation, Y_), h = l === "Rim light" ? ", outlining the edges" : "";
    s.push(l + ": " + NI(r) + " light " + c + h + ", " + d + ".");
  }), s.push(epe(t)), s.push(tpe(t));
  const o = sx(i.look);
  return o && o.words && LI(i) && s.push(o.words), s.join(" ");
}
function ope() {
  return "Relight image 1 with the lighting of image 2: its direction, colour, softness and contrast. Keep everything in image 1 as it is: the people, pose, composition, camera angle, materials and object colours. Use image 2 only for its light, not for anything in it.";
}
function rpe(i) {
  if (i.mode === "transfer") return "Light transfer";
  const e = sx(i.look);
  if (e && LI(i)) return e.label;
  const t = i.lights[0];
  if (!t) return "Relight";
  const n = bm(t) ? "from above" : vm(t) ? "from below" : BI[String(Cc(t.rotate))].replace(" (the camera's side)", "").replace(" of the frame", "");
  return (i.lights.length > 1 ? i.lights.length + " lights, " : "") + NI(t).replace(/ \(about \d+ K\)/, "") + " key " + n;
}
function ape(i, e) {
  const t = new Uint8ClampedArray(e * e * 4), n = i.lights.map((r) => {
    const a = Gl(r.rotate) * Math.PI / 180, l = r.elevation * Math.PI / 180, [d, c, h] = FI(r.color);
    return { x: Math.sin(a) * Math.cos(l), y: Math.sin(l), z: Math.cos(a) * Math.cos(l), r: d / 255, g: c / 255, b: h / 255, k: r.intensity / 7 };
  }), s = i.softness === "soft" ? 0.45 : 0.08, o = e / 2 - 1;
  for (let r = 0; r < e; r++)
    for (let a = 0; a < e; a++) {
      const l = (a + 0.5 - e / 2) / o, d = -(r + 0.5 - e / 2) / o, c = l * l + d * d, h = (r * e + a) * 4;
      if (c > 1) continue;
      const f = Math.sqrt(1 - c);
      let p = 0.06, y = 0.06, v = 0.075;
      for (const w of n) {
        const S = l * w.x + d * w.y + f * w.z, M = Math.max(0, (S + s) / (1 + s)), _ = i.softness === "hard" ? Math.pow(Math.max(0, S), 24) * 0.35 : Math.pow(Math.max(0, S), 8) * 0.12;
        p += (M * 0.85 + _) * w.r * w.k, y += (M * 0.85 + _) * w.g * w.k, v += (M * 0.85 + _) * w.b * w.k;
      }
      const x = Math.min(1, (1 - Math.sqrt(c)) * o * 0.9);
      t[h] = Math.min(255, Math.pow(p, 1 / 2.2) * 255), t[h + 1] = Math.min(255, Math.pow(y, 1 / 2.2) * 255), t[h + 2] = Math.min(255, Math.pow(v, 1 / 2.2) * 255), t[h + 3] = Math.round(255 * x);
    }
  return t;
}
function kb(i) {
  const e = Gl(i.rotate) * Math.PI / 180, t = i.elevation * Math.PI / 180, n = Math.sin(e) * Math.cos(t), s = Math.sin(t), o = Math.cos(e) * Math.cos(t), r = 0.43;
  return { x: 0.5 + n * r, y: 0.5 - s * r, front: o >= -0.05 };
}
var lpe = Object.defineProperty, dpe = (i, e, t) => e in i ? lpe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, _b = (i, e, t) => dpe(i, typeof e != "symbol" ? e + "" : e, t);
const Z_ = ["#ffffff", "#f4f1ea", "#d9d9de", "#8a8f99", "#16141f", "#e9d5c4", "#f6c9c9", "#cfe3f5", "#cdebd5", "#ffe9a8"], Sb = /* @__PURE__ */ new Map();
function Q_(i) {
  let e = Sb.get(i);
  return e || (e = si(i).then((t) => $he(lhe(t))), Sb.set(i, e), e.catch(() => Sb.delete(i))), e;
}
class cpe {
  constructor(e, t) {
    _b(this, "studio", e), _b(this, "board", t), _b(this, "t"), this.t = /* @__PURE__ */ Xt({
      open: null,
      guard: null,
      busy: null,
      resize: { mode: "crop", ratio: "free", crop: { ...Lh }, frame: null, frameRatio: "16:9", words: "", for: null, auto: !1 },
      background: { mode: "remove", fill: void 0, words: "", refId: null, layer: Oh(), for: null },
      adjust: { a: zf(), group: "light", original: !1, source: null, for: null, band: "red", picked: null, picking: !1 },
      skin: ihe(),
      camera: { set: { ...Pp }, seed: null, lock: !0 },
      relight: { rig: Tc(), selected: null, refId: null },
      compare: null
    });
  }
  get stage() {
    return this.studio.stage.value;
  }
  // ---------------------------------------------------------------- one tool at a time
  /** Open a tool (the bar shows it, active); open again, or Close, and the bar is back. */
  open(e) {
    this.t.open === e || this.held() || this.leave(() => {
      this.t.open = e, this.t.compare = null, this.studio.finishEditing(), this.ready(e);
    });
  }
  /** Back to the bar, through the question if the tool has a change not yet made. */
  close(e) {
    if (!this.t.open) {
      e && e();
      return;
    }
    this.held() || this.leave(() => {
      this.t.open = null, e && e();
    });
  }
  /**
   * Leave the open tool, then do `then`: at once when nothing's pending, else
   * once you've chosen to apply or discard. True when it went at once.
   */
  leave(e) {
    const t = this.t.open;
    return this.held() ? !1 : !t || !this.pending(t) ? (t && this.reset(t), e(), !0) : (this.t.guard = { tool: t, then: e }, !1);
  }
  /** The question answered: apply the change (it becomes a version), or discard it; then what was asked for. */
  async answer(e) {
    const t = this.t.guard;
    t && (this.t.guard = null, !(e && !await this.apply(t.tool)) && (this.reset(t.tool), t.then && t.then()));
  }
  /** Stay in the tool (Escape on the question). */
  stay() {
    this.t.guard = null;
  }
  /** Whether a tool has a change showing on the stage that isn't a version yet. */
  pending(e = this.t.open) {
    const t = this.stage;
    if (!e || !t) return !1;
    if (e === "resize") {
      const n = this.t.resize;
      return n.for !== t.id ? !1 : n.mode === "crop" ? !j_(n.crop) : !!n.frame && A0(n.frame) && !n.auto;
    }
    if (e === "background") {
      const n = this.t.background;
      return n.for !== t.id ? !1 : n.mode === "remove" ? n.fill !== void 0 && this.isCutout(t) : n.mode === "adjust" ? nu(n.layer) : !1;
    }
    if (e === "adjust") {
      const n = this.t.adjust;
      if (n.for !== t.id) return !1;
      const s = t.made && t.made.tool === "adjust" && t.made.settings ? t.made.settings.adjust : void 0;
      return s ? JSON.stringify(e4(s)) !== JSON.stringify(e4(n.a)) : E0(n.a);
    }
    return !1;
  }
  /** A tool's stage state as it starts, for the picture on the stage. */
  ready(e) {
    const t = this.stage;
    if (t) {
      if (e === "resize") {
        const n = this.t.resize;
        n.for !== t.id && (n.for = t.id, n.crop = { ...Lh }, n.ratio = "free", n.frame = null), this.readyExpand();
      }
      if (e === "background") {
        const n = this.t.background;
        n.for !== t.id && (n.for = t.id, n.fill = void 0, n.layer = { ...Oh(), target: n.layer.target });
      }
      e === "adjust" && this.readyAdjust();
    }
  }
  /** A tool's change dropped: the stage shows the picture as it is. */
  reset(e) {
    if (this.t.busy) return;
    const t = this.stage;
    e === "resize" && (this.t.resize.crop = { ...Lh }, this.t.resize.ratio = "free", this.t.resize.frame = null, this.t.resize.frameRatio = "free", this.t.resize.auto = !1, this.t.resize.for = t ? t.id : null), e === "background" && (this.t.background.fill = void 0, this.t.background.layer = { ...Oh(), target: this.t.background.layer.target }, this.t.background.for = t ? t.id : null), e === "adjust" && (this.t.adjust.for = null, this.readyAdjust());
  }
  /** The picture on the stage changed: a tool's stage state is for the old one. */
  stageChanged() {
    const e = this.t.open;
    this.t.compare = this.t.compare && this.stage && this.t.compare.with !== this.stage.id ? this.t.compare : null, e && this.ready(e);
  }
  /** Apply the open tool's change: its version is made and takes the stage. */
  async apply(e = this.t.open) {
    return e ? e === "resize" ? this.t.resize.mode === "crop" ? this.applyCrop() : this.runTool("expand") : e === "background" ? this.t.background.mode === "adjust" ? this.applyLayers() : this.applyFill() : e === "adjust" ? this.applyAdjust() : !1 : !1;
  }
  // ---------------------------------------------------------------- Crop
  setRatio(e) {
    if (this.t.busy) return;
    const t = this.stage, n = this.t.resize;
    if (n.ratio = e, !t) return;
    n.for = t.id;
    const s = Mc(e, t.w, t.h);
    if (s == null) return;
    const o = n.crop;
    n.crop = mhe(s, t.w, t.h, { x: o.x + o.w / 2, y: o.y + o.h / 2 });
  }
  setCrop(e) {
    if (this.t.busy) return;
    const t = this.stage;
    this.t.resize.crop = e, t && (this.t.resize.for = t.id);
  }
  /** The crop's size in the picture's pixels. */
  cropPixels() {
    const e = this.stage;
    return e ? I0(this.t.resize.crop, e.w, e.h) : { w: 0, h: 0 };
  }
  async applyCrop() {
    const e = this.stage, t = this.t.resize;
    if (!e || j_(t.crop)) return !1;
    const n = { ...t.crop }, s = t.ratio;
    return this.bake("Cropping", async () => {
      const o = await si(e.url), r = ahe(o, n), a = I0(n, e.w, e.h);
      return this.studio.addVersion(r, { tool: "crop", label: vhe(s, a), settings: { crop: n, ratio: s } }, e);
    }, () => {
      t.crop = { ...Lh }, t.ratio = "free";
    });
  }
  // ---------------------------------------------------------------- Expand (Bria)
  /**
   * Expand opens with the shape it lights already framed (CHAT-41: its New
   * size read the picture's own size while 16:9 was lit and no frame made).
   * The frame isn't a change of yours until you touch it, so leaving doesn't ask.
   */
  readyExpand() {
    const e = this.stage, t = this.t.resize;
    if (!e || t.mode !== "expand" || t.frameRatio === "free" || t.for === e.id && t.frame) return;
    const n = Mc(t.frameRatio, e.w, e.h);
    n != null && (t.for = e.id, t.frame = vb(n, e.w, e.h, 1.06), t.auto = !0);
  }
  setFrameRatio(e) {
    if (this.t.busy) return;
    const t = this.stage, n = this.t.resize;
    if (n.auto = !1, n.frameRatio = e, !t) return;
    n.for = t.id;
    const s = Mc(e, t.w, t.h);
    n.frame = s == null ? n.frame || vb(t.w / t.h, t.w, t.h, 1.25) : vb(s, t.w, t.h, 1.06);
  }
  setFrame(e) {
    if (this.t.busy) return;
    const t = this.stage;
    this.t.resize.frame = e, this.t.resize.auto = !1, t && (this.t.resize.for = t.id);
  }
  frame() {
    const e = this.stage;
    return e ? this.t.resize.frame || zI(e.w, e.h) : null;
  }
  // ---------------------------------------------------------------- Background
  /** Whether the picture is a cut-out (Remove background's result, or anything see-through). */
  isCutout(e) {
    if (!e) return !1;
    if (e.made && (e.made.tool === "removebg" || e.made.settings && e.made.settings.cutout)) return !0;
    const t = e.runId ? this.board.studioRecords.get("edit:" + e.runId) : void 0;
    return !!t && t.role === "edit" && t.studio === "removebg";
  }
  /** The cut-out a background adjustment needs: the stage picture's own Remove background result, if there is one. */
  cutoutFor(e) {
    return e ? this.isCutout(e) ? e : this.studio.items.value.find((t) => t.parentId === e.id && t.status === "done" && this.isCutout(t)) || null : null;
  }
  setFill(e) {
    if (this.t.busy) return;
    const t = this.stage;
    this.t.background.fill = e, t && (this.t.background.for = t.id);
  }
  async applyFill() {
    const e = this.stage, t = this.t.background.fill;
    return !e || t === void 0 || !this.isCutout(e) ? !1 : this.bake("Filling the background", async () => {
      const n = await si(e.url), s = II(n, t), o = t ? "Background filled" : "Background see-through";
      return this.studio.addVersion(s, { tool: "background", label: o, settings: { fill: t, cutout: !t } }, e, { alpha: !t });
    }, () => {
      this.t.background.fill = void 0;
    });
  }
  setLayer(e) {
    if (this.t.busy) return;
    const t = this.stage;
    this.t.background.layer = { ...this.t.background.layer, ...e }, t && (this.t.background.for = t.id);
  }
  async applyLayers() {
    const e = this.stage, t = this.cutoutFor(e), n = this.t.background.layer;
    if (!e || !t || !nu(n)) return !1;
    const s = t === e ? e.parentId && this.studio.items.value.find((o) => o.id === e.parentId) || null : e;
    return s ? this.bake("Adjusting the " + (n.target === "background" ? "background" : "subject"), async () => {
      const [o, r] = await Promise.all([si(s.url), si(t.url)]), a = wl(o.width, o.height), l = AI(o, r, n, a.w, a.h);
      return this.studio.addVersion(l, { tool: "layers", label: n.target === "background" ? "Background adjusted" : "Subject adjusted", settings: { layer: { ...n } } }, s);
    }, () => {
      this.t.background.layer = { ...Oh(), target: n.target };
    }) : !1;
  }
  // ---------------------------------------------------------------- Adjust
  /** Adjust as it opens on the stage picture: an Adjust version reopens with its settings, drawn from its own original. */
  readyAdjust() {
    const e = this.stage, t = this.t.adjust;
    if (!e || t.for === e.id) return;
    t.for = e.id;
    const n = e.made && e.made.tool === "adjust" && e.made.settings ? e.made.settings.adjust : void 0, s = n && e.parentId ? this.studio.items.value.find((o) => o.id === e.parentId && o.status === "done") : null;
    n && s ? (t.a = iu(n), t.source = s.id) : (t.a = zf(), t.source = e.id);
  }
  /** The picture Adjust draws from. */
  adjustSource() {
    const e = this.t.adjust.source;
    return e && this.studio.items.value.find((t) => t.id === e) || this.stage;
  }
  setAdjust(e) {
    this.t.busy || (this.t.adjust.a = e);
  }
  /** Match colours to another version: its colour read, then carried onto this one as you set how much. */
  async matchTo(e) {
    if (this.t.busy) return;
    const t = this.t.adjust.a;
    if (!e) {
      this.t.adjust.a = { ...t, match: { to: null, amount: 0, stats: null }, look: null };
      return;
    }
    const n = this.studio.items.value.find((s) => s.id === e);
    if (n)
      try {
        const s = await Q_(n.url);
        this.t.adjust.a = { ...this.t.adjust.a, match: { to: e, amount: this.t.adjust.a.match.amount || 80, stats: s } };
      } catch (s) {
        console.warn("[board] that version's colour couldn't be read", s), this.studio.say("That version's colour couldn't be read");
      }
  }
  /** How Match colours moves this picture's colour, for the shader (null when it isn't matched). */
  async transfer(e = this.t.adjust.a, t = this.adjustSource()) {
    if (!e.match.to || !e.match.stats || !t) return null;
    try {
      return Dhe(await Q_(t.url), e.match.stats);
    } catch {
      return null;
    }
  }
  async applyAdjust() {
    const e = this.adjustSource(), t = iu(this.t.adjust.a);
    return !e || !E0(t) ? !1 : this.bake("Applying your adjustments", async () => {
      const n = await si(e.url), s = new DI(document.createElement("canvas"));
      try {
        const o = wl(n.width, n.height, Math.min(8192, s.maxSize())), r = su(t, o.w, o.h);
        s.setImage(n, n.width, n.height), s.render(t, r.w, r.h, { transfer: await this.transfer(t, e), grainScale: r.w / Math.max(1, su(t, n.width, n.height).w) });
        const a = Rn(r.w, r.h);
        return zn(a).drawImage(s.canvas, 0, 0), this.studio.addVersion(a, { tool: "adjust", label: Rhe(t), settings: { adjust: t } }, e, { alpha: CI(n) });
      } finally {
        s.dispose();
      }
    }, () => {
      this.t.adjust.for = null;
    });
  }
  // ---------------------------------------------------------------- shared
  /**
   * While a tool's version is being made, nothing else moves (IL-100; Adam:
   * changing exposure or resize while one applied raced it): it says so, and
   * the tools, their settings and the stage wait for it.
   */
  held() {
    const e = this.t.busy;
    return e ? (this.studio.say("One moment: " + e.charAt(0).toLowerCase() + e.slice(1)), !0) : !1;
  }
  /** Make a tool's version: one at a time, said in the bar while it's made. */
  async bake(e, t, n) {
    if (this.t.busy) return !1;
    this.t.busy = e, this.studio.s.baking = e;
    try {
      return await t() ? (n(), !0) : !1;
    } catch (s) {
      return console.warn("[board] a tool's version couldn't be made", s), this.studio.say(s instanceof Error && /read|draw|saved|uploaded/i.test(s.message) ? s.message.replace(/\.$/, "") : "That couldn't be made. Please try again"), !1;
    } finally {
      this.t.busy = null, this.studio.s.baking = null;
    }
  }
  // ---------------------------------------------------------------- the model tools' runs
  /** A reference picture a tool sends as image 2 (Replace background's, Light transfer's). */
  refItem(e) {
    return e && this.studio.items.value.find((t) => t.id === e && t.status === "done") || null;
  }
  /** A model tool's run, as its plan: the stage picture, the tool's settings as its model's inputs, its words. */
  plan(e) {
    var t;
    const n = this.stage, s = this.studio.modelOf(e);
    if (!n || n.status !== "done" || !s) return null;
    const o = { w: n.w, h: n.h }, r = { kind: e, model: s, words: "", count: this.studio.countOf(e), base: n.id }, a = { kind: "item", item: n, marks: !1 }, l = s.fields.find((c) => c.placement === "prompt"), d = l ? String((t = this.studio.valueOf(e, l)) != null ? t : "") : "";
    if (e === "upscale")
      return { ...r, pics: [a], compiled: d, inputs: this.studio.editInputs(e, s, null), settings: { label: ppe(s, this.studio.valueOfKey(e, "scale")) } };
    if (e === "removebg")
      return { ...r, count: 1, pics: [a], compiled: d, inputs: this.studio.editInputs(e, s, null), settings: { label: "" } };
    if (e === "replacebg") {
      const c = this.refItem(this.t.background.refId), h = this.t.background.words;
      return {
        ...r,
        words: h,
        pics: c ? [a, { kind: "item", item: c, marks: !1 }] : [a],
        compiled: the(h, !!c),
        inputs: this.studio.editInputs(e, s, o),
        settings: { label: hpe(h) || (c ? "from a picture" : "") }
      };
    }
    if (e === "skin")
      return { ...r, pics: [a], compiled: she(this.t.skin), inputs: this.studio.editInputs(e, s, o), settings: { label: "", skin: { ...this.t.skin } } };
    if (e === "expand") {
      const c = this.frame();
      if (!c) return null;
      const h = khe(c), f = this.t.resize.words, p = {
        canvasWidth: h.canvas_size[0],
        canvasHeight: h.canvas_size[1],
        imageWidth: h.original_image_size[0],
        imageHeight: h.original_image_size[1],
        imageX: h.original_image_location[0],
        imageY: h.original_image_location[1]
      }, y = { ...this.studio.editInputs(e, s, null), ...O_(s, p) };
      return {
        ...r,
        count: 1,
        words: f,
        pics: [a],
        compiled: f.trim(),
        inputs: y,
        settings: { label: Che(this.t.resize.frameRatio, c), frame: { ...c } }
      };
    }
    if (e === "camera") {
      const c = this.t.camera, h = ro(c.set), f = Vne(h, c.lock ? this.seed() : null), p = { ...this.studio.editInputs(e, s, null), ...O_(s, f, { rotate: /rotate|horizontal/i, vertical: /vertical/i, zoom: /zoom/i }) };
      return {
        ...r,
        count: this.studio.countOf(e),
        pics: [a],
        compiled: d,
        inputs: p,
        settings: { label: kc(h), camera: h }
      };
    }
    if (e === "relight") {
      const c = this.t.relight, h = c.rig.mode === "transfer" ? this.refItem(c.refId) : null;
      return {
        ...r,
        pics: h ? [a, { kind: "item", item: h, marks: !1 }] : [a],
        compiled: spe(c.rig),
        inputs: this.studio.editInputs(e, s, o),
        settings: { label: rpe(c.rig), rig: JSON.parse(JSON.stringify(c.rig)) }
      };
    }
    return null;
  }
  /** What stops a tool's run before its model's own checks. */
  problem(e, t = !1) {
    const n = this.stage;
    if (!n || n.status !== "done") return "Pick an image first";
    if (!this.studio.modelOf(e)) return (upe[e] || "This") + " isn't available here yet";
    if (e === "replacebg" && !t && !this.t.background.words.trim() && !this.refItem(this.t.background.refId)) return "Say what background you want, or pick a picture of it";
    if (e === "expand") {
      const s = this.frame();
      if (!s || !A0(s)) return "Drag the frame past the picture, or pick a shape";
    }
    return e === "relight" && this.t.relight.rig.mode === "transfer" && !this.refItem(this.t.relight.refId) ? "Pick the picture whose light to copy" : null;
  }
  /** Send a model tool's run: with the prompt it puts together, or your own full prompt instead (IL-076). */
  async runTool(e, t = null) {
    const n = this.problem(e, t != null);
    if (n)
      return this.studio.say(n), !1;
    const s = this.plan(e);
    if (!s) return !1;
    const o = this.t.resize.frame, r = this.t.resize.words, a = await this.studio.run(t != null ? { ...s, compiled: t } : s);
    return a && e === "expand" && (this.t.resize.frame === o && (this.t.resize.frame = null), this.t.resize.words === r && (this.t.resize.words = "")), a;
  }
  /**
   * The colour mixer's picker (CHAT-42: Adam couldn't tell what the mixer was
   * for): a click on the picture (fx, fy: 0 to 1 across it) picks its colour,
   * and the mixer goes to that colour's band, so its sliders move what you picked.
   */
  async pickColourAt(e, t) {
    const n = this.t.adjust;
    n.picking = !1;
    const s = this.stage, o = n.source ? this.studio.itemById(n.source) : null, r = o && o.url || (s ? s.url : "");
    if (r)
      try {
        const a = await si(r), l = Math.min(a.width - 1, Math.max(0, Math.round(e * a.width))), d = Math.min(a.height - 1, Math.max(0, Math.round(t * a.height))), c = Rn(5, 5), h = zn(c);
        h.drawImage(a, l - 2, d - 2, 5, 5, 0, 0, 5, 5);
        const f = h.getImageData(0, 0, 5, 5).data;
        let p = 0, y = 0, v = 0;
        for (let S = 0; S < f.length; S += 4)
          p += f[S], y += f[S + 1], v += f[S + 2];
        const x = f.length / 4, w = [p / x / 255, y / x / 255, v / x / 255];
        n.picked = w, n.band = Bhe(w);
      } catch {
        this.studio.say("That colour couldn't be read from the picture.");
      }
  }
  /** Change camera's seed, kept while you nudge the sliders so a small move doesn't reshuffle the picture. */
  seed() {
    return this.t.camera.seed == null && (this.t.camera.seed = Math.floor(Math.random() * 2147483646) + 1), this.t.camera.seed;
  }
  setCamera(e) {
    this.t.camera.set = ro({ ...this.t.camera.set, ...e });
  }
  // ---------------------------------------------------------------- Compare
  /** Compare the stage picture with another version: Split (a slider) or Toggle. */
  compare(e, t = this.t.compare ? this.t.compare.mode : "split") {
    const n = this.stage;
    if (!e || !n || e === n.id) {
      this.t.compare = null;
      return;
    }
    this.t.compare = { with: e, mode: t, at: this.t.compare ? this.t.compare.at : 0.5, other: !1 };
  }
  /** What Compare starts against: the version the stage picture was made from, else its original. */
  compareDefault() {
    const e = this.stage;
    if (!e) return null;
    if (e.parentId && this.studio.items.value.some((n) => n.id === e.parentId && n.status === "done")) return e.parentId;
    const t = this.studio.rootId.value;
    return t && t !== e.id ? t : null;
  }
  dispose() {
    this.t.guard = null;
  }
}
const upe = {
  upscale: "Upscaling",
  removebg: "Removing backgrounds",
  replacebg: "Replacing backgrounds",
  expand: "Expand",
  skin: "Improve people",
  camera: "Change camera",
  relight: "Relight",
  erase: "Erase",
  select: "Picking objects"
};
function e4(i) {
  const e = iu(i);
  return e.look = null, e.match = { ...e.match, stats: null }, e;
}
function hpe(i) {
  const e = i.trim().split(/\s+/).filter(Boolean);
  return e.slice(0, 5).join(" ") + (e.length > 5 ? "…" : "");
}
function ppe(i, e) {
  const t = typeof e == "number" ? e : typeof e == "string" ? parseFloat(e) : NaN;
  return Number.isFinite(t) ? t + "×" : i.name;
}
var fpe = Object.defineProperty, mpe = (i, e, t) => e in i ? fpe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, bt = (i, e, t) => mpe(i, typeof e != "symbol" ? e + "" : e, t);
const z0 = ["#ff3d6e", "#ffc93c", "#36d6ff", "#ffffff", "#16141f"], gpe = 0.5, GI = ["threed", "edit", "erase", "upscale", "removebg", "replacebg", "expand", "skin", "camera", "relight", "select"], t4 = 700, Mb = 1024, bpe = 1400, jI = (i) => "rd-board-studio:" + i, HI = "Your edited prompt runs instead: use Run with this prompt, or reset it";
class vpe {
  constructor(e, t) {
    bt(this, "board", e), bt(this, "sessionId", t), bt(this, "s"), bt(this, "items"), bt(this, "boardItems"), bt(this, "historySessions"), bt(this, "side"), bt(this, "video"), bt(this, "genMode"), bt(this, "stage"), bt(this, "family"), bt(this, "rootId"), bt(this, "names"), bt(this, "shown"), bt(this, "queueItems"), bt(this, "editRefItems"), bt(this, "dockModel"), bt(this, "limit"), bt(this, "session"), bt(this, "models3d"), bt(this, "model3d"), bt(this, "card"), bt(this, "tools"), bt(this, "parentOf"), bt(this, "undo", /* @__PURE__ */ new Map()), bt(this, "redo", /* @__PURE__ */ new Map()), bt(this, "newText", null), bt(this, "textBefore", ""), bt(this, "newPin", null), bt(this, "pinBefore", ""), bt(this, "noteTimer", 0), bt(this, "queueKey", ""), bt(this, "promptTimer", 0), bt(this, "promptBase", ""), bt(this, "keeping", []), bt(this, "dirty", /* @__PURE__ */ new Set()), bt(this, "marksTimer", 0), bt(this, "awaiting", /* @__PURE__ */ new Map()), bt(this, "resumed", /* @__PURE__ */ new Set()), bt(this, "flat", /* @__PURE__ */ new Map()), bt(this, "files", /* @__PURE__ */ new Map()), bt(this, "scope", r1(!0));
    const n = _pe(e.user.uid), s = {};
    for (const a of GI) s[a] = n[a] || { modelId: "", count: 1, inputs: {} };
    this.s = /* @__PURE__ */ Xt({
      studio: "prompt",
      last: { generate: "prompt", edit: "edit" },
      modes: s,
      bar: "edit",
      areaTool: "brush",
      areaCut: !1,
      areaSize: 48,
      precision: !0,
      objects: {},
      baking: null,
      finishing: [],
      stageId: null,
      queue: [],
      editRefs: [],
      dropper: !1,
      refPulse: null,
      fullOpen: {},
      fullEdits: {},
      wordsOnly: Spe(e.user.uid),
      sessions: [],
      pinned: !1,
      columns: H8(e.user.uid),
      histShut: Tpe(e.user.uid),
      peekId: null,
      cardId: null,
      marks: {},
      asks: {},
      tool: "brush",
      color: z0[0],
      opacity: gpe,
      size: 5,
      selection: [],
      editingText: null,
      editingPin: null,
      histRev: 0,
      prompt: e.promptOf(t).prompt || "",
      sending: 0,
      ghosts: [],
      three: { model: null, cam: null, backdrop: "studio", aspect: "16:9", loading: !1, keeping: null, error: null },
      note: null
    }), this.session = I(() => {
      e.docRev.value;
      const a = e.store.get(t);
      return a && a.type === "tool" ? a : null;
    }), this.video = I(() => {
      const a = this.session.value;
      return !!a && (a.kitId === "video" || a.kitId === "videoEdit");
    });
    const o = I(() => e.studioRecords.forSession(t)), r = I(() => o.value.filter((a) => a.role === "ref"));
    this.models3d = I(() => o.value.filter((a) => a.role === "model").sort((a, l) => a.createdAt - l.createdAt)), this.model3d = I(() => this.models3d.value.find((a) => a.id === this.s.three.model) || null), this.parentOf = (a) => {
      const l = this.s.ghosts.find((p) => p.id === a);
      if (l) return l.parentId;
      const d = e.studioRecords.get(a);
      if (d && d.role === "ref") return d.base && d.base !== a ? d.base : null;
      const c = e.results.get(a), h = c ? c.runId : a.includes(":") ? a.split(":")[0] : null;
      if (!h) return null;
      const f = e.studioRecords.get(Ap(h));
      return f && f.role === "edit" && f.base !== a ? f.base : null;
    }, this.items = I(() => {
      e.results.rev.value, e.studioRecords.rev.value;
      const a = this.hidden(e.studioRecords.forSession(t)), l = e.results.list(t).filter((c) => i4(c, a)).map((c) => this.genItem(c)), d = r.value.map((c) => n4(c));
      return [...this.s.ghosts, ...l, ...d].sort((c, h) => h.createdAt - c.createdAt);
    }), this.boardItems = I(() => {
      e.results.rev.value, e.docRev.value;
      const a = this.items.value.filter((d) => !(d.kind === "ref" && d.how === "board")), l = this.hidden(e.studioRecords.all());
      for (const d of e.store.all())
        if (!(d.type !== "tool" || d.id === t))
          for (const c of e.results.list(d.id))
            i4(c, l) && a.push({ ...this.genItem(c), parentId: null, sessionId: d.id });
      return a.sort((d, c) => c.createdAt - d.createdAt);
    }), this.historySessions = I(() => {
      const a = /* @__PURE__ */ new Map();
      for (const h of this.boardItems.value) {
        const f = h.sessionId || t;
        a.set(f, (a.get(f) || 0) + 1);
      }
      const l = e.recentTools(), d = l.find((h) => h.id === t), c = l.filter((h) => h.id !== t && (a.has(h.id) || e.isPinned(h.id)));
      return [...d ? [d] : [], ...c].map((h) => ({
        id: h.id,
        name: h.name,
        icon: h.icon || "Image",
        count: a.get(h.id) || 0,
        here: h.id === t,
        pinned: e.isPinned(h.id)
      }));
    }), this.side = I(() => z_[this.s.studio]), this.genMode = I(() => this.side.value === "generate" ? this.s.studio : this.s.last.generate), this.stage = I(() => this.items.value.find((a) => a.id === this.s.stageId) || null), this.family = I(() => Lue(this.items.value, this.parentOf, this.s.stageId)), this.rootId = I(() => this.s.stageId ? vI(this.parentOf, this.s.stageId) : null), this.names = I(() => {
      const a = Bue(this.family.value, this.rootId.value), l = this.rootId.value ? this.family.value.find((d) => d.id === this.rootId.value) : null;
      return l && l.kind === "gen" && a.set(l.id, l.label), a;
    }), this.shown = I(() => {
      if (this.s.pinned) return this.pinnedItems();
      const a = this.pickedSessions();
      return a.length ? this.boardItems.value.filter((l) => a.includes(l.sessionId || t)) : this.boardItems.value;
    }), this.queueItems = I(() => {
      const a = new Map(this.items.value.map((l) => [l.id, l]));
      return this.s.queue.map((l) => a.get(l)).filter((l) => !!l);
    }), this.editRefItems = I(() => {
      const a = new Map(this.items.value.map((l) => [l.id, l]));
      return this.s.editRefs.map((l) => a.get(l)).filter((l) => !!l && l.status === "done");
    }), this.dockModel = I(() => this.modelOf(this.genMode.value)), this.limit = I(() => zo(this.dockModel.value)), this.card = I(() => (e.docRev.value, this.cardFor(this.family.value))), this.promptBase = this.s.prompt, this.tools = new cpe(this, e), this.scope.run(() => {
      Ae(() => e.studioRecords.rev.value, () => this.readMarks(), { immediate: !0 }), Ae(() => e.results.rev.value, () => this.landResults(), { immediate: !0 }), Ae(() => this.s.modes, () => Ipe(e.user.uid, this.s.modes), { deep: !0 }), Ae(() => this.s.stageId, () => this.dropStaleEdits()), Ae(() => e.promptOf(t).prompt || "", (a) => {
        const l = this.s.prompt === this.promptBase;
        this.promptBase = a, l && (this.s.prompt = a);
      }), Ae(() => this.promptPictures(), (a) => {
        a !== this.queueKey && this.loadQueue();
      }), Ae(() => this.s.dropper && (this.side.value === "edit" ? !!this.tools.t.open || !this.takesRefs() : !this.limit.value), (a) => {
        a && (this.s.dropper = !1);
      }), Ae(this.side, () => {
        this.s.dropper = !1;
      });
    });
  }
  /**
   * Results no one should see as pictures: a helper run's (Select's map of a
   * picture's objects), one a Precision version stands in for, and one being
   * finished here (IL-073). Run ids are kept as "run:" and the id.
   */
  hidden(e) {
    const t = new Set(this.s.finishing);
    for (const n of e)
      n.role === "edit" && n.helper && t.add("run:" + n.runId), n.role === "ref" && n.made && n.made.from && t.add(n.made.from);
    return t;
  }
  genItem(e) {
    return {
      id: e.id,
      kind: "gen",
      url: e.url,
      w: e.w || 4,
      h: e.h || 3,
      createdAt: e.createdAt,
      parentId: this.parentOf(e.id),
      label: this.labelOf(e),
      status: e.status === "done" ? "done" : e.status === "pending" ? "pending" : "failed",
      result: e,
      asset: e.asset || null,
      runId: e.runId
    };
  }
  /**
   * A result's name here: what its person wrote (a Studios view run's prompt
   * is their words, then lines for the model, which aren't a name), else
   * what kind of run it was.
   */
  labelOf(e) {
    const t = e.runId ? this.board.studioRecords.get(Ap(e.runId)) : void 0, n = t && t.role === "edit" ? t : null;
    if (n && !["edit", "draw", "comment", "threed"].includes(n.studio)) {
      const o = hb[n.studio] || "Edit", r = n.settings && typeof n.settings.label == "string" ? n.settings.label : "";
      return r ? o + " · " + r : o;
    }
    const s = wpe(e.prompt || "");
    return s ? Ab(s, 7) : n ? hb[n.studio] || "Edit" : e.prompt && /^Image 1 is the image to edit/.test(e.prompt) ? "From image 1" : e.label || e.model || "Generation";
  }
  // ---------------------------------------------------------------- entering
  /**
   * Open on an image (Edit: it goes on the stage, ready to mark up, and is
   * queued as image 1 for the Generate side; its versions run under the
   * stage) or on the session alone (Generate, Prompt).
   */
  enter(e) {
    if (this.loadQueue(), this.s.prompt = this.board.promptOf(this.sessionId).prompt || "", this.promptBase = this.s.prompt, this.s.editingPin = null, this.s.editingText = null, this.s.selection = [], e && this.as3d(this.entryModel3d(e))) {
      this.s.cardId = null;
      return;
    }
    const t = e ? this.itemFor(e) : null;
    this.s.cardId = e && e.elementId ? e.elementId : null, t ? (this.s.stageId = t.id, this.limit.value && this.setQueue(Dh(this.s.queue, t.id, this.limit.value).queue), this.s.studio = this.video.value ? "prompt" : this.s.last.edit) : (this.s.stageId = null, this.s.studio = "prompt", this.s.last.generate = "prompt");
  }
  /** The 3D model an entry is, where it's one: a 3D result, or a 3D model placed on the board from your Library. */
  entryModel3d(e) {
    if (e.resultId) return Ib(this.board.results.get(e.resultId));
    const t = e.elementId ? this.board.store.get(e.elementId) : void 0;
    if (!t || t.type !== "image") return null;
    const n = t;
    return Ib(n.resultId && this.board.results.get(n.resultId) || n);
  }
  /** The item for a board image or a result; an image no session made comes in as a reference. */
  itemFor(e) {
    const t = this.items.value;
    if (e.resultId) return t.find((l) => l.id === e.resultId) || null;
    if (!e.elementId) return null;
    const n = this.board.store.get(e.elementId);
    if (!n || n.type !== "image") return null;
    if (n.resultId) {
      const l = t.find((d) => d.id === n.resultId);
      if (l) return l;
    }
    const s = t.find((l) => l.url === n.src);
    if (s) return s;
    const o = n.asset || this.board.assetFor(n.src), r = ga(o), a = this.addRef({
      how: "board",
      url: n.src,
      w: r ? r.width : n.w,
      h: r ? r.height : n.h,
      label: n.label || "Board image",
      asset: o,
      source: n.resultId || null
    });
    return r || this.measureRef(a.id, n.src), a;
  }
  /** A reference whose record holds no size takes its picture's own, once it loads (IL-100). */
  measureRef(e, t) {
    Id(t).then((n) => {
      if (n.w === 4 && n.h === 3) return;
      const s = this.board.studioRecords.get(e);
      s && s.role === "ref" && (s.pw !== n.w || s.ph !== n.h) && this.board.studioRecords.patch(e, { pw: n.w, ph: n.h });
    });
  }
  // ---------------------------------------------------------------- models and settings
  /** The models a studio offers, from the board's catalog. */
  modelsFor(e) {
    const t = this.session.value;
    return Jue(this.board.catalog.value, e, t ? t.kitId : null);
  }
  /** A studio's model: Prompt's is the session's; the others keep their own. */
  modelOf(e) {
    if (e === "prompt") {
      const s = this.session.value;
      return s ? this.board.modelFor(s).model : null;
    }
    const t = this.modelsFor(e), n = this.s.modes[e].modelId;
    return t.find((s) => s.id === n) || t.find((s) => MI.test(s.name)) || t[0] || null;
  }
  setModel(e, t) {
    if (e === "prompt") {
      this.board.patchTool(this.sessionId, { model: t.name, nodeDefId: t.id });
      return;
    }
    const n = this.s.modes[e];
    n.modelId !== t.id && (this.s.modes[e] = { modelId: t.id, count: n.count, inputs: {} });
  }
  /** How many a studio makes, within what its model allows. */
  countOf(e) {
    const t = this.modelOf(e), n = e === "prompt" ? this.board.promptOf(this.sessionId).n || (t ? t.numResults.def : 1) || 1 : this.s.modes[e].count;
    return t ? Math.max(t.numResults.min, Math.min(t.numResults.max, n)) : n;
  }
  setCount(e, t) {
    const n = this.modelOf(e), s = n ? Math.max(n.numResults.min, Math.min(Math.min(n.numResults.max, 8), t)) : Math.max(1, Math.min(4, t));
    e === "prompt" ? this.board.setPrompt(this.sessionId, { n: s }) : this.s.modes[e].count = s;
  }
  /** The most a studio's count goes to. */
  maxCount(e) {
    const t = this.modelOf(e);
    return t ? Math.min(t.numResults.max, 8) : 4;
  }
  /** The least it goes to: its model's least. */
  minCount(e) {
    const t = this.modelOf(e);
    return t ? Math.max(1, t.numResults.min) : 1;
  }
  /** A studio's values for its model's inputs: Prompt's are your session prompt's. */
  inputsOf(e) {
    return e === "prompt" ? { ...this.board.promptOf(this.sessionId).inputs || {} } : { ...this.s.modes[e].inputs };
  }
  /** The chips a studio shows under its words: its model's chip inputs. */
  chipsOf(e) {
    const t = this.modelOf(e);
    return t ? t.fields.filter((n) => n.placement === "chip" && n.kind !== "model") : [];
  }
  /** The chips that can be changed here (a choice, a switch or a slider), less any the run sets itself. */
  shownChips(e, t = []) {
    return this.chipsOf(e).filter((n) => !t.includes(n.key) && (n.kind === "boolean" || n.kind === "slider" || !!(n.options && n.options.length)));
  }
  /** A chip's value as the run will send it: an Edit studio's and 3D's shape follow their picture's unless you chose one. */
  valueOf(e, t) {
    const n = this.modelOf(e);
    if (!n || e === "prompt") return Lc(t, { inputs: this.inputsOf(e) });
    const s = this.editInputs(e, n, this.shapeSource(e));
    return Lc(t, { inputs: s, prompt: t.placement === "prompt" ? s[t.key] : void 0 });
  }
  /** v1's "Match Media Input" (B26): the size nearest the picture the run sends in the input this size follows. */
  matchOf(e, t) {
    const n = t.kind === "size" ? this.previewUp(e) : null;
    return n ? Q6(n.model, t, n.up, (s) => this.board.measuredSize(s)) : null;
  }
  setInput(e, t, n) {
    if (e === "prompt") {
      const s = this.board.promptOf(this.sessionId);
      this.board.setPrompt(this.sessionId, { inputs: { ...s.inputs || {}, [t]: n } });
      return;
    }
    this.s.modes[e] = { ...this.s.modes[e], inputs: { ...this.s.modes[e].inputs, [t]: n } };
  }
  // ---------------------------------------------------------------- studios
  needsImage(e) {
    return e === "edit";
  }
  canUse(e) {
    if (this.video.value && e !== "prompt") return !1;
    if (!this.needsImage(e)) return !0;
    const t = this.stage.value;
    return !!t && t.status === "done";
  }
  setStudio(e) {
    this.canUse(e) && (this.finishEditing(), this.s.studio = e, this.s.last[z_[e]] = e, this.s.selection = [], e === "threed" && !this.s.three.model && this.models3d.value.length && (this.s.three.model = this.models3d.value[this.models3d.value.length - 1].id));
  }
  /** Generate or Edit: back to the studio last open there. Edit needs a picture. */
  setSide(e) {
    if (this.side.value !== e) {
      if (e === "edit" && this.video.value) {
        this.say("Edit changes pictures: this session makes videos");
        return;
      }
      if (e === "edit" && !this.toEdit()) {
        this.say("Make an image or bring one in first, then edit it");
        return;
      }
      e === "edit" && this.s.stageId && this.from3d(this.s.stageId) || this.setStudio(this.s.last[e]);
    }
  }
  /** There's something to edit: a finished picture in history. */
  canEdit() {
    return this.items.value.some((e) => e.status === "done");
  }
  /** The stage's picture, or else the newest finished one, put on the stage. */
  toEdit() {
    const e = this.stage.value;
    if (e && e.status === "done") return !0;
    const t = this.items.value.find((n) => n.status === "done");
    return t ? (this.show(t.id), !0) : !1;
  }
  // ---------------------------------------------------------------- the stage and history
  /** Any item: this session's, or another session's on the board. */
  itemById(e) {
    return this.items.value.find((t) => t.id === e) || this.boardItems.value.find((t) => t.id === e) || null;
  }
  /**
   * An item as this session has it: its own, or another session's (the Board
   * view) brought in as a reference, once, to stage, queue, mark up or edit.
   */
  bringIn(e) {
    if (e.startsWith("pin:")) return this.bringInPin(e.slice(4));
    const t = this.items.value.find((o) => o.id === e);
    if (t) return t;
    const n = this.boardItems.value.find((o) => o.id === e);
    if (!n || n.status !== "done") return null;
    const s = this.items.value.find((o) => o.kind === "ref" && o.how === "board" && o.source === e);
    return s || this.addRef({ how: "board", url: n.url, w: n.w, h: n.h, label: n.label, asset: n.asset || null, source: e });
  }
  /**
   * The result behind an item: a run's own, or the one another session's
   * picture brought in here came from (a video plays on the stage as itself,
   * not as its poster, CHAT-31). Null for an upload, a capture, a version
   * made here.
   */
  resultOf(e) {
    return e.result ? e.result : e.kind !== "ref" || !e.source ? null : (this.board.results.rev.value, this.board.results.get(e.source) || null);
  }
  /**
   * Your pinned pictures, as history's Pinned view shows them: a result the
   * board has as itself, one already brought in here as that, and any other
   * as a stand-in that comes in (bringInPin) when it's used.
   */
  pinnedItems() {
    const e = new Map(this.boardItems.value.map((n) => [n.id, n])), t = this.items.value.filter((n) => n.kind === "ref");
    return this.board.pinnedImages.value.map((n) => {
      const s = n.resultId && e.get(n.resultId) || t.find((o) => o.url === n.url);
      return s || {
        id: "pin:" + n.id,
        kind: "ref",
        how: "board",
        pin: !0,
        url: n.url,
        w: n.pw,
        h: n.ph,
        createdAt: n.createdAt,
        parentId: null,
        label: n.label,
        status: "done",
        asset: n.asset || null,
        source: n.resultId || n.url,
        sessionId: n.fromSession || void 0
      };
    });
  }
  /** A pinned picture brought into this session: as a reference from the board, once. */
  bringInPin(e) {
    const t = this.board.studioRecords.get(e);
    if (!t || t.role !== "pin") return null;
    const n = t.resultId || t.url, s = this.items.value.find((o) => o.kind === "ref" && (o.source === n || o.url === t.url));
    if (s) return s;
    if (t.resultId) {
      const o = this.items.value.find((r) => r.id === t.resultId);
      if (o) return o;
    }
    return this.addRef({ how: "board", url: t.url, w: t.pw, h: t.ph, label: t.label, asset: t.asset || null, source: n });
  }
  /** A picture brought into this session, saved on the board as a reference; the item it is here. */
  addRef(e, t = Date.now()) {
    e.how !== "board" && this.reveal();
    const n = {
      ...bl,
      id: St(),
      type: "studio",
      role: "ref",
      sessionId: this.sessionId,
      createdAt: t,
      how: e.how,
      url: e.url,
      pw: e.w || 4,
      ph: e.h || 3,
      label: e.label,
      asset: e.asset || null,
      source: e.source || null,
      model: e.model || null,
      camera: e.camera || null,
      shot: e.shot || null,
      ...e.base ? { base: e.base } : {},
      ...e.made ? { made: e.made } : {}
    };
    return this.board.studioRecords.put(n), n4(n);
  }
  /**
   * The name of the session an item came from. A picture brought in from the
   * board names the session whose result it copies, and none when no session
   * made it (an upload dropped on the canvas): its record is this session's.
   */
  sessionName(e) {
    var t;
    const n = e.sessionId || (e.kind === "ref" && e.how === "board" ? e.source && ((t = this.board.results.get(e.source)) == null ? void 0 : t.sessionId) || null : this.sessionId), s = n ? this.board.store.get(n) : void 0;
    return s && s.type === "tool" ? s.name : "";
  }
  /**
   * Put an item on the stage (another session's comes in first). An Edit
   * tool with a change on the stage that isn't a version yet asks first
   * (IL-073): apply it, or discard it.
   */
  show(e) {
    if (this.tools && this.s.stageId !== e && this.tools.held()) return;
    if (this.tools && this.tools.t.open && this.tools.pending() && this.s.stageId !== e) {
      this.tools.leave(() => {
        const n = this.tools.t.open;
        this.show(e), n && (this.tools.t.open = n);
      });
      return;
    }
    if (this.side.value === "edit" && this.from3d(e)) return;
    const t = this.bringIn(e);
    t && (this.finishEditing(), this.s.stageId = t.id, this.s.selection = [], this.s.studio === "threed" && (this.s.studio = "prompt", this.s.last.generate = "prompt"));
  }
  // ---------------------------------------------------------------- history: the board's, by session
  /** The sessions history is narrowed to, of those it lists; none is every session. */
  pickedSessions() {
    const e = this.historySessions.value;
    return this.s.sessions.filter((t) => e.some((n) => n.id === t));
  }
  /** Whether history shows every session on the board. */
  allSessions() {
    const e = this.pickedSessions();
    return !e.length || e.length === this.historySessions.value.length;
  }
  /** Add a session to the ones history shows, or take it out (the last one out is every session again). */
  toggleSession(e) {
    const t = this.pickedSessions();
    this.s.sessions = t.includes(e) ? t.filter((n) => n !== e) : [...t, e];
  }
  /** History shows this session alone; or every session, with none named. */
  onlySession(e) {
    this.s.sessions = e ? [e] : [];
  }
  /** What you make or bring in here always shows in history, whatever sessions it was narrowed to. */
  reveal() {
    const e = this.pickedSessions();
    e.length && !e.includes(this.sessionId) && (this.s.sessions = [...e, this.sessionId]);
  }
  /** History's columns, remembered for the next visit and the next board. */
  setColumns(e) {
    const t = W8(e);
    t !== this.s.columns && (this.s.columns = t, V8(this.board.user.uid, t));
  }
  // ---------------------------------------------------------------- the queue (your session prompt's pictures)
  /**
   * The session prompt's pictures, as this session's items, and then what's
   * queued beyond the model's limit (kept here, not in the prompt). A result
   * not read yet is read; a picture from elsewhere comes in as a reference.
   */
  loadQueue() {
    this.queueKey = this.promptPictures();
    const e = this.modelOf("prompt"), t = this.board.promptOf(this.sessionId), n = [];
    for (const o of Sf(e, t)) {
      const r = t.assets && t.assets[o] || this.board.assetFor(o), a = this.items.value.find((c) => c.url === o || c.result && c.result.thumb === o);
      if (a) {
        n.includes(a.id) || n.push(a.id);
        continue;
      }
      const l = r && "nodeRunResult" in r ? kpe(r) : null;
      if (l) {
        n.push(l), this.board.loadRecord(l).then((c) => {
          if (c && c.sessionId === this.sessionId) return;
          const h = this.s.queue.indexOf(l);
          if (h < 0) return;
          const f = this.bringInResult(l, o, r, c), p = this.s.queue.slice();
          p[h] = f.id, this.s.queue = p;
        }).catch(() => {
        });
        continue;
      }
      const d = this.addRef({ how: "board", url: o, w: 4, h: 3, label: "Reference", asset: r });
      n.push(d.id);
    }
    const s = this.s.queue.filter((o) => !n.includes(o) && this.items.value.some((r) => r.id === o));
    this.s.queue = n.concat(s);
  }
  /** Another session's result (or one that's gone) in your prompt: a reference here, once. */
  bringInResult(e, t, n, s) {
    const o = this.items.value.find((r) => r.kind === "ref" && r.source === e);
    return o || this.addRef({ how: "board", url: t, w: s ? s.w : 4, h: s ? s.h : 3, label: s && (s.label || s.prompt) || "Reference", asset: n, source: e });
  }
  /** A new queue: the model's share of it goes into your session prompt. */
  setQueue(e) {
    this.s.queue = e;
    const t = this.modelOf("prompt");
    if (!t || !zo(t)) return;
    const n = new Map(this.items.value.map((r) => [r.id, r])), s = e.slice(0, zo(t)).map((r) => n.get(r)).filter((r) => !!r).map((r) => ({ url: r.url, asset: r.asset || this.board.assetFor(r.url) })), o = _d(t, this.board.promptOf(this.sessionId), s);
    this.board.setPrompt(this.sessionId, { ref: o.ref, inputs: o.inputs, assets: o.assets }), this.queueKey = this.promptPictures();
  }
  /** The session prompt's pictures, as a key: the queue's own writes, told from anyone else's. */
  promptPictures() {
    const e = this.modelOf("prompt");
    return e ? Sf(e, this.board.promptOf(this.sessionId)).join(`
`) : "";
  }
  /** Its place in the queue (1 first), or 0; another session's item counts by its copy here. */
  queued(e) {
    const t = this.s.queue.indexOf(e);
    if (t >= 0) return t + 1;
    const n = this.items.value.find((s) => s.kind === "ref" && s.source === e);
    return n ? this.s.queue.indexOf(n.id) + 1 : 0;
  }
  /** What each slot is, where the dock's model has several image inputs (a start and an end frame). */
  slotName(e) {
    return Mne(this.dockModel.value)[e] || "";
  }
  add(e) {
    if (!this.limit.value) {
      this.say(this.modelName(this.genMode.value) + " takes no images");
      return;
    }
    const t = $h(this.s.queue, e, this.limit.value);
    t.full && this.say(this.modelName(this.genMode.value) + " takes " + this.limit.value + ": remove one first"), this.setQueue(t.queue);
  }
  remove(e) {
    this.setQueue(R_(this.s.queue, e));
  }
  toggleQueued(e) {
    if (!this.queued(e) && (this.refuseVideo(e) || this.from3d(e))) return;
    const t = this.bringIn(e);
    t && (this.queued(t.id) ? this.remove(t.id) : this.add(t.id));
  }
  /** The result goes into slot 1, in place of the image its run edited. */
  // ---------------------------------------------------------------- a Video Edit session's video (TD-13)
  //
  // A Video Edit tool takes a video, not pictures: the Studios view said it
  // "works from words alone" and offered only pictures. Its video is the
  // session's own input, the one its canvas card sets, so either place sets it.
  /** The session's model's video input, where it takes one. */
  videoField() {
    const e = this.modelOf("prompt");
    return e && e.fields.find((t) => t.placement === "reference" && t.kind === "video") || null;
  }
  /** The video the next run edits: the session's, set here or on its card. */
  sessionVideo() {
    const e = this.videoField();
    return e ? (this.board.promptRev.value, this.board.refImages(this.sessionId, e.key)[0] || null) : null;
  }
  /**
   * The file that plays for a video input's value: a board video is handed
   * over as its poster (its run's record carries the video), so it's looked
   * up; an upload is the file itself. Null when only a poster is known.
   */
  playableVideo(e) {
    if (!e) return null;
    this.board.results.rev.value;
    for (const n of this.board.store.all()) {
      if (n.type !== "tool") continue;
      const s = this.board.results.list(n.id).find((o) => o.url === e && o.video);
      if (s) return s.videoSrc || s.previewSrc || null;
    }
    const t = this.board.imagesInOrder().find((n) => n.src === e && n.video);
    return t ? t.videoSrc || null : /^blob:|\.(mp4|mov|m4v|webm)(\?|#|$)/i.test(e) ? e : null;
  }
  /** A video for the next run: from the board, your Library, or an upload (null takes it out). */
  setSessionVideo(e, t) {
    const n = this.videoField();
    n && this.board.setRefInput(this.sessionId, n.key, e, e ? t || this.board.assetFor(e) : null);
  }
  /** A video file from your computer, kept in your uploads, as the next run's video. */
  async bringInVideo(e) {
    if (this.videoField())
      try {
        const t = await this.board.uploadVideoFile(e);
        this.setSessionVideo(t.url, t.asset);
      } catch (t) {
        this.say(Cd(t, e.name));
      }
  }
  /**
   * Where a result sits in its run's batch, "1 of 2", when the run made more
   * than one (B29: a batch's results were each tagged "Original").
   */
  batchOf(e) {
    if (e.kind !== "gen" || !e.runId) return "";
    const t = this.items.value.filter((n) => n.kind === "gen" && n.runId === e.runId).sort((n, s) => n.createdAt - s.createdAt);
    return t.length < 2 ? "" : t.findIndex((n) => n.id === e.id) + 1 + " of " + t.length;
  }
  /**
   * What a picture was made from (B29: Studio showed none of it): the images
   * its run took, in their order. Empty for one brought in, or a run that took none.
   */
  madeFrom(e) {
    const t = e ? this.resultOf(e) : null;
    return (t && t.refs ? t.refs.filter((s, o, r) => !!s && r.indexOf(s) === o) : []).map((s, o) => ({ url: s, n: o + 1 }));
  }
  /** One of those, in the viewer: the picture it is if it's here, else brought in as a reference. */
  async showUrl(e) {
    const t = this.items.value.find((o) => o.url === e && o.status === "done") || this.boardItems.value.find((o) => o.url === e && o.status === "done");
    if (t) {
      this.show(t.id);
      return;
    }
    const n = await Promise.race([Id(e), new Promise((o) => window.setTimeout(() => o({ w: 4, h: 3 }), 2500))]), s = this.addRef({ how: this.howPicked(e), url: e, w: n.w, h: n.h, label: "Input", asset: this.board.assetFor(e) });
    this.show(s.id);
  }
  continueFrom(e) {
    if (!this.limit.value) {
      this.say(this.modelName(this.genMode.value) + " takes no images");
      return;
    }
    const t = this.bringIn(e);
    t && (this.setQueue(Dh(this.s.queue, t.id, this.limit.value).queue), this.show(t.id), this.say("Next run starts from this"));
  }
  move(e, t) {
    const n = this.s.queue.filter((s) => s !== e);
    n.splice(Math.max(0, Math.min(t, n.length)), 0, e), this.setQueue(n);
  }
  /**
   * Pictures picked in your Library (from anywhere): references here, queued
   * as far as the model takes them, the first on the stage. Each starts a
   * history of its own; history shows the session, where they join
   * everything else.
   */
  addFromLibrary(e) {
    const t = [], n = Date.now();
    if (e.forEach((l, d) => {
      const c = this.items.value.find((h) => h.kind === "ref" && h.how === "library" && h.source === l.id || h.url === l.url);
      if (c) {
        t.push(c);
        return;
      }
      l.asset && this.board.rememberAsset(l.url, l.asset), t.push(this.addRef({
        how: "library",
        url: l.url,
        w: l.w || 4,
        h: l.h || 3,
        label: Ab(l.prompt || l.label || "From your Library", 6),
        asset: l.asset || null,
        source: l.id
      }, n + d));
    }), !t.length) return;
    let s = 0, o = this.s.queue;
    if (this.limit.value) {
      for (const l of t) {
        const d = $h(o, l.id, this.limit.value);
        !d.full && d.queue !== o && s++, o = d.queue;
      }
      this.setQueue(o);
    }
    this.show(t[0].id);
    const r = t.length, a = this.modelName(this.genMode.value);
    this.limit.value ? s < r ? this.say(s ? s + " queued, the rest are in history: " + a + " takes " + this.limit.value : "The queue is full: " + (r === 1 ? "it's" : "they're") + " in history") : this.say(r === 1 ? "Brought in and queued" : "Brought in " + r + ", queued") : this.say(a + " takes no images: " + (r === 1 ? "it's" : "they're") + " in history");
  }
  /** An image from your computer: into your uploads (made a picture any browser shows), a reference here, queued. */
  async addUpload(e) {
    const t = await this.upload(e);
    t && (this.add(t.id), this.s.stageId || this.show(t.id));
  }
  /** An image from your computer on the Edit side: into your uploads, and one of the edit's references. */
  async addUploadRef(e) {
    const t = await this.upload(e);
    t && this.addEditRef(t.id);
  }
  /** A file into your uploads, as a picture brought into this session. */
  async upload(e) {
    const t = e.name.replace(/\.[a-z0-9]+$/i, "").slice(0, 40) || "Upload";
    let n, s;
    try {
      s = this.board.realRuns ? await this.board.uploadFile(e) : { url: await s4(e, Mb), asset: null }, n = await Id(s.url);
    } catch (o) {
      return this.say(Cd(o, e.name)), null;
    }
    return this.addRef({ how: "upload", url: s.url, w: n.w, h: n.h, label: t, asset: s.asset });
  }
  // ---------------------------------------------------------------- marks (Draw and Annotate)
  //
  // Each picture has its own marks, and they go with it when it's sent. They
  // stay editable shapes (v1 baked them into the picture), and are saved on
  // the board with the picture, for next time and for teammates.
  /** A picture's marks. */
  marksOf(e) {
    return e && this.s.marks[e.id] || Md();
  }
  /** The stage's marks, as Draw and Annotate edit them. */
  working() {
    return this.marksOf(this.stage.value);
  }
  /** The picture has marks or notes on it (they'll go with it when it's sent). */
  marked(e) {
    return Zd(this.s.marks[e]);
  }
  canUndo() {
    return this.s.histRev, !!this.s.stageId && !!(this.undo.get(this.s.stageId) || []).length;
  }
  canRedo() {
    return this.s.histRev, !!this.s.stageId && !!(this.redo.get(this.s.stageId) || []).length;
  }
  /** One undo step, before a change. */
  remember(e) {
    const t = this.undo.get(e) || [];
    t.push(Td(this.s.marks[e] || Md())), t.length > 100 && t.shift(), this.undo.set(e, t), this.redo.delete(e), this.s.histRev++;
  }
  /** Set a picture's marks, to be saved on the board after a pause. */
  putMarks(e, t) {
    const n = { ...this.s.marks };
    t && ub(t) ? n[e] = t : delete n[e], this.s.marks = n, this.changed(e);
  }
  /** Change the stage's marks: one undo step, unless `step` is false (the moves inside a gesture). */
  editMarks(e, t = !0) {
    const n = this.s.stageId;
    if (!n) return;
    t && this.remember(n);
    const s = this.marksOf(this.stage.value);
    this.putMarks(n, e({ strokes: s.strokes.slice(), pins: s.pins.slice(), ...s.area ? { area: s.area.slice() } : {} }));
  }
  /** A drag that changes marks as it goes: one undo step for all of it. */
  beginGesture() {
    this.s.stageId && this.remember(this.s.stageId);
  }
  /** The gesture changed nothing after all: its undo step goes too. */
  dropGesture() {
    const e = this.s.stageId ? this.undo.get(this.s.stageId) : null;
    e && e.length && (e.pop(), this.s.histRev++);
  }
  addStroke(e) {
    this.editMarks((t) => ({ ...t, strokes: [...t.strokes, e] }));
  }
  /** Change some marks: one undo step, unless `step` is false (inside a gesture). */
  updateStrokes(e, t, n = !0) {
    const s = new Set(e);
    this.editMarks((o) => ({ ...o, strokes: o.strokes.map((r) => s.has(r.id) ? t(r) : r) }), n);
  }
  deleteStrokes(e) {
    if (!e.length) return;
    const t = new Set(e);
    this.editMarks((n) => ({ ...n, strokes: n.strokes.filter((s) => !t.has(s.id)) })), this.s.selection = this.s.selection.filter((n) => !t.has(n)), this.s.editingText && t.has(this.s.editingText) && (this.s.editingText = null);
  }
  /** The colour for new marks; it also recolours the selection, or the block being written (as v1 did). */
  setColor(e) {
    this.s.color = e;
    const t = this.s.editingText ? [this.s.editingText] : this.s.tool === "move" ? this.s.selection : [];
    t.length && this.updateStrokes(t, (n) => ({ ...n, color: e }), !this.s.editingText);
  }
  /**
   * How solid new marks are (IL-079), and the selected ones with them (not
   * text: it stays solid). `step` false while a slider drags, after a
   * beginGesture, so the drag is one undo step.
   */
  setOpacity(e, t = !0) {
    const n = Math.round(Math.max(uI, Math.min(1, e)) * 100) / 100;
    if (this.s.opacity = n, this.s.tool !== "move") return;
    const s = this.working().strokes.filter((o) => this.s.selection.includes(o.id) && o.kind !== "text").map((o) => o.id);
    s.length && this.updateStrokes(s, (o) => ({ ...o, opacity: n }), t);
  }
  select(e) {
    this.s.selection = e;
  }
  /** Drop selected or edited marks that undo took away. */
  pruneSelection() {
    const e = new Set(this.working().strokes.map((n) => n.id));
    this.s.selection = this.s.selection.filter((n) => e.has(n)), this.s.editingText && !e.has(this.s.editingText) && (this.s.editingText = null);
    const t = new Set(this.working().pins.map((n) => n.id));
    this.s.editingPin && !t.has(this.s.editingPin) && (this.s.editingPin = null);
  }
  // ------ text blocks (Draw)
  /** A new block at `p`, open for writing. It and its first words are one undo step. */
  addText(e, t) {
    this.s.editingText && this.commitText(this.s.editingText);
    const n = { id: St(), kind: "text", color: this.s.color, size: t, pts: [e], text: "" };
    return this.addStroke(n), this.s.selection = [], this.s.editingText = n.id, this.newText = n.id, this.textBefore = "", n;
  }
  /** Open a block for writing again: this edit is one undo step. */
  editText(e) {
    if (this.s.editingText === e) return;
    this.s.editingText && this.commitText(this.s.editingText);
    const t = this.working().strokes.find((n) => n.id === e);
    !t || t.kind !== "text" || (this.beginGesture(), this.s.editingText = e, this.s.selection = [], this.newText = null, this.textBefore = t.text || "");
  }
  setText(e, t) {
    this.updateStrokes([e], (n) => ({ ...n, text: t }), !1);
  }
  /** Leaving a block. An empty new one never happened; an emptied old one is removed (undo brings it back). */
  commitText(e) {
    this.s.editingText === e && (this.s.editingText = null);
    const t = this.working().strokes.find((o) => o.id === e), n = this.newText === e;
    if (this.newText = null, !t) return;
    const s = (t.text || "").replace(/\s+$/, "");
    if (!s.trim()) {
      n ? this.revertStep() : this.editMarks((o) => ({ ...o, strokes: o.strokes.filter((r) => r.id !== e) }), !1);
      return;
    }
    s !== t.text && this.setText(e, s), !n && s === this.textBefore && this.dropGesture();
  }
  // ------ pins (Annotate)
  addPin(e, t) {
    if (!this.s.stageId) return null;
    this.s.editingPin && this.commitPin(this.s.editingPin);
    const n = { id: St(), x: e, y: t, text: "" };
    return this.editMarks((s) => ({ ...s, pins: [...s.pins, n] })), this.s.editingPin = n.id, this.newPin = n.id, this.pinBefore = "", n;
  }
  /** Open a pin's text: this edit is one undo step. */
  editPin(e) {
    if (this.s.editingPin === e) return;
    this.s.editingPin && this.commitPin(this.s.editingPin);
    const t = this.working().pins.find((n) => n.id === e);
    t && (this.beginGesture(), this.s.editingPin = e, this.newPin = null, this.pinBefore = t.text);
  }
  /** A pin dragged: `step` true on its first move, so the whole drag is one undo step. */
  movePin(e, t, n, s = !1) {
    this.editMarks((o) => ({ ...o, pins: o.pins.map((r) => r.id === e ? { ...r, x: t, y: n } : r) }), s);
  }
  setPinText(e, t) {
    this.editMarks((n) => ({ ...n, pins: n.pins.map((s) => s.id === e ? { ...s, text: t } : s) }), !1);
  }
  removePin(e) {
    this.editMarks((t) => ({ ...t, pins: t.pins.filter((n) => n.id !== e) })), this.s.editingPin === e && (this.s.editingPin = null), this.newPin === e && (this.newPin = null);
  }
  /** Leaving a pin's text. An empty new pin never happened; an emptied old one is removed. */
  commitPin(e) {
    this.s.editingPin === e && (this.s.editingPin = null);
    const t = this.newPin === e;
    this.newPin = null;
    const n = this.working().pins.find((s) => s.id === e);
    if (n) {
      if (!n.text.trim()) {
        t ? this.revertStep() : this.editMarks((s) => ({ ...s, pins: s.pins.filter((o) => o.id !== e) }), !1);
        return;
      }
      !t && n.text === this.pinBefore && this.dropGesture();
    }
  }
  // ------ undo, redo, clear
  /** Take the last step back as if it never happened: nothing to redo. */
  revertStep() {
    const e = this.s.stageId, t = e ? (this.undo.get(e) || []).pop() : void 0;
    !e || !t || (this.putMarks(e, t), this.s.histRev++, this.pruneSelection());
  }
  undoMark() {
    const e = this.s.stageId;
    if (!e) return;
    const t = (this.undo.get(e) || []).pop();
    if (!t) return;
    const n = this.redo.get(e) || [];
    n.push(Td(this.working())), this.redo.set(e, n), this.putMarks(e, t), this.s.histRev++, this.pruneSelection();
  }
  redoMark() {
    const e = this.s.stageId;
    if (!e) return;
    const t = (this.redo.get(e) || []).pop();
    if (!t) return;
    const n = this.undo.get(e) || [];
    n.push(Td(this.working())), this.undo.set(e, n), this.putMarks(e, t), this.s.histRev++, this.pruneSelection();
  }
  /** Clear all: every mark and note on the picture, as v1's Clear did (one undo step); its area stays. */
  clearMarks() {
    Zd(this.working()) && (this.finishEditing(), this.editMarks((e) => ({ ...Md(), ...e.area ? { area: e.area } : {} })), this.s.selection = []);
  }
  // ------ the area (the bar's Edit and Erase modes)
  /** The stage picture's selected area, as its steps. */
  area() {
    return this.working().area || [];
  }
  /** Whether the stage picture has an area selected. */
  hasArea() {
    return _I(this.working());
  }
  /** One more step of the area (a brush stroke, a lasso, an object): one undo step. */
  addAreaOp(e) {
    this.editMarks((t) => ({ ...t, area: [...t.area || [], e] }));
  }
  /** The area cleared (one undo step). */
  clearArea() {
    this.area().length && this.editMarks((e) => ({ strokes: e.strokes, pins: e.pins }));
  }
  /** The bar's mode: Edit (words, and an area to keep the change in), Erase, or Annotate (marks and notes). */
  setBar(e) {
    this.s.bar !== e && (this.finishEditing(), this.s.bar = e, this.s.selection = []);
  }
  /** Close whatever is being written. */
  finishEditing() {
    this.s.editingText && this.commitText(this.s.editingText), this.s.editingPin && this.commitPin(this.s.editingPin);
  }
  // ------ kept on the board
  /** A picture's marks or words changed here: saved after a pause. */
  changed(e) {
    this.dirty.add(e), clearTimeout(this.marksTimer), this.marksTimer = window.setTimeout(() => this.saveMarks(), t4);
  }
  /** Save what changed: each picture's marks and words in its one record, or none when it has neither. */
  saveMarks() {
    clearTimeout(this.marksTimer);
    const e = this.s.editingText || this.s.editingPin ? this.s.stageId : null;
    for (const t of Array.from(this.dirty)) {
      if (t === e) continue;
      this.dirty.delete(t);
      const n = this.s.marks[t], s = (this.s.asks[t] || "").trim() ? this.s.asks[t] : "", o = c_(t), r = this.board.studioRecords.get(o);
      if (!ub(n) && !s) {
        r && this.board.studioRecords.remove([o]);
        continue;
      }
      const a = {
        ...bl,
        id: o,
        type: "studio",
        role: "marks",
        sessionId: this.sessionId,
        target: t,
        marks: n ? Td(n) : Md(),
        ask: s,
        createdAt: r ? r.createdAt : Date.now()
      };
      this.board.studioRecords.put(a);
    }
    this.dirty.size && (this.marksTimer = window.setTimeout(() => this.saveMarks(), t4));
  }
  /** Marks and words saved on the board, for every picture you aren't changing here. */
  readMarks() {
    const e = {}, t = {};
    for (const a of this.board.studioRecords.forSession(this.sessionId))
      a.role === "marks" && (ub(a.marks) && (e[a.target] = a.marks), a.ask && (t[a.target] = a.ask));
    const n = { ...this.s.marks }, s = { ...this.s.asks };
    let o = !1;
    const r = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t), ...Object.keys(this.s.marks), ...Object.keys(this.s.asks)]);
    for (const a of r) {
      if (this.dirty.has(a)) continue;
      const l = e[a], d = this.s.marks[a];
      l && (!d || !Wue(l, d)) ? (n[a] = Td(l), o = !0) : !l && d && (delete n[a], o = !0), (t[a] || "") !== (this.s.asks[a] || "") && (t[a] ? s[a] = t[a] : delete s[a], o = !0);
    }
    o && (this.s.marks = n, this.s.asks = s, this.pruneSelection());
  }
  // ---------------------------------------------------------------- 3D
  /** A model file from your computer: kept in your Library where the host can, and shown. */
  async addModelFile(e) {
    const t = (e.name.split(".").pop() || "").toLowerCase();
    if (!["glb", "gltf", "obj", "stl"].includes(t)) {
      this.say(e.name + " isn't a model the 3D studio reads: use .glb, .gltf, .obj or .stl");
      return;
    }
    this.s.three.loading = !0, this.s.three.error = null;
    let n = "", s = null;
    const o = this.board.upload3d(e);
    try {
      if (o) {
        this.keeping.push(e.name), this.s.three.keeping = e.name;
        const a = await o;
        n = a.url, s = a.upload ? { upload: a.upload } : null;
      } else
        n = URL.createObjectURL(e);
    } catch (a) {
      this.keeping.length <= 1 && (this.s.three.loading = !1), this.say(Cd(a, e.name));
      return;
    } finally {
      o && (this.keeping.splice(this.keeping.indexOf(e.name), 1), this.s.three.keeping = this.keeping.length ? this.keeping[this.keeping.length - 1] : null);
    }
    const r = this.addModel({ name: e.name, url: n, ext: t, asset: s });
    this.files.set(r.id, e);
  }
  /** A 3D model picked in your Library. */
  addModelFromLibrary(e) {
    e.model3d && this.openModel({ name: e.label || "Model", url: e.model3d.url, ext: e.model3d.ext, asset: e.asset || null });
  }
  /** A model into the 3D view: the one this session has already, or a new one. */
  openModel(e) {
    const t = this.models3d.value.find((n) => n.url === e.url);
    t ? this.useModel(t.id) : this.addModel(e);
  }
  /**
   * A 3D model used as a picture (P3-02): its file is a model, not a picture,
   * so it opens in Generate's 3D view, as one picked in your Library does,
   * for a view of it to be captured as the picture. True when it was one.
   */
  as3d(e) {
    return e ? this.canUse("threed") ? (this.openModel(e), this.setStudio("threed"), this.say("Frame a view, then Capture to use it as a picture"), !0) : (this.say("A 3D model can't be used as a picture here"), !0) : !1;
  }
  /** An item in history, or the board's, used as a picture: as3d where it's a 3D model. */
  from3d(e) {
    const t = this.items.value.find((n) => n.id === e) || this.boardItems.value.find((n) => n.id === e);
    return this.as3d(t ? Ib(this.resultOf(t)) : null);
  }
  /** Bonneville Tower's massing, built in the viewer: a model to try the studio with. */
  addSample() {
    const e = this.models3d.value.find((t) => t.url === Cb);
    if (e) {
      this.s.three.model = e.id;
      return;
    }
    this.addModel({ name: "Bonneville massing", url: Cb, ext: "obj", asset: null });
  }
  addModel(e) {
    const t = {
      ...bl,
      id: St(),
      type: "studio",
      role: "model",
      sessionId: this.sessionId,
      createdAt: Date.now(),
      name: e.name,
      url: e.url,
      ext: e.ext,
      asset: e.asset,
      cameras: []
    };
    return this.board.studioRecords.put(t), this.s.three.model = t.id, this.s.three.cam = null, t;
  }
  /** The model's file, for the viewer: picked this visit, or read from where it's kept. */
  async modelFile(e) {
    const t = this.files.get(e.id);
    if (t) return t;
    if (e.url === Cb) return new Blob([yI()], { type: "text/plain" });
    const n = await fetch(e.url, { mode: "cors" }).catch(() => null);
    if (!n || !n.ok) throw new Error("This model's file couldn't be read. Bring it in again.");
    return n.blob();
  }
  useModel(e) {
    this.s.three.model !== e && (this.s.three.model = e, this.s.three.cam = null, this.s.three.error = null);
  }
  saveCamera() {
    const e = this.model3d.value, t = this.s.three.cam;
    if (!e || !t) return null;
    const n = { id: St(), name: "View " + (e.cameras.length + 1), cam: { ...t } };
    return this.board.studioRecords.patch(e.id, { cameras: [...e.cameras, n] }), n;
  }
  renameCamera(e, t) {
    const n = this.model3d.value;
    n && this.board.studioRecords.patch(n.id, { cameras: n.cameras.map((s) => s.id === e ? { ...s, name: t.trim() || s.name } : s) });
  }
  removeCamera(e) {
    const t = this.model3d.value;
    t && this.board.studioRecords.patch(t.id, { cameras: t.cameras.filter((n) => n.id !== e) });
  }
  /** A captured view's shape, width over height (the viewfinder's). */
  captureRatio() {
    const [e, t] = this.s.three.aspect.split(":").map(Number);
    return e > 0 && t > 0 ? e / t : 1;
  }
  /**
   * A 3D view captured as a picture: kept with your uploads, in history (a
   * history of its own), on the stage, and in the queue (at the end, or as
   * image 1 when it's what the run will start from). The same frame captured
   * a moment ago is used again rather than captured twice. Picking a view
   * leaves the 3D view for Prompt, as Use 3D did (CHAT-08); a run from the
   * view leaves once it goes (generate).
   */
  async captureView(e, t = !1) {
    const n = this.model3d.value, s = this.s.three.cam;
    if (!n || !s) return null;
    const o = JSON.stringify({ m: n.id, cam: $0(s), b: this.s.three.backdrop, a: this.s.three.aspect }), r = this.items.value.find((f) => f.kind === "ref" && f.how === "threed" && f.shot === o);
    if (r)
      return t ? this.setQueue(Dh(this.s.queue, r.id, this.limit.value).queue) : this.queued(r.id) || this.setQueue($h(this.s.queue, r.id, this.limit.value).queue), this.s.stageId = r.id, this.say("Using this view, already captured" + (this.queued(r.id) ? " as image " + this.queued(r.id) : "")), t || this.setStudio("prompt"), r;
    const a = new File([e.blob], "view.png", { type: "image/png" });
    let l;
    try {
      l = this.board.realRuns ? await this.board.uploadFile(a) : { url: await s4(a, Mb), asset: null };
    } catch (f) {
      return this.say(Cd(f, "The view")), null;
    }
    const d = n.cameras.find((f) => ype(f.cam, s)) || null, c = this.items.value.filter((f) => f.kind === "ref" && f.how === "threed").length + 1, h = this.addRef({
      how: "threed",
      url: l.url,
      w: e.w,
      h: e.h,
      label: d ? d.name : "View " + c,
      asset: l.asset,
      model: n.id,
      camera: d || { id: St(), name: "View " + c, cam: { ...s } },
      shot: o
    });
    if (!this.limit.value)
      this.say("Captured. " + this.modelName(this.genMode.value) + " takes no images");
    else {
      const f = t ? Dh(this.s.queue, h.id, this.limit.value) : $h(this.s.queue, h.id, this.limit.value);
      this.setQueue(f.queue), this.say(f.full ? "Captured. The queue is full" : "Captured as image " + (f.queue.indexOf(h.id) + 1));
    }
    return this.s.stageId = h.id, t || this.setStudio("prompt"), h;
  }
  // ---------------------------------------------------------------- what's sent
  /** The prompt the model gets: your words, then which image is which, then the notes by image and marker. */
  compileFor(e, t) {
    const n = [], s = t.trim();
    return s && n.push(s), e.length && n.push(e.length === 1 ? "Image 1 is the image to edit." : "Image 1 is the image to edit; the others are references."), n.push(...this.notesFor(e.map((o, r) => ({ it: o, n: r + 1 })))), n.join(`
`);
  }
  /** What to follow on the pictures sent, then each note by marker: `n` is the image each is sent as (a guide copy can come between). */
  notesFor(e) {
    const t = [], n = e.length === 1, s = e.some(({ it: a }) => this.marksOf(a).pins.some((l) => l.text.trim())), o = e.some(({ it: a }) => this.marksOf(a).strokes.length > 0), r = n ? "image" : "images";
    if (s || o) {
      const a = s && o ? "the numbered annotations and the annotations drawn on the " + r : s ? "the numbered annotations on the " + r : "the annotations drawn on the " + r;
      t.push("Follow " + a + ", then remove every annotation from the result.");
    }
    for (const { it: a, n: l } of e)
      this.marksOf(a).pins.forEach((d, c) => {
        d.text.trim() && t.push((n ? "Annotation " : "Image " + l + ", annotation ") + (c + 1) + ": " + d.text.trim());
      });
    return t;
  }
  /** The queue's images the dock's model takes, image 1 first. */
  sentFromQueue() {
    return this.queueItems.value.slice(0, Fue(this.s.queue, this.limit.value)).filter((e) => e.status === "done");
  }
  /** What goes with the queue's images: per image, how many marks and notes. */
  sending() {
    return this.sentFromQueue().map((e, t) => ({ image: t + 1, ...this.carried(e) })).filter((e) => e.marks || e.comments);
  }
  /** A picture's marks and notes, counted. */
  carried(e) {
    const t = this.marksOf(e);
    return { marks: t.strokes.length, comments: t.pins.filter((n) => n.text.trim()).length };
  }
  // ------ the Edit side's runs, in one shape (IL-073)
  /** What the bar sends: Erase on an eraser where the board has one, else an edit. */
  barKind() {
    if (this.s.bar !== "erase") return "edit";
    const e = this.modelOf("erase");
    return e && Ul(e) ? "erase" : "edit";
  }
  /** The bar's run, by its mode: words and the area (Edit), the area alone (Erase), marks and notes (Annotate). */
  barPlan() {
    const e = this.stage.value;
    if (!e || e.status !== "done") return null;
    const t = this.askOf(e.id), n = this.s.bar === "annotate" ? [] : this.area(), s = F_(n);
    if (this.s.bar === "erase") {
      const v = this.modelOf("erase");
      if (v && Ul(v)) {
        const x = TI(v);
        return {
          kind: "erase",
          model: v,
          pics: [{ kind: "item", item: e, marks: !1 }],
          words: "",
          compiled: "",
          inputs: this.editInputs("erase", v, { w: e.w, h: e.h }),
          count: this.countOf("erase"),
          base: e.id,
          mask: s ? { field: x.key, make: () => this.areaCanvas(e, n) } : null,
          settings: { label: "" }
        };
      }
    }
    const o = this.modelOf("edit");
    if (!o) return null;
    const r = this.s.bar === "erase", a = this.editInputs("edit", o, { w: e.w, h: e.h }), l = r ? 1 : this.countOf("edit"), d = this.sentRefs(), c = d.map((v) => ({ kind: "item", item: v, marks: !0 }));
    if (!s)
      return {
        kind: "edit",
        model: o,
        pics: [{ kind: "item", item: e, marks: !0 }, ...c],
        words: t,
        compiled: this.s.wordsOnly ? t.trim() : this.compileFor([e, ...d], t),
        inputs: a,
        count: l,
        base: e.id
      };
    const h = zo(o) >= 2, f = h ? [{ kind: "item", item: e, marks: !0 }, { kind: "made", name: "area", make: () => this.guideCanvas(e, n) }, ...c] : [{ kind: "made", name: "area", make: () => this.guideCanvas(e, n) }], p = [Que(t, { erase: r, guide: h })];
    h && (p.push(...this.notesFor([{ it: e, n: 1 }, ...d.map((v, x) => ({ it: v, n: x + 3 }))])), d.length && p.push(ehe(3, d.length)));
    const y = r || this.s.precision;
    return {
      kind: r ? "erase" : "edit",
      model: o,
      pics: f,
      words: r ? "" : t,
      compiled: this.s.wordsOnly && !r ? t.trim() : p.join(`
`),
      inputs: a,
      count: l,
      base: e.id,
      precision: y ? { area: n.map((v) => ({ ...v })) } : null,
      settings: r ? { label: "" } : null
    };
  }
  // ------ the full prompt (IL-076): what a run puts together, to see and change
  /** The prompt a run puts together, as its model gets it: your words, then which picture is which, then the notes. */
  fullPromptOf(e) {
    if (e === "prompt" || e === "threed") return this.s.wordsOnly ? this.s.prompt.trim() : this.compileFor(this.sentFromQueue(), this.s.prompt);
    const t = this.planFor(e);
    return t ? t.compiled : "";
  }
  /** Your change to a run's full prompt, while it holds: for the picture it was written on (the dock's for the session). */
  fullEdit(e) {
    const t = this.s.fullEdits[e];
    return t && t.on === this.fullScope(e) ? t.text : null;
  }
  /** Whether the prompt the run puts together has changed since you began changing yours. */
  fullDrifted(e) {
    const t = this.s.fullEdits[e];
    return !!t && t.on === this.fullScope(e) && t.from !== this.fullPromptOf(e);
  }
  /** Change a run's full prompt; back to just what the run puts together, it's yours no longer. */
  setFullEdit(e, t) {
    const n = this.fullPromptOf(e), s = this.s.fullEdits[e], o = { ...this.s.fullEdits };
    t === n ? delete o[e] : o[e] = { text: t, on: this.fullScope(e), from: s && s.on === this.fullScope(e) ? s.from : n }, this.s.fullEdits = o;
  }
  /** Back to the prompt the run puts together. */
  resetFullEdit(e) {
    if (!this.s.fullEdits[e]) return;
    const t = { ...this.s.fullEdits };
    delete t[e], this.s.fullEdits = t;
  }
  /** Whether this run can send your words alone: Generate's and the Edit bar's (a tool's prompt is its own words). */
  /**
   * Whether the full prompt (and its Send my words only switch) has something
   * to show: its words, your own version of them, or the switch on (R15:
   * with no typed words the switch emptied the prompt, which hid the panel
   * holding the switch).
   */
  fullShown(e) {
    return !!this.fullPromptOf(e).trim() || this.fullEdit(e) != null || this.s.wordsOnly && this.takesWordsOnly(e);
  }
  takesWordsOnly(e) {
    return e === "prompt" || e === "threed" || e === "edit";
  }
  /** Send my words only, on or off (CHAT-34), kept for next time. */
  setWordsOnly(e) {
    this.s.wordsOnly = e, Mpe(this.board.user.uid, e);
  }
  setFullOpen(e, t) {
    this.s.fullOpen = { ...this.s.fullOpen, [e]: t };
  }
  /** Your full prompt runs instead of the run's own: it's open, and you've changed it. Then the run's own button rests. */
  fullTakesOver(e) {
    return !!this.s.fullOpen[e] && this.fullEdit(e) != null;
  }
  /** What stops a run with your own full prompt: none written, what a tool needs besides words (Expand's frame), then the model's checks. */
  fullProblem(e, t) {
    if (!t.trim()) return "Write the prompt first";
    const n = this.stage.value;
    if (cb(e) && (!n || n.status !== "done")) return "Pick an image to edit first";
    if (e !== "edit" && e !== "erase" && cb(e)) {
      const s = this.tools.problem(e, !0);
      if (s) return s;
    }
    return this.checkOf(e, t).problem;
  }
  fullScope(e) {
    return e === "prompt" || e === "threed" ? null : this.s.stageId;
  }
  /** A change written for another picture than the one on the stage goes. */
  dropStaleEdits() {
    const e = { ...this.s.fullEdits };
    let t = !1;
    for (const n of Object.keys(e)) {
      const s = e[n];
      s && s.on !== this.fullScope(n) && (delete e[n], t = !0);
    }
    t && (this.s.fullEdits = e);
  }
  // ------ the bar's references (IL-075)
  /** Whether the bar's run takes references: an edit on a model that reads more than one picture (the eraser reads one, and a mask). */
  takesRefs() {
    if (this.barKind() === "erase") return !1;
    const e = this.modelOf("edit");
    return !!e && zo(e) >= 2;
  }
  /** How many references the bar's run sends: its model's pictures, less the one it edits and an area's guide copy. */
  refRoom() {
    const e = this.modelOf("edit");
    if (!e || !this.takesRefs()) return 0;
    const t = this.s.bar !== "annotate" && F_(this.area());
    return Math.max(0, zo(e) - 1 - (t ? 1 : 0));
  }
  /** The references the bar's run sends: as many as its model has room for, never the picture on the stage itself. */
  sentRefs() {
    const e = this.stage.value;
    return this.editRefItems.value.filter((t) => !e || t.id !== e.id).slice(0, this.refRoom());
  }
  /** Whether a reference goes with the next run (one past the model's room, or on the stage, waits). */
  refSent(e) {
    return this.sentRefs().some((t) => t.id === e);
  }
  /**
   * A picture as one of the edit's references: from history (another
   * session's comes in first), a version, the slot's picker or an upload.
   * One already there isn't added twice; its tile pulses instead.
   */
  addEditRef(e) {
    if (this.from3d(e)) return "none";
    const t = this.bringIn(e);
    if (!t || t.status !== "done") return "none";
    const n = this.stage.value;
    if (n && t.id === n.id)
      return this.say("That's the picture you're editing"), "stage";
    if (this.s.editRefs.includes(t.id))
      return this.pulseRef(t.id), "have";
    if (!this.takesRefs())
      return this.say(this.refsRefused()), "none";
    const s = this.refRoom();
    return this.editRefItems.value.filter((r) => !n || r.id !== n.id).length >= s ? (this.say(s ? this.modelName("edit") + " takes " + s + (s === 1 ? " reference" : " references") + " here: remove one first" : "No room for a reference while an area is selected"), "full") : (this.s.editRefs = [...this.s.editRefs, t.id], this.pulseRef(t.id), "added");
  }
  /**
   * A picture by its address, from the slot's picker (a pinned picture, the
   * board's, your Library's, an upload): the one here already, else brought in.
   */
  async addEditRefUrl(e) {
    const t = this.items.value.find((o) => o.url === e && o.status === "done") || this.boardItems.value.find((o) => o.url === e && o.status === "done");
    if (t) return this.addEditRef(t.id) === "added";
    const n = await Promise.race([Id(e), new Promise((o) => window.setTimeout(() => o({ w: 4, h: 3 }), 2500))]), s = this.addRef({ how: this.howPicked(e), url: e, w: n.w, h: n.h, label: "Reference", asset: this.board.assetFor(e) });
    return this.addEditRef(s.id) === "added";
  }
  /**
   * How a picture picked by its address came in: from the board when it's
   * there (a picture on it, or one you've pinned), which history leaves to
   * where it is; else as its record says, an upload or a Library generation,
   * which history shows, as nothing else does.
   */
  howPicked(e) {
    if (this.board.isPinnedImage(e)) return "board";
    for (const n of this.board.store.all()) if (n.type === "image" && n.src === e) return "board";
    const t = this.board.assetFor(e);
    return t && "nodeRunResult" in t ? "library" : "upload";
  }
  /**
   * A picture dropped on Generate's queue, from history or a version
   * (CHAT-06), as the Edit bar takes one: brought in, and queued.
   */
  queueItem(e) {
    if (this.refuseVideo(e) || this.from3d(e)) return;
    const t = this.bringIn(e);
    t && !this.queued(t.id) && this.add(t.id);
  }
  /**
   * The queue holds pictures (a Video Edit model's video is the one on the
   * session's card): a video dragged onto it, or added from its preview, is
   * turned away, rather than sent as an image input.
   */
  refuseVideo(e) {
    const t = this.items.value.find((s) => s.id === e) || this.boardItems.value.find((s) => s.id === e), n = t ? this.resultOf(t) : null;
    return t && af(t.url) ? (this.say("The queue takes pictures, not 3D models"), !0) : !n || !(n.video || n.kind === "video") ? !1 : (this.say("The queue takes pictures, not videos"), !0);
  }
  /** A picture by its address, from the queue's picker (a pinned picture, the board's, your Library's, an upload): queued. */
  async queueUrl(e) {
    const t = this.items.value.find((o) => o.url === e && o.status === "done") || this.boardItems.value.find((o) => o.url === e && o.status === "done");
    if (t) {
      this.queueItem(t.id);
      return;
    }
    const n = await Promise.race([Id(e), new Promise((o) => window.setTimeout(() => o({ w: 4, h: 3 }), 2500))]), s = this.addRef({ how: this.howPicked(e), url: e, w: n.w, h: n.h, label: "Reference", asset: this.board.assetFor(e) });
    this.queued(s.id) || this.add(s.id);
  }
  removeEditRef(e) {
    this.s.editRefs = this.s.editRefs.filter((t) => t !== e);
  }
  /** Why the bar takes no references right now. */
  refsRefused() {
    return this.barKind() === "erase" ? "Erase takes no references" : this.modelName("edit") + " takes one picture: the one you're editing";
  }
  pulseRef(e) {
    const t = (this.s.refPulse ? this.s.refPulse.n : 0) + 1;
    this.s.refPulse = { id: e, n: t }, window.setTimeout(() => {
      this.s.refPulse && this.s.refPulse.n === t && (this.s.refPulse = null);
    }, 900);
  }
  /**
   * The eyedropper, on or off: on, a click on a picture in history (or a
   * version) makes it a reference on the Edit side, and queues it for the
   * next image on the Generate side (CHAT-10: both rows pick the same way).
   */
  setDropper(e) {
    if (e && this.side.value === "edit" && !this.takesRefs()) {
      this.say(this.refsRefused());
      return;
    }
    if (e && this.side.value !== "edit" && !this.limit.value) {
      this.say(this.modelName(this.genMode.value) + " works from words alone");
      return;
    }
    this.s.dropper = e, e && this.s.histShut && this.setHistShut(!1);
  }
  /** Fold history down to a slim rail (the stage takes the room), or bring it back; remembered for next time. */
  setHistShut(e) {
    this.s.histShut !== e && (this.s.histShut = e, Cpe(this.board.user.uid, e));
  }
  /** A pick with the eyedropper: the picture becomes a reference, or joins the queue, and the eyedropper goes (it stays for another try on the picture being edited). */
  dropperPick(e) {
    if (this.side.value !== "edit") {
      this.queueItem(e), this.s.dropper = !1;
      return;
    }
    this.addEditRef(e) !== "stage" && (this.s.dropper = !1);
  }
  /** What stops the bar's run before the model's own checks: nothing to send yet, or no area to erase. */
  barProblem() {
    const e = this.stage.value;
    if (!e || e.status !== "done") return "Pick an image to edit first";
    const t = this.askOf(e.id).trim(), n = Zd(this.marksOf(e));
    return this.s.bar === "erase" ? this.hasArea() ? null : "Paint over what should go first" : this.s.bar === "edit" && this.hasArea() && !t ? "Say what to change in the area" : !t && !n ? this.s.bar === "annotate" ? "Annotate the image, or say what to change" : "Say what to change, or select an area" : null;
  }
  /** A run's plan: the bar's or a tool's. */
  planFor(e) {
    return e === "edit" || e === "erase" ? this.barPlan() : this.tools.plan(e);
  }
  /** A plan's prompt state before anything is made or uploaded: stand-ins for what's still to make. */
  previewOf(e) {
    const t = e.pics.map((s, o) => s.kind === "item" ? { url: s.item.url, asset: s.item.asset || null } : { url: "made:" + o + ":" + s.name, asset: null }), n = _d(e.model, { prompt: e.compiled, ...Tb(e.ref), inputs: e.inputs, n: e.count }, t);
    return e.mask ? { ...n, masks: { [e.mask.field]: { boardMask: "pending" } } } : n;
  }
  /** The area as a mask the picture's size (capped), white where it is. */
  async areaCanvas(e, t) {
    const n = wl(e.w, e.h, 4096);
    return zp(t, n.w, n.h, await this.mapsFor(t));
  }
  /** The picture with the area marked in magenta, for a model that reads pictures, not masks. */
  async guideCanvas(e, t) {
    const n = await si(e.url), s = wl(n.width, n.height, 2048);
    return fhe(n, zp(t, s.w, s.h, await this.mapsFor(t)));
  }
  /** The segment maps an area's picked objects come from, read. */
  async mapsFor(e) {
    const t = /* @__PURE__ */ new Map();
    for (const n of EI(e)) t.set(n, await Rf(n));
    return t;
  }
  modelName(e) {
    const t = this.modelOf(e);
    return t ? t.name : "This model";
  }
  /** A run's words, pictures and settings as the model's form has them (before marks are flattened and masks made). */
  previewUp(e, t = null) {
    if (cb(e)) {
      const a = this.planFor(e);
      if (a) return { model: a.model, count: a.count, up: this.previewOf(t != null ? { ...a, compiled: t } : a) };
      const l = this.modelOf(e);
      if (!l) return null;
      const d = this.countOf(e), c = this.stage.value, h = c ? [{ url: c.url, asset: c.asset || null }] : [];
      return { model: l, count: d, up: _d(l, { prompt: "", inputs: this.editInputs(e, l, c ? { w: c.w, h: c.h } : null), n: d }, h) };
    }
    const n = this.modelOf(e);
    if (!n) return null;
    const s = this.countOf(e), o = this.sentFromQueue(), r = o.map((a) => ({ url: a.url, asset: a.asset || null }));
    return { model: n, count: s, up: _d(n, { prompt: t != null ? t : this.compileFor(o, this.s.prompt), ...Tb(this.ownRef(e, n)), inputs: this.inputsOf(e), n: s }, r) };
  }
  /**
   * The sizes an Edit run can be made at, keeping its picture's shape
   * (TD-10): Nano Banana Pro's 1K, 2K and 4K. The bar hides the shape chip,
   * so this is where the size is chosen.
   */
  tiersOf(e) {
    const t = this.modelOf(e), n = e === "prompt" ? null : this.shapeSource(e);
    return t && n ? KC(t, n.w, n.h) : [];
  }
  /**
   * The size you chose, else the smallest; but a Precision edit, whose result
   * keeps the picture's own pixels outside its area, defaults to the
   * picture's own size (P3-04): the smallest at least as big, or the biggest.
   */
  tierOf(e) {
    if (e === "prompt") return 0;
    const t = this.s.modes[e].tier;
    if (t != null) return t;
    if (!((e === "edit" || e === "erase") && this.s.bar !== "annotate" && this.hasArea() && (this.s.bar === "erase" || this.s.precision))) return 0;
    const s = this.shapeSource(e), o = this.tiersOf(e), r = s ? o.findIndex((a) => a.px >= s.w * s.h) : -1;
    return r >= 0 ? r : Math.max(0, o.length - 1);
  }
  setTier(e, t) {
    e !== "prompt" && (this.s.modes[e] = { ...this.s.modes[e], tier: t });
  }
  /** A model's settings that aren't chips (the bar's More settings, TD-10): what ModelFields lays out under More. */
  advancedOf(e) {
    const t = this.modelOf(e);
    return t ? t.fields.filter((n) => n.placement === "advanced" && n.kind !== "seed" && n.kind !== "header" && n.kind !== "model" && n.kind !== "video") : [];
  }
  /** The shape a studio's result keeps: an Edit studio's picture's, 3D's frame's. */
  shapeSource(e) {
    if (e === "threed") return { w: Math.round(1e3 * this.captureRatio()), h: 1e3 };
    const t = this.stage.value;
    return t ? { w: t.w, h: t.h } : null;
  }
  /** A field's value by what it is (the tools read their model's scale this way). */
  valueOfKey(e, t) {
    const n = this.modelOf(e);
    if (!n) return;
    const s = n.fields.find((o) => o.raw && o.raw.boardKey === t || o.key === t || o.label.toLowerCase().includes(t));
    return s ? this.valueOf(e, s) : void 0;
  }
  /** An Edit run's or 3D's inputs: its own, with the shape kept to its picture's (at the size you chose) unless you chose one. */
  editInputs(e, t, n) {
    const s = this.inputsOf(e), o = n ? Ene(t, n.w, n.h, this.tierOf(e)) : null;
    return o && s[o.key] === void 0 && (s[o.key] = o.value), s;
  }
  /** What stops a studio's run, in v1's words; null when it can go. */
  problemOf(e) {
    return this.checkOf(e).problem;
  }
  /** What stops a studio's run, and whether it's only the tokens it costs (Run then offers to get more, as the board's does). */
  checkOf(e, t = null) {
    const n = this.previewUp(e, t);
    if (!n) return { problem: "No model is available for this.", tokens: !1 };
    const s = Xi(n.model, n.up, n.count, !!this.board.user.isAdmin);
    if (s.problems[0]) return { problem: s.problems[0], tokens: !1 };
    const o = this.board.tokensProblem(s.price);
    return { problem: o || null, tokens: !!o };
  }
  /** A studio's run's cost, as the board writes tokens. */
  priceOf(e) {
    const t = this.previewUp(e);
    if (!t) return "";
    const n = Xi(t.model, t.up, t.count, !!this.board.user.isAdmin);
    return n.price != null ? El(n.price) : t8(t.model, t.count);
  }
  // ------ what you ask an Edit studio to change, kept with the picture
  askOf(e) {
    return e && this.s.asks[e] || "";
  }
  setAsk(e, t) {
    const n = { ...this.s.asks };
    t ? n[e] = t : delete n[e], this.s.asks = n, this.changed(e);
  }
  // ------ the dock's words: your session prompt's
  setPrompt(e) {
    this.s.prompt = e, clearTimeout(this.promptTimer), this.promptTimer = window.setTimeout(() => this.commitPrompt(), 450);
  }
  commitPrompt() {
    clearTimeout(this.promptTimer), this.s.prompt !== this.promptBase && (this.promptBase = this.s.prompt, (this.board.promptOf(this.sessionId).prompt || "") !== this.s.prompt && this.board.setPrompt(this.sessionId, { prompt: this.s.prompt }));
  }
  // ------ runs
  /** Runs of yours in flight from here: being got ready, or sent and not all back. */
  busy() {
    return this.s.sending > 0 || this.items.value.some((e) => e.status === "pending" && !!e.runId && this.awaiting.has(e.runId));
  }
  /**
   * The dock's run (the Generate side): the queue, image 1 first, and the
   * words, on the open studio's model. Generate makes new images, each the
   * start of a history of its own; history shows the session.
   */
  async generate(e = null) {
    this.commitPrompt(), this.finishEditing();
    const t = this.genMode.value, n = this.modelOf(t);
    if (!n)
      return this.say("No model is available for this session"), !1;
    const s = this.sentFromQueue(), o = this.s.prompt, r = t === "threed" ? this.editInputs(t, n, s[0] ? { w: s[0].w, h: s[0].h } : this.shapeSource(t)) : this.inputsOf(t), a = await this.run({
      kind: t,
      model: n,
      pics: s.map((l) => ({ kind: "item", item: l, marks: !0 })),
      words: o,
      compiled: e != null ? e : this.s.wordsOnly ? o.trim() : this.compileFor(s, o),
      inputs: r,
      count: this.countOf(t),
      base: null,
      ref: this.ownRef(t, n)
    });
    return a && t === "threed" && this.s.studio === "threed" && this.setStudio("prompt"), a;
  }
  /**
   * Your session's own first input, sent as it is, where Prompt's model's
   * first input isn't a picture (a Video Edit model's video: the queue holds
   * pictures, so the video is the one set on the session's card), with its
   * record, so a run sends it as it is. Null otherwise: the queue's pictures
   * fill a picture input.
   */
  ownRef(e, t) {
    if (e !== "prompt") return null;
    const n = t.fields.find((o) => o.placement === "reference");
    if (!n || oo(t).includes(n)) return null;
    const s = this.board.promptOf(this.sessionId);
    return s.ref ? { url: s.ref, asset: s.assets && s.assets[s.ref] || this.board.assetFor(s.ref) } : null;
  }
  /**
   * The bar's run (IL-073): the picture on the stage, by the bar's mode (its
   * words and area, its area to erase, its marks and notes), on the bar's
   * model. Its results are the picture's next versions, in its history; the
   * first takes the stage. Your own full prompt (IL-076) goes instead of the
   * one the bar puts together, and is all it needs to go.
   */
  async generateEdit(e = null) {
    const t = this.stage.value;
    if (!t || t.status !== "done")
      return this.say("Pick an image to edit first"), !1;
    this.finishEditing();
    const n = e != null ? null : this.barProblem();
    if (n)
      return this.say(n), !1;
    const s = this.barPlan();
    return s ? this.run(e != null ? { ...s, compiled: e } : s) : (this.say("No model is available for this"), !1);
  }
  /**
   * Get a run ready and send it: stand-ins in history at once, marked
   * pictures flattened, pictures and a mask made here uploaded, then the
   * board's run path. Its first result takes the stage when it lands, unless
   * you've moved on; a Precision edit's is put back inside its area first.
   */
  async run(e) {
    const t = Xi(e.model, this.previewOf(e), e.count, !!this.board.user.isAdmin), n = t.problems[0] || this.board.tokensProblem(t.price);
    if (n)
      return this.say(n.replace(/\.$/, "")), !1;
    this.reveal();
    const s = Date.now(), o = [], r = e.base && this.items.value.find((d) => d.id === e.base) || null;
    if (!e.helper) {
      const d = Ab(e.words, 5) || e.settings && typeof e.settings.label == "string" && e.settings.label || hb[e.kind] || "New image";
      for (let c = 0; c < e.count; c++)
        o.push({
          id: "sending:" + St(),
          kind: "gen",
          url: "",
          w: r ? r.w : 4,
          h: r ? r.h : 3,
          createdAt: s + c,
          parentId: e.base,
          label: d,
          status: "pending"
        });
    }
    this.s.ghosts = [...o, ...this.s.ghosts], this.s.sending++;
    const a = this.s.stageId, l = this.draftOf(a);
    try {
      const d = [];
      for (const f of e.pics) d.push(f.kind === "item" ? await this.pictureToSend(f.item, f.marks) : await this.madeToSend(await f.make(), f.name));
      let c = _d(e.model, { prompt: e.compiled, ...Tb(e.ref), inputs: e.inputs, n: e.count }, d);
      e.mask && (c = { ...c, masks: { [e.mask.field]: await this.maskToSend(await e.mask.make()) } });
      const h = await this.board.runStudio({
        sessionId: this.sessionId,
        model: e.model,
        up: c,
        count: e.count,
        words: e.words,
        edit: e.base ? { base: e.base, studio: e.kind, settings: e.settings || null, helper: !!e.helper, precision: e.precision || null } : null,
        onFail: (f) => {
          e.helper && e.base && this.objectsFailed(e.base), this.say(f);
        }
      });
      return "error" in h ? (this.say(h.error.replace(/\.$/, "")), !1) : (this.awaiting.set(h.runId, { stageWas: a, base: e.base, helper: !!e.helper, precision: e.precision || null, finished: /* @__PURE__ */ new Set(), draft: l }), !0);
    } catch (d) {
      return this.say(d instanceof Error && d.message.replace(/\.$/, "") || "The run couldn't start. Please try again"), !1;
    } finally {
      this.s.sending = Math.max(0, this.s.sending - 1);
      const d = new Set(o.map((c) => c.id));
      this.s.ghosts = this.s.ghosts.filter((c) => !d.has(c.id));
    }
  }
  /**
   * A picture as a run sends it: as it is, or with its marks flattened in (by
   * v1's annotation service on a real board, by the browser in the harness).
   */
  async pictureToSend(e, t = !0) {
    const n = e.asset || this.board.assetFor(e.url), s = this.s.marks[e.id];
    if (!t || !Zd(s)) return { url: e.url, asset: n };
    const o = { strokes: s.strokes, pins: s.pins }, r = e.id + ":" + JSON.stringify(o), a = this.flat.get(r);
    if (a) return a;
    let l;
    if (this.board.canAnnotate) {
      const d = await this.board.flattenPicture({ url: e.url, asset: n }, await jue(o, e.w, e.h));
      l = { url: d.url, asset: d.asset };
    } else
      l = { url: await Hue(e.url, o, e.w, e.h), asset: null };
    return this.flat.set(r, l), l;
  }
  /** A picture made for a run (the area's guide): into your uploads on a real board, a small copy in the harness. */
  async madeToSend(e, t) {
    if (!this.board.realRuns) return { url: gb(e, Mb, !1), asset: null };
    const n = await this.board.uploadFile(mb(await fb(e, !1), "board-" + t));
    return { url: n.url, asset: n.asset };
  }
  /** An area's mask for a run: kept as one of your masks on a real board (v1's inpainting masks), a stand-in in the harness. */
  async maskToSend(e) {
    return this.board.realRuns ? this.board.uploadMask(mb(await fb(e, !0), "board-mask")) : { boardMask: gb(e, 512, !0) };
  }
  /**
   * Runs sent from here: the first result takes the stage, unless you've
   * moved on or are writing. A helper run's result is the picture's objects;
   * a Precision edit's results are put back inside the area first.
   */
  landResults() {
    for (const [t, n] of Array.from(this.awaiting)) {
      const s = this.board.results.ofRun(t), o = s.filter((l) => l.status === "done" && !!l.url).sort((l, d) => l.createdAt - d.createdAt), r = s.some((l) => l.status === "pending");
      if (!o.length) {
        r || (this.awaiting.delete(t), n.helper && n.base && this.objectsFailed(n.base));
        continue;
      }
      if (n.helper) {
        this.awaiting.delete(t), n.base && this.objectsFound(n.base, o[0].url, t);
        continue;
      }
      if (n.precision) {
        for (const l of o)
          n.finished.has(l.id) || (n.finished.add(l.id), this.finishPrecision(l, n, n.finished.size === 1));
        r || this.awaiting.delete(t);
        continue;
      }
      this.awaiting.delete(t), !(this.s.editingText || this.s.editingPin || this.s.stageId !== n.stageWas || this.startedSince(n)) && (this.s.stageId = o[0].id, this.s.selection = []);
    }
    const e = this.hidden(this.board.studioRecords.forSession(this.sessionId));
    for (const t of this.board.results.list(this.sessionId)) {
      if (t.status !== "done" || !t.url || !t.runId || this.awaiting.has(t.runId) || this.resumed.has(t.id) || e.has(t.id)) continue;
      const n = this.board.studioRecords.get(Ap(t.runId));
      !n || n.role !== "edit" || !n.precision || n.updatedBy !== this.board.user.uid || this.finishPrecision(t, { stageWas: null, base: n.base, helper: !1, precision: n.precision, finished: /* @__PURE__ */ new Set(), draft: "" }, !1);
    }
  }
  /** A picture's words and marks (its area among them), to tell later whether they've changed. */
  draftOf(e) {
    if (!e) return "";
    const t = Object.values(this.s.fullEdits).filter((n) => !!n && n.on === e).map((n) => n.text);
    return JSON.stringify([this.s.asks[e] || "", this.s.marks[e] || null, t]);
  }
  /**
   * Whether you've started something on the picture a run went from since
   * it went: a tool's change not applied yet, or new words, marks or an
   * area. Its result then waits in history rather than take the stage (and
   * a tool's change isn't dropped without asking, as show() would ask).
   */
  startedSince(e) {
    return !!this.tools && this.tools.pending() || this.draftOf(e.stageWas) !== e.draft;
  }
  /**
   * A Precision edit's result put back inside its area, every other pixel
   * the original's, as a version of its own that stands in for the result
   * (which history then hides). If it can't be, the result shows as it came.
   */
  async finishPrecision(e, t, n) {
    this.resumed.add(e.id);
    const s = t.base ? this.items.value.find((a) => a.id === t.base) : null;
    if (!s || !t.precision) return;
    this.s.finishing = [...this.s.finishing, e.id];
    const o = { id: "finishing:" + e.id, kind: "gen", url: "", w: s.w, h: s.h, createdAt: e.createdAt, parentId: s.id, label: "Precision", status: "pending" };
    this.s.ghosts = [o, ...this.s.ghosts];
    const r = this.s.stageId;
    try {
      const [a, l] = await Promise.all([si(s.url), si(e.url)]), d = wl(a.width, a.height), c = zp(t.precision.area, d.w, d.h, await this.mapsFor(t.precision.area)), h = dhe(a, l, c, Math.max(2, Math.max(d.w, d.h) * 6e-3)), f = await this.addVersion(h, { tool: "precision", label: "Precision", from: e.id }, s, { stage: !1, name: this.labelOf(e), at: e.createdAt }), p = this.s.stageId !== r && this.s.stageId !== t.stageWas;
      f && n && !p && !this.s.editingText && !this.s.editingPin && !this.startedSince(t) && (this.s.stageId = f.id);
    } catch (a) {
      console.warn("[board] a Precision edit couldn't be put back inside its area", a), this.say("The edit couldn't be kept to its area, so it shows as it came back"), n && this.s.stageId === t.stageWas && !this.startedSince(t) && (this.s.stageId = e.id);
    } finally {
      this.s.finishing = this.s.finishing.filter((a) => a !== e.id), this.s.ghosts = this.s.ghosts.filter((a) => a.id !== o.id);
    }
  }
  /**
   * A version made here by a tool (IL-073): kept in your uploads on a real
   * board (a small copy in the harness), a reference whose parent is the
   * picture it was made from, with how it was made. It takes the stage.
   */
  async addVersion(e, t, n, s = {}) {
    const o = s.alpha != null ? s.alpha : CI(e);
    let r;
    try {
      r = this.board.realRuns ? await this.board.uploadFile(mb(await fb(e, o), "board-" + t.tool)) : { url: gb(e, bpe, o), asset: null };
    } catch (l) {
      return this.say(Cd(l, "The new version")), null;
    }
    const a = this.addRef({ how: "tool", url: r.url, w: e.width, h: e.height, label: s.name || t.label, asset: r.asset, base: n.id, made: t }, s.at);
    return s.stage !== !1 && (this.finishEditing(), this.s.stageId = a.id, this.s.selection = []), a;
  }
  // ------ a picture's objects (Select)
  /** The stage picture's objects: found already (here, or by an earlier visit's run), being found, or not yet. */
  objectsOf(e) {
    if (!e) return null;
    const t = this.s.objects[e];
    if (t) return t;
    this.board.results.rev.value;
    for (const n of this.board.studioRecords.forSession(this.sessionId)) {
      if (n.role !== "edit" || !n.helper || n.base !== e) continue;
      const s = this.board.results.ofRun(n.runId).find((o) => o.status === "done" && !!o.url);
      if (s) return { status: "ready", url: s.url, runId: n.runId };
    }
    return null;
  }
  /** Find the stage picture's objects, once: a run of the segmentation model, whose result is never shown. */
  async findObjects() {
    const e = this.stage.value;
    if (!e || e.status !== "done") return !1;
    const t = this.objectsOf(e.id);
    if (t && t.status !== "failed") return t.status === "ready";
    const n = this.modelOf("select");
    if (!n)
      return this.say("Picking objects isn't available here yet: paint or draw round the area instead"), !1;
    this.s.objects = { ...this.s.objects, [e.id]: { status: "finding" } };
    const s = await this.run({
      kind: "select",
      model: n,
      pics: [{ kind: "item", item: e, marks: !1 }],
      words: "",
      compiled: "",
      inputs: this.inputsOf("select"),
      count: 1,
      base: e.id,
      helper: !0,
      settings: { label: "Objects" }
    });
    return s || this.objectsFailed(e.id), s;
  }
  objectsFound(e, t, n) {
    this.s.objects = { ...this.s.objects, [e]: { status: "ready", url: t, runId: n } }, Rf(t).catch((s) => {
      console.warn("[board] the picture's objects couldn't be read", s), this.objectsFailed(e);
    });
  }
  /** The picture's objects couldn't be found, or their map couldn't be read: Select offers to try again. */
  objectsFailed(e) {
    this.s.objects = { ...this.s.objects, [e]: { status: "failed" } };
  }
  // ---------------------------------------------------------------- Promote: which version the canvas shows
  /** A card on the canvas showing a picture from this history: the one you came in from first. */
  cardFor(e) {
    if (!e.length) return null;
    const t = (s) => e.some((o) => this.cardShows(s, o)), n = this.s.cardId ? this.board.store.get(this.s.cardId) : void 0;
    if (n && n.type === "image" && t(n)) return n;
    for (const s of this.board.store.all()) if (s.type === "image" && t(s)) return s;
    return null;
  }
  /** Whether a card shows this picture: its result, or the same picture (a reference copies another's). */
  cardShows(e, t) {
    return e.resultId && (e.resultId === t.id || e.resultId === t.source) ? !0 : !e.resultId && !!t.url && e.src === t.url;
  }
  /** The picture the card on the canvas shows now, if it's one of the stage's history. */
  onCard(e) {
    this.board.docRev.value;
    const t = this.card.value, n = this.items.value.find((s) => s.id === e);
    return !!t && !!n && this.cardShows(t, n);
  }
  /** Show this version on the canvas, in the card's place (Tyler, 2026-10-13). */
  promote(e) {
    const t = this.card.value, n = this.items.value.find((a) => a.id === e);
    if (!t || !n || n.status !== "done" || this.cardShows(t, n)) return;
    const s = n.kind === "gen" ? n.id : n.how === "board" && n.source ? n.source : null, o = s ? this.board.results.get(s) : void 0;
    this.board.showOnCard(t.id, {
      url: n.url,
      w: n.w,
      h: n.h,
      label: n.label,
      resultId: s,
      sessionId: n.kind === "gen" ? this.sessionId : t.sessionId || null,
      asset: n.asset || null,
      fav: o ? !!o.fav : !1
    }) && this.say((this.names.value.get(e) || "This version") + " is on the board now");
  }
  // ---------------------------------------------------------------- info and the board
  /** The board's info view, over the Studios view, for a generation (this session's, or another's on the board). */
  openInfo(e) {
    const t = this.itemById(e);
    if (!t || t.kind !== "gen" || t.status !== "done") return !1;
    const n = this.board.placedFor(e);
    return this.board.ui.infoSession = t.sessionId || this.sessionId, this.board.ui.infoAt = n ? n.id : "result:" + e, !0;
  }
  placeOnBoard(e) {
    const t = this.itemById(e);
    if (!(!t || t.status !== "done")) {
      if (t.kind === "gen" && t.result) {
        if (this.board.placedFor(e)) {
          this.say("Already on the board");
          return;
        }
        this.board.placeResult(t.result);
      } else {
        const s = 360 / Math.max(t.w, t.h);
        this.board.placeImages([{ url: t.url, w: Math.round(t.w * s), h: Math.round(t.h * s), label: t.label, asset: t.asset || void 0 }]);
      }
      this.say("Placed on the board");
    }
  }
  /** References, and your own results (a real board lets you delete only yours, as v1 does). */
  canDelete(e) {
    const t = this.items.value.find((n) => n.id === e);
    return !t || t.status === "pending" ? !1 : t.kind === "ref" ? !0 : !!t.result && (this.board.canDelete(t.result) || !this.board.realRuns);
  }
  async deleteItem(e) {
    const t = this.items.value.find((s) => s.id === e);
    if (!t || !this.canDelete(e)) return;
    if (t.kind === "ref")
      this.board.studioRecords.remove([e]), this.board.trashRev.value++, this.board.toast("Picture deleted. It waits in Recently Deleted.");
    else if (t.result)
      if (this.board.realRuns) {
        if (!await this.board.deleteResult(t.result)) return;
      } else
        this.board.results.remove([e]), this.board.binResult(t.result);
    const n = c_(e);
    if (this.board.studioRecords.has(n) && this.board.studioRecords.remove([n]), this.s.queue.includes(e) && this.setQueue(R_(this.s.queue, e)), this.s.stageId === e) {
      const s = this.family.value.find((o) => o.id !== e && o.status === "done");
      this.s.stageId = s ? s.id : null;
    }
  }
  say(e) {
    clearTimeout(this.noteTimer), this.s.note = { id: Date.now(), text: e }, this.noteTimer = window.setTimeout(() => {
      this.s.note = null;
    }, 3200);
  }
  /** Leaving: what's typed and drawn is saved. */
  leave() {
    this.s.dropper = !1, this.finishEditing(), this.commitPrompt(), this.saveMarks();
  }
  dispose() {
    this.leave(), this.tools.dispose(), this.scope.stop(), clearTimeout(this.noteTimer), clearTimeout(this.promptTimer), clearTimeout(this.marksTimer);
  }
}
function Tb(i) {
  return i ? { ref: i.url, assets: i.asset ? { [i.url]: i.asset } : {} } : {};
}
const Cb = "sample:bonneville-massing";
function n4(i) {
  return {
    id: i.id,
    kind: "ref",
    how: i.how,
    url: i.url,
    w: i.pw || 4,
    h: i.ph || 3,
    createdAt: i.createdAt,
    parentId: i.base || null,
    label: i.label,
    status: "done",
    source: i.source || void 0,
    asset: i.asset || null,
    camera: i.camera || null,
    shot: i.shot || void 0,
    modelId: i.model || void 0,
    made: i.made || null
  };
}
function Ib(i) {
  if (!i || i.kind !== "3d" || !i.download) return null;
  const e = (/\.([a-z0-9]+)$/i.exec(decodeURIComponent(i.download.split("?")[0])) || ["", "glb"])[1].toLowerCase();
  return { name: i.label || "Model", url: i.download, ext: e, asset: i.asset || null };
}
function i4(i, e) {
  return i.status === "moderated" || i.status === "done" && !i.url ? !1 : !e.has(i.id) && !(i.runId && e.has("run:" + i.runId));
}
function ype(i, e) {
  return JSON.stringify($0(i)) === JSON.stringify($0(e));
}
function $0(i) {
  const e = (n) => Math.round(n * 100) / 100, t = (n) => Number((n || 0).toPrecision(3));
  return { yaw: e(i.yaw), pitch: e(i.pitch), dist: t(i.dist), tx: t(i.tx), ty: t(i.ty), tz: t(i.tz), ox: t(i.ox), oy: t(i.oy) };
}
const xpe = [
  /^Image 1 is the image to edit/,
  /^Follow (the numbered markers|the marks drawn)/,
  /^Marker \d+:/,
  /^Image \d+, marker \d+:/,
  // today's wording (IL-100); the lines above read results made before it
  /^Follow (the numbered annotations|the annotations drawn)/,
  /^Annotation \d+:/,
  /^Image \d+, annotation \d+:/,
  /^The area to change is marked/,
  /^Remove what is marked in magenta/,
  /^Image 2 is image 1 with the area/
];
function wpe(i) {
  return i.split(`
`).filter((e) => e.trim() && !xpe.some((t) => t.test(e.trim()))).join(" ").trim();
}
function Ab(i, e) {
  const t = i.trim().split(/\s+/).filter(Boolean);
  return t.slice(0, e).join(" ") + (t.length > e ? "…" : "");
}
function Cd(i, e) {
  return (i && typeof i == "object" && "userMessage" in i ? String(i.userMessage || "") : "") || e + " couldn't be uploaded";
}
function Id(i) {
  return new Promise((e) => {
    const t = new Image();
    t.onload = () => e({ w: t.naturalWidth || 4, h: t.naturalHeight || 3 }), t.onerror = () => e({ w: 4, h: 3 }), t.src = i;
  });
}
function kpe(i) {
  if (!("nodeRunResult" in i)) return null;
  const e = i.nodeRunResult;
  return typeof e.nodeRunId == "string" && typeof e.uuid == "string" ? e.nodeRunId + ":" + e.uuid : null;
}
function s4(i, e) {
  return new Promise((t, n) => {
    const s = URL.createObjectURL(i), o = new Image();
    o.onload = () => {
      const r = Math.min(1, e / Math.max(o.naturalWidth, o.naturalHeight)), a = document.createElement("canvas");
      a.width = Math.max(1, Math.round(o.naturalWidth * r)), a.height = Math.max(1, Math.round(o.naturalHeight * r));
      const l = a.getContext("2d");
      if (URL.revokeObjectURL(s), !l) {
        n(new Error(i.name + " couldn't be read as an image"));
        return;
      }
      l.fillStyle = "#ffffff", l.fillRect(0, 0, a.width, a.height), l.drawImage(o, 0, 0, a.width, a.height), t(a.toDataURL("image/jpeg", 0.86));
    }, o.onerror = () => {
      URL.revokeObjectURL(s), n(new Error(i.name + " couldn't be read as an image"));
    }, o.src = s;
  });
}
function _pe(i) {
  try {
    const e = JSON.parse(localStorage.getItem(jI(i)) || "{}");
    !e.edit && e.draw && (e.edit = e.draw);
    const t = {};
    for (const n of GI) {
      const s = e[n];
      if (!s || typeof s.modelId != "string") continue;
      t[n] = { modelId: s.modelId, count: Number(s.count) || 1, inputs: s.inputs && typeof s.inputs == "object" ? s.inputs : {} };
      const o = Number(s.tier);
      s.tier != null && Number.isInteger(o) && o >= 0 && (t[n].tier = o);
    }
    return t;
  } catch {
    return {};
  }
}
const D0 = (i) => "rd-board-studio-hist:" + i, O0 = (i) => "rd-board-studio-words-only:" + i;
function Spe(i) {
  try {
    return localStorage.getItem(O0(i)) === "1";
  } catch {
    return !1;
  }
}
function Mpe(i, e) {
  try {
    e ? localStorage.setItem(O0(i), "1") : localStorage.removeItem(O0(i));
  } catch {
  }
}
function Tpe(i) {
  try {
    return localStorage.getItem(D0(i)) === "shut";
  } catch {
    return !1;
  }
}
function Cpe(i, e) {
  try {
    e ? localStorage.setItem(D0(i), "shut") : localStorage.removeItem(D0(i));
  } catch {
  }
}
function Ipe(i, e) {
  try {
    localStorage.setItem(jI(i), JSON.stringify(e));
  } catch {
  }
}
const o4 = /* @__PURE__ */ new WeakMap();
function L0(i, e) {
  let t = o4.get(i);
  t || (t = /* @__PURE__ */ new Map(), o4.set(i, t));
  let n = t.get(e);
  return n || (n = new vpe(i, e), t.set(e, n)), n;
}
function Ape() {
  return St();
}
const VI = /* @__PURE__ */ Symbol("studio");
function Ppe(i) {
  p5(VI, { studio: i });
}
function yt() {
  const i = Qf(VI);
  if (!i) throw new Error("useStudio() outside the Studios view");
  return i.studio;
}
const Epe = ["value"], Rpe = /* @__PURE__ */ Pe({
  __name: "DrawLayer",
  props: {
    w: {},
    h: {}
  },
  emits: ["live"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = yt(), o = s.s, r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(!1), c = /* @__PURE__ */ K(null), h = I(() => ({ w: t.w, h: t.h })), f = I(() => s.working().strokes);
    let p = null;
    function y(L) {
      const N = r.value.getBoundingClientRect();
      return { x: (L.clientX - N.left) * (t.w / (N.width || t.w)), y: (L.clientY - N.top) * (t.h / (N.height || t.h)) };
    }
    function v(L) {
      return { x: Math.min(t.w, Math.max(0, L.x)), y: Math.min(t.h, Math.max(0, L.y)) };
    }
    function x(L, N = !1) {
      const X = f.value;
      for (let B = X.length - 1; B >= 0; B--) {
        const se = X[B];
        if (!(N && se.kind !== "text") && mue(se, L, h.value))
          return se;
      }
      return null;
    }
    function w(L) {
      const N = Sc(L, h.value);
      if (!L.rot) return N;
      const X = Kr(L, h.value), B = [{ x: N.x, y: N.y }, { x: N.x + N.w, y: N.y }, { x: N.x + N.w, y: N.y + N.h }, { x: N.x, y: N.y + N.h }].map((Z) => Lo(Z, X, L.rot)), se = B.map((Z) => Z.x), V = B.map((Z) => Z.y);
      return { x: Math.min(...se), y: Math.min(...V), w: Math.max(...se) - Math.min(...se), h: Math.max(...V) - Math.min(...V) };
    }
    function S() {
      const L = document.activeElement;
      L && L !== a.value && /^(INPUT|TEXTAREA|BUTTON|SELECT)$/.test(L.tagName) && L.blur();
    }
    function M(L) {
      if (L.button !== 0 || !r.value) return;
      S();
      const N = y(L);
      o.editingText && s.commitText(o.editingText), L.preventDefault(), r.value.setPointerCapture(L.pointerId);
      const X = o.tool;
      if (X === "move") {
        _(L, N);
        return;
      }
      if (X === "text") {
        const V = x(N, !0);
        if (V) {
          s.editText(V.id);
          return;
        }
        const Z = Math.min(N.x, Math.max(0, t.w - 50)), Y = Math.min(N.y, Math.max(0, t.h - 50));
        s.addText($o({ x: Z, y: Y }, h.value), Math.max(uue, o.size) / qr(h.value));
        return;
      }
      if (X === "eraser") {
        s.beginGesture(), p = { kind: "erase", start: N, last: N, moved: !1, trails: /* @__PURE__ */ new Map() }, R(N);
        return;
      }
      if (X === "note") return;
      const B = $o(v(N), h.value), se = { id: Ape(), kind: X, color: o.color, size: o.size / qr(h.value), pts: X === "brush" ? [B] : [B, B], opacity: o.opacity };
      p = { kind: "draw", stroke: se }, n("live", se);
    }
    function _(L, N) {
      const X = L.target.dataset.handle, B = o.selection.length === 1 && f.value.find((V) => V.id === o.selection[0]) || null;
      if (B && X) {
        if (s.beginGesture(), X === "turn") {
          const V = Kr(B, h.value);
          p = { kind: "turn", orig: B, centre: V, a0: Math.atan2(N.y - V.y, N.x - V.x) };
        } else {
          const V = Sc(B, h.value), Y = {
            nw: { x: V.x + V.w, y: V.y + V.h },
            ne: { x: V.x, y: V.y + V.h },
            se: { x: V.x, y: V.y },
            sw: { x: V.x + V.w, y: V.y }
          }[X], H = B.rot ? Lo(Y, Kr(B, h.value), B.rot) : Y;
          p = { kind: "resize", orig: B, anchor: H, box: V, even: B.kind === "text" };
        }
        return;
      }
      const se = x(N);
      if (se) {
        if (L.shiftKey) {
          s.select(o.selection.includes(se.id) ? o.selection.filter((Z) => Z !== se.id) : [...o.selection, se.id]);
          return;
        }
        o.selection.includes(se.id) || s.select([se.id]), s.beginGesture();
        const V = /* @__PURE__ */ new Map();
        for (const Z of f.value) o.selection.includes(Z.id) && V.set(Z.id, Z);
        p = { kind: "move", start: N, orig: V, moved: !1 };
        return;
      }
      p = { kind: "marquee", start: N, before: L.shiftKey ? o.selection.slice() : [] }, L.shiftKey || s.select([]), c.value = { x: N.x, y: N.y, w: 0, h: 0 };
    }
    function T(L) {
      const N = y(L);
      if ((o.tool === "brush" || o.tool === "eraser") && (l.value = N), !p) {
        d.value = o.tool === "move" && !!x(N);
        return;
      }
      if (!r.value || !r.value.hasPointerCapture(L.pointerId)) return;
      const X = p;
      if (X.kind === "draw") {
        const B = $o(v(N), h.value), se = X.stroke;
        if (se.kind === "brush") {
          const V = se.pts[se.pts.length - 1];
          if (Math.hypot((B.x - V.x) * t.w, (B.y - V.y) * t.h) < 2) return;
          X.stroke = { ...se, pts: [...se.pts, B] };
        } else
          X.stroke = { ...se, pts: [se.pts[0], B] };
        n("live", X.stroke);
      } else if (X.kind === "erase")
        R(N);
      else if (X.kind === "move") {
        if (!X.moved && Math.hypot(N.x - X.start.x, N.y - X.start.y) < 2) return;
        X.moved = !0;
        const B = (N.x - X.start.x) / t.w, se = (N.y - X.start.y) / t.h;
        s.updateStrokes(Array.from(X.orig.keys()), (V) => cI(X.orig.get(V.id) || V, B, se), !1);
      } else if (X.kind === "resize") {
        const B = X.orig, se = Kr(B, h.value), V = B.rot ? Lo(N, se, -B.rot) : N, Z = B.rot ? Lo(X.anchor, se, -B.rot) : X.anchor;
        let Y = Math.abs(V.x - Z.x) / Math.max(1, X.box.w), H = Math.abs(V.y - Z.y) / Math.max(1, X.box.h);
        if (X.even || L.shiftKey) {
          const re = Math.max(Y, H);
          Y = re, H = re;
        }
        s.updateStrokes([B.id], () => gue(B, X.anchor, Math.max(0.05, Y), Math.max(0.05, H), h.value), !1);
      } else if (X.kind === "turn") {
        let B = (X.orig.rot || 0) + Math.atan2(N.y - X.centre.y, N.x - X.centre.x) - X.a0;
        L.shiftKey && (B = Math.round(B / (Math.PI / 12)) * (Math.PI / 12)), s.updateStrokes([X.orig.id], (se) => ({ ...se, rot: B }), !1);
      } else if (X.kind === "marquee") {
        const B = { x: Math.min(X.start.x, N.x), y: Math.min(X.start.y, N.y), w: Math.abs(N.x - X.start.x), h: Math.abs(N.y - X.start.y) };
        c.value = B;
        const se = f.value.filter((V) => vue(w(V), B)).map((V) => V.id);
        s.select(Array.from(/* @__PURE__ */ new Set([...X.before, ...se])));
      }
    }
    function k(L) {
      r.value && r.value.hasPointerCapture(L.pointerId) && r.value.releasePointerCapture(L.pointerId);
      const N = p;
      if (p = null, c.value = null, n("live", null), !!N)
        if (N.kind === "draw") {
          const X = N.stroke, B = X.pts[0], se = X.pts[X.pts.length - 1], V = Math.hypot((se.x - B.x) * t.w, (se.y - B.y) * t.h);
          if (X.kind !== "brush" && V < 4) return;
          s.addStroke(X);
        } else if (N.kind === "erase") {
          if (!N.moved) {
            const X = x(N.start, !0);
            if (X) {
              s.dropGesture(), s.deleteStrokes([X.id]);
              return;
            }
          }
          N.trails.size || s.dropGesture();
        } else N.kind === "move" && !N.moved && s.dropGesture();
    }
    function P() {
      l.value = null, d.value = !1;
    }
    function A(L) {
      if (o.tool !== "move") return;
      const N = x(y(L), !0);
      N && s.editText(N.id);
    }
    function R(L) {
      const N = p;
      if (!N || N.kind !== "erase") return;
      Math.hypot(L.x - N.start.x, L.y - N.start.y) > 4 && (N.moved = !0);
      const X = N.last;
      N.last = L;
      const B = o.size, se = h.value;
      let V = !1;
      for (const Y of f.value) {
        const H = N.trails.get(Y.id);
        H ? (H.trail.pts.push($o(yl(L, Y, se), se)), V = !0) : bue(Y, X, L, B, se) && (N.trails.set(Y.id, {
          before: Y.erase || [],
          trail: { pts: [$o(yl(X, Y, se), se), $o(yl(L, Y, se), se)], size: B / qr(se) }
        }), V = !0);
      }
      if (!V) return;
      const Z = N.trails;
      s.updateStrokes(Array.from(Z.keys()), (Y) => {
        const H = Z.get(Y.id);
        return { ...Y, erase: [...H.before, { size: H.trail.size, pts: H.trail.pts.slice() }] };
      }, !1);
    }
    const D = (L) => L.kind === "text" ? 5 : L.size * qr(h.value) / 2 + 5, O = I(() => {
      if (o.tool !== "move") return [];
      const L = new Set(o.selection);
      return f.value.filter((N) => L.has(N.id)).map((N) => {
        const X = Sc(N, h.value), B = D(N);
        return { id: N.id, left: X.x - B, top: X.y - B, width: X.w + B * 2, height: X.h + B * 2, rot: N.rot || 0 };
      });
    }), F = I(() => f.value.find((L) => L.id === o.editingText && L.kind === "text") || null), te = I(() => {
      const L = F.value;
      if (!L) return null;
      const N = Mu(L, h.value), X = Math.max(N.font, t.w - N.box.x);
      return {
        left: N.box.x + "px",
        top: N.box.y + "px",
        width: Math.min(X, N.box.w + N.font * 0.7) + "px",
        height: Math.max(N.box.h, N.font * eu) + "px",
        fontSize: N.font + "px",
        lineHeight: String(eu),
        fontFamily: Qc,
        color: L.color,
        transform: L.rot ? "rotate(" + L.rot + "rad)" : void 0
      };
    });
    Ae(() => o.editingText, (L) => {
      L && nt(() => {
        a.value && (a.value.focus(), a.value.select());
      });
    });
    function ee(L) {
      var N;
      L.key === "Enter" && (L.metaKey || L.ctrlKey) && (L.preventDefault(), (N = a.value) == null || N.blur());
    }
    function me() {
      o.editingText && s.commitText(o.editingText);
    }
    return (L, N) => (g(), b("div", {
      ref_key: "layer",
      ref: r,
      class: G(["sv-layer is-draw", ["tool-" + m(o).tool, { "is-over": d.value }]]),
      "data-testid": "studio-draw-layer",
      onPointerdown: M,
      onPointermove: T,
      onPointerup: k,
      onPointercancel: k,
      onPointerleave: P,
      onDblclick: A
    }, [
      (g(!0), b(j, null, be(O.value, (X) => (g(), b("div", {
        key: X.id,
        class: "sv-sel",
        style: ce({ left: X.left + "px", top: X.top + "px", width: X.width + "px", height: X.height + "px", transform: X.rot ? "rotate(" + X.rot + "rad)" : void 0 })
      }, [
        O.value.length === 1 ? (g(), b(j, { key: 0 }, [
          N[2] || (N[2] = _1('<i class="h nw" data-handle="nw"></i><i class="h ne" data-handle="ne"></i><i class="h se" data-handle="se"></i><i class="h sw" data-handle="sw"></i><i class="stem"></i><i class="h turn" data-handle="turn" title="Turn (Shift snaps)"></i>', 6))
        ], 64)) : z("", !0)
      ], 4))), 128)),
      c.value ? (g(), b("div", {
        key: 0,
        class: "sv-marquee",
        style: ce({ left: c.value.x + "px", top: c.value.y + "px", width: c.value.w + "px", height: c.value.h + "px" })
      }, null, 4)) : z("", !0),
      l.value && (m(o).tool === "brush" || m(o).tool === "eraser") ? (g(), b("span", {
        key: 1,
        class: G(["sv-ring", { "is-eraser": m(o).tool === "eraser" }]),
        style: ce({ left: l.value.x + "px", top: l.value.y + "px", width: Math.max(4, m(o).size) + "px", height: Math.max(4, m(o).size) + "px" })
      }, null, 6)) : z("", !0),
      F.value && te.value ? (g(), b("textarea", {
        key: 2,
        ref_key: "editor",
        ref: a,
        class: "sv-text-editor",
        style: ce(te.value),
        value: F.value.text,
        placeholder: "Text",
        spellcheck: "false",
        "data-testid": "studio-text-editor",
        onInput: N[0] || (N[0] = (X) => m(s).setText(F.value.id, X.target.value)),
        onKeydown: ee,
        onBlur: me,
        onPointerdown: N[1] || (N[1] = Se(() => {
        }, ["stop"]))
      }, null, 44, Epe)) : z("", !0)
    ], 34));
  }
}), zpe = ["title", "data-testid", "onPointerdown"], $pe = { class: "sv-pin-editor-head" }, Dpe = { class: "n" }, Ope = ["value"], Lpe = { class: "sv-pin-editor-foot" }, Bpe = /* @__PURE__ */ Pe({
  __name: "PinLayer",
  props: {
    w: {},
    h: {}
  },
  setup(i) {
    const e = i, t = yt(), n = t.s, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = I(() => t.working().pins), a = I(() => r.value.find((x) => x.id === n.editingPin) || null);
    Ae(() => n.editingPin, (x) => {
      x && nt(() => o.value && o.value.focus());
    });
    function l(x) {
      const w = s.value.getBoundingClientRect();
      return { x: Math.min(1, Math.max(0, (x.clientX - w.left) / w.width)), y: Math.min(1, Math.max(0, (x.clientY - w.top) / w.height)) };
    }
    function d(x) {
      if (x.button !== 0) return;
      if (x.preventDefault(), n.editingPin) {
        t.commitPin(n.editingPin);
        return;
      }
      const w = l(x);
      t.addPin(w.x, w.y);
    }
    let c = null;
    function h(x, w) {
      w.stopPropagation(), w.button === 0 && (w.currentTarget.setPointerCapture(w.pointerId), c = { id: x, x0: w.clientX, y0: w.clientY, moved: !1 });
    }
    function f(x) {
      if (!c || !c.moved && Math.hypot(x.clientX - c.x0, x.clientY - c.y0) < 4) return;
      const w = !c.moved;
      c.moved = !0;
      const S = l(x);
      t.movePin(c.id, S.x, S.y, w);
    }
    function p(x) {
      const w = c;
      c = null, x.currentTarget.releasePointerCapture(x.pointerId), w && !w.moved && t.editPin(w.id);
    }
    function y(x, w) {
      x.key === "Enter" && !x.shiftKey ? (x.preventDefault(), t.commitPin(w)) : x.key === "Escape" && (x.preventDefault(), x.stopPropagation(), t.commitPin(w));
    }
    const v = I(() => {
      const x = a.value;
      if (!x) return null;
      const w = x.x * e.w, S = x.y * e.h;
      return { left: w > e.w - 280 ? w - 262 : w + 22, top: Math.min(Math.max(S - 22, -8), e.h - 120) };
    });
    return (x, w) => (g(), b("div", {
      ref_key: "layer",
      ref: s,
      class: "sv-layer is-comment",
      "data-testid": "studio-pin-layer",
      onPointerdown: Se(d, ["self"])
    }, [
      (g(!0), b(j, null, be(r.value, (S, M) => (g(), b("button", {
        key: S.id,
        class: G(["sv-pin", { "is-on": m(n).editingPin === S.id, "is-empty": !S.text.trim() }]),
        style: ce({ left: S.x * 100 + "%", top: S.y * 100 + "%" }),
        title: S.text || "New note",
        "data-testid": "studio-pin-" + (M + 1),
        onPointerdown: (_) => h(S.id, _),
        onPointermove: f,
        onPointerup: p
      }, E(M + 1), 47, zpe))), 128)),
      a.value && v.value ? (g(), b("div", {
        key: 0,
        class: "sv-pin-editor",
        style: ce({ left: v.value.left + "px", top: v.value.top + "px" }),
        onPointerdown: w[4] || (w[4] = Se(() => {
        }, ["stop"]))
      }, [
        u("div", $pe, [
          u("span", Dpe, E(r.value.indexOf(a.value) + 1), 1),
          w[5] || (w[5] = u("span", { class: "t" }, "Note for the model", -1)),
          u("button", {
            class: "x",
            title: "Delete this note",
            onClick: w[0] || (w[0] = (S) => m(t).removePin(a.value.id))
          }, [
            C($, {
              name: "Trash2",
              size: 12
            })
          ])
        ]),
        u("textarea", {
          ref_key: "editor",
          ref: o,
          value: a.value.text,
          rows: "2",
          spellcheck: "false",
          placeholder: "What should change here?",
          "data-testid": "studio-pin-text",
          onInput: w[1] || (w[1] = (S) => m(t).setPinText(a.value.id, S.target.value)),
          onKeydown: w[2] || (w[2] = (S) => y(S, a.value.id))
        }, null, 40, Ope),
        u("div", Lpe, [
          w[6] || (w[6] = u("span", null, "Enter to save", -1)),
          u("button", {
            class: "sv-mini-btn",
            onClick: w[3] || (w[3] = (S) => m(t).commitPin(a.value.id))
          }, "Done")
        ])
      ], 36)) : z("", !0)
    ], 544));
  }
}), r4 = 1400, Fpe = 3e-3, Npe = 1, a4 = 4096, l4 = {
  studio: [0.925, 0.918, 0.902, 1],
  clear: [0, 0, 0, 0],
  night: [0.055, 0.06, 0.09, 1]
};
function Upe(i, e) {
  const t = Math.PI * 2;
  let n = (e - i) % t;
  return n > Math.PI && (n -= t), n < -Math.PI && (n += t), i + n;
}
function Gpe(i) {
  return i < 0.5 ? 4 * i * i * i : 1 - Math.pow(-2 * i + 2, 3) / 2;
}
function jpe(i, e, t) {
  const n = (s, o) => s + (o - s) * t;
  return {
    yaw: n(i.yaw, Upe(i.yaw, e.yaw)),
    pitch: n(i.pitch, e.pitch),
    dist: n(i.dist, e.dist),
    tx: n(i.tx, e.tx),
    ty: n(i.ty, e.ty),
    tz: n(i.tz, e.tz),
    ox: n(i.ox || 0, e.ox || 0),
    oy: n(i.oy || 0, e.oy || 0)
  };
}
async function Hpe(i, e) {
  const t = new i.Engine(e, !0, { preserveDrawingBuffer: !0, stencil: !0 }, !0), n = new i.Scene(t), s = new i.ArcRotateCamera("studio-camera", Math.PI / 2, Math.PI / 2.5, 3, i.Vector3.Zero(), n);
  s.attachControl(e, !0), s.angularSensibilityX = r4, s.angularSensibilityY = r4, s.wheelDeltaPercentage = Fpe, s.inertia = 0.6, s.panningInertia = 0.6, s.lowerRadiusLimit = 0.01, s.minZ = 0.01, s.lowerBetaLimit = 0.02, s.upperBetaLimit = Math.PI - 0.02;
  const o = new i.HemisphericLight("studio-hemi", new i.Vector3(0, 1, 0), n);
  o.intensity = 0.75, o.groundColor = new i.Color3(0.32, 0.31, 0.34);
  const r = new i.DirectionalLight("studio-sun", new i.Vector3(-0.55, -1, -0.35), n);
  r.intensity = 0.75;
  let a = [], l = { yaw: Math.PI / 2, pitch: Math.PI / 2.5, dist: 3, tx: 0, ty: 0, tz: 0, ox: 0, oy: 0 }, d = null;
  const c = /* @__PURE__ */ new Set();
  let h = 0;
  const f = () => ({
    yaw: s.alpha,
    pitch: s.beta,
    dist: s.radius,
    tx: s.target.x,
    ty: s.target.y,
    tz: s.target.z,
    ox: s.targetScreenOffset.x,
    oy: s.targetScreenOffset.y
  }), p = (L) => {
    s.alpha = L.yaw, s.beta = L.pitch, s.radius = L.dist, s.setTarget(new i.Vector3(L.tx, L.ty, L.tz)), s.alpha = L.yaw, s.beta = L.pitch, s.radius = L.dist, s.targetScreenOffset.set(L.ox || 0, L.oy || 0);
  }, y = () => {
    h || (h = requestAnimationFrame(() => {
      h = 0;
      const L = f();
      for (const N of c) N(L);
    }));
  };
  s.onViewMatrixChangedObservable.add(y);
  const v = () => (s.radius > 0 ? s.radius : 1) * Math.tan((s.fov > 0 ? s.fov : 0.8) / 2), x = () => {
    const L = v() * Npe, N = s.targetScreenOffset, X = Math.hypot(N.x, N.y);
    X > L && X > 0 && N.set(N.x * L / X, N.y * L / X);
  };
  s.panningSensibility = 1200, s.panningAxis = new i.Vector3(0, 0, 0);
  let w = null;
  const S = (L) => L.button === 2 || L.button === 0 && L.ctrlKey, M = (L) => {
    S(L) && (w = { x: L.clientX, y: L.clientY }, d = null);
  }, _ = (L) => {
    if (!w) return;
    if (L.buttons === 0) {
      w = null;
      return;
    }
    const N = 2 * v() / Math.max(1, e.clientHeight), X = s.targetScreenOffset;
    X.set(X.x + (L.clientX - w.x) * N, X.y - (L.clientY - w.y) * N), w = { x: L.clientX, y: L.clientY }, x(), y();
  }, T = () => {
    w = null;
  }, k = () => {
    w = null, window.removeEventListener("pointermove", _), window.removeEventListener("pointerup", k), window.removeEventListener("pointercancel", k);
  }, P = (L) => {
    L.target !== e || L.button !== 0 || !L.shiftKey || L.ctrlKey || (L.stopPropagation(), L.preventDefault(), w = { x: L.clientX, y: L.clientY }, d = null, window.addEventListener("pointermove", _), window.addEventListener("pointerup", k), window.addEventListener("pointercancel", k));
  };
  window.addEventListener("pointerdown", P, !0);
  const A = (L) => L.preventDefault();
  e.addEventListener("pointerdown", M), e.addEventListener("pointermove", _), e.addEventListener("pointerup", T), e.addEventListener("pointercancel", T), e.addEventListener("contextmenu", A);
  let R = null;
  const D = () => {
    if (R == null) return;
    const L = Math.max(s.radius, 1e-6), N = (R + L * 0.02 - s.target.y) / L, X = N <= -1 ? Math.PI - 0.02 : N >= 1 ? 0.02 : Math.min(Math.PI - 0.02, Math.acos(N));
    s.upperBetaLimit = Math.max(0.02, X), s.beta > s.upperBetaLimit && (s.beta = s.upperBetaLimit);
  }, O = n.onBeforeRenderObservable.add(() => {
    if (d) {
      const L = Math.min(1, (performance.now() - d.t0) / d.ms);
      p(jpe(d.from, d.to, Gpe(L))), L >= 1 && (d = null);
    }
    x(), D();
  }), F = new ResizeObserver(() => t.resize());
  F.observe(e), t.runRenderLoop(() => n.render());
  let te = "studio";
  const ee = (L) => {
    te = L;
    const N = l4[L];
    n.clearColor = new i.Color4(N[0], N[1], N[2], N[3]);
  };
  ee("studio");
  const me = () => {
    let L = null, N = null;
    for (const se of n.meshes) {
      if (!se.getTotalVertices()) continue;
      se.computeWorldMatrix(!0);
      const V = se.getBoundingInfo().boundingBox;
      L = L ? i.Vector3.Minimize(L, V.minimumWorld) : V.minimumWorld.clone(), N = N ? i.Vector3.Maximize(N, V.maximumWorld) : V.maximumWorld.clone();
    }
    if (!L || !N) return l;
    const X = Math.max(N.x - L.x, N.y - L.y, N.z - L.z) || 2;
    R = L.y;
    const B = X * 1.5;
    return s.lowerRadiusLimit = B * 0.08, s.upperRadiusLimit = B * 10, s.minZ = B * 2e-3, s.maxZ = B * 60, {
      yaw: Math.PI / 2 + 0.75,
      pitch: 1.2,
      dist: B,
      tx: (L.x + N.x) / 2,
      ty: (L.y + N.y) / 2,
      tz: (L.z + N.z) / 2,
      ox: 0,
      oy: 0
    };
  };
  return {
    async load(L, N) {
      const X = L instanceof File ? L : new File([L], "model." + N), B = await i.SceneLoader.ImportMeshAsync("", "", X, n, null, "." + N.replace(/^\./, ""));
      for (const V of a) V.dispose();
      a = B.meshes;
      const se = new i.StandardMaterial("studio-clay", n);
      se.diffuseColor = new i.Color3(0.8, 0.77, 0.73), se.specularColor = new i.Color3(0.08, 0.08, 0.08), se.backFaceCulling = !1;
      for (const V of B.meshes) !V.material && V.getTotalVertices() && (V.material = se);
      l = me(), d = null, p(l);
    },
    camera: f,
    setCamera(L) {
      d = null, p(L);
    },
    fly(L, N = 460) {
      d = { from: f(), to: L, t0: performance.now(), ms: N };
    },
    home: () => ({ ...l }),
    setBackdrop: ee,
    async capture(L, N, X) {
      const B = Math.max(1, e.clientWidth), se = Math.max(1, e.clientHeight);
      let V = Math.max(N / L.w, X / L.h);
      V = Math.min(V, a4 / B, a4 / se);
      const Z = Math.round(B * V), Y = Math.round(se * V), H = await new Promise((Re) => {
        i.CreateScreenshotUsingRenderTarget(t, s, { width: Z, height: Y, precision: 1 }, (Ne) => Re(Ne), "image/png", 1, !0);
      }), re = await new Promise((Re, Ne) => {
        const Me = new Image();
        Me.onload = () => Re(Me), Me.onerror = () => Ne(new Error("The view couldn't be captured.")), Me.src = H;
      }), le = document.createElement("canvas");
      le.width = N, le.height = X;
      const he = le.getContext("2d");
      if (!he) throw new Error("The view couldn't be captured.");
      if (te !== "clear") {
        const Re = l4[te];
        he.fillStyle = "rgb(" + Math.round(Re[0] * 255) + "," + Math.round(Re[1] * 255) + "," + Math.round(Re[2] * 255) + ")", he.fillRect(0, 0, N, X);
      }
      return he.drawImage(re, L.x * V, L.y * V, L.w * V, L.h * V, 0, 0, N, X), new Promise((Re, Ne) => le.toBlob((Me) => Me ? Re(Me) : Ne(new Error("The view couldn't be captured.")), "image/png"));
    },
    onCamera(L) {
      return c.add(L), () => c.delete(L);
    },
    dispose() {
      cancelAnimationFrame(h), c.clear(), F.disconnect(), n.onBeforeRenderObservable.remove(O), e.removeEventListener("pointerdown", M), e.removeEventListener("pointermove", _), e.removeEventListener("pointerup", T), e.removeEventListener("pointercancel", T), e.removeEventListener("contextmenu", A), window.removeEventListener("pointerdown", P, !0), k();
      try {
        t.stopRenderLoop(), t.dispose();
      } catch {
      }
    }
  };
}
const Vpe = { class: "sv-finder-tag" }, Wpe = {
  key: 1,
  class: "sv-model-state",
  "data-testid": "studio-3d-loading"
}, qpe = {
  key: 2,
  class: "sv-model-state is-error",
  "data-testid": "studio-3d-error"
}, Kpe = {
  class: "sv-seg is-text is-small is-dark",
  role: "radiogroup",
  "aria-label": "Frame"
}, Ype = ["aria-checked", "title", "data-testid", "onClick"], Xpe = {
  class: "sv-seg is-text is-small is-dark",
  role: "radiogroup",
  "aria-label": "Backdrop"
}, Jpe = ["aria-checked", "onClick"], Zpe = /* @__PURE__ */ Pe({
  __name: "ModelView",
  setup(i, { expose: e }) {
    const t = yt(), { board: n } = Ze(), s = t.s, o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K({ w: 800, h: 600 }), l = /* @__PURE__ */ K(!1), d = [
      { id: "studio", label: "Studio" },
      { id: "clear", label: "Clear" },
      { id: "night", label: "Night" }
    ], c = ["1:1", "4:3", "3:4", "16:9", "9:16"];
    let h = null, f = null, p = null, y = !1;
    const v = I(() => {
      const k = t.captureRatio(), P = a.value.w - 48, A = a.value.h - 48, R = Math.min(P, A * k), D = R / k;
      return { w: R, h: D, left: (a.value.w - R) / 2, top: (a.value.h - D) / 2 };
    });
    function x(k) {
      const P = k instanceof Error ? k.message : "";
      return P && /couldn't|isn't|unavailable/i.test(P) ? P : "This file couldn't be read as a 3D model. Try a .glb, or an .obj or .stl.";
    }
    async function w(k) {
      if (!(!h || !k || p === k.id)) {
        p = k.id, s.three.loading = !0, s.three.error = null;
        try {
          const P = await t.modelFile(k);
          if (y || p !== k.id || !h || (await h.load(P, k.ext), y || p !== k.id || !h)) return;
          s.three.cam = h.camera();
        } catch (P) {
          console.warn("[board] 3D model not shown", P), p === k.id && (s.three.error = x(P), p = null);
        } finally {
          y || (s.three.loading = !1);
        }
      }
    }
    let S = null;
    ot(async () => {
      o.value && (S = new ResizeObserver(() => {
        if (!o.value) return;
        const P = o.value.getBoundingClientRect();
        a.value = { w: Math.max(200, P.width), h: Math.max(160, P.height) };
      }), S.observe(o.value));
      const k = n.babylon;
      if (!k || !r.value) {
        s.three.error = "3D isn't available here.";
        return;
      }
      s.three.loading = !0;
      try {
        const P = await k();
        if (y || !r.value) return;
        h = await Hpe(P, r.value);
      } catch (P) {
        console.error("[board] 3D unavailable", P), s.three.error = "3D couldn't start in this browser.", s.three.loading = !1;
        return;
      }
      if (y) {
        h.dispose(), h = null;
        return;
      }
      h.setBackdrop(s.three.backdrop), f = h.onCamera((P) => {
        s.three.cam = P;
      }), l.value = !0, s.three.loading = !1, await w(t.model3d.value);
    }), Ae(() => t.model3d.value ? t.model3d.value.id : null, () => w(t.model3d.value)), Ae(() => s.three.backdrop, (k) => {
      h && h.setBackdrop(k);
    }), We(() => {
      y = !0, S && S.disconnect(), f && f(), h && h.dispose(), h = null;
    });
    function M(k) {
      h && h.fly(k);
    }
    function _() {
      h && h.fly(h.home());
    }
    async function T() {
      if (!h || !l.value || s.three.loading || s.three.error) return null;
      const k = v.value, P = t.captureRatio(), A = P >= 1 ? 1024 : Math.round(1024 * P), R = P >= 1 ? Math.round(1024 / P) : 1024;
      return { blob: await h.capture({ x: k.left, y: k.top, w: k.w, h: k.h }, A, R), w: A, h: R };
    }
    return e({ fly: M, capture: T, home: _ }), (k, P) => (g(), b("div", {
      ref_key: "box",
      ref: o,
      class: G(["sv-model", { "is-clear": m(s).three.backdrop === "clear", "is-night": m(s).three.backdrop === "night" }]),
      "data-testid": "studio-model-view"
    }, [
      u("canvas", {
        ref_key: "canvas",
        ref: r,
        class: "sv-model-canvas",
        onDblclick: _
      }, null, 544),
      l.value && !m(s).three.error ? (g(), b("div", {
        key: 0,
        class: "sv-finder",
        style: ce({ left: v.value.left + "px", top: v.value.top + "px", width: v.value.w + "px", height: v.value.h + "px" }),
        "aria-hidden": "true"
      }, [
        P[1] || (P[1] = u("i", { class: "tl" }, null, -1)),
        P[2] || (P[2] = u("i", { class: "tr" }, null, -1)),
        P[3] || (P[3] = u("i", { class: "bl" }, null, -1)),
        P[4] || (P[4] = u("i", { class: "br" }, null, -1)),
        u("span", Vpe, E(m(s).three.aspect), 1)
      ], 4)) : z("", !0),
      m(s).three.loading || m(s).three.keeping ? (g(), b("div", Wpe, [
        P[5] || (P[5] = u("span", { class: "sv-making" }, null, -1)),
        J(" " + E(m(s).three.keeping ? "Keeping " + m(s).three.keeping + " in your Library, then opening it" : "Opening the model"), 1)
      ])) : m(s).three.error ? (g(), b("div", qpe, [
        C($, {
          name: "AlertCircle",
          size: 15
        }),
        J(" " + E(m(s).three.error), 1)
      ])) : z("", !0),
      u("div", {
        class: "sv-model-tools",
        onPointerdown: P[0] || (P[0] = Se(() => {
        }, ["stop"]))
      }, [
        u("div", Kpe, [
          (g(), b(j, null, be(c, (A) => u("button", {
            key: A,
            class: G({ on: m(s).three.aspect === A }),
            role: "radio",
            "aria-checked": m(s).three.aspect === A,
            title: "Capture a " + A + " frame",
            "data-testid": "studio-3d-aspect-" + A.replace(":", "x"),
            onClick: (R) => m(s).three.aspect = A
          }, E(A), 11, Ype)), 64))
        ]),
        u("div", Xpe, [
          (g(), b(j, null, be(d, (A) => u("button", {
            key: A.id,
            class: G({ on: m(s).three.backdrop === A.id }),
            role: "radio",
            "aria-checked": m(s).three.backdrop === A.id,
            onClick: (R) => m(s).three.backdrop = A.id
          }, E(A.label), 11, Jpe)), 64))
        ]),
        u("button", {
          class: "sv-model-btn",
          title: "Back to the framed view (double-click the model)",
          onClick: _
        }, [
          C($, {
            name: "RotateCcw",
            size: 13
          })
        ])
      ], 32)
    ], 2));
  }
}), Qpe = ["viewBox"], efe = ["d"], tfe = {
  key: 0,
  class: "tk"
}, nfe = /* @__PURE__ */ Pe({
  __name: "AreaLayer",
  props: {
    w: {},
    h: {}
  },
  setup(i) {
    const e = i, t = yt(), n = t.s, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(!1), c = /* @__PURE__ */ K(0), h = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ K(null), p = I(() => t.area()), y = I(() => n.bar === "erase"), v = I(() => n.areaCut !== d.value), x = I(() => t.objectsOf(n.stageId)), w = I(() => Math.max(e.w, e.h)), S = I(() => y.value ? [255, 92, 110] : [168, 118, 255]);
    Ae(() => x.value && x.value.status === "ready" ? x.value.url : null, async (L) => {
      if (f.value = null, c.value = 0, !L) return;
      const N = n.stageId;
      try {
        const X = await Rf(L);
        h.set(L, X), f.value = X;
      } catch {
        f.value = null, N && t.objectsFailed(N);
      }
    }, { immediate: !0 });
    let M = 0;
    function _() {
      cancelAnimationFrame(M), M = requestAnimationFrame(T);
    }
    async function T() {
      const L = o.value;
      if (!L) return;
      const N = Math.min(2, window.devicePixelRatio || 1), X = Math.max(1, Math.round(e.w * N)), B = Math.max(1, Math.round(e.h * N));
      (L.width !== X || L.height !== B) && (L.width = X, L.height = B);
      const se = l.value ? [...p.value, k(l.value)] : p.value;
      for (const Re of EI(se))
        if (!h.has(Re))
          try {
            h.set(Re, await Rf(Re));
          } catch {
          }
      const V = L.getContext("2d");
      if (V.clearRect(0, 0, X, B), !se.length) return;
      const Z = zp(se, X, B, h), [Y, H, re] = S.value;
      V.save(), V.drawImage(Z, 0, 0), V.globalCompositeOperation = "source-in", V.fillStyle = "rgba(" + Y + "," + H + "," + re + ",0.4)", V.fillRect(0, 0, X, B), V.restore();
      const le = document.createElement("canvas");
      le.width = X, le.height = B;
      const he = le.getContext("2d");
      he.filter = "blur(" + 1.6 * N + "px)", he.drawImage(Z, 0, 0), he.filter = "none", he.globalCompositeOperation = "destination-out", he.drawImage(Z, 0, 0), he.globalCompositeOperation = "source-in", he.fillStyle = "rgba(255,255,255,0.95)", he.fillRect(0, 0, X, B), V.drawImage(le, 0, 0);
    }
    function k(L) {
      return L.kind === "brush" ? { kind: "brush", pts: L.pts, size: n.areaSize / w.value, cut: L.cut } : { kind: "lasso", pts: L.pts, cut: L.cut };
    }
    Ae([p, () => e.w, () => e.h, y], _, { deep: !0 }), ot(_);
    function P() {
      const L = r.value;
      if (!L) return;
      const N = Math.min(2, window.devicePixelRatio || 1);
      L.width = Math.max(1, Math.round(e.w * N)), L.height = Math.max(1, Math.round(e.h * N));
      const X = L.getContext("2d");
      if (X.clearRect(0, 0, L.width, L.height), !f.value || !c.value) return;
      const B = PI(f.value, c.value), se = L.width, V = L.height;
      X.drawImage(B, 0, 0, se, V), X.globalCompositeOperation = "source-in", X.fillStyle = v.value ? "rgba(255, 92, 110, 0.3)" : "rgba(190, 150, 255, 0.34)", X.fillRect(0, 0, se, V);
      const Z = document.createElement("canvas");
      Z.width = se, Z.height = V;
      const Y = Z.getContext("2d");
      Y.filter = "blur(2px)", Y.drawImage(B, 0, 0, se, V), Y.filter = "none", Y.globalCompositeOperation = "destination-out", Y.drawImage(B, 0, 0, se, V), Y.globalCompositeOperation = "source-in", Y.fillStyle = "#fff", Y.fillRect(0, 0, se, V), X.globalCompositeOperation = "source-over", X.drawImage(Z, 0, 0);
    }
    Ae(c, P);
    function A(L) {
      const N = s.value.getBoundingClientRect();
      return { x: (L.clientX - N.left) * (e.w / (N.width || e.w)), y: (L.clientY - N.top) * (e.h / (N.height || e.h)) };
    }
    function R(L) {
      return { x: Math.min(1, Math.max(0, L.x / e.w)), y: Math.min(1, Math.max(0, L.y / e.h)) };
    }
    function D(L) {
      if (L.button !== 0 || !s.value) return;
      const N = document.activeElement;
      N && /^(INPUT|TEXTAREA|BUTTON|SELECT)$/.test(N.tagName) && N.blur(), d.value = L.altKey;
      const X = R(A(L));
      if (n.areaTool === "object") {
        if (!f.value) return;
        const B = B_(f.value, X.x, X.y);
        B && t.addAreaOp({ kind: "object", map: f.value.url, segment: B, cut: v.value });
        return;
      }
      L.preventDefault(), s.value.setPointerCapture(L.pointerId), l.value = { kind: n.areaTool === "lasso" ? "lasso" : "brush", pts: [X], cut: v.value }, _();
    }
    function O(L) {
      const N = A(L);
      if (d.value = L.altKey, n.areaTool === "brush" && (a.value = N), n.areaTool === "object" && f.value) {
        const V = R(N), Z = B_(f.value, V.x, V.y);
        Z !== c.value && (c.value = Z);
      }
      const X = l.value;
      if (!X || !s.value || !s.value.hasPointerCapture(L.pointerId)) return;
      const B = R(N), se = X.pts[X.pts.length - 1];
      Math.hypot((B.x - se.x) * e.w, (B.y - se.y) * e.h) < (X.kind === "brush" ? 2 : 3) || (X.pts = [...X.pts, B], _());
    }
    function F(L) {
      s.value && s.value.hasPointerCapture(L.pointerId) && s.value.releasePointerCapture(L.pointerId);
      const N = l.value;
      if (l.value = null, !!N) {
        if (N.kind === "lasso" && N.pts.length < 3) {
          _();
          return;
        }
        t.addAreaOp(k(N));
      }
    }
    function te() {
      a.value = null, c.value = 0;
    }
    function ee(L) {
      d.value = L.altKey;
    }
    ot(() => {
      window.addEventListener("keydown", ee), window.addEventListener("keyup", ee);
    }), We(() => {
      cancelAnimationFrame(M), window.removeEventListener("keydown", ee), window.removeEventListener("keyup", ee);
    });
    const me = I(() => {
      const L = l.value;
      return !L || L.kind !== "lasso" ? "" : L.pts.map((N, X) => (X ? "L" : "M") + (N.x * e.w).toFixed(1) + " " + (N.y * e.h).toFixed(1)).join(" ");
    });
    return (L, N) => (g(), b("div", {
      ref_key: "layer",
      ref: s,
      class: G(["sv-layer ed-area-layer", ["tool-" + m(n).areaTool, { "is-cut": v.value, "is-erase": y.value, "is-picking": m(n).areaTool === "object" && !!f.value, "is-over": !!c.value }]]),
      "data-testid": "studio-area-layer",
      onPointerdown: D,
      onPointermove: O,
      onPointerup: F,
      onPointercancel: F,
      onPointerleave: te
    }, [
      u("canvas", {
        ref_key: "paint",
        ref: o,
        class: "ed-area-paint",
        style: ce({ width: i.w + "px", height: i.h + "px" })
      }, null, 4),
      m(n).areaTool === "object" ? (g(), b("canvas", {
        key: 0,
        ref_key: "hoverCanvas",
        ref: r,
        class: "ed-area-hover",
        style: ce({ width: i.w + "px", height: i.h + "px" })
      }, null, 4)) : z("", !0),
      me.value ? (g(), b("svg", {
        key: 1,
        class: "ed-area-lasso",
        viewBox: "0 0 " + i.w + " " + i.h,
        style: ce({ width: i.w + "px", height: i.h + "px" })
      }, [
        u("path", { d: me.value }, null, 8, efe)
      ], 12, Qpe)) : z("", !0),
      a.value && m(n).areaTool === "brush" ? (g(), b("span", {
        key: 2,
        class: G(["sv-ring ed-area-ring", { "is-eraser": v.value }]),
        style: ce({ left: a.value.x + "px", top: a.value.y + "px", width: Math.max(4, m(n).areaSize) + "px", height: Math.max(4, m(n).areaSize) + "px" })
      }, null, 6)) : z("", !0),
      C(vt, { name: "ed-fade" }, {
        default: Xe(() => [
          m(n).areaTool === "object" && (!x.value || x.value.status !== "ready" || !f.value) ? (g(), b("div", {
            key: 0,
            class: "ed-area-find",
            onPointerdown: N[1] || (N[1] = Se(() => {
            }, ["stop"]))
          }, [
            x.value && x.value.status === "finding" ? (g(), b(j, { key: 0 }, [
              C($, {
                name: "Loader2",
                size: 13,
                spin: ""
              }),
              N[2] || (N[2] = J(" Finding the objects in this picture", -1))
            ], 64)) : x.value && x.value.status === "ready" ? (g(), b(j, { key: 1 }, [
              C($, {
                name: "Loader2",
                size: 13,
                spin: ""
              }),
              N[3] || (N[3] = J(" Reading the objects", -1))
            ], 64)) : (g(), b("button", {
              key: 2,
              class: "ed-area-find-btn",
              "data-testid": "studio-find-objects",
              onClick: N[0] || (N[0] = (X) => m(t).findObjects())
            }, [
              C($, {
                name: "MousePointerClick",
                size: 13
              }),
              J(" " + E(x.value && x.value.status === "failed" ? "The objects couldn't be found. Try again" : "Find the objects in this picture") + " ", 1),
              m(t).modelOf("select") ? (g(), b("span", tfe, [
                C($, {
                  name: "Tokens",
                  size: 10
                }),
                J(" " + E(m(t).priceOf("select")), 1)
              ])) : z("", !0)
            ]))
          ], 32)) : z("", !0)
        ]),
        _: 1
      })
    ], 34));
  }
}), ife = ["data-handle", "onPointerdown"], sfe = { class: "ed-crop-size" }, ofe = /* @__PURE__ */ Pe({
  __name: "CropOverlay",
  props: {
    w: {},
    h: {}
  },
  setup(i) {
    const e = i, t = yt(), n = t.tools, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(!1), r = I(() => n.t.resize.crop), a = I(() => ({ left: r.value.x * e.w, top: r.value.y * e.h, width: r.value.w * e.w, height: r.value.h * e.h })), l = I(() => {
      const y = t.stage.value;
      return y ? I0(r.value, y.w, y.h) : { w: 0, h: 0 };
    }), d = ["nw", "n", "ne", "e", "se", "s", "sw", "w"];
    let c = null;
    function h(y, v) {
      if (v.button !== 0 || !s.value) return;
      v.preventDefault(), v.stopPropagation(), v.currentTarget.setPointerCapture(v.pointerId);
      const x = t.stage.value, w = x ? Mc(n.t.resize.ratio, x.w, x.h) : null;
      c = { kind: y, x0: v.clientX, y0: v.clientY, start: { ...r.value }, ratio: w }, o.value = !0;
    }
    function f(y) {
      var v;
      if (!c) return;
      const x = t.stage.value;
      if (!x) return;
      const w = (y.clientX - c.x0) / e.w, S = (y.clientY - c.y0) / e.h;
      if (c.kind === "move") {
        n.setCrop(ghe(c.start, w, S));
        return;
      }
      const M = (v = c.ratio) != null ? v : y.shiftKey ? c.start.w * x.w / (c.start.h * x.h) : null;
      n.setCrop(bhe(c.start, c.kind, w, S, x.w, x.h, M, 16));
    }
    function p(y) {
      const v = y.currentTarget;
      v.hasPointerCapture(y.pointerId) && v.releasePointerCapture(y.pointerId), c = null, o.value = !1;
    }
    return (y, v) => (g(), b("div", {
      ref_key: "layer",
      ref: s,
      class: G(["sv-layer ed-crop", { "is-active": o.value }]),
      "data-testid": "studio-crop-frame"
    }, [
      u("i", {
        class: "shade",
        style: ce({ left: 0, top: 0, width: i.w + "px", height: a.value.top + "px" })
      }, null, 4),
      u("i", {
        class: "shade",
        style: ce({ left: 0, top: a.value.top + a.value.height + "px", width: i.w + "px", height: Math.max(0, i.h - a.value.top - a.value.height) + "px" })
      }, null, 4),
      u("i", {
        class: "shade",
        style: ce({ left: 0, top: a.value.top + "px", width: a.value.left + "px", height: a.value.height + "px" })
      }, null, 4),
      u("i", {
        class: "shade",
        style: ce({ left: a.value.left + a.value.width + "px", top: a.value.top + "px", width: Math.max(0, i.w - a.value.left - a.value.width) + "px", height: a.value.height + "px" })
      }, null, 4),
      u("div", {
        class: "ed-crop-box",
        style: ce({ left: a.value.left + "px", top: a.value.top + "px", width: a.value.width + "px", height: a.value.height + "px" }),
        onPointerdown: v[0] || (v[0] = (x) => h("move", x)),
        onPointermove: f,
        onPointerup: p,
        onPointercancel: p
      }, [
        v[1] || (v[1] = u("i", { class: "third v1" }, null, -1)),
        v[2] || (v[2] = u("i", { class: "third v2" }, null, -1)),
        v[3] || (v[3] = u("i", { class: "third h1" }, null, -1)),
        v[4] || (v[4] = u("i", { class: "third h2" }, null, -1)),
        (g(), b(j, null, be(d, (x) => u("span", {
          key: x,
          class: G(["ed-crop-h", "h-" + x]),
          "data-handle": x,
          onPointerdown: (w) => h(x, w),
          onPointermove: f,
          onPointerup: p,
          onPointercancel: p
        }, null, 42, ife)), 64)),
        u("span", sfe, E(l.value.w) + " × " + E(l.value.h), 1)
      ], 36)
    ], 2));
  }
}), rfe = ["src"], afe = ["data-handle", "onPointerdown"], lfe = { class: "ed-crop-size" }, d4 = 32, dfe = /* @__PURE__ */ Pe({
  __name: "ExpandStage",
  props: {
    room: {}
  },
  setup(i) {
    const e = i, t = yt(), n = t.tools, s = I(() => t.stage.value), o = I(() => n.frame()), r = /* @__PURE__ */ K(!1), a = I(() => {
      const p = o.value;
      if (!p) return null;
      const y = Math.max(80, e.room.w - d4 * 2), v = Math.max(80, e.room.h - d4 * 2), x = Math.min(y / p.cw, v / p.ch), w = Math.round(p.cw * x), S = Math.round(p.ch * x);
      return { k: x, w, h: S, left: Math.round((e.room.w - w) / 2), top: Math.round((e.room.h - S) / 2) };
    }), l = I(() => {
      const p = o.value, y = a.value;
      return !p || !y ? null : { left: p.ix * y.k, top: p.iy * y.k, width: p.iw * y.k, height: p.ih * y.k };
    });
    let d = null;
    function c(p, y) {
      y.button !== 0 || !o.value || !a.value || (y.preventDefault(), y.stopPropagation(), y.currentTarget.setPointerCapture(y.pointerId), d = { kind: p, x0: y.clientX, y0: y.clientY, start: { ...o.value }, k: a.value.k }, r.value = !0);
    }
    function h(p) {
      if (!d) return;
      const y = (p.clientX - d.x0) / d.k, v = (p.clientY - d.y0) / d.k;
      if (d.kind === "pic") {
        n.setFrame(She(d.start, y, v));
        return;
      }
      const x = d.kind === "e" ? y : d.kind === "w" ? -y : d.kind === "s" ? v : -v;
      let w = _he(d.start, d.kind, Math.round(x));
      d.kind === "e" && (w = { ...w, cw: Math.max(w.cw, w.ix + w.iw * 0.5) }), d.kind === "s" && (w = { ...w, ch: Math.max(w.ch, w.iy + w.ih * 0.5) }), n.t.resize.frameRatio = "free", n.setFrame(w);
    }
    function f(p) {
      const y = p.currentTarget;
      y.hasPointerCapture(p.pointerId) && y.releasePointerCapture(p.pointerId), d = null, r.value = !1;
    }
    return (p, y) => s.value && a.value && l.value && o.value ? (g(), b("div", {
      key: 0,
      class: G(["ed-expand", { "is-active": r.value }]),
      style: ce({ left: a.value.left + "px", top: a.value.top + "px", width: a.value.w + "px", height: a.value.h + "px" }),
      "data-testid": "studio-expand-frame"
    }, [
      y[2] || (y[2] = u("div", { class: "ed-expand-room" }, null, -1)),
      u("div", {
        class: "ed-expand-pic",
        style: ce({ left: l.value.left + "px", top: l.value.top + "px", width: l.value.width + "px", height: l.value.height + "px" }),
        onPointerdown: y[0] || (y[0] = (v) => c("pic", v)),
        onPointermove: h,
        onPointerup: f,
        onPointercancel: f
      }, [
        u("img", {
          src: s.value.url,
          alt: "",
          draggable: "false"
        }, null, 8, rfe)
      ], 36),
      (g(), b(j, null, be(["n", "s", "e", "w"], (v) => u("span", {
        key: v,
        class: G(["ed-expand-h", "h-" + v]),
        "data-handle": v,
        onPointerdown: (x) => c(v, x),
        onPointermove: h,
        onPointerup: f,
        onPointercancel: f
      }, [...y[1] || (y[1] = [
        u("i", null, null, -1)
      ])], 42, afe)), 64)),
      u("span", lfe, E(Math.round(o.value.cw)) + " × " + E(Math.round(o.value.ch)), 1)
    ], 6)) : z("", !0);
  }
}), cfe = {
  key: 0,
  class: "ed-stage-note"
}, ufe = /* @__PURE__ */ Pe({
  __name: "AdjustCanvas",
  props: {
    w: {},
    h: {}
  },
  setup(i) {
    const e = i, n = yt().tools, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(!1);
    let a = null, l = "", d = { w: 1, h: 1 }, c = null, h = 0;
    const f = I(() => n.adjustSource());
    async function p() {
      const v = f.value;
      if (!(!v || !a) && v.url !== l) {
        l = v.url, o.value = !1;
        try {
          const x = await si(v.url);
          if (!a || l !== v.url) return;
          a.setImage(x, x.width, x.height), d = { w: x.width, h: x.height }, o.value = !0, y();
        } catch (x) {
          console.warn("[board] Adjust couldn't read the picture", x), r.value = !0;
        }
      }
    }
    function y() {
      cancelAnimationFrame(h), h = requestAnimationFrame(() => {
        if (!a || !o.value) return;
        const v = n.t.adjust.a, x = Math.min(2, window.devicePixelRatio || 1), w = su(v, e.w, e.h), S = Math.max(1, Math.round(w.w * x)), M = Math.max(1, Math.round(w.h * x)), _ = su(v, d.w, d.h);
        a.render(v, S, M, { transfer: c, original: n.t.adjust.original, grainScale: S / Math.max(1, _.w) });
      });
    }
    return ot(() => {
      if (s.value) {
        try {
          a = new DI(s.value);
        } catch (v) {
          console.warn("[board] Adjust has no WebGL 2 here", v), r.value = !0;
          return;
        }
        p();
      }
    }), We(() => {
      cancelAnimationFrame(h), a && a.dispose(), a = null;
    }), Ae(f, () => {
      p();
    }), Ae(() => [n.t.adjust.a, n.t.adjust.original, e.w, e.h], y, { deep: !0 }), Ae(() => [n.t.adjust.a.match.to, n.t.adjust.a.match.stats, f.value && f.value.url], async () => {
      c = await n.transfer(), y();
    }, { immediate: !0 }), (v, x) => (g(), b(j, null, [
      u("canvas", {
        ref_key: "el",
        ref: s,
        class: G(["ed-adjust-canvas", { "is-ready": o.value }]),
        style: ce({ width: i.w + "px", height: i.h + "px" }),
        "data-testid": "studio-adjust-preview"
      }, null, 6),
      r.value ? (g(), b("span", cfe, "This picture can't be adjusted live here")) : z("", !0)
    ], 64));
  }
}), hfe = /* @__PURE__ */ Pe({
  __name: "LayersPreview",
  props: {
    w: {},
    h: {}
  },
  setup(i) {
    const e = i, t = yt(), n = t.tools, s = /* @__PURE__ */ K(null);
    let o = 0;
    const r = I(() => n.t.background), a = I(() => t.stage.value), l = I(() => n.cutoutFor(a.value)), d = I(() => {
      const p = a.value, y = l.value;
      return !p || !y ? null : y === p ? t.items.value.find((v) => v.id === p.parentId) || null : p;
    }), c = I(() => r.value.mode === "remove" ? r.value.fill !== void 0 && n.isCutout(a.value) : r.value.mode === "adjust" && !!l.value && !!d.value && nu(r.value.layer));
    async function h() {
      var p;
      const y = s.value;
      if (!y || !c.value) return;
      const v = Math.min(2, window.devicePixelRatio || 1), x = Math.max(1, Math.round(e.w * v)), w = Math.max(1, Math.round(e.h * v));
      try {
        let S;
        if (r.value.mode === "remove") {
          const _ = await si(a.value.url), T = Rn(x, w);
          zn(T).drawImage(_, 0, 0, x, w), S = II(T, (p = r.value.fill) != null ? p : null);
        } else {
          const [_, T] = await Promise.all([si(d.value.url), si(l.value.url)]);
          S = AI(_, T, r.value.layer, x, w);
        }
        y.width = x, y.height = w;
        const M = zn(y);
        M.clearRect(0, 0, x, w), M.drawImage(S, 0, 0);
      } catch (S) {
        console.warn("[board] the background preview couldn't be drawn", S);
      }
    }
    function f() {
      cancelAnimationFrame(o), o = requestAnimationFrame(() => {
        h();
      });
    }
    return ot(f), We(() => cancelAnimationFrame(o)), Ae(() => [r.value.fill, r.value.layer, r.value.mode, e.w, e.h, a.value && a.value.url, c.value], f, { deep: !0 }), (p, y) => (g(), Ce(vt, { name: "ed-fade" }, {
      default: Xe(() => [
        kt(u("canvas", {
          ref_key: "el",
          ref: s,
          class: G(["ed-layers-canvas", { "is-clear": r.value.mode === "remove" && r.value.fill === null }]),
          style: ce({ width: i.w + "px", height: i.h + "px" }),
          "data-testid": "studio-background-preview"
        }, null, 6), [
          [bv, c.value]
        ])
      ]),
      _: 1
    }));
  }
}), pfe = ["src"], ffe = { class: "ed-compare-tag is-left" }, mfe = { class: "ed-compare-tag is-right" }, gfe = {
  key: 1,
  class: "ed-compare-tag is-left"
}, bfe = /* @__PURE__ */ Pe({
  __name: "CompareOverlay",
  props: {
    w: {},
    h: {}
  },
  setup(i) {
    const e = yt(), t = e.tools, n = I(() => t.t.compare), s = I(() => n.value && e.items.value.find((p) => p.id === n.value.with) || null), o = I(() => s.value ? e.names.value.get(s.value.id) || s.value.label : ""), r = I(() => e.stage.value ? e.names.value.get(e.stage.value.id) || "This" : ""), a = /* @__PURE__ */ K(null);
    let l = !1;
    function d(p) {
      if (!a.value || !t.t.compare) return;
      const y = a.value.getBoundingClientRect();
      t.t.compare.at = Math.min(1, Math.max(0, (p.clientX - y.left) / y.width));
    }
    function c(p) {
      if (!(p.button !== 0 || !n.value)) {
        if (p.stopPropagation(), n.value.mode === "toggle") {
          t.t.compare.other = !0;
          return;
        }
        l = !0, p.currentTarget.setPointerCapture(p.pointerId), d(p);
      }
    }
    function h(p) {
      l && d(p);
    }
    function f() {
      l = !1, t.t.compare && (t.t.compare.other = !1);
    }
    return (p, y) => n.value && s.value ? (g(), b("div", {
      key: 0,
      ref_key: "layer",
      ref: a,
      class: G(["sv-layer ed-compare", "is-" + n.value.mode]),
      "data-testid": "studio-compare-view",
      onPointerdown: c,
      onPointermove: h,
      onPointerup: f,
      onPointercancel: f,
      onPointerleave: f
    }, [
      u("div", {
        class: "ed-compare-other",
        style: ce(n.value.mode === "split" ? { clipPath: "inset(0 " + (100 - n.value.at * 100) + "% 0 0)" } : { opacity: n.value.other ? 1 : 0 })
      }, [
        u("img", {
          src: s.value.url,
          alt: "",
          draggable: "false"
        }, null, 8, pfe)
      ], 4),
      n.value.mode === "split" ? (g(), b(j, { key: 0 }, [
        u("i", {
          class: "ed-compare-line",
          style: ce({ left: n.value.at * 100 + "%" })
        }, [
          u("span", null, [
            C($, {
              name: "ChevronLeft",
              size: 12
            }),
            C($, {
              name: "ChevronRight",
              size: 12
            })
          ])
        ], 4),
        u("span", ffe, E(o.value), 1),
        u("span", mfe, E(r.value), 1)
      ], 64)) : (g(), b("span", gfe, E(n.value.other ? o.value : r.value) + " · press and hold to see " + E(n.value.other ? r.value : o.value), 1))
    ], 34)) : z("", !0);
  }
}), vfe = {
  key: 0,
  class: "ed-cam-stage",
  "data-testid": "studio-camera-preview"
}, yfe = { class: "ed-cam-view" }, xfe = ["src"], wfe = { class: "ed-cam-hud" }, kfe = /* @__PURE__ */ Pe({
  __name: "CameraPreview",
  props: {
    room: {}
  },
  setup(i) {
    const e = i, t = yt(), n = I(() => t.stage.value), s = I(() => ro(t.tools.t.camera.set)), o = I(() => {
      const d = n.value;
      if (!d) return null;
      const h = Math.min(e.room.w * 0.42, e.room.h * 0.5) / Math.max(d.w, d.h), f = Math.round(d.w * h), p = Math.round(d.h * h);
      return { w: f, h: p, d: Math.round(Math.min(f, p) * 0.55) };
    }), r = I(() => {
      const d = s.value;
      return { transform: "scale(" + (0.8 + d.zoom / 10 * 0.45).toFixed(3) + ") rotateX(" + (-d.vertical * 0.72).toFixed(1) + "deg) rotateY(" + (-Wy(d.rotate)).toFixed(1) + "deg)" };
    }), a = I(() => n.value ? 'url("' + n.value.url + '")' : "none");
    function l(d, c, h, f) {
      const p = o.value;
      return {
        width: d + "px",
        height: c + "px",
        left: (p.w - d) / 2 + "px",
        top: (p.h - c) / 2 + "px",
        transform: h,
        backgroundImage: a.value,
        backgroundPosition: f,
        backgroundSize: p.w + "px " + p.h + "px"
      };
    }
    return (d, c) => n.value && o.value ? (g(), b("div", vfe, [
      u("div", yfe, [
        u("div", {
          class: "ed-cam-scene",
          style: ce({ ...r.value, top: o.value.h / 2 + "px" })
        }, [
          c[1] || (c[1] = u("div", { class: "ed-cam-floor" }, null, -1)),
          u("div", {
            class: "ed-cam-box",
            style: ce({ width: o.value.w + "px", height: o.value.h + "px", marginLeft: -o.value.w / 2 + "px", marginTop: -o.value.h + "px" })
          }, [
            u("img", {
              class: "ed-cam-face is-front",
              src: n.value.url,
              alt: "",
              draggable: "false",
              style: ce({ transform: "translateZ(" + o.value.d / 2 + "px)" })
            }, null, 12, xfe),
            u("i", {
              class: "ed-cam-face is-side",
              style: ce(l(o.value.d, o.value.h, "rotateY(90deg) translateZ(" + o.value.w / 2 + "px)", "right center"))
            }, null, 4),
            u("i", {
              class: "ed-cam-face is-side",
              style: ce(l(o.value.d, o.value.h, "rotateY(-90deg) translateZ(" + o.value.w / 2 + "px)", "left center"))
            }, null, 4),
            u("i", {
              class: "ed-cam-face is-side is-top",
              style: ce(l(o.value.w, o.value.d, "rotateX(90deg) translateZ(" + o.value.h / 2 + "px)", "center top"))
            }, null, 4),
            u("i", {
              class: "ed-cam-face is-back",
              style: ce(l(o.value.w, o.value.h, "rotateY(180deg) translateZ(" + o.value.d / 2 + "px)", "center"))
            }, [...c[0] || (c[0] = [
              u("span", null, "Not in the picture: invented", -1)
            ])], 4)
          ], 4)
        ], 4)
      ]),
      u("div", wfe, [
        u("b", null, E(m(kc)(s.value)), 1),
        u("span", null, "A preview of the move. The model draws the new view" + E(m(JC)(s.value) ? ", inventing what the picture doesn't show" : "") + ".", 1)
      ])
    ])) : z("", !0);
  }
}), _fe = {
  key: 0,
  class: "ed-relight-preview",
  "data-testid": "studio-relight-preview"
}, Sfe = /* @__PURE__ */ Pe({
  __name: "RelightPreview",
  props: {
    w: {},
    h: {}
  },
  setup(i) {
    const e = yt(), t = I(() => e.tools.t.relight.rig);
    function n(a) {
      const l = $f(a), d = (a.rotate % 360 + 360) % 360, c = d >= 135 && d <= 225, h = Math.min(0.85, 0.25 + a.intensity * 0.06);
      if (c)
        return "radial-gradient(ellipse 70% 80% at 50% 50%, transparent 55%, " + a.color + " 100%)";
      const f = 50 + l.x * 62, p = 50 + l.y * 62;
      return "radial-gradient(circle at " + f.toFixed(0) + "% " + p.toFixed(0) + "%, " + a.color + " 0%, " + s(a.color, h * 0.55) + " 26%, transparent " + (t.value.softness === "soft" ? 78 : 58) + "%)";
    }
    function s(a, l) {
      const d = /^#?([0-9a-f]{6})$/i.exec(a), c = d ? parseInt(d[1], 16) : 16777215;
      return "rgba(" + (c >> 16 & 255) + "," + (c >> 8 & 255) + "," + (c & 255) + "," + l.toFixed(2) + ")";
    }
    const o = I(() => t.value.lights[0] || null), r = I(() => {
      const a = o.value;
      if (!a) return "";
      const l = $f(a);
      return Math.hypot(l.x, l.y) < 0.25 ? "" : "radial-gradient(circle at " + (50 - l.x * 70).toFixed(0) + "% " + (50 - l.y * 70).toFixed(0) + "%, rgba(4,3,12,0.5), transparent 70%)";
    });
    return (a, l) => t.value.mode === "relight" ? (g(), b("div", _fe, [
      r.value ? (g(), b("i", {
        key: 0,
        class: "shade",
        style: ce({ background: r.value })
      }, null, 4)) : z("", !0),
      (g(!0), b(j, null, be(t.value.lights, (d) => (g(), b("i", {
        key: d.id,
        class: "wash",
        style: ce({ background: n(d), opacity: Math.min(0.9, 0.3 + d.intensity * 0.05) })
      }, null, 4))), 128)),
      l[0] || (l[0] = u("span", { class: "ed-stage-note" }, "A hint of the light. The model relights the picture.", -1))
    ])) : z("", !0);
  }
}), Mfe = ["aria-label"], Tfe = { class: "ed-guard-card" }, Cfe = { class: "ic" }, Ife = { class: "tx" }, Afe = { class: "acts" }, Pfe = /* @__PURE__ */ Pe({
  __name: "GuardAsk",
  setup(i) {
    const e = yt(), t = e.tools, n = I(() => t.t.guard), s = I(() => n.value ? ex(n.value.tool) : null), o = I(() => {
      const l = n.value ? n.value.tool : null;
      return l === "resize" ? t.t.resize.mode === "crop" ? "your crop" : "the expanded frame" : l === "background" ? t.t.background.mode === "adjust" ? "your background adjustments" : "the new background" : l === "adjust" ? "your adjustments" : "your changes";
    }), r = I(() => (n.value ? n.value.tool : null) === "resize" && t.t.resize.mode === "expand" ? "Expand (" + e.priceOf("expand") + ")" : "Apply");
    function a(l) {
      n.value && (l.key === "Escape" ? (l.preventDefault(), l.stopImmediatePropagation(), t.stay()) : l.key === "Enter" && (l.preventDefault(), l.stopImmediatePropagation(), t.answer(!0)));
    }
    return ot(() => window.addEventListener("keydown", a, !0)), We(() => window.removeEventListener("keydown", a, !0)), (l, d) => (g(), Ce(vt, { name: "ed-guard" }, {
      default: Xe(() => [
        n.value && s.value ? (g(), b("div", {
          key: 0,
          class: "ed-guard",
          role: "alertdialog",
          "aria-modal": "true",
          "aria-label": "Apply " + o.value + "?",
          "data-testid": "studio-tool-guard",
          onPointerdown: d[2] || (d[2] = Se((c) => m(t).stay(), ["self"]))
        }, [
          u("div", Tfe, [
            u("span", Cfe, [
              C($, {
                name: s.value.icon,
                size: 16
              }, null, 8, ["name"])
            ]),
            u("div", Ife, [
              u("b", null, "Apply " + E(o.value) + "?", 1),
              u("span", null, E(s.value.label) + " has a change that isn't a version yet. Apply makes it one; Discard leaves the picture as it was.", 1)
            ]),
            u("div", Afe, [
              u("button", {
                class: "sv-btn",
                "data-testid": "studio-tool-discard",
                onClick: d[0] || (d[0] = (c) => m(t).answer(!1))
              }, "Discard"),
              u("button", {
                class: "sv-btn is-primary",
                "data-testid": "studio-tool-apply",
                onClick: d[1] || (d[1] = (c) => m(t).answer(!0))
              }, E(r.value), 1)
            ])
          ])
        ], 40, Mfe)) : z("", !0)
      ]),
      _: 1
    }));
  }
}), Efe = ["disabled", "title"], Rfe = ["aria-expanded", "aria-label"], zfe = ["disabled", "title"], $fe = {
  key: 0,
  class: "sv-pop sv-zoom-pop",
  role: "menu",
  "aria-label": "Zoom",
  "data-testid": "studio-zoom-menu"
}, Dfe = ["disabled"], Ofe = ["disabled"], Lfe = ["disabled"], Bfe = /* @__PURE__ */ Pe({
  __name: "StageZoom",
  props: {
    share: {},
    fitted: { type: Boolean },
    atMin: { type: Boolean },
    atMax: { type: Boolean }
  },
  emits: ["step", "fit", "actual"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = /* @__PURE__ */ K(!1), o = /* @__PURE__ */ K(null), r = I(() => Math.round(t.share * 100) + "%"), a = {
      in: En(["mod", "+"]),
      out: En(["mod", "-"]),
      actual: En(["mod", "0"]),
      fit: "D"
    };
    function l(f) {
      s.value = !1, f === "in" ? n("step", 1) : f === "out" ? n("step", -1) : n(f === "actual" ? "actual" : "fit");
    }
    function d(f) {
      o.value && !o.value.contains(f.target) && (s.value = !1);
    }
    function c(f) {
      f.key === "Escape" && (f.stopPropagation(), f.preventDefault(), s.value = !1);
    }
    function h() {
      window.removeEventListener("pointerdown", d, !0), window.removeEventListener("keydown", c, !0);
    }
    return Ae(s, (f) => {
      if (!f) {
        h();
        return;
      }
      window.addEventListener("pointerdown", d, !0), window.addEventListener("keydown", c, !0);
    }), We(h), (f, p) => (g(), b("span", {
      ref_key: "wrap",
      ref: o,
      class: "sv-zoom",
      "data-testid": "studio-zoom",
      onPointerdown: p[7] || (p[7] = Se(() => {
      }, ["stop"]))
    }, [
      u("button", {
        class: "sv-zoom-btn",
        disabled: i.atMin,
        title: "Zoom out (" + a.out + ")",
        "aria-label": "Zoom out",
        "data-testid": "studio-zoom-out",
        onClick: p[0] || (p[0] = (y) => n("step", -1))
      }, [
        C($, {
          name: "Minus",
          size: 12
        })
      ], 8, Efe),
      u("button", {
        class: G(["sv-zoom-pct", { on: s.value }]),
        "aria-haspopup": "menu",
        "aria-expanded": s.value,
        "aria-label": "Zoom: " + r.value,
        "data-testid": "studio-zoom-pct",
        onClick: p[1] || (p[1] = (y) => s.value = !s.value)
      }, [
        J(E(r.value), 1),
        C($, {
          name: "ChevronDown",
          size: 11,
          class: "chev"
        })
      ], 10, Rfe),
      u("button", {
        class: "sv-zoom-btn",
        disabled: i.atMax,
        title: "Zoom in (" + a.in + ")",
        "aria-label": "Zoom in",
        "data-testid": "studio-zoom-in",
        onClick: p[2] || (p[2] = (y) => n("step", 1))
      }, [
        C($, {
          name: "Plus",
          size: 12
        })
      ], 8, zfe),
      s.value ? (g(), b("div", $fe, [
        u("button", {
          class: "sv-pop-row",
          role: "menuitem",
          disabled: i.atMax,
          "data-testid": "studio-zoom-menu-in",
          onClick: p[3] || (p[3] = (y) => l("in"))
        }, [
          p[8] || (p[8] = u("span", { class: "nm" }, "Zoom in", -1)),
          u("kbd", null, E(a.in), 1)
        ], 8, Dfe),
        u("button", {
          class: "sv-pop-row",
          role: "menuitem",
          disabled: i.atMin,
          "data-testid": "studio-zoom-menu-out",
          onClick: p[4] || (p[4] = (y) => l("out"))
        }, [
          p[9] || (p[9] = u("span", { class: "nm" }, "Zoom out", -1)),
          u("kbd", null, E(a.out), 1)
        ], 8, Ofe),
        u("button", {
          class: "sv-pop-row",
          role: "menuitem",
          "data-testid": "studio-zoom-menu-actual",
          onClick: p[5] || (p[5] = (y) => l("actual"))
        }, [
          p[10] || (p[10] = u("span", { class: "nm" }, "Zoom to 100%", -1)),
          u("kbd", null, E(a.actual), 1)
        ]),
        u("button", {
          class: "sv-pop-row",
          role: "menuitem",
          disabled: i.fitted,
          "data-testid": "studio-zoom-menu-fit",
          onClick: p[6] || (p[6] = (y) => l("fit"))
        }, [
          p[11] || (p[11] = u("span", { class: "nm" }, "Zoom to fit", -1)),
          u("kbd", null, E(a.fit), 1)
        ], 8, Lfe)
      ])) : z("", !0)
    ], 544));
  }
}), Bh = { k: 1, cx: 0.5, cy: 0.5 }, _r = [0.1, 0.125, 0.25, 1 / 3, 0.5, 2 / 3, 1, 1.5, 2, 3, 4, 6, 8], Ffe = 8, Nfe = 0.25;
function c4(i) {
  return Math.abs(i.k - 1) < 1e-4 && Math.abs(i.cx - 0.5) < 1e-4 && Math.abs(i.cy - 0.5) < 1e-4;
}
function WI(i, e) {
  const t = i.w * e.k, n = i.h * e.k;
  return { left: i.left + i.w / 2 - e.cx * t, top: i.top + i.h / 2 - e.cy * n, w: t, h: n };
}
function Ufe(i, e) {
  const t = Math.max(i.left, e.left), n = Math.max(i.top, e.top), s = Math.min(i.left + i.w, e.left + e.w), o = Math.min(i.top + i.h, e.top + e.h);
  return { left: t, top: n, w: Math.max(0, s - t), h: Math.max(0, o - n) };
}
function u4(i, e, t) {
  const n = (s, o, r, a, l) => {
    if (o <= l) return 0.5;
    const d = (r - a) / o, c = (r + o - a - l) / o;
    return Math.min(c, Math.max(d, s));
  };
  return {
    k: i.k,
    cx: n(i.cx, e.w * i.k, e.left + e.w / 2, t.left, t.w),
    cy: n(i.cy, e.h * i.k, e.top + e.h / 2, t.top, t.h)
  };
}
function Gfe(i, e, t, n, s) {
  const o = WI(s, i), r = (t - o.left) / o.w, a = (n - o.top) / o.h;
  return { k: e, cx: (s.left + s.w / 2 - t) / (s.w * e) + r, cy: (s.top + s.h / 2 - n) / (s.h * e) + a };
}
function h4(i, e, t, n) {
  return { k: i.k, cx: i.cx - e / (n.w * i.k), cy: i.cy - t / (n.h * i.k) };
}
function jfe(i, e, t) {
  return e * i / Math.max(1, t);
}
function B0(i, e, t) {
  return i * Math.max(1, t) / Math.max(1, e);
}
function Hfe(i, e) {
  return { min: Nfe, max: Math.max(1, B0(Ffe, i, e)) };
}
function Vfe(i, e) {
  if (e > 0) {
    const t = _r.find((n) => n > i * 1.01);
    return t == null ? _r[_r.length - 1] : t;
  }
  for (let t = _r.length - 1; t >= 0; t--) if (_r[t] < i * 0.99) return _r[t];
  return _r[0];
}
function Wfe(i) {
  return Math.exp(-Math.max(-60, Math.min(60, i)) / 100);
}
const qfe = {
  key: 1,
  class: "sv-invite",
  "data-testid": "studio-3d-empty"
}, Kfe = { class: "sv-invite-mark" }, Yfe = {
  key: 0,
  class: "sv-model-state is-inline",
  "data-testid": "studio-3d-keeping"
}, Xfe = {
  key: 1,
  class: "sv-invite-acts"
}, Jfe = ["title"], Zfe = ["src", "poster"], Qfe = ["src"], eme = {
  key: 0,
  class: "sv-pic-unsaved is-marks",
  title: "Its annotations go with it when it's sent"
}, tme = {
  key: 3,
  class: "sv-promote is-done",
  "data-testid": "studio-stage-on-board",
  title: "This is the version the board shows"
}, nme = {
  key: 4,
  class: "ed-stage-tools"
}, ime = ["aria-pressed", "title"], sme = {
  key: 0,
  class: "sv-seg is-small is-dark"
}, ome = {
  key: 0,
  class: "ed-baking"
}, rme = {
  key: 5,
  class: "sv-invite is-making"
}, ame = {
  key: 6,
  class: "sv-invite",
  "data-testid": "studio-edit-empty"
}, lme = { class: "sv-invite-mark" }, dme = { class: "sv-invite-acts" }, cme = {
  key: 7,
  class: "sv-edit-video",
  "data-testid": "studio-edit-video"
}, ume = ["src", "poster"], hme = ["src"], pme = { class: "sv-invite-acts" }, fme = {
  key: 8,
  class: "sv-invite",
  "data-testid": "studio-empty"
}, mme = { class: "sv-invite-mark" }, gme = { class: "sub" }, bme = { class: "sv-invite-acts" }, vme = {
  key: 9,
  class: "sv-invite",
  "data-testid": "studio-empty"
}, yme = { class: "sv-invite-mark" }, xme = { class: "sv-invite-acts" }, wme = {
  key: 10,
  class: "sv-invite",
  "data-testid": "studio-empty"
}, kme = { class: "sv-invite-mark" }, _me = { class: "sv-invite-acts" }, Ad = 8, Sme = /* @__PURE__ */ Pe({
  __name: "Stage",
  emits: ["upload", "upload-model", "library-model", "upload-video"],
  setup(i, { expose: e, emit: t }) {
    const n = t, s = yt(), { board: o } = Ze(), r = s.s, a = s.tools, l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K({ w: 800, h: 600 }), c = /* @__PURE__ */ K(null), h = /* @__PURE__ */ K(""), f = /* @__PURE__ */ K(null), p = I(() => s.stage.value), y = I(() => {
      const ze = p.value && s.resultOf(p.value);
      return ze && ze.video && ze.videoSrc || null;
    }), v = I(() => s.side.value === "edit"), x = I(() => v.value ? a.t.open : null), w = I(() => x.value === "resize" && a.t.resize.mode === "expand"), S = I(() => x.value === "adjust"), M = /* @__PURE__ */ K(!1);
    Ae(() => r.stageId, (ze, Ee) => {
      x.value === "camera" && ze && Ee && ze !== Ee && (M.value = !0);
    }), Ae(() => a.t.camera.set, () => {
      M.value = !1;
    }, { deep: !0 }), Ae(x, (ze) => {
      ze !== "camera" && (M.value = !1);
    });
    const _ = I(() => x.value === "camera" && !M.value), T = I(() => {
      const ze = p.value;
      if (!ze) return null;
      if (S.value) {
        const Ee = a.adjustSource() || ze;
        return su(a.t.adjust.a, Ee.w, Ee.h);
      }
      return { w: ze.w, h: ze.h };
    }), k = I(() => {
      const ze = T.value;
      if (!ze) return null;
      const Ee = 32, lt = Math.max(80, d.value.w - Ee * 2), nn = Math.max(80, d.value.h - Ee * 2), Ui = Math.min(lt / ze.w, nn / ze.h), ho = Math.round(ze.w * Ui), po = Math.round(ze.h * Ui);
      return { w: ho, h: po, left: Math.round((d.value.w - ho) / 2), top: Math.round((d.value.h - po) / 2) };
    }), P = /* @__PURE__ */ K({ ...Bh }), A = /* @__PURE__ */ K(null), R = /* @__PURE__ */ K(!1);
    let D = 0;
    const O = I(() => !!p.value && p.value.status === "done" && !!k.value && r.studio !== "threed" && !w.value && !_.value && x.value !== "resize"), F = I(() => ({ left: Ad, top: Ad, w: Math.max(1, d.value.w - Ad * 2), h: Math.max(1, d.value.h - Ad * 2) })), te = I(() => O.value ? P.value : Bh), ee = I(() => !c4(te.value)), me = I(() => k.value ? WI(k.value, te.value) : null), L = I(() => me.value ? ee.value ? Ufe(me.value, F.value) : me.value : null), N = I(() => {
      const ze = T.value, Ee = p.value;
      if (!ze) return 1;
      const lt = A.value;
      return lt && Ee && Ee.w ? lt.w * (ze.w / Ee.w) : ze.w;
    }), X = I(() => k.value ? jfe(te.value.k, k.value.w, N.value) : 1), B = I(() => k.value ? Hfe(k.value.w, N.value) : { min: 1, max: 1 }), se = I(() => ee.value && !!L.value && L.value.top < Ad + 30), V = I(() => {
      const ze = L.value;
      return ze ? { left: ze.left + "px", top: ze.top + "px", width: ze.w + "px", height: ze.h + "px" } : {};
    }), Z = I(() => {
      const ze = me.value, Ee = L.value, lt = k.value;
      if (!ee.value || !ze || !Ee || !lt) return {};
      const nn = te.value.k;
      return { left: ze.left - Ee.left + "px", top: ze.top - Ee.top + "px", width: lt.w + "px", height: lt.h + "px", transform: "scale(" + nn + ")", "--zoom": String(nn) };
    });
    function Y(ze, Ee = !1) {
      const lt = k.value;
      lt && (P.value = u4(ze, lt, F.value), R.value = Ee, clearTimeout(D), Ee && (D = window.setTimeout(() => {
        R.value = !1;
      }, 280)));
    }
    function H(ze, Ee = null, lt = !0) {
      const nn = k.value;
      if (!nn || !O.value) return;
      const Ui = Math.min(B.value.max, Math.max(B.value.min, ze)), ho = Ee || { x: F.value.left + F.value.w / 2, y: F.value.top + F.value.h / 2 };
      Y(Gfe(P.value, Ui, ho.x, ho.y, nn), lt);
    }
    function re(ze) {
      const Ee = k.value;
      Ee && H(B0(Vfe(X.value, ze), Ee.w, N.value));
    }
    function le() {
      O.value && Y({ ...Bh }, !0);
    }
    function he() {
      const ze = k.value;
      ze && H(B0(1, ze.w, N.value));
    }
    function Re(ze, Ee) {
      if (!O.value) return !1;
      const lt = kn(ze);
      if (lt && (ze.key === "=" || ze.key === "+")) re(1);
      else if (lt && (ze.key === "-" || ze.key === "_")) re(-1);
      else if (lt && ze.key === "0") he();
      else if (!lt && !Ee && !ze.altKey && !ze.shiftKey && ze.key.toLowerCase() === "d") le();
      else return !1;
      return !0;
    }
    function Ne(ze) {
      const Ee = k.value, lt = me.value;
      if (!O.value || !Ee || !lt || !l.value) return;
      const nn = l.value.getBoundingClientRect(), Ui = ze.deltaMode === 1 ? 16 : ze.deltaMode === 2 ? nn.height : 1;
      if (ze.ctrlKey || ze.metaKey) {
        ze.preventDefault(), H(P.value.k * Wfe(ze.deltaY * Ui), { x: ze.clientX - nn.left, y: ze.clientY - nn.top }, !1);
        return;
      }
      lt.w <= F.value.w + 0.5 && lt.h <= F.value.h + 0.5 || (ze.preventDefault(), Y(h4(P.value, -ze.deltaX * Ui, -ze.deltaY * Ui, Ee)));
    }
    const Me = /* @__PURE__ */ K(!1), ue = /* @__PURE__ */ K(!1);
    let U = null;
    function q(ze) {
      const Ee = ze;
      return !!Ee && (Ee.tagName === "INPUT" || Ee.tagName === "TEXTAREA" || Ee.isContentEditable);
    }
    function ie(ze) {
      ze.code !== "Space" || q(ze.target) || !O.value || (ze.preventDefault(), Me.value = !0);
    }
    function de(ze) {
      ze.code === "Space" && (Me.value && ze.preventDefault(), Me.value = !1);
    }
    function pe() {
      Me.value = !1;
    }
    function Te(ze) {
      !O.value || !l.value || !(Me.value && ze.button === 0) && ze.button !== 1 || (ze.preventDefault(), ze.stopPropagation(), l.value.setPointerCapture(ze.pointerId), U = { id: ze.pointerId, x: ze.clientX, y: ze.clientY }, ue.value = !0);
    }
    function Be(ze) {
      const Ee = k.value;
      !U || U.id !== ze.pointerId || !Ee || (Y(h4(P.value, ze.clientX - U.x, ze.clientY - U.y, Ee)), U = { id: U.id, x: ze.clientX, y: ze.clientY });
    }
    function ge(ze) {
      !U || U.id !== ze.pointerId || (l.value && l.value.hasPointerCapture(ze.pointerId) && l.value.releasePointerCapture(ze.pointerId), U = null, ue.value = !1);
    }
    function ne(ze) {
      const Ee = ze.target;
      p.value && (h.value = p.value.url), Ee.naturalWidth && (A.value = { w: Ee.naturalWidth, h: Ee.naturalHeight });
    }
    function oe(ze) {
      const Ee = ze.target;
      p.value && (h.value = p.value.url), Ee.videoWidth && (A.value = { w: Ee.videoWidth, h: Ee.videoHeight });
    }
    let ye = 0;
    Ae(() => p.value && p.value.status === "done" ? T.value : null, (ze) => {
      if (!ze) return;
      const Ee = ze.h ? ze.w / ze.h : 0;
      (!ye || !Ee || Math.abs(Ee - ye) / ye > 0.04) && (P.value = { ...Bh }), ye = Ee;
    }, { immediate: !0 }), Ae(() => p.value ? p.value.url : null, () => {
      A.value = null;
    });
    let Oe = 0;
    Ae([k, F, B], () => {
      const ze = k.value;
      if (!ze) return;
      const Ee = Oe;
      if (Oe = ze.w, c4(P.value)) return;
      const lt = Ee && Ee !== ze.w ? P.value.k * (Ee / ze.w) : P.value.k, nn = Math.min(B.value.max, Math.max(B.value.min, lt));
      P.value = u4({ ...P.value, k: nn }, ze, F.value);
    });
    const Ve = I(() => v.value && !x.value && r.bar === "annotate"), Ue = I(() => Ve.value && r.tool === "note"), tt = I(() => v.value && !x.value && r.bar !== "annotate"), Ye = I(() => {
      const ze = s.marksOf(p.value);
      return x.value ? { strokes: [], pins: [] } : Ue.value ? { strokes: ze.strokes, pins: [] } : { strokes: ze.strokes, pins: ze.pins };
    }), at = I(() => r.editingText ? [r.editingText] : []), wt = I(() => {
      const ze = p.value;
      if (!ze) return "";
      const Ee = s.names.value.get(ze.id), lt = ze.parentId ? s.names.value.get(ze.parentId) : null, nn = Ee ? Ee + (lt && Ee !== "Original" ? " · from " + lt : "") : "";
      return ze.kind === "gen" ? [nn || "Generation", s.batchOf(ze)].filter(Boolean).join(" · ") : ze.how === "tool" ? [nn, ze.made ? ze.made.label : ""].filter(Boolean).join(" · ") || "Version" : "Reference · " + (xl[ze.how || "upload"].text + (ze.how === "board" && s.sessionName(ze) ? " (" + s.sessionName(ze) + ")" : "")) + (nn ? " · " + nn : "");
    }), $e = I(() => s.sessionVideo()), Fe = I(() => s.playableVideo($e.value));
    function W() {
      o.openLibrary({
        purpose: "pick",
        max: 1,
        kinds: ["video"],
        confirmLabel: "Edit this video",
        onPick: (ze) => {
          const Ee = ze[0];
          Ee && (o.rememberAsset(Ee.url, Ee.asset), s.setSessionVideo(Ee.url, Ee.asset));
        }
      });
    }
    const Q = I(() => {
      const ze = p.value;
      return !!ze && ze.kind === "gen" && ze.status === "done" && !v.value && !x.value && !y.value && !Me.value;
    });
    function ae(ze) {
      if (Le.value) {
        ve(ze);
        return;
      }
      !Q.value || ue.value || ze.defaultPrevented || p.value && s.openInfo(p.value.id);
    }
    const Le = I(() => S.value && !!a.t.adjust.picking);
    function ve(ze) {
      const Ee = ze.currentTarget.querySelector(".sv-pic-view");
      if (!Ee) return;
      const lt = Ee.getBoundingClientRect();
      !lt.width || !lt.height || a.pickColourAt((ze.clientX - lt.left) / lt.width, (ze.clientY - lt.top) / lt.height);
    }
    const ke = I(() => {
      const ze = p.value;
      return !!ze && ze.status === "done" && !v.value && !y.value && s.limit.value > 0 && r.queue[0] !== ze.id;
    }), De = I(() => s.card.value), Qe = I(() => !!p.value && s.onCard(p.value.id)), ft = I(() => !!De.value && !!p.value && p.value.status === "done" && !Qe.value), Dn = I(() => a.compareDefault()), Zn = I(() => !!a.t.compare);
    function ya() {
      a.t.compare ? a.compare(null) : a.compare(Dn.value);
    }
    Ae(() => r.stageId, () => a.stageChanged());
    let xa = null;
    return ot(() => {
      l.value && (xa = new ResizeObserver((ze) => {
        const Ee = ze[ze.length - 1].contentRect;
        d.value = { w: Ee.width, h: Ee.height };
      }), xa.observe(l.value));
    }), ot(() => {
      window.addEventListener("keydown", ie), window.addEventListener("keyup", de), window.addEventListener("blur", pe);
    }), We(() => {
      xa && xa.disconnect(), clearTimeout(D), window.removeEventListener("keydown", ie), window.removeEventListener("keyup", de), window.removeEventListener("blur", pe);
    }), e({ model: f, zoomKey: Re }), (ze, Ee) => (g(), b("div", {
      ref_key: "area",
      ref: l,
      class: G(["sv-stage", { "is-threed": m(r).studio === "threed", ["tool-" + x.value]: !!x.value, "is-space": Me.value && O.value, "is-panning": ue.value }]),
      "data-testid": "studio-stage",
      onWheel: Ne,
      onPointerdownCapture: Te,
      onPointermove: Be,
      onPointerup: ge,
      onPointercancel: ge
    }, [
      m(r).studio === "threed" && m(s).model3d.value ? (g(), Ce(Zpe, {
        key: 0,
        ref_key: "model",
        ref: f
      }, null, 512)) : m(r).studio === "threed" ? (g(), b("div", qfe, [
        u("span", Kfe, [
          C($, {
            name: "Box",
            size: 20
          })
        ]),
        Ee[18] || (Ee[18] = u("b", null, "Start from a 3D model", -1)),
        Ee[19] || (Ee[19] = u("span", { class: "sub" }, "Bring in a .glb, .gltf, .obj or .stl, find the view you want, and generate from it. Models you bring in stay with the session, and so do the views you save.", -1)),
        m(r).three.keeping ? (g(), b("div", Yfe, [
          Ee[14] || (Ee[14] = u("span", { class: "sv-making" }, null, -1)),
          J(" Keeping " + E(m(r).three.keeping) + " in your Library, then opening it", 1)
        ])) : (g(), b("div", Xfe, [
          u("button", {
            class: "sv-btn is-primary",
            "data-testid": "studio-3d-upload",
            onClick: Ee[0] || (Ee[0] = (lt) => n("upload-model"))
          }, [
            C($, {
              name: "Upload",
              size: 14
            }),
            Ee[15] || (Ee[15] = J(" From your computer", -1))
          ]),
          m(o).hasLibrary ? (g(), b("button", {
            key: 0,
            class: "sv-btn",
            "data-testid": "studio-3d-library",
            onClick: Ee[1] || (Ee[1] = (lt) => n("library-model"))
          }, [
            C($, {
              name: "Library",
              size: 14
            }),
            Ee[16] || (Ee[16] = J(" From your Library", -1))
          ])) : z("", !0),
          u("button", {
            class: "sv-btn",
            "data-testid": "studio-3d-sample",
            onClick: Ee[2] || (Ee[2] = (lt) => m(s).addSample())
          }, [
            C($, {
              name: "Building2",
              size: 14
            }),
            Ee[17] || (Ee[17] = J(" Try the sample", -1))
          ])
        ]))
      ])) : p.value && w.value ? (g(), Ce(dfe, {
        key: 2,
        room: d.value
      }, null, 8, ["room"])) : p.value && _.value ? (g(), Ce(kfe, {
        key: 3,
        room: d.value
      }, null, 8, ["room"])) : p.value && k.value && L.value ? (g(), b("div", {
        key: 4,
        class: G(["sv-pic", { "is-loading": p.value.status === "pending" || h.value !== p.value.url, "is-editing": v.value && !x.value, "is-failed": p.value.status === "failed", "is-tool": !!x.value, "is-cutout": m(s).tools.isCutout(p.value), "is-viewed": ee.value, "is-tag-inside": se.value, "is-gliding": R.value }]),
        style: ce(V.value)
      }, [
        u("div", {
          class: G(["sv-pic-clip", { "is-openable": Q.value && !Le.value, "is-picking": Le.value }]),
          title: Le.value ? "Click the colour to work on" : Q.value ? "Open it large, with its details" : void 0,
          "data-testid": "studio-pic",
          onClick: ae
        }, [
          u("div", {
            class: "sv-pic-view",
            style: ce(Z.value),
            "data-testid": "studio-pic-view"
          }, [
            y.value ? (g(), b("video", {
              key: y.value,
              src: y.value,
              poster: p.value.url || void 0,
              controls: "",
              loop: "",
              playsinline: "",
              preload: "metadata",
              "data-testid": "studio-stage-video",
              onLoadedmetadata: oe
            }, null, 40, Zfe)) : p.value.url ? (g(), b("img", {
              key: p.value.url,
              src: p.value.url,
              alt: "",
              draggable: "false",
              onLoad: ne
            }, null, 40, Qfe)) : z("", !0),
            S.value ? (g(), Ce(ufe, {
              key: 2,
              w: k.value.w,
              h: k.value.h
            }, null, 8, ["w", "h"])) : z("", !0),
            x.value === "background" ? (g(), Ce(hfe, {
              key: 3,
              w: k.value.w,
              h: k.value.h
            }, null, 8, ["w", "h"])) : z("", !0),
            x.value === "relight" ? (g(), Ce(Sfe, {
              key: 4,
              w: k.value.w,
              h: k.value.h
            }, null, 8, ["w", "h"])) : z("", !0),
            C(bI, {
              marks: Ye.value,
              w: p.value.w,
              h: p.value.h,
              live: c.value,
              hide: at.value,
              fit: "none"
            }, null, 8, ["marks", "w", "h", "live", "hide"]),
            tt.value && !Zn.value ? (g(), Ce(nfe, {
              key: 5,
              w: k.value.w,
              h: k.value.h
            }, null, 8, ["w", "h"])) : Ve.value && !Ue.value && !Zn.value ? (g(), Ce(Rpe, {
              key: 6,
              w: k.value.w,
              h: k.value.h,
              onLive: Ee[3] || (Ee[3] = (lt) => c.value = lt)
            }, null, 8, ["w", "h"])) : Ue.value && !Zn.value ? (g(), Ce(Bpe, {
              key: 7,
              w: k.value.w,
              h: k.value.h
            }, null, 8, ["w", "h"])) : z("", !0),
            x.value === "resize" && !Zn.value ? (g(), Ce(ofe, {
              key: 8,
              w: k.value.w,
              h: k.value.h
            }, null, 8, ["w", "h"])) : z("", !0),
            Zn.value ? (g(), Ce(bfe, {
              key: 9,
              w: k.value.w,
              h: k.value.h
            }, null, 8, ["w", "h"])) : z("", !0)
          ], 4)
        ], 10, Jfe),
        u("span", {
          class: G(["sv-pic-tag", { "is-ref": p.value.kind === "ref" && p.value.how !== "tool" }])
        }, E(wt.value), 3),
        !v.value && m(s).marked(p.value.id) ? (g(), b("span", eme, [
          C($, {
            name: "Pencil",
            size: 11
          }),
          Ee[20] || (Ee[20] = J(" Annotated", -1))
        ])) : z("", !0),
        ke.value ? (g(), b("button", {
          key: 1,
          class: "sv-continue",
          "data-testid": "studio-stage-continue",
          title: "Make this image 1: the next run starts from it",
          onClick: Ee[4] || (Ee[4] = (lt) => m(s).continueFrom(p.value.id))
        }, [
          C($, {
            name: "CornerDownLeft",
            size: 13
          }),
          Ee[21] || (Ee[21] = J(" Start from this image ", -1))
        ])) : z("", !0),
        ft.value ? (g(), b("button", {
          key: 2,
          class: "sv-promote",
          "data-testid": "studio-stage-promote",
          title: "The board shows another version of this picture: use this one there instead",
          onClick: Ee[5] || (Ee[5] = (lt) => m(s).promote(p.value.id))
        }, [
          C($, {
            name: "Replace",
            size: 13
          }),
          Ee[22] || (Ee[22] = J(" Use this version on the board ", -1))
        ])) : De.value && Qe.value ? (g(), b("span", tme, [
          C($, {
            name: "LayoutGrid",
            size: 12
          }),
          Ee[23] || (Ee[23] = J(" On the board", -1))
        ])) : z("", !0),
        O.value || v.value && p.value.status === "done" && (Dn.value || Zn.value) ? (g(), b("div", nme, [
          v.value && p.value.status === "done" && (Dn.value || Zn.value) ? (g(), b(j, { key: 0 }, [
            u("button", {
              class: G(["ed-stage-btn", { on: Zn.value }]),
              "aria-pressed": Zn.value,
              title: Zn.value ? "Stop comparing" : "Compare with the version it came from",
              "data-testid": "studio-compare",
              onClick: ya
            }, [
              C($, {
                name: "Columns2",
                size: 13
              }),
              Ee[24] || (Ee[24] = J(" Compare ", -1))
            ], 10, ime),
            Zn.value && m(a).t.compare ? (g(), b("span", sme, [
              u("button", {
                class: G({ on: m(a).t.compare.mode === "split" }),
                onClick: Ee[6] || (Ee[6] = (lt) => m(a).t.compare.mode = "split")
              }, "Split", 2),
              u("button", {
                class: G({ on: m(a).t.compare.mode === "toggle" }),
                onClick: Ee[7] || (Ee[7] = (lt) => m(a).t.compare.mode = "toggle")
              }, "Toggle", 2)
            ])) : z("", !0)
          ], 64)) : z("", !0),
          O.value ? (g(), Ce(Bfe, {
            key: 1,
            share: X.value,
            fitted: !ee.value,
            "at-min": te.value.k <= B.value.min + 1e-4,
            "at-max": te.value.k >= B.value.max - 1e-4,
            onStep: re,
            onFit: le,
            onActual: he
          }, null, 8, ["share", "fitted", "at-min", "at-max"])) : z("", !0)
        ])) : z("", !0),
        C(vt, { name: "ed-fade" }, {
          default: Xe(() => [
            m(r).baking ? (g(), b("div", ome, [
              C($, {
                name: "Loader2",
                size: 14,
                spin: ""
              }),
              J(" " + E(m(r).baking), 1)
            ])) : z("", !0)
          ]),
          _: 1
        })
      ], 6)) : m(s).busy() ? (g(), b("div", rme, [
        Ee[25] || (Ee[25] = u("span", { class: "sv-making" }, null, -1)),
        u("b", null, E(m(s).video.value ? "Making your video" : "Making your image"), 1),
        m(o).runningSince[m(s).sessionId] ? (g(), Ce(N1, {
          key: 0,
          class: "sv-making-time",
          since: m(o).runningSince[m(s).sessionId]
        }, null, 8, ["since"])) : z("", !0)
      ])) : v.value ? (g(), b("div", ame, [
        u("span", lme, [
          C($, {
            name: "Pencil",
            size: 20
          })
        ]),
        Ee[27] || (Ee[27] = u("b", null, "Pick an image to edit", -1)),
        Ee[28] || (Ee[28] = u("span", { class: "sub" }, "Choose one from history on the right, or bring in your own.", -1)),
        u("div", dme, [
          u("button", {
            class: "sv-btn",
            onClick: Ee[8] || (Ee[8] = (lt) => n("upload"))
          }, [
            C($, {
              name: "Upload",
              size: 14
            }),
            Ee[26] || (Ee[26] = J(" Bring in an image", -1))
          ])
        ])
      ])) : m(s).videoField() && $e.value ? (g(), b("div", cme, [
        Ee[31] || (Ee[31] = u("span", { class: "sv-pic-tag" }, "Video to edit", -1)),
        Fe.value ? (g(), b("video", {
          key: Fe.value,
          src: Fe.value,
          poster: Fe.value === $e.value ? void 0 : $e.value,
          controls: "",
          autoplay: "",
          muted: "",
          loop: "",
          playsinline: ""
        }, null, 8, ume)) : (g(), b("img", {
          key: 1,
          src: $e.value,
          alt: "The video to edit"
        }, null, 8, hme)),
        u("div", pme, [
          m(o).canUploadVideo ? (g(), b("button", {
            key: 0,
            class: "sv-btn",
            onClick: Ee[9] || (Ee[9] = (lt) => n("upload-video"))
          }, [
            C($, {
              name: "Upload",
              size: 14
            }),
            Ee[29] || (Ee[29] = J(" Another from your computer", -1))
          ])) : z("", !0),
          m(o).hasLibrary ? (g(), b("button", {
            key: 1,
            class: "sv-btn",
            onClick: W
          }, [
            C($, {
              name: "Library",
              size: 14
            }),
            Ee[30] || (Ee[30] = J(" From your Library", -1))
          ])) : z("", !0)
        ])
      ])) : m(s).videoField() ? (g(), b("div", fme, [
        u("span", mme, [
          C($, {
            name: "Clapperboard",
            size: 20
          })
        ]),
        Ee[34] || (Ee[34] = u("b", null, "Choose the video to edit", -1)),
        u("span", gme, E(m(s).modelName("prompt")) + " edits a video: bring one in, then say what to change in the box below. A video on the board can go in from the box's Video slot.", 1),
        u("div", bme, [
          m(o).canUploadVideo ? (g(), b("button", {
            key: 0,
            class: "sv-btn is-primary",
            "data-testid": "studio-video-upload",
            onClick: Ee[10] || (Ee[10] = (lt) => n("upload-video"))
          }, [
            C($, {
              name: "Upload",
              size: 14
            }),
            Ee[32] || (Ee[32] = J(" From your computer", -1))
          ])) : z("", !0),
          m(o).hasLibrary ? (g(), b("button", {
            key: 1,
            class: "sv-btn",
            "data-testid": "studio-video-library",
            onClick: W
          }, [
            C($, {
              name: "Library",
              size: 14
            }),
            Ee[33] || (Ee[33] = J(" From your Library", -1))
          ])) : z("", !0)
        ])
      ])) : m(s).video.value ? (g(), b("div", vme, [
        u("span", yme, [
          C($, {
            name: "Video",
            size: 20
          })
        ]),
        Ee[36] || (Ee[36] = u("b", null, "Describe a new video", -1)),
        Ee[37] || (Ee[37] = u("span", { class: "sub" }, "Write a prompt below. To start the video from a picture, pick one from history or bring in your own.", -1)),
        u("div", xme, [
          u("button", {
            class: "sv-btn",
            onClick: Ee[11] || (Ee[11] = (lt) => n("upload"))
          }, [
            C($, {
              name: "Upload",
              size: 14
            }),
            Ee[35] || (Ee[35] = J(" Bring in a picture", -1))
          ])
        ])
      ])) : (g(), b("div", wme, [
        u("span", kme, [
          C($, {
            name: "Sparkles",
            size: 20
          })
        ]),
        Ee[40] || (Ee[40] = u("b", null, "Describe a new image", -1)),
        Ee[41] || (Ee[41] = u("span", { class: "sub" }, "Write a prompt below. To change an image instead, pick one from history, start from a 3D model, or bring in your own.", -1)),
        u("div", _me, [
          u("button", {
            class: "sv-btn",
            onClick: Ee[12] || (Ee[12] = (lt) => m(s).setStudio("threed"))
          }, [
            C($, {
              name: "Box",
              size: 14
            }),
            Ee[38] || (Ee[38] = J(" Start from 3D", -1))
          ]),
          u("button", {
            class: "sv-btn",
            onClick: Ee[13] || (Ee[13] = (lt) => n("upload"))
          }, [
            C($, {
              name: "Upload",
              size: 14
            }),
            Ee[39] || (Ee[39] = J(" Bring in an image", -1))
          ])
        ])
      ])),
      C(Pfe)
    ], 34));
  }
}), Mme = { class: "sv-art" }, Tme = ["src"], Cme = {
  key: 2,
  class: "sv-art-play",
  "aria-hidden": "true"
}, ao = /* @__PURE__ */ Pe({
  __name: "ItemArt",
  props: {
    item: {},
    full: { type: Boolean, default: !1 }
  },
  setup(i) {
    const e = i, t = yt(), n = I(() => t.marksOf(e.item)), s = I(() => e.item.url.startsWith("data:") || e.item.url.startsWith("blob:") || e.full ? e.item.url : Bt(e.item.url)), o = I(() => {
      const r = t.resultOf(e.item);
      return !!(r && r.video);
    });
    return (r, a) => (g(), b("span", Mme, [
      i.item.url ? (g(), b("img", {
        key: 0,
        src: s.value,
        alt: "",
        draggable: "false",
        loading: "lazy"
      }, null, 8, Tme)) : z("", !0),
      n.value.strokes.length || n.value.pins.length ? (g(), Ce(bI, {
        key: 1,
        marks: n.value,
        w: i.item.w,
        h: i.item.h,
        small: ""
      }, null, 8, ["marks", "w", "h"])) : z("", !0),
      o.value ? (g(), b("span", Cme, [
        C($, {
          name: "Play",
          size: 10
        })
      ])) : z("", !0)
    ]));
  }
}), rx = "application/x-rd-studio-item", Yr = /* @__PURE__ */ K(null);
function Ime(i, e, t) {
  i.dataTransfer && (i.dataTransfer.effectAllowed = "copy", i.dataTransfer.setData(rx, e), t && i.dataTransfer.setDragImage(t, t.offsetWidth / 2, t.offsetHeight / 2), Yr.value = e);
}
function Df() {
  Yr.value = null;
}
function qI(i) {
  return !!i.dataTransfer && Array.from(i.dataTransfer.types).includes(rx);
}
function KI(i) {
  return i.dataTransfer && i.dataTransfer.getData(rx) || null;
}
const YI = 230, XI = 260, Bo = {
  label: "Add an image",
  addTitle: "Add an image: your pinned pictures, the board's, your Library, or an upload",
  dropper: "Pick from history",
  tip: "Or drag a picture here from history, or from your computer."
}, Ame = { class: "sv-queue-slots is-video" }, Pme = ["title"], Eme = ["src", "poster"], Rme = ["src"], zme = { class: "v" }, $me = { class: "sv-slot-add-wrap" }, Dme = ["title", "aria-label", "aria-expanded"], Ome = {
  key: 1,
  class: "sv-queue-empty"
}, Lme = {
  key: 0,
  class: "sv-queue-count"
}, Bme = {
  key: 1,
  class: "sv-queue-sep"
}, Fme = {
  key: 1,
  class: "sv-queue-label"
}, Nme = {
  key: 2,
  class: "sv-queue-slots"
}, Ume = ["title", "data-testid", "onDragstart", "onDrop", "onClick", "onMouseenter"], Gme = { class: "n" }, jme = {
  key: 0,
  class: "m",
  title: "Its annotations and notes go with it"
}, Hme = ["title", "onClick"], Vme = {
  key: 2,
  class: "sv-slot-add-wrap"
}, Wme = ["title", "aria-expanded"], qme = {
  key: 3,
  class: "sv-queue-empty"
}, Kme = { class: "n" }, p4 = 6, Yme = /* @__PURE__ */ Pe({
  __name: "QueueRow",
  setup(i) {
    const e = yt(), t = e.s, n = /* @__PURE__ */ K(!1), s = I(() => e.queueItems.value), o = I(() => n.value ? s.value : s.value.slice(0, p4)), r = I(() => s.value.length - o.value.length), a = I(() => e.limit.value), l = I(() => e.modelName(e.genMode.value)), d = /* @__PURE__ */ K(null), c = /* @__PURE__ */ K(null), h = /* @__PURE__ */ K(null);
    function f(ee, me) {
      const L = s.value.find((Y) => Y.id === ee);
      if (!L || !c.value || d.value) return;
      const N = Math.min(YI / L.w, XI / L.h), X = Math.round(L.w * N), B = Math.round(L.h * N), se = me.currentTarget.getBoundingClientRect(), V = c.value.getBoundingClientRect(), Z = Math.max(0, Math.min(V.width - X, se.left - V.left + se.width / 2 - X / 2));
      h.value = { id: ee, left: Z, w: X, h: B };
    }
    const p = I(() => h.value && s.value.find((ee) => ee.id === h.value.id) || null);
    function y(ee, me) {
      d.value = ee, h.value = null, me.dataTransfer && (me.dataTransfer.effectAllowed = "move", me.dataTransfer.setData("text/plain", ee));
    }
    function v(ee) {
      d.value && e.move(d.value, ee), d.value = null;
    }
    const x = /* @__PURE__ */ K(!1), w = I(() => !!Yr.value && !!a.value);
    function S(ee) {
      !qI(ee) || !a.value || (ee.preventDefault(), ee.dataTransfer && (ee.dataTransfer.dropEffect = "copy"), x.value = !0);
    }
    function M(ee) {
      const me = ee.relatedTarget;
      (!me || !ee.currentTarget.contains(me)) && (x.value = !1);
    }
    function _(ee) {
      const me = KI(ee);
      x.value = !1, Df(), !(!me || !a.value) && (ee.preventDefault(), e.queueItem(me));
    }
    const T = /* @__PURE__ */ K(!1);
    async function k(ee) {
      T.value = !1, await e.queueUrl(ee);
    }
    function P() {
      T.value = !1, e.setDropper(!0);
    }
    const A = I(() => e.videoField()), R = I(() => e.sessionVideo()), D = I(() => e.playableVideo(R.value)), O = /* @__PURE__ */ K(!1);
    function F(ee) {
      O.value = !1, e.setSessionVideo(ee);
    }
    function te(ee) {
      ee.key === "Escape" && (ee.stopPropagation(), ee.preventDefault(), T.value = !1, O.value = !1);
    }
    return Ae(() => T.value || O.value, (ee) => {
      ee ? window.addEventListener("keydown", te, !0) : window.removeEventListener("keydown", te, !0);
    }), We(() => window.removeEventListener("keydown", te, !0)), (ee, me) => (g(), b("div", {
      ref_key: "row",
      ref: c,
      class: G(["sv-queue", { "is-empty": !s.value.length, "no-images": !a.value, "is-over": x.value, "is-air": w.value && !x.value }]),
      "data-testid": "studio-queue",
      onDragover: S,
      onDragleave: M,
      onDrop: _
    }, [
      A.value ? (g(), b(j, { key: 0 }, [
        me[9] || (me[9] = u("span", { class: "sv-queue-label" }, "Video to edit", -1)),
        u("div", Ame, [
          R.value ? (g(), b("div", {
            key: 0,
            class: "sv-slot is-video",
            title: "The video " + l.value + " edits",
            "data-testid": "studio-video-slot"
          }, [
            D.value ? (g(), b("video", {
              key: 0,
              src: D.value,
              poster: D.value === R.value ? void 0 : R.value,
              muted: "",
              preload: "metadata",
              playsinline: ""
            }, null, 8, Eme)) : (g(), b("img", {
              key: 1,
              src: R.value,
              alt: ""
            }, null, 8, Rme)),
            u("span", zme, [
              C($, {
                name: "Video",
                size: 9
              })
            ]),
            u("button", {
              class: "x",
              title: "Take the video out",
              "data-testid": "studio-video-remove",
              onClick: me[0] || (me[0] = Se((L) => m(e).setSessionVideo(null), ["stop"]))
            }, [
              C($, {
                name: "X",
                size: 10
              })
            ])
          ], 8, Pme)) : z("", !0),
          u("div", $me, [
            u("button", {
              class: "sv-slot-add",
              title: R.value ? "Choose another video" : "Choose the video to edit: from the board, your Library or your computer",
              "aria-label": R.value ? "Choose another video" : "Choose the video to edit",
              "aria-expanded": O.value,
              "data-testid": "studio-video-add",
              onClick: me[1] || (me[1] = (L) => O.value = !O.value)
            }, [
              C($, {
                name: "Video",
                size: 14
              })
            ], 8, Dme),
            O.value ? (g(), Ce(Zc, {
              key: 0,
              "session-id": m(e).sessionId,
              label: "Video",
              kind: "video",
              dropper: !1,
              tip: "Or set it on the session's card, on the board.",
              onPick: F,
              onClose: me[2] || (me[2] = (L) => O.value = !1)
            }, null, 8, ["session-id"])) : z("", !0)
          ]),
          R.value ? z("", !0) : (g(), b("span", Ome, "Choose the video " + E(l.value) + " edits: from the board, your Library or your computer.", 1))
        ]),
        a.value ? z("", !0) : (g(), b("span", Lme, E(R.value ? "1 video" : "No video yet"), 1)),
        a.value ? (g(), b("i", Bme)) : z("", !0)
      ], 64)) : z("", !0),
      !A.value || a.value ? (g(), b("span", Fme, E(m(e).video.value ? "Next video starts from" : "Next image uses"), 1)) : z("", !0),
      !A.value || a.value ? (g(), b("div", Nme, [
        (g(!0), b(j, null, be(o.value, (L, N) => (g(), b("div", {
          key: L.id,
          class: G(["sv-slot", { "is-base": N === 0, "is-unsent": N >= a.value, "is-stage": m(t).stageId === L.id, "is-ref": L.kind === "ref" }]),
          title: (m(e).slotName(N) ? m(e).slotName(N) + ": image " + (N + 1) : N === 0 ? "Image 1: the one it starts from" : "Image " + (N + 1) + ": a reference") + (N >= a.value ? " (not sent: " + l.value + " takes " + a.value + ")" : ""),
          draggable: "true",
          "data-testid": "studio-slot-" + (N + 1),
          onDragstart: (X) => y(L.id, X),
          onDragover: me[3] || (me[3] = Se(() => {
          }, ["prevent"])),
          onDrop: Se((X) => v(N), ["prevent"]),
          onClick: (X) => m(e).show(L.id),
          onMouseenter: (X) => f(L.id, X),
          onMouseleave: me[4] || (me[4] = (X) => h.value = null)
        }, [
          C(ao, { item: L }, null, 8, ["item"]),
          u("span", Gme, E(N + 1), 1),
          m(e).marked(L.id) ? (g(), b("span", jme, [
            C($, {
              name: "Pencil",
              size: 8
            })
          ])) : z("", !0),
          u("button", {
            class: "x",
            title: "Take image " + (N + 1) + " out",
            onClick: Se((X) => m(e).remove(L.id), ["stop"])
          }, [
            C($, {
              name: "X",
              size: 10
            })
          ], 8, Hme)
        ], 42, Ume))), 128)),
        r.value > 0 ? (g(), b("button", {
          key: 0,
          class: "sv-slot-more",
          onClick: me[5] || (me[5] = (L) => n.value = !0)
        }, "+" + E(r.value), 1)) : z("", !0),
        n.value && s.value.length > p4 ? (g(), b("button", {
          key: 1,
          class: "sv-slot-more",
          title: "Fewer",
          onClick: me[6] || (me[6] = (L) => n.value = !1)
        }, [
          C($, {
            name: "ChevronLeft",
            size: 12
          })
        ])) : z("", !0),
        a.value ? (g(), b("div", Vme, [
          u("button", {
            class: G(["sv-slot-add", { "is-dropper": m(t).dropper }]),
            title: m(Bo).addTitle,
            "aria-label": "Add an image",
            "aria-expanded": T.value,
            "data-testid": "studio-queue-add",
            onClick: me[7] || (me[7] = (L) => {
              T.value = !T.value, m(e).setDropper(!1);
            })
          }, [
            C($, {
              name: "ImagePlus",
              size: 16
            })
          ], 10, Wme),
          T.value ? (g(), Ce(Zc, {
            key: 0,
            "session-id": m(e).sessionId,
            label: m(Bo).label,
            "dropper-label": m(Bo).dropper,
            tip: m(Bo).tip,
            onPick: k,
            onDropper: P,
            onClose: me[8] || (me[8] = (L) => T.value = !1)
          }, null, 8, ["session-id", "label", "dropper-label", "tip"])) : z("", !0)
        ])) : z("", !0),
        s.value.length ? z("", !0) : (g(), b("span", qme, E(a.value ? "Nothing yet: your words alone make a new " + (m(e).video.value ? "video." : "image.") : l.value + " works from words alone; pick another model to send images."), 1))
      ])) : z("", !0),
      h.value && p.value ? (g(), b("div", {
        key: 3,
        class: "sv-slot-peek",
        style: ce({ left: h.value.left + "px", width: h.value.w + "px", height: h.value.h + "px" }),
        "aria-hidden": "true"
      }, [
        C(ao, {
          item: p.value,
          full: ""
        }, null, 8, ["item"]),
        u("span", Kme, E(m(e).slotName(m(e).queued(p.value.id) - 1) || "Image " + m(e).queued(p.value.id)), 1)
      ], 4)) : z("", !0),
      !A.value || a.value ? (g(), b("span", {
        key: 4,
        class: G(["sv-queue-count", { "is-over": s.value.length > a.value }])
      }, [
        a.value ? (g(), b(j, { key: 0 }, [
          J(E(Math.min(s.value.length, a.value)) + " of " + E(a.value), 1)
        ], 64)) : (g(), b(j, { key: 1 }, [
          J("No images")
        ], 64))
      ], 2)) : z("", !0)
    ], 34));
  }
}), Xme = ["aria-expanded", "disabled", "title"], Jme = { class: "lb" }, Zme = { class: "nm" }, Qme = ["aria-expanded", "disabled"], ege = { class: "nm" }, tge = ["aria-expanded", "disabled", "title"], nge = { class: "nm" }, ige = {
  key: 0,
  class: "tk"
}, sge = {
  key: 0,
  class: "sv-pop-tabs",
  role: "tablist",
  "aria-label": "Model groups"
}, oge = ["aria-selected", "data-testid", "onClick"], rge = {
  key: 1,
  class: "sv-pop-search"
}, age = { class: "sv-pop-rows" }, lge = ["aria-selected", "onClick"], dge = { class: "nm" }, cge = { class: "mt" }, uge = { class: "tk" }, hge = ["title", "aria-label", "aria-pressed", "data-testid", "onClick"], pge = {
  key: 0,
  class: "sv-pop-empty"
}, fge = {
  key: 2,
  class: "sv-pop-foot"
}, mge = {
  key: 3,
  class: "sv-pop-foot"
}, JI = /* @__PURE__ */ Pe({
  __name: "ModelPicker",
  props: {
    mode: {},
    variant: { default: "chip" }
  },
  setup(i) {
    const e = i, t = I(() => e.mode === "edit"), n = yt(), { board: s } = Ze(), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(""), l = /* @__PURE__ */ K(null), d = I(() => n.modelsFor(e.mode)), c = I(() => {
      if (e.mode !== "prompt") return null;
      const P = n.session.value;
      return P && s.catalog.value.kits.find((A) => A.id === P.kitId) || null;
    }), h = I(() => {
      const P = c.value, A = s.catalog.value;
      return P ? A.all.filter((R) => Fc(A, P, R)) : [];
    }), f = I(() => c.value ? rI(_0(c.value), h.value.some((P) => s.isModelPinned(P.id))) : []), p = /* @__PURE__ */ K(null), y = I(() => {
      if (f.value.length && c.value) return s.pinnedModelsFirst(lI(c.value.models, h.value, p.value, a.value, (A) => s.isModelPinned(A)));
      const P = a.value.trim().toLowerCase();
      return s.pinnedModelsFirst(P ? d.value.filter((A) => A.name.toLowerCase().includes(P)) : d.value);
    }), v = I(() => n.modelOf(e.mode)), x = I(() => d.value.length > 7);
    function w(P) {
      const A = zo(P);
      return A ? "up to " + A + (A === 1 ? " image" : " images") : "words only";
    }
    function S(P) {
      return P.tokensLabel || (P.tokensPerResult != null ? String(P.tokensPerResult) : "");
    }
    function M(P) {
      n.setModel(e.mode, P), o.value = !1;
    }
    function _() {
      if (o.value = !o.value, a.value = "", o.value && f.value.length) {
        const P = v.value, A = P && P.kitTags ? f.value.find((R) => P.kitTags.includes(R)) : null;
        p.value = A || _0(c.value)[0] || Su;
      }
      o.value && x.value && nt(() => l.value && l.value.focus());
    }
    function T(P) {
      r.value && !r.value.contains(P.target) && (o.value = !1);
    }
    Ae(o, (P) => {
      P ? window.addEventListener("pointerdown", T, !0) : window.removeEventListener("pointerdown", T, !0);
    }), We(() => window.removeEventListener("pointerdown", T, !0));
    function k(P) {
      P.key === "Escape" ? (P.stopPropagation(), o.value = !1) : P.key === "Enter" && y.value.length && (P.preventDefault(), M(y.value[0]));
    }
    return (P, A) => (g(), b("div", {
      ref_key: "wrap",
      ref: r,
      class: G(["sv-pop-wrap", { "is-row": i.variant === "row" }]),
      onKeydown: k
    }, [
      i.variant === "flat" ? (g(), b("button", {
        key: 0,
        class: G(["up-model", { on: o.value }]),
        "aria-expanded": o.value,
        disabled: !d.value.length,
        title: v.value && v.value.time ? "About " + v.value.time + " a run" : void 0,
        "data-testid": "studio-model",
        onClick: _
      }, [
        u("span", Jme, E(t.value ? "Edit model" : "Model"), 1),
        kt((g(), b("span", Zme, [
          J(E(v.value ? v.value.name : "None available"), 1)
        ])), [
          [m(dl), v.value ? v.value.name : null]
        ]),
        C($, {
          name: "ChevronDown",
          size: 12
        })
      ], 10, Xme)) : i.variant === "chip" ? (g(), b("button", {
        key: 1,
        class: G(["sv-chip is-model", { on: o.value }]),
        "aria-expanded": o.value,
        disabled: !d.value.length,
        "data-testid": "studio-model",
        onClick: _
      }, [
        A[2] || (A[2] = u("span", { class: "lb" }, "Model", -1)),
        kt((g(), b("span", ege, [
          J(E(v.value ? v.value.name : "None available"), 1)
        ])), [
          [m(dl), v.value ? v.value.name : null]
        ]),
        C($, {
          name: "ChevronDown",
          size: 12
        })
      ], 10, Qme)) : (g(), b("button", {
        key: 2,
        class: G(["sv-model-row", { on: o.value }]),
        "aria-expanded": o.value,
        disabled: !d.value.length,
        title: v.value ? "Model: " + v.value.name + (v.value.time ? " (about " + v.value.time + " a run)" : "") : "No model takes a picture here",
        "data-testid": "studio-edit-model",
        onClick: _
      }, [
        C($, {
          name: "Cpu",
          size: 14
        }),
        kt((g(), b("span", nge, [
          J(E(v.value ? v.value.name : "None available"), 1)
        ])), [
          [m(dl), v.value ? v.value.name : null]
        ]),
        v.value ? (g(), b("span", ige, [
          C($, {
            name: "Tokens",
            size: 11
          }),
          J(" " + E(m(n).priceOf(i.mode)), 1)
        ])) : z("", !0),
        C($, {
          class: "chev",
          name: o.value ? "ChevronUp" : "ChevronDown",
          size: 13
        }, null, 8, ["name"])
      ], 10, tge)),
      o.value ? (g(), b("div", {
        key: 3,
        class: G(i.variant === "row" ? "sv-model-list" : "sv-pop"),
        role: "listbox",
        "aria-label": "Models for this studio"
      }, [
        f.value.length ? (g(), b("div", sge, [
          (g(!0), b(j, null, be(f.value, (R) => (g(), b("button", {
            key: R,
            role: "tab",
            class: G(["sv-pop-tab", { on: p.value === R && !a.value.trim() }]),
            "aria-selected": p.value === R,
            "data-testid": "studio-model-tab-" + R.replace(/[^a-z]/gi, "").toLowerCase(),
            onClick: (D) => {
              p.value = R, a.value = "";
            }
          }, E(m(aI)(R, c.value ? c.value.name : "Models")), 11, oge))), 128))
        ])) : z("", !0),
        x.value || f.value.length ? (g(), b("label", rge, [
          C($, {
            name: "Search",
            size: 12
          }),
          kt(u("input", {
            ref_key: "searchEl",
            ref: l,
            "onUpdate:modelValue": A[0] || (A[0] = (R) => a.value = R),
            placeholder: "Find a model",
            spellcheck: "false",
            "data-testid": "studio-model-search"
          }, null, 512), [
            [Zt, a.value]
          ])
        ])) : z("", !0),
        u("div", age, [
          (g(!0), b(j, null, be(y.value, (R) => (g(), b("div", {
            key: R.id,
            class: "sv-pop-item"
          }, [
            u("button", {
              class: G(["sv-pop-row", { on: !!v.value && R.id === v.value.id }]),
              role: "option",
              "aria-selected": !!v.value && R.id === v.value.id,
              onClick: (D) => M(R)
            }, [
              kt((g(), b("span", dge, [
                J(E(R.name), 1)
              ])), [
                [m(dl), R.name]
              ]),
              u("span", cge, E(w(R)), 1),
              u("span", uge, [
                C($, {
                  name: "Tokens",
                  size: 11
                }),
                J(" " + E(S(R)), 1)
              ])
            ], 10, lge),
            u("button", {
              class: G(["sv-pop-pin", { on: m(s).isModelPinned(R.id) }]),
              title: m(s).isModelPinned(R.id) ? "Unpin" : "Pin to the top",
              "aria-label": (m(s).isModelPinned(R.id) ? "Unpin " : "Pin ") + R.name,
              "aria-pressed": m(s).isModelPinned(R.id),
              "data-testid": "studio-model-pin-" + R.id,
              onKeydown: A[1] || (A[1] = tn(Se(() => {
              }, ["stop"]), ["enter"])),
              onClick: Se((D) => m(s).toggleModelPinned(R.id), ["stop"])
            }, [
              C($, {
                name: "Pin",
                size: 12
              })
            ], 42, hge)
          ]))), 128)),
          y.value.length ? z("", !0) : (g(), b("div", pge, E(d.value.length ? "No tools found. Try a different search." : "No model here takes a picture"), 1))
        ]),
        i.mode === "prompt" ? (g(), b("p", fge, "Changes the session's model, as its prompt box does.")) : t.value ? (g(), b("p", mge, "Edit keeps a model of its own: the session's Generate model stays as it is.")) : z("", !0)
      ], 2)) : z("", !0)
    ], 34));
  }
}), gge = ["title", "data-testid", "onClick"], bge = {
  key: 0,
  class: "t"
}, vge = ["aria-label"], yge = { class: "sv-pop-title" }, xge = {
  key: 0,
  class: "sv-pop-slider"
}, wge = ["min", "max", "step", "value", "onInput"], kge = {
  key: 1,
  class: "sv-pop-rows"
}, _ge = ["onClick"], Sge = ["aria-selected", "onClick"], Mge = { class: "nm" }, Tge = {
  key: 1,
  class: "mt"
}, Cge = /* @__PURE__ */ Pe({
  __name: "FieldChips",
  props: {
    mode: {},
    upward: { type: Boolean, default: !0 },
    hide: { default: () => [] },
    pills: { type: Boolean, default: !1 }
  },
  setup(i) {
    const e = i, t = yt(), n = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K(null), o = I(() => t.shownChips(e.mode, e.hide));
    function r(x) {
      return t.valueOf(e.mode, x);
    }
    function a(x) {
      const w = r(x);
      return (x.options || []).find((S) => Qi(S.value, w)) || null;
    }
    function l(x) {
      if (x.kind === "boolean") return x.label;
      const w = r(x), S = a(x);
      return x.kind === "size" && S || S ? S.label : w == null || w === "" ? x.label : String(w);
    }
    function d(x) {
      if (x.icon) return x.icon;
      if (x.kind === "size") {
        const w = a(x);
        return w && w.icon || "RectangleHorizontal";
      }
      return x.kind === "boolean" ? r(x) ? "SquareCheck" : "Square" : "Settings2";
    }
    function c(x) {
      if (x.kind === "boolean") {
        t.setInput(e.mode, x.key, !r(x));
        return;
      }
      n.value = n.value === x.key ? null : x.key;
    }
    function h(x, w) {
      t.setInput(e.mode, x.key, w.value), n.value = null;
    }
    function f(x) {
      return t.matchOf(e.mode, x);
    }
    function p(x, w) {
      const S = cc(x, w);
      S != null && t.setInput(e.mode, x.key, S);
    }
    function y(x, w) {
      return w.meta && (x.kind !== "size" || ef(w.value)) ? w.meta : "";
    }
    function v(x) {
      s.value && !s.value.contains(x.target) && (n.value = null);
    }
    return Ae(n, (x) => {
      x ? window.addEventListener("pointerdown", v, !0) : window.removeEventListener("pointerdown", v, !0);
    }), We(() => window.removeEventListener("pointerdown", v, !0)), (x, w) => o.value.length ? (g(), b("div", {
      key: 0,
      ref_key: "wrap",
      ref: s,
      class: G(["sv-fields", { "is-pills": i.pills }]),
      "data-testid": "studio-fields"
    }, [
      (g(!0), b(j, null, be(o.value, (S) => {
        var M, _, T, k, P, A;
        return g(), b("div", {
          key: S.key,
          class: "sv-pop-wrap"
        }, [
          u("button", {
            class: G([i.pills ? "up-chip" : "sv-chip", { on: n.value === S.key || S.kind === "boolean" && !!r(S) }]),
            title: S.tooltip || S.label,
            "data-testid": "studio-field-" + S.key,
            onClick: (R) => c(S)
          }, [
            C($, {
              name: d(S),
              size: i.pills ? 13 : 12
            }, null, 8, ["name", "size"]),
            i.pills ? (g(), b("span", bge, E(l(S)), 1)) : (g(), b(j, { key: 1 }, [
              J(E(l(S)), 1)
            ], 64))
          ], 10, gge),
          n.value === S.key ? (g(), b("div", {
            key: 0,
            class: G(["sv-pop is-narrow", { "is-down": !i.upward }]),
            role: "listbox",
            "aria-label": S.label,
            onKeydown: w[0] || (w[0] = tn(Se((R) => n.value = null, ["stop"]), ["esc"]))
          }, [
            u("div", yge, E(S.label), 1),
            S.kind === "slider" ? (g(), b("label", xge, [
              u("input", {
                type: "range",
                min: (M = S.min) != null ? M : 0,
                max: (_ = S.max) != null ? _ : 100,
                step: (T = S.step) != null ? T : 1,
                value: Number((P = (k = r(S)) != null ? k : S.defaultValue) != null ? P : 0),
                onInput: (R) => p(S, R.target.value)
              }, null, 40, wge),
              u("b", null, E((A = r(S)) != null ? A : S.defaultValue), 1)
            ])) : (g(), b("div", kge, [
              f(S) ? (g(), b(j, { key: 0 }, [
                u("button", {
                  class: "sv-pop-row",
                  role: "option",
                  "aria-selected": !1,
                  "data-testid": "studio-field-match",
                  onClick: (R) => h(S, f(S))
                }, [
                  C($, {
                    name: "Proportions",
                    size: 12
                  }),
                  w[1] || (w[1] = u("span", { class: "nm" }, "Match media input", -1))
                ], 8, _ge),
                w[2] || (w[2] = u("div", {
                  class: "sv-pop-sep",
                  "aria-hidden": "true"
                }, null, -1))
              ], 64)) : z("", !0),
              (g(!0), b(j, null, be(S.options, (R) => (g(), b("button", {
                key: String(R.label),
                class: G(["sv-pop-row", { on: m(Qi)(R.value, r(S)) }]),
                role: "option",
                "aria-selected": m(Qi)(R.value, r(S)),
                onClick: (D) => h(S, R)
              }, [
                R.icon ? (g(), Ce($, {
                  key: 0,
                  name: R.icon,
                  size: 12
                }, null, 8, ["name"])) : z("", !0),
                u("span", Mge, E(R.label), 1),
                y(S, R) ? (g(), b("span", Tge, E(y(S, R)), 1)) : z("", !0)
              ], 10, Sge))), 128))
            ]))
          ], 42, vge)) : z("", !0)
        ]);
      }), 128))
    ], 2)) : z("", !0);
  }
}), Ige = { class: "up-chips" }, Age = { class: "up-chip-wrap up-model-wrap" }, Pge = ["title"], Ege = { class: "nm" }, Rge = ["title"], zge = ["title"], $ge = { class: "up-run-wrap" }, Dge = ["disabled", "title", "data-testid"], Oge = {
  key: 2,
  class: "tip",
  "data-testid": "studio-run-tip"
}, ZI = /* @__PURE__ */ Pe({
  __name: "PromptFoot",
  props: {
    kind: {},
    own: { default: null },
    resting: { type: Boolean, default: !1 },
    unchecked: { type: Boolean, default: !1 },
    fixed: { type: Boolean, default: !1 },
    fixedTitle: { default: "" },
    most: { default: null },
    hide: { default: () => [] },
    label: { default: null },
    runTestid: { default: "studio-run" },
    countTestid: { default: "studio-count" }
  },
  emits: ["run"],
  setup(i, { expose: e, emit: t }) {
    const n = i, s = t, o = yt(), r = o.s, { board: a } = Ze(), l = /* @__PURE__ */ K(null), d = I(() => o.modelOf(n.kind)), c = I(() => n.unchecked ? { problem: null, tokens: !1 } : o.checkOf(n.kind)), h = I(() => n.resting ? HI : n.own || c.value.problem || (d.value ? null : "No model is available for this")), f = I(() => !n.own && c.value.tokens && a.canGetTokens), p = I(() => d.value ? o.priceOf(n.kind) : ""), y = I(() => o.countOf(n.kind)), v = I(() => n.most != null ? Math.min(n.most, o.maxCount(n.kind)) : o.maxCount(n.kind)), x = I(() => o.shownChips(n.kind, n.hide).length > 0), w = I(() => r.sending > 0), S = I(() => o.video.value || d.value && d.value.fields.some((k) => k.kind === "video") ? e8(d.value, (k) => o.valueOf(n.kind, k)) : "");
    let M = 0;
    function _() {
      const k = l.value ? l.value.closest(".sv-dock") : null;
      k && (k.classList.remove("is-nudge"), k.offsetWidth, k.classList.add("is-nudge"), clearTimeout(M), M = window.setTimeout(() => k.classList.remove("is-nudge"), 1800));
    }
    We(() => clearTimeout(M));
    function T() {
      if (!w.value) {
        if (h.value || f.value) {
          _();
          return;
        }
        s("run");
      }
    }
    return e({ tryRun: T }), (k, P) => (g(), b("div", {
      ref_key: "root",
      ref: l,
      class: "up-foot sv-pfoot",
      "data-testid": "studio-foot"
    }, [
      u("div", Ige, [
        u("span", Age, [
          i.fixed ? (g(), b("span", {
            key: 0,
            class: "up-model is-fixed",
            title: i.fixedTitle || void 0,
            "data-testid": "studio-model-fixed"
          }, [
            P[2] || (P[2] = u("span", { class: "lb" }, "Model", -1)),
            u("span", Ege, E(d.value ? d.value.name : "None"), 1)
          ], 8, Pge)) : (g(), Ce(JI, {
            key: 1,
            mode: i.kind,
            variant: "flat"
          }, null, 8, ["mode"])),
          p.value ? (g(), b("span", {
            key: 2,
            class: "up-cost",
            title: "Token cost for this run" + (d.value && d.value.time ? ", about " + d.value.time : ""),
            "data-testid": "studio-cost"
          }, [
            C($, {
              name: "Tokens",
              size: 12
            }),
            J(E(p.value), 1)
          ], 8, Rge)) : z("", !0)
        ]),
        x.value ? (g(), b(j, { key: 0 }, [
          P[3] || (P[3] = u("span", { class: "up-foot-sep" }, null, -1)),
          C(Cge, {
            mode: i.kind,
            hide: i.hide,
            pills: ""
          }, null, 8, ["mode", "hide"])
        ], 64)) : z("", !0),
        Ss(k.$slots, "chips")
      ]),
      Ss(k.$slots, "aside"),
      S.value ? (g(), b("span", {
        key: 0,
        class: "sv-out-line",
        "data-testid": "studio-output-line",
        title: S.value + ": from this tool's settings"
      }, E(S.value), 9, zge)) : z("", !0),
      v.value > 1 ? (g(), Ce(Jy, {
        key: 1,
        value: y.value,
        min: m(o).minCount(i.kind),
        max: v.value,
        testid: i.countTestid,
        onUpdate: P[0] || (P[0] = (A) => m(o).setCount(i.kind, A))
      }, null, 8, ["value", "min", "max", "testid"])) : z("", !0),
      u("span", $ge, [
        f.value && !w.value ? (g(), b("button", {
          key: 0,
          class: "up-run is-get",
          "data-testid": "studio-get-tokens",
          onClick: P[1] || (P[1] = (A) => m(a).getTokens())
        }, [
          C($, {
            name: "Tokens",
            size: 13
          }),
          P[4] || (P[4] = J("Get tokens ", -1))
        ])) : (g(), b("button", {
          key: 1,
          class: G(["up-run", { "is-busy": w.value }]),
          disabled: w.value || !!h.value,
          title: i.resting ? h.value || void 0 : h.value || w.value ? void 0 : "Run (" + m(En)(["mod", "enter"]) + ")",
          "data-testid": i.runTestid,
          onClick: T
        }, [
          w.value ? (g(), Ce($, {
            key: 0,
            name: "Loader2",
            size: 14,
            spin: ""
          })) : z("", !0),
          J(" " + E(w.value ? "Running" : i.label || "Run"), 1)
        ], 10, Dge)),
        (h.value || f.value) && !w.value && !i.resting ? (g(), b("span", Oge, E(h.value), 1)) : z("", !0)
      ])
    ], 512));
  }
}), Lge = { class: "sv-fp-head" }, Bge = {
  key: 0,
  class: "sv-fp-tag",
  "data-testid": "studio-full-prompt-edited"
}, Fge = ["aria-checked"], Nge = ["value"], Uge = { class: "sv-fp-foot" }, Gge = {
  class: "sv-fp-note",
  "data-testid": "studio-full-prompt-note"
}, jge = { class: "up-run-wrap" }, Hge = ["disabled", "title"], Vge = {
  key: 0,
  class: "tip"
}, ax = /* @__PURE__ */ Pe({
  __name: "FullPrompt",
  props: {
    kind: {}
  },
  emits: ["run"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = yt(), o = /* @__PURE__ */ K(null), r = I(() => s.fullEdit(t.kind)), a = I(() => r.value != null), l = I(() => r.value != null ? r.value : s.fullPromptOf(t.kind)), d = I(() => s.s.sending > 0), c = I(() => a.value ? s.fullProblem(t.kind, l.value) : null), h = I(() => a.value && s.fullDrifted(t.kind));
    function f() {
      const x = o.value;
      x && (x.style.height = "0px", x.style.height = Math.min(180, Math.max(54, x.scrollHeight)) + "px");
    }
    Ae(l, () => nt(f)), ot(f);
    function p(x) {
      s.setFullEdit(t.kind, x.target.value);
    }
    function y() {
      !a.value || c.value || d.value || n("run", l.value);
    }
    function v(x) {
      x.key === "Enter" && kn(x) && (x.preventDefault(), y());
    }
    return (x, w) => (g(), b("div", {
      class: G(["sv-fp", { "is-edited": a.value }]),
      "data-testid": "studio-full-prompt"
    }, [
      u("div", Lge, [
        w[4] || (w[4] = u("span", { class: "t" }, "Full prompt", -1)),
        C(vt, { name: "sv-fp-tag" }, {
          default: Xe(() => [
            a.value ? (g(), b("span", Bge, "Edited")) : z("", !0)
          ]),
          _: 1
        }),
        w[5] || (w[5] = u("span", { class: "sv-grow" }, null, -1)),
        m(s).takesWordsOnly(i.kind) ? (g(), b("button", {
          key: 0,
          class: G(["sv-fp-only", { on: m(s).s.wordsOnly }]),
          role: "switch",
          "aria-checked": m(s).s.wordsOnly,
          title: "Send exactly what you typed, without the lines about the pictures and notes",
          "data-testid": "studio-words-only",
          onClick: w[0] || (w[0] = (S) => m(s).setWordsOnly(!m(s).s.wordsOnly))
        }, [...w[2] || (w[2] = [
          u("i", null, null, -1),
          J("Send my words only", -1)
        ])], 10, Fge)) : z("", !0),
        a.value ? (g(), b("button", {
          key: 1,
          class: "sv-fp-reset",
          title: "Back to the prompt put together from your words",
          "data-testid": "studio-full-prompt-reset",
          onClick: w[1] || (w[1] = (S) => m(s).resetFullEdit(i.kind))
        }, [
          C($, {
            name: "RotateCcw",
            size: 11
          }),
          w[3] || (w[3] = J(" Reset ", -1))
        ])) : z("", !0)
      ]),
      u("textarea", {
        ref_key: "el",
        ref: o,
        class: "sv-fp-text",
        value: l.value,
        spellcheck: "false",
        "aria-label": "Full prompt",
        "data-testid": "studio-full-prompt-text",
        onInput: p,
        onKeydown: v
      }, null, 40, Nge),
      u("div", Uge, [
        u("span", Gge, [
          h.value ? (g(), b(j, { key: 0 }, [
            J("Your words changed since: reset to start again from them")
          ], 64)) : a.value ? (g(), b(j, { key: 1 }, [
            J("Runs instead of the prompt put together from your words")
          ], 64)) : m(s).s.wordsOnly && m(s).takesWordsOnly(i.kind) ? (g(), b(j, { key: 2 }, [
            J("Only your words go: the lines about the pictures and notes are left out")
          ], 64)) : (g(), b(j, { key: 3 }, [
            J("What the model gets. Change it to run your own")
          ], 64))
        ]),
        u("span", jge, [
          u("button", {
            class: G(["up-run sv-fp-run", { "is-busy": d.value && a.value }]),
            disabled: !a.value || !!c.value || d.value,
            title: a.value ? void 0 : "Change the prompt to run it",
            "data-testid": "studio-full-prompt-run",
            onClick: y
          }, [
            d.value && a.value ? (g(), Ce($, {
              key: 0,
              name: "Loader2",
              size: 13,
              spin: ""
            })) : z("", !0),
            J(" " + E(d.value && a.value ? "Running" : "Run with this prompt"), 1)
          ], 10, Hge),
          a.value && c.value && !d.value ? (g(), b("span", Vge, E(c.value), 1)) : z("", !0)
        ])
      ])
    ], 2));
  }
}), Wge = ["aria-expanded", "title"], qge = {
  key: 0,
  class: "dot",
  "aria-hidden": "true"
}, lx = /* @__PURE__ */ Pe({
  __name: "FullPromptToggle",
  props: {
    kind: {}
  },
  setup(i) {
    const e = i, t = yt(), n = I(() => !!t.s.fullOpen[e.kind]), s = I(() => t.fullEdit(e.kind) != null), o = I(() => n.value || t.fullShown(e.kind)), r = I(() => n.value ? "Hide the full prompt" : s.value ? "Your edited prompt: open it to run it" : "See the whole prompt the model gets, and change it");
    return (a, l) => o.value ? (g(), b("button", {
      key: 0,
      class: G(["sv-fp-link", { on: n.value, "is-edited": s.value }]),
      "aria-expanded": n.value,
      title: r.value,
      "data-testid": "studio-full-prompt-toggle",
      onClick: l[0] || (l[0] = (d) => m(t).setFullOpen(i.kind, !n.value))
    }, [
      l[1] || (l[1] = u("span", null, "Full prompt", -1)),
      s.value ? (g(), b("span", qge)) : z("", !0),
      C($, {
        name: "ChevronDown",
        size: 12,
        class: "chev"
      })
    ], 10, Wge)) : z("", !0);
  }
}), Kge = {
  key: 0,
  class: "ed-collapse"
}, pa = /* @__PURE__ */ Pe({
  __name: "Collapse",
  props: {
    open: { type: Boolean }
  },
  setup(i) {
    const e = () => typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function t(r, a) {
      let l = !1;
      const d = () => {
        l || (l = !0, r.removeEventListener("transitionend", c), a());
      }, c = (h) => {
        h.target === r && h.propertyName === "height" && d();
      };
      r.addEventListener("transitionend", c), window.setTimeout(d, 520);
    }
    function n(r, a) {
      const l = r;
      if (e()) {
        a();
        return;
      }
      l.style.clipPath = "inset(0)", l.style.height = "0px", l.style.opacity = "0", l.offsetHeight, l.style.height = l.scrollHeight + "px", l.style.opacity = "1", t(l, a);
    }
    function s(r) {
      const a = r;
      a.style.height = "", a.style.opacity = "", a.style.clipPath = "";
    }
    function o(r, a) {
      const l = r;
      if (e()) {
        a();
        return;
      }
      l.style.clipPath = "inset(0)", l.style.height = l.scrollHeight + "px", l.offsetHeight, l.style.height = "0px", l.style.opacity = "0", t(l, a);
    }
    return (r, a) => (g(), Ce(vt, {
      css: !1,
      onEnter: n,
      onAfterEnter: s,
      onLeave: o
    }, {
      default: Xe(() => [
        i.open ? (g(), b("div", Kge, [
          Ss(r.$slots, "default")
        ])) : z("", !0)
      ]),
      _: 3
    }));
  }
}), Yge = { class: "ed-slider-head" }, Xge = { class: "lb" }, Jge = ["title"], Zge = { class: "ed-slider-track" }, Qge = ["min", "max", "step", "value", "disabled", "aria-label", "data-testid"], Ct = /* @__PURE__ */ Pe({
  __name: "Slider",
  props: {
    label: {},
    modelValue: {},
    min: {},
    max: {},
    step: { default: 1 },
    start: { default: 0 },
    format: { type: [Function, null], default: null },
    ticks: { default: () => [] },
    testid: { default: void 0 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "commit"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = I(() => t.min < 0 && t.max > 0), o = I(() => Math.max(1e-9, t.max - t.min)), r = (f) => (Math.min(t.max, Math.max(t.min, f)) - t.min) / o.value, a = I(() => {
      const f = s.value ? r(0) : 0, p = r(t.modelValue);
      return { left: Math.min(f, p) * 100 + "%", width: Math.abs(p - f) * 100 + "%" };
    }), l = I(() => {
      if (t.format) return t.format(t.modelValue);
      const f = Math.round(t.modelValue * 100) / 100;
      return s.value && f > 0 ? "+" + f : String(f);
    }), d = I(() => Math.abs(t.modelValue - t.start) > 1e-9);
    function c(f) {
      n("update:modelValue", Number(f.target.value));
    }
    function h() {
      t.disabled || (n("update:modelValue", t.start), n("commit", t.start));
    }
    return (f, p) => (g(), b("label", {
      class: G(["ed-slider", { "is-changed": d.value, "is-off": i.disabled }]),
      onDblclick: h
    }, [
      u("span", Yge, [
        u("span", Xge, E(i.label), 1),
        u("span", {
          class: "v",
          title: d.value ? "Double-click to reset" : ""
        }, E(l.value), 9, Jge)
      ]),
      u("span", Zge, [
        p[1] || (p[1] = u("span", { class: "rail" }, null, -1)),
        u("span", {
          class: "fill",
          style: ce(a.value)
        }, null, 4),
        (g(!0), b(j, null, be(i.ticks, (y) => (g(), b("i", {
          key: y,
          class: G(["tick", { on: Math.abs(y - i.modelValue) < 1e-6 }]),
          style: ce({ left: r(y) * 100 + "%" })
        }, null, 6))), 128)),
        u("input", {
          type: "range",
          min: i.min,
          max: i.max,
          step: i.step,
          value: i.modelValue,
          disabled: i.disabled,
          "aria-label": i.label,
          "data-testid": i.testid,
          onInput: c,
          onChange: p[0] || (p[0] = (y) => n("commit", Number(y.target.value)))
        }, null, 40, Qge)
      ])
    ], 34));
  }
}), ebe = ["data-testid"], tbe = {
  key: 0,
  class: "ed-field"
}, nbe = { class: "ed-field-lb" }, ibe = ["aria-label"], sbe = ["aria-checked", "onClick"], obe = {
  key: 1,
  class: "ed-field"
}, rbe = { class: "ed-field-lb" }, abe = { class: "ed-select" }, lbe = ["value", "onChange"], dbe = ["value"], cbe = {
  key: 3,
  class: "ed-field"
}, ube = { class: "ed-field-lb" }, hbe = ["value", "placeholder", "onInput"], pbe = ["aria-expanded"], fbe = {
  key: 1,
  class: "ed-fields-more"
}, mbe = {
  key: 1,
  class: "ed-switch"
}, gbe = ["checked", "onChange"], bbe = {
  key: 2,
  class: "ed-field"
}, vbe = { class: "ed-field-lb" }, ybe = { class: "ed-select" }, xbe = ["value", "onChange"], wbe = ["value"], kbe = {
  key: 3,
  class: "ed-field"
}, _be = { class: "ed-field-lb" }, Sbe = ["value", "placeholder", "onInput"], dx = /* @__PURE__ */ Pe({
  __name: "ModelFields",
  props: {
    kind: {},
    skip: { default: () => [] },
    part: { default: "all" }
  },
  setup(i) {
    const e = i, t = yt(), n = /* @__PURE__ */ K(!1), s = I(() => t.modelOf(e.kind)), o = I(() => {
      const p = s.value;
      return p ? p.fields.filter((y) => y.placement !== "reference" && y.kind !== "seed" && y.kind !== "header" && y.kind !== "model" && y.kind !== "video" && !e.skip.includes(y.key) && !e.skip.includes(y.label)) : [];
    }), r = I(() => e.part === "more" ? [] : o.value.filter((p) => p.placement === "chip" || p.placement === "prompt")), a = I(() => o.value.filter((p) => p.placement === "advanced"));
    function l(p) {
      return t.valueOf(e.kind, p);
    }
    function d(p, y) {
      t.setInput(e.kind, p.key, y);
    }
    function c(p) {
      const y = l(p), v = typeof y == "number" ? y : Number(y);
      return Number.isFinite(v) ? v : Number(p.defaultValue) || 0;
    }
    function h(p) {
      return p.replace(/\s*\(optional\)\s*/i, "").replace(/\s*\(must be [^)]*\)\s*/i, "");
    }
    function f(p) {
      return p.replace(/_n_/g, " and ").replace(/_/g, " ").replace(/^\w/, (y) => y.toUpperCase());
    }
    return (p, y) => (i.part === "more" ? a.value.length : o.value.length) ? (g(), b("div", {
      key: 0,
      class: "ed-fields",
      "data-testid": i.part === "more" ? "studio-edit-more" : void 0
    }, [
      (g(!0), b(j, null, be(r.value, (v) => {
        var x, w, S, M;
        return g(), b(j, {
          key: v.key
        }, [
          (v.kind === "select" || v.kind === "size") && v.options && v.options.length <= 5 ? (g(), b("div", tbe, [
            u("span", nbe, E(h(v.label)), 1),
            u("div", {
              class: "sv-seg is-small ed-pills",
              role: "radiogroup",
              "aria-label": v.label
            }, [
              (g(!0), b(j, null, be(v.options, (_) => (g(), b("button", {
                key: String(_.label),
                role: "radio",
                "aria-checked": m(Qi)(_.value, l(v)),
                class: G({ on: m(Qi)(_.value, l(v)) }),
                onClick: (T) => d(v, _.value)
              }, E(/^\d+$/.test(String(_.label)) ? _.label + "×" : f(String(_.label))), 11, sbe))), 128))
            ], 8, ibe)
          ])) : v.kind === "select" && v.options ? (g(), b("label", obe, [
            u("span", rbe, E(h(v.label)), 1),
            u("span", abe, [
              u("select", {
                value: JSON.stringify(l(v)),
                onChange: (_) => d(v, JSON.parse(_.target.value))
              }, [
                (g(!0), b(j, null, be(v.options, (_) => (g(), b("option", {
                  key: String(_.label),
                  value: JSON.stringify(_.value)
                }, E(f(String(_.label))), 9, dbe))), 128))
              ], 40, lbe),
              C($, {
                name: "ChevronDown",
                size: 12
              })
            ])
          ])) : v.kind === "slider" ? (g(), Ce(Ct, {
            key: 2,
            label: h(v.label),
            "model-value": c(v),
            min: (x = v.min) != null ? x : 0,
            max: (w = v.max) != null ? w : 100,
            step: (S = v.step) != null ? S : 1,
            start: Number(v.defaultValue) || 0,
            "onUpdate:modelValue": (_) => d(v, _)
          }, null, 8, ["label", "model-value", "min", "max", "step", "start", "onUpdate:modelValue"])) : v.kind === "prompt" || v.kind === "text" ? (g(), b("label", cbe, [
            u("span", ube, E(h(v.label)), 1),
            u("textarea", {
              class: "ed-text",
              rows: "2",
              value: String((M = l(v)) != null ? M : ""),
              placeholder: v.placeholder || "Optional",
              spellcheck: "false",
              onInput: (_) => d(v, _.target.value)
            }, null, 40, hbe)
          ])) : z("", !0)
        ], 64);
      }), 128)),
      a.value.length && i.part !== "more" ? (g(), b("button", {
        key: 0,
        class: G(["ed-more", { on: n.value }]),
        "aria-expanded": n.value,
        onClick: y[0] || (y[0] = (v) => n.value = !n.value)
      }, [
        C($, {
          name: "Settings2",
          size: 12
        }),
        J(" " + E(n.value ? "Fewer settings" : "More settings") + " ", 1),
        C($, {
          name: n.value ? "ChevronUp" : "ChevronDown",
          size: 12
        }, null, 8, ["name"])
      ], 10, pbe)) : z("", !0),
      n.value || i.part === "more" ? (g(), b("div", fbe, [
        (g(!0), b(j, null, be(a.value, (v) => {
          var x, w, S, M;
          return g(), b(j, {
            key: v.key
          }, [
            v.kind === "slider" ? (g(), Ce(Ct, {
              key: 0,
              label: h(v.label),
              "model-value": c(v),
              min: (x = v.min) != null ? x : 0,
              max: (w = v.max) != null ? w : 100,
              step: (S = v.step) != null ? S : 1,
              start: Number(v.defaultValue) || 0,
              "onUpdate:modelValue": (_) => d(v, _)
            }, null, 8, ["label", "model-value", "min", "max", "step", "start", "onUpdate:modelValue"])) : v.kind === "boolean" ? (g(), b("label", mbe, [
              u("input", {
                type: "checkbox",
                checked: !!l(v),
                onChange: (_) => d(v, _.target.checked)
              }, null, 40, gbe),
              y[1] || (y[1] = u("i", null, null, -1)),
              u("span", null, E(h(v.label)), 1)
            ])) : (v.kind === "select" || v.kind === "size") && v.options ? (g(), b("label", bbe, [
              u("span", vbe, E(h(v.label)), 1),
              u("span", ybe, [
                u("select", {
                  value: JSON.stringify(l(v)),
                  onChange: (_) => d(v, JSON.parse(_.target.value))
                }, [
                  (g(!0), b(j, null, be(v.options, (_) => (g(), b("option", {
                    key: String(_.label),
                    value: JSON.stringify(_.value)
                  }, E(f(String(_.label))), 9, wbe))), 128))
                ], 40, xbe),
                C($, {
                  name: "ChevronDown",
                  size: 12
                })
              ])
            ])) : v.kind === "prompt" || v.kind === "text" || v.kind === "negPrompt" ? (g(), b("label", kbe, [
              u("span", _be, E(h(v.label)), 1),
              u("textarea", {
                class: "ed-text",
                rows: "2",
                value: String((M = l(v)) != null ? M : ""),
                placeholder: v.placeholder || "Optional",
                spellcheck: "false",
                onInput: (_) => d(v, _.target.value)
              }, null, 40, Sbe)
            ])) : z("", !0)
          ], 64);
        }), 128))
      ])) : z("", !0)
    ], 8, ebe)) : z("", !0);
  }
}), Mbe = {
  class: "sv-describe",
  "data-testid": "studio-composer"
}, Tbe = ["value", "placeholder"], Cbe = ["aria-expanded"], Ibe = ["aria-expanded"], Abe = ["title"], Pbe = /* @__PURE__ */ Pe({
  __name: "Composer",
  props: {
    before: { type: [Function, null], default: null },
    label: { default: null }
  },
  setup(i) {
    const e = i, t = yt(), { board: n } = Ze(), s = t.s, o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = I(() => t.genMode.value), l = I(() => t.sending()), d = I(() => t.queueItems.value.length > 0 && t.limit.value > 0), c = I(() => Math.max(0, Math.min(t.queueItems.value.length, t.limit.value) - 1)), h = I(() => a.value === "threed" && !!e.before), f = I(() => t.fullTakesOver(a.value)), p = I(() => !!s.fullOpen[a.value] && t.fullShown(a.value)), y = /* @__PURE__ */ K(!1), v = I(() => t.advancedOf(a.value).length > 0);
    Ae(a, () => {
      y.value = !1;
    });
    const x = I(() => n.ui.library.open && n.ui.library.inStudio);
    function w() {
      if (x.value) {
        n.promptLibrary.close();
        return;
      }
      t.commitPrompt(), n.promptLibrary.openInStudio(t.sessionId);
    }
    function S(R, D) {
      return R + " " + D + (R === 1 ? "" : "s");
    }
    const M = I(() => l.value.map((R) => {
      const D = [R.marks ? S(R.marks, "annotation") : "", R.comments ? S(R.comments, "note") : ""].filter(Boolean);
      return "Image " + R.image + ": " + D.join(", ");
    }).join(" · ")), _ = I(() => {
      if (l.value.length) {
        const R = l.value.reduce((F, te) => F + te.marks, 0), D = l.value.reduce((F, te) => F + te.comments, 0);
        return { icon: "Pencil", text: [R ? S(R, "annotation") : "", D ? S(D, "note") : ""].filter(Boolean).join(", ") + (R + D === 1 ? " goes with it" : " go with them"), title: "Goes with it: " + M.value };
      }
      return d.value ? { icon: "Images", text: c.value ? "From image 1, with " + c.value + " more" : "From image 1", title: "Starts from image 1" + (c.value ? ", with " + c.value + " more as references" : "") } : null;
    }), T = I(() => t.video.value ? d.value ? c.value ? "Describe the video to make from these pictures" : "Describe the video to make from image 1" : "Describe a new video" : d.value ? l.value.length ? "Anything to add? Their annotations and notes go with them" : c.value ? "Describe what to make from these images" : "Describe what to make from image 1" : "Describe a new image");
    function k() {
      const R = o.value;
      R && (R.style.height = "0px", R.style.height = Math.min(160, Math.max(48, R.scrollHeight)) + "px");
    }
    Ae(() => s.prompt, () => nt(k)), ot(() => {
      k(), s.studio === "prompt" && o.value && o.value.focus();
    });
    async function P(R = null) {
      s.sending || e.before && !await e.before() || await t.generate(R);
    }
    function A(R) {
      R.key === "Enter" && kn(R) && (R.preventDefault(), r.value && r.value.tryRun());
    }
    return (R, D) => (g(), b("div", Mbe, [
      u("div", {
        class: G(["sv-words", { "has-side": a.value === "prompt" }])
      }, [
        u("textarea", {
          ref_key: "text",
          ref: o,
          value: m(s).prompt,
          class: "up-text sv-describe-text",
          rows: "1",
          spellcheck: "false",
          placeholder: T.value,
          "data-testid": "studio-prompt",
          onInput: D[0] || (D[0] = (O) => {
            m(t).setPrompt(O.target.value), k();
          }),
          onBlur: D[1] || (D[1] = (O) => m(t).commitPrompt()),
          onKeydown: A
        }, null, 40, Tbe),
        a.value === "prompt" ? (g(), b("button", {
          key: 0,
          class: G(["up-side-btn sv-words-side", { on: x.value }]),
          title: "Prompt library",
          "aria-label": "Prompt library",
          "aria-expanded": x.value,
          "data-testid": "studio-library-button",
          onClick: w
        }, [
          C($, {
            name: "LayoutTemplate",
            size: 15
          })
        ], 10, Cbe)) : z("", !0)
      ], 2),
      C(pa, { open: p.value }, {
        default: Xe(() => [
          C(ax, {
            kind: a.value,
            onRun: P
          }, null, 8, ["kind"])
        ]),
        _: 1
      }, 8, ["open"]),
      C(pa, {
        open: y.value && v.value
      }, {
        default: Xe(() => [
          C(dx, {
            kind: a.value,
            part: "more"
          }, null, 8, ["kind"])
        ]),
        _: 1
      }, 8, ["open"]),
      C(ZI, {
        ref_key: "foot",
        ref: r,
        kind: a.value,
        resting: f.value,
        unchecked: h.value,
        label: i.label,
        "run-testid": "studio-generate",
        "count-testid": "studio-count",
        onRun: D[3] || (D[3] = (O) => P())
      }, {
        chips: Xe(() => [
          v.value ? (g(), b("button", {
            key: 0,
            class: G(["up-chip", { on: y.value }]),
            "aria-expanded": y.value,
            title: "More settings",
            "data-testid": "studio-more-toggle",
            onClick: D[2] || (D[2] = (O) => y.value = !y.value)
          }, [
            C($, {
              name: "Settings2",
              size: 13
            }),
            D[4] || (D[4] = u("span", { class: "t" }, "More", -1))
          ], 10, Ibe)) : z("", !0),
          _.value ? (g(), b(j, { key: 1 }, [
            D[5] || (D[5] = u("span", { class: "up-foot-sep" }, null, -1)),
            u("span", {
              class: "up-note",
              title: _.value.title,
              "data-testid": "studio-sending"
            }, [
              C($, {
                name: _.value.icon,
                size: 12
              }, null, 8, ["name"]),
              J(E(_.value.text), 1)
            ], 8, Abe)
          ], 64)) : z("", !0)
        ]),
        aside: Xe(() => [
          C(lx, { kind: a.value }, null, 8, ["kind"])
        ]),
        _: 1
      }, 8, ["kind", "resting", "unchecked", "label"])
    ]));
  }
}), ym = /* @__PURE__ */ Pe({
  __name: "Radio",
  props: {
    on: { type: Boolean }
  },
  setup(i) {
    return (e, t) => (g(), b("span", {
      class: G(["ed-radio", { on: i.on }]),
      "aria-hidden": "true"
    }, [...t[0] || (t[0] = [
      u("i", null, null, -1)
    ])], 2));
  }
}), Ebe = /* @__PURE__ */ Pe({
  __name: "AutoHeight",
  setup(i) {
    const e = /* @__PURE__ */ K(null), t = /* @__PURE__ */ K(null), n = /* @__PURE__ */ K(!1);
    let s = null, o = 0;
    function r() {
      if (!e.value) return;
      const a = e.value.offsetHeight;
      t.value != null && Math.abs(a - t.value) > 0.5 && (n.value = !0, clearTimeout(o), o = window.setTimeout(() => {
        n.value = !1;
      }, 380)), t.value = a;
    }
    return ot(() => {
      r(), e.value && (s = new ResizeObserver(r), s.observe(e.value));
    }), We(() => {
      s && s.disconnect(), clearTimeout(o);
    }), (a, l) => (g(), b("div", {
      class: G(["ed-autoh", { "is-moving": n.value }]),
      style: ce({ height: t.value != null ? t.value + "px" : "auto" })
    }, [
      u("div", {
        ref_key: "inner",
        ref: e,
        class: "ed-autoh-in"
      }, [
        Ss(a.$slots, "default")
      ], 512)
    ], 6));
  }
}), Rbe = {
  class: "ed-tools-inline",
  "data-testid": "studio-area-tools"
}, zbe = {
  class: "sv-seg is-small ed-seg-icons",
  role: "radiogroup",
  "aria-label": "Select the area with"
}, $be = ["aria-checked", "title", "aria-label", "data-testid", "onClick"], Dbe = ["aria-pressed", "title"], Obe = ["title"], Lbe = ["disabled", "title"], Bbe = ["disabled", "title"], Fbe = ["disabled"], Nbe = /* @__PURE__ */ Pe({
  __name: "AreaTools",
  setup(i) {
    const e = yt(), t = e.s, n = [
      { id: "brush", icon: "Paintbrush", label: "Brush", key: "B", hint: "Paint over what should change" },
      { id: "lasso", icon: "LassoSelect", label: "Lasso", key: "L", hint: "Draw round what should change" },
      { id: "object", icon: "MousePointerClick", label: "Pick an object", key: "S", hint: "Click a thing in the picture to take it all" }
    ], s = En(["alt"]), o = I(() => e.area().length > 0);
    function r(a) {
      t.areaTool = a;
    }
    return (a, l) => (g(), b("div", Rbe, [
      u("div", zbe, [
        (g(), b(j, null, be(n, (d) => u("button", {
          key: d.id,
          role: "radio",
          "aria-checked": m(t).areaTool === d.id,
          class: G({ on: m(t).areaTool === d.id }),
          title: d.label + " (" + d.key + `)
` + d.hint,
          "aria-label": d.label,
          "data-testid": "studio-area-" + d.id,
          onClick: (c) => r(d.id)
        }, [
          C($, {
            name: d.icon,
            size: 14
          }, null, 8, ["name"])
        ], 10, $be)), 64))
      ]),
      u("button", {
        class: G(["ed-icon-chip", { on: m(t).areaCut }]),
        "aria-pressed": m(t).areaCut,
        title: `Take away from the area
Or hold ` + m(s) + " as you paint",
        "data-testid": "studio-area-cut",
        onClick: l[0] || (l[0] = (d) => m(t).areaCut = !m(t).areaCut)
      }, [
        C($, {
          name: "Minus",
          size: 13
        })
      ], 10, Dbe),
      m(t).areaTool === "brush" ? (g(), b("label", {
        key: 0,
        class: "ed-size",
        title: "Brush size: " + m(t).areaSize + `
[ and ] change it`
      }, [
        u("i", {
          style: ce({ width: Math.max(4, Math.min(18, m(t).areaSize / 6)) + "px", height: Math.max(4, Math.min(18, m(t).areaSize / 6)) + "px" })
        }, null, 4),
        kt(u("input", {
          "onUpdate:modelValue": l[1] || (l[1] = (d) => m(t).areaSize = d),
          type: "range",
          min: "6",
          max: "200",
          step: "1",
          "aria-label": "Brush size",
          "data-testid": "studio-area-size"
        }, null, 512), [
          [
            Zt,
            m(t).areaSize,
            void 0,
            { number: !0 }
          ]
        ])
      ], 8, Obe)) : z("", !0),
      l[5] || (l[5] = u("span", { class: "ed-mini-sep" }, null, -1)),
      u("button", {
        class: "ed-icon-chip",
        disabled: !m(e).canUndo(),
        title: "Undo (" + m(En)(["mod", "Z"]) + ")",
        "aria-label": "Undo",
        onClick: l[2] || (l[2] = (d) => m(e).undoMark())
      }, [
        C($, {
          name: "Undo2",
          size: 13
        })
      ], 8, Lbe),
      u("button", {
        class: "ed-icon-chip",
        disabled: !m(e).canRedo(),
        title: "Redo (" + m(En)(m(z1)()) + ")",
        "aria-label": "Redo",
        onClick: l[3] || (l[3] = (d) => m(e).redoMark())
      }, [
        C($, {
          name: "Redo2",
          size: 13
        })
      ], 8, Bbe),
      u("button", {
        class: "ed-icon-chip",
        disabled: !o.value,
        title: "Clear the area",
        "aria-label": "Clear the area",
        "data-testid": "studio-area-clear",
        onClick: l[4] || (l[4] = (d) => m(e).clearArea())
      }, [
        C($, {
          name: "Trash2",
          size: 13
        })
      ], 8, Fbe)
    ]));
  }
}), Ube = { class: "sv-pop-wrap" }, Gbe = ["aria-expanded", "title"], jbe = {
  key: 0,
  class: "sv-pop ed-mark-pop",
  role: "radiogroup",
  "aria-label": "Annotate with"
}, Hbe = ["aria-checked", "data-testid", "onClick"], Vbe = { class: "nm" }, Wbe = ["value"], qbe = ["disabled"], Kbe = { class: "sv-pop-wrap" }, Ybe = ["title"], Xbe = { class: "ed-swatch-row" }, Jbe = ["title", "onClick"], Zbe = ["value"], Qbe = ["title"], eve = ["value", "disabled"], tve = { "data-testid": "studio-opacity-value" }, nve = ["disabled", "title"], ive = ["disabled", "title"], sve = /* @__PURE__ */ Pe({
  __name: "MarkTools",
  setup(i) {
    const e = yt(), t = e.s, n = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K(null), o = [
      { id: "move", icon: "MousePointer2", label: "Move", key: "V", hint: "Select annotations to move, resize or turn them" },
      { id: "brush", icon: "Brush", label: "Pencil", key: "B", hint: "Draw on the picture to show where" },
      { id: "text", icon: "Type", label: "Text", key: "T", hint: "Write a label on the picture" },
      { id: "box", icon: "Square", label: "Box", key: "R", hint: "Box an area" },
      { id: "ellipse", icon: "Circle", label: "Ellipse", key: "O", hint: "Circle an area" },
      { id: "arrow", icon: "ArrowUpRight", label: "Arrow", key: "A", hint: "Point at something" },
      { id: "eraser", icon: "Eraser", label: "Eraser", key: "E", hint: "Rub out parts of your annotations" },
      { id: "note", icon: "MapPin", label: "Note", key: "N", hint: "Pin a numbered note where something should change" }
    ], r = I(() => o.find((S) => S.id === t.tool) || o[1]), a = I(() => !z0.includes(t.color)), l = I(() => t.tool === "text"), d = I(() => Math.round(t.opacity * 100));
    let c = !1;
    function h() {
      c = !0, t.tool === "move" && t.selection.length && e.beginGesture();
    }
    function f(S) {
      e.setOpacity(Number(S.target.value) / 100, !c);
    }
    function p() {
      c = !1;
    }
    const y = I(() => {
      const S = e.working();
      return S.strokes.length > 0 || S.pins.length > 0;
    });
    function v(S) {
      e.finishEditing(), t.tool = S, S !== "move" && e.select([]), n.value = null;
    }
    function x(S) {
      !Number.isFinite(S) || S <= 0 || (t.size = Math.max(1, Math.min(80, Math.round(S))));
    }
    function w(S) {
      s.value && !s.value.contains(S.target) && (n.value = null);
    }
    return Ae(n, (S) => {
      S ? window.addEventListener("pointerdown", w, !0) : window.removeEventListener("pointerdown", w, !0);
    }), We(() => window.removeEventListener("pointerdown", w, !0)), (S, M) => (g(), b("div", {
      ref_key: "wrap",
      ref: s,
      class: "ed-tools-inline",
      "data-testid": "studio-mark-tools",
      onKeydown: M[8] || (M[8] = tn(Se((_) => n.value = null, ["stop"]), ["esc"]))
    }, [
      u("div", Ube, [
        u("button", {
          class: G(["sv-chip ed-tool-chip", { on: n.value === "tool" }]),
          "aria-expanded": n.value === "tool",
          title: r.value.label + " (" + r.value.key + `)
` + r.value.hint,
          "data-testid": "studio-mark-tool",
          onClick: M[0] || (M[0] = (_) => n.value = n.value === "tool" ? null : "tool")
        }, [
          C($, {
            name: r.value.icon,
            size: 13
          }, null, 8, ["name"]),
          u("span", null, E(r.value.label), 1),
          C($, {
            name: "ChevronUp",
            size: 11,
            class: "chev"
          })
        ], 10, Gbe),
        n.value === "tool" ? (g(), b("div", jbe, [
          (g(), b(j, null, be(o, (_) => u("button", {
            key: _.id,
            class: G(["ed-mark-row", { on: m(t).tool === _.id }]),
            role: "radio",
            "aria-checked": m(t).tool === _.id,
            "data-testid": "studio-tool-" + _.id,
            onClick: (T) => v(_.id)
          }, [
            C($, {
              name: _.icon,
              size: 14
            }, null, 8, ["name"]),
            u("span", Vbe, E(_.label), 1),
            u("kbd", null, E(_.key), 1)
          ], 10, Hbe)), 64)),
          u("div", {
            class: G(["ed-mark-size", { "is-off": m(t).tool === "move" || m(t).tool === "text" || m(t).tool === "note" }])
          }, [
            M[9] || (M[9] = u("span", null, "Size", -1)),
            u("input", {
              value: m(t).size,
              type: "range",
              min: "1",
              max: "80",
              step: "1",
              "aria-label": "Size",
              onInput: M[1] || (M[1] = (_) => x(+_.target.value))
            }, null, 40, Wbe),
            u("b", null, E(m(t).size), 1)
          ], 2),
          u("button", {
            class: "ed-mark-clear",
            disabled: !y.value,
            "data-testid": "studio-clear",
            onClick: M[2] || (M[2] = (_) => {
              m(e).clearMarks(), n.value = null;
            })
          }, [
            C($, {
              name: "Trash2",
              size: 12
            }),
            M[10] || (M[10] = J(" Clear annotations and notes", -1))
          ], 8, qbe)
        ])) : z("", !0)
      ]),
      u("div", Kbe, [
        u("button", {
          class: G(["sv-color ed-color", { on: n.value === "colour" }]),
          style: ce({ "--c": m(t).color, "--o": l.value ? 1 : m(t).opacity }),
          title: "Colour" + (l.value ? "" : ", " + d.value + "% opacity"),
          "aria-label": "Colour and opacity",
          "data-testid": "studio-color",
          onClick: M[3] || (M[3] = (_) => n.value = n.value === "colour" ? null : "colour")
        }, [...M[11] || (M[11] = [
          u("i", null, null, -1)
        ])], 14, Ybe),
        n.value === "colour" ? (g(), b("div", {
          key: 0,
          class: "sv-pop is-colors ed-colour-pop",
          "data-testid": "studio-colour-pop",
          onPointerdown: M[5] || (M[5] = Se(() => {
          }, ["stop"]))
        }, [
          u("div", Xbe, [
            (g(!0), b(j, null, be(m(z0), (_) => (g(), b("button", {
              key: _,
              class: G(["sw", { on: m(t).color === _ }]),
              style: ce({ "--c": _ }),
              title: _,
              onClick: (T) => m(e).setColor(_)
            }, null, 14, Jbe))), 128)),
            u("label", {
              class: G(["sw is-any", { on: a.value }]),
              style: ce(a.value ? { "--c": m(t).color } : void 0),
              title: "Any colour"
            }, [
              u("input", {
                type: "color",
                value: m(t).color,
                onInput: M[4] || (M[4] = (_) => m(e).setColor(_.target.value))
              }, null, 40, Zbe)
            ], 6)
          ]),
          u("label", {
            class: G(["ed-opacity", { "is-off": l.value }]),
            title: l.value ? "Text stays solid, so it reads clearly" : "How see-through new annotations are"
          }, [
            M[12] || (M[12] = u("span", { class: "lb" }, "Opacity", -1)),
            u("input", {
              class: "ed-opacity-range",
              type: "range",
              min: "10",
              max: "100",
              step: "5",
              value: d.value,
              disabled: l.value,
              style: ce({ "--c": m(t).color }),
              "aria-label": "Opacity",
              "data-testid": "studio-opacity",
              onPointerdown: h,
              onInput: f,
              onChange: p
            }, null, 44, eve),
            u("b", tve, E(l.value ? 100 : d.value) + "%", 1)
          ], 10, Qbe)
        ], 32)) : z("", !0)
      ]),
      M[13] || (M[13] = u("span", { class: "ed-mini-sep" }, null, -1)),
      u("button", {
        class: "ed-icon-chip",
        disabled: !m(e).canUndo(),
        title: "Undo (" + m(En)(["mod", "Z"]) + ")",
        "aria-label": "Undo",
        "data-testid": "studio-undo",
        onClick: M[6] || (M[6] = (_) => m(e).undoMark())
      }, [
        C($, {
          name: "Undo2",
          size: 13
        })
      ], 8, nve),
      u("button", {
        class: "ed-icon-chip",
        disabled: !m(e).canRedo(),
        title: "Redo (" + m(En)(m(z1)()) + ")",
        "aria-label": "Redo",
        "data-testid": "studio-redo",
        onClick: M[7] || (M[7] = (_) => m(e).redoMark())
      }, [
        C($, {
          name: "Redo2",
          size: 13
        })
      ], 8, ive)
    ], 544));
  }
}), ove = { class: "sv-queue-slots" }, rve = ["title", "onMouseenter"], ave = {
  key: 0,
  class: "n"
}, lve = ["aria-label", "onClick"], dve = {
  key: 0,
  class: "sv-slot-add-wrap"
}, cve = ["title", "aria-expanded"], uve = { class: "n" }, hve = /* @__PURE__ */ Pe({
  __name: "EditRefs",
  props: {
    over: { type: Boolean }
  },
  setup(i) {
    const e = i, t = yt(), n = t.s, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(!1), r = I(() => t.editRefItems.value), a = I(() => t.refRoom()), l = I(() => r.value.filter((D) => D.id !== n.stageId)), d = I(() => l.value.length < a.value), c = I(() => t.modelName("edit")), h = I(() => n.bar !== "annotate" && t.hasArea() ? 3 : 2), f = I(() => !!Yr.value && !r.value.some((D) => D.id === Yr.value));
    function p(D) {
      return t.refSent(D.id);
    }
    function y(D) {
      return D.id === n.stageId ? "In the viewer: it's the picture being edited, so it isn't sent as a reference" : p(D) ? "Image " + v(D) + ": a reference" : "Waits: " + c.value + " takes " + a.value + (a.value === 1 ? " reference" : " references") + " here";
    }
    function v(D) {
      return h.value + l.value.findIndex((O) => O.id === D.id);
    }
    function x(D) {
      const O = n.refPulse;
      return O && O.id === D ? O.n : 0;
    }
    function w(D) {
      _.value = null, t.removeEditRef(D.id);
    }
    async function S(D) {
      o.value = !1, await t.addEditRefUrl(D);
    }
    function M() {
      o.value = !1, t.setDropper(!0);
    }
    const _ = /* @__PURE__ */ qe(null);
    function T(D, O) {
      if (!s.value || Yr.value) return;
      const F = Math.min(YI / D.w, XI / D.h), te = Math.round(D.w * F), ee = Math.round(D.h * F), me = O.currentTarget.getBoundingClientRect(), L = s.value.getBoundingClientRect();
      _.value = { it: D, w: te, h: ee, left: Math.max(0, Math.min(L.width - te, me.left - L.left + me.width / 2 - te / 2)) };
    }
    const k = I(() => Math.min(l.value.length, a.value)), P = I(() => {
      const D = _.value;
      return D && !o.value && !Yr.value && r.value.some((O) => O.id === D.it.id) ? D : null;
    });
    function A(D) {
      const O = D.target;
      s.value && !s.value.contains(O) && !O.closest(".lb-backdrop") && (o.value = !1);
    }
    function R(D) {
      D.key === "Escape" && (D.stopPropagation(), D.preventDefault(), o.value = !1);
    }
    return Ae(o, (D) => {
      D ? (window.addEventListener("pointerdown", A, !0), window.addEventListener("keydown", R, !0)) : (window.removeEventListener("pointerdown", A, !0), window.removeEventListener("keydown", R, !0));
    }), We(() => {
      window.removeEventListener("pointerdown", A, !0), window.removeEventListener("keydown", R, !0);
    }), (D, O) => (g(), b("div", {
      ref_key: "wrap",
      ref: s,
      class: G(["sv-queue ed-refs", { "is-empty": !r.value.length, "is-over": e.over, "is-air": f.value && !e.over && a.value > 0 }]),
      "data-testid": "studio-edit-refs"
    }, [
      O[3] || (O[3] = u("span", { class: "sv-queue-label" }, "References", -1)),
      u("div", ove, [
        C(Xp, { name: "ed-ref" }, {
          default: Xe(() => [
            (g(!0), b(j, null, be(r.value, (F) => (g(), b("div", {
              key: F.id,
              class: G(["sv-slot is-ref", { "is-unsent": !p(F), "is-stage": F.id === m(n).stageId }]),
              title: y(F),
              "data-testid": "studio-edit-ref",
              onMouseenter: (te) => T(F, te),
              onMouseleave: O[0] || (O[0] = (te) => _.value = null)
            }, [
              C(ao, { item: F }, null, 8, ["item"]),
              p(F) ? (g(), b("span", ave, E(v(F)), 1)) : z("", !0),
              u("button", {
                class: "x",
                title: "Remove",
                "aria-label": "Remove " + (F.label || "reference"),
                "data-testid": "studio-edit-ref-remove",
                onClick: Se((te) => w(F), ["stop"])
              }, [
                C($, {
                  name: "X",
                  size: 10
                })
              ], 8, lve),
              x(F.id) ? (g(), b("span", {
                key: "pulse" + x(F.id),
                class: "up-ref-pulse",
                "aria-hidden": "true"
              })) : z("", !0)
            ], 42, rve))), 128))
          ]),
          _: 1
        }),
        d.value ? (g(), b("div", dve, [
          u("button", {
            class: G(["sv-slot-add", { "is-target": e.over, "is-dropper": m(n).dropper }]),
            title: m(Bo).addTitle,
            "aria-label": "Add an image",
            "aria-expanded": o.value,
            "data-testid": "studio-edit-ref-add",
            onClick: O[1] || (O[1] = (F) => {
              o.value = !o.value, m(t).setDropper(!1);
            })
          }, [
            C($, {
              name: "ImagePlus",
              size: 16
            })
          ], 10, cve),
          o.value ? (g(), Ce(Zc, {
            key: 0,
            "session-id": m(t).sessionId,
            label: m(Bo).label,
            "dropper-label": m(Bo).dropper,
            tip: m(Bo).tip,
            onPick: S,
            onDropper: M,
            onClose: O[2] || (O[2] = (F) => o.value = !1)
          }, null, 8, ["session-id", "label", "dropper-label", "tip"])) : z("", !0)
        ])) : z("", !0),
        r.value.length ? z("", !0) : (g(), b("span", {
          key: 1,
          class: G(["sv-queue-empty ed-refs-hint", { "is-air": (f.value || e.over) && a.value > 0 }])
        }, E(a.value ? f.value || e.over ? "Drop it here to send it with the edit" : "Nothing yet: drag pictures here from history, or pick them with the eyedropper." : "No room for references while an area is selected: " + c.value + " takes two pictures"), 3))
      ]),
      P.value ? (g(), b("div", {
        key: 0,
        class: "sv-slot-peek",
        style: ce({ left: P.value.left + "px", width: P.value.w + "px", height: P.value.h + "px" }),
        "aria-hidden": "true",
        "data-testid": "studio-edit-ref-peek"
      }, [
        C(ao, {
          item: P.value.it,
          full: ""
        }, null, 8, ["item"]),
        u("span", uve, E(P.value.it.id === m(n).stageId ? "In the viewer" : p(P.value.it) ? "Image " + v(P.value.it) : "Waits"), 1)
      ], 4)) : z("", !0),
      a.value ? (g(), b("span", {
        key: 1,
        class: G(["sv-queue-count", { "is-over": l.value.length > a.value }])
      }, E(k.value) + " of " + E(a.value), 3)) : z("", !0)
    ], 2));
  }
}), pve = ["aria-expanded", "title"], fve = { class: "t" }, mve = {
  key: 0,
  class: "sv-pop ed-keep-pop",
  role: "radiogroup",
  "aria-label": "How the area is kept"
}, gve = { class: "sv-pop-rows" }, bve = ["aria-checked", "data-testid", "onClick"], vve = { class: "tx" }, yve = { class: "nm" }, xve = { class: "hint" }, wve = /* @__PURE__ */ Pe({
  __name: "AreaKeep",
  setup(i) {
    const t = yt().s, n = /* @__PURE__ */ K(!1), s = /* @__PURE__ */ K(null), o = [
      { precise: !0, label: "Precision", hint: "Only the area changes: every other pixel is kept", testid: "studio-precision" },
      { precise: !1, label: "Creative", hint: "The area changes most, and the rest may change a little to match", testid: "studio-creative" }
    ];
    function r(c) {
      t.precision = c, n.value = !1;
    }
    function a(c) {
      s.value && !s.value.contains(c.target) && (n.value = !1);
    }
    function l(c) {
      c.key === "Escape" && (c.stopPropagation(), c.preventDefault(), n.value = !1);
    }
    function d() {
      window.removeEventListener("pointerdown", a, !0), window.removeEventListener("keydown", l, !0);
    }
    return Ae(n, (c) => {
      if (!c) {
        d();
        return;
      }
      window.addEventListener("pointerdown", a, !0), window.addEventListener("keydown", l, !0);
    }), We(d), (c, h) => (g(), b("div", {
      ref_key: "wrap",
      ref: s,
      class: "sv-pop-wrap"
    }, [
      u("button", {
        class: G(["up-chip ed-keep", { on: n.value }]),
        "aria-expanded": n.value,
        title: "The area you selected: " + (m(t).precision ? o[0].hint : o[1].hint),
        "data-testid": "studio-area-keep",
        onClick: h[0] || (h[0] = (f) => n.value = !n.value)
      }, [
        C($, {
          name: "SquareDashed",
          size: 13
        }),
        u("span", fve, E(m(t).precision ? "Precision" : "Creative"), 1)
      ], 10, pve),
      n.value ? (g(), b("div", mve, [
        h[1] || (h[1] = u("div", { class: "sv-pop-title" }, "The area you selected", -1)),
        u("div", gve, [
          (g(), b(j, null, be(o, (f) => u("button", {
            key: f.label,
            class: G(["sv-pop-row ed-keep-row", { on: m(t).precision === f.precise }]),
            role: "radio",
            "aria-checked": m(t).precision === f.precise,
            "data-testid": f.testid,
            onClick: (p) => r(f.precise)
          }, [
            u("span", vve, [
              u("span", yve, E(f.label), 1),
              u("span", xve, E(f.hint), 1)
            ]),
            m(t).precision === f.precise ? (g(), Ce($, {
              key: 0,
              name: "Check",
              size: 12,
              class: "ck"
            })) : z("", !0)
          ], 10, bve)), 64))
        ])
      ])) : z("", !0)
    ], 512));
  }
}), kve = ["title", "aria-expanded"], _ve = { class: "t" }, Sve = { class: "sv-pop-rows" }, Mve = ["aria-selected", "data-testid", "onClick"], Tve = { class: "nm" }, Cve = {
  key: 0,
  class: "mt"
}, Ive = /* @__PURE__ */ Pe({
  __name: "EditSize",
  props: {
    kind: {}
  },
  setup(i) {
    const e = i, t = yt(), n = I(() => t.tiersOf(e.kind)), s = I(() => Math.min(t.tierOf(e.kind), Math.max(0, n.value.length - 1))), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(null);
    function a(d) {
      t.setTier(e.kind, d), o.value = !1;
    }
    function l(d) {
      r.value && !r.value.contains(d.target) && (o.value = !1);
    }
    return ot(() => window.addEventListener("pointerdown", l, !0)), We(() => window.removeEventListener("pointerdown", l, !0)), (d, c) => n.value.length > 1 ? (g(), b("div", {
      key: 0,
      ref_key: "wrap",
      ref: r,
      class: "sv-pop-wrap"
    }, [
      u("button", {
        class: G(["up-chip", { on: o.value }]),
        title: "Size: " + (n.value[s.value].meta || n.value[s.value].label) + ". The picture keeps its shape.",
        "aria-expanded": o.value,
        "data-testid": "studio-edit-size",
        onClick: c[0] || (c[0] = (h) => o.value = !o.value)
      }, [
        C($, {
          name: "Maximize2",
          size: 13
        }),
        u("span", _ve, E(n.value[s.value].label), 1)
      ], 10, kve),
      o.value ? (g(), b("div", {
        key: 0,
        class: "sv-pop is-narrow",
        role: "listbox",
        "aria-label": "Size",
        onKeydown: c[1] || (c[1] = tn(Se((h) => o.value = !1, ["stop"]), ["esc"]))
      }, [
        c[2] || (c[2] = u("div", { class: "sv-pop-title" }, "Size", -1)),
        u("div", Sve, [
          (g(!0), b(j, null, be(n.value, (h, f) => (g(), b("button", {
            key: h.label,
            class: G(["sv-pop-row", { on: f === s.value }]),
            role: "option",
            "aria-selected": f === s.value,
            "data-testid": "studio-edit-size-" + f,
            onClick: (p) => a(f)
          }, [
            u("span", Tve, E(h.label), 1),
            h.meta ? (g(), b("span", Cve, E(h.meta), 1)) : z("", !0)
          ], 10, Mve))), 128))
        ])
      ], 32)) : z("", !0)
    ], 512)) : z("", !0);
  }
}), Ave = {
  key: "tool",
  class: "ed-bar-tool",
  "data-testid": "studio-edit-bar-tool"
}, Pve = { class: "ed-bar-tool-head" }, Eve = { class: "ic" }, Rve = { class: "st" }, zve = ["disabled"], $ve = {
  key: "bar",
  class: "ed-bar-main ed-card"
}, Dve = { class: "up-side ed-side" }, Ove = ["disabled", "title", "aria-pressed"], Lve = { class: "ed-col" }, Bve = ["placeholder", "disabled", "readonly"], Fve = { class: "ed-bar-modes" }, Nve = {
  class: "ed-modes",
  role: "radiogroup",
  "aria-label": "Mode"
}, Uve = ["aria-checked", "title", "data-testid", "onClick"], Gve = ["aria-expanded"], jve = {
  key: 1,
  class: "up-note",
  title: "Your annotations and notes on the picture go with the edit (N to change them)",
  "data-testid": "studio-edit-sending"
}, Hve = 48, Vve = 160, Wve = /* @__PURE__ */ Pe({
  __name: "EditBar",
  setup(i) {
    const e = yt(), t = e.s, n = e.tools, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = [
      { id: "edit", label: "Edit", key: "M", tip: "Say what to change; select an area to keep the change inside it" },
      { id: "erase", label: "Erase", key: "X", tip: "Paint over what should go; no words needed" },
      { id: "annotate", label: "Annotate", key: "N", tip: "Draw, label and pin notes to show the model what to change" }
    ], a = I(() => ex(n.t.open)), l = I(() => e.stage.value), d = I(() => !!l.value && l.value.status === "done"), c = I(() => e.barKind()), h = I(() => t.bar === "erase"), f = I(() => c.value === "erase"), p = I(() => e.takesRefs()), y = I({
      get: () => e.askOf(t.stageId),
      set: (Y) => {
        t.stageId && e.setAsk(t.stageId, Y);
      }
    }), v = I(() => t.bar !== "annotate" && e.hasArea()), x = I(() => e.carried(l.value)), w = I(() => {
      const Y = x.value;
      return [Y.marks ? Y.marks + (Y.marks === 1 ? " annotation" : " annotations") : "", Y.comments ? Y.comments + (Y.comments === 1 ? " note" : " notes") : ""].filter(Boolean).join(", ");
    }), S = I(() => w.value && t.bar !== "annotate" && !f.value ? w.value + (x.value.marks + x.value.comments === 1 ? " goes with it" : " go with it") : ""), M = I(() => v.value && !h.value), _ = I(() => e.modelOf(c.value)), T = I(() => e.fullTakesOver(c.value)), k = I(() => d.value ? e.barProblem() : "Pick an image to edit first"), P = I(() => !!t.fullOpen[c.value] && e.fullShown(c.value)), A = /* @__PURE__ */ K(!1), R = I(() => !f.value && e.advancedOf(c.value).length > 0), D = Ze().board, O = Zy({
      board: D,
      field: "edit",
      sessionId: () => e.sessionId,
      value: () => y.value,
      write: (Y) => {
        y.value = Y;
      }
    }), F = I(() => O.ghost.value ? O.ghost.value : h.value ? f.value ? "Erase takes no words: paint over what should go" : "Paint over what should go, and say what belongs there instead (optional)" : t.bar === "annotate" ? w.value ? "Anything else to change? The annotations and notes go with it" : "Annotate the picture, or say what to change" : v.value ? "Say what to change in the area" : "Say what to change, or select an area on the picture to keep the change there"), te = I(() => {
      const Y = _.value, H = Y ? Hy(Y) : null;
      return H ? [H.key] : [];
    }), ee = I(() => p.value ? "Pick a reference from history (I)" : h.value ? "Erase takes no references" : "This model takes one picture: the one you're editing");
    function me() {
      const Y = s.value;
      Y && (Y.style.height = "0px", Y.style.height = Math.min(Vve, Math.max(Hve, Y.scrollHeight)) + "px");
    }
    Ae(y, () => nt(me)), Ae(a, (Y) => {
      Y || nt(me);
    }), ot(me);
    function L() {
      t.sending || e.generateEdit();
    }
    function N(Y) {
      t.sending || e.generateEdit(Y);
    }
    function X(Y) {
      Y.key === "Enter" && kn(Y) && (Y.preventDefault(), o.value && o.value.tryRun());
    }
    const B = /* @__PURE__ */ K(!1);
    function se(Y) {
      a.value || !qI(Y) || (Y.preventDefault(), Y.dataTransfer && (Y.dataTransfer.dropEffect = p.value ? "copy" : "none"), B.value = p.value);
    }
    function V(Y) {
      const H = Y.relatedTarget;
      (!H || !Y.currentTarget.contains(H)) && (B.value = !1);
    }
    function Z(Y) {
      const H = KI(Y);
      B.value = !1, Df(), !(!H || a.value) && (Y.preventDefault(), Y.stopPropagation(), e.addEditRef(H));
    }
    return (Y, H) => (g(), b("div", {
      class: G(["sv-dock ed-bar", { "is-tool": !!a.value, "is-over": B.value }]),
      "data-testid": "studio-edit-bar",
      onDragover: se,
      onDragleave: V,
      onDrop: Z
    }, [
      C(vt, { name: "sv-note" }, {
        default: Xe(() => [
          m(t).note ? (g(), b("div", {
            key: m(t).note.id,
            class: "sv-note",
            role: "status"
          }, E(m(t).note.text), 1)) : z("", !0)
        ]),
        _: 1
      }),
      C(Ebe, null, {
        default: Xe(() => [
          C(vt, { name: "ed-swap" }, {
            default: Xe(() => [
              a.value ? (g(), b("div", Ave, [
                u("div", Pve, [
                  u("span", Eve, [
                    C($, {
                      name: a.value.icon,
                      size: 15
                    }, null, 8, ["name"])
                  ]),
                  u("b", null, E(a.value.label), 1),
                  H[6] || (H[6] = u("span", { class: "dot" }, "·", -1)),
                  u("span", Rve, [
                    m(n).t.busy ? (g(), b(j, { key: 0 }, [
                      C($, {
                        name: "Loader2",
                        size: 12,
                        spin: ""
                      }),
                      J(" " + E(m(n).t.busy), 1)
                    ], 64)) : m(n).pending() ? (g(), b(j, { key: 1 }, [
                      J("Not applied yet")
                    ], 64)) : (g(), b(j, { key: 2 }, [
                      J(E(a.value.hint), 1)
                    ], 64))
                  ]),
                  H[7] || (H[7] = u("span", { class: "grow" }, null, -1)),
                  u("button", {
                    class: "ed-bar-close",
                    "data-testid": "studio-tool-close",
                    title: "Back to the bar (Esc)",
                    disabled: !!m(n).t.busy,
                    onClick: H[0] || (H[0] = (re) => m(n).close())
                  }, [
                    H[5] || (H[5] = J(" Close ", -1)),
                    C($, {
                      name: "X",
                      size: 13
                    })
                  ], 8, zve)
                ]),
                H[8] || (H[8] = u("div", {
                  id: "studio-bar-go",
                  class: "ed-bar-go",
                  "data-testid": "studio-bar-go"
                }, null, -1))
              ])) : (g(), b("div", $ve, [
                u("div", Dve, [
                  u("button", {
                    class: G(["up-side-btn", { on: m(t).dropper }]),
                    disabled: !p.value,
                    title: ee.value,
                    "aria-label": "Pick a reference from history",
                    "aria-pressed": m(t).dropper,
                    "data-testid": "studio-eyedropper",
                    onClick: H[1] || (H[1] = (re) => m(e).setDropper(!m(t).dropper))
                  }, [
                    C($, {
                      name: "Pipette",
                      size: 15
                    })
                  ], 10, Ove)
                ]),
                u("div", Lve, [
                  C(vt, { name: "ed-fold" }, {
                    default: Xe(() => [
                      p.value ? (g(), Ce(hve, {
                        key: 0,
                        over: B.value
                      }, null, 8, ["over"])) : z("", !0)
                    ]),
                    _: 1
                  }),
                  kt(u("textarea", {
                    ref_key: "text",
                    ref: s,
                    "onUpdate:modelValue": H[2] || (H[2] = (re) => y.value = re),
                    class: G(["up-text ed-words", { "is-tour-ghost": !!m(O).ghost.value, "is-typing": m(O).typing.value }]),
                    spellcheck: "false",
                    placeholder: F.value,
                    disabled: !d.value || f.value,
                    readonly: m(O).held.value || m(O).typing.value,
                    "data-testid": "studio-edit-prompt",
                    onInput: me,
                    onKeydown: X
                  }, null, 42, Bve), [
                    [Zt, y.value]
                  ]),
                  m(O).ghost.value ? (g(), b("button", {
                    key: 0,
                    type: "button",
                    tabindex: "-1",
                    class: "up-cue is-tour ed-tour-cue",
                    "data-testid": "studio-ghost-cue",
                    onClick: H[3] || (H[3] = (re) => m(D).tour && m(D).tour.press && m(D).tour.press("edit"))
                  }, [...H[9] || (H[9] = [
                    u("kbd", null, "Tab", -1),
                    J(" to write it in", -1)
                  ])])) : z("", !0),
                  u("div", Fve, [
                    u("div", Nve, [
                      (g(), b(j, null, be(r, (re) => u("button", {
                        key: re.id,
                        class: G(["ed-mode", { on: m(t).bar === re.id }]),
                        role: "radio",
                        "aria-checked": m(t).bar === re.id,
                        title: re.label + " (" + re.key + `)
` + re.tip,
                        "data-testid": "studio-mode-" + re.id,
                        onClick: (le) => m(e).setBar(re.id)
                      }, [
                        C(ym, {
                          on: m(t).bar === re.id
                        }, null, 8, ["on"]),
                        u("span", null, E(re.label), 1)
                      ], 10, Uve)), 64))
                    ]),
                    H[10] || (H[10] = u("span", { class: "sv-sep" }, null, -1)),
                    C(vt, {
                      name: "ed-fade",
                      mode: "out-in"
                    }, {
                      default: Xe(() => [
                        m(t).bar === "annotate" ? (g(), Ce(sve, { key: "marks" })) : (g(), Ce(Nbe, { key: "area" }))
                      ]),
                      _: 1
                    })
                  ]),
                  C(pa, { open: P.value }, {
                    default: Xe(() => [
                      C(ax, {
                        kind: c.value,
                        onRun: N
                      }, null, 8, ["kind"])
                    ]),
                    _: 1
                  }, 8, ["open"]),
                  C(pa, {
                    open: A.value && R.value
                  }, {
                    default: Xe(() => [
                      C(dx, {
                        kind: c.value,
                        part: "more"
                      }, null, 8, ["kind"])
                    ]),
                    _: 1
                  }, 8, ["open"]),
                  C(ZI, {
                    ref_key: "foot",
                    ref: o,
                    kind: c.value,
                    own: k.value,
                    resting: T.value,
                    fixed: f.value,
                    "fixed-title": _.value ? _.value.name + " removes what you paint and fills in behind it" : "",
                    most: h.value ? 1 : null,
                    hide: te.value,
                    "run-testid": "studio-edit-generate",
                    "count-testid": "studio-edit-count",
                    onRun: L
                  }, {
                    chips: Xe(() => [
                      f.value ? z("", !0) : (g(), Ce(Ive, {
                        key: 0,
                        kind: c.value
                      }, null, 8, ["kind"])),
                      R.value ? (g(), b("button", {
                        key: 1,
                        class: G(["up-chip", { on: A.value }]),
                        "aria-expanded": A.value,
                        title: "More settings",
                        "data-testid": "studio-edit-more-toggle",
                        onClick: H[4] || (H[4] = (re) => A.value = !A.value)
                      }, [
                        C($, {
                          name: "Settings2",
                          size: 13
                        }),
                        H[11] || (H[11] = u("span", { class: "t" }, "More", -1))
                      ], 10, Gve)) : z("", !0),
                      M.value || S.value ? (g(), b(j, { key: 2 }, [
                        H[12] || (H[12] = u("span", { class: "up-foot-sep" }, null, -1)),
                        M.value ? (g(), Ce(wve, { key: 0 })) : z("", !0),
                        S.value ? (g(), b("span", jve, [
                          C($, {
                            name: "Pencil",
                            size: 12
                          }),
                          J(E(S.value), 1)
                        ])) : z("", !0)
                      ], 64)) : z("", !0)
                    ]),
                    aside: Xe(() => [
                      C(lx, { kind: c.value }, null, 8, ["kind"])
                    ]),
                    _: 1
                  }, 8, ["kind", "own", "resting", "fixed", "fixed-title", "most", "hide"])
                ])
              ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 34));
  }
}), qve = { class: "ed-panel" }, Kve = {
  class: "ed-modes-x",
  role: "radiogroup",
  "aria-label": "What the bar does"
}, Yve = ["aria-checked", "data-testid", "onClick"], Xve = { class: "hd" }, Jve = { class: "ln" }, Zve = /* @__PURE__ */ Pe({
  __name: "PromptPanel",
  setup(i) {
    const e = yt(), t = e.s, n = [
      { id: "edit", label: "Edit", key: "M", line: "Say what to change. Paint an area to keep the change inside it: Precision keeps every pixel outside it." },
      { id: "erase", label: "Erase", key: "X", line: "Paint over what should go and press Run: no words. In a busy scene, use Edit with an area and say what belongs there." },
      { id: "annotate", label: "Annotate", key: "N", line: "Draw, label and pin numbered notes to show what to change. No area: the model may change the whole picture." }
    ];
    return (s, o) => (g(), b("div", qve, [
      u("div", Kve, [
        (g(), b(j, null, be(n, (r) => u("button", {
          key: r.id,
          type: "button",
          role: "radio",
          class: G(["ed-mode-x", { on: m(t).bar === r.id }]),
          "aria-checked": m(t).bar === r.id,
          "data-testid": "mode-explain-" + r.id,
          onClick: (a) => m(e).setBar(r.id)
        }, [
          u("span", Xve, [
            u("b", null, E(r.label), 1),
            u("kbd", null, E(r.key), 1)
          ]),
          u("span", Jve, E(r.line), 1)
        ], 10, Yve)), 64))
      ])
    ]));
  }
}), Qve = { class: "ed-bar-go-in" }, ou = /* @__PURE__ */ Pe({
  __name: "BarGo",
  setup(i) {
    return (e, t) => (g(), Ce(m1, {
      defer: "",
      to: "#studio-bar-go"
    }, [
      u("div", Qve, [
        Ss(e.$slots, "default")
      ])
    ]));
  }
}), e0e = { class: "ed-go is-bar" }, t0e = { class: "ed-go-line" }, n0e = ["title"], i0e = { class: "nm" }, s0e = {
  key: 3,
  class: "ed-model-none"
}, o0e = ["title"], r0e = {
  key: 5,
  class: "ed-go-full"
}, a0e = ["title"], l0e = ["disabled", "title", "data-testid"], d0e = { class: "lb" }, Yo = /* @__PURE__ */ Pe({
  __name: "ToolGo",
  props: {
    kind: {},
    label: {},
    icon: { default: "Sparkles" },
    picker: { type: Boolean, default: !1 },
    why: { default: "" },
    many: { type: Boolean, default: !0 },
    showModel: { type: Boolean, default: !0 },
    testid: { default: void 0 }
  },
  setup(i) {
    const e = i, t = yt(), n = t.s, s = t.tools, o = I(() => t.modelsFor(e.kind)), r = I(() => t.modelOf(e.kind)), a = I(() => t.countOf(e.kind)), l = I(() => e.many ? t.maxCount(e.kind) : 1), d = I(() => r.value ? t.priceOf(e.kind) : ""), c = I(() => t.fullTakesOver(e.kind)), h = I(() => c.value ? HI : s.problem(e.kind)), f = I(() => h.value || (r.value ? t.problemOf(e.kind) : null)), p = I(() => !!n.fullOpen[e.kind] && t.fullShown(e.kind));
    function y() {
      n.sending || c.value || s.runTool(e.kind);
    }
    function v(x) {
      n.sending || s.runTool(e.kind, x);
    }
    return (x, w) => (g(), Ce(ou, null, {
      default: Xe(() => [
        u("div", e0e, [
          C(pa, { open: p.value }, {
            default: Xe(() => [
              C(ax, {
                kind: i.kind,
                class: "is-tool",
                onRun: v
              }, null, 8, ["kind"])
            ]),
            _: 1
          }, 8, ["open"]),
          u("div", t0e, [
            i.showModel ? i.picker && o.value.length > 1 ? (g(), Ce(JI, {
              key: 1,
              mode: i.kind,
              variant: "flat"
            }, null, 8, ["mode"])) : r.value ? (g(), b("span", {
              key: 2,
              class: "ed-model-fixed is-inline",
              title: i.why ? r.value.name + ": " + i.why : r.value.name
            }, [
              C($, {
                name: "Cpu",
                size: 13
              }),
              u("span", i0e, E(r.value.name), 1)
            ], 8, n0e)) : (g(), b("span", s0e, [
              C($, {
                name: "CloudOff",
                size: 13
              }),
              w[1] || (w[1] = J(" Not available on this board yet", -1))
            ])) : (g(), b(j, { key: 0 }, [], 64)),
            r.value && d.value ? (g(), b("span", {
              key: 4,
              class: "ed-go-cost",
              title: "Token cost for this run" + (r.value.time ? ", about " + r.value.time : "")
            }, [
              C($, {
                name: "Tokens",
                size: 11
              }),
              J(" " + E(d.value), 1)
            ], 8, o0e)) : z("", !0),
            r.value ? (g(), b("span", r0e, [
              C(lx, { kind: i.kind }, null, 8, ["kind"])
            ])) : z("", !0),
            w[2] || (w[2] = u("span", { class: "grow" }, null, -1)),
            f.value && !c.value ? (g(), b("span", {
              key: 6,
              class: "sv-problem is-inline",
              title: f.value
            }, [
              C($, {
                name: "AlertCircle",
                size: 12
              }),
              J(" " + E(f.value.replace(/\.$/, "")), 1)
            ], 8, a0e)) : z("", !0),
            l.value > 1 ? (g(), Ce(Jy, {
              key: 7,
              value: a.value,
              min: m(t).minCount(i.kind),
              max: l.value,
              onUpdate: w[0] || (w[0] = (S) => m(t).setCount(i.kind, S))
            }, null, 8, ["value", "min", "max"])) : z("", !0),
            u("button", {
              class: G(["sv-go ed-go-btn", { "is-busy": m(n).sending > 0, "is-blocked": !!f.value }]),
              disabled: !r.value || c.value,
              title: f.value || "",
              "data-testid": i.testid || "studio-tool-run-" + i.kind,
              onClick: y
            }, [
              C($, {
                name: m(n).sending ? "Loader2" : i.icon,
                size: 14,
                spin: m(n).sending > 0
              }, null, 8, ["name", "spin"]),
              u("span", d0e, E(m(n).sending ? "Sending" : i.label), 1)
            ], 10, l0e)
          ])
        ])
      ]),
      _: 1
    }));
  }
}), c0e = { class: "ed-panel" }, u0e = {
  key: 0,
  class: "ed-info",
  "data-testid": "studio-upscale-size"
}, h0e = /* @__PURE__ */ Pe({
  __name: "UpscalePanel",
  setup(i) {
    const e = yt(), t = I(() => e.stage.value), n = I(() => {
      var o;
      const r = (o = e.valueOfKey("upscale", "scale")) != null ? o : e.valueOfKey("upscale", "factor"), a = typeof r == "number" ? r : typeof r == "string" ? parseFloat(r) : NaN;
      return Number.isFinite(a) && a > 0 ? a : null;
    }), s = I(() => {
      const o = t.value;
      if (!o || !n.value) return "";
      const r = ga(o.asset), a = r ? r.width : o.w, l = r ? r.height : o.h;
      return Math.round(a * n.value).toLocaleString() + " × " + Math.round(l * n.value).toLocaleString();
    });
    return (o, r) => (g(), b("div", c0e, [
      r[1] || (r[1] = u("p", { class: "ed-hint" }, "More pixels and finer detail. Each upscaler has its own look; its settings follow.", -1)),
      C(dx, { kind: "upscale" }),
      s.value ? (g(), b("div", u0e, [
        r[0] || (r[0] = u("span", null, "Final size", -1)),
        u("b", null, E(s.value), 1)
      ])) : z("", !0),
      C(Yo, {
        kind: "upscale",
        label: "Upscale",
        icon: "Maximize2",
        many: !1,
        picker: ""
      })
    ]));
  }
}), p0e = { class: "ed-panel" }, f0e = ["aria-selected"], m0e = ["aria-selected"], g0e = {
  class: "ed-ratios",
  role: "radiogroup",
  "aria-label": "Shape"
}, b0e = ["aria-checked", "data-testid", "onClick"], v0e = ["aria-expanded"], y0e = { class: "ed-wh" }, x0e = ["value"], w0e = ["aria-pressed", "title"], k0e = ["value"], _0e = { class: "ed-acts is-bar" }, S0e = ["disabled"], M0e = ["disabled"], T0e = {
  class: "ed-ratios",
  role: "radiogroup",
  "aria-label": "Frame shape"
}, C0e = ["aria-checked", "data-testid", "onClick"], I0e = ["aria-expanded"], A0e = {
  key: 0,
  class: "ed-info"
}, P0e = {
  key: 1,
  class: "sv-warn"
}, E0e = { class: "ed-field" }, R0e = { class: "ed-acts is-tight" }, z0e = ["disabled"], $0e = ["disabled"], D0e = /* @__PURE__ */ Pe({
  __name: "ResizePanel",
  setup(i) {
    const e = yt(), t = e.tools, n = I(() => t.t.resize), s = I(() => e.stage.value), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(!0), a = I(() => C0.filter((M) => !M.more || o.value || M.id === n.value.ratio)), l = I(() => C0.filter((M) => M.id !== "original" && (!M.more || o.value || M.id === n.value.frameRatio))), d = I(() => t.cropPixels()), c = I(() => t.frame()), h = I(() => {
      const M = s.value, _ = c.value;
      return M && _ ? Math.round(_.iw / M.w * 100) : 100;
    }), f = I(() => !!c.value && whe(c.value) < xhe);
    function p(M) {
      const _ = s.value, T = Mc(M, _ ? _.w : 4, _ ? _.h : 3), k = T == null ? 1.25 : T;
      return k >= 1 ? { w: 22, h: Math.max(6, Math.round(22 / k)) } : { w: Math.max(6, Math.round(22 * k)), h: 22 };
    }
    function y(M) {
      n.value.mode !== M && t.leave(() => {
        t.t.resize.mode = M, t.t.open = "resize", t.readyExpand();
      });
    }
    function v(M) {
      const _ = s.value;
      if (!_ || !Number.isFinite(M) || M < 8) return;
      const T = r.value ? M / Math.max(1, d.value.w) : 1;
      t.setCrop(G_(n.value.crop, M, r.value ? d.value.h * T : d.value.h, _.w, _.h)), r.value || (t.t.resize.ratio = "free");
    }
    function x(M) {
      const _ = s.value;
      if (!_ || !Number.isFinite(M) || M < 8) return;
      const T = r.value ? M / Math.max(1, d.value.h) : 1;
      t.setCrop(G_(n.value.crop, r.value ? d.value.w * T : d.value.w, M, _.w, _.h)), r.value || (t.t.resize.ratio = "free");
    }
    function w(M) {
      const _ = s.value, T = c.value;
      !_ || !T || t.setFrame(Mhe(T, _.w, _.h, M / 100));
    }
    function S() {
      const M = s.value;
      M && (t.t.resize.frame = null, t.t.resize.frameRatio = "free", t.setFrame(zI(M.w, M.h)));
    }
    return (M, _) => (g(), b("div", p0e, [
      u("div", {
        class: "sv-seg is-text ed-tabs ed-slide",
        role: "tablist",
        "aria-label": "Crop or expand",
        style: ce({ "--i": n.value.mode === "expand" ? 1 : 0, "--n": 2 })
      }, [
        u("button", {
          role: "tab",
          "aria-selected": n.value.mode === "crop",
          class: G({ on: n.value.mode === "crop" }),
          "data-testid": "studio-resize-crop",
          onClick: _[0] || (_[0] = (T) => y("crop"))
        }, [
          C($, {
            name: "Crop",
            size: 13
          }),
          _[11] || (_[11] = J(" Crop", -1))
        ], 10, f0e),
        u("button", {
          role: "tab",
          "aria-selected": n.value.mode === "expand",
          class: G({ on: n.value.mode === "expand" }),
          "data-testid": "studio-resize-expand",
          onClick: _[1] || (_[1] = (T) => y("expand"))
        }, [
          C($, {
            name: "Expand",
            size: 13
          }),
          _[12] || (_[12] = J(" Expand", -1))
        ], 10, m0e)
      ], 4),
      n.value.mode === "crop" ? (g(), b(j, { key: 0 }, [
        _[17] || (_[17] = u("p", { class: "ed-hint" }, "Drag the frame's edges and corners on the picture, or pick a shape. The crop is made at full size.", -1)),
        u("div", g0e, [
          (g(!0), b(j, null, be(a.value, (T) => (g(), b("button", {
            key: T.id,
            role: "radio",
            "aria-checked": n.value.ratio === T.id,
            class: G(["ed-ratio", { on: n.value.ratio === T.id }]),
            "data-testid": "studio-crop-ratio-" + T.id,
            onClick: (k) => m(t).setRatio(T.id)
          }, [
            u("i", {
              class: G({ free: T.id === "free" }),
              style: ce({ width: p(T.id).w + "px", height: p(T.id).h + "px" })
            }, null, 6),
            u("span", null, E(T.label), 1)
          ], 10, b0e))), 128)),
          u("button", {
            class: "ed-ratio is-more",
            "aria-expanded": o.value,
            onClick: _[2] || (_[2] = (T) => o.value = !o.value)
          }, [
            C($, {
              name: o.value ? "ChevronUp" : "Ellipsis",
              size: 14
            }, null, 8, ["name"]),
            u("span", null, E(o.value ? "Fewer" : "More"), 1)
          ], 8, v0e)
        ]),
        u("div", y0e, [
          u("label", null, [
            _[13] || (_[13] = u("span", null, "W", -1)),
            u("input", {
              type: "number",
              min: "8",
              value: d.value.w,
              "data-testid": "studio-crop-w",
              onChange: _[3] || (_[3] = (T) => v(+T.target.value))
            }, null, 40, x0e)
          ]),
          u("button", {
            class: G(["ed-lock", { on: r.value }]),
            "aria-pressed": r.value,
            title: r.value ? "Keep the shape" : "Width and height apart",
            onClick: _[4] || (_[4] = (T) => r.value = !r.value)
          }, [
            C($, {
              name: r.value ? "Lock" : "LockOpen",
              size: 12
            }, null, 8, ["name"])
          ], 10, w0e),
          u("label", null, [
            _[14] || (_[14] = u("span", null, "H", -1)),
            u("input", {
              type: "number",
              min: "8",
              value: d.value.h,
              "data-testid": "studio-crop-h",
              onChange: _[5] || (_[5] = (T) => x(+T.target.value))
            }, null, 40, k0e)
          ]),
          _[15] || (_[15] = u("span", { class: "u" }, "px", -1))
        ]),
        C(ou, null, {
          default: Xe(() => [
            u("div", _0e, [
              _[16] || (_[16] = u("span", { class: "grow" }, null, -1)),
              u("button", {
                class: "sv-btn",
                disabled: !m(t).pending("resize"),
                onClick: _[6] || (_[6] = (T) => m(t).reset("resize"))
              }, "Reset", 8, S0e),
              u("button", {
                class: "sv-btn is-primary ed-apply",
                disabled: !m(t).pending("resize") || !!m(t).t.busy,
                "data-testid": "studio-crop-apply",
                onClick: _[7] || (_[7] = (T) => m(t).apply("resize"))
              }, [
                C($, {
                  name: m(t).t.busy ? "Loader2" : "Crop",
                  size: 14,
                  spin: !!m(t).t.busy
                }, null, 8, ["name", "spin"]),
                J(" " + E(m(t).t.busy ? "Cropping" : "Crop"), 1)
              ], 8, M0e)
            ])
          ]),
          _: 1
        })
      ], 64)) : (g(), b(j, { key: 1 }, [
        _[22] || (_[22] = u("p", { class: "ed-hint" }, "Pull the frame past the picture's edges in the viewer, or pick a shape; drag the picture to place it. The new area is painted to match.", -1)),
        u("div", T0e, [
          (g(!0), b(j, null, be(l.value, (T) => (g(), b("button", {
            key: T.id,
            role: "radio",
            "aria-checked": n.value.frameRatio === T.id,
            class: G(["ed-ratio", { on: n.value.frameRatio === T.id }]),
            "data-testid": "studio-expand-ratio-" + T.id,
            onClick: (k) => m(t).setFrameRatio(T.id)
          }, [
            u("i", {
              class: G({ free: T.id === "free" }),
              style: ce({ width: p(T.id).w + "px", height: p(T.id).h + "px" })
            }, null, 6),
            u("span", null, E(T.label), 1)
          ], 10, C0e))), 128)),
          u("button", {
            class: "ed-ratio is-more",
            "aria-expanded": o.value,
            onClick: _[8] || (_[8] = (T) => o.value = !o.value)
          }, [
            C($, {
              name: o.value ? "ChevronUp" : "Ellipsis",
              size: 14
            }, null, 8, ["name"]),
            u("span", null, E(o.value ? "Fewer" : "More"), 1)
          ], 8, I0e)
        ]),
        C(Ct, {
          label: "Picture size",
          "model-value": h.value,
          min: 30,
          max: 100,
          start: 100,
          format: (T) => T + "%",
          "onUpdate:modelValue": w
        }, null, 8, ["model-value", "format"]),
        c.value ? (g(), b("div", A0e, [
          _[18] || (_[18] = u("span", null, "New size", -1)),
          u("b", null, E(Math.round(c.value.cw)) + " × " + E(Math.round(c.value.ch)), 1)
        ])) : z("", !0),
        f.value ? (g(), b("div", P0e, [
          C($, {
            name: "AlertCircle",
            size: 12
          }),
          _[19] || (_[19] = u("span", null, "The picture is small in this frame; the expand is best when it covers at least a sixth.", -1))
        ])) : z("", !0),
        u("label", E0e, [
          _[20] || (_[20] = u("span", { class: "ed-field-lb" }, "What to add (optional)", -1)),
          kt(u("textarea", {
            "onUpdate:modelValue": _[9] || (_[9] = (T) => m(t).t.resize.words = T),
            class: "ed-text",
            rows: "2",
            placeholder: "More sky, the street continuing, the lawn and planting",
            spellcheck: "false",
            "data-testid": "studio-expand-words"
          }, null, 512), [
            [Zt, m(t).t.resize.words]
          ])
        ]),
        u("div", R0e, [
          u("button", {
            class: "sv-btn",
            disabled: !c.value || !m(A0)(c.value),
            onClick: S
          }, "Reset", 8, z0e),
          u("button", {
            class: "sv-btn",
            disabled: !c.value,
            title: "Centre the picture in the frame",
            onClick: _[10] || (_[10] = (T) => c.value && m(t).setFrame(m(The)(c.value)))
          }, [
            C($, {
              name: "LocateFixed",
              size: 13
            }),
            _[21] || (_[21] = J(" Centre", -1))
          ], 8, $0e)
        ]),
        C(Yo, {
          kind: "expand",
          label: "Expand",
          icon: "Expand",
          many: !1,
          why: "Bria Expand paints the new area to match",
          picker: ""
        })
      ], 64))
    ]));
  }
}), O0e = { class: "ed-refpick" }, L0e = { class: "ed-field-lb" }, B0e = ["aria-label"], F0e = ["aria-checked", "title", "onClick"], N0e = {
  key: 1,
  class: "ed-hint is-quiet"
}, QI = /* @__PURE__ */ Pe({
  __name: "RefPick",
  props: {
    modelValue: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = yt(), o = I(() => s.items.value.filter((a) => a.status === "done" && a.id !== s.s.stageId).slice(0, 12));
    function r(a) {
      n("update:modelValue", t.modelValue === a ? null : a);
    }
    return (a, l) => (g(), b("div", O0e, [
      u("span", L0e, E(i.label), 1),
      o.value.length ? (g(), b("div", {
        key: 0,
        class: "ed-refpick-row",
        role: "radiogroup",
        "aria-label": i.label
      }, [
        (g(!0), b(j, null, be(o.value, (d) => (g(), b("button", {
          key: d.id,
          class: G(["ed-refpick-cell", { on: i.modelValue === d.id }]),
          role: "radio",
          "aria-checked": i.modelValue === d.id,
          title: d.label,
          "data-testid": "studio-refpick",
          onClick: (c) => r(d.id)
        }, [
          C(ao, { item: d }, null, 8, ["item"])
        ], 10, F0e))), 128))
      ], 8, B0e)) : (g(), b("span", N0e, "Bring a picture into history first (drop one on the view)."))
    ]));
  }
}), U0e = { class: "ed-panel" }, G0e = ["aria-selected"], j0e = ["aria-selected"], H0e = ["aria-selected"], V0e = {
  class: "ed-fills",
  role: "radiogroup",
  "aria-label": "Fill"
}, W0e = ["aria-checked"], q0e = ["aria-checked", "title", "data-testid", "onClick"], K0e = ["value"], Y0e = { class: "ed-acts is-bar" }, X0e = ["disabled"], J0e = ["disabled"], Z0e = { class: "ed-field" }, Q0e = ["aria-checked"], e1e = ["aria-checked"], t1e = { class: "ed-acts is-bar" }, n1e = ["disabled"], i1e = ["disabled"], s1e = /* @__PURE__ */ Pe({
  __name: "BackgroundPanel",
  setup(i) {
    const e = yt(), t = e.tools, n = I(() => t.t.background), s = I(() => e.stage.value), o = I(() => t.isCutout(s.value)), r = I(() => t.cutoutFor(s.value)), a = I(() => typeof n.value.fill == "string" && !Z_.includes(n.value.fill));
    function l(d) {
      n.value.mode !== d && t.leave(() => {
        t.t.background.mode = d, t.t.open = "background";
      });
    }
    return (d, c) => (g(), b("div", U0e, [
      u("div", {
        class: "sv-seg is-text ed-tabs is-three ed-slide",
        role: "tablist",
        "aria-label": "Background",
        style: ce({ "--i": ["remove", "replace", "adjust"].indexOf(n.value.mode), "--n": 3 })
      }, [
        u("button", {
          role: "tab",
          "aria-selected": n.value.mode === "remove",
          class: G({ on: n.value.mode === "remove" }),
          "data-testid": "studio-bg-remove",
          onClick: c[0] || (c[0] = (h) => l("remove"))
        }, "Remove", 10, G0e),
        u("button", {
          role: "tab",
          "aria-selected": n.value.mode === "replace",
          class: G({ on: n.value.mode === "replace" }),
          "data-testid": "studio-bg-replace",
          onClick: c[1] || (c[1] = (h) => l("replace"))
        }, "Replace", 10, j0e),
        u("button", {
          role: "tab",
          "aria-selected": n.value.mode === "adjust",
          class: G({ on: n.value.mode === "adjust" }),
          "data-testid": "studio-bg-adjust",
          onClick: c[2] || (c[2] = (h) => l("adjust"))
        }, "Adjust", 10, H0e)
      ], 4),
      n.value.mode === "remove" ? (g(), b(j, { key: 0 }, [
        o.value ? (g(), b(j, { key: 1 }, [
          c[21] || (c[21] = u("p", { class: "ed-hint" }, "The background is clear. Fill it, or keep it see-through.", -1)),
          u("div", V0e, [
            u("button", {
              class: G(["ed-fill is-clear", { on: n.value.fill === null }]),
              role: "radio",
              "aria-checked": n.value.fill === null,
              title: "See-through",
              "data-testid": "studio-fill-clear",
              onClick: c[3] || (c[3] = (h) => m(t).setFill(null))
            }, null, 10, W0e),
            (g(!0), b(j, null, be(m(Z_), (h) => (g(), b("button", {
              key: h,
              class: G(["ed-fill", { on: n.value.fill === h }]),
              role: "radio",
              "aria-checked": n.value.fill === h,
              style: ce({ "--c": h }),
              title: h,
              "data-testid": "studio-fill-" + h.slice(1),
              onClick: (f) => m(t).setFill(h)
            }, null, 14, q0e))), 128)),
            u("label", {
              class: G(["ed-fill is-any", { on: a.value }]),
              style: ce(a.value ? { "--c": n.value.fill } : void 0),
              title: "Any colour"
            }, [
              u("input", {
                type: "color",
                value: typeof n.value.fill == "string" ? n.value.fill : "#ffffff",
                onInput: c[4] || (c[4] = (h) => m(t).setFill(h.target.value))
              }, null, 40, K0e)
            ], 6)
          ]),
          C(ou, null, {
            default: Xe(() => [
              u("div", Y0e, [
                c[20] || (c[20] = u("span", { class: "grow" }, null, -1)),
                u("button", {
                  class: "sv-btn",
                  disabled: n.value.fill === void 0,
                  onClick: c[5] || (c[5] = (h) => m(t).setFill(void 0))
                }, "Reset", 8, X0e),
                u("button", {
                  class: "sv-btn is-primary ed-apply",
                  disabled: n.value.fill === void 0 || !!m(t).t.busy,
                  "data-testid": "studio-fill-apply",
                  onClick: c[6] || (c[6] = (h) => m(t).apply("background"))
                }, [
                  C($, {
                    name: m(t).t.busy ? "Loader2" : "PaintBucket",
                    size: 14,
                    spin: !!m(t).t.busy
                  }, null, 8, ["name", "spin"]),
                  J(" " + E(m(t).t.busy ? "Filling" : "Fill"), 1)
                ], 8, J0e)
              ])
            ]),
            _: 1
          })
        ], 64)) : (g(), b(j, { key: 0 }, [
          c[19] || (c[19] = u("p", { class: "ed-hint" }, "Cuts the subject out, leaving the background see-through. Then fill it with a colour, or keep it clear.", -1)),
          C(Yo, {
            kind: "removebg",
            label: "Remove background",
            icon: "Scan",
            many: !1,
            why: "Clean edges, hair and fine detail included"
          })
        ], 64))
      ], 64)) : n.value.mode === "replace" ? (g(), b(j, { key: 1 }, [
        c[23] || (c[23] = u("p", { class: "ed-hint" }, "Describe what should be behind the subject, or pick a picture of it. The model keeps the subject as close to the original as it can.", -1)),
        u("label", Z0e, [
          c[22] || (c[22] = u("span", { class: "ed-field-lb" }, "The new background", -1)),
          kt(u("textarea", {
            "onUpdate:modelValue": c[7] || (c[7] = (h) => m(t).t.background.words = h),
            class: "ed-text",
            rows: "3",
            placeholder: "A clear sky with soft clouds over a quiet street",
            spellcheck: "false",
            "data-testid": "studio-replace-words"
          }, null, 512), [
            [Zt, m(t).t.background.words]
          ])
        ]),
        C(QI, {
          modelValue: m(t).t.background.refId,
          "onUpdate:modelValue": c[8] || (c[8] = (h) => m(t).t.background.refId = h),
          label: "A picture of it (optional)"
        }, null, 8, ["modelValue"]),
        C(Yo, {
          kind: "replacebg",
          label: "Replace",
          icon: "Replace",
          picker: ""
        })
      ], 64)) : (g(), b(j, { key: 2 }, [
        r.value ? (g(), b(j, { key: 1 }, [
          u("div", {
            class: "sv-seg is-small ed-pills ed-slide",
            role: "radiogroup",
            "aria-label": "Adjust",
            style: ce({ "--i": n.value.layer.target === "subject" ? 1 : 0, "--n": 2 })
          }, [
            u("button", {
              role: "radio",
              "aria-checked": n.value.layer.target === "background",
              class: G({ on: n.value.layer.target === "background" }),
              onClick: c[9] || (c[9] = (h) => m(t).setLayer({ target: "background" }))
            }, "Background", 10, Q0e),
            u("button", {
              role: "radio",
              "aria-checked": n.value.layer.target === "subject",
              class: G({ on: n.value.layer.target === "subject" }),
              onClick: c[10] || (c[10] = (h) => m(t).setLayer({ target: "subject" }))
            }, "Subject", 10, e1e)
          ], 4),
          C(Ct, {
            label: "Blur",
            "model-value": n.value.layer.blur,
            min: 0,
            max: 40,
            start: 0,
            format: (h) => h + " px",
            testid: "studio-layer-blur",
            "onUpdate:modelValue": c[11] || (c[11] = (h) => m(t).setLayer({ blur: h }))
          }, null, 8, ["model-value", "format"]),
          C(Ct, {
            label: "Grayscale",
            "model-value": n.value.layer.grayscale,
            min: 0,
            max: 100,
            start: 0,
            "onUpdate:modelValue": c[12] || (c[12] = (h) => m(t).setLayer({ grayscale: h }))
          }, null, 8, ["model-value"]),
          C(Ct, {
            label: "Sepia",
            "model-value": n.value.layer.sepia,
            min: 0,
            max: 100,
            start: 0,
            "onUpdate:modelValue": c[13] || (c[13] = (h) => m(t).setLayer({ sepia: h }))
          }, null, 8, ["model-value"]),
          C(Ct, {
            label: "Brightness",
            "model-value": n.value.layer.brightness,
            min: 0,
            max: 200,
            start: 100,
            format: (h) => (h - 100 > 0 ? "+" : "") + (h - 100),
            "onUpdate:modelValue": c[14] || (c[14] = (h) => m(t).setLayer({ brightness: h }))
          }, null, 8, ["model-value", "format"]),
          C(Ct, {
            label: "Contrast",
            "model-value": n.value.layer.contrast,
            min: 0,
            max: 200,
            start: 100,
            format: (h) => (h - 100 > 0 ? "+" : "") + (h - 100),
            "onUpdate:modelValue": c[15] || (c[15] = (h) => m(t).setLayer({ contrast: h }))
          }, null, 8, ["model-value", "format"]),
          C(Ct, {
            label: "Saturation",
            "model-value": n.value.layer.saturation,
            min: 0,
            max: 200,
            start: 100,
            format: (h) => (h - 100 > 0 ? "+" : "") + (h - 100),
            "onUpdate:modelValue": c[16] || (c[16] = (h) => m(t).setLayer({ saturation: h }))
          }, null, 8, ["model-value", "format"]),
          C(ou, null, {
            default: Xe(() => [
              u("div", t1e, [
                c[25] || (c[25] = u("span", { class: "grow" }, null, -1)),
                u("button", {
                  class: "sv-btn",
                  disabled: !m(nu)(n.value.layer),
                  onClick: c[17] || (c[17] = (h) => m(t).reset("background"))
                }, "Reset", 8, n1e),
                u("button", {
                  class: "sv-btn is-primary ed-apply",
                  disabled: !m(nu)(n.value.layer) || !!m(t).t.busy,
                  "data-testid": "studio-layer-apply",
                  onClick: c[18] || (c[18] = (h) => m(t).apply("background"))
                }, [
                  C($, {
                    name: m(t).t.busy ? "Loader2" : "Check",
                    size: 14,
                    spin: !!m(t).t.busy
                  }, null, 8, ["name", "spin"]),
                  J(" " + E(m(t).t.busy ? "Applying" : "Apply"), 1)
                ], 8, i1e)
              ])
            ]),
            _: 1
          })
        ], 64)) : (g(), b(j, { key: 0 }, [
          c[24] || (c[24] = u("p", { class: "ed-hint" }, "Adjusting the background apart from the subject needs a cut-out first: Remove background makes one.", -1)),
          C(Yo, {
            kind: "removebg",
            label: "Remove background",
            icon: "Scan",
            many: !1,
            why: "Its cut-out tells the subject from the background"
          })
        ], 64))
      ], 64))
    ]));
  }
}), o1e = { class: "ed-wheel" }, r1e = ["aria-label", "aria-valuenow", "aria-valuetext"], a1e = { class: "ed-wheel-lb" }, l1e = ["value", "aria-label"], Pb = 30, Eb = /* @__PURE__ */ Pe({
  __name: "ColorWheel",
  props: {
    label: {},
    wheel: {}
  },
  emits: ["change"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = /* @__PURE__ */ K(null), o = I(() => {
      const d = (t.wheel.hue - 90) * Math.PI / 180, c = t.wheel.amount / 100 * Pb;
      return { left: Pb + Math.cos(d) * c + "px", top: Pb + Math.sin(d) * c + "px" };
    });
    function r(d) {
      if (!s.value) return;
      const c = s.value.getBoundingClientRect(), h = d.clientX - c.left - c.width / 2, f = d.clientY - c.top - c.height / 2, p = Math.round(Math.min(1, Math.hypot(h, f) / (c.width / 2)) * 100), y = Math.round((Math.atan2(f, h) * 180 / Math.PI + 90 + 360) % 360);
      n("change", { ...t.wheel, hue: y, amount: p });
    }
    function a(d) {
      d.button === 0 && (d.currentTarget.setPointerCapture(d.pointerId), r(d));
    }
    function l(d) {
      d.currentTarget.hasPointerCapture(d.pointerId) && r(d);
    }
    return (d, c) => (g(), b("div", o1e, [
      u("div", {
        ref_key: "el",
        ref: s,
        class: "ed-wheel-disc",
        role: "slider",
        "aria-label": i.label + " tint",
        "aria-valuenow": i.wheel.amount,
        "aria-valuetext": i.wheel.amount ? i.wheel.hue + "°, " + i.wheel.amount + "%" : "none",
        tabindex: "0",
        onPointerdown: a,
        onPointermove: l,
        onDblclick: c[0] || (c[0] = (h) => n("change", { ...i.wheel, amount: 0 }))
      }, [
        u("i", {
          class: G(["ed-wheel-dot", { on: i.wheel.amount > 0 }]),
          style: ce(o.value)
        }, null, 6)
      ], 40, r1e),
      u("span", a1e, E(i.label), 1),
      u("input", {
        class: "ed-wheel-lum",
        type: "range",
        min: "-100",
        max: "100",
        value: i.wheel.lum,
        "aria-label": i.label + " brightness",
        onInput: c[1] || (c[1] = (h) => n("change", { ...i.wheel, lum: Number(h.target.value) })),
        onDblclick: c[2] || (c[2] = (h) => n("change", { ...i.wheel, lum: 0 }))
      }, null, 40, l1e)
    ]));
  }
}), d1e = { class: "ed-panel ed-adjust" }, c1e = { class: "ed-groups" }, u1e = { class: "ed-group-head" }, h1e = ["aria-expanded", "data-testid", "onClick"], p1e = { class: "t" }, f1e = {
  key: 0,
  class: "ed-changed"
}, m1e = ["title", "onClick"], g1e = { class: "ed-group-body" }, b1e = {
  key: 2,
  class: "ed-looks",
  role: "radiogroup",
  "aria-label": "Looks"
}, v1e = ["aria-checked", "data-testid", "onClick"], y1e = { class: "sw" }, x1e = { class: "nm" }, w1e = {
  key: 3,
  class: "ed-wheels"
}, k1e = { class: "ed-mix-pick" }, _1e = ["aria-pressed"], S1e = ["title"], M1e = {
  class: "ed-hint is-quiet",
  "data-testid": "studio-mixer-hint"
}, T1e = {
  class: "ed-bands",
  role: "radiogroup",
  "aria-label": "Colour"
}, C1e = ["aria-checked", "title", "aria-label", "onClick"], I1e = {
  class: "ed-refpick-row",
  role: "radiogroup",
  "aria-label": "Match to"
}, A1e = ["aria-checked", "title", "onClick"], P1e = { class: "tag" }, E1e = { class: "ed-overlay-row" }, R1e = ["value"], z1e = { class: "ed-select" }, $1e = ["value"], D1e = ["value"], O1e = { class: "ed-turns" }, L1e = { class: "ed-acts is-bar" }, B1e = ["disabled"], F1e = ["disabled"], N1e = ["disabled"], U1e = /* @__PURE__ */ Pe({
  __name: "AdjustPanel",
  setup(i) {
    const e = yt(), t = e.tools, n = I(() => t.t.adjust), s = I(() => n.value.a), o = I({
      get: () => n.value.band || "red",
      set: (T) => {
        t.t.adjust.band = T, t.t.adjust.picked = null;
      }
    }), r = I(() => n.value.picked || Nhe((Yi.find((T) => T.id === o.value) || Yi[0]).color)), a = I(() => Lhe(r.value, s.value.mixer)), l = I(() => (Yi.find((T) => T.id === o.value) || Yi[0]).label), d = I(() => !!n.value.picked && Fhe(n.value.picked) < 0.35), c = [
      { id: "light", label: "Light", icon: "Sun" },
      { id: "colour", label: "Colour", icon: "Palette" },
      { id: "looks", label: "Looks", icon: "Sparkle" },
      { id: "grading", label: "Colour grading", icon: "Contrast" },
      { id: "mixer", label: "Colour mixer", icon: "Rainbow" },
      { id: "match", label: "Match colours", icon: "Droplet" },
      { id: "overlay", label: "Overlay", icon: "Blend" },
      { id: "grain", label: "Grain", icon: "Film" },
      { id: "rotate", label: "Rotate", icon: "RotateCw" }
    ], h = I(() => n.value.group);
    function f(T) {
      t.t.adjust.group = n.value.group === T ? null : T;
    }
    function p(T) {
      const k = iu(s.value);
      T(k), k.look = null, t.setAdjust(k);
    }
    function y(T) {
      return T === "looks" ? !!s.value.look : kl(s.value, T);
    }
    function v(T) {
      if (T === "looks") {
        t.setAdjust(H_(s.value, ""));
        return;
      }
      t.setAdjust(Ahe(s.value, T));
    }
    const x = (T) => T > 0 ? "+" + T : String(T), w = (T) => (T > 0 ? "+" : "") + T + "°", S = I(() => {
      const T = e.family.value.filter((P) => P.status === "done" && P.id !== e.s.stageId), k = e.items.value.filter((P) => P.status === "done" && P.id !== e.s.stageId && !T.some((A) => A.id === P.id));
      return [...T, ...k].slice(0, 12);
    });
    function M(T) {
      return e.names.value.get(T) || "Picture";
    }
    const _ = I(() => E0(s.value));
    return (T, k) => (g(), b("div", d1e, [
      u("div", c1e, [
        (g(), b(j, null, be(c, (P) => u("section", {
          key: P.id,
          class: G(["ed-group", { on: h.value === P.id, "is-changed": y(P.id) }])
        }, [
          u("div", u1e, [
            u("button", {
              class: "ed-group-btn",
              "aria-expanded": h.value === P.id,
              "data-testid": "studio-adjust-group-" + P.id,
              onClick: (A) => f(P.id)
            }, [
              C($, {
                name: P.icon,
                size: 13,
                class: "ic"
              }, null, 8, ["name"]),
              u("span", p1e, E(P.label), 1),
              y(P.id) ? (g(), b("i", f1e)) : z("", !0),
              C($, {
                name: h.value === P.id ? "ChevronUp" : "ChevronDown",
                size: 12,
                class: "chev"
              }, null, 8, ["name"])
            ], 8, h1e),
            y(P.id) ? (g(), b("button", {
              key: 0,
              class: "ed-group-reset",
              title: "Reset " + P.label.toLowerCase(),
              onClick: (A) => v(P.id)
            }, [
              C($, {
                name: "RotateCcw",
                size: 11
              })
            ], 8, m1e)) : z("", !0)
          ]),
          C(pa, {
            open: h.value === P.id
          }, {
            default: Xe(() => [
              u("div", g1e, [
                P.id === "light" ? (g(), b(j, { key: 0 }, [
                  C(Ct, {
                    label: "Exposure",
                    "model-value": s.value.exposure,
                    min: -100,
                    max: 100,
                    format: x,
                    testid: "studio-adjust-exposure",
                    "onUpdate:modelValue": k[0] || (k[0] = (A) => p((R) => R.exposure = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Contrast",
                    "model-value": s.value.contrast,
                    min: -100,
                    max: 100,
                    format: x,
                    testid: "studio-adjust-contrast",
                    "onUpdate:modelValue": k[1] || (k[1] = (A) => p((R) => R.contrast = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Brightness",
                    "model-value": s.value.brightness,
                    min: -100,
                    max: 100,
                    format: x,
                    "onUpdate:modelValue": k[2] || (k[2] = (A) => p((R) => R.brightness = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Highlights",
                    "model-value": s.value.highlights,
                    min: -100,
                    max: 100,
                    format: x,
                    "onUpdate:modelValue": k[3] || (k[3] = (A) => p((R) => R.highlights = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Shadows",
                    "model-value": s.value.shadows,
                    min: -100,
                    max: 100,
                    format: x,
                    "onUpdate:modelValue": k[4] || (k[4] = (A) => p((R) => R.shadows = A))
                  }, null, 8, ["model-value"])
                ], 64)) : P.id === "colour" ? (g(), b(j, { key: 1 }, [
                  C(Ct, {
                    label: "Saturation",
                    "model-value": s.value.saturation,
                    min: -100,
                    max: 100,
                    format: x,
                    testid: "studio-adjust-saturation",
                    "onUpdate:modelValue": k[5] || (k[5] = (A) => p((R) => R.saturation = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Hue",
                    "model-value": s.value.hue,
                    min: -180,
                    max: 180,
                    format: w,
                    "onUpdate:modelValue": k[6] || (k[6] = (A) => p((R) => R.hue = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Temperature",
                    "model-value": s.value.temperature,
                    min: -100,
                    max: 100,
                    format: x,
                    testid: "studio-adjust-temperature",
                    "onUpdate:modelValue": k[7] || (k[7] = (A) => p((R) => R.temperature = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Tint",
                    "model-value": s.value.tint,
                    min: -100,
                    max: 100,
                    format: x,
                    "onUpdate:modelValue": k[8] || (k[8] = (A) => p((R) => R.tint = A))
                  }, null, 8, ["model-value"])
                ], 64)) : P.id === "looks" ? (g(), b("div", b1e, [
                  (g(!0), b(j, null, be(m(tx), (A) => (g(), b("button", {
                    key: A.id,
                    class: G(["ed-look", ["look-" + A.id, { on: s.value.look === A.id }]]),
                    role: "radio",
                    "aria-checked": s.value.look === A.id,
                    "data-testid": "studio-look-" + A.id,
                    onClick: (R) => m(t).setAdjust(m(H_)(s.value, s.value.look === A.id ? "" : A.id))
                  }, [
                    u("span", y1e, [
                      m(e).stage.value ? (g(), Ce(ao, {
                        key: 0,
                        item: m(e).stage.value
                      }, null, 8, ["item"])) : z("", !0)
                    ]),
                    u("span", x1e, E(A.label), 1)
                  ], 10, v1e))), 128))
                ])) : P.id === "grading" ? (g(), b("div", w1e, [
                  C(Eb, {
                    label: "Shadows",
                    wheel: s.value.grade.shadows,
                    onChange: k[9] || (k[9] = (A) => p((R) => R.grade.shadows = A))
                  }, null, 8, ["wheel"]),
                  C(Eb, {
                    label: "Midtones",
                    wheel: s.value.grade.midtones,
                    onChange: k[10] || (k[10] = (A) => p((R) => R.grade.midtones = A))
                  }, null, 8, ["wheel"]),
                  C(Eb, {
                    label: "Highlights",
                    wheel: s.value.grade.highlights,
                    onChange: k[11] || (k[11] = (A) => p((R) => R.grade.highlights = A))
                  }, null, 8, ["wheel"])
                ])) : P.id === "mixer" ? (g(), b(j, { key: 4 }, [
                  u("div", k1e, [
                    u("button", {
                      class: G(["sv-btn ed-mix-dropper", { on: n.value.picking }]),
                      "aria-pressed": !!n.value.picking,
                      title: "Click a colour in the picture to work on it",
                      "data-testid": "studio-mixer-pick",
                      onClick: k[12] || (k[12] = (A) => m(t).t.adjust.picking = !n.value.picking)
                    }, [
                      C($, {
                        name: "Pipette",
                        size: 13
                      }),
                      J(" " + E(n.value.picking ? "Click the picture" : "Pick a colour"), 1)
                    ], 10, _1e),
                    u("span", {
                      class: "ed-mix-swatch",
                      title: (n.value.picked ? "The colour you picked" : l.value + " in the picture") + ", before and after the mixer",
                      "data-testid": "studio-mixer-swatch"
                    }, [
                      u("i", {
                        style: ce({ background: m(V_)(r.value) })
                      }, null, 4),
                      C($, {
                        name: "ArrowRight",
                        size: 11
                      }),
                      u("i", {
                        style: ce({ background: m(V_)(a.value) })
                      }, null, 4)
                    ], 8, S1e)
                  ]),
                  u("p", M1e, [
                    d.value ? (g(), b(j, { key: 0 }, [
                      J("That colour is close to grey: the mixer barely moves it. Pick a richer one.")
                    ], 64)) : n.value.picked ? (g(), b(j, { key: 1 }, [
                      J("You picked a " + E(l.value.toLowerCase()) + ": these move the ", 1),
                      u("b", null, E(l.value.toLowerCase()) + "s", 1),
                      k[34] || (k[34] = J(" in the picture, its hue, richness and lightness.", -1))
                    ], 64)) : (g(), b(j, { key: 2 }, [
                      k[35] || (k[35] = J("Moves only the ", -1)),
                      u("b", null, E(l.value.toLowerCase()) + "s", 1),
                      k[36] || (k[36] = J(" in the picture: shift their hue, make them richer or duller, lighter or darker.", -1))
                    ], 64))
                  ]),
                  u("div", T1e, [
                    (g(!0), b(j, null, be(m(Yi), (A) => (g(), b("button", {
                      key: A.id,
                      class: G(["ed-band", { on: o.value === A.id, "is-changed": s.value.mixer[A.id].hue || s.value.mixer[A.id].sat || s.value.mixer[A.id].lum }]),
                      style: ce({ "--c": A.color }),
                      role: "radio",
                      "aria-checked": o.value === A.id,
                      title: A.label,
                      "aria-label": A.label,
                      onClick: (R) => o.value = A.id
                    }, null, 14, C1e))), 128))
                  ]),
                  C(Ct, {
                    label: "Hue",
                    "model-value": s.value.mixer[o.value].hue,
                    min: -100,
                    max: 100,
                    format: x,
                    "onUpdate:modelValue": k[13] || (k[13] = (A) => p((R) => R.mixer[o.value].hue = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Saturation",
                    "model-value": s.value.mixer[o.value].sat,
                    min: -100,
                    max: 100,
                    format: x,
                    "onUpdate:modelValue": k[14] || (k[14] = (A) => p((R) => R.mixer[o.value].sat = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Luminance",
                    "model-value": s.value.mixer[o.value].lum,
                    min: -100,
                    max: 100,
                    format: x,
                    "onUpdate:modelValue": k[15] || (k[15] = (A) => p((R) => R.mixer[o.value].lum = A))
                  }, null, 8, ["model-value"])
                ], 64)) : P.id === "match" ? (g(), b(j, { key: 5 }, [
                  k[37] || (k[37] = u("p", { class: "ed-hint" }, "Carry another version's colour onto this one: for a cast that crept in over repeated edits, match it to the original.", -1)),
                  u("div", I1e, [
                    (g(!0), b(j, null, be(S.value, (A) => (g(), b("button", {
                      key: A.id,
                      class: G(["ed-refpick-cell", { on: s.value.match.to === A.id }]),
                      role: "radio",
                      "aria-checked": s.value.match.to === A.id,
                      title: "Match to " + M(A.id),
                      "data-testid": "studio-match-to",
                      onClick: (R) => m(t).matchTo(s.value.match.to === A.id ? null : A.id)
                    }, [
                      C(ao, { item: A }, null, 8, ["item"]),
                      u("span", P1e, E(M(A.id)), 1)
                    ], 10, A1e))), 128))
                  ]),
                  C(Ct, {
                    label: "Amount",
                    "model-value": s.value.match.amount,
                    min: 0,
                    max: 100,
                    start: 0,
                    disabled: !s.value.match.to,
                    format: (A) => A + "%",
                    "onUpdate:modelValue": k[16] || (k[16] = (A) => p((R) => R.match.amount = A))
                  }, null, 8, ["model-value", "disabled", "format"])
                ], 64)) : P.id === "overlay" ? (g(), b(j, { key: 6 }, [
                  u("div", E1e, [
                    u("label", {
                      class: "sv-color ed-color",
                      style: ce({ "--c": s.value.overlay.color }),
                      title: "Overlay colour"
                    }, [
                      k[38] || (k[38] = u("i", null, null, -1)),
                      u("input", {
                        type: "color",
                        value: s.value.overlay.color,
                        onInput: k[17] || (k[17] = (A) => p((R) => R.overlay.color = A.target.value))
                      }, null, 40, R1e)
                    ], 4),
                    u("span", z1e, [
                      u("select", {
                        value: s.value.overlay.blend,
                        "aria-label": "Blend",
                        onChange: k[18] || (k[18] = (A) => p((R) => R.overlay.blend = A.target.value))
                      }, [
                        (g(!0), b(j, null, be(m(Ihe), (A) => (g(), b("option", {
                          key: A.id,
                          value: A.id
                        }, E(A.label), 9, D1e))), 128))
                      ], 40, $1e),
                      C($, {
                        name: "ChevronDown",
                        size: 12
                      })
                    ])
                  ]),
                  C(Ct, {
                    label: "Opacity",
                    "model-value": s.value.overlay.opacity,
                    min: 0,
                    max: 100,
                    start: 0,
                    format: (A) => A + "%",
                    "onUpdate:modelValue": k[19] || (k[19] = (A) => p((R) => R.overlay.opacity = A))
                  }, null, 8, ["model-value", "format"])
                ], 64)) : P.id === "grain" ? (g(), b(j, { key: 7 }, [
                  C(Ct, {
                    label: "Amount",
                    "model-value": s.value.grain.amount,
                    min: 0,
                    max: 100,
                    start: 0,
                    "onUpdate:modelValue": k[20] || (k[20] = (A) => p((R) => R.grain.amount = A))
                  }, null, 8, ["model-value"]),
                  C(Ct, {
                    label: "Size",
                    "model-value": s.value.grain.size,
                    min: 0,
                    max: 100,
                    start: 35,
                    "onUpdate:modelValue": k[21] || (k[21] = (A) => p((R) => R.grain.size = A))
                  }, null, 8, ["model-value"])
                ], 64)) : P.id === "rotate" ? (g(), b(j, { key: 8 }, [
                  C(Ct, {
                    label: "Straighten",
                    "model-value": s.value.straighten,
                    min: -45,
                    max: 45,
                    step: 0.5,
                    format: w,
                    testid: "studio-adjust-straighten",
                    "onUpdate:modelValue": k[22] || (k[22] = (A) => p((R) => R.straighten = A))
                  }, null, 8, ["model-value"]),
                  u("div", O1e, [
                    u("button", {
                      class: "sv-btn",
                      title: "Turn left",
                      "data-testid": "studio-adjust-turn-left",
                      onClick: k[23] || (k[23] = (A) => p((R) => R.quarter = (R.quarter + 3) % 4))
                    }, [
                      C($, {
                        name: "RotateCcw",
                        size: 14
                      })
                    ]),
                    u("button", {
                      class: "sv-btn",
                      title: "Turn right",
                      "data-testid": "studio-adjust-turn-right",
                      onClick: k[24] || (k[24] = (A) => p((R) => R.quarter = (R.quarter + 1) % 4))
                    }, [
                      C($, {
                        name: "RotateCw",
                        size: 14
                      })
                    ]),
                    u("button", {
                      class: G(["sv-btn", { "is-on": s.value.flipH }]),
                      title: "Flip left to right",
                      onClick: k[25] || (k[25] = (A) => p((R) => R.flipH = !R.flipH))
                    }, [
                      C($, {
                        name: "FlipHorizontal2",
                        size: 14
                      })
                    ], 2),
                    u("button", {
                      class: G(["sv-btn", { "is-on": s.value.flipV }]),
                      title: "Flip top to bottom",
                      onClick: k[26] || (k[26] = (A) => p((R) => R.flipV = !R.flipV))
                    }, [
                      C($, {
                        name: "FlipVertical2",
                        size: 14
                      })
                    ], 2)
                  ])
                ], 64)) : z("", !0)
              ])
            ]),
            _: 2
          }, 1032, ["open"])
        ], 2)), 64))
      ]),
      C(ou, null, {
        default: Xe(() => [
          u("div", L1e, [
            k[39] || (k[39] = u("span", { class: "grow" }, null, -1)),
            u("button", {
              class: "sv-btn ed-square ed-hold",
              disabled: !_.value,
              title: "Hold to see the picture as it was",
              "aria-label": "Hold to see the original",
              "data-testid": "studio-adjust-original",
              onPointerdown: k[27] || (k[27] = (P) => m(t).t.adjust.original = !0),
              onPointerup: k[28] || (k[28] = (P) => m(t).t.adjust.original = !1),
              onPointerleave: k[29] || (k[29] = (P) => m(t).t.adjust.original = !1),
              onKeydown: k[30] || (k[30] = tn(Se((P) => m(t).t.adjust.original = !0, ["prevent"]), ["space"])),
              onKeyup: k[31] || (k[31] = tn(Se((P) => m(t).t.adjust.original = !1, ["prevent"]), ["space"]))
            }, [
              C($, {
                name: "Eye",
                size: 14
              })
            ], 40, B1e),
            u("button", {
              class: "sv-btn ed-square",
              disabled: !_.value,
              title: "Reset all",
              "aria-label": "Reset all",
              "data-testid": "studio-adjust-reset",
              onClick: k[32] || (k[32] = (P) => m(t).reset("adjust"))
            }, [
              C($, {
                name: "RotateCcw",
                size: 14
              })
            ], 8, F1e),
            u("button", {
              class: "sv-btn is-primary ed-apply",
              disabled: !m(t).pending("adjust") || !!m(t).t.busy,
              "data-testid": "studio-adjust-apply",
              onClick: k[33] || (k[33] = (P) => m(t).apply("adjust"))
            }, [
              C($, {
                name: m(t).t.busy ? "Loader2" : "Check",
                size: 14,
                spin: !!m(t).t.busy
              }, null, 8, ["name", "spin"]),
              J(" " + E(m(t).t.busy ? "Applying" : "Apply"), 1)
            ], 8, N1e)
          ])
        ]),
        _: 1
      })
    ]));
  }
}), G1e = { class: "ed-panel" }, j1e = ["aria-checked", "title", "onClick"], H1e = {
  class: "ed-radios",
  role: "radiogroup",
  "aria-label": "Improve"
}, V1e = ["aria-checked", "onClick"], W1e = /* @__PURE__ */ Pe({
  __name: "SkinPanel",
  setup(i) {
    const e = yt(), t = I(() => e.tools.t.skin);
    return (n, s) => (g(), b("div", G1e, [
      u("div", {
        class: "sv-seg is-small ed-pills ed-slide",
        role: "radiogroup",
        "aria-label": "How faithful",
        style: ce({ "--i": Math.max(0, m(pb).findIndex((o) => o.id === t.value.version)), "--n": m(pb).length })
      }, [
        (g(!0), b(j, null, be(m(pb), (o) => (g(), b("button", {
          key: o.id,
          role: "radio",
          "aria-checked": t.value.version === o.id,
          class: G({ on: t.value.version === o.id }),
          title: o.hint,
          onClick: (r) => m(e).tools.t.skin.version = o.id
        }, E(o.label), 11, j1e))), 128))
      ], 4),
      u("div", H1e, [
        (g(!0), b(j, null, be(m(nhe), (o) => (g(), b("button", {
          key: o.id,
          class: G(["ed-radio-row", { on: t.value.focus === o.id }]),
          role: "radio",
          "aria-checked": t.value.focus === o.id,
          onClick: (r) => m(e).tools.t.skin.focus = o.id
        }, [
          C(ym, {
            on: t.value.focus === o.id
          }, null, 8, ["on"]),
          s[2] || (s[2] = J()),
          u("span", null, E(o.label), 1)
        ], 10, V1e))), 128))
      ]),
      C(Ct, {
        label: "Sharpen",
        "model-value": t.value.sharpen,
        min: 0,
        max: 100,
        start: 30,
        "onUpdate:modelValue": s[0] || (s[0] = (o) => m(e).tools.t.skin.sharpen = o)
      }, null, 8, ["model-value"]),
      C(Ct, {
        label: "Grain",
        "model-value": t.value.grain,
        min: 0,
        max: 100,
        start: 0,
        "onUpdate:modelValue": s[1] || (s[1] = (o) => m(e).tools.t.skin.grain = o)
      }, null, 8, ["model-value"]),
      C(Yo, {
        kind: "skin",
        label: "Improve",
        icon: "Smile",
        picker: ""
      })
    ]));
  }
}), q1e = { class: "ed-panel ed-camera" }, K1e = ["aria-valuenow", "aria-valuetext"], Y1e = ["rx", "ry"], X1e = ["cx", "cy"], J1e = ["d"], Z1e = ["x", "y"], Q1e = ["x2", "y2"], eye = ["transform"], tye = ["aria-valuenow", "aria-valuetext"], nye = ["d"], iye = ["x2"], sye = ["cx", "cy"], oye = ["x", "y"], rye = ["y1", "x2", "y2"], aye = ["transform"], lye = {
  class: "ed-camera-name",
  "data-testid": "studio-camera-name"
}, dye = {
  class: "ed-views",
  "data-testid": "studio-camera-views"
}, cye = { class: "ed-views-head" }, uye = {
  class: "ed-views-only",
  title: "Your saved views are yours alone, on every board and picture"
}, hye = ["maxlength", "onKeydown"], pye = ["title", "aria-pressed", "onClick", "onDblclick"], fye = { class: "nm" }, mye = ["title", "aria-label", "onClick"], gye = ["disabled", "title"], bye = {
  key: 0,
  class: "ed-views-empty"
}, vye = {
  key: 0,
  class: "sv-warn ed-camera-warn"
}, yye = { class: "ed-seed" }, xye = { class: "ed-switch" }, wye = ["disabled"], Fh = 78, Pd = 30, Sr = 92, Mr = 52, Ed = 46, Ba = 22, Fa = 60, kye = /* @__PURE__ */ Pe({
  __name: "CameraPanel",
  setup(i) {
    const e = yt(), { board: t } = Ze(), n = e.tools, s = I(() => n.t.camera), o = I(() => s.value.set), r = I(() => t.ui.cameraViews), a = I(() => r.value.find((V) => Rne(V, o.value)) || null), l = I(() => r.value.length >= Tf), d = I(() => a.value ? "This view is saved as " + a.value.name : l.value ? "You keep the most views there can be: remove one first" : "Save this view, to come back to it on any board"), c = /* @__PURE__ */ K(null), h = /* @__PURE__ */ K(""), f = /* @__PURE__ */ K(null);
    function p(V) {
      c.value || n.setCamera({ rotate: V.rotate, vertical: V.vertical, zoom: V.zoom });
    }
    function y() {
      const V = t.saveCameraView(o.value, kc(o.value));
      V && v(V);
    }
    function v(V) {
      c.value = V.id, h.value = V.name, nt(() => {
        const Z = f.value && f.value[0];
        Z && (Z.focus(), Z.select());
      });
    }
    function x() {
      c.value && (t.renameCameraView(c.value, h.value), c.value = null);
    }
    function w() {
      c.value = null;
    }
    function S(V, Z = 1) {
      const Y = V * Math.PI / 180;
      return { x: Sr + Math.sin(Y) * Fh * Z, y: Mr + Math.cos(Y) * Pd * Z };
    }
    const M = I(() => 1.12 - o.value.zoom / 10 * 0.42), _ = I(() => S(o.value.rotate, M.value)), T = I(() => Math.cos(o.value.rotate * Math.PI / 180) < 0);
    function k(V) {
      const Z = V * Math.PI / 180;
      return { x: Ba + Math.cos(Z) * Ed, y: Fa - Math.sin(Z) * Ed };
    }
    const P = I(() => {
      const V = k(-30), Z = k(90);
      return "M " + V.x + " " + V.y + " A " + Ed + " " + Ed + " 0 0 0 " + Z.x + " " + Z.y;
    }), A = I(() => k(o.value.vertical)), R = /* @__PURE__ */ K(null), D = /* @__PURE__ */ K(null);
    let O = null;
    function F(V, Z) {
      const Y = V.getBoundingClientRect(), H = V.viewBox.baseVal;
      return { x: (Z.clientX - Y.left) / Y.width * H.width, y: (Z.clientY - Y.top) / Y.height * H.height };
    }
    function te(V) {
      if (!R.value) return;
      const Z = F(R.value, V), Y = Math.atan2((Z.x - Sr) / Fh, (Z.y - Mr) / Pd) * 180 / Math.PI;
      n.setCamera({ rotate: V.shiftKey ? Math.round(_u(Y)) : h_(Y) });
    }
    function ee(V) {
      if (!D.value) return;
      const Z = F(D.value, V), Y = Math.atan2(Fa - Z.y, Z.x - Ba) * 180 / Math.PI, H = Math.max(-30, Math.min(90, Y));
      n.setCamera({ vertical: V.shiftKey ? Math.round(H) : p_(H) });
    }
    function me(V, Z) {
      Z.button === 0 && (O = V, Z.currentTarget.setPointerCapture(Z.pointerId), V === "ring" ? te(Z) : ee(Z));
    }
    function L(V) {
      O === "ring" ? te(V) : O === "arc" && ee(V);
    }
    function N() {
      O = null;
    }
    const X = (V) => {
      const Z = Wy(V);
      return (Z === 0 ? "0°" : Z > 0 ? Z + "° right" : -Z + "° left") + " · " + v0(V);
    }, B = (V) => (V > 0 ? "+" : "") + V + "° · " + y0(V), se = (V) => XC(V);
    return (V, Z) => (g(), b("div", q1e, [
      u("div", {
        class: "ed-orbit",
        onPointermove: L,
        onPointerup: N,
        onPointercancel: N
      }, [
        (g(), b("svg", {
          ref_key: "ring",
          ref: R,
          class: "ed-orbit-ring",
          viewBox: "0 0 184 104",
          role: "slider",
          "aria-label": "Rotate around the scene",
          "aria-valuenow": o.value.rotate,
          "aria-valuetext": m(v0)(o.value.rotate),
          tabindex: "0",
          "data-testid": "studio-camera-ring",
          onPointerdown: Z[0] || (Z[0] = (Y) => me("ring", Y))
        }, [
          u("ellipse", {
            cx: Sr,
            cy: Mr,
            rx: Fh,
            ry: Pd,
            class: "track"
          }),
          u("ellipse", {
            cx: Sr,
            cy: Mr,
            rx: Fh * 0.7,
            ry: Pd * 0.7,
            class: "track is-inner"
          }, null, 8, Y1e),
          (g(!0), b(j, null, be(m(b0), (Y) => (g(), b("g", { key: Y }, [
            u("circle", {
              cx: S(Y).x,
              cy: S(Y).y,
              r: "2.2",
              class: G(["stop", { on: Y === o.value.rotate }])
            }, null, 10, X1e)
          ]))), 128)),
          u("path", {
            d: "M " + (Sr - 5) + " " + (Mr + Pd + 9) + " l 5 -6 l 5 6 z",
            class: "origin"
          }, null, 8, J1e),
          u("rect", {
            x: Sr - 16,
            y: Mr - 3,
            width: "32",
            height: "6",
            rx: "1.5",
            class: "card"
          }, null, 8, Z1e),
          u("line", {
            x1: Sr,
            y1: Mr,
            x2: _.value.x,
            y2: _.value.y,
            class: G(["ray", { "is-behind": T.value }])
          }, null, 10, Q1e),
          u("g", {
            class: "cam",
            transform: "translate(" + _.value.x + " " + _.value.y + ")"
          }, [...Z[8] || (Z[8] = [
            u("circle", {
              r: "9",
              class: "halo"
            }, null, -1),
            u("circle", {
              r: "5.5",
              class: "dot"
            }, null, -1)
          ])], 8, eye)
        ], 40, K1e)),
        (g(), b("svg", {
          ref_key: "arc",
          ref: D,
          class: "ed-orbit-arc",
          viewBox: "0 0 84 96",
          role: "slider",
          "aria-label": "Camera height",
          "aria-valuenow": o.value.vertical,
          "aria-valuetext": m(y0)(o.value.vertical),
          tabindex: "0",
          "data-testid": "studio-camera-arc",
          onPointerdown: Z[1] || (Z[1] = (Y) => me("arc", Y))
        }, [
          u("path", {
            d: P.value,
            class: "track"
          }, null, 8, nye),
          u("line", {
            x1: Ba,
            y1: Fa,
            x2: Ba + Ed + 6,
            y2: Fa,
            class: "ground"
          }, null, 8, iye),
          (g(!0), b(j, null, be(m(Cf), (Y) => (g(), b("circle", {
            key: Y.at,
            cx: k(Y.at).x,
            cy: k(Y.at).y,
            r: "2",
            class: G(["stop", { on: Y.at === o.value.vertical }])
          }, null, 10, sye))), 128)),
          u("rect", {
            x: Ba - 3,
            y: Fa - 16,
            width: "6",
            height: "16",
            rx: "1.5",
            class: "card"
          }, null, 8, oye),
          u("line", {
            x1: Ba,
            y1: Fa - 8,
            x2: A.value.x,
            y2: A.value.y,
            class: "ray"
          }, null, 8, rye),
          u("g", {
            class: "cam",
            transform: "translate(" + A.value.x + " " + A.value.y + ")"
          }, [...Z[9] || (Z[9] = [
            u("circle", {
              r: "8",
              class: "halo"
            }, null, -1),
            u("circle", {
              r: "5",
              class: "dot"
            }, null, -1)
          ])], 8, aye)
        ], 40, tye))
      ], 32),
      u("div", lye, E(a.value ? a.value.name : m(kc)(o.value)), 1),
      u("section", dye, [
        u("div", cye, [
          Z[11] || (Z[11] = u("span", { class: "t" }, "Your cameras", -1)),
          u("span", uye, [
            C($, {
              name: "Lock",
              size: 9
            }),
            Z[10] || (Z[10] = J(" Only you", -1))
          ])
        ]),
        C(Xp, {
          name: "ed-view",
          tag: "div",
          class: "ed-views-list"
        }, {
          default: Xe(() => [
            (g(!0), b(j, null, be(r.value, (Y) => (g(), b("div", {
              key: Y.id,
              class: G(["ed-view", { on: !!a.value && a.value.id === Y.id, "is-naming": c.value === Y.id }])
            }, [
              c.value === Y.id ? kt((g(), b("input", {
                key: 0,
                ref_for: !0,
                ref_key: "nameEl",
                ref: f,
                "onUpdate:modelValue": Z[2] || (Z[2] = (H) => h.value = H),
                class: "ed-view-input",
                maxlength: m(Vy),
                spellcheck: "false",
                "aria-label": "The view's name",
                "data-testid": "studio-camera-view-name",
                onKeydown: [
                  tn(Se(x, ["prevent"]), ["enter"]),
                  tn(Se(w, ["stop", "prevent"]), ["esc"])
                ],
                onBlur: x
              }, null, 40, hye)), [
                [Zt, h.value]
              ]) : (g(), b("button", {
                key: 1,
                class: "ed-view-chip",
                title: m(kc)(Y) + ". Double-click to rename it",
                "aria-pressed": !!a.value && a.value.id === Y.id,
                "data-testid": "studio-camera-view",
                onClick: (H) => p(Y),
                onDblclick: (H) => v(Y)
              }, [
                C($, {
                  name: "Camera",
                  size: 11
                }),
                u("span", fye, E(Y.name), 1)
              ], 40, pye)),
              c.value !== Y.id ? (g(), b("button", {
                key: 2,
                class: "ed-view-x",
                title: "Remove " + Y.name,
                "aria-label": "Remove " + Y.name,
                "data-testid": "studio-camera-view-remove",
                onClick: (H) => m(t).removeCameraView(Y.id)
              }, [
                C($, {
                  name: "X",
                  size: 10
                })
              ], 8, mye)) : z("", !0)
            ], 2))), 128)),
            u("button", {
              key: "save",
              class: G(["ed-views-save", { "is-saved": !!a.value }]),
              disabled: !!a.value || l.value,
              title: d.value,
              "data-testid": "studio-camera-save",
              onClick: y
            }, [
              C($, {
                name: a.value ? "Check" : "Plus",
                size: 12
              }, null, 8, ["name"]),
              J(" " + E(a.value ? "Saved" : "Save view"), 1)
            ], 10, gye)
          ]),
          _: 1
        }),
        r.value.length ? z("", !0) : (g(), b("p", bye, "Save a view to come back to it, on any board and any picture."))
      ]),
      C(Ct, {
        label: "Rotate",
        "model-value": o.value.rotate,
        min: 0,
        max: 359,
        ticks: m(b0),
        format: X,
        testid: "studio-camera-rotate",
        "onUpdate:modelValue": Z[3] || (Z[3] = (Y) => m(n).setCamera({ rotate: m(h_)(Y, 4) }))
      }, null, 8, ["model-value", "ticks"]),
      C(Ct, {
        label: "Vertical",
        "model-value": o.value.vertical,
        min: -30,
        max: 90,
        ticks: m(Cf).map((Y) => Y.at),
        format: B,
        testid: "studio-camera-vertical",
        "onUpdate:modelValue": Z[4] || (Z[4] = (Y) => m(n).setCamera({ vertical: m(p_)(Y, 4) }))
      }, null, 8, ["model-value", "ticks"]),
      C(Ct, {
        label: "Zoom",
        "model-value": o.value.zoom,
        min: 0,
        max: 10,
        step: 0.5,
        start: 5,
        ticks: m(YC).map((Y) => Y.at),
        format: se,
        testid: "studio-camera-zoom",
        "onUpdate:modelValue": Z[5] || (Z[5] = (Y) => m(n).setCamera({ zoom: m(jne)(Y, 0.4) }))
      }, null, 8, ["model-value", "ticks"]),
      C(vt, { name: "ed-fade" }, {
        default: Xe(() => [
          m(JC)(o.value) ? (g(), b("div", vye, [
            C($, {
              name: "AlertCircle",
              size: 12
            }),
            Z[12] || (Z[12] = u("span", null, "Past a side view, the sides the picture doesn't show are invented.", -1))
          ])) : z("", !0)
        ]),
        _: 1
      }),
      u("div", yye, [
        u("label", xye, [
          kt(u("input", {
            "onUpdate:modelValue": Z[6] || (Z[6] = (Y) => m(n).t.camera.lock = Y),
            type: "checkbox",
            "data-testid": "studio-camera-seed-lock"
          }, null, 512), [
            [ol, m(n).t.camera.lock]
          ]),
          Z[13] || (Z[13] = u("i", null, null, -1)),
          Z[14] || (Z[14] = u("span", { title: "The same seed while you nudge the sliders, so a small move doesn't reshuffle the picture" }, "Keep the seed", -1))
        ]),
        u("button", {
          class: "ed-icon-chip",
          title: "A new seed",
          "aria-label": "A new seed",
          disabled: !s.value.lock,
          onClick: Z[7] || (Z[7] = (Y) => {
            m(n).t.camera.seed = null, m(n).seed();
          })
        }, [
          C($, {
            name: "Dice5",
            size: 13
          })
        ], 8, wye)
      ]),
      C(Yo, {
        kind: "camera",
        label: "Change camera",
        icon: "Rotate3d",
        why: "Trained on exactly these three settings",
        many: !0
      })
    ]));
  }
}), _ye = { class: "ed-panel ed-relight" }, Sye = ["aria-selected"], Mye = ["aria-selected"], Tye = {
  class: "ed-looks is-light",
  role: "radiogroup",
  "aria-label": "Looks"
}, Cye = ["aria-checked", "title", "data-testid", "onClick"], Iye = { class: "ed-rig" }, Aye = ["title", "onClick"], Pye = { class: "ed-lights" }, Eye = ["data-testid", "onClick"], Rye = { class: "nm" }, zye = ["aria-label", "onClick"], $ye = {
  class: "ed-quick",
  role: "group",
  "aria-label": "Quick positions"
}, Dye = ["onClick"], Oye = { class: "ed-field" }, Lye = {
  class: "ed-whites",
  role: "radiogroup",
  "aria-label": "White light"
}, Bye = ["aria-checked", "title", "onClick"], Fye = {
  class: "ed-gels",
  role: "radiogroup",
  "aria-label": "Coloured light"
}, Nye = ["aria-checked", "title", "onClick"], Uye = {
  class: "ed-gel is-any",
  title: "Any colour"
}, Gye = ["value"], jye = ["aria-checked"], Hye = ["aria-checked"], Vye = {
  key: 2,
  class: "ed-relight-reset"
}, Wye = ["disabled"], Rd = 132, qye = /* @__PURE__ */ Pe({
  __name: "RelightPanel",
  setup(i) {
    const t = yt().tools, n = I(() => t.t.relight), s = (() => {
      const k = Tc().lights[0];
      return { rotate: k.rotate, elevation: k.elevation, intensity: k.intensity };
    })(), o = I(() => JSON.stringify(r(l.value)) === JSON.stringify(r({ ...Tc(), mode: l.value.mode })));
    function r(k) {
      return { ...k, lights: k.lights.map((P) => ({ ...P, id: "" })) };
    }
    function a() {
      const k = { ...Tc(), mode: l.value.mode };
      t.t.relight.rig = k, t.t.relight.selected = k.lights[0].id;
    }
    const l = I(() => n.value.rig), d = I(() => l.value.lights.find((k) => k.id === n.value.selected) || l.value.lights[0] || null), c = /* @__PURE__ */ K(null);
    function h() {
      const k = c.value;
      if (!k) return;
      const P = Math.min(2, window.devicePixelRatio || 1), A = Math.round(Rd * P);
      k.width !== A && (k.width = A, k.height = A);
      const R = k.getContext("2d");
      if (!R) return;
      const D = R.createImageData(A, A);
      D.data.set(ape(l.value, A)), R.putImageData(D, 0, 0);
    }
    ot(h), Ae(l, h, { deep: !0 });
    function f(k) {
      const P = d.value;
      if (!P) return;
      const A = l.value.lights.map((R) => {
        if (R.id !== P.id) return R;
        const D = { ...R };
        return k(D), D;
      });
      t.t.relight.rig = { ...l.value, lights: A, look: l.value.look };
    }
    function p(k) {
      t.t.relight.rig = { ...l.value, mode: k };
    }
    function y(k) {
      const P = R0.find((A) => A.id === k);
      P && (t.t.relight.rig = Xhe(P, l.value.mode), t.t.relight.selected = t.t.relight.rig.lights[0].id);
    }
    function v() {
      var k;
      if (l.value.lights.length >= W_) return;
      const P = l.value.lights.map((D) => D.rotate), A = (k = [90, -90, 135, 0].find((D) => !P.includes(D))) != null ? k : 135, R = ix({ rotate: A, elevation: 0, intensity: 4, color: "#fff4e5", kelvin: 5600 });
      t.t.relight.rig = { ...l.value, lights: [...l.value.lights, R] }, t.t.relight.selected = R.id;
    }
    function x(k) {
      if (l.value.lights.length <= 1) return;
      const P = l.value.lights.filter((A) => A.id !== k);
      t.t.relight.rig = { ...l.value, lights: P }, n.value.selected === k && (t.t.relight.selected = P[0].id);
    }
    const w = (k) => {
      const P = Cc(k);
      return P === 0 ? "Front" : P === 180 ? "Behind" : Math.abs(P) === 90 ? P > 0 ? "Right" : "Left" : (Math.abs(P) > 90 ? "Behind " : "Front ") + (P > 0 ? "right" : "left");
    }, S = (k) => k >= 75 ? "Overhead" : k <= -75 ? "Below" : k > 0 ? "High, " + k + "°" : k < 0 ? "Low, " + k + "°" : "Level", M = (k) => String(k), _ = I(() => npe(l.value.lights));
    function T(k) {
      return _.value[k] || "Light " + (k + 1);
    }
    return (k, P) => (g(), b("div", _ye, [
      u("div", {
        class: "sv-seg is-text ed-tabs ed-slide",
        role: "tablist",
        "aria-label": "Relight",
        style: ce({ "--i": l.value.mode === "transfer" ? 1 : 0, "--n": 2 })
      }, [
        u("button", {
          role: "tab",
          "aria-selected": l.value.mode === "relight",
          class: G({ on: l.value.mode === "relight" }),
          "data-testid": "studio-relight-mode-relight",
          onClick: P[0] || (P[0] = (A) => p("relight"))
        }, "Relight", 10, Sye),
        u("button", {
          role: "tab",
          "aria-selected": l.value.mode === "transfer",
          class: G({ on: l.value.mode === "transfer" }),
          "data-testid": "studio-relight-mode-transfer",
          onClick: P[1] || (P[1] = (A) => p("transfer"))
        }, "Light transfer", 10, Mye)
      ], 4),
      l.value.mode === "relight" ? (g(), b(j, { key: 0 }, [
        u("div", Tye, [
          (g(!0), b(j, null, be(m(R0), (A) => (g(), b("button", {
            key: A.id,
            class: G(["ed-light-look", { on: l.value.look === A.id }]),
            role: "radio",
            "aria-checked": l.value.look === A.id,
            title: A.words || A.label,
            "data-testid": "studio-relight-look-" + A.id,
            onClick: (R) => y(A.id)
          }, [
            u("i", {
              style: ce({ background: "radial-gradient(circle at 32% 30%, " + A.swatch[0] + ", " + A.swatch[1] + " 72%)" })
            }, null, 4),
            u("span", null, E(A.label), 1)
          ], 10, Cye))), 128))
        ]),
        u("div", Iye, [
          u("div", {
            class: "ed-sphere",
            style: ce({ width: Rd + "px", height: Rd + "px" })
          }, [
            u("canvas", {
              ref_key: "sphere",
              ref: c,
              style: ce({ width: Rd + "px", height: Rd + "px" })
            }, null, 4),
            (g(!0), b(j, null, be(l.value.lights, (A, R) => (g(), b("button", {
              key: A.id,
              class: G(["ed-sphere-light", { on: d.value && d.value.id === A.id, "is-behind": !m(kb)(A).front }]),
              style: ce({ left: m(kb)(A).x * 100 + "%", top: m(kb)(A).y * 100 + "%", "--c": A.color }),
              title: T(R),
              onClick: (D) => m(t).t.relight.selected = A.id
            }, E(R + 1), 15, Aye))), 128))
          ], 4),
          u("div", Pye, [
            (g(!0), b(j, null, be(l.value.lights, (A, R) => (g(), b("button", {
              key: A.id,
              class: G(["ed-light-chip", { on: d.value && d.value.id === A.id }]),
              style: ce({ "--c": A.color }),
              "data-testid": "studio-relight-light-" + R,
              onClick: (D) => m(t).t.relight.selected = A.id
            }, [
              P[9] || (P[9] = u("i", null, null, -1)),
              u("span", Rye, E(T(R)), 1),
              l.value.lights.length > 1 ? (g(), b("span", {
                key: 0,
                class: "x",
                role: "button",
                "aria-label": "Remove " + T(R),
                onClick: Se((D) => x(A.id), ["stop"])
              }, [
                C($, {
                  name: "X",
                  size: 10
                })
              ], 8, zye)) : z("", !0)
            ], 14, Eye))), 128)),
            l.value.lights.length < m(W_) ? (g(), b("button", {
              key: 0,
              class: "ed-light-chip is-add",
              "data-testid": "studio-relight-add",
              onClick: v
            }, [
              C($, {
                name: "Plus",
                size: 11
              }),
              P[10] || (P[10] = J(" Light", -1))
            ])) : z("", !0)
          ])
        ]),
        d.value ? (g(), b(j, { key: 0 }, [
          u("div", $ye, [
            (g(!0), b(j, null, be(m(Khe), (A) => (g(), b("button", {
              key: A.id,
              class: G(["ed-quick-btn", { on: m(Cc)(d.value.rotate) === A.rotate && m(K_)(d.value.elevation) === A.elevation }]),
              onClick: (R) => {
                f((D) => {
                  D.rotate = A.rotate, D.elevation = A.elevation;
                });
              }
            }, E(A.label), 11, Dye))), 128))
          ]),
          C(Ct, {
            label: "Around",
            "model-value": d.value.rotate,
            min: -135,
            max: 180,
            step: 45,
            start: m(s).rotate,
            ticks: [-135, -90, -45, 0, 45, 90, 135, 180],
            format: w,
            testid: "studio-relight-rotate",
            "onUpdate:modelValue": P[2] || (P[2] = (A) => f((R) => R.rotate = m(Cc)(A)))
          }, null, 8, ["model-value", "start"]),
          C(Ct, {
            label: "Height",
            "model-value": d.value.elevation,
            min: -90,
            max: 90,
            step: 45,
            start: m(s).elevation,
            ticks: [-90, -45, 0, 45, 90],
            format: S,
            testid: "studio-relight-elevation",
            "onUpdate:modelValue": P[3] || (P[3] = (A) => f((R) => R.elevation = m(K_)(A)))
          }, null, 8, ["model-value", "start"]),
          C(Ct, {
            label: "Intensity",
            "model-value": d.value.intensity,
            min: 1,
            max: 10,
            start: m(s).intensity,
            format: M,
            testid: "studio-relight-intensity",
            "onUpdate:modelValue": P[4] || (P[4] = (A) => f((R) => R.intensity = A))
          }, null, 8, ["model-value", "start"]),
          u("div", Oye, [
            P[12] || (P[12] = u("span", { class: "ed-field-lb" }, "Colour", -1)),
            u("div", Lye, [
              (g(!0), b(j, null, be(m(OI), (A) => (g(), b("button", {
                key: A.kelvin,
                class: G(["ed-white", { on: d.value.kelvin === A.kelvin }]),
                style: ce({ "--c": A.color }),
                role: "radio",
                "aria-checked": d.value.kelvin === A.kelvin,
                title: A.name + ", about " + A.kelvin + " K",
                onClick: (R) => {
                  f((D) => {
                    D.color = A.color, D.kelvin = A.kelvin;
                  });
                }
              }, [
                P[11] || (P[11] = u("i", null, null, -1)),
                u("span", null, E(A.kelvin / 1e3) + "k", 1)
              ], 14, Bye))), 128))
            ]),
            u("div", Fye, [
              (g(!0), b(j, null, be(m(qhe), (A) => (g(), b("button", {
                key: A,
                class: G(["ed-gel", { on: !d.value.kelvin && d.value.color.toLowerCase() === A }]),
                style: ce({ "--c": A }),
                role: "radio",
                "aria-checked": !d.value.kelvin && d.value.color.toLowerCase() === A,
                title: A,
                onClick: (R) => {
                  f((D) => {
                    D.color = A, D.kelvin = null;
                  });
                }
              }, null, 14, Nye))), 128)),
              u("label", Uye, [
                u("input", {
                  type: "color",
                  value: d.value.color,
                  onInput: P[5] || (P[5] = (A) => {
                    f((R) => {
                      R.color = A.target.value, R.kelvin = null;
                    });
                  })
                }, null, 40, Gye)
              ])
            ])
          ])
        ], 64)) : z("", !0),
        u("div", {
          class: "sv-seg is-small ed-pills ed-slide",
          role: "radiogroup",
          "aria-label": "Softness",
          style: ce({ "--i": l.value.softness === "hard" ? 1 : 0, "--n": 2 })
        }, [
          u("button", {
            role: "radio",
            "aria-checked": l.value.softness === "soft",
            class: G({ on: l.value.softness === "soft" }),
            onClick: P[6] || (P[6] = (A) => m(t).t.relight.rig = { ...l.value, softness: "soft" })
          }, "Soft", 10, jye),
          u("button", {
            role: "radio",
            "aria-checked": l.value.softness === "hard",
            class: G({ on: l.value.softness === "hard" }),
            onClick: P[7] || (P[7] = (A) => m(t).t.relight.rig = { ...l.value, softness: "hard" })
          }, "Hard", 10, Hye)
        ], 4)
      ], 64)) : (g(), b(j, { key: 1 }, [
        P[13] || (P[13] = u("p", { class: "ed-hint" }, "Copies another picture's light (its direction, colour and softness) onto this one, keeping everything else.", -1)),
        C(QI, {
          modelValue: m(t).t.relight.refId,
          "onUpdate:modelValue": P[8] || (P[8] = (A) => m(t).t.relight.refId = A),
          label: "The light to copy"
        }, null, 8, ["modelValue"])
      ], 64)),
      l.value.mode !== "transfer" ? (g(), b("div", Vye, [
        u("button", {
          class: "sv-btn",
          disabled: o.value,
          title: "The lights as Relight starts them",
          "data-testid": "studio-relight-reset",
          onClick: a
        }, [
          C($, {
            name: "RotateCcw",
            size: 13
          }),
          P[14] || (P[14] = J(" Reset lights", -1))
        ], 8, Wye)
      ])) : z("", !0),
      C(Yo, {
        kind: "relight",
        label: l.value.mode === "transfer" ? "Transfer light" : "Relight",
        icon: "Lightbulb",
        why: l.value.mode === "transfer" ? "Copies the light of the picture you pick: it kept pictures truest in our relighting tests" : "Your lights, described in words: it kept pictures truest in our relighting tests"
      }, null, 8, ["label", "why"])
    ]));
  }
}), Kye = ["data-tool"], Yye = ["aria-checked", "disabled", "title", "data-testid", "onClick"], Xye = { class: "lbl" }, Jye = {
  key: 0,
  class: "ed-pending",
  title: "Not applied yet"
}, Zye = ["inert", "aria-busy", "data-testid"], Qye = /* @__PURE__ */ Pe({
  __name: "ToolList",
  setup(i) {
    const e = yt(), t = e.tools, n = t.t, s = [
      { id: null, label: "Prompt", icon: "Wand2", hint: "Say what to change in the bar below, select an area, or annotate the picture" },
      ...SI
    ], o = {
      prompt: Zve,
      upscale: h0e,
      resize: D0e,
      background: s1e,
      adjust: U1e,
      skin: W1e,
      camera: kye,
      relight: qye
    }, r = I(() => !!e.stage.value && e.stage.value.status === "done");
    function a(f) {
      f === null ? t.close() : t.open(f);
    }
    const l = /* @__PURE__ */ K(null), d = () => typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let c = 0;
    Ae(() => [n.open, n.resize.mode, n.background.mode, n.relight.rig.mode], ([f]) => {
      clearTimeout(c), c = window.setTimeout(() => h(f || "prompt"), d() ? 0 : 360);
    });
    function h(f) {
      const p = l.value && l.value.querySelector('[data-tool="' + f + '"]'), y = p && p.closest(".sv-studios");
      if (!p || !y) return;
      if (f === "prompt") {
        y.scrollTop > 0 && y.scrollTo({ top: 0, behavior: d() ? "auto" : "smooth" });
        return;
      }
      const v = y.getBoundingClientRect(), x = p.getBoundingClientRect(), w = x.top - v.top - 10, S = w < 0 ? w : x.bottom > v.bottom ? Math.min(x.bottom - v.bottom, w) : 0;
      Math.abs(S) > 1 && y.scrollBy({ top: S, behavior: d() ? "auto" : "smooth" });
    }
    return We(() => clearTimeout(c)), (f, p) => (g(), b("div", {
      ref_key: "root",
      ref: l,
      class: "ed-tools",
      role: "radiogroup",
      "aria-label": "Edit with",
      "data-testid": "studio-edit-tools"
    }, [
      (g(), b(j, null, be(s, (y) => u("section", {
        key: y.id || "prompt",
        "data-tool": y.id || "prompt",
        class: G(["ed-tool", { on: m(n).open === y.id, "is-pending": !!y.id && m(n).open === y.id && m(t).pending(y.id) }])
      }, [
        u("button", {
          class: "ed-tool-head",
          role: "radio",
          "aria-checked": m(n).open === y.id,
          disabled: !r.value && !!y.id || !!m(n).busy && m(n).open !== y.id,
          title: y.hint,
          "data-testid": "studio-edit-tool-" + (y.id || "prompt"),
          onClick: (v) => a(y.id)
        }, [
          C(ym, {
            on: m(n).open === y.id
          }, null, 8, ["on"]),
          C($, {
            name: y.icon,
            size: 15,
            class: "ic"
          }, null, 8, ["name"]),
          u("span", Xye, E(y.label), 1),
          y.id && m(n).open === y.id && m(t).pending(y.id) ? (g(), b("span", Jye)) : z("", !0)
        ], 8, Yye),
        C(pa, {
          open: m(n).open === y.id
        }, {
          default: Xe(() => [
            u("div", {
              class: G(["ed-tool-body", { "is-held": !!m(n).busy }]),
              inert: !!m(n).busy || void 0,
              "aria-busy": !!m(n).busy || void 0,
              "data-testid": "studio-edit-panel-" + (y.id || "prompt")
            }, [
              (g(), Ce(la(o[y.id || "prompt"])))
            ], 10, Zye)
          ]),
          _: 2
        }, 1032, ["open"])
      ], 10, Kye)), 64))
    ], 512));
  }
}), exe = {
  class: "sv-tools",
  "data-testid": "studio-tools-threed"
}, txe = {
  class: "sv-views",
  "data-testid": "studio-models"
}, nxe = ["title", "onClick"], ixe = { class: "sv-views-adds" }, sxe = {
  class: "sv-views",
  "data-testid": "studio-cameras"
}, oxe = ["value", "onKeydown", "onBlur"], rxe = ["title", "onClick", "onDblclick"], axe = ["title", "onClick"], lxe = ["disabled"], dxe = ["disabled"], cxe = /* @__PURE__ */ Pe({
  __name: "ThreeDTools",
  props: {
    fly: { type: Function },
    capture: { type: Function }
  },
  emits: ["upload-model", "library-model"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = yt(), { board: o } = Ze(), r = s.s, a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(!1);
    function c() {
      const y = s.saveCamera();
      y && s.say("Saved " + y.name + " with this model");
    }
    function h(y) {
      a.value = y, nt(() => {
        const v = l.value && l.value[0];
        v && (v.focus(), v.select());
      });
    }
    function f(y, v) {
      a.value === y && (s.renameCamera(y, v.target.value), a.value = null);
    }
    async function p() {
      if (!d.value) {
        d.value = !0;
        try {
          await t.capture();
        } finally {
          d.value = !1;
        }
      }
    }
    return (y, v) => (g(), b("div", exe, [
      m(s).model3d.value ? (g(), b(j, { key: 0 }, [
        v[10] || (v[10] = u("p", { class: "sv-tools-hint" }, "Drag to orbit, right-drag or Shift-drag to move the view, scroll to zoom. Frame it in the viewfinder.", -1)),
        v[11] || (v[11] = u("div", { class: "sv-tools-label" }, "Models", -1)),
        u("ul", txe, [
          (g(!0), b(j, null, be(m(s).models3d.value, (x) => (g(), b("li", {
            key: x.id
          }, [
            u("button", {
              class: G(["go", { on: x.id === m(r).three.model }]),
              title: "Show " + x.name,
              onClick: (w) => m(s).useModel(x.id)
            }, [
              C($, {
                name: "Box",
                size: 12
              }),
              J(" " + E(x.name), 1)
            ], 10, nxe)
          ]))), 128)),
          u("li", ixe, [
            u("button", {
              class: "go is-add",
              title: "A model from your computer",
              "data-testid": "studio-3d-add",
              onClick: v[0] || (v[0] = (x) => n("upload-model"))
            }, [
              C($, {
                name: "Upload",
                size: 12
              }),
              v[6] || (v[6] = J(" Computer", -1))
            ]),
            m(o).hasLibrary ? (g(), b("button", {
              key: 0,
              class: "go is-add",
              title: "A model from your Library",
              onClick: v[1] || (v[1] = (x) => n("library-model"))
            }, [
              C($, {
                name: "Library",
                size: 12
              }),
              v[7] || (v[7] = J(" Library", -1))
            ])) : z("", !0)
          ])
        ]),
        v[12] || (v[12] = u("div", { class: "sv-tools-label" }, "Saved views", -1)),
        u("ul", sxe, [
          (g(!0), b(j, null, be(m(s).model3d.value.cameras, (x) => (g(), b("li", {
            key: x.id
          }, [
            a.value === x.id ? (g(), b("input", {
              key: 0,
              ref_for: !0,
              ref_key: "nameEl",
              ref: l,
              class: "sv-view-input",
              value: x.name,
              spellcheck: "false",
              onKeydown: [
                tn(Se((w) => f(x.id, w), ["prevent"]), ["enter"]),
                v[2] || (v[2] = tn(Se((w) => a.value = null, ["stop", "prevent"]), ["esc"]))
              ],
              onBlur: (w) => f(x.id, w)
            }, null, 40, oxe)) : (g(), b(j, { key: 1 }, [
              u("button", {
                class: "go",
                title: "Fly to " + x.name + " (double-click to rename)",
                onClick: (w) => i.fly(x.cam),
                onDblclick: (w) => h(x.id)
              }, [
                C($, {
                  name: "Camera",
                  size: 12
                }),
                J(" " + E(x.name), 1)
              ], 40, rxe),
              u("button", {
                class: "x",
                title: "Forget " + x.name,
                onClick: (w) => m(s).removeCamera(x.id)
              }, [
                C($, {
                  name: "X",
                  size: 11
                })
              ], 8, axe)
            ], 64))
          ]))), 128)),
          u("li", null, [
            u("button", {
              class: "go is-add",
              "data-testid": "studio-save-camera",
              title: "Save this view to come back to",
              disabled: !m(r).three.cam,
              onClick: c
            }, [
              C($, {
                name: "Plus",
                size: 12
              }),
              v[8] || (v[8] = J(" Save this view", -1))
            ], 8, lxe)
          ])
        ]),
        u("button", {
          class: "sv-btn is-wide",
          disabled: d.value || m(r).three.loading || !!m(r).three.error,
          "data-testid": "studio-capture",
          title: "Adds this frame to history and the queue, to draw on, annotate or send",
          onClick: p
        }, [
          C($, {
            name: d.value ? "Loader2" : "Camera",
            size: 14,
            spin: d.value
          }, null, 8, ["name", "spin"]),
          v[9] || (v[9] = J(" Capture view ", -1))
        ], 8, dxe)
      ], 64)) : (g(), b(j, { key: 1 }, [
        v[16] || (v[16] = u("p", { class: "sv-tools-hint" }, "Bring in a model to find your view. Views you save stay with the model.", -1)),
        u("button", {
          class: "sv-btn is-wide",
          onClick: v[3] || (v[3] = (x) => n("upload-model"))
        }, [
          C($, {
            name: "Upload",
            size: 14
          }),
          v[13] || (v[13] = J(" From your computer", -1))
        ]),
        m(o).hasLibrary ? (g(), b("button", {
          key: 0,
          class: "sv-btn is-wide",
          onClick: v[4] || (v[4] = (x) => n("library-model"))
        }, [
          C($, {
            name: "Library",
            size: 14
          }),
          v[14] || (v[14] = J(" From your Library", -1))
        ])) : z("", !0),
        u("button", {
          class: "sv-btn is-wide",
          onClick: v[5] || (v[5] = (x) => m(s).addSample())
        }, [
          C($, {
            name: "Building2",
            size: 14
          }),
          v[15] || (v[15] = J(" Try the sample", -1))
        ])
      ], 64))
    ]));
  }
}), uxe = {
  class: "sv-hist-pop",
  "data-testid": "studio-history-preview"
}, hxe = ["title"], pxe = { class: "cap" }, fxe = { class: "n" }, mxe = { class: "m" }, gxe = { class: "sv-hist-acts" }, bxe = ["aria-pressed"], vxe = { class: "tip" }, yxe = { class: "tip" }, xxe = { class: "tip" }, wxe = { class: "tip" }, kxe = /* @__PURE__ */ Pe({
  __name: "HistoryPreview",
  props: {
    item: {}
  },
  emits: ["done"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = yt(), { board: o } = Ze(), r = /* @__PURE__ */ K(!1);
    Ae(() => t.item.id, () => {
      r.value = !1;
    });
    const a = I(() => t.item), l = I(() => s.side.value === "generate"), d = I(() => !!a.value.sessionId && a.value.sessionId !== s.sessionId && a.value.kind === "gen"), c = I(() => !!s.card.value && !s.onCard(a.value.id) && s.family.value.some((P) => P.id === a.value.id)), h = I(() => {
      const P = s.names.value.get(a.value.id), A = a.value.parentId ? s.items.value.find((O) => O.id === a.value.parentId) : null, R = A ? "from " + (s.names.value.get(A.id) || A.label) : "";
      return [a.value.pin ? a.value.label : a.value.kind === "ref" && !f.value ? xl[a.value.how || "upload"].text : P || a.value.label, R].filter(Boolean).join(" · ");
    }), f = I(() => a.value.kind === "ref" && a.value.how === "tool" && !!a.value.made), p = I(() => a.value.pin ? "Pinned" : f.value ? xl.tool.text + " · " + Jn(a.value.createdAt) : a.value.kind === "ref" ? "Reference" : (d.value ? s.sessionName(a.value) + " · " : "") + Jn(a.value.createdAt)), y = I(() => d.value ? "Bring it in from " + s.sessionName(a.value) : s.side.value === "edit" ? "Edit this one" : "Open in the viewer"), v = I(() => o.isPinnedImage(a.value.url));
    function x() {
      const P = a.value, A = P.result;
      o.togglePinImage({
        url: P.url,
        w: P.w,
        h: P.h,
        label: P.label,
        asset: P.asset || null,
        resultId: A ? A.id : null,
        sessionId: P.sessionId || (A ? A.sessionId : s.sessionId),
        video: !!(A && A.video),
        videoSrc: A && A.videoSrc || null,
        dur: A && A.dur || null
      });
    }
    const w = I(() => s.editRefItems.value.find((P) => P.id === a.value.id || !!P.source && P.source === a.value.id) || null), S = I(() => !l.value && s.takesRefs() && a.value.status === "done" && a.value.id !== s.s.stageId);
    function M() {
      w.value ? s.removeEditRef(w.value.id) : s.addEditRef(a.value.id);
    }
    function _(P) {
      P(), n("done");
    }
    function T() {
      a.value.status === "done" && s.show(a.value.id);
    }
    function k() {
      if (!r.value) {
        r.value = !0;
        return;
      }
      _(() => s.deleteItem(a.value.id));
    }
    return (P, A) => (g(), b("div", uxe, [
      u("button", {
        class: "art",
        title: y.value,
        onClick: A[0] || (A[0] = (R) => _(T))
      }, [
        C(ao, {
          item: a.value,
          full: ""
        }, null, 8, ["item"])
      ], 8, hxe),
      u("span", pxe, [
        u("span", fxe, E(h.value), 1),
        u("span", mxe, E(p.value), 1)
      ]),
      u("span", gxe, [
        u("button", {
          class: G(["is-pin", { on: v.value }]),
          "aria-pressed": v.value,
          "data-testid": "studio-pin",
          onClick: Se(x, ["stop"])
        }, [
          C($, {
            name: "Pin",
            size: 13
          }),
          u("span", vxe, E(v.value ? m(Xn).unpin : m(Xn).pin), 1)
        ], 10, bxe),
        l.value ? (g(), b("button", {
          key: 0,
          class: G({ on: m(s).queued(a.value.id) > 0 }),
          "data-testid": "studio-queue-toggle",
          onClick: A[1] || (A[1] = Se((R) => m(s).toggleQueued(a.value.id), ["stop"]))
        }, [
          C($, {
            name: m(s).queued(a.value.id) ? "Check" : "ImagePlus",
            size: 13
          }, null, 8, ["name"]),
          u("span", yxe, E(m(s).queued(a.value.id) ? "Image " + m(s).queued(a.value.id) + " of the next run: take it out" : "Use as reference (add it to the next run)"), 1)
        ], 2)) : z("", !0),
        S.value ? (g(), b("button", {
          key: 1,
          class: G({ on: !!w.value }),
          "data-testid": "studio-ref-toggle",
          onClick: Se(M, ["stop"])
        }, [
          C($, {
            name: w.value ? "Check" : "ImagePlus",
            size: 13
          }, null, 8, ["name"]),
          u("span", xxe, E(w.value ? "A reference for the edit: take it out" : "Use as reference"), 1)
        ], 2)) : z("", !0),
        u("button", {
          "data-testid": "studio-place",
          onClick: A[2] || (A[2] = Se((R) => _(() => m(s).placeOnBoard(a.value.id)), ["stop"]))
        }, [
          C($, {
            name: "ArrowDownToLine",
            size: 13
          }),
          A[6] || (A[6] = u("span", { class: "tip" }, "Place on the board", -1))
        ]),
        a.value.kind === "gen" ? (g(), b("button", {
          key: 2,
          "data-testid": "studio-pop-details",
          onClick: A[3] || (A[3] = Se((R) => _(() => m(s).openInfo(a.value.id)), ["stop"]))
        }, [
          C($, {
            name: "Info",
            size: 13
          }),
          A[7] || (A[7] = u("span", { class: "tip" }, "Details", -1))
        ])) : z("", !0),
        m(s).canDelete(a.value.id) ? (g(), b("button", {
          key: 3,
          class: G(["is-danger", { "is-armed": r.value }]),
          "data-testid": "studio-delete",
          onClick: Se(k, ["stop"])
        }, [
          C($, {
            name: "Trash2",
            size: 13
          }),
          u("span", wxe, E(r.value ? "Click again to delete it" : "Delete"), 1)
        ], 2)) : z("", !0),
        l.value ? (g(), b("button", {
          key: 4,
          "data-testid": "studio-continue",
          onClick: A[4] || (A[4] = Se((R) => _(() => m(s).continueFrom(a.value.id)), ["stop"]))
        }, [
          C($, {
            name: "CornerDownLeft",
            size: 13
          }),
          A[8] || (A[8] = u("span", { class: "tip" }, "Start from this image: it becomes image 1", -1))
        ])) : z("", !0),
        c.value ? (g(), b("button", {
          key: 5,
          class: "is-promote",
          "data-testid": "studio-promote",
          onClick: A[5] || (A[5] = Se((R) => _(() => m(s).promote(a.value.id)), ["stop"]))
        }, [
          C($, {
            name: "Replace",
            size: 13
          }),
          A[9] || (A[9] = u("span", { class: "tip" }, "Use this version on the board, in place of the one there", -1))
        ])) : z("", !0)
      ])
    ]));
  }
}), _xe = ["inert"], Sxe = { class: "sv-hist-head" }, Mxe = { class: "t" }, Txe = {
  class: "n",
  "data-testid": "studio-history-count"
}, Cxe = {
  key: 0,
  class: "sv-hist-from",
  "data-testid": "studio-made-from"
}, Ixe = ["aria-expanded"], Axe = { class: "n" }, Pxe = {
  key: 0,
  class: "sv-hist-from-row"
}, Exe = ["title", "data-testid", "onClick"], Rxe = { class: "k" }, zxe = ["data-testid", "draggable", "onMouseenter", "onClick", "onDragstart"], $xe = { class: "frame" }, Dxe = {
  key: 1,
  class: "sv-cell-fail"
}, Oxe = ["title"], Lxe = ["title"], Bxe = {
  key: 2,
  class: "sv-cell-marks",
  title: "Annotated: its annotations go with it when it's sent"
}, Fxe = {
  key: 3,
  class: "sv-cell-card",
  title: "The version the board shows",
  "data-testid": "studio-on-board"
}, Nxe = ["title"], Uxe = { class: "sv-cell-cap" }, Gxe = {
  key: 1,
  class: "sv-hist-empty"
}, f4 = 60, jxe = 260, Hxe = /* @__PURE__ */ Pe({
  __name: "History",
  setup(i) {
    const e = yt(), { board: t } = Ze(), n = e.s, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null);
    let r = 0;
    function a(B) {
      return {
        w: Math.max(300, Math.min(640, B.left - 12 - 330)),
        h: Math.max(380, Math.min(720, window.innerHeight - f4 - 40))
      };
    }
    const l = I(() => e.shown.value), d = I(() => e.historySessions.value), c = I(() => e.pickedSessions()), h = I(() => e.allSessions()), f = I(() => F1(e)), p = I(() => (h.value ? d.value.length : c.value.length) > 1), y = I(() => e.side.value === "generate"), v = I(() => e.card.value);
    function x(B) {
      const se = e.stage.value;
      return !!se && (se.id === B.id || se.source === B.id);
    }
    const w = I(() => e.madeFrom(e.stage.value)), S = /* @__PURE__ */ K(!0);
    function M(B) {
      const se = t.store.get(B);
      !se || se.type !== "tool" || e.tools.close(() => {
        e.leave(), t.closeStudio(), t.openSession(se);
      });
    }
    function _(B) {
      return B.kind === "ref" && B.how === "tool" && !!B.made;
    }
    function T(B) {
      return B.status === "pending" ? "Making…" : B.status === "failed" ? "Failed" : n.pinned ? e.sessionName(B) || B.label : B.kind === "ref" && !_(B) ? xl[B.how || "upload"].text : p.value && e.sessionName(B) || Jn(B.createdAt);
    }
    function k() {
      t.openLibrary({
        purpose: "pick",
        max: 24,
        kinds: ["image"],
        confirmLabel: "Bring into the studio",
        onPick: (B) => e.addFromLibrary(B)
      });
    }
    function P(B) {
      B.status === "done" && (n.dropper ? e.dropperPick(B.id) : e.show(B.id));
    }
    function A(B) {
      if (e.side.value !== "edit") {
        const se = e.queued(B.id);
        return se ? { text: "Image " + se, adds: !1 } : { text: "Add to the next image", adds: !0 };
      }
      return x(B) ? { text: "Being edited", adds: !1 } : e.editRefItems.value.some((se) => se.id === B.id || se.source === B.id) ? { text: "A reference", adds: !1 } : { text: "Add as a reference", adds: !0 };
    }
    function R(B, se) {
      if (B.status !== "done") {
        se.preventDefault();
        return;
      }
      F();
      const V = se.currentTarget.querySelector(".frame");
      Ime(se, B.id, V);
    }
    const D = () => {
      clearTimeout(r), clearTimeout(te);
    }, O = () => {
      clearTimeout(r), clearTimeout(te), r = window.setTimeout(() => {
        o.value = null;
      }, 180);
    }, F = () => {
      clearTimeout(r), clearTimeout(te), o.value = null;
    };
    Ae(() => o.value && o.value.it.id, (B, se) => {
      B ? n.peekId = B : n.peekId === se && (n.peekId = null);
    }), We(() => {
      clearTimeout(r), clearTimeout(te), o.value && n.peekId === o.value.it.id && (n.peekId = null);
    });
    let te = 0, ee = null;
    function me(B) {
      ee = { x: B.clientX, y: B.clientY };
    }
    const L = /* @__PURE__ */ K(!1);
    let N = 0;
    Ae(() => n.histShut, (B) => {
      F(), L.value = !0, clearTimeout(N), N = window.setTimeout(() => {
        L.value = !1;
      }, 380), B && n.dropper && e.setDropper(!1);
    }), We(() => clearTimeout(N));
    function X(B, se) {
      if (D(), B.status !== "done" || !s.value || n.dropper) {
        o.value = null;
        return;
      }
      const V = se.currentTarget.getBoundingClientRect(), Z = s.value.getBoundingClientRect(), Y = a(Z), H = Math.min(Y.w / B.w, Y.h / B.h), re = Math.round(B.w * H), le = Math.round(B.h * H), he = Math.min(Math.max(f4 + 8 - Z.top, V.top - Z.top + V.height / 2 - le / 2), window.innerHeight - 8 - le - Z.top), Re = { it: B, top: he, w: re, h: le }, Ne = o.value, Me = ee ? se.clientX - ee.x : 0, ue = ee ? se.clientY - ee.y : 0;
      if (Ne && Ne.it.id !== B.id && Me < 0 && -Me >= Math.abs(ue)) {
        te = window.setTimeout(() => {
          o.value = Re;
        }, jxe);
        return;
      }
      o.value = Re;
    }
    return (B, se) => (g(), b("aside", {
      ref_key: "rail",
      ref: s,
      class: G(["sv-hist", ["cols-" + m(n).columns, { "is-dropper": m(n).dropper, "is-shut": m(n).histShut, "is-moving": L.value }]]),
      "data-testid": "studio-history",
      onMouseleave: O,
      onMousemovePassive: me
    }, [
      u("div", {
        class: "sv-hist-body",
        inert: m(n).histShut || void 0
      }, [
        u("div", Sxe, [
          u("span", Mxe, E(m(n).pinned ? "Pinned" : "History"), 1),
          u("span", Txe, E(l.value.length), 1),
          se[5] || (se[5] = u("span", { class: "sv-grow" }, null, -1)),
          m(t).hasLibrary ? (g(), b("button", {
            key: 0,
            class: "sv-hist-lib",
            title: "Find a picture anywhere: your Library",
            "data-testid": "studio-open-library",
            onClick: k
          }, [
            C($, {
              name: "Library",
              size: 14
            })
          ])) : z("", !0),
          C(K8, {
            columns: m(n).columns,
            testid: "studio-cols",
            onSet: se[0] || (se[0] = (V) => m(e).setColumns(V))
          }, null, 8, ["columns"]),
          u("button", {
            class: "sv-hist-lib sv-hist-fold",
            title: "Hide history, for more room",
            "aria-label": "Hide history",
            "data-testid": "studio-history-hide",
            onClick: se[1] || (se[1] = (V) => m(e).setHistShut(!0))
          }, [
            C($, {
              name: "PanelRightClose",
              size: 14
            })
          ])
        ]),
        C(Y8, {
          filter: m(e),
          tid: "studio",
          pinned: m(n).pinned,
          "pin-count": m(t).pinnedImages.value.length,
          "go-to": M,
          onPinned: se[2] || (se[2] = (V) => m(n).pinned = V)
        }, null, 8, ["filter", "pinned", "pin-count"]),
        w.value.length ? (g(), b("div", Cxe, [
          u("button", {
            class: "sv-hist-from-head",
            "aria-expanded": S.value,
            onClick: se[3] || (se[3] = (V) => S.value = !S.value)
          }, [
            C($, {
              name: "Images",
              size: 12
            }),
            se[6] || (se[6] = u("span", null, "Made from", -1)),
            u("span", Axe, E(w.value.length), 1),
            se[7] || (se[7] = u("span", { class: "sv-grow" }, null, -1)),
            C($, {
              name: S.value ? "ChevronUp" : "ChevronDown",
              size: 12
            }, null, 8, ["name"])
          ], 8, Ixe),
          S.value ? (g(), b("div", Pxe, [
            (g(!0), b(j, null, be(w.value, (V) => (g(), b("button", {
              key: V.url,
              class: "sv-hist-from-pic",
              title: "Image " + V.n + ": open it in the viewer",
              style: ce({ backgroundImage: 'url("' + m(Bt)(V.url) + '"), url("' + V.url + '")' }),
              "data-testid": "studio-made-from-" + V.n,
              onClick: (Z) => m(e).showUrl(V.url)
            }, [
              u("span", Rxe, E(V.n), 1)
            ], 12, Exe))), 128))
          ])) : z("", !0)
        ])) : z("", !0),
        u("div", {
          class: "sv-hist-grid",
          style: ce({ "--cols": m(n).columns }),
          onScroll: F
        }, [
          (g(!0), b(j, null, be(l.value, (V) => (g(), b("div", {
            key: V.id,
            class: G(["sv-cell", {
              "is-ref": V.kind === "ref",
              "is-stage": x(V),
              "is-pending": V.status === "pending",
              "is-failed": V.status === "failed",
              "is-queued": y.value && m(e).queued(V.id) > 0,
              "is-card": !!v.value && m(e).onCard(V.id),
              "is-new": Date.now() - V.createdAt < 4e3,
              "is-on": o.value && o.value.it.id === V.id
            }]),
            "data-testid": "studio-item-" + V.kind,
            draggable: V.status === "done",
            onMouseenter: (Z) => X(V, Z),
            onMouseleave: O,
            onClick: (Z) => P(V),
            onDragstart: (Z) => R(V, Z),
            onDragend: se[4] || (se[4] = //@ts-ignore
            (...Z) => m(Df) && m(Df)(...Z))
          }, [
            u("span", $xe, [
              V.status === "done" ? (g(), Ce(ao, {
                key: 0,
                item: V
              }, null, 8, ["item"])) : V.status === "failed" ? (g(), b("span", Dxe, [
                C($, {
                  name: "AlertCircle",
                  size: 16
                })
              ])) : V.status === "pending" ? (g(), Ce(N1, {
                key: 2,
                class: "sv-cell-time",
                since: V.result && V.result.startedAt || V.createdAt
              }, null, 8, ["since"])) : z("", !0)
            ]),
            V.kind === "ref" ? (g(), b("span", {
              key: 0,
              class: "sv-cell-how",
              title: _(V) ? V.made.label : m(xl)[V.how || "upload"].text
            }, [
              C($, {
                name: m(xl)[V.how || "upload"].icon,
                size: 10
              }, null, 8, ["name"])
            ], 8, Oxe)) : z("", !0),
            y.value && m(e).queued(V.id) ? (g(), b("span", {
              key: 1,
              class: "sv-cell-q",
              title: "Image " + m(e).queued(V.id) + " in the queue"
            }, E(m(e).queued(V.id)), 9, Lxe)) : z("", !0),
            m(e).marked(V.id) ? (g(), b("span", Bxe, [
              C($, {
                name: "Pencil",
                size: 9
              })
            ])) : z("", !0),
            v.value && m(e).onCard(V.id) ? (g(), b("span", Fxe, [
              C($, {
                name: "LayoutGrid",
                size: 9
              }),
              se[8] || (se[8] = u("span", { class: "tx" }, "On the board", -1))
            ])) : z("", !0),
            !m(n).pinned && V.status === "done" && m(t).isPinnedImage(V.url) ? (g(), b("span", {
              key: 4,
              class: "sv-cell-pin",
              title: m(Xn).badge
            }, [
              C($, {
                name: "Pin",
                size: 10
              })
            ], 8, Nxe)) : z("", !0),
            u("span", Uxe, E(T(V)), 1),
            m(n).dropper && V.status === "done" ? (g(), b("span", {
              key: 5,
              class: G(["sv-cell-drop", { "is-in": !A(V).adds }]),
              "aria-hidden": "true"
            }, [
              C($, {
                name: A(V).adds ? "Pipette" : "Check",
                size: 11
              }, null, 8, ["name"]),
              J(E(A(V).text), 1)
            ], 2)) : z("", !0)
          ], 42, zxe))), 128)),
          m(n).pinned && !l.value.length ? (g(), Ce(U1, { key: 0 })) : l.value.length ? z("", !0) : (g(), b("div", Gxe, E(h.value ? "What you make on this board, and the images you bring in, collect here." : "Nothing from " + f.value + " yet."), 1))
        ], 36)
      ], 8, _xe),
      o.value ? (g(), Ce(kxe, {
        key: 0,
        item: o.value.it,
        style: ce({ top: o.value.top + "px", width: o.value.w + "px", height: o.value.h + "px" }),
        onMouseenter: D,
        onMouseleave: O,
        onDone: F
      }, null, 8, ["item", "style"])) : z("", !0)
    ], 34));
  }
}), Vxe = 700;
function cx(i = () => !0) {
  const e = /* @__PURE__ */ K(!1);
  let t = 0, n = !1;
  const s = () => {
    clearTimeout(t), e.value = !1;
  }, o = (d) => n || !d.dataTransfer || !Array.from(d.dataTransfer.types).includes("Files") || !i() ? !1 : (e.value = !0, clearTimeout(t), t = window.setTimeout(s, Vxe), !0), r = (d) => {
    const c = d.currentTarget;
    if (!c) return s();
    const h = d.relatedTarget;
    if (h) {
      c.contains(h) || s();
      return;
    }
    const f = c.getBoundingClientRect(), p = d.clientX, y = d.clientY;
    (p === 0 && y === 0 || p <= f.left || p >= f.right - 1 || y <= f.top || y >= f.bottom - 1) && s();
  }, a = () => {
    n = !0;
  }, l = () => {
    n = !1, s();
  };
  return ot(() => {
    window.addEventListener("dragstart", a, !0), window.addEventListener("dragend", l, !0), window.addEventListener("drop", l, !0), window.addEventListener("blur", s);
  }), We(() => {
    clearTimeout(t), window.removeEventListener("dragstart", a, !0), window.removeEventListener("dragend", l, !0), window.removeEventListener("drop", l, !0), window.removeEventListener("blur", s);
  }), { active: e, over: o, leave: r, stop: s };
}
const Wxe = {
  class: "sv-ambient",
  "aria-hidden": "true"
}, qxe = { class: "sv-top" }, Kxe = { class: "sv-title" }, Yxe = { class: "eyebrow" }, Xxe = ["title"], Jxe = ["title"], Zxe = { class: "ic" }, Qxe = {
  key: 1,
  class: "sv-pos",
  "data-testid": "studio-position"
}, ewe = ["title"], twe = {
  class: "sv-studios",
  "aria-label": "Studios"
}, nwe = ["aria-selected", "disabled", "title", "data-testid", "onClick"], iwe = {
  key: "generate",
  class: "sv-modes ed-tools",
  role: "radiogroup",
  "aria-label": "Generate with"
}, swe = ["title", "aria-checked", "data-testid", "onClick"], owe = { class: "lbl" }, rwe = ["data-testid"], awe = {
  key: 1,
  class: "sv-tools-hint"
}, lwe = {
  key: 2,
  class: "sv-tools-hint"
}, dwe = {
  key: 3,
  class: "sv-tools-hint"
}, cwe = { class: "sv-main" }, uwe = {
  key: 0,
  class: "bd-dropper sv-dropper",
  role: "status",
  "data-testid": "studio-dropper-banner"
}, hwe = { class: "bd-dropper-mark" }, pwe = { class: "bd-dropper-text" }, fwe = {
  class: "bd-dropper-count",
  "data-testid": "studio-dropper-count"
}, mwe = {
  key: 0,
  class: "sv-dropping"
}, gwe = /* @__PURE__ */ Pe({
  __name: "StudiosView",
  setup(i) {
    const { board: e } = Ze(), t = e.ui.studio, n = L0(e, t.sessionId);
    Ppe(n);
    const s = n.s, o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(0), l = I(() => e.ui.library.open && !!e.ui.library.inStudio);
    let d = null;
    Ae(r, (ge) => {
      d && d.disconnect(), d = null, ge && (d = new ResizeObserver(() => {
        a.value = ge.offsetHeight + 30;
      }), d.observe(ge));
    });
    const c = /* @__PURE__ */ K(null), h = /* @__PURE__ */ K(null);
    Ae(() => e.ui.studio && e.ui.studio.n, () => {
      const ge = e.ui.studio;
      !ge || ge.sessionId !== n.sessionId || n.enter(ge.elementId || ge.resultId ? { elementId: ge.elementId, resultId: ge.resultId } : null);
    }, { immediate: !0 });
    const f = [
      { id: "prompt", label: "Prompt", icon: "Wand2", side: "generate", tip: "Say what you want: a new image, or one from the images you queue" },
      { id: "threed", label: "3D", icon: "Box", side: "generate", tip: "Find a view of a 3D model and generate from it" },
      { id: "edit", label: "Edit", icon: "Pencil", side: "edit", tip: "Change the image in the viewer" }
    ], p = { edit: "Edit", erase: "Erase", annotate: "Annotate" }, y = [
      { id: "generate", label: "Generate", icon: "Sparkles" },
      { id: "edit", label: "Edit", icon: "Pencil" }
    ], v = I(() => n.session.value), x = I(() => n.stage.value), w = I(() => s.studio === "threed" ? n.model3d.value ? n.model3d.value.name : "3D model" : x.value ? x.value.label : n.video.value ? "New video" : "New image"), S = I(() => {
      const ge = x.value;
      if (!ge || s.studio === "threed") return "";
      const ne = n.names.value.get(ge.id), oe = n.family.value.length;
      return ne ? ne + (oe > 1 ? " of " + oe : "") : "";
    }), M = I(() => {
      if (s.studio !== "edit") return f.find((ne) => ne.id === s.studio).label;
      const ge = ex(n.tools.t.open);
      return ge ? ge.label : p[s.bar];
    }), _ = I(() => n.side.value), T = /* @__PURE__ */ K(s.histShut ? Date.now() : 0);
    Ae(() => s.histShut, (ge) => {
      T.value = ge ? Date.now() : 0;
    });
    const k = I(() => n.shown.value.find((ge) => ge.status === "done" && !!ge.url) || null), P = I(() => s.histShut ? n.shown.value.filter((ge) => ge.status === "done" && (ge.result && ge.result.doneAt || ge.createdAt) > T.value).length : 0);
    Ae(_, () => {
      l.value && e.promptLibrary.close();
    });
    const A = I(() => y.find((ge) => ge.id === _.value).label), R = I(() => n.video.value ? y.filter((ge) => ge.id === "generate") : y), D = I(() => f.filter((ge) => ge.side === _.value && (!n.video.value || ge.id === "prompt"))), O = I(() => n.video.value ? "Say what you want: a new video, or one that starts from the pictures you queue" : f[0].tip);
    function F(ge) {
      if (!n.canUse(ge)) {
        n.say("Pick an image to edit: one from history, or make one");
        return;
      }
      n.setStudio(ge);
    }
    function te(ge) {
      ge !== _.value && (ge === "generate" ? n.tools.close(() => n.setSide(ge)) : n.setSide(ge));
    }
    function ee() {
      n.tools.close(() => {
        n.leave(), e.closeStudio();
      });
    }
    function me() {
      const ge = v.value;
      n.tools.close(() => {
        n.leave(), e.closeStudio(), ge && e.openSession(ge);
      });
    }
    function L() {
      c.value && c.value.click();
    }
    function N() {
      h.value && h.value.click();
    }
    function X(ge) {
      const ne = ge.target, oe = Array.from(ne.files || []);
      ne.value = "";
      for (const ye of oe) n.addUpload(ye);
    }
    function B(ge) {
      const ne = ge.target, oe = (ne.files || [])[0];
      ne.value = "", oe && n.addModelFile(oe);
    }
    const se = /* @__PURE__ */ K(null);
    function V() {
      se.value && se.value.click();
    }
    function Z(ge) {
      const ne = ge.target, oe = ne.files && ne.files[0];
      ne.value = "", oe && n.bringInVideo(oe);
    }
    function Y() {
      e.openLibrary({
        purpose: "pick",
        max: 1,
        kinds: ["3d"],
        confirmLabel: "Use this model",
        onPick: (ge) => {
          ge[0] && n.addModelFromLibrary(ge[0]);
        }
      });
    }
    const H = I(() => o.value && o.value.model || null), re = (ge) => {
      H.value && H.value.fly(ge);
    };
    async function le(ge = !1) {
      const ne = H.value;
      if (!ne) return !1;
      let oe;
      try {
        oe = await ne.capture();
      } catch (ye) {
        return console.warn("[board] view not captured", ye), n.say("The view couldn't be captured"), !1;
      }
      return oe ? !!await n.captureView(oe, ge) : !1;
    }
    const he = () => le(!1), Re = I(() => s.studio === "threed" && n.model3d.value ? () => le(!0) : null), Ne = I(() => {
      if (_.value !== "edit") return Math.min(n.queueItems.value.length, n.limit.value) + " of " + n.limit.value;
      const ge = n.refRoom(), ne = n.editRefItems.value.filter((oe) => oe.id !== s.stageId).length;
      return Math.min(ne, ge) + " of " + ge;
    });
    function Me(ge) {
      if (e.ui.libraryOpen) return;
      if (l.value) {
        ge.key === "Escape" && (ge.preventDefault(), e.promptLibrary.back());
        return;
      }
      const ne = ge.target, oe = !!ne && (ne.tagName === "INPUT" || ne.tagName === "TEXTAREA" || ne.isContentEditable);
      if (ge.key === "Escape") {
        if (n.tools.t.guard) return;
        e.ui.infoAt ? e.ui.infoAt = null : s.dropper ? n.setDropper(!1) : s.editingPin ? n.commitPin(s.editingPin) : oe ? ne.blur() : _.value === "edit" && s.bar === "annotate" && s.selection.length ? n.select([]) : n.tools.t.compare ? n.tools.compare(null) : n.tools.t.open ? n.tools.close() : ee(), ge.preventDefault();
        return;
      }
      if (!e.ui.infoAt && !n.tools.t.guard && o.value && o.value.zoomKey(ge, oe)) {
        ge.preventDefault();
        return;
      }
      if (e.ui.infoAt || oe || n.tools.t.guard) return;
      const ye = _.value === "edit", Oe = ge.key.toLowerCase();
      if (ye && kn(ge) && (Oe === "y" || Oe === "z" && ge.shiftKey)) {
        ge.preventDefault(), n.redoMark();
        return;
      }
      if (ye && kn(ge) && Oe === "z") {
        ge.preventDefault(), n.undoMark();
        return;
      }
      if ((ge.key === "Delete" || ge.key === "Backspace") && !kn(ge) && !ge.altKey && !n.tools.t.open && !(ye && s.bar === "annotate" && s.selection.length)) {
        const Ue = s.peekId || s.stageId;
        if (Ue && n.canDelete(Ue)) {
          ge.preventDefault(), n.deleteItem(Ue);
          return;
        }
      }
      if (!ye || n.tools.t.open || kn(ge) || ge.altKey) return;
      if (Oe === "m" || Oe === "x" || Oe === "n" && s.bar !== "annotate") {
        ge.preventDefault(), n.setBar(Oe === "m" ? "edit" : Oe === "x" ? "erase" : "annotate");
        return;
      }
      if (Oe === "i") {
        ge.preventDefault(), n.setDropper(!s.dropper);
        return;
      }
      if (s.bar !== "annotate") {
        const Ue = { b: "brush", l: "lasso", s: "object" }[Oe];
        if (Ue) {
          s.areaTool = Ue;
          return;
        }
        if (ge.key === "[" || ge.key === "]") {
          s.areaSize = Math.max(6, Math.min(200, Math.round(s.areaSize * (ge.key === "]" ? 1.2 : 1 / 1.2))));
          return;
        }
        return;
      }
      if ((ge.key === "Delete" || ge.key === "Backspace") && s.selection.length) {
        ge.preventDefault(), n.deleteStrokes(s.selection.slice());
        return;
      }
      const Ve = { v: "move", b: "brush", t: "text", r: "box", o: "ellipse", a: "arrow", e: "eraser", n: "note" }[Oe];
      Ve && (n.finishEditing(), s.tool = Ve, Ve !== "move" && n.select([]));
    }
    const { active: ue, over: U, leave: q, stop: ie } = cx();
    function de(ge) {
      U(ge) && (ge.preventDefault(), ge.stopPropagation());
    }
    function pe(ge) {
      if (ie(), !!ge.dataTransfer) {
        ge.preventDefault(), ge.stopPropagation();
        for (const ne of Array.from(ge.dataTransfer.files || []).filter((oe) => oe.type.startsWith("image/")).slice(0, 14)) Te(ne);
      }
    }
    function Te(ge) {
      _.value === "edit" ? n.addUploadRef(ge) : n.addUpload(ge);
    }
    function Be(ge) {
      if (e.ui.libraryOpen) return;
      const ne = ge.target;
      if (ne && (ne.tagName === "INPUT" || ne.tagName === "TEXTAREA")) return;
      const oe = Array.from(ge.clipboardData && ge.clipboardData.files || []).filter((ye) => ye.type.startsWith("image/"));
      if (oe.length) {
        ge.preventDefault();
        for (const ye of oe) Te(ye);
      }
    }
    return ot(() => {
      window.addEventListener("keydown", Me), window.addEventListener("paste", Be);
    }), We(() => {
      window.removeEventListener("keydown", Me), window.removeEventListener("paste", Be), l.value && e.promptLibrary.close(), d && d.disconnect();
    }), (ge, ne) => (g(), b("div", {
      class: G(["sv-root", ["in-" + m(s).studio, "side-" + _.value, { "is-dropper": m(s).dropper, "hist-shut": m(s).histShut }]]),
      "data-testid": "studios-view",
      onPointerdown: ne[3] || (ne[3] = Se((oe) => m(s).editingPin && m(n).commitPin(m(s).editingPin), ["self"])),
      onDragover: de,
      onDragleave: ne[4] || (ne[4] = //@ts-ignore
      (...oe) => m(q) && m(q)(...oe)),
      onDrop: pe
    }, [
      u("div", Wxe, [
        x.value && x.value.url && m(s).studio !== "threed" ? (g(), b("span", {
          key: x.value.url,
          style: ce({ backgroundImage: 'url("' + x.value.url + '")' })
        }, null, 4)) : z("", !0)
      ]),
      u("header", qxe, [
        u("button", {
          class: "sv-back",
          title: "Back to the board (Esc)",
          "data-testid": "studio-back",
          onClick: ee
        }, [
          C($, {
            name: "ArrowLeft",
            size: 15
          })
        ]),
        u("div", Kxe, [
          u("span", Yxe, [
            J(E(A.value), 1),
            M.value !== A.value ? (g(), b(j, { key: 0 }, [
              J(" · " + E(M.value), 1)
            ], 64)) : z("", !0)
          ]),
          u("span", {
            class: "name",
            title: w.value
          }, E(w.value), 9, Xxe)
        ]),
        v.value ? (g(), b("button", {
          key: 0,
          type: "button",
          class: "sv-session",
          title: "Back to the board, on " + v.value.name,
          "data-testid": "studio-session",
          onClick: me
        }, [
          ne[5] || (ne[5] = u("span", { class: "lb" }, "Session", -1)),
          u("span", Zxe, [
            C($, {
              name: v.value.icon || "Image",
              size: 12
            }, null, 8, ["name"])
          ]),
          u("b", null, E(v.value.name), 1)
        ], 8, Jxe)) : z("", !0),
        ne[7] || (ne[7] = u("span", { class: "sv-grow" }, null, -1)),
        S.value ? (g(), b("span", Qxe, E(S.value), 1)) : z("", !0),
        x.value && x.value.kind === "gen" && x.value.status === "done" && m(s).studio !== "threed" ? (g(), b("button", {
          key: 2,
          class: "sv-top-btn",
          title: "Its details, large",
          "data-testid": "studio-details",
          onClick: ne[0] || (ne[0] = (oe) => m(n).openInfo(x.value.id))
        }, [
          C($, {
            name: "Info",
            size: 14
          }),
          ne[6] || (ne[6] = J(" Details", -1))
        ])) : z("", !0),
        C(vt, { name: "sv-hist-show" }, {
          default: Xe(() => [
            m(s).histShut ? (g(), b("button", {
              key: "pill" + P.value,
              class: G(["sv-top-btn sv-hist-show", { "is-new": P.value > 0 }]),
              title: P.value ? P.value + " new since you folded it: show history" : "Show history",
              "aria-label": "Show history",
              "data-testid": "studio-history-show",
              onClick: ne[1] || (ne[1] = (oe) => m(n).setHistShut(!1))
            }, [
              k.value ? (g(), b("span", {
                key: 0,
                class: "sh",
                style: ce({ backgroundImage: 'url("' + m(Bt)(k.value.url) + '")' })
              }, null, 4)) : (g(), Ce($, {
                key: 1,
                name: "PanelRightOpen",
                size: 14
              })),
              u("span", null, E(m(s).pinned ? "Pinned" : "History"), 1),
              u("span", {
                class: G(["n", { "is-new": P.value > 0 }])
              }, E(P.value ? "+" + P.value : m(n).shown.value.length), 3)
            ], 10, ewe)) : z("", !0)
          ]),
          _: 1
        }),
        u("button", {
          class: "sv-close",
          title: "Close (Esc)",
          "data-testid": "studio-close",
          onClick: ee
        }, [
          C($, {
            name: "X",
            size: 16
          })
        ])
      ]),
      u("nav", twe, [
        u("div", {
          class: "sv-seg is-text sv-sides ed-slide",
          role: "tablist",
          "aria-label": "Generate or edit",
          style: ce({ "--i": Math.max(0, R.value.findIndex((oe) => oe.id === _.value)), "--n": R.value.length })
        }, [
          (g(!0), b(j, null, be(R.value, (oe) => (g(), b("button", {
            key: oe.id,
            role: "tab",
            "aria-selected": _.value === oe.id,
            class: G({ on: _.value === oe.id }),
            disabled: oe.id === "edit" && _.value !== "edit" && !m(n).canEdit(),
            title: oe.id === "edit" ? "Change an image: say what to change, select an area, annotate it, or use a tool" : m(n).video.value ? "Make videos: from a prompt, and the pictures they start from" : "Make images: from a prompt, or a 3D view",
            "data-testid": "studio-side-" + oe.id,
            onClick: (ye) => te(oe.id)
          }, [
            C($, {
              name: oe.icon,
              size: 13
            }, null, 8, ["name"]),
            J(" " + E(oe.label), 1)
          ], 10, nwe))), 128))
        ], 4),
        C(vt, {
          name: "ed-side",
          mode: "out-in"
        }, {
          default: Xe(() => [
            _.value === "edit" ? (g(), Ce(Qye, { key: "edit" })) : (g(), b("div", iwe, [
              (g(!0), b(j, null, be(D.value, (oe) => (g(), b("section", {
                key: oe.id,
                class: G(["ed-tool", { on: m(s).studio === oe.id }])
              }, [
                u("button", {
                  class: "ed-tool-head",
                  role: "radio",
                  title: oe.id === "prompt" ? O.value : oe.tip,
                  "aria-checked": m(s).studio === oe.id,
                  "data-testid": "studio-pick-" + oe.id,
                  onClick: (ye) => F(oe.id)
                }, [
                  C(ym, {
                    on: m(s).studio === oe.id
                  }, null, 8, ["on"]),
                  C($, {
                    name: oe.icon,
                    size: 15,
                    class: "ic"
                  }, null, 8, ["name"]),
                  u("span", owe, E(oe.label), 1)
                ], 8, swe),
                m(s).studio === oe.id ? (g(), b("div", {
                  key: 0,
                  class: "ed-tool-body is-plain",
                  "data-testid": "studio-panel-" + oe.id
                }, [
                  oe.id === "threed" ? (g(), Ce(cxe, {
                    key: 0,
                    fly: re,
                    capture: he,
                    onUploadModel: N,
                    onLibraryModel: Y
                  })) : m(n).videoField() ? (g(), b("p", awe, "Choose the video to edit in the box below, then say what to change.")) : m(n).video.value ? (g(), b("p", lwe, "Say what you want in the box below. Queue pictures there for the video to start from, image 1 first.")) : (g(), b("p", dwe, "Say what you want in the box below. Queue images there to start from them, image 1 first; their annotations and notes go with them."))
                ], 8, rwe)) : z("", !0)
              ], 2))), 128))
            ]))
          ]),
          _: 1
        })
      ]),
      u("main", cwe, [
        C(vt, { name: "bd-dropper" }, {
          default: Xe(() => [
            m(s).dropper ? (g(), b("div", uwe, [
              u("span", hwe, [
                C($, {
                  name: "Pipette",
                  size: 13
                })
              ]),
              u("span", pwe, E(_.value === "edit" ? "Click a picture in history to send it with the edit" : "Click a picture in history to add it to the next image"), 1),
              u("span", fwe, E(Ne.value), 1),
              u("button", {
                class: "bd-dropper-done",
                title: "Done (Esc)",
                "data-testid": "studio-dropper-done",
                onClick: ne[2] || (ne[2] = (oe) => m(n).setDropper(!1))
              }, "Done")
            ])) : z("", !0)
          ]),
          _: 1
        }),
        C(Sme, {
          ref_key: "stageRef",
          ref: o,
          onUpload: L,
          onUploadModel: N,
          onLibraryModel: Y,
          onUploadVideo: V
        }, null, 512),
        l.value && _.value === "generate" ? (g(), b("div", {
          key: 0,
          class: "sv-pl-float",
          style: ce({ bottom: a.value + "px" })
        }, [
          C(Xy, { floating: "" })
        ], 4)) : z("", !0),
        _.value === "generate" ? (g(), b("div", {
          key: 1,
          ref_key: "dockEl",
          ref: r,
          class: "sv-dock"
        }, [
          C(vt, { name: "sv-note" }, {
            default: Xe(() => [
              m(s).note ? (g(), b("div", {
                key: m(s).note.id,
                class: "sv-note",
                role: "status"
              }, E(m(s).note.text), 1)) : z("", !0)
            ]),
            _: 1
          }),
          C(Yme),
          C(Pbe, {
            before: Re.value,
            label: Re.value ? "Run from view" : null
          }, null, 8, ["before", "label"])
        ], 512)) : (g(), Ce(Wve, { key: 2 }))
      ]),
      C(Hxe),
      m(ue) ? (g(), b("div", mwe, [
        u("div", null, [
          C($, {
            name: "ImagePlus",
            size: 18
          }),
          J(" " + E(_.value === "edit" ? "Drop images to send them with the edit" : "Drop images to add them to the queue"), 1)
        ])
      ])) : z("", !0),
      u("input", {
        ref_key: "imageInput",
        ref: c,
        type: "file",
        accept: "image/*",
        multiple: "",
        style: { display: "none" },
        onChange: X
      }, null, 544),
      u("input", {
        ref_key: "modelInput",
        ref: h,
        type: "file",
        accept: ".glb,.gltf,.obj,.stl",
        style: { display: "none" },
        onChange: B
      }, null, 544),
      u("input", {
        ref_key: "videoInput",
        ref: se,
        type: "file",
        accept: "video/*",
        style: { display: "none" },
        onChange: Z
      }, null, 544)
    ], 34));
  }
}), bwe = ["disabled"], vwe = ["disabled"], ywe = { class: "lb-peek-shell" }, xwe = { class: "lb-peek-stage" }, wwe = {
  key: 0,
  class: "lb-peek-withheld"
}, kwe = { class: "lb-empty-mark is-warn" }, _we = ["src", "poster"], Swe = ["src"], Mwe = { class: "lb-peek-side" }, Twe = { class: "lb-peek-top" }, Cwe = { class: "n" }, Iwe = ["title", "aria-pressed"], Awe = ["title", "aria-pressed"], Pwe = ["title"], Ewe = {
  key: 0,
  class: "lb-peek-confirm"
}, Rwe = { class: "lb-peek-block" }, zwe = { class: "lb-peek-head" }, $we = { class: "lb-peek-prompt" }, Dwe = { class: "lb-peek-specs" }, Owe = { key: 0 }, Lwe = { key: 1 }, Bwe = { key: 2 }, Fwe = {
  key: 0,
  class: "lb-peek-acts"
}, Nwe = ["disabled"], Uwe = /* @__PURE__ */ Pe({
  __name: "LibraryPeek",
  props: {
    lib: {},
    item: {},
    placing: { type: Boolean },
    single: { type: Boolean },
    model: {}
  },
  emits: ["close", "pick", "star", "remove"],
  setup(i, { emit: e }) {
    const t = i, n = e, { board: s } = Ze(), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(""), a = /* @__PURE__ */ K(!1), l = I(() => t.lib.shown.value), d = I(() => l.value.findIndex((_) => _.id === t.item.id)), c = I(() => t.lib.order(t.item.id)), h = I(() => t.item.w && t.item.h ? t.item.w + " × " + t.item.h : ""), f = I(() => t.lib.faved(t.item)), p = I(() => s.isPinnedImage(t.item.url));
    Ae(() => t.item.id, () => {
      a.value = !1;
    });
    function y(_) {
      const T = l.value.length;
      T < 2 || d.value < 0 || (t.lib.s.peek = l.value[(d.value + _ + T) % T]);
    }
    async function v() {
      if (t.item.prompt)
        try {
          await navigator.clipboard.writeText(t.item.prompt), o.value = !0, window.setTimeout(() => {
            o.value = !1;
          }, 1400);
        } catch {
        }
    }
    function x() {
      const _ = t.item, T = _.video && _.videoSrc ? _.videoSrc : _.url, k = (/(\.\w{3,4})(\?|$)/.exec(T.replace(/%2F/gi, "/")) || ["", _.video ? ".mp4" : ".webp"])[1], P = _.run ? df(_.prompt || "", _.run.uuid, T) : _.label.replace(/\.[a-z0-9]+$/i, "") + k;
      s.saveFile(T, P);
    }
    function w() {
      if (!a.value) {
        a.value = !0;
        return;
      }
      a.value = !1, n("remove", t.item);
    }
    function S() {
      s.placeFromLibrary([t.item]), s.closeLibrary();
    }
    function M(_) {
      const T = _.target;
      T && (T.tagName === "INPUT" || T.tagName === "TEXTAREA") || (_.key === "ArrowLeft" ? (_.preventDefault(), y(-1)) : _.key === "ArrowRight" && (_.preventDefault(), y(1)));
    }
    return ot(() => window.addEventListener("keydown", M)), We(() => window.removeEventListener("keydown", M)), (_, T) => (g(), b("div", {
      class: "lb-peek",
      "data-testid": "library-peek",
      onPointerdown: T[8] || (T[8] = Se((k) => n("close"), ["self"]))
    }, [
      u("button", {
        class: "lb-peek-nav at-left",
        title: "Previous (←)",
        disabled: l.value.length < 2,
        onClick: T[0] || (T[0] = (k) => y(-1))
      }, [
        C($, {
          name: "ChevronLeft",
          size: 20
        })
      ], 8, bwe),
      u("button", {
        class: "lb-peek-nav at-right",
        title: "Next (→)",
        disabled: l.value.length < 2,
        onClick: T[1] || (T[1] = (k) => y(1))
      }, [
        C($, {
          name: "ChevronRight",
          size: 20
        })
      ], 8, vwe),
      u("div", ywe, [
        u("div", xwe, [
          i.item.moderated ? (g(), b("div", wwe, [
            u("span", kwe, [
              C($, {
                name: "EyeOff",
                size: 20
              })
            ]),
            T[9] || (T[9] = u("b", null, "Moderated by RunDiffusion", -1)),
            T[10] || (T[10] = u("span", null, "This image was flagged by our moderation system. This can happen because of NSFW, copyright, gore, or other related reasons. This system is currently a work in progress, please have patience as we work to improve it.", -1))
          ])) : i.item.video && i.item.videoSrc ? (g(), b("video", {
            key: i.item.videoSrc,
            class: "lb-peek-art",
            src: i.item.videoSrc,
            poster: i.item.url,
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            controls: "",
            controlslist: "nodownload noplaybackrate",
            disablepictureinpicture: ""
          }, null, 8, _we)) : (g(), b("img", {
            key: i.item.url,
            class: G(["lb-peek-art", { "is-loading": r.value !== i.item.url }]),
            src: i.item.url,
            alt: "",
            draggable: "false",
            onLoad: T[2] || (T[2] = (k) => r.value = i.item.url)
          }, null, 42, Swe))
        ]),
        u("aside", Mwe, [
          u("div", Twe, [
            u("span", Cwe, [
              C($, {
                name: "Images",
                size: 13
              }),
              J(" " + E(d.value >= 0 ? d.value + 1 : "–") + " of " + E(l.value.length), 1)
            ]),
            T[11] || (T[11] = u("span", { class: "lb-grow" }, null, -1)),
            i.item.moderated ? z("", !0) : (g(), b("button", {
              key: 0,
              class: G(["lb-peek-act lb-peek-pin", { on: p.value }]),
              title: p.value ? m(Xn).unpin : m(Xn).pin,
              "aria-pressed": p.value,
              "data-testid": "library-peek-pin",
              onClick: T[3] || (T[3] = (k) => m(s).togglePinImage(m(nU)(i.item)))
            }, [
              C($, {
                name: "Pin",
                size: 14
              })
            ], 10, Iwe)),
            i.lib.canStar(i.item) ? (g(), b("button", {
              key: 1,
              class: G(["lb-peek-act lb-peek-star", { on: f.value }]),
              title: f.value ? "Remove from your favorites" : "Add to your favorites",
              "aria-pressed": f.value,
              "data-testid": "library-peek-star",
              onClick: T[4] || (T[4] = (k) => n("star", i.item))
            }, [
              C($, {
                name: "Heart",
                size: 14
              })
            ], 10, Awe)) : z("", !0),
            i.item.moderated ? z("", !0) : (g(), b("button", {
              key: 2,
              class: "lb-peek-act",
              title: "Download",
              "data-testid": "library-peek-download",
              onClick: x
            }, [
              C($, {
                name: "Download",
                size: 14
              })
            ])),
            i.lib.canRemove(i.item) ? (g(), b("button", {
              key: 3,
              class: G(["lb-peek-act is-danger", { "is-confirming": a.value }]),
              title: a.value ? "Click again to delete it for good" : i.item.uploadId ? "Delete this upload" : "Delete this generation",
              "data-testid": "library-peek-delete",
              onClick: w,
              onBlur: T[5] || (T[5] = (k) => a.value = !1)
            }, [
              C($, {
                name: a.value ? "Check" : "Trash2",
                size: 14
              }, null, 8, ["name"]),
              a.value ? (g(), b("span", Ewe, "Delete?")) : z("", !0)
            ], 42, Pwe)) : z("", !0),
            u("button", {
              class: "lb-peek-act",
              title: "Back to your Library (Esc)",
              "data-testid": "library-peek-close",
              onClick: T[6] || (T[6] = (k) => n("close"))
            }, [
              C($, {
                name: "X",
                size: 15
              })
            ])
          ]),
          u("div", Rwe, [
            u("div", zwe, [
              u("span", null, [
                C($, {
                  name: "MessageSquare",
                  size: 13
                }),
                J(" " + E(i.item.prompt ? "Prompt" : "Name"), 1)
              ]),
              i.item.prompt ? (g(), b("button", {
                key: 0,
                title: "Copy the prompt",
                onClick: v
              }, [
                C($, {
                  name: o.value ? "Check" : "Clipboard",
                  size: 13
                }, null, 8, ["name"])
              ])) : z("", !0)
            ]),
            u("p", $we, E(i.item.prompt || i.item.label), 1)
          ]),
          u("dl", Dwe, [
            i.model ? (g(), b("div", Owe, [
              T[12] || (T[12] = u("dt", null, "Model", -1)),
              u("dd", null, E(i.model), 1)
            ])) : z("", !0),
            i.item.createdAt ? (g(), b("div", Lwe, [
              u("dt", null, E(i.item.uploadId ? "Uploaded" : "Made"), 1),
              u("dd", null, E(m(I1)(i.item.createdAt)), 1)
            ])) : z("", !0),
            h.value ? (g(), b("div", Bwe, [
              T[13] || (T[13] = u("dt", null, "Size", -1)),
              u("dd", null, E(h.value), 1)
            ])) : z("", !0),
            u("div", null, [
              T[14] || (T[14] = u("dt", null, "Kind", -1)),
              u("dd", null, E(i.item.uploadId ? "Upload" : i.item.video ? "Video" : "Image") + E(f.value ? ", a favorite" : ""), 1)
            ])
          ]),
          T[16] || (T[16] = u("span", { class: "lb-grow" }, null, -1)),
          i.item.moderated ? z("", !0) : (g(), b("div", Fwe, [
            u("button", {
              class: G(["lb-btn", c.value ? "is-picked" : ""]),
              disabled: !i.lib.allowed(i.item) || !c.value && i.lib.full() && !i.single,
              "data-testid": "library-peek-pick",
              onClick: T[7] || (T[7] = (k) => n("pick", i.item))
            }, [
              C($, {
                name: c.value ? "Check" : "Plus",
                size: 14
              }, null, 8, ["name"]),
              J(" " + E(i.single ? "Use this one" : c.value ? "Picked (" + c.value + ")" : "Pick"), 1)
            ], 10, Nwe),
            i.placing ? (g(), b("button", {
              key: 0,
              class: "lb-btn is-primary",
              "data-testid": "library-peek-place",
              onClick: S
            }, [
              C($, {
                name: "ArrowDownToLine",
                size: 14
              }),
              T[15] || (T[15] = J(" Place on the board ", -1))
            ])) : z("", !0)
          ]))
        ])
      ])
    ], 32));
  }
}), Gwe = ["data-lb-own-keys"], jwe = ["aria-expanded", "data-testid"], Hwe = { class: "t" }, Vwe = {
  key: 1,
  class: "bd-spinner is-sm"
}, Wwe = {
  key: 0,
  class: "lb-select-pop",
  role: "listbox"
}, qwe = {
  key: 0,
  class: "lb-select-search"
}, Kwe = { class: "lb-select-rows" }, Ywe = ["aria-selected", "onMouseenter", "onClick"], Xwe = { class: "t" }, Jwe = {
  key: 0,
  class: "lb-select-none"
}, Nh = /* @__PURE__ */ Pe({
  __name: "LibrarySelect",
  props: {
    modelValue: { default: void 0 },
    options: {},
    anyText: {},
    icon: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    testid: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = /* @__PURE__ */ K(!1), o = /* @__PURE__ */ K(""), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(0), d = I(() => t.options.find((w) => w.value === t.modelValue) || null), c = I(() => t.options.length > 8), h = I(() => {
      const w = o.value.trim().toLowerCase();
      return w ? t.options.filter((S) => S.text.toLowerCase().includes(w)) : t.options;
    }), f = I(() => [null, ...h.value]);
    function p() {
      s.value = !s.value;
    }
    function y(w) {
      n("update:modelValue", w ? w.value : void 0), s.value = !1;
    }
    function v(w) {
      s.value && (w.key === "Escape" ? (w.preventDefault(), w.stopPropagation(), s.value = !1) : w.key === "ArrowDown" ? (w.preventDefault(), l.value = Math.min(f.value.length - 1, l.value + 1)) : w.key === "ArrowUp" ? (w.preventDefault(), l.value = Math.max(0, l.value - 1)) : w.key === "Enter" && (w.preventDefault(), y(f.value[l.value])));
    }
    function x(w) {
      r.value && !r.value.contains(w.target) && (s.value = !1);
    }
    return Ae(s, (w) => {
      o.value = "", l.value = Math.max(0, f.value.findIndex((S) => (S ? S.value : void 0) === t.modelValue)), w ? (window.addEventListener("pointerdown", x, !0), nt(() => {
        a.value && a.value.focus();
      })) : window.removeEventListener("pointerdown", x, !0);
    }), Ae(o, () => {
      l.value = 0;
    }), We(() => window.removeEventListener("pointerdown", x, !0)), (w, S) => (g(), b("div", {
      ref_key: "root",
      ref: r,
      class: "lb-select-wrap",
      "data-lb-own-keys": s.value ? "" : void 0,
      onKeydown: v
    }, [
      u("button", {
        class: G(["lb-select-btn", { on: s.value, "is-set": !!d.value }]),
        "aria-expanded": s.value,
        "data-testid": i.testid,
        onClick: p
      }, [
        i.icon ? (g(), Ce($, {
          key: 0,
          name: i.icon,
          size: 13
        }, null, 8, ["name"])) : z("", !0),
        u("span", Hwe, E(d.value ? d.value.text : i.anyText), 1),
        i.loading ? (g(), b("span", Vwe)) : (g(), Ce($, {
          key: 2,
          name: "ChevronDown",
          size: 13,
          class: "chev"
        }))
      ], 10, jwe),
      s.value ? (g(), b("div", Wwe, [
        c.value ? (g(), b("label", qwe, [
          C($, {
            name: "Search",
            size: 13
          }),
          kt(u("input", {
            ref_key: "searchEl",
            ref: a,
            "onUpdate:modelValue": S[0] || (S[0] = (M) => o.value = M),
            type: "text",
            spellcheck: "false",
            placeholder: "Find",
            "aria-label": "Find in the list"
          }, null, 512), [
            [Zt, o.value]
          ])
        ])) : z("", !0),
        u("div", Kwe, [
          (g(!0), b(j, null, be(f.value, (M, _) => (g(), b("button", {
            key: M ? M.value : "(any)",
            class: G(["lb-select-row", { on: (M ? M.value : void 0) === i.modelValue, "is-active": _ === l.value, "is-any": !M }]),
            role: "option",
            "aria-selected": (M ? M.value : void 0) === i.modelValue,
            onMouseenter: (T) => l.value = _,
            onClick: (T) => y(M)
          }, [
            u("span", Xwe, E(M ? M.text : i.anyText), 1),
            (M ? M.value : void 0) === i.modelValue ? (g(), Ce($, {
              key: 0,
              name: "Check",
              size: 13
            })) : z("", !0)
          ], 42, Ywe))), 128)),
          h.value.length ? z("", !0) : (g(), b("div", Jwe, "Nothing matches “" + E(o.value.trim()) + "”", 1))
        ])
      ])) : z("", !0)
    ], 40, Gwe));
  }
});
function Zwe(i) {
  return i.model3d ? "3d" : i.video ? "video" : "image";
}
const m4 = { image: ["picture", "pictures"], video: ["video", "videos"], "3d": ["3D model", "3D models"] };
function Qwe(i, e, t) {
  if (t) return "Pick pictures to place on the board";
  const [n, s] = i.length === 1 ? m4[i[0]] : m4.image;
  return e === 1 ? "Pick a " + n : "Pick up to " + e + " " + s;
}
const eke = 2, eA = [
  { value: "1:1", text: "1:1 (Square)" },
  { value: "16:9", text: "16:9 (Landscape)" },
  { value: "2:1", text: "2:1" },
  { value: "3:2", text: "3:2" },
  { value: "4:3", text: "4:3" },
  { value: "21:9", text: "21:9 (Ultrawide)" },
  { value: "9:16", text: "9:16 (Portrait)" },
  { value: "2:3", text: "2:3" },
  { value: "3:4", text: "3:4" },
  { value: "OTHER", text: "Other" }
], tA = [
  { value: "1K", text: "1K (~1024px)" },
  { value: "2K", text: "2K (~2048px)" },
  { value: "4K+", text: "4K+ (4096px and up)" }
];
function xm(i) {
  const e = (i || "").trim();
  return e.length >= eke ? e : "";
}
function nA(i) {
  return Of(i) > 0;
}
function Of(i) {
  if (!i) return 0;
  let e = 0;
  for (const t of ["aspect", "resolution", "tool", "family", "media", "board"]) i[t] && e++;
  return (i.from || i.to) && e++, i.favorited && e++, e;
}
const Xr = 24;
function tke(i, e = {}) {
  const t = e.filters || {}, n = typeof e.cursor == "string" ? e.cursor : null, s = { limit: Xr };
  return n && (s.cursor = n), i === "favorites" ? (s.favorites = !0, s) : (s.filters = {
    aspectRatioFilter: t.aspect || null,
    resolutionFilter: t.resolution || null,
    toolFilter: t.tool || null,
    modelFamilyTagFilter: t.family || null,
    mediaTagFilter: t.media || null,
    dateFromFilter: t.from || null,
    dateToFilter: t.to || null,
    favoriteFilter: t.favorited ? "favorited" : null,
    // a search answers in one page: never sent with a cursor
    searchFilter: n ? null : xm(e.search) || null
  }, t.board && (s.runnitId = t.board), s);
}
function nke(i) {
  switch (i.code) {
    case "ACCOUNT_NOT_MEMBER":
      return "You are not a member of the selected team account";
    case "EMAIL_NOT_VERIFIED":
      return "Verify your email in the web app before filtering team generations";
    case "ANONYMOUS_NOT_ALLOWED":
      return "Sign in with your account to filter generations";
    case "ACCOUNT_NOT_FOUND":
      return "That team account no longer exists";
    case "PERMISSION_DENIED":
      return "You do not have permission to view these generations";
  }
  return i.reason === "unauthorized" ? "Your session expired, please sign in again" : i.reason === "forbidden" ? "You do not have permission to view these generations" : "Could not load filtered generations, please try again";
}
function F0(i, e, t) {
  const n = { storageUrl: e.storageUrl, modelName: e.modelName, authorName: () => "" }, s = [];
  for (const o of lS(i, n)) {
    if (!o.asset || o.status !== "done" && o.status !== "moderated") continue;
    const r = o.asset.nodeRunResult;
    if (r && r.type === "MODEL") continue;
    const a = r && r.file && typeof r.file.name == "string" ? r.file.name : "", l = (/\.([a-z0-9]+)$/i.exec(a) || ["", "glb"])[1].toLowerCase(), d = (t || o.prompt || "").trim();
    s.push({
      id: o.id,
      url: o.url,
      thumb: o.thumb,
      w: o.w,
      h: o.h,
      video: o.kind === "video",
      videoSrc: o.videoSrc,
      model3d: o.kind === "3d" && o.download ? { url: o.download, ext: l } : void 0,
      label: d || o.model || "Generation",
      prompt: d,
      model: o.model || void 0,
      createdAt: o.createdAt,
      moderated: o.status === "moderated" || void 0,
      mine: i.userId === e.uid,
      run: {
        id: i.id,
        uuid: o.uuid || "",
        nodeDefId: i.nodeDefId,
        nodeId: i.nodeId,
        runnitId: i.runnitId,
        type: r && typeof r.type == "string" ? r.type : o.kind === "video" ? "VID" : "IMG"
      },
      asset: o.asset
    });
  }
  return s;
}
function ike(i, e, t) {
  const n = [];
  for (const s of i) {
    const o = {
      id: s.id,
      runnitId: s.board_id || "",
      nodeId: s.node_id || "",
      nodeDefId: s.tool_id || "",
      userId: s.user_id || "",
      teamId: s.team_id,
      email: s.email || void 0,
      state: "DONE",
      initAt: s.init_at ? Date.parse(s.init_at) : void 0,
      doneAt: s.done_at ? Date.parse(s.done_at) : void 0,
      results: s.results || []
    }, r = (a) => e[a] && e[a].title || t.modelName(a);
    n.push(...F0(o, { ...t, modelName: r }, s.prompt));
  }
  return n;
}
const ske = {
  class: "lb-filters",
  "data-testid": "library-filters",
  "aria-label": "Filters"
}, oke = { class: "lb-filters-grid" }, rke = { class: "lb-field is-wide" }, ake = { class: "lb-chips" }, lke = ["title", "data-testid", "onClick"], dke = { class: "lb-field" }, cke = { class: "lb-chips" }, uke = ["title", "onClick"], hke = { class: "lb-field" }, pke = { class: "lb-chips" }, fke = { class: "lb-field" }, mke = { class: "lb-field" }, gke = { class: "lb-field" }, bke = { class: "lb-field" }, vke = { class: "lb-field is-dates" }, yke = { class: "lb-dates" }, xke = ["value", "max"], wke = ["value", "min"], kke = { class: "lb-filters-foot" }, _ke = { class: "lb-filters-count" }, Ske = ["disabled"], Mke = /* @__PURE__ */ Pe({
  __name: "LibraryFilters",
  props: {
    lib: {},
    options: {},
    loading: { type: Boolean }
  },
  setup(i) {
    const e = i, t = e.lib.s, n = I(() => Of(t.draft)), s = I(() => JSON.stringify(o(t.draft)) !== JSON.stringify(o(t.filters)));
    function o(d) {
      const c = {};
      for (const [h, f] of Object.entries(d)) f && (c[h] = f);
      return c;
    }
    function r(d, c) {
      t.draft = { ...t.draft, [d]: c };
    }
    function a(d) {
      const c = /^(\d+):(\d+)$/.exec(d);
      if (!c) return { width: "12px", height: "12px" };
      const h = Number(c[1]) / Number(c[2]), f = 15;
      return h >= 1 ? { width: f + "px", height: Math.max(5, Math.round(f / h)) + "px" } : { width: Math.max(5, Math.round(f * h)) + "px", height: f + "px" };
    }
    function l() {
      e.lib.applyFilters({});
    }
    return (d, c) => (g(), b("section", ske, [
      u("div", oke, [
        u("div", rke, [
          c[13] || (c[13] = u("span", { class: "lb-field-label" }, "Aspect ratio", -1)),
          u("div", ake, [
            u("button", {
              class: G(["lb-chip", { on: !m(t).draft.aspect }]),
              onClick: c[0] || (c[0] = (h) => r("aspect", void 0))
            }, "Any", 2),
            (g(!0), b(j, null, be(m(eA), (h) => (g(), b("button", {
              key: h.value,
              class: G(["lb-chip", { on: m(t).draft.aspect === h.value }]),
              title: h.text,
              "data-testid": "library-aspect-" + h.value,
              onClick: (f) => r("aspect", m(t).draft.aspect === h.value ? void 0 : h.value)
            }, [
              u("i", {
                class: G(["glyph", { "is-other": h.value === "OTHER" }]),
                style: ce(a(h.value))
              }, null, 6),
              J(" " + E(h.value === "OTHER" ? "Other" : h.value), 1)
            ], 10, lke))), 128))
          ])
        ]),
        u("div", dke, [
          c[14] || (c[14] = u("span", { class: "lb-field-label" }, "Resolution", -1)),
          u("div", cke, [
            u("button", {
              class: G(["lb-chip", { on: !m(t).draft.resolution }]),
              onClick: c[1] || (c[1] = (h) => r("resolution", void 0))
            }, "Any", 2),
            (g(!0), b(j, null, be(m(tA), (h) => (g(), b("button", {
              key: h.value,
              class: G(["lb-chip", { on: m(t).draft.resolution === h.value }]),
              title: h.text,
              onClick: (f) => r("resolution", m(t).draft.resolution === h.value ? void 0 : h.value)
            }, E(h.value), 11, uke))), 128))
          ])
        ]),
        u("div", hke, [
          c[16] || (c[16] = u("span", { class: "lb-field-label" }, "Show", -1)),
          u("div", pke, [
            u("button", {
              class: G(["lb-chip", { on: !m(t).draft.favorited }]),
              onClick: c[2] || (c[2] = (h) => r("favorited", void 0))
            }, "All", 2),
            u("button", {
              class: G(["lb-chip", { on: !!m(t).draft.favorited }]),
              "data-testid": "library-only-favorites",
              onClick: c[3] || (c[3] = (h) => r("favorited", !0))
            }, [
              C($, {
                name: "Heart",
                size: 12
              }),
              c[15] || (c[15] = J(" Favorited", -1))
            ], 2)
          ])
        ]),
        u("div", fke, [
          c[17] || (c[17] = u("span", { class: "lb-field-label" }, "Tool", -1)),
          C(Nh, {
            "model-value": m(t).draft.tool,
            options: i.options ? i.options.tools : [],
            "any-text": "Any tool",
            icon: "Wand2",
            loading: i.loading && !i.options,
            testid: "library-filter-tool",
            "onUpdate:modelValue": c[4] || (c[4] = (h) => r("tool", h))
          }, null, 8, ["model-value", "options", "loading"])
        ]),
        u("div", mke, [
          c[18] || (c[18] = u("span", { class: "lb-field-label" }, "Model family", -1)),
          C(Nh, {
            "model-value": m(t).draft.family,
            options: i.options ? i.options.families : [],
            "any-text": "Any family",
            icon: "Layers",
            loading: i.loading && !i.options,
            "onUpdate:modelValue": c[5] || (c[5] = (h) => r("family", h))
          }, null, 8, ["model-value", "options", "loading"])
        ]),
        u("div", gke, [
          c[19] || (c[19] = u("span", { class: "lb-field-label" }, "Media", -1)),
          C(Nh, {
            "model-value": m(t).draft.media,
            options: i.options ? i.options.media : [],
            "any-text": "Any media",
            icon: "Images",
            loading: i.loading && !i.options,
            "onUpdate:modelValue": c[6] || (c[6] = (h) => r("media", h))
          }, null, 8, ["model-value", "options", "loading"])
        ]),
        u("div", bke, [
          c[20] || (c[20] = u("span", { class: "lb-field-label" }, "Board", -1)),
          C(Nh, {
            "model-value": m(t).draft.board,
            options: i.options ? i.options.boards : [],
            "any-text": "Any board",
            icon: "LayoutGrid",
            loading: i.loading && !i.options,
            "onUpdate:modelValue": c[7] || (c[7] = (h) => r("board", h))
          }, null, 8, ["model-value", "options", "loading"])
        ]),
        u("div", vke, [
          c[22] || (c[22] = u("span", { class: "lb-field-label" }, "Made between", -1)),
          u("div", yke, [
            u("input", {
              value: m(t).draft.from || "",
              type: "date",
              max: m(t).draft.to || void 0,
              "aria-label": "From",
              "data-testid": "library-from",
              onInput: c[8] || (c[8] = (h) => r("from", h.target.value || void 0))
            }, null, 40, xke),
            c[21] || (c[21] = u("span", { class: "to" }, "to", -1)),
            u("input", {
              value: m(t).draft.to || "",
              type: "date",
              min: m(t).draft.from || void 0,
              "aria-label": "To",
              "data-testid": "library-to",
              onInput: c[9] || (c[9] = (h) => r("to", h.target.value || void 0))
            }, null, 40, wke),
            m(t).draft.from || m(t).draft.to ? (g(), b("button", {
              key: 0,
              class: "lb-dates-x",
              title: "Clear the dates",
              onClick: c[10] || (c[10] = (h) => m(t).draft = { ...m(t).draft, from: void 0, to: void 0 })
            }, [
              C($, {
                name: "X",
                size: 11
              })
            ])) : z("", !0)
          ])
        ])
      ]),
      u("footer", kke, [
        u("span", _ke, E(n.value ? n.value + (n.value === 1 ? " filter" : " filters") : "No filters"), 1),
        n.value || i.lib.filtersOn() ? (g(), b("button", {
          key: 0,
          class: "lb-link",
          "data-testid": "library-filters-clear",
          onClick: l
        }, [
          C($, {
            name: "RotateCcw",
            size: 12
          }),
          c[23] || (c[23] = J(" Clear all", -1))
        ])) : z("", !0),
        c[25] || (c[25] = u("span", { class: "lb-grow" }, null, -1)),
        u("button", {
          class: "lb-btn is-ghost",
          onClick: c[11] || (c[11] = (h) => i.lib.cancelFilters())
        }, "Cancel"),
        u("button", {
          class: "lb-btn is-primary",
          disabled: !s.value,
          "data-testid": "library-filters-apply",
          onClick: c[12] || (c[12] = (h) => i.lib.applyFilters())
        }, [
          C($, {
            name: "Check",
            size: 14
          }),
          c[24] || (c[24] = J(" Apply filters", -1))
        ], 8, Ske)
      ])
    ]));
  }
}), Tke = ["data-testid"], Cke = {
  key: 0,
  class: "hill b"
}, Ike = { class: "le-spark" }, Ake = { class: "le-prompt" }, Pke = { class: "le-drop" }, Eke = { class: "le-check" }, Rke = { class: "le-burst" }, zke = { class: "le-heart" }, $ke = {
  key: 0,
  class: "le-lens"
}, Rb = /* @__PURE__ */ Pe({
  __name: "LibraryEmptyArt",
  props: {
    kind: {}
  },
  setup(i) {
    return (e, t) => (g(), b("div", {
      class: G(["le", "is-" + i.kind]),
      "aria-hidden": "true",
      "data-testid": "library-empty-art-" + i.kind
    }, [
      t[9] || (t[9] = u("i", { class: "le-glow" }, null, -1)),
      i.kind === "generations" ? (g(), b(j, { key: 0 }, [
        (g(), b(j, null, be(3, (n) => u("i", {
          key: n,
          class: G(["le-pic", "p" + n])
        }, [
          t[0] || (t[0] = u("i", { class: "sun" }, null, -1)),
          t[1] || (t[1] = u("i", { class: "hill" }, null, -1)),
          n === 2 ? (g(), b("i", Cke)) : z("", !0)
        ], 2)), 64)),
        u("i", Ike, [
          C($, {
            name: "Sparkles",
            size: 12
          })
        ]),
        u("i", Ake, [
          C($, {
            name: "Sparkles",
            size: 11
          }),
          t[2] || (t[2] = u("i", { class: "t1" }, null, -1)),
          t[3] || (t[3] = u("i", { class: "t2" }, null, -1)),
          t[4] || (t[4] = u("i", { class: "run" }, null, -1))
        ])
      ], 64)) : i.kind === "uploads" ? (g(), b(j, { key: 1 }, [
        u("i", Pke, [
          C($, {
            name: "Upload",
            size: 14
          })
        ]),
        t[5] || (t[5] = u("i", { class: "le-pic u" }, [
          u("i", { class: "sun" }),
          u("i", { class: "hill" }),
          u("i", { class: "hill b" })
        ], -1)),
        u("i", Eke, [
          C($, {
            name: "Check",
            size: 11
          })
        ])
      ], 64)) : i.kind === "favorites" ? (g(), b(j, { key: 2 }, [
        t[6] || (t[6] = _1('<i class="le-pic f1"><i class="sun"></i><i class="hill"></i></i><i class="le-pic f3"><i class="sun"></i><i class="hill"></i></i><i class="le-pic f2"><i class="sun"></i><i class="hill"></i><i class="hill b"></i></i>', 3)),
        u("i", Rke, [
          (g(), b(j, null, be(6, (n) => u("i", {
            key: n,
            class: G("b" + n)
          }, null, 2)), 64))
        ]),
        u("i", zke, [
          C($, {
            name: "Heart",
            size: 12
          })
        ])
      ], 64)) : (g(), b(j, { key: 3 }, [
        (g(), b(j, null, be(3, (n) => u("i", {
          key: n,
          class: G(["le-ghost", "g" + n])
        }, null, 2)), 64)),
        i.kind === "search" ? (g(), b("i", $ke)) : (g(), b(j, { key: 1 }, [
          t[7] || (t[7] = u("i", { class: "le-track t1" }, [
            u("i", { class: "knob" })
          ], -1)),
          t[8] || (t[8] = u("i", { class: "le-track t2" }, [
            u("i", { class: "knob" })
          ], -1))
        ], 64))
      ], 64))
    ], 10, Tke));
  }
});
var Dke = Object.defineProperty, Oke = (i, e, t) => e in i ? Dke(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Na = (i, e, t) => Oke(i, typeof e != "symbol" ? e + "" : e, t);
const Lke = [
  { id: "generations", label: "Your generations", icon: "Images" },
  { id: "uploads", label: "Uploads", icon: "Upload" },
  { id: "favorites", label: "Favorites", icon: "Heart" }
], iA = 1, sA = 12;
function Bke(i) {
  return i >= 1300 ? 6 : i >= 1e3 ? 5 : i >= 760 ? 4 : i >= 480 ? 3 : 2;
}
const oA = "rd-board-library";
function Fke() {
  try {
    const i = localStorage.getItem(oA);
    return i ? JSON.parse(i) : {};
  } catch {
    return {};
  }
}
function g4(i) {
  try {
    localStorage.setItem(oA, JSON.stringify(i));
  } catch {
  }
}
const Nke = { search: !1, filters: !1, star: !1, remove: !1 };
function Uke(i) {
  return /* @__PURE__ */ Xt({
    tab: "generations",
    /** what's typed in the search box */
    searchText: "",
    /** the search in force (two characters or more) */
    search: "",
    /** the filters in force, and the panel's copy being edited */
    filters: {},
    draft: {},
    filtersOpen: !1,
    layout: i.layout || "grid",
    /** chosen columns; 0 until you choose (the view's width decides) */
    columns: i.columns || 0,
    /** picking: a click picks rather than looks */
    selecting: !0,
    /** picked items, in the order picked */
    picked: [],
    /** the item open large, if any */
    peek: null,
    /** starred results (item ids), as far as known */
    favs: /* @__PURE__ */ new Set(),
    /** uploads under way */
    uploading: [],
    tabs: {
      generations: $b(),
      uploads: $b(),
      favorites: $b()
    }
  });
}
class Gke {
  constructor(e, t, n = ["image", "video"]) {
    Na(this, "shelf", e), Na(this, "max", t), Na(this, "kinds", n), Na(this, "s"), Na(this, "shown"), Na(this, "features"), this.features = e ? e.features : Nke, this.s = Uke(Fke()), this.shown = I(() => this.s.tabs[this.s.tab].items);
  }
  /** Can this be picked here: a finished picture of a kind wanted? */
  allowed(e) {
    return !e.moderated && this.kinds.includes(Zwe(e));
  }
  tab() {
    return this.s.tabs[this.s.tab];
  }
  /** The query for a tab: Your generations carries the filters and search in force. */
  query(e, t = null) {
    return e !== "generations" ? { cursor: t } : { cursor: t, filters: { ...this.s.filters }, search: this.s.search || void 0 };
  }
  /** Another tab: as in v1, it starts without filters or search. */
  setTab(e) {
    this.s.tab !== e && (this.s.tab = e, this.s.peek = null, this.s.filtersOpen = !1, (this.s.search || Of(this.s.filters)) && (this.s.search = "", this.s.searchText = "", this.s.filters = {}, this.reset("generations")), this.s.tabs[e].loaded || this.load(e));
  }
  /** Start a tab over (its query changed). */
  reset(e) {
    const t = this.s.tabs[e];
    t.items = [], t.next = null, t.loaded = !1, t.failed = !1, t.latched = !1, t.error = "", t.loading = !1, t.version++;
  }
  /** The tab's first page, or (more) its next one. */
  async load(e = this.s.tab, t = !1) {
    const n = this.s.tabs[e];
    if (!this.shelf || n.loading || t && (n.next === null || n.latched)) return;
    const s = n.version;
    n.loading = !0, n.failed = !1;
    try {
      const o = this.query(e, t ? n.next : null), r = await (e === "generations" ? this.shelf.generations(o) : e === "uploads" ? this.shelf.uploads(o) : this.shelf.favorites(o));
      if (n.version !== s) return;
      const a = new Set(t ? n.items.map((d) => d.id) : []), l = r.items.filter((d) => !a.has(d.id));
      for (const d of l) d.fav && this.s.favs.add(d.id);
      n.items = t ? n.items.concat(l) : l, n.next = r.next, n.loaded = !0;
    } catch (o) {
      if (n.version !== s) return;
      console.warn("[board] your Library could not be loaded", o), n.failed = !0, n.latched = t, n.error = zb(o);
    } finally {
      n.version === s && (n.loading = !1);
    }
  }
  /** Ask again after a page failed. */
  retry() {
    const e = this.tab();
    e.latched = !1, this.load(this.s.tab, e.loaded);
  }
  /** Which of your results are starred, to mark them on every tab. */
  async loadFavs() {
    if (!(!this.shelf || !this.shelf.favoriteKeys))
      try {
        for (const e of await this.shelf.favoriteKeys()) this.s.favs.add(e);
      } catch (e) {
        console.warn("[board] your favorites could not be read", e);
      }
  }
  // ------------------------------------------------------------ search and filters
  /** The words in the box, in force (the box waits for a pause, or Enter). */
  commitSearch() {
    const e = xm(this.s.searchText);
    e !== this.s.search && (this.s.search = e, this.s.tab !== "generations" && (this.s.tab = "generations"), this.reset("generations"), this.load("generations"));
  }
  clearSearch() {
    this.s.searchText = "", this.commitSearch();
  }
  openFilters() {
    this.s.draft = { ...this.s.filters }, this.s.filtersOpen = !0;
  }
  /** The panel's Cancel: back to what's in force. */
  cancelFilters() {
    this.s.draft = { ...this.s.filters }, this.s.filtersOpen = !1;
  }
  /** Apply filters (the panel's draft, or these): Your generations starts over with them; the search stays. */
  applyFilters(e = this.s.draft) {
    const t = {};
    for (const [n, s] of Object.entries(e))
      s && (t[n] = s);
    this.s.filters = t, this.s.draft = { ...t }, this.s.filtersOpen = !1, this.s.tab !== "generations" && (this.s.tab = "generations"), this.reset("generations"), this.load("generations");
  }
  /** One filter off (a chip's ×). */
  dropFilter(e) {
    const t = { ...this.s.filters };
    e === "dates" ? (delete t.from, delete t.to) : delete t[e], this.applyFilters(t);
  }
  filtersOn() {
    return Of(this.s.filters);
  }
  // ------------------------------------------------------------ layout
  setLayout(e) {
    this.s.layout = e, g4({ layout: e, columns: this.s.columns || void 0 });
  }
  setColumns(e) {
    this.s.columns = Math.max(iA, Math.min(sA, Math.round(e))), g4({ layout: this.s.layout, columns: this.s.columns });
  }
  // ------------------------------------------------------------ picking
  /** Its place in the picks (1 first), or 0. */
  order(e) {
    return this.s.picked.findIndex((t) => t.id === e) + 1;
  }
  /** Pick or unpick; false when it can't be picked here, or the picks are full. */
  toggle(e) {
    return this.order(e.id) ? (this.s.picked = this.s.picked.filter((t) => t.id !== e.id), !0) : !this.allowed(e) || this.s.picked.length >= this.max ? !1 : (this.s.picked = [...this.s.picked, e], !0);
  }
  /** Pick every shown picture that can be, up to the limit, after what's already picked. */
  pickAll() {
    let e = 0;
    for (const t of this.shown.value) {
      if (this.s.picked.length >= this.max) break;
      this.order(t.id) || !this.allowed(t) || (this.s.picked = [...this.s.picked, t], e++);
    }
    return e;
  }
  clear() {
    this.s.picked = [];
  }
  full() {
    return this.s.picked.length >= this.max;
  }
  // ------------------------------------------------------------ stars, deletes, uploads
  faved(e) {
    return this.s.favs.has(e.id);
  }
  /** Can you star it: one of your finished generations, where the Library can star. */
  canStar(e) {
    return !!this.shelf && !!this.shelf.setFavorite && this.features.star && !!e.run && !!e.mine && !e.moderated;
  }
  /** Star or unstar, shown at once; undone, with the reason, if it's refused. */
  async star(e, t) {
    if (!this.canStar(e)) return null;
    const n = this.faved(e);
    this.markFav(e, t);
    try {
      return await this.shelf.setFavorite(e, t), null;
    } catch (s) {
      return this.markFav(e, n), zb(s) || "Could not change the favorite, please try again";
    }
  }
  markFav(e, t) {
    const n = new Set(this.s.favs);
    t ? n.add(e.id) : n.delete(e.id), this.s.favs = n;
    const s = this.s.tabs.favorites;
    t && s.loaded && !s.items.some((o) => o.id === e.id) && (s.items = [{ ...e, fav: !0 }, ...s.items]), t || (s.items = s.items.filter((o) => o.id !== e.id));
  }
  canRemove(e) {
    return !!this.shelf && !!this.shelf.remove && this.features.remove && !!e.mine;
  }
  /** Delete it: gone from every tab and the picks at once; back, with the reason, if it's refused. */
  async remove(e) {
    if (!this.canRemove(e)) return null;
    const t = Object.keys(this.s.tabs).map((s) => [s, this.s.tabs[s].items]), n = this.s.picked;
    for (const s of Object.keys(this.s.tabs)) this.s.tabs[s].items = this.s.tabs[s].items.filter((o) => o.id !== e.id);
    this.s.picked = this.s.picked.filter((s) => s.id !== e.id), this.s.peek && this.s.peek.id === e.id && (this.s.peek = null);
    try {
      return await this.shelf.remove(e), null;
    } catch (s) {
      for (const [o, r] of t) this.s.tabs[o].items = r;
      return this.s.picked = n, zb(s) || "Issues deleting image, please try again";
    }
  }
  uploadStarted(e, t) {
    this.s.uploading = [...this.s.uploading, { id: e, name: t }];
  }
  /** An upload landed: first in Uploads, and picked if there's room. */
  uploadDone(e, t) {
    if (this.s.uploading = this.s.uploading.filter((s) => s.id !== e), !t) return;
    const n = this.s.tabs.uploads;
    n.items = [t, ...n.items.filter((s) => s.id !== t.id)], this.s.selecting && !this.order(t.id) && this.allowed(t) && !this.full() && (this.s.picked = [...this.s.picked, t]);
  }
}
function zb(i) {
  const e = i && typeof i == "object" ? i.userMessage : void 0;
  return typeof e == "string" ? e : "";
}
function $b() {
  return { items: [], next: null, loading: !1, loaded: !1, failed: !1, error: "", latched: !1, version: 0 };
}
const jke = {
  class: "lb-shell",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "Your Library"
}, Hke = { class: "lb-head" }, Vke = { class: "lb-row is-top" }, Wke = { class: "lb-mark" }, qke = { class: "lb-title" }, Kke = {
  key: 0,
  class: "bd-spinner is-sm"
}, Yke = { key: 2 }, Xke = {
  key: 1,
  class: "lb-grow"
}, Jke = { class: "lb-row is-bar" }, Zke = {
  class: "lb-tabs",
  role: "tablist",
  "aria-label": "Library"
}, Qke = ["aria-selected", "data-testid", "onClick"], e2e = ["aria-expanded", "title"], t2e = {
  key: 0,
  class: "n"
}, n2e = {
  class: "lb-seg",
  role: "radiogroup",
  "aria-label": "Layout"
}, i2e = ["aria-checked", "title", "data-testid", "onClick"], s2e = {
  key: 1,
  class: "lb-cols",
  title: "Number of columns"
}, o2e = ["disabled"], r2e = { "data-testid": "library-cols" }, a2e = ["disabled"], l2e = ["aria-pressed", "title"], d2e = {
  key: 1,
  class: "lb-applied",
  "data-testid": "library-applied"
}, c2e = {
  key: 0,
  class: "lb-applied-chip is-search"
}, u2e = ["title", "onClick"], h2e = {
  key: 2,
  class: "lb-applied-note"
}, p2e = {
  key: 1,
  class: "lb-empty",
  "data-testid": "library-failed"
}, f2e = { class: "lb-empty-mark is-warn" }, m2e = {
  key: 2,
  class: "lb-empty",
  "data-testid": "library-no-match"
}, g2e = {
  key: 3,
  class: "lb-empty",
  "data-testid": "library-no-match"
}, b2e = {
  key: 4,
  class: "lb-empty",
  "data-testid": "library-empty"
}, v2e = {
  key: 0,
  class: "lb-empty-hint"
}, y2e = { class: "key" }, x2e = { class: "ic" }, w2e = { class: "lb-frame" }, k2e = { class: "lb-uploading" }, _2e = ["title", "onClick", "onDblclick"], S2e = { class: "lb-frame" }, M2e = {
  key: 0,
  class: "lb-withheld"
}, T2e = ["src"], C2e = { class: "lb-info" }, I2e = { class: "p" }, A2e = {
  key: 0,
  class: "m"
}, P2e = {
  key: 0,
  class: "lb-row-text"
}, E2e = { class: "p" }, R2e = { class: "m" }, z2e = {
  key: 1,
  class: "lb-badge is-video"
}, $2e = {
  key: 2,
  class: "lb-badge is-3d"
}, D2e = ["title", "aria-pressed", "onClick"], O2e = {
  key: 4,
  class: "lb-star on is-still"
}, L2e = ["aria-label", "aria-pressed", "onClick"], B2e = { key: 0 }, F2e = ["onClick"], N2e = {
  key: 6,
  class: "lb-more"
}, U2e = {
  key: 7,
  class: "lb-more is-failed",
  "data-testid": "library-more-failed"
}, G2e = {
  key: 8,
  class: "lb-more"
}, j2e = {
  key: 9,
  class: "lb-end"
}, H2e = {
  key: 0,
  class: "lb-tray",
  "data-testid": "library-tray"
}, V2e = { class: "lb-tray-picks" }, W2e = { class: "lb-tray-count" }, q2e = ["disabled"], K2e = {
  key: 2,
  class: "lb-dropping"
}, Hi = 12, Ua = 108, Y2e = /* @__PURE__ */ Pe({
  __name: "LibraryView",
  setup(i) {
    const { board: e } = Ze(), t = e.ui.libraryOpen, n = t.kinds || (t.purpose === "place" ? ["image", "video", "3d"] : ["image", "video"]), s = new Gke(e.libraryShelf, t.max, n), o = s.s, r = t.purpose === "place", a = t.max === 1, l = !!e.uploader, d = /* @__PURE__ */ K(null), c = /* @__PURE__ */ K(null), h = /* @__PURE__ */ K(null), f = /* @__PURE__ */ K(1100), p = /* @__PURE__ */ K(700), y = /* @__PURE__ */ K(0), v = /* @__PURE__ */ K(null), { active: x, over: w, leave: S, stop: M } = cx(() => l), _ = /* @__PURE__ */ K(null), T = /* @__PURE__ */ K(!1);
    let k = 0;
    const P = [
      { id: "grid", label: "Grid", icon: "Grid3x3" },
      { id: "masonry", label: "Masonry", icon: "LayoutDashboard" },
      { id: "list", label: "Details", icon: "Rows3" }
    ], A = I(() => o.tabs[o.tab]), R = I(() => s.shown.value), D = I(() => o.layout === "list" ? 1 : o.columns || Bke(f.value)), O = I(() => Math.floor((f.value - Hi * (D.value - 1)) / D.value)), F = I(() => a || o.selecting), te = I(() => {
      const W = [];
      if (o.tab === "uploads" && l) {
        W.push({ kind: "upload", key: "(upload)" });
        for (const Q of o.uploading) W.push({ kind: "uploading", name: Q.name, key: "up-" + Q.id });
      }
      for (const Q of R.value) W.push({ kind: "item", it: Q, key: Q.id });
      return W;
    }), ee = I(() => {
      const W = D.value, Q = O.value, ae = [];
      if (o.layout === "list")
        return te.value.forEach((ve, ke) => ae.push({ e: ve, x: 0, y: ke * (Ua + 8), w: f.value, h: Ua })), { cells: ae, height: te.value.length ? te.value.length * (Ua + 8) - 8 : 0 };
      if (o.layout === "grid") {
        te.value.forEach((ke, De) => ae.push({ e: ke, x: De % W * (Q + Hi), y: Math.floor(De / W) * (Q + Hi), w: Q, h: Q }));
        const ve = Math.ceil(te.value.length / W);
        return { cells: ae, height: ve ? ve * (Q + Hi) - Hi : 0 };
      }
      const Le = new Array(W).fill(0);
      for (const ve of te.value) {
        let ke = 0;
        for (let Dn = 1; Dn < W; Dn++) Le[Dn] < Le[ke] - 1 && (ke = Dn);
        const De = ve.kind === "item" ? ve.it : null, Qe = De && De.w && De.h ? De.h / De.w : 1, ft = Math.round(Q * Math.max(0.45, Math.min(2.2, Qe)));
        ae.push({ e: ve, x: ke * (Q + Hi), y: Le[ke], w: Q, h: ft }), Le[ke] += ft + Hi;
      }
      return { cells: ae, height: Math.max(0, ...Le) - Hi };
    }), me = I(() => {
      const W = y.value - 900, Q = y.value + p.value + 900;
      return ee.value.cells.filter((ae) => ae.y + ae.h >= W && ae.y <= Q);
    }), L = I(() => !!o.search), N = I(() => !A.value.loaded && !A.value.failed), X = I(() => A.value.loaded && !te.value.length && !A.value.loading), B = I(() => o.tab === "generations" && (L.value || s.filtersOn() > 0)), se = I(() => {
      const W = o.picked.length;
      return t.confirmLabel ? t.confirmLabel : r ? W === 1 ? "Place on the board" : "Place " + (W || "") + " on the board" : W === 1 ? "Use image" : "Use " + (W || "") + " images";
    }), V = {
      generations: { title: "No generations yet", sub: "Everything you make, in any session on any board, collects here." },
      uploads: { title: "No uploads yet", sub: "Images you bring in collect here." },
      favorites: { title: "No favorites yet", sub: "Tap the heart on any of your generations to add it to your favorites." }
    }, Z = I(() => {
      const W = /* @__PURE__ */ new Map();
      for (const Q of e.catalog.value.kits) for (const ae of Q.models) W.set(ae.id, ae.name);
      return W;
    });
    function Y(W) {
      return W.model || W.run && Z.value.get(W.run.nodeDefId) || "";
    }
    function H(W) {
      return [Y(W), W.createdAt ? Jn(W.createdAt) : ""].filter(Boolean).join(" · ");
    }
    function re(W) {
      return W.thumb || Bt(W.url);
    }
    const le = I(() => _.value && _.value.tools.length ? _.value.tools : Array.from(Z.value.entries()).map(([W, Q]) => ({ value: W, text: Q })).sort((W, Q) => W.text.localeCompare(Q.text))), he = I(() => _.value ? { ..._.value, tools: le.value } : null), Re = I(() => {
      const W = o.filters, Q = _.value, ae = (ve, ke) => {
        var De;
        return ve && ((De = ve.find((Qe) => Qe.value === ke)) == null ? void 0 : De.text) || ke;
      }, Le = [];
      return W.favorited && Le.push({ key: "favorited", label: "Favorited" }), W.aspect && Le.push({ key: "aspect", label: ae(eA, W.aspect) }), W.resolution && Le.push({ key: "resolution", label: ae(tA, W.resolution) }), W.tool && Le.push({ key: "tool", label: ae(le.value, W.tool) }), W.family && Le.push({ key: "family", label: ae(Q == null ? void 0 : Q.families, W.family) }), W.media && Le.push({ key: "media", label: ae(Q == null ? void 0 : Q.media, W.media) }), W.board && Le.push({ key: "board", label: ae(Q == null ? void 0 : Q.boards, W.board) }), (W.from || W.to) && Le.push({ key: "dates", label: (W.from ? Ne(W.from) : "…") + " → " + (W.to ? Ne(W.to) : "…") }), Le;
    });
    function Ne(W) {
      const [Q, ae, Le] = W.split("-").map(Number);
      return new Date(Q, ae - 1, Le).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    }
    function Me(W, Q) {
      clearTimeout(k), v.value = { id: Date.now(), text: W, tone: Q }, k = window.setTimeout(() => {
        v.value = null;
      }, Q ? 5e3 : 2400);
    }
    function ue() {
      e.closeLibrary();
    }
    function U(W) {
      o.tab !== W && (s.setTab(W), q());
    }
    function q() {
      d.value && (d.value.scrollTop = 0), y.value = 0;
    }
    function ie(W, Q) {
      if (Q.shiftKey && F.value && !W.moderated) {
        de(W);
        return;
      }
      o.peek = W;
    }
    function de(W) {
      if (!W.moderated) {
        if (!s.allowed(W)) {
          const Q = n, ae = { image: "images", video: "videos", "3d": "3D models" };
          Me(Q.length === 1 ? "Only " + ae[Q[0]] + " can be used here" : (W.model3d ? "3D models" : W.video ? "Videos" : "Images") + " can't be used here");
          return;
        }
        if (a) {
          s.s.picked = [W], pe();
          return;
        }
        s.toggle(W) || Me("You can pick " + t.max + (t.max === 1 ? " picture" : " pictures") + " at most: unpick one first");
      }
    }
    function pe() {
      const W = o.picked.slice();
      W.length && (r ? e.placeFromLibrary(W, t.at) : t.onPick && t.onPick(W), ue());
    }
    async function Te(W) {
      const Q = await s.star(W, !s.faved(W));
      Q && Me(Q, "error");
    }
    async function Be(W) {
      const Q = await s.remove(W);
      if (Q) {
        Me(Q, "error");
        return;
      }
      e.forgetLibraryItem(W), Me(W.uploadId ? "Upload deleted" : "Generation deleted");
    }
    function ge() {
      if (o.filtersOpen) {
        s.cancelFilters();
        return;
      }
      s.openFilters(), ne();
    }
    async function ne() {
      const W = e.libraryShelf;
      if (!(_.value || T.value)) {
        if (!W || !W.filterOptions) {
          _.value = { tools: [], families: [], media: [], boards: [] };
          return;
        }
        T.value = !0;
        try {
          _.value = await W.filterOptions(e.meta.teamId);
        } catch (Q) {
          console.warn("[board] the Library's filter options are unavailable", Q), _.value = { tools: [], families: [], media: [], boards: [] };
        } finally {
          T.value = !1;
        }
      }
    }
    function oe(W) {
      s.setColumns(D.value + W);
    }
    function ye(W) {
      return new Promise((Q) => {
        const ae = new Image();
        ae.onload = () => Q({ w: ae.naturalWidth || 4, h: ae.naturalHeight || 3 }), ae.onerror = () => Q({ w: 4, h: 3 }), ae.src = W;
      });
    }
    async function Oe(W) {
      const Q = W.filter((ae) => ae.type.startsWith("image/")).slice(0, 24);
      !Q.length || !l || (o.tab !== "uploads" && U("uploads"), await Promise.all(Q.map(async (ae) => {
        const Le = St();
        s.uploadStarted(Le, ae.name);
        try {
          const ve = URL.createObjectURL(ae), ke = await ye(ve), De = await e.uploadFile(ae);
          De.url !== ve && URL.revokeObjectURL(ve);
          const Qe = De.asset && "upload" in De.asset ? De.asset.upload : null;
          s.uploadDone(Le, {
            id: "upload:" + (Qe && Qe.id ? Qe.id : Le),
            url: De.url,
            w: ke.w,
            h: ke.h,
            video: !1,
            label: ae.name,
            createdAt: Date.now(),
            mine: !0,
            uploadId: Qe && Qe.id ? Qe.id : void 0,
            asset: De.asset || { upload: { name: ae.name } }
          });
        } catch (ve) {
          s.uploadDone(Le, null);
          const ke = ve ? ve.userMessage : void 0;
          Me(ke || ae.name + " could not be uploaded.", "error");
        }
      })));
    }
    function Ve(W) {
      const Q = W.target, ae = Array.from(Q.files || []);
      Q.value = "", Oe(ae);
    }
    function Ue(W) {
      w(W) && W.preventDefault();
    }
    function tt(W) {
      M(), !(!W.dataTransfer || !l) && (W.preventDefault(), Oe(Array.from(W.dataTransfer.files || [])));
    }
    let Ye = null;
    function at() {
      if (!d.value) return;
      const W = getComputedStyle(d.value), Q = parseFloat(W.paddingLeft) + parseFloat(W.paddingRight);
      f.value = Math.max(280, d.value.clientWidth - Q), p.value = d.value.clientHeight;
    }
    function wt() {
      const W = d.value;
      W && (y.value = W.scrollTop, W.scrollHeight - W.scrollTop - W.clientHeight < 700 && s.load(o.tab, !0));
    }
    let $e = 0;
    Ae(() => o.searchText, () => {
      clearTimeout($e), $e = window.setTimeout(() => {
        s.commitSearch(), q();
      }, 300);
    }), Ae(() => o.filters, q), Ae(() => [ee.value.height, A.value.loading], () => {
      nt(() => {
        const W = A.value;
        d.value && !W.loading && W.loaded && W.next !== null && !W.latched && ee.value.height < p.value + 400 && s.load(o.tab, !0);
      });
    });
    function Fe(W) {
      const Q = W.target;
      if (Q && Q.closest && Q.closest("[data-lb-own-keys]")) return;
      const ae = !!Q && (Q.tagName === "INPUT" || Q.tagName === "TEXTAREA");
      if (W.key === "Escape") {
        W.preventDefault(), W.stopPropagation(), o.peek ? o.peek = null : o.filtersOpen ? s.cancelFilters() : ae && o.searchText ? s.clearSearch() : ae ? Q.blur() : ue();
        return;
      }
      if (!o.peek) {
        if (W.key === "Enter" && ae && Q === c.value) {
          W.preventDefault(), clearTimeout($e), s.commitSearch();
          return;
        }
        if (W.key === "/" && !ae && c.value) {
          W.preventDefault(), c.value.focus();
          return;
        }
        ae || (W.key === "Enter" && o.picked.length && !a ? (W.preventDefault(), pe()) : kn(W) && W.key.toLowerCase() === "a" && F.value && !a && (W.preventDefault(), !s.pickAll() && s.full() && Me("That's as many as you can pick")));
      }
    }
    return ot(() => {
      s.load("generations"), s.loadFavs(), at(), d.value && (Ye = new ResizeObserver(at), Ye.observe(d.value)), window.addEventListener("keydown", Fe, !0), nt(() => {
        c.value && c.value.focus({ preventScroll: !0 });
      });
    }), We(() => {
      Ye && Ye.disconnect(), window.removeEventListener("keydown", Fe, !0), clearTimeout(k), clearTimeout($e);
    }), (W, Q) => (g(), b("div", {
      class: "lb-backdrop",
      "data-testid": "library",
      onPointerdown: Se(ue, ["self"]),
      onDragover: Ue,
      onDragleave: Q[16] || (Q[16] = //@ts-ignore
      (...ae) => m(S) && m(S)(...ae)),
      onDrop: tt
    }, [
      u("div", jke, [
        u("header", Hke, [
          Q[21] || (Q[21] = u("span", {
            class: "lb-glow",
            "aria-hidden": "true"
          }, null, -1)),
          u("div", Vke, [
            u("span", Wke, [
              C($, {
                name: "Library",
                size: 17
              })
            ]),
            u("div", qke, [
              Q[17] || (Q[17] = u("b", null, "Library", -1)),
              u("span", null, E(m(Qwe)(m(n), m(t).max, r)), 1)
            ]),
            m(s).features.search ? (g(), b("label", {
              key: 0,
              class: G(["lb-search", { "has-words": !!m(o).searchText }])
            }, [
              C($, {
                name: "Search",
                size: 15
              }),
              kt(u("input", {
                ref_key: "searchEl",
                ref: c,
                "onUpdate:modelValue": Q[0] || (Q[0] = (ae) => m(o).searchText = ae),
                type: "text",
                spellcheck: "false",
                placeholder: "Search your Library",
                "aria-label": "Search your Library",
                "data-testid": "library-search"
              }, null, 512), [
                [Zt, m(o).searchText]
              ]),
              L.value && A.value.loading ? (g(), b("span", Kke)) : z("", !0),
              m(o).searchText ? (g(), b("button", {
                key: 1,
                class: "lb-search-clear",
                title: "Clear",
                onClick: Q[1] || (Q[1] = (ae) => m(s).clearSearch())
              }, [
                C($, {
                  name: "X",
                  size: 12
                })
              ])) : (g(), b("kbd", Yke, "/"))
            ], 2)) : (g(), b("span", Xke)),
            u("button", {
              class: "lb-close",
              title: "Close (Esc)",
              "data-testid": "library-close",
              onClick: ue
            }, [
              C($, {
                name: "X",
                size: 16
              })
            ])
          ]),
          u("div", Jke, [
            u("nav", Zke, [
              (g(!0), b(j, null, be(m(Lke), (ae) => (g(), b("button", {
                key: ae.id,
                role: "tab",
                "aria-selected": m(o).tab === ae.id,
                class: G({ on: m(o).tab === ae.id }),
                "data-testid": "library-tab-" + ae.id,
                onClick: (Le) => U(ae.id)
              }, [
                C($, {
                  name: ae.icon,
                  size: 14
                }, null, 8, ["name"]),
                J(" " + E(ae.label), 1)
              ], 10, Qke))), 128))
            ]),
            Q[20] || (Q[20] = u("span", { class: "lb-grow" }, null, -1)),
            m(s).features.filters && m(o).tab === "generations" ? (g(), b("button", {
              key: 0,
              class: G(["lb-tool", { on: m(o).filtersOpen, "is-set": m(s).filtersOn() > 0 }]),
              "aria-expanded": m(o).filtersOpen,
              title: m(o).filtersOpen ? "Hide filters" : "Show filters",
              "data-testid": "library-filter-toggle",
              onClick: ge
            }, [
              C($, {
                name: "SlidersHorizontal",
                size: 14
              }),
              Q[18] || (Q[18] = J(" Filters ", -1)),
              m(s).filtersOn() ? (g(), b("span", t2e, E(m(s).filtersOn()), 1)) : z("", !0)
            ], 10, e2e)) : z("", !0),
            u("div", n2e, [
              (g(), b(j, null, be(P, (ae) => u("button", {
                key: ae.id,
                role: "radio",
                "aria-checked": m(o).layout === ae.id,
                class: G({ on: m(o).layout === ae.id }),
                title: ae.label,
                "data-testid": "library-layout-" + ae.id,
                onClick: (Le) => m(s).setLayout(ae.id)
              }, [
                C($, {
                  name: ae.icon,
                  size: 14
                }, null, 8, ["name"])
              ], 10, i2e)), 64))
            ]),
            m(o).layout !== "list" ? (g(), b("div", s2e, [
              u("button", {
                disabled: D.value <= m(iA),
                "aria-label": "Fewer columns",
                "data-testid": "library-cols-less",
                onClick: Q[2] || (Q[2] = (ae) => oe(-1))
              }, [
                C($, {
                  name: "Minus",
                  size: 12
                })
              ], 8, o2e),
              u("span", r2e, [
                u("b", null, E(D.value), 1),
                C($, {
                  name: "Columns3",
                  size: 12
                })
              ]),
              u("button", {
                disabled: D.value >= m(sA),
                "aria-label": "More columns",
                "data-testid": "library-cols-more",
                onClick: Q[3] || (Q[3] = (ae) => oe(1))
              }, [
                C($, {
                  name: "Plus",
                  size: 12
                })
              ], 8, a2e)
            ])) : z("", !0),
            a ? z("", !0) : (g(), b("button", {
              key: 2,
              class: G(["lb-select", { on: m(o).selecting }]),
              "aria-pressed": m(o).selecting,
              title: m(o).selecting ? "Selection mode: each picture's check picks it (Shift-click too). Turn off to hide the checks" : "Turn on selection mode to pick pictures",
              "data-testid": "library-selecting",
              onClick: Q[4] || (Q[4] = (ae) => m(o).selecting = !m(o).selecting)
            }, [...Q[19] || (Q[19] = [
              u("span", { class: "sw" }, [
                u("i")
              ], -1),
              J(" Select ", -1)
            ])], 10, l2e))
          ])
        ]),
        m(o).filtersOpen ? (g(), Ce(Mke, {
          key: 0,
          lib: m(s),
          options: he.value,
          loading: T.value
        }, null, 8, ["lib", "options", "loading"])) : B.value ? (g(), b("div", d2e, [
          L.value ? (g(), b("span", c2e, [
            C($, {
              name: "Search",
              size: 12
            }),
            J(" “" + E(m(o).search) + "” ", 1),
            u("button", {
              title: "Clear the search",
              onClick: Q[5] || (Q[5] = (ae) => m(s).clearSearch())
            }, [
              C($, {
                name: "X",
                size: 11
              })
            ])
          ])) : z("", !0),
          (g(!0), b(j, null, be(Re.value, (ae) => (g(), b("span", {
            key: ae.key,
            class: "lb-applied-chip"
          }, [
            J(E(ae.label) + " ", 1),
            u("button", {
              title: "Remove " + ae.label,
              onClick: (Le) => m(s).dropFilter(ae.key)
            }, [
              C($, {
                name: "X",
                size: 11
              })
            ], 8, u2e)
          ]))), 128)),
          Re.value.length ? (g(), b("button", {
            key: 1,
            class: "lb-link",
            onClick: Q[6] || (Q[6] = (ae) => m(s).applyFilters({}))
          }, "Clear filters")) : z("", !0),
          Q[22] || (Q[22] = u("span", { class: "lb-grow" }, null, -1)),
          L.value ? (g(), b("span", h2e, "Best matches first")) : z("", !0)
        ])) : z("", !0),
        u("main", {
          ref_key: "body",
          ref: d,
          class: G(["lb-body", "is-" + m(o).layout]),
          "data-testid": "library-body",
          onScroll: wt
        }, [
          N.value ? (g(), b("div", {
            key: 0,
            class: "lb-wall",
            style: ce({ height: (m(o).layout === "list" ? 6 * (Ua + 8) : Math.ceil(18 / D.value) * (O.value + Hi)) + "px" })
          }, [
            (g(!0), b(j, null, be(m(o).layout === "list" ? 6 : Math.min(18, D.value * 3), (ae) => (g(), b("span", {
              key: ae,
              class: "lb-skel",
              style: ce(m(o).layout === "list" ? { left: "0px", top: (ae - 1) * (Ua + 8) + "px", width: f.value + "px", height: Ua + "px", animationDelay: ae % 6 * 70 + "ms" } : { left: (ae - 1) % D.value * (O.value + Hi) + "px", top: Math.floor((ae - 1) / D.value) * (O.value + Hi) + "px", width: O.value + "px", height: O.value + "px", animationDelay: ae % 6 * 70 + "ms" })
            }, null, 4))), 128))
          ], 4)) : A.value.failed && !A.value.loaded ? (g(), b("div", p2e, [
            u("span", f2e, [
              C($, {
                name: "AlertCircle",
                size: 20
              })
            ]),
            Q[24] || (Q[24] = u("b", null, "Your Library couldn't be loaded", -1)),
            u("span", null, E(A.value.error || "Check your connection, then try again."), 1),
            u("button", {
              class: "lb-btn",
              onClick: Q[7] || (Q[7] = (ae) => m(s).retry())
            }, [
              C($, {
                name: "RotateCcw",
                size: 14
              }),
              Q[23] || (Q[23] = J(" Try again", -1))
            ])
          ])) : X.value && L.value ? (g(), b("div", m2e, [
            C(Rb, { kind: "search" }),
            Q[25] || (Q[25] = u("b", null, "No results match your search.", -1)),
            u("span", null, "Try other words" + E(m(s).filtersOn() ? ", or fewer filters" : "") + ".", 1),
            u("button", {
              class: "lb-btn",
              onClick: Q[8] || (Q[8] = (ae) => m(s).clearSearch())
            }, "Clear search")
          ])) : X.value && B.value ? (g(), b("div", g2e, [
            C(Rb, { kind: "filters" }),
            Q[26] || (Q[26] = u("b", null, "Nothing matches these filters", -1)),
            Q[27] || (Q[27] = u("span", null, "Loosen one, or clear them all.", -1)),
            u("button", {
              class: "lb-btn",
              onClick: Q[9] || (Q[9] = (ae) => m(s).applyFilters({}))
            }, "Clear filters")
          ])) : X.value ? (g(), b("div", b2e, [
            C(Rb, {
              kind: m(o).tab
            }, null, 8, ["kind"]),
            u("b", null, E(V[m(o).tab].title), 1),
            u("span", null, E(V[m(o).tab].sub), 1),
            m(o).tab === "favorites" ? (g(), b("span", v2e, [
              Q[28] || (Q[28] = J("Look for ", -1)),
              u("span", y2e, [
                C($, {
                  name: "Heart",
                  size: 11
                })
              ]),
              Q[29] || (Q[29] = J(" on any generation", -1))
            ])) : z("", !0)
          ])) : (g(), b("div", {
            key: 5,
            class: "lb-wall",
            style: ce({ height: ee.value.height + "px" })
          }, [
            (g(!0), b(j, null, be(me.value, (ae) => (g(), b(j, {
              key: ae.e.key
            }, [
              ae.e.kind === "upload" ? (g(), b("button", {
                key: 0,
                class: G(["lb-upload-tile", { "is-list": m(o).layout === "list" }]),
                style: ce({ left: ae.x + "px", top: ae.y + "px", width: ae.w + "px", height: ae.h + "px" }),
                "data-testid": "library-upload",
                onClick: Q[10] || (Q[10] = (Le) => h.value && h.value.click())
              }, [
                u("span", x2e, [
                  C($, {
                    name: "Upload",
                    size: 18
                  })
                ]),
                Q[30] || (Q[30] = u("b", null, "Upload images", -1)),
                Q[31] || (Q[31] = u("span", null, "or drop them here", -1))
              ], 6)) : ae.e.kind === "uploading" ? (g(), b("div", {
                key: 1,
                class: G(["lb-cell is-uploading", { "is-list": m(o).layout === "list" }]),
                style: ce({ left: ae.x + "px", top: ae.y + "px", width: ae.w + "px", height: ae.h + "px" })
              }, [
                u("span", w2e, [
                  u("span", k2e, [
                    Q[32] || (Q[32] = u("span", { class: "bd-spinner is-sm" }, null, -1)),
                    J(" " + E(ae.e.name), 1)
                  ])
                ])
              ], 6)) : (g(), b("div", {
                key: 2,
                class: G(["lb-cell", {
                  "is-list": m(o).layout === "list",
                  "is-picked": m(s).order(ae.e.it.id) > 0,
                  "is-off": F.value && !ae.e.it.moderated && (!m(s).allowed(ae.e.it) || m(s).full() && !m(s).order(ae.e.it.id) && !a),
                  "is-selecting": F.value,
                  "is-moderated": !!ae.e.it.moderated
                }]),
                style: ce({ left: ae.x + "px", top: ae.y + "px", width: ae.w + "px", height: ae.h + "px" }),
                title: ae.e.it.moderated ? "Moderated by RunDiffusion" : ae.e.it.prompt || ae.e.it.label,
                "data-testid": "library-item",
                onClick: (Le) => ie(ae.e.it, Le),
                onDblclick: (Le) => m(o).peek = ae.e.it
              }, [
                u("span", S2e, [
                  ae.e.it.moderated ? (g(), b("span", M2e, [
                    C($, {
                      name: "EyeOff",
                      size: 16
                    }),
                    Q[33] || (Q[33] = u("b", null, "Moderated", -1))
                  ])) : (g(), b("img", {
                    key: 1,
                    src: re(ae.e.it),
                    alt: "",
                    loading: "lazy",
                    draggable: "false",
                    onLoad: Q[11] || (Q[11] = (Le) => Le.target.classList.add("is-in"))
                  }, null, 40, T2e)),
                  m(o).layout !== "list" ? (g(), b(j, { key: 2 }, [
                    Q[34] || (Q[34] = u("span", {
                      class: "lb-shade",
                      "aria-hidden": "true"
                    }, null, -1)),
                    u("span", C2e, [
                      u("span", I2e, E(ae.e.it.prompt || ae.e.it.label), 1),
                      H(ae.e.it) ? (g(), b("span", A2e, E(H(ae.e.it)), 1)) : z("", !0)
                    ])
                  ], 64)) : z("", !0)
                ]),
                m(o).layout === "list" ? (g(), b("span", P2e, [
                  u("span", E2e, E(ae.e.it.moderated ? "Moderated by RunDiffusion" : ae.e.it.prompt || ae.e.it.label), 1),
                  u("span", R2e, [
                    Y(ae.e.it) ? (g(), b(j, { key: 0 }, [
                      J(E(Y(ae.e.it)) + " · ", 1)
                    ], 64)) : z("", !0),
                    J(E(ae.e.it.createdAt ? m(Jn)(ae.e.it.createdAt) : ""), 1),
                    ae.e.it.w && ae.e.it.h ? (g(), b(j, { key: 1 }, [
                      J(" · " + E(ae.e.it.w) + " × " + E(ae.e.it.h), 1)
                    ], 64)) : z("", !0)
                  ])
                ])) : z("", !0),
                ae.e.it.video ? (g(), b("span", z2e, [
                  C($, {
                    name: "Play",
                    size: 9
                  }),
                  Q[35] || (Q[35] = J(" Video", -1))
                ])) : ae.e.it.model3d ? (g(), b("span", $2e, [
                  C($, {
                    name: "Box",
                    size: 9
                  }),
                  Q[36] || (Q[36] = J(" 3D", -1))
                ])) : z("", !0),
                m(s).canStar(ae.e.it) ? (g(), b("button", {
                  key: 3,
                  class: G(["lb-star", { on: m(s).faved(ae.e.it) }]),
                  title: m(s).faved(ae.e.it) ? "Remove from your favorites" : "Add to your favorites",
                  "aria-pressed": m(s).faved(ae.e.it),
                  "data-testid": "library-star",
                  onClick: Se((Le) => Te(ae.e.it), ["stop"])
                }, [
                  C($, {
                    name: "Heart",
                    size: 13
                  })
                ], 10, D2e)) : m(s).faved(ae.e.it) ? (g(), b("span", O2e, [
                  C($, {
                    name: "Heart",
                    size: 13
                  })
                ])) : z("", !0),
                F.value && !ae.e.it.moderated ? (g(), b("button", {
                  key: 5,
                  class: G(["lb-check", { on: m(s).order(ae.e.it.id) > 0, "is-single": a }]),
                  "aria-label": m(s).order(ae.e.it.id) ? "Unpick" : "Pick",
                  "aria-pressed": m(s).order(ae.e.it.id) > 0,
                  onClick: Se((Le) => de(ae.e.it), ["stop"])
                }, [
                  m(s).order(ae.e.it.id) ? (g(), b("span", B2e, E(m(s).order(ae.e.it.id)), 1)) : (g(), Ce($, {
                    key: 1,
                    name: a ? "Check" : "Plus",
                    size: 13
                  }, null, 8, ["name"]))
                ], 10, L2e)) : ae.e.it.moderated ? z("", !0) : (g(), b("button", {
                  key: 6,
                  class: "lb-look",
                  title: "Look at it large",
                  onClick: Se((Le) => m(o).peek = ae.e.it, ["stop"])
                }, [
                  C($, {
                    name: "Maximize2",
                    size: 12
                  })
                ], 8, F2e))
              ], 46, _2e))
            ], 64))), 128))
          ], 4)),
          A.value.loaded && A.value.loading ? (g(), b("div", N2e, [...Q[37] || (Q[37] = [
            u("span", { class: "bd-spinner is-sm" }, null, -1),
            J(" Loading more", -1)
          ])])) : A.value.loaded && A.value.failed ? (g(), b("div", U2e, [
            J(E(A.value.error || "Couldn't load more") + " ", 1),
            u("button", {
              class: "lb-link",
              onClick: Q[12] || (Q[12] = (ae) => m(s).retry())
            }, "Try again")
          ])) : A.value.loaded && A.value.next !== null ? (g(), b("div", G2e, [
            u("button", {
              class: "lb-btn",
              "data-testid": "library-more",
              onClick: Q[13] || (Q[13] = (ae) => m(s).load(m(o).tab, !0))
            }, "Load more")
          ])) : A.value.loaded && R.value.length > D.value * 2 ? (g(), b("div", j2e, "That's everything" + E(B.value ? " that matches" : ""), 1)) : z("", !0)
        ], 34),
        C(vt, { name: "lb-tray" }, {
          default: Xe(() => [
            F.value && !a ? (g(), b("footer", H2e, [
              u("div", V2e, [
                (g(!0), b(j, null, be(m(o).picked.slice(-5), (ae, Le) => (g(), b("span", {
                  key: ae.id,
                  class: "lb-tray-thumb",
                  style: ce({ backgroundImage: 'url("' + re(ae) + '")', zIndex: Le })
                }, null, 4))), 128)),
                u("span", W2e, [
                  u("b", null, E(m(o).picked.length), 1),
                  J(" of " + E(m(t).max) + " picked ", 1)
                ])
              ]),
              m(o).picked.length ? (g(), b("button", {
                key: 0,
                class: "lb-tray-clear",
                "data-testid": "library-clear",
                onClick: Q[14] || (Q[14] = (ae) => m(s).clear())
              }, "Clear")) : z("", !0),
              Q[38] || (Q[38] = u("span", { class: "lb-grow" }, null, -1)),
              u("button", {
                class: "lb-btn is-ghost",
                "data-testid": "library-cancel",
                onClick: ue
              }, "Cancel"),
              u("button", {
                class: "lb-btn is-primary",
                disabled: !m(o).picked.length,
                "data-testid": "library-confirm",
                onClick: pe
              }, [
                C($, {
                  name: r ? "ArrowDownToLine" : "Check",
                  size: 14
                }, null, 8, ["name"]),
                J(" " + E(se.value), 1)
              ], 8, q2e)
            ])) : z("", !0)
          ]),
          _: 1
        }),
        C(vt, { name: "lb-note" }, {
          default: Xe(() => [
            v.value ? (g(), b("div", {
              key: v.value.id,
              class: G(["lb-note", { "is-error": v.value.tone === "error" }]),
              role: "status"
            }, E(v.value.text), 3)) : z("", !0)
          ]),
          _: 1
        }),
        m(x) ? (g(), b("div", K2e, [
          u("div", null, [
            C($, {
              name: "Upload",
              size: 18
            }),
            Q[39] || (Q[39] = J(" Drop images to upload them to your Library", -1))
          ])
        ])) : z("", !0),
        m(o).peek ? (g(), Ce(Uwe, {
          key: 3,
          lib: m(s),
          item: m(o).peek,
          placing: r,
          single: a,
          model: Y(m(o).peek),
          onClose: Q[15] || (Q[15] = (ae) => m(o).peek = null),
          onPick: de,
          onStar: Te,
          onRemove: Be
        }, null, 8, ["lib", "item", "model"])) : z("", !0),
        u("input", {
          ref_key: "fileEl",
          ref: h,
          type: "file",
          accept: "image/*",
          multiple: "",
          style: { display: "none" },
          onChange: Ve
        }, null, 544)
      ])
    ], 32));
  }
}), X2e = {
  image: ["image", "images"],
  frame: ["frame", "frames"],
  note: ["note", "notes"],
  shape: ["shape", "shapes"],
  tool: ["session", "sessions"],
  studio: ["studio record", "studio records"],
  chat: ["chat", "chats"]
}, J2e = ["image", "tool", "note", "frame", "shape", "chat", "studio"], Z2e = /* @__PURE__ */ new Set(["Add", "Edit", "Delete", "Remote"]);
function rA(i) {
  const e = [];
  for (const t of J2e) {
    const n = i[t] || 0;
    n && e.push(n + " " + X2e[t][n === 1 ? 0 : 1]);
  }
  return e.join(", ") || "nothing";
}
function Q2e(i) {
  if (i.ephemeral || i.origin === "load") return null;
  const e = /* @__PURE__ */ new Map();
  for (const a of i.added) e.set(a.id, a.type);
  for (const a of i.updated) e.set(a.id, a.el.type);
  for (const a of i.removed) e.set(a.id, a.type);
  if (!e.size) return null;
  const t = {};
  for (const a of e.values()) t[a] = (t[a] || 0) + 1;
  const n = rA(t), s = Array.from(e.keys()), o = s.slice(0, 6).join(", ") + (s.length > 6 ? " and " + (s.length - 6) + " more" : "");
  if (i.origin === "remote") return { kind: "remote", label: "Someone else's edit: " + n, detail: o };
  let r = i.label;
  return (!r || Z2e.has(r)) && (r = i.removed.length && !i.added.length && !i.updated.length ? "Delete" : i.added.length && !i.updated.length && !i.removed.length ? "Add" : "Edit"), { kind: "edit", label: r + ": " + n, detail: o };
}
const aA = [
  ["the board menu", (i) => i.ui.boardMenu],
  ["Keyboard Shortcuts", (i) => i.ui.keysOpen],
  ["Recently Deleted", (i) => i.ui.trashOpen],
  ["the board's history", (i) => i.ui.boardHistory],
  ["image info", (i) => !!i.ui.infoAt],
  ["the Studios view", (i) => !!i.ui.studio],
  ["your Library", (i) => !!i.ui.libraryOpen],
  ["the prompt library", (i) => i.ui.library.open],
  ["the add menu", (i) => i.ui.addMenu],
  ["the place image menu", (i) => i.ui.placeMenu],
  ["the canvas menu", (i) => !!i.ui.canvasMenu],
  ["the session finder", (i) => !!i.ui.finder],
  ["the eyedropper", (i) => !!i.ui.eyedropper]
];
function lA(i) {
  return aA.filter(([, e]) => e(i)).map(([e]) => e);
}
function e_e(i) {
  const e = {};
  for (const t of i.ui.selection) {
    const n = i.store.get(t);
    n && (e[n.type] = (e[n.type] || 0) + 1);
  }
  return rA(e);
}
const b4 = {
  error: "Saving failed; the board is retrying",
  offline: "The board went offline; changes are kept here"
};
function t_e(i, e) {
  const t = [];
  let n = 0, s = 0;
  i.record("board", "Opened a board", e.meta.id), t.push(e.store.subscribe((o) => {
    const r = Q2e(o);
    r && i.record(r.kind, r.label, r.detail);
  })), t.push(Ae(() => e.loaded.value, (o) => {
    o && i.record("board", 'Loaded "' + e.meta.title + '": ' + e.store.size + " elements");
  })), t.push(Ae(() => e.loadError.value, (o) => {
    o && i.record("error", "The board didn't open: " + o);
  })), e.onStep = (o, r, a) => i.record(o, r, a), t.push(Ae(() => e.ui.mode, (o) => i.record("tool", o === "hand" ? "Chose the Hand tool" : "Chose the Select tool"))), t.push(Ae(() => e.ui.shapeArmed ? e.ui.shapeKind : null, (o) => {
    o && i.record("tool", "Chose the " + o + " tool");
  })), t.push(Ae(() => e.ui.selection.slice(), () => {
    clearTimeout(n), n = window.setTimeout(() => {
      i.record("select", e.ui.selection.length ? "Selected " + e_e(e) : "Cleared the selection", e.ui.selection.slice(0, 6).join(", ") || void 0);
    }, 450);
  }));
  for (const [o, r] of aA)
    t.push(Ae(() => r(e), (a) => i.record("panel", (a ? "Opened " : "Closed ") + o)));
  return t.push(Ae(() => e.ui.toast ? e.ui.toast.id : 0, () => {
    const o = e.ui.toast;
    o && i.record(o.tone === "error" ? "error" : "toast", 'The board said: "' + o.text + '"');
  })), t.push(Ae(() => e.saveState.value, (o, r) => {
    b4[o] ? i.record("save", b4[o]) : o === "saved" && (r === "error" || r === "offline") && i.record("save", "Saved again");
  })), t.push(e.onCameraFrame((o) => {
    clearTimeout(s), s = window.setTimeout(() => {
      i.record("view", "Moved the view (" + Math.round(o.zoom * 100) + "%)", "x " + Math.round(o.x) + ", y " + Math.round(o.y));
    }, 700);
  })), () => {
    for (const o of t) o();
    clearTimeout(n), clearTimeout(s), e.onStep && (e.onStep = null), i.record("board", "Left the board", e.meta.id);
  };
}
const dA = "[modern-screenshot]", jl = typeof window != "undefined", n_e = jl && "Worker" in window;
var $3;
const ux = jl ? ($3 = window.navigator) == null ? void 0 : $3.userAgent : "", cA = ux.includes("Chrome"), Lf = ux.includes("AppleWebKit") && !cA, hx = ux.includes("Firefox"), i_e = (i) => i && "__CONTEXT__" in i, s_e = (i) => i.constructor.name === "CSSFontFaceRule", o_e = (i) => i.constructor.name === "CSSImportRule", r_e = (i) => i.constructor.name === "CSSLayerBlockRule", Ms = (i) => i.nodeType === 1, Tu = (i) => typeof i.className == "object", uA = (i) => i.tagName === "image", a_e = (i) => i.tagName === "use", ru = (i) => Ms(i) && typeof i.style != "undefined" && !Tu(i), l_e = (i) => i.nodeType === 8, d_e = (i) => i.nodeType === 3, Hl = (i) => i.tagName === "IMG", wm = (i) => i.tagName === "VIDEO", c_e = (i) => i.tagName === "CANVAS", u_e = (i) => i.tagName === "TEXTAREA", h_e = (i) => i.tagName === "INPUT", p_e = (i) => i.tagName === "STYLE", f_e = (i) => i.tagName === "SCRIPT", m_e = (i) => i.tagName === "SELECT", g_e = (i) => i.tagName === "SLOT", b_e = (i) => i.tagName === "IFRAME", v_e = (...i) => console.warn(dA, ...i);
function y_e(i) {
  var t;
  const e = (t = i == null ? void 0 : i.createElement) == null ? void 0 : t.call(i, "canvas");
  return e && (e.height = e.width = 1), !!e && "toDataURL" in e && !!e.toDataURL("image/webp").includes("image/webp");
}
const N0 = (i) => i.startsWith("data:");
function hA(i, e) {
  if (i.match(/^[a-z]+:\/\//i))
    return i;
  if (jl && i.match(/^\/\//))
    return window.location.protocol + i;
  if (i.match(/^[a-z]+:/i) || !jl)
    return i;
  const t = km().implementation.createHTMLDocument(), n = t.createElement("base"), s = t.createElement("a");
  return t.head.appendChild(n), t.body.appendChild(s), e && (n.href = e), s.href = i, s.href;
}
function km(i) {
  var e;
  return (e = i && Ms(i) ? i == null ? void 0 : i.ownerDocument : i) != null ? e : window.document;
}
const _m = "http://www.w3.org/2000/svg";
function x_e(i, e, t) {
  const n = km(t).createElementNS(_m, "svg");
  return n.setAttributeNS(null, "width", i.toString()), n.setAttributeNS(null, "height", e.toString()), n.setAttributeNS(null, "viewBox", `0 0 ${i} ${e}`), n;
}
function w_e(i, e) {
  let t = new XMLSerializer().serializeToString(i);
  return e && (t = t.replace(/[\u0000-\u0008\v\f\u000E-\u001F\uD800-\uDFFF\uFFFE\uFFFF]/gu, "")), `data:image/svg+xml;charset=utf-8,${encodeURIComponent(t)}`;
}
function k_e(i, e) {
  return new Promise((t, n) => {
    const s = new FileReader();
    s.onload = () => t(s.result), s.onerror = () => n(s.error), s.onabort = () => n(new Error(`Failed read blob to ${e}`)), s.readAsDataURL(i);
  });
}
const __e = (i) => k_e(i, "dataUrl");
function _l(i, e) {
  const t = km(e).createElement("img");
  return t.decoding = "sync", t.loading = "eager", t.src = i, t;
}
function au(i, e) {
  return new Promise((t) => {
    const { timeout: n, ownerDocument: s, onError: o, onWarn: r } = e != null ? e : {}, a = typeof i == "string" ? _l(i, km(s)) : i;
    let l = null, d = null;
    function c() {
      t(a), l && clearTimeout(l), d == null || d();
    }
    if (n && (l = setTimeout(c, n)), wm(a)) {
      const h = a.currentSrc || a.src;
      if (!h)
        return a.poster ? au(a.poster, e).then(t) : c();
      if (a.readyState >= 2)
        return c();
      const f = c, p = (y) => {
        r == null || r(
          "Failed video load",
          h,
          y
        ), o == null || o(y), c();
      };
      d = () => {
        a.removeEventListener("loadeddata", f), a.removeEventListener("error", p);
      }, a.addEventListener("loadeddata", f, { once: !0 }), a.addEventListener("error", p, { once: !0 });
    } else {
      const h = uA(a) ? a.href.baseVal : a.currentSrc || a.src;
      if (!h)
        return c();
      const f = async () => {
        if (Hl(a) && "decode" in a)
          try {
            await a.decode();
          } catch (y) {
            r == null || r(
              "Failed to decode image, trying to render anyway",
              a.dataset.originalSrc || h,
              y
            );
          }
        c();
      }, p = (y) => {
        r == null || r(
          "Failed image load",
          a.dataset.originalSrc || h,
          y
        ), c();
      };
      if (Hl(a) && a.complete)
        return f();
      d = () => {
        a.removeEventListener("load", f), a.removeEventListener("error", p);
      }, a.addEventListener("load", f, { once: !0 }), a.addEventListener("error", p, { once: !0 });
    }
  });
}
async function S_e(i, e) {
  ru(i) && (Hl(i) || wm(i) ? await au(i, e) : await Promise.all(
    ["img", "video"].flatMap((t) => Array.from(i.querySelectorAll(t)).map((n) => au(n, e)))
  ));
}
const pA = /* @__PURE__ */ (function() {
  let e = 0;
  const t = () => `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4);
  return () => (e += 1, `u${t()}${e}`);
})();
function fA(i) {
  return i == null ? void 0 : i.split(",").map((e) => e.trim().replace(/"|'/g, "").toLowerCase()).filter(Boolean);
}
let v4 = 0;
function M_e(i) {
  const e = `${dA}[#${v4}]`;
  return v4++, {
    // eslint-disable-next-line no-console
    time: (t) => i && console.time(`${e} ${t}`),
    // eslint-disable-next-line no-console
    timeEnd: (t) => i && console.timeEnd(`${e} ${t}`),
    warn: (...t) => i && v_e(...t)
  };
}
function T_e(i) {
  return {
    cache: i ? "no-cache" : "force-cache"
  };
}
async function mA(i, e) {
  return i_e(i) ? i : C_e(i, { ...e, autoDestruct: !0 });
}
async function C_e(i, e) {
  var p, y, v, x, w;
  const { scale: t = 1, workerUrl: n, workerNumber: s = 1 } = e || {}, o = !!(e != null && e.debug), r = (p = e == null ? void 0 : e.features) != null ? p : !0, a = (y = i.ownerDocument) != null ? y : jl ? window.document : void 0, l = (x = (v = i.ownerDocument) == null ? void 0 : v.defaultView) != null ? x : jl ? window : void 0, d = /* @__PURE__ */ new Map(), c = {
    // Options
    width: 0,
    height: 0,
    quality: 1,
    type: "image/png",
    scale: t,
    backgroundColor: null,
    style: null,
    filter: null,
    maximumCanvasSize: 0,
    timeout: 3e4,
    progress: null,
    debug: o,
    fetch: {
      requestInit: T_e((w = e == null ? void 0 : e.fetch) == null ? void 0 : w.bypassingCache),
      placeholderImage: "data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      bypassingCache: !1,
      ...e == null ? void 0 : e.fetch
    },
    fetchFn: null,
    font: {},
    drawImageInterval: 100,
    workerUrl: null,
    workerNumber: s,
    onCloneEachNode: null,
    onCloneNode: null,
    onEmbedNode: null,
    onCreateForeignObjectSvg: null,
    includeStyleProperties: null,
    autoDestruct: !1,
    ...e,
    // InternalContext
    __CONTEXT__: !0,
    log: M_e(o),
    node: i,
    ownerDocument: a,
    ownerWindow: l,
    dpi: t === 1 ? null : 96 * t,
    svgStyleElement: gA(a),
    svgDefsElement: a == null ? void 0 : a.createElementNS(_m, "defs"),
    svgStyles: /* @__PURE__ */ new Map(),
    defaultComputedStyles: /* @__PURE__ */ new Map(),
    workers: [
      ...Array.from({
        length: n_e && n && s ? s : 0
      })
    ].map(() => {
      try {
        const S = new Worker(n);
        return S.onmessage = async (M) => {
          var k, P, A, R;
          const { url: _, result: T } = M.data;
          T ? (P = (k = d.get(_)) == null ? void 0 : k.resolve) == null || P.call(k, T) : (R = (A = d.get(_)) == null ? void 0 : A.reject) == null || R.call(A, new Error(`Error receiving message from worker: ${_}`));
        }, S.onmessageerror = (M) => {
          var T, k;
          const { url: _ } = M.data;
          (k = (T = d.get(_)) == null ? void 0 : T.reject) == null || k.call(T, new Error(`Error receiving message from worker: ${_}`));
        }, S;
      } catch (S) {
        return c.log.warn("Failed to new Worker", S), null;
      }
    }).filter(Boolean),
    fontFamilies: /* @__PURE__ */ new Map(),
    fontCssTexts: /* @__PURE__ */ new Map(),
    acceptOfImage: `${[
      y_e(a) && "image/webp",
      "image/svg+xml",
      "image/*",
      "*/*"
    ].filter(Boolean).join(",")};q=0.8`,
    requests: d,
    drawImageCount: 0,
    tasks: [],
    features: r,
    isEnable: (S) => {
      var M, _;
      return S === "restoreScrollPosition" ? typeof r == "boolean" ? !1 : (M = r[S]) != null ? M : !1 : typeof r == "boolean" ? r : (_ = r[S]) != null ? _ : !0;
    },
    shadowRoots: []
  };
  c.log.time("wait until load"), await S_e(i, { timeout: c.timeout, onWarn: c.log.warn }), c.log.timeEnd("wait until load");
  const { width: h, height: f } = I_e(i, c);
  return c.width = h, c.height = f, c;
}
function gA(i) {
  if (!i)
    return;
  const e = i.createElement("style"), t = e.ownerDocument.createTextNode(`
.______background-clip--text {
  background-clip: text;
  -webkit-background-clip: text;
}
`);
  return e.appendChild(t), e;
}
function I_e(i, e) {
  let { width: t, height: n } = e;
  if (Ms(i) && (!t || !n)) {
    const s = i.getBoundingClientRect();
    t = t || s.width || Number(i.getAttribute("width")) || 0, n = n || s.height || Number(i.getAttribute("height")) || 0;
  }
  return { width: t, height: n };
}
async function A_e(i, e) {
  const {
    log: t,
    timeout: n,
    drawImageCount: s,
    drawImageInterval: o
  } = e;
  t.time("image to canvas");
  const r = await au(i, { timeout: n, onWarn: e.log.warn }), { canvas: a, context2d: l } = P_e(i.ownerDocument, e), d = () => {
    try {
      l == null || l.drawImage(r, 0, 0, a.width, a.height);
    } catch (c) {
      e.log.warn("Failed to drawImage", c);
    }
  };
  if (d(), e.isEnable("fixSvgXmlDecode"))
    for (let c = 0; c < s; c++)
      await new Promise((h) => {
        setTimeout(() => {
          l == null || l.clearRect(0, 0, a.width, a.height), d(), h();
        }, c + o);
      });
  return e.drawImageCount = 0, t.timeEnd("image to canvas"), a;
}
function P_e(i, e) {
  const { width: t, height: n, scale: s, backgroundColor: o, maximumCanvasSize: r } = e, a = i.createElement("canvas");
  a.width = Math.floor(t * s), a.height = Math.floor(n * s), a.style.width = `${t}px`, a.style.height = `${n}px`, r && (a.width > r || a.height > r) && (a.width > r && a.height > r ? a.width > a.height ? (a.height *= r / a.width, a.width = r) : (a.width *= r / a.height, a.height = r) : a.width > r ? (a.height *= r / a.width, a.width = r) : (a.width *= r / a.height, a.height = r));
  const l = a.getContext("2d");
  return l && o && (l.fillStyle = o, l.fillRect(0, 0, a.width, a.height)), { canvas: a, context2d: l };
}
function bA(i, e) {
  if (i.ownerDocument)
    try {
      const o = i.toDataURL();
      if (o !== "data:,")
        return _l(o, i.ownerDocument);
    } catch (o) {
      e.log.warn("Failed to clone canvas", o);
    }
  const t = i.cloneNode(!1), n = i.getContext("2d"), s = t.getContext("2d");
  try {
    return n && s && s.putImageData(
      n.getImageData(0, 0, i.width, i.height),
      0,
      0
    ), t;
  } catch (o) {
    e.log.warn("Failed to clone canvas", o);
  }
  return t;
}
function E_e(i, e) {
  var t;
  try {
    if ((t = i == null ? void 0 : i.contentDocument) != null && t.documentElement)
      return px(i.contentDocument.documentElement, e);
  } catch (n) {
    e.log.warn("Failed to clone iframe", n);
  }
  return i.cloneNode(!1);
}
function R_e(i) {
  const e = i.cloneNode(!1);
  return i.currentSrc && i.currentSrc !== i.src && (e.src = i.currentSrc, e.srcset = ""), e.loading === "lazy" && (e.loading = "eager"), e;
}
async function z_e(i, e) {
  if (i.ownerDocument && !i.currentSrc && i.poster)
    return _l(i.poster, i.ownerDocument);
  const t = i.cloneNode(!1);
  t.crossOrigin = "anonymous", i.currentSrc && i.currentSrc !== i.src && (t.src = i.currentSrc);
  const n = t.ownerDocument;
  if (n) {
    let s = !0;
    if (await au(t, { onError: () => s = !1, onWarn: e.log.warn }), !s)
      return i.poster ? _l(i.poster, i.ownerDocument) : t;
    t.currentTime = i.currentTime, await new Promise((r) => {
      t.addEventListener("seeked", r, { once: !0 });
    });
    const o = n.createElement("canvas");
    o.width = i.offsetWidth, o.height = i.offsetHeight;
    try {
      const r = o.getContext("2d");
      r && r.drawImage(t, 0, 0, o.width, o.height);
    } catch (r) {
      return e.log.warn("Failed to clone video", r), i.poster ? _l(i.poster, i.ownerDocument) : t;
    }
    return bA(o, e);
  }
  return t;
}
function $_e(i, e) {
  return c_e(i) ? bA(i, e) : b_e(i) ? E_e(i, e) : Hl(i) ? R_e(i) : wm(i) ? z_e(i, e) : i.cloneNode(!1);
}
function D_e(i) {
  let e = i.sandbox;
  if (!e) {
    const { ownerDocument: t } = i;
    try {
      t && (e = t.createElement("iframe"), e.id = `__SANDBOX__${pA()}`, e.width = "0", e.height = "0", e.style.visibility = "hidden", e.style.position = "fixed", t.body.appendChild(e), e.srcdoc = '<!DOCTYPE html><meta charset="UTF-8"><title></title><body>', i.sandbox = e);
    } catch (n) {
      i.log.warn("Failed to getSandBox", n);
    }
  }
  return e;
}
const O_e = [
  "width",
  "height",
  "-webkit-text-fill-color"
], L_e = [
  "stroke",
  "fill"
];
function vA(i, e, t) {
  const { defaultComputedStyles: n } = t, s = i.nodeName.toLowerCase(), o = Tu(i) && s !== "svg", r = o ? L_e.map((v) => [v, i.getAttribute(v)]).filter(([, v]) => v !== null) : [], a = [
    o && "svg",
    s,
    r.map((v, x) => `${v}=${x}`).join(","),
    e
  ].filter(Boolean).join(":");
  if (n.has(a))
    return n.get(a);
  const l = D_e(t), d = l == null ? void 0 : l.contentWindow;
  if (!d)
    return /* @__PURE__ */ new Map();
  const c = d == null ? void 0 : d.document;
  let h, f;
  o ? (h = c.createElementNS(_m, "svg"), f = h.ownerDocument.createElementNS(h.namespaceURI, s), r.forEach(([v, x]) => {
    f.setAttributeNS(null, v, x);
  }), h.appendChild(f)) : h = f = c.createElement(s), f.textContent = " ", c.body.appendChild(h);
  const p = d.getComputedStyle(f, e), y = /* @__PURE__ */ new Map();
  for (let v = p.length, x = 0; x < v; x++) {
    const w = p.item(x);
    O_e.includes(w) || y.set(w, p.getPropertyValue(w));
  }
  return c.body.removeChild(h), n.set(a, y), y;
}
function yA(i, e, t) {
  var a;
  const n = /* @__PURE__ */ new Map(), s = [], o = /* @__PURE__ */ new Map();
  if (t)
    for (const l of t)
      r(l);
  else
    for (let l = i.length, d = 0; d < l; d++) {
      const c = i.item(d);
      r(c);
    }
  for (let l = s.length, d = 0; d < l; d++)
    (a = o.get(s[d])) == null || a.forEach((c, h) => n.set(h, c));
  function r(l) {
    const d = i.getPropertyValue(l), c = i.getPropertyPriority(l), h = l.lastIndexOf("-"), f = h > -1 ? l.substring(0, h) : void 0;
    if (f) {
      let p = o.get(f);
      p || (p = /* @__PURE__ */ new Map(), o.set(f, p)), p.set(l, [d, c]);
    }
    e.get(l) === d && !c || (f ? s.push(f) : n.set(l, [d, c]));
  }
  return n;
}
function B_e(i, e, t, n) {
  var h, f, p, y;
  const { ownerWindow: s, includeStyleProperties: o, currentParentNodeStyle: r } = n, a = e.style, l = s.getComputedStyle(i), d = vA(i, null, n);
  r == null || r.forEach((v, x) => {
    d.delete(x);
  });
  const c = yA(l, d, o);
  c.delete("transition-property"), c.delete("all"), c.delete("d"), c.delete("content"), t && (c.delete("position"), c.delete("margin-top"), c.delete("margin-right"), c.delete("margin-bottom"), c.delete("margin-left"), c.delete("margin-block-start"), c.delete("margin-block-end"), c.delete("margin-inline-start"), c.delete("margin-inline-end"), c.set("box-sizing", ["border-box", ""])), ((h = c.get("background-clip")) == null ? void 0 : h[0]) === "text" && e.classList.add("______background-clip--text"), cA && (c.has("font-kerning") || c.set("font-kerning", ["normal", ""]), (((f = c.get("overflow-x")) == null ? void 0 : f[0]) === "hidden" || ((p = c.get("overflow-y")) == null ? void 0 : p[0]) === "hidden") && ((y = c.get("text-overflow")) == null ? void 0 : y[0]) === "ellipsis" && i.scrollWidth === i.clientWidth && c.set("text-overflow", ["clip", ""]));
  for (let v = a.length, x = 0; x < v; x++)
    a.removeProperty(a.item(x));
  return c.forEach(([v, x], w) => {
    a.setProperty(w, v, x);
  }), c;
}
function F_e(i, e) {
  (u_e(i) || h_e(i) || m_e(i)) && e.setAttribute("value", i.value);
}
const N_e = [
  "::before",
  "::after"
  // '::placeholder', TODO
], U_e = [
  "::-webkit-scrollbar",
  "::-webkit-scrollbar-button",
  // '::-webkit-scrollbar:horizontal', TODO
  "::-webkit-scrollbar-thumb",
  "::-webkit-scrollbar-track",
  "::-webkit-scrollbar-track-piece",
  // '::-webkit-scrollbar:vertical', TODO
  "::-webkit-scrollbar-corner",
  "::-webkit-resizer"
];
function G_e(i, e, t, n, s) {
  const { ownerWindow: o, svgStyleElement: r, svgStyles: a, currentNodeStyle: l } = n;
  if (!r || !o)
    return;
  function d(c) {
    var M;
    const h = o.getComputedStyle(i, c);
    let f = h.getPropertyValue("content");
    if (!f || f === "none")
      return;
    s == null || s(f), f = f.replace(/(')|(")|(counter\(.+\))/g, "");
    const p = [pA()], y = vA(i, c, n);
    l == null || l.forEach((_, T) => {
      y.delete(T);
    });
    const v = yA(h, y, n.includeStyleProperties);
    v.delete("content"), v.delete("-webkit-locale"), ((M = v.get("background-clip")) == null ? void 0 : M[0]) === "text" && e.classList.add("______background-clip--text");
    const x = [
      `content: '${f}';`
    ];
    if (v.forEach(([_, T], k) => {
      x.push(`${k}: ${_}${T ? " !important" : ""};`);
    }), x.length === 1)
      return;
    try {
      e.className = [e.className, ...p].join(" ");
    } catch (_) {
      n.log.warn("Failed to copyPseudoClass", _);
      return;
    }
    const w = x.join(`
  `);
    let S = a.get(w);
    S || (S = [], a.set(w, S)), S.push(`.${p[0]}${c}`);
  }
  N_e.forEach(d), t && U_e.forEach(d);
}
const y4 = /* @__PURE__ */ new Set([
  "symbol"
  // test/fixtures/svg.symbol.html
]);
async function x4(i, e, t, n, s) {
  if (Ms(t) && (p_e(t) || f_e(t)) || n.filter && !n.filter(t))
    return;
  y4.has(e.nodeName) || y4.has(t.nodeName) ? n.currentParentNodeStyle = void 0 : n.currentParentNodeStyle = n.currentNodeStyle;
  const o = await px(t, n, !1, s);
  n.isEnable("restoreScrollPosition") && j_e(i, o), e.appendChild(o);
}
async function w4(i, e, t, n) {
  var o;
  let s = i.firstChild;
  Ms(i) && i.shadowRoot && (s = (o = i.shadowRoot) == null ? void 0 : o.firstChild, t.shadowRoots.push(i.shadowRoot));
  for (let r = s; r; r = r.nextSibling)
    if (!l_e(r))
      if (Ms(r) && g_e(r) && typeof r.assignedNodes == "function") {
        const a = r.assignedNodes();
        for (let l = 0; l < a.length; l++)
          await x4(i, e, a[l], t, n);
      } else
        await x4(i, e, r, t, n);
}
function j_e(i, e) {
  if (!ru(i) || !ru(e))
    return;
  const { scrollTop: t, scrollLeft: n } = i;
  if (!t && !n)
    return;
  const { transform: s } = e.style, o = new DOMMatrix(s), { a: r, b: a, c: l, d } = o;
  o.a = 1, o.b = 0, o.c = 0, o.d = 1, o.translateSelf(-n, -t), o.a = r, o.b = a, o.c = l, o.d = d, e.style.transform = o.toString();
}
function H_e(i, e) {
  const { backgroundColor: t, width: n, height: s, style: o } = e, r = i.style;
  if (t && r.setProperty("background-color", t, "important"), n && r.setProperty("width", `${n}px`, "important"), s && r.setProperty("height", `${s}px`, "important"), o)
    for (const a in o) r[a] = o[a];
}
const V_e = /^[\w-:]+$/;
async function px(i, e, t = !1, n) {
  var d, c, h, f;
  const { ownerDocument: s, ownerWindow: o, fontFamilies: r, onCloneEachNode: a } = e;
  if (s && d_e(i))
    return n && /\S/.test(i.data) && n(i.data), s.createTextNode(i.data);
  if (s && o && Ms(i) && (ru(i) || Tu(i))) {
    const p = await $_e(i, e);
    if (e.isEnable("removeAbnormalAttributes")) {
      const M = p.getAttributeNames();
      for (let _ = M.length, T = 0; T < _; T++) {
        const k = M[T];
        V_e.test(k) || p.removeAttribute(k);
      }
    }
    const y = e.currentNodeStyle = B_e(i, p, t, e);
    t && H_e(p, e);
    let v = !1;
    if (e.isEnable("copyScrollbar")) {
      const M = [
        (d = y.get("overflow-x")) == null ? void 0 : d[0],
        (c = y.get("overflow-y")) == null ? void 0 : c[0]
      ];
      v = M.includes("scroll") || (M.includes("auto") || M.includes("overlay")) && (i.scrollHeight > i.clientHeight || i.scrollWidth > i.clientWidth);
    }
    const x = (h = y.get("text-transform")) == null ? void 0 : h[0], w = fA((f = y.get("font-family")) == null ? void 0 : f[0]), S = w ? (M) => {
      x === "uppercase" ? M = M.toUpperCase() : x === "lowercase" ? M = M.toLowerCase() : x === "capitalize" && (M = M[0].toUpperCase() + M.substring(1)), w.forEach((_) => {
        let T = r.get(_);
        T || r.set(_, T = /* @__PURE__ */ new Set()), M.split("").forEach((k) => T.add(k));
      });
    } : void 0;
    return G_e(
      i,
      p,
      v,
      e,
      S
    ), F_e(i, p), wm(i) || await w4(
      i,
      p,
      e,
      S
    ), await (a == null ? void 0 : a(p)), p;
  }
  const l = i.cloneNode(!1);
  return await w4(i, l, e), await (a == null ? void 0 : a(l)), l;
}
function W_e(i) {
  if (i.ownerDocument = void 0, i.ownerWindow = void 0, i.svgStyleElement = void 0, i.svgDefsElement = void 0, i.svgStyles.clear(), i.defaultComputedStyles.clear(), i.sandbox) {
    try {
      i.sandbox.remove();
    } catch (e) {
      i.log.warn("Failed to destroyContext", e);
    }
    i.sandbox = void 0;
  }
  i.workers = [], i.fontFamilies.clear(), i.fontCssTexts.clear(), i.requests.clear(), i.tasks = [], i.shadowRoots = [];
}
function q_e(i) {
  const { url: e, timeout: t, responseType: n, ...s } = i, o = new AbortController(), r = t ? setTimeout(() => o.abort(), t) : void 0;
  return fetch(e, { signal: o.signal, ...s }).then((a) => {
    if (!a.ok)
      throw new Error("Failed fetch, not 2xx response", { cause: a });
    switch (n) {
      case "arrayBuffer":
        return a.arrayBuffer();
      case "dataUrl":
        return a.blob().then(__e);
      default:
        return a.text();
    }
  }).finally(() => clearTimeout(r));
}
function lu(i, e) {
  const { url: t, requestType: n = "text", responseType: s = "text", imageDom: o } = e;
  let r = t;
  const {
    timeout: a,
    acceptOfImage: l,
    requests: d,
    fetchFn: c,
    fetch: {
      requestInit: h,
      bypassingCache: f,
      placeholderImage: p
    },
    font: y,
    workers: v,
    fontFamilies: x
  } = i;
  n === "image" && (Lf || hx) && i.drawImageCount++;
  let w = d.get(t);
  if (!w) {
    f && f instanceof RegExp && f.test(r) && (r += (/\?/.test(r) ? "&" : "?") + (/* @__PURE__ */ new Date()).getTime());
    const S = n.startsWith("font") && y && y.minify, M = /* @__PURE__ */ new Set();
    S && n.split(";")[1].split(",").forEach((P) => {
      x.has(P) && x.get(P).forEach((A) => M.add(A));
    });
    const _ = S && M.size, T = {
      url: r,
      timeout: a,
      responseType: _ ? "arrayBuffer" : s,
      headers: n === "image" ? { accept: l } : void 0,
      ...h
    };
    w = {
      type: n,
      resolve: void 0,
      reject: void 0,
      response: null
    }, w.response = (async () => {
      if (c && n === "image") {
        const k = await c(t);
        if (k)
          return k;
      }
      return !Lf && t.startsWith("http") && v.length ? new Promise((k, P) => {
        v[d.size & v.length - 1].postMessage({ rawUrl: t, ...T }), w.resolve = k, w.reject = P;
      }) : q_e(T);
    })().catch((k) => {
      if (d.delete(t), n === "image" && p)
        return i.log.warn("Failed to fetch image base64, trying to use placeholder image", r), typeof p == "string" ? p : p(o);
      throw k;
    }), d.set(t, w);
  }
  return w.response;
}
async function xA(i, e, t, n) {
  if (!wA(i))
    return i;
  for (const [s, o] of K_e(i, e))
    try {
      const r = await lu(
        t,
        {
          url: o,
          requestType: n ? "image" : "text",
          responseType: "dataUrl"
        }
      );
      i = i.replace(Y_e(s), `$1${r}$3`);
    } catch (r) {
      t.log.warn("Failed to fetch css data url", s, r);
    }
  return i;
}
function wA(i) {
  return /url\((['"]?)([^'"]+?)\1\)/.test(i);
}
const kA = /url\((['"]?)([^'"]+?)\1\)/g;
function K_e(i, e) {
  const t = [];
  return i.replace(kA, (n, s, o) => (t.push([o, hA(o, e)]), n)), t.filter(([n]) => !N0(n));
}
function Y_e(i) {
  const e = i.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
  return new RegExp(`(url\\(['"]?)(${e})(['"]?\\))`, "g");
}
const X_e = [
  "background-image",
  "border-image-source",
  "-webkit-border-image",
  "-webkit-mask-image",
  "list-style-image"
];
function J_e(i, e) {
  return X_e.map((t) => {
    const n = i.getPropertyValue(t);
    return !n || n === "none" ? null : ((Lf || hx) && e.drawImageCount++, xA(n, null, e, !0).then((s) => {
      !s || n === s || i.setProperty(
        t,
        s,
        i.getPropertyPriority(t)
      );
    }));
  }).filter(Boolean);
}
function Z_e(i, e) {
  if (Hl(i)) {
    const t = i.currentSrc || i.src;
    if (!N0(t))
      return [
        lu(e, {
          url: t,
          imageDom: i,
          requestType: "image",
          responseType: "dataUrl"
        }).then((n) => {
          n && (i.srcset = "", i.dataset.originalSrc = t, i.src = n || "");
        })
      ];
    (Lf || hx) && e.drawImageCount++;
  } else if (Tu(i) && !N0(i.href.baseVal)) {
    const t = i.href.baseVal;
    return [
      lu(e, {
        url: t,
        imageDom: i,
        requestType: "image",
        responseType: "dataUrl"
      }).then((n) => {
        n && (i.dataset.originalSrc = t, i.href.baseVal = n || "");
      })
    ];
  }
  return [];
}
function Q_e(i, e) {
  var a;
  const { ownerDocument: t, svgDefsElement: n } = e, s = (a = i.getAttribute("href")) != null ? a : i.getAttribute("xlink:href");
  if (!s)
    return [];
  const [o, r] = s.split("#");
  if (r) {
    const l = `#${r}`, d = e.shadowRoots.reduce(
      (c, h) => c != null ? c : h.querySelector(`svg ${l}`),
      t == null ? void 0 : t.querySelector(`svg ${l}`)
    );
    if (o && i.setAttribute("href", l), n != null && n.querySelector(l))
      return [];
    if (d)
      return n == null || n.appendChild(d.cloneNode(!0)), [];
    if (o)
      return [
        lu(e, {
          url: o,
          responseType: "text"
        }).then((c) => {
          n == null || n.insertAdjacentHTML("beforeend", c);
        })
      ];
  }
  return [];
}
function _A(i, e) {
  const { tasks: t } = e;
  Ms(i) && ((Hl(i) || uA(i)) && t.push(...Z_e(i, e)), a_e(i) && t.push(...Q_e(i, e))), ru(i) && t.push(...J_e(i.style, e)), i.childNodes.forEach((n) => {
    _A(n, e);
  });
}
async function e4e(i, e) {
  const {
    ownerDocument: t,
    svgStyleElement: n,
    fontFamilies: s,
    fontCssTexts: o,
    tasks: r,
    font: a
  } = e;
  if (!(!t || !n || !s.size))
    if (a && a.cssText) {
      const l = _4(a.cssText, e);
      n.appendChild(t.createTextNode(`${l}
`));
    } else {
      const l = Array.from(t.styleSheets).filter((p) => {
        try {
          return "cssRules" in p && !!p.cssRules.length;
        } catch (y) {
          return e.log.warn(`Error while reading CSS rules from ${p.href}`, y), !1;
        }
      }), d = t.implementation.createHTMLDocument(""), c = d.createElement("style");
      d.head.appendChild(c);
      const h = c.sheet;
      await Promise.all(
        l.flatMap((p) => Array.from(p.cssRules).map(async (y) => {
          if (o_e(y)) {
            const v = y.href;
            let x = "";
            try {
              x = await lu(e, {
                url: v,
                requestType: "text",
                responseType: "text"
              });
            } catch (S) {
              e.log.warn(`Error fetch remote css import from ${v}`, S);
            }
            const w = x.replace(
              kA,
              (S, M, _) => S.replace(_, hA(_, v))
            );
            for (const S of n4e(w))
              try {
                h.insertRule(S, h.cssRules.length);
              } catch (M) {
                e.log.warn("Error inserting rule from remote css import", { rule: S, error: M });
              }
          }
        }))
      ), h.cssRules.length && l.push(h);
      const f = [];
      l.forEach((p) => {
        U0(p.cssRules, f);
      }), f.filter((p) => {
        var y;
        return s_e(p) && wA(p.style.getPropertyValue("src")) && ((y = fA(p.style.getPropertyValue("font-family"))) == null ? void 0 : y.some((v) => s.has(v)));
      }).forEach((p) => {
        const y = p, v = o.get(y.cssText);
        v ? n.appendChild(t.createTextNode(`${v}
`)) : r.push(
          xA(
            y.cssText,
            y.parentStyleSheet ? y.parentStyleSheet.href : null,
            e
          ).then((x) => {
            x = _4(x, e), o.set(y.cssText, x), n.appendChild(t.createTextNode(`${x}
`));
          })
        );
      });
    }
}
const t4e = /(\/\*[\s\S]*?\*\/)/g, k4 = /((@.*?keyframes [\s\S]*?){([\s\S]*?}\s*?)})/gi;
function n4e(i) {
  if (i == null)
    return [];
  const e = [];
  let t = i.replace(t4e, "");
  for (; ; ) {
    const o = k4.exec(t);
    if (!o)
      break;
    e.push(o[0]);
  }
  t = t.replace(k4, "");
  const n = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi, s = new RegExp(
    // eslint-disable-next-line
    "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})",
    "gi"
  );
  for (; ; ) {
    let o = n.exec(t);
    if (o)
      s.lastIndex = n.lastIndex;
    else if (o = s.exec(t), o)
      n.lastIndex = s.lastIndex;
    else
      break;
    e.push(o[0]);
  }
  return e;
}
const i4e = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g, s4e = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function _4(i, e) {
  const { font: t } = e, n = t ? t == null ? void 0 : t.preferredFormat : void 0;
  return n ? i.replace(s4e, (s) => {
    for (; ; ) {
      const [o, , r] = i4e.exec(s) || [];
      if (!r)
        return "";
      if (r === n)
        return `src: ${o};`;
    }
  }) : i;
}
function U0(i, e = []) {
  for (const t of Array.from(i))
    r_e(t) ? e.push(...U0(t.cssRules)) : "cssRules" in t ? U0(t.cssRules, e) : e.push(t);
  return e;
}
const o4e = /\bx?link:?href\s*=\s*["'](?!data:)[^"']+["']/i;
function r4e(i) {
  return o4e.test(i.innerHTML);
}
async function a4e(i, e) {
  const t = await mA(i, e);
  if (Ms(t.node) && Tu(t.node) && !r4e(t.node))
    return t.node;
  const {
    ownerDocument: n,
    log: s,
    tasks: o,
    svgStyleElement: r,
    svgDefsElement: a,
    svgStyles: l,
    font: d,
    progress: c,
    autoDestruct: h,
    onCloneNode: f,
    onEmbedNode: p,
    onCreateForeignObjectSvg: y
  } = t;
  s.time("clone node");
  const v = await px(t.node, t, !0);
  if (r && n) {
    let _ = "";
    l.forEach((T, k) => {
      _ += `${T.join(`,
`)} {
  ${k}
}
`;
    }), r.appendChild(n.createTextNode(_));
  }
  s.timeEnd("clone node"), await (f == null ? void 0 : f(v)), d !== !1 && Ms(v) && (s.time("embed web font"), await e4e(v, t), s.timeEnd("embed web font")), s.time("embed node"), _A(v, t);
  const x = o.length;
  let w = 0;
  const S = async () => {
    for (; ; ) {
      const _ = o.pop();
      if (!_)
        break;
      try {
        await _;
      } catch (T) {
        t.log.warn("Failed to run task", T);
      }
      c == null || c(++w, x);
    }
  };
  c == null || c(w, x), await Promise.all([...Array.from({ length: 4 })].map(S)), s.timeEnd("embed node"), await (p == null ? void 0 : p(v));
  const M = l4e(v, t);
  return a && M.insertBefore(a, M.children[0]), r && M.insertBefore(r, M.children[0]), h && W_e(t), await (y == null ? void 0 : y(M)), M;
}
function l4e(i, e) {
  const { width: t, height: n } = e, s = x_e(t, n, i.ownerDocument), o = s.ownerDocument.createElementNS(s.namespaceURI, "foreignObject");
  return o.setAttributeNS(null, "x", "0%"), o.setAttributeNS(null, "y", "0%"), o.setAttributeNS(null, "width", "100%"), o.setAttributeNS(null, "height", "100%"), o.append(i), s.appendChild(o), s;
}
async function d4e(i, e) {
  var r;
  const t = await mA(i, e), n = await a4e(t), s = w_e(n, t.isEnable("removeControlCharacter"));
  t.autoDestruct || (t.svgStyleElement = gA(t.ownerDocument), t.svgDefsElement = (r = t.ownerDocument) == null ? void 0 : r.createElementNS(_m, "defs"), t.svgStyles.clear());
  const o = _l(s, n.ownerDocument);
  return await A_e(o, t);
}
const SA = 2560, c4e = 3.5 * 1024 * 1024;
function u4e(i) {
  return i instanceof Element ? i.hasAttribute("data-feedback-skip") ? !1 : !(i.tagName === "CANVAS" && i.classList.contains("bd-canvas")) : !0;
}
const G0 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
function h4e(i) {
  return new Promise((e, t) => {
    const n = new FileReader();
    n.onload = () => e(String(n.result || "")), n.onerror = () => t(n.error || new Error("The picture couldn't be read")), n.readAsDataURL(i);
  });
}
async function p4e(i) {
  if (!/^https?:/i.test(i)) return !1;
  try {
    if (new URL(i, location.href).origin === location.origin) return !1;
    const e = await fetch(i + (i.indexOf("?") >= 0 ? "&" : "?") + "rdcors=1", { mode: "cors", credentials: "omit" });
    return e.ok ? await h4e(await e.blob()) : G0;
  } catch {
    return G0;
  }
}
function f4e(i) {
  const e = [];
  return i.querySelectorAll("img").forEach((t) => {
    t.loading !== "lazy" || t.complete || (t.loading = "eager", e.push(t));
  }), () => {
    for (const t of e) t.loading = "lazy";
  };
}
function S4(i, e, t) {
  return new Promise((n) => i.toBlob(n, e, t));
}
function m4e(i, e) {
  const t = document.createElement("canvas");
  t.width = Math.max(1, Math.round(i.width * e)), t.height = Math.max(1, Math.round(i.height * e));
  const n = t.getContext("2d");
  return n && n.drawImage(i, 0, 0, t.width, t.height), t;
}
async function MA(i) {
  let e = i;
  for (let t = 0; t < 4; t++) {
    let n = await S4(e, "image/webp", 0.86);
    if ((!n || n.type !== "image/webp") && (n = await S4(e, "image/jpeg", 0.88)), n && (n.size <= c4e || t === 3)) {
      const s = n.type === "image/webp" ? "image/webp" : n.type === "image/png" ? "image/png" : "image/jpeg";
      return { blob: n, type: s, w: e.width, h: e.height };
    }
    e = m4e(e, 0.75);
  }
  throw new Error("The screenshot couldn't be encoded");
}
async function g4e(i, e, t) {
  const n = Date.now(), s = e ? e.snapshot() : null, o = i.querySelector("canvas.bd-canvas");
  if (s && o && o.parentElement) {
    const a = o.getBoundingClientRect();
    s.setAttribute("data-feedback-frame", ""), s.style.cssText = "position:absolute;left:0;top:0;width:" + a.width + "px;height:" + a.height + "px;pointer-events:none", o.parentElement.appendChild(s);
  }
  const r = f4e(i);
  try {
    const a = i.getBoundingClientRect(), l = Math.min(2, window.devicePixelRatio || 1), d = Math.min(l, SA / Math.max(1, a.width, a.height)), c = await d4e(i, {
      scale: d,
      filter: u4e,
      timeout: 1e4,
      fetchFn: p4e,
      fetch: { placeholderImage: G0 }
    }), h = await MA(c);
    return { ...h, url: URL.createObjectURL(h.blob), at: n, from: "board", ...t };
  } finally {
    r(), s && s.parentElement && s.parentElement.removeChild(s);
  }
}
const b4e = 40 * 1024 * 1024;
function TA(i) {
  return /^image\//i.test(i.type);
}
async function v4e(i) {
  if (typeof createImageBitmap == "function")
    try {
      const t = await createImageBitmap(i);
      return { pic: t, w: t.width, h: t.height, release: () => t.close() };
    } catch {
    }
  const e = URL.createObjectURL(i);
  try {
    const t = new Image();
    return t.src = e, await t.decode(), { pic: t, w: t.naturalWidth, h: t.naturalHeight, release: () => URL.revokeObjectURL(e) };
  } catch (t) {
    throw URL.revokeObjectURL(e), t;
  }
}
async function y4e(i, e) {
  if (i.size > b4e) throw new Error("The picture is too large to add");
  const t = Date.now(), n = await v4e(i);
  try {
    if (!n.w || !n.h) throw new Error("The picture has no pixels");
    const s = Math.min(1, SA / Math.max(n.w, n.h)), o = document.createElement("canvas");
    o.width = Math.max(1, Math.round(n.w * s)), o.height = Math.max(1, Math.round(n.h * s));
    const r = o.getContext("2d");
    if (!r) throw new Error("No 2D canvas to draw the picture on");
    r.drawImage(n.pic, 0, 0, o.width, o.height);
    const a = await MA(o);
    return { ...a, url: URL.createObjectURL(a.blob), at: t, from: e, camera: null, selection: [], panels: [] };
  } finally {
    n.release();
  }
}
const M4 = 9 * 1024 * 1024, T4 = 4e3, CA = 50;
class IA extends Error {
  constructor() {
    super("This report is too large to send. Remove a screenshot and try again."), this.name = "ReportTooLarge";
  }
}
function x4e(i) {
  return new Promise((e, t) => {
    const n = new FileReader();
    n.onload = () => {
      const s = String(n.result || "");
      e(s.slice(s.indexOf(",") + 1));
    }, n.onerror = () => t(n.error || new Error("The file couldn't be read")), n.readAsDataURL(i);
  });
}
function C4(i) {
  let e = "";
  for (let t = 0; t < i.length; t += 32768) e += String.fromCharCode.apply(null, Array.from(i.subarray(t, t + 32768)));
  return btoa(e);
}
async function I4(i) {
  const e = JSON.stringify(i), t = typeof CompressionStream != "undefined" ? new Response(e).body : null;
  if (t) {
    const n = await new Response(t.pipeThrough(new CompressionStream("gzip"))).arrayBuffer();
    return { data: C4(new Uint8Array(n)), gzip: !0 };
  }
  return { data: C4(new TextEncoder().encode(e)), gzip: !1 };
}
function AA(i) {
  let e;
  return (e = i.match(/Edg\/(\d+)/)) ? "Edge " + e[1] : (e = i.match(/Firefox\/(\d+)/)) ? "Firefox " + e[1] : (e = i.match(/Chrome\/(\d+)/)) ? "Chrome " + e[1] : (e = i.match(/Version\/(\d+(?:\.\d+)?).*Safari/)) ? "Safari " + e[1] : "Unknown browser";
}
function PA(i, e) {
  return /iPad|iPhone/.test(i) ? "iOS or iPadOS" : /Mac OS X/.test(i) ? e > 1 ? "iPadOS" : "macOS" : /Windows/.test(i) ? "Windows" : /Android/.test(i) ? "Android" : /CrOS/.test(i) ? "ChromeOS" : /Linux/.test(i) ? "Linux" : "Unknown";
}
function EA(i) {
  const e = navigator;
  return {
    browser: AA(e.userAgent),
    os: PA(e.userAgent, e.maxTouchPoints || 0),
    dpr: window.devicePixelRatio || 1,
    viewport: { w: window.innerWidth, h: window.innerHeight },
    gpu: i,
    memoryGb: typeof e.deviceMemory == "number" ? e.deviceMemory : null
  };
}
function w4e(i) {
  const e = navigator;
  return {
    userAgent: e.userAgent,
    language: e.language,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screen: { w: screen.width, h: screen.height },
    window: { w: window.innerWidth, h: window.innerHeight },
    dpr: window.devicePixelRatio || 1,
    memoryGb: typeof e.deviceMemory == "number" ? e.deviceMemory : null,
    cores: e.hardwareConcurrency || null,
    online: e.onLine,
    connection: e.connection && e.connection.effectiveType ? e.connection.effectiveType : null,
    gpu: i
  };
}
function RA(i) {
  const e = {};
  for (const n of i.store.all()) e[n.type] = (e[n.type] || 0) + 1;
  const t = i.cam.value;
  return {
    board: { id: i.meta.id, title: i.meta.title, teamId: i.meta.teamId, accessLevel: i.meta.accessLevel, size: i.store.size, counts: e },
    camera: { x: Math.round(t.x), y: Math.round(t.y), zoom: Math.round(t.zoom * 1e3) / 1e3 },
    view: { w: Math.round(i.view.w), h: Math.round(i.view.h) },
    selection: i.ui.selection.slice(0, CA),
    tool: i.ui.shapeArmed ? i.ui.shapeKind : i.ui.mode,
    openPanels: lA(i),
    undo: i.store.undoLabels().slice(-12),
    saveState: i.saveState.value,
    running: Object.keys(i.generating),
    loaded: i.loaded.value,
    loadError: i.loadError.value,
    engine: i.engine ? i.engine.currentStats() : null
  };
}
function zA(i, e) {
  return e && e > 0 && i.length > e ? i.slice(-e) : i;
}
async function k4e(i, e) {
  const { board: t, recorder: n } = e, s = t.engine ? t.engine.gpu() : null, o = i.include.steps ? zA(n.list(), i.include.stepCount) : [], r = i.include.errors ? n.errors() : [], a = await Promise.all(i.shots.map(async (y) => ({
    contentType: y.type,
    data: await x4e(y.blob),
    w: y.w,
    h: y.h,
    at: y.at,
    from: y.from,
    camera: y.camera,
    selection: y.selection.slice(0, CA),
    panels: y.panels.slice(0, 20)
  }))), l = t.engine, d = (y) => ({
    v: 1,
    createdAt: Date.now(),
    build: e.build,
    steps: o,
    errors: r,
    frames: l ? { intervalsMs: l.frameIntervals().map((v) => Math.round(v * 10) / 10), stats: l.currentStats() } : null,
    state: i.include.state ? RA(t) : null,
    snapshot: i.include.state ? y ? { elements: Array.from(t.store.all()) } : { dropped: "The board was too large to send with this report.", size: t.store.size } : null,
    device: i.include.device ? w4e(s) : null
  }), c = a.reduce((y, v) => y + v.data.length, 0);
  let f = i.include.steps || i.include.errors || i.include.state || i.include.device ? await I4(d(!0)) : null;
  if (f && c + f.data.length > M4 && i.include.state && (f = await I4(d(!1))), c + (f ? f.data.length : 0) > M4) throw new IA();
  const p = i.include.device ? EA(s) : { browser: AA(navigator.userAgent), os: PA(navigator.userAgent, navigator.maxTouchPoints || 0), dpr: window.devicePixelRatio || 1, viewport: { w: window.innerWidth, h: window.innerHeight }, gpu: null, memoryGb: null };
  return {
    kind: i.kind,
    happened: i.happened.trim().slice(0, T4),
    expected: i.expected.trim().slice(0, T4),
    source: i.source,
    board: { id: t.meta.id, title: t.meta.title },
    teamId: t.meta.teamId,
    shots: a,
    bundle: f,
    counts: { steps: o.length, errors: r.length },
    build: e.build,
    env: p
  };
}
var _4e = Object.defineProperty, S4e = (i, e, t) => e in i ? _4e(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Ga = (i, e, t) => S4e(i, typeof e != "symbol" ? e + "" : e, t);
const Sl = 6, Db = "Six screenshots is the most a report holds.", M4e = { upload: "from your computer", paste: "pasted", drop: "dropped in" };
function Ob() {
  return {
    kind: "bug",
    happened: "",
    expected: "",
    source: "button",
    include: { steps: !0, stepCount: null, state: !0, errors: !0, device: !0 },
    shots: [],
    active: 0,
    capturing: !1,
    sending: !1,
    error: null
  };
}
class T4e {
  constructor(e) {
    Ga(this, "state", /* @__PURE__ */ Xt({ mode: "closed", flash: 0, ...Ob() })), Ga(this, "recorder"), Ga(this, "board"), Ga(this, "sink"), Ga(this, "build"), Ga(this, "disposed", !1), this.board = e.board, this.recorder = e.recorder, this.sink = e.sink, this.build = e.build;
  }
  get hasDraft() {
    const e = this.state;
    return e.shots.length > 0 || !!e.happened.trim() || !!e.expected.trim();
  }
  get canSend() {
    return !!this.state.happened.trim() && !this.state.sending && !this.state.capturing;
  }
  /**
   * Feedback asked for. Stepped aside, it takes the next screenshot. With a
   * draft waiting, the button and the menu reopen it as it was, and the key
   * adds the view it caught. Otherwise a new report starts with a screenshot.
   */
  async start(e) {
    const t = this.state;
    if (!(this.disposed || t.mode === "open" || t.capturing || t.sending)) {
      if (t.mode === "aside") {
        await this.capture();
        return;
      }
      if (this.hasDraft && e !== "key") {
        this.open("Reopened the draft report");
        return;
      }
      this.hasDraft || (t.source = e), e !== "key" && (this.board.ui.boardMenu = !1, await nt()), await this.capture(), this.open("Opened Send Feedback (" + (e === "key" ? "the ` key" : e === "menu" ? "the board menu" : "the Feedback button") + ")");
    }
  }
  open(e) {
    this.board.ui.boardMenu = !1, this.state.mode = "open", this.recorder.record("panel", e);
  }
  /** "Add screenshot": the reporter steps aside while the tester sets up the next view. */
  stepAside() {
    this.state.shots.length >= Sl || (this.state.mode = "aside", this.recorder.record("panel", "Stepped aside to set up another screenshot"));
  }
  /** Back to the reporter from stepping aside. */
  resume() {
    this.state.mode === "aside" && this.open("Back to the report");
  }
  /** Close the reporter; the draft waits on the Feedback button. */
  close() {
    this.state.mode !== "closed" && (this.state.mode = "closed", this.recorder.record("panel", this.hasDraft ? "Closed Send Feedback, draft kept" : "Closed Send Feedback"));
  }
  discard() {
    this.releaseShots();
    const e = this.state.flash;
    Object.assign(this.state, { mode: "closed", flash: e }, Ob()), this.recorder.record("panel", "Discarded a draft report");
  }
  removeShot(e) {
    const t = this.state, n = t.shots[e];
    n && (URL.revokeObjectURL(n.url), t.shots.splice(e, 1), t.active >= t.shots.length ? t.active = Math.max(0, t.shots.length - 1) : t.active > e && t.active--, this.recorder.record("shot", "Removed screenshot " + (e + 1)));
  }
  /** Take a screenshot of the board as it is now. */
  async capture() {
    const e = this.state;
    if (e.capturing) return !1;
    if (e.shots.length >= Sl)
      return this.board.toast(Db), !1;
    const t = this.board.worldEl ? this.board.worldEl.closest(".bd-root") : null;
    if (!(t instanceof HTMLElement)) return !1;
    e.capturing = !0, e.error = null, e.flash++;
    try {
      const n = this.board.cam.value, s = await g4e(t, this.board.engine, {
        camera: { x: Math.round(n.x), y: Math.round(n.y), zoom: Math.round(n.zoom * 1e3) / 1e3 },
        selection: this.board.ui.selection.slice(),
        panels: lA(this.board)
      });
      return this.disposed ? (URL.revokeObjectURL(s.url), !1) : (e.shots.push(cv(s)), e.active = e.shots.length - 1, this.recorder.record("shot", "Took screenshot " + e.shots.length, s.w + " × " + s.h), !0);
    } catch (n) {
      return console.warn("[board] the feedback screenshot failed", n), e.error = "The screenshot couldn't be taken. You can still send your report.", !1;
    } finally {
      e.capturing = !1;
    }
  }
  /**
   * Pictures from their computer (chosen, pasted or dropped in), as many as
   * the report has room for. Anything else is left out, and why is said.
   * Resolves to how many were added.
   */
  async addFiles(e, t) {
    const n = this.state;
    if (this.disposed || n.capturing || n.sending || !e.length) return 0;
    const s = e.filter(TA);
    if (!s.length)
      return n.error = "Only pictures can be added as screenshots.", 0;
    const o = Sl - n.shots.length;
    if (o <= 0)
      return n.error = Db, 0;
    n.capturing = !0, n.error = null;
    let r = 0, a = 0;
    try {
      for (const l of s.slice(0, o))
        try {
          const d = await y4e(l, t);
          if (this.disposed)
            return URL.revokeObjectURL(d.url), r;
          n.shots.push(cv(d)), n.active = n.shots.length - 1, r++, this.recorder.record("shot", "Added screenshot " + n.shots.length + " (" + M4e[t] + ")", d.w + " × " + d.h);
        } catch (d) {
          console.warn("[board] a picture couldn't be added to the feedback report", d), a++;
        }
    } finally {
      n.capturing = !1;
    }
    return a ? n.error = (a === 1 ? "A picture" : a + " pictures") + " couldn't be read. Try a PNG or JPEG under 40 MB." : s.length > o ? n.error = Db + " " + (s.length - o) + " " + (s.length - o === 1 ? "picture wasn't" : "pictures weren't") + " added." : s.length < e.length && (n.error = "Only pictures can be added as screenshots."), r;
  }
  async send() {
    const e = this.state;
    if (this.canSend) {
      e.sending = !0, e.error = null;
      try {
        const t = await k4e(
          { kind: e.kind, happened: e.happened, expected: e.expected, source: e.source, include: { ...e.include }, shots: e.shots.slice() },
          { board: this.board, recorder: this.recorder, build: this.build }
        ), n = await this.sink.submit(t);
        if (this.disposed) return;
        if (!n.success) {
          e.error = n.message;
          return;
        }
        this.recorder.record("panel", "Sent report " + n.number), this.releaseShots();
        const s = e.flash;
        Object.assign(e, { mode: "closed", flash: s }, Ob()), this.board.toast("Thanks. Report " + n.number + " is with RunDiffusion.");
      } catch (t) {
        console.warn("[board] the feedback report couldn't be sent", t), e.error = t instanceof IA ? t.message : "Your report couldn't be sent. Check your connection and try again.";
      } finally {
        e.sending = !1;
      }
    }
  }
  releaseShots() {
    for (const e of this.state.shots) URL.revokeObjectURL(e.url);
  }
  dispose() {
    this.disposed = !0, this.releaseShots();
  }
}
const C4e = { class: "fb-head" }, I4e = { class: "fb-mark" }, A4e = { class: "fb-body" }, P4e = {
  class: "fb-shots",
  "aria-label": "Screenshots"
}, E4e = {
  class: "fb-preview",
  "data-testid": "feedback-preview"
}, R4e = ["src", "alt"], z4e = {
  key: 1,
  class: "fb-preview-note"
}, $4e = {
  key: 2,
  class: "fb-preview-note"
}, D4e = {
  key: 3,
  class: "fb-drop",
  "data-testid": "feedback-drop"
}, O4e = { class: "fb-strip" }, L4e = ["aria-label", "aria-pressed", "onClick"], B4e = ["src"], F4e = { class: "fb-thumb-n" }, N4e = ["title", "aria-label", "onClick"], U4e = ["disabled", "title"], G4e = ["disabled", "title"], j4e = {
  key: 0,
  class: "fb-tip"
}, H4e = {
  class: "fb-form",
  "aria-label": "Your report"
}, V4e = {
  class: "fb-seg",
  role: "radiogroup",
  "aria-label": "What kind of feedback"
}, W4e = ["aria-checked", "data-testid", "onClick"], q4e = { class: "fb-field" }, K4e = { class: "fb-label" }, Y4e = ["placeholder"], X4e = { class: "fb-field" }, J4e = { class: "fb-label" }, Z4e = ["placeholder"], Q4e = {
  class: "fb-inc-box",
  "data-testid": "feedback-includes"
}, e3e = { class: "fb-inc" }, t3e = { class: "fb-inc-what is-fixed" }, n3e = { class: "fb-inc" }, i3e = { class: "fb-inc-what" }, s3e = {
  key: 0,
  class: "fb-steps-pick",
  role: "radiogroup",
  "aria-label": "How many recent steps to send",
  "data-testid": "feedback-step-count"
}, o3e = ["aria-checked", "disabled", "data-testid", "onClick"], r3e = ["aria-expanded"], a3e = {
  key: 0,
  class: "fb-peek",
  "data-testid": "feedback-peek"
}, l3e = { class: "fb-inc" }, d3e = { class: "fb-inc-what" }, c3e = ["aria-expanded"], u3e = {
  key: 1,
  class: "fb-peek"
}, h3e = {
  key: 2,
  class: "fb-inc"
}, p3e = { class: "fb-inc-what" }, f3e = ["aria-expanded"], m3e = {
  key: 3,
  class: "fb-inc"
}, g3e = { class: "fb-inc-what is-fixed" }, b3e = {
  key: 4,
  class: "fb-peek"
}, v3e = { class: "fb-inc" }, y3e = { class: "fb-inc-what" }, x3e = ["aria-expanded"], w3e = {
  key: 5,
  class: "fb-peek"
}, k3e = { class: "fb-foot" }, _3e = {
  key: 0,
  class: "fb-error",
  role: "alert",
  "data-testid": "feedback-error"
}, S3e = {
  class: "fb-keys",
  "aria-hidden": "true"
}, M3e = ["disabled", "title"], T3e = /* @__PURE__ */ Pe({
  __name: "FeedbackDialog",
  props: {
    feedback: {}
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = e.feedback, s = n.state, o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(!1), d = /* @__PURE__ */ K(!1), c = /* @__PURE__ */ K(null), h = /* @__PURE__ */ K(0), f = [
      { id: "bug", label: "Bug", icon: "Bug", q1: "What happened?", p1: "I dragged two images into the frame and one jumped back.", q2: "What did you expect?", p2: "Both stay where I dropped them." },
      { id: "confusing", label: "Confusing", icon: "CircleHelp", q1: "What were you trying to do?", p1: "Start a new image session from a note.", q2: "What got in the way?", p2: "I couldn't find where sessions start." },
      { id: "idea", label: "Idea", icon: "Lightbulb", q1: "What would you like?", p1: "Let me keep the prompt open while I pan.", q2: "What would it help you do?", p2: "Compare results without losing my settings." }
    ], p = I(() => f.find((Y) => Y.id === s.kind) || f[0]), y = I(() => s.shots[s.active] || null), v = I(() => (h.value, n.recorder.list())), x = I(() => v.value.filter((Y) => Y.kind === "error" || Y.kind === "warn")), w = [{ n: 15, label: "15" }, { n: 50, label: "50" }, { n: null, label: "All" }], S = I(() => w.filter((Y) => Y.n == null || Y.n < v.value.length)), M = I(() => zA(v.value, s.include.stepCount)), _ = I(() => (t.docRev.value, t.store.size)), T = I(() => EA(t.engine ? t.engine.gpu() : null)), k = I(() => s.shots.length ? s.shots.length + (s.shots.length === 1 ? " screenshot" : " screenshots") : "No screenshots"), P = En(["mod", "enter"]), A = En(["mod", "V"]), R = I(() => s.shots.length >= Sl);
    function D(Y) {
      return new Date(Y).toLocaleTimeString([], { hour: "numeric", minute: "2-digit", second: "2-digit" });
    }
    function O(Y) {
      return Y.slice().reverse().map((H) => D(H.at) + "  " + H.label + (H.detail ? "  (" + H.detail + ")" : "")).join(`
`) || "Nothing yet.";
    }
    const F = I(() => (h.value, c.value === "steps" ? O(M.value) : c.value === "errors" ? O(x.value) : c.value === "state" ? JSON.stringify(RA(t), null, 2) : c.value === "device" ? JSON.stringify(T.value, null, 2) : ""));
    function te(Y) {
      h.value++, c.value = c.value === Y ? null : Y;
    }
    function ee(Y) {
      if (Y.stopPropagation(), Y.key === "Escape") {
        Y.preventDefault(), d.value ? d.value = !1 : n.close();
        return;
      }
      Y.key === "Enter" && kn(Y) && (Y.preventDefault(), n.send());
    }
    function me() {
      a.value && a.value.click();
    }
    function L() {
      const Y = a.value;
      if (!Y) return;
      const H = Array.from(Y.files || []);
      Y.value = "", H.length && n.addFiles(H, "upload");
    }
    function N(Y) {
      const H = Y.clipboardData ? Array.from(Y.clipboardData.files || []) : [];
      H.some(TA) && (Y.preventDefault(), Y.stopImmediatePropagation(), n.addFiles(H, "paste"));
    }
    function X(Y) {
      return !!Y.dataTransfer && Array.from(Y.dataTransfer.types || []).indexOf("Files") >= 0;
    }
    function B(Y) {
      X(Y) && (Y.preventDefault(), Y.dataTransfer && (Y.dataTransfer.dropEffect = "copy"), l.value = !0);
    }
    function se(Y) {
      const H = Y.relatedTarget;
      (!(H instanceof Node) || !(Y.currentTarget instanceof Node) || !Y.currentTarget.contains(H)) && (l.value = !1);
    }
    function V(Y) {
      l.value = !1, !(!X(Y) || !Y.dataTransfer) && (Y.preventDefault(), n.addFiles(Array.from(Y.dataTransfer.files || []), "drop"));
    }
    let Z = null;
    return ot(() => {
      Z = document.activeElement, window.addEventListener("keydown", ee, !0), window.addEventListener("paste", N, !0), nt(() => {
        r.value && !s.happened ? r.value.focus({ preventScroll: !0 }) : o.value && o.value.focus({ preventScroll: !0 });
      });
    }), We(() => {
      window.removeEventListener("keydown", ee, !0), window.removeEventListener("paste", N, !0), Z && document.contains(Z) && Z.focus({ preventScroll: !0 });
    }), (Y, H) => (g(), b("div", {
      class: "fb",
      "data-testid": "feedback",
      "data-feedback-skip": "",
      "data-lb-own-keys": "",
      onPointerdown: H[17] || (H[17] = Se((re) => m(n).close(), ["self"])),
      onWheel: H[18] || (H[18] = Se(() => {
      }, ["stop"])),
      onDragover: B,
      onDragleave: se,
      onDrop: V
    }, [
      u("div", {
        ref_key: "card",
        ref: o,
        class: G(["fb-card", { "is-dropping": l.value }]),
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "fb-title",
        tabindex: "-1",
        onPointerdown: H[16] || (H[16] = Se(() => {
        }, ["stop"]))
      }, [
        u("header", C4e, [
          u("span", I4e, [
            C($, {
              name: "MessageSquareWarning",
              size: 17
            })
          ]),
          H[19] || (H[19] = u("div", { class: "fb-titles" }, [
            u("h2", { id: "fb-title" }, "Send feedback"),
            u("p", null, "Your screenshots and your recent steps on this board go with it. You can check everything before you send.")
          ], -1)),
          u("button", {
            class: "fb-close",
            title: "Close (your draft is kept)",
            "aria-label": "Close (your draft is kept)",
            "data-testid": "feedback-close",
            onClick: H[0] || (H[0] = (re) => m(n).close())
          }, [
            C($, {
              name: "X",
              size: 15
            })
          ])
        ]),
        u("div", A4e, [
          u("section", P4e, [
            u("div", E4e, [
              y.value ? (g(), b("img", {
                key: 0,
                src: y.value.url,
                alt: "Screenshot " + (m(s).active + 1),
                "data-testid": "feedback-preview-image"
              }, null, 8, R4e)) : m(s).capturing ? (g(), b("span", z4e, [
                C($, {
                  name: "Loader2",
                  size: 14,
                  spin: ""
                }),
                H[20] || (H[20] = J("Adding the screenshot…", -1))
              ])) : (g(), b("span", $4e, "No screenshots. Add one, or send without.")),
              l.value ? (g(), b("div", D4e, [
                C($, {
                  name: "Upload",
                  size: 20
                }),
                u("span", null, E(R.value ? "Six screenshots is the most a report holds" : "Drop to add it as a screenshot"), 1)
              ])) : z("", !0)
            ]),
            u("div", O4e, [
              (g(!0), b(j, null, be(m(s).shots, (re, le) => (g(), b("div", {
                key: re.url,
                class: G(["fb-thumb", { on: le === m(s).active }]),
                "data-testid": "feedback-thumb"
              }, [
                u("button", {
                  class: "fb-thumb-pick",
                  "aria-label": "Show screenshot " + (le + 1),
                  "aria-pressed": le === m(s).active,
                  onClick: (he) => m(s).active = le
                }, [
                  u("img", {
                    src: re.url,
                    alt: ""
                  }, null, 8, B4e)
                ], 8, L4e),
                u("span", F4e, E(le + 1), 1),
                u("button", {
                  class: "fb-thumb-x",
                  title: "Remove screenshot " + (le + 1),
                  "aria-label": "Remove screenshot " + (le + 1),
                  "data-testid": "feedback-remove-shot",
                  onClick: (he) => m(n).removeShot(le)
                }, [
                  C($, {
                    name: "X",
                    size: 11
                  })
                ], 8, N4e)
              ], 2))), 128)),
              u("button", {
                class: "fb-add",
                disabled: R.value || m(s).capturing,
                title: R.value ? "Six screenshots is the most a report holds" : "Set up another view on the board, then capture it",
                "data-testid": "feedback-add-shot",
                onClick: H[1] || (H[1] = (re) => m(n).stepAside())
              }, [
                C($, {
                  name: "Camera",
                  size: 15
                }),
                H[21] || (H[21] = J("Capture board ", -1))
              ], 8, U4e),
              u("button", {
                class: "fb-add",
                disabled: R.value || m(s).capturing,
                title: R.value ? "Six screenshots is the most a report holds" : "Add a picture from your computer",
                "data-testid": "feedback-upload",
                onClick: me
              }, [
                C($, {
                  name: "Upload",
                  size: 15
                }),
                H[22] || (H[22] = J("Upload image ", -1))
              ], 8, G4e),
              u("input", {
                ref_key: "fileEl",
                ref: a,
                type: "file",
                accept: "image/*",
                multiple: "",
                hidden: "",
                "data-testid": "feedback-upload-input",
                onChange: L
              }, null, 544)
            ]),
            R.value ? z("", !0) : (g(), b("p", j4e, "You can also paste a picture (" + E(m(A)) + ") or drop one here.", 1))
          ]),
          u("section", H4e, [
            u("div", V4e, [
              (g(), b(j, null, be(f, (re) => u("button", {
                key: re.id,
                role: "radio",
                "aria-checked": m(s).kind === re.id,
                class: G({ "is-on": m(s).kind === re.id }),
                "data-testid": "feedback-kind-" + re.id,
                onClick: (le) => m(s).kind = re.id
              }, [
                C($, {
                  name: re.icon,
                  size: 13
                }, null, 8, ["name"]),
                J(E(re.label), 1)
              ], 10, W4e)), 64))
            ]),
            u("label", q4e, [
              u("span", K4e, E(p.value.q1), 1),
              kt(u("textarea", {
                ref_key: "happenedEl",
                ref: r,
                "onUpdate:modelValue": H[2] || (H[2] = (re) => m(s).happened = re),
                class: "fb-text",
                placeholder: p.value.p1,
                maxlength: "4000",
                "data-testid": "feedback-happened"
              }, null, 8, Y4e), [
                [Zt, m(s).happened]
              ])
            ]),
            u("label", X4e, [
              u("span", J4e, E(p.value.q2), 1),
              kt(u("textarea", {
                "onUpdate:modelValue": H[3] || (H[3] = (re) => m(s).expected = re),
                class: "fb-text is-short",
                placeholder: p.value.p2,
                maxlength: "4000",
                "data-testid": "feedback-expected"
              }, null, 8, Z4e), [
                [Zt, m(s).expected]
              ])
            ]),
            u("div", Q4e, [
              H[29] || (H[29] = u("div", { class: "fb-inc-h" }, "Sent with your report", -1)),
              u("div", e3e, [
                u("span", t3e, [
                  C($, {
                    name: "Check",
                    size: 13
                  }),
                  u("span", null, [
                    J(E(k.value), 1),
                    H[23] || (H[23] = u("small", null, "Remove any in the strip", -1))
                  ])
                ])
              ]),
              u("div", n3e, [
                u("label", i3e, [
                  kt(u("input", {
                    "onUpdate:modelValue": H[4] || (H[4] = (re) => m(s).include.steps = re),
                    type: "checkbox",
                    "data-testid": "feedback-include-steps"
                  }, null, 512), [
                    [ol, m(s).include.steps]
                  ]),
                  u("span", null, [
                    J("Your last " + E(M.value.length) + " " + E(M.value.length === 1 ? "step" : "steps") + " on this board", 1),
                    H[24] || (H[24] = u("small", null, "What you moved, ran and opened, with times", -1))
                  ])
                ]),
                S.value.length > 1 ? (g(), b("span", s3e, [
                  (g(!0), b(j, null, be(S.value, (re) => (g(), b("button", {
                    key: re.label,
                    type: "button",
                    role: "radio",
                    "aria-checked": (m(s).include.stepCount || null) === re.n,
                    class: G({ on: (m(s).include.stepCount || null) === re.n }),
                    disabled: !m(s).include.steps,
                    "data-testid": "feedback-steps-" + re.label.toLowerCase(),
                    onClick: (le) => m(s).include.stepCount = re.n
                  }, E(re.label), 11, o3e))), 128))
                ])) : z("", !0),
                u("button", {
                  class: "fb-view",
                  "aria-expanded": c.value === "steps",
                  "data-testid": "feedback-view-steps",
                  onClick: H[5] || (H[5] = (re) => te("steps"))
                }, E(c.value === "steps" ? "Hide" : "View"), 9, r3e)
              ]),
              c.value === "steps" ? (g(), b("pre", a3e, E(F.value), 1)) : z("", !0),
              u("div", l3e, [
                u("label", d3e, [
                  kt(u("input", {
                    "onUpdate:modelValue": H[6] || (H[6] = (re) => m(s).include.state = re),
                    type: "checkbox",
                    "data-testid": "feedback-include-state"
                  }, null, 512), [
                    [ol, m(s).include.state]
                  ]),
                  u("span", null, [
                    H[25] || (H[25] = J("The board as it is now", -1)),
                    u("small", null, E(_.value) + " " + E(_.value === 1 ? "element" : "elements") + ", the view and your selection", 1)
                  ])
                ]),
                u("button", {
                  class: "fb-view",
                  "aria-expanded": c.value === "state",
                  onClick: H[7] || (H[7] = (re) => te("state"))
                }, E(c.value === "state" ? "Hide" : "View"), 9, c3e)
              ]),
              c.value === "state" ? (g(), b("pre", u3e, E(F.value), 1)) : z("", !0),
              x.value.length ? (g(), b("div", h3e, [
                u("label", p3e, [
                  kt(u("input", {
                    "onUpdate:modelValue": H[8] || (H[8] = (re) => m(s).include.errors = re),
                    type: "checkbox",
                    "data-testid": "feedback-include-errors"
                  }, null, 512), [
                    [ol, m(s).include.errors]
                  ]),
                  u("span", null, [
                    J(E(x.value.length) + " " + E(x.value.length === 1 ? "error or warning" : "errors and warnings"), 1),
                    H[26] || (H[26] = u("small", null, "What the board logged while you worked", -1))
                  ])
                ]),
                u("button", {
                  class: "fb-view",
                  "aria-expanded": c.value === "errors",
                  onClick: H[9] || (H[9] = (re) => te("errors"))
                }, E(c.value === "errors" ? "Hide" : "View"), 9, f3e)
              ])) : (g(), b("div", m3e, [
                u("span", g3e, [
                  C($, {
                    name: "Check",
                    size: 13
                  }),
                  H[27] || (H[27] = u("span", null, "No errors seen", -1))
                ])
              ])),
              c.value === "errors" ? (g(), b("pre", b3e, E(F.value), 1)) : z("", !0),
              u("div", v3e, [
                u("label", y3e, [
                  kt(u("input", {
                    "onUpdate:modelValue": H[10] || (H[10] = (re) => m(s).include.device = re),
                    type: "checkbox",
                    "data-testid": "feedback-include-device"
                  }, null, 512), [
                    [ol, m(s).include.device]
                  ]),
                  u("span", null, [
                    H[28] || (H[28] = J("Browser, device and app version", -1)),
                    u("small", null, E(T.value.browser) + " on " + E(T.value.os), 1)
                  ])
                ]),
                u("button", {
                  class: "fb-view",
                  "aria-expanded": c.value === "device",
                  onClick: H[11] || (H[11] = (re) => te("device"))
                }, E(c.value === "device" ? "Hide" : "View"), 9, x3e)
              ]),
              c.value === "device" ? (g(), b("pre", w3e, E(F.value), 1)) : z("", !0)
            ])
          ])
        ]),
        u("footer", k3e, [
          d.value ? (g(), b(j, { key: 0 }, [
            H[30] || (H[30] = u("span", { class: "fb-confirm" }, "Discard this report and its screenshots?", -1)),
            u("button", {
              class: "bd-btn is-ghost",
              "data-testid": "feedback-discard-keep",
              onClick: H[12] || (H[12] = (re) => d.value = !1)
            }, "Keep it"),
            u("button", {
              class: "bd-btn",
              "data-testid": "feedback-discard-confirm",
              onClick: H[13] || (H[13] = (re) => m(n).discard())
            }, "Discard")
          ], 64)) : (g(), b(j, { key: 1 }, [
            H[31] || (H[31] = u("span", { class: "fb-note" }, "Only RunDiffusion staff can see reports.", -1)),
            m(s).error ? (g(), b("span", _3e, E(m(s).error), 1)) : z("", !0),
            u("button", {
              class: "bd-btn is-ghost",
              "data-testid": "feedback-discard",
              onClick: H[14] || (H[14] = (re) => d.value = !0)
            }, "Discard"),
            u("span", S3e, E(m(P)), 1),
            u("button", {
              class: "bd-btn",
              disabled: !m(n).canSend,
              title: m(n).canSend ? "Send report (" + m(P) + ")" : "Write a line about it first",
              "data-testid": "feedback-send",
              onClick: H[15] || (H[15] = (re) => m(n).send())
            }, [
              C($, {
                name: m(s).sending ? "Loader2" : "Send",
                size: 14,
                spin: m(s).sending
              }, null, 8, ["name", "spin"]),
              J(E(m(s).sending ? "Sending…" : "Send report"), 1)
            ], 8, M3e)
          ], 64))
        ])
      ], 34)
    ], 32));
  }
}), C3e = {
  class: "fb-aside",
  role: "status",
  "data-testid": "feedback-aside",
  "data-feedback-skip": "",
  "data-feedback-bar": ""
}, I3e = { class: "fb-aside-mark" }, A3e = { class: "fb-aside-text" }, P3e = {
  class: "fb-aside-count",
  "data-testid": "feedback-aside-count"
}, E3e = ["disabled"], R3e = /* @__PURE__ */ Pe({
  __name: "FeedbackShotBar",
  props: {
    feedback: {}
  },
  setup(i) {
    const e = i, t = e.feedback.state, n = I(() => t.shots.length >= Sl);
    return (s, o) => (g(), b("div", C3e, [
      u("span", I3e, [
        C($, {
          name: "Camera",
          size: 13
        })
      ]),
      u("span", A3e, E(n.value ? "Six screenshots is the most a report holds" : "Set up the next screenshot, then capture it"), 1),
      u("span", P3e, E(m(t).shots.length) + " of " + E(m(Sl)), 1),
      u("button", {
        class: "fb-aside-btn is-cta",
        disabled: n.value || m(t).capturing,
        title: "Capture (`)",
        "data-testid": "feedback-capture",
        onClick: o[0] || (o[0] = (r) => e.feedback.capture())
      }, [
        C($, {
          name: "Camera",
          size: 12
        }),
        o[2] || (o[2] = J("Capture ", -1))
      ], 8, E3e),
      u("button", {
        class: "fb-aside-btn",
        title: "Back to your report (Esc)",
        "data-testid": "feedback-aside-done",
        onClick: o[1] || (o[1] = (r) => e.feedback.resume())
      }, "Done")
    ]));
  }
}), rr = /* @__PURE__ */ Pe({
  __name: "Avatar",
  props: {
    uid: {},
    name: {},
    size: { default: 26 }
  },
  setup(i) {
    const e = i, t = I(() => {
      const [s, o] = zie(e.uid || e.name);
      return {
        width: e.size + "px",
        height: e.size + "px",
        fontSize: Math.round(e.size * 0.38) + "px",
        background: "linear-gradient(140deg, " + s + ", " + o + ")"
      };
    }), n = I(() => ma(e.name || "?").slice(0, 2));
    return (s, o) => (g(), b("span", {
      class: "cm-avatar",
      style: ce(t.value),
      "aria-hidden": "true"
    }, E(n.value), 5));
  }
}), z3e = ["href"], du = /* @__PURE__ */ Pe({
  __name: "CommentText",
  props: {
    text: {},
    mentions: {},
    me: {},
    clamp: {}
  },
  setup(i) {
    const e = i, t = I(() => Iie(e.text, e.mentions, e.me)), n = I(() => !e.clamp && _ie(e.text));
    return (s, o) => (g(), b("span", {
      class: G(["cm-text", { "is-big": n.value, "is-clamped": !!i.clamp }]),
      style: ce(i.clamp ? { "-webkit-line-clamp": String(i.clamp) } : void 0)
    }, [
      (g(!0), b(j, null, be(t.value, (r, a) => (g(), b(j, { key: a }, [
        r.kind === "mention" ? (g(), b("span", {
          key: 0,
          class: G(["cm-mention", { "is-me": r.me }])
        }, E(r.text), 3)) : r.kind === "link" ? (g(), b("a", {
          key: 1,
          class: "cm-link",
          href: r.href,
          target: "_blank",
          rel: "noopener noreferrer",
          onPointerdown: o[0] || (o[0] = Se(() => {
          }, ["stop"])),
          onClick: o[1] || (o[1] = Se(() => {
          }, ["stop"]))
        }, E(r.text), 41, z3e)) : (g(), b(j, { key: 2 }, [
          J(E(r.text), 1)
        ], 64))
      ], 64))), 128))
    ], 6));
  }
}), Ks = [
  { id: "amethyst", label: "Amethyst", hex: "#9968df" },
  { id: "vista", label: "Vista", hex: "#6b72f0" },
  { id: "sky", label: "Sky", hex: "#3db4e6" },
  { id: "mint", label: "Mint", hex: "#34c79a" },
  { id: "amber", label: "Amber", hex: "#f2a93b" },
  { id: "rose", label: "Rose", hex: "#ef5f7a" }
];
function $3e(i) {
  return typeof i == "string" && Ks.some((e) => e.id === i);
}
const D3e = ["aria-label", "data-thread", "onPointerdown", "onMouseenter"], O3e = { class: "cm-pin-face" }, L3e = {
  key: 0,
  class: "cm-pin-check"
}, B3e = {
  key: 0,
  class: "cm-pin-count"
}, F3e = {
  key: 1,
  class: "cm-pin-dot",
  "data-testid": "comment-pin-unread"
}, N3e = {
  key: 0,
  class: "cm-peek",
  "data-testid": "comment-peek"
}, U3e = { class: "cm-peek-head" }, G3e = {
  key: 0,
  class: "cm-peek-foot"
}, j3e = {
  class: "cm-pin is-draft",
  "data-testid": "comment-draft-pin"
}, H3e = { class: "cm-pin-face" }, V3e = /* @__PURE__ */ Pe({
  __name: "CommentPins",
  setup(i) {
    const { board: e } = Ze(), t = e.comments, n = e.user.uid, s = dr(), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ qe(null);
    let a = 0;
    const l = I(() => t.ui.showPins ? t.pins.value : t.pins.value.filter((M) => M.t.id === t.ui.openId)), d = (M) => (Ks.find((_) => _.id === M) || Ks[0]).hex, c = I(() => t.ui.flash ? t.ui.flash.id + ":" + t.ui.flash.n : "");
    function h(M) {
      return t.commentsOf(M.t.id)[0] || null;
    }
    function f(M) {
      clearTimeout(a), a = window.setTimeout(() => {
        r.value = M;
      }, 220);
    }
    function p() {
      clearTimeout(a), r.value = null;
    }
    We(() => clearTimeout(a));
    function y(M, _) {
      if (_.button !== 0) return;
      _.stopPropagation(), _.preventDefault(), p();
      const T = { x: _.clientX, y: _.clientY };
      let k = !1;
      const P = (R) => {
        if (!k && Math.hypot(R.clientX - T.x, R.clientY - T.y) < 4) return;
        k = !0;
        const D = e.screenToWorld(R.clientX, R.clientY);
        t.ui.dragging = { id: M.t.id, x: D.x, y: D.y };
      }, A = (R) => {
        window.removeEventListener("pointermove", P), window.removeEventListener("pointerup", A), window.removeEventListener("pointercancel", A);
        const D = t.ui.dragging;
        if (k && D) {
          t.moveTo(M.t.id, D.x, D.y), window.setTimeout(() => {
            t.ui.dragging && t.ui.dragging.id === M.t.id && (t.ui.dragging = null);
          }, 400);
          return;
        }
        t.ui.dragging = null, R.type !== "pointercancel" && (t.ui.openId === M.t.id ? t.close() : t.open(M.t.id));
      };
      window.addEventListener("pointermove", P), window.addEventListener("pointerup", A), window.addEventListener("pointercancel", A);
    }
    let v = null;
    function x(M) {
      return M instanceof Element && !!M.closest(".cm-pin, .cm-card, .cm-emoji, .cm-menu, .cm-peek");
    }
    function w(M) {
      if (!(M.button !== 0 || x(M.target))) {
        if (t.ui.armed) {
          if (v && v.classList.contains("is-hand")) return;
          M.preventDefault(), M.stopPropagation(), t.placeAt(M.clientX, M.clientY);
          return;
        }
        t.ui.openId && t.close(), t.ui.draft && !t.ui.draft.text.trim() && t.cancelDraft();
      }
    }
    ot(() => {
      v = o.value ? o.value.closest(".cv-stage") : null, v && v.addEventListener("pointerdown", w, !0);
    }), We(() => {
      v && (v.removeEventListener("pointerdown", w, !0), v.classList.remove("is-commenting"));
    }), Ae(() => t.ui.armed, (M) => {
      v && v.classList.toggle("is-commenting", M);
    }, { flush: "post" });
    const S = I(() => t.ui.draft);
    return (M, _) => (g(), b("div", {
      ref_key: "root",
      ref: o,
      class: G(["cm-pins", { "is-armed": m(t).ui.armed }])
    }, [
      (g(!0), b(j, null, be(l.value, (T) => (g(), b("div", {
        key: T.t.id,
        class: G(["cm-pin-at", { "is-open": m(t).ui.openId === T.t.id, "is-resolved": !!T.t.resolvedAt, "is-dragging": !!m(t).ui.dragging && m(t).ui.dragging.id === T.t.id }]),
        style: ce({ left: T.x + "px", top: T.y + "px", "--thread": d(T.t.color) })
      }, [
        (g(), b("button", {
          key: c.value.startsWith(T.t.id + ":") ? c.value : T.t.id,
          class: G(["cm-pin", { "is-unread": T.unread, "is-flash": c.value.startsWith(T.t.id + ":") }]),
          "aria-label": "Comment by " + T.t.createdByName + (T.unread ? ", unread" : ""),
          "data-thread": T.t.id,
          "data-testid": "comment-pin",
          onPointerdown: (k) => y(T, k),
          onMouseenter: (k) => f(T.t.id),
          onMouseleave: p
        }, [
          u("span", O3e, [
            T.t.resolvedAt ? (g(), b("span", L3e, [
              C($, {
                name: "Check",
                size: 15,
                stroke: 3
              })
            ])) : (g(), Ce(rr, {
              key: 1,
              uid: T.t.createdBy,
              name: T.t.createdByName,
              size: 26
            }, null, 8, ["uid", "name"]))
          ]),
          T.count > 1 ? (g(), b("span", B3e, E(T.count > 99 ? "99+" : T.count), 1)) : z("", !0),
          T.unread ? (g(), b("span", F3e)) : z("", !0)
        ], 42, D3e)),
        r.value === T.t.id && m(t).ui.openId !== T.t.id && h(T) ? (g(), b("div", N3e, [
          u("div", U3e, [
            u("b", null, E(h(T).authorName), 1),
            u("span", null, E(m(Jn)(T.t.lastAt, m(s))), 1)
          ]),
          C(du, {
            text: h(T).text,
            mentions: h(T).mentions,
            me: m(n),
            clamp: 3
          }, null, 8, ["text", "mentions", "me"]),
          T.count > 1 ? (g(), b("div", G3e, [
            J(E(T.count - 1 === 1 ? "1 reply" : T.count - 1 + " replies"), 1),
            m(t).freshIn(T.t) ? (g(), b(j, { key: 0 }, [
              _[0] || (_[0] = J(" · ", -1)),
              u("em", null, E(m(t).freshIn(T.t)) + " new", 1)
            ], 64)) : z("", !0)
          ])) : z("", !0)
        ])) : z("", !0)
      ], 6))), 128)),
      S.value ? (g(), b("div", {
        key: 0,
        class: "cm-pin-at is-draft",
        style: ce({ left: S.value.anchor.x + "px", top: S.value.anchor.y + "px" })
      }, [
        u("span", j3e, [
          u("span", H3e, [
            C(rr, {
              uid: m(n),
              name: m(t).myName,
              size: 26
            }, null, 8, ["uid", "name"])
          ])
        ])
      ], 4)) : z("", !0)
    ], 2));
  }
}), W3e = { class: "cm-emoji-head" }, q3e = { class: "cm-emoji-search" }, K3e = ["aria-label", "onClick"], Y3e = {
  key: 0,
  class: "cm-emoji-quick",
  "data-testid": "emoji-quick"
}, X3e = ["onClick"], J3e = {
  key: 1,
  class: "cm-emoji-tabs",
  "aria-label": "Categories"
}, Z3e = ["title", "aria-label", "onClick"], Q3e = {
  key: 0,
  class: "cm-emoji-grid"
}, e5e = ["aria-label", "onMouseenter", "onClick"], t5e = {
  key: 1,
  class: "cm-emoji-none"
}, n5e = {
  key: 0,
  class: "cm-emoji-sec",
  "data-group": "recent"
}, i5e = { class: "cm-emoji-grid" }, s5e = ["aria-label", "onMouseenter", "onClick"], o5e = ["data-group"], r5e = { class: "cm-emoji-label" }, a5e = { class: "cm-emoji-grid" }, l5e = ["aria-label", "onMouseenter", "onClick"], d5e = { class: "cm-emoji-foot" }, c5e = { class: "cm-emoji-big" }, u5e = { class: "cm-emoji-name" }, h5e = { class: "cm-emoji-code" }, p5e = {
  key: 1,
  class: "cm-emoji-hint"
}, Lb = 340, A4 = 392, P4 = 8, $A = /* @__PURE__ */ Pe({
  __name: "EmojiPicker",
  props: {
    at: {},
    mode: { default: "insert" }
  },
  emits: ["pick", "close"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(""), l = /* @__PURE__ */ K(w0()), d = /* @__PURE__ */ K(!1), c = /* @__PURE__ */ qe(x0()), h = /* @__PURE__ */ qe(null), f = /* @__PURE__ */ K(x0().length ? "recent" : "smileys"), p = bie(), y = I(() => a.value.trim() ? eI(a.value, 160) : null), v = I(() => c.value.map((O) => ({ c: O, e: Ky(O) })).filter((O) => !!O.e)), x = I(() => [
      ...v.value.length ? [{ key: "recent", label: "Recent", icon: "Clock" }] : [],
      ...p.map((O) => ({ key: O.key, label: O.label, icon: w[O.key] || "Smile" }))
    ]), w = {
      smileys: "Smile",
      people: "Hand",
      nature: "Leaf",
      food: "Coffee",
      travel: "Plane",
      activities: "Trophy",
      objects: "Lightbulb",
      symbols: "Heart",
      flags: "Flag"
    }, S = I(() => {
      const O = t.at, F = window.innerWidth, te = window.innerHeight;
      let ee = O.y + O.h + P4;
      ee + A4 > te - 8 && (ee = Math.max(8, O.y - P4 - A4));
      let me = O.x + O.w - Lb;
      return me < 8 && (me = Math.min(O.x, F - Lb - 8)), { left: Math.max(8, Math.min(me, F - Lb - 8)) + "px", top: ee + "px" };
    });
    function M(O) {
      const F = typeof O == "string" ? O : ll(O, l.value);
      n("pick", F);
    }
    function _(O) {
      l.value = O, xie(O), d.value = !1;
    }
    function T() {
      yie(), c.value = [], f.value === "recent" && (f.value = p[0].key);
    }
    function k(O) {
      a.value = "", nt(() => {
        const F = o.value && o.value.querySelector('[data-group="' + O + '"]');
        F && o.value && o.value.scrollTo({ top: F.offsetTop - 4, behavior: "smooth" }), f.value = O;
      });
    }
    function P() {
      const O = o.value;
      if (!O || y.value) return;
      const F = O.querySelectorAll("[data-group]");
      let te = f.value;
      for (const ee of Array.from(F)) ee.offsetTop - 24 <= O.scrollTop && (te = ee.dataset.group || te);
      f.value = te;
    }
    function A(O) {
      if (O.key === "Escape")
        O.preventDefault(), O.stopPropagation(), n("close");
      else if (O.key === "Enter") {
        O.preventDefault(), O.stopPropagation();
        const F = y.value;
        F && F[0] && M(F[0]);
      }
    }
    function R(O) {
      const F = O.target;
      s.value && F && s.value.contains(F) || n("close");
    }
    ot(() => {
      window.setTimeout(() => window.addEventListener("pointerdown", R, !0), 0), nt(() => {
        r.value && r.value.focus({ preventScroll: !0 });
      });
    }), We(() => window.removeEventListener("pointerdown", R, !0));
    function D(O) {
      return O.s.length ? ":" + O.s[0] + ":" : "";
    }
    return (O, F) => (g(), b("div", {
      ref_key: "root",
      ref: s,
      class: G(["cm-emoji", "is-" + i.mode]),
      style: ce(S.value),
      role: "dialog",
      "aria-label": "Emoji",
      "data-testid": "emoji-picker",
      onPointerdown: F[4] || (F[4] = Se(() => {
      }, ["stop"])),
      onWheel: F[5] || (F[5] = Se(() => {
      }, ["stop"])),
      onKeydown: A
    }, [
      u("div", W3e, [
        u("label", q3e, [
          C($, {
            name: "Search",
            size: 13
          }),
          kt(u("input", {
            ref_key: "search",
            ref: r,
            "onUpdate:modelValue": F[0] || (F[0] = (te) => a.value = te),
            type: "text",
            placeholder: "Search emoji",
            spellcheck: "false",
            "data-testid": "emoji-search"
          }, null, 512), [
            [Zt, a.value]
          ]),
          a.value ? (g(), b("button", {
            key: 0,
            class: "cm-emoji-clear",
            title: "Clear",
            onClick: F[1] || (F[1] = (te) => a.value = "")
          }, [
            C($, {
              name: "X",
              size: 12
            })
          ])) : z("", !0)
        ]),
        u("div", {
          class: G(["cm-emoji-tone", { open: d.value }])
        }, [
          d.value ? (g(!0), b(j, { key: 1 }, be(m(m_), (te, ee) => (g(), b("button", {
            key: te,
            class: G(["cm-emoji-tonebtn", { on: ee === l.value }]),
            "aria-label": ee ? "Skin tone " + ee : "Default skin tone",
            onClick: (me) => _(ee)
          }, E(te), 11, K3e))), 128)) : (g(), b("button", {
            key: 0,
            class: "cm-emoji-tonebtn",
            title: "Skin tone",
            "data-testid": "emoji-tone",
            onClick: F[2] || (F[2] = (te) => d.value = !0)
          }, E(m(m_)[l.value]), 1))
        ], 2)
      ]),
      i.mode === "react" && !a.value ? (g(), b("div", Y3e, [
        (g(!0), b(j, null, be(m(fie), (te) => (g(), b("button", {
          key: te,
          class: "cm-emo is-quick",
          onClick: (ee) => M(te)
        }, E(te), 9, X3e))), 128))
      ])) : z("", !0),
      a.value ? z("", !0) : (g(), b("nav", J3e, [
        (g(!0), b(j, null, be(x.value, (te) => (g(), b("button", {
          key: te.key,
          class: G({ on: f.value === te.key }),
          title: te.label,
          "aria-label": te.label,
          onClick: (ee) => k(te.key)
        }, [
          C($, {
            name: te.icon,
            size: 15
          }, null, 8, ["name"])
        ], 10, Z3e))), 128))
      ])),
      u("div", {
        ref_key: "body",
        ref: o,
        class: "cm-emoji-body",
        onScrollPassive: P,
        onMouseleave: F[3] || (F[3] = (te) => h.value = null)
      }, [
        y.value ? (g(), b(j, { key: 0 }, [
          y.value.length ? (g(), b("div", Q3e, [
            (g(!0), b(j, null, be(y.value, (te) => (g(), b("button", {
              key: te.c,
              class: "cm-emo",
              "aria-label": te.n,
              onMouseenter: (ee) => h.value = te,
              onClick: (ee) => M(te)
            }, E(m(ll)(te, l.value)), 41, e5e))), 128))
          ])) : (g(), b("div", t5e, "No emoji for “" + E(a.value) + "”", 1))
        ], 64)) : (g(), b(j, { key: 1 }, [
          v.value.length ? (g(), b("section", n5e, [
            u("div", { class: "cm-emoji-label" }, [
              F[6] || (F[6] = J("Recent", -1)),
              u("button", {
                class: "cm-emoji-clearrecent",
                onClick: T
              }, "Clear")
            ]),
            u("div", i5e, [
              (g(!0), b(j, null, be(v.value, (te) => (g(), b("button", {
                key: "r" + te.c,
                class: "cm-emo",
                "aria-label": te.e.n,
                onMouseenter: (ee) => h.value = te.e,
                onClick: (ee) => M(te.c)
              }, E(te.c), 41, s5e))), 128))
            ])
          ])) : z("", !0),
          (g(!0), b(j, null, be(m(p), (te) => (g(), b("section", {
            key: te.key,
            class: "cm-emoji-sec",
            "data-group": te.key
          }, [
            u("div", r5e, E(te.label), 1),
            u("div", a5e, [
              (g(!0), b(j, null, be(te.emoji, (ee) => (g(), b("button", {
                key: ee.c,
                class: "cm-emo",
                "aria-label": ee.n,
                onMouseenter: (me) => h.value = ee,
                onClick: (me) => M(ee)
              }, E(m(ll)(ee, l.value)), 41, l5e))), 128))
            ])
          ], 8, o5e))), 128))
        ], 64))
      ], 544),
      u("div", d5e, [
        h.value ? (g(), b(j, { key: 0 }, [
          u("span", c5e, E(m(ll)(h.value, l.value)), 1),
          u("span", u5e, E(h.value.n), 1),
          u("span", h5e, E(D(h.value)), 1)
        ], 64)) : (g(), b("span", p5e, E(i.mode === "react" ? "React with any emoji" : "Type : and a name in a comment for emoji too"), 1))
      ])
    ], 38));
  }
}), f5e = ["placeholder", "data-testid"], m5e = { class: "cm-compose-tools" }, g5e = ["data-testid"], b5e = ["disabled", "data-testid"], v5e = ["data-testid"], y5e = ["disabled", "data-testid"], x5e = ["aria-selected", "onMouseenter", "onClick"], w5e = { class: "cm-menu-text" }, k5e = { key: 0 }, _5e = { class: "cm-menu-group" }, S5e = { class: "cm-menu-text" }, M5e = { class: "cm-menu-emoji" }, T5e = { class: "cm-menu-text" }, C5e = { key: 0 }, I5e = {
  key: 1,
  class: "cm-menu-alone"
}, j0 = /* @__PURE__ */ Pe({
  __name: "Composer",
  props: {
    people: {},
    me: {},
    placeholder: { default: "Add a comment" },
    text: { default: "" },
    mentions: { default: () => [] },
    autofocus: { type: Boolean, default: !1 },
    group: { default: null },
    editing: { type: Boolean, default: !1 },
    alone: { default: null },
    testid: { default: "composer" }
  },
  emits: ["submit", "cancel", "edit-last", "change"],
  setup(i, { expose: e, emit: t }) {
    const n = i, s = t, o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(n.text), d = /* @__PURE__ */ qe(n.mentions.slice()), c = /* @__PURE__ */ K(0), h = /* @__PURE__ */ K(0), f = /* @__PURE__ */ qe(null), p = /* @__PURE__ */ K(!1), y = /* @__PURE__ */ K(!1);
    let v = 0;
    function x() {
      y.value = !1, clearTimeout(v), requestAnimationFrame(() => {
        y.value = !0, v = window.setTimeout(() => {
          y.value = !1;
        }, 450);
      });
    }
    const w = I(() => l.value.trim().length > 0), S = I(() => {
      const B = Aie(l.value, c.value);
      if (!B) return null;
      const se = l.value;
      return d.value.some((V) => se.startsWith("@" + V.name, B.start) && c.value > B.start + V.name.length) ? null : B;
    }), M = I(() => S.value ? null : Pie(l.value, c.value)), _ = /* @__PURE__ */ K(-1), T = I(() => {
      const B = S.value;
      if (B && B.start !== _.value) {
        const V = n.alone ? n.people.filter((le) => le.uid !== n.me) : n.people, Z = Rie(V, B.query, n.me).slice(0, 7).map((le) => ({ kind: "person", p: le })), Y = n.people.filter((le) => le.uid !== n.me), H = n.group;
        return H && Y.length > 1 && Y.length < iI && (!B.query || H.toLowerCase().startsWith(B.query.toLowerCase()) || "everyone".startsWith(B.query.toLowerCase())) ? [{ kind: "group", label: H, count: Y.length }, ...Z] : Z;
      }
      const se = M.value;
      return se && se.start !== _.value ? eI(se.query, 6).map((V) => ({ kind: "emoji", e: V })) : [];
    }), k = I(() => T.value.length > 0 || !!S.value && S.value.start !== _.value && !!n.alone);
    Ae(T, () => {
      h.value = 0;
    }), Ae(k, (B) => {
      if (!B || !r.value) return;
      const se = r.value.getBoundingClientRect();
      p.value = window.innerHeight - se.bottom < 300 && se.top > window.innerHeight - se.bottom;
    });
    function P(B) {
      if (B.kind === "emoji") {
        const V = M.value;
        if (!V) return;
        const Z = ll(B.e, w0());
        If(Z), A(V.start, c.value, Z + " ");
        return;
      }
      const se = S.value;
      if (se) {
        if (B.kind === "group") {
          const V = n.people.filter((Z) => Z.uid !== n.me);
          d.value = [...d.value, ...V.map((Z) => ({ uid: Z.uid, name: B.label }))], A(se.start, c.value, "@" + B.label + " ");
          return;
        }
        d.value = [...d.value.filter((V) => V.uid !== B.p.uid), { uid: B.p.uid, name: B.p.name }], A(se.start, c.value, "@" + B.p.name + " ");
      }
    }
    function A(B, se, V) {
      const Z = l.value;
      l.value = Z.slice(0, B) + V + Z.slice(se);
      const Y = B + V.length;
      nt(() => {
        const H = o.value;
        H && (H.focus({ preventScroll: !0 }), H.setSelectionRange(Y, Y), c.value = Y, O());
      });
    }
    function R(B) {
      const se = o.value, V = se ? se.selectionStart : l.value.length, Z = se ? se.selectionEnd : V;
      A(V, Z, B);
    }
    function D() {
      const B = o.value, se = B ? B.selectionStart : l.value.length, V = l.value.slice(0, se);
      R(V && !/\s$/.test(V) ? " @" : "@");
    }
    function O() {
      const B = o.value;
      B && (B.style.height = "auto", B.style.height = Math.min(B.scrollHeight, 168) + "px");
    }
    function F() {
      const B = o.value;
      B && (c.value = B.selectionStart), O(), s("change", { text: l.value, mentions: d.value });
    }
    function te() {
      if (!w.value) {
        x();
        return;
      }
      s("submit", { text: l.value, mentions: d.value });
    }
    function ee() {
      l.value = "", d.value = [], nt(O);
    }
    function me(B) {
      if (k.value && T.value.length) {
        if (B.key === "ArrowDown" || B.key === "ArrowUp") {
          B.preventDefault();
          const se = T.value.length;
          h.value = (h.value + (B.key === "ArrowDown" ? 1 : -1) + se) % se;
          return;
        }
        if (B.key === "Enter" || B.key === "Tab") {
          B.preventDefault(), B.stopPropagation(), P(T.value[h.value]);
          return;
        }
      }
      if (B.key === "Escape") {
        if (B.preventDefault(), B.stopPropagation(), k.value) {
          const se = S.value || M.value;
          _.value = se ? se.start : -1;
          return;
        }
        s("cancel");
        return;
      }
      if (B.key === "Enter" && (!B.shiftKey || kn(B))) {
        B.preventDefault(), B.stopPropagation(), te();
        return;
      }
      B.key === "ArrowUp" && !l.value && !n.editing && (B.preventDefault(), s("edit-last"));
    }
    function L() {
      const B = a.value;
      if (!B) return;
      const se = B.getBoundingClientRect();
      f.value = f.value ? null : { x: se.left, y: se.top, w: se.width, h: se.height };
    }
    function N(B) {
      If(B), f.value = null, R(B);
    }
    function X() {
      const B = o.value;
      if (!B) return;
      B.focus({ preventScroll: !0 });
      const se = l.value.length;
      B.setSelectionRange(se, se), c.value = se;
    }
    return Ae(() => n.text, (B) => {
      B !== l.value && (l.value = B, nt(O));
    }), ot(() => {
      O(), n.autofocus && nt(X);
    }), We(() => clearTimeout(v)), e({ reset: ee, focus: X, nod: x }), (B, se) => (g(), b("div", {
      ref_key: "wrap",
      ref: r,
      class: G(["cm-compose", { "is-editing": i.editing, "can-send": w.value, "is-nod": y.value }]),
      onPointerdown: se[4] || (se[4] = Se(() => {
      }, ["stop"]))
    }, [
      kt(u("textarea", {
        ref_key: "box",
        ref: o,
        "onUpdate:modelValue": se[0] || (se[0] = (V) => l.value = V),
        class: "cm-compose-box",
        rows: "1",
        placeholder: i.placeholder,
        maxlength: "5000",
        spellcheck: "true",
        "data-testid": i.testid + "-input",
        onInput: F,
        onClick: F,
        onKeyup: F,
        onKeydown: me
      }, null, 40, f5e), [
        [Zt, l.value]
      ]),
      u("div", m5e, [
        i.editing ? (g(), b(j, { key: 0 }, [
          u("button", {
            class: "cm-btn is-ghost is-sm",
            "data-testid": i.testid + "-cancel",
            onClick: se[1] || (se[1] = (V) => s("cancel"))
          }, "Cancel", 8, g5e),
          u("button", {
            class: "cm-btn is-sm",
            disabled: !w.value,
            "data-testid": i.testid + "-save",
            onClick: te
          }, "Save", 8, b5e)
        ], 64)) : (g(), b(j, { key: 1 }, [
          u("button", {
            class: "cm-tool",
            title: "Mention someone (@)",
            "aria-label": "Mention someone",
            onClick: D
          }, [
            C($, {
              name: "AtSign",
              size: 14
            })
          ]),
          u("button", {
            ref_key: "emojiBtn",
            ref: a,
            class: G(["cm-tool", { on: !!f.value }]),
            title: "Emoji",
            "aria-label": "Emoji",
            "data-testid": i.testid + "-emoji",
            onClick: L
          }, [
            C($, {
              name: "Smile",
              size: 14
            })
          ], 10, v5e),
          u("button", {
            class: "cm-send",
            disabled: !w.value,
            title: "Send (Enter)",
            "aria-label": "Send",
            "data-testid": i.testid + "-send",
            onClick: te
          }, [
            C($, {
              name: "ArrowUp",
              size: 14,
              stroke: 2.4
            })
          ], 8, y5e)
        ], 64))
      ]),
      k.value ? (g(), b("div", {
        key: 0,
        class: G(["cm-menu", { "is-up": p.value }]),
        role: "listbox",
        "data-testid": "mention-menu",
        onPointerdown: se[2] || (se[2] = Se(() => {
        }, ["stop", "prevent"]))
      }, [
        T.value.length ? (g(!0), b(j, { key: 0 }, be(T.value, (V, Z) => (g(), b("button", {
          key: V.kind === "person" ? V.p.uid : V.kind === "emoji" ? V.e.c : "group",
          class: G(["cm-menu-row", { on: Z === h.value, "is-emoji": V.kind === "emoji" }]),
          role: "option",
          "aria-selected": Z === h.value,
          onMouseenter: (Y) => h.value = Z,
          onClick: (Y) => P(V)
        }, [
          V.kind === "person" ? (g(), b(j, { key: 0 }, [
            C(rr, {
              uid: V.p.uid,
              name: V.p.name,
              size: 24
            }, null, 8, ["uid", "name"]),
            u("span", w5e, [
              u("b", null, [
                J(E(V.p.name), 1),
                V.p.uid === i.me ? (g(), b("i", k5e, " (you)")) : z("", !0)
              ]),
              u("small", null, E(V.p.email), 1)
            ])
          ], 64)) : V.kind === "group" ? (g(), b(j, { key: 1 }, [
            u("span", _5e, [
              C($, {
                name: "Users",
                size: 13
              })
            ]),
            u("span", S5e, [
              u("b", null, E(V.label), 1),
              u("small", null, "Everyone who can see this board (" + E(V.count) + ")", 1)
            ])
          ], 64)) : (g(), b(j, { key: 2 }, [
            u("span", M5e, E(m(ll)(V.e, m(w0)())), 1),
            u("span", T5e, [
              u("b", null, E(V.e.n), 1),
              V.e.s.length ? (g(), b("small", C5e, ":" + E(V.e.s[0]) + ":", 1)) : z("", !0)
            ])
          ], 64))
        ], 42, x5e))), 128)) : (g(), b("div", I5e, E(i.alone), 1))
      ], 34)) : z("", !0),
      (g(), Ce(m1, {
        defer: "",
        to: ".cm-portal"
      }, [
        f.value ? (g(), Ce($A, {
          key: 0,
          at: f.value,
          mode: "insert",
          onPick: N,
          onClose: se[3] || (se[3] = (V) => f.value = null)
        }, null, 8, ["at"])) : z("", !0)
      ]))
    ], 34));
  }
}), A5e = ["data-comment"], P5e = { class: "cm-row-main" }, E5e = { class: "cm-row-head" }, R5e = { class: "cm-row-name" }, z5e = ["title"], $5e = ["title"], D5e = {
  key: 2,
  class: "cm-reactions"
}, O5e = ["title", "onClick"], L5e = { class: "e" }, B5e = { class: "n" }, F5e = {
  key: 0,
  class: "cm-row-acts"
}, N5e = ["title", "aria-label"], U5e = /* @__PURE__ */ Pe({
  __name: "CommentRow",
  props: {
    c: {},
    first: { type: Boolean }
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = t.comments, s = t.user.uid, o = dr(), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ qe(null), l = I(() => Eie(e.c, s)), d = I(() => e.c.authorId === s), c = I(() => n.ui.editingId === e.c.id), h = I(() => {
      if (!e.first) return n.canDeleteComment(e.c);
      const S = n.thread(e.c.threadId);
      return !!S && n.canDelete(S);
    }), f = I(() => Jn(e.c.createdAt, o.value)), p = I(() => {
      const S = /* @__PURE__ */ new Map();
      for (const M of n.mentionable()) S.set(M.uid, M.name);
      return S;
    });
    function y(S) {
      const M = S.map((_) => _ === s ? "You" : p.value.get(_) || "Someone");
      return M.length <= 3 ? M.join(", ") : M.slice(0, 3).join(", ") + " and " + (M.length - 3) + " more";
    }
    function v(S) {
      const M = S || r.value;
      if (!M) return;
      const _ = M.getBoundingClientRect();
      a.value = { x: _.left, y: _.top, w: _.width, h: _.height };
    }
    function x(S) {
      a.value = null, n.react(e.c.id, S);
    }
    function w() {
      e.first ? n.askDeleteThread(e.c.threadId) : n.deleteComment(e.c.id);
    }
    return (S, M) => (g(), b("div", {
      class: G(["cm-row", { "is-editing": c.value, "is-mine": d.value }]),
      "data-comment": i.c.id,
      "data-testid": "comment"
    }, [
      C(rr, {
        uid: i.c.authorId,
        name: i.c.authorName,
        size: 28
      }, null, 8, ["uid", "name"]),
      u("div", P5e, [
        u("div", E5e, [
          u("b", R5e, E(d.value ? i.c.authorName || "You" : i.c.authorName), 1),
          u("span", {
            class: "cm-row-time",
            title: m(Zp)(i.c.createdAt)
          }, E(f.value), 9, z5e),
          i.c.editedAt ? (g(), b("span", {
            key: 0,
            class: "cm-row-edited",
            title: "Edited " + m(Zp)(i.c.editedAt)
          }, "edited", 8, $5e)) : z("", !0)
        ]),
        c.value ? (g(), Ce(j0, {
          key: 0,
          people: m(n).mentionable(),
          me: m(s),
          text: i.c.text,
          mentions: i.c.mentions,
          editing: "",
          autofocus: "",
          testid: "edit",
          onSubmit: M[0] || (M[0] = (_) => m(n).edit(i.c.id, _.text, _.mentions)),
          onCancel: M[1] || (M[1] = (_) => m(n).ui.editingId = null)
        }, null, 8, ["people", "me", "text", "mentions"])) : (g(), Ce(du, {
          key: 1,
          class: "cm-row-text",
          text: i.c.text,
          mentions: i.c.mentions,
          me: m(s)
        }, null, 8, ["text", "mentions", "me"])),
        l.value.length && !c.value ? (g(), b("div", D5e, [
          (g(!0), b(j, null, be(l.value, (_) => (g(), b("button", {
            key: _.key,
            class: G(["cm-chip", { mine: _.mine }]),
            title: y(_.who) + " reacted with " + _.emoji,
            "data-testid": "reaction",
            onClick: (T) => x(_.emoji)
          }, [
            u("span", L5e, E(_.emoji), 1),
            u("span", B5e, E(_.count), 1)
          ], 10, O5e))), 128)),
          u("button", {
            class: "cm-chip is-add",
            title: "Add a reaction",
            "aria-label": "Add a reaction",
            onClick: M[2] || (M[2] = (_) => v(_.currentTarget))
          }, [
            C($, {
              name: "SmilePlus",
              size: 13
            })
          ])
        ])) : z("", !0)
      ]),
      c.value ? z("", !0) : (g(), b("div", F5e, [
        u("button", {
          ref_key: "reactBtn",
          ref: r,
          title: "React",
          "aria-label": "React",
          "data-testid": "comment-react",
          onClick: M[3] || (M[3] = (_) => v())
        }, [
          C($, {
            name: "SmilePlus",
            size: 14
          })
        ], 512),
        d.value ? (g(), b("button", {
          key: 0,
          title: "Edit",
          "aria-label": "Edit",
          "data-testid": "comment-edit",
          onClick: M[4] || (M[4] = (_) => m(n).ui.editingId = i.c.id)
        }, [
          C($, {
            name: "Pencil",
            size: 13
          })
        ])) : z("", !0),
        h.value ? (g(), b("button", {
          key: 1,
          title: i.first ? "Delete thread" : "Delete",
          "aria-label": i.first ? "Delete thread" : "Delete",
          "data-testid": "comment-delete",
          onClick: w
        }, [
          C($, {
            name: "Trash2",
            size: 13
          })
        ], 8, N5e)) : z("", !0)
      ])),
      (g(), Ce(m1, {
        defer: "",
        to: ".cm-portal"
      }, [
        a.value ? (g(), Ce($A, {
          key: 0,
          at: a.value,
          mode: "react",
          onPick: x,
          onClose: M[5] || (M[5] = (_) => a.value = null)
        }, null, 8, ["at"])) : z("", !0)
      ]))
    ], 10, A5e));
  }
}), G5e = ["data-thread", "data-testid"], j5e = { class: "cm-draft-head" }, H5e = ["title"], V5e = { class: "cm-card-head" }, W5e = {
  class: "cm-dots",
  role: "radiogroup",
  "aria-label": "Thread colour"
}, q5e = ["aria-checked", "title", "aria-label", "onClick"], K5e = ["title", "aria-label", "aria-pressed"], Y5e = ["title"], X5e = { class: "cm-card-menu-wrap" }, J5e = ["aria-expanded"], Z5e = {
  key: 0,
  class: "cm-card-menu",
  role: "menu",
  "data-testid": "thread-menu-list"
}, Q5e = { key: 0 }, e6e = ["title", "aria-label"], t6e = {
  key: 0,
  class: "cm-strip"
}, n6e = ["title"], i6e = {
  key: 1,
  class: "cm-resolved-note"
}, s6e = {
  key: 2,
  class: "cm-nav"
}, o6e = {
  class: "cm-nav-n",
  "data-testid": "thread-position"
}, r6e = { class: "cm-reply" }, a6e = /* @__PURE__ */ new Map(), E4 = /* @__PURE__ */ Pe({
  __name: "ThreadCard",
  props: {
    id: {},
    draft: { type: Boolean }
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = t.comments, s = t.user.uid, o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(!1), d = /* @__PURE__ */ qe({ w: 340, h: 200 }), c = I(() => e.draft ? null : n.thread(e.id)), h = I(() => c.value ? n.commentsOf(c.value.id) : []), f = I(() => !e.draft && n.ui.openId === e.id), p = I(() => !!c.value && n.pinned(c.value)), y = I(() => !!c.value && n.following(c.value)), v = I(() => !!c.value && n.isUnread(c.value)), x = I(() => f.value ? n.position() : null), w = I(() => c.value && Ks.find((le) => le.id === c.value.color) || Ks[0]), S = I(() => n.mentionable()), M = I(() => n.people.value.scope), _ = I(() => M.value === "team" || M.value === "restricted" ? t.labels.team : null), T = I(() => M.value === "personal" ? "Only you can see this personal board, so there's no one to mention." : M.value === "private" ? "Only its owner can see this private board. Share it from Access Settings to mention others." : null), k = I(() => {
      const le = c.value, he = e.draft && n.ui.draft ? n.ui.draft.anchor : null, Re = le ? le.anchorLabel : he ? he.label : "", Ne = le ? n.elementOf(le) : he && he.elementId ? t.store.get(he.elementId) : null;
      if (!Re && !Ne) return null;
      const Me = Cie(Ne);
      return { label: Re || "Board", icon: { image: "Image", video: "Video", note: "StickyNote", tool: "LayoutGrid", frame: "Frame", shape: "Square", chat: "MessagesSquare", canvas: "MapPin" }[Me] };
    }), P = 34, A = 14, R = 62, D = 76;
    function O() {
      if (e.draft) {
        const he = n.ui.draft;
        return he ? { x: he.anchor.x, y: he.anchor.y } : null;
      }
      const le = c.value;
      return le ? n.pointOf(le) : null;
    }
    function F() {
      const le = o.value, he = O();
      if (!le || !he) return;
      const Re = t.worldToClient(he.x, he.y), Ne = window.innerWidth, Me = window.innerHeight, { w: ue, h: U } = d.value, q = Ne - n.rightInset();
      let ie = Re.x + 34 + A;
      ie + ue > q - 8 && (ie = Re.x - A - ue), ie = Math.max(8, Math.min(ie, q - ue - 8));
      let de = Re.y - P - 6;
      de = Math.max(R, Math.min(de, Me - U - D));
      const pe = Re.x < -60 || Re.y < 0 || Re.x > Ne + 60 || Re.y > Me + 60;
      le.style.transform = "translate3d(" + Math.round(ie) + "px," + Math.round(de) + "px,0)", le.classList.toggle("is-away", pe);
    }
    let te = null, ee = null;
    ot(() => {
      te = t.onCameraFrame(() => F()), o.value && typeof ResizeObserver != "undefined" && (ee = new ResizeObserver(() => {
        o.value && (d.value = { w: o.value.offsetWidth, h: o.value.offsetHeight }, F());
      }), ee.observe(o.value)), F(), me(!1), window.addEventListener("resize", F);
    }), We(() => {
      te && te(), ee && ee.disconnect(), window.removeEventListener("resize", F);
    }), Ae(() => [t.docRev.value, n.ui.panelOpen, t.ui.boardHistory, n.ui.draft && n.ui.draft.anchor, n.ui.dragging], () => nt(F));
    function me(le = !0) {
      nt(() => {
        const he = r.value;
        he && he.scrollTo({ top: he.scrollHeight, behavior: le ? "smooth" : "auto" });
      });
    }
    Ae(() => h.value.length, (le, he) => {
      le > (he || 0) && me();
    });
    const L = a6e, N = I(() => e.id ? L.get(e.id) || { text: "", mentions: [] } : { text: "", mentions: [] });
    async function X(le) {
      if (e.draft) {
        await n.post(le.text, le.mentions);
        return;
      }
      if (!e.id) return;
      await n.reply(e.id, le.text, le.mentions) && (L.delete(e.id), a.value && a.value.reset());
    }
    function B(le) {
      if (e.draft) {
        const he = n.ui.draft;
        he && (he.text = le.text, he.mentions = le.mentions);
        return;
      }
      e.id && L.set(e.id, le);
    }
    function se() {
      e.draft ? n.cancelDraft() : n.close();
    }
    function V() {
      const le = h.value.filter((Re) => Re.authorId === s), he = le[le.length - 1];
      he && (n.ui.editingId = he.id);
    }
    Ae(() => e.draft && n.ui.draft ? n.ui.draft.n : 0, (le) => {
      le && a.value && a.value.nod();
    });
    function Z(le) {
      l.value = !1, le();
    }
    function Y() {
      const le = c.value;
      le && (f.value ? n.close() : n.pin(le.id, !1));
    }
    function H(le) {
      l.value && o.value && !le.target.closest(".cm-card-menu-wrap") && (l.value = !1);
    }
    function re(le) {
      le.key !== "Escape" || !l.value || (le.preventDefault(), le.stopPropagation(), l.value = !1);
    }
    return ot(() => {
      window.addEventListener("pointerdown", H, !0), window.addEventListener("keydown", re, !0);
    }), We(() => {
      window.removeEventListener("pointerdown", H, !0), window.removeEventListener("keydown", re, !0);
    }), (le, he) => (g(), b("div", {
      ref_key: "el",
      ref: o,
      class: G(["cm-card", { "is-draft": i.draft, "is-open": f.value, "is-pinned": p.value && !f.value, "is-resolved": c.value && !!c.value.resolvedAt }]),
      style: ce({ "--thread": w.value.hex }),
      "data-thread": i.draft ? "draft" : i.id,
      "data-testid": i.draft ? "comment-draft" : "comment-thread",
      onPointerdown: he[10] || (he[10] = Se(() => {
      }, ["stop"])),
      onWheel: he[11] || (he[11] = Se(() => {
      }, ["stop"])),
      onContextmenu: he[12] || (he[12] = Se(() => {
      }, ["stop"]))
    }, [
      i.draft ? (g(), b(j, { key: 0 }, [
        u("div", j5e, [
          C(rr, {
            uid: m(s),
            name: m(n).myName,
            size: 26
          }, null, 8, ["uid", "name"]),
          he[13] || (he[13] = u("span", { class: "cm-draft-title" }, "New comment", -1)),
          k.value ? (g(), b("span", {
            key: 0,
            class: "cm-on is-inline",
            title: "On " + k.value.label
          }, [
            C($, {
              name: k.value.icon,
              size: 11
            }, null, 8, ["name"]),
            J(E(k.value.label), 1)
          ], 8, H5e)) : z("", !0),
          u("button", {
            class: "cm-icon",
            title: "Discard (Esc)",
            "aria-label": "Discard",
            onClick: se
          }, [
            C($, {
              name: "X",
              size: 14
            })
          ])
        ]),
        C(j0, {
          ref_key: "composer",
          ref: a,
          people: S.value,
          me: m(s),
          text: m(n).ui.draft ? m(n).ui.draft.text : "",
          mentions: m(n).ui.draft ? m(n).ui.draft.mentions : [],
          group: _.value,
          alone: T.value,
          placeholder: "Add a comment. Use @ to mention.",
          autofocus: "",
          testid: "draft",
          onSubmit: X,
          onChange: B,
          onCancel: se
        }, null, 8, ["people", "me", "text", "mentions", "group", "alone"])
      ], 64)) : c.value ? (g(), b(j, { key: 1 }, [
        u("div", V5e, [
          u("div", W5e, [
            (g(!0), b(j, null, be(m(Ks), (Re) => (g(), b("button", {
              key: Re.id,
              class: G(["cm-dot", { on: c.value.color === Re.id }]),
              style: ce({ "--c": Re.hex }),
              role: "radio",
              "aria-checked": c.value.color === Re.id,
              title: Re.label,
              "aria-label": Re.label,
              onClick: (Ne) => m(n).setColor(c.value.id, Re.id)
            }, null, 14, q5e))), 128))
          ]),
          he[19] || (he[19] = u("span", { class: "cm-grow" }, null, -1)),
          u("button", {
            class: G(["cm-icon", { on: y.value }]),
            title: y.value ? "Following: replies show in your Updates. Click to unfollow" : "Follow: hear about replies in your Updates",
            "aria-label": y.value ? "Unfollow" : "Follow",
            "aria-pressed": y.value,
            "data-testid": "thread-follow",
            onClick: he[0] || (he[0] = (Re) => m(n).follow(c.value, !y.value))
          }, [
            C($, {
              name: y.value ? "Bell" : "BellOff",
              size: 14
            }, null, 8, ["name"])
          ], 10, K5e),
          u("button", {
            class: G(["cm-resolve", { on: !!c.value.resolvedAt }]),
            title: c.value.resolvedAt ? "Reopen" : "Resolve",
            "data-testid": "thread-resolve",
            onClick: he[1] || (he[1] = (Re) => m(n).resolve(c.value.id, !c.value.resolvedAt))
          }, [
            C($, {
              name: "CircleCheck",
              size: 14
            }),
            u("span", null, E(c.value.resolvedAt ? "Resolved" : "Resolve"), 1)
          ], 10, Y5e),
          u("div", X5e, [
            u("button", {
              class: G(["cm-icon", { on: l.value }]),
              title: "More",
              "aria-label": "More",
              "aria-haspopup": "menu",
              "aria-expanded": l.value,
              "data-testid": "thread-menu",
              onClick: he[2] || (he[2] = (Re) => l.value = !l.value)
            }, [
              C($, {
                name: "Ellipsis",
                size: 15
              })
            ], 10, J5e),
            l.value ? (g(), b("div", Z5e, [
              v.value ? (g(), b("button", {
                key: 0,
                role: "menuitem",
                "data-testid": "thread-mark-read",
                onClick: he[3] || (he[3] = (Re) => Z(() => m(n).markRead([c.value])))
              }, [
                C($, {
                  name: "CheckCheck",
                  size: 14
                }),
                he[14] || (he[14] = J("Mark as read", -1))
              ])) : (g(), b("button", {
                key: 1,
                role: "menuitem",
                "data-testid": "thread-mark-unread",
                onClick: he[4] || (he[4] = (Re) => Z(() => m(n).markUnread(c.value)))
              }, [
                C($, {
                  name: "MessageSquareDot",
                  size: 14
                }),
                he[15] || (he[15] = J("Mark as unread", -1))
              ])),
              u("button", {
                role: "menuitem",
                "data-testid": "thread-pin",
                onClick: he[5] || (he[5] = (Re) => Z(() => m(n).pin(c.value.id, !p.value)))
              }, [
                C($, {
                  name: p.value ? "PinOff" : "Pin",
                  size: 14
                }, null, 8, ["name"]),
                J(E(p.value ? "Unpin" : "Pin for yourself") + " ", 1),
                p.value ? z("", !0) : (g(), b("small", Q5e, "Keeps it open on the board"))
              ]),
              u("button", {
                role: "menuitem",
                "data-testid": "thread-copy-link",
                onClick: he[6] || (he[6] = (Re) => Z(() => m(n).copyLink(c.value)))
              }, [
                C($, {
                  name: "Link2",
                  size: 14
                }),
                he[16] || (he[16] = J("Copy link", -1))
              ]),
              m(n).canDelete(c.value) ? (g(), b(j, { key: 2 }, [
                he[18] || (he[18] = u("span", { class: "cm-card-menu-sep" }, null, -1)),
                u("button", {
                  role: "menuitem",
                  class: "is-danger",
                  "data-testid": "thread-delete",
                  onClick: he[7] || (he[7] = (Re) => Z(() => m(n).askDeleteThread(c.value.id)))
                }, [
                  C($, {
                    name: "Trash2",
                    size: 14
                  }),
                  he[17] || (he[17] = J("Delete thread", -1))
                ])
              ], 64)) : z("", !0)
            ])) : z("", !0)
          ]),
          u("button", {
            class: "cm-icon",
            title: f.value ? "Close (Esc)" : "Unpin",
            "aria-label": f.value ? "Close" : "Unpin",
            "data-testid": "thread-close",
            onClick: Y
          }, [
            C($, {
              name: f.value ? "X" : "PinOff",
              size: 14
            }, null, 8, ["name"])
          ], 8, e6e)
        ]),
        k.value || c.value.resolvedAt || x.value && x.value.of > 1 ? (g(), b("div", t6e, [
          k.value ? (g(), b("span", {
            key: 0,
            class: "cm-on",
            title: "On " + k.value.label
          }, [
            C($, {
              name: k.value.icon,
              size: 11
            }, null, 8, ["name"]),
            J(E(k.value.label), 1)
          ], 8, n6e)) : z("", !0),
          c.value.resolvedAt ? (g(), b("span", i6e, [
            C($, {
              name: "CircleCheck",
              size: 11
            }),
            he[20] || (he[20] = J("Resolved", -1))
          ])) : z("", !0),
          he[21] || (he[21] = u("span", { class: "cm-grow" }, null, -1)),
          x.value && x.value.of > 1 ? (g(), b("div", s6e, [
            u("button", {
              class: "cm-icon",
              title: "Previous thread",
              "aria-label": "Previous thread",
              "data-testid": "thread-prev",
              onClick: he[8] || (he[8] = (Re) => m(n).step(-1))
            }, [
              C($, {
                name: "ChevronLeft",
                size: 14
              })
            ]),
            u("span", o6e, E(x.value.at) + " of " + E(x.value.of), 1),
            u("button", {
              class: "cm-icon",
              title: "Next thread",
              "aria-label": "Next thread",
              "data-testid": "thread-next",
              onClick: he[9] || (he[9] = (Re) => m(n).step(1))
            }, [
              C($, {
                name: "ChevronRight",
                size: 14
              })
            ])
          ])) : z("", !0)
        ])) : z("", !0),
        u("div", {
          ref_key: "list",
          ref: r,
          class: "cm-list"
        }, [
          (g(!0), b(j, null, be(h.value, (Re, Ne) => (g(), Ce(U5e, {
            key: Re.id,
            c: Re,
            first: Ne === 0
          }, null, 8, ["c", "first"]))), 128))
        ], 512),
        u("div", r6e, [
          (g(), Ce(j0, {
            ref_key: "composer",
            ref: a,
            key: "r" + c.value.id,
            people: S.value,
            me: m(s),
            text: N.value.text,
            mentions: N.value.mentions,
            group: _.value,
            alone: T.value,
            placeholder: c.value.resolvedAt ? "Reply to reopen" : "Reply",
            autofocus: f.value,
            testid: "reply",
            onSubmit: X,
            onChange: B,
            onCancel: se,
            onEditLast: V
          }, null, 8, ["people", "me", "text", "mentions", "group", "alone", "placeholder", "autofocus"]))
        ])
      ], 64)) : z("", !0)
    ], 46, G5e));
  }
}), l6e = { class: "cm-reply-main" }, d6e = { class: "cm-reply-head" }, c6e = ["title"], u6e = { key: 0 }, R4 = /* @__PURE__ */ Pe({
  __name: "ReplyRow",
  props: {
    c: {},
    me: {},
    now: {},
    fresh: { type: Boolean, default: !1 },
    clamp: { default: 4 }
  },
  setup(i) {
    return (e, t) => (g(), b("div", {
      class: G(["cm-reply-row", { "is-new": i.fresh }]),
      "data-testid": "comments-reply"
    }, [
      C(rr, {
        uid: i.c.authorId,
        name: i.c.authorName,
        size: 20
      }, null, 8, ["uid", "name"]),
      u("div", l6e, [
        u("div", d6e, [
          u("b", null, E(i.c.authorName), 1),
          u("span", {
            title: m(Zp)(i.c.createdAt)
          }, E(m(Jn)(i.c.createdAt, i.now)), 9, c6e),
          i.fresh ? (g(), b("i", u6e, "new")) : z("", !0)
        ]),
        C(du, {
          class: "cm-reply-text",
          text: i.c.text,
          mentions: i.c.mentions,
          me: i.me,
          clamp: i.clamp
        }, null, 8, ["text", "mentions", "me", "clamp"])
      ])
    ], 2));
  }
}), h6e = { class: "cm-panel-head" }, p6e = { class: "cm-panel-settings-wrap" }, f6e = {
  key: 0,
  class: "cm-card-menu is-settings",
  role: "menu",
  "data-testid": "comments-settings-menu"
}, m6e = ["aria-checked"], g6e = ["aria-checked"], b6e = ["disabled"], v6e = {
  class: "cm-tabs",
  role: "tablist"
}, y6e = ["aria-selected"], x6e = {
  key: 0,
  class: "cm-count"
}, w6e = ["aria-selected"], k6e = {
  key: 0,
  class: "cm-count"
}, _6e = { class: "cm-tools" }, S6e = { class: "cm-search" }, M6e = {
  class: "cm-chips",
  role: "radiogroup",
  "aria-label": "Show"
}, T6e = ["aria-checked", "data-testid", "onClick"], C6e = {
  key: 0,
  class: "n"
}, I6e = {
  class: "cm-feed",
  "data-testid": "comments-feed"
}, A6e = {
  key: 0,
  class: "cm-feed-empty"
}, P6e = {
  key: 1,
  class: "cm-feed-empty"
}, E6e = { class: "cm-empty-mark is-error" }, R6e = {
  key: 2,
  class: "cm-feed-empty",
  "data-testid": "comments-empty"
}, z6e = { class: "cm-empty-mark" }, $6e = {
  key: 3,
  class: "cm-feed-empty"
}, D6e = { class: "cm-empty-mark" }, O6e = {
  key: 0,
  class: "cm-feed-label"
}, L6e = {
  key: 0,
  class: "cm-feed-label"
}, B6e = ["data-thread", "onClick", "onKeydown"], F6e = {
  key: 0,
  class: "cm-item-dot",
  "aria-label": "Unread"
}, N6e = { class: "cm-item-main" }, U6e = { class: "cm-item-head" }, G6e = { class: "cm-item-time" }, j6e = {
  key: 1,
  class: "cm-item-on"
}, H6e = { class: "cm-item-on-label" }, V6e = {
  key: 2,
  class: "cm-replies"
}, W6e = ["onClick"], q6e = {
  key: 3,
  class: "cm-item-foot"
}, K6e = { class: "cm-item-resolved" }, Y6e = ["title", "aria-label", "onClick"], X6e = ["title", "aria-label", "onClick"], J6e = { class: "cm-item-menu-wrap" }, Z6e = ["onClick"], Q6e = ["onClick"], e8e = ["onClick"], t8e = ["onClick"], n8e = ["onClick"], i8e = { class: "cm-tools is-elsewhere" }, s8e = {
  class: "cm-chips",
  role: "radiogroup",
  "aria-label": "Show"
}, o8e = ["aria-checked"], r8e = {
  key: 0,
  class: "n"
}, a8e = ["aria-checked"], l8e = ["disabled"], d8e = {
  class: "cm-feed",
  "data-testid": "elsewhere-feed"
}, c8e = {
  key: 0,
  class: "cm-feed-empty"
}, u8e = { class: "cm-empty-mark" }, h8e = { class: "cm-board-head" }, p8e = { class: "cm-board-title" }, f8e = { class: "cm-board-n" }, m8e = ["onClick"], g8e = ["onClick", "onKeydown"], b8e = {
  key: 0,
  class: "cm-item-dot",
  "aria-label": "Unread"
}, v8e = { class: "cm-item-main" }, y8e = { class: "cm-item-head" }, x8e = { class: "cm-item-time" }, w8e = {
  key: 1,
  class: "cm-replies is-all",
  "data-testid": "elsewhere-thread"
}, k8e = {
  key: 0,
  class: "bd-spinner is-sm"
}, _8e = {
  key: 1,
  class: "cm-replies-failed"
}, S8e = { class: "cm-item-foot" }, M8e = {
  key: 0,
  class: "cm-item-resolved"
}, T8e = ["onClick"], C8e = { class: "cm-item-open" }, I8e = ["title", "aria-label", "onClick"], A8e = ["onClick"], P8e = /* @__PURE__ */ Pe({
  __name: "UpdatesPanel",
  setup(i) {
    const { board: e } = Ze(), t = e.comments, n = e.user.uid, s = dr(), o = /* @__PURE__ */ K(!1), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = [
      { id: "all", label: "All" },
      { id: "unread", label: "Unread" },
      { id: "mentions", label: "Mentions" },
      { id: "mine", label: "Yours" }
    ], d = I(() => t.feed.value), c = I(() => d.value.filter((X) => X.pinned)), h = I(() => d.value.filter((X) => !X.pinned)), f = I(() => t.allThreads().filter((X) => !X.resolvedAt || t.ui.showResolved).length), p = (X) => (Ks.find((B) => B.id === X) || Ks[0]).hex;
    function y(X) {
      r.value = null, t.focus(X.t.id);
    }
    const v = /* @__PURE__ */ K(!1);
    function x(X, B) {
      if (r.value === X) {
        r.value = null;
        return;
      }
      const se = B.currentTarget.getBoundingClientRect(), V = B.currentTarget.closest(".cm-feed"), Z = V ? V.getBoundingClientRect().bottom : window.innerHeight;
      v.value = Z - se.bottom < 200, r.value = X;
    }
    function w(X) {
      r.value = null, o.value = !1, X();
    }
    function S() {
      t.ui.panelOpen = !1;
    }
    function M() {
      S(), t.arm(!0);
    }
    const _ = I(() => {
      if (t.ui.query) return { title: "No matches", sub: "Nothing on this board says “" + t.ui.query + "”." };
      switch (t.ui.filter) {
        case "unread":
          return { title: "You're all caught up", sub: "Nothing unread on this board." };
        case "mentions":
          return { title: "No mentions", sub: "When someone @mentions you, or replies where you've commented, it shows here." };
        case "mine":
          return { title: "Nothing of yours yet", sub: "Threads you start or reply to show here." };
        default:
          return null;
      }
    }), T = /* @__PURE__ */ K(/* @__PURE__ */ new Set());
    function k(X) {
      const B = new Set(T.value);
      B.has(X) ? B.delete(X) : B.add(X), T.value = B;
    }
    function P(X) {
      return t.commentsOf(X.t.id).slice(1);
    }
    function A(X) {
      const B = P(X);
      return T.value.has(X.t.id) ? B : B.slice(-1);
    }
    function R(X) {
      return P(X).slice(0, -1).filter((B) => t.isFresh(X.t, B)).length;
    }
    const D = I(() => t.elsewhere.value), O = /* @__PURE__ */ qe({});
    function F(X) {
      const B = O.value[X.id];
      return B && B.at === X.lastAt ? B : null;
    }
    async function te(X) {
      if (k(X.id), !T.value.has(X.id) || F(X)) return;
      const B = X.lastAt;
      O.value = { ...O.value, [X.id]: { at: B, list: null } };
      try {
        const se = await t.commentsElsewhere(X);
        O.value = { ...O.value, [X.id]: { at: B, list: se } };
      } catch (se) {
        console.warn("[board] comments: a thread on another board couldn't be read", se), O.value = { ...O.value, [X.id]: { at: B, list: [], failed: !0 } };
      }
    }
    function ee(X) {
      r.value = null, t.openElsewhere(X);
    }
    function me(X) {
      const B = X.target;
      o.value && !B.closest(".cm-panel-settings-wrap") && (o.value = !1), r.value && !B.closest(".cm-item-menu-wrap") && (r.value = null);
    }
    function L(X) {
      X.key !== "Escape" || !o.value && !r.value || (X.preventDefault(), X.stopPropagation(), o.value = !1, r.value = null);
    }
    function N(X) {
      X.key === "/" && document.activeElement !== a.value && !X.target.closest("textarea, input") && (X.preventDefault(), a.value && a.value.focus());
    }
    return ot(() => {
      window.addEventListener("pointerdown", me, !0), window.addEventListener("keydown", N), window.addEventListener("keydown", L, !0), t.refreshPeople();
    }), We(() => {
      window.removeEventListener("pointerdown", me, !0), window.removeEventListener("keydown", N), window.removeEventListener("keydown", L, !0);
    }), (X, B) => (g(), b("aside", {
      class: "cm-panel",
      "aria-label": "Comments",
      "data-testid": "comments-panel",
      onPointerdown: B[13] || (B[13] = Se(() => {
      }, ["stop"])),
      onWheel: B[14] || (B[14] = Se(() => {
      }, ["stop"]))
    }, [
      u("div", h6e, [
        B[20] || (B[20] = u("span", { class: "cm-panel-title" }, "Comments", -1)),
        B[21] || (B[21] = u("span", { class: "cm-grow" }, null, -1)),
        u("button", {
          class: "cm-icon",
          title: "Comment (C)",
          "aria-label": "Add a comment",
          "data-testid": "comments-add",
          onClick: M
        }, [
          C($, {
            name: "MessageCirclePlus",
            size: 15
          })
        ]),
        u("div", p6e, [
          u("button", {
            class: G(["cm-icon", { on: o.value }]),
            title: "Settings",
            "aria-label": "Settings",
            "data-testid": "comments-settings",
            onClick: B[0] || (B[0] = (se) => o.value = !o.value)
          }, [
            C($, {
              name: "SlidersHorizontal",
              size: 15
            })
          ], 2),
          o.value ? (g(), b("div", f6e, [
            u("button", {
              role: "menuitemcheckbox",
              "aria-checked": m(t).ui.showPins,
              "data-testid": "comments-show-pins",
              onClick: B[1] || (B[1] = (se) => m(t).ui.showPins = !m(t).ui.showPins)
            }, [
              C($, {
                name: m(t).ui.showPins ? "Eye" : "EyeOff",
                size: 14
              }, null, 8, ["name"]),
              B[15] || (B[15] = J("Comments on the board ", -1)),
              u("span", {
                class: G(["cm-switch", { on: m(t).ui.showPins }])
              }, null, 2),
              B[16] || (B[16] = u("kbd", null, "⇧C", -1))
            ], 8, m6e),
            u("button", {
              role: "menuitemcheckbox",
              "aria-checked": m(t).ui.showResolved,
              "data-testid": "comments-show-resolved",
              onClick: B[2] || (B[2] = (se) => m(t).ui.showResolved = !m(t).ui.showResolved)
            }, [
              C($, {
                name: "CircleCheck",
                size: 14
              }),
              B[17] || (B[17] = J("Resolved threads ", -1)),
              u("span", {
                class: G(["cm-switch", { on: m(t).ui.showResolved }])
              }, null, 2)
            ], 8, g6e),
            B[19] || (B[19] = u("span", { class: "cm-card-menu-sep" }, null, -1)),
            u("button", {
              role: "menuitem",
              disabled: !m(t).unreadCount.value,
              "data-testid": "comments-mark-all",
              onClick: B[3] || (B[3] = (se) => w(() => m(t).markAllRead()))
            }, [
              C($, {
                name: "CheckCheck",
                size: 14
              }),
              B[18] || (B[18] = J("Mark all as read", -1))
            ], 8, b6e)
          ])) : z("", !0)
        ]),
        u("button", {
          class: "cm-icon",
          title: "Close (Esc)",
          "aria-label": "Close comments",
          "data-testid": "comments-close",
          onClick: S
        }, [
          C($, {
            name: "X",
            size: 15
          })
        ])
      ]),
      u("div", v6e, [
        u("button", {
          role: "tab",
          "aria-selected": m(t).ui.tab === "board",
          class: G({ on: m(t).ui.tab === "board" }),
          "data-testid": "comments-tab-board",
          onClick: B[4] || (B[4] = (se) => m(t).ui.tab = "board")
        }, [
          B[22] || (B[22] = J(" This board", -1)),
          m(t).unreadCount.value ? (g(), b("span", x6e, E(m(t).unreadCount.value), 1)) : z("", !0)
        ], 10, y6e),
        u("button", {
          role: "tab",
          "aria-selected": m(t).ui.tab === "elsewhere",
          class: G({ on: m(t).ui.tab === "elsewhere" }),
          "data-testid": "comments-tab-elsewhere",
          onClick: B[5] || (B[5] = (se) => m(t).ui.tab = "elsewhere")
        }, [
          B[23] || (B[23] = J(" Everywhere else", -1)),
          m(t).elsewhereUnread.value ? (g(), b("span", k6e, E(m(t).elsewhereUnread.value), 1)) : z("", !0)
        ], 10, w6e)
      ]),
      m(t).ui.tab === "board" ? (g(), b(j, { key: 0 }, [
        u("div", _6e, [
          u("label", S6e, [
            C($, {
              name: "Search",
              size: 13
            }),
            kt(u("input", {
              ref_key: "search",
              ref: a,
              "onUpdate:modelValue": B[6] || (B[6] = (se) => m(t).ui.query = se),
              type: "text",
              placeholder: "Search comments",
              spellcheck: "false",
              "data-testid": "comments-search"
            }, null, 512), [
              [Zt, m(t).ui.query]
            ]),
            m(t).ui.query ? (g(), b("button", {
              key: 0,
              class: "cm-search-clear",
              "aria-label": "Clear the search",
              onClick: B[7] || (B[7] = (se) => m(t).ui.query = "")
            }, [
              C($, {
                name: "X",
                size: 12
              })
            ])) : z("", !0)
          ]),
          u("div", M6e, [
            (g(), b(j, null, be(l, (se) => u("button", {
              key: se.id,
              class: G(["cm-fchip", { on: m(t).ui.filter === se.id }]),
              role: "radio",
              "aria-checked": m(t).ui.filter === se.id,
              "data-testid": "comments-filter-" + se.id,
              onClick: (V) => m(t).ui.filter = se.id
            }, [
              J(E(se.label), 1),
              se.id === "unread" && m(t).unreadCount.value ? (g(), b("span", C6e, E(m(t).unreadCount.value), 1)) : z("", !0)
            ], 10, T6e)), 64))
          ])
        ]),
        u("div", I6e, [
          m(t).loaded.value ? m(t).failed.value ? (g(), b("div", P6e, [
            u("span", E6e, [
              C($, {
                name: "CloudOff",
                size: 18
              })
            ]),
            B[25] || (B[25] = u("b", null, "Comments are unavailable", -1)),
            B[26] || (B[26] = u("span", null, "They couldn't be loaded on this board. Please reload the page.", -1))
          ])) : f.value ? !d.value.length && _.value ? (g(), b("div", $6e, [
            u("span", D6e, [
              C($, {
                name: m(t).ui.filter === "unread" && !m(t).ui.query ? "CheckCheck" : "Search",
                size: 18
              }, null, 8, ["name"])
            ]),
            u("b", null, E(_.value.title), 1),
            u("span", null, E(_.value.sub), 1)
          ])) : (g(), b(j, { key: 4 }, [
            c.value.length ? (g(), b("div", O6e, [
              C($, {
                name: "Pin",
                size: 11
              }),
              B[30] || (B[30] = J("Pinned for you", -1))
            ])) : z("", !0),
            (g(!0), b(j, null, be([c.value, h.value], (se, V) => (g(), b(j, { key: V }, [
              V === 1 && c.value.length && h.value.length ? (g(), b("div", L6e, "Recent activity")) : z("", !0),
              (g(!0), b(j, null, be(se, (Z) => (g(), b("div", {
                key: Z.t.id,
                class: G(["cm-item", { "is-unread": Z.unread, "is-open": m(t).ui.openId === Z.t.id, "is-resolved": !!Z.t.resolvedAt }]),
                style: ce({ "--thread": p(Z.t.color) }),
                role: "button",
                tabindex: "0",
                "data-thread": Z.t.id,
                "data-testid": "comments-item",
                onClick: (Y) => y(Z),
                onKeydown: tn((Y) => y(Z), ["enter"])
              }, [
                Z.unread ? (g(), b("span", F6e)) : z("", !0),
                C(rr, {
                  uid: Z.t.createdBy,
                  name: Z.t.createdByName,
                  size: 28
                }, null, 8, ["uid", "name"]),
                u("div", N6e, [
                  u("div", U6e, [
                    u("b", null, E(Z.first ? Z.first.authorName : Z.t.createdByName), 1),
                    u("span", G6e, E(m(Jn)(Z.first ? Z.first.createdAt : Z.t.createdAt, m(s))), 1)
                  ]),
                  Z.first ? (g(), Ce(du, {
                    key: 0,
                    class: "cm-item-text",
                    text: Z.first.text,
                    mentions: Z.first.mentions,
                    me: m(n),
                    clamp: 3
                  }, null, 8, ["text", "mentions", "me"])) : z("", !0),
                  Z.t.anchorLabel || Z.t.anchorThumb ? (g(), b("div", j6e, [
                    Z.t.anchorThumb ? (g(), b("span", {
                      key: 0,
                      class: "cm-item-thumb",
                      style: ce({ backgroundImage: 'url("' + m(Bt)(Z.t.anchorThumb) + '")' })
                    }, null, 4)) : z("", !0),
                    u("span", H6e, E(Z.t.anchorLabel || "Board"), 1)
                  ])) : z("", !0),
                  Z.replies ? (g(), b("div", V6e, [
                    Z.replies > 1 ? (g(), b("button", {
                      key: 0,
                      class: G(["cm-replies-more", { "is-new": !T.value.has(Z.t.id) && R(Z) }]),
                      "data-testid": "comments-replies-toggle",
                      onClick: Se((Y) => k(Z.t.id), ["stop"])
                    }, [
                      T.value.has(Z.t.id) ? (g(), b(j, { key: 0 }, [
                        J("Hide earlier replies")
                      ], 64)) : (g(), b(j, { key: 1 }, [
                        J("Show " + E(Z.replies - 1) + " earlier " + E(Z.replies - 1 === 1 ? "reply" : "replies"), 1),
                        R(Z) ? (g(), b(j, { key: 0 }, [
                          J(" · " + E(R(Z)) + " new", 1)
                        ], 64)) : z("", !0)
                      ], 64))
                    ], 10, W6e)) : z("", !0),
                    (g(!0), b(j, null, be(A(Z), (Y) => (g(), Ce(R4, {
                      key: Y.id,
                      c: Y,
                      me: m(n),
                      now: m(s),
                      fresh: m(t).isFresh(Z.t, Y)
                    }, null, 8, ["c", "me", "now", "fresh"]))), 128))
                  ])) : z("", !0),
                  Z.t.resolvedAt ? (g(), b("div", q6e, [
                    u("span", K6e, [
                      C($, {
                        name: "CircleCheck",
                        size: 11
                      }),
                      B[31] || (B[31] = J("Resolved", -1))
                    ])
                  ])) : z("", !0)
                ]),
                u("div", {
                  class: "cm-item-acts",
                  onClick: B[8] || (B[8] = Se(() => {
                  }, ["stop"]))
                }, [
                  u("button", {
                    class: G(["is-resolve", { on: !!Z.t.resolvedAt }]),
                    title: Z.t.resolvedAt ? "Reopen" : "Resolve",
                    "aria-label": Z.t.resolvedAt ? "Reopen" : "Resolve",
                    "data-testid": "comments-item-resolve",
                    onClick: (Y) => m(t).resolve(Z.t.id, !Z.t.resolvedAt)
                  }, [
                    C($, {
                      name: "CircleCheck",
                      size: 14
                    })
                  ], 10, Y6e),
                  u("button", {
                    title: Z.unread ? "Mark as read" : "Mark as unread",
                    "aria-label": Z.unread ? "Mark as read" : "Mark as unread",
                    "data-testid": "comments-item-read",
                    onClick: (Y) => Z.unread ? m(t).markRead([Z.t]) : m(t).markUnread(Z.t)
                  }, [
                    C($, {
                      name: Z.unread ? "CheckCheck" : "MessageSquareDot",
                      size: 14
                    }, null, 8, ["name"])
                  ], 8, X6e),
                  u("div", J6e, [
                    u("button", {
                      title: "More",
                      "aria-label": "More",
                      class: G({ on: r.value === Z.t.id }),
                      "data-testid": "comments-item-more",
                      onClick: (Y) => x(Z.t.id, Y)
                    }, [
                      C($, {
                        name: "Ellipsis",
                        size: 14
                      })
                    ], 10, Z6e),
                    r.value === Z.t.id ? (g(), b("div", {
                      key: 0,
                      class: G(["cm-card-menu is-item", { "is-up": v.value }]),
                      role: "menu",
                      "data-testid": "comments-item-menu"
                    }, [
                      u("button", {
                        role: "menuitem",
                        onClick: (Y) => w(() => m(t).follow(Z.t, !m(t).following(Z.t)))
                      }, [
                        C($, {
                          name: m(t).following(Z.t) ? "BellOff" : "Bell",
                          size: 14
                        }, null, 8, ["name"]),
                        J(E(m(t).following(Z.t) ? "Unfollow" : "Follow"), 1)
                      ], 8, Q6e),
                      u("button", {
                        role: "menuitem",
                        onClick: (Y) => w(() => m(t).pin(Z.t.id, !Z.pinned))
                      }, [
                        C($, {
                          name: Z.pinned ? "PinOff" : "Pin",
                          size: 14
                        }, null, 8, ["name"]),
                        J(E(Z.pinned ? "Unpin" : "Pin for yourself"), 1)
                      ], 8, e8e),
                      u("button", {
                        role: "menuitem",
                        onClick: (Y) => w(() => m(t).copyLink(Z.t))
                      }, [
                        C($, {
                          name: "Link2",
                          size: 14
                        }),
                        B[32] || (B[32] = J("Copy link", -1))
                      ], 8, t8e),
                      m(t).canDelete(Z.t) ? (g(), b(j, { key: 0 }, [
                        B[34] || (B[34] = u("span", { class: "cm-card-menu-sep" }, null, -1)),
                        u("button", {
                          role: "menuitem",
                          class: "is-danger",
                          onClick: (Y) => w(() => m(t).askDeleteThread(Z.t.id))
                        }, [
                          C($, {
                            name: "Trash2",
                            size: 14
                          }),
                          B[33] || (B[33] = J("Delete thread", -1))
                        ], 8, n8e)
                      ], 64)) : z("", !0)
                    ], 2)) : z("", !0)
                  ])
                ])
              ], 46, B6e))), 128))
            ], 64))), 128))
          ], 64)) : (g(), b("div", R6e, [
            u("span", z6e, [
              C($, {
                name: "MessageCircle",
                size: 18
              })
            ]),
            B[28] || (B[28] = u("b", null, "No comments yet", -1)),
            B[29] || (B[29] = u("span", null, [
              J("Press "),
              u("kbd", null, "C"),
              J(", then click anything on the board (or anywhere on it) to start a thread.")
            ], -1)),
            u("button", {
              class: "cm-btn",
              onClick: M
            }, [
              C($, {
                name: "MessageCirclePlus",
                size: 14
              }),
              B[27] || (B[27] = J("Add a comment", -1))
            ])
          ])) : (g(), b("div", A6e, [...B[24] || (B[24] = [
            u("span", { class: "bd-spinner is-sm" }, null, -1)
          ])]))
        ])
      ], 64)) : (g(), b(j, { key: 1 }, [
        u("div", i8e, [
          u("div", s8e, [
            u("button", {
              class: G(["cm-fchip", { on: m(t).ui.elsewhereUnread }]),
              role: "radio",
              "aria-checked": m(t).ui.elsewhereUnread,
              "data-testid": "elsewhere-unread",
              onClick: B[9] || (B[9] = (se) => m(t).ui.elsewhereUnread = !0)
            }, [
              B[35] || (B[35] = J(" Unread", -1)),
              m(t).elsewhereUnread.value ? (g(), b("span", r8e, E(m(t).elsewhereUnread.value), 1)) : z("", !0)
            ], 10, o8e),
            u("button", {
              class: G(["cm-fchip", { on: !m(t).ui.elsewhereUnread }]),
              role: "radio",
              "aria-checked": !m(t).ui.elsewhereUnread,
              "data-testid": "elsewhere-all",
              onClick: B[10] || (B[10] = (se) => m(t).ui.elsewhereUnread = !1)
            }, "All", 10, a8e)
          ]),
          B[36] || (B[36] = u("span", { class: "cm-grow" }, null, -1)),
          u("button", {
            class: "cm-linkbtn",
            disabled: !m(t).elsewhereUnread.value,
            "data-testid": "elsewhere-mark-all",
            onClick: B[11] || (B[11] = (se) => m(t).markAllReadElsewhere())
          }, "Mark all as read", 8, l8e)
        ]),
        u("div", d8e, [
          D.value.length ? z("", !0) : (g(), b("div", c8e, [
            u("span", u8e, [
              C($, {
                name: "Inbox",
                size: 18
              })
            ]),
            u("b", null, E(m(t).ui.elsewhereUnread ? "Nothing new elsewhere" : "Nothing to follow yet"), 1),
            B[37] || (B[37] = u("span", null, "Threads you start, reply to or are mentioned in on your other boards show here.", -1))
          ])),
          (g(!0), b(j, null, be(D.value, (se) => (g(), b("section", {
            key: se.boardId,
            class: "cm-board-group",
            "data-testid": "elsewhere-board"
          }, [
            u("div", h8e, [
              C($, {
                name: "LayoutDashboard",
                size: 12
              }),
              u("span", p8e, E(se.title), 1),
              u("span", f8e, E(se.items.length), 1),
              B[38] || (B[38] = u("span", { class: "cm-grow" }, null, -1)),
              se.items.some((V) => m(gs)(V, m(n))) ? (g(), b("button", {
                key: 0,
                class: "cm-linkbtn is-sm",
                title: "Mark this board's as read",
                onClick: (V) => m(t).markAllReadElsewhere(se.boardId)
              }, "Mark read", 8, m8e)) : z("", !0)
            ]),
            (g(!0), b(j, null, be(se.items, (V) => (g(), b("div", {
              key: V.id,
              class: G(["cm-item is-elsewhere", { "is-unread": m(gs)(V, m(n)), "is-resolved": !!V.resolvedAt }]),
              style: ce({ "--thread": p(V.color) }),
              role: "button",
              tabindex: "0",
              "data-testid": "elsewhere-item",
              onClick: (Z) => ee(V),
              onKeydown: tn((Z) => ee(V), ["enter"])
            }, [
              m(gs)(V, m(n)) ? (g(), b("span", b8e)) : z("", !0),
              C(rr, {
                uid: V.preview ? V.preview.by : V.createdBy,
                name: V.preview ? V.preview.byName : V.createdByName,
                size: 28
              }, null, 8, ["uid", "name"]),
              u("div", v8e, [
                u("div", y8e, [
                  u("b", null, E(V.preview ? V.preview.byName : V.createdByName), 1),
                  u("span", x8e, E(m(Jn)(V.lastAt, m(s))), 1)
                ]),
                V.preview && !T.value.has(V.id) ? (g(), Ce(du, {
                  key: 0,
                  class: "cm-item-text",
                  text: V.preview.text,
                  mentions: [{ uid: m(n), name: m(t).myName }],
                  me: m(n),
                  clamp: 3
                }, null, 8, ["text", "mentions", "me"])) : z("", !0),
                T.value.has(V.id) ? (g(), b("div", w8e, [
                  F(V) && !F(V).list ? (g(), b("span", k8e)) : F(V) && F(V).failed ? (g(), b("span", _8e, "This thread couldn't be read. Open it on its board.")) : F(V) ? (g(!0), b(j, { key: 2 }, be(F(V).list, (Z) => (g(), Ce(R4, {
                    key: Z.id,
                    c: Z,
                    me: m(n),
                    now: m(s),
                    fresh: m(t).isFresh(V, Z)
                  }, null, 8, ["c", "me", "now", "fresh"]))), 128)) : z("", !0)
                ])) : z("", !0),
                u("div", S8e, [
                  V.resolvedAt ? (g(), b("span", M8e, [
                    C($, {
                      name: "CircleCheck",
                      size: 11
                    }),
                    B[39] || (B[39] = J("Resolved", -1))
                  ])) : z("", !0),
                  V.count > 1 ? (g(), b("button", {
                    key: 1,
                    class: "cm-replies-more",
                    "data-testid": "elsewhere-thread-toggle",
                    onClick: Se((Z) => te(V), ["stop"])
                  }, E(T.value.has(V.id) ? "Show only the newest" : "Show all " + V.count + " comments"), 9, T8e)) : z("", !0),
                  u("span", C8e, [
                    B[40] || (B[40] = J("Open", -1)),
                    C($, {
                      name: "ArrowUpRight",
                      size: 11
                    })
                  ])
                ])
              ]),
              u("div", {
                class: "cm-item-acts",
                onClick: B[12] || (B[12] = Se(() => {
                }, ["stop"]))
              }, [
                u("button", {
                  title: m(gs)(V, m(n)) ? "Mark as read" : "Mark as unread",
                  "aria-label": m(gs)(V, m(n)) ? "Mark as read" : "Mark as unread",
                  onClick: (Z) => m(gs)(V, m(n)) ? m(t).markRead([V]) : m(t).markUnread(V)
                }, [
                  C($, {
                    name: m(gs)(V, m(n)) ? "CheckCheck" : "MessageSquareDot",
                    size: 14
                  }, null, 8, ["name"])
                ], 8, I8e),
                u("button", {
                  title: "Unfollow",
                  "aria-label": "Unfollow",
                  onClick: (Z) => m(t).follow(V, !1)
                }, [
                  C($, {
                    name: "BellOff",
                    size: 14
                  })
                ], 8, A8e)
              ])
            ], 46, g8e))), 128))
          ]))), 128))
        ])
      ], 64))
    ], 32));
  }
}), E8e = { class: "ic" }, R8e = { class: "tx" }, z8e = { class: "acts" }, $8e = /* @__PURE__ */ Pe({
  __name: "DeleteThreadAsk",
  setup(i) {
    const { board: e } = Ze(), t = e.comments, n = I(() => t.ui.confirmDelete);
    function s(d) {
      return d.length <= 2 ? d.join(" and ") : d.slice(0, 2).join(", ") + " and " + (d.length - 2) + (d.length - 2 === 1 ? " other" : " others");
    }
    const o = I(() => {
      const d = n.value;
      return d ? (d.replies === 1 ? "A reply from " : d.replies + " replies from ") + s(d.names) + " will be deleted with it. You can undo it for a few seconds." : "";
    }), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null);
    Ae(n, (d) => {
      d && nt(() => r.value && r.value.focus({ preventScroll: !0 }));
    }, { immediate: !0 });
    function l(d) {
      if (n.value) {
        if (d.key === "Escape")
          d.preventDefault(), d.stopImmediatePropagation(), t.answerDelete(!1);
        else if (d.key === "Enter") {
          const c = d.target;
          if (c && a.value && a.value.contains(c) && c.tagName === "BUTTON") return;
          d.preventDefault(), d.stopImmediatePropagation();
        } else if (d.key === "Tab") {
          const c = d.target;
          (!c || !a.value || !a.value.contains(c)) && (d.preventDefault(), r.value && r.value.focus({ preventScroll: !0 }));
        }
      }
    }
    return ot(() => window.addEventListener("keydown", l, !0)), We(() => window.removeEventListener("keydown", l, !0)), (d, c) => (g(), Ce(vt, { name: "cm-ask" }, {
      default: Xe(() => [
        n.value ? (g(), b("div", {
          key: 0,
          class: "cm-ask",
          role: "alertdialog",
          "aria-modal": "true",
          "aria-label": "Delete this thread?",
          "data-testid": "thread-delete-ask",
          onPointerdown: c[2] || (c[2] = Se((h) => m(t).answerDelete(!1), ["self"]))
        }, [
          u("div", {
            ref_key: "card",
            ref: a,
            class: "cm-ask-card"
          }, [
            u("span", E8e, [
              C($, {
                name: "Trash2",
                size: 16
              })
            ]),
            u("div", R8e, [
              c[3] || (c[3] = u("b", null, "Delete this thread?", -1)),
              u("span", null, E(o.value), 1)
            ]),
            u("div", z8e, [
              u("button", {
                class: "cm-ask-btn",
                "data-testid": "thread-delete-keep",
                onClick: c[0] || (c[0] = (h) => m(t).answerDelete(!1))
              }, "Keep it"),
              u("button", {
                ref_key: "confirmBtn",
                ref: r,
                class: "cm-ask-btn is-danger",
                "data-testid": "thread-delete-confirm",
                onClick: c[1] || (c[1] = (h) => m(t).answerDelete(!0))
              }, "Delete thread", 512)
            ])
          ], 512)
        ], 32)) : z("", !0)
      ]),
      _: 1
    }));
  }
}), D8e = { key: 0 }, O8e = { key: 0 }, L8e = { key: 0 }, B8e = { key: 1 }, F8e = { key: 0 }, N8e = { key: 2 }, U8e = { key: 0 }, Bb = /* @__PURE__ */ Pe({
  __name: "ChatText",
  props: {
    text: {},
    caret: { type: Boolean }
  },
  setup(i) {
    const e = i;
    function t(s) {
      const o = [], r = s.split(/(\*\*[^*]+\*\*)/g);
      for (const a of r)
        a && (/^\*\*[^*]+\*\*$/.test(a) ? o.push({ bold: !0, text: a.slice(2, -2) }) : o.push({ bold: !1, text: a }));
      return o;
    }
    const n = I(() => {
      const s = [];
      for (const o of String(e.text || "").split(/\n{2,}/)) {
        const r = o.split(`
`).filter((l) => l.trim() !== "");
        if (!r.length) continue;
        let a = null;
        for (const l of r) {
          const d = /^\s*[-•]\s+(.*)$/.exec(l), c = /^\s*\d+[.)]\s+(.*)$/.exec(l);
          if (d || c) {
            const h = d ? "ul" : "ol";
            (!a || a.kind !== h) && (a = { kind: h, items: [] }, s.push(a)), a.items.push(t((d || c)[1]));
          } else
            (!a || a.kind !== "p") && (a = { kind: "p", lines: [] }, s.push(a)), a.lines.push(t(l));
        }
      }
      return s;
    });
    return (s, o) => (g(), b("div", {
      class: G(["ch-text", { "has-caret": i.caret }])
    }, [
      (g(!0), b(j, null, be(n.value, (r, a) => (g(), b(j, { key: a }, [
        r.kind === "p" ? (g(), b("p", D8e, [
          (g(!0), b(j, null, be(r.lines, (l, d) => (g(), b(j, { key: d }, [
            d ? (g(), b("br", O8e)) : z("", !0),
            (g(!0), b(j, null, be(l, (c, h) => (g(), b(j, { key: h }, [
              c.bold ? (g(), b("b", L8e, E(c.text), 1)) : (g(), b(j, { key: 1 }, [
                J(E(c.text), 1)
              ], 64))
            ], 64))), 128))
          ], 64))), 128))
        ])) : r.kind === "ul" ? (g(), b("ul", B8e, [
          (g(!0), b(j, null, be(r.items, (l, d) => (g(), b("li", { key: d }, [
            (g(!0), b(j, null, be(l, (c, h) => (g(), b(j, { key: h }, [
              c.bold ? (g(), b("b", F8e, E(c.text), 1)) : (g(), b(j, { key: 1 }, [
                J(E(c.text), 1)
              ], 64))
            ], 64))), 128))
          ]))), 128))
        ])) : (g(), b("ol", N8e, [
          (g(!0), b(j, null, be(r.items, (l, d) => (g(), b("li", { key: d }, [
            (g(!0), b(j, null, be(l, (c, h) => (g(), b(j, { key: h }, [
              c.bold ? (g(), b("b", U8e, E(c.text), 1)) : (g(), b(j, { key: 1 }, [
                J(E(c.text), 1)
              ], 64))
            ], 64))), 128))
          ]))), 128))
        ]))
      ], 64))), 128))
    ], 2));
  }
}), G8e = { class: "ch-plan-head" }, j8e = { class: "ch-plan-mark" }, H8e = { class: "ch-plan-titles" }, V8e = { class: "ch-plan-eyebrow" }, W8e = {
  key: 0,
  class: "dot"
}, q8e = { class: "ch-plan-title" }, K8e = { class: "ch-plan-est" }, Y8e = ["title"], X8e = {
  key: 0,
  class: "ch-plan-time"
}, J8e = {
  key: 0,
  class: "ch-plan-summary"
}, Z8e = { class: "ch-sessions" }, Q8e = { class: "ch-session-icon" }, eSe = { class: "ch-session-main" }, tSe = { class: "ch-session-name" }, nSe = { class: "n" }, iSe = {
  key: 0,
  class: "ch-tag",
  title: "A session already in the frame"
}, sSe = {
  key: 1,
  class: "ch-tag is-new",
  title: "The plan adds this session to the frame"
}, oSe = { class: "ch-session-meta" }, rSe = { class: "tk" }, aSe = {
  key: 0,
  class: "ch-session-settings"
}, lSe = {
  key: 1,
  class: "ch-session-why"
}, dSe = ["title", "onClick"], cSe = ["title"], uSe = {
  key: 1,
  class: "ch-actions",
  "data-testid": "plan-steps"
}, hSe = { class: "ch-action-icon" }, pSe = { class: "ch-action-main" }, fSe = { class: "ch-action-text" }, mSe = {
  key: 0,
  class: "ch-action-detail"
}, gSe = {
  key: 2,
  class: "ch-plan-foot"
}, bSe = { class: "ch-plan-breakdown" }, vSe = ["disabled"], ySe = ["disabled"], xSe = {
  key: 3,
  class: "ch-plan-foot is-running"
}, wSe = { class: "ch-plan-breakdown" }, kSe = { class: "ch-plan-breakdown" }, z4 = /* @__PURE__ */ Pe({
  __name: "PlanCard",
  props: {
    plan: {},
    chatId: {},
    preview: { type: Boolean }
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = os(t), s = I(() => SU(e.plan)), o = I(() => e.plan.status === "proposed"), r = I(() => e.plan.status === "running"), a = I(() => r.value && n.isRunningHere(e.plan.id)), l = I(() => {
      const M = e.plan, _ = M.status === "proposed" ? "Proposed plan" : M.status === "running" ? "Running plan" : "Plan", T = s.value;
      return [_, T.sessions === 1 ? "1 session" : T.sessions + " sessions", T.runs === 1 ? "1 run" : T.runs + " runs"];
    }), d = I(() => {
      const M = s.value;
      return (M.results === 1 ? "1 image" : M.results + " images") + (e.plan.secs ? " · about " + Ow(e.plan.secs) : "");
    });
    function c(M) {
      const _ = [];
      for (const T of M.runs) for (const k of T.images || []) _.push(k.url);
      return _;
    }
    function h(M) {
      return Nl[M.kitId] || "Image";
    }
    const f = /* @__PURE__ */ K({});
    function p(M) {
      f.value = { ...f.value, [M]: !f.value[M] };
    }
    function y(M) {
      return M === "done" ? "CircleCheck" : M === "failed" ? "CircleAlert" : M === "running" ? "Loader2" : "Circle";
    }
    function v() {
      e.preview || n.runPlan(e.chatId, e.plan.id);
    }
    function x() {
      n.cancelPlan(e.chatId, e.plan.id);
    }
    function w() {
      const M = n.chat(e.chatId), _ = M ? n.frameOf(M) : null;
      _ && n.showFrame(_, !0);
      const T = e.plan.sessions.map((k) => k.toolId || k.addedId).filter((k) => !!k && !!t.store.get(k));
      T.length > 1 && t.select(T);
    }
    const S = I(() => {
      const M = e.plan, _ = s.value;
      return M.status === "done" ? "Done: " + (M.results === 1 ? "1 result" : (M.results || 0) + " results") + (M.ranBy ? " · run by " + M.ranBy : "") : M.status === "cancelled" ? M.error || "Cancelled. Nothing was spent." : M.status === "failed" ? "Stopped: " + (M.error || "something went wrong") : M.status === "stopped" ? "Stopped: " + (M.error || "it didn't finish") + (M.results ? " (" + M.results + " of " + _.results + " results made it)" : "") : "";
    });
    return (M, _) => (g(), b("div", {
      class: G(["ch-plan", ["is-" + i.plan.status, { "is-preview": i.preview }]]),
      "data-testid": "plan-card"
    }, [
      u("div", G8e, [
        u("span", j8e, [
          C($, {
            name: "Route",
            size: 13
          })
        ]),
        u("span", H8e, [
          u("span", V8e, [
            (g(!0), b(j, null, be(l.value, (T, k) => (g(), b(j, { key: k }, [
              k ? (g(), b("span", W8e, "·")) : z("", !0),
              J(E(T), 1)
            ], 64))), 128))
          ]),
          u("span", q8e, E(i.plan.title), 1)
        ]),
        u("span", K8e, [
          u("span", {
            class: G(["ch-plan-cost", { "is-estimate": o.value }]),
            title: o.value ? "Estimated from each tool's price rules, before anything runs" : "Estimated cost",
            "data-testid": "plan-cost"
          }, [
            C($, {
              name: "Tokens",
              size: 11
            }),
            J(E(m(hc)(i.plan.tokens)), 1)
          ], 10, Y8e),
          i.plan.secs ? (g(), b("span", X8e, [
            C($, {
              name: "Clock",
              size: 9
            }),
            J("~" + E(m(Ow)(i.plan.secs)), 1)
          ])) : z("", !0)
        ])
      ]),
      i.plan.summary ? (g(), b("div", J8e, E(i.plan.summary), 1)) : z("", !0),
      u("div", Z8e, [
        (g(!0), b(j, null, be(i.plan.sessions, (T) => (g(), b("div", {
          key: T.key,
          class: "ch-session"
        }, [
          u("span", Q8e, [
            C($, {
              name: h(T),
              size: 13
            }, null, 8, ["name"])
          ]),
          u("span", eSe, [
            u("span", tSe, [
              u("span", nSe, E(T.name), 1),
              T.toolId ? (g(), b("span", iSe, "In frame")) : (g(), b("span", sSe, "New"))
            ]),
            u("span", oSe, [
              T.model !== T.name ? (g(), b(j, { key: 0 }, [
                J(E(T.model), 1),
                _[0] || (_[0] = u("span", { class: "sep" }, "·", -1))
              ], 64)) : z("", !0),
              J(E(T.runs.length === 1 ? "1 run" : T.runs.length + " runs"), 1),
              _[1] || (_[1] = u("span", { class: "sep" }, "·", -1)),
              J(E(T.n === 1 ? "1 result" : T.n + " results") + E(T.runs.length > 1 ? " each" : ""), 1),
              _[2] || (_[2] = u("span", { class: "sep" }, "·", -1)),
              u("span", rSe, [
                C($, {
                  name: "Tokens",
                  size: 9
                }),
                J(E(m(hc)(T.tokens)), 1)
              ])
            ]),
            T.settings ? (g(), b("span", aSe, E(T.settings), 1)) : z("", !0),
            T.why && o.value ? (g(), b("span", lSe, [
              C($, {
                name: "CornerDownRight",
                size: 10
              }),
              J(E(T.why), 1)
            ])) : z("", !0),
            u("button", {
              class: G(["ch-session-prompt", { "is-open": f.value[T.key] }]),
              title: f.value[T.key] ? "Show less" : "Show the whole prompt",
              onClick: (k) => p(T.key)
            }, "“" + E(T.prompt) + "”", 11, dSe),
            c(T).length ? (g(), b("span", {
              key: 2,
              class: "ch-session-inputs",
              title: c(T).length === 1 ? "The image this run takes" : "One image per run"
            }, [
              (g(!0), b(j, null, be(c(T).slice(0, 8), (k, P) => (g(), b("span", {
                key: P,
                class: "th",
                style: ce({ backgroundImage: 'url("' + m(Bt)(k) + '")' })
              }, null, 4))), 128))
            ], 8, cSe)) : z("", !0)
          ])
        ]))), 128))
      ]),
      i.plan.steps && i.plan.steps.length ? (g(), b("div", uSe, [
        (g(!0), b(j, null, be(i.plan.steps, (T) => (g(), b("div", {
          key: T.id,
          class: G(["ch-action", "is-" + T.status])
        }, [
          u("span", hSe, [
            C($, {
              name: y(T.status),
              size: 12,
              spin: T.status === "running"
            }, null, 8, ["name", "spin"])
          ]),
          u("span", pSe, [
            u("span", fSe, E(T.text), 1),
            T.detail ? (g(), b("span", mSe, E(T.detail), 1)) : z("", !0)
          ])
        ], 2))), 128))
      ])) : z("", !0),
      o.value ? (g(), b("div", gSe, [
        u("span", bSe, E(d.value), 1),
        u("button", {
          class: "ch-plan-cancel",
          disabled: i.preview,
          "data-testid": "plan-cancel",
          onClick: x
        }, "Cancel", 8, vSe),
        u("button", {
          class: "ch-plan-run",
          disabled: i.preview,
          "data-testid": "plan-run",
          onClick: v
        }, [
          C($, {
            name: "Play",
            size: 12
          }),
          _[3] || (_[3] = J("Run plan", -1)),
          _[4] || (_[4] = u("span", { class: "sep" }, "·", -1)),
          C($, {
            name: "Tokens",
            size: 11
          }),
          J(E(m(hc)(i.plan.tokens)), 1)
        ], 8, ySe)
      ])) : r.value ? (g(), b("div", xSe, [
        C($, {
          name: "Loader2",
          size: 12,
          spin: ""
        }),
        u("span", wSe, "Running" + E(i.plan.ranBy ? " · run by " + i.plan.ranBy : ""), 1),
        a.value ? (g(), b("button", {
          key: 0,
          class: "ch-plan-cancel",
          title: "Stop before the next step; runs already sent still finish",
          onClick: x
        }, "Stop")) : z("", !0)
      ])) : (g(), b("div", {
        key: 4,
        class: G(["ch-plan-foot", "is-" + i.plan.status])
      }, [
        C($, {
          name: i.plan.status === "done" ? "CircleCheck" : i.plan.status === "cancelled" ? "CircleX" : "CircleAlert",
          size: 12
        }, null, 8, ["name"]),
        u("span", kSe, E(S.value), 1),
        i.plan.status === "done" || i.plan.results && i.plan.status !== "cancelled" ? (g(), b("button", {
          key: 0,
          class: "ch-plan-show",
          onClick: w
        }, [
          C($, {
            name: "Focus",
            size: 12
          }),
          _[5] || (_[5] = J("Show on the board", -1))
        ])) : z("", !0)
      ], 2))
    ], 2));
  }
}), _Se = {
  class: "ch-picks",
  "data-testid": "chat-picks"
}, SSe = { class: "ch-pick-main" }, MSe = { class: "ch-pick-top" }, TSe = { class: "ch-pick-name" }, CSe = {
  key: 0,
  class: "ch-pick-price",
  title: "Tokens a result at its default settings"
}, ISe = { class: "ch-pick-why" }, ASe = {
  key: 0,
  class: "ch-pick-kit"
}, PSe = ["disabled", "title", "onClick"], $4 = /* @__PURE__ */ Pe({
  __name: "ToolPicks",
  props: {
    picks: {},
    chatId: {},
    preview: { type: Boolean }
  },
  setup(i) {
    const e = i, { board: t } = Ze(), n = os(t), s = I(() => {
      const r = new u8(t.catalog.value, !!t.user.isAdmin);
      return e.picks.map((a) => {
        const l = r.get(a.modelId), d = l ? r.price(l, { prompt: "x", n: 1 }, 1) : null, c = l ? r.kitFor(l, "generate") : null;
        return {
          ...a,
          on: !!l,
          avatar: l && l.model.avatar ? l.model.avatar : "",
          icon: c && Nl[c.id] || "Image",
          kit: c ? c.name : "",
          price: d == null ? "" : hc(d) + (l && l.model.tokensLabel.includes("+") ? "+" : "")
        };
      });
    });
    function o(r) {
      e.preview || n.addTool(e.chatId, r);
    }
    return (r, a) => (g(), b("div", _Se, [
      (g(!0), b(j, null, be(s.value, (l) => (g(), b("div", {
        key: l.modelId,
        class: G(["ch-pick", { "is-off": !l.on }])
      }, [
        u("span", {
          class: "ch-pick-pic",
          style: ce(l.avatar ? { backgroundImage: 'url("' + l.avatar + '")' } : void 0)
        }, [
          l.avatar ? z("", !0) : (g(), Ce($, {
            key: 0,
            name: l.icon,
            size: 14
          }, null, 8, ["name"]))
        ], 4),
        u("div", SSe, [
          u("div", MSe, [
            u("span", TSe, E(l.name), 1),
            l.price ? (g(), b("span", CSe, E(l.price), 1)) : z("", !0)
          ]),
          u("div", ISe, E(l.why), 1),
          l.kit ? (g(), b("div", ASe, E(l.kit), 1)) : z("", !0)
        ]),
        l.on ? (g(), b("button", {
          key: 0,
          class: "ch-pick-try",
          disabled: i.preview,
          title: "Add a " + l.name + " session to this frame, ready for a prompt",
          "data-testid": "chat-pick-try",
          onClick: (d) => o(l.modelId)
        }, [
          C($, {
            name: "Plus",
            size: 11
          }),
          a[0] || (a[0] = J("Try it", -1))
        ], 8, PSe)) : z("", !0)
      ], 2))), 128))
    ]));
  }
}), ESe = {
  class: "ch-ideas",
  "data-testid": "chat-ideas"
}, RSe = ["disabled", "title", "onClick"], zSe = { class: "ch-idea-n" }, $Se = { class: "ch-idea-main" }, DSe = { class: "ch-idea-title" }, OSe = { class: "ch-idea-pitch" }, LSe = {
  key: 0,
  class: "ch-idea-tool"
}, D4 = /* @__PURE__ */ Pe({
  __name: "IdeaCards",
  props: {
    ideas: {},
    preview: { type: Boolean }
  },
  emits: ["pick"],
  setup(i, { emit: e }) {
    const t = i, n = e;
    function s(o) {
      t.preview || n("pick", `Let's go with "` + o.title + '": ' + o.pitch + (o.tool ? " Use " + o.tool + "." : "") + " Make a plan for it.");
    }
    return (o, r) => (g(), b("div", ESe, [
      (g(!0), b(j, null, be(i.ideas, (a, l) => (g(), b("button", {
        key: a.title,
        class: "ch-idea",
        disabled: i.preview,
        title: "Plan “" + a.title + "”",
        onClick: (d) => s(a)
      }, [
        u("span", zSe, E(l + 1), 1),
        u("span", $Se, [
          u("span", DSe, E(a.title), 1),
          u("span", OSe, E(a.pitch), 1),
          a.tool ? (g(), b("span", LSe, [
            C($, {
              name: "Sparkles",
              size: 10
            }),
            J(E(a.tool), 1)
          ])) : z("", !0)
        ]),
        C($, {
          class: "ch-idea-go",
          name: "ChevronRight",
          size: 13
        })
      ], 8, RSe))), 128))
    ]));
  }
}), BSe = { class: "ch-head" }, FSe = { class: "ch-head-mark" }, NSe = { class: "ch-head-titles ch-switch" }, USe = ["title", "aria-expanded"], GSe = { class: "t" }, jSe = {
  key: 0,
  class: "ch-switch-menu",
  role: "menu"
}, HSe = ["onClick"], VSe = { class: "m" }, WSe = { class: "n" }, qSe = { class: "f" }, KSe = { class: "c" }, YSe = { class: "ch-head-sub" }, XSe = ["title"], JSe = {
  class: "ch-head-n",
  "data-testid": "chat-in-context"
}, ZSe = {
  class: "ch-head-n",
  "data-testid": "chat-in-context"
}, QSe = {
  key: 0,
  class: "ch-context",
  "data-testid": "chat-context"
}, eMe = ["title", "onClick"], tMe = {
  key: 0,
  class: "ch-ctxchip is-empty"
}, nMe = {
  key: 1,
  class: "ch-context is-picks",
  "data-testid": "chat-picks"
}, iMe = ["title", "onClick"], sMe = { class: "nm" }, oMe = ["aria-label", "onClick"], rMe = {
  key: 2,
  class: "ch-context is-none"
}, aMe = {
  key: 0,
  class: "ch-intro"
}, lMe = { class: "ch-intro-mark" }, dMe = { class: "ch-intro-title" }, cMe = {
  key: 0,
  class: "ch-intro-sub"
}, uMe = {
  key: 1,
  class: "ch-intro-sub"
}, hMe = {
  key: 2,
  class: "ch-chips is-start"
}, pMe = ["onClick"], fMe = { class: "ch-msg-meta" }, mMe = { class: "ch-bubble" }, gMe = {
  key: 1,
  class: "ch-msg is-agent"
}, bMe = { class: "ch-ai-mark" }, vMe = { class: "ch-ai-body" }, yMe = ["title"], xMe = {
  key: 5,
  class: "ch-chips",
  "data-testid": "chat-chips"
}, wMe = ["onClick"], kMe = {
  key: 1,
  class: "ch-msg is-agent is-live",
  "data-testid": "chat-live"
}, _Me = { class: "ch-ai-mark is-busy" }, SMe = { class: "ch-ai-body" }, MMe = {
  key: 1,
  class: "ch-status"
}, TMe = {
  key: 2,
  class: "ch-plan is-skeleton"
}, CMe = { class: "ch-composer" }, IMe = ["placeholder", "disabled", "readonly", "maxlength"], AMe = { class: "ch-comp-foot" }, PMe = {
  key: 0,
  class: "ch-model"
}, EMe = ["aria-expanded", "title"], RMe = { class: "t" }, zMe = {
  key: 0,
  class: "ch-model-menu",
  role: "menu"
}, $Me = ["aria-checked", "data-testid", "onClick"], DMe = { class: "m" }, OMe = { class: "n" }, LMe = { class: "f" }, BMe = ["aria-checked"], FMe = {
  key: 1,
  class: "ch-model-note"
}, NMe = ["title"], UMe = ["disabled"], GMe = /* @__PURE__ */ Pe({
  __name: "ChatPanel",
  setup(i) {
    const { board: e } = Ze(), t = os(e), n = t.open, s = I(() => n.value ? t.frameOf(n.value) : null), o = I(() => n.value ? t.contextOf(n.value) : null), r = I(() => o.value ? h8(o.value) : 0), a = I(() => {
      if (e.docRev.value, !n.value || s.value) return [];
      const ne = new Set(n.value.contextIds || []);
      return e.ui.selection.filter((oe) => {
        var ye;
        return !ne.has(oe) && ((ye = e.store.get(oe)) == null ? void 0 : ye.type) === "image";
      });
    }), l = I(() => (e.docRev.value, !n.value || s.value ? [] : t.picksOf(n.value).map((ne) => ({
      id: ne.id,
      label: ne.type === "image" ? ne.label && ne.label !== "placed_image" ? ne.label : "Picture" : ne.type === "tool" ? ne.name : "Note",
      icon: ne.type === "image" ? "Image" : ne.type === "tool" ? "Box" : "StickyNote",
      thumb: ne.type === "image" ? ne.src : null
    })))), d = I(() => n.value ? n.value.messages || [] : []), c = I(() => n.value && t.live[n.value.id] || null), h = dr(), f = I(() => {
      const ne = o.value;
      if (!ne) return [];
      const oe = [];
      return ne.images.length && oe.push({
        key: "images",
        icon: "Image",
        label: ne.images.length === 1 ? "1 image" : ne.images.length + " images",
        ids: ne.images.map((ye) => ye.id),
        title: ne.images.map((ye, Oe) => "Image " + (Oe + 1) + (ye.model ? ": " + ye.model : "") + (ye.prompt ? ", “" + ye.prompt.slice(0, 60) + (ye.prompt.length > 60 ? "…" : "") + "”" : "")).join(`
`)
      }), ne.sessions.length && oe.push({
        key: "sessions",
        icon: Nl[ne.sessions[0].kitId] || "Image",
        label: ne.sessions.length === 1 ? "1 session" : ne.sessions.length + " sessions",
        ids: ne.sessions.map((ye) => ye.id),
        title: ne.sessions.map((ye) => ye.name + " (" + ye.model + ")").join(`
`)
      }), ne.notes.length && oe.push({
        key: "notes",
        icon: "StickyNote",
        label: ne.notes.length === 1 ? "1 note" : ne.notes.length + " notes",
        ids: ne.notes.map((ye) => ye.id),
        title: `Notes are standing instructions:
` + ne.notes.map((ye) => "“" + ye.text.slice(0, 80) + "”").join(`
`)
      }), oe;
    });
    function p(ne) {
      const oe = ne.filter((ye) => !!e.store.get(ye));
      oe.length && e.select(oe);
    }
    const y = I(() => {
      const ne = o.value;
      if (!ne) return [];
      const oe = [];
      return ne.images.length && oe.push({ label: "Make these night scenes", send: "Please change " + (ne.images.length === 1 ? "this image" : "all " + ne.images.length + " of these images") + " to a nighttime scene with ChatGPT Image 2.5. Use recommended settings." }), ne.sessions.length && oe.push({ label: "Run a new prompt through these", send: "Now try: a glass pavilion in a pine forest at dawn" }), oe.push({ label: "Compare 3 image tools", send: "Get me the best image tools to compare a single prompt across 3 different image tools. Which are the best?" }), ne.images.length || oe.push({ label: "Make 4 concept images", send: "Make 4 concept images of a timber pavilion on a lake at dusk" }), oe.push({ label: "Prompting tips", send: "How should I prompt Ideogram for signage text?" }), oe.slice(0, 4);
    }), v = /* @__PURE__ */ new Map(), x = /* @__PURE__ */ K(""), w = /* @__PURE__ */ K(null), S = /* @__PURE__ */ K(null), M = Zy({
      board: e,
      field: "chat",
      sessionId: () => n.value ? n.value.id : null,
      value: () => x.value,
      write: (ne) => {
        x.value = ne, nt(Z);
      }
    }), _ = I(() => M.ghost.value || bU(o.value)), T = I(() => t.brain.value), k = I(() => t.agentStatus.value), P = I(() => k.value && k.value.ready && k.value.models || []), A = I(() => !t.guided && (t.canSimulate || P.value.length > 0)), R = t.showCosts, D = /* @__PURE__ */ K(!1), O = I(() => {
      const ne = P.value.find((oe) => oe.id === T.value);
      return ne ? ne.label : T.value === Ci ? "Simulated" : k.value ? "Unavailable" : "Connecting…";
    }), F = I(() => {
      const ne = k.value;
      return ne ? ne.ready ? "" : ne.reason || "No model is set up here." : t.asksAgent ? "Checking which models can answer…" : "";
    });
    function te(ne) {
      D.value = !1, t.setBrain(ne);
    }
    function ee(ne) {
      return ne >= 1e3 ? (Math.round(ne / 100) / 10).toLocaleString("en-US") + "K" : String(ne);
    }
    function me(ne) {
      return ne == null ? "" : "≈" + (ne < 10 ? Math.round(ne * 10) / 10 : Math.round(ne)).toLocaleString("en-US");
    }
    function L(ne) {
      return "$" + ne.input + " / $" + ne.output + " per 1M";
    }
    const N = I(() => n.value && n.value.spend || null), X = I(() => {
      const ne = N.value;
      return !R || !ne || !ne.turns ? "" : "This chat " + lg(ne.usd) + " at the API · " + me(ne.credits) + " tokens · " + ne.turns + (ne.turns === 1 ? " answer" : " answers");
    }), B = I(() => {
      if (!R) return;
      const ne = N.value;
      if (!ne) return xU;
      const oe = Object.entries(ne.byModel).map(([Ve, Ue]) => Ve + ": " + lg(Ue.usd) + " over " + Ue.turns + (Ue.turns === 1 ? " answer" : " answers")), ye = n.value, Oe = ye ? t.usage[ye.id] : null;
      return Oe && oe.push("Last answer: " + Math.round(Oe.ms / 100) / 10 + "s, " + ee(Oe.input) + " tokens in (" + ee(Oe.cached) + " cached), " + ee(Oe.output) + " out"), oe.push("Tokens are RunDiffusion tokens at $0.0006 each: an estimate, nothing is charged."), oe.join(`
`);
    }), se = I(() => X.value || "nothing runs until Run plan"), V = I(() => !!x.value.trim() && !!s.value && !c.value);
    Ae(() => n.value ? n.value.id : null, (ne, oe) => {
      oe && v.set(oe, x.value), x.value = ne && v.get(ne) || "", nt(() => {
        Z(), U(!0), w.value && w.value.focus({ preventScroll: !0 });
      });
    }, { immediate: !0 });
    function Z() {
      const ne = w.value;
      ne && (ne.style.height = "auto", ne.style.height = Math.min(160, Math.max(44, ne.scrollHeight)) + "px");
    }
    function Y(ne) {
      const oe = n.value, ye = (ne != null ? ne : x.value).trim();
      !oe || !ye || c.value || !s.value || (ne == null && (x.value = "", nt(Z)), t.send(oe.id, ye), nt(() => U(!0)));
    }
    function H(ne) {
      Y(ne.send || ne.label);
    }
    function re(ne) {
      ne.key === "Enter" && !ne.shiftKey && !ne.isComposing && (ne.preventDefault(), Y());
    }
    const le = I(() => {
      for (let ne = d.value.length - 1; ne >= 0; ne--) if (d.value[ne].role === "agent") return d.value[ne].id;
      return null;
    }), he = I(() => d.value.length > 0 && d.value[d.value.length - 1].role === "agent");
    function Re(ne) {
      return ne.role === "user" && ne.authorId === e.user.uid;
    }
    function Ne(ne) {
      return h.value, Jn(ne);
    }
    let Me = !0;
    function ue() {
      const ne = S.value;
      ne && (Me = ne.scrollTop + ne.clientHeight > ne.scrollHeight - 60);
    }
    function U(ne = !1) {
      const oe = S.value;
      !oe || !ne && !Me || (oe.scrollTop = oe.scrollHeight);
    }
    Ae(() => [d.value.length, c.value ? c.value.text.length : -1, c.value && c.value.plan ? 1 : 0, c.value ? c.value.status : ""], () => nt(() => U())), Ae(() => JSON.stringify(d.value.map((ne) => ne.plan ? (ne.plan.steps || []).length + ne.plan.status : "")), () => nt(() => U()));
    function q() {
      t.close();
    }
    const ie = /* @__PURE__ */ K(!1), de = I(() => (e.docRev.value, t.allChats().map((ne) => {
      const oe = t.frameOf(ne);
      return { id: ne.id, name: ne.name, frame: oe ? oe.title : "Not in a frame", n: z8(ne) };
    })));
    function pe(ne) {
      ie.value = !1, e.ui.selection = [ne], e.ui.chatOpen = ne;
    }
    function Te(ne) {
      const oe = ne.target;
      ie.value && oe && !oe.closest(".ch-switch") && (ie.value = !1), D.value && oe && !oe.closest(".ch-model") && (D.value = !1);
    }
    window.addEventListener("pointerdown", Te, !0), We(() => window.removeEventListener("pointerdown", Te, !0));
    function Be() {
      s.value && t.showFrame(s.value, !0);
    }
    function ge(ne) {
      if (ne.key === "Escape") {
        ne.stopPropagation();
        const oe = document.activeElement;
        oe && oe.tagName === "TEXTAREA" ? oe.blur() : q();
      }
    }
    return ot(() => nt(() => U(!0))), We(() => {
      n.value && v.set(n.value.id, x.value);
    }), (ne, oe) => m(n) ? (g(), b("aside", {
      key: 0,
      class: "ch-panel",
      "data-testid": "chat-panel",
      onPointerdown: oe[8] || (oe[8] = Se(() => {
      }, ["stop"])),
      onKeydown: ge
    }, [
      u("header", BSe, [
        u("span", FSe, [
          C($, {
            name: "MessagesSquare",
            size: 15
          })
        ]),
        u("div", NSe, [
          u("button", {
            class: G(["ch-head-name", { "has-more": de.value.length > 1 }]),
            title: de.value.length > 1 ? "Switch to another chat on this board" : m(n).name,
            "aria-expanded": ie.value,
            "data-testid": "chat-switch",
            onClick: oe[0] || (oe[0] = (ye) => de.value.length > 1 && (ie.value = !ie.value))
          }, [
            u("span", GSe, E(m(n).name), 1),
            de.value.length > 1 ? (g(), Ce($, {
              key: 0,
              name: "ChevronDown",
              size: 12
            })) : z("", !0)
          ], 10, USe),
          ie.value ? (g(), b("div", jSe, [
            oe[9] || (oe[9] = u("div", { class: "ch-switch-eyebrow" }, "Chats on this board", -1)),
            (g(!0), b(j, null, be(de.value, (ye) => (g(), b("button", {
              key: ye.id,
              class: G(["ch-switch-row", { on: ye.id === m(n).id }]),
              role: "menuitem",
              onClick: (Oe) => pe(ye.id)
            }, [
              C($, {
                name: "MessagesSquare",
                size: 13
              }),
              u("span", VSe, [
                u("span", WSe, E(ye.name), 1),
                u("span", qSe, E(ye.frame), 1)
              ]),
              u("span", KSe, E(ye.n), 1)
            ], 10, HSe))), 128))
          ])) : z("", !0),
          u("div", YSe, [
            s.value ? (g(), b(j, { key: 0 }, [
              u("span", {
                class: "ch-head-frame",
                title: s.value.title
              }, "in " + E(s.value.title), 9, XSe),
              oe[10] || (oe[10] = u("span", { class: "dot" }, "·", -1)),
              u("span", JSe, E(r.value) + " in context", 1)
            ], 64)) : (g(), b(j, { key: 1 }, [
              oe[12] || (oe[12] = J(" Not in a frame", -1)),
              l.value.length ? (g(), b(j, { key: 0 }, [
                oe[11] || (oe[11] = u("span", { class: "dot" }, "·", -1)),
                u("span", ZSe, E(r.value) + " picked", 1)
              ], 64)) : z("", !0)
            ], 64))
          ])
        ]),
        u("button", {
          class: "ch-iconbtn",
          title: "Show the frame",
          "aria-label": "Show the frame",
          onClick: Be
        }, [
          C($, {
            name: "Focus",
            size: 14
          })
        ]),
        u("button", {
          class: "ch-iconbtn",
          title: "Close (Esc)",
          "aria-label": "Close the chat",
          "data-testid": "chat-close",
          onClick: q
        }, [
          C($, {
            name: "X",
            size: 15
          })
        ])
      ]),
      s.value ? (g(), b("div", QSe, [
        (g(!0), b(j, null, be(f.value, (ye) => (g(), b("button", {
          key: ye.key,
          class: "ch-ctxchip",
          title: ye.title + `

Click to select them on the board.`,
          onClick: (Oe) => p(ye.ids)
        }, [
          C($, {
            name: ye.icon,
            size: 11
          }, null, 8, ["name"]),
          J(E(ye.label), 1)
        ], 8, eMe))), 128)),
        f.value.length ? z("", !0) : (g(), b("span", tMe, [
          C($, {
            name: "Frame",
            size: 11
          }),
          oe[13] || (oe[13] = J("Empty frame", -1))
        ]))
      ])) : l.value.length ? (g(), b("div", nMe, [
        (g(!0), b(j, null, be(l.value, (ye) => (g(), b("span", {
          key: ye.id,
          class: "ch-ctxchip is-pick",
          title: ye.label + `

Click to select it on the board.`,
          onClick: (Oe) => p([ye.id])
        }, [
          ye.thumb ? (g(), b("span", {
            key: 0,
            class: "th",
            style: ce({ backgroundImage: 'url("' + ye.thumb + '")' })
          }, null, 4)) : (g(), Ce($, {
            key: 1,
            name: ye.icon,
            size: 11
          }, null, 8, ["name"])),
          u("span", sMe, E(ye.label), 1),
          u("button", {
            class: "x",
            title: "Take it out",
            "aria-label": "Take " + ye.label + " out",
            "data-testid": "chat-pick-remove",
            onClick: Se((Oe) => m(t).togglePick(m(n).id, ye.id), ["stop"])
          }, [
            C($, {
              name: "X",
              size: 10
            })
          ], 8, oMe)
        ], 8, iMe))), 128)),
        a.value.length ? (g(), b("button", {
          key: 0,
          class: "ch-ctxchip is-add",
          "data-testid": "chat-add-selected",
          onClick: oe[1] || (oe[1] = (ye) => m(t).addPicks(m(n).id, a.value))
        }, [
          C($, {
            name: "Plus",
            size: 11
          }),
          J("Add the " + E(a.value.length === 1 ? "selected picture" : a.value.length + " selected pictures"), 1)
        ])) : z("", !0),
        oe[14] || (oe[14] = u("span", { class: "ch-picks-hint" }, "Shift-click more on the board. Its plan runs in a frame it makes round them.", -1))
      ])) : (g(), b("div", rMe, [
        oe[15] || (oe[15] = J(" Not in a frame. Shift-click pictures on the board to give it something to work with, or move it into a frame. ", -1)),
        a.value.length ? (g(), b("button", {
          key: 0,
          class: "ch-ctxchip is-add",
          "data-testid": "chat-add-selected",
          onClick: oe[2] || (oe[2] = (ye) => m(t).addPicks(m(n).id, a.value))
        }, [
          C($, {
            name: "Plus",
            size: 11
          }),
          J("Add the " + E(a.value.length === 1 ? "selected picture" : a.value.length + " selected pictures"), 1)
        ])) : z("", !0)
      ])),
      u("div", {
        ref_key: "scroller",
        ref: S,
        class: "ch-scroll",
        onScrollPassive: ue
      }, [
        !d.value.length && !c.value ? (g(), b("div", aMe, [
          u("span", lMe, [
            C($, {
              name: "Sparkles",
              size: 16
            })
          ]),
          u("div", dMe, E(s.value ? r.value ? "Ask about “" + s.value.title + "”" : "What should we build in “" + s.value.title + "”?" : l.value.length ? "Ask about what you picked" : "Pick what it works with"), 1),
          s.value ? (g(), b("div", cMe, " Everything in this frame is my context. I can set up tool sessions here and run them for you, always with a priced plan you approve first. ")) : (g(), b("div", uMe, " Shift-click pictures on the board, and they're my context. When I run a plan, I put them in a frame with this chat first. Or move this chat into a frame. ")),
          (s.value || l.value.length) && !m(t).guided ? (g(), b("div", hMe, [
            (g(!0), b(j, null, be(y.value, (ye) => (g(), b("button", {
              key: ye.label,
              class: "ch-chip",
              onClick: (Oe) => H(ye)
            }, E(ye.label), 9, pMe))), 128))
          ])) : z("", !0)
        ])) : z("", !0),
        (g(!0), b(j, null, be(d.value, (ye) => (g(), b(j, {
          key: ye.id
        }, [
          ye.role === "user" ? (g(), b("div", {
            key: 0,
            class: G(["ch-msg is-user", { "is-theirs": !Re(ye) }])
          }, [
            u("div", fMe, [
              J(E(Re(ye) ? "You" : ye.author), 1),
              oe[16] || (oe[16] = u("span", { class: "dot" }, "·", -1)),
              J(E(Ne(ye.at)), 1)
            ]),
            u("div", mMe, [
              C(Bb, {
                text: ye.text
              }, null, 8, ["text"])
            ])
          ], 2)) : (g(), b("div", gMe, [
            u("span", bMe, [
              C($, {
                name: "Sparkles",
                size: 12
              })
            ]),
            u("div", vMe, [
              ye.text ? (g(), Ce(Bb, {
                key: 0,
                class: "ch-ai-text",
                text: ye.text
              }, null, 8, ["text"])) : z("", !0),
              ye.plan ? (g(), Ce(z4, {
                key: 1,
                plan: ye.plan,
                "chat-id": m(n).id
              }, null, 8, ["plan", "chat-id"])) : z("", !0),
              ye.picks && ye.picks.length ? (g(), Ce($4, {
                key: 2,
                picks: ye.picks,
                "chat-id": m(n).id
              }, null, 8, ["picks", "chat-id"])) : z("", !0),
              ye.ideas && ye.ideas.length ? (g(), Ce(D4, {
                key: 3,
                ideas: ye.ideas,
                preview: !!c.value,
                onPick: Y
              }, null, 8, ["ideas", "preview"])) : z("", !0),
              m(R) && ye.usage ? (g(), b("div", {
                key: 4,
                class: "ch-msg-cost",
                title: ee(ye.usage.input) + " tokens in (" + ee(ye.usage.cached) + " cached), " + ee(ye.usage.output) + " out"
              }, [
                J(E(ye.usage.model), 1),
                oe[18] || (oe[18] = u("span", { class: "dot" }, "·", -1)),
                J(E(ye.usage.usd == null ? "price unknown" : m(lg)(ye.usage.usd)), 1),
                ye.usage.credits != null ? (g(), b(j, { key: 0 }, [
                  oe[17] || (oe[17] = u("span", { class: "dot" }, "·", -1)),
                  C($, {
                    name: "Tokens",
                    size: 10
                  }),
                  J(E(me(ye.usage.credits)), 1)
                ], 64)) : z("", !0),
                oe[19] || (oe[19] = u("span", { class: "dot" }, "·", -1)),
                J(E(Math.round(ye.usage.ms / 100) / 10) + "s ", 1)
              ], 8, yMe)) : z("", !0),
              ye.chips && ye.chips.length && ye.id === le.value && he.value && !c.value && (!ye.plan || ye.plan.status === "proposed") ? (g(), b("div", xMe, [
                (g(!0), b(j, null, be(ye.chips, (Oe) => (g(), b("button", {
                  key: Oe.label,
                  class: "ch-chip",
                  onClick: (Ve) => H(Oe)
                }, E(Oe.label), 9, wMe))), 128))
              ])) : z("", !0)
            ])
          ]))
        ], 64))), 128)),
        c.value ? (g(), b("div", kMe, [
          u("span", _Me, [
            C($, {
              name: "Sparkles",
              size: 12
            })
          ]),
          u("div", SMe, [
            c.value.text ? (g(), Ce(Bb, {
              key: 0,
              class: "ch-ai-text",
              text: m($8)(c.value.text),
              caret: ""
            }, null, 8, ["text"])) : z("", !0),
            c.value.status ? (g(), b("div", MMe, E(c.value.status), 1)) : z("", !0),
            c.value.status === "Pricing the plan…" ? (g(), b("div", TMe, [...oe[20] || (oe[20] = [
              u("div", { class: "sk sk-a" }, null, -1),
              u("div", { class: "sk sk-b" }, null, -1),
              u("div", { class: "sk sk-c" }, null, -1)
            ])])) : z("", !0),
            c.value.plan ? (g(), Ce(z4, {
              key: 3,
              plan: c.value.plan,
              "chat-id": m(n).id,
              preview: ""
            }, null, 8, ["plan", "chat-id"])) : z("", !0),
            c.value.picks.length ? (g(), Ce($4, {
              key: 4,
              picks: c.value.picks,
              "chat-id": m(n).id,
              preview: ""
            }, null, 8, ["picks", "chat-id"])) : z("", !0),
            c.value.ideas.length ? (g(), Ce(D4, {
              key: 5,
              ideas: c.value.ideas,
              preview: ""
            }, null, 8, ["ideas"])) : z("", !0)
          ])
        ])) : z("", !0)
      ], 544),
      u("footer", CMe, [
        u("div", {
          class: G(["ch-comp-box", { "is-off": !s.value }])
        }, [
          kt(u("textarea", {
            ref_key: "inputEl",
            ref: w,
            "onUpdate:modelValue": oe[3] || (oe[3] = (ye) => x.value = ye),
            class: G(["ch-comp-input", { "is-tour-ghost": !!m(M).ghost.value, "is-typing": m(M).typing.value }]),
            placeholder: _.value,
            disabled: !s.value,
            readonly: m(M).held.value || m(M).typing.value,
            maxlength: m(zv),
            rows: "1",
            spellcheck: "true",
            "data-testid": "chat-input",
            onKeydown: re,
            onInput: Z
          }, null, 42, IMe), [
            [Zt, x.value]
          ]),
          m(M).ghost.value ? (g(), b("button", {
            key: 0,
            type: "button",
            tabindex: "-1",
            class: "up-cue is-tour ch-tour-cue",
            "data-testid": "chat-ghost-cue",
            onClick: oe[4] || (oe[4] = (ye) => m(e).tour && m(e).tour.press && m(e).tour.press("chat"))
          }, [...oe[21] || (oe[21] = [
            u("kbd", null, "Tab", -1),
            J(" to write it in", -1)
          ])])) : z("", !0),
          u("div", AMe, [
            A.value ? (g(), b("div", PMe, [
              u("button", {
                class: G(["ch-model-btn", { "is-sim": T.value === m(Ci) }]),
                "aria-expanded": D.value,
                title: F.value || "Who answers",
                "data-testid": "chat-model",
                onClick: oe[5] || (oe[5] = (ye) => D.value = !D.value)
              }, [
                C($, {
                  name: T.value === m(Ci) ? "Route" : "Sparkles",
                  size: 11
                }, null, 8, ["name"]),
                u("span", RMe, E(O.value), 1),
                C($, {
                  name: "ChevronUp",
                  size: 11
                })
              ], 10, EMe),
              D.value ? (g(), b("div", zMe, [
                oe[23] || (oe[23] = u("div", { class: "ch-switch-eyebrow" }, "Who answers", -1)),
                (g(!0), b(j, null, be(P.value, (ye) => (g(), b("button", {
                  key: ye.id,
                  class: G(["ch-model-row", { on: ye.id === T.value }]),
                  role: "menuitemradio",
                  "aria-checked": ye.id === T.value,
                  "data-testid": "chat-model-" + ye.id,
                  onClick: (Oe) => te(ye.id)
                }, [
                  u("span", DMe, [
                    u("span", OMe, E(ye.label), 1),
                    u("span", LMe, [
                      J(E(ye.route) + " · " + E(ye.effort) + " reasoning", 1),
                      m(R) && ye.price ? (g(), b(j, { key: 0 }, [
                        J(" · " + E(L(ye.price)), 1)
                      ], 64)) : z("", !0)
                    ])
                  ]),
                  ye.id === T.value ? (g(), Ce($, {
                    key: 0,
                    name: "Check",
                    size: 12
                  })) : z("", !0)
                ], 10, $Me))), 128)),
                m(t).canSimulate ? (g(), b("button", {
                  key: 0,
                  class: G(["ch-model-row", { on: T.value === m(Ci) }]),
                  role: "menuitemradio",
                  "aria-checked": T.value === m(Ci),
                  "data-testid": "chat-model-simulated",
                  onClick: oe[6] || (oe[6] = (ye) => te(m(Ci)))
                }, [
                  oe[22] || (oe[22] = u("span", { class: "m" }, [
                    u("span", { class: "n" }, "Simulated"),
                    u("span", { class: "f" }, "Scripted answers, no model")
                  ], -1)),
                  T.value === m(Ci) ? (g(), Ce($, {
                    key: 0,
                    name: "Check",
                    size: 12
                  })) : z("", !0)
                ], 10, BMe)) : z("", !0),
                F.value ? (g(), b("div", FMe, E(F.value), 1)) : z("", !0)
              ])) : z("", !0)
            ])) : z("", !0),
            u("span", {
              class: "ch-comp-hint",
              title: B.value,
              "data-testid": "chat-spend"
            }, E(se.value), 9, NMe),
            u("button", {
              class: "ch-send",
              disabled: !V.value,
              title: "Send (Enter)",
              "aria-label": "Send",
              "data-testid": "chat-send",
              onClick: oe[7] || (oe[7] = (ye) => Y())
            }, [
              C($, {
                name: "ArrowUp",
                size: 15
              })
            ], 8, UMe)
          ])
        ], 2)
      ])
    ], 32)) : z("", !0);
  }
}), jMe = 4, Lr = 0.01, HMe = 24, Jt = (i, e) => e === "x" ? i.x : i.y, Ut = (i, e) => e === "x" ? i.x + i.w : i.y + i.h, fx = (i) => i === "x" ? "y" : "x";
function DA(i, e, t) {
  const n = fx(t);
  return Jt(i, n) < Ut(e, n) && Jt(e, n) < Ut(i, n);
}
function O4(i, e, t) {
  const n = L4(i, e, "x", t), s = L4(i, e, "y", t);
  return { dx: n === null ? 0 : n, dy: s === null ? 0 : s, x: n !== null, y: s !== null };
}
function L4(i, e, t, n) {
  let s = null;
  const o = (d) => {
    Math.abs(d) <= n && (s === null || Math.abs(d) < Math.abs(s)) && (s = d);
  }, r = Jt(i, t), a = Ut(i, t), l = (r + a) / 2;
  for (const d of e) {
    const c = Jt(d, t), h = Ut(d, t);
    o(c - r), o(h - r), o(c - a), o(h - a), o((c + h) / 2 - l);
  }
  for (const d of VMe(i, e, t)) o(d);
  return s;
}
function OA(i, e, t, n) {
  const s = [];
  let o = null, r = null;
  const a = Jt(i, t), l = Ut(i, t);
  for (const d of e)
    DA(d, i, t) && (s.push(d), Ut(d, t) <= a + n ? (!o || Ut(d, t) > Ut(o, t)) && (o = d) : Jt(d, t) >= l - n && (!r || Jt(d, t) < Jt(r, t)) && (r = d));
  return { row: s, before: o, after: r };
}
function LA(i, e) {
  if (i.length < 2) return [];
  const t = i.slice().sort((s, o) => Ut(s, e) - Ut(o, e)), n = [];
  for (const s of i) {
    const o = Jt(s, e);
    let r = 0, a = t.length;
    for (; r < a; ) {
      const c = r + a >> 1;
      Ut(t[c], e) <= o ? r = c + 1 : a = c;
    }
    if (r === 0) continue;
    const l = t[r - 1], d = o - Ut(l, e);
    d > 0 && DA(l, s, e) && n.push({ p: l, q: s, size: d });
  }
  return n;
}
function VMe(i, e, t) {
  const { row: n, before: s, after: o } = OA(i, e, t, 0);
  if (!s && !o) return [];
  const r = Jt(i, t), a = Ut(i, t), l = [];
  s && o && Jt(o, t) - Ut(s, t) >= a - r && l.push((Ut(s, t) + Jt(o, t)) / 2 - (r + a) / 2);
  for (const d of LA(n, t))
    s && l.push(Ut(s, t) + d.size - r), o && l.push(Jt(o, t) - d.size - a);
  return l;
}
function B4(i, e) {
  return {
    lines: Bf(i, e, "x", !0).concat(Bf(i, e, "y", !0)),
    gaps: F4(i, e, "x").concat(F4(i, e, "y")).slice(0, HMe)
  };
}
function Bf(i, e, t, n) {
  const s = fx(t), o = Jt(i, t), r = Ut(i, t), a = (o + r) / 2, l = [o, a, r], d = [null, null, null], c = (p, y) => Math.abs(p - y) <= Lr, h = (p, y) => {
    const v = d[p] || [Jt(i, s), Ut(i, s)];
    v[0] = Math.min(v[0], Jt(y, s)), v[1] = Math.max(v[1], Ut(y, s)), d[p] = v;
  };
  for (const p of e) {
    const y = Jt(p, t), v = Ut(p, t);
    let x = !1;
    n && (c(o, y) || c(o, v)) && (h(0, p), x = !0), (c(r, y) || c(r, v)) && (h(2, p), x = !0), n && !x && c(a, (y + v) / 2) && h(1, p);
  }
  const f = [];
  return d.forEach((p, y) => {
    if (!p) return;
    const v = f.find((x) => c(x.at, l[y]));
    v ? (v.from = Math.min(v.from, p[0]), v.to = Math.max(v.to, p[1])) : f.push({ axis: t, at: l[y], from: p[0], to: p[1] });
  }), f;
}
function F4(i, e, t) {
  const { row: n, before: s, after: o } = OA(i, e, t, Lr);
  if (!s && !o) return [];
  const r = s ? Jt(i, t) - Ut(s, t) : 0, a = o ? Jt(o, t) - Ut(i, t) : 0, l = (p, y) => Math.abs(p - y) <= Lr, d = [], c = (p, y) => d.push({ axis: t, from: Ut(p, t), to: Jt(y, t), at: WMe(p, y, t) });
  let h = r > Lr && a > Lr && l(r, a), f = h;
  for (const p of LA(n, t))
    r > Lr && l(p.size, r) ? (h = !0, c(p.p, p.q)) : a > Lr && l(p.size, a) && (f = !0, c(p.p, p.q));
  return h && s && c(s, i), f && o && c(i, o), d;
}
function WMe(i, e, t) {
  const n = fx(t), s = Math.max(Jt(i, n), Jt(e, n)), o = Math.min(Ut(i, n), Ut(e, n));
  return s <= o ? (s + o) / 2 : (Jt(i, n) + Ut(i, n) + Jt(e, n) + Ut(e, n)) / 4;
}
function qMe(i, e, t) {
  const n = N4(i.x + i.w, e, "x", t), s = N4(i.y + i.h, e, "y", t);
  return { dx: n === null ? 0 : n, dy: s === null ? 0 : s, x: n !== null, y: s !== null };
}
function N4(i, e, t, n) {
  let s = null;
  const o = (r) => {
    Math.abs(r) <= n && (s === null || Math.abs(r) < Math.abs(s)) && (s = r);
  };
  for (const r of e)
    o(Jt(r, t) - i), o(Ut(r, t) - i);
  return s;
}
function KMe(i, e) {
  return { lines: Bf(i, e, "x", !1).concat(Bf(i, e, "y", !1)), gaps: [] };
}
var YMe = Object.defineProperty, XMe = (i, e, t) => e in i ? YMe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, ni = (i, e, t) => XMe(i, typeof e != "symbol" ? e + "" : e, t);
const Uh = 4;
function H0(i) {
  const e = i || document.activeElement;
  if (!e) return !1;
  const t = e.tagName;
  return t === "TEXTAREA" || t === "INPUT" || t === "SELECT" || !!e.isContentEditable;
}
function Gh() {
  const i = document.activeElement;
  i && i.blur && H0(i) && i.blur();
}
function yo(i) {
  return Math.round(i * 1e3) / 1e3;
}
function U4(i, e, t) {
  return { x: i.x + e, y: i.y + t, w: i.w, h: i.h };
}
function G4(i) {
  return i.x && (!i.y || Math.abs(i.dx) <= Math.abs(i.dy)) ? "x" : i.y ? "y" : null;
}
class Fb {
  constructor(e, t, n, s) {
    ni(this, "b", e), ni(this, "exclude", t), ni(this, "free"), ni(this, "cam", null), ni(this, "rects", []), ni(this, "onKey"), this.free = kn(n), this.onKey = (o) => {
      kn(o) !== this.free && (this.free = !this.free, s());
    }, window.addEventListener("keydown", this.onKey), window.addEventListener("keyup", this.onKey);
  }
  /** The command key, as a pointer event has it. */
  pointer(e) {
    this.free = kn(e);
  }
  /** How near counts, in world units at this zoom. */
  get tol() {
    return jMe / this.b.cam.value.zoom;
  }
  /** What is in view, less what moves; read again whenever the camera moves. */
  targets() {
    const e = this.b.cam.value;
    if (e !== this.cam) {
      this.cam = e, this.rects = [];
      for (const t of this.b.store.query(fl(e, this.b.view.w, this.b.view.h)))
        this.exclude.has(t.id) || this.rects.push(He(t));
    }
    return this.rects;
  }
  show(e) {
    const t = e && (e.lines.length || e.gaps.length) ? e : null;
    (t || this.b.guides.value) && (this.b.guides.value = t);
  }
  end() {
    window.removeEventListener("keydown", this.onKey), window.removeEventListener("keyup", this.onKey), this.b.guides.value = null;
  }
}
function xo(i) {
  let e = null, t = 0;
  return {
    call(n) {
      e = n, t || (t = requestAnimationFrame(() => {
        t = 0, e && i(e);
      }));
    },
    flush() {
      t && cancelAnimationFrame(t), t = 0, e && i(e);
    },
    cancel() {
      t && cancelAnimationFrame(t), t = 0;
    }
  };
}
class JMe {
  constructor(e) {
    ni(this, "b", e), ni(this, "spaceDown", !1), ni(this, "rightPress", null), ni(this, "rightEnded", null), ni(this, "stage", null), ni(this, "cleanups", []), ni(this, "hoverRaf", 0), ni(this, "lastPointer", { x: 0, y: 0 }), ni(this, "lastShift", !1);
  }
  attach(e) {
    this.stage = e;
    const t = (d) => this.onWheel(d);
    e.addEventListener("wheel", t, { passive: !1 });
    const n = (d) => this.onHover(d);
    e.addEventListener("pointermove", n);
    const s = () => this.setHover(null);
    e.addEventListener("pointerleave", s);
    const o = (d) => this.onKeyDown(d), r = (d) => this.onKeyUp(d);
    window.addEventListener("keydown", o), window.addEventListener("keyup", r);
    const a = () => {
      this.spaceDown = !1;
    };
    window.addEventListener("blur", a);
    const l = (d) => d.preventDefault();
    e.addEventListener("gesturestart", l), e.addEventListener("gesturechange", l), this.cleanups.push(() => {
      e.removeEventListener("wheel", t), e.removeEventListener("pointermove", n), e.removeEventListener("pointerleave", s), window.removeEventListener("keydown", o), window.removeEventListener("keyup", r), window.removeEventListener("blur", a), e.removeEventListener("gesturestart", l), e.removeEventListener("gesturechange", l);
    });
  }
  detach() {
    for (const e of this.cleanups) e();
    this.cleanups = [], cancelAnimationFrame(this.hoverRaf);
  }
  get spacePan() {
    return this.spaceDown;
  }
  // ------------------------------------------------------------- wheel
  onWheel(e) {
    if (!e.ctrlKey && !kn(e) && this.noteScrolls(e)) return;
    e.preventDefault();
    const t = this.b;
    if (!t.engine) return;
    (t.ui.canvasMenu || t.ui.finder || t.ui.boardLinkMenu) && (t.ui.canvasMenu = null, t.ui.finder = null, t.ui.boardLinkMenu = null);
    const n = e.clientX - t.view.left, s = e.clientY - t.view.top, o = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? t.view.h : 1, r = e.deltaX * o, a = e.deltaY * o;
    if (e.ctrlKey || kn(e)) {
      const l = e.ctrlKey && !e.metaKey && e.deltaMode === 0 && Math.abs(a) < 50;
      t.engine.zoomAt(n, s, Math.exp(l ? -a * 0.012 : -Math.max(-60, Math.min(60, a)) * 4e-3));
      return;
    }
    e.shiftKey && r === 0 ? t.engine.panBy(-a, 0) : t.engine.panBy(-r, -a);
  }
  /** The wheel is over the text of a selected (or open) note that can still scroll its way. */
  noteScrolls(e) {
    const t = e.target instanceof Element ? e.target.closest(".cv-note-text") : null, n = t && t.closest("[data-el]");
    if (!t || !n) return !1;
    const s = n.dataset.el;
    return !this.b.ui.selection.includes(s) && this.b.ui.editingNote !== s ? !1 : e.deltaY > 0 ? t.scrollTop + t.clientHeight < t.scrollHeight - 1 : e.deltaY < 0 ? t.scrollTop > 0 : !1;
  }
  // ------------------------------------------------------------- hover
  onHover(e) {
    this.lastPointer = { x: e.clientX, y: e.clientY }, this.lastShift = e.shiftKey, !(e.buttons || !this.b.engine) && (this.hoverRaf || (this.hoverRaf = requestAnimationFrame(() => {
      this.hoverRaf = 0;
      const t = this.b;
      if (!t.engine || t.ui.marquee || t.ui.dragging) return;
      const n = document.elementFromPoint(this.lastPointer.x, this.lastPointer.y), o = n && !n.classList.contains("bd-canvas") && !n.closest(".cv-img-hover") && n !== this.stage ? null : t.engine.hitTest(this.lastPointer.x - t.view.left, this.lastPointer.y - t.view.top);
      if (this.setHover(o && o.type === "image" ? o.id : null), this.stage) {
        const r = o && !t.isHeld(o) && (o.type === "image" || o.type === "frame" || o.type === "shape"), a = !!o && o.type === "image" && this.lastShift;
        this.stage.style.cursor = t.ui.eyedropper || t.comments.ui.armed ? "" : t.ui.shapeArmed ? "crosshair" : t.ui.mode === "hand" || this.spaceDown ? "" : a ? "copy" : r ? "grab" : "";
      }
    })));
  }
  setHover(e) {
    const t = this.b;
    t.ui.hoverId !== e && (t.ui.hoverId = e, t.engine && t.engine.setHover(e));
  }
  // ------------------------------------------------------------- stage
  /** pointerdown that reached the stage itself (not a DOM element). */
  stageDown(e) {
    const t = this.b;
    if (!t.engine) return;
    const n = e.button === 1 || e.button === 0 && (t.ui.mode === "hand" || this.spaceDown);
    if (t.ui.addMenu = !1, t.ui.shapeMenu = !1, t.ui.canvasMenu = null, t.ui.finder = null, t.ui.boardLinkMenu = null, n) {
      e.preventDefault(), this.beginPan(e, { clickClears: e.button === 0 });
      return;
    }
    if (e.button === 2) {
      this.beginRightPress(e);
      return;
    }
    if (e.button !== 0) return;
    if (t.ui.styleOpen = !1, Gh(), t.ui.eyedropper) {
      e.preventDefault();
      const o = t.engine.hitTest(e.clientX - t.view.left, e.clientY - t.view.top);
      o && o.type === "image" ? t.eyedropImage(o) : this.beginPan(e);
      return;
    }
    if (t.ui.shapeArmed) {
      e.preventDefault(), this.beginShape(e);
      return;
    }
    const s = t.engine.hitTest(e.clientX - t.view.left, e.clientY - t.view.top);
    if (s) {
      this.elementDown(s, e);
      return;
    }
    this.beginMarquee(e);
  }
  stageDoubleClick(e) {
    const t = this.b;
    if (!t.engine || t.ui.eyedropper) return;
    const n = t.engine.hitTest(e.clientX - t.view.left, e.clientY - t.view.top);
    n && n.type === "image" ? (t.ui.selection = [n.id], t.ui.infoAt = n.id) : n && n.type === "frame" ? (t.ui.selection = [n.id], t.engine.fitTo(He(n), { pad: 72, maxZoom: 1, animate: 460 })) : n && n.type === "note" ? t.editNote(n.id) : n && n.type === "tool" ? t.openSession(n) : n && n.type === "chat" ? (t.ui.selection = [n.id], t.ui.chatOpen = n.id) : !n && this.onCanvas(e.target) && t.ui.mode === "select" && !this.spaceDown && !t.ui.shapeArmed && t.openFinder(e.clientX, e.clientY);
  }
  /**
   * Right-click (Ctrl-click on a Mac, a long press on touch) on the empty
   * canvas or inside a frame: the canvas menu, which adds things there.
   * Elsewhere on the board the browser's own menu stays off and none shows.
   */
  stageContextMenu(e) {
    if (e.preventDefault(), this.rightPress) return;
    const t = this.rightEnded;
    t && performance.now() - t.at < 500 || this.menuAt(e.clientX, e.clientY, e.target);
  }
  /** The canvas menu at a point, where it opens: the empty canvas or inside a frame. */
  menuAt(e, t, n) {
    const s = this.b;
    if (!s.engine || s.ui.eyedropper || s.ui.shapeArmed || s.ui.panning || s.ui.dragging || !this.onCanvas(n)) return;
    const o = s.engine.hitTest(e - s.view.left, t - s.view.top);
    o && o.type !== "frame" || (Gh(), s.openCanvasMenu(e, t));
  }
  /**
   * Right-drag pans the board, as Miro's does (CHAT-21); a right-click that
   * doesn't move still opens the canvas menu, when it lets go.
   */
  beginRightPress(e) {
    const t = this.b, n = { x: e.clientX, y: e.clientY };
    this.rightPress = { ...n, target: e.target };
    let s = n, o = !1;
    const r = xo((l) => {
      if (t.engine) {
        if (!o) {
          if (Math.hypot(l.clientX - n.x, l.clientY - n.y) <= Uh) return;
          o = !0, t.ui.panning = !0;
        }
        t.engine.panBy(l.clientX - s.x, l.clientY - s.y), s = { x: l.clientX, y: l.clientY };
      }
    }), a = (l) => {
      r.flush();
      const d = this.rightPress;
      this.rightPress = null, this.rightEnded = { at: performance.now(), panned: o }, t.ui.panning = !1, window.removeEventListener("pointermove", r.call), window.removeEventListener("pointerup", a), window.removeEventListener("pointercancel", a), !o && d && l.type === "pointerup" && this.menuAt(d.x, d.y, d.target);
    };
    window.addEventListener("pointermove", r.call), window.addEventListener("pointerup", a), window.addEventListener("pointercancel", a);
  }
  /** The pointer is on the canvas itself, not on a card, a note or a frame's title drawn over it. */
  onCanvas(e) {
    return e === this.stage || e instanceof HTMLElement && e.classList.contains("bd-canvas");
  }
  /**
   * `clickClears`: a press that never moves is a click, which on the empty
   * canvas lets go of the selection, as it does without the hand (IL-100;
   * Blake: with the hand, a drawn shape's box took a second click, after
   * switching back, to go).
   */
  beginPan(e, t = {}) {
    const n = this.b;
    n.ui.panning = !0;
    const s = { x: e.clientX, y: e.clientY };
    let o = { x: e.clientX, y: e.clientY }, r = !1;
    const a = xo((d) => {
      n.engine && (!r && Math.hypot(d.clientX - s.x, d.clientY - s.y) > Uh && (r = !0), n.engine.panBy(d.clientX - o.x, d.clientY - o.y), o = { x: d.clientX, y: d.clientY });
    }), l = (d) => {
      a.flush(), n.ui.panning = !1, t.clickClears && !r && d.type === "pointerup" && n.engine && !n.engine.hitTest(d.clientX - n.view.left, d.clientY - n.view.top) && (n.ui.selection = []), window.removeEventListener("pointermove", a.call), window.removeEventListener("pointerup", l), window.removeEventListener("pointercancel", l);
    };
    window.addEventListener("pointermove", a.call), window.addEventListener("pointerup", l), window.addEventListener("pointercancel", l);
  }
  /**
   * A drag on the empty canvas selects what it touches. Started on a locked
   * frame (IL-070), or on what one holds (B31), which a drag can't move,
   * it's the same drag; a press that never moves is a click on it instead,
   * and selects it (then `onClick`, a session card's Open).
   */
  beginMarquee(e, t = null, n) {
    const s = this.b, o = e.clientX - s.view.left, r = e.clientY - s.view.top, a = e.shiftKey, l = a ? s.ui.selection.slice() : [];
    !a && !t && (s.ui.selection = []), s.ui.editingNote = null, s.ui.editingTitle = null;
    let d = !1;
    const c = xo((f) => {
      const p = f.clientX - s.view.left, y = f.clientY - s.view.top;
      if (!d && Math.hypot(p - o, y - r) < 3) return;
      d = !0, s.ui.marquee = { x0: o, y0: r, x1: p, y1: y };
      const v = s.cam.value, x = (Math.min(o, p) - v.x) / v.zoom, w = (Math.min(r, y) - v.y) / v.zoom, S = (Math.max(o, p) - v.x) / v.zoom, M = (Math.max(r, y) - v.y) / v.zoom, _ = s.store.query({ x, y: w, w: S - x, h: M - w }).filter((k) => k.type !== "frame" || k.x >= x && k.y >= w && k.x + k.w <= S && k.y + k.h <= M).map((k) => k.id), T = a ? Array.from(new Set(l.concat(_))) : _;
      (T.length !== s.ui.selection.length || T.some((k, P) => k !== s.ui.selection[P])) && (s.ui.selection = T);
    }), h = () => {
      if (c.flush(), s.ui.marquee = null, window.removeEventListener("pointermove", c.call), window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", h), t && !d) {
        const f = t.id;
        s.ui.selection = a ? l.includes(f) ? l.filter((p) => p !== f) : l.concat([f]) : [f], n && !a && n();
      }
    };
    window.addEventListener("pointermove", c.call), window.addEventListener("pointerup", h), window.addEventListener("pointercancel", h);
  }
  // ----------------------------------------------------------- elements
  /** pointerdown on an element (DOM or GPU). Click selects; drag moves. */
  /** `onClick`: a press that never became a drag, after it selects (a session card's Open, IL-100) */
  elementDown(e, t, n = {}) {
    const s = this.b;
    if (t.button === 1 || s.ui.mode === "hand" || this.spaceDown) {
      t.preventDefault(), t.stopPropagation(), this.beginPan(t);
      return;
    }
    if (t.button !== 0) return;
    if (t.stopPropagation(), s.ui.eyedropper) {
      t.preventDefault(), e.type === "image" ? s.eyedropImage(e) : this.beginPan(t);
      return;
    }
    if (s.ui.addMenu = !1, s.ui.editingNote === e.id) return;
    if (Gh(), Ro(e)) {
      this.beginMarquee(t, e);
      return;
    }
    if (t.shiftKey && e.type === "image") {
      this.beginReferenceDrag(e, t);
      return;
    }
    if (s.isHeld(e)) {
      this.beginMarquee(t, e, n.onClick);
      return;
    }
    const o = s.ui.selection.includes(e.id) ? s.ui.selection.filter((S) => !s.isHeld(s.store.get(S))) : [e.id], r = new Set(o);
    for (const S of o) {
      const M = s.store.get(S);
      if (M && M.type === "frame")
        for (const _ of s.carriedBy(M)) s.isHeld(s.store.get(_)) || r.add(_);
    }
    const a = /* @__PURE__ */ new Map();
    for (const S of r) {
      const M = s.store.get(S);
      M && a.set(S, { x: M.x, y: M.y });
    }
    const l = s.store.bounds(o), d = { x: t.clientX, y: t.clientY };
    let c = !1, h = null;
    const f = e.type === "image" && s.promptTool.value ? this.promptRect() : null;
    let p = !f;
    const y = new Fb(s, r, t, () => {
      c && h && v.call(h);
    }), v = xo((S) => {
      const M = s.cam.value.zoom;
      if (c && !p && f && S.clientX >= f.left && S.clientX <= f.right && S.clientY >= f.top && S.clientY <= f.bottom && (p = !0, s.toast("Hold Shift as you drag to use an image as a reference.")), !c && Math.hypot(S.clientX - d.x, S.clientY - d.y) > Uh && (c = !0, s.ui.selection.includes(e.id) || (s.ui.selection = [e.id]), s.ui.dragging = !0, s.ui.styleOpen = !1, s.store.beginGesture(r.size > 1 ? "Move " + r.size + " items" : "Move"), this.setHover(null)), !c) return;
      const _ = (S.clientX - d.x) / M, T = (S.clientY - d.y) / M;
      let k = Math.round(_), P = Math.round(T), A = null;
      if (l && !y.free) {
        const D = y.targets(), O = O4(U4(l, _, T), D, y.tol);
        O.x && (k = yo(_ + O.dx)), O.y && (P = yo(T + O.dy)), (O.x || O.y) && (A = B4(U4(l, k, P), D));
      }
      const R = [];
      for (const [D, O] of a) R.push([D, { x: O.x + k, y: O.y + P }]);
      s.store.updateMany(R), y.show(A);
    }), x = (S) => {
      h = S, y.pointer(S), v.call(S);
    }, w = (S) => {
      if (v.flush(), y.end(), window.removeEventListener("pointermove", x), window.removeEventListener("pointerup", w), window.removeEventListener("pointercancel", w), c) {
        s.growFramesFor(o), s.store.endGesture(), s.ui.dragging = !1;
        return;
      }
      S.shiftKey ? s.ui.selection = s.ui.selection.includes(e.id) ? s.ui.selection.filter((M) => M !== e.id) : s.ui.selection.concat([e.id]) : (s.ui.selection = [e.id], n.onClick && n.onClick());
    };
    window.addEventListener("pointermove", x), window.addEventListener("pointerup", w), window.addEventListener("pointercancel", w);
  }
  /**
   * Shift-drag an image (IL-071): a small copy of it follows the pointer, and
   * dropped on a session (its card, its row in the sessions rail, or the open
   * prompt and its image slots) the picture becomes that session's reference
   * and the session opens. The image itself stays where it is. Without a
   * drag it's Shift-click: in or out of the selection.
   */
  beginReferenceDrag(e, t) {
    const n = this.b, s = { x: t.clientX, y: t.clientY };
    let o = !1, r = null;
    const a = xo((d) => {
      if (!o) {
        if (Math.hypot(d.clientX - s.x, d.clientY - s.y) <= Uh) return;
        o = !0, n.ui.dragging = !0, this.setHover(null);
      }
      r = this.refDropAt(d.clientX, d.clientY);
      const c = r && r.key ? r.key : !1, h = r && !r.key ? r.sessionId : null;
      n.ui.refTarget !== c && (n.ui.refTarget = c), n.ui.refSession !== h && (n.ui.refSession = h), n.ui.ghost = { x: d.clientX, y: d.clientY, url: e.src, ref: !!r };
    }), l = (d) => {
      if (a.flush(), window.removeEventListener("pointermove", a.call), window.removeEventListener("pointerup", l), window.removeEventListener("pointercancel", l), n.ui.ghost = null, n.ui.refTarget = !1, n.ui.refSession = null, n.ui.dragging = !1, !o) {
        if (n.shiftPick && n.shiftPick(e.id)) return;
        n.ui.selection = n.ui.selection.includes(e.id) ? n.ui.selection.filter((h) => h !== e.id) : n.ui.selection.concat([e.id]);
        return;
      }
      if (d.type === "pointercancel") return;
      const c = r;
      c ? n.referenceImage(e.id, c.sessionId, { key: c.key, reveal: c.reveal }) : n.toast("Drop it on a session, or on the open prompt, to use it as a reference.");
    };
    window.addEventListener("pointermove", a.call), window.addEventListener("pointerup", l), window.addEventListener("pointercancel", l);
  }
  /**
   * What a Shift-dragged image would go to at a client point: an image slot
   * in the open prompt, the open prompt, a session's row in the rail (from
   * elsewhere on the board, so it's brought into view), or a session's card
   * (drawn by the engine when far out).
   */
  refDropAt(e, t) {
    const n = this.b, s = document.elementFromPoint(e, t);
    if (!s) return null;
    const o = n.promptTool.value, r = s.closest("[data-ref-key]");
    if (o && r) return { sessionId: o.id, key: r.getAttribute("data-ref-key") || void 0 };
    if (o && s.closest(".v2-uprompt")) return { sessionId: o.id };
    const a = s.closest("[data-ref-session]");
    if (a) return { sessionId: a.getAttribute("data-ref-session"), reveal: a.hasAttribute("data-ref-reveal") };
    if (this.onCanvas(s) && n.engine) {
      const l = n.engine.hitTest(e - n.view.left, t - n.view.top);
      if (l && l.type === "tool") return { sessionId: l.id };
    }
    return null;
  }
  /** Where the open prompt is on screen, if it is. */
  promptRect() {
    const e = document.querySelector(".v2-uprompt");
    return e ? e.getBoundingClientRect() : null;
  }
  /**
   * The bottom-right handle of a single selection. The edges it moves (the
   * right and the bottom) snap to the edges of what is on screen; a card
   * that keeps its proportions snaps whichever of the two is nearer.
   */
  resizeDown(e, t) {
    const n = this.b;
    if (t.button !== 0 || n.isHeld(e)) return;
    t.stopPropagation(), t.preventDefault(), Gh();
    const s = { x: t.clientX, y: t.clientY }, o = He(e), r = e.type === "image" ? n.ownerFrame(e) : null;
    n.store.beginGesture("Resize"), n.ui.dragging = !0;
    let a = null;
    const l = new Fb(n, /* @__PURE__ */ new Set([e.id]), t, () => {
      a && d.call(a);
    }), d = xo((f) => {
      const p = n.cam.value.zoom, y = (f.clientX - s.x) / p, v = (f.clientY - s.y) / p, x = l.free ? null : l.targets(), w = (M, _) => qMe({ x: o.x, y: o.y, w: M, h: _ }, x || [], l.tol);
      if (e.type === "tool") {
        let M = (o.w + y) / Rt.w;
        const _ = x ? w(Rt.w * M, Rt.h * M) : null, T = _ && G4(_);
        _ && T === "x" ? M = (Rt.w * M + _.dx) / Rt.w : _ && T === "y" && (M = (Rt.h * M + _.dy) / Rt.h), M = Math.max(0.7, Math.min(2.6, M)), n.store.update(e.id, { scale: T ? Math.round(M * 1e4) / 1e4 : Math.round(M * 100) / 100 });
      } else if (e.type === "image") {
        const M = o.h / o.w, _ = o.w + (f.shiftKey || Math.abs(y) > Math.abs(v / M) ? y : v / M);
        let T = Math.round(_), k = Math.round(T * M);
        const P = x ? w(_, _ * M) : null, A = P && G4(P);
        P && A === "x" ? (T = yo(_ + P.dx), k = Math.round(T * M)) : P && A === "y" && (k = yo(_ * M + P.dy), T = Math.round(k / M)), T < 120 && (T = 120, k = Math.round(T * M)), n.store.update(e.id, { w: T, h: k });
      } else {
        const M = e.type === "shape" && (e.shape === "line" || e.shape === "arrow"), _ = e.type === "shape" ? M ? 0 : 12 : e.type === "frame" ? 200 : 140, T = e.type === "shape" ? M ? 0 : 12 : e.type === "frame" ? 160 : 120;
        let k = o.w + y, P = o.h + v;
        const A = x ? w(k, P) : null;
        k = A && A.x ? yo(k + A.dx) : Math.round(k), P = A && A.y ? yo(P + A.dy) : Math.round(P);
        const R = e.type === "note" ? { grow: void 0 } : {};
        n.store.update(e.id, { w: Math.max(_, k), h: Math.max(T, P), ...R });
      }
      const S = n.store.get(e.id);
      l.show(x && S ? KMe(He(S), x) : null);
    }), c = (f) => {
      a = f, l.pointer(f), d.call(f);
    }, h = () => {
      d.flush(), l.end(), window.removeEventListener("pointermove", c), window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", h), e.type === "image" && n.growFramesFor([e.id], r ? /* @__PURE__ */ new Map([[e.id, r.id]]) : void 0), n.store.endGesture(), n.ui.dragging = !1;
    };
    window.addEventListener("pointermove", c), window.addEventListener("pointerup", h), window.addEventListener("pointercancel", h);
  }
  // ------------------------------------------------------------- shapes
  /** Drag draws; a plain click drops a readable default. Shift constrains. */
  beginShape(e) {
    const t = this.b, n = t.ui.shapeKind, s = t.screenToWorld(e.clientX, e.clientY), o = St();
    t.ui.shapeArmed = !1, t.store.beginGesture("Draw " + n);
    const r = {
      id: o,
      type: "shape",
      shape: n,
      x: Math.round(s.x),
      y: Math.round(s.y),
      w: 0,
      h: 0,
      z: 0,
      sc: [0, 0],
      stroke: t.ui.shapeStyle.stroke,
      sw: t.ui.shapeStyle.sw,
      createdBy: t.user.uid
    };
    r.z = t.store.nextZ(r), t.store.add([r]), t.ui.selection = [o], t.ui.dragging = !0;
    let a = !1;
    const l = xo((c) => {
      const h = t.screenToWorld(c.clientX, c.clientY);
      let f = h.x - s.x, p = h.y - s.y;
      if (c.shiftKey)
        if (n === "rect" || n === "ellipse") {
          const y = Math.max(Math.abs(f), Math.abs(p));
          f = (f < 0 ? -1 : 1) * y, p = (p < 0 ? -1 : 1) * y;
        } else {
          const y = Math.round(Math.atan2(p, f) / (Math.PI / 4)) * (Math.PI / 4), v = Math.hypot(f, p);
          f = Math.cos(y) * v, p = Math.sin(y) * v;
        }
      (Math.abs(f) * t.cam.value.zoom > 4 || Math.abs(p) * t.cam.value.zoom > 4) && (a = !0), t.store.update(o, {
        x: Math.round(Math.min(s.x, s.x + f)),
        y: Math.round(Math.min(s.y, s.y + p)),
        w: Math.round(Math.abs(f)),
        h: Math.round(Math.abs(p)),
        sc: [f < 0 ? 1 : 0, p < 0 ? 1 : 0]
      });
    }), d = () => {
      if (l.flush(), window.removeEventListener("pointermove", l.call), window.removeEventListener("pointerup", d), window.removeEventListener("pointercancel", d), !a) {
        const c = n === "line" || n === "arrow";
        t.store.update(o, c ? { x: Math.round(s.x - 130), y: Math.round(s.y), w: 260, h: 0, sc: [0, 0] } : { x: Math.round(s.x - 130), y: Math.round(s.y - 85), w: 260, h: 170 });
      }
      t.store.endGesture(), t.ui.dragging = !1, t.ui.styleOpen = !0;
    };
    window.addEventListener("pointermove", l.call), window.addEventListener("pointerup", d), window.addEventListener("pointercancel", d);
  }
  // ------------------------------------------------------- drag-outs
  /**
   * Pull a result out of a tool card or the gallery. Over the canvas it
   * becomes a card that follows the pointer; over the prompt's reference
   * slot it becomes the reference. A short drag is a click.
   */
  dragResultOut(e, t, n = {}) {
    const s = this.b;
    if (t.button !== 0) return;
    t.preventDefault(), t.stopPropagation();
    const o = { x: t.clientX, y: t.clientY }, r = n.slop || 6;
    let a = !1, l = null;
    const d = e.w || 300, c = e.h || 200, h = (_) => {
      const T = document.elementFromPoint(_.clientX, _.clientY), k = T ? T.closest("[data-ref-key]") : null;
      return k && k.getAttribute("data-ref-key") || !1;
    }, f = (_) => {
      const T = document.elementFromPoint(_.clientX, _.clientY);
      return !T || T.closest(".v2-hist, .v2-uprompt, .rs, .cv-topbar, .v2-railwrap, .cv-corner, .cv-addmenu, .v2-info") ? !1 : !!T.closest(".cv-stage");
    }, p = /* @__PURE__ */ new Set();
    let y = null;
    const v = new Fb(s, p, t, () => {
      l && y && w.call(y);
    }), x = (_) => {
      const T = { x: _.x - d / 2, y: _.y - c / 2, w: d, h: c };
      let k = Math.round(T.x), P = Math.round(T.y), A = null;
      if (!v.free) {
        const R = v.targets(), D = O4(T, R, v.tol);
        D.x && (k = yo(T.x + D.dx)), D.y && (P = yo(T.y + D.dy)), (D.x || D.y) && (A = B4({ x: k, y: P, w: d, h: c }, R));
      }
      return { x: k, y: P, guides: A };
    }, w = xo((_) => {
      if (!a && Math.hypot(_.clientX - o.x, _.clientY - o.y) > r && (a = !0, s.ui.dragging = !0), !!a)
        if (f(_)) {
          const T = s.screenToWorld(_.clientX, _.clientY);
          if (l) {
            const k = x(T);
            s.store.update(l, { x: k.x, y: k.y }), v.show(k.guides);
          } else {
            s.store.beginGesture("Place result");
            const k = e.result || null, P = {
              id: St(),
              type: "image",
              x: 0,
              y: 0,
              w: d,
              h: c,
              z: 0,
              src: e.url,
              label: e.label || k && k.label || "result",
              resultId: k ? k.id : void 0,
              sessionId: e.sessionId || k && k.sessionId || void 0,
              video: k ? k.video : void 0,
              dur: k ? k.dur : void 0,
              videoSrc: k ? k.videoSrc : void 0,
              previewSrc: k ? k.previewSrc : void 0,
              asset: k ? k.asset : void 0,
              download: k ? k.download : void 0,
              kind: k ? k.kind : void 0,
              createdBy: s.user.uid
            };
            p.add(P.id);
            const A = x(T);
            P.x = A.x, P.y = A.y, P.z = s.store.nextZ(P), l = P.id, s.ui.ghost = null, s.ui.refTarget = !1, s.store.add([P]), n.keepSelection || (s.ui.selection = [P.id]), v.show(A.guides);
          }
        } else {
          l && (s.store.cancelGesture(), l = null), v.show(null);
          const T = h(_);
          s.ui.refTarget = T, s.ui.ghost = { x: _.clientX, y: _.clientY, url: e.url, ref: !!T };
        }
    }), S = (_) => {
      y = _, v.pointer(_), w.call(_);
    }, M = (_) => {
      w.flush(), v.end(), window.removeEventListener("pointermove", S), window.removeEventListener("pointerup", M), window.removeEventListener("pointercancel", M);
      const T = a && !l && h(_);
      if (s.ui.ghost = null, s.ui.refTarget = !1, s.ui.dragging = !1, l && (s.growFramesFor([l]), s.store.endGesture()), n.keepSelection && (s.ui.selection = [n.keepSelection]), T) {
        const k = s.promptTool.value;
        k && s.setRefInput(k.id, T, e.url, e.result && e.result.asset || s.assetFor(e.url));
        return;
      }
      !a && n.onClick && n.onClick();
    };
    window.addEventListener("pointermove", S), window.addEventListener("pointerup", M), window.addEventListener("pointercancel", M);
  }
  // ----------------------------------------------------------- keyboard
  onKeyUp(e) {
    e.code === "Space" && (this.spaceDown = !1, this.stage && this.stage.classList.remove("is-hand"));
  }
  onKeyDown(e) {
    const t = this.b, n = t.feedback;
    if (n && n.state.mode === "open") return;
    const s = H0(e.target), o = kn(e);
    if (n && !s && e.code === "Backquote" && !o && !e.shiftKey && !e.altKey) {
      e.preventDefault(), n.start("key");
      return;
    }
    if (t.ui.studio || t.ui.libraryOpen) return;
    if (e.key === "Escape") {
      if (n && n.state.mode === "aside") {
        e.preventDefault(), n.resume();
        return;
      }
      this.escape(e, s);
      return;
    }
    if (s || t.ui.trashOpen) return;
    if (e.key === "?" && !o) {
      e.preventDefault(), t.ui.boardMenu = !1, t.ui.keysOpen = !t.ui.keysOpen;
      return;
    }
    if (t.ui.keysOpen || t.ui.infoAt || t.ui.library.open && !o) return;
    if (e.code === "Space") {
      !this.spaceDown && this.stage && this.stage.classList.add("is-hand"), this.spaceDown = !0, e.preventDefault();
      return;
    }
    const r = e.key.toLowerCase();
    if (o) {
      r === "z" ? (e.preventDefault(), e.shiftKey ? t.redo() : t.undo()) : r === "y" ? (e.preventDefault(), t.redo()) : r === "d" ? (e.preventDefault(), t.duplicateIds(t.ui.selection.slice())) : r === "l" && e.shiftKey ? t.ui.selection.some((l) => {
        var d;
        return ((d = t.store.get(l)) == null ? void 0 : d.type) === "frame";
      }) && (e.preventDefault(), t.toggleLock()) : r === "a" ? (e.preventDefault(), t.selectAll()) : r === "c" ? t.ui.selection.length && (e.preventDefault(), t.copy(!1)) : r === "x" ? t.ui.selection.length && (e.preventDefault(), t.copy(!0)) : r === "0" ? (e.preventDefault(), t.zoomTo(1)) : r === "=" || r === "+" ? (e.preventDefault(), t.zoomBy(1.25)) : r === "-" && (e.preventDefault(), t.zoomBy(1 / 1.25));
      return;
    }
    if (e.altKey || uB(e)) return;
    const a = (l) => {
      e.preventDefault(), l();
    };
    switch (r) {
      case "v":
        a(() => t.setMode("select"));
        break;
      case "h":
        a(() => t.setMode("hand"));
        break;
      case "i": {
        const l = t.promptTool.value;
        l && a(() => t.toggleEyedropper(l.id));
        break;
      }
      case "c":
        if (!t.comments.enabled) break;
        e.shiftKey ? a(() => {
          const l = !t.comments.ui.showPins;
          t.comments.ui.showPins = l, t.toast(l ? "Comments shown on the board" : "Comments hidden. Shift+C shows them again");
        }) : a(() => t.comments.arm());
        break;
      case "m":
        a(() => t.armShape("rect"));
        break;
      case "l":
        a(() => t.armShape("ellipse"));
        break;
      case "n":
        a(() => t.addElement("note"));
        break;
      case "f":
        a(() => t.addElement("frame"));
        break;
      case "=":
      case "+":
        a(() => t.zoomBy(1.2));
        break;
      case "-":
      case "_":
        a(() => t.zoomBy(1 / 1.2));
        break;
      case "1":
      case "!":
        a(() => t.fit());
        break;
      case "0":
      case ")":
        a(() => t.zoomTo(1));
        break;
      case "delete":
      case "backspace":
        t.ui.selection.length && (e.preventDefault(), t.deleteIds(t.ui.selection.slice()));
        break;
      case "arrowleft":
      case "arrowright":
      case "arrowup":
      case "arrowdown": {
        if (!t.ui.selection.length) return;
        e.preventDefault();
        const l = e.shiftKey ? 10 : 1;
        t.nudge(r === "arrowleft" ? -l : r === "arrowright" ? l : 0, r === "arrowup" ? -l : r === "arrowdown" ? l : 0);
        break;
      }
      case "enter": {
        const l = t.ui.selection.length === 1 ? t.store.get(t.ui.selection[0]) : null;
        l && l.type === "note" ? (e.preventDefault(), t.editNote(l.id)) : l && l.type === "chat" ? (e.preventDefault(), t.ui.chatOpen = l.id) : l && l.type === "image" && (e.preventDefault(), t.ui.infoAt = l.id);
        break;
      }
      default:
        (e.code === "Backslash" || e.key === "\\" || e.key === "|") && a(() => t.armShape(e.shiftKey || e.key === "|" ? "arrow" : "line"));
    }
  }
  /** Esc closes the top layer only: menus, popovers, modal, then selection. */
  escape(e, t) {
    const n = this.b, s = n.ui;
    if (t) {
      document.activeElement.blur(), s.editingNote && (s.editingNote = null), s.editingTitle && (s.editingTitle = null);
      return;
    }
    const o = n.comments;
    s.boardMenu ? s.boardMenu = !1 : s.ctxMenu ? s.ctxMenu = !1 : s.canvasMenu ? s.canvasMenu = null : s.finder ? s.finder = null : s.boardLinkMenu ? s.boardLinkMenu = null : s.trashOpen ? s.trashOpen = !1 : s.keysOpen ? s.keysOpen = !1 : s.addMenu ? s.addMenu = !1 : s.placeMenu ? s.placeMenu = !1 : s.shapeMenu ? s.shapeMenu = !1 : s.shapeArmed ? s.shapeArmed = !1 : o.ui.draft ? o.cancelDraft() : o.ui.editingId ? o.ui.editingId = null : o.ui.openId ? o.close() : o.ui.armed ? o.ui.armed = !1 : s.eyedropper ? s.eyedropper = null : s.styleOpen ? s.styleOpen = !1 : s.infoAt && s.infoSave ? s.infoSave = !1 : s.infoAt ? s.infoAt = null : s.library.open ? n.promptLibrary.back() : s.boardHistory ? s.boardHistory = !1 : o.ui.panelOpen ? o.ui.panelOpen = !1 : s.chatOpen ? s.chatOpen = null : s.advOpen ? s.advOpen = !1 : s.selection.length ? s.selection = [] : s.mode === "hand" && (s.mode = "select"), e.preventDefault();
  }
  /** Paste from the system clipboard: board elements, or image files. */
  onPaste(e, t) {
    if (H0(e.target)) return;
    const n = this.b;
    if (n.ui.trashOpen || n.ui.studio || n.ui.libraryOpen) return;
    const s = e.clipboardData;
    if (!s) return;
    const o = Array.from(s.files || []).filter((a) => a.type.startsWith("image/"));
    if (o.length) {
      e.preventDefault(), t(o, n.viewportCentre());
      return;
    }
    const r = s.getData("text/plain");
    if (r && r.startsWith('{"rdBoard"'))
      try {
        const a = JSON.parse(r);
        if (a && Array.isArray(a.els)) {
          e.preventDefault(), n.paste(a.els, typeof a.board == "string" ? a.board : null);
          return;
        }
      } catch {
      }
    e.preventDefault(), n.paste();
  }
  /**
   * Leaving a note: its text stays, and so does the note when it has none
   * (Tyler, 2026-10-27: a note placed and left blank stays put, as Miro's
   * do; Delete removes it).
   */
  commitNote(e, t) {
    const n = this.b, s = n.store.get(e);
    n.ui.editingNote = null, s && s.text !== t && n.store.update(e, { text: t }, { history: !1 });
  }
}
const ZMe = {
  key: 0,
  class: "bd-empty",
  "data-testid": "empty-board"
}, QMe = { class: "bd-empty-mark" }, eTe = { class: "bd-empty-actions" }, tTe = {
  key: 0,
  class: "cm-cards"
}, nTe = {
  key: 2,
  class: "pl-float"
}, iTe = {
  key: 20,
  class: "bd-drop"
}, sTe = { class: "bd-drop-card" }, oTe = { class: "bd-toast-text" }, rTe = /* @__PURE__ */ Pe({
  __name: "BoardView",
  props: {
    board: {},
    onHome: { type: Function },
    onIndex: { type: Function }
  },
  setup(i) {
    const e = i, t = EE(), n = e.board, s = new JMe(n);
    lL({ board: n, input: s });
    const o = os(n), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(null), c = /* @__PURE__ */ qe(!1), { active: h, over: f, leave: p, stop: y } = cx(), v = n.ui, x = n.comments, w = n.promptTool, S = I(() => (n.results.rev.value, w.value ? n.results.list(w.value.id) : [])), M = I(() => !!o.open.value), _ = I(() => !!w.value && S.value.length > 0 && v.histOpen && !v.boardHistory && !x.ui.panelOpen && !M.value), T = I(() => v.boardHistory || x.ui.panelOpen), k = I(() => ({
      "hist-rail": _.value,
      "board-hist": T.value,
      "chat-open": M.value,
      "light-canvas": v.lightCanvas,
      "no-grid": !v.showGrid,
      "is-studio": !!v.studio
    })), P = I(() => n.overlayIds.value.length > 120), A = n.feedback, R = I(() => !!A && A.state.mode === "open");
    function D(Z) {
      const Y = Z.target;
      A && Y instanceof Element && Y.closest("[data-feedback-bar]") && Z.stopImmediatePropagation();
    }
    window.addEventListener("pointerdown", D, !0), We(() => window.removeEventListener("pointerdown", D, !0)), Ae(() => !!v.studio, (Z) => {
      n.engine && n.engine.setPaused(Z);
    });
    const O = I(() => (n.docRev.value, n.store.size === 0));
    ot(async () => {
      await nt(), !(!r.value || !a.value || !l.value) && (s.attach(r.value), await n.attach(a.value, l.value), c.value = !0, window.addEventListener("paste", ee));
    }), We(() => {
      DG(n), s.detach(), window.removeEventListener("paste", ee);
    });
    function F(Z) {
      const Y = Z.currentTarget;
      (Y.scrollTop || Y.scrollLeft) && (Y.scrollTop = 0, Y.scrollLeft = 0);
    }
    function te(Z) {
      s.stageDown(Z);
    }
    function ee(Z) {
      R.value || s.onPaste(Z, (Y, H) => B(Y, H));
    }
    let me;
    function L(Z) {
      me = Z, d.value && d.value.click();
    }
    async function N(Z) {
      const Y = Array.from(Z.target.files || []);
      Z.target.value = "";
      const H = me;
      me = void 0, Y.length && await B(Y, H);
    }
    function X(Z) {
      return new Promise((Y) => {
        const H = new Image();
        H.onload = () => Y({ w: H.naturalWidth || 4, h: H.naturalHeight || 3 }), H.onerror = () => Y({ w: 4, h: 3 }), H.src = Z;
      });
    }
    async function B(Z, Y) {
      const H = Z.filter((he) => he.type.startsWith("image/")).slice(0, 24);
      if (!H.length) return;
      const re = n.uploader;
      n.toast(H.length === 1 ? "Placing image…" : "Placing " + H.length + " images…");
      const le = [];
      for (const he of H) {
        const Re = URL.createObjectURL(he), Ne = await X(Re);
        let Me = Re, ue;
        if (re)
          try {
            const ie = await n.uploadFile(he);
            Me = ie.url, ue = ie.asset || void 0, URL.revokeObjectURL(Re);
          } catch (ie) {
            console.error("[board] upload failed", ie);
            const de = ie ? ie.userMessage : void 0;
            n.toast(de || he.name + " could not be uploaded.", "error"), URL.revokeObjectURL(Re);
            continue;
          }
        const q = 360 / Math.max(Ne.w, Ne.h);
        le.push({ url: Me, w: Math.round(Ne.w * q), h: Math.round(Ne.h * q), label: he.name.replace(/\.[a-z0-9]+$/i, "").slice(0, 40), asset: ue });
      }
      le.length && n.placeImages(le, Y);
    }
    function se(Z) {
      R.value || !f(Z) || Z.preventDefault();
    }
    function V(Z) {
      if (y(), R.value || !Z.dataTransfer) return;
      const Y = Array.from(Z.dataTransfer.files || []);
      Y.length && (Z.preventDefault(), B(Y, n.screenToWorld(Z.clientX, Z.clientY)));
    }
    return (Z, Y) => (g(), b("div", {
      class: G(["cv-root v2-root p1-root bd-root", k.value]),
      style: ce(m(v).promptCardH ? { "--up-card-h": m(v).promptCardH + "px" } : void 0),
      "data-screen-label": "Phase 1 - Boards V2",
      onDragover: se,
      onDragleave: Y[10] || (Y[10] = //@ts-ignore
      (...H) => m(p) && m(p)(...H)),
      onDrop: V
    }, [
      C(cL),
      u("div", {
        ref_key: "stage",
        ref: r,
        class: G(["cv-stage v2-stage", { "is-hand": m(v).mode === "hand", "is-panning": m(v).panning, "is-draw": m(v).shapeArmed, "is-dropper": !!m(v).eyedropper }]),
        "data-testid": "stage",
        onPointerdown: te,
        onDblclick: Y[0] || (Y[0] = (H) => m(s).stageDoubleClick(H)),
        onContextmenu: Y[1] || (Y[1] = (H) => m(s).stageContextMenu(H)),
        onScroll: F
      }, [
        u("div", {
          ref_key: "canvasHost",
          ref: a,
          class: "bd-canvas-host"
        }, null, 512),
        u("div", {
          ref_key: "world",
          ref: l,
          class: G(["cv-world", { "is-moving": m(n).moving.value, "is-crowded": P.value, "is-far": m(n).far.value }])
        }, [
          c.value ? (g(), Ce(tre, { key: 0 })) : z("", !0),
          c.value && m(x).enabled ? (g(), Ce(V3e, { key: 1 })) : z("", !0)
        ], 2),
        m(v).marquee ? (g(), b("div", {
          key: 0,
          class: "cv-marquee",
          style: ce({
            left: Math.min(m(v).marquee.x0, m(v).marquee.x1) + "px",
            top: Math.min(m(v).marquee.y0, m(v).marquee.y1) + "px",
            width: Math.abs(m(v).marquee.x1 - m(v).marquee.x0) + "px",
            height: Math.abs(m(v).marquee.y1 - m(v).marquee.y0) + "px"
          })
        }, null, 4)) : z("", !0),
        C(are)
      ], 34),
      C(vt, { name: "bd-empty" }, {
        default: Xe(() => [
          c.value && O.value && !m(v).addMenu && !m(v).finder && !m(v).shapeArmed ? (g(), b("div", ZMe, [
            u("div", {
              class: "bd-empty-card",
              onPointerdown: Y[5] || (Y[5] = Se(() => {
              }, ["stop"]))
            }, [
              u("span", QMe, [
                C($, {
                  name: "Sparkles",
                  size: 18
                })
              ]),
              Y[14] || (Y[14] = u("b", null, "A blank board", -1)),
              Y[15] || (Y[15] = u("span", { class: "bd-empty-sub" }, "Start a tool session, drop images anywhere, or jot a note.", -1)),
              u("div", eTe, [
                u("button", {
                  class: "bd-btn",
                  "data-testid": "empty-start",
                  onClick: Y[2] || (Y[2] = (H) => m(n).addElement("tool"))
                }, [
                  C($, {
                    name: "Plus",
                    size: 14
                  }),
                  Y[11] || (Y[11] = J(" Start a tool session", -1))
                ]),
                u("button", {
                  class: "bd-btn is-ghost",
                  onClick: Y[3] || (Y[3] = (H) => L())
                }, [
                  C($, {
                    name: "Upload",
                    size: 14
                  }),
                  Y[12] || (Y[12] = J(" Add images", -1))
                ]),
                m(n).hasLibrary ? (g(), b("button", {
                  key: 0,
                  class: "bd-btn is-ghost",
                  "data-testid": "empty-library",
                  onClick: Y[4] || (Y[4] = (H) => m(n).openLibrary())
                }, [
                  C($, {
                    name: "Library",
                    size: 14
                  }),
                  Y[13] || (Y[13] = J(" From your Library", -1))
                ])) : z("", !0)
              ]),
              Y[16] || (Y[16] = u("div", { class: "bd-empty-keys" }, [
                u("kbd", null, "N"),
                J(" note "),
                u("kbd", null, "F"),
                J(" frame "),
                u("kbd", null, "M"),
                J(" shape "),
                u("kbd", null, "V"),
                J(" select")
              ], -1))
            ], 32)
          ])) : z("", !0)
        ]),
        _: 1
      }),
      c.value && m(x).enabled ? (g(), b("div", tTe, [
        (g(!0), b(j, null, be(m(x).openCards.value, (H) => (g(), Ce(E4, {
          id: H.id,
          key: H.id
        }, null, 8, ["id"]))), 128)),
        m(x).ui.draft ? (g(), Ce(E4, {
          id: null,
          key: "draft",
          draft: ""
        })) : z("", !0)
      ])) : z("", !0),
      C(dB, {
        "on-home": e.onHome,
        "on-index": e.onIndex
      }, null, 8, ["on-home", "on-index"]),
      C(ure),
      C(XB, {
        away: !!m(w),
        "on-image": () => L()
      }, null, 8, ["away", "on-image"]),
      C(wF),
      m(w) ? (g(), Ce(cue, {
        key: m(w).id,
        tool: m(w)
      }, null, 8, ["tool"])) : z("", !0),
      m(v).library.open && !m(v).library.sessionId ? (g(), b("div", nTe, [
        C(Xy, { floating: "" })
      ])) : z("", !0),
      m(v).addMenu ? (g(), Ce(OF, { key: 3 })) : z("", !0),
      m(v).canvasMenu ? (g(), Ce(JF, {
        key: "cm" + m(v).canvasMenu.x + "," + m(v).canvasMenu.y,
        menu: m(v).canvasMenu,
        "on-image": L
      }, null, 8, ["menu"])) : z("", !0),
      m(v).finder ? (g(), Ce(SN, {
        key: "sf" + m(v).finder.x + "," + m(v).finder.y,
        menu: m(v).finder
      }, null, 8, ["menu"])) : z("", !0),
      m(v).boardLinkMenu ? (g(), Ce(UN, {
        key: "bl" + m(v).boardLinkMenu.x + "," + m(v).boardLinkMenu.y,
        menu: m(v).boardLinkMenu
      }, null, 8, ["menu"])) : z("", !0),
      u("div", {
        class: G(["cv-corner", { "is-away": _.value || T.value || M.value }])
      }, [
        m(v).miniOpen ? (g(), Ce(YN, { key: 0 })) : z("", !0),
        C(QN)
      ], 2),
      C(gH),
      m(v).boardHistory ? (g(), Ce(RV, { key: 7 })) : z("", !0),
      m(x).enabled && m(x).ui.panelOpen && !m(v).boardHistory ? (g(), Ce(P8e, { key: 8 })) : z("", !0),
      M.value && !m(v).boardHistory ? (g(), Ce(GMe, { key: 9 })) : z("", !0),
      _.value && m(w) ? (g(), Ce(tH, {
        key: "h" + m(w).id,
        tool: m(w)
      }, null, 8, ["tool"])) : z("", !0),
      m(w) && S.value.length && !m(v).histOpen && !T.value && !M.value ? (g(), b("button", {
        key: 11,
        class: "v2-hist-open",
        title: "Show the gallery",
        onPointerdown: Y[6] || (Y[6] = Se(() => {
        }, ["stop"])),
        onClick: Y[7] || (Y[7] = (H) => m(v).histOpen = !0)
      }, [
        C($, {
          name: "PanelRightOpen",
          size: 14
        }),
        u("span", null, E(S.value.length), 1)
      ], 32)) : z("", !0),
      C(oj),
      C(yj),
      C(Pj),
      m(v).studio ? (g(), Ce(gwe, {
        key: m(v).studio.sessionId
      })) : z("", !0),
      m(v).infoAt ? (g(), Ce(Uq, { key: 13 })) : z("", !0),
      m(v).keysOpen ? (g(), Ce(Jq, { key: 14 })) : z("", !0),
      m(v).trashOpen ? (g(), Ce(zse, { key: 15 })) : z("", !0),
      m(v).libraryOpen ? (g(), Ce(Y2e, {
        key: m(v).libraryOpen.n
      })) : z("", !0),
      C(vt, { name: "fb-aside" }, {
        default: Xe(() => [
          m(A) && m(A).state.mode === "aside" ? (g(), Ce(R3e, {
            key: 0,
            feedback: m(A)
          }, null, 8, ["feedback"])) : z("", !0)
        ]),
        _: 1
      }),
      m(A) && m(A).state.mode === "open" ? (g(), Ce(T3e, {
        key: 17,
        feedback: m(A)
      }, null, 8, ["feedback"])) : z("", !0),
      m(A) && m(A).state.flash ? (g(), b("div", {
        key: "fb-flash" + m(A).state.flash,
        class: "fb-flash",
        "data-feedback-skip": ""
      })) : z("", !0),
      m(v).ghost ? (g(), b("div", {
        key: 19,
        class: G(["tl-ghost", { "is-ref": m(v).ghost.ref }]),
        style: ce({ left: m(v).ghost.x + "px", top: m(v).ghost.y + "px", backgroundImage: 'url("' + m(v).ghost.url + '")' })
      }, null, 6)) : z("", !0),
      m(h) ? (g(), b("div", iTe, [
        u("div", sTe, [
          C($, {
            name: "ImagePlus",
            size: 20
          }),
          Y[17] || (Y[17] = J(" Drop images to place them on the board", -1))
        ])
      ])) : z("", !0),
      C(vt, { name: "bd-toast" }, {
        default: Xe(() => [
          m(v).toast ? (g(), b("div", {
            key: m(v).toast.id,
            class: G(["bd-toast", { "is-error": m(v).toast.tone === "error", "has-action": !!m(v).toast.action, "is-long": m(v).toast.text.length > 70 }]),
            role: "status",
            "data-testid": "toast"
          }, [
            C($, {
              name: m(v).toast.tone === "error" ? "AlertCircle" : "Check",
              size: 13
            }, null, 8, ["name"]),
            u("span", oTe, E(m(v).toast.text), 1),
            m(v).toast.action ? (g(), b("button", {
              key: 0,
              class: "bd-toast-act",
              "data-testid": "toast-action",
              onPointerdown: Y[8] || (Y[8] = Se(() => {
              }, ["stop"])),
              onClick: Y[9] || (Y[9] = (H) => m(v).toast.action.run())
            }, E(m(v).toast.action.label), 33)) : z("", !0)
          ], 2)) : z("", !0)
        ]),
        _: 1
      }),
      Ss(Z.$slots, "hud"),
      m(v).showStats && !m(t).hud ? (g(), Ce(Ose, { key: 21 })) : z("", !0),
      u("input", {
        ref_key: "fileEl",
        ref: d,
        type: "file",
        accept: "image/*",
        multiple: "",
        style: { display: "none" },
        onChange: N
      }, null, 544),
      Y[18] || (Y[18] = u("div", { class: "cm-portal" }, null, -1)),
      m(x).enabled ? (g(), Ce($8e, { key: 22 })) : z("", !0)
    ], 38));
  }
}), Ql = "1 33 239 173", fa = [
  {
    d: "M160.973 91.1044H105.586C103.271 91.1044 101.134 89.8671 99.9766 87.8597L74.5215 43.7307C72.0284 39.4055 75.1448 33.9999 80.1311 33.9999H135.518C137.833 33.9999 139.97 35.2372 141.128 37.2447L166.579 81.3772C169.072 85.7024 165.956 91.108 160.97 91.108L160.973 91.1044Z",
    fill: "#CC5FD1",
    origin: "50% 17.1%",
    axis: [0.87, 0.49],
    out: [0, -1]
  },
  {
    d: "M150.485 148.213H205.872C208.187 148.213 210.324 146.975 211.481 144.968L236.933 100.835C239.426 96.5102 236.31 91.1046 231.323 91.1046H175.936C173.621 91.1046 171.484 92.3419 170.327 94.3494L144.875 138.482C142.382 142.807 145.498 148.213 150.485 148.213Z",
    fill: "#9A6ADF",
    origin: "79.5% 50.1%",
    axis: [0.87, -0.49],
    out: [1, 0]
  },
  {
    d: "M160.974 205.317H105.587C103.271 205.317 101.134 204.079 99.9769 202.072L74.5254 157.939C72.0323 153.614 75.1487 148.209 80.135 148.209H135.522C137.837 148.209 139.974 149.446 141.132 151.453L166.583 195.586C169.076 199.911 165.96 205.317 160.974 205.317Z",
    fill: "#B0B3F6",
    origin: "50% 83.1%",
    axis: [0.87, 0.49],
    out: [0, 1]
  },
  {
    d: "M40.7394 200.572L67.1953 151.857C68.2994 149.821 68.2389 147.35 67.0279 145.371L40.4581 101.905C37.8545 97.6479 31.6216 97.8048 29.2389 102.194L2.78656 150.909C1.68245 152.945 1.74299 155.416 2.95395 157.395L29.5238 200.86C32.1274 205.118 38.3603 204.961 40.743 200.572H40.7394Z",
    fill: "#A691DF",
    origin: "14.2% 68%",
    axis: [0, 1],
    out: [-0.94, 0.34]
  }
], BA = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='${Ql}'>${fa.map((i) => `<path d='${i.d}'/>`).join("")}</svg>`
)}")`;
function aTe(i, e) {
  return {
    "--i": String(e),
    "--ox": i.origin.split(" ")[0],
    "--oy": i.origin.split(" ")[1],
    "--ax": String(i.axis[0]),
    "--ay": String(i.axis[1]),
    "--dx": String(i.out[0]),
    "--dy": String(i.out[1])
  };
}
const lTe = 800;
function dTe() {
  var i;
  const e = performance.now(), t = (i = window.__rdMarkLoaderClock) != null ? i : window.__rdMarkLoaderClock = { epoch: e, live: 0, lastSeen: -1 / 0 };
  return t.live === 0 && e - t.lastSeen > lTe && (t.epoch = e), t.live++, Math.round(e - t.epoch);
}
function cTe() {
  const i = window.__rdMarkLoaderClock;
  i && (i.live = Math.max(0, i.live - 1), i.lastSeen = performance.now());
}
const uTe = { class: "bd-ml-mark" }, hTe = ["viewBox"], pTe = ["d", "fill"], FA = /* @__PURE__ */ Pe({
  __name: "MarkLoader",
  props: {
    size: { default: 72 }
  },
  setup(i) {
    const e = i, t = dTe();
    return We(cTe), (n, s) => (g(), b("div", {
      class: "bd-mark-loader",
      role: "status",
      "aria-label": "Loading",
      style: ce({ "--ml-size": `${e.size}px`, "--ml-offset": `${m(t)}ms`, "--ml-mask": m(BA) })
    }, [
      s[1] || (s[1] = u("div", { class: "bd-ml-glow" }, null, -1)),
      u("div", uTe, [
        (g(!0), b(j, null, be(m(fa), (o, r) => (g(), b("svg", {
          key: r,
          class: "bd-ml-facet",
          viewBox: m(Ql),
          style: ce(m(aTe)(o, r)),
          "aria-hidden": "true",
          focusable: "false"
        }, [
          u("path", {
            d: o.d,
            fill: o.fill
          }, null, 8, pTe)
        ], 12, hTe))), 128)),
        s[0] || (s[0] = u("div", { class: "bd-ml-sheen" }, null, -1))
      ])
    ], 4));
  }
}), Qd = [
  { id: "pan", label: "Pan, whole board", hint: "All of it in view", about: "A trackpad pan at the overview, with every object on screen" },
  { id: "zoom", label: "Pinch zoom", hint: "In close and back", about: "Pinch from the overview about 45 times closer and back out, through every level of detail" },
  { id: "pan-near", label: "Pan at 60%", hint: "Images stream in", about: "A steady trackpad pan across copies at 60%, loading images as they come into view" },
  { id: "fly", label: "Fly-through", hint: "Dives and glides", about: "Camera glides: dives into a copy, a long glide across, pull-backs to the overview; reports how long the images take to sharpen after landing" }
];
class mx extends Error {
  constructor() {
    super("Benchmark stopped");
  }
}
const Nb = 4e3;
function jh(i, e) {
  const t = i.slice().sort((r, a) => r - a), n = (r) => t.length ? t[Math.min(t.length - 1, Math.floor(r * t.length))] : 0, s = n(0.95), o = i.filter((r) => r > e * 3).length;
  return {
    p50: n(0.5),
    p95: s,
    max: t.length ? t[t.length - 1] : 0,
    slow: o,
    n: i.length,
    vsync: e,
    pass: t.length > 0 && s <= e * 1.5 + 1 && o === 0
  };
}
function NA(i = 30) {
  return new Promise((e) => {
    const t = [];
    let n = 0;
    const s = (o) => {
      if (n && t.push(o - n), n = o, t.length < i) {
        requestAnimationFrame(s);
        return;
      }
      t.sort((r, a) => r - a), e(t[Math.floor(t.length / 2)]);
    };
    requestAnimationFrame(s);
  });
}
const V0 = (i) => new Promise((e) => setTimeout(e, i));
function $p(i) {
  if (i.cancelled && i.cancelled()) throw new mx();
}
function fTe(i) {
  const e = i.worldEl && i.worldEl.closest('[data-testid="stage"]');
  if (!e) throw new Error("The board is not on screen");
  return e;
}
async function UA(i, e = 6e3, t) {
  const n = performance.now();
  for (await V0(300); performance.now() - n < e && (t && $p(t), !(!i.engine || i.engine.textureStats().pending === 0)); )
    await V0(50);
  return performance.now() - n;
}
function Hh(i) {
  const e = i.store.bounds() || { x: 0, y: 0, w: i.view.w, h: i.view.h };
  return rm(e, i.view.w, i.view.h, 120, 1);
}
function Vh(i, e) {
  let t = null;
  for (const s of i.store.all()) {
    if (s.type !== "frame") continue;
    const o = He(s);
    o.x < e.x || o.y < e.y || o.x + o.w > e.x + e.w || o.y + o.h > e.y + e.h || (!t || o.w * o.h > t.w * t.h) && (t = o);
  }
  const n = t || e;
  return { x: n.x + n.w / 2, y: n.y + n.h / 2 };
}
function Ub(i, e, t) {
  return new Promise((n, s) => {
    const o = [];
    let r = 0, a = 0;
    const l = (d) => {
      if (i.cancelled && i.cancelled()) {
        s(new mx());
        return;
      }
      r || (r = d), a && o.push(d - a), a = d;
      const c = d - r;
      if (i.onProgress && i.onProgress(Math.min(1, c / e)), c >= e) {
        n(o);
        return;
      }
      t(c), requestAnimationFrame(l);
    };
    requestAnimationFrame(l);
  });
}
function mTe(i) {
  return new Promise((e, t) => {
    const n = [];
    let s = !1, o = null;
    i.then(() => {
      s = !0;
    }, (l) => {
      o = l, s = !0;
    });
    let r = 0;
    const a = (l) => {
      if (r && n.push(l - r), r = l, s) {
        o ? t(o) : e(n);
        return;
      }
      requestAnimationFrame(a);
    };
    requestAnimationFrame(a);
  });
}
function Gb(i, e) {
  const t = i.getBoundingClientRect();
  i.dispatchEvent(new WheelEvent("wheel", {
    deltaMode: 0,
    clientX: t.left + t.width / 2,
    clientY: t.top + t.height / 2,
    bubbles: !0,
    cancelable: !0,
    ...e
  }));
}
async function jb(i, e, t) {
  i.onPhase && i.onPhase("warm"), i.onProgress && i.onProgress(0), i.board.setCamera(e), await UA(i.board, t, i);
}
async function gTe(i, e) {
  const { board: t, layout: n } = e;
  if (!t.engine) throw new Error("The board is still loading");
  const s = fTe(t), o = t.view.w, r = t.view.h, a = n.tiles[Math.floor(n.rows / 2) * n.cols + Math.floor(n.cols / 2)] || n.tiles[0];
  if (i === "pan" || i === "zoom")
    await jb(e, Hh(t), 8e3);
  else if (i === "pan-near") {
    const T = Vh(t, a);
    await jb(e, rl(T.x, T.y, 0.6, o, r), 5e3);
  } else
    await jb(e, Hh(t), 8e3);
  $p(e);
  const l = await NA();
  $p(e), e.onPhase && e.onPhase("measure");
  const d = l / (1e3 / 60);
  if (i === "pan") {
    const T = await Ub(e, Nb, (k) => {
      const P = k / 16.666666666666668;
      Gb(s, { deltaX: 12 * d * Math.cos(P / 17), deltaY: 9 * d * Math.cos(P / 23) });
    });
    return jh(T, l);
  }
  if (i === "pan-near") {
    const T = await Ub(e, Nb, (k) => {
      const P = k / 16.666666666666668;
      Gb(s, { deltaX: d * (26 + 8 * Math.sin(P / 13)), deltaY: 14 * d * Math.cos(P / 23) });
    });
    return jh(T, l);
  }
  if (i === "zoom") {
    const T = await Ub(e, Nb, (k) => {
      const P = k / 16.666666666666668;
      Gb(s, { deltaY: -8 * d * Math.sin(P / 20), ctrlKey: !0 });
    });
    return jh(T, l);
  }
  const c = t.engine, h = n.tiles[Math.min(n.tiles.indexOf(a) + 2, n.tiles.length - 1)], f = n.tiles[n.tiles.length - 1], p = Vh(t, a), y = Vh(t, h), v = Vh(t, f), x = [
    { cam: rm(a, o, r, 60, 1), ms: 1400 },
    { cam: rl(p.x, p.y, 0.6, o, r), ms: 900, sharp: !0 },
    { cam: rl(y.x, y.y, 0.6, o, r), ms: 2200 },
    { cam: Hh(t), ms: 1400 },
    { cam: rl(v.x, v.y, 1, o, r), ms: 1700, sharp: !0 },
    { cam: Hh(t), ms: 1400 }
  ], w = x.reduce((T, k) => T + k.ms, 0);
  let S = 0;
  const M = (async () => {
    let T = 0;
    for (const k of x) {
      $p(e);
      const P = performance.now(), A = window.setInterval(() => {
        e.onProgress && e.onProgress(Math.min(1, (T + Math.min(k.ms, performance.now() - P)) / w));
      }, 100);
      try {
        await c.animateCamera(k.cam, k.ms);
      } finally {
        clearInterval(A);
      }
      T += k.ms, k.sharp ? S = Math.max(S, await UA(t, 5e3, e)) : await V0(250);
    }
  })(), _ = await mTe(M);
  return e.onProgress && e.onProgress(1), { ...jh(_, l), sharpMs: S };
}
const bTe = [1e3, 4500, 1e4, 2e4], vTe = 4500, yTe = 5e4;
function j4(i) {
  const e = Math.round(Number(i));
  return !Number.isFinite(e) || e <= 0 ? vTe : Math.min(yTe, e);
}
const H4 = (i) => Math.round(i).toLocaleString("en-US"), Wh = (i) => (Math.round(i * 10) / 10).toFixed(1);
function xTe(i) {
  const e = (l) => {
    const d = i.match(l);
    return d ? d[1] : null;
  };
  let t = "Browser";
  const n = e(/Edg\/(\d+)/), s = e(/Chrome\/(\d+)/), o = e(/Firefox\/(\d+)/), r = e(/Version\/(\d+(?:\.\d+)?).*Safari/);
  n ? t = "Edge " + n : s ? t = "Chrome " + s : o ? t = "Firefox " + o : r && (t = "Safari " + r);
  let a = "";
  return /Mac OS X/.test(i) ? a = "macOS" : /Windows/.test(i) ? a = "Windows" : /Android/.test(i) ? a = "Android" : /iPhone|iPad/.test(i) ? a = "iOS" : /Linux/.test(i) && (a = "Linux"), a ? t + " on " + a : t;
}
function GA(i) {
  return i.pass ? "Smooth" : "Dropped frames";
}
function wTe(i, e, t) {
  const n = (l, d) => l.length >= d ? l + " " : l + " ".repeat(d - l.length), s = [], o = t.getFullYear() + "-" + String(t.getMonth() + 1).padStart(2, "0") + "-" + String(t.getDate()).padStart(2, "0") + " " + String(t.getHours()).padStart(2, "0") + ":" + String(t.getMinutes()).padStart(2, "0");
  s.push("Boards stress test, " + o);
  let r = 0;
  for (const l of i) for (const d of Object.values(l.results)) d && d.vsync && (r = d.vsync);
  const a = [xTe(e.userAgent), e.viewport.w + "×" + e.viewport.h + " at " + e.dpr + "x"];
  r && a.push(Math.round(1e3 / r) + " Hz display (" + Wh(r) + " ms frames)"), e.cores && a.push(e.cores + " cores"), e.memoryGB && a.push(e.memoryGB + " GB memory"), s.push(a.join(" · "));
  for (const l of i) {
    const d = Qd.filter((c) => l.results[c.id]);
    if (d.length) {
      s.push(""), s.push(H4(l.images) + " images · " + H4(l.objects) + " objects · " + l.copies + " copies (" + l.cols + " × " + l.rows + ")");
      for (const c of d) {
        const h = l.results[c.id];
        let f = "  " + n(c.label, 19) + n("p50 " + Wh(h.p50), 10) + n("p95 " + Wh(h.p95), 10) + n("max " + Wh(h.max), 11) + n(h.slow + " slow", 8) + GA(h);
        h.sharpMs != null && (f += ", sharp in " + (h.sharpMs / 1e3).toFixed(1) + " s"), s.push(f);
      }
    }
  }
  return s.push(""), s.push("Frame times in ms. Smooth: p95 within 1.5 display frames and no frame past 3."), s.join(`
`);
}
const kTe = { class: "sx-head" }, _Te = { class: "sx-mark" }, STe = { class: "sx-title" }, MTe = { key: 0 }, TTe = { key: 1 }, CTe = ["title"], ITe = { class: "sx-pinned" }, ATe = {
  class: "sx-graph",
  title: "Frame times, newest on the right. The line is the budget: 1.5 display frames."
}, PTe = { class: "sx-graph-label" }, ETe = { class: "sx-live" }, RTe = { title: "CPU time of the last frame the board drew" }, zTe = { title: "Elements inside the view" }, $Te = { title: "Notes, sessions and labels mounted as DOM" }, DTe = { title: "GPU memory held by image textures (budget 420 MB)" }, OTe = { title: "Image renditions queued or decoding" }, LTe = { title: "JavaScript heap in use (Chrome only)" }, BTe = {
  class: "sx-tabs",
  role: "tablist"
}, FTe = ["aria-selected"], NTe = ["aria-selected"], UTe = {
  key: 0,
  class: "sx-dot"
}, GTe = {
  key: 1,
  class: "sx-tab-n"
}, jTe = { class: "sx-body" }, HTe = {
  key: 0,
  class: "sx-pane"
}, VTe = {
  class: "sx-seg",
  role: "radiogroup",
  "aria-label": "Board size"
}, WTe = ["aria-checked", "disabled", "data-testid", "onClick"], qTe = {
  class: "sx-counts",
  "data-testid": "stress-counts"
}, KTe = { class: "sx-big" }, YTe = {
  class: "is-grad",
  "data-testid": "stress-images"
}, XTe = { class: "sx-big" }, JTe = { "data-testid": "stress-objects" }, ZTe = { key: 0 }, QTe = { class: "sx-row" }, eCe = ["disabled"], tCe = ["disabled"], nCe = ["disabled"], iCe = ["disabled"], sCe = {
  key: 1,
  class: "sx-pane"
}, oCe = { class: "sx-bench" }, rCe = ["data-testid"], aCe = ["title"], lCe = {
  key: 0,
  class: "sx-phase"
}, dCe = {
  key: 2,
  class: "sx-hint"
}, cCe = ["disabled", "title", "aria-label", "onClick"], uCe = {
  key: 0,
  class: "sx-bench-res",
  "data-testid": "stress-result"
}, hCe = {
  key: 1,
  class: "sx-progress"
}, pCe = { class: "sx-note" }, fCe = { class: "sx-actions" }, mCe = ["disabled"], gCe = ["disabled"], Rs = 120, bCe = /* @__PURE__ */ Pe({
  __name: "StressPanel",
  props: {
    board: {},
    stress: {}
  },
  setup(i) {
    const e = i, t = e.board, n = e.stress, s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = n.collapsed, a = n.tab, l = (U) => U.toLocaleString("en-US"), d = I(() => {
      t.docRev.value, t.results.rev.value;
      const U = { image: 0, video: 0, tool: 0, note: 0, frame: 0, shape: 0, chat: 0 };
      for (const q of t.store.all())
        q.type === "image" ? (U.image++, q.video && U.video++) : q.type in U && U[q.type]++;
      return { ...U, objects: t.store.size, results: t.results.size };
    }), c = I(() => n.layout.value), h = new Float32Array(Rs);
    let f = 0, p = 0, y = 0, v = 0, x = 0, w = null;
    const S = /* @__PURE__ */ qe(1e3 / 60), M = /* @__PURE__ */ qe(0), _ = /* @__PURE__ */ Xt({ frameMs: 0, visible: 0, dom: 0, textureMB: 0, pending: 0, heapMB: 0 }), T = I(() => {
      const U = 1e3 / S.value;
      return M.value ? M.value < U * 0.6 ? "is-bad" : M.value < U * 0.9 ? "is-warn" : "" : "";
    });
    function k() {
      const U = o.value;
      if (!U) return;
      const q = U.getBoundingClientRect();
      if (q.width < 2) return;
      const ie = Math.min(2, window.devicePixelRatio || 1);
      U.width = Math.round(q.width * ie), U.height = Math.round(q.height * ie), w = U.getContext("2d");
    }
    function P() {
      const U = o.value;
      if (!U || !w || r.value) return;
      const q = U.width, ie = U.height, de = S.value, pe = de * 4;
      w.clearRect(0, 0, q, ie), w.fillStyle = "rgba(255, 255, 255, 0.12)", w.fillRect(0, Math.round(ie - de * 1.5 / pe * ie), q, 1);
      const Te = q / Rs, Be = Te > 3 ? 1 : 0;
      for (let ge = 0; ge < p; ge++) {
        const ne = h[(f - p + ge + Rs) % Rs], oe = Math.max(2, Math.min(ie, ne / pe * ie));
        w.fillStyle = ne > de * 3 ? "#ff5c7a" : ne > de * 1.5 + 1 ? "#ffb347" : "rgba(55, 211, 153, 0.85)", w.fillRect((Rs - p + ge) * Te, ie - oe, Te - Be, oe);
      }
    }
    function A(U) {
      y && U - y < 1e3 && (h[f] = U - y, f = (f + 1) % Rs, p = Math.min(Rs, p + 1), P()), y = U, v = requestAnimationFrame(A);
    }
    function R() {
      if (p) {
        const ie = Math.min(p, 60);
        let de = 0;
        for (let pe = 1; pe <= ie; pe++) de += h[(f - pe + Rs) % Rs];
        M.value = Math.round(1e3 / (de / ie));
      }
      const U = t.stats.value;
      if (U && (_.frameMs = U.frameMs, _.visible = U.visible), t.engine) {
        const ie = t.engine.textureStats();
        _.textureMB = ie.mb, _.pending = ie.pending;
      }
      _.dom = t.overlayIds.value.length;
      const q = performance.memory;
      q && (_.heapMB = Math.round(q.usedJSHeapSize / 1048576));
    }
    const D = /* @__PURE__ */ qe(null);
    function O(U) {
      B.value || U === n.images.value || (D.value = U, requestAnimationFrame(() => setTimeout(() => n.rebuild(U), 30)));
    }
    function F(U) {
      t.zoomTo(U);
    }
    function te() {
      const U = c.value.tiles;
      if (!t.engine || !U.length) return;
      const q = U[Math.floor(Math.random() * U.length)];
      let ie = q;
      for (const de of t.store.all()) {
        if (de.type !== "frame") continue;
        const pe = He(de);
        pe.x >= q.x && pe.y >= q.y && pe.x + pe.w <= q.x + q.w && pe.y + pe.h <= q.y + q.h && (ie === q || pe.w * pe.h > ie.w * ie.h) && (ie = pe);
      }
      t.engine.animateCamera(rl(ie.x + ie.w / 2, ie.y + ie.h / 2, 0.6, t.view.w, t.view.h), 900);
    }
    const ee = n.reports.get(n.images.value), me = /* @__PURE__ */ Xt(ee ? { ...ee.results } : {}), L = /* @__PURE__ */ qe(null), N = /* @__PURE__ */ qe("warm"), X = /* @__PURE__ */ qe(!1), B = I(() => !!L.value || D.value != null), se = I(() => Qd.filter((U) => me[U.id]).length), V = I(() => se.value > 0 || Array.from(n.reports.values()).some((U) => Object.keys(U.results).length > 0));
    let Z = !1;
    function Y(U) {
      s.value && s.value.style.setProperty("--sx-p", String(U));
    }
    function H(U, q) {
      me[U] = q;
      const ie = n.images.value, de = c.value, pe = n.reports.get(ie) || {
        images: d.value.image,
        objects: d.value.objects,
        copies: de.copies,
        cols: de.cols,
        rows: de.rows,
        results: {}
      };
      pe.results[U] = q, n.reports.set(ie, pe);
    }
    async function re(U) {
      if (!B.value) {
        Z = !1;
        for (const q of U) {
          L.value = q, N.value = "warm", Y(0);
          try {
            const ie = await gTe(q, {
              board: t,
              layout: c.value,
              onProgress: Y,
              onPhase: (de) => {
                N.value = de;
              },
              cancelled: () => Z
            });
            H(q, ie);
          } catch (ie) {
            ie instanceof mx || t.toast(ie.message || "The benchmark stopped", "error");
            break;
          }
        }
        L.value = null, Y(0);
      }
    }
    function le() {
      Z = !0;
    }
    function he(U) {
      U.key === "Escape" && L.value && le();
    }
    function Re(U) {
      const q = (de) => (Math.round(de * 10) / 10).toFixed(1);
      let ie = "p95 " + q(U.p95) + " · max " + q(U.max) + " ms · " + U.slow + " slow";
      return U.sharpMs != null && (ie += " · sharp " + (U.sharpMs / 1e3).toFixed(1) + " s"), ie;
    }
    function Ne() {
      const U = navigator;
      return {
        userAgent: U.userAgent,
        dpr: window.devicePixelRatio || 1,
        viewport: { w: window.innerWidth, h: window.innerHeight },
        cores: U.hardwareConcurrency || void 0,
        memoryGB: U.deviceMemory
      };
    }
    async function Me() {
      const U = wTe(Array.from(n.reports.values()).sort((q, ie) => q.images - ie.images), Ne(), /* @__PURE__ */ new Date());
      try {
        await navigator.clipboard.writeText(U), X.value = !0, setTimeout(() => {
          X.value = !1;
        }, 1800);
      } catch {
        t.toast("Couldn't copy the report. The browser blocked clipboard access.", "error");
      }
    }
    function ue() {
      r.value = !r.value, r.value || requestAnimationFrame(k);
    }
    return ot(() => {
      k(), v = requestAnimationFrame(A), x = window.setInterval(R, 250), window.addEventListener("keydown", he), window.addEventListener("resize", k), NA().then((U) => {
        S.value = U;
      });
    }), We(() => {
      Z = !0, cancelAnimationFrame(v), clearInterval(x), window.removeEventListener("keydown", he), window.removeEventListener("resize", k);
    }), (U, q) => (g(), b("div", {
      ref_key: "root",
      ref: s,
      class: G(["sx", { "is-collapsed": m(r), "is-busy": B.value }]),
      "data-testid": "stress-panel",
      onPointerdown: q[6] || (q[6] = Se(() => {
      }, ["stop"])),
      onWheel: q[7] || (q[7] = Se(() => {
      }, ["stop"]))
    }, [
      u("header", kTe, [
        u("span", _Te, [
          C($, {
            name: "Gauge",
            size: 15
          })
        ]),
        u("div", STe, [
          q[8] || (q[8] = u("b", null, "Stress test", -1)),
          m(r) ? (g(), b("span", MTe, E(l(d.value.image)) + " images", 1)) : (g(), b("span", TTe, "Demo board × " + E(c.value.copies), 1))
        ]),
        u("span", {
          class: G(["sx-fps", T.value]),
          title: "Frames per second, from the browser's frame clock",
          "data-testid": "stress-fps"
        }, E(M.value || "–") + " fps", 3),
        u("button", {
          class: "sx-icon",
          title: m(r) ? "Expand the panel" : "Collapse the panel",
          onClick: ue
        }, [
          C($, {
            name: m(r) ? "ChevronDown" : "ChevronUp",
            size: 14
          }, null, 8, ["name"])
        ], 8, CTe)
      ]),
      kt(u("div", ITe, [
        u("div", ATe, [
          u("canvas", {
            ref_key: "graph",
            ref: o,
            "aria-hidden": "true"
          }, null, 512),
          u("span", PTe, E((Math.round(S.value * 10) / 10).toFixed(1)) + " ms frames", 1)
        ]),
        u("div", ETe, [
          u("div", RTe, [
            u("b", null, E(_.frameMs.toFixed(1)), 1),
            q[9] || (q[9] = u("span", null, "ms to draw", -1))
          ]),
          u("div", zTe, [
            u("b", null, E(l(_.visible)), 1),
            q[10] || (q[10] = u("span", null, "in view", -1))
          ]),
          u("div", $Te, [
            u("b", null, E(l(_.dom)), 1),
            q[11] || (q[11] = u("span", null, "DOM cards", -1))
          ]),
          u("div", DTe, [
            u("b", null, E(l(_.textureMB)), 1),
            q[12] || (q[12] = u("span", null, "MB textures", -1))
          ]),
          u("div", OTe, [
            u("b", null, E(l(_.pending)), 1),
            q[13] || (q[13] = u("span", null, "loading", -1))
          ]),
          u("div", LTe, [
            u("b", null, E(_.heapMB ? l(_.heapMB) : "–"), 1),
            q[14] || (q[14] = u("span", null, "MB JS heap", -1))
          ])
        ]),
        u("div", BTe, [
          u("button", {
            role: "tab",
            "aria-selected": m(a) === "board",
            class: G({ "is-on": m(a) === "board" }),
            "data-testid": "stress-tab-board",
            onClick: q[0] || (q[0] = (ie) => a.value = "board")
          }, "Board", 10, FTe),
          u("button", {
            role: "tab",
            "aria-selected": m(a) === "bench",
            class: G({ "is-on": m(a) === "bench" }),
            "data-testid": "stress-tab-bench",
            onClick: q[1] || (q[1] = (ie) => a.value = "bench")
          }, [
            q[15] || (q[15] = J(" Benchmarks ", -1)),
            L.value ? (g(), b("span", UTe)) : se.value ? (g(), b("span", GTe, E(se.value) + "/" + E(m(Qd).length), 1)) : z("", !0)
          ], 10, NTe)
        ])
      ], 512), [
        [bv, !m(r)]
      ]),
      kt(u("div", jTe, [
        m(a) === "board" ? (g(), b("section", HTe, [
          q[26] || (q[26] = u("h4", null, [
            J("Board size "),
            u("span", null, "images, at least")
          ], -1)),
          u("div", VTe, [
            (g(!0), b(j, null, be(m(bTe), (ie) => (g(), b("button", {
              key: ie,
              role: "radio",
              "aria-checked": ie === m(n).images.value,
              class: G({ "is-on": ie === m(n).images.value }),
              disabled: B.value && D.value !== ie,
              "data-testid": "stress-size-" + ie,
              onClick: (de) => O(ie)
            }, [
              D.value === ie ? (g(), Ce($, {
                key: 0,
                name: "Loader2",
                size: 12,
                spin: ""
              })) : z("", !0),
              J(" " + E(l(ie)), 1)
            ], 10, WTe))), 128))
          ]),
          u("div", qTe, [
            u("div", KTe, [
              u("b", YTe, E(l(d.value.image)), 1),
              q[16] || (q[16] = u("span", null, "images", -1))
            ]),
            u("div", XTe, [
              u("b", JTe, E(l(d.value.objects)), 1),
              u("span", null, "objects, " + E(c.value.cols) + " × " + E(c.value.rows) + " copies", 1)
            ]),
            u("dl", null, [
              u("div", null, [
                q[17] || (q[17] = u("dt", null, "Sessions", -1)),
                u("dd", null, E(l(d.value.tool)), 1)
              ]),
              u("div", null, [
                q[18] || (q[18] = u("dt", null, "Notes", -1)),
                u("dd", null, E(l(d.value.note)), 1)
              ]),
              d.value.chat ? (g(), b("div", ZTe, [
                q[19] || (q[19] = u("dt", null, "Chats", -1)),
                u("dd", null, E(l(d.value.chat)), 1)
              ])) : z("", !0),
              u("div", null, [
                q[20] || (q[20] = u("dt", null, "Frames", -1)),
                u("dd", null, E(l(d.value.frame)), 1)
              ]),
              u("div", null, [
                q[21] || (q[21] = u("dt", null, "Shapes", -1)),
                u("dd", null, E(l(d.value.shape)), 1)
              ]),
              u("div", null, [
                q[22] || (q[22] = u("dt", null, "Videos", -1)),
                u("dd", null, E(l(d.value.video)), 1)
              ]),
              u("div", null, [
                q[23] || (q[23] = u("dt", null, "Results", -1)),
                u("dd", null, E(l(d.value.results)), 1)
              ])
            ])
          ]),
          q[27] || (q[27] = u("h4", { class: "sx-h-gap" }, "Camera", -1)),
          u("div", QTe, [
            u("button", {
              class: "sx-chip",
              disabled: B.value,
              title: "See the whole board",
              onClick: q[2] || (q[2] = (ie) => m(t).fit())
            }, [
              C($, {
                name: "Scan",
                size: 13
              }),
              q[24] || (q[24] = J("Fit all", -1))
            ], 8, eCe),
            u("button", {
              class: "sx-chip",
              disabled: B.value,
              title: "Zoom to 60%",
              onClick: q[3] || (q[3] = (ie) => F(0.6))
            }, "60%", 8, tCe),
            u("button", {
              class: "sx-chip",
              disabled: B.value,
              title: "Zoom to 100%",
              onClick: q[4] || (q[4] = (ie) => F(1))
            }, "100%", 8, nCe),
            u("button", {
              class: "sx-chip",
              disabled: B.value,
              title: "Fly to a random copy",
              onClick: te
            }, [
              C($, {
                name: "LocateFixed",
                size: 13
              }),
              q[25] || (q[25] = J("Random", -1))
            ], 8, iCe)
          ])
        ])) : (g(), b("section", sCe, [
          u("ul", oCe, [
            (g(!0), b(j, null, be(m(Qd), (ie) => (g(), b("li", {
              key: ie.id,
              class: G({ "is-running": L.value === ie.id }),
              "data-testid": "stress-bench-" + ie.id
            }, [
              u("div", {
                class: "sx-bench-name",
                title: ie.about
              }, [
                u("b", null, E(ie.label), 1),
                L.value === ie.id ? (g(), b("span", lCe, E(N.value === "warm" ? "Loading the start" + (_.pending ? ", " + l(_.pending) + " to go" : "") : "Measuring"), 1)) : me[ie.id] ? (g(), b("span", {
                  key: 1,
                  class: G(["sx-pill", me[ie.id].pass ? "is-ok" : "is-bad"]),
                  "data-testid": "stress-verdict"
                }, E(m(GA)(me[ie.id])), 3)) : (g(), b("span", dCe, E(ie.hint), 1))
              ], 8, aCe),
              u("button", {
                class: "sx-play",
                disabled: B.value,
                title: "Run " + ie.label.toLowerCase(),
                "aria-label": "Run " + ie.label.toLowerCase(),
                onClick: (de) => re([ie.id])
              }, [
                L.value === ie.id ? (g(), Ce($, {
                  key: 0,
                  name: "Loader2",
                  size: 13,
                  spin: ""
                })) : (g(), Ce($, {
                  key: 1,
                  name: "Play",
                  size: 12
                }))
              ], 8, cCe),
              me[ie.id] && L.value !== ie.id ? (g(), b("div", uCe, E(Re(me[ie.id])), 1)) : z("", !0),
              L.value === ie.id ? (g(), b("div", hCe)) : z("", !0)
            ], 10, rCe))), 128))
          ]),
          u("p", pCe, E(L.value ? "Hands off the board while it runs. Esc stops it." : "Smooth: p95 under 1.5 frames, none over 3."), 1),
          u("div", fCe, [
            L.value ? (g(), b("button", {
              key: 0,
              class: "bd-btn is-ghost",
              "data-testid": "stress-stop",
              onClick: le
            }, [
              C($, {
                name: "Square",
                size: 12
              }),
              q[28] || (q[28] = J("Stop", -1))
            ])) : (g(), b("button", {
              key: 1,
              class: "bd-btn",
              disabled: B.value,
              "data-testid": "stress-run-all",
              onClick: q[5] || (q[5] = (ie) => re(m(Qd).map((de) => de.id)))
            }, [
              C($, {
                name: "Play",
                size: 12
              }),
              q[29] || (q[29] = J("Run all", -1))
            ], 8, mCe)),
            u("button", {
              class: "bd-btn is-ghost",
              disabled: !V.value,
              "data-testid": "stress-copy",
              onClick: Me
            }, [
              C($, {
                name: X.value ? "Check" : "Copy",
                size: 13
              }, null, 8, ["name"]),
              J(E(X.value ? "Copied" : "Copy report"), 1)
            ], 8, gCe)
          ])
        ]))
      ], 512), [
        [bv, !m(r)]
      ])
    ], 34));
  }
}), vCe = "/internal/canvas-boards", yCe = 100, xCe = 200, wCe = 100;
function ja(i) {
  return i && i.trim() ? i.trim() : null;
}
function kCe(i) {
  const e = new URLSearchParams(), t = ja(i.teamId);
  t && e.set("team_id", t), i.view && e.set("view", i.view);
  const n = ja(i.cursor);
  n && e.set("cursor", n), e.set("limit", String(Math.min(yCe, Math.max(1, Math.floor(i.limit) || 1)))), ja(i.customFieldKey);
  const s = ja(i.q);
  s && e.set("q", s.slice(0, xCe));
  const o = Array.from(new Set(i.ownerUserIds.map((a) => ja(a)).filter((a) => !!a))).slice(0, wCe);
  o.length && e.set("owner_user_id", o.join(","));
  const r = ja(i.accessLevel);
  return r && e.set("access_level", r), e;
}
function cu(i) {
  return i !== null && typeof i == "object" && !Array.isArray(i) ? i : null;
}
function zi(i) {
  return typeof i == "string" && i ? i : null;
}
function _Ce(i) {
  const e = cu(i), t = e ? zi(e.key) : null;
  return !e || !t ? null : { key: t, label: zi(e.label), value: typeof e.value == "string" ? e.value : null };
}
function SCe(i) {
  const e = cu(i), t = e ? zi(e.id) : null;
  return !e || !t ? null : {
    id: t,
    created: zi(e.created),
    title: zi(e.title),
    description: zi(e.description),
    accessLevel: zi(e.access_level) || "PRIVATE",
    ownerUserId: zi(e.owner_user_id),
    ownerEmail: zi(e.owner_email),
    teamId: zi(e.team_id),
    avatarUrl: zi(e.avatar_url),
    customFields: Array.isArray(e.custom_fields) ? e.custom_fields.map(_Ce).filter((n) => n !== null) : []
  };
}
function MCe(i) {
  const e = cu(i) || {};
  return {
    rows: Array.isArray(e.data) ? e.data.map(SCe).filter((t) => t !== null) : [],
    nextCursor: zi(e.next_cursor),
    hasMore: !!e.has_more
  };
}
async function TCe(i) {
  var e;
  try {
    const t = cu((e = cu(await i.json())) == null ? void 0 : e.error) || {};
    return {
      code: typeof t.code == "string" ? t.code : void 0,
      message: typeof t.message == "string" ? t.message : void 0
    };
  } catch {
    return {};
  }
}
async function CCe(i, e, t) {
  let n;
  try {
    n = await t(i, { method: "GET", headers: e });
  } catch {
    return { ok: !1, reason: "network" };
  }
  if (!n.ok) {
    const { code: s, message: o } = await TCe(n);
    return { ok: !1, reason: s === "INVALID_CURSOR" ? "stale-cursor" : n.status === 401 ? "unauthorized" : n.status === 403 ? "forbidden" : "failed", ...s ? { code: s } : {}, message: o || "HTTP " + n.status };
  }
  try {
    return { ok: !0, body: await n.json() };
  } catch {
    return { ok: !1, reason: "failed", message: "Invalid JSON" };
  }
}
async function ICe(i, e, t, n = window.fetch.bind(window)) {
  const s = kCe(t).toString(), o = i.replace(/\/$/, "") + vCe + (s ? "?" + s : ""), r = await CCe(o, { Authorization: "Bearer " + e.idToken, "X-Device-Id": e.deviceId }, n);
  return r.ok ? { ok: !0, page: MCe(r.body) } : r;
}
const ACe = {
  key: 0,
  class: "cv-root bd-root"
}, PCe = { class: "bd-center" }, ECe = {
  class: "bd-error-card",
  "data-testid": "board-error"
}, RCe = { style: { "margin-bottom": "16px" } }, zCe = { class: "bd-error-actions" }, $Ce = {
  key: 0,
  class: "bd-root bd-splash",
  "data-testid": "board-opening"
}, jA = /* @__PURE__ */ Pe({
  __name: "BoardApp",
  props: {
    env: {}
  },
  setup(i) {
    const t = i.env, n = /* @__PURE__ */ qe(null);
    let s = null;
    function o() {
      s && s(), s = null;
      const l = n.value;
      l && (l.feedback && l.feedback.dispose(), l.dispose(), n.value = null, t.onController && t.onController(null));
    }
    function r(l) {
      if (o(), !l) return;
      const d = t.servicesFor ? t.servicesFor(l) : null;
      let c = null;
      const h = () => c ? { title: c.meta.title, teamId: c.meta.teamId, ownerId: c.meta.ownerId, accessLevel: c.meta.accessLevel } : { title: "", teamId: null, ownerId: "", accessLevel: null }, f = t.commentsFor ? t.commentsFor(l, h) : null, p = t.initialComment || null;
      t.initialComment = null;
      const y = t.linkedFrom && t.linkedFrom.id !== l ? t.linkedFrom : null;
      t.linkedFrom = null;
      const v = new Pf({
        boardId: l,
        sync: t.directory.open(l),
        user: t.user,
        catalog: t.catalog,
        gen: d ? d.gen : t.gen,
        runs: d ? d.runs : null,
        prompts: d ? d.prompts : null,
        favorites: d ? d.favorites : null,
        pins: d ? d.pins : null,
        models: d ? d.models : null,
        balance: d ? d.balance : null,
        teamStatus: d ? d.teamStatus : null,
        library: d ? d.library : t.library || null,
        companyTools: d ? d.companyTools : null,
        featured: d ? d.featured : t.featured || null,
        myPrompts: d ? d.myPrompts : t.myPrompts || null,
        labels: t.labels,
        onGetTokens: t.getTokens,
        canBuyTokens: t.canBuyTokens,
        onOpenTour: t.openTour ? () => t.openTour(l) : void 0,
        track: t.track,
        storageUrl: t.storageUrl,
        studio: { ...t.studio || {}, ...d ? { annotate: d.annotate } : {} },
        initialCamera: t.initialCamera,
        onCameraSettled: t.onCameraSettled,
        initialStudio: t.initialStudio,
        onStudio: t.onStudio,
        onTitle: t.onTitle,
        comments: f ? {
          store: f,
          linkFor: t.commentLink,
          openAt: (w, S) => {
            t.initialComment = S, t.openBoard(w);
          },
          initial: p,
          onShown: t.clearCommentLink
        } : null,
        agent: t.agent || null,
        boardLinks: {
          // the boards list's listing, which the server keeps to what you may open (R1); the harness lists its own
          list: async (w, S) => {
            const M = t.boardsApi;
            if (M) {
              const T = await M.credentials();
              if (!T) return [];
              const k = await ICe(M.baseUrl, T, {
                teamId: w,
                view: "all",
                cursor: null,
                limit: 100,
                customFieldKey: null,
                q: S || null,
                ownerUserIds: [],
                accessLevel: null
              });
              if (!k.ok)
                throw k.code && M.onRejected && M.onRejected(k.code), new Error(k.message || k.reason);
              return k.page.rows.map((P) => ({ id: P.id, title: P.title || "Untitled board", at: P.created ? Date.parse(P.created) : null }));
            }
            const _ = S.toLowerCase();
            return (await t.directory.list()).filter((T) => (T.teamId || null) === (w || null) && (!_ || (T.title || "").toLowerCase().includes(_))).map((T) => ({ id: T.id, title: T.title || "Untitled board", at: T.updatedAt || T.createdAt || null }));
          },
          get: async (w) => {
            const S = t.directory.get ? await t.directory.get(w) : (await t.directory.list()).find((M) => M.id === w) || null;
            return S ? { id: S.id, title: S.title || "Untitled board" } : null;
          },
          create: async (w) => {
            const S = await t.directory.create(w);
            return { id: S.id, title: S.title || w };
          },
          open: (w, S) => {
            t.linkedFrom = S, t.openBoard(w);
          }
        },
        linkedFrom: y
      });
      c = v, v.uploader = t.uploaderFor ? t.uploaderFor(l) : null;
      const x = t.feedback;
      x && (v.feedback = new T4e({ board: v, recorder: x.recorder, sink: x.sink, build: x.build }), s = t_e(x.recorder, v)), v.ui.showStats = T1, n.value = v, t.onController && t.onController(v), v.load(), t.initialCamera = null, t.initialStudio = null;
    }
    Ae(() => t.ready.value ? t.boardId.value : void 0, (l) => {
      l !== void 0 && r(l);
    }, { immediate: !0 }), We(() => {
      n.value ? o() : t.onController && t.onController(null);
    });
    const a = I(() => !t.ready.value || !!n.value && !n.value.loadError.value && !n.value.loaded.value);
    return (l, d) => (g(), b(j, null, [
      m(t).ready.value && n.value ? (g(), b(j, { key: 0 }, [
        n.value.loadError.value ? (g(), b("div", ACe, [
          u("div", PCe, [
            u("div", ECe, [
              u("b", null, E(n.value.loadErrorKind.value === "not-canvas" ? "This board opens in Boards" : "This board couldn't be opened"), 1),
              u("div", RCe, E(n.value.loadError.value), 1),
              u("div", zCe, [
                n.value.loadErrorKind.value === "not-canvas" && m(t).openRunnit ? (g(), b("button", {
                  key: 0,
                  class: "bd-btn",
                  "data-testid": "open-in-boards",
                  onClick: d[0] || (d[0] = (c) => m(t).openRunnit(n.value.meta.id))
                }, " Open in Boards ")) : z("", !0),
                u("button", {
                  class: "bd-btn is-ghost",
                  onClick: d[1] || (d[1] = (c) => m(t).openBoard(null))
                }, "Back to boards")
              ])
            ])
          ])
        ])) : n.value.loaded.value ? (g(), Ce(rTe, {
          key: n.value.meta.id,
          board: n.value,
          "on-home": m(t).home,
          "on-index": () => m(t).openBoard(null)
        }, AE({ _: 2 }, [
          m(t).stress ? {
            name: "hud",
            fn: Xe(() => [
              C(bCe, {
                board: n.value,
                stress: m(t).stress
              }, null, 8, ["board", "stress"])
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["board", "on-home", "on-index"])) : z("", !0)
      ], 64)) : z("", !0),
      C(vt, { name: "bd-splash" }, {
        default: Xe(() => [
          a.value ? (g(), b("div", $Ce, [
            C(FA)
          ])) : z("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), DCe = '.bd-root{--steel-pink-300: #812686;--steel-pink-500: #c750ce;--amethyst-300: #5722a2;--amethyst-400: #7532d3;--amethyst-500: #9968df;--amethyst-600: #ae86e5;--amethyst-700: #c2a4ec;--amethyst-800: #d6c2f2;--vista-blue-300: #1822dc;--vista-blue-400: #5a61ed;--vista-blue-500: #a3a7f5;--vista-blue-600: #b6b9f7;--bg-deep: #04030c;--bg-base: #070910;--bg-raised: #0b0d14;--bg-surface: #121521;--bg-overlay: rgba(4, 3, 12, .86);--hairline: rgba(255, 255, 255, .1);--hairline-soft: rgba(255, 255, 255, .06);--inset-highlight: inset 0 1px 0 rgba(255, 255, 255, .08);--fg-1: #ffffff;--fg-2: rgba(255, 255, 255, .72);--fg-3: rgba(255, 255, 255, .58);--fg-4: rgba(255, 255, 255, .38);--fg-5: rgba(255, 255, 255, .25);--success: #37d399;--warning: #ffb347;--danger: #ff5c7a;--grad-cta: linear-gradient(90deg, var(--amethyst-500) 0%, #8f72ff 50%, var(--vista-blue-400) 100%);--grad-glass: linear-gradient(180deg, rgba(255, 255, 255, .09), rgba(255, 255, 255, .03));--grad-purple-pink: linear-gradient(90deg, var(--steel-pink-500), var(--amethyst-500), var(--vista-blue-500));--shadow-card: 0 18px 60px rgba(5, 8, 20, .28);--shadow-deep: 0 30px 100px rgba(2, 6, 23, .55);--radius-xs: 6px;--radius-sm: 10px;--radius-md: 16px;--radius-lg: 24px;--radius-pill: 999px;--font-sans: "SpaceGrotesk", "Space Grotesk", system-ui, -apple-system, "Segoe UI", sans-serif;--ease-out-soft: cubic-bezier(.16, 1, .3, 1);--dur-fast: .2s;--dur-med: .3s;--dur-slow: .5s}.bd-root,.bd-root *,.bd-root *:before,.bd-root *:after{box-sizing:border-box;background-repeat:repeat}.bd-root{font-family:var(--font-sans);font-size:14px;line-height:normal;color:var(--fg-2);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility}.bd-root button,.bd-root input,.bd-root textarea{font-family:var(--font-sans);letter-spacing:inherit}:where(.bd-root) button,:where(.bd-root) input,:where(.bd-root) textarea{margin:0}.bd-root button{-webkit-tap-highlight-color:transparent}.bd-root button:focus{outline:none}.bd-root button:focus-visible{outline:2px solid rgba(163,167,245,.7);outline-offset:2px}.bd-root p{margin:0}', OCe = `.cv-root{--cv-accent: var(--amethyst-500);--cv-accent-strong: var(--amethyst-400);--cv-accent-soft: rgba(153, 104, 223, .4);--cv-accent-tint: rgba(153, 104, 223, .14);--cv-accent-text: var(--amethyst-700);--cv-guide: var(--amethyst-600);--cv-guide-halo: rgba(4, 3, 12, .35);--cv-glass-a: 1;--cv-blur: 24px;--cv-atmo: 1;--cv-zoom: 1;--cv-inv-zoom: 1;position:fixed;inset:0;overflow:hidden;overflow:clip;background:var(--bg-deep);user-select:none;-webkit-user-select:none;touch-action:none;overscroll-behavior:none;z-index:200}.licon{display:inline-flex;align-items:center;justify-content:center;line-height:0;flex:none}.licon svg{display:block}.licon-spin svg{animation:cvSpin .9s linear infinite}@keyframes cvSpin{to{transform:rotate(360deg)}}.cv-atmo{position:absolute;inset:0;pointer-events:none}.cv-atmo-glow{position:absolute;inset:0;background:radial-gradient(56% 42% at 50% -6%,rgba(255,255,255,.075),transparent 60%),linear-gradient(115deg,#9968df21,#04030c00 30%,#a3a7f51a 68%,#04030c00 90%);opacity:var(--cv-atmo)}.cv-atmo-orb-a,.cv-atmo-orb-b{position:absolute;width:560px;height:560px;border-radius:50%;filter:blur(160px);opacity:calc(.16 * var(--cv-atmo));transform:translateZ(0)}.cv-atmo-orb-a{left:-220px;top:-180px;background:var(--amethyst-500)}.cv-atmo-orb-b{right:-200px;top:-120px;background:var(--vista-blue-400);opacity:calc(.11 * var(--cv-atmo))}.cv-grid{position:absolute;inset:0;pointer-events:none;background-image:radial-gradient(rgba(255,255,255,.85) 1.15px,transparent 1.6px);opacity:calc(.26 * var(--cv-atmo));transition:opacity var(--dur-med) var(--ease-out-soft)}.v2-root.no-grid .cv-grid{opacity:0}.cv-stage{position:absolute;inset:0;overflow:hidden;overflow:clip;cursor:default;outline:none}.cv-stage.is-hand{cursor:grab}.cv-stage.is-dropper{--dropper-cursor: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke-linecap='round' stroke-linejoin='round'><g stroke='%23070910' stroke-width='4'><path d='m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12'/><path d='m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z'/><path d='m2 22 .414-.414'/></g><g stroke='white' stroke-width='2'><path d='m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12'/><path d='m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z'/><path d='m2 22 .414-.414'/></g></svg>") 2 22, crosshair;cursor:var(--dropper-cursor)}.cv-stage.is-dropper .cv-el,.cv-stage.is-dropper .cv-el *{cursor:grab}.cv-stage.is-dropper .cv-el .cv-thumb-pull{cursor:var(--dropper-cursor)}.cv-stage.is-panning,.cv-stage.is-panning *{cursor:grabbing!important}.bd-canvas{position:absolute;left:0;top:0;display:block}.cv-world{position:absolute;left:0;top:0;width:0;height:0;transform-origin:0 0;pointer-events:none}.cv-world.is-moving{will-change:transform}.cv-el{position:absolute;pointer-events:auto}.cv-el-body{position:relative;width:100%;height:100%;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-med) var(--ease-out-soft)}.cv-el.is-dragging .cv-el-body{transition:none}@media(prefers-reduced-motion:no-preference){.cv-el.cv-enter{animation:cvEnter .65s var(--ease-out-soft) both;animation-delay:var(--d, 0s)}@keyframes cvEnter{0%{opacity:0;transform:translateY(34px)}to{opacity:1;transform:translateY(0)}}}.cv-ring{position:absolute;inset:calc(-3px * var(--cv-inv-zoom));border-radius:inherit;pointer-events:none;border:calc(1.5px * var(--cv-inv-zoom)) solid var(--cv-accent);box-shadow:0 0 0 calc(4px * var(--cv-inv-zoom)) var(--cv-accent-tint);opacity:0;transition:opacity var(--dur-fast)}.is-selected>.cv-el-body>*>.cv-ring,.is-selected .cv-bucket>.cv-ring,.is-selected .cv-note>.cv-ring{opacity:1}.cv-bucket{width:100%;border-radius:var(--radius-md);background:linear-gradient(180deg,rgba(255,255,255,calc(.09 * var(--cv-glass-a))),rgba(255,255,255,calc(.03 * var(--cv-glass-a))));border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-card);backdrop-filter:blur(var(--cv-blur));-webkit-backdrop-filter:blur(var(--cv-blur));padding:14px;cursor:pointer;position:relative;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-med) var(--ease-out-soft)}.cv-world.is-moving .cv-bucket,.cv-world.is-crowded .cv-bucket{backdrop-filter:none;-webkit-backdrop-filter:none}.cv-el:hover .cv-bucket{transform:translateY(-4px);box-shadow:var(--inset-highlight),0 24px 70px #05081461}.cv-el.is-dragging .cv-bucket,.cv-el.is-open .cv-bucket{transform:none}.cv-bucket .cv-ring{border-radius:var(--radius-md)}.cv-el.is-stack-top:before,.cv-el.is-stack-deep:after{content:"";position:absolute;inset:0;z-index:-1;pointer-events:none;border-radius:var(--radius-md);background:linear-gradient(180deg,#282a3cf5,#161824f5);border:1px solid rgba(255,255,255,.14);box-shadow:0 10px 26px #04061073;transform:translate(7px,8px);transition:transform var(--dur-med) var(--ease-out-soft)}.cv-el.is-stack-deep:after{z-index:-2;transform:translate(14px,16px);opacity:.7}.cv-el.is-stack-top:hover:before{transform:translate(9px,11px)}.cv-el.is-stack-deep:hover:after{transform:translate(18px,22px)}.cv-stack-badge{position:absolute;top:-11px;right:-11px;z-index:3;display:inline-flex;align-items:center;gap:4px;height:22px;padding:0 8px 0 7px;border-radius:999px;border:1px solid rgba(214,194,242,.45);background:linear-gradient(180deg,#7e56d0f5,#5c4cd6f5);color:#fff;font:600 11px/1 var(--font-sans);font-variant-numeric:tabular-nums;box-shadow:0 4px 14px #543cc873,inset 0 1px #ffffff40;cursor:pointer;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.cv-stack-badge:hover,.cv-stack-badge.is-open{transform:scale(1.08);box-shadow:0 6px 18px #543cc899,0 0 0 3px var(--cv-accent-tint),inset 0 1px #ffffff40}.cv-fan{position:fixed;z-index:62;display:flex;gap:10px;align-items:flex-end;pointer-events:auto}.cv-fan.is-below{align-items:flex-start}.cv-fan-card{position:relative;flex:none;width:168px;padding:0;overflow:hidden;display:flex;flex-direction:column;text-align:left;border-radius:13px;border:1px solid var(--hairline);background:#0e101af7;color:var(--fg-1);cursor:pointer;box-shadow:var(--inset-highlight),0 18px 46px #02040c99;transform:var(--tilt);transition:transform var(--dur-med) var(--ease-out-soft),border-color var(--dur-fast),box-shadow var(--dur-med);animation:fanIn .38s var(--ease-out-soft) both;animation-delay:calc(var(--i) * 45ms)}.cv-fan-card:hover{transform:translateY(-6px) scale(1.03);border-color:#c2a4ec8c;box-shadow:var(--inset-highlight),0 22px 56px #02040cb3,0 0 0 3px var(--cv-accent-tint);z-index:1}.cv-fan-card .pic{display:flex;align-items:center;justify-content:center;height:76px;background:#ffffff0a center / cover no-repeat;color:var(--fg-4)}.cv-fan-card .txt{display:flex;flex-direction:column;gap:3px;padding:8px 10px 9px;min-width:0}.cv-fan-card .txt b{font-size:12px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cv-fan-card .txt small{display:flex;align-items:center;gap:4px;font-size:10.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cv-fan-card .on-top{position:absolute;top:7px;left:7px;height:18px;padding:0 7px;border-radius:999px;display:inline-flex;align-items:center;background:#080910c7;color:var(--fg-2);font-size:9.5px;font-weight:600;letter-spacing:.02em;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px)}@keyframes fanIn{0%{opacity:0;transform:translateY(26px) scale(.86)}}.cv-fan.is-below .cv-fan-card{animation-name:fanInBelow}@keyframes fanInBelow{0%{opacity:0;transform:translateY(-26px) scale(.86)}}.cv-fan-leave-active{transition:opacity .18s ease,transform .18s ease}.cv-fan-leave-to{opacity:0;transform:translateY(10px) scale(.97)}@media(prefers-reduced-motion:reduce){.cv-fan-card{animation:none}}.cv-el.is-ref-target .cv-bucket{box-shadow:var(--inset-highlight),0 0 0 1px var(--cv-accent-soft),0 18px 54px #9968df4d}.cv-el.is-ref-target .cv-bucket>.cv-ring{opacity:1}.cv-bucket-head{display:flex;align-items:center;gap:10px}.cv-badge{width:36px;height:36px;flex:none;border-radius:12px;background:#ffffff0f;box-shadow:inset 0 1px #ffffff14;display:flex;align-items:center;justify-content:center;color:var(--cv-accent-text)}.cv-bucket-titles{min-width:0;flex:1}.cv-bucket-kind{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-4);white-space:nowrap;display:flex;align-items:baseline;min-width:0}.cv-bucket-sep{margin:0 6px;color:var(--fg-5);letter-spacing:0}.cv-bucket-model{min-width:0;overflow:hidden;text-overflow:ellipsis;font-size:10px;font-weight:500;text-transform:none;letter-spacing:.01em;color:var(--fg-5)}.cv-bucket-name{font-size:14.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:1px}.cv-bucket-name-input{width:100%;font-size:14.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;background:#ffffff0f;border:1px solid var(--cv-accent-soft);border-radius:6px;padding:0 5px;margin:0 0 0 -6px;outline:none;height:21px;user-select:text;-webkit-user-select:text}.cv-count{flex:none;font-size:11px;font-weight:600;color:var(--fg-3);background:#ffffff0d;border:1px solid var(--hairline-soft);border-radius:var(--radius-pill);padding:3px 9px;font-variant-numeric:tabular-nums}.cv-fold{flex:none;width:26px;height:26px;margin:0 -4px 0 -2px;padding:0;border:0;border-radius:8px;display:inline-flex;align-items:center;justify-content:center;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),color var(--dur-fast),background var(--dur-fast)}.cv-el:hover .cv-fold,.cv-el.is-selected .cv-fold,.cv-el.is-folded .cv-fold,.cv-fold:focus-visible{opacity:1}.cv-fold:hover{color:var(--fg-1);background:#ffffff12}.cv-fold:disabled{display:none}.cv-el.is-folded .cv-bucket{height:100%;padding-top:13px;padding-bottom:13px}.cv-count.is-state{display:inline-flex;align-items:center;justify-content:center;min-width:30px;padding:3px 8px}.cv-count.is-state.is-error{color:#ff8aa0}.cv-count.is-state .ch-pulse{margin:0}.cv-bucket-thumbs{display:flex;gap:6px;margin-top:12px}.cv-bucket-thumbs .cv-thumb{flex:1;aspect-ratio:1}.cv-bucket-thumbs .cv-thumb-empty{flex:1;aspect-ratio:1;border-radius:8px;border:1px dashed rgba(255,255,255,.1);background:#ffffff05}.cv-thumb{border-radius:8px;min-width:0;border:1px solid rgba(255,255,255,.07);box-shadow:inset 0 1px #ffffff0f;background-color:#ffffff0a;background-size:cover;background-position:center}.cv-thumb-pull{cursor:grab;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast),border-color var(--dur-fast)}.cv-thumb-pull:hover{transform:translateY(-2px) scale(1.03);box-shadow:inset 0 1px #ffffff1a,0 10px 26px #05081473;border-color:var(--cv-accent-soft)}.cv-thumb-pull:active{cursor:grabbing}@media(prefers-reduced-motion:no-preference){.cv-thumb.thumb-new{animation:thumbIn .55s var(--ease-out-soft) both;animation-delay:var(--d, 0s)}@keyframes thumbIn{0%{opacity:0;transform:scale(.82)}to{opacity:1;transform:scale(1)}}}.cv-thumb.thumb-shimmer,.cv-thumb-empty.thumb-shimmer{position:relative;overflow:hidden}.cv-thumb.thumb-shimmer:after,.cv-thumb-empty.thumb-shimmer:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}@keyframes shimmer{0%{transform:translate(-100%)}to{transform:translate(100%)}}.cv-bucket-foot{display:flex;align-items:center;justify-content:space-between;margin-top:11px;font-size:11px;color:var(--fg-4)}.cv-bucket-foot .is-error{color:#ff8aa0;display:inline-flex;align-items:center;gap:5px}.cv-bucket-open-hint{display:inline-flex;align-items:center;gap:5px;margin:-3px -6px;padding:3px 6px;border:0;border-radius:7px;background:transparent;color:var(--fg-4);font:inherit;cursor:pointer;opacity:0;transition:opacity var(--dur-fast),color var(--dur-fast),background var(--dur-fast)}.cv-el:hover .cv-bucket-open-hint{opacity:1}.cv-bucket-open-hint:hover,.cv-bucket-open-hint:focus-visible{color:var(--fg-1);background:#ffffff12;opacity:1}.cv-thumb-empty.is-open{cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.cv-thumb-empty.is-open:hover{background:#ffffff0d;border-color:#ffffff29}.cv-note{width:100%;height:100%;border-radius:var(--radius-md);padding:16px;display:flex;flex-direction:column;backdrop-filter:blur(var(--cv-blur));-webkit-backdrop-filter:blur(var(--cv-blur));cursor:grab;position:relative;box-shadow:inset 0 1px #ffffff1a,var(--shadow-card);transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-med) var(--ease-out-soft)}.cv-world.is-moving .cv-note,.cv-world.is-crowded .cv-note{backdrop-filter:none;-webkit-backdrop-filter:none}.cv-el.is-dragging .cv-note{cursor:grabbing}.cv-el:hover .cv-note{transform:translateY(-4px)}.cv-el.is-dragging .cv-note,.cv-el.is-selected .cv-note,.cv-note.is-editing{transform:none}.cv-note .cv-ring{border-radius:var(--radius-md)}.cv-note.tint-amethyst{background:linear-gradient(180deg,#9968df2b,#9968df14);border:1px solid rgba(194,164,236,.22)}.cv-note.tint-vista{background:linear-gradient(180deg,#5a61ed2b,#5a61ed14);border:1px solid rgba(163,167,245,.22)}.cv-note.tint-sky{background:linear-gradient(180deg,#3db4e62b,#3db4e614);border:1px solid rgba(153,217,243,.22)}.cv-note.tint-mint{background:linear-gradient(180deg,#34c79a2b,#34c79a14);border:1px solid rgba(143,229,201,.22)}.cv-note.tint-amber{background:linear-gradient(180deg,#f0b44a2b,#f0b44a14);border:1px solid rgba(247,212,143,.22)}.cv-note.tint-rose{background:linear-gradient(180deg,#ec5b9a2b,#ec5b9a14);border:1px solid rgba(245,163,199,.22)}.cv-note.tint-glass{background:var(--grad-glass);border:1px solid var(--hairline)}.cv-note-text{flex:1;min-height:0;font-size:13.5px;line-height:1.45;color:#ffffffdb;letter-spacing:-.005em;outline:none;overflow-x:hidden;overflow-y:auto;word-wrap:break-word;white-space:pre-wrap;scrollbar-width:none;overscroll-behavior:contain}.cv-note-text::-webkit-scrollbar{display:none}.cv-note.more-below .cv-note-text{-webkit-mask-image:linear-gradient(180deg,#000 calc(100% - 28px),transparent);mask-image:linear-gradient(180deg,#000 calc(100% - 28px),transparent)}.cv-note.more-above .cv-note-text{-webkit-mask-image:linear-gradient(0deg,#000 calc(100% - 28px),transparent);mask-image:linear-gradient(0deg,#000 calc(100% - 28px),transparent)}.cv-note.more-above.more-below .cv-note-text{-webkit-mask-image:linear-gradient(180deg,transparent,#000 28px,#000 calc(100% - 28px),transparent);mask-image:linear-gradient(180deg,transparent,#000 28px,#000 calc(100% - 28px),transparent)}.cv-note.is-editing .cv-note-text{cursor:text;user-select:text;-webkit-user-select:text}.cv-note-meta{font-size:10px;color:#ffffff61;font-weight:600;letter-spacing:.16em;text-transform:uppercase;margin-top:8px}.cv-link{padding:14px 16px;gap:6px;cursor:pointer}.cv-link-head{display:flex;align-items:center;gap:7px}.cv-link-head .ic{width:22px;height:22px;border-radius:7px;display:inline-flex;align-items:center;justify-content:center;background:#ffffff14;color:#c9ccfa}.cv-link-head .kind{font-size:9.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:#ffffff80}.cv-link-title{flex:1;min-height:0;font-size:16px;font-weight:600;line-height:1.3;letter-spacing:-.01em;color:#fff;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.cv-link-foot{display:flex;align-items:center;justify-content:flex-end;min-height:24px}.cv-link-open{display:inline-flex;align-items:center;gap:5px;height:26px;padding:0 10px;border:0;border-radius:8px;background:#ffffff1a;color:#fff;font:inherit;font-size:11.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast)}.cv-link-open:hover{background:#ffffff2e}.cv-link .miss{font-size:11px;color:#ffb3c1}.cv-link.is-missing .cv-link-title{color:#ffffff8c;text-decoration:line-through;text-decoration-color:#ffffff4d}.cv-frame-title{position:absolute;left:0;bottom:0;padding:0 0 9px 4px;max-width:calc(100% * var(--cv-zoom));transform:scale(var(--cv-inv-zoom));transform-origin:0 100%;display:flex;align-items:center;gap:10px;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-4);white-space:nowrap;cursor:grab;outline:none;pointer-events:auto}.cv-frame-title .cv-frame-name{min-width:0;overflow:hidden;text-overflow:ellipsis}.cv-frame-title .cv-frame-count{flex:none}.cv-world.is-far .cv-frame-count{display:none}.cv-world.is-far .cv-frame-title{left:8px;padding:3px 8px 3px 9px;font-size:9.5px;letter-spacing:.18em;color:var(--fg-2);max-width:calc(100% * var(--cv-zoom) - 16px);transform:scale(var(--cv-inv-zoom)) translateY(50%);background:#0d0c1ae0;border:1px solid rgba(255,255,255,.09);border-radius:7px;box-shadow:0 4px 14px #00000059}.light-canvas .cv-world.is-far .cv-frame-title{background:#fffffff0;border-color:#1318281a;color:#131828b3;box-shadow:0 4px 14px #13182814}.cv-frame-title .cv-frame-count{letter-spacing:.06em;color:var(--fg-5);text-transform:none;font-weight:500}.cv-frame-title.is-selected{color:var(--cv-accent-text)}.cv-frame-title.is-locked{cursor:default}.cv-frame-title .cv-frame-lock{flex:none;display:inline-flex;margin-right:-4px;color:var(--fg-3)}.cv-frame-title.is-selected .cv-frame-lock{color:inherit}.cv-frame-title-input{font:inherit;letter-spacing:.22em;text-transform:uppercase;color:var(--fg-1);background:#ffffff0f;border:1px solid var(--cv-accent-soft);border-radius:6px;padding:1px 6px;margin:-2px 0 0 -7px;outline:none;min-width:120px;user-select:text;-webkit-user-select:text}.cv-resize{position:absolute;right:calc(-6px * var(--cv-inv-zoom));bottom:calc(-6px * var(--cv-inv-zoom));width:calc(15px * var(--cv-inv-zoom));height:calc(15px * var(--cv-inv-zoom));border-radius:calc(5px * var(--cv-inv-zoom));background:var(--cv-accent);border:calc(2px * var(--cv-inv-zoom)) solid var(--bg-deep);box-shadow:0 0 0 calc(3px * var(--cv-inv-zoom)) var(--cv-accent-tint);cursor:nwse-resize;z-index:7;pointer-events:auto;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cv-resize:hover{transform:scale(1.15)}.cv-marquee{position:absolute;pointer-events:none;border:1px solid var(--cv-accent-soft);background:var(--cv-accent-tint);border-radius:4px}.cv-guides{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;overflow:visible}.cv-guides path{fill:none;stroke-width:1px}.cv-guide-line{stroke:var(--cv-guide);stroke-dasharray:4 4}.cv-guide-gap{stroke:var(--cv-guide)}.cv-guide-halo{stroke:var(--cv-guide-halo);stroke-width:3px!important}.cv-guide-halo.is-dashed{stroke-dasharray:4 4}.cv-vid{position:absolute;pointer-events:none;border-radius:12px;overflow:hidden;opacity:0;transition:opacity .22s var(--ease-out-soft),top .2s var(--ease-out-soft)}.cv-vid.is-shown{opacity:1}.cv-vid video{display:block;width:100%;height:100%;object-fit:cover}.cv-vid-bar{position:absolute;left:0;right:0;bottom:0;height:calc(2px * var(--cv-inv-zoom));background:#ffffff29}.cv-vid-bar i{display:block;height:100%;transform-origin:0 50%;transform:scaleX(0);background:linear-gradient(90deg,var(--amethyst-600),var(--vista-blue-500))}.cv-dropper-ring{position:absolute;pointer-events:none;border-radius:12px;box-shadow:0 0 0 calc(2px * var(--cv-inv-zoom)) var(--amethyst-500),0 0 0 calc(6px * var(--cv-inv-zoom)) #9968df38;animation:cvFade var(--dur-fast) ease both}.cv-dropper-ring.is-in{box-shadow:0 0 0 calc(2px * var(--cv-inv-zoom)) #ffffff8c}.cv-dropper-chip{position:absolute;left:0;top:0;transform-origin:0 0;transform:translate(calc(8px * var(--cv-inv-zoom)),calc(8px * var(--cv-inv-zoom))) scale(var(--cv-inv-zoom));display:inline-flex;align-items:center;gap:5px;padding:3px 9px 3px 7px;border-radius:999px;background:#04030ccc;color:#fff;font-size:11px;font-weight:600;white-space:nowrap;box-shadow:0 4px 14px #02040c73}.cv-img-hover{position:absolute;pointer-events:none;border-radius:12px;overflow:hidden;transition:transform var(--dur-fast) var(--ease-out-soft)}.cv-img-shade{position:absolute;left:0;right:0;bottom:0;height:46%;background:linear-gradient(180deg,#04030c00,#04030c8c);pointer-events:none;animation:cvFade var(--dur-fast) ease both}.cv-img-foot{position:absolute;left:12px;bottom:9px;right:9px;display:flex;align-items:center;gap:8px;pointer-events:none}.cv-img-label{flex:1;min-width:0;font-size:11px;font-weight:500;color:#ffffffc7;letter-spacing:.01em;pointer-events:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;animation:cvFade var(--dur-fast) ease both}.cv-img-model{flex:none;max-width:60%;padding:2px 8px;border-radius:var(--radius-pill);background:#0c0e1894;border:1px solid rgba(255,255,255,.12);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);font-size:10.5px;font-weight:600;color:#ffffffe6;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;animation:cvFade var(--dur-fast) ease both}.cv-img-actions{position:absolute;top:8px;right:8px;display:flex;gap:4px;pointer-events:auto;animation:cvFade var(--dur-fast) ease both}@keyframes cvFade{0%{opacity:0}to{opacity:1}}.cv-img-hint{--s: var(--cv-inv-zoom);flex:none;display:inline-flex;align-items:center;gap:calc(6px * var(--s));padding:calc(3px * var(--s)) calc(9px * var(--s)) calc(3px * var(--s)) calc(3px * var(--s));border-radius:var(--radius-pill);background:#0c0e189e;border:calc(1px * var(--s)) solid rgba(255,255,255,.1);backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);font-size:calc(10.5px * var(--s));font-weight:500;color:#fffc;white-space:nowrap;animation:cvFade .3s ease .7s both}.cv-img-hint kbd{display:inline-flex;align-items:center;justify-content:center;min-width:calc(18px * var(--s));height:calc(17px * var(--s));padding:0 calc(5px * var(--s));border-radius:999px;background:#ffffff1f;color:#fff;font-family:var(--font-sans);font-size:calc(10px * var(--s));font-weight:600;line-height:1}.cv-img-actions button{width:26px;height:26px;border:1px solid rgba(255,255,255,.1);border-radius:8px;background:#0c0e189e;backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);color:#ffffffb8;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;transition:background var(--dur-fast),color var(--dur-fast)}.cv-img-actions button:hover{background:#141624d9;color:#fff}.cv-img-badges{position:absolute;pointer-events:none}.cv-img-vid{position:absolute;left:10px;top:10px;display:inline-flex;align-items:center;gap:5px;padding:4px 9px;border-radius:var(--radius-pill);background:#04030c94;border:1px solid rgba(255,255,255,.12);font-size:10px;font-weight:600;color:#ffffffd1;font-variant-numeric:tabular-nums}.cv-img-fav{position:absolute;top:8px;left:8px;width:20px;height:20px;display:inline-flex;align-items:center;justify-content:center;border-radius:999px;background:#04030c9e;color:#ef5f7a}.cv-img-vid+.cv-img-fav{left:auto;right:8px}.cv-img-fav svg{fill:currentColor}.cv-img-missing{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:6px;color:var(--fg-4);font-size:11px;pointer-events:none}.cv-topbar{position:absolute;top:0;left:0;right:0;height:60px;z-index:48;display:flex;align-items:center;gap:16px;padding:0 18px;background:#0709109e;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);border-bottom:1px solid var(--hairline-soft)}.cv-topbar-left{display:flex;align-items:center;gap:12px;flex:1;min-width:0}.cv-topbar-right{display:flex;align-items:center;gap:14px;flex:1;justify-content:flex-end}.cv-mark{width:34px;height:30px;border-radius:9px;flex:none;display:flex;align-items:center;justify-content:center;background:none;border:0;cursor:pointer;padding:0;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-med)}.cv-mark svg{display:block;width:28px;height:auto}.cv-mark:hover{transform:scale(1.06);filter:drop-shadow(0 4px 12px rgba(153,104,223,.45))}.cv-mark:focus-visible{outline:none;box-shadow:0 0 0 1px #04030ca6,0 0 0 3px #a3a7f58c}.cv-crumb{font-size:12.5px;color:var(--fg-4);white-space:nowrap;background:none;border:0;padding:0;cursor:pointer;transition:color var(--dur-fast)}.cv-crumb:hover{color:var(--fg-2)}.cv-crumb-sep{color:var(--fg-5);margin:0 -4px}.cv-board-title{font-size:14.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0;padding:3px 6px;margin:0 -6px;border-radius:7px;cursor:text;transition:background var(--dur-fast)}.cv-board-title:hover{background:#ffffff0d}.cv-board-title-input{font:inherit;font-size:13.5px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1);background:#ffffff0f;border:1px solid var(--cv-accent-soft);border-radius:7px;padding:3px 6px;margin:0 -6px;outline:none;min-width:220px;user-select:text;-webkit-user-select:text}.cv-tokens{display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 10px;border:1px solid var(--hairline-soft);border-radius:999px;background:#ffffff08;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;white-space:nowrap;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.cv-tokens .licon{color:var(--fg-4)}.cv-tokens.is-link{cursor:pointer}.cv-tokens.is-link:hover{background:#ffffff12;color:var(--fg-1)}.cv-tokens.is-empty{color:#ffb38a;border-color:#ff8c5a59}.cv-tokens.is-empty .licon{color:#ffb38a}.cv-save-state{display:inline-flex;align-items:center;gap:6px;font-size:11px;color:var(--fg-5);white-space:nowrap;transition:color var(--dur-med)}.cv-save-state .dot{width:6px;height:6px;border-radius:50%;background:var(--fg-5);transition:background var(--dur-med)}.cv-save-state.is-saving .dot{background:var(--warning);animation:syPulse 1.1s ease-in-out infinite}.cv-save-state.is-error{color:#ff8aa0}.cv-save-state.is-error .dot{background:var(--danger)}@keyframes syPulse{0%,to{opacity:1}50%{opacity:.35}}.cv-tool{width:32px;height:32px;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;position:relative;padding:0;transition:background var(--dur-fast),color var(--dur-fast)}.cv-tool:hover{background:#ffffff12;color:var(--fg-1)}.cv-tool.on{background:var(--cv-accent-tint);color:var(--cv-accent-text)}.cv-tool .tip{position:absolute;bottom:calc(100% + 10px);left:50%;transform:translate(-50%) translateY(4px);background:#0b0d14eb;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:11px;font-weight:500;padding:5px 10px;border-radius:8px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cv-tool:hover .tip{opacity:1;transform:translate(-50%) translateY(0);transition-delay:.26s}.cv-tool .key{color:var(--fg-5);margin-left:6px}.cv-iconbtn{width:30px;height:30px;flex:none;display:inline-flex;align-items:center;justify-content:center;border-radius:9px;border:1px solid transparent;background:transparent;color:var(--fg-4);cursor:pointer;padding:0;transition:background var(--dur-fast),color var(--dur-fast)}.cv-iconbtn:hover{background:#ffffff12;color:var(--fg-1)}.cv-corner{position:absolute;right:18px;bottom:22px;z-index:40;display:flex;flex-direction:column;align-items:flex-end;gap:10px;transition:opacity var(--dur-med) var(--ease-out-soft),transform var(--dur-med) var(--ease-out-soft)}.cv-corner.is-away .cv-minimap{display:none}.cv-corner.is-away .cv-zoomhud{flex-direction:column;padding:4px;animation:upIn var(--dur-med) var(--ease-out-soft) both}.cv-corner.is-away .cv-zoomhud button{width:28px}.cv-corner.is-away .cv-zoomhud .pct{min-width:0;padding:0;font-size:10px;letter-spacing:-.02em}.cv-corner.is-away .cv-zoomhud .sep{width:16px;height:1px;margin:3px 0}.cv-minimap{width:188px;height:124px;border-radius:14px;overflow:hidden;background:#0b0d14b8;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-card);backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);position:relative;cursor:pointer;transform-origin:50% 50%;animation:upIn var(--dur-med) var(--ease-out-soft) both}.cv-minimap canvas{position:absolute;left:0;top:0;width:188px;height:124px;pointer-events:none}.cv-minimap .mm-view{position:absolute;border:1.5px solid var(--cv-accent);border-radius:3px;background:var(--cv-accent-tint);cursor:grab;pointer-events:none}.cv-minimap.is-going{animation:none;pointer-events:none;will-change:transform,opacity;transition:transform .46s cubic-bezier(.4,0,.2,1),opacity .46s cubic-bezier(.4,0,.2,1) .06s,border-radius .46s var(--ease-out-soft)}.mm-hide{position:absolute;top:6px;right:6px;z-index:2;width:20px;height:20px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid rgba(255,255,255,.1);border-radius:6px;background:#04030cb8;color:var(--fg-3);cursor:pointer;opacity:0;transform:translateY(-3px);transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft),color var(--dur-fast),background var(--dur-fast)}.cv-minimap:hover .mm-hide,.mm-hide:focus-visible{opacity:1;transform:none}.mm-hide:hover{background:#04030ceb;color:#fff}.cv-minimap.is-going .mm-hide{opacity:0}.cv-zoomhud{display:flex;align-items:center;gap:2px;padding:5px;border-radius:var(--radius-sm);background:#121521b8;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-card);backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px)}.cv-zoomhud button{height:28px;min-width:28px;border:0;border-radius:7px;padding:0;background:transparent;color:var(--fg-3);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cv-zoomhud button:hover{background:#ffffff12;color:var(--fg-1)}.cv-zoomhud .pct{padding:0 6px;min-width:46px}.cv-zoomhud .sep{width:1px;height:16px;margin:0 3px;background:var(--hairline-soft);flex:none}.cv-zoomhud .grid-toggle{color:var(--fg-2)}.cv-zoomhud .grid-toggle.is-off{color:var(--fg-5)}.cv-zoomhud .mm-slot:disabled{cursor:default}.cv-zoomhud .mm-slot.is-landing{animation:mmLand .5s cubic-bezier(.16,1,.3,1) .26s both}@keyframes mmLand{0%{transform:scale(.5);color:var(--fg-4)}45%{transform:scale(1.18);color:var(--cv-accent-soft)}to{transform:none;color:var(--fg-3)}}.cv-ctxbar{position:absolute;z-index:45;display:flex;align-items:center;gap:2px;padding:5px;border-radius:12px;background:#121521d1;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);white-space:nowrap}@media(prefers-reduced-motion:no-preference){.cv-ctxbar{animation:ctxIn .3s var(--ease-out-soft) both}@keyframes ctxIn{0%{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}}.cv-ctxbar .sep{width:1px;height:18px;background:var(--hairline-soft);margin:0 4px;flex:none}.cv-ctxbar button{width:30px;height:30px;border:0;border-radius:8px;padding:0;background:transparent;color:var(--fg-3);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;position:relative;transition:background var(--dur-fast),color var(--dur-fast)}.cv-ctxbar button:hover{background:#ffffff14;color:var(--fg-1)}.cv-ctxbar button.danger:hover{background:#ff5c7a24;color:var(--danger)}.cv-ctxbar .swatch{width:14px;height:14px;border-radius:5px;border:1px solid rgba(255,255,255,.25);transition:box-shadow var(--dur-fast)}.cv-ctxbar button.is-swatch{width:26px}.cv-ctxbar button.is-swatch.on .swatch{box-shadow:0 0 0 2px var(--bg-deep),0 0 0 3.5px #ffffffbf}.cv-ctxbar .swatch.tint-amethyst{background:#9968df8c}.cv-ctxbar .swatch.tint-vista{background:#5a61ed99}.cv-ctxbar .swatch.tint-sky{background:#3db4e68c}.cv-ctxbar .swatch.tint-mint{background:#34c79a8c}.cv-ctxbar .swatch.tint-amber{background:#f0b44a8c}.cv-ctxbar .swatch.tint-rose{background:#ec5b9a8c}.cv-ctxbar .swatch.tint-glass{background:#ffffff2e}.cv-ctxbar .tip{position:absolute;bottom:calc(100% + 9px);left:50%;transform:translate(-50%) translateY(4px);background:#0b0d14f0;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:11px;font-weight:500;padding:5px 9px;border-radius:8px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cv-ctxbar button:hover .tip{opacity:1;transform:translate(-50%) translateY(0);transition-delay:.26s}.cv-ctxbar button.is-rest{color:var(--fg-5);cursor:default}.cv-ctxbar button.is-rest:hover{background:transparent;color:var(--fg-4)}.cv-ctxbar .tip .why{display:block;margin-top:2px;font-weight:400;color:var(--fg-4)}.cv-ctx-edit{display:inline-flex;align-items:center;gap:6px;width:auto!important;height:30px;padding:0 11px!important;border:0;border-radius:8px;background:var(--cv-accent-tint)!important;color:var(--fg-1)!important;font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.cv-ctx-edit:hover{background:#9968df4d!important}.cv-ctx-edit .swatch{width:12px;height:12px;border-radius:4px;border:1px solid rgba(255,255,255,.3)}.cv-ctx-info{display:inline-flex;align-items:center;gap:6px;width:auto!important;height:30px;padding:0 11px!important;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.cv-ctx-info:hover{background:#ffffff14;color:var(--fg-1)}.cv-ctx-info.is-locked{color:var(--fg-2)}.cv-ctxbar button.is-more.on{background:#ffffff14;color:var(--fg-1)}.cv-addmenu{position:absolute;left:50%;bottom:88px;transform:translate(-50%);width:312px;z-index:46;border-radius:var(--radius-md);background:#121521d9;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(28px) saturate(110%);-webkit-backdrop-filter:blur(28px) saturate(110%);overflow:hidden}.am-view{will-change:transform,opacity}@media(prefers-reduced-motion:no-preference){.am-view.fwd{animation:amFwd .3s var(--ease-out-soft) both}.am-view.back{animation:amBack .3s var(--ease-out-soft) both}@keyframes amFwd{0%{opacity:0;transform:translate(28px)}to{opacity:1;transform:none}}@keyframes amBack{0%{opacity:0;transform:translate(-28px)}to{opacity:1;transform:none}}}.am-search{display:flex;align-items:center;gap:8px;margin:2px 12px 4px;padding:0 6px 0 11px;height:34px;border-radius:var(--radius-sm);background:#ffffff0b;border:1px solid var(--hairline-soft);box-shadow:inset 0 1px #ffffff0d;color:var(--fg-4);transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.am-search:focus-within{border-color:var(--cv-accent-soft);box-shadow:0 0 0 3px var(--cv-accent-tint)}.am-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;font-family:var(--font-sans);font-size:12.5px;color:var(--fg-1);user-select:text;-webkit-user-select:text}.am-search input::placeholder{color:var(--fg-4)}.am-none{padding:14px 10px 12px;font-size:12px;color:var(--fg-4)}.am-rows{padding:4px 6px 8px;max-height:348px;overflow-y:auto}.am-rows::-webkit-scrollbar{width:8px}.am-rows::-webkit-scrollbar-thumb{background:#ffffff1a;border-radius:4px;border:2px solid transparent;background-clip:content-box}.am-eyebrow{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-5);padding:10px 10px 5px}.am-row{display:flex;align-items:center;gap:11px;width:100%;text-align:left;border:0;background:transparent;padding:8px 9px;border-radius:10px;cursor:pointer;transition:background var(--dur-fast)}.am-row:hover,.am-row.is-active{background:#ffffff0f}.am-row .cv-badge{width:32px;height:32px;border-radius:10px}.am-eyebrow.is-apart{margin:6px 4px 0;padding:12px 6px 5px;border-top:1px solid var(--hairline-soft)}.cv-badge.is-prompts{background:linear-gradient(135deg,#9968df52,#5a61ed38);color:#fff}.am-main{flex:1;min-width:0}.am-name{font-size:13px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.am-sub{font-size:11px;color:var(--fg-4);margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.am-go{color:var(--fg-5);flex:none;transition:color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.am-row:hover .am-go{color:var(--fg-2);transform:translate(1px)}.am-searchrow{display:flex;align-items:center;gap:6px;padding:12px 10px 8px 12px}.am-searchrow .am-search{flex:1;min-width:0;margin:0}.am-close{flex:none;width:30px;height:30px;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:transparent;color:var(--fg-4);cursor:pointer;padding:0;transition:background var(--dur-fast),color var(--dur-fast)}.am-close:hover{background:#ffffff14;color:var(--fg-1)}`, LCe = '.v2-root{--cv-fav: #ef5f7a;--chat-w: 80px;--set-w: 0px}.v2-root .cv-topbar{height:52px;padding:0 16px;gap:14px}.v2-root .cv-topbar-left{gap:11px}.v2-root .cv-topbar-right{gap:12px}.v2-root .cv-mark{width:31px;height:27px;border-radius:8px}.v2-root .cv-mark svg{width:25px}.v2-root .cv-crumb{font-size:12px}.v2-root .cv-board-title{font-size:13.5px}.v2-root.light-canvas{background:#f4f5f7}.v2-root.light-canvas .cv-topbar{background:#070910f0}.v2-root.light-canvas .rs,.v2-root.light-canvas .bd-siderail,.v2-root.light-canvas .v2-rail,.v2-root.light-canvas .cv-zoomhud{background:#121521f0}.v2-root.light-canvas .cv-atmo-glow,.v2-root.light-canvas .cv-atmo-orb-a,.v2-root.light-canvas .cv-atmo-orb-b{opacity:0}.v2-root.light-canvas .cv-grid{background-image:radial-gradient(rgba(12,16,30,.85) 1.15px,transparent 1.6px);opacity:calc(.3 * var(--cv-atmo))}.v2-root.light-canvas.no-grid .cv-grid{opacity:0}.v2-root.light-canvas{--lc-ink: #131828;--lc-ink-2: rgba(19, 24, 40, .74);--lc-ink-3: rgba(19, 24, 40, .56);--lc-line: rgba(19, 24, 40, .14);--cv-guide: var(--amethyst-400);--cv-guide-halo: rgba(255, 255, 255, .55)}.v2-root.light-canvas .cv-frame-title{color:var(--lc-ink-2)}.v2-root.light-canvas .cv-frame-title .cv-frame-count{color:var(--lc-ink-3)}.v2-root.light-canvas .cv-frame-title.is-selected{color:var(--amethyst-400)}.v2-root.light-canvas .cv-frame-title-input{color:var(--lc-ink);background:#fff;border-color:#7532d373;box-shadow:0 1px 2px #13182814}.v2-root.light-canvas .cv-frame-title .cv-frame-lock{color:var(--lc-ink-3)}.v2-root.light-canvas .cv-frame-title.is-selected .cv-frame-lock{color:inherit}.v2-root.light-canvas .cv-minimap{background:#f4f5f7f5;border-color:var(--lc-line);box-shadow:0 1px 2px #13182814,0 18px 40px #1318281f}.v2-root.light-canvas .mm-hide{background:#fff;border-color:var(--lc-line);color:var(--lc-ink-2)}.v2-root.light-canvas .mm-hide:hover{background:#fff;color:var(--lc-ink)}.v2-root.light-canvas .cv-bucket{background:#fff;border-color:var(--lc-line);box-shadow:0 1px 2px #13182814,0 18px 40px #1318281a;backdrop-filter:none;-webkit-backdrop-filter:none}.v2-root.light-canvas .cv-el:hover .cv-bucket{box-shadow:0 1px 2px #13182814,0 26px 60px #13182829}.v2-root.light-canvas .cv-bucket-name{color:var(--lc-ink)}.v2-root.light-canvas .cv-bucket-kind,.v2-root.light-canvas .cv-bucket-foot{color:var(--lc-ink-3)}.v2-root.light-canvas .cv-bucket-model,.v2-root.light-canvas .cv-bucket-sep{color:#1318286b}.v2-root.light-canvas .cv-count{color:var(--lc-ink-2);background:#1318280f;border-color:var(--lc-line)}.v2-root.light-canvas .cv-badge{background:#1318280d;box-shadow:inset 0 1px #fffc;color:var(--amethyst-400)}.v2-root.light-canvas .cv-thumb{border-color:#13182814}.v2-root.light-canvas .cv-thumb-empty{border-color:#13182824;background:#13182808}.v2-root.light-canvas .cv-note{box-shadow:0 1px 2px #13182814,0 16px 36px #1318281f;backdrop-filter:none;-webkit-backdrop-filter:none}.v2-root.light-canvas .cv-note.tint-glass{background:#fff;border-color:var(--lc-line)}.v2-root.light-canvas .cv-note.tint-amethyst{background:linear-gradient(180deg,#9968df33,#9968df1a);border-color:#9968df52}.v2-root.light-canvas .cv-note.tint-vista{background:linear-gradient(180deg,#5a61ed2e,#5a61ed17);border-color:#5a61ed4d}.v2-root.light-canvas .cv-note.tint-sky{background:linear-gradient(180deg,#3db4e633,#3db4e61a);border-color:#3db4e657}.v2-root.light-canvas .cv-note.tint-mint{background:linear-gradient(180deg,#34c79a33,#34c79a1a);border-color:#34c79a57}.v2-root.light-canvas .cv-note.tint-amber{background:linear-gradient(180deg,#f0b44a42,#f0b44a21);border-color:#d696285c}.v2-root.light-canvas .cv-note.tint-rose{background:linear-gradient(180deg,#ec5b9a2e,#ec5b9a17);border-color:#ec5b9a52}.v2-root.light-canvas .cv-note-text{color:var(--lc-ink)}.v2-root.light-canvas .cv-note-meta{color:var(--lc-ink-3)}.v2-root.light-canvas .cv-img-label{color:#fff;text-shadow:0 1px 6px rgba(4,3,12,.85)}.v2-root.light-canvas .cv-marquee{border-color:#7532d38c;background:#7532d31a}.v2-stage{left:0!important;top:52px!important;right:var(--set-w)!important}.v2-root .cv-corner{right:calc(18px + var(--set-w))}.v2-railwrap{position:absolute;left:var(--chat-w);right:var(--set-w);bottom:22px;z-index:41;pointer-events:none;display:flex;align-items:center;justify-content:center;gap:10px;transition:left var(--dur-med) var(--ease-out-soft),right var(--dur-med) var(--ease-out-soft),opacity var(--dur-med) var(--ease-out-soft),transform var(--dur-med) var(--ease-out-soft)}.v2-railwrap>*{pointer-events:auto}.v2-railwrap.is-away{opacity:0;transform:translateY(18px)}.v2-railwrap.is-away>*{pointer-events:none}.v2-rail .cv-tool.v2-add{background:var(--grad-cta);color:#fff;box-shadow:0 5px 14px #745aff47,inset 0 1px #ffffff2e;transition:box-shadow var(--dur-med),filter var(--dur-fast)}.v2-rail .cv-tool.v2-add:hover{background:var(--grad-cta);color:#fff;filter:brightness(1.1)}.v2-rail .cv-tool.v2-add.on{box-shadow:0 5px 14px #745aff47,inset 0 1px #ffffff38,0 0 0 3px var(--cv-accent-tint)}.v2-add>.licon{transition:transform var(--dur-med) var(--ease-out-soft)}.v2-add.on>.licon{transform:rotate(45deg)}.v2-rail{position:relative;display:flex;flex-direction:row;align-items:center;gap:3px;padding:6px;border-radius:15px;background:#121521b8;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px)}.v2-rail .sep{width:1px;height:20px;background:var(--hairline-soft);margin:auto 4px}.v2-rail .cv-tool{width:36px;height:36px;border-radius:10px}.v2-rail .v2-shapetool .face{width:40px}.cv-addmenu.at-rail{left:calc(var(--chat-w) + (100vw - var(--chat-w) - var(--set-w)) / 2);right:auto;top:auto;bottom:80px;transform:translate(-50%)}@media(prefers-reduced-motion:no-preference){.cv-addmenu.at-rail{animation:amInRail .35s var(--ease-out-soft) both}@keyframes amInRail{0%{opacity:0;transform:translate(-50%) translateY(12px)}to{opacity:1;transform:translate(-50%) translateY(0)}}}.v2-uprompt{position:absolute;left:var(--chat-w);right:var(--set-w);bottom:20px;z-index:70;pointer-events:none;display:flex;flex-direction:column;align-items:center;animation:upIn var(--dur-med) var(--ease-out-soft) both;transition:left var(--dur-med) var(--ease-out-soft),right var(--dur-med) var(--ease-out-soft)}.v2-uprompt>*{pointer-events:auto}.v2-root.hist-rail .v2-uprompt{right:calc(var(--set-w) + 368px)}.v2-root.board-hist .v2-uprompt{right:calc(var(--set-w) + 398px)}@keyframes upIn{0%{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}.up-card{position:relative;z-index:5;width:min(720px,100%);display:grid;grid-template-columns:30px minmax(0,1fr);gap:10px 12px;padding:11px 12px;border-radius:18px;border:1px solid rgba(255,255,255,.055);background:#0b0d15fb;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0b,0 2px 8px #02040c66,0 30px 80px #02040c9e;transition:box-shadow var(--dur-med) var(--ease-out-soft),border-color var(--dur-med)}.up-card:focus-within{border-color:#ffffff17}.up-card.is-fresh{animation:upFresh 2.2s var(--ease-out-soft) infinite}@keyframes upFresh{0%,to{box-shadow:inset 0 1px #ffffff0b,0 0 0 1px #9968df73,0 0 0 4px #9968df1a,0 30px 80px #02040c9e}50%{box-shadow:inset 0 1px #ffffff0b,0 0 0 1px #9968dfbf,0 0 0 7px #9968df29,0 30px 80px #02040c9e}}@media(prefers-reduced-motion:reduce){.up-card.is-fresh{animation:none;box-shadow:0 0 0 1px #9968df99,0 30px 80px #02040c9e}}.up-card.is-nudge{animation:upNudge .42s var(--ease-out-soft)}.up-card.is-nudge .up-run-wrap .tip{opacity:1}@keyframes upNudge{0%,to{translate:0 0}20%{translate:-6px 0}40%{translate:5px 0}60%{translate:-3px 0}80%{translate:2px 0}}@media(prefers-reduced-motion:reduce){.up-card.is-nudge{animation:none}}.up-side{grid-column:1;grid-row:1 / span 2;display:flex;flex-direction:column;align-items:center;gap:7px}.up-card.has-refs .up-side{grid-row:1 / span 3}.up-card.has-refs .up-text,.up-card.has-refs .up-ghost,.up-card.has-refs .up-cue{grid-row:2}.up-card.has-refs .up-foot{grid-row:3}.up-side-btn{width:30px;height:30px;flex:none;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:transparent;color:var(--fg-4);cursor:pointer;padding:0;transition:background var(--dur-fast),color var(--dur-fast)}.up-side-btn:hover{background:#ffffff0f;color:var(--fg-2)}.up-side-btn.on{background:var(--cv-accent-tint);color:var(--cv-accent-soft)}.up-side-btn .badge{position:absolute;margin:-18px 0 0 18px;min-width:14px;height:14px;padding:0 4px;border-radius:999px;background:var(--cv-accent);color:#fff;font-size:9px;font-weight:700;line-height:14px}.up-text{grid-column:2;grid-row:1;width:100%;min-height:70px;resize:none;overflow-y:auto;box-sizing:border-box;border:0;background:transparent;padding:4px 0 0;color:var(--fg-1);font-family:var(--font-sans);font-size:13.5px;line-height:1.55;letter-spacing:-.005em;outline:none;text-wrap:pretty;user-select:text;-webkit-user-select:text}textarea.up-text{min-height:0}.up-text::placeholder{color:var(--fg-4)}.up-grip{position:absolute;top:-9px;left:12px;z-index:3;width:30px;height:18px;display:flex;align-items:center;justify-content:center;cursor:ns-resize;touch-action:none;outline:none}.up-grip i{display:block;width:22px;height:4px;border-radius:999px;background:#ffffff29;box-shadow:0 0 0 1px #04030ca6;transition:background var(--dur-fast),width var(--dur-fast) var(--ease-out-soft)}.up-card:hover .up-grip i{background:#ffffff4d}.up-grip:hover i,.up-grip.is-on i,.up-grip:focus-visible i{width:28px;background:#ffffffa6}.up-grip:focus-visible i{box-shadow:0 0 0 1px #04030ca6,0 0 0 3px #a3a7f58c}.up-card.is-resizing,.up-card.is-resizing *{cursor:ns-resize!important;user-select:none}.up-text::-webkit-scrollbar{width:6px}.up-text::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.up-drop{width:56px;height:56px;flex:none;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px dashed rgba(255,255,255,.2);border-radius:12px;background:#ffffff08;color:var(--fg-4);cursor:pointer;transition:border-color var(--dur-fast),color var(--dur-fast),background var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.up-drop:hover,.up-drop.is-target{border-color:var(--cv-accent-soft);color:var(--cv-accent-soft);background:var(--cv-accent-tint)}.up-drop.is-target{transform:scale(1.06);border-style:solid}.up-refs{grid-column:2;grid-row:1;display:flex;flex-wrap:wrap;gap:6px;align-items:flex-start}.up-ref{position:relative;width:56px;height:56px;border-radius:12px;flex:none;background-size:cover;background-position:center;background-color:#ffffff0d;box-shadow:inset 0 0 0 1px #ffffff1f;animation:refIn .32s var(--ease-out-soft) both}@keyframes refIn{0%{opacity:0;transform:scale(.85)}to{opacity:1;transform:none}}.up-ref.is-target{box-shadow:inset 0 0 0 2px var(--cv-accent-text)}.up-ref button{position:absolute;top:-6px;right:-6px;width:20px;height:20px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:#0b0d15f0;color:var(--fg-3);cursor:pointer;box-shadow:0 4px 12px #02040c99;transition:color var(--dur-fast);opacity:0}.up-ref:hover button,.up-ref button:focus-visible{opacity:1}.up-ref button:hover{color:#fff}.up-ref .lbl{position:absolute;left:4px;right:4px;bottom:4px;padding:1px 5px;border-radius:6px;background:#04030cb3;color:var(--fg-2);font-size:8.5px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.up-drop.is-dropper{border-style:solid;border-color:var(--cv-accent-soft);color:var(--cv-accent-text);background:var(--cv-accent-tint)}.up-ref.is-dropper{box-shadow:inset 0 0 0 2px var(--cv-accent-soft)}.up-ref-pulse{position:absolute;inset:0;border-radius:inherit;pointer-events:none;animation:upPulse .9s var(--ease-out-soft) both}@keyframes upPulse{0%{box-shadow:inset 0 0 0 2px #ffffffe6,0 0 #9968df99}to{box-shadow:inset 0 0 0 2px #fff0,0 0 0 10px #9968df00}}@media(prefers-reduced-motion:reduce){.up-ref-pulse{animation:none}}.up-ref-glow{position:absolute;inset:0;border-radius:inherit;pointer-events:none;animation:upGlowBreathe 1.25s ease-in-out infinite alternate,upGlowLife 5s linear both}@keyframes upGlowBreathe{0%{box-shadow:inset 0 0 0 1.5px #c4a2ff80,0 0 6px 1px #9968df33}to{box-shadow:inset 0 0 0 1.5px #c4a2ffd9,0 0 18px 4px #9968df6b}}@keyframes upGlowLife{0%{opacity:0}8%{opacity:1}76%{opacity:1}to{opacity:0}}@media(prefers-reduced-motion:reduce){.up-ref-glow{animation:upGlowLife 5s linear both;box-shadow:inset 0 0 0 1.5px #c4a2ffb3,0 0 10px 2px #9968df4d}}.up-ref-peek{position:absolute;bottom:calc(100% + 12px);z-index:8;transform:translate(-50%);border-radius:12px;overflow:hidden;pointer-events:none;background:#ffffff0a;box-shadow:0 0 0 1px #ffffff24,0 24px 60px #02040cb8;animation:upPeek .18s var(--ease-out-soft) both}.up-ref-peek img{display:block;max-width:320px;max-height:320px}.up-ref-peek .n{position:absolute;left:8px;top:8px;padding:2px 8px;border-radius:999px;background:#04030cb3;color:#fff;font-size:10.5px;font-weight:600}@keyframes upPeek{0%{opacity:0;transform:translate(-50%) translateY(6px) scale(.96)}to{opacity:1;transform:translate(-50%)}}@media(prefers-reduced-motion:reduce){.up-ref-peek{animation:none}}.up-foot{grid-column:2;grid-row:2;display:flex;align-items:flex-end;gap:7px;min-width:0}.up-chips{display:flex;align-items:center;gap:6px;row-gap:6px;flex:1;min-width:0;overflow:visible;flex-wrap:wrap}.up-chip-wrap{position:relative;display:inline-flex;min-width:0}.up-chip{display:inline-flex;align-items:center;gap:6px;max-width:190px;height:30px;padding:0 11px;border:1px solid var(--hairline-soft);border-radius:999px;background:#ffffff0d;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.up-chip:hover{background:#ffffff17;color:var(--fg-1)}.up-chip.on{border-color:var(--cv-accent-soft);color:var(--fg-1);background:var(--cv-accent-tint)}.up-chip .licon{flex:none;color:var(--fg-4)}.up-chip.on .licon{color:var(--cv-accent-soft)}.up-chip .t{min-width:0;overflow:hidden;text-overflow:ellipsis}.up-cog{flex:none;width:24px;height:30px;padding:0;border:0;background:none;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;color:var(--fg-4);transition:color var(--dur-fast)}.up-cog:hover,.up-cog.on{color:var(--fg-1)}.up-chip.is-locked{cursor:default;background:#ffffff06;border-style:dashed;color:var(--fg-4)}.up-chip.is-locked:hover{background:#ffffff0a;color:var(--fg-3)}.up-chip .lk{flex:none;margin-left:-2px;color:var(--fg-4);opacity:.8}.up-count-wrap{position:relative;flex:none;display:inline-flex}.up-count{display:inline-flex;align-items:center;gap:3px;height:30px;padding:0 6px 0 9px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);cursor:pointer;font-family:var(--font-sans);font-size:12px;font-weight:600;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast)}.up-count:hover:not(:disabled),.up-count.on{background:#ffffff0d;color:var(--fg-1)}.up-count .chev{color:var(--fg-4);opacity:.85;transition:transform .22s var(--ease-out-soft),color var(--dur-fast)}.up-count:hover .chev,.up-count.on .chev{color:var(--fg-2)}.up-count.on .chev{transform:rotate(180deg)}.up-count:disabled{cursor:default;color:var(--fg-3)}.up-count:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:1px}.up-count.is-tall{height:40px;padding:0 9px 0 12px;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff08}.up-count.is-tall:hover:not(:disabled),.up-count.is-tall.on{background:#ffffff0f}.up-count-pop .sv-pop-row{font-variant-numeric:tabular-nums}.up-count-pop .sv-pop-row:focus-visible{outline:none;background:#ffffff0f;color:var(--fg-1)}.up-count-pop .ck{margin-left:auto;color:var(--cv-accent-text)}@media(prefers-reduced-motion:reduce){.up-count .chev{transition:none}}.up-run{flex:none;height:30px;padding:0 17px;display:inline-flex;align-items:center;gap:7px;border:0;border-radius:999px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:12.5px;font-weight:600;letter-spacing:-.01em;cursor:pointer;box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff2e;transition:filter var(--dur-fast),box-shadow var(--dur-med),transform var(--dur-fast) var(--ease-out-soft);position:relative}.up-run:hover{filter:brightness(1.08);box-shadow:0 9px 24px #745aff61,inset 0 1px #ffffff38}.up-run:active:not(:disabled){transform:scale(.97)}.up-run:disabled{cursor:default;filter:none;background:#ffffff12;color:var(--fg-4);box-shadow:none}.up-run:disabled:hover{filter:none;box-shadow:none}.up-run:disabled.is-busy{background:var(--grad-cta);color:#fff;opacity:.72}.up-run.is-get{background:linear-gradient(135deg,#ff9a6b,#f2668b);box-shadow:0 6px 18px #f2668b47,inset 0 1px #fff3}.up-run.is-get .licon{color:#fff}.up-run-wrap .tip{position:absolute;bottom:calc(100% + 9px);right:0;width:max-content;max-width:300px;background:#0b0d14f0;border:1px solid var(--hairline-soft);line-height:1.4;text-align:left;color:var(--fg-2);font-size:11px;font-weight:500;padding:5px 9px;border-radius:8px;opacity:0;pointer-events:none;transition:opacity var(--dur-fast)}.up-run-wrap{position:relative;display:inline-flex}.up-run-wrap:hover .tip{opacity:1}.up-out-line{flex:none;margin-left:auto;margin-right:6px;font-size:11px;color:var(--fg-4);white-space:nowrap;font-variant-numeric:tabular-nums}.v2-root.light-canvas .up-out-line{color:var(--fg-4)}.up-cost{flex:none;display:inline-flex;align-items:baseline;gap:4px;margin-left:1px;white-space:nowrap;color:var(--fg-4);font-size:11px;font-weight:500;font-variant-numeric:tabular-nums}.up-cost .licon{color:var(--fg-5);align-self:center}.up-note{flex:none;display:inline-flex;align-items:center;gap:5px;height:30px;white-space:nowrap;color:var(--fg-4);font-size:11px;font-weight:500}.up-note .licon{color:var(--fg-5)}.up-model-wrap{min-width:0;flex:0 1 auto;align-items:baseline}.up-model{display:inline-flex;align-items:baseline;gap:7px;min-width:0;max-width:240px;height:30px;padding:0 8px;margin-left:-6px;border:0;border-radius:8px;background:transparent;color:var(--fg-1);font-family:var(--font-sans);cursor:pointer;line-height:30px;transition:background var(--dur-fast)}.up-model:hover,.up-model.on{background:#ffffff0d}.up-model .lb{flex:none;font-size:10px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.up-model .nm{min-width:0;font-size:12.5px;font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.up-model .licon{flex:none;align-self:center;color:var(--fg-4)}.up-foot-sep{flex:none;width:1px;height:18px;margin:0 3px;background:var(--hairline-soft)}.up-pop{position:absolute;bottom:calc(100% + 8px);left:0;min-width:190px;z-index:6;display:flex;flex-direction:column;gap:2px;padding:7px;border:1px solid var(--hairline);border-radius:14px;background:#11131ef5;backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);box-shadow:var(--inset-highlight),var(--shadow-deep);animation:upIn var(--dur-fast) var(--ease-out-soft) both;max-height:min(420px,60vh);overflow-y:auto}.up-pop::-webkit-scrollbar{width:6px}.up-pop::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.up-pop.is-wide{min-width:320px}.up-pop-label{padding:3px 6px 6px;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.2em;color:var(--fg-4)}.up-pop-search{display:flex;align-items:center;gap:7px;margin:0 2px 6px;height:30px;padding:0 9px;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff0a;color:var(--fg-4)}.up-pop-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-size:12px;user-select:text;-webkit-user-select:text}.up-pop-row{display:flex;align-items:center;gap:8px;width:100%;padding:7px 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;font-weight:500;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast);flex:none}.up-pop-row:hover{background:#ffffff12;color:var(--fg-1)}.up-pop-row.on{background:var(--cv-accent-tint);color:var(--fg-1)}.up-pop-main{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.up-pop-meta{flex:none;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.up-pop-sep{flex:none;height:1px;margin:3px 6px;background:var(--hairline-soft)}.up-pop-slider{display:flex;align-items:center;gap:10px;min-width:220px;padding:2px 6px 6px}.up-pop-slider .up-adv-num{flex:none;width:58px}.up-pop-avatar{width:24px;height:24px;flex:none;border-radius:7px;background-size:cover;background-position:center;background-color:#ffffff0f}.up-pop-item{position:relative;flex:none}.up-pop-item .up-pop-row{padding-right:38px}.up-pop-item:hover .up-pop-row{background:#ffffff12;color:var(--fg-1)}.up-pop-item:hover .up-pop-row.on{background:var(--cv-accent-tint)}.up-pop-pin{position:absolute;right:5px;top:50%;transform:translateY(-50%);width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.up-pop-item:hover .up-pop-pin,.up-pop-pin.on,.up-pop-pin:focus-visible{opacity:1}.up-pop-pin:hover{background:#ffffff17;color:#fff}.up-pop-pin.on{color:var(--cv-accent-text)}.up-pop-pin.on svg{fill:currentColor}.up-pop-empty{padding:10px 8px 12px;font-size:12px;line-height:1.45;color:var(--fg-4)}.up-modelpick{width:320px}.up-modelpick-row{padding-top:6px;padding-bottom:6px}.up-modelpick-av{width:32px;height:32px;flex:none;display:inline-flex;align-items:center;justify-content:center;border-radius:8px;object-fit:cover;background:#ffffff0f;color:var(--fg-4)}.up-modelpick-av.is-none{background:transparent;border:1px dashed var(--hairline)}.up-modelpick-desc{display:block;margin-top:1px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:11px;font-weight:400;color:var(--fg-4)}.up-modelpick-group{padding:8px 6px 4px;font-size:10px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-5)}.up-modelpick-note{display:flex;align-items:center;gap:8px;padding:8px 8px 10px;font-size:12px;line-height:1.45;color:var(--fg-4)}.up-influence{width:260px;gap:8px;padding:9px 12px 12px}.up-influence .up-pop-label{padding:3px 0 2px}.up-influence-ends{display:flex;align-items:flex-end;justify-content:space-between;height:22px;color:var(--fg-2);font-weight:600;font-variant-numeric:tabular-nums}.up-influence-ends span{display:inline-flex;align-items:center;gap:5px;transition:font-size var(--dur-fast)}.up-influence-ends .licon{color:var(--fg-4)}.up-influence .up-range{width:100%;margin:4px 0 2px}.up-chip .av{width:20px;height:20px;flex:none;margin-left:-6px;border-radius:50%;object-fit:cover;box-shadow:0 0 0 1px #ffffff14}.up-pop-tabs{display:flex;flex-wrap:wrap;gap:4px;margin:0 2px 6px;flex:none}.up-pop-tabs button{flex:none;height:24px;padding:0 9px;border-radius:999px;border:1px solid var(--hairline-soft);background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.up-pop-tabs button:hover{color:var(--fg-1);background:#ffffff0d}.up-pop-tabs button.on{color:var(--fg-1);background:var(--cv-accent-tint);border-color:var(--cv-accent-soft)}.up-pop-badge{display:inline-flex;align-items:center;height:16px;padding:0 6px;margin-left:6px;border-radius:999px;vertical-align:1px;font-size:9.5px;font-weight:600;letter-spacing:.02em;color:var(--fg-3);background:#ffffff12}.up-pop-badge.is-popular{color:#ffb38a;background:#ff8c5a24}.up-adv{position:relative;width:min(360px,100%);margin-bottom:10px;z-index:4;display:flex;flex-direction:column;gap:16px;padding:16px;border:1px solid rgba(255,255,255,.055);border-radius:18px;background:#0b0d15fb;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0b,0 2px 8px #02040c66,0 30px 80px #02040c9e;animation:upIn var(--dur-med) var(--ease-out-soft) both;max-height:calc(100vh - 290px);overflow-y:auto}.up-adv::-webkit-scrollbar{width:6px}.up-adv::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.up-adv-head{display:flex;align-items:center;gap:6px}.up-adv-title{flex:1;font-size:14px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.up-adv-field{display:flex;flex-direction:column;gap:9px;min-width:0;margin:0;padding:0;border:0}.up-adv-field.is-locked>:not(.up-adv-label):not(.up-adv-why){opacity:.45;pointer-events:none}.up-adv-why{display:flex;align-items:flex-start;gap:6px;margin-top:-3px;font-size:11px;line-height:1.45;color:var(--fg-4)}.up-adv-why .licon{flex:none;margin-top:2px}.up-adv-label{display:flex;align-items:center;gap:6px;font-size:12px;font-weight:500;color:var(--fg-2)}.up-adv-label .licon{color:var(--fg-4)}.up-adv-label .req{color:var(--cv-accent-text)}.up-adv-hint{font-size:11px;line-height:1.45;color:var(--fg-4)}.up-adv-row{display:flex;align-items:center;gap:10px}.up-range{flex:1;min-width:0;height:4px;-webkit-appearance:none;appearance:none;border-radius:999px;background:#ffffff1f;outline:none}.up-range::-webkit-slider-thumb{-webkit-appearance:none;width:13px;height:13px;border-radius:50%;background:#fff;box-shadow:0 2px 6px #02061780;cursor:pointer}.up-range::-moz-range-thumb{width:13px;height:13px;border:0;border-radius:50%;background:#fff;cursor:pointer}.up-adv-num{width:64px;flex:none;height:30px;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;text-align:center;outline:none;font-variant-numeric:tabular-nums;user-select:text;-webkit-user-select:text}.up-adv-num.is-full{width:100%;text-align:left;padding:0 10px}.up-adv-num:focus{border-color:var(--cv-accent-soft)}textarea.up-adv-num{height:auto;min-height:62px;padding:8px 10px;line-height:1.5;resize:vertical;text-align:left}.up-seg{display:inline-flex;flex-wrap:wrap;gap:2px;padding:2px;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff08;align-self:flex-start}.up-seg button{height:26px;padding:0 12px;border:1px solid transparent;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.up-seg button:hover{color:var(--fg-1)}.up-seg button.on{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:var(--fg-1)}.up-toggle{position:relative;width:32px;height:18px;border-radius:999px;border:0;padding:0;cursor:pointer;background:#ffffff24;transition:background var(--dur-fast)}.up-toggle:after{content:"";position:absolute;left:2px;top:2px;width:14px;height:14px;border-radius:50%;background:#fff;box-shadow:0 2px 6px #02061766;transition:transform var(--dur-fast) var(--ease-out-soft)}.up-toggle.on{background:var(--cv-accent)}.up-toggle.on:after{transform:translate(14px)}.up-error{display:flex;align-items:flex-start;gap:8px;width:min(720px,100%);margin-bottom:8px;padding:9px 12px;border-radius:12px;font-size:12px;line-height:1.45;background:#ff5c7a1a;border:1px solid rgba(255,92,122,.28);color:#ffb3c1;animation:upIn var(--dur-med) var(--ease-out-soft) both}.up-error .licon{margin-top:1px}.up-error button{margin-left:auto;border:0;background:transparent;color:inherit;cursor:pointer;padding:0;opacity:.7}.up-error button:hover{opacity:1}.v2-hist{position:absolute;z-index:46;top:66px;right:68px;bottom:14px;width:300px;display:flex;flex-direction:column;padding:12px;border-radius:18px;background:#0b0d15f7;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 28px 80px #02040c99;pointer-events:auto;animation:histIn .26s var(--ease-out-soft) both}@keyframes histIn{0%{opacity:0;transform:translate(16px)}to{opacity:1;transform:none}}.v2-hist-head{flex:none;display:flex;align-items:center;gap:8px;margin-bottom:6px}.v2-hist-head .n{flex:none;padding:2px 7px;border-radius:999px;background:#ffffff0f;color:var(--fg-2);font-size:10px;font-weight:600;font-variant-numeric:tabular-nums}.v2-hist-head .t{min-width:0;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-hist-close{margin-left:auto;flex:none;width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid var(--hairline-soft);border-radius:8px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-hist-close:hover{background:#ffffff17;color:var(--fg-1)}.v2-hist-hint{flex:none;margin-bottom:9px;font-size:10px;line-height:1.4;color:var(--fg-5)}.v2-hist-open{position:absolute;z-index:46;top:66px;right:68px;display:inline-flex;align-items:center;gap:6px;height:32px;padding:0 11px;border-radius:11px;border:1px solid var(--hairline);background:#0b0d15f0;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);box-shadow:var(--inset-highlight),0 18px 44px #02040c80;color:var(--fg-2);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;animation:histIn .26s var(--ease-out-soft) both}.v2-hist-open:hover{background:#161926f5;color:#fff}.v2-hist-grid{flex:1;min-height:0;overflow-y:auto;padding-right:2px;position:relative;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.v2-hist-grid::-webkit-scrollbar{width:5px}.v2-hist-grid::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.v2-hist-item{position:absolute}.v2-hist-item .shot{position:absolute;inset:0;padding:0;border:0;border-radius:10px;background:transparent;cursor:pointer;outline:none}.v2-hist-item .art{position:absolute;inset:0;border-radius:10px;box-shadow:inset 0 0 0 1px #ffffff12;transition:box-shadow var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft);background-color:#ffffff0a;background-size:cover;background-position:center}.v2-hist-item:hover .art{transform:translateY(-2px);box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft),0 12px 28px #02040c80}.v2-hist-item.is-on .art{box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft)}.v2-hist-item.is-new .art{animation:thumbIn .55s var(--ease-out-soft) both}.v2-hist-item.is-pending .art{overflow:hidden}.v2-hist-item.is-pending .art:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.v2-hist-item.is-failed .art{display:flex;align-items:center;justify-content:center;color:#ff8aa0;background:#ff5c7a14;box-shadow:inset 0 0 0 1px #ff5c7a40}.v2-hist-acts{position:absolute;right:10px;bottom:10px;z-index:3;display:flex;align-items:center;gap:6px}.v2-hist-acts button{height:28px;border:1px solid rgba(255,255,255,.18);border-radius:999px;background:#04030cb8;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);color:#fff;font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast);position:relative}.v2-hist-acts .find{width:28px;display:inline-flex;align-items:center;justify-content:center;padding:0}.v2-hist-acts button:hover{background:var(--cv-accent);border-color:transparent}.v2-hist-acts .tip{position:absolute;bottom:calc(100% + 8px);left:50%;transform:translate(-50%);background:#0b0d14f0;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:10.5px;font-weight:500;padding:4px 8px;border-radius:7px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast)}.v2-hist-acts button:hover .tip{opacity:1}.v2-hist-pop{position:absolute;right:calc(100% + 12px);z-index:6;border-radius:14px;pointer-events:auto;box-shadow:0 28px 70px #02040cc2;animation:histPop .22s var(--ease-out-soft) both}@keyframes histPop{0%{opacity:0;transform:translate(10px) scale(.94)}to{opacity:1;transform:none}}.v2-hist-pop:after{content:"";position:absolute;right:-14px;top:0;bottom:0;width:14px}.v2-hist-pop .art{position:absolute;inset:0;width:100%;height:100%;padding:0;border:0;cursor:pointer;border-radius:14px;box-shadow:inset 0 0 0 1px #ffffff1f;background-color:#ffffff0a;background-size:cover;background-position:center}.v2-hist-pop .art-vid{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:14px;pointer-events:none;opacity:0;transition:opacity .22s var(--ease-out-soft)}.v2-hist-pop .art-vid.is-shown{opacity:1}.v2-hist-pop .cap{position:absolute;left:0;right:0;bottom:0;display:flex;align-items:center;gap:8px;padding:30px 112px 15px 13px;pointer-events:none;border-radius:0 0 14px 14px;background:linear-gradient(180deg,#04030c00,#04030ce0 64%)}.v2-hist-pop .cap .n{flex:1;min-width:0;font-size:11.5px;font-weight:600;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-hist-pop .cap .m{flex:none;display:inline-flex;align-items:center;gap:4px;font-size:10.5px;font-weight:600;color:#ffffffb8}.v2-hist-vid,.v2-hist-fav{position:absolute;top:5px;display:inline-flex;align-items:center;gap:2px;height:14px;padding:0 5px;border-radius:999px;background:#04030cb3;font-size:7.5px;font-weight:700;letter-spacing:.02em}.v2-hist-vid{right:5px;color:#fff}.v2-hist-fav{left:5px;padding:0 4px;color:var(--cv-fav)}.v2-hist-fav svg{fill:currentColor}.v2-hist-empty{padding:30px 12px;text-align:center;font-size:11.5px;line-height:1.5;color:var(--fg-4)}.v2-hist-time{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:1;font-size:10.5px;font-weight:600;font-variant-numeric:tabular-nums;letter-spacing:.02em;color:#ffffff9e;pointer-events:none}.v2-hist-item.is-withheld .art{display:flex;align-items:center;justify-content:center;background:radial-gradient(120% 90% at 30% 20%,#9968df38,#ffffff08 70%);box-shadow:inset 0 0 0 1px #ffffff14}.v2-hist-withheld{display:inline-flex;flex-direction:column;align-items:center;gap:5px;font-size:9.5px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:var(--fg-4)}.v2-hist-more{display:flex;justify-content:center;padding:10px 0 14px}.tl-ghost{position:fixed;z-index:95;pointer-events:none;width:132px;height:92px;border-radius:10px;background-size:cover;background-position:center;background-color:#ffffff0f;border:1px solid rgba(255,255,255,.22);box-shadow:0 24px 60px #02061799;opacity:.9;transform:translate(-50%,-50%) rotate(-2deg);transition:box-shadow var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.tl-ghost.is-ref{box-shadow:0 0 0 2px var(--cv-accent-text),0 18px 44px #02040c99;transform:translate(-50%,-50%) rotate(0) scale(.86)}.v2-info{position:fixed;inset:0;z-index:90;display:flex;align-items:center;justify-content:center;padding:28px 64px;background:#04030cc7;backdrop-filter:blur(18px);-webkit-backdrop-filter:blur(18px);animation:infoIn .22s var(--ease-out-soft) both}@keyframes infoIn{0%{opacity:0}to{opacity:1}}.v2-info-shell{display:grid;grid-template-columns:minmax(0,1fr) 372px;gap:26px;width:min(1440px,100%);height:min(88vh,960px);animation:infoShell .32s var(--ease-out-soft) both}@keyframes infoShell{0%{opacity:0;transform:translateY(10px) scale(.99)}to{opacity:1;transform:none}}.v2-info-stage{position:relative;min-width:0;display:flex;align-items:center;justify-content:center;border-radius:18px;background:#ffffff08;border:1px solid var(--hairline-soft);overflow:hidden}.v2-info-art{display:block;border-radius:12px;object-fit:cover;box-shadow:0 30px 100px #0206178c;transition:transform .25s var(--ease-out-soft),opacity .3s ease;max-width:none}.v2-info-art.is-loading{opacity:0}.v2-info-play{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:60px;height:60px;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:0;cursor:pointer;background:#04030c99;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);color:#fff;transition:transform var(--dur-fast) var(--ease-out-soft),background var(--dur-fast)}.v2-info-play:hover{transform:translate(-50%,-50%) scale(1.06);background:#04030cbf}span.v2-info-play{cursor:default;pointer-events:none}.v2-info-art.is-video{background:#000}.v2-info-zoom{position:absolute;left:50%;bottom:16px;transform:translate(-50%);display:flex;align-items:center;gap:2px;padding:4px;border-radius:999px;background:#04030c9e;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border:1px solid rgba(255,255,255,.1);color:#fffc}.v2-info-zoom button,.v2-info-zoom span{width:28px;height:26px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:999px;background:transparent;color:inherit;cursor:pointer}.v2-info-zoom button:hover{background:#ffffff1a;color:#fff}.v2-info-zoom span{color:#ffffff80;cursor:default;width:auto;padding:0 6px;font-size:11px;font-weight:600;font-variant-numeric:tabular-nums}.v2-info-zoom button.is-word{width:auto;padding:0 11px;gap:6px;font:600 11.5px var(--font-sans)}.v2-info-zoom button.is-word.on{background:#9968df4d;color:#fff}.v2-info-zoom .sep{width:1px;height:16px;margin:0 3px;background:#ffffff24}.v2-info-cmp-menu{position:absolute;left:50%;bottom:58px;transform:translate(-50%);z-index:3;min-width:240px;padding:6px;border-radius:14px;background:#0a0b14f5;border:1px solid var(--hairline);box-shadow:0 24px 60px #02040c99;animation:cmpIn .2s var(--ease-out-soft) both}@keyframes cmpIn{0%{opacity:0;transform:translate(-50%) translateY(6px)}}.v2-info-cmp-menu .hd{padding:6px 8px 4px;font-size:9.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-5)}.v2-info-cmp-menu .row{display:flex;align-items:center;gap:10px;width:100%;padding:6px 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-1);font:500 12px var(--font-sans);text-align:left;cursor:pointer}.v2-info-cmp-menu .row:hover{background:#ffffff12}.v2-info-cmp-menu .pic{width:34px;height:34px;flex:none;border-radius:7px;background:#ffffff0d center / cover no-repeat;border:1px solid var(--hairline-soft)}.v2-info-cmp{position:relative;overflow:hidden;border-radius:12px;cursor:ew-resize;touch-action:none;user-select:none;box-shadow:0 30px 100px #0206178c;background:#ffffff08}.v2-info-cmp img{position:absolute;inset:0;width:100%;height:100%;pointer-events:none}.v2-info-cmp .under{object-fit:contain}.v2-info-cmp .over{object-fit:cover}.v2-info-cmp .line{position:absolute;top:0;bottom:0;width:2px;margin-left:-1px;background:#fff;box-shadow:0 0 0 1px #00000040,0 0 16px #00000059;pointer-events:none}.v2-info-cmp .knob{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:50%;background:#fff;color:#12131c;box-shadow:0 4px 16px #0006}.v2-info-cmp .tag,.v2-info-pair-view figcaption{position:absolute;top:12px;height:24px;padding:0 10px;border-radius:999px;display:inline-flex;align-items:center;background:#04030ca8;color:#fff;font:600 11px var(--font-sans);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);pointer-events:none;max-width:45%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-info-cmp .tag.at-left{left:12px}.v2-info-cmp .tag.at-right{right:12px}.v2-info-pair-view{display:flex;gap:14px;width:calc(100% - 36px);height:calc(100% - 96px)}.v2-info-pair-view figure{position:relative;flex:1;min-width:0;margin:0;display:flex;align-items:center;justify-content:center}.v2-info-pair-view .pic{position:relative;display:inline-flex;max-width:100%;max-height:100%}.v2-info-pair-view img{display:block;max-width:100%;max-height:min(100%,calc(88vh - 160px));object-fit:contain;border-radius:12px;box-shadow:0 24px 70px #02061780}.v2-info-pair-view figcaption{left:12px}.v2-info-specs em.is-compare{cursor:zoom-in;transition:box-shadow var(--dur-fast)}.v2-info-specs em.is-compare:hover{box-shadow:0 0 0 2px #c2a4ecb3}.v2-info-nav{position:absolute;top:50%;transform:translateY(-50%);width:42px;height:42px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:transparent;color:#fff9;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-info-nav:hover{background:#ffffff14;color:#fff}.v2-info-nav:disabled{opacity:.25;cursor:default}.v2-info-nav.at-left{left:12px}.v2-info-nav.at-right{right:12px}.v2-info-side{min-width:0;display:flex;flex-direction:column;gap:14px;overflow-y:auto}.v2-info-side::-webkit-scrollbar{width:6px}.v2-info-side::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.v2-info-top{flex:none;display:flex;align-items:center;gap:9px}.v2-info-mail{flex:1;min-width:0;font-size:12.5px;font-weight:500;color:var(--fg-2);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-info-act{flex:none;width:30px;height:30px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid var(--hairline-soft);border-radius:50%;background:#ffffff0d;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-info-act:hover{background:#ffffff1c;color:#fff}.v2-info-act.is-danger:hover{color:#ff8aa0}.v2-info-act.is-confirming{width:auto;padding:0 11px 0 9px;gap:5px;border-radius:999px;color:#fff;background:#ff5c7a38;border-color:#ff5c7a73}.v2-info-confirm{font-size:11.5px;font-weight:600}.v2-info-avatar{width:26px;height:26px;border-radius:50%;flex:none;display:flex;align-items:center;justify-content:center;font-size:9.5px;font-weight:700;color:#fff;letter-spacing:.02em;background:var(--grad-cta)}.v2-info-card{flex:none;display:flex;flex-direction:column;gap:14px;padding:14px;border-radius:20px;background:linear-gradient(180deg,#ffffff12,#ffffff06);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-card)}.v2-info-card.is-record{flex:0 1 auto;min-height:0}.v2-info-scroll{flex:0 1 auto;min-height:0;display:flex;flex-direction:column;gap:14px;overflow-y:auto;margin:0 -6px;padding:0 6px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.v2-info-scroll.is-more{-webkit-mask-image:linear-gradient(180deg,#000 calc(100% - 36px),transparent);mask-image:linear-gradient(180deg,#000 calc(100% - 36px),transparent)}.v2-info-acts{flex:none;display:flex;flex-direction:column;gap:14px}.v2-info-strip{display:flex;align-items:center;gap:10px}.v2-info-strip .n{display:inline-flex;align-items:center;gap:6px;font-size:11px;font-weight:600;color:var(--fg-3);font-variant-numeric:tabular-nums}.v2-info-strip .when{flex:1;font-size:11.5px;color:var(--fg-3);font-variant-numeric:tabular-nums;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-info-star{flex:none;width:26px;height:26px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;transition:color var(--dur-fast),background var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.v2-info-star:hover{color:var(--fg-2);background:#ffffff0f}.v2-info-star.on{color:var(--cv-fav)}.v2-info-star.on svg{fill:currentColor}.v2-info-star:active{transform:scale(.88)}.v2-info-star.is-pin+.v2-info-star{margin-left:-6px}.v2-info-star.is-pin.on{color:var(--cv-accent-text)}.v2-info-block{border-radius:14px;background:#04030c57;border:1px solid var(--hairline-soft);padding:12px}.v2-info-block-head{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:9px}.v2-info-block-head span{display:inline-flex;align-items:center;gap:7px;font-size:11.5px;font-weight:600;color:var(--fg-2);min-width:0}.v2-info-block-head span .licon{color:var(--cv-accent-text)}.v2-info-block-head i{font-style:normal;font-weight:500;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:170px}.v2-info-block-head button{width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer}.v2-info-block-head button:hover{background:#ffffff12;color:var(--fg-1)}.v2-info-prompt{margin:0;font-size:12px;line-height:1.65;color:var(--fg-2);max-height:260px;overflow-y:auto;text-wrap:pretty;user-select:text;-webkit-user-select:text}.v2-info-prompt.is-reading{color:var(--fg-3);animation:infoReading 1.2s ease-in-out infinite alternate}.v2-info-prompt.is-none{color:var(--fg-3)}@keyframes infoReading{0%{opacity:.55}to{opacity:1}}@media(prefers-reduced-motion:reduce){.v2-info-prompt.is-reading{animation:none}}.v2-info-specs{display:grid;grid-template-columns:1fr 1fr;gap:14px 12px;padding:0 2px}.v2-info-specs>div{min-width:0}.v2-info-specs span{display:block;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4);margin-bottom:5px}.v2-info-specs b{display:block;font-size:12px;font-weight:500;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-info-specs b.none{color:var(--fg-5);font-style:italic}.v2-info-specs em{display:block;width:46px;height:32px;border-radius:7px;background-size:cover;background-position:center;border:1px solid var(--hairline-soft)}.v2-info-tool{display:flex;align-items:center;gap:11px;padding:10px;border-radius:14px;background:#04030c57;border:1px solid var(--hairline-soft);width:100%;text-align:left;font-family:var(--font-sans);cursor:default}button.v2-info-tool{cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}button.v2-info-tool:hover{background:#ffffff0d;border-color:var(--hairline)}.v2-info-tool .thumb{flex:none;width:38px;height:38px;border-radius:10px;background-size:cover;background-position:center;background-color:#ffffff0d}.v2-info-tool .body{min-width:0;flex:1}.v2-info-tool em{display:block;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.16em;color:var(--fg-4);font-style:normal}.v2-info-tool b{display:block;margin-top:3px;font-size:13px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v2-info-tool .go{flex:none;color:var(--fg-4)}.v2-info-place{display:inline-flex;align-items:center;justify-content:center;gap:9px;height:46px;border:0;border-radius:999px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:14px;font-weight:600;cursor:pointer;box-shadow:0 18px 44px #745aff52;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-fast)}.v2-info-place:hover{transform:translateY(-1px);filter:brightness(1.06)}.v2-info-remix{display:inline-flex;align-items:center;justify-content:center;gap:9px;height:38px;border-radius:999px;background:#ffffff0f;border:1px solid var(--hairline-soft);color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-info-remix:hover{background:#ffffff1a;color:var(--fg-1)}.v2-stage.is-draw,.v2-stage.is-draw *{cursor:crosshair!important}.v2-shapetool{position:relative;display:inline-flex;align-items:center}.v2-shapetool .face{position:relative;width:36px}.v2-shapetool .face>.licon:first-child{transform:translate(-2px)}.v2-shapetool .caret{position:absolute;right:4px;bottom:6px;display:inline-flex;color:var(--fg-5);transition:color var(--dur-fast),transform var(--dur-med) var(--ease-out-soft)}.v2-shapetool .face:hover .caret{color:var(--fg-3)}.v2-shapetool.is-open .face{background:#ffffff12;color:var(--fg-1)}.v2-shapetool.is-open .caret{color:var(--fg-2);transform:rotate(180deg)}.v2-shapetool.on .face{background:var(--cv-accent-tint);color:var(--cv-accent-text)}.v2-shapetool.on .caret{color:var(--cv-accent-text);opacity:.7}.v2-shapetool.is-open .tip{display:none}.v2-shapemenu{position:absolute;bottom:calc(100% + 12px);left:50%;transform:translate(-50%);width:218px;padding:8px;z-index:60;border-radius:var(--radius-md);background:#0e101af0;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px)}@media(prefers-reduced-motion:no-preference){.v2-shapemenu{animation:shpIn .24s var(--ease-out-soft) both}@keyframes shpIn{0%{opacity:0;transform:translate(-50%) translateY(8px)}to{opacity:1;transform:translate(-50%) translateY(0)}}}.v2-shapemenu .hd{font-size:10.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5);padding:4px 8px 8px}.v2-shapemenu .row{display:flex;align-items:center;gap:9px;width:100%;height:34px;padding:0 9px 0 4px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:13px;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.v2-shapemenu .row:hover{background:#ffffff12;color:var(--fg-1)}.v2-shapemenu .row.on{color:var(--fg-1)}.v2-shapemenu .row .tick{width:18px;display:inline-flex;justify-content:center;color:var(--cv-accent-text)}.v2-shapemenu .row .lb{flex:1;text-align:left}.v2-shapemenu .row .k{color:var(--fg-5);font-size:11.5px;letter-spacing:.04em}.v2-stylebar{position:absolute;z-index:46;padding:10px 12px 12px;border-radius:var(--radius-md);background:#0e101af0;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px)}@media(prefers-reduced-motion:no-preference){.v2-stylebar{animation:ctxIn .26s var(--ease-out-soft) both}}.v2-stylebar .hd{display:flex;align-items:center;justify-content:space-between;font-size:10.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5);margin-bottom:9px}.v2-stylebar .hd .x{width:22px;height:22px;border:0;padding:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center}.v2-stylebar .hd .x:hover{background:#ffffff14;color:var(--fg-1)}.v2-stylebar .sw-grid{display:grid;grid-template-columns:repeat(9,1fr);gap:6px}.v2-stylebar .sw{width:100%;aspect-ratio:1;padding:2px;border:1px solid transparent;border-radius:8px;background:#ffffff0d;cursor:pointer;display:flex;transition:border-color var(--dur-fast),background var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.v2-stylebar .sw span{flex:1;border-radius:5px;box-shadow:inset 0 0 0 1px #ffffff24}.v2-stylebar .sw:hover{background:#ffffff1f;transform:scale(1.08)}.v2-stylebar .sw.on{border-color:var(--cv-accent-text);background:var(--cv-accent-tint)}.v2-stylebar .wrow{display:flex;align-items:center;gap:10px;margin-top:13px}.v2-stylebar .wrow .lb{font-size:12px;color:var(--fg-3);flex:none}.v2-stylebar input[type=range]{flex:1;min-width:0;-webkit-appearance:none;appearance:none;height:3px;border-radius:999px;background:#ffffff29;outline:none}.v2-stylebar input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;width:14px;height:14px;border-radius:50%;background:var(--fg-1);border:0;cursor:pointer;box-shadow:0 2px 6px #02040c80}.v2-stylebar input[type=range]::-moz-range-thumb{width:14px;height:14px;border-radius:50%;background:var(--fg-1);border:0;cursor:pointer}.v2-stylebar .num{flex:none;display:flex;align-items:stretch;height:28px;border:1px solid var(--hairline-soft);border-radius:8px;overflow:hidden;background:#ffffff0a}.v2-stylebar .num>span{display:inline-flex;align-items:center;justify-content:center;width:32px;font-size:12.5px;font-variant-numeric:tabular-nums;color:var(--fg-1)}.v2-stylebar .num .stp{display:flex;flex-direction:column;border-left:1px solid var(--hairline-soft)}.v2-stylebar .num .stp button{flex:1;width:20px;border:0;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;padding:0}.v2-stylebar .num .stp button:hover{background:#ffffff1a;color:var(--fg-1)}.v2-stylebar .prev{margin-top:11px;border-radius:9px;background:#ffffff0a;padding:6px 0;display:flex;align-items:center;overflow:hidden}.rs{position:absolute;left:14px;bottom:22px;z-index:44;display:flex;flex-direction:column;width:58px;max-height:calc(100vh - 230px);overflow:hidden;border-radius:14px;background:#121521b8;backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);font-family:var(--font-sans);transition:width .42s cubic-bezier(.16,1,.3,1)}.rs.is-open{width:336px}.rs-head{display:flex;align-items:center;gap:7px;height:0;padding:0 12px;opacity:0;overflow:hidden;transition:height .36s cubic-bezier(.16,1,.3,1),padding .36s,opacity .2s}.rs.is-open .rs-head{height:32px;padding-top:6px;opacity:1}.rs-eyebrow{font-size:9.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4);white-space:nowrap}.rs-count{font-size:10px;font-weight:600;color:var(--fg-3);padding:1px 6px;border-radius:999px;background:#ffffff0f;font-variant-numeric:tabular-nums}.rs-list{display:flex;flex-direction:column;gap:2px;padding:5px 5px 0;max-height:200px;overflow:hidden;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent;transition:max-height .42s cubic-bezier(.16,1,.3,1)}.rs.is-open .rs-list{flex:none;height:200px;max-height:200px;overflow-y:auto;overscroll-behavior:contain}.rs-list::-webkit-scrollbar{width:5px}.rs-list::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.rs-head,.rs-more{flex-shrink:0}.rs-row{position:relative;display:flex;align-items:center;gap:11px;flex:none;width:324px;padding:5px;border:0;border-radius:11px;background:transparent;color:inherit;cursor:pointer;font-family:var(--font-sans);transition:background var(--dur-fast)}.rs-row:hover{background:#ffffff12}.rs-row.on{background:var(--cv-accent-tint)}.rs-row.on .rs-shot{box-shadow:0 0 0 2px var(--cv-accent-text)}.rs-row.is-ref-target,.rs-item:hover .rs-row.is-ref-target{background:var(--cv-accent-tint);box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft)}.rs-item{position:relative;flex:none}.rs-item:hover .rs-row{background:#ffffff12}.rs-item:hover .rs-row.on{background:var(--cv-accent-tint)}.rs.is-open .rs-row{padding-right:38px}.rs-pin{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;pointer-events:none;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.rs.is-open .rs-pin{pointer-events:auto}.rs.is-open .rs-item:hover .rs-pin,.rs.is-open .rs-pin.on,.rs.is-open .rs-pin:focus-visible{opacity:1}.rs-pin:hover{background:#ffffff17;color:#fff}.rs-pin.on{color:var(--cv-accent-text)}.rs-pin.on svg{fill:currentColor}.rs-shot .pin{position:absolute;left:-4px;top:-4px;width:15px;height:15px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:var(--cv-accent);color:#fff;box-shadow:0 0 0 2px #121521f2;transition:opacity .18s}.rs-shot .pin svg{fill:currentColor}.rs.is-open .rs-shot .pin{opacity:0}.rs-shot{position:relative;flex:none;display:inline-flex;align-items:center;justify-content:center;width:38px;height:38px;border-radius:10px;background-color:#ffffff0f;background-size:cover;background-position:center;color:var(--fg-3);box-shadow:inset 0 0 0 1px #ffffff1a;transition:box-shadow var(--dur-fast)}.rs-shot .k{position:absolute;right:-3px;bottom:-3px;width:15px;height:15px;border-radius:5px;display:flex;align-items:center;justify-content:center;background:#090b13f0;color:var(--fg-2);box-shadow:0 0 0 1px var(--hairline)}.rs-shot .busy{position:absolute;inset:0;border-radius:10px;overflow:hidden}.rs-shot .busy:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.18) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.rs-meta{min-width:0;flex:1;display:flex;flex-direction:column;gap:2px;text-align:left;opacity:0;transition:opacity .18s}.rs-n{flex:none;font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums;padding-right:4px;opacity:0;transition:opacity .18s}.rs.is-open .rs-meta,.rs.is-open .rs-n{opacity:1;transition-delay:.08s}.rs-name{font-size:12.5px;font-weight:500;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rs-sub{display:flex;align-items:baseline;gap:5px;min-width:0;font-size:10.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rs-sub .kind{font-size:9px;font-weight:600;letter-spacing:.16em;text-transform:uppercase}.rs-sub .sep{color:var(--fg-5)}.rs-more{align-self:flex-start;margin:3px 0 7px 9px;width:38px;text-align:center;font-size:10.5px;font-weight:600;color:var(--fg-3)}.rs-tools{flex:none;display:flex;flex-direction:column;gap:8px;width:324px;max-height:0;padding:0 6px;overflow:hidden;opacity:0;pointer-events:none;transition:max-height .36s cubic-bezier(.16,1,.3,1),padding .36s,opacity .2s}.rs.is-open .rs-tools{max-height:110px;padding:6px 6px 4px;opacity:1;pointer-events:auto;transition-delay:0s,0s,.06s}.v2-dock-search{flex:none;display:flex;align-items:center;gap:8px;height:34px;padding:0 10px;border:1px solid var(--hairline-soft);border-radius:11px;background:#ffffff0a;color:var(--fg-4);transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.v2-dock-search:focus-within{border-color:var(--cv-accent-soft);box-shadow:0 0 0 3px var(--cv-accent-tint)}.v2-dock-search input{flex:1;min-width:0;border:0;background:transparent;outline:none;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;user-select:text;-webkit-user-select:text}.v2-dock-search input::placeholder{color:var(--fg-5)}.v2-dock-filters{flex:none;display:flex;flex-wrap:nowrap;gap:5px}.v2-fchip{flex:none;height:26px;padding:0 11px;border:1px solid var(--hairline-soft);border-radius:999px;background:#ffffff09;color:var(--fg-3);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.v2-fchip:hover{background:#ffffff14;color:var(--fg-1)}.v2-fchip.on{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff}.rs-filters{gap:4px;overflow-x:auto;scrollbar-width:none}.rs-filters::-webkit-scrollbar{display:none}.rs-filters .v2-fchip{padding:0 9px}.rs-none{width:314px;padding:18px 8px;text-align:center;font-size:12px;color:var(--fg-4)}.rs-pad{flex:none;height:5px}.rs.is-open .rs-pad{height:6px}.rs-empty-body{display:flex;align-items:center;gap:11px;width:324px;padding:9px 9px 0}.rs-empty.is-open .rs-empty-body{padding:5px 9px 0}.rs-empty-slot{flex:none;width:38px;height:38px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px dashed rgba(255,255,255,.22);border-radius:10px;background:#ffffff08;color:var(--fg-3);cursor:pointer;transition:border-color var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.rs-empty-slot:hover{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:var(--cv-accent-text)}.rs-empty-txt{min-width:0;flex:1;display:flex;flex-direction:column;gap:3px;opacity:0;transition:opacity .18s}.rs-empty.is-open .rs-empty-txt{opacity:1;transition-delay:.08s}.rs-empty-txt .t{font-size:12.5px;font-weight:500;color:var(--fg-1);white-space:nowrap}.rs-empty-txt .s{font-size:11px;line-height:1.45;color:var(--fg-4);text-wrap:pretty}.rs-empty-kinds{display:flex;gap:5px;width:324px;max-height:0;padding:0 6px;overflow:hidden;opacity:0;transition:max-height .36s cubic-bezier(.16,1,.3,1),padding .36s,opacity .2s}.rs-empty.is-open .rs-empty-kinds{max-height:40px;padding:10px 6px 0;opacity:1}.rs-empty-kind{display:inline-flex;align-items:center;gap:4px;height:24px;padding:0 9px;border:1px solid transparent;border-radius:999px;background:#ffffff0d;color:var(--fg-3);font:inherit;font-size:10.5px;white-space:nowrap;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.rs-empty-kind:hover{background:var(--cv-accent-tint);border-color:#c2a4ec4d;color:var(--cv-accent-text)}.rs-empty-cta{flex:none;display:flex;align-items:center;justify-content:center;gap:6px;width:288px;height:0;margin:0 6px;padding:0;border:0;border-radius:10px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:12px;font-weight:600;white-space:nowrap;cursor:pointer;opacity:0;pointer-events:none;overflow:hidden;transition:opacity .18s,height .3s,margin .3s,transform var(--dur-fast)}.rs-empty.is-open .rs-empty-cta{height:34px;margin:10px 6px 0;opacity:1;pointer-events:auto}.rs-empty-cta:hover{transform:translateY(-1px)}.rs-empty .rs-pad{height:9px}.rs-empty.is-open .rs-pad{height:6px}.v2-placewrap{position:relative;display:inline-flex}.v2-placemenu{position:absolute;left:50%;bottom:calc(100% + 14px);transform:translate(-50%);z-index:46;width:292px;padding:6px;border-radius:var(--radius-md);background:#121521e6;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(28px) saturate(110%);-webkit-backdrop-filter:blur(28px) saturate(110%)}.v2-placemenu .am-row .cv-badge{color:var(--fg-2)}.v2-placemenu .am-row .cv-badge.is-lib{background:linear-gradient(135deg,#9968df52,#5a61ed38);color:#fff}.v2-placemenu .am-name,.v2-placemenu .am-sub{display:block}.v2-placemenu-enter-active,.v2-placemenu-leave-active{transition:opacity .18s var(--ease-out-soft),transform .18s var(--ease-out-soft)}.v2-placemenu-enter-from,.v2-placemenu-leave-to{opacity:0;transform:translate(-50%) translateY(6px) scale(.98)}.bd-pointmenu{position:absolute;left:0;top:0;z-index:72;border-radius:var(--radius-md);font-family:var(--font-sans);outline:none;background:#121521e0;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(28px) saturate(110%);-webkit-backdrop-filter:blur(28px) saturate(110%);transform-origin:var(--pm-origin, top left)}@media(prefers-reduced-motion:no-preference){.bd-pointmenu{animation:pmIn .16s var(--ease-out-soft) both}@keyframes pmIn{0%{opacity:0;transform:scale(.96)}to{opacity:1;transform:none}}}.v2-root.light-canvas .bd-pointmenu{background:#121521f0}.bd-pointmenu kbd{flex:none;display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 5px;border-radius:5px;border:1px solid var(--hairline);background:#ffffff0a;font-family:var(--font-sans);font-size:10px;font-weight:600;line-height:1;color:var(--fg-3)}.bd-canvasmenu{width:212px;padding:5px}.bd-pm-eyebrow{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-5);padding:7px 8px 5px}.bd-pm-row{display:flex;align-items:center;gap:10px;width:100%;height:32px;padding:0 7px 0 4px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);cursor:pointer;outline:none;font-family:var(--font-sans);font-size:12.5px;font-weight:500;letter-spacing:-.01em;text-align:left;transition:background var(--dur-fast),color var(--dur-fast)}.bd-pm-row:hover,.bd-pm-row:focus{background:#ffffff12;color:var(--fg-1)}.bd-pm-row .lbl{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.bd-pm-add{flex:none;display:inline-flex;color:var(--cv-accent-text);opacity:0;transform:translate(-3px);transition:opacity var(--dur-fast),transform var(--dur-fast)}.bd-pm-row:hover .bd-pm-add,.bd-pm-row:focus .bd-pm-add{opacity:1;transform:none}.bd-pm-ic{flex:none;width:24px;height:24px;border-radius:7px;display:inline-flex;align-items:center;justify-content:center;background:#ffffff0f;box-shadow:inset 0 1px #ffffff14;color:var(--cv-accent-text)}.bd-pm-ic.is-plain{color:var(--fg-2)}.bd-pm-ic.is-prompts{background:linear-gradient(135deg,#9968df52,#5a61ed38);color:#fff}.bd-pm-sep{height:1px;margin:5px 6px;background:var(--hairline-soft)}.bd-ctxmenu{width:224px;padding:5px}.bd-pm-ic.is-bare{width:20px;background:none;box-shadow:none}.bd-pm-row:disabled{cursor:default;color:var(--fg-5);background:transparent}.bd-pm-row:disabled .bd-pm-ic,.bd-pm-row:disabled kbd{opacity:.45}.bd-pm-row.is-danger:not(:disabled):hover,.bd-pm-row.is-danger:not(:disabled):focus{background:#ff5c7a24;color:var(--danger)}.bd-pm-row.is-danger:not(:disabled):hover .bd-pm-ic,.bd-pm-row.is-danger:not(:disabled):focus .bd-pm-ic{color:var(--danger)}.bd-finder{width:380px;display:flex;flex-direction:column;overflow:hidden}.sf-searchrow{flex:none;padding:10px 8px 8px 10px}.sf-filters{padding:0 10px 4px;gap:4px;overflow-x:auto;scrollbar-width:none}.sf-filters::-webkit-scrollbar{display:none}.sf-filters .v2-fchip{padding:0 10px}.sf-body{flex:1;min-height:0;overflow-y:auto;overscroll-behavior:contain;padding:0 6px 6px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.sf-body::-webkit-scrollbar{width:5px}.sf-body::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.sf-eyebrow{display:flex;align-items:center;gap:7px;padding:12px 6px 6px;font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-5)}.sf-eyebrow .n{font-size:10px;letter-spacing:0;color:var(--fg-3);padding:1px 6px;border-radius:999px;background:#ffffff0f;font-variant-numeric:tabular-nums}.sf-kits{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:5px;padding:0 2px}.sf-kit,.sf-prompts{display:flex;align-items:center;gap:8px;min-width:0;height:40px;padding:0 8px 0 7px;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff08;color:var(--fg-1);cursor:pointer;text-align:left;font-family:var(--font-sans);font-size:12px;font-weight:600;letter-spacing:-.01em;transition:background var(--dur-fast),border-color var(--dur-fast)}.sf-kit .nm{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sf-kit.is-active,.sf-prompts.is-active{background:#ffffff12;border-color:var(--cv-accent-soft)}.sf-kit-ic{position:relative;transition:background var(--dur-fast)}.sf-add{position:absolute;right:-5px;bottom:-5px;width:14px;height:14px;border-radius:5px;display:flex;align-items:center;justify-content:center;background:var(--grad-cta);color:#fff;box-shadow:0 0 0 1.5px #0a0c14f2,0 2px 6px #745aff59;opacity:0;transform:scale(.4);transition:opacity .14s ease,transform .22s var(--ease-out-soft)}.sf-kit:hover .sf-add,.sf-kit.is-active .sf-add{opacity:1;transform:none}.sf-kit:hover .sf-kit-ic,.sf-kit.is-active .sf-kit-ic{background:var(--cv-accent-tint)}@media(prefers-reduced-motion:reduce){.sf-add{transition:none}}.sf-prompts{width:calc(100% - 4px);margin:0 2px}.sf-prompts .nm{flex:none;white-space:nowrap}.sf-prompts .sub{min-width:0;font-size:11px;font-weight:500;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sf-item{position:relative}.sf-row{display:flex;align-items:center;gap:11px;width:100%;padding:5px 40px 5px 5px;border:0;border-radius:11px;background:transparent;color:inherit;cursor:pointer;text-align:left;font-family:var(--font-sans);transition:background var(--dur-fast)}.sf-item.is-active .sf-row{background:#ffffff12}.sf-meta{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.sf-n{flex:none;font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.sf-pin{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.sf-item:hover .sf-pin,.sf-item.is-active .sf-pin,.sf-pin.on{opacity:1}.sf-pin:hover{background:#ffffff17;color:#fff}.sf-pin.on{color:var(--cv-accent-text)}.sf-pin.on svg{fill:currentColor}.sf-none{padding:22px 8px;text-align:center;font-size:12px;color:var(--fg-4)}.bd-linkmenu{width:340px}.bl-row{padding-right:10px}.bl-ic{flex:none;width:34px;height:34px;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;background:#5a61ed29;color:#c9ccfa}.bl-row.is-new .bl-ic{background:var(--cv-accent-tint);color:var(--cv-accent-soft)}.sf-foot{flex:none;display:flex;align-items:center;gap:14px;height:34px;padding:0 12px;border-top:1px solid var(--hairline-soft);font-size:11px;color:var(--fg-4)}.sf-foot>span{display:inline-flex;align-items:center;gap:3px}.sf-foot kbd{margin-right:3px}.bd-siderail{position:absolute;z-index:46;top:66px;right:14px;display:flex;flex-direction:column;gap:2px;padding:4px;border-radius:13px;background:#121521b8;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),var(--shadow-deep);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px)}.bd-siderail-btn{position:relative;width:36px;height:36px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.bd-siderail-btn:hover{background:#ffffff14;color:var(--fg-1)}.bd-siderail-btn.on{background:var(--cv-accent-tint);color:#fff;box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.bd-siderail-btn .badge{position:absolute;left:-5px;top:-5px;min-width:16px;height:16px;padding:0 4px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent);color:#fff;font-size:9.5px;font-weight:700;line-height:1;font-variant-numeric:tabular-nums;box-shadow:0 0 0 2px #121521f2;pointer-events:none}.bd-siderail-btn .tip{position:absolute;right:calc(100% + 12px);top:50%;transform:translateY(-50%) translate(4px);background:#0b0d14eb;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:11px;font-weight:500;padding:5px 10px;border-radius:8px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.bd-siderail-btn:hover .tip{opacity:1;transform:translateY(-50%);transition-delay:.26s}.bd-siderail-btn.on .tip{display:none}.bd-boardhist.sv-hist{position:absolute;z-index:46;top:66px;right:68px;bottom:14px;width:330px;margin:0;background:#0b0d15f7;border-color:var(--hairline);animation:histIn .26s var(--ease-out-soft) both}.bd-boardhist .sv-hist-head .t,.bd-boardhist .sv-hist-head .n{display:revert}.bd-boardhist-close{flex:none;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.bd-boardhist-close:hover{background:#ffffff14;color:var(--fg-1)}.bd-boardhist .sv-cell{touch-action:none}.bd-boardhist-vid{position:absolute;left:6px;top:6px;z-index:2;display:inline-flex;align-items:center;gap:3px;height:16px;padding:0 5px;border-radius:5px;background:#04030cb8;color:#fff;font-size:9.5px;font-weight:600;font-variant-numeric:tabular-nums;pointer-events:none}.bd-boardhist.cols-4 .bd-boardhist-vid,.bd-boardhist.cols-5 .bd-boardhist-vid{left:4px;top:4px;padding:0 3px;font-size:0;gap:0}.bd-boardhist-play{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:14px;pointer-events:none}.sv-hist-filterrow{flex:none;display:flex;align-items:center;gap:6px;margin:10px 0 8px}.sv-hist-filterrow .sv-hist-filter{flex:1;min-width:0;margin:0}.sv-hist-filter.is-resting .sv-hist-filter-btn{cursor:default;color:var(--fg-2)}.sv-hist-filter.is-resting .sv-hist-filter-btn:hover{background:#ffffff0d}.sv-hist-filter.is-resting .sv-hist-filter-btn .chev{opacity:.35}.sv-hist-pinned{flex:none;display:inline-flex;align-items:center;justify-content:center;gap:5px;min-width:32px;height:32px;padding:0 9px;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff0d;color:var(--fg-3);cursor:pointer;font-family:var(--font-sans);font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sv-hist-pinned:hover{background:#ffffff17;color:var(--fg-1)}.sv-hist-pinned.on{background:#9968df2e;border-color:#9968df80;color:#fff}.sv-hist-pinned.on svg{fill:currentColor}.sv-hist-pinned .ct{color:inherit;opacity:.8}.sv-cell-pin,.v2-hist-pin,.cv-img-pin{display:inline-flex;align-items:center;justify-content:center;border-radius:50%;background:var(--cv-accent);color:#fff;box-shadow:0 0 0 1.5px #090b13d9;pointer-events:none}.sv-cell-pin svg,.v2-hist-pin svg,.cv-img-pin svg{fill:currentColor}.sv-cell-pin{position:absolute;right:6px;top:6px;z-index:2;width:18px;height:18px}.sv-hist.cols-4 .sv-cell-pin,.sv-hist.cols-5 .sv-cell-pin{right:4px;top:4px;width:14px;height:14px}.sv-hist.cols-4 .sv-cell-pin svg,.sv-hist.cols-5 .sv-cell-pin svg{width:8px;height:8px}.v2-hist-pin{position:absolute;right:5px;bottom:5px;z-index:2;width:16px;height:16px}.cv-img-pin{position:absolute;top:8px;right:8px;width:20px;height:20px}.cv-img-vid+.cv-img-fav:has(+.cv-img-pin){right:34px}.sv-hist-acts button.is-pin.on{background:var(--amethyst-400);border-color:transparent}.sv-hist-acts button.is-pin.on svg,.v2-hist-acts button.is-pin.on svg{fill:currentColor}.v2-hist-acts button.is-pin.on{background:var(--amethyst-400);border-color:transparent;color:#fff}.pe{grid-column:1 / -1;display:flex;flex-direction:column;align-items:center;text-align:center;padding:22px 14px 18px}.pe-art{position:relative;width:184px;height:112px;margin-bottom:14px}.pe-glow{position:absolute;left:50%;top:54%;width:170px;height:110px;translate:-50% -50%;border-radius:50%;background:radial-gradient(closest-side,rgba(153,104,223,.32),rgba(90,97,237,.12) 60%,transparent);filter:blur(6px)}.pe-card{position:absolute;width:60px;height:46px;border-radius:9px;overflow:hidden;box-shadow:inset 0 0 0 1px #ffffff2e,0 12px 26px #02040c8c}.pe-card.c1{left:28px;top:40px;rotate:-12deg;background:linear-gradient(160deg,#2d2160,#7532d3 58%,#c750ce)}.pe-card.c3{left:96px;top:40px;rotate:11deg;background:linear-gradient(165deg,#3a2240,#c750ce 52%,#ffb38a)}.pe-card.c2{left:62px;top:26px;rotate:-2deg;z-index:2;background:linear-gradient(175deg,#1d3a6e,#5a61ed 55%,#9ad0ff)}.pe-card .sun{position:absolute;right:10px;top:8px;width:10px;height:10px;border-radius:50%;background:#ffffffd1;box-shadow:0 0 10px #fff9}.pe-card .hill{position:absolute;left:-10px;right:-6px;bottom:-18px;height:30px;border-radius:50%;background:#090b1e8c}.pe-card .hill.b{left:26px;right:-30px;bottom:-20px;background:#090b1e59}.pe-pin{position:absolute;left:81px;top:15px;z-index:4;width:22px;height:22px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent);color:#fff;box-shadow:0 0 0 2px #0b0d15f2,0 6px 14px #02040c99}.pe-pin svg{fill:currentColor}.pe-ring{position:absolute;left:81px;top:15px;z-index:3;width:22px;height:22px;border-radius:50%;box-shadow:0 0 0 2px #c4a7ffe6;opacity:0}@media(prefers-reduced-motion:no-preference){.pe-card.c1{animation:peFloat 4.8s ease-in-out infinite}.pe-card.c3{animation:peFloat 4.8s ease-in-out -1.6s infinite}.pe-card.c2{animation:peSettle 4.8s var(--ease-out-soft) infinite}.pe-pin{animation:peDrop 4.8s var(--ease-out-soft) infinite}.pe-ring{animation:peRing 4.8s ease-out infinite}.pe-glow{animation:peGlow 4.8s ease-in-out infinite}@keyframes peFloat{0%,to{translate:0 0}50%{translate:0 -4px}}@keyframes peSettle{0%,26%{translate:0 -3px;scale:1}31%{translate:0 1px;scale:.97}40%,to{translate:0 0;scale:1}}@keyframes peDrop{0%{opacity:0;translate:0 -34px;rotate:-30deg;scale:1}12%{opacity:1}27%{translate:0 0;rotate:0deg;scale:1}31%{scale:.84}38%{scale:1}82%{opacity:1;translate:0 0;rotate:0deg}94%,to{opacity:0;translate:0 -8px;rotate:8deg}}@keyframes peRing{0%,29%{opacity:0;scale:.5}32%{opacity:.9;scale:.6}62%,to{opacity:0;scale:2.6}}@keyframes peGlow{0%,to{opacity:.75}35%{opacity:1}}}.pe-title{font-size:14px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em}.pe-body{margin:7px 0 0;max-width:270px;font-size:12px;line-height:1.55;color:var(--fg-3)}.pe-note{margin:0;max-width:292px;font-size:11px;line-height:1.5;color:var(--fg-4)}.pe-note:before{content:"";display:block;width:32px;height:1px;margin:16px auto 14px;background:var(--hairline)}.pe-hint{display:inline-flex;align-items:center;gap:6px;margin-top:14px;padding:4px 12px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0a;font-size:11px;color:var(--fg-3)}.pe-key{width:20px;height:20px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent-tint);color:var(--cv-accent-text)}.pe-key svg{fill:currentColor}.cv-ctxbar button.is-pin.on{color:var(--cv-accent-text);background:var(--cv-accent-tint)}.cv-ctxbar button.is-pin.on svg{fill:currentColor}.pe.is-compact{padding:2px 12px 6px}.pe.is-compact .pe-art{scale:.8;margin:-10px 0 -6px}.pe.is-compact .pe-private{margin-bottom:7px}.pe.is-compact .pe-title{font-size:13px}.pe.is-compact .pe-body{margin-top:4px;max-width:290px;font-size:11.5px}.pe.is-compact .pe-hint{margin-top:11px}.sv-hist-private,.pe-private{flex:none;display:inline-flex;align-items:center;gap:4px;height:18px;padding:0 7px;border-radius:999px;background:#9968df24;color:#c4a7ff;font-size:10px;font-weight:600;letter-spacing:.01em;white-space:nowrap}.pe-private{margin-bottom:9px;height:20px;padding:0 9px;font-size:10.5px}.up-studio-wrap{position:absolute;top:10px;right:12px;z-index:7;display:inline-flex}.up-studio{position:relative;isolation:isolate;display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 12px 0 10px;border-radius:999px;border:1px solid rgba(255,255,255,.1);background:#ffffff0a;color:var(--fg-3);font-family:var(--font-sans);font-size:12px;font-weight:600;letter-spacing:-.005em;cursor:pointer;transition:color var(--dur-fast),box-shadow var(--dur-med),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.up-studio:before{content:"";position:absolute;inset:-1px;z-index:-1;border-radius:inherit;opacity:0;background:linear-gradient(135deg,#9968df5c,#5a61ed3d);transition:opacity var(--dur-fast)}.up-studio:hover,.up-studio.on,.up-studio:focus-visible{color:#fff;border-color:#c4a2ffcc;box-shadow:inset 0 1px #fff3,0 6px 22px #7532d373;outline:none}.up-studio:hover:before,.up-studio.on:before,.up-studio:focus-visible:before{opacity:1}.up-studio:active{transform:scale(.97)}.up-studio .licon{color:var(--fg-4);transition:color var(--dur-fast)}.up-studio:hover .licon,.up-studio.on .licon,.up-studio:focus-visible .licon{color:#e6dbff}.up-card.has-refs .up-refs{padding-right:96px}.up-card:not(.has-refs) .up-text{padding-right:96px}.up-studio-pop{position:absolute;right:-6px;bottom:calc(100% + 10px);width:480px;border-radius:18px;overflow:hidden;cursor:pointer;background:#0f101a;border:1px solid rgba(255,255,255,.09);box-shadow:0 0 0 1px #9968df29,0 28px 70px #02040cb8,0 10px 24px #02040c73;transform-origin:calc(100% - 44px) 100%}.up-studio-pop-enter-active{transition:opacity .22s ease,transform .32s var(--ease-out-soft)}.up-studio-pop-leave-active{transition:opacity .14s ease,transform .16s ease}.up-studio-pop-enter-from,.up-studio-pop-leave-to{opacity:0;transform:translateY(8px) scale(.95)}.up-studio-pop .media{position:relative;aspect-ratio:16 / 9;background:#07080e;overflow:hidden}.up-studio-pop .media>video,.up-studio-pop .media>img{position:absolute;inset:0;display:block;width:100%;height:100%;object-fit:cover}.up-studio-pop .media>img{animation:upStudioDrift 4.2s ease-out both}@keyframes upStudioDrift{0%{transform:scale(1.06)}to{transform:scale(1)}}.up-studio-slide-enter-active,.up-studio-slide-leave-active{transition:opacity .45s ease}.up-studio-slide-enter-from,.up-studio-slide-leave-to{opacity:0}.up-studio-pop .media:after{content:"";position:absolute;left:0;right:0;bottom:0;height:48px;pointer-events:none;background:linear-gradient(180deg,transparent,rgba(15,16,26,.6))}.up-studio-pop .tag{position:absolute;left:12px;top:12px;z-index:1;display:inline-flex;align-items:center;gap:6px;padding:4px 10px 4px 8px;border-radius:999px;background:#04030c9e;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#fff;font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase}.up-studio-pop .tag .licon{color:#d9c6ff}.up-studio-pop .body{display:flex;flex-direction:column;gap:12px;padding:14px 18px 15px}.up-studio-pop .words{display:flex;flex-direction:column;gap:4px;height:62px;overflow:hidden}.up-studio-pop .words b{font-size:15px;font-weight:650;letter-spacing:-.01em;color:#fff}.up-studio-pop .words span{font-size:12.5px;line-height:1.45;color:var(--fg-3)}.up-studio-words-enter-active{transition:opacity .26s ease,transform .32s var(--ease-out-soft)}.up-studio-words-leave-active{transition:opacity .12s ease}.up-studio-words-enter-from{opacity:0;transform:translateY(4px)}.up-studio-words-leave-to{opacity:0}.up-studio-pop .foot{display:flex;align-items:center;justify-content:space-between}.up-studio-pop .dots{display:inline-flex;align-items:center;gap:5px}.up-studio-pop .dots button{position:relative;width:7px;height:7px;padding:0;border:0;border-radius:999px;overflow:hidden;cursor:pointer;background:#ffffff38;transition:width .32s var(--ease-out-soft),background var(--dur-fast)}.up-studio-pop .dots button:hover{background:#fff6}.up-studio-pop .dots button.on{width:26px;background:#ffffff29}.up-studio-pop .dots button.on i{position:absolute;inset:0;border-radius:inherit;transform-origin:0 50%;background:linear-gradient(90deg,var(--amethyst-500),#8b8ff5);animation:upStudioFill var(--d, 3.4s) linear both}@keyframes upStudioFill{0%{transform:scaleX(0)}to{transform:scaleX(1)}}.up-studio-pop .cta{display:inline-flex;align-items:center;gap:5px;font-size:12px;font-weight:600;color:var(--cv-accent-text);transition:gap var(--dur-fast)}.up-studio-pop:hover .cta{gap:7px;color:#fff}@media(prefers-reduced-motion:reduce){.up-studio-pop-enter-active,.up-studio-pop-leave-active,.up-studio-slide-enter-active,.up-studio-slide-leave-active,.up-studio-words-enter-active,.up-studio-words-leave-active{transition:none}.up-studio-pop .media>img{animation:none}.up-studio-pop .dots button.on i{animation:none;transform:none}}', BCe = '.bd-canvas-host{position:absolute;inset:0}.cv-el.is-tool .cv-el-body{height:100%}.cv-el.is-tool .cv-bucket{height:100%;display:flex;flex-direction:column}.cv-el.is-tool .cv-bucket-foot{margin-top:auto}.cv-bucket.is-busy .cv-badge{color:#fff;background:var(--cv-accent-tint)}.cv-el.is-frame-title{pointer-events:none}.cv-el.is-frame-title .cv-frame-title{pointer-events:auto}.cv-note-text:empty:before{content:attr(data-placeholder);color:#ffffff57}.v2-root.light-canvas .cv-note-text:empty:before{color:var(--lc-ink-3)}.up-drop-wrap{position:relative;display:inline-flex}.up-text-static{display:flex;align-items:center;color:var(--fg-4);font-size:13px;line-height:1.5;min-height:70px;padding:4px 10px 0;margin:0 -10px;border-radius:12px;border:1px dashed transparent;transition:border-color var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.up-text-static.is-target{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:var(--fg-2)}.up-card.has-refs .up-text-static{min-height:48px}.up-refpick{min-width:300px;width:300px}.up-refpick.has-tabs{width:404px}.up-pop.up-refpick{max-height:min(460px,64vh)}.up-refpick-note{display:flex;align-items:center;gap:8px;padding:4px 6px 8px}.up-refpick-more{justify-content:center}.up-refpick-tip{display:flex;align-items:center;gap:9px;margin:6px 0 0;padding:9px 8px 3px;border-top:1px solid var(--hairline-soft);font-size:11px;line-height:1.45;color:var(--fg-4)}.up-refpick-tip kbd{flex:none;display:inline-flex;align-items:center;justify-content:center;min-width:20px;height:20px;padding:0 5px;border-radius:6px;border:1px solid var(--hairline);background:#ffffff0d;font-family:var(--font-sans);font-size:11px;font-weight:600;line-height:1;color:var(--cv-accent-text)}.up-refpick-more .up-pop-main{flex:none}.up-refcell.is-video{position:relative}.up-refcell.is-video:after{content:"";position:absolute;right:5px;bottom:5px;width:0;height:0;border-left:7px solid rgba(255,255,255,.9);border-top:4.5px solid transparent;border-bottom:4.5px solid transparent;filter:drop-shadow(0 1px 2px rgba(0,0,0,.6))}.up-drop.up-more{flex-direction:column;gap:1px;border-style:solid;border-color:var(--hairline)}.up-drop.up-more .n{font-size:15px;font-weight:600;color:var(--fg-2);letter-spacing:-.01em}.up-drop.up-more .s{font-size:9px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--fg-4)}.up-drop.up-more.has-some .s{color:var(--cv-accent-text)}.up-drop.up-more.on{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint)}.up-refmore{width:276px;min-width:0}.up-moregrid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px 8px;padding:2px 4px 4px}.up-morecell{display:flex;flex-direction:column;align-items:center;gap:5px;min-width:0}.up-morecell .lbl{max-width:100%;font-size:9.5px;font-weight:500;color:var(--fg-3);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.up-drop.is-sm,.up-ref.is-sm{width:52px;height:52px;border-radius:11px}.up-refgrid{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;padding:2px 2px 8px;max-height:230px;overflow-y:auto}.up-refpick .up-refgrid{margin-bottom:6px}.up-refcell{aspect-ratio:1;border:0;padding:0;border-radius:8px;cursor:pointer;background-color:#ffffff0d;background-size:cover;background-position:center;box-shadow:inset 0 0 0 1px #ffffff14;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.up-refcell:hover{transform:translateY(-1px);box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft),0 8px 20px #02040c80}.bd-drop{position:absolute;inset:52px 0 0;z-index:95;pointer-events:none;display:flex;align-items:center;justify-content:center;background:#9968df0f;box-shadow:inset 0 0 0 2px #9968df73;animation:cvFade var(--dur-fast) ease both}.bd-drop-card{display:inline-flex;align-items:center;gap:10px;padding:14px 20px;border-radius:16px;background:#0b0d15eb;border:1px solid var(--hairline);color:var(--fg-1);font-size:13px;font-weight:600;box-shadow:var(--shadow-deep)}.bd-empty{position:absolute;inset:52px 0 0;z-index:40;pointer-events:none;display:flex;align-items:center;justify-content:center;padding-bottom:60px}.bd-empty-card{pointer-events:none;width:fit-content;min-width:min(380px,calc(100vw - 32px));max-width:calc(100vw - 32px);display:flex;flex-direction:column;align-items:center;text-align:center;gap:8px;padding:26px 26px 20px;border-radius:22px;background:linear-gradient(180deg,#ffffff12,#ffffff06);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 30px 80px #02040c8c;backdrop-filter:blur(24px) saturate(120%);-webkit-backdrop-filter:blur(24px) saturate(120%);font-family:var(--font-sans)}.bd-empty-mark{width:42px;height:42px;border-radius:14px;margin-bottom:6px;display:flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:0 12px 30px #745aff59}.bd-empty-card b{font-size:16px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.bd-empty-sub{font-size:12.5px;line-height:1.5;color:var(--fg-3);max-width:280px}.bd-empty-actions{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin-top:10px}.bd-empty-actions button{pointer-events:auto}.bd-empty-keys{margin-top:12px;font-size:11px;color:var(--fg-4);display:flex;align-items:center;gap:5px;flex-wrap:wrap;justify-content:center}.bd-empty-keys kbd{display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 4px;margin-left:6px;border-radius:5px;border:1px solid var(--hairline);background:#ffffff0d;font-family:var(--font-sans);font-size:10px;font-weight:600;color:var(--fg-2)}.bd-empty-keys kbd:first-child{margin-left:0}.bd-empty-enter-active{transition:opacity .5s var(--ease-out-soft) .25s,transform .5s var(--ease-out-soft) .25s}.bd-empty-leave-active{transition:opacity .18s ease,transform .18s ease}.bd-empty-enter-from{opacity:0;transform:translateY(8px) scale(.985)}.bd-empty-leave-to{opacity:0;transform:scale(.985)}.light-canvas .bd-empty-card{background:#ffffffeb;border-color:#1318281a;box-shadow:0 1px 2px #13182814,0 24px 60px #1318281f}.light-canvas .bd-empty-card b{color:#131828}.light-canvas .bd-empty-sub,.light-canvas .bd-empty-keys{color:#13182899}.light-canvas .bd-empty-keys kbd{color:#131828bf;background:#1318280a;border-color:#13182824}@media(prefers-reduced-motion:reduce){.bd-empty-enter-active,.bd-empty-leave-active{transition:opacity .2s ease}.bd-empty-enter-from,.bd-empty-leave-to{transform:none}}.bd-toast{position:absolute;left:50%;bottom:186px;z-index:96;transform:translate(-50%);display:inline-flex;align-items:center;gap:8px;max-width:min(560px,calc(100vw - 32px));padding:9px 14px;border-radius:999px;background:#11131ef5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 18px 44px #02040c8c;color:var(--fg-1);font-size:12px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none}.bd-toast .licon{color:var(--success)}.bd-toast.is-error{border-color:#ff5c7a59}.bd-toast.is-error .licon{color:var(--danger)}.bd-toast.is-error{white-space:normal;align-items:flex-start;border-radius:14px;max-width:min(460px,calc(100vw - 32px));line-height:1.45;text-align:left}.bd-toast.is-error .licon{margin-top:2px}.bd-toast-enter-active{transition:opacity .3s var(--ease-out-soft),transform .3s var(--ease-out-soft)}.bd-toast-leave-active{transition:opacity .2s ease,transform .2s ease}.bd-toast-enter-from,.bd-toast-leave-to{opacity:0;transform:translate(-50%) translateY(8px)}.bd-dropper{position:absolute;left:50%;top:72px;z-index:60;transform:translate(-50%);display:inline-flex;align-items:center;gap:10px;max-width:min(620px,calc(100vw - 32px));padding:5px 5px 5px 6px;border-radius:999px;background:#11131ef5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 18px 44px #02040c8c;color:var(--fg-1);font-size:12.5px;font-weight:500;white-space:nowrap}.bd-dropper-mark{flex:none;width:26px;height:26px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent-tint);color:var(--cv-accent-text)}.bd-dropper-text{min-width:0;overflow:hidden;text-overflow:ellipsis}.bd-dropper-count{flex:none;color:var(--fg-4);font-variant-numeric:tabular-nums}.bd-dropper-done{flex:none;height:26px;padding:0 12px;border:0;border-radius:999px;cursor:pointer;background:#ffffff14;color:var(--fg-1);font:inherit;font-weight:600;transition:background var(--dur-fast)}.bd-dropper-done:hover{background:#ffffff24}.bd-dropper-enter-active{transition:opacity .25s var(--ease-out-soft),transform .25s var(--ease-out-soft)}.bd-dropper-leave-active{transition:opacity .18s ease,transform .18s ease}.bd-dropper-enter-from,.bd-dropper-leave-to{opacity:0;transform:translate(-50%) translateY(-6px)}.bd-stats{position:absolute;left:82px;top:62px;z-index:97;display:flex;flex-direction:column;gap:2px;padding:8px 10px;border-radius:10px;background:#04030cd1;border:1px solid var(--hairline-soft);font-family:ui-monospace,SF Mono,Menlo,monospace;font-size:10.5px;color:var(--fg-3);pointer-events:none;font-variant-numeric:tabular-nums}.bd-stats b{color:var(--success);font-size:12px}.bd-stats b.warn{color:var(--warning)}.bd-stats b.bad{color:var(--danger)}.sx{--sx-mono: ui-monospace, "SF Mono", Menlo, monospace;position:absolute;left:14px;top:66px;z-index:45;width:304px;max-width:calc(100vw - 28px);max-height:max(300px,calc(100% - 336px));display:flex;flex-direction:column;border-radius:18px;background:#0b0d15e6;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 28px 80px #02040c99;font-family:var(--font-sans);color:var(--fg-2);animation:sxIn .34s var(--ease-out-soft) both}@keyframes sxIn{0%{opacity:0;transform:translateY(-6px) scale(.985)}to{opacity:1;transform:none}}.sx:before{content:"";position:absolute;left:22px;right:22px;top:-1px;height:1px;pointer-events:none;background:linear-gradient(90deg,transparent,rgba(199,80,206,.55),rgba(153,104,223,.7),rgba(90,97,237,.55),transparent)}.sx.is-collapsed{width:auto}.sx-head{flex:none;display:flex;align-items:center;gap:10px;padding:11px 11px 11px 12px}.sx-mark{flex:none;width:30px;height:30px;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:inset 0 1px #ffffff38,0 8px 20px #745aff52}.sx-title{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}.sx-title b{font-size:13px;font-weight:600;color:var(--fg-1);letter-spacing:.005em}.sx-title span{font-size:11px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sx-fps{flex:none;min-width:58px;text-align:center;padding:4px 9px;border-radius:999px;font:600 11.5px var(--sx-mono);font-variant-numeric:tabular-nums;color:var(--success);background:#37d3991a;border:1px solid rgba(55,211,153,.22);transition:color var(--dur-fast),background var(--dur-fast),border-color var(--dur-fast)}.sx-fps.is-warn{color:var(--warning);background:#ffb3471a;border-color:#ffb34742}.sx-fps.is-bad{color:var(--danger);background:#ff5c7a1a;border-color:#ff5c7a47}.sx-icon{flex:none;width:26px;height:26px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid var(--hairline-soft);border-radius:8px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sx-icon:hover{background:#ffffff17;color:var(--fg-1)}.sx-pinned{flex:none;display:flex;flex-direction:column;gap:6px;padding:0 12px}.sx-body{min-height:0;overflow-y:auto;overscroll-behavior:contain;padding:12px}.sx-body::-webkit-scrollbar{width:8px}.sx-body::-webkit-scrollbar-thumb{background:#ffffff14;border-radius:4px;border:2px solid transparent;background-clip:content-box}.sx-pane{animation:sxPane .24s var(--ease-out-soft) both}@keyframes sxPane{0%{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}.sx-graph{position:relative;flex:none;height:44px;border-radius:11px;overflow:hidden;background:linear-gradient(180deg,#ffffff04,#ffffff0a);border:1px solid var(--hairline-soft)}.sx-graph canvas{display:block;width:100%;height:100%}.sx-graph-label{position:absolute;left:8px;top:5px;font:500 9.5px var(--sx-mono);color:var(--fg-5);pointer-events:none}.sx-live{display:grid;grid-template-columns:repeat(3,1fr);gap:5px}.sx-live>div{display:flex;flex-direction:column;gap:1px;padding:6px 9px;border-radius:9px;background:#ffffff09}.sx-live b{font:600 12px var(--sx-mono);font-variant-numeric:tabular-nums;color:var(--fg-1)}.sx-live span{font-size:9.5px;color:var(--fg-4);white-space:nowrap}.sx-tabs{display:flex;gap:18px;margin-top:4px;padding:0 2px;border-bottom:1px solid var(--hairline-soft)}.sx-tabs button{position:relative;height:32px;display:inline-flex;align-items:center;gap:6px;padding:0;border:0;background:transparent;color:var(--fg-4);cursor:pointer;font-size:12px;font-weight:600;transition:color var(--dur-fast)}.sx-tabs button:hover{color:var(--fg-2)}.sx-tabs button.is-on{color:var(--fg-1)}.sx-tabs button:after{content:"";position:absolute;left:0;right:0;bottom:-1px;height:2px;border-radius:2px;background:var(--grad-cta);transform:scaleX(0);transition:transform var(--dur-med) var(--ease-out-soft)}.sx-tabs button.is-on:after{transform:scaleX(1)}.sx-tab-n{padding:1px 6px;border-radius:999px;background:#ffffff12;color:var(--fg-3);font-size:9.5px;font-variant-numeric:tabular-nums}.sx-dot{width:6px;height:6px;border-radius:50%;background:var(--amethyst-600);box-shadow:0 0 8px var(--amethyst-500);animation:sxPulse 1s ease-in-out infinite}@keyframes sxPulse{50%{opacity:.35}}.sx h4{display:flex;align-items:baseline;justify-content:space-between;gap:8px;margin:0 0 8px;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4)}.sx h4 span{font-size:10.5px;font-weight:500;letter-spacing:0;text-transform:none;color:var(--fg-5)}.sx h4.sx-h-gap{margin-top:14px}.sx-seg{display:grid;grid-template-columns:repeat(4,1fr);gap:2px;padding:3px;border-radius:12px;background:#ffffff0a;border:1px solid var(--hairline-soft)}.sx-seg button{height:28px;display:inline-flex;align-items:center;justify-content:center;gap:5px;padding:0;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast),box-shadow var(--dur-fast)}.sx-seg button:hover:not(:disabled):not(.is-on){color:var(--fg-1);background:#ffffff0d}.sx-seg button.is-on{color:#fff;cursor:default;background:linear-gradient(180deg,#9968df75,#5a61ed57);box-shadow:inset 0 1px #ffffff29,0 6px 16px #745aff42}.sx-seg button:disabled:not(.is-on){opacity:.45;cursor:default}.sx-counts{display:grid;grid-template-columns:1fr 1fr;gap:9px 12px;margin-top:11px}.sx-big{display:flex;flex-direction:column;gap:1px}.sx-big b{font-size:22px;font-weight:600;line-height:1.1;color:var(--fg-1);font-variant-numeric:tabular-nums;letter-spacing:-.01em}.sx-big b.is-grad{background:var(--grad-purple-pink);-webkit-background-clip:text;background-clip:text;color:transparent}.sx-big span{font-size:11px;color:var(--fg-4)}.sx-counts dl{grid-column:1 / -1;display:grid;grid-template-columns:1fr 1fr 1fr;gap:5px 14px;margin:0;padding-top:9px;border-top:1px solid var(--hairline-soft)}.sx-counts dl>div{display:flex;flex-direction:column;gap:1px}.sx-counts dt{font-size:10px;color:var(--fg-4)}.sx-counts dd{margin:0;font:500 11.5px var(--sx-mono);font-variant-numeric:tabular-nums;color:var(--fg-2)}.sx-note{margin:10px 2px 0;font-size:10.5px;line-height:1.45;color:var(--fg-5)}.sx-row{display:grid;grid-template-columns:1.1fr .8fr .8fr 1.1fr;gap:6px}.sx-chip{height:30px;display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:0 8px;white-space:nowrap;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-2);cursor:pointer;font-size:11.5px;font-weight:600;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sx-chip:hover:not(:disabled){background:#ffffff14;border-color:var(--hairline);color:#fff}.sx-chip:disabled{opacity:.45;cursor:default}.sx-bench{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:6px}.sx-bench li{position:relative;overflow:hidden;display:grid;grid-template-columns:1fr auto;align-items:center;gap:2px 10px;padding:7px 7px 7px 12px;border-radius:12px;background:#ffffff08;border:1px solid var(--hairline-soft);transition:border-color var(--dur-med),background var(--dur-med)}.sx-bench li.is-running{border-color:#9968df6b;background:#9968df12}.sx-bench-name{min-width:0;display:flex;align-items:center;gap:8px}.sx-bench-name b{flex:none;font-size:12px;font-weight:600;color:var(--fg-1)}.sx-hint{min-width:0;font-size:10.5px;color:var(--fg-5);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sx-play{width:28px;height:28px;display:inline-flex;align-items:center;justify-content:center;padding:0;border-radius:10px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-2);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast),box-shadow var(--dur-fast)}.sx-play:hover:not(:disabled){background:var(--grad-cta);border-color:transparent;color:#fff;box-shadow:0 6px 16px #745aff4d}.sx-play:disabled{opacity:.45;cursor:default}.sx-bench li.is-running .sx-play{opacity:1;color:var(--amethyst-700)}.sx-bench-res{grid-column:1 / -1;padding-bottom:2px;font:500 10.5px var(--sx-mono);font-variant-numeric:tabular-nums;color:var(--fg-3);animation:sxRes .3s var(--ease-out-soft) both}@keyframes sxRes{0%{opacity:0;transform:translateY(-3px)}to{opacity:1;transform:none}}.sx-phase{min-width:0;font-size:10.5px;color:var(--amethyst-700);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sx-pill{flex:none;padding:2px 8px;border-radius:999px;font-family:var(--font-sans);font-size:10px;font-weight:600}.sx-pill.is-ok{color:var(--success);background:#37d3991f}.sx-pill.is-bad{color:var(--danger);background:#ff5c7a1f}.sx-progress{position:absolute;left:0;right:0;bottom:0;height:2px;transform-origin:0 50%;transform:scaleX(var(--sx-p, 0));background:var(--grad-purple-pink);box-shadow:0 0 10px #9968dfcc}.sx-actions{display:flex;gap:8px;margin-top:10px}.sx-actions .bd-btn{flex:1;height:34px;padding:0 12px;gap:7px}.sx-actions .bd-btn:disabled{opacity:.45;cursor:default;transform:none;filter:none}.bd-center{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:14px;color:var(--fg-3);font-size:13px;z-index:30}.bd-spinner{width:26px;height:26px;border-radius:50%;border:2px solid rgba(255,255,255,.12);border-top-color:var(--amethyst-500);animation:cvSpin .8s linear infinite}.bd-spinner.is-sm{width:16px;height:16px}.bd-splash{position:fixed;inset:0;z-index:210;display:flex;align-items:center;justify-content:center;background:var(--bg-deep)}.bd-splash-leave-active{transition:opacity .5s cubic-bezier(.4,0,.2,1);pointer-events:none}.bd-splash-leave-to{opacity:0}.bd-mark-loader{--ml-size: 72px;--ml-cycle: 3.6s;--ml-step: .12s;--ml-offset: 0ms;position:relative;flex:none;width:var(--ml-size);aspect-ratio:239 / 173;isolation:isolate}.bd-ml-glow{position:absolute;inset:-70% -55%;pointer-events:none;opacity:0;background:radial-gradient(closest-side,rgba(153,104,223,.2),rgba(153,104,223,.06) 55%,transparent 100%);animation:bdMlGlow var(--ml-cycle) ease-in-out calc(0ms - var(--ml-offset)) infinite}.bd-ml-mark{position:absolute;inset:0;perspective:calc(var(--ml-size) * 3);animation:bdMlBreathe var(--ml-cycle) ease-in-out calc(0ms - var(--ml-offset)) infinite}.bd-ml-facet{position:absolute;inset:0;width:100%;height:100%;overflow:visible;transform-origin:var(--ox) var(--oy);animation:bdMlFacet var(--ml-cycle) linear calc(var(--i) * var(--ml-step) - var(--ml-offset)) infinite both;will-change:transform,opacity,filter}.bd-ml-sheen{position:absolute;inset:0;pointer-events:none;opacity:0;-webkit-mask:var(--ml-mask) center / 100% 100% no-repeat;mask:var(--ml-mask) center / 100% 100% no-repeat;background-image:linear-gradient(105deg,transparent 38%,rgba(255,255,255,.8) 50%,transparent 62%);background-size:320% 100%;background-repeat:no-repeat;mix-blend-mode:screen;animation:bdMlSheen var(--ml-cycle) linear calc(0ms - var(--ml-offset)) infinite}@keyframes bdMlFacet{0%{opacity:0;filter:brightness(.35);transform:translate(calc(var(--dx) * var(--ml-size) * .09),calc(var(--dy) * var(--ml-size) * .09)) rotate3d(var(--ax),var(--ay),0,88deg) scale(.84);animation-timing-function:cubic-bezier(.16,1,.3,1)}5%{opacity:1}21%{opacity:1;filter:brightness(1);transform:translate(0) rotate3d(var(--ax),var(--ay),0,0) scale(1)}67%{opacity:1;filter:brightness(1);transform:translate(0) rotate3d(var(--ax),var(--ay),0,0) scale(1);animation-timing-function:cubic-bezier(.55,0,.75,.2)}80%{opacity:1}83%,to{opacity:0;filter:brightness(.3);transform:translate(calc(var(--dx) * var(--ml-size) * -.05),calc(var(--dy) * var(--ml-size) * -.05)) rotate3d(var(--ax),var(--ay),0,-88deg) scale(.9)}}@keyframes bdMlBreathe{0%,28%{transform:scale(1)}50%{transform:scale(1.035)}72%,to{transform:scale(1)}}@keyframes bdMlGlow{0%,18%{opacity:0}42%,58%{opacity:1}82%,to{opacity:0}}@keyframes bdMlSheen{0%,34%{opacity:0;background-position:100% 0}37%,55%{opacity:1}58%,to{opacity:0;background-position:0% 0}}@keyframes bdMlPulse{0%,to{opacity:.55}50%{opacity:1}}@media(prefers-reduced-motion:reduce){.bd-ml-glow,.bd-ml-facet,.bd-ml-sheen{animation:none}.bd-ml-mark{animation:bdMlPulse 1.8s ease-in-out infinite}}.bd-error-card{width:360px;padding:24px;border-radius:18px;text-align:center;background:#121521d9;border:1px solid var(--hairline);box-shadow:var(--shadow-deep)}.bd-error-actions{display:flex;justify-content:center;gap:10px;flex-wrap:wrap}.bd-error-card b{display:block;color:var(--fg-1);font-size:15px;margin-bottom:6px}.bd-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:36px;padding:0 18px;white-space:nowrap;flex-shrink:0;border:0;border-radius:999px;cursor:pointer;font-family:var(--font-sans);font-size:12.5px;font-weight:600;background:var(--grad-cta);color:#fff;box-shadow:0 10px 28px #745aff47;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-fast)}.bd-btn:hover{transform:translateY(-1px);filter:brightness(1.06)}.bd-btn.is-ghost{background:#ffffff0f;border:1px solid var(--hairline);color:var(--fg-1);box-shadow:none}.bd-btn.is-ghost:hover{background:#ffffff1a}.cv-topbar-btn{width:30px;height:30px;flex:none;display:inline-flex;align-items:center;justify-content:center;padding:0;border:0;border-radius:9px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.cv-topbar-btn:hover{background:#ffffff12;color:var(--fg-1)}.cv-topbar-btn.on{background:var(--cv-accent-tint, rgba(153, 104, 223, .16));color:var(--fg-1)}.cv-board-menu-wrap{position:relative;display:inline-flex}.cv-board-menu-wrap .cv-topbar-btn{position:relative}.cv-topbar-dot{position:absolute;top:5px;right:6px;width:6px;height:6px;border-radius:50%;background:var(--amethyst-700, #c2a4ec);box-shadow:0 0 0 2px #070910e6}.cv-board-menu{position:absolute;top:calc(100% + 10px);right:-4px;z-index:50;width:300px;display:flex;flex-direction:column;gap:2px;padding:6px;border:1px solid var(--hairline);border-radius:16px;background:radial-gradient(130% 100% at 100% 100%,rgba(153,104,223,.34),transparent 72%),#11131ef5;backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);box-shadow:var(--inset-highlight),var(--shadow-deep);animation:cvMenuIn var(--dur-fast) var(--ease-out-soft) both}@keyframes cvMenuIn{0%{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}.cv-board-menu-item{display:flex;align-items:flex-start;gap:12px;width:100%;padding:10px 12px;text-align:left;border:0;border-radius:11px;background:transparent;color:var(--fg-2);cursor:pointer;font-family:var(--font-sans);transition:background var(--dur-fast),color var(--dur-fast)}.cv-board-menu-item:hover,.cv-board-menu-item:focus-visible{background:#ffffff12;color:var(--fg-1);outline:none}.cv-board-menu-item>.licon{margin-top:1px;color:var(--fg-3)}.cv-board-menu-item:hover>.licon{color:var(--fg-1)}.cv-board-menu-text{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.cv-board-menu-title{font-size:13.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em}.cv-board-menu-desc{font-size:11.5px;line-height:1.4;color:var(--fg-4)}.cv-board-menu-count,.cv-board-menu-kbd{flex:none;min-width:20px;height:20px;padding:0 6px;margin-top:1px;border-radius:6px;display:inline-flex;align-items:center;justify-content:center;font-family:var(--font-sans);font-size:11px;font-weight:600;line-height:1;font-variant-numeric:tabular-nums}.cv-board-menu-count{background:var(--cv-accent-tint, rgba(153, 104, 223, .16));color:var(--fg-1)}.cv-board-menu-kbd{border:1px solid var(--hairline);background:#ffffff0a;color:var(--fg-3)}.cv-links-wrap{position:relative;display:inline-flex;flex:none}.cv-links-btn{height:26px;min-width:26px;padding:0 7px;display:inline-flex;align-items:center;justify-content:center;gap:5px;border:1px solid transparent;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;font-family:var(--font-sans);font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.cv-links-btn.has-links{border-color:var(--hairline);color:var(--fg-2)}.cv-links-btn:hover,.cv-links-btn.on{background:#ffffff12;color:var(--fg-1)}.cv-links-menu{left:-4px;right:auto;width:340px}.cv-links-head{display:flex;align-items:center;gap:7px;padding:8px 10px 6px;font-size:9.5px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:var(--fg-4)}.cv-links-head .n{padding:1px 6px;border-radius:999px;background:#ffffff12;color:var(--fg-2);letter-spacing:0}.cv-links-empty{padding:4px 10px 10px;font-size:12px;line-height:1.45;color:var(--fg-3)}.cv-links-row{display:flex;align-items:center;gap:10px;padding:7px 8px 7px 10px;border-radius:11px}.cv-links-row:hover{background:#ffffff0d}.cv-links-row .ic{flex:none;width:30px;height:30px;border-radius:9px;display:inline-flex;align-items:center;justify-content:center;background:#5a61ed29;color:#c9ccfa}.cv-links-row .tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.cv-links-row .t{font-size:13px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cv-links-row .s{font-size:11px;color:var(--fg-4)}.cv-links-row.is-missing .t{color:var(--fg-4);text-decoration:line-through}.cv-links-row.is-missing .s{color:#ffb3c1}.cv-links-open{flex:none;display:inline-flex;align-items:center;gap:4px;height:28px;padding:0 10px;border:0;border-radius:8px;background:#ffffff17;color:#fff;font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer}.cv-links-open:hover{background:#ffffff29}.cv-links-add{margin-top:2px;border-top:1px solid var(--hairline-soft);border-radius:0 0 11px 11px}.ks{position:absolute;inset:0;z-index:120;display:flex;align-items:center;justify-content:center;padding:24px;background:#04030c85;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);animation:ksFade .2s ease both}@keyframes ksFade{0%{opacity:0}to{opacity:1}}.ks-card{position:relative;width:min(940px,100%);max-height:100%;overflow-y:auto;outline:none;padding:30px 36px 34px;border-radius:24px;background:#0b0d15f5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 40px 120px #02040cb8;font-family:var(--font-sans);animation:ksIn .34s var(--ease-out-soft) both}@keyframes ksIn{0%{opacity:0;transform:translateY(10px) scale(.985)}to{opacity:1;transform:none}}.ks-card:before{content:"";position:absolute;left:32px;right:32px;top:-1px;height:1px;pointer-events:none;background:linear-gradient(90deg,transparent,rgba(199,80,206,.5),rgba(153,104,223,.7),rgba(90,97,237,.5),transparent)}.ks-card::-webkit-scrollbar{width:8px}.ks-card::-webkit-scrollbar-thumb{background:#ffffff14;border-radius:4px;border:2px solid transparent;background-clip:content-box}.ks-head{display:flex;align-items:center;gap:14px;margin-bottom:30px}.ks-mark{flex:none;width:38px;height:38px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:inset 0 1px #ffffff38,0 10px 26px #745aff52}.ks-titles{flex:1;min-width:0}.ks-titles h2{margin:0;font-size:18px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.ks-titles p{margin:4px 0 0;font-size:12.5px;color:var(--fg-4)}.ks-os{display:inline-flex;align-items:center;height:20px;padding:0 8px;margin-left:10px;vertical-align:2px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0d;font-size:10.5px;font-weight:600;letter-spacing:.04em;color:var(--fg-3)}.ks-close{margin-left:auto;align-self:flex-start;flex:none;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ks-close:hover{background:#ffffff17;color:var(--fg-1)}.ks-grid{display:grid;gap:30px 44px;align-items:start;grid-template-columns:repeat(3,minmax(0,1fr));grid-template-areas:"tools view edit" "tools board edit"}@media(max-width:920px){.ks-grid{grid-template-columns:repeat(2,minmax(0,1fr));grid-template-areas:"tools edit" "view board"}}@media(max-width:620px){.ks-card{padding:24px 22px 26px}.ks-grid{grid-template-columns:minmax(0,1fr);grid-template-areas:"tools" "view" "edit" "board"}}.ks-group h3{margin:0 0 8px;padding-bottom:11px;border-bottom:1px solid var(--hairline-soft);font-size:10px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.ks-group ul{list-style:none;margin:0;padding:0;display:flex;flex-direction:column}.ks-group li{display:flex;align-items:center;justify-content:space-between;gap:16px;min-height:36px;padding:3px 0}.ks-label{min-width:0;display:flex;flex-direction:column;gap:2px;font-size:13px;color:var(--fg-2)}.ks-label small{font-size:11px;color:var(--fg-5)}.ks-keys{flex:none;display:inline-flex;align-items:center;gap:4px}.ks-key{min-width:24px;height:24px;padding:0 7px;display:inline-flex;align-items:center;justify-content:center;border-radius:7px;font-family:var(--font-sans);font-size:12px;font-weight:500;line-height:1;color:var(--fg-1);background:linear-gradient(180deg,#ffffff1a,#ffffff0b);border:1px solid rgba(255,255,255,.1);border-bottom-color:#ffffff0d;box-shadow:inset 0 1px #ffffff12,0 1px #00000073}.ks-key.is-word{padding:0 9px;font-size:11px;color:var(--fg-2)}.ks-key.is-inline{min-width:20px;height:20px;padding:0 6px;margin:0 2px;font-size:11px;vertical-align:1px}.rd{position:absolute;inset:0;z-index:92;display:flex;align-items:center;justify-content:center;padding:24px;background:#04030c85;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);animation:ksFade .2s ease both}.rd-card{position:relative;width:min(980px,100%);max-height:min(780px,100%);outline:none;display:flex;flex-direction:column;border-radius:24px;background:#0b0d15f5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 40px 120px #02040cb8;font-family:var(--font-sans);animation:ksIn .34s var(--ease-out-soft) both}.rd-card:before{content:"";position:absolute;left:32px;right:32px;top:-1px;height:1px;pointer-events:none;background:linear-gradient(90deg,transparent,rgba(199,80,206,.5),rgba(153,104,223,.7),rgba(90,97,237,.5),transparent)}.rd-head{flex:none;display:flex;align-items:center;gap:14px;padding:28px 32px 22px;border-bottom:1px solid var(--hairline-soft)}.rd-mark{flex:none;width:38px;height:38px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:inset 0 1px #ffffff38,0 10px 26px #745aff52}.rd-titles{flex:1;min-width:0}.rd-titles h2{margin:0;font-size:18px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.rd-titles p{margin:4px 0 0;font-size:12.5px;color:var(--fg-4)}.rd-head-acts{flex:none;display:flex;gap:8px}.rd-close{flex:none;align-self:flex-start;width:32px;height:32px;padding:0;margin-left:4px;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.rd-close:hover{background:#ffffff17;color:var(--fg-1)}.rd-btn{height:30px;padding:0 11px;display:inline-flex;align-items:center;gap:6px;white-space:nowrap;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0d;font-family:var(--font-sans);font-size:12px;font-weight:500;line-height:1;color:var(--fg-2);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.rd-btn:hover{background:#ffffff1a;color:var(--fg-1)}.rd-btn.is-danger:hover{color:var(--danger);border-color:#ff5c7a59;background:#ff5c7a14}.rd-btn.is-confirming,.rd-btn.is-confirming:hover{color:#fff;background:#ff5c7ae0;border-color:transparent}.rd-groups{flex:1;min-height:0;overflow-y:auto;padding:0 32px 32px}.rd-groups::-webkit-scrollbar{width:8px}.rd-groups::-webkit-scrollbar-thumb{background:#ffffff14;border-radius:4px;border:2px solid transparent;background-clip:content-box}.rd-group{padding:22px 0 6px}.rd-group+.rd-group{border-top:1px solid var(--hairline-soft)}.rd-group-head{display:flex;align-items:center;gap:12px;margin-bottom:14px}.rd-avatar{flex:none;width:30px;height:30px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;font-size:10.5px;font-weight:600;letter-spacing:.02em;color:#fff;background:linear-gradient(135deg,var(--amethyst-500),var(--vista-blue-400));box-shadow:inset 0 1px #ffffff38}.rd-who{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.rd-email{font-size:13px;font-weight:500;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rd-email em{font-style:normal;margin-left:8px;padding:1px 6px;vertical-align:1px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0f;font-size:10px;font-weight:600;color:var(--fg-3)}.rd-when{font-size:11.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rd-left{flex:none;display:inline-flex;align-items:center;gap:5px;margin-right:4px;font-size:11.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.rd-group-acts{flex:none;display:flex;gap:6px}.rd-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(128px,1fr));gap:14px}.rd-item{position:relative;min-width:0;display:flex;flex-direction:column;gap:7px}.rd-thumb{position:relative;aspect-ratio:1 / 1;overflow:hidden;display:flex;align-items:center;justify-content:center;border-radius:12px;border:1px solid var(--hairline-soft);background:#ffffff09}.rd-thumb img{width:100%;height:100%;object-fit:cover;display:block}.rd-play{position:absolute;left:8px;bottom:8px;width:24px;height:24px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:#08091099;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px)}.rd-note{position:absolute;inset:10px;padding:9px 10px;border-radius:9px;overflow:hidden}.rd-note span{overflow:hidden;font-size:10.5px;line-height:1.45;color:var(--fg-2);white-space:pre-wrap;word-break:break-word;display:-webkit-box;-webkit-line-clamp:6;-webkit-box-orient:vertical}.rd-note.tint-amethyst{background:linear-gradient(180deg,#9968df2b,#9968df14);border:1px solid rgba(194,164,236,.22)}.rd-note.tint-vista{background:linear-gradient(180deg,#5a61ed2b,#5a61ed14);border:1px solid rgba(163,167,245,.22)}.rd-note.tint-sky{background:linear-gradient(180deg,#3db4e62b,#3db4e614);border:1px solid rgba(153,217,243,.22)}.rd-note.tint-mint{background:linear-gradient(180deg,#34c79a2b,#34c79a14);border:1px solid rgba(143,229,201,.22)}.rd-note.tint-amber{background:linear-gradient(180deg,#f0b44a2b,#f0b44a14);border:1px solid rgba(247,212,143,.22)}.rd-note.tint-rose{background:linear-gradient(180deg,#ec5b9a2b,#ec5b9a14);border:1px solid rgba(245,163,199,.22)}.rd-note.tint-glass{background:var(--grad-glass);border:1px solid var(--hairline)}.rd-frame{position:absolute;inset:18px 14px;padding:8px;display:flex;align-items:flex-start;border-radius:8px;border:1.5px dashed rgba(255,255,255,.26)}.rd-frame span{min-width:0;font-size:10.5px;font-weight:600;color:var(--fg-3);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rd-shape{width:72%;height:72%;fill:none;stroke-width:4;stroke-linecap:round;stroke-linejoin:round}.rd-tool{color:var(--fg-3);display:inline-flex}.rd-item-acts{position:absolute;top:7px;right:7px;display:flex;gap:5px;opacity:0;transform:translateY(-3px);transition:opacity var(--dur-fast),transform var(--dur-fast)}.rd-item:hover .rd-item-acts,.rd-item:focus-within .rd-item-acts{opacity:1;transform:none}.rd-item-acts button{width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:8px;border:1px solid rgba(255,255,255,.12);background:#0a0b13cc;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:var(--fg-1);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.rd-item-acts button:hover{background:#1e2030f0}.rd-item-acts button.is-danger:hover{color:var(--danger)}.rd-item-acts button.is-confirming,.rd-item-acts button.is-confirming:hover{background:#ff5c7aeb;border-color:transparent;color:#fff}.rd-item-name{min-width:0;display:flex;align-items:center;gap:6px;font-size:11.5px;color:var(--fg-3)}.rd-item-name>:first-child{flex:none;color:var(--fg-4)}.rd-item-name span{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.rd-more{aspect-ratio:1 / 1;border-radius:12px;border:1px dashed var(--hairline);background:transparent;font-family:var(--font-sans);font-size:12px;font-weight:500;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.rd-more:hover{color:var(--fg-1);background:#ffffff0a}.rd-empty{padding:64px 32px 76px;display:flex;flex-direction:column;align-items:center;text-align:center}.rd-empty-mark{width:52px;height:52px;margin-bottom:16px;border-radius:16px;display:inline-flex;align-items:center;justify-content:center;color:var(--fg-3);background:#ffffff0a;border:1px solid var(--hairline-soft)}.rd-empty h3{margin:0;font-size:15px;font-weight:600;color:var(--fg-1)}.rd-empty p{margin:6px 0 0;max-width:380px;font-size:12.5px;line-height:1.55;color:var(--fg-4)}.rd-pop-leave-active{transition:opacity .18s ease,transform .18s ease}.rd-pop-leave-to{opacity:0;transform:scale(.94)}@media(max-width:720px){.rd{padding:12px}.rd-head{flex-wrap:wrap;padding:22px 20px 18px}.rd-head-acts{order:3;width:100%}.rd-groups{padding:0 20px 24px}.rd-group-head{flex-wrap:wrap;row-gap:10px}.rd-who{flex-basis:calc(100% - 42px)}.rd-left{margin-left:42px}.rd-group-acts{margin-left:auto}.rd-grid{grid-template-columns:repeat(auto-fill,minmax(96px,1fr));gap:10px}.rd-note span{-webkit-line-clamp:3}}@media(prefers-reduced-motion:reduce){.rd,.rd-card{animation:none}.rd-pop-leave-active{transition:none}}', FCe = '.sv-root{position:absolute;inset:0;z-index:88;overflow:hidden;--hist-w: 340px;--hist-col: var(--hist-w);display:grid;grid-template-columns:290px minmax(0,1fr) var(--hist-col);grid-template-rows:60px minmax(0,1fr);transition:grid-template-columns .34s var(--ease-out-soft);background:var(--bg-deep);color:var(--fg-2);animation:svIn .3s var(--ease-out-soft) both}@keyframes svIn{0%{opacity:0;transform:scale(.985)}to{opacity:1;transform:none}}@media(prefers-reduced-motion:reduce){.sv-root{animation:none}}.sv-ambient{position:absolute;inset:0;pointer-events:none;overflow:hidden}.sv-ambient span{position:absolute;inset:-12%;background-size:cover;background-position:center;filter:blur(90px) saturate(1.35);opacity:.2;animation:svAmbient .9s ease both}@keyframes svAmbient{0%{opacity:0}to{opacity:.2}}.sv-ambient:after{content:"";position:absolute;inset:0;background:radial-gradient(ellipse 70% 60% at 50% 45%,#04030c26,#04030cb8 70%,#04030cf0)}.sv-top{grid-column:1 / -1;grid-row:1;position:relative;z-index:3;display:flex;align-items:center;gap:12px;padding:0 14px;border-bottom:1px solid var(--hairline-soft);background:#0709108c;backdrop-filter:blur(22px);-webkit-backdrop-filter:blur(22px)}.sv-back,.sv-close{flex:none;width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;padding:0;border:1px solid var(--hairline-soft);border-radius:11px;background:#ffffff09;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sv-back:hover,.sv-close:hover{background:#ffffff14;color:var(--fg-1);border-color:var(--hairline)}.sv-close{border-color:transparent;background:transparent}.sv-title{display:flex;flex-direction:column;min-width:0;gap:2px}.sv-title .eyebrow{font-size:9.5px;font-weight:600;letter-spacing:.22em;text-transform:uppercase;color:var(--fg-4)}.sv-title .name{font-size:14.5px;font-weight:600;color:var(--fg-1);max-width:340px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;letter-spacing:-.005em}.sv-session{flex:none;display:inline-flex;align-items:center;gap:8px;height:32px;padding:0 13px 0 11px;margin-left:6px;border-radius:999px;border:1px solid rgba(153,104,223,.32);background:#9968df14;font:inherit;color:inherit;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-session:hover{background:#9968df29;border-color:#9968df8c}.sv-session:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:2px}.sv-session .lb{font-size:9.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4)}.sv-session .ic{width:20px;height:20px;border-radius:6px;display:inline-flex;align-items:center;justify-content:center;background:#ffffff14;color:var(--amethyst-700)}.sv-session b{font-size:12.5px;font-weight:600;color:var(--fg-1);white-space:nowrap}.sv-pos{font-size:12px;color:var(--fg-4);font-variant-numeric:tabular-nums;white-space:nowrap}.sv-top-btn{display:inline-flex;align-items:center;gap:6px;height:32px;padding:0 12px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-2);font-size:12px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-top-btn:hover{background:#ffffff14;color:var(--fg-1)}.sv-grow{flex:1;min-width:0}.sv-studios{grid-column:1;grid-row:2;position:relative;z-index:2;min-height:0;display:flex;flex-direction:column;margin:14px 0 14px 14px;padding:10px;border-radius:18px;background:#0b0d15e6;border:1px solid var(--hairline-soft);backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:var(--inset-highlight),0 28px 80px #02040c8c;overflow-y:auto;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.sv-studios::-webkit-scrollbar{width:5px}.sv-studios::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.sv-seg.sv-sides{flex:none;display:flex;width:100%;padding:3px;border-radius:12px}.sv-seg.sv-sides button{flex:1;height:34px;font-size:12.5px;font-weight:600;border-radius:9px}.sv-seg.sv-sides button.on{background:#9968df38;color:#fff;box-shadow:inset 0 0 0 1px #9968df5c,inset 0 1px #ffffff14}.sv-seg.sv-sides button.on .licon{color:var(--amethyst-700)}.sv-modes{display:flex;flex-direction:column;margin-top:8px}.sv-mode+.sv-mode{border-top:1px solid var(--hairline-soft)}.sv-mode-head{display:flex;align-items:center;gap:11px;width:100%;height:48px;padding:0 8px;border:0;border-radius:10px;background:transparent;color:var(--fg-2);font-size:13.5px;font-weight:500;cursor:pointer;text-align:left;transition:background var(--dur-fast),color var(--dur-fast)}.sv-mode-head .licon{color:var(--fg-4);transition:color var(--dur-fast)}.sv-mode-head .chev{margin-left:auto;color:var(--fg-5)}.sv-mode-head:hover{color:var(--fg-1)}.sv-mode-head:hover .licon{color:var(--fg-2)}.sv-mode.on .sv-mode-head{color:var(--fg-1);cursor:default}.sv-mode.on .sv-mode-head .licon:first-child{color:var(--amethyst-600)}.sv-mode.on .sv-mode-head .chev{color:var(--fg-3)}.sv-mode.is-locked:not(.on) .sv-mode-head{opacity:.4}.sv-mode-body{display:flex;flex-direction:column;gap:14px;padding:0 4px 14px;animation:svPop .22s var(--ease-out-soft) both}.sv-main{grid-column:2;grid-row:2;position:relative;z-index:1;display:flex;flex-direction:column;min-width:0;min-height:0}.sv-stage{position:relative;flex:1;min-height:0}.sv-pic{position:absolute;border-radius:12px;background:#ffffff08;box-shadow:0 0 0 1px #ffffff0f,0 30px 90px #0206179e;transition:left .28s var(--ease-out-soft),top .28s var(--ease-out-soft),width .28s var(--ease-out-soft),height .28s var(--ease-out-soft);animation:svPic .36s var(--ease-out-soft) both}@keyframes svPic{0%{opacity:0;transform:scale(.985)}to{opacity:1;transform:none}}.sv-pic img{display:block;width:100%;height:100%;object-fit:cover;border-radius:12px;user-select:none;-webkit-user-drag:none;transition:opacity .3s ease}.sv-art-play{position:absolute;left:5px;bottom:5px;width:18px;height:18px;border-radius:50%;display:grid;place-items:center;color:#fff;background:#080a129e;pointer-events:none}.sv-pic video{display:block;width:100%;height:100%;object-fit:contain;border-radius:12px;background:#000}.sv-pic.is-loading img{opacity:0}.sv-pic.is-loading{overflow:hidden}.sv-pic.is-loading:after{content:"";position:absolute;inset:0;border-radius:12px;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.07) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.sv-pic.is-editing{box-shadow:0 0 0 1px #9968df73,0 0 0 5px #9968df14,0 30px 90px #0206179e}.sv-pic-tag,.sv-pic-unsaved{position:absolute;top:-27px;display:inline-flex;align-items:center;gap:6px;height:22px;padding:0 10px;white-space:nowrap;border-radius:999px;font-size:11px;font-weight:600;pointer-events:none;background:#04030c9e;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);border:1px solid rgba(255,255,255,.12);color:var(--fg-1)}.sv-pic-tag{left:0;max-width:70%;overflow:hidden;text-overflow:ellipsis}.sv-pic-tag.is-ref{border-color:#a3a7f573;color:var(--vista-blue-600)}.sv-pic-unsaved{right:0;border-color:#ffb34766;color:#ffd08a}.sv-marks{position:absolute;inset:0;width:100%;height:100%;pointer-events:none;overflow:visible}.sv-pin-mark circle{fill:#7c4dff;stroke:#fff;stroke-width:2.5}.sv-pin-mark text{fill:#fff;font-family:var(--font-sans);font-weight:700}.sv-layer{position:absolute;inset:0;touch-action:none;border-radius:12px}.sv-layer.is-draw{cursor:crosshair}.sv-layer.is-draw.tool-eraser{cursor:cell}.sv-layer.is-comment{cursor:copy}.sv-pin{position:absolute;z-index:2;transform:translate(-50%,-50%);width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:2.5px solid #fff;background:#7c4dff;color:#fff;font-family:var(--font-sans);font-size:12px;font-weight:700;box-shadow:0 6px 18px #04030c80;cursor:grab;transition:box-shadow var(--dur-fast),transform var(--dur-fast);animation:svPinIn .28s var(--ease-out-soft) both}@keyframes svPinIn{0%{transform:translate(-50%,-50%) scale(.4);opacity:0}to{transform:translate(-50%,-50%);opacity:1}}.sv-pin:hover{transform:translate(-50%,-50%) scale(1.08)}.sv-pin:active{cursor:grabbing}.sv-pin.is-on{box-shadow:0 0 0 4px #7c4dff59,0 6px 18px #04030c80}.sv-pin.is-empty{background:#7c4dff8c}.sv-pin-editor{position:absolute;z-index:4;width:250px;padding:10px;border-radius:14px;background:#0d0f18f7;border:1px solid var(--hairline);backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);box-shadow:var(--inset-highlight),0 24px 60px #02040c99;animation:svPop .2s var(--ease-out-soft) both;cursor:default}@keyframes svPop{0%{opacity:0;transform:translateY(4px) scale(.98)}to{opacity:1;transform:none}}.sv-pin-editor-head{display:flex;align-items:center;gap:8px;margin-bottom:8px}.sv-pin-editor-head .n{width:20px;height:20px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#7c4dff;color:#fff;font-size:10.5px;font-weight:700}.sv-pin-editor-head .t{font-size:11px;font-weight:600;color:var(--fg-3)}.sv-pin-editor-head .x{margin-left:auto;width:24px;height:24px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer}.sv-pin-editor-head .x:hover{background:#ff5c7a1f;color:#ff8aa0}.sv-pin-editor textarea{display:block;width:100%;min-height:52px;resize:none;padding:8px 9px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-size:13px;line-height:1.45;outline:none}.sv-pin-editor textarea:focus{border-color:#9968df80}.sv-pin-editor-foot{display:flex;align-items:center;justify-content:space-between;margin-top:8px;font-size:10.5px;color:var(--fg-5)}.sv-mini-btn{height:26px;padding:0 12px;border:0;border-radius:8px;background:#9968df38;color:var(--amethyst-800);font-size:11.5px;font-weight:600;cursor:pointer}.sv-mini-btn:hover{background:#9968df57;color:#fff}.sv-invite{position:absolute;left:50%;top:48%;transform:translate(-50%,-50%);width:min(440px,calc(100% - 40px));display:flex;flex-direction:column;align-items:center;gap:10px;text-align:center;animation:svInvite .4s var(--ease-out-soft) both}@keyframes svInvite{0%{opacity:0;transform:translate(-50%,-46%)}to{opacity:1;transform:translate(-50%,-50%)}}.sv-invite b{font-size:18px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em}.sv-invite .sub{font-size:13px;line-height:1.55;color:var(--fg-3);max-width:380px}.sv-invite-mark{width:46px;height:46px;border-radius:14px;display:inline-flex;align-items:center;justify-content:center;margin-bottom:4px;background:linear-gradient(135deg,#9968df52,#5a61ed38);color:#fff;box-shadow:inset 0 1px #ffffff2e,0 14px 40px #7532d34d}.sv-invite-acts{display:flex;gap:8px;margin-top:8px;flex-wrap:wrap;justify-content:center}.sv-invite.is-making{gap:14px}.sv-making-time{margin-top:-6px;font-size:13px;font-weight:600;font-variant-numeric:tabular-nums;color:var(--fg-3)}.sv-making{width:34px;height:34px;border-radius:50%;border:2.5px solid rgba(255,255,255,.12);border-top-color:var(--amethyst-600);animation:cvSpin .9s linear infinite}.sv-model{position:absolute;inset:16px 16px 8px;border-radius:16px;overflow:hidden;background:#e4e1dc;box-shadow:0 0 0 1px #ffffff0f,0 30px 90px #0206178c}.sv-model.is-clear{background-color:#2a2c36;background-image:conic-gradient(rgba(255,255,255,.07) 25%,transparent 0 50%,rgba(255,255,255,.07) 0 75%,transparent 0);background-size:22px 22px}.sv-model canvas{display:block;cursor:grab;touch-action:none}.sv-model.is-dragging canvas{cursor:grabbing}.sv-finder{position:absolute;pointer-events:none;box-shadow:0 0 0 9999px #04030c4d;border-radius:4px}.sv-finder i{position:absolute;width:18px;height:18px;border:2px solid rgba(255,255,255,.92)}.sv-finder .tl{left:-2px;top:-2px;border-right:0;border-bottom:0;border-radius:4px 0 0}.sv-finder .tr{right:-2px;top:-2px;border-left:0;border-bottom:0;border-radius:0 4px 0 0}.sv-finder .bl{left:-2px;bottom:-2px;border-right:0;border-top:0;border-radius:0 0 0 4px}.sv-finder .br{right:-2px;bottom:-2px;border-left:0;border-top:0;border-radius:0 0 4px}.sv-finder-tag{position:absolute;right:8px;top:8px;padding:2px 8px;border-radius:999px;background:#04030c8c;color:#fff;font-size:10.5px;font-weight:600}.sv-dock{position:relative;z-index:6;flex:none;width:min(880px,calc(100% - 40px));margin:6px auto 18px;padding:10px 12px 12px;border-radius:18px;border:1px solid rgba(255,255,255,.06);background:#0b0d15f0;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0b,0 2px 8px #02040c66,0 30px 80px #02040c9e}.sv-note{position:absolute;left:50%;bottom:calc(100% + 10px);transform:translate(-50%);z-index:3;display:inline-flex;align-items:center;height:30px;padding:0 14px;border-radius:999px;white-space:nowrap;background:#11131ef5;border:1px solid var(--hairline);color:var(--fg-1);font-size:12px;font-weight:500;box-shadow:0 14px 40px #02040c80}.sv-note-enter-active,.sv-note-leave-active{transition:opacity .22s var(--ease-out-soft),transform .22s var(--ease-out-soft)}.sv-note-enter-from,.sv-note-leave-to{opacity:0;transform:translate(-50%,6px)}.sv-queue{display:flex;align-items:center;gap:12px;padding:2px 2px 10px;margin-bottom:10px;border-bottom:1px solid var(--hairline-soft);min-height:58px}.sv-queue-label{flex:none;font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4);white-space:nowrap}.sv-queue-slots{flex:1;min-width:0;display:flex;align-items:center;gap:9px;padding:5px 0 0 5px}.sv-queue-slots.is-video{flex:0 1 auto}.sv-queue-slots.is-video:only-of-type,.sv-queue:not(:has(.sv-queue-sep)) .sv-queue-slots.is-video{flex:1}.sv-slot.is-video{width:64px;overflow:hidden;cursor:default}.sv-slot.is-video video,.sv-slot.is-video img{width:100%;height:100%;object-fit:cover;border-radius:10px;display:block;background:#000}.sv-slot.is-video .v{position:absolute;left:4px;bottom:4px;display:inline-flex;padding:2px;border-radius:5px;background:#04030cb3;color:#fff}.sv-queue-sep{flex:none;width:1px;height:30px;background:var(--hairline-soft)}.sv-slot{position:relative;flex:none;width:44px;height:44px;border-radius:10px;cursor:pointer;background:#ffffff0a;box-shadow:inset 0 0 0 1px #ffffff1a;transition:transform var(--dur-fast) var(--ease-out-soft),opacity var(--dur-fast);animation:svSlot .32s var(--ease-out-soft) backwards}@keyframes svSlot{0%{opacity:0;transform:scale(.7)}to{opacity:1;transform:none}}.sv-slot:hover{transform:translateY(-2px)}.sv-slot .sv-art{border-radius:10px}.sv-slot:after{content:"";position:absolute;inset:0;border-radius:10px;box-shadow:inset 0 0 0 1px #ffffff1f;pointer-events:none}.sv-slot.is-ref:after{box-shadow:inset 0 0 0 1.5px #a3a7f599}.sv-slot.is-base:after{box-shadow:inset 0 0 0 2px var(--amethyst-500)}.sv-slot.is-stage{outline:2px solid rgba(255,255,255,.85);outline-offset:2px}.sv-slot.is-unsent{opacity:.38}.sv-slot.is-unsent:after{box-shadow:inset 0 0 0 1px #ffffff4d;border:1px dashed rgba(255,255,255,.5)}.sv-slot .n{position:absolute;left:-6px;top:-6px;z-index:2;min-width:18px;height:18px;padding:0 4px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:var(--amethyst-400);color:#fff;font-size:10px;font-weight:700;box-shadow:0 0 0 2px #0b0d15}.sv-slot.is-base .n{background:linear-gradient(135deg,var(--amethyst-500),var(--vista-blue-400))}.sv-slot .x{position:absolute;right:-6px;top:-6px;z-index:2;width:18px;height:18px;padding:0;border-radius:50%;border:0;display:inline-flex;align-items:center;justify-content:center;background:#2a2d3b;color:var(--fg-2);cursor:pointer;box-shadow:0 0 0 2px #0b0d15;opacity:0;transition:opacity var(--dur-fast)}.sv-slot:hover .x{opacity:1}.sv-slot .x:hover{background:#ff5c7a;color:#fff}.sv-slot-add,.sv-slot-more{flex:none;width:44px;height:44px;padding:0;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;border:1px dashed rgba(255,255,255,.18);background:transparent;color:var(--fg-4);font-size:12px;font-weight:600;cursor:pointer;transition:border-color var(--dur-fast),color var(--dur-fast),background var(--dur-fast)}.sv-slot-more{border-style:solid;background:#ffffff0a;color:var(--fg-2)}.sv-slot-add:hover,.sv-slot-more:hover{border-color:var(--cv-accent-soft);color:var(--amethyst-700);background:var(--cv-accent-tint)}.sv-queue-empty{font-size:12px;color:var(--fg-4);margin-left:4px}.sv-slot-add-wrap{position:relative;display:inline-flex}.sv-slot-add-wrap>.up-pop{left:0;right:auto;bottom:calc(100% + 10px);top:auto}.sv-queue{border-radius:14px;transition:background var(--dur-fast),box-shadow var(--dur-fast)}.sv-queue.is-air .sv-slot-add{border-color:var(--cv-accent-soft);color:var(--amethyst-700)}.sv-queue.is-over{background:var(--cv-accent-tint);box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.sv-queue-count{flex:none;font-size:11.5px;font-weight:600;color:var(--fg-3);font-variant-numeric:tabular-nums}.sv-queue-count.is-over{color:#ffd08a}.sv-art{position:absolute;inset:0;display:block;overflow:hidden;border-radius:inherit}.sv-art img{display:block;width:100%;height:100%;object-fit:cover;user-select:none;-webkit-user-drag:none}.sv-bar{display:flex;align-items:center;gap:10px;min-height:36px}.sv-studio-bar{display:flex;flex-direction:column;gap:8px}.sv-bar-top{min-height:44px;display:flex;align-items:center;padding:0 4px}.sv-bar-top .sv-hint b{color:var(--fg-1);font-weight:600}.sv-chip.is-placeholder{cursor:default;color:var(--fg-5);background:transparent;border-style:dashed}.sv-chip.is-placeholder:hover{background:transparent;color:var(--fg-5)}.sv-pinchips{display:flex;align-items:center;gap:6px;min-width:0;overflow-x:auto;scrollbar-width:none}.sv-pinchips::-webkit-scrollbar{display:none}.sv-pinchip{flex:none;display:inline-flex;align-items:center;gap:7px;height:32px;max-width:220px;padding:0 11px 0 5px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-2);font-size:12px;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.sv-pinchip:hover{background:#ffffff14;color:var(--fg-1)}.sv-pinchip .n{flex:none;width:22px;height:22px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#7c4dff;color:#fff;font-size:11px;font-weight:700}.sv-pinchip .t{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-pinchip.on{border-color:#7c4dff99;background:#7c4dff24;color:var(--fg-1)}.sv-pinchip.is-empty .t{color:var(--fg-4)}.sv-pinchips-empty{font-size:12px;color:var(--fg-5);padding-left:4px}.sv-hint{display:inline-flex;align-items:center;gap:8px;min-width:0;font-size:12.5px;color:var(--fg-3)}.sv-hint .licon{color:var(--amethyst-600);flex:none}.sv-sep{flex:none;width:1px;height:20px;background:var(--hairline-soft);margin:0 2px}.sv-seg{display:inline-flex;align-items:center;gap:2px;padding:3px;border-radius:11px;background:#ffffff09;border:1px solid var(--hairline-soft)}.sv-seg button{height:30px;min-width:32px;padding:0 8px;display:inline-flex;align-items:center;justify-content:center;gap:6px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-size:12px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-seg button:hover:not(:disabled){color:var(--fg-1);background:#ffffff0d}.sv-seg button.on{background:#ffffff1a;color:var(--fg-1);box-shadow:inset 0 1px #ffffff0f}.sv-seg button:disabled{opacity:.4;cursor:default}.sv-seg.is-text button{padding:0 11px}.sv-seg.is-small{padding:2px;border-radius:9px}.sv-seg.is-small button{height:24px;font-size:11px;padding:0 9px;border-radius:7px}.sv-swatches{display:inline-flex;align-items:center;gap:7px;padding:0 2px;transition:opacity var(--dur-fast)}.sv-swatches.is-off,.sv-size.is-off{opacity:.35;pointer-events:none}.sv-swatches .sw{width:20px;height:20px;padding:0;border-radius:50%;border:0;cursor:pointer;background:var(--c);box-shadow:inset 0 0 0 1.5px #ffffff38;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.sv-swatches .sw:hover{transform:scale(1.12)}.sv-swatches .sw.on{box-shadow:0 0 0 2px #0b0d15,0 0 0 4px #ffffffd9}.sv-size{display:inline-flex;align-items:center;gap:9px;transition:opacity var(--dur-fast)}.sv-size i{flex:none;display:inline-block;border-radius:50%;box-shadow:0 0 0 1px #fff3}.sv-size input{width:88px;accent-color:var(--amethyst-500)}.sv-icon-btn{flex:none;width:34px;height:34px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff09;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-icon-btn:hover:not(:disabled){background:#ffffff14;color:var(--fg-1)}.sv-icon-btn:disabled{opacity:.35;cursor:default}.sv-go{flex:none;display:inline-flex;align-items:center;gap:8px;height:36px;padding:0 16px;border:0;border-radius:11px;background:var(--grad-cta);color:#fff;font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff38;transition:filter var(--dur-fast),box-shadow var(--dur-fast),transform var(--dur-fast)}.sv-go:hover:not(:disabled){filter:brightness(1.08);box-shadow:0 9px 24px #745aff66,inset 0 1px #ffffff38}.sv-go:active:not(:disabled){transform:scale(.97)}.sv-go:disabled{background:#ffffff12;color:var(--fg-4);box-shadow:none;cursor:default}.sv-go.is-busy{opacity:.85}.sv-btn{display:inline-flex;align-items:center;gap:8px;height:36px;padding:0 15px;border-radius:11px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-1);font-size:13px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-btn:hover{background:#ffffff17;border-color:#ffffff29}.sv-btn.is-primary{border-color:transparent;background:var(--grad-cta);box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff38}.sv-btn.is-primary:hover{filter:brightness(1.08)}.sv-chip{flex:none;display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 11px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-2);font-size:12px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sv-chip:hover{background:#ffffff14;color:var(--fg-1)}.sv-chip.on{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:var(--fg-1)}.sv-chip .licon{color:var(--fg-4)}.sv-chip.is-model .lb{font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.sv-chip.is-model .nm{font-size:12.5px;color:var(--fg-1)}.sv-chip.is-dashed{border-style:dashed;border-color:#fff3;background:transparent;color:var(--fg-3)}.sv-chip.is-dashed:hover{border-color:var(--cv-accent-soft);color:var(--amethyst-700);background:var(--cv-accent-tint)}.sv-chip.is-file .nm{max-width:170px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--fg-1)}.sv-cost{flex:none;display:inline-flex;align-items:center;gap:5px;font-size:11.5px;color:var(--fg-4);white-space:nowrap}.sv-pop-wrap{position:relative;flex:none;display:inline-flex}.sv-pop{position:absolute;left:0;bottom:calc(100% + 8px);z-index:10;min-width:290px;padding:6px;border-radius:13px;background:#0d0f18fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 60px #02040c99;animation:svPop .18s var(--ease-out-soft) both}.sv-pop.is-narrow{min-width:110px}.sv-pop-row{display:flex;align-items:center;gap:10px;width:100%;height:34px;padding:0 10px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);font-size:12.5px;text-align:left;cursor:pointer}.sv-pop-row:hover{background:#ffffff0f;color:var(--fg-1)}.sv-pop-row.on{background:var(--cv-accent-tint);color:var(--fg-1)}.sv-pop-row .nm{font-weight:500}.sv-pop-sep{height:1px;margin:3px 8px;background:var(--hairline-soft)}.sv-pop-row .mt{margin-left:auto;font-size:11px;color:var(--fg-4);white-space:nowrap}.sv-pop-row .tk{display:inline-flex;align-items:center;gap:4px;font-size:11px;color:var(--fg-3);min-width:44px;justify-content:flex-end}.sv-describe{display:flex;flex-direction:column;gap:8px}.sv-words{position:relative}.sv-words.has-side .sv-describe-text{padding-right:40px}.sv-words-side{position:absolute;top:2px;right:0}.sv-lines{display:flex;flex-direction:column;gap:6px;max-height:128px;overflow-y:auto;padding:8px 10px;border-radius:12px;background:#ffffff08;border:1px solid var(--hairline-soft)}.sv-lines.is-quiet{padding:6px 10px}.sv-lines-head{display:flex;align-items:center;justify-content:space-between;gap:10px;font-size:11px;color:var(--fg-3)}.sv-lines-head>span{display:inline-flex;align-items:center;gap:6px}.sv-lines-head .licon{color:var(--amethyst-600)}.sv-line{display:flex;align-items:baseline;gap:9px;font-size:12.5px;color:var(--fg-1);line-height:1.45}.sv-line .tag{flex:none;display:inline-flex;align-items:center;gap:2px;padding:1px 7px;border-radius:999px;background:#7c4dff33;color:var(--amethyst-800);font-size:10.5px;font-weight:700;font-variant-numeric:tabular-nums}.sv-line .tag i{font-style:normal;opacity:.6}.sv-warn{display:flex;align-items:center;gap:8px;padding:7px 10px;border-radius:10px;font-size:12px;color:#ffd08a;background:#ffb34714;border:1px solid rgba(255,179,71,.22)}.sv-warn span{flex:1;min-width:0}.sv-link{flex:none;padding:0;border:0;background:transparent;color:var(--amethyst-700);font-size:11.5px;font-weight:600;cursor:pointer}.sv-link:hover{color:#fff;text-decoration:underline;text-underline-offset:3px}.sv-prompt{display:block;width:100%;min-height:44px;max-height:150px;resize:none;padding:6px 4px;border:0;outline:none;background:transparent;color:var(--fg-1);font-size:15px;line-height:1.5;overflow-y:auto}.sv-prompt::placeholder{color:var(--fg-4)}.sv-foot{display:flex;align-items:center;gap:8px}.sv-foot .sv-go{margin-left:auto}.sv-cams{display:flex;align-items:center;gap:6px;min-width:0;overflow-x:auto;scrollbar-width:none}.sv-cams::-webkit-scrollbar{display:none}.sv-cam{flex:none;display:inline-flex;align-items:center;height:32px;border-radius:10px;border:1px solid rgba(163,167,245,.3);background:#5a61ed1a;overflow:hidden}.sv-cam button{height:100%;border:0;background:transparent;color:var(--fg-1);cursor:pointer;display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:500}.sv-cam .go{padding:0 6px 0 10px}.sv-cam .go .licon{color:var(--vista-blue-500)}.sv-cam .x{padding:0 8px 0 4px;color:var(--fg-4)}.sv-cam .go:hover{background:#5a61ed29}.sv-cam .x:hover{color:#ff8aa0}.sv-cam-input{flex:none;width:120px;height:32px;padding:0 10px;border-radius:10px;border:1px solid rgba(163,167,245,.6);background:#5a61ed24;color:var(--fg-1);font-size:12px;outline:none}.sv-hist{grid-column:3;grid-row:2;position:relative;z-index:2;min-height:0;margin:14px 14px 14px 0;display:flex;flex-direction:column;padding:12px;border-radius:18px;background:#0b0d15e6;border:1px solid var(--hairline-soft);backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:var(--inset-highlight),0 28px 80px #02040c8c}.sv-hist-head{flex:none;display:flex;align-items:center;gap:8px}.sv-hist-head .t{font-size:10px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:var(--fg-4)}.sv-hist-head .n{padding:2px 7px;border-radius:999px;background:#ffffff0f;color:var(--fg-2);font-size:10px;font-weight:600;font-variant-numeric:tabular-nums}.sv-hist-from{flex:none;border-radius:12px;border:1px solid var(--hairline-soft);background:#ffffff06}.sv-hist-from-head{display:flex;align-items:center;gap:7px;width:100%;height:30px;padding:0 10px;border:0;background:transparent;color:var(--fg-3);cursor:pointer;font:600 10px var(--font-sans);letter-spacing:.14em;text-transform:uppercase}.sv-hist-from-head:hover{color:var(--fg-1)}.sv-hist-from-head .n{padding:1px 6px;border-radius:999px;background:#ffffff0f;color:var(--fg-2);letter-spacing:0;font-variant-numeric:tabular-nums}.sv-hist-from-row{display:flex;flex-wrap:wrap;gap:6px;padding:0 10px 10px}.sv-hist-from-pic{position:relative;width:52px;height:52px;padding:0;border-radius:8px;cursor:pointer;border:1px solid var(--hairline);background:#ffffff0a center / cover no-repeat;transition:transform var(--dur-fast) var(--ease-out-soft),border-color var(--dur-fast)}.sv-hist-from-pic:hover{transform:translateY(-2px);border-color:#c2a4ec99}.sv-hist-from-pic .k{position:absolute;left:4px;top:4px;min-width:15px;height:15px;padding:0 4px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:#080910c7;color:#fff;font:600 9px var(--font-sans)}.sv-hist-cols{flex:none;display:inline-flex;align-items:center;gap:8px;height:30px;padding:0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-4);transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.sv-hist-cols:hover,.sv-hist-cols:focus-within{background:#ffffff0f;color:var(--fg-2)}.sv-hist-cols .licon{flex:none}.sv-hist-cols-track{position:relative;flex:none;width:66px;height:18px}.sv-hist-cols-track .rail,.sv-hist-cols-track .fill{position:absolute;top:50%;height:3px;margin-top:-1.5px;border-radius:999px;pointer-events:none}.sv-hist-cols-track .rail{left:6px;right:6px;background:#ffffff24}.sv-hist-cols-track .fill{left:6px;background:var(--amethyst-500);transition:width var(--dur-fast) var(--ease-out-soft)}.sv-hist-cols-track i{position:absolute;top:50%;width:3px;height:3px;margin:-1.5px 0 0 -1.5px;border-radius:50%;background:#ffffff4d;pointer-events:none}.sv-hist-cols-track i.on{background:#ffffffd9}.sv-hist-cols-track input{position:absolute;inset:0;width:100%;height:100%;margin:0;padding:0;-webkit-appearance:none;appearance:none;background:transparent;cursor:pointer;outline:none}.sv-hist-cols-track input::-webkit-slider-runnable-track{height:18px;background:transparent;border:0}.sv-hist-cols-track input::-moz-range-track{height:18px;background:transparent;border:0}.sv-hist-cols-track input::-webkit-slider-thumb{-webkit-appearance:none;width:12px;height:12px;margin-top:3px;border:0;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c8c;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.sv-hist-cols-track input::-moz-range-thumb{width:12px;height:12px;border:0;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c8c}.sv-hist-cols-track input:hover::-webkit-slider-thumb,.sv-hist-cols-track input:active::-webkit-slider-thumb{transform:scale(1.15)}.sv-hist-cols-track input:focus-visible::-webkit-slider-thumb{box-shadow:0 0 0 3px var(--cv-accent-soft),0 1px 4px #02040c8c}.sv-hist-cols-track input:focus-visible::-moz-range-thumb{box-shadow:0 0 0 3px var(--cv-accent-soft)}.sv-hist-grid{--cols: 2;flex:1;min-height:0;overflow-y:auto;display:grid;grid-template-columns:repeat(var(--cols),minmax(0,1fr));gap:10px;align-content:start;padding:6px 2px 2px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.sv-hist.cols-3 .sv-hist-grid{gap:8px}.sv-hist.cols-4 .sv-hist-grid,.sv-hist.cols-5 .sv-hist-grid{gap:6px}.sv-hist-grid::-webkit-scrollbar{width:5px}.sv-hist-grid::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px}.sv-hist-empty{grid-column:1 / -1;padding:18px 8px;font-size:12px;line-height:1.5;color:var(--fg-4);text-align:center}.sv-cell{position:relative;flex:none;aspect-ratio:4 / 3;cursor:pointer}.sv-cell.is-new{animation:svCellIn .45s var(--ease-out-soft) backwards}@keyframes svCellIn{0%{opacity:0;transform:scale(.86)}to{opacity:1;transform:none}}.sv-cell .frame{position:absolute;inset:0;border-radius:10px;overflow:hidden;background:#ffffff0a;box-shadow:inset 0 0 0 1px #ffffff12;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.sv-cell .frame:after{content:"";position:absolute;inset:0;border-radius:10px;box-shadow:inset 0 0 0 1px #ffffff14;pointer-events:none;transition:box-shadow var(--dur-fast)}.sv-cell:hover .frame,.sv-cell.is-on .frame{transform:translateY(-2px);box-shadow:0 12px 28px #02040c80}.sv-cell:hover .frame:after,.sv-cell.is-on .frame:after{box-shadow:inset 0 0 0 1.5px var(--cv-accent-soft)}.sv-cell.is-ref .frame:after{box-shadow:inset 0 0 0 1.5px #a3a7f58c}.sv-cell.is-stage .frame:after{box-shadow:inset 0 0 0 2px #ffffffe6}.sv-cell.is-pending .frame:before{content:"";position:absolute;inset:0;z-index:1;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.sv-cell-time{position:absolute;left:50%;top:50%;z-index:2;transform:translate(-50%,-50%);font-size:11px;font-weight:600;font-variant-numeric:tabular-nums;letter-spacing:.02em;color:#ffffffa8;pointer-events:none}.sv-cell.is-failed .frame{display:flex;align-items:center;justify-content:center;background:#ff5c7a14;box-shadow:inset 0 0 0 1px #ff5c7a40}.sv-cell-fail{color:#ff8aa0;display:inline-flex}.sv-cell-how{position:absolute;left:6px;top:6px;z-index:2;width:20px;height:20px;border-radius:7px;display:inline-flex;align-items:center;justify-content:center;background:#5a61ede6;color:#fff;box-shadow:0 2px 8px #04030c66}.sv-cell-q{position:absolute;right:6px;top:6px;z-index:2;min-width:20px;height:20px;padding:0 5px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:var(--amethyst-400);color:#fff;font-size:10.5px;font-weight:700;box-shadow:0 2px 8px #04030c66}.sv-cell-dot{position:absolute;right:8px;bottom:8px;z-index:2;width:8px;height:8px;border-radius:50%;background:#ffb347;box-shadow:0 0 0 2px #0b0d15e6}.sv-cell-cap{position:absolute;left:6px;bottom:6px;z-index:2;max-width:calc(100% - 12px);padding:2px 7px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:var(--fg-2);font-size:10.5px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transition:opacity var(--dur-fast)}.sv-hist.cols-3 .sv-cell-cap,.sv-hist.cols-4 .sv-cell-cap,.sv-hist.cols-5 .sv-cell-cap{display:none}.sv-hist:not(.cols-1) .sv-cell-card{padding:0;width:18px;justify-content:center}.sv-hist:not(.cols-1) .sv-cell-card .tx{display:none}.sv-hist.cols-4 .sv-cell .frame,.sv-hist.cols-5 .sv-cell .frame,.sv-hist.cols-4 .sv-cell .frame:after,.sv-hist.cols-5 .sv-cell .frame:after{border-radius:8px}.sv-hist.cols-4 .sv-cell-how,.sv-hist.cols-5 .sv-cell-how{left:4px;top:4px;width:16px;height:16px;border-radius:5px}.sv-hist.cols-4 .sv-cell-q,.sv-hist.cols-5 .sv-cell-q{right:4px;top:4px;min-width:16px;height:16px;padding:0 4px;font-size:9.5px}.sv-hist.cols-4 .sv-cell-marks,.sv-hist.cols-5 .sv-cell-marks{right:4px;bottom:4px;width:14px;height:14px}.sv-hist.cols-4 .sv-cell-marks .licon,.sv-hist.cols-5 .sv-cell-marks .licon{display:none}.sv-hist.cols-4 .sv-cell-card,.sv-hist.cols-5 .sv-cell-card{right:4px;bottom:4px;width:16px;height:16px}.sv-hist-pop{position:absolute;z-index:6;border-radius:14px;pointer-events:auto;box-shadow:0 28px 70px #02040cc2}.sv-hist .sv-hist-pop{right:calc(100% + 12px);animation:svHistPop .22s var(--ease-out-soft) both}@keyframes svHistPop{0%{opacity:0;transform:translate(10px) scale(.94)}to{opacity:1;transform:none}}.sv-hist .sv-hist-pop:after{content:"";position:absolute;right:-26px;top:0;bottom:0;width:26px}.sv-hist-pop .art{position:absolute;inset:0;width:100%;height:100%;padding:0;border:0;border-radius:14px;overflow:hidden;cursor:pointer;background:#ffffff0a;box-shadow:inset 0 0 0 1px #ffffff1f}.sv-hist-pop .art .sv-art{border-radius:14px}.sv-hist-pop .cap{position:absolute;left:0;right:0;bottom:0;display:flex;flex-direction:column;gap:2px;padding:34px 13px 12px;pointer-events:none;border-radius:0 0 14px 14px;background:linear-gradient(180deg,#04030c00,#04030ce0 64%)}.sv-hist-pop .cap .n{min-width:0;font-size:12px;font-weight:600;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sv-hist-pop .cap .m{font-size:10.5px;font-weight:500;color:#ffffffa8}.sv-hist-acts{position:absolute;right:10px;top:10px;z-index:3;display:flex;align-items:center;gap:6px}.sv-hist-acts button{position:relative;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid rgba(255,255,255,.18);border-radius:999px;background:#04030cb8;color:#fff;cursor:pointer;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-hist-acts button:hover{background:var(--cv-accent);border-color:transparent}.sv-hist-acts button.on{background:var(--amethyst-400);border-color:transparent}.sv-hist-acts button.is-danger:hover,.sv-hist-acts button.is-armed{background:#e5486a;border-color:transparent}.sv-hist-acts .tip{position:absolute;top:calc(100% + 8px);right:-4px;z-index:2;background:#0b0d14f5;border:1px solid var(--hairline-soft);color:var(--fg-2);font-size:10.5px;font-weight:500;padding:4px 8px;border-radius:7px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity var(--dur-fast)}.sv-hist-acts button:hover .tip,.sv-hist-acts button.is-armed .tip{opacity:1}.sv-dropping{position:absolute;inset:0;z-index:20;display:flex;align-items:center;justify-content:center;background:#04030c8c;pointer-events:none}.sv-dropping>div{display:inline-flex;align-items:center;gap:10px;padding:14px 20px;border-radius:14px;border:1.5px dashed rgba(153,104,223,.7);background:#0d0f18eb;color:var(--fg-1);font-size:13.5px}@media(max-width:900px){.sv-session .lb,.sv-queue-label,.sv-cost,.sv-pos{display:none}.sv-bar,.sv-foot{flex-wrap:wrap;row-gap:8px}.sv-bar .sv-go{margin-left:auto}.sv-hist{margin-right:10px;padding:10px}.sv-title .name{max-width:180px}.sv-dock{width:calc(100% - 20px);margin-bottom:10px}.sv-size input{width:64px}}.sv-continue{position:absolute;left:50%;bottom:14px;transform:translate(-50%);z-index:3;display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 14px;border-radius:999px;white-space:nowrap;border:1px solid rgba(255,255,255,.2);background:#04030ca8;color:#fff;font-size:12px;font-weight:600;cursor:pointer;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);box-shadow:0 10px 30px #02040c73;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft);animation:svContIn .24s var(--ease-out-soft) backwards}@keyframes svContIn{0%{opacity:0;transform:translate(-50%,6px)}to{opacity:1;transform:translate(-50%)}}.sv-continue:hover{background:var(--cv-accent);border-color:transparent;transform:translate(-50%) translateY(-1px)}.bd-root.is-studio .cv-stage{visibility:hidden;transition:visibility 0s linear .32s}.sv-model-tools{position:absolute;right:14px;bottom:14px;display:flex;align-items:center;gap:6px}.sv-seg.is-dark{background:#04030c8c;border-color:#ffffff1f;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px)}.sv-seg.is-dark button{color:#ffffffb8}.sv-seg.is-dark button.on{background:#ffffff2e;color:#fff}.sv-model-btn{width:30px;height:30px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:9px;border:1px solid rgba(255,255,255,.12);background:#04030c8c;color:#fffc;cursor:pointer;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);transition:background var(--dur-fast)}.sv-model-btn:hover{background:#04030cbf;color:#fff}.sv-layer.is-draw.tool-move{cursor:default}.sv-layer.is-draw.tool-move.is-over{cursor:move}.sv-layer.is-draw.tool-text{cursor:text}.sv-layer.is-draw.tool-brush,.sv-layer.is-draw.tool-eraser{cursor:none}.sv-sel{position:absolute;z-index:2;pointer-events:none;border:1.5px dashed rgba(255,255,255,.95);border-radius:3px;box-shadow:0 0 0 1px #04030c73}.sv-sel .h{position:absolute;width:11px;height:11px;border-radius:3px;pointer-events:auto;background:#fff;box-shadow:0 0 0 1.5px #7c4dff,0 2px 6px #04030c66}.sv-sel .nw{left:-6px;top:-6px;cursor:nwse-resize}.sv-sel .ne{right:-6px;top:-6px;cursor:nesw-resize}.sv-sel .se{right:-6px;bottom:-6px;cursor:nwse-resize}.sv-sel .sw{left:-6px;bottom:-6px;cursor:nesw-resize}.sv-sel .stem{position:absolute;left:50%;top:-22px;width:1.5px;height:16px;margin-left:-.75px;background:#ffffffe6}.sv-sel .turn{left:50%;top:-30px;margin-left:-6px;width:12px;height:12px;border-radius:50%;cursor:grab}.sv-marquee{position:absolute;z-index:2;pointer-events:none;border:1px solid rgba(153,104,223,.9);background:#7c4dff1f;border-radius:2px}.sv-ring{position:absolute;z-index:3;pointer-events:none;transform:translate(-50%,-50%);border-radius:50%;border:1.5px solid #fff;box-shadow:0 0 0 1px #04030c8c,inset 0 0 0 1px #04030c59}.sv-ring.is-eraser{border-style:dashed;background:#ffffff1f}.sv-text-editor{position:absolute;z-index:4;margin:0;padding:0;border:0;outline:1px dashed rgba(255,255,255,.85);outline-offset:3px;background:transparent;resize:none;overflow:hidden;white-space:pre-wrap;word-break:normal;overflow-wrap:anywhere;font-weight:400;letter-spacing:normal;transform-origin:center;caret-color:currentColor;text-shadow:none}.sv-text-editor::placeholder{color:currentColor;opacity:.45}.sv-color{flex:none;width:34px;height:34px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff09;cursor:pointer;transition:background var(--dur-fast)}.sv-color i{width:18px;height:18px;border-radius:50%;background:var(--c);box-shadow:inset 0 0 0 1.5px #ffffff4d}.sv-color:hover,.sv-color.on{background:#ffffff14}.sv-pop.is-colors{min-width:0;display:flex;align-items:center;gap:8px;padding:9px 10px}.sv-pop.is-colors .sw{position:relative;width:22px;height:22px;padding:0;border-radius:50%;border:0;cursor:pointer;background:var(--c);box-shadow:inset 0 0 0 1.5px #ffffff38;transition:transform var(--dur-fast) var(--ease-out-soft)}.sv-pop.is-colors .sw:hover{transform:scale(1.12)}.sv-pop.is-colors .sw.on{box-shadow:0 0 0 2px #0d0f18,0 0 0 4px #ffffffd9}.sv-pop.is-colors .sw.is-any{background:conic-gradient(#ff3d6e,#ffc93c,#4ade80,#36d6ff,#7c4dff,#ff3d6e);overflow:hidden}.sv-pop.is-colors .sw.is-any.on{background:var(--c)}.sv-pop.is-colors .sw.is-any input{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer;border:0;padding:0}.sv-size .num{width:42px;height:28px;padding:0 6px;border-radius:8px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-size:12px;font-variant-numeric:tabular-nums;text-align:center;outline:none;-moz-appearance:textfield}.sv-size .num::-webkit-inner-spin-button,.sv-size .num::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.sv-size .num:focus{border-color:#9968df80}.sv-size i.is-eraser{border:1.5px dashed rgba(255,255,255,.6)}.sv-size input[type=range]{width:84px}.sv-tools{display:flex;flex-direction:column;gap:10px}.sv-tools-hint{margin:0;font-size:11.5px;line-height:1.5;color:var(--fg-2)}.sv-tools-empty{margin:0;font-size:11.5px;color:var(--fg-3)}.sv-tools-label{font-size:9.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-3);margin-bottom:-4px}.sv-tools-row{display:flex;align-items:center;gap:8px}.sv-tools-row.is-hist{gap:6px}.sv-toolgrid{display:grid;grid-template-columns:repeat(4,1fr);gap:4px}.sv-toolgrid button{height:34px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-toolgrid button:hover{background:#ffffff0f;color:var(--fg-1)}.sv-toolgrid button.on{background:#9968df33;color:#fff;box-shadow:inset 0 0 0 1px #9968df59}.sv-tools .sv-size{flex:1;min-width:0;gap:6px}.sv-tools .sv-size input[type=range]{flex:1;min-width:0;width:auto}.sv-tools .sv-size .num{width:38px}.sv-icon-btn.is-text{width:auto;padding:0 10px;gap:6px;font-size:12px;margin-left:auto}.sv-pop.is-below{top:calc(100% + 8px);bottom:auto}.sv-comments{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:4px;max-height:300px;overflow-y:auto}.sv-comments li{display:flex;align-items:flex-start;gap:2px;border-radius:9px;transition:background var(--dur-fast)}.sv-comments li:hover,.sv-comments li.on{background:#7c4dff1f}.sv-comments .go{flex:1;min-width:0;display:flex;align-items:flex-start;gap:8px;padding:6px 4px 6px 6px;border:0;background:transparent;color:var(--fg-1);text-align:left;cursor:pointer;font-size:12px;line-height:1.4}.sv-comments .n{flex:none;width:20px;height:20px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#7c4dff;color:#fff;font-size:10.5px;font-weight:700}.sv-comments .t{min-width:0;padding-top:1px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}.sv-comments .t.is-empty{color:var(--fg-4)}.sv-comments .x{flex:none;width:24px;height:24px;margin:4px 4px 0 0;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-5);cursor:pointer;opacity:0;transition:opacity var(--dur-fast)}.sv-comments li:hover .x{opacity:1}.sv-comments .x:hover{color:#ff8aa0;background:#ff5c7a1f}.sv-file{display:flex;align-items:center;gap:8px;width:100%;height:32px;padding:0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-size:12px;cursor:pointer;text-align:left}.sv-file span{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-file .licon{color:var(--fg-4)}.sv-file:hover{background:#ffffff14}.sv-views{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:3px}.sv-views li{display:flex;align-items:center;border-radius:9px;transition:background var(--dur-fast)}.sv-views li:hover{background:#5a61ed1f}.sv-views .go{flex:1;min-width:0;display:flex;align-items:center;gap:8px;height:30px;padding:0 8px;border:0;background:transparent;color:var(--fg-1);font-size:12px;cursor:pointer;text-align:left}.sv-views .go .licon{color:var(--vista-blue-500)}.sv-views .go.is-add{color:var(--fg-2)}.sv-views .go.is-add .licon{color:var(--fg-3)}.sv-views .x{width:24px;height:24px;margin-right:3px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer}.sv-views .x:hover{color:#ff8aa0;background:#ff5c7a1f}.sv-view-input{width:100%;height:30px;padding:0 8px;border-radius:8px;border:1px solid rgba(163,167,245,.6);background:#5a61ed24;color:var(--fg-1);font-size:12px;outline:none}.sv-btn.is-wide{width:100%;justify-content:center;height:34px;font-size:12.5px}.sv-cell-marks,.sv-slot .m{position:absolute;z-index:2;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;background:#ff3d6e;color:#fff;box-shadow:0 0 0 2px #0b0d15e6}.sv-cell-marks{right:6px;bottom:6px;width:18px;height:18px}.sv-slot .m{right:-5px;bottom:-5px;width:16px;height:16px}.sv-pic-unsaved.is-marks{border-color:#ff3d6e66;color:#ff9db5}@media(max-width:1180px){.sv-root{--hist-w: 284px;grid-template-columns:266px minmax(0,1fr) var(--hist-col)}.sv-hist-head .t,.sv-hist-head .n,.sv-chip.is-model .lb{display:none}}@media(max-width:900px){.sv-root{--hist-w: 184px;grid-template-columns:240px minmax(0,1fr) var(--hist-col)}.sv-hist-head{gap:6px}.sv-hist-head .sv-hist-cols{padding:0 8px}.sv-hist-head .sv-hist-cols .licon{display:none}}.sv-pop-wrap.is-row{display:flex;flex-direction:column;gap:6px;width:100%}.sv-model-row{display:flex;align-items:center;gap:9px;width:100%;height:40px;padding:0 12px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-1);font-size:12.5px;font-weight:500;text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-model-row:hover,.sv-model-row.on{background:#ffffff12}.sv-model-row.on{border-color:var(--cv-accent-soft)}.sv-model-row .licon{flex:none;color:var(--fg-4)}.sv-model-row .nm{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-model-row .tk{flex:none;display:inline-flex;align-items:center;gap:4px;font-size:11.5px;color:var(--fg-3);font-variant-numeric:tabular-nums}.sv-model-row .tk .licon{color:inherit}.sv-model-list{display:flex;flex-direction:column;gap:2px;padding:4px;border-radius:11px;border:1px solid var(--hairline-soft);background:#090a1099;animation:svPop .18s var(--ease-out-soft) both}.sv-model-list .sv-pop-row{display:grid;grid-template-columns:minmax(0,1fr) auto;grid-template-rows:auto auto;align-items:center;row-gap:1px;height:auto;padding:7px 10px}.sv-model-list .sv-pop-row .nm{grid-column:1;grid-row:1;font-size:12.5px}.sv-model-list .sv-pop-row .mt{grid-column:1;grid-row:2;margin-left:0;font-size:10.5px}.sv-model-list .sv-pop-row .tk{grid-column:2;grid-row:1 / span 2}.sv-pop-item{position:relative}.sv-pop-item .sv-pop-row{padding-right:40px}.sv-pop-item:hover .sv-pop-row{background:#ffffff0f;color:var(--fg-1)}.sv-pop-item:hover .sv-pop-row.on{background:var(--cv-accent-tint)}.sv-pop-pin{position:absolute;right:6px;top:50%;transform:translateY(-50%);width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.sv-pop-item:hover .sv-pop-pin,.sv-pop-pin.on,.sv-pop-pin:focus-visible{opacity:1}.sv-pop-pin:hover{background:#ffffff17;color:#fff}.sv-pop-pin.on{color:var(--cv-accent-text)}.sv-pop-pin.on svg{fill:currentColor}.sv-queue{position:relative}.sv-slot-peek{position:absolute;bottom:calc(100% + 24px);z-index:8;border-radius:12px;overflow:hidden;pointer-events:none;background:#ffffff0a;box-shadow:0 0 0 1px #ffffff24,0 24px 60px #02040cb8;animation:svPeek .18s var(--ease-out-soft) both}@keyframes svPeek{0%{opacity:0;transform:translateY(6px) scale(.96)}to{opacity:1;transform:none}}.sv-slot-peek .sv-art{border-radius:12px}.sv-slot-peek .n{position:absolute;left:8px;top:8px;z-index:2;padding:2px 8px;border-radius:999px;background:#04030cb3;color:#fff;font-size:10.5px;font-weight:600}.sv-note.is-floating{bottom:22px}.sv-root.side-edit .sv-stage{margin-bottom:6px}.sv-hist-lib{flex:none;width:30px;height:30px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff09;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.sv-hist-lib:hover{background:#9968df29;border-color:#9968df66;color:#fff}.sv-hist-filter{position:relative;flex:none;margin:10px 0 8px}.sv-hist-filter-btn{display:flex;align-items:center;gap:8px;width:100%;height:32px;padding:0 9px 0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0d;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.sv-hist-filter-btn .licon{flex:none;color:var(--fg-4)}.sv-hist-filter-btn .licon:first-child{color:var(--amethyst-600)}.sv-hist-filter-btn .lb{flex:1;min-width:0;text-align:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-hist-filter-btn .chev{transition:transform var(--dur-med) var(--ease-out-soft)}.sv-hist-filter-btn:hover,.sv-hist-filter-btn.on{background:#ffffff17}.sv-hist-filter-btn.on{border-color:#9968df73}.sv-hist-filter-btn.on .chev{transform:rotate(180deg)}.sv-hist-filter-btn.is-narrowed{border-color:#9968df61;background:#9968df1f}.sv-hist-filter-pop{position:absolute;left:0;right:0;top:calc(100% + 6px);z-index:12;padding:5px;border-radius:13px;background:#0d0f18fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 60px #02040c99;animation:svPop .18s var(--ease-out-soft) both}.sv-hist-opts{max-height:320px;overflow-y:auto;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.sv-hist-opt-sep{height:1px;margin:4px 6px;background:var(--hairline-soft)}.sv-hist-opt-line{position:relative;display:flex;align-items:center;border-radius:9px;transition:background var(--dur-fast)}.sv-hist-opt-line:hover{background:#ffffff0f}.sv-hist-opt{flex:1;min-width:0;display:flex;align-items:center;gap:9px;width:100%;margin:0;padding:7px 9px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.sv-hist-opt.is-all:hover{background:#ffffff0f}.sv-hist-opt:hover,.sv-hist-opt.on{color:#fff}.sv-hist-filter-pop .ck{flex:none;width:16px;height:16px;border-radius:5px;display:inline-flex;align-items:center;justify-content:center;box-shadow:inset 0 0 0 1.5px #ffffff3d;color:#fff;transition:background var(--dur-fast),box-shadow var(--dur-fast)}.sv-hist-opt.on .ck{background:var(--amethyst-400);box-shadow:none}.sv-hist-filter-pop .ic{flex:none;width:20px;height:20px;border-radius:6px;display:inline-flex;align-items:center;justify-content:center;background:#ffffff12;color:var(--amethyst-700)}.sv-hist-filter-pop .tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}.sv-hist-filter-pop .tx b{font-size:12.5px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-hist-filter-pop .tx small{font-size:10.5px;color:var(--fg-4);line-height:1.35}.sv-hist-filter-pop .ct{flex:none;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.sv-hist-opt-line .sv-hist-opt{padding-right:40px}.sv-hist-opt-acts{position:absolute;right:6px;top:50%;transform:translateY(-50%);display:flex;align-items:center;gap:4px}.sv-hist-only{height:24px;padding:0 9px;border-radius:7px;border:1px solid var(--hairline);background:#161824fa;color:var(--fg-2);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.sv-hist-opt-line:hover .sv-hist-only,.sv-hist-only:focus-visible{opacity:1}.sv-hist-only:hover{background:var(--cv-accent);border-color:transparent;color:#fff}.sv-hist-opt-line:hover .ct{visibility:hidden}.sv-hist-pin{width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.sv-hist-opt-line:hover .sv-hist-pin,.sv-hist-pin.on,.sv-hist-pin:focus-visible{opacity:1}.sv-hist-pin:hover{background:#ffffff17;color:#fff}.sv-hist-pin.on{color:var(--amethyst-700)}.sv-hist-pin.on svg{fill:currentColor}.sv-hist-opt-label{padding:8px 10px 4px;font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5)}.sv-hist-opt-none{padding:14px 10px;font-size:12px;color:var(--fg-4);text-align:center}.sv-hist-opt-note{margin:4px 0 0;padding:8px 10px 4px;border-top:1px solid var(--hairline-soft);font-size:10.5px;line-height:1.45;color:var(--fg-4)}.sv-hist-opt.is-current small{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sv-hist-search{display:flex;align-items:center;gap:8px;height:34px;margin:0 0 4px;padding:0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-4);transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.sv-hist-search:focus-within{border-color:#9968df80;box-shadow:0 0 0 3px #9968df1f}.sv-hist-search input{flex:1;min-width:0;height:100%;margin:0;padding:0;border:0;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;outline:none}.sv-hist-search input::placeholder{color:var(--fg-5)}.sv-hist-search .x{flex:none;width:20px;height:20px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:6px;background:#ffffff0f;color:var(--fg-3);cursor:pointer}.sv-hist-search .x:hover{background:#ffffff1f;color:#fff}.sv-pop-search{display:flex;align-items:center;gap:7px;height:32px;margin:0 0 4px;padding:0 9px;border-radius:8px;background:#ffffff0a;border:1px solid var(--hairline-soft);color:var(--fg-4)}.sv-pop-search input{flex:1;min-width:0;height:100%;border:0;background:transparent;color:var(--fg-1);font-size:12.5px;outline:none}.sv-pop-rows{max-height:300px;overflow-y:auto}.sv-model-list .sv-pop-rows{max-height:260px}.sv-pop-empty{padding:10px;font-size:12px;color:var(--fg-4)}.sv-pop-foot{margin:6px 4px 2px;font-size:10.5px;line-height:1.4;color:var(--fg-5)}.sv-pop-title{padding:4px 10px 6px;font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5)}.sv-pop.is-down{bottom:auto;top:calc(100% + 6px)}.sv-pop-slider{display:flex;align-items:center;gap:10px;padding:4px 10px 8px;min-width:200px}.sv-pop-slider input{flex:1;accent-color:var(--amethyst-500)}.sv-pop-slider b{min-width:28px;text-align:right;font-size:12px;color:var(--fg-1);font-variant-numeric:tabular-nums}.sv-fields{display:flex;align-items:center;flex-wrap:wrap;gap:6px}.sv-problem{display:flex;align-items:center;gap:6px;margin-top:8px;font-size:11.5px;color:#ffcf8a}.sv-problem.is-inline{margin-top:0}.sv-problem .licon{flex:none}.sv-go.is-blocked:not(.is-busy){filter:saturate(.6)}.sv-promote{position:absolute;right:12px;bottom:14px;z-index:3;display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 14px;border-radius:999px;white-space:nowrap;border:1px solid rgba(255,255,255,.2);background:#04030ca8;color:#fff;font-size:12px;font-weight:600;cursor:pointer;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);box-shadow:0 10px 30px #02040c73;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft);animation:svPop .24s var(--ease-out-soft) backwards}.sv-promote:hover{background:var(--cv-accent);border-color:transparent;transform:translateY(-1px)}.sv-promote.is-done{cursor:default;height:28px;padding:0 11px;font-size:11px;font-weight:600;color:#b9f3d0;border-color:#34d39959}.sv-promote.is-done:hover{background:#04030ca8;border-color:#34d39959;transform:none}.sv-cell-card{position:absolute;right:6px;bottom:6px;z-index:2;display:inline-flex;align-items:center;gap:4px;height:18px;padding:0 7px;border-radius:999px;background:#107052e0;color:#e8fff4;font-size:9.5px;font-weight:700;letter-spacing:.02em;box-shadow:0 2px 8px #04030c66}.sv-cell.is-card .frame:after{box-shadow:inset 0 0 0 1.5px #34d399b3}.sv-cell.is-card.is-stage .frame:after{box-shadow:inset 0 0 0 2px #ffffffe6}.sv-hist-acts button.is-promote:hover{background:#10916a}.sv-model-canvas{position:absolute;inset:0;width:100%;height:100%;display:block;outline:none;cursor:grab;touch-action:none}.sv-model-canvas:active{cursor:grabbing}.sv-model.is-night{background:#0e0f17}.sv-model-state{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:2;display:inline-flex;align-items:center;gap:10px;padding:10px 16px;border-radius:12px;background:#04030cb8;color:#fff;font-size:12.5px;font-weight:500;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);max-width:min(420px,80%);text-align:left}.sv-model-state .sv-making{width:18px;height:18px;border-width:2px}.sv-model-state.is-error{color:#ffd0d8}.sv-model-state.is-inline{position:static;transform:none;margin-top:8px}.sv-model-tools{flex-wrap:wrap;justify-content:flex-end;max-width:calc(100% - 28px)}.sv-views .go.on{color:#fff;background:#5a61ed33;border-radius:9px}.sv-views-adds{gap:4px}.sv-views-adds:hover{background:transparent}.sv-views-adds .go{flex:1;border-radius:9px}.sv-views-adds .go:hover{background:#5a61ed1f}.sv-views .go:disabled{opacity:.45;cursor:default}.sv-foot{flex-wrap:wrap;row-gap:8px}.sv-foot .sv-fields{flex:0 1 auto}.sv-hist.cols-1 .sv-cell.is-card .sv-cell-marks{right:108px}.sv-hist:not(.cols-1) .sv-cell.is-card .sv-cell-marks{right:28px}.sv-hist.cols-4 .sv-cell.is-card .sv-cell-marks,.sv-hist.cols-5 .sv-cell.is-card .sv-cell-marks{right:23px}.sv-pop-rows .sv-pop-row .nm{flex:1 1 auto;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sv-pop-rows .sv-pop-row .mt,.sv-pop-rows .sv-pop-row .tk{flex:none;white-space:nowrap}.sv-pop:has(.sv-pop-search),.sv-pop:has(.sv-pop-foot){min-width:360px}.sv-pic-clip.is-openable{cursor:zoom-in}.sv-edit-video{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:48px 24px 14px}.sv-edit-video video,.sv-edit-video img{min-height:0;max-width:100%;max-height:calc(100% - 52px);border-radius:14px;background:#000;box-shadow:0 30px 90px #02040c99}.sv-edit-video>.sv-pic-tag{position:absolute;top:14px;left:50%;transform:translate(-50%)}.sv-out-line{flex:none;font-size:11px;color:var(--fg-4);white-space:nowrap;margin-right:4px;font-variant-numeric:tabular-nums}@media(max-width:1100px){.sv-out-line{display:none}}.sv-pop-tabs{display:flex;flex-wrap:wrap;gap:4px;padding:6px 6px 2px}.sv-pop-tab{height:24px;padding:0 10px;border:1px solid var(--hairline-soft);border-radius:999px;background:transparent;color:var(--fg-3);font:600 11px var(--font-sans);cursor:pointer;transition:color var(--dur-fast),background var(--dur-fast),border-color var(--dur-fast)}.sv-pop-tab:hover{color:var(--fg-1);background:#ffffff0d}.sv-pop-tab.on{color:var(--fg-1);background:var(--cv-accent-tint);border-color:var(--cv-accent-soft)}.sv-pl-float{position:absolute;left:0;right:0;top:0;z-index:7;display:flex;align-items:flex-end;justify-content:center;padding:14px 14px 0;pointer-events:none}.sv-pl-float>.pl-wrap{pointer-events:auto;width:100%;max-width:1040px;height:100%;max-height:780px;margin:0}.sv-pl-float>.pl-wrap.is-floating .pl-panel{height:100%}', NCe = `.ed-radio{position:relative;flex:none;width:16px;height:16px;border-radius:50%;box-shadow:inset 0 0 0 1.5px #ffffff42;transition:box-shadow .22s var(--ease-out-soft),background .22s var(--ease-out-soft)}.ed-radio i{position:absolute;left:50%;top:50%;width:8px;height:8px;margin:-4px 0 0 -4px;border-radius:50%;background:#fff;transform:scale(0);opacity:0;transition:transform .3s cubic-bezier(.34,1.56,.64,1),opacity .18s ease}.ed-radio.on{box-shadow:inset 0 0 0 1.5px var(--amethyst-500),0 0 0 3px #9968df29;background:#9968df38}.ed-radio.on i{transform:scale(1);opacity:1;background:linear-gradient(135deg,#fff,var(--amethyst-800))}*:hover>.ed-radio:not(.on){box-shadow:inset 0 0 0 1.5px #ffffff73}@media(prefers-reduced-motion:reduce){.ed-radio,.ed-radio i{transition:none}}.ed-collapse{transition:height .34s var(--ease-out-soft),opacity .26s ease}.ed-autoh{position:relative;transition:height .34s var(--ease-out-soft)}.ed-autoh.is-moving{overflow:hidden}.ed-autoh-in{position:relative}.ed-autoh.is-moving>.ed-autoh-in{position:absolute;left:0;right:0;bottom:0}.ed-swap-enter-active{transition:opacity .22s ease .07s,transform .3s var(--ease-out-soft) .04s}.ed-swap-leave-active{position:absolute;left:0;right:0;bottom:0;pointer-events:none;transition:opacity .12s ease}.ed-swap-enter-from{opacity:0;transform:translateY(6px)}.ed-swap-leave-to{opacity:0}.ed-fade-enter-active,.ed-fade-leave-active{transition:opacity .2s ease}.ed-fade-enter-from,.ed-fade-leave-to{opacity:0}.ed-side-enter-active,.ed-side-leave-active{transition:opacity .18s ease,transform .24s var(--ease-out-soft)}.ed-side-enter-from{opacity:0;transform:translate(-6px)}.ed-side-leave-to{opacity:0;transform:translate(6px)}.ed-slide{position:relative;isolation:isolate;--p: 3px;--g: 2px;--r: 8px}.ed-slide:before{content:"";position:absolute;z-index:-1;top:var(--p);bottom:var(--p);width:calc((100% - 2 * var(--p) - (var(--n) - 1) * var(--g)) / var(--n));left:calc(var(--p) + var(--i) * ((100% - 2 * var(--p) - (var(--n) - 1) * var(--g)) / var(--n) + var(--g)));border-radius:var(--r);background:#9968df38;box-shadow:inset 0 0 0 1px #9968df5c,inset 0 1px #ffffff14;transition:left .32s var(--ease-out-soft)}.sv-seg.ed-slide>button{position:relative}.sv-seg.ed-slide>button.on,.sv-seg.ed-slide>button.on:hover{background:transparent;box-shadow:none;color:#fff}.sv-seg.ed-slide.sv-sides{--r: 9px}.sv-seg.ed-slide.is-small{--p: 2px;--r: 7px;display:inline-grid;grid-template-columns:repeat(var(--n),minmax(0,1fr))}@media(prefers-reduced-motion:reduce){.ed-collapse,.ed-autoh,.ed-swap-enter-active,.ed-swap-leave-active,.ed-side-enter-active,.ed-side-leave-active,.ed-slide:before{transition:none}}kbd{display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 5px;border-radius:5px;background:#ffffff12;box-shadow:inset 0 -1px #ffffff0f,inset 0 0 0 1px #ffffff14;color:var(--fg-3);font-family:var(--font-sans);font-size:10px;font-weight:600}.ed-tools{display:flex;flex-direction:column;margin-top:8px;gap:2px}.ed-tool{border-radius:12px;transition:background .24s ease,box-shadow .24s ease}.ed-tool.on{background:#ffffff06;box-shadow:inset 0 0 0 1px #ffffff0d}.ed-tool-head{display:flex;align-items:center;gap:11px;width:100%;height:44px;padding:0 10px;border:0;border-radius:11px;background:transparent;color:var(--fg-2);font-size:13.5px;font-weight:500;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-tool-head .ic{color:var(--fg-4);transition:color var(--dur-fast),transform .3s var(--ease-out-soft)}.ed-tool-head .lbl{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ed-tool-head:hover:not(:disabled){color:var(--fg-1);background:#ffffff0a}.ed-tool-head:hover:not(:disabled) .ic{color:var(--fg-2)}.ed-tool-head:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:-2px}.ed-tool-head:disabled{opacity:.38;cursor:default}.ed-tool.on .ed-tool-head{color:#fff;cursor:default}.ed-tool.on .ed-tool-head .ic{color:var(--amethyst-600);transform:scale(1.06)}.ed-pending{flex:none;width:7px;height:7px;border-radius:50%;background:#ffb347;box-shadow:0 0 0 3px #ffb34729;animation:edPulse 1.8s ease-in-out infinite}@keyframes edPulse{0%,to{box-shadow:0 0 0 3px #ffb34729}50%{box-shadow:0 0 0 5px #ffb3470f}}.ed-tool-body{padding:2px 8px 14px}.ed-tool-body.is-plain{padding:0 10px 12px 37px;animation:svPop .22s var(--ease-out-soft) both}.ed-tools .ed-tool+.ed-tool:not(.on):not(:has(+.on)){position:relative}.ed-panel{display:flex;flex-direction:column;gap:12px}.ed-hint{margin:0;font-size:11.5px;line-height:1.5;color:var(--fg-3)}.ed-hint.is-quiet{color:var(--fg-5)}.ed-keys{display:flex;flex-wrap:wrap;gap:10px;font-size:11px;color:var(--fg-4)}.ed-keys span{display:inline-flex;align-items:center;gap:5px}.ed-modes-x{display:flex;flex-direction:column;gap:4px}.ed-mode-x{display:flex;flex-direction:column;gap:3px;width:100%;padding:8px 10px;text-align:left;cursor:pointer;border:1px solid transparent;border-radius:10px;background:transparent;color:var(--fg-3);font:inherit;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-mode-x:hover{background:#ffffff0a;color:var(--fg-2)}.ed-mode-x.on{background:var(--cv-accent-tint);border-color:#c2a4ec4d;color:var(--fg-2)}.ed-mode-x .hd{display:flex;align-items:center;gap:7px}.ed-mode-x b{font-size:12px;font-weight:600;color:var(--fg-1)}.ed-mode-x kbd{padding:0 5px;border-radius:4px;background:#ffffff12;color:var(--fg-4);font:600 9.5px var(--font-sans);line-height:16px}.ed-mode-x .ln{font-size:11px;line-height:1.45}.ed-info{display:flex;align-items:baseline;justify-content:space-between;gap:10px;padding:8px 10px;border-radius:10px;background:#ffffff08;border:1px solid var(--hairline-soft);font-size:11.5px;color:var(--fg-3)}.ed-info b{font-size:12px;font-weight:600;color:var(--fg-1);font-variant-numeric:tabular-nums}.ed-tabs{display:flex;width:100%}.ed-tabs button{flex:1;height:30px;font-size:12px;font-weight:600}.ed-tabs button.on{background:#9968df33;color:#fff;box-shadow:inset 0 0 0 1px #9968df52}.ed-acts{display:flex;align-items:center;gap:8px}.ed-acts .sv-btn{height:34px;padding:0 12px;font-size:12.5px}.ed-acts .ed-apply{flex:1;justify-content:center}.ed-acts .ed-square{flex:none;width:34px;padding:0;justify-content:center}.ed-acts.is-foot,.ed-go{position:sticky;bottom:-10px;z-index:3;margin:0 -8px -14px;padding:12px 8px 14px;background:#0b0d15}.ed-acts.is-foot:after,.ed-go:after{content:"";position:absolute;left:0;right:0;bottom:100%;height:18px;pointer-events:none;background:linear-gradient(180deg,#0b0d1500,#0b0d15)}.ed-go{padding-top:14px}.ed-go:before{content:"";position:absolute;left:8px;right:8px;top:4px;height:1px;background:var(--hairline-soft)}.ed-acts.is-tight .sv-btn{flex:1;justify-content:center}.sv-btn:disabled{opacity:.4;cursor:default;filter:none}.sv-btn.is-primary:disabled{background:#ffffff12;box-shadow:none;color:var(--fg-4)}.sv-btn.is-on{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:#fff}.ed-slider{display:flex;flex-direction:column;gap:6px;cursor:default}.ed-slider-head{display:flex;align-items:baseline;justify-content:space-between;gap:8px}.ed-slider-head .lb{font-size:11.5px;color:var(--fg-3);transition:color var(--dur-fast)}.ed-slider-head .v{font-size:11px;font-weight:600;color:var(--fg-4);font-variant-numeric:tabular-nums;transition:color var(--dur-fast)}.ed-slider.is-changed .ed-slider-head .lb{color:var(--fg-1)}.ed-slider.is-changed .ed-slider-head .v{color:var(--amethyst-700)}.ed-slider.is-off{opacity:.4}.ed-slider-track{position:relative;height:16px}.ed-slider-track .rail,.ed-slider-track .fill{position:absolute;top:50%;height:3px;margin-top:-1.5px;border-radius:999px;pointer-events:none}.ed-slider-track .rail{left:0;right:0;background:#ffffff1f}.ed-slider-track .fill{background:linear-gradient(90deg,var(--amethyst-500),#8f72ff);transition:left .08s linear,width .08s linear}.ed-slider-track .tick{position:absolute;top:50%;width:3px;height:3px;margin:-1.5px 0 0 -1.5px;border-radius:50%;background:#ffffff52;pointer-events:none;transition:background var(--dur-fast),transform var(--dur-fast)}.ed-slider-track .tick.on{background:#fff;transform:scale(1.4)}.ed-slider-track input{position:absolute;inset:0;width:100%;height:100%;margin:0;padding:0;-webkit-appearance:none;appearance:none;background:transparent;cursor:pointer;outline:none}.ed-slider-track input::-webkit-slider-runnable-track{height:16px;background:transparent;border:0}.ed-slider-track input::-moz-range-track{height:16px;background:transparent;border:0}.ed-slider-track input::-webkit-slider-thumb{-webkit-appearance:none;width:13px;height:13px;margin-top:1.5px;border:0;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c99,0 0 #9968df66;transition:transform .18s var(--ease-out-soft),box-shadow .18s ease}.ed-slider-track input::-moz-range-thumb{width:13px;height:13px;border:0;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c99}.ed-slider-track input:hover::-webkit-slider-thumb{transform:scale(1.12)}.ed-slider-track input:active::-webkit-slider-thumb{transform:scale(1.2);box-shadow:0 1px 4px #02040c99,0 0 0 5px #9968df40}.ed-slider-track input:focus-visible::-webkit-slider-thumb{box-shadow:0 0 0 3px var(--cv-accent-soft),0 1px 4px #02040c8c}.ed-slider-track input:disabled{cursor:default}.ed-fields,.ed-fields-more{display:flex;flex-direction:column;gap:12px}.ed-fields-more{animation:svPop .2s var(--ease-out-soft) both}.ed-field{display:flex;flex-direction:column;gap:6px}.ed-field-lb{font-size:11.5px;color:var(--fg-3)}.ed-pills{display:flex;width:100%;flex-wrap:wrap}.ed-pills button{flex:1 1 auto;height:26px;font-size:11.5px;padding:0 8px}.ed-pills button.on{background:#9968df38;color:#fff;box-shadow:inset 0 0 0 1px #9968df5c}.ed-select{position:relative;display:flex;align-items:center}.ed-select select{width:100%;height:32px;padding:0 30px 0 10px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;-webkit-appearance:none;appearance:none;cursor:pointer;outline:none;transition:border-color var(--dur-fast),background var(--dur-fast)}.ed-select select:hover{background:#ffffff12}.ed-select select:focus{border-color:#9968df80}.ed-select select option{background:#14151f;color:var(--fg-1)}.ed-select .licon{position:absolute;right:10px;pointer-events:none;color:var(--fg-4)}.ed-text{display:block;width:100%;min-height:54px;max-height:140px;resize:vertical;padding:8px 10px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;line-height:1.45;outline:none;transition:border-color var(--dur-fast),background var(--dur-fast)}.ed-text::placeholder{color:var(--fg-5)}.ed-text:focus{border-color:#9968df80;background:#ffffff0d}.ed-more{align-self:flex-start;display:inline-flex;align-items:center;gap:6px;height:26px;padding:0 9px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-more:hover,.ed-more.on{background:#ffffff0d;color:var(--fg-1)}.ed-switch{display:flex;align-items:center;gap:10px;font-size:12px;color:var(--fg-2);cursor:pointer;user-select:none}.ed-switch input{position:absolute;opacity:0;width:0;height:0}.ed-switch i{position:relative;flex:none;width:30px;height:18px;border-radius:999px;background:#ffffff24;transition:background .2s ease}.ed-switch i:after{content:"";position:absolute;left:2px;top:2px;width:14px;height:14px;border-radius:50%;background:#fff;box-shadow:0 1px 3px #02040c80;transition:transform .25s var(--ease-out-soft)}.ed-switch input:checked+i{background:var(--amethyst-500)}.ed-switch input:checked+i:after{transform:translate(12px)}.ed-switch input:focus-visible+i{box-shadow:0 0 0 3px var(--cv-accent-soft)}.ed-radios{display:flex;flex-direction:column;gap:2px}.ed-radio-row{display:flex;align-items:center;gap:10px;height:32px;padding:0 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-radio-row:hover{background:#ffffff0d;color:var(--fg-1)}.ed-radio-row.on{color:#fff}.ed-go{display:flex;flex-direction:column;gap:9px}.ed-model-fixed,.ed-model-none{display:flex;align-items:center;gap:9px;min-height:32px;padding:0 2px;font-size:12px;color:var(--fg-2)}.ed-model-fixed .licon{flex:none;color:var(--fg-4)}.ed-model-fixed .tx{min-width:0;display:flex;flex-direction:column;gap:1px}.ed-model-fixed .nm{font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ed-model-fixed .why{font-size:10.5px;line-height:1.35;color:var(--fg-4)}.ed-model-none{color:var(--fg-4)}.ed-go-row{display:flex;align-items:center;gap:8px;container:edgo / inline-size}@container edgo (max-width: 228px){.ed-go-btn .licon{display:none}}@media(max-height:820px){.ed-model-fixed .why{display:none}.ed-go{gap:7px}}.ed-go-btn{flex:1;min-width:0;justify-content:center;height:40px;padding:0 12px;gap:7px}.ed-go-btn .lb{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ed-go-cost{display:flex;align-items:center;justify-content:center;gap:5px;margin-top:-3px;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.ed-bar{transition:border-color .3s ease,background .3s ease,box-shadow .3s ease}.ed-bar.is-tool{border-color:#9968df57;background:#100e1cf2;box-shadow:inset 0 1px #ffffff0b,0 0 0 4px #9968df0f,0 30px 80px #02040c9e}.ed-bar-tool{display:flex;flex-direction:column;gap:10px;padding:0 2px 0 4px}.ed-bar-tool-head{display:flex;align-items:center;gap:10px;height:40px;min-width:0}.ed-bar-go{display:flex;flex-direction:column;gap:8px;padding-top:10px;border-top:1px solid var(--hairline-soft)}.ed-bar-go:empty{display:none}.ed-bar-go-in{display:flex;flex-direction:column;gap:8px}.ed-go.is-bar{position:static;margin:0;padding:0;gap:8px;background:none}.ed-go.is-bar:before,.ed-go.is-bar:after{display:none}.ed-go-line{display:flex;align-items:center;gap:10px;min-height:30px;min-width:0}.ed-go-line .grow{flex:1}.ed-go-line .ed-model-fixed.is-inline{min-height:0;flex:0 1 auto;min-width:0}.ed-go-line .ed-go-cost,.ed-go-line .ed-go-full{margin:0;flex:none}.ed-go-line .sv-problem.is-inline{min-width:0;max-width:300px;margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ed-go-line .ed-go-btn{flex:none;min-width:112px;height:30px;padding:0 14px}.ed-acts.is-bar{display:flex;align-items:center;gap:8px;min-height:40px}.ed-acts.is-bar .grow{flex:1}.ed-acts.is-bar .ed-apply{flex:none;min-width:120px;height:40px}.ed-acts.is-bar .sv-btn:not(.ed-apply){height:40px}.ed-acts.is-bar .ed-square{width:40px}.ed-bar-tool .ic{flex:none;width:30px;height:30px;border-radius:9px;display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#9968df73,#5a61ed52);color:#fff;box-shadow:inset 0 1px #ffffff2e,0 6px 16px #7532d34d}.ed-bar-tool b{font-size:13.5px;font-weight:600;color:#fff;white-space:nowrap}.ed-bar-tool .dot{color:var(--fg-5)}.ed-bar-tool .st{min-width:0;display:inline-flex;align-items:center;gap:6px;font-size:12px;color:var(--fg-3);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ed-bar-tool-head .grow{flex:1}.ed-bar-close{flex:none;display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 12px 0 14px;border-radius:10px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.ed-bar-close:hover{background:#ffffff1a;border-color:#ffffff2e}.ed-bar-main{display:flex;flex-direction:column}.ed-bar-main .sv-prompt:disabled{opacity:.55;cursor:default}.ed-bar{container:edbar / inline-size}@container edbar (max-width: 600px){.ed-bar-modes>.sv-sep{display:none}}.ed-grow{flex:1 1 0;min-width:4px}.ed-modes{flex:none;display:inline-flex;align-items:center;gap:2px;padding:3px;border-radius:11px;background:#ffffff08;border:1px solid var(--hairline-soft)}.ed-mode{display:inline-flex;align-items:center;gap:7px;height:28px;padding:0 10px 0 7px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12px;font-weight:500;cursor:pointer;transition:background .2s ease,color .2s ease}.ed-mode .ed-radio{width:14px;height:14px}.ed-mode .ed-radio i{width:6px;height:6px;margin:-3px 0 0 -3px}.ed-mode:hover{color:var(--fg-1);background:#ffffff0a}.ed-mode.on{color:#fff;background:#9968df29}.ed-mode:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:1px}.sv-chip.is-fixed{cursor:default}.sv-chip.is-fixed:hover{background:#ffffff0a;color:var(--fg-2)}.ed-tools-inline{flex:none;display:inline-flex;align-items:center;gap:4px}.ed-seg-icons button{width:30px;min-width:30px;height:26px;padding:0}.ed-seg-icons button.on{background:#9968df3d;color:#fff;box-shadow:inset 0 0 0 1px #9968df61}.ed-icon-chip{flex:none;width:30px;height:30px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid transparent;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.ed-icon-chip:hover:not(:disabled){background:#ffffff12;color:var(--fg-1)}.ed-icon-chip.on{border-color:#ff5c7a6b;background:#ff5c7a1f;color:#ff9db0}.ed-icon-chip:disabled{opacity:.3;cursor:default}.ed-mini-sep{flex:none;width:1px;height:16px;margin:0 2px;background:var(--hairline-soft)}.ed-size{display:inline-flex;align-items:center;gap:7px;padding:0 4px 0 6px}.ed-size i{flex:none;display:inline-block;border-radius:50%;background:#ffffff8c;box-shadow:0 0 0 1px #fff3;transition:width .12s ease,height .12s ease}.ed-size input{width:64px;accent-color:var(--amethyst-500)}.ed-tool-chip{height:30px;padding:0 9px;gap:6px}.ed-tool-chip .chev{color:var(--fg-4);transition:transform var(--dur-fast)}.ed-tool-chip.on .chev{transform:rotate(180deg)}.ed-color{width:30px;height:30px;border-radius:9px;position:relative;overflow:hidden}.ed-color input[type=color]{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer;border:0;padding:0}.ed-mark-pop{min-width:228px;padding:6px;display:grid;grid-template-columns:1fr 1fr;gap:2px}.ed-mark-row{display:flex;align-items:center;gap:9px;height:32px;padding:0 8px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-mark-row .nm{flex:1}.ed-mark-row:hover{background:#ffffff0f;color:var(--fg-1)}.ed-mark-row.on{background:var(--cv-accent-tint);color:#fff}.ed-mark-row.on kbd{background:#9968df4d;color:#fff}.ed-mark-size{grid-column:1 / -1;display:flex;align-items:center;gap:9px;padding:8px 8px 4px;margin-top:4px;border-top:1px solid var(--hairline-soft);font-size:11.5px;color:var(--fg-3);transition:opacity var(--dur-fast)}.ed-mark-size input{flex:1;accent-color:var(--amethyst-500)}.ed-mark-size b{min-width:20px;text-align:right;font-size:11.5px;color:var(--fg-1);font-variant-numeric:tabular-nums}.ed-mark-size.is-off{opacity:.35;pointer-events:none}.ed-mark-clear{grid-column:1 / -1;display:flex;align-items:center;gap:7px;height:30px;padding:0 8px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;cursor:pointer}.ed-mark-clear:hover:not(:disabled){background:#ff5c7a1a;color:#ff9db0}.ed-mark-clear:disabled{opacity:.35;cursor:default}.ed-guard{position:absolute;inset:0;z-index:30;display:flex;align-items:flex-end;justify-content:center;padding-bottom:26px;background:#04030c52;backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px)}.ed-guard-card{display:flex;align-items:center;gap:14px;width:min(560px,calc(100% - 40px));padding:14px 14px 14px 16px;border-radius:16px;background:#10111cfa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 30px 80px #02040cb3}.ed-guard-card .ic{flex:none;width:34px;height:34px;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;background:#ffb34724;color:#ffc670}.ed-guard-card .tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.ed-guard-card .tx b{font-size:13.5px;font-weight:600;color:#fff}.ed-guard-card .tx span{font-size:11.5px;line-height:1.45;color:var(--fg-3)}.ed-guard-card .acts{flex:none;display:flex;gap:8px}.ed-guard-card .acts .sv-btn{height:34px;padding:0 14px;font-size:12.5px}.ed-guard-enter-active,.ed-guard-leave-active{transition:opacity .2s ease}.ed-guard-enter-active .ed-guard-card,.ed-guard-leave-active .ed-guard-card{transition:transform .3s var(--ease-out-soft),opacity .2s ease}.ed-guard-enter-from,.ed-guard-leave-to{opacity:0}.ed-guard-enter-from .ed-guard-card{transform:translateY(12px) scale(.98)}.ed-guard-leave-to .ed-guard-card{transform:translateY(6px)}.ed-ratios{display:grid;grid-template-columns:repeat(4,1fr);gap:4px}.ed-ratio{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;height:56px;padding:0;border:1px solid transparent;border-radius:10px;background:#ffffff08;color:var(--fg-3);font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast),transform .2s var(--ease-out-soft)}.ed-ratio i{display:block;border-radius:3px;box-shadow:inset 0 0 0 1.5px currentColor;opacity:.85;transition:width .3s var(--ease-out-soft),height .3s var(--ease-out-soft)}.ed-ratio i.free{box-shadow:none;border:1.5px dashed currentColor}.ed-ratio:hover{background:#ffffff12;color:var(--fg-1)}.ed-ratio:active{transform:scale(.97)}.ed-ratio.on{border-color:#9968df80;background:#9968df29;color:#fff}.ed-ratio.is-more{color:var(--fg-4)}.ed-wh{display:flex;align-items:center;gap:6px}.ed-wh label{flex:1;min-width:0;display:flex;align-items:center;gap:6px;height:32px;padding:0 8px;border-radius:9px;border:1px solid var(--hairline-soft);background:#ffffff09;transition:border-color var(--dur-fast)}.ed-wh label:focus-within{border-color:#9968df80}.ed-wh label span{font-size:10.5px;font-weight:700;color:var(--fg-5)}.ed-wh input{flex:1;min-width:0;width:100%;border:0;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;font-variant-numeric:tabular-nums;outline:none;-moz-appearance:textfield}.ed-wh input::-webkit-inner-spin-button,.ed-wh input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.ed-wh .u{font-size:10.5px;color:var(--fg-5)}.ed-lock{flex:none;width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-lock:hover{background:#ffffff12;color:var(--fg-1)}.ed-lock.on{color:var(--amethyst-700)}.ed-crop{pointer-events:none;border-radius:12px;overflow:hidden}.ed-crop .shade{position:absolute;background:#04030c94;pointer-events:none;transition:background .24s ease}.ed-crop.is-active .shade{background:#04030ca8}.ed-crop-box{position:absolute;pointer-events:auto;cursor:move;box-shadow:inset 0 0 0 1.5px #ffffffeb,0 0 0 1px #04030c66;animation:edCropIn .34s var(--ease-out-soft) both}@keyframes edCropIn{0%{opacity:0;transform:scale(1.02)}to{opacity:1;transform:none}}.ed-crop-box .third{position:absolute;background:#ffffff5c;opacity:0;transition:opacity .2s ease;pointer-events:none}.ed-crop.is-active .ed-crop-box .third{opacity:1}.ed-crop-box .third.v1{left:33.333%;top:0;bottom:0;width:1px}.ed-crop-box .third.v2{left:66.666%;top:0;bottom:0;width:1px}.ed-crop-box .third.h1{top:33.333%;left:0;right:0;height:1px}.ed-crop-box .third.h2{top:66.666%;left:0;right:0;height:1px}.ed-crop-h{position:absolute;z-index:2;width:22px;height:22px;margin:-11px 0 0 -11px;pointer-events:auto}.ed-crop-h:after{content:"";position:absolute;left:50%;top:50%;width:11px;height:11px;margin:-5.5px 0 0 -5.5px;border-radius:3px;background:#fff;box-shadow:0 0 0 1.5px var(--amethyst-400),0 2px 6px #04030c73;transition:transform .18s var(--ease-out-soft)}.ed-crop-h:hover:after{transform:scale(1.25)}.ed-crop-h.h-n,.ed-crop-h.h-s{left:50%;cursor:ns-resize}.ed-crop-h.h-e,.ed-crop-h.h-w{top:50%;cursor:ew-resize}.ed-crop-h.h-n:after,.ed-crop-h.h-s:after{width:22px;height:6px;margin:-3px 0 0 -11px;border-radius:3px}.ed-crop-h.h-e:after,.ed-crop-h.h-w:after{width:6px;height:22px;margin:-11px 0 0 -3px;border-radius:3px}.ed-crop-h.h-nw{left:0;top:0;cursor:nwse-resize}.ed-crop-h.h-ne{left:100%;top:0;cursor:nesw-resize}.ed-crop-h.h-se{left:100%;top:100%;cursor:nwse-resize}.ed-crop-h.h-sw{left:0;top:100%;cursor:nesw-resize}.ed-crop-h.h-n{top:0}.ed-crop-h.h-s{top:100%}.ed-crop-h.h-e{left:100%}.ed-crop-h.h-w{left:0}.ed-crop-size{position:absolute;left:50%;bottom:10px;transform:translate(-50%);padding:3px 9px;border-radius:999px;white-space:nowrap;pointer-events:none;background:#04030cb8;color:#fff;font-size:11px;font-weight:600;font-variant-numeric:tabular-nums;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px)}.ed-expand{position:absolute;border-radius:12px;animation:svPic .36s var(--ease-out-soft) both;transition:left .28s var(--ease-out-soft),top .28s var(--ease-out-soft),width .28s var(--ease-out-soft),height .28s var(--ease-out-soft)}.ed-expand-room{position:absolute;inset:0;border-radius:12px;border:1.5px dashed rgba(199,166,255,.55);background-color:#9968df0d;background-image:radial-gradient(rgba(255,255,255,.11) 1px,transparent 1.4px);background-size:14px 14px;background-repeat:repeat}.ed-expand-pic{position:absolute;cursor:move;border-radius:4px;overflow:hidden;box-shadow:0 0 0 1.5px #ffffffe6,0 18px 50px #0206178c}.ed-expand.is-active .ed-expand-pic{transition:none}.ed-expand-pic img{display:block;width:100%;height:100%;object-fit:fill;user-select:none;-webkit-user-drag:none}.ed-expand-h{position:absolute;z-index:2;display:flex;align-items:center;justify-content:center}.ed-expand-h i{display:block;border-radius:3px;background:#fff;box-shadow:0 0 0 1.5px var(--amethyst-400),0 2px 6px #04030c73;transition:transform .18s var(--ease-out-soft)}.ed-expand-h:hover i{transform:scale(1.2)}.ed-expand-h.h-n,.ed-expand-h.h-s{left:0;right:0;height:22px;cursor:ns-resize}.ed-expand-h.h-n{top:-11px}.ed-expand-h.h-s{bottom:-11px}.ed-expand-h.h-n i,.ed-expand-h.h-s i{width:28px;height:6px}.ed-expand-h.h-e,.ed-expand-h.h-w{top:0;bottom:0;width:22px;cursor:ew-resize}.ed-expand-h.h-e{right:-11px}.ed-expand-h.h-w{left:-11px}.ed-expand-h.h-e i,.ed-expand-h.h-w i{width:6px;height:28px}.ed-tabs.is-three button{padding:0 6px}.ed-fills{display:grid;grid-template-columns:repeat(6,1fr);gap:7px}.ed-fill{position:relative;aspect-ratio:1;padding:0;border:0;border-radius:9px;cursor:pointer;background:var(--c);box-shadow:inset 0 0 0 1px #ffffff29;transition:transform .2s var(--ease-out-soft),box-shadow var(--dur-fast)}.ed-fill:hover{transform:scale(1.07)}.ed-fill.on{box-shadow:0 0 0 2px #0b0d15,0 0 0 4px #ffffffd9}.ed-fill.is-clear{background-color:#2a2c36;background-image:conic-gradient(rgba(255,255,255,.22) 25%,transparent 0 50%,rgba(255,255,255,.22) 0 75%,transparent 0);background-size:10px 10px;background-repeat:repeat}.ed-fill.is-any{background:conic-gradient(#ff3d6e,#ffc93c,#4ade80,#36d6ff,#7c4dff,#ff3d6e);overflow:hidden}.ed-fill.is-any.on{background:var(--c)}.ed-fill.is-any input{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer;border:0;padding:0}.sv-pic.is-cutout{background-color:#2a2c36;background-image:conic-gradient(rgba(255,255,255,.07) 25%,transparent 0 50%,rgba(255,255,255,.07) 0 75%,transparent 0);background-size:22px 22px;background-repeat:repeat}.ed-layers-canvas{position:absolute;inset:0;border-radius:12px;pointer-events:none}.ed-refpick{display:flex;flex-direction:column;gap:6px}.ed-refpick-row{display:grid;grid-template-columns:repeat(4,1fr);gap:6px}.ed-refpick-cell{position:relative;aspect-ratio:1;padding:0;border:0;border-radius:9px;overflow:hidden;cursor:pointer;background:#ffffff0a;opacity:.72;transition:opacity var(--dur-fast),transform .2s var(--ease-out-soft),box-shadow var(--dur-fast)}.ed-refpick-cell:after{content:"";position:absolute;inset:0;border-radius:9px;box-shadow:inset 0 0 0 1px #ffffff1a;pointer-events:none;transition:box-shadow var(--dur-fast)}.ed-refpick-cell:hover{opacity:1;transform:translateY(-1px)}.ed-refpick-cell.on{opacity:1}.ed-refpick-cell.on:after{box-shadow:inset 0 0 0 2px var(--amethyst-500)}.ed-refpick-cell .tag{position:absolute;left:4px;bottom:4px;z-index:2;padding:1px 5px;border-radius:999px;background:#04030cb8;color:#fff;font-size:9.5px;font-weight:600}.ed-groups{display:flex;flex-direction:column;gap:2px;margin:0 -4px}.ed-group{border-radius:10px;transition:background .24s ease}.ed-group.on{background:#ffffff06}.ed-group-head{display:flex;align-items:center}.ed-group-btn{flex:1;min-width:0;display:flex;align-items:center;gap:9px;height:34px;padding:0 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;font-weight:500;text-align:left;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-group-btn .ic{color:var(--fg-4);transition:color var(--dur-fast)}.ed-group-btn .t{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ed-group-btn .chev{color:var(--fg-5)}.ed-group-btn:hover{background:#ffffff0a;color:var(--fg-1)}.ed-group.on .ed-group-btn{color:#fff}.ed-group.on .ed-group-btn .ic,.ed-group.is-changed .ed-group-btn .ic{color:var(--amethyst-600)}.ed-changed{flex:none;width:6px;height:6px;border-radius:50%;background:var(--amethyst-500);box-shadow:0 0 0 3px #9968df2e}.ed-group-reset{flex:none;width:26px;height:26px;margin-right:4px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-group-reset:hover{background:#ffffff12;color:#fff}.ed-group-body{display:flex;flex-direction:column;gap:12px;padding:4px 8px 12px}.ed-looks{display:grid;grid-template-columns:repeat(2,1fr);gap:6px}.ed-look{display:flex;flex-direction:column;gap:5px;padding:4px;border:1px solid transparent;border-radius:10px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-look .sw{position:relative;display:block;height:46px;border-radius:7px;overflow:hidden;background:#ffffff0d}.ed-look:hover{background:#ffffff0d;color:var(--fg-1)}.ed-look.on{border-color:#9968df80;background:#9968df24;color:#fff}.ed-look .nm{padding:0 2px 2px;text-align:left}.ed-look.look-vintage .sw{filter:sepia(.35) saturate(.75) contrast(.92) brightness(1.04)}.ed-look.look-retro-film .sw{filter:contrast(1.12) saturate(.88) hue-rotate(-8deg) sepia(.12)}.ed-look.look-duotone .sw{filter:grayscale(1) sepia(.6) hue-rotate(220deg) saturate(1.6) contrast(1.05)}.ed-look.look-vibrant .sw{filter:saturate(1.45) contrast(1.08)}.ed-look.look-warm .sw{filter:sepia(.22) saturate(1.15) hue-rotate(-6deg)}.ed-look.look-cool-breeze .sw{filter:hue-rotate(12deg) saturate(.9) brightness(1.05)}.ed-look.look-red-tint .sw{filter:sepia(.3) hue-rotate(-30deg) saturate(1.4)}.ed-look.look-cold .sw{filter:hue-rotate(18deg) saturate(.75) contrast(1.04)}.ed-look.look-mono .sw{filter:grayscale(1) contrast(1.15)}.ed-look.look-matte .sw{filter:contrast(.8) brightness(1.08) saturate(.85)}.ed-wheels{display:grid;grid-template-columns:repeat(3,1fr);gap:6px}.ed-wheel{display:flex;flex-direction:column;align-items:center;gap:6px}.ed-wheel-disc{position:relative;width:60px;height:60px;border-radius:50%;cursor:crosshair;touch-action:none;outline:none;background:radial-gradient(circle,gray,#80808000 72%),conic-gradient(from 0deg,#ff4d4d,#ffd24d,#4dff6a,#4dffff,#4d6aff,#d24dff,#ff4d4d);box-shadow:inset 0 0 0 1px #ffffff24,0 4px 14px #02040c66}.ed-wheel-disc:focus-visible{box-shadow:0 0 0 3px var(--cv-accent-soft)}.ed-wheel-dot{position:absolute;width:12px;height:12px;margin:-6px 0 0 -6px;border-radius:50%;background:#fff9;box-shadow:0 0 0 2px #04030c99;pointer-events:none;transition:left .06s linear,top .06s linear}.ed-wheel-dot.on{background:#fff}.ed-wheel-lb{font-size:10.5px;font-weight:600;color:var(--fg-3)}.ed-wheel-lum{width:60px;accent-color:var(--amethyst-500)}.ed-bands{display:flex;justify-content:space-between;gap:4px}.ed-band{position:relative;width:22px;height:22px;padding:0;border:0;border-radius:50%;background:var(--c);cursor:pointer;box-shadow:inset 0 0 0 1px #fff3;transition:transform .2s var(--ease-out-soft),box-shadow var(--dur-fast)}.ed-band:hover{transform:scale(1.1)}.ed-band.on{box-shadow:0 0 0 2px #0b0d15,0 0 0 4px #ffffffd9}.ed-band.is-changed:after{content:"";position:absolute;right:-2px;top:-2px;width:7px;height:7px;border-radius:50%;background:#fff;box-shadow:0 0 0 2px #0b0d15}.ed-overlay-row{display:flex;align-items:center;gap:8px}.ed-overlay-row .ed-select{flex:1}.ed-turns{display:grid;grid-template-columns:repeat(4,1fr);gap:6px}.ed-turns .sv-btn{justify-content:center;height:32px;padding:0}.ed-hold{user-select:none}.ed-hold:active{background:#ffffff24}.ed-adjust-canvas{position:absolute;inset:0;border-radius:12px;pointer-events:none;opacity:0;transition:opacity .2s ease}.ed-adjust-canvas.is-ready{opacity:1}.ed-stage-note{position:absolute;left:50%;bottom:12px;transform:translate(-50%);z-index:3;padding:4px 10px;border-radius:999px;white-space:nowrap;pointer-events:none;background:#04030ca8;color:#ffffffd1;font-size:11px;font-weight:500;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px)}.ed-area-layer{cursor:crosshair}.ed-area-layer.tool-brush{cursor:none}.ed-area-layer.tool-object{cursor:default}.ed-area-layer.tool-object.is-over{cursor:pointer}.ed-area-paint,.ed-area-hover,.ed-area-lasso{position:absolute;inset:0;border-radius:12px;pointer-events:none}.ed-area-paint{animation:edAreaBreathe 2.6s ease-in-out infinite}@keyframes edAreaBreathe{0%,to{opacity:1}50%{opacity:.86}}@media(prefers-reduced-motion:reduce){.ed-area-paint{animation:none}}.ed-area-hover{transition:opacity .12s ease}.ed-area-lasso path{fill:#a876ff29;stroke:#fff;stroke-width:1.5;stroke-dasharray:5 4;animation:edAnts .6s linear infinite}.ed-area-layer.is-cut .ed-area-lasso path{fill:#ff5c6e1f}@keyframes edAnts{to{stroke-dashoffset:-9}}.ed-area-ring{border-color:#fff;background:#a876ff24}.ed-area-layer.is-erase .ed-area-ring{background:#ff5c6e29}.ed-area-ring.is-eraser{border-style:dashed;background:#ffffff0f}.ed-area-find{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:4;display:inline-flex;align-items:center;gap:8px;padding:8px 14px;border-radius:999px;background:#04030cc7;color:#fff;font-size:12px;font-weight:500;white-space:nowrap;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);box-shadow:0 14px 40px #02040c80}.ed-area-find-btn{display:inline-flex;align-items:center;gap:8px;padding:0;border:0;background:transparent;color:#fff;font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.ed-area-find-btn .tk{display:inline-flex;align-items:center;gap:3px;padding:2px 7px;border-radius:999px;background:#ffffff24;font-size:11px}.ed-area-find:has(.ed-area-find-btn):hover{background:#7532d3e0}.ed-stage-tools{position:absolute;left:12px;bottom:14px;z-index:5;display:flex;align-items:center;gap:6px;animation:svPop .24s var(--ease-out-soft) backwards}.ed-stage-btn{display:inline-flex;align-items:center;gap:7px;height:30px;padding:0 12px;border-radius:999px;white-space:nowrap;border:1px solid rgba(255,255,255,.2);background:#04030ca8;color:#fff;font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);transition:background var(--dur-fast),border-color var(--dur-fast)}.ed-stage-btn:hover{background:#04030cd1}.ed-stage-btn.on{background:var(--cv-accent);border-color:transparent}.ed-compare{z-index:3;cursor:ew-resize}.ed-compare.is-toggle{cursor:pointer}.ed-compare-other{position:absolute;inset:0;border-radius:12px;overflow:hidden;transition:opacity .18s ease}.ed-compare.is-split .ed-compare-other{transition:none}.ed-compare-other img{display:block;width:100%;height:100%;object-fit:cover;user-select:none;-webkit-user-drag:none}.ed-compare-line{position:absolute;top:0;bottom:0;width:2px;margin-left:-1px;background:#fff;box-shadow:0 0 0 1px #04030c59,0 0 18px #04030c66;pointer-events:none}.ed-compare-line span{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:30px;height:30px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#fff;color:#1a1530;box-shadow:0 4px 14px #04030c80}.ed-compare-line span .licon{margin:0 -3px}.ed-compare-tag{position:absolute;top:10px;z-index:2;padding:3px 9px;border-radius:999px;background:#04030cb3;color:#fff;font-size:11px;font-weight:600;pointer-events:none}.ed-compare-tag.is-left{left:10px}.ed-compare-tag.is-right{right:10px}.ed-baking{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:6;display:inline-flex;align-items:center;gap:9px;padding:9px 16px;border-radius:999px;background:#04030ccc;color:#fff;font-size:12.5px;font-weight:500;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);box-shadow:0 14px 40px #02040c80}.sv-pic.is-tool{box-shadow:0 0 0 1px #ffffff14,0 30px 90px #0206179e}.ed-orbit{display:grid;grid-template-columns:minmax(0,1fr) 76px;gap:6px;align-items:center;padding:6px 4px 2px;border-radius:12px;background:radial-gradient(ellipse at 50% 60%,#9968df1a,#ffffff04 70%);border:1px solid var(--hairline-soft)}.ed-orbit svg{display:block;width:100%;height:auto;touch-action:none;cursor:grab;overflow:visible;outline:none}.ed-orbit svg:active{cursor:grabbing}.ed-orbit svg:focus-visible{filter:drop-shadow(0 0 4px rgba(153,104,223,.6))}.ed-orbit .track{fill:none;stroke:#fff3;stroke-width:1.2}.ed-orbit .track.is-inner{stroke:#ffffff12;stroke-dasharray:2 3}.ed-orbit .ground{stroke:#ffffff24;stroke-width:1}.ed-orbit .stop{fill:#ffffff59;transition:fill .2s ease,r .2s ease}.ed-orbit .stop.on{fill:#fff}.ed-orbit .origin{fill:#ffffff47}.ed-orbit .card{fill:#c7a6ff8c;stroke:#fff9;stroke-width:.8}.ed-orbit .ray{stroke:#c7a6ff8c;stroke-width:1;stroke-dasharray:2 2.5}.ed-orbit .ray.is-behind{stroke:#ffb34799}.ed-orbit .cam{transition:transform .18s var(--ease-out-soft)}.ed-orbit .cam .halo{fill:#9968df38}.ed-orbit .cam .dot{fill:#fff;stroke:var(--amethyst-400);stroke-width:2}.ed-camera-name{margin-top:-4px;text-align:center;font-size:12.5px;font-weight:600;color:#fff;letter-spacing:-.005em}.ed-seed{display:flex;align-items:center;justify-content:space-between;gap:8px}.ed-cam-stage{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;animation:svPic .36s var(--ease-out-soft) both}.ed-cam-view{position:relative;flex:1;width:100%;display:flex;align-items:center;justify-content:center;perspective:1500px;perspective-origin:50% 40%;overflow:hidden}.ed-cam-scene{position:relative;width:0;height:0;transform-style:preserve-3d;transition:transform .5s var(--ease-out-soft)}.ed-cam-floor{position:absolute;left:-480px;top:-480px;width:960px;height:960px;transform:rotateX(90deg);border-radius:50%;background:radial-gradient(circle,rgba(153,104,223,.16),transparent 62%),repeating-linear-gradient(0deg,rgba(255,255,255,.07) 0 1px,transparent 1px 48px),repeating-linear-gradient(90deg,rgba(255,255,255,.07) 0 1px,transparent 1px 48px);-webkit-mask-image:radial-gradient(circle,#000 30%,transparent 68%);mask-image:radial-gradient(circle,#000 30%,transparent 68%)}.ed-cam-box{position:absolute;left:0;top:0;transform-style:preserve-3d}.ed-cam-face{position:absolute;display:block;backface-visibility:hidden;-webkit-backface-visibility:hidden}.ed-cam-face.is-front{left:0;top:0;width:100%;height:100%;object-fit:cover;border-radius:3px;box-shadow:0 0 0 1px #ffffff24}.ed-cam-face.is-side{background-repeat:no-repeat;filter:blur(1.2px) brightness(.5) saturate(.7)}.ed-cam-face.is-side:after,.ed-cam-face.is-back:after{content:"";position:absolute;inset:0;background-image:linear-gradient(#16122661,#16122661),repeating-linear-gradient(45deg,rgba(255,255,255,.08) 0 2px,transparent 2px 9px);background-repeat:repeat;box-shadow:inset 0 0 0 1px #ffb34761}.ed-cam-face.is-top{filter:blur(1.2px) brightness(.62) saturate(.7)}.ed-cam-face.is-back{display:flex;align-items:center;justify-content:center;filter:none;background-image:none!important;background-color:#1a162cf5}.ed-cam-face.is-back span{position:relative;z-index:1;padding:4px 10px;border-radius:999px;background:#ffb34724;color:#ffd08a;font-size:11px;font-weight:600;transform:scaleX(-1) scaleX(-1)}.ed-cam-hud{flex:none;display:flex;flex-direction:column;align-items:center;gap:3px;padding:10px 0 18px;text-align:center}.ed-cam-hud b{font-size:14px;font-weight:600;color:#fff}.ed-cam-hud span{font-size:11.5px;color:var(--fg-3)}@media(prefers-reduced-motion:reduce){.ed-cam-scene{transition:none}}.ed-looks.is-light{grid-template-columns:repeat(3,1fr);gap:4px}.ed-light-look{display:flex;flex-direction:column;align-items:center;gap:5px;padding:7px 2px 6px;border:1px solid transparent;border-radius:10px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:10px;font-weight:600;line-height:1.2;text-align:center;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-light-look i{width:26px;height:26px;border-radius:50%;box-shadow:inset 0 0 0 1px #ffffff2e,0 4px 12px #02040c73;transition:transform .25s var(--ease-out-soft)}.ed-light-look:hover{background:#ffffff0d;color:var(--fg-1)}.ed-light-look:hover i{transform:scale(1.08)}.ed-light-look.on{border-color:#9968df80;background:#9968df24;color:#fff}.ed-rig{display:flex;align-items:center;gap:12px}.ed-sphere{position:relative;flex:none;border-radius:50%}.ed-sphere canvas{display:block;border-radius:50%}.ed-sphere-light{position:absolute;z-index:2;width:20px;height:20px;margin:-10px 0 0 -10px;padding:0;border:2px solid #fff;border-radius:50%;background:var(--c);color:#16141f;font-family:var(--font-sans);font-size:10px;font-weight:800;cursor:pointer;box-shadow:0 0 0 1px #04030c80,0 0 14px var(--c);transition:left .3s var(--ease-out-soft),top .3s var(--ease-out-soft),transform .2s var(--ease-out-soft),opacity .2s ease}.ed-sphere-light.is-behind{opacity:.45;border-style:dashed}.ed-sphere-light.on{transform:scale(1.18);box-shadow:0 0 0 2px var(--amethyst-400),0 0 18px var(--c)}.ed-lights{flex:1;min-width:0;display:flex;flex-direction:column;gap:4px}.ed-light-chip{display:flex;align-items:center;gap:8px;height:28px;padding:0 6px 0 8px;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff08;color:var(--fg-2);font-family:var(--font-sans);font-size:11.5px;font-weight:600;text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-light-chip{white-space:nowrap}.ed-light-chip .nm{min-width:0;overflow:hidden;text-overflow:ellipsis}.ed-light-chip i{flex:none;width:10px;height:10px;border-radius:50%;background:var(--c);box-shadow:0 0 8px var(--c)}.ed-light-chip .x{margin-left:auto;width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;border-radius:5px;color:var(--fg-4)}.ed-light-chip .x:hover{background:#ff5c7a24;color:#ff9db0}.ed-light-chip:hover{background:#ffffff0f;color:var(--fg-1)}.ed-light-chip.on{border-color:#9968df80;background:#9968df24;color:#fff}.ed-light-chip.is-add{border-style:dashed;color:var(--fg-4);justify-content:center}.ed-quick{display:grid;grid-template-columns:repeat(6,1fr);gap:3px}.ed-quick-btn{height:26px;padding:0;border:0;border-radius:7px;background:#ffffff0a;color:var(--fg-3);font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ed-quick-btn:hover{background:#ffffff14;color:var(--fg-1)}.ed-quick-btn.on{background:#9968df3d;color:#fff}.ed-whites{display:grid;grid-template-columns:repeat(7,1fr);gap:3px}.ed-white{display:flex;flex-direction:column;align-items:center;gap:3px;padding:4px 0;border:1px solid transparent;border-radius:8px;background:transparent;color:var(--fg-4);font-family:var(--font-sans);font-size:9px;font-weight:600;cursor:pointer}.ed-white i{width:16px;height:16px;border-radius:50%;background:var(--c);box-shadow:inset 0 0 0 1px #ffffff40}.ed-white:hover{background:#ffffff0d;color:var(--fg-1)}.ed-white.on{border-color:#9968df80;background:#9968df24;color:#fff}.ed-gels{display:flex;align-items:center;gap:6px;margin-top:4px}.ed-gel{position:relative;width:20px;height:20px;padding:0;border:0;border-radius:50%;background:var(--c);cursor:pointer;box-shadow:inset 0 0 0 1px #ffffff38;transition:transform .2s var(--ease-out-soft)}.ed-gel:hover{transform:scale(1.12)}.ed-gel.on{box-shadow:0 0 0 2px #0b0d15,0 0 0 4px #ffffffd9}.ed-gel.is-any{background:conic-gradient(#ff3d6e,#ffc93c,#4ade80,#36d6ff,#7c4dff,#ff3d6e);overflow:hidden}.ed-gel.is-any input{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer;border:0;padding:0}.ed-relight-preview{position:absolute;inset:0;border-radius:12px;overflow:hidden;pointer-events:none}.ed-relight-preview .wash,.ed-relight-preview .shade{position:absolute;inset:0;transition:opacity .4s ease,background .4s ease}.ed-relight-preview .wash{mix-blend-mode:overlay}.ed-relight-preview .shade{mix-blend-mode:multiply}@media(max-width:1180px){.ed-mode{padding:0 8px 0 6px}.ed-size input{width:48px}}.sv-warn .licon{flex:none}.ed-panel .sv-warn{align-items:flex-start;line-height:1.45;font-size:11.5px}.ed-panel .sv-warn .licon{margin-top:2px}.ed-card{position:relative;display:flex;flex-direction:row;align-items:stretch;gap:12px;padding:1px 0 0}.ed-side{flex:none;width:30px;padding-top:1px}.up-side-btn:disabled{opacity:.35;cursor:default;background:transparent;color:var(--fg-4)}.ed-col{flex:1;min-width:0;display:flex;flex-direction:column;gap:10px}.ed-words,.sv-describe-text{display:block;height:48px;max-height:160px}.ed-words:disabled{opacity:.55;cursor:default}.ed-bar-modes{display:flex;align-items:center;gap:6px;row-gap:6px;min-width:0;flex-wrap:wrap}.ed-keep .licon{color:#c7a6ff}.ed-keep-pop{min-width:0;width:280px}.ed-keep-row{height:auto;align-items:flex-start;gap:10px;padding:8px 10px}.ed-keep-row .tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.ed-keep-row .nm{color:var(--fg-1)}.ed-keep-row .hint{font-size:11px;line-height:1.4;color:var(--fg-4);white-space:normal}.ed-keep-row .ck{flex:none;margin-top:2px;color:var(--cv-accent-text)}.ed-refs{min-height:56px}.ed-refs .sv-slot-peek{z-index:12}.ed-refs .up-ref-pulse{z-index:1;border-radius:10px}.ed-ref-leave-active{transition:opacity .16s ease,transform .16s ease}.ed-ref-leave-to{opacity:0;transform:scale(.85)}.ed-ref-move{transition:transform .26s var(--ease-out-soft)}.ed-refs-hint{line-height:1.4;transition:color var(--dur-fast)}.ed-refs-hint.is-air{color:var(--cv-accent-text)}.sv-queue.is-air .sv-slot-add{border-color:#9968df99;color:var(--cv-accent-soft);animation:edAir .9s ease-in-out infinite alternate}.sv-slot-add.is-target,.sv-slot-add.is-dropper{border-color:var(--cv-accent-soft);color:var(--amethyst-700);background:var(--cv-accent-tint)}@keyframes edAir{0%{background:#9968df0a}to{background:#9968df29}}.ed-bar.is-over{border-color:#9968df80;box-shadow:inset 0 1px #ffffff0b,0 0 0 4px #9968df1a,0 30px 80px #02040c9e}.ed-fold-enter-active,.ed-fold-leave-active{transition:opacity .2s ease,transform .24s var(--ease-out-soft)}.ed-fold-enter-from,.ed-fold-leave-to{opacity:0;transform:translateY(4px)}.ed-fold-leave-active{position:absolute}.up-model.is-fixed{cursor:default}.up-model.is-fixed:hover{background:transparent}.sv-pfoot{width:100%;container:pfoot / inline-size;flex-wrap:wrap;row-gap:8px}@container pfoot (max-width: 520px){.sv-pfoot .up-foot-sep{display:none}.sv-pfoot>.up-chips{flex-basis:100%}.sv-pfoot>.up-chips+*{margin-left:auto}}.sv-describe .sv-pfoot{margin-top:2px}.sv-dock.is-nudge{animation:upNudge .42s var(--ease-out-soft)}.sv-dock.is-nudge .up-run-wrap .tip{opacity:1}.sv-root.is-dropper{--dropper-cursor: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke-linecap='round' stroke-linejoin='round'><g stroke='%23070910' stroke-width='4'><path d='m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12'/><path d='m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z'/><path d='m2 22 .414-.414'/></g><g stroke='white' stroke-width='2'><path d='m12 9-8.414 8.414A2 2 0 0 0 3 18.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 3.828 21h1.344a2 2 0 0 0 1.414-.586L15 12'/><path d='m18 9 .4.4a1 1 0 1 1-3 3l-3.8-3.8a1 1 0 1 1 3-3l.4.4 3.4-3.4a1 1 0 1 1 3 3z'/><path d='m2 22 .414-.414'/></g></svg>") 2 22, crosshair}.sv-hist.is-dropper .sv-cell{cursor:var(--dropper-cursor)}.sv-hist.is-dropper .sv-cell:hover .frame{transform:translateY(-2px);box-shadow:0 0 0 2px var(--amethyst-500),0 0 0 6px #9968df38,0 12px 28px #02040c80}.sv-cell-drop{position:absolute;left:7px;top:7px;z-index:4;display:inline-flex;align-items:center;gap:5px;padding:3px 9px 3px 7px;border-radius:999px;background:#04030cd1;color:#fff;font-size:11px;font-weight:600;white-space:nowrap;box-shadow:0 4px 14px #02040c73;opacity:0;transform:translateY(-3px);pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.sv-cell-drop .licon{color:var(--cv-accent-text)}.sv-cell-drop.is-in{color:var(--fg-2)}.sv-cell-drop.is-in .licon{color:var(--fg-3)}.sv-hist.is-dropper .sv-cell:hover .sv-cell-drop{opacity:1;transform:none}.bd-dropper.sv-dropper{top:10px;z-index:30}@media(prefers-reduced-motion:reduce){.sv-queue.is-air .sv-slot-add{animation:none;background:#9968df1f}.sv-dock.is-nudge{animation:none}.ed-fold-enter-active,.ed-fold-leave-active,.ed-ref-leave-active,.ed-ref-move{transition:none}}.sv-fp-link{flex:none;display:inline-flex;align-items:center;gap:4px;height:30px;padding:0 7px;margin-right:1px;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;font-family:var(--font-sans);font-size:11px;font-weight:500;white-space:nowrap;transition:color var(--dur-fast),background var(--dur-fast)}.sv-fp-link:hover{color:var(--fg-2);background:#ffffff0a}.sv-fp-link.on{color:var(--fg-2)}.sv-fp-link .chev{color:inherit;opacity:.7;transition:transform .22s var(--ease-out-soft)}.sv-fp-link.on .chev{transform:rotate(180deg)}.sv-fp-link .dot{width:5px;height:5px;border-radius:50%;background:var(--amethyst-500);box-shadow:0 0 0 2px #9968df2e}.ed-go-full{display:flex;justify-content:center;margin:-4px 0 -6px}.ed-go-full .sv-fp-link{height:24px}.sv-fp{display:flex;flex-direction:column;gap:6px;padding:8px 10px 9px;border-radius:12px;background:#ffffff06;border:1px solid var(--hairline-soft);transition:border-color .24s ease,background .24s ease}.sv-fp.is-edited{border-color:#9968df5c;background:#9968df0e}.sv-fp-head{display:flex;align-items:center;gap:8px;min-height:22px}.sv-fp-head .t{font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-5)}.sv-fp-tag{padding:1px 7px;border-radius:999px;background:#9968df2e;color:var(--amethyst-800);font-size:10px;font-weight:600;letter-spacing:.02em}.sv-fp-tag-enter-active,.sv-fp-tag-leave-active{transition:opacity .18s ease,transform .2s var(--ease-out-soft)}.sv-fp-tag-enter-from,.sv-fp-tag-leave-to{opacity:0;transform:scale(.85)}.sv-fp-only{display:inline-flex;align-items:center;gap:7px;height:24px;padding:0 9px 0 5px;margin-right:6px;border:1px solid var(--hairline-soft);border-radius:999px;background:transparent;color:var(--fg-3);font:600 10.5px var(--font-sans);cursor:pointer;transition:color var(--dur-fast),border-color var(--dur-fast),background var(--dur-fast)}.sv-fp-only i{position:relative;width:22px;height:13px;border-radius:999px;background:#ffffff24;transition:background var(--dur-fast)}.sv-fp-only i:after{content:"";position:absolute;left:2px;top:2px;width:9px;height:9px;border-radius:50%;background:#fff;transition:transform var(--dur-fast) var(--ease-out-soft)}.sv-fp-only:hover{color:var(--fg-1)}.sv-fp-only.on{color:var(--fg-1);border-color:#c2a4ec73;background:var(--cv-accent-tint)}.sv-fp-only.on i{background:var(--amethyst-500)}.sv-fp-only.on i:after{transform:translate(9px)}.sv-fp-reset{display:inline-flex;align-items:center;gap:4px;height:22px;padding:0 7px;border:0;border-radius:7px;background:transparent;color:var(--fg-4);font-family:var(--font-sans);font-size:11px;font-weight:500;cursor:pointer;transition:color var(--dur-fast),background var(--dur-fast)}.sv-fp-reset:hover{color:var(--fg-1);background:#ffffff0f}.sv-fp-text{display:block;width:100%;min-height:54px;max-height:180px;resize:none;padding:1px 0;border:0;outline:none;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12px;line-height:1.55;overflow-y:auto;white-space:pre-wrap;user-select:text;-webkit-user-select:text;transition:color var(--dur-fast)}.sv-fp-text:focus,.sv-fp.is-edited .sv-fp-text{color:var(--fg-1)}.sv-fp-text::-webkit-scrollbar{width:6px}.sv-fp-text::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.sv-fp-foot{display:flex;align-items:center;gap:10px}.sv-fp-note{flex:1;min-width:0;font-size:11px;line-height:1.4;color:var(--fg-5)}.sv-fp.is-edited .sv-fp-note{color:var(--fg-4)}.sv-fp-run{height:26px;padding:0 13px;font-size:11.5px}.sv-fp.is-tool{margin:6px 0 0}.sv-fp.is-tool .sv-fp-text{max-height:140px}.sv-fp.is-tool .sv-fp-foot{flex-direction:column;align-items:stretch;gap:8px}.sv-fp.is-tool .up-run-wrap,.sv-fp.is-tool .sv-fp-run{width:100%;justify-content:center}@media(prefers-reduced-motion:reduce){.sv-fp-link .chev,.sv-fp,.sv-fp-tag-enter-active,.sv-fp-tag-leave-active{transition:none}}.ed-views{display:flex;flex-direction:column;gap:8px;padding:9px 10px 10px;border-radius:12px;background:#ffffff06;border:1px solid var(--hairline-soft)}.ed-views-head{display:flex;align-items:center;gap:7px;min-height:24px}.ed-views-head .t{white-space:nowrap;font-size:9.5px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:var(--fg-4)}.ed-views-only{flex:none;display:inline-flex;align-items:center;gap:3px;padding:1px 6px;border-radius:999px;white-space:nowrap;background:#9968df1f;color:var(--amethyst-800);font-size:9.5px;font-weight:600}.ed-views-save{display:inline-flex;align-items:center;gap:5px;height:28px;padding:0 11px;border-radius:999px;white-space:nowrap;border:1px dashed rgba(255,255,255,.2);background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-views-save:hover:not(:disabled){background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff}.ed-views-save:disabled{cursor:default;color:var(--fg-5)}.ed-views-save.is-saved{border-style:solid;border-color:transparent;color:var(--fg-4);padding:0 6px}.ed-views-list{display:flex;flex-wrap:wrap;gap:6px}.ed-view{position:relative;display:inline-flex;max-width:100%}.ed-view-chip{display:inline-flex;align-items:center;gap:6px;max-width:100%;height:28px;padding:0 22px 0 9px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-2);font-family:var(--font-sans);font-size:11.5px;font-weight:500;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ed-view-chip .licon{flex:none;color:var(--fg-4)}.ed-view-chip .nm{min-width:0;overflow:hidden;text-overflow:ellipsis}.ed-view-chip:hover{background:#ffffff14;color:var(--fg-1)}.ed-view.on .ed-view-chip{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint);color:#fff}.ed-view.on .ed-view-chip .licon{color:var(--cv-accent-text)}.ed-view-x{position:absolute;right:4px;top:50%;width:18px;height:18px;margin-top:-9px;padding:0;border:0;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:transparent;color:var(--fg-5);cursor:pointer;opacity:0;transition:opacity var(--dur-fast),background var(--dur-fast),color var(--dur-fast)}.ed-view:hover .ed-view-x,.ed-view-x:focus-visible{opacity:1}.ed-view-x:hover{background:#ff5c7a29;color:#ff9db0}.ed-view-input{height:28px;width:180px;max-width:100%;padding:0 10px;border-radius:999px;border:1px solid var(--cv-accent-soft);background:#9968df14;color:#fff;font-family:var(--font-sans);font-size:11.5px;outline:none;box-shadow:0 0 0 3px #9968df24}.ed-views-empty{margin:0;font-size:11px;line-height:1.45;color:var(--fg-5)}.ed-view-enter-active{transition:opacity .22s ease,transform .26s var(--ease-out-soft)}.ed-view-leave-active{transition:opacity .16s ease,transform .16s ease}.ed-view-enter-from,.ed-view-leave-to{opacity:0;transform:scale(.85)}.ed-view-move{transition:transform .24s var(--ease-out-soft)}@media(prefers-reduced-motion:reduce){.ed-view-enter-active,.ed-view-leave-active,.ed-view-move{transition:none}}.sv-root.hist-shut{--hist-col: 0px}.sv-hist-body{flex:1;min-height:0;display:flex;flex-direction:column;gap:inherit;transition:opacity .22s ease}.sv-hist.is-shut,.sv-hist.is-moving{overflow:hidden}.sv-hist.is-shut .sv-hist-body,.sv-hist.is-moving .sv-hist-body{flex:none;align-self:flex-end;width:calc(var(--hist-w) - 40px);height:100%}.sv-hist.is-shut .sv-hist-body{opacity:0;pointer-events:none}.sv-hist-fold{margin-left:-2px}.sv-hist.is-shut{padding:0;visibility:hidden;transition:visibility 0s linear .34s}.sv-hist-show .n{padding:1px 7px;border-radius:999px;background:#ffffff12;color:var(--fg-2);font-size:10.5px;font-weight:600;font-variant-numeric:tabular-nums}.sv-hist-show{gap:7px;padding-left:5px}.sv-hist-show .sh{width:22px;height:22px;flex:none;border-radius:6px;background-size:cover;background-position:center;box-shadow:0 0 0 1px #ffffff1f}.sv-hist-show .n.is-new{background:var(--cv-accent);color:#fff}.sv-hist-show-enter-active{animation:svPillGlow 1.4s var(--ease-out-soft) .3s}.sv-hist-show.is-new{animation:svPillGlow 1.4s var(--ease-out-soft)}@keyframes svPillGlow{0%{box-shadow:0 0 #9968dfa6}70%{box-shadow:0 0 0 9px #9968df00}to{box-shadow:0 0 #9968df00}}.sv-hist-show-enter-active{transition:opacity .22s ease .12s,transform .28s var(--ease-out-soft) .12s}.sv-hist-show-leave-active{transition:opacity .12s ease}.sv-hist-show-enter-from{opacity:0;transform:translate(10px)}.sv-hist-show-leave-to{opacity:0}@media(prefers-reduced-motion:reduce){.sv-root,.sv-hist.is-shut{transition:none}.sv-hist-show.is-new,.sv-hist-show-enter-active{animation:none}.sv-hist-body,.sv-hist-show-enter-active,.sv-hist-show-leave-active{transition:none}}.ed-color i{position:relative;overflow:hidden;background:transparent;box-shadow:none}.ed-color i:before{content:"";position:absolute;inset:0;border-radius:inherit;background:conic-gradient(#ffffff57 25%,#ffffff14 0 50%,#ffffff57 0 75%,#ffffff14 0) 0 0 / 8px 8px}.ed-color i:after{content:"";position:absolute;inset:0;border-radius:inherit;background:var(--c);opacity:var(--o, 1);box-shadow:inset 0 0 0 1.5px #ffffff4d;transition:opacity var(--dur-fast)}.sv-pop.ed-colour-pop{flex-direction:column;align-items:stretch;gap:10px;padding:10px 12px 11px}.ed-swatch-row{display:flex;align-items:center;gap:8px}.ed-opacity{display:flex;align-items:center;gap:10px}.ed-opacity .lb{flex:none;font-size:9.5px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:var(--fg-4)}.ed-opacity b{flex:none;min-width:34px;text-align:right;font-size:11.5px;font-weight:600;color:var(--fg-1);font-variant-numeric:tabular-nums}.ed-opacity.is-off{opacity:.45}.ed-opacity-range{-webkit-appearance:none;appearance:none;flex:1;min-width:96px;height:10px;margin:0;border-radius:999px;cursor:pointer;background:linear-gradient(90deg,transparent,var(--c)),conic-gradient(#ffffff42 25%,#ffffff0f 0 50%,#ffffff42 0 75%,#ffffff0f 0) 0 0 / 8px 8px;box-shadow:inset 0 0 0 1px #ffffff24}.ed-opacity-range:disabled{cursor:default}.ed-opacity-range::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:16px;height:16px;border-radius:50%;background:#fff;box-shadow:0 0 0 2px #0d0f18e6,0 2px 6px #0006;cursor:grab}.ed-opacity-range:active::-webkit-slider-thumb{cursor:grabbing}.ed-opacity-range:focus-visible{outline:2px solid var(--cv-accent-soft);outline-offset:3px}.sv-pic-clip{position:absolute;inset:0;border-radius:inherit}.sv-pic.is-viewed .sv-pic-clip{overflow:hidden}.sv-pic-view{position:absolute;left:0;top:0;width:100%;height:100%;transform-origin:0 0;--zoom: 1}.sv-pic.is-viewed{transition:none}.sv-pic.is-gliding,.sv-pic.is-gliding .sv-pic-view{transition:left .24s var(--ease-out-soft),top .24s var(--ease-out-soft),width .24s var(--ease-out-soft),height .24s var(--ease-out-soft),transform .24s var(--ease-out-soft)}.sv-pic-view img,.sv-pic-view video,.sv-pic-view .sv-layer,.sv-pic-view .ed-compare-other{border-radius:calc(12px / var(--zoom))}.sv-pic.is-tag-inside .sv-pic-tag,.sv-pic.is-tag-inside .sv-pic-unsaved{top:10px;z-index:6}.sv-pic.is-tag-inside .sv-pic-tag{left:10px}.sv-pic.is-tag-inside .sv-pic-unsaved{right:10px}.sv-pic.is-viewed .sv-pin,.sv-pic.is-viewed .sv-pin-editor,.sv-pic.is-viewed .ed-compare-line span,.sv-pic.is-viewed .ed-compare-tag.is-left,.sv-pic.is-viewed .ed-area-find{transform-origin:0 0;scale:calc(1 / var(--zoom))}.sv-pic.is-viewed .ed-compare-tag.is-right{transform-origin:100% 0;scale:calc(1 / var(--zoom))}.sv-pic.is-viewed .ed-compare-line{width:calc(2px / var(--zoom));margin-left:calc(-1px / var(--zoom))}.sv-stage.is-space,.sv-stage.is-space *{cursor:grab!important}.sv-stage.is-panning,.sv-stage.is-panning *{cursor:grabbing!important}.sv-zoom{position:relative;display:inline-flex;align-items:center;gap:1px;height:30px;padding:0 3px;border-radius:999px;border:1px solid rgba(255,255,255,.2);background:#04030ca8;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px)}.sv-zoom-btn,.sv-zoom-pct{display:inline-flex;align-items:center;justify-content:center;height:24px;padding:0;border:0;border-radius:999px;background:transparent;color:#fff;font-family:var(--font-sans);cursor:pointer;transition:background var(--dur-fast)}.sv-zoom-btn{width:24px;color:var(--fg-2)}.sv-zoom-btn:hover:not(:disabled),.sv-zoom-pct:hover,.sv-zoom-pct.on{background:#ffffff1f;color:#fff}.sv-zoom-btn:disabled{opacity:.35;cursor:default}.sv-zoom-pct{gap:2px;min-width:52px;padding:0 4px 0 7px;font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums}.sv-zoom-pct .chev{color:var(--fg-3);transition:transform .2s var(--ease-out-soft)}.sv-zoom-pct.on .chev{transform:rotate(180deg)}.sv-pop.sv-zoom-pop{min-width:0;width:208px;left:-4px}.sv-zoom-pop .sv-pop-row{justify-content:space-between;white-space:nowrap}.sv-zoom-pop .sv-pop-row:disabled{opacity:.4;cursor:default}.sv-zoom-pop .sv-pop-row:disabled:hover{background:transparent}.sv-zoom-pop kbd{min-width:18px;height:18px;padding:0 5px;display:inline-flex;align-items:center;justify-content:center;border-radius:5px;border:1px solid rgba(255,255,255,.1);background:#ffffff0f;color:var(--fg-3);font-family:var(--font-sans);font-size:10.5px;font-weight:600}@media(prefers-reduced-motion:reduce){.sv-pic.is-gliding,.sv-pic.is-gliding .sv-pic-view{transition:none}}.ed-tool-body.is-held{opacity:.55;transition:opacity var(--dur-fast)}.ed-relight-reset{display:flex;justify-content:flex-end}.ed-relight-reset .sv-btn{height:30px;padding:0 11px;gap:6px;font-size:11.5px}.ed-mix-pick{display:flex;align-items:center;gap:10px}.ed-mix-dropper{height:30px;padding:0 11px;gap:6px;font-size:11.5px}.ed-mix-dropper.on{background:var(--cv-accent-tint);border-color:#c2a4ec73;color:var(--fg-1)}.ed-mix-swatch{display:inline-flex;align-items:center;gap:5px;margin-left:auto;color:var(--fg-4)}.ed-mix-swatch i{width:26px;height:26px;border-radius:8px;box-shadow:inset 0 0 0 1px #fff3;transition:background .2s ease}.ed-hint b{font-weight:600;color:var(--fg-2)}.sv-pic-clip.is-picking,.sv-pic-clip.is-picking *{cursor:crosshair!important}`, UCe = '.lb-backdrop{position:fixed;inset:0;z-index:92;display:flex;align-items:center;justify-content:center;padding:26px 34px;background:#04030cb8;backdrop-filter:blur(16px) saturate(110%);-webkit-backdrop-filter:blur(16px) saturate(110%);animation:lbFade .22s var(--ease-out-soft) both}@keyframes lbFade{0%{opacity:0}to{opacity:1}}.lb-shell{position:relative;display:flex;flex-direction:column;width:min(1520px,100%);height:min(940px,100%);border-radius:24px;overflow:hidden;color:var(--fg-2);background:linear-gradient(180deg,#10121ef7,#090a11fa);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 40px 120px #02040cb3,0 0 0 1px #0006;animation:lbIn .34s var(--ease-out-soft) both}@keyframes lbIn{0%{opacity:0;transform:translateY(12px) scale(.985)}to{opacity:1;transform:none}}@media(prefers-reduced-motion:reduce){.lb-backdrop,.lb-shell{animation:none}}.lb-head{position:relative;flex:none;padding:18px 22px 0;border-bottom:1px solid var(--hairline-soft)}.lb-glow{position:absolute;inset:0 0 auto;height:190px;pointer-events:none;opacity:.9;background:radial-gradient(60% 120% at 6% -20%,rgba(153,104,223,.3),transparent 62%),radial-gradient(40% 90% at 70% -40%,rgba(90,97,237,.2),transparent 70%),radial-gradient(30% 80% at 98% -30%,rgba(199,80,206,.12),transparent 70%)}.lb-row{position:relative;display:flex;align-items:center;gap:12px}.lb-row.is-top{padding-bottom:16px}.lb-mark{flex:none;width:38px;height:38px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#9968df6b,#5a61ed4d);color:#fff;box-shadow:inset 0 1px #fff3,0 10px 30px #7532d359}.lb-title{display:flex;flex-direction:column;gap:1px;min-width:0;margin-right:8px}.lb-title b{font-size:18px;font-weight:600;color:var(--fg-1);letter-spacing:-.015em}.lb-title span{font-size:12px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.lb-search{flex:1;max-width:560px;margin-left:auto;height:42px;display:flex;align-items:center;gap:10px;padding:0 8px 0 14px;border-radius:13px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-4);box-shadow:inset 0 1px #ffffff0d;cursor:text;transition:border-color var(--dur-fast),box-shadow var(--dur-fast),background var(--dur-fast)}.lb-search:focus-within{border-color:#9968df8c;background:#ffffff12;box-shadow:0 0 0 4px #9968df24;color:var(--amethyst-700)}.lb-search input{flex:1;min-width:0;height:100%;border:0;outline:none;background:transparent;font-family:var(--font-sans);font-size:14px;color:var(--fg-1);user-select:text;-webkit-user-select:text}.lb-search input::placeholder{color:var(--fg-4)}.lb-search kbd{flex:none;min-width:22px;height:22px;display:inline-flex;align-items:center;justify-content:center;border-radius:6px;border:1px solid var(--hairline);background:#ffffff0a;color:var(--fg-4);font-family:var(--font-sans);font-size:11px}.lb-search-clear{flex:none;width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:#ffffff14;color:var(--fg-2);cursor:pointer}.lb-search-clear:hover{background:#ffffff24;color:#fff}.lb-close{flex:none;width:38px;height:38px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid transparent;border-radius:12px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.lb-close:hover{background:#ffffff12;border-color:var(--hairline-soft);color:#fff}.lb-row.is-bar{gap:10px}.lb-tabs{display:flex;align-items:flex-end;gap:4px;align-self:stretch}.lb-tabs button{position:relative;display:inline-flex;align-items:center;gap:8px;height:44px;padding:0 14px;border:0;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:13px;font-weight:600;letter-spacing:.01em;cursor:pointer;transition:color var(--dur-fast)}.lb-tabs button .licon{color:var(--fg-4);transition:color var(--dur-fast)}.lb-tabs button:hover{color:var(--fg-1)}.lb-tabs button:after{content:"";position:absolute;left:12px;right:12px;bottom:-1px;height:2px;border-radius:2px;background:var(--grad-cta);opacity:0;transform:scaleX(.6);transition:opacity var(--dur-fast),transform var(--dur-med) var(--ease-out-soft)}.lb-tabs button.on{color:#fff}.lb-tabs button.on .licon{color:var(--amethyst-600)}.lb-tabs button.on:after{opacity:1;transform:none}.lb-grow{flex:1;min-width:0}.lb-seg{display:inline-flex;align-items:center;gap:2px;padding:3px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09}.lb-seg button{min-width:30px;height:28px;padding:0 7px;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);font-family:var(--font-sans);font-size:11px;font-weight:700;letter-spacing:.04em;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.lb-seg button:hover{color:var(--fg-1);background:#ffffff0d}.lb-seg button.on{background:#ffffff1c;color:#fff;box-shadow:inset 0 1px #ffffff12}.lb-select{display:inline-flex;align-items:center;gap:9px;height:36px;padding:0 13px 0 9px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.lb-select:hover{background:#ffffff12;color:#fff}.lb-select .sw{position:relative;width:30px;height:18px;border-radius:999px;background:#ffffff24;transition:background var(--dur-med)}.lb-select .sw i{position:absolute;left:2px;top:2px;width:14px;height:14px;border-radius:50%;background:#fff;box-shadow:0 1px 4px #0006;transition:transform var(--dur-med) var(--ease-out-soft)}.lb-select.on{border-color:#9968df73;background:#9968df24;color:#fff}.lb-select.on .sw{background:var(--grad-cta)}.lb-select.on .sw i{transform:translate(12px)}.lb-row.is-bar .lb-seg,.lb-row.is-bar .lb-select{margin-bottom:6px}.lb-body{position:relative;flex:1;min-height:0;overflow-y:auto;padding:18px 22px 110px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.16) transparent}.lb-body::-webkit-scrollbar{width:8px}.lb-body::-webkit-scrollbar-thumb{background:#ffffff24;border-radius:999px;border:2px solid transparent;background-clip:content-box}.lb-wall{position:relative}.lb-cell{position:absolute;border-radius:12px;cursor:zoom-in;animation:lbCell .4s var(--ease-out-soft) backwards}.lb-cell.is-selecting{cursor:pointer}@keyframes lbCell{0%{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}.lb-frame{position:absolute;inset:0;overflow:hidden;border-radius:12px;background:#ffffff0a;transition:transform .26s var(--ease-out-soft),box-shadow var(--dur-fast)}.lb-frame img{display:block;width:100%;height:100%;object-fit:cover;opacity:0;transform:scale(1.02);transition:opacity .35s ease,transform .6s var(--ease-out-soft);user-select:none;-webkit-user-drag:none}.lb-frame img.is-in{opacity:1;transform:none}.lb-frame:after{content:"";position:absolute;inset:0;border-radius:12px;box-shadow:inset 0 0 0 1px #ffffff12;pointer-events:none;transition:box-shadow var(--dur-fast)}.lb-cell:hover .lb-frame{transform:translateY(-2px);box-shadow:0 16px 40px #02040c8c}.lb-cell:hover .lb-frame:after{box-shadow:inset 0 0 0 1.5px #c2a4ec80}.lb-shade{position:absolute;inset:0;border-radius:12px;pointer-events:none;opacity:0;background:linear-gradient(180deg,#04030c6b,#04030c00 26% 52%,#04030cdb);transition:opacity var(--dur-fast)}.lb-cell:hover .lb-shade,.lb-cell.is-picked .lb-shade{opacity:1}.lb-info{position:absolute;left:12px;right:12px;bottom:10px;display:flex;flex-direction:column;gap:3px;pointer-events:none;opacity:0;transform:translateY(4px);transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.lb-cell:hover .lb-info{opacity:1;transform:none}.lb-info .p{font-size:12px;line-height:1.35;color:#fff;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.lb-info .m{font-size:10.5px;font-weight:500;color:#ffffff9e;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.lb-badge{position:absolute;top:9px;left:9px;display:inline-flex;align-items:center;gap:4px;height:20px;padding:0 7px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#fff;font-size:10px;font-weight:600;pointer-events:none}.lb-badge.is-fav{left:auto;right:44px;padding:0 6px;color:var(--cv-fav, #ff6b8b)}.lb-badge.is-fav svg{fill:currentColor}.lb-cell:not(.is-selecting) .lb-badge.is-fav{right:9px}.lb-check,.lb-look{position:absolute;top:8px;right:8px;z-index:2;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:1.5px solid rgba(255,255,255,.75);background:#04030c6b;color:#fff;cursor:pointer;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);font-family:var(--font-sans);font-size:12px;font-weight:700;transition:transform var(--dur-fast) var(--ease-out-soft),background var(--dur-fast),border-color var(--dur-fast),opacity var(--dur-fast)}.lb-check{opacity:.85}.lb-cell:hover .lb-check{opacity:1;transform:scale(1.06)}.lb-check.on{opacity:1;border-color:transparent;background:var(--grad-cta);box-shadow:0 4px 14px #745aff80}.lb-look{opacity:0;border-color:#ffffff4d}.lb-cell:hover .lb-look{opacity:1}.lb-look:hover{background:#04030cb3}.lb-cell.is-picked .lb-frame{transform:scale(.94)}.lb-cell.is-picked .lb-frame:after{box-shadow:inset 0 0 0 2.5px var(--amethyst-500)}.lb-cell.is-picked:hover .lb-frame{transform:scale(.94) translateY(-2px)}.lb-cell.is-off{cursor:not-allowed}.lb-cell.is-off .lb-frame{opacity:.35;filter:saturate(.6)}.lb-cell.is-off .lb-check{opacity:.35}.lb-skel{position:absolute;border-radius:12px;overflow:hidden;background:#ffffff0b;animation:lbSkel 1.4s ease-in-out infinite}@keyframes lbSkel{0%,to{opacity:.55}50%{opacity:1}}.lb-more,.lb-end{display:flex;align-items:center;justify-content:center;gap:10px;padding:22px 0 6px;font-size:12px;color:var(--fg-4)}.lb-end{color:var(--fg-5)}.lb-empty{box-sizing:border-box;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;max-width:400px;min-height:100%;margin:0 auto;padding-bottom:4vh;text-align:center;animation:lbEmptyIn .4s var(--ease-out-soft) both}@keyframes lbEmptyIn{0%{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}.lb-empty b{font-size:17px;font-weight:600;color:var(--fg-1)}.lb-empty>span{font-size:13px;line-height:1.55;color:var(--fg-3);text-wrap:balance}.lb-empty .lb-empty-hint{display:inline-flex;align-items:center;gap:6px;margin-top:8px;padding:4px 12px;border-radius:999px;border:1px solid var(--hairline-soft);background:#ffffff0a;font-size:11.5px;color:var(--fg-3)}.lb-empty-hint .key{width:20px;height:20px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#ff5b8a29;color:#ff8aa8}.lb-empty-hint .key svg{fill:currentColor}.le{position:relative;flex:none;width:200px;height:118px;margin-bottom:10px}.le svg{display:block}.le-glow{position:absolute;left:50%;top:52%;width:190px;height:116px;translate:-50% -50%;border-radius:50%;background:radial-gradient(closest-side,rgba(153,104,223,.3),rgba(90,97,237,.11) 60%,transparent);filter:blur(6px)}.le-pic{position:absolute;width:54px;height:42px;border-radius:9px;overflow:hidden;box-shadow:inset 0 0 0 1px #ffffff2e,0 12px 26px #02040c8c}.le-pic .sun{position:absolute;right:9px;top:7px;width:9px;height:9px;border-radius:50%;background:#ffffffd1;box-shadow:0 0 10px #fff9}.le-pic .hill{position:absolute;left:-10px;right:-6px;bottom:-17px;height:28px;border-radius:50%;background:#090b1e8c}.le-pic .hill.b{left:24px;right:-28px;bottom:-19px;background:#090b1e59}.le-pic.p1,.le-pic.f1{background:linear-gradient(160deg,#2d2160,#7532d3 58%,#c750ce)}.le-pic.p2,.le-pic.f2,.le-pic.u{background:linear-gradient(175deg,#1d3a6e,#5a61ed 55%,#9ad0ff)}.le-pic.p3,.le-pic.f3{background:linear-gradient(165deg,#3a2240,#c750ce 52%,#ffb38a)}.le-pic.p1{left:24px;top:14px;rotate:-7deg}.le-pic.p2{left:73px;top:8px;z-index:2}.le-pic.p3{left:122px;top:14px;rotate:7deg}.le-spark{position:absolute;left:170px;top:0;color:#e2d4ff;filter:drop-shadow(0 0 6px rgba(196,167,255,.8))}.le-prompt{position:absolute;left:28px;top:78px;z-index:3;box-sizing:border-box;width:144px;height:26px;padding:0 5px 0 9px;display:flex;align-items:center;gap:6px;border-radius:13px;color:#c4a7ff;background:#10121ef0;border:1px solid rgba(255,255,255,.12);box-shadow:0 10px 24px #02040c80}.le-prompt .t1,.le-prompt .t2{height:5px;border-radius:3px;transform-origin:0 50%}.le-prompt .t1{width:54px;background:#ffffff57}.le-prompt .t2{width:26px;background:#ffffff2e}.le-prompt .run{margin-left:auto;width:16px;height:16px;border-radius:50%;background:var(--grad-cta, #8b5cf6)}.le-drop{position:absolute;left:46px;top:40px;box-sizing:border-box;width:108px;height:66px;border-radius:12px;display:flex;align-items:center;justify-content:center;color:#c4a7ff8c;border:1.5px dashed rgba(194,164,236,.38);background:#9968df0f}.le-pic.u{left:73px;top:52px;z-index:2}.le-check{position:absolute;left:144px;top:30px;z-index:3;width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#34c79a;color:#fff;box-shadow:0 0 0 2px #0b0d15f2,0 6px 14px #02040c99}.le-pic.f1{left:30px;top:38px;rotate:-10deg}.le-pic.f3{left:116px;top:38px;rotate:10deg}.le-pic.f2{left:73px;top:24px;z-index:2;rotate:-1deg}.le-heart{position:absolute;left:113px;top:14px;z-index:4;width:22px;height:22px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#ff5b8a;color:#fff;box-shadow:0 0 0 2px #0b0d15f2,0 6px 14px #02040c99}.le-heart svg{fill:currentColor}.le-burst{position:absolute;left:124px;top:25px;z-index:3;width:0;height:0}.le-burst i{position:absolute;left:-2px;top:-2px;width:4px;height:4px;border-radius:50%;background:#ff9ab6;opacity:0}.le-burst .b1{--bx: 0px;--by: -18px}.le-burst .b2{--bx: 16px;--by: -9px}.le-burst .b3{--bx: 16px;--by: 9px}.le-burst .b4{--bx: 0px;--by: 18px}.le-burst .b5{--bx: -16px;--by: 9px}.le-burst .b6{--bx: -16px;--by: -9px}.le-ghost{position:absolute;box-sizing:border-box;width:54px;height:42px;border-radius:9px;border:1.5px dashed rgba(255,255,255,.18);background:#ffffff06}.le-ghost.g1{left:24px;top:30px;rotate:-6deg}.le-ghost.g2{left:73px;top:24px}.le-ghost.g3{left:122px;top:30px;rotate:6deg}.le-lens{position:absolute;left:85px;top:28px;z-index:2;box-sizing:border-box;width:30px;height:30px;border-radius:50%;border:2.5px solid rgba(214,200,255,.92);background:#9968df24;box-shadow:0 8px 20px #02040c80}.le-lens:after{content:"";position:absolute;left:22px;top:25px;width:12px;height:3.5px;border-radius:2px;background:#d6c8ffeb;rotate:45deg}.le-track{position:absolute;left:50px;width:100px;height:3px;border-radius:2px;background:#ffffff24}.le-track.t1{top:84px}.le-track.t2{top:98px}.le-track .knob{position:absolute;top:-5px;box-sizing:border-box;width:13px;height:13px;border-radius:50%;background:#fff;border:2.5px solid #9968df;box-shadow:0 3px 8px #02040c8c}.le-track.t1 .knob{left:20px}.le-track.t2 .knob{left:68px}@media(prefers-reduced-motion:no-preference){.le-glow{animation:leGlow 6s ease-in-out infinite}@keyframes leGlow{0%,to{opacity:.7}45%{opacity:1}}.is-generations .le-prompt .t1{animation:leType1 6s ease-out infinite}.is-generations .le-prompt .t2{animation:leType2 6s ease-out infinite}.is-generations .le-prompt .run{animation:leRun 6s ease-out infinite}.le-pic.p1{animation:leLand1 6s var(--ease-out-soft) infinite}.le-pic.p2{animation:leLand2 6s var(--ease-out-soft) infinite}.le-pic.p3{animation:leLand3 6s var(--ease-out-soft) infinite}.le-spark{animation:leSpark 6s ease-out infinite}@keyframes leType1{0%{transform:scaleX(0);opacity:1}14%,86%{transform:scaleX(1);opacity:1}95%,to{transform:scaleX(1);opacity:0}}@keyframes leType2{0%,10%{transform:scaleX(0);opacity:1}22%,86%{transform:scaleX(1);opacity:1}95%,to{transform:scaleX(1);opacity:0}}@keyframes leRun{0%,24%{scale:1;box-shadow:0 0 #c2a4ecb3}27%{scale:.8}36%{scale:1;box-shadow:0 0 0 8px #c2a4ec00}to{scale:1;box-shadow:0 0 #c2a4ec00}}@keyframes leLand1{0%,30%{opacity:0;translate:0 14px;scale:.7}38%{opacity:1;translate:0 -2px;scale:1.04}44%,86%{opacity:1;translate:0 0;scale:1}95%,to{opacity:0;translate:0 -6px;scale:1}}@keyframes leLand2{0%,35%{opacity:0;translate:0 14px;scale:.7}43%{opacity:1;translate:0 -2px;scale:1.04}49%,86%{opacity:1;translate:0 0;scale:1}95%,to{opacity:0;translate:0 -6px;scale:1}}@keyframes leLand3{0%,40%{opacity:0;translate:0 14px;scale:.7}48%{opacity:1;translate:0 -2px;scale:1.04}54%,86%{opacity:1;translate:0 0;scale:1}95%,to{opacity:0;translate:0 -6px;scale:1}}@keyframes leSpark{0%,52%{opacity:0;scale:.4;rotate:-25deg}60%{opacity:1;scale:1.2;rotate:0deg}66%,82%{opacity:1;scale:1;rotate:0deg}92%,to{opacity:0;scale:.6;rotate:10deg}}.le-pic.u{animation:leDropIn 5.6s var(--ease-out-soft) infinite}.le-drop{animation:leZone 5.6s ease-in-out infinite}.le-check{animation:leCheck 5.6s var(--ease-out-soft) infinite}@keyframes leDropIn{0%{opacity:0;translate:28px -60px;rotate:14deg;scale:1}10%{opacity:1}34%{translate:0 0;rotate:0deg;scale:1}39%{scale:.93}45%,86%{opacity:1;translate:0 0;rotate:0deg;scale:1}95%,to{opacity:0;translate:0 0;rotate:0deg;scale:.96}}@keyframes leZone{0%,16%,52%,to{border-color:#c2a4ec61;background-color:#9968df0f}26%,38%{border-color:#c2a4ece6;background-color:#9968df29}}@keyframes leCheck{0%,42%{opacity:0;scale:.3}50%{opacity:1;scale:1.2}56%,86%{opacity:1;scale:1}95%,to{opacity:0;scale:.8}}.le-heart{animation:leHeart 5.2s var(--ease-out-soft) infinite}.le-burst i{animation:leBurst 5.2s ease-out infinite}.le-pic.f2{animation:leLift 5.2s var(--ease-out-soft) infinite}.le-pic.f1{animation:leFloat 5.2s ease-in-out infinite}.le-pic.f3{animation:leFloat 5.2s ease-in-out -1.7s infinite}@keyframes leHeart{0%,20%{opacity:0;scale:.2}28%{opacity:1;scale:1.32}34%{scale:.9}40%,86%{opacity:1;scale:1}95%,to{opacity:0;scale:.7}}@keyframes leBurst{0%,26%{opacity:0;translate:0 0;scale:1}29%{opacity:1}46%,to{opacity:0;translate:var(--bx) var(--by);scale:.4}}@keyframes leLift{0%,26%{translate:0 0}34%,86%{translate:0 -3px}96%,to{translate:0 0}}@keyframes leFloat{0%,to{translate:0 0}50%{translate:0 -4px}}.le-lens{animation:leSweep 4.4s ease-in-out infinite}.is-filters .le-ghost{animation:leDim 4.4s ease-in-out infinite}.le-track.t1 .knob{animation:leKnob1 4.4s ease-in-out infinite}.le-track.t2 .knob{animation:leKnob2 4.4s ease-in-out infinite}@keyframes leSweep{0%,to{translate:-54px 6px;rotate:-8deg}50%{translate:54px 2px;rotate:8deg}}@keyframes leDim{0%,to{opacity:1}50%{opacity:.3}}@keyframes leKnob1{0%,to{translate:0 0}50%{translate:48px 0}}@keyframes leKnob2{0%,to{translate:0 0}50%{translate:-48px 0}}}.lb-empty .lb-btn{margin-top:8px}.lb-empty-mark{width:48px;height:48px;border-radius:15px;margin-bottom:6px;display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#9968df4d,#5a61ed33);color:#fff;box-shadow:inset 0 1px #ffffff29,0 14px 40px #7532d347}.lb-empty-mark.is-warn{background:#ff5c7a24;color:#ff8aa0;box-shadow:none}.lb-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:40px;padding:0 16px;border-radius:12px;border:1px solid var(--hairline);background:#ffffff0f;color:var(--fg-1);font-family:var(--font-sans);font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),border-color var(--dur-fast),filter var(--dur-fast),transform var(--dur-fast)}.lb-btn:hover:not(:disabled){background:#ffffff1a;border-color:#ffffff29}.lb-btn:active:not(:disabled){transform:scale(.98)}.lb-btn:disabled{opacity:.45;cursor:default}.lb-btn.is-ghost{border-color:transparent;background:transparent;color:var(--fg-2)}.lb-btn.is-ghost:hover{background:#ffffff0f;color:#fff}.lb-btn.is-primary{border-color:transparent;background:var(--grad-cta);color:#fff;box-shadow:0 8px 24px #745aff59,inset 0 1px #ffffff38}.lb-btn.is-primary:hover:not(:disabled){filter:brightness(1.08);background:var(--grad-cta)}.lb-btn.is-primary:disabled{background:#ffffff12;box-shadow:none;color:var(--fg-4);opacity:1}.lb-btn.is-picked{border-color:#9968df80;background:#9968df2e}.lb-tray{position:absolute;left:50%;bottom:22px;z-index:5;transform:translate(-50%);display:flex;align-items:center;gap:12px;width:min(720px,calc(100% - 44px));padding:10px 10px 10px 14px;border-radius:18px;background:#0e101af0;border:1px solid var(--hairline);backdrop-filter:blur(26px) saturate(120%);-webkit-backdrop-filter:blur(26px) saturate(120%);box-shadow:var(--inset-highlight),0 24px 70px #02040cb3}.lb-tray-enter-active,.lb-tray-leave-active{transition:opacity .24s var(--ease-out-soft),transform .24s var(--ease-out-soft)}.lb-tray-enter-from,.lb-tray-leave-to{opacity:0;transform:translate(-50%) translateY(14px)}.lb-tray-picks{display:flex;align-items:center;min-width:0}.lb-tray-thumb{position:relative;flex:none;width:34px;height:34px;margin-right:-10px;border-radius:9px;background-size:cover;background-position:center;box-shadow:0 0 0 2px #0e101a,0 4px 12px #0006;animation:lbThumb .26s var(--ease-out-soft) backwards}@keyframes lbThumb{0%{opacity:0;transform:scale(.6) translateY(6px)}to{opacity:1;transform:none}}.lb-tray-count{margin-left:22px;font-size:13px;color:var(--fg-3);white-space:nowrap}.lb-tray-picks .lb-tray-count:first-child{margin-left:2px}.lb-tray-count b{font-size:15px;font-weight:700;color:#fff;font-variant-numeric:tabular-nums}.lb-tray-clear{flex:none;padding:0 4px;border:0;background:transparent;color:var(--amethyst-700);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.lb-tray-clear:hover{color:#fff;text-decoration:underline;text-underline-offset:3px}.lb-note{position:absolute;left:50%;bottom:96px;z-index:6;transform:translate(-50%);display:inline-flex;align-items:center;height:32px;padding:0 14px;border-radius:999px;white-space:nowrap;background:#11131ef7;border:1px solid var(--hairline);color:var(--fg-1);font-size:12.5px;font-weight:500;box-shadow:0 14px 40px #02040c80}.lb-note-enter-active,.lb-note-leave-active{transition:opacity .2s var(--ease-out-soft),transform .2s var(--ease-out-soft)}.lb-note-enter-from,.lb-note-leave-to{opacity:0;transform:translate(-50%,6px)}.lb-peek{position:absolute;inset:0;z-index:8;display:flex;align-items:center;justify-content:center;padding:26px 70px;background:#06060ee6;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);animation:lbFade .2s var(--ease-out-soft) both}.lb-peek-shell{display:grid;grid-template-columns:minmax(0,1fr) 340px;gap:22px;width:100%;height:100%;animation:lbIn .3s var(--ease-out-soft) both}.lb-peek-stage{position:relative;min-width:0;display:flex;align-items:center;justify-content:center;border-radius:18px;background:#ffffff06;border:1px solid var(--hairline-soft);overflow:hidden}.lb-peek-art{display:block;max-width:calc(100% - 36px);max-height:calc(100% - 36px);border-radius:12px;box-shadow:0 30px 100px #02061799;transition:opacity .3s ease}.lb-peek-art.is-loading{opacity:0}.lb-peek-nav{position:absolute;top:50%;z-index:2;width:44px;height:44px;margin-top:-22px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-2);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.lb-peek-nav:hover:not(:disabled){background:#ffffff1f;color:#fff}.lb-peek-nav:disabled{opacity:.3;cursor:default}.lb-peek-nav.at-left{left:14px}.lb-peek-nav.at-right{right:14px}.lb-peek-side{display:flex;flex-direction:column;gap:16px;min-width:0;padding:18px;border-radius:18px;background:#ffffff09;border:1px solid var(--hairline-soft);overflow-y:auto}.lb-peek-top{display:flex;align-items:center;gap:8px}.lb-peek-top .n{display:inline-flex;align-items:center;gap:7px;font-size:12px;color:var(--fg-3);font-variant-numeric:tabular-nums}.lb-peek-x{margin-left:auto;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:10px;background:#ffffff0d;color:var(--fg-2);cursor:pointer}.lb-peek-x:hover{background:#ffffff1a;color:#fff}.lb-peek-block{display:flex;flex-direction:column;gap:8px}.lb-peek-head{display:flex;align-items:center;justify-content:space-between;font-size:11px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-4)}.lb-peek-head span{display:inline-flex;align-items:center;gap:7px}.lb-peek-head button{width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer}.lb-peek-head button:hover{background:#ffffff12;color:#fff}.lb-peek-prompt{margin:0;max-height:260px;overflow-y:auto;font-size:13.5px;line-height:1.6;color:var(--fg-1);white-space:pre-wrap;overflow-wrap:anywhere}.lb-peek-specs{margin:0;display:flex;flex-direction:column;gap:1px;border-radius:12px;overflow:hidden;border:1px solid var(--hairline-soft)}.lb-peek-specs div{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 12px;background:#ffffff06}.lb-peek-specs dt{font-size:12px;color:var(--fg-4)}.lb-peek-specs dd{margin:0;font-size:12.5px;color:var(--fg-1);text-align:right;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.lb-peek-acts{display:flex;flex-direction:column;gap:8px}.lb-peek-acts .lb-btn{width:100%}@media(max-width:980px){.lb-backdrop{padding:12px}.lb-title span{display:none}.lb-row.is-bar{flex-wrap:wrap}.lb-tabs button{padding:0 10px}.lb-peek{padding:16px}.lb-peek-shell{grid-template-columns:1fr;grid-template-rows:minmax(0,1fr) auto}.lb-peek-nav{display:none}}.lb-tool{display:inline-flex;align-items:center;gap:8px;height:36px;padding:0 12px;margin-bottom:6px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.lb-tool .licon{color:var(--fg-4);transition:color var(--dur-fast)}.lb-tool:hover{background:#ffffff12;color:#fff}.lb-tool.on,.lb-tool.is-set{border-color:#9968df73;background:#9968df24;color:#fff}.lb-tool.on .licon,.lb-tool.is-set .licon{color:var(--amethyst-700)}.lb-tool .n{min-width:18px;height:18px;padding:0 5px;display:inline-flex;align-items:center;justify-content:center;border-radius:999px;background:var(--grad-cta);color:#fff;font-size:10.5px;font-weight:700;font-variant-numeric:tabular-nums}.lb-cols{display:inline-flex;align-items:center;gap:2px;height:36px;padding:3px;margin-bottom:6px;border-radius:11px;border:1px solid var(--hairline-soft);background:#ffffff09}.lb-cols button{width:26px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.lb-cols button:hover:not(:disabled){background:#ffffff12;color:#fff}.lb-cols button:disabled{opacity:.3;cursor:default}.lb-cols span{display:inline-flex;align-items:center;gap:5px;min-width:38px;justify-content:center;color:var(--fg-4)}.lb-cols span b{font-size:12.5px;font-weight:700;color:#fff;font-variant-numeric:tabular-nums}.lb-link{display:inline-flex;align-items:center;gap:6px;padding:0;border:0;background:transparent;color:var(--amethyst-700);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer}.lb-link:hover{color:#fff;text-decoration:underline;text-underline-offset:3px}.lb-filters{position:relative;z-index:4;flex:none;padding:16px 22px 14px;border-bottom:1px solid var(--hairline-soft);background:linear-gradient(180deg,#9968df0f,#ffffff04);animation:lbDrop .26s var(--ease-out-soft) both}@keyframes lbDrop{0%{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:none}}.lb-filters-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(212px,1fr));gap:14px 16px}.lb-field{display:flex;flex-direction:column;gap:7px;min-width:0}.lb-field.is-wide{grid-column:1 / -1}.lb-field.is-dates{grid-column:span 2}.lb-field.is-dates .lb-dates input{max-width:190px}.lb-field-label{font-size:10px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.lb-chips{display:flex;flex-wrap:wrap;gap:6px}.lb-chip{display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 11px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff09;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.lb-chip:hover{background:#ffffff12;color:#fff}.lb-chip.on{border-color:#9968df8c;background:#9968df33;color:#fff}.lb-chip .licon{color:var(--fg-4)}.lb-chip.on .licon{color:#ff8fb0}.lb-chip .glyph{flex:none;display:inline-block;border-radius:2.5px;border:1.5px solid currentColor;opacity:.75}.lb-chip .glyph.is-other{border-style:dashed}.lb-dates{display:flex;align-items:center;gap:6px}.lb-dates input{flex:1;min-width:0;height:36px;padding:0 9px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:12px;color-scheme:dark;outline:none}.lb-dates input:focus{border-color:#9968df8c}.lb-dates .to{font-size:11.5px;color:var(--fg-4)}.lb-dates-x{flex:none;width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:#ffffff0f;color:var(--fg-3);cursor:pointer}.lb-dates-x:hover{background:#ffffff1f;color:#fff}.lb-filters-foot{display:flex;align-items:center;gap:12px;margin-top:16px;padding-top:14px;border-top:1px solid var(--hairline-soft)}.lb-filters-count{font-size:12px;color:var(--fg-4)}.lb-filters-foot .lb-btn{height:36px}.lb-select-wrap{position:relative;min-width:0}.lb-select-btn{display:flex;align-items:center;gap:8px;width:100%;height:36px;padding:0 10px;border-radius:10px;border:1px solid var(--hairline-soft);background:#ffffff0a;color:var(--fg-3);font-family:var(--font-sans);font-size:12.5px;text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.lb-select-btn .licon{flex:none;color:var(--fg-4)}.lb-select-btn .t{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.lb-select-btn:hover,.lb-select-btn.on{background:#ffffff12;color:#fff}.lb-select-btn.on{border-color:#9968df80}.lb-select-btn.is-set{color:#fff;border-color:#9968df73;background:#9968df1f}.lb-select-btn.is-set .licon:first-child{color:var(--amethyst-700)}.lb-select-pop{position:absolute;left:0;right:0;top:calc(100% + 6px);z-index:20;min-width:220px;padding:6px;border-radius:13px;background:#0d0f18fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 60px #02040c99;animation:lbDrop .18s var(--ease-out-soft) both}.lb-select-search{display:flex;align-items:center;gap:8px;height:32px;padding:0 9px;margin-bottom:4px;border-radius:9px;background:#ffffff0d;color:var(--fg-4)}.lb-select-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px}.lb-select-rows{max-height:260px;overflow-y:auto;scrollbar-width:thin}.lb-select-row{display:flex;align-items:center;gap:8px;width:100%;height:32px;padding:0 9px;border:0;border-radius:8px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);font-size:12.5px;text-align:left;cursor:pointer}.lb-select-row .t{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.lb-select-row.is-active{background:#ffffff0f;color:#fff}.lb-select-row.on{color:#fff}.lb-select-row.on .licon{color:var(--amethyst-600)}.lb-select-row.is-any{color:var(--fg-4)}.lb-select-none{padding:10px 9px;font-size:12px;color:var(--fg-4)}.lb-applied{flex:none;display:flex;align-items:center;flex-wrap:wrap;gap:8px;padding:12px 22px 0}.lb-applied-chip{display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 4px 0 11px;border-radius:999px;border:1px solid rgba(153,104,223,.4);background:#9968df1f;color:#fff;font-size:12px;font-weight:600;animation:lbThumb .24s var(--ease-out-soft) backwards}.lb-applied-chip.is-search .licon{color:var(--amethyst-700)}.lb-applied-chip button{width:20px;height:20px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:#ffffff1a;color:var(--fg-2);cursor:pointer}.lb-applied-chip button:hover{background:#fff3;color:#fff}.lb-applied-note{font-size:11.5px;color:var(--fg-4)}.lb-star{position:absolute;top:8px;right:42px;z-index:2;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;border:0;background:#04030c80;color:#fff;cursor:pointer;opacity:0;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft),background var(--dur-fast)}.lb-cell:hover .lb-star,.lb-star.on{opacity:1}.lb-star:hover{transform:scale(1.08);background:#04030cb8}.lb-star.on{color:#ff6b8b}.lb-star.on svg{fill:currentColor}.lb-star.is-still{cursor:default}.lb-cell:not(.is-selecting) .lb-star{right:42px}.lb-cell.is-moderated{cursor:help}.lb-withheld{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;color:var(--fg-4);background:radial-gradient(120% 90% at 30% 20%,#9968df38,#ffffff08 70%)}.lb-withheld b{font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase}.lb-cell.is-list{display:flex;align-items:center;gap:16px;padding:8px 120px 8px 8px;border-radius:14px;background:#ffffff06;border:1px solid var(--hairline-soft);transition:background var(--dur-fast),border-color var(--dur-fast)}.lb-cell.is-list:hover{background:#ffffff0d}.lb-cell.is-list .lb-frame{position:relative;inset:auto;flex:none;width:92px;height:92px;border-radius:10px}.lb-cell.is-list:hover .lb-frame{transform:none;box-shadow:none}.lb-cell.is-list.is-picked{border-color:#9968df99;background:#9968df1a}.lb-cell.is-list.is-picked .lb-frame{transform:none}.lb-row-text{flex:1;min-width:0;display:flex;flex-direction:column;gap:6px}.lb-row-text .p{font-size:13px;line-height:1.45;color:var(--fg-1);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.lb-row-text .m{font-size:11.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.lb-cell.is-list .lb-check,.lb-cell.is-list .lb-look{top:50%;right:16px;margin-top:-14px}.lb-cell.is-list .lb-star{top:50%;right:54px;margin-top:-14px}.lb-cell.is-list .lb-badge{top:14px;left:14px}.lb-upload-tile{position:absolute;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;padding:10px;border-radius:12px;border:1.5px dashed rgba(194,164,236,.4);background:#9968df0f;color:var(--fg-2);font-family:var(--font-sans);cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.lb-upload-tile:hover{background:#9968df21;border-color:#c2a4ecb3;transform:translateY(-2px)}.lb-upload-tile .ic{width:40px;height:40px;margin-bottom:4px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#9968df66,#5a61ed4d);color:#fff}.lb-upload-tile b{font-size:13px;font-weight:600;color:#fff}.lb-upload-tile span{font-size:11.5px;color:var(--fg-4)}.lb-upload-tile.is-list{flex-direction:row;gap:14px;justify-content:flex-start;padding:0 18px}.lb-upload-tile.is-list .ic{margin:0}.lb-cell.is-uploading{cursor:progress}.lb-uploading{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;gap:8px;padding:10px;font-size:11.5px;color:var(--fg-3);text-align:center;overflow:hidden}.lb-cell.is-uploading .lb-frame:before{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.08) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.lb-dropping{position:absolute;inset:0;z-index:9;display:flex;align-items:center;justify-content:center;background:#04030c99;pointer-events:none;animation:lbFade .16s ease both}.lb-dropping>div{display:inline-flex;align-items:center;gap:10px;padding:16px 22px;border-radius:16px;border:1.5px dashed rgba(194,164,236,.75);background:#0d0f18f0;color:#fff;font-size:14px;font-weight:500}.lb-more.is-failed{color:#ff9db5}.lb-note.is-error{border-color:#ff5c7a66;color:#ffb3c1}.lb-peek-act{flex:none;height:32px;min-width:32px;padding:0 8px;display:inline-flex;align-items:center;justify-content:center;gap:6px;border:0;border-radius:10px;background:#ffffff0d;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.lb-peek-act:hover{background:#ffffff1a;color:#fff}.lb-peek-act.lb-peek-star.on{color:#ff6b8b}.lb-peek-act.lb-peek-star.on svg{fill:currentColor}.lb-peek-act.lb-peek-pin.on{color:#c4a7ff;background:#9968df29}.lb-peek-act.lb-peek-pin.on svg{fill:currentColor}.lb-peek-act.is-danger:hover,.lb-peek-act.is-confirming{background:#ff5c7a29;color:#ff9db5}.lb-peek-withheld{display:flex;flex-direction:column;align-items:center;gap:10px;max-width:420px;padding:24px;text-align:center}.lb-peek-withheld b{font-size:16px;color:#fff}.lb-peek-withheld span{font-size:13px;line-height:1.6;color:var(--fg-3)}.lb-badge.is-3d{color:#b9c1ff}', GCe = '.pl-wrap{position:relative;z-index:6;width:min(1200px,calc(100% - 16px));margin-bottom:12px;animation:plRise .46s var(--ease-out-soft) both}@keyframes plRise{0%{opacity:0;transform:translateY(18px) scale(.985)}to{opacity:1;transform:none}}@media(prefers-reduced-motion:reduce){.pl-wrap{animation:none}}.pl-float{position:absolute;left:var(--chat-w);right:var(--set-w);top:52px;bottom:84px;z-index:72;display:flex;align-items:center;justify-content:center;pointer-events:none}.pl-float>.pl-wrap{pointer-events:auto;margin-bottom:0}.pl-panel{position:relative;display:flex;overflow:hidden;height:clamp(340px,calc(100vh - 52px - var(--up-card-h, 150px) - 84px),740px);border:1px solid rgba(255,255,255,.06);border-radius:22px;background:radial-gradient(120% 70% at 50% -18%,rgba(153,104,223,.11),transparent 62%),#0a0c14fb;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0d,0 2px 8px #02040c66,0 40px 110px #02040cad;container:pl-panel / inline-size}.pl-wrap.is-floating .pl-panel{height:clamp(360px,calc(100vh - 184px),760px)}.pl-close{position:absolute;top:-12px;right:-12px;z-index:3;width:30px;height:30px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid rgba(255,255,255,.1);border-radius:50%;background:#141723f7;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);color:var(--fg-2);cursor:pointer;box-shadow:0 6px 18px #02040c8c;transition:background var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-close:hover{background:#222638fa;color:#fff;transform:rotate(90deg)}.pl-side{flex:none;width:248px;min-height:0;box-sizing:border-box;display:flex;flex-direction:column;padding:14px 8px 12px 12px;border-right:1px solid rgba(255,255,255,.05);background:#ffffff04}.pl-side-tabs{display:flex;width:100%;box-sizing:border-box}.pl-tabs.pl-side-tabs button{flex:1 1 0;min-width:0;justify-content:center;gap:6px;padding:0 6px;white-space:nowrap}.pl-side-scroll{flex:1;min-height:0;overflow-y:auto;margin-top:12px;padding-right:4px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.1) transparent}.pl-tree{display:flex;flex-direction:column;gap:1px}.pl-node{position:relative;display:flex;align-items:center;gap:9px;width:100%;min-height:32px;box-sizing:border-box;padding:0 10px;border:0;border-radius:9px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12.5px;font-weight:500;text-align:left;cursor:pointer;outline:none;transition:background var(--dur-fast),color var(--dur-fast),box-shadow var(--dur-fast)}.pl-node>.licon{flex:none;color:var(--fg-4);transition:color var(--dur-fast)}.pl-node .lbl{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-node .n{flex:none;font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-node:hover{background:#ffffff0b;color:var(--fg-1)}.pl-node:focus-visible{box-shadow:inset 0 0 0 1.5px var(--vista-blue-500)}.pl-node.on{background:var(--cv-accent-tint);color:var(--fg-1);box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.pl-node.on>.licon,.pl-node.is-in>.licon{color:var(--cv-accent-text)}.pl-node.is-empty:not(.on) .lbl,.pl-node.is-empty:not(.on)>.licon{opacity:.5}.pl-node.is-root{margin-bottom:4px}.pl-node.is-kind{margin-top:8px;color:var(--fg-2);font-weight:600}.pl-branch.is-in>.pl-node.is-kind{color:var(--fg-1)}.pl-node.is-action{min-height:40px;padding:5px 10px 5px 30px}.pl-node.is-action .lbl{display:flex;flex-direction:column;gap:1px;line-height:1.3}.pl-node.is-action em{font-style:normal;font-size:10.5px;font-weight:500;color:var(--fg-4);overflow:hidden;text-overflow:ellipsis}.pl-node.is-action.on em{color:var(--fg-3)}.pl-leaves{position:relative;display:flex;flex-direction:column;gap:1px;margin:1px 0 3px}.pl-leaves:before{content:"";position:absolute;left:36px;top:4px;bottom:4px;width:1px;background:#ffffff14}@media(prefers-reduced-motion:no-preference){.pl-leaves{animation:plLeaves .32s var(--ease-out-soft) both}}@keyframes plLeaves{0%{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}.pl-node.is-cat{min-height:29px;padding:5px 10px 5px 46px;font-size:12px;line-height:1.35}.pl-node.is-cat .lbl{white-space:normal;text-wrap:pretty}.pl-side-sec{display:flex;flex-direction:column;gap:1px;margin-top:14px;padding-top:12px;border-top:1px solid var(--hairline-soft)}.pl-side-label{padding:0 10px 6px;font-size:10px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4)}.pl-node.is-level.on{background:transparent;box-shadow:none}.pl-node.is-level.on:hover{background:#ffffff0b}.pl-tick{flex:none;width:14px;height:14px;display:inline-flex;align-items:center;justify-content:center;border-radius:4px;box-shadow:inset 0 0 0 1.5px #ffffff38;color:transparent;transition:background var(--dur-fast),box-shadow var(--dur-fast),color var(--dur-fast)}.pl-node.is-level.on .pl-tick{background:var(--cv-accent);box-shadow:none;color:#fff}.pl-head .pl-side-toggle,.pl-side-scrim{display:none}@container pl-panel (max-width: 700px){.pl-side{position:absolute;z-index:6;top:0;bottom:0;left:0;width:248px;background:#0c0e16fe;box-shadow:18px 0 50px #02040c8c;transform:translate(-104%);visibility:hidden;transition:transform .32s var(--ease-out-soft),visibility 0s linear .32s}.pl-panel.is-side-open .pl-side{transform:none;visibility:visible;transition:transform .32s var(--ease-out-soft)}.pl-head .pl-side-toggle{display:inline-flex;flex:none;width:36px;height:36px;border-radius:11px}.pl-side-scrim{display:block;position:absolute;inset:0;z-index:5;background:#04050a73}}.pl-content{position:relative;flex:1;min-width:0;min-height:0;display:flex;flex-direction:column;container-type:inline-size}.pl-head{display:flex;align-items:center;gap:10px;padding:14px 16px 10px;flex:none}.pl-tabs{display:inline-flex;gap:2px;padding:3px;border-radius:12px;background:#ffffff0a;flex:none}.pl-tabs button{height:30px;padding:0 13px;display:inline-flex;align-items:center;gap:7px;border:0;border-radius:9px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:12.5px;font-weight:500;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.pl-tabs button:hover{color:var(--fg-1)}.pl-tabs button.on{background:#ffffff17;color:var(--fg-1);box-shadow:var(--inset-highlight)}.pl-tabs .n{font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-search{flex:1;min-width:0;height:36px;padding:0 8px 0 12px;display:flex;align-items:center;gap:9px;border:1px solid transparent;border-radius:11px;background:#ffffff0b;color:var(--fg-4);transition:border-color var(--dur-fast),background var(--dur-fast)}.pl-search:focus-within{border-color:var(--cv-accent-soft);background:#ffffff0f}.pl-search.is-off{opacity:.5}.pl-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;font-weight:500;user-select:text;-webkit-user-select:text}.pl-search input::placeholder{color:var(--fg-4)}.pl-clear{width:22px;height:22px;flex:none;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:#ffffff0f;color:var(--fg-3);cursor:pointer}.pl-clear:hover{background:#ffffff1f;color:#fff}.pl-kbd{flex:none;min-width:20px;height:20px;padding:0 6px;display:inline-flex;align-items:center;justify-content:center;border-radius:6px;background:#ffffff0f;color:var(--fg-4);font-family:var(--font-sans);font-size:10.5px}.pl-scope{flex:none;display:flex;align-items:center;gap:8px;min-width:0;padding:0 16px 12px}.pl-scope-crumb{flex:none;display:inline-flex;align-items:center;gap:3px;font-size:12.5px;color:var(--fg-4);white-space:nowrap}.pl-scope-title{flex:none;max-width:50%;font-size:13.5px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-scope-hint{flex:1;min-width:0;font-size:12px;color:var(--fg-3);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-scope-n{flex:none;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-chip{flex:none;height:28px;padding:0 12px;border:1px solid var(--hairline-soft);border-radius:999px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:600;white-space:nowrap;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.pl-chip:hover{color:var(--fg-1);background:#ffffff0d}.pl-chip.on{color:var(--fg-1);background:var(--cv-accent-tint);border-color:var(--cv-accent-soft)}.pl-main{position:relative;flex:1;min-height:0}.pl-body{position:absolute;inset:0;overflow-y:auto;padding:2px 16px 16px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.pl-body::-webkit-scrollbar{width:6px}.pl-body::-webkit-scrollbar-thumb{background:#ffffff1f;border-radius:999px}.pl-body.is-covered{visibility:hidden}.pl-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px}@container (max-width: 640px){.pl-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}@container (max-width: 400px){.pl-grid{grid-template-columns:minmax(0,1fr)}}.pl-tile{position:relative;aspect-ratio:4 / 3;border-radius:15px;overflow:hidden;isolation:isolate;background:#0c0e17;box-shadow:inset 0 0 0 1px #ffffff0f;transition:transform .35s var(--ease-out-soft),box-shadow .35s var(--ease-out-soft)}@media(prefers-reduced-motion:no-preference){.pl-tile{animation:plTileIn .5s var(--ease-out-soft) both}.pl-tile:nth-child(2){animation-delay:.03s}.pl-tile:nth-child(3){animation-delay:.06s}.pl-tile:nth-child(4){animation-delay:.09s}.pl-tile:nth-child(5){animation-delay:.12s}.pl-tile:nth-child(6){animation-delay:.15s}}@keyframes plTileIn{0%{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}.pl-tile:hover,.pl-tile:focus-within{transform:translateY(-3px);box-shadow:inset 0 0 0 1px #ffffff26,0 18px 44px #02040c8c}.pl-tile-art{position:absolute;inset:0;overflow:hidden}.pl-tile-art:before,.pl-tile.is-skeleton:before{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.05) 50%,transparent 80%);animation:shimmer 1.4s linear infinite}.pl-tile.is-in .pl-tile-art:before{display:none}.pl-tile.is-skeleton{animation:none}.pl-tile-img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;opacity:0;transform:scale(1.04);transition:opacity .5s var(--ease-out-soft),transform .9s var(--ease-out-soft)}.pl-tile.is-in .pl-tile-img{opacity:1;transform:none}.pl-tile:hover .pl-tile-img:not(.is-peek){transform:scale(1.035)}.pl-tile-img.is-peek,.pl-tile-img.is-video{z-index:1;opacity:1;transform:none}.pl-tile-shade{position:absolute;inset:0;z-index:2;pointer-events:none;background:linear-gradient(180deg,#04030c00 46%,#04030cd6)}.pl-tile-shade:after{content:"";position:absolute;inset:0;opacity:0;background:linear-gradient(180deg,#04030c00 20%,#04030c99);transition:opacity .55s var(--ease-out-soft)}.pl-tile:hover .pl-tile-shade:after,.pl-tile:focus-within .pl-tile-shade:after{opacity:1}.pl-tile-hit{position:absolute;inset:0;z-index:3;padding:0;border:0;border-radius:inherit;background:transparent;cursor:pointer;outline:none}.pl-tile-hit:focus-visible{box-shadow:inset 0 0 0 2px var(--vista-blue-500)}.pl-tile-meta{position:absolute;left:12px;right:12px;bottom:11px;z-index:4;display:flex;flex-direction:column;gap:2px;pointer-events:none;transform:translateY(40px);transition:transform .6s var(--ease-out-soft)}.pl-tile:hover .pl-tile-meta,.pl-tile:focus-within .pl-tile-meta{transform:none}.pl-tile-name{font-size:13.5px;font-weight:600;letter-spacing:-.01em;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-shadow:0 1px 12px rgba(4,3,12,.5)}.pl-tile-tool{font-size:11px;color:#ffffff9e;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-tile-acts{display:flex;gap:6px;margin-top:9px;opacity:0;pointer-events:auto;transition:opacity .45s var(--ease-out-soft)}.pl-tile:hover .pl-tile-acts,.pl-tile:focus-within .pl-tile-acts{opacity:1}.pl-tile-cap{position:absolute;top:10px;left:58px;z-index:5;max-width:calc(100% - 68px);width:max-content;padding:3px 9px;border-radius:999px;background:#04030cbd;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#fff;font-size:10.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none}.pl-stack{position:absolute;top:10px;left:10px;z-index:5;display:flex;flex-direction:column;gap:5px}.pl-stack-win{height:calc(var(--rows) * 42px - 4px);width:42px;margin:-2px;padding:2px;overflow:hidden;border-radius:11px;box-sizing:content-box}.pl-stack-reel{display:flex;flex-direction:column;gap:4px;transform:translateY(calc(var(--off) * -42px));transition:transform .42s var(--ease-out-soft)}.pl-stack-th{width:38px;height:38px;flex:none;border-radius:9px;background-size:cover;background-position:center;background-color:#ffffff0f;cursor:pointer;box-shadow:0 0 0 1.5px #ffffffd1,0 6px 14px #04030c80;transition:box-shadow var(--dur-fast)}.pl-stack-th.is-markup{box-shadow:0 0 0 1.5px var(--amethyst-700),0 6px 14px #04030c80}.pl-stack-th.on{box-shadow:0 0 0 2px var(--vista-blue-500),0 8px 18px #04030c99}.pl-stack-more{position:relative;width:38px;height:20px;padding:0;overflow:hidden;border:0;border-radius:7px;background:#04030cc2;color:#fff;font-family:var(--font-sans);font-size:10px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.pl-stack-more .n,.pl-stack-more .ic{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;transition:opacity .2s var(--ease-out-soft),transform .2s var(--ease-out-soft)}.pl-stack-more .ic{opacity:0;transform:translateY(-4px)}.pl-tile:hover .pl-stack-more .n{opacity:0;transform:translateY(4px)}.pl-tile:hover .pl-stack-more .ic{opacity:1;transform:none}.pl-stack-more:hover{background:#fffffff0;color:#0b0d14}.pl-btn{display:inline-flex;align-items:center;justify-content:center;gap:6px;height:28px;padding:0 12px;border:0;border-radius:999px;font-family:var(--font-sans);font-size:11.5px;font-weight:600;letter-spacing:-.005em;white-space:nowrap;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-btn:active{transform:scale(.97)}.pl-btn.is-light{background:#fffffff0;color:#0b0d14}.pl-btn.is-light:hover{background:#fff}.pl-btn.is-glass{background:#ffffff1a;color:var(--fg-1);box-shadow:inset 0 0 0 1px #ffffff24;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px)}.pl-btn.is-glass:hover{background:#ffffff2b}.pl-btn.is-lg{height:38px;padding:0 16px;border-radius:12px;font-size:12.5px}.pl-cta{height:38px;padding:0 22px;border:0;border-radius:12px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:13px;font-weight:600;cursor:pointer;box-shadow:0 14px 34px #745aff4d;transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.pl-cta:hover{transform:translateY(-1px);box-shadow:0 18px 42px #745aff66}.pl-cta:active{transform:scale(.98)}.pl-icon-btn{width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.pl-icon-btn:hover{background:#ffffff12;color:var(--fg-1)}.pl-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;min-height:100%;padding:32px 24px;box-sizing:border-box;text-align:center;color:var(--fg-3);font-size:12.5px;line-height:1.55;text-wrap:pretty}.pl-empty>.licon{color:var(--fg-4);margin-bottom:4px}.pl-empty b{color:var(--fg-1);font-size:14px;font-weight:600;letter-spacing:-.01em}.pl-empty>span{max-width:380px}.pl-empty .pl-btn{margin-top:8px}.pl-empty-acts{display:flex;gap:8px}.pl-empty-mark{width:44px;height:44px;margin-bottom:6px;display:inline-flex;align-items:center;justify-content:center;border-radius:14px;background:var(--cv-accent-tint);color:var(--cv-accent-text);box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.pl-detail{position:absolute;inset:0;z-index:2;display:grid;grid-template-columns:minmax(0,1.12fr) minmax(0,1fr);gap:16px;padding:2px 16px 14px}@container (max-width: 600px){.pl-detail{grid-template-columns:minmax(0,1fr);grid-template-rows:minmax(150px,40%) minmax(0,1fr);gap:12px}}.pl-detail-enter-active{transition:opacity .3s var(--ease-out-soft)}.pl-detail-leave-active{transition:opacity .16s ease}.pl-detail-enter-from,.pl-detail-leave-to{opacity:0}.pl-detail-art{position:relative;min-height:0;border-radius:16px;overflow:hidden;display:flex;align-items:center;justify-content:center;background:radial-gradient(90% 70% at 50% 40%,rgba(153,104,223,.07),transparent 70%),#07080f;box-shadow:inset 0 0 0 1px #ffffff0d}.pl-detail-img{display:block;max-width:calc(100% - 28px);max-height:calc(100% - 28px);width:auto;height:auto;border-radius:12px;box-shadow:0 22px 60px #02040c8c}.pl-detail-img.is-landing{opacity:0}.pl-peek-enter-active{transition:opacity .2s var(--ease-out-soft)}.pl-peek-leave-active{transition:opacity .12s ease}.pl-peek-enter-from,.pl-peek-leave-to{opacity:0}.pl-back{position:absolute;top:12px;left:12px;z-index:2;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:10px;background:#04030c9e;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);color:#fff;cursor:pointer;box-shadow:inset 0 0 0 1px #ffffff1f;transition:background var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-back:hover{background:#04030cd6;transform:translate(-2px)}.pl-detail-cap{position:absolute;top:14px;right:14px;z-index:2;max-width:70%;padding:4px 11px;border-radius:999px;background:#04030cb8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#ffffffd9;font-size:11px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none}.pl-detail-strip{position:absolute;left:14px;bottom:14px;z-index:2;display:flex;gap:7px}.pl-th-slot{display:flex;flex:none}.pl-detail-th{width:52px;height:52px;padding:0;border:0;border-radius:11px;cursor:pointer;background-size:cover;background-position:center;background-color:#ffffff0f;box-shadow:0 0 0 1.5px #fffc,0 8px 18px #04030c8c;transition:box-shadow var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-detail-th:hover,.pl-detail-th.on{transform:translateY(-2px);box-shadow:0 0 0 2px var(--vista-blue-500),0 10px 22px #04030c99}.pl-detail-th.is-markup{box-shadow:0 0 0 1.5px var(--amethyst-700),0 8px 18px #04030c8c}.pl-detail-more{height:52px;min-width:40px;padding:0 8px;display:inline-flex;align-items:center;justify-content:center;border-radius:11px;background:#04030cbd;color:#fff;font-size:11px;font-weight:600}.pl-detail-info{position:relative;display:flex;flex-direction:column;min-height:0}.pl-detail-scroll{flex:1;min-height:0;overflow-y:auto;display:flex;flex-direction:column;gap:16px;padding:6px 6px 16px 2px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.pl-detail-foot{flex:none;display:flex;flex-direction:column;gap:8px;padding-top:14px;border-top:1px solid var(--hairline-soft)}@media(prefers-reduced-motion:no-preference){.pl-detail-info{animation:plInfoIn .5s var(--ease-out-soft) .08s both}@keyframes plInfoIn{0%{opacity:0;transform:translate(14px)}to{opacity:1;transform:none}}}.pl-detail-top{display:flex;align-items:center;gap:10px}.pl-crumb{flex:1;min-width:0;font-size:10px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pl-detail-nav{display:inline-flex;align-items:center;gap:2px;flex:none}.pl-detail-nav button{width:26px;height:26px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.pl-detail-nav button:hover:not(:disabled){background:#ffffff12;color:#fff}.pl-detail-nav button:disabled{opacity:.3;cursor:default}.pl-detail-count{min-width:56px;text-align:center;font-size:11px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-detail-name{margin:-6px 0 0;font-size:19px;font-weight:600;letter-spacing:-.02em;line-height:1.2;color:var(--fg-1)}.pl-detail-desc{margin:-8px 0 0;font-size:12.5px;line-height:1.6;color:var(--fg-3);text-wrap:pretty}.pl-block{display:flex;flex-direction:column;gap:8px}.pl-label-row{display:flex;align-items:center;justify-content:space-between;margin:-4px 0}.pl-label{font-size:10px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:var(--fg-4)}.pl-prompt{margin:0;padding:12px 14px;max-height:220px;overflow-y:auto;border-radius:12px;background:#ffffff09;box-shadow:inset 0 0 0 1px #ffffff0d;color:var(--fg-2);font-size:12.5px;line-height:1.6;white-space:pre-wrap;text-wrap:pretty;user-select:text;-webkit-user-select:text;scrollbar-width:thin}.pl-pills{display:flex;flex-wrap:wrap;gap:6px}.pl-pill{display:inline-flex;align-items:center;gap:7px;height:28px;padding:0 11px 0 9px;border-radius:999px;background:#ffffff0e;color:var(--fg-2);font-size:12px;font-weight:500}.pl-pill .licon{color:var(--cv-accent-text)}.pl-pill.is-quiet{background:#ffffff08;color:var(--fg-3)}.pl-pill.is-quiet .licon{color:var(--fg-4)}.pl-note{display:flex;align-items:flex-start;gap:7px;margin:0;padding:9px 11px;border-radius:10px;background:#ffb34712;box-shadow:inset 0 0 0 1px #ffb34729;color:#ffdcaadb;font-size:11.5px;line-height:1.5}.pl-note .licon{margin-top:2px;color:var(--warning);flex:none}.pl-inputs{display:flex;flex-wrap:wrap;gap:7px}.pl-input{position:relative;width:62px;height:62px;padding:0;overflow:hidden;border:0;border-radius:11px;cursor:pointer;background-size:cover;background-position:center;background-color:#ffffff0d;box-shadow:inset 0 0 0 1px #ffffff17;transition:box-shadow var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.pl-input:hover,.pl-input.on{transform:translateY(-2px);box-shadow:0 0 0 2px var(--vista-blue-500)}.pl-input.is-markup{box-shadow:inset 0 0 0 1.5px var(--amethyst-700)}.pl-input-n{position:absolute;top:4px;left:4px;min-width:16px;height:16px;padding:0 4px;border-radius:5px;display:flex;align-items:center;justify-content:center;background:#04030cbd;color:#fff;font-size:9.5px;font-weight:600}.pl-input-tag{position:absolute;left:0;right:0;bottom:0;padding:3px 0;background:#04030cc2;color:#fff;font-size:8.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;text-align:center}.pl-detail-acts{display:flex;align-items:center;gap:8px}.pl-acts-hint{margin:0;font-size:11px;color:var(--fg-4);line-height:1.5}.up-ghost{grid-column:2;grid-row:1;align-self:start;min-width:0;padding-top:4px;font-family:var(--font-sans);font-size:13.5px;line-height:1.55;letter-spacing:-.005em;color:var(--fg-4);pointer-events:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.up-ghost-enter-active{transition:opacity .45s var(--ease-out-soft),transform .45s var(--ease-out-soft)}.up-ghost-leave-active{transition:opacity .22s ease}.up-ghost-enter-from{opacity:0;transform:translateY(5px)}.up-ghost-leave-to{opacity:0}.up-cue{grid-column:2;grid-row:1;align-self:end;justify-self:start;margin-bottom:2px;display:inline-flex;align-items:center;gap:6px;padding:2px 9px 2px 4px;border-radius:999px;background:var(--cv-accent-tint);color:var(--cv-accent-text);font-size:10.5px;letter-spacing:.01em;pointer-events:none;animation:upIn .4s var(--ease-out-soft) .15s both}.up-cue kbd{font-family:var(--font-sans);font-size:9.5px;padding:1px 6px;border-radius:5px;background:#ffffff24;color:var(--fg-1)}.up-cue .src{color:var(--fg-4)}.up-card.is-landed{animation:upLanded 1.2s var(--ease-out-soft)}@keyframes upLanded{0%{box-shadow:inset 0 1px #ffffff0b,0 0 0 1px #a3a7f5e6,0 0 42px #745aff73,0 30px 80px #02040c9e}to{box-shadow:inset 0 1px #ffffff0b,0 0 0 1px #a3a7f500,0 0 #745aff00,0 30px 80px #02040c9e}}@media(prefers-reduced-motion:reduce){.up-card.is-landed{animation:none}}.bd-toast{bottom:max(186px,calc(var(--up-card-h, 0px) + 44px))}.bd-toast.has-action{pointer-events:auto;padding-right:6px}.bd-toast-text{min-width:0;overflow:hidden;text-overflow:ellipsis}.bd-toast.is-long{white-space:normal;border-radius:14px;max-width:min(520px,calc(100vw - 32px));line-height:1.45}.bd-toast.is-long .bd-toast-text{overflow:visible}.bd-toast-act{flex:none;margin-left:4px;height:24px;padding:0 11px;border:0;border-radius:999px;background:#ffffff1c;color:#fff;font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast)}.bd-toast-act:hover{background:#fff3}.lib-new{position:absolute;top:3px;right:3px;width:7px;height:7px;border-radius:50%;pointer-events:none;background:var(--cv-accent-soft);box-shadow:0 0 0 2px #0e101af2,0 0 10px #9968dfbf}.up-side-btn.has-new{position:relative}.pl-head-act{flex:none;height:36px;border-radius:11px}.pl-chip .n{font-size:10px;color:var(--fg-4);font-variant-numeric:tabular-nums}.pl-tile-levels{position:absolute;top:10px;right:10px;z-index:5;display:inline-flex;align-items:center;gap:5px;height:22px;padding:0 8px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#ffffffd1}.pl-tile-words,.pl-cover-text{position:absolute;inset:0;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;padding:18px 18px 64px;box-sizing:border-box;background:radial-gradient(120% 90% at 0% 0%,rgba(153,104,223,.22),transparent 60%),radial-gradient(90% 80% at 100% 100%,rgba(90,97,237,.18),transparent 60%),#0d0f1a;color:#ffffffdb;font-size:15px;font-weight:500;line-height:1.45;letter-spacing:-.01em;-webkit-line-clamp:6}.pl-cover-text{position:relative;inset:auto;width:calc(100% - 28px);height:calc(100% - 28px);border-radius:12px;padding:28px;font-size:18px;-webkit-line-clamp:12}.pl-detail-by{margin:-10px 0 0;font-size:11.5px;color:var(--fg-4)}.pl-acts-own{margin-left:auto;display:inline-flex;gap:4px}.pl-icon-btn.is-lg{width:auto;min-width:38px;height:38px;padding:0 10px;gap:6px;border-radius:12px;font-family:var(--font-sans);font-size:12px;font-weight:600}.pl-icon-btn.is-danger:hover,.pl-icon-btn.is-danger.is-confirming{background:#ff5c7a24;color:var(--danger)}.pl-icon-btn.is-danger.is-confirming{box-shadow:inset 0 0 0 1px #ff5c7a66}.pl-edit{position:absolute;inset:0;z-index:3;display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:16px;padding:2px 16px 14px}@container (max-width: 600px){.pl-edit{grid-template-columns:minmax(0,1fr);grid-template-rows:minmax(140px,32%) minmax(0,1fr);gap:12px}}.pl-edit-form{min-height:0;display:flex;flex-direction:column;padding:4px 2px}.ps{flex:0 1 auto;min-height:0;display:flex;flex-direction:column;gap:16px}.ps-body{flex:0 1 auto;min-height:0;display:flex;flex-direction:column;gap:16px;overflow-y:auto;margin:0 -6px;padding:0 6px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.ps-body.is-more{-webkit-mask-image:linear-gradient(180deg,#000 calc(100% - 36px),transparent);mask-image:linear-gradient(180deg,#000 calc(100% - 36px),transparent)}.ps-head{display:flex;align-items:center;gap:11px}.ps-mark{flex:none;width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;border-radius:11px;background:var(--cv-accent-tint);color:var(--cv-accent-text);box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.ps-title{display:flex;flex-direction:column;gap:2px;min-width:0}.ps-title b{font-size:14.5px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.ps-title em{font-style:normal;font-size:11.5px;color:var(--fg-4)}.ps-field{display:flex;flex-direction:column;gap:8px;min-width:0}.ps-input{width:100%;box-sizing:border-box;height:38px;padding:0 12px;border:1px solid var(--hairline-soft);border-radius:11px;background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:13px;font-weight:500;outline:none;transition:border-color var(--dur-fast),background var(--dur-fast);user-select:text;-webkit-user-select:text}.ps-input:focus{border-color:var(--cv-accent-soft);background:#ffffff0f}.ps-input::placeholder{color:var(--fg-4)}.ps-input.is-chip{width:150px;height:28px;border-radius:999px;font-size:11.5px}.ps-text{height:auto;min-height:96px;padding:10px 12px;resize:vertical;line-height:1.55;font-size:12.5px}.ps-hint{font-size:11px;color:var(--fg-4)}.ps-hint.is-bad{color:var(--danger)}.ps-audience{display:flex;align-items:center;gap:7px;margin:0;font-size:12px;color:var(--fg-2)}.ps-audience .licon{color:var(--cv-accent-text)}.ps-levels{display:flex;flex-direction:column;gap:6px}.ps-level{display:flex;align-items:center;gap:11px;width:100%;padding:10px 12px;text-align:left;cursor:pointer;border:1px solid var(--hairline-soft);border-radius:12px;background:#ffffff06;color:var(--fg-2);font-family:var(--font-sans);transition:background var(--dur-fast),border-color var(--dur-fast)}.ps-level:hover{background:#ffffff0d}.ps-level.on{border-color:var(--cv-accent-soft);background:var(--cv-accent-tint)}.ps-level>.licon{flex:none;color:var(--fg-4)}.ps-level.on>.licon{color:var(--cv-accent-text)}.ps-level-text{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.ps-level-text b{font-size:12.5px;font-weight:600;color:var(--fg-1)}.ps-level-text em{font-style:normal;font-size:11px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ps-switch{position:relative;flex:none;width:30px;height:18px;border-radius:999px;background:#ffffff1f;transition:background var(--dur-fast)}.ps-switch:after{content:"";position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;background:#fff;box-shadow:0 1px 4px #02040c66;transition:transform var(--dur-med) var(--ease-out-soft)}.ps-level.on .ps-switch{background:var(--cv-accent)}.ps-level.on .ps-switch:after{transform:translate(12px)}.ps-level.is-off{cursor:default;opacity:.5}.ps-level.is-off:hover{background:#ffffff06}.ps-level.is-off:disabled{opacity:.62}.ps-level.is-off .ps-level-text em{white-space:normal}.ps-cats{display:flex;flex-wrap:wrap;align-items:center;gap:6px}.ps-check{display:flex;align-items:center;gap:9px;font-size:12px;color:var(--fg-2);cursor:pointer}.ps-check input{accent-color:var(--cv-accent);width:15px;height:15px;margin:0}.ps-thumbs{display:inline-flex;margin-left:4px}.ps-thumbs span{width:26px;height:26px;margin-left:-6px;border-radius:8px;background-size:cover;background-position:center;box-shadow:0 0 0 1.5px #0b0d15}.ps-thumbs span:first-child{margin-left:0}.ps-dup{display:flex;flex-wrap:wrap;align-items:center;gap:6px 8px;margin:0;padding:10px 12px;border-radius:11px;background:#a3a7f514;box-shadow:inset 0 0 0 1px #a3a7f533;color:var(--fg-2);font-size:12px}.ps-dup .licon{color:var(--vista-blue-500)}.ps-link{padding:0;border:0;background:none;color:var(--vista-blue-500);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;text-decoration:underline;text-underline-offset:3px}.ps-foot{flex:none;display:flex;gap:8px}.pl-cta:disabled{opacity:.45;cursor:default;box-shadow:none;transform:none}.v2-info-pair{display:grid;grid-template-columns:1fr 1fr;gap:8px}.v2-info-pair>:last-child:nth-child(odd){grid-column:1 / -1}.v2-info-card.is-form{flex:0 1 auto;min-height:0;padding:16px;overflow:hidden}.v2-info-card.is-form>.ps{animation:infoForm .32s var(--ease-out-soft) both}@keyframes infoForm{0%{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}@media(prefers-reduced-motion:reduce){.v2-info-card.is-form>.ps{animation:none}}', jCe = '.dp-wrap{position:relative;display:inline-flex}.dp-pop{position:absolute;z-index:60;bottom:calc(100% + 14px);width:480px;cursor:pointer}.dp-wrap.is-above .dp-pop{left:50%;transform:translate(-50%)}.dp-wrap.is-above-start .dp-pop{left:-8px}.dp-pop:after{content:"";position:absolute;left:0;right:0;top:100%;height:16px}.dp-card{overflow:hidden;border-radius:18px;border:1px solid rgba(255,255,255,.08);background:radial-gradient(120% 70% at 50% -18%,rgba(153,104,223,.1),transparent 62%),#0a0c14f9;backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:inset 0 1px #ffffff0d,0 2px 8px #02040c66,0 40px 110px #02040cad;transition:border-color var(--dur-fast)}.dp-pop:hover .dp-card{border-color:#c4a2ff57}.dp-media{position:relative;aspect-ratio:16 / 9;overflow:hidden;background:#07080d}.dp-media img,.dp-media video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;user-select:none;-webkit-user-select:none}.dp-tag{position:absolute;top:10px;left:10px;z-index:2;display:inline-flex;align-items:center;gap:5px;height:22px;padding:0 9px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);color:#fff;font-family:var(--font-sans);font-size:10.5px;font-weight:600;letter-spacing:.01em}.dp-body{padding:13px 16px 14px;font-family:var(--font-sans)}.dp-words b{display:block;font-size:14px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.dp-words span{display:block;margin-top:3px;min-height:2.9em;font-size:12px;line-height:1.45;color:var(--fg-3)}.dp-foot{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:11px}.dp-dots{display:inline-flex;align-items:center;gap:5px}.dp-dots button{width:16px;height:4px;padding:0;border:0;border-radius:999px;overflow:hidden;background:#ffffff24;cursor:pointer;transition:width var(--dur-med) var(--ease-out-soft),background var(--dur-fast)}.dp-dots button:hover{background:#ffffff3d}.dp-dots button.on{width:30px}.dp-dots button i{display:block;width:0;height:100%;border-radius:inherit;background:var(--cv-accent-soft)}.dp-dots button.on i{animation:dpFill var(--d, 3.4s) linear forwards}@keyframes dpFill{to{width:100%}}.dp-cta{display:inline-flex;align-items:center;gap:3px;font-size:11.5px;font-weight:600;color:var(--cv-accent-text);white-space:nowrap}.dp-pop-enter-active,.dp-pop-leave-active{transition:opacity .22s var(--ease-out-soft),translate .22s var(--ease-out-soft),scale .22s var(--ease-out-soft)}.dp-pop-enter-from,.dp-pop-leave-to{opacity:0;translate:0 8px;scale:.98}.dp-slide-enter-active,.dp-slide-leave-active{transition:opacity .45s ease}.dp-slide-enter-from,.dp-slide-leave-to{opacity:0}.dp-words-enter-active,.dp-words-leave-active{transition:opacity .18s ease,translate .18s ease}.dp-words-enter-from{opacity:0;translate:0 4px}.dp-words-leave-to{opacity:0}@media(prefers-reduced-motion:reduce){.dp-pop-enter-active,.dp-pop-leave-active,.dp-slide-enter-active,.dp-slide-leave-active,.dp-words-enter-active,.dp-words-leave-active{transition:none}.dp-dots button.on i{animation:none;width:100%}}', HCe = '.cv-feedback{position:relative;display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 10px;border:1px solid var(--hairline-soft);border-radius:999px;background:#ffffff08;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:500;white-space:nowrap;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.cv-feedback .licon{color:var(--fg-4);transition:color var(--dur-fast)}.cv-feedback:hover{background:#ffffff12;color:var(--fg-1)}.cv-feedback:hover .licon{color:var(--fg-2)}.cv-feedback-dot{position:absolute;top:-2px;right:-2px;width:7px;height:7px;border-radius:50%;background:var(--amethyst-700, #c2a4ec);box-shadow:0 0 0 2px #070910e6}.fb-flash{position:absolute;inset:0;z-index:130;pointer-events:none;background:#fff;opacity:0;animation:fbFlash .36s ease-out both}@keyframes fbFlash{0%{opacity:.38}to{opacity:0}}@media(prefers-reduced-motion:reduce){.fb-flash{animation:none}}.fb{position:absolute;inset:0;z-index:120;display:flex;align-items:center;justify-content:center;padding:24px;background:#04030c85;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);animation:ksFade .2s ease both}.fb-card{position:relative;width:min(1060px,100%);height:min(720px,100%);outline:none;display:flex;flex-direction:column;border-radius:24px;background:#0b0d15f5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 40px 120px #02040cb8;font-family:var(--font-sans);animation:ksIn .34s var(--ease-out-soft) both}.fb-card:before{content:"";position:absolute;left:32px;right:32px;top:-1px;height:1px;pointer-events:none;background:linear-gradient(90deg,transparent,rgba(199,80,206,.5),rgba(153,104,223,.7),rgba(90,97,237,.5),transparent)}.fb-head{flex:none;display:flex;align-items:center;gap:14px;padding:24px 30px 18px}.fb-mark{flex:none;width:38px;height:38px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;color:#fff;background:var(--grad-cta);box-shadow:inset 0 1px #ffffff38,0 10px 26px #745aff52}.fb-titles{flex:1;min-width:0}.fb-titles h2{margin:0;font-size:18px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.fb-titles p{margin:4px 0 0;font-size:12.5px;color:var(--fg-4)}.fb-close{margin-left:auto;align-self:flex-start;flex:none;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:10px;background:#ffffff0a;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.fb-close:hover{background:#ffffff17;color:var(--fg-1)}.fb-body{flex:1;min-height:0;display:grid;grid-template-columns:minmax(0,1fr) 344px;gap:24px;padding:0 30px}.fb-shots{min-width:0;min-height:0;display:flex;flex-direction:column;gap:12px}.fb-preview{position:relative;flex:1;min-height:0;display:flex;align-items:center;justify-content:center;overflow:hidden;border-radius:16px;border:1px solid var(--hairline-soft);background:var(--bg-deep)}.fb-preview img{display:block;max-width:100%;max-height:100%;object-fit:contain}.fb-preview-note{display:inline-flex;align-items:center;gap:8px;padding:0 24px;text-align:center;font-size:12.5px;color:var(--fg-4)}.fb-strip{flex:none;display:flex;align-items:center;gap:8px;overflow-x:auto;padding:2px 2px 4px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.fb-thumb{position:relative;flex:none;width:104px;height:64px;border-radius:10px}.fb-thumb-pick{width:100%;height:100%;padding:0;overflow:hidden;cursor:pointer;border:1.5px solid var(--hairline-soft);border-radius:10px;background:var(--bg-deep);transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.fb-thumb-pick img{display:block;width:100%;height:100%;object-fit:cover}.fb-thumb.on .fb-thumb-pick{border-color:var(--cv-accent);box-shadow:0 0 0 3px var(--cv-accent-tint)}.fb-thumb-n{position:absolute;left:5px;top:5px;min-width:18px;height:18px;padding:0 5px;pointer-events:none;display:inline-flex;align-items:center;justify-content:center;border-radius:6px;background:#04030cc7;color:var(--fg-1);font-size:10.5px;font-weight:600;font-variant-numeric:tabular-nums}.fb-thumb-x{position:absolute;right:4px;top:4px;width:20px;height:20px;padding:0;display:inline-flex;align-items:center;justify-content:center;opacity:0;border:0;border-radius:50%;background:#04030cd9;color:var(--fg-1);cursor:pointer;transition:opacity var(--dur-fast)}.fb-thumb:hover .fb-thumb-x,.fb-thumb:focus-within .fb-thumb-x{opacity:1}.fb-add{flex:none;width:128px;height:64px;padding:0 8px;display:inline-flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;border:1.5px dashed rgba(255,255,255,.18);border-radius:10px;background:transparent;color:var(--fg-3);font-size:11.5px;font-weight:600;cursor:pointer;transition:border-color var(--dur-fast),color var(--dur-fast),background var(--dur-fast)}.fb-add:hover:not(:disabled){border-color:var(--cv-accent-soft);color:var(--fg-1);background:#ffffff08}.fb-add:disabled{opacity:.45;cursor:default}.fb-tip{flex:none;margin:-4px 2px 0;font-size:11.5px;color:var(--fg-4)}.fb-card.is-dropping{border-color:var(--cv-accent-soft);box-shadow:var(--inset-highlight),0 0 0 3px var(--cv-accent-tint),0 40px 120px #02040cb8}.fb-drop{position:absolute;inset:0;pointer-events:none;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;border:1.5px dashed var(--cv-accent-soft);border-radius:inherit;background:#0b0d15db;color:var(--fg-1);font-size:13px;font-weight:600}.fb-form{min-width:0;min-height:0;overflow-y:auto;display:flex;flex-direction:column;gap:14px;margin:0 -6px;padding:0 6px 4px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.12) transparent}.fb-seg{flex:none;display:grid;grid-template-columns:repeat(3,1fr);gap:2px;padding:3px;border-radius:12px;background:#ffffff0a;border:1px solid var(--hairline-soft)}.fb-seg button{height:30px;display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:0;border:0;border-radius:9px;background:transparent;color:var(--fg-3);cursor:pointer;font-size:12px;font-weight:600;transition:background var(--dur-fast),color var(--dur-fast),box-shadow var(--dur-fast)}.fb-seg button:hover:not(.is-on){color:var(--fg-1);background:#ffffff0d}.fb-seg button.is-on{color:#fff;cursor:default;background:linear-gradient(180deg,#9968df75,#5a61ed57);box-shadow:inset 0 1px #ffffff29,0 6px 16px #745aff42}.fb-field{flex:none;display:flex;flex-direction:column;gap:8px;min-width:0}.fb-label{font-size:12px;font-weight:600;color:var(--fg-2)}.fb-text{width:100%;box-sizing:border-box;min-height:84px;padding:10px 12px;resize:vertical;border:1px solid var(--hairline-soft);border-radius:11px;background:#ffffff0a;color:var(--fg-1);font-family:var(--font-sans);font-size:13px;line-height:1.55;outline:none;transition:border-color var(--dur-fast),background var(--dur-fast);user-select:text;-webkit-user-select:text}.fb-text.is-short{min-height:58px}.fb-text:focus{border-color:var(--cv-accent-soft);background:#ffffff0f}.fb-text::placeholder{color:var(--fg-4)}.fb-inc-box{flex:none;padding:4px 12px 6px;border:1px solid var(--hairline-soft);border-radius:14px;background:#ffffff05}.fb-inc-h{padding:8px 0 6px;font-size:10px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-4)}.fb-inc{display:flex;align-items:flex-start;gap:10px;padding:7px 0;border-top:1px solid var(--hairline-soft)}.fb-inc-what{flex:1;min-width:0;display:flex;align-items:flex-start;gap:9px;font-size:12.5px;color:var(--fg-2);cursor:pointer}.fb-inc-what.is-fixed{cursor:default}.fb-inc-what input{flex:none;width:15px;height:15px;margin:1px 0 0;accent-color:var(--cv-accent)}.fb-inc-what .licon{flex:none;width:15px;color:var(--success)}.fb-inc-what small{display:block;margin-top:2px;font-size:11px;color:var(--fg-4)}.fb-steps-pick{flex:none;display:inline-flex;padding:2px;gap:2px;border-radius:8px;background:#ffffff0a;border:1px solid var(--hairline-soft)}.fb-steps-pick button{min-width:30px;height:22px;padding:0 7px;border:0;border-radius:6px;background:transparent;cursor:pointer;color:var(--fg-3);font-family:var(--font-sans);font-size:11px;font-weight:600;font-variant-numeric:tabular-nums}.fb-steps-pick button:hover:not(:disabled){color:var(--fg-1);background:#ffffff0f}.fb-steps-pick button.on{color:#fff;background:var(--cv-accent-tint);box-shadow:inset 0 0 0 1px var(--cv-accent-soft)}.fb-steps-pick button:disabled{opacity:.4;cursor:default}.fb-view{flex:none;padding:0;border:0;background:none;cursor:pointer;color:var(--vista-blue-500);font-family:var(--font-sans);font-size:11.5px;font-weight:600}.fb-view:hover{text-decoration:underline;text-underline-offset:3px}.fb-peek{margin:0 0 8px 24px;max-height:168px;overflow:auto;padding:8px 10px;border-radius:10px;border:1px solid var(--hairline-soft);background:var(--bg-deep);font:11px/1.55 ui-monospace,SF Mono,Menlo,monospace;color:var(--fg-3);white-space:pre-wrap;overflow-wrap:anywhere;user-select:text;-webkit-user-select:text}.fb-foot{flex:none;display:flex;align-items:center;gap:10px;padding:18px 30px 24px}.fb-note{margin-right:auto;font-size:11.5px;color:var(--fg-4)}.fb-error{max-width:420px;font-size:12px;color:#ff8aa0}.fb-keys{font-size:11px;color:var(--fg-5);font-variant-numeric:tabular-nums}.fb-foot .bd-btn:disabled{opacity:.45;cursor:default;transform:none;filter:none}.fb-confirm{margin-right:auto;display:inline-flex;align-items:center;gap:10px;font-size:12.5px;color:var(--fg-2)}@media(max-width:860px){.fb-card{height:100%}.fb-body{grid-template-columns:minmax(0,1fr);overflow-y:auto}.fb-preview{flex:none;height:240px}.fb-form{overflow:visible}}.fb-aside{position:absolute;left:50%;top:72px;z-index:150;transform:translate(-50%);display:inline-flex;align-items:center;gap:10px;max-width:min(640px,calc(100vw - 32px));padding:5px 5px 5px 6px;border-radius:999px;background:#11131ef5;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 18px 44px #02040c8c;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;font-weight:500;white-space:nowrap}.fb-aside-mark{flex:none;width:26px;height:26px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent-tint);color:var(--cv-accent-text)}.fb-aside-text{min-width:0;overflow:hidden;text-overflow:ellipsis}.fb-aside-count{flex:none;color:var(--fg-4);font-variant-numeric:tabular-nums}.fb-aside-btn{flex:none;height:26px;padding:0 12px;border:0;border-radius:999px;cursor:pointer;display:inline-flex;align-items:center;gap:6px;background:#ffffff14;color:var(--fg-1);font:inherit;font-weight:600;transition:background var(--dur-fast),filter var(--dur-fast)}.fb-aside-btn:hover:not(:disabled){background:#ffffff24}.fb-aside-btn.is-cta{background:var(--grad-cta)}.fb-aside-btn.is-cta:hover:not(:disabled){filter:brightness(1.08)}.fb-aside-btn:disabled{opacity:.5;cursor:default}.fb-aside-enter-active{transition:opacity .25s var(--ease-out-soft),transform .25s var(--ease-out-soft)}.fb-aside-leave-active{transition:opacity .18s ease,transform .18s ease}.fb-aside-enter-from,.fb-aside-leave-to{opacity:0;transform:translate(-50%) translateY(-6px)}', VCe = `.cv-root{--cm-unread: #d36be0;--cm-unread-glow: rgba(211, 107, 224, .45);--cm-card-bg: rgba(14, 16, 26, .97);--cm-raise: rgba(255, 255, 255, .05)}.cm-avatar{flex:none;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;color:#fff;font-weight:700;letter-spacing:.02em;line-height:1;box-shadow:inset 0 0 0 1px #ffffff2e,inset 0 1px #ffffff40;text-shadow:0 1px 2px rgba(10,6,30,.35);user-select:none}.cm-text{white-space:pre-wrap;word-wrap:break-word;overflow-wrap:anywhere}.cm-text.is-clamped{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.cm-text.is-big{font-size:30px;line-height:1.15;letter-spacing:.04em}.cm-mention{color:var(--amethyst-700);font-weight:600;border-radius:5px;padding:0 2px;margin:0 -1px;background:#9968df24}.cm-mention.is-me{color:#fff;background:linear-gradient(90deg,#c750ce6b,#9968df6b)}.cm-link{color:var(--vista-blue-500);text-decoration:underline;text-decoration-color:#a3a7f566;text-underline-offset:2px;word-break:break-all}.cm-link:hover{color:#fff;text-decoration-color:currentColor}.cv-stage.is-commenting,.cv-stage.is-commenting .cv-el,.cv-stage.is-commenting .cv-el *,.cv-stage.is-commenting .cv-frame-title{cursor:url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28'><path d='M3 25V14a10 10 0 1 1 10 10z' fill='%239968df' stroke='white' stroke-width='2' stroke-linejoin='round'/><path d='M13 9.5v8M9 13.5h8' stroke='white' stroke-width='2.2' stroke-linecap='round'/></svg>") 3 25,crosshair}.cm-pins{position:absolute;left:0;top:0;width:0;height:0;z-index:1000000;pointer-events:none}.cm-pin-at{position:absolute;width:0;height:0}.cm-pin-at.is-open,.cm-pin-at:hover{z-index:2}.cm-pin{position:absolute;left:0;bottom:0;width:36px;height:36px;padding:3px;margin:0;transform-origin:0 100%;transform:scale(var(--cv-inv-zoom));border:0;border-radius:18px 18px 18px 4px;background:var(--thread, var(--amethyst-500));box-shadow:0 0 0 1.5px #ffffffeb,0 8px 22px #02040e80,0 2px 5px #02040e59;cursor:pointer;pointer-events:auto;touch-action:none;transition:box-shadow var(--dur-fast),filter var(--dur-fast);animation:cmPinIn .42s cubic-bezier(.34,1.56,.64,1) both}@keyframes cmPinIn{0%{opacity:0;scale:.3}to{opacity:1;scale:1}}.cm-pin-face{width:30px;height:30px;border-radius:15px 15px 15px 2px;overflow:hidden;display:flex;align-items:center;justify-content:center;background:#0b0d14;transition:transform var(--dur-fast) var(--ease-out-soft)}.cm-pin-face .cm-avatar{width:30px!important;height:30px!important;border-radius:0;box-shadow:none;font-size:11px!important}.cm-pin:hover{filter:brightness(1.08);box-shadow:0 0 0 1.5px #fff,0 12px 28px #02040e8c,0 0 0 6px color-mix(in srgb,var(--thread) 26%,transparent)}.cm-pin:hover .cm-pin-face{transform:scale(1.04)}.cm-pin-at.is-open .cm-pin{box-shadow:0 0 0 2px #fff,0 0 0 7px color-mix(in srgb,var(--thread) 38%,transparent),0 12px 30px #02040e99}.cm-pin-at.is-dragging .cm-pin{cursor:grabbing;filter:brightness(1.1);box-shadow:0 0 0 2px #fff,0 20px 40px #02040e99;animation:none}.cm-pin-at.is-resolved .cm-pin{opacity:.86}.cm-pin-check{display:flex;align-items:center;justify-content:center;width:100%;height:100%;color:#fff;background:var(--thread)}.cm-pin-count{position:absolute;right:-9px;bottom:-5px;min-width:18px;height:18px;padding:0 5px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:#0b0d14;color:#fff;font-size:10px;font-weight:700;font-variant-numeric:tabular-nums;line-height:1;box-shadow:0 0 0 1.5px var(--thread),0 3px 8px #0006}.cm-pin-dot{position:absolute;right:-3px;top:-3px;width:12px;height:12px;border-radius:50%;background:var(--cm-unread);box-shadow:0 0 0 2px #fff,0 0 12px var(--cm-unread-glow)}.cm-pin-dot:after{content:"";position:absolute;inset:-2px;border-radius:50%;border:2px solid var(--cm-unread);animation:cmPulse 1.8s var(--ease-out-soft) infinite}@keyframes cmPulse{0%{opacity:.85;transform:scale(1)}to{opacity:0;transform:scale(2.4)}}.cm-pin.is-flash{animation:cmPinFlash .9s cubic-bezier(.34,1.56,.64,1) both}@keyframes cmPinFlash{0%{scale:1;rotate:0deg}30%{scale:1.28;rotate:-4deg}60%{scale:.94;rotate:2deg}to{scale:1;rotate:0deg}}.cm-pin.is-flash:before{content:"";position:absolute;inset:-4px;border-radius:inherit;border:2px solid var(--thread);animation:cmRipple .9s var(--ease-out-soft) both;pointer-events:none}@keyframes cmRipple{0%{opacity:.9;transform:scale(1)}to{opacity:0;transform:scale(2)}}.cm-pin.is-draft{cursor:default;pointer-events:none;background:transparent;padding:1px;border:2px dashed rgba(255,255,255,.85);box-shadow:0 8px 22px #02040e80;animation:cmPinIn .42s cubic-bezier(.34,1.56,.64,1) both,cmDraft 1.6s ease-in-out .42s infinite}.cm-pin.is-draft .cm-pin-face{width:30px;height:30px}@keyframes cmDraft{50%{box-shadow:0 0 0 6px #9968df47,0 8px 22px #02040e80}}.cm-peek{position:absolute;left:0;bottom:0;width:260px;padding:11px 13px 12px;transform-origin:0 100%;transform:scale(var(--cv-inv-zoom)) translate(46px,6px);border-radius:14px;background:var(--cm-card-bg);border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 20px 50px #02040e99;color:var(--fg-2);font-size:12.5px;line-height:1.45;pointer-events:none;animation:cmPeekIn var(--dur-fast) var(--ease-out-soft) both}@keyframes cmPeekIn{0%{opacity:0;margin-left:-6px}to{opacity:1;margin-left:0}}.cm-peek-head{display:flex;align-items:baseline;gap:8px;margin-bottom:4px}.cm-peek-head b{color:var(--fg-1);font-size:12.5px;font-weight:600}.cm-peek-head span{font-size:11px;color:var(--fg-4)}.cm-peek-foot{margin-top:7px;font-size:11px;color:var(--fg-4)}.cm-peek-foot em{font-style:normal;color:var(--cm-unread);font-weight:600}.cm-cards{position:absolute;inset:0;z-index:44;pointer-events:none;overflow:hidden}.cm-card{position:absolute;left:0;top:0;width:344px;max-height:calc(100vh - 140px);display:flex;flex-direction:column;pointer-events:auto;border-radius:18px;background:var(--cm-card-bg);border:1px solid var(--hairline);backdrop-filter:blur(28px) saturate(120%);-webkit-backdrop-filter:blur(28px) saturate(120%);box-shadow:var(--inset-highlight),0 0 0 1px #00000040,0 30px 80px #02040e9e;color:var(--fg-2);font-size:13px;user-select:text;-webkit-user-select:text;animation:cmCardIn .28s var(--ease-out-soft) both}.cm-card:before{content:"";position:absolute;left:16px;right:16px;top:-1px;height:2px;border-radius:0 0 2px 2px;background:linear-gradient(90deg,transparent,var(--thread),transparent);opacity:.85;pointer-events:none}@keyframes cmCardIn{0%{opacity:0;scale:.96}to{opacity:1;scale:1}}.cm-card.is-away{visibility:hidden}.cm-card.is-pinned{box-shadow:var(--inset-highlight),0 0 0 1px color-mix(in srgb,var(--thread) 40%,transparent),0 24px 60px #02040e80}.cm-card-head{flex:none;display:flex;align-items:center;gap:4px;padding:9px 9px 7px 12px}.cm-grow{flex:1}.cm-icon{flex:none;position:relative;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.cm-icon:hover{background:#ffffff14;color:var(--fg-1)}.cm-icon.on{color:var(--amethyst-700)}.cm-nav{flex:none;display:inline-flex;align-items:center;gap:0;margin:-2px -4px -2px 0;padding:0 2px;border-radius:9px;background:#ffffff0a}.cm-nav .cm-icon{width:22px;height:22px}.cm-nav-n{min-width:40px;text-align:center;font-size:11px;font-weight:600;color:var(--fg-3);font-variant-numeric:tabular-nums;white-space:nowrap}.cm-dots{display:inline-flex;align-items:center;gap:3px}.cm-dot{width:18px;height:18px;padding:0;border:0;border-radius:50%;background:transparent;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;position:relative}.cm-dot:after{content:"";width:10px;height:10px;border-radius:50%;background:var(--c);transition:transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.cm-dot:hover:after{transform:scale(1.25)}.cm-dot.on:after{box-shadow:0 0 0 2px var(--cm-card-bg),0 0 0 3.5px var(--c)}.cm-resolve{flex:none;display:inline-flex;align-items:center;gap:6px;height:28px;padding:0 10px 0 8px;border:1px solid var(--hairline);border-radius:999px;background:#ffffff0a;color:var(--fg-2);font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.cm-resolve:hover{background:#37d3991f;border-color:#37d39966;color:#fff}.cm-resolve:hover .licon{color:var(--success)}.cm-resolve.on{background:#37d39929;border-color:#37d39973;color:#c9f5e4}.cm-resolve.on .licon{color:var(--success);animation:cmTick .5s cubic-bezier(.34,1.56,.64,1)}@keyframes cmTick{0%{transform:scale(.4) rotate(-30deg)}to{transform:none}}.cm-card-menu-wrap{position:relative;display:inline-flex}.cm-card-menu{position:absolute;right:-4px;top:calc(100% + 6px);z-index:5;min-width:220px;display:flex;flex-direction:column;padding:5px;border:1px solid var(--hairline);border-radius:13px;background:#131521fa;box-shadow:var(--inset-highlight),0 20px 50px #02040e99;animation:cvMenuIn var(--dur-fast) var(--ease-out-soft) both}.cm-card-menu>button{display:flex;align-items:center;flex-wrap:wrap;column-gap:10px;width:100%;padding:8px 10px;text-align:left;border:0;border-radius:8px;background:transparent;color:var(--fg-1);cursor:pointer;font-family:var(--font-sans);font-size:12.5px;font-weight:500;white-space:nowrap}.cm-card-menu>button small{flex-basis:100%;padding-left:24px;font-size:11px;color:var(--fg-4);font-weight:400}.cm-card-menu>button .licon{color:var(--fg-3)}.cm-card-menu>button:hover:not(:disabled){background:#ffffff12}.cm-card-menu>button:hover .licon{color:var(--fg-1)}.cm-card-menu>button:disabled{opacity:.4;cursor:default}.cm-card-menu>button.is-danger{color:#ff9eb0}.cm-card-menu>button.is-danger .licon{color:#ff7f98}.cm-card-menu>button.is-danger:hover{background:#ff5c7a1f}.cm-card-menu-sep{height:1px;margin:4px 6px;background:var(--hairline-soft)}.cm-card-menu kbd{margin-left:6px;padding:1px 5px;border-radius:5px;border:1px solid var(--hairline);font-family:var(--font-sans);font-size:10.5px;color:var(--fg-4)}.cm-switch{position:relative;margin-left:auto;width:28px;height:16px;border-radius:999px;background:#ffffff24;transition:background var(--dur-fast)}.cm-switch:after{content:"";position:absolute;left:2px;top:2px;width:12px;height:12px;border-radius:50%;background:#fff;box-shadow:0 1px 4px #0006;transition:transform var(--dur-fast) var(--ease-out-soft)}.cm-switch.on{background:var(--cv-accent)}.cm-switch.on:after{transform:translate(12px)}.cm-strip{flex:none;display:flex;align-items:center;gap:8px;min-height:22px;padding:0 14px 8px}.cm-on{min-width:0;display:inline-flex;align-items:center;gap:5px;max-width:100%;height:20px;padding:0 8px 0 6px;border-radius:6px;background:#ffffff0d;color:var(--fg-3);font-size:11px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-on.is-inline{flex:0 1 auto;margin-left:2px}.cm-resolved-note{display:inline-flex;align-items:center;gap:4px;font-size:11px;font-weight:600;color:var(--success)}.cm-list{flex:1 1 auto;min-height:0;max-height:380px;overflow-y:auto;padding:2px 6px 4px;border-top:1px solid var(--hairline-soft);scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.cm-reply{flex:none;padding:8px 10px 10px;border-top:1px solid var(--hairline-soft)}.cm-card.is-resolved .cm-list{opacity:.8}.cm-draft-head{display:flex;align-items:center;gap:9px;padding:10px 9px 8px 12px}.cm-draft-title{font-size:13px;font-weight:600;color:var(--fg-1);white-space:nowrap}.cm-card.is-draft{width:336px}.cm-card.is-draft .cm-compose{margin:0 10px 10px}.cm-row{position:relative;display:flex;gap:10px;padding:10px 8px;border-radius:12px;animation:cmRowIn .32s var(--ease-out-soft) both;transition:background var(--dur-fast)}@keyframes cmRowIn{0%{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}.cm-row:hover{background:#ffffff09}.cm-row-main{flex:1;min-width:0}.cm-row-head{display:flex;align-items:baseline;gap:7px;margin-bottom:3px;padding-right:64px}.cm-row.is-editing .cm-row-head{padding-right:0}.cm-row-name{color:var(--fg-1);font-size:12.5px;font-weight:600;letter-spacing:-.005em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-row-time{flex:none;font-size:11px;color:var(--fg-4);white-space:nowrap}.cm-row-edited{flex:none;font-size:10.5px;color:var(--fg-5);font-style:italic}.cm-row-text{display:block;color:#ffffffdb;font-size:13px;line-height:1.5}.cm-row-acts{position:absolute;right:6px;top:6px;display:flex;gap:1px;padding:2px;border-radius:9px;background:#181b29fa;border:1px solid var(--hairline);box-shadow:0 6px 16px #0006;opacity:0;transform:translateY(2px);pointer-events:none;transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cm-row:hover .cm-row-acts,.cm-row:focus-within .cm-row-acts{opacity:1;transform:none;pointer-events:auto}.cm-row-acts button{width:26px;height:24px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-3);cursor:pointer}.cm-row-acts button:hover{background:#ffffff17;color:var(--fg-1)}.cm-reactions{display:flex;flex-wrap:wrap;gap:5px;margin-top:7px}.cm-chip{display:inline-flex;align-items:center;gap:5px;height:24px;padding:0 8px 0 6px;border:1px solid var(--hairline);border-radius:999px;background:#ffffff0a;color:var(--fg-2);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.cm-chip .e{font-size:14px;line-height:1}.cm-chip .n{font-variant-numeric:tabular-nums}.cm-chip:hover{background:#ffffff14;border-color:#ffffff2e;transform:translateY(-1px)}.cm-chip:active{transform:scale(.94)}.cm-chip.mine{background:#9968df33;border-color:#ae86e599;color:#fff}.cm-chip.is-add{padding:0 7px;color:var(--fg-4);opacity:0}.cm-row:hover .cm-chip.is-add{opacity:1}.cm-compose{position:relative;display:flex;align-items:flex-end;gap:6px;padding:6px 6px 6px 12px;border:1px solid var(--hairline);border-radius:14px;background:#ffffff0b;transition:border-color var(--dur-fast),background var(--dur-fast),box-shadow var(--dur-fast)}.cm-compose:focus-within{border-color:var(--cv-accent-soft);background:#ffffff0f;box-shadow:0 0 0 3px #9968df1f}.cm-compose.is-nod{animation:cmNod .42s cubic-bezier(.36,.07,.19,.97) both}@keyframes cmNod{20%,60%{transform:translate(-5px)}40%,80%{transform:translate(5px)}}.cm-compose-box{flex:1;min-width:0;min-height:22px;max-height:168px;padding:4px 0;resize:none;overflow-y:auto;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:13px;line-height:1.45;user-select:text;-webkit-user-select:text}.cm-compose-box::placeholder{color:var(--fg-4)}.cm-compose-tools{flex:none;display:flex;align-items:center;gap:2px}.cm-tool{width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.cm-tool:hover,.cm-tool.on{background:#ffffff14;color:var(--fg-1)}.cm-send{width:28px;height:28px;padding:0;margin-left:2px;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:9px;background:#ffffff14;color:var(--fg-4);cursor:default;transition:background var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft),box-shadow var(--dur-fast)}.cm-compose.can-send .cm-send{background:var(--grad-cta);color:#fff;cursor:pointer;box-shadow:0 6px 16px #785ae673}.cm-compose.can-send .cm-send:hover{transform:translateY(-1px)}.cm-compose.can-send .cm-send:active{transform:scale(.92)}.cm-compose.is-editing{flex-direction:column;align-items:stretch;padding:6px 6px 6px 10px;margin-top:2px}.cm-compose.is-editing .cm-compose-tools{justify-content:flex-end;gap:6px}.cm-btn{display:inline-flex;align-items:center;justify-content:center;gap:6px;height:32px;padding:0 14px;border:0;border-radius:999px;background:var(--grad-cta);color:#fff;cursor:pointer;font-family:var(--font-sans);font-size:12.5px;font-weight:600;box-shadow:0 8px 20px #785ae659;transition:transform var(--dur-fast) var(--ease-out-soft),opacity var(--dur-fast)}.cm-btn:hover{transform:translateY(-1px)}.cm-btn:disabled{opacity:.4;cursor:default;transform:none}.cm-btn.is-sm{height:26px;padding:0 12px;font-size:12px}.cm-btn.is-ghost{background:#ffffff0f;color:var(--fg-2);box-shadow:none;border:1px solid var(--hairline)}.cm-btn.is-ghost:hover{background:#ffffff1a;color:#fff}.cm-portal{position:absolute;inset:0;z-index:140;pointer-events:none}.cm-portal>*{pointer-events:auto}.cm-menu{position:absolute;left:-1px;right:-1px;top:calc(100% + 6px);z-index:10;min-width:260px;max-height:300px;overflow-y:auto;padding:5px;border:1px solid var(--hairline);border-radius:13px;background:#131521fa;box-shadow:var(--inset-highlight),0 24px 60px #02040ea6;backdrop-filter:blur(24px);-webkit-backdrop-filter:blur(24px);animation:cvMenuIn var(--dur-fast) var(--ease-out-soft) both}.cm-menu.is-up{top:auto;bottom:calc(100% + 6px)}.cm-menu-row{display:flex;align-items:center;gap:10px;width:100%;padding:6px 8px;text-align:left;border:0;border-radius:9px;background:transparent;color:var(--fg-1);cursor:pointer;font-family:var(--font-sans)}.cm-menu-row.on{background:#9968df2e}.cm-menu-text{min-width:0;display:flex;flex-direction:column;gap:1px}.cm-menu-text b{font-size:12.5px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-menu-text b i{font-style:normal;font-weight:500;color:var(--fg-4)}.cm-menu-text small{font-size:11px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-menu-group{width:24px;height:24px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#ffffff14;color:var(--fg-2);flex:none}.cm-menu-emoji{width:24px;text-align:center;font-size:18px;line-height:1;flex:none}.cm-menu-alone{padding:10px;font-size:12px;line-height:1.45;color:var(--fg-3);max-width:300px}.cm-emoji{position:absolute;width:340px;height:392px;display:flex;flex-direction:column;border:1px solid var(--hairline);border-radius:16px;background:#11131efb;box-shadow:var(--inset-highlight),0 30px 80px #02040eb3;backdrop-filter:blur(28px);-webkit-backdrop-filter:blur(28px);animation:cmCardIn .22s var(--ease-out-soft) both;overflow:hidden;user-select:none}.cm-emoji-head{flex:none;display:flex;align-items:center;gap:6px;padding:10px 10px 6px}.cm-emoji-search{flex:1;min-width:0;display:flex;align-items:center;gap:7px;height:32px;padding:0 8px 0 10px;border:1px solid var(--hairline);border-radius:10px;background:#ffffff0d;color:var(--fg-4)}.cm-emoji-search:focus-within{border-color:var(--cv-accent-soft);color:var(--fg-2)}.cm-emoji-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;user-select:text;-webkit-user-select:text}.cm-emoji-search input::placeholder{color:var(--fg-4)}.cm-emoji-clear{width:20px;height:20px;padding:0;border:0;border-radius:6px;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center}.cm-emoji-clear:hover{color:var(--fg-1);background:#ffffff14}.cm-emoji-tone{flex:none;display:flex;gap:1px;padding:2px;border-radius:10px}.cm-emoji-tone.open{background:#ffffff0d}.cm-emoji-tonebtn{width:28px;height:28px;padding:0;border:0;border-radius:8px;background:transparent;font-size:17px;line-height:1;cursor:pointer}.cm-emoji-tonebtn:hover,.cm-emoji-tonebtn.on{background:#ffffff1a}.cm-emoji-quick{flex:none;display:flex;justify-content:space-between;padding:2px 10px 6px}.cm-emo{width:36px;height:36px;padding:0;border:0;border-radius:9px;background:transparent;cursor:pointer;font-size:22px;line-height:1;font-family:"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif;transition:background var(--dur-fast),transform .12s var(--ease-out-soft)}.cm-emo:hover{background:#ffffff1a;transform:scale(1.14)}.cm-emo:active{transform:scale(.9)}.cm-emo.is-quick{width:36px;height:36px;font-size:22px;background:#ffffff0a}.cm-emoji-tabs{flex:none;display:flex;justify-content:space-between;padding:0 8px 4px;border-bottom:1px solid var(--hairline-soft)}.cm-emoji-tabs button{position:relative;width:32px;height:30px;padding:0;border:0;border-radius:8px;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;transition:color var(--dur-fast),background var(--dur-fast)}.cm-emoji-tabs button:hover{color:var(--fg-1);background:#ffffff0f}.cm-emoji-tabs button.on{color:#fff}.cm-emoji-tabs button.on:after{content:"";position:absolute;left:8px;right:8px;bottom:-5px;height:2px;border-radius:2px;background:var(--grad-purple-pink)}.cm-emoji-body{flex:1;min-height:0;overflow-y:auto;padding:4px 8px 6px;scroll-behavior:auto;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.cm-emoji-sec{content-visibility:auto;contain-intrinsic-size:auto 360px}.cm-emoji-label{position:sticky;top:-4px;z-index:1;display:flex;align-items:center;justify-content:space-between;padding:8px 4px 4px;background:#11131efb;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4)}.cm-emoji-clearrecent{border:0;background:transparent;color:var(--fg-4);font-family:var(--font-sans);font-size:10.5px;font-weight:600;letter-spacing:0;text-transform:none;cursor:pointer;padding:0 2px}.cm-emoji-clearrecent:hover{color:var(--fg-1)}.cm-emoji-grid{display:grid;grid-template-columns:repeat(8,36px);justify-content:space-between;row-gap:1px}.cm-emoji-none{padding:40px 12px;text-align:center;font-size:12.5px;color:var(--fg-4)}.cm-emoji-foot{flex:none;display:flex;align-items:center;gap:9px;height:44px;padding:0 12px;border-top:1px solid var(--hairline-soft);background:#ffffff05}.cm-emoji-big{font-size:24px;line-height:1}.cm-emoji-name{flex:1;min-width:0;font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-emoji-name:first-letter{text-transform:uppercase}.cm-emoji-code{flex:none;font-size:11px;color:var(--fg-4)}.cm-emoji-hint{font-size:11.5px;color:var(--fg-4)}.cm-panel{position:absolute;z-index:46;top:66px;right:68px;bottom:14px;width:340px;display:flex;flex-direction:column;border-radius:18px;background:#0b0d15f7;border:1px solid var(--hairline);backdrop-filter:blur(30px) saturate(115%);-webkit-backdrop-filter:blur(30px) saturate(115%);box-shadow:var(--inset-highlight),0 28px 80px #02040c99;animation:histIn .26s var(--ease-out-soft) both;user-select:none}.cm-panel-head{flex:none;display:flex;align-items:center;gap:2px;padding:12px 10px 6px 16px}.cm-panel-title{font-size:14.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em}.cm-panel-settings-wrap{position:relative;display:inline-flex}.cm-card-menu.is-settings{width:268px}.cm-card-menu.is-settings>button{flex-wrap:nowrap}.cm-tabs{flex:none;display:grid;grid-template-columns:1fr 1fr;gap:2px;margin:4px 12px 8px;padding:3px;border-radius:11px;background:#ffffff0b;border:1px solid var(--hairline-soft)}.cm-tabs button{display:inline-flex;align-items:center;justify-content:center;gap:6px;height:30px;padding:0 8px;border:0;border-radius:8px;background:transparent;color:var(--fg-3);cursor:pointer;font-family:var(--font-sans);font-size:12px;font-weight:600;white-space:nowrap;transition:background var(--dur-fast),color var(--dur-fast)}.cm-tabs button:hover{color:var(--fg-1)}.cm-tabs button.on{background:#ffffff17;color:#fff;box-shadow:var(--inset-highlight),0 2px 8px #00000040}.cm-count{min-width:17px;height:17px;padding:0 5px;border-radius:999px;display:inline-flex;align-items:center;justify-content:center;background:var(--cm-unread);color:#fff;font-size:10px;font-weight:700;font-variant-numeric:tabular-nums;box-shadow:0 0 10px var(--cm-unread-glow)}.cm-tools{flex:none;display:flex;flex-direction:column;gap:8px;padding:0 12px 10px;border-bottom:1px solid var(--hairline-soft)}.cm-tools.is-elsewhere{flex-direction:row;align-items:center}.cm-search{display:flex;align-items:center;gap:7px;height:32px;padding:0 8px 0 10px;border:1px solid var(--hairline);border-radius:10px;background:#ffffff0a;color:var(--fg-4);transition:border-color var(--dur-fast)}.cm-search:focus-within{border-color:var(--cv-accent-soft);color:var(--fg-2)}.cm-search input{flex:1;min-width:0;border:0;outline:none;background:transparent;color:var(--fg-1);font-family:var(--font-sans);font-size:12.5px;user-select:text;-webkit-user-select:text}.cm-search input::placeholder{color:var(--fg-4)}.cm-search-clear{width:20px;height:20px;padding:0;border:0;border-radius:6px;background:transparent;color:var(--fg-4);cursor:pointer;display:inline-flex;align-items:center;justify-content:center}.cm-search-clear:hover{color:var(--fg-1);background:#ffffff14}.cm-chips{display:flex;gap:5px;flex-wrap:wrap}.cm-fchip{display:inline-flex;align-items:center;gap:5px;height:26px;padding:0 10px;border:1px solid var(--hairline);border-radius:999px;background:transparent;color:var(--fg-3);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.cm-fchip:hover{color:var(--fg-1);border-color:#fff3}.cm-fchip.on{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff}.cm-fchip .n{font-size:10px;color:var(--cm-unread);font-variant-numeric:tabular-nums}.cm-fchip.on .n{color:#f3c8f7}.cm-linkbtn{border:0;background:transparent;padding:0;color:var(--amethyst-700);font-family:var(--font-sans);font-size:11.5px;font-weight:600;cursor:pointer;white-space:nowrap}.cm-linkbtn:hover:not(:disabled){color:#fff}.cm-linkbtn:disabled{color:var(--fg-5);cursor:default}.cm-linkbtn.is-sm{font-size:11px}.cm-feed{flex:1;min-height:0;overflow-y:auto;padding:8px 8px 12px;scrollbar-width:thin;scrollbar-color:rgba(255,255,255,.14) transparent}.cm-feed-label{display:flex;align-items:center;gap:6px;padding:6px 8px;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4)}.cm-feed-empty{display:flex;flex-direction:column;align-items:center;gap:8px;padding:46px 22px;text-align:center;font-size:12.5px;line-height:1.5;color:var(--fg-4)}.cm-feed-empty b{font-size:13.5px;color:var(--fg-1);font-weight:600}.cm-feed-empty kbd{padding:1px 6px;border-radius:5px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-2);font-family:var(--font-sans);font-size:11px}.cm-feed-empty .cm-btn{margin-top:8px}.cm-empty-mark{width:42px;height:42px;border-radius:14px;display:inline-flex;align-items:center;justify-content:center;margin-bottom:4px;background:linear-gradient(140deg,#9968df47,#5a61ed33);color:#fff;box-shadow:inset 0 0 0 1px #ffffff1f,0 10px 30px #785ae640}.cm-empty-mark.is-error{background:#ff5c7a24;color:#ff9eb0}.cm-item{position:relative;display:flex;gap:10px;padding:11px 10px 11px 14px;margin-bottom:4px;border-radius:13px;border:1px solid transparent;cursor:pointer;outline:none;transition:background var(--dur-fast),border-color var(--dur-fast)}.cm-item:before{content:"";position:absolute;left:4px;top:14px;bottom:14px;width:3px;border-radius:3px;background:var(--thread);opacity:.55}.cm-item:hover,.cm-item:focus-visible{background:#ffffff0d;border-color:var(--hairline-soft)}.cm-item.is-open{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft)}.cm-item.is-unread{background:#d36be00f}.cm-item.is-unread:hover{background:#d36be01a}.cm-item.is-resolved{opacity:.62}.cm-item.is-resolved:hover{opacity:.9}.cm-item-dot{position:absolute;left:-1px;top:18px;width:8px;height:8px;border-radius:50%;z-index:1;background:var(--cm-unread);box-shadow:0 0 0 2px #0b0d15f7,0 0 10px var(--cm-unread-glow)}.cm-item-main{flex:1;min-width:0}.cm-item-head{display:flex;align-items:baseline;gap:8px;margin-bottom:3px}.cm-item-head b{min-width:0;color:var(--fg-1);font-size:12.5px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-item-time{margin-left:auto;flex:none;font-size:11px;color:var(--fg-4);white-space:nowrap;transition:opacity var(--dur-fast)}.cm-item-text{color:var(--fg-2);font-size:12.5px;line-height:1.45}.cm-item.is-unread .cm-item-text{color:#ffffffe6}.cm-item-on{display:flex;align-items:center;gap:6px;margin-top:7px;min-width:0}.cm-item-thumb{flex:none;width:22px;height:22px;border-radius:6px;background-size:cover;background-position:center;background-repeat:no-repeat;box-shadow:inset 0 0 0 1px #ffffff1f}.cm-item-on-label{min-width:0;font-size:11px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-item-foot{display:flex;align-items:center;gap:10px;margin-top:7px;font-size:11px;color:var(--fg-4)}.cm-item-foot>span{display:inline-flex;align-items:center;gap:4px}.cm-replies{display:flex;flex-direction:column;align-items:stretch;gap:8px;margin-top:9px;padding-left:11px;border-left:2px solid rgba(255,255,255,.08)}.cm-replies.is-all{gap:9px}.cm-replies-more{align-self:flex-start;padding:0;border:0;background:transparent;cursor:pointer;color:var(--amethyst-700);font-family:var(--font-sans);font-size:11.5px;font-weight:600;transition:color var(--dur-fast)}.cm-replies-more:hover{color:#fff}.cm-replies-more.is-new{color:var(--cm-unread)}.cm-replies-failed{font-size:11.5px;color:var(--fg-4)}.cm-reply-row{position:relative;display:flex;gap:8px}.cm-reply-row.is-new:before{content:"";position:absolute;left:-16px;top:7px;width:6px;height:6px;border-radius:50%;background:var(--cm-unread);box-shadow:0 0 0 2px #0b0d15f7,0 0 8px var(--cm-unread-glow)}.cm-reply-main{flex:1;min-width:0}.cm-reply-head{display:flex;align-items:baseline;gap:6px;margin-bottom:1px;min-width:0}.cm-reply-head b{min-width:0;font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-reply-head span{flex:none;font-size:10.5px;color:var(--fg-4)}.cm-reply-head i{flex:none;font-style:normal;font-size:9.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--cm-unread)}.cm-reply-text{display:block;font-size:12px;line-height:1.45;color:var(--fg-2)}.cm-item.is-unread .cm-reply-row.is-new .cm-reply-text{color:#ffffffe0}.cm-item-resolved{color:var(--success);font-weight:600}.cm-item-open{margin-left:auto;color:var(--fg-4);opacity:0;transition:opacity var(--dur-fast)}.cm-item:hover .cm-item-open{opacity:1;color:var(--amethyst-700)}.cm-item-acts{position:absolute;right:8px;top:5px;display:flex;gap:1px;padding:2px;border-radius:9px;background:#181b29fa;border:1px solid var(--hairline);box-shadow:0 6px 16px #0006;opacity:0;pointer-events:none;transition:opacity var(--dur-fast)}.cm-item:hover .cm-item-acts,.cm-item:focus-within .cm-item-acts{opacity:1;pointer-events:auto}.cm-item:hover .cm-item-time{opacity:0}.cm-item-acts>button,.cm-item-menu-wrap>button{width:26px;height:22px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:7px;background:transparent;color:var(--fg-3);cursor:pointer}.cm-item-acts>button:hover,.cm-item-acts>button.on,.cm-item-menu-wrap>button:hover,.cm-item-menu-wrap>button.on{background:#ffffff17;color:var(--fg-1)}.cm-item-acts>button.is-resolve.on .licon{color:var(--success)}.cm-item-menu-wrap{position:relative;display:inline-flex}.cm-card-menu.is-item{right:-6px;min-width:200px}.cm-card-menu.is-item.is-up{top:auto;bottom:calc(100% + 6px)}.cm-board-group{margin-bottom:10px}.cm-board-head{display:flex;align-items:center;gap:7px;padding:8px 8px 6px;color:var(--fg-3)}.cm-board-title{min-width:0;font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cm-board-n{flex:none;padding:1px 6px;border-radius:999px;background:#ffffff0f;font-size:10px;font-weight:600;color:var(--fg-3)}.bd-siderail-btn .badge.is-unread{background:var(--cm-unread);box-shadow:0 0 0 2px #121521f2,0 0 12px var(--cm-unread-glow)}.cm-rail-dot{position:absolute;right:6px;top:6px;width:8px;height:8px;border-radius:50%;background:var(--cm-unread);box-shadow:0 0 0 2px #121521f2;pointer-events:none}.v2-root.light-canvas .cm-pin{box-shadow:0 0 0 1.5px #fff,0 8px 22px #13182840,0 2px 5px #13182833}@media(prefers-reduced-motion:reduce){.cm-pin,.cm-card,.cm-row,.cm-peek,.cm-emoji,.cm-pin-dot:after{animation:none!important}}.cm-ask{position:absolute;inset:0;z-index:150;display:flex;align-items:center;justify-content:center;background:#04030c6b}.cm-ask-card{display:flex;align-items:center;gap:14px;width:min(560px,calc(100% - 40px));padding:14px 14px 14px 16px;border-radius:16px;background:#10111cfa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 30px 80px #02040cb3}.cm-ask-card .ic{flex:none;width:34px;height:34px;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;background:#ff5c7a24;color:#ff8aa0}.cm-ask-card .tx{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.cm-ask-card .tx b{font-size:13.5px;font-weight:600;color:#fff}.cm-ask-card .tx span{font-size:11.5px;line-height:1.45;color:var(--fg-3)}.cm-ask-card .acts{flex:none;display:flex;gap:8px}.cm-ask-btn{height:34px;padding:0 14px;border-radius:10px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-1);font:inherit;font-size:12.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast)}.cm-ask-btn:hover{background:#ffffff17}.cm-ask-btn:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:2px}.cm-ask-btn.is-danger{border-color:#ff5c7a80;background:#ff5c7a29;color:#ffb3c1}.cm-ask-btn.is-danger:hover{background:#ff5c7a42;color:#fff}.cm-ask-enter-active,.cm-ask-leave-active{transition:opacity .2s ease}.cm-ask-enter-active .cm-ask-card,.cm-ask-leave-active .cm-ask-card{transition:transform .3s var(--ease-out-soft),opacity .2s ease}.cm-ask-enter-from,.cm-ask-leave-to{opacity:0}.cm-ask-enter-from .cm-ask-card{transform:translateY(10px) scale(.98)}`, WCe = '.cv-el.is-chat .cv-el-body{height:100%}.cv-el.is-chat .cv-bucket{height:100%;display:flex;flex-direction:column}.cv-el.is-chat .cv-bucket-foot{margin-top:auto}.ch-card{background:linear-gradient(180deg,rgba(153,104,223,calc(.17 * var(--cv-glass-a))),rgba(153,104,223,calc(.06 * var(--cv-glass-a))));border-color:#c2a4ec38}.ch-card.is-live{border-color:#c2a4ec8c;box-shadow:var(--inset-highlight),0 0 0 calc(3px * var(--cv-inv-zoom)) #9968df29,var(--shadow-card)}.ch-badge{background:linear-gradient(135deg,#9968df8c,#5a61ed6b);color:#fff;box-shadow:inset 0 1px #ffffff2e}.ch-card .cv-bucket-model{color:var(--amethyst-700);opacity:.8}.ch-card-last{margin-top:12px;font-size:12px;line-height:1.45;color:var(--fg-2);display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;word-break:break-word}.ch-card-last b{color:var(--fg-1);font-weight:600}.ch-card-last.is-empty{color:var(--fg-4)}.ch-card-state{display:inline-flex;align-items:center;gap:6px;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-card-state.is-busy{color:var(--amethyst-700);font-weight:600}.ch-pulse{width:6px;height:6px;flex:none;border-radius:50%;background:var(--amethyst-600);box-shadow:0 0 #ae86e599}@media(prefers-reduced-motion:no-preference){.ch-pulse{animation:chPulse 1.4s var(--ease-out-soft) infinite}@keyframes chPulse{0%{box-shadow:0 0 #ae86e599}70%{box-shadow:0 0 0 7px #ae86e500}to{box-shadow:0 0 #ae86e500}}}.v2-root.light-canvas .ch-card{background:#fff;border-color:#7532d342}.v2-root.light-canvas .ch-card-last{color:var(--lc-ink-2)}.v2-root.light-canvas .ch-card-last b{color:var(--lc-ink)}.v2-root.light-canvas .ch-card-state.is-busy,.v2-root.light-canvas .ch-card .cv-bucket-model{color:var(--amethyst-400)}.cv-frame-glow{position:absolute;pointer-events:none;z-index:3;border-radius:24px;box-shadow:0 0 0 calc(2px * var(--cv-inv-zoom)) #c2a4ecd9,0 0 0 calc(6px * var(--cv-inv-zoom)) #9968df29,0 0 calc(70px * var(--cv-inv-zoom)) calc(6px * var(--cv-inv-zoom)) #8f72ff47}.cv-pick-glow{border-radius:10px}@media(prefers-reduced-motion:no-preference){.cv-frame-glow{animation:chGlowIn .5s var(--ease-out-soft) both}.cv-frame-glow.is-working{animation:chGlowIn .5s var(--ease-out-soft) both,chBreathe 2.2s ease-in-out .5s infinite}@keyframes chGlowIn{0%{opacity:0}to{opacity:1}}@keyframes chBreathe{0%,to{opacity:1}50%{opacity:.55}}}.v2-root.light-canvas .cv-frame-glow{box-shadow:0 0 0 calc(2px * var(--cv-inv-zoom)) #7532d3bf,0 0 0 calc(6px * var(--cv-inv-zoom)) #9968df29,0 0 calc(60px * var(--cv-inv-zoom)) calc(4px * var(--cv-inv-zoom)) #7532d32e}.v2-root.chat-open .v2-uprompt{right:calc(var(--set-w) + 464px)}.cv-ctxbar .cv-ctx-info.is-chat .licon{color:var(--amethyst-700)}.ch-panel{position:absolute;z-index:46;top:66px;right:68px;bottom:14px;width:380px;display:flex;flex-direction:column;overflow:hidden;background:#090b13f0;backdrop-filter:blur(28px) saturate(110%);-webkit-backdrop-filter:blur(28px) saturate(110%);border:1px solid var(--hairline);border-radius:20px;box-shadow:var(--inset-highlight),var(--shadow-deep);pointer-events:auto;animation:histIn .26s var(--ease-out-soft) both;font-family:var(--font-sans)}.ch-head{flex:none;display:flex;align-items:center;gap:10px;padding:13px 12px 11px 14px;border-bottom:1px solid var(--hairline-soft)}.ch-head-mark{width:30px;height:30px;flex:none;border-radius:10px;display:inline-flex;align-items:center;justify-content:center;background:var(--grad-cta);color:#fff;box-shadow:inset 0 1px #fff3,0 6px 18px #745aff4d}.ch-head-titles{flex:1;min-width:0}.ch-head-name{display:inline-flex;align-items:center;gap:4px;max-width:100%;padding:0;border:0;background:transparent;cursor:default;font-family:var(--font-sans);font-size:14px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.ch-head-name .t{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-head-name.has-more{cursor:pointer}.ch-head-name.has-more .licon{color:var(--fg-4);transition:color var(--dur-fast)}.ch-head-name.has-more:hover .licon{color:var(--fg-1)}.ch-switch{position:relative}.ch-switch-menu{position:absolute;left:-6px;top:calc(100% + 8px);z-index:5;width:280px;max-height:320px;overflow-y:auto;display:flex;flex-direction:column;gap:2px;padding:6px;border-radius:14px;background:#121217fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 70px #02040cb3;animation:histIn .18s var(--ease-out-soft) both}.ch-switch-eyebrow{padding:4px 8px 6px;font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.18em;color:var(--fg-5)}.ch-switch-row{display:flex;align-items:center;gap:9px;width:100%;padding:7px 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);text-align:left;cursor:pointer;transition:background var(--dur-fast)}.ch-switch-row:hover{background:#ffffff0f}.ch-switch-row.on{background:var(--cv-accent-tint)}.ch-switch-row>.licon{flex:none;color:var(--amethyst-700)}.ch-switch-row .m{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}.ch-switch-row .n{font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-switch-row .f{font-size:10.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-switch-row .c{flex:none;font-size:10px;font-weight:600;color:var(--fg-4);background:#ffffff0f;border-radius:999px;padding:2px 7px;font-variant-numeric:tabular-nums}.ch-head-sub{display:flex;align-items:center;gap:5px;margin-top:2px;font-size:11px;color:var(--fg-4);min-width:0}.ch-head-frame{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--fg-3)}.ch-head-sub .dot{color:var(--fg-5)}.ch-head-n{flex:none;color:var(--amethyst-700);font-weight:600}.ch-iconbtn{flex:none;width:28px;height:28px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:1px solid var(--hairline-soft);border-radius:9px;background:#ffffff0a;color:var(--fg-3);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ch-iconbtn:hover{background:#ffffff17;color:var(--fg-1)}.ch-context{flex:none;display:flex;flex-wrap:wrap;gap:5px;padding:9px 14px 10px;border-bottom:1px solid var(--hairline-soft)}.ch-context.is-none{font-size:11px;line-height:1.45;color:var(--fg-4)}.ch-ctxchip{display:inline-flex;align-items:center;gap:5px;height:24px;padding:0 9px;border-radius:999px;border:1px solid rgba(194,164,236,.22);background:#9968df1a;color:var(--amethyst-800);font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ch-ctxchip:hover{background:#9968df33;border-color:var(--cv-accent-soft);color:#fff}.ch-ctxchip .licon{color:var(--amethyst-700)}.ch-ctxchip.is-empty{cursor:default;border-color:var(--hairline-soft);background:#ffffff0a;color:var(--fg-4)}.ch-ctxchip.is-empty .licon{color:var(--fg-5)}.ch-context.is-picks{align-items:center}.ch-ctxchip.is-pick{max-width:100%;padding:0 3px 0 4px;gap:5px}.ch-ctxchip.is-pick .th{width:18px;height:18px;flex:none;border-radius:6px;background-size:cover;background-position:center}.ch-ctxchip.is-pick .nm{min-width:0;max-width:140px;overflow:hidden;text-overflow:ellipsis}.ch-ctxchip.is-pick .x{width:18px;height:18px;padding:0;border:0;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:transparent;color:var(--fg-3);cursor:pointer}.ch-ctxchip.is-pick .x:hover{background:#ff5c7a33;color:#fff}.ch-ctxchip.is-add{border-style:dashed;background:transparent}.ch-context.is-none .ch-ctxchip.is-add{margin-top:6px}.ch-picks-hint{flex-basis:100%;font-size:10.5px;line-height:1.4;color:var(--fg-4)}.ch-scroll{flex:1;min-height:0;overflow-y:auto;padding:16px 14px 6px;overscroll-behavior:contain}.ch-scroll::-webkit-scrollbar{width:8px}.ch-scroll::-webkit-scrollbar-thumb{background:#ffffff17;border-radius:4px;border:2px solid transparent;background-clip:content-box}.ch-intro{display:flex;flex-direction:column;align-items:center;text-align:center;gap:8px;padding:22px 8px 10px}.ch-intro-mark{width:36px;height:36px;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;background:var(--grad-cta);color:#fff;box-shadow:0 10px 26px #745aff4d}.ch-intro-title{margin-top:4px;font-size:15px;font-weight:600;letter-spacing:-.015em;color:var(--fg-1);text-wrap:balance}.ch-intro-sub{font-size:12px;line-height:1.5;color:var(--fg-4);text-wrap:pretty;max-width:300px}.ch-msg{margin-bottom:16px}@media(prefers-reduced-motion:no-preference){.ch-msg{animation:chMsgIn .45s var(--ease-out-soft) both}@keyframes chMsgIn{0%{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}}.ch-msg.is-user{display:flex;flex-direction:column;align-items:flex-end}.ch-msg-meta{display:flex;align-items:center;gap:5px;margin:0 4px 4px;font-size:10px;font-weight:500;color:var(--fg-5)}.ch-msg.is-theirs .ch-msg-meta{color:var(--fg-4)}.ch-bubble{max-width:88%;border-radius:16px 16px 6px;background:linear-gradient(180deg,#ffffff16,#ffffff09);border:1px solid var(--hairline);box-shadow:inset 0 1px #ffffff12;padding:10px 13px;font-size:13px;line-height:1.5;color:#ffffffe0;word-break:break-word}.ch-msg.is-theirs .ch-bubble{background:linear-gradient(180deg,#5a61ed29,#5a61ed12);border-color:#a3a7f538}.ch-msg.is-agent{display:flex;gap:10px}.ch-ai-mark{width:24px;height:24px;flex:none;border-radius:8px;margin-top:1px;background:var(--grad-cta);display:flex;align-items:center;justify-content:center;color:#fff}@media(prefers-reduced-motion:no-preference){.ch-ai-mark.is-busy{animation:chBreathe 1.6s ease-in-out infinite}}.ch-ai-body{flex:1;min-width:0}.ch-ai-text{font-size:12.5px;line-height:1.55;color:var(--fg-2)}.ch-text{word-break:break-word;text-wrap:pretty}.ch-text p{margin:0 0 8px}.ch-text>:last-child{margin-bottom:0}.ch-text ul,.ch-text ol{margin:2px 0 8px;padding-left:18px}.ch-text li{margin:3px 0;padding-left:2px}.ch-text li::marker{color:var(--fg-5)}.ch-text b{color:var(--fg-1);font-weight:600}.ch-text.has-caret>:last-child:after{content:"";display:inline-block;width:7px;height:13px;margin-left:2px;vertical-align:-2px;border-radius:2px;background:var(--amethyst-600)}@media(prefers-reduced-motion:no-preference){.ch-text.has-caret>:last-child:after{animation:chCaret .9s steps(2,start) infinite}@keyframes chCaret{to{visibility:hidden}}}.ch-status{margin-top:2px;font-size:11.5px;font-weight:500;color:var(--fg-4);position:relative;width:fit-content;overflow:hidden}.ch-status:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(9,11,19,.75) 50%,transparent 80%);animation:shimmer 1.6s linear infinite}.ch-ai-text+.ch-status{margin-top:8px}.ch-chips{display:flex;flex-wrap:wrap;gap:6px;margin-top:10px}.ch-chips.is-start{justify-content:center;margin-top:8px}.ch-chip{display:inline-flex;align-items:center;gap:5px;max-width:100%;padding:5px 10px;border-radius:999px;border:1px solid var(--hairline);background:#ffffff0d;color:var(--fg-2);font-family:var(--font-sans);font-size:11px;font-weight:600;line-height:1.3;text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.ch-chip:hover{background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff;transform:translateY(-1px)}.ch-plan{margin-top:10px;border-radius:16px;overflow:hidden;background:#ffffff08;border:1px solid var(--hairline-soft);box-shadow:inset 0 1px #ffffff0d}.ch-ai-text+.ch-plan{margin-top:12px}.ch-plan.is-proposed,.ch-plan.is-running{border-color:#c2a4ec38;background:#9968df0e}.ch-plan.is-cancelled{opacity:.62}.ch-plan-head{display:flex;align-items:flex-start;gap:9px;padding:11px 12px 0}.ch-plan-mark{width:22px;height:22px;flex:none;border-radius:7px;margin-top:1px;background:#ffffff0f;box-shadow:inset 0 1px #ffffff14;display:inline-flex;align-items:center;justify-content:center;color:var(--amethyst-700)}.ch-plan-titles{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.ch-plan-eyebrow{display:flex;align-items:center;flex-wrap:wrap;gap:3px 5px;font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-4)}.ch-plan-eyebrow .dot{color:var(--fg-5);letter-spacing:0}.ch-plan-title{font-size:13px;font-weight:600;letter-spacing:-.01em;color:var(--fg-1)}.ch-plan-est{flex:none;display:flex;flex-direction:column;align-items:flex-end;gap:4px}.ch-plan-cost{display:inline-flex;align-items:center;gap:4px;font-size:10.5px;font-weight:700;color:var(--fg-2);background:#ffffff0f;border-radius:999px;padding:3px 9px;font-variant-numeric:tabular-nums;white-space:nowrap}.ch-plan-cost.is-estimate{color:var(--amethyst-700);background:var(--cv-accent-tint)}.ch-plan-time{display:inline-flex;align-items:center;gap:4px;font-size:10px;font-weight:600;color:var(--fg-4);font-variant-numeric:tabular-nums;white-space:nowrap;padding-right:2px}.ch-plan-summary{margin:8px 12px 6px;font-size:12px;line-height:1.5;color:var(--fg-2);text-wrap:pretty}.ch-sessions{display:flex;flex-direction:column;gap:2px;padding:2px 6px 4px}.ch-session{display:flex;align-items:flex-start;gap:9px;padding:8px;border-radius:11px;border:1px solid transparent}.ch-session+.ch-session{border-top-color:var(--hairline-soft);border-radius:0 0 11px 11px}.ch-session-icon{width:24px;height:24px;flex:none;border-radius:8px;margin-top:1px;display:inline-flex;align-items:center;justify-content:center;background:#ffffff0f;color:var(--amethyst-700)}.ch-session-main{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.ch-session-name{display:flex;align-items:center;gap:6px;min-width:0}.ch-session-name .n{min-width:0;font-size:12.5px;font-weight:600;color:var(--fg-1);letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-tag{flex:none;font-size:8.5px;font-weight:700;text-transform:uppercase;letter-spacing:.12em;color:var(--fg-4);background:#ffffff12;border-radius:999px;padding:2px 6px}.ch-tag.is-new{color:var(--amethyst-700);background:var(--cv-accent-tint)}.ch-session-meta{display:flex;align-items:center;flex-wrap:wrap;gap:2px 5px;font-size:10.5px;color:var(--fg-4);font-variant-numeric:tabular-nums}.ch-session-meta .sep{color:var(--fg-5)}.ch-session-meta .tk{display:inline-flex;align-items:center;gap:3px;color:var(--fg-3);font-weight:600}.ch-session-settings{font-size:10.5px;color:var(--fg-3)}.ch-session-why{display:flex;align-items:flex-start;gap:5px;font-size:10.5px;line-height:1.4;color:var(--fg-4)}.ch-session-why .licon{flex:none;margin-top:1px;color:var(--fg-5)}.ch-session-prompt{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;margin-top:3px;padding:7px 9px;border-radius:9px;text-align:left;cursor:pointer;border:1px solid var(--hairline-soft);background:#0000002e;font-family:var(--font-sans);font-size:11px;line-height:1.45;color:var(--fg-2);font-style:italic;transition:border-color var(--dur-fast),background var(--dur-fast)}.ch-session-prompt:hover{border-color:var(--hairline);background:#00000042}.ch-session-prompt.is-open{display:block;-webkit-line-clamp:unset}.ch-session-inputs{display:flex;flex-wrap:wrap;gap:4px;margin-top:4px}.ch-session-inputs .th{width:30px;height:30px;border-radius:6px;background-size:cover;background-position:center;background-color:#ffffff0d;border:1px solid rgba(255,255,255,.08)}.ch-actions{display:flex;flex-direction:column;gap:1px;margin:4px 12px 2px;padding:8px 10px;border-radius:11px;background:#00000029;border:1px solid var(--hairline-soft)}.ch-action{display:flex;align-items:flex-start;gap:8px;padding:3px 0;font-size:11.5px;line-height:1.4;color:var(--fg-3)}@media(prefers-reduced-motion:no-preference){.ch-action{animation:chMsgIn .35s var(--ease-out-soft) both}}.ch-action-icon{flex:none;display:inline-flex;margin-top:1px;color:var(--fg-5)}.ch-action.is-done .ch-action-icon{color:var(--success)}.ch-action.is-done{color:var(--fg-2)}.ch-action.is-running .ch-action-icon,.ch-action.is-running{color:var(--amethyst-700)}.ch-action.is-running{font-weight:600}.ch-action.is-failed .ch-action-icon,.ch-action.is-failed{color:#ff8aa0}.ch-action-main{min-width:0;display:flex;flex-direction:column;gap:1px}.ch-action-detail{font-size:10.5px;font-weight:500;color:var(--fg-4)}.ch-action.is-failed .ch-action-detail{color:#ffb3c1}.ch-plan-foot{display:flex;align-items:center;gap:8px;margin-top:8px;padding:10px 12px;border-top:1px solid var(--hairline-soft);font-size:10.5px;color:var(--fg-4)}.ch-plan-foot.is-running{color:var(--amethyst-700);font-weight:600}.ch-plan-foot.is-done{color:var(--success);font-weight:600}.ch-plan-foot.is-failed,.ch-plan-foot.is-stopped{color:#ff8aa0;font-weight:600}.ch-plan-breakdown{flex:1;min-width:0;line-height:1.4}.ch-plan-run{flex:none;display:inline-flex;align-items:center;gap:6px;height:30px;padding:0 13px;border:0;border-radius:9px;background:var(--grad-cta);color:#fff;font-family:var(--font-sans);font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;box-shadow:0 10px 26px #745aff42,inset 0 1px #ffffff2e;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-fast)}.ch-plan-run .sep{opacity:.6;margin:0 1px}.ch-plan-run:hover:not(:disabled){transform:translateY(-1px);filter:brightness(1.08)}.ch-plan-run:disabled{opacity:.7;cursor:default}.ch-plan-cancel,.ch-plan-show{flex:none;display:inline-flex;align-items:center;gap:5px;height:28px;padding:0 11px;border-radius:9px;background:#ffffff0e;border:1px solid var(--hairline);color:var(--fg-2);font-family:var(--font-sans);font-size:11px;font-weight:600;cursor:pointer;white-space:nowrap;transition:background var(--dur-fast),color var(--dur-fast)}.ch-plan-cancel:hover:not(:disabled),.ch-plan-show:hover{background:#ffffff1a;color:var(--fg-1)}.ch-plan-cancel:disabled{opacity:.5;cursor:default}.ch-plan.is-skeleton{padding:12px;display:flex;flex-direction:column;gap:8px}.ch-plan .sk{height:11px;border-radius:5px;background:#ffffff12;position:relative;overflow:hidden}.ch-plan .sk-a{width:76%}.ch-plan .sk-b{width:92%}.ch-plan .sk-c{width:58%}.ch-plan .sk:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:shimmer 1.2s linear infinite}.ch-composer{flex:none;padding:10px 12px 12px;border-top:1px solid var(--hairline-soft)}.ch-comp-box{border-radius:var(--radius-md);background:#1e1e23bf;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 20px 40px #0206173d;padding:10px 10px 8px 12px;transition:border-color var(--dur-fast),box-shadow var(--dur-fast)}.ch-comp-box:focus-within{border-color:var(--cv-accent-soft);box-shadow:var(--inset-highlight),0 0 0 3px var(--cv-accent-tint)}.ch-comp-box.is-off{opacity:.6}.ch-comp-input{display:block;width:100%;min-height:44px;max-height:160px;resize:none;border:0;outline:none;background:transparent;padding:0;font-family:var(--font-sans);font-size:13px;line-height:1.5;color:var(--fg-1);user-select:text;-webkit-user-select:text}.ch-comp-input::placeholder{color:var(--fg-4)}.ch-comp-foot{display:flex;align-items:center;gap:10px;margin-top:6px}.ch-comp-hint{flex:1;min-width:0;font-size:10px;color:var(--fg-5);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-model{position:relative;flex:none}.ch-model-btn{display:inline-flex;align-items:center;gap:5px;max-width:170px;height:24px;padding:0 8px 0 9px;border:1px solid var(--cv-accent-soft);border-radius:999px;background:var(--cv-accent-tint);color:#fff;font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast)}.ch-model-btn .t{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-model-btn.is-sim{border-color:var(--hairline-soft);background:#ffffff0d;color:var(--fg-3)}.ch-model-btn:hover{border-color:var(--cv-accent-soft);color:#fff}.ch-model-menu{position:absolute;left:-4px;bottom:calc(100% + 10px);z-index:6;width:250px;display:flex;flex-direction:column;gap:2px;padding:6px;border-radius:14px;background:#121217fa;border:1px solid var(--hairline);box-shadow:var(--inset-highlight),0 24px 70px #02040cb3;animation:histIn .18s var(--ease-out-soft) both}.ch-model-row{display:flex;align-items:center;gap:9px;width:100%;padding:7px 8px;border:0;border-radius:9px;background:transparent;color:var(--fg-2);font-family:var(--font-sans);text-align:left;cursor:pointer;transition:background var(--dur-fast)}.ch-model-row:hover{background:#ffffff0f}.ch-model-row.on{background:var(--cv-accent-tint)}.ch-model-row>.licon{flex:none;color:var(--amethyst-700)}.ch-model-row .m{flex:1;min-width:0;display:flex;flex-direction:column;gap:1px}.ch-model-row .n{font-size:12px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-model-row .f{font-size:10.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-model-note{padding:6px 8px 4px;font-size:10.5px;line-height:1.45;color:var(--fg-4);text-wrap:pretty}.ch-send{flex:none;width:32px;height:32px;padding:0;display:inline-flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:var(--grad-cta);color:#fff;cursor:pointer;box-shadow:0 8px 22px #745aff4d,inset 0 1px #fff3;transition:transform var(--dur-fast) var(--ease-out-soft),filter var(--dur-fast)}.ch-send:hover:not(:disabled){transform:translateY(-1px);filter:brightness(1.08)}.ch-send:disabled{cursor:default;background:#ffffff14;color:var(--fg-5);box-shadow:none}.ch-picks{display:flex;flex-direction:column;gap:6px;margin-top:10px}.ch-ai-text+.ch-picks{margin-top:12px}.ch-pick{display:flex;align-items:flex-start;gap:10px;padding:9px 10px;border-radius:14px;background:#ffffff08;border:1px solid var(--hairline-soft);box-shadow:inset 0 1px #ffffff0d}.ch-pick.is-off{opacity:.55}.ch-pick-pic{flex:none;width:34px;height:34px;border-radius:10px;margin-top:1px;background:#ffffff0f center / cover no-repeat;box-shadow:inset 0 0 0 1px #ffffff14;display:inline-flex;align-items:center;justify-content:center;color:var(--amethyst-700)}.ch-pick-main{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.ch-pick-top{display:flex;align-items:baseline;gap:6px;min-width:0}.ch-pick-name{min-width:0;font-size:12.5px;font-weight:600;color:var(--fg-1);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ch-pick-price{flex:none;margin-left:auto;font-size:10px;font-weight:700;color:var(--fg-2);background:#ffffff0f;border-radius:999px;padding:2px 7px;font-variant-numeric:tabular-nums;white-space:nowrap}.ch-pick-why{font-size:11.5px;line-height:1.45;color:var(--fg-3);text-wrap:pretty}.ch-pick-kit{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.14em;color:var(--fg-5);margin-top:1px}.ch-pick-try{flex:none;align-self:center;display:inline-flex;align-items:center;gap:4px;height:26px;padding:0 10px;border:1px solid var(--hairline);border-radius:999px;background:#ffffff0d;color:var(--fg-2);font-family:var(--font-sans);font-size:10.5px;font-weight:600;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.ch-pick-try:hover:not(:disabled){background:var(--cv-accent-tint);border-color:var(--cv-accent-soft);color:#fff;transform:translateY(-1px)}.ch-pick-try:disabled{opacity:.5;cursor:default}.ch-ideas{display:flex;flex-direction:column;gap:6px;margin-top:10px}.ch-ai-text+.ch-ideas{margin-top:12px}.ch-idea{display:flex;align-items:flex-start;gap:10px;width:100%;padding:10px 10px 10px 11px;border-radius:14px;background:#ffffff08;border:1px solid var(--hairline-soft);color:var(--fg-2);box-shadow:inset 0 1px #ffffff0d;font-family:var(--font-sans);text-align:left;cursor:pointer;transition:background var(--dur-fast),border-color var(--dur-fast),transform var(--dur-fast) var(--ease-out-soft)}.ch-idea:hover:not(:disabled){background:#9968df14;border-color:#c2a4ec47;transform:translateY(-1px)}.ch-idea:disabled{cursor:default}.ch-idea-n{flex:none;width:20px;height:20px;margin-top:1px;border-radius:7px;display:inline-flex;align-items:center;justify-content:center;background:var(--cv-accent-tint);color:var(--amethyst-700);font-size:10.5px;font-weight:700;font-variant-numeric:tabular-nums}.ch-idea-main{flex:1;min-width:0;display:flex;flex-direction:column;gap:3px}.ch-idea-title{font-size:12.5px;font-weight:600;color:var(--fg-1)}.ch-idea-pitch{font-size:11.5px;line-height:1.45;color:var(--fg-3);text-wrap:pretty}.ch-idea-tool{display:inline-flex;align-items:center;gap:4px;font-size:10px;font-weight:600;color:var(--amethyst-700);margin-top:1px}.ch-idea-go{flex:none;align-self:center;color:var(--fg-5)}.ch-idea:hover:not(:disabled) .ch-idea-go{color:var(--fg-2)}.ch-msg-cost{display:flex;align-items:center;gap:4px;margin-top:8px;font-size:10px;font-weight:500;color:var(--fg-4);font-variant-numeric:tabular-nums}.ch-msg-cost .dot{color:var(--fg-5);opacity:.7}.ch-msg-cost .licon{opacity:.8}', qCe = `
/* while a board is open the host's emulator banner would sit on the rail */
body.bd-open .firebase-emulator-warning { display: none !important; }
`;
let qh = 0, wo = null;
function HA() {
  return qh++, wo || (wo = document.createElement("style"), wo.setAttribute("data-rd-board", ""), wo.textContent = [DCe, OCe, LCe, BCe, FCe, NCe, UCe, GCe, jCe, HCe, VCe, WCe, CL, qCe].join(`
`), document.head.appendChild(wo)), () => {
    qh = Math.max(0, qh - 1), !qh && wo && (wo.remove(), wo = null);
  };
}
const KCe = ".bd-root.bd-tip{position:fixed;left:0;top:0;z-index:2147483600;pointer-events:none;display:flex;flex-direction:column;gap:3px;width:max-content;max-width:280px;padding:6px 10px 7px;border-radius:9px;background:#131520fa;border:1px solid rgba(255,255,255,.11);box-shadow:inset 0 1px #ffffff0b,0 12px 32px #02040c8c,0 2px 8px #02040c66;color:var(--fg-1);font-size:12px;font-weight:500;line-height:1.35;letter-spacing:-.005em;text-align:left;white-space:normal;overflow-wrap:anywhere;opacity:0;transform:translateY(3px);transition:opacity .12s ease,transform .16s var(--ease-out-soft)}.bd-root.bd-tip.is-below{transform:translateY(-3px)}.bd-root.bd-tip.on{opacity:1;transform:none}.bd-root.bd-tip.is-now{transition:none}.bd-tip .ln{display:flex;align-items:center;gap:10px}.bd-tip .tx{flex:1 1 auto;min-width:0}.bd-tip .keys{flex:none;display:inline-flex;gap:3px;margin-right:-3px}.bd-tip kbd{min-width:18px;height:18px;padding:0 5px;display:inline-flex;align-items:center;justify-content:center;border-radius:5px;border:1px solid rgba(255,255,255,.1);background:#ffffff12;box-shadow:inset 0 -1px #0000004d;color:var(--fg-2);font-family:var(--font-sans);font-size:10.5px;font-weight:600;line-height:1}.bd-tip .hint{font-size:11.5px;font-weight:400;line-height:1.4;color:var(--fg-3)}@media(prefers-reduced-motion:reduce){.bd-root.bd-tip,.bd-root.bd-tip.is-below{transition:none;transform:none}}", YCe = 260, XCe = 400, Hb = 8, zd = 8, Ff = "bd-tip", Vb = "(?:Esc|Enter|Del|Space|Tab|↵|⌫|[←→↑↓\\[\\]/\\\\,.=+\\-?])", JCe = new RegExp("^(?:[A-Z]|" + Vb + "|[⌘⇧⌥⌃]+(?:[A-Z0-9]|" + Vb + ")|(?:(?:Ctrl|Alt|Shift|Cmd)\\+)+(?:[A-Z0-9]|" + Vb + "))$");
function VA(i) {
  const [e, ...t] = i.split(`
`), n = e.trim(), s = /^(.*\S)\s+\(([^()]+)\)$/.exec(n), o = s ? s[2].trim() : "", r = s && JCe.test(o) ? ZCe(o) : [];
  return { label: r.length ? s[1] : n, keys: r, hint: t.map((a) => a.trim()).filter(Boolean).join(" ") };
}
function ZCe(i) {
  const e = /^((?:(?:Ctrl|Alt|Shift|Cmd)\+)+)(.+)$/.exec(i);
  if (e) return [...e[1].split("+").filter(Boolean), e[2]];
  const t = /^([⌘⇧⌥⌃]*)(.+)$/u.exec(i);
  return t ? [...Array.from(t[1]), t[2]] : [i];
}
let Kh = 0, Tr = null, jn = null, wn = null, gx = "pointer", Sm = !1, Ml = !1, bx = -1 / 0, Nf = 0, W0 = 0, Ic = null;
const ar = /* @__PURE__ */ new WeakMap(), q0 = /* @__PURE__ */ new WeakSet();
function WA(i) {
  const e = i instanceof Element ? i : null, t = e ? e.closest("[title]") : null;
  return !t || !t.closest(".bd-root") || t === jn || !ar.has(t) && !(t.getAttribute("title") || "").trim() ? null : t;
}
function QCe(i) {
  const e = ar.get(i);
  if (e != null) return e;
  const t = i.getAttribute("title");
  return !t || !t.trim() ? null : (ar.set(i, t), i.setAttribute("title", ""), !i.hasAttribute("aria-label") && !i.hasAttribute("aria-labelledby") && !(i.textContent || "").trim() && (i.setAttribute("aria-label", VA(t).label), q0.add(i)), t);
}
function eIe(i) {
  const e = ar.get(i);
  ar.delete(i), e != null && i.getAttribute("title") === "" && i.setAttribute("title", e), q0.has(i) && (i.removeAttribute("aria-label"), q0.delete(i));
  const t = (i.getAttribute("aria-describedby") || "").split(/\s+/).filter((n) => n && n !== Ff);
  t.length ? i.setAttribute("aria-describedby", t.join(" ")) : i.removeAttribute("aria-describedby");
}
function tIe() {
  if (!wn) return;
  const i = wn.getAttribute("title");
  if (i !== "") {
    if (i == null) {
      ar.delete(wn), vx();
      return;
    }
    ar.set(wn, i), wn.setAttribute("title", ""), Ml && K0(!0);
  }
}
function qA(i, e) {
  QCe(i) != null && (wn = i, gx = e, Sm = !1, Ic = new MutationObserver(tIe), Ic.observe(i, { attributes: !0, attributeFilter: ["title"] }), clearTimeout(Nf), performance.now() - bx < XCe ? K0(!0) : Nf = window.setTimeout(() => K0(!1), YCe));
}
function ed() {
  clearTimeout(Nf), Ic && Ic.disconnect(), Ic = null;
  const i = wn;
  wn = null, Sm = !1, vx(), i && eIe(i);
}
function nIe() {
  return jn && jn.isConnected || (jn = document.createElement("div"), jn.className = "bd-root bd-tip", jn.id = Ff, jn.setAttribute("role", "tooltip"), jn.setAttribute("data-testid", "board-tip"), document.body.appendChild(jn)), jn;
}
function iIe(i, e) {
  i.replaceChildren();
  const t = document.createElement("span");
  t.className = "ln";
  const n = document.createElement("span");
  if (n.className = "tx", n.textContent = e.label, t.appendChild(n), e.keys.length) {
    const s = document.createElement("span");
    s.className = "keys";
    for (const o of e.keys) {
      const r = document.createElement("kbd");
      r.textContent = o, s.appendChild(r);
    }
    t.appendChild(s);
  }
  if (i.appendChild(t), e.hint) {
    const s = document.createElement("span");
    s.className = "hint", s.textContent = e.hint, i.appendChild(s);
  }
}
function sIe(i, e) {
  const t = e.getBoundingClientRect(), n = i.offsetWidth, s = i.offsetHeight;
  let o = t.top - Hb - s, r = !1;
  o < zd && (o = t.bottom + Hb, r = !0, o + s > window.innerHeight - zd && (o = Math.max(zd, t.top - Hb - s), r = !1));
  const a = Math.max(zd, Math.min(window.innerWidth - zd - n, t.left + t.width / 2 - n / 2));
  i.classList.toggle("is-below", r), i.style.left = Math.round(a) + "px", i.style.top = Math.round(o) + "px";
}
function K0(i) {
  const e = wn, t = e ? ar.get(e) : null;
  if (!e || !t || Sm || !e.isConnected || e.querySelector(".tip")) return;
  const n = nIe();
  iIe(n, VA(t)), n.classList.toggle("is-now", i || Ml), Ml || n.classList.remove("on"), sIe(n, e), n.offsetWidth, n.classList.add("on"), Ml = !0, bx = performance.now();
  const s = (e.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean);
  s.includes(Ff) || e.setAttribute("aria-describedby", [...s, Ff].join(" ")), clearInterval(W0), W0 = window.setInterval(() => {
    (!wn || !wn.isConnected) && ed();
  }, 250);
}
function vx() {
  clearTimeout(Nf), clearInterval(W0), Ml && (bx = performance.now()), Ml = !1, jn && jn.classList.remove("on");
}
function V4(i) {
  if (i.pointerType === "touch") return;
  const e = WA(i.target);
  e !== wn && (wn && ed(), e && !i.buttons && qA(e, "pointer"));
}
function W4(i) {
  wn && gx === "pointer" && !i.relatedTarget && ed();
}
function ms() {
  wn && (Sm = !0, vx());
}
function q4(i) {
  i.key === "Escape" && ms();
}
function K4(i) {
  const e = i.target;
  wn && (e === document || e instanceof Node && e.contains(wn)) && ms();
}
function Y4(i) {
  const e = i.target;
  if (!(e instanceof HTMLElement) || !e.matches(":focus-visible")) return;
  const t = WA(e);
  !t || t === wn || (wn && ed(), qA(t, "focus"));
}
function X4() {
  wn && gx === "focus" && ed();
}
function KA() {
  if (typeof document == "undefined") return () => {
  };
  Kh++, Kh === 1 && (Tr = document.createElement("style"), Tr.setAttribute("data-rd-board-tips", ""), Tr.textContent = KCe, document.head.appendChild(Tr), document.addEventListener("pointerover", V4, !0), document.addEventListener("pointerout", W4, !0), document.addEventListener("pointerdown", ms, !0), document.addEventListener("keydown", q4, !0), document.addEventListener("focusin", Y4, !0), document.addEventListener("focusout", X4, !0), window.addEventListener("scroll", K4, !0), window.addEventListener("wheel", ms, { capture: !0, passive: !0 }), window.addEventListener("blur", ms), window.addEventListener("resize", ms));
  let i = !1;
  return () => {
    i || (i = !0, Kh--, !(Kh > 0) && (ed(), document.removeEventListener("pointerover", V4, !0), document.removeEventListener("pointerout", W4, !0), document.removeEventListener("pointerdown", ms, !0), document.removeEventListener("keydown", q4, !0), document.removeEventListener("focusin", Y4, !0), document.removeEventListener("focusout", X4, !0), window.removeEventListener("scroll", K4, !0), window.removeEventListener("wheel", ms, !0), window.removeEventListener("blur", ms), window.removeEventListener("resize", ms), jn && jn.remove(), jn = null, Tr && Tr.remove(), Tr = null));
  };
}
const oIe = [
  { value: "1:1", label: "1:1", meta: "1024×1024", icon: "Square" },
  { value: "3:4", label: "3:4", meta: "896×1152", icon: "RectangleVertical" },
  { value: "4:3", label: "4:3", meta: "1152×896", icon: "RectangleHorizontal" },
  { value: "16:9", label: "16:9", meta: "1344×768", icon: "RectangleHorizontal" },
  { value: "9:16", label: "9:16", meta: "768×1344", icon: "RectangleVertical" }
], rIe = ["2s", "4s", "6s", "10s"].map((i) => ({ value: i, label: i })), J4 = {
  "Nano Banana Pro": 14,
  "Nano Banana 2": 14,
  "ChatGPT Image 2": 16,
  "GPT Image 1.5": 16,
  "Seedream 5 Lite": 10,
  "Flux 2 Pro": 0
};
function Z4(i, e = "") {
  const t = { key: "prompt", kind: "prompt", label: "Prompt", placement: "prompt", required: !0, defaultValue: "" }, n = { key: "aspect", kind: "size", label: "Output size", placement: "chip", defaultValue: "3:4", options: oIe }, s = { key: "seed", kind: "seed", label: "Seed", placement: "advanced", defaultValue: null, tooltip: "The same seed with the same prompt and settings repeats a result." };
  if (i === "video")
    return [
      t,
      { key: "startFrame", kind: "image", label: "Start frame", placement: "reference" },
      { ...n, defaultValue: "16:9" },
      { key: "length", kind: "select", label: "Length", placement: "chip", icon: "Clock", defaultValue: "4s", options: rIe },
      s
    ];
  if (i === "threed")
    return [
      { ...t, required: !1, placeholder: "Optional: describe the object" },
      { key: "source", kind: "image", label: "Source image", placement: "reference", required: !0 },
      { key: "texture", kind: "boolean", label: "Bake textures", placement: "advanced", defaultValue: !0 },
      s
    ];
  if (i === "upscale" && /video/i.test(e))
    return [
      { key: "video", kind: "video", label: "Video to upscale", placement: "reference", required: !0 },
      { key: "factor", kind: "select", label: "Scale", placement: "chip", icon: "Maximize2", defaultValue: "2x", options: [{ value: "2x", label: "2×" }, { value: "4x", label: "4×" }] }
    ];
  if (i === "upscale")
    return [
      { key: "image", kind: "image", label: "Image to upscale", placement: "reference", required: !0 },
      {
        key: "factor",
        kind: "select",
        label: "Scale",
        placement: "chip",
        icon: "Maximize2",
        defaultValue: "2x",
        options: [{ value: "2x", label: "2×" }, { value: "4x", label: "4×" }]
      },
      { key: "creativity", kind: "slider", label: "Creativity", placement: "advanced", min: 0, max: 10, step: 1, defaultValue: 3, tooltip: "How much new detail the upscaler may invent." }
    ];
  const o = e in J4 ? J4[e] : 4;
  return [
    t,
    ...o ? [{ key: "images", kind: "images", label: "Images", placement: "reference", maxImages: o }] : [],
    n,
    { key: "steps", kind: "slider", label: "Steps (Quality)", placement: "advanced", min: 1, max: 50, step: 1, defaultValue: 4, tooltip: "More steps take longer and add detail." },
    s
  ];
}
function aIe() {
  return {
    id: "demo:threed:Hunyuan 3D Pro",
    name: "Hunyuan 3D Pro",
    desc: "One object from up to six views",
    kitId: "threed",
    tokensLabel: "813",
    tokensPerResult: 813,
    time: "2m",
    fields: [
      { key: "prompt", kind: "prompt", label: "Prompt", placement: "prompt", required: !1, defaultValue: "", placeholder: "Optional: describe the object" },
      ...["Front", "Back", "Left", "Right", "Top", "Bottom"].map((e, t) => ({ key: "view" + e, kind: "image", label: e + " view", placement: "reference", required: t === 0 })),
      { key: "seed", kind: "seed", label: "Seed", placement: "advanced", defaultValue: null }
    ],
    numResults: { min: 1, max: 1, def: 1 }
  };
}
const lIe = [
  { kitId: "image", name: "Qwen Image", tokens: 43, time: "10s" },
  { kitId: "image", name: "Recraft v4 Pro", tokens: 698, time: "25s" },
  { kitId: "video", name: "Veo 3.1 Fast", tokens: 233, time: "1m" },
  { kitId: "video", name: "Luma Ray 2", tokens: 1164, time: "2m" }
];
function Vi(i) {
  const { display: e, ...t } = i;
  return { ...t, raw: { boardKey: i.key, display: e || {} } };
}
function $d(i, e, t, n, s, o, r = 1) {
  return {
    id: "demo:tools:" + i,
    name: e,
    kitId: "tools",
    tokensLabel: String(n),
    tokensPerResult: n,
    time: s,
    fields: o,
    numResults: { min: 1, max: r, def: 1 },
    boardTool: t
  };
}
function dIe() {
  const i = (t = "Image") => Vi({ key: "image", kind: "image", label: t, placement: "reference", required: !0 }), e = (t, n) => Vi({ key: t, kind: "slider", label: n, placement: "advanced", min: 0, max: 5e3, step: 1 });
  return [
    $d("removebg", "Remove Background", "removebg", 9, "6s", [i("Image to cut out")]),
    $d("erase", "Person and Object Remover", "erase", 93, "11s", [Vi({ key: "image", kind: "image", label: "Image to remove items from", placement: "reference", required: !0, display: { hasInpainting: !0, inpaintingRequired: !0 } })]),
    $d("expand", "Expand", "expand", 93, "15s", [
      i("Image to expand"),
      Vi({ key: "prompt", kind: "prompt", label: "What to add", placement: "prompt", required: !1, defaultValue: "" }),
      e("canvasWidth", "Canvas width"),
      e("canvasHeight", "Canvas height"),
      e("imageWidth", "Image width"),
      e("imageHeight", "Image height"),
      e("imageX", "Image left"),
      e("imageY", "Image top")
    ]),
    $d("camera", "Change Camera", "camera", 76, "18s", [
      i("Image to see from another angle"),
      Vi({ key: "rotate", kind: "slider", label: "Rotate", placement: "advanced", min: 0, max: 360, step: 1, defaultValue: 45 }),
      Vi({ key: "vertical", kind: "slider", label: "Vertical", placement: "advanced", min: -30, max: 90, step: 1, defaultValue: 0 }),
      Vi({ key: "zoom", kind: "slider", label: "Zoom", placement: "advanced", min: 0, max: 10, step: 0.5, defaultValue: 5 }),
      Vi({ key: "keep", kind: "text", label: "Keep", placement: "advanced", defaultValue: "" }),
      Vi({ key: "avoid", kind: "negPrompt", label: "Avoid", placement: "advanced", defaultValue: "" }),
      Vi({ key: "loraScale", kind: "slider", label: "LoRA scale", placement: "advanced", min: 0, max: 4, step: 0.1, defaultValue: 0.9 }),
      Vi({ key: "seed", kind: "seed", label: "Seed", placement: "advanced", defaultValue: null })
    ], 4),
    $d("select", "Find Objects", "select", 11, "4s", [i("Image to find the objects in")])
  ];
}
function cIe() {
  const i = (e) => e.map((t) => ({ value: t, label: t }));
  return {
    id: "demo:upscale:Magnific Upscaler",
    name: "Magnific Upscaler",
    kitId: "upscale",
    tokensLabel: "282+",
    time: "45s",
    numResults: { min: 1, max: 1, def: 1 },
    fields: [
      { key: "image", kind: "image", label: "Image", placement: "reference", required: !0 },
      { key: "scale", kind: "select", label: "Scale Factor", placement: "chip", icon: "Maximize2", defaultValue: 2, options: [2, 4, 8, 16].map((e) => ({ value: e, label: String(e) })) },
      { key: "optimized", kind: "select", label: "Optimized For", placement: "chip", defaultValue: "standard", options: i(["standard", "soft_portraits", "hard_portraits", "art_n_illustration", "videogame_assets", "nature_n_landscapes", "films_n_photography", "3d_renders", "science_fiction_n_horror"]) },
      { key: "prompt", kind: "text", label: "Prompt (Optional)", placement: "advanced", defaultValue: "" },
      { key: "creativity", kind: "slider", label: "Creativity", placement: "advanced", min: -10, max: 10, step: 1, defaultValue: 0 },
      { key: "hdr", kind: "slider", label: "HDR", placement: "advanced", min: -10, max: 10, step: 1, defaultValue: 0 },
      { key: "resemblance", kind: "slider", label: "Resemblance", placement: "advanced", min: -10, max: 10, step: 1, defaultValue: 0 },
      { key: "fractality", kind: "slider", label: "Fractality", placement: "advanced", min: -10, max: 10, step: 1, defaultValue: 0 },
      { key: "engine", kind: "select", label: "Engine", placement: "advanced", defaultValue: "automatic", options: i(["automatic", "magnific_illusio", "magnific_sharpy", "magnific_sparkle"]) }
    ]
  };
}
function YA() {
  const i = na.kits.map((t) => ({
    id: t.id,
    name: t.name,
    icon: t.icon,
    desc: t.desc,
    models: t.models.map((n) => ({
      id: "demo:" + t.id + ":" + n.name,
      name: n.name,
      desc: n.desc,
      kitId: t.id,
      tokensLabel: String(n.tokens),
      tokensPerResult: /^\d+$/.test(String(n.tokens)) ? Number(n.tokens) : void 0,
      time: n.time,
      fields: Z4(t.id, n.name),
      numResults: { min: 1, max: 8, def: 1 }
    })).concat(t.id === "threed" ? [aIe()] : t.id === "upscale" ? [cIe()] : [])
  })), e = lIe.map((t) => ({
    id: "demo:" + t.kitId + ":" + t.name,
    name: t.name,
    kitId: t.kitId,
    tokensLabel: String(t.tokens),
    tokensPerResult: t.tokens,
    time: t.time,
    fields: Z4(t.kitId, t.name),
    numResults: { min: 1, max: 4, def: 1 }
  }));
  return nf("demo", i, e, dIe());
}
var uIe = Object.defineProperty, hIe = (i, e, t) => e in i ? uIe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Jr = (i, e, t) => hIe(i, typeof e != "symbol" ? e + "" : e, t);
class yx {
  constructor(e = null, t = null) {
    if (Jr(this, "persistKey", e), Jr(this, "user", t), Jr(this, "boards", /* @__PURE__ */ new Map()), e)
      try {
        const n = localStorage.getItem(e);
        if (n) {
          const s = JSON.parse(n);
          for (const [o, r] of Object.entries(s)) this.boards.set(o, r);
        }
      } catch {
      }
  }
  save() {
    if (this.persistKey)
      try {
        const e = {};
        for (const [t, n] of this.boards)
          t.startsWith("stress-") || (e[t] = n);
        localStorage.setItem(this.persistKey, JSON.stringify(e));
      } catch {
      }
  }
  async list() {
    return Array.from(this.boards.values()).map((e) => ({ ...e.meta })).sort((e, t) => (t.updatedAt || 0) - (e.updatedAt || 0));
  }
  async get(e) {
    const t = this.boards.get(e);
    return t ? { ...t.meta } : null;
  }
  /** `id`: the harness gives a board the boards list made the list's own id */
  async create(e, t = "blank", n = St()) {
    const s = Date.now(), o = t === "demo" ? Kl() : null, r = {
      meta: { id: n, title: o ? o.title : e, createdAt: s, updatedAt: s, ...this.user ? { ownerId: this.user.uid } : {} },
      elements: {},
      results: {}
    };
    if (o) {
      for (const a of o.elements) r.elements[a.id] = a;
      for (const a of o.results) r.results[a.id] = a;
    }
    return this.boards.set(n, r), this.save(), { ...r.meta };
  }
  /** Benchmark boards: regenerated every time, never persisted. */
  ensureStress(e, t) {
    const n = "stress-" + e + (t ? "-syn" : "");
    return this.boards.has(n) || this.addSeeded(n, GW(e, t)), n;
  }
  /** The demo board tiled to at least `minImages` images (the stress page). */
  ensureTiledDemo(e) {
    const t = "stress-demo-" + e;
    return this.boards.has(t) || this.addSeeded(t, UW(e)), t;
  }
  /** A board made from a seed under the id given (the stress page's, the tour's practice board). */
  addSeeded(e, t) {
    const n = { meta: { id: e, title: t.title, createdAt: Date.now(), updatedAt: Date.now() }, elements: {}, results: {} };
    for (const s of t.elements) n.elements[s.id] = s;
    for (const s of t.results) n.results[s.id] = s;
    this.boards.set(e, n);
  }
  async rename(e, t) {
    const n = this.boards.get(e);
    n && (n.meta.title = t, n.meta.updatedAt = Date.now(), this.save());
  }
  async remove(e) {
    this.boards.delete(e), this.save();
  }
  open(e) {
    return new pIe(this, e);
  }
  board(e) {
    return this.boards.get(e);
  }
}
class pIe {
  constructor(e, t) {
    Jr(this, "dir", e), Jr(this, "id", t), Jr(this, "status", /* @__PURE__ */ K("saved")), Jr(this, "saveTimer", 0);
  }
  async load() {
    const e = this.dir.board(this.id);
    if (!e) throw new Error("Board not found");
    return {
      meta: JSON.parse(JSON.stringify(e.meta)),
      elements: Object.values(e.elements).map((t) => JSON.parse(JSON.stringify(t))),
      results: Object.values(e.results).map((t) => JSON.parse(JSON.stringify(t)))
    };
  }
  watch(e) {
  }
  commit(e) {
    const t = this.dir.board(this.id);
    if (!t) return;
    const n = Date.now(), s = this.dir.user;
    for (const o of e.added)
      t.elements[o.id] = JSON.parse(JSON.stringify(o)), t.trash && delete t.trash[o.id];
    for (const o of e.updated) t.elements[o.id] = JSON.parse(JSON.stringify(o.el));
    for (const o of e.removed)
      delete t.elements[o.id], t.trash || (t.trash = {}), t.trash[o.id] = {
        el: JSON.parse(JSON.stringify(o)),
        deletedAt: n,
        hardDeleteAt: n + L1,
        deletedBy: s ? s.uid : void 0,
        deletedByEmail: s ? s.email : void 0
      };
    t.meta.updatedAt = n, this.schedule();
  }
  trash() {
    const e = this.dir.board(this.id);
    if (!e || !e.trash) return [];
    const t = Date.now();
    return Object.values(e.trash).filter((n) => n.hardDeleteAt > t).map((n) => JSON.parse(JSON.stringify(n))).sort((n, s) => s.deletedAt - n.deletedAt);
  }
  purge(e) {
    const t = this.dir.board(this.id);
    if (!(!t || !t.trash)) {
      for (const n of e) delete t.trash[n];
      this.schedule();
    }
  }
  commitResults(e) {
    const t = this.dir.board(this.id);
    if (t) {
      for (const n of e) t.results[n.id] = JSON.parse(JSON.stringify(n));
      this.schedule();
    }
  }
  saveMeta(e) {
    const t = this.dir.board(this.id);
    t && (Object.assign(t.meta, JSON.parse(JSON.stringify(e)), { updatedAt: Date.now() }), this.schedule());
  }
  schedule() {
    this.status.value = "saving", clearTimeout(this.saveTimer), this.saveTimer = window.setTimeout(() => {
      this.dir.save(), this.status.value = "saved";
    }, 500);
  }
  async flush() {
    clearTimeout(this.saveTimer), this.dir.save(), this.status.value = "saved";
  }
  dispose() {
    this.flush();
  }
}
var fIe = Object.defineProperty, mIe = (i, e, t) => e in i ? fIe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Yh = (i, e, t) => mIe(i, typeof e != "symbol" ? e + "" : e, t);
const XA = 260, ko = (i, e = XA) => new Promise((t) => setTimeout(() => t(i), e)), gIe = [{ value: "demo-board", text: "Bonneville Tower" }, { value: "demo-old", text: "Depot Yards (v1 board)" }], Q4 = [
  [/nano banana/i, "fam-gemini", "Nano Banana"],
  [/gpt|chatgpt/i, "fam-openai", "GPT Image"],
  [/seedream/i, "fam-seedream", "Seedream"],
  [/kling/i, "fam-kling", "Kling"],
  [/flux/i, "fam-flux", "Flux"]
], bIe = [["1:1", 1], ["16:9", 16 / 9], ["2:1", 2], ["3:2", 1.5], ["4:3", 4 / 3], ["21:9", 21 / 9], ["9:16", 9 / 16], ["2:3", 2 / 3], ["3:4", 0.75]];
function vIe(i = 1, e = 1) {
  const t = i / e;
  let n = "OTHER", s = 0.06;
  for (const [o, r] of bIe) {
    const a = Math.abs(Math.log(t / r));
    a < s && (s = a, n = o);
  }
  return n;
}
function yIe(i = 0) {
  const e = new Date(i);
  return e.getFullYear() + "-" + String(e.getMonth() + 1).padStart(2, "0") + "-" + String(e.getDate()).padStart(2, "0");
}
function xIe(i, e) {
  const t = e.trim().toLowerCase();
  if (!t) return !0;
  const n = [i.prompt, i.label, i.model].filter(Boolean).join(" ").toLowerCase();
  return t.split(/\s+/).every((s) => n.includes(s));
}
class wIe {
  constructor() {
    Yh(this, "features", { search: !0, filters: !0, star: !0, remove: !0 }), Yh(this, "gens"), Yh(this, "ups"), Yh(this, "facets", /* @__PURE__ */ new Map());
    const e = Kl(), t = /* @__PURE__ */ new Set(), n = [];
    e.results.forEach((a, l) => {
      if (!a.url || t.has(a.url)) return;
      t.add(a.url);
      const d = "demo:" + a.id;
      n.push({
        id: d,
        url: a.url,
        w: a.w,
        h: a.h,
        video: !!a.video,
        videoSrc: a.videoSrc,
        label: a.prompt || a.label || "Generation",
        prompt: a.prompt || "",
        model: a.model,
        createdAt: a.createdAt,
        fav: !!a.fav,
        mine: !0,
        run: { id: "demo-run-" + a.id, uuid: a.id, nodeDefId: a.model || "", nodeId: a.sessionId, runnitId: "demo-board", type: a.video ? "VID" : "IMG" },
        asset: { nodeRunResult: { url: a.url, uuid: a.id } }
      });
      const c = Q4.find(([h]) => h.test(a.model || ""));
      this.facets.set(d, {
        aspect: vIe(a.w, a.h),
        // the demo's renders are all small: give them a spread to filter by
        resolution: l % 7 === 0 ? "4K+" : l % 3 === 0 ? "2K" : "1K",
        tool: a.model || "",
        family: c ? c[1] : "",
        media: a.video ? "media-video" : "media-image",
        board: l % 5 === 4 ? "demo-old" : "demo-board",
        day: yIe(a.createdAt)
      });
    }), this.gens = n.sort((a, l) => (l.createdAt || 0) - (a.createdAt || 0));
    const s = [];
    let o = Date.UTC(2026, 8, 14, 18, 0);
    for (const a of e.elements) {
      if (a.type !== "image") continue;
      const l = a;
      l.video || !/site|existing|reference|sketch|plan|photo|material/i.test(l.label || "") || s.some((d) => d.url === l.src) || s.push({
        id: "demo-upload:" + l.id,
        url: l.src,
        w: l.w,
        h: l.h,
        video: !1,
        label: (l.label || "upload") + ".jpg",
        createdAt: o -= 5.5 * 3600 * 1e3,
        mine: !0,
        uploadId: l.id,
        asset: { upload: { id: l.id, name: (l.label || "upload") + ".jpg" } }
      });
    }
    const r = e.elements.find((a) => a.type === "image" && /massing|white card|model/i.test(a.label || ""));
    r && s.unshift({
      id: "demo-upload:massing-obj",
      url: r.src,
      w: r.w,
      h: r.h,
      video: !1,
      label: "bonneville-massing.obj",
      createdAt: Date.UTC(2026, 8, 15, 9, 0),
      mine: !0,
      uploadId: "massing-obj",
      asset: { upload: { id: "massing-obj", name: "bonneville-massing.obj", type: "ASSET_3D" } },
      model3d: { url: "data:text/plain;base64," + btoa(yI()), ext: "obj" }
    }), this.ups = s;
  }
  filtered(e) {
    if (!nA(e)) return this.gens;
    const t = e;
    return this.gens.filter((n) => {
      const s = this.facets.get(n.id);
      return !(!s || t.aspect && s.aspect !== t.aspect || t.resolution && s.resolution !== t.resolution || t.tool && s.tool !== t.tool || t.family && s.family !== t.family || t.media && s.media !== t.media || t.board && s.board !== t.board || t.favorited && !n.fav || t.from && s.day < t.from || t.to && s.day > t.to);
    });
  }
  page(e, t) {
    const n = typeof t == "string" && Number(t) || 0, s = e.slice(n, n + Xr).map((r) => ({ ...r })), o = n + Xr;
    return { items: s, next: o < e.length ? String(o) : null };
  }
  generations(e = {}) {
    const t = xm(e.search), n = this.filtered(e.filters);
    return t ? ko({ items: n.filter((s) => xIe(s, t)).slice(0, 200).map((s) => ({ ...s })), next: null }, XA + 240) : ko(this.page(n, e.cursor));
  }
  uploads(e = {}) {
    return ko(this.page(this.ups, e.cursor));
  }
  favorites(e = {}) {
    return ko(this.page(this.gens.filter((t) => t.fav), e.cursor));
  }
  favoriteKeys() {
    return ko(this.gens.filter((e) => e.fav).map((e) => e.id), 120);
  }
  filterOptions() {
    const e = Q4.filter(([, n]) => this.gens.some((s) => {
      var o;
      return ((o = this.facets.get(s.id)) == null ? void 0 : o.family) === n;
    })).map(([, n, s]) => ({ value: n, text: s })), t = Array.from(new Set(this.gens.map((n) => n.model).filter((n) => !!n))).sort().map((n) => ({ value: n, text: n }));
    return ko({
      tools: t,
      families: e,
      media: [{ value: "media-image", text: "Image" }, { value: "media-video", text: "Video" }],
      boards: gIe
    }, 180);
  }
  setFavorite(e, t) {
    const n = this.gens.find((s) => s.id === e.id);
    return n && (n.fav = t), ko(void 0, 120);
  }
  remove(e) {
    return this.gens = this.gens.filter((t) => t.id !== e.id), this.ups = this.ups.filter((t) => t.id !== e.id), ko(void 0, 160);
  }
  /** The harness's uploads land in its Library too. */
  addUpload(e) {
    this.ups = [e, ...this.ups.filter((t) => t.id !== e.id)];
  }
}
var kIe = Object.defineProperty, _Ie = (i, e, t) => e in i ? kIe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, e3 = (i, e, t) => _Ie(i, typeof e != "symbol" ? e + "" : e, t);
const SIe = 200, t3 = 300, MIe = /^ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
function n3(i) {
  return i.length > t3 ? i.slice(0, t3 - 1) + "…" : i;
}
function i3(i) {
  if (i instanceof Error) {
    const e = i.stack ? i.stack.split(`
`).slice(1, 3).map((t) => t.trim()).join(" ") : "";
    return i.name + ": " + i.message + (e ? " (" + e + ")" : "");
  }
  if (typeof i == "string") return i;
  if (i && typeof i == "object")
    try {
      return JSON.stringify(i);
    } catch {
      return String(i);
    }
  return String(i);
}
class TIe {
  constructor() {
    e3(this, "steps", []), e3(this, "released", []);
  }
  record(e, t, n) {
    const s = { at: Date.now(), kind: e, label: n3(t) };
    n && (s.detail = n3(n)), this.steps.push(s), this.steps.length > SIe && this.steps.shift();
  }
  /** Every step kept, oldest first (a copy). */
  list() {
    return this.steps.slice();
  }
  errors() {
    return this.steps.filter((e) => e.kind === "error" || e.kind === "warn");
  }
  /**
   * Keep the page's console errors and warnings, and anything thrown or
   * rejected that nobody caught. The console still prints them as before.
   */
  captureConsole() {
    for (const n of ["error", "warn"]) {
      const s = console[n], o = this, r = function(...a) {
        try {
          o.record(n, a.map(i3).join(" "));
        } catch {
        }
        return s.apply(this, a);
      };
      console[n] = r, this.released.push(() => {
        console[n] === r && (console[n] = s);
      });
    }
    const e = (n) => {
      MIe.test(n.message || "") || this.record("error", "Uncaught: " + (n.message || "an error"), n.filename ? n.filename + ":" + n.lineno : void 0);
    }, t = (n) => this.record("error", "Unhandled rejection: " + i3(n.reason));
    window.addEventListener("error", e), window.addEventListener("unhandledrejection", t), this.released.push(() => {
      window.removeEventListener("error", e), window.removeEventListener("unhandledrejection", t);
    });
  }
  dispose() {
    for (const e of this.released) e();
    this.released = [], this.steps = [];
  }
}
var CIe = Object.defineProperty, IIe = (i, e, t) => e in i ? CIe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Wb = (i, e, t) => IIe(i, typeof e != "symbol" ? e + "" : e, t);
class AIe {
  constructor() {
    Wb(this, "sent", []), Wb(this, "fail", null), Wb(this, "next", 1);
  }
  async submit(e) {
    return this.fail ? { success: !1, message: this.fail } : (this.sent.push(e), { success: !0, id: "memory-" + this.sent.length, number: this.next++ });
  }
}
const PIe = 12e4;
function EIe(i) {
  return !!i && typeof i == "object" && typeof i.success == "boolean";
}
function RIe(i) {
  return {
    async submit(e) {
      const t = await i.functions.httpsCallable("submitBoardFeedback", { timeout: PIe })(e);
      return EIe(t.data) ? t.data : { success: !1, message: "Your report couldn't be sent. Try again in a moment." };
    }
  };
}
var zIe = Object.defineProperty, $Ie = (i, e, t) => e in i ? zIe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Dd = (i, e, t) => $Ie(i, typeof e != "symbol" ? e + "" : e, t);
let qb = 0;
function Ha() {
  return qb = Math.max(Date.now(), qb + 1), qb;
}
class DIe {
  constructor(e) {
    Dd(this, "opts", e), Dd(this, "db"), Dd(this, "me"), Dd(this, "boardId"), Dd(this, "unsubs", []), this.db = e.db, this.me = e.me, this.boardId = e.boardId;
  }
  watchBoard(e) {
    const t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
    let s = !0;
    const o = () => {
      const d = this.db.data, c = [], h = /* @__PURE__ */ new Set();
      for (const x of Object.values(d.threads))
        x.boardId === this.boardId && (h.add(x.id), t.get(x.id) !== x && (t.set(x.id, x), c.push(x)));
      const f = Array.from(t.keys()).filter((x) => !h.has(x));
      for (const x of f) t.delete(x);
      const p = [], y = /* @__PURE__ */ new Set();
      for (const x of Object.values(d.comments))
        x.boardId === this.boardId && (y.add(x.id), n.get(x.id) !== x && (n.set(x.id, x), p.push(x)));
      const v = Array.from(n.keys()).filter((x) => !y.has(x));
      for (const x of v) n.delete(x);
      (s || c.length || f.length) && e.threads(c, f), (p.length || v.length) && e.comments(p, v), s = !1;
    };
    let r = !0;
    queueMicrotask(() => {
      r && o();
    });
    const a = this.db.subscribe(o), l = () => {
      r = !1, a();
    };
    return this.unsubs.push(l), l;
  }
  watchFollowed(e) {
    const t = () => {
      const r = Object.values(this.db.data.threads).filter((a) => a.followers.includes(this.me.uid)).sort((a, l) => l.lastAt - a.lastAt).slice(0, 60);
      e(r);
    };
    let n = !0;
    queueMicrotask(() => {
      n && t();
    });
    const s = this.db.subscribe(t), o = () => {
      n = !1, s();
    };
    return this.unsubs.push(o), o;
  }
  async people() {
    const e = this.opts.people || [];
    return e.length ? { people: [this.me, ...e], scope: "team" } : { people: [this.me], scope: "personal" };
  }
  async checkIn() {
    const e = this.db.data.seen[this.boardId] || {};
    return e[this.me.uid] ? e[this.me.uid] : (this.db.write((t) => {
      t.seen[this.boardId] = { ...t.seen[this.boardId] || {}, [this.me.uid]: 1 }, t.titles[this.boardId] = this.opts.board().title;
    }), 1);
  }
  async createThread(e, t) {
    const n = Ha();
    this.db.write((s) => {
      s.threads[e.id] = { ...e, createdAt: n, lastAt: n, readBy: { ...e.readBy, [this.me.uid]: n } }, s.comments[t.id] = { ...t, createdAt: n }, s.titles[this.boardId] = e.boardTitle;
    });
  }
  async reply(e, t, n) {
    const s = Ha();
    this.db.write((o) => {
      o.comments[t.id] = { ...t, createdAt: s };
      const r = o.threads[e.id];
      r && (o.threads[e.id] = {
        ...r,
        lastAt: s,
        lastBy: t.authorId,
        count: r.count + 1,
        preview: Ep(t),
        followers: Od(r.followers, [t.authorId, ...n]),
        readBy: { ...r.readBy, [t.authorId]: s },
        markedUnread: r.markedUnread.filter((a) => a !== t.authorId),
        resolvedAt: null,
        resolvedBy: null
      });
    });
  }
  async editComment(e, t, n) {
    const s = Ha();
    this.db.write((o) => {
      const r = o.comments[e.id];
      if (!r) return;
      o.comments[e.id] = { ...r, text: e.text, mentions: e.mentions, editedAt: s };
      const a = o.threads[e.threadId];
      a && (o.threads[e.threadId] = { ...a, preview: t || a.preview, followers: Od(a.followers, n) });
    });
  }
  async deleteComment(e, t, n) {
    this.db.write((s) => {
      delete s.comments[e.id];
      const o = s.threads[e.threadId];
      o && (s.threads[e.threadId] = { ...o, count: t, preview: n });
    });
  }
  async deleteThread(e, t) {
    this.db.write((n) => {
      delete n.threads[e];
      for (const s of t) delete n.comments[s];
    });
  }
  async markDeleted(e) {
    this.db.patchThread(e, (t) => t.deletedAt ? t : { ...t, deletedAt: Ha(), deletedBy: this.me.uid });
  }
  async react(e, t, n) {
    const s = this.me.uid;
    this.db.write((o) => {
      const r = o.comments[e.id];
      if (!r) return;
      const a = (r.reactions[s] || []).filter((l) => l !== t);
      n && a.push(t), o.comments[e.id] = { ...r, reactions: { ...r.reactions, [s]: a } };
    });
  }
  async resolve(e, t) {
    this.db.patchThread(e, (n) => ({ ...n, resolvedAt: t ? Ha() : null, resolvedBy: t ? this.me.uid : null }));
  }
  async setColor(e, t) {
    this.db.patchThread(e, (n) => ({ ...n, color: t }));
  }
  async move(e, t) {
    this.db.patchThread(e, (n) => ({ ...n, x: t.x, y: t.y, elementId: t.elementId, ex: t.ex, ey: t.ey, anchorLabel: t.label, anchorThumb: t.thumb }));
  }
  async follow(e, t) {
    const n = this.me.uid;
    this.db.patchThread(e, (s) => ({ ...s, followers: t ? Od(s.followers, [n]) : s.followers.filter((o) => o !== n) }));
  }
  async pin(e, t) {
    const n = this.me.uid;
    this.db.patchThread(e, (s) => ({ ...s, pinnedBy: t ? Od(s.pinnedBy, [n]) : s.pinnedBy.filter((o) => o !== n) }));
  }
  async markRead(e) {
    const t = this.me.uid, n = Ha();
    this.db.write((s) => {
      for (const { id: o } of e) {
        const r = s.threads[o];
        r && (s.threads[o] = { ...r, readBy: { ...r.readBy, [t]: n }, markedUnread: r.markedUnread.filter((a) => a !== t) });
      }
    });
  }
  async markUnread(e) {
    const t = this.me.uid;
    this.db.patchThread(e, (n) => ({ ...n, markedUnread: Od(n.markedUnread, [t]) }));
  }
  async threadComments(e, t) {
    return Object.values(this.db.data.comments).filter((n) => n.boardId === e && n.threadId === t).sort((n, s) => n.createdAt - s.createdAt);
  }
  async boardTitles(e) {
    const t = {};
    for (const n of e) this.db.data.titles[n] && (t[n] = this.db.data.titles[n]);
    return t;
  }
  dispose() {
    for (const e of this.unsubs) e();
    this.unsubs = [];
  }
}
function Od(i, e) {
  const t = i.slice();
  for (const n of e) n && !t.includes(n) && t.push(n);
  return t;
}
const OIe = 8e-4;
function LIe(i, e) {
  const t = i.pad == null ? 8 : i.pad, n = t + (i.padTop || 0);
  let s = null;
  if (i.el) {
    const o = i.el(), r = o ? o.getBoundingClientRect() : null;
    r && (r.width || r.height) && (s = { x: r.left, y: r.top, w: r.width, h: r.height });
  } else if (i.box)
    s = i.box();
  else if (i.world && e) {
    const o = i.world();
    if (o) {
      const r = e.worldToClient(o.x, o.y), a = e.cam.value.zoom;
      s = { x: r.x, y: r.y, w: o.w * a, h: o.h * a };
    }
  }
  return s ? { x: s.x - t, y: s.y - n, w: s.w + t * 2, h: s.h + t + n } : null;
}
function BIe(i, e, t) {
  const n = /* @__PURE__ */ qe([]), s = /* @__PURE__ */ qe([]);
  let o = 0, r = 0;
  const a = /* @__PURE__ */ new Map();
  function l(d) {
    const c = r ? Math.min(0.1, (d - r) / 1e3) : 1;
    r = d;
    const h = t ? 1 : 1 - Math.pow(OIe, c), f = /* @__PURE__ */ new Map(), p = [];
    for (const v of i.value) {
      const x = LIe(v, e.value);
      x && (f.set(v.key, { ...x, r: v.radius == null ? 14 : v.radius, drop: v.drop, look: v.look, ring: v.ring }), p.push({ key: v.key, x: Math.round(x.x), y: Math.round(x.y), w: Math.round(x.w), h: Math.round(x.h) }));
    }
    let y = !1;
    for (const [v, x] of f) {
      let w = a.get(v);
      if (!w) {
        const A = a.size ? [...a.values()][0] : null;
        w = A && !t ? { key: v, x: A.x, y: A.y, w: A.w, h: A.h, r: A.r, open: A.open, drop: x.drop, look: x.look, ring: x.ring } : { key: v, x: x.x + x.w / 2, y: x.y + x.h / 2, w: 0, h: 0, r: x.r, open: t ? 1 : 0, drop: x.drop, look: x.look, ring: x.ring }, a.set(v, w), y = !0;
      }
      const S = w.x + (x.x - w.x) * h, M = w.y + (x.y - w.y) * h, _ = w.w + (x.w - w.w) * h, T = w.h + (x.h - w.h) * h, k = w.r + (Math.min(x.r, x.w / 2, x.h / 2) - w.r) * h, P = w.open + (1 - w.open) * h;
      Math.abs(S - w.x) + Math.abs(M - w.y) + Math.abs(_ - w.w) + Math.abs(T - w.h) + Math.abs(P - w.open) > 0.05 && (y = !0), Object.assign(w, { x: S, y: M, w: _, h: T, r: k, open: P, drop: x.drop, look: x.look, ring: x.ring });
    }
    for (const [v, x] of a) {
      if (f.has(v)) continue;
      y = !0;
      const w = x.x + x.w / 2, S = x.y + x.h / 2;
      x.w += (0 - x.w) * h, x.h += (0 - x.h) * h, x.x = w - x.w / 2, x.y = S - x.h / 2, x.open += (0 - x.open) * h, (x.w < 1 || x.h < 1 || t) && a.delete(v);
    }
    y && (n.value = [...a.values()].map((v) => ({ ...v }))), JSON.stringify(p) !== JSON.stringify(s.value) && (s.value = p), o = requestAnimationFrame(l);
  }
  return ot(() => {
    o = requestAnimationFrame(l);
  }), We(() => {
    o && cancelAnimationFrame(o);
  }), { holes: n, exact: s };
}
const uu = 76, Xo = 16, Xh = 18, Jh = { above: "below", below: "above", left: "right", right: "left" };
function Kb(i, e, t, n) {
  switch (i) {
    case "above":
      return { x: e.x + e.w / 2 - t.w / 2, y: e.y - t.h - Xh };
    case "below":
      return { x: e.x + e.w / 2 - t.w / 2, y: e.y + e.h + Xh };
    case "left":
      return { x: e.x - t.w - Xh, y: e.y + e.h / 2 - t.h / 2 };
    case "right":
      return { x: e.x + e.w + Xh, y: e.y + e.h / 2 - t.h / 2 };
    case "right-edge":
      return { x: n.w - t.w - 24, y: e.y + e.h / 2 - t.h / 2 };
    case "left-edge":
      return { x: 24, y: e.y + e.h / 2 - t.h / 2 };
    case "top-right":
      return { x: n.w - t.w - 24, y: uu + 6 };
    case "bottom-left":
      return { x: 24, y: n.h - t.h - Xo };
    case "bottom-right":
      return { x: n.w - t.w - 24, y: n.h - t.h - Xo };
    case "bottom-center":
      return { x: n.w / 2 - t.w / 2, y: n.h - t.h - 108 };
    default:
      return { x: n.w / 2 - t.w / 2, y: n.h / 2 - t.h / 2 };
  }
}
function FIe(i, e, t) {
  return i.x >= Xo && i.y >= uu && i.x + e.w <= t.w - Xo && i.y + e.h <= t.h - Xo;
}
const Yb = (i, e, t) => ({
  x: Math.max(Xo, Math.min(t.w - e.w - Xo, i.x)),
  y: Math.max(uu, Math.min(t.h - e.h - Xo, i.y))
});
function NIe(i, e) {
  return i.x < e.x + e.w && e.x < i.x + i.w && i.y < e.y + e.h && e.y < i.y + i.h;
}
const UIe = ["below", "above", "right", "left", "bottom-left", "bottom-right", "top-right", "right-edge", "left-edge"];
function GIe(i, e, t, n, s = []) {
  if (!e && !(i === "top-right" || i === "bottom-center")) return { ...Yb(Kb("center", { x: 0, y: 0, w: 0, h: 0 }, t, n), t, n), side: "center" };
  const r = e || { x: 0, y: 0, w: 0, h: 0 }, a = [i];
  if (Jh[i] && a.push(Jh[i]), e)
    for (const c of UIe) a.includes(c) || a.push(c);
  const l = e ? [...s, e] : s, d = (c) => !l.some((h) => NIe({ x: c.x, y: c.y, w: t.w, h: t.h }, h));
  for (const c of a) {
    const h = Kb(c, r, t, n), f = c === i || c === Jh[i] ? Yb(h, t, n) : h;
    if ((c === i || c === Jh[i] || FIe(f, t, n)) && d(f)) return { ...f, side: c };
  }
  return { ...Yb(Kb(i, r, t, n), t, n), side: i };
}
function s3(i) {
  if (!i.length) return null;
  const e = Math.min(...i.map((o) => o.x)), t = Math.min(...i.map((o) => o.y)), n = Math.max(...i.map((o) => o.x + o.w)), s = Math.max(...i.map((o) => o.y + o.h));
  return { x: e, y: t, w: n - e, h: s - t };
}
const Wn = { w: 1180, h: 620, bar: 44, shown: 540 }, JA = { w: Wn.w, h: Wn.h - Wn.bar }, Uf = { x: JA.w / 2, y: 217 }, Y0 = Wn.shown - Wn.bar - 16, Ys = { w: 600, h: 138, x: (JA.w - 600) / 2, y: Y0 - 138 }, Fo = { x: Ys.x + 54, y: Ys.y + 12, w: 44, h: 44 }, ec = { x: Ys.x + Ys.w - 12 - 62, y: Ys.y + Ys.h - 12 - 30, w: 62, h: 30 }, Dp = "https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-", Qt = (i) => Dp + i + "-400w.webp", pt = {
  whiteCard: Qt("e05-option-a-white-card-model-c61989"),
  golden: Qt("t03-autumn-golden-hour-3768d6"),
  dusk: Qt("t07-alpenglow-dusk-1d0baa"),
  blueHour: Qt("t04-winter-blue-hour-50f063"),
  night: Qt("t06-night-facade-lighting-69ccb0"),
  aerial: Qt("s01-existing-site-aerial-f3aa4c"),
  depot: Qt("s02-existing-depot-street-7c94e0"),
  creek: Qt("s03-existing-buried-creek-channel-160598"),
  sketchCanyon: Qt("e02-option-b-sketch-canyon-374663"),
  sketchSalt: Qt("e03-option-c-sketch-salt-11df63"),
  sketchShore: Qt("e01-option-a-sketch-shoreline-c101a0"),
  whiteCardSet: Qt("e04-white-card-options-a-b-c-1713cd"),
  lobbyModel: Qt("i01-lobby-white-model-d9fd93"),
  optionB: Qt("e06-option-b-render-parked-80d4c0"),
  optionC: Qt("e07-option-c-render-parked-e0c191"),
  watercolor: Qt("e08-option-a-watercolor-db5917"),
  openCrown: Qt("e10-hero-v2-open-crown-4a3b4d"),
  terraces: Qt("e12-hero-v3-deeper-terraces-1c4ede"),
  brickPodium: Qt("e15-hero-v4-brick-podium-11449d"),
  lobby: Qt("i02-lobby-v1-geometry-materials-ef49f9"),
  lobbyBright: Qt("i06-lobby-v4-competition-brightening-34918a"),
  masterplan: Qt("l02-watercolor-masterplan-6b0e55"),
  creekWalk: Qt("l04-creek-walk-marketing-hero-92d17d"),
  gardens: Qt("l08-daytime-gardens-with-people-8fb7f2"),
  dollyIn: Dp + "v02-hero-dolly-in-88196408-poster-400w.webp",
  dayToNight: Dp + "v03-aerial-day-to-night-time-lapse-744df3b5-poster-400w.webp",
  skyLounge: Dp + "v06-sky-lounge-sunset-time-lapse-a0a91aee-poster-400w.webp"
}, _o = { w: 252, h: 160 }, zs = [0, 1304, 2608], $s = [0, 470, 1e3], Ds = 1164, ZA = [
  { title: "Site photos", x: zs[0], y: $s[0], w: Ds, h: 300 },
  { title: "Massing sketches", x: zs[1], y: $s[0], w: Ds, h: 300 },
  { title: "White card models", x: zs[2], y: $s[0], w: Ds, h: 300 },
  { title: "Direction renders", x: zs[0], y: $s[1], w: Ds, h: 330 },
  { title: "Hero options", x: zs[1], y: $s[1], w: Ds, h: 330 },
  { title: "Facade iterations", x: zs[2], y: $s[1], w: Ds, h: 330 },
  { title: "Lobby", x: zs[0], y: $s[2], w: Ds, h: 300 },
  { title: "Bench Gardens", x: zs[1], y: $s[2], w: Ds, h: 300 },
  { title: "Motion", x: zs[2], y: $s[2], w: Ds, h: 300 }
], QA = ZA[4], Tl = { id: "white-card", src: pt.whiteCard, x: 1608, y: 500, w: 150, h: 200 }, No = [
  { id: "golden", src: pt.golden, x: 1798, y: 500, w: 150, h: 200 },
  { id: "dusk", src: pt.dusk, x: 1962, y: 500, w: 150, h: 200 },
  { id: "blue-hour", src: pt.blueHour, x: 2126, y: 500, w: 150, h: 200 },
  { id: "night", src: pt.night, x: 2290, y: 500, w: 150, h: 200 }
], eP = [
  { id: "aerial", src: pt.aerial, x: 304, y: 30, w: 260, h: 146 },
  { id: "depot", src: pt.depot, x: 578, y: 30, w: 260, h: 146 },
  { id: "creek", src: pt.creek, x: 852, y: 30, w: 260, h: 146 },
  { id: "sketch-canyon", src: pt.sketchCanyon, x: 1332, y: 30, w: 180, h: 240 },
  { id: "sketch-salt", src: pt.sketchSalt, x: 1526, y: 30, w: 180, h: 240 },
  { id: "sketch-shore", src: pt.sketchShore, x: 1720, y: 30, w: 180, h: 240 },
  { id: "white-card-set", src: pt.whiteCardSet, x: 2912, y: 30, w: 400, h: 225 },
  { id: "lobby-model", src: pt.lobbyModel, x: 3326, y: 30, w: 400, h: 225 },
  { id: "option-b", src: pt.optionB, x: 304, y: 500, w: 200, h: 267 },
  { id: "option-c", src: pt.optionC, x: 518, y: 500, w: 200, h: 267 },
  { id: "watercolor", src: pt.watercolor, x: 732, y: 500, w: 200, h: 267 },
  Tl,
  { id: "open-crown", src: pt.openCrown, x: 2636, y: 500, w: 200, h: 267 },
  { id: "terraces", src: pt.terraces, x: 2850, y: 500, w: 200, h: 267 },
  { id: "brick-podium", src: pt.brickPodium, x: 3064, y: 500, w: 200, h: 267 },
  { id: "lobby", src: pt.lobby, x: 304, y: 1030, w: 316, h: 236 },
  { id: "lobby-bright", src: pt.lobbyBright, x: 634, y: 1030, w: 316, h: 236 },
  { id: "masterplan", src: pt.masterplan, x: 1332, y: 1030, w: 316, h: 237 },
  { id: "creek-walk", src: pt.creekWalk, x: 1662, y: 1030, w: 400, h: 225 },
  { id: "gardens", src: pt.gardens, x: 2076, y: 1030, w: 364, h: 205 },
  { id: "dolly-in", src: pt.dollyIn, x: 2912, y: 1030, w: 180, h: 240, video: !0 },
  { id: "day-to-night", src: pt.dayToNight, x: 3106, y: 1030, w: 300, h: 169, video: !0 },
  { id: "sky-lounge", src: pt.skyLounge, x: 3420, y: 1030, w: 300, h: 169, video: !0 }
], ti = { id: "hero", kind: "Image", model: "Nano Banana Pro", name: "Hero options", x: 1332, y: 500, thumbs: [], foot: "No runs yet" }, tP = [
  { id: "site", kind: "Image", model: "Nano Banana Pro", name: "Site photos", x: 28, y: 30, thumbs: [pt.aerial, pt.depot, pt.creek], foot: "Updated Sep 2" },
  { id: "sketch", kind: "Image", model: "Nano Banana 2", name: "Sketch options", x: 1928, y: 30, thumbs: [pt.sketchCanyon, pt.sketchSalt, pt.sketchShore], foot: "Updated Sep 4" },
  { id: "white", kind: "Image", model: "Seedream 5 Lite", name: "White card", x: 2636, y: 30, thumbs: [pt.whiteCardSet, pt.lobbyModel], foot: "Updated Sep 5" },
  { id: "directions", kind: "Image", model: "Nano Banana 2", name: "Directions", x: 28, y: 500, thumbs: [pt.optionB, pt.optionC, pt.watercolor], foot: "Updated Sep 6" },
  ti,
  { id: "facade", kind: "Image", model: "Nano Banana Pro", name: "Facade", x: 3292, y: 500, thumbs: [pt.openCrown, pt.terraces, pt.brickPodium], foot: "Updated Sep 9" },
  { id: "lobby", kind: "Image", model: "Nano Banana 2", name: "Lobby", x: 28, y: 1030, thumbs: [pt.lobby, pt.lobbyBright], foot: "Updated Sep 11" },
  { id: "motion", kind: "Video", model: "Kling 2.6 Pro", name: "Hero dolly-in", x: 2636, y: 1030, thumbs: [pt.dollyIn, pt.dayToNight, pt.skyLounge], foot: "Updated Sep 12" }
], Zh = { id: "cover", text: "Golden hour for the cover. Client review Thursday.", by: "MT", tint: "amethyst", x: 1332, y: 676, w: 252, h: 96 }, nP = [
  { id: "creek", text: "Option B reads best from the creek.", by: "KB", tint: "amber", x: 2194, y: 30, w: 246, h: 120 },
  { id: "canyon", text: "Canyon for the competition entry.", by: "JR", tint: "rose", x: 946, y: 500, w: 190, h: 120 },
  { id: "podium", text: "Brick podium is the keeper.", by: "MT", tint: "mint", x: 3292, y: 676, w: 252, h: 96 }
], X0 = "Photoreal, at golden hour, dusk, blue hour and night";
function J0(i) {
  const e = (t, n) => t >= i.x && t < i.x + i.w && n >= i.y && n < i.y + i.h;
  return eP.filter((t) => e(t.x, t.y)).length + tP.filter((t) => e(t.x, t.y)).length + nP.filter((t) => e(t.x, t.y)).length;
}
const Qh = { x: 1886, y: 650 }, jIe = 0.6;
function HIe(i, e = 0) {
  const t = i.x + (i.w || 0) / 2, n = i.y + (i.h || 0) / 2, s = Math.hypot(Qh.x, Qh.y), o = jIe * Math.pow(Math.min(1, Math.hypot(t - Qh.x, n - Qh.y) / s), 0.85) - e;
  return Math.max(0, Math.round(o * 1e3) / 1e3);
}
const tc = { fx: 1886, fy: 628, z: 0.29 }, Op = { fx: 1886, fy: 653, z: 0.9 };
function VIe(i, e, t) {
  return { x: Uf.x + (e - i.fx) * i.z, y: Uf.y + (t - i.fy) * i.z };
}
function Z0(i, e, t) {
  return { fx: i.fx + (e.fx - i.fx) * t, fy: i.fy + (e.fy - i.fy) * t, z: i.z * Math.pow(e.z / i.z, t) };
}
function Uo(i, e, t, n) {
  const s = 3 * i, o = 3 * (t - i) - s, r = 1 - s - o, a = 3 * e, l = 3 * (n - e) - a, d = 1 - a - l, c = (p) => ((r * p + o) * p + s) * p, h = (p) => ((d * p + l) * p + a) * p, f = (p) => (3 * r * p + 2 * o) * p + s;
  return (p) => {
    if (p <= 0) return 0;
    if (p >= 1) return 1;
    let y = p;
    for (let w = 0; w < 8; w++) {
      const S = c(y) - p;
      if (Math.abs(S) < 1e-6) return h(y);
      const M = f(y);
      if (Math.abs(M) < 1e-6) break;
      y -= S / M;
    }
    let v = 0, x = 1;
    y = p;
    for (let w = 0; w < 30; w++) {
      const S = c(y);
      if (Math.abs(S - p) < 1e-6) break;
      S < p ? v = y : x = y, y = (v + x) / 2;
    }
    return h(y);
  };
}
const Je = {
  /** the camera's dive: slow away, slow to rest */
  dive: Uo(0.65, 0, 0.3, 1),
  /** the pull back: it eases away, then settles over a long tail */
  settle: Uo(0.5, 0, 0.12, 1),
  /** the pointer: quick to start, gentle to arrive */
  move: Uo(0.4, 0, 0.2, 1),
  /** the board's --ease-out-soft: things arriving */
  out: Uo(0.16, 1, 0.3, 1),
  linear: (i) => i,
  sine: (i) => 0.5 - 0.5 * Math.cos(Math.PI * i)
}, hu = (i) => i < 0 ? 0 : i > 1 ? 1 : i;
function Ge(i, e, t, n = Je.linear) {
  return n(hu((i - e) / (t - e)));
}
function WIe(i) {
  const t = i - 1;
  return 1 + t * t * ((1.9 + 1) * t + 1.9);
}
const Lp = 30, je = {
  zoomIn: [1.2, 3.8],
  cursorIn: [3.9, 4.2],
  toSession: [4, 4.7],
  clickSession: 4.75,
  promptOpen: [4.8, 5.3],
  toWhiteCard: [5.45, 6.05],
  /** Shift goes down: the keycap shows beside the pointer */
  shift: 6.05,
  /** the press on the model: its copy lifts */
  press: 6.2,
  drag: [6.25, 7.05],
  drop: 7.1,
  type: [7.4, 9.4],
  toRun: [9.5, 10],
  run: 10.05,
  land: 11.95,
  toHeart: [12.65, 13.25],
  heart: 13.35,
  note: 14.05,
  toEmpty: [14.85, 15.45],
  deselect: 15.5,
  promptClose: [15.55, 16],
  cursorOut: [15.75, 16.15],
  zoomOut: [16.05, 19.65],
  sheen: [21.2, 23.9],
  /** the run's additions leave, while the board is small, ready for the next loop */
  reset: [28.2, 29.2]
}, o3 = 14.75;
function qIe(i) {
  return i < je.zoomIn[0] ? tc : i < je.zoomIn[1] ? Z0(tc, Op, Ge(i, je.zoomIn[0], je.zoomIn[1], Je.dive)) : i < je.zoomOut[0] ? Op : i < je.zoomOut[1] ? Z0(Op, tc, Ge(i, je.zoomOut[0], je.zoomOut[1], Je.settle)) : tc;
}
function Xb(i, e) {
  return VIe(Op, i, e);
}
const wi = {
  start: { x: 760, y: 262 },
  session: Xb(ti.x + 132, ti.y + 50),
  whiteCard: Xb(Tl.x + 78, Tl.y + 112),
  slot: { x: Fo.x + Fo.w / 2 + 2, y: Fo.y + Fo.h / 2 + 2 },
  run: { x: ec.x + ec.w / 2 + 4, y: ec.y + ec.h / 2 + 3 },
  heart: Xb(No[0].x + 17, No[0].y + 17),
  // clear canvas, below Hero options and right of the prompt
  empty: { x: 968, y: 398 }
}, KIe = [
  { at: je.toSession, from: wi.start, to: wi.session, arc: 0.12 },
  { at: je.toWhiteCard, from: wi.session, to: wi.whiteCard, arc: -0.1 },
  { at: je.drag, from: wi.whiteCard, to: wi.slot, arc: 0.16 },
  { at: je.toRun, from: wi.slot, to: wi.run, arc: -0.08 },
  { at: je.toHeart, from: wi.run, to: wi.heart, arc: 0.1 },
  { at: je.toEmpty, from: wi.heart, to: wi.empty, arc: -0.12 }
];
function Jb(i) {
  let e = wi.start;
  for (const t of KIe) {
    if (i < t.at[0]) return e;
    if (i < t.at[1]) {
      const n = Ge(i, t.at[0], t.at[1], Je.move), s = t.to.x - t.from.x, o = t.to.y - t.from.y, r = Math.sin(Math.PI * n) * t.arc;
      return { x: t.from.x + s * n - o * r, y: t.from.y + o * n + s * r };
    }
    e = t.to;
  }
  return e;
}
const iP = [je.clickSession, je.run, je.heart, je.deselect], r3 = (() => {
  const i = Array.from(X0, (s, o) => {
    const r = X0[o - 1], a = (Math.sin(o * 12.9898) * 43758.5453 % 1 + 1) % 1;
    return (r === "," ? 3.2 : r === " " ? 1.5 : 1) * (0.82 + 0.36 * a);
  }), e = i.reduce((s, o) => s + o, 0), t = je.type[1] - je.type[0];
  let n = 0;
  return i.map((s) => (n += s, je.type[0] + n / e * t));
})();
function YIe(i) {
  if (i < je.type[0] || i >= je.reset[1]) return 0;
  let e = 0;
  for (; e < r3.length && r3[e] <= i; ) e++;
  return e;
}
function XIe(i, e, t, n) {
  return i < e || i > t ? 0 : Math.min(hu((i - e) / n), hu((t - i) / n));
}
function JIe(i) {
  for (const e of iP) if (i >= e - 0.02 && i < e + 0.14) return 1;
  return i >= je.press && i < je.drop ? 1 : 0;
}
function ep(i) {
  const e = (i % Lp + Lp) % Lp, t = qIe(e), n = 1 - Ge(e, je.reset[0], je.reset[1], Je.sine), s = e >= je.land && e < je.reset[1], o = Jb(e), r = Math.min(Ge(e, je.cursorIn[0], je.cursorIn[1], Je.sine), 1 - Ge(e, je.cursorOut[0], je.cursorOut[1], Je.sine));
  let a = { x: o.x, y: o.y, shown: 0, size: 0 };
  for (const F of iP)
    if (e >= F && e < F + 0.5) {
      const te = (e - F) / 0.5;
      a = { x: Jb(F).x, y: Jb(F).y, shown: 0.42 * (1 - te), size: 0.45 + 0.75 * Je.out(te) };
    }
  const l = Ge(e, je.press, je.press + 0.2, Je.out), d = Ge(e, je.drop, je.drop + 0.18, Je.sine), c = Ge(e, je.drag[1] - 0.3, je.drag[1], Je.sine), h = {
    x: o.x,
    y: o.y,
    shown: e >= je.press && e < je.drop + 0.18 ? l * (1 - d) : 0,
    tilt: -7 * (1 - c),
    ring: c
  }, f = Ge(e, je.promptOpen[0], je.promptOpen[1], Je.out) * (1 - Ge(e, je.promptClose[0], je.promptClose[1], Je.sine)), p = YIe(e), y = e >= je.type[0] && e < je.type[1] + 0.05, v = (F) => Math.floor((e - F) / 0.53) % 2 === 0 ? 1 : 0;
  let x = 0;
  f > 0.5 && e < je.run && (x = y ? 1 : v(e < je.type[0] ? je.promptOpen[1] : je.type[1]));
  const w = e >= je.drop && e < je.promptClose[1] ? Ge(e, je.drop, je.drop + 0.55, Je.out) : 0, S = e - je.drop, M = w > 0 && S < 5 ? Math.min(hu(S / 0.6), hu((5 - S) / 1)) * (0.55 + 0.45 * Math.sin(S / 2.5 * Math.PI * 2 - Math.PI / 2)) : 0, _ = e >= je.promptClose[1] ? 0 : Ge(e, je.type[0], je.type[0] + 0.25, Je.sine), T = e >= je.run - 0.02 && e < je.run + 0.14 ? 1 : 0, k = e >= je.run && e < je.land, P = Ge(e, je.clickSession, je.clickSession + 0.18) * (1 - Ge(e, je.deselect, je.deselect + 0.18));
  let A = ti.foot;
  k ? A = "Generating… 0:0" + Math.floor(e - je.run) : s && e < je.reset[0] && (A = "Updated just now");
  const R = (F) => s ? Ge(e, je.land + F * 0.08, je.land + F * 0.08 + 0.65, Je.out) * n : 0, D = No.map((F, te) => R(te)), O = e >= je.note && e < je.reset[1];
  return {
    cam: t,
    pointer: { x: o.x, y: o.y, shown: r, pressed: JIe(e), shift: XIe(e, je.shift, je.drop + 0.3, 0.15) },
    ripple: a,
    ghost: h,
    dock: 1 - f,
    prompt: f,
    refIn: w,
    refGlow: M,
    typed: p,
    caret: x,
    runLit: _,
    runPressed: T,
    runBusy: k,
    sessionSelected: P,
    sessionFoot: A,
    sessionThumbs: D,
    sessionCount: s ? 4 : 0,
    shimmer: k,
    results: D,
    heart: e >= je.heart && e < je.reset[1] ? WIe(Ge(e, je.heart, je.heart + 0.38)) * n : 0,
    note: O ? Ge(e, je.note, je.note + 0.65, Je.out) * n : 0,
    frameItems: J0(QA) + (s && e < je.reset[0] ? No.length : 0) + (O && e < je.reset[0] ? 1 : 0),
    sheen: e >= je.sheen[0] && e < je.sheen[1] ? Ge(e, je.sheen[0], je.sheen[1], Je.sine) : -1
  };
}
const xx = [
  { id: "board", label: "Board" },
  { id: "session", label: "Sessions" },
  { id: "generate", label: "Generate" },
  { id: "studio", label: "Studio view" },
  { id: "edit", label: "Edit" },
  { id: "chat", label: "Chat" },
  { id: "finish", label: "Finish" }
], sP = "Bonneville Tower", ZIe = "Client review Thursday: a hero render from Depot Street. Planted terraces, the mountains behind.", QIe = "MT", a3 = "Bonneville Tower from Depot Street, planted timber terraces, a glass crown, the Wasatch behind, photoreal", l3 = "Make it night, with warm light in every window", d3 = 4, eAe = "https://cdn.rundiffusion.com/file/rd-web-assets/mcp-asset-library/_mcp/bonneville-tower-demo/bonneville-tower-", Ji = (i) => eAe + i + "-800w.webp", Cu = [
  { id: "site-aerial", src: Ji("s01-existing-site-aerial-f3aa4c"), label: "Site aerial" },
  { id: "site-depot", src: Ji("s02-existing-depot-street-7c94e0"), label: "Depot Street today" },
  { id: "site-creek", src: Ji("s03-existing-buried-creek-channel-160598"), label: "Buried creek channel" }
], Gf = [
  { src: Ji("t03-autumn-golden-hour-3768d6"), label: "Golden hour" },
  { src: Ji("t01-spring-noon-3be8a4"), label: "Spring noon" },
  { src: Ji("t07-alpenglow-dusk-1d0baa"), label: "Alpenglow" },
  { src: Ji("e12-hero-v3-deeper-terraces-1c4ede"), label: "Deeper terraces" }
], nc = { src: Ji("t06-night-facade-lighting-69ccb0"), label: "Night, windows lit" }, Va = { w: 300, h: 402 }, tAe = "Show this tower in each of these site photos", oP = "Nano Banana Pro", Wa = {
  title: "The finished tower, from each site photo",
  session: "Site photos, finished",
  prompt: "Image 1 is a photo of the site; image 2 is the tower designed for it. Show this site with the tower finished, from image 1's viewpoint and in its light: the tower's planted timber terraces and glass crown, green streets, the buried creek opened up as a park. Photorealistic architectural photograph.",
  why: "It keeps each photo's viewpoint and light, so every view lines up with the site",
  /** the runs' shape: the site photos' own */
  size: "16:9"
}, nAe = "I can see a render of the tower and three site photos in this frame: the aerial, Depot Street today and the buried creek channel. I'll give each photo to " + oP + " with the tower render, one run per photo, so you see the tower finished from every viewpoint.", iAe = "Done: three views, set out in the frame under the session. From Depot Street the tower sits just out of the photo, so that one shows the planted street instead. Open the session to change its prompt or run it again.", Q0 = {
  "site-aerial": { src: Ji("s06-masterplan-aerial-55b63e"), label: "Aerial, finished" },
  "site-depot": { src: Ji("l09-greener-depot-street-a56204"), label: "Depot Street, finished" },
  "site-creek": { src: Ji("l04-creek-walk-marketing-hero-92d17d"), label: "Creek walk, finished" }
}, Wi = [
  {
    id: "welcome",
    chapter: "board",
    eyebrow: "Welcome to Boards",
    title: "Every project, on one board",
    body: "A board is an endless space for a project: the images, the AI sessions that make them, and the notes around them, side by side. Let's make your first image together. It takes about three minutes.",
    kind: "continue",
    demo: "board",
    place: "center"
  },
  {
    id: "look",
    chapter: "board",
    title: "Here's your brief",
    body: "This practice board holds the site photos for " + sP + " and a note from the client. Let's make the render they asked for. Nothing here is saved, and nothing costs tokens.",
    kind: "continue",
    place: "below"
  },
  {
    id: "add-session",
    hint: "Use the glowing + button, in the bar at the bottom, then Image",
    chapter: "session",
    title: "Start a tool session",
    body: "A session is an AI tool that lives on your board. It keeps its model, your prompt and every image it makes, all in one place.",
    task: "Click **+** and choose **Image**",
    kind: "click",
    demo: "session",
    place: "above"
  },
  {
    id: "open-session",
    hint: "Click the session card that's lit up",
    chapter: "session",
    title: "Open it to write a prompt",
    body: "Your session is on the board, beside the brief. Click any session to open its prompt, and click the board to put it away.",
    task: "Click the session",
    kind: "click",
    demo: "open",
    place: "right"
  },
  {
    id: "tab-prompt",
    hint: "Press the Tab key on your keyboard",
    chapter: "generate",
    title: "Write the prompt with Tab",
    body: "Say what to make: the subject, where it stands, the light. We've drafted this one from the brief.",
    task: "Press **Tab** to write it in",
    kind: "tab",
    demo: "prompt",
    place: "above"
  },
  {
    id: "run",
    hint: "Click Run, at the prompt's bottom right",
    chapter: "generate",
    title: "Run it",
    body: "Run sends your prompt to the model. This session makes four images at a time, so you can pick the best.",
    task: "Click **Run**",
    kind: "run",
    demo: "run",
    place: "above",
    waiting: { title: "Making your images", body: "A real run takes about half a minute. This practice one is quicker." },
    landed: { title: "Your four images are in", body: "Four takes on the brief, each in its own light." }
  },
  {
    id: "results",
    chapter: "generate",
    title: "Four options, kept in the session",
    body: "Each image lands in its session: on the card, and in the gallery on the right. Open the session any time to find them again.",
    kind: "continue",
    // the run's own demonstration carries on (it shows just this), so the card holds still as the words change
    demo: "run",
    place: "left"
  },
  {
    id: "drag",
    hint: "Hold a picture in the gallery, then drag it onto the board",
    chapter: "generate",
    title: "Put one on the board",
    body: "Drag a picture out of the gallery to lay it out on the board, beside the session it came from. The session keeps every image either way.",
    task: "Drag an image onto the board",
    kind: "drag",
    demo: "drag",
    place: "left"
  },
  {
    id: "studio-open",
    hint: "Click Studio, at the prompt's top right",
    chapter: "studio",
    title: "Studio view: the session, full screen",
    body: "Studio view gives a session the whole screen: the picture large, its versions above it, and every editing tool beside it.",
    task: "Click **Studio**",
    kind: "click",
    demo: "studio",
    place: "above"
  },
  {
    id: "edit-side",
    hint: "Click Edit, at the top left",
    chapter: "edit",
    title: "Switch to Edit",
    body: "Generate makes new images from words. Edit changes the picture in the viewer.",
    task: "Click **Edit**",
    kind: "click",
    demo: "edit",
    place: "top-right"
  },
  {
    id: "edit-tab",
    hint: "Press the Tab key on your keyboard",
    chapter: "edit",
    title: "Say what changes",
    body: "Plain words are enough. To change just one part, paint over it first so the model knows where to focus.",
    task: "Press **Tab** to write it in",
    kind: "tab",
    place: "top-right"
  },
  {
    id: "edit-run",
    hint: "Click Run, under the picture",
    chapter: "edit",
    title: "Run the edit",
    body: "The edit becomes a new version of the picture, and the one you started from is kept.",
    task: "Click **Run**",
    kind: "run",
    place: "top-right",
    waiting: { title: "Making the new version", body: "Same building, same view. Only what you asked for changes." },
    landed: { title: "Your new version is in", body: "Night, with warm light in every window, as you asked." }
  },
  {
    id: "edit-result",
    chapter: "edit",
    title: "Same building, new light",
    body: "Every edit is a version you can step through above the picture, or split two to compare. Relight, Change camera and Upscale wait in the list on the left.",
    kind: "continue",
    place: "top-right"
  },
  {
    id: "chat-open",
    hint: "Click Chat, on the bar over the Site photos frame",
    chapter: "chat",
    // the tour closes Studio view on the way here (TourController), so this says it did
    note: { did: "We closed Studio view for you", how: "To close it yourself, press **Esc** or click the back arrow at its top left." },
    title: "Hand a chat the work",
    body: "A chat lives in a frame, and everything in the frame is what it works with: here, the three site photos and the tower render we've added beside them. Say what you need, and it sets up the sessions and runs them for you.",
    task: "Click **Chat** on the frame",
    kind: "click",
    demo: "chat",
    place: "right"
  },
  {
    id: "chat-tab",
    hint: "Press the Tab key on your keyboard",
    chapter: "chat",
    title: "Ask in plain words",
    body: "Say it the way you'd ask a colleague. It sees the photos, so you only say what you want from them.",
    task: "Press **Tab** to write it in",
    kind: "tab",
    place: "left"
  },
  {
    id: "chat-send",
    hint: "Press Enter, or click the arrow under the message",
    chapter: "chat",
    title: "Send it",
    body: "It reads the frame first, then answers with a plan.",
    task: "Press **Enter** to send it",
    kind: "run",
    place: "left",
    waiting: { title: "Reading the frame", body: "It looks at each photo, then works out the session, its prompt and what it costs." },
    landed: { title: "Here's its plan", body: "One session and a run per photo, with what it would cost. Nothing has run yet." }
  },
  {
    id: "chat-run",
    hint: "Click Run plan, at the bottom of the plan",
    chapter: "chat",
    title: "Nothing runs until you say so",
    body: "A plan shows its sessions, the prompt it wrote and the cost before anything is spent. One click runs the lot.",
    task: "Click **Run plan**",
    kind: "run",
    place: "left",
    waiting: { title: "Working in the frame", body: "It adds the session, gives it each photo in turn and runs it. Watch the frame." },
    landed: { title: "Every photo, finished", body: "A new picture from each viewpoint, set out in the frame under the session that made it." }
  },
  {
    id: "chat-result",
    chapter: "chat",
    title: "Its work is yours to change",
    body: "What the chat made is an ordinary session in the frame: open it to change the prompt or run it again. Anyone on the board can open the chat and carry on.",
    kind: "continue",
    place: "left"
  },
  {
    id: "organize",
    chapter: "finish",
    title: "Keep the whole project together",
    body: "Frames group the work, notes keep decisions beside it, and comments start a conversation right on the board. Press F for a frame and N for a note.",
    kind: "continue",
    demo: "organize",
    place: "bottom-center"
  },
  {
    id: "finale",
    chapter: "finish",
    title: "You're ready",
    body: "",
    kind: "continue",
    place: "center"
  }
];
function Mm(i) {
  const e = Wi.find((t) => t.id === i);
  if (!e) throw new Error("No tour step " + i);
  return e;
}
function sAe(i) {
  return xx.findIndex((e) => e.id === i);
}
function wx(i) {
  const e = (i.title || "").trim();
  return !e || /^untitled board$/i.test(e) ? "your new board" : e;
}
function oAe(i, e) {
  return i === "first-board" && e ? "Take a three-minute tour of how a board works before you start on " + wx(e) + ". You'll make an image, edit it, ask a chat to run some work for you, and see where your results go. Nothing here is saved, and nothing costs tokens." : i === "replay" ? "Everything a board does, in about three minutes. You'll make an image, edit it, ask a chat to run some work for you, and see where your results go. Nothing here is saved, and nothing costs tokens." : Mm("welcome").body;
}
function rAe(i) {
  return i === "replay" ? "Start" : "Start the tour";
}
function aAe(i, e) {
  if (i === "first-board" && e) {
    const t = wx(e);
    return "That's the heart of Boards: sessions on the board, Tab to write a prompt, Studio view to edit, and a chat to do the legwork. " + t.charAt(0).toUpperCase() + t.slice(1) + " is ready for you.";
  }
  return i === "replay" ? "That's the tour: sessions on the board, Tab to write a prompt, Studio view to edit, and a chat to do the legwork. Your boards are right where you left them." : "That's the heart of Boards: sessions on the board, Tab to write a prompt, Studio view to edit, and a chat to do the legwork. Your first board is one click away.";
}
const lAe = [
  "Sessions live on your board",
  "Tab writes a prompt",
  "Every image stays in its session",
  "Studio view edits in place",
  "A chat works with its frame"
];
function dAe(i, e) {
  if (i === "new-account") return { label: "Create my first board", exit: "create-board" };
  if (e) {
    const t = wx(e) === "your new board";
    return i === "first-board" ? { label: t ? "Open my board" : "Open " + e.title, exit: "open-board" } : { label: t ? "Back to my board" : "Back to " + e.title, exit: "open-board" };
  }
  return { label: "Done", exit: "leave" };
}
function c3(i) {
  const e = [], t = /\*\*([^*]+)\*\*/g;
  let n = 0, s;
  for (; s = t.exec(i); )
    s.index > n && e.push({ text: i.slice(n, s.index), strong: !1 }), e.push({ text: s[1], strong: !0 }), n = s.index + s[0].length;
  return n < i.length && e.push({ text: i.slice(n), strong: !1 }), e;
}
const So = { w: 640, h: 360 }, u3 = (i) => i < 0 ? 0 : i > 1 ? 1 : i, oa = (i) => ({ x: i.x + i.w / 2, y: i.y + i.h / 2 });
function no(i, e, t, n = 0.3, s = 0.3) {
  return i < e || i > t ? 0 : Math.min(u3((i - e) / n), u3((t - i) / s));
}
function ur(i, e, t, n, s, o = []) {
  let r = e, a = e, l = !1;
  for (const h of t) {
    if (i < h.at[0]) {
      a = r, l = !0;
      break;
    }
    if (i < h.at[1]) {
      const f = Ge(i, h.at[0], h.at[1], Je.move), p = h.to.x - r.x, y = h.to.y - r.y, v = Math.sin(Math.PI * f) * (h.arc == null ? 0.1 : h.arc);
      a = { x: r.x + p * f - y * v, y: r.y + y * f + p * v }, l = !0;
      break;
    }
    r = h.to;
  }
  l || (a = r);
  let d = { x: a.x, y: a.y, shown: 0, size: 0 };
  for (const h of n)
    if (i >= h && i < h + 0.5) {
      const f = (i - h) / 0.5, p = ur(h, e, t, [], s);
      d = { x: p.x, y: p.y, shown: 0.5 * (1 - f), size: 0.45 + 0.8 * Je.out(f) };
    }
  const c = n.some((h) => i >= h - 0.03 && i < h + 0.14) || o.some(([h, f]) => i >= h && i < f);
  return { x: a.x, y: a.y, shown: no(i, s[0], s[1], 0.3, 0.35), pressed: c, ring: d };
}
const Ni = { w: 252, h: 160 }, Yn = Gf.map((i) => i.src.replace("-800w.webp", "-400w.webp")), jf = nc.src.replace("-800w.webp", "-400w.webp"), pu = "Bonneville Tower from Depot Street, planted terraces, photoreal", h3 = "Make it night, warm light in every window";
function Tm(i, e, t, n) {
  if (e <= t) return "";
  if (e >= n) return i;
  const s = Array.from(i), o = s.map((c, h) => s[h - 1] === "," ? 3 : s[h - 1] === " " ? 1.4 : 1), r = o.reduce((c, h) => c + h, 0), a = (e - t) / (n - t) * r;
  let l = 0, d = 0;
  for (; d < s.length && l + o[d] <= a; ) l += o[d++];
  return s.slice(0, d).join("");
}
const Ei = {
  loop: 8.4,
  still: 6.2,
  dock: { x: 196, y: 298, w: 248, h: 46 },
  /** the dock's + (CHAT-20: it opens the tool menu) */
  add: { x: 201, y: 304, w: 34, h: 34 },
  /** the tool menu, risen from the dock */
  menu: { x: 180, y: 118, w: 280, h: 170 },
  /** its Image row */
  image: { x: 188, y: 174, w: 264, h: 30 },
  card: { x: 194, y: 58, w: Ni.w, h: Ni.h },
  tags: ["Its model", "Your prompt", "Every image it makes"],
  T: { cursorIn: [0.35, 7.7], toAdd: [0.6, 1.4], click: 1.55, menu: [1.62, 1.95], toImage: [2.15, 2.85], pick: 3, menuOut: [3.05, 3.3], land: [3.2, 3.85], tags: [4.05, 4.35, 4.65], reset: [7.6, 8.25] }
};
function cAe(i) {
  const e = Ei, t = (i % e.loop + e.loop) % e.loop, n = 1 - Ge(t, e.T.reset[0], e.T.reset[1], Je.sine), s = Ge(t, e.T.land[0], e.T.land[1], Je.out) * n;
  return {
    pointer: ur(t, { x: 560, y: 210 }, [
      { at: e.T.toAdd, to: oa(e.add), arc: -0.12 },
      { at: e.T.toImage, to: { x: e.image.x + 46, y: e.image.y + e.image.h / 2 }, arc: 0.08 }
    ], [e.T.click, e.T.pick], e.T.cursorIn),
    addLit: no(t, e.T.click - 0.05, e.T.menuOut[0], 0.05, 0.2),
    menu: Ge(t, e.T.menu[0], e.T.menu[1], Je.out) * (1 - Ge(t, e.T.menuOut[0], e.T.menuOut[1], Je.sine)),
    imageLit: no(t, e.T.toImage[1] - 0.15, e.T.menuOut[0], 0.15, 0.1),
    card: s,
    selected: Ge(t, e.T.land[1] - 0.1, e.T.land[1] + 0.2) * n,
    tags: e.T.tags.map((o) => Ge(t, o, o + 0.45, Je.out) * n)
  };
}
const il = {
  loop: 6.4,
  still: 3.4,
  card: { x: 194, y: 40, w: Ni.w, h: Ni.h },
  prompt: { x: 70, y: 218, w: 500, h: 124 },
  dock: { x: 196, y: 298, w: 248, h: 46 },
  empty: { x: 96, y: 128 },
  T: { cursorIn: [0.3, 5.9], toCard: [0.5, 1.3], click: 1.45, open: [1.55, 2.05], toEmpty: [3.6, 4.3], away: 4.45, close: [4.55, 5] }
};
function uAe(i) {
  const e = il, t = (i % e.loop + e.loop) % e.loop, n = Ge(t, e.T.open[0], e.T.open[1], Je.out) * (1 - Ge(t, e.T.close[0], e.T.close[1], Je.sine));
  return {
    pointer: ur(t, { x: 560, y: 150 }, [
      { at: e.T.toCard, to: { x: e.card.x + 128, y: e.card.y + 52 }, arc: 0.1 },
      { at: e.T.toEmpty, to: e.empty, arc: -0.1 }
    ], [e.T.click, e.T.away], e.T.cursorIn),
    selected: Ge(t, e.T.click, e.T.click + 0.18) * (1 - Ge(t, e.T.away, e.T.away + 0.18)),
    prompt: n
  };
}
const Io = {
  loop: 7.2,
  still: 5.2,
  prompt: { x: 40, y: 40, w: 560, h: 156 },
  key: { x: 272, y: 240, w: 96, h: 56 },
  T: { fadeIn: 0.35, keyIn: [0.4, 0.8], press: [1.45, 1.7], type: [1.75, 4.3], run: 4.4, keyOut: [5.6, 6], reset: [6.4, 7] }
}, hAe = { ghost: 1, typed: "", caret: 0, cue: 1, key: 0, keyDown: !1, runLit: 0, fade: 0 };
function pAe(i) {
  const e = Io, t = (i % e.loop + e.loop) % e.loop, n = Math.min(Ge(t, 0, e.T.fadeIn, Je.sine), 1 - Ge(t, e.T.reset[0], e.T.reset[1], Je.sine));
  if (n <= 0) return { ...hAe };
  const s = t < e.T.reset[0] ? Tm(pu, t, e.T.type[0], e.T.type[1]) : pu, o = t >= e.T.type[0] && t < e.T.type[1], r = Math.floor(t / 0.53) % 2 === 0 ? 1 : 0;
  return {
    ghost: t < e.T.type[0] ? 1 : 0,
    typed: t >= e.T.reset[1] ? "" : s,
    caret: o ? 1 : t < e.T.reset[0] ? r : 0,
    cue: t < e.T.type[0] ? 1 - Ge(t, e.T.press[0], e.T.type[0]) : 0,
    key: no(t, e.T.keyIn[0], e.T.keyOut[1], 0.4, 0.4),
    keyDown: t >= e.T.press[0] && t < e.T.press[1],
    runLit: Ge(t, e.T.run, e.T.run + 0.3) * n,
    fade: n
  };
}
const sl = {
  loop: 8.2,
  still: 5.6,
  card: { x: 36, y: 36, w: Ni.w, h: Ni.h },
  prompt: { x: 30, y: 226, w: 400, h: 116 },
  run: { x: 356, y: 300, w: 62, h: 30 },
  gallery: { x: 452, y: 14, w: 174, h: 332 },
  T: { cursorIn: [0.3, 2.2], toRun: [0.5, 1.2], click: 1.35, busy: [1.4, 3.3], land: 3.3, gallery: [4, 4.7], reset: [7.4, 8.1] }
};
function fAe(i) {
  const e = sl, t = (i % e.loop + e.loop) % e.loop, n = 1 - Ge(t, e.T.reset[0], e.T.reset[1], Je.sine), s = t >= e.T.busy[0] && t < e.T.busy[1], o = Yn.map((r, a) => t >= e.T.land ? Ge(t, e.T.land + a * 0.14, e.T.land + a * 0.14 + 0.5, Je.out) * n : 0);
  return {
    pointer: ur(t, { x: 560, y: 250 }, [{ at: e.T.toRun, to: oa(e.run), arc: 0.12 }], [e.T.click], e.T.cursorIn),
    busy: s,
    seconds: s ? Math.floor(t - e.T.busy[0]) : 0,
    thumbs: o,
    count: t >= e.T.land && t < e.T.reset[0] ? Yn.length : 0,
    gallery: Ge(t, e.T.gallery[0], e.T.gallery[1], Je.out) * n,
    foot: s ? "Generating… 0:0" + Math.floor(t - e.T.busy[0] + 1) : t >= e.T.land && t < e.T.reset[0] ? "Updated just now" : "No runs yet",
    runPressed: t >= e.T.click - 0.03 && t < e.T.click + 0.14
  };
}
const ki = {
  loop: 7,
  still: 3.4,
  card: { x: 36, y: 36, w: Ni.w, h: Ni.h },
  gallery: { x: 452, y: 14, w: 174, h: 332 },
  /** the gallery's first picture */
  pick: { x: 462, y: 54, w: 73, h: 98 },
  /** where it lands on the board */
  drop: { x: 316, y: 26, w: 116, h: 156 },
  T: { cursorIn: [0.3, 5], toPick: [0.5, 1.2], press: 1.38, drag: [1.5, 2.65], drop: 2.75, reset: [6.2, 6.8] }
};
function mAe(i) {
  const e = ki, t = (i % e.loop + e.loop) % e.loop, n = 1 - Ge(t, e.T.reset[0], e.T.reset[1], Je.sine), s = { x: e.drop.x + 40, y: e.drop.y + 54 }, o = ur(t, { x: 560, y: 300 }, [
    { at: e.T.toPick, to: { x: e.pick.x + 30, y: e.pick.y + 40 }, arc: 0.1 },
    { at: e.T.drag, to: s, arc: -0.18 }
  ], [], e.T.cursorIn, [[e.T.press, e.T.drop]]), r = Ge(t, e.T.press, e.T.press + 0.2, Je.out), a = Ge(t, e.T.drop, e.T.drop + 0.16, Je.sine), l = Ge(t, e.T.drag[1] - 0.35, e.T.drag[1], Je.sine);
  return {
    pointer: o,
    ghost: { x: o.x, y: o.y, shown: t >= e.T.press && t < e.T.drop + 0.16 ? r * (1 - a) : 0, tilt: -8 * (1 - l) },
    placed: t >= e.T.drop ? Ge(t, e.T.drop, e.T.drop + 0.45, Je.out) * n : 0,
    slot: no(t, e.T.press + 0.1, e.T.drop + 0.1, 0.25, 0.2)
  };
}
const Fs = {
  loop: 8,
  still: 4.2,
  card: { x: 194, y: 34, w: Ni.w, h: Ni.h },
  prompt: { x: 70, y: 214, w: 500, h: 128 },
  pill: { x: 482, y: 224, w: 76, h: 26 },
  T: { cursorIn: [0.3, 1.9], toPill: [0.5, 1.3], hover: 1.3, click: 1.7, open: [1.85, 2.6], close: [6.5, 7.1], reset: [7.1, 7.6] }
};
function gAe(i) {
  const e = Fs, t = (i % e.loop + e.loop) % e.loop, n = Ge(t, e.T.open[0], e.T.open[1], Je.dive) * (1 - Ge(t, e.T.close[0], e.T.close[1], Je.sine));
  return {
    pointer: ur(t, { x: 600, y: 120 }, [{ at: e.T.toPill, to: oa(e.pill), arc: 0.14 }], [e.T.click], e.T.cursorIn),
    pillLit: no(t, e.T.hover, e.T.open[1], 0.2, 0.2),
    open: n,
    parts: Ge(t, e.T.open[1] - 0.1, e.T.open[1] + 0.6, Je.out) * (1 - Ge(t, e.T.close[0], e.T.close[0] + 0.3))
  };
}
const Ao = {
  loop: 9.4,
  still: 7.2,
  stage: { x: 222, y: 30, w: 196, h: 262 },
  bar: { x: 162, y: 302, w: 316, h: 44 },
  run: { x: 416, y: 310, w: 54, h: 28 },
  /** the painted area: over the tower's middle floors */
  stroke: "M262 128 C 300 120, 336 122, 378 130 M262 150 C 300 142, 340 146, 380 152 M264 172 C 302 166, 338 168, 378 174",
  T: { cursorIn: [0.3, 4.9], toPaint: [0.5, 1], paint: [1.05, 2.4], type: [2.6, 4], toRun: [4, 4.5], click: 4.62, busy: [4.7, 5.6], wipe: [5.6, 6.5], version: 6.5, reset: [8.6, 9.2] }
};
function bAe(i) {
  const e = Ao, t = (i % e.loop + e.loop) % e.loop, n = 1 - Ge(t, e.T.reset[0], e.T.reset[1], Je.sine), s = ur(t, { x: 560, y: 200 }, [
    { at: e.T.toPaint, to: { x: 262, y: 128 }, arc: 0.08 },
    { at: [e.T.paint[0], e.T.paint[0] + 0.45], to: { x: 378, y: 130 }, arc: -0.03 },
    { at: [e.T.paint[0] + 0.45, e.T.paint[0] + 0.9], to: { x: 262, y: 150 }, arc: 0.02 },
    { at: [e.T.paint[0] + 0.9, e.T.paint[1]], to: { x: 378, y: 172 }, arc: -0.02 },
    { at: e.T.toRun, to: oa(e.run), arc: 0.1 }
  ], [e.T.click], e.T.cursorIn, [[e.T.paint[0], e.T.paint[1]]]), o = t >= e.T.reset[1] ? "" : t < e.T.reset[0] ? Tm(h3, t, e.T.type[0], e.T.type[1]) : h3;
  return {
    pointer: s,
    brush: t >= e.T.toPaint[1] - 0.1 && t < e.T.paint[1] + 0.15,
    // the area goes once the new version is in
    painted: t < e.T.wipe[1] ? Ge(t, e.T.paint[0], e.T.paint[1]) : 0,
    area: (1 - Ge(t, e.T.wipe[0], e.T.wipe[1])) * (t >= e.T.paint[0] ? 1 : 0),
    typed: o,
    busy: t >= e.T.busy[0] && t < e.T.busy[1],
    wipe: Ge(t, e.T.wipe[0], e.T.wipe[1], Je.dive) * n,
    versions: t >= e.T.version && t < e.T.reset[0] ? 2 : 1
  };
}
const vAe = Cu.map((i) => i.src.replace("-800w.webp", "-400w.webp")), yAe = Cu.map((i) => Q0[i.id].src.replace("-800w.webp", "-400w.webp")), rP = "Show the finished tower in each of these photos", Ln = {
  loop: 11.8,
  still: 9.8,
  frame: { x: 24, y: 50, w: 372, h: 286 },
  /** where a click on the frame's title lands */
  title: { x: 62, y: 38 },
  photos: [
    { x: 40, y: 72, w: 108, h: 61 },
    { x: 156, y: 72, w: 108, h: 61 },
    { x: 272, y: 72, w: 108, h: 61 }
  ],
  /** each photo's finished view lands under it */
  finished: [
    { x: 40, y: 145, w: 108, h: 61 },
    { x: 156, y: 145, w: 108, h: 61 },
    { x: 272, y: 145, w: 108, h: 61 }
  ],
  /** the chat's card, in the frame */
  card: { x: 40, y: 222, w: 132, h: 96 },
  /** the frame's bar, and its Chat button */
  bar: { x: 150, y: 4, w: 118, h: 30 },
  chat: { x: 155, y: 9, w: 56, h: 20 },
  /** the chat panel, docked on the right, and what's in it (in the stage's pixels) */
  panel: { x: 412, y: 10, w: 216, h: 340 },
  bubble: { x: 452, y: 58, w: 168, h: 34 },
  answer: { x: 420, y: 104, w: 200, h: 30 },
  plan: { x: 440, y: 142, w: 180, h: 92 },
  run: { x: 538, y: 204, w: 76, h: 22 },
  composer: { x: 420, y: 284, w: 200, h: 58 },
  send: { x: 592, y: 314, w: 22, h: 22 },
  T: {
    cursorIn: [0.3, 9.6],
    toTitle: [0.5, 1.15],
    select: 1.3,
    toChat: [1.6, 2.2],
    open: 2.35,
    panel: [2.45, 2.95],
    card: [2.6, 3],
    type: [3.2, 4.5],
    toSend: [4.4, 4.95],
    send: 5.1,
    bubble: [5.15, 5.45],
    think: [5.45, 5.95],
    answer: [5.95, 6.5],
    plan: [6.55, 6.95],
    toRun: [7, 7.6],
    run: 7.75,
    busy: [7.8, 8.5],
    land: [8.5, 8.8, 9.1],
    reset: [10.8, 11.4]
  }
};
function xAe(i) {
  const e = Ln, t = (i % e.loop + e.loop) % e.loop, n = 1 - Ge(t, e.T.reset[0], e.T.reset[1], Je.sine), s = t >= e.T.send, o = Ge(t, e.T.panel[0], e.T.panel[1], Je.out) * n;
  return {
    pointer: ur(t, { x: 560, y: 210 }, [
      { at: e.T.toTitle, to: e.title, arc: -0.1 },
      { at: e.T.toChat, to: oa(e.chat), arc: 0.12 },
      { at: e.T.toSend, to: oa(e.send), arc: -0.08 },
      { at: e.T.toRun, to: oa(e.run), arc: 0.1 }
    ], [e.T.select, e.T.open, e.T.send, e.T.run], e.T.cursorIn),
    // the frame selected shows its bar; both go as the chat opens (its glow takes over)
    selected: Ge(t, e.T.select, e.T.select + 0.18) * (1 - Ge(t, e.T.panel[0], e.T.panel[1])),
    bar: Ge(t, e.T.select, e.T.select + 0.2) * (1 - Ge(t, e.T.panel[0], e.T.panel[1])),
    chatLit: no(t, e.T.open - 0.05, e.T.open + 0.4, 0.05, 0.3),
    panel: o,
    glow: o * (1 - Ge(t, e.T.reset[0] - 0.4, e.T.reset[0])),
    card: Ge(t, e.T.card[0], e.T.card[1], Je.out) * n,
    typed: s || t >= e.T.reset[0] ? "" : Tm(rP, t, e.T.type[0], e.T.type[1]),
    sendLit: t >= e.T.type[1] && !s ? 1 : no(t, e.T.send - 0.05, e.T.send + 0.3, 0.05, 0.25),
    bubble: Ge(t, e.T.bubble[0], e.T.bubble[1], Je.out) * n,
    thinking: t >= e.T.think[0] && t < e.T.think[1],
    answer: Ge(t, e.T.answer[0], e.T.answer[1]) * n,
    plan: Ge(t, e.T.plan[0], e.T.plan[1], Je.out) * n,
    runLit: no(t, e.T.run - 0.05, e.T.run + 0.4, 0.05, 0.3),
    busy: t >= e.T.busy[0] && t < e.T.busy[1],
    done: t >= e.T.busy[1] && t < e.T.reset[0],
    finished: e.T.land.map((r) => Ge(t, r, r + 0.45, Je.out) * n)
  };
}
const Sn = {
  loop: 9,
  still: 5.2,
  frame: { x: 40, y: 46, w: 420, h: 214 },
  card: { x: 60, y: 92, w: Ni.w, h: Ni.h },
  pics: [
    { x: 332, y: 86, w: 54, h: 72 },
    { x: 392, y: 86, w: 54, h: 72 },
    { x: 332, y: 166, w: 54, h: 72 }
  ],
  note: { x: 486, y: 70, w: 128, h: 100 },
  pin: { x: 380, y: 92 },
  /** the frame's title, the note's words and the comment's, as the demo writes them */
  title: "Hero options",
  noteText: "Night version for the cover.",
  comment: "This one. Ship it.",
  T: { draw: [0.6, 1.8], title: [1.9, 2.5], note: [2.8, 3.4], pin: [3.8, 4.2], bubble: [4.2, 4.8], zoom: [5.6, 7], reset: [8.4, 9] }
};
function wAe(i) {
  const e = Sn, t = (i % e.loop + e.loop) % e.loop, n = 1 - Ge(t, e.T.reset[0], e.T.reset[1], Je.sine);
  return {
    frame: Ge(t, e.T.draw[0], e.T.draw[1], Je.move) * n,
    title: t >= e.T.reset[0] ? "" : Tm(e.title, t, e.T.title[0], e.T.title[1]),
    note: Ge(t, e.T.note[0], e.T.note[1], Je.out) * n,
    pin: Ge(t, e.T.pin[0], e.T.pin[1], Je.out) * n,
    bubble: Ge(t, e.T.bubble[0], e.T.bubble[1], Je.out) * n,
    zoom: 1 - 0.18 * Ge(t, e.T.zoom[0], e.T.zoom[1], Je.settle) * n
  };
}
function kx() {
  return typeof window != "undefined" && !!window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function uo(i, e) {
  const t = /* @__PURE__ */ K(null), n = /* @__PURE__ */ qe(0), s = /* @__PURE__ */ K(0.55), o = /* @__PURE__ */ K({ x: 0, y: 0 }), r = kx();
  let a = 0, l = 0, d = !1, c = null;
  function h() {
    const w = t.value;
    if (!w || !w.clientWidth) return;
    const S = w.clientWidth, M = w.clientHeight || S * So.h / So.w, _ = Math.min(S / So.w, M / So.h);
    s.value = _, o.value = { x: (S - So.w * _) / 2, y: (M - So.h * _) / 2 };
  }
  function f(w) {
    l || (l = w - n.value * 1e3), document.hidden ? l = w - n.value * 1e3 : n.value = (w - l) / 1e3 % i, a = requestAnimationFrame(f);
  }
  function p() {
    a || r || d || (l = 0, a = requestAnimationFrame(f));
  }
  function y() {
    a && cancelAnimationFrame(a), a = 0;
  }
  ot(() => {
    h(), typeof ResizeObserver != "undefined" && t.value && (c = new ResizeObserver(h), c.observe(t.value)), r ? n.value = e : p();
  }), We(() => {
    y(), c && c.disconnect();
  });
  const v = I(() => ({
    width: So.w + "px",
    height: So.h + "px",
    transform: "translate(" + o.value.x.toFixed(2) + "px, " + o.value.y.toFixed(2) + "px) scale(" + s.value.toFixed(5) + ")"
  }));
  return { root: t, bind: (w) => {
    t.value = w || null;
  }, t: n, scale: s, stageStyle: v, reduced: r };
}
const Dt = (i) => i.toFixed(2), ut = (i) => i.toFixed(3), kAe = {
  class: "ob-head",
  "data-tour-ui": "",
  "data-testid": "tour-header"
}, _Ae = { class: "ob-head-left" }, SAe = ["viewBox"], MAe = ["d", "fill"], TAe = {
  class: "ob-chapters",
  "aria-label": "Tour progress"
}, CAe = ["aria-current", "data-chapter"], IAe = { class: "n" }, AAe = { class: "l" }, PAe = { class: "ob-head-right" }, EAe = /* @__PURE__ */ Pe({
  __name: "TourHeader",
  props: {
    tour: {}
  },
  setup(i) {
    const e = i, t = I(() => sAe(e.tour.step.value.chapter)), n = I(() => e.tour.phase.value === "finished"), s = I(() => e.tour.reason === "replay" ? "Exit tour" : "Skip tour");
    return (o, r) => (g(), b("header", kAe, [
      u("div", _Ae, [
        (g(), b("svg", {
          class: "ob-head-mark",
          viewBox: m(Ql),
          width: "25",
          height: "18",
          "aria-hidden": "true"
        }, [
          (g(!0), b(j, null, be(m(fa), (a) => (g(), b("path", {
            key: a.d,
            d: a.d,
            fill: a.fill
          }, null, 8, MAe))), 128))
        ], 8, SAe)),
        r[1] || (r[1] = u("span", { class: "ob-head-name" }, [
          J("Boards"),
          u("span", { class: "sep" }, "/"),
          u("b", null, "Getting started")
        ], -1))
      ]),
      u("ol", TAe, [
        (g(!0), b(j, null, be(m(xx), (a, l) => (g(), b("li", {
          key: a.id,
          class: G({ on: l === t.value && !n.value, done: l < t.value || n.value }),
          "aria-current": l === t.value ? "step" : void 0,
          "data-chapter": a.id
        }, [
          u("span", IAe, [
            l < t.value || n.value ? (g(), Ce($, {
              key: 0,
              name: "Check",
              size: 10,
              stroke: 3
            })) : (g(), b(j, { key: 1 }, [
              J(E(l + 1), 1)
            ], 64))
          ]),
          u("span", AAe, E(a.label), 1)
        ], 10, CAe))), 128))
      ]),
      u("div", PAe, [
        i.tour.canSkip && !n.value ? (g(), b("button", {
          key: 0,
          class: "ob-skip",
          "data-testid": "tour-skip",
          onClick: r[0] || (r[0] = (a) => i.tour.skip())
        }, E(s.value), 1)) : z("", !0)
      ])
    ]));
  }
}), RAe = {
  key: 0,
  class: "ob-d-brush"
}, zAe = {
  key: 1,
  class: "arrow",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22"
}, va = /* @__PURE__ */ Pe({
  __name: "DemoPointer",
  props: {
    p: {},
    brush: { type: Boolean }
  },
  setup(i) {
    const e = i, t = I(() => ({
      opacity: ut(e.p.ring.shown),
      transform: "translate(" + Dt(e.p.ring.x) + "px, " + Dt(e.p.ring.y) + "px) scale(" + ut(e.p.ring.size) + ")"
    })), n = I(() => ({ opacity: ut(e.p.shown), transform: "translate(" + Dt(e.p.x) + "px, " + Dt(e.p.y) + "px)" }));
    return (s, o) => (g(), b(j, null, [
      u("span", {
        class: "bl-hd-ripple",
        style: ce(t.value)
      }, null, 4),
      u("span", {
        class: G(["bl-hd-pointer ob-d-pointer", { "is-pressed": i.p.pressed, "is-brush": i.brush }]),
        style: ce(n.value)
      }, [
        i.brush ? (g(), b("span", RAe)) : (g(), b("svg", zAe, [...o[0] || (o[0] = [
          u("path", {
            d: "M4 2.5v15.2l3.9-3.7 2.6 6 2.7-1.2-2.6-5.9h5.4z",
            fill: "#fff",
            stroke: "#0b0d14",
            "stroke-width": "1.3",
            "stroke-linejoin": "round"
          }, null, -1)
        ])])),
        Ss(s.$slots, "default")
      ], 6)
    ], 64));
  }
}), $Ae = { class: "bl-hd-session-head" }, DAe = { class: "bl-hd-badge" }, OAe = { class: "bl-hd-session-titles" }, LAe = { class: "kind" }, BAe = { class: "model" }, FAe = { class: "name" }, NAe = { class: "bl-hd-count" }, UAe = ["src"], GAe = { class: "bl-hd-foot" }, td = /* @__PURE__ */ Pe({
  __name: "DemoCard",
  props: {
    box: {},
    name: { default: "Image Tool 1" },
    model: { default: "Nano Banana Pro" },
    thumbs: { default: () => [] },
    shown: { default: void 0 },
    count: { default: 0 },
    foot: { default: "No runs yet" },
    selected: { default: 0 },
    busy: { type: Boolean, default: !1 }
  },
  setup(i) {
    return (e, t) => (g(), b("div", {
      class: "bl-hd-session ob-d-card",
      style: ce({ left: i.box.x + "px", top: i.box.y + "px", width: i.box.w + "px", height: i.box.h + "px" })
    }, [
      u("span", {
        class: "bl-hd-ring",
        style: ce({ opacity: m(ut)(i.selected) })
      }, null, 4),
      u("div", $Ae, [
        u("span", DAe, [
          C($, {
            name: "Image",
            size: 17
          })
        ]),
        u("span", OAe, [
          u("span", LAe, [
            t[0] || (t[0] = J("Image", -1)),
            t[1] || (t[1] = u("span", { class: "sep" }, "·", -1)),
            u("span", BAe, E(i.model), 1)
          ]),
          u("span", FAe, E(i.name), 1)
        ]),
        u("span", NAe, E(i.count), 1)
      ]),
      u("div", {
        class: G(["bl-hd-thumbs", { "is-busy": i.busy }])
      }, [
        (g(), b(j, null, be(4, (n) => u("span", {
          key: n,
          class: "bl-hd-thumb is-empty"
        }, [
          i.thumbs[n - 1] ? (g(), b("img", {
            key: 0,
            src: i.thumbs[n - 1],
            alt: "",
            draggable: "false",
            class: "is-in",
            style: ce(i.shown ? { opacity: m(ut)(i.shown[n - 1] || 0), transform: "scale(" + m(ut)(0.82 + 0.18 * (i.shown[n - 1] || 0)) + ")" } : void 0)
          }, null, 12, UAe)) : z("", !0)
        ])), 64))
      ], 2),
      u("div", GAe, E(i.foot), 1)
    ], 4));
  }
}), jAe = { class: "bl-hd-rail" }, HAe = { class: "is-on" }, aP = /* @__PURE__ */ Pe({
  __name: "DemoDock",
  props: {
    box: {},
    lit: { default: 0 },
    shown: { default: 1 },
    open: { default: 0 }
  },
  setup(i) {
    return (e, t) => (g(), b("div", {
      class: "bl-hd-dock ob-d-dock",
      style: ce({ left: i.box.x + "px", top: i.box.y + "px", width: i.box.w + "px", opacity: m(ut)(i.shown), transform: "translateY(" + m(Dt)((1 - i.shown) * 10) + "px)" })
    }, [
      u("span", {
        class: G(["bl-hd-add is-plus", { "is-lit": i.lit > 0.3, "is-open": i.open > 0.5 }])
      }, [
        C($, {
          name: "Plus",
          size: 17,
          stroke: 2.4
        })
      ], 2),
      u("span", jAe, [
        u("i", HAe, [
          C($, {
            name: "MousePointer2",
            size: 15
          })
        ]),
        u("i", null, [
          C($, {
            name: "Hand",
            size: 15
          })
        ]),
        t[0] || (t[0] = u("b", null, null, -1)),
        u("i", null, [
          C($, {
            name: "Image",
            size: 15
          })
        ]),
        u("i", null, [
          C($, {
            name: "StickyNote",
            size: 15
          })
        ]),
        u("i", null, [
          C($, {
            name: "Frame",
            size: 15
          })
        ])
      ])
    ], 4));
  }
}), VAe = { class: "search" }, WAe = { class: "badge" }, qAe = { class: "main" }, KAe = /* @__PURE__ */ Pe({
  __name: "DemoSession",
  setup(i) {
    const { bind: e, t, stageStyle: n } = uo(Ei.loop, Ei.still), s = I(() => cAe(t.value)), o = [
      { icon: "Image", name: "Image", sub: "Create images with AI-powered models" },
      { icon: "Video", name: "Video", sub: "Generate dynamic videos and animations" },
      { icon: "Box", name: "3D", sub: "Generate 3D models from images or prompts" },
      { icon: "Maximize2", name: "Upscale", sub: "Upscale your images and videos" }
    ];
    return (r, a) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "session"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(n))
      }, [
        a[3] || (a[3] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        u("div", {
          class: "ob-d-land",
          style: ce({ opacity: m(ut)(s.value.card), transform: "translateY(" + m(Dt)((1 - s.value.card) * -18) + "px) scale(" + m(ut)(0.9 + 0.1 * s.value.card) + ")" })
        }, [
          C(td, {
            box: m(Ei).card,
            selected: s.value.selected
          }, null, 8, ["box", "selected"])
        ], 4),
        (g(!0), b(j, null, be(m(Ei).tags, (l, d) => (g(), b("span", {
          key: l,
          class: "ob-d-tag",
          style: ce({ left: m(Ei).card.x + m(Ei).card.w + 22 + "px", top: m(Ei).card.y + 20 + d * 44 + "px", opacity: m(ut)(s.value.tags[d]), transform: "translateX(" + m(Dt)((1 - s.value.tags[d]) * -10) + "px)" })
        }, [
          a[0] || (a[0] = u("i", null, null, -1)),
          J(E(l), 1)
        ], 4))), 128)),
        u("div", {
          class: "ob-d-menu",
          style: ce({ left: m(Ei).menu.x + "px", top: m(Ei).menu.y + "px", width: m(Ei).menu.w + "px", opacity: m(ut)(s.value.menu), transform: "translateY(" + m(Dt)((1 - s.value.menu) * 12) + "px)" })
        }, [
          u("div", VAe, [
            C($, {
              name: "Search",
              size: 11
            }),
            a[1] || (a[1] = J("Search generators", -1))
          ]),
          a[2] || (a[2] = u("div", { class: "eyebrow" }, "New tool session", -1)),
          (g(), b(j, null, be(o, (l, d) => u("div", {
            key: l.name,
            class: G(["row", { "is-lit": d === 0 && s.value.imageLit > 0.3 }])
          }, [
            u("span", WAe, [
              C($, {
                name: l.icon,
                size: 12
              }, null, 8, ["name"])
            ]),
            u("span", qAe, [
              u("b", null, E(l.name), 1),
              u("small", null, E(l.sub), 1)
            ])
          ], 2)), 64))
        ], 4),
        C(aP, {
          box: m(Ei).dock,
          lit: s.value.addLit,
          open: s.value.menu
        }, null, 8, ["box", "lit", "open"]),
        C(va, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), YAe = { class: "bl-hd-prompt-side" }, XAe = { class: "ob-d-words" }, JAe = {
  key: 0,
  class: "ph"
}, ZAe = { class: "typed" }, QAe = { class: "bl-hd-prompt-foot" }, ePe = { class: "chip" }, tPe = { class: "chip" }, nPe = { class: "step" }, Cm = /* @__PURE__ */ Pe({
  __name: "DemoPrompt",
  props: {
    box: {},
    typed: { default: "" },
    ghost: { default: "" },
    ghostShown: { default: 0 },
    cue: { default: 0 },
    caret: { default: 0 },
    placeholder: { default: "Describe what Image Tool 1 should make" },
    runLit: { default: 0 },
    runPressed: { type: Boolean, default: !1 },
    runBusy: { type: Boolean, default: !1 },
    studio: { type: Boolean, default: !0 },
    studioLit: { default: 0 },
    shown: { default: 1 }
  },
  setup(i) {
    return (e, t) => (g(), b("div", {
      class: "bl-hd-prompt ob-d-prompt",
      style: ce({
        left: i.box.x + "px",
        top: i.box.y + "px",
        width: i.box.w + "px",
        height: i.box.h + "px",
        opacity: m(ut)(i.shown),
        visibility: i.shown > 1e-3 ? "visible" : "hidden",
        transform: "translateY(" + m(Dt)((1 - i.shown) * 16) + "px)"
      })
    }, [
      u("span", YAe, [
        u("i", null, [
          C($, {
            name: "LayoutTemplate",
            size: 15
          })
        ]),
        u("i", null, [
          C($, {
            name: "Pipette",
            size: 15
          })
        ])
      ]),
      i.studio ? (g(), b("span", {
        key: 0,
        class: G(["ob-d-pill", { "is-lit": i.studioLit > 0.5 }])
      }, [
        C($, {
          name: "Expand",
          size: 12
        }),
        t[0] || (t[0] = J("Studio", -1))
      ], 2)) : z("", !0),
      u("span", XAe, [
        !i.typed && !i.ghost ? (g(), b("span", JAe, E(i.placeholder), 1)) : z("", !0),
        i.ghost && !i.typed ? (g(), b("span", {
          key: 1,
          class: "ghost",
          style: ce({ opacity: m(ut)(i.ghostShown) })
        }, E(i.ghost), 5)) : z("", !0),
        u("span", ZAe, E(i.typed), 1),
        u("span", {
          class: "caret",
          style: ce({ opacity: m(ut)(i.caret) })
        }, null, 4)
      ]),
      i.cue > 0.01 ? (g(), b("span", {
        key: 1,
        class: "ob-d-cue",
        style: ce({ opacity: m(ut)(i.cue) })
      }, [...t[1] || (t[1] = [
        u("kbd", null, "Tab", -1),
        J(" to write it in", -1)
      ])], 4)) : z("", !0),
      u("span", QAe, [
        u("span", ePe, [
          t[2] || (t[2] = u("small", null, "Model", -1)),
          t[3] || (t[3] = J("Nano Banana Pro", -1)),
          C($, {
            name: "ChevronDown",
            size: 12
          })
        ]),
        u("span", tPe, [
          C($, {
            name: "RectangleVertical",
            size: 12
          }),
          t[4] || (t[4] = J("896×1152", -1))
        ]),
        t[6] || (t[6] = u("span", { class: "sp" }, null, -1)),
        u("span", nPe, [
          C($, {
            name: "Minus",
            size: 11
          }),
          t[5] || (t[5] = u("b", null, "4", -1)),
          C($, {
            name: "Plus",
            size: 11
          })
        ]),
        u("span", {
          class: G(["run", { "is-lit": i.runLit > 0.5, "is-pressed": i.runPressed, "is-busy": i.runBusy }]),
          style: { width: "62px" }
        }, E(i.runBusy ? "Running" : "Run"), 3)
      ])
    ], 4));
  }
}), iPe = /* @__PURE__ */ Pe({
  __name: "DemoOpen",
  setup(i) {
    const { bind: e, t, stageStyle: n } = uo(il.loop, il.still), s = I(() => uAe(t.value));
    return (o, r) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "open"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(n))
      }, [
        r[0] || (r[0] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        C(td, {
          box: m(il).card,
          selected: s.value.selected
        }, null, 8, ["box", "selected"]),
        C(aP, {
          box: m(il).dock,
          shown: 1 - s.value.prompt
        }, null, 8, ["box", "shown"]),
        C(Cm, {
          box: m(il).prompt,
          shown: s.value.prompt,
          caret: s.value.prompt > 0.9 ? 1 : 0,
          studio: !1
        }, null, 8, ["box", "shown", "caret"]),
        C(va, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), sPe = /* @__PURE__ */ Pe({
  __name: "DemoPromptTab",
  setup(i) {
    const { bind: e, t, stageStyle: n } = uo(Io.loop, Io.still), s = I(() => pAe(t.value));
    return (o, r) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "prompt"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(n))
      }, [
        r[1] || (r[1] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        u("div", {
          style: ce({ opacity: m(ut)(s.value.fade) })
        }, [
          C(Cm, {
            box: m(Io).prompt,
            class: "is-big",
            typed: s.value.typed,
            ghost: m(pu),
            "ghost-shown": s.value.ghost,
            cue: s.value.cue,
            caret: s.value.caret,
            "run-lit": s.value.runLit,
            studio: !1
          }, null, 8, ["box", "typed", "ghost", "ghost-shown", "cue", "caret", "run-lit"])
        ], 4),
        u("span", {
          class: G(["ob-d-keycap", { "is-down": s.value.keyDown }]),
          style: ce({ left: m(Io).key.x + "px", top: m(Io).key.y + "px", width: m(Io).key.w + "px", height: m(Io).key.h + "px", opacity: m(ut)(s.value.key), transform: "translateY(" + m(Dt)((1 - s.value.key) * 8) + "px)" })
        }, [...r[0] || (r[0] = [
          u("span", null, "Tab", -1),
          u("i", null, "⇥", -1)
        ])], 6)
      ], 4)
    ], 512));
  }
}), oPe = { class: "grid" }, rPe = ["src"], lP = /* @__PURE__ */ Pe({
  __name: "DemoGallery",
  props: {
    box: {},
    shown: { default: 1 },
    lifted: { default: -1 }
  },
  setup(i) {
    return (e, t) => (g(), b("div", {
      class: "ob-d-gallery",
      style: ce({ left: i.box.x + "px", top: i.box.y + "px", width: i.box.w + "px", height: i.box.h + "px", opacity: m(ut)(i.shown), transform: "translateX(" + m(Dt)((1 - i.shown) * 60) + "px)" })
    }, [
      t[0] || (t[0] = u("div", { class: "head" }, [
        u("b", null, "4"),
        J(" Image Tool 1")
      ], -1)),
      u("div", oPe, [
        (g(!0), b(j, null, be(m(Yn), (n, s) => (g(), b("span", {
          key: n,
          class: G(["cell", { "is-lifted": s === i.lifted }])
        }, [
          u("img", {
            src: n,
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, rPe)
        ], 2))), 128))
      ])
    ], 4));
  }
}), aPe = /* @__PURE__ */ Pe({
  __name: "DemoRun",
  setup(i) {
    const { bind: e, t, stageStyle: n } = uo(sl.loop, sl.still), s = I(() => fAe(t.value));
    return (o, r) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "run"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(n))
      }, [
        r[0] || (r[0] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        C(td, {
          box: m(sl).card,
          thumbs: m(Yn),
          shown: s.value.thumbs,
          count: s.value.count,
          foot: s.value.foot,
          busy: s.value.busy,
          selected: 1
        }, null, 8, ["box", "thumbs", "shown", "count", "foot", "busy"]),
        C(Cm, {
          box: m(sl).prompt,
          typed: m(pu),
          "run-lit": 1,
          "run-pressed": s.value.runPressed,
          "run-busy": s.value.busy,
          studio: !1
        }, null, 8, ["box", "typed", "run-pressed", "run-busy"]),
        C(lP, {
          box: m(sl).gallery,
          shown: s.value.gallery
        }, null, 8, ["box", "shown"]),
        C(va, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), lPe = ["src"], dPe = ["src"], cPe = /* @__PURE__ */ Pe({
  __name: "DemoDrag",
  setup(i) {
    const { bind: e, t, stageStyle: n } = uo(ki.loop, ki.still), s = I(() => mAe(t.value));
    return (o, r) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "drag"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(n))
      }, [
        r[0] || (r[0] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        C(td, {
          box: m(ki).card,
          thumbs: m(Yn),
          count: 4,
          foot: "Updated just now",
          selected: 1
        }, null, 8, ["box", "thumbs"]),
        u("span", {
          class: "ob-d-slot",
          style: ce({ left: m(ki).drop.x + "px", top: m(ki).drop.y + "px", width: m(ki).drop.w + "px", height: m(ki).drop.h + "px", opacity: m(ut)(s.value.slot) })
        }, null, 4),
        u("div", {
          class: "bl-hd-pic ob-d-placed",
          style: ce({ left: m(ki).drop.x + "px", top: m(ki).drop.y + "px", width: m(ki).drop.w + "px", height: m(ki).drop.h + "px", opacity: m(ut)(s.value.placed), transform: "scale(" + m(ut)(1.05 - 0.05 * s.value.placed) + ")" })
        }, [
          u("img", {
            src: m(Yn)[0],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, lPe)
        ], 4),
        C(lP, {
          box: m(ki).gallery,
          lifted: s.value.ghost.shown > 0.05 ? 0 : -1
        }, null, 8, ["box", "lifted"]),
        u("span", {
          class: "bl-hd-ghost ob-d-ghost",
          style: ce({ opacity: m(ut)(s.value.ghost.shown), transform: "translate(" + m(Dt)(s.value.ghost.x - 26) + "px, " + m(Dt)(s.value.ghost.y - 30) + "px) rotate(" + m(Dt)(s.value.ghost.tilt) + "deg)" })
        }, [
          u("img", {
            src: m(Yn)[0],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, dPe)
        ], 4),
        C(va, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), uPe = { class: "back" }, hPe = { class: "crumb" }, pPe = { class: "chip" }, fPe = { class: "x" }, mPe = { class: "tabs" }, gPe = { class: "v on" }, bPe = ["src"], vPe = {
  key: 0,
  class: "v is-new"
}, yPe = ["src"], xPe = ["src"], wPe = ["src"], kPe = ["src"], dP = /* @__PURE__ */ Pe({
  __name: "DemoStudioView",
  props: {
    side: { default: "generate" },
    parts: { default: 1 },
    wipe: { default: -1 },
    versions: { default: 1 },
    busy: { type: Boolean, default: !1 }
  },
  setup(i) {
    const e = [
      { icon: "Wand2", label: "Prompt" },
      { icon: "Sparkles", label: "Upscale" },
      { icon: "Lightbulb", label: "Relight" },
      { icon: "Camera", label: "Change camera" },
      { icon: "Layers", label: "Background" }
    ];
    return (t, n) => (g(), b("div", {
      class: G(["ob-d-studio", "is-" + i.side])
    }, [
      u("div", {
        class: "top",
        style: ce({ opacity: m(ut)(i.parts) })
      }, [
        u("span", uPe, [
          C($, {
            name: "ArrowLeft",
            size: 13
          })
        ]),
        u("span", hPe, [
          u("small", null, E(i.side === "edit" ? "Edit" : "Generate"), 1),
          n[0] || (n[0] = J("Image Tool 1", -1))
        ]),
        u("span", pPe, [
          C($, {
            name: "Image",
            size: 11
          }),
          n[1] || (n[1] = J("Session", -1))
        ]),
        u("span", fPe, [
          C($, {
            name: "X",
            size: 13
          })
        ])
      ], 4),
      u("div", {
        class: "tools",
        style: ce({ opacity: m(ut)(i.parts), transform: "translateX(" + m(Dt)((1 - i.parts) * -14) + "px)" })
      }, [
        u("div", mPe, [
          u("span", {
            class: G({ on: i.side === "generate" })
          }, "Generate", 2),
          u("span", {
            class: G({ on: i.side === "edit" })
          }, "Edit", 2)
        ]),
        (g(), b(j, null, be(e, (s, o) => u("div", {
          key: s.label,
          class: G(["row", { on: o === 0 }])
        }, [
          C($, {
            name: s.icon,
            size: 12
          }, null, 8, ["name"]),
          J(E(s.label), 1)
        ], 2)), 64))
      ], 4),
      u("div", {
        class: "versions",
        style: ce({ opacity: m(ut)(i.parts) })
      }, [
        u("span", gPe, [
          u("img", {
            src: m(Yn)[0],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, bPe)
        ]),
        i.versions > 1 ? (g(), b("span", vPe, [
          u("img", {
            src: m(jf),
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, yPe)
        ])) : z("", !0)
      ], 4),
      u("div", {
        class: G(["stage", { "is-busy": i.busy }]),
        style: ce({ opacity: m(ut)(i.parts), transform: "scale(" + m(ut)(0.94 + 0.06 * i.parts) + ")" })
      }, [
        u("img", {
          src: m(Yn)[0],
          alt: "",
          draggable: "false",
          class: "is-in"
        }, null, 8, xPe),
        i.wipe >= 0 ? (g(), b("img", {
          key: 0,
          src: m(jf),
          alt: "",
          draggable: "false",
          class: "is-in night",
          style: ce({ clipPath: "inset(0 " + m(Dt)((1 - i.wipe) * 100) + "% 0 0)" })
        }, null, 12, wPe)) : z("", !0),
        i.wipe > 0 && i.wipe < 1 ? (g(), b("span", {
          key: 1,
          class: "seam",
          style: ce({ left: m(Dt)(i.wipe * 100) + "%" })
        }, null, 4)) : z("", !0),
        Ss(t.$slots, "stage")
      ], 6),
      u("div", {
        class: "hist",
        style: ce({ opacity: m(ut)(i.parts), transform: "translateX(" + m(Dt)((1 - i.parts) * 14) + "px)" })
      }, [
        (g(!0), b(j, null, be(m(Yn), (s) => (g(), b("span", {
          key: s,
          class: "h"
        }, [
          u("img", {
            src: s,
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, kPe)
        ]))), 128))
      ], 4),
      Ss(t.$slots, "default")
    ], 2));
  }
}), _Pe = /* @__PURE__ */ Pe({
  __name: "DemoStudio",
  setup(i) {
    const { bind: e, t, stageStyle: n } = uo(Fs.loop, Fs.still), s = I(() => gAe(t.value)), o = Fs.pill.x + Fs.pill.w / 2 + "px " + (Fs.pill.y + Fs.pill.h / 2) + "px";
    return (r, a) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "studio"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(n))
      }, [
        a[0] || (a[0] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        C(td, {
          box: m(Fs).card,
          thumbs: m(Yn),
          count: 4,
          foot: "Updated just now",
          selected: 1
        }, null, 8, ["box", "thumbs"]),
        C(Cm, {
          box: m(Fs).prompt,
          typed: m(pu),
          "run-lit": 1,
          "studio-lit": s.value.pillLit
        }, null, 8, ["box", "typed", "studio-lit"]),
        u("div", {
          class: "ob-d-studio-wrap",
          style: ce({ opacity: m(ut)(Math.min(1, s.value.open * 1.6)), transform: "scale(" + m(ut)(0.12 + 0.88 * s.value.open) + ")", transformOrigin: o, visibility: s.value.open > 1e-3 ? "visible" : "hidden", borderRadius: m(Dt)(28 * (1 - s.value.open) + 4) + "px" })
        }, [
          C(dP, {
            parts: s.value.parts
          }, null, 8, ["parts"])
        ], 4),
        C(va, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), SPe = ["d", "stroke-dashoffset"], MPe = { class: "words" }, TPe = {
  key: 0,
  class: "ph"
}, CPe = { class: "typed" }, p3 = 420, IPe = /* @__PURE__ */ Pe({
  __name: "DemoEdit",
  setup(i) {
    const { bind: e, t, stageStyle: n } = uo(Ao.loop, Ao.still), s = I(() => bAe(t.value));
    return (o, r) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "edit"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(n))
      }, [
        r[0] || (r[0] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        C(dP, {
          side: "edit",
          wipe: s.value.wipe > 0 ? s.value.wipe : -1,
          versions: s.value.versions,
          busy: s.value.busy
        }, null, 8, ["wipe", "versions", "busy"]),
        (g(), b("svg", {
          class: "ob-d-paint",
          viewBox: "0 0 640 360",
          width: "640",
          height: "360",
          style: ce({ opacity: m(ut)(s.value.area) })
        }, [
          u("path", {
            d: m(Ao).stroke,
            fill: "none",
            stroke: "rgba(174, 134, 229, 0.62)",
            "stroke-width": "16",
            "stroke-linecap": "round",
            "stroke-dasharray": p3,
            "stroke-dashoffset": p3 * (1 - s.value.painted)
          }, null, 8, SPe)
        ], 4)),
        u("div", {
          class: "ob-d-editbar",
          style: ce({ left: m(Ao).bar.x + "px", top: m(Ao).bar.y + "px", width: m(Ao).bar.w + "px", height: m(Ao).bar.h + "px" })
        }, [
          u("span", MPe, [
            s.value.typed ? z("", !0) : (g(), b("span", TPe, "Say what to change")),
            u("span", CPe, E(s.value.typed), 1)
          ]),
          u("span", {
            class: G(["run", { "is-lit": !!s.value.typed, "is-busy": s.value.busy }])
          }, E(s.value.busy ? "Running" : "Run"), 3)
        ], 4),
        C(va, {
          p: s.value.pointer,
          brush: s.value.brush
        }, null, 8, ["p", "brush"])
      ], 4)
    ], 512));
  }
}), APe = ["src"], PPe = ["src"], EPe = { class: "head" }, RPe = { class: "mark" }, zPe = { class: "head" }, $Pe = { class: "mark" }, DPe = { class: "lines" }, OPe = { class: "eyebrow" }, LPe = { class: "sess" }, BPe = { class: "words" }, FPe = {
  key: 0,
  class: "ph"
}, NPe = { class: "typed" }, UPe = /* @__PURE__ */ Pe({
  __name: "DemoChat",
  setup(i) {
    const { bind: e, t, stageStyle: n } = uo(Ln.loop, Ln.still), s = I(() => xAe(t.value)), o = (a) => ({ left: a.x + "px", top: a.y + "px", width: a.w + "px", height: a.h + "px" }), r = (a) => o({ x: a.x - Ln.panel.x, y: a.y - Ln.panel.y, w: a.w, h: a.h });
    return (a, l) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "chat"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(n))
      }, [
        l[11] || (l[11] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        u("div", {
          class: "ob-d-frame is-drawn ob-d-chatframe",
          style: ce({ ...o(m(Ln).frame), "--glow": m(ut)(s.value.glow), "--sel": m(ut)(s.value.selected) })
        }, [...l[0] || (l[0] = [
          u("span", { class: "title" }, "Site photos", -1)
        ])], 4),
        (g(!0), b(j, null, be(m(Ln).photos, (d, c) => (g(), b("div", {
          key: "p" + c,
          class: "bl-hd-pic",
          style: ce(o(d))
        }, [
          u("img", {
            src: m(vAe)[c],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, APe)
        ], 4))), 128)),
        (g(!0), b(j, null, be(m(Ln).finished, (d, c) => (g(), b("div", {
          key: "f" + c,
          class: "bl-hd-pic ob-d-finished",
          style: ce({ ...o(d), opacity: m(ut)(s.value.finished[c]), transform: "translateY(" + m(Dt)((1 - s.value.finished[c]) * 10) + "px) scale(" + m(ut)(0.94 + 0.06 * s.value.finished[c]) + ")" })
        }, [
          u("img", {
            src: m(yAe)[c],
            alt: "",
            draggable: "false",
            class: "is-in"
          }, null, 8, PPe)
        ], 4))), 128)),
        u("div", {
          class: "ob-d-chatcard",
          style: ce({ ...o(m(Ln).card), opacity: m(ut)(s.value.card), transform: "scale(" + m(ut)(0.9 + 0.1 * s.value.card) + ")" })
        }, [
          u("span", EPe, [
            u("span", RPe, [
              C($, {
                name: "MessagesSquare",
                size: 11
              })
            ]),
            l[1] || (l[1] = u("span", { class: "n" }, "Chat 1", -1))
          ]),
          l[2] || (l[2] = u("span", { class: "line" }, null, -1)),
          l[3] || (l[3] = u("span", { class: "line is-short" }, null, -1))
        ], 4),
        u("div", {
          class: "ob-d-ctxbar",
          style: ce({ ...o(m(Ln).bar), opacity: m(ut)(s.value.bar) })
        }, [
          u("span", {
            class: G(["chat", { "is-lit": s.value.chatLit > 0.01 }])
          }, [
            C($, {
              name: "MessageSquarePlus",
              size: 10
            }),
            l[4] || (l[4] = J("Chat", -1))
          ], 2),
          l[5] || (l[5] = u("span", { class: "ic" }, null, -1)),
          l[6] || (l[6] = u("span", { class: "ic" }, null, -1)),
          l[7] || (l[7] = u("span", { class: "ic" }, null, -1))
        ], 4),
        u("div", {
          class: "ob-d-chat",
          style: ce({ ...o(m(Ln).panel), opacity: m(ut)(s.value.panel), transform: "translateX(" + m(Dt)((1 - s.value.panel) * 44) + "px)" })
        }, [
          u("div", zPe, [
            u("span", $Pe, [
              C($, {
                name: "MessagesSquare",
                size: 11
              })
            ]),
            l[8] || (l[8] = u("span", { class: "t" }, [
              u("b", null, "Chat 1"),
              u("small", null, "in Site photos · 3 in context")
            ], -1))
          ]),
          u("div", {
            class: "bubble",
            style: ce({ ...r(m(Ln).bubble), opacity: m(ut)(s.value.bubble), transform: "translateY(" + m(Dt)((1 - s.value.bubble) * 10) + "px)" })
          }, E(m(rP)), 5),
          u("div", {
            class: "answer",
            style: ce(r(m(Ln).answer))
          }, [
            u("span", {
              class: G(["ai", { "is-busy": s.value.thinking }]),
              style: ce({ opacity: m(ut)(s.value.thinking || s.value.answer > 0 ? 1 : 0) })
            }, [
              C($, {
                name: "Sparkles",
                size: 9
              })
            ], 6),
            u("span", DPe, [
              u("i", {
                style: ce({ width: m(Dt)(100 * Math.min(1, s.value.answer * 1.6)) + "%" })
              }, null, 4),
              u("i", {
                style: ce({ width: m(Dt)(72 * Math.max(0, s.value.answer * 1.6 - 0.6)) + "%" })
              }, null, 4)
            ])
          ], 4),
          u("div", {
            class: "plan",
            style: ce({ ...r(m(Ln).plan), opacity: m(ut)(s.value.plan), transform: "translateY(" + m(Dt)((1 - s.value.plan) * 8) + "px)" })
          }, [
            u("span", OPe, E(s.value.busy || s.value.done ? "Plan" : "Proposed plan") + " · 3 runs", 1),
            l[10] || (l[10] = u("span", { class: "ttl" }, "The finished tower", -1)),
            u("span", LPe, [
              C($, {
                name: "Image",
                size: 10
              }),
              l[9] || (l[9] = J("Nano Banana Pro · 3 photos", -1))
            ])
          ], 4),
          u("span", {
            class: G(["run", { "is-lit": s.value.runLit > 0.01, "is-busy": s.value.busy, "is-done": s.value.done }]),
            style: ce({ ...r(m(Ln).run), opacity: m(ut)(s.value.plan) })
          }, [
            C($, {
              name: s.value.done ? "CircleCheck" : "Play",
              size: 9
            }, null, 8, ["name"]),
            J(E(s.value.done ? "Done" : s.value.busy ? "Running" : "Run plan"), 1)
          ], 6),
          u("div", {
            class: "composer",
            style: ce(r(m(Ln).composer))
          }, [
            u("span", BPe, [
              s.value.typed ? z("", !0) : (g(), b("span", FPe, "Ask about these 3 images…")),
              u("span", NPe, E(s.value.typed), 1)
            ])
          ], 4),
          u("span", {
            class: G(["send", { "is-lit": s.value.sendLit > 0.01 }]),
            style: ce(r(m(Ln).send))
          }, [
            C($, {
              name: "ArrowUp",
              size: 11
            })
          ], 6)
        ], 4),
        C(va, {
          p: s.value.pointer
        }, null, 8, ["p"])
      ], 4)
    ], 512));
  }
}), GPe = {
  key: 0,
  class: "title"
}, jPe = ["src"], HPe = { class: "text" }, VPe = /* @__PURE__ */ Pe({
  __name: "DemoOrganize",
  setup(i) {
    const { bind: e, t, stageStyle: n } = uo(Sn.loop, Sn.still), s = I(() => wAe(t.value)), o = [Yn[0], jf, Yn[2]];
    return (r, a) => (g(), b("div", {
      ref: m(e),
      class: "ob-demo bl-hd",
      "aria-hidden": "true",
      "data-demo": "organize"
    }, [
      u("div", {
        class: "ob-demo-stage",
        style: ce(m(n))
      }, [
        a[1] || (a[1] = u("div", { class: "ob-demo-canvas" }, null, -1)),
        u("div", {
          class: "ob-d-world",
          style: ce({ transform: "scale(" + m(ut)(s.value.zoom) + ")" })
        }, [
          u("div", {
            class: G(["ob-d-frame", { "is-drawn": s.value.frame >= 1 }]),
            style: ce({ left: m(Sn).frame.x + "px", top: m(Sn).frame.y + "px", width: m(Dt)(m(Sn).frame.w * s.value.frame) + "px", height: m(Dt)(m(Sn).frame.h * s.value.frame) + "px", opacity: s.value.frame > 0.01 ? 1 : 0 })
          }, [
            s.value.title ? (g(), b("span", GPe, E(s.value.title), 1)) : z("", !0)
          ], 6),
          C(td, {
            box: m(Sn).card,
            thumbs: [m(Yn)[0], m(jf), m(Yn)[2], m(Yn)[3]],
            count: 5,
            foot: "Updated just now"
          }, null, 8, ["box", "thumbs"]),
          (g(!0), b(j, null, be(m(Sn).pics, (l, d) => (g(), b("div", {
            key: d,
            class: "bl-hd-pic",
            style: ce({ left: l.x + "px", top: l.y + "px", width: l.w + "px", height: l.h + "px" })
          }, [
            u("img", {
              src: o[d],
              alt: "",
              draggable: "false",
              class: "is-in"
            }, null, 8, jPe)
          ], 4))), 128)),
          u("div", {
            class: "bl-hd-note is-amber ob-d-note",
            style: ce({ left: m(Sn).note.x + "px", top: m(Sn).note.y + "px", width: m(Sn).note.w + "px", height: m(Sn).note.h + "px", opacity: m(ut)(s.value.note), transform: "translateY(" + m(Dt)((1 - s.value.note) * -16) + "px) rotate(" + m(Dt)((1 - s.value.note) * -4) + "deg)" })
          }, [
            u("span", HPe, E(m(Sn).noteText), 1),
            a[0] || (a[0] = u("span", { class: "meta" }, "MT", -1))
          ], 4),
          u("span", {
            class: "ob-d-pin",
            style: ce({ left: m(Sn).pin.x + "px", top: m(Sn).pin.y + "px", opacity: m(ut)(s.value.pin), transform: "scale(" + m(ut)(0.4 + 0.6 * s.value.pin) + ")" })
          }, "JR", 4),
          u("span", {
            class: "ob-d-bubble",
            style: ce({ left: m(Sn).pin.x + 30 + "px", top: m(Sn).pin.y - 6 + "px", opacity: m(ut)(s.value.bubble), transform: "translateX(" + m(Dt)((1 - s.value.bubble) * -8) + "px)" })
          }, E(m(Sn).comment), 5)
        ], 4)
      ], 4)
    ], 512));
  }
}), WPe = ["aria-label", "data-step"], qPe = { class: "ob-tag" }, KPe = { class: "ob-body" }, YPe = { class: "ob-words-stack" }, XPe = {
  key: 0,
  class: "ob-note",
  "data-testid": "tour-note"
}, JPe = { class: "ob-tick" }, ZPe = { class: "ob-note-words" }, QPe = {
  key: 0,
  class: "ob-key"
}, eEe = { class: "ob-title" }, tEe = { class: "ob-text" }, nEe = { class: "ob-tick" }, iEe = { class: "ob-task-words" }, sEe = {
  key: 0,
  class: "ob-key"
}, oEe = {
  key: 1,
  class: "ob-chip"
}, rEe = { class: "ob-foot" }, aEe = ["aria-label"], lEe = { class: "ob-foot-acts" }, dEe = ["disabled"], cEe = /* @__PURE__ */ Pe({
  __name: "CoachCard",
  props: {
    tour: {},
    x: {},
    y: {},
    wide: { type: Boolean },
    short: { type: Boolean }
  },
  emits: ["size"],
  setup(i, { emit: e }) {
    const t = i, n = e, s = {
      session: KAe,
      open: iPe,
      prompt: sPe,
      run: aPe,
      drag: cPe,
      studio: _Pe,
      edit: IPe,
      chat: UPe,
      organize: VPe
    }, o = { board: "LayoutDashboard", session: "Image", generate: "Sparkles", studio: "Expand", edit: "Wand2", chat: "MessagesSquare", finish: "Check" }, r = I(() => t.tour.step.value), a = I(() => t.tour.phase.value), l = I(() => t.tour.waiting.value), d = I(() => r.value.demo && s[r.value.demo] || null), c = I(() => xx.find((A) => A.id === r.value.chapter)), h = I(() => Wi.filter((A) => A.chapter === r.value.chapter && A.id !== "finale")), f = I(() => h.value.findIndex((A) => A.id === r.value.id)), p = I(() => {
      const A = r.value;
      return a.value === "success" && A.landed ? { key: "landed", ...A.landed } : l.value && A.waiting ? { key: "wait", ...A.waiting } : { key: "step", title: A.title, body: A.body };
    }), y = I(() => p.value.title), v = I(() => p.value.body), x = I(() => r.value.task ? c3(r.value.task) : []), w = /* @__PURE__ */ new Set(["Tab", "Esc", "Enter"]), S = I(() => r.value.kind === "run" && !x.value.some((A) => A.strong && w.has(A.text))), M = I(() => r.value.note ? c3(r.value.note.how) : []), _ = pn(["mod", "enter"]), T = /* @__PURE__ */ K(0);
    Ae(() => t.tour.nudges.value, () => {
      T.value++;
    });
    const k = /* @__PURE__ */ K(null);
    let P = null;
    return Ae(k, (A, R) => {
      P && R && P.unobserve(R), A && (P || (P = new ResizeObserver(() => {
        k.value && n("size", { w: k.value.offsetWidth, h: k.value.offsetHeight });
      })), P.observe(A), n("size", { w: A.offsetWidth, h: A.offsetHeight }));
    }), (A, R) => (g(), b("div", {
      ref_key: "card",
      ref: k,
      class: G(["ob-card", { "has-demo": !!d.value, "is-wide": i.wide, "is-short": i.short && !!d.value, "is-entering": a.value === "enter", "is-done": a.value === "success", "is-waiting": l.value }]),
      style: ce({ transform: "translate3d(" + Math.round(i.x) + "px, " + Math.round(i.y) + "px, 0)" }),
      role: "dialog",
      "aria-live": "polite",
      "aria-label": r.value.title,
      "data-tour-ui": "",
      "data-testid": "tour-card",
      "data-step": r.value.id
    }, [
      C(vt, {
        name: "ob-media",
        mode: "out-in"
      }, {
        default: Xe(() => [
          d.value ? (g(), b("div", {
            key: r.value.demo,
            class: "ob-media"
          }, [
            (g(), Ce(la(d.value))),
            u("span", qPe, [
              C($, {
                name: o[c.value.id] || "Sparkles",
                size: 10
              }, null, 8, ["name"]),
              J(E(c.value.label), 1)
            ])
          ])) : z("", !0)
        ]),
        _: 1
      }),
      u("div", KPe, [
        u("div", YPe, [
          C(vt, { name: "ob-words" }, {
            default: Xe(() => [
              (g(), b("div", {
                key: r.value.id + ":" + p.value.key,
                class: "ob-words"
              }, [
                r.value.note ? (g(), b("div", XPe, [
                  u("span", JPe, [
                    C($, {
                      name: "Check",
                      size: 11,
                      stroke: 3
                    })
                  ]),
                  u("span", ZPe, [
                    u("b", null, E(r.value.note.did), 1),
                    u("span", null, [
                      (g(!0), b(j, null, be(M.value, (D, O) => (g(), b(j, { key: O }, [
                        D.strong ? (g(), b("kbd", QPe, E(D.text), 1)) : (g(), b(j, { key: 1 }, [
                          J(E(D.text), 1)
                        ], 64))
                      ], 64))), 128))
                    ])
                  ])
                ])) : z("", !0),
                u("b", eEe, E(y.value), 1),
                u("span", tEe, E(v.value), 1)
              ]))
            ]),
            _: 1
          })
        ]),
        r.value.kind !== "continue" ? (g(), b("div", {
          key: "task" + T.value,
          class: G(["ob-task", { "is-shaking": T.value > 0 && a.value === "task" }]),
          "data-testid": "tour-task"
        }, [
          a.value === "success" ? (g(), b(j, { key: 0 }, [
            u("span", nEe, [
              C($, {
                name: "Check",
                size: 12,
                stroke: 3
              })
            ]),
            R[2] || (R[2] = u("span", null, "Nice", -1))
          ], 64)) : l.value ? (g(), b(j, { key: 1 }, [
            R[3] || (R[3] = u("span", { class: "ob-spin" }, null, -1)),
            R[4] || (R[4] = u("span", null, "Working on it", -1))
          ], 64)) : (g(), b(j, { key: 2 }, [
            R[6] || (R[6] = u("span", { class: "ob-dot" }, null, -1)),
            u("span", iEe, [
              (g(!0), b(j, null, be(x.value, (D, O) => (g(), b(j, { key: O }, [
                D.strong && m(w).has(D.text) ? (g(), b("kbd", sEe, E(D.text), 1)) : D.strong ? (g(), b("span", oEe, E(D.text), 1)) : (g(), b(j, { key: 2 }, [
                  J(E(D.text), 1)
                ], 64))
              ], 64))), 128)),
              S.value ? (g(), b(j, { key: 0 }, [
                R[5] || (R[5] = J(" or press ", -1)),
                (g(!0), b(j, null, be(m(_), (D) => (g(), b("kbd", {
                  key: D,
                  class: "ob-key"
                }, E(D), 1))), 128))
              ], 64)) : z("", !0)
            ])
          ], 64))
        ], 2)) : z("", !0),
        i.tour.nudgeHint.value && a.value === "task" && r.value.kind !== "continue" ? (g(), b("div", {
          key: "hint" + T.value,
          class: "ob-hint",
          "data-testid": "tour-hint"
        }, E(i.tour.nudgeHint.value), 1)) : z("", !0),
        u("div", rEe, [
          u("span", {
            class: "ob-steps",
            "aria-label": "Step " + (f.value + 1) + " of " + h.value.length + " in " + c.value.label
          }, [
            (g(!0), b(j, null, be(h.value, (D, O) => (g(), b("i", {
              key: D.id,
              class: G({ on: O === f.value, done: O < f.value || O === f.value && a.value === "success" })
            }, null, 2))), 128))
          ], 8, aEe),
          u("span", lEe, [
            i.tour.canBack ? (g(), b("button", {
              key: 0,
              class: "ob-link",
              "data-testid": "tour-back",
              onClick: R[0] || (R[0] = (D) => i.tour.back())
            }, "Back")) : z("", !0),
            r.value.kind === "continue" ? (g(), b("button", {
              key: 1,
              class: "ob-btn",
              disabled: a.value !== "task",
              "data-testid": "tour-continue",
              onClick: R[1] || (R[1] = (D) => i.tour.next())
            }, [...R[7] || (R[7] = [
              J(" Continue", -1),
              u("kbd", { class: "ob-key is-on-btn" }, "↵", -1)
            ])], 8, dEe)) : z("", !0)
          ])
        ])
      ])
    ], 14, WPe));
  }
}), uEe = {
  class: "licon",
  "aria-hidden": "true",
  style: { display: "inline-flex", flex: "none" }
}, an = /* @__PURE__ */ Pe({
  __name: "LIcon",
  props: {
    name: {},
    size: { default: 16 },
    stroke: { default: 2 }
  },
  setup(i) {
    const e = {
      ArrowDown: pR,
      ArrowUp: e6,
      ArrowUpDown: vR,
      ArrowUpRight: Q5,
      Check: t6,
      ChevronDown: n6,
      ChevronLeft: i6,
      ChevronRight: s6,
      CircleAlert: vv,
      CircleCheck: o6,
      Copy: a6,
      Download: l6,
      Ellipsis: d6,
      ExternalLink: c6,
      Globe: h6,
      Image: g6,
      LayoutGrid: b6,
      Lock: x6,
      Minus: k6,
      Pencil: S6,
      Plus: C6,
      RefreshCw: ID,
      Search: A6,
      ShieldCheck: rO,
      SlidersHorizontal: E6,
      Sparkles: yv,
      StickyNote: z6,
      Table2: IO,
      Trash2: $6,
      UserRound: ZO,
      Users: O6,
      Wand2: B6,
      X: F6,
      // Edit and Access Settings
      ArrowRight: Z5,
      CircleMinus: lz,
      CircleX: r6,
      Link: s7,
      LoaderCircle: y6,
      UserCheck: qO,
      UserPlus: D6,
      UserRoundCog: XO,
      // the hero's demo window
      Frame: u6,
      Hand: p6,
      Heart: f6,
      ImagePlus: m6,
      LayoutTemplate: v6,
      Maximize2: w6,
      MousePointer2: _6,
      Pause: aD,
      Pipette: M6,
      Play: T6,
      RectangleVertical: I6,
      Settings: P6,
      Square: R6,
      Video: L6,
      // the hero's Take the tour (IL-095), and its minimize (IL-108)
      CirclePlay: cz,
      Minimize2: D7
    }, t = i, n = I(() => e[t.name] || yv);
    return (s, o) => (g(), b("span", uEe, [
      (g(), Ce(la(n.value), {
        size: i.size,
        "stroke-width": i.stroke
      }, null, 8, ["size", "stroke-width"]))
    ]));
  }
});
function hEe() {
  try {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
    return !1;
  }
}
function pEe() {
  const i = /* @__PURE__ */ K(hEe());
  let e = null;
  const t = () => {
    i.value = !!e && e.matches;
  };
  return ot(() => {
    try {
      e = window.matchMedia("(prefers-reduced-motion: reduce)"), e.addEventListener("change", t);
    } catch {
      e = null;
    }
  }), We(() => {
    e && e.removeEventListener("change", t);
  }), i;
}
const fEe = ["viewBox"], mEe = ["d", "fill"], gEe = { class: "bl-hd-canvas" }, bEe = { class: "bl-hd-ftitle" }, vEe = { key: 1 }, yEe = { class: "bl-hd-flabel" }, xEe = ["src", "fetchpriority"], wEe = {
  key: 0,
  class: "bl-hd-play"
}, kEe = ["src"], _Ee = { class: "bl-hd-session-head" }, SEe = { class: "bl-hd-badge" }, MEe = { class: "bl-hd-session-titles" }, TEe = { class: "kind" }, CEe = { class: "model" }, IEe = { class: "name" }, AEe = { class: "bl-hd-count" }, PEe = { class: "bl-hd-thumbs" }, EEe = ["src"], REe = { class: "bl-hd-foot" }, zEe = { class: "bl-hd-session-head" }, $Ee = { class: "bl-hd-badge" }, DEe = { class: "bl-hd-session-titles" }, OEe = { class: "kind" }, LEe = { class: "model" }, BEe = { class: "name" }, FEe = ["src"], NEe = { class: "text" }, UEe = { class: "meta" }, GEe = { class: "text" }, jEe = { class: "meta" }, HEe = { class: "bl-hd-add is-plus" }, VEe = { class: "bl-hd-rail" }, WEe = { class: "is-on" }, qEe = { class: "bl-hd-prompt-side" }, KEe = ["src"], YEe = { class: "bl-hd-prompt-text" }, XEe = { class: "bl-hd-prompt-foot" }, JEe = { class: "chip" }, ZEe = { class: "chip" }, QEe = { class: "cog" }, e9e = { class: "step" }, t9e = ["src"], cP = /* @__PURE__ */ Pe({
  __name: "HeroDemo",
  props: {
    paused: { type: Boolean },
    opening: { type: Boolean }
  },
  setup(i, { expose: e }) {
    const t = i, n = pEe(), s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(null), c = /* @__PURE__ */ K(null), h = /* @__PURE__ */ K(null), f = /* @__PURE__ */ K(null), p = /* @__PURE__ */ K(null), y = /* @__PURE__ */ K(null), v = /* @__PURE__ */ K(null), x = /* @__PURE__ */ K(null), w = /* @__PURE__ */ K(null), S = /* @__PURE__ */ K(null), M = /* @__PURE__ */ K(null), _ = /* @__PURE__ */ K(null), T = /* @__PURE__ */ K(null), k = /* @__PURE__ */ K(null), P = /* @__PURE__ */ K(null), A = /* @__PURE__ */ K(null), R = /* @__PURE__ */ K(null), D = /* @__PURE__ */ K(null), O = /* @__PURE__ */ K(null), F = /* @__PURE__ */ K(null), te = /* @__PURE__ */ K(null), ee = [], me = [];
    let L = null, N = null;
    const X = ($e) => {
      L = $e;
    }, B = ($e) => {
      N = $e;
    }, se = tP.filter(($e) => $e !== ti), V = eP;
    function Z($e) {
      const Fe = { left: $e.x + "px", top: $e.y + "px" };
      return $e.w && (Fe.width = $e.w + "px"), $e.h && (Fe.height = $e.h + "px"), Fe;
    }
    function Y($e) {
      return $e + ($e === 1 ? " item" : " items");
    }
    function H($e) {
      const Fe = $e.target;
      Fe.classList.remove("is-broken"), Fe.classList.add("is-in");
    }
    function re($e) {
      const Fe = $e.target;
      Fe.classList.add("is-broken"), !(Fe.dataset.retried || !at) && (Fe.dataset.retried = "1", window.setTimeout(() => {
        at && (Fe.src = Fe.src + (Fe.src.includes("?") ? "&" : "?") + "retry=1");
      }, 2e3));
    }
    const le = /* @__PURE__ */ new WeakMap();
    function he($e, Fe, W) {
      if (!$e) return;
      let Q = le.get($e);
      Q || le.set($e, Q = {}), Q[Fe] !== W && (Q[Fe] = W, $e.style.setProperty(Fe, W));
    }
    function Re($e, Fe) {
      $e && $e.textContent !== Fe && ($e.textContent = Fe);
    }
    function Ne($e, Fe, W) {
      $e && $e.classList.contains(Fe) !== W && $e.classList.toggle(Fe, W);
    }
    const Me = ($e) => $e.toFixed(2), ue = ($e) => $e.toFixed(3);
    function U($e, Fe = !1) {
      const { cam: W } = $e;
      he(a.value, "transform", `translate(${Me(Uf.x - W.fx * W.z)}px, ${Me(Uf.y - W.fy * W.z)}px) scale(${W.z.toFixed(4)})`), he(a.value, "--z", ue(W.z)), he(a.value, "--iz", ue(1 / W.z)), Re(d.value, Math.round(W.z * 100) + "%"), he(c.value, "opacity", ue($e.dock)), he(c.value, "transform", `translate(-50%, ${Me((1 - $e.dock) * 10)}px)`), he(h.value, "opacity", ue($e.prompt)), he(h.value, "transform", `translateY(${Me((1 - $e.prompt) * 14)}px)`), he(h.value, "visibility", $e.prompt > 1e-3 ? "visible" : "hidden"), he(f.value, "opacity", $e.typed ? "0" : "1"), Re(p.value, X0.slice(0, $e.typed)), he(y.value, "opacity", String(Fe ? 0 : $e.caret)), he(x.value, "opacity", ue($e.refIn)), he(x.value, "transform", `scale(${ue(0.82 + 0.18 * $e.refIn)})`), he(w.value, "opacity", ue($e.refGlow)), Ne(v.value, "is-target", $e.ghost.ring > 0.5 && $e.ghost.shown > 0 && !$e.refIn), Ne(S.value, "is-lit", $e.runLit > 0.5), Ne(S.value, "is-pressed", $e.runPressed > 0), Ne(S.value, "is-busy", $e.runBusy), he(M.value, "opacity", ue($e.sessionSelected)), Re(_.value, $e.sessionFoot), he(T.value, "opacity", $e.sessionCount ? "1" : "0"), Ne(k.value, "is-busy", $e.shimmer), $e.sessionThumbs.forEach((Le, ve) => {
        he(me[ve], "opacity", ue(Le)), he(me[ve], "transform", `scale(${ue(0.82 + 0.18 * Le)})`);
      }), $e.results.forEach((Le, ve) => {
        he(ee[ve], "opacity", ue(Le)), he(ee[ve], "transform", `translateY(${Me((1 - Le) * 34)}px)`);
      }), he(N, "opacity", $e.heart > 0 ? "1" : "0"), he(N, "transform", `scale(${ue($e.heart)})`), he(P.value, "opacity", ue($e.note)), he(P.value, "transform", `translateY(${Me((1 - $e.note) * 34)}px)`), Re(L, Y($e.frameItems));
      const Q = $e.pointer;
      he(A.value, "opacity", Fe ? "0" : ue(Q.shown)), he(A.value, "transform", `translate(${Me(Q.x)}px, ${Me(Q.y)}px)`), Ne(A.value, "is-pressed", Q.pressed > 0), he(R.value, "opacity", ue(Q.shift)), he(F.value, "opacity", Fe ? "0" : ue($e.ripple.shown)), he(F.value, "transform", `translate(${Me($e.ripple.x)}px, ${Me($e.ripple.y)}px) scale(${ue($e.ripple.size)})`);
      const ae = $e.ghost;
      he(D.value, "opacity", Fe ? "0" : ue(ae.shown)), he(D.value, "transform", `translate(${Me(ae.x + 12)}px, ${Me(ae.y + 14)}px) rotate(${Me(ae.tilt)}deg) scale(${ue(0.86 + 0.14 * ae.shown)})`), he(O.value, "opacity", ue(ae.ring)), he(te.value, "opacity", $e.sheen < 0 ? "0" : ue(Math.sin(Math.PI * $e.sheen))), he(te.value, "transform", `translateX(${Me(-100 + 270 * Math.max(0, $e.sheen))}%)`);
    }
    let q = 0, ie = 0, de = 0, pe = !1, Te = !1;
    function Be() {
      return !n.value && pe && Te && !0 && !t.paused && !t.opening && !document.hidden;
    }
    function ge($e) {
      const Fe = ep(0);
      U({ ...Fe, cam: $e.cam, dock: Fe.dock * $e.chrome }, !0), he(s.value, "--build", ue($e.build)), he(r.value, "opacity", ue($e.chrome)), he(l.value, "opacity", ue($e.chrome));
      const W = $e.glint || { pic: 0, session: 0, note: 0, frame: 0 };
      he(s.value, "--g-pic", ue(W.pic)), he(s.value, "--g-session", ue(W.session)), he(s.value, "--g-note", ue(W.note)), he(s.value, "--g-frame", ue(W.frame));
    }
    e({ paintOpening: ge });
    const ne = ($e, Fe = 0) => ({ "--d": String(HIe($e, Fe)) });
    function oe($e) {
      ie = ($e - de) / 1e3 % Lp, U(ep(ie)), q = requestAnimationFrame(oe);
    }
    function ye() {
      if (Be()) {
        q || (de = performance.now() - ie * 1e3, q = requestAnimationFrame(oe));
        return;
      }
      q && (cancelAnimationFrame(q), q = 0), n.value && U(ep(o3), !0);
    }
    Ae(() => t.paused, ye), Ae(n, ye);
    function Oe() {
      const $e = s.value;
      $e && o.value && he(o.value, "transform", `scale(${($e.clientWidth / Wn.w).toFixed(5)})`);
    }
    function Ve() {
      const $e = Array.from(s.value ? s.value.querySelectorAll("img") : []), Fe = Promise.allSettled($e.map((W) => W.decode ? W.decode() : Promise.resolve()));
      return Promise.race([Fe.then(() => {
      }), new Promise((W) => window.setTimeout(W, 4500))]);
    }
    let Ue = null, tt = null;
    const Ye = () => ye();
    let at = !0;
    ot(() => {
      Oe(), typeof ResizeObserver != "undefined" && s.value && (tt = new ResizeObserver(Oe), tt.observe(s.value)), U(ep(n.value ? o3 : 0), n.value), typeof IntersectionObserver != "undefined" && s.value ? (Ue = new IntersectionObserver(($e) => {
        pe = $e.some((Fe) => Fe.isIntersecting), ye();
      }, { threshold: 0.08 }), Ue.observe(s.value)) : pe = !0, document.addEventListener("visibilitychange", Ye), Ve().then(() => {
        at && (Te = !0, ye());
      });
    }), We(() => {
      at = !1, q && cancelAnimationFrame(q), q = 0, Ue && Ue.disconnect(), tt && tt.disconnect(), document.removeEventListener("visibilitychange", Ye);
    });
    const wt = ($e) => "is-" + $e.tint;
    return ($e, Fe) => (g(), b("div", {
      ref_key: "root",
      ref: s,
      class: G(["bl-hd", { "is-opening": i.opening }]),
      "aria-hidden": "true",
      "data-testid": "hero-demo"
    }, [
      u("div", {
        ref_key: "win",
        ref: o,
        class: "bl-hd-win",
        style: ce({ width: m(Wn).w + "px", height: m(Wn).h + "px" })
      }, [
        u("div", {
          ref_key: "bar",
          ref: r,
          class: "bl-hd-bar"
        }, [
          Fe[0] || (Fe[0] = u("span", { class: "bl-hd-lights" }, [
            u("i"),
            u("i"),
            u("i")
          ], -1)),
          (g(), b("svg", {
            class: "bl-hd-mark",
            viewBox: m(Ql),
            width: "25",
            height: "18"
          }, [
            (g(!0), b(j, null, be(m(fa), (W) => (g(), b("path", {
              key: W.d,
              d: W.d,
              fill: W.fill
            }, null, 8, mEe))), 128))
          ], 8, fEe)),
          Fe[1] || (Fe[1] = u("span", { class: "bl-hd-crumbs" }, [
            J("Boards "),
            u("span", { class: "sep" }, "/"),
            J(),
            u("b", null, "Bonneville Tower")
          ], -1)),
          Fe[2] || (Fe[2] = u("span", { class: "bl-hd-saved" }, [
            u("i"),
            J("Saved")
          ], -1)),
          Fe[3] || (Fe[3] = u("span", { class: "bl-hd-kebab" }, [
            u("i"),
            u("i"),
            u("i")
          ], -1))
        ], 512),
        u("div", gEe, [
          u("div", {
            ref_key: "world",
            ref: a,
            class: "bl-hd-world"
          }, [
            Fe[6] || (Fe[6] = u("div", { class: "bl-hd-dots is-fine" }, null, -1)),
            Fe[7] || (Fe[7] = u("div", { class: "bl-hd-dots is-coarse" }, null, -1)),
            (g(!0), b(j, null, be(m(ZA), (W) => (g(), b("div", {
              key: W.title,
              class: "bl-hd-frame",
              style: ce({ ...Z(W), ...ne(W, 0.06) })
            }, [
              u("span", bEe, [
                J(E(W.title) + " ", 1),
                W === m(QA) ? (g(), b("small", {
                  key: 0,
                  ref_for: !0,
                  ref: X
                }, E(Y(m(J0)(W))), 513)) : (g(), b("small", vEe, E(Y(m(J0)(W))), 1))
              ]),
              u("span", yEe, E(W.title), 1)
            ], 4))), 128)),
            (g(!0), b(j, null, be(m(V), (W) => (g(), b("div", {
              key: W.id,
              class: G(["bl-hd-pic", { "is-video": W.video }]),
              style: ce({ ...Z(W), ...ne(W) })
            }, [
              u("img", {
                src: W.src,
                alt: "",
                decoding: "async",
                fetchpriority: W === m(Tl) ? "high" : "low",
                onLoad: H,
                onError: re
              }, null, 40, xEe),
              W.video ? (g(), b("span", wEe, [
                C(an, {
                  name: "Play",
                  size: 11,
                  stroke: 2.4
                })
              ])) : z("", !0)
            ], 6))), 128)),
            (g(!0), b(j, null, be(m(No), (W, Q) => (g(), b("div", {
              key: W.id,
              ref_for: !0,
              ref: (ae) => {
                ae && (ee[Q] = ae);
              },
              class: G(["bl-hd-pic is-result", { "is-first": Q === 0 }]),
              style: ce(Z(W))
            }, [
              u("img", {
                src: W.src,
                alt: "",
                decoding: "async",
                onLoad: H,
                onError: re
              }, null, 40, kEe),
              Q === 0 ? (g(), b("span", {
                key: 0,
                ref_for: !0,
                ref: B,
                class: "bl-hd-heart"
              }, [
                C(an, {
                  name: "Heart",
                  size: 10,
                  stroke: 2.6
                })
              ], 512)) : z("", !0)
            ], 6))), 128)),
            (g(!0), b(j, null, be(m(se), (W) => (g(), b("div", {
              key: W.id,
              class: "bl-hd-session",
              style: ce({ ...Z({ x: W.x, y: W.y, w: m(_o).w, h: m(_o).h }), ...ne({ x: W.x, y: W.y, w: m(_o).w, h: m(_o).h }) })
            }, [
              u("div", _Ee, [
                u("span", SEe, [
                  C(an, {
                    name: W.kind,
                    size: 17
                  }, null, 8, ["name"])
                ]),
                u("span", MEe, [
                  u("span", TEe, [
                    J(E(W.kind), 1),
                    Fe[4] || (Fe[4] = u("span", { class: "sep" }, "·", -1)),
                    u("span", CEe, E(W.model), 1)
                  ]),
                  u("span", IEe, E(W.name), 1)
                ]),
                u("span", AEe, E(W.thumbs.length), 1)
              ]),
              u("div", PEe, [
                (g(), b(j, null, be(4, (Q) => u("span", {
                  key: Q,
                  class: G(["bl-hd-thumb", { "is-empty": !W.thumbs[Q - 1] }])
                }, [
                  W.thumbs[Q - 1] ? (g(), b("img", {
                    key: 0,
                    src: W.thumbs[Q - 1],
                    alt: "",
                    decoding: "async",
                    fetchpriority: "low",
                    onLoad: H,
                    onError: re
                  }, null, 40, EEe)) : z("", !0)
                ], 2)), 64))
              ]),
              u("div", REe, E(W.foot), 1)
            ], 4))), 128)),
            u("div", {
              class: "bl-hd-session is-hero",
              style: ce({ ...Z({ x: m(ti).x, y: m(ti).y, w: m(_o).w, h: m(_o).h }), ...ne({ x: m(ti).x, y: m(ti).y, w: m(_o).w, h: m(_o).h }) })
            }, [
              u("span", {
                ref_key: "ring",
                ref: M,
                class: "bl-hd-ring"
              }, null, 512),
              u("div", zEe, [
                u("span", $Ee, [
                  C(an, {
                    name: "Image",
                    size: 17
                  })
                ]),
                u("span", DEe, [
                  u("span", OEe, [
                    J(E(m(ti).kind), 1),
                    Fe[5] || (Fe[5] = u("span", { class: "sep" }, "·", -1)),
                    u("span", LEe, E(m(ti).model), 1)
                  ]),
                  u("span", BEe, E(m(ti).name), 1)
                ]),
                u("span", {
                  ref_key: "count",
                  ref: T,
                  class: "bl-hd-count"
                }, E(m(No).length), 513)
              ]),
              u("div", {
                ref_key: "thumbsRow",
                ref: k,
                class: "bl-hd-thumbs"
              }, [
                (g(!0), b(j, null, be(m(No), (W, Q) => (g(), b("span", {
                  key: W.id,
                  class: "bl-hd-thumb is-empty"
                }, [
                  u("img", {
                    ref_for: !0,
                    ref: (ae) => {
                      ae && (me[Q] = ae);
                    },
                    src: W.src,
                    alt: "",
                    decoding: "async",
                    class: "is-in",
                    onLoad: H,
                    onError: re
                  }, null, 40, FEe)
                ]))), 128))
              ], 512),
              u("div", {
                ref_key: "foot",
                ref: _,
                class: "bl-hd-foot"
              }, E(m(ti).foot), 513)
            ], 4),
            (g(!0), b(j, null, be(m(nP), (W) => (g(), b("div", {
              key: W.id,
              class: G(["bl-hd-note", wt(W)]),
              style: ce({ ...Z(W), ...ne(W) })
            }, [
              u("span", NEe, E(W.text), 1),
              u("span", UEe, E(W.by), 1)
            ], 6))), 128)),
            u("div", {
              ref_key: "note",
              ref: P,
              class: G(["bl-hd-note", wt(m(Zh))]),
              style: ce(Z(m(Zh)))
            }, [
              u("span", GEe, E(m(Zh).text), 1),
              u("span", jEe, E(m(Zh).by), 1)
            ], 6)
          ], 512),
          u("div", {
            ref_key: "dock",
            ref: c,
            class: "bl-hd-dock",
            style: ce({ top: m(Y0) - 46 + "px" })
          }, [
            u("span", HEe, [
              C(an, {
                name: "Plus",
                size: 17,
                stroke: 2.4
              })
            ]),
            u("span", VEe, [
              u("i", WEe, [
                C(an, {
                  name: "MousePointer2",
                  size: 15
                })
              ]),
              u("i", null, [
                C(an, {
                  name: "Hand",
                  size: 15
                })
              ]),
              Fe[8] || (Fe[8] = u("b", null, null, -1)),
              u("i", null, [
                C(an, {
                  name: "Image",
                  size: 15
                })
              ]),
              u("i", null, [
                C(an, {
                  name: "StickyNote",
                  size: 15
                })
              ]),
              u("i", null, [
                C(an, {
                  name: "Frame",
                  size: 15
                })
              ]),
              u("i", null, [
                C(an, {
                  name: "Square",
                  size: 15
                })
              ])
            ])
          ], 4),
          u("div", {
            ref_key: "prompt",
            ref: h,
            class: "bl-hd-prompt",
            style: ce(Z(m(Ys)))
          }, [
            u("span", qEe, [
              u("i", null, [
                C(an, {
                  name: "LayoutTemplate",
                  size: 15
                })
              ]),
              u("i", null, [
                C(an, {
                  name: "Pipette",
                  size: 15
                })
              ]),
              u("i", null, [
                C(an, {
                  name: "Maximize2",
                  size: 14
                })
              ])
            ]),
            u("span", {
              ref_key: "slot",
              ref: v,
              class: "bl-hd-slot",
              style: ce({ left: m(Fo).x - m(Ys).x + "px", top: m(Fo).y - m(Ys).y + "px", width: m(Fo).w + "px", height: m(Fo).h + "px" })
            }, [
              C(an, {
                name: "ImagePlus",
                size: 17
              }),
              u("span", {
                ref_key: "refGlow",
                ref: w,
                class: "glow"
              }, null, 512),
              u("img", {
                ref_key: "refThumb",
                ref: x,
                src: m(Tl).src,
                alt: "",
                decoding: "async",
                class: "is-in",
                onError: re
              }, null, 40, KEe)
            ], 4),
            u("span", YEe, [
              u("span", {
                ref_key: "placeholder",
                ref: f,
                class: "ph"
              }, "Describe what " + E(m(ti).name) + " should make", 513),
              u("span", {
                ref_key: "typedEl",
                ref: p,
                class: "typed"
              }, null, 512),
              u("span", {
                ref_key: "caret",
                ref: y,
                class: "caret"
              }, null, 512)
            ]),
            u("span", XEe, [
              u("span", JEe, [
                Fe[9] || (Fe[9] = u("small", null, "Model", -1)),
                J(E(m(ti).model), 1),
                C(an, {
                  name: "ChevronDown",
                  size: 12
                })
              ]),
              u("span", ZEe, [
                C(an, {
                  name: "RectangleVertical",
                  size: 12
                }),
                Fe[10] || (Fe[10] = J("896×1152", -1))
              ]),
              u("span", QEe, [
                C(an, {
                  name: "Settings",
                  size: 14
                })
              ]),
              Fe[11] || (Fe[11] = u("span", { class: "sp" }, null, -1)),
              u("span", e9e, [
                C(an, {
                  name: "Minus",
                  size: 11
                }),
                u("b", null, E(m(No).length), 1),
                C(an, {
                  name: "Plus",
                  size: 11
                })
              ]),
              u("span", {
                ref_key: "run",
                ref: S,
                class: "run",
                style: ce({ width: m(ec).w + "px" })
              }, "Run", 4)
            ])
          ], 4),
          u("span", {
            ref_key: "zoomPill",
            ref: l,
            class: "bl-hd-zoom",
            style: ce({ top: m(Y0) - 34 + "px" })
          }, [
            C(an, {
              name: "Minus",
              size: 12
            }),
            u("span", {
              ref_key: "zoomText",
              ref: d,
              class: "pct"
            }, "29%", 512),
            C(an, {
              name: "Plus",
              size: 12
            })
          ], 4),
          u("span", {
            ref_key: "ghost",
            ref: D,
            class: "bl-hd-ghost"
          }, [
            u("img", {
              src: m(Tl).src,
              alt: "",
              class: "is-in",
              onError: re
            }, null, 40, t9e),
            u("span", {
              ref_key: "ghostRing",
              ref: O,
              class: "ring"
            }, null, 512)
          ], 512),
          u("span", {
            ref_key: "ripple",
            ref: F,
            class: "bl-hd-ripple"
          }, null, 512),
          u("span", {
            ref_key: "pointer",
            ref: A,
            class: "bl-hd-pointer"
          }, [
            Fe[12] || (Fe[12] = u("svg", {
              class: "arrow",
              width: "22",
              height: "22",
              viewBox: "0 0 22 22"
            }, [
              u("path", {
                d: "M4 2.5v15.2l3.9-3.7 2.6 6 2.7-1.2-2.6-5.9h5.4z",
                fill: "#fff",
                stroke: "#0b0d14",
                "stroke-width": "1.3",
                "stroke-linejoin": "round"
              })
            ], -1)),
            u("span", {
              ref_key: "shiftKey",
              ref: R,
              class: "bl-hd-key"
            }, "⇧ Shift", 512)
          ], 512)
        ]),
        u("span", {
          ref_key: "sheen",
          ref: te,
          class: "bl-hd-sheen"
        }, null, 512)
      ], 4)
    ], 2));
  }
}), n9e = ["aria-label"], i9e = { class: "ob-welcome-media" }, s9e = { class: "ob-welcome-body" }, o9e = { class: "ob-eyebrow" }, r9e = { class: "ob-welcome-title" }, a9e = { class: "ob-welcome-text" }, l9e = { class: "ob-welcome-actions" }, d9e = ["disabled"], c9e = /* @__PURE__ */ Pe({
  __name: "WelcomeCard",
  props: {
    tour: {}
  },
  setup(i) {
    const e = i, t = Mm("welcome"), n = I(() => oAe(e.tour.reason, e.tour.boardRef)), s = I(() => e.tour.phase.value === "task");
    return (o, r) => (g(), b("div", {
      class: G(["ob-welcome", { "is-intro": !!i.tour.intro.value }]),
      role: "dialog",
      "aria-label": m(t).title,
      "data-tour-ui": "",
      "data-testid": "tour-welcome"
    }, [
      u("div", i9e, [
        C(cP, {
          paused: !!i.tour.intro.value
        }, null, 8, ["paused"]),
        r[1] || (r[1] = u("span", { class: "ob-welcome-fade" }, null, -1))
      ]),
      u("div", s9e, [
        u("span", o9e, E(m(t).eyebrow), 1),
        u("h1", r9e, E(m(t).title), 1),
        u("p", a9e, E(n.value), 1),
        u("div", l9e, [
          u("button", {
            class: "ob-btn is-big",
            disabled: !s.value,
            "data-testid": "tour-start",
            onClick: r[0] || (r[0] = (a) => i.tour.next())
          }, [
            J(E(m(rAe)(i.tour.reason)), 1),
            C($, {
              name: "ArrowRight",
              size: 15,
              stroke: 2.4
            })
          ], 8, d9e),
          r[2] || (r[2] = u("span", { class: "ob-or" }, [
            J("or press "),
            u("kbd", { class: "ob-key" }, "↵")
          ], -1))
        ])
      ])
    ], 10, n9e));
  }
}), u9e = ["aria-label"], h9e = {
  class: "ob-finale-mark",
  "aria-hidden": "true"
}, p9e = ["viewBox"], f9e = ["d", "fill"], m9e = { class: "ob-finale-title" }, g9e = { class: "ob-finale-text" }, b9e = { class: "ob-learned" }, v9e = { class: "ob-tick" }, y9e = {
  key: 0,
  class: "ob-finale-error",
  role: "alert"
}, x9e = { class: "ob-finale-actions" }, w9e = ["disabled"], k9e = ["disabled"], _9e = /* @__PURE__ */ Pe({
  __name: "TourFinale",
  props: {
    tour: {},
    busy: { type: Boolean },
    error: {}
  },
  setup(i) {
    const e = i, t = Mm("finale"), n = I(() => aAe(e.tour.reason, e.tour.boardRef)), s = I(() => dAe(e.tour.reason, e.tour.boardRef)), o = I(() => e.busy ? s.value.exit === "create-board" ? "Creating your board…" : "Opening…" : s.value.label), r = /* @__PURE__ */ K(null);
    return ot(() => {
      window.setTimeout(() => {
        r.value && r.value.focus({ preventScroll: !0 });
      }, 700);
    }), (a, l) => (g(), b("div", {
      class: "ob-finale",
      role: "dialog",
      "aria-label": m(t).title,
      "data-tour-ui": "",
      "data-testid": "tour-finale"
    }, [
      u("div", h9e, [
        l[2] || (l[2] = u("span", { class: "halo" }, null, -1)),
        (g(), b("svg", {
          viewBox: m(Ql),
          width: "64",
          height: "46"
        }, [
          (g(!0), b(j, null, be(m(fa), (d, c) => (g(), b("path", {
            key: d.d,
            d: d.d,
            fill: d.fill,
            style: ce({ "--i": c })
          }, null, 12, f9e))), 128))
        ], 8, p9e))
      ]),
      u("h1", m9e, E(m(t).title), 1),
      u("p", g9e, E(n.value), 1),
      u("ul", b9e, [
        (g(!0), b(j, null, be(m(lAe), (d, c) => (g(), b("li", {
          key: d,
          style: ce({ "--i": c })
        }, [
          u("span", v9e, [
            C($, {
              name: "Check",
              size: 11,
              stroke: 3
            })
          ]),
          J(E(d), 1)
        ], 4))), 128))
      ]),
      i.error ? (g(), b("p", y9e, E(i.error), 1)) : z("", !0),
      u("div", x9e, [
        u("button", {
          ref_key: "primary",
          ref: r,
          class: "ob-btn is-big",
          disabled: i.busy,
          "data-testid": "tour-finish",
          onClick: l[0] || (l[0] = (d) => i.tour.finish(s.value.exit))
        }, [
          J(E(o.value), 1),
          i.busy ? z("", !0) : (g(), Ce($, {
            key: 0,
            name: "ArrowRight",
            size: 15,
            stroke: 2.4
          }))
        ], 8, w9e),
        u("button", {
          class: "ob-link",
          disabled: i.busy,
          "data-testid": "tour-again",
          onClick: l[1] || (l[1] = (d) => i.tour.again())
        }, [
          C($, {
            name: "RotateCcw",
            size: 13
          }),
          l[3] || (l[3] = J("Take the tour again", -1))
        ], 8, k9e)
      ])
    ], 8, u9e));
  }
}), fu = 6.4, xt = {
  /** the loader that held while the board opened gives way */
  loader: [0, 0.45],
  /** the light behind the mark */
  glow: [0.1, 1.2],
  /** the mark's facets turn in, each a step after the last, where the loader was (the middle of the window) */
  facets: { at: 0.2, each: 0.78, step: 0.12 },
  /** the light passes over the mark */
  sheen: [1.35, 2.05],
  /** the mark rises from the middle to make room for the line */
  rise: [1.2, 2.05],
  /** the mark's slow breath while it holds */
  breathe: [1.1, 3.6],
  /** the line rises, a word a step after the last */
  words: { at: 1.45, each: 0.75, step: 0.13 },
  /** the board's canvas fades up behind the words */
  stage: [2.2, 2.8],
  /** the board builds itself, from the middle out */
  build: [2.3, 4.25],
  /** the row naming what a board holds comes in under the line */
  row: [2.9, 3.15],
  /** the camera draws back the whole time the board shows, ending on the card's first frame */
  pull: [2.2, 6.1],
  /** the shade behind the words while they're over the board */
  scrim: [2.3, 2.9],
  /** the view shrinks into the card's window */
  land: [4.8, 6.1],
  /** the dark lifts off the practice board */
  lift: [4.95, 6.05],
  /** the window's bar, the dock and the zoom come in as it lands */
  chrome: [5.5, 6.05],
  /** the card comes up round it */
  card: [5.3, 6.2],
  /** the big mark hands over to the window bar's own */
  markOut: [5.8, 6.1],
  /** landed: the card's own window (the same picture) shows under the opening's, which fades off it */
  handover: [6.1, 6.35],
  /** Skip intro: there while the opening is full screen */
  skip: [0.8, 1.4]
}, e1 = [
  { key: "pic", label: "Images", at: 3.15 },
  { key: "session", label: "AI sessions", at: 3.5 },
  { key: "note", label: "Notes", at: 3.85 },
  { key: "frame", label: "Frames", at: 4.2 }
], S9e = 0.6, M9e = { fx: 1886, fy: 640, z: 0.6 }, T9e = Uo(0.7, 0, 0.2, 1), C9e = Uo(0.33, 0, 0.15, 1), I9e = Uo(0.16, 1, 0.3, 1), A9e = Uo(0.65, 0, 0.35, 1);
function P9e(i) {
  return i.split(" ").filter(Boolean);
}
function E9e(i, e = 5) {
  const t = Math.max(0, Math.min(fu, i)), n = xt.facets, s = xt.words, o = Ge(t, xt.land[0], xt.land[1], T9e), r = (a) => 1 - Ge(t, xt.land[0], xt.land[0] + a, Je.sine);
  return {
    t,
    backdrop: 1 - Ge(t, xt.lift[0], xt.lift[1], Je.sine),
    loader: 1 - Ge(t, xt.loader[0], xt.loader[1], Je.sine),
    glow: Ge(t, xt.glow[0], xt.glow[1], Je.sine) * r(0.8),
    facets: [0, 1, 2, 3].map((a) => Ge(t, n.at + a * n.step, n.at + a * n.step + n.each)),
    sheen: t < xt.sheen[0] || t > xt.sheen[1] ? -1 : Ge(t, xt.sheen[0], xt.sheen[1]),
    breathe: 1 + 0.03 * Math.sin(Math.PI * Ge(t, xt.breathe[0], xt.breathe[1])),
    rise: Ge(t, xt.rise[0], xt.rise[1], A9e),
    mark: 1 - Ge(t, xt.markOut[0], xt.markOut[1], Je.sine),
    words: Array.from({ length: e }, (a, l) => Ge(t, s.at + l * s.step, s.at + l * s.step + s.each, Je.out)),
    stage: Ge(t, xt.stage[0], xt.stage[1], Je.sine) * (1 - Ge(t, xt.handover[0], xt.handover[1], Je.sine)),
    build: Ge(t, xt.build[0], xt.build[1]),
    row: Ge(t, xt.row[0], xt.row[1], Je.sine) * r(0.35),
    named: e1.map((a) => Ge(t, a.at, a.at + 0.25, Je.out)),
    lit: e1.map((a) => Math.sin(Math.PI * Ge(t, a.at, a.at + S9e))),
    media: t >= xt.handover[0] ? 1 : 0,
    cam: Z0(M9e, tc, Ge(t, xt.pull[0], xt.pull[1], C9e)),
    scrim: Ge(t, xt.scrim[0], xt.scrim[1], Je.sine) * r(0.7),
    land: o,
    chrome: Ge(t, xt.chrome[0], xt.chrome[1], Je.sine),
    card: Ge(t, xt.card[0], xt.card[1], Je.out),
    skip: Ge(t, xt.skip[0], xt.skip[1], Je.sine) * r(0.3),
    done: i >= fu
  };
}
function R9e(i, e, t) {
  const n = I9e(Math.max(0, Math.min(1, e))), s = 1 - n, o = t * 0.09 * s;
  return {
    opacity: Math.min(1, Math.max(0, e) / 0.24),
    brightness: 0.35 + 0.65 * n,
    transform: `translate(${(i.out[0] * o).toFixed(2)}px, ${(i.out[1] * o).toFixed(2)}px) rotate3d(${i.axis[0]}, ${i.axis[1]}, 0, ${(88 * s).toFixed(2)}deg) scale(${(0.84 + 0.16 * n).toFixed(4)})`
  };
}
function f3(i) {
  const e = Wn.h - Wn.bar, t = Math.max(i.w, i.h * Wn.w / e), n = t / Wn.w;
  return { x: (i.w - t) / 2, y: (i.h - e * n) / 2 - Wn.bar * n, w: t, h: Wn.h * n };
}
function m3(i) {
  return { x: i.x, y: i.y, w: i.w, h: i.w * Wn.h / Wn.w };
}
function z9e(i, e) {
  return { x: (i.x - e.x) / e.w, y: (i.y - e.y) / e.w, w: i.w / e.w, h: i.h / e.w };
}
function $9e(i, e) {
  return { x: e.x + i.x * e.w, y: e.y + i.y * e.w, w: i.w * e.w, h: i.h * e.w };
}
function g3(i, e, t) {
  return { x: i.x + (e.x - i.x) * t, y: i.y + (e.y - i.y) * t, w: i.w + (e.w - i.w) * t, h: i.h + (e.h - i.h) * t };
}
function b3(i, e, t) {
  const n = 1 + (e.w / i.w - 1) * t;
  return `translate(${((e.x - i.x) * t).toFixed(2)}px, ${((e.y - i.y) * t).toFixed(2)}px) scale(${n.toFixed(4)})`;
}
const D9e = {
  class: "ob-intro-center",
  "aria-hidden": "true"
}, O9e = ["viewBox"], L9e = ["d", "fill"], B9e = {
  key: 0,
  class: "sep"
}, F9e = /* @__PURE__ */ Pe({
  __name: "TourIntro",
  props: {
    tour: {}
  },
  setup(i) {
    const t = i.tour, n = P9e(Mm("welcome").title), s = /* @__PURE__ */ K(null), o = /* @__PURE__ */ K(null), r = /* @__PURE__ */ K(null), a = /* @__PURE__ */ K(null), l = /* @__PURE__ */ K(null), d = /* @__PURE__ */ K(null), c = /* @__PURE__ */ K(null), h = /* @__PURE__ */ K(null), f = /* @__PURE__ */ K(null), p = /* @__PURE__ */ K(null), y = /* @__PURE__ */ K(null), v = /* @__PURE__ */ K(null), x = /* @__PURE__ */ K(null), w = /* @__PURE__ */ K(null), S = /* @__PURE__ */ K(null), M = [], _ = [], T = [];
    let k = null;
    const P = /* @__PURE__ */ new WeakMap();
    function A(re, le, he) {
      if (!re) return;
      let Re = P.get(re);
      Re || P.set(re, Re = {}), Re[le] !== he && (Re[le] = he, re.style.setProperty(le, he));
    }
    const R = (re) => re.toFixed(2), D = (re) => re.toFixed(3);
    function O(re, le) {
      A(re, "left", R(le.x) + "px"), A(re, "top", R(le.y) + "px"), A(re, "width", R(le.w) + "px"), A(re, "height", R(le.h) + "px");
    }
    function F(re) {
      if (!re) return null;
      const le = re.getBoundingClientRect();
      return { x: le.left, y: le.top, w: le.width, h: le.height };
    }
    let te = null, ee = null, me = 120;
    function L() {
      const re = f.value, le = v.value;
      if (!re || !le) return;
      const he = [re.style.transform, le.style.transform];
      re.style.transform = "none", le.style.transform = "none";
      const Re = F(re), Ne = F(le);
      re.style.transform = he[0], le.style.transform = he[1], Re && Ne && (te = { mark: Re, title: Ne }, me = Re.w);
    }
    function N() {
      const re = k ? k.querySelector(".ob-welcome") : null, le = F(re && re.querySelector(".ob-welcome-media")), he = F(re && re.querySelector(".ob-welcome-title")), Re = F(re && re.querySelector(".ob-welcome-media .bl-hd-mark"));
      ee = re && le && he && Re ? { media: le, title: he, mark: z9e(Re, m3(le)), radius: parseFloat(getComputedStyle(re).borderTopLeftRadius) || 0 } : null;
    }
    function X(re) {
      const le = E9e(re, n.length), he = { w: window.innerWidth, h: window.innerHeight };
      A(o.value, "opacity", D(le.backdrop)), A(r.value, "opacity", D(le.loader)), A(r.value, "transform", `scale(${D(1 + 0.35 * (1 - le.loader))})`), A(h.value, "opacity", D(le.glow)), A(h.value, "transform", `translate(-50%, -50%) scale(${D(0.55 + 0.45 * le.glow)})`), fa.forEach((q, ie) => {
        const de = R9e(q, le.facets[ie], me);
        A(M[ie], "opacity", D(de.opacity)), A(M[ie], "transform", de.transform), A(M[ie], "filter", `brightness(${D(de.brightness)})`);
      }), A(y.value, "opacity", le.sheen < 0 ? "0" : D(Math.sin(Math.PI * le.sheen))), A(y.value, "background-position", `${R(100 - 100 * Math.max(0, le.sheen))}% 0`), A(p.value, "transform", `scale(${D(le.breathe)})`), le.words.forEach((q, ie) => {
        A(_[ie], "opacity", D(q)), A(_[ie], "transform", `translateY(${R((1 - q) * 28)}px)`), A(_[ie], "filter", q >= 1 ? "none" : `blur(${R((1 - q) * 12)}px)`);
      }), A(x.value, "opacity", D(le.row)), le.named.forEach((q, ie) => {
        A(T[ie], "opacity", D(q * (0.5 + 0.5 * le.lit[ie]))), A(T[ie], "transform", `translateY(${R((1 - q) * 8)}px)`), A(T[ie], "color", le.lit[ie] > 0.5 ? "#fff" : "");
      }), le.land > 0 && !ee && (L(), N());
      const Re = { x: 0, y: 0, w: he.w, h: he.h }, Ne = ee ? g3(Re, ee.media, le.land) : Re, Me = ee ? g3(f3(he), m3(ee.media), le.land) : f3(he);
      A(a.value, "opacity", D(le.stage)), O(a.value, Ne);
      const ue = R((ee ? ee.radius : 0) * le.land), U = R(14 * Math.sin(Math.PI * le.land));
      if (A(a.value, "border-radius", `${ue}px ${ue}px ${U}px ${U}px`), A(a.value, "box-shadow", `0 40px 120px rgba(0, 0, 0, ${D(0.65 * Math.sin(Math.PI * le.land))})`), O(l.value, { x: Me.x - Ne.x, y: Me.y - Ne.y, w: Me.w, h: Me.h }), A(d.value, "opacity", D(le.card)), A(c.value, "opacity", D(le.scrim)), S.value) {
        const [q, ie, de, pe] = le.lit;
        S.value.paintOpening({ build: le.build, cam: le.cam, chrome: le.chrome, glint: { pic: q, session: ie, note: de, frame: pe } });
      }
      if (te && ee && le.land > 0)
        A(f.value, "transform", b3(te.mark, $9e(ee.mark, Me), le.land)), A(v.value, "transform", b3(te.title, ee.title, le.land));
      else {
        const q = te ? he.h / 2 - (te.mark.y + te.mark.h / 2) : 0;
        A(f.value, "transform", le.rise >= 1 ? "none" : `translateY(${R((1 - le.rise) * q)}px)`), A(v.value, "transform", "none");
      }
      A(f.value, "opacity", D(le.mark)), A(v.value, "--ts", D(1 - le.land)), A(w.value, "opacity", D(le.skip)), A(w.value, "visibility", le.skip > 0.01 ? "visible" : "hidden"), A(k, "--ob-intro-card", D(le.card)), A(k, "--ob-intro-media", String(le.media));
    }
    let B = 0, se = 0, V = 0;
    function Z(re) {
      const le = V ? Math.min(0.1, (re - V) / 1e3) : 0;
      if (V = re, se = Math.min(fu, se + le), X(se), se >= fu) {
        B = 0, t.introDone();
        return;
      }
      B = requestAnimationFrame(Z);
    }
    function Y() {
      B || (V = 0, B = requestAnimationFrame(Z));
    }
    Ae(() => t.intro.value, (re) => {
      re === "playing" && Y();
    }, { immediate: !0 });
    const H = () => {
      L(), ee && N(), X(se);
    };
    return ot(() => {
      k = s.value ? s.value.closest(".ob-layer") : null, L(), X(se), window.addEventListener("resize", H);
    }), We(() => {
      B && cancelAnimationFrame(B), B = 0, window.removeEventListener("resize", H), k && (k.style.removeProperty("--ob-intro-card"), k.style.removeProperty("--ob-intro-media"));
    }), (re, le) => (g(), b("div", {
      ref_key: "root",
      ref: s,
      class: "ob-intro",
      "data-tour-ui": "",
      "data-testid": "tour-intro",
      onWheel: le[1] || (le[1] = Se(() => {
      }, ["prevent"])),
      onContextmenu: le[2] || (le[2] = Se(() => {
      }, ["prevent"]))
    }, [
      u("div", {
        ref_key: "dark",
        ref: o,
        class: "ob-intro-dark"
      }, null, 512),
      u("div", {
        ref_key: "loader",
        ref: r,
        class: "ob-intro-loader"
      }, [
        C(FA)
      ], 512),
      u("div", {
        ref_key: "stage",
        ref: a,
        class: "ob-intro-stage",
        "aria-hidden": "true"
      }, [
        u("div", {
          ref_key: "win",
          ref: l,
          class: "ob-intro-win"
        }, [
          C(cP, {
            ref_key: "hero",
            ref: S,
            paused: !0,
            opening: ""
          }, null, 512)
        ], 512),
        u("span", {
          ref_key: "fade",
          ref: d,
          class: "ob-welcome-fade"
        }, null, 512),
        u("div", {
          ref_key: "scrim",
          ref: c,
          class: "ob-intro-scrim"
        }, null, 512)
      ], 512),
      u("div", D9e, [
        u("div", {
          ref_key: "mark",
          ref: f,
          class: "ob-intro-mark"
        }, [
          u("div", {
            ref_key: "glow",
            ref: h,
            class: "ob-intro-glow"
          }, null, 512),
          u("div", {
            ref_key: "markIn",
            ref: p,
            class: "ob-intro-mark-in",
            style: ce({ "--mask": m(BA) })
          }, [
            (g(!0), b(j, null, be(m(fa), (he, Re) => (g(), b("svg", {
              key: Re,
              ref_for: !0,
              ref: (Ne) => {
                Ne && (M[Re] = Ne);
              },
              class: "ob-intro-facet",
              viewBox: m(Ql),
              style: ce({ transformOrigin: he.origin }),
              focusable: "false"
            }, [
              u("path", {
                d: he.d,
                fill: he.fill
              }, null, 8, L9e)
            ], 12, O9e))), 128)),
            u("div", {
              ref_key: "sheen",
              ref: y,
              class: "ob-intro-sheen"
            }, null, 512)
          ], 4)
        ], 512),
        u("div", {
          ref_key: "title",
          ref: v,
          class: "ob-intro-title"
        }, [
          (g(!0), b(j, null, be(m(n), (he, Re) => (g(), b("span", {
            key: Re,
            ref_for: !0,
            ref: (Ne) => {
              Ne && (_[Re] = Ne);
            },
            class: "ob-intro-word"
          }, E(he + (Re < m(n).length - 1 ? " " : "")), 1))), 128))
        ], 512),
        u("div", {
          ref_key: "row",
          ref: x,
          class: "ob-intro-row"
        }, [
          (g(!0), b(j, null, be(m(e1), (he, Re) => (g(), b("span", {
            key: he.key,
            ref_for: !0,
            ref: (Ne) => {
              Ne && (T[Re] = Ne);
            },
            class: "ob-intro-aspect"
          }, [
            Re > 0 ? (g(), b("i", B9e)) : z("", !0),
            J(E(he.label), 1)
          ]))), 128))
        ], 512)
      ]),
      u("button", {
        ref_key: "skipBtn",
        ref: w,
        class: "ob-intro-skip",
        "data-testid": "tour-intro-skip",
        onClick: le[0] || (le[0] = (he) => m(t).skipIntro())
      }, [...le[3] || (le[3] = [
        J(" Skip intro", -1),
        u("kbd", { class: "ob-key" }, "Esc", -1)
      ])], 512)
    ], 544));
  }
}), Zb = ["#9968df", "#c750ce", "#a3a7f5", "#5a61ed", "#d6c2f2", "#ffd27a"], N9e = 1500, U9e = 2.4, G9e = 420;
function Qb(i, e = Math.random) {
  const t = i.count == null ? 120 : i.count, n = i.angle == null ? -Math.PI / 2 : i.angle, s = i.spread == null ? Math.PI / 2.2 : i.spread, o = i.power == null ? 1250 : i.power, r = [];
  for (let a = 0; a < t; a++) {
    const l = n + (e() - 0.5) * s, d = o * (0.45 + e() * 0.55);
    r.push({
      x: i.x,
      y: i.y,
      vx: Math.cos(l) * d,
      vy: Math.sin(l) * d,
      rot: e() * Math.PI * 2,
      vr: (e() - 0.5) * 14,
      flip: e() * Math.PI * 2,
      vf: 6 + e() * 10,
      w: 6 + e() * 6,
      h: 3 + e() * 4,
      color: Zb[Math.floor(e() * Zb.length) % Zb.length],
      life: 1,
      span: 1.9 + e() * 0.8
    });
  }
  return r;
}
function j9e(i, e) {
  const t = Math.max(0, 1 - U9e * e), n = [];
  for (const s of i)
    s.vx *= t, s.vy = Math.min(G9e, (s.vy + N9e * e) * t), s.x += s.vx * e, s.y += s.vy * e, s.rot += s.vr * e, s.flip += s.vf * e, s.life -= e / s.span, s.life > 0 && n.push(s);
  return n;
}
function H9e(i) {
  return Math.max(0, Math.min(1, i.life * 3));
}
const V9e = ["data-bursts"], W9e = /* @__PURE__ */ Pe({
  __name: "TourConfetti",
  props: {
    tour: {},
    reduced: { type: Boolean },
    origin: {}
  },
  setup(i) {
    const e = i, t = /* @__PURE__ */ new Set(["run", "chat-run"]), n = /* @__PURE__ */ K(null), s = /* @__PURE__ */ K(0);
    let o = [], r = 0, a = 0;
    function l(c) {
      const h = n.value;
      if (!h) {
        r = 0;
        return;
      }
      const f = Math.min(0.05, a ? (c - a) / 1e3 : 0.016);
      a = c, o = j9e(o, f);
      const p = window.devicePixelRatio || 1, y = window.innerWidth, v = window.innerHeight;
      (h.width !== Math.round(y * p) || h.height !== Math.round(v * p)) && (h.width = Math.round(y * p), h.height = Math.round(v * p));
      const x = h.getContext("2d");
      if (!x) {
        r = 0;
        return;
      }
      x.setTransform(p, 0, 0, p, 0, 0), x.clearRect(0, 0, y, v);
      for (const w of o)
        x.save(), x.globalAlpha = H9e(w), x.translate(w.x, w.y), x.rotate(w.rot), x.scale(Math.cos(w.flip), 1), x.fillStyle = w.color, x.fillRect(-w.w / 2, -w.h / 2, w.w, w.h), x.restore();
      o.length ? r = requestAnimationFrame(l) : (r = 0, a = 0, x.clearRect(0, 0, y, v));
    }
    function d(c) {
      s.value++, !e.reduced && (o = o.concat(c), r || (r = requestAnimationFrame(l)));
    }
    return Ae(
      () => [e.tour.step.value.id, e.tour.phase.value],
      ([c, h], f) => {
        const [p, y] = f || ["", ""];
        if (h === "success" && y !== "success" && t.has(c)) {
          const v = e.origin || { x: window.innerWidth / 2, y: window.innerHeight * 0.55 };
          d(Qb({ x: v.x, y: v.y, count: 110, power: 1100 }));
        } else if (c === "finale" && p !== "finale") {
          const v = window.innerHeight, x = window.innerWidth;
          d([
            ...Qb({ x: x * 0.04, y: v * 0.96, angle: -Math.PI / 2 + 0.5, spread: Math.PI / 4, power: 1500, count: 90 }),
            ...Qb({ x: x * 0.96, y: v * 0.96, angle: -Math.PI / 2 - 0.5, spread: Math.PI / 4, power: 1500, count: 90 })
          ]);
        }
      }
    ), We(() => {
      r && cancelAnimationFrame(r);
    }), (c, h) => (g(), b("canvas", {
      ref_key: "canvas",
      ref: n,
      class: "ob-confetti",
      "aria-hidden": "true",
      "data-testid": "tour-confetti",
      "data-bursts": s.value
    }, null, 8, V9e));
  }
}), q9e = ["data-step", "data-phase"], K9e = ["width", "height", "viewBox"], Y9e = ["width", "height"], X9e = ["width", "height"], J9e = ["x", "y", "width", "height", "rx", "fill-opacity"], Z9e = ["width", "height"], Q9e = ["width", "height"], eRe = ["d"], tRe = ["cx", "cy"], nRe = /* @__PURE__ */ Pe({
  __name: "TourLayer",
  props: {
    tour: {},
    busy: { type: Boolean },
    error: {}
  },
  setup(i) {
    const t = i.tour, n = kx(), { holes: s, exact: o } = BIe(t.targets, t.board, n), r = /* @__PURE__ */ K({ w: window.innerWidth, h: window.innerHeight }), a = () => {
      r.value = { w: window.innerWidth, h: window.innerHeight };
    };
    ot(() => window.addEventListener("resize", a)), We(() => window.removeEventListener("resize", a));
    const l = I(() => t.step.value), d = I(() => l.value.id), c = I(() => d.value === "welcome" || d.value === "finale"), h = I(() => d.value === "welcome" ? 0.5 : d.value === "finale" ? 0.46 : d.value === "organize" ? 0.18 : 0.32), f = /* @__PURE__ */ K({ w: 380, h: 420 }), p = I(() => t.cardPlace.value), y = I(() => {
      const A = p.value.anchor;
      if (A) return o.value.find((D) => D.key === A) || null;
      const R = t.targets.value.filter((D) => !D.look).map((D) => D.key);
      return s3(o.value.filter((D) => R.includes(D.key)));
    }), v = I(() => p.value.place === "center" ? [] : o.value.map((A) => ({ x: A.x, y: A.y, w: A.w, h: A.h }))), x = I(() => GIe(p.value.place, p.value.place === "center" ? null : y.value, f.value, r.value, v.value)), w = I(() => p.value.place === "center" || p.value.place === "bottom-center"), S = I(() => p.value.place === "bottom-center" || r.value.h < 820 && p.value.place !== "top-right" && p.value.place !== "center"), M = I(() => t.phase.value === "success"), _ = I(() => {
      const A = s3(o.value);
      return A ? { x: A.x + A.w / 2, y: A.y + A.h / 2 } : null;
    }), T = /* @__PURE__ */ K(0);
    Ae(() => t.nudges.value, () => {
      T.value++;
    });
    const k = I(() => {
      if (d.value !== "drag" || t.phase.value === "success") return null;
      const A = o.value.find((ee) => ee.key === "pick"), R = o.value.find((ee) => ee.key === "slot");
      if (!A || !R) return null;
      const D = { x: A.x + A.w / 2, y: A.y + A.h / 2 }, O = { x: R.x + R.w * 0.62, y: R.y + R.h * 0.42 }, F = Math.min(160, Math.abs(D.x - O.x) * 0.35 + 40), te = { x: (D.x + O.x) / 2, y: Math.min(D.y, O.y) - F };
      return { d: "M" + D.x + " " + D.y + " Q " + te.x + " " + te.y + " " + O.x + " " + O.y, to: O };
    }), P = (A) => ({
      left: A.x + "px",
      top: A.y + "px",
      width: A.w + "px",
      height: A.h + "px",
      borderRadius: A.r + "px"
    });
    return (A, R) => (g(), b("div", {
      class: G(["bd-root ob-layer", { "is-own": c.value, "is-reduced": m(n) }]),
      "data-testid": "tour",
      "data-step": d.value,
      "data-phase": m(t).phase.value
    }, [
      (g(), b("svg", {
        class: "ob-dim",
        width: r.value.w,
        height: r.value.h,
        viewBox: "0 0 " + r.value.w + " " + r.value.h,
        "aria-hidden": "true"
      }, [
        u("defs", null, [
          u("mask", {
            id: "ob-holes",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: r.value.w,
            height: r.value.h
          }, [
            u("rect", {
              x: "0",
              y: "0",
              width: r.value.w,
              height: r.value.h,
              fill: "#fff"
            }, null, 8, X9e),
            (g(!0), b(j, null, be(m(s), (D) => (g(), b("rect", {
              key: D.key,
              x: D.x,
              y: D.y,
              width: Math.max(0, D.w),
              height: Math.max(0, D.h),
              rx: Math.max(0, D.r),
              fill: "#000",
              "fill-opacity": D.look && !D.ring ? 0.55 : 1
            }, null, 8, J9e))), 128))
          ], 8, Y9e)
        ]),
        u("rect", {
          class: "ob-dim-fill",
          x: "0",
          y: "0",
          width: r.value.w,
          height: r.value.h,
          mask: "url(#ob-holes)",
          style: ce({ opacity: h.value })
        }, null, 12, Z9e)
      ], 8, K9e)),
      (g(!0), b(j, null, be(m(s), (D) => (g(), b(j, {
        key: "ring:" + D.key
      }, [
        D.drop ? (g(), b("div", {
          key: 0,
          class: G(["ob-slot", { "is-done": M.value }]),
          style: ce({ ...P(D), opacity: D.open }),
          "data-testid": "tour-drop"
        }, [
          u("span", null, E(D.drop), 1)
        ], 6)) : !D.look || D.ring ? (g(), b("div", {
          key: "r" + T.value,
          class: G(["ob-ring", { "is-done": M.value, "is-nudged": T.value > 0 }]),
          style: ce({ ...P(D), opacity: D.open }),
          "data-testid": "tour-ring"
        }, null, 6)) : z("", !0)
      ], 64))), 128)),
      k.value ? (g(), b("svg", {
        key: 0,
        class: "ob-arc",
        width: r.value.w,
        height: r.value.h,
        "aria-hidden": "true"
      }, [
        u("path", {
          d: k.value.d
        }, null, 8, eRe),
        u("circle", {
          cx: k.value.to.x,
          cy: k.value.to.y,
          r: "4"
        }, null, 8, tRe)
      ], 8, Q9e)) : z("", !0),
      C(EAe, { tour: m(t) }, null, 8, ["tour"]),
      C(vt, { name: "ob-own" }, {
        default: Xe(() => [
          d.value === "welcome" ? (g(), Ce(c9e, {
            key: 0,
            tour: m(t)
          }, null, 8, ["tour"])) : d.value === "finale" ? (g(), Ce(_9e, {
            key: 1,
            tour: m(t),
            busy: i.busy,
            error: i.error
          }, null, 8, ["tour", "busy", "error"])) : z("", !0)
        ]),
        _: 1
      }),
      C(vt, { name: "ob-card" }, {
        default: Xe(() => [
          c.value ? z("", !0) : (g(), Ce(cEe, {
            key: 0,
            tour: m(t),
            x: x.value.x,
            y: x.value.y,
            wide: w.value,
            short: S.value,
            onSize: R[0] || (R[0] = (D) => f.value = D)
          }, null, 8, ["tour", "x", "y", "wide", "short"]))
        ]),
        _: 1
      }),
      C(W9e, {
        tour: m(t),
        reduced: m(n),
        origin: _.value
      }, null, 8, ["tour", "reduced", "origin"]),
      C(vt, { name: "ob-intro" }, {
        default: Xe(() => [
          m(t).intro.value ? (g(), Ce(F9e, {
            key: 0,
            tour: m(t)
          }, null, 8, ["tour"])) : z("", !0)
        ]),
        _: 1
      })
    ], 10, q9e));
  }
}), iRe = /* @__PURE__ */ Pe({
  __name: "OnboardingApp",
  props: {
    env: {},
    tour: {},
    busy: {},
    error: {}
  },
  setup(i) {
    return (e, t) => (g(), b(j, null, [
      C(jA, { env: i.env }, null, 8, ["env"]),
      C(nRe, {
        tour: i.tour,
        busy: i.busy.value,
        error: i.error.value
      }, null, 8, ["tour", "busy", "error"])
    ], 64));
  }
}), Cl = { w: 316, h: 176 }, ra = 28, _x = 96, uP = (i) => "tour-" + i;
function sRe(i) {
  const e = Cu.find((t) => uP(t.id) === i);
  return e ? e.id : null;
}
const Hn = {
  id: "tour-site",
  type: "frame",
  title: "Site photos",
  z: 0,
  x: 0,
  y: 0,
  w: ra + Cu.length * (Cl.w + ra),
  h: _x + Cl.h + 40
}, Go = {
  id: "tour-brief",
  type: "note",
  tint: "amber",
  text: ZIe,
  author: QIe,
  z: 1,
  x: Hn.x + Hn.w + 48,
  y: 64,
  w: 236,
  h: 196
}, ev = {
  x: Go.x + Go.w + 64 + Rt.w / 2,
  y: Go.y + Go.h / 2
}, Hf = "tour-tower";
function oRe(i, e) {
  const t = Cl.h, n = Math.round(t * e), s = Hn.x - (n + ra);
  return {
    frame: { x: s, w: Hn.w + n + ra },
    tower: { id: Hf, type: "image", src: i, label: "Tower render", z: 5, x: s + ra, y: Hn.y + _x, w: n, h: t }
  };
}
function rRe() {
  const i = Cu.map((e, t) => ({
    id: uP(e.id),
    type: "image",
    src: e.src,
    label: e.label,
    z: 2 + t,
    x: Hn.x + ra + t * (Cl.w + ra),
    y: Hn.y + _x,
    w: Cl.w,
    h: Cl.h
  }));
  return { title: sP, elements: [Hn, Go, ...i], results: [] };
}
var aRe = Object.defineProperty, lRe = (i, e, t) => e in i ? aRe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, tp = (i, e, t) => lRe(i, typeof e != "symbol" ? e + "" : e, t);
const dRe = (i) => new Promise((e) => window.setTimeout(e, i)), cRe = "There are no photos in this frame for me to work with. Move this chat back into the Site photos frame, and ask again.";
function uRe(i) {
  const e = i.catalog.search(oP)[0], t = i.context.images.filter((r) => !r.video && !r.kind), n = t.find((r) => r.id === Hf) || null, s = t.filter((r) => r.id !== Hf);
  if (!e || !s.length) return null;
  const o = e.model.fields.find((r) => r.kind === "size" && (r.options || []).some((a) => a.value === Wa.size));
  return {
    title: Wa.title,
    place: !0,
    sessions: [{
      name: Wa.session,
      modelId: e.id,
      job: "generate",
      prompt: Wa.prompt,
      n: 1,
      runs: s.map((r) => ({ imageIds: n ? [r.id, n.id] : [r.id] })),
      ...o ? { settings: { [o.label]: Wa.size } } : {},
      why: Wa.why
    }]
  };
}
class hRe {
  constructor(e = {}) {
    tp(this, "id", "tour"), tp(this, "label", "Assistant"), tp(this, "pace"), tp(this, "sleep"), this.pace = e.pace == null ? 1 : e.pace, this.sleep = e.sleep || dRe;
  }
  wait(e) {
    return this.pace > 0 ? this.sleep(e * this.pace) : Promise.resolve();
  }
  async *say(e, t) {
    for (const n of C8(e)) {
      if (t.aborted) return;
      yield { type: "text", delta: n }, await this.wait(26);
    }
  }
  // Its status lines hold long enough to read (IL-100): a first-timer is
  // reading the card beside the chat as well, and at a model's own pace
  // (1.1 s, 0.5 s) they went by unread.
  async *turn(e, t) {
    if (e.input.kind === "plan-ended") {
      yield { type: "status", text: "Looking at what it made…" }, await this.wait(1500), yield* this.say(iAe, t);
      return;
    }
    if (yield { type: "status", text: "Reading the frame…" }, await this.wait(2e3), t.aborted) return;
    const n = uRe(e);
    if (!n) {
      yield* this.say(cRe, t);
      return;
    }
    yield* this.say(nAe, t), !t.aborted && (yield { type: "status", text: "Pricing the plan…" }, await this.wait(1300), !t.aborted && (yield { type: "plan", plan: n }));
  }
}
var pRe = Object.defineProperty, fRe = (i, e, t) => e in i ? pRe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, It = (i, e, t) => fRe(i, typeof e != "symbol" ? e + "" : e, t);
const hP = { enter: 520, success: 780, fly: 900, intro: fu * 1e3, chatRun: 2400 };
function mRe(i, e) {
  const t = (i.title + " " + i.body).split(/\s+/).filter(Boolean).length, n = Math.min(4600, t * 230) * (e / hP.success);
  return Math.round(Math.max(e * 1.8, n));
}
const gRe = /* @__PURE__ */ new Set(["contextmenu", "dblclick", "auxclick"]), bRe = /* @__PURE__ */ new Set(["Shift", "Meta", "Control", "Alt", "CapsLock", "Fn", "OS", "Hyper", "Super"]), Qn = (i) => () => document.querySelector(i), v3 = '[data-testid="studio-stage"] .sv-pic', vRe = {
  session: '.up-card [data-testid="prompt-text"]',
  edit: '[data-testid="studio-edit-prompt"]',
  chat: '[data-testid="chat-input"]'
};
class yRe {
  constructor(e) {
    It(this, "reason"), It(this, "canSkip"), It(this, "boardRef"), It(this, "step", /* @__PURE__ */ qe(Wi[0])), It(this, "index", /* @__PURE__ */ qe(0)), It(this, "phase", /* @__PURE__ */ qe("enter")), It(this, "nudges", /* @__PURE__ */ qe(0)), It(this, "nudgeHint", /* @__PURE__ */ qe("")), It(this, "toolId", /* @__PURE__ */ qe(null)), It(this, "placedId", /* @__PURE__ */ qe(null)), It(this, "chatId", /* @__PURE__ */ qe(null)), It(this, "asked", /* @__PURE__ */ qe(!1)), It(this, "typingField", /* @__PURE__ */ qe(null)), It(this, "board", /* @__PURE__ */ qe(null)), It(this, "intro", /* @__PURE__ */ qe(null)), It(this, "hooks"), It(this, "opts"), It(this, "timing"), It(this, "tabs", /* @__PURE__ */ Xt({ session: 0, edit: 0, chat: 0 })), It(this, "timers", []), It(this, "stops", []), It(this, "stepStops", []), It(this, "started", !1), It(this, "disposed", !1), It(this, "listening", !1), It(this, "rt", {}), It(this, "snaps", /* @__PURE__ */ new Map()), It(this, "boardTick", /* @__PURE__ */ qe(0)), It(this, "waiting", I(() => (this.step.value, this.boardTick.value, this.phase.value === "task" && !!this.rt.waiting && this.rt.waiting()))), It(this, "targets", I(() => (this.step.value, this.board.value, this.toolId.value, this.placedId.value, this.phase.value, this.waiting.value, this.rt.targets ? this.rt.targets() : []))), It(this, "cardPlace", I(() => (this.step.value, this.phase.value, this.waiting.value, this.rt.card ? this.rt.card() : { place: this.step.value.place }))), It(this, "onKey", (n) => {
      if (bRe.has(n.key) || xRe(n) || !this.inScope(n.target)) return;
      if (this.intro.value) {
        n.preventDefault(), n.stopImmediatePropagation(), !n.repeat && (n.key === "Escape" || n.key === "Enter" || n.key === " ") && this.skipIntro();
        return;
      }
      const s = n.target, o = !!(s && s.closest && s.closest("[data-tour-ui]")), r = this.step.value;
      if (o && (n.key === "Enter" || n.key === " " || n.key === "Tab" && r.kind !== "tab")) return;
      const a = this.phase.value === "task" && this.rt.key ? this.rt.key(n) : void 0;
      if (a !== "pass" && (n.preventDefault(), n.stopImmediatePropagation(), !(a === "handled" || n.repeat))) {
        if (this.phase.value === "task" && r.kind === "continue" && n.key === "Enter") {
          this.next();
          return;
        }
        this.phase.value === "task" && this.nudge(w3(r));
      }
    }), It(this, "onPointer", (n) => {
      const s = n.target;
      this.inScope(s) && (s && s.closest && s.closest("[data-tour-ui]") || n.type !== "wheel" && !gRe.has(n.type) && this.phase.value === "task" && this.rt.hands && this.inTargets(s, n) || (n.cancelable && n.preventDefault(), n.stopImmediatePropagation(), n.type === "pointerdown" && this.phase.value === "task" && this.step.value.kind !== "continue" && this.nudge(w3(this.step.value))));
    }), this.opts = e, this.reason = e.reason, this.canSkip = e.canSkip, this.boardRef = e.board, this.timing = { ...hP, ...e.reducedMotion ? { fly: 0, enter: 200, intro: 0 } : {}, ...e.timing || {} }, this.intro.value = this.timing.intro > 0 ? "waiting" : null;
    const t = this;
    this.hooks = {
      chat: e.chat || new hRe(),
      lineFor(n, s) {
        const o = t.step.value.id;
        return n === "chat" ? s === t.chatId.value && o === "chat-tab" ? tAe : null : s !== t.toolId.value ? null : n === "session" ? o === "tab-prompt" ? a3 : null : o === "edit-tab" ? l3 : null;
      },
      holds(n, s) {
        return n === "chat" ? s === t.chatId.value && t.index.value >= x3("chat-tab") : s !== t.toolId.value ? !1 : t.index.value >= x3(n === "session" ? "tab-prompt" : "edit-tab");
      },
      tabbed(n) {
        return t.tabs[n];
      },
      typing(n, s) {
        t.typingField.value = s ? n : null, n === "chat" && !s && (t.asked.value = !0);
      },
      landing() {
        return t.step.value.id === "add-session" ? { ...ev } : null;
      },
      press(n) {
        const s = t.step.value.id;
        t.phase.value !== "task" || t.typingField.value === n || (n === "session" && s === "tab-prompt" || n === "edit" && s === "edit-tab" || n === "chat" && s === "chat-tab") && t.tabs[n]++;
      }
    };
  }
  /** the tour began: its practice board opened and is drawing */
  get isStarted() {
    return this.started;
  }
  // ---------------------------------------------------------------- the board
  /** The practice board's controller, as it opens (and again, if the tour starts over on a new one). */
  attach(e) {
    for (const t of this.stops) t();
    this.stops = [], this.board.value = e, e && (e.tour = this.hooks, this.stops.push(Ae(() => e.results.rev.value, () => {
      this.boardTick.value++;
    })), this.stops.push(Ae(() => e.loaded.value, (t) => {
      if (!t || this.started) return;
      const n = () => {
        if (!(this.disposed || this.started || this.board.value !== e)) {
          if (!e.engine) {
            requestAnimationFrame(n);
            return;
          }
          this.started = !0, this.listen(), this.opts.onProgress && this.opts.onProgress({ status: "started", step: Wi[0].id }), this.go(0);
        }
      };
      n();
    }, { immediate: !0 })));
  }
  /** Back to the welcome, on a fresh board (the finale's Take the tour again). */
  reset() {
    this.clearStep(), this.snaps.clear(), this.started = !1, this.toolId.value = null, this.placedId.value = null, this.chatId.value = null, this.asked.value = !1, this.typingField.value = null, this.tabs.session = 0, this.tabs.edit = 0, this.tabs.chat = 0, this.index.value = 0, this.step.value = Wi[0], this.phase.value = "enter";
  }
  dispose() {
    this.disposed = !0, this.clearStep();
    for (const t of this.stops) t();
    this.stops = [], this.unlisten();
    const e = this.board.value;
    e && e.tour === this.hooks && (e.tour = null);
  }
  // ---------------------------------------------------------------- playing
  go(e) {
    if (this.disposed) return;
    this.clearStep();
    const t = Wi[Math.max(0, Math.min(Wi.length - 1, e))];
    if (this.capture(Wi.indexOf(t)), this.index.value = Wi.indexOf(t), this.step.value = t, this.nudgeHint.value = "", this.rt = this.runtime(t.id), this.phase.value = "enter", this.rt.enter && this.rt.enter(), t.id === "finale" && this.opts.onProgress && this.opts.onProgress({ status: "completed", step: t.id }), t.id === "welcome" && this.intro.value === "waiting") {
      this.intro.value = "playing", this.later(() => this.introDone(), this.timing.intro + 4e3);
      return;
    }
    t.id !== "welcome" && (this.intro.value = null), this.later(() => this.arrive(), this.timing.enter);
  }
  /** The step has arrived: it takes input, and watches the board for being done. */
  arrive() {
    const e = this.step.value;
    this.phase.value = e.id === "finale" ? "finished" : "task";
    const t = this.rt;
    t.done && this.stepStops.push(Ae(() => (this.boardTick.value, t.done()), (n) => {
      n && this.phase.value === "task" && this.succeed();
    }, { immediate: !0 })), t.watchStray && t.watchStray();
  }
  /** The opening has played (or was skipped): the welcome takes over. */
  introDone() {
    this.intro.value === "playing" && (this.intro.value = null, this.step.value.id === "welcome" && this.phase.value === "enter" && this.arrive());
  }
  /** Skip intro (its button, Esc, Enter or Space) while it plays. */
  skipIntro() {
    this.introDone();
  }
  /** The step is done: a beat, then the next (long enough to read, when a run has landed and says so). */
  succeed() {
    if (this.phase.value !== "task") return;
    this.rt.onDone && this.rt.onDone(), this.phase.value = "success";
    const e = this.index.value, t = this.step.value.landed;
    this.later(() => {
      this.index.value === e && this.go(e + 1);
    }, t ? mRe(t, this.timing.success) : this.timing.success);
  }
  /** The harness and tests: straight to a step (its board readied as the step readies it). */
  goTo(e) {
    const t = Wi.findIndex((n) => n.id === e);
    t >= 0 && this.go(t);
  }
  /** Continue (the button, or Enter), on a step that only says something. */
  next() {
    this.phase.value !== "task" || this.step.value.kind !== "continue" || this.go(this.index.value + 1);
  }
  /**
   * Back, to the step before (TD-03): from any step but the first, once it's
   * taking input and nothing's on its way. What the steps since put on the
   * practice board (a session, a run's pictures, a placed picture, a chat and
   * its plan, typed words) goes, so the step before can be done again.
   */
  get canBack() {
    const e = this.index.value;
    return e > 0 && this.step.value.id !== "finale" && this.phase.value === "task" && !this.waiting.value && !this.typingField.value && this.snaps.has(e - 1);
  }
  back() {
    if (!this.canBack) return;
    const e = this.index.value - 1, t = this.snaps.get(e), n = this.board.value;
    this.clearStep(), n && n.tourRestore(t.board), this.toolId.value = t.toolId, this.placedId.value = t.placedId, this.chatId.value = t.chatId, this.asked.value = t.asked, this.tabs.session = t.tabs.session, this.tabs.edit = t.tabs.edit, this.tabs.chat = t.tabs.chat;
    const s = this.studio();
    if (s && t.studio) {
      s.s.studio !== t.studio.side && s.setStudio(t.studio.side), s.s.asks = { ...t.studio.asks };
      const o = t.studio.stageId;
      o && s.s.stageId !== o && s.show(o);
    }
    this.go(e);
  }
  /** The practice board and the tour's notes as step `i` begins, for a Back to it. */
  capture(e) {
    const t = this.board.value;
    if (!t) return;
    const n = this.studio();
    this.snaps.set(e, {
      board: t.tourSnapshot(),
      toolId: this.toolId.value,
      placedId: this.placedId.value,
      chatId: this.chatId.value,
      asked: this.asked.value,
      tabs: { ...this.tabs },
      studio: n ? { side: n.s.studio, asks: { ...n.s.asks }, stageId: n.s.stageId } : null
    });
    for (const s of Array.from(this.snaps.keys())) s > e && this.snaps.delete(s);
  }
  /** Skip (or Exit): only where it's offered. */
  skip() {
    !this.canSkip || this.disposed || (this.opts.onProgress && this.opts.onProgress({ status: "skipped", step: this.step.value.id }), this.opts.onExit("skip"));
  }
  /** The finale's way out. */
  finish(e) {
    this.phase.value === "finished" && this.opts.onExit(e);
  }
  /** The finale's Take the tour again. */
  again() {
    this.phase.value === "finished" && this.opts.restart && this.opts.restart();
  }
  clearStep() {
    for (const e of this.timers) clearTimeout(e);
    this.timers = [];
    for (const e of this.stepStops) e();
    this.stepStops = [], this.rt = {};
  }
  later(e, t) {
    this.timers.push(window.setTimeout(e, t));
  }
  nudge(e = "") {
    this.nudgeHint.value = e, this.nudges.value++;
  }
  // ---------------------------------------------------------------- the steps
  tool() {
    const e = this.board.value, t = this.toolId.value, n = e && t ? e.store.get(t) : null;
    return n && n.type === "tool" ? n : null;
  }
  studio() {
    const e = this.board.value, t = this.toolId.value;
    return e && t ? L0(e, t) : null;
  }
  results() {
    const e = this.board.value, t = this.toolId.value;
    return !e || !t ? [] : (this.boardTick.value, e.results.list(t));
  }
  runtime(e) {
    const t = this.board.value;
    switch (e) {
      case "welcome":
        return {
          enter: () => {
            t.clearSelection(), this.flyTo(Bp([Hn, Go]), { zoom: 0.62, ax: 0.5, ay: 0.46 });
          }
        };
      case "look":
        return {
          enter: () => {
            t.clearSelection(), this.flyTo(Bp([Hn, Go]), { fit: 0.84, maxZoom: 0.95, ax: 0.5, ay: 0.4 });
          },
          targets: () => [
            { key: "site", world: () => this.rectOf(Hn.id), pad: 10, padTop: 40, radius: 18 },
            { key: "brief", world: () => this.rectOf(Go.id), pad: 10, radius: 18 }
          ]
        };
      case "add-session":
        return {
          enter: () => {
            t.clearSelection(), this.flyTo({ x: ev.x - 1, y: ev.y - 1, w: 2, h: 2 }, { zoom: 0.8, ax: 0.68, ay: 0.28 });
          },
          // the dock's +, then (its menu up) the menu's Image: a session starts from a choice of kit (CHAT-20)
          targets: () => t.ui.addMenu ? [{ key: "add-image", el: Qn('[data-testid="add-kit-image"]'), pad: 4, radius: 12 }] : [{ key: "add", el: Qn('[data-testid="all-tools"]'), pad: 6, radius: 14 }],
          hands: !0,
          done: () => !!this.addedTool(),
          onDone: () => {
            const n = this.addedTool();
            n && this.adopt(n);
          }
        };
      case "open-session":
        return {
          enter: () => {
            const n = this.tool();
            n && this.flyTo(He(n), { zoom: 1.12, ax: 0.3, ay: 0.34 });
          },
          targets: () => [{ key: "session", el: () => this.sessionCard(), pad: 8, radius: 22 }],
          hands: !0,
          done: () => !!t.promptTool.value && t.promptTool.value.id === this.toolId.value
        };
      case "tab-prompt":
        return {
          enter: () => {
            this.keepOpen(), this.focusField("session");
          },
          targets: () => [{ key: "prompt", box: () => np('.up-card [data-testid="prompt-text"]', '.up-card [data-testid="ghost-cue"]'), pad: 12, radius: 14 }],
          hands: !0,
          done: () => {
            t.promptRev.value;
            const n = this.toolId.value;
            return !!n && t.promptOf(n).prompt === a3 && this.typingField.value !== "session";
          },
          key: (n) => this.tabKey(n, "session")
        };
      case "run":
        return {
          enter: () => {
            this.keepOpen(), this.opts.gen.planned || this.opts.gen.plan(Gf);
          },
          // once it runs, the light moves to where the images land, and stays there as they
          // land (the success beat), so nothing jumps back to Run before the next step
          targets: () => this.results().length > 0 ? [
            { key: "session", el: () => this.sessionCard(), pad: 8, radius: 22, look: !0, ring: !0 },
            { key: "gallery", box: () => this.galleryBox(), pad: 6, radius: 16, look: !0 }
          ] : [{ key: "run", el: Qn('[data-testid="run"]'), pad: 6, radius: 14 }],
          hands: !0,
          waiting: () => this.results().some((n) => n.status === "pending"),
          done: () => this.results().filter((n) => n.status === "done").length >= d3,
          key: (n) => this.runKey(n, '[data-testid="run"]'),
          card: () => this.results().length > 0 ? { place: "right", anchor: "session" } : { place: "above" }
        };
      case "results":
        return {
          enter: () => {
            this.keepOpen(), t.ui.histOpen = !0;
          },
          targets: () => [
            { key: "session", el: () => this.sessionCard(), pad: 8, radius: 22 },
            { key: "gallery", box: () => this.galleryBox(), pad: 6, radius: 16 }
          ],
          card: () => ({ place: "right", anchor: "session" })
        };
      case "drag":
        return {
          enter: () => {
            this.keepOpen(), t.ui.histOpen = !0;
          },
          targets: () => [
            { key: "gallery", box: () => this.galleryBox(), pad: 6, radius: 16 },
            { key: "pick", el: Qn('[data-testid="results-gallery"] .shot'), pad: 0, radius: 10, look: !0 },
            { key: "slot", world: () => this.dropSlot(), pad: 0, radius: 16, drop: "Drop it here", look: !0 },
            // the session the picture came from, beside where it goes; its pictures drag out
            // as the gallery's do (CHAT-03: lit, and saying so as you hovered, but they stuck)
            { key: "session", el: () => this.sessionCard(), pad: 8, radius: 22, look: !0, takes: ".cv-thumb-pull" }
          ],
          card: () => ({ place: "below", anchor: "slot" }),
          hands: !0,
          // dropped, not just carried over the board (the board makes the picture as the drag
          // crosses the canvas, and takes it back if it's carried off again)
          done: () => !!this.placedImage() && !t.ui.dragging,
          onDone: () => {
            const n = this.placedImage();
            n && (this.placedId.value = n.id);
          },
          watchStray: () => {
            this.stepStops.push(Ae(() => t.ui.infoAt, (n) => {
              n && (t.ui.infoAt = null, this.nudge("Hold the picture, then drag it onto the board"));
            }));
          }
        };
      case "studio-open":
        return {
          enter: () => {
            this.keepOpen();
          },
          targets: () => [{ key: "studio", el: Qn(".up-studio-wrap"), pad: 6, radius: 999 }],
          hands: !0,
          done: () => !!t.ui.studio && t.ui.studio.sessionId === this.toolId.value
        };
      case "edit-side":
        return {
          enter: () => {
            const n = this.studio(), s = this.placedResultId();
            n && s && this.later(() => n.show(s), 60);
          },
          targets: () => [{ key: "edit", el: Qn('[data-testid="studio-side-edit"]'), pad: 5, radius: 12 }],
          hands: !0,
          done: () => {
            const n = this.studio();
            return !!n && n.side.value === "edit";
          }
        };
      case "edit-tab":
        return {
          enter: () => this.focusField("edit"),
          targets: () => [{ key: "words", box: () => np('[data-testid="studio-edit-prompt"]', '[data-testid="studio-ghost-cue"]'), pad: 10, radius: 14 }],
          hands: !0,
          done: () => {
            const n = this.studio();
            return !!n && n.askOf(n.s.stageId) === l3 && this.typingField.value !== "edit";
          },
          key: (n) => this.tabKey(n, "edit")
        };
      case "edit-run":
        return {
          enter: () => {
            this.opts.gen.planned || this.opts.gen.plan([nc]);
          },
          // once it runs, the light moves to the picture, where the new version arrives, and
          // stays there as it lands
          targets: () => this.results().some((n) => n.status === "pending" || n.url === nc.src) ? [{ key: "stage", el: Qn(v3), pad: 10, padTop: 32, radius: 16, look: !0, ring: !0 }] : [{ key: "run", el: Qn('[data-testid="studio-edit-generate"]'), pad: 6, radius: 14 }],
          hands: !0,
          waiting: () => this.results().some((n) => n.status === "pending"),
          done: () => this.results().some((n) => n.status === "done" && n.url === nc.src),
          key: (n) => this.runKey(n, '[data-testid="studio-edit-generate"]')
        };
      case "edit-result":
        return {
          enter: () => {
            const n = this.studio(), s = this.results().find((o) => o.status === "done" && o.url === nc.src);
            n && s && n.s.stageId !== s.id && n.show(s.id);
          },
          targets: () => [
            // the picture (and its tag), not the whole stage round it, as while the edit ran: the card keeps its
            // corner from the run, with no flight across the window
            { key: "stage", el: Qn(v3), pad: 10, padTop: 32, radius: 16 },
            // the versions themselves, not their whole bar
            { key: "versions", box: () => t1(Array.from(document.querySelectorAll('[data-testid="studio-version"]'))), pad: 6, radius: 14 }
          ]
        };
      case "chat-open":
        return {
          enter: () => {
            this.closeStudio(), t.ui.histOpen = !1, this.addTower(), t.select([Hn.id]), this.flyTo(this.rectOf(Hn.id), { fitW: 0.42, fitH: 0.5, maxZoom: 0.58, ax: 0.28, ay: 0.42 });
          },
          targets: () => [
            { key: "chat", el: Qn('[data-testid="ctx-chat"]'), pad: 6, radius: 12 },
            { key: "site", world: () => this.rectOf(Hn.id), pad: 10, padTop: 40, radius: 18, look: !0 }
          ],
          hands: !0,
          done: () => !!this.openChat(),
          onDone: () => {
            const n = this.openChat();
            n && (this.chatId.value = n.id);
          },
          card: () => ({ place: "right", anchor: "site" })
        };
      case "chat-tab":
        return {
          enter: () => this.focusField("chat"),
          targets: () => [{ key: "ask", box: () => np('[data-testid="chat-input"]', '[data-testid="chat-ghost-cue"]'), pad: 10, radius: 14 }],
          hands: !0,
          done: () => this.asked.value && this.typingField.value !== "chat",
          key: (n) => this.tabKey(n, "chat")
        };
      case "chat-send":
        return {
          // once it's sent, the light moves to where the answer arrives, and stays there as the plan lands;
          // till then the card keeps clear of the message it asks you to send
          targets: () => this.sent() ? [{ key: "answer", el: Qn('[data-testid="chat-panel"] .ch-scroll'), pad: 0, radius: 14, look: !0, ring: !0 }] : [
            { key: "send", el: Qn('[data-testid="chat-send"]'), pad: 6, radius: 999 },
            { key: "ask", box: () => np('[data-testid="chat-input"]', '[data-testid="chat-send"]'), pad: 10, radius: 14, look: !0 }
          ],
          hands: !0,
          waiting: () => this.chatBusy(),
          done: () => !!this.chatPlan("proposed"),
          key: (n) => this.sendKey(n),
          card: () => ({ place: "left", anchor: this.sent() ? "answer" : "ask" })
        };
      case "chat-run":
        return {
          enter: () => this.planChatRuns(),
          // once it runs, the light moves to the frame, where the work lands, and to the plan's rows ticking
          targets: () => this.chatPlan("started") ? [
            { key: "frame", world: () => this.rectOf(Hn.id), pad: 10, padTop: 40, radius: 18, look: !0, ring: !0 },
            { key: "steps", el: Qn('[data-testid="chat-panel"] [data-testid="plan-steps"]'), pad: 6, radius: 12, look: !0 }
          ] : [
            { key: "plan-run", el: Qn('[data-testid="chat-panel"] [data-testid="plan-run"]'), pad: 6, radius: 12 },
            // the whole plan shows, and the card keeps off it (its prompt, its cost, Cancel)
            { key: "plan", el: Qn('[data-testid="chat-panel"] [data-testid="plan-card"]'), pad: 4, radius: 14, look: !0 }
          ],
          hands: !0,
          waiting: () => !!this.chatPlan("started") && !this.chatSettled(),
          // the plan has run and the chat has said how it went
          done: () => this.chatSettled(),
          key: (n) => this.runKey(n, '[data-testid="chat-panel"] [data-testid="plan-run"]'),
          card: () => ({ place: "left", anchor: this.chatPlan("started") ? "steps" : "plan" })
        };
      case "chat-result":
        return {
          targets: () => [{ key: "made", world: () => this.chatWork(), pad: 12, radius: 18 }],
          card: () => ({ place: "left", anchor: "made" })
        };
      case "organize":
        return {
          enter: () => {
            this.closeStudio(), t.ui.chatOpen = null, t.clearSelection(), t.ui.histOpen = !1;
            const n = t.store.bounds(), s = Math.max(160, t.view.h - uu - 320);
            n && this.flyTo(n, { fitW: 0.84, fitH: s / t.view.h, maxZoom: 0.9, ax: 0.5, ay: (uu + 6 + s / 2) / t.view.h });
          },
          targets: () => [{ key: "board", world: () => t.store.bounds(), pad: 26, radius: 24, look: !0 }]
        };
      case "finale":
        return {
          enter: () => {
            t.clearSelection();
            const n = t.store.bounds();
            n && this.flyTo(n, { fit: 0.7, maxZoom: 0.9, ax: 0.5, ay: 0.5 });
          }
        };
    }
    return {};
  }
  /** The session Image Gen added (the board holds no other). */
  addedTool() {
    const e = this.board.value;
    if (!e) return null;
    e.docRev.value;
    for (const t of e.store.all()) if (t.type === "tool") return t;
    return null;
  }
  /** The session the tour had you add, set to make four, waiting closed on the board. */
  adopt(e) {
    const t = this.board.value;
    this.toolId.value = e.id, t.setPrompt(e.id, { n: d3 }), t.clearSelection();
  }
  /** The session's prompt stays up while the steps need it. */
  keepOpen() {
    const e = this.board.value, t = this.toolId.value;
    !e || !t || (!e.promptTool.value || e.promptTool.value.id !== t) && e.select([t]);
  }
  sessionCard() {
    const e = this.toolId.value;
    return e ? document.querySelector('[data-el="' + e + '"] .cv-bucket') || document.querySelector('[data-el="' + e + '"]') : null;
  }
  rectOf(e) {
    const t = this.board.value, n = t ? t.store.get(e) : null;
    return n ? He(n) : null;
  }
  /** The gallery's pictures and its head, as one box (not the empty panel below them). */
  galleryBox() {
    const e = document.querySelector('[data-testid="results-gallery"]');
    if (!e) return null;
    const t = Array.from(e.querySelectorAll(".v2-hist-head, .v2-hist-item"));
    return t1(t.length ? t : [e]);
  }
  /** Where the drag step suggests the picture goes: right of the session. */
  dropSlot() {
    const e = this.tool();
    if (!e) return null;
    const t = 236;
    return { x: e.x + e.w + 56, y: e.y + e.h / 2 - t * Va.h / Va.w / 2, w: t, h: Math.round(t * Va.h / Va.w) };
  }
  /** A picture on the board placed from the session's gallery. */
  placedImage() {
    const e = this.board.value, t = this.toolId.value;
    if (!e || !t) return null;
    e.docRev.value;
    const n = new Set(this.results().map((s) => s.id));
    for (const s of e.store.all()) {
      if (s.type !== "image") continue;
      const o = s;
      if (o.sessionId === t || o.resultId && n.has(o.resultId)) return o;
    }
    return null;
  }
  /**
   * The tower goes into the site photos' frame before the chat sees it
   * (TD-04): the render you placed on the board, else the run's first, at
   * the frame's front. Once: a Back or a second visit finds it there.
   */
  addTower() {
    const e = this.board.value;
    if (!e || e.store.get(Hf)) return;
    const t = this.placedId.value ? e.store.get(this.placedId.value) : void 0, n = t && t.src ? t.src : Gf[0].src, s = t && t.w && t.h ? t.w / t.h : Va.w / Va.h, { frame: o, tower: r } = oRe(n, s);
    e.store.update(Hn.id, o, { history: !1 }), e.store.add([r], { history: !1 });
  }
  placedResultId() {
    const e = this.board.value, t = this.placedId.value, n = e && t ? e.store.get(t) : void 0;
    if (n && n.resultId) return n.resultId;
    const s = this.results().find((o) => o.status === "done");
    return s ? s.id : null;
  }
  focusField(e) {
    this.later(() => {
      const t = document.querySelector(vRe[e]);
      t && document.activeElement !== t && t.focus({ preventScroll: !0 });
    }, 80);
  }
  /** Done with Studio view: closed, as its back arrow closes it. */
  closeStudio() {
    const e = this.board.value;
    !e || !e.ui.studio || (L0(e, e.ui.studio.sessionId).leave(), e.closeStudio());
  }
  /** The chat open in the panel (Chat on the frame made it). */
  openChat() {
    const e = this.board.value;
    if (!e) return null;
    e.docRev.value;
    const t = e.ui.chatOpen, n = t ? e.store.get(t) : void 0;
    return n && n.type === "chat" ? n : null;
  }
  /** The chat you started, as it stands. */
  chat() {
    const e = this.board.value, t = this.chatId.value;
    if (!e || !t) return null;
    e.docRev.value;
    const n = e.store.get(t);
    return n && n.type === "chat" ? n : null;
  }
  /** Your message is in the chat. */
  sent() {
    const e = this.chat();
    return !!e && (e.messages || []).some((t) => t.role === "user");
  }
  /** The chat is answering. */
  chatBusy() {
    const e = this.board.value, t = this.chatId.value;
    return !!e && !!t && os(e).busy(t);
  }
  /** Its plan: waiting for Run plan (`proposed`), or run, running or done (`started`). */
  chatPlan(e) {
    const t = this.chat(), n = t && t.messages || [];
    for (let s = n.length - 1; s >= 0; s--) {
      const o = n[s].plan;
      if (o && (e === "proposed" ? o.status === "proposed" : o.status !== "proposed" && o.status !== "cancelled")) return o;
    }
    return null;
  }
  /** The plan has run, and the chat has said how it went. */
  chatSettled() {
    const e = this.chatPlan("started");
    return !!e && e.status === "done" && !this.chatBusy();
  }
  /** Each of the plan's runs lands its photo's finished view, in the plan's order. */
  planChatRuns() {
    const e = this.chatPlan("proposed"), t = this.opts.gen;
    if (!(!e || t.planned))
      for (const n of e.sessions)
        for (const s of n.runs) {
          const o = s.images && s.images.length ? sRe(s.images[0].id) : null, r = o && Q0[o] || Object.values(Q0)[0];
          t.plan([r], { first: this.timing.chatRun });
        }
  }
  /** What the chat's plan made: its session, and the pictures set out under it. */
  chatWork() {
    const e = this.board.value, t = this.chatPlan("started");
    if (!e || !t) return null;
    e.docRev.value;
    const n = new Set(t.sessions.map((o) => o.toolId || o.addedId).filter((o) => !!o)), s = [];
    for (const o of e.store.all())
      (n.has(o.id) || o.type === "image" && o.sessionId && n.has(o.sessionId)) && s.push(He(o));
    return s.length ? Bp(s) : null;
  }
  /** Enter sends the chat's message (as the composer's own Enter does), wherever the focus is. */
  sendKey(e) {
    if (!(e.key !== "Enter" || e.shiftKey || e.altKey)) {
      if (!e.repeat) {
        const t = document.querySelector('[data-testid="chat-send"]');
        t && !t.disabled && t.click();
      }
      return "handled";
    }
  }
  tabKey(e, t) {
    if (e.key === "Tab")
      return e.shiftKey || e.metaKey || e.ctrlKey || e.altKey || !e.repeat && this.typingField.value !== t && (this.focusField(t), this.tabs[t]++), "handled";
  }
  runKey(e, t) {
    if (!(e.key !== "Enter" || !kn(e))) {
      if (!e.repeat) {
        const n = document.querySelector(t);
        n && !n.disabled && n.click();
      }
      return "handled";
    }
  }
  // ---------------------------------------------------------------- the camera
  /**
   * Fly so a place on the board sits at (ax, ay) of the view (fractions),
   * at `zoom`, or zoomed to fill `fit` of the view (no closer than maxZoom).
   */
  flyTo(e, t) {
    const n = this.board.value;
    if (!n || !n.engine || !e) return;
    const s = n.view.w, o = n.view.h;
    let r = t.zoom || 1;
    const a = t.fitW || t.fit, l = t.fitH || t.fit;
    a && l && (r = Math.min(t.maxZoom || 1, s * a / Math.max(1, e.w), o * l / Math.max(1, e.h)));
    const d = { zoom: r, x: s * t.ax - (e.x + e.w / 2) * r, y: o * t.ay - (e.y + e.h / 2) * r };
    this.timing.fly ? n.engine.animateCamera(d, this.timing.fly) : n.setCamera(d);
  }
  // ---------------------------------------------------------------- holding the board still
  listen() {
    if (!this.listening) {
      this.listening = !0, window.addEventListener("keydown", this.onKey, !0);
      for (const e of y3) window.addEventListener(e, this.onPointer, { capture: !0, passive: !1 });
    }
  }
  unlisten() {
    if (this.listening) {
      this.listening = !1, window.removeEventListener("keydown", this.onKey, !0);
      for (const e of y3) window.removeEventListener(e, this.onPointer, { capture: !0 });
    }
  }
  /** Inside the tour's part of the page (the page itself counts: a key pressed with nothing focused). */
  inScope(e) {
    const t = this.opts.scope ? this.opts.scope() : null;
    return !t || !(e instanceof Node) ? !0 : e === document.body || e === document.documentElement || e === document || t.contains(e);
  }
  /** Inside a lit control that takes clicks: in its element, or (a box of several) within its bounds. */
  inTargets(e, t) {
    if (!e) return !1;
    const n = wRe(t);
    for (const s of this.targets.value) {
      if (s.look) {
        const o = s.takes, r = o && s.el ? s.el() : null, a = r && o ? e.closest(o) : null;
        if (r && a && r.contains(a)) return !0;
        continue;
      }
      if (s.el) {
        const o = s.el();
        if (o && (o === e || o.contains(e))) return !0;
      } else if (s.box && n) {
        const o = s.box();
        if (o && n.x >= o.x && n.x <= o.x + o.w && n.y >= o.y && n.y <= o.y + o.h) return !0;
      }
    }
    return !1;
  }
}
const y3 = ["pointerdown", "mousedown", "click", "dblclick", "auxclick", "contextmenu", "wheel", "touchstart", "dragstart"];
function xRe(i) {
  if (/^F\d{1,2}$/.test(i.key)) return !0;
  if (!i.metaKey && !i.ctrlKey) return !1;
  if (i.altKey) return !0;
  const e = i.key.toLowerCase();
  return ["r", "t", "w", "n", "q", "p", "f"].includes(e) || e === "l" && !i.shiftKey;
}
function x3(i) {
  return Wi.findIndex((e) => e.id === i);
}
function Bp(i) {
  const e = Math.min(...i.map((o) => o.x)), t = Math.min(...i.map((o) => o.y)), n = Math.max(...i.map((o) => o.x + o.w)), s = Math.max(...i.map((o) => o.y + o.h));
  return { x: e, y: t, w: n - e, h: s - t };
}
function w3(i) {
  return i.hint || "";
}
function wRe(i) {
  const e = i;
  if (typeof e.clientX == "number") return { x: e.clientX, y: e.clientY };
  const t = i.touches && i.touches[0];
  return t ? { x: t.clientX, y: t.clientY } : null;
}
function t1(i) {
  const e = i.map((t) => t.getBoundingClientRect()).filter((t) => t.width || t.height);
  return e.length ? Bp(e.map((t) => ({ x: t.left, y: t.top, w: t.width, h: t.height }))) : null;
}
function np(...i) {
  return t1(i.map((e) => document.querySelector(e)).filter((e) => !!e));
}
var kRe = Object.defineProperty, _Re = (i, e, t) => e in i ? kRe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, ip = (i, e, t) => _Re(i, typeof e != "symbol" ? e + "" : e, t);
const SRe = { first: 2600, gap: 420 };
class MRe {
  constructor(e, t = SRe) {
    ip(this, "fallback", e), ip(this, "timing", t), ip(this, "queue", []), ip(this, "runs", 0);
  }
  /** What the next run makes (several plans wait their turn), and, when it isn't the usual, how soon it lands. */
  plan(e, t = {}) {
    this.queue.push({ pictures: e, timing: { ...this.timing, ...t } });
  }
  /** Forget every plan (the tour starting over). */
  reset() {
    this.queue.length = 0, this.runs = 0;
  }
  /** Plans not yet used. */
  get planned() {
    return this.queue.length;
  }
  run(e, t) {
    this.runs++;
    const n = St(), s = this.queue.shift(), o = s ? s.pictures : this.fallback, r = s ? s.timing : this.timing, a = Uy(e.aspect || "3:4"), l = Date.now(), d = [];
    for (let p = 0; p < e.count; p++)
      d.push({
        id: St(),
        sessionId: e.sessionId,
        status: "pending",
        url: "",
        w: a.w,
        h: a.h,
        prompt: e.prompt,
        model: e.model.name,
        modelId: e.model.id,
        inputs: e.inputs,
        refs: e.refs,
        seed: 1e3 + p,
        author: e.author,
        createdAt: l + p,
        runId: n,
        parents: e.refs.slice()
      });
    const c = [];
    let h = !1;
    const f = [];
    return d.forEach((p, y) => {
      c.push(window.setTimeout(() => {
        if (h) return;
        const v = o[y % o.length], x = { ...p, status: "done", url: v.src, label: v.label };
        f.push(x), t.onResult(x), f.length === d.length && t.onDone(f);
      }, r.first + y * r.gap));
    }), {
      runId: n,
      pending: d,
      cancel: () => {
        h = !0;
        for (const p of c) clearTimeout(p);
      }
    };
  }
}
const TRe = '.bl-hero{--stage-w: min(80%, 940px);position:relative;display:flex;flex-direction:column;align-items:center;margin:0 0 44px;border-radius:28px;background:var(--bg-deep);border:1px solid transparent;box-shadow:0 40px 120px #00000073;text-align:center}.bl-hero:before{content:"";position:absolute;inset:-1px;z-index:1;padding:1px;border-radius:inherit;background:linear-gradient(180deg,#d6c8f24d,#ffffff17 34%,#ffffff0d 70%,#ffffff12);-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask:linear-gradient(#000 0 0) content-box exclude,linear-gradient(#000 0 0);pointer-events:none}.bl-hero-clip{position:absolute;inset:0;border-radius:inherit;overflow:hidden;container-type:inline-size;pointer-events:none}.bl-hero-atmo{position:absolute;inset:0;background:radial-gradient(64% 44% at 50% -10%,rgba(255,255,255,.05),transparent 66%)}.bl-hero-light{position:absolute;inset:0}.bl-hero-lit{position:absolute;inset:0;-webkit-mask-image:var(--bl-survey, linear-gradient(transparent, transparent)),radial-gradient(64% 80% at 50% 42%,transparent 58%,#000 100%);-webkit-mask-size:3200px 1500px,100% 100%;-webkit-mask-position:50% calc(-1 * var(--bl-top, 0px)),0 0;-webkit-mask-repeat:no-repeat,no-repeat;-webkit-mask-composite:source-in;mask-image:var(--bl-survey, linear-gradient(transparent, transparent)),radial-gradient(64% 80% at 50% 42%,transparent 58%,#000 100%);mask-size:3200px 1500px,100% 100%;mask-position:50% calc(-1 * var(--bl-top, 0px)),0 0;mask-repeat:no-repeat,no-repeat;mask-composite:intersect}.bl-hero .glow{position:absolute;aspect-ratio:1;border-radius:50%;animation:bl-glow-drift calc(26s + var(--i) * 4.3s) ease-in-out calc(var(--i) * -5.1s) infinite alternate,bl-glow-breathe calc(12s + var(--i) * 2.2s) ease-in-out calc(var(--i) * -3.7s) infinite;animation-play-state:paused}.bl-hero-light .glow{filter:blur(40px)}.bl-hero.is-live .glow{animation-play-state:running}@keyframes bl-glow-drift{0%{transform:translate(0) scale(1)}50%{transform:translate(1.5cqw,9cqw) scale(1.08)}to{transform:translate(-1cqw,-5cqw) scale(.95)}}@keyframes bl-glow-breathe{0%,to{opacity:.6}50%{opacity:1}}.bl-hero-stage{position:absolute;left:50%;bottom:0;width:var(--stage-w);aspect-ratio:1180 / 540;transform:translate(-50%)}.bl-hero-stage:before{content:"";position:absolute;left:6%;right:6%;top:-14%;height:50%;border-radius:50%;background:radial-gradient(50% 50% at 50% 50%,rgba(170,160,225,.13),rgba(150,156,230,.04) 55%,transparent 75%);filter:blur(40px)}.bl-hero-room{flex:none;width:var(--stage-w);aspect-ratio:1180 / 540;margin-top:34px}.bl-hero-top{position:absolute;left:18px;top:18px;z-index:4;display:flex;text-align:left}.bl-hero-copy{position:relative;z-index:2;max-width:880px;padding:50px 24px 0}.bl-title{font-size:clamp(36px,4vw,54px);line-height:1.03;letter-spacing:-.045em;font-weight:500!important;color:#fff;background:linear-gradient(180deg,#fff 35%,#ffffffbd);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent}.bl-title em{font-style:normal;background:linear-gradient(100deg,#efe6ff 0%,var(--amethyst-700) 48%,var(--vista-blue-500) 100%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent}.bl-sub{max-width:820px;margin:14px auto 0!important;font-size:15.5px;line-height:1.55;color:#ffffff8f;text-wrap:balance}.bl-hero-actions{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:12px;margin-top:24px}.bl-hero-pause{position:absolute;right:16px;bottom:16px;z-index:3;display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;padding:0;border-radius:999px;border:1px solid rgba(255,255,255,.12);background:#12121a9e;color:#ffffffc7;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.bl-hero-pause:hover{background:#282836cc;color:#fff;border-color:#fff3}.bl-hero-pause:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:2px}.bl-hero-corner{position:absolute;right:18px;top:18px;z-index:4;display:flex;align-items:center;gap:8px}.bl-hero-tour{display:inline-flex;align-items:center;gap:7px;height:32px;padding:0 13px 0 10px;border-radius:999px;border:1px solid rgba(255,255,255,.1);background:#12121a80;color:#ffffffb8;font:500 12.5px var(--font-sans);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.bl-hero-tour .licon{color:var(--amethyst-700)}.bl-hero-tour:hover{background:#282836c7;color:#fff;border-color:#fff3}.bl-hero-tour:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:2px}.bl-hero-round{display:inline-flex;flex:none;align-items:center;justify-content:center;width:32px;height:32px;padding:0;border-radius:999px;border:1px solid rgba(255,255,255,.1);background:#12121a80;color:#ffffffb8;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast),border-color var(--dur-fast)}.bl-hero-round:hover{background:#282836c7;color:#fff;border-color:#fff3}.bl-hero-round:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:2px}.bl-hero.is-min{flex-direction:row;align-items:stretch;margin:0 0 26px;border-radius:0;background:none;border-color:transparent;box-shadow:none;text-align:left}.bl-hero.is-min:before{display:none}.bl-hero.is-min .bl-hero-copy{display:flex;flex:1;flex-wrap:wrap;align-items:flex-end;justify-content:space-between;gap:18px 32px;max-width:none;padding:8px 0 0;animation:bl-head-in .3s var(--ease-out-soft)}.bl-hero.is-min .bl-hero-text{flex:1 1 360px;min-width:0}.bl-hero.is-min .bl-title{font-size:clamp(28px,2.4vw,34px);letter-spacing:-.04em}.bl-hero.is-min .bl-sub{max-width:560px;margin:8px 0 0!important;font-size:14px;text-wrap:pretty}.bl-hero.is-min .bl-hero-actions{flex:none;justify-content:flex-end;gap:10px;margin-top:0}.bl-hero.is-min .bl-hero-tour{height:38px;padding:0 14px 0 12px}.bl-hero.is-min .bl-hero-round{width:38px;height:38px}@keyframes bl-head-in{0%{opacity:0;transform:translateY(4px)}to{opacity:1;transform:none}}.bl-hd{position:absolute;inset:0;pointer-events:none}.bl-hd-win{position:absolute;left:0;top:0;transform-origin:0 0;border-radius:16px;overflow:hidden;background:#070910;box-shadow:0 0 0 1px #ffffff1f,0 -8px 40px #00000080,0 50px 140px #000000e6;font-family:var(--font-sans);color:var(--fg-2);text-align:left;user-select:none;-webkit-user-select:none;contain:layout paint}.bl-hd-win:after{content:"";position:absolute;inset:0;z-index:9;border-radius:inherit;box-shadow:inset 0 1px #ffffff1a;pointer-events:none}.bl-hd img{display:block;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .6s var(--ease-out-soft)}.bl-hd img.is-in{opacity:1}.bl-hd img.is-broken{visibility:hidden}.bl-hd-bar{position:absolute;left:0;right:0;top:0;z-index:3;display:flex;align-items:center;gap:12px;height:44px;padding:0 16px;background:linear-gradient(180deg,#10121b,#0b0d14);border-bottom:1px solid rgba(255,255,255,.06)}.bl-hd-lights{display:inline-flex;gap:8px;margin-right:12px}.bl-hd-lights i{width:12px;height:12px;border-radius:50%;background:#ff5f57;box-shadow:inset 0 0 0 .5px #0000004d}.bl-hd-lights i:nth-child(2){background:#febc2e}.bl-hd-lights i:nth-child(3){background:#28c840}.bl-hd-mark{flex:none}.bl-hd-crumbs{font-size:13px;color:var(--fg-4);letter-spacing:-.005em;white-space:nowrap}.bl-hd-crumbs .sep{margin:0 5px;color:var(--fg-5)}.bl-hd-crumbs b{color:var(--fg-1);font-weight:600}.bl-hd-saved{margin-left:auto;display:inline-flex;align-items:center;gap:6px;font-size:11.5px;color:var(--fg-4)}.bl-hd-saved i{width:6px;height:6px;border-radius:50%;background:#ffffff47}.bl-hd-kebab{display:inline-flex;flex-direction:column;gap:2.5px;padding:0 8px 0 14px}.bl-hd-kebab i{width:3px;height:3px;border-radius:50%;background:var(--fg-4)}.bl-hd-canvas{position:absolute;inset:44px 0 0;overflow:hidden;background:radial-gradient(55% 75% at 16% 0%,rgba(117,50,211,.17),transparent 70%),radial-gradient(45% 60% at 90% 10%,rgba(90,97,237,.1),transparent 70%),#070910}.bl-hd-world{position:absolute;left:0;top:0;width:0;height:0;transform-origin:0 0}.bl-hd-dots{position:absolute;left:-900px;top:-800px;width:5600px;height:3400px}.bl-hd-dots.is-fine{background-image:radial-gradient(circle,rgba(255,255,255,.14) 1.2px,transparent 1.7px);background-size:26px 26px;opacity:clamp(0,calc((var(--z, 1) - .4) * 4),1)}.bl-hd-dots.is-coarse{background-image:radial-gradient(circle,rgba(255,255,255,.12) 3.4px,transparent 4.6px);background-size:104px 104px;opacity:clamp(0,calc((.66 - var(--z, 1)) * 4),1)}.bl-hd-frame{position:absolute;border-radius:22px;background:#ffffff06;border:1.5px solid rgba(255,255,255,.065)}.bl-hd-ftitle{position:absolute;left:4px;bottom:calc(100% + 10px);white-space:nowrap;font-size:11.5px;font-weight:600;letter-spacing:.26em;text-transform:uppercase;color:#ffffff94;opacity:clamp(0,calc((var(--z, 1) - .42) * 5),1)}.bl-hd-ftitle small{margin-left:8px;font-size:11.5px;font-weight:500;letter-spacing:.02em;text-transform:none;color:#ffffff4d}.bl-hd-flabel{position:absolute;left:0;bottom:100%;transform-origin:0 100%;transform:scale(var(--iz, 1)) translateY(-6px);white-space:nowrap;padding:3px 7px;border-radius:6px;background:#0c0e16eb;border:1px solid rgba(255,255,255,.1);font-size:8.5px;font-weight:600;letter-spacing:.2em;text-transform:uppercase;color:#ffffffb8;opacity:clamp(0,calc((.5 - var(--z, 1)) * 5),1)}.bl-hd-pic{position:absolute;border-radius:9px;overflow:hidden;background:#ffffff0b;box-shadow:0 14px 40px #02040c73,inset 0 0 0 1px #ffffff0d}.bl-hd-pic.is-result{opacity:0}.bl-hd-pic.is-video img{animation:bl-hd-drift 9s ease-in-out infinite alternate;animation-play-state:paused}.bl-hero.is-live .bl-hd-pic.is-video img{animation-play-state:running}@keyframes bl-hd-drift{0%{transform:scale(1)}to{transform:scale(1.09) translate(-2%,-1.5%)}}.bl-hd-play,.bl-hd-heart{position:absolute;left:9px;top:9px;display:flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:50%;background:#080a129e;box-shadow:inset 0 0 0 1px #ffffff2e;color:#fff}.bl-hd-play .licon svg{fill:currentColor}.bl-hd-heart{color:#ff6b8b;opacity:0}.bl-hd-heart .licon svg{fill:currentColor}.bl-hd-session{position:absolute;border-radius:16px;padding:14px;background:linear-gradient(180deg,#ffffff13,#ffffff08),#0c0e17;border:1px solid rgba(255,255,255,.1);box-shadow:inset 0 1px #ffffff14,0 18px 60px #05081459}.bl-hd-session-head{display:flex;align-items:center;gap:10px}.bl-hd-badge{display:flex;flex:none;align-items:center;justify-content:center;width:36px;height:36px;border-radius:12px;background:#ffffff0f;box-shadow:inset 0 1px #ffffff14;color:var(--amethyst-700)}.bl-hd-session-titles{display:flex;flex:1;flex-direction:column;min-width:0}.bl-hd-session-titles .kind{font-size:9px;font-weight:600;text-transform:uppercase;letter-spacing:.22em;color:var(--fg-4);white-space:nowrap;overflow:hidden}.bl-hd-session-titles .sep{margin:0 6px;color:var(--fg-5);letter-spacing:0}.bl-hd-session-titles .model{font-size:10px;font-weight:500;text-transform:none;letter-spacing:.01em;color:var(--fg-5)}.bl-hd-session-titles .name{margin-top:1px;font-size:14.5px;font-weight:600;color:#fff;letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.bl-hd-count{flex:none;padding:3px 9px;border-radius:999px;background:#ffffff0d;border:1px solid rgba(255,255,255,.06);font-size:11px;font-weight:600;color:var(--fg-3)}.bl-hd-thumbs{display:flex;gap:6px;margin-top:12px}.bl-hd-thumb{position:relative;flex:1;aspect-ratio:1;border-radius:8px;overflow:hidden;border:1px solid rgba(255,255,255,.07);background:#ffffff0a}.bl-hd-thumb.is-empty{border:1px dashed rgba(255,255,255,.1);background:#ffffff05}.is-hero .bl-hd-thumb img{transition:none}.bl-hd-thumbs.is-busy .bl-hd-thumb:after{content:"";position:absolute;inset:0;background:linear-gradient(100deg,transparent 20%,rgba(255,255,255,.1) 50%,transparent 80%);animation:bl-hd-shimmer 1.2s linear infinite}@keyframes bl-hd-shimmer{0%{transform:translate(-100%)}to{transform:translate(100%)}}.bl-hd-foot{margin-top:11px;font-size:11px;color:var(--fg-4);white-space:nowrap}.bl-hd-ring{position:absolute;inset:-4px;border-radius:19px;border:1.7px solid var(--amethyst-500);box-shadow:0 0 0 4.5px #9968df33;opacity:0}.bl-hd-note{position:absolute;display:flex;flex-direction:column;padding:16px;border-radius:16px;box-shadow:inset 0 1px #ffffff1a,0 18px 60px #0508144d}.bl-hd-note .text{flex:1;font-size:13.5px;line-height:1.45;color:#ffffffdb;letter-spacing:-.005em}.bl-hd-note .meta{margin-top:8px;font-size:10px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:#ffffff61}.bl-hd-note.is-amethyst{background:linear-gradient(180deg,#9968df33,#9968df17),#0b0b16;border:1px solid rgba(194,164,236,.24)}.bl-hd-note.is-amber{background:linear-gradient(180deg,#f0b44a2e,#f0b44a14),#0d0b0c;border:1px solid rgba(247,212,143,.22)}.bl-hd-note.is-rose{background:linear-gradient(180deg,#ec5b9a2b,#ec5b9a14),#0d0a12;border:1px solid rgba(245,163,199,.22)}.bl-hd-note.is-mint{background:linear-gradient(180deg,#34c79a29,#34c79a12),#080d10;border:1px solid rgba(143,229,201,.2)}.bl-hd.is-opening .bl-hd-frame,.bl-hd.is-opening .bl-hd-pic:not(.is-result),.bl-hd.is-opening .bl-hd-session,.bl-hd.is-opening .bl-hd-note{--p: clamp(0, calc((var(--build, 0) - var(--d, 0)) * 2.5), 1);--q: calc(1 - var(--p));opacity:var(--p);transform:translate3d(0,calc(var(--q) * var(--q) * 56px),0) scale(calc(1 - .1 * var(--q) * var(--q)));filter:blur(calc(var(--q) * var(--q) * 16px))}.bl-hd.is-opening .bl-hd-frame:after,.bl-hd.is-opening .bl-hd-pic:not(.is-result):after,.bl-hd.is-opening .bl-hd-session:after,.bl-hd.is-opening .bl-hd-note:after{content:"";position:absolute;inset:calc(-3px * var(--iz, 1));border-radius:inherit;pointer-events:none;box-shadow:0 0 0 calc(1.5px * var(--iz, 1)) #decefaeb,0 0 calc(26px * var(--iz, 1)) calc(4px * var(--iz, 1)) #9968df80;opacity:0}.bl-hd.is-opening .bl-hd-pic:not(.is-result):after{inset:0;z-index:1;box-shadow:inset 0 0 0 calc(2.5px * var(--iz, 1)) #decefaf2,inset 0 0 calc(38px * var(--iz, 1)) #9968dfb3;opacity:var(--g-pic, 0)}.bl-hd.is-opening .bl-hd-session:after{opacity:var(--g-session, 0)}.bl-hd.is-opening .bl-hd-note:after{opacity:var(--g-note, 0)}.bl-hd.is-opening .bl-hd-frame:after{opacity:var(--g-frame, 0)}.bl-hd-dock{position:absolute;left:50%;z-index:2;display:flex;align-items:center;gap:6px;padding:5px;border-radius:15px;background:#121521e6;border:1px solid var(--hairline);box-shadow:inset 0 1px #ffffff14,0 30px 80px #0206178c}.bl-hd-add{display:inline-flex;height:34px;border-radius:10px;overflow:hidden;background:var(--grad-cta);color:#fff;box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff2e}.bl-hd-add.is-plus{width:34px;align-items:center;justify-content:center}.bl-hd-add.is-plus .licon{transition:transform .3s cubic-bezier(.16,1,.3,1)}.bl-hd-add.is-plus.is-open .licon{transform:rotate(45deg)}.bl-hd-rail{display:inline-flex;align-items:center;gap:2px}.bl-hd-rail i{display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:9px;color:var(--fg-3)}.bl-hd-rail i.is-on{background:#9968df29;color:#fff}.bl-hd-rail b{width:1px;height:18px;margin:0 4px;background:var(--hairline-soft)}.bl-hd-prompt{position:absolute;z-index:2;border-radius:18px;border:1px solid rgba(255,255,255,.075);background:#0b0d15fb;box-shadow:inset 0 1px #ffffff0d,0 2px 8px #02040c66,0 30px 80px #02040c9e;visibility:hidden}.bl-hd-prompt-side{position:absolute;left:12px;top:12px;display:flex;flex-direction:column;gap:7px}.bl-hd-prompt-side i{display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:9px;color:var(--fg-4)}.bl-hd-slot{position:absolute;display:flex;align-items:center;justify-content:center;border-radius:10px;border:1px dashed rgba(255,255,255,.16);background:#ffffff05;color:var(--fg-4)}.bl-hd-slot.is-target{border:1px solid rgba(194,164,236,.7);background:#9968df24;color:var(--amethyst-700)}.bl-hd-slot img{position:absolute;inset:-1px;width:calc(100% + 2px);height:calc(100% + 2px);border-radius:10px;transition:none}.bl-hd-slot .glow{position:absolute;inset:-4px;z-index:1;border-radius:13px;box-shadow:0 0 0 1.5px #c2a4ecd9,0 0 22px 4px #9968df6b;opacity:0}.bl-hd-prompt-text{position:absolute;left:54px;right:18px;top:66px;height:22px;white-space:nowrap;font-size:15px;line-height:22px;letter-spacing:-.005em;color:#fff}.bl-hd-prompt-text .ph{position:absolute;left:0;top:0;color:var(--fg-4)}.bl-hd-prompt-text .caret{display:inline-block;width:1.5px;height:18px;margin-left:1px;vertical-align:-3px;border-radius:1px;background:var(--amethyst-700)}.bl-hd-prompt-foot{position:absolute;left:54px;right:12px;bottom:12px;display:flex;align-items:center;gap:7px}.bl-hd-prompt-foot .chip{display:inline-flex;align-items:center;gap:6px;height:30px;padding:0 11px;border-radius:999px;background:#ffffff0d;border:1px solid rgba(255,255,255,.06);font-size:12px;color:var(--fg-2);white-space:nowrap}.bl-hd-prompt-foot .chip small{font-size:9.5px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:var(--fg-4)}.bl-hd-prompt-foot .chip .licon{color:var(--fg-4)}.bl-hd-prompt-foot .cog{display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;color:var(--fg-4)}.bl-hd-prompt-foot .sp{flex:1}.bl-hd-prompt-foot .step{display:inline-flex;align-items:center;gap:10px;height:30px;padding:0 11px;border-radius:999px;border:1px solid rgba(255,255,255,.08);color:var(--fg-4);font-size:12.5px}.bl-hd-prompt-foot .step b{color:#fff;font-weight:600}.bl-hd-prompt-foot .run{position:relative;isolation:isolate;display:inline-flex;align-items:center;justify-content:center;height:30px;border-radius:999px;background:#ffffff12;font-size:12.5px;font-weight:600;letter-spacing:-.01em;color:var(--fg-4);transition:color .3s,box-shadow .3s,transform .12s var(--ease-out-soft),opacity .2s}.bl-hd-prompt-foot .run:before{content:"";position:absolute;inset:0;z-index:-1;border-radius:inherit;background:var(--grad-cta);opacity:0;transition:opacity .3s}.bl-hd-prompt-foot .run.is-lit{color:#fff;box-shadow:0 6px 18px #745aff4d,inset 0 1px #ffffff2e}.bl-hd-prompt-foot .run.is-lit:before{opacity:1}.bl-hd-prompt-foot .run.is-pressed{transform:scale(.95)}.bl-hd-prompt-foot .run.is-busy{opacity:.72}.bl-hd-zoom{position:absolute;right:16px;z-index:2;display:inline-flex;align-items:center;gap:10px;height:34px;padding:0 11px;border-radius:12px;background:#121521e6;border:1px solid var(--hairline);color:var(--fg-4);font-size:12px}.bl-hd-zoom .pct{min-width:30px;text-align:center;color:var(--fg-2);font-variant-numeric:tabular-nums}.bl-hd-ghost{position:absolute;left:0;top:0;z-index:5;width:54px;height:72px;border-radius:8px;opacity:0;transform-origin:0 0;box-shadow:0 16px 40px #0000008c}.bl-hd-ghost img{border-radius:8px}.bl-hd-ghost .ring{position:absolute;inset:-3px;border-radius:10px;box-shadow:0 0 0 1.5px var(--amethyst-700),0 0 18px #9968df80;opacity:0}.bl-hd-ripple{position:absolute;left:-18px;top:-18px;z-index:6;width:36px;height:36px;border-radius:50%;border:1.5px solid rgba(255,255,255,.9);opacity:0}.bl-hd-pointer{position:absolute;left:0;top:0;z-index:7;opacity:0}.bl-hd-pointer .arrow{display:block;margin:-3px 0 0 -4px;filter:drop-shadow(0 3px 6px rgba(0,0,0,.45));transform-origin:4px 3px;transition:transform .09s ease-out}.bl-hd-pointer.is-pressed .arrow{transform:scale(.86)}.bl-hd-key{position:absolute;left:16px;top:-26px;padding:3px 7px;border-radius:6px;background:#f5f5faf5;box-shadow:0 1px #00000040,0 6px 16px #00000059;font-size:11px;font-weight:600;white-space:nowrap;color:#11131c;opacity:0}.bl-hd-sheen{position:absolute;top:-10%;bottom:-10%;left:0;z-index:8;width:60%;opacity:0;pointer-events:none;background:linear-gradient(105deg,transparent 25%,rgba(255,255,255,.1) 50%,transparent 75%);mix-blend-mode:screen}@media(max-width:900px){.bl-hero{--stage-w: 92%;margin:0 0 30px;border-radius:22px}.bl-hero-pause{top:14px;right:14px;bottom:auto}.bl-hero-corner{top:14px;right:56px}.bl-hero-copy{padding-top:54px}.bl-sub{font-size:14.5px}}@media(max-width:600px){.bl-hero-stage,.bl-hero-room{display:none}.bl-hero-copy{padding:52px 18px 34px}.bl-hero.is-min{margin-bottom:18px}.bl-hero.is-min .bl-hero-copy{padding:4px 0 0}.bl-hero.is-min .bl-hero-actions{flex:1 1 100%;justify-content:flex-start}}', CRe = '.ob-layer{position:fixed;inset:0;z-index:2147483000;pointer-events:none;color:var(--fg-2)}.ob-layer [data-tour-ui]{pointer-events:auto}.ob-dim{position:absolute;inset:0}.ob-confetti{position:absolute;inset:0;width:100%;height:100%;z-index:30;pointer-events:none}.ob-dim-fill{fill:#04030c;transition:opacity .7s var(--ease-out-soft)}.ob-ring{position:absolute;box-shadow:0 0 0 1.5px #d6c2f2f2,0 0 0 5px #9968df38,0 0 34px 6px #9968df52;animation:obBreathe 2.4s ease-in-out infinite}.ob-ring:after{content:"";position:absolute;inset:-2px;border-radius:inherit;box-shadow:0 0 0 1.5px #d6c2f2b3;animation:obRipple 2.4s var(--ease-out-soft) infinite}@keyframes obBreathe{0%,to{box-shadow:0 0 0 1.5px #d6c2f2f2,0 0 0 5px #9968df33,0 0 30px 4px #9968df42}50%{box-shadow:0 0 0 1.5px #e8dcff,0 0 0 7px #9968df47,0 0 46px 10px #9968df66}}@keyframes obRipple{0%{inset:-2px;opacity:.9}70%,to{inset:-16px;opacity:0}}.ob-ring.is-nudged{animation:obCall .6s var(--ease-out-soft),obBreathe 2.4s ease-in-out .6s infinite}@keyframes obCall{0%{box-shadow:0 0 0 1.5px #fff,0 0 0 12px #9968df59,0 0 60px 16px #9968df8c}to{box-shadow:0 0 0 1.5px #d6c2f2f2,0 0 0 5px #9968df33,0 0 30px 4px #9968df42}}.ob-ring.is-done{animation:obDone .75s var(--ease-out-soft) forwards}.ob-ring.is-done:after{animation:none;opacity:0}@keyframes obDone{0%{box-shadow:0 0 0 1.5px #fff,0 0 0 5px #37d39959,0 0 40px 8px #37d39966}to{box-shadow:0 0 0 1.5px #37d39900,0 0 0 18px #37d39900,0 0 60px 16px #37d39900}}.ob-slot{position:absolute;display:flex;align-items:center;justify-content:center;border:1.5px dashed rgba(214,194,242,.75);background:#9968df12;animation:obSlot 1.8s ease-in-out infinite}.ob-slot span{padding:6px 12px;border-radius:999px;background:#04030cb8;color:#fff;font-size:12px;font-weight:600;letter-spacing:-.005em;white-space:nowrap}.ob-slot.is-done{animation:none;border-color:#37d399cc}@keyframes obSlot{0%,to{background:#9968df0d}50%{background:#9968df24}}.ob-arc{position:absolute;inset:0;overflow:visible}.ob-arc path{fill:none;stroke:#d6c2f2d9;stroke-width:2;stroke-linecap:round;stroke-dasharray:.5 9;animation:obMarch .8s linear infinite;filter:drop-shadow(0 0 4px rgba(153,104,223,.8))}.ob-arc circle{fill:#fff;filter:drop-shadow(0 0 6px rgba(153,104,223,.9))}@keyframes obMarch{to{stroke-dashoffset:-9.5}}.ob-head{position:absolute;left:0;right:0;top:0;height:60px;display:grid;grid-template-columns:1fr auto 1fr;align-items:center;padding:0 18px;background:#070910f0;backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);border-bottom:1px solid var(--hairline-soft)}.ob-head-left{display:flex;align-items:center;gap:12px;min-width:0}.ob-head-mark{flex:none}.ob-head-name{font-size:13px;color:var(--fg-4);white-space:nowrap}.ob-head-name .sep{margin:0 6px;color:var(--fg-5)}.ob-head-name b{color:var(--fg-1);font-weight:600}.ob-chapters{display:flex;align-items:center;gap:4px;margin:0;padding:0;list-style:none}.ob-chapters li{display:flex;align-items:center;gap:7px;height:30px;padding:0 11px 0 5px;border-radius:999px;color:var(--fg-4);font-size:12px;font-weight:500;white-space:nowrap;transition:background .4s var(--ease-out-soft),color .4s}.ob-chapters li+li:before{content:"";width:14px;height:1px;margin:0 4px 0 -6px;background:var(--hairline)}.ob-chapters .n{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;border:1px solid var(--hairline);font-size:10.5px;font-weight:600;color:var(--fg-4);font-variant-numeric:tabular-nums;transition:background .4s,border-color .4s,color .4s}.ob-chapters li.on{background:#9968df24;color:#fff}.ob-chapters li.on .n{border-color:transparent;background:var(--grad-cta);color:#fff;box-shadow:0 0 14px #9968df8c}.ob-chapters li.done{color:var(--fg-3)}.ob-chapters li.done .n{border-color:#c2a4ec66;background:#9968df33;color:var(--amethyst-800)}.ob-head-right{display:flex;justify-content:flex-end}.ob-skip{height:32px;padding:0 14px;border:1px solid var(--hairline);border-radius:999px;background:#ffffff08;color:var(--fg-3);font:500 12.5px var(--font-sans);cursor:pointer;transition:background var(--dur-fast),color var(--dur-fast)}.ob-skip:hover{background:#ffffff14;color:#fff}.ob-card{position:absolute;left:0;top:0;width:372px;border-radius:20px;overflow:hidden;background:#0f101a;border:1px solid rgba(255,255,255,.09);box-shadow:0 0 0 1px #9968df29,0 34px 90px #02040cb8,0 10px 26px #02040c73;transition:transform .7s var(--ease-out-soft);will-change:transform}.ob-card.is-wide{width:min(560px,calc(100vw - 32px))}.ob-card.is-short,.ob-card.is-short.is-wide{display:flex;align-items:stretch;width:min(600px,calc(100vw - 32px))}.ob-card.is-short .ob-media{flex:none;width:236px;aspect-ratio:auto;min-height:150px;border-bottom:0;border-right:1px solid var(--hairline-soft)}.ob-card.is-short .ob-body{flex:1;min-width:0;gap:10px;padding:14px 16px}.ob-card.is-short .ob-title{font-size:15.5px}.ob-card.is-short .ob-text{font-size:12.5px}.ob-card-enter-active{transition:opacity .4s ease,transform .7s var(--ease-out-soft)}.ob-card-leave-active{transition:opacity .2s ease}.ob-card-enter-from,.ob-card-leave-to{opacity:0}.ob-media{position:relative;aspect-ratio:16 / 9;overflow:hidden;background:#070910;border-bottom:1px solid var(--hairline-soft)}.ob-media:after{content:"";position:absolute;left:0;right:0;bottom:0;height:40px;pointer-events:none;background:linear-gradient(180deg,transparent,rgba(15,16,26,.5))}.ob-media-enter-active{transition:opacity .35s ease}.ob-media-leave-active{transition:opacity .18s ease}.ob-media-enter-from,.ob-media-leave-to{opacity:0}.ob-tag{position:absolute;left:12px;top:12px;z-index:3;display:inline-flex;align-items:center;gap:6px;padding:4px 10px 4px 8px;border-radius:999px;background:#04030ca8;backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#fff;font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase}.ob-tag .licon{color:#d9c6ff}.ob-body{display:flex;flex-direction:column;gap:12px;padding:16px 18px}.ob-words-stack{display:grid}.ob-words-stack>.ob-words{grid-area:1 / 1;min-width:0}.ob-words{display:flex;flex-direction:column;gap:6px}.ob-words-enter-active{transition:opacity .32s ease .06s,transform .42s var(--ease-out-soft) .06s}.ob-words-leave-active{transition:opacity .18s ease}.ob-words-enter-from{opacity:0;transform:translateY(6px)}.ob-words-leave-to{opacity:0}.ob-title{font-size:16.5px;font-weight:650;letter-spacing:-.015em;color:#fff;line-height:1.3}.ob-text{font-size:13px;line-height:1.55;color:var(--fg-3);text-wrap:pretty}.ob-card.is-wide .ob-title{font-size:19px}.ob-card.is-wide .ob-text{font-size:14px}.ob-note{display:flex;align-items:flex-start;gap:10px;margin-bottom:6px;padding:9px 12px;border-radius:12px;background:linear-gradient(180deg,#37d39921,#37d3990d);border:1px solid rgba(55,211,153,.3);font-size:12.5px;line-height:1.45;color:var(--fg-3)}.ob-note .ob-tick{width:18px;height:18px;margin-top:1px;animation-delay:.2s;animation-fill-mode:both}.ob-note-words{display:flex;flex-direction:column;gap:3px;min-width:0}.ob-note-words b{color:#fff;font-size:13px;font-weight:600}.ob-note .ob-key{min-width:0;height:18px;padding:0 5px;font-size:10.5px;box-shadow:0 1.5px #8e8ea6,0 3px 8px #0000004d}.ob-task{display:flex;align-items:center;gap:10px;min-height:42px;padding:8px 12px;border-radius:12px;background:linear-gradient(180deg,#9968df24,#9968df14);border:1px solid rgba(194,164,236,.22);color:#fff;font-size:13px;font-weight:500;line-height:1.4;transition:background .4s,border-color .4s}.ob-task-words{display:inline}.ob-task.is-shaking{animation:obShake .42s var(--ease-out-soft)}@keyframes obShake{0%,to{transform:translate(0)}20%{transform:translate(-5px)}45%{transform:translate(4px)}70%{transform:translate(-2px)}}.ob-dot{flex:none;width:8px;height:8px;border-radius:50%;background:var(--amethyst-600);box-shadow:0 0 #ae86e599;animation:obDot 1.6s ease-out infinite}@keyframes obDot{0%{box-shadow:0 0 #ae86e599}to{box-shadow:0 0 0 9px #ae86e500}}.ob-chip{display:inline-flex;align-items:center;height:22px;margin:0 2px;padding:0 9px;border-radius:999px;background:var(--grad-cta);color:#fff;font-size:12px;font-weight:600;vertical-align:1px;box-shadow:0 4px 12px #745aff4d}.ob-key{display:inline-flex;align-items:center;justify-content:center;min-width:24px;height:22px;margin:0 2px;padding:0 7px;border-radius:6px;background:linear-gradient(180deg,#fdfdff,#e4e4ee);color:#11131c;font:650 11.5px var(--font-sans);vertical-align:1px;box-shadow:0 2px #8e8ea6,0 4px 10px #00000059}.ob-key+.ob-key{margin-left:3px}.ob-key.is-on-btn{min-width:0;height:18px;margin-left:8px;padding:0 5px;font-size:11px;background:#ffffff38;color:#fff;box-shadow:none}.ob-card.is-done .ob-task{background:linear-gradient(180deg,#37d39929,#37d39914);border-color:#37d39959}.ob-tick{display:inline-flex;align-items:center;justify-content:center;flex:none;width:20px;height:20px;border-radius:50%;background:var(--success);color:#04130d;animation:obTick .42s var(--ease-out-soft)}@keyframes obTick{0%{transform:scale(.4);opacity:0}to{transform:scale(1);opacity:1}}.ob-spin{flex:none;width:15px;height:15px;border-radius:50%;border:2px solid rgba(255,255,255,.16);border-top-color:var(--amethyst-700);animation:obSpin .8s linear infinite}@keyframes obSpin{to{transform:rotate(360deg)}}.ob-hint{margin-top:-4px;font-size:12px;color:var(--amethyst-800);animation:obHint .35s var(--ease-out-soft)}@keyframes obHint{0%{opacity:0;transform:translateY(-3px)}to{opacity:1;transform:none}}.ob-foot{display:flex;align-items:center;justify-content:space-between;min-height:22px}.ob-foot-acts{display:inline-flex;align-items:center;gap:6px}.ob-steps{display:inline-flex;align-items:center;gap:5px}.ob-steps i{width:6px;height:6px;border-radius:999px;background:#ffffff29;transition:width .4s var(--ease-out-soft),background .4s}.ob-steps i.on{width:20px;background:#c2a4ec99}.ob-steps i.done{background:var(--amethyst-500)}.ob-steps i.on.done{background:var(--success)}.ob-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:36px;padding:0 16px;border:0;border-radius:999px;background:var(--grad-cta);color:#fff;font:600 13px var(--font-sans);letter-spacing:-.01em;cursor:pointer;box-shadow:0 8px 22px #745aff52,inset 0 1px #fff3;transition:transform .15s var(--ease-out-soft),box-shadow var(--dur-fast),filter var(--dur-fast),opacity var(--dur-fast)}.ob-btn:hover{filter:brightness(1.08);box-shadow:0 10px 28px #745aff73,inset 0 1px #ffffff3d}.ob-btn:active{transform:scale(.97)}.ob-btn:disabled{opacity:.55;cursor:default;filter:none}.ob-btn:focus-visible,.ob-link:focus-visible,.ob-skip:focus-visible{outline:2px solid var(--amethyst-700);outline-offset:3px}.ob-btn.is-big{height:46px;padding:0 24px;font-size:14.5px}.ob-link{display:inline-flex;align-items:center;gap:7px;padding:6px 10px;border:0;border-radius:999px;background:transparent;color:var(--fg-3);font:500 13px var(--font-sans);cursor:pointer;transition:color var(--dur-fast),background var(--dur-fast)}.ob-link:hover{color:#fff;background:#ffffff0d}.ob-link:disabled{opacity:.5;cursor:default}.ob-welcome,.ob-finale{position:absolute;left:50%;top:calc(50% + 30px);transform:translate(-50%,-50%);border-radius:26px;background:#070810;box-shadow:0 0 0 1px #ffffff14,0 0 0 1px #9968df24,0 50px 140px #000000b3}.ob-welcome{width:min(760px,calc(100vw - 32px));max-height:calc(100vh - 92px);overflow:hidden;display:flex;flex-direction:column}.ob-welcome:before,.ob-finale:before{content:"";position:absolute;inset:-1px;z-index:2;padding:1px;border-radius:inherit;background:linear-gradient(180deg,#d6c8f257,#ffffff14 34%,#ffffff0a 70%,#ffffff0f);-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask:linear-gradient(#000 0 0) content-box exclude,linear-gradient(#000 0 0);pointer-events:none}.ob-welcome-media{position:relative;flex:none;aspect-ratio:1180 / 540;overflow:hidden;background:#04030c}.ob-welcome-media .bl-hd-win{border-radius:0}.ob-welcome-fade{position:absolute;left:0;right:0;bottom:0;height:90px;z-index:9;background:linear-gradient(180deg,#07081000,#070810);pointer-events:none}.ob-welcome-body{position:relative;z-index:10;display:flex;flex-direction:column;align-items:flex-start;gap:10px;margin-top:-28px;padding:0 36px 32px}.ob-eyebrow{font-size:11px;font-weight:700;letter-spacing:.2em;text-transform:uppercase;color:var(--amethyst-700)}.ob-welcome-title,.ob-finale-title{margin:0;font-size:30px;font-weight:650;line-height:1.15;letter-spacing:-.025em;color:#fff}.ob-welcome-text{max-width:600px;margin:2px 0 8px;font-size:15px;line-height:1.6;color:var(--fg-3);text-wrap:pretty}.ob-welcome-actions{display:flex;align-items:center;gap:16px}.ob-or{font-size:12.5px;color:var(--fg-4)}.ob-own-enter-active{transition:opacity .5s ease,transform .7s var(--ease-out-soft)}.ob-own-leave-active{transition:opacity .3s ease,transform .4s ease}.ob-own-enter-from{opacity:0;transform:translate(-50%,calc(-50% + 18px)) scale(.98)}.ob-own-leave-to{opacity:0;transform:translate(-50%,calc(-50% - 10px)) scale(.985)}.ob-welcome.is-intro{opacity:var(--ob-intro-card, 0)}.ob-welcome.is-intro .ob-welcome-media{opacity:var(--ob-intro-media, 0)}.ob-welcome.is-intro .ob-welcome-title{visibility:hidden}.ob-intro{position:absolute;inset:0;z-index:40;overflow:hidden;cursor:default;user-select:none;-webkit-user-select:none}.ob-intro-leave-active{transition:opacity .32s ease}.ob-intro-leave-to{opacity:0}.ob-intro-dark{position:absolute;inset:0;background:var(--bg-deep)}.ob-intro-loader{position:absolute;inset:0;display:flex;align-items:center;justify-content:center}.ob-intro-stage{position:absolute;left:0;top:0;overflow:hidden;opacity:0;background:#070910;isolation:isolate}.ob-intro-win{position:absolute}.ob-intro-win .bl-hd-win{border-radius:0}.ob-intro-stage .ob-welcome-fade{opacity:0}.ob-intro-scrim{position:absolute;inset:0;pointer-events:none;opacity:0;background:radial-gradient(ellipse 52% 48% at 50% 50%,#04030ce0,#04030c99 58%,#04030c42)}.ob-intro-center{position:absolute;inset:0;z-index:2;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:clamp(22px,3.6vh,40px);padding-bottom:6vh;pointer-events:none}.ob-intro-mark{position:relative;flex:none;width:clamp(84px,9.5vw,148px);aspect-ratio:239 / 173;transform-origin:0 0}.ob-intro-glow{position:absolute;left:50%;top:50%;width:560%;aspect-ratio:1;border-radius:50%;opacity:0;pointer-events:none;background:radial-gradient(closest-side,rgba(153,104,223,.3),rgba(90,97,237,.1) 52%,transparent 100%)}.ob-intro-mark-in{position:absolute;inset:0;perspective:calc(clamp(84px,9.5vw,148px)*3)}.ob-intro-facet{position:absolute;inset:0;width:100%;height:100%;overflow:visible;opacity:0;will-change:transform,opacity,filter}.ob-intro-sheen{position:absolute;inset:0;opacity:0;pointer-events:none;-webkit-mask:var(--mask) center / 100% 100% no-repeat;mask:var(--mask) center / 100% 100% no-repeat;background-image:linear-gradient(105deg,transparent 38%,rgba(255,255,255,.85) 50%,transparent 62%);background-size:320% 100%;background-repeat:no-repeat;mix-blend-mode:screen}.ob-intro-title{position:relative;flex:none;white-space:nowrap;font-size:clamp(32px,4.6vw,66px);font-weight:650;line-height:1.15;letter-spacing:-.025em;color:#fff;transform-origin:0 0;text-shadow:0 2px 34px rgba(4,3,12,calc(.9 * var(--ts, 1)))}.ob-intro-word{display:inline-block;opacity:0}.ob-intro-row{display:flex;align-items:center;margin-top:calc(-1*clamp(8px,1.6vh,18px));opacity:0;white-space:nowrap;font-size:clamp(11px,.95vw,13.5px);font-weight:600;letter-spacing:.26em;text-transform:uppercase}.ob-intro-aspect{display:inline-flex;align-items:center;opacity:0;color:#cbb8f2;transition:color .25s ease}.ob-intro-aspect .sep{width:4px;height:4px;margin:0 1.1em 0 .9em;border-radius:50%;background:#cbb8f280}.ob-intro-skip{position:absolute;right:22px;bottom:20px;z-index:3;display:inline-flex;align-items:center;gap:9px;height:34px;padding:0 10px 0 14px;border:1px solid rgba(255,255,255,.1);border-radius:999px;background:#ffffff0a;color:var(--fg-3);font:500 12.5px var(--font-sans);cursor:pointer;opacity:0;visibility:hidden;transition:color var(--dur-fast),background var(--dur-fast)}.ob-intro-skip:hover{color:#fff;background:#ffffff14}.ob-intro-skip .ob-key{min-width:0;height:18px;margin:0;padding:0 5px;font-size:10.5px;box-shadow:0 1.5px #8e8ea6}.ob-finale{width:min(540px,calc(100vw - 32px));display:flex;flex-direction:column;align-items:center;padding:40px 40px 32px;text-align:center}.ob-finale-mark{position:relative;display:flex;align-items:center;justify-content:center;width:96px;height:96px;margin-bottom:18px}.ob-finale-mark .halo{position:absolute;inset:0;border-radius:50%;background:radial-gradient(circle,rgba(153,104,223,.42),rgba(90,97,237,.12) 55%,transparent 72%);animation:obHalo 3.2s ease-in-out infinite}@keyframes obHalo{0%,to{transform:scale(.92);opacity:.75}50%{transform:scale(1.12);opacity:1}}.ob-finale-mark svg{position:relative;overflow:visible}.ob-finale-mark path{transform-box:fill-box;transform-origin:50% 50%;animation:obFacet .7s var(--ease-out-soft) both;animation-delay:calc(.12s + var(--i) * .09s)}@keyframes obFacet{0%{opacity:0;transform:scale(.4) rotate(-30deg)}to{opacity:1;transform:none}}.ob-finale .ob-finale-text{max-width:420px;margin:12px 0 26px;font-size:14.5px;line-height:1.6;color:var(--fg-3);text-wrap:pretty}.ob-learned{display:grid;grid-template-columns:1fr 1fr;gap:8px 10px;width:100%;margin:0 0 26px;padding:0;list-style:none;text-align:left}.ob-learned li{display:flex;align-items:center;gap:10px;padding:10px 12px;border-radius:12px;background:#ffffff09;border:1px solid var(--hairline-soft);font-size:12.5px;color:var(--fg-2);animation:obLearned .55s var(--ease-out-soft) both;animation-delay:calc(.5s + var(--i) * .14s)}.ob-learned .ob-tick{width:18px;height:18px;animation:obTick .42s var(--ease-out-soft) both;animation-delay:calc(.62s + var(--i) * .14s)}.ob-learned li:last-child:nth-child(odd){grid-column:1 / -1}@keyframes obLearned{0%{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}.ob-finale .ob-finale-error{margin:-12px 0 16px;font-size:12.5px;color:var(--danger)}.ob-finale-actions{display:flex;flex-direction:column;align-items:center;gap:10px}.bd-root .up-ghost.is-tour{white-space:normal;overflow:visible;color:var(--fg-3)}.bd-root .up-cue.is-tour{border:0;font-family:var(--font-sans);pointer-events:auto;cursor:pointer;animation:upIn .4s var(--ease-out-soft) .15s both,obCue 2.2s ease-in-out .6s infinite}.bd-root .up-cue.is-tour:hover{background:#9968df3d}@keyframes obCue{0%,to{box-shadow:0 0 #9968df00}50%{box-shadow:0 0 0 4px #9968df2e}}.bd-root .up-text.is-typing{caret-color:var(--amethyst-700);text-shadow:0 0 16px rgba(194,164,236,.45)}.bd-root .ed-words.is-tour-ghost::placeholder{color:var(--fg-3)}.bd-root .ed-tour-cue{position:static;align-self:flex-start;margin:2px 0 4px}.bd-root .ch-comp-input.is-tour-ghost::placeholder{color:var(--fg-3)}.bd-root .ch-comp-input.is-typing{caret-color:var(--amethyst-700);text-shadow:0 0 16px rgba(194,164,236,.45)}.bd-root .ch-tour-cue{position:static;display:inline-flex;margin:2px 0}.ob-demo{position:absolute;inset:0;overflow:hidden;pointer-events:none}.ob-demo-stage{position:absolute;left:0;top:0;transform-origin:0 0}.ob-demo-canvas{position:absolute;inset:0;background:radial-gradient(60% 80% at 14% 0%,rgba(117,50,211,.18),transparent 70%),radial-gradient(50% 60% at 92% 8%,rgba(90,97,237,.11),transparent 70%),#070910}.ob-demo-canvas:before{content:"";position:absolute;inset:0;background-image:radial-gradient(circle,rgba(255,255,255,.075) 1px,transparent 1.4px);background-size:22px 22px;background-position:11px 11px;background-repeat:repeat}.ob-demo .bl-hd-session{position:absolute}.ob-d-land{position:absolute;inset:0;transform-origin:320px 138px}.ob-d-tag{position:absolute;display:inline-flex;align-items:center;gap:8px;height:28px;padding:0 12px 0 9px;border-radius:999px;background:#121521f0;border:1px solid var(--hairline);color:var(--fg-1);font-size:12.5px;font-weight:500;white-space:nowrap;box-shadow:0 10px 24px #02040c73}.ob-d-tag:before{content:"";position:absolute;left:-20px;top:50%;width:18px;height:1px;background:linear-gradient(90deg,transparent,rgba(194,164,236,.6))}.ob-d-tag i{width:7px;height:7px;border-radius:50%;background:var(--amethyst-600);box-shadow:0 0 8px var(--amethyst-500)}.ob-demo .bl-hd-add{transition:box-shadow .25s ease,filter .25s ease}.ob-demo .bl-hd-add.is-lit{filter:brightness(1.15);box-shadow:0 0 0 3px #d6c2f280,0 10px 30px #745aff99}.ob-d-dock{transform:none}.ob-d-menu{position:absolute;z-index:3;padding:8px;border-radius:14px;background:#0e101af7;border:1px solid var(--hairline);box-shadow:inset 0 1px #ffffff0f,0 24px 60px #02040c99}.ob-d-menu .search{display:flex;align-items:center;gap:6px;height:26px;padding:0 9px;border-radius:8px;background:#ffffff0d;color:var(--fg-4);font-size:10.5px}.ob-d-menu .eyebrow{margin:8px 6px 4px;font-size:8.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-5)}.ob-d-menu .row{display:flex;align-items:center;gap:8px;height:30px;padding:0 8px;border-radius:8px;transition:background .2s ease,box-shadow .2s ease}.ob-d-menu .row.is-lit{background:#9968df33;box-shadow:inset 0 0 0 1px #c2a4ec59}.ob-d-menu .badge{display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:6px;background:#ffffff0f;color:var(--fg-2)}.ob-d-menu .main{display:flex;flex-direction:column;min-width:0;line-height:1.15}.ob-d-menu .main b{font-size:10.5px;font-weight:600;color:#fff}.ob-d-menu .main small{font-size:8.5px;color:var(--fg-4);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ob-d-prompt{transform-origin:50% 100%}.ob-d-words{position:absolute;left:54px;right:92px;top:16px;font-size:15px;line-height:22px;letter-spacing:-.005em;color:#fff;white-space:normal}.ob-d-prompt.is-big .ob-d-words{right:22px;top:20px;font-size:17px;line-height:26px}.ob-d-words .ph{color:var(--fg-4)}.ob-d-words .ghost{position:absolute;left:0;top:0;right:0;color:var(--fg-4)}.ob-d-words .caret{display:inline-block;width:1.5px;height:18px;margin-left:1px;vertical-align:-3px;border-radius:1px;background:var(--amethyst-700)}.ob-d-prompt.is-big .ob-d-words .caret{height:21px}.ob-d-words .typed{text-shadow:0 0 14px rgba(194,164,236,.35)}.ob-d-cue{position:absolute;left:54px;top:78px;display:inline-flex;align-items:center;gap:6px;padding:3px 10px 3px 4px;border-radius:999px;background:#9968df29;color:var(--amethyst-800);font-size:11.5px}.ob-d-cue kbd{padding:1px 7px;border-radius:5px;background:#ffffff29;color:#fff;font:600 10.5px var(--font-sans)}.ob-d-pill{position:absolute;top:10px;right:12px;display:inline-flex;align-items:center;gap:5px;height:26px;padding:0 11px 0 9px;border-radius:999px;background:#9968df29;border:1px solid rgba(194,164,236,.3);color:#e9dcff;font-size:11.5px;font-weight:600;transition:background .25s,box-shadow .25s}.ob-d-pill.is-lit{background:#9968df57;box-shadow:0 0 0 3px #9968df38,0 0 20px #9968df80}.ob-d-keycap{position:absolute;display:flex;align-items:flex-end;justify-content:space-between;padding:0 12px 8px;border-radius:11px;background:linear-gradient(180deg,#fdfdff,#e5e5ee);color:#11131c;font-size:15px;font-weight:650;box-shadow:0 5px #8e8ea6,0 14px 30px #00000080;transition:transform .1s ease-out,box-shadow .1s ease-out}.ob-d-keycap i{font-style:normal;font-size:18px;line-height:1;color:#4a4c5e}.ob-d-keycap.is-down{box-shadow:0 1px #8e8ea6,0 6px 14px #00000073,0 0 0 4px #9968df73;margin-top:4px}.ob-d-gallery{position:absolute;padding:10px;border-radius:14px;background:#0b0d15f7;border:1px solid var(--hairline);box-shadow:0 24px 60px #02040c99}.ob-d-gallery .head{display:flex;align-items:center;gap:7px;height:30px;font-size:10.5px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:var(--fg-4)}.ob-d-gallery .head b{display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;border-radius:999px;background:#ffffff14;color:#fff;font-size:10px;letter-spacing:0}.ob-d-gallery .grid{display:grid;grid-template-columns:1fr 1fr;gap:6px}.ob-d-gallery .cell{aspect-ratio:3 / 4;border-radius:8px;overflow:hidden;background:#ffffff0a;transition:opacity .2s}.ob-d-gallery .cell.is-lifted{opacity:.35}.ob-d-slot{position:absolute;border:1.5px dashed rgba(214,194,242,.7);border-radius:12px;background:#9968df1a}.ob-d-placed{position:absolute;border-radius:10px;overflow:hidden;box-shadow:0 22px 50px #0000008c,0 0 0 1px #ffffff14}.ob-d-ghost{width:52px;height:70px}.ob-d-pointer .ob-d-brush{display:block;width:18px;height:18px;margin:-9px 0 0 -9px;border-radius:50%;border:2px solid #fff;background:#ae86e540;box-shadow:0 0 0 1px #0006,0 2px 8px #0006}.ob-d-studio-wrap{position:absolute;inset:0;z-index:4;overflow:hidden;box-shadow:0 30px 80px #0009}.ob-d-studio{position:absolute;inset:0;background:#090b12}.ob-d-studio .top{position:absolute;left:0;right:0;top:0;height:26px;display:flex;align-items:center;gap:9px;padding:0 10px;border-bottom:1px solid var(--hairline-soft);color:var(--fg-3);font-size:10.5px}.ob-d-studio .top .back,.ob-d-studio .top .x{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:6px;background:#ffffff0d}.ob-d-studio .top .x{margin-left:auto}.ob-d-studio .top .crumb{color:#fff;font-weight:600}.ob-d-studio .top .crumb small{margin-right:6px;font-size:8px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:var(--fg-4)}.ob-d-studio .top .chip{display:inline-flex;align-items:center;gap:4px;height:16px;padding:0 7px;border-radius:999px;border:1px solid rgba(194,164,236,.3);color:var(--amethyst-800);font-size:9px}.ob-d-studio .tools,.ob-d-studio .hist{position:absolute;top:34px;width:132px;height:316px;padding:8px;border-radius:12px;background:#121521d9;border:1px solid var(--hairline-soft)}.ob-d-studio .tools{left:10px}.ob-d-studio .hist{left:498px;display:grid;grid-template-columns:1fr 1fr;grid-auto-rows:min-content;gap:5px}.ob-d-studio .tabs{display:flex;padding:3px;margin-bottom:6px;border-radius:9px;background:#ffffff0a}.ob-d-studio .tabs span{flex:1;padding:5px 0;border-radius:7px;text-align:center;font-size:10.5px;font-weight:600;color:var(--fg-3)}.ob-d-studio .tabs span.on{background:#9968df4d;color:#fff}.ob-d-studio .row{display:flex;align-items:center;gap:7px;margin-top:3px;padding:7px 8px;border-radius:8px;font-size:10.5px;color:var(--fg-3)}.ob-d-studio .row.on{background:#ffffff0d;color:#fff}.ob-d-studio .row .licon{color:var(--fg-4)}.ob-d-studio .row.on .licon{color:var(--amethyst-700)}.ob-d-studio .versions{position:absolute;left:230px;top:38px;z-index:3;display:flex;gap:5px}.ob-d-studio .versions .v{width:24px;height:32px;border-radius:5px;overflow:hidden;border:1.5px solid rgba(255,255,255,.18);box-shadow:0 4px 10px #00000080}.ob-d-studio .versions .v.is-new{border-color:var(--amethyst-600);animation:obTick .4s var(--ease-out-soft)}.ob-d-studio .stage{position:absolute;left:222px;top:30px;width:196px;height:262px;border-radius:12px;overflow:hidden;box-shadow:0 20px 50px #0000008c,0 0 0 1px #ffffff12;transform-origin:50% 50%}.ob-d-studio .stage img{position:absolute;inset:0}.ob-d-studio .stage .seam{position:absolute;top:0;bottom:0;width:2px;margin-left:-1px;background:#fff;box-shadow:0 0 14px 3px #c2a4ecd9}.ob-d-studio .stage.is-busy:after{content:"";position:absolute;inset:0;background:linear-gradient(105deg,transparent 30%,rgba(255,255,255,.18) 50%,transparent 70%);background-size:250% 100%;animation:obShimmer 1.1s linear infinite}@keyframes obShimmer{0%{background-position:120% 0}to{background-position:-120% 0}}.ob-d-studio .hist .h{aspect-ratio:3 / 4;border-radius:6px;overflow:hidden}.ob-d-paint{position:absolute;left:0;top:0;z-index:3;overflow:visible;mix-blend-mode:screen}.ob-d-editbar{position:absolute;z-index:3;display:flex;align-items:center;gap:8px;padding:0 8px 0 14px;border-radius:14px;background:#0b0d15fa;border:1px solid var(--hairline);box-shadow:0 20px 50px #02040c99}.ob-d-editbar .words{flex:1;min-width:0;font-size:12px;color:#fff;white-space:nowrap;overflow:hidden}.ob-d-editbar .ph{color:var(--fg-4)}.ob-d-editbar .run{display:inline-flex;align-items:center;justify-content:center;width:54px;height:28px;border-radius:999px;background:#ffffff12;color:var(--fg-4);font-size:11.5px;font-weight:600;transition:background .3s,color .3s}.ob-d-editbar .run.is-lit{background:var(--grad-cta);color:#fff;box-shadow:0 6px 16px #745aff59}.ob-d-editbar .run.is-busy{opacity:.75}.ob-d-world{position:absolute;inset:0;transform-origin:320px 170px}.ob-d-frame{position:absolute;border:1px solid rgba(255,255,255,.16);border-radius:14px;background:#ffffff06}.ob-d-frame:not(.is-drawn){border-style:dashed;border-color:#d6c2f2bf;background:#9968df0f}.ob-d-frame .title{position:absolute;left:2px;top:-24px;font-size:11px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:var(--fg-2);white-space:nowrap}.ob-d-note{z-index:2}.ob-d-note .text{font-size:12.5px}.ob-d-pin{position:absolute;z-index:3;display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;margin:-28px 0 0;border-radius:50% 50% 50% 4px;background:linear-gradient(135deg,#e07bb3,#9968df);color:#fff;font-size:10px;font-weight:700;box-shadow:0 0 0 2px #070910,0 8px 20px #00000073;transform-origin:0 100%}.ob-d-bubble{position:absolute;z-index:3;margin-top:-28px;padding:6px 11px;border-radius:10px 10px 10px 3px;background:#121521f7;border:1px solid var(--hairline);color:#fff;font-size:11.5px;white-space:nowrap;box-shadow:0 10px 26px #00000073}.ob-d-chatframe{box-shadow:0 0 0 calc(2px * var(--sel, 0)) rgba(174,134,229,calc(.9 * var(--sel, 0))),0 0 0 calc(1.5px * var(--glow, 0)) rgba(194,164,236,calc(.85 * var(--glow, 0))),0 0 calc(26px * var(--glow, 0)) rgba(153,104,223,calc(.55 * var(--glow, 0)))}.ob-d-finished{z-index:1;box-shadow:0 14px 40px #02040c73,0 0 0 1px #c2a4ec59}.ob-d-chatcard{position:absolute;display:flex;flex-direction:column;gap:7px;padding:9px 10px;border-radius:11px;background:#121521f0;border:1px solid rgba(194,164,236,.4);box-shadow:0 12px 30px #00000073;transform-origin:0 0}.ob-d-chatcard .head{display:flex;align-items:center;gap:6px;font-size:10.5px;font-weight:600;color:#fff}.ob-d-chatcard .line{height:5px;border-radius:3px;background:#ffffff1a}.ob-d-chatcard .line.is-short{width:62%}.ob-d-chatcard .mark,.ob-d-chat .head .mark{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:6px;background:var(--grad-cta);color:#fff}.ob-d-ctxbar{position:absolute;z-index:3;display:flex;align-items:center;gap:6px;padding:0 5px;border-radius:10px;background:#0e101af7;border:1px solid var(--hairline);box-shadow:0 10px 26px #00000073}.ob-d-ctxbar .chat{display:inline-flex;align-items:center;justify-content:center;gap:4px;width:56px;height:20px;border-radius:6px;color:#fff;font-size:10px;font-weight:600;transition:background .2s}.ob-d-ctxbar .chat.is-lit{background:#9968df61;box-shadow:0 0 0 3px #9968df38}.ob-d-ctxbar .ic{width:14px;height:14px;border-radius:4px;background:#ffffff14}.ob-d-chat{position:absolute;z-index:2;border-radius:14px;background:#0b0d15fa;border:1px solid var(--hairline);box-shadow:0 24px 60px #02040c99}.ob-d-chat>*{position:absolute}.ob-d-chat .head{left:0;right:0;top:0;display:flex;align-items:center;gap:8px;height:38px;padding:0 10px;border-bottom:1px solid var(--hairline-soft)}.ob-d-chat .head .t{display:flex;flex-direction:column;line-height:1.25}.ob-d-chat .head b{font-size:10.5px;color:#fff}.ob-d-chat .head small{font-size:8.5px;color:var(--fg-4)}.ob-d-chat .bubble{box-sizing:border-box;padding:6px 9px;border-radius:11px 11px 3px;background:#9968df4d;color:#fff;font-size:9.5px;line-height:1.35}.ob-d-chat .answer{display:flex;gap:7px}.ob-d-chat .answer .ai{display:inline-flex;align-items:center;justify-content:center;flex:none;width:16px;height:16px;border-radius:50%;background:#9968df52;color:var(--amethyst-800)}.ob-d-chat .answer .ai.is-busy{animation:obCue 1s ease-in-out infinite}.ob-d-chat .answer .lines{flex:1;display:flex;flex-direction:column;gap:6px;padding-top:3px}.ob-d-chat .answer .lines i{display:block;height:5px;border-radius:3px;background:#ffffff29}.ob-d-chat .plan{box-sizing:border-box;display:flex;flex-direction:column;gap:4px;padding:9px 10px;border-radius:11px;background:#ffffff0a;border:1px solid var(--hairline-soft)}.ob-d-chat .plan .eyebrow{font-size:7.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--fg-4)}.ob-d-chat .plan .ttl{font-size:11px;font-weight:600;color:#fff}.ob-d-chat .plan .sess{display:inline-flex;align-items:center;gap:5px;font-size:9px;color:var(--fg-3)}.ob-d-chat .run{z-index:1;display:inline-flex;align-items:center;justify-content:center;gap:4px;border-radius:999px;background:var(--grad-cta);color:#fff;font-size:9.5px;font-weight:600;box-shadow:0 6px 16px #745aff59;transition:box-shadow .25s,background .3s}.ob-d-chat .run.is-lit{box-shadow:0 0 0 3px #d6c2f280,0 8px 22px #745aff99}.ob-d-chat .run.is-busy{opacity:.8}.ob-d-chat .run.is-done{background:#2ecc8a2e;color:#7fe3b4;box-shadow:none}.ob-d-chat .composer{box-sizing:border-box;padding:8px 34px 8px 10px;border-radius:11px;background:#ffffff09;border:1px solid var(--hairline-soft)}.ob-d-chat .composer .words{display:block;font-size:9.5px;line-height:1.4;color:#fff}.ob-d-chat .composer .ph{color:var(--fg-4)}.ob-d-chat .composer .typed{text-shadow:0 0 14px rgba(194,164,236,.35)}.ob-d-chat .send{display:inline-flex;align-items:center;justify-content:center;border-radius:50%;background:#ffffff14;color:var(--fg-4);transition:background .25s,color .25s}.ob-d-chat .send.is-lit{background:var(--grad-cta);color:#fff;box-shadow:0 4px 12px #745aff73}@media(max-width:900px){.ob-chapters li .l{display:none}.ob-chapters li.on .l{display:inline}.ob-head-name{display:none}}@media(max-width:640px){.ob-card{width:calc(100vw - 32px)}.ob-welcome-title,.ob-finale-title{font-size:24px}.ob-welcome-body{padding:0 22px 24px}.ob-learned{grid-template-columns:1fr}}@media(prefers-reduced-motion:reduce){.ob-ring,.ob-ring:after,.ob-slot,.ob-arc path,.ob-dot,.ob-finale-mark .halo,.ob-finale-mark path,.ob-learned li,.ob-learned .ob-tick,.bd-root .up-cue.is-tour{animation:none}.ob-card,.ob-own-enter-active,.ob-own-leave-active,.ob-card-enter-active,.ob-card-leave-active,.ob-media-enter-active,.ob-media-leave-active,.ob-words-enter-active,.ob-words-leave-active{transition:none}}';
let sp = 0, Mo = null;
function IRe() {
  return sp++, Mo || (Mo = document.createElement("style"), Mo.setAttribute("data-rd-board-tour", ""), Mo.textContent = [TRe, CRe].join(`
`), document.head.appendChild(Mo)), () => {
    sp = Math.max(0, sp - 1), !sp && Mo && (Mo.remove(), Mo = null);
  };
}
const ARe = 25e3;
function Hze(i, e) {
  const t = HA(), n = IRe(), s = KA(), o = e.user || { uid: "local", name: "You", email: "" }, r = { ...o, initials: ma(o.name || o.email || "You") }, a = new yx(null, { uid: r.uid, email: r.email }), l = new MRe(Gf);
  let d = 0;
  const c = () => {
    const T = "tour-practice-" + Date.now().toString(36) + "-" + ++d;
    return a.addSeeded(T, rRe()), T;
  }, h = /* @__PURE__ */ K(c()), f = /* @__PURE__ */ K(!1), p = /* @__PURE__ */ K(""), y = new yRe({
    reason: e.reason,
    canSkip: e.canSkip || e.reason === "replay",
    board: e.board || null,
    gen: l,
    onProgress: e.onProgress,
    onExit: (T) => {
      f.value || (f.value = !0, p.value = "", Promise.resolve().then(() => e.onExit(T)).catch((k) => {
        f.value = !1, p.value = k instanceof Error && k.message || "Something went wrong. Please try again.";
      }));
    },
    restart: () => {
      const T = h.value;
      y.reset(), l.reset(), h.value = c(), T && a.remove(T);
    },
    reducedMotion: kx(),
    timing: e.timing,
    // a host's own dialogs, outside the tour's element, keep their clicks and keys
    scope: () => i
  }), v = {
    directory: a,
    user: r,
    catalog: /* @__PURE__ */ qe(YA()),
    gen: l,
    boardId: h,
    ready: /* @__PURE__ */ K(!0),
    onController: (T) => {
      y.attach(T), e.onController && e.onController(T, y);
    },
    // the tour's bar covers the board's: nothing leaves through it
    openBoard: () => {
    },
    home: () => {
    },
    library: null,
    labels: e.labels
  };
  let x = !1;
  const w = (T) => {
    x || y.isStarted || (x = !0, console.error("[tour] the practice board did not open:", T), Promise.resolve().then(() => e.onExit("failed")).catch((k) => console.error("[tour]", k)));
  }, S = window.setTimeout(() => w("it took too long"), e.startWithin || ARe), M = Ae(() => y.board.value && y.board.value.loadError.value, (T) => {
    T && w(T);
  }), _ = J5(iRe, { env: v, tour: y, busy: f, error: p });
  return _.config.errorHandler = (T) => console.error("[tour]", T), _.mount(i), document.body.classList.add("bd-open"), {
    unmount() {
      clearTimeout(S), M(), y.dispose(), _.unmount(), document.body.classList.remove("bd-open"), s(), n(), t();
    }
  };
}
var PRe = { version: "0.1.0", commit: "58d9186b7" };
function ERe(i) {
  if (!i) return null;
  const e = Number(i.x), t = Number(i.y), n = Number(i.z);
  return !Number.isFinite(e) || !Number.isFinite(t) || !Number.isFinite(n) || n <= 0 ? null : { x: e, y: t, zoom: n };
}
function RRe(i, e) {
  const t = HA(), n = KA(), s = e.user || { uid: "local", name: "You", email: "" }, o = { ...s, initials: ma(s.name || s.email || "You") };
  let r = null;
  const a = /* @__PURE__ */ K(e.boardId), l = /* @__PURE__ */ qe(YA()), d = iS(), c = new Yte(d, FW());
  let h, f, p, y, v = null;
  const x = /* @__PURE__ */ K(!0);
  if (e.directory)
    h = e.directory;
  else if (e.firebase) {
    const R = e.firebase, D = Promise.resolve().then(() => Sx), O = [];
    let F = null, te = null;
    x.value = !1, D.then((me) => {
      te = me, F = new me.RunnitCanvasDirectory(R, o);
      for (const L of O) L(F);
      x.value = !0, v = () => {
        me.loadToolCatalog(R, o, { isBlocked: e.isToolBlocked }).then((L) => {
          L && L.kits.length && (l.value = L);
        }).catch((L) => console.warn("[board] live tool catalog unavailable, using the demo catalog", L));
      }, v();
    });
    const ee = () => F ? Promise.resolve(F) : new Promise((me) => O.push(me));
    h = {
      list: () => ee().then((me) => me.list()),
      create: (me, L) => ee().then((N) => N.create(me, L)),
      rename: (me, L) => ee().then((N) => N.rename(me, L)),
      open: (me) => {
        if (F) return F.open(me);
        throw new Error("Board storage is still starting");
      }
    }, p = (me) => te ? te.boardServices(R, o, me, { isBlocked: e.isToolBlocked }) : null, y = (me, L) => te ? te.commentStore(R, o, me, L) : null, f = () => ({
      upload: (me) => D.then((L) => L.uploadFile(R, o, me)).then((L) => L.url),
      uploadRecord: (me) => D.then((L) => L.uploadFile(R, o, me)),
      uploadVideo: R.uploadVideo
    });
  } else
    h = new yx(null, { uid: o.uid, email: o.email });
  const w = e.comments;
  !y && w && (y = (R, D) => new DIe({ db: w.db, me: { uid: o.uid, name: o.name, email: o.email }, boardId: R, board: D, people: w.people }));
  const S = (R) => {
    const D = e.stress;
    if (D) {
      D.rebuild(R || D.images.value);
      return;
    }
    const O = R ? "?images=" + R : "";
    e.navigate ? e.navigate("/board/stress" + O) : location.assign("/stress.html" + O);
  }, M = e.feedback || {};
  let _ = null;
  M.enabled !== !1 && !e.stress && (_ = new TIe(), _.captureConsole());
  const T = M.sink || (e.firebase ? RIe(e.firebase) : new AIe()), k = e.stress ? "in memory (the stress page, never saved)" : e.backend ? e.backend : e.firebase ? "Firebase project " + (e.firebase.db.app.options.projectId || "unknown") : e.directory ? "this browser (the harness)" : "in memory", P = {
    directory: h,
    user: o,
    catalog: l,
    gen: c,
    boardId: a,
    ready: x,
    // the open board's controller: the host's refreshTokenAccess reaches it (and the harness and tests get it too)
    onController: (R) => {
      r = R, e.onController && e.onController(R);
    },
    openBoard: (R) => {
      e.openBoard ? e.openBoard(R) : a.value = R;
    },
    home: () => {
      e.navigate && e.navigate("/runnit/home");
    },
    uploaderFor: f || (() => ({
      // harness: the image (or video) lives as long as the page
      upload: (R) => Promise.resolve(URL.createObjectURL(R)),
      uploadVideo: (R) => Promise.resolve({ url: URL.createObjectURL(R) })
    })),
    servicesFor: p,
    studio: {
      babylon: e.babylon,
      upload3d: e.firebase && e.firebase.upload3d ? e.firebase.upload3d : void 0,
      uploadMask: e.firebase && e.firebase.uploadMask ? e.firebase.uploadMask : void 0
    },
    // without real services (the harness, tests), a Library of the demo's pictures
    library: e.firebase ? null : new wIe(),
    storageUrl: e.firebase ? e.firebase.storageUrl : void 0,
    openRunnit: (R) => {
      e.navigate && e.navigate("/runnit/" + R);
    },
    getTokens: e.getTokens,
    canBuyTokens: e.canBuyTokens,
    openTour: e.openTour,
    track: e.track,
    initialCamera: ERe(e.initialQuery),
    onCameraSettled: (R) => {
      e.replaceQuery && e.replaceQuery({ x: String(Math.round(R.x)), y: String(Math.round(R.y)), z: String(Math.round(R.zoom * 1e3) / 1e3) });
    },
    // ?studio= keeps the Studios view's session, so a refresh comes back to it (CHAT-07)
    initialStudio: e.initialQuery && typeof e.initialQuery.studio == "string" ? e.initialQuery.studio : null,
    onStudio: (R) => {
      e.replaceQuery && e.replaceQuery({ studio: R || void 0 });
    },
    onTitle: (R) => {
      e.onTitle ? e.onTitle(R) : document.title = R + " | RunDiffusion";
    },
    showStats: T1,
    openStress: S,
    backend: k,
    stress: e.stress,
    featured: e.featuredPrompts ? { load: e.featuredPrompts } : void 0,
    myPrompts: e.promptShelf,
    labels: e.labels,
    feedback: _ ? { recorder: _, sink: T, build: PRe } : void 0,
    commentsFor: y,
    commentLink: e.commentLink || ((R, D) => location.origin + "/board/" + R + "?comment=" + encodeURIComponent(D)),
    initialComment: e.initialQuery && typeof e.initialQuery.comment == "string" ? e.initialQuery.comment : null,
    clearCommentLink: () => {
      e.replaceQuery && e.replaceQuery({ comment: void 0 });
    },
    agent: e.agent || null,
    boardsApi: e.firebase && e.firebase.api || null
  }, A = J5(jA, { env: P });
  return A.config.errorHandler = (R) => console.error("[board]", R), A.mount(i), document.body.classList.add("bd-open"), {
    setBoardId(R) {
      a.value !== R && (a.value = R);
    },
    refreshTools() {
      v && v();
    },
    refreshTokenAccess() {
      r && r.refreshTokenAccess();
    },
    unmount() {
      A.unmount(), _ && _.dispose(), document.body.classList.remove("bd-open"), n(), t();
    }
  };
}
async function Vze(i, e, t) {
  const n = await Promise.resolve().then(() => Sx), s = { ...e, initials: ma(e.name || e.email || "You") };
  return (await new n.RunnitCanvasDirectory(i, s).create(t, "blank")).id;
}
async function Wze(i, e, t = {}) {
  const n = await Promise.resolve().then(() => Sx), s = { ...e, initials: ma(e.name || e.email || "You") }, o = new n.RunnitCanvasDirectory(i, s);
  if (!t.fresh) {
    const a = await o.findOwn("Bonneville Tower");
    if (a) return a.id;
  }
  return (await o.create("Bonneville Tower", "demo")).id;
}
function qze(i, e = {}) {
  const t = new yx(null), n = /* @__PURE__ */ K(j4(e.images));
  let s = t.ensureTiledDemo(n.value), o = null;
  const r = {
    images: n,
    layout: /* @__PURE__ */ qe(rk(n.value)),
    collapsed: /* @__PURE__ */ K(!1),
    tab: /* @__PURE__ */ K("board"),
    reports: /* @__PURE__ */ new Map(),
    rebuild(a) {
      const l = j4(a);
      if (l === n.value || !o) return;
      const d = s;
      s = t.ensureTiledDemo(l), n.value = l, r.layout.value = rk(l), o.setBoardId(s), t.remove(d), e.onImages && e.onImages(l);
    }
  };
  return o = RRe(i, {
    boardId: s,
    directory: t,
    user: e.user,
    navigate: e.navigate,
    onController: e.onController,
    openBoard: (a) => {
      a && o ? o.setBoardId(a) : !a && e.onIndex && e.onIndex();
    },
    showStats: !0,
    stress: r
  }), o;
}
ht.add(TY);
ht.mixin(mn, CY);
ht.add(LM);
ht.add(BM);
ht.mixin(mn, aZ);
ht.add(jM, UM);
ht.add(GM);
const zRe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), $Re = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
var DRe = Object.defineProperty, ORe = (i, e, t) => e in i ? DRe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Yt = (i, e, t) => ORe(i, typeof e != "symbol" ? e + "" : e, t);
const n1 = 450, LRe = 500, ic = "CANVAS";
class op extends Error {
  constructor(e, t, n) {
    super(e), Yt(this, "kind", t), Yt(this, "runnitType", n);
  }
}
function Vf(i, e) {
  return {
    id: i,
    title: e.title || "Untitled board",
    ownerId: e.userId,
    teamId: e.teamId || null,
    description: e.description || "",
    accessLevel: e.accessLevel || null,
    createdAt: gn(e.createdAt)
  };
}
class BRe {
  constructor(e, t) {
    Yt(this, "fb", e), Yt(this, "user", t);
  }
  /** Your personal canvas boards, and your team's: the Dev chip's links to your demo boards (the real list is src/list). */
  async list() {
    const e = this.fb.db.collection("runnits"), t = [
      e.where("userId", "==", this.user.uid).where("type", "==", ic).where("deletedAt", "==", null).where("teamId", "==", null)
    ];
    this.user.teamId && t.push(e.where("teamId", "==", this.user.teamId).where("type", "==", ic).where("deletedAt", "==", null));
    const n = await Promise.all(t.map((o) => o.limit(200).get())), s = [];
    for (const o of n)
      for (const r of o.docs) s.push(Vf(r.id, r.data()));
    return s.sort((o, r) => (r.createdAt || 0) - (o.createdAt || 0));
  }
  /**
   * One board by id (B33's links): null when it's deleted, isn't a canvas
   * board, or the rules refuse you it. Each link is looked up on its own, so
   * none is taken for gone because a listing stopped short of it.
   */
  async get(e) {
    try {
      const t = await this.fb.db.collection("runnits").doc(e).get();
      if (!t.exists) return null;
      const n = t.data();
      return n.type !== ic || n.deletedAt ? null : Vf(e, n);
    } catch (t) {
      if ((t && typeof t == "object" && "code" in t ? String(t.code) : "") === "permission-denied") return null;
      throw t;
    }
  }
  /**
   * Your own board by this title in the account you're working in (the
   * newest), or null: the admins' demo board reopens rather than coming again
   * every time (IL-100).
   */
  async findOwn(e) {
    const t = this.user.teamId || null;
    return (await this.list()).filter((s) => s.ownerId === this.user.uid && (s.teamId || null) === t && s.title === e)[0] || null;
  }
  /** A canvas board in the team you're working in (or a personal one), as v1's create path writes a runnit. */
  async create(e, t = "blank") {
    const n = this.fb.FieldValue, s = t === "demo" ? Kl() : null, o = this.user.teamId || null, r = {
      createdAt: n.serverTimestamp(),
      deletedAt: null,
      userId: this.user.uid,
      teamId: o,
      type: ic,
      accessLevel: "PRIVATE",
      title: s ? s.title : e,
      description: "",
      avatarId: null,
      avatar: null
    }, a = await this.fb.db.collection("runnits").add(r);
    return s && await FRe(this.fb, this.user, a, s.elements), { id: a.id, title: r.title, ownerId: this.user.uid, teamId: o, createdAt: Date.now() };
  }
  async rename(e, t) {
    await this.fb.db.collection("runnits").doc(e).update({ title: t });
  }
  open(e) {
    return new NRe(this.fb, this.user, e);
  }
}
async function FRe(i, e, t, n) {
  const s = new R8(), o = t.collection("runnitCanvasElements"), r = Date.now(), a = /* @__PURE__ */ new Map();
  for (const c of n) {
    const h = yp(c, e.uid, r), f = s.place(c.id, zl(h), () => o.doc().id);
    a.has(f) || a.set(f, {}), a.get(f)[c.id] = h;
  }
  let l = i.db.batch(), d = 0;
  for (const [c, h] of a)
    l.set(o.doc(c), { v: I8, elements: h, updatedBy: e.uid, updatedAt: i.FieldValue.serverTimestamp() }), ++d >= n1 && (await l.commit(), l = i.db.batch(), d = 0);
  d && await l.commit();
}
class NRe {
  constructor(e, t, n) {
    Yt(this, "fb", e), Yt(this, "user", t), Yt(this, "boardId", n), Yt(this, "status", /* @__PURE__ */ K("saved")), Yt(this, "index", new R8()), Yt(this, "known", /* @__PURE__ */ new Map()), Yt(this, "idsIn", /* @__PURE__ */ new Map()), Yt(this, "serverBuckets", /* @__PURE__ */ new Set()), Yt(this, "latest", /* @__PURE__ */ new Map()), Yt(this, "hints", /* @__PURE__ */ new Map()), Yt(this, "queue", /* @__PURE__ */ new Map()), Yt(this, "onRemote", null), Yt(this, "unsubs", []), Yt(this, "timer", 0), Yt(this, "flushing", null), Yt(this, "retry", 0), Yt(this, "loaded", !1), Yt(this, "disposed", !1), Yt(this, "abortLoad", null), Yt(this, "meta", null), Yt(this, "onlineHandler", () => this.updateOnline()), window.addEventListener("online", this.onlineHandler), window.addEventListener("offline", this.onlineHandler), this.updateOnline();
  }
  runnitRef() {
    return this.fb.db.collection("runnits").doc(this.boardId);
  }
  bucketRef(e) {
    return this.runnitRef().collection("runnitCanvasElements").doc(e);
  }
  updateOnline() {
    navigator.onLine ? this.status.value === "offline" && (this.status.value = this.queue.size ? "saving" : "saved") : this.status.value = "offline";
  }
  async load() {
    let e;
    try {
      e = await this.runnitRef().get();
    } catch (s) {
      throw Wo(s) === "permission-denied" ? new op("This board doesn't exist, or you don't have access to it.", "missing") : s;
    }
    if (this.disposed) throw new Error("The board was closed while it loaded.");
    if (!e.exists) throw new op("This board doesn't exist, or you don't have access to it.", "missing");
    const t = e.data();
    if (t.type !== ic) throw new op("It was made in Boards, before canvas boards, and it opens there.", "not-canvas", t.type);
    if (t.deletedAt) throw new op("This board was deleted.", "deleted");
    this.meta = Vf(this.boardId, t);
    const n = await new Promise((s, o) => {
      this.abortLoad = o;
      const r = this.runnitRef().collection("runnitCanvasElements").onSnapshot(
        (a) => {
          this.loaded ? this.nextSnapshot(a) : (this.loaded = !0, s(this.firstSnapshot(a)));
        },
        (a) => {
          console.error("[board] contents listener failed", a), this.loaded ? this.status.value = "error" : o(a);
        }
      );
      this.keep(r);
    });
    return this.abortLoad = null, this.keep(this.runnitRef().onSnapshot((s) => {
      if (!this.onRemote || s.metadata.hasPendingWrites || !s.exists) return;
      const o = s.data();
      this.meta = Vf(this.boardId, o), this.onRemote({ upserted: [], removed: [], meta: { ...this.meta, deleted: !!o.deletedAt } });
    }, () => {
    })), { meta: { ...this.meta }, elements: n, results: BW(n) };
  }
  firstSnapshot(e) {
    const t = [];
    for (const n of e.docs) {
      const s = this.readBucket(n);
      t.push(...Gw(this.known, this.idsOf(n.id), s).upserted);
    }
    return t;
  }
  nextSnapshot(e) {
    if (!this.onRemote) return;
    const t = [], n = [];
    let s = !1;
    const o = new Set(this.queue.keys());
    for (const r of e.docChanges()) {
      if (r.doc.metadata.hasPendingWrites) continue;
      const a = r.type === "removed" ? {} : this.readBucket(r.doc), l = Gw(this.known, this.idsOf(r.doc.id), a, o);
      t.push(...l.upserted), n.push(...l.removed), l.trash && (s = !0);
    }
    (t.length || n.length || s) && this.onRemote({ upserted: t, removed: n, trash: s || void 0 });
  }
  readBucket(e) {
    const t = e.data(), n = t.elements || {};
    return this.serverBuckets.add(e.id), this.latest.set(e.id, n), this.hints.set(e.id, gn(t.hardDeleteAt) || null), this.index.setBucket(e.id, n), n;
  }
  idsOf(e) {
    let t = this.idsIn.get(e);
    return t || (t = /* @__PURE__ */ new Set(), this.idsIn.set(e, t)), t;
  }
  watch(e) {
    this.onRemote = e;
  }
  enqueue(e, t, n) {
    const s = this.queue.get(e);
    this.queue.set(e, { op: qu(s ? s.op : void 0, t), full: n || (s ? s.full : null) });
  }
  commit(e) {
    const t = Date.now(), n = this.user.uid;
    for (const s of e.added) {
      const o = yp(s, n, t);
      this.index.place(s.id, zl(o), () => this.newBucketId()), this.enqueue(s.id, { kind: "put", data: o }, s);
    }
    for (const s of e.updated) {
      const o = {};
      for (const [r, a] of Object.entries(s.after)) o[r] = a === void 0 ? void 0 : sf(a);
      o.updatedBy = n, o.updatedAt = t, this.enqueue(s.id, { kind: "patch", fields: o }, s.el);
    }
    for (const s of e.removed)
      this.enqueue(s.id, { kind: "patch", fields: wG(n, this.user.email, t) }, s);
    this.schedule();
  }
  /** An element as the server will have it once the queue is saved. */
  pending(e) {
    const t = this.known.get(e), n = this.queue.get(e);
    if (!n) return t;
    let s = n.op;
    return s.kind === "patch" && !t && n.full && (s = qu({ kind: "put", data: yp(n.full, this.user.uid, Date.now()) }, s)), ag(t, s);
  }
  trash() {
    const e = Date.now(), t = [], n = new Set(this.known.keys());
    for (const s of this.queue.keys()) n.add(s);
    for (const s of n) {
      const o = _G(s, this.pending(s), e);
      o && t.push(o);
    }
    return t.sort((s, o) => o.deletedAt - s.deletedAt);
  }
  purge(e) {
    for (const t of e)
      this.index.bucketOf(t) && this.enqueue(t, { kind: "delete" }, null);
    this.schedule();
  }
  commitResults() {
  }
  saveMeta(e) {
    const t = {};
    e.title !== void 0 && (t.title = e.title), e.description !== void 0 && (t.description = e.description), Object.keys(t).length && this.runnitRef().update(t).catch((n) => {
      console.error("[board] board details not saved", n), this.onRemote && this.meta && this.onRemote({ upserted: [], removed: [], meta: { ...this.meta, refused: Wo(n) === "permission-denied" ? "owner" : "error" } });
    });
  }
  newBucketId() {
    return this.runnitRef().collection("runnitCanvasElements").doc().id;
  }
  schedule() {
    this.status.value !== "offline" && (this.status.value = "saving"), clearTimeout(this.timer), this.timer = window.setTimeout(() => {
      this.flush().catch(() => {
      });
    }, LRe);
  }
  async flush() {
    if (clearTimeout(this.timer), this.flushing && (await this.flushing, !this.queue.size))
      return;
    if (!this.queue.size) {
      this.status.value === "saving" && (this.status.value = "saved");
      return;
    }
    const e = this.queue;
    return this.queue = /* @__PURE__ */ new Map(), this.flushing = this.write(e).then(() => {
      this.retry = 0, !this.queue.size && navigator.onLine && (this.status.value = "saved");
    }).catch((t) => {
      if (Wo(t) === "permission-denied") {
        console.error("[board] save refused", t), this.status.value = "error";
        return;
      }
      console.error("[board] save failed, retrying", t);
      for (const [n, s] of e) {
        const o = this.queue.get(n);
        this.queue.set(n, o ? { op: qu(s.op, o.op), full: o.full || s.full } : s);
      }
      this.status.value = navigator.onLine ? "error" : "offline", this.retry = Math.min(6, this.retry + 1), this.disposed || (clearTimeout(this.timer), this.timer = window.setTimeout(() => {
        this.flush().catch(() => {
        });
      }, 1e3 * 2 ** this.retry));
    }).finally(() => {
      this.flushing = null;
    }), this.flushing;
  }
  /** One batch: per bucket, one set (a new bucket) or one field-level update. */
  async write(e) {
    const t = this.fb.FieldValue, n = this.fb.FieldPath, s = Date.now(), o = /* @__PURE__ */ new Map();
    for (const [d, c] of e) {
      let h = c.op;
      const f = this.index.bucketOf(d) || this.index.place(d, h.kind === "put" ? zl(h.data) : 400, () => this.newBucketId());
      if (h.kind === "patch" && (!this.known.has(d) || !this.serverBuckets.has(f))) {
        if (!c.full) continue;
        h = qu({ kind: "put", data: yp(c.full, this.user.uid, s) }, h);
      }
      o.has(f) || o.set(f, []), o.get(f).push([d, h]);
    }
    const r = [], a = [];
    for (const [d, c] of o) {
      const h = this.bucketRef(d);
      if (!this.serverBuckets.has(d)) {
        const w = {};
        for (const [M, _] of c) _.kind === "put" && (w[M] = _.data);
        if (!Object.keys(w).length) continue;
        const S = E8(w);
        r.push((M) => M.set(h, {
          v: I8,
          elements: w,
          ...S != null ? { hardDeleteAt: new Date(S) } : {},
          updatedBy: this.user.uid,
          updatedAt: t.serverTimestamp(),
          _created: t.serverTimestamp()
        }, { merge: !0 })), a.push(d);
        continue;
      }
      const f = [];
      for (const [w, S] of c)
        if (S.kind === "put") f.push(new n("elements", w), S.data);
        else if (S.kind === "delete") f.push(new n("elements", w), t.delete());
        else for (const [M, _] of Object.entries(S.fields)) f.push(new n("elements", w, M), _ === void 0 ? t.delete() : _);
      const p = this.hintFor(d, c);
      p != null && f.push("hardDeleteAt", new Date(p)), f.push("updatedBy", this.user.uid, "updatedAt", t.serverTimestamp());
      const [y, v, ...x] = f;
      r.push((w) => w.update(h, y, v, ...x));
    }
    const l = /* @__PURE__ */ new Map();
    for (const d of o.values())
      for (const [c, h] of d) {
        l.set(c, this.known.get(c));
        const f = ag(this.known.get(c), h);
        f ? this.known.set(c, f) : this.known.delete(c);
      }
    try {
      for (let d = 0; d < r.length; d += n1) {
        const c = this.fb.db.batch();
        for (const h of r.slice(d, d + n1)) h(c);
        await c.commit();
      }
    } catch (d) {
      for (const [c, h] of l)
        h ? this.known.set(c, h) : this.known.delete(c);
      throw d;
    }
    for (const d of a) this.serverBuckets.add(d);
  }
  /** The bucket's hardDeleteAt for a write (buckets.ts hintForWrite); `known` is still the state before it. */
  hintFor(e, t) {
    const n = t.map(([s, o]) => {
      const r = this.known.get(s);
      return [r, ag(r, o)];
    });
    return kG(this.hints.get(e) || null, n, this.latest.get(e) || {});
  }
  /** Keep a listener until dispose; one set up after it (closed mid-load) stops at once. */
  keep(e) {
    this.disposed ? e() : this.unsubs.push(e);
  }
  dispose() {
    this.disposed = !0, window.removeEventListener("online", this.onlineHandler), window.removeEventListener("offline", this.onlineHandler), this.flush().catch(() => {
    });
    for (const e of this.unsubs) e();
    this.unsubs = [], this.onRemote = null, this.abortLoad && this.abortLoad(new Error("The board was closed while it loaded.")), this.abortLoad = null;
  }
}
var URe = Object.defineProperty, GRe = (i, e, t) => e in i ? URe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, tv = (i, e, t) => GRe(i, typeof e != "symbol" ? e + "" : e, t);
const jRe = 60;
function Zr(i, e) {
  const t = e.staticInputs || {};
  return {
    id: i,
    runnitId: String(e.runnitId || ""),
    nodeId: String(e.nodeId || ""),
    nodeDefId: String(e.nodeDefId || ""),
    userId: String(e.userId || ""),
    teamId: e.teamId || null,
    email: typeof e.email == "string" ? e.email : void 0,
    state: e.state || "INIT",
    initAt: gn(e.initAt) || gn(e.createdAt),
    doneAt: gn(e.doneAt),
    inputs: e.inputs || {},
    staticInputs: { numResults: typeof t.numResults == "number" ? t.numResults : void 0 },
    fields: Array.isArray(e.fields) ? e.fields : void 0,
    results: Array.isArray(e.results) ? e.results : void 0,
    tokensCharged: rp(e.tokensCharged),
    freeTokensCharged: rp(e.freeTokensCharged),
    tokensReturned: rp(e.tokensReturned),
    freeTokensReturned: rp(e.freeTokensReturned),
    deletedAt: e.deletedAt || null
  };
}
function rp(i) {
  return typeof i == "number" ? i : void 0;
}
async function pP(i, e, t = !1) {
  try {
    const n = i.db.collection("runnitNodeRuns").doc(e), s = await (t ? n.get({ source: "server" }) : n.get());
    return s.exists ? Zr(s.id, s.data({ serverTimestamps: "estimate" }) || {}) : null;
  } catch (n) {
    if (Wo(n) === "permission-denied" || Wo(n) === "not-found") return null;
    throw n;
  }
}
class HRe {
  constructor(e, t) {
    tv(this, "fb", e), tv(this, "boardId", t), tv(this, "unsubs", []);
  }
  col() {
    return this.fb.db.collection("runnitNodeRuns");
  }
  /** The board's newest runs, live. `changed` is what this snapshot brought. */
  watchRecent(e, t) {
    const n = this.col().where("runnitId", "==", this.boardId).where("deletedAt", "==", null).orderBy("initAt", "desc").limit(jRe).onSnapshot((s) => {
      const o = [], r = [];
      for (const a of s.docChanges())
        a.type === "removed" ? r.push(a.doc.id) : o.push(Zr(a.doc.id, a.doc.data({ serverTimestamps: "estimate" })));
      (o.length || r.length) && e(o, r);
    }, (s) => {
      console.warn("[board] the board's runs are unavailable", s), t && t(s);
    });
    this.unsubs.push(n);
  }
  /**
   * A page of the whole board's runs, newest first, for the board's history;
   * `before` is the last page's oldest initAt. watchRecent's query, paged, so
   * it needs no index of its own.
   */
  async boardPage(e, t = 40) {
    let n = this.col().where("runnitId", "==", this.boardId).where("deletedAt", "==", null).orderBy("initAt", "desc");
    return e != null && (n = n.startAfter(new Date(e))), (await n.limit(t).get()).docs.map((o) => Zr(o.id, o.data({ serverTimestamps: "estimate" })));
  }
  /** A page of one session's runs, newest first; `before` is the last page's oldest initAt. */
  async sessionPage(e, t, n = 24) {
    let s = this.col().where("runnitId", "==", this.boardId).where("nodeId", "==", e).where("deletedAt", "==", null).orderBy("initAt", "desc");
    return t != null && (s = s.startAfter(new Date(t))), (await s.limit(n).get()).docs.map((r) => Zr(r.id, r.data({ serverTimestamps: "estimate" })));
  }
  /** One run, read once (see readRun). */
  getRun(e, t = !1) {
    return pP(this.fb, e, t);
  }
  /** Follow one run (one you just started) until it's over. */
  watchRun(e, t) {
    const n = this.col().doc(e).onSnapshot((s) => {
      t(s.exists ? Zr(s.id, s.data({ serverTimestamps: "estimate" }) || {}) : null);
    }, () => t(null));
    return this.unsubs.push(n), () => {
      n(), this.unsubs = this.unsubs.filter((s) => s !== n);
    };
  }
  /**
   * Delete one result from its session's history, as v1 does: the result
   * is marked deleted inside its run, and the run too once all of its are.
   * The rules let its runner (or a team admin who manages generations) do it.
   */
  async deleteResult(e, t, n) {
    const s = this.col().doc(e);
    await this.fb.db.runTransaction(async (o) => {
      const r = await o.get(s);
      if (!r.exists) return;
      const a = (r.data() || {}).results || [], l = /* @__PURE__ */ new Date(), d = a.map((h) => h.uuid === t && !h.deletedAt ? { ...h, deletedAt: l, deletedByUserId: n } : h), c = d.every((h) => !!h.deletedAt);
      o.update(s, {
        results: d,
        ...c ? { deletedAt: l, deletedByUserId: n } : {}
      });
    });
  }
  /**
   * deleteResult taken back (Recently Deleted's Recover, CHAT-14): the
   * result's delete stamps go, and the run's too when the delete had taken
   * its last result. The same fields deleteResult writes, which the run's
   * owner may write either way. The run's deletedAt goes back to null rather
   * than away: every query of runs asks for deletedAt == null, which a run
   * without the field doesn't match, so it would be in no history at all.
   */
  async restoreResult(e, t) {
    const n = this.col().doc(e), s = this.fb.FieldValue;
    await this.fb.db.runTransaction(async (o) => {
      const r = await o.get(n);
      if (!r.exists) throw new Error("run " + e + " is gone");
      const a = r.data() || {}, d = (a.results || []).map((c) => {
        if (c.uuid !== t || !c.deletedAt) return c;
        const h = { ...c };
        return delete h.deletedAt, delete h.deletedByUserId, h;
      });
      o.update(n, {
        results: d,
        ...a.deletedAt ? { deletedAt: null, deletedByUserId: s.delete() } : {}
      });
    });
  }
  dispose() {
    for (const e of this.unsubs) e();
    this.unsubs = [];
  }
}
var VRe = Object.defineProperty, WRe = (i, e, t) => e in i ? VRe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, On = (i, e, t) => WRe(i, typeof e != "symbol" ? e + "" : e, t);
function qRe(i, e) {
  return !i || !e ? i !== e : i.id !== e.id || i.nodeDefId !== e.nodeDefId || i.numResults !== e.numResults || JSON.stringify(i.inputs) !== JSON.stringify(e.inputs);
}
const KRe = 800, YRe = 8e3;
class XRe {
  constructor(e, t, n) {
    On(this, "fb", e), On(this, "uid", t), On(this, "boardId", n), On(this, "all", /* @__PURE__ */ new Map()), On(this, "current", /* @__PURE__ */ new Map()), On(this, "consumed", /* @__PURE__ */ new Set()), On(this, "submitting", /* @__PURE__ */ new Set()), On(this, "awaiting", /* @__PURE__ */ new Map()), On(this, "pending", /* @__PURE__ */ new Map()), On(this, "restoring", /* @__PURE__ */ new Map()), On(this, "runNode", /* @__PURE__ */ new Map()), On(this, "writing", /* @__PURE__ */ new Map()), On(this, "onChange", null), On(this, "followed", /* @__PURE__ */ new Map()), On(this, "listening", /* @__PURE__ */ new Map()), On(this, "timer", 0), On(this, "disposed", !1);
  }
  /**
   * Where your drafts go as they arrive. Nothing is read yet: a session's are
   * read when it's followed (opened, saved or run), so a board with many
   * sessions reads only the few you use.
   */
  start(e) {
    this.onChange = e;
    for (const [t, n] of this.current) e(t, n);
    return Promise.resolve();
  }
  /**
   * Follow your drafts in one session, live, so another tab's edit shows here.
   * Resolves once its first snapshot is in, so a save or a run knows which
   * draft is the session's before it writes.
   */
  follow(e) {
    let t = this.followed.get(e);
    return t || (t = new Promise((n) => {
      const s = { unsub: () => {
      }, settled: !1 }, o = () => {
        s.settled || (s.settled = !0, n(), this.disposed && s.unsub());
      };
      s.unsub = this.fb.db.collection("runnitNodeRunDrafts").where("userId", "==", this.uid).where("runnitId", "==", this.boardId).where("nodeId", "==", e).where("deletedAt", "==", null).onSnapshot((r) => {
        this.read(r, !s.settled), o();
      }, (r) => {
        console.warn("[board] drafts unavailable", r), o();
      }), this.listening.set(e, s);
    }), this.followed.set(e, t), t);
  }
  read(e, t) {
    const n = /* @__PURE__ */ new Set();
    for (const s of e.docChanges()) {
      const o = s.doc.data({ serverTimestamps: "estimate" }), r = String(o.nodeId || "");
      if (!r) continue;
      if (n.add(r), s.type === "removed") {
        this.all.delete(s.doc.id);
        continue;
      }
      if (o.state && o.state !== "DRAFT") {
        this.all.delete(s.doc.id);
        continue;
      }
      const a = o.staticInputs || {};
      this.all.set(s.doc.id, {
        id: s.doc.id,
        nodeId: r,
        nodeDefId: String(o.nodeDefId || ""),
        draftAt: gn(o.draftAt) || gn(o.createdAt) || 0,
        inputs: o.inputs || {},
        numResults: typeof a.numResults == "number" ? a.numResults : void 0
      });
    }
    for (const s of n) {
      const o = this.current.get(s), r = this.newest(s);
      r ? (this.current.set(s, r), o && o.id !== r.id && this.awaiting.delete(s)) : this.current.delete(s), !(this.pending.has(s) || this.restoring.has(s)) && this.onChange && (t || qRe(o, r)) && this.onChange(s, r);
    }
  }
  newest(e) {
    let t = null;
    for (const n of this.all.values())
      n.nodeId !== e || this.consumed.has(n.id) || (!t || n.draftAt > t.draftAt) && (t = n);
    return t;
  }
  get(e) {
    return this.current.get(e) || null;
  }
  /** Keep a session's prompt (debounced). */
  save(e, t, n, s) {
    this.pending.set(e, { nodeDefId: t, inputs: n, numResults: s }), this.later(KRe);
  }
  later(e) {
    clearTimeout(this.timer), this.disposed || (this.timer = window.setTimeout(() => {
      this.flush().catch(() => {
      });
    }, e));
  }
  /**
   * Whether a session's saves wait: a run is on its way with its draft, or
   * took it and the draft it leaves in its place hasn't arrived yet.
   */
  holding(e, t) {
    const n = this.current.get(e);
    if (n && this.submitting.has(n.id)) return !0;
    const s = this.awaiting.get(e);
    return !!(s && s > t && !n);
  }
  async flush() {
    clearTimeout(this.timer);
    const e = Date.now();
    let t = !1;
    const n = [];
    for (const [s, o] of Array.from(this.pending)) {
      if (this.holding(s, e)) {
        t = !0;
        continue;
      }
      this.pending.delete(s), n.push(this.queue(s, () => this.saveNow(s, o)).catch((r) => console.warn("[board] prompt not kept", r)));
    }
    await Promise.all(n), t && this.later(1e3);
  }
  /** A save's turn came: unless a run took the draft while it waited, in which case it waits again. */
  async saveNow(e, t) {
    if (await this.follow(e), this.holding(e, Date.now())) {
      this.pending.has(e) || this.pending.set(e, t), this.later(1e3);
      return;
    }
    await this.write(e, t);
  }
  /** Run a session's writes one after another, whatever became of the one before. */
  queue(e, t) {
    const s = (this.writing.get(e) || Promise.resolve()).then(t, t), o = s.catch(() => {
    });
    return this.writing.set(e, o), o.then(() => {
      this.writing.get(e) === o && this.writing.delete(e);
    }), s;
  }
  /**
   * Write a session's prompt now and give the draft id a run takes. Saves
   * leave that draft alone until the run settles: markConsumed when it went,
   * release when it didn't.
   */
  prepare(e, t, n, s, o = null) {
    return this.pending.delete(e), o && this.restoring.set(e, o), this.queue(e, async () => {
      await this.follow(e);
      let r;
      try {
        r = await this.write(e, { nodeDefId: t, inputs: n, numResults: s });
      } catch (a) {
        throw this.restoring.delete(e), a;
      }
      return this.submitting.add(r), this.runNode.set(r, e), r;
    });
  }
  /** The run didn't go: its draft is the session's again, and saves held for it go now. */
  release(e) {
    const t = this.submitting.delete(e), n = this.runNode.get(e);
    this.runNode.delete(e), n && this.putBack(n), t && this.pending.size && this.later(0);
  }
  /**
   * A run that wasn't the session's prompt is done with its draft: the prompt
   * goes back into it (or into the one a run leaves), unless something typed
   * since is waiting to be saved, which is newer and wins.
   */
  putBack(e) {
    const t = this.restoring.get(e);
    t && (this.restoring.delete(e), this.pending.has(e) || this.pending.set(e, t), this.later(0));
  }
  /** A run took this draft: later saves wait for the one the server leaves in its place. */
  markConsumed(e) {
    this.submitting.delete(e), this.consumed.add(e);
    const t = this.all.get(e), n = t && t.nodeId || this.runNode.get(e);
    if (this.runNode.delete(e), !n) return;
    this.awaiting.set(n, Date.now() + YRe);
    const s = this.newest(n);
    s ? this.current.set(n, s) : this.current.delete(n), this.putBack(n);
  }
  /** Write to the session's draft, or start one. Only ever in the session's queue. */
  async write(e, t) {
    const n = this.current.get(e), s = this.fb.db.collection("runnitNodeRunDrafts"), o = this.fb.db.collection("runnitNodeDefs").doc(t.nodeDefId);
    if (n && !this.consumed.has(n.id) && !this.submitting.has(n.id))
      try {
        return await s.doc(n.id).update({
          inputs: t.inputs,
          staticInputs: { numResults: t.numResults },
          ...n.nodeDefId !== t.nodeDefId ? { nodeDefId: t.nodeDefId, nodeDef: o } : {}
        }), this.all.set(n.id, { ...n, nodeDefId: t.nodeDefId, inputs: t.inputs, numResults: t.numResults }), this.current.set(e, this.all.get(n.id)), n.id;
      } catch (d) {
        if (Wo(d) !== "permission-denied" && Wo(d) !== "not-found") throw d;
        this.consumed.add(n.id);
      }
    const r = this.fb.FieldValue, a = await s.add({
      createdAt: r.serverTimestamp(),
      deletedAt: null,
      draftAt: r.serverTimestamp(),
      userId: this.uid,
      runnitId: this.boardId,
      nodeId: e,
      nodeDefId: t.nodeDefId,
      nodeDef: o,
      mode: "MANUAL",
      state: "DRAFT",
      inputs: t.inputs,
      staticInputs: { numResults: t.numResults }
    }), l = { id: a.id, nodeId: e, nodeDefId: t.nodeDefId, draftAt: Date.now(), inputs: t.inputs, numResults: t.numResults };
    return this.all.set(a.id, l), this.current.set(e, l), this.awaiting.delete(e), a.id;
  }
  dispose() {
    this.disposed = !0, this.flush().catch(() => {
    });
    for (const e of this.listening.values()) e.settled && e.unsub();
    this.onChange = null;
  }
}
var JRe = Object.defineProperty, ZRe = (i, e, t) => e in i ? JRe(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Ld = (i, e, t) => ZRe(i, typeof e != "symbol" ? e + "" : e, t);
class QRe {
  constructor(e, t, n) {
    Ld(this, "fb", e), Ld(this, "uid", t), Ld(this, "boardId", n), Ld(this, "uuids", /* @__PURE__ */ qe(/* @__PURE__ */ new Set())), Ld(this, "unsub", null);
  }
  start() {
    this.unsub = this.fb.db.collection("resultFavorites").where("userId", "==", this.uid).where("runnitId", "==", this.boardId).onSnapshot((e) => {
      const t = /* @__PURE__ */ new Set();
      for (const n of e.docs) {
        const s = n.data().nodeRunResultUuid;
        s && t.add(s);
      }
      this.uuids.value = t, xs(this.uuids);
    }, (e) => console.warn("[board] favorites unavailable", e));
  }
  has(e) {
    return !!e && this.uuids.value.has(e);
  }
  /** A result can be starred by whoever ran it, once it's finished. */
  canStar(e) {
    return !!e.uuid && !!e.runId && e.status === "done" && e.userId === this.uid;
  }
  async set(e, t) {
    if (!this.canStar(e)) return;
    const n = this.fb.db.collection("resultFavorites").doc(this.uid + "_" + e.uuid), s = new Set(this.uuids.value);
    if (t ? s.add(e.uuid) : s.delete(e.uuid), this.uuids.value = s, xs(this.uuids), !t) {
      await n.delete();
      return;
    }
    await n.set({
      createdAt: this.fb.FieldValue.serverTimestamp(),
      userId: this.uid,
      nodeRunId: e.runId,
      nodeRunResultUuid: e.uuid,
      nodeDefId: e.modelId || "",
      nodeId: e.sessionId,
      runnitId: this.boardId,
      resultType: e.video ? "VID" : e.kind === "3d" ? "ASSET_3D" : e.kind === "layers" ? "LAYERS" : "IMG"
    });
  }
  dispose() {
    this.unsub && this.unsub(), this.unsub = null;
  }
}
var eze = Object.defineProperty, tze = (i, e, t) => e in i ? eze(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, ap = (i, e, t) => tze(i, typeof e != "symbol" ? e + "" : e, t);
const nv = { models: "pinnedModelIds", sessions: "pinnedSessionIds" };
class nze {
  constructor(e, t, n) {
    ap(this, "fb", e), ap(this, "uid", t), ap(this, "boardId", n), ap(this, "there", /* @__PURE__ */ new Map());
  }
  docId(e) {
    return e === "models" ? "global" : this.boardId;
  }
  ref(e) {
    return this.fb.db.doc("users/" + this.uid + "/boardPrefs/" + this.docId(e));
  }
  /**
   * A merge into the doc, naming its `_created` when this write makes it.
   * Before any snapshot has said whether it's there, a read does; when that
   * fails too, `_created` is left alone rather than reset.
   */
  async merge(e, t) {
    const n = this.docId(e);
    let s = this.there.get(n);
    s === void 0 && (s = await this.ref(e).get().then((o) => o.exists, () => !0)), this.there.set(n, !0);
    try {
      await this.ref(e).set(s ? t : { ...t, _created: this.fb.FieldValue.serverTimestamp() }, { merge: !0 });
    } catch (o) {
      throw s || this.there.delete(n), o;
    }
  }
  watch(e, t, n) {
    return this.ref(e).onSnapshot((s) => {
      this.there.set(this.docId(e), s.exists);
      const o = s.exists ? (s.data() || {})[nv[e]] : void 0;
      t(Array.isArray(o) ? o.filter((r) => typeof r == "string") : null);
    }, (s) => {
      console.warn("[board] your pins are kept in this browser only", s), n();
    });
  }
  pin(e, t, n) {
    const s = this.fb.FieldValue;
    return this.merge(e, { [nv[e]]: n ? s.arrayUnion(t) : s.arrayRemove(t) });
  }
  seed(e, t) {
    return this.merge(e, { [nv[e]]: t });
  }
  watchViews(e, t) {
    return this.ref("models").onSnapshot((n) => {
      this.there.set(this.docId("models"), n.exists);
      const s = n.exists ? (n.data() || {}).cameraViews : void 0;
      e(Array.isArray(s) ? s : null);
    }, (n) => {
      console.warn("[board] your camera views are kept in this browser only", n), t();
    });
  }
  saveViews(e) {
    return this.merge("models", { cameraViews: e });
  }
}
var ize = Object.defineProperty, sze = (i, e, t) => e in i ? ize(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, iv = (i, e, t) => sze(i, typeof e != "symbol" ? e + "" : e, t);
class oze {
  constructor(e, t) {
    iv(this, "fb", e), iv(this, "uid", t), iv(this, "avatars", /* @__PURE__ */ new Map());
  }
  /** Newest first: yours, then the team's shared ones. */
  async list(e) {
    const t = this.fb.db.collection("models"), n = e ? [
      t.where("teamId", "==", e).where("accessLevel", "==", "PRIVATE").where("isDeleted", "==", !1).where("userId", "==", this.uid).orderBy("createdAt", "desc").limit(1e3),
      t.where("teamId", "==", e).where("accessLevel", "==", "SHARED").where("isDeleted", "==", !1).orderBy("createdAt", "desc").limit(1e3)
    ] : [
      t.where("userId", "==", this.uid).where("teamId", "==", null).where("accessLevel", "==", "PRIVATE").where("isDeleted", "==", !1).orderBy("createdAt", "desc").limit(100)
    ], s = await Promise.all(n.map((a) => a.get())), o = [];
    return s.forEach((a, l) => a.docs.forEach((d) => o.push({ doc: d, shared: !!e && l === 1 }))), (await Promise.all(o.map(({ doc: a, shared: l }) => this.toModel(a, l)))).filter((a) => !!a);
  }
  async toModel(e, t) {
    const n = e.data();
    if (!n.file) return null;
    const s = n.avatarId ? await this.avatar(n.avatarId) : null, o = { ...n, id: e.id };
    s && (o.avatar = s);
    const r = s ? rS(s) : null, a = this.fb.storageUrl;
    return {
      id: e.id,
      name: n.name || "Untitled model",
      description: n.description || void 0,
      architecture: n.architecture || void 0,
      shared: t,
      thumb: r && a ? a(r.thumb) : void 0,
      image: r && a ? a(r.file) : void 0,
      record: o
    };
  }
  avatar(e) {
    let t = this.avatars.get(e);
    return t || (t = this.fb.db.doc("avatars/" + e).get().then((n) => n.exists ? { ...n.data(), id: e } : null).catch(() => null), this.avatars.set(e, t)), t;
  }
}
var rze = Object.defineProperty, aze = (i, e, t) => e in i ? rze(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, k3 = (i, e, t) => aze(i, typeof e != "symbol" ? e + "" : e, t);
function _3(i, e) {
  let t = typeof i[e] == "number" ? i[e] : 0;
  const n = e + "_delta_";
  for (const s of Object.keys(i))
    s.startsWith(n) && typeof i[s] == "number" && (t += i[s]);
  return t;
}
function lze(i, e) {
  const t = _3(i, "runnitTokens"), n = i.type === "USER" && e ? _3(i, "freeRunnitTokens") : 0;
  return t + n;
}
class dze {
  constructor(e, t) {
    k3(this, "fb", e), k3(this, "freemiumPassport", t);
  }
  /** Follow an account (a team id, or your uid); null while it can't be read. */
  watch(e, t) {
    return this.fb.db.doc("balanceAccounts/" + e).onSnapshot((n) => {
      if (!n.exists) {
        t(null);
        return;
      }
      const s = n.data() || {};
      t({ tokens: lze(s, this.freemiumPassport), team: s.type === "TEAM" });
    }, (n) => {
      console.warn("[board] balance unavailable", n), t(null);
    });
  }
}
var cze = Object.defineProperty, uze = (i, e, t) => e in i ? cze(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, hze = (i, e, t) => uze(i, e + "", t);
class pze {
  constructor(e) {
    hze(this, "fb", e);
  }
  /**
   * Follow a team: whether it's active (no isActive counts as not), or null
   * while it can't be read; and its name, which the token chip names as the
   * account that pays (N5).
   */
  watch(e, t) {
    return this.fb.db.doc("teams/" + e).onSnapshot((n) => {
      if (!n.exists) {
        t(null);
        return;
      }
      const s = n.data() || {};
      t(s.isActive === !0, typeof s.name == "string" && s.name.trim() ? s.name.trim() : null);
    }, (n) => {
      console.warn("[board] team status unavailable", n), t(null);
    });
  }
}
var fze = Object.defineProperty, mze = (i, e, t) => e in i ? fze(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, lp = (i, e, t) => mze(i, typeof e != "symbol" ? e + "" : e, t);
const gze = 48, bze = 1e3, dp = 200;
function Bd(i, e) {
  const t = new Error(i);
  return t.userMessage = i, t.cause = e, t;
}
class vze {
  constructor(e, t, n = {}) {
    lp(this, "fb", e), lp(this, "uid", t), lp(this, "features"), lp(this, "api"), this.api = e.library || null, this.features = { search: !!this.api && !!n.isAdmin, filters: !!this.api, star: !0, remove: !0 };
  }
  url(e) {
    return this.fb.storageUrl ? this.fb.storageUrl(e) : "";
  }
  ctx() {
    return { uid: this.uid, storageUrl: (e) => this.url(e), modelName: () => "" };
  }
  /** Your finished generations, from any board, a page at a time; filtered or searched through the API. */
  async generations(e = {}) {
    if (this.api && (nA(e.filters) || xm(e.search) || typeof e.cursor == "string")) return this.fromApi("generations", e);
    let t = this.fb.db.collection("runnitNodeRuns").where("deletedAt", "==", null).where("state", "==", "DONE").where("templateOriginalData", "==", null).where("userId", "==", this.uid).orderBy("initAt", "desc");
    typeof e.cursor == "number" && (t = t.startAfter(new Date(e.cursor)));
    const s = (await t.limit(Xr).get()).docs.map((a) => Zr(a.id, a.data())), o = [];
    for (const a of s) o.push(...F0(a, this.ctx()));
    const r = s[s.length - 1];
    return { items: o, next: s.length === Xr && r && r.initAt ? r.initAt : null };
  }
  /** Your uploads, newest first, a page at a time. */
  async uploads(e = {}) {
    let t = this.fb.db.collection("runnitUploads").where("deletedAt", "==", null).where("userId", "==", this.uid).orderBy("createdAt", "desc");
    typeof e.cursor == "number" && (t = t.startAfter(new Date(e.cursor)));
    const n = await t.limit(Xr).get(), s = [];
    let o = null;
    for (const r of n.docs) {
      const a = { ...r.data(), id: r.id };
      if (o = gn(a.createdAt) || o, !a.name || a.type && a.type !== "IMG" && a.type !== "VID" && a.type !== "ASSET_3D") continue;
      const l = V1(a), d = a.type === "VID", c = a.type === "ASSET_3D", h = l.replace(/[^/]+$/, (f) => "thumbs/" + f.replace(/\.[^/.]+$/, "_512x512.webp"));
      s.push({
        id: "upload:" + r.id,
        // a video shows its first frame, as results do, and a 3D model its preview
        url: this.url(d || c ? h : l),
        thumb: this.url(h),
        w: a.width,
        h: a.height,
        video: d,
        videoSrc: d ? this.url(l) : void 0,
        label: a.name,
        createdAt: gn(a.createdAt),
        mine: a.userId === this.uid,
        uploadId: r.id,
        asset: { upload: a },
        model3d: c ? { url: this.url(l), ext: (/\.([a-z0-9]+)$/i.exec(a.name) || ["", "glb"])[1].toLowerCase() } : void 0
      });
    }
    return { items: s, next: n.docs.length === Xr ? o : null };
  }
  /** What you've starred, most recently first: through the API (paged), or each favorite's run. */
  async favorites(e = {}) {
    if (this.api) return this.fromApi("favorites", e);
    const n = (await this.fb.db.collection("resultFavorites").where("userId", "==", this.uid).orderBy("createdAt", "desc").limit(gze).get()).docs.map((a) => a.data()).filter((a) => !!a.nodeRunId && !!a.nodeRunResultUuid), s = Array.from(new Set(n.map((a) => a.nodeRunId))), o = /* @__PURE__ */ new Map();
    await Promise.all(s.map(async (a) => {
      const l = await this.fb.db.doc("runnitNodeRuns/" + a).get().catch(() => null);
      l && l.exists && o.set(a, Zr(a, l.data() || {}));
    }));
    const r = [];
    for (const a of n) {
      const l = o.get(a.nodeRunId);
      if (!l) continue;
      const d = F0(l, this.ctx()).find((c) => c.id === l.id + ":" + a.nodeRunResultUuid);
      d && r.push({ ...d, fav: !0 });
    }
    return { items: r, next: null };
  }
  async fromApi(e, t) {
    const n = await this.api(tke(e, t));
    if (!n.ok) throw Bd(nke(n), n);
    const s = ike(n.page.data, n.page.nodeDefs || {}, this.ctx());
    if (e === "favorites") for (const o of s) o.fav = !0;
    return { items: s, next: n.page.hasMore ? n.page.nextCursor : null };
  }
  /** The results you've starred, as Library item ids (run:result), to mark them anywhere. */
  async favoriteKeys() {
    const e = await this.fb.db.collection("resultFavorites").where("userId", "==", this.uid).orderBy("createdAt", "desc").limit(bze).get(), t = [];
    for (const n of e.docs) {
      const s = n.data();
      s.nodeRunId && s.nodeRunResultUuid && t.push(s.nodeRunId + ":" + s.nodeRunResultUuid);
    }
    return t;
  }
  /**
   * What the filters pick from: the tools' Model family and Media tags, and
   * the boards you can read (v1's board reads, canvas boards too). Tools come
   * from the board's own catalog.
   */
  async filterOptions(e = null) {
    const [t, n] = await Promise.all([this.tags(), this.boards(e)]);
    return { tools: [], families: t.families, media: t.media, boards: n };
  }
  async tags() {
    try {
      const t = (await this.fb.db.collection("runnitNodeDefTags").where("isDeleted", "==", !1).get()).docs.map((s) => ({ id: s.id, ...s.data() })).sort((s, o) => (s.sortOrder || 0) - (o.sortOrder || 0) || (s.label || "").localeCompare(o.label || "")), n = (s) => t.filter((o) => o.type === s && o.label).map((o) => ({ value: o.id, text: o.label }));
      return { families: n("MODEL_FAMILY"), media: n("MEDIA") };
    } catch (e) {
      return console.warn("[board] the Library's tool tags are unavailable", e), { families: [], media: [] };
    }
  }
  /** v1's board reads (libraryBoards.ts), for v1's boards and canvas boards alike; deduped, by title. */
  async boards(e) {
    const t = () => this.fb.db.collection("runnits"), n = [];
    for (const o of ["WORKFLOW", "CANVAS"])
      n.push(t().where("userId", "==", this.uid).where("teamId", "==", null).where("deletedAt", "==", null).where("type", "==", o).orderBy("createdAt", "desc").limit(dp)), e && (n.push(t().where("teamId", "==", e).where("accessLevel", "==", "PRIVATE").where("deletedAt", "==", null).where("type", "==", o).where("userId", "==", this.uid).orderBy("createdAt", "desc").limit(dp)), n.push(t().where("teamId", "==", e).where("accessLevel", "==", "RESTRICTED").where("deletedAt", "==", null).where("type", "==", o).where(`userIds.${this.uid}`, "==", !0).limit(dp)), n.push(t().where("teamId", "==", e).where("accessLevel", "==", "SHARED").where("deletedAt", "==", null).where("type", "==", o).orderBy("createdAt", "desc").limit(dp)));
    const s = /* @__PURE__ */ new Map();
    return await Promise.all(n.map(async (o) => {
      try {
        const r = await o.get();
        for (const a of r.docs)
          s.has(a.id) || s.set(a.id, { value: a.id, text: a.data().title || "Untitled board" });
      } catch (r) {
        console.warn("[board] a board list for the Library is unavailable", r);
      }
    })), Array.from(s.values()).sort((o, r) => o.text.localeCompare(r.text));
  }
  /** Star or unstar one of your finished generations (resultFavorites/{uid}_{result}, as v1 writes it). */
  async setFavorite(e, t) {
    if (!e.run || !e.mine || e.moderated) throw Bd("Only your own generations can be starred");
    const n = this.fb.db.collection("resultFavorites").doc(this.uid + "_" + e.run.uuid);
    try {
      if (!t) {
        await n.delete();
        return;
      }
      await n.set({
        createdAt: this.fb.FieldValue.serverTimestamp(),
        userId: this.uid,
        nodeRunId: e.run.id,
        nodeRunResultUuid: e.run.uuid,
        nodeDefId: e.run.nodeDefId || null,
        nodeId: e.run.nodeId || null,
        runnitId: e.run.runnitId || null,
        resultType: e.run.type || (e.video ? "VID" : "IMG")
      });
    } catch (s) {
      throw Bd(t ? "Could not favorite it, please try again" : "Could not unfavorite it, please try again", s);
    }
  }
  /** Delete one of your generations or uploads (stamped, as v1 deletes them). */
  async remove(e) {
    if (!e.mine) throw Bd("Only your own pictures can be deleted");
    try {
      if (e.uploadId) {
        await this.fb.db.collection("runnitUploads").doc(e.uploadId).update({ deletedAt: /* @__PURE__ */ new Date(), deletedByUserId: this.uid });
        return;
      }
      if (!e.run) return;
      const t = e.run.id, n = e.run.uuid, s = this.fb.db.collection("runnitNodeRuns").doc(t);
      await this.fb.db.runTransaction(async (o) => {
        const r = await o.get(s);
        if (!r.exists) return;
        const a = (r.data() || {}).results || [], l = /* @__PURE__ */ new Date(), d = a.map((h) => h.uuid === n && !h.deletedAt ? { ...h, deletedAt: l, deletedByUserId: this.uid } : h), c = d.every((h) => !!h.deletedAt);
        o.update(s, { results: d, ...c ? { deletedAt: l, deletedByUserId: this.uid } : {} });
      });
    } catch (t) {
      throw Bd("Issues deleting image, please try again", t);
    }
  }
}
var yze = Object.defineProperty, xze = (i, e, t) => e in i ? yze(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, S3 = (i, e, t) => xze(i, typeof e != "symbol" ? e + "" : e, t);
function wze(i, e = Date.now()) {
  const t = typeof i == "string" ? Date.parse(i) : typeof i == "number" ? i : NaN;
  if (!Number.isFinite(t)) return "";
  const n = new Date(t), s = n.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }).toLowerCase();
  return n.toDateString() === new Date(e).toDateString() ? s : s + " on " + n.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
function kze(i) {
  if (!i) return "The run couldn't start. Please try again.";
  if (i.message === "TOKEN_COOLDOWN_ACTIVE") {
    const e = wze(i.resetAt);
    return "The spending limit for runs here has been reached for now. It resets " + (e ? "at " + e : "soon") + "; ask an admin if you need more.";
  }
  return i.message ? i.message : "The run couldn't start. Please try again.";
}
function _ze(i) {
  const e = i && typeof i == "object" && "code" in i ? String(i.code) : "";
  return e.endsWith("deadline-exceeded") ? "The run took too long to start. Please try again." : e.endsWith("unavailable") ? "The run couldn't start. Check your connection and try again." : "The run couldn't start. Please try again.";
}
class Sze {
  constructor(e, t) {
    S3(this, "fb", e), S3(this, "drafts", t);
  }
  run(e, t) {
    let n = !1;
    const s = { runId: "", pending: [], cancel: () => {
      n = !0;
    } }, o = e.v1Inputs || {};
    return (async () => {
      let r;
      try {
        r = await this.drafts.prepare(e.sessionId, e.model.id, o, e.count, e.restore || null);
      } catch (c) {
        console.error("[board] run draft not written", c), n || t.onError("The run couldn't start: your prompt wasn't saved. Please try again.", []);
        return;
      }
      let a = null, l = !1, d = null;
      try {
        const h = await this.fb.functions.httpsCallable("runRunnitNode")({
          nodeRunId: r,
          nodeDefId: e.model.id,
          inputValues: o,
          staticInputValues: { numResults: e.count }
        });
        a = h && h.data || null;
      } catch (c) {
        l = !0, d = c;
      }
      if (l) {
        if (console.error("[board] runRunnitNode failed", d), !await this.ranAnyway(r)) {
          this.drafts.release(r), n || t.onError(_ze(d), []);
          return;
        }
      } else if (!a || !a.success) {
        this.drafts.release(r), n || t.onError(kze(a), []);
        return;
      }
      this.drafts.markConsumed(r), s.runId = r, !n && t.onStarted && t.onStarted(r);
    })(), s;
  }
  /** Whether a run whose call failed went through all the same; no, when nobody can say. */
  async ranAnyway(e) {
    try {
      return !!await pP(this.fb, e, !0);
    } catch {
      return !1;
    }
  }
}
var Mze = Object.defineProperty, Tze = (i, e, t) => e in i ? Mze(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, M3 = (i, e, t) => Tze(i, typeof e != "symbol" ? e + "" : e, t);
const Cze = "featuredPrompts";
class Ize {
  constructor(e) {
    M3(this, "fb", e), M3(this, "pending", null);
  }
  load() {
    if (!this.pending) {
      const e = this.fb.db.collection(Cze).doc("current").get().then(
        (t) => t.exists ? DV(t.data()) : null,
        // rules that don't know the collection yet (not deployed) refuse the read:
        // that's no set published, not a connection to try again
        (t) => {
          if (t && t.code === "permission-denied") return null;
          throw t;
        }
      );
      e.catch(() => {
        this.pending === e && (this.pending = null);
      }), this.pending = e;
    }
    return this.pending;
  }
}
const T3 = /* @__PURE__ */ new WeakMap();
function Aze(i) {
  let e = T3.get(i);
  return e || (e = new Ize(i), T3.set(i, e)), e;
}
var Pze = Object.defineProperty, Eze = (i, e, t) => e in i ? Pze(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, cp = (i, e, t) => Eze(i, typeof e != "symbol" ? e + "" : e, t);
const Fd = "libraryPrompts";
function C3(i) {
  return JSON.parse(JSON.stringify(i));
}
class Rze {
  constructor(e, t = e.api || null, n) {
    cp(this, "fb", e), cp(this, "api", t), cp(this, "fetchImpl", n), cp(this, "teams", /* @__PURE__ */ new Map());
  }
  async list(e) {
    const t = this.api;
    if (!t) return { ok: !1, reason: "failed", message: "The web app's API isn't available here" };
    let n;
    try {
      n = await t.credentials();
    } catch (o) {
      return console.warn("[board] my prompts: no API credentials", o), { ok: !1, reason: "failed" };
    }
    if (!n) return { ok: !1, reason: "unauthorized" };
    const s = await nie(t.baseUrl, n, e, this.fetchImpl);
    return !s.ok && s.code && t.onRejected && t.onRejected(s.code), s;
  }
  follow(e, t, n) {
    return this.fb.db.collection(Fd).doc(e).onSnapshot(
      // a save of yours shows at once, its server times estimated until they land
      (s) => t(s.exists ? WV(s.id, s.data({ serverTimestamps: "estimate" })) : null),
      (s) => {
        n && n(s);
      }
    );
  }
  async save(e, t) {
    const n = this.fb.FieldValue.serverTimestamp();
    return (await this.fb.db.collection(Fd).add({ ...C3(e), v: 1, authorId: t.uid, authorName: t.name, createdAt: n, updatedAt: n, deletedAt: null })).id;
  }
  async update(e, t) {
    await this.fb.db.collection(Fd).doc(e).update({ ...C3(t), updatedAt: this.fb.FieldValue.serverTimestamp() });
  }
  async remove(e) {
    await this.fb.db.collection(Fd).doc(e).update({ deletedAt: this.fb.FieldValue.serverTimestamp() });
  }
  async restore(e) {
    await this.fb.db.collection(Fd).doc(e).update({ deletedAt: null });
  }
  teamName(e) {
    let t = this.teams.get(e);
    return t || (t = this.fb.db.collection("teams").doc(e).get().then((n) => {
      const s = n.exists ? n.data() : void 0;
      return s && typeof s.name == "string" ? s.name : null;
    }).catch(() => null), this.teams.set(e, t)), t;
  }
}
const I3 = /* @__PURE__ */ new WeakMap();
function zze(i) {
  let e = I3.get(i);
  return e || (e = new Rze(i), I3.set(i, e)), e;
}
var $ze = Object.defineProperty, Dze = (i, e, t) => e in i ? $ze(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Nd = (i, e, t) => Dze(i, typeof e != "symbol" ? e + "" : e, t);
const Oze = 24 * 3600 * 1e3, up = 450;
function sn(i, e = "") {
  return typeof i == "string" ? i : e;
}
function Fp(i) {
  return Array.isArray(i) ? i.filter((e) => typeof e == "string") : [];
}
function Ud(i, e = 0) {
  return typeof i == "number" && Number.isFinite(i) ? i : e;
}
function Lze(i) {
  if (!i || typeof i != "object") return null;
  const e = i;
  return { by: sn(e.by), byName: sn(e.byName), text: sn(e.text) };
}
function A3(i, e) {
  var t, n;
  const s = {};
  if (e.readBy && typeof e.readBy == "object")
    for (const [r, a] of Object.entries(e.readBy)) {
      const l = gn(a);
      l != null && (s[r] = l);
    }
  const o = gn(e.createdAt) || Date.now();
  return {
    id: i,
    boardId: sn(e.boardId),
    teamId: typeof e.teamId == "string" ? e.teamId : null,
    createdBy: sn(e.createdBy),
    createdByName: sn(e.createdByName),
    createdByEmail: sn(e.createdByEmail),
    createdAt: o,
    x: Ud(e.x),
    y: Ud(e.y),
    elementId: typeof e.elementId == "string" ? e.elementId : null,
    ex: Ud(e.ex),
    ey: Ud(e.ey),
    anchorLabel: sn(e.anchorLabel),
    anchorThumb: typeof e.anchorThumb == "string" ? e.anchorThumb : null,
    color: $3e(e.color) ? e.color : "amethyst",
    resolvedAt: (t = gn(e.resolvedAt)) != null ? t : null,
    resolvedBy: typeof e.resolvedBy == "string" ? e.resolvedBy : null,
    followers: Fp(e.followers),
    readBy: s,
    markedUnread: Fp(e.markedUnread),
    pinnedBy: Fp(e.pinnedBy),
    lastAt: gn(e.lastAt) || o,
    lastBy: sn(e.lastBy),
    count: Ud(e.count, 1),
    preview: Lze(e.preview),
    boardTitle: sn(e.boardTitle),
    deletedAt: (n = gn(e.deletedAt)) != null ? n : null,
    deletedBy: typeof e.deletedBy == "string" ? e.deletedBy : null
  };
}
function P3(i, e) {
  var t;
  const n = [];
  if (Array.isArray(e.mentions))
    for (const o of e.mentions)
      o && typeof o == "object" && typeof o.uid == "string" && n.push({ uid: o.uid, name: sn(o.name) });
  const s = {};
  if (e.reactions && typeof e.reactions == "object")
    for (const [o, r] of Object.entries(e.reactions)) {
      const a = Fp(r);
      a.length && (s[o] = a);
    }
  return {
    id: i,
    threadId: sn(e.threadId),
    boardId: sn(e.boardId),
    authorId: sn(e.authorId),
    authorName: sn(e.authorName),
    authorEmail: sn(e.authorEmail),
    text: sn(e.text),
    mentions: n,
    createdAt: gn(e.createdAt) || Date.now(),
    editedAt: (t = gn(e.editedAt)) != null ? t : null,
    reactions: s
  };
}
const hp = (i) => i.data({ serverTimestamps: "estimate" }) || {}, E3 = 60, R3 = 480;
class Bze {
  constructor(e, t, n, s) {
    Nd(this, "fb", e), Nd(this, "user", t), Nd(this, "boardId", n), Nd(this, "board", s), Nd(this, "unsubs", []);
  }
  get runnit() {
    return this.fb.db.collection("runnits").doc(this.boardId);
  }
  threadRef(e, t = this.boardId) {
    return this.fb.db.collection("runnits").doc(t).collection("runnitCanvasThreads").doc(e);
  }
  commentRef(e) {
    return this.runnit.collection("runnitCanvasComments").doc(e);
  }
  watchBoard(e) {
    const t = this.runnit.collection("runnitCanvasThreads").onSnapshot((o) => {
      const r = [], a = [];
      for (const l of o.docChanges())
        l.type === "removed" ? a.push(l.doc.id) : r.push(A3(l.doc.id, hp(l.doc)));
      (r.length || a.length || !o.docChanges().length) && e.threads(r, a);
    }, (o) => e.error(o)), n = this.runnit.collection("runnitCanvasComments").onSnapshot((o) => {
      const r = [], a = [];
      for (const l of o.docChanges())
        l.type === "removed" ? a.push(l.doc.id) : r.push(P3(l.doc.id, hp(l.doc)));
      (r.length || a.length) && e.comments(r, a);
    }, (o) => e.error(o)), s = () => {
      t(), n();
    };
    return this.unsubs.push(s), s;
  }
  watchFollowed(e, t) {
    let n = E3, s = () => {
    }, o = !1;
    const r = () => {
      s(), s = this.fb.db.collectionGroup("runnitCanvasThreads").where("followers", "array-contains", this.user.uid).orderBy("lastAt", "desc").limit(n).onSnapshot((l) => {
        if (o) return;
        const d = l.docs.map((h) => A3(h.id, hp(h))).filter((h) => !!h.boardId);
        if (d.filter((h) => !h.deletedAt).length < E3 && l.docs.length >= n && n < R3) {
          n = Math.min(R3, n * 2), r();
          return;
        }
        e(d);
      }, (l) => t(l));
    };
    r();
    const a = () => {
      o = !0, s();
    };
    return this.unsubs.push(a), a;
  }
  async people() {
    const e = this.board(), t = { uid: this.user.uid, name: this.user.name || _c(this.user.email), email: this.user.email };
    if (!e.teamId) return { people: [t], scope: "personal" };
    const n = /* @__PURE__ */ new Map();
    try {
      const l = await this.runnit.collection("runnitCanvasPeople").limit(500).get();
      for (const d of l.docs) {
        const c = d.data();
        n.set(d.id, { uid: d.id, name: sn(c.name), email: sn(c.email) });
      }
    } catch (l) {
      console.warn("[board] comments: the board's people couldn't be read", l);
    }
    const s = e.accessLevel || "PRIVATE";
    let o = null;
    if (s === "PRIVATE" && (o = /* @__PURE__ */ new Set([e.ownerId])), s === "RESTRICTED") {
      o = /* @__PURE__ */ new Set([e.ownerId]);
      try {
        const d = ((await this.runnit.get()).data() || {}).userIds;
        if (d && typeof d == "object")
          for (const [c, h] of Object.entries(d)) h && o.add(c);
      } catch (l) {
        console.warn("[board] comments: the board's access couldn't be read", l);
      }
    }
    const r = /* @__PURE__ */ new Map();
    r.set(t.uid, t);
    try {
      const l = await this.fb.db.collection("teams").doc(e.teamId).collection("teamMembers").where("isAccepted", "==", !0).limit(500).get();
      for (const d of l.docs) {
        const c = d.data(), h = sn(c.userId), f = sn(c.email, d.id);
        if (!h || r.has(h) || o && !o.has(h)) continue;
        const p = n.get(h);
        r.set(h, { uid: h, email: f, name: p && p.name || _c(f) });
      }
    } catch (l) {
      console.warn("[board] comments: the team's members couldn't be read", l);
      for (const d of n.values()) !r.has(d.uid) && (!o || o.has(d.uid)) && r.set(d.uid, d);
    }
    const a = s === "SHARED" ? "team" : s === "RESTRICTED" ? "restricted" : "private";
    return { people: Array.from(r.values()), scope: a };
  }
  async checkIn() {
    const e = this.runnit.collection("runnitCanvasPeople").doc(this.user.uid), t = this.fb.FieldValue, n = this.user.name || _c(this.user.email);
    let s = await e.get();
    if (!s.exists)
      try {
        return await e.set({ uid: this.user.uid, name: n, email: this.user.email, firstSeenAt: t.serverTimestamp(), seenAt: t.serverTimestamp() }), Date.now();
      } catch (a) {
        if (s = await e.get(), !s.exists) throw a;
      }
    const o = s.data() || {}, r = gn(o.seenAt) || 0;
    return (sn(o.name) !== n || sn(o.email) !== this.user.email || Date.now() - r > Oze) && e.update({ name: n, email: this.user.email, seenAt: t.serverTimestamp() }).catch((a) => console.warn("[board] comments: check-in not saved", a)), gn(o.firstSeenAt) || null;
  }
  async createThread(e, t) {
    const s = this.fb.FieldValue.serverTimestamp(), o = this.fb.db.batch();
    o.set(this.threadRef(e.id), {
      v: 1,
      boardId: e.boardId,
      teamId: e.teamId,
      createdBy: e.createdBy,
      createdByName: e.createdByName,
      createdByEmail: e.createdByEmail,
      createdAt: s,
      x: e.x,
      y: e.y,
      elementId: e.elementId,
      ex: e.ex,
      ey: e.ey,
      anchorLabel: e.anchorLabel.slice(0, 120),
      anchorThumb: e.anchorThumb && e.anchorThumb.length <= 1e3 ? e.anchorThumb : null,
      color: e.color,
      resolvedAt: null,
      resolvedBy: null,
      followers: e.followers,
      readBy: { [this.user.uid]: s },
      markedUnread: [],
      pinnedBy: [],
      lastAt: s,
      lastBy: e.lastBy,
      count: 1,
      preview: e.preview,
      boardTitle: e.boardTitle.slice(0, 200)
    }), o.set(this.commentRef(t.id), this.commentDoc(t)), await o.commit();
  }
  commentDoc(e) {
    return {
      v: 1,
      threadId: e.threadId,
      boardId: e.boardId,
      authorId: e.authorId,
      authorName: e.authorName,
      authorEmail: e.authorEmail,
      text: e.text,
      mentions: e.mentions.map((t) => ({ uid: t.uid, name: t.name })),
      createdAt: this.fb.FieldValue.serverTimestamp(),
      editedAt: null,
      reactions: {}
    };
  }
  async reply(e, t, n) {
    const s = this.fb.FieldValue, o = this.fb.db.batch();
    o.set(this.commentRef(t.id), this.commentDoc(t));
    const r = {
      lastAt: s.serverTimestamp(),
      lastBy: this.user.uid,
      count: s.increment(1),
      preview: { by: t.authorId, byName: t.authorName, text: t.text.replace(/\s+/g, " ").trim().slice(0, 280) },
      followers: s.arrayUnion(this.user.uid, ...n),
      ["readBy." + this.user.uid]: s.serverTimestamp(),
      markedUnread: s.arrayRemove(this.user.uid)
    };
    e.resolvedAt && (r.resolvedAt = null, r.resolvedBy = null), o.update(this.threadRef(e.id), r), await o.commit();
  }
  async editComment(e, t, n) {
    const s = this.fb.FieldValue, o = this.fb.db.batch();
    o.update(this.commentRef(e.id), { text: e.text, mentions: e.mentions.map((a) => ({ uid: a.uid, name: a.name })), editedAt: s.serverTimestamp() });
    const r = {};
    t && (r.preview = t), n.length && (r.followers = s.arrayUnion(...n)), Object.keys(r).length && o.update(this.threadRef(e.threadId), r), await o.commit();
  }
  async deleteComment(e, t, n) {
    const s = this.fb.db.batch();
    s.delete(this.commentRef(e.id)), s.update(this.threadRef(e.threadId), { count: Math.max(1, t), preview: n }), await s.commit();
  }
  async deleteThread(e, t) {
    const n = t.slice();
    for (; n.length > up; ) {
      const o = this.fb.db.batch();
      for (const r of n.splice(0, up)) o.delete(this.commentRef(r));
      await o.commit();
    }
    const s = this.fb.db.batch();
    for (const o of n) s.delete(this.commentRef(o));
    s.delete(this.threadRef(e)), await s.commit();
  }
  async markDeleted(e) {
    await this.threadRef(e).update({ deletedAt: this.fb.FieldValue.serverTimestamp(), deletedBy: this.user.uid });
  }
  async react(e, t, n) {
    const s = this.fb.FieldValue;
    await this.commentRef(e.id).update({ ["reactions." + this.user.uid]: n ? s.arrayUnion(t) : s.arrayRemove(t) });
  }
  async resolve(e, t) {
    const n = this.fb.FieldValue;
    await this.threadRef(e).update(t ? { resolvedAt: n.serverTimestamp(), resolvedBy: this.user.uid } : { resolvedAt: null, resolvedBy: null });
  }
  async setColor(e, t) {
    await this.threadRef(e).update({ color: t });
  }
  async move(e, t) {
    await this.threadRef(e).update({
      x: t.x,
      y: t.y,
      elementId: t.elementId,
      ex: t.ex,
      ey: t.ey,
      anchorLabel: t.label.slice(0, 120),
      anchorThumb: t.thumb && t.thumb.length <= 1e3 ? t.thumb : null
    });
  }
  async follow(e, t, n) {
    const s = this.fb.FieldValue;
    await this.threadRef(e, n).update({ followers: t ? s.arrayUnion(this.user.uid) : s.arrayRemove(this.user.uid) });
  }
  async pin(e, t) {
    const n = this.fb.FieldValue;
    await this.threadRef(e).update({ pinnedBy: t ? n.arrayUnion(this.user.uid) : n.arrayRemove(this.user.uid) });
  }
  async markRead(e) {
    const t = this.fb.FieldValue, n = /* @__PURE__ */ new Map();
    for (const s of e) {
      const o = s.boardId || this.boardId;
      n.set(o, [...n.get(o) || [], s.id]);
    }
    await Promise.all(Array.from(n.entries()).map(async ([s, o]) => {
      for (let r = 0; r < o.length; r += up) {
        const a = this.fb.db.batch();
        for (const l of o.slice(r, r + up))
          a.update(this.threadRef(l, s), { ["readBy." + this.user.uid]: t.serverTimestamp(), markedUnread: t.arrayRemove(this.user.uid) });
        await a.commit();
      }
    }));
  }
  async markUnread(e, t) {
    await this.threadRef(e, t).update({ markedUnread: this.fb.FieldValue.arrayUnion(this.user.uid) });
  }
  async threadComments(e, t) {
    return (await this.fb.db.collection("runnits").doc(e).collection("runnitCanvasComments").where("threadId", "==", t).limit(300).get()).docs.map((s) => P3(s.id, hp(s))).sort((s, o) => s.createdAt - o.createdAt);
  }
  async boardTitles(e) {
    const t = {};
    return await Promise.all(e.map(async (n) => {
      try {
        const s = await this.fb.db.collection("runnits").doc(n).get(), o = s.exists ? s.data() || {} : null;
        t[n] = !o || o.deletedAt ? null : typeof o.title == "string" && o.title ? o.title : "Untitled board";
      } catch (s) {
        Wo(s) === "permission-denied" && (t[n] = null);
      }
    })), t;
  }
  dispose() {
    for (const e of this.unsubs) e();
    this.unsubs = [];
  }
}
function fP(i) {
  return async (e, t) => {
    const s = await i.functions.httpsCallable("saveAnnotatedImage", { timeout: 25e4 })({ source: e, overlayPngBase64: t }), o = s && s.data || null;
    if (!o || !o.upload)
      throw new Error(o && o.error && o.error.message || "Your marks couldn't be added to the picture. Please try again.");
    const { createdAtMs: r, ...a } = o.upload;
    return { ...a, createdAt: typeof r == "number" ? new Date(r) : /* @__PURE__ */ new Date() };
  };
}
function Fze(i, e, t, n = {}) {
  const s = new XRe(i, e.uid, t);
  return {
    runs: new HRe(i, t),
    prompts: s,
    favorites: new QRe(i, e.uid, t),
    pins: new nze(i, e.uid, t),
    models: new oze(i, e.uid),
    balance: new dze(i, !!e.freemiumPassport),
    teamStatus: new pze(i),
    library: new vze(i, e.uid, { isAdmin: e.isAdmin }),
    companyTools: (o) => WC(i, o, e, { isBlocked: n.isBlocked }),
    gen: new Sze(i, s),
    annotate: fP(i),
    featured: Aze(i),
    myPrompts: zze(i)
  };
}
function Nze(i, e, t, n) {
  return new Bze(i, e, t, n);
}
async function Uze(i, e, t) {
  if (i.upload) return i.upload(t);
  const n = (t.name.split(".").pop() || "png").toLowerCase().replace(/[^a-z0-9]/g, "") || "png", s = i.storage.ref("runnitUploads/users/" + e.uid + "/uploads/board-" + St() + "." + n);
  return await s.put(t, { contentType: t.type || "image/png" }), { url: await s.getDownloadURL() };
}
const Sx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RunnitCanvasDirectory: BRe,
  annotateWith: fP,
  boardServices: Fze,
  commentStore: Nze,
  loadCompanyTools: WC,
  loadToolCatalog: vne,
  uploadFile: Uze
}, Symbol.toStringTag, { value: "Module" }));
export {
  Vze as createCanvasBoard,
  Wze as createDemoBoard,
  RRe as mountBoard,
  Hze as mountOnboarding,
  qze as mountStressBoard
};
